/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		101: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "js/pages/" + ({"0":"intlPolyfill","1":"placeholder_polyfill","2":"scrollIntoViewPolyfill","3":"smartcarnet-results","4":"disruption-alerts-handler","5":"point-outward","6":"services-grid","7":"widget-auth-routes","8":"login-reset-password","9":"point-search","10":"delivery","11":"season-search","12":"search-widget-iframe","13":"season-results","17":"othertickets","18":"open-golf-ticket-selection","20":"roversrangers-results","21":"account-routes","22":"daysave-results","26":"roversrangers","27":"daysave","28":"account-layout","30":"inapp-routes","31":"handoff-fare","32":"payment-confirmation","33":"open-golf-find-tickets-widget","35":"open-golf-timetable-widget","36":"promotion","37":"payment-routes","38":"refund-widget","39":"payment-wrapper","40":"promotion-toc-family-verify","41":"newsletter-unsubscribe","42":"smartregister","43":"nre-order-landing","44":"promotion-toc-family","45":"promotion-apply","46":"account-smartcard-link-confirmation","47":"timetable-change-routes","48":"disruption-alerts-routes","49":"widget-auth-handler","50":"order-payment","51":"inapp-handler","52":"payment","53":"inapp-one-click-delay-repay","54":"inapp-account-orders-refunds","55":"account-amend-details","56":"account-smartcard-keygo","57":"account-reservations","58":"payment-hosted","59":"inapp-auto-delay-repay","60":"account-book-passenger-assist","61":"account-view-booked-assistance","62":"payment-hosted-braintree","63":"account-refund-details","64":"account-accessibility-profile","65":"account-disruption-alerts","66":"account-etickets","67":"account-smartcard-keygo-history","68":"flexi","69":"account-photocards-railcards","70":"account-stickets","71":"inapp-account","72":"account-smartcard-replacement","73":"account-smartcard-history","74":"account-preferences","75":"account-smartcard-tickets","76":"account-smartcard-transfer-results","77":"account-smartcard-link","78":"account-details","79":"account-confirm-smartcard-replacement","80":"account-payment","81":"account-addresses","82":"account-smartcard-routes","83":"account-historic-etickets","84":"account-smartcard-transfer-routes","85":"account-smartcard-apply","86":"account-order-details","87":"account-smartcard-transfer-search","88":"account-evouchers","89":"account-link-order","90":"widget-auth-register","91":"widget-auth-login","92":"inapp-register-smartcard","93":"inapp-register","94":"inapp-logout","95":"inapp-login","96":"disruption-alerts-mute","97":"timetable-change-delete","98":"account-smartcard-transfer","99":"account-smartcard-transfer-confirmation","100":"account-smartcard"}[chunkId]||chunkId) + "." + {"0":"f8d68afe2cf38fa8fa7d","1":"47abd0b252e95170b349","2":"e301857d370b25e1fe4e","3":"856533ef9c4d9f903355","4":"bc77b7249bcf908ae624","5":"35820a2a169230bde174","6":"586096e4377e0af5a582","7":"2d28622e0ab9dd0ad5a3","8":"161bf8d23914c894fb84","9":"a3d5bb21c88c73047cdd","10":"87f75719d69fc9e0c19e","11":"beade89dc7606c87ee94","12":"3977eb0e5f73c236dcbd","13":"1247624834bd7487906c","17":"ac129fee514930527613","18":"4b8870f4d6a7a9fb0cdb","20":"854958a95a96ec10fce6","21":"8b433e9e31d06cba5c21","22":"6b55992eb9c3e3c607de","26":"4de17ad8c589ec065baa","27":"07eee23ea44135448c20","28":"ffca4cd01279f165328c","30":"202e8e202c92d53089f8","31":"b14c79f88750cbf1abe4","32":"17a3dfc428f8f8a092f3","33":"0a74edc6ada34c1e471e","35":"d482fb6f8c15570944a9","36":"561fc7479beb823d7a65","37":"a3f86f2a98bdc97a2504","38":"0f8ad031d16cd3e012f8","39":"1832210482b379d6430d","40":"4a1fc3b71e0cd0c65df2","41":"a1a4c0918da1b1ff78fb","42":"8a9e2ecfcca9a4e98ead","43":"3bfe551ac009bcc015ad","44":"6e957f7d4a70a07ee7a4","45":"72f161914a25fdeeab7f","46":"3d9bb4f87346515c9a74","47":"ad3a786a8179e3f18ae4","48":"72d8621598a894f97cf3","49":"52d2adab211be9f7f7d8","50":"34ac422f1324d5a37bac","51":"c032e8b39c00590af7ca","52":"d61afe4264724ea4fd45","53":"117cb5b03647a9c3bbbd","54":"903904b80f44e8522808","55":"fba70d142ce5fa7cd83d","56":"33addc8a3c91fa3bc0a3","57":"9d6bda50d73988e94ee3","58":"2718afca98ce3971d8ad","59":"52a63163d4ff3e72f603","60":"9551751866368cbc2fff","61":"48c06a8fd9e58376af61","62":"b3acad33b0293394c3f2","63":"6f5045a3085ae117409e","64":"2e26ddf531bf4661f853","65":"b1cfb24198f5224bec88","66":"4b53304cd36dbd318241","67":"edd16b6c56a4212dec69","68":"282ffb9c5422b4ba5b2d","69":"53e5ee8d2ab2a270a799","70":"dd66c5f871f62fedbd7c","71":"a73491898e82c5963d89","72":"32d8639224d972766a0d","73":"7476d2aaf38243bfba17","74":"e598cf61dd9cb5eb4836","75":"ba975c5b4c5349cfd15b","76":"949d999cc9ff0d0f7db1","77":"2a33ac44b59689aa89f0","78":"7bca2985e72e75d197a8","79":"4f85e1d5c3e891b726e2","80":"e3f1b3c3b27e80dae8b0","81":"d1a72199170e947afa78","82":"900e5cee6009b759ec0c","83":"ced513d16175d5e2329f","84":"abb0d07094c9aba81984","85":"6439040ae917c1825986","86":"2458a0e30e61a522c118","87":"cfddd591d979d30e6abf","88":"0c03283baeb3f7a49cef","89":"b1be13a0077bea8d9bb3","90":"9fe2fc9ef0ee6ef687a7","91":"6bcf29a72188e6fcfea2","92":"c5936fe6ac1a142c7101","93":"08353489d4590c3cbdc4","94":"777f0d6b7eff142fb8bd","95":"6ac4481290c97bb36872","96":"d535e94038bb1cecde87","97":"99b553d91e997b19ce26","98":"7c835d0c0ff1933335c3","99":"5cf1a104d0f07a8bbd18","100":"3d81bb962360a09138b4"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2211);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["?React"] = __webpack_require__(1403);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1710)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(741);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.TransPennineStaffRoverNlcCodes = exports.ReservationErrorCodes = exports.ReservationContexts = exports.ReservationBundleOutcome = exports.ReservationSalesFlowType = exports.ReservationTabs = exports.ReservationStepIndex = exports.RESERVATION_CANCELLATION_STATUS = exports.RESERVATION_NOT_POSSIBLE = exports.Directions = exports.TrainTypes = exports.IconFillColours = exports.SmartcardBenefitsPaths = exports.TicketBenefitsPaths = exports.CARBON_FOOTPRINT_DATA = exports.StationStepFreeAccessLevels = exports.JourneySupportPaths = exports.STicketErrors = exports.OYSTER_BUTTON_TYPE = exports.oneClickDelayRepayReimbursementMethods = exports.notificationPreferences = exports.PlusBusSectionsContext = exports.OrderSummaryContexts = exports.THAMESLINK_APP_CHANNEL = exports.SOUTHERN_APP_CHANNEL = exports.GREATNORTHERN_APP_CHANNEL = exports.GATWICK_APP_CHANNEL = exports.NATIVE_BOOKING_FLOW_APP_CHANNEL = exports.WEBVIEW_BOOKING_FLOW_APP_CHANNEL = exports.DEFAULT_APP_CHANNEL = exports.ValidityPeriods = exports.RefundReasons = exports.RegistrationReferrers = exports.STICKET_PHOTOCARD = exports.JPWidgetConf = exports.SmartCarnetTicketStatus = exports.SmartCarnetValidation = exports.SmartCarnetTicketCodes = exports.FlexiSeasonValidation = exports.AssociationDetailsType = exports.AssociationStatuses = exports.Pay360SessionState = exports.SundryCodes = undefined;
exports.GOTriggers = exports.DisabledPeopleRailcards = exports.DisruptionAlertReactivationOptions = exports.DisruptionAlertWeekdays = exports.DisruptionAlertDaysOptions = exports.DisruptionAlertDurationOptions = exports.DisruptionAlertPrimaryDateFormat = exports.DisruptionAlertMaximumServices = exports.DisruptionAlertMaximumAlerts = exports.FavouriteSeasonExpiringSoonThresholdDays = exports.FavouriteExcludedTicketTypes = exports.Browsers = exports.OpenGolfTickets = exports.OPEN_GOLF_TICKET_CODE_REGEX = exports.AmazonLoginCTATypes = exports.widgetSearchElements = exports.RefundCalculation = exports.AllowedSameDeliveryAddressCountries = exports.AllowedDeliveryCountryCodes = exports.Railcard1617Errors = exports.AmazonLoginResponseType = exports.AmazonLoginAuthStatus = exports.AmazonLoginStatus = exports.AmazonIds = exports.AmazonPayErrors = exports.TEST_REDUCED_TIMEOUT_INTERVAL = exports.filteredRailcards = exports.filteredOutRailcards = exports.KeyGoHostedFollowOnActions = exports.keyGoPaymentCardStatus = exports.KeyGoReimbursementStatus = exports.WidgetTab = exports.WidgetLayout = exports.IBlocksTransitModes = exports.IBlocksErrorCodes = exports.KeyGoTapGenerationCauseText = exports.KeyGoTapGenerationCause = exports.KeyGoTapTypes = exports.KeyGoTapStatus = exports.KeyGoJourneyStates = exports.JOB_CENTRE_PLUS_RAILCARD_CODE = exports.RAILCARD1617_CODE = exports.Railcard1617States = exports.WeekDaysJourney = exports.InitialWeekDayJourney = exports.WeekDays = exports.BusinessDays = exports.WeekdayNames = exports.SignupTypes = exports.PlusBusOptions = exports.TicketOfficeHours = exports.SkipAutoLogoutRedirectRoutes = exports.SubscriptionActions = exports.NREIncompatibleRailcards = exports.StationFinderSearchInteractions = exports.IgnoredErrors = exports.BulletinSeverity = exports.DRCStates = exports.BAlertTypes = exports.CookieKeys = exports.LoadingTypes = exports.MAX_NOTIFICATION_TIME = exports.RailDayStart = exports.JourneySelectorTypes = exports.COUNTED_PLACE = exports.TPECustomerTitles = exports.CustomerTitles = exports.CardLockStatus = exports.RAILCARD_CODES_WITH_FARE_AND_TIME_RESTRICTIONS = exports.TPE_GROUP_SAVE_CODE = exports.GROUP_SAVE_CODE = exports.ChangeoverActions = exports.TicketRefundStates = exports.TripBookingStatus = exports.OrderStates = exports.OrderTripTypes = exports.TripTypes = exports.VISA_CHECKOUT_BUTTON_ID = exports.CardTypes = exports.PaymentTooltipIds = exports.PaymentAuthStatuses = exports.PaymentAuthCodes = exports.PaymentType = exports.UploadSize5mb = exports.UploadSize2mb = exports.SmartcardReplacementReason = exports.KEYGO_NICKNAME = exports.KEYGO_TOPUP_AMOUNT = exports.KeyGoProductStatus = exports.SmartcardProductStatusText = exports.SmartcardProductStatusGroup = exports.SmartcardProductStatus = exports.SmartcardProgress = exports.SmartcardStatus = exports.Validation = exports.GenericModals = exports.GlobalModals = exports.API_KEYGO_FORMAT = exports.API_FORMAT = exports.API_ISO_FORMAT = undefined;
exports.BreakPoints = exports.ListSteps = exports.ServicesPerLayout = exports.JourneyPlannerLayout = exports.Duration = exports.SeasonCustomRange = exports.DurationPeriods = exports.DurationTypes = exports.TransitModes = exports.SmartcardServiceErrors = exports.SmartcardSelfRegistrationStatuses = exports.SmartcardErrorBlocking = exports.SmartCardErrorBlockingForLoggedIn = exports.SmartcardErrorNonBlocking = exports.PostalDeliveryType = exports.STicketStatus = exports.FulfilmentType = exports.StopPatterns = exports.OperatorColors = exports.SeatingPrefNames = exports.SeatingPrefs = exports.ReservableStates = exports.DelayRepayBankPeriod = exports.DelayRepayPaymentMethod = exports.Widgets = exports.DelayRepayClaimReason = exports.DelayRepayTicketClass = exports.CompensationLevel = exports.DelayRepayTicket = exports.CompensationEvidence = exports.CompensationPurchaseLocations = exports.CompensationTicket = exports.CompensationClaimType = exports.CompensationPages = exports.DelayRepayClaimType = exports.AutoDelayRepayPages = exports.DelayRepayPages = exports.SearchWidgetPages = exports.OtherPages = exports.PromotionPages = exports.HandOffPages = exports.WidgetAuthPages = exports.InAppPages = exports.NewsletterPages = exports.LoginPages = exports.NREPages = exports.RailcardTutorial = exports.SmartcardTutorial = exports.CONSENTS = exports.StationFinderTutorialStages = exports.SeasonsTutorialStages = exports.JPGridTutorialStages = exports.JPListTutorialStages = exports.Tutorials = exports.AccountPagesForceLoginInsteadOfRedirect = exports.SmartcardPages = exports.DisruptionAlertsPages = exports.PortalClaims = exports.AccountPages = exports.CheckoutStages = exports.SmartCarnetStages = exports.RoversRangersStages = exports.DaySaveStages = exports.OtherTicketStages = exports.SeasonStages = exports.PointStages = exports.GridPages = exports.SmartCarnetFiltersRoute = exports.SmartCarnetFiltersService = exports.SmartCarnetFilterTypes = exports.FareFilterSelections = exports.FareCategories = exports.BasketItemTypes = exports.NRELinkFareClasses = exports.FareClasses = exports.SearchTypes = exports.PlusBusDirections = exports.JourneyDirections = exports.AdjustedTimeConfidence = exports.JourneyStatus = exports.TimeDirections = exports.TimeTypes = exports.DelayRepayStationTypes = exports.SmartcardSeasonStationTypes = exports.SeasonStationTypes = exports.SmartcardStationTypes = exports.DaySaveStationTypes = exports.StationTypes = exports.RecentStationsTypes = exports.ActionTypes = exports.IdentityProviders = exports.AuthGrantTypes = exports.DefaultPagination = exports.GroupSavePassengers = exports.PassengerTypes = exports.TicketTypes = exports.Brands = exports.KeyCodes = exports.TimeZone = exports.AppName = undefined;

var _SeatingPrefNames, _DurationPeriods, _ServicesPerLayout, _SmartcardProductStat, _KeyGoTapGenerationCa;

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppName = exports.AppName = {
    BOOKING_ENGINE: 'booking-engine',
    DELAY_REPAY: 'delay-repay',
    SEARCH_WIDGETS: 'otrl-search-widgets'
};

var TimeZone = exports.TimeZone = 'Europe/London';

var KeyCodes = exports.KeyCodes = {
    ENTER: 13,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
    UP_ARROW: 38,
    DOWN_ARROW: 40
};

// GTR brands used for cross-brand refunds
var Brands = exports.Brands = {
    GN: 'greatnorthern',
    TL: 'thameslink',
    SN: 'southern',
    GX: 'gatwick'
};

var TicketTypes = exports.TicketTypes = {
    SINGLE: 'single',
    RETURN: 'return',
    OPEN_RETURN: 'open-return'
};

var PassengerTypes = exports.PassengerTypes = {
    ADULT: 'adult',
    CHILD: 'child'
};

var GroupSavePassengers = exports.GroupSavePassengers = {
    MIN: 3,
    MAX: 9
};

var DefaultPagination = exports.DefaultPagination = {
    LIMIT: '3',
    PAGE: '1'
};

var AuthGrantTypes = exports.AuthGrantTypes = {
    AMAZON_AUTH_CODE: 'amazon_authorization_code',
    PASSWORD: 'password',
    REFRESH_TOKEN: 'refresh_token'
};

var IdentityProviders = exports.IdentityProviders = {
    AMAZON: 'amazon'
};

var ActionTypes = exports.ActionTypes = (0, _keymirror2.default)({
    APP_INITIALIZED: null,
    WINDOW_RESIZED: null,
    ACTIVITY_DETECTED: null,
    ROUTE_CHANGED: null,

    SEARCH_LOADED: null,
    SEARCH_UPDATED: null,
    SEARCH_STARTED: null,
    SEARCH_FAILED: null,
    SEARCH_FINISHED: null,

    RESET_JOURNEY_STORE: null,

    CHECK_TOC_ONLY_ADD: null,
    CHECK_TOC_ONLY_UPDATE: null,

    SEASON_SEARCH_LOADED: null,
    SEASON_SEARCH_UPDATED: null,
    SEASON_SEARCH_STARTED: null,
    SEASON_SEARCH_FAILED: null,
    SEASON_SEARCH_FINISHED: null,
    SEASON_TICKET_SELECTED: null,
    SEASON_TICKET_PHOTOCARD_UPDATED: null,
    SEASON_TICKET_PHOTOCARD_FIELD_UPDATED: null,
    SEASON_TICKET_PHOTOCARD_CLEAR: null,

    FARE_ONLY_SEARCH_STARTED: null,
    FARE_ONLY_SEARCH_FAILED: null,
    FARE_ONLY_SEARCH_FINISHED: null,

    FARE_ONLY_SEASON_SEARCH_STARTED: null,
    FARE_ONLY_SEASON_SEARCH_FAILED: null,
    FARE_ONLY_SEASON_SEARCH_FINISHED: null,

    ELIGIBLE_SERVICES_SEARCH_STARTED: null,
    ELIGIBLE_SERVICES_SEARCH_FINISHED: null,
    ELIGIBLE_SERVICES_SEARCH_FAILED: null,
    ELIGIBLE_SERVICES_RESET: null,

    SMART_CARNET_SEARCH_LOADED: null,
    SMART_CARNET_SEARCH_STARTED: null,
    SMART_CARNET_SEARCH_FAILED: null,
    SMART_CARNET_SEARCH_FINISHED: null,
    SMART_CARNET_SEARCH_SELECTED: null,
    SMART_CARNET_RETURN_SEARCH_STARTED: null,
    SMART_CARNET_RETURN_SEARCH_FAILED: null,
    SMART_CARNET_RETURN_SEARCH_FINISHED: null,
    SMART_CARNET_RETURN_SEARCH_SELECTED: null,
    SMART_CARNET_FILTER_CHANGED: null,
    SMART_CARNET_PASSES_STARTED: null,
    SMART_CARNET_PASSES_FAILED: null,
    SMART_CARNET_PASSES_FINISHED: null,
    SMART_CARNET_RETURN_CLOSED: null,
    SMART_CARNET_TICKET_DETAILS_STARTED: null,
    SMART_CARNET_TICKET_DETAILS_FAILED: null,
    SMART_CARNET_TICKET_DETAILS_FINISHED: null,
    SMART_CARNET_TICKETS_STARTED: null,
    SMART_CARNET_TICKETS_FAILED: null,
    SMART_CARNET_TICKETS_FINISHED: null,

    INWARD_SERVICE_SELECTED: null,
    OUTWARD_SERVICE_SELECTED: null,

    FARE_SELECTED: null,
    FARE_ONLY_SELECTED: null,
    FARE_CATEGORY_SELECTED: null,
    FARE_STAGE_CHANGED: null,

    SELECTING_CHEAPEST_FARE: null,
    SELECTING_NON_CHEAPEST_FARE: null,

    DELIVERY_METHOD: null,
    PAYMENT_METHOD: null,

    ORDER_LOADING: null,
    ORDER_STARTED: null,
    ORDER_CREATED: null,
    ORDER_UPDATED: null,
    ORDER_FAILED: null,
    ORDER_TRIP_CREATED: null,
    ORDER_TRIP_UPDATED: null,
    ORDER_TRIP_DELETED: null,
    ORDER_TRIP_LEAD_PASSENGER_UPDATED: null,
    ORDER_PAID: null,
    BASKET_CLEARED: null,
    ORDER_DELIVERY_OPTIONS_LOADED: null,
    ORDER_DELIVERY_OPTIONS_LOADING: null,
    ORDER_PLUSBUS_UPDATED: null,
    ORDER_EXPIRED: null,
    ORDER_TAXI_BOOKING_AVAILABILITY: null,
    UTN_DETAILS: null,
    ORDER_CONTACT_DETAILS_UPDATED: null,
    POSTAL_FULFILMENT_STORED_ADDRESS_UPDATED: null,
    ORDER_HANDOFF_UPDATED: null,
    ORDER_HANDOFF_REFERRAL_REPORTED: null,
    LINK_ORDER_TO_ACCOUNT: null,

    ORDER_LOAD_STARTED: null,
    ORDER_LOADED: null,
    ORDER_LOAD_FAILED: null,

    APPLY_DISCOUNT_CODE_STARTED: null,
    APPLY_DISCOUNT_CODE_FAILED: null,
    APPLY_DISCOUNT_CODE_FINISHED: null,

    DELETE_DISCOUNT_CODE_STARTED: null,
    DELETE_DISCOUNT_CODE_FAILED: null,
    DELETE_DISCOUNT_CODE_FINISHED: null,

    ORDER_LOCKED: null,
    ORDER_UNLOCKED: null,

    SERVICE_SELECTED: null,
    LEG_SELECTED: null,

    TRIP_UPDATED: null,
    TRIP_PLUSBUS_AVAILABILITY_LOADED: null,

    FULFILMENT_UPDATED: null,
    FULFILMENT_METHOD_UPDATED: null,

    REGISTRATION_STARTED: null,
    REGISTRATION_FAILED: null,
    REGISTRATION_SUCCESS: null,

    LOGGED_IN: null,
    LOGGED_OUT: null,
    AUTH_LOADED: null,
    AUTH_REFRESH_STARTED: null,
    AUTH_REFRESHED: null,
    AUTH_ERROR: null,
    USER_UPDATED: null,
    CHECK_EMAIL: null,
    USER_PREFERENCES_UPDATED: null,
    USER_PREFERENCES_FETCHED: null,

    GET_CONSENTS_TEMPLATE_STARTED: null,
    GET_CONSENTS_TEMPLATE_SUCCESS: null,
    GET_CONSENTS_TEMPLATE_FAILED: null,
    GET_CONSENTS_TEMPLATE_FINISHED: null,

    GET_USER_CONSENTS_STARTED: null,
    GET_USER_CONSENTS_SUCCESS: null,
    GET_USER_CONSENTS_FAILED: null,
    GET_USER_CONSENTS_FINISHED: null,

    UPDATE_USER_CONSENTS_STARTED: null,
    UPDATE_USER_CONSENTS_SUCCESS: null,
    UPDATE_USER_CONSENTS_FAILED: null,
    UPDATE_USER_CONSENTS_FINISHED: null,

    SET_CONSENTS_FORM: null,

    MODAL_OPENED: null,
    MODAL_CLOSED: null,
    GENERIC_MODAL_OPEN: null,

    PAYMENT_FORM_CHANGED: null,
    PAYMENT_FORM_ERROR_MESSAGE: null,
    PAYMENT_DISCOUNT_CODE_CHANGED: null,
    PAYMENT_AUTH_STARTED: null,
    PAYMENT_AUTH_FINISHED: null,
    PAYMENT_AUTH_FAILED: null,
    PAYMENT_AUTH_RESET: null,
    PAYMENT_AUTH_WAITING: null,
    PAYMENT_PRE_AUTH_VOUCHERS_STARTED: null,
    PAYMENT_PRE_AUTH_VOUCHERS_RELEASED: null,
    PAYMENT_PRE_AUTH_VOUCHERS_COMPLETED: null,
    PAYMENT_LEFT: null,

    ORDER_REFRESH_STARTED: null,
    ORDER_REFRESH_LOADED: null,
    ORDER_REFRESH_FAILED: null,

    CALLING_POINTS_LOAD_STARTED: null,
    CALLING_POINTS_LOADED: null,
    CALLING_POINTS_LOAD_FAILED: null,

    ACCOUNT_DRC_LOADED: null,
    SET_FAVOURITE_DRC: null,
    REMOVED_DRC_DEVICE: null,

    RAILCARDS_LOAD_STARTED: null,
    RAILCARDS_LOADED: null,
    RAILCARDS_LOAD_FAILED: null,

    RAILCARD1617_CHECKED: null,
    RAILCARD1617_FLASH_CHECKBOX: null,
    RAILCARD1617_FORM_CHANGED: null,
    RAILCARD1617_LOAD_FAILED: null,
    RAILCARD1617_LOAD_STARTED: null,
    RAILCARD1617_LOADED: null,
    RAILCARD1617_REMOVE: null,
    RAILCARD1617_RESET_VALIDATION: null,
    RAILCARD1617_VALIDATION_COMPLETED: null,
    RAILCARD1617_VALIDATION_FAILED: null,
    RAILCARD1617_VALIDATION_STARTED: null,

    RAILCARD_JOBCENTREPLUS_CHECKED: null,

    IN_APP_SESSION_STARTED: null,
    DEVICE_TOKEN_UPDATED: null,
    SEARCH_WIDGET_LOADED: null,
    MOBILE_APP_RATING_TRIGGERED: null,
    MOBILE_APP_RE_ORDER: null,

    WIDGET_AUTH_SESSION_STARTED: null,

    LOADING_STARTED: null,
    LOADING_COMPLETED: null,
    LOADING_FAILED: null,
    LOADING_STOPPED: null,

    SHOW_EARLIER_TRAINS_STARTED: null,
    SHOW_EARLIER_TRAINS_FINISHED: null,
    SHOW_LATER_TRAINS_STARTED: null,
    SHOW_LATER_TRAINS_FINISHED: null,

    BANNER_DISMISSED: null,
    BANNER_CONFIG_LOADED: null,

    JOURNEY_NOTIFICATIONS_DISMISSED: null,
    JOURNEY_NOTIFICATIONS_LOADED: null,

    ADDRESSES_LOADED: null,
    ADDRESS_CREATED: null,
    ADDRESS_DELETED: null,
    ADDRESS_UPDATED: null,

    PHOTOCARDS_LOADED: null,
    PHOTOCARD_CREATED: null,
    PHOTOCARD_DELETED: null,

    ACCOUNT_RAILCARDS_LOADED: null,
    NEWLY_APPROVED_RAILCARDS_LOADED: null,
    ACCOUNT_RAILCARD_DELETED: null,
    RAILCARD_APPLICATION_SUBMITTED: null,

    NOTIFICATION_SHOW: null,
    NOTIFICATION_HIDE: null,

    SEASON_RESULTS_FILTERS_CHANGE: null,

    SET_TRIP_BIKES: null,

    DISCOUNT_LOADED: null,
    DISCOUNT_LOAD_FAILED: null,

    PROMOCODE_APPLIED: null,
    PROMOCODE_REMOVED: null,

    CUSTOMER_VOUCHERS_STARTED: null,
    CUSTOMER_VOUCHERS_LOADED: null,
    CUSTOMER_VOUCHERS_FAILED: null,

    CUSTOMER_ORDERS_SEARCHING: null,
    CUSTOMER_ORDERS_LOADED: null,
    CUSTOMER_ORDER_LOADED: null,

    CUSTOMER_PAYMENTCARDS_STARTED: null,
    CUSTOMER_PAYMENTCARDS_LOADED: null,
    CUSTOMER_PAYMENTCARD_DELETED: null,

    SMARTCARD_STARTED: null,
    SMARTCARD_LOADED: null,
    SMARTCARD_FAILED: null,
    SMARTCARD_FAILURE_NOTIFIED: null,
    SMARTCARD_DIRTY: null,
    SMARTCARD_REGISTERED: null,
    SMARTCARD_LINKED: null,
    SMARTCARDS_LOADED: null,
    SMARTCARD_JOURNEYS_LOADED: null,
    SMARTCARD_ACTIVATION_STARTED: null,
    SMARTCARD_ACTIVATION_FAILED: null,
    SMARTCARD_ACTIVATED: null,
    SMARTCARD_PAPER_TRANSFER_COMPLETE: null,
    SMARTCARD_SET_SHOW_COLLECTION_LOCATION: null,
    SMARTCARD_ASSOCIATED_SMARTCARDS_LOADED: null,
    SMARTCARD_ASSOCIATED_ACCOUNTS_LOADED: null,
    SMARTCARD_ASSOCIATION_COMPLETED: null,
    SMARTCARD_ASSOCIATION_REMOVED: null,
    SMARTCARD_TO_ASSOCIATE_LOADED: null,

    SMARTCARD_CTA_DISMISSED: null,

    LINKING_SMARTCARDS_LINK: null,

    CHECK_USER_COOKIE: null,

    KEYGO_FORM_CHANGED: null,
    KEYGO_ADDRESS_SELECTED: null,
    KEYGO_FORM_RETRY: null,
    KEYGO_REGISTRATION_STARTED: null,
    KEYGO_REGISTRATION_COMPLETE: null,
    KEYGO_REGISTRATION_FAILED: null,
    KEYGO_CANCELLED: null,
    KEYGO_UPDATE_STARTED: null,
    KEYGO_UPDATE_COMPLETE: null,
    KEYGO_UPDATE_FAILED: null,
    KEYGO_FORM_RESET: null,
    KEYGO_TAPS_LOADED: null,
    KEYGO_TRANSACTIONS_LOADED: null,
    KEYGO_TRANSACTIONS_LOADING: null,

    REPLACEMENT_SMARTCARD_REQUESTED: null,

    DAYSAVE_SEARCH_LOADED: null,
    DAYSAVE_SEARCH_STARTED: null,
    DAYSAVE_SEARCH_FINISHED: null,
    DAYSAVE_SEARCH_FAILED: null,
    DAYSAVE_TICKET_SELECTED: null,

    ROVERSRANGERS_SEARCH_LOADED: null,
    ROVERSRANGERS_SEARCH_STARTED: null,
    ROVERSRANGERS_SEARCH_FINISHED: null,
    ROVERSRANGERS_SEARCH_FAILED: null,
    ROVERSRANGERS_TICKET_SELECTED: null,
    ROVERSRANGERS_TICKET_PASSENGERS_CHANGED: null,

    UNSUBSCRIBE_STARTED: null,
    UNSUBSCRIBE_COMPLETE: null,
    UNSUBSCRIBE_FAILED: null,

    REFUND_CONFIG_STARTED: null,
    REFUND_CONFIG_LOADED: null,
    REFUND_CONFIG_FAILED: null,
    REFUND_DETAILS_STARTED: null,
    REFUND_DETAILS_LOADED: null,
    REFUND_DETAILS_FAILED: null,
    REFUND_CALCULATIONS_STARTED: null,
    REFUND_CALCULATIONS_LOADED: null,
    REFUND_ITSO_CALCULATIONS_LOADED: null,
    REFUND_CALCULATIONS_FAILED: null,
    REFUND_UPDATED: null,
    REFUND_STARTED: null,
    REFUND_COMPLETE: null,
    REFUND_FAILED: null,
    REFUND_RESET: null,

    AMEND_CANCELLED: null,
    AMEND_CANCEL_FAILED: null,
    AMEND_CANCEL_STARTED: null,
    AMEND_CONFIG_FAILED: null,
    AMEND_CONFIG_LOADED: null,
    AMEND_CONFIG_LOADING: null,
    AMEND_FARE_SELECTED: null,
    AMEND_ORDER_CANCEL: null,
    AMEND_ORDER_REFRESHED: null,
    AMEND_PAYMENT_AUTH_FINISHED: null,
    AMEND_RESET: null,
    AMEND_SEARCH_FAILED: null,
    AMEND_SEARCH_FINISHED: null,
    AMEND_SEARCH_LOADED: null,
    AMEND_SEARCH_STARTED: null,
    AMEND_SEARCH_UPDATED: null,
    AMEND_SERVICE_SELECTED: null,
    AMEND_SET_FAILED: null,
    AMEND_SET_STARTED: null,
    AMEND_SHOW_EARLIER_TRAINS_FINISHED: null,
    AMEND_SHOW_EARLIER_TRAINS_STARTED: null,
    AMEND_SHOW_LATER_TRAINS_FINISHED: null,
    AMEND_SHOW_LATER_TRAINS_STARTED: null,
    AMEND_TOOK_PAYMENT: null,
    AMEND_TRIP_FAILED: null,
    AMEND_TRIP_FINISHED: null,
    AMEND_TRIP_STARTED: null,
    AMEND_PLUSBUS_SET: null,
    AMEND_UPDATED: null,
    AMEND_CTA_CLICKED: null,
    AMEND_CONFIRMED: null,

    AMAZON_LOGIN_LOGIN_ACCESS_TOKEN: null,
    AMAZON_LOGIN_EMAIL: null,
    AMAZON_LOGIN_PROCESSING_FINISHED: null,
    AMAZON_LOGIN_PROCESSING_STARTED: null,
    AMAZON_LOGIN_STATUS: null,

    AMAZON_PAY_ADDRESS_ERROR: null,
    AMAZON_PAY_CLEAR_ERROR: null,
    AMAZON_PAY_ERROR: null,
    AMAZON_PAY_INVALID_PAYMENT_METHOD: null,
    AMAZON_PAY_LOGIN_COMPLETE: null,
    AMAZON_PAY_LOGOUT: null,
    AMAZON_PAY_MFA_SUCCESSFUL: null,
    AMAZON_PAY_PROCESSING: null,

    PAYPAL_CLIENT_TOKEN_LOADED: null,
    PAYPAL_PAYMENT_METHOD_RECEIVED: null,
    PAYPAL_ADDRESS_ERROR: null,
    PAYPAL_CHECKOUT: null,

    BRAINTREE_CLIENT_TOKEN_LOADED: null,
    BRAINTREE_PAYMENT_METHOD_RECEIVED: null,
    BRAINTREE_CHECKOUT: null,

    PAY360_SESSION_CREATE_STARTED: null,
    PAY360_SESSION_CREATED: null,
    PAY360_SESSION_LOADED: null,

    DELAY_REPAY_CUSTOMER_UPDATED: null,
    DELAY_REPAY_AGE_TOGGLED: null,
    DELAY_REPAY_USER_ADDED: null,
    DELAY_REPAY_SMARTCARD_ADDED: null,
    DELAY_REPAY_CLAIM_ADDED: null,
    DELAY_REPAY_CLAIM_UPDATED: null,
    DELAY_REPAY_CLAIM_REMOVED: null,
    DELAY_REPAY_CLAIM_CLONED: null,
    DELAY_REPAY_CLAIM_FILE_SELECTED: null,
    DELAY_REPAY_UPLOAD_STARTING: null,
    DELAY_REPAY_UPLOAD_COMPLETE: null,
    DELAY_REPAY_UPLOAD_FAILED: null,
    DELAY_REPAY_UPLOAD_CANCELLED: null,
    DELAY_REPAY_PAYMENT_UPDATED: null,
    DELAY_REPAY_SUBMITTING: null,
    DELAY_REPAY_SUBMITTED: null,
    DELAY_REPAY_FAILED: null,
    DELAY_REPAY_HPP_STARTED: null,
    DELAY_REPAY_HPP_RESPONSE_RECEIVED: null,
    DELAY_REPAY_HPP_AUTHORIZED: null,
    DELAY_REPAY_HPP_ABORTED: null,
    DELAY_REPAY_PAYMENT_RESET: null,
    DELAY_REPAY_RESET: null,
    DELAY_REPAY_CAPTCHA_COMPLETE: null,
    DELAY_REPAY_CAPTCHA_EXPIRED: null,
    DELAY_REPAY_CAPTCHA_VALIDATED: null,
    DELAY_REPAY_CAPTCHA_BYPASSED: null,
    DELAY_REPAY_CAPTCHA_FAILED: null,
    DELAY_REPAY_ADDRESS_UPDATED: null,
    DELAY_REPAY_BACS_VALIDATED: null,
    DELAY_REPAY_PAYMENT_PREFERENCES_LOADED: null,

    FAVOURITES_ADDED: null,
    FAVOURITES_REMOVED: null,
    FAVOURITES_LOADED: null,
    FAVOURITES_PHOTOCARD_UPDATED: null,
    FAVOURITES_DELIVERY_ADDED: null,
    FAVOURITES_DELIVERY_UPDATED: null,
    FAVOURITES_SEASON_EXPIRY_DATE_UPDATED: null,
    FAVOURITES_LAST_USED_DATE_UPDATED: null,

    DISRUPTION_ALERTS_LOAD_STARTED: null,
    DISRUPTION_ALERTS_LOAD_FINISHED: null,
    DISRUPTION_ALERTS_LOAD_FAILED: null,
    SERVICE_CHANGE_ALERTS_LOAD_STARTED: null,
    SERVICE_CHANGE_ALERTS_LOAD_FINISHED: null,
    SERVICE_CHANGE_ALERTS_LOAD_FAILED: null,
    DISRUPTION_ALERT_CREATED: null,
    DISRUPTION_ALERT_UPDATED: null,
    DISRUPTION_ALERT_DELETED: null,
    SERVICE_CHANGE_ALERT_DELETED: null,
    DISRUPTION_ALERT_MUTE_CREATED: null,
    DISRUPTION_ALERT_MUTE_UPDATED: null,
    DISRUPTION_ALERT_MUTE_DELETED: null,
    DISRUPTION_ALERTS_SEARCH_STARTED: null,
    DISRUPTION_ALERTS_SEARCH_FINISHED: null,
    DISRUPTION_ALERTS_SEARCH_FAILED: null,
    DISRUPTION_ALERTS_SEARCH_EARLIER_STARTED: null,
    DISRUPTION_ALERTS_SEARCH_EARLIER_FINISHED: null,
    DISRUPTION_ALERTS_SEARCH_LATER_STARTED: null,
    DISRUPTION_ALERTS_SEARCH_LATER_FINISHED: null,
    DISRUPTION_ALERTS_SERVICES_RESET: null,
    DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_STARTED: null,
    DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_FINISHED: null,
    DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_FAILED: null,

    COMPENSATION_RESET: null,
    COMPENSATION_CLAIM_UPDATED: null,
    COMPENSATION_CLAIM_ABORTED: null,
    COMPENSATION_ROUTE_ADDED: null,
    COMPENSATION_ROUTE_REMOVED: null,
    COMPENSATION_TICKET_ADDED: null,
    COMPENSATION_TICKET_REMOVED: null,
    COMPENSATION_TRAVEL_WEEK_ADDED: null,
    COMPENSATION_TRAVEL_WEEK_REMOVED: null,
    COMPENSATION_TRAVEL_WEEK_UPDATED: null,
    COMPENSATION_UPLOAD_STARTING: null,
    COMPENSATION_UPLOAD_COMPLETE: null,
    COMPENSATION_UPLOAD_FAILED: null,
    COMPENSATION_UPLOAD_CANCELLED: null,
    COMPENSATION_WHITELIST_INITIALISED: null,
    COMPENSATION_WHITELIST_VALIDATED: null,
    COMPENSATION_SUBMITTED: null,
    COMPENSATION_AUTHORIZED: null,
    COMPENSATION_USER_ADDED: null,
    COMPENSATION_SMARTCARD_ADDED: null,
    AUTO_DR_CLAIMS_LOADING: null,
    AUTO_DR_CLAIMS_LOADED: null,
    AUTO_DR_CLAIMS_FAILED: null,
    AUTO_DR_CLAIM_SUBMIT_STARTED: null,
    AUTO_DR_CLAIM_SUBMITTED: null,
    AUTO_DR_CLAIM_SUBMIT_FAILED: null,
    AUTO_DR_CLAIM_SUBMIT_CANCELLED: null,
    AUTO_DR_CLAIM_AUTHORIZED: null,
    AUTO_DR_CLAIM_DISMISSED: null,
    AUTO_DR_CLAIM_SELECTED: null,
    AUTO_DR_CLAIM_DESELECTED: null,
    AUTO_DR_CLAIM_FORM_UPDATED: null,
    AUTO_DR_CLAIM_BACS_VALIDATED: null,

    FEATURE_TOGGLED: null,
    FEATURE_VARIANT_UPDATED: null,

    PRESELECT_CHEAPEST: null,
    UPDATE_DISPLAY_FILTERS: null,
    LAYOUT_SET_EMBEDDED: null,

    WIDGET_SEARCH_STATION_SELECT: null,
    WIDGET_SEARCH_STATION_SWITCH: null,
    WIDGET_SEARCH_CLICK: null,
    WIDGET_SEARCH_DAY_SELECT: null,

    PLUS_BUS_SELECT: null,
    FARES_EXPAND: null,

    EXTERNAL_LINK: null,

    JP_CHANGE_LAYOUT: null,
    JP_FARE_CLASS_FILTER_CLICK: null,
    JP_FARE_SELECTION_FILTER_CLICK: null,
    JP_TOC_SPECIFIC_FILTER_RENDERED: null,
    JP_TOC_SPECIFIC_FILTER_CLICK: null,
    JP_ALL_FARES_ACCORDION_CLICK: null,
    JP_CHECKOUT_WITH_SUGGESTED_PRODUCTS: null,
    JP_CHANGE_SEARCH_TYPE: null,

    TUTORIAL_TOGGLE: null,

    STATION_FINDER_SEARCH_STARTED: null,
    STATION_FINDER_SEARCH_COMPLETE: null,
    STATION_FINDER_SEARCH_FAILED: null,
    STATION_FINDER_STATIONS_CLEARED: null,
    STATION_FINDER_ERROR_CLEARED: null,
    STATION_FINDER_SET_EXPANDED: null,
    STATION_FINDER_STATION_SELECTED: null,
    STATION_FINDER_TICKET_OFFICE_LOADED: null,

    FAVOURITE_ADDED_TO_BASKET: null,
    REORDER_ADDED_TO_BASKET: null,

    RETURN_TRAVELCARD_CTA_CLICK: null,

    WIDGETS_RENDER_JP: null,
    WIDGETS_VIEW_RESULTS: null,

    VISA_CO_SETUP: null,
    VISA_CO_UPDATE_AMOUNT: null,
    VISA_CO_STORE_PAYMENT_CARD: null,
    VISA_CO_GET_CARD_DETAILS: null,
    VISA_CO_CARD_DETAILS_LOADED: null,
    VISA_CO_DELIVERY_ADDRESS_UPDATED: null,
    VISA_CO_STORED_PAYMENT_CARD_LOADED: null,

    GET_COLLECTION_STATIONS_STARTED: null,
    GET_COLLECTION_STATIONS_ENDED: null,
    GET_COLLECTION_STATIONS_FAILED: null,

    OPEN_GOLF_GET_TICKETS_STARTED: null,
    OPEN_GOLF_GET_TICKETS_ENDED: null,
    OPEN_GOLF_GET_TICKETS_FAILED: null,
    OPEN_GOLF_ADD_TRIP: null,

    FARE_HANDOFF_LOADING: null,
    FARE_HANDOFF_LOADED: null,
    FARE_HANDOFF_LOAD_FAILED: null,

    TRACKING_ENABLED: null,
    TRACKING_DISABLED: null,
    SHOW_FLEXI_WARNING_MODAL: null,
    FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_CHECKED: null,
    FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_UNCHECKED: null,
    FLEXI_WARNING_MODAL_CLOSE: null,
    FLEXI_WARNING_MODAL_CONTINUE: null,
    FLEXI_WARNING_MODAL_MORE_INFO_CLICKED: null,

    SEATING_AVAILABILITY_STARTED: null,
    SEATING_AVAILABILITY_LOADED: null,
    SEATING_AVAILABILITY_FAILED: null,

    TOGGLE_SEATFINDER: null,
    TOGGLE_STEP_FREE: null,
    TOGGLE_SEAT_AVAILABILITY: null,
    TOGGLE_JOURNEY_SUPPORT_MODAL: null,

    USER_OPTED_IN: null,
    USER_OPTED_OUT: null,
    SELECT_NOTIFICATION_PREFERENCE: null,
    SELECT_REPAYMENT_METHOD: null,
    AMEND_REPAYMENT_METHOD: null,
    AMEND_NOTIFICATION_PREFERENCE: null,
    AMEND_ADDRESS: null,

    USER_OCDR_SUBSCRIBE_SUCCESS: null,
    USER_OCDR_SUBSCRIBE_FAILURE: null,
    USER_OCDR_UNSUBSCRIBE_SUCCESS: null,
    USER_OCDR_UNSUBSCRIBE_FAILURE: null,
    USER_OCDR_UPDATE_SUBSCRIPTION_SUCCESS: null,
    USER_OCDR_UPDATE_SUBSCRIPTION_FAILURE: null,

    SET_IN_APP: null,

    SET_TIMETABLE_ALERTS_WIDGET_STATE: null,
    GET_TIMETABLE_ALERTS_WIDGET_STATE: null,
    ADD_TIMETABLE_ALERT: null,
    RESET_TIMETABLE_ALERTS: null,
    SAVE_REGULAR_JOURNEY_WITH_OCDR_FAV_JOURNEY: null,

    WEBCHAT_OPENED: null,

    BACK_FROM_PAYMENT_PAGE: null,
    ADD_ANOTHER_JOURNEY_ON_DELIVERY_PAGE: null,
    ADD_ANOTHER_JOURNEY_ON_PAYMENT_PAGE: null,
    ADD_ANOTHER_JOURNEY_ON_BASKET_MODAL: null,

    DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_REMOVED: null,
    DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_KEPT: null,

    SET_ACCESSIBILITY_PROFILE_FORM: null,
    AUTO_POPULATE_ACCESSIBILITY_PROFILE_FORM: null,
    RESET_ACCESSIBILITY_PROFILE_FORM: null,
    SET_ACCESSIBILITY_PROFILE_STATUS: null,
    SET_ACCESSIBILITY_PROFILE: null,
    SET_BOOKING_PA_STATUS: null,
    SET_TRAVEL_ASSIST: null,
    DELETE_TRAVEL_ASSIST: null,
    SET_PENDING_TRAVEL_ASSIST_REQUESTS: null,
    SET_PENDING_TRAVEL_ASSIST_REQUEST_ENABLED: null,
    CLEAR_PENDING_TRAVEL_ASSIST_REQUESTS: null,
    RESET_TRAVEL_ASSIST: null,
    SET_IS_EDIT_PA_MODE_ENABLED: null,
    SET_EDIT_PA_SECTION: null,
    USE_ACCESSIBILITY_PROFILE: null,
    RESET_OUTWARD_JOURNEY: null,
    RESET_RETURN_JOURNEY: null,
    SET_BOOKING_PA_ENTER_ACCESSIBILITY_PROFILE_STEP: null,
    SET_SHOW_BACK_TO_SEARCH_RESULTS_BUTTON: null,

    ADD_ORDER_TRIP_ID_TO_PASSENGER_ASSIST_REQUEST: null,

    SET_ACCESSIBILITY_PROFILE_STEP: null,
    SET_NEXT_ACCESSIBILITY_PROFILE_STEP: null,
    SET_PREV_ACCESSIBILITY_PROFILE_STEP: null,

    SET_BOOKING_PA_STEP: null,
    SET_NEXT_BOOKING_PA_STEP: null,
    SET_PREV_BOOKING_PA_STEP: null,

    FETCH_CHILD_SMARTCARD_REPLACEMENT_STARTED: null,
    FETCH_CHILD_SMARTCARD_REPLACEMENT_SUCCESS: null,
    FETCH_CHILD_SMARTCARD_REPLACEMENT_FAILED: null,
    FETCH_CHILD_SMARTCARD_REPLACEMENT_FINISHED: null,

    REQUEST_CHILD_SMARTCARD_REPLACEMENT_STARTED: null,
    REQUEST_CHILD_SMARTCARD_REPLACEMENT_SUCCESS: null,
    REQUEST_CHILD_SMARTCARD_REPLACEMENT_FAILED: null,
    REQUEST_CHILD_SMARTCARD_REPLACEMENT_FINISHED: null,

    GET_ACCESSIBILITY_PROFILE_STARTED: null,
    GET_ACCESSIBILITY_PROFILE_LOADED: null,
    GET_ACCESSIBILITY_PROFILE_FAILED: null,
    GET_ACCESSIBILITY_PROFILE_FINISHED: null,

    CREATE_ACCESSIBILITY_PROFILE_STARTED: null,
    CREATE_ACCESSIBILITY_PROFILE_LOADED: null,
    CREATE_ACCESSIBILITY_PROFILE_FAILED: null,
    CREATE_ACCESSIBILITY_PROFILE_FINISHED: null,

    DELETE_ACCESSIBILITY_PROFILE_STARTED: null,
    DELETE_ACCESSIBILITY_PROFILE_SUCCESS: null,
    DELETE_ACCESSIBILITY_PROFILE_FAILED: null,
    DELETE_ACCESSIBILITY_PROFILE_FINISHED: null,

    UPDATE_ACCESSIBILITY_PROFILE_STARTED: null,
    UPDATE_ACCESSIBILITY_PROFILE_LOADED: null,
    UPDATE_ACCESSIBILITY_PROFILE_FAILED: null,
    UPDATE_ACCESSIBILITY_PROFILE_FINISHED: null,

    GET_PREVIOUS_JOURNEYS_STARTED: null,
    GET_PREVIOUS_JOURNEYS_SUCCESS: null,
    GET_PREVIOUS_JOURNEYS_FAILED: null,
    GET_PREVIOUS_JOURNEYS_FINISHED: null,

    GET_ASSISTED_TRAVEL_LOCATION_STARTED: null,
    GET_ASSISTED_TRAVEL_LOCATION_SUCCESS: null,
    GET_ASSISTED_TRAVEL_LOCATION_FAILED: null,
    GET_ASSISTED_TRAVEL_LOCATION_FINISHED: null,

    BOOK_ASSIST_STARTED: null,
    BOOK_ASSIST_SUCCESS: null,
    BOOK_ASSIST_FAILED: null,
    BOOK_ASSIST_FINISHED: null,

    BOOK_MANY_ASSISTS_STARTED: null,
    BOOK_MANY_ASSISTS_SUCCESS: null,
    BOOK_MANY_ASSISTS_FAILED: null,
    BOOK_MANY_ASSISTS_FINISHED: null,

    GET_ASSISTED_BOOKING_STARTED: null,
    GET_ASSISTED_BOOKING_SUCCESS: null,
    GET_ASSISTED_BOOKING_FAILED: null,
    GET_ASSISTED_BOOKING_FINISHED: null,

    GET_ASSISTED_BOOKINGS_STARTED: null,
    GET_ASSISTED_BOOKINGS_SUCCESS: null,
    GET_ASSISTED_BOOKINGS_FAILED: null,
    GET_ASSISTED_BOOKINGS_FINISHED: null,

    SET_PASSENGER_ASSIST_WIDGET_TOGGLED: null,

    CANCEL_ASSISTED_BOOKING_STARTED: null,
    CANCEL_ASSISTED_BOOKING_SUCCESS: null,
    CANCEL_ASSISTED_BOOKING_FAILED: null,
    CANCEL_ASSISTED_BOOKING_FINISHED: null,

    EDIT_ASSISTED_BOOKING_STARTED: null,
    EDIT_ASSISTED_BOOKING_SUCCESS: null,
    EDIT_ASSISTED_BOOKING_FAILED: null,
    EDIT_ASSISTED_BOOKING_FINISHED: null,

    FAMILY_VERIFICATION_STARTED: null,
    FAMILY_VERIFICATION_VERIFIED: null,
    FAMILY_VERIFICATION_FAILED: null,
    FAMILY_VERIFICATION_ALLOWANCE_EXCEEDED: null,
    FAMILY_VERIFICATION_RESET: null,

    START_RESERVATION_FLOW: null,
    CANCEL_RESERVATION_FLOW: null,
    RESERVATION_COMPLETED: null,

    ADD_BIKE_RESERVATION: null,
    REMOVE_BIKE_RESERVATION: null,
    ADD_SEAT_RESERVATION: null,
    REMOVE_SEAT_RESERVATION: null,

    CREATE_RESERVATION_STARTED: null,
    CREATE_RESERVATION_LOADED: null,
    CREATE_RESERVATION_FINISHED: null,
    CREATE_RESERVATION_FAILED: null,

    AMEND_RESERVATION_STARTED: null,
    AMEND_RESERVATION_LOADED: null,
    AMEND_RESERVATION_FINISHED: null,
    AMEND_RESERVATION_FAILED: null,

    GET_RESERVATION_STARTED: null,
    GET_RESERVATION_LOADED: null,
    GET_RESERVATION_FINISHED: null,
    GET_RESERVATION_FAILED: null,
    CLEAR_RESERVATION_STORE: null,

    RESERVATION_WIDGET_TOGGLED: null,

    GET_ORDER_CHARITY_OPTIONS_STARTED: null,
    GET_ORDER_CHARITY_OPTIONS_SUCCESS: null,
    GET_ORDER_CHARITY_OPTIONS_FAILED: null,
    GET_ORDER_CHARITY_OPTIONS_FINISHED: null,

    SET_ORDER_CHARITY_OPTIONS_STARTED: null,
    SET_ORDER_CHARITY_OPTIONS_SUCCESS: null,
    SET_ORDER_CHARITY_OPTIONS_FAILED: null,
    SET_ORDER_CHARITY_OPTIONS_FINISHED: null,

    DELETE_ORDER_CHARITY_OPTIONS_STARTED: null,
    DELETE_ORDER_CHARITY_OPTIONS_SUCCESS: null,
    DELETE_ORDER_CHARITY_OPTIONS_FAILED: null,
    DELETE_ORDER_CHARITY_OPTIONS_FINISHED: null,

    CANCEL_RESERVATION_STARTED: null,
    CANCEL_RESERVATION_SUCCESS: null,
    CANCEL_RESERVATION_FAILED: null,
    CANCEL_RESERVATION_FINISHED: null,
    CLEAR_CANCEL_RESERVATION_STATUS: null,

    SET_RESERVATION_REQUEST_PASSENGERS: null,
    SET_RESERVATION_REQUEST_BIKES: null,

    SET_RESERVATION_BIKES_COUNT: null,

    CLEAR_RESERVATION_REQUEST_STORE: null,

    GET_RESERVATIONS_AVAILABILITY_STARTED: null,
    GET_RESERVATIONS_AVAILABILITY_SUCCESS: null,
    GET_RESERVATIONS_AVAILABILITY_FAILED: null,
    GET_RESERVATIONS_AVAILABILITY_FINISHED: null,

    SET_RESERVATION_REQUEST_OUTBOUND_SERVICE: null,
    SET_RESERVATION_REQUEST_INBOUND_SERVICE: null,
    SET_RESERVATION_REQUEST_OUTBOUND_FARE: null,
    SET_RESERVATION_REQUEST_INBOUND_FARE: null,

    RESET_RESERVATION_REQUEST_OUTBOUND_SERVICE: null,
    RESET_RESERVATION_REQUEST_INBOUND_SERVICE: null,
    RESET_RESERVATION_REQUEST_OUTBOUND_FARE: null,
    RESET_RESERVATION_REQUEST_INBOUND_FARE: null,

    SET_RESERVATION_PAGINATION: null,

    SET_RESERVATION_REQUEST_SEATS: null
});

var RecentStationsTypes = exports.RecentStationsTypes = (0, _keymirror2.default)({
    SEASON: null,
    POINT: null,
    SMARTCARD: null,
    SMARTCARDSEASON: null,
    DAYSAVE: null,
    DELAY_REPAY: null
});

var StationTypes = exports.StationTypes = {
    ORIGIN: 'origin',
    DESTINATION: 'destination',
    TICKET_ORIGIN: 'ticketOrigin',
    TICKET_DESTINATION: 'ticketDestination',
    VIAAVOID: 'viaAvoid',
    VIA: 'via',
    AVOID: 'avoid'
};

var DaySaveStationTypes = exports.DaySaveStationTypes = {
    ORIGIN: 'DaySaveOrigin'
};

var SmartcardStationTypes = exports.SmartcardStationTypes = {
    ORIGIN: 'smartcardOrigin',
    DESTINATION: 'smartcardDestination',
    VIAAVOID: 'smartcardViaAvoid'
};

var SeasonStationTypes = exports.SeasonStationTypes = {
    ORIGIN: 'seasonOrigin',
    DESTINATION: 'seasonDestination'
};

var SmartcardSeasonStationTypes = exports.SmartcardSeasonStationTypes = {
    ORIGIN: 'SmartcardSeasonOrigin',
    DESTINATION: 'SmartcardSeasonDestination'
};

var DelayRepayStationTypes = exports.DelayRepayStationTypes = {
    ORIGIN: 'delayRepayOrigin',
    DESTINATION: 'delayRepayDestination',
    VIAAVOID: 'delayRepayViaAvoid',
    TICKETORIGIN: 'delayRepayOrigin',
    TICKETDESTINATION: 'delayRepayDestination'
};

var TimeTypes = exports.TimeTypes = {
    ARRIVE: 'Arrive',
    DEPART: 'Depart'
};

var TimeDirections = exports.TimeDirections = {
    EARLIER: 'earlier',
    LATER: 'later'
};

var JourneyStatus = exports.JourneyStatus = {
    SUCCESSFUL: 'successful',
    BROKEN: 'broken',
    REPAIRED: 'repaired'
};

var AdjustedTimeConfidence = exports.AdjustedTimeConfidence = {
    UNCERTAIN: 'Uncertain'
};

var JourneyDirections = exports.JourneyDirections = {
    OUTWARD: 'outward',
    INWARD: 'inward'
};

var PlusBusDirections = exports.PlusBusDirections = {
    OUTWARD: 'outward',
    RETURN: 'return'
};

var SearchTypes = exports.SearchTypes = {
    CHEAPEST: 'cheapest',
    FASTEST: 'fastest'
};

var FareClasses = exports.FareClasses = {
    STANDARD: 'standard',
    FIRST_CLASS: 'first-class',
    CARNET: 'carnet',
    ALL: 'all'
};

var NRELinkFareClasses = exports.NRELinkFareClasses = {
    STANDARD: 'Standard',
    FIRST: 'First'
};

var BasketItemTypes = exports.BasketItemTypes = {
    SINGLE_OUTWARD: 'outwardSingle',
    SINGLE_INWARD: 'inboundSingle',
    RETURN: 'return'
};

var FareCategories = exports.FareCategories = {
    ADVANCE: 'Advance',
    OFF_PEAK: 'OffPeak',
    ANYTIME: 'Anytime'
};

var FareFilterSelections = exports.FareFilterSelections = (0, _keymirror2.default)({
    CHEAPEST: null,
    FASTEST: null,
    FIRST_CLASS: null
});

var SmartCarnetFilterTypes = exports.SmartCarnetFilterTypes = {
    ROUTE: 'route',
    SERVICE: 'service'
};

var SmartCarnetFiltersService = exports.SmartCarnetFiltersService = (0, _keymirror2.default)({
    OFF_PEAK: null,
    PEAK: null
});

var SmartCarnetFiltersRoute = exports.SmartCarnetFiltersRoute = (0, _keymirror2.default)({
    ANY_PERMITTED: null,
    BRAND_ONLY: null
});

var GridPages = exports.GridPages = {
    SERVICES: 'services-grid'
};

var PointStages = exports.PointStages = {
    INIT: 'point-init',
    SEARCH: 'point-search',
    RESULTS: 'point-results',
    SEARCH_RESULTS: 'point-search-results',
    CHOOSE_OUTWARD: 'point-choose-out'
};

var SeasonStages = exports.SeasonStages = {
    INIT: 'season-init',
    SEARCH: 'season-search',
    RESULTS: 'season-results',
    DETAILS: 'season-details'
};

var OtherTicketStages = exports.OtherTicketStages = {
    SEARCH: 'other-search'
};

var DaySaveStages = exports.DaySaveStages = {
    SEARCH: 'daysave-search',
    RESULTS: 'daysave-results'
};

var RoversRangersStages = exports.RoversRangersStages = {
    SEARCH: 'roversrangers-search',
    RESULTS: 'roversrangers-results'
};

var SmartCarnetStages = exports.SmartCarnetStages = {
    SEARCH: 'smartcarnet-search',
    RESULTS: 'smartcarnet-results'
};

var CheckoutStages = exports.CheckoutStages = {
    DELIVERY: 'delivery',
    PAYMENT: 'payment',
    PAYMENT_AMAZON_PAY: 'payment-amazonpay',
    PAYMENT_CARD_HOSTED: 'payment-card-hosted',
    PAYMENT_CARD_HOSTED_BRAINTREE: 'payment-card-hosted-braintree',
    PAYMENT_CONFIRMATION: 'payment-confirmation',
    AMAZON_PAY_MFA_SUCCESS: 'amazonpay-mfa-success',
    AMAZON_PAY_MFA_FAILURE: 'amazonpay-mfa-failure'
};

var AccountPages = exports.AccountPages = {
    ACCOUNT_DETAILS: 'account',
    ACCOUNT_ADDRESSES: 'account-addresses',
    ACCOUNT_PREFERENCE_CENTRE: 'account-preferences',
    ACCOUNT_PHOTOCARDS_RAILCARDS: 'account-photocards-railcards',
    ACCOUNT_PAYMENT: 'account-payment',
    ACCOUNT_ORDERS_REFUNDS: 'account-ordersrefunds',
    ACCOUNT_ORDER_DETAILS: 'account-orderdetails',
    ACCOUNT_REFUND_DETAILS: 'account-refunddetails',
    ACCOUNT_AUTO_DELAY_REPAY: 'auto-delay-repay',
    ACCOUNT_AMEND_DETAILS: 'account-amenddetails',
    ACCOUNT_AMEND_SEARCH: 'account-amendsearch',
    ACCOUNT_AMEND_CHECKOUT: 'account-amendcheckout',
    ACCOUNT_STICKETS: 'account-stickets',
    ACCOUNT_ETICKETS: 'account-etickets',
    ACCOUNT_DISRUPTION_ALERTS: 'account-disruption-alerts',
    ACCOUNT_LINK_ORDER: 'account-linkorder',
    ACCOUNT_SMART_CARNET: 'account-smart-carnet',
    ACCOUNT_CONFIRM_SMARTCARD_REPLACEMENT: 'account-confirm-smartcard-replacement',
    ACCOUNT_RESERVATIONS: 'account-reservations',
    SMARTCARD_APPLY: 'smartcard-apply',
    SMARTCARD_TICKETS: 'smartcard-tickets',
    SMARTCARD_HISTORY: 'smartcard-history',
    SMARTCARD_KEYGO: 'smartcard-keygo',
    SMARTCARD_KEYGO_HISTORY: 'smartcard-keygo-history',
    SMARTCARD_REPLACEMENT: 'smartcard-replacement',
    SMARTCARD_TRANSFER: 'smartcard-transfer',
    SMARTCARD_TRANSFER_RESULTS: 'smartcard-transfer-results',
    SMARTCARD_TRANSFER_CONFIRMATION: 'smartcard-transfer-confirmation',
    SMARTCARD_LINK: 'smartcard-link',
    SMARTCARD_LINK_CONFIRMATION: 'smartcard-link-confirmation',
    EVOUCHERS: 'evouchers',
    AUTO_DELAY_REPAY: 'auto-dr-claims',
    ONE_CLICK_DELAY_REPAY: 'one-click-delay-repay',
    FLEXI: 'flexi',
    BOOK_PASSENGER_ASSIST: 'book-passenger-assist',
    VIEW_BOOKED_ASSISTANCE: 'view-booked-assistance',
    ACCESSIBILITY_PROFILE: 'accessibility-profile',
    ACCOUNT_HISTORIC_ETICKETS: 'historic-etickets'
};

var PortalClaims = exports.PortalClaims = {
    MY_CLAIMS: 'my-claims'
};

var DisruptionAlertsPages = exports.DisruptionAlertsPages = {
    MUTE: 'disruption-alerts-mute',
    DELETE: 'timetable-change-delete'
};

var SmartcardPages = exports.SmartcardPages = {
    SELF_REGISTERED: 'smartregister'
};

var AccountPagesForceLoginInsteadOfRedirect = exports.AccountPagesForceLoginInsteadOfRedirect = [AccountPages.ACCOUNT_STICKETS, AccountPages.ACCOUNT_ETICKETS, AccountPages.ACCOUNT_LINK_ORDER, AccountPages.ACCOUNT_PREFERENCE_CENTRE, AccountPages.ACCOUNT_DISRUPTION_ALERTS];

var Tutorials = exports.Tutorials = {
    JP_GRID: 'jp-grid',
    JP_LIST: 'jp-list',
    SEASONS: 'seasons',
    STATION_FINDER: 'station-finder',
    PREFERENCE_CENTRE: 'preference-centre',
    SMARTCARD: 'smartcard',
    RAILCARD: 'railcard'
};

var JPListTutorialStages = exports.JPListTutorialStages = {
    INTRO: 'intro',
    TABS: 'tabs',
    LIST_VIEW: 'list-view',
    GRID_VIEW: 'grid-view',
    TOC_FILTER: 'toc-filter',
    SELECT_SERVICE: 'select-service',
    SERVICE_INFO: 'service-info',
    SELECT_FARE: 'select-fare',
    TICKET_DETAILS: 'ticket-details',
    RETURN_SERVICE: 'return-service',
    PREFERENCES: 'preferences'
};

var JPGridTutorialStages = exports.JPGridTutorialStages = {
    INTRO: 'intro',
    TABS: 'tabs',
    GRID_VIEW: 'grid-view',
    LIST_VIEW: 'list-view',
    TOC_FILTER: 'toc-filter',
    SERVICE_CAROUSEL: 'service-carousel',
    SERVICE_INFO: 'service-info',
    TICKET_CATEGORIES: 'ticket-categories',
    TICKET_DETAILS: 'ticket-details',
    PREFERENCES: 'preferences'
};

var SeasonsTutorialStages = exports.SeasonsTutorialStages = {
    INTRO: 'intro',
    FILTERS: 'filters',
    COMPARISON: 'comparison'
};

var StationFinderTutorialStages = exports.StationFinderTutorialStages = {
    INTRO: 'intro',
    ORIGIN_DESTINATION: 'origin-destination'
};

var CONSENTS = exports.CONSENTS = {
    PHONE: 'phone',
    EMAIL_MARKETING: 'Email_Marketing',
    PUSH_MARKETING: 'Push_Marketing',
    SMS_Marketing: 'SMS_Marketing',
    OVER_16: 'over_16',
    UNDER_16: 'under_16',
    I_CONFIRM_16_YEARS_OLD: 'i_confirm_i_am_16_years_old_or_older',
    PERMISSIONS: 'permissions',
    SINGLE_CHOICE_PREFERENCE: 'single-choice-preference'
};

var SmartcardTutorial = exports.SmartcardTutorial = {
    INTRO: 'intro'
};

var RailcardTutorial = exports.RailcardTutorial = {
    INTRO: 'intro'
};

var NREPages = exports.NREPages = {
    ORDER_LANDING: 'order-landing'
};

var LoginPages = exports.LoginPages = {
    RESET_PASSWORD: 'reset-password',
    SET_PASSWORD_AND_PREFERENCES: 'set-password-and-preferences'
};

var NewsletterPages = exports.NewsletterPages = {
    UNSUBSCRIBE: 'newsletter-unsubscribe'
};

var InAppPages = exports.InAppPages = {
    LOGIN: 'in-app-login',
    ACCOUNT: 'in-app-account-menu',
    ACCOUNT_ORDERS_REFUNDS: 'in-app-account-orders',
    ONE_CLICK_DELAY_REPAY: 'in-app-one-click-delay-repay',
    AUTO_DELAY_REPAY: 'in-app-auto-delay-repay',
    REDIRECT: 'in-app-redirect',
    REGISTER: 'in-app-register',
    REGISTER_SMARTCARD: 'in-app-register-smartcard',
    SEARCH: 'in-app-search',
    SEASON_SEARCH: 'in-app-season-tickets',
    LOGOUT: 'in-app-logout',
    RESULTS: 'in-app-results',
    SEASON_RESULTS: 'in-app-season-results'
};

var WidgetAuthPages = exports.WidgetAuthPages = {
    LOGIN: 'widget-auth-login',
    REGISTER: 'widget-auth-register',
    LOGOUT: 'widget-auth-logout'
};

var HandOffPages = exports.HandOffPages = {
    FARE: 'hand-off-fare'
};

var PromotionPages = exports.PromotionPages = {
    PROMOTION: 'promotion',
    APPLY_PROMOTION: 'apply-promotion',
    TOC_FAMILY: 'toc-family',
    TOC_FAMILY_VERIFY: 'toc-family-verify'
};

var OtherPages = exports.OtherPages = {
    PAYMENT_LANDING: 'order-payment'
};

var SearchWidgetPages = exports.SearchWidgetPages = {
    IFRAME: 'search-widget-iframe'
};

var DelayRepayPages = exports.DelayRepayPages = {
    CUSTOMER: 'delayrepay-customer',
    CLAIMS: 'delayrepay-claims',
    PAYMENT: 'delayrepay-payment',
    CONFIRM: 'delayrepay-confirm'
};

var AutoDelayRepayPages = exports.AutoDelayRepayPages = {
    SUBSCRIPTION: 'auto-delayrepay-subscription'
};

var DelayRepayClaimType = exports.DelayRepayClaimType = {
    DEFAULT: 'delay-repay',
    SEASON_COMPENSATION: 'season-ticket-compensation',
    NON_SEASON_COMPENSATION: 'daily-ticket-compensation'
};

var CompensationPages = exports.CompensationPages = {
    DETAILS: 'compensation-details',
    SEASON: 'compensation-season',
    PRE_APPROVED: 'compensation-pre-approved',
    NON_SEASON: 'compensation-non-season'
};

var CompensationClaimType = exports.CompensationClaimType = {
    WHITELIST: 'whitelist',
    SEASON: 'season',
    NON_SEASON: 'nonSeason'
};

var CompensationTicket = exports.CompensationTicket = {
    // season
    STANDARD: 'season-standard-class',
    FIRST_CLASS: 'season-first-class',
    TRAVELCARD: 'season-travelcard',
    SEASON_OYSTER: 'season-oyster',
    SMART_KEY: 'contactless-key',
    SMART_PAYGO: 'contactless-paygo',
    SMART_OTHER: 'contactless-other',

    // non-season
    SINGLE: 'single',
    RETURN: 'return',
    CARNET: 'carnet',
    FREEDOM_PASS: 'freedom-pass',
    CONTACTLESS_BANK: 'contactless-other',
    OYSTER_PAYG: 'contactless-paygo',
    CONTACTLESS_KEY: 'contactless-key'
};

var CompensationPurchaseLocations = exports.CompensationPurchaseLocations = {
    STATION: 'ticket-office',
    WEBSITE: 'online',
    OTHER: 'other'
};

var CompensationEvidence = exports.CompensationEvidence = {
    TICKET_IMAGE: 'ticket-image',
    TICKET_RECEIPT: 'receipt',
    TICKET_MIXTURE: 'ticket-mixture',
    BANK_STATEMENT: 'bank-statement',
    JOURNEY_HISTORY: 'journey-history',
    FREEDOM_PASS_IMAGE: 'freedom-pass-image',
    OTHER: 'further-information',
    NONE: 'no-evidence'
};

var DelayRepayTicket = exports.DelayRepayTicket = {
    SEASON_ANNUAL: 'season-annual',
    SEASON_SIX_MONTHLY: 'season-quarterly',
    SEASON_QUARTERLY: 'season-six-monthly',
    SEASON_MONTHLY: 'season-monthly',
    SEASON_WEEKLY: 'season-weekly',
    SEASON_OTHER: 'season-other',
    SEASON_OYSTER: 'season-oyster',
    SINGLE: 'single',
    RETURN: 'return',
    ETICKET_SINGLE: 'selfprint-single',
    ETICKET_RETURN: 'selfprint-return',
    SMART_KEY: 'contactless-key',
    SMART_PAYGO: 'contactless-paygo',
    SMART_OTHER: 'contactless-other',
    ADVANCE: 'advance',
    ANYTIME_DAY_RETURN: 'anytime-day-return',
    ANYTIME_DAY_SINGLE: 'anytime-day-single',
    ANYTIME_RETURN: 'anytime-return',
    ANYTIME_SINGLE: 'anytime-single',
    OFFPEAK_DAY_RETURN: 'offpeak-day-return',
    OFFPEAK_DAY_SINGLE: 'offpeak-day-single',
    OFFPEAK_RETURN: 'offpeak-return',
    OFFPEAK_SINGLE: 'offpeak-single',
    ROVER_RANGER: 'rover-ranger'
};

var CompensationLevel = exports.CompensationLevel = {
    NONE: 'OFF_ROUTE',
    LEVEL1: 'QUALIFIES_MONTHLY_CAP',
    LEVEL2: 'QUALIFIES_WEEKLY_CAP'
};

var DelayRepayTicketClass = exports.DelayRepayTicketClass = {
    STANDARD: 'standard-class',
    FIRST_CLASS: 'first-class'
};

var DelayRepayClaimReason = exports.DelayRepayClaimReason = {
    DELAYED_DEPARTURE: 'Delayed Departure',
    DELAYED_ON_ROUTE: 'Delayed on Route',
    TRAIN_CANCELLED: 'Train Cancelled',
    TRAIN_DIVERTED: 'Train Diverted',
    TRAIN_SHORT_FORMED: 'Train short formed',
    MISSED_CONNECTION: 'Missed Connection',
    RESUBMITTED_CLAIM: 'Resubmitted Claim',
    ABANDONED_JOURNEY: 'Abandoned Journey',
    STRIKE_ACTION: 'Strike Action',
    OTHER: 'Other'
};

var Widgets = exports.Widgets = {
    OPEN_GOLF_FIND_TICKETS: 'open-golf-find-tickets-widget',
    OPEN_GOLF_TIMETABLE: 'open-golf-timetable-widget',
    OPEN_GOLF_TICKET_SELECTION: 'open-golf-ticket-selection',
    REFUND_WIDGET: 'refund-widget'
};

var DelayRepayPaymentMethod = exports.DelayRepayPaymentMethod = {
    BACS: 'bacs',
    EVOUCHER: 'e-vouchers',
    PAYPAL: 'paypal',
    CARD: 'credit/debit card',
    AMAZON: 'amazon-incentives',
    VOUCHER: 'cashable voucher',
    CHEQUE: 'cheque',
    CHARITY: 'rail-charity'
};

var DelayRepayBankPeriod = exports.DelayRepayBankPeriod = {
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    ANNUALLY: 'annually',
    NONE: 'do not bank'
};

var ReservableStates = exports.ReservableStates = {
    COMPULSORY: 'Compulsory',
    BICYCLES: 'BicyclesEssential',
    RECOMMENDED: 'Recommended',
    POSSIBLE: 'Possible',
    NO: 'No'
};

var SeatingPrefs = exports.SeatingPrefs = {
    NONE: 'NONE',
    FORWARDS: 'FACE',
    BACKWARDS: 'BACK',
    AISLE: 'AISL',
    WINDOW: 'WIND',
    INDIVIDUAL: 'INDL',
    AIRLINE: 'AIRL',
    TABLE: 'TABL',
    QUIET_COACH: 'QUIE',
    NEAR_TOILET: 'NRWC',
    POWER_SOCKET: 'POWE',
    NEAR_LUGGAGE: 'LUGG'
};

var SeatingPrefNames = exports.SeatingPrefNames = (_SeatingPrefNames = {}, _SeatingPrefNames[SeatingPrefs.FORWARDS] = 'booking.seating.direction.forwards', _SeatingPrefNames[SeatingPrefs.BACKWARDS] = 'booking.seating.direction.backwards', _SeatingPrefNames[SeatingPrefs.AISLE] = 'booking.seating.position.aisle', _SeatingPrefNames[SeatingPrefs.WINDOW] = 'booking.seating.position.window', _SeatingPrefNames[SeatingPrefs.INDIVIDUAL] = 'booking.seating.position.individual', _SeatingPrefNames[SeatingPrefs.AIRLINE] = 'booking.seating.seatType.airline', _SeatingPrefNames[SeatingPrefs.TABLE] = 'booking.seating.seatType.table', _SeatingPrefNames[SeatingPrefs.QUIET_COACH] = 'booking.seating.features.quietCoach', _SeatingPrefNames[SeatingPrefs.NEAR_TOILET] = 'booking.seating.features.nearToilets', _SeatingPrefNames[SeatingPrefs.POWER_SOCKET] = 'booking.seating.features.powerSocket', _SeatingPrefNames[SeatingPrefs.NEAR_LUGGAGE] = 'booking.seating.features.nearLuggageRack', _SeatingPrefNames);

var OperatorColors = exports.OperatorColors = {
    DEFAULT: '#10069f',
    TL: '#461e78', // Thameslink
    GN: '#461e78', // Great Northern
    VT: '#1f4555', // Virgin Trains
    GR: '#cc0000', // Virgin Trains East Coast
    LM: '#25252D', // London Midland
    XC: '#443135', // CrossCountry
    SE: '#1D1951', // SouthEastern
    TP: '#ed037c', // First Transpennine Express
    GX: '#cc0000', // Gatwick Express
    SN: '#2f9771',
    GW: '#001e67',
    SW: '#f89520',
    NR: '#7d4199',
    GE: '#fe0000'
};

var StopPatterns = exports.StopPatterns = {
    PASSING: 'Passing',
    NORMAL: 'Normal',
    PICK_UP: 'PickUpOnly',
    SET_DOWN: 'SetDownOnly'
};

var FulfilmentType = exports.FulfilmentType = {
    E_TICKET: '00006',
    PRINT_AT_HOME: '00003',
    COLLECTION: '00005',
    POSTAL: '00009',
    SMARTCARD: '00001',
    S_TICKET: '00007'
};

var STicketStatus = exports.STicketStatus = {
    ACTIVE: 'active',
    INACTIVE: 'inactive'
};

// we need to declare different icons soon
var PostalDeliveryType = exports.PostalDeliveryType = {
    FIRST_CLASS: '1st-class-mail',
    ROYAL_SIGNED: '1st-class-mail',
    ROYAL_SPECIAL: '1st-class-mail'
};

var SmartcardErrorNonBlocking = exports.SmartcardErrorNonBlocking = {
    NOT_LOGGED: 'NotLoggedInError',
    NO_SMARTCARD: 'NoSmartcardError',
    APP_COLLECTION_ONLY: 'AppCollectionOnlyError'
};

var SmartCardErrorBlockingForLoggedIn = exports.SmartCardErrorBlockingForLoggedIn = {
    INVALID_KEYGO: 'InvalidKeygoError',
    TOO_MANY_ADULT_TICKETS_SMARTCARD: 'TooManyAdultTicketsInBasketError',
    TOO_MANY_CHILD_TICKETS_SMARTCARD: "TooManyChildTicketsInBasketError",
    NOT_ENOUGH_ACTIVE_SMARTCARDS_ERROR: "NotEnoughActiveSmartcardsError",
    TICKET_WITH_INVALID_AGE_FOR_CHILD_SMARTCARD_ERROR: 'TicketWithInvalidAgeForChildSmartcardError',
    TICKET_WITH_EXPIRED_SMARTCARD_ERROR: 'TicketWithExpiredSmartcardError'
};

var SmartcardErrorBlocking = exports.SmartcardErrorBlocking = {
    PENDING_SMARTCARD: 'PendingSmartcardError',
    PENDING_ACTIONLIST: 'PendingActionlistError',
    TOO_MANY_TICKETS_SMARTCARD: 'TooManyTicketsOnSmartcardError',
    CANT_DELIVER_IN_TIME: 'SmartcardCantBeDeliveredInTimeError',
    EXPIRED_SMARTCARD: 'ExpiredSmartcardError',
    INVALID_SMARTCARD: 'InvalidSmartcardStatusError',
    NOT_ENOUGH_TIME: 'NotEnoughTimeToActionlistTicketError',
    NOT_CORRECT_AGE: 'NotCorrectAgeForFareError',
    PRE_ENCODE_ERROR: 'DisabledPreEncodeError',
    SMART_CARNET_EXCEEDED_PASSES: 'SmartCarnetExceededNumberOfPassesError',
    INVALID_CARNET_TICKET_TYPE: 'InvalidCarnetTicketTypeError'
};

var SmartcardSelfRegistrationStatuses = exports.SmartcardSelfRegistrationStatuses = {
    LINK_SMARTCARD: 'Link',
    ONLY_REPLACEMENT: 'Replacement',
    NEW_SMARTCARD: 'New',
    NOT_POSSIBLE: 'Denied',
    COMPLETE: 'Complete'
};

var SmartcardServiceErrors = exports.SmartcardServiceErrors = {
    SERVICE_NOT_AVAILABLE: 'SmartcardServiceNotAvailableError',
    DECODING_ERROR: 'DecodingError'
};

var TransitModes = exports.TransitModes = {
    TRAIN: 'Train',
    METRO: 'Metro',
    BUS: 'Bus',
    REPLACEMENT_BUS: 'ReplacementBus',
    TRAM: 'Tram',
    FERRY: 'Ferry',
    TAXI: 'Taxi',
    WALK: 'Walk',
    OTHER: 'Other'
};

var DurationTypes = exports.DurationTypes = {
    WEEKLY: 'weekly',
    FOUR_WEEKLY: 'fourWeekly',
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    SIX_MONTHLY: 'sixMonthly',
    ANNUAL: 'annual',
    CUSTOM: 'custom'
};

var DurationPeriods = exports.DurationPeriods = (_DurationPeriods = {}, _DurationPeriods[DurationTypes.WEEKLY] = [0, 7], _DurationPeriods[DurationTypes.FOUR_WEEKLY] = [0, 28], _DurationPeriods[DurationTypes.MONTHLY] = [1, 0], _DurationPeriods[DurationTypes.QUARTERLY] = [3, 0], _DurationPeriods[DurationTypes.SIX_MONTHLY] = [6, 0], _DurationPeriods[DurationTypes.ANNUAL] = [12, 0], _DurationPeriods);

var SeasonCustomRange = exports.SeasonCustomRange = {
    MIN: 'P1M1D',
    MAX: 'P10M12D'
};

var Duration = exports.Duration = {
    P7D: 'Weekly',
    P1M: 'Monthly',
    P1Y: 'Annual',
    P1Y1D: 'Annual' // leap year??
};

var JourneyPlannerLayout = exports.JourneyPlannerLayout = (0, _keymirror2.default)({
    GRID: null,
    GRID_2: null,
    LIST: null
});

var ServicesPerLayout = exports.ServicesPerLayout = (_ServicesPerLayout = {}, _ServicesPerLayout[JourneyPlannerLayout.GRID] = 3, _ServicesPerLayout[JourneyPlannerLayout.GRID_2] = 3, _ServicesPerLayout[JourneyPlannerLayout.LIST] = 5, _ServicesPerLayout);

var ListSteps = exports.ListSteps = {
    OUTWARD_SERVICE: 'outward-service',
    OUTWARD_FARE: 'outward-fare',
    INWARD_SERVICE: 'inward-service',
    INWARD_FARE: 'inward-fare'
};

var BreakPoints = exports.BreakPoints = {
    DESKTOP_WIDTH_XL: 1701,
    DESKTOP_WIDTH_L: 1200,
    DESKTOP_WIDTH: 992,
    TABLET_PORTRAIT_WIDTH: 767,
    MOBILE_WIDTH: 508,
    DROPDOWN_MEDIUM_HEIGHT: 930,
    DROPDOWN_SMALL_HEIGHT: 750
};

var API_ISO_FORMAT = exports.API_ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
var API_FORMAT = exports.API_FORMAT = 'YYYY-MM-DD HH:mm:ss';
var API_KEYGO_FORMAT = exports.API_KEYGO_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";

var GlobalModals = exports.GlobalModals = (0, _keymirror2.default)({
    REGISTER: null,
    REGISTER_SMARTCARD: null,
    LOGIN: null,
    ERROR: null,
    CONFIRM: null,
    INFO: null,
    BASKET: null,
    BASKET_EXPIRED: null,
    FORGOT_PASSWORD: null,
    LOGGED_OUT: null,
    LOGOUT_WARNING: null,
    NRE: null,
    ORDER_STATE_ERROR: null,
    SYNC_EMAIL_AMAZON_LOGIN: null,
    PROMPT_PASSWORD_CHANGE: null,
    INTEROP_ERROR: null,
    BOOK_PASSENGER_ASSIST: null,
    CHILD_SMART_CARD_EXPIRATION: null,
    RESERVATIONS: null
});

var GenericModals = exports.GenericModals = (0, _keymirror2.default)({
    FARE_INFO: null,
    FARE_CATEGORY_INFO: null,
    SERVICE_INFO: null,
    JOURNEY_DETAILS_FORM: null,
    STATION_FINDER: null,
    TRAVELCARD_FARES: null,
    RAILCARD1617: null,
    TRAVEL_VIA_AVOID: null,
    PASSENGERS_RAILCARDS: null,
    OPEN_RETURN: null,
    SMARTCARD_TUTORIAL: null,
    PLUS_BUS: null,
    OYSTER: null,
    SEATING_PREFERENCES: null,
    DISRUPTION_ALERT: null,
    DELETE_ACCOUNT: null
});

var Validation = exports.Validation = {
    // validated against 2.5 million postcodes -  https://gist.github.com/simonflk/a5bf43bac48791db5563
    postcode: /^([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)\s*(\d[ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
    countryCode: /^[A-Z]{3}$/,
    telephone: /^\+?(\d+[-\s]*)+$/,
    cv2: /^\d{3,4}$/,
    sortCode: /^\s*\d\d(?:-|\s+)?\d\d(?:-|\s+)?\d\d\s*$/,
    accountNumber: /^\d{8}$/,
    cardHolderName: /\S+\s+\S+/,
    photocardHolder: /^(?=.{1,40}$)[A-Za-zÀ-ÿ]+(?:[-'` ][A-Za-zÀ-ÿ]+)*$/,
    delayRepayTicketNumber: /^\d{5}$/,
    issueNumber: /^[\dA-Za-z-]{1,35}$/,
    keySmartcardNumber: /^633\d{3}[ -]?\d{4}[ -]?\d{4}[ -]?\d{4}$/,
    oysterNumber: /^\d{10}\s?\d{2}$/,
    lettersAndSpaces: /^[a-zA-Z' -]+$/
};

var SmartcardStatus = exports.SmartcardStatus = (0, _keymirror2.default)({
    AWAITING_PRODUCT: null,
    AWAITING_FULFILMENT: null,
    AWAITING_COMPLETION: null,
    ACKNOWLEDGED: null,
    REQUESTED: null,
    ACCEPTED: null,
    UNKNOWN: null,
    ACTIVE: null,
    HOTLISTED: null,
    HOTLIST_REQUESTED: null,
    HOTLIST_ACCEPTED: null,
    HOTLIST_LIVE: null,
    HOTLIST_ERROR: null,
    SPOILED: null,
    PENDING: null,
    CANCELLED: null,
    EXPIRED: null
});

var SmartcardProgress = exports.SmartcardProgress = {
    IN_PROGRESS: 'inProgress',
    NOT_STARTED: 'notStarted',
    COMPLETED: 'completed'
};

var SmartcardProductStatus = exports.SmartcardProductStatus = (0, _keymirror2.default)({
    PENDING: null,
    AWAITING_DISTRIBUTION: null,
    UPDATE_AWAITING_DISTRIBUTION: null,
    AVAILABLE_FOR_COLLECTION: null,
    UPDATE_AVAILABLE_FOR_COLLECTION: null,
    ACTIVE: null,
    HOTLISTED: null,
    DELETED: null,
    BLOCKED: null,
    REJECTED: null,
    UPDATE_REJECTED: null,
    CANCELLED: null,
    FULFILLING: null,
    REQUESTED: null,
    INACTIVE: null,
    CANCELLING: null
});

var SmartcardProductStatusGroup = exports.SmartcardProductStatusGroup = {
    PENDING: [SmartcardProductStatus.PENDING, SmartcardProductStatus.AWAITING_DISTRIBUTION, SmartcardProductStatus.UPDATE_AWAITING_DISTRIBUTION, SmartcardProductStatus.AVAILABLE_FOR_COLLECTION, SmartcardProductStatus.UPDATE_AVAILABLE_FOR_COLLECTION, SmartcardProductStatus.REQUESTED, SmartcardProductStatus.FULFILLING],
    CURRENT: [SmartcardProductStatus.ACTIVE, SmartcardProductStatus.HOTLISTED],
    ACTIVE: [SmartcardProductStatus.ACTIVE]
};

var SmartcardProductStatusText = exports.SmartcardProductStatusText = (_SmartcardProductStat = {}, _SmartcardProductStat[SmartcardProductStatus.PENDING] = 'account.smartcard.product.status.pending', _SmartcardProductStat[SmartcardProductStatus.AWAITING_DISTRIBUTION] = 'account.smartcard.product.status.sendingToStation', _SmartcardProductStat[SmartcardProductStatus.UPDATE_AWAITING_DISTRIBUTION] = 'account.smartcard.product.status.sendingTopupToStation', _SmartcardProductStat[SmartcardProductStatus.AVAILABLE_FOR_COLLECTION] = 'account.smartcard.product.status.readyToCollect', _SmartcardProductStat[SmartcardProductStatus.UPDATE_AVAILABLE_FOR_COLLECTION] = 'account.smartcard.product.status.topupReadyToCollect', _SmartcardProductStat[SmartcardProductStatus.ACTIVE] = 'account.smartcard.product.status.loadedOnCard', _SmartcardProductStat[SmartcardProductStatus.HOTLISTED] = 'account.smartcard.product.status.productBlocked', _SmartcardProductStat[SmartcardProductStatus.DELETED] = 'account.smartcard.product.status.productRemovedFromCard', _SmartcardProductStat[SmartcardProductStatus.BLOCKED] = 'account.smartcard.product.status.productBlocked', _SmartcardProductStat[SmartcardProductStatus.REJECTED] = 'account.smartcard.product.status.errorPleaseContact', _SmartcardProductStat[SmartcardProductStatus.UPDATE_REJECTED] = 'account.smartcard.product.errorPleaseContact', _SmartcardProductStat[SmartcardProductStatus.CANCELLED] = 'account.smartcard.product.status.cancelled', _SmartcardProductStat[SmartcardProductStatus.FULFILLING] = 'account.smartcard.product.status.sendingToStation', _SmartcardProductStat[SmartcardProductStatus.REQUESTED] = 'account.smartcard.product.status.pending', _SmartcardProductStat[SmartcardProductStatus.CANCELLING] = 'account.smartcard.product.status.cancelled', _SmartcardProductStat[SmartcardProductStatus.INACTIVE] = 'account.smartcard.product.status.productBlocked', _SmartcardProductStat);

var KeyGoProductStatus = exports.KeyGoProductStatus = {
    LIVE: 'ACTIVE',
    PENDING_CLOSURE: 'PENDING_CLOSURE',
    PENDING: 'PENDING',
    CLOSED: 'CLOSED'
};

var KEYGO_TOPUP_AMOUNT = exports.KEYGO_TOPUP_AMOUNT = 25 * 100;

var KEYGO_NICKNAME = exports.KEYGO_NICKNAME = 'keyGo CA';

var SmartcardReplacementReason = exports.SmartcardReplacementReason = {
    LOST: 'lost',
    NOT_WORKING: 'not-working',
    NOT_RECEIVED: 'not-received',
    STOLEN: 'stolen',
    NAME_CHANGE: 'change-of-name'
};

var UploadSize2mb = exports.UploadSize2mb = 2 * Math.pow(1024, 2);
var UploadSize5mb = exports.UploadSize5mb = 5 * Math.pow(1024, 2);

var PaymentType = exports.PaymentType = {
    VOUCHER: 'cocs-voucher',
    STORED_CARD: 'paypoint-stored',
    CARD: 'paypoint-card',
    PAY360_HOSTED: 'pay360-hosted',
    PAYPAL: 'paypal-checkout',
    VISA_CHECKOUT: 'visa-checkout',
    AMAZON_PAY: 'amazon-pay',
    BRAINTREE_CARD_CHECKOUT: 'card-checkout'
};

var PaymentAuthCodes = exports.PaymentAuthCodes = {
    API_ERROR: 'E900',
    API_HTTP_ERROR: 'E901',
    BAD_PRICE: 'E003',
    BAD_TRANSACTION_REFERENCE: 'E008',
    BRAND_NOT_FOUND: 'A104',
    CANCELLED: 'C000',
    CARD_NOT_FOUND: 'E007',
    DECLINED_BY_UPSTREAM_PROCESSOR: 'D100',
    ENROLLED: 'S000',
    EXPIRED: 'E000',
    FRAUD: 'F001',
    MISSING_DELIVERY: 'E012',
    NO_RESULT: 'E006',
    OK: 'S001',
    ORDER_NOT_FOUND: 'E001',
    BAD_STATE: 'E002',
    PENDING: 'S002',
    PROCESSING: 'S003',
    REFUNDED: 'R000',
    REFUNDREJECTED: 'R001',
    REJECTED_BY_FRAUD: 'A136',
    REPLACED: 'R003',
    SWAPSMARTCARD: 'R004',
    UNDER_REVIEW: 'F000',
    UNSUPPORTED_TYPE: 'E004',
    USER_NOT_VOUCHER_OWNER: 'E009',
    VOIDED: 'V000',
    VOUCHER_INSUFFICIENT_AMOUNT: 'E011',
    VOUCHER_NOT_FOUND_OR_EXPIRED: 'E010',
    AMAZON_PAY_MFA_FAILURE: 'AMAZON_PAY_MFA_FAILURE',
    AMAZON_PAY_INVALID_PAYMENT_METHOD_ERROR: 'EAP1',
    AMAZON_PAY_PAYMENT_REJECTED_ERROR: 'EAP2',
    AMAZON_PAY_PROCESSING_FAILURE_ERROR: 'EAP3',
    AMAZON_PAY_TRANSACTION_TIMEOUT_ERROR: 'EAP4'
};

var PaymentAuthStatuses = exports.PaymentAuthStatuses = {
    SUCCESS: 'success',
    ENROLLED: 'enrolled',
    FAILED: 'failed',
    EXPIRED: 'expired',
    CANCELLED: 'cancelled',
    VOIDED: 'voided',
    FRAUD: 'fraud',
    PENDING: 'pending'
};

var PaymentTooltipIds = exports.PaymentTooltipIds = {
    PaymentMethods: 'PaymentMethods',
    OrderSummary: 'OrderSummary'
};

var CardTypes = exports.CardTypes = {
    AMEX: /^(3[47]|9905)/,
    VISA: /^(4|9903)/,
    VISA_ELECTRON: /^(4(026|17500|405|508|844|91[37])|9902)/,
    MAESTRO: /^(5018|5020|5038|6304|6759|676[1-3]|9900)/,
    MASTERCARD: /^(5[1-5]|9901)/
};

var VISA_CHECKOUT_BUTTON_ID = exports.VISA_CHECKOUT_BUTTON_ID = 'visa-checkout-button';

var TripTypes = exports.TripTypes = (0, _keymirror2.default)({
    SEASON: null,
    POINT: null,
    SMARTCARD_SEASON: null,
    SMARTCARD_POINT: null,
    DAYSAVE: null,
    ROVERSRANGERS: null
});

var OrderTripTypes = exports.OrderTripTypes = (0, _keymirror2.default)({
    RETURN: null,
    SEASON: null,
    SINGLE: null,
    RETURN_SINGLE: null,
    RETURN_SINGLES: null,
    DAYSAVE: null,
    FARE_ONLY: null,
    ROVERSRANGERS: null,
    SMART_CARNET: null
});

var OrderStates = exports.OrderStates = {
    INCOMPLETE: 'Incomplete',
    COMPLETE: 'Complete',
    EXPIRED: 'Expired',
    PENDING: 'Pending',
    REFUNDED: 'Refunded',
    UNDER_REVIEW: 'UnderReview',
    FULFILLED: 'Fulfilled',
    FRAUD: 'Fraud',
    AMENDING: 'Amending'
};

var TripBookingStatus = exports.TripBookingStatus = {
    OK: 'OK',
    FAILED_NOT_REQUIRED: 'FailedButNotRequired',
    FAILED: 'Failed',
    MAPPING_ERROR: 'MappingError',
    INTERNAL_ERROR: 'InternalError',
    UPSTREAM_ERROR: 'UpstreamError'
};

var TicketRefundStates = exports.TicketRefundStates = {
    REFUNDED: 'refunded',
    REFUNDABLE: 'refundable',
    ADVANCE_TICKET: 'not-online-advance-ticket',
    SEASON_TICKET: 'not-online-season-ticket',
    PRINTED: 'not-online-printed',
    EXCEEDED_VALIDITY: 'not-online-exceeded-refund-validity-days',
    UNKNOWN: 'unknown'
};

var ChangeoverActions = exports.ChangeoverActions = {
    REFUND: 'refund',
    PAYMENT: 'payment'
};

var GROUP_SAVE_CODE = exports.GROUP_SAVE_CODE = 'GS3';

var TPE_GROUP_SAVE_CODE = exports.TPE_GROUP_SAVE_CODE = 'SGB';

var RAILCARD_CODES_WITH_FARE_AND_TIME_RESTRICTIONS = exports.RAILCARD_CODES_WITH_FARE_AND_TIME_RESTRICTIONS = {
    HM_FORCES: 'HMF',
    NETWORK: 'NEW',
    ANNUAL_GOLD_CARD: 'NGC',
    SENIOR: 'SRN',
    RAILCARD_26_TO_30: 'TST',
    RAILCARD_16_TO_25: 'YNG',
    VETERANS: 'VET'
};

var CardLockStatus = exports.CardLockStatus = {
    SUCCESS: 'S00',
    BAD_REQUEST: 'V00',
    MISSING_PAN: 'V01',
    INVALID_PAN: 'V02',
    INVALID_CVV: 'V03',
    UNKNOWN_PUBLISHABLE_ID: 'A01',
    SERVICE_UNAVAILABLE: 'E00',
    INTERNAL_ERROR: 'E01'
};

var CustomerTitles = exports.CustomerTitles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Mx'];

var TPECustomerTitles = exports.TPECustomerTitles = ['Mr', 'Mrs', 'Ms', 'Miss', 'Mx', 'Dr', 'Rev', 'Lady', 'Lord', 'Sir', 'Dame'];

var COUNTED_PLACE = exports.COUNTED_PLACE = '***';

var JourneySelectorTypes = exports.JourneySelectorTypes = {
    OPEN: 'open',
    CLOSED: 'closed'
};

var RailDayStart = exports.RailDayStart = {
    hours: 4,
    minutes: 30
};

var MAX_NOTIFICATION_TIME = exports.MAX_NOTIFICATION_TIME = 30 * 1000;

var LoadingTypes = exports.LoadingTypes = (0, _keymirror2.default)({
    SMARTCARD: null,
    API: null,
    ORDER: null,
    TRIP: null
});

var CookieKeys = exports.CookieKeys = (0, _keymirror2.default)({
    CONFIRMED_SMARTCARDS: null,
    SMARTCARD_CTA_DISMISSED: null,
    DO_NOT_TRACK: null,
    ORDER: null
});

var BAlertTypes = exports.BAlertTypes = {
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger',
    SUCCESS: 'success'
};

var DRCStates = exports.DRCStates = {
    PENDING: 'Pending',
    BLOCKED: 'Blocked',
    ACTIVE: 'Active',
    EXPIRED: 'Expired'
};

var BulletinSeverity = exports.BulletinSeverity = (0, _keymirror2.default)({
    P1: null
});

var IgnoredErrors = exports.IgnoredErrors = [/Blocked a frame with origin/g, //CORS errors usual culprit is GTM
/Script error/g, //3rd party External Script error
/multiple calls to tags.js/g, //Visa checkout sdk error with Firefox
/TypeError: _jp\.\w+ is not a function/, // local webpack websocket errors
/ResizeObserver loop limit exceeded/g, // harmless resize observer threshold error
/TypeError.*null.*appendChild/g];

var StationFinderSearchInteractions = exports.StationFinderSearchInteractions = {
    CURRENT_LOCATION: 'current-location',
    ENTERED_LOCATION: 'entered-location'
};

var NREIncompatibleRailcards = exports.NREIncompatibleRailcards = ['GS3'];

var SubscriptionActions = exports.SubscriptionActions = {
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe'
};

var SkipAutoLogoutRedirectRoutes = exports.SkipAutoLogoutRedirectRoutes = [AccountPages.AUTO_DELAY_REPAY, CompensationPages.SEASON, CompensationPages.NON_SEASON, Widgets.REFUND_WIDGET];

var TicketOfficeHours = exports.TicketOfficeHours = {
    CLOSING_CUT_OFF: '6:00',
    OPEN: 'open',
    CLOSED: 'closed',
    NO_OFFICE: 'no-office',
    NOT_AVAILABLE: 'not-available'
};

var PlusBusOptions = exports.PlusBusOptions = [{
    direction: 'outward',
    terminal: 'origin'
}, {
    direction: 'outward',
    terminal: 'destination'
}, {
    direction: 'return',
    terminal: 'origin'
}, {
    direction: 'return',
    terminal: 'destination'
}];

var SignupTypes = exports.SignupTypes = (0, _keymirror2.default)({
    WITH_SMARTCARD: null,
    WITH_TRANSFER: null,
    WITHOUT_SMARTCARD: null
});

var WeekdayNames = exports.WeekdayNames = {
    MONDAY: 'monday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday',
    THURSDAY: 'thursday',
    FRIDAY: 'friday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday'
};

var BusinessDays = exports.BusinessDays = [WeekdayNames.MONDAY, WeekdayNames.TUESDAY, WeekdayNames.WEDNESDAY, WeekdayNames.THURSDAY, WeekdayNames.FRIDAY];
var WeekDays = exports.WeekDays = BusinessDays.concat([WeekdayNames.SATURDAY, WeekdayNames.SUNDAY]);

var InitialWeekDayJourney = exports.InitialWeekDayJourney = 'weekday';
var WeekDaysJourney = exports.WeekDaysJourney = [InitialWeekDayJourney, WeekdayNames.SATURDAY, WeekdayNames.SUNDAY];

var Railcard1617States = exports.Railcard1617States = (0, _keymirror2.default)({
    ACCEPTED: null
});

var RAILCARD1617_CODE = exports.RAILCARD1617_CODE = 'TSU';
var JOB_CENTRE_PLUS_RAILCARD_CODE = exports.JOB_CENTRE_PLUS_RAILCARD_CODE = 'JCP';

var KeyGoJourneyStates = exports.KeyGoJourneyStates = (0, _keymirror2.default)({
    INCOMPLETE_PROVISIONAL: null,
    COMPLETE_PROVISIONAL: null,
    INCOMPLETE_FINAL: null,
    COMPLETE_FINAL: null
});

var KeyGoTapStatus = exports.KeyGoTapStatus = (0, _keymirror2.default)({
    GENERATED: null,
    VALID: null
});

var KeyGoTapTypes = exports.KeyGoTapTypes = (0, _keymirror2.default)({
    INSPECTION: null,
    ENTRY: null,
    EXIT: null
});

var KeyGoTapGenerationCause = exports.KeyGoTapGenerationCause = (0, _keymirror2.default)({
    TOUCH: null,
    MULTI_USE_BOUNDARY: null,
    GATELINE_AUTOCOMPLETE: null,
    SINGLE_USE_BOUNDARY: null,
    AUTO_SAME_STATION_EXIT: null,
    AUTOFILL: null,
    CORRECTION: null,
    MANUALFILL: null,
    UNKNOWN: null
});

var KeyGoTapGenerationCauseText = exports.KeyGoTapGenerationCauseText = (_KeyGoTapGenerationCa = {}, _KeyGoTapGenerationCa[KeyGoTapGenerationCause.TOUCH] = 'account.smartcard.keygo.journeyhistory.touch', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.MULTI_USE_BOUNDARY] = 'account.smartcard.keygo.journeyhistory.multiUseBoundary', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.GATELINE_AUTOCOMPLETE] = 'account.smartcard.keygo.journeyhistory.gatelineAutocomplete', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.SINGLE_USE_BOUNDARY] = 'account.smartcard.keygo.journeyhistory.singleUseBoundary', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.AUTO_SAME_STATION_EXIT] = 'account.smartcard.keygo.journeyhistory.autoSameStationExit', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.AUTOFILL] = 'account.smartcard.keygo.journeyhistory.autofill', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.CORRECTION] = 'account.smartcard.keygo.journeyhistory.correction', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.MANUALFILL] = 'account.smartcard.keygo.journeyhistory.manualfill', _KeyGoTapGenerationCa[KeyGoTapGenerationCause.UNKNOWN] = 'account.smartcard.keygo.journeyhistory.unknown', _KeyGoTapGenerationCa);

var IBlocksErrorCodes = exports.IBlocksErrorCodes = {
    CONFLICT: 'ECF0003',
    ACCOUNT_CLOSED: 'EBR0006',
    REACHED_TAP_LIMIT: 'EBR0008',
    INVALID_TAP_TIME: 'EBR0009'
};

var IBlocksTransitModes = exports.IBlocksTransitModes = (0, _keymirror2.default)({
    RAIL: null,
    BUS: null
});

var WidgetLayout = exports.WidgetLayout = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal'
};

var WidgetTab = exports.WidgetTab = {
    SEARCH: 'search',
    SEASON: 'season'
};

var KeyGoReimbursementStatus = exports.KeyGoReimbursementStatus = (0, _keymirror2.default)({
    SUCCESS: null
});

var keyGoPaymentCardStatus = exports.keyGoPaymentCardStatus = (0, _keymirror2.default)({
    ACTIVE: null,
    NO_CARD: null,
    EXPIRED: null,
    EXPIRES_THIS_MONTH: null
});

var KeyGoHostedFollowOnActions = exports.KeyGoHostedFollowOnActions = (0, _keymirror2.default)({
    RegisterOnActiveCard: null,
    RegisterOnNewCard: null,
    UpdateCard: null,
    testing: null // used for testing only, it will not register a keyGo
});

var filteredOutRailcards = exports.filteredOutRailcards = {
    keyGo: ['2TR', 'DIC', 'FAM'],
    season: ['2TR', 'DIC', 'DIS', 'FAM', 'HMF', 'JCP', 'NEW', 'NGC', 'SRN', 'TST', 'VET', 'YNG']
};

var filteredRailcards = exports.filteredRailcards = {
    keyGo: ['DIS', 'HMF', 'JCP', 'NEW', 'NGC', 'SRN', 'TST', 'TSU', 'VET', 'YNG'],
    season: ['TSU']
};

// For tests that use _.defer, let's not wait until jasmine.DEFAULT_TIMEOUT_INTERVAL
// but quit much quicker. The actual timeout value depends on host machine's CPU
// (which tend to be slow for CI/CD) so upped the value from 1 ms to 100 ms.
var TEST_REDUCED_TIMEOUT_INTERVAL = exports.TEST_REDUCED_TIMEOUT_INTERVAL = 100;

var AmazonPayErrors = exports.AmazonPayErrors = {
    GeneralError: 'OtrlGeneralError',
    BuyerSessionExpired: 'BuyerSessionExpired'
};

var AmazonIds = exports.AmazonIds = {
    ADDRESS_BOOK: 'addressBookWidgetDiv',
    BUTTON: 'AmazonPayButton',
    LOGIN_BUTTON: 'AmazonLoginButton',
    WALLET: 'walletWidgetDiv'
};

var AmazonLoginStatus = exports.AmazonLoginStatus = (0, _keymirror2.default)({
    IDLE: null,
    LINK_START: null,
    LINK_ERROR: null,
    LINK_SUCCESS: null,
    LOGIN_ERROR: null,
    LOGIN_READY_TO_AUTH: null,
    LOGIN_SUCCESS: null,
    REGISTER_START: null,
    SYNC_EMAIL_START: null,
    UNLINK_SUCCESS: null
});

var AmazonLoginAuthStatus = exports.AmazonLoginAuthStatus = {
    LINKING_NOT_AVAILABLE: 'linking_not_available',
    LINKING_REQUIRED: 'linking_required',
    MISMATCHED_EMAILS: 'mismatched_emails'
};

var AmazonLoginResponseType = exports.AmazonLoginResponseType = {
    CODE: 'code',
    TOKEN: 'token'
};

var Railcard1617Errors = exports.Railcard1617Errors = {
    ALREADY_EXISTS: 'card already exists'
};

var AllowedDeliveryCountryCodes = exports.AllowedDeliveryCountryCodes = ['GB'];
var AllowedSameDeliveryAddressCountries = exports.AllowedSameDeliveryAddressCountries = ['United Kingdom'];

var RefundCalculation = exports.RefundCalculation = {
    initiatedByCustomer: 'Customer',
    initiatedByAgent: 'Customer Service'
};

var widgetSearchElements = exports.widgetSearchElements = {
    dateSelector: 'DateSelector',
    arriveDepart: 'ArriveDepart',
    timeSelector: 'TimeSelector'
};

var AmazonLoginCTATypes = exports.AmazonLoginCTATypes = (0, _keymirror2.default)({
    LOGIN: null,
    REGISTER: null
});

var OPEN_GOLF_TICKET_CODE_REGEX = exports.OPEN_GOLF_TICKET_CODE_REGEX = /^OG[1-48]$/;

var OpenGolfTickets = exports.OpenGolfTickets = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    EIGHT: 8
};

var Browsers = exports.Browsers = {
    IE9_10: 'Internet Explorer 9-10',
    IE11: 'Internet Explorer 11',
    MOZ: 'Mozilla Firefox',
    O: 'Opera',
    SAFARI: 'Safari',
    CHROME: 'Google Chrome',
    IOS_CHROME: "iOS Chrome"
};

var FavouriteExcludedTicketTypes = exports.FavouriteExcludedTicketTypes = [OPEN_GOLF_TICKET_CODE_REGEX];
var FavouriteSeasonExpiringSoonThresholdDays = exports.FavouriteSeasonExpiringSoonThresholdDays = 7;

var DisruptionAlertMaximumAlerts = exports.DisruptionAlertMaximumAlerts = 10;
var DisruptionAlertMaximumServices = exports.DisruptionAlertMaximumServices = 5;
var DisruptionAlertPrimaryDateFormat = exports.DisruptionAlertPrimaryDateFormat = 'ddd DD MMM YYYY';
var DisruptionAlertDurationOptions = exports.DisruptionAlertDurationOptions = (0, _keymirror2.default)({
    INFINITE: null,
    SIXMONTHS: null,
    ONEOFF: null,
    CUSTOM: null
});
var DisruptionAlertDaysOptions = exports.DisruptionAlertDaysOptions = (0, _keymirror2.default)({
    WEEKDAYS: null,
    SATURDAYS: null,
    SUNDAYS: null
});
var DisruptionAlertWeekdays = exports.DisruptionAlertWeekdays = (0, _keymirror2.default)({
    MONDAY: null,
    TUESDAY: null,
    WEDNESDAY: null,
    THURSDAY: null,
    FRIDAY: null
});
var DisruptionAlertReactivationOptions = exports.DisruptionAlertReactivationOptions = (0, _keymirror2.default)({
    NEVER: null,
    DAY: null,
    WEEK: null,
    MONTH: null,
    CUSTOM: null
});

var DisabledPeopleRailcards = exports.DisabledPeopleRailcards = ['DIS', 'DIC'];

var GOTriggers = exports.GOTriggers = {
    SERVICES_GRID: 'OTRL:page:services-grid'
};

var SundryCodes = exports.SundryCodes = {
    BOOKING_FEE: 91354,
    TRAINHUGGER_DISCOUNT: 55555 //TEMP VALUE
};

var Pay360SessionState = exports.Pay360SessionState = (0, _keymirror2.default)({
    CREATING: null,
    READY: null,
    INVALID: null,
    SUCCESS: null,
    FAILED: null,
    CANCELLED: null
});

var AssociationStatuses = exports.AssociationStatuses = (0, _keymirror2.default)({
    pending: null,
    approved: null
});

var AssociationDetailsType = exports.AssociationDetailsType = (0, _keymirror2.default)({
    client: null,
    smartcard: null
});

var FlexiSeasonValidation = exports.FlexiSeasonValidation = {
    PASSES_PER_FLEXI: 8
};

var SmartCarnetTicketCodes = exports.SmartCarnetTicketCodes = {
    PEAK: '0BI',
    OFF_PEAK: '0BK'
};

var SmartCarnetValidation = exports.SmartCarnetValidation = {
    PASSES_PER_BOOK: 5
};

var SmartCarnetTicketStatus = exports.SmartCarnetTicketStatus = {
    ACTIVE: '1',
    EXPIRED: '2',
    ALL: '3'
};

var JPWidgetConf = exports.JPWidgetConf = {
    ID: 'JP_WIDGET'
};

var STICKET_PHOTOCARD = exports.STICKET_PHOTOCARD = 'sTicket';

var RegistrationReferrers = exports.RegistrationReferrers = (0, _keymirror2.default)({
    REGISTER_MODAL: null,
    PAYMENT_FORM: null,
    DELAY_REPAY: null
});

var RefundReasons = exports.RefundReasons = {
    UNUSED_TICKETS: 6,
    ETICKET_UNUSED_TICKETS: 12
};

var ValidityPeriods = exports.ValidityPeriods = {
    DAY: "0001",
    ETICKET_DAY: "0002"
};

var DEFAULT_APP_CHANNEL = exports.DEFAULT_APP_CHANNEL = 'app';
var WEBVIEW_BOOKING_FLOW_APP_CHANNEL = exports.WEBVIEW_BOOKING_FLOW_APP_CHANNEL = 'app-2021'; // 1.x.x and by mistake 2.0.0
var NATIVE_BOOKING_FLOW_APP_CHANNEL = exports.NATIVE_BOOKING_FLOW_APP_CHANNEL = 'app-2022'; // 2.x.x
var GATWICK_APP_CHANNEL = exports.GATWICK_APP_CHANNEL = 'app-gx'; // 3.x.x
var GREATNORTHERN_APP_CHANNEL = exports.GREATNORTHERN_APP_CHANNEL = 'app-gn'; // 3.x.x
var SOUTHERN_APP_CHANNEL = exports.SOUTHERN_APP_CHANNEL = 'app-sn'; // 3.x.x
var THAMESLINK_APP_CHANNEL = exports.THAMESLINK_APP_CHANNEL = 'app-tl'; // 3.x.x

var OrderSummaryContexts = exports.OrderSummaryContexts = (0, _keymirror2.default)({
    'BASKET_MODAL': null,
    'PAYMENT_CONFIRMATION': null
});

var PlusBusSectionsContext = exports.PlusBusSectionsContext = (0, _keymirror2.default)({
    'REORDER_MODAL': null
});

var notificationPreferences = exports.notificationPreferences = {
    APP_AND_EMAIL: 'appAndEmail',
    APP: 'app',
    EMAIL: 'email'
};

var oneClickDelayRepayReimbursementMethods = exports.oneClickDelayRepayReimbursementMethods = {
    BACS: 'bacs',
    PAYPAL: 'paypal',
    EVOUCHERS: 'e-vouchers',
    CHARITY: 'rail-charity'
};

var OYSTER_BUTTON_TYPE = exports.OYSTER_BUTTON_TYPE = {
    BASKET: 'BASKET',
    CTA: 'CTA',
    WEEKLY_CAP_ICON: 'WEEKLY_CAP_ICON'
};

var STicketErrors = exports.STicketErrors = {
    NOT_AVAILABLE_ON_ROUTE: "SticketDeliveryOptionIsNotAvailableOnRoute",
    TOO_MANY_TICKETS_IN_BASKET: "TooManyTicketsInBasketError"
};

var JourneySupportPaths = exports.JourneySupportPaths = {
    STEP_FREE_GREEN: '/images/step-free-green.svg',
    STEP_FREE_ORANGE: '/images/step-free-orange.svg',
    STEP_FREE_RED: '/images/step-free-red.svg',

    SEATING_GREEN: '/images/seating-green.svg',
    SEATING_LIGHT_GREEN: '/images/seating-light-green.svg',
    SEATING_YELLOW: '/images/seating-yellow.svg',
    SEATING_ORANGE: '/images/seating-orange.svg',
    SEATING_RED: '/images/seating-red.svg',
    SEATING_NO_DATA: '/images/seating-no-data.svg'
};

var StationStepFreeAccessLevels = exports.StationStepFreeAccessLevels = {
    WHOLE_STATION: 'wholeStation',
    PARTIAL_STATION: 'partialStation',
    NO_PART_OF_STATION: 'noPartOfStation'
};

var CARBON_FOOTPRINT_DATA = exports.CARBON_FOOTPRINT_DATA = {
    CAR_EMISSIONS_PER_MILE: 0.22469,
    TRAIN_EMISSIONS_PER_MILE: 0.07150,
    BULB_PER_KG: 0.0075,
    KETTLE_PER_KG: 0.047,
    MICROWAVE_PER_KG: 0.406,
    PHONE_PER_KG: 0.008197,
    TV_PER_KG: 0.086,
    WASHING_MACHINE_PER_KG: 0.273
};

var TicketBenefitsPaths = exports.TicketBenefitsPaths = {
    FIRST: '/images/logos/southeastern-logo-app.png',
    SECOND: '/images/paperless.png',
    THIRD: '/images/contactless.png'
};

var SmartcardBenefitsPaths = exports.SmartcardBenefitsPaths = {
    FIRST: '/images/logos/southeastern-logo-app.png',
    SECOND: '/images/tap-through.png',
    THIRD: '/images/travelcard-ready.png'
};

var IconFillColours = exports.IconFillColours = {
    southeastern: '#009ADB',
    gatwick: '#DC0A1E',
    greatnorthern: '#43165C',
    southern: '#003f2E',
    ticketyboo: '#E95A0C',
    thameslink: '#E9418B'
};

var TrainTypes = exports.TrainTypes = {
    DIRECT: 'direct',
    MULTILEG: 'multi,'
};

var Directions = exports.Directions = {
    RETURN: 'Return',
    OUTBOUND: 'Outbound'
};

var RESERVATION_NOT_POSSIBLE = exports.RESERVATION_NOT_POSSIBLE = 'NotPossible';

var RESERVATION_CANCELLATION_STATUS = exports.RESERVATION_CANCELLATION_STATUS = {
    SUCCESS: 'Success',
    FAILURE: 'Failure'
};

var ReservationStepIndex = exports.ReservationStepIndex = {
    INIT: 0,
    SEARCH: 1,
    OUTWARD: 2,
    INWARD: 3,
    PREFERENCES: 4,
    SUMMARY: 5
};

var ReservationTabs = exports.ReservationTabs = {
    UPCOMING_RESERVATIONS: 'upcoming-reservations',
    PREVIOUS_RESERVATIONS: 'previous-reservations'
};

var ReservationSalesFlowType = exports.ReservationSalesFlowType = (0, _keymirror2.default)({
    SALES: null,
    AFTER_SALES: null
});

var ReservationBundleOutcome = exports.ReservationBundleOutcome = (0, _keymirror2.default)({
    FULL_AVAILABILITY: null,
    PARTIAL_AVAILABILITY: null,
    NO_AVAILABILITY: null,
    NO_TARIFF: null,
    SERVICE_FULL: null
});

var ReservationContexts = exports.ReservationContexts = (0, _keymirror2.default)({
    TICKET_BOOKING: null,
    STANDALONE_BOOKING: null
});

var ReservationErrorCodes = exports.ReservationErrorCodes = {
    RESERVATION_LIMIT_REACHED: "ReservationRateLimitError"
};

var TransPennineStaffRoverNlcCodes = exports.TransPennineStaffRoverNlcCodes = {
    ORIGIN: 'Z031',
    DESTINATION: 'Z032'
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.fields = undefined;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _reduce2 = __webpack_require__(219);

var _reduce3 = _interopRequireDefault(_reduce2);

var _identity2 = __webpack_require__(116);

var _identity3 = _interopRequireDefault(_identity2);

var _partial2 = __webpack_require__(615);

var _partial3 = _interopRequireDefault(_partial2);

var _isNull2 = __webpack_require__(451);

var _isNull3 = _interopRequireDefault(_isNull2);

var _isUndefined2 = __webpack_require__(278);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

exports.construct = construct;
exports.resolve = resolve;
exports.resolveAll = resolveAll;
exports.resolveMap = resolveMap;
exports.addLinks = addLinks;
exports.getLinks = getLinks;
exports.clearLinks = clearLinks;

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _linkMap = new _immutable.Map();

var _isLink = function _isLink(value) {
    return (0, _isString3.default)(value) && value.charAt(0) === '/';
};

var _applier = function _applier(oldValue, newValue, func) {
    return oldValue ? func(newValue) : oldValue;
};

var _deserializer = function _deserializer(oldValue, newValue, Type) {
    if ((0, _isUndefined3.default)(oldValue) || (0, _isNull3.default)(oldValue)) {
        return oldValue;
    }
    var result = Type.fromJSON(newValue);
    if (_isLink(oldValue) && !result.get('id') && result.has('id')) {
        result = result.set('id', oldValue);
    }
    return result;
};

function construct(Type) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var schema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var resolved = (0, _keys2.default)(schema).reduce(function (reduction, key) {
        var factory = schema[key];
        if (typeof factory === 'function') {
            reduction[key] = factory(values[key]);
        } else {
            reduction[key] = factory;
        }
        return reduction;
    }, {});
    return new Type(resolved);
}

function resolve(key) {
    var resolved = void 0;

    if (_isLink(key)) {
        resolved = _linkMap.get(key, null);
        if (!resolved) {
            console.warn('No link found for "' + key + '"');
        }
    }

    // In anycase return what was given
    if (!resolved) {
        resolved = key;
    }

    return {
        as: (0, _partial3.default)(_deserializer, key, resolved),
        with: (0, _partial3.default)(_applier, key, resolved)
    };
}

resolve.as = function (Type) {
    return function (value) {
        return resolve(value).as(Type);
    };
};

resolve.with = function (func) {
    return function (value) {
        return resolve(value).with(func);
    };
};

var fields = exports.fields = {
    string: resolve.with(String),
    bool: resolve.with(Boolean),
    boolean: resolve.with(Boolean),
    number: resolve.with(Number),
    datetime: resolve.with(_TrainTime2.default),
    duration: resolve.with(_TrainTime2.default.duration),
    identity: resolve.with(_identity3.default)
};

function resolveAll(keys) {
    var Collection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _immutable.List;

    var list = new Collection(keys);
    var resolved = list.map(function (key) {
        return resolve(key);
    });

    return {
        as: function as(Type) {
            return resolved.map(function (item) {
                return item.as(Type);
            });
        },
        with: function _with(func) {
            return resolved.map(function (item) {
                return item.with(func);
            });
        }
    };
}

resolveAll.as = function (Type, Collection) {
    return function (value) {
        return resolveAll(value, Collection).as(Type);
    };
};

resolveAll.with = function (func, Collection) {
    return function (value) {
        return resolveAll(value, Collection).with(func);
    };
};

function resolveMap(values) {
    return resolveAll(values, _immutable.Map);
}

resolveMap.as = function (Type) {
    return resolveAll.as(Type, _immutable.Map);
};

resolveMap.with = function (Type) {
    return resolveAll.with(Type, _immutable.Map);
};

function addLinks(links) {
    _linkMap = (0, _reduce3.default)(links, function (acc, linkValue, linkKey) {
        return acc.set(linkKey, linkValue);
    }, _linkMap);

    return _linkMap;
}

function getLinks() {
    return _linkMap;
}

function clearLinks() {
    _linkMap = _linkMap.clear();
    return _linkMap;
}

exports.default = {
    clearLinks: clearLinks,
    getLinks: getLinks,
    addLinks: addLinks,
    resolve: resolve,
    resolveAll: resolveAll
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getFinalMessage = getFinalMessage;
exports.hasMessage = hasMessage;
exports.replaceGlobals = replaceGlobals;
exports.translate = translate;

var _intlMessageformat = __webpack_require__(1581);

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

var _intlFormatCache = __webpack_require__(1590);

var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dictionary = __webpack_require__(1593).default; /**
                                                            * Very simple i18n wrapper for now
                                                            */

if (false) {
    module.hot.accept('../messages/dictionary', function () {
        dictionary = require('../messages/dictionary').default;
    });
}

var getMessageFormat = (0, _intlFormatCache2.default)(_intlMessageformat2.default);

/**
 * Recursively resolve a key in the dictionary
 */
function getFinalMessage(dict, key) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (count > 5) {
        throw new Error('Mutually referencing dictionary key: ' + key);
    }
    var message = dict.get(key);
    return !message ? key : getFinalMessage(dict, message, ++count);
}

/**
 * Returns {true} if dictionary contains message for `key`
 */
function hasMessage(key) {
    return dictionary[_config2.default.get('brand')].has(key);
}

/**
 * Replace <{variable}> with a value from the dictionary
 */
function replaceGlobals(dict, input) {
    var regExp = /<\{(.*?)\}>/g;
    var output = input;
    var match = void 0;

    while ((match = regExp.exec(input)) !== null) {
        var key = match[1];
        var value = dict.get(key);

        if (!value) {
            console.warn('Couldn\'t find global value: ' + key);
        }

        output = output.replace(match[0], value);
    }

    return output;
}

/**
 * Translate a key to a message
 */
function translate(key, values) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!key) {
        console.warn('Translate called with no key');
    }
    var dict = dictionary[_config2.default.get('brand')];

    var message = getFinalMessage(dict, key);

    if (message === key) {
        message = fallback || key;
    }

    return message ? getMessageFormat(replaceGlobals(dict, message)).format(values) : null;
}

exports.default = translate;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(130);
var hide = __webpack_require__(111);
var redefine = __webpack_require__(112);
var ctx = __webpack_require__(131);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _DisabledService = __webpack_require__(1424);

var _DisabledService2 = _interopRequireDefault(_DisabledService);

var _Tutorial = __webpack_require__(964);

var _Tutorial2 = _interopRequireDefault(_Tutorial);

var _TicketType = __webpack_require__(967);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _NonSeasonTicketType = __webpack_require__(779);

var _NonSeasonTicketType2 = _interopRequireDefault(_NonSeasonTicketType);

var _PurchaseLocation = __webpack_require__(780);

var _PurchaseLocation2 = _interopRequireDefault(_PurchaseLocation);

var _EvidenceType = __webpack_require__(968);

var _EvidenceType2 = _interopRequireDefault(_EvidenceType);

var _TicketType3 = __webpack_require__(1499);

var _TicketType4 = _interopRequireDefault(_TicketType3);

var _Reason = __webpack_require__(1500);

var _Reason2 = _interopRequireDefault(_Reason);

var _Time = __webpack_require__(1501);

var _Time2 = _interopRequireDefault(_Time);

var _PaymentMethod = __webpack_require__(961);

var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentHost = window && window.location && window.location.host;

var defaults = {
    name: _AppConstants.AppName.BOOKING_ENGINE,
    version: '',
    title: 'Booking Engine',
    environment: 'development',
    bookingEngineHost: currentHost,
    delayRepayHost: currentHost,
    autoDelayRepayHost: currentHost,
    baseHref: '',
    namespace: '',
    brandUrls: {},
    extraInfoSecretVersion: 'Shown in the <SecretVersion> component.',

    debug: false,
    a11y: false, //Enable or disable React-a11y

    //Api settings
    apiHost: 'localhost',
    apiPort: '443',
    apiProtocol: 'https',
    apiPath: '',
    apiAccessToken: '8gh2w38ho43o83hw48o4hg8h4g8',
    configApiHost: null, // overrides default apiHost
    configApiAccessToken: null, // overrides default access token
    forceCORSProxy: false, //If true force the app to use the cors proxy
    cookieDomain: [],

    //Widgets
    openGolfPathname: 'open-golf',
    openGolfTimetablePathname: 'open-golf-timetable',
    jpWidgetBundleUrl: null,

    //Brand config
    brand: 'thameslink',
    configServiceBrand: null, // Override to set different brand for confsvc
    tocCode: null, //The TOC code for this brand
    tocGroup: [],
    mainSiteUrl: 'http://www.thameslinkrailway.com',
    plusBusUrl: 'http://plusbus.info/',
    groupSaveDetailsUrl: 'http://www.nationalrail.co.uk/times_fares/groupsave_calendar.html',
    ticketTermsAndConditions: 'http://ojp.nationalrail.co.uk/service/ticketterms/show?&ticketTypeCode={ticketTypeCode}',
    threeDSecureCallbackUrl: '/3d-secure.html',
    threeDSecureTermUrlV1Payment: '/orders/{orderId}/payment/{paymentId}/3d-secure?x-customer-device={deviceToken}&callbackUrl={callbackUrl}',
    threeDSecureTermUrlV2Payment: '/orders/{orderId}/payment/{paymentId}/3d-secure/v2?x-customer-device={deviceToken}&callbackUrl={callbackUrl}',
    threeDSecureTermUrlV1Authorization: '/customers/keygo/resume/{paymentId}?callbackUrl={callbackUrl}',
    threeDSecureTermUrlV2Authorization: '/customers/keygo/resume/{paymentId}/v2?callbackUrl={callbackUrl}',
    cardLockId: undefined,
    cardLockUrl: 'https://api.mite.pay360.com/cardlock/createToken?pan={cardNumber}&cvv={securityCode}&publishableId={publishableId}',
    paypalEnvironment: 'sandbox',
    pay360SessionReturnUrl: '/pay360-session.html',
    pay360SkinId: 1, // override this for each brand on test/prod
    pay360SkinKeyGoId: 1,
    legalUrl: 'https://www.thameslinkrailway.com/contact-us/terms',
    accessibilityStatementUrl: 'https://www.thameslinkrailway.com/terms-of-use/site-accessibility',
    ownerUrl: 'http://www.govia.info',
    faqUrl: 'https://www.thameslinkrailway.com/contact-us/frequently-asked-questions',
    eTicketsUrl: null,
    eTicketsFaqUrl: 'https://www.thameslinkrailway.com/help-and-support/contact-us/faqs/etickets',
    contactUrl: 'https://www.thameslinkrailway.com/help-and-support/contact-us',
    smartcardLogo: '/images/smartcard-logo.png',
    loadSmartcardIllustration: '/images/smartcard/load-smartcard-gtr.png',
    loadSTicketIllustration: '/images/load-sticket.svg',
    smartcardReadMoreUrl: 'https://www.thameslinkrailway.com/tickets-and-fares/the-key-smartcard',
    delayRepayCompensationUrl: null,
    autoDelayRepayInformationUrl: 'https://www.thameslinkrailway.com/help-and-support/journey-problems/delay-repay/auto-delay-repay',
    smartcardPhoneNumber: '03450 26 47 00',
    customerServicesPhoneNumber: '03450 26 47 00',
    nationalRailConditionsUrl: 'https://www.nationalrail.co.uk/travel-information/your-rights-and-obligations-as-a-passenger',
    privacyPolicyUrl: 'https://www.thameslinkrailway.com/contact-us/terms/privacy-policy',
    googleMapPrimaryColour: '#00a5e2',
    keyGoInformationUrl: 'https://www.thameslinkrailway.com/keyGo',
    keyGoTermsAndConditionsUrl: '/files/keygo-conditions-of-use.pdf',
    keyGoCollectionMapUrl: 'http://southernrailway.com/keygo',
    helpUrl: 'https://www.thameslinkrailway.com/help',
    delayRepayUrl: 'https://www.thameslinkrailway.com/help-and-support/journey-problems/delay-repay',
    googleMapsSrc: '//maps.googleapis.com/maps/api/js?callback=callback&libraries=places,geometry&key=',
    googleMapsApiKey: 'AIzaSyB5IuxzS7OotxO0oEEQmQkuG1OyS5Q1BCI', //Google maps api key, managed by the thomas.the.tank
    googleRecaptchaKey: '6LfAESkTAAAAAJel3dLFhw7lYUWqoNe8lBUa1tR8', //Google recaptcha api key, managed by the thomas.the.tank
    addisonLeeClientID: 'aa5abe2e8e9348daa1dd1c2f98c2596f',
    addisonLeeFrameSrc: 'https://widget.partnerships.addisonlee.com/index.html?clientid={addisonLeeClientID}&sandbox=false',
    defaultDeliveryCountry: 'GBR',
    journeySelectorType: 'open', //The type of station selector to show on the point search page (open/closed)
    journeySelectorOptions: null, //If the type of journeySelector is closed, a list of valid origin destination combinations
    journeySelectorAdditionalOptions: null,
    journeyPlannerDefaultLayout: _AppConstants.JourneyPlannerLayout.GRID,
    journeyPlannerDefaultCheapestSearch: false,
    journeyPlannerAllowDepartedServiceSearchTimeLimit: 4, // Hours threshold for allowing a search of already departed services
    allowSearchTypeChange: true,
    micrositeLogo: null,
    maxOutboundDays: 84, //The maximum number of days in the future you can search for
    maxSeasonStartPeriod: 'P30D',
    maxSeasonStartPeriodSmartcard: 'P30D',
    minAwaitingSmartcardProductDays: 5,
    minDeliveryLeadTimeInDays: 2, //Used to calculate the earliest date a monthly+ season ticket can be purchased for
    pivotalPostalHour: 16, //The cut-off time during the day for postal delivery, after which the lead time will be extended
    minTodOffset: 'PT5M', //The minimum time requires for TOD tickets
    minTodGTROffset: 'PT5M', //The minimum time fot GTR brands requires for TOD tickets
    minSmartcardOffset: 'PT2H', //The minimum time a brand requires for Smartcard tickets
    smartcardPreloadTimeLimit: 'PT2H', //Time limit when pregistering a smartcard that a ticket will still be preloaded onto the card
    keyGoMaxDurationBetweenTaps: 'PT4H35M', //Maximum duration between keygo journey entry and exit taps
    daySaveUrl: 'http://www.southernrailway.com/tickets-and-fares/ticket-types/daysave/',
    railcard1617WebsiteUrl: 'https://www.16-17saver.co.uk/',
    appStoreAppUrl: 'https://apps.apple.com/gb/app/thameslink-on-track/id908805038',
    googlePlayAppUrl: 'https://play.google.com/store/apps/details?id=com.thameslinkgreatnorthern.ontrack',
    minServiceDelay: 5, // Minimum delay for a service (on arrival) before we draw attention to the fact
    fulfilmentOptionsLink: 'https://www.thameslinkrailway.com/tickets/buy-tickets/ways-to-pay/delivery-options',
    myTicketLinkNRE: 'http://ojp.nationalrail.co.uk/service/wct/show',
    maxSavedAddresses: 10,
    daySaveAbsoluteDateRangeStart: null,
    daySaveAbsoluteDateRangeEnd: null,
    daySaveRelativeDateRangeStart: 3,
    daySaveRelativeDateRangeEnd: 84,
    daySaveDestinationNlc: null,
    discoverMoreUrl: null,
    visaCheckoutSdkScriptUrl: 'https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/integration/v1/sdk.js',
    visaCheckoutSdkApiKey: 'AZDFMKOIDAR8S7QLOHCC21xx-rk1rdmN7I2nJrSZ8E-npLEu0',
    showAdultBirthday: true,
    amazonPayClientId: null,
    amazonPayClientIdSandbox: 'amzn1.application-oa2-client.360dad6bea894164accb7b9d98b00e25',
    amazonPayEnvironment: 'sandbox',
    amazonPaySdkUrls: {
        production: 'https://static-eu.payments-amazon.com/OffAmazonPayments/gbp/lpa/js/Widgets.js',
        sandbox: 'https://static-eu.payments-amazon.com/OffAmazonPayments/uk/sandbox/lpa/js/Widgets.js'
    },
    amazonSellerId: 'AP6D7BCLVKVIN',
    yourAccountHelpUrl: '',
    amazonPaySDKInAppDelay: 500, // Delayed loading Amazon JavaSCript SDK in InApp
    amazonPayWidgetsInAppDelay: 500, // Delayed loading of Amazon Widgets in InApp
    visaCheckoutInAppDelay: 500, // Delayed loading of Visa Checkout in InApp
    customerTitles: _AppConstants.CustomerTitles,
    accessibilityInfoUrl: null,
    registerDetailsImageUrl: '/images/registration/register-details-tl.png',
    registerSmartcardImageUrl: '/images/registration/register-smartcard.png',
    registerPreferencesImageUrl: '/images/registration/register-preferences-tl.png',
    icoUrl: 'https://ico.org.uk/',
    rewardPointsUrl: null,
    rewardPointsTermsUrl: null,
    rewardPointsTocUrl: null,

    defaultCollectionLocationNlc: null,

    createAccountBenefits: ['account.register.create.benefits.checkout', 'account.register.create.benefits.refunds', 'account.register.create.benefits.history'],

    smartcardRegistrationBenefits: ['account.register.smartcard.benefits.tickets', 'account.register.smartcard.benefits.app', 'account.register.smartcard.benefits.queues', 'account.register.smartcard.benefits.contactless', 'account.register.smartcard.benefits.refunds'],

    // Track and Trace
    trackAndTraceAppLink: 'https://covid19.nhs.uk',

    // Refunds
    /*
     * Flag combination to disable itso season refunds on a brand
     *  - enableItsoSeasonRefunds: false
     *  - enableAllowRefundsOnOtherBrands: true
     */
    refundUrl: 'https://www.thameslinkrailway.com/paperticketrefund',
    industrialActionUrl: null,
    smartcardRefundUrl: null,
    sTicketRefundUrl: null,
    smartcardRefundFormUrl: null,
    smartcardRefundContactUrl: null,
    smartcardRefundInformationUrl: 'http://www.nationalrail.co.uk/times_fares/ticket_types/46571.aspx',
    paperTicketRefundsUrl: null,
    eTicketRefundsUrl: null,
    enableSeasonRefundsMoreInfo: true,
    refundSurrenderDateMiddayCutOff: true,
    enableDayTicketRefunds: true,
    enableItsoSeasonRefunds: true,
    enableItsoDayTicketRefunds: false,
    enableAllowRefundsOnOtherBrands: false,
    enableNonStandardItsoSeasonRefundFromLink: true,
    displaySeasonRefundsZeroAdminFee: true,
    enablePurchaseHistoryDisclaimer: true,
    enableItsoRefundsSmartcardValidations: true,
    enableSelfServiceRefundDelay: false,
    selfServiceRefundDelayMinDelay: 3,
    selfServiceRefundDelayMaxDelay: 15,

    // Timeouts for waiting for processing orders
    awaitProcessingTimeout: 5000,
    awaitProcessingAttempts: 60,

    //Tags
    googleGTMID: null, //Google Tag Manager ID
    widgetsGTMID: 'GTM-WMCGG5Q',
    gtmDataLayer: 'dataLayer',
    gtmCampaignWidget: 'On-Track-Widget',

    //Limit jp results to specific service providers
    serviceProviders: null,
    alwaysFilterByServiceProviders: true,

    // Raven Sentry Connection string
    ravenDSN: 'https://c086582b3d514c8a97323da0d6deefa2@app.getsentry.com/72485',
    ravenDSNTAB: 'https://ce79d17425004678bc9bcfd2a03955bf@app.getsentry.com/72482',

    //Security/login
    sessionShort: true,
    minPasswordLength: 8,
    autoLogoutMinutes: 30,
    autoLogoutWarningMinutes: 25,

    //Oyster/contactless further info
    oysterInfo: 'https://www.nationalrail.co.uk/tickets-railcards-and-offers/ticket-types/oyster-contactless-and-travelcards/',
    contactlessInfo: 'https://www.nationalrail.co.uk/tickets-railcards-and-offers/ticket-types/oyster-contactless-and-travelcards/',

    // Carbon Footprint
    carbonFootprint: 'https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2023',
    EPACalculationUrl: 'https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references',
    carbonFootprintCalculatorUrl: 'https://www.carbonfootprint.com/energyconsumption.html',

    // Libs
    leafletGeolocationUrl: 'https://unpkg.com/leaflet-geosearch@latest/dist/bundle.min.js',

    //Amend time period
    amendMinMinutesLeft: 30,

    //Feature Flags - flexi (only used for Flexi account screen)
    enableFlexi: true,

    // Enable map on the Search Page
    enableMap: true,

    //Use OpenStreetMaps instead of googlemaps
    enableOpenMaps: false,

    // Feature Flags - sTickets
    enableSTickets: false,
    enableSTicketsDelivery: true,
    enableSTicketsRefunds: false,
    enableSTicketsList: false,
    hideSTicketsDelivery: false,

    //Feature Flags - smartcard
    enableActivateSmartcard: false,
    enableSmartcardMaintenance: false,
    enableSmartcard: true,
    enableSmartcardAtSignup: true,
    enableSmartcardAccountApplication: true,
    enableDefaultSmartcardAtSignup: false,
    enableSmartcardPaperTransfers: false, //Allow transferring paper tickets onto smartcards
    enableSmartcardTransferAtSignUp: false,
    enableSmartcardEditAddress: false,
    enableSmartcardDiffDeliveryOptAlert: false,
    enableSmartcardTutorial: ':[2020-10-01]',
    enablePaperTransferCollectionFilter: false, //Checks if collection locations are open 3 hours or more on all working days of the week
    enableTocOnlySearch: false,
    enableSmartcardCTA: false,
    enableChildSmartcardMessage: false,
    enableProductPreload: true,
    enableDayTicketPreload: false,
    enableSmartPlusBus: false,
    smartcardPhotoMimeTypes: ['image/jpeg', 'image/jpg', 'image/png'],
    enableSmartcardSelfRegistration: false,
    enableSmartcardSelfRegistrationLink: false,
    enableSmartcardAssociations: false,
    enableSmartcardAddressChange: false,
    enableSmartcardSeasonEnforcement: false,
    enableSmartcardPhotoReplacement: false,
    enableChildSmartcardTransitioning: false,
    enableChildSmartcardRegistration: true,
    enableForcedAppCollectionForTwoHourCollectionWindow: false,
    enableFooterOwnerLink: true,
    enablePendingActionlistSmartcardDeliveryBlocking: false,

    //Feature Flags - keyGo
    enableKeyGoRegistration: true,
    disableKeyGoRegistrationUntilDate: '2018-01-31',
    enableKeyGo: true,
    enableKeyGoRegistrationAtSignup: false,
    enableKeyGoRegistrationWarning: true,
    enableKeyGoCTA: false,
    enableKeyGoCollectionInfo: true,
    enableKeyGoMinTopup: true,
    enableKeyGoSelfCompleteJourneys: false,
    enableKeyGoReimbursement: false,
    enableKeyGoSignposting: false,
    enableKeyGoPaymentCardExpiryReminder: false,
    enableKeyGoRailcards: false,
    enableHostedKeyGoPayments: false,

    //Feature Flags - banners
    enableBetaBanner: false,
    disableBetaBannerDate: null,
    bannerMessageDismissExpires: 60 * 60 * 12,
    enableMicrositeBanner: false,

    //Feature Flags - journey notifications
    journeyNotificationDismissExpires: 60 * 60 * 24,

    //Feature Flags - journey planning
    enableViaAvoid: true,
    enableSeatingPreferences: true,
    enablePlusBus: true,
    enableSeasonTickets: true,
    enableWeeklySeasonTickets: true,
    enableFlexiSeasonTickets: true,
    enableFourWeeklySeasonTickets: false,
    enableQuarterlySeasonTickets: false,
    enableSixMonthlySeasonTickets: false,
    enableOtherTickets: true,
    enableDaySave: false,
    enableHiddenDaySave: false,
    enableRoversRangers: true,
    enableSmartCarnet: false,
    enableAddisonLeeWidget: true,
    enableRailcard1617: true,
    enableRailcardVeterans: true,
    enableDeleteRailcards: false,
    enableBrandTocForServices: false, //Show the TOC when listing services
    enableDelayRepay: true,
    enableDelayRepayHandoff: false,
    enableDelayRepayCaptcha: true,
    enableAutoDelayRepay: false,
    enableOneClickDelayRepay: false,
    enableRewardCodes: false,
    autoDelayRepayMaxJourneys: 50,
    autoDelayRepayRemainingJourneysWarningThreshold: 10,
    enableDelayRepayWarningMessage: false,
    enableCompensationWhitelist: false,
    enableCompensationSeason: false,
    enableCompensationNonSeason: false,
    disableWhitelistCompensationClaim: false,
    disableSeasonTicketCompensationClaim: false,
    disableNonSeasonCompensationClaim: false,
    disableStationFinder: false,
    enableBuyButtonOnResetPassSuccess: false,
    enableOpenReturnInfoModal: true,
    enableDepartNow: true,
    enableEligibleServicesModal: true,
    openReturnGoodValueMultiplier: 1.9,
    enableUsualSeatingAvailabilityModal: false,
    enableJourneySupport: false,
    seatingAvailabilityButtonShowDurationHours: 48,
    enablePromoDiscount: false,
    enablePromoDiscountValidation: false,
    enableBestFareFinderAndRecentOrdersJPWidget: false,

    //Feature Flags - checkout
    enableLogoutRedirect: true,
    enableHeaderBasket: true,
    enableOrderRefundDetails: true,
    enableOrderAmendDetails: true,
    enableEVoucherAmends: true, // This is ok for Pay360Api, but requires some backend work for Pay360Hosted
    enableEVoucherCheckout: true,
    enableAmazonLogin: false,
    enableAmazonRegistration: false,
    enableAmazonPay: false,
    enablePaypal: true,
    enableCardPayments: true,
    enableVisaCheckout: false,
    enablePay360Api: true,
    enablePay360Hosted: false,
    enableBraintreeCardPayments: false,
    enableAmexPayments: true,
    enableSafeKey: true,
    enableSavedPhotocards: true,
    enableTicketDownload: false,
    enableRegistrationDuringCheckout: true,
    disableSelfPrint: false,
    disableETickets: true,
    enableETicketAmends: false,
    disableTOD: false,
    disableCCST: false,
    enableFreeTicketCollectionInfo: false,
    enableFulfilmentOptionsInfo: false,
    enableReorderFromPurchaseHistory: true,
    enableFavouriteTickets: true,
    enableFavouriteTicketChanges: true,
    enableDefaultFulfilmentEticket: false,
    enableDefaultFulfilmentSmartcard: false,
    enableEticketAccountSection: false,
    enableCustomerOnlyDelayRepay: false,
    enableBookingFee: false,
    enableDiscountCode: false,
    enableCheckDeliveryOptionsForFulfilmentCTA: true, // Hide the Details on all fulfilment options CTA if there's only 1 delivery option available,
    enableFlexiKeyGoWarningModal: false,
    enableTrackAndTraceAppLink: true,
    enableBookingConfirmationDelayRepayInfo: false,
    enableDeliveryOptionWatermarkImages: false,
    enableRewardPoints: false,
    enableETicketByPost: false,
    enableCharityRoundUp: false,

    // Feature Flags - account page
    enableEVouchers: true,
    enableNewAccountMenuView: false,
    enablePassengerAssist: false,
    enablePassengerAssistBookingWidget: false,
    enableReservations: false,

    // Feature Flags - disruption alerts
    enableDisruptionAlerts: false,
    enableDisruptionAlertsAccountSection: false,
    enableDisruptionAlertsEditing: false,
    enableDisruptionAlertsCreateButton: false,

    enableTimetableAlertsWidget: false,
    enableTimetableAlertsWidgetAdvancedOptions: false,
    enableAlertsPreferenceOptions: false,
    enableAlertsLimitInfo: false,

    // Feature Flags - preference centre
    enableEmailMarketing: true,
    enableSmsMarketing: false,
    enableServicePreference: true,
    enableServicePreferenceHelpIcon: false,
    enablePromotionsPreference: true,
    enablePromotionsPreferenceHelpIcon: true,
    enableProductsPreference: false,
    enablePrefCentreUnder16Warning: false,
    enableMarketingConsents: false,

    // Feature Flags - misc
    enableInAppTokenRefreshOnPageLoad: true,
    enableFooterFaqsLink: true,
    enableFooterPaymentMethods: true,
    enableFooterLinkInternal: [],
    enableForceScrollRegistration: false,
    enableFirstClassAccessibilityInfo: true,
    enablePostCodeLookUp: true,
    enableBacsValidation: true,
    enableAccountRailcards: false,
    enableAddAccountRailcards: false,
    enableSetPasswordAndPreferencesPage: false,
    enableModalHistoryTracking: true,
    enableETicketRefundAdminFee: false,
    enableETicketRefundBlockingForTravelToday: false,
    enableConfirmEmailField: false,
    enableAccountDeletion: false,
    enableHistoricETickets: false,

    // Feature Flags - OCDR charities
    enableOcdrCharityReimbursementMethod: false,
    enableRailwayChildrenCharity: false,
    enableDameKellyHolmesCharity: false,
    enableSamaritansCharity: false,
    enableCancerResearchCharity: false,
    enableGreatOrmondStreetCharity: false,
    enableNhsCharity: false,
    enableDecCharity: false,

    //Feature Flags - On Track App widget
    enableOnTrackAppWidget: true,

    //Feature Flags - Basket widget
    enableBasketWidget: false,
    enableLogoRedirectToSearchPage: true,

    // Feature Flags - Open Golf
    enableOpenGolf: false,

    // Enable DataDome tracking
    dataDomeJsKey: null,
    enableDelayRepayDataDome: false,

    hideSeatingPreferencesButton: false,

    //Feature Flags - addresses
    enableUserAddresses: true,

    preselectedEmailMarketing: true,

    //Feature Flags - TL/GN split modal
    showBrandSplitModal: false,

    // Feature Flags - carbon emissions
    enableCarbonCalculator: false,

    // eTicket pagination defaults
    eTicketDefaultPage: 1,
    eTicketDefaultLimit: 10,

    showRailcardExpiryInfo: false,

    showMyTreesMenuLink: false,

    disableDayTicketsAdminFee: false,

    brandedMenuNav: null,
    brandedAccountMenuNav: null,

    disableAppTracking: false,
    enableNativeReordering: false,

    // Digital railcards
    enableDigitalRailcards: false,

    // null | Array<TOCCode>
    // Display warnings for services with counted places on the following TOCs:
    showCountedPlaceWarnings: null,

    //Disable tickets on the results page for a specific TOC between certain dates
    disabledServices: [{
        tocCode: 'SN',
        startDate: '2017-01-10 00:00:00',
        endDate: '2017-01-11 23:59:59',
        message: 'global.strike.message'
    }, {
        tocCode: 'SN',
        startDate: '2017-01-13 00:00:00',
        endDate: '2017-01-13 23:59:59',
        message: 'global.strike.message'
    }, {
        tocCode: 'SN',
        startDate: '2017-01-23 00:00:00',
        endDate: '2017-01-23 23:59:59',
        message: 'global.strike.message'
    }],

    enableKentRover: false,
    roversRangersTicketTypes: [{ code: '14R', name: 'roversRangers.ticketTypeName.14R' }, { code: 'R07', name: 'roversRangers.ticketTypeName.R07' }, { code: 'MTR', name: 'roversRangers.ticketTypeName.MTR' }],

    // Feature flags for TOC Family promotion
    enableTPERover: false,
    enableTPEStaffRover: false,
    enableStaffDiscounts: false,
    staffYearlyAllowance: 40,
    tocFamilyTermsAndConditionsUrl: '#',

    railcard1617GracePeriod: { months: 4 },

    // Open Golf
    openGolfStartDate: '2020-03-26', // TODO[limal] Remove
    // openGolfStartDate: '2020-07-19', // TODO[limal] Enable
    openGolfEndDate: '2020-07-19',
    openGolfStation: 'SDW',

    // refund widget
    enableRefundWidgetPoweredBy: false,

    // delay repay
    realexHppUrl: 'https://hpp.sandbox.realexpayments.com/pay',
    delayRepayFaq: 'https://www.thameslinkrailway.com/help-and-support/contact-us/faqs/delays-and-compensation',
    delayRepayMaxTicketDays: 28,
    delayRepayMaxClaims: 5,
    delayRepayStations: null,
    delayRepayVia: true,
    delayRepayMaxUploadMb: 5,
    delayRepayMinUploadMb: 0.01,
    delayRepayUploadTypes: ['application/pdf', 'image/jpeg', 'image/png'],
    delayRepayPaymentLogo: false,
    delayRepayArrivalTime: true,
    delayRepayResponseTime: 24,
    delayRepayResponseUnits: 'hours', // hours|minutes|days
    delayRepayClaimMaxDate: false,
    delayRepayPaperRequiresMoreInfo: false,
    showGroupStations: false,

    // starts from 0
    gridViewVersion: 1,
    serviceListVersion: 1,

    hideBookingRailcardTutorial: true,

    delayRepayTickets: [{
        id: _AppConstants.DelayRepayTicket.SEASON_ANNUAL,
        group: 'season',
        ticketNumber: true,
        photocardNumber: true,
        ticketUpload: true,
        allowPreviousUpload: true
    }, {
        id: _AppConstants.DelayRepayTicket.SEASON_MONTHLY,
        group: 'season',
        ticketNumber: true,
        photocardNumber: true,
        ticketUpload: true,
        allowPreviousUpload: true
    }, {
        id: _AppConstants.DelayRepayTicket.SEASON_WEEKLY,
        group: 'season',
        ticketNumber: true,
        photocardNumber: true,
        ticketUpload: true
    }, {
        id: _AppConstants.DelayRepayTicket.SEASON_OTHER,
        group: 'season',
        ticketNumber: true,
        photocardNumber: true,
        ticketUpload: true,
        allowPreviousUpload: true
    }, { id: _AppConstants.DelayRepayTicket.SINGLE, group: 'non-season', ticketNumber: true, ticketUpload: true }, { id: _AppConstants.DelayRepayTicket.RETURN, group: 'non-season', ticketNumber: true, ticketUpload: true }, {
        id: _AppConstants.DelayRepayTicket.ETICKET_SINGLE,
        group: 'electronic',
        ticketNumber: false,
        ticketUpload: true
    }, {
        id: _AppConstants.DelayRepayTicket.ETICKET_RETURN,
        group: 'electronic',
        ticketNumber: false,
        ticketUpload: true
    }, { id: _AppConstants.DelayRepayTicket.SMART_KEY, group: 'contactless', smartcardNumber: true }, {
        id: _AppConstants.DelayRepayTicket.SEASON_OYSTER,
        group: 'contactless',
        ticketNumber: false,
        statementUpload: true,
        allowPreviousUpload: true
    }, { id: _AppConstants.DelayRepayTicket.SMART_PAYGO, group: 'contactless', statementUpload: true }, {
        id: _AppConstants.DelayRepayTicket.SMART_OTHER,
        group: 'contactless',
        statementUpload: true,
        contactlessNumber: true
    }],

    delayRepayReasons: [{ id: _AppConstants.DelayRepayClaimReason.DELAYED_DEPARTURE }, { id: _AppConstants.DelayRepayClaimReason.DELAYED_ON_ROUTE }, { id: _AppConstants.DelayRepayClaimReason.TRAIN_CANCELLED, moreDetailsOptional: true }, { id: _AppConstants.DelayRepayClaimReason.MISSED_CONNECTION }, {
        id: _AppConstants.DelayRepayClaimReason.RESUBMITTED_CLAIM,
        moreDetailsRequired: true,
        maxTicketDays: 180
    }],

    delayRepayTimes: [{ id: 'short', value: '30-59' }, { id: 'medium', value: '60-119' }, { id: 'long', value: '120' }],

    delayRepayBankable: false,

    delayRepayPaymentMethods: [{
        id: _AppConstants.DelayRepayPaymentMethod.AMAZON,
        requiresAccount: true,
        isBankable: false
    }, {
        id: _AppConstants.DelayRepayPaymentMethod.BACS,
        requiresAccount: false,
        isBankable: true,
        countries: ['GBR']
    }, {
        id: _AppConstants.DelayRepayPaymentMethod.EVOUCHER,
        requiresAccount: true,
        isBankable: false
    }, {
        id: _AppConstants.DelayRepayPaymentMethod.PAYPAL,
        requiresAccount: true,
        isBankable: true
    }, {
        id: _AppConstants.DelayRepayPaymentMethod.CHARITY,
        requiresAccount: false,
        isBankable: true,
        isOtherType: false,
        countries: ['GBR']
    }, {
        id: _AppConstants.DelayRepayPaymentMethod.VOUCHER,
        requiresAccount: false,
        isBankable: true,
        isOtherType: true,
        message: 'delayrepay.paymentMethod.message.longer',
        countries: ['GBR']
    }],

    delayRepayCharities: [{
        imageUrl: '/images/charity-railway-children.png',
        name: 'railway-children',
        text: 'delayrepay.charities.texts.railway-children',
        title: 'Railway Children',
        website: 'https://www.railwaychildren.org.uk/',
        linkText: 'www.railwaychildren.org.uk'
    }, {
        imageUrl: '/images/charity-samaritans.png',
        name: 'samaritans',
        text: 'delayrepay.charities.texts.samaritans',
        title: 'Samaritans',
        website: 'https://www.samaritans.org/',
        linkText: 'www.samaritans.org'
    }, {
        imageUrl: '/images/charity-nhs.png',
        name: 'nhs',
        text: 'delayrepay.charities.texts.nhs',
        title: 'NHS',
        website: 'https://www.nhscharitiestogether.co.uk/what-we-do/',
        linkText: 'www.nhscharitiestogether.co.uk'
    }],

    delayRepayAmazonClientId: null,

    autoDelayRepayPaymentMethods: [{ id: _AppConstants.DelayRepayPaymentMethod.BACS, requiresAccount: false, countries: ['GBR'] }, { id: _AppConstants.DelayRepayPaymentMethod.EVOUCHER, requiresAccount: true, disabled: false }, { id: _AppConstants.DelayRepayPaymentMethod.PAYPAL, requiresAccount: true }, { id: _AppConstants.DelayRepayPaymentMethod.CHARITY, requiresAccount: false, isBankable: true }],

    compensationIBlocksApi: {
        url: 'https://seasoncomp-api.iblocks.co.uk/eligibility-check/apiV2',
        user: 'otrl-live',
        password: '**41_party_ANGRY_23**'
    },
    compensationPhoneNumber: '0345 0264 700',
    compensationHelpUrl: 'https://railcompensation.thameslinkrailway.com/',
    compensationFaqUrl: 'https://railcompensation.thameslinkrailway.com/faq',
    compensationEligibilityCheckerUrl: 'https://railcompensation.thameslinkrailway.com/check-eligibility',
    compensationMinDuration: { weeks: 1 },
    compensationMinDurationPerRoute: { weeks: 1 },
    compensationMaxRoutes: 8,
    compensationMaxTicketsPerRoute: 5,
    compensationMaxTotalBookSize: 10,
    compensationMinTicketsPerWeek: 3,
    compensationMaxTicketsPerWeek: 5,
    compensationMinWeeks: 1,
    compensationMaxWeeks: 4,
    compensationMaxWeeksWithCarnet: 2,
    compensationMaxWeeksLevel2: 1,
    compensationStartDate: '2018-05-20',
    compensationEndDate: '2018-07-28',
    compensationNonSeasonStartDate: '2018-05-21',
    compensationNonSeasonEndDate: '2018-07-29',
    compensationStartDayOfWeek: 'monday',
    compensationTickets: [{
        id: _AppConstants.CompensationTicket.STANDARD,
        class: _AppConstants.DelayRepayTicketClass.STANDARD,
        ticketNumber: true,
        photocardNumber: true,
        dates: true,
        price: true,
        purchaseLocation: true,
        ticketUpload: true
    }, {
        id: _AppConstants.CompensationTicket.FIRST_CLASS,
        class: _AppConstants.DelayRepayTicketClass.FIRST_CLASS,
        ticketNumber: true,
        photocardNumber: true,
        dates: true,
        price: true,
        purchaseLocation: true,
        ticketUpload: true
    }, {
        id: _AppConstants.CompensationTicket.SMART_KEY,
        smartcardNumber: true,
        price: true,
        dates: true
    }, {
        id: _AppConstants.CompensationTicket.SMART_PAYGO,
        weeklyCap: true,
        fixedDuration: { days: 7 },
        dates: true,
        statementUpload: true,
        requiresUpload: true,
        price: false
    }, {
        id: _AppConstants.CompensationTicket.SMART_OTHER,
        contactlessNumber: true,
        statementUpload: true,
        requiresUpload: true,
        price: true,
        dates: true
    }, {
        id: _AppConstants.CompensationTicket.SEASON_OYSTER,
        oysterNumber: true,
        statementUpload: true,
        requiresUpload: true,
        uploadHint: true,
        price: true,
        dates: true
    }],

    compensationNonSeasonTickets: [{
        id: _AppConstants.CompensationTicket.SINGLE,
        stations: true,
        price: true,
        ticketNumber: true,
        purchaseLocation: true,
        pairWithOther: true,
        pairWithSelf: true
    }, {
        id: _AppConstants.CompensationTicket.RETURN,
        stations: true,
        price: true,
        ticketNumber: true,
        purchaseLocation: true,
        pairWithOther: false,
        pairWithSelf: false
    }, {
        id: _AppConstants.CompensationTicket.CARNET,
        stations: true,
        price: true,
        ticketNumber: true,
        purchaseLocation: true,
        bookSize: true,
        pairWithSelf: true,
        pairWithOther: false,
        returnMustMatch: true,
        weeklyExclusive: true
    }, {
        id: _AppConstants.CompensationTicket.FREEDOM_PASS,
        stations: true,
        pairWithOther: true,
        pairWithSelf: false
    }, {
        id: _AppConstants.CompensationTicket.CONTACTLESS_BANK,
        price: true,
        stations: true,
        pairWithOther: true,
        pairWithSelf: true
    }, {
        id: _AppConstants.CompensationTicket.OYSTER_PAYG,
        stations: true,
        oysterNumber: true,
        pairWithOther: true,
        pairWithSelf: true,
        evidenceIsOptional: true
    }, {
        id: _AppConstants.CompensationTicket.CONTACTLESS_KEY,
        smartcardNumber: true,
        pairWithOther: true,
        pairWithSelf: true,
        optionalReturn: true,
        evidenceNotRequired: true
    }],

    compensationEvidence: [{ id: _AppConstants.CompensationEvidence.TICKET_IMAGE }, { id: _AppConstants.CompensationEvidence.TICKET_RECEIPT }, { id: _AppConstants.CompensationEvidence.BANK_STATEMENT, allowPreviousUpload: true }, { id: _AppConstants.CompensationEvidence.JOURNEY_HISTORY, allowPreviousUpload: true }, { id: _AppConstants.CompensationEvidence.OTHER, comments: true }, { id: _AppConstants.CompensationEvidence.NONE, comments: true }, { id: _AppConstants.CompensationEvidence.TICKET_MIXTURE, comments: true, onlyFor: [_AppConstants.CompensationTicket.CARNET] }, { id: _AppConstants.CompensationEvidence.FREEDOM_PASS_IMAGE, allowPreviousUpload: true, onlyFor: [_AppConstants.CompensationTicket.FREEDOM_PASS] }],

    compensationDurations: (0, _immutable.fromJS)([_AppConstants.DurationTypes.WEEKLY, _AppConstants.DurationTypes.MONTHLY, _AppConstants.DurationTypes.ANNUAL, _AppConstants.DurationTypes.CUSTOM]),
    compensationCpayWeeklyCaps: (0, _immutable.fromJS)([{ name: 'Zones 1-3', price: 2790 }, { name: 'Zones 1-4', price: 3420 }, { name: 'Zones 1-5', price: 4070 }, { name: 'Zones 1-6', price: 4360 }, { name: 'Zones 2-3', price: 1780 }, { name: 'Zones 2-4', price: 1970 }, { name: 'Zones 2-5', price: 2370 }, { name: 'Zones 2-6', price: 2980 }, { name: 'Zone 3 only', price: 1780 }, { name: 'Zones 3-4', price: 1780 }, { name: 'Zones 3-5', price: 1970 }, { name: 'Zones 3-6', price: 2370 }, { name: 'Zone 4 only', price: 1780 }, { name: 'Zones 4-5', price: 1780 }, { name: 'Zones 4-6', price: 1970 }, { name: 'Zone 5 only', price: 1780 }, { name: 'Zones 5-6', price: 1780 }]),

    compensationPurchaseLocations: [{ id: _AppConstants.CompensationPurchaseLocations.STATION, requiresStation: true }, { id: _AppConstants.CompensationPurchaseLocations.WEBSITE }, { id: _AppConstants.CompensationPurchaseLocations.OTHER, requiresOther: true }],

    compensationPaymentMethods: [{
        id: _AppConstants.DelayRepayPaymentMethod.BACS,
        requiresAccount: false,
        isBankable: true,
        countries: ['GBR']
    }, {
        id: _AppConstants.DelayRepayPaymentMethod.EVOUCHER,
        requiresAccount: true,
        isBankable: false,
        disabled: false
    }],

    tutorials: [{
        name: _AppConstants.Tutorials.JP_GRID,
        currentIndex: 0,
        dismissed: false,
        defaultOpen: false,
        stages: [{
            name: _AppConstants.JPGridTutorialStages.INTRO,
            title: 'jp-grid-tutorial.intro.title',
            text: 'jp-grid-tutorial.intro.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.TABS,
            title: 'jp-grid-tutorial.tabs.title',
            text: 'jp-grid-tutorial.tabs.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.GRID_VIEW,
            title: 'jp-grid-tutorial.grid-view.title',
            text: 'jp-grid-tutorial.grid-view.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.LIST_VIEW,
            title: 'jp-list-tutorial.list-view.title',
            text: 'jp-list-tutorial.list-view.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.SERVICE_CAROUSEL,
            title: 'jp-grid-tutorial.service-carousel.title',
            text: 'jp-grid-tutorial.service-carousel.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.SERVICE_INFO,
            title: 'jp-grid-tutorial.service-info.title',
            text: 'jp-grid-tutorial.service-info.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.TICKET_CATEGORIES,
            title: 'jp-grid-tutorial.ticket-categories.title',
            text: 'jp-grid-tutorial.ticket-categories.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.TICKET_DETAILS,
            title: 'jp-grid-tutorial.ticket-details.title',
            text: 'jp-grid-tutorial.ticket-details.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.PREFERENCES,
            title: 'jp-grid-tutorial.preferences.title',
            text: 'jp-grid-tutorial.preferences.text',
            image: true
        }]
    }, {
        name: _AppConstants.Tutorials.JP_LIST,
        currentIndex: 0,
        dismissed: false,
        defaultOpen: false,
        stages: [{
            name: _AppConstants.JPListTutorialStages.INTRO,
            title: 'jp-list-tutorial.intro.title',
            text: 'jp-list-tutorial.intro.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.TABS,
            title: 'jp-list-tutorial.tabs.title',
            text: 'jp-list-tutorial.tabs.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.LIST_VIEW,
            title: 'jp-list-tutorial.list-view.title',
            text: 'jp-list-tutorial.list-view.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.GRID_VIEW,
            title: 'jp-grid-tutorial.grid-view.title',
            text: 'jp-grid-tutorial.grid-view.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.SELECT_SERVICE,
            title: 'jp-list-tutorial.select-service.title',
            text: 'jp-list-tutorial.select-service.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.SERVICE_INFO,
            title: 'jp-list-tutorial.service-info.title',
            text: 'jp-list-tutorial.service-info.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.SELECT_FARE,
            title: 'jp-list-tutorial.select-fare.title',
            text: 'jp-list-tutorial.select-fare.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.TICKET_DETAILS,
            title: 'jp-list-tutorial.ticket-details.title',
            text: 'jp-list-tutorial.ticket-details.text',
            image: true
        }, {
            name: _AppConstants.JPListTutorialStages.RETURN_SERVICE,
            title: 'jp-list-tutorial.return-service.title',
            text: 'jp-list-tutorial.return-service.text',
            image: true
        }, {
            name: _AppConstants.JPGridTutorialStages.PREFERENCES,
            title: 'jp-list-tutorial.preferences.title',
            text: 'jp-list-tutorial.preferences.text',
            image: true
        }]
    }, {
        name: _AppConstants.Tutorials.SEASONS,
        currentIndex: 0,
        dismissed: false,
        defaultOpen: false,
        stages: [{
            name: _AppConstants.SeasonsTutorialStages.INTRO,
            title: 'seasons-tutorial.intro.title',
            text: 'seasons-tutorial.intro.text',
            image: true
        }, {
            name: _AppConstants.SeasonsTutorialStages.FILTERS,
            title: 'seasons-tutorial.filters.title',
            text: 'seasons-tutorial.filters.text',
            image: true
        }, {
            name: _AppConstants.SeasonsTutorialStages.COMPARISON,
            title: 'seasons-tutorial.comparison.title',
            text: 'seasons-tutorial.comparison.text',
            image: true
        }]
    }, {
        name: _AppConstants.Tutorials.STATION_FINDER,
        currentIndex: 0,
        dismissed: false,
        defaultOpen: false,
        stages: [{
            name: _AppConstants.StationFinderTutorialStages.INTRO,
            title: 'station-finder.intro.title',
            text: 'station-finder.intro.text',
            image: true
        }, {
            name: _AppConstants.StationFinderTutorialStages.ORIGIN_DESTINATION,
            title: 'station-finder.origin-destination.title',
            text: 'station-finder.origin-destination.text',
            image: true
        }]
    }, {
        name: _AppConstants.Tutorials.SMARTCARD,
        currentIndex: 0,
        dismissed: false,
        defaultOpen: true,
        hideProgression: true,
        stages: [{
            name: _AppConstants.SmartcardTutorial.INTRO,
            title: 'booking.smartcard.info.header',
            text: 'booking.smartcard.info.body'
        }]
    }, {
        name: _AppConstants.Tutorials.RAILCARD,
        currentIndex: 0,
        dismissed: false,
        defaultOpen: true,
        hideProgression: true,
        stages: [{
            name: _AppConstants.RailcardTutorial.INTRO,
            title: 'booking.tutorial.railcard',
            text: 'booking.tutorial.railcard'
        }]
    }],

    //Feature Flags - inApp
    enableAppUpdateAlertPopup: true,
    enableSmartcardInfoInApp: true,

    // pay attention to the version with 2 digits, 2.6 it means 2.6.x
    unsupportedAppVersions: {
        iOS: '2.6.0 || 2.5.0',
        Android: '2.8.1 || 2.8.0 || 2.6.0 || 2.5.0'
    },

    gaAjaxHandlerAppVersion: '> 2.9.1',

    // -- Google Optimize
    featureExperimentIds: null,
    featureVariants: null,
    // -- end: Google Optimize

    // external JP widget
    jpWidgetStylesheetUrl: null,

    externalRegistrationLink: null,

    showNRETicketLink: true,
    hasFooterPoweredByOn: false,
    poweredByUrl: 'https://www.ontrackretail.co.uk/',

    flexiHelpUrl: null,
    keyGoFlexiExplainedUrl: null,
    flexiNoResultsLink: null,

    digitalRailcardsPortalUrl: null,

    // NRE Handoff
    enableNREHandoffLogging: false,
    journeyPlannerNREStagingUrl: 'https://nreojp.staging.nationalrail.co.uk',
    journeyPlannerNREUrl: 'https://ojp.nationalrail.co.uk',

    // Webchat
    enableWebchat: false,
    webchatIframeSrc: '',
    webchatProhibitedPaths: ['/search', '/season-tickets', '/journeys-list/', '/journeys-grid/', '/delivery', '/payment', '/account'],

    // Map default center coords
    defaultMapCenter: {
        lat: 51.505,
        lng: -0.09
    }
};

var Config = function (_record) {
    (0, _inherits3.default)(Config, _record);

    function Config() {
        (0, _classCallCheck3.default)(this, Config);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Config.resolveAll = function resolveAll(list, RecordType) {
        if (list) {
            return (0, _immutable.fromJS)(list).map(function (item) {
                return RecordType.fromJSON(item.toJS ? item.toJS() : item);
            });
        }
        return list;
    };

    Config.fromJS = function fromJS() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var resolved = (0, _assign2.default)(json, {
            journeySelectorOptions: (0, _immutable.fromJS)(json.journeySelectorOptions),
            journeySelectorAdditionalOptions: (0, _immutable.fromJS)(json.journeySelectorAdditionalOptions),
            serviceProviders: (0, _immutable.fromJS)(json.serviceProviders),
            disabledServices: Config.resolveAll(json.disabledServices, _DisabledService2.default),
            delayRepayStations: (0, _immutable.fromJS)(json.delayRepayStations),
            delayRepayTickets: Config.resolveAll(json.delayRepayTickets, _TicketType4.default),
            delayRepayReasons: Config.resolveAll(json.delayRepayReasons, _Reason2.default),
            delayRepayTimes: Config.resolveAll(json.delayRepayTimes, _Time2.default),
            delayRepayPaymentMethods: Config.resolveAll(json.delayRepayPaymentMethods, _PaymentMethod2.default),
            compensationPaymentMethods: Config.resolveAll(json.compensationPaymentMethods, _PaymentMethod2.default),
            compensationTickets: Config.resolveAll(json.compensationTickets, _TicketType2.default),
            compensationNonSeasonTickets: Config.resolveAll(json.compensationNonSeasonTickets, _NonSeasonTicketType2.default),
            compensationEvidence: Config.resolveAll(json.compensationEvidence, _EvidenceType2.default),
            compensationPurchaseLocations: Config.resolveAll(json.compensationPurchaseLocations, _PurchaseLocation2.default),
            autoDelayRepayPaymentMethods: Config.resolveAll(json.autoDelayRepayPaymentMethods, _PaymentMethod2.default),
            tutorials: Config.resolveAll(json.tutorials, _Tutorial2.default),
            featureVariants: (0, _immutable.fromJS)(json.featureVariants),
            featureExperimentIds: (0, _immutable.fromJS)(json.featureExperimentIds)
        });
        return new Config(resolved);
    };

    return Config;
}((0, _immutable.Record)(defaults));

var instance = new Config();

exports.default = {
    has: function has(key) {
        return instance.has(key);
    },
    get: function get(key) {
        var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        return instance.get(key, def);
    },
    set: function set(key, value) {
        if (!window.jasmine) {
            console.warn('Called config.set, this should only be used in tests');
        }
        instance = instance.set(key, value);
    },
    keys: function keys() {
        return instance.keySeq();
    },
    init: function init() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var invalidKey = (0, _keys2.default)(options).find(function (key) {
            return !(key in defaults);
        });
        if (invalidKey) {
            throw Error('\'' + invalidKey + '\' is not a valid config option');
        }
        instance = Config.fromJS((0, _extends3.default)({}, defaults, options));
    },
    toJS: function toJS() {
        return instance.toJS();
    }
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$create = __webpack_require__(848);

var setPrototypeOf = __webpack_require__(1779);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1507);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$assign = __webpack_require__(401);

function _extends() {
  module.exports = _extends = _Object$assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1401), __esModule: true };

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _momentTimezone = __webpack_require__(235);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trainTime(timeStr) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _momentTimezone2.default.tz(timeStr, format, _AppConstants.TimeZone);
}

var utilMethods = 'min max utc unix months isDate locale invalid duration isMoment weekdays isDuration monthsShort weekdaysMin weekdaysShort normalizeUnits'.split(' ');

function proxyStatic(name) {
    trainTime[name] = _momentTimezone2.default[name].bind(_momentTimezone2.default);
}

utilMethods.forEach(proxyStatic);

trainTime.isTrainTime = function istrainTime(datetime) {
    return trainTime.isMoment(datetime) && datetime.tz() === _AppConstants.TimeZone;
};

_momentTimezone2.default.fn.calendarDuration = function (d2) {
    return trainTime.calendarDuration(this, d2);
};

trainTime.calendarDuration = function (d1, d2) {
    return _momentTimezone2.default.duration(trainTime.calendarDiff(d1, d2));
};

_momentTimezone2.default.fn.calendarDiff = function (d2) {
    return trainTime.calendarDiff(this, d2);
};

trainTime.calendarDiff = function (d1, d2) {
    // Adapted from moment-precise-range to return a differences object which can be used to construct a moment.duration
    // https://github.com/codebox/moment-precise-range
    /**
     * @license
     * The MIT License (MIT)
     * Copyright (c) 2014 Rob Dawson
     * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
     * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
     */
    var m1 = trainTime(d1);
    var m2 = trainTime(d2);
    var sign = 1;

    if (m1.isSame(m2)) {
        return {
            years: 0,
            months: 0,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        };
    }

    if (m1.isBefore(m2)) {
        sign = -1;
        var _ref = [m2, m1];
        m1 = _ref[0];
        m2 = _ref[1];
    }

    var mDiff = m1.month() - m2.month();
    var dDiff = m1.date() - m2.date();
    var hourDiff = m1.hour() - m2.hour();
    var minDiff = m1.minute() - m2.minute();
    var yDiff = m1.year() - m2.year();
    var secDiff = m1.second() - m2.second();

    if (secDiff < 0) {
        secDiff = 60 + secDiff;
        minDiff--;
    }
    if (minDiff < 0) {
        minDiff = 60 + minDiff;
        hourDiff--;
    }
    if (hourDiff < 0) {
        hourDiff = 24 + hourDiff;
        dDiff--;
    }
    if (dDiff < 0) {
        var daysInLastFullMonth = trainTime(m1.year() + '-' + (m1.month() + 1), "YYYY-MM").subtract(1, 'M').daysInMonth();
        if (daysInLastFullMonth < m2.date()) {
            // 31/01 -> 2/03
            dDiff = daysInLastFullMonth + dDiff + (m2.date() - daysInLastFullMonth);
        } else {
            dDiff = daysInLastFullMonth + dDiff;
        }
        mDiff--;
    }
    if (mDiff < 0) {
        mDiff = 12 + mDiff;
        yDiff--;
    }

    return {
        years: sign * yDiff,
        months: sign * mDiff,
        days: sign * dDiff,
        hours: sign * hourDiff,
        minutes: sign * minDiff,
        seconds: sign * secDiff
    };
};

_momentTimezone2.default.fn.isSameWeek = function (d2) {
    return trainTime.isSameWeek(this, d2);
};

trainTime.isSameWeek = function (d1, d2) {
    return d1.isoWeek() !== d2.isoWeek();
};

_momentTimezone2.default.fn.isWeekendDate = function () {
    return trainTime.isWeekendDate(this);
};

trainTime.isWeekendDate = function (date) {
    return date.isoWeekday() === 6 || date.isoWeekday() === 7;
};

_momentTimezone2.default.fn.addWorkingDays = function (days) {
    return trainTime.addWorkingDays(this, days);
};

trainTime.addWorkingDays = function (date, days) {
    var startDate = date.clone().startOf('day');
    var weekendDays = 0;

    date.startOf('day').add(days, 'days');

    if (trainTime.isWeekendDate(date)) {
        weekendDays += 2;
    }

    if (trainTime.isSameWeek(startDate, date)) {
        weekendDays += 2 * (date.isoWeek() - startDate.isoWeek());
        if (trainTime.isWeekendDate(startDate)) {
            weekendDays -= startDate.isoWeekday() - 5;
        }
    } else {
        if (trainTime.isWeekendDate(startDate)) {
            weekendDays -= date.isoWeekday() - 6;
        }
    }

    return date.add(weekendDays, 'days');
};

trainTime.ukDate = function (date) {
    return (0, _momentTimezone2.default)(date).format('DD-MM-YYYY');
};

trainTime.ukDateTime = function (date) {
    return (0, _momentTimezone2.default)(date).format('DD-MM-YYYY HH:mm');
};

trainTime.isoDate = function (date) {
    return (0, _momentTimezone2.default)(date).format('YYYY-MM-DD');
};

trainTime.isToday = function (date) {
    // return moment(date).isSame(moment().startOf('day'), 'd');
    return (0, _momentTimezone2.default)(date).isSame((0, _momentTimezone2.default)(), 'day');
};

trainTime.isTomorrow = function (date) {
    return (0, _momentTimezone2.default)(date).isSame((0, _momentTimezone2.default)().add(1, 'days').startOf('day'), 'd');
};

trainTime.isInThePast = function (date) {
    var now = (0, _momentTimezone2.default)();
    return now.isAfter((0, _momentTimezone2.default)(date));
};

exports.default = trainTime;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$keys = __webpack_require__(842);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.prefix = prefix;
exports.getClassSet = getClassSet;
exports.splitBsProps = splitBsProps;
exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
exports.addStyle = addStyle;
exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = void 0;

var _entries = _interopRequireDefault(__webpack_require__(409));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _invariant = _interopRequireDefault(__webpack_require__(72));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _StyleConfig = __webpack_require__(90);

// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? (0, _invariant.default)(false, 'A `bsClass` prop is required for this component') : invariant(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = _propTypes.default.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
exports.bsClass = bsClass;
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = _propTypes.default.oneOf(existing); // expose the values on the propType function for documentation


  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = (0, _extends2.default)({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
exports.bsStyles = bsStyles;
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = _StyleConfig.SIZE_MAP[size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = _propTypes.default.oneOf(values);

  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = (0, _extends2.default)({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
exports.bsSizes = bsSizes;

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  (0, _entries.default)(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });
  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};
  (0, _entries.default)(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });
  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */


function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;
exports._curry = _curry;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PersistedStores = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _weakMap = __webpack_require__(1526);

var _weakMap2 = _interopRequireDefault(_weakMap);

var _keys2 = __webpack_require__(127);

var _keys3 = _interopRequireDefault(_keys2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _events = __webpack_require__(1536);

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _LocalStorage = __webpack_require__(316);

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_EVENT = 'CHANGE';

// Weakmap used to implement private members
var EMITTERS = new _weakMap2.default();
var PersistedStores = exports.PersistedStores = [];

/**
 * [defaultOptions description]
 * @type {Object}
 */
var defaultOptions = {
    // localStorage key to persist store data
    storageKey: null,

    // Immutable Record class with a `fromJSON` static method
    recordType: null,

    // Max number of seconds to keep persisted store data
    expires: null,

    // Function to validate persisted store data that hasn't expired
    validateStoredData: null
};

var BaseStore = function () {
    function BaseStore() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
        (0, _classCallCheck3.default)(this, BaseStore);

        (0, _assign2.default)(this, (0, _pick3.default)(options, (0, _keys3.default)(defaultOptions)));
        var emitter = new _events.EventEmitter();
        // EventEmitter started to throw a warning
        // about a potential memory leak (11 listeners)
        emitter.setMaxListeners(Infinity);
        EMITTERS.set(this, emitter);
        this.registerActionHandlers();
        this.state = this.getInitialState();
        if (options.storageKey) {
            PersistedStores.push(this);
        }
    }

    BaseStore.prototype.get = function get(key) {
        return this.state.get(key);
    };

    BaseStore.prototype.getAll = function getAll() {
        return this.state;
    };

    BaseStore.prototype.getInitialState = function getInitialState() {
        return this.deserialize(this.recordType ? (0, _LinkMapper.resolve)(null).as(this.recordType) : null);
    };

    BaseStore.prototype.getPersistedState = function getPersistedState() {
        if (this.storageKey) {
            var local = _LocalStorage2.default.objectFromLocalStorage(this.storageKey, this.recordType, this.validateStoredData);

            if (local) {
                return this.deserialize(local);
            }
        }

        return null;
    };

    BaseStore.prototype.deserialize = function deserialize(serialized) {
        var RecordType = this.recordType || _immutable.Map;
        return serialized ? _immutable2.default.fromJS(serialized) : new RecordType();
    };

    BaseStore.prototype.setState = function setState(newState) {
        this.state = newState;
        this.persist();
        this.emitChange();
    };

    BaseStore.prototype.loadPersistedState = function loadPersistedState() {
        var persistedState = this.getPersistedState();
        this.setState(persistedState ? persistedState : this.state);
    };

    BaseStore.prototype.resetState = function resetState() {
        this.setState(this.getInitialState());
    };

    BaseStore.prototype.getStorageKey = function getStorageKey() {
        return this.storageKey;
    };

    BaseStore.prototype.getExpiry = function getExpiry() {
        return _LocalStorage2.default.getExpiry(this.getStorageKey());
    };

    BaseStore.prototype.persist = function persist() {
        if (this.storageKey) {
            _LocalStorage2.default.objectToLocalStorage(this.getStorageKey(), this.serialize(), this.expires);
        }
    };

    BaseStore.prototype.serialize = function serialize() {
        return this.state.toJS();
    };

    BaseStore.prototype.getActionHandlers = function getActionHandlers() {
        return false;
    };

    BaseStore.prototype.registerActionHandlers = function registerActionHandlers() {
        var _this = this;

        var handlers = this.getActionHandlers();
        if (handlers) {
            _AppDispatcher2.default.register(function (payload) {
                return handlers[payload.actionType] && handlers[payload.actionType].call(_this, payload);
            });
        }
    };

    BaseStore.prototype.emitChange = function emitChange() {
        EMITTERS.get(this).emit(CHANGE_EVENT);
    };

    BaseStore.prototype.addChangeListener = function addChangeListener(callback) {
        EMITTERS.get(this).on(CHANGE_EVENT, callback);
    };

    BaseStore.prototype.removeChangeListener = function removeChangeListener(callback) {
        EMITTERS.get(this).removeListener(CHANGE_EVENT, callback);
    };

    return BaseStore;
}();

exports.default = BaseStore;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Icon(_ref) {
    var icon = _ref.icon,
        className = _ref.className,
        srOnly = _ref.srOnly,
        inline = _ref.inline,
        onClick = _ref.onClick,
        iconProps = (0, _objectWithoutProperties3.default)(_ref, ['icon', 'className', 'srOnly', 'inline', 'onClick']);

    var iconClasses = (0, _classnames2.default)('otrl otrl-' + icon, className, { 'otrl-inline': inline });

    if (srOnly) {
        return _react2.default.createElement(
            'i',
            (0, _extends3.default)({ onClick: onClick, className: iconClasses }, iconProps),
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                srOnly
            )
        );
    }
    return _react2.default.createElement('i', (0, _extends3.default)({ onClick: onClick, className: iconClasses, 'aria-hidden': 'true' }, iconProps));
}

Icon.propTypes = {
    icon: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    srOnly: _propTypes2.default.string,
    inline: _propTypes2.default.bool
};

Icon.defaultProps = {
    className: '',
    srOnly: ''
};

exports.default = Icon;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _map2 = __webpack_require__(314);

var _map3 = _interopRequireDefault(_map2);

var _keys2 = __webpack_require__(127);

var _keys3 = _interopRequireDefault(_keys2);

var _zipObject2 = __webpack_require__(204);

var _zipObject3 = _interopRequireDefault(_zipObject2);

exports.getDefaults = getDefaults;
exports.getResolvers = getResolvers;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper functions for creating record classes
 *
 *  schemas should be defined as:
 *
 *  {
 *      field: [ resolver, defaultValue ]
 *  }
 *
 *  eg:
 *
 *  {
 *      name: [ fields.string, 'pete'],
 *      age: [ field.number ]
 *  }
 */

function objFromSchema(schema, index) {
  var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return (0, _zipObject3.default)((0, _keys3.default)(schema), (0, _map3.default)(schema, function (def) {
    return (0, _get3.default)(def, index, defaultVal);
  }));
}

/**
 * Get the default values for a record schema
 */
function getDefaults(schema) {
  return objFromSchema(schema, 1);
}

/**
 * Get the resolvers for a schema to use with LinkMappers construct helper
 */
function getResolvers(schema) {
  return objFromSchema(schema, 0);
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(656);

var _createChainableTypeChecker = __webpack_require__(324);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FeatureFlagStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lazy date regexes - moment.js will reject invalid dates, causing flag to be `false`
var DATE_RX = /\d{4}-\d\d-\d\d/;
var TIME_RX = /\d\d:\d\d/;
var DATETIME_RX = new RegExp('(' + DATE_RX.source + '(?:[ T]' + TIME_RX.source + ')?)'); // capture
var DATE_RANGE_RX = new RegExp('^(!)?(?:\\[' + DATETIME_RX.source + '])?:(?:\\[' + DATETIME_RX.source + '])?$'); // optional [fromDate]:[toDate]

var FeatureFlagStore = exports.FeatureFlagStore = function (_BaseStore) {
    (0, _inherits3.default)(FeatureFlagStore, _BaseStore);

    function FeatureFlagStore() {
        (0, _classCallCheck3.default)(this, FeatureFlagStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    FeatureFlagStore.prototype.get = function get(flag) {
        var value = this.state.get(flag, _config2.default.get(flag));
        var match = typeof value === 'string' && value.match(DATE_RANGE_RX);
        if (match) {
            var invert = match[1],
                _match$ = match[2],
                startDate = _match$ === undefined ? (0, _TrainTime2.default)().startOf('day') : _match$,
                _match$2 = match[3],
                endDate = _match$2 === undefined ? (0, _TrainTime2.default)().endOf('day') : _match$2;

            var isInRange = (0, _TrainTime2.default)().isBetween((0, _TrainTime2.default)(startDate), (0, _TrainTime2.default)(endDate), null, '[]');
            return invert ? !isInRange : isInRange;
        }
        return Boolean(value);
    };

    FeatureFlagStore.prototype._toggleFeature = function _toggleFeature(_ref) {
        var feature = _ref.feature,
            value = _ref.value;

        this.setState(this.state.set(feature, value));
    };

    FeatureFlagStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.FEATURE_TOGGLED] = this._toggleFeature, _ref2[_AppConstants.ActionTypes.APP_INITIALIZED] = this.resetState, _ref2;
    };

    return FeatureFlagStore;
}(_BaseStore3.default);

var instance = new FeatureFlagStore({
    storageKey: 'feature-flags',
    expires: 60 * 60 * 12
});

exports.default = instance;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalActions = {
    open: function open(type, data) {
        _AppDispatcher2.default.dispatch({
            type: type,
            data: data,
            actionType: _AppConstants.ActionTypes.MODAL_OPENED
        });
    },
    close: function close(type) {
        _AppDispatcher2.default.dispatch({
            type: type,
            actionType: _AppConstants.ActionTypes.MODAL_CLOSED
        });
    }
};

exports.default = ModalActions;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.BaseModalUnconnected = exports.BaseModal = exports.baseModalScrollTo = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Modal = __webpack_require__(547);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _ReactOverlayManager = __webpack_require__(1844);

var _ReactOverlayManager2 = _interopRequireDefault(_ReactOverlayManager);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Page = __webpack_require__(424);

var _Page2 = _interopRequireDefault(_Page);

var _BaseModalTracker = __webpack_require__(1849);

var _BaseModalTracker2 = _interopRequireDefault(_BaseModalTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        isDesktop: _DimensionsStore2.default.isDesktopWidth()
    };
};

var baseModalScrollTo = exports.baseModalScrollTo = function baseModalScrollTo(_ref) {
    var _ref$left = _ref.left,
        left = _ref$left === undefined ? null : _ref$left,
        _ref$top = _ref.top,
        top = _ref$top === undefined ? null : _ref$top,
        _ref$behavior = _ref.behavior,
        behavior = _ref$behavior === undefined ? 'smooth' : _ref$behavior;

    var modalBody = document.querySelector('.modal-body');
    if (modalBody && modalBody.scrollTo) {
        modalBody.scrollTo({ left: left, top: top, behavior: behavior });
    }
};

var modalManager = new _ReactOverlayManager2.default();

var BaseModal = exports.BaseModal = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(BaseModal, _React$PureComponent);

    function BaseModal(props) {
        (0, _classCallCheck3.default)(this, BaseModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call(this, props));

        _this.uid = (0, _uniqueId3.default)('modalBody_');

        _this.handleModalOpened = function () {
            var isAutofocusing = _this.props.isAutofocusing;

            var modalBody = document.getElementById(_this.uid);

            if (modalBody) {
                var inputElt = modalBody.querySelector('button:not(:disabled), input, select');
                if (inputElt && isAutofocusing) {
                    inputElt.focus();
                } else {
                    modalBody.focus();
                }
            }
        };

        if (props.show) {
            props.onOpen();
        }
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
    }

    BaseModal.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.show && !this.props.show) {
            newProps.onOpen();
        }
    };

    BaseModal.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        window.addEventListener('keydown', this.handleKeyPress);
    };

    BaseModal.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress);
    };

    BaseModal.prototype.componentDidMount = function componentDidMount() {
        (0, _defer3.default)(this.handleModalOpened);
    };

    BaseModal.prototype.handleKeyPress = function handleKeyPress(event) {
        var ignoreTarget = ['TEXTAREA', 'BUTTON'].includes(event.target.tagName);
        if (this.props.show && event.keyCode === _AppConstants.KeyCodes.ENTER && !this.props.disableContinue && !ignoreTarget && this.props.onEnterContinue) {
            event.stopPropagation();
            (0, _defer3.default)(this.props.onContinue);
        }
    };

    BaseModal.prototype._renderHeader = function _renderHeader(_ref2) {
        var header = _ref2.header,
            headerIcon = _ref2.headerIcon,
            titleText = _ref2.titleText,
            titleComponent = _ref2.titleComponent,
            closeText = _ref2.closeText,
            onClose = _ref2.onClose,
            isDesktop = _ref2.isDesktop,
            hideClose = _ref2.hideClose,
            disableClose = _ref2.disableClose,
            headerClass = _ref2.headerClass,
            useFlex = _ref2.useFlex,
            modalTitleClass = _ref2.modalTitleClass,
            showCloseIcon = _ref2.showCloseIcon;

        var headerClassName = (0, _classnames3.default)(headerClass, { 'modal-header--flex': useFlex });
        var showCloseBtn = showCloseIcon || !hideClose && !isDesktop;

        if (!header) {
            if (header === false) {
                return null;
            }

            return _react2.default.createElement(
                _Modal2.default.Header,
                { className: headerClassName },
                headerIcon && _react2.default.createElement(
                    'div',
                    { className: 'modal-header__icon pull-left' },
                    headerIcon
                ),
                titleText && _react2.default.createElement(
                    _Page2.default,
                    { title: (0, _I18n.translate)(titleText), goBack: false },
                    _react2.default.createElement(
                        _Modal2.default.Title,
                        { id: 'modalTitle', componentClass: titleComponent, className: modalTitleClass },
                        (0, _I18n.translate)(titleText),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            '. '
                        )
                    )
                ),
                showCloseBtn && _react2.default.createElement(
                    'button',
                    {
                        onClick: onClose,
                        disabled: disableClose,
                        className: 'modal-header__close-button'
                    },
                    _react2.default.createElement(_Icon2.default, { icon: 'close' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        (0, _I18n.translate)(closeText)
                    )
                )
            );
        } else {
            return _react2.default.createElement(
                _Modal2.default.Header,
                { className: headerClassName },
                header
            );
        }
    };

    BaseModal.prototype._renderFooter = function _renderFooter(_ref3) {
        var backText = _ref3.backText,
            showBack = _ref3.showBack,
            onBack = _ref3.onBack,
            disableBack = _ref3.disableBack,
            disableBorderFooter = _ref3.disableBorderFooter,
            disableContinue = _ref3.disableContinue,
            isDesktop = _ref3.isDesktop,
            hideClose = _ref3.hideClose,
            disableClose = _ref3.disableClose,
            continueText = _ref3.continueText,
            continueClassName = _ref3.continueClassName,
            closeText = _ref3.closeText,
            onContinue = _ref3.onContinue,
            onClose = _ref3.onClose,
            hideContinue = _ref3.hideContinue,
            footer = _ref3.footer,
            footerContent = _ref3.footerContent,
            useFlex = _ref3.useFlex,
            _ref3$continueProps = _ref3.continueProps,
            continueProps = _ref3$continueProps === undefined ? {} : _ref3$continueProps;

        var footerClassName = (0, _classnames3.default)({
            'modal-footer--flex': useFlex,
            'modal-footer--no-border': disableBorderFooter || !isDesktop && !footer && hideContinue,
            'modal-footer--no-padding': !isDesktop && !footer && hideContinue
        });

        if (!footer) {
            if (footer === false) {
                return null;
            }

            return _react2.default.createElement(
                _Modal2.default.Footer,
                { className: footerClassName },
                (!hideClose && isDesktop || this.props.showCloseFooterButton) && _react2.default.createElement(
                    _Button2.default,
                    {
                        bsStyle: 'default',
                        onClick: onClose,
                        className: 'close action-btn action-btn--secondary pull-left',
                        disabled: disableClose
                    },
                    (0, _I18n.translate)(closeText)
                ),
                showBack && _react2.default.createElement(
                    _Button2.default,
                    {
                        bsStyle: 'default',
                        onClick: onBack,
                        className: 'close action-btn action-btn--secondary pull-left',
                        disabled: disableBack
                    },
                    (0, _I18n.translate)(backText)
                ),
                footerContent,
                !hideContinue && _react2.default.createElement(
                    _Button2.default,
                    (0, _extends3.default)({
                        bsStyle: 'primary',
                        onClick: onContinue,
                        className: (0, _classnames3.default)("continue action-btn action-btn--primary pull-right", continueClassName),
                        disabled: disableContinue
                    }, continueProps),
                    (0, _I18n.translate)(continueText)
                )
            );
        } else {
            return _react2.default.createElement(
                _Modal2.default.Footer,
                { className: footerClassName },
                footer
            );
        }
    };

    BaseModal.prototype.render = function render() {
        var _classnames;

        var modalDescription = this.props.modalDescription;


        var modalProps = {
            show: this.props.show,
            container: _ReactOverlayManager.modalContainer,
            dialogClassName: (0, _classnames3.default)('otrl-body', this.props.className, (_classnames = {
                'modal--flex': this.props.useFlex,
                'modal--no-header': this.props.header === false
            }, _classnames['modal--variant-' + this.props.variant] = this.props.variant, _classnames)),
            onHide: this.props.onClose,
            animation: false,
            backdrop: this.props.disableBlur ? 'static' : true,
            keyboard: !this.props.disableEscape,
            backdropClassName: this.props.backdropClassName,
            bodyAriaLabel: this.props.bodyAriaLabel,
            manager: modalManager,
            'aria-modal': true,
            'aria-hidden': !this.props.show,
            'aria-labelledby': !this.props.header && this.props.titleText ? 'modalTitle' : null,
            'aria-describedby': modalDescription ? 'modalDescription' : null
        };

        return _react2.default.createElement(
            _Modal2.default,
            (0, _extends3.default)({ 'data-testid': 'base-modal' }, modalProps),
            _react2.default.createElement(_BaseModalTracker2.default, this.props),
            modalDescription && _react2.default.createElement(
                'span',
                { id: 'modalDescription', className: 'sr-only' },
                modalDescription
            ),
            !this.props.hideHeader && this._renderHeader(this.props),
            _react2.default.createElement(
                _Modal2.default.Body,
                { 'aria-label': this.props.bodyAriaLabel, className: (0, _classnames3.default)({ 'modal-body--flex': this.props.useFlex }), onKeyDown: this.props.onKeyDown, id: this.uid, tabIndex: '0' },
                this.props.children
            ),
            this._renderFooter(this.props)
        );
    };

    return BaseModal;
}(_react2.default.PureComponent), _class.propTypes = {
    show: _propTypes2.default.bool,
    bodyAriaLabel: _propTypes2.default.string,
    disableBlur: _propTypes2.default.bool,
    disableBorderFooter: _propTypes2.default.bool,
    disableEscape: _propTypes2.default.bool,
    disableClose: _propTypes2.default.bool,
    disableContinue: _propTypes2.default.bool,
    disableBack: _propTypes2.default.bool,
    showCloseIcon: _propTypes2.default.bool,
    hideClose: _propTypes2.default.bool,
    hideContinue: _propTypes2.default.bool,
    hideHeader: _propTypes2.default.bool,
    showBack: _propTypes2.default.bool,
    isAutofocusing: _propTypes2.default.bool,
    onEnterContinue: _propTypes2.default.bool,
    onOpen: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    onContinue: _propTypes2.default.func,
    onKeyDown: _propTypes2.default.func,
    onBack: _propTypes2.default.func,
    className: _propTypes2.default.string,
    modalDescription: _propTypes2.default.string,
    titleText: _propTypes2.default.string,
    titleComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    closeText: _propTypes2.default.string,
    continueText: _propTypes2.default.string,
    backText: _propTypes2.default.string,
    continueClassName: _propTypes2.default.string,
    children: _propTypes2.default.node,
    header: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
    footer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
    footerContent: _propTypes2.default.object,
    headerClass: _propTypes2.default.string,
    headerIcon: _propTypes2.default.element,
    useFlex: _propTypes2.default.bool,
    backdropClassName: _propTypes2.default.string,
    variant: _propTypes2.default.oneOf(['light']),
    isDesktop: _propTypes2.default.bool,
    modalTitleClass: _propTypes2.default.string,
    showCloseFooterButton: _propTypes2.default.bool,
    continueProps: _propTypes2.default.object
}, _class.defaultProps = {
    show: true,
    disableBlur: false,
    disableBorderFooter: false,
    disableEscape: false,
    disableClose: false,
    disableContinue: false,
    showBack: false,
    hideContinue: false,
    hideHeader: false,
    isAutofocusing: true,
    onEnterContinue: true,
    onOpen: _noop3.default,
    onClose: _noop3.default,
    onContinue: _noop3.default,
    onKeyDown: _noop3.default,
    className: null,
    modalDescription: null,
    titleText: null,
    titleComponent: 'h1',
    closeText: 'button.text.close',
    continueText: 'button.text.continue',
    backText: 'button.text.back',
    header: null,
    headerClass: '',
    headerIcon: null,
    footer: null,
    footerContent: null,
    useFlex: false,
    backdropClassName: null,
    bodyAriaLabel: null,
    variant: null,
    isDesktop: true,
    modalTitleClass: ''
}, _temp);
var BaseModalUnconnected = exports.BaseModalUnconnected = BaseModal;

exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default], _getStateFromStores)(BaseModal);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _escape2 = __webpack_require__(1852);

var _escape3 = _interopRequireDefault(_escape2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(1854);

var _server2 = _interopRequireDefault(_server);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function splitParagraphs(input) {
    var tagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'p';

    var paragraphs = input.split("\n").map(function (line) {
        return '<' + tagName + '>' + line.trim() + '</' + tagName + '>';
    });
    return paragraphs.join("");
}

// What follows is from react-intl adapted to use our dictionary
/*
Copyright 2014 Yahoo Inc.
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.

    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

    * Neither the name of the Yahoo Inc. nor the
      names of its contributors may be used to endorse or promote products
      derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL YAHOO! INC. BE LIABLE FOR ANY
DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
var FormattedHTMLMessage = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FormattedHTMLMessage, _React$PureComponent);

    function FormattedHTMLMessage() {
        (0, _classCallCheck3.default)(this, FormattedHTMLMessage);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    FormattedHTMLMessage.prototype.render = function render() {
        var props = this.props;
        var tagName = props.tagName;
        var message = props.message;
        var onClickHandler = null;

        // Process all the props before they are used as values when formatting
        // the ICU Message string. Since the formatted message will be injected
        // via `innerHTML`, all String-based values need to be HTML-escaped. Any
        // React Elements that are passed as props will be rendered to a static
        // markup string that is presumed to be safe.
        var messageValues = (0, _keys2.default)(props).reduce(function (values, name) {
            var value = props[name];

            if (typeof value === 'string') {
                value = (0, _escape3.default)(value);
            } else if (_react2.default.isValidElement(value)) {
                onClickHandler = value.props.onClick ? value.props.onClick : null;
                value = _server2.default.renderToStaticMarkup(value);
            }

            values[name] = value;
            return values;
        }, {});

        var html = (0, _I18n.translate)(message, messageValues);
        if (this.props.splitParagraphs) {
            html = splitParagraphs(html, this.props.paragraphTagName);
        }

        // Since the message presumably has HTML in it, we need to set
        // `innerHTML` in order for it to be rendered and not escaped by React.
        // To be safe, all string prop values were escaped before formatting the
        // message. It is assumed that the message is not UGC, and came from
        // the developer making it more like a template.
        //
        // Note: There's a perf impact of using this component since there's no
        // way for React to do its virtual DOM diffing.
        return _react2.default.createElement(tagName, {
            className: this.props.className,
            onClick: onClickHandler,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    };

    return FormattedHTMLMessage;
}(_react2.default.PureComponent), _class.propTypes = {
    tagName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    message: _propTypes2.default.string.isRequired,
    splitParagraphs: _propTypes2.default.bool,
    paragraphTagName: _propTypes2.default.string
}, _class.defaultProps = {
    tagName: 'span',
    className: null,
    splitParagraphs: false,
    paragraphTagName: 'p'
}, _temp);
exports.default = FormattedHTMLMessage;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useCurrentUser = exports.UserStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _debounce2 = __webpack_require__(277);

var _debounce3 = _interopRequireDefault(_debounce2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _momentTimezone = __webpack_require__(235);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _Cookie = __webpack_require__(258);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

var _hookUtils = __webpack_require__(234);

var _hookUtils2 = _interopRequireDefault(_hookUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentUser = null;
var lastRefreshed = null;
var autoLogoutWarn = false;
var autoLogout = false;

var USER_COOKIE_KEY = 'Customer-Token';
var LAST_USER_ACTIVITY_KEY = 'last-user-activity';

var UserStore = exports.UserStore = function (_BaseStore) {
    (0, _inherits3.default)(UserStore, _BaseStore);

    function UserStore() {
        (0, _classCallCheck3.default)(this, UserStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, _BaseStore.call(this));

        _this._setInactivityWarning = (0, _debounce3.default)(function () {
            if (_this.getCurrent().isLoggedIn()) {
                autoLogoutWarn = true;
                _this.emitChange();
            }
        }, _config2.default.get('autoLogoutWarningMinutes') * 60 * 1000);
        _this._setInactivityLogout = (0, _debounce3.default)(function () {
            if (_this.getCurrent().isLoggedIn()) {
                autoLogout = true;
                _this.emitChange();
            }
        }, _config2.default.get('autoLogoutMinutes') * 60 * 1000);

        (0, _defer3.default)(function () {
            return _this._initialiseAutoLogout();
        });
        return _this;
    }

    UserStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.AUTH_LOADED] = this.handleAuthUpdated, _ref[_AppConstants.ActionTypes.USER_UPDATED] = this.handleUserUpdated, _ref[_AppConstants.ActionTypes.AUTH_REFRESH_STARTED] = this.handleAuthRefreshStarted, _ref[_AppConstants.ActionTypes.AUTH_REFRESHED] = this.handleAuthUpdated, _ref[_AppConstants.ActionTypes.LOGGED_IN] = this.handleUserUpdated, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleLoggedOut, _ref[_AppConstants.ActionTypes.REGISTRATION_SUCCESS] = this.handleUserUpdated, _ref[_AppConstants.ActionTypes.REGISTRATION_FAILED] = this.handleRegistrationFailed, _ref[_AppConstants.ActionTypes.REGISTRATION_STARTED] = this.handleRegistrationStarted, _ref[_AppConstants.ActionTypes.SMARTCARD_REGISTERED] = this.handleSmartcardRegistered, _ref[_AppConstants.ActionTypes.USER_OCDR_SUBSCRIBE_SUCCESS] = this.handleOneClickDelayRepayOptIn, _ref[_AppConstants.ActionTypes.USER_OCDR_UNSUBSCRIBE_SUCCESS] = this.handleOneClickDelayRepayOptOut, _ref[_AppConstants.ActionTypes.SMARTCARD_LINKED] = this.handleSmartcardRegistered, _ref[_AppConstants.ActionTypes.ACTIVITY_DETECTED] = this.updateLastUserActivity, _ref[_AppConstants.ActionTypes.ADDRESSES_LOADED] = this.handleAddressesLoaded, _ref[_AppConstants.ActionTypes.ADDRESS_CREATED] = this.handleAddressCreated, _ref[_AppConstants.ActionTypes.ADDRESS_DELETED] = this.handleAddressDeleted, _ref[_AppConstants.ActionTypes.ADDRESS_UPDATED] = this.handleAddressUpdated, _ref[_AppConstants.ActionTypes.USER_PREFERENCES_UPDATED] = this.handlePreferencesUpdated, _ref[_AppConstants.ActionTypes.USER_PREFERENCES_FETCHED] = this.handlePreferencesFetched, _ref[_AppConstants.ActionTypes.CHECK_USER_COOKIE] = this.checkUserCookie, _ref;
    };

    UserStore.prototype.getCurrent = function getCurrent() {
        if (!currentUser) {
            currentUser = _Cookie2.default.objectFromCookie(USER_COOKIE_KEY, _User2.default) || new _User2.default();
        }
        return currentUser;
    };

    UserStore.prototype.setCurrent = function setCurrent(user) {
        if (!user) {
            return false;
        }
        var userWithoutAddresses = user.setIn(['customer', 'addresses'], new _immutable.List());
        currentUser = user;
        var authToken = user.authToken;
        if (authToken && user.id) {
            if (_InAppStore2.default.isInApp()) {
                var expires = (0, _TrainTime2.default)(authToken.expires).format();
                _Cookie2.default.objectToCookie(USER_COOKIE_KEY, userWithoutAddresses, expires);
            } else {
                _Cookie2.default.objectToCookie(USER_COOKIE_KEY, userWithoutAddresses);
            }
        }
        this.emitChange();

        return true;
    };

    UserStore.prototype.getIsRegistering = function getIsRegistering() {
        return this.isRegistering;
    };

    UserStore.prototype.setIsRegistering = function setIsRegistering(isRegistering) {
        this.isRegistering = isRegistering;
        this.emitChange();
    };

    UserStore.prototype.getIsRefreshingAuthToken = function getIsRefreshingAuthToken() {
        return this.isRefreshingAuthToken;
    };

    UserStore.prototype.setIsRefreshingAuthToken = function setIsRefreshingAuthToken(isRefreshingAuthToken) {
        this.isRefreshingAuthToken = isRefreshingAuthToken;
        this.emitChange();
    };

    UserStore.prototype.checkUserCookie = function checkUserCookie() {
        if (_Cookie2.default.objectFromCookie(USER_COOKIE_KEY, _User2.default)) {
            location.reload();
        }
    };

    UserStore.prototype.handleUserUpdated = function handleUserUpdated(_ref2) {
        var user = _ref2.user;

        lastRefreshed = (0, _TrainTime2.default)();
        this.setIsRegistering(false);
        this.setCurrent(user);
        this.updateLastUserActivity();
    };

    UserStore.prototype.handlePreferencesUpdated = function handlePreferencesUpdated(_ref3) {
        var preferences = _ref3.preferences,
            isOver16 = _ref3.isOver16,
            telephoneNumber = _ref3.telephoneNumber;

        var updated = this.getCurrent().setPreferences(preferences).setIsOver16(isOver16).setTelephoneNumber(telephoneNumber);
        this.setCurrent(updated);
    };

    UserStore.prototype.handlePreferencesFetched = function handlePreferencesFetched(_ref4) {
        var preferences = _ref4.preferences;

        this.setCurrent(this.getCurrent().setPreferences(preferences));
    };

    UserStore.prototype.handleAuthRefreshStarted = function handleAuthRefreshStarted() {
        this.setIsRefreshingAuthToken(true);
    };

    UserStore.prototype.handleAuthUpdated = function handleAuthUpdated(_ref5) {
        var token = _ref5.token;

        var user = this.getCurrent().setAuthToken(token);
        this.handleUserUpdated({ user: user });
        this.setIsRefreshingAuthToken(false);
    };

    UserStore.prototype.handleLoggedOut = function handleLoggedOut() {
        currentUser = null;
        lastRefreshed = null;
        _Cookie2.default.clear(USER_COOKIE_KEY);
        this._resetAutoLogoutFlags();
        this.setIsRefreshingAuthToken(false);
        this.emitChange();
    };

    UserStore.prototype.handleSmartcardRegistered = function handleSmartcardRegistered() {
        this.setCurrent(this.getCurrent().setHasRegisteredSmartcard(true));
    };

    UserStore.prototype.handleOneClickDelayRepayOptIn = function handleOneClickDelayRepayOptIn() {
        this.setCurrent(this.getCurrent().setOneClickDelayRepayOptedIn(true));
    };

    UserStore.prototype.handleOneClickDelayRepayOptOut = function handleOneClickDelayRepayOptOut() {
        this.setCurrent(this.getCurrent().setOneClickDelayRepayOptedIn(false));
    };

    UserStore.prototype.shouldBeRefreshed = function shouldBeRefreshed() {
        var user = this.getCurrent();
        if (user.isLoggedIn()) {
            var today = (0, _TrainTime2.default)().startOf('day');
            return !lastRefreshed || today.isAfter(lastRefreshed);
        }
        return false;
    };

    UserStore.prototype.shouldAutoLogout = function shouldAutoLogout() {
        return autoLogout && !_InAppStore2.default.disableAutoLogout() && _config2.default.get('sessionShort');
    };

    UserStore.prototype.shouldAutoLogoutWarn = function shouldAutoLogoutWarn() {
        return autoLogoutWarn && !_InAppStore2.default.disableAutoLogout() && _config2.default.get('sessionShort');
    };

    UserStore.prototype.updateLastUserActivity = function updateLastUserActivity() {
        if (this.getCurrent().isLoggedIn()) {
            var expires = (0, _momentTimezone2.default)().add(_config2.default.get('autoLogoutMinutes'), 'minutes');
            _Cookie2.default.objectToCookie(LAST_USER_ACTIVITY_KEY, (0, _momentTimezone2.default)().format(), expires.format());

            if (autoLogoutWarn) {
                autoLogoutWarn = false;
                this.emitChange();
            }

            this._setInactivityWarning();
            this._setInactivityLogout();
        }
    };

    UserStore.prototype._initialiseAutoLogout = function _initialiseAutoLogout() {
        if (this.getCurrent().isLoggedIn()) {
            var lastActivityStored = _Cookie2.default.objectFromCookie(LAST_USER_ACTIVITY_KEY);
            if (!lastActivityStored) {
                autoLogout = true;
            }
        }

        if (!autoLogout) {
            this.updateLastUserActivity();
        }
    };

    UserStore.prototype._resetAutoLogoutFlags = function _resetAutoLogoutFlags() {
        this._setInactivityLogout.cancel();
        this._setInactivityWarning.cancel();
        _Cookie2.default.clear(LAST_USER_ACTIVITY_KEY);
        autoLogoutWarn = false;
        autoLogout = false;
    };

    UserStore.prototype.handleAddressesLoaded = function handleAddressesLoaded(_ref6) {
        var addresses = _ref6.addresses;

        this.setCurrent(this.getCurrent().setAddresses(addresses));
    };

    UserStore.prototype.handleAddressCreated = function handleAddressCreated(_ref7) {
        var address = _ref7.address;

        var addresses = this.getCurrent().addresses.push(address);
        this.setCurrent(this.getCurrent().setAddresses(addresses));
    };

    UserStore.prototype.handleAddressDeleted = function handleAddressDeleted(_ref8) {
        var address = _ref8.address;

        var addresses = this.getCurrent().addresses;
        var index = addresses.indexOf(address);
        this.setCurrent(this.getCurrent().setAddresses(addresses.delete(index)));
    };

    UserStore.prototype.handleAddressUpdated = function handleAddressUpdated(_ref9) {
        var updatedAddress = _ref9.updatedAddress;

        var addresses = this.getCurrent().addresses;
        var index = addresses.findIndex(function (x) {
            return x.id === updatedAddress.id;
        });
        this.setCurrent(this.getCurrent().setAddresses(addresses.set(index, updatedAddress)));
    };

    UserStore.prototype.handleRegistrationStarted = function handleRegistrationStarted() {
        this.setIsRegistering(true);
    };

    UserStore.prototype.handleRegistrationFailed = function handleRegistrationFailed() {
        this.setIsRegistering(false);
    };

    return UserStore;
}(_BaseStore3.default);

var storeInstance = new UserStore();

/**
 * Hook to access the current logged-in user
 * @returns {User}
 */
var useCurrentUser = exports.useCurrentUser = (0, _hookUtils2.default)(function _useCurrentUser() {
    var user = (0, _useStoreState2.default)(storeInstance, storeInstance.getCurrent);
    return user && user.isFullyLoaded() ? user : null;
}, 'useCurrentUser');

exports.default = storeInstance;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var propTypes = {
  componentClass: _elementType.default,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: _propTypes.default.number,

  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: _propTypes.default.number,

  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: _propTypes.default.number,

  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: _propTypes.default.number,

  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: _propTypes.default.bool,

  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: _propTypes.default.bool,

  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: _propTypes.default.bool,

  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: _propTypes.default.bool,

  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: _propTypes.default.number,

  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: _propTypes.default.number,

  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: _propTypes.default.number,

  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: _propTypes.default.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: _propTypes.default.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: _propTypes.default.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: _propTypes.default.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: _propTypes.default.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: _propTypes.default.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: _propTypes.default.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: _propTypes.default.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: _propTypes.default.number
};
var defaultProps = {
  componentClass: 'div'
};

var Col =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Col, _React$Component);

  function Col() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Col.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = "" + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push((0, _bootstrapUtils.prefix)(bsProps, "" + size + modifier + "-" + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');
      var hiddenPropName = size + "Hidden";

      if (elementProps[hiddenPropName]) {
        classes.push("hidden-" + size);
      }

      delete elementProps[hiddenPropName];
    });

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Col;
}(_react.default.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('col', Col);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends3 = __webpack_require__(13);

var _extends4 = _interopRequireDefault(_extends3);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _keys2 = __webpack_require__(127);

var _keys3 = _interopRequireDefault(_keys2);

var _zipObject2 = __webpack_require__(204);

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

exports.getValues = getValues;

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getValues(obj) {
    var values = obj.toJS();
    if (typeof obj.getComputedValues === 'function') {
        (0, _assign2.default)(values, obj.getComputedValues());
    }
    return values;
}

function cleanErrorMessage(message) {
    // Joi adds "someFieldName" at the start - we strip it out
    return (0, _isString3.default)(message) ? message.replace(/^"[\S]+"\s/, '') : message;
}

var ValidationMixin = {
    isComplete: function isComplete() {
        var schemaData = getValues(this);
        return !this.validateData(schemaData, this.getSchema());
    },
    isFieldValid: function isFieldValid(field, additionalValues, additionalSchemaFields) {
        var _validateField = this.validateField(field, additionalValues, additionalSchemaFields),
            error = _validateField.error; // you may want to override the stored value to check an arbitrary value against the field's schema

        return error === null;
    },
    validate: function validate() {
        return _joi2.default.validate(getValues(this), this.getSchema(), { abortEarly: false });
    },
    validateField: function validateField(field) {
        var _this = this;

        var additionalValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var additionalSchemaFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var values = this.toJS();

        if (values && typeof values[field] !== 'undefined') {
            var _extends2;

            var schema = _assign2.default.apply(Object, [field].concat(additionalSchemaFields).map(function (name) {
                var _ref;

                return _ref = {}, _ref[name] = _this.getSchema()[name], _ref;
            }));

            return _joi2.default.validate((0, _extends4.default)((_extends2 = {}, _extends2[field] = values[field], _extends2), additionalValues), schema);
        } else {
            throw 'The validateField failed because "' + field + '" does not exist in the Record: ' + (0, _stringify2.default)(values, null, 2) + '.';
        }
    },
    getValidationSummary: function getValidationSummary() {
        var values = getValues(this);
        var fields = (0, _zipObject3.default)((0, _keys3.default)(values));
        var errors = this.validateData(values, this.getSchema(), { abortEarly: false });
        var errorDetails = errors ? errors.details : [];

        return errorDetails.reduce(function (acc, detail) {
            acc[detail.path] = cleanErrorMessage(detail.message);
            return acc;
        }, fields);
    },
    getValidationSummaryArray: function getValidationSummaryArray() {
        return (0, _compact3.default)((0, _values3.default)(this.getValidationSummary()));
    },
    getError: function getError(field) {
        return this.getValidationSummary()[field];
    },
    validateData: function validateData(value, schema, options) {
        options = (0, _assign2.default)({ allowUnknown: true }, options);

        var _joi$validate = _joi2.default.validate(value, schema, options),
            error = _joi$validate.error;

        return error;
    }
};

exports.default = ValidationMixin;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = connectToStores;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Exports a higher-order component that connects the component to stores.
 * This higher-order component is most easily used as an ES7 decorator.
 * Decorators are just syntactic sugar over wrapping class in a function call.
 *
 * adapted from https://github.com/gaearon/flux-react-router-example
 */
function connectToStores(stores, getState) {
    return function (DecoratedComponent) {
        var _class, _temp;

        var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

        return _temp = _class = function (_React$Component) {
            (0, _inherits3.default)(StoreConnector, _React$Component);

            StoreConnector.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
                return getState(props);
            };

            function StoreConnector() {
                (0, _classCallCheck3.default)(this, StoreConnector);

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

                _this.state = getState(_this.props) || {};

                _this._handleStoresChanged = function () {
                    _this.setState(getState(_this.props));
                };

                stores.forEach(function (store) {
                    return store.addChangeListener(_this._handleStoresChanged);
                });
                return _this;
            }

            StoreConnector.prototype.componentWillUnmount = function componentWillUnmount() {
                var _this2 = this;

                stores.forEach(function (store) {
                    return store.removeChangeListener(_this2._handleStoresChanged);
                });
            };

            StoreConnector.prototype.render = function render() {
                return _react2.default.createElement(DecoratedComponent, (0, _extends3.default)({}, this.props, this.state));
            };

            return StoreConnector;
        }(_react2.default.Component), _class.displayName = 'connectToStores(' + displayName + ')', _temp;
    };
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reduce2 = __webpack_require__(219);

var _reduce3 = _interopRequireDefault(_reduce2);

exports.logActionHandler = logActionHandler;

var _flux = __webpack_require__(1504);

var _Immutable = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _flux.Dispatcher();
function logActionHandler(payload) {
    /* eslint-disable no-console */
    if (!payload.actionType) {
        console.warn('Invalid action type dispatched');
    } else {
        if (console.groupCollapsed) {
            console.groupCollapsed('%c Dispatched: ' + payload.actionType, 'color: #bada55');
            console.log('Original: ', payload);
            var readablePayload = (0, _reduce3.default)(payload, function (acc, value, key) {
                acc[key] = (0, _Immutable.toJS)(value);
                return acc;
            }, {});
            console.log('Readable: ', readablePayload);
            console.trace();
            console.groupEnd();
        }
    }
    /* eslint-enable no-console */
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    nlc: null,
    crs: null,
    name: null,
    categories: new _immutable.List(),
    latitude: null,
    longitude: null,
    validity: new _immutable.Map(),
    onwardTaxiBookingAvailable: false,
    gazetteer: null,
    facilities: null,
    weeklyCapAvailable: false,
    accessibilityData: new _immutable.Map()
};

var Station = function (_record) {
    (0, _inherits3.default)(Station, _record);

    function Station() {
        (0, _classCallCheck3.default)(this, Station);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Station.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Station, json, {
            id: json.id,
            nlc: _LinkMapper.resolve.with(String),
            crs: _LinkMapper.resolve.with(String),
            name: _LinkMapper.resolve.with(String),
            categories: _LinkMapper.resolveAll.with(String),
            latitude: _LinkMapper.resolve.with(Number),
            longitude: _LinkMapper.resolve.with(Number),
            validity: _LinkMapper.resolve.with(_immutable.Map),
            onwardTaxiBookingAvailable: _LinkMapper.resolve.with(Boolean),
            gazetteer: _LinkMapper.resolve.with(_immutable2.default.fromJS),
            facilities: json.facilities,
            weeklyCapAvailable: _LinkMapper.resolve.with(Boolean),
            accessibilityData: _LinkMapper.resolve.with(_immutable.Map)
        });
    };

    Station.prototype.getAccessibilityData = function getAccessibilityData() {
        return this.get('accessibilityData');
    };

    Station.prototype.getName = function getName() {
        return this.get('name');
    };

    Station.prototype.getCrs = function getCrs() {
        return this.get('crs');
    };

    Station.prototype.isTravelcard = function isTravelcard() {
        return ["0034", "0035"].includes(this.nlc);
    };

    Station.prototype.isLondonStation = function isLondonStation() {
        return this.gazetteer && this.gazetteer.get('londonZones', new _immutable.List()).size > 0;
    };

    Station.prototype.isLondonTerminals = function isLondonTerminals() {
        return this.nlc === "1072";
    };

    Station.prototype.isEmpty = function isEmpty() {
        return this.nlc === defaults.nlc;
    };

    Station.prototype.getLatLng = function getLatLng() {
        return { lat: this.latitude, lng: this.longitude };
    };

    Station.prototype.isWithinGoldcardArea = function isWithinGoldcardArea() {
        return this.gazetteer && this.gazetteer.get('withinGoldcardArea');
    };

    Station.prototype.isGroupStation = function isGroupStation() {
        return !this.getCrs() && this.categories.includes('NationalRail');
    };

    return Station;
}((0, _immutable.Record)(defaults));

exports.default = Station;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(794),
    baseRest = __webpack_require__(203);

/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = baseRest(function(func, args) {
  return baseDelay(func, 1, args);
});

module.exports = defer;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Row, _React$Component);

  function Row() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Row;
}(_react.default.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('row', Row);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _isNumber2 = __webpack_require__(651);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
    required: function required() {
        var requiredMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'alertmessage.required';
        var emptyMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'alertmessage.empty';

        return _joi2.default.any().invalid(null, '').required().options({
            language: {
                any: {
                    invalid: (0, _I18n.translate)(requiredMessage),
                    required: (0, _I18n.translate)(requiredMessage),
                    empty: (0, _I18n.translate)(emptyMessage)
                }
            }
        });
    },
    optional: function optional() {
        return _joi2.default.any().optional();
    },
    name: function name() {
        var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 19;

        return _joi2.default.string().regex(_AppConstants.Validation.lettersAndSpaces).trim().required().min(min).max(max).options({
            language: {
                any: {
                    required: (0, _I18n.translate)('alertmessage.required'),
                    empty: (0, _I18n.translate)('alertmessage.empty')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.string.min', { num: min }),
                    min: (0, _I18n.translate)('alertmessage.string.min', { num: min }),
                    max: (0, _I18n.translate)('alertmessage.string.max', { num: max }),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badName')
                    }
                }
            }
        });
    },
    requiredString: function requiredString() {
        var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var max = arguments[1];
        var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'alertmessage.required';

        var validator = _joi2.default.string().trim().required().min(min);
        var options = {
            language: {
                any: {
                    required: (0, _I18n.translate)(msg),
                    empty: (0, _I18n.translate)('alertmessage.empty')
                },
                string: {
                    base: (0, _I18n.translate)(msg),
                    min: min === 1 ? (0, _I18n.translate)(msg) : (0, _I18n.translate)('alertmessage.string.min', { num: min })
                }
            }
        };

        if ((0, _isNumber3.default)(max)) {
            validator = validator.max(max);
            options.language.string.max = (0, _I18n.translate)('alertmessage.string.max', { num: max });
        }

        return validator.options(options);
    },
    voucherAmount: function voucherAmount(maxAmount) {
        return _joi2.default.number().min(0).max(maxAmount).required().options({
            language: {
                number: {
                    base: (0, _I18n.translate)('voucher.error.number.base'),
                    min: (0, _I18n.translate)('voucher.error.number.min'),
                    max: (0, _I18n.translate)('voucher.error.number.max', { maxAmount: maxAmount.toFixed(2) })
                }
            }
        });
    },
    price: function price() {
        return _joi2.default.number().min(0).required().options({
            language: {
                number: {
                    base: (0, _I18n.translate)('alertmessage.price')
                }
            }
        });
    },
    cardHolderName: function cardHolderName() {
        return _joi2.default.string().regex(_AppConstants.Validation.lettersAndSpaces).regex(_AppConstants.Validation.cardHolderName).trim().min(3).required().options({
            language: {
                any: {
                    required: (0, _I18n.translate)('alertmessage.badCardHolder'),
                    empty: (0, _I18n.translate)('alertmessage.badCardHolder')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badCardHolder'),
                    min: (0, _I18n.translate)('alertmessage.badCardHolder'),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badCardHolder')
                    }
                }
            }
        });
    },
    photocardHolder: function photocardHolder() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _I18n.translate)('alertmessage.badPhotocardFirstName');

        return _joi2.default.string().regex(_AppConstants.Validation.photocardHolder).trim().required().options({
            language: {
                any: {
                    required: message,
                    empty: message
                },
                string: {
                    base: message,
                    min: message,
                    regex: {
                        base: message
                    }
                }
            }
        });
    },
    cardNumber: function cardNumber() {
        return _joi2.default.string().trim().creditCard().required().options({
            language: {
                string: {
                    base: (0, _I18n.translate)('alertmessage.badCardNumber'),
                    creditCard: (0, _I18n.translate)('alertmessage.badCardNumber')
                }
            }
        });
    },
    isrn: function isrn() {
        return _joi2.default.string().trim().regex(_AppConstants.Validation.keySmartcardNumber).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.smartcard', { fieldName: (0, _I18n.translate)('account.smartcard.text.label') })
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.smartcard', { fieldName: (0, _I18n.translate)('account.smartcard.text.label') }),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.smartcard', { fieldName: (0, _I18n.translate)('account.smartcard.text.label') })
                    }
                }
            }
        });
    },
    expiryMonth: function expiryMonth() {
        return _joi2.default.number().min(1).max(12).required().options({
            language: {
                number: {
                    base: (0, _I18n.translate)('alertmessage.badExpiryMonth'),
                    min: (0, _I18n.translate)('alertmessage.badExpiryMonth'),
                    max: (0, _I18n.translate)('alertmessage.badExpiryMonth')
                }
            }
        });
    },
    expiryYear: function expiryYear() {
        return _joi2.default.number().min((0, _TrainTime2.default)().year()).required().options({
            language: {
                number: {
                    base: (0, _I18n.translate)('alertmessage.badExpiryYear'),
                    min: (0, _I18n.translate)('alertmessage.badExpiryYear'),
                    max: (0, _I18n.translate)('alertmessage.badExpiryYear')
                }
            }
        });
    },
    isAdult: function isAdult() {
        return _joi2.default.boolean().required().options({
            language: {
                boolean: {
                    base: 'test'
                }
            }
        });
    },
    cv2: function cv2() {
        return _joi2.default.string().trim().regex(_AppConstants.Validation.cv2).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badCvv')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badCvv'),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badCvv')
                    }
                }
            }
        });
    },
    addressLine: function addressLine() {
        return _joi2.default.string().trim().min(1).max(50).options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badAddressLine')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badAddressLine'),
                    min: (0, _I18n.translate)('alertmessage.badAddressLine'),
                    max: (0, _I18n.translate)('alertmessage.string.max', { num: 50 })
                }
            }
        });
    },
    textMaxLength: function textMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

        return _joi2.default.string().trim().max(maxLength).allow([null, '']).options({
            language: {
                string: {
                    base: (0, _I18n.translate)('alertmessage.string.max', { num: maxLength }),
                    max: (0, _I18n.translate)('alertmessage.string.max', { num: maxLength })
                }
            }
        });
    },
    townCity: function townCity() {
        return _joi2.default.string().trim().min(2).max(50).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badTownCity')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badTownCity'),
                    min: (0, _I18n.translate)('alertmessage.badTownCity'),
                    max: (0, _I18n.translate)('alertmessage.string.max', { num: 50 })
                }
            }
        });
    },
    postcode: function postcode() {
        return _joi2.default.string().trim().regex(_AppConstants.Validation.postcode).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badPostCode')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badPostCode'),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badPostCode')
                    }
                }
            }
        });
    },
    country: function country() {
        return _joi2.default.string().trim().regex(_AppConstants.Validation.countryCode).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badCountry')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badCountry'),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badCountry')
                    }
                }
            }
        });
    },
    email: function email() {
        return _joi2.default.string().trim().email({ minDomainAtoms: 2 }).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badEmail')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badEmail'),
                    email: (0, _I18n.translate)('alertmessage.badEmail')
                }
            }
        });
    },
    confirmEmail: function confirmEmail() {
        var brand = _config2.default.get('brand');
        var isGTR = (0, _values3.default)(_AppConstants.Brands).includes(brand);

        var baseValidator = _joi2.default.string().trim().valid(_joi2.default.ref('email')).options({
            language: {
                any: {
                    allowOnly: (0, _I18n.translate)('alertmessage.fieldsNoMatch', { field: 'Email' }),
                    empty: (0, _I18n.translate)('alertmessage.required')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.required')
                }
            }
        });

        if (isGTR) {
            return baseValidator.required();
        } else {
            return baseValidator.optional();
        }
    },
    phone: function phone() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

        return _joi2.default.string().trim().regex(_AppConstants.Validation.telephone).max(maxLength).options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badContactNumber')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badContactNumber'),
                    max: (0, _I18n.translate)('alertmessage.string.max', { num: maxLength }),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badContactNumber')
                    }
                }
            }
        });
    },
    passwordEntry: function passwordEntry() {
        return this.requiredString().options({
            language: {
                string: {
                    base: (0, _I18n.translate)('alertmessage.login.badPassword'),
                    min: (0, _I18n.translate)('alertmessage.login.badPassword')
                }
            }
        });
    },
    passwordCreate: function passwordCreate() {
        return _joi2.default.string().trim().min(_config2.default.get('minPasswordLength')).regex(/[a-z]/, 'lowercase characters').regex(/[A-Z]/, 'uppercase characters').regex(/\d/, 'digits').options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badPassword')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badPassword'),
                    min: (0, _I18n.translate)('alertmessage.badPassword.tooShort'),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badPassword'),
                        // cannot put the following into the dictionary
                        // the installed version of intl-messageformat (2.x) does not support escaping
                        // it is supported in 8.x
                        name: 'One or more {{name}} required'
                    }
                }
            }
        });
    },
    title: function title() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _I18n.translate)('alertmessage.choose');

        return _joi2.default.any().valid(_config2.default.get('customerTitles')).options({
            language: {
                any: {
                    allowOnly: message
                }
            }
        });
    },
    regex: function regex(_regex) {
        var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _I18n.translate)('alertmessage.regex.fieldName');
        var alertmessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'alertmessage.regex';

        return _joi2.default.string().regex(_regex).options({
            language: {
                any: {
                    required: (0, _I18n.translate)('alertmessage.required')
                },
                string: {
                    base: (0, _I18n.translate)(alertmessage, { fieldName: fieldName }),
                    regex: {
                        base: (0, _I18n.translate)(alertmessage, { fieldName: fieldName })
                    }
                }
            }
        });
    },
    allowOnly: function allowOnly(list) {
        return _joi2.default.string().only(list).options({
            language: {
                any: {
                    allowOnly: (0, _I18n.translate)('alertmessage.choose'),
                    required: (0, _I18n.translate)('alertmessage.required'),
                    empty: (0, _I18n.translate)('alertmessage.required')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.required')
                }
            }
        });
    },


    true: function _true() {
        return validators.boolean(true, 'alertmessage.required');
    },

    boolean: function boolean() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'alertmessage.required';

        return _joi2.default.boolean().only([!!value]).options({
            language: {
                any: {
                    allowOnly: (0, _I18n.translate)(message),
                    required: (0, _I18n.translate)(message),
                    empty: (0, _I18n.translate)(message)
                },
                boolean: {
                    base: (0, _I18n.translate)(message)
                }
            }
        });
    },


    isOver16: function isOver16() {
        return _joi2.default.boolean().only(true).options({
            language: {
                any: {
                    allowOnly: (0, _I18n.translate)('alertmessage.date.over16'),
                    required: (0, _I18n.translate)('alertmessage.date.over16'),
                    empty: (0, _I18n.translate)('alertmessage.date.over16')
                },
                boolean: {
                    base: (0, _I18n.translate)('alertmessage.date.over16')
                }
            }
        });
    },

    sortCode: function sortCode() {
        return validators.regex(_AppConstants.Validation.sortCode).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badSortCode')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badSortCode'),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badSortCode')
                    }
                }
            }
        });
    },

    accountNumber: function accountNumber() {
        return validators.regex(_AppConstants.Validation.accountNumber).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badAccountNumber')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badAccountNumber'),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badAccountNumber')
                    }
                }
            }
        });
    },

    railcardsNumber: function railcardsNumber(passengersNumberRef) {
        return _joi2.default.number().min(0).max(_joi2.default.ref(passengersNumberRef)).options({
            language: {
                number: {
                    max: (0, _I18n.translate)('alertmessage.form.moreRailcardsThanPassengers')
                }
            }
        });
    },
    collectionLocation: function collectionLocation() {
        var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return required ? _joi2.default.any().invalid(null, '').required().options({
            language: {
                any: {
                    invalid: (0, _I18n.translate)('alertmessage.required'),
                    required: (0, _I18n.translate)('alertmessage.required'),
                    empty: (0, _I18n.translate)('alertmessage.empty')
                }
            }
        }) : _joi2.default.any().optional();
    }
};

exports.default = validators;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1410), __esModule: true };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PureRenderComponent = function (_React$PureComponent) {
  (0, _inherits3.default)(PureRenderComponent, _React$PureComponent);

  function PureRenderComponent() {
    (0, _classCallCheck3.default)(this, PureRenderComponent);
    return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
  }

  return PureRenderComponent;
}(_react2.default.PureComponent);

exports.default = PureRenderComponent;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _values = _interopRequireDefault(__webpack_require__(125));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var propTypes = {
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  block: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  componentClass: _elementType.default,
  href: _propTypes.default.string,

  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: _propTypes.default.oneOf(['button', 'reset', 'submit'])
};
var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.renderAnchor = function renderAnchor(elementProps, className) {
    return _react.default.createElement(_SafeAnchor.default, (0, _extends3.default)({}, elementProps, {
      className: (0, _classnames.default)(className, elementProps.disabled && 'disabled')
    }));
  };

  _proto.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["componentClass"]);
    var Component = componentClass || 'button';
    return _react.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "block", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
      active: active
    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
    var fullClassName = (0, _classnames.default)(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(_react.default.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1405);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(313);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _includes2 = __webpack_require__(535);

var _includes3 = _interopRequireDefault(_includes2);

var _momentTimezone = __webpack_require__(235);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Immutable = __webpack_require__(54);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _Ticket = __webpack_require__(1121);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _DeliveryOption = __webpack_require__(443);

var _DeliveryOption2 = _interopRequireDefault(_DeliveryOption);

var _AppConstants = __webpack_require__(6);

var _Fulfilment = __webpack_require__(349);

var _Fulfilment2 = _interopRequireDefault(_Fulfilment);

var _Payments = __webpack_require__(1686);

var _Payments2 = _interopRequireDefault(_Payments);

var _Sundry = __webpack_require__(1689);

var _Sundry2 = _interopRequireDefault(_Sundry);

var _OrderDiscount = __webpack_require__(1690);

var _OrderDiscount2 = _interopRequireDefault(_OrderDiscount);

var _DelayRepayOrderHandoff = __webpack_require__(1691);

var _LinkMapper = __webpack_require__(8);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _fpUtils = __webpack_require__(637);

var _fpUtils2 = _interopRequireDefault(_fpUtils);

var _Ticket3 = __webpack_require__(1693);

var _Ticket4 = _interopRequireDefault(_Ticket3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Order = new _immutable.Record({
    id: null,
    email: null,
    brand: null,
    charity: null,
    customerId: null,
    customerName: null,
    expiry: null,
    trips: new _immutable.List(),
    delivery: new _Fulfilment2.default(),
    collectionReference: null,
    amendedTickets: new _immutable.List(),
    changeoverTickets: new _immutable.List(),
    state: null,
    discount: new _OrderDiscount2.default(),
    totalPrice: null,
    leftToPay: null,
    amendPriceDiff: null,
    nlc: null,
    creationDate: null,
    purchaseDate: null,
    lastUpdated: null,
    availableDeliveryOptions: new _immutable.List(),
    payments: null,
    changeoverPayments: null,
    telephoneNumber: null,
    isPartialRefund: false,
    isFullRefund: false,
    isChangeoverRefund: false,
    alreadyPaidForRefund: false,
    refundCanBeAttemptedOnline: false,
    refundCanBeAttemptedOffline: false,
    refundsLocked: false,
    sundries: new _immutable.List(),
    isInterop: false,
    channel: null,
    totalRewardPoints: null,
    rewardPointUid: null,
    rewardName: null,
    promotionalDiscount: null
});

(0, _assign2.default)(Order.prototype, {
    isGuestOrder: function isGuestOrder() {
        return !this.customerId;
    },
    isSmartcard: function isSmartcard() {
        return !!this.trips.size && this.trips.some(function (trip) {
            return trip.isSmartcard();
        });
    },
    isMultiSmartcard: function isMultiSmartcard() {
        return this.isSmartcard() && (this.trips.size > 1 || this.getTickets().size > 1);
    },
    isSmartcardWithProductDelivery: function isSmartcardWithProductDelivery() {
        if (this.isSmartcard()) {
            var smartTrip = this.trips.find(function (trip) {
                return trip.isSmartcard();
            });
            return smartTrip.getTickets().some(function (ticket) {
                return !ticket.getSmartcardNumber();
            });
        }
        return false;
    },
    isETicketDeliveryAndCanAmendETickets: function isETicketDeliveryAndCanAmendETickets() {
        return this.delivery.isETicket() && _FeatureFlagStore2.default.get('enableETicketAmends');
    },
    isETicketByPostDelivery: function isETicketByPostDelivery() {
        return _FeatureFlagStore2.default.get('enableETicketByPost') && this.delivery.isETicketByPost();
    },
    canAmend: function canAmend() {
        return (this.delivery.isCollection() || this.isETicketDeliveryAndCanAmendETickets() || this.isETicketByPostDelivery()) && !this.hasPaypalPayment() && !this.hasAmazonPayPayment() && !this.isAmending() && !this.isCollected() && this.trips.some(function (x) {
            return x.canAmend();
        });
    },
    hasDaySaveTrip: function hasDaySaveTrip() {
        return this.trips.some(function (trip) {
            return trip.getDaySaveFare();
        });
    },
    hasRoversRangersTrip: function hasRoversRangersTrip() {
        return this.trips.some(function (trip) {
            return trip.getRoversRangersFare();
        });
    },
    hasTransPennineStaffRoverTrip: function hasTransPennineStaffRoverTrip() {
        return this.trips.some(function (trip) {
            return trip.isTransPennineStaffRover();
        });
    },
    hasSeasonTrip: function hasSeasonTrip() {
        return this.trips.some(function (trip) {
            return trip.getSeasonFare();
        });
    },
    hasSmartCarnetTrip: function hasSmartCarnetTrip() {
        return this.trips.some(function (trip) {
            return trip.getSmartCarnetFare();
        });
    },
    hasPartialFulfilment: function hasPartialFulfilment() {
        return this.delivery;
    },
    getSeasonTrips: function getSeasonTrips() {
        return this.trips.filter(function (trip) {
            return trip.getSeasonFare();
        });
    },
    getSmartCarnetTrips: function getSmartCarnetTrips() {
        return this.trips.filter(function (trip) {
            return trip.getSmartCarnetFare();
        });
    },
    numberOfSeasonTrips: function numberOfSeasonTrips() {
        return this.trips.filter(function (trip) {
            return trip.getSeasonFare();
        }).size;
    },
    hasFulfilment: function hasFulfilment() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$disableAddressCh = _ref.disableAddressCheck,
            disableAddressCheck = _ref$disableAddressCh === undefined ? false : _ref$disableAddressCh,
            _ref$linkedSmartcards = _ref.linkedSmartcards,
            linkedSmartcards = _ref$linkedSmartcards === undefined ? false : _ref$linkedSmartcards;

        return this.delivery && this.delivery.isValid(this.trips, { disableAddressCheck: disableAddressCheck, linkedSmartcards: linkedSmartcards }, this.getSmartcardOption());
    },
    getTodOption: function getTodOption() {
        return this.availableDeliveryOptions.find(function (deliveryOption) {
            return deliveryOption.isCollection();
        });
    },
    getPendingAmendedTickets: function getPendingAmendedTickets() {
        return this.amendedTickets.filter(function (x) {
            return !x.amended;
        });
    },
    getSmartcardOption: function getSmartcardOption() {
        return this.availableDeliveryOptions.find(function (deliveryOption) {
            return deliveryOption.isSmartcard();
        });
    },
    getSTicketOption: function getSTicketOption() {
        return this.availableDeliveryOptions.find(function (deliveryOption) {
            return deliveryOption.isSTicket();
        });
    },
    isTooSoonToCollectOnSmartcard: function isTooSoonToCollectOnSmartcard() {
        var enableForcedAppCollectionForTwoHourCollectionWindow = _FeatureFlagStore2.default.get('enableForcedAppCollectionForTwoHourCollectionWindow');

        if (enableForcedAppCollectionForTwoHourCollectionWindow) {
            return false;
        }

        var smartcardOption = this.getSmartcardOption();

        if (!smartcardOption) {
            return false;
        }

        var errors = smartcardOption.errors;


        return errors && errors.some(function (err) {
            return _AppConstants.SmartcardErrorNonBlocking.APP_COLLECTION_ONLY in err;
        });
    },
    insufficientActiveSmartcardsToCompleteLinkingOrder: function insufficientActiveSmartcardsToCompleteLinkingOrder() {
        var enableSmartcardAssociations = _FeatureFlagStore2.default.get('enableSmartcardAssociations');

        var smartcardOption = this.getSmartcardOption();

        if (!enableSmartcardAssociations || !smartcardOption || !this.delivery.isSmartcard()) {
            return false;
        }

        var errors = smartcardOption.errors;


        if (errors && errors.some(function (err) {
            return _AppConstants.SmartCardErrorBlockingForLoggedIn.NOT_ENOUGH_ACTIVE_SMARTCARDS_ERROR in err;
        })) {
            return true;
        }

        return false;
    },
    isSmartcardDeliveryOnly: function isSmartcardDeliveryOnly() {
        return this.availableDeliveryOptions.size === 1 && !!this.getSmartcardOption();
    },
    isSTicketDeliveryOnly: function isSTicketDeliveryOnly() {
        return this.availableDeliveryOptions.size === 1 && !!this.getSTicketOption();
    },
    tooManyTicketsForNonLinkedSmartOrder: function tooManyTicketsForNonLinkedSmartOrder(ignoreDeliveryMethods) {
        if (!ignoreDeliveryMethods && !this.delivery.isSmartcard()) {
            return false;
        }

        var enableSmartcardAssociations = _FeatureFlagStore2.default.get('enableSmartcardAssociations');

        if (!enableSmartcardAssociations) {
            var tooManyTicketsForSmartcardOnlyDelivery = this.getTickets().size > 1 && (ignoreDeliveryMethods ? true : this.isSmartcardDeliveryOnly());

            return tooManyTicketsForSmartcardOnlyDelivery;
        }

        return false;
    },
    smartcardCantBeDeliveredInTime: function smartcardCantBeDeliveredInTime(associatedSmartcards, smartcard) {
        var smartcardOption = this.getSmartcardOption();

        if (!smartcardOption || !this.delivery.isSmartcard()) {
            return false;
        }

        var errors = smartcardOption.errors;


        var errorKeys = [_AppConstants.SmartcardErrorBlocking.CANT_DELIVER_IN_TIME];

        // errors is an array, but seems to only ever contain one error object
        if (errors && errors.some(function (err) {
            return _fpUtils2.default.objectHasAnyKeyInList(err, errorKeys);
        })) {
            return true;
        }

        var isUserLoggedIn = _UserStore2.default.getCurrent().isLoggedIn();

        if (isUserLoggedIn && smartcardOption.isDeliverableOnTime === false && !smartcard && associatedSmartcards && associatedSmartcards.size < 1) {
            return true;
        }

        return false;
    },
    smartcardInvalid: function smartcardInvalid() {
        var smartcardOption = this.getSmartcardOption();

        if (!smartcardOption || !this.delivery.isSmartcard()) {
            return false;
        }

        var errors = smartcardOption.errors;


        var errorKeys = [_AppConstants.SmartcardErrorBlocking.PENDING_SMARTCARD, _AppConstants.SmartcardErrorBlocking.EXPIRED_SMARTCARD, _AppConstants.SmartcardErrorBlocking.INVALID_SMARTCARD];

        // errors is an array, but seems to only ever contain one error object
        if (errors && errors.some(function (err) {
            return _fpUtils2.default.objectHasAnyKeyInList(err, errorKeys);
        })) {
            return true;
        }

        return false;
    },
    smartcardTypeFareAgeMismatch: function smartcardTypeFareAgeMismatch() {
        var smartcardOption = this.getSmartcardOption();

        if (!smartcardOption || !this.delivery.isSmartcard()) {
            return false;
        }

        var errors = smartcardOption.errors;


        var errorKeys = [_AppConstants.SmartcardErrorBlocking.NOT_CORRECT_AGE];

        // errors is an array, but seems to only ever contain one error object
        if (errors && errors.some(function (err) {
            return _fpUtils2.default.objectHasAnyKeyInList(err, errorKeys);
        })) {
            return true;
        }

        return false;
    },
    smartcardHasPendingProducts: function smartcardHasPendingProducts() {
        /*
            We only block the purchase of further products on a Smartcard
            that has pending (uncollected) products for GTR brands
        */
        if (!_FeatureFlagStore2.default.get('enablePendingActionlistSmartcardDeliveryBlocking')) {
            return false;
        }

        var smartcardOption = this.getSmartcardOption();

        if (!smartcardOption || !this.delivery.isSmartcard()) {
            return false;
        }

        var errors = smartcardOption.errors;


        var errorKeys = [_AppConstants.SmartcardErrorBlocking.PENDING_ACTIONLIST];

        // errors is an array, but seems to only ever contain one error object
        if (errors && errors.some(function (err) {
            return _fpUtils2.default.objectHasAnyKeyInList(err, errorKeys);
        })) {
            return true;
        }

        return false;
    },
    canBeFulfilledToSmartcard: function canBeFulfilledToSmartcard() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var includesChildPreencode = options.includesChildPreencode,
            ignoreNewSmartcardDeliveryTime = options.ignoreNewSmartcardDeliveryTime,
            ignoreDeliveryMethods = options.ignoreDeliveryMethods;


        return !this.isTooSoonToCollectOnSmartcard() && !includesChildPreencode && !this.tooManyTicketsForNonLinkedSmartOrder(ignoreDeliveryMethods) && !this.smartcardTypeFareAgeMismatch() && !this.smartcardInvalid() && !this.smartcardHasPendingProducts() && (!ignoreNewSmartcardDeliveryTime ? !this.smartcardCantBeDeliveredInTime() : true);
    },
    hasSmartcardDeliveryErrors: function hasSmartcardDeliveryErrors() {
        var smartcardOption = this.getSmartcardOption();

        if (!smartcardOption) {
            return false;
        }

        var errors = smartcardOption.errors;

        return !!errors;
    },
    hasSTicketDeliveryErrors: function hasSTicketDeliveryErrors() {
        var sTicketOption = this.getSTicketOption();

        if (!sTicketOption) {
            return false;
        }

        var errors = sTicketOption.errors;

        return !!errors;
    },
    canBeFulfilled: function canBeFulfilled() {
        if (!this.availableDeliveryOptions.size) {
            return false;
        }

        if (this.isSmartcard()) {
            return !!this.getSmartcardOption();
        }

        if (this.isSmartcardDeliveryOnly() && (!this.canBeFulfilledToSmartcard() || this.hasSmartcardDeliveryErrors())) {
            return false;
        }

        if (this.isSTicketDeliveryOnly() && this.hasSTicketDeliveryErrors()) {
            return false;
        }

        /*
            if Smartcard and sTicket are the only delivery options and both have errors,
            then the order cannot be fulfilled
        */
        if (!!this.getSmartcardOption() && !!this.getSTicketOption() && this.availableDeliveryOptions.size === 2 && this.hasSmartcardDeliveryErrors() && this.hasSTicketDeliveryErrors()) {
            return false;
        }

        return true;
    },
    isRefundable: function isRefundable() {
        return this.canRefundOnline() || this.canRefundOffline();
    },
    canRefundOnline: function canRefundOnline() {
        // TODO: [CORE-16632]: This is a temporary solution to block refund for changeover tickets
        return this.refundCanBeAttemptedOnline && this.changeoverTickets.size === 0;
    },
    canRefundOffline: function canRefundOffline() {
        return this.refundCanBeAttemptedOffline;
    },
    isRefundsLocked: function isRefundsLocked() {
        return this.refundsLocked;
    },
    hasCollectionWindowEnded: function hasCollectionWindowEnded() {
        var now = (0, _TrainTime2.default)();
        var latestCollectionDateBasedOnTrips = this.getLatestCollectionDate();
        var latestCollectionDateBasedOnWindow = this.getCollectionStartDate().clone().add(this.delivery.collectionWindowDays, 'days');

        var latestCollectionDate = latestCollectionDateBasedOnTrips.isBefore(latestCollectionDateBasedOnWindow) ? latestCollectionDateBasedOnTrips : latestCollectionDateBasedOnWindow;

        return latestCollectionDate.isBefore(now);
    },
    getCollectionStartDate: function getCollectionStartDate() {
        return this.delivery && this.delivery.collectionStartDate ? this.delivery.collectionStartDate : this.getEarliestCollectionDate();
    },
    getSmartcardCollectionLocation: function getSmartcardCollectionLocation() {
        return this.getIn(['delivery', 'collectionLocation']) || this.getSmartcardOption().suggestedCollectionPoint;
    },
    getEarliestCollectionDate: function getEarliestCollectionDate() {
        var now = (0, _TrainTime2.default)();
        var depart = this.trips.first().getEarliestTime();
        var earliestDepart = depart.clone().subtract(this.delivery.collectionWindowDays - 1, 'days');
        var earliestDepartDate = now.isBefore(earliestDepart) ? earliestDepart : now;
        return earliestDepartDate.startOf('day');
    },
    getLatestCollectionDate: function getLatestCollectionDate() {
        var now = (0, _TrainTime2.default)();
        var latestCollectionDate = this.trips.first().getEarliestTime();
        return now.isBefore(latestCollectionDate) ? latestCollectionDate : now;
    },
    getDiscountCode: function getDiscountCode() {
        return this.getIn(['discount', 'code']);
    },
    getTotalDiscount: function getTotalDiscount() {
        return this.getIn(['discount', 'fixedAmount']) > 0 ? this.discount.get('fixedAmount') : null;
    },
    getTotalPrice: function getTotalPrice() {
        return this.totalPrice;
    },
    getOriginalTotalPrice: function getOriginalTotalPrice() {
        return this.getTotalPriceWithDelivery();
    },
    getTotalPriceWithDelivery: function getTotalPriceWithDelivery() {
        return this.getTripsPrice() + this.getDeliveryPrice() - this.getTotalDiscount() - this.getDiscountCodeValue() + this.getBookingFeePrice();
    },
    getTripsPrice: function getTripsPrice() {
        return this.get('trips').reduce(function (totalPrice, trip) {
            return totalPrice + trip.getTotalPrice();
        }, 0);
    },
    getRefundAmount: function getRefundAmount() {
        if (this.hasAlternativePayment()) {
            return this.getAlternativePaymentRefundAmount();
        } else {
            return this.getTotalRefundAmount();
        }
    },
    getTrip: function getTrip(id) {
        return this.trips.find(function (trip) {
            return trip.id === id || trip.getCleanId() === id;
        });
    },
    updateTrip: function updateTrip(trip, nextTrip) {
        var next = this.trips.set(this.trips.findIndex(function (x) {
            return x.id === trip.id;
        }), nextTrip);
        return this.set('trips', next);
    },
    getTripIds: function getTripIds() {
        return this.trips.map(function (trip) {
            return trip.getCleanId();
        });
    },
    setDeliveryOption: function setDeliveryOption(option) {
        return this.set('delivery', this.delivery.setOption(option));
    },
    getDeliveryPrice: function getDeliveryPrice() {
        return this.getIn(['delivery', 'price']);
    },
    getDeliveryMethodName: function getDeliveryMethodName() {
        return this.getIn(['delivery', 'displayName']);
    },
    hasDeliveryAddress: function hasDeliveryAddress() {
        var delivery = this.delivery;

        if (!delivery || !delivery.isPostalDelivery()) {
            return false;
        }

        var address = delivery.getAddress();
        return address && address.isComplete();
    },
    isPostalDelivery: function isPostalDelivery() {
        return this.delivery && this.delivery.isPostalDelivery();
    },
    isSmartcardCollection: function isSmartcardCollection() {
        return this.delivery && this.delivery.isSmartcard();
    },
    getDeliveryAddress: function getDeliveryAddress() {
        return this.delivery.getAddress();
    },
    getFirstOrigin: function getFirstOrigin() {
        var sorted = this.trips.sort(function (a, b) {
            return a.getEarliestTime().isBefore(b.getEarliestTime()) ? -1 : 1;
        });

        var earliest = sorted.first();

        if (!earliest) {
            return new _Station2.default();
        } else {
            return earliest.getFirstOrigin();
        }
    },
    isPaid: function isPaid() {
        return (0, _includes3.default)([_AppConstants.OrderStates.COMPLETE, _AppConstants.OrderStates.PENDING, _AppConstants.OrderStates.UNDER_REVIEW, _AppConstants.OrderStates.FULFILLED, _AppConstants.OrderStates.FRAUD, _AppConstants.OrderStates.REFUNDED], this.state);
    },
    isUnderReview: function isUnderReview() {
        return (0, _includes3.default)([_AppConstants.OrderStates.UNDER_REVIEW, _AppConstants.OrderStates.FRAUD], this.state);
    },
    isAmending: function isAmending() {
        return _AppConstants.OrderStates.AMENDING === this.state;
    },
    isComplete: function isComplete() {
        return _AppConstants.OrderStates.COMPLETE === this.state;
    },
    isCollectAtStation: function isCollectAtStation() {
        return this.delivery.isCollection();
    },
    isPrintAtHome: function isPrintAtHome() {
        return this.delivery.isPrintAtHome();
    },
    isETicket: function isETicket() {
        return this.delivery.isETicket();
    },
    isSTicket: function isSTicket() {
        return this.delivery.isSTicket();
    },
    isCollectable: function isCollectable() {
        return this.isCollectAtStation() && this.trips.some(function (trip) {
            return trip.isUnprinted();
        });
    },
    isCollected: function isCollected() {
        return this.isCollectAtStation() && this.trips.every(function (trip) {
            return trip.isPrinted();
        });
    },
    isEmpty: function isEmpty() {
        return this.trips.size === 0;
    },
    isCurrentBrand: function isCurrentBrand() {
        return (0, _isEqual3.default)(this.brand, _config2.default.get('brand')) || _config2.default.get('enableAllowRefundsOnOtherBrands');
    },
    brandIsGTR: function brandIsGTR() {
        var _this = this;

        return Boolean((0, _keys2.default)(_AppConstants.Brands).find(function (key) {
            return _AppConstants.Brands[key] === _this.brand;
        }));
    },
    hasExpired: function hasExpired() {
        return this.expiry ? this.expiry.isBefore() : false;
    },
    hasRecentlyExpired: function hasRecentlyExpired() {
        return this.expiry ? this.expiry.isAfter((0, _TrainTime2.default)().subtract(2, 'hours')) : false;
    },
    hasBikeReservations: function hasBikeReservations() {
        return this.trips.some(function (trip) {
            var fares = trip && trip.get('fares');
            if (!fares) {
                return false;
            }

            return fares.some(function (fare) {
                if (!fare) {
                    return false;
                }

                var outwardJourney = fare.get('outwardJourney');
                var returnJourney = fare.get('returnJourney');

                var outwardHasBikes = outwardJourney && outwardJourney.countBikeSeats() > 0;
                var returnHasBikes = returnJourney && returnJourney.countBikeSeats() > 0;

                return outwardHasBikes || returnHasBikes;
            });
        });
    },
    setAvailableDeliveryOptions: function setAvailableDeliveryOptions(deliveryOptions) {
        var _this2 = this;

        var updatedOrder = this.set('availableDeliveryOptions', deliveryOptions);

        var hasBikeReservations = this.hasBikeReservations();

        // If delivery options are available
        if (deliveryOptions.size) {
            // Set it to the first available without an error (like smartcard unavailable)
            return updatedOrder.setDeliveryOption(deliveryOptions.find(function (option) {
                return option.getFirstAvailableDeliveryOption(_this2.delivery, deliveryOptions, hasBikeReservations);
            }));
        }

        // If there are no options, clear the selected
        return updatedOrder.setDeliveryOption(null);
    },
    getFaresIncludedInFavourites: function getFaresIncludedInFavourites() {
        var withDelivery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return this.get('trips').reduce(function (acc, trip) {
            return trip.includesFavouriteFare(withDelivery) ? acc.concat(trip.getFaresIncludedInFavourites(withDelivery)) : acc;
        }, new _immutable.List());
    },
    includesFavouriteFare: function includesFavouriteFare() {
        var withDelivery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return this.getFaresIncludedInFavourites(withDelivery).size > 0;
    },
    hasCardPayment: function hasCardPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getCardPayments(type).size > 0;
    },
    getCardPaymentAmount: function getCardPaymentAmount() {
        var cardPayment = this.getCardPayment();
        return cardPayment && cardPayment.amount || 0;
    },
    getCardPayment: function getCardPayment() {
        return this.getCardPayments().first();
    },
    getCardPayments: function getCardPayments() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this[type] && this[type].getCards() || new _immutable.List();
    },
    hasLatestVoucherPayment: function hasLatestVoucherPayment() {
        return this.payments.hasLatestVoucherPayment();
    },
    hasLatestCardPayment: function hasLatestCardPayment() {
        return this.payments.hasLatestCardPayment();
    },
    getLatestCardPaymentDetails: function getLatestCardPaymentDetails() {
        return this.payments.getLatestCardDetails();
    },
    getLatestVoucherPayment: function getLatestVoucherPayment() {
        if (!this.hasVoucherPayment()) {
            return null;
        }
        return this.payments.getLatestVoucherPayment();
    },
    getLatestCardPayment: function getLatestCardPayment() {
        if (!this.hasCardPayment()) {
            return null;
        }
        return this.payments.getLatestCardPayment();
    },
    hasVoucherPayment: function hasVoucherPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'warrants'], new _immutable.List()).size > 0;
    },
    hasPromoCode: function hasPromoCode() {
        return !!this.getPromoCode();
    },
    getPromoCode: function getPromoCode() {
        return this.promotionalDiscount;
    },
    checkIfThisPromotionalDiscountHasAlreadyApplied: function checkIfThisPromotionalDiscountHasAlreadyApplied(code) {
        return this.getPromoCode() && this.getPromoCode().promoCode && this.getPromoCode().promoCode.toLowerCase() === code.toLowerCase();
    },
    checkIfThisPromoCodeHasAlreadyApplied: function checkIfThisPromoCodeHasAlreadyApplied(code) {
        var tickets = this.getTickets();
        var ticketWithTheSamePromoCode = tickets.find(function (ticket) {
            return ticket.discount && ticket.promoCode === code;
        });
        return Boolean(ticketWithTheSamePromoCode);
    },
    getVoucherPaymentAmount: function getVoucherPaymentAmount() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return (0, _Immutable.sum)(this[type].warrants || new _immutable.List(), 'amount');
    },
    getCardPaymentsTotal: function getCardPaymentsTotal() {
        return (0, _Immutable.sum)(this.getCardPayments() || new _immutable.List(), 'amount');
    },
    hasAmazonPayPayment: function hasAmazonPayPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'amazonPay'], new _immutable.List()).size > 0;
    },
    hasPaypalPayment: function hasPaypalPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'paypal'], new _immutable.List()).size > 0;
    },
    hasGooglePayPayment: function hasGooglePayPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'googlePay'], new _immutable.List()).size > 0;
    },
    hasApplePayPayment: function hasApplePayPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'applePay'], new _immutable.List()).size > 0;
    },
    hasBraintreeCardPayment: function hasBraintreeCardPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'cardCheckout'], new _immutable.List()).size > 0;
    },
    getAmazonPayPayment: function getAmazonPayPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'amazonPay', 0]);
    },
    getPaypalPayment: function getPaypalPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'paypal', 0]);
    },
    getApplePayPayment: function getApplePayPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'applePay', 0]);
    },
    getBraintreeCardPayment: function getBraintreeCardPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'cardCheckout', 0]);
    },
    getPaypalPaymentAmount: function getPaypalPaymentAmount() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'paypal', 0, 'amount'], 0);
    },
    getGooglePayPayment: function getGooglePayPayment() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'googlePay', 0]);
    },
    getGooglePayPaymentAmount: function getGooglePayPaymentAmount() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'googlePay', 0, 'amount'], 0);
    },
    getApplePayPaymentAmount: function getApplePayPaymentAmount() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'applePay', 0, 'amount'], 0);
    },
    getBraintreeCardPaymentAmount: function getBraintreeCardPaymentAmount() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'payments';

        return this.getIn([type, 'cardCheckout', 0, 'amount'], 0);
    },
    getPaymentRefundAmount: function getPaymentRefundAmount(type) {
        return (0, _Immutable.sum)(this.getIn(['payments', type], new _immutable.List()), 'amountRefunded');
    },
    getVoucherRefundAmount: function getVoucherRefundAmount() {
        return this.getPaymentRefundAmount('warrants');
    },
    getCardRefundAmount: function getCardRefundAmount() {
        return this.getPaymentRefundAmount('cards') + this.getPaymentRefundAmount('hostedCards');
    },
    getPaypalRefundAmount: function getPaypalRefundAmount() {
        return this.getPaymentRefundAmount('paypal');
    },
    getAmazonPayRefundAmount: function getAmazonPayRefundAmount() {
        return this.getPaymentRefundAmount('amazonPay');
    },
    getAlternativePayment: function getAlternativePayment() {
        return this.getIn(['payments', 'alternative', 0]);
    },
    getTotalRefundAmount: function getTotalRefundAmount() {
        return this.getCardRefundAmount() + this.getPaypalRefundAmount() + this.getAmazonPayRefundAmount() + this.getVoucherRefundAmount();
    },
    getAlternativePaymentRefundAmount: function getAlternativePaymentRefundAmount() {
        return this.getIn(['payments', 'alternative', 0, 'amount'], 0);
    },
    getAlternativePaymentType: function getAlternativePaymentType() {
        return this.getIn(['payments', 'alternative', 0, 'paymentType'], 0);
    },


    // this method does not consider eTickets:
    hasTooSoonToCollect: function hasTooSoonToCollect() {
        return this.trips.some(function (trip) {
            return trip.isTooSoonToCollect();
        });
    },
    collectionLocationEqualTo: function collectionLocationEqualTo(station) {
        var collectionStation = this.getIn(['delivery', 'collectionLocation']);
        return station && collectionStation && station.nlc === collectionStation.nlc;
    },
    hasRefunds: function hasRefunds() {
        return this.isFullRefund || this.isPartialRefund;
    },
    hasRefundableTicket: function hasRefundableTicket() {
        return this.trips.some(function (t) {
            return t.hasRefundableTicket();
        });
    },
    hasRefundablePaymentType: function hasRefundablePaymentType() {
        // for now only allow card/voucher payments to be refunded
        return this.hasCardPayment() || this.hasVoucherPayment() && !this.hasPaypalPayment();
    },
    hasAmendablePaymentType: function hasAmendablePaymentType() {
        // same as for refunds but separate in case one or the other
        // changes
        return this.hasCardPayment() || this.hasVoucherPayment() && !this.hasPaypalPayment();
    },
    hasDownloadableTickets: function hasDownloadableTickets() {
        return this.isPaid() && this.isPrintAtHome() && this.trips.some(function (t) {
            return t.hasDownloadableTickets();
        });
    },
    getProducts: function getProducts() {
        return this.trips.map(function (trip) {
            return trip.getProducts();
        }).flatten(1);
    },
    getTickets: function getTickets() {
        return this.getProducts().map(function (fare) {
            return fare.tickets;
        }).flatten(1);
    },
    hasChildTickets: function hasChildTickets() {
        return this.getTickets().some(function (_ref2) {
            var children = _ref2.children;
            return children > 0;
        });
    },
    getFareByTicketId: function getFareByTicketId(id) {
        return this.getFares().find(function (fare) {
            return fare.tickets.find(function (t) {
                return t.id === id;
            });
        });
    },
    getFares: function getFares() {
        return this.getProducts().map(function (fare) {
            return fare;
        });
    },
    hasFlexiFares: function hasFlexiFares() {
        return this.getFares().some(function (x) {
            return x.isFlexi();
        });
    },
    arePassengersReady: function arePassengersReady() {
        return !this.trips.filter(function (trip) {
            return trip.needsPassengers();
        }).some(function (trip) {
            return !trip.hasPassengers();
        });
    },
    hasAmendedTickets: function hasAmendedTickets() {
        return this.amendedTickets.size > 0;
    },
    hasChangeoverTickets: function hasChangeoverTickets() {
        return this.changeoverTickets.size > 0;
    },
    getChangeoverTrips: function getChangeoverTrips() {
        return this.changeoverTickets.map(function (_ref3) {
            var changeoverTrip = _ref3.changeoverTrip;
            return changeoverTrip;
        });
    },
    isNewTicket: function isNewTicket(id) {
        return [].concat(this.amendedTickets, this.changeoverTickets).some(function (fare) {
            return fare.newTicket === id;
        });
    },
    getOldFareFromNewTicketId: function getOldFareFromNewTicketId(id) {
        if (!this.isNewTicket(id)) {
            return null;
        }
        return [].concat(this.amendedTickets, this.changeoverTickets).find(function (amended) {
            return amended.isNewTicket(id);
        }).getOldFare();
    },
    hasReachedDiscountLimit: function hasReachedDiscountLimit(discount) {
        if (!discount || !discount.maxProducts) {
            return false;
        }

        var dicountAppliedCount = this.trips.count(function (trip) {
            return trip.hasDiscount(discount);
        });
        return dicountAppliedCount >= discount.maxProducts;
    },
    hasAlternativePayment: function hasAlternativePayment() {
        return this.getIn(['payments', 'alternative', 0]);
    },
    hasRailcard1617: function hasRailcard1617() {
        return this.getFares().some(function (fare) {
            return fare.hasRailcard1617();
        });
    },
    hasRailcardJCP: function hasRailcardJCP() {
        return this.getFares().some(function (fare) {
            return fare.hasRailcardJCP();
        });
    },
    hasDisabledPeopleRailcard: function hasDisabledPeopleRailcard() {
        return this.getFares().some(function (fare) {
            return fare.hasDisabledPeopleRailcard();
        });
    },
    getBookingFeePrice: function getBookingFeePrice() {
        var bookingFeeSundry = this.sundries.find(function (sundry) {
            return sundry.isBookingFee();
        });
        return bookingFeeSundry ? bookingFeeSundry.price : 0;
    },
    getDiscountCodeValue: function getDiscountCodeValue() {
        var discountCodeSundry = this.sundries.find(function (sundry) {
            return sundry.isDiscountCode();
        });
        return discountCodeSundry ? discountCodeSundry.price : 0;
    },
    canClaimDelayRepay: function canClaimDelayRepay() {
        return (0, _DelayRepayOrderHandoff.validateOrderJourneys)(this, _config2.default.get('tocGroup')).some(function (validation) {
            return validation.status === _DelayRepayOrderHandoff.HandoffState.CLAIMABLE;
        });
    },
    numAdultOrChildTickets: function numAdultOrChildTickets(adults) {
        return this.getProducts().map(function (fare) {
            return fare.tickets.reduce(function (acc, ticket) {
                return acc + Number(adults ? ticket.adults > 0 : ticket.children > 0);
            }, 0);
        }).reduce(function (acc, numTickets) {
            return acc + numTickets;
        }, 0);
    }
});

Order.fromJSON = function (json) {
    var trips = (0, _LinkMapper.resolveAll)(json.trips).as(_Trip2.default).sort(function (orderTripA, orderTripB) {
        return orderTripA.id > orderTripB.id;
    });
    var tickets = trips.map(function (trip) {
        return trip.getTickets();
    }).flatten(true);
    var refunds = tickets.filter(function (ticket) {
        return ticket.isRefunded;
    });
    var isChangeoverRefund = tickets.some(function (ticket) {
        return ticket.isChangeoverRefund;
    });
    var amendedTickets = (0, _LinkMapper.resolveAll)(json.amendedTickets).as(_Ticket2.default);
    var changeoverTickets = (0, _LinkMapper.resolveAll)(json.changeoverTickets).as(_Ticket4.default);

    return (0, _LinkMapper.construct)(Order, json, {
        id: _LinkMapper.fields.number,
        expiry: _LinkMapper.resolve.with(_momentTimezone2.default),
        trips: trips,
        state: _LinkMapper.fields.string,
        brand: _LinkMapper.fields.string,
        nlc: _LinkMapper.fields.string,
        amendedTickets: amendedTickets,
        changeoverTickets: changeoverTickets,
        email: _LinkMapper.fields.string,
        charity: json.charity,
        customerId: _LinkMapper.fields.number,
        customerName: _LinkMapper.fields.string,
        collectionReference: _LinkMapper.fields.string,
        discount: json.discount ? _LinkMapper.resolve.as(_OrderDiscount2.default) : new _OrderDiscount2.default(),
        totalPrice: _LinkMapper.fields.number,
        leftToPay: _LinkMapper.fields.number,
        amendPriceDiff: _LinkMapper.fields.number,
        creationDate: _LinkMapper.resolve.with(_TrainTime2.default),
        purchaseDate: _LinkMapper.resolve.with(_TrainTime2.default),
        lastUpdated: _LinkMapper.resolve.with(_TrainTime2.default),
        delivery: json.delivery ? _LinkMapper.resolve.as(_Fulfilment2.default) : new _Fulfilment2.default(),
        availableDeliveryOptions: _LinkMapper.resolveAll.as(_DeliveryOption2.default),
        payments: (0, _LinkMapper.resolve)(json.payments || {}).as(_Payments2.default),
        changeoverPayments: (0, _LinkMapper.resolve)(json.changeoverPayments || {}).as(_Payments2.default),
        telephoneNumber: _LinkMapper.fields.string,
        isFullRefund: refunds.size > 0 && tickets.size === refunds.size,
        isPartialRefund: refunds.size > 0 && refunds.size < tickets.size,
        isChangeoverRefund: isChangeoverRefund,
        refundCanBeAttemptedOnline: _LinkMapper.fields.bool,
        refundCanBeAttemptedOffline: _LinkMapper.fields.bool,
        refundsLocked: _LinkMapper.fields.bool,
        alreadyPaidForRefund: (0, _LinkMapper.resolve)(json.alreadyPaidForRefund).with(Boolean),
        amazonPayOrderReferenceId: _LinkMapper.fields.string,
        sundries: (0, _LinkMapper.resolveAll)(json.sundries).as(_Sundry2.default),
        channel: _LinkMapper.fields.string,
        isInterop: _LinkMapper.fields.bool,
        totalRewardPoints: _LinkMapper.fields.number,
        rewardPointUid: _LinkMapper.fields.string,
        rewardName: _LinkMapper.fields.string,
        promotionalDiscount: _LinkMapper.resolve.with(Object)
    });
};

exports.default = Order;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RouteResolveError = exports.RouteNotFoundError = exports.RouteError = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ref; /**
           * Map of route names to route specs to add named routing abilities to react-router
           */

var _routeParser = __webpack_require__(813);

var _routeParser2 = _interopRequireDefault(_routeParser);

var _immutable = __webpack_require__(5);

var _urijs = __webpack_require__(283);

var _urijs2 = _interopRequireDefault(_urijs);

var _queryString = __webpack_require__(1076);

var _queryString2 = _interopRequireDefault(_queryString);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

var _urls = __webpack_require__(1665);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchPart = "(:origin)/(:destination)/(:outboundDateTime)/(:returnDateTime)/(:adults)/(:children)/(:railcards)";
var seasonSearchPart = "(:origin)/(:destination)/(:startDate)/(:duration)/(:passengerType)(/:railcardCode)";
var openGolfSearchPart = ":origin/:adults/:children(/:railcards)";
var smartCarnetSearchPart = ":origin/:destination/:startingDate";

var urlTable = new _immutable.Map((_ref = {}, _ref[_AppConstants.GridPages.SERVICES] = '/journeys-grid/' + searchPart, _ref[_AppConstants.PointStages.SEARCH] = '/search', _ref[_AppConstants.PointStages.SEARCH_RESULTS] = '/search-results/:source/' + searchPart, _ref[_AppConstants.PointStages.RESULTS] = '/journeys/' + searchPart, _ref[_AppConstants.PointStages.CHOOSE_OUTWARD] = '/journeys-list/' + searchPart, _ref[_AppConstants.PointStages.INIT] = '/initialise-search/' + searchPart, _ref[_AppConstants.CheckoutStages.DELIVERY] = '/delivery', _ref[_AppConstants.CheckoutStages.PAYMENT] = '/payment', _ref[_AppConstants.CheckoutStages.PAYMENT_AMAZON_PAY] = '/payment/amazonpay', _ref[_AppConstants.CheckoutStages.PAYMENT_CARD_HOSTED] = '/payment/card/hosted', _ref[_AppConstants.CheckoutStages.PAYMENT_CARD_HOSTED_BRAINTREE] = '/payment/card/hosted-braintree', _ref[_AppConstants.CheckoutStages.PAYMENT_CONFIRMATION] = '/payment-confirmation', _ref[_AppConstants.CheckoutStages.AMAZON_PAY_MFA_SUCCESS] = '/amazonpay-mfa-success', _ref[_AppConstants.CheckoutStages.AMAZON_PAY_MFA_FAILURE] = '/amazonpay-mfa-failure', _ref[_AppConstants.SeasonStages.SEARCH] = '/search/season', _ref[_AppConstants.SeasonStages.RESULTS] = '/season-tickets/' + seasonSearchPart, _ref[_AppConstants.SeasonStages.DETAILS] = '/season-tickets/details', _ref[_AppConstants.SeasonStages.INIT] = '/initialise-season/' + seasonSearchPart, _ref[_AppConstants.OtherTicketStages.SEARCH] = '/search/other', _ref[_AppConstants.DaySaveStages.SEARCH] = '/search/other/daysave', _ref[_AppConstants.DaySaveStages.RESULTS] = '/daysave/(:date)/(:origin)/(:adults)/(:children)', _ref[_AppConstants.RoversRangersStages.SEARCH] = '/search/other/roversrangers', _ref[_AppConstants.RoversRangersStages.RESULTS] = '/roversrangers/(:date)/(:ticketType)/(:adults)/(:children)/(:railcards)', _ref[_AppConstants.SmartCarnetStages.SEARCH] = '/search/other/smart-carnet', _ref[_AppConstants.SmartCarnetStages.RESULTS] = '/smart-carnet/' + smartCarnetSearchPart, _ref[_AppConstants.AccountPages.ACCOUNT_DETAILS] = '/account/details', _ref[_AppConstants.AccountPages.ACCOUNT_ADDRESSES] = '/account/address', _ref[_AppConstants.AccountPages.ACCOUNT_CONFIRM_SMARTCARD_REPLACEMENT] = '/account/confirm-smartcard', _ref[_AppConstants.AccountPages.ACCOUNT_PREFERENCE_CENTRE] = '/account/preferences', _ref[_AppConstants.AccountPages.ACCOUNT_PHOTOCARDS_RAILCARDS] = '/account/photocards-railcards', _ref[_AppConstants.AccountPages.ACCOUNT_PAYMENT] = '/account/payment', _ref[_AppConstants.AccountPages.ACCOUNT_ORDERS_REFUNDS] = '/account/orders', _ref[_AppConstants.AccountPages.ACCOUNT_ORDER_DETAILS] = '/account/orders/:orderId', _ref[_AppConstants.AccountPages.ACCOUNT_LINK_ORDER] = '/account/link-order', _ref[_AppConstants.AccountPages.ACCOUNT_REFUND_DETAILS] = '/account/refunds/:orderId', _ref[_AppConstants.AccountPages.ACCOUNT_AMEND_DETAILS] = '/account/amend/:orderId', _ref[_AppConstants.AccountPages.ACCOUNT_ETICKETS] = '/account/etickets(/:orderId)', _ref[_AppConstants.AccountPages.ACCOUNT_STICKETS] = '/account/stickets', _ref[_AppConstants.AccountPages.ACCOUNT_AUTO_DELAY_REPAY] = '/account/auto-delay-repay', _ref[_AppConstants.AccountPages.ONE_CLICK_DELAY_REPAY] = '/account/one-click-delay-repay', _ref[_AppConstants.AccountPages.ACCOUNT_DISRUPTION_ALERTS] = '/account/disruption-alerts', _ref[_AppConstants.AccountPages.ACCOUNT_RESERVATIONS] = '/account/reservations', _ref[_AppConstants.AccountPages.ACCOUNT_HISTORIC_ETICKETS] = '/account/historic-etickets', _ref[_AppConstants.PortalClaims.MY_CLAIMS] = '/my/claims', _ref[_AppConstants.AccountPages.SMARTCARD_APPLY] = '/account/smartcard-apply', _ref[_AppConstants.AccountPages.SMARTCARD_TICKETS] = '/account/smartcard-tickets', _ref[_AppConstants.AccountPages.SMARTCARD_HISTORY] = '/account/smartcard-history', _ref[_AppConstants.AccountPages.SMARTCARD_KEYGO] = '/account/smartcard-keygo', _ref[_AppConstants.AccountPages.SMARTCARD_KEYGO_HISTORY] = '/account/smartcard-keygo-history', _ref[_AppConstants.AccountPages.SMARTCARD_REPLACEMENT] = '/account/smartcard-replacement', _ref[_AppConstants.AccountPages.SMARTCARD_TRANSFER] = '/account/smartcard-transfer', _ref[_AppConstants.AccountPages.SMARTCARD_TRANSFER_RESULTS] = '/account/smartcard-transfer/results/:photocardNumber/:postcode', _ref[_AppConstants.AccountPages.SMARTCARD_TRANSFER_CONFIRMATION] = '/account/smartcard-transfer/confirmation', _ref[_AppConstants.AccountPages.SMARTCARD_LINK] = '/account/smartcard-link', _ref[_AppConstants.AccountPages.SMARTCARD_LINK_CONFIRMATION] = '/account/smartcard-link-confirmation/:customerId/:choice/:token', _ref[_AppConstants.AccountPages.EVOUCHERS] = '/account/evouchers', _ref[_AppConstants.AccountPages.ACCOUNT_SMART_CARNET] = '/account/smart-carnet', _ref[_AppConstants.AccountPages.FLEXI] = '/account/flexi-season', _ref[_AppConstants.AccountPages.BOOK_PASSENGER_ASSIST] = '/account/book-passenger-assist', _ref[_AppConstants.AccountPages.VIEW_BOOKED_ASSISTANCE] = '/account/view-booked-assistance', _ref[_AppConstants.AccountPages.ACCESSIBILITY_PROFILE] = '/account/view-my-accessibility-profile', _ref[_AppConstants.SmartcardPages.SELF_REGISTERED] = '/smartregister', _ref[_AppConstants.PromotionPages.TOC_FAMILY] = '/promotion/toc-family', _ref[_AppConstants.PromotionPages.TOC_FAMILY_VERIFY] = '/promotion/verify', _ref[_AppConstants.PromotionPages.PROMOTION] = '/promotion/:promotion', _ref[_AppConstants.PromotionPages.APPLY_PROMOTION] = '/promotion/:promotion/:promoCode(/)', _ref[_AppConstants.LoginPages.RESET_PASSWORD] = '/reset-password/:token', _ref[_AppConstants.LoginPages.SET_PASSWORD_AND_PREFERENCES] = '/set-password-and-preferences/:token', _ref[_AppConstants.InAppPages.LOGIN] = '/in-app/login', _ref[_AppConstants.InAppPages.REGISTER] = '/in-app/register', _ref[_AppConstants.InAppPages.REGISTER_SMARTCARD] = '/in-app/register-smartcard', _ref[_AppConstants.InAppPages.ACCOUNT] = '/in-app/account', _ref[_AppConstants.InAppPages.ACCOUNT_ORDERS_REFUNDS] = '/in-app/account/orders', _ref[_AppConstants.InAppPages.ONE_CLICK_DELAY_REPAY] = '/in-app/account/one-click-delay-repay', _ref[_AppConstants.InAppPages.AUTO_DELAY_REPAY] = '/in-app/account/auto-delay-repay', _ref[_AppConstants.InAppPages.REDIRECT] = '/in-app/redirect/*', _ref[_AppConstants.InAppPages.SEARCH] = '/in-app/search(/' + searchPart + ')', _ref[_AppConstants.InAppPages.SEASON_SEARCH] = '/in-app/season-search/' + seasonSearchPart, _ref[_AppConstants.InAppPages.RESULTS] = '/in-app/journeys/' + searchPart, _ref[_AppConstants.InAppPages.SEASON_RESULTS] = '/in-app/season-tickets/' + seasonSearchPart, _ref[_AppConstants.InAppPages.LOGOUT] = '/in-app/logout', _ref[_AppConstants.WidgetAuthPages.LOGIN] = '/widget-auth/login', _ref[_AppConstants.WidgetAuthPages.REGISTER] = '/widget-auth/register', _ref[_AppConstants.WidgetAuthPages.LOGOUT] = '/widget-auth/logout', _ref[_AppConstants.HandOffPages.FARE] = '/hand-off/fare', _ref[_AppConstants.DisruptionAlertsPages.MUTE] = '/disruption-alerts/mute', _ref[_AppConstants.DisruptionAlertsPages.DELETE] = '/timetable-change/delete', _ref[_AppConstants.NREPages.ORDER_LANDING] = '/nre-order/:orderID/:deviceToken(/)', _ref[_AppConstants.NewsletterPages.UNSUBSCRIBE] = '/customers/unsubscribe/:id/:token', _ref[_AppConstants.OtherPages.PAYMENT_LANDING] = '/order-payment/:orderID/:deviceToken(/)', _ref[_AppConstants.SearchWidgetPages.IFRAME] = '/search-widget/iframe', _ref[_AppConstants.Widgets.OPEN_GOLF_FIND_TICKETS] = '/' + _config2.default.get('openGolfPathname'), _ref[_AppConstants.Widgets.OPEN_GOLF_TIMETABLE] = '/' + _config2.default.get('openGolfTimetablePathname'), _ref[_AppConstants.Widgets.OPEN_GOLF_TICKET_SELECTION] = '/open-ticket-selection/' + openGolfSearchPart, _ref[_AppConstants.Widgets.REFUND_WIDGET] = '/refund-widget', _ref)).merge(_urls2.default);

function _makeRoutes(urlMap) {
    return urlMap.reduce(function (out, value, key) {
        var route = new _routeParser2.default(value);
        route.name = key;
        return out.set(key, route);
    }, new _immutable.Map());
}

//Turn the map above into a map of route-parser objects
var routes = _makeRoutes(urlTable);

var RouteError = exports.RouteError = function (_ExtendableError) {
    (0, _inherits3.default)(RouteError, _ExtendableError);

    function RouteError() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RouteError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'RouteError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return RouteError;
}(_ExtendableError3.default);

var RouteNotFoundError = exports.RouteNotFoundError = function (_RouteError) {
    (0, _inherits3.default)(RouteNotFoundError, _RouteError);

    function RouteNotFoundError() {
        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, RouteNotFoundError);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, _RouteError.call.apply(_RouteError, [this].concat(args))), _this2), _this2.name = 'RouteNotFoundError', _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    return RouteNotFoundError;
}(RouteError);

var RouteResolveError = exports.RouteResolveError = function (_RouteError2) {
    (0, _inherits3.default)(RouteResolveError, _RouteError2);

    function RouteResolveError() {
        var _temp3, _this3, _ret3;

        (0, _classCallCheck3.default)(this, RouteResolveError);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, _RouteError2.call.apply(_RouteError2, [this].concat(args))), _this3), _this3.name = 'RouteResolveError', _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
    }

    return RouteResolveError;
}(RouteError);

exports.default = {

    /**
     * Set the url map, useful for tests
     */
    setUrls: function setUrls(urlMap) {
        routes = _makeRoutes(urlMap);
    },
    reset: function reset() {
        routes = _makeRoutes(urlTable);
    },


    /**
     * Get a route from a route name
     */
    get: function get(name) {
        var route = routes.get(name);
        if (!route) {
            throw new RouteNotFoundError('Cannot find route ' + name);
        }
        return route;
    },


    /**
     * Build a path from a route name and params
     */
    reverse: function reverse(name, params) {
        return this.get(name).reverse(params);
    },


    /**
     * Build a location descriptor from a route name, params, and query
     */
    location: function location(name, params, query, extra) {
        return (0, _extends3.default)({
            pathname: this.reverse(name, params),
            query: query
        }, extra);
    },


    /**
     * Find a route given a path
     */
    resolve: function resolve(path) {
        var matches = routes.filter(function (route) {
            return route.match(path);
        });
        if (!matches.size) {
            throw new RouteResolveError('Could not resolve route for path: ' + path);
        }
        return matches.first();
    },
    hasMatchingRoute: function hasMatchingRoute(name) {
        var appName = _config2.default.get('name');
        var isDelayRepay = _urls2.default.has(name);
        if (appName === _AppConstants.AppName.BOOKING_ENGINE && !isDelayRepay) {
            return true;
        } else if (appName === _AppConstants.AppName.DELAY_REPAY && isDelayRepay) {
            return true;
        }
        return false;
    },
    getUrl: function getUrl(name, params, query) {
        var path = this.reverse(name, params);
        var queryString = query ? '?' + _urijs2.default.buildQuery(query, false, false) : '';
        var isDelayRepay = _urls2.default.has(name);
        var host = isDelayRepay ? _config2.default.get('delayRepayHost') : _config2.default.get('bookingEngineHost');
        return 'https://' + host + path + queryString;
    },
    getCurrentHostUrl: function getCurrentHostUrl(name, params, query) {
        var path = this.reverse(name, params);
        var queryString = query ? '?' + _urijs2.default.buildQuery(query, false, false) : '';
        var _window$location = window.location,
            hostname = _window$location.hostname,
            port = _window$location.port;

        var localEnvironmentPath = '';

        if (hostname === 'localhost') {
            var environment = /^\/([^/]*)\//.exec(location.pathname);
            localEnvironmentPath = '/' + environment[1];
        }

        return 'https://' + hostname + (port ? ':' + port : '') + localEnvironmentPath + path + queryString;
    },
    getQuery: function getQuery(name) {
        var parsed = _queryString2.default.parseUrl(window.location.href);
        return parsed.query[name];
    },
    isCurrentUrlPath: function isCurrentUrlPath(pathname) {
        return window.location.pathname.includes(pathname);
    }
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {

exports.__esModule = true;
exports.APIClient = exports.makeUrl = exports.fetcher = exports.NotFoundError = exports.ForbiddenError = exports.UnauthorisedError = exports.BadRequestError = exports.ServerError = exports.RequestError = undefined;

var _getIterator2 = __webpack_require__(287);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _entries = __webpack_require__(238);

var _entries2 = _interopRequireDefault(_entries);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _mapKeys2 = __webpack_require__(783);

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

var _forEach2 = __webpack_require__(522);

var _forEach3 = _interopRequireDefault(_forEach2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _identity2 = __webpack_require__(116);

var _identity3 = _interopRequireDefault(_identity2);

var _has2 = __webpack_require__(1075);

var _has3 = _interopRequireDefault(_has2);

var resolveBody = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var contentType, body;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(options.responseType === 'arraybuffer')) {
                            _context.next = 6;
                            break;
                        }

                        _context.next = 3;
                        return response.arrayBuffer();

                    case 3:
                        return _context.abrupt('return', _context.sent);

                    case 6:
                        if (!(options.responseType === 'blob')) {
                            _context.next = 12;
                            break;
                        }

                        _context.next = 9;
                        return response.blob();

                    case 9:
                        return _context.abrupt('return', _context.sent);

                    case 12:
                        if (!(options.responseType === 'text')) {
                            _context.next = 16;
                            break;
                        }

                        _context.next = 15;
                        return response.text();

                    case 15:
                        return _context.abrupt('return', _context.sent);

                    case 16:
                        contentType = response.headers.get('content-type') || 'text/plain';
                        body = void 0;

                        if (!(response.status === 204)) {
                            _context.next = 22;
                            break;
                        }

                        body = '';
                        _context.next = 38;
                        break;

                    case 22:
                        if (!(contentType.indexOf('application/json') > -1)) {
                            _context.next = 29;
                            break;
                        }

                        _context.next = 25;
                        return response.json();

                    case 25:
                        body = _context.sent;

                        body = addLinks(body);
                        _context.next = 38;
                        break;

                    case 29:
                        if (!contentType.includes('image/')) {
                            _context.next = 35;
                            break;
                        }

                        _context.next = 32;
                        return response.blob();

                    case 32:
                        body = _context.sent;
                        _context.next = 38;
                        break;

                    case 35:
                        _context.next = 37;
                        return response.text();

                    case 37:
                        body = _context.sent;

                    case 38:
                        return _context.abrupt('return', body);

                    case 39:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function resolveBody(_x2) {
        return _ref.apply(this, arguments);
    };
}();

var _urijs = __webpack_require__(283);

var _urijs2 = _interopRequireDefault(_urijs);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _LinkMapper = __webpack_require__(8);

var _LinkMapper2 = _interopRequireDefault(_LinkMapper);

var _RequestBody = __webpack_require__(1519);

var _LoadingActions = __webpack_require__(787);

var _LoadingActions2 = _interopRequireDefault(_LoadingActions);

var _TraceToken = __webpack_require__(1521);

var _TraceToken2 = _interopRequireDefault(_TraceToken);

var _CustomerEndpoint = __webpack_require__(524);

var _API = __webpack_require__(201);

var _AuthToken = __webpack_require__(392);

var _AuthToken2 = _interopRequireDefault(_AuthToken);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _Customer = __webpack_require__(808);

var _RefreshTokenError = __webpack_require__(1608);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Re-export the errors to make it easy to import with the APIClient
/* eslint-disable camelcase, no-use-before-define */
exports.RequestError = _API.RequestError;
exports.ServerError = _API.ServerError;
exports.BadRequestError = _API.BadRequestError;
exports.UnauthorisedError = _API.UnauthorisedError;
exports.ForbiddenError = _API.ForbiddenError;
exports.NotFoundError = _API.NotFoundError;


var refreshIterator = 0;
var requestsQueue = [];

var resetRefreshActions = function resetRefreshActions() {
    requestsQueue = [];
    refreshIterator = 0;
};

var withNewToken = function withNewToken(options, refreshToken) {
    return (0, _extends3.default)({}, options, {
        headers: (0, _extends3.default)({}, options.headers, {
            'x-customer-token': refreshToken
        }),
        _isRetry: true
    });
};

var addLinks = function addLinks(response) {
    if ((0, _has3.default)(response, 'links')) {
        _LinkMapper2.default.addLinks(response.links);
    }
    return response;
};

function createErrorFrom(status, response, resolvedBody, errorContext) {
    var errors = {
        500: _API.ServerError,
        400: _API.BadRequestError,
        401: _API.UnauthorisedError,
        403: _API.ForbiddenError,
        404: _API.NotFoundError
    };

    var ErrorClass = _API.RequestError;
    if (errors[status]) {
        ErrorClass = errors[status];
    }

    return new ErrorClass(response, resolvedBody, errorContext);
}

var fetcher = exports.fetcher = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(url, options) {
        var id, showLoader, response, resolvedBody, refreshTokenPayload, authResponse, token, result, errorContext, shouldSuppressThrow;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        options.responseMap = options.responseMap || _identity3.default;
                        options.credentials = options.credentials || 'include';
                        id = (0, _uniqueId3.default)('api-');
                        showLoader = options.loader === undefined ? true : options.loader;


                        if (showLoader) {
                            _LoadingActions2.default.start(_AppConstants.LoadingTypes.API, id, { url: url });
                        }

                        _context3.prev = 5;
                        _context3.t0 = fetch;

                        if (!_context3.t0) {
                            _context3.next = 11;
                            break;
                        }

                        _context3.next = 10;
                        return window.fetch(url, options);

                    case 10:
                        _context3.t0 = _context3.sent;

                    case 11:
                        response = _context3.t0;
                        _context3.next = 14;
                        return resolveBody(response, options);

                    case 14:
                        resolvedBody = _context3.sent;

                        if (!(!response || !response.ok)) {
                            _context3.next = 52;
                            break;
                        }

                        if (showLoader) {
                            _LoadingActions2.default.fail(_AppConstants.LoadingTypes.API, id, { url: url, response: response });
                        }

                        if (!(!options._isRetry && _UserStore2.default.getCurrent().refreshToken && response.status === 401 && url.includes(_makeUrl('/')))) {
                            _context3.next = 49;
                            break;
                        }

                        if (!url.includes(_CustomerEndpoint.URL.refresh)) {
                            _context3.next = 24;
                            break;
                        }

                        resetRefreshActions();
                        (0, _Customer.logoutUser)(response);
                        throw new _RefreshTokenError.RefreshTokenError();

                    case 24:

                        refreshIterator++;

                        if (!(refreshIterator === 1)) {
                            _context3.next = 46;
                            break;
                        }

                        refreshTokenPayload = {
                            grant_type: 'refresh_token',
                            token: _UserStore2.default.getCurrent().refreshToken,
                            session_short: _config2.default.get('sessionShort')
                        };
                        _context3.next = 29;
                        return new APIClient().post(_CustomerEndpoint.URL.refresh, refreshTokenPayload);

                    case 29:
                        authResponse = _context3.sent;
                        token = (0, _LinkMapper.resolve)(authResponse.result).as(_AuthToken2.default);


                        _AppDispatcher2.default.dispatch({
                            actionType: _AppConstants.ActionTypes.AUTH_REFRESHED,
                            token: token
                        });

                        if (!token) {
                            _context3.next = 41;
                            break;
                        }

                        _context3.next = 35;
                        return fetcher(url, withNewToken(options, token.accessToken));

                    case 35:
                        result = _context3.sent;

                        requestsQueue.map(function (resolver) {
                            return resolver(token.accessToken);
                        });
                        resetRefreshActions();

                        return _context3.abrupt('return', result);

                    case 41:
                        resetRefreshActions();
                        (0, _Customer.logoutUser)(response);
                        throw new _RefreshTokenError.RefreshTokenError();

                    case 44:
                        _context3.next = 47;
                        break;

                    case 46:
                        return _context3.abrupt('return', new _promise2.default(function (resolve, reject) {
                            requestsQueue.push(function () {
                                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(token) {
                                    var _result;

                                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    _context2.prev = 0;
                                                    _context2.next = 3;
                                                    return fetcher(url, withNewToken(options, token));

                                                case 3:
                                                    _result = _context2.sent;

                                                    resolve(_result);
                                                    _context2.next = 10;
                                                    break;

                                                case 7:
                                                    _context2.prev = 7;
                                                    _context2.t0 = _context2['catch'](0);

                                                    reject(_context2.t0);

                                                case 10:
                                                case 'end':
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, undefined, [[0, 7]]);
                                }));

                                return function (_x5) {
                                    return _ref3.apply(this, arguments);
                                };
                            }());
                        }));

                    case 47:
                        _context3.next = 52;
                        break;

                    case 49:
                        if (refreshIterator) {
                            _context3.next = 52;
                            break;
                        }

                        errorContext = {
                            url: url,
                            method: (options.method || 'GET').toUpperCase(),
                            status: response && response.status,
                            traceToken: options.headers['x-trace-token'],
                            body: (0, _stringify2.default)(resolvedBody)
                        };
                        throw createErrorFrom(response.status, response, resolvedBody, errorContext);

                    case 52:

                        if (showLoader) {
                            _LoadingActions2.default.success(_AppConstants.LoadingTypes.API, id, { url: url, response: response });
                        }

                        return _context3.abrupt('return', options.responseMap(resolvedBody, response));

                    case 56:
                        _context3.prev = 56;
                        _context3.t1 = _context3['catch'](5);
                        shouldSuppressThrow = options.validErrorStatuses && _context3.t1.extra && options.validErrorStatuses.includes(_context3.t1.extra.status);


                        if (showLoader) {
                            _LoadingActions2.default.fail(_AppConstants.LoadingTypes.API, id, { url: url, error: _context3.t1 });
                        }

                        if (shouldSuppressThrow) {
                            _context3.next = 62;
                            break;
                        }

                        throw _context3.t1;

                    case 62:
                        return _context3.abrupt('return', _context3.t1);

                    case 63:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined, [[5, 56]]);
    }));

    return function fetcher(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

var needsCorsProxy = function needsCorsProxy() {
    return _config2.default.get('forceCORSProxy') || !('withCredentials' in new XMLHttpRequest());
};

var _makeUrl = function _makeUrl(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var defaults = {
        protocol: _config2.default.get('apiProtocol'),
        apiHost: _config2.default.get('apiHost'),
        apiPort: _config2.default.get('apiPort'),
        apiPath: _config2.default.get('apiPath')
    };
    options = (0, _defaults3.default)(options, defaults);
    return _urijs2.default.build({
        protocol: options.protocol,
        hostname: needsCorsProxy() ? window.location.hostname : options.apiHost,
        port: needsCorsProxy() ? window.location.port : options.apiPort,
        path: options.apiPath + path,
        query: options.query
    });
};

exports.makeUrl = _makeUrl;
function makeRequestBody(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return (0, _stringify2.default)(options.trim ? (0, _RequestBody.trimPayload)(data) : data);
}

var APIClient = exports.APIClient = function () {
    function APIClient() {
        (0, _classCallCheck3.default)(this, APIClient);
    }

    APIClient.prototype.makeUrl = function makeUrl() {
        return _makeUrl.apply(undefined, arguments);
    };

    APIClient.prototype.getHeaders = function getHeaders() {
        var clientId = _config2.default.get('name') + '@' + _config2.default.get('version');
        var headers = {
            'accept': 'application/json',
            'content-type': 'application/json',
            'x-access-token': _config2.default.get('apiAccessToken'),
            'x-trace-token': clientId + '/' + _TraceToken2.default.getToken()
        };

        if (needsCorsProxy()) {
            headers['x-cors-proxy'] = 1;
        }

        return headers;
    };

    APIClient.prototype.post = function post(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        options = (0, _assign2.default)({}, options, {
            method: 'POST',
            headers: (0, _extends3.default)({}, this.getHeaders(), options.headers),
            body: makeRequestBody(data, options)
        });
        return fetcher(this.makeUrl(path, options), options);
    };

    APIClient.prototype.postForm = function postForm(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var files = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var headers = this.getHeaders();
        var body = new FormData();
        (0, _forEach3.default)(data, function (v, k) {
            return body.append(k, v);
        });
        (0, _forEach3.default)(files, function (v, k) {
            if (v instanceof Blob) {
                body.append(k, v, 'blob.jpg');
            } else {
                body.append(k, v);
            }
        });
        delete headers['content-type'];

        return fetcher(this.makeUrl(path), {
            method: 'POST',
            headers: headers,
            body: body
        });
    };

    APIClient.prototype.get = function get(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        options = (0, _assign2.default)({}, options, {
            method: 'GET',
            headers: (0, _extends3.default)({}, this.getHeaders(), options.headers)
        });
        var url = this.makeUrl(path, { query: _urijs2.default.buildQuery(data) });
        return fetcher(url, options);
    };

    APIClient.prototype.put = function put(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        options = (0, _assign2.default)({}, options, {
            method: 'PUT',
            headers: this.getHeaders(),
            body: makeRequestBody(data, options)
        });
        return fetcher(this.makeUrl(path), options);
    };

    APIClient.prototype.delete = function _delete(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        options = (0, _assign2.default)({}, options, {
            method: 'DELETE',
            headers: this.getHeaders(),
            body: data && makeRequestBody(data, options)
        });
        return fetcher(this.makeUrl(path), options);
    };

    APIClient.prototype.patch = function patch(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        // fetch fails in chrome ATM
        var _xhr = this.xhr('PATCH', path),
            xhr = _xhr.xhr,
            promise = _xhr.promise;

        xhr.send(makeRequestBody(data, options));
        return promise.then(function (_ref4) {
            var responseText = _ref4.responseText;
            return responseText && JSON.parse(responseText);
        });
    };

    APIClient.prototype.xhr = function xhr(method, path) {
        var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var xhr = new XMLHttpRequest();
        var url = this.makeUrl(path);
        method = method.toUpperCase();
        xhr.open(method, url);
        xhr.withCredentials = true;

        var normalizeHeader = function normalizeHeader(value, name) {
            return name.toLowerCase();
        };
        headers = (0, _assign2.default)((0, _mapKeys3.default)(this.getHeaders(), normalizeHeader), (0, _mapKeys3.default)(headers, normalizeHeader));
        for (var _iterator = (0, _entries2.default)(headers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
            var _ref6;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref6 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref6 = _i.value;
            }

            var _ref5 = _ref6;
            var name = _ref5[0];
            var value = _ref5[1];

            if (value !== undefined) {
                xhr.setRequestHeader(name, value);
            }
        }

        // eslint-disable-next-line no-shadow
        var promise = new _promise2.default(function (resolve, reject) {
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    var status = xhr.status,
                        responseText = xhr.responseText;

                    if (status >= 200 && status <= 299) {
                        resolve(xhr);
                    } else {
                        var extraInfo = {
                            path: path, method: method, status: status, responseText: responseText
                        };
                        reject(createErrorFrom(status, xhr, responseText, extraInfo));
                    }
                }
            };
        });
        return { xhr: xhr, promise: promise };
    };

    return APIClient;
}();

exports.default = new APIClient();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(650)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1384), __esModule: true };

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.sum = sum;
exports.compact = compact;
exports.unique = unique;
exports.without = without;
exports.union = union;
exports.isImmutable = isImmutable;
exports.toJS = toJS;
exports.toImmutable = toImmutable;

var _immutable = __webpack_require__(5);

function sum(list) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return list.reduce(function (result, item) {
        if (param) {
            return result + (item.get(param, 0) || 0);
        }
        return result + item;
    }, 0);
}

function compact(list) {
    return list.filter(function (item) {
        return !!item;
    });
}

function unique(list, mapper) {
    var map = list.reduce(function (reduction, value) {
        return reduction.set(mapper(value), value);
    }, new _immutable.Map());
    return map.toList();
}

function without(list, item) {
    var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return list.filter(function (x) {
        if (prop) {
            return x.get(prop) !== item.get(prop);
        } else {
            return x !== item;
        }
    });
}

function union() {
    var output = new _immutable.List();

    for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
    }

    var _loop = function _loop() {
        var item = items.shift();
        var prev = new _immutable.Set(output);

        output = item.reduce(function (acc, val) {
            return prev.has(val) ? acc : acc.push(val);
        }, output);
    };

    do {
        _loop();
    } while (items.length);

    return output;
}

function isImmutable(arg) {
    return _immutable.Iterable.isIterable(arg);
}

function toJS(arg) {
    return isImmutable(arg) ? arg.toJS() : arg;
}

function toImmutable(arg) {
    return isImmutable(arg) ? arg : (0, _immutable.fromJS)(arg);
}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(292)('wks');
var uid = __webpack_require__(206);
var Symbol = __webpack_require__(36).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.warnRuleDeprecated = exports.AXURL = exports.fn = exports.devices = exports.browser = exports.role = exports.DOM = exports.aria = exports.hasProp = exports.trueish = exports.listensTo = exports.hiddenFromAT = exports.isInteractive = undefined;

var _symbol = __webpack_require__(286);

var _symbol2 = _interopRequireDefault(_symbol);

var _isInteractive = __webpack_require__(1618);

Object.defineProperty(exports, 'isInteractive', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_isInteractive).default;
    }
});

var _hiddenFromAt = __webpack_require__(1619);

Object.defineProperty(exports, 'hiddenFromAT', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_hiddenFromAt).default;
    }
});

var _listensTo = __webpack_require__(1620);

Object.defineProperty(exports, 'listensTo', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_listensTo).default;
    }
});

var _trueish = __webpack_require__(811);

Object.defineProperty(exports, 'trueish', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_trueish).default;
    }
});

var _hasProp = __webpack_require__(1621);

Object.defineProperty(exports, 'hasProp', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_hasProp).default;
    }
});

var _aria = __webpack_require__(1622);

Object.defineProperty(exports, 'aria', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_aria).default;
    }
});

var _DOM = __webpack_require__(1623);

Object.defineProperty(exports, 'DOM', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DOM).default;
    }
});

var _role = __webpack_require__(1624);

Object.defineProperty(exports, 'role', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_role).default;
    }
});

var _browser = __webpack_require__(812);

Object.defineProperty(exports, 'browser', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_browser).default;
    }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var devices = exports.devices = {
    screenReaders: (0, _symbol2.default)('screenReaders'),
    keyboardOnly: (0, _symbol2.default)('keyboardOnly'),
    mobile: (0, _symbol2.default)('mobile')
};

// simple callback
var fn = exports.fn = function fn() {
    return null;
};

// builds url for specific google AX Rule
var AXURL = exports.AXURL = function AXURL(ax) {
    return 'https://github.com/GoogleChrome/accessibility-developer-tools/wiki/Audit-Rules#' + ax;
};

var warnRuleDeprecated = exports.warnRuleDeprecated = function warnRuleDeprecated(currentRule, newRule) {
    return console.warn('[react-a11y]: Warning: the rule ' + currentRule + ' is deprecated.  Use the rule ' + newRule + ' instead.');
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NotFoundError = exports.UnauthorisedError = exports.BadRequestError = exports.ServerError = exports.RequestError = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _pickBy2 = __webpack_require__(161);

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _API = __webpack_require__(201);

Object.defineProperty(exports, 'RequestError', {
    enumerable: true,
    get: function get() {
        return _API.RequestError;
    }
});
Object.defineProperty(exports, 'ServerError', {
    enumerable: true,
    get: function get() {
        return _API.ServerError;
    }
});
Object.defineProperty(exports, 'BadRequestError', {
    enumerable: true,
    get: function get() {
        return _API.BadRequestError;
    }
});
Object.defineProperty(exports, 'UnauthorisedError', {
    enumerable: true,
    get: function get() {
        return _API.UnauthorisedError;
    }
});
Object.defineProperty(exports, 'NotFoundError', {
    enumerable: true,
    get: function get() {
        return _API.NotFoundError;
    }
});

var _APIClient2 = __webpack_require__(52);

var _TokenStore = __webpack_require__(281);

var _TokenStore2 = _interopRequireDefault(_TokenStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthenticatedAPIClient = function (_APIClient) {
    (0, _inherits3.default)(AuthenticatedAPIClient, _APIClient);

    function AuthenticatedAPIClient() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AuthenticatedAPIClient);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _APIClient.call.apply(_APIClient, [this].concat(args))), _this), _this.additionalHeaders = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    AuthenticatedAPIClient.prototype.getHeaders = function getHeaders() {
        return (0, _assign2.default)({}, _APIClient.prototype.getHeaders.call(this), (0, _pickBy3.default)((0, _extends3.default)({
            'x-customer-token': _TokenStore2.default.getCustomer(),
            'x-customer-device': _TokenStore2.default.getDevice()
        }, this.additionalHeaders), _isString3.default));
    };

    AuthenticatedAPIClient.prototype.setAdditionalHeaders = function setAdditionalHeaders(headers) {
        this.additionalHeaders = headers;
    };

    return AuthenticatedAPIClient;
}(_APIClient2.APIClient);

exports.default = new AuthenticatedAPIClient();

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores(_ref) {
    var name = _ref.name,
        expires = _ref.expires,
        inverse = _ref.inverse;

    var flag = _FeatureFlagStore2.default.get(name);
    if (expires) {
        var expiresDate = _FeatureFlagStore2.default.get(expires);
        flag = flag && (0, _TrainTime2.default)().isBefore((0, _TrainTime2.default)(expiresDate));
    }
    if (inverse) {
        flag = !flag;
    }
    return { flag: flag };
};

var FeatureFlag = (_dec = (0, _connectToStores2.default)([_FeatureFlagStore2.default], _getStateFromStores), _dec(_class = (_temp = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(FeatureFlag, _PureRenderComponent);

    function FeatureFlag() {
        (0, _classCallCheck3.default)(this, FeatureFlag);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    FeatureFlag.prototype.render = function render() {
        var _props = this.props,
            disabled = _props.disabled,
            children = _props.children,
            flag = _props.flag,
            className = _props.className;


        if (disabled || !flag || !children) {
            return null;
        }

        if (_react2.default.Children.count(children) === 1) {
            return children;
        }

        return _react2.default.createElement(
            'div',
            { className: className },
            children
        );
    };

    return FeatureFlag;
}(_PureRenderComponent3.default), _class2.propTypes = {
    name: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node,
    disabled: _propTypes2.default.bool,
    expires: _propTypes2.default.string,
    inverse: _propTypes2.default.bool,
    flag: _propTypes2.default.bool,
    className: _propTypes2.default.string
}, _class2.defaultProps = {
    inverse: false,
    disabled: false,
    expires: null,
    className: null
}, _temp)) || _class);
exports.default = FeatureFlag;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

exports.route = route;
exports.featureRoute = featureRoute;
exports.featureRouteOr = featureRouteOr;
exports.featuresRoute = featuresRoute;
exports.redirectRoute = redirectRoute;

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper for route to help with named routes
 */
function route(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var path = name ? _urls2.default.get(name).spec : null;

    var routeObj = (0, _extends3.default)({
        name: name,
        shouldRefocusRouteContent: function shouldRefocusRouteContent() {
            return true;
        }
    }, options);

    if (path) {
        routeObj.path = path;
    }

    return routeObj;
}

/**
 * Wrapper for route to allow feature flagged routes
 */
function featureRoute(feature) {
    if (!_FeatureFlagStore2.default.get(feature)) {
        return null;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return route.apply(undefined, args);
}

/**
 * Wrapper for route to allow feature flagged routes
 * Allows the route if any of the supplied feature flags are enabled
 */
function featureRouteOr(features) {
    var enabledFeatures = [];

    features.map(function (feature) {
        if (_FeatureFlagStore2.default.get(feature)) {
            enabledFeatures.push(feature);
        }
    });

    if ((0, _isEmpty3.default)(enabledFeatures)) {
        return null;
    }

    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
    }

    return route.apply(undefined, args);
}

function featuresRoute(features) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
    }

    return features.some(function (feature) {
        return !_FeatureFlagStore2.default.get(feature);
    }) ? null : route.apply(undefined, args);
}

function redirectRoute(path, to, params, query) {
    var routeObj = {
        onEnter: function onEnter(nextState, replace) {
            var _window$location = window.location,
                hostname = _window$location.hostname,
                pathname = _window$location.pathname;


            if (hostname === 'localhost') {
                console.error('*** WARNING *** No route found for \'' + pathname + '. Check routes/index.js.');
            }

            replace(_urls2.default.location(to, params, query));
        }
    };
    if (path) {
        routeObj.path = path;
    }
    return routeObj;
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(385);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hoek = __webpack_require__(96);
var Any = __webpack_require__(137);
var Cast = __webpack_require__(318);
var Errors = __webpack_require__(530);
var Lazy = __webpack_require__(1576);
var Ref = __webpack_require__(153);

// Declare internals

var internals = {
    alternatives: __webpack_require__(532),
    array: __webpack_require__(1577),
    boolean: __webpack_require__(805),
    binary: __webpack_require__(1578),
    date: __webpack_require__(531),
    number: __webpack_require__(804),
    object: __webpack_require__(806),
    string: __webpack_require__(802)
};

internals.root = function () {

    var any = new Any();

    var root = any.clone();
    root.any = function () {

        Hoek.assert(arguments.length === 0, 'Joi.any() does not allow arguments.');

        return any;
    };

    root.alternatives = root.alt = function () {

        return arguments.length ? internals.alternatives.try.apply(internals.alternatives, arguments) : internals.alternatives;
    };

    root.array = function () {

        Hoek.assert(arguments.length === 0, 'Joi.array() does not allow arguments.');

        return internals.array;
    };

    root.boolean = root.bool = function () {

        Hoek.assert(arguments.length === 0, 'Joi.boolean() does not allow arguments.');

        return internals.boolean;
    };

    root.binary = function () {

        Hoek.assert(arguments.length === 0, 'Joi.binary() does not allow arguments.');

        return internals.binary;
    };

    root.date = function () {

        Hoek.assert(arguments.length === 0, 'Joi.date() does not allow arguments.');

        return internals.date;
    };

    root.func = function () {

        Hoek.assert(arguments.length === 0, 'Joi.func() does not allow arguments.');

        return internals.object._func();
    };

    root.number = function () {

        Hoek.assert(arguments.length === 0, 'Joi.number() does not allow arguments.');

        return internals.number;
    };

    root.object = function () {

        return arguments.length ? internals.object.keys.apply(internals.object, arguments) : internals.object;
    };

    root.string = function () {

        Hoek.assert(arguments.length === 0, 'Joi.string() does not allow arguments.');

        return internals.string;
    };

    root.ref = function () {

        return Ref.create.apply(null, arguments);
    };

    root.isRef = function (ref) {

        return Ref.isRef(ref);
    };

    root.validate = function (value /*, [schema], [options], callback */) {

        var last = arguments[arguments.length - 1];
        var callback = typeof last === 'function' ? last : null;

        var count = arguments.length - (callback ? 1 : 0);
        if (count === 1) {
            return any.validate(value, callback);
        }

        var options = count === 3 ? arguments[2] : {};
        var schema = root.compile(arguments[1]);

        return schema._validateWithOptions(value, options, callback);
    };

    root.describe = function () {

        var schema = arguments.length ? root.compile(arguments[0]) : any;
        return schema.describe();
    };

    root.compile = function (schema) {

        try {
            return Cast.schema(schema);
        } catch (err) {
            if (err.hasOwnProperty('path')) {
                err.message = err.message + '(' + err.path + ')';
            }
            throw err;
        }
    };

    root.assert = function (value, schema, message) {

        root.attempt(value, schema, message);
    };

    root.attempt = function (value, schema, message) {

        var result = root.validate(value, schema);
        var error = result.error;
        if (error) {
            if (!message) {
                if (typeof error.annotate === 'function') {
                    error.message = error.annotate();
                }
                throw error;
            }

            if (!(message instanceof Error)) {
                if (typeof error.annotate === 'function') {
                    error.message = message + ' ' + error.annotate();
                }
                throw error;
            }

            throw message;
        }

        return result.value;
    };

    root.reach = function (schema, path) {

        Hoek.assert(schema && schema instanceof Any, 'you must provide a joi schema');
        Hoek.assert(typeof path === 'string', 'path must be a string');

        if (path === '') {
            return schema;
        }

        var parts = path.split('.');
        var children = schema._inner.children;
        if (!children) {
            return;
        }

        var key = parts[0];
        for (var i = 0; i < children.length; ++i) {
            var child = children[i];
            if (child.key === key) {
                return this.reach(child.schema, path.substr(key.length + 1));
            }
        }
    };

    root.lazy = function (fn) {

        return Lazy.set(fn);
    };

    root.extend = function () {
        var _this = this;

        var extensions = Hoek.flatten(Array.prototype.slice.call(arguments));
        Hoek.assert(extensions.length > 0, 'You need to provide at least one extension');

        this.assert(extensions, root.extensionsSchema);

        var joi = (0, _create2.default)(this.any());
        (0, _assign2.default)(joi, this);

        var _loop = function _loop(i) {
            var extension = extensions[i];

            if (typeof extension === 'function') {
                extension = extension(joi);
            }

            _this.assert(extension, root.extensionSchema);

            var base = (extension.base || _this.any()).clone(); // Cloning because we're going to override language afterwards
            var ctor = base.constructor;
            var type = function (_ctor) {
                (0, _inherits3.default)(type, _ctor);

                // eslint-disable-line no-loop-func

                function type() {
                    (0, _classCallCheck3.default)(this, type);

                    var _this2 = (0, _possibleConstructorReturn3.default)(this, _ctor.call(this));

                    if (extension.base) {
                        (0, _assign2.default)(_this2, base);
                    }

                    _this2._type = extension.name;

                    if (extension.language) {
                        var _Hoek$applyToDefaults;

                        _this2._settings = _this2._settings || { language: {} };
                        _this2._settings.language = Hoek.applyToDefaults(_this2._settings.language, (_Hoek$applyToDefaults = {}, _Hoek$applyToDefaults[extension.name] = extension.language, _Hoek$applyToDefaults));
                    }
                    return _this2;
                }

                return type;
            }(ctor);

            if (extension.coerce) {
                type.prototype._coerce = function (value, state, options) {

                    if (ctor.prototype._coerce) {
                        var baseRet = ctor.prototype._coerce.call(this, value, state, options);

                        if (baseRet.errors) {
                            return baseRet;
                        }

                        value = baseRet.value;
                    }

                    var ret = extension.coerce.call(this, value, state, options);
                    if (ret instanceof Errors.Err) {
                        return { value: value, errors: ret };
                    }

                    return { value: ret };
                };
            }
            if (extension.pre) {
                type.prototype._base = function (value, state, options) {

                    if (ctor.prototype._base) {
                        var baseRet = ctor.prototype._base.call(this, value, state, options);

                        if (baseRet.errors) {
                            return baseRet;
                        }

                        value = baseRet.value;
                    }

                    var ret = extension.pre.call(this, value, state, options);
                    if (ret instanceof Errors.Err) {
                        return { value: value, errors: ret };
                    }

                    return { value: ret };
                };
            }

            if (extension.rules) {
                var _loop2 = function _loop2(j) {
                    var rule = extension.rules[j];
                    var ruleArgs = rule.params ? rule.params instanceof Any ? rule.params._inner.children.map(function (k) {
                        return k.key;
                    }) : (0, _keys2.default)(rule.params) : [];
                    var validateArgs = rule.params ? Cast.schema(rule.params) : null;

                    type.prototype[rule.name] = function () {
                        // eslint-disable-line no-loop-func

                        if (arguments.length > ruleArgs.length) {
                            throw new Error('Unexpected number of arguments');
                        }

                        var args = Array.prototype.slice.call(arguments);
                        var hasRef = false;
                        var arg = {};

                        for (var k = 0; k < ruleArgs.length; ++k) {
                            arg[ruleArgs[k]] = args[k];
                            if (!hasRef && Ref.isRef(args[k])) {
                                hasRef = true;
                            }
                        }

                        if (validateArgs) {
                            arg = joi.attempt(arg, validateArgs);
                        }

                        var schema = void 0;
                        if (rule.validate) {
                            var validate = function validate(value, state, options) {

                                return rule.validate.call(this, arg, value, state, options);
                            };

                            schema = this._test(rule.name, arg, validate, {
                                description: rule.description,
                                hasRef: hasRef
                            });
                        } else {
                            schema = this.clone();
                        }

                        if (rule.setup) {
                            var newSchema = rule.setup.call(schema, arg);
                            if (newSchema !== undefined) {
                                Hoek.assert(newSchema instanceof Any, 'Setup of extension Joi.' + this._type + '().' + rule.name + '() must return undefined or a Joi object');
                                schema = newSchema;
                            }
                        }

                        return schema;
                    };
                };

                for (var j = 0; j < extension.rules.length; ++j) {
                    _loop2(j);
                }
            }

            if (extension.describe) {
                type.prototype.describe = function () {

                    var description = ctor.prototype.describe.call(this);
                    return extension.describe.call(this, description);
                };
            }

            var instance = new type();
            joi[extension.name] = function () {

                return instance;
            };
        };

        for (var i = 0; i < extensions.length; ++i) {
            _loop(i);
        }

        return joi;
    };

    root.extensionSchema = internals.object.keys({
        base: internals.object.type(Any, 'Joi object'),
        name: internals.string.required(),
        coerce: internals.object._func().arity(3),
        pre: internals.object._func().arity(3),
        language: internals.object,
        describe: internals.object._func().arity(1),
        rules: internals.array.items(internals.object.keys({
            name: internals.string.required(),
            setup: internals.object._func().arity(1),
            validate: internals.object._func().arity(4),
            params: [internals.object.pattern(/.*/, internals.object.type(Any, 'Joi object')), internals.object.type(internals.object.constructor, 'Joi object')],
            description: [internals.string, internals.object._func().arity(1)]
        }).or('setup', 'validate'))
    }).strict();

    root.extensionsSchema = internals.array.items([internals.object, internals.object._func().arity(1)]).strict();

    root.version = __webpack_require__(1579).version;

    return root;
};

module.exports = internals.root();

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(133);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(40)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(252)(module)))

/***/ }),
/* 68 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(82);
var core = __webpack_require__(49);
var ctx = __webpack_require__(164);
var hide = __webpack_require__(182);
var has = __webpack_require__(184);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(187),
    isFunction = __webpack_require__(202),
    toKey = __webpack_require__(188);

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = castPath(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(31);
var IE8_DOM_DEFINE = __webpack_require__(688);
var toPrimitive = __webpack_require__(148);
var dP = Object.defineProperty;

exports.f = __webpack_require__(66) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(149);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1515), __esModule: true };

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Customer = __webpack_require__(795);

var _Customer2 = _interopRequireDefault(_Customer);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    customer: null
};

var User = function (_record) {
    (0, _inherits3.default)(User, _record);

    function User() {
        (0, _classCallCheck3.default)(this, User);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    User.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var customerData = json.customer ? json.customer : (0, _values2.default)(json).length ? json : undefined;
        var customer = (0, _LinkMapper.resolve)(customerData).as(_Customer2.default);
        return new User({ customer: customer });
    };

    User.prototype.getCustomerProp = function getCustomerProp() {
        for (var _len = arguments.length, path = Array(_len), _key = 0; _key < _len; _key++) {
            path[_key] = arguments[_key];
        }

        return this.getIn(['customer'].concat(path));
    };

    User.prototype.setAuthToken = function setAuthToken(token) {
        if (this.customer) {
            return this.setIn(['customer', 'accessToken'], token);
        } else {
            return User.fromJSON({ customer: { accessToken: token } });
        }
    };

    User.prototype.isLoggedIn = function isLoggedIn() {
        return !!(this.authToken && this.authToken.isValid());
    };

    User.prototype.isFullyLoaded = function isFullyLoaded() {
        return this.isLoggedIn() && this.created;
    };

    User.prototype.isChild = function isChild() {
        return this.customer && this.customer.isChild();
    };

    User.prototype.isAdult = function isAdult() {
        return !this.isChild();
    };

    User.prototype.hasIdentityProvider = function hasIdentityProvider(provider) {
        return this.customer && this.customer.hasIdentityProvider(provider);
    };

    User.prototype.removeIdentityProvider = function removeIdentityProvider(provider) {
        if (this.customer) {
            var newCustomer = this.customer && this.customer.removeIdentityProvider(provider);

            return this.set('customer', newCustomer);
        }

        return false;
    };

    User.prototype.setTelephoneNumber = function setTelephoneNumber(telephoneNumber) {
        return this.setIn(['customer', 'telephoneNumber'], telephoneNumber);
    };

    User.prototype.setHasRegisteredSmartcard = function setHasRegisteredSmartcard(value) {
        return this.setIn(['customer', 'smartcardRegistered'], value);
    };

    User.prototype.setOneClickDelayRepayOptedIn = function setOneClickDelayRepayOptedIn(value) {
        return this.setIn(['customer', 'autoDrOptedIn'], value);
    };

    User.prototype.setAddresses = function setAddresses(addresses) {
        return this.setIn(['customer', 'addresses'], addresses);
    };

    User.prototype.setIdentityProviders = function setIdentityProviders(identityProviders) {
        return this.setIn(['customer', 'identityProviders'], identityProviders);
    };

    User.prototype.setPreferences = function setPreferences(preferences) {
        return this.setIn(['customer', 'preferences'], preferences);
    };

    User.prototype.setAutoDrOptedIn = function setAutoDrOptedIn() {
        var isSubscribed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return this.setIn(['customer', 'autoDrOptedIn'], isSubscribed);
    };

    User.prototype.setIsOver16 = function setIsOver16(isOver16) {
        return this.setIn(['customer', 'isOver16'], isOver16);
    };

    User.prototype.getSmartcardAddress = function getSmartcardAddress() {
        return this.addresses.find(function (address) {
            return address.isSmartcardAddress();
        });
    };

    (0, _createClass3.default)(User, [{
        key: 'accessToken',
        get: function get() {
            return this.getCustomerProp('accessToken', 'accessToken');
        }
    }, {
        key: 'accessTokenDevice',
        get: function get() {
            return this.getCustomerProp('accessToken', 'customerDevice');
        }
    }, {
        key: 'refreshToken',
        get: function get() {
            return this.getCustomerProp('accessToken', 'refreshToken');
        }
    }, {
        key: 'authToken',
        get: function get() {
            return this.getCustomerProp('accessToken');
        }
    }, {
        key: 'fullName',
        get: function get() {
            return [this.title, this.firstNames, this.surname].join(' ');
        }
    }, {
        key: 'title',
        get: function get() {
            return this.getCustomerProp('title');
        }
    }, {
        key: 'firstNames',
        get: function get() {
            return this.getCustomerProp('firstNames');
        }
    }, {
        key: 'surname',
        get: function get() {
            return this.getCustomerProp('surname');
        }
    }, {
        key: 'telephoneNumber',
        get: function get() {
            return this.getCustomerProp('telephoneNumber');
        }
    }, {
        key: 'email',
        get: function get() {
            return this.getCustomerProp('email');
        }
    }, {
        key: 'id',
        get: function get() {
            // id comes from the access token when logging in, otherwise it's in the customer :-/
            var accessToken = this.getCustomerProp('accessToken');
            return this.getCustomerProp('id') || accessToken && accessToken.getIn(['customer', 'id']);
        }
    }, {
        key: 'smartcardRegistered',
        get: function get() {
            return this.getCustomerProp('smartcardRegistered');
        }
    }, {
        key: 'addresses',
        get: function get() {
            return this.getCustomerProp('addresses') || new _immutable.List();
        }
    }, {
        key: 'deliveryAddresses',
        get: function get() {
            var addresses = this.addresses;
            return addresses.filter(function (address) {
                return address.contactName && address.country === _config2.default.get('defaultDeliveryCountry');
            });
        }
    }, {
        key: 'created',
        get: function get() {
            return this.getCustomerProp('created');
        }
    }, {
        key: 'dateOfBirth',
        get: function get() {
            return this.getCustomerProp('dateOfBirth');
        }
    }, {
        key: 'preferences',
        get: function get() {
            return this.getCustomerProp('preferences');
        }
    }, {
        key: 'autoDrOptedIn',
        get: function get() {
            return this.getIn(['customer', 'autoDrOptedIn']);
        }
    }, {
        key: 'isOver16',
        get: function get() {
            return this.getCustomerProp('isOver16');
        }
    }, {
        key: 'brandChosen',
        get: function get() {
            return this.getCustomerProp('brandChosen');
        }
    }, {
        key: 'deactivationRequests',
        get: function get() {
            return this.getCustomerProp('deactivationRequests');
        }
    }]);
    return User;
}((0, _immutable.Record)(defaults));

exports.default = User;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _set2 = __webpack_require__(394);

var _set3 = _interopRequireDefault(_set2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _Route = __webpack_require__(319);

var _Route2 = _interopRequireDefault(_Route);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _Ticket = __webpack_require__(239);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _Journey = __webpack_require__(816);

var _Journey2 = _interopRequireDefault(_Journey);

var _RailcardTickets = __webpack_require__(1683);

var _RailcardTickets2 = _interopRequireDefault(_RailcardTickets);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _LinkMapper = __webpack_require__(8);

var _Immutable = __webpack_require__(54);

var _Railcards = __webpack_require__(818);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    fareId: null,
    origin: new _Station2.default(),
    destination: new _Station2.default(),
    route: new _Route2.default(),
    ticketType: new _TicketType2.default(),
    smartTicketType: null,
    crossLondon: false,
    restrictionCode: null,
    outwardJourney: new _Journey2.default(),
    returnJourney: new _Journey2.default(),
    tickets: new _immutable.List()
};

var OrderFare = function (_Record) {
    (0, _inherits3.default)(OrderFare, _Record);

    function OrderFare() {
        (0, _classCallCheck3.default)(this, OrderFare);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap
    OrderFare.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new OrderFare({
            id: json.id,
            fareId: json.fareId,
            origin: (0, _LinkMapper.resolve)(json.origin).as(_Station2.default),
            destination: (0, _LinkMapper.resolve)(json.destination).as(_Station2.default),
            route: (0, _LinkMapper.resolve)(json.routeCode || json.route).as(_Route2.default),
            ticketType: (0, _LinkMapper.resolve)(json.ticketTypeCode || json.ticketType).as(_TicketType2.default),
            smartTicketType: (0, _LinkMapper.resolve)(json.smartTicketTypeCode).with(String),
            crossLondon: (0, _LinkMapper.resolve)(json.crossLondon).with(Boolean),
            restrictionCode: (0, _LinkMapper.resolve)(json.restrictionCode).with(String),
            outwardJourney: (0, _LinkMapper.resolve)(json.outwardJourney).as(_Journey2.default),
            returnJourney: (0, _LinkMapper.resolve)(json.returnJourney).as(_Journey2.default),
            tickets: (0, _LinkMapper.resolveAll)(json.tickets).as(_Ticket2.default)
        });
    };

    OrderFare.prototype.getName = function getName() {
        return this.ticketType.name;
    };

    OrderFare.prototype.getDescription = function getDescription() {
        return this.route.description.length > 1 ? this.route.description : null;
    };

    OrderFare.prototype.isReturn = function isReturn() {
        return this.ticketType.isReturn;
    };

    OrderFare.prototype.isGroupSave = function isGroupSave() {
        return this.tickets.some(function (ticket) {
            return ticket.isGroupSave();
        });
    };

    OrderFare.prototype.isDaySave = function isDaySave() {
        return this.ticketType.isDaySave();
    };

    OrderFare.prototype.isDaySaveOffPeak = function isDaySaveOffPeak() {
        return this.ticketType.isDaySaveOffPeak();
    };

    OrderFare.prototype.isRoversRangers = function isRoversRangers() {
        return this.ticketType.isRoversRangers();
    };

    OrderFare.prototype.isCarnet = function isCarnet() {
        return this.ticketType.isCarnet;
    };

    OrderFare.prototype.isPlusBus = function isPlusBus() {
        return this.ticketType.isPlusBus();
    };

    OrderFare.prototype.isSeason = function isSeason() {
        return this.ticketType.isSeason;
    };

    OrderFare.prototype.isCrossLondon = function isCrossLondon() {
        return this.crossLondon;
    };

    OrderFare.prototype.isFlexi = function isFlexi() {
        return this.ticketType.isFlexi;
    };

    OrderFare.prototype.isAdvance = function isAdvance() {
        return this.ticketType.isAdvance;
    };

    OrderFare.prototype.isOpenGolf = function isOpenGolf() {
        return this.ticketType && this.ticketType.code && this.ticketType.code.match(_AppConstants.OPEN_GOLF_TICKET_CODE_REGEX);
    };

    OrderFare.prototype.isSmartcard = function isSmartcard() {
        return this.tickets.some(function (ticket) {
            return ticket.getIn(['passenger', 'smartcardNumber']);
        });
    };

    OrderFare.prototype.isSmartCarnet = function isSmartCarnet() {
        return this.ticketType.isSmartCarnet();
    };

    OrderFare.prototype.isStandard = function isStandard() {
        return !this.ticketType.isFirstClass;
    };

    OrderFare.prototype.isFirstClass = function isFirstClass() {
        return this.ticketType.isFirstClass;
    };

    OrderFare.prototype.adultTickets = function adultTickets() {
        return this.tickets.filter(function (ticket) {
            return ticket.adults;
        });
    };

    OrderFare.prototype.adults = function adults() {
        return this.isSmartCarnet() ? 1 : (0, _Immutable.sum)(this.adultTickets(), 'adults');
    };

    OrderFare.prototype.childTickets = function childTickets() {
        return this.tickets.filter(function (ticket) {
            return ticket.children;
        });
    };

    OrderFare.prototype.children = function children() {
        return (0, _Immutable.sum)(this.childTickets(), 'children');
    };

    OrderFare.prototype.getAdultTotalPrice = function getAdultTotalPrice() {
        return this.getTotalPrice(this.adultTickets());
    };

    OrderFare.prototype.getChildTotalPrice = function getChildTotalPrice() {
        return this.getTotalPrice(this.childTickets());
    };

    OrderFare.prototype.getTotalPrice = function getTotalPrice() {
        var tickets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tickets;

        return (0, _Immutable.sum)(tickets, 'price');
    };

    OrderFare.prototype.getMatchingTicketPrice = function getMatchingTicketPrice(price) {
        var sortedTickets = this.tickets.sortBy(function (x) {
            return x.price;
        });
        var match = sortedTickets.find(function (ticket) {
            return ticket.price >= price;
        });
        return match && match.price;
    };

    OrderFare.prototype.getRailcards = function getRailcards() {
        var tickets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tickets;

        var railcards = (0, _Immutable.compact)(tickets.map(function (t) {
            return t.railcard;
        }));
        return (0, _Immutable.unique)(railcards, function (r) {
            return r.code;
        });
    };

    OrderFare.prototype.getRefundableTickets = function getRefundableTickets() {
        return this.tickets.filter(function (ticket) {
            return ticket.isRefundable;
        });
    };

    OrderFare.prototype.getTicketsWithRailCard = function getTicketsWithRailCard(railcard) {
        var tickets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.tickets;

        var railcardTickets = tickets.filter(function (ticket) {
            return ticket.hasRailcard(railcard);
        });
        return new _RailcardTickets2.default().concat(railcardTickets);
    };

    OrderFare.prototype.getPlusBusTickets = function getPlusBusTickets() {
        return this.isPlusBus() ? this.tickets : new _immutable.List();
    };

    OrderFare.prototype.getRailcardTickets = function getRailcardTickets() {
        var _this2 = this;

        return this.getRailcards().map(function (railcard) {
            return _this2.getTicketsWithRailCard(railcard);
        });
    };

    OrderFare.prototype.getRailcardCounts = function getRailcardCounts() {
        var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'code';

        return this.tickets.filter(function (railcardTicket) {
            return railcardTicket.railcard && railcardTicket.railcard[property] && !railcardTicket.railcard.isGroupSave();
        }).reduce(function (counts, ticket) {
            return counts.update(ticket.railcard[property], 0, function (quantity) {
                return quantity + 1;
            });
        }, new _immutable.Map());
    };

    OrderFare.prototype.getPassengerRailcards = function getPassengerRailcards() {
        return this.getRailcardCounts().map(function (quantity, code) {
            return new _PassengerRailcard2.default({ code: code, quantity: quantity });
        }).toList();
    };

    OrderFare.prototype.getAllRailcards = function getAllRailcards() {
        return this.tickets.reduce(function (railcards, _ref) {
            var railcard = _ref.railcard;

            if (railcard && railcard.code && !railcard.isGroupSave()) {
                railcards = railcards.push(railcard);
            }
            return railcards;
        }, new _immutable.List());
    };

    OrderFare.prototype.getPhotocardNumber = function getPhotocardNumber() {
        if (!this.isSeason()) {
            return null;
        }

        var passenger = this.getPassengers().first();
        if (!passenger) {
            return null;
        }

        return passenger.get('photocardNumber');
    };

    OrderFare.prototype.hasPhotocardNumber = function hasPhotocardNumber() {
        return !!this.getPhotocardNumber();
    };

    OrderFare.prototype.getValidTo = function getValidTo() {
        var journey = this.returnJourney || this.outwardJourney;
        return journey.validTo;
    };

    OrderFare.prototype.getValidFrom = function getValidFrom() {
        return this.outwardJourney.validFrom;
    };

    OrderFare.prototype.getOutwardValidityPeriod = function getOutwardValidityPeriod() {
        return this.outwardJourney.getValidityPeriod();
    };

    OrderFare.prototype.getDepartureTime = function getDepartureTime() {
        return this.outwardJourney.getDepartureTime();
    };

    OrderFare.prototype.isPrinted = function isPrinted() {
        return this.tickets.every(function (ticket) {
            return ticket.printed;
        });
    };

    OrderFare.prototype.isUnprinted = function isUnprinted() {
        return this.tickets.some(function (ticket) {
            return !ticket.printed;
        });
    };

    OrderFare.prototype.getCarnetInformation = function getCarnetInformation() {
        return this.ticketType.carnetInformation;
    };

    OrderFare.prototype.getFlexiInformation = function getFlexiInformation() {
        return this.ticketType.flexiInformation;
    };

    OrderFare.prototype.hasRefundableTickets = function hasRefundableTickets() {
        return this.tickets.some(function (ticket) {
            return ticket.isRefundable;
        });
    };

    OrderFare.prototype.hasAmendableTickets = function hasAmendableTickets() {
        return this.tickets.some(function (ticket) {
            return ticket.canAmend();
        });
    };

    OrderFare.prototype.hasRefundedTickets = function hasRefundedTickets() {
        return this.tickets.some(function (ticket) {
            return ticket.isRefunded;
        });
    };

    OrderFare.prototype.isReorderable = function isReorderable() {
        return !(this.isPlusBus() || this.isAdvance() || this.isDaySave() || this.isRoversRangers() || this.isOpenGolf());
    };

    OrderFare.prototype.getPassengers = function getPassengers() {
        return (0, _Immutable.compact)(this.tickets.map(function (ticket) {
            return ticket.passenger;
        }));
    };

    OrderFare.prototype.hasRailcard = function hasRailcard() {
        return this.tickets.some(function (ticket) {
            return ticket.railcard && !ticket.isGroupSave();
        });
    };

    OrderFare.prototype.hasTicket = function hasTicket(id) {
        return this.tickets.some(function (ticket) {
            return ticket.id === id;
        });
    };

    OrderFare.prototype.isTravelcard = function isTravelcard() {
        return this.origin.isTravelcard() || this.destination.isTravelcard();
    };

    OrderFare.prototype.isExcludedFromFavourites = function isExcludedFromFavourites() {
        var _this3 = this;

        return this.ticketType && _AppConstants.FavouriteExcludedTicketTypes.some(function (excludedCode) {
            return _this3.ticketType.code && _this3.ticketType.code.match(excludedCode);
        });
    };

    OrderFare.prototype.matchFare = function matchFare(fare) {
        return this.origin.nlc === fare.origin.nlc && this.destination.nlc === fare.destination.nlc && this.adults() === fare.adults() && this.children() === fare.children() && this.route.code === fare.route.code && this.ticketType.code === fare.ticketType.code && this.isSeason() === fare.isSeason() && this.isReturn() === fare.isReturn() && (this.ticketType.isSeason ? this.getOutwardValidityDurationString() === fare.getOutwardValidityDurationString() : true) && (0, _Railcards.matchRailcards)(this, fare);
    };

    OrderFare.prototype.getOutwardValidityDurationString = function getOutwardValidityDurationString() {
        return this.getOutwardValidityPeriod().toDuration().toJSON();
    };

    OrderFare.prototype.getNRELinkParams = function getNRELinkParams() {
        var fareClass = 'Standard';
        if (this.isFirstClass()) {
            fareClass = 'First';
        }
        return {
            origin: this.origin.crs || this.origin.nlc,
            destination: this.destination.crs || this.destination.nlc,
            outwardDate: (0, _moment2.default)(this.outwardJourney.validFrom._d).format('DD-MMM-YY'),
            fareClass: fareClass
        };
    };

    OrderFare.prototype.getNRELinkQuery = function getNRELinkQuery() {
        var query = {};
        if (this.isReturn() && this.returnJourney && !!this.returnJourney.legs.size) {
            (0, _set3.default)(query, 'returnDate', (0, _moment2.default)(this.returnJourney.validFrom._d).format('DD-MMM-YY'));
        }
        return query;
    };

    OrderFare.prototype.hasDisabledPeopleRailcard = function hasDisabledPeopleRailcard() {
        return this.tickets.some(function (ticket) {
            return ticket.hasDisabledPeopleRailcard();
        });
    };

    OrderFare.prototype.getNumberOfPasses = function getNumberOfPasses() {
        if (this.isSmartCarnet()) {
            return this.tickets.size * _AppConstants.SmartCarnetValidation.PASSES_PER_BOOK;
        }

        if (this.isFlexi()) {
            return this.ticketType.flexiInformation.numberOfTickets;
        }

        return null;
    };

    OrderFare.prototype.hasRailcard1617 = function hasRailcard1617() {
        return this.tickets.some(function (ticket) {
            return ticket.hasRailcard1617();
        });
    };

    OrderFare.prototype.hasRailcardJCP = function hasRailcardJCP() {
        return this.tickets.some(function (ticket) {
            return ticket.hasRailcardJCP();
        });
    };

    OrderFare.prototype.hasCountedPlaceWarning = function hasCountedPlaceWarning() {
        var tocs = _config2.default.get('showCountedPlaceWarnings');
        if (!tocs || tocs.length === 0) {
            return false;
        }

        var legs = [].concat(this.outwardJourney ? this.outwardJourney.legs.toArray() : []).concat(this.returnJourney ? this.returnJourney.legs.toArray() : []);
        return legs.some(function (leg) {
            return leg.reservable === _AppConstants.ReservableStates.COMPULSORY && leg.hasCountedPlaceSeats() && tocs.includes(leg.getIn(['toc', 'code']));
        });
    };

    OrderFare.prototype.isTPEGroupSave = function isTPEGroupSave() {
        return this.discountCode === _AppConstants.TPE_GROUP_SAVE_CODE;
    };

    return OrderFare;
}((0, _immutable.Record)(defaults));

exports.default = OrderFare;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

var _default = createChainedFunction;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.OrderStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _isBoolean2 = __webpack_require__(1139);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _map2 = __webpack_require__(314);

var _map3 = _interopRequireDefault(_map2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _FavouritesStore = __webpack_require__(271);

var _FavouritesStore2 = _interopRequireDefault(_FavouritesStore);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderStore = exports.OrderStore = function (_BaseStore) {
    (0, _inherits3.default)(OrderStore, _BaseStore);

    function OrderStore() {
        (0, _classCallCheck3.default)(this, OrderStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    OrderStore.prototype.deserialize = function deserialize(serialized) {
        var state = new _immutable.Map({
            isLoading: false,
            discountCodeLoading: false,
            discountCodeMessage: null,
            isLoadingDeliveryOptions: false,
            postalFulfilmentStoredAddress: null,
            handoffDetails: null,
            handoffReferralReported: false
        });
        if (serialized) {
            (0, _map3.default)(serialized, function (value, key) {
                if (key === 'discountCodeMessage' || key === 'postalFulfilmentStoredAddress') {
                    state = state.set(key, null);
                } //investigate
                else if (value) {
                        state = state.set(key, _Order2.default.fromJSON(value));
                    }
            });
        }
        return state;
    };

    OrderStore.prototype.setLoading = function setLoading(_ref) {
        var isLoading = _ref.isLoading;

        return this.setState(this.state.set('isLoading', isLoading));
    };

    OrderStore.prototype.setLoadingDeliveryOptions = function setLoadingDeliveryOptions(_ref2) {
        var isLoadingDeliveryOptions = _ref2.isLoadingDeliveryOptions;

        return this.setState(this.state.set('isLoadingDeliveryOptions', isLoadingDeliveryOptions));
    };

    OrderStore.prototype.getLoading = function getLoading() {
        return this.state.get('isLoading');
    };

    OrderStore.prototype.getLoadingDeliveryOptions = function getLoadingDeliveryOptions() {
        return this.state.get('isLoadingDeliveryOptions');
    };

    OrderStore.prototype.getDiscountCodeLoading = function getDiscountCodeLoading() {
        return this.state.get('discountCodeLoading');
    };

    OrderStore.prototype.getDiscountCodeMessage = function getDiscountCodeMessage() {
        return this.state.get('discountCodeMessage');
    };

    OrderStore.prototype.getCurrent = function getCurrent() {
        return this.state.get('current', new _Order2.default());
    };

    OrderStore.prototype.setCurrent = function setCurrent(order) {
        this.setState(this.state.set('current', order));
    };

    OrderStore.prototype.handleOrderPaid = function handleOrderPaid(_ref3) {
        var order = _ref3.order;

        var newState = this.state.set('current', new _Order2.default()) //Clear the current order
        .set('paid', order); //Save it as a paid order

        this.setState(newState);
    };

    OrderStore.prototype.clearPaidOrder = function clearPaidOrder() {
        var newState = this.state.set('paid', new _Order2.default());
        this.setState(newState);
    };

    OrderStore.prototype.getPaid = function getPaid() {
        return this.state.get('paid');
    };

    OrderStore.prototype.setPostalFulfilmentStoredAddress = function setPostalFulfilmentStoredAddress(address) {
        return this.setState(this.state.set('postalFulfilmentStoredAddress', address));
    };

    OrderStore.prototype.getPostalFulfilmentStoredAddress = function getPostalFulfilmentStoredAddress() {
        return this.state.get('postalFulfilmentStoredAddress');
    };

    OrderStore.prototype.handleOrderCreated = function handleOrderCreated(_ref4) {
        var order = _ref4.order;

        this.setCurrent(order);
    };

    OrderStore.prototype.handleFulfilmentUpdated = function handleFulfilmentUpdated(_ref5) {
        var path = _ref5.path,
            value = _ref5.value;

        var current = this.getCurrent();
        path.unshift('delivery');

        current = current.setIn(path, value);
        this.setCurrent(current.set('totalPrice', current.getTotalPriceWithDelivery()));
    };

    OrderStore.prototype.handleFulfilmentMethodUpdated = function handleFulfilmentMethodUpdated(_ref6) {
        var deliveryOption = _ref6.deliveryOption;

        var current = this.getCurrent();

        current = current.set('delivery', current.delivery.setOption(deliveryOption));
        this.setCurrent(current.set('totalPrice', current.getTotalPriceWithDelivery()));
    };

    OrderStore.prototype.handlePostalFulfilmentStoredAddress = function handlePostalFulfilmentStoredAddress(_ref7) {
        var address = _ref7.address;

        this.setPostalFulfilmentStoredAddress(address);
    };

    OrderStore.prototype.handleOrderUpdated = function handleOrderUpdated(_ref8) {
        var order = _ref8.order;

        var updatedOrder = order
        // Delivery details are deleted
        // when deleting a trip from an order - so we should
        // maintain what we had chosen before
        .set('delivery', this.getCurrent().get('delivery'))
        // API-BUG: Keep the fulfilment values, as this isnt in the api yet
        .set('availableDeliveryOptions', this.getCurrent().get('availableDeliveryOptions'));

        this.setCurrent(updatedOrder);
    };

    OrderStore.prototype.handleLeadPassengerUpdated = function handleLeadPassengerUpdated(_ref9) {
        var trip = _ref9.trip,
            leadPassengerName = _ref9.leadPassengerName;

        var order = this.getCurrent();
        var index = order.trips.indexOf(trip);
        var updatedOrder = order.setIn(['trips', index, 'selfPrintPassenger'], leadPassengerName);
        this.setCurrent(updatedOrder);
    };

    OrderStore.prototype.handlePaymentStarted = function handlePaymentStarted() {
        this.setState(this.state.set('paid', null));
    };

    OrderStore.prototype.handleOrderDeleted = function handleOrderDeleted() {
        var newState = this.state.set('current', new _Order2.default()).set('paid', new _Order2.default());
        this.setState(newState);
    };

    OrderStore.prototype.handleNewDeliveryOptions = function handleNewDeliveryOptions(_ref10) {
        var deliveryOptions = _ref10.deliveryOptions;

        var updatedOrder = this.getCurrent().setAvailableDeliveryOptions(deliveryOptions);
        var updatedOption = void 0;

        // Check if any favourite fares (with delivery attached) exist in the order
        // and set the delivery to match that of the most recently added favourite fare
        if (updatedOrder.includesFavouriteFare(true)) {
            var mostRecentFare = updatedOrder.getFaresIncludedInFavourites(true).last();
            var orderTrip = updatedOrder.trips.filter(function (trip) {
                return trip.hasFare(mostRecentFare);
            }).first();
            var favouriteDelivery = _FavouritesStore2.default.getFavourite(mostRecentFare, orderTrip).get('delivery');
            updatedOption = deliveryOptions.find(function (_ref11) {
                var id = _ref11.id;
                return id === favouriteDelivery.deliveryMethodId;
            });
        } else if (_config2.default.get('enableDefaultFulfilmentEticket')) {
            updatedOption = deliveryOptions.find(function (_ref12) {
                var fulfilmentMethod = _ref12.fulfilmentMethod;
                return fulfilmentMethod === _AppConstants.FulfilmentType.E_TICKET;
            });
        } else if (_config2.default.get('enableDefaultFulfilmentSmartcard')) {
            updatedOption = deliveryOptions.find(function (_ref13) {
                var fulfilmentMethod = _ref13.fulfilmentMethod;
                return fulfilmentMethod === _AppConstants.FulfilmentType.SMARTCARD;
            });
        }

        if (updatedOption) {
            updatedOrder = updatedOrder.setDeliveryOption(updatedOption);
        }

        this.setCurrent(updatedOrder);
    };

    OrderStore.prototype.handleTaxiBookingAvailability = function handleTaxiBookingAvailability(_ref14) {
        var onwardTaxiBookingAvailable = _ref14.onwardTaxiBookingAvailable;

        this.setState(this.state.set('onwardTaxiBookingAvailable', onwardTaxiBookingAvailable));
    };

    OrderStore.prototype.isTaxiBookingAvailable = function isTaxiBookingAvailable() {
        // QUICKFIX: The store defaults this key to an order for some reason
        if ((0, _isBoolean3.default)(this.state.get('onwardTaxiBookingAvailable'))) {
            return this.state.get('onwardTaxiBookingAvailable', false);
        }
        return false;
    };

    OrderStore.prototype.handleCheckDiscountCodeStarted = function handleCheckDiscountCodeStarted() {
        this.setState(this.state.set('discountCodeLoading', true));
    };

    OrderStore.prototype.hideDiscountCodeMessage = function hideDiscountCodeMessage() {
        var newState = this.state.set('discountCodeMessage', '');
        this.setState(newState);
    };

    OrderStore.prototype.handleCheckDiscountCodeFinished = function handleCheckDiscountCodeFinished(_ref15) {
        var _this2 = this;

        var updatedOrder = _ref15.updatedOrder;

        this.handleOrderUpdated({ order: updatedOrder });

        var newState = this.state.set('discountCodeLoading', false).set('discountCodeMessage', (0, _get3.default)(updatedOrder, 'discount.description'));
        this.setState(newState);

        // hiding the message after 2 sec
        setTimeout(function () {
            _this2.hideDiscountCodeMessage();
        }, 2000);
    };

    OrderStore.prototype.handleCheckDiscountCodeFailed = function handleCheckDiscountCodeFailed(_ref16) {
        var _this3 = this;

        var error = _ref16.error;

        var newState = this.state.set('discountCodeLoading', false).set('discountCodeMessage', (0, _get3.default)(error, 'body.errors') && (0, _get3.default)(error, 'body.errors')[0].message);
        this.setState(newState);

        // hiding the message after 2 sec
        setTimeout(function () {
            _this3.hideDiscountCodeMessage();
        }, 2000);
    };

    OrderStore.prototype.handleContactDetailsUpdated = function handleContactDetailsUpdated(_ref17) {
        var email = _ref17.email,
            telephoneNumber = _ref17.telephoneNumber;

        var updated = this.getCurrent().merge({ email: email, telephoneNumber: telephoneNumber });
        this.setCurrent(updated);
    };

    OrderStore.prototype.handleOrderHandoffUpdated = function handleOrderHandoffUpdated(_ref18) {
        var handoffDetails = _ref18.handoffDetails;

        return this.setState(this.state.set('handoffDetails', handoffDetails));
    };

    OrderStore.prototype.getHandoffDetails = function getHandoffDetails() {
        return this.state.get('handoffDetails');
    };

    OrderStore.prototype.handleHandoffReferralReported = function handleHandoffReferralReported(_ref19) {
        var referralReported = _ref19.referralReported;

        return this.setState(this.state.set('handoffReferralReported', referralReported));
    };

    OrderStore.prototype.getHandoffReferralReported = function getHandoffReferralReported() {
        return this.state.get('handoffReferralReported');
    };

    OrderStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref20;

        return _ref20 = {}, _ref20[_AppConstants.ActionTypes.ORDER_LOADING] = this.setLoading, _ref20[_AppConstants.ActionTypes.ORDER_DELIVERY_OPTIONS_LOADING] = this.setLoadingDeliveryOptions, _ref20[_AppConstants.ActionTypes.ORDER_CREATED] = this.handleOrderCreated, _ref20[_AppConstants.ActionTypes.ORDER_REFRESH_LOADED] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.ORDER_TRIP_CREATED] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.ORDER_TRIP_UPDATED] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.ORDER_TRIP_DELETED] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.SET_ORDER_CHARITY_OPTIONS_SUCCESS] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.DELETE_ORDER_CHARITY_OPTIONS_SUCCESS] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.ORDER_TRIP_LEAD_PASSENGER_UPDATED] = this.handleLeadPassengerUpdated, _ref20[_AppConstants.ActionTypes.ORDER_PLUSBUS_UPDATED] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.ORDER_PAID] = this.handleOrderPaid, _ref20[_AppConstants.ActionTypes.ORDER_DELIVERY_OPTIONS_LOADED] = this.handleNewDeliveryOptions, _ref20[_AppConstants.ActionTypes.ORDER_UPDATED] = this.handleOrderUpdated, _ref20[_AppConstants.ActionTypes.FULFILMENT_UPDATED] = this.handleFulfilmentUpdated, _ref20[_AppConstants.ActionTypes.FULFILMENT_METHOD_UPDATED] = this.handleFulfilmentMethodUpdated, _ref20[_AppConstants.ActionTypes.POSTAL_FULFILMENT_STORED_ADDRESS_UPDATED] = this.handlePostalFulfilmentStoredAddress, _ref20[_AppConstants.ActionTypes.ADDRESS_CREATED] = this.handlePostalFulfilmentStoredAddress, _ref20[_AppConstants.ActionTypes.PAYMENT_AUTH_STARTED] = this.handlePaymentStarted, _ref20[_AppConstants.ActionTypes.PAY360_SESSION_CREATED] = this.handlePaymentStarted, _ref20[_AppConstants.ActionTypes.BASKET_CLEARED] = this.handleOrderDeleted, _ref20[_AppConstants.ActionTypes.ORDER_EXPIRED] = this.handleOrderDeleted, _ref20[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleOrderDeleted, _ref20[_AppConstants.ActionTypes.LOGGED_IN] = this.clearPaidOrder, _ref20[_AppConstants.ActionTypes.ORDER_TAXI_BOOKING_AVAILABILITY] = this.handleTaxiBookingAvailability, _ref20[_AppConstants.ActionTypes.ORDER_LOAD_STARTED] = this.handleOrderDeleted, _ref20[_AppConstants.ActionTypes.ORDER_LOADED] = this.handleOrderCreated, _ref20[_AppConstants.ActionTypes.ORDER_LOAD_FAILED] = this.handleOrderDeleted, _ref20[_AppConstants.ActionTypes.ORDER_CONTACT_DETAILS_UPDATED] = this.handleContactDetailsUpdated, _ref20[_AppConstants.ActionTypes.ORDER_HANDOFF_UPDATED] = this.handleOrderHandoffUpdated, _ref20[_AppConstants.ActionTypes.ORDER_HANDOFF_REFERRAL_REPORTED] = this.handleHandoffReferralReported, _ref20[_AppConstants.ActionTypes.APPLY_DISCOUNT_CODE_STARTED] = this.handleCheckDiscountCodeStarted, _ref20[_AppConstants.ActionTypes.APPLY_DISCOUNT_CODE_FINISHED] = this.handleCheckDiscountCodeFinished, _ref20[_AppConstants.ActionTypes.APPLY_DISCOUNT_CODE_FAILED] = this.handleCheckDiscountCodeFailed, _ref20[_AppConstants.ActionTypes.DELETE_DISCOUNT_CODE_STARTED] = this.handleCheckDiscountCodeStarted, _ref20[_AppConstants.ActionTypes.DELETE_DISCOUNT_CODE_FINISHED] = this.handleCheckDiscountCodeFinished, _ref20[_AppConstants.ActionTypes.DELETE_DISCOUNT_CODE_FAILED] = this.handleCheckDiscountCodeFailed, _ref20;
    };

    return OrderStore;
}(_BaseStore3.default);

var storeInstance = new OrderStore({ storageKey: 'orders' });

exports.default = storeInstance;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(64);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _delay2 = __webpack_require__(627);

var _delay3 = _interopRequireDefault(_delay2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Immutable = __webpack_require__(54);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Field = __webpack_require__(1149);

var _Field2 = _interopRequireDefault(_Field);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatedFormField = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(ValidatedFormField, _React$PureComponent);

    function ValidatedFormField() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ValidatedFormField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            visited: !!_this.props.form[_this.props.field] || _this.props.visited
        }, _this._makeHandleBlur = function (_ref) {
            var onBlur = _ref.onBlur;
            return function (field, value) {
                /**
                 *  We don't want this to run right away, as it would show
                 *  Errors for the previous form state.
                 *  Its hacky, but it works until we have a better way
                 *  NOTE: "isMounted()" is not allowed with plain ES6 classes
                 */
                (0, _delay3.default)(function () {
                    if (_this._isMounted) {
                        _this.setState({ visited: true });
                        onBlur(field, value, _this._resetVisited);
                    }
                }, 350);
            };
        }, _this._resetVisited = function () {
            _this.setState({ visited: false });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ValidatedFormField.prototype.componentDidMount = function componentDidMount() {
        this._isMounted = true;
    };

    ValidatedFormField.prototype.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
    };

    ValidatedFormField.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if ('visited' in nextProps && !this.state.visited) {
            this.setState({ visited: nextProps.visited });
        }
        if (nextProps.resetVisited && this.state.visited) {
            this.setState({ visited: false });
        }
    };

    ValidatedFormField.prototype._getError = function _getError(_ref2) {
        var validation = _ref2.validation,
            form = _ref2.form,
            field = _ref2.field,
            error = _ref2.error;

        if (error) {
            return error;
        } else if (validation) {
            return (0, _Immutable.isImmutable)(validation) ? validation.get(field) : validation[field];
        }
        return form.getError(field);
    };

    ValidatedFormField.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            type = _props.type,
            required = _props.required,
            focusForAmend = _props.focusForAmend,
            label = _props.label,
            outsideLabel = _props.outsideLabel,
            hideError = _props.hideError,
            speakDigits = _props.speakDigits;

        var errorMessage = this._getError(this.props);
        var visited = this.props.visited !== undefined ? this.props.visited : this.state.visited;
        var showInvalid = visited && errorMessage;
        var newProps = (0, _omit3.default)(this.props, ['visited']);

        if (showInvalid) {
            newProps.label = label ? _react2.default.createElement(
                'span',
                { 'aria-live': 'polite' },
                label,
                _react2.default.createElement(
                    'span',
                    { className: (0, _classnames2.default)({ "sr-only": ['checkbox', 'radio'].includes(type) }) },
                    (0, _I18n2.default)('error.title'),
                    ': ',
                    errorMessage,
                    '.'
                )
            ) : _react2.default.createElement(
                'span',
                { 'aria-live': 'polite' },
                (0, _I18n2.default)('error.title'),
                ': ',
                errorMessage,
                '.'
            );
            newProps.labelText = label;
        }

        var classNames = (0, _classnames2.default)({
            'input--valid': !showInvalid && type !== 'checkbox',
            'input--invalid': showInvalid && type !== 'checkbox',
            'input--amend': focusForAmend && type === 'select',
            'input--outside-label': outsideLabel,
            'speak-digits': speakDigits
        }, className);

        // Checkbox form fields require the validation state classes to
        // be at a higher level than that of normal text based form fields
        var checkboxClassNames = (0, _classnames2.default)('validated-form-field', {
            'checkbox--required': required && type === 'checkbox',
            'checkbox--valid': !showInvalid && type === 'checkbox',
            'checkbox--invalid': showInvalid && type === 'checkbox',
            'validated-field--required': required,
            'validated-field--valid': !showInvalid,
            'validated-field--invalid': showInvalid
        });

        var errorId = 'form-error-' + type + '-' + this.props.name;
        return _react2.default.createElement(
            'div',
            { className: checkboxClassNames },
            _react2.default.createElement(_Field2.default, (0, _extends3.default)({}, newProps, {
                className: classNames,
                onBlur: this._makeHandleBlur(this.props),
                onFocus: this.props.onFocus,
                'aria-invalid': Boolean(showInvalid)
            }, showInvalid && !hideError && {
                'aria-describedby': this.props['aria-describedby'] || errorId
            })),
            showInvalid && !hideError && _react2.default.createElement(_Error2.default, {
                id: errorId,
                message: errorMessage,
                className: (0, _classnames2.default)(this.props.errorClassName, {
                    'alert--outside-label': outsideLabel
                })
            })
        );
    };

    return ValidatedFormField;
}(_react2.default.PureComponent), _class.propTypes = (0, _extends3.default)({
    outsideLabel: _propTypes2.default.bool,
    visited: _propTypes2.default.bool,
    validation: _propTypes2.default.object,
    error: _propTypes2.default.string,
    errorClassName: _propTypes2.default.string,
    hideError: _propTypes2.default.bool,
    avoidPaste: _propTypes2.default.bool
}, _Field2.default.propTypes), _class.defaultProps = (0, _assign2.default)({}, _Field2.default.defaultProps), _temp2);
exports.default = ValidatedFormField;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deprecateObjectProperties = __webpack_require__(411);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _InternalPropTypes = __webpack_require__(223);

var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

// Deprecated stuff below:

var falsy = exports.falsy = InternalPropTypes.falsy;
var history = exports.history = InternalPropTypes.history;
var location = exports.location = locationShape;
var component = exports.component = InternalPropTypes.component;
var components = exports.components = InternalPropTypes.components;
var route = exports.route = InternalPropTypes.route;
var routes = exports.routes = InternalPropTypes.routes;
var router = exports.router = routerShape;

if (false) {
  var deprecatePropType = function deprecatePropType(propType, message) {
    return function () {
      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
      return propType.apply(undefined, arguments);
    };
  };

  var deprecateInternalPropType = function deprecateInternalPropType(propType) {
    return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
  };

  var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
    return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
  };

  exports.falsy = falsy = deprecateInternalPropType(falsy);
  exports.history = history = deprecateInternalPropType(history);
  exports.component = component = deprecateInternalPropType(component);
  exports.components = components = deprecateInternalPropType(components);
  exports.route = route = deprecateInternalPropType(route);
  exports.routes = routes = deprecateInternalPropType(routes);

  exports.location = location = deprecateRenamedPropType(location, 'location');
  exports.router = router = deprecateRenamedPropType(router, 'router');
}

var defaultExport = {
  falsy: falsy,
  history: history,
  location: location,
  component: component,
  components: components,
  route: route,
  // For some reason, routes was never here.
  router: router
};

if (false) {
  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
}

exports.default = defaultExport;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _LinkMapper = __webpack_require__(8);

var _TripFares = __webpack_require__(1669);

var _TripFares2 = _interopRequireDefault(_TripFares);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LeadPassenger = __webpack_require__(1684);

var _LeadPassenger2 = _interopRequireDefault(_LeadPassenger);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _FavouritesStore = __webpack_require__(271);

var _FavouritesStore2 = _interopRequireDefault(_FavouritesStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    bookingStatus: null,
    bookingReference: null,
    fares: new _TripFares2.default(),
    itso: false,
    selfPrintPassenger: new _LeadPassenger2.default(),
    isSeatsRequested: false
};

var OrderTrip = function (_record) {
    (0, _inherits3.default)(OrderTrip, _record);

    function OrderTrip() {
        (0, _classCallCheck3.default)(this, OrderTrip);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderTrip.prototype.isSmartcard = function isSmartcard() {
        return this.itso;
    };

    OrderTrip.prototype.getType = function getType() {
        if (this.hasDaySaveFare()) {
            return _AppConstants.OrderTripTypes.DAYSAVE;
        }
        if (this.hasRoversRangersFare()) {
            return _AppConstants.OrderTripTypes.ROVERSRANGERS;
        }
        if (this.fares.season) {
            return _AppConstants.OrderTripTypes.SEASON;
        }
        if (this.fares.return) {
            return _AppConstants.OrderTripTypes.RETURN;
        }
        if (this.hasFareOnlyFare()) {
            return _AppConstants.OrderTripTypes.FARE_ONLY;
        }
        if (this.fares.outwardSingle && this.fares.returnSingle) {
            return _AppConstants.OrderTripTypes.RETURN_SINGLES;
        }
        if (this.fares.returnSingle) {
            return _AppConstants.OrderTripTypes.RETURN_SINGLE;
        }

        return _AppConstants.OrderTripTypes.SINGLE;
    };

    OrderTrip.prototype.isSingle = function isSingle() {
        return this.getType() === _AppConstants.OrderTripTypes.SINGLE;
    };

    OrderTrip.prototype.isFareOnly = function isFareOnly() {
        return this.getType() === _AppConstants.OrderTripTypes.FARE_ONLY;
    };

    OrderTrip.prototype.isSeason = function isSeason() {
        return this.getType() === _AppConstants.OrderTripTypes.SEASON;
    };

    OrderTrip.prototype.canAmend = function canAmend() {
        var minsFromNow = (0, _moment2.default)().add(_config2.default.get('amendMinMinutesLeft'), 'minutes');
        var hasValidAdvanceFares = this.getProducts().some(function (fare) {
            return fare.isAdvance() && fare.hasAmendableTickets() && fare.getDepartureTime() && fare.getDepartureTime().isAfter(minsFromNow);
        });
        return !this.isSeason() && hasValidAdvanceFares;
    };

    OrderTrip.prototype.needsJourney = function needsJourney() {
        var type = this.getType();
        return type !== _AppConstants.OrderTripTypes.DAYSAVE && type !== _AppConstants.OrderTripTypes.SEASON && type !== _AppConstants.OrderTripTypes.ROVERSRANGERS && !this.isTransPennineStaffRover();
    };

    OrderTrip.prototype.hasFare = function hasFare(fare) {
        return this.getJourneyFares().contains(fare);
    };

    OrderTrip.prototype.getJourneyFares = function getJourneyFares() {
        var fares = this.fares;

        var journeyFares = new _immutable.List();
        switch (this.getType()) {
            case _AppConstants.OrderTripTypes.DAYSAVE:
                journeyFares = _immutable.List.of(this.getDaySaveFare());
                break;
            case _AppConstants.OrderTripTypes.ROVERSRANGERS:
                journeyFares = _immutable.List.of(this.getRoversRangersFare());
                break;
            case _AppConstants.OrderTripTypes.FARE_ONLY:
                journeyFares = _immutable.List.of(this.getFareOnlyFare());
                break;
            case _AppConstants.OrderTripTypes.RETURN:
                journeyFares = _immutable.List.of(fares.return);
                break;
            case _AppConstants.OrderTripTypes.RETURN_SINGLES:
                journeyFares = _immutable.List.of(fares.outwardSingle, fares.returnSingle);
                break;
            case _AppConstants.OrderTripTypes.RETURN_SINGLE:
                journeyFares = _immutable.List.of(fares.returnSingle);
                break;
            case _AppConstants.OrderTripTypes.SEASON:
                journeyFares = _immutable.List.of(fares.season);
                break;
            default:
                journeyFares = _immutable.List.of(fares.outwardSingle);
        }

        return journeyFares.filter(function (x) {
            return !!x;
        });
    };

    OrderTrip.prototype.getFareByTicketId = function getFareByTicketId(id) {
        return this.getJourneyFares().concat(this.getPlusBusFares()).find(function (fare) {
            return fare.hasTicket(id);
        });
    };

    OrderTrip.prototype.getFaresIncludedInFavourites = function getFaresIncludedInFavourites() {
        var _this2 = this;

        var withDelivery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var favourites = _FavouritesStore2.default.getFavourites();
        return this.getJourneyFares().filter(function (fare) {
            return favourites.filter(function (favourite) {
                return favourite.matchFare(fare, _this2) && (withDelivery ? favourite.delivery : true);
            }).isEmpty() === false;
        });
    };

    OrderTrip.prototype.includesFavouriteFare = function includesFavouriteFare() {
        var withDelivery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return this.getFaresIncludedInFavourites(withDelivery).size > 0;
    };

    OrderTrip.prototype.getPhotocardNumber = function getPhotocardNumber() {
        if (!this.hasSeasonFare) {
            return null;
        }

        var seasonFare = this.getSeasonFare();
        if (!seasonFare.hasPhotocardNumber()) {
            return null;
        }

        return seasonFare.getPhotocardNumber();
    };

    OrderTrip.prototype.hasPhotocardNumber = function hasPhotocardNumber() {
        return !!this.getPhotocardNumber();
    };

    OrderTrip.prototype.getTotalPrice = function getTotalPrice() {
        var fares = this.getJourneyFares().reduce(function (out, fare) {
            return out + fare.getTotalPrice();
        }, 0);
        var plusBus = this.hasPlusBus() ? this.getPlusBus().getTotalPrice() : 0;

        return fares + plusBus;
    };

    OrderTrip.prototype.getDepartureTime = function getDepartureTime() {
        return this.getOutwardJourney().getDepartureTime();
    };

    OrderTrip.prototype.getEarliestTime = function getEarliestTime() {
        var journey = this.getOutwardJourney();
        return this.needsJourney() && journey.getDepartureTime() || journey.validFrom;
    };

    OrderTrip.prototype.getOutwardJourney = function getOutwardJourney() {
        var fare = this.getOutwardFare();
        return fare.outwardJourney || null;
    };

    OrderTrip.prototype.getReturnJourney = function getReturnJourney() {
        if (this.fares.returnSingle) {
            return this.fares.returnSingle.outwardJourney;
        }

        if (this.fares.return) {
            return this.fares.return.returnJourney;
        }

        return null;
    };

    OrderTrip.prototype.hasReturnJourney = function hasReturnJourney() {
        return !!this.getReturnJourney();
    };

    OrderTrip.prototype.getJourneys = function getJourneys() {
        return new _immutable.List([this.getOutwardJourney(), this.getReturnJourney()]).filter(Boolean);
    };

    OrderTrip.prototype.getCleanId = function getCleanId() {
        var regex = /orders\/.*\/trips\/(.*)/;
        var matches = this.id.match(regex);
        if (matches) {
            return matches[1];
        }
        return this.id;
    };

    OrderTrip.prototype.getPlusBus = function getPlusBus() {
        return this.fares.plusBus;
    };

    OrderTrip.prototype.getPlusBusFares = function getPlusBusFares() {
        return this.fares.plusBus.getFares();
    };

    OrderTrip.prototype.hasPlusBus = function hasPlusBus() {
        return !!(this.fares.plusBus && this.getPlusBus().count()) && this.getPlusBusFares().some(function (fare) {
            return fare.getPlusBusTickets().some(function (ticket) {
                return !ticket.isRefunded;
            });
        });
    };

    OrderTrip.prototype.getDaySaveFare = function getDaySaveFare() {
        return this.fares.getDaySaveFare();
    };

    OrderTrip.prototype.getRoversRangersFare = function getRoversRangersFare() {
        return this.fares.getRoversRangersFare();
    };

    OrderTrip.prototype.getSmartCarnetFare = function getSmartCarnetFare() {
        return this.fares.getSmartCarnetFare();
    };

    OrderTrip.prototype.hasDaySaveFare = function hasDaySaveFare() {
        return !!this.getDaySaveFare();
    };

    OrderTrip.prototype.hasRoversRangersFare = function hasRoversRangersFare() {
        return !!this.getRoversRangersFare();
    };

    OrderTrip.prototype.hasFareOnlyFare = function hasFareOnlyFare() {
        return !!this.getFareOnlyFare();
    };

    OrderTrip.prototype.hasSmartCarnetFare = function hasSmartCarnetFare() {
        return !!this.getSmartCarnetFare();
    };

    OrderTrip.prototype.getFareOnlyFare = function getFareOnlyFare() {
        return this.fares.fareOnly;
    };

    OrderTrip.prototype.hasSeasonFare = function hasSeasonFare() {
        return !!this.getSeasonFare();
    };

    OrderTrip.prototype.getSeasonFare = function getSeasonFare() {
        return this.fares.season;
    };

    OrderTrip.prototype.getOutwardFare = function getOutwardFare() {
        if (this.hasFareOnlyFare()) {
            return this.getFareOnlyFare();
        }
        if (this.hasDaySaveFare()) {
            return this.getDaySaveFare();
        }
        if (this.hasSeasonFare()) {
            return this.getSeasonFare();
        }
        if (this.fares.return) {
            return this.fares.return;
        }

        if (this.fares.outwardSingle) {
            return this.fares.outwardSingle;
        }
        return null;
    };

    OrderTrip.prototype.seatsReserved = function seatsReserved() {
        return this.bookingStatus === _AppConstants.TripBookingStatus.OK;
    };

    OrderTrip.prototype.seatsNotRequired = function seatsNotRequired() {
        return this.bookingStatus === _AppConstants.TripBookingStatus.FAILED_NOT_REQUIRED;
    };

    OrderTrip.prototype.isPrinted = function isPrinted() {
        if (this.isSmartcard()) {
            return undefined;
        }
        var fares = this.getJourneyFares();
        return fares.every(function (fare) {
            return fare.isPrinted();
        });
    };

    OrderTrip.prototype.isUnprinted = function isUnprinted() {
        if (this.isSmartcard()) {
            return undefined;
        }
        var fares = this.getJourneyFares();
        return fares.some(function (fare) {
            return fare.isUnprinted();
        });
    };

    // this method does not consider eTickets:


    OrderTrip.prototype.isTooSoonToCollect = function isTooSoonToCollect() {
        if (this.isSmartcard()) {
            return (0, _TrainTime2.default)().add(2, 'hours').isAfter(this.getDepartureTime());
        }
        return (0, _TrainTime2.default)().add(30, 'minutes').isAfter(this.getDepartureTime());
    };

    OrderTrip.prototype.hasTicket = function hasTicket(id) {
        return this.amendedTickets.some(function (fare) {
            return fare.newTicket === id;
        });
    };

    OrderTrip.prototype.isReturn = function isReturn() {
        return !!this.getOutwardJourney() && !!this.getReturnJourney();
    };

    OrderTrip.prototype.isOpenReturn = function isOpenReturn() {
        return this.fares.isOpenReturn();
    };

    OrderTrip.prototype.getTickets = function getTickets() {
        return this.getJourneyFares().map(function (fare) {
            return fare && fare.tickets;
        }).flatten(true);
    };

    OrderTrip.prototype.getTicketsWithTicketTypeAndValidity = function getTicketsWithTicketTypeAndValidity() {
        return this.getJourneyFares().map(function (fare) {
            return fare && fare.tickets.map(function (t) {
                return t.set('ticketType', fare.ticketType.code);
            }).map(function (t) {
                return t.set('travelStartDate', fare.getValidFrom());
            });
        }).flatten(true);
    };

    OrderTrip.prototype.getProducts = function getProducts() {
        return this.getJourneyFares().concat(this.getPlusBus().getFares());
    };

    OrderTrip.prototype.hasRefundableTicket = function hasRefundableTicket() {
        return this.getTickets().some(function (t) {
            return t.isRefundable;
        }) || this.getPlusBusFares().some(function (f) {
            return f.hasRefundableTickets();
        });
    };

    OrderTrip.prototype.hasDownloadableTickets = function hasDownloadableTickets() {
        return this.getTickets().some(function (t) {
            return t.attachment;
        });
    };

    OrderTrip.prototype.hasJCPRailcard = function hasJCPRailcard() {
        return this.getTickets().some(function (t) {
            return t.railcard && t.railcard.code === 'JCP';
        });
    };

    OrderTrip.prototype.has1617Railcard = function has1617Railcard() {
        return this.getTickets().some(function (t) {
            return t.railcard && t.railcard.code === 'TSU';
        });
    };

    OrderTrip.prototype.getFirstOrigin = function getFirstOrigin() {
        if (this.hasFareOnlyFare()) {
            return this.getFareOnlyFare().origin;
        }

        if (this.hasDaySaveFare() || this.hasRoversRangersFare()) {
            return new _Station2.default();
        }

        return this.hasSeasonFare() ? this.getSeasonFare().origin : this.getOutwardJourney().legs.first() ? this.getOutwardJourney().legs.first().origin : this.getOutwardFare().origin; // Open Golf does not have legs use origin from the fare instead
    };

    OrderTrip.prototype.getDestination = function getDestination() {
        var journey = this.getOutwardJourney();
        if (journey.legs.size) {
            return journey.legs.last().destination;
        }
        var fare = this.getOutwardFare();
        return fare && fare.destination || new _Station2.default();
    };

    OrderTrip.prototype.needsPassengers = function needsPassengers() {
        return this.hasRoversRangersFare();
    };

    OrderTrip.prototype.hasPassengers = function hasPassengers() {
        return this.getTickets().every(function (ticket) {
            return ticket.passenger !== null;
        });
    };

    OrderTrip.prototype.hasDiscount = function hasDiscount(discount) {
        return this.getTickets().some(function (ticket) {
            return ticket.hasDiscount(discount);
        });
    };

    OrderTrip.prototype.canClaimDelayRepay = function canClaimDelayRepay() {
        // Return false for open return and other trip types
        var notApplicable = [_AppConstants.OrderTripTypes.SEASON, _AppConstants.OrderTripTypes.DAYSAVE, _AppConstants.OrderTripTypes.ROVERSRANGERS];
        if (this.isOpenReturn() || notApplicable.includes(this.getType())) {
            return false;
        }

        var outwardFare = this.getOutwardFare();
        var returnFare = this.fares.returnSingle || this.fares.return;
        var hasClaimableTickets = function hasClaimableTickets(fare) {
            return fare && fare.tickets.some(function (ticket) {
                return !ticket.refunded;
            });
        };

        var journeys = [hasClaimableTickets(outwardFare) ? outwardFare.outwardJourney : null, hasClaimableTickets(returnFare) ? returnFare.isReturn() ? returnFare.returnJourney : returnFare.outwardJourney : null];

        // Can only claim for fares with journeys that might have been delayed (in the past)
        var pastJourneys = journeys.filter(function (journey) {
            var departure = journey && journey.getDepartureTime();
            return departure && departure.isBefore() && departure.isAfter((0, _TrainTime2.default)().startOf('day').subtract(_config2.default.get('delayRepayMaxTicketDays'), 'days'));
        });

        if (pastJourneys.length >= 0) {
            // At least one leg in the journey must operate on a valid TOC for this brand
            var tocGroup = _config2.default.get('tocGroup');
            var isApplicableToBrand = pastJourneys.some(function (journey) {
                var legs = journey.legs.filter(function (leg) {
                    return leg.toc;
                });
                return legs.some(function (leg) {
                    return leg.toc && tocGroup.includes(leg.toc.code);
                });
            });
            return isApplicableToBrand;
        }

        return false;
    };

    OrderTrip.prototype.isFlexi = function isFlexi() {
        return this.fares.season && this.fares.season.smartTicketType === 'FL1';
    };

    OrderTrip.prototype.isTransPennineStaffRover = function isTransPennineStaffRover() {
        var origin = this.getFirstOrigin();
        var destination = this.getDestination();
        return Boolean(origin && destination && origin.get('nlc') === 'Z031' && destination.get('nlc') === 'Z032');
    };

    OrderTrip.fromJSON = function fromJSON(json) {
        return new OrderTrip({
            id: json.id,
            bookingStatus: json.bookingStatus,
            bookingReference: json.bookingReference,
            fares: (0, _LinkMapper.resolve)(json.fares).as(_TripFares2.default),
            itso: (0, _LinkMapper.resolve)(json.itso).with(Boolean),
            selfPrintPassenger: (0, _LinkMapper.resolve)(json.selfPrintPassenger).as(_LeadPassenger2.default) || new _LeadPassenger2.default(),
            isSeatsRequested: json.isSeatsRequested
        });
    };

    return OrderTrip;
}((0, _immutable.Record)(defaults));

exports.default = OrderTrip;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(746);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(138);
var core = __webpack_require__(78);
var ctx = __webpack_require__(262);
var hide = __webpack_require__(191);
var has = __webpack_require__(189);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(1804)["default"];

var _WeakMap = __webpack_require__(1820);

var _Object$defineProperty = __webpack_require__(1832);

var _Object$getOwnPropertyDescriptor = __webpack_require__(1835);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof _WeakMap !== "function") return null;
  var cacheBabelInterop = new _WeakMap();
  var cacheNodeInterop = new _WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Style = exports.State = exports.DEVICE_SIZES = exports.SIZE_MAP = exports.Size = void 0;
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
exports.Size = Size;
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
exports.SIZE_MAP = SIZE_MAP;
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
exports.DEVICE_SIZES = DEVICE_SIZES;
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
exports.State = State;
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};
exports.Style = Style;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extending the built in class loses stack traces, this provides an
 * Error class you can extend
 *
 * @see: http://stackoverflow.com/questions/30402287/extended-errors-do-not-have-message-or-stack-trace
 */

var ErrorClass = function ErrorClass(message, extra) {
    (0, _classCallCheck3.default)(this, ErrorClass);


    if (Error.hasOwnProperty('captureStackTrace')) {
        Error.captureStackTrace(this, this.constructor);
    } else {
        Object.defineProperty(this, 'stack', {
            value: new Error().stack
        });
    }

    if (message !== undefined) {
        Object.defineProperty(this, 'message', {
            value: message,
            writable: true
        });
    }

    this.extra = extra;
};

ErrorClass.prototype = (0, _create2.default)(Error.prototype);

exports.default = ErrorClass;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1580),
    keys = __webpack_require__(127);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(499)('wks');
var uid = __webpack_require__(373);
var Symbol = __webpack_require__(82).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1412);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(286);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {

// Load modules

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _isSafeInteger = __webpack_require__(257);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

var _from = __webpack_require__(285);

var _from2 = _interopRequireDefault(_from);

var _set = __webpack_require__(796);

var _set2 = _interopRequireDefault(_set);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty = __webpack_require__(313);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getOwnPropertyNames = __webpack_require__(799);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(393);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _map = __webpack_require__(800);

var _map2 = _interopRequireDefault(_map);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Crypto = __webpack_require__(529);
var Path = __webpack_require__(1563);
var Util = __webpack_require__(1564);
var Escape = __webpack_require__(1567);

// Declare internals

var internals = {};

// Clone object or array

exports.clone = function (obj, seen) {

    if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object' || obj === null) {

        return obj;
    }

    seen = seen || new _map2.default();

    var lookup = seen.get(obj);
    if (lookup) {
        return lookup;
    }

    var newObj = void 0;
    var cloneDeep = false;

    if (!Array.isArray(obj)) {
        if (Buffer.isBuffer(obj)) {
            newObj = new Buffer(obj);
        } else if (obj instanceof Date) {
            newObj = new Date(obj.getTime());
        } else if (obj instanceof RegExp) {
            newObj = new RegExp(obj);
        } else {
            var proto = (0, _getPrototypeOf2.default)(obj);
            if (proto && proto.isImmutable) {

                newObj = obj;
            } else {
                newObj = (0, _create2.default)(proto);
                cloneDeep = true;
            }
        }
    } else {
        newObj = [];
        cloneDeep = true;
    }

    seen.set(obj, newObj);

    if (cloneDeep) {
        var keys = (0, _getOwnPropertyNames2.default)(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            var descriptor = (0, _getOwnPropertyDescriptor2.default)(obj, key);
            if (descriptor && (descriptor.get || descriptor.set)) {

                (0, _defineProperty2.default)(newObj, key, descriptor);
            } else {
                newObj[key] = exports.clone(obj[key], seen);
            }
        }
    }

    return newObj;
};

// Merge all the properties of source into target, source wins in conflict, and by default null and undefined from source are applied

/*eslint-disable */
exports.merge = function (target, source, isNullOverride /* = true */, isMergeArrays /* = true */) {
    /*eslint-enable */

    exports.assert(target && (typeof target === 'undefined' ? 'undefined' : (0, _typeof3.default)(target)) === 'object', 'Invalid target value: must be an object');
    exports.assert(source === null || source === undefined || (typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) === 'object', 'Invalid source value: must be null, undefined, or an object');

    if (!source) {
        return target;
    }

    if (Array.isArray(source)) {
        exports.assert(Array.isArray(target), 'Cannot merge array onto an object');
        if (isMergeArrays === false) {
            // isMergeArrays defaults to true
            target.length = 0; // Must not change target assignment
        }

        for (var i = 0; i < source.length; ++i) {
            target.push(exports.clone(source[i]));
        }

        return target;
    }

    var keys = (0, _keys2.default)(source);
    for (var _i = 0; _i < keys.length; ++_i) {
        var key = keys[_i];
        if (key === '__proto__') {
            continue;
        }

        var value = source[key];
        if (value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {

            if (!target[key] || (0, _typeof3.default)(target[key]) !== 'object' || Array.isArray(target[key]) !== Array.isArray(value) || value instanceof Date || Buffer.isBuffer(value) || value instanceof RegExp) {

                target[key] = exports.clone(value);
            } else {
                exports.merge(target[key], value, isNullOverride, isMergeArrays);
            }
        } else {
            if (value !== null && value !== undefined) {
                // Explicit to preserve empty strings

                target[key] = value;
            } else if (isNullOverride !== false) {
                // Defaults to true
                target[key] = value;
            }
        }
    }

    return target;
};

// Apply options to a copy of the defaults

exports.applyToDefaults = function (defaults, options, isNullOverride) {

    exports.assert(defaults && (typeof defaults === 'undefined' ? 'undefined' : (0, _typeof3.default)(defaults)) === 'object', 'Invalid defaults value: must be an object');
    exports.assert(!options || options === true || (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object', 'Invalid options value: must be true, falsy or an object');

    if (!options) {
        // If no options, return null
        return null;
    }

    var copy = exports.clone(defaults);

    if (options === true) {
        // If options is set to true, use defaults
        return copy;
    }

    return exports.merge(copy, options, isNullOverride === true, false);
};

// Clone an object except for the listed keys which are shallow copied

exports.cloneWithShallow = function (source, keys) {

    if (!source || (typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) !== 'object') {

        return source;
    }

    var storage = internals.store(source, keys); // Move shallow copy items to storage
    var copy = exports.clone(source); // Deep copy the rest
    internals.restore(copy, source, storage); // Shallow copy the stored items and restore
    return copy;
};

internals.store = function (source, keys) {

    var storage = {};
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = exports.reach(source, key);
        if (value !== undefined) {
            storage[key] = value;
            internals.reachSet(source, key, undefined);
        }
    }

    return storage;
};

internals.restore = function (copy, source, storage) {

    var keys = (0, _keys2.default)(storage);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        internals.reachSet(copy, key, storage[key]);
        internals.reachSet(source, key, storage[key]);
    }
};

internals.reachSet = function (obj, key, value) {

    var path = key.split('.');
    var ref = obj;
    for (var i = 0; i < path.length; ++i) {
        var segment = path[i];
        if (i + 1 === path.length) {
            ref[segment] = value;
        }

        ref = ref[segment];
    }
};

// Apply options to defaults except for the listed keys which are shallow copied from option without merging

exports.applyToDefaultsWithShallow = function (defaults, options, keys) {

    exports.assert(defaults && (typeof defaults === 'undefined' ? 'undefined' : (0, _typeof3.default)(defaults)) === 'object', 'Invalid defaults value: must be an object');
    exports.assert(!options || options === true || (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object', 'Invalid options value: must be true, falsy or an object');
    exports.assert(keys && Array.isArray(keys), 'Invalid keys');

    if (!options) {
        // If no options, return null
        return null;
    }

    var copy = exports.cloneWithShallow(defaults, keys);

    if (options === true) {
        // If options is set to true, use defaults
        return copy;
    }

    var storage = internals.store(options, keys); // Move shallow copy items to storage
    exports.merge(copy, options, false, false); // Deep copy the rest
    internals.restore(copy, options, storage); // Shallow copy the stored items and restore
    return copy;
};

// Deep object or array comparison

exports.deepEqual = function (obj, ref, options, seen) {

    options = options || { prototype: true };

    var type = typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj);

    if (type !== (typeof ref === 'undefined' ? 'undefined' : (0, _typeof3.default)(ref))) {
        return false;
    }

    if (type !== 'object' || obj === null || ref === null) {

        if (obj === ref) {
            // Copied from Deep-eql, copyright(c) 2013 Jake Luer, jake@alogicalparadox.com, MIT Licensed, https://github.com/chaijs/deep-eql
            return obj !== 0 || 1 / obj === 1 / ref; // -0 / +0
        }

        return obj !== obj && ref !== ref; // NaN
    }

    seen = seen || [];
    if (seen.indexOf(obj) !== -1) {
        return true; // If previous comparison failed, it would have stopped execution
    }

    seen.push(obj);

    if (Array.isArray(obj)) {
        if (!Array.isArray(ref)) {
            return false;
        }

        if (!options.part && obj.length !== ref.length) {
            return false;
        }

        for (var i = 0; i < obj.length; ++i) {
            if (options.part) {
                var found = false;
                for (var j = 0; j < ref.length; ++j) {
                    if (exports.deepEqual(obj[i], ref[j], options)) {
                        found = true;
                        break;
                    }
                }

                return found;
            }

            if (!exports.deepEqual(obj[i], ref[i], options)) {
                return false;
            }
        }

        return true;
    }

    if (Buffer.isBuffer(obj)) {
        if (!Buffer.isBuffer(ref)) {
            return false;
        }

        if (obj.length !== ref.length) {
            return false;
        }

        for (var _i2 = 0; _i2 < obj.length; ++_i2) {
            if (obj[_i2] !== ref[_i2]) {
                return false;
            }
        }

        return true;
    }

    if (obj instanceof Date) {
        return ref instanceof Date && obj.getTime() === ref.getTime();
    }

    if (obj instanceof RegExp) {
        return ref instanceof RegExp && obj.toString() === ref.toString();
    }

    if (options.prototype) {
        if ((0, _getPrototypeOf2.default)(obj) !== (0, _getPrototypeOf2.default)(ref)) {
            return false;
        }
    }

    var keys = (0, _getOwnPropertyNames2.default)(obj);

    if (!options.part && keys.length !== (0, _getOwnPropertyNames2.default)(ref).length) {
        return false;
    }

    for (var _i3 = 0; _i3 < keys.length; ++_i3) {
        var key = keys[_i3];
        var descriptor = (0, _getOwnPropertyDescriptor2.default)(obj, key);
        if (descriptor.get) {
            if (!exports.deepEqual(descriptor, (0, _getOwnPropertyDescriptor2.default)(ref, key), options, seen)) {
                return false;
            }
        } else if (!exports.deepEqual(obj[key], ref[key], options, seen)) {
            return false;
        }
    }

    return true;
};

// Remove duplicate items from array

exports.unique = function (array, key) {

    var result = void 0;
    if (key) {
        result = [];
        var index = new _set2.default();
        array.forEach(function (item) {

            var identifier = item[key];
            if (!index.has(identifier)) {
                index.add(identifier);
                result.push(item);
            }
        });
    } else {
        result = (0, _from2.default)(new _set2.default(array));
    }

    return result;
};

// Convert array into object

exports.mapToObject = function (array, key) {

    if (!array) {
        return null;
    }

    var obj = {};
    for (var i = 0; i < array.length; ++i) {
        if (key) {
            if (array[i][key]) {
                obj[array[i][key]] = true;
            }
        } else {
            obj[array[i]] = true;
        }
    }

    return obj;
};

// Find the common unique items in two arrays

exports.intersect = function (array1, array2, justFirst) {

    if (!array1 || !array2) {
        return [];
    }

    var common = [];
    var hash = Array.isArray(array1) ? exports.mapToObject(array1) : array1;
    var found = {};
    for (var i = 0; i < array2.length; ++i) {
        if (hash[array2[i]] && !found[array2[i]]) {
            if (justFirst) {
                return array2[i];
            }

            common.push(array2[i]);
            found[array2[i]] = true;
        }
    }

    return justFirst ? null : common;
};

// Test if the reference contains the values

exports.contain = function (ref, values, options) {

    /*
        string -> string(s)
        array -> item(s)
        object -> key(s)
        object -> object (key:value)
    */

    var valuePairs = null;
    if ((typeof ref === 'undefined' ? 'undefined' : (0, _typeof3.default)(ref)) === 'object' && (typeof values === 'undefined' ? 'undefined' : (0, _typeof3.default)(values)) === 'object' && !Array.isArray(ref) && !Array.isArray(values)) {

        valuePairs = values;
        values = (0, _keys2.default)(values);
    } else {
        values = [].concat(values);
    }

    options = options || {}; // deep, once, only, part

    exports.assert(arguments.length >= 2, 'Insufficient arguments');
    exports.assert(typeof ref === 'string' || (typeof ref === 'undefined' ? 'undefined' : (0, _typeof3.default)(ref)) === 'object', 'Reference must be string or an object');
    exports.assert(values.length, 'Values array cannot be empty');

    var compare = void 0;
    var compareFlags = void 0;
    if (options.deep) {
        compare = exports.deepEqual;

        var hasOnly = options.hasOwnProperty('only');
        var hasPart = options.hasOwnProperty('part');

        compareFlags = {
            prototype: hasOnly ? options.only : hasPart ? !options.part : false,
            part: hasOnly ? !options.only : hasPart ? options.part : true
        };
    } else {
        compare = function compare(a, b) {
            return a === b;
        };
    }

    var misses = false;
    var matches = new Array(values.length);
    for (var i = 0; i < matches.length; ++i) {
        matches[i] = 0;
    }

    if (typeof ref === 'string') {
        var pattern = '(';
        for (var _i4 = 0; _i4 < values.length; ++_i4) {
            var value = values[_i4];
            exports.assert(typeof value === 'string', 'Cannot compare string reference to non-string value');
            pattern += (_i4 ? '|' : '') + exports.escapeRegex(value);
        }

        var regex = new RegExp(pattern + ')', 'g');
        var leftovers = ref.replace(regex, function ($0, $1) {

            var index = values.indexOf($1);
            ++matches[index];
            return ''; // Remove from string
        });

        misses = !!leftovers;
    } else if (Array.isArray(ref)) {
        for (var _i5 = 0; _i5 < ref.length; ++_i5) {
            var matched = false;
            for (var j = 0; j < values.length && matched === false; ++j) {
                matched = compare(values[j], ref[_i5], compareFlags) && j;
            }

            if (matched !== false) {
                ++matches[matched];
            } else {
                misses = true;
            }
        }
    } else {
        var keys = (0, _getOwnPropertyNames2.default)(ref);
        for (var _i6 = 0; _i6 < keys.length; ++_i6) {
            var key = keys[_i6];
            var pos = values.indexOf(key);
            if (pos !== -1) {
                if (valuePairs && !compare(valuePairs[key], ref[key], compareFlags)) {

                    return false;
                }

                ++matches[pos];
            } else {
                misses = true;
            }
        }
    }

    var result = false;
    for (var _i7 = 0; _i7 < matches.length; ++_i7) {
        result = result || !!matches[_i7];
        if (options.once && matches[_i7] > 1 || !options.part && !matches[_i7]) {

            return false;
        }
    }

    if (options.only && misses) {

        return false;
    }

    return result;
};

// Flatten array

exports.flatten = function (array, target) {

    var result = target || [];

    for (var i = 0; i < array.length; ++i) {
        if (Array.isArray(array[i])) {
            exports.flatten(array[i], result);
        } else {
            result.push(array[i]);
        }
    }

    return result;
};

// Convert an object key chain string ('a.b.c') to reference (object[a][b][c])

exports.reach = function (obj, chain, options) {

    if (chain === false || chain === null || typeof chain === 'undefined') {

        return obj;
    }

    options = options || {};
    if (typeof options === 'string') {
        options = { separator: options };
    }

    var path = chain.split(options.separator || '.');
    var ref = obj;
    for (var i = 0; i < path.length; ++i) {
        var key = path[i];
        if (key[0] === '-' && Array.isArray(ref)) {
            key = key.slice(1, key.length);
            key = ref.length - key;
        }

        if (!ref || !(((typeof ref === 'undefined' ? 'undefined' : (0, _typeof3.default)(ref)) === 'object' || typeof ref === 'function') && key in ref) || (typeof ref === 'undefined' ? 'undefined' : (0, _typeof3.default)(ref)) !== 'object' && options.functions === false) {
            // Only object and function can have properties

            exports.assert(!options.strict || i + 1 === path.length, 'Missing segment', key, 'in reach path ', chain);
            exports.assert((typeof ref === 'undefined' ? 'undefined' : (0, _typeof3.default)(ref)) === 'object' || options.functions === true || typeof ref !== 'function', 'Invalid segment', key, 'in reach path ', chain);
            ref = options.default;
            break;
        }

        ref = ref[key];
    }

    return ref;
};

exports.reachTemplate = function (obj, template, options) {

    return template.replace(/{([^}]+)}/g, function ($0, chain) {

        var value = exports.reach(obj, chain, options);
        return value === undefined || value === null ? '' : value;
    });
};

exports.formatStack = function (stack) {

    var trace = [];
    for (var i = 0; i < stack.length; ++i) {
        var item = stack[i];
        trace.push([item.getFileName(), item.getLineNumber(), item.getColumnNumber(), item.getFunctionName(), item.isConstructor()]);
    }

    return trace;
};

exports.formatTrace = function (trace) {

    var display = [];

    for (var i = 0; i < trace.length; ++i) {
        var row = trace[i];
        display.push((row[4] ? 'new ' : '') + row[3] + ' (' + row[0] + ':' + row[1] + ':' + row[2] + ')');
    }

    return display;
};

exports.callStack = function (slice) {

    // http://code.google.com/p/v8/wiki/JavaScriptStackTraceApi

    var v8 = Error.prepareStackTrace;
    Error.prepareStackTrace = function (_, stack) {

        return stack;
    };

    var capture = {};
    Error.captureStackTrace(capture, this); // arguments.callee is not supported in strict mode so we use this and slice the trace of this off the result
    var stack = capture.stack;

    Error.prepareStackTrace = v8;

    var trace = exports.formatStack(stack);

    return trace.slice(1 + slice);
};

exports.displayStack = function (slice) {

    var trace = exports.callStack(slice === undefined ? 1 : slice + 1);

    return exports.formatTrace(trace);
};

exports.abortThrow = false;

exports.abort = function (message, hideStack) {

    if ("production" === 'test' || exports.abortThrow === true) {
        throw new Error(message || 'Unknown error');
    }

    var stack = '';
    if (!hideStack) {
        stack = exports.displayStack(1).join('\n\t');
    }
    console.log('ABORT: ' + message + '\n\t' + stack);
    process.exit(1);
};

exports.assert = function (condition /*, msg1, msg2, msg3 */) {

    if (condition) {
        return;
    }

    if (arguments.length === 2 && arguments[1] instanceof Error) {
        throw arguments[1];
    }

    var msgs = [];
    for (var i = 1; i < arguments.length; ++i) {
        if (arguments[i] !== '') {
            msgs.push(arguments[i]); // Avoids Array.slice arguments leak, allowing for V8 optimizations
        }
    }

    msgs = msgs.map(function (msg) {

        return typeof msg === 'string' ? msg : msg instanceof Error ? msg.message : exports.stringify(msg);
    });

    throw new Error(msgs.join(' ') || 'Unknown error');
};

exports.Timer = function () {

    this.ts = 0;
    this.reset();
};

exports.Timer.prototype.reset = function () {

    this.ts = Date.now();
};

exports.Timer.prototype.elapsed = function () {

    return Date.now() - this.ts;
};

exports.Bench = function () {

    this.ts = 0;
    this.reset();
};

exports.Bench.prototype.reset = function () {

    this.ts = exports.Bench.now();
};

exports.Bench.prototype.elapsed = function () {

    return exports.Bench.now() - this.ts;
};

exports.Bench.now = function () {

    var ts = process.hrtime();
    return ts[0] * 1e3 + ts[1] / 1e6;
};

// Escape string for Regex construction

exports.escapeRegex = function (string) {

    // Escape ^$.*+-?=!:|\/()[]{},
    return string.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, '\\$&');
};

// Base64url (RFC 4648) encode

exports.base64urlEncode = function (value, encoding) {

    exports.assert(typeof value === 'string' || Buffer.isBuffer(value), 'value must be string or buffer');
    var buf = Buffer.isBuffer(value) ? value : new Buffer(value, encoding || 'binary');
    return buf.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
};

// Base64url (RFC 4648) decode

exports.base64urlDecode = function (value, encoding) {

    if (typeof value !== 'string') {

        return new Error('Value not a string');
    }

    if (!/^[\w\-]*$/.test(value)) {

        return new Error('Invalid character');
    }

    var buf = new Buffer(value, 'base64');
    return encoding === 'buffer' ? buf : buf.toString(encoding || 'binary');
};

// Escape attribute value for use in HTTP header

exports.escapeHeaderAttribute = function (attribute) {

    // Allowed value characters: !#$%&'()*+,-./:;<=>?@[]^_`{|}~ and space, a-z, A-Z, 0-9, \, "

    exports.assert(/^[ \w\!#\$%&'\(\)\*\+,\-\.\/\:;<\=>\?@\[\]\^`\{\|\}~\"\\]*$/.test(attribute), 'Bad attribute value (' + attribute + ')');

    return attribute.replace(/\\/g, '\\\\').replace(/\"/g, '\\"'); // Escape quotes and slash
};

exports.escapeHtml = function (string) {

    return Escape.escapeHtml(string);
};

exports.escapeJavaScript = function (string) {

    return Escape.escapeJavaScript(string);
};

exports.escapeJson = function (string) {

    return Escape.escapeJson(string);
};

exports.nextTick = function (callback) {

    return function () {

        var args = arguments;
        process.nextTick(function () {

            callback.apply(null, args);
        });
    };
};

exports.once = function (method) {

    if (method._hoekOnce) {
        return method;
    }

    var once = false;
    var wrapped = function wrapped() {

        if (!once) {
            once = true;
            method.apply(null, arguments);
        }
    };

    wrapped._hoekOnce = true;

    return wrapped;
};

exports.isInteger = _isSafeInteger2.default;

exports.ignore = function () {};

exports.inherits = Util.inherits;

exports.format = Util.format;

exports.transform = function (source, transform, options) {

    exports.assert(source === null || source === undefined || (typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) === 'object' || Array.isArray(source), 'Invalid source object: must be null, undefined, an object, or an array');
    var separator = (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object' && options !== null ? options.separator || '.' : '.';

    if (Array.isArray(source)) {
        var results = [];
        for (var i = 0; i < source.length; ++i) {
            results.push(exports.transform(source[i], transform, options));
        }
        return results;
    }

    var result = {};
    var keys = (0, _keys2.default)(transform);

    for (var _i8 = 0; _i8 < keys.length; ++_i8) {
        var key = keys[_i8];
        var path = key.split(separator);
        var sourcePath = transform[key];

        exports.assert(typeof sourcePath === 'string', 'All mappings must be "." delineated strings');

        var segment = void 0;
        var res = result;

        while (path.length > 1) {
            segment = path.shift();
            if (!res[segment]) {
                res[segment] = {};
            }
            res = res[segment];
        }
        segment = path.shift();
        res[segment] = exports.reach(source, sourcePath, options);
    }

    return result;
};

exports.uniqueFilename = function (path, extension) {

    if (extension) {
        extension = extension[0] !== '.' ? '.' + extension : extension;
    } else {
        extension = '';
    }

    path = Path.resolve(path);
    var name = [Date.now(), process.pid, Crypto.randomBytes(8).toString('hex')].join('-') + extension;
    return Path.join(path, name);
};

exports.stringify = function () {

    try {
        return _stringify2.default.apply(null, arguments);
    } catch (err) {
        return '[Cannot display object: ' + err.message + ']';
    }
};

exports.shallow = function (source) {

    var target = {};
    var keys = (0, _keys2.default)(source);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        target[key] = source[key];
    }

    return target;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(317).Buffer, __webpack_require__(186)))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.deserializers = exports.serializers = undefined;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _find2 = __webpack_require__(344);

var _find3 = _interopRequireDefault(_find2);

var _zipObject2 = __webpack_require__(204);

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _includes2 = __webpack_require__(535);

var _includes3 = _interopRequireDefault(_includes2);

var _map2 = __webpack_require__(314);

var _map3 = _interopRequireDefault(_map2);

var _reduce2 = __webpack_require__(219);

var _reduce3 = _interopRequireDefault(_reduce2);

exports.serialize = serialize;
exports.deserialize = deserialize;
exports.searchDateToTrainTime = searchDateToTrainTime;

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _StationStore = __webpack_require__(429);

var _StationStore2 = _interopRequireDefault(_StationStore);

var _AppConstants = __webpack_require__(6);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _CustomDuration = __webpack_require__(823);

var _CustomDuration2 = _interopRequireDefault(_CustomDuration);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Serialize an object based on a schema
 */
function serialize(schema, source) {
    var serialized = {};
    (0, _reduce3.default)(schema, function (reduction, serializer, name) {
        var result = serializer(source[name], source, name);
        if (result !== null) {
            reduction[name] = result;
        }
        return reduction;
    }, serialized);
    return serialized;
}

/**
 * List of serializers, they take a value, source object and name of the field they are operating on
 */
var serializers = exports.serializers = {
    station: function station(_station) {
        return _station.crs || _station.nlc;
    },
    stationCrs: function stationCrs(station) {
        return station.crs;
    },
    stationNlc: function stationNlc(station) {
        return station.nlc;
    },
    code: function code(obj) {
        return obj.code || null;
    },
    promoCode: function promoCode(promo) {
        return promo && promo.promoCode || null;
    },
    railcards: function railcards(_railcards) {
        var mapped = _railcards.filter(function (r) {
            return r.code !== '' && r.quantity > 0;
        }).map(function (r) {
            return r.code + 'x' + r.quantity;
        });

        if (mapped.size > 0) {
            return mapped.toJS();
        }
        return null;
    },
    railcardCodes: function railcardCodes(railcards) {
        return railcards.filterNot(function (r) {
            return r.code === null;
        }).map(function (r) {
            return r.code;
        }).toJS();
    },
    date: function date(_date) {
        return _date.format('YYYY-MM-DD');
    },
    time: function time(dateTime) {
        return dateTime.format('HH:mm:ss');
    },
    dateTime: function dateTime(_dateTime) {
        return _dateTime.format('YYYY-MM-DDTHH:mm');
    },
    isoDateTime: function isoDateTime(dateTime) {
        return dateTime.format(_AppConstants.API_ISO_FORMAT);
    },
    timeBand: function timeBand(_timeBand, source, name) {
        var prefix = _timeBand.arriveDepart === _AppConstants.TimeTypes.ARRIVE ? _AppConstants.TimeTypes.ARRIVE + '_at_' : '';
        if (name !== 'returnDateTime' || source.ticketType === _AppConstants.TicketTypes.RETURN) {
            return prefix + _timeBand.datetime.format('YYYY-MM-DDTHH:mm');
        }

        if (source.ticketType === _AppConstants.TicketTypes.OPEN_RETURN) {
            return 'open';
        }

        return null;
    },


    identity: function identity(value) {
        return value;
    },

    serializedIdentity: function serializedIdentity(value) {
        return value.serialize();
    },

    durationStartDate: function durationStartDate(durationField) {
        return function (x, source) {
            return source[durationField].getStartDate().format('YYYY-MM-DD');
        };
    },
    durations: function durations(durationField) {
        return function (x, source) {
            var result = [];
            if (source.flexi) {
                result.push('flexi');
            } // Technically not a duration type
            if (source.weekly) {
                result.push(_AppConstants.DurationTypes.WEEKLY);
            }
            if (source.fourWeekly) {
                result.push(_AppConstants.DurationTypes.FOUR_WEEKLY);
            }
            if (source.monthly) {
                result.push(_AppConstants.DurationTypes.MONTHLY);
            }
            if (source.quarterly) {
                result.push(_AppConstants.DurationTypes.QUARTERLY);
            }
            if (source.sixMonthly) {
                result.push(_AppConstants.DurationTypes.SIX_MONTHLY);
            }
            if (source.annual) {
                result.push(_AppConstants.DurationTypes.ANNUAL);
            }
            if (source.custom) {
                result.push(source[durationField].getDuration().toJSON());
            }
            return result;
        };
    },


    boolean: function boolean(value) {
        return value ? 'yes' : 'no';
    },

    ticketType: function ticketType(type) {
        return type.code;
    }
};

/**
 * Deserialize params based on a schema
 */
function deserialize(schema, params) {

    var results = (0, _map3.default)(schema, function (deserializer, name) {
        return deserializer(params[name], params, name);
    });

    // Deserializers can return promises so we need to get all the results
    // and then reduce them into the deserialized object
    return _promise2.default.all(results).then(function (values) {
        return (0, _reduce3.default)(values, function (result, value) {
            return (0, _assign2.default)({}, result, value);
        }, {});
    });
}

function splitDatetime(value) {
    var arriveDepart, datetime;
    if (value.match('_at_')) {
        var _value$split = value.split('_at_');

        arriveDepart = _value$split[0];
        datetime = _value$split[1];
    } else {
        arriveDepart = _AppConstants.TimeTypes.DEPART;
        datetime = value;
    }

    arriveDepart = arriveDepart === _AppConstants.TimeTypes.ARRIVE ? _AppConstants.TimeTypes.ARRIVE : _AppConstants.TimeTypes.DEPART;
    return [arriveDepart, datetime];
}

// Takes a date & returns a trainTime
// Actual date strings are passed straight onto trainTime()
// Accepts relative dates such as "today", "tomorrow", "+7days"
// And times such as "@10:45", "@17:30"
// You can combine the two: "today@10:00", "+7days@09:30"
function searchDateToTrainTime(dateString) {
    if (dateString.match(/^\d/)) {
        return (0, _TrainTime2.default)(dateString);
    }

    var parsed = (0, _TrainTime2.default)();

    var _dateString$split = dateString.split('@'),
        date = _dateString$split[0],
        time = _dateString$split[1];

    if (date === 'tomorrow') {
        parsed = (0, _TrainTime2.default)().add({ days: 1 });
    } else if (date) {
        var _ref = date.match(/\+(\d+)\s*(.*)/) || [],
            match = _ref[0],
            num = _ref[1],
            unit = _ref[2];

        if (match) {
            parsed = (0, _TrainTime2.default)().add(num, unit);
        }
    }

    if (time) {
        var _time$split = time.split(':'),
            hours = _time$split[0],
            minutes = _time$split[1];

        parsed = parsed.set({ hours: hours, minutes: minutes });
    }
    return parsed;
}

/**
 * List of deserializers
 *
 * A deserializer is passed a value, the source object and the name of the field it is operating on
 * Because deserializers can set multiple parameters they need to a return a map of the fields they
 * are setting on the result, or a promise that returns this
 */
var deserializers = exports.deserializers = {
    boolean: function boolean(value, source, name) {
        var _ref2;

        var result = Boolean(value);
        var str = String(value);
        if (str.toLowerCase() === 'false' || str.toLowerCase() === 'no' || parseInt(str, 0) === 0) {
            result = Boolean(false);
        }
        return _ref2 = {}, _ref2[name] = result, _ref2;
    },


    identity: function identity(value, source, name) {
        var _ref3;

        return _ref3 = {}, _ref3[name] = value, _ref3;
    },

    station: function station(value, source, name) {
        return _StationStore2.default.get(value).then(function (station) {
            var _ref4;

            return _ref4 = {}, _ref4[name] = station, _ref4;
        });
    },
    promoCode: function promoCode(value, source, name) {
        var _ref5;

        return _ref5 = {}, _ref5[name] = new _PromoCode2.default({ promoCode: value }), _ref5;
    },
    fareClass: function fareClass(value, source, name) {
        var _ref7;

        if (value && (0, _includes3.default)((0, _values3.default)(_AppConstants.FareClasses), value)) {
            var _ref6;

            return _ref6 = {}, _ref6[name] = value, _ref6;
        }

        return _ref7 = {}, _ref7[name] = _AppConstants.FareClasses.STANDARD, _ref7;
    },
    int: function int(value, source, name) {
        var _ref9;

        value = parseInt(value, 10);
        if (!isNaN(value)) {
            var _ref8;

            return _ref8 = {}, _ref8[name] = value, _ref8;
        }

        return _ref9 = {}, _ref9[name] = 0, _ref9;
    },
    railcards: function railcards(_railcards2, source, name) {
        var _ref10;

        if (!_railcards2) {
            return {};
        }

        var filtered = _railcards2.split(',').map(function (x) {
            return x.split(/x(?=[^x]*$)/);
        }).filter(function (x) {
            return x.length >= 2;
        });

        if (filtered.length <= 0) {
            return {};
        }

        var mapped = filtered.map(function (part) {
            var parsed = (0, _zipObject3.default)(['code', 'quantity'], part);
            parsed.quantity = parseInt(parsed.quantity, 10);
            return new _PassengerRailcard2.default(parsed);
        });

        return _ref10 = {}, _ref10[name] = new _immutable.List(mapped), _ref10;
    },
    timeBand: function timeBand(value, source, name) {
        var _result;

        if (!value) {
            return {};
        }
        if (value === 'open') {
            return { ticketType: _AppConstants.TicketTypes.OPEN_RETURN };
        }

        var _splitDatetime = splitDatetime(value),
            arriveDepart = _splitDatetime[0],
            datetime = _splitDatetime[1];

        var datetimeObj = void 0;

        if (name === 'returnDateTime' && datetime === 'return') {
            var outbound = splitDatetime(source.outboundDateTime)[1];
            datetimeObj = searchDateToTrainTime(outbound);
        } else {
            datetimeObj = searchDateToTrainTime(datetime);
        }

        if (!datetimeObj.isValid()) {
            datetimeObj = (0, _TrainTime2.default)();
        }

        var result = (_result = {}, _result[name] = new _Timeband2.default({ arriveDepart: arriveDepart, datetime: datetimeObj }), _result);
        if (name === 'returnDateTime') {
            result.ticketType = _AppConstants.TicketTypes.RETURN;
        }

        return result;
    },
    date: function date(value, source, name) {
        var _ref11;

        return _ref11 = {}, _ref11[name] = searchDateToTrainTime(value), _ref11;
    },
    durations: function durations(_durations, source) {
        var startDate = searchDateToTrainTime(source.startDate);
        var custom = new _CustomDuration2.default({ startDate: startDate });
        var flags = {};

        var DurationTypesWithFlexi = (0, _assign2.default)({}, _AppConstants.DurationTypes, { FLEXI: 'flexi' });

        (0, _keys2.default)(DurationTypesWithFlexi).forEach(function (flag) {
            return flags[DurationTypesWithFlexi[flag]] = false;
        });

        if (_durations) {
            _durations.split(',').forEach(function (duration) {
                if ((0, _find3.default)(DurationTypesWithFlexi, function (type) {
                    return type === duration;
                })) {
                    flags[duration] = true;
                } else {
                    flags.custom = true;
                    custom = custom.setDuration(_TrainTime2.default.duration(duration));
                }
            });
        }
        custom = custom.setStartDate(startDate);

        return (0, _assign2.default)(flags, { dates: custom });
    },
    ticketType: function ticketType(value, source, name) {
        var _ref13;

        if (!value) {
            var _ref12;

            return _ref12 = {}, _ref12[name] = new _TicketType2.default(), _ref12;
        }

        return _ref13 = {}, _ref13[name] = new _TicketType2.default({ code: value }), _ref13;
    }
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _set2 = __webpack_require__(394);

var _set3 = _interopRequireDefault(_set2);

var _partial2 = __webpack_require__(615);

var _partial3 = _interopRequireDefault(_partial2);

exports.getLatLngCenter = getLatLngCenter;

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _Immutable = __webpack_require__(54);

var _AppConstants = __webpack_require__(6);

var _Route = __webpack_require__(319);

var _Route2 = _interopRequireDefault(_Route);

var _Setter = __webpack_require__(1672);

var _Setter2 = _interopRequireDefault(_Setter);

var _Ticket = __webpack_require__(353);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _FarePriceComparison = __webpack_require__(1674);

var _FarePriceComparison2 = _interopRequireDefault(_FarePriceComparison);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _Validity = __webpack_require__(1029);

var _Validity2 = _interopRequireDefault(_Validity);

var _LinkMapper = __webpack_require__(8);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    category: null,
    alternateDestinations: new _immutable.List(),
    alternateOrigins: new _immutable.List(),
    destination: new _Station2.default(),
    origin: new _Station2.default(),
    price: null,
    totalPrice: null,
    originalTotalPrice: null,
    route: new _Route2.default(),
    tickets: new _immutable.List(),
    ticketType: new _TicketType2.default(),
    validFrom: null,
    validUntil: null,
    outwardValidity: null,
    returnValidity: null,
    utsZones: new _immutable.List(),
    restriction: null,
    seatAvailability: null,
    discountCode: null,
    discountPercent: null,
    discountName: null,
    discountDescription: null,
    discountFixedAmount: null,
    priceComparison: new _FarePriceComparison2.default(),
    numberOfPasses: null,
    setter: new _Setter2.default()
};

// borrowed & es6ified from http://stackoverflow.com/a/30033564
function rad2degr(rad) {
    return rad * 180 / Math.PI;
}
function degr2rad(degr) {
    return degr * Math.PI / 180;
}

/**
 * @param latLngInDeg array of arrays with latitude and longtitude
 *   pairs in degrees. e.g. [[latitude1, longtitude1], [latitude2
 *   [longtitude2] ...]
 *
 * @return array with the center latitude longtitude pairs in
 *   degrees.
 */
function getLatLngCenter(latLngInDegr) {
    var sumX = 0,
        sumY = 0,
        sumZ = 0;


    latLngInDegr.forEach(function (_ref) {
        var lat = _ref[0],
            lng = _ref[1];

        lat = degr2rad(lat);
        lng = degr2rad(lng);
        // sum of cartesian coordinates
        sumX += Math.cos(lat) * Math.cos(lng);
        sumY += Math.cos(lat) * Math.sin(lng);
        sumZ += Math.sin(lat);
    });

    var avgX = sumX / latLngInDegr.size;
    var avgY = sumY / latLngInDegr.size;
    var avgZ = sumZ / latLngInDegr.size;

    // convert average x, y, z coordinate to latitude and longtitude
    var lng = Math.atan2(avgY, avgX);
    var hyp = Math.sqrt(avgX * avgX + avgY * avgY);
    var lat = Math.atan2(avgZ, hyp);

    return [rad2degr(lat), rad2degr(lng)];
}

var Fare = function (_record) {
    (0, _inherits3.default)(Fare, _record);

    function Fare() {
        (0, _classCallCheck3.default)(this, Fare);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Fare.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        var originWithLocation = (0, _partial3.default)(Fare.getStationWithLocation, _partial3.default.placeholder, (0, _LinkMapper.resolveAll)(json.alternateOrigins).as(_Station2.default));
        var destinationWithLocation = (0, _partial3.default)(Fare.getStationWithLocation, _partial3.default.placeholder, (0, _LinkMapper.resolveAll)(json.alternateDestinations).as(_Station2.default));

        return (0, _LinkMapper.construct)(Fare, json, {
            id: json.id,
            category: _LinkMapper.fields.string,
            origin: _LinkMapper.resolve.with(originWithLocation),
            destination: _LinkMapper.resolve.with(destinationWithLocation),
            price: _LinkMapper.resolve.with(_immutable2.default.fromJS),
            totalPrice: _LinkMapper.fields.number,
            originalTotalPrice: _LinkMapper.fields.number,
            route: _LinkMapper.resolve.as(_Route2.default),
            tickets: _LinkMapper.resolveAll.as(_Ticket2.default),
            ticketType: _LinkMapper.resolve.as(_TicketType2.default),
            outwardValidity: _LinkMapper.resolve.as(_Validity2.default),
            returnValidity: _LinkMapper.resolve.as(_Validity2.default),
            alternateOrigins: _LinkMapper.resolveAll.as(_Station2.default),
            alternateDestinations: _LinkMapper.resolveAll.as(_Station2.default),
            utsZones: _LinkMapper.resolveAll.with(Number),
            restriction: _LinkMapper.fields.string,
            discountCode: _LinkMapper.fields.string,
            discountPercent: _LinkMapper.fields.number,
            discountFixedAmount: _LinkMapper.fields.number,
            seatAvailability: _LinkMapper.fields.number,
            discountName: _LinkMapper.fields.string,
            discountDescription: _LinkMapper.fields.string,
            priceComparison: _LinkMapper.resolve.as(_FarePriceComparison2.default),
            numberOfPasses: _LinkMapper.fields.number,
            setter: _LinkMapper.resolve.as(_Setter2.default)
        });
    };

    Fare.prototype.getPrice = function getPrice() {
        var price = this.totalPrice || 0;

        return price;
    };

    Fare.prototype.getPricePerFlexiPass = function getPricePerFlexiPass() {
        var price = this.totalPrice || 0;
        return price > 0 ? price / _AppConstants.FlexiSeasonValidation.PASSES_PER_FLEXI : 0;
    };

    Fare.prototype.getName = function getName() {
        var ticketName = this.ticketType.name;
        var subTypes = this.getSubTicketTypes().map(function (type) {
            return type.name;
        }).join(', ');
        if (subTypes) {
            return (0, _I18n.translate)('booking.fares.name.withSubtypes', { ticketName: ticketName, subTypes: subTypes });
        } else {
            return ticketName;
        }
    };

    Fare.prototype.getDescription = function getDescription() {
        return this.route.description && this.route.description.length > 1 ? this.route.description : null;
    };

    Fare.prototype.getOutwardDuration = function getOutwardDuration() {
        return this.outwardValidity.period.toDuration();
    };

    Fare.prototype.getTotalPrice = function getTotalPrice() {
        return (0, _Immutable.sum)(this.tickets, 'price');
    };

    Fare.prototype.getMatchingTicketPrice = function getMatchingTicketPrice(price) {
        var sortedTickets = this.tickets.sortBy(function (x) {
            return x.price;
        });
        var match = sortedTickets.find(function (ticket) {
            return ticket.price >= price;
        });
        return match && match.price;
    };

    Fare.prototype.hasMatchingOrLowerTicketPrice = function hasMatchingOrLowerTicketPrice(price) {
        return this.tickets.some(function (ticket) {
            return ticket.price ? ticket.price <= price : ticket.totalPrice <= price;
        });
    };

    Fare.prototype.hasMatchingOrHigherTicketPrice = function hasMatchingOrHigherTicketPrice(price) {
        return this.tickets.some(function (ticket) {
            return ticket.price ? ticket.price >= price : ticket.totalPrice >= price;
        });
    };

    Fare.prototype.hasMatchingTicketType = function hasMatchingTicketType(ticketType) {
        return this.ticketType.code === ticketType;
    };

    Fare.prototype.isReturn = function isReturn() {
        return this.ticketType.isReturn;
    };

    Fare.prototype.isStandard = function isStandard() {
        return !this.ticketType.isFirstClass;
    };

    Fare.prototype.isFirstClass = function isFirstClass() {
        return this.ticketType.isFirstClass;
    };

    Fare.prototype.getClass = function getClass() {
        return this.isStandard() ? _AppConstants.FareClasses.STANDARD : _AppConstants.FareClasses.FIRST_CLASS;
    };

    Fare.prototype.isCarnet = function isCarnet() {
        return this.ticketType.isCarnet;
    };

    Fare.prototype.isSmartCarnet = function isSmartCarnet() {
        return this.ticketType.isSmartCarnet();
    };

    Fare.prototype.isGroupSave = function isGroupSave() {
        return this.tickets.some(function (ticket) {
            return ticket.isGroupSave();
        });
    };

    Fare.prototype.isDiscounted = function isDiscounted() {
        return !!this.discountPercent || this.tickets.some(function (ticket) {
            return ticket.hasPromoDiscount();
        });
    };

    Fare.prototype.hasRailcard = function hasRailcard() {
        return this.tickets.some(function (ticket) {
            return ticket.railcard && !ticket.isGroupSave();
        });
    };

    Fare.prototype.isTravelcard = function isTravelcard() {
        return this.origin.isTravelcard() || this.destination.isTravelcard();
    };

    Fare.prototype.isDaySave = function isDaySave() {
        return this.ticketType.isDaySave();
    };

    Fare.prototype.isDaySaveOffPeak = function isDaySaveOffPeak() {
        return this.ticketType.isDaySaveOffPeak();
    };

    Fare.prototype.isRoversRangers = function isRoversRangers() {
        return this.ticketType.isRoversRangers();
    };

    Fare.prototype.isSeatCompulsory = function isSeatCompulsory() {
        return this.ticketType.isAdvance;
    };

    Fare.prototype.isPlusBus = function isPlusBus() {
        return this.ticketType.isPlusBus();
    };

    Fare.prototype.isSeason = function isSeason() {
        return this.ticketType.isSeason;
    };

    Fare.prototype.isFlexi = function isFlexi() {
        return this.ticketType.isFlexi;
    };

    Fare.prototype.isOffPeak = function isOffPeak() {
        return this.category === _AppConstants.FareCategories.OFF_PEAK;
    };

    Fare.prototype.isAnytime = function isAnytime() {
        return this.category === _AppConstants.FareCategories.ANYTIME;
    };

    Fare.prototype.isAdvance = function isAdvance() {
        var ticketName = this.getName();
        return this.category === _AppConstants.FareCategories.ADVANCE || ticketName === 'ADVANCE NETWORK WEEKEND';
    };

    Fare.prototype.isOpenGolf = function isOpenGolf() {
        return this.ticketType && this.ticketType.code && this.ticketType.code.match(_AppConstants.OPEN_GOLF_TICKET_CODE_REGEX);
    };

    Fare.prototype.isReorderable = function isReorderable() {
        return !(this.isPlusBus() || this.isAdvance() || this.isDaySave() || this.isRoversRangers() || this.isOpenGolf());
    };

    Fare.prototype.isSmartcard = function isSmartcard() {
        return this.tickets.some(function (ticket) {
            return ticket.getIn(['passenger', 'smartcardNumber']);
        });
    };

    Fare.prototype.getValidFrom = function getValidFrom() {
        return this.outwardValidity.from;
    };

    Fare.prototype.getOriginalTotalPrice = function getOriginalTotalPrice() {
        if (this.isDiscounted()) {
            return this.originalTotalPrice;
        }
        return (0, _Immutable.sum)(this.tickets, 'railcardDiscount') + this.getPrice();
    };

    Fare.prototype.getSubTicketTypes = function getSubTicketTypes() {
        var ticketTypes = (0, _Immutable.compact)(this.tickets.map(function (ticket) {
            return ticket.ticketTypeOverride;
        }));
        return (0, _Immutable.unique)(ticketTypes, function (type) {
            return type.code;
        });
    };

    Fare.prototype.getPassengers = function getPassengers() {
        return (0, _Immutable.compact)(this.tickets.map(function (ticket) {
            return ticket.passenger;
        }));
    };

    Fare.prototype.getPassengerCounts = function getPassengerCounts() {
        var children = (0, _Immutable.sum)(this.tickets, 'children');
        var adults = (0, _Immutable.sum)(this.tickets, 'adults');
        return { adults: adults, children: children };
    };

    Fare.prototype.adults = function adults() {
        return this.isSmartCarnet() ? 1 : (0, _Immutable.sum)(this.tickets, 'adults');
    };

    Fare.prototype.children = function children() {
        return (0, _Immutable.sum)(this.tickets, 'children');
    };

    Fare.prototype.getRailcardCounts = function getRailcardCounts() {
        return this.tickets.reduce(function (acc, _ref2) {
            var railcard = _ref2.railcard;

            if (railcard && !railcard.isGroupSave()) {
                var code = railcard.code;

                acc[code] = acc[code] || 0;
                acc[code]++;
            }
            return acc;
        }, {});
    };

    Fare.prototype.getAllRailcards = function getAllRailcards() {
        return this.tickets.reduce(function (railcards, _ref3) {
            var railcard = _ref3.railcard;

            if (railcard && railcard.code && !railcard.isGroupSave()) {
                railcards = railcards.push(railcard);
            }
            return railcards;
        }, new _immutable.List());
    };

    Fare.prototype.getCarnetInformation = function getCarnetInformation() {
        return this.ticketType.carnetInformation;
    };

    Fare.prototype.getFlexiInformation = function getFlexiInformation() {
        return this.ticketType.flexiInformation;
    };

    Fare.getStationWithLocation = function getStationWithLocation(station, alternativeStations) {
        station = (0, _Immutable.isImmutable)(station) ? station : (0, _LinkMapper.resolve)(station).as(_Station2.default);
        if (station.latitude && station.longitude) {
            return station;
        }

        var _getLatLngCenter = getLatLngCenter(alternativeStations.map(function (alt) {
            return [alt.latitude, alt.longitude];
        })),
            latitude = _getLatLngCenter[0],
            longitude = _getLatLngCenter[1];

        return station.merge({ latitude: latitude, longitude: longitude });
    };

    Fare.prototype.getOutwardValidityPeriod = function getOutwardValidityPeriod() {
        return this.outwardValidity.period;
    };

    Fare.prototype.getOutwardValidityDurationString = function getOutwardValidityDurationString() {
        return this.getOutwardValidityPeriod().toDuration().toJSON();
    };

    Fare.prototype.hasPriceComparison = function hasPriceComparison() {
        return this.priceComparison && !this.priceComparison.isEmpty();
    };

    Fare.prototype.getNRELinkParams = function getNRELinkParams() {
        var fareClass = _AppConstants.NRELinkFareClasses.STANDARD;
        if (this.isFirstClass()) {
            fareClass = _AppConstants.NRELinkFareClasses.FIRST;
        }
        return {
            origin: this.origin.crs || this.origin.nlc,
            destination: this.destination.crs || this.destination.nlc,
            outwardDate: (0, _moment2.default)(this.outwardValidity.from).format('DD-MMM-YY'),
            fareClass: fareClass
        };
    };

    Fare.prototype.getNRELinkQuery = function getNRELinkQuery() {
        var query = {};
        if (this.isReturn()) {
            (0, _set3.default)(query, 'returnDate', (0, _moment2.default)(this.returnValidity.from).format('DD-MMM-YY'));
        }
        return query;
    };

    Fare.prototype.getNumberOfPasses = function getNumberOfPasses() {
        if (this.isSmartCarnet()) {
            return this.tickets.size * _AppConstants.SmartCarnetValidation.PASSES_PER_BOOK;
        }

        if (this.isFlexi()) {
            return this.ticketType.flexiInformation.numberOfTickets;
        }

        return null;
    };

    Fare.prototype.setNumberOfPasses = function setNumberOfPasses() {
        var numberOfPasses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isSmartCarnet() ? _AppConstants.SmartCarnetValidation.PASSES_PER_BOOK : _AppConstants.FlexiSeasonValidation.PASSES_PER_FLEXI;

        return this.set('numberOfPasses', numberOfPasses);
    };

    Fare.prototype.includesJCPRailcardDiscount = function includesJCPRailcardDiscount() {
        return this.tickets.some(function (ticket) {
            return ticket.railcard && ticket.railcard.code === 'JCP';
        });
    };

    Fare.prototype.isWeeklyCapAvailable = function isWeeklyCapAvailable() {
        var isWeeklyTicket = this.getOutwardDuration().toJSON() === 'P7D';
        return isWeeklyTicket && this.origin.weeklyCapAvailable && this.destination.weeklyCapAvailable;
    };

    Fare.prototype.isTPEGroupSave = function isTPEGroupSave() {
        return this.discountCode === _AppConstants.TPE_GROUP_SAVE_CODE;
    };

    return Fare;
}((0, _immutable.Record)(defaults));

exports.default = Fare;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _invert2 = __webpack_require__(431);

var _invert3 = _interopRequireDefault(_invert2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _find2 = __webpack_require__(344);

var _find3 = _interopRequireDefault(_find2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _desc, _value, _obj;

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AddressService = __webpack_require__(543);

var _AddressService2 = _interopRequireDefault(_AddressService);

var _CustomerService = __webpack_require__(280);

var _CustomerService2 = _interopRequireDefault(_CustomerService);

var _KeyGoService = __webpack_require__(1020);

var _KeyGoService2 = _interopRequireDefault(_KeyGoService);

var _OrderHistoryService = __webpack_require__(835);

var _OrderHistoryService2 = _interopRequireDefault(_OrderHistoryService);

var _PaymentCardService = __webpack_require__(1744);

var _PaymentCardService2 = _interopRequireDefault(_PaymentCardService);

var _PhotocardService = __webpack_require__(837);

var _PhotocardService2 = _interopRequireDefault(_PhotocardService);

var _RailcardsService = __webpack_require__(620);

var _RailcardsService2 = _interopRequireDefault(_RailcardsService);

var _SmartcardService = __webpack_require__(1135);

var _SmartcardService2 = _interopRequireDefault(_SmartcardService);

var _VoucherService = __webpack_require__(1764);

var _VoucherService2 = _interopRequireDefault(_VoucherService);

var _STicketService = __webpack_require__(1765);

var _STicketService2 = _interopRequireDefault(_STicketService);

var _ConfirmationModalActions = __webpack_require__(629);

var _ConfirmationModalActions2 = _interopRequireDefault(_ConfirmationModalActions);

var _TokenActions = __webpack_require__(446);

var _TokenActions2 = _interopRequireDefault(_TokenActions);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AccountRailcard = __webpack_require__(1769);

var _Customer = __webpack_require__(447);

var _Smartcard = __webpack_require__(336);

var _Loading = __webpack_require__(546);

var _Registration = __webpack_require__(355);

var _Registration2 = _interopRequireDefault(_Registration);

var _UserPreferences = __webpack_require__(228);

var _UserPreferences2 = _interopRequireDefault(_UserPreferences);

var _EditPreferencesForm = __webpack_require__(1054);

var _EditPreferencesForm2 = _interopRequireDefault(_EditPreferencesForm);

var _SmartcardAssociationInfo = __webpack_require__(674);

var _SmartcardAssociationInfo2 = _interopRequireDefault(_SmartcardAssociationInfo);

var _LinkMapper = __webpack_require__(8);

var _AuthResponse = __webpack_require__(607);

var _AuthResponse2 = _interopRequireDefault(_AuthResponse);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var withSmartcardLoadingActions = (0, _Loading.createLoadingDecoratorFor)(_AppConstants.LoadingTypes.SMARTCARD);
var isErrorPresent = function isErrorPresent(error) {
    return error && error.body && error.body.errors && error.body.errors.length;
};

var CustomerActions = (_obj = {
    registerWithPayment: function registerWithPayment(registration, payment) {
        var form = new _Registration2.default().merge(registration.toJS()).set('email', payment.contact.email).set('referrer', _AppConstants.RegistrationReferrers.PAYMENT_FORM);

        if (!registration.get('phone')) {
            form = form.set('phone', payment.contact.phone);
        }

        return CustomerActions.register(form);
    },
    registerWithDelayRepay: function registerWithDelayRepay(form) {
        form = new _Registration2.default(form).set('referrer', _AppConstants.RegistrationReferrers.DELAY_REPAY);
        return this.register(form);
    },
    register: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(registration) {
            var amazonToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var user, errors, emailIsInUse, migrationRequired;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            user = void 0;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.REGISTRATION_STARTED
                            });

                            if (!registration.isAmazonRegistration) {
                                _context.next = 9;
                                break;
                            }

                            _context.next = 6;
                            return _CustomerService2.default.createAmazon(registration, amazonToken);

                        case 6:
                            user = _context.sent;
                            _context.next = 12;
                            break;

                        case 9:
                            _context.next = 11;
                            return _CustomerService2.default.create(registration);

                        case 11:
                            user = _context.sent;

                        case 12:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.REGISTRATION_SUCCESS,
                                user: user
                            });

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.LOGGED_IN,
                                user: user
                            });

                            _TokenActions2.default.updateDevice(user.accessTokenDevice);

                            return _context.abrupt('return', user);

                        case 18:
                            _context.prev = 18;
                            _context.t0 = _context['catch'](0);

                            console.error(_context.t0);
                            errors = (0, _result3.default)(_context.t0, 'body.errors', []);
                            emailIsInUse = (0, _find3.default)(errors, { code: 8000 });
                            migrationRequired = (0, _find3.default)(errors, { code: 8100 });


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.REGISTRATION_FAILED
                            });

                            if (!(migrationRequired || emailIsInUse)) {
                                _context.next = 27;
                                break;
                            }

                            throw new _Customer.CustomerEmailInUseError();

                        case 27:
                            throw new _Customer.CustomerRegistrationError('Unexpected registration error', { error: _context.t0 });

                        case 28:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 18]]);
        }));

        function register(_x2) {
            return _ref.apply(this, arguments);
        }

        return register;
    }(),
    loginWithToken: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
            var token = _ref2.token;
            var user, isAmazonIdentityProvider, identityProviders;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AUTH_LOADED,
                                token: token
                            });

                            _context2.next = 3;
                            return _CustomerService2.default.fetch(token);

                        case 3:
                            user = _context2.sent;

                            if (!_FeatureFlagStore2.default.get('enableAmazonLogin')) {
                                _context2.next = 10;
                                break;
                            }

                            _context2.next = 7;
                            return _CustomerService2.default.fetchIdentityProvider(user.id, _AppConstants.IdentityProviders.AMAZON);

                        case 7:
                            isAmazonIdentityProvider = _context2.sent;
                            identityProviders = isAmazonIdentityProvider ? [_AppConstants.IdentityProviders.AMAZON] : null;


                            user = user.setIdentityProviders(identityProviders);

                        case 10:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.LOGGED_IN,
                                user: user
                            });

                            this.notifyApprovedRailcards({ onlyUnseen: true });

                            return _context2.abrupt('return', user);

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function loginWithToken(_x3) {
            return _ref3.apply(this, arguments);
        }

        return loginWithToken;
    }(),
    login: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref4) {
            var username = _ref4.username,
                password = _ref4.password;
            var token;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _CustomerService2.default.auth(username, password);

                        case 3:
                            token = _context3.sent;
                            return _context3.abrupt('return', CustomerActions.loginWithToken({ token: token }));

                        case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3['catch'](0);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AUTH_ERROR,
                                error: _context3.t0
                            });
                            console.error(_context3.t0);

                            if (!(_context3.t0.hasCode && _context3.t0.hasCode(_Customer.CustomerMaxFailedLoginAttemptsReached.code))) {
                                _context3.next = 15;
                                break;
                            }

                            throw new _Customer.CustomerMaxFailedLoginAttemptsReached();

                        case 15:
                            if (!(_context3.t0.hasCode && _context3.t0.hasCode(_Customer.CustomerAccountDormant.code))) {
                                _context3.next = 19;
                                break;
                            }

                            throw new _Customer.CustomerAccountDormant();

                        case 19:
                            if (!(_context3.t0.hasCode && _context3.t0.hasCode(_Customer.CustomerAccountLocked.code))) {
                                _context3.next = 21;
                                break;
                            }

                            throw new _Customer.CustomerAccountLocked();

                        case 21:
                            throw new _Customer.CustomerLoginError();

                        case 22:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 7]]);
        }));

        function login(_x4) {
            return _ref5.apply(this, arguments);
        }

        return login;
    }(),
    setPreferredBrand: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(user, brandName) {
            var brandUpdate;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _CustomerService2.default.update(user, { brandUpdate: brandName });

                        case 2:
                            brandUpdate = _context4.sent;

                            if (!(user.isLoggedIn() && brandUpdate)) {
                                _context4.next = 7;
                                break;
                            }

                            user = brandUpdate;
                            _context4.next = 10;
                            break;

                        case 7:
                            _context4.next = 9;
                            return _CustomerService2.default.fetch(user.authToken, user);

                        case 9:
                            user = _context4.sent;

                        case 10:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: user
                            });

                            return _context4.abrupt('return', user);

                        case 12:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function setPreferredBrand(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return setPreferredBrand;
    }(),
    logout: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(user) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (user && user.isLoggedIn()) {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.LOGGED_OUT
                                });
                                _CustomerService2.default.logout(user);
                            }

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function logout(_x7) {
            return _ref7.apply(this, arguments);
        }

        return logout;
    }(),
    resetPassword: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(resetToken, password) {
            var authToken, user;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return _CustomerService2.default.resetPassword(resetToken, password);

                        case 2:
                            authToken = _context6.sent;

                            if (!authToken) {
                                _context6.next = 10;
                                break;
                            }

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AUTH_LOADED,
                                token: authToken
                            });

                            _context6.next = 7;
                            return _CustomerService2.default.fetch(authToken);

                        case 7:
                            user = _context6.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.LOGGED_IN,
                                user: user
                            });

                            return _context6.abrupt('return', user);

                        case 10:
                            return _context6.abrupt('return', null);

                        case 11:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function resetPassword(_x8, _x9) {
            return _ref8.apply(this, arguments);
        }

        return resetPassword;
    }(),
    refresh: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(user) {
            var shouldRefreshTokens = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var isRefreshingAuthToken, token, fetchedUser;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            isRefreshingAuthToken = _UserStore2.default.getIsRefreshingAuthToken();

                            /*
                                if we try to refresh an auth token in the middle of a previous
                                refresh request, we get an "Invalid refresh token" error back from
                                the customers/auth/refresh endpoint because it tries to use a token
                                that has now been deleted from the DB
                            */

                            if (!isRefreshingAuthToken) {
                                _context7.next = 3;
                                break;
                            }

                            return _context7.abrupt('return', false);

                        case 3:
                            _context7.prev = 3;
                            token = user.customer.accessToken;

                            if (!shouldRefreshTokens) {
                                _context7.next = 11;
                                break;
                            }

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AUTH_REFRESH_STARTED,
                                token: token
                            });
                            _context7.next = 9;
                            return _CustomerService2.default.refresh(user);

                        case 9:
                            token = _context7.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AUTH_REFRESHED,
                                token: token
                            });

                        case 11:
                            if (!token) {
                                _context7.next = 19;
                                break;
                            }

                            _context7.next = 14;
                            return _CustomerService2.default.fetch(token);

                        case 14:
                            fetchedUser = _context7.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: fetchedUser
                            });

                            _context7.next = 18;
                            return CustomerActions.getSmartcard(fetchedUser);

                        case 18:
                            return _context7.abrupt('return', fetchedUser);

                        case 19:
                            _context7.next = 26;
                            break;

                        case 21:
                            _context7.prev = 21;
                            _context7.t0 = _context7['catch'](3);

                            console.error(_context7.t0);
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.LOGGED_OUT
                            });
                            throw new _Customer.CustomerRefreshError();

                        case 26:
                            return _context7.abrupt('return', null);

                        case 27:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[3, 21]]);
        }));

        function refresh(_x11) {
            return _ref9.apply(this, arguments);
        }

        return refresh;
    }(),
    fetchUser: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(token) {
            var user;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return _CustomerService2.default.fetch(token);

                        case 2:
                            user = _context8.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: user
                            });

                            return _context8.abrupt('return', user);

                        case 5:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function fetchUser(_x12) {
            return _ref10.apply(this, arguments);
        }

        return fetchUser;
    }(),
    updateAuthenticatedProperties: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(_ref11) {
            var user = _ref11.user,
                currentPassword = _ref11.currentPassword,
                changes = _ref11.changes,
                _ref11$requireAuth = _ref11.requireAuth,
                requireAuth = _ref11$requireAuth === undefined ? true : _ref11$requireAuth;
            var updated;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.prev = 0;

                            if (!requireAuth) {
                                _context9.next = 4;
                                break;
                            }

                            _context9.next = 4;
                            return _CustomerService2.default.auth(user.email, currentPassword);

                        case 4:
                            _context9.next = 10;
                            break;

                        case 6:
                            _context9.prev = 6;
                            _context9.t0 = _context9['catch'](0);

                            console.error(_context9.t0);
                            throw new _Customer.CustomerLoginError();

                        case 10:
                            _context9.next = 12;
                            return _CustomerService2.default.update(user, changes);

                        case 12:
                            updated = _context9.sent;

                            if (!updated) {
                                _context9.next = 17;
                                break;
                            }

                            user = updated;
                            _context9.next = 20;
                            break;

                        case 17:
                            _context9.next = 19;
                            return _CustomerService2.default.fetch(user.authToken, user);

                        case 19:
                            user = _context9.sent;

                        case 20:
                            if (changes.password) {
                                user = user.setAuthToken(user.authToken.set('showPasswordChangeModal', false));
                            }

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: user
                            });

                            return _context9.abrupt('return', user);

                        case 23:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this, [[0, 6]]);
        }));

        function updateAuthenticatedProperties(_x13) {
            return _ref12.apply(this, arguments);
        }

        return updateAuthenticatedProperties;
    }(),
    checkEmail: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(email) {
            var checkEmail;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.next = 2;
                            return _CustomerService2.default.checkEmailAddress(email);

                        case 2:
                            checkEmail = _context10.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CHECK_EMAIL,
                                email: email
                            });
                            return _context10.abrupt('return', checkEmail);

                        case 5:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        function checkEmail(_x14) {
            return _ref13.apply(this, arguments);
        }

        return checkEmail;
    }(),
    updatePreferences: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(userId, form) {
            var omitAge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var preferences;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.next = 2;
                            return _CustomerService2.default.updatePreferences(userId, form, omitAge);

                        case 2:
                            preferences = _context11.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_PREFERENCES_UPDATED,
                                preferences: preferences,
                                isOver16: form.get('isOver16'),
                                telephoneNumber: form.get('telephoneNumber')
                            });
                            return _context11.abrupt('return', preferences);

                        case 5:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this);
        }));

        function updatePreferences(_x16, _x17) {
            return _ref14.apply(this, arguments);
        }

        return updatePreferences;
    }(),
    updateName: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(user, form) {
            var newUser;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return _CustomerService2.default.update(user, form);

                        case 2:
                            newUser = _context12.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: newUser
                            });

                            return _context12.abrupt('return', newUser);

                        case 5:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function updateName(_x18, _x19) {
            return _ref15.apply(this, arguments);
        }

        return updateName;
    }(),
    fetchPreferences: function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(userId) {
            var preferences;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.next = 2;
                            return _CustomerService2.default.fetchPreferences(userId);

                        case 2:
                            preferences = _context13.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_PREFERENCES_FETCHED,
                                preferences: preferences
                            });
                            return _context13.abrupt('return', preferences);

                        case 5:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this);
        }));

        function fetchPreferences(_x20) {
            return _ref16.apply(this, arguments);
        }

        return fetchPreferences;
    }(),
    getEmailUserPreferences: function () {
        var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(userId, token) {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.next = 2;
                            return _CustomerService2.default.fetchEmailUserPreferences(userId, token);

                        case 2:
                            return _context14.abrupt('return', _context14.sent);

                        case 3:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this);
        }));

        function getEmailUserPreferences(_x21, _x22) {
            return _ref17.apply(this, arguments);
        }

        return getEmailUserPreferences;
    }(),
    updateEmailUserPreferences: function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(userId, token, preferences) {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.next = 2;
                            return _CustomerService2.default.updateEmailUserPreferences(userId, token, preferences);

                        case 2:
                            return _context15.abrupt('return', _promise2.default.resolve());

                        case 3:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this);
        }));

        function updateEmailUserPreferences(_x23, _x24, _x25) {
            return _ref18.apply(this, arguments);
        }

        return updateEmailUserPreferences;
    }(),
    setPasswordAndPreferences: function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(token, form) {
            var authToken, user, isOver16, telephoneNumber, preferences;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            _context16.prev = 0;
                            _context16.next = 3;
                            return _CustomerService2.default.resetPassword(token, form.password);

                        case 3:
                            authToken = _context16.sent;

                            if (!authToken) {
                                _context16.next = 18;
                                break;
                            }

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AUTH_LOADED,
                                token: authToken
                            });

                            _context16.next = 8;
                            return _CustomerService2.default.fetch(authToken);

                        case 8:
                            user = _context16.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.LOGGED_IN,
                                user: user
                            });

                            if (!user) {
                                _context16.next = 17;
                                break;
                            }

                            isOver16 = form.get('isOver16') || user.isOver16;
                            telephoneNumber = form.get('telephoneNumber') || user.get('telephoneNumber');
                            _context16.next = 15;
                            return _CustomerService2.default.patchPreferences(user.id, _UserPreferences2.default.getRegistrationPreferencesFields(form.get('preferences')));

                        case 15:
                            preferences = _context16.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_PREFERENCES_UPDATED,
                                preferences: preferences,
                                isOver16: isOver16,
                                telephoneNumber: telephoneNumber
                            });

                        case 17:
                            return _context16.abrupt('return', user);

                        case 18:
                            return _context16.abrupt('return', null);

                        case 21:
                            _context16.prev = 21;
                            _context16.t0 = _context16['catch'](0);
                            throw _context16.t0;

                        case 24:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, this, [[0, 21]]);
        }));

        function setPasswordAndPreferences(_x26, _x27) {
            return _ref19.apply(this, arguments);
        }

        return setPasswordAndPreferences;
    }(),
    getVouchers: function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(user) {
            var vouchers;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_VOUCHERS_STARTED
                            });

                            _context17.prev = 1;
                            _context17.next = 4;
                            return _VoucherService2.default.getAll(user);

                        case 4:
                            vouchers = _context17.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_VOUCHERS_LOADED,
                                vouchers: vouchers
                            });
                            return _context17.abrupt('return', vouchers);

                        case 9:
                            _context17.prev = 9;
                            _context17.t0 = _context17['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_VOUCHERS_FAILED,
                                error: _context17.t0
                            });
                            return _context17.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, this, [[1, 9]]);
        }));

        function getVouchers(_x28) {
            return _ref20.apply(this, arguments);
        }

        return getVouchers;
    }(),
    getPaymentCards: function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(user) {
            var cards;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_PAYMENTCARDS_STARTED
                            });

                            _context18.next = 3;
                            return _PaymentCardService2.default.getAll(user);

                        case 3:
                            cards = _context18.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_PAYMENTCARDS_LOADED,
                                cards: cards
                            });

                            return _context18.abrupt('return', cards);

                        case 6:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, this);
        }));

        function getPaymentCards(_x29) {
            return _ref21.apply(this, arguments);
        }

        return getPaymentCards;
    }(),
    deletePaymentCard: function () {
        var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(user, card) {
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            _context19.next = 2;
                            return _PaymentCardService2.default.delete(user, card);

                        case 2:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_PAYMENTCARD_DELETED,
                                deleted: card
                            });

                        case 3:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, this);
        }));

        function deletePaymentCard(_x30, _x31) {
            return _ref22.apply(this, arguments);
        }

        return deletePaymentCard;
    }(),
    registerSmartcard: function () {
        var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(user, form) {
            var currentPreferences, updatedPreferences, emailPromotions, smsPromotions, emailProducts, smsProducts, finalPreferences;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            _context20.prev = 0;
                            _context20.next = 3;
                            return _SmartcardService2.default.registerSmartcard(user, form);

                        case 3:
                            user = user.setHasRegisteredSmartcard(true);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_REGISTERED
                            });

                            if (!_FeatureFlagStore2.default.get('enableAutoDelayRepay')) {
                                _context20.next = 14;
                                break;
                            }

                            currentPreferences = _EditPreferencesForm2.default.fromUser(user);
                            _context20.next = 9;
                            return this.fetchPreferences(user.id);

                        case 9:
                            updatedPreferences = _context20.sent;


                            /*
                                The below must be set to false for under 16s.
                                When registering for a Child Smartcard, the BE will
                                override any marketing prefs to false, and the FE must get these
                                to avoid accidentally setting these back to true when opting in to
                                auto delay repay
                                 emailPromotions
                                smsPromotions
                                emailProducts
                                smsProducts
                            */

                            emailPromotions = updatedPreferences.emailPromotions, smsPromotions = updatedPreferences.smsPromotions, emailProducts = updatedPreferences.emailProducts, smsProducts = updatedPreferences.smsProducts;
                            finalPreferences = currentPreferences.setIn(['preferences', 'autoDelayRepay'], true) // opt the customer in to auto-delay-repay regardless of age
                            .setIn(['preferences', 'emailPromotions'], emailPromotions).setIn(['preferences', 'smsPromotions'], smsPromotions).setIn(['preferences', 'emailProducts'], emailProducts).setIn(['preferences', 'smsProducts'], smsProducts);
                            _context20.next = 14;
                            return this.updatePreferences(user.id, finalPreferences, true);

                        case 14:
                            _context20.next = 16;
                            return this.loadAddresses(user);

                        case 16:
                            _context20.next = 18;
                            return this.getSmartcard(user);

                        case 18:
                            return _context20.abrupt('return', _context20.sent);

                        case 21:
                            _context20.prev = 21;
                            _context20.t0 = _context20['catch'](0);

                            if (_context20.t0 instanceof _Smartcard.SmartcardRegistrationError) {
                                _context20.next = 26;
                                break;
                            }

                            console.error(_context20.t0);
                            throw new _Smartcard.SmartcardRegistrationError('Unexpected registration failure', { error: _context20.t0 });

                        case 26:
                            throw _context20.t0;

                        case 27:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, this, [[0, 21]]);
        }));

        function registerSmartcard(_x32, _x33) {
            return _ref23.apply(this, arguments);
        }

        return registerSmartcard;
    }(),
    linkSmartcard: function () {
        var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(user, form, type) {
            var updatedPreferences;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            _context21.prev = 0;
                            _context21.next = 3;
                            return _SmartcardService2.default.linkSmartcard(user, form, type);

                        case 3:
                            user = user.setHasRegisteredSmartcard(true);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_LINKED
                            });

                            if (!_FeatureFlagStore2.default.get('enableAutoDelayRepay')) {
                                _context21.next = 9;
                                break;
                            }

                            updatedPreferences = _EditPreferencesForm2.default.fromUser(user).setIn(['preferences', 'autoDelayRepay'], true);
                            _context21.next = 9;
                            return this.updatePreferences(user.id, updatedPreferences);

                        case 9:
                            _context21.next = 11;
                            return this.loadAddresses(user);

                        case 11:
                            _context21.next = 13;
                            return this.getSmartcard(user);

                        case 13:
                            return _context21.abrupt('return', _context21.sent);

                        case 16:
                            _context21.prev = 16;
                            _context21.t0 = _context21['catch'](0);

                            if (_context21.t0 instanceof _Smartcard.SelfSmartcardRegistrationError) {
                                _context21.next = 21;
                                break;
                            }

                            console.error(_context21.t0);
                            throw new _Smartcard.SelfSmartcardRegistrationError('Unexpected registration failure', { error: _context21.t0 });

                        case 21:
                            throw _context21.t0;

                        case 22:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, this, [[0, 16]]);
        }));

        function linkSmartcard(_x34, _x35, _x36) {
            return _ref24.apply(this, arguments);
        }

        return linkSmartcard;
    }(),
    getSmartcard: function () {
        var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(user) {
            var smartcard;
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            if (_FeatureFlagStore2.default.get('enableSmartcard')) {
                                _context22.next = 2;
                                break;
                            }

                            return _context22.abrupt('return', _promise2.default.resolve(null));

                        case 2:
                            _context22.prev = 2;
                            _context22.next = 5;
                            return _SmartcardService2.default.getSmartcard(user);

                        case 5:
                            smartcard = _context22.sent;

                            if (smartcard) {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.SMARTCARD_LOADED,
                                    smartcard: smartcard
                                });
                            }
                            return _context22.abrupt('return', smartcard);

                        case 10:
                            _context22.prev = 10;
                            _context22.t0 = _context22['catch'](2);

                            console.error(_context22.t0);
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_FAILED,
                                error: _context22.t0
                            });

                            if (!_SmartcardStore2.default.get('smartcardFailureNotified')) {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                    type: _AppConstants.GlobalModals.ERROR,
                                    data: {
                                        heading: 'error.smartcard.heading',
                                        title: 'error.smartcard.title',
                                        message: 'error.smartcard.message'
                                    }
                                });
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.SMARTCARD_FAILURE_NOTIFIED
                                });
                            }
                            return _context22.abrupt('return', null);

                        case 16:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, this, [[2, 10]]);
        }));

        function getSmartcard(_x37) {
            return _ref25.apply(this, arguments);
        }

        return getSmartcard;
    }(),
    getSmartcardPhoto: function () {
        var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(user) {
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            if (_FeatureFlagStore2.default.get('enableSmartcard')) {
                                _context23.next = 2;
                                break;
                            }

                            return _context23.abrupt('return', _promise2.default.resolve(null));

                        case 2:
                            _context23.next = 4;
                            return _SmartcardService2.default.getSmartcardPhoto(user);

                        case 4:
                            return _context23.abrupt('return', _context23.sent);

                        case 5:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, this);
        }));

        function getSmartcardPhoto(_x38) {
            return _ref26.apply(this, arguments);
        }

        return getSmartcardPhoto;
    }(),
    uploadNewSmartcardPhoto: function () {
        var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(user, photo) {
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            _context24.next = 2;
                            return _SmartcardService2.default.uploadNewSmartcardPhoto(user, photo);

                        case 2:
                            return _context24.abrupt('return', _context24.sent);

                        case 3:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, this);
        }));

        function uploadNewSmartcardPhoto(_x39, _x40) {
            return _ref27.apply(this, arguments);
        }

        return uploadNewSmartcardPhoto;
    }(),
    disableCollectionLocation: function disableCollectionLocation() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SMARTCARD_SET_SHOW_COLLECTION_LOCATION,
                showCollectionLocation: false
            });
        });
    },
    refreshSmartcard: function () {
        var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(user) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_DIRTY
                            });
                            _context25.next = 3;
                            return _promise2.default.delay(delay);

                        case 3:
                            _context25.next = 5;
                            return CustomerActions.getSmartcard(user);

                        case 5:
                            return _context25.abrupt('return', _context25.sent);

                        case 6:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, this);
        }));

        function refreshSmartcard(_x42) {
            return _ref28.apply(this, arguments);
        }

        return refreshSmartcard;
    }(),
    getAllSmartcards: function () {
        var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(user) {
            var smartcards;
            return _regenerator2.default.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            _context26.next = 2;
                            return _SmartcardService2.default.getAllSmartcards(user);

                        case 2:
                            smartcards = _context26.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARDS_LOADED,
                                smartcards: smartcards
                            });
                            return _context26.abrupt('return', smartcards);

                        case 5:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, this);
        }));

        function getAllSmartcards(_x43) {
            return _ref29.apply(this, arguments);
        }

        return getAllSmartcards;
    }(),
    getSmartcardUrl: function getSmartcardUrl(user) {
        return _SmartcardService2.default.getSmartcardUrl(user);
    },
    getOrderHistory: function () {
        var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(user) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var _ref31, orders, pagination;

            return _regenerator2.default.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            if (!(!user || !user.isLoggedIn())) {
                                _context27.next = 2;
                                break;
                            }

                            return _context27.abrupt('return');

                        case 2:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_ORDERS_SEARCHING,
                                params: params
                            });

                            _context27.next = 5;
                            return _OrderHistoryService2.default.search(user, params);

                        case 5:
                            _ref31 = _context27.sent;
                            orders = _ref31.orders;
                            pagination = _ref31.pagination;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_ORDERS_LOADED,
                                orders: orders, pagination: pagination
                            });

                        case 9:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, this);
        }));

        function getOrderHistory(_x45) {
            return _ref30.apply(this, arguments);
        }

        return getOrderHistory;
    }(),
    getOrderDetails: function () {
        var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(orderId) {
            var order, refundCalculations;
            return _regenerator2.default.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            _context28.next = 2;
                            return _OrderHistoryService2.default.fetch(orderId);

                        case 2:
                            order = _context28.sent;
                            refundCalculations = new _immutable.List();

                            if (!order.hasRefunds()) {
                                _context28.next = 8;
                                break;
                            }

                            _context28.next = 7;
                            return _OrderHistoryService2.default.fetchRefundCalculations(orderId);

                        case 7:
                            refundCalculations = _context28.sent;

                        case 8:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_ORDER_LOADED,
                                order: order,
                                refundCalculations: refundCalculations
                            });

                            return _context28.abrupt('return', order);

                        case 10:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, this);
        }));

        function getOrderDetails(_x46) {
            return _ref32.apply(this, arguments);
        }

        return getOrderDetails;
    }(),
    getOrderHistoryDetails: function () {
        var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(orderId) {
            var order;
            return _regenerator2.default.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            _context29.next = 2;
                            return _OrderHistoryService2.default.getOrderHistory(orderId);

                        case 2:
                            order = _context29.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CUSTOMER_ORDER_LOADED,
                                order: order
                            });

                            return _context29.abrupt('return', order);

                        case 5:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, this);
        }));

        function getOrderHistoryDetails(_x47) {
            return _ref33.apply(this, arguments);
        }

        return getOrderHistoryDetails;
    }(),
    getKeyGoTaps: function () {
        var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(user, smartcard) {
            var taps;
            return _regenerator2.default.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            if (!(!smartcard || !smartcard.hasKeyGo())) {
                                _context30.next = 2;
                                break;
                            }

                            return _context30.abrupt('return');

                        case 2:
                            _context30.next = 4;
                            return _SmartcardService2.default.getKeyGoTaps(user, smartcard);

                        case 4:
                            taps = _context30.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.KEYGO_TAPS_LOADED,
                                taps: taps
                            });

                        case 6:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, this);
        }));

        function getKeyGoTaps(_x48, _x49) {
            return _ref34.apply(this, arguments);
        }

        return getKeyGoTaps;
    }(),
    getKeyGoTransactionHistory: function () {
        var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(smartcard) {
            var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var transactionHistory;
            return _regenerator2.default.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            if (smartcard) {
                                _context31.next = 2;
                                break;
                            }

                            return _context31.abrupt('return');

                        case 2:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.KEYGO_TRANSACTIONS_LOADING
                            });

                            _context31.next = 5;
                            return _KeyGoService2.default.getKeyGoTransactions(queryParams);

                        case 5:
                            transactionHistory = _context31.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.KEYGO_TRANSACTIONS_LOADED,
                                transactionHistory: transactionHistory
                            });

                        case 7:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, this);
        }));

        function getKeyGoTransactionHistory(_x51) {
            return _ref35.apply(this, arguments);
        }

        return getKeyGoTransactionHistory;
    }(),
    getSmartcardJourneys: function () {
        var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(user, smartcard) {
            var journeys;
            return _regenerator2.default.wrap(function _callee32$(_context32) {
                while (1) {
                    switch (_context32.prev = _context32.next) {
                        case 0:
                            if (!(!smartcard || smartcard.hasKeyGo())) {
                                _context32.next = 2;
                                break;
                            }

                            return _context32.abrupt('return');

                        case 2:
                            _context32.next = 4;
                            return _SmartcardService2.default.getJourneys(user, smartcard);

                        case 4:
                            journeys = _context32.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_JOURNEYS_LOADED,
                                journeys: journeys
                            });

                        case 6:
                        case 'end':
                            return _context32.stop();
                    }
                }
            }, _callee32, this);
        }));

        function getSmartcardJourneys(_x52, _x53) {
            return _ref36.apply(this, arguments);
        }

        return getSmartcardJourneys;
    }(),
    resetKeyGoForm: function resetKeyGoForm() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.KEYGO_FORM_RESET
        });
    },
    changeKeyGoForm: function changeKeyGoForm(field, value) {
        _AppDispatcher2.default.dispatch({
            field: field,
            value: value,
            actionType: _AppConstants.ActionTypes.KEYGO_FORM_CHANGED
        });
    },
    changeRailcard1617Form: function changeRailcard1617Form(field, value) {
        _AppDispatcher2.default.dispatch({
            field: field,
            value: value,
            actionType: _AppConstants.ActionTypes.RAILCARD1617_FORM_CHANGED
        });
    },
    keyGoFormAddressSelected: function keyGoFormAddressSelected(address) {
        _AppDispatcher2.default.dispatch({
            address: address,
            actionType: _AppConstants.ActionTypes.KEYGO_ADDRESS_SELECTED
        });
    },
    retryKeyGoForm: function retryKeyGoForm() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.KEYGO_FORM_RETRY
        });
    },
    registrationKeyGoFormComplete: function registrationKeyGoFormComplete() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.KEYGO_REGISTRATION_COMPLETE
        });
    },
    keyGoUpdateComplete: function keyGoUpdateComplete() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.KEYGO_UPDATE_COMPLETE
        });
    },
    registerKeyGo: function () {
        var _ref37 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(user, form) {
            var response, threeDSecureAuthResponse, code, messages, message;
            return _regenerator2.default.wrap(function _callee33$(_context33) {
                while (1) {
                    switch (_context33.prev = _context33.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.KEYGO_REGISTRATION_STARTED,
                                collectionLocation: form.collectionLocation
                            });

                            _context33.prev = 1;
                            _context33.next = 4;
                            return _SmartcardService2.default.registerKeyGo(user, form);

                        case 4:
                            response = _context33.sent;
                            threeDSecureAuthResponse = (0, _LinkMapper.resolve)(response.result).as(_AuthResponse2.default);


                            if (_FeatureFlagStore2.default.get('enableRailcard1617')) {
                                this.notifyApprovedRailcards({ filterRailcards: ['TSU'], goToRailcardsPageOnConfirm: false });
                            }

                            if (!threeDSecureAuthResponse.isEnrolled()) {
                                _context33.next = 11;
                                break;
                            }

                            return _context33.abrupt('return', threeDSecureAuthResponse);

                        case 11:
                            if (!(!threeDSecureAuthResponse.isEnrolled() && !threeDSecureAuthResponse.isError())) {
                                _context33.next = 17;
                                break;
                            }

                            CustomerActions.registrationKeyGoFormComplete();
                            CustomerActions.getPaymentCards(user);
                            return _context33.abrupt('return', threeDSecureAuthResponse);

                        case 17:
                            // assumed to be an error scenario
                            code = threeDSecureAuthResponse.code;
                            messages = (0, _invert3.default)(_AppConstants.PaymentAuthCodes);
                            message = messages[code] || 'unknown error';


                            _AppDispatcher2.default.dispatch({
                                message: message,
                                actionType: _AppConstants.ActionTypes.KEYGO_REGISTRATION_FAILED
                            });

                        case 21:
                            _context33.next = 26;
                            break;

                        case 23:
                            _context33.prev = 23;
                            _context33.t0 = _context33['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                error: _context33.t0,
                                actionType: _AppConstants.ActionTypes.KEYGO_REGISTRATION_FAILED
                            });

                        case 26:
                            return _context33.abrupt('return', undefined);

                        case 27:
                        case 'end':
                            return _context33.stop();
                    }
                }
            }, _callee33, this, [[1, 23]]);
        }));

        function registerKeyGo(_x54, _x55) {
            return _ref37.apply(this, arguments);
        }

        return registerKeyGo;
    }(),
    registerKeyGoResume: function () {
        var _ref38 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34(user, paymentId) {
            var _ref39, result, status;

            return _regenerator2.default.wrap(function _callee34$(_context34) {
                while (1) {
                    switch (_context34.prev = _context34.next) {
                        case 0:
                            _context34.next = 2;
                            return _SmartcardService2.default.keyGoResume(user.customer.id, paymentId);

                        case 2:
                            _ref39 = _context34.sent;
                            result = _ref39.result;
                            status = result.status;


                            if (status === 'success') {
                                CustomerActions.registrationKeyGoFormComplete();
                                CustomerActions.getPaymentCards(user);
                            } else {
                                _AppDispatcher2.default.dispatch({
                                    error: 'authorisation error',
                                    actionType: _AppConstants.ActionTypes.KEYGO_UPDATE_FAILED
                                });
                            }

                            return _context34.abrupt('return', result);

                        case 7:
                        case 'end':
                            return _context34.stop();
                    }
                }
            }, _callee34, this);
        }));

        function registerKeyGoResume(_x56, _x57) {
            return _ref38.apply(this, arguments);
        }

        return registerKeyGoResume;
    }(),
    updateKeyGo: function () {
        var _ref40 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35(user, form) {
            var response, threeDSecureAuthResponse, code, messages, message;
            return _regenerator2.default.wrap(function _callee35$(_context35) {
                while (1) {
                    switch (_context35.prev = _context35.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.KEYGO_UPDATE_STARTED
                            });

                            _context35.prev = 1;
                            _context35.next = 4;
                            return _SmartcardService2.default.updateKeyGo(user, form);

                        case 4:
                            response = _context35.sent;
                            threeDSecureAuthResponse = (0, _LinkMapper.resolve)(response.result).as(_AuthResponse2.default);

                            if (!threeDSecureAuthResponse.isEnrolled()) {
                                _context35.next = 10;
                                break;
                            }

                            return _context35.abrupt('return', threeDSecureAuthResponse);

                        case 10:
                            if (!(!threeDSecureAuthResponse.isEnrolled() && !threeDSecureAuthResponse.isError())) {
                                _context35.next = 16;
                                break;
                            }

                            CustomerActions.keyGoUpdateComplete();
                            CustomerActions.getPaymentCards(user);
                            return _context35.abrupt('return', threeDSecureAuthResponse);

                        case 16:
                            // assumed to be an error scenario
                            code = threeDSecureAuthResponse.code;
                            messages = (0, _invert3.default)(_AppConstants.PaymentAuthCodes);
                            message = messages[code] || 'unknown error';


                            _AppDispatcher2.default.dispatch({
                                error: message,
                                actionType: _AppConstants.ActionTypes.KEYGO_UPDATE_FAILED
                            });

                        case 20:
                            _context35.next = 25;
                            break;

                        case 22:
                            _context35.prev = 22;
                            _context35.t0 = _context35['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                error: _context35.t0,
                                actionType: _AppConstants.ActionTypes.KEYGO_UPDATE_FAILED
                            });

                        case 25:
                            return _context35.abrupt('return', undefined);

                        case 26:
                        case 'end':
                            return _context35.stop();
                    }
                }
            }, _callee35, this, [[1, 22]]);
        }));

        function updateKeyGo(_x58, _x59) {
            return _ref40.apply(this, arguments);
        }

        return updateKeyGo;
    }(),
    updateKeyGoResume: function () {
        var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee36(user, paymentId) {
            var _ref42, result, status;

            return _regenerator2.default.wrap(function _callee36$(_context36) {
                while (1) {
                    switch (_context36.prev = _context36.next) {
                        case 0:
                            _context36.next = 2;
                            return _SmartcardService2.default.keyGoResume(user.customer.id, paymentId);

                        case 2:
                            _ref42 = _context36.sent;
                            result = _ref42.result;
                            status = result.status;


                            if (status === 'success') {
                                CustomerActions.keyGoUpdateComplete();
                                CustomerActions.getPaymentCards(user);
                            } else {
                                _AppDispatcher2.default.dispatch({
                                    error: 'authorisation error',
                                    actionType: _AppConstants.ActionTypes.KEYGO_UPDATE_FAILED
                                });
                            }

                            return _context36.abrupt('return', result);

                        case 7:
                        case 'end':
                            return _context36.stop();
                    }
                }
            }, _callee36, this);
        }));

        function updateKeyGoResume(_x60, _x61) {
            return _ref41.apply(this, arguments);
        }

        return updateKeyGoResume;
    }(),
    cancelKeyGo: function () {
        var _ref43 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee37(user) {
            return _regenerator2.default.wrap(function _callee37$(_context37) {
                while (1) {
                    switch (_context37.prev = _context37.next) {
                        case 0:
                            _context37.next = 2;
                            return _SmartcardService2.default.cancelKeyGo(user);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.KEYGO_CANCELLED
                            });

                        case 3:
                        case 'end':
                            return _context37.stop();
                    }
                }
            }, _callee37, this);
        }));

        function cancelKeyGo(_x62) {
            return _ref43.apply(this, arguments);
        }

        return cancelKeyGo;
    }(),
    withdrawKeyGoBalance: function () {
        var _ref44 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee38() {
            return _regenerator2.default.wrap(function _callee38$(_context38) {
                while (1) {
                    switch (_context38.prev = _context38.next) {
                        case 0:
                            _context38.next = 2;
                            return _KeyGoService2.default.withdrawKeyGoBalance();

                        case 2:
                            return _context38.abrupt('return', _context38.sent);

                        case 3:
                        case 'end':
                            return _context38.stop();
                    }
                }
            }, _callee38, this);
        }));

        function withdrawKeyGoBalance() {
            return _ref44.apply(this, arguments);
        }

        return withdrawKeyGoBalance;
    }(),
    withdrawKeyGoBalanceWithCheque: function () {
        var _ref45 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee39(reimbursementId) {
            return _regenerator2.default.wrap(function _callee39$(_context39) {
                while (1) {
                    switch (_context39.prev = _context39.next) {
                        case 0:
                            _context39.next = 2;
                            return _KeyGoService2.default.withdrawKeyGoBalanceWithCheque(reimbursementId);

                        case 2:
                            return _context39.abrupt('return', _context39.sent);

                        case 3:
                        case 'end':
                            return _context39.stop();
                    }
                }
            }, _callee39, this);
        }));

        function withdrawKeyGoBalanceWithCheque(_x63) {
            return _ref45.apply(this, arguments);
        }

        return withdrawKeyGoBalanceWithCheque;
    }(),
    fetchChildSmartcardReplacement: function () {
        var _ref46 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee40(user) {
            var smartcardConfirmation;
            return _regenerator2.default.wrap(function _callee40$(_context40) {
                while (1) {
                    switch (_context40.prev = _context40.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.FETCH_CHILD_SMARTCARD_REPLACEMENT_STARTED,
                                    userId: user && user.id
                                });
                            });
                            _context40.prev = 1;
                            _context40.next = 4;
                            return _SmartcardService2.default.fetchChildSmartcardReplacement(user);

                        case 4:
                            smartcardConfirmation = _context40.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.FETCH_CHILD_SMARTCARD_REPLACEMENT_SUCCESS,
                                    smartcardConfirmation: smartcardConfirmation
                                });
                            });
                            return _context40.abrupt('return', smartcardConfirmation);

                        case 9:
                            _context40.prev = 9;
                            _context40.t0 = _context40['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.FETCH_CHILD_SMARTCARD_REPLACEMENT_FAILED,
                                    error: _context40.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.confirm-smartcard.fetch-smartcard-confirmation.failed' });
                            return _context40.abrupt('return', null);

                        case 14:
                            _context40.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.FETCH_CHILD_SMARTCARD_REPLACEMENT_FINISHED
                                });
                            });
                            return _context40.finish(14);

                        case 17:
                        case 'end':
                            return _context40.stop();
                    }
                }
            }, _callee40, this, [[1, 9, 14, 17]]);
        }));

        function fetchChildSmartcardReplacement(_x64) {
            return _ref46.apply(this, arguments);
        }

        return fetchChildSmartcardReplacement;
    }(),
    requestChildSmartcardReplacement: function () {
        var _ref48 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee41(_ref47) {
            var user = _ref47.user,
                isCardReplacementRequested = _ref47.isCardReplacementRequested;
            return _regenerator2.default.wrap(function _callee41$(_context41) {
                while (1) {
                    switch (_context41.prev = _context41.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.REQUEST_CHILD_SMARTCARD_REPLACEMENT_STARTED,
                                    userId: user && user.id
                                });
                            });
                            _context41.prev = 1;
                            _context41.next = 4;
                            return _SmartcardService2.default.requestChildSmartcardReplacement({
                                user: user,
                                isCardReplacementRequested: isCardReplacementRequested
                            });

                        case 4:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.REQUEST_CHILD_SMARTCARD_REPLACEMENT_SUCCESS
                                });
                            });
                            return _context41.abrupt('return', true);

                        case 8:
                            _context41.prev = 8;
                            _context41.t0 = _context41['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.REQUEST_CHILD_SMARTCARD_REPLACEMENT_FAILED,
                                    error: _context41.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.confirm-smartcard.request-smartcard-confirmation.failed' });
                            return _context41.abrupt('return', false);

                        case 13:
                            _context41.prev = 13;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.REQUEST_CHILD_SMARTCARD_REPLACEMENT_FINISHED
                                });
                            });
                            return _context41.finish(13);

                        case 16:
                        case 'end':
                            return _context41.stop();
                    }
                }
            }, _callee41, this, [[1, 8, 13, 16]]);
        }));

        function requestChildSmartcardReplacement(_x65) {
            return _ref48.apply(this, arguments);
        }

        return requestChildSmartcardReplacement;
    }(),
    replaceSmartcard: function () {
        var _ref49 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee42(user, smartcardReplacement) {
            var _smartcardReplacement, reason, additionalDetails, crimeNumber, response;

            return _regenerator2.default.wrap(function _callee42$(_context42) {
                while (1) {
                    switch (_context42.prev = _context42.next) {
                        case 0:
                            _smartcardReplacement = smartcardReplacement.toJS(), reason = _smartcardReplacement.reason, additionalDetails = _smartcardReplacement.additionalDetails, crimeNumber = _smartcardReplacement.crimeNumber;
                            _context42.next = 3;
                            return _SmartcardService2.default.replaceSmartcard(user, { reason: reason, additionalDetails: additionalDetails, crimeNumber: crimeNumber });

                        case 3:
                            response = _context42.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.REPLACEMENT_SMARTCARD_REQUESTED
                            });
                            return _context42.abrupt('return', response);

                        case 6:
                        case 'end':
                            return _context42.stop();
                    }
                }
            }, _callee42, this);
        }));

        function replaceSmartcard(_x66, _x67) {
            return _ref49.apply(this, arguments);
        }

        return replaceSmartcard;
    }(),
    loadAddresses: function () {
        var _ref50 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee43(user) {
            var addresses;
            return _regenerator2.default.wrap(function _callee43$(_context43) {
                while (1) {
                    switch (_context43.prev = _context43.next) {
                        case 0:
                            _context43.prev = 0;
                            _context43.next = 3;
                            return _AddressService2.default.getAll(user);

                        case 3:
                            addresses = _context43.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ADDRESSES_LOADED,
                                addresses: addresses
                            });
                            _context43.next = 10;
                            break;

                        case 7:
                            _context43.prev = 7;
                            _context43.t0 = _context43['catch'](0);

                            console.warn('error getting customer addresses', _context43.t0);

                        case 10:
                        case 'end':
                            return _context43.stop();
                    }
                }
            }, _callee43, this, [[0, 7]]);
        }));

        function loadAddresses(_x68) {
            return _ref50.apply(this, arguments);
        }

        return loadAddresses;
    }(),
    createAddress: function () {
        var _ref51 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee44(user, address, isDefault) {
            var newAddress;
            return _regenerator2.default.wrap(function _callee44$(_context44) {
                while (1) {
                    switch (_context44.prev = _context44.next) {
                        case 0:
                            _context44.next = 2;
                            return _AddressService2.default.create(user, address, isDefault);

                        case 2:
                            newAddress = _context44.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ADDRESS_CREATED,
                                address: newAddress
                            });

                        case 4:
                        case 'end':
                            return _context44.stop();
                    }
                }
            }, _callee44, this);
        }));

        function createAddress(_x69, _x70, _x71) {
            return _ref51.apply(this, arguments);
        }

        return createAddress;
    }(),
    deleteAddress: function () {
        var _ref52 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee45(user, address) {
            return _regenerator2.default.wrap(function _callee45$(_context45) {
                while (1) {
                    switch (_context45.prev = _context45.next) {
                        case 0:
                            _context45.next = 2;
                            return _AddressService2.default.delete(user, address);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ADDRESS_DELETED,
                                address: address
                            });

                        case 3:
                        case 'end':
                            return _context45.stop();
                    }
                }
            }, _callee45, this);
        }));

        function deleteAddress(_x72, _x73) {
            return _ref52.apply(this, arguments);
        }

        return deleteAddress;
    }(),
    updateAddress: function () {
        var _ref53 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee46(user, address, isDefault) {
            var updatedAddress;
            return _regenerator2.default.wrap(function _callee46$(_context46) {
                while (1) {
                    switch (_context46.prev = _context46.next) {
                        case 0:
                            _context46.next = 2;
                            return _AddressService2.default.update(user, address, isDefault);

                        case 2:
                            updatedAddress = _context46.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ADDRESS_UPDATED,
                                updatedAddress: updatedAddress
                            });

                        case 4:
                        case 'end':
                            return _context46.stop();
                    }
                }
            }, _callee46, this);
        }));

        function updateAddress(_x74, _x75, _x76) {
            return _ref53.apply(this, arguments);
        }

        return updateAddress;
    }(),
    loadPhotocards: function () {
        var _ref54 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee47(user) {
            var photocards;
            return _regenerator2.default.wrap(function _callee47$(_context47) {
                while (1) {
                    switch (_context47.prev = _context47.next) {
                        case 0:
                            _context47.next = 2;
                            return _PhotocardService2.default.getAll(user);

                        case 2:
                            photocards = _context47.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.PHOTOCARDS_LOADED,
                                photocards: photocards
                            });
                            return _context47.abrupt('return', photocards);

                        case 5:
                        case 'end':
                            return _context47.stop();
                    }
                }
            }, _callee47, this);
        }));

        function loadPhotocards(_x77) {
            return _ref54.apply(this, arguments);
        }

        return loadPhotocards;
    }(),
    resetPhotocards: function () {
        var _ref55 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee48() {
            var photocards;
            return _regenerator2.default.wrap(function _callee48$(_context48) {
                while (1) {
                    switch (_context48.prev = _context48.next) {
                        case 0:
                            photocards = new _immutable.List();

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.PHOTOCARDS_LOADED,
                                photocards: photocards
                            });
                            return _context48.abrupt('return', photocards);

                        case 3:
                        case 'end':
                            return _context48.stop();
                    }
                }
            }, _callee48, this);
        }));

        function resetPhotocards() {
            return _ref55.apply(this, arguments);
        }

        return resetPhotocards;
    }(),
    createPhotocard: function () {
        var _ref56 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee49(user, photocard) {
            var newPhotocard;
            return _regenerator2.default.wrap(function _callee49$(_context49) {
                while (1) {
                    switch (_context49.prev = _context49.next) {
                        case 0:
                            _context49.next = 2;
                            return _PhotocardService2.default.create(user, photocard);

                        case 2:
                            newPhotocard = _context49.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.PHOTOCARD_CREATED,
                                photocard: newPhotocard
                            });
                            return _context49.abrupt('return', newPhotocard);

                        case 5:
                        case 'end':
                            return _context49.stop();
                    }
                }
            }, _callee49, this);
        }));

        function createPhotocard(_x78, _x79) {
            return _ref56.apply(this, arguments);
        }

        return createPhotocard;
    }(),
    updateSTicketCard: function () {
        var _ref57 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee50(user, photocard) {
            return _regenerator2.default.wrap(function _callee50$(_context50) {
                while (1) {
                    switch (_context50.prev = _context50.next) {
                        case 0:
                            return _context50.abrupt('return', _PhotocardService2.default.updateSTicketCard(user, photocard));

                        case 1:
                        case 'end':
                            return _context50.stop();
                    }
                }
            }, _callee50, this);
        }));

        function updateSTicketCard(_x80, _x81) {
            return _ref57.apply(this, arguments);
        }

        return updateSTicketCard;
    }(),
    deletePhotocard: function () {
        var _ref58 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee51(user, photocard) {
            return _regenerator2.default.wrap(function _callee51$(_context51) {
                while (1) {
                    switch (_context51.prev = _context51.next) {
                        case 0:
                            _context51.next = 2;
                            return _PhotocardService2.default.delete(user, photocard);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.PHOTOCARD_DELETED,
                                photocard: photocard
                            });

                        case 3:
                        case 'end':
                            return _context51.stop();
                    }
                }
            }, _callee51, this);
        }));

        function deletePhotocard(_x82, _x83) {
            return _ref58.apply(this, arguments);
        }

        return deletePhotocard;
    }(),
    loadAccountRailcards: function () {
        var _ref59 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee52(user) {
            var _smartcard, filterRailcardCodes, smartcard, isKeyGo, accountRailcards;

            return _regenerator2.default.wrap(function _callee52$(_context52) {
                while (1) {
                    switch (_context52.prev = _context52.next) {
                        case 0:
                            if (_SmartcardStore2.default.getCurrent()) {
                                _context52.next = 7;
                                break;
                            }

                            _context52.next = 3;
                            return this.getSmartcard(user);

                        case 3:
                            _smartcard = _context52.sent;

                            if (!_smartcard) {
                                _context52.next = 7;
                                break;
                            }

                            _context52.next = 7;
                            return this.getAllSmartcards(user);

                        case 7:
                            filterRailcardCodes = void 0;


                            if (_FeatureFlagStore2.default.get('enableRailcard1617')) {
                                filterRailcardCodes = _AppConstants.filteredRailcards.season;
                            }

                            smartcard = _SmartcardStore2.default.getCurrent();
                            isKeyGo = !!(smartcard && smartcard.getKeyGoProduct());

                            if (_FeatureFlagStore2.default.get('enableKeyGoRailcards') && isKeyGo) {
                                filterRailcardCodes = _AppConstants.filteredRailcards.keyGo;
                            }

                            _context52.next = 14;
                            return _RailcardsService2.default.getAccountRailcards(user, filterRailcardCodes);

                        case 14:
                            accountRailcards = _context52.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ACCOUNT_RAILCARDS_LOADED,
                                accountRailcards: accountRailcards
                            });
                            return _context52.abrupt('return', accountRailcards);

                        case 17:
                        case 'end':
                            return _context52.stop();
                    }
                }
            }, _callee52, this);
        }));

        function loadAccountRailcards(_x84) {
            return _ref59.apply(this, arguments);
        }

        return loadAccountRailcards;
    }(),
    loadSTickets: function () {
        var _ref60 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee53(user) {
            var sTickets;
            return _regenerator2.default.wrap(function _callee53$(_context53) {
                while (1) {
                    switch (_context53.prev = _context53.next) {
                        case 0:
                            _context53.next = 2;
                            return _STicketService2.default.loadSTickets(user.id);

                        case 2:
                            sTickets = _context53.sent;
                            return _context53.abrupt('return', sTickets);

                        case 4:
                        case 'end':
                            return _context53.stop();
                    }
                }
            }, _callee53, this);
        }));

        function loadSTickets(_x85) {
            return _ref60.apply(this, arguments);
        }

        return loadSTickets;
    }(),
    loadSTicketSurfacedCoupons: function () {
        var _ref61 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee54(user, query) {
            var sTicketsCoupons;
            return _regenerator2.default.wrap(function _callee54$(_context54) {
                while (1) {
                    switch (_context54.prev = _context54.next) {
                        case 0:
                            _context54.next = 2;
                            return _STicketService2.default.getAllSurfacedCoupons(user.id, query);

                        case 2:
                            sTicketsCoupons = _context54.sent;
                            return _context54.abrupt('return', sTicketsCoupons);

                        case 4:
                        case 'end':
                            return _context54.stop();
                    }
                }
            }, _callee54, this);
        }));

        function loadSTicketSurfacedCoupons(_x86, _x87) {
            return _ref61.apply(this, arguments);
        }

        return loadSTicketSurfacedCoupons;
    }(),
    hasAnyActiveSTicket: function () {
        var _ref62 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee55(user) {
            var sTickets;
            return _regenerator2.default.wrap(function _callee55$(_context55) {
                while (1) {
                    switch (_context55.prev = _context55.next) {
                        case 0:
                            _context55.next = 2;
                            return this.loadSTickets(user);

                        case 2:
                            sTickets = _context55.sent;
                            return _context55.abrupt('return', sTickets.some(function (_ref63) {
                                var status = _ref63.status,
                                    isFlexi = _ref63.isFlexi;
                                return status === _AppConstants.STicketStatus.ACTIVE && !isFlexi;
                            }));

                        case 4:
                        case 'end':
                            return _context55.stop();
                    }
                }
            }, _callee55, this);
        }));

        function hasAnyActiveSTicket(_x88) {
            return _ref62.apply(this, arguments);
        }

        return hasAnyActiveSTicket;
    }(),
    hasAnyPendingSTicketPhotoRequests: function () {
        var _ref64 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee56(user) {
            var _ref65, result;

            return _regenerator2.default.wrap(function _callee56$(_context56) {
                while (1) {
                    switch (_context56.prev = _context56.next) {
                        case 0:
                            _context56.next = 2;
                            return _STicketService2.default.loadSTicketPhotoRequests(user);

                        case 2:
                            _ref65 = _context56.sent;
                            result = _ref65.result;
                            return _context56.abrupt('return', result && !!result.length);

                        case 5:
                        case 'end':
                            return _context56.stop();
                    }
                }
            }, _callee56, this);
        }));

        function hasAnyPendingSTicketPhotoRequests(_x89) {
            return _ref64.apply(this, arguments);
        }

        return hasAnyPendingSTicketPhotoRequests;
    }(),
    submitRailcardApplication: function () {
        var _ref66 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee57(user, data) {
            var formData, files;
            return _regenerator2.default.wrap(function _callee57$(_context57) {
                while (1) {
                    switch (_context57.prev = _context57.next) {
                        case 0:
                            formData = {
                                firstName: data.get('firstName'),
                                lastName: data.get('lastName'),
                                railcardCode: data.get('railcardCode'),
                                railcardNumber: data.get('railcardNumber'),
                                expiryDate: _TrainTime2.default.isoDate(data.get('expiryDate')),
                                syncWithKeygo: data.syncWithKeygo
                            };
                            files = {
                                photo: data.get('photo').get('selectedImage')
                            };
                            _context57.next = 4;
                            return _RailcardsService2.default.submitRailcardApplication(user, formData, files).then(function (response) {
                                if (response.result && response.result.state === 'PENDING') {
                                    _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD_APPLICATION_SUBMITTED });
                                    _AppDispatcher2.default.dispatch({
                                        actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                        type: _AppConstants.GlobalModals.INFO,
                                        data: {
                                            message: 'notifications.railcard.applicationSubmitted'
                                        }
                                    });
                                }
                            }).catch(function (error) {
                                console.error(error);
                                var hasErrors = isErrorPresent(error);
                                var isRailcardAlreadyExistError = hasErrors && error.body.errors[0].message.includes(_AppConstants.Railcard1617Errors.ALREADY_EXISTS);
                                var isRailcardNotFound = hasErrors && error.body.errors[0].message.toLowerCase().includes('not be found');
                                var heading = void 0,
                                    message = void 0,
                                    title = 'error.submit-railcard-application.message';

                                if (isRailcardAlreadyExistError) {
                                    heading = 'error.railcardAlreadyExist.heading';
                                    message = 'error.railcardAlreadyExist.message';
                                    title = 'error.railcardAlreadyExist.title';
                                } else if (isRailcardNotFound) {
                                    heading = 'error.railcardAlreadyExist.heading';
                                    message = 'booking.railcard1617.errors.invalid';
                                    title = 'error.railcardNotFound.title';
                                }

                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                    type: _AppConstants.GlobalModals.ERROR,
                                    data: {
                                        heading: heading,
                                        message: message,
                                        title: title
                                    }
                                });

                                if (!isRailcardAlreadyExistError && !isRailcardNotFound) {
                                    throw new _AccountRailcard.AccountRailcardSubmissionError('Unexpected Railcard application submission error', { error: error });
                                }
                            });

                        case 4:
                        case 'end':
                            return _context57.stop();
                    }
                }
            }, _callee57, this);
        }));

        function submitRailcardApplication(_x90, _x91) {
            return _ref66.apply(this, arguments);
        }

        return submitRailcardApplication;
    }(),
    deleteAccountRailcard: function () {
        var _ref67 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee58(user, accountRailcard) {
            return _regenerator2.default.wrap(function _callee58$(_context58) {
                while (1) {
                    switch (_context58.prev = _context58.next) {
                        case 0:
                            _context58.next = 2;
                            return _RailcardsService2.default.deleteAccountRailcard(user, accountRailcard).then(function () {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.ACCOUNT_RAILCARD_DELETED,
                                    accountRailcard: accountRailcard
                                });
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                    type: _AppConstants.GlobalModals.INFO,
                                    data: {
                                        message: 'notifications.railcard.deleted'
                                    }
                                });
                            }).catch(function () {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                    type: _AppConstants.GlobalModals.ERROR,
                                    data: {
                                        message: 'error.remove-railcard.message'
                                    }
                                });
                            });

                        case 2:
                        case 'end':
                            return _context58.stop();
                    }
                }
            }, _callee58, this);
        }));

        function deleteAccountRailcard(_x92, _x93) {
            return _ref67.apply(this, arguments);
        }

        return deleteAccountRailcard;
    }(),
    notifyApprovedRailcards: function () {
        var _ref69 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee59(_ref68) {
            var _ref68$filterRailcard = _ref68.filterRailcards,
                filterRailcards = _ref68$filterRailcard === undefined ? [] : _ref68$filterRailcard,
                _ref68$goToRailcardsP = _ref68.goToRailcardsPageOnConfirm,
                goToRailcardsPageOnConfirm = _ref68$goToRailcardsP === undefined ? true : _ref68$goToRailcardsP,
                _ref68$onlyUnseen = _ref68.onlyUnseen,
                onlyUnseen = _ref68$onlyUnseen === undefined ? false : _ref68$onlyUnseen;
            var user, allRailcards, accountRailcards, messageValues, unsyncedKeyGoRailcards, setSeenSyncKeyGoNotification;
            return _regenerator2.default.wrap(function _callee59$(_context59) {
                while (1) {
                    switch (_context59.prev = _context59.next) {
                        case 0:
                            if (!_FeatureFlagStore2.default.get('enableAccountRailcards')) {
                                _context59.next = 9;
                                break;
                            }

                            user = _UserStore2.default.getCurrent();
                            _context59.next = 4;
                            return this.loadAccountRailcards(user);

                        case 4:
                            allRailcards = _context59.sent.toJS();
                            accountRailcards = allRailcards.filter(function (_ref70) {
                                var railcardCode = _ref70.railcardCode,
                                    seenRailcardApproved = _ref70.seenRailcardApproved,
                                    state = _ref70.state;

                                return state === _AppConstants.SmartcardStatus.ACCEPTED && (filterRailcards.length ? filterRailcards.includes(railcardCode) : true) && (onlyUnseen ? seenRailcardApproved === false : true);
                            }).map(function (_ref71) {
                                var id = _ref71.id,
                                    railcardName = _ref71.railcardName;
                                return { id: id, railcardName: railcardName };
                            });


                            if (accountRailcards.length) {
                                messageValues = accountRailcards.length === 1 ? { railcardName: accountRailcards[0].railcardName } : { railcardCount: accountRailcards.length };


                                _ConfirmationModalActions2.default.open(function (router) {
                                    return _RailcardsService2.default.seenApprovedRailcards(user, accountRailcards.map(function (_ref72) {
                                        var id = _ref72.id;
                                        return id;
                                    })).then(function () {
                                        if (goToRailcardsPageOnConfirm) {
                                            router.push(_urls2.default.location(_AppConstants.AccountPages.ACCOUNT_PHOTOCARDS_RAILCARDS));
                                        }
                                    });
                                }, accountRailcards.length === 1 ? 'railcard.newlyApprovedRailcards.modal.message.one' : 'railcard.newlyApprovedRailcards.modal.message.multiple', {
                                    title: 'railcard.newlyApprovedRailcards.modal.title',
                                    confirmButtonText: goToRailcardsPageOnConfirm ? 'railcard.newlyApprovedRailcards.modal.confirmButtonText' : 'button.text.confirm',
                                    messageValues: messageValues,
                                    onCancel: function onCancel() {
                                        return _RailcardsService2.default.seenApprovedRailcards(user, accountRailcards.map(function (_ref73) {
                                            var id = _ref73.id;
                                            return id;
                                        }));
                                    }
                                });
                            }

                            unsyncedKeyGoRailcards = allRailcards.filter(function (_ref74) {
                                var railcardCode = _ref74.railcardCode,
                                    seenSyncKeyGoNotification = _ref74.seenSyncKeyGoNotification,
                                    syncedWithKeygo = _ref74.syncedWithKeygo,
                                    state = _ref74.state;
                                return state === _AppConstants.SmartcardStatus.ACCEPTED && railcardCode === _AppConstants.RAILCARD1617_CODE && !seenSyncKeyGoNotification && !syncedWithKeygo;
                            }).map(function (_ref75) {
                                var id = _ref75.id,
                                    railcardName = _ref75.railcardName;
                                return { id: id, railcardName: railcardName };
                            });


                            if (unsyncedKeyGoRailcards.length) {
                                setSeenSyncKeyGoNotification = function setSeenSyncKeyGoNotification() {
                                    return _RailcardsService2.default.seenSyncKeyGoNotification(user, unsyncedKeyGoRailcards.map(function (_ref76) {
                                        var id = _ref76.id;
                                        return id;
                                    }));
                                };

                                _ConfirmationModalActions2.default.open(function (router) {
                                    return setSeenSyncKeyGoNotification().then(function () {
                                        router.push(_urls2.default.location(_AppConstants.AccountPages.ACCOUNT_PHOTOCARDS_RAILCARDS));
                                    });
                                }, 'railcard.syncKeyGoRailcards.modal.message', {
                                    title: 'railcard.syncKeyGoRailcards.modal.title',
                                    confirmButtonText: 'railcard.syncKeyGoRailcards.modal.confirmButtonText',
                                    messageValues: {},
                                    onCancel: setSeenSyncKeyGoNotification
                                });
                            }

                        case 9:
                        case 'end':
                            return _context59.stop();
                    }
                }
            }, _callee59, this);
        }));

        function notifyApprovedRailcards(_x94) {
            return _ref69.apply(this, arguments);
        }

        return notifyApprovedRailcards;
    }(),
    unsubscribe: function () {
        var _ref77 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee60(id, token, user) {
            return _regenerator2.default.wrap(function _callee60$(_context60) {
                while (1) {
                    switch (_context60.prev = _context60.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                id: id,
                                token: token,
                                actionType: _AppConstants.ActionTypes.UNSUBSCRIBE_STARTED
                            });

                            _context60.prev = 1;
                            _context60.next = 4;
                            return _CustomerService2.default.unsubscribe(id, token);

                        case 4:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.UNSUBSCRIBE_COMPLETE
                            });

                            if (!user.isLoggedIn()) {
                                _context60.next = 10;
                                break;
                            }

                            _context60.next = 8;
                            return _CustomerService2.default.fetch(user.authToken, user);

                        case 8:
                            user = _context60.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: user
                            });

                        case 10:
                            _context60.next = 16;
                            break;

                        case 12:
                            _context60.prev = 12;
                            _context60.t0 = _context60['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                error: _context60.t0,
                                actionType: _AppConstants.ActionTypes.UNSUBSCRIBE_FAILED
                            });
                            throw _context60.t0;

                        case 16:
                        case 'end':
                            return _context60.stop();
                    }
                }
            }, _callee60, this, [[1, 12]]);
        }));

        function unsubscribe(_x95, _x96, _x97) {
            return _ref77.apply(this, arguments);
        }

        return unsubscribe;
    }(),
    activateSmartcard: function () {
        var _ref78 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee61(user) {
            var activationError;
            return _regenerator2.default.wrap(function _callee61$(_context61) {
                while (1) {
                    switch (_context61.prev = _context61.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ACTIVATION_STARTED
                            });

                            _context61.prev = 1;
                            _context61.next = 4;
                            return _CustomerService2.default.activateSmartcard(user);

                        case 4:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ACTIVATED
                            });

                            _context61.next = 12;
                            break;

                        case 7:
                            _context61.prev = 7;
                            _context61.t0 = _context61['catch'](1);
                            activationError = new _Smartcard.SmartcardActivationError('Unexpected activation error', { error: _context61.t0 });


                            _AppDispatcher2.default.dispatch({
                                activationError: activationError,
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ACTIVATION_FAILED
                            });

                            throw activationError;

                        case 12:
                        case 'end':
                            return _context61.stop();
                    }
                }
            }, _callee61, this, [[1, 7]]);
        }));

        function activateSmartcard(_x98) {
            return _ref78.apply(this, arguments);
        }

        return activateSmartcard;
    }(),
    dismissSmartcardCTA: function dismissSmartcardCTA() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SMARTCARD_CTA_DISMISSED
        });
    },
    checkUserCookie: function checkUserCookie() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.CHECK_USER_COOKIE
        });
    },
    transferSeasonTicket: function () {
        var _ref79 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee62(user, transferForm, params) {
            return _regenerator2.default.wrap(function _callee62$(_context62) {
                while (1) {
                    switch (_context62.prev = _context62.next) {
                        case 0:
                            _context62.next = 2;
                            return _CustomerService2.default.transferSeasonTicket(user, transferForm, params);

                        case 2:
                            _context62.next = 4;
                            return this.getSmartcard(user);

                        case 4:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_PAPER_TRANSFER_COMPLETE
                            });

                        case 5:
                        case 'end':
                            return _context62.stop();
                    }
                }
            }, _callee62, this);
        }));

        function transferSeasonTicket(_x99, _x100, _x101) {
            return _ref79.apply(this, arguments);
        }

        return transferSeasonTicket;
    }(),
    getAssociatedSmartcards: function () {
        var _ref80 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee63(user) {
            var includeUserSmartcard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var onlyActiveSmartcards = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var smartcards, smartcard, hasValidSmartcard, smartcardList, _smartcardList;

            return _regenerator2.default.wrap(function _callee63$(_context63) {
                while (1) {
                    switch (_context63.prev = _context63.next) {
                        case 0:
                            _context63.prev = 0;
                            _context63.next = 3;
                            return _SmartcardService2.default.getAssociatedSmartcards(user, onlyActiveSmartcards);

                        case 3:
                            smartcards = _context63.sent;
                            smartcard = _SmartcardStore2.default.getCurrent();
                            hasValidSmartcard = smartcard && (smartcard.isAwaitingProduct() || smartcard.isActiveAndAvailableForMoreProducts());


                            if (includeUserSmartcard && hasValidSmartcard) {
                                smartcardList = new _immutable.List([new _SmartcardAssociationInfo2.default({
                                    associatedSmartcardNumber: smartcard.isrn,
                                    cardHolderDateOfBirth: smartcard.cardHolderDateOfBirth,
                                    expiryDate: smartcard.expiryDate,
                                    customerName: (0, _I18n2.default)('delivery.smartcard-passengers.your-smartcard'),
                                    customerId: user.id,
                                    isAdult: user.isAdult(),
                                    isMain: true // mark as your smartcard
                                })]);

                                smartcards = smartcardList.concat(smartcards);
                            } else if (includeUserSmartcard && !smartcard) {
                                _smartcardList = new _immutable.List([new _SmartcardAssociationInfo2.default({
                                    associatedSmartcardNumber: '',
                                    customerName: (0, _I18n2.default)('delivery.smartcard-passengers.new-smartcard'),
                                    customerId: user.id,
                                    isAdult: user.isAdult(),
                                    isMain: true // mark as your smartcard
                                })]);

                                smartcards = _smartcardList.concat(smartcards);
                            }

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ASSOCIATED_SMARTCARDS_LOADED,
                                smartcards: smartcards
                            });
                            _context63.next = 14;
                            break;

                        case 10:
                            _context63.prev = 10;
                            _context63.t0 = _context63['catch'](0);

                            console.warn(_context63.t0);
                            throw _context63.t0;

                        case 14:
                        case 'end':
                            return _context63.stop();
                    }
                }
            }, _callee63, this, [[0, 10]]);
        }));

        function getAssociatedSmartcards(_x104) {
            return _ref80.apply(this, arguments);
        }

        return getAssociatedSmartcards;
    }(),
    getAssociatedAccounts: function () {
        var _ref81 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee64(user, smartcard) {
            var accounts;
            return _regenerator2.default.wrap(function _callee64$(_context64) {
                while (1) {
                    switch (_context64.prev = _context64.next) {
                        case 0:
                            if (smartcard) {
                                _context64.next = 2;
                                break;
                            }

                            return _context64.abrupt('return');

                        case 2:
                            _context64.prev = 2;
                            _context64.next = 5;
                            return _SmartcardService2.default.getAssociatedAccounts(user);

                        case 5:
                            accounts = _context64.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ASSOCIATED_ACCOUNTS_LOADED,
                                accounts: accounts
                            });
                            _context64.next = 13;
                            break;

                        case 9:
                            _context64.prev = 9;
                            _context64.t0 = _context64['catch'](2);

                            console.warn(_context64.t0);
                            throw _context64.t0;

                        case 13:
                        case 'end':
                            return _context64.stop();
                    }
                }
            }, _callee64, this, [[2, 9]]);
        }));

        function getAssociatedAccounts(_x105, _x106) {
            return _ref81.apply(this, arguments);
        }

        return getAssociatedAccounts;
    }(),
    handleAssociationErrors: function handleAssociationErrors(error, shouldThrow) {
        var errorMessage = isErrorPresent(error) && error.body.errors[0].message.toLowerCase();
        var heading = 'smartcard.associate.error.heading';
        var title = 'smartcard.associate.error.unknown.title';
        var message = 'smartcard.associate.error.unknown.message';

        if (errorMessage) {
            var isSmartcardNotFoundForEmail = errorMessage.includes('not found for email');
            var isSmartcardNotFoundForIsrn = errorMessage.includes('not found for smartcard number');
            var isUsersSmartcard = errorMessage.includes('can\'t link their own');
            var isSmartcardAlreadyAssociated = errorMessage.includes('already linked');
            var isSmartcardInactive = errorMessage.includes('is not active');
            var isAssociationInWrongState = errorMessage.includes('link in state');
            var isUnknownCustomer = errorMessage.includes('unknown customer');
            var isSmartcardEmpty = errorMessage.includes('number is empty');

            if (isSmartcardNotFoundForEmail) {
                title = 'smartcard.associate.error.notFound.title';
                message = 'smartcard.associate.error.notFound.email.message';
            } else if (isSmartcardNotFoundForIsrn) {
                title = 'smartcard.associate.error.notFound.title';
                message = 'smartcard.associate.error.notFound.isrn.message';
            } else if (isUsersSmartcard) {
                title = 'smartcard.associate.error.invalid.title';
                message = 'smartcard.associate.error.own.message';
            } else if (isSmartcardAlreadyAssociated) {
                title = 'smartcard.associate.error.invalid.title';
                message = 'smartcard.associate.error.alreadyRequested.message';
            } else if (isSmartcardInactive) {
                title = 'smartcard.associate.error.invalid.title';
                message = 'smartcard.associate.error.inactive.message';
            } else if (isUnknownCustomer) {
                title = 'smartcard.associate.error.smartcardNotFound.title';
                message = 'smartcard.associate.error.notFound.email.message';
            } else if (isSmartcardEmpty) {
                title = 'smartcard.associate.error.smartcardNotFound.title';
                message = 'smartcard.associate.error.notFound.isrn.message';
            } else if (isAssociationInWrongState) {
                heading = 'smartcard.dissociate.error.heading';
                title = 'smartcard.associate.error.remove-association.title';
                message = errorMessage;
            }
        }

        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.MODAL_OPENED,
            type: _AppConstants.GlobalModals.ERROR,
            data: {
                heading: heading,
                message: message,
                title: title
            }
        });

        if (shouldThrow && !errorMessage) {
            throw error;
        }
    },
    getSmartcardToAssociate: function () {
        var _ref82 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee65(user, query) {
            var smartcardToAssociate;
            return _regenerator2.default.wrap(function _callee65$(_context65) {
                while (1) {
                    switch (_context65.prev = _context65.next) {
                        case 0:
                            smartcardToAssociate = null;
                            _context65.prev = 1;

                            if (!(query && query.includes("@"))) {
                                _context65.next = 8;
                                break;
                            }

                            _context65.next = 5;
                            return _SmartcardService2.default.queryAvailableAssociations(user, {
                                email: decodeURIComponent(query)
                            });

                        case 5:
                            smartcardToAssociate = _context65.sent;
                            _context65.next = 11;
                            break;

                        case 8:
                            _context65.next = 10;
                            return _SmartcardService2.default.queryAvailableAssociations(user, {
                                smartcardNumber: query
                            });

                        case 10:
                            smartcardToAssociate = _context65.sent;

                        case 11:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_TO_ASSOCIATE_LOADED,
                                smartcardToAssociate: smartcardToAssociate
                            });
                            _context65.next = 17;
                            break;

                        case 14:
                            _context65.prev = 14;
                            _context65.t0 = _context65['catch'](1);

                            this.handleAssociationErrors(_context65.t0);

                        case 17:
                            return _context65.abrupt('return', smartcardToAssociate);

                        case 18:
                        case 'end':
                            return _context65.stop();
                    }
                }
            }, _callee65, this, [[1, 14]]);
        }));

        function getSmartcardToAssociate(_x107, _x108) {
            return _ref82.apply(this, arguments);
        }

        return getSmartcardToAssociate;
    }(),
    associateSmartcard: function () {
        var _ref83 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee66(user, query) {
            var smartcardToAssociate;
            return _regenerator2.default.wrap(function _callee66$(_context66) {
                while (1) {
                    switch (_context66.prev = _context66.next) {
                        case 0:
                            _context66.next = 2;
                            return this.getSmartcardToAssociate(user, query);

                        case 2:
                            smartcardToAssociate = _context66.sent;

                            if (!(smartcardToAssociate && smartcardToAssociate.smartcardNumber)) {
                                _context66.next = 14;
                                break;
                            }

                            _context66.prev = 4;
                            _context66.next = 7;
                            return _SmartcardService2.default.associateSmartcard(user, smartcardToAssociate.smartcardNumber);

                        case 7:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ASSOCIATION_COMPLETED
                            });

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                type: _AppConstants.GlobalModals.INFO,
                                data: {
                                    heading: 'smartcard.associate.confirm.heading',
                                    title: 'smartcard.associate.confirm.message'
                                }
                            });
                            _context66.next = 14;
                            break;

                        case 11:
                            _context66.prev = 11;
                            _context66.t0 = _context66['catch'](4);

                            this.handleAssociationErrors(_context66.t0, true);

                        case 14:
                        case 'end':
                            return _context66.stop();
                    }
                }
            }, _callee66, this, [[4, 11]]);
        }));

        function associateSmartcard(_x109, _x110) {
            return _ref83.apply(this, arguments);
        }

        return associateSmartcard;
    }(),
    dissociateSmartcard: function () {
        var _ref84 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee67(user, associatedSmartcard) {
            return _regenerator2.default.wrap(function _callee67$(_context67) {
                while (1) {
                    switch (_context67.prev = _context67.next) {
                        case 0:
                            _context67.prev = 0;
                            _context67.next = 3;
                            return _SmartcardService2.default.dissociateSmartcard(user, associatedSmartcard);

                        case 3:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ASSOCIATION_REMOVED
                            });
                            _context67.next = 9;
                            break;

                        case 6:
                            _context67.prev = 6;
                            _context67.t0 = _context67['catch'](0);

                            this.handleAssociationErrors(_context67.t0, true);

                        case 9:
                        case 'end':
                            return _context67.stop();
                    }
                }
            }, _callee67, this, [[0, 6]]);
        }));

        function dissociateSmartcard(_x111, _x112) {
            return _ref84.apply(this, arguments);
        }

        return dissociateSmartcard;
    }(),
    dissociateAccount: function () {
        var _ref85 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee68(user, associatedSmartcard) {
            return _regenerator2.default.wrap(function _callee68$(_context68) {
                while (1) {
                    switch (_context68.prev = _context68.next) {
                        case 0:
                            _context68.prev = 0;
                            _context68.next = 3;
                            return _SmartcardService2.default.dissociateAccount(user, associatedSmartcard);

                        case 3:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMARTCARD_ASSOCIATION_REMOVED
                            });
                            _context68.next = 9;
                            break;

                        case 6:
                            _context68.prev = 6;
                            _context68.t0 = _context68['catch'](0);

                            this.handleAssociationErrors(_context68.t0, true);

                        case 9:
                        case 'end':
                            return _context68.stop();
                    }
                }
            }, _callee68, this, [[0, 6]]);
        }));

        function dissociateAccount(_x113, _x114) {
            return _ref85.apply(this, arguments);
        }

        return dissociateAccount;
    }(),
    confirmAssociation: function () {
        var _ref86 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee69(customerId, choice, token) {
            return _regenerator2.default.wrap(function _callee69$(_context69) {
                while (1) {
                    switch (_context69.prev = _context69.next) {
                        case 0:
                            _context69.prev = 0;
                            _context69.next = 3;
                            return _SmartcardService2.default.confirmAssociation(customerId, choice, token);

                        case 3:
                            return _context69.abrupt('return', _context69.sent);

                        case 6:
                            _context69.prev = 6;
                            _context69.t0 = _context69['catch'](0);
                            throw _context69.t0;

                        case 9:
                        case 'end':
                            return _context69.stop();
                    }
                }
            }, _callee69, this, [[0, 6]]);
        }));

        function confirmAssociation(_x115, _x116, _x117) {
            return _ref86.apply(this, arguments);
        }

        return confirmAssociation;
    }(),
    deleteCustomer: function () {
        var _ref87 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee70(user, password) {
            var email, id, authToken, updatedUser, errorMessage;
            return _regenerator2.default.wrap(function _callee70$(_context70) {
                while (1) {
                    switch (_context70.prev = _context70.next) {
                        case 0:
                            email = user.email, id = user.id, authToken = user.authToken;
                            _context70.prev = 1;
                            _context70.next = 4;
                            return _CustomerService2.default.auth(email, password);

                        case 4:
                            _context70.next = 6;
                            return _CustomerService2.default.deleteCustomer(id);

                        case 6:
                            _context70.next = 8;
                            return _CustomerService2.default.fetch(authToken, user);

                        case 8:
                            updatedUser = _context70.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: updatedUser
                            });

                            _context70.next = 18;
                            break;

                        case 12:
                            _context70.prev = 12;
                            _context70.t0 = _context70['catch'](1);
                            errorMessage = isErrorPresent(_context70.t0) && _context70.t0.body.errors[0].message.toLowerCase();

                            if (!(errorMessage && errorMessage.includes('customer authentication failed'))) {
                                _context70.next = 17;
                                break;
                            }

                            throw new _Customer.CustomerLoginError();

                        case 17:
                            throw _context70.t0;

                        case 18:
                        case 'end':
                            return _context70.stop();
                    }
                }
            }, _callee70, this, [[1, 12]]);
        }));

        function deleteCustomer(_x118, _x119) {
            return _ref87.apply(this, arguments);
        }

        return deleteCustomer;
    }(),
    cancelDeletionRequest: function () {
        var _ref88 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee71(user, requestId) {
            var id, authToken, updatedUser;
            return _regenerator2.default.wrap(function _callee71$(_context71) {
                while (1) {
                    switch (_context71.prev = _context71.next) {
                        case 0:
                            id = user.id, authToken = user.authToken;
                            _context71.prev = 1;
                            _context71.next = 4;
                            return _CustomerService2.default.cancelDeletionRequest(id, requestId);

                        case 4:
                            _context71.next = 6;
                            return _CustomerService2.default.fetch(authToken, user);

                        case 6:
                            updatedUser = _context71.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_UPDATED,
                                user: updatedUser
                            });

                            _context71.next = 13;
                            break;

                        case 10:
                            _context71.prev = 10;
                            _context71.t0 = _context71['catch'](1);
                            throw _context71.t0;

                        case 13:
                        case 'end':
                            return _context71.stop();
                    }
                }
            }, _callee71, this, [[1, 10]]);
        }));

        function cancelDeletionRequest(_x120, _x121) {
            return _ref88.apply(this, arguments);
        }

        return cancelDeletionRequest;
    }()
}, (_applyDecoratedDescriptor(_obj, 'registerSmartcard', [withSmartcardLoadingActions], (0, _getOwnPropertyDescriptor2.default)(_obj, 'registerSmartcard'), _obj), _applyDecoratedDescriptor(_obj, 'linkSmartcard', [withSmartcardLoadingActions], (0, _getOwnPropertyDescriptor2.default)(_obj, 'linkSmartcard'), _obj)), _obj);

exports.default = CustomerActions;

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var bootstrapUtils_namespaceObject = {};
__webpack_require__.d(bootstrapUtils_namespaceObject, "prefix", function() { return prefix; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "bsClass", function() { return bootstrapUtils_bsClass; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "bsStyles", function() { return bsStyles; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "bsSizes", function() { return bsSizes; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "getClassSet", function() { return getClassSet; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "splitBsProps", function() { return splitBsProps; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "splitBsPropsAndOmit", function() { return splitBsPropsAndOmit; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "addStyle", function() { return addStyle; });
__webpack_require__.d(bootstrapUtils_namespaceObject, "_curry", function() { return _curry; });
var utils_namespaceObject = {};
__webpack_require__.d(utils_namespaceObject, "bootstrapUtils", function() { return bootstrapUtils_namespaceObject; });
__webpack_require__.d(utils_namespaceObject, "createChainedFunction", function() { return utils_createChainedFunction; });
__webpack_require__.d(utils_namespaceObject, "ValidComponentChildren", function() { return ValidComponentChildren; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/assign.js
var object_assign = __webpack_require__(401);
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/extends.js

function _extends() {
  _extends = assign_default.a || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/create.js
var create = __webpack_require__(848);
var create_default = /*#__PURE__*/__webpack_require__.n(create);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/set-prototype-of.js
var set_prototype_of = __webpack_require__(849);
var set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(set_prototype_of);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/setPrototypeOf.js

function _setPrototypeOf(o, p) {
  _setPrototypeOf = set_prototype_of_default.a || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/inheritsLoose.js


function _inheritsLoose(subClass, superClass) {
  subClass.prototype = create_default()(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/react/index.js-exposed
var index_js_exposed = __webpack_require__(0);
var index_js_exposed_default = /*#__PURE__*/__webpack_require__.n(index_js_exposed);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__(842);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutPropertiesLoose.js

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = keys_default()(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(2);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/uncontrollable/index.js
var uncontrollable = __webpack_require__(106);
var uncontrollable_default = /*#__PURE__*/__webpack_require__.n(uncontrollable);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/entries.js
var entries = __webpack_require__(409);
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(72);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/StyleConfig.js
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/bootstrapUtils.js


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.




function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : browser_default()(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}
var bootstrapUtils_bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = prop_types_default.a.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });
  var propType = prop_types_default.a.oneOf(existing); // expose the values on the propType function for documentation

  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = _extends({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = SIZE_MAP[size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });
  var propType = prop_types_default.a.oneOf(values);
  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = _extends({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = SIZE_MAP[props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};

  entries_default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};

  entries_default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */

function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}
var _curry = curry;
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/ValidComponentChildren.js
// TODO: This module should be ElementChildren, and should use named exports.

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */

function map(children, func, context) {
  var index = 0;
  return index_js_exposed_default.a.Children.map(children, function (child) {
    if (!index_js_exposed_default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}
/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */


function forEach(children, func, context) {
  var index = 0;
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (!index_js_exposed_default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}
/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */


function ValidComponentChildren_count(children) {
  var result = 0;
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (!index_js_exposed_default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });
  return result;
}
/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */


function filter(children, func, context) {
  var index = 0;
  var result = [];
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (!index_js_exposed_default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });
  return result;
}

function find(children, func, context) {
  var index = 0;
  var result;
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!index_js_exposed_default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });
  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }

    if (!index_js_exposed_default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });
  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!index_js_exposed_default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });
  return result;
}

function toArray(children) {
  var result = [];
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (!index_js_exposed_default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });
  return result;
}

/* harmony default export */ var ValidComponentChildren = ({
  map: map,
  forEach: forEach,
  count: ValidComponentChildren_count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/utils/createChainableTypeChecker.js
var createChainableTypeChecker = __webpack_require__(324);
var createChainableTypeChecker_default = /*#__PURE__*/__webpack_require__.n(createChainableTypeChecker);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/PropTypes.js



var idPropType = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]);
function generatedId(name) {
  return function (props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
      }
    }

    return error;
  };
}
function requiredRoles() {
  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return createChainableTypeChecker_default()(function (props, propName, component) {
    var missing;
    roles.every(function (role) {
      if (!ValidComponentChildren.some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}
function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return createChainableTypeChecker_default()(function (props, propName, component) {
    var duplicate;
    roles.every(function (role) {
      var childrenWithRole = ValidComponentChildren.filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelGroup.js










var PanelGroup_propTypes = {
  accordion: prop_types_default.a.bool,

  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: prop_types_default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: prop_types_default.a.func,

  /**
   * An HTML role attribute
   */
  role: prop_types_default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: prop_types_default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: generatedId('PanelGroup')
};
var PanelGroup_defaultProps = {
  accordion: false
};
var childContextTypes = {
  $bs_panelGroup: prop_types_default.a.shape({
    getId: prop_types_default.a.func,
    headerRole: prop_types_default.a.string,
    panelRole: prop_types_default.a.string,
    activeKey: prop_types_default.a.any,
    onToggle: prop_types_default.a.func
  })
};

var PanelGroup_PanelGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PanelGroup, _React$Component);

  function PanelGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    };

    return _this;
  }

  var _proto = PanelGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        accordion = _this$props.accordion,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;
    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + "-" + type + "-" + key : null;
      };
    }

    return {
      $bs_panelGroup: _extends({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        accordion = _this$props2.accordion,
        className = _this$props2.className,
        children = _this$props2.children,
        props = _objectWithoutPropertiesLoose(_this$props2, ["accordion", "className", "children"]);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), ValidComponentChildren.map(children, function (child) {
      return Object(index_js_exposed["cloneElement"])(child, {
        bsStyle: child.props.bsStyle || bsProps.bsStyle
      });
    }));
  };

  return PanelGroup;
}(index_js_exposed_default.a.Component);

PanelGroup_PanelGroup.propTypes = PanelGroup_propTypes;
PanelGroup_PanelGroup.defaultProps = PanelGroup_defaultProps;
PanelGroup_PanelGroup.childContextTypes = childContextTypes;
/* harmony default export */ var es_PanelGroup = (uncontrollable_default()(bootstrapUtils_bsClass('panel-group', PanelGroup_PanelGroup), {
  activeKey: 'onSelect'
}));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Accordion.js





var Accordion_Accordion =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Accordion, _React$Component);

  function Accordion() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    return index_js_exposed_default.a.createElement(es_PanelGroup, _extends({}, this.props, {
      accordion: true
    }), this.props.children);
  };

  return Accordion;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_Accordion = (Accordion_Accordion);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/values.js
var object_values = __webpack_require__(125);
var values_default = /*#__PURE__*/__webpack_require__.n(object_values);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/CloseButton.js



var CloseButton_propTypes = {
  label: prop_types_default.a.string.isRequired,
  onClick: prop_types_default.a.func
};
var CloseButton_defaultProps = {
  label: 'Close'
};

var CloseButton_CloseButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CloseButton, _React$Component);

  function CloseButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CloseButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        onClick = _this$props.onClick;
    return index_js_exposed_default.a.createElement("button", {
      type: "button",
      className: "close",
      onClick: onClick
    }, index_js_exposed_default.a.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"), index_js_exposed_default.a.createElement("span", {
      className: "sr-only"
    }, label));
  };

  return CloseButton;
}(index_js_exposed_default.a.Component);

CloseButton_CloseButton.propTypes = CloseButton_propTypes;
CloseButton_CloseButton.defaultProps = CloseButton_defaultProps;
/* harmony default export */ var es_CloseButton = (CloseButton_CloseButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Alert.js










var Alert_propTypes = {
  onDismiss: prop_types_default.a.func,
  closeLabel: prop_types_default.a.string
};
var Alert_defaultProps = {
  closeLabel: 'Close alert'
};

var Alert_Alert =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Alert, _React$Component);

  function Alert() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        onDismiss = _this$props.onDismiss,
        closeLabel = _this$props.closeLabel,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["onDismiss", "closeLabel", "className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'dismissable')] = dismissable, _extends2));

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      role: "alert",
      className: classnames_default()(className, classes)
    }), dismissable && index_js_exposed_default.a.createElement(es_CloseButton, {
      onClick: onDismiss,
      label: closeLabel
    }), children);
  };

  return Alert;
}(index_js_exposed_default.a.Component);

Alert_Alert.propTypes = Alert_propTypes;
Alert_Alert.defaultProps = Alert_defaultProps;
/* harmony default export */ var es_Alert = (bsStyles(values_default()(State), State.INFO, bootstrapUtils_bsClass('alert', Alert_Alert)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Badge.js






 // TODO: `pullRight` doesn't belong here. There's no special handling here.

var Badge_propTypes = {
  pullRight: prop_types_default.a.bool
};
var Badge_defaultProps = {
  pullRight: false
};

var Badge_Badge =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Badge, _React$Component);

  function Badge() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Badge.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    index_js_exposed_default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        pullRight = _this$props.pullRight,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["pullRight", "className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), {
      'pull-right': pullRight,
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return index_js_exposed_default.a.createElement("span", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), children);
  };

  return Badge;
}(index_js_exposed_default.a.Component);

Badge_Badge.propTypes = Badge_propTypes;
Badge_Badge.defaultProps = Badge_defaultProps;
/* harmony default export */ var es_Badge = (bootstrapUtils_bsClass('badge', Badge_Badge));
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/elementType.js
var elementType = __webpack_require__(26);
var elementType_default = /*#__PURE__*/__webpack_require__.n(elementType);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var utils_createChainedFunction = (createChainedFunction);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/SafeAnchor.js








var SafeAnchor_propTypes = {
  href: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  onKeyDown: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  tabIndex: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * this is sort of silly but needed for Button
   */
  componentClass: elementType_default.a
};
var SafeAnchor_defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */


var SafeAnchor_SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        props = _objectWithoutPropertiesLoose(_this$props2, ["componentClass", "disabled", "onKeyDown"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = _extends({
        pointerEvents: 'none'
      }, props.style);
    }

    return index_js_exposed_default.a.createElement(Component, _extends({}, props, {
      onClick: this.handleClick,
      onKeyDown: utils_createChainedFunction(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(index_js_exposed_default.a.Component);

SafeAnchor_SafeAnchor.propTypes = SafeAnchor_propTypes;
SafeAnchor_SafeAnchor.defaultProps = SafeAnchor_defaultProps;
/* harmony default export */ var es_SafeAnchor = (SafeAnchor_SafeAnchor);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/BreadcrumbItem.js







var BreadcrumbItem_propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: prop_types_default.a.bool,

  /**
   * `href` attribute for the inner `a` element
   */
  href: prop_types_default.a.string,

  /**
   * `title` attribute for the inner `a` element
   */
  title: prop_types_default.a.node,

  /**
   * `target` attribute for the inner `a` element
   */
  target: prop_types_default.a.string
};
var BreadcrumbItem_defaultProps = {
  active: false
};

var BreadcrumbItem_BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        href = _this$props.href,
        title = _this$props.title,
        target = _this$props.target,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.


    var linkProps = {
      href: href,
      title: title,
      target: target
    };
    return index_js_exposed_default.a.createElement("li", {
      className: classnames_default()(className, {
        active: active
      })
    }, active ? index_js_exposed_default.a.createElement("span", props) : index_js_exposed_default.a.createElement(es_SafeAnchor, _extends({}, props, linkProps)));
  };

  return BreadcrumbItem;
}(index_js_exposed_default.a.Component);

BreadcrumbItem_BreadcrumbItem.propTypes = BreadcrumbItem_propTypes;
BreadcrumbItem_BreadcrumbItem.defaultProps = BreadcrumbItem_defaultProps;
/* harmony default export */ var es_BreadcrumbItem = (BreadcrumbItem_BreadcrumbItem);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Breadcrumb.js








var Breadcrumb_Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Breadcrumb, _React$Component);

  function Breadcrumb() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Breadcrumb.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("ol", _extends({}, elementProps, {
      role: "navigation",
      "aria-label": "breadcrumbs",
      className: classnames_default()(className, classes)
    }));
  };

  return Breadcrumb;
}(index_js_exposed_default.a.Component);

Breadcrumb_Breadcrumb.Item = es_BreadcrumbItem;
/* harmony default export */ var es_Breadcrumb = (bootstrapUtils_bsClass('breadcrumb', Breadcrumb_Breadcrumb));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Button.js











var Button_propTypes = {
  active: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  block: prop_types_default.a.bool,
  onClick: prop_types_default.a.func,
  componentClass: elementType_default.a,
  href: prop_types_default.a.string,

  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: prop_types_default.a.oneOf(['button', 'reset', 'submit'])
};
var Button_defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button_Button =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.renderAnchor = function renderAnchor(elementProps, className) {
    return index_js_exposed_default.a.createElement(es_SafeAnchor, _extends({}, elementProps, {
      className: classnames_default()(className, elementProps.disabled && 'disabled')
    }));
  };

  _proto.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = _objectWithoutPropertiesLoose(_ref, ["componentClass"]);

    var Component = componentClass || 'button';
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["active", "block", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {
      active: active
    }, _extends2[prefix(bsProps, 'block')] = block, _extends2));

    var fullClassName = classnames_default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(index_js_exposed_default.a.Component);

Button_Button.propTypes = Button_propTypes;
Button_Button.defaultProps = Button_defaultProps;
/* harmony default export */ var es_Button = (bootstrapUtils_bsClass('btn', bsSizes([Size.LARGE, Size.SMALL, Size.XSMALL], bsStyles(values_default()(State).concat([Style.DEFAULT, Style.PRIMARY, Style.LINK]), Style.DEFAULT, Button_Button))));
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/all.js
var lib_all = __webpack_require__(196);
var all_default = /*#__PURE__*/__webpack_require__.n(lib_all);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ButtonGroup.js









var ButtonGroup_propTypes = {
  vertical: prop_types_default.a.bool,
  justified: prop_types_default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: all_default()(prop_types_default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};
var ButtonGroup_defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup_ButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ButtonGroup, _React$Component);

  function ButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        block = _this$props.block,
        justified = _this$props.justified,
        vertical = _this$props.vertical,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["block", "justified", "vertical", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps)] = !vertical, _extends2[prefix(bsProps, 'vertical')] = vertical, _extends2[prefix(bsProps, 'justified')] = justified, _extends2[prefix(es_Button.defaultProps, 'block')] = block, _extends2));

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return ButtonGroup;
}(index_js_exposed_default.a.Component);

ButtonGroup_ButtonGroup.propTypes = ButtonGroup_propTypes;
ButtonGroup_ButtonGroup.defaultProps = ButtonGroup_defaultProps;
/* harmony default export */ var es_ButtonGroup = (bootstrapUtils_bsClass('btn-group', ButtonGroup_ButtonGroup));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ButtonToolbar.js







var ButtonToolbar_ButtonToolbar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonToolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      role: "toolbar",
      className: classnames_default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_ButtonToolbar = (bootstrapUtils_bsClass('btn-toolbar', ButtonToolbar_ButtonToolbar));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/CarouselCaption.js







var CarouselCaption_propTypes = {
  componentClass: elementType_default.a
};
var CarouselCaption_defaultProps = {
  componentClass: 'div'
};

var CarouselCaption_CarouselCaption =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CarouselCaption, _React$Component);

  function CarouselCaption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CarouselCaption.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return CarouselCaption;
}(index_js_exposed_default.a.Component);

CarouselCaption_CarouselCaption.propTypes = CarouselCaption_propTypes;
CarouselCaption_CarouselCaption.defaultProps = CarouselCaption_defaultProps;
/* harmony default export */ var es_CarouselCaption = (bootstrapUtils_bsClass('carousel-caption', CarouselCaption_CarouselCaption));
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(46);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/dom-helpers/transition/index.js
var dom_helpers_transition = __webpack_require__(909);
var transition_default = /*#__PURE__*/__webpack_require__.n(dom_helpers_transition);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/CarouselItem.js









var CarouselItem_propTypes = {
  direction: prop_types_default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: prop_types_default.a.func,
  active: prop_types_default.a.bool,
  animateIn: prop_types_default.a.bool,
  animateOut: prop_types_default.a.bool,
  index: prop_types_default.a.number
};
var CarouselItem_defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem_CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({
        direction: null
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;
    var prevActive = prevProps.active;

    if (!active && prevActive) {
      transition_default.a.end(react_dom_default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  _proto.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        direction = _this$props.direction,
        active = _this$props.active,
        animateIn = _this$props.animateIn,
        animateOut = _this$props.animateOut,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["direction", "active", "animateIn", "animateOut", "className"]);

    delete props.onAnimateOutEnd;
    delete props.index;
    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };

    if (direction && active && animateIn) {
      classes[direction] = true;
    }

    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return index_js_exposed_default.a.createElement("div", _extends({}, props, {
      className: classnames_default()(className, classes)
    }));
  };

  return CarouselItem;
}(index_js_exposed_default.a.Component);

CarouselItem_CarouselItem.propTypes = CarouselItem_propTypes;
CarouselItem_CarouselItem.defaultProps = CarouselItem_defaultProps;
/* harmony default export */ var es_CarouselItem = (CarouselItem_CarouselItem);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Glyphicon.js







var Glyphicon_propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: prop_types_default.a.string.isRequired
};

var Glyphicon_Glyphicon =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Glyphicon, _React$Component);

  function Glyphicon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Glyphicon.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        glyph = _this$props.glyph,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["glyph", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, glyph)] = true, _extends2));

    return index_js_exposed_default.a.createElement("span", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Glyphicon;
}(index_js_exposed_default.a.Component);

Glyphicon_Glyphicon.propTypes = Glyphicon_propTypes;
/* harmony default export */ var es_Glyphicon = (bootstrapUtils_bsClass('glyphicon', Glyphicon_Glyphicon));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Carousel.js












 // TODO: `slide` should be `animate`.
// TODO: Use uncontrollable.

var Carousel_propTypes = {
  slide: prop_types_default.a.bool,
  indicators: prop_types_default.a.bool,

  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: prop_types_default.a.number,
  controls: prop_types_default.a.bool,
  pauseOnHover: prop_types_default.a.bool,
  wrap: prop_types_default.a.bool,

  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: prop_types_default.a.func,
  onSlideEnd: prop_types_default.a.func,
  activeIndex: prop_types_default.a.number,
  defaultActiveIndex: prop_types_default.a.number,
  direction: prop_types_default.a.oneOf(['prev', 'next']),
  prevIcon: prop_types_default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: prop_types_default.a.string,
  nextIcon: prop_types_default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: prop_types_default.a.string
};
var Carousel_defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: index_js_exposed_default.a.createElement(es_Glyphicon, {
    glyph: "chevron-left"
  }),
  prevLabel: 'Previous',
  nextIcon: index_js_exposed_default.a.createElement(es_Glyphicon, {
    glyph: "chevron-right"
  }),
  nextLabel: 'Next'
};

var Carousel_Carousel =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Carousel, _React$Component);

  function Carousel(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handlePrev = _this.handlePrev.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleNext = _this.handleNext.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    var defaultActiveIndex = props.defaultActiveIndex;
    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);
      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  _proto.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  _proto.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  _proto.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  _proto.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  _proto.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = ValidComponentChildren.count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }

      index = 0;
    }

    this.select(index, e, 'next');
  };

  _proto.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }

      index = ValidComponentChildren.count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  }; // This might be a public API.


  _proto.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  }; // This might be a public API.


  _proto.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  _proto.select = function select(index, e, direction) {
    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.

    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);
    var onSelect = this.props.onSelect;

    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = {
            direction: direction
          };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  _proto.waitForNext = function waitForNext() {
    var _this$props = this.props,
        slide = _this$props.slide,
        interval = _this$props.interval,
        activeIndexProp = _this$props.activeIndex;

    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  _proto.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;
    var controlClassName = prefix(bsProps, 'control');
    var count = ValidComponentChildren.count(children);
    return [(wrap || activeIndex !== 0) && index_js_exposed_default.a.createElement(es_SafeAnchor, {
      key: "prev",
      className: classnames_default()(controlClassName, 'left'),
      onClick: this.handlePrev
    }, prevIcon, prevLabel && index_js_exposed_default.a.createElement("span", {
      className: "sr-only"
    }, prevLabel)), (wrap || activeIndex !== count - 1) && index_js_exposed_default.a.createElement(es_SafeAnchor, {
      key: "next",
      className: classnames_default()(controlClassName, 'right'),
      onClick: this.handleNext
    }, nextIcon, nextLabel && index_js_exposed_default.a.createElement("span", {
      className: "sr-only"
    }, nextLabel))];
  };

  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];
    ValidComponentChildren.forEach(children, function (child, index) {
      indicators.push(index_js_exposed_default.a.createElement("li", {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }), // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });
    return index_js_exposed_default.a.createElement("ol", {
      className: prefix(bsProps, 'indicators')
    }, indicators);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props2 = this.props,
        slide = _this$props2.slide,
        indicators = _this$props2.indicators,
        controls = _this$props2.controls,
        wrap = _this$props2.wrap,
        prevIcon = _this$props2.prevIcon,
        prevLabel = _this$props2.prevLabel,
        nextIcon = _this$props2.nextIcon,
        nextLabel = _this$props2.nextLabel,
        className = _this$props2.className,
        children = _this$props2.children,
        props = _objectWithoutPropertiesLoose(_this$props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);

    var _this$state = this.state,
        previousActiveIndex = _this$state.previousActiveIndex,
        direction = _this$state.direction;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = _extends({}, getClassSet(bsProps), {
      slide: slide
    });

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes),
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut
    }), indicators && this.renderIndicators(children, activeIndex, bsProps), index_js_exposed_default.a.createElement("div", {
      className: prefix(bsProps, 'inner')
    }, ValidComponentChildren.map(children, function (child, index) {
      var active = index === activeIndex;
      var previousActive = slide && index === previousActiveIndex;
      return Object(index_js_exposed["cloneElement"])(child, {
        active: active,
        index: index,
        animateOut: previousActive,
        animateIn: active && previousActiveIndex != null && slide,
        direction: direction,
        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
      });
    })), controls && this.renderControls({
      wrap: wrap,
      children: children,
      activeIndex: activeIndex,
      prevIcon: prevIcon,
      prevLabel: prevLabel,
      nextIcon: nextIcon,
      nextLabel: nextLabel,
      bsProps: bsProps
    }));
  };

  return Carousel;
}(index_js_exposed_default.a.Component);

Carousel_Carousel.propTypes = Carousel_propTypes;
Carousel_Carousel.defaultProps = Carousel_defaultProps;
Carousel_Carousel.Caption = es_CarouselCaption;
Carousel_Carousel.Item = es_CarouselItem;
/* harmony default export */ var es_Carousel = (bootstrapUtils_bsClass('carousel', Carousel_Carousel));
// EXTERNAL MODULE: ./node_modules/warning/browser.js
var warning_browser = __webpack_require__(64);
var warning_browser_default = /*#__PURE__*/__webpack_require__.n(warning_browser);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Checkbox.js




/* eslint-disable jsx-a11y/label-has-for */





var Checkbox_propTypes = {
  inline: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  title: prop_types_default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: prop_types_default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: prop_types_default.a.func
};
var Checkbox_defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox_Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = index_js_exposed_default.a.createElement("input", _extends({}, elementProps, {
      ref: inputRef,
      type: "checkbox",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[prefix(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return index_js_exposed_default.a.createElement("label", {
        className: classnames_default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = _extends({}, getClassSet(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return index_js_exposed_default.a.createElement("div", {
      className: classnames_default()(className, classes),
      style: style
    }, index_js_exposed_default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Checkbox;
}(index_js_exposed_default.a.Component);

Checkbox_Checkbox.propTypes = Checkbox_propTypes;
Checkbox_Checkbox.defaultProps = Checkbox_defaultProps;
/* harmony default export */ var es_Checkbox = (bootstrapUtils_bsClass('checkbox', Checkbox_Checkbox));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/capitalize.js
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Clearfix.js










var Clearfix_propTypes = {
  componentClass: elementType_default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: prop_types_default.a.bool,

  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: prop_types_default.a.bool,

  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: prop_types_default.a.bool,

  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: prop_types_default.a.bool
};
var Clearfix_defaultProps = {
  componentClass: 'div'
};

var Clearfix_Clearfix =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Clearfix, _React$Component);

  function Clearfix() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Clearfix.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    DEVICE_SIZES.forEach(function (size) {
      var propName = "visible" + capitalize(size) + "Block";

      if (elementProps[propName]) {
        classes["visible-" + size + "-block"] = true;
      }

      delete elementProps[propName];
    });
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Clearfix;
}(index_js_exposed_default.a.Component);

Clearfix_Clearfix.propTypes = Clearfix_propTypes;
Clearfix_Clearfix.defaultProps = Clearfix_defaultProps;
/* harmony default export */ var es_Clearfix = (bootstrapUtils_bsClass('clearfix', Clearfix_Clearfix));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ControlLabel.js








var ControlLabel_propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: prop_types_default.a.string,
  srOnly: prop_types_default.a.bool
};
var ControlLabel_defaultProps = {
  srOnly: false
};
var contextTypes = {
  $bs_formGroup: prop_types_default.a.object
};

var ControlLabel_ControlLabel =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ControlLabel, _React$Component);

  function ControlLabel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ControlLabel.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        _this$props$htmlFor = _this$props.htmlFor,
        htmlFor = _this$props$htmlFor === void 0 ? controlId : _this$props$htmlFor,
        srOnly = _this$props.srOnly,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["htmlFor", "srOnly", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = _extends({}, getClassSet(bsProps), {
      'sr-only': srOnly
    });

    return index_js_exposed_default.a.createElement("label", _extends({}, elementProps, {
      htmlFor: htmlFor,
      className: classnames_default()(className, classes)
    }));
  };

  return ControlLabel;
}(index_js_exposed_default.a.Component);

ControlLabel_ControlLabel.propTypes = ControlLabel_propTypes;
ControlLabel_ControlLabel.defaultProps = ControlLabel_defaultProps;
ControlLabel_ControlLabel.contextTypes = contextTypes;
/* harmony default export */ var es_ControlLabel = (bootstrapUtils_bsClass('control-label', ControlLabel_ControlLabel));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Col.js









var Col_propTypes = {
  componentClass: elementType_default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: prop_types_default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: prop_types_default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: prop_types_default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: prop_types_default.a.number,

  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: prop_types_default.a.bool,

  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: prop_types_default.a.bool,

  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: prop_types_default.a.bool,

  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: prop_types_default.a.bool,

  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: prop_types_default.a.number,

  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: prop_types_default.a.number,

  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: prop_types_default.a.number,

  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: prop_types_default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: prop_types_default.a.number
};
var Col_defaultProps = {
  componentClass: 'div'
};

var Col_Col =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Col, _React$Component);

  function Col() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Col.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    DEVICE_SIZES.forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = "" + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(prefix(bsProps, "" + size + modifier + "-" + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');
      var hiddenPropName = size + "Hidden";

      if (elementProps[hiddenPropName]) {
        classes.push("hidden-" + size);
      }

      delete elementProps[hiddenPropName];
    });
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Col;
}(index_js_exposed_default.a.Component);

Col_Col.propTypes = Col_propTypes;
Col_Col.defaultProps = Col_defaultProps;
/* harmony default export */ var es_Col = (bootstrapUtils_bsClass('col', Col_Col));
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/parse-int.js
var parse_int = __webpack_require__(910);
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);

// EXTERNAL MODULE: ./node_modules/dom-helpers/style/index.js
var dom_helpers_style = __webpack_require__(263);
var style_default = /*#__PURE__*/__webpack_require__.n(dom_helpers_style);

// EXTERNAL MODULE: ./node_modules/react-transition-group/Transition.js
var react_transition_group_Transition = __webpack_require__(408);
var Transition_default = /*#__PURE__*/__webpack_require__.n(react_transition_group_Transition);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Collapse.js





var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
}; // reading a dimension prop will cause the browser to recalculate,
// which will let our animations work

function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem["offset" + capitalize(dimension)];
  var margins = MARGINS[dimension];
  return value + parse_int_default()(style_default()(elem, margins[0]), 10) + parse_int_default()(style_default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[react_transition_group_Transition["EXITED"]] = 'collapse', _collapseStyles[react_transition_group_Transition["EXITING"]] = 'collapsing', _collapseStyles[react_transition_group_Transition["ENTERING"]] = 'collapsing', _collapseStyles[react_transition_group_Transition["ENTERED"]] = 'collapse in', _collapseStyles);
var Collapse_propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: prop_types_default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: prop_types_default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: prop_types_default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: prop_types_default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: prop_types_default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: prop_types_default.a.oneOfType([prop_types_default.a.oneOf(['height', 'width']), prop_types_default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: prop_types_default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: prop_types_default.a.string
};
var Collapse_defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse_Collapse =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      triggerBrowserReflow(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }; // for testing


  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem["scroll" + capitalize(dimension)] + "px";
  };
  /* -- Expanding -- */


  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);

    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = utils_createChainedFunction(this.handleEnter, onEnter);
    var handleEntering = utils_createChainedFunction(this.handleEntering, onEntering);
    var handleEntered = utils_createChainedFunction(this.handleEntered, onEntered);
    var handleExit = utils_createChainedFunction(this.handleExit, onExit);
    var handleExiting = utils_createChainedFunction(this.handleExiting, onExiting);
    return index_js_exposed_default.a.createElement(Transition_default.a, _extends({}, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return index_js_exposed_default.a.cloneElement(children, _extends({}, innerProps, {
        className: classnames_default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(index_js_exposed_default.a.Component);

Collapse_Collapse.propTypes = Collapse_propTypes;
Collapse_Collapse.defaultProps = Collapse_defaultProps;
/* harmony default export */ var es_Collapse = (Collapse_Collapse);
// EXTERNAL MODULE: ./node_modules/dom-helpers/activeElement.js
var activeElement = __webpack_require__(561);
var activeElement_default = /*#__PURE__*/__webpack_require__.n(activeElement);

// EXTERNAL MODULE: ./node_modules/dom-helpers/query/contains.js
var contains = __webpack_require__(194);
var contains_default = /*#__PURE__*/__webpack_require__.n(contains);

// EXTERNAL MODULE: ./node_modules/keycode/index.js
var keycode = __webpack_require__(267);
var keycode_default = /*#__PURE__*/__webpack_require__.n(keycode);

// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/isRequiredForA11y.js
var isRequiredForA11y = __webpack_require__(197);
var isRequiredForA11y_default = /*#__PURE__*/__webpack_require__.n(isRequiredForA11y);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/from.js
var from = __webpack_require__(912);
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/react-overlays/lib/RootCloseWrapper.js
var RootCloseWrapper = __webpack_require__(586);
var RootCloseWrapper_default = /*#__PURE__*/__webpack_require__.n(RootCloseWrapper);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/DropdownMenu.js














var DropdownMenu_propTypes = {
  open: prop_types_default.a.bool,
  pullRight: prop_types_default.a.bool,
  onClose: prop_types_default.a.func,
  labelledBy: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  onSelect: prop_types_default.a.func,
  rootCloseEvent: prop_types_default.a.oneOf(['click', 'mousedown'])
};
var DropdownMenu_defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu_DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleRootClose = _this.handleRootClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = react_dom_default.a.findDOMNode(this);

    if (!node) {
      return [];
    }

    return from_default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);
    return {
      items: items,
      activeIndex: activeIndex
    };
  };

  _proto.focusNext = function focusNext() {
    var _this$getItemsAndActi = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi.items,
        activeIndex = _this$getItemsAndActi.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  _proto.focusPrevious = function focusPrevious() {
    var _this$getItemsAndActi2 = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi2.items,
        activeIndex = _this$getItemsAndActi2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case keycode_default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;

      case keycode_default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;

      case keycode_default.a.codes.esc:
      case keycode_default.a.codes.tab:
        this.props.onClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, {
      source: 'rootClose'
    });
  };

  _proto.render = function render() {
    var _extends2,
        _this2 = this;

    var _this$props = this.props,
        open = _this$props.open,
        pullRight = _this$props.pullRight,
        labelledBy = _this$props.labelledBy,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'right')] = pullRight, _extends2));

    return index_js_exposed_default.a.createElement(RootCloseWrapper_default.a, {
      disabled: !open,
      onRootClose: this.handleRootClose,
      event: rootCloseEvent
    }, index_js_exposed_default.a.createElement("ul", _extends({}, elementProps, {
      role: "menu",
      className: classnames_default()(className, classes),
      "aria-labelledby": labelledBy
    }), ValidComponentChildren.map(children, function (child) {
      return index_js_exposed_default.a.cloneElement(child, {
        onKeyDown: utils_createChainedFunction(child.props.onKeyDown, _this2.handleKeyDown),
        onSelect: utils_createChainedFunction(child.props.onSelect, onSelect)
      });
    })));
  };

  return DropdownMenu;
}(index_js_exposed_default.a.Component);

DropdownMenu_DropdownMenu.propTypes = DropdownMenu_propTypes;
DropdownMenu_DropdownMenu.defaultProps = DropdownMenu_defaultProps;
/* harmony default export */ var es_DropdownMenu = (bootstrapUtils_bsClass('dropdown-menu', DropdownMenu_DropdownMenu));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/DropdownToggle.js









var DropdownToggle_propTypes = {
  noCaret: prop_types_default.a.bool,
  open: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  useAnchor: prop_types_default.a.bool
};
var DropdownToggle_defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle_DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownToggle, _React$Component);

  function DropdownToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        noCaret = _this$props.noCaret,
        open = _this$props.open,
        useAnchor = _this$props.useAnchor,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);

    delete props.bsRole;
    var Component = useAnchor ? es_SafeAnchor : es_Button;
    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.
    // FIXME: Should this really fall back to `title` as children?

    return index_js_exposed_default.a.createElement(Component, _extends({}, props, {
      role: "button",
      className: classnames_default()(className, bsClass),
      "aria-haspopup": true,
      "aria-expanded": open
    }), children || props.title, useCaret && ' ', useCaret && index_js_exposed_default.a.createElement("span", {
      className: "caret"
    }));
  };

  return DropdownToggle;
}(index_js_exposed_default.a.Component);

DropdownToggle_DropdownToggle.propTypes = DropdownToggle_propTypes;
DropdownToggle_DropdownToggle.defaultProps = DropdownToggle_defaultProps;
/* harmony default export */ var es_DropdownToggle = (bootstrapUtils_bsClass('dropdown-toggle', DropdownToggle_DropdownToggle));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Dropdown.js























var TOGGLE_ROLE = es_DropdownToggle.defaultProps.bsRole;
var MENU_ROLE = es_DropdownMenu.defaultProps.bsRole;
var Dropdown_propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: prop_types_default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),
  componentClass: elementType_default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: all_default()(requiredRoles(TOGGLE_ROLE, MENU_ROLE), exclusiveRoles(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: prop_types_default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: prop_types_default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: prop_types_default.a.bool,
  defaultOpen: prop_types_default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: prop_types_default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: prop_types_default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: prop_types_default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: prop_types_default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: prop_types_default.a.func,

  /**
   * @private
   */
  onMouseLeave: prop_types_default.a.func
};
var Dropdown_defaultProps = {
  componentClass: es_ButtonGroup
};

var Dropdown_Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Dropdown, _React$Component);

  function Dropdown(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = contains_default()(react_dom_default.a.findDOMNode(this.menu), activeElement_default()(document));
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;
    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  _proto.focus = function focus() {
    var toggle = react_dom_default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  _proto.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu || !menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  _proto.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, {
      source: 'click'
    });
  };

  _proto.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case keycode_default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, {
            source: 'keydown'
          });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }

        event.preventDefault();
        break;

      case keycode_default.a.codes.esc:
      case keycode_default.a.codes.tab:
        this.handleClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  _proto.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = _objectWithoutPropertiesLoose(_ref, ["id", "onSelect", "rootCloseEvent"]);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = utils_createChainedFunction(child.ref, ref);
    }

    return Object(index_js_exposed["cloneElement"])(child, _extends({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: prefix(props, 'menu'),
      onClose: utils_createChainedFunction(child.props.onClose, this.handleClose),
      onSelect: utils_createChainedFunction(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, {
          source: 'select'
        });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  _proto.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = utils_createChainedFunction(child.ref, ref);
    }

    return Object(index_js_exposed["cloneElement"])(child, _extends({}, props, {
      ref: ref,
      bsClass: prefix(props, 'toggle'),
      onClick: utils_createChainedFunction(child.props.onClick, this.handleClick),
      onKeyDown: utils_createChainedFunction(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  _proto.render = function render() {
    var _classes,
        _this4 = this;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        id = _this$props.id,
        dropup = _this$props.dropup,
        disabled = _this$props.disabled,
        pullRight = _this$props.pullRight,
        open = _this$props.open,
        onSelect = _this$props.onSelect,
        role = _this$props.role,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);

    delete props.onToggle;
    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    } // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.


    return index_js_exposed_default.a.createElement(Component, _extends({}, props, {
      className: classnames_default()(className, classes)
    }), ValidComponentChildren.map(children, function (child) {
      switch (child.props.bsRole) {
        case TOGGLE_ROLE:
          return _this4.renderToggle(child, {
            id: id,
            disabled: disabled,
            open: open,
            role: role,
            bsClass: bsClass
          });

        case MENU_ROLE:
          return _this4.renderMenu(child, {
            id: id,
            open: open,
            pullRight: pullRight,
            bsClass: bsClass,
            onSelect: onSelect,
            rootCloseEvent: rootCloseEvent
          });

        default:
          return child;
      }
    }));
  };

  return Dropdown;
}(index_js_exposed_default.a.Component);

Dropdown_Dropdown.propTypes = Dropdown_propTypes;
Dropdown_Dropdown.defaultProps = Dropdown_defaultProps;
bootstrapUtils_bsClass('dropdown', Dropdown_Dropdown);
var UncontrolledDropdown = uncontrollable_default()(Dropdown_Dropdown, {
  open: 'onToggle'
});
UncontrolledDropdown.Toggle = es_DropdownToggle;
UncontrolledDropdown.Menu = es_DropdownMenu;
/* harmony default export */ var es_Dropdown = (UncontrolledDropdown);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/splitComponentProps.js

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;
  var parentProps = {};
  var childProps = {};

  entries_default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/DropdownButton.js








var DropdownButton_propTypes = _extends({}, es_Dropdown.propTypes, {
  // Toggle props.
  bsStyle: prop_types_default.a.string,
  bsSize: prop_types_default.a.string,
  title: prop_types_default.a.node.isRequired,
  noCaret: prop_types_default.a.bool,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: prop_types_default.a.node
});

var DropdownButton_DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownButton, _React$Component);

  function DropdownButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["bsSize", "bsStyle", "title", "children"]);

    var _splitComponentProps = splitComponentProps(props, es_Dropdown.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return index_js_exposed_default.a.createElement(es_Dropdown, _extends({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), index_js_exposed_default.a.createElement(es_Dropdown.Toggle, _extends({}, toggleProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), index_js_exposed_default.a.createElement(es_Dropdown.Menu, null, children));
  };

  return DropdownButton;
}(index_js_exposed_default.a.Component);

DropdownButton_DropdownButton.propTypes = DropdownButton_propTypes;
/* harmony default export */ var es_DropdownButton = (DropdownButton_DropdownButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Fade.js




var _fadeStyles;





var Fade_propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: prop_types_default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: prop_types_default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: prop_types_default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: prop_types_default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the has component faded in
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired before the component fades out
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the component has faded out
   */
  onExited: prop_types_default.a.func
};
var Fade_defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[react_transition_group_Transition["ENTERING"]] = 'in', _fadeStyles[react_transition_group_Transition["ENTERED"]] = 'in', _fadeStyles);

var Fade_Fade =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Fade, _React$Component);

  function Fade() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    return index_js_exposed_default.a.createElement(Transition_default.a, props, function (status, innerProps) {
      return index_js_exposed_default.a.cloneElement(children, _extends({}, innerProps, {
        className: classnames_default()('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(index_js_exposed_default.a.Component);

Fade_Fade.propTypes = Fade_propTypes;
Fade_Fade.defaultProps = Fade_defaultProps;
/* harmony default export */ var es_Fade = (Fade_Fade);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Form.js








var Form_propTypes = {
  horizontal: prop_types_default.a.bool,
  inline: prop_types_default.a.bool,
  componentClass: elementType_default.a
};
var Form_defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form_Form =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Form, _React$Component);

  function Form() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        horizontal = _this$props.horizontal,
        inline = _this$props.inline,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["horizontal", "inline", "componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    if (horizontal) {
      classes.push(prefix(bsProps, 'horizontal'));
    }

    if (inline) {
      classes.push(prefix(bsProps, 'inline'));
    }

    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Form;
}(index_js_exposed_default.a.Component);

Form_Form.propTypes = Form_propTypes;
Form_Form.defaultProps = Form_defaultProps;
/* harmony default export */ var es_Form = (bootstrapUtils_bsClass('form', Form_Form));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormControlFeedback.js








var FormControlFeedback_defaultProps = {
  bsRole: 'feedback'
};
var FormControlFeedback_contextTypes = {
  $bs_formGroup: prop_types_default.a.object
};

var FormControlFeedback_FormControlFeedback =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlFeedback.prototype;

  _proto.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';

      case 'warning':
        return 'warning-sign';

      case 'error':
        return 'remove';

      default:
        return null;
    }
  };

  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);

    if (!glyph) {
      return null;
    }

    return index_js_exposed_default.a.createElement(es_Glyphicon, _extends({}, elementProps, {
      glyph: glyph,
      className: classnames_default()(className, classes)
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = index_js_exposed_default.a.Children.only(children);
    return index_js_exposed_default.a.cloneElement(child, _extends({}, elementProps, {
      className: classnames_default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(index_js_exposed_default.a.Component);

FormControlFeedback_FormControlFeedback.defaultProps = FormControlFeedback_defaultProps;
FormControlFeedback_FormControlFeedback.contextTypes = FormControlFeedback_contextTypes;
/* harmony default export */ var es_FormControlFeedback = (bootstrapUtils_bsClass('form-control-feedback', FormControlFeedback_FormControlFeedback));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormControlStatic.js







var FormControlStatic_propTypes = {
  componentClass: elementType_default.a
};
var FormControlStatic_defaultProps = {
  componentClass: 'p'
};

var FormControlStatic_FormControlStatic =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FormControlStatic, _React$Component);

  function FormControlStatic() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlStatic.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return FormControlStatic;
}(index_js_exposed_default.a.Component);

FormControlStatic_FormControlStatic.propTypes = FormControlStatic_propTypes;
FormControlStatic_FormControlStatic.defaultProps = FormControlStatic_defaultProps;
/* harmony default export */ var es_FormControlStatic = (bootstrapUtils_bsClass('form-control-static', FormControlStatic_FormControlStatic));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormControl.js












var FormControl_propTypes = {
  componentClass: elementType_default.a,

  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: prop_types_default.a.string,

  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: prop_types_default.a.string,

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: prop_types_default.a.func
};
var FormControl_defaultProps = {
  componentClass: 'input'
};
var FormControl_contextTypes = {
  $bs_formGroup: prop_types_default.a.object
};

var FormControl_FormControl =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FormControl, _React$Component);

  function FormControl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControl.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        type = _this$props.type,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? controlId : _this$props$id,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        bsSize = _this$props.bsSize,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.

    var classes;

    if (type !== 'file') {
      classes = getClassSet(bsProps);
    } // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm


    if (bsSize) {
      var size = SIZE_MAP[bsSize] || bsSize;
      classes[prefix({
        bsClass: 'input'
      }, size)] = true;
    }

    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: classnames_default()(className, classes)
    }));
  };

  return FormControl;
}(index_js_exposed_default.a.Component);

FormControl_FormControl.propTypes = FormControl_propTypes;
FormControl_FormControl.defaultProps = FormControl_defaultProps;
FormControl_FormControl.contextTypes = FormControl_contextTypes;
FormControl_FormControl.Feedback = es_FormControlFeedback;
FormControl_FormControl.Static = es_FormControlStatic;
/* harmony default export */ var es_FormControl = (bootstrapUtils_bsClass('form-control', bsSizes([Size.SMALL, Size.LARGE], FormControl_FormControl)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/FormGroup.js









var FormGroup_propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: prop_types_default.a.string,
  validationState: prop_types_default.a.oneOf(['success', 'warning', 'error', null])
};
var FormGroup_childContextTypes = {
  $bs_formGroup: prop_types_default.a.object.isRequired
};

var FormGroup_FormGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FormGroup, _React$Component);

  function FormGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        controlId = _this$props.controlId,
        validationState = _this$props.validationState;
    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  _proto.hasFeedback = function hasFeedback(children) {
    var _this = this;

    return ValidComponentChildren.some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        validationState = _this$props2.validationState,
        className = _this$props2.className,
        children = _this$props2.children,
        props = _objectWithoutPropertiesLoose(_this$props2, ["validationState", "className", "children"]);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = _extends({}, getClassSet(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), children);
  };

  return FormGroup;
}(index_js_exposed_default.a.Component);

FormGroup_FormGroup.propTypes = FormGroup_propTypes;
FormGroup_FormGroup.childContextTypes = FormGroup_childContextTypes;
/* harmony default export */ var es_FormGroup = (bootstrapUtils_bsClass('form-group', bsSizes([Size.LARGE, Size.SMALL], FormGroup_FormGroup)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Grid.js








var Grid_propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: prop_types_default.a.bool,

  /**
   * You can use a custom element for this component
   */
  componentClass: elementType_default.a
};
var Grid_defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid_Grid =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Grid, _React$Component);

  function Grid() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        fluid = _this$props.fluid,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["fluid", "componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = prefix(bsProps, fluid && 'fluid');
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Grid;
}(index_js_exposed_default.a.Component);

Grid_Grid.propTypes = Grid_propTypes;
Grid_Grid.defaultProps = Grid_defaultProps;
/* harmony default export */ var es_Grid = (bootstrapUtils_bsClass('container', Grid_Grid));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/HelpBlock.js







var HelpBlock_HelpBlock =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(HelpBlock, _React$Component);

  function HelpBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HelpBlock.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("span", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return HelpBlock;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_HelpBlock = (bootstrapUtils_bsClass('help-block', HelpBlock_HelpBlock));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Image.js







var Image_propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: prop_types_default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: prop_types_default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: prop_types_default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: prop_types_default.a.bool
};
var Image_defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image_Image =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Image, _React$Component);

  function Image() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _classes;

    var _this$props = this.props,
        responsive = _this$props.responsive,
        rounded = _this$props.rounded,
        circle = _this$props.circle,
        thumbnail = _this$props.thumbnail,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["responsive", "rounded", "circle", "thumbnail", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[prefix(bsProps, 'responsive')] = responsive, _classes[prefix(bsProps, 'rounded')] = rounded, _classes[prefix(bsProps, 'circle')] = circle, _classes[prefix(bsProps, 'thumbnail')] = thumbnail, _classes);
    return index_js_exposed_default.a.createElement("img", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Image;
}(index_js_exposed_default.a.Component);

Image_Image.propTypes = Image_propTypes;
Image_Image.defaultProps = Image_defaultProps;
/* harmony default export */ var es_Image = (bootstrapUtils_bsClass('img', Image_Image));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/InputGroupAddon.js







var InputGroupAddon_InputGroupAddon =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupAddon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("span", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_InputGroupAddon = (bootstrapUtils_bsClass('input-group-addon', InputGroupAddon_InputGroupAddon));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/InputGroupButton.js







var InputGroupButton_InputGroupButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InputGroupButton, _React$Component);

  function InputGroupButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("span", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return InputGroupButton;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_InputGroupButton = (bootstrapUtils_bsClass('input-group-btn', InputGroupButton_InputGroupButton));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/InputGroup.js










var InputGroup_InputGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InputGroup, _React$Component);

  function InputGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("span", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return InputGroup;
}(index_js_exposed_default.a.Component);

InputGroup_InputGroup.Addon = es_InputGroupAddon;
InputGroup_InputGroup.Button = es_InputGroupButton;
/* harmony default export */ var es_InputGroup = (bootstrapUtils_bsClass('input-group', bsSizes([Size.LARGE, Size.SMALL], InputGroup_InputGroup)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Jumbotron.js







var Jumbotron_propTypes = {
  componentClass: elementType_default.a
};
var Jumbotron_defaultProps = {
  componentClass: 'div'
};

var Jumbotron_Jumbotron =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Jumbotron, _React$Component);

  function Jumbotron() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Jumbotron.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Jumbotron;
}(index_js_exposed_default.a.Component);

Jumbotron_Jumbotron.propTypes = Jumbotron_propTypes;
Jumbotron_Jumbotron.defaultProps = Jumbotron_defaultProps;
/* harmony default export */ var es_Jumbotron = (bootstrapUtils_bsClass('jumbotron', Jumbotron_Jumbotron));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Label.js









var Label_Label =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Label, _React$Component);

  function Label() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    index_js_exposed_default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), {
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return index_js_exposed_default.a.createElement("span", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), children);
  };

  return Label;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_Label = (bootstrapUtils_bsClass('label', bsStyles(values_default()(State).concat([Style.DEFAULT, Style.PRIMARY]), Style.DEFAULT, Label_Label)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ListGroupItem.js









var ListGroupItem_propTypes = {
  active: prop_types_default.a.any,
  disabled: prop_types_default.a.any,
  header: prop_types_default.a.node,
  listItem: prop_types_default.a.bool,
  onClick: prop_types_default.a.func,
  href: prop_types_default.a.string,
  type: prop_types_default.a.string
};
var ListGroupItem_defaultProps = {
  listItem: false
};

var ListGroupItem_ListGroupItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ListGroupItem, _React$Component);

  function ListGroupItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroupItem.prototype;

  _proto.renderHeader = function renderHeader(header, headingClassName) {
    if (index_js_exposed_default.a.isValidElement(header)) {
      return Object(index_js_exposed["cloneElement"])(header, {
        className: classnames_default()(header.props.className, headingClassName)
      });
    }

    return index_js_exposed_default.a.createElement("h4", {
      className: headingClassName
    }, header);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        className = _this$props.className,
        header = _this$props.header,
        listItem = _this$props.listItem,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["active", "disabled", "className", "header", "listItem", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = classnames_default()(className, classes); // TODO: Deprecate `header` prop.

    if (header) {
      return index_js_exposed_default.a.createElement(Component, elementProps, this.renderHeader(header, prefix(bsProps, 'heading')), index_js_exposed_default.a.createElement("p", {
        className: prefix(bsProps, 'text')
      }, children));
    }

    return index_js_exposed_default.a.createElement(Component, elementProps, children);
  };

  return ListGroupItem;
}(index_js_exposed_default.a.Component);

ListGroupItem_ListGroupItem.propTypes = ListGroupItem_propTypes;
ListGroupItem_ListGroupItem.defaultProps = ListGroupItem_defaultProps;
/* harmony default export */ var es_ListGroupItem = (bootstrapUtils_bsClass('list-group-item', bsStyles(values_default()(State), ListGroupItem_ListGroupItem)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ListGroup.js









var ListGroup_propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: elementType_default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (ValidComponentChildren.some(children, function (child) {
    return child.type !== es_ListGroupItem || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup_ListGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$component = _this$props.componentClass,
        Component = _this$props$component === void 0 ? getDefaultComponent(children) : _this$props$component,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    var useListItem = Component === 'ul' && ValidComponentChildren.every(children, function (child) {
      return child.type === es_ListGroupItem;
    });
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), useListItem ? ValidComponentChildren.map(children, function (child) {
      return Object(index_js_exposed["cloneElement"])(child, {
        listItem: true
      });
    }) : children);
  };

  return ListGroup;
}(index_js_exposed_default.a.Component);

ListGroup_ListGroup.propTypes = ListGroup_propTypes;
/* harmony default export */ var es_ListGroup = (bootstrapUtils_bsClass('list-group', ListGroup_ListGroup));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaBody.js









var MediaBody_propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: prop_types_default.a.oneOf(['top', 'middle', 'bottom']),
  componentClass: elementType_default.a
};
var MediaBody_defaultProps = {
  componentClass: 'div'
};

var MediaBody_MediaBody =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MediaBody, _React$Component);

  function MediaBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        align = _this$props.align,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "align", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[prefix(es_Media.defaultProps, align)] = true;
    }

    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return MediaBody;
}(index_js_exposed_default.a.Component);

MediaBody_MediaBody.propTypes = MediaBody_propTypes;
MediaBody_MediaBody.defaultProps = MediaBody_defaultProps;
/* harmony default export */ var es_MediaBody = (bootstrapUtils_bsClass('media-body', MediaBody_MediaBody));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaHeading.js







var MediaHeading_propTypes = {
  componentClass: elementType_default.a
};
var MediaHeading_defaultProps = {
  componentClass: 'h4'
};

var MediaHeading_MediaHeading =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MediaHeading, _React$Component);

  function MediaHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return MediaHeading;
}(index_js_exposed_default.a.Component);

MediaHeading_MediaHeading.propTypes = MediaHeading_propTypes;
MediaHeading_MediaHeading.defaultProps = MediaHeading_defaultProps;
/* harmony default export */ var es_MediaHeading = (bootstrapUtils_bsClass('media-heading', MediaHeading_MediaHeading));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaLeft.js








var MediaLeft_propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: prop_types_default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft_MediaLeft =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MediaLeft, _React$Component);

  function MediaLeft() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaLeft.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["align", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[prefix(es_Media.defaultProps, align)] = true;
    }

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return MediaLeft;
}(index_js_exposed_default.a.Component);

MediaLeft_MediaLeft.propTypes = MediaLeft_propTypes;
/* harmony default export */ var es_MediaLeft = (bootstrapUtils_bsClass('media-left', MediaLeft_MediaLeft));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaList.js







var MediaList_MediaList =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MediaList, _React$Component);

  function MediaList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("ul", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return MediaList;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_MediaList = (bootstrapUtils_bsClass('media-list', MediaList_MediaList));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaListItem.js







var MediaListItem_MediaListItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MediaListItem, _React$Component);

  function MediaListItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("li", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return MediaListItem;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_MediaListItem = (bootstrapUtils_bsClass('media', MediaListItem_MediaListItem));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MediaRight.js








var MediaRight_propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: prop_types_default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight_MediaRight =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MediaRight, _React$Component);

  function MediaRight() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaRight.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["align", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[prefix(es_Media.defaultProps, align)] = true;
    }

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return MediaRight;
}(index_js_exposed_default.a.Component);

MediaRight_MediaRight.propTypes = MediaRight_propTypes;
/* harmony default export */ var es_MediaRight = (bootstrapUtils_bsClass('media-right', MediaRight_MediaRight));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Media.js













var Media_propTypes = {
  componentClass: elementType_default.a
};
var Media_defaultProps = {
  componentClass: 'div'
};

var Media_Media =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Media, _React$Component);

  function Media() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Media.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Media;
}(index_js_exposed_default.a.Component);

Media_Media.propTypes = Media_propTypes;
Media_Media.defaultProps = Media_defaultProps;
Media_Media.Heading = es_MediaHeading;
Media_Media.Body = es_MediaBody;
Media_Media.Left = es_MediaLeft;
Media_Media.Right = es_MediaRight;
Media_Media.List = es_MediaList;
Media_Media.ListItem = es_MediaListItem;
/* harmony default export */ var es_Media = (bootstrapUtils_bsClass('media', Media_Media));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/MenuItem.js











var MenuItem_propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: prop_types_default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: prop_types_default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: all_default()(prop_types_default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: prop_types_default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: prop_types_default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: prop_types_default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: prop_types_default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: prop_types_default.a.func
};
var MenuItem_defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem_MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MenuItem, _React$Component);

  function MenuItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        href = _this$props.href,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        disabled = _this$props2.disabled,
        divider = _this$props2.divider,
        header = _this$props2.header,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = _objectWithoutPropertiesLoose(_this$props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;
      return index_js_exposed_default.a.createElement("li", _extends({}, elementProps, {
        role: "separator",
        className: classnames_default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return index_js_exposed_default.a.createElement("li", _extends({}, elementProps, {
        role: "heading",
        className: classnames_default()(className, prefix(bsProps, 'header')),
        style: style
      }));
    }

    return index_js_exposed_default.a.createElement("li", {
      role: "presentation",
      className: classnames_default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, index_js_exposed_default.a.createElement(es_SafeAnchor, _extends({}, elementProps, {
      role: "menuitem",
      tabIndex: "-1",
      onClick: utils_createChainedFunction(onClick, this.handleClick)
    })));
  };

  return MenuItem;
}(index_js_exposed_default.a.Component);

MenuItem_MenuItem.propTypes = MenuItem_propTypes;
MenuItem_MenuItem.defaultProps = MenuItem_defaultProps;
/* harmony default export */ var es_MenuItem = (bootstrapUtils_bsClass('dropdown', MenuItem_MenuItem));
// EXTERNAL MODULE: ./node_modules/dom-helpers/events/index.js
var events = __webpack_require__(851);
var events_default = /*#__PURE__*/__webpack_require__.n(events);

// EXTERNAL MODULE: ./node_modules/dom-helpers/ownerDocument.js
var ownerDocument = __webpack_require__(222);
var ownerDocument_default = /*#__PURE__*/__webpack_require__.n(ownerDocument);

// EXTERNAL MODULE: ./node_modules/dom-helpers/util/inDOM.js
var inDOM = __webpack_require__(168);
var inDOM_default = /*#__PURE__*/__webpack_require__.n(inDOM);

// EXTERNAL MODULE: ./node_modules/dom-helpers/util/scrollbarSize.js
var scrollbarSize = __webpack_require__(560);
var scrollbarSize_default = /*#__PURE__*/__webpack_require__.n(scrollbarSize);

// EXTERNAL MODULE: ./node_modules/react-overlays/lib/Modal.js
var lib_Modal = __webpack_require__(852);
var Modal_default = /*#__PURE__*/__webpack_require__.n(lib_Modal);

// EXTERNAL MODULE: ./node_modules/react-overlays/lib/utils/isOverflowing.js
var isOverflowing = __webpack_require__(563);
var isOverflowing_default = /*#__PURE__*/__webpack_require__.n(isOverflowing);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalBody.js







var ModalBody_propTypes = {
  componentClass: elementType_default.a
};
var ModalBody_defaultProps = {
  componentClass: 'div'
};

var ModalBody_ModalBody =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalBody, _React$Component);

  function ModalBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return ModalBody;
}(index_js_exposed_default.a.Component);

ModalBody_ModalBody.propTypes = ModalBody_propTypes;
ModalBody_ModalBody.defaultProps = ModalBody_defaultProps;
/* harmony default export */ var es_ModalBody = (bootstrapUtils_bsClass('modal-body', ModalBody_ModalBody));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalDialog.js








var ModalDialog_propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: prop_types_default.a.string
};

var ModalDialog_ModalDialog =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalDialog, _React$Component);

  function ModalDialog() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalDialog.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        dialogClassName = _this$props.dialogClassName,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["dialogClassName", "className", "style", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = prefix(bsProps);

    var modalStyle = _extends({
      display: 'block'
    }, style);

    var dialogClasses = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[prefix(bsProps, 'dialog')] = true, _extends2));

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      tabIndex: "-1",
      role: "dialog",
      style: modalStyle,
      className: classnames_default()(className, bsClassName)
    }), index_js_exposed_default.a.createElement("div", {
      className: classnames_default()(dialogClassName, dialogClasses)
    }, index_js_exposed_default.a.createElement("div", {
      className: prefix(bsProps, 'content'),
      role: "document"
    }, children)));
  };

  return ModalDialog;
}(index_js_exposed_default.a.Component);

ModalDialog_ModalDialog.propTypes = ModalDialog_propTypes;
/* harmony default export */ var es_ModalDialog = (bootstrapUtils_bsClass('modal', bsSizes([Size.LARGE, Size.SMALL], ModalDialog_ModalDialog)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalFooter.js







var ModalFooter_propTypes = {
  componentClass: elementType_default.a
};
var ModalFooter_defaultProps = {
  componentClass: 'div'
};

var ModalFooter_ModalFooter =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalFooter, _React$Component);

  function ModalFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return ModalFooter;
}(index_js_exposed_default.a.Component);

ModalFooter_ModalFooter.propTypes = ModalFooter_propTypes;
ModalFooter_ModalFooter.defaultProps = ModalFooter_defaultProps;
/* harmony default export */ var es_ModalFooter = (bootstrapUtils_bsClass('modal-footer', ModalFooter_ModalFooter));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalHeader.js








 // TODO: `aria-label` should be `closeLabel`.

var ModalHeader_propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: prop_types_default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: prop_types_default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: prop_types_default.a.func
};
var ModalHeader_defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var ModalHeader_contextTypes = {
  $bs_modal: prop_types_default.a.shape({
    onHide: prop_types_default.a.func
  })
};

var ModalHeader_ModalHeader =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalHeader, _React$Component);

  function ModalHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        closeLabel = _this$props.closeLabel,
        closeButton = _this$props.closeButton,
        onHide = _this$props.onHide,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["closeLabel", "closeButton", "onHide", "className", "children"]);

    var modal = this.context.$bs_modal;

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), closeButton && index_js_exposed_default.a.createElement(es_CloseButton, {
      label: closeLabel,
      onClick: utils_createChainedFunction(modal && modal.onHide, onHide)
    }), children);
  };

  return ModalHeader;
}(index_js_exposed_default.a.Component);

ModalHeader_ModalHeader.propTypes = ModalHeader_propTypes;
ModalHeader_ModalHeader.defaultProps = ModalHeader_defaultProps;
ModalHeader_ModalHeader.contextTypes = ModalHeader_contextTypes;
/* harmony default export */ var es_ModalHeader = (bootstrapUtils_bsClass('modal-header', ModalHeader_ModalHeader));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ModalTitle.js







var ModalTitle_propTypes = {
  componentClass: elementType_default.a
};
var ModalTitle_defaultProps = {
  componentClass: 'h4'
};

var ModalTitle_ModalTitle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalTitle, _React$Component);

  function ModalTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return ModalTitle;
}(index_js_exposed_default.a.Component);

ModalTitle_ModalTitle.propTypes = ModalTitle_propTypes;
ModalTitle_ModalTitle.defaultProps = ModalTitle_defaultProps;
/* harmony default export */ var es_ModalTitle = (bootstrapUtils_bsClass('modal-title', ModalTitle_ModalTitle));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Modal.js


























var Modal_propTypes = _extends({}, Modal_default.a.propTypes, es_ModalDialog.propTypes, {
  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: prop_types_default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: prop_types_default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: prop_types_default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: prop_types_default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: elementType_default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: prop_types_default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: prop_types_default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: prop_types_default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: prop_types_default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: prop_types_default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: prop_types_default.a.func,

  /**
   * @private
   */
  container: Modal_default.a.propTypes.container
});

var Modal_defaultProps = _extends({}, Modal_default.a.defaultProps, {
  animation: true,
  dialogComponentClass: es_ModalDialog
});

var Modal_childContextTypes = {
  $bs_modal: prop_types_default.a.shape({
    onHide: prop_types_default.a.func
  })
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return index_js_exposed_default.a.createElement(es_Fade, _extends({}, props, {
    timeout: Modal_Modal.TRANSITION_DURATION
  }));
}

function BackdropTransition(props) {
  return index_js_exposed_default.a.createElement(es_Fade, _extends({}, props, {
    timeout: Modal_Modal.BACKDROP_TRANSITION_DURATION
  }));
}
/* eslint-enable no-use-before-define */


var Modal_Modal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEntering = _this.handleEntering.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleDialogClick = _this.handleDialogClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setModalRef = _this.setModalRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      style: {}
    };
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  _proto.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  _proto.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  _proto.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    events_default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  _proto.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    events_default.a.off(window, 'resize', this.handleWindowResize);
  };

  _proto.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  _proto.updateStyle = function updateStyle() {
    if (!inDOM_default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();

    var dialogHeight = dialogNode.scrollHeight;
    var document = ownerDocument_default()(dialogNode);
    var bodyIsOverflowing = isOverflowing_default()(react_dom_default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? scrollbarSize_default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? scrollbarSize_default()() : undefined
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        backdrop = _this$props.backdrop,
        backdropClassName = _this$props.backdropClassName,
        animation = _this$props.animation,
        show = _this$props.show,
        Dialog = _this$props.dialogComponentClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        onEntering = _this$props.onEntering,
        onExited = _this$props.onExited,
        props = _objectWithoutPropertiesLoose(_this$props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);

    var _splitComponentProps = splitComponentProps(props, Modal_default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';
    return index_js_exposed_default.a.createElement(Modal_default.a, _extends({}, baseModalProps, {
      ref: this.setModalRef,
      show: show,
      containerClassName: prefix(props, 'open'),
      transition: animation ? DialogTransition : undefined,
      backdrop: backdrop,
      backdropTransition: animation ? BackdropTransition : undefined,
      backdropClassName: classnames_default()(prefix(props, 'backdrop'), backdropClassName, inClassName),
      onEntering: utils_createChainedFunction(onEntering, this.handleEntering),
      onExited: utils_createChainedFunction(onExited, this.handleExited)
    }), index_js_exposed_default.a.createElement(Dialog, _extends({}, dialogProps, {
      style: _extends({}, this.state.style, style),
      className: classnames_default()(className, inClassName),
      onClick: backdrop === true ? this.handleDialogClick : null
    }), children));
  };

  return Modal;
}(index_js_exposed_default.a.Component);

Modal_Modal.propTypes = Modal_propTypes;
Modal_Modal.defaultProps = Modal_defaultProps;
Modal_Modal.childContextTypes = Modal_childContextTypes;
Modal_Modal.Body = es_ModalBody;
Modal_Modal.Header = es_ModalHeader;
Modal_Modal.Title = es_ModalTitle;
Modal_Modal.Footer = es_ModalFooter;
Modal_Modal.Dialog = es_ModalDialog;
Modal_Modal.TRANSITION_DURATION = 300;
Modal_Modal.BACKDROP_TRANSITION_DURATION = 150;
/* harmony default export */ var es_Modal = (bootstrapUtils_bsClass('modal', bsSizes([Size.LARGE, Size.SMALL], Modal_Modal)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Nav.js












 // TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
// TODO: This `bsStyle` is very unlike the others. Should we rename it?
// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var Nav_propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: prop_types_default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: prop_types_default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: prop_types_default.a.bool,
  justified: all_default()(prop_types_default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: prop_types_default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: prop_types_default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: prop_types_default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: prop_types_default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: prop_types_default.a.bool
};
var Nav_defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};
var Nav_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    onSelect: prop_types_default.a.func
  }),
  $bs_tabContainer: prop_types_default.a.shape({
    activeKey: prop_types_default.a.any,
    onSelect: prop_types_default.a.func.isRequired,
    getTabId: prop_types_default.a.func.isRequired,
    getPaneId: prop_types_default.a.func.isRequired
  })
};

var Nav_Nav =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Nav, _React$Component);

  function Nav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Nav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;
    var children = this.props.children;

    var _this$getActiveProps = this.getActiveProps(),
        activeKey = _this$getActiveProps.activeKey,
        activeHref = _this$getActiveProps.activeHref;

    var activeChild = ValidComponentChildren.find(children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    });
    var childrenArray = ValidComponentChildren.toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);
    var childNodes = react_dom_default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  _proto.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
      return tabContainer;
    }

    return this.props;
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    var _this2 = this;

    var children = this.props.children;
    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _this$getActiveProps2 = this.getActiveProps(),
        activeKey = _this$getActiveProps2.activeKey,
        activeHref = _this$getActiveProps2.activeHref;

    var activeChild = ValidComponentChildren.find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    }); // This assumes the active child is not disabled.

    var activeChildIndex = validChildren.indexOf(activeChild);

    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this3 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;

    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = utils_createChainedFunction(function (event) {
        return _this3.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild;

    switch (event.keyCode) {
      case keycode_default.a.codes.left:
      case keycode_default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;

      case keycode_default.a.codes.right:
      case keycode_default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;

      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _extends2,
        _this4 = this;

    var _this$props = this.props,
        stacked = _this$props.stacked,
        justified = _this$props.justified,
        onSelect = _this$props.onSelect,
        propsRole = _this$props.role,
        propsNavbar = _this$props.navbar,
        pullRight = _this$props.pullRight,
        pullLeft = _this$props.pullLeft,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _this$getActiveProps3 = this.getActiveProps(),
        activeKey = _this$getActiveProps3.activeKey,
        activeHref = _this$getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().

    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'stacked')] = stacked, _extends2[prefix(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName;
    var pullRightClassName;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || {
        bsClass: 'navbar'
      };
      classes[prefix(navbarProps, 'nav')] = true;
      pullRightClassName = prefix(navbarProps, 'right');
      pullLeftClassName = prefix(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;
    return index_js_exposed_default.a.createElement("ul", _extends({}, elementProps, {
      role: role,
      className: classnames_default()(className, classes)
    }), ValidComponentChildren.map(children, function (child) {
      var active = _this4.isActive(child, activeKey, activeHref);

      var childOnSelect = utils_createChainedFunction(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
      return Object(index_js_exposed["cloneElement"])(child, _extends({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
        active: active,
        activeKey: activeKey,
        activeHref: activeHref,
        onSelect: childOnSelect
      }));
    }));
  };

  return Nav;
}(index_js_exposed_default.a.Component);

Nav_Nav.propTypes = Nav_propTypes;
Nav_Nav.defaultProps = Nav_defaultProps;
Nav_Nav.contextTypes = Nav_contextTypes;
/* harmony default export */ var es_Nav = (bootstrapUtils_bsClass('nav', bsStyles(['tabs', 'pills'], Nav_Nav)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarBrand.js







var NavbarBrand_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var NavbarBrand_NavbarBrand =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavbarBrand, _React$Component);

  function NavbarBrand() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarBrand.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = prefix(navbarProps, 'brand');

    if (index_js_exposed_default.a.isValidElement(children)) {
      return index_js_exposed_default.a.cloneElement(children, {
        className: classnames_default()(children.props.className, className, bsClassName)
      });
    }

    return index_js_exposed_default.a.createElement("span", _extends({}, props, {
      className: classnames_default()(className, bsClassName)
    }), children);
  };

  return NavbarBrand;
}(index_js_exposed_default.a.Component);

NavbarBrand_NavbarBrand.contextTypes = NavbarBrand_contextTypes;
/* harmony default export */ var es_NavbarBrand = (NavbarBrand_NavbarBrand);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarCollapse.js







var NavbarCollapse_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool
  })
};

var NavbarCollapse_NavbarCollapse =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarCollapse.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = prefix(navbarProps, 'collapse');
    return index_js_exposed_default.a.createElement(es_Collapse, _extends({
      in: navbarProps.expanded
    }, props), index_js_exposed_default.a.createElement("div", {
      className: bsClassName
    }, children));
  };

  return NavbarCollapse;
}(index_js_exposed_default.a.Component);

NavbarCollapse_NavbarCollapse.contextTypes = NavbarCollapse_contextTypes;
/* harmony default export */ var es_NavbarCollapse = (NavbarCollapse_NavbarCollapse);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarHeader.js







var NavbarHeader_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var NavbarHeader_NavbarHeader =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavbarHeader, _React$Component);

  function NavbarHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = prefix(navbarProps, 'header');
    return index_js_exposed_default.a.createElement("div", _extends({}, props, {
      className: classnames_default()(className, bsClassName)
    }));
  };

  return NavbarHeader;
}(index_js_exposed_default.a.Component);

NavbarHeader_NavbarHeader.contextTypes = NavbarHeader_contextTypes;
/* harmony default export */ var es_NavbarHeader = (NavbarHeader_NavbarHeader);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavbarToggle.js








var NavbarToggle_propTypes = {
  onClick: prop_types_default.a.func,

  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: prop_types_default.a.node
};
var NavbarToggle_contextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool,
    onToggle: prop_types_default.a.func.isRequired
  })
};

var NavbarToggle_NavbarToggle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavbarToggle, _React$Component);

  function NavbarToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["onClick", "className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };

    var buttonProps = _extends({
      type: 'button'
    }, props, {
      onClick: utils_createChainedFunction(onClick, navbarProps.onToggle),
      className: classnames_default()(className, prefix(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return index_js_exposed_default.a.createElement("button", buttonProps, children);
    }

    return index_js_exposed_default.a.createElement("button", buttonProps, index_js_exposed_default.a.createElement("span", {
      className: "sr-only"
    }, "Toggle navigation"), index_js_exposed_default.a.createElement("span", {
      className: "icon-bar"
    }), index_js_exposed_default.a.createElement("span", {
      className: "icon-bar"
    }), index_js_exposed_default.a.createElement("span", {
      className: "icon-bar"
    }));
  };

  return NavbarToggle;
}(index_js_exposed_default.a.Component);

NavbarToggle_NavbarToggle.propTypes = NavbarToggle_propTypes;
NavbarToggle_NavbarToggle.contextTypes = NavbarToggle_contextTypes;
/* harmony default export */ var es_NavbarToggle = (NavbarToggle_NavbarToggle);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Navbar.js




// TODO: Remove this pragma once we upgrade eslint-config-airbnb.

/* eslint-disable react/no-multi-comp */













var Navbar_propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: prop_types_default.a.bool,

  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: prop_types_default.a.bool,

  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: prop_types_default.a.bool,

  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: prop_types_default.a.bool,

  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: prop_types_default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: elementType_default.a,

  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: prop_types_default.a.func,

  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: prop_types_default.a.func,

  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: prop_types_default.a.bool,

  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: prop_types_default.a.bool,
  role: prop_types_default.a.string
};
var Navbar_defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};
var Navbar_childContextTypes = {
  $bs_navbar: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool,
    onToggle: prop_types_default.a.func.isRequired,
    onSelect: prop_types_default.a.func
  })
};

var Navbar_Navbar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Navbar, _React$Component);

  function Navbar(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        expanded = _this$props.expanded,
        onSelect = _this$props.onSelect,
        collapseOnSelect = _this$props.collapseOnSelect;
    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: utils_createChainedFunction(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  _proto.handleCollapse = function handleCollapse() {
    var _this$props2 = this.props,
        onToggle = _this$props2.onToggle,
        expanded = _this$props2.expanded;

    if (expanded) {
      onToggle(false);
    }
  };

  _proto.handleToggle = function handleToggle() {
    var _this$props3 = this.props,
        onToggle = _this$props3.onToggle,
        expanded = _this$props3.expanded;
    onToggle(!expanded);
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props4 = this.props,
        Component = _this$props4.componentClass,
        fixedTop = _this$props4.fixedTop,
        fixedBottom = _this$props4.fixedBottom,
        staticTop = _this$props4.staticTop,
        inverse = _this$props4.inverse,
        fluid = _this$props4.fluid,
        className = _this$props4.className,
        children = _this$props4.children,
        props = _objectWithoutPropertiesLoose(_this$props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = Style.INVERSE;
    }

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'fixed-top')] = fixedTop, _extends2[prefix(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[prefix(bsProps, 'static-top')] = staticTop, _extends2));

    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), index_js_exposed_default.a.createElement(es_Grid, {
      fluid: fluid
    }, children));
  };

  return Navbar;
}(index_js_exposed_default.a.Component);

Navbar_Navbar.propTypes = Navbar_propTypes;
Navbar_Navbar.defaultProps = Navbar_defaultProps;
Navbar_Navbar.childContextTypes = Navbar_childContextTypes;
bootstrapUtils_bsClass('navbar', Navbar_Navbar);
var UncontrollableNavbar = uncontrollable_default()(Navbar_Navbar, {
  expanded: 'onToggle'
});

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = _objectWithoutPropertiesLoose(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);

    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === void 0 ? {
      bsClass: 'navbar'
    } : _ref2$$bs_navbar;
    return index_js_exposed_default.a.createElement(Component, _extends({}, props, {
      className: classnames_default()(className, prefix(navbarProps, suffix), pullRight && prefix(navbarProps, 'right'), pullLeft && prefix(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;
  Wrapper.propTypes = {
    componentClass: elementType_default.a,
    pullRight: prop_types_default.a.bool,
    pullLeft: prop_types_default.a.bool
  };
  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };
  Wrapper.contextTypes = {
    $bs_navbar: prop_types_default.a.shape({
      bsClass: prop_types_default.a.string
    })
  };
  return Wrapper;
}

UncontrollableNavbar.Brand = es_NavbarBrand;
UncontrollableNavbar.Header = es_NavbarHeader;
UncontrollableNavbar.Toggle = es_NavbarToggle;
UncontrollableNavbar.Collapse = es_NavbarCollapse;
UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.

/* harmony default export */ var es_Navbar = (bsStyles([Style.DEFAULT, Style.INVERSE], Style.DEFAULT, UncontrollableNavbar));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavDropdown.js










var NavDropdown_propTypes = _extends({}, es_Dropdown.propTypes, {
  // Toggle props.
  title: prop_types_default.a.node.isRequired,
  noCaret: prop_types_default.a.bool,
  active: prop_types_default.a.bool,
  activeKey: prop_types_default.a.any,
  activeHref: prop_types_default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: prop_types_default.a.node
});

var NavDropdown_NavDropdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavDropdown, _React$Component);

  function NavDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropdown.prototype;

  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
    var _this = this;

    var props = _ref.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (ValidComponentChildren.some(props.children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        title = _this$props.title,
        activeKey = _this$props.activeKey,
        activeHref = _this$props.activeHref,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["title", "activeKey", "activeHref", "className", "style", "children"]);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().

    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = splitComponentProps(props, es_Dropdown.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.


    return index_js_exposed_default.a.createElement(es_Dropdown, _extends({}, dropdownProps, {
      componentClass: "li",
      className: classnames_default()(className, {
        active: active
      }),
      style: style
    }), index_js_exposed_default.a.createElement(es_Dropdown.Toggle, _extends({}, toggleProps, {
      useAnchor: true
    }), title), index_js_exposed_default.a.createElement(es_Dropdown.Menu, null, ValidComponentChildren.map(children, function (child) {
      return index_js_exposed_default.a.cloneElement(child, {
        active: _this2.isActive(child, activeKey, activeHref)
      });
    })));
  };

  return NavDropdown;
}(index_js_exposed_default.a.Component);

NavDropdown_NavDropdown.propTypes = NavDropdown_propTypes;
/* harmony default export */ var es_NavDropdown = (NavDropdown_NavDropdown);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/NavItem.js









var NavItem_propTypes = {
  active: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  href: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  onSelect: prop_types_default.a.func,
  eventKey: prop_types_default.a.any
};
var NavItem_defaultProps = {
  active: false,
  disabled: false
};

var NavItem_NavItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavItem, _React$Component);

  function NavItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = NavItem.prototype;

  _proto.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        className = _this$props.className,
        style = _this$props.style,
        props = _objectWithoutPropertiesLoose(_this$props, ["active", "disabled", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.

    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return index_js_exposed_default.a.createElement("li", {
      role: "presentation",
      className: classnames_default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, index_js_exposed_default.a.createElement(es_SafeAnchor, _extends({}, props, {
      disabled: disabled,
      onClick: utils_createChainedFunction(onClick, this.handleClick)
    })));
  };

  return NavItem;
}(index_js_exposed_default.a.Component);

NavItem_NavItem.propTypes = NavItem_propTypes;
NavItem_NavItem.defaultProps = NavItem_defaultProps;
/* harmony default export */ var es_NavItem = (NavItem_NavItem);
// EXTERNAL MODULE: ./node_modules/react-overlays/lib/Overlay.js
var lib_Overlay = __webpack_require__(913);
var Overlay_default = /*#__PURE__*/__webpack_require__.n(lib_Overlay);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Overlay.js










var Overlay_propTypes = _extends({}, Overlay_default.a.propTypes, {
  /**
   * Set the visibility of the Overlay
   */
  show: prop_types_default.a.bool,

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: prop_types_default.a.bool,

  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: prop_types_default.a.func,

  /**
   * Use animation
   */
  animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: prop_types_default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: prop_types_default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var Overlay_defaultProps = {
  animation: es_Fade,
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay_Overlay =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Overlay, _React$Component);

  function Overlay() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overlay.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        animation = _this$props.animation,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["animation", "children"]);

    var transition = animation === true ? es_Fade : animation || null;
    var child;

    if (!transition) {
      child = Object(index_js_exposed["cloneElement"])(children, {
        className: classnames_default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return index_js_exposed_default.a.createElement(Overlay_default.a, _extends({}, props, {
      transition: transition
    }), child);
  };

  return Overlay;
}(index_js_exposed_default.a.Component);

Overlay_Overlay.propTypes = Overlay_propTypes;
Overlay_Overlay.defaultProps = Overlay_defaultProps;
/* harmony default export */ var es_Overlay = (Overlay_Overlay);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
var is_array = __webpack_require__(916);
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/OverlayTrigger.js












/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */

function isOneOf(one, of) {
  if (is_array_default()(of)) {
    return of.indexOf(one) >= 0;
  }

  return one === of;
}

var triggerType = prop_types_default.a.oneOf(['click', 'hover', 'focus']);

var OverlayTrigger_propTypes = _extends({}, es_Overlay.propTypes, {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: prop_types_default.a.oneOfType([triggerType, prop_types_default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: prop_types_default.a.number,

  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: prop_types_default.a.number,

  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: prop_types_default.a.number,
  // FIXME: This should be `defaultShow`.

  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: prop_types_default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: prop_types_default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: prop_types_default.a.func,

  /**
   * @private
   */
  onClick: prop_types_default.a.func,

  /**
   * @private
   */
  onFocus: prop_types_default.a.func,

  /**
   * @private
   */
  onMouseOut: prop_types_default.a.func,

  /**
   * @private
   */
  onMouseOver: prop_types_default.a.func,
  // Overridden props from `<Overlay>`.

  /**
   * @private
   */
  target: prop_types_default.a.oneOf([null]),

  /**
   * @private
   */
  onHide: prop_types_default.a.oneOf([null]),

  /**
   * @private
   */
  show: prop_types_default.a.oneOf([null])
});

var OverlayTrigger_defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger_OverlayTrigger =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleHide = _this.handleHide.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;
    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  var _proto = OverlayTrigger.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    react_dom_default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;
    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  _proto.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;

      _this2.hide();
    }, delay);
  };

  _proto.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;

      _this3.show();
    }, delay);
  };

  _proto.handleHide = function handleHide() {
    this.hide();
  }; // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !contains_default()(target, related)) {
      handler(e);
    }
  };

  _proto.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  _proto.hide = function hide() {
    this.setState({
      show: false
    });
  };

  _proto.makeOverlay = function makeOverlay(overlay, props) {
    return index_js_exposed_default.a.createElement(es_Overlay, _extends({}, props, {
      show: this.state.show,
      onHide: this.handleHide,
      target: this
    }), overlay);
  };

  _proto.show = function show() {
    this.setState({
      show: true
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    react_dom_default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        trigger = _this$props.trigger,
        overlay = _this$props.overlay,
        children = _this$props.children,
        onBlur = _this$props.onBlur,
        onClick = _this$props.onClick,
        onFocus = _this$props.onFocus,
        onMouseOut = _this$props.onMouseOut,
        onMouseOver = _this$props.onMouseOver,
        props = _objectWithoutPropertiesLoose(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;
    var child = index_js_exposed_default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    } // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.


    triggerProps.onClick = utils_createChainedFunction(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = utils_createChainedFunction(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
      triggerProps.onMouseOver = utils_createChainedFunction(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = utils_createChainedFunction(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = utils_createChainedFunction(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = utils_createChainedFunction(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);
    return Object(index_js_exposed["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(index_js_exposed_default.a.Component);

OverlayTrigger_OverlayTrigger.propTypes = OverlayTrigger_propTypes;
OverlayTrigger_OverlayTrigger.defaultProps = OverlayTrigger_defaultProps;
/* harmony default export */ var es_OverlayTrigger = (OverlayTrigger_OverlayTrigger);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PageHeader.js







var PageHeader_PageHeader =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PageHeader, _React$Component);

  function PageHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), index_js_exposed_default.a.createElement("h1", null, children));
  };

  return PageHeader;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_PageHeader = (bootstrapUtils_bsClass('page-header', PageHeader_PageHeader));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PagerItem.js









var PagerItem_propTypes = {
  disabled: prop_types_default.a.bool,
  previous: prop_types_default.a.bool,
  next: prop_types_default.a.bool,
  onClick: prop_types_default.a.func,
  onSelect: prop_types_default.a.func,
  eventKey: prop_types_default.a.any
};
var PagerItem_defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem_PagerItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PagerItem, _React$Component);

  function PagerItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = PagerItem.prototype;

  _proto.handleSelect = function handleSelect(e) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        previous = _this$props2.previous,
        next = _this$props2.next,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = _objectWithoutPropertiesLoose(_this$props2, ["disabled", "previous", "next", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey;
    return index_js_exposed_default.a.createElement("li", {
      className: classnames_default()(className, {
        disabled: disabled,
        previous: previous,
        next: next
      }),
      style: style
    }, index_js_exposed_default.a.createElement(es_SafeAnchor, _extends({}, props, {
      disabled: disabled,
      onClick: utils_createChainedFunction(onClick, this.handleSelect)
    })));
  };

  return PagerItem;
}(index_js_exposed_default.a.Component);

PagerItem_PagerItem.propTypes = PagerItem_propTypes;
PagerItem_PagerItem.defaultProps = PagerItem_defaultProps;
/* harmony default export */ var es_PagerItem = (PagerItem_PagerItem);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/deprecationWarning.js


var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message;

  if (typeof oldname === 'object') {
    message = oldname.message;
  } else {
    message = oldname + " is deprecated. Use " + newname + " instead.";

    if (link) {
      message += "\nYou can read more about it at " + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(DeprecatedComponent, _Component);

      function DeprecatedComponent() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = DeprecatedComponent.prototype;

      _proto.componentWillMount = function componentWillMount() {
        deprecationWarning.apply(void 0, args);

        if (_Component.prototype.componentWillMount) {
          var _Component$prototype$;

          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            methodArgs[_key2] = arguments[_key2];
          }

          (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
        }
      };

      return DeprecatedComponent;
    }(Component)
  );
};

/* harmony default export */ var utils_deprecationWarning = (deprecationWarning);
function _resetWarned() {
  warned = {};
}
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PageItem.js


/* harmony default export */ var PageItem = (utils_deprecationWarning.wrapper(es_PagerItem, '`<PageItem>`', '`<Pager.Item>`'));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Pager.js










var Pager_propTypes = {
  onSelect: prop_types_default.a.func
};

var Pager_Pager =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Pager, _React$Component);

  function Pager() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pager.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["onSelect", "className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("ul", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), ValidComponentChildren.map(children, function (child) {
      return Object(index_js_exposed["cloneElement"])(child, {
        onSelect: utils_createChainedFunction(child.props.onSelect, onSelect)
      });
    }));
  };

  return Pager;
}(index_js_exposed_default.a.Component);

Pager_Pager.propTypes = Pager_propTypes;
Pager_Pager.Item = es_PagerItem;
/* harmony default export */ var es_Pager = (bootstrapUtils_bsClass('pager', Pager_Pager));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PaginationItem.js




/* eslint-disable react/no-multi-comp */




var PaginationItem_propTypes = {
  eventKey: prop_types_default.a.any,
  className: prop_types_default.a.string,
  onSelect: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  active: prop_types_default.a.bool,
  activeLabel: prop_types_default.a.string.isRequired
};
var PaginationItem_defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);

  var Component = active || disabled ? 'span' : es_SafeAnchor;
  return index_js_exposed_default.a.createElement("li", {
    style: style,
    className: classnames_default()(className, {
      active: active,
      disabled: disabled
    })
  }, index_js_exposed_default.a.createElement(Component, _extends({
    disabled: disabled
  }, props), children, active && index_js_exposed_default.a.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
}
PaginationItem.propTypes = PaginationItem_propTypes;
PaginationItem.defaultProps = PaginationItem_defaultProps;

function createButton(name, defaultValue, label) {
  var _class, _temp;

  if (label === void 0) {
    label = name;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          children = _this$props.children,
          className = _this$props.className,
          props = _objectWithoutPropertiesLoose(_this$props, ["disabled", "children", "className"]);

      var Component = disabled ? 'span' : es_SafeAnchor;
      return index_js_exposed_default.a.createElement("li", _extends({
        "aria-label": label,
        className: classnames_default()(className, {
          disabled: disabled
        })
      }, props), index_js_exposed_default.a.createElement(Component, null, children || defaultValue));
    };

    return _class;
  }(index_js_exposed_default.a.Component), _class.displayName = name, _class.propTypes = {
    disabled: prop_types_default.a.bool
  }, _temp;
}

var First = createButton('First', "\xAB");
var Prev = createButton('Prev', "\u2039");
var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
var Next = createButton('Next', "\u203A");
var Last = createButton('Last', "\xBB");
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Pagination.js








var Pagination_Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Pagination, _React$Component);

  function Pagination() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("ul", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), children);
  };

  return Pagination;
}(index_js_exposed_default.a.Component);

bootstrapUtils_bsClass('pagination', Pagination_Pagination);
Pagination_Pagination.First = First;
Pagination_Pagination.Prev = Prev;
Pagination_Pagination.Ellipsis = Ellipsis;
Pagination_Pagination.Item = PaginationItem;
Pagination_Pagination.Next = Next;
Pagination_Pagination.Last = Last;
/* harmony default export */ var es_Pagination = (Pagination_Pagination);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelCollapse.js






var PanelCollapse_propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: prop_types_default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: prop_types_default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: prop_types_default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: prop_types_default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: prop_types_default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: prop_types_default.a.func
};
var PanelCollapse_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    headingId: prop_types_default.a.string,
    bodyId: prop_types_default.a.string,
    bsClass: prop_types_default.a.string,
    expanded: prop_types_default.a.bool
  })
};

var PanelCollapse_PanelCollapse =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PanelCollapse, _React$Component);

  function PanelCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelCollapse.prototype;

  _proto.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = splitBsProps(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return index_js_exposed_default.a.createElement(es_Collapse, _extends({
      in: expanded
    }, props), index_js_exposed_default.a.createElement("div", {
      className: prefix(bsProps, 'collapse')
    }, children));
  };

  return PanelCollapse;
}(index_js_exposed_default.a.Component);

PanelCollapse_PanelCollapse.propTypes = PanelCollapse_propTypes;
PanelCollapse_PanelCollapse.contextTypes = PanelCollapse_contextTypes;
/* harmony default export */ var es_PanelCollapse = (bootstrapUtils_bsClass('panel', PanelCollapse_PanelCollapse));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelBody.js







var PanelBody_propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: prop_types_default.a.bool.isRequired
};
var PanelBody_defaultProps = {
  collapsible: false
};
var PanelBody_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var PanelBody_PanelBody =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PanelBody, _React$Component);

  function PanelBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        collapsible = _this$props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    var body = index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, prefix(bsProps, 'body'))
    }), children);

    if (collapsible) {
      body = index_js_exposed_default.a.createElement(es_PanelCollapse, null, body);
    }

    return body;
  };

  return PanelBody;
}(index_js_exposed_default.a.Component);

PanelBody_PanelBody.propTypes = PanelBody_propTypes;
PanelBody_PanelBody.defaultProps = PanelBody_defaultProps;
PanelBody_PanelBody.contextTypes = PanelBody_contextTypes;
/* harmony default export */ var es_PanelBody = (bootstrapUtils_bsClass('panel', PanelBody_PanelBody));
// EXTERNAL MODULE: ./node_modules/react-prop-types/lib/elementType.js
var lib_elementType = __webpack_require__(268);
var lib_elementType_default = /*#__PURE__*/__webpack_require__.n(lib_elementType);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelHeading.js








var PanelHeading_propTypes = {
  componentClass: lib_elementType_default.a
};
var PanelHeading_defaultProps = {
  componentClass: 'div'
};
var PanelHeading_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    headingId: prop_types_default.a.string,
    bsClass: prop_types_default.a.string
  })
};

var PanelHeading_PanelHeading =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PanelHeading, _React$Component);

  function PanelHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        Component = _this$props.componentClass,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, prefix(bsProps, 'heading'))
    }), children);
  };

  return PanelHeading;
}(index_js_exposed_default.a.Component);

PanelHeading_PanelHeading.propTypes = PanelHeading_propTypes;
PanelHeading_PanelHeading.defaultProps = PanelHeading_defaultProps;
PanelHeading_PanelHeading.contextTypes = PanelHeading_contextTypes;
/* harmony default export */ var es_PanelHeading = (bootstrapUtils_bsClass('panel', PanelHeading_PanelHeading));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelToggle.js









var PanelToggle_propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: prop_types_default.a.func,

  /**
   * You can use a custom element for this component
   */
  componentClass: lib_elementType_default.a
};
var PanelToggle_defaultProps = {
  componentClass: es_SafeAnchor
};
var PanelToggle_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bodyId: prop_types_default.a.string,
    onToggle: prop_types_default.a.func,
    expanded: prop_types_default.a.bool
  })
};

var PanelToggle_PanelToggle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PanelToggle, _React$Component);

  function PanelToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = PanelToggle.prototype;

  _proto.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        componentClass = _this$props.componentClass,
        props = _objectWithoutPropertiesLoose(_this$props, ["onClick", "className", "componentClass"]);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;
    props.onClick = utils_createChainedFunction(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = classnames_default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return index_js_exposed_default.a.createElement(Component, props);
  };

  return PanelToggle;
}(index_js_exposed_default.a.Component);

PanelToggle_PanelToggle.propTypes = PanelToggle_propTypes;
PanelToggle_PanelToggle.defaultProps = PanelToggle_defaultProps;
PanelToggle_PanelToggle.contextTypes = PanelToggle_contextTypes;
/* harmony default export */ var es_PanelToggle = (PanelToggle_PanelToggle);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelTitle.js









var PanelTitle_propTypes = {
  componentClass: lib_elementType_default.a,

  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: prop_types_default.a.bool
};
var PanelTitle_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};
var PanelTitle_defaultProps = {
  componentClass: 'div'
};

var PanelTitle_PanelTitle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PanelTitle, _React$Component);

  function PanelTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        toggle = _this$props.toggle,
        Component = _this$props.componentClass,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "toggle", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = index_js_exposed_default.a.createElement(es_PanelToggle, null, children);
    }

    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, prefix(bsProps, 'title'))
    }), children);
  };

  return PanelTitle;
}(index_js_exposed_default.a.Component);

PanelTitle_PanelTitle.propTypes = PanelTitle_propTypes;
PanelTitle_PanelTitle.defaultProps = PanelTitle_defaultProps;
PanelTitle_PanelTitle.contextTypes = PanelTitle_contextTypes;
/* harmony default export */ var es_PanelTitle = (bootstrapUtils_bsClass('panel', PanelTitle_PanelTitle));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/PanelFooter.js






var PanelFooter_contextTypes = {
  $bs_panel: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string
  })
};

var PanelFooter_PanelFooter =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PanelFooter, _React$Component);

  function PanelFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = splitBsProps(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, prefix(bsProps, 'footer'))
    }), children);
  };

  return PanelFooter;
}(index_js_exposed_default.a.Component);

PanelFooter_PanelFooter.contextTypes = PanelFooter_contextTypes;
/* harmony default export */ var es_PanelFooter = (bootstrapUtils_bsClass('panel', PanelFooter_PanelFooter));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Panel.js

















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + "--" + type : null;
};

var Panel_propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: prop_types_default.a.bool,

  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: prop_types_default.a.func,
  eventKey: prop_types_default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: prop_types_default.a.string
};
var Panel_contextTypes = {
  $bs_panelGroup: prop_types_default.a.shape({
    getId: prop_types_default.a.func,
    activeKey: prop_types_default.a.any,
    onToggle: prop_types_default.a.func
  })
};
var Panel_childContextTypes = {
  $bs_panel: prop_types_default.a.shape({
    headingId: prop_types_default.a.string,
    bodyId: prop_types_default.a.string,
    bsClass: prop_types_default.a.string,
    onToggle: prop_types_default.a.func,
    expanded: prop_types_default.a.bool
  })
};

var Panel_Panel =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Panel, _React$Component);

  function Panel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    };

    return _this;
  }

  var _proto = Panel.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        id = _this$props.id;
    var idKey = eventKey == null ? id : eventKey;
    var ids;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: _extends({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  _proto.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return index_js_exposed_default.a.createElement("div", _extends({}, props, {
      className: classnames_default()(className, getClassSet(bsProps))
    }), children);
  };

  return Panel;
}(index_js_exposed_default.a.Component);

Panel_Panel.propTypes = Panel_propTypes;
Panel_Panel.contextTypes = Panel_contextTypes;
Panel_Panel.childContextTypes = Panel_childContextTypes;
var UncontrolledPanel = uncontrollable_default()(bootstrapUtils_bsClass('panel', bsStyles(values_default()(State).concat([Style.DEFAULT, Style.PRIMARY]), Style.DEFAULT, Panel_Panel)), {
  expanded: 'onToggle'
});

assign_default()(UncontrolledPanel, {
  Heading: es_PanelHeading,
  Title: es_PanelTitle,
  Body: es_PanelBody,
  Footer: es_PanelFooter,
  Toggle: es_PanelToggle,
  Collapse: es_PanelCollapse
});

/* harmony default export */ var es_Panel = (UncontrolledPanel);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Popover.js








var Popover_propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: prop_types_default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "left" position value for the Popover.
   */
  positionLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * Title content
   */
  title: prop_types_default.a.node
};
var Popover_defaultProps = {
  placement: 'right'
};

var Popover_Popover =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Popover, _React$Component);

  function Popover() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popover.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        title = _this$props.title,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = _extends({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      role: "tooltip",
      className: classnames_default()(className, classes),
      style: outerStyle
    }), index_js_exposed_default.a.createElement("div", {
      className: "arrow",
      style: arrowStyle
    }), title && index_js_exposed_default.a.createElement("h3", {
      className: prefix(bsProps, 'title')
    }, title), index_js_exposed_default.a.createElement("div", {
      className: prefix(bsProps, 'content')
    }, children));
  };

  return Popover;
}(index_js_exposed_default.a.Component);

Popover_Popover.propTypes = Popover_propTypes;
Popover_Popover.defaultProps = Popover_defaultProps;
/* harmony default export */ var es_Popover = (bootstrapUtils_bsClass('popover', Popover_Popover));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ProgressBar.js










var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  index_js_exposed_default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */


    var element = index_js_exposed_default.a.createElement(ProgressBar_ProgressBar, null);
    if (child.type === element.type) return;
    var childIdentifier = index_js_exposed_default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });
  return error;
}

var ProgressBar_propTypes = {
  min: prop_types_default.a.number,
  now: prop_types_default.a.number,
  max: prop_types_default.a.number,
  label: prop_types_default.a.node,
  srOnly: prop_types_default.a.bool,
  striped: prop_types_default.a.bool,
  active: prop_types_default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: prop_types_default.a.bool
};
var ProgressBar_defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar_ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ProgressBar, _React$Component);

  function ProgressBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBar.prototype;

  _proto.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = _objectWithoutPropertiesLoose(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {
      active: active
    }, _extends2[prefix(bsProps, 'striped')] = active || striped, _extends2));

    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      role: "progressbar",
      className: classnames_default()(className, classes),
      style: _extends({
        width: getPercentage(now, min, max) + "%"
      }, style),
      "aria-valuenow": now,
      "aria-valuemin": min,
      "aria-valuemax": max
    }), srOnly ? index_js_exposed_default.a.createElement("span", {
      className: "sr-only"
    }, label) : label);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isChild = _this$props.isChild,
        props = _objectWithoutPropertiesLoose(_this$props, ["isChild"]);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = _objectWithoutPropertiesLoose(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);

    return index_js_exposed_default.a.createElement("div", _extends({}, wrapperProps, {
      className: classnames_default()(className, 'progress')
    }), children ? ValidComponentChildren.map(children, function (child) {
      return Object(index_js_exposed["cloneElement"])(child, {
        isChild: true
      });
    }) : this.renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      srOnly: srOnly,
      striped: striped,
      active: active,
      bsClass: bsClass,
      bsStyle: bsStyle
    }));
  };

  return ProgressBar;
}(index_js_exposed_default.a.Component);

ProgressBar_ProgressBar.propTypes = ProgressBar_propTypes;
ProgressBar_ProgressBar.defaultProps = ProgressBar_defaultProps;
/* harmony default export */ var es_ProgressBar = (bootstrapUtils_bsClass('progress-bar', bsStyles(values_default()(State), ProgressBar_ProgressBar)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Radio.js




/* eslint-disable jsx-a11y/label-has-for */





var Radio_propTypes = {
  inline: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  title: prop_types_default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: prop_types_default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: prop_types_default.a.func
};
var Radio_defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio_Radio =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Radio, _React$Component);

  function Radio() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = index_js_exposed_default.a.createElement("input", _extends({}, elementProps, {
      ref: inputRef,
      type: "radio",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[prefix(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return index_js_exposed_default.a.createElement("label", {
        className: classnames_default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = _extends({}, getClassSet(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return index_js_exposed_default.a.createElement("div", {
      className: classnames_default()(className, classes),
      style: style
    }, index_js_exposed_default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Radio;
}(index_js_exposed_default.a.Component);

Radio_Radio.propTypes = Radio_propTypes;
Radio_Radio.defaultProps = Radio_defaultProps;
/* harmony default export */ var es_Radio = (bootstrapUtils_bsClass('radio', Radio_Radio));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ResponsiveEmbed.js







 // TODO: This should probably take a single `aspectRatio` prop.

var ResponsiveEmbed_propTypes = {
  /**
   * This component requires a single child element
   */
  children: prop_types_default.a.element.isRequired,

  /**
   * 16by9 aspect ratio
   */
  a16by9: prop_types_default.a.bool,

  /**
   * 4by3 aspect ratio
   */
  a4by3: prop_types_default.a.bool
};
var ResponsiveEmbed_defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed_ResponsiveEmbed =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ResponsiveEmbed.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        a16by9 = _this$props.a16by9,
        a4by3 = _this$props.a4by3,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["a16by9", "a4by3", "className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, '16by9')] = a16by9, _extends2[prefix(bsProps, '4by3')] = a4by3, _extends2));

    return index_js_exposed_default.a.createElement("div", {
      className: classnames_default()(classes)
    }, Object(index_js_exposed["cloneElement"])(children, _extends({}, elementProps, {
      className: classnames_default()(className, prefix(bsProps, 'item'))
    })));
  };

  return ResponsiveEmbed;
}(index_js_exposed_default.a.Component);

ResponsiveEmbed_ResponsiveEmbed.propTypes = ResponsiveEmbed_propTypes;
ResponsiveEmbed_ResponsiveEmbed.defaultProps = ResponsiveEmbed_defaultProps;
/* harmony default export */ var es_ResponsiveEmbed = (bootstrapUtils_bsClass('embed-responsive', ResponsiveEmbed_ResponsiveEmbed));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Row.js







var Row_propTypes = {
  componentClass: elementType_default.a
};
var Row_defaultProps = {
  componentClass: 'div'
};

var Row_Row =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Row, _React$Component);

  function Row() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["componentClass", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Row;
}(index_js_exposed_default.a.Component);

Row_Row.propTypes = Row_propTypes;
Row_Row.defaultProps = Row_defaultProps;
/* harmony default export */ var es_Row = (bootstrapUtils_bsClass('row', Row_Row));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/SplitToggle.js





var SplitToggle_SplitToggle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SplitToggle, _React$Component);

  function SplitToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitToggle.prototype;

  _proto.render = function render() {
    return index_js_exposed_default.a.createElement(es_DropdownToggle, _extends({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(index_js_exposed_default.a.Component);

SplitToggle_SplitToggle.defaultProps = es_DropdownToggle.defaultProps;
/* harmony default export */ var es_SplitToggle = (SplitToggle_SplitToggle);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/SplitButton.js










var SplitButton_propTypes = _extends({}, es_Dropdown.propTypes, {
  // Toggle props.
  bsStyle: prop_types_default.a.string,
  bsSize: prop_types_default.a.string,
  href: prop_types_default.a.string,
  onClick: prop_types_default.a.func,

  /**
   * The content of the split button.
   */
  title: prop_types_default.a.node.isRequired,

  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: prop_types_default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: prop_types_default.a.node
});

var SplitButton_SplitButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SplitButton, _React$Component);

  function SplitButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        toggleLabel = _this$props.toggleLabel,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);

    var _splitComponentProps = splitComponentProps(props, es_Dropdown.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return index_js_exposed_default.a.createElement(es_Dropdown, _extends({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), index_js_exposed_default.a.createElement(es_Button, _extends({}, buttonProps, {
      disabled: props.disabled,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), index_js_exposed_default.a.createElement(es_SplitToggle, {
      "aria-label": toggleLabel || title,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), index_js_exposed_default.a.createElement(es_Dropdown.Menu, null, children));
  };

  return SplitButton;
}(index_js_exposed_default.a.Component);

SplitButton_SplitButton.propTypes = SplitButton_propTypes;
SplitButton_SplitButton.Toggle = es_SplitToggle;
/* harmony default export */ var es_SplitButton = (SplitButton_SplitButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/TabContainer.js





var TAB = 'tab';
var PANE = 'pane';
var TabContainer_idPropType = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]);
var TabContainer_propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = TabContainer_idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },

  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: prop_types_default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: prop_types_default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: prop_types_default.a.any
};
var TabContainer_childContextTypes = {
  $bs_tabContainer: prop_types_default.a.shape({
    activeKey: prop_types_default.a.any,
    onSelect: prop_types_default.a.func.isRequired,
    getTabId: prop_types_default.a.func.isRequired,
    getPaneId: prop_types_default.a.func.isRequired
  })
};

var TabContainer_TabContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TabContainer, _React$Component);

  function TabContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContainer.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        onSelect = _this$props.onSelect,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;

    var getId = generateChildId || function (key, type) {
      return id ? id + "-" + type + "-" + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children"]);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;
    return index_js_exposed_default.a.cloneElement(index_js_exposed_default.a.Children.only(children), props);
  };

  return TabContainer;
}(index_js_exposed_default.a.Component);

TabContainer_TabContainer.propTypes = TabContainer_propTypes;
TabContainer_TabContainer.childContextTypes = TabContainer_childContextTypes;
/* harmony default export */ var es_TabContainer = (uncontrollable_default()(TabContainer_TabContainer, {
  activeKey: 'onSelect'
}));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/TabContent.js









var TabContent_propTypes = {
  componentClass: elementType_default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: prop_types_default.a.bool
};
var TabContent_defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};
var TabContent_contextTypes = {
  $bs_tabContainer: prop_types_default.a.shape({
    activeKey: prop_types_default.a.any
  })
};
var TabContent_childContextTypes = {
  $bs_tabContent: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),
    activeKey: prop_types_default.a.any,
    mountOnEnter: prop_types_default.a.bool,
    unmountOnExit: prop_types_default.a.bool,
    onPaneEnter: prop_types_default.a.func.isRequired,
    onPaneExited: prop_types_default.a.func.isRequired,
    exiting: prop_types_default.a.bool.isRequired
  })
};

var TabContent_TabContent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TabContent, _React$Component);

  function TabContent(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handlePaneEnter = _this.handlePaneEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handlePaneExited = _this.handlePaneExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.

    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit;
    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();
    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({
        activeKey: null,
        activeChild: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    } // It's possible that this child should be transitioning out.


    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });
    return true;
  };

  _proto.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        className = _this$props2.className,
        props = _objectWithoutPropertiesLoose(_this$props2, ["componentClass", "className"]);

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, prefix(bsProps, 'content'))
    }));
  };

  return TabContent;
}(index_js_exposed_default.a.Component);

TabContent_TabContent.propTypes = TabContent_propTypes;
TabContent_TabContent.defaultProps = TabContent_defaultProps;
TabContent_TabContent.contextTypes = TabContent_contextTypes;
TabContent_TabContent.childContextTypes = TabContent_childContextTypes;
/* harmony default export */ var es_TabContent = (bootstrapUtils_bsClass('tab', TabContent_TabContent));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/TabPane.js












var TabPane_propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: prop_types_default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),

  /** @private * */
  id: prop_types_default.a.string,

  /** @private * */
  'aria-labelledby': prop_types_default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: prop_types_default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: prop_types_default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: prop_types_default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: prop_types_default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: prop_types_default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: prop_types_default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: prop_types_default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: prop_types_default.a.bool
};
var TabPane_contextTypes = {
  $bs_tabContainer: prop_types_default.a.shape({
    getTabId: prop_types_default.a.func,
    getPaneId: prop_types_default.a.func
  }),
  $bs_tabContent: prop_types_default.a.shape({
    bsClass: prop_types_default.a.string,
    animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),
    activeKey: prop_types_default.a.any,
    mountOnEnter: prop_types_default.a.bool,
    unmountOnExit: prop_types_default.a.bool,
    onPaneEnter: prop_types_default.a.func.isRequired,
    onPaneExited: prop_types_default.a.func.isRequired,
    exiting: prop_types_default.a.bool.isRequired
  })
};
/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */

var TabPane_childContextTypes = {
  $bs_tabContainer: prop_types_default.a.oneOf([null])
};

var TabPane_TabPane =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TabPane, _React$Component);

  function TabPane(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEnter = _this.handleEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.in = false;
    return _this;
  }

  var _proto = TabPane.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  _proto.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  _proto.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  _proto.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  _proto.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;
    return this.props.eventKey === activeKey;
  };

  _proto.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        className = _this$props.className,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        onExited = _this$props.onExited,
        propsMountOnEnter = _this$props.mountOnEnter,
        propsUnmountOnExit = _this$props.unmountOnExit,
        props = _objectWithoutPropertiesLoose(_this$props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);

    var _this$context = this.context,
        tabContent = _this$context.$bs_tabContent,
        tabContainer = _this$context.$bs_tabContainer;

    var _splitBsPropsAndOmit = splitBsPropsAndOmit(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();
    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? es_Fade : animation || null;

    if (tabContent) {
      bsProps.bsClass = prefix(tabContent, 'pane');
    }

    var classes = _extends({}, getClassSet(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      role: "tabpanel",
      "aria-hidden": !active,
      className: classnames_default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;
      return index_js_exposed_default.a.createElement(Transition, {
        in: active && !exiting,
        onEnter: utils_createChainedFunction(this.handleEnter, onEnter),
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: utils_createChainedFunction(this.handleExited, onExited),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
      }, pane);
    }

    return pane;
  };

  return TabPane;
}(index_js_exposed_default.a.Component);

TabPane_TabPane.propTypes = TabPane_propTypes;
TabPane_TabPane.contextTypes = TabPane_contextTypes;
TabPane_TabPane.childContextTypes = TabPane_childContextTypes;
/* harmony default export */ var es_TabPane = (bootstrapUtils_bsClass('tab-pane', TabPane_TabPane));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Tab.js








var Tab_propTypes = _extends({}, es_TabPane.propTypes, {
  disabled: prop_types_default.a.bool,
  title: prop_types_default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: prop_types_default.a.string
});

var Tab_Tab =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var props = _extends({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.


    delete props.title;
    delete props.disabled;
    delete props.tabClassName;
    return index_js_exposed_default.a.createElement(es_TabPane, props);
  };

  return Tab;
}(index_js_exposed_default.a.Component);

Tab_Tab.propTypes = Tab_propTypes;
Tab_Tab.Container = es_TabContainer;
Tab_Tab.Content = es_TabContent;
Tab_Tab.Pane = es_TabPane;
/* harmony default export */ var es_Tab = (Tab_Tab);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Table.js







var Table_propTypes = {
  striped: prop_types_default.a.bool,
  bordered: prop_types_default.a.bool,
  condensed: prop_types_default.a.bool,
  hover: prop_types_default.a.bool,
  responsive: prop_types_default.a.bool
};
var Table_defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table_Table =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Table, _React$Component);

  function Table() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        striped = _this$props.striped,
        bordered = _this$props.bordered,
        condensed = _this$props.condensed,
        hover = _this$props.hover,
        responsive = _this$props.responsive,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[prefix(bsProps, 'striped')] = striped, _extends2[prefix(bsProps, 'bordered')] = bordered, _extends2[prefix(bsProps, 'condensed')] = condensed, _extends2[prefix(bsProps, 'hover')] = hover, _extends2));

    var table = index_js_exposed_default.a.createElement("table", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));

    if (responsive) {
      return index_js_exposed_default.a.createElement("div", {
        className: prefix(bsProps, 'responsive')
      }, table);
    }

    return table;
  };

  return Table;
}(index_js_exposed_default.a.Component);

Table_Table.propTypes = Table_propTypes;
Table_Table.defaultProps = Table_defaultProps;
/* harmony default export */ var es_Table = (bootstrapUtils_bsClass('table', Table_Table));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Tabs.js














var Tabs_TabContainer = es_TabContainer.ControlledComponent;
var Tabs_propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: prop_types_default.a.any,

  /**
   * Navigation style
   */
  bsStyle: prop_types_default.a.oneOf(['tabs', 'pills']),

  /**
   * Sets a default animation strategy. Use `false` to disable, `true`
   * to enable the default `<Fade>` animation, or a react-transition-group
   * v2 `<Transition/>` component.
   */
  animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, elementType_default.a]),
  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: prop_types_default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: prop_types_default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: prop_types_default.a.bool
};
var Tabs_defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  ValidComponentChildren.forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

var Tabs_Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Tabs, _React$Component);

  function Tabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tabs.prototype;

  _proto.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return index_js_exposed_default.a.createElement(es_NavItem, {
      eventKey: eventKey,
      disabled: disabled,
      className: tabClassName
    }, title);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        onSelect = _this$props.onSelect,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        _this$props$activeKey = _this$props.activeKey,
        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
        props = _objectWithoutPropertiesLoose(_this$props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);

    return index_js_exposed_default.a.createElement(Tabs_TabContainer, {
      id: id,
      activeKey: activeKey,
      onSelect: onSelect,
      className: className,
      style: style
    }, index_js_exposed_default.a.createElement("div", null, index_js_exposed_default.a.createElement(es_Nav, _extends({}, props, {
      role: "tablist"
    }), ValidComponentChildren.map(children, this.renderTab)), index_js_exposed_default.a.createElement(es_TabContent, {
      bsClass: bsClass,
      animation: animation,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, children)));
  };

  return Tabs;
}(index_js_exposed_default.a.Component);

Tabs_Tabs.propTypes = Tabs_propTypes;
Tabs_Tabs.defaultProps = Tabs_defaultProps;
bootstrapUtils_bsClass('tab', Tabs_Tabs);
/* harmony default export */ var es_Tabs = (uncontrollable_default()(Tabs_Tabs, {
  activeKey: 'onSelect'
}));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Thumbnail.js




/* eslint-disable jsx-a11y/alt-text */





var Thumbnail_propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: prop_types_default.a.string,

  /**
   * alt property that is passed down to the image inside this component
   */
  alt: prop_types_default.a.string,

  /**
   * href property that is passed down to the image inside this component
   */
  href: prop_types_default.a.string,

  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: prop_types_default.a.func,

  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: prop_types_default.a.func
};

var Thumbnail_Thumbnail =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Thumbnail, _React$Component);

  function Thumbnail() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Thumbnail.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        src = _this$props.src,
        alt = _this$props.alt,
        onError = _this$props.onError,
        onLoad = _this$props.onLoad,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["src", "alt", "onError", "onLoad", "className", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? es_SafeAnchor : 'div';
    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement(Component, _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }), index_js_exposed_default.a.createElement("img", {
      src: src,
      alt: alt,
      onError: onError,
      onLoad: onLoad
    }), children && index_js_exposed_default.a.createElement("div", {
      className: "caption"
    }, children));
  };

  return Thumbnail;
}(index_js_exposed_default.a.Component);

Thumbnail_Thumbnail.propTypes = Thumbnail_propTypes;
/* harmony default export */ var es_Thumbnail = (bootstrapUtils_bsClass('thumbnail', Thumbnail_Thumbnail));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ToggleButton.js






var ToggleButton_propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: prop_types_default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: prop_types_default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: prop_types_default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: prop_types_default.a.bool,

  /**
   * [onChange description]
   */
  onChange: prop_types_default.a.func,

  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: prop_types_default.a.any.isRequired
};

var ToggleButton_ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ToggleButton, _React$Component);

  function ToggleButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        checked = _this$props.checked,
        type = _this$props.type,
        onChange = _this$props.onChange,
        value = _this$props.value,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "name", "checked", "type", "onChange", "value"]);

    var disabled = props.disabled;
    return index_js_exposed_default.a.createElement(es_Button, _extends({}, props, {
      active: !!checked,
      componentClass: "label"
    }), index_js_exposed_default.a.createElement("input", {
      name: name,
      type: type,
      autoComplete: "off",
      value: value,
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange
    }), children);
  };

  return ToggleButton;
}(index_js_exposed_default.a.Component);

ToggleButton_ToggleButton.propTypes = ToggleButton_propTypes;
/* harmony default export */ var es_ToggleButton = (ToggleButton_ToggleButton);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/ToggleButtonGroup.js











var ToggleButtonGroup_propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: prop_types_default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: prop_types_default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: prop_types_default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: prop_types_default.a.oneOf(['checkbox', 'radio']).isRequired
};
var ToggleButtonGroup_defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup_ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getValues = function getValues() {
    var value = this.props.value;
    return value == null ? [] : [].concat(value);
  };

  _proto.handleToggle = function handleToggle(value) {
    var _this$props = this.props,
        type = _this$props.type,
        onChange = _this$props.onChange;
    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }

      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange(values.concat([value]));
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        type = _this$props2.type,
        name = _this$props2.name,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "type", "name"]);

    var values = this.getValues();
    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : browser_default()(false) : void 0;
    delete props.onChange;
    delete props.value; // the data attribute is required b/c twbs css uses it in the selector

    return index_js_exposed_default.a.createElement(es_ButtonGroup, _extends({}, props, {
      "data-toggle": "buttons"
    }), ValidComponentChildren.map(children, function (child) {
      var _child$props = child.props,
          value = _child$props.value,
          onChange = _child$props.onChange;

      var handler = function handler() {
        return _this.handleToggle(value);
      };

      return index_js_exposed_default.a.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(value) !== -1,
        onChange: utils_createChainedFunction(onChange, handler)
      });
    }));
  };

  return ToggleButtonGroup;
}(index_js_exposed_default.a.Component);

ToggleButtonGroup_ToggleButtonGroup.propTypes = ToggleButtonGroup_propTypes;
ToggleButtonGroup_ToggleButtonGroup.defaultProps = ToggleButtonGroup_defaultProps;
var UncontrolledToggleButtonGroup = uncontrollable_default()(ToggleButtonGroup_ToggleButtonGroup, {
  value: 'onChange'
});
UncontrolledToggleButtonGroup.Button = es_ToggleButton;
/* harmony default export */ var es_ToggleButtonGroup = (UncontrolledToggleButtonGroup);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Tooltip.js








var Tooltip_propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: isRequiredForA11y_default()(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: prop_types_default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),

  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string])
};
var Tooltip_defaultProps = {
  placement: 'right'
};

var Tooltip_Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Tooltip, _React$Component);

  function Tooltip() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tooltip.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = _extends({}, getClassSet(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = _extends({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      role: "tooltip",
      className: classnames_default()(className, classes),
      style: outerStyle
    }), index_js_exposed_default.a.createElement("div", {
      className: prefix(bsProps, 'arrow'),
      style: arrowStyle
    }), index_js_exposed_default.a.createElement("div", {
      className: prefix(bsProps, 'inner')
    }, children));
  };

  return Tooltip;
}(index_js_exposed_default.a.Component);

Tooltip_Tooltip.propTypes = Tooltip_propTypes;
Tooltip_Tooltip.defaultProps = Tooltip_defaultProps;
/* harmony default export */ var es_Tooltip = (bootstrapUtils_bsClass('tooltip', Tooltip_Tooltip));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/Well.js








var Well_Well =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Well, _React$Component);

  function Well() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Well.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["className"]);

    var _splitBsProps = splitBsProps(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = getClassSet(bsProps);
    return index_js_exposed_default.a.createElement("div", _extends({}, elementProps, {
      className: classnames_default()(className, classes)
    }));
  };

  return Well;
}(index_js_exposed_default.a.Component);

/* harmony default export */ var es_Well = (bootstrapUtils_bsClass('well', bsSizes([Size.LARGE, Size.SMALL], Well_Well)));
// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/utils/index.js






// CONCATENATED MODULE: ./node_modules/react-bootstrap/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Accordion", function() { return es_Accordion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Alert", function() { return es_Alert; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Badge", function() { return es_Badge; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return es_Breadcrumb; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return es_BreadcrumbItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Button", function() { return es_Button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return es_ButtonGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return es_ButtonToolbar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Carousel", function() { return es_Carousel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return es_CarouselItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Checkbox", function() { return es_Checkbox; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Clearfix", function() { return es_Clearfix; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CloseButton", function() { return es_CloseButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ControlLabel", function() { return es_ControlLabel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Col", function() { return es_Col; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Collapse", function() { return es_Collapse; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Dropdown", function() { return es_Dropdown; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return es_DropdownButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Fade", function() { return es_Fade; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Form", function() { return es_Form; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormControl", function() { return es_FormControl; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormGroup", function() { return es_FormGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Glyphicon", function() { return es_Glyphicon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Grid", function() { return es_Grid; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HelpBlock", function() { return es_HelpBlock; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Image", function() { return es_Image; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InputGroup", function() { return es_InputGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return es_Jumbotron; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Label", function() { return es_Label; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListGroup", function() { return es_ListGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return es_ListGroupItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Media", function() { return es_Media; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuItem", function() { return es_MenuItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Modal", function() { return es_Modal; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalBody", function() { return es_ModalBody; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalDialog", function() { return es_ModalDialog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return es_ModalFooter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return es_ModalHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalTitle", function() { return es_ModalTitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Nav", function() { return es_Nav; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Navbar", function() { return es_Navbar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return es_NavbarBrand; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return es_NavDropdown; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavItem", function() { return es_NavItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Overlay", function() { return es_Overlay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "OverlayTrigger", function() { return es_OverlayTrigger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PageHeader", function() { return es_PageHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PageItem", function() { return PageItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Pager", function() { return es_Pager; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Pagination", function() { return es_Pagination; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Panel", function() { return es_Panel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PanelGroup", function() { return es_PanelGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Popover", function() { return es_Popover; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return es_ProgressBar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Radio", function() { return es_Radio; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ResponsiveEmbed", function() { return es_ResponsiveEmbed; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Row", function() { return es_Row; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SafeAnchor", function() { return es_SafeAnchor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SplitButton", function() { return es_SplitButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tab", function() { return es_Tab; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabContainer", function() { return es_TabContainer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabContent", function() { return es_TabContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Table", function() { return es_Table; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabPane", function() { return es_TabPane; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tabs", function() { return es_Tabs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return es_Thumbnail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return es_ToggleButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ToggleButtonGroup", function() { return es_ToggleButtonGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tooltip", function() { return es_Tooltip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Well", function() { return es_Well; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "utils", function() { return utils_namespaceObject; });















































































































































/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.VisibleBAlert = exports.bAlertType = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _AppConstants = __webpack_require__(6);

var _scrollComponentIntoView = __webpack_require__(1103);

var _scrollComponentIntoView2 = _interopRequireDefault(_scrollComponentIntoView);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BAlert(_ref) {
    var type = _ref.type,
        children = _ref.children,
        onClose = _ref.onClose,
        className = _ref.className,
        focusOnload = _ref.focusOnload,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['type', 'children', 'onClose', 'className', 'focusOnload']);


    var alertRef = (0, _react.useRef)(null);

    (0, _react.useEffect)(function () {
        if (focusOnload) {
            alertRef.current.focus();
        }
    }, [focusOnload, alertRef]);

    var dismissible = onClose !== _noop3.default;
    var classNames = (0, _classnames2.default)('b-alert', className, {
        'b-alert--success': type === _AppConstants.BAlertTypes.SUCCESS,
        'b-alert--info': type === _AppConstants.BAlertTypes.INFO,
        'b-alert--warning': type === _AppConstants.BAlertTypes.WARNING,
        'b-alert--danger': type === _AppConstants.BAlertTypes.DANGER,
        'b-alert--dismissible': dismissible
    });
    return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ tabIndex: '0', ref: alertRef, className: classNames }, otherProps),
        dismissible && _react2.default.createElement(_Icon2.default, { icon: 'clear', className: 'b-alert__close', onClick: onClose }),
        children
    );
}

BAlert.propTypes = {
    className: _propTypes2.default.string,
    type: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.BAlertTypes)).isRequired,
    onClose: _propTypes2.default.func,
    children: _propTypes2.default.node,
    focusOnload: _propTypes2.default.bool
};

BAlert.defaultProps = {
    className: '',
    onClose: _noop3.default,
    children: null
};

exports.default = BAlert;
var bAlertType = exports.bAlertType = _AppConstants.BAlertTypes;
var VisibleBAlert = exports.VisibleBAlert = (0, _scrollComponentIntoView2.default)(BAlert);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1431),
    baseMatchesProperty = __webpack_require__(1468),
    identity = __webpack_require__(116),
    isArray = __webpack_require__(68),
    property = __webpack_require__(966);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = uncontrollable;

var _react = _interopRequireDefault(__webpack_require__(0));

var _invariant = _interopRequireDefault(__webpack_require__(72));

var Utils = _interopRequireWildcard(__webpack_require__(1936));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var isCompositeComponent = Utils.isReactComponent(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(isCompositeComponent || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (isCompositeComponent) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[Utils.defaultKey(key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
          _this3._values[key] = nextProps[Utils.defaultKey(key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.getControlledInstance = function getControlledInstance() {
      return this.inner;
    };

    _proto.render = function render() {
      var _this4 = this;

      var props = _extends({}, this.props);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(_react.default.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Utils.uncontrolledPropTypes(controlledValues, displayName);
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _inner;

      return (_inner = this.inner)[method].apply(_inner, arguments);
    };
  });
  UncontrolledComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  UncontrolledComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return UncontrolledComponent;
}

module.exports = exports["default"];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

// TODO: This module should be ElementChildren, and should use named exports.

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;
  return _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}
/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */


function forEach(children, func, context) {
  var index = 0;

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}
/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */


function count(children) {
  var result = 0;

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}
/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */


function filter(children, func, context) {
  var index = 0;
  var result = [];

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result;

  _react.default.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  _react.default.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }

    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  _react.default.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!_react.default.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  _react.default.Children.forEach(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

var _default = {
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
};
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _CountryStore = __webpack_require__(457);

var _CountryStore2 = _interopRequireDefault(_CountryStore);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardAddressName = 'Smartcard';

var defaults = {
    id: null,
    name: null,
    contactName: null,
    line1: null,
    line2: null,
    line3: null,
    town: null,
    postCode: null,
    country: _config2.default.get('defaultDeliveryCountry'),
    telephoneNumber: null,
    toSave: false,
    default: false
};

var Address = function (_Record) {
    (0, _inherits3.default)(Address, _Record);

    function Address() {
        (0, _classCallCheck3.default)(this, Address);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    Address.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Address(json);
    };

    Address.prototype.getSchema = function getSchema() {
        return {
            contactName: _validation2.default.requiredString(),
            line1: _validation2.default.addressLine().required(),
            line2: _validation2.default.textMaxLength(),
            line3: _validation2.default.textMaxLength(),
            town: _validation2.default.townCity(),
            postCode: _joi2.default.any().when('country', {
                is: _config2.default.get('defaultDeliveryCountry'),
                then: _validation2.default.postcode(),
                otherwise: _joi2.default.any()
            }),
            country: _validation2.default.requiredString(),
            telephoneNumber: _validation2.default.phone().allow(null),
            name: _joi2.default.any().when('toSave', {
                is: true,
                then: _validation2.default.name(1, 50),
                otherwise: _joi2.default.any()
            }),
            isDefault: _joi2.default.boolean().optional()
        };
    };

    Address.prototype.reset = function reset() {
        var includeContactName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var contactName = !includeContactName ? this.contactName : null;
        return new Address({ contactName: contactName });
    };

    Address.prototype.isPostCodeRequired = function isPostCodeRequired() {
        return this.country === defaults.country;
    };

    Address.prototype.isDeliveryCountry = function isDeliveryCountry() {
        return this.country === defaults.country;
    };

    Address.prototype.isStored = function isStored() {
        return !!this.id;
    };

    Address.prototype.isSmartcardAddress = function isSmartcardAddress() {
        return this.isStored() && this.name === SmartcardAddressName;
    };

    Address.prototype.isEditable = function isEditable() {
        return this.isSmartcardAddress();
    };

    Address.prototype.isDeletable = function isDeletable() {
        return !this.isSmartcardAddress();
    };

    Address.prototype.getCountryName = function getCountryName() {
        return _CountryStore2.default.getCountry(this.country) && _CountryStore2.default.getCountry(this.country).name || this.country;
    };

    Address.prototype.getUpdateRequestJSON = function getUpdateRequestJSON() {
        return {
            "line1": this.line1,
            "line2": this.line2,
            "line3": this.line3,
            "town": this.town,
            "postCode": this.postCode,
            "default": this.default
        };
    };

    Address.prototype.asList = function asList() {
        var includeContactName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        return (0, _Immutable.toImmutable)((0, _compact3.default)([includeContactName && this.contactName, this.line1, this.line2, this.line3, this.town, this.postCode, this.getCountryName()]));
    };

    Address.prototype.toString = function toString() {
        return this.asList().join(', ');
    };

    return Address;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(Address.prototype, _ValidationMixin2.default);

exports.default = Address;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.plusBusTypes = exports.daySaveOffPeakTypes = exports.daySaveTypes = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _LinkMapper = __webpack_require__(8);

var _CarnetInformation = __webpack_require__(1028);

var _CarnetInformation2 = _interopRequireDefault(_CarnetInformation);

var _FlexiInformation = __webpack_require__(1673);

var _FlexiInformation2 = _interopRequireDefault(_FlexiInformation);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daySaveTypes = exports.daySaveTypes = new _immutable.List(['SD4', 'SD1', 'SDP', 'SS0']);
var daySaveOffPeakTypes = exports.daySaveOffPeakTypes = new _immutable.List(['SD1']);
var plusBusTypes = exports.plusBusTypes = new _immutable.List(['PBD', 'PB7', 'BMS', 'BQS', 'BAS', 'PBW']);
var returnTravelcardTypes = new _immutable.List(['ODT', 'ADT', 'FDT', 'AM3', 'SOE', 'SOT', 'STO', 'STP', 'WRE', 'WTC', '0CA', '0CC', '0CE', 'FTC']);
var roversRangersTypes = _immutable.List.of('14R', 'R07', 'H37', 'HE7', 'WM1', 'WM3', 'MTR', 'E37', 'EM7', 'NC8', 'NE8', 'NE7', 'NES', 'N37', 'NW7', 'WER');
var allLineRovers = _immutable.List.of('14R', 'R07');
var familyDayRangerType = 'WM3';
var nonFamilyDayRangerType = 'WM1';
var smartCarnetTypes = (0, _values2.default)(_AppConstants.SmartCarnetTicketCodes);

var defaults = {
    id: null,
    name: null,
    code: null,
    description: null,
    isReturn: null,
    isSeason: null,
    isFlexi: null,
    isAdvance: null,
    isPackage: null,
    isCarnet: null,
    isSmartCarnet: null,
    isFirstClass: null,
    validityCode: null,
    carnetInformation: null,
    flexiInformation: null
};

var TicketType = function (_record) {
    (0, _inherits3.default)(TicketType, _record);

    function TicketType() {
        (0, _classCallCheck3.default)(this, TicketType);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TicketType.fromJSON = function fromJSON(json) {
        json = json || {};

        var name = (0, _LinkMapper.resolve)(json.name).with(String);
        var translatedName = name ? (0, _I18n2.default)(name) : name;
        var code = (0, _LinkMapper.resolve)(json.code).with(String);
        var description = (0, _LinkMapper.resolve)(json.description).with(String);
        var isReturn = (0, _LinkMapper.resolve)(json.isReturn).with(Boolean);
        var isSeason = (0, _LinkMapper.resolve)(json.isSeason).with(Boolean);
        var isFlexi = (0, _LinkMapper.resolve)(json.isFlexi).with(Boolean);
        var isAdvance = (0, _LinkMapper.resolve)(json.isAdvance).with(Boolean);
        var isPackage = (0, _LinkMapper.resolve)(json.isPackage).with(Boolean);
        var isCarnet = (0, _LinkMapper.resolve)(json.isCarnet).with(Boolean);
        var isFirstClass = (0, _LinkMapper.resolve)(json.isFirstClass).with(Boolean);
        var validityCode = (0, _LinkMapper.resolve)(json.validityCode).with(String);
        var carnetInformation = (0, _LinkMapper.resolve)(json.carnetInformation).as(_CarnetInformation2.default);
        var flexiInformation = (0, _LinkMapper.resolve)(json.flexiInformation).as(_FlexiInformation2.default);

        return new TicketType({
            name: translatedName,
            code: code,
            description: description,
            isReturn: isReturn,
            isFlexi: isFlexi,
            isSeason: isSeason,
            isPackage: isPackage,
            isAdvance: isAdvance,
            isCarnet: isCarnet,
            isFirstClass: isFirstClass,
            validityCode: validityCode,
            carnetInformation: carnetInformation,
            flexiInformation: flexiInformation
        });
    };

    TicketType.getFamilyRangerCode = function getFamilyRangerCode() {
        return familyDayRangerType;
    };

    TicketType.prototype.isDaySave = function isDaySave() {
        return daySaveTypes.includes(this.code);
    };

    TicketType.prototype.isRoversRangers = function isRoversRangers() {
        return roversRangersTypes.includes(this.code);
    };

    TicketType.prototype.isFamilyRanger = function isFamilyRanger() {
        return familyDayRangerType === this.code;
    };

    TicketType.prototype.isNonFamilyRanger = function isNonFamilyRanger() {
        return nonFamilyDayRangerType === this.code;
    };

    TicketType.prototype.isDaySaveOffPeak = function isDaySaveOffPeak() {
        return daySaveOffPeakTypes.includes(this.code);
    };

    TicketType.prototype.isPlusBus = function isPlusBus() {
        return plusBusTypes.includes(this.code);
    };

    TicketType.prototype.isReturnTravelcard = function isReturnTravelcard() {
        return returnTravelcardTypes.includes(this.code);
    };

    TicketType.prototype.isAllLineRovers = function isAllLineRovers() {
        return allLineRovers.includes(this.code);
    };

    TicketType.prototype.isSmartCarnet = function isSmartCarnet() {
        return smartCarnetTypes.includes(this.code);
    };

    // HACK to prevent '1 Child Child Flat Fare Single' from being displayed:


    TicketType.prototype.shortenName = function shortenName() {
        return this.name.split(' ').slice(1).join(' ');
    };

    TicketType.prototype.ticketMultiplier = function ticketMultiplier() {
        if (this.isCarnet) {
            return this.getIn(['carnetInformation', 'numberOfTickets'], 1);
        } else if (this.isFlexi) {
            return this.getIn(['flexiInformation', 'numberOfTickets'], 1);
        }
        return 1;
    };

    return TicketType;
}((0, _immutable.Record)(defaults));

exports.default = TicketType;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Currency = __webpack_require__(169);

var _I18n = __webpack_require__(9);

var _DigitSpinner = __webpack_require__(1098);

var _DigitSpinner2 = _interopRequireDefault(_DigitSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Price(_ref) {
    var showFree = _ref.showFree,
        price = _ref.price,
        className = _ref.className,
        animated = _ref.animated,
        nonNegative = _ref.nonNegative,
        split = _ref.split,
        srOnly = _ref.srOnly,
        id = _ref.id;

    if (showFree && !price) {
        return _react2.default.createElement(
            'span',
            { className: className },
            (0, _I18n.translate)('booking.delivery.free')
        );
    }

    var validatedPrice = nonNegative && price < 0 ? 0 : price;
    var amount = (0, _Currency.toPounds)(validatedPrice).toFixed(2);

    var _amount$split = amount.split('.', 2),
        pounds = _amount$split[0],
        pence = _amount$split[1];

    var srText = '\xA3' + amount;
    return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('sr-container', className), id: id },
        _react2.default.createElement(
            'span',
            { 'aria-hidden': 'true' },
            _react2.default.createElement(
                'span',
                { className: 'price__symbol' },
                '\xA3'
            ),
            animated ? _react2.default.createElement(_DigitSpinner2.default, { number: amount }) : split ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'span',
                    { className: 'price__pounds' },
                    pounds
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'price__decimal' },
                    '.'
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'price__pence' },
                    pence
                )
            ) : amount
        ),
        _react2.default.createElement(
            'span',
            { className: 'sr-text' },
            (0, _I18n.translate)(srOnly || srText, { price: srText })
        )
    );
}

Price.propTypes = {
    price: _propTypes2.default.number,
    className: _propTypes2.default.string,
    showFree: _propTypes2.default.bool,
    animated: _propTypes2.default.bool,
    nonNegative: _propTypes2.default.bool,
    split: _propTypes2.default.bool,
    srOnly: _propTypes2.default.string,
    id: _propTypes2.default.string
};

Price.defaultProps = {
    price: 0,
    showFree: false,
    className: '',
    animated: false,
    nonNegative: false,
    split: false
};

exports.default = Price;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var createDesc = __webpack_require__(205);
module.exports = __webpack_require__(66) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var hide = __webpack_require__(111);
var has = __webpack_require__(120);
var SRC = __webpack_require__(206)('src');
var $toString = __webpack_require__(1185);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(130).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var fails = __webpack_require__(40);
var defined = __webpack_require__(149);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnEnterTrigger = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(OnEnterTrigger, _React$PureComponent);

    function OnEnterTrigger() {
        (0, _classCallCheck3.default)(this, OnEnterTrigger);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call(this));

        _this.focused = false;

        _this.onFocus = function () {
            _this.focused = true;
        };

        _this.onBlur = function () {
            _this.focused = false;
        };

        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
    }

    OnEnterTrigger.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        window.addEventListener('keydown', this.handleKeyPress);
    };

    OnEnterTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress);
    };

    OnEnterTrigger.prototype.handleKeyPress = function handleKeyPress(event) {
        if (this.props.disabled || !this.focused) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.stopImmediatePropagation();
            event.preventDefault();
            this.props.onClick(event);
            this.props.onTrigger();
        }
    };

    OnEnterTrigger.prototype.render = function render() {
        var _props = this.props,
            Element = _props.element,
            disabled = _props.disabled,
            disableTabIndex = _props.disableTabIndex,
            tabIndex = _props.tabIndex,
            ariaHidden = _props.ariaHidden,
            srOnly = _props.srOnly,
            reference = _props.reference;

        var expectedTabIndex = disabled ? -1 : tabIndex;
        var tabIndexProp = disableTabIndex ? null : { tabIndex: expectedTabIndex };

        var srOnlyProps = srOnly ? { 'aria-label': srOnly } : null;
        var referenceProps = reference ? { ref: reference } : null;

        return _react2.default.createElement(Element, (0, _extends3.default)({}, (0, _omit3.default)(this.props, ['element', 'onTrigger', 'tabIndex', 'ariaHidden', 'disabled', 'srOnly', 'disableTabIndex']), tabIndexProp, {
            'aria-hidden': ariaHidden,
            onFocus: this.onFocus,
            onBlur: this.onBlur
        }, referenceProps, srOnlyProps));
    };

    return OnEnterTrigger;
}(_react2.default.PureComponent), _class.propTypes = {
    element: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    onClick: _propTypes2.default.func,
    onTrigger: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    disableTabIndex: _propTypes2.default.bool,
    tabIndex: _propTypes2.default.string,
    ariaHidden: _propTypes2.default.string,
    srOnly: _propTypes2.default.string,
    reference: _propTypes2.default.object,
    role: _propTypes2.default.string
}, _class.defaultProps = {
    element: 'div',
    onClick: _noop3.default,
    onTrigger: _noop3.default,
    disabled: false,
    disableTabIndex: false,
    tabIndex: "0",
    ariaHidden: "false",
    srOnly: null,
    reference: null,
    role: 'button'
}, _temp);
exports.default = OnEnterTrigger;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DimensionsStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DimensionsStore = exports.DimensionsStore = function (_BaseStore) {
    (0, _inherits3.default)(DimensionsStore, _BaseStore);

    function DimensionsStore() {
        (0, _classCallCheck3.default)(this, DimensionsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    DimensionsStore.prototype.getWindowSize = function getWindowSize() {
        return new _immutable.Map({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };

    DimensionsStore.prototype.getInitialState = function getInitialState() {
        return this.getWindowSize();
    };

    DimensionsStore.prototype.handleResize = function handleResize() {
        this.setState(this.getWindowSize());
    };

    DimensionsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.WINDOW_RESIZED] = this.handleResize, _ref;
    };

    DimensionsStore.prototype.isMobileWidth = function isMobileWidth() {
        return this.state.get('width') < _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH;
    };

    DimensionsStore.prototype.isTabletWidth = function isTabletWidth() {
        return this.state.get('width') >= _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH && this.state.get('width') < _AppConstants.BreakPoints.DESKTOP_WIDTH;
    };

    DimensionsStore.prototype.isDesktopWidth = function isDesktopWidth() {
        return this.state.get('width') >= _AppConstants.BreakPoints.DESKTOP_WIDTH;
    };

    DimensionsStore.prototype.isDesktopLWidth = function isDesktopLWidth() {
        return this.state.get('width') >= _AppConstants.BreakPoints.DESKTOP_WIDTH_L;
    };

    DimensionsStore.prototype.isDesktopXLWidth = function isDesktopXLWidth() {
        return this.state.get('width') >= _AppConstants.BreakPoints.DESKTOP_WIDTH_XL;
    };

    return DimensionsStore;
}(_BaseStore3.default);

var instance = new DimensionsStore();

exports.default = instance;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackingActions = {
    jpLayoutTabSelect: function jpLayoutTabSelect(layout) {
        _AppDispatcher2.default.dispatch({
            layout: layout,
            actionType: _AppConstants.ActionTypes.JP_CHANGE_LAYOUT
        });
    },
    jpFareClassFilterClick: function jpFareClassFilterClick(fareClass, value) {
        _AppDispatcher2.default.dispatch({
            fareClass: fareClass,
            value: value,
            actionType: _AppConstants.ActionTypes.JP_FARE_CLASS_FILTER_CLICK
        });
    },
    jpFareSelectionFilterClick: function jpFareSelectionFilterClick(selection) {
        _AppDispatcher2.default.dispatch({
            selection: selection,
            actionType: _AppConstants.ActionTypes.JP_FARE_SELECTION_FILTER_CLICK
        });
    },
    jpTocSpecificFilterRendered: function jpTocSpecificFilterRendered() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.JP_TOC_SPECIFIC_FILTER_RENDERED
        });
    },
    jpTocSpecificFilterClick: function jpTocSpecificFilterClick(value) {
        _AppDispatcher2.default.dispatch({
            value: value,
            actionType: _AppConstants.ActionTypes.JP_TOC_SPECIFIC_FILTER_CLICK
        });
    },
    jpAllFaresAccordionClick: function jpAllFaresAccordionClick(value) {
        _AppDispatcher2.default.dispatch({
            value: value,
            actionType: _AppConstants.ActionTypes.JP_ALL_FARES_ACCORDION_CLICK
        });
    },
    jpCheckoutWithSuggestedProducts: function jpCheckoutWithSuggestedProducts() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.JP_CHECKOUT_WITH_SUGGESTED_PRODUCTS
        });
    },
    jpChangedSearchType: function jpChangedSearchType(searchType) {
        _AppDispatcher2.default.dispatch({
            searchType: searchType,
            actionType: _AppConstants.ActionTypes.JP_CHANGE_SEARCH_TYPE
        });
    },
    genericModalOpen: function genericModalOpen(type) {
        _AppDispatcher2.default.dispatch({
            type: type,
            actionType: _AppConstants.ActionTypes.GENERIC_MODAL_OPEN
        });
    },
    returnTravelcardAdded: function returnTravelcardAdded(orderTrip) {
        _AppDispatcher2.default.dispatch({
            orderTrip: orderTrip,
            actionType: _AppConstants.ActionTypes.RETURN_TRAVELCARD_CTA_CLICK
        });
    },
    deliveryMethod: function deliveryMethod(order, eventType) {
        _AppDispatcher2.default.dispatch({
            order: order,
            eventType: eventType,
            actionType: _AppConstants.ActionTypes.DELIVERY_METHOD
        });
    },
    paymentMethod: function paymentMethod(id, _paymentMethod, eventType) {
        _AppDispatcher2.default.dispatch({
            id: id,
            paymentMethod: _paymentMethod,
            eventType: eventType,
            actionType: _AppConstants.ActionTypes.PAYMENT_METHOD
        });
    },
    widgetStationSearch: function widgetStationSearch(search) {
        _AppDispatcher2.default.dispatch({
            search: search,
            actionType: _AppConstants.ActionTypes.WIDGET_SEARCH_STATION_SELECT
        });
    },
    widgetStationSwitch: function widgetStationSwitch() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.WIDGET_SEARCH_STATION_SWITCH
        });
    },
    widgetDaySelect: function widgetDaySelect(data) {
        _AppDispatcher2.default.dispatch({
            data: data,
            actionType: _AppConstants.ActionTypes.WIDGET_SEARCH_DAY_SELECT
        });
    },
    widgetSearchClick: function widgetSearchClick(type) {
        _AppDispatcher2.default.dispatch({
            type: type,
            actionType: _AppConstants.ActionTypes.WIDGET_SEARCH_CLICK
        });
    },
    expandFares: function expandFares(type) {
        _AppDispatcher2.default.dispatch({
            type: type,
            actionType: _AppConstants.ActionTypes.FARES_EXPAND
        });
    },
    plusBusSelect: function plusBusSelect(type) {
        _AppDispatcher2.default.dispatch({
            type: type,
            actionType: _AppConstants.ActionTypes.PLUS_BUS_SELECT
        });
    },
    externalLink: function externalLink(type) {
        _AppDispatcher2.default.dispatch({
            type: type,
            actionType: _AppConstants.ActionTypes.EXTERNAL_LINK
        });
    },
    jobcenterPlusRailcardToggle: function jobcenterPlusRailcardToggle(type) {
        _AppDispatcher2.default.dispatch({
            type: type,
            actionType: _AppConstants.ActionTypes.RAILCARD_JOBCENTREPLUS_CHECKED
        });
    },
    showFlexiWarningModal: function showFlexiWarningModal(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SHOW_FLEXI_WARNING_MODAL,
            context: context
        });
    },
    flexiWarningModalAcknowledgementCheckboxChecked: function flexiWarningModalAcknowledgementCheckboxChecked(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_CHECKED,
            context: context
        });
    },
    flexiWarningModalAcknowledgementCheckboxUnchecked: function flexiWarningModalAcknowledgementCheckboxUnchecked(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_UNCHECKED,
            context: context
        });
    },
    flexiWarningModalClose: function flexiWarningModalClose(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.FLEXI_WARNING_MODAL_CLOSE,
            context: context
        });
    },
    flexiWarningModalContinue: function flexiWarningModalContinue(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.FLEXI_WARNING_MODAL_CONTINUE,
            context: context
        });
    },
    flexiWarningModalMoreInfoClicked: function flexiWarningModalMoreInfoClicked(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.FLEXI_WARNING_MODAL_MORE_INFO_CLICKED,
            context: context
        });
    },
    userOptedIn: function userOptedIn(from) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.USER_OPTED_IN,
            from: from
        });
    },
    userOptedOut: function userOptedOut() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.USER_OPTED_OUT
        });
    },
    selectNotificationPreference: function selectNotificationPreference(method) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SELECT_NOTIFICATION_PREFERENCE,
            method: method
        });
    },
    selectRepaymentMethod: function selectRepaymentMethod(method) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SELECT_REPAYMENT_METHOD,
            method: method
        });
    },
    amendNotificationPreference: function amendNotificationPreference() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.AMEND_NOTIFICATION_PREFERENCE
        });
    },
    amendRepaymentMethod: function amendRepaymentMethod() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.AMEND_REPAYMENT_METHOD
        });
    },
    amendAddress: function amendAddress() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.AMEND_ADDRESS
        });
    },
    saveRegularJourneyAlertWithOCDRFavJourney: function saveRegularJourneyAlertWithOCDRFavJourney() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SAVE_REGULAR_JOURNEY_WITH_OCDR_FAV_JOURNEY
        });
    },
    webchatOpened: function webchatOpened() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.WEBCHAT_OPENED
        });
    },
    backFromPaymentPage: function backFromPaymentPage(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.BACK_FROM_PAYMENT_PAGE,
            context: context
        });
    },
    addAnotherJourneyOnDeliveryPage: function addAnotherJourneyOnDeliveryPage(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.ADD_ANOTHER_JOURNEY_ON_DELIVERY_PAGE,
            context: context
        });
    },
    addAnotherJourneyOnPaymentPage: function addAnotherJourneyOnPaymentPage(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.ADD_ANOTHER_JOURNEY_ON_PAYMENT_PAGE,
            context: context
        });
    },
    addAnotherJourneyOnBasketModal: function addAnotherJourneyOnBasketModal(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.ADD_ANOTHER_JOURNEY_ON_BASKET_MODAL,
            context: context
        });
    },
    deliveryScreenBackNavigationTicketRemoved: function deliveryScreenBackNavigationTicketRemoved(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_REMOVED,
            context: context
        });
    },
    deliveryScreenBackNavigationTicketKept: function deliveryScreenBackNavigationTicketKept(context) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_KEPT,
            context: context
        });
    }
};

exports.default = TrackingActions;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1534),
    flatRest = __webpack_require__(792);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(309);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(293);
var defined = __webpack_require__(149);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(294);
var createDesc = __webpack_require__(205);
var toIObject = __webpack_require__(121);
var toPrimitive = __webpack_require__(148);
var has = __webpack_require__(120);
var IE8_DOM_DEFINE = __webpack_require__(688);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(66) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(120);
var toObject = __webpack_require__(73);
var IE_PROTO = __webpack_require__(467)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(183)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1842);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1537), __esModule: true };

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(744),
    baseKeys = __webpack_require__(747),
    isArrayLike = __webpack_require__(143);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isArray = __webpack_require__(68),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _Cookie = __webpack_require__(258);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardStore = function (_BaseStore) {
    (0, _inherits3.default)(SmartcardStore, _BaseStore);

    function SmartcardStore() {
        (0, _classCallCheck3.default)(this, SmartcardStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SmartcardStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            lastUpdated: undefined,
            smartcard: undefined,
            smartcardDirty: false,
            smartcardFailure: null,
            smartcardFailureNotified: false,
            smartcards: new _immutable.List(),
            activatedSmartcards: this.activatedSmartcardsCookie,
            associatedAccounts: new _immutable.List(),
            associatedSmartcards: new _immutable.List(),
            smartcardToAssociate: null
        });
    };

    SmartcardStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.SMARTCARD_LOADED] = this.handleSmartcardLoaded, _ref[_AppConstants.ActionTypes.SMARTCARD_FAILED] = this.handleSmartcardFailed, _ref[_AppConstants.ActionTypes.SMARTCARD_FAILURE_NOTIFIED] = this.handleSmartcardFailureNotified, _ref[_AppConstants.ActionTypes.SMARTCARD_DIRTY] = this.handleDirtySmartcard, _ref[_AppConstants.ActionTypes.SMARTCARDS_LOADED] = this.handlePropertyChange('smartcards'), _ref[_AppConstants.ActionTypes.SMARTCARD_ACTIVATION_STARTED] = this.handleSmartcardActivationStarted, _ref[_AppConstants.ActionTypes.SMARTCARD_ACTIVATED] = this.handleManualActivation, _ref[_AppConstants.ActionTypes.SMARTCARD_ACTIVATION_FAILED] = this.handleSmartcardActivationFailure, _ref[_AppConstants.ActionTypes.SMARTCARD_PAPER_TRANSFER_COMPLETE] = this.handlePaperTransfer, _ref[_AppConstants.ActionTypes.SMARTCARD_ASSOCIATED_ACCOUNTS_LOADED] = this.handleAssociatedAccountsLoaded, _ref[_AppConstants.ActionTypes.SMARTCARD_ASSOCIATED_SMARTCARDS_LOADED] = this.handleAssociatedSmartcardsLoaded, _ref[_AppConstants.ActionTypes.SMARTCARD_TO_ASSOCIATE_LOADED] = this.handleSmartcardToAssociateLoaded, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref;
    };

    SmartcardStore.prototype.handlePropertyChange = function handlePropertyChange(name, key) {
        var _this2 = this;

        return function (payload) {
            return _this2.setState(_this2.state.set(name, payload[key || name]));
        };
    };

    SmartcardStore.prototype.handleSmartcardLoaded = function handleSmartcardLoaded(_ref2) {
        var smartcard = _ref2.smartcard;

        this.setState(this.state.merge({
            smartcard: smartcard,
            smartcardDirty: false,
            lastUpdated: (0, _TrainTime2.default)(),
            smartcardFailure: null,
            smartcardFailureNotified: false
        }));
    };

    SmartcardStore.prototype.handleDirtySmartcard = function handleDirtySmartcard() {
        this.setState(this.state.set('smartcardDirty', true));
    };

    SmartcardStore.prototype.handleSmartcardFailed = function handleSmartcardFailed(_ref3) {
        var error = _ref3.error;

        this.setState(this.state.set('smartcardFailure', error));
    };

    SmartcardStore.prototype.handleSmartcardFailureNotified = function handleSmartcardFailureNotified() {
        this.setState(this.state.set('smartcardFailureNotified', true));
    };

    SmartcardStore.prototype.resetState = function resetState() {
        this.setState(this.getInitialState());
    };

    SmartcardStore.prototype.handleSmartcardActivationStarted = function handleSmartcardActivationStarted() {
        this.setState(this.state.set('smartcardActivating', true));
    };

    SmartcardStore.prototype.handleManualActivation = function handleManualActivation() {
        var cardRef = this.state.getIn(['smartcard', 'reference']);
        var activatedCards = this.state.get('activatedSmartcards').add(cardRef);

        this.setState(this.state.set('activatedSmartcards', activatedCards).set('smartcardActivating', false));
        this.activatedSmartcardsCookie = activatedCards;
    };

    SmartcardStore.prototype.handleSmartcardActivationFailure = function handleSmartcardActivationFailure() {
        this.setState(this.state.set('smartcardActivating', false));
    };

    SmartcardStore.prototype.handlePaperTransfer = function handlePaperTransfer() {
        var smartcard = this.state.get('smartcard');
        var updated = smartcard.set('cardStatus', _AppConstants.SmartcardStatus.AWAITING_FULFILMENT);
        this.setState(this.state.set('smartcard', updated));
    };

    SmartcardStore.prototype.handleAssociatedAccountsLoaded = function handleAssociatedAccountsLoaded(_ref4) {
        var accounts = _ref4.accounts;

        this.setState(this.state.set('associatedAccounts', accounts));
    };

    SmartcardStore.prototype.handleAssociatedSmartcardsLoaded = function handleAssociatedSmartcardsLoaded(_ref5) {
        var smartcards = _ref5.smartcards;

        this.setState(this.state.set('associatedSmartcards', smartcards));
    };

    SmartcardStore.prototype.handleSmartcardToAssociateLoaded = function handleSmartcardToAssociateLoaded(_ref6) {
        var smartcard = _ref6.smartcard;

        this.setState(this.state.set('smartcardToAssociate', smartcard));
    };

    SmartcardStore.prototype.getCurrent = function getCurrent() {
        return this.get('smartcard');
    };

    SmartcardStore.prototype.shouldGetSmartcard = function shouldGetSmartcard() {
        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
        var timeUnits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'minutes';

        var lastUpdated = this.get('lastUpdated');

        return !this.get('smartcard') || this.get('smartcardDirty') || lastUpdated && lastUpdated.isBefore((0, _TrainTime2.default)().subtract(time, timeUnits));
    };

    SmartcardStore.prototype.isReplacementPending = function isReplacementPending() {
        var smartcard = this.state.get('smartcard');
        return smartcard && smartcard.replacementInProgress;
    };

    SmartcardStore.prototype.canAutoDelayRepay = function canAutoDelayRepay() {
        var smartcard = this.state.get('smartcard');
        return smartcard && (smartcard.isActive() || this.isReplacementPending());
    };

    SmartcardStore.prototype.getAssociatedSmartcards = function getAssociatedSmartcards() {
        return this.get('associatedSmartcards');
    };

    (0, _createClass3.default)(SmartcardStore, [{
        key: 'activatedSmartcardsCookie',
        get: function get() {
            var value = _Cookie2.default.get(_AppConstants.CookieKeys.CONFIRMED_SMARTCARDS) || [];
            return new _immutable.Set(value);
        },
        set: function set(value) {
            var expires = (0, _moment2.default)().add(1, 'year').format();
            _Cookie2.default.set(_AppConstants.CookieKeys.CONFIRMED_SMARTCARDS, value.toJS(), { expires: expires });
        }
    }]);
    return SmartcardStore;
}(_BaseStore3.default);

exports.default = new SmartcardStore();

/***/ }),
/* 130 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(93);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(40);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(136);
var IE8_DOM_DEFINE = __webpack_require__(724);
var toPrimitive = __webpack_require__(495);
var dP = Object.defineProperty;

exports.f = __webpack_require__(124) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(103);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(393);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hoek = __webpack_require__(96);
var Ref = __webpack_require__(153);
var Errors = __webpack_require__(530);
var Alternatives = null; // Delay-loaded to prevent circular dependencies
var Cast = null;

// Declare internals

var internals = {
    Set: __webpack_require__(801)
};

internals.defaults = {
    abortEarly: true,
    convert: true,
    allowUnknown: false,
    skipFunctions: false,
    stripUnknown: false,
    language: {},
    presence: 'optional',
    strip: false,
    noDefaults: false

    // context: null
};

module.exports = internals.Any = function () {
    function _class() {
        (0, _classCallCheck3.default)(this, _class);


        Cast = Cast || __webpack_require__(318);

        this.isJoi = true;
        this._type = 'any';
        this._settings = null;
        this._valids = new internals.Set();
        this._invalids = new internals.Set();
        this._tests = [];
        this._refs = [];
        this._flags = {
            /*
             presence: 'optional',                   // optional, required, forbidden, ignore
             allowOnly: false,
             allowUnknown: undefined,
             default: undefined,
             forbidden: false,
             encoding: undefined,
             insensitive: false,
             trim: false,
             case: undefined,                        // upper, lower
             empty: undefined,
             func: false,
             raw: false
             */
        };

        this._description = null;
        this._unit = null;
        this._notes = [];
        this._tags = [];
        this._examples = [];
        this._meta = [];

        this._inner = {}; // Hash of arrays of immutable objects
    }

    _class.prototype.createError = function createError(type, context, state, options) {

        return Errors.create(type, context, state, options, this._flags);
    };

    _class.prototype.createOverrideError = function createOverrideError(type, context, state, options, message, template) {

        return Errors.create(type, context, state, options, this._flags, message, template);
    };

    _class.prototype.checkOptions = function checkOptions(options) {

        var Schemas = __webpack_require__(1575);
        var result = Schemas.options.validate(options);
        if (result.error) {
            throw new Error(result.error.details[0].message);
        }
    };

    _class.prototype.clone = function clone() {

        var obj = (0, _create2.default)((0, _getPrototypeOf2.default)(this));

        obj.isJoi = true;
        obj._type = this._type;
        obj._settings = internals.concatSettings(this._settings);
        obj._baseType = this._baseType;
        obj._valids = Hoek.clone(this._valids);
        obj._invalids = Hoek.clone(this._invalids);
        obj._tests = this._tests.slice();
        obj._refs = this._refs.slice();
        obj._flags = Hoek.clone(this._flags);

        obj._description = this._description;
        obj._unit = this._unit;
        obj._notes = this._notes.slice();
        obj._tags = this._tags.slice();
        obj._examples = this._examples.slice();
        obj._meta = this._meta.slice();

        obj._inner = {};
        var inners = (0, _keys2.default)(this._inner);
        for (var i = 0; i < inners.length; ++i) {
            var key = inners[i];
            obj._inner[key] = this._inner[key] ? this._inner[key].slice() : null;
        }

        return obj;
    };

    _class.prototype.concat = function concat(schema) {

        Hoek.assert(schema instanceof internals.Any, 'Invalid schema object');
        Hoek.assert(this._type === 'any' || schema._type === 'any' || schema._type === this._type, 'Cannot merge type', this._type, 'with another type:', schema._type);

        var obj = this.clone();

        if (this._type === 'any' && schema._type !== 'any') {

            // Reset values as if we were "this"
            var tmpObj = schema.clone();
            var keysToRestore = ['_settings', '_valids', '_invalids', '_tests', '_refs', '_flags', '_description', '_unit', '_notes', '_tags', '_examples', '_meta', '_inner'];

            for (var i = 0; i < keysToRestore.length; ++i) {
                tmpObj[keysToRestore[i]] = obj[keysToRestore[i]];
            }

            obj = tmpObj;
        }

        obj._settings = obj._settings ? internals.concatSettings(obj._settings, schema._settings) : schema._settings;
        obj._valids.merge(schema._valids, schema._invalids);
        obj._invalids.merge(schema._invalids, schema._valids);
        obj._tests = obj._tests.concat(schema._tests);
        obj._refs = obj._refs.concat(schema._refs);
        Hoek.merge(obj._flags, schema._flags);

        obj._description = schema._description || obj._description;
        obj._unit = schema._unit || obj._unit;
        obj._notes = obj._notes.concat(schema._notes);
        obj._tags = obj._tags.concat(schema._tags);
        obj._examples = obj._examples.concat(schema._examples);
        obj._meta = obj._meta.concat(schema._meta);

        var inners = (0, _keys2.default)(schema._inner);
        var isObject = obj._type === 'object';
        for (var _i = 0; _i < inners.length; ++_i) {
            var key = inners[_i];
            var source = schema._inner[key];
            if (source) {
                var target = obj._inner[key];
                if (target) {
                    if (isObject && key === 'children') {
                        var keys = {};

                        for (var j = 0; j < target.length; ++j) {
                            keys[target[j].key] = j;
                        }

                        for (var _j = 0; _j < source.length; ++_j) {
                            var sourceKey = source[_j].key;
                            if (keys[sourceKey] >= 0) {
                                target[keys[sourceKey]] = {
                                    key: sourceKey,
                                    schema: target[keys[sourceKey]].schema.concat(source[_j].schema)
                                };
                            } else {
                                target.push(source[_j]);
                            }
                        }
                    } else {
                        obj._inner[key] = obj._inner[key].concat(source);
                    }
                } else {
                    obj._inner[key] = source.slice();
                }
            }
        }

        return obj;
    };

    _class.prototype._test = function _test(name, arg, func, options) {

        var obj = this.clone();
        obj._tests.push({ func: func, name: name, arg: arg, options: options });
        return obj;
    };

    _class.prototype.options = function options(_options) {

        Hoek.assert(!_options.context, 'Cannot override context');
        this.checkOptions(_options);

        var obj = this.clone();
        obj._settings = internals.concatSettings(obj._settings, _options);
        return obj;
    };

    _class.prototype.strict = function strict(isStrict) {

        var obj = this.clone();
        obj._settings = obj._settings || {};
        obj._settings.convert = isStrict === undefined ? false : !isStrict;
        return obj;
    };

    _class.prototype.raw = function raw(isRaw) {

        var value = isRaw === undefined ? true : isRaw;

        if (this._flags.raw === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.raw = value;
        return obj;
    };

    _class.prototype.error = function error(err) {

        Hoek.assert(err && (err instanceof Error || typeof err === 'function'), 'Must provide a valid Error object or a function');

        var obj = this.clone();
        obj._flags.error = err;
        return obj;
    };

    _class.prototype.allow = function allow() {

        var obj = this.clone();
        var values = Hoek.flatten(Array.prototype.slice.call(arguments));
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
            obj._invalids.remove(value);
            obj._valids.add(value, obj._refs);
        }
        return obj;
    };

    _class.prototype.valid = function valid() {

        var obj = this.allow.apply(this, arguments);
        obj._flags.allowOnly = true;
        return obj;
    };

    _class.prototype.invalid = function invalid(value) {

        var obj = this.clone();
        var values = Hoek.flatten(Array.prototype.slice.call(arguments));
        for (var i = 0; i < values.length; ++i) {
            value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
            obj._valids.remove(value);
            obj._invalids.add(value, this._refs);
        }

        return obj;
    };

    _class.prototype.required = function required() {

        if (this._flags.presence === 'required') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'required';
        return obj;
    };

    _class.prototype.optional = function optional() {

        if (this._flags.presence === 'optional') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'optional';
        return obj;
    };

    _class.prototype.forbidden = function forbidden() {

        if (this._flags.presence === 'forbidden') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'forbidden';
        return obj;
    };

    _class.prototype.strip = function strip() {

        if (this._flags.strip) {
            return this;
        }

        var obj = this.clone();
        obj._flags.strip = true;
        return obj;
    };

    _class.prototype.applyFunctionToChildren = function applyFunctionToChildren(children, fn, args, root) {

        children = [].concat(children);

        if (children.length !== 1 || children[0] !== '') {
            root = root ? root + '.' : '';

            var extraChildren = (children[0] === '' ? children.slice(1) : children).map(function (child) {

                return root + child;
            });

            throw new Error('unknown key(s) ' + extraChildren.join(', '));
        }

        return this[fn].apply(this, args);
    };

    _class.prototype.default = function _default(value, description) {

        if (typeof value === 'function' && !Ref.isRef(value)) {

            if (!value.description && description) {

                value.description = description;
            }

            if (!this._flags.func) {
                Hoek.assert(typeof value.description === 'string' && value.description.length > 0, 'description must be provided when default value is a function');
            }
        }

        var obj = this.clone();
        obj._flags.default = value;
        Ref.push(obj._refs, value);
        return obj;
    };

    _class.prototype.empty = function empty(schema) {

        var obj = this.clone();
        obj._flags.empty = schema === undefined ? undefined : Cast.schema(schema);
        return obj;
    };

    _class.prototype.when = function when(ref, options) {

        Hoek.assert(options && (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object', 'Invalid options');
        Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');

        var then = options.hasOwnProperty('then') ? this.concat(Cast.schema(options.then)) : undefined;
        var otherwise = options.hasOwnProperty('otherwise') ? this.concat(Cast.schema(options.otherwise)) : undefined;

        Alternatives = Alternatives || __webpack_require__(532);
        var obj = Alternatives.when(ref, { is: options.is, then: then, otherwise: otherwise });
        obj._flags.presence = 'ignore';
        obj._baseType = this;

        return obj;
    };

    _class.prototype.description = function description(desc) {

        Hoek.assert(desc && typeof desc === 'string', 'Description must be a non-empty string');

        var obj = this.clone();
        obj._description = desc;
        return obj;
    };

    _class.prototype.notes = function notes(_notes) {

        Hoek.assert(_notes && (typeof _notes === 'string' || Array.isArray(_notes)), 'Notes must be a non-empty string or array');

        var obj = this.clone();
        obj._notes = obj._notes.concat(_notes);
        return obj;
    };

    _class.prototype.tags = function tags(_tags) {

        Hoek.assert(_tags && (typeof _tags === 'string' || Array.isArray(_tags)), 'Tags must be a non-empty string or array');

        var obj = this.clone();
        obj._tags = obj._tags.concat(_tags);
        return obj;
    };

    _class.prototype.meta = function meta(_meta) {

        Hoek.assert(_meta !== undefined, 'Meta cannot be undefined');

        var obj = this.clone();
        obj._meta = obj._meta.concat(_meta);
        return obj;
    };

    _class.prototype.example = function example(value) {

        Hoek.assert(arguments.length, 'Missing example');
        var result = this._validate(value, null, internals.defaults);
        Hoek.assert(!result.errors, 'Bad example:', result.errors && Errors.process(result.errors, value));

        var obj = this.clone();
        obj._examples.push(value);
        return obj;
    };

    _class.prototype.unit = function unit(name) {

        Hoek.assert(name && typeof name === 'string', 'Unit name must be a non-empty string');

        var obj = this.clone();
        obj._unit = name;
        return obj;
    };

    _class.prototype._prepareEmptyValue = function _prepareEmptyValue(value) {

        if (typeof value === 'string' && this._flags.trim) {
            return value.trim();
        }

        return value;
    };

    _class.prototype._validate = function _validate(value, state, options, reference) {
        var _this = this;

        var originalValue = value;

        // Setup state and settings

        state = state || { key: '', path: '', parent: null, reference: reference };

        if (this._settings) {
            options = internals.concatSettings(options, this._settings);
        }

        var errors = [];
        var finish = function finish() {

            var finalValue = void 0;

            if (value !== undefined) {
                finalValue = _this._flags.raw ? originalValue : value;
            } else if (options.noDefaults) {
                finalValue = value;
            } else if (Ref.isRef(_this._flags.default)) {
                finalValue = _this._flags.default(state.parent, options);
            } else if (typeof _this._flags.default === 'function' && !(_this._flags.func && !_this._flags.default.description)) {

                var args = void 0;

                if (state.parent !== null && _this._flags.default.length > 0) {

                    args = [Hoek.clone(state.parent), options];
                }

                var defaultValue = internals._try(_this._flags.default, args);
                finalValue = defaultValue.value;
                if (defaultValue.error) {
                    errors.push(_this.createError('any.default', defaultValue.error, state, options));
                }
            } else {
                finalValue = Hoek.clone(_this._flags.default);
            }

            if (errors.length && typeof _this._flags.error === 'function') {
                var change = _this._flags.error.call(_this, errors);

                if (typeof change === 'string') {
                    errors = [_this.createOverrideError('override', { reason: errors }, state, options, change)];
                } else {
                    errors = [].concat(change).map(function (err) {

                        return err instanceof Error ? err : _this.createOverrideError(err.type || 'override', err.context, state, options, err.message, err.template);
                    });
                }
            }

            return {
                value: _this._flags.strip ? undefined : finalValue,
                finalValue: finalValue,
                errors: errors.length ? errors : null
            };
        };

        if (this._coerce) {
            var coerced = this._coerce.call(this, value, state, options);
            if (coerced.errors) {
                value = coerced.value;
                errors = errors.concat(coerced.errors);
                return finish(); // Coerced error always aborts early
            }

            value = coerced.value;
        }

        if (this._flags.empty && !this._flags.empty._validate(this._prepareEmptyValue(value), null, internals.defaults).errors) {
            value = undefined;
        }

        // Check presence requirements

        var presence = this._flags.presence || options.presence;
        if (presence === 'optional') {
            if (value === undefined) {
                var isDeepDefault = this._flags.hasOwnProperty('default') && this._flags.default === undefined;
                if (isDeepDefault && this._type === 'object') {
                    value = {};
                } else {
                    return finish();
                }
            }
        } else if (presence === 'required' && value === undefined) {

            errors.push(this.createError('any.required', null, state, options));
            return finish();
        } else if (presence === 'forbidden') {
            if (value === undefined) {
                return finish();
            }

            errors.push(this.createError('any.unknown', null, state, options));
            return finish();
        }

        // Check allowed and denied values using the original value

        if (this._valids.has(value, state, options, this._flags.insensitive)) {
            return finish();
        }

        if (this._invalids.has(value, state, options, this._flags.insensitive)) {
            errors.push(this.createError(value === '' ? 'any.empty' : 'any.invalid', null, state, options));
            if (options.abortEarly || value === undefined) {
                // No reason to keep validating missing value

                return finish();
            }
        }

        // Convert value and validate type

        if (this._base) {
            var base = this._base.call(this, value, state, options);
            if (base.errors) {
                value = base.value;
                errors = errors.concat(base.errors);
                return finish(); // Base error always aborts early
            }

            if (base.value !== value) {
                value = base.value;

                // Check allowed and denied values using the converted value

                if (this._valids.has(value, state, options, this._flags.insensitive)) {
                    return finish();
                }

                if (this._invalids.has(value, state, options, this._flags.insensitive)) {
                    errors.push(this.createError(value === '' ? 'any.empty' : 'any.invalid', null, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }
            }
        }

        // Required values did not match

        if (this._flags.allowOnly) {
            errors.push(this.createError('any.allowOnly', { valids: this._valids.values({ stripUndefined: true }) }, state, options));
            if (options.abortEarly) {
                return finish();
            }
        }

        // Helper.validate tests

        for (var i = 0; i < this._tests.length; ++i) {
            var test = this._tests[i];
            var ret = test.func.call(this, value, state, options);
            if (ret instanceof Errors.Err) {
                errors.push(ret);
                if (options.abortEarly) {
                    return finish();
                }
            } else {
                value = ret;
            }
        }

        return finish();
    };

    _class.prototype._validateWithOptions = function _validateWithOptions(value, options, callback) {

        if (options) {
            this.checkOptions(options);
        }

        var settings = internals.concatSettings(internals.defaults, options);
        var result = this._validate(value, null, settings);
        var errors = Errors.process(result.errors, value);

        if (callback) {
            return callback(errors, result.value);
        }

        return { error: errors, value: result.value };
    };

    _class.prototype.validate = function validate(value, options, callback) {

        if (typeof options === 'function') {
            return this._validateWithOptions(value, null, options);
        }

        return this._validateWithOptions(value, options, callback);
    };

    _class.prototype.describe = function describe() {
        var _this2 = this;

        var description = {
            type: this._type
        };

        var flags = (0, _keys2.default)(this._flags);
        if (flags.length) {
            if (['empty', 'default', 'lazy', 'label'].some(function (flag) {
                return _this2._flags.hasOwnProperty(flag);
            })) {
                description.flags = {};
                for (var i = 0; i < flags.length; ++i) {
                    var flag = flags[i];
                    if (flag === 'empty') {
                        description.flags[flag] = this._flags[flag].describe();
                    } else if (flag === 'default') {
                        if (Ref.isRef(this._flags[flag])) {
                            description.flags[flag] = this._flags[flag].toString();
                        } else if (typeof this._flags[flag] === 'function') {
                            description.flags[flag] = this._flags[flag].description;
                        } else {
                            description.flags[flag] = this._flags[flag];
                        }
                    } else if (flag === 'lazy' || flag === 'label') {
                        // We don't want it in the description
                    } else {
                        description.flags[flag] = this._flags[flag];
                    }
                }
            } else {
                description.flags = this._flags;
            }
        }

        if (this._settings) {
            description.options = Hoek.clone(this._settings);
        }

        if (this._baseType) {
            description.base = this._baseType.describe();
        }

        if (this._description) {
            description.description = this._description;
        }

        if (this._notes.length) {
            description.notes = this._notes;
        }

        if (this._tags.length) {
            description.tags = this._tags;
        }

        if (this._meta.length) {
            description.meta = this._meta;
        }

        if (this._examples.length) {
            description.examples = this._examples;
        }

        if (this._unit) {
            description.unit = this._unit;
        }

        var valids = this._valids.values();
        if (valids.length) {
            description.valids = valids.map(function (v) {

                return Ref.isRef(v) ? v.toString() : v;
            });
        }

        var invalids = this._invalids.values();
        if (invalids.length) {
            description.invalids = invalids.map(function (v) {

                return Ref.isRef(v) ? v.toString() : v;
            });
        }

        description.rules = [];

        for (var _i2 = 0; _i2 < this._tests.length; ++_i2) {
            var validator = this._tests[_i2];
            var item = { name: validator.name };

            if (validator.arg !== void 0) {
                item.arg = Ref.isRef(validator.arg) ? validator.arg.toString() : validator.arg;
            }

            var options = validator.options;
            if (options) {
                if (options.hasRef) {
                    item.arg = {};
                    var keys = (0, _keys2.default)(validator.arg);
                    for (var j = 0; j < keys.length; ++j) {
                        var key = keys[j];
                        var value = validator.arg[key];
                        item.arg[key] = Ref.isRef(value) ? value.toString() : value;
                    }
                }

                if (typeof options.description === 'string') {
                    item.description = options.description;
                } else if (typeof options.description === 'function') {
                    item.description = options.description(item.arg);
                }
            }

            description.rules.push(item);
        }

        if (!description.rules.length) {
            delete description.rules;
        }

        var label = this._getLabel();
        if (label) {
            description.label = label;
        }

        return description;
    };

    _class.prototype.label = function label(name) {

        Hoek.assert(name && typeof name === 'string', 'Label name must be a non-empty string');

        var obj = this.clone();
        obj._flags.label = name;
        return obj;
    };

    _class.prototype._getLabel = function _getLabel(def) {

        return this._flags.label || def;
    };

    return _class;
}();

internals.Any.prototype.isImmutable = true; // Prevents Hoek from deep cloning schema objects

// Aliases

internals.Any.prototype.only = internals.Any.prototype.equal = internals.Any.prototype.valid;
internals.Any.prototype.disallow = internals.Any.prototype.not = internals.Any.prototype.invalid;
internals.Any.prototype.exist = internals.Any.prototype.required;

internals._try = function (fn, args) {

    var err = void 0;
    var result = void 0;

    try {
        result = fn.apply(null, args);
    } catch (e) {
        err = e;
    }

    return {
        value: result,
        error: err
    };
};

internals.concatSettings = function (target, source) {

    // Used to avoid cloning context

    if (!target && !source) {

        return null;
    }

    var obj = {};

    if (target) {
        (0, _assign2.default)(obj, target);
    }

    if (source) {
        var sKeys = (0, _keys2.default)(source);
        for (var i = 0; i < sKeys.length; ++i) {
            var key = sKeys[i];
            if (key !== 'language' || !obj.hasOwnProperty(key)) {

                obj[key] = source[key];
            } else {
                obj[key] = Hoek.applyToDefaults(obj[key], source[key]);
            }
        }
    }

    return obj;
};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(552)('wks');
var uid = __webpack_require__(400);
var Symbol = __webpack_require__(138).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var propTypes = {
  href: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  role: _propTypes.default.string,
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * this is sort of silly but needed for Button
   */
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["componentClass", "disabled", "onKeyDown"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = (0, _extends2.default)({
        pointerEvents: 'none'
      }, props.style);
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      onClick: this.handleClick,
      onKeyDown: (0, _createChainedFunction.default)(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(_react.default.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;
var _default = SafeAnchor;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(202),
    isLength = __webpack_require__(507);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(203),
    eq = __webpack_require__(253),
    isIterateeCall = __webpack_require__(236),
    keysIn = __webpack_require__(255);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useStoreState = useStoreState;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hookUtils = __webpack_require__(234);

var _hookUtils2 = _interopRequireDefault(_hookUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _hookUtils2.default)(useStoreState, 'useStoreState');

/**
 * A hook to subscribe to a store and retrieve data from it
 *
 * Accepts a string, or a function to return value/values from a store
 * If passed a string, it will return the value of that property on the state object
 * If passed a function, it will call that function passing in the store as an argument,
 *   the return value of the function will be returned to your component when the store updates
 * If not passed a stateLookup, it will return the entire store state
 *
 * examples:
 *
 * `const currentOrder = useStoreState(OrderStore, 'current');`
 *
 * ```
 *   const smartcardStatus = useStoreState(
 *     SmartcardStore,
 *     store => store.state.getIn(['smartcard', 'cardStatus'])
 *   );
 * ```
 *
 * @param {BaseStore} store - A store to subscribe to
 * @param {string|function} [stateLookup] - a state key to return, or a function which takes the store and returns the desired state
 */

function useStoreState(store, stateLookup) {
    // use a ref so that we always have the latest version without having to memoize/hoist
    // to avoid state unnecessary updates
    var getState = _react2.default.useRef();
    getState.current = function () {
        if (typeof stateLookup === 'string') {
            return function () {
                return store.get(stateLookup);
            };
        } else if (typeof stateLookup === 'function') {
            return function () {
                return stateLookup(store);
            };
        } else if (stateLookup === undefined) {
            return function () {
                return store.state;
            };
        } else {
            console.error('Unsupported stateLookup ' + stateLookup + ' on ' + store);
            return function () {};
        }
    };
    var initialState = _react2.default.useMemo(function () {
        return getState.current();
    }, []);

    var _React$useState = _react2.default.useState(initialState),
        internalState = _React$useState[0],
        setInternalState = _React$useState[1];

    // keep internal state in sync with store
    // memoize the listener, so we can unsubscribe


    var listener = _react2.default.useCallback(function () {
        return setInternalState(getState.current());
    }, []);

    // Manage store subscription
    _react2.default.useEffect(function () {
        store.addChangeListener(listener);
        return function () {
            return store.removeChangeListener(listener);
        };
    }, [listener, store]);

    return internalState;
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(119);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _trim = __webpack_require__(521);

var _trim2 = _interopRequireDefault(_trim);

var _rtrim = __webpack_require__(1503);

var _rtrim2 = _interopRequireDefault(_rtrim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var assetVersion = '';

exports.default = {
    set assetVersion(url) {
        assetVersion = (0, _rtrim2.default)(url, ['/']);
    },

    get assetVersion() {
        return assetVersion;
    },

    assetUrl: function assetUrl(filename) {
        var stripped = (0, _trim2.default)(filename, ['/']);
        return [assetVersion, stripped].join('/');
    }
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(48);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(10);
var core = __webpack_require__(130);
var fails = __webpack_require__(40);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(131);
var IObject = __webpack_require__(293);
var toObject = __webpack_require__(73);
var toLength = __webpack_require__(63);
var asc = __webpack_require__(483);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(250),
    getRawTag = __webpack_require__(1426),
    objectToString = __webpack_require__(1427);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Hoek = __webpack_require__(96);

// Declare internals

var internals = {};

exports.create = function (key, options) {

    Hoek.assert(typeof key === 'string', 'Invalid reference key:', key);

    var settings = Hoek.clone(options); // options can be reused and modified

    var ref = function ref(value, validationOptions) {

        return Hoek.reach(ref.isContext ? validationOptions.context : value, ref.key, settings);
    };

    ref.isContext = key[0] === (settings && settings.contextPrefix || '$');
    ref.key = ref.isContext ? key.slice(1) : key;
    ref.path = ref.key.split(settings && settings.separator || '.');
    ref.depth = ref.path.length;
    ref.root = ref.path[0];
    ref.isJoi = true;

    ref.toString = function () {

        return (ref.isContext ? 'context:' : 'ref:') + ref.key;
    };

    return ref;
};

exports.isRef = function (ref) {

    return typeof ref === 'function' && ref.isJoi;
};

exports.push = function (array, ref) {

    if (exports.isRef(ref) && !ref.isContext) {

        array.push(ref.root);
    }
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(193)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _Immutable = __webpack_require__(54);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _FareOnlySearchPreferences = __webpack_require__(824);

var _FareOnlySearchPreferences2 = _interopRequireDefault(_FareOnlySearchPreferences);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _SearchUrls = __webpack_require__(97);

var _SearchMixin = __webpack_require__(538);

var _SearchMixin2 = _interopRequireDefault(_SearchMixin);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @note import deserialize as deserialize - workaround an issue with the unit tests & rewire
function _getDefaultOutboundDateTime(smartcard) {
    var offset = smartcard ? 'minSmartcardOffset' : 'minTodOffset';
    var todDuration = _TrainTime2.default.duration(_config2.default.get(offset));
    var outbound = (0, _TrainTime2.default)().add(todDuration);
    var roundedUp = Math.ceil(outbound.minute() / 15) * 15;

    return outbound.clone().minute(roundedUp).second(0);
}

function _getDefaultReturnDateTime(outboundDateTime) {
    var roundedUp = Math.ceil(outboundDateTime.minute() / 15) * 15;
    return outboundDateTime.add(2, 'hours').minute(roundedUp).second(0);
}

var defaults = {
    id: null,
    origin: new _Station2.default(),
    destination: new _Station2.default(),
    via: new _Station2.default(),
    avoid: new _Station2.default(),
    ticketType: _AppConstants.TicketTypes.SINGLE,
    outboundDateTime: new _Timeband2.default({ datetime: _getDefaultOutboundDateTime() }),
    returnDateTime: new _Timeband2.default({ datetime: _getDefaultReturnDateTime(_getDefaultOutboundDateTime()) }),
    adults: 1,
    children: 0,
    numJourneys: _AppConstants.ServicesPerLayout[_config2.default.get('journeyPlannerDefaultLayout')],
    railcards: new _immutable.List(),
    submitted: false,
    smartcard: false,
    groupSave: false,
    tocSpecific: false,
    showCheapest: _config2.default.get('journeyPlannerDefaultCheapestSearch'),
    targetLayout: _config2.default.get('journeyPlannerDefaultLayout'),
    realTime: false,
    departNow: false,
    searchPreferences: new _FareOnlySearchPreferences2.default(),
    showAdditionalRoutes: false,
    promoCode: new _PromoCode2.default(),
    orderId: null,
    isAmending: false,
    email: null
};

var Search = function (_record) {
    (0, _inherits3.default)(Search, _record);

    function Search() {
        (0, _classCallCheck3.default)(this, Search);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Search.prototype.serialize = function serialize() {
        var params = (0, _SearchUrls.serialize)({
            origin: _SearchUrls.serializers.station,
            destination: _SearchUrls.serializers.station,
            outboundDateTime: _SearchUrls.serializers.timeBand,
            returnDateTime: _SearchUrls.serializers.timeBand,
            railcards: _SearchUrls.serializers.railcards,
            adults: _SearchUrls.serializers.identity,
            children: _SearchUrls.serializers.identity,
            numJourneys: _SearchUrls.serializers.identity,
            targetLayout: _SearchUrls.serializers.identity,
            promoCode: _SearchUrls.serializers.promoCode,
            email: _SearchUrls.serializers.identity
        }, this);

        var querySchema = {
            via: _SearchUrls.serializers.station,
            avoid: _SearchUrls.serializers.station,
            tocSpecific: _SearchUrls.serializers.boolean,
            showCheapest: _SearchUrls.serializers.boolean,
            realTime: _SearchUrls.serializers.boolean,
            departNow: _SearchUrls.serializers.boolean,
            searchPreferences: function searchPreferences(preferences) {
                return preferences.toString();
            },
            showAdditionalRoutes: _SearchUrls.serializers.boolean,
            promoCode: _SearchUrls.serializers.promoCode,
            email: _SearchUrls.serializers.identity
        };

        var query = (0, _SearchUrls.serialize)(querySchema, this);

        return {
            params: params,
            query: query
        };
    };

    Search.prototype.toFareOnlyJSON = function toFareOnlyJSON() {
        var _this2 = this;

        return (0, _SearchUrls.serialize)({
            origin: function origin(station) {
                return station.nlc;
            },
            destination: function destination(station) {
                return station.nlc;
            },
            via: _SearchUrls.serializers.station,
            avoid: _SearchUrls.serializers.station,
            outward: function outward() {
                return _SearchUrls.serializers.date(_this2.outboundDateTime.datetime);
            },
            return: function _return() {
                return _SearchUrls.serializers.date(_this2.returnDateTime.datetime);
            },
            adults: _SearchUrls.serializers.identity,
            children: _SearchUrls.serializers.identity,
            searchPreferences: function searchPreferences(_searchPreferences) {
                return _searchPreferences.toJSON();
            },
            promoCode: function promoCode(_promoCode) {
                return _promoCode ? _promoCode.promoCode : null;
            },
            smartCard: function smartCard() {
                return _SearchUrls.serializers.identity(_this2.smartcard);
            },
            railcards: function railcards() {
                return _SearchUrls.serializers.railcardCodes(_this2.railcards);
            }
        }, this);
    };

    Search.prototype.setTargetLayout = function setTargetLayout(layout) {
        var numJourneys = _AppConstants.ServicesPerLayout[layout];
        return this.set('targetLayout', layout).set('numJourneys', numJourneys);
    };

    Search.prototype.getDefaultOutboundDateTime = function getDefaultOutboundDateTime() {
        return _getDefaultOutboundDateTime(this.smartcard);
    };

    Search.prototype.getDefaultReturnDateTime = function getDefaultReturnDateTime() {
        return _getDefaultReturnDateTime(this.getDefaultOutboundDateTime());
    };

    Search.prototype.setTicketType = function setTicketType(value) {
        return this.set('ticketType', value);
    };

    Search.prototype.getTimebandForDirection = function getTimebandForDirection(direction) {
        return direction === _AppConstants.JourneyDirections.INWARD ? this.returnDateTime : this.outboundDateTime;
    };

    Search.prototype.validateDatesBeforeMax = function validateDatesBeforeMax() {
        var beforeMax = function beforeMax(date) {
            return (0, _TrainTime2.default)().add(_config2.default.get('maxOutboundDays'), 'days').isSameOrAfter(date);
        };

        if (this.isSingle() || this.isOpenReturn()) {
            return beforeMax(this.getOutboundDateTime());
        } else {
            return beforeMax(this.getOutboundDateTime()) && beforeMax(this.getReturnDateTime());
        }
    };

    Search.prototype.validateDepartBeforeArrive = function validateDepartBeforeArrive() {
        if (this.isReturn()) {
            return this.getReturnDateTime().isAfter(this.getOutboundDateTime());
        } else {
            return true;
        }
    };

    Search.prototype.validateDatesComplete = function validateDatesComplete() {
        if (this.isSingle() || this.isOpenReturn()) {
            return this.getOutboundDateTime().isValid();
        } else {
            if (!this.getOutboundDateTime() || !this.getReturnDateTime()) {
                return false;
            }
            return this.getOutboundDateTime().isValid() && this.getReturnDateTime().isValid();
        }
    };

    Search.prototype.validateDatesInFuture = function validateDatesInFuture() {
        var isTransPennineRover = this.email && this.origin && this.origin.nlc === 'Z031' && this.destination && this.destination.nlc === 'Z032';

        if (isTransPennineRover) {
            // In order to find TransPennine Rover journeys the the time is fixed to 11:30am
            // so it allow for searches to be made in the past
            return true;
        }

        if (this.isSingle() || this.isOpenReturn()) {
            return this.departNow || this.getOutboundDateTime().isAfter();
        } else {
            return (this.departNow || this.getOutboundDateTime().isAfter()) && this.getReturnDateTime().isAfter();
        }
    };

    Search.prototype.validateSmartcardPeriodReturn = function validateSmartcardPeriodReturn() {
        if (this.smartcard && this.isReturn()) {
            var outboundStart = this.getOutboundDateTime().clone().startOf('day');
            var returnStart = this.getReturnDateTime().clone().startOf('day');
            return outboundStart.isSame(returnStart);
        } else {
            return true;
        }
    };

    Search.prototype.validateAtLeastOnePassenger = function validateAtLeastOnePassenger() {
        return this.adults + this.children >= 1;
    };

    Search.prototype.validateLessThanNinePassengers = function validateLessThanNinePassengers() {
        return this.adults + this.children <= 9;
    };

    Search.prototype.validateRailcardsQuantity = function validateRailcardsQuantity() {
        var passengers = this.adults + this.children;
        var railcards = (0, _Immutable.sum)(this.railcards, 'quantity');
        return railcards <= passengers;
    };

    Search.prototype.getTotalPassengercount = function getTotalPassengercount() {
        return this.adults + this.children;
    };

    Search.prototype.isValid = function isValid() {
        return this.getValidationErrors().isEmpty();
    };

    Search.prototype.hasPromoCode = function hasPromoCode() {
        return !!this.getPromoCode();
    };

    Search.prototype.getPromoCode = function getPromoCode() {
        return this.promoCode && this.promoCode.promoCode;
    };

    Search.prototype.getValidationErrors = function getValidationErrors() {
        var _this3 = this;

        var tests = (0, _immutable.Set)(['validateStationsComplete', 'validateStationsNotEqual', 'validateDatesComplete', 'validateDepartBeforeArrive', 'validateAtLeastOnePassenger', 'validateLessThanNinePassengers', 'validateRailcardsQuantity', 'validateSmartcardPeriodReturn', 'validateDatesBeforeMax']);

        return tests.filterNot(function (test) {
            return _this3[test]();
        });
    };

    Search.prototype.refreshDates = function refreshDates(smartcard) {
        var currentOutwardTime = this.getOutboundDateTime();
        if (smartcard && smartcard.isAwaitingProduct()) {
            var minOutwardTime = (0, _TrainTime2.default)().addWorkingDays(_config2.default.get('minAwaitingSmartcardProductDays')).hour(currentOutwardTime.hour()).minute(currentOutwardTime.minute());
            if (minOutwardTime.isAfter(currentOutwardTime)) {
                return this.setOutboundDateTime(minOutwardTime);
            }
        }
        if ((0, _TrainTime2.default)().isAfter(currentOutwardTime) || (0, _TrainTime2.default)().isAfter(this.getReturnDateTime())) {
            return this.setOutboundDateTime(this.getDefaultOutboundDateTime()).setReturnDateTime(this.getDefaultReturnDateTime());
        }
        if (currentOutwardTime.isAfter(this.getReturnDateTime())) {
            return this.setReturnDateTime(_getDefaultReturnDateTime(currentOutwardTime));
        }

        return this;
    };

    Search.prototype.refreshAmending = function refreshAmending() {
        return this.set('isAmending', false);
    };

    Search.prototype.slideAfterChange = function slideAfterChange() {
        if (this.getOutboundDateTime().isAfter(this.getReturnDateTime())) {
            return this.setReturnDateTime(_getDefaultReturnDateTime(this.getOutboundDateTime()));
        } else if (this.getOutboundDateTime().isBefore((0, _TrainTime2.default)())) {
            return this.setOutboundDateTime(_getDefaultOutboundDateTime(this.smartcard));
        }

        return this;
    };

    Search.prototype.setOutwardTimeNow = function setOutwardTimeNow() {
        return this.setIn(['outboundDateTime', 'arriveDepart'], 'Depart').setIn(['outboundDateTime', 'datetime'], (0, _TrainTime2.default)().add(1, 'minutes'));
    };

    Search.prototype.earlier = function earlier(direction, services) {
        var dateTimeKey = direction === _AppConstants.JourneyDirections.OUTWARD ? 'outboundDateTime' : 'returnDateTime';

        var updatedSearch = void 0;
        if (services.size > 0) {
            var updatedDateTime = services.first().getArrivalDateTime(false).add(1, 'minute');

            updatedSearch = this.setIn([dateTimeKey, 'arriveDepart'], 'Arrive').setIn([dateTimeKey, 'datetime'], updatedDateTime);
        } else {
            updatedSearch = this.set(dateTimeKey, this.get(dateTimeKey).getEarlier());
        }

        if (direction === _AppConstants.JourneyDirections.INWARD && !updatedSearch.returnDateTime.getEnd().isAfter(updatedSearch.outboundDateTime.getEnd())) {
            updatedSearch = updatedSearch.set('outboundDateTime', updatedSearch.get(dateTimeKey).getEarlier());
        }

        return updatedSearch;
    };

    Search.prototype.later = function later(direction, services) {
        var dateTimeKey = direction === _AppConstants.JourneyDirections.OUTWARD ? 'outboundDateTime' : 'returnDateTime';

        if (services.size > 0) {
            return this.setIn([dateTimeKey, 'arriveDepart'], 'Depart').setIn([dateTimeKey, 'datetime'], services.last().getDepartureDateTime(false));
        } else {
            return this.set(dateTimeKey, this.get(dateTimeKey).getLater());
        }
    };

    Search.prototype.isEarlierSearchDisabled = function isEarlierSearchDisabled(_ref) {
        var direction = _ref.direction,
            services = _ref.services,
            trip = _ref.trip;

        try {
            var search = trip.search;

            var dateTimeKey = direction === _AppConstants.JourneyDirections.OUTWARD ? 'outboundDateTime' : 'returnDateTime';

            var _search$dateTimeKey$t = search[dateTimeKey].toRange({ truncateStart: (0, _TrainTime2.default)() }),
                rangeStart = _search$dateTimeKey$t.rangeStart,
                rangeEnd = _search$dateTimeKey$t.rangeEnd;

            return services.size === 1 && (0, _moment2.default)(rangeStart).isBefore((0, _moment2.default)()) && (0, _moment2.default)(rangeEnd).diff((0, _moment2.default)(rangeStart), 'hours') < _Timeband.DEFAULT_WINDOW_LENGTH;
        } catch (error) {
            console.error(error);
            return true;
        }
    };

    Search.prototype.setOrigin = function setOrigin(station) {
        return this.set('origin', station);
    };

    Search.prototype.setPromoCode = function setPromoCode(promo) {
        return this.set('promoCode', promo);
    };

    Search.prototype.setDestination = function setDestination(station) {
        return this.set('destination', station);
    };

    Search.prototype.addReturn = function addReturn() {
        return this.setTicketType(_AppConstants.TicketTypes.RETURN).refreshDates();
    };

    Search.prototype.isSingle = function isSingle() {
        return this.get('ticketType') === _AppConstants.TicketTypes.SINGLE;
    };

    Search.prototype.isReturn = function isReturn() {
        return this.get('ticketType') === _AppConstants.TicketTypes.RETURN;
    };

    Search.prototype.isReturnLondonTravelcard = function isReturnLondonTravelcard() {
        return this.destination.isLondonStation() && this.destination.isTravelcard();
    };

    Search.prototype.isOpenReturn = function isOpenReturn() {
        return this.get('ticketType') === _AppConstants.TicketTypes.OPEN_RETURN;
    };

    Search.prototype.getOutboundDateTime = function getOutboundDateTime() {
        return (0, _result3.default)(this.getIn(['outboundDateTime', 'datetime']), 'clone');
    };

    Search.prototype.setOutboundDateTime = function setOutboundDateTime() {
        var datetime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getDefaultOutboundDateTime();

        return this.setIn(['outboundDateTime', 'datetime'], datetime);
    };

    Search.prototype.getReturnDateTime = function getReturnDateTime() {
        return (0, _result3.default)(this.getIn(['returnDateTime', 'datetime']), 'clone');
    };

    Search.prototype.setReturnDateTime = function setReturnDateTime() {
        var datetime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getDefaultReturnDateTime();

        return this.setIn(['returnDateTime', 'datetime'], datetime);
    };

    Search.prototype.setOutboundDateTimeWindow = function setOutboundDateTimeWindow(hours) {
        return this.setIn(['outboundDateTime', 'windowLength'], hours);
    };

    Search.prototype.setReturnDateTimeWindow = function setReturnDateTimeWindow(hours) {
        return this.setIn(['returnDateTime', 'windowLength'], hours);
    };

    Search.prototype.getMinDate = function getMinDate(direction) {
        return this._isReturnDirection(direction) ? this.getOutboundDateTime() : (0, _TrainTime2.default)();
    };

    Search.prototype.getMaxDate = function getMaxDate(direction) {
        return this._isReturnDirection(direction) && this.smartcard ? this.getOutboundDateTime() : (0, _TrainTime2.default)().add(_config2.default.get('maxOutboundDays'), 'days');
    };

    Search.prototype._isReturnDirection = function _isReturnDirection(direction) {
        return direction === _AppConstants.JourneyDirections.INWARD;
    };

    Search.prototype.setNumberOfJourneys = function setNumberOfJourneys(num) {
        return this.set('numJourneys', num);
    };

    Search.prototype.getRouteOptions = function getRouteOptions() {
        var options = _config2.default.get('journeySelectorOptions');
        var additionalOptions = _config2.default.get('journeySelectorAdditionalOptions');
        if (this.showAdditionalRoutes) {
            return options.concat(additionalOptions);
        }
        return options;
    };

    Search.prototype.matchesRouteOptions = function matchesRouteOptions() {
        var _this4 = this;

        // where options is a List of Lists which contain a pair of CRSs
        // (see journeySelectorOptions in config)
        return this.getRouteOptions().some(function (option) {
            return option.get(0) === _this4.origin.crs && option.get(1) === _this4.destination.crs;
        });
    };

    Search.fromAmendRequest = function fromAmendRequest(amendRequest) {
        var trip = amendRequest.trip,
            fares = amendRequest.fares,
            order = amendRequest.order;
        // get the first fare that is actually a fare, not a
        // plusbus etc.

        var fare = fares.keySeq().toList().filter(function (x) {
            return !x.isPlusBus();
        }).first();
        var adults = amendRequest.getAdults(fare);
        var children = amendRequest.getChildren(fare);
        var railcards = amendRequest.getAllValidRailcards({
            passengers: adults + children
        });
        var outwardJourney = trip.getOutwardJourney();
        var returnJourney = trip.getReturnJourney();

        var outboundDateTime = new _Timeband2.default({
            datetime: outwardJourney.getDepartureTime(),
            windowLength: 8
        });
        var returnDateTime = new _Timeband2.default({
            datetime: returnJourney ? returnJourney.getDepartureTime() : outwardJourney.getArrivalTime(),
            windowLength: 8
        });

        var hasPromoTickets = amendRequest.getAmendedTickets().some(function (ticket) {
            return ticket.hasPromoDiscount();
        });

        return Search.fromJSON((0, _assign2.default)(defaults, {
            outboundDateTime: outboundDateTime,
            returnDateTime: returnDateTime,
            railcards: railcards,
            origin: trip.getFirstOrigin(),
            destination: trip.getDestination(),
            adults: adults,
            children: children,
            ticketType: amendRequest.hasReturnFare() ? _AppConstants.TicketTypes.RETURN : _AppConstants.TicketTypes.SINGLE,
            numJourneys: 8,
            promoCode: hasPromoTickets ? order.getPromoCode() : new _PromoCode2.default(),
            orderId: order.id,
            isAmending: true
        }));
    };

    Search.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Search, json, {
            origin: _LinkMapper.resolve.as(_Station2.default),
            destination: _LinkMapper.resolve.as(_Station2.default),
            via: _LinkMapper.resolve.as(_Station2.default),
            avoid: _LinkMapper.resolve.as(_Station2.default),
            ticketType: _LinkMapper.resolve.with(String),
            outboundDateTime: _LinkMapper.resolve.as(_Timeband2.default),
            returnDateTime: _LinkMapper.resolve.as(_Timeband2.default),
            adults: _LinkMapper.resolve.with(Number),
            numJourneys: _LinkMapper.resolve.with(Number),
            children: _LinkMapper.resolve.with(Number),
            railcards: _LinkMapper.resolveAll.as(_PassengerRailcard2.default),
            submitted: _LinkMapper.resolve.with(Boolean),
            smartcard: _LinkMapper.resolve.with(Boolean),
            tocSpecific: _LinkMapper.resolve.with(Boolean),
            showCheapest: _LinkMapper.resolve.with(Boolean),
            targetLayout: _LinkMapper.resolve.with(String),
            realTime: _LinkMapper.resolve.with(Boolean),
            departNow: _LinkMapper.resolve.with(Boolean),
            searchPreferences: _LinkMapper.resolve.as(_FareOnlySearchPreferences2.default),
            showAdditionalRoutes: _LinkMapper.resolve.with(Boolean),
            promoCode: _LinkMapper.resolve.as(_PromoCode2.default),
            orderId: _LinkMapper.resolve.with(Number),
            email: _LinkMapper.resolve.with(String)
        });
    };

    /**
     * Return a promise that resolves to a new Search, from the url params
     */


    Search.deserialize = function deserialize(params, query) {
        var source = (0, _assign2.default)({}, query, params);
        var schema = {
            origin: _SearchUrls.deserializers.station,
            destination: _SearchUrls.deserializers.station,
            via: _SearchUrls.deserializers.station,
            avoid: _SearchUrls.deserializers.station,
            adults: _SearchUrls.deserializers.int,
            children: _SearchUrls.deserializers.int,
            numJourneys: function numJourneys(value, json, name) {
                if (value) {
                    var _ref2;

                    return _ref2 = {}, _ref2[name] = value, _ref2;
                } else if (json.targetLayout) {
                    var _ref3;

                    return _ref3 = {}, _ref3[name] = _AppConstants.ServicesPerLayout[json.targetLayout], _ref3;
                }
                return _AppConstants.ServicesPerLayout[_config2.default.get('journeyPlannerDefaultLayout')];
            },
            railcards: _SearchUrls.deserializers.railcards,
            outboundDateTime: _SearchUrls.deserializers.timeBand,
            returnDateTime: _SearchUrls.deserializers.timeBand,
            tocSpecific: _SearchUrls.deserializers.boolean,
            showCheapest: _SearchUrls.deserializers.boolean,
            targetLayout: function targetLayout(value, json, name) {
                var _ref5;

                if (value) {
                    var _ref4;

                    return _ref4 = {}, _ref4[name] = value, _ref4;
                }
                return _ref5 = {}, _ref5[name] = _config2.default.get('journeyPlannerDefaultLayout'), _ref5;
            },
            realTime: _SearchUrls.deserializers.boolean,
            departNow: _SearchUrls.deserializers.boolean,
            searchPreferences: function searchPreferences(value, data, name) {
                var _ref6;

                return _ref6 = {}, _ref6[name] = _FareOnlySearchPreferences2.default.fromString(value), _ref6;
            },
            showAdditionalRoutes: _SearchUrls.deserializers.boolean,
            promoCode: _SearchUrls.deserializers.promoCode,
            email: _SearchUrls.deserializers.identity
        };

        return (0, _SearchUrls.deserialize)(schema, source).then(function (deserialized) {
            return new Search(deserialized);
        });
    };

    Search.fromFare = function fromFare(fare) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        return Search.fromFavourite(_Favourite2.default.fromFare(fare), date);
    };

    /**
     * @param {Favourite} favourite
     * @param {trainTime} date
     * @return {Search}
     */


    Search.fromFavourite = function fromFavourite(favourite) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (!date) {
            date = _getDefaultOutboundDateTime();
        }

        var railcards = favourite.getPassengerRailcards();

        //Set to midday so offpeak and anytime are valid
        var outboundDate = date.clone().set({ hour: 12, minute: 0 });
        var ticketMultiplier = favourite.ticketType.ticketMultiplier();

        var search = new Search({
            origin: favourite.origin,
            destination: favourite.destination,
            adults: favourite.adults / ticketMultiplier,
            children: favourite.children / ticketMultiplier,
            ticketType: favourite.isReturn() ? _AppConstants.TicketTypes.RETURN : _AppConstants.TicketTypes.SINGLE,
            railcards: railcards,
            searchPreferences: _FareOnlySearchPreferences2.default.fromFavourite(favourite)
        }).setIn(['outboundDateTime', 'datetime'], outboundDate).refreshDates();

        if (favourite.isReturn()) {
            search = search.setIn(['returnDateTime', 'datetime'], outboundDate.clone().add(30, 'm')).refreshDates();
        }

        return search;
    };

    Search.fromReorderable = function fromReorderable(reorderable) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (reorderable instanceof _Fare2.default) {
            return Search.fromFare(reorderable, date);
        } else if (reorderable instanceof _Favourite2.default) {
            return Search.fromFavourite(reorderable, date);
        }

        return null;
    };

    Search.prototype.getJsonForJourneyNotification = function getJsonForJourneyNotification() {
        var json = {
            origin: this.origin.nlc,
            destination: this.destination.nlc,
            startDate: this.getOutboundDateTime().format('YYYY-MM-DD HH:mm:ss'),
            adult: this.adults > 0,
            child: this.children > 0
        };
        return this.isReturn() ? (0, _assign2.default)({}, json, {
            endDate: this.getReturnDateTime().format('YYYY-MM-DD HH:mm:ss')
        }) : json;
    };

    return Search;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(Search.prototype, _SearchMixin2.default);

exports.default = Search;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _desc, _value, _obj;

var _Trip = __webpack_require__(199);

var _Trip2 = _interopRequireDefault(_Trip);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _LinkingSmartcardsStore = __webpack_require__(348);

var _LinkingSmartcardsStore2 = _interopRequireDefault(_LinkingSmartcardsStore);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _OrderService = __webpack_require__(346);

var _OrderService2 = _interopRequireDefault(_OrderService);

var _OrderHistoryService = __webpack_require__(835);

var _OrderHistoryService2 = _interopRequireDefault(_OrderHistoryService);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _StationService = __webpack_require__(341);

var _StationService2 = _interopRequireDefault(_StationService);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _TokenActions = __webpack_require__(446);

var _TokenActions2 = _interopRequireDefault(_TokenActions);

var _Order3 = __webpack_require__(1914);

var _Loading = __webpack_require__(546);

var _DisruptionAlertActions = __webpack_require__(340);

var _DisruptionAlertActions2 = _interopRequireDefault(_DisruptionAlertActions);

var _RewardPointsActions = __webpack_require__(1146);

var _RewardPointsActions2 = _interopRequireDefault(_RewardPointsActions);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _PassengerAssistActions = __webpack_require__(334);

var _PassengerAssistActions2 = _interopRequireDefault(_PassengerAssistActions);

var _Cookie = __webpack_require__(258);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var withOrderLoadingActions = (0, _Loading.createLoadingDecoratorFor)(_AppConstants.LoadingTypes.ORDER);

var actions = (_obj = {
    updateAddress: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(order) {
            var updatedOrder;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _OrderService2.default.updateFulfilment(order);

                        case 2:
                            updatedOrder = _context.sent;


                            _AppDispatcher2.default.dispatch({
                                order: updatedOrder,
                                actionType: _AppConstants.ActionTypes.ORDER_UPDATED
                            });

                            return _context.abrupt('return', updatedOrder);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function updateAddress(_x) {
            return _ref.apply(this, arguments);
        }

        return updateAddress;
    }(),
    checkBasket: function checkBasket() {
        // returns TRUE only if @checkOrderExpiry allows this action to run
        return true;
    },
    create: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
            var trip = _ref2.trip,
                order = _ref2.order;

            var channel, currentTrip, updatedTrip, _ref4, createdOrder, deviceToken, mostRecentAddedTrip;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!order) {
                                order = new _Order2.default();
                            }

                            this.handleOrderLoading(true);

                            _AppDispatcher2.default.dispatch({
                                trip: trip,
                                actionType: _AppConstants.ActionTypes.ORDER_STARTED
                            });

                            _context2.prev = 3;
                            channel = _InAppStore2.default.isInApp() ? _InAppStore2.default.getChannel() : 'web';
                            currentTrip = _CurrentTripStore2.default.get();
                            updatedTrip = trip;

                            /*
                                To Do: Remove this when we have a proper way to mutations to the trip in the
                                middle of adding to the basket.
                                 This stems from the fact that we update the bikes count in the current trip
                                after the action to create the order has been created with a trip with 0 bikes.
                            */

                            if (currentTrip.bikes > 0) {
                                updatedTrip = updatedTrip.set('bikes', currentTrip.bikes);
                            }

                            if (currentTrip.hasSeatingPreferences()) {
                                updatedTrip = updatedTrip.setSeatingPreferences(currentTrip.reservationPreferences);
                            }

                            _context2.next = 11;
                            return _OrderService2.default.create(order, updatedTrip, channel);

                        case 11:
                            _ref4 = _context2.sent;
                            createdOrder = _ref4.order;
                            deviceToken = _ref4.deviceToken;


                            _AppDispatcher2.default.dispatch({
                                order: createdOrder,
                                trip: trip.set('orderTripId', createdOrder.trips.first().id),
                                actionType: _AppConstants.ActionTypes.ORDER_CREATED
                            });

                            _TokenActions2.default.updateDevice(deviceToken);

                            if (_FeatureFlagStore2.default.get('enablePassengerAssist')) {
                                mostRecentAddedTrip = createdOrder.trips.last();

                                _PassengerAssistActions2.default.addOrderTripIdToMostRecentPassengerAssistRequest(mostRecentAddedTrip.id);
                            }

                            _NotificationActions2.default.showNotification('notifications.basket.itemAdded');

                            return _context2.abrupt('return', createdOrder);

                        case 21:
                            _context2.prev = 21;
                            _context2.t0 = _context2['catch'](3);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ORDER_FAILED,
                                error: _context2.t0
                            });
                            throw _context2.t0;

                        case 25:
                            _context2.prev = 25;

                            this.handleOrderLoading(false);
                            return _context2.finish(25);

                        case 28:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[3, 21, 25, 28]]);
        }));

        function create(_x2) {
            return _ref3.apply(this, arguments);
        }

        return create;
    }(),
    addTrip: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(order, trip) {
            var updatedOrder, currentTrip, updatedTrip, knownIds, orderTrip, mostRecentAddedTrip;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            updatedOrder = order;


                            this.handleOrderLoading(true);

                            _context3.prev = 2;
                            currentTrip = _CurrentTripStore2.default.get();
                            updatedTrip = trip;

                            /*
                                To Do: Remove this when we have a proper way to mutations to the trip in the
                                middle of adding to the basket.
                                 This stems from the fact that we update the bikes count in the current trip
                                after the action to create the order has been created with a trip with 0 bikes.
                            */

                            if (currentTrip.bikes > 0) {
                                updatedTrip = updatedTrip.set('bikes', currentTrip.bikes);
                            }

                            if (currentTrip.hasSeatingPreferences()) {
                                updatedTrip = updatedTrip.setSeatingPreferences(currentTrip.reservationPreferences);
                            }

                            _context3.next = 9;
                            return _OrderService2.default.addTrip(order, updatedTrip);

                        case 9:
                            updatedOrder = _context3.sent;
                            _context3.next = 22;
                            break;

                        case 12:
                            _context3.prev = 12;
                            _context3.t0 = _context3['catch'](2);

                            if (!_InAppStore2.default.isInApp()) {
                                _context3.next = 21;
                                break;
                            }

                            // InApp crashes when user adds another trip to a non-empty basket.
                            // It does not properly clears the basket after logging in/out or when
                            // user abandoned the basket that results in invalid X-Customer-Device token.
                            // In that case catch the error, clear the basket and create a new order
                            // with the currently selected trip.
                            this.clearBasket(order);
                            _context3.next = 18;
                            return this.create({ trip: trip });

                        case 18:
                            updatedOrder = _context3.sent;
                            _context3.next = 22;
                            break;

                        case 21:
                            throw _context3.t0;

                        case 22:
                            _context3.prev = 22;

                            this.handleOrderLoading(false);
                            return _context3.finish(22);

                        case 25:
                            knownIds = order.getTripIds();
                            orderTrip = updatedOrder.trips.find(function (t) {
                                return !knownIds.includes(t.getCleanId());
                            });


                            _AppDispatcher2.default.dispatch({
                                orderTrip: orderTrip,
                                order: updatedOrder,
                                trip: trip.set('orderTripId', orderTrip.id),
                                actionType: _AppConstants.ActionTypes.ORDER_TRIP_CREATED
                            });

                            if (_FeatureFlagStore2.default.get('enablePassengerAssist')) {
                                mostRecentAddedTrip = updatedOrder.trips.last();

                                _PassengerAssistActions2.default.addOrderTripIdToMostRecentPassengerAssistRequest(mostRecentAddedTrip.id);
                            }

                            _NotificationActions2.default.showNotification('notifications.basket.itemAdded');

                            return _context3.abrupt('return', updatedOrder);

                        case 31:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[2, 12, 22, 25]]);
        }));

        function addTrip(_x3, _x4) {
            return _ref5.apply(this, arguments);
        }

        return addTrip;
    }(),
    deleteTrip: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(order, orderTrip) {
            var tripDeletedOrder;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _OrderService2.default.deleteTrip(orderTrip);

                        case 2:
                            _context4.next = 4;
                            return _OrderService2.default.get(order.id);

                        case 4:
                            tripDeletedOrder = _context4.sent;

                            _AppDispatcher2.default.dispatch({
                                order: tripDeletedOrder,
                                orderTrip: orderTrip,
                                actionType: _AppConstants.ActionTypes.ORDER_TRIP_DELETED
                            });

                            _NotificationActions2.default.showNotification('notifications.basket.itemDeleted');
                            return _context4.abrupt('return', tripDeletedOrder);

                        case 8:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function deleteTrip(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return deleteTrip;
    }(),
    updateTrip: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(order, orderTrip, trip) {
            var tripDeletedOrder, tripAddedOrder;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            this.handleOrderLoading(true);

                            _context5.prev = 1;
                            _context5.next = 4;
                            return _OrderService2.default.deleteTrip(orderTrip);

                        case 4:
                            _context5.next = 6;
                            return _OrderService2.default.get(order.id);

                        case 6:
                            tripDeletedOrder = _context5.sent;
                            _context5.next = 9;
                            return this.addTrip(tripDeletedOrder, trip);

                        case 9:
                            tripAddedOrder = _context5.sent;
                            return _context5.abrupt('return', tripAddedOrder);

                        case 13:
                            _context5.prev = 13;
                            _context5.t0 = _context5['catch'](1);
                            throw _context5.t0;

                        case 16:
                            _context5.prev = 16;

                            this.handleOrderLoading(false);
                            return _context5.finish(16);

                        case 19:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[1, 13, 16, 19]]);
        }));

        function updateTrip(_x7, _x8, _x9) {
            return _ref7.apply(this, arguments);
        }

        return updateTrip;
    }(),
    checkTrip: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref8) {
            var trip = _ref8.trip,
                smartcard = _ref8.smartcard;
            var order, isSmartcardTrip, isSmartcardOrder, user;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            order = _OrderStore2.default.getCurrent();
                            isSmartcardTrip = trip.isSmartcard();
                            isSmartcardOrder = order.isSmartcard();

                            if (!(order.trips.size && (isSmartcardTrip || isSmartcardOrder))) {
                                _context6.next = 6;
                                break;
                            }

                            _ModalActions2.default.open(_AppConstants.GlobalModals.BASKET);
                            return _context6.abrupt('return', false);

                        case 6:
                            if (!isSmartcardTrip) {
                                _context6.next = 14;
                                break;
                            }

                            user = _UserStore2.default.getCurrent();

                            if (user.isLoggedIn()) {
                                _context6.next = 11;
                                break;
                            }

                            _ModalActions2.default.open(_AppConstants.GlobalModals.LOGIN);
                            return _context6.abrupt('return', false);

                        case 11:
                            if (!(!smartcard || !smartcard.canLoadProduct())) {
                                _context6.next = 14;
                                break;
                            }

                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'booking.error.noSmartcard' });
                            return _context6.abrupt('return', false);

                        case 14:
                            return _context6.abrupt('return', { trip: trip });

                        case 15:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function checkTrip(_x10) {
            return _ref9.apply(this, arguments);
        }

        return checkTrip;
    }(),
    createOrUpdate: function createOrUpdate(_ref10) {
        var order = _ref10.order,
            trip = _ref10.trip;


        if (!order) {
            order = _OrderStore2.default.getCurrent();
        }

        if (!order.id) {
            return this.create({ order: order, trip: trip });
        }

        return this.addTrip(order, trip);
    },
    changeTripPassengers: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(order, trip) {
            var orderTrip, rrFare, passengers, updatedOrder;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (order.id) {
                                _context7.next = 2;
                                break;
                            }

                            return _context7.abrupt('return', false);

                        case 2:
                            orderTrip = order.getTrip(trip.orderTripId);

                            if (orderTrip) {
                                _context7.next = 5;
                                break;
                            }

                            return _context7.abrupt('return', false);

                        case 5:
                            rrFare = orderTrip.getRoversRangersFare();
                            passengers = trip.passengers.setTicketIds(rrFare.tickets);

                            if (passengers.isComplete()) {
                                _context7.next = 10;
                                break;
                            }

                            this.deleteTrip(order, orderTrip);
                            return _context7.abrupt('return', false);

                        case 10:
                            _context7.prev = 10;

                            if (!rrFare.ticketType.isFamilyRanger()) {
                                _context7.next = 13;
                                break;
                            }

                            return _context7.abrupt('return', this.updateTrip(order, orderTrip, trip));

                        case 13:
                            _context7.next = 15;
                            return _OrderService2.default.updatePassengers(order, orderTrip, passengers);

                        case 15:
                            _context7.next = 17;
                            return _OrderService2.default.get(order.id);

                        case 17:
                            updatedOrder = _context7.sent;


                            _AppDispatcher2.default.dispatch({
                                order: updatedOrder,
                                actionType: _AppConstants.ActionTypes.ORDER_TRIP_UPDATED
                            });

                            return _context7.abrupt('return', updatedOrder);

                        case 22:
                            _context7.prev = 22;
                            _context7.t0 = _context7['catch'](10);

                            this.deleteTrip(order, orderTrip);
                            return _context7.abrupt('return', false);

                        case 26:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[10, 22]]);
        }));

        function changeTripPassengers(_x11, _x12) {
            return _ref11.apply(this, arguments);
        }

        return changeTripPassengers;
    }(),
    createOrderForPreRegisteredSmartcard: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(_ref12) {
            var trip = _ref12.trip;
            var order, deliveryOptions, smartcardOption;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return this.create({ trip: trip });

                        case 2:
                            order = _context8.sent;
                            _context8.next = 5;
                            return this.loadDeliveryOptions(order);

                        case 5:
                            deliveryOptions = _context8.sent;
                            smartcardOption = deliveryOptions.find(function (option) {
                                return option.isSmartcard();
                            });
                            _context8.next = 9;
                            return this.updateFulfilmentMethod(smartcardOption);

                        case 9:
                            return _context8.abrupt('return', this.update());

                        case 10:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function createOrderForPreRegisteredSmartcard(_x13) {
            return _ref13.apply(this, arguments);
        }

        return createOrderForPreRegisteredSmartcard;
    }(),
    addOrUpdatePlusBus: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(plusBus, trip, order) {
            var tripWithPlusBus, orderTrip, updatedOrder;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            if (!order) {
                                order = _OrderStore2.default.getCurrent();
                            }

                            tripWithPlusBus = trip.setPlusBus(plusBus);

                            if (order.id) {
                                _context9.next = 4;
                                break;
                            }

                            return _context9.abrupt('return', this.create({ order: order, trip: tripWithPlusBus }));

                        case 4:
                            orderTrip = order.getTrip(trip.orderTripId);

                            if (orderTrip) {
                                _context9.next = 7;
                                break;
                            }

                            return _context9.abrupt('return', this.addTrip(order, tripWithPlusBus));

                        case 7:
                            if (!(plusBus !== trip.getPlusBus())) {
                                _context9.next = 12;
                                break;
                            }

                            _context9.next = 10;
                            return _OrderService2.default.updatePlusBus(order, orderTrip, tripWithPlusBus);

                        case 10:
                            updatedOrder = _context9.sent;


                            _AppDispatcher2.default.dispatch({
                                orderTrip: updatedOrder.getTrip(orderTrip.id),
                                order: updatedOrder,
                                trip: tripWithPlusBus,
                                actionType: _AppConstants.ActionTypes.ORDER_PLUSBUS_UPDATED
                            });

                        case 12:
                            return _context9.abrupt('return', order);

                        case 13:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function addOrUpdatePlusBus(_x14, _x15, _x16) {
            return _ref14.apply(this, arguments);
        }

        return addOrUpdatePlusBus;
    }(),
    update: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                order = _ref16.order;

            var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref17$disableAddress = _ref17.disableAddress,
                disableAddress = _ref17$disableAddress === undefined ? false : _ref17$disableAddress;

            var linkedSmartcards, updatedOrder, user, storedAddress;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            if (!order) {
                                order = _OrderStore2.default.getCurrent();
                            }

                            if (!(!order || !(0, _get3.default)(order, 'delivery.fulfilmentMethod'))) {
                                _context10.next = 3;
                                break;
                            }

                            return _context10.abrupt('return', null);

                        case 3:

                            this.handleOrderLoading(true);

                            _context10.prev = 4;
                            linkedSmartcards = _LinkingSmartcardsStore2.default.getAllLinkedSmartcards();
                            _context10.next = 8;
                            return _OrderService2.default.updateFulfilment(order, { disableAddress: disableAddress, linkedSmartcards: linkedSmartcards });

                        case 8:
                            updatedOrder = _context10.sent;


                            if (_FeatureFlagStore2.default.get('enableRewardPoints') && !updatedOrder.isPaid()) {
                                _RewardPointsActions2.default.registerTicketsForRewardPoints(updatedOrder);
                            }

                            user = _UserStore2.default.getCurrent();
                            storedAddress = order.delivery.storedAddress;

                            if (user.isLoggedIn() && order.delivery.isPostalDelivery() && storedAddress) {
                                this.updatePostalFulfilmentStoredAddress(storedAddress);
                            }

                            _AppDispatcher2.default.dispatch({
                                order: updatedOrder,
                                actionType: _AppConstants.ActionTypes.ORDER_UPDATED
                            });

                            return _context10.abrupt('return', updatedOrder);

                        case 17:
                            _context10.prev = 17;
                            _context10.t0 = _context10['catch'](4);
                            throw _context10.t0;

                        case 20:
                            _context10.prev = 20;

                            this.handleOrderLoading(false);
                            return _context10.finish(20);

                        case 23:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this, [[4, 17, 20, 23]]);
        }));

        function update() {
            return _ref15.apply(this, arguments);
        }

        return update;
    }(),
    clearBasket: function clearBasket(order) {
        if (order) {
            /*
             * Fire and forget delete order, so backend can cleanup and release
             * tickets with NRS (CORE-1793)
             */
            _OrderService2.default.delete(order).catch(function (e) {
                console.warn('delete order failed', e);
            });
        }

        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.BASKET_CLEARED
        });

        _NotificationActions2.default.showNotification('notifications.basket.cleared');

        _DisruptionAlertActions2.default.resetTimetableAlerts();
    },
    handleOrderLoading: function handleOrderLoading() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _AppDispatcher2.default.dispatch({
            isLoading: value,
            actionType: _AppConstants.ActionTypes.ORDER_LOADING
        });
    },
    handleOrderLoadingDeliveryOptions: function handleOrderLoadingDeliveryOptions() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _AppDispatcher2.default.dispatch({
            isLoadingDeliveryOptions: value,
            actionType: _AppConstants.ActionTypes.ORDER_DELIVERY_OPTIONS_LOADING
        });
    },
    updateFulfilment: function updateFulfilment(path, value) {
        _AppDispatcher2.default.dispatch({
            path: path,
            value: value,
            actionType: _AppConstants.ActionTypes.FULFILMENT_UPDATED
        });
    },
    deleteSTicketPhoto: function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(userId) {
            var errorMessage;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.prev = 0;
                            _context11.next = 3;
                            return _OrderService2.default.deleteSTicketPhoto(userId);

                        case 3:
                            return _context11.abrupt('return', true);

                        case 6:
                            _context11.prev = 6;
                            _context11.t0 = _context11['catch'](0);
                            errorMessage = (0, _get3.default)(_context11.t0, 'body.errors.message');

                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: errorMessage });
                            return _context11.abrupt('return', false);

                        case 11:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this, [[0, 6]]);
        }));

        function deleteSTicketPhoto(_x21) {
            return _ref18.apply(this, arguments);
        }

        return deleteSTicketPhoto;
    }(),
    updateSTicketPhoto: function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(userId, photo) {
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return _OrderService2.default.updateSTicketPhoto(userId, photo);

                        case 2:
                            return _context12.abrupt('return', _context12.sent);

                        case 3:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function updateSTicketPhoto(_x22, _x23) {
            return _ref19.apply(this, arguments);
        }

        return updateSTicketPhoto;
    }(),
    sendSTicketPhotoChangeRequest: function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(userId, photo) {
            var request;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.next = 2;
                            return _OrderService2.default.sendSTicketPhotoChangeRequest(userId, photo);

                        case 2:
                            request = _context13.sent;


                            _NotificationActions2.default.showNotification('sticket.photo.change.notification');

                            return _context13.abrupt('return', request);

                        case 5:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this);
        }));

        function sendSTicketPhotoChangeRequest(_x24, _x25) {
            return _ref20.apply(this, arguments);
        }

        return sendSTicketPhotoChangeRequest;
    }(),
    getSTicketPhoto: function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(userId) {
            var photoBlob;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.next = 2;
                            return _OrderService2.default.getSTicketPhoto(userId);

                        case 2:
                            photoBlob = _context14.sent;
                            return _context14.abrupt('return', photoBlob);

                        case 4:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this);
        }));

        function getSTicketPhoto(_x26) {
            return _ref21.apply(this, arguments);
        }

        return getSTicketPhoto;
    }(),
    updateFulfilmentMethod: function updateFulfilmentMethod(deliveryOption) {
        _AppDispatcher2.default.dispatch({
            deliveryOption: deliveryOption,
            actionType: _AppConstants.ActionTypes.FULFILMENT_METHOD_UPDATED
        });
    },
    updatePostalFulfilmentStoredAddress: function updatePostalFulfilmentStoredAddress(address) {
        _AppDispatcher2.default.dispatch({
            address: address,
            actionType: _AppConstants.ActionTypes.POSTAL_FULFILMENT_STORED_ADDRESS_UPDATED
        });
    },
    load: function () {
        var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(orderID) {
            var order;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                orderID: orderID,
                                actionType: _AppConstants.ActionTypes.ORDER_LOAD_STARTED
                            });

                            _context15.prev = 1;
                            _context15.next = 4;
                            return _OrderService2.default.get(orderID);

                        case 4:
                            order = _context15.sent;


                            _AppDispatcher2.default.dispatch({
                                order: order,
                                actionType: _AppConstants.ActionTypes.ORDER_LOADED
                            });
                            return _context15.abrupt('return', order);

                        case 9:
                            _context15.prev = 9;
                            _context15.t0 = _context15['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                orderID: orderID, error: _context15.t0,
                                actionType: _AppConstants.ActionTypes.ORDER_LOAD_FAILED
                            });
                            throw _context15.t0;

                        case 13:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this, [[1, 9]]);
        }));

        function load(_x27) {
            return _ref22.apply(this, arguments);
        }

        return load;
    }(),
    refresh: function () {
        var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(order) {
            var refreshedOrder;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                order: order,
                                actionType: _AppConstants.ActionTypes.ORDER_REFRESH_STARTED
                            });

                            _context16.prev = 1;
                            _context16.next = 4;
                            return _OrderService2.default.get(order.id);

                        case 4:
                            refreshedOrder = _context16.sent;


                            if (refreshedOrder.isPaid()) {
                                _AppDispatcher2.default.dispatch({
                                    order: refreshedOrder,
                                    actionType: _AppConstants.ActionTypes.ORDER_PAID
                                });
                            } else {
                                _AppDispatcher2.default.dispatch({
                                    order: refreshedOrder,
                                    actionType: _AppConstants.ActionTypes.ORDER_REFRESH_LOADED
                                });
                            }
                            return _context16.abrupt('return', refreshedOrder);

                        case 9:
                            _context16.prev = 9;
                            _context16.t0 = _context16['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                order: order, error: _context16.t0,
                                actionType: _AppConstants.ActionTypes.ORDER_REFRESH_FAILED
                            });
                            return _context16.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, this, [[1, 9]]);
        }));

        function refresh(_x28) {
            return _ref23.apply(this, arguments);
        }

        return refresh;
    }(),
    refreshOrderFromCookieData: function refreshOrderFromCookieData() {
        if (!_FeatureFlagStore2.default.get('enableBasketWidget')) {
            return;
        }

        var orderCookie = _Cookie2.default.get(_AppConstants.CookieKeys.ORDER, true);

        var _ref24 = orderCookie && orderCookie.order || {},
            orderId = _ref24.id,
            journeysAmount = _ref24.journeysAmount;

        if (!orderId) {
            return;
        }
        if (journeysAmount) {
            this.update();
        } else {
            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.BASKET_CLEARED });
        }
    },
    refreshAmendment: function () {
        var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(order) {
            var refreshedOrder;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                order: order,
                                actionType: _AppConstants.ActionTypes.ORDER_REFRESH_STARTED
                            });

                            _context17.prev = 1;
                            _context17.next = 4;
                            return _OrderHistoryService2.default.getOrderHistory(order.id);

                        case 4:
                            refreshedOrder = _context17.sent;


                            if (refreshedOrder.isPaid()) {
                                _AppDispatcher2.default.dispatch({
                                    order: refreshedOrder,
                                    actionType: _AppConstants.ActionTypes.ORDER_PAID
                                });
                            } else {
                                _AppDispatcher2.default.dispatch({
                                    order: refreshedOrder,
                                    actionType: _AppConstants.ActionTypes.ORDER_REFRESH_LOADED
                                });
                            }
                            return _context17.abrupt('return', refreshedOrder);

                        case 9:
                            _context17.prev = 9;
                            _context17.t0 = _context17['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                order: order, error: _context17.t0,
                                actionType: _AppConstants.ActionTypes.ORDER_REFRESH_FAILED
                            });
                            return _context17.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, this, [[1, 9]]);
        }));

        function refreshAmendment(_x29) {
            return _ref25.apply(this, arguments);
        }

        return refreshAmendment;
    }(),
    loadDeliveryOptions: function () {
        var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18() {
            var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _OrderStore2.default.getCurrent();
            var smartcard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SmartcardStore2.default.getCurrent();
            var deliveryOptions;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:

                            this.handleOrderLoadingDeliveryOptions(true);

                            _context18.prev = 1;
                            _context18.next = 4;
                            return _OrderService2.default.getDeliveryOptions(order.id, smartcard);

                        case 4:
                            deliveryOptions = _context18.sent;


                            _AppDispatcher2.default.dispatch({
                                order: order, deliveryOptions: deliveryOptions,
                                actionType: _AppConstants.ActionTypes.ORDER_DELIVERY_OPTIONS_LOADED
                            });

                            this.handleOrderLoadingDeliveryOptions(false);

                            return _context18.abrupt('return', deliveryOptions);

                        case 10:
                            _context18.prev = 10;
                            _context18.t0 = _context18['catch'](1);

                            this.handleOrderLoadingDeliveryOptions(false);

                            throw _context18.t0;

                        case 14:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, this, [[1, 10]]);
        }));

        function loadDeliveryOptions() {
            return _ref26.apply(this, arguments);
        }

        return loadDeliveryOptions;
    }(),
    createSmartCarnetOrder: function () {
        var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(trip) {
            var outwardTrip, inwardTrip, order;
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            outwardTrip = new _Trip2.default().setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, trip.getOutwardFare());
                            inwardTrip = new _Trip2.default().setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, trip.getInwardFare());
                            _context19.next = 4;
                            return this.create({ order: new _Order2.default(), trip: outwardTrip });

                        case 4:
                            order = _context19.sent;

                            if (!inwardTrip.hasOutwardFare()) {
                                _context19.next = 9;
                                break;
                            }

                            _context19.next = 8;
                            return this.addTrip(order, inwardTrip);

                        case 8:
                            order = _context19.sent;

                        case 9:
                            return _context19.abrupt('return', order);

                        case 10:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, this);
        }));

        function createSmartCarnetOrder(_x32) {
            return _ref27.apply(this, arguments);
        }

        return createSmartCarnetOrder;
    }(),
    checkTaxiBookingAvailability: function () {
        var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(order) {
            var destinationRequests, destinationResponses, onwardTaxiBookingAvailable;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            destinationRequests = order.get('trips').filter(function (trip) {
                                return trip.needsJourney();
                            }).map(function (trip) {
                                return trip.getDestination();
                            }).filter(function (destination) {
                                return destination.get('crs');
                            }).map(function (destination) {
                                return _StationService2.default.search(destination.get('crs'));
                            });
                            _context20.next = 3;
                            return _promise2.default.all(destinationRequests.toArray());

                        case 3:
                            destinationResponses = _context20.sent;
                            onwardTaxiBookingAvailable = destinationResponses.some(function (response) {
                                return response.first().get('onwardTaxiBookingAvailable');
                            });


                            _AppDispatcher2.default.dispatch({
                                onwardTaxiBookingAvailable: onwardTaxiBookingAvailable,
                                actionType: _AppConstants.ActionTypes.ORDER_TAXI_BOOKING_AVAILABILITY
                            });

                            return _context20.abrupt('return', onwardTaxiBookingAvailable);

                        case 7:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, this);
        }));

        function checkTaxiBookingAvailability(_x33) {
            return _ref28.apply(this, arguments);
        }

        return checkTaxiBookingAvailability;
    }(),
    linkOrderToAccount: function () {
        var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(token, email) {
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.LINK_ORDER_TO_ACCOUNT
                            });

                            _context21.next = 3;
                            return _OrderService2.default.linkToAccount(token, email);

                        case 3:
                            return _context21.abrupt('return', _context21.sent);

                        case 4:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, this);
        }));

        function linkOrderToAccount(_x34, _x35) {
            return _ref29.apply(this, arguments);
        }

        return linkOrderToAccount;
    }(),
    updateLeadPassenger: function updateLeadPassenger(trip, leadPassengerName) {
        _AppDispatcher2.default.dispatch({
            trip: trip, leadPassengerName: leadPassengerName,
            actionType: _AppConstants.ActionTypes.ORDER_TRIP_LEAD_PASSENGER_UPDATED
        });
    },
    applyDiscountCode: function () {
        var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(discountCode) {
            var updatedOrder;
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.APPLY_DISCOUNT_CODE_STARTED
                            });

                            _context22.prev = 1;
                            _context22.next = 4;
                            return _OrderService2.default.applyDiscountCode(_OrderStore2.default.getCurrent(), discountCode);

                        case 4:
                            updatedOrder = _context22.sent;


                            _AppDispatcher2.default.dispatch({
                                updatedOrder: updatedOrder,
                                actionType: _AppConstants.ActionTypes.APPLY_DISCOUNT_CODE_FINISHED
                            });

                            return _context22.abrupt('return', updatedOrder);

                        case 9:
                            _context22.prev = 9;
                            _context22.t0 = _context22['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                error: _context22.t0,
                                actionType: _AppConstants.ActionTypes.APPLY_DISCOUNT_CODE_FAILED
                            });
                            return _context22.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, this, [[1, 9]]);
        }));

        function applyDiscountCode(_x36) {
            return _ref30.apply(this, arguments);
        }

        return applyDiscountCode;
    }(),
    removeDiscountCode: function () {
        var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(discountCode) {
            var updatedOrder;
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DELETE_DISCOUNT_CODE_STARTED
                            });

                            _context23.prev = 1;
                            _context23.next = 4;
                            return _OrderService2.default.removeDiscountCode(_OrderStore2.default.getCurrent(), discountCode);

                        case 4:
                            updatedOrder = _context23.sent;


                            _AppDispatcher2.default.dispatch({
                                updatedOrder: updatedOrder,
                                actionType: _AppConstants.ActionTypes.DELETE_DISCOUNT_CODE_FINISHED
                            });

                            return _context23.abrupt('return', updatedOrder);

                        case 9:
                            _context23.prev = 9;
                            _context23.t0 = _context23['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                error: _context23.t0,
                                actionType: _AppConstants.ActionTypes.DELETE_DISCOUNT_CODE_FAILED
                            });
                            return _context23.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, this, [[1, 9]]);
        }));

        function removeDiscountCode(_x37) {
            return _ref31.apply(this, arguments);
        }

        return removeDiscountCode;
    }(),
    lock: function () {
        var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(order) {
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            _context24.prev = 0;

                            if (order && order.id) {
                                _context24.next = 4;
                                break;
                            }

                            console.error('OrderActions.lock error: Invalid order object: ', order);
                            return _context24.abrupt('return');

                        case 4:
                            _context24.next = 6;
                            return _OrderService2.default.lock(order);

                        case 6:
                            _AppDispatcher2.default.dispatch({
                                order: order,
                                actionType: _AppConstants.ActionTypes.ORDER_LOCKED
                            });
                            _context24.next = 12;
                            break;

                        case 9:
                            _context24.prev = 9;
                            _context24.t0 = _context24['catch'](0);

                            console.error('OrderActions.lock error: ', _context24.t0);

                        case 12:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, this, [[0, 9]]);
        }));

        function lock(_x38) {
            return _ref32.apply(this, arguments);
        }

        return lock;
    }(),
    unlock: function () {
        var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(order) {
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            if (order && order.id) {
                                _context25.next = 3;
                                break;
                            }

                            console.error('OrderActions.unlock error: Invalid order object: ', order);
                            return _context25.abrupt('return');

                        case 3:
                            _context25.prev = 3;
                            _context25.next = 6;
                            return _OrderService2.default.unlock(order);

                        case 6:
                            _AppDispatcher2.default.dispatch({
                                order: order,
                                actionType: _AppConstants.ActionTypes.ORDER_UNLOCKED
                            });
                            _context25.next = 12;
                            break;

                        case 9:
                            _context25.prev = 9;
                            _context25.t0 = _context25['catch'](3);

                            console.error('OrderActions.unlock error: ', _context25.t0);

                        case 12:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, this, [[3, 9]]);
        }));

        function unlock(_x39) {
            return _ref33.apply(this, arguments);
        }

        return unlock;
    }(),
    loadChangeovers: function () {
        var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(order, customerId) {
            return _regenerator2.default.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            return _context26.abrupt('return', _OrderService2.default.loadChangeovers(order, customerId));

                        case 1:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, this);
        }));

        function loadChangeovers(_x40, _x41) {
            return _ref34.apply(this, arguments);
        }

        return loadChangeovers;
    }(),
    updateContactDetails: function () {
        var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(_ref35) {
            var email = _ref35.email,
                telephoneNumber = _ref35.telephoneNumber;
            return _regenerator2.default.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                email: email,
                                telephoneNumber: telephoneNumber,
                                actionType: _AppConstants.ActionTypes.ORDER_CONTACT_DETAILS_UPDATED
                            });

                        case 1:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, this);
        }));

        function updateContactDetails(_x42) {
            return _ref36.apply(this, arguments);
        }

        return updateContactDetails;
    }(),
    updateHandoffDetails: function updateHandoffDetails(handoffDetails) {
        _AppDispatcher2.default.dispatch({
            handoffDetails: handoffDetails,
            actionType: _AppConstants.ActionTypes.ORDER_HANDOFF_UPDATED
        });
    },
    updateHandoffReferralReported: function updateHandoffReferralReported(referralReported) {
        _AppDispatcher2.default.dispatch({
            referralReported: referralReported,
            actionType: _AppConstants.ActionTypes.ORDER_HANDOFF_REFERRAL_REPORTED
        });
    },
    validateRewardCode: function validateRewardCode(data) {
        return _OrderService2.default.validateRewardCode(data);
    },
    updateOrder: function updateOrder(order) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                order: order,
                actionType: _AppConstants.ActionTypes.ORDER_UPDATED
            });
        });
    }
}, (_applyDecoratedDescriptor(_obj, 'checkBasket', [_Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'checkBasket'), _obj), _applyDecoratedDescriptor(_obj, 'create', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'create'), _obj), _applyDecoratedDescriptor(_obj, 'addTrip', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'addTrip'), _obj), _applyDecoratedDescriptor(_obj, 'deleteTrip', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie, _Order3.deleteMatchingPassengerAssistRequests], (0, _getOwnPropertyDescriptor2.default)(_obj, 'deleteTrip'), _obj), _applyDecoratedDescriptor(_obj, 'updateTrip', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'updateTrip'), _obj), _applyDecoratedDescriptor(_obj, 'checkTrip', [_Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'checkTrip'), _obj), _applyDecoratedDescriptor(_obj, 'createOrUpdate', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'createOrUpdate'), _obj), _applyDecoratedDescriptor(_obj, 'changeTripPassengers', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'changeTripPassengers'), _obj), _applyDecoratedDescriptor(_obj, 'createOrderForPreRegisteredSmartcard', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'createOrderForPreRegisteredSmartcard'), _obj), _applyDecoratedDescriptor(_obj, 'addOrUpdatePlusBus', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'addOrUpdatePlusBus'), _obj), _applyDecoratedDescriptor(_obj, 'update', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'update'), _obj), _applyDecoratedDescriptor(_obj, 'clearBasket', [_Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'clearBasket'), _obj), _applyDecoratedDescriptor(_obj, 'handleOrderLoading', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'handleOrderLoading'), _obj), _applyDecoratedDescriptor(_obj, 'handleOrderLoadingDeliveryOptions', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'handleOrderLoadingDeliveryOptions'), _obj), _applyDecoratedDescriptor(_obj, 'updateFulfilment', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'updateFulfilment'), _obj), _applyDecoratedDescriptor(_obj, 'updateFulfilmentMethod', [_Order3.handleOrderErrors, _Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'updateFulfilmentMethod'), _obj), _applyDecoratedDescriptor(_obj, 'load', [withOrderLoadingActions], (0, _getOwnPropertyDescriptor2.default)(_obj, 'load'), _obj), _applyDecoratedDescriptor(_obj, 'refresh', [withOrderLoadingActions, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'refresh'), _obj), _applyDecoratedDescriptor(_obj, 'refreshOrderFromCookieData', [_Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'refreshOrderFromCookieData'), _obj), _applyDecoratedDescriptor(_obj, 'refreshAmendment', [withOrderLoadingActions, _Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'refreshAmendment'), _obj), _applyDecoratedDescriptor(_obj, 'loadDeliveryOptions', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'loadDeliveryOptions'), _obj), _applyDecoratedDescriptor(_obj, 'createSmartCarnetOrder', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry], (0, _getOwnPropertyDescriptor2.default)(_obj, 'createSmartCarnetOrder'), _obj), _applyDecoratedDescriptor(_obj, 'applyDiscountCode', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'applyDiscountCode'), _obj), _applyDecoratedDescriptor(_obj, 'removeDiscountCode', [withOrderLoadingActions, _Order3.handleOrderErrors, _Order3.checkOrderExpiry, _Order3.setOrderDataCookie], (0, _getOwnPropertyDescriptor2.default)(_obj, 'removeDiscountCode'), _obj)), _obj);

exports.default = actions;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Checkbox = __webpack_require__(923);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxWrapper = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(CheckboxWrapper, _React$PureComponent);

    function CheckboxWrapper() {
        (0, _classCallCheck3.default)(this, CheckboxWrapper);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    /*
     * Only use an alternate SR label if you're happy for everything inside
     *  the original label to be aria-hidden. Don't use if, for example,
     *  it includes a HelpIcon whose aria-label should be read out.
     */

    CheckboxWrapper.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            label = _props.label,
            helpIcon = _props.helpIcon,
            helpLink = _props.helpLink,
            groupClassName = _props.groupClassName,
            labelClassName = _props.labelClassName,
            darkBackground = _props.darkBackground,
            inline = _props.inline,
            srOnly = _props.srOnly,
            error = _props.error,
            props = (0, _objectWithoutProperties3.default)(_props, ['className', 'label', 'helpIcon', 'helpLink', 'groupClassName', 'labelClassName', 'darkBackground', 'inline', 'srOnly', 'error']);

        var errorMessage = error ? (0, _I18n2.default)(error) : '';
        var groupClassNames = (0, _classnames2.default)(groupClassName, {
            'checkbox-inline': inline
        });
        var classNames = (0, _classnames2.default)(className, {
            'checkbox--invalid': error,
            'checkbox--dark-bg': darkBackground
        });

        if (srOnly) {
            return _react2.default.createElement(
                'div',
                { className: groupClassNames },
                _react2.default.createElement(
                    _Checkbox2.default,
                    (0, _extends3.default)({ className: classNames }, props),
                    _react2.default.createElement(
                        'span',
                        { className: labelClassName, 'aria-hidden': 'true' },
                        label
                    ),
                    helpIcon && helpLink && _react2.default.createElement(
                        'a',
                        { href: helpLink },
                        helpIcon
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        error ? 'Error: ' + errorMessage + '. ' : '',
                        srOnly
                    )
                )
            );
        }
        return _react2.default.createElement(
            'div',
            { className: groupClassNames },
            _react2.default.createElement(
                _Checkbox2.default,
                (0, _extends3.default)({ className: classNames }, props),
                _react2.default.createElement(
                    'span',
                    { className: labelClassName },
                    label
                )
            )
        );
    };

    return CheckboxWrapper;
}(_react2.default.PureComponent), _class.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.any,
    helpIcon: _propTypes2.default.any,
    helpLink: _propTypes2.default.string,
    labelClassName: _propTypes2.default.string,
    groupClassName: _propTypes2.default.string,
    darkBackground: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    srOnly: _propTypes2.default.string,
    error: _propTypes2.default.string
}, _class.defaultProps = {
    className: '',
    label: null,
    helpIcon: null,
    helpLink: null,
    labelClassName: null,
    groupClassName: null,
    darkBackground: false,
    inline: false,
    autoFocus: false,
    srOnly: '',
    error: ''
}, _temp);
exports.default = CheckboxWrapper;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withRouter;

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(1857);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _PropTypes = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = function (_React$Component) {
    _inherits(WithRouter, _React$Component);

    function WithRouter() {
      var _temp, _this, _ret;

      _classCallCheck(this, WithRouter);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.getWrappedInstance = function () {
        !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;

        return _this.wrappedInstance;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    WithRouter.prototype.render = function render() {
      var _this2 = this;

      var router = this.props.router || this.context.router;
      var props = _extends({}, this.props, { router: router });

      if (withRef) {
        props.ref = function (c) {
          _this2.wrappedInstance = c;
        };
      }

      return _react2.default.createElement(WrappedComponent, props);
    };

    return WithRouter;
  }(_react2.default.Component);

  WithRouter.contextTypes = { router: _PropTypes.routerShape };
  WithRouter.propTypes = { router: _PropTypes.routerShape };


  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
}
module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InAppStore = undefined;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InAppStore = exports.InAppStore = function (_BaseStore) {
    (0, _inherits3.default)(InAppStore, _BaseStore);

    function InAppStore() {
        (0, _classCallCheck3.default)(this, InAppStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    InAppStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.IN_APP_SESSION_STARTED] = this.handleSessionStarted, _ref[_AppConstants.ActionTypes.AUTH_REFRESHED] = this.handleAuthRefresh, _ref[_AppConstants.ActionTypes.LOGGED_IN] = this.handleAuthRefresh, _ref[_AppConstants.ActionTypes.USER_UPDATED] = this.handleAuthRefresh, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleLogout, _ref[_AppConstants.ActionTypes.MOBILE_APP_RATING_TRIGGERED] = this.handleMobileAppRating, _ref[_AppConstants.ActionTypes.MOBILE_APP_RE_ORDER] = this.handleReorder, _ref[_AppConstants.ActionTypes.SET_IN_APP] = this.setInApp, _ref;
    };

    InAppStore.prototype.isInApp = function isInApp() {
        return this.state.get('inApp');
    };

    InAppStore.prototype.setInApp = function setInApp(_ref2) {
        var value = _ref2.value;

        this.setState(this.state.set('inApp', value));
    };

    InAppStore.prototype.getChannel = function getChannel() {
        return this.state.get('channel', _AppConstants.DEFAULT_APP_CHANNEL);
    };

    InAppStore.prototype.disableAutoLogout = function disableAutoLogout() {
        return this.state.get('disableAutoLogout', false);
    };

    InAppStore.prototype.disableAccountNavigationLogout = function disableAccountNavigationLogout() {
        return this.state.get('disableAccountNavigationLogout', false);
    };

    InAppStore.prototype.getAppVersion = function getAppVersion() {
        return this.state.get('appVersion');
    };

    InAppStore.prototype.handleSessionStarted = function handleSessionStarted() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            appVersion = _ref3.appVersion,
            _ref3$channel = _ref3.channel,
            channel = _ref3$channel === undefined ? _AppConstants.DEFAULT_APP_CHANNEL : _ref3$channel,
            _ref3$disableAutoLogo = _ref3.disableAutoLogout,
            disableAutoLogout = _ref3$disableAutoLogo === undefined ? false : _ref3$disableAutoLogo,
            _ref3$disableAccountN = _ref3.disableAccountNavigationLogout,
            disableAccountNavigationLogout = _ref3$disableAccountN === undefined ? false : _ref3$disableAccountN;

        var state = this.state.merge({
            appVersion: appVersion,
            channel: channel,
            disableAutoLogout: disableAutoLogout,
            disableAccountNavigationLogout: disableAccountNavigationLogout,
            inApp: true
        });
        this.setState(state);
    };

    /**
     * Crucial for keeping the app authenticated
     */


    InAppStore.prototype.handleAuthRefresh = function handleAuthRefresh() {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage((0, _stringify2.default)({
                source: 'otrl',
                event: 'auth-refreshed'
            }));
        }
    };

    InAppStore.prototype.handleLogout = function handleLogout() {
        if (this.isInApp() && window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage((0, _stringify2.default)({
                source: 'otrl',
                event: 'auth-logout'
            }));
        }
    };

    InAppStore.prototype.handleMobileAppRating = function handleMobileAppRating() {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage((0, _stringify2.default)({
                source: 'otrl',
                event: 'rate-app'
            }));
        }
    };

    InAppStore.prototype.handleReorder = function handleReorder(params) {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage((0, _stringify2.default)({
                source: 'otrl',
                event: 're-order',
                data: params
            }));
        }
    };

    return InAppStore;
}(_BaseStore3.default);

var storeInstance = new InAppStore({ storageKey: 'inApp' });

exports.default = storeInstance;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(288),
    baseIteratee = __webpack_require__(102),
    basePickBy = __webpack_require__(790),
    getAllKeysIn = __webpack_require__(536);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(66)) {
  var LIBRARY = __webpack_require__(179);
  var global = __webpack_require__(36);
  var fails = __webpack_require__(40);
  var $export = __webpack_require__(10);
  var $typed = __webpack_require__(366);
  var $buffer = __webpack_require__(491);
  var ctx = __webpack_require__(131);
  var anInstance = __webpack_require__(212);
  var propertyDesc = __webpack_require__(205);
  var hide = __webpack_require__(111);
  var redefineAll = __webpack_require__(214);
  var toInteger = __webpack_require__(133);
  var toLength = __webpack_require__(63);
  var toIndex = __webpack_require__(716);
  var toAbsoluteIndex = __webpack_require__(208);
  var toPrimitive = __webpack_require__(148);
  var has = __webpack_require__(120);
  var classof = __webpack_require__(243);
  var isObject = __webpack_require__(48);
  var toObject = __webpack_require__(73);
  var isArrayIter = __webpack_require__(480);
  var create = __webpack_require__(209);
  var getPrototypeOf = __webpack_require__(123);
  var gOPN = __webpack_require__(210).f;
  var getIterFn = __webpack_require__(482);
  var uid = __webpack_require__(206);
  var wks = __webpack_require__(56);
  var createArrayMethod = __webpack_require__(151);
  var createArrayIncludes = __webpack_require__(356);
  var speciesConstructor = __webpack_require__(296);
  var ArrayIterators = __webpack_require__(485);
  var Iterators = __webpack_require__(245);
  var $iterDetect = __webpack_require__(361);
  var setSpecies = __webpack_require__(211);
  var arrayFill = __webpack_require__(484);
  var arrayCopyWithin = __webpack_require__(705);
  var $DP = __webpack_require__(71);
  var $GOPD = __webpack_require__(122);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(711);
var $export = __webpack_require__(10);
var shared = __webpack_require__(292)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(714))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(298);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1422), __esModule: true };

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, Promise */

;(function ($) {
  'use strict'

  var urlAPI = $.URL || $.webkitURL

  /**
   * Creates an object URL for a given File object.
   *
   * @param {Blob} blob Blob object
   * @returns {string|boolean} Returns object URL if API exists, else false.
   */
  function createObjectURL(blob) {
    return urlAPI ? urlAPI.createObjectURL(blob) : false
  }

  /**
   * Revokes a given object URL.
   *
   * @param {string} url Blob object URL
   * @returns {undefined|boolean} Returns undefined if API exists, else false.
   */
  function revokeObjectURL(url) {
    return urlAPI ? urlAPI.revokeObjectURL(url) : false
  }

  /**
   * Helper function to revoke an object URL
   *
   * @param {string} url Blob Object URL
   * @param {object} [options] Options object
   */
  function revokeHelper(url, options) {
    if (url && url.slice(0, 5) === 'blob:' && !(options && options.noRevoke)) {
      revokeObjectURL(url)
    }
  }

  /**
   * Loads a given File object via FileReader interface.
   *
   * @param {Blob} file Blob object
   * @param {Function} onload Load event callback
   * @param {Function} [onerror] Error/Abort event callback
   * @param {string} [method=readAsDataURL] FileReader method
   * @returns {FileReader|boolean} Returns FileReader if API exists, else false.
   */
  function readFile(file, onload, onerror, method) {
    if (!$.FileReader) return false
    var reader = new FileReader()
    reader.onload = function () {
      onload.call(reader, this.result)
    }
    if (onerror) {
      reader.onabort = reader.onerror = function () {
        onerror.call(reader, this.error)
      }
    }
    var readerMethod = reader[method || 'readAsDataURL']
    if (readerMethod) {
      readerMethod.call(reader, file)
      return reader
    }
  }

  /**
   * Cross-frame instanceof check.
   *
   * @param {string} type Instance type
   * @param {object} obj Object instance
   * @returns {boolean} Returns true if the object is of the given instance.
   */
  function isInstanceOf(type, obj) {
    // Cross-frame instanceof check
    return Object.prototype.toString.call(obj) === '[object ' + type + ']'
  }

  /**
   * @typedef { HTMLImageElement|HTMLCanvasElement } Result
   */

  /**
   * Loads an image for a given File object.
   *
   * @param {Blob|string} file Blob object or image URL
   * @param {Function|object} [callback] Image load event callback or options
   * @param {object} [options] Options object
   * @returns {HTMLImageElement|FileReader|Promise<Result>} Object
   */
  function loadImage(file, callback, options) {
    /**
     * Promise executor
     *
     * @param {Function} resolve Resolution function
     * @param {Function} reject Rejection function
     * @returns {HTMLImageElement|FileReader} Object
     */
    function executor(resolve, reject) {
      var img = document.createElement('img')
      var url
      /**
       * Callback for the fetchBlob call.
       *
       * @param {HTMLImageElement|HTMLCanvasElement} img Error object
       * @param {object} data Data object
       * @returns {undefined} Undefined
       */
      function resolveWrapper(img, data) {
        if (resolve === reject) {
          // Not using Promises
          if (resolve) resolve(img, data)
          return
        } else if (img instanceof Error) {
          reject(img)
          return
        }
        data = data || {} // eslint-disable-line no-param-reassign
        data.image = img
        resolve(data)
      }
      /**
       * Callback for the fetchBlob call.
       *
       * @param {Blob} blob Blob object
       * @param {Error} err Error object
       */
      function fetchBlobCallback(blob, err) {
        if (err && $.console) console.log(err) // eslint-disable-line no-console
        if (blob && isInstanceOf('Blob', blob)) {
          file = blob // eslint-disable-line no-param-reassign
          url = createObjectURL(file)
        } else {
          url = file
          if (options && options.crossOrigin) {
            img.crossOrigin = options.crossOrigin
          }
        }
        img.src = url
      }
      img.onerror = function (event) {
        revokeHelper(url, options)
        if (reject) reject.call(img, event)
      }
      img.onload = function () {
        revokeHelper(url, options)
        var data = {
          originalWidth: img.naturalWidth || img.width,
          originalHeight: img.naturalHeight || img.height
        }
        try {
          loadImage.transform(img, options, resolveWrapper, file, data)
        } catch (error) {
          if (reject) reject(error)
        }
      }
      if (typeof file === 'string') {
        if (loadImage.requiresMetaData(options)) {
          loadImage.fetchBlob(file, fetchBlobCallback, options)
        } else {
          fetchBlobCallback()
        }
        return img
      } else if (isInstanceOf('Blob', file) || isInstanceOf('File', file)) {
        url = createObjectURL(file)
        if (url) {
          img.src = url
          return img
        }
        return readFile(
          file,
          function (url) {
            img.src = url
          },
          reject
        )
      }
    }
    if ($.Promise && typeof callback !== 'function') {
      options = callback // eslint-disable-line no-param-reassign
      return new Promise(executor)
    }
    return executor(callback, callback)
  }

  // Determines if metadata should be loaded automatically.
  // Requires the load image meta extension to load metadata.
  loadImage.requiresMetaData = function (options) {
    return options && options.meta
  }

  // If the callback given to this function returns a blob, it is used as image
  // source instead of the original url and overrides the file argument used in
  // the onload and onerror event callbacks:
  loadImage.fetchBlob = function (url, callback) {
    callback()
  }

  loadImage.transform = function (img, options, callback, file, data) {
    callback(img, data)
  }

  loadImage.global = $
  loadImage.readFile = readFile
  loadImage.isInstanceOf = isInstanceOf
  loadImage.createObjectURL = createObjectURL
  loadImage.revokeObjectURL = revokeObjectURL

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return loadImage
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    module.exports = loadImage
  } else {
    $.loadImage = loadImage
  }
})((typeof window !== 'undefined' && window) || this)


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(192);
var IE8_DOM_DEFINE = __webpack_require__(846);
var toPrimitive = __webpack_require__(554);
var dP = Object.defineProperty;

exports.f = __webpack_require__(154) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isFinite2 = __webpack_require__(1667);

var _isFinite3 = _interopRequireDefault(_isFinite2);

exports.toPounds = toPounds;
exports.toPence = toPence;
exports.formatPounds = formatPounds;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaultNum(num) {
    return (0, _isFinite3.default)(num) ? num : 0;
}

function toPounds(pence) {
    return parseInt(_defaultNum(pence), 10) / 100;
}

function toPence(pounds) {
    return Math.round(_defaultNum(parseFloat(pounds)) * 100);
}

function formatPounds(pounds) {
    return '\xA3' + _defaultNum(pounds).toFixed(2);
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(510);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(747),
    getTag = __webpack_require__(307),
    isArguments = __webpack_require__(304),
    isArray = __webpack_require__(68),
    isArrayLike = __webpack_require__(143),
    isBuffer = __webpack_require__(251),
    isPrototype = __webpack_require__(330),
    isTypedArray = __webpack_require__(306);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExternalLink(_ref) {
    var message = _ref.message,
        href = _ref.href,
        className = _ref.className,
        messageClassName = _ref.messageClassName,
        noUnderline = _ref.noUnderline,
        srOnly = _ref.srOnly,
        rel = _ref.rel,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['message', 'href', 'className', 'messageClassName', 'noUnderline', 'srOnly', 'rel']);

    var anchorClassName = (0, _classnames2.default)('external-link-no-underline', className);
    var msgClassName = (0, _classnames2.default)('external-link', {
        'external-link-no-underline': noUnderline
    }, messageClassName);

    return _react2.default.createElement(
        'a',
        (0, _extends3.default)({ className: anchorClassName, rel: rel, href: href, target: '_blank' }, rest),
        _react2.default.createElement(_FormattedHTMLMessage2.default, { className: msgClassName, message: message }),
        _react2.default.createElement(
            'span',
            { className: 'external-link__spacer' },
            '\xA0'
        ),
        _react2.default.createElement('i', { className: 'otrl otrl-externallink' }),
        _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            srOnly,
            (0, _I18n2.default)('global.externalLink')
        )
    );
}

ExternalLink.propTypes = {
    message: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    messageClassName: _propTypes2.default.string,
    noUnderline: _propTypes2.default.bool,
    srOnly: _propTypes2.default.string,
    rel: _propTypes2.default.string
};

ExternalLink.defaultProps = {
    className: '',
    messageClassName: '',
    noUnderline: false,
    srOnly: '',
    rel: null
};

exports.default = ExternalLink;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _entries = __webpack_require__(238);

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _text = __webpack_require__(448);

var _constants = __webpack_require__(333);

var _AccessibilityProfileForm = __webpack_require__(1859);

var _AccessibilityProfileForm2 = _interopRequireDefault(_AccessibilityProfileForm);

var _Stepper = __webpack_require__(1860);

var _Stepper2 = _interopRequireDefault(_Stepper);

var _AssistedTravel = __webpack_require__(675);

var _AssistedTravel2 = _interopRequireDefault(_AssistedTravel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    accessibilityProfile: _AccessibilityProfileForm.defaultAccessibilityProfile,
    isAccessibilityProfileLoading: false,
    accessibilityProfileForm: new _AccessibilityProfileForm2.default(),
    accessibilityProfileStepper: new _Stepper2.default({
        steps: new _immutable.List((0, _values2.default)(_constants.ACCESSIBILITY_PROFILE_STEPS).map(function (_ref) {
            var title = _ref.title;
            return title;
        })),
        activeStep: 0
    }),
    accessibilityProfileStatus: null,
    previousJourneys: new _immutable.List(),
    isPreviousJourneysLoading: false,
    bookingPAStepper: new _Stepper2.default({
        steps: new _immutable.List((0, _values2.default)(_constants.BOOK_PA_STEPS).map(function (_ref2) {
            var title = _ref2.title;
            return title;
        })),
        activeStep: 0
    }),
    bookingPAEnterAccessibilityProfileStep: _constants.ACCESSIBILITY_PROFILE_STEPS.PERSONAL_DETAILS.index,
    bookingPAStatus: _constants.BOOKING_PA_STATUSES.BOOK_OUTWARD_JOURNEY,
    useAccessibilityProfile: true,
    isEditPAModeEnabled: false,
    editPASection: _constants.EDIT_PA_SECTION_INDEXES.PERSONAL_DETAILS,
    assistedBookings: new _immutable.List(),
    isAssistedBookingsLoading: false,
    assistedBooking: {},
    widgetToggled: false,
    isAssistedBookingLoading: false,
    travelAssist: new _AssistedTravel2.default(),
    pendingTravelAssistRequests: new _immutable.List(),
    showBackToSearchResultsButton: false
});

var PassengerAssistStore = function (_BaseStore) {
    (0, _inherits3.default)(PassengerAssistStore, _BaseStore);

    function PassengerAssistStore() {
        (0, _classCallCheck3.default)(this, PassengerAssistStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    PassengerAssistStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            var accessibilityProfile = serialized.accessibilityProfile,
                isAccessibilityProfileLoading = serialized.isAccessibilityProfileLoading,
                accessibilityProfileForm = serialized.accessibilityProfileForm,
                accessibilityProfileStatus = serialized.accessibilityProfileStatus,
                accessibilityProfileStepper = serialized.accessibilityProfileStepper,
                assistedBooking = serialized.assistedBooking,
                assistedBookings = serialized.assistedBookings,
                isEditPAModeEnabled = serialized.isEditPAModeEnabled,
                editPASection = serialized.editPASection,
                bookingPAStatus = serialized.bookingPAStatus,
                bookingPAStepper = serialized.bookingPAStepper,
                isAssistedBookingLoading = serialized.isAssistedBookingLoading,
                isAssistedBookingsLoading = serialized.isAssistedBookingsLoading,
                isPreviousJourneysLoading = serialized.isPreviousJourneysLoading,
                pendingTravelAssistRequests = serialized.pendingTravelAssistRequests,
                previousJourneys = serialized.previousJourneys,
                travelAssist = serialized.travelAssist,
                widgetToggled = serialized.widgetToggled;


            var accessibilityProfileRecord = (0, _extends3.default)({}, accessibilityProfile, {
                reasonForAssistance: new _immutable.List(accessibilityProfileForm.reasonForAssistance)
            });

            return new State({
                accessibilityProfile: accessibilityProfileRecord,
                isAccessibilityProfileLoading: isAccessibilityProfileLoading,
                accessibilityProfileForm: new _AccessibilityProfileForm2.default(accessibilityProfileRecord),
                accessibilityProfileStatus: accessibilityProfileStatus,
                accessibilityProfileStepper: new _Stepper2.default({
                    activeStep: accessibilityProfileStepper.activeStep,
                    steps: new _immutable.List(accessibilityProfileStepper.steps)
                }),
                assistedBooking: assistedBooking,
                assistedBookings: assistedBookings,
                isEditPAModeEnabled: isEditPAModeEnabled,
                editPASection: editPASection,
                bookingPAStatus: bookingPAStatus,
                useAccessibilityProfile: true,
                bookingPAStepper: new _Stepper2.default({
                    activeStep: bookingPAStepper.activeStep,
                    steps: new _immutable.List(bookingPAStepper.steps)
                }),
                bookingPAEnterAccessibilityProfileStep: _constants.ACCESSIBILITY_PROFILE_STEPS.PERSONAL_DETAILS.index,
                isAssistedBookingLoading: isAssistedBookingLoading,
                isAssistedBookingsLoading: isAssistedBookingsLoading,
                isPreviousJourneysLoading: isPreviousJourneysLoading,
                pendingTravelAssistRequests: new _immutable.List(pendingTravelAssistRequests.map(function (x) {
                    return new _AssistedTravel2.default(x);
                })),
                previousJourneys: new _immutable.List(previousJourneys.map(function (journey) {
                    return (0, _extends3.default)({}, journey, {
                        legs: new _immutable.List(previousJourneys.legs)
                    });
                })),
                travelAssist: new _AssistedTravel2.default({
                    departureDate: (0, _moment2.default)(travelAssist.departureDate),
                    outwardJourney: travelAssist.outwardJourney,
                    returnJourney: travelAssist.returnJourney
                }),
                widgetToggled: widgetToggled,
                showBackToSearchResultsButton: false
            });
        }
        return new State();
    };

    PassengerAssistStore.prototype.getInitialState = function getInitialState() {
        return new State();
    };

    PassengerAssistStore.prototype.addOrderTripIdToTravelAssist = function addOrderTripIdToTravelAssist(_ref3) {
        var orderTripId = _ref3.orderTripId;

        var lastItem = this.state.pendingTravelAssistRequests.last();

        if (lastItem && !lastItem.orderTripId) {
            var updatedLastItem = this.state.pendingTravelAssistRequests.last().set('orderTripId', orderTripId);

            return this.setState(this.state.set('pendingTravelAssistRequests', this.state.pendingTravelAssistRequests.pop().push(updatedLastItem)));
        } else {
            return false;
        }
    };

    PassengerAssistStore.prototype.getPendingPassengerAssistRequests = function getPendingPassengerAssistRequests() {
        return this.state.get('pendingTravelAssistRequests');
    };

    PassengerAssistStore.prototype.setAccessibilityProfileForm = function setAccessibilityProfileForm(_ref4) {
        var accessibilityProfileFields = _ref4.accessibilityProfileFields;

        var updatedProfileForm = this.state.accessibilityProfileForm ? this.state.accessibilityProfileForm.merge(accessibilityProfileFields) : new _AccessibilityProfileForm2.default();
        return this.setState(this.state.set('accessibilityProfileForm', updatedProfileForm));
    };

    PassengerAssistStore.prototype.resetAccessibilityProfileForm = function resetAccessibilityProfileForm(_ref5) {
        var accessibilityProfileFields = _ref5.accessibilityProfileFields;

        var accessibilityProfile = (0, _extends3.default)({}, _AccessibilityProfileForm.defaultAccessibilityProfile, accessibilityProfileFields);
        return this.setState(this.state.set('accessibilityProfileForm', new _AccessibilityProfileForm2.default(accessibilityProfile)));
    };

    PassengerAssistStore.prototype.setLoadedAccessibilityProfile = function setLoadedAccessibilityProfile(_ref6) {
        var accessibilityProfile = _ref6.accessibilityProfile;

        var normalizedAccessibilityProfile = this.normalizeGetAccessibilityProfileResponse(accessibilityProfile);
        this.setState(this.state.set('accessibilityProfile', normalizedAccessibilityProfile).set('accessibilityProfileStatus', normalizedAccessibilityProfile.id ? _constants.ACCESSIBILITY_PROFILE_STATUSES.VIEW : _constants.ACCESSIBILITY_PROFILE_STATUSES.CREATE).set('accessibilityProfileForm', this.state.accessibilityProfileForm.merge(normalizedAccessibilityProfile)).set('isAccessibilityProfileLoading', false));
    };

    PassengerAssistStore.prototype.setIsAccessibilityProfileLoading = function setIsAccessibilityProfileLoading(value) {
        return function () {
            this.setState(this.state.set('isAccessibilityProfileLoading', value));
        };
    };

    PassengerAssistStore.prototype.setAccessibilityProfile = function setAccessibilityProfile(_ref7) {
        var accessibilityProfile = _ref7.accessibilityProfile;

        this.setState(this.state.set('accessibilityProfile', accessibilityProfile));
    };

    PassengerAssistStore.prototype.normalizeGetAccessibilityProfileResponse = function normalizeGetAccessibilityProfileResponse(response) {
        if (response && response.id) {
            return {
                title: response.title,
                firstName: response.firstNames,
                surname: response.surname,
                phone: response.contactNumber,
                postCode: response.postCode,
                line1: response.addressLine1,
                line2: response.addressLine2,
                line3: response.addressLine3,
                town: response.town,
                country: response.county,
                contactMethod: response.contactMethod,
                assistanceLocation: response.assistanceLocation,
                otherAssistanceLocation: response.otherAssistanceLocation,
                reasonForAssistance: Array.isArray(response.reasonForAssistance) ? new _immutable.List(response.reasonForAssistance) : response.reasonForAssistance,
                otherAssistanceType: response.otherAssistanceType,
                participateSurvey: (0, _text.yesNoToBoolean)(response.participateSurvey),
                participateImprovementSurvey: null,
                pushNotify: response.pushNotify,
                id: response.id
            };
        }
        return {};
    };

    PassengerAssistStore.prototype.setAccessibilityStatus = function setAccessibilityStatus(_ref8) {
        var status = _ref8.status;

        this.setState(this.state.set('accessibilityProfileStatus', status));
    };

    PassengerAssistStore.prototype.createAccessibilityProfile = function createAccessibilityProfile(_ref9) {
        var accessibilityProfile = _ref9.accessibilityProfile;

        this.setState(this.state.set('accessibilityProfile', this.normalizeGetAccessibilityProfileResponse(accessibilityProfile)).set('accessibilityProfileStatus', _constants.ACCESSIBILITY_PROFILE_STATUSES.CREATED));
    };

    PassengerAssistStore.prototype.updateAccessibilityProfile = function updateAccessibilityProfile(_ref10) {
        var accessibilityProfile = _ref10.accessibilityProfile;

        this.setState(this.state.set('accessibilityProfile', this.normalizeGetAccessibilityProfileResponse(accessibilityProfile)).set('accessibilityProfileStatus', _constants.ACCESSIBILITY_PROFILE_STATUSES.VIEW));
    };

    PassengerAssistStore.prototype.deleteAccessibilityProfile = function deleteAccessibilityProfile() {
        this.setState(this.state.set('accessibilityProfile', _AccessibilityProfileForm.defaultAccessibilityProfile).set('accessibilityProfileStatus', _constants.ACCESSIBILITY_PROFILE_STATUSES.CREATE));
    };

    PassengerAssistStore.prototype.getAccessibilityProfile = function getAccessibilityProfile() {
        return this.state.get('accessibilityProfile');
    };

    PassengerAssistStore.prototype.getAccessibilityProfileId = function getAccessibilityProfileId() {
        return this.state.get('accessibilityProfile').id;
    };

    PassengerAssistStore.prototype.setPreviousJourneys = function setPreviousJourneys(_ref11) {
        var _this2 = this;

        var previousJourneys = _ref11.previousJourneys,
            departureDate = _ref11.departureDate;

        var normalizedPreviousJourneys = previousJourneys.map(function (previousJourney) {
            var previousJourneyDepartureDate = (0, _moment2.default)(previousJourney.departureDate, 'DD/MM/YYYY');
            var previousJourneyArrivalDate = (0, _moment2.default)(previousJourney.arrivalDate, 'DD/MM/YYYY');
            var journeyDaysDiff = previousJourneyArrivalDate.diff(previousJourneyDepartureDate, 'days');
            var legs = previousJourney.legs.map(function (leg) {
                var legDepartureDate = (0, _moment2.default)(leg.departureDate, 'DD/MM/YYYY');
                var legArrivalDate = (0, _moment2.default)(leg.arrivalDate, 'DD/MM/YYYY');
                var legsDaysDiff = legArrivalDate.diff(legDepartureDate, 'days');
                return (0, _extends3.default)({}, leg, {
                    departureDate: departureDate.format('DD/MM/YYYY'),
                    arrivalDate: departureDate.clone().add(legsDaysDiff, 'days').format('DD/MM/YYYY')
                });
            });

            return (0, _extends3.default)({}, previousJourney, {
                departureDate: departureDate.format('DD/MM/YYYY'),
                arrivalDate: departureDate.clone().add(journeyDaysDiff, 'days').format('DD/MM/YYYY'),
                legs: legs
            });
        });

        var filterPreviousJourneys = function filterPreviousJourneys(journeys) {
            var isDepartureDateToday = departureDate.isSame((0, _moment2.default)(), 'day');
            if (!isDepartureDateToday) {
                return journeys;
            }
            return journeys.filter(function (journey) {
                return _this2.state.travelAssist.getJourneyDepartureMoment(journey).isAfter((0, _moment2.default)());
            });
        };

        var prevJourneys = filterPreviousJourneys(normalizedPreviousJourneys);
        this.setState(this.state.set('previousJourneys', new _immutable.List(prevJourneys.map(function (prevJourney) {
            return (0, _extends3.default)({}, prevJourney, { legs: new _immutable.List(prevJourney.legs) });
        }))));
    };

    PassengerAssistStore.prototype.setIsPreviousJourneysLoading = function setIsPreviousJourneysLoading(value) {
        return function () {
            this.setState(this.state.set('isPreviousJourneysLoading', value));
        };
    };

    PassengerAssistStore.prototype.setBookingPAStatus = function setBookingPAStatus(_ref12) {
        var status = _ref12.status;

        this.setState(this.state.set('bookingPAStatus', status));
    };

    PassengerAssistStore.prototype.setIsEditPAModeEnabled = function setIsEditPAModeEnabled(_ref13) {
        var isEditPAModeEnabled = _ref13.isEditPAModeEnabled;

        this.setState(this.state.set('isEditPAModeEnabled', isEditPAModeEnabled));
    };

    PassengerAssistStore.prototype.setEditPASection = function setEditPASection(_ref14) {
        var sectionIndex = _ref14.sectionIndex;

        this.setState(this.state.set('editPASection', sectionIndex));
    };

    PassengerAssistStore.prototype.setAssistedBookings = function setAssistedBookings(_ref15) {
        var assistedBookings = _ref15.assistedBookings;

        this.setState(this.state.set('assistedBookings', new _immutable.List(assistedBookings)));
    };

    PassengerAssistStore.prototype.setAssistedBooking = function setAssistedBooking(_ref16) {
        var assistedBooking = _ref16.assistedBooking;

        this.setState(this.state.set('assistedBooking', assistedBooking));
    };

    PassengerAssistStore.prototype.setPassengerAssistWidgetToggled = function setPassengerAssistWidgetToggled(_ref17) {
        var toggled = _ref17.toggled;

        this.setState(this.state.set('widgetToggled', toggled));
    };

    PassengerAssistStore.prototype.handleClear = function handleClear() {
        this.setState(this.getInitialState());
    };

    PassengerAssistStore.prototype.setAssistedBookingsLoading = function setAssistedBookingsLoading(value) {
        return function () {
            this.setState(this.state.set('isAssistedBookingsLoading', value));
        };
    };

    PassengerAssistStore.prototype.setAssistedBookingLoading = function setAssistedBookingLoading(value) {
        return function () {
            this.setState(this.state.set('isAssistedBookingLoading', value));
        };
    };

    PassengerAssistStore.prototype.setAccessibilityProfileStep = function setAccessibilityProfileStep(_ref18) {
        var step = _ref18.step;

        return this.setState(this.state.set('accessibilityProfileStepper', this.state.accessibilityProfileStepper.setActiveStep(step)));
    };

    PassengerAssistStore.prototype.setPrevAccessibilityProfileStep = function setPrevAccessibilityProfileStep() {
        return this.setState(this.state.set('accessibilityProfileStepper', this.state.accessibilityProfileStepper.handlePrevStep()));
    };

    PassengerAssistStore.prototype.setNextAccessibilityProfileStep = function setNextAccessibilityProfileStep() {
        return this.setState(this.state.set('accessibilityProfileStepper', this.state.accessibilityProfileStepper.handleNextStep()));
    };

    PassengerAssistStore.prototype.setBookingPAStep = function setBookingPAStep(_ref19) {
        var step = _ref19.step;

        return this.setState(this.state.set('bookingPAStepper', this.state.bookingPAStepper.setActiveStep(step)));
    };

    PassengerAssistStore.prototype.setPrevBookingPAStep = function setPrevBookingPAStep() {
        return this.setState(this.state.set('bookingPAStepper', this.state.bookingPAStepper.handlePrevStep()));
    };

    PassengerAssistStore.prototype.setNextBookingPAStep = function setNextBookingPAStep() {
        return this.setState(this.state.set('bookingPAStepper', this.state.bookingPAStepper.handleNextStep()));
    };

    PassengerAssistStore.prototype.setUseAccessibilityProfile = function setUseAccessibilityProfile(_ref20) {
        var useAccessibilityProfile = _ref20.useAccessibilityProfile;

        return this.setState(this.state.set('useAccessibilityProfile', useAccessibilityProfile));
    };

    PassengerAssistStore.prototype.deleteTravelAssist = function deleteTravelAssist(_ref21) {
        var travelAssist = _ref21.travelAssist;

        return this.setState(this.state.set('pendingTravelAssistRequests', this.state.pendingTravelAssistRequests.filter(function (req) {
            return req.orderTripId !== travelAssist.orderTripId;
        })));
    };

    PassengerAssistStore.prototype.setTravelAssist = function setTravelAssist(_ref22) {
        var travelAssist = _ref22.travelAssist;
        var _Object$entries$ = (0, _entries2.default)(travelAssist)[0],
            key = _Object$entries$[0],
            value = _Object$entries$[1];

        return this.setState(this.state.set('travelAssist', this.state.travelAssist.set(key, value)));
    };

    PassengerAssistStore.prototype.setPendingTravelAssistRequests = function setPendingTravelAssistRequests(_ref23) {
        var travelAssistRequests = _ref23.travelAssistRequests;

        var updated = this.state.pendingTravelAssistRequests.concat(travelAssistRequests);

        return this.setState(this.state.set('pendingTravelAssistRequests', updated));
    };

    PassengerAssistStore.prototype.setPendingTravelAssistRequestEnabled = function setPendingTravelAssistRequestEnabled(_ref24) {
        var params = _ref24.params;
        var orderTripId = params.orderTripId,
            enabled = params.enabled,
            direction = params.direction;


        var newState = this.state.pendingTravelAssistRequests.map(function (req) {
            if (req.orderTripId === orderTripId) {
                if (direction === 'Outward') {
                    return req.setOutwardEnabled(enabled);
                } else {
                    return req.setReturnEnabled(enabled);
                }
            } else {
                return req;
            }
        });

        return this.setState(this.state.set('pendingTravelAssistRequests', newState));
    };

    PassengerAssistStore.prototype.getPendingTravelAssistRequests = function getPendingTravelAssistRequests() {
        return this.get('pendingTravelAssistRequests');
    };

    PassengerAssistStore.prototype.clearPendingTravelAssistRequests = function clearPendingTravelAssistRequests() {
        return this.setState(this.state.set('pendingTravelAssistRequests', new _immutable.List()));
    };

    PassengerAssistStore.prototype.resetTravelAssist = function resetTravelAssist() {
        return this.setState(this.state.set('travelAssist', new _AssistedTravel2.default()));
    };

    PassengerAssistStore.prototype.resetOutwardJourney = function resetOutwardJourney() {
        return this.setState(this.state.set('travelAssist', this.state.travelAssist.set('outwardJourney', {})));
    };

    PassengerAssistStore.prototype.resetReturnJourney = function resetReturnJourney() {
        return this.setState(this.state.set('travelAssist', this.state.travelAssist.set('returnJourney', {})));
    };

    PassengerAssistStore.prototype.setBookingPAEnterAccessibilityProfileStep = function setBookingPAEnterAccessibilityProfileStep(_ref25) {
        var step = _ref25.step;

        return this.setState(this.state.set('bookingPAEnterAccessibilityProfileStep', step));
    };

    PassengerAssistStore.prototype.setShowBackToSearchResultsButton = function setShowBackToSearchResultsButton(_ref26) {
        var showButton = _ref26.showButton;

        return this.setState(this.state.set('showBackToSearchResultsButton', showButton));
    };

    PassengerAssistStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref27;

        return _ref27 = {}, _ref27[_AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE_FORM] = this.setAccessibilityProfileForm, _ref27[_AppConstants.ActionTypes.AUTO_POPULATE_ACCESSIBILITY_PROFILE_FORM] = this.setAccessibilityProfileForm, _ref27[_AppConstants.ActionTypes.RESET_ACCESSIBILITY_PROFILE_FORM] = this.resetAccessibilityProfileForm, _ref27[_AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE_STATUS] = this.setAccessibilityStatus, _ref27[_AppConstants.ActionTypes.GET_ACCESSIBILITY_PROFILE_STARTED] = this.setIsAccessibilityProfileLoading(true), _ref27[_AppConstants.ActionTypes.GET_ACCESSIBILITY_PROFILE_LOADED] = this.setLoadedAccessibilityProfile, _ref27[_AppConstants.ActionTypes.GET_ACCESSIBILITY_PROFILE_FINISHED] = this.setIsAccessibilityProfileLoading(false), _ref27[_AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE] = this.setAccessibilityProfile, _ref27[_AppConstants.ActionTypes.CREATE_ACCESSIBILITY_PROFILE_LOADED] = this.createAccessibilityProfile, _ref27[_AppConstants.ActionTypes.UPDATE_ACCESSIBILITY_PROFILE_LOADED] = this.updateAccessibilityProfile, _ref27[_AppConstants.ActionTypes.DELETE_ACCESSIBILITY_PROFILE_SUCCESS] = this.deleteAccessibilityProfile, _ref27[_AppConstants.ActionTypes.SET_BOOKING_PA_STATUS] = this.setBookingPAStatus, _ref27[_AppConstants.ActionTypes.SET_BOOKING_PA_ENTER_ACCESSIBILITY_PROFILE_STEP] = this.setBookingPAEnterAccessibilityProfileStep, _ref27[_AppConstants.ActionTypes.RESET_OUTWARD_JOURNEY] = this.resetOutwardJourney, _ref27[_AppConstants.ActionTypes.RESET_RETURN_JOURNEY] = this.resetReturnJourney, _ref27[_AppConstants.ActionTypes.USE_ACCESSIBILITY_PROFILE] = this.setUseAccessibilityProfile, _ref27[_AppConstants.ActionTypes.SET_IS_EDIT_PA_MODE_ENABLED] = this.setIsEditPAModeEnabled, _ref27[_AppConstants.ActionTypes.SET_EDIT_PA_SECTION] = this.setEditPASection, _ref27[_AppConstants.ActionTypes.SET_SHOW_BACK_TO_SEARCH_RESULTS_BUTTON] = this.setShowBackToSearchResultsButton, _ref27[_AppConstants.ActionTypes.GET_PREVIOUS_JOURNEYS_STARTED] = this.setIsPreviousJourneysLoading(true), _ref27[_AppConstants.ActionTypes.GET_PREVIOUS_JOURNEYS_SUCCESS] = this.setPreviousJourneys, _ref27[_AppConstants.ActionTypes.GET_PREVIOUS_JOURNEYS_FINISHED] = this.setIsPreviousJourneysLoading(false), _ref27[_AppConstants.ActionTypes.GET_ASSISTED_BOOKINGS_STARTED] = this.setAssistedBookingsLoading(true), _ref27[_AppConstants.ActionTypes.GET_ASSISTED_BOOKINGS_SUCCESS] = this.setAssistedBookings, _ref27[_AppConstants.ActionTypes.GET_ASSISTED_BOOKINGS_FINISHED] = this.setAssistedBookingsLoading(false), _ref27[_AppConstants.ActionTypes.GET_ASSISTED_BOOKING_STARTED] = this.setAssistedBookingLoading(true), _ref27[_AppConstants.ActionTypes.GET_ASSISTED_BOOKING_SUCCESS] = this.setAssistedBooking, _ref27[_AppConstants.ActionTypes.SET_PASSENGER_ASSIST_WIDGET_TOGGLED] = this.setPassengerAssistWidgetToggled, _ref27[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleClear, _ref27[_AppConstants.ActionTypes.BASKET_CLEARED] = this.handleClear, _ref27[_AppConstants.ActionTypes.ORDER_EXPIRED] = this.handleClear, _ref27[_AppConstants.ActionTypes.GET_ASSISTED_BOOKING_FINISHED] = this.setAssistedBookingLoading(false), _ref27[_AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE_STEP] = this.setAccessibilityProfileStep, _ref27[_AppConstants.ActionTypes.SET_NEXT_ACCESSIBILITY_PROFILE_STEP] = this.setNextAccessibilityProfileStep, _ref27[_AppConstants.ActionTypes.SET_PREV_ACCESSIBILITY_PROFILE_STEP] = this.setPrevAccessibilityProfileStep, _ref27[_AppConstants.ActionTypes.SET_BOOKING_PA_STEP] = this.setBookingPAStep, _ref27[_AppConstants.ActionTypes.SET_NEXT_BOOKING_PA_STEP] = this.setNextBookingPAStep, _ref27[_AppConstants.ActionTypes.SET_PREV_BOOKING_PA_STEP] = this.setPrevBookingPAStep, _ref27[_AppConstants.ActionTypes.SET_TRAVEL_ASSIST] = this.setTravelAssist, _ref27[_AppConstants.ActionTypes.DELETE_TRAVEL_ASSIST] = this.deleteTravelAssist, _ref27[_AppConstants.ActionTypes.SET_PENDING_TRAVEL_ASSIST_REQUESTS] = this.setPendingTravelAssistRequests, _ref27[_AppConstants.ActionTypes.SET_PENDING_TRAVEL_ASSIST_REQUEST_ENABLED] = this.setPendingTravelAssistRequestEnabled, _ref27[_AppConstants.ActionTypes.CLEAR_PENDING_TRAVEL_ASSIST_REQUESTS] = this.clearPendingTravelAssistRequests, _ref27[_AppConstants.ActionTypes.ADD_ORDER_TRIP_ID_TO_PASSENGER_ASSIST_REQUEST] = this.addOrderTripIdToTravelAssist, _ref27[_AppConstants.ActionTypes.RESET_TRAVEL_ASSIST] = this.resetTravelAssist, _ref27;
    };

    return PassengerAssistStore;
}(_BaseStore3.default);

var instance = new PassengerAssistStore({ storageKey: 'passenger-assist' });

exports.default = instance;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormError(_ref) {
    var id = _ref.id,
        className = _ref.className,
        message = _ref.message;

    return _react2.default.createElement(
        'p',
        { id: id, className: 'alert alert-danger ' + className },
        message
    );
}

FormError.propTypes = {
    id: _propTypes2.default.string,
    message: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string
};

FormError.defaultProps = {
    className: ''
};

exports.default = FormError;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CurrentTripStore = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _Trip = __webpack_require__(199);

var _Trip2 = _interopRequireDefault(_Trip);

var _OverallCheapestSelection = __webpack_require__(539);

var _OverallCheapestSelection2 = _interopRequireDefault(_OverallCheapestSelection);

var _CheapestMatchingFares = __webpack_require__(1729);

var _CheapestMatchingFares2 = _interopRequireDefault(_CheapestMatchingFares);

var _Passengers = __webpack_require__(652);

var _Passengers2 = _interopRequireDefault(_Passengers);

var _AppConstants = __webpack_require__(6);

var _Photocard = __webpack_require__(279);

var _Photocard2 = _interopRequireDefault(_Photocard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrentTripStore = exports.CurrentTripStore = function (_BaseStore) {
    (0, _inherits3.default)(CurrentTripStore, _BaseStore);

    function CurrentTripStore() {
        (0, _classCallCheck3.default)(this, CurrentTripStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    CurrentTripStore.prototype.get = function get() {
        return this.state;
    };

    CurrentTripStore.prototype.deserialize = function deserialize(state) {
        return state ? _Trip2.default.fromJSON(state) : new _Trip2.default();
    };

    CurrentTripStore.prototype.serialize = function serialize() {
        return (0, _assign2.default)(this.state.toJS(), {
            searchClass: this.state.search.constructor.name
        });
    };

    CurrentTripStore.prototype.handleInwardServiceSelected = function handleInwardServiceSelected(_ref) {
        var service = _ref.service;

        this.setState(this.state.set('returnJourney', service).set('raw', false).setIn(['fares', 'returnSingle'], null));
    };

    CurrentTripStore.prototype.handleOutwardServiceSelected = function handleOutwardServiceSelected(_ref2) {
        var service = _ref2.service;

        this.setState(this.state.set('outwardJourney', service).set('raw', false).resetFares());
    };

    CurrentTripStore.prototype.handleSelectFare = function handleSelectFare(_ref3) {
        var fare = _ref3.fare,
            direction = _ref3.direction,
            service = _ref3.service,
            fareCategory = _ref3.fareCategory,
            fareClass = _ref3.fareClass;

        this.setState(this.state.set('fareCategory', fareCategory).set('fareClass', fareClass).setFareForDirection(direction, fare).setServiceForDirection(direction, service).setSeatingForDirection(direction, fare, service).set('raw', false));
    };

    CurrentTripStore.prototype.handleSelectingCheapestFare = function handleSelectingCheapestFare() {
        this.setState(this.state.set('selectingCheapestFare', true));
    };

    CurrentTripStore.prototype.handleSelectingNonCheapestFare = function handleSelectingNonCheapestFare() {
        this.setState(this.state.set('selectingCheapestFare', false));
    };

    CurrentTripStore.prototype.handleSelectSeasonTicket = function handleSelectSeasonTicket(_ref4) {
        var fare = _ref4.fare;

        this.setState(this.state.setSeasonFare(fare));
    };

    CurrentTripStore.prototype.handleSelectDaySaveTicket = function handleSelectDaySaveTicket(_ref5) {
        var fare = _ref5.fare;

        this.setState(this.state.setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, fare));
    };

    CurrentTripStore.prototype.handleSelectRoversRangersTicket = function handleSelectRoversRangersTicket(_ref6) {
        var fare = _ref6.fare;

        var passengers = _Passengers2.default.fromTickets(fare.ticketType, fare.tickets);
        this.setState(this.state.setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, fare).set('passengers', passengers));
    };

    CurrentTripStore.prototype.handlePassengersUpdate = function handlePassengersUpdate(_ref7) {
        var pax = _ref7.pax;

        this.setState(this.state.set('passengers', this.state.passengers.set('pax', pax)));
    };

    CurrentTripStore.prototype.handlePhotocardUpdate = function handlePhotocardUpdate(_ref8) {
        var photocard = _ref8.photocard;

        this.setState(this.state.set('photocard', photocard));
    };

    CurrentTripStore.prototype.handlePhotocardFieldUpdate = function handlePhotocardFieldUpdate(_ref9) {
        var field = _ref9.field,
            value = _ref9.value;

        this.setState(this.state.setIn(['photocard', field], value));
    };

    CurrentTripStore.prototype.handleClearPhotocard = function handleClearPhotocard() {
        this.setState(this.state.set('photocard', new _Photocard2.default()));
    };

    CurrentTripStore.prototype.handleSeasonSearchFinished = function handleSeasonSearchFinished(_ref10) {
        var seasonTickets = _ref10.seasonTickets;

        if (!seasonTickets.includes(this.state.getSeasonFare())) {
            var selectedFare = void 0;
            var fare = seasonTickets.first();

            if (fare) {
                selectedFare = fare;
            }

            this.handleSelectSeasonTicket({ fare: selectedFare });
        }
    };

    CurrentTripStore.prototype.handleOtherSearchFinished = function handleOtherSearchFinished(_ref11) {
        var searchResults = _ref11.searchResults;

        var fare = searchResults.first();
        if (fare) {
            var passengers = _Passengers2.default.fromTickets(fare.ticketType, fare.tickets);
            this.setState(this.state.setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, fare).set('passengers', passengers));
        }
    };

    CurrentTripStore.prototype.handleSmartCarnetFinshed = function handleSmartCarnetFinshed(_ref12) {
        var fares = _ref12.fares;

        var fare = fares.first();
        var passengers = _Passengers2.default.fromTickets(fare.ticketType, fare.tickets);
        this.setState(this.state.set('passengers', passengers));
    };

    CurrentTripStore.prototype.handleSelectSmartCarnetTicket = function handleSelectSmartCarnetTicket(_ref13) {
        var fare = _ref13.fare;

        if (fare) {
            var passengers = _Passengers2.default.fromTickets(fare.ticketType, fare.tickets);

            this.setState(this.state.setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, fare).set('passengers', passengers));
        } else {
            this.setState(this.state.setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, fare));
        }
    };

    CurrentTripStore.prototype.handleSelectSmartCarnetTicketReturn = function handleSelectSmartCarnetTicketReturn(_ref14) {
        var fare = _ref14.fare;

        this.setState(this.state.setFareForDirection(_AppConstants.JourneyDirections.INWARD, fare));
    };

    CurrentTripStore.prototype.handleOrderTripCreated = function handleOrderTripCreated(_ref15) {
        var trip = _ref15.trip;

        this.setState(trip);
    };

    CurrentTripStore.prototype.handleSearchStarted = function handleSearchStarted(_ref16) {
        var search = _ref16.search;

        this.setState(new _Trip2.default({ search: search }));
    };

    CurrentTripStore.prototype.handleSearchUpdated = function handleSearchUpdated(_ref17) {
        var search = _ref17.search;

        this.setState(this.state.set('search', search));
    };

    CurrentTripStore.prototype.handleResultsUpdated = function handleResultsUpdated(_ref18) {
        var _this2 = this;

        var result = _ref18.result,
            tripDirection = _ref18.tripDirection;


        var isDisabledForTrip = function isDisabledForTrip(service) {
            return !service.isDisabledForTrip(_this2.state);
        };

        this.setState(this.state.set('cheapest', _OverallCheapestSelection2.default.fromServices(result.outward, result.inward, this.state)).set('cheapestFastest', _CheapestMatchingFares2.default.fromServices.apply(_CheapestMatchingFares2.default, this.getFastestServices(result.outward.filter(isDisabledForTrip), result.inward.filter(isDisabledForTrip))).getOverallCheapest()).set('cheapestFirstClass', _CheapestMatchingFares2.default.fromServices(result.outward.filter(isDisabledForTrip), result.inward.filter(isDisabledForTrip), function (fare) {
            return fare.isFirstClass();
        }).getOverallCheapest()).set('hasServiceProvider', result.hasServiceProvider).resetSelected(tripDirection));

        if (this.state.search.targetLayout === _AppConstants.JourneyPlannerLayout.GRID || this.state.search.targetLayout === _AppConstants.JourneyPlannerLayout.GRID_2) {
            this.handlePreselectCheapest();
        }
    };

    CurrentTripStore.prototype.handleSearchFinished = function handleSearchFinished(_ref19) {
        var _this3 = this;

        var outward = _ref19.outward,
            inward = _ref19.inward,
            hasServiceProvider = _ref19.hasServiceProvider;

        var isDisabledForTrip = function isDisabledForTrip(service) {
            return !service.isDisabledForTrip(_this3.state);
        };

        this.setState(this.state.set('cheapest', _OverallCheapestSelection2.default.fromServices(outward, inward, this.state)).set('cheapestFastest', _CheapestMatchingFares2.default.fromServices.apply(_CheapestMatchingFares2.default, this.getFastestServices(outward.filter(isDisabledForTrip), inward.filter(isDisabledForTrip))).getOverallCheapest()).set('cheapestFirstClass', _CheapestMatchingFares2.default.fromServices(outward.filter(isDisabledForTrip), inward.filter(isDisabledForTrip), function (fare) {
            return fare.isFirstClass();
        }).getOverallCheapest()).set('hasServiceProvider', hasServiceProvider));

        if (this.state.search.targetLayout === _AppConstants.JourneyPlannerLayout.GRID || this.state.search.targetLayout === _AppConstants.JourneyPlannerLayout.GRID_2) {
            this.handlePreselectCheapest();
        }
    };

    CurrentTripStore.prototype.getFastestServices = function getFastestServices(outward, inward) {
        var getServiceDuration = function getServiceDuration(service) {
            return service.journey.getTripDuration();
        };
        var getFastest = function getFastest(services) {
            return services.sortBy(getServiceDuration).groupBy(getServiceDuration).first();
        };
        return [getFastest(outward), inward && getFastest(inward)];
    };

    CurrentTripStore.prototype.handleClear = function handleClear() {
        this.setState(this.state.resetSelected());
    };

    CurrentTripStore.prototype.handlePlusBusLoaded = function handlePlusBusLoaded(_ref20) {
        var plusBus = _ref20.plusBus;

        this.setState(this.state.set('plusBusAvailability', plusBus));
    };

    CurrentTripStore.prototype.handleSelectFareCategory = function handleSelectFareCategory(_ref21) {
        var fareCategory = _ref21.fareCategory,
            service = _ref21.service,
            fareClass = _ref21.fareClass;

        this.setState(this.state.set('fareCategory', fareCategory).set('fareClass', fareClass).set('outwardJourney', service).set('returnJourney', null).resetFares());
    };

    CurrentTripStore.prototype.handleUpdateDisplayFilters = function handleUpdateDisplayFilters(_ref22) {
        var filters = _ref22.filters;

        var newState = this.state.set('filters', filters);
        if (filters.selection !== this.state.filters.selection) {
            newState = this.getPreselectedState(newState);
        }
        this.setState(newState);
    };

    CurrentTripStore.prototype.handlePreselectCheapest = function handlePreselectCheapest() {
        this.setState(this.getPreselectedState());
    };

    CurrentTripStore.prototype.getPreselectedState = function getPreselectedState() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

        var _ref23 = state.filters || _AppConstants.FareFilterSelections.CHEAPEST,
            selection = _ref23.selection;

        var cheapestSelection = selection === _AppConstants.FareFilterSelections.FASTEST ? state.cheapestFastest : selection === _AppConstants.FareFilterSelections.FIRST_CLASS ? state.cheapestFirstClass : state.cheapest;
        var fareCategory = state.getCheapestFareCategory(cheapestSelection);
        var fareClass = state.getCheapestFareClass(cheapestSelection);

        var newState = state.set('fareCategory', fareCategory).set('fareClass', fareClass).set('outwardJourney', cheapestSelection.outwardService).set('returnJourney', cheapestSelection.inboundService);

        if (cheapestSelection.hasOutwardFare()) {
            newState = newState.setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, cheapestSelection.getOutwardFare()).setSeatingForDirection(_AppConstants.JourneyDirections.OUTWARD, cheapestSelection.getOutwardFare(), cheapestSelection.outwardService);
        }

        if (cheapestSelection.hasInwardFare()) {
            newState = newState.setFareForDirection(_AppConstants.JourneyDirections.INWARD, cheapestSelection.getInwardFare()).setSeatingForDirection(_AppConstants.JourneyDirections.INWARD, cheapestSelection.getInwardFare(), cheapestSelection.inboundService);
        }

        if (cheapestSelection.hasReturnFare()) {
            newState = newState.setFareForDirection(_AppConstants.JourneyDirections.OUTWARD, cheapestSelection.getReturnFare());
        }

        return newState;
    };

    CurrentTripStore.prototype.handleSelectFareOnly = function handleSelectFareOnly(_ref24) {
        var fare = _ref24.fare;

        this.setState(this.state.setFareOnlyFare(fare));
    };

    CurrentTripStore.prototype.handleSetRequestBikeReservation = function handleSetRequestBikeReservation(_ref25) {
        var bikes = _ref25.bikes;

        return this.setState(this.state.set('bikes', bikes));
    };

    CurrentTripStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref26;

        return _ref26 = {}, _ref26[_AppConstants.ActionTypes.INWARD_SERVICE_SELECTED] = this.handleInwardServiceSelected, _ref26[_AppConstants.ActionTypes.OUTWARD_SERVICE_SELECTED] = this.handleOutwardServiceSelected, _ref26[_AppConstants.ActionTypes.FARE_SELECTED] = this.handleSelectFare, _ref26[_AppConstants.ActionTypes.FARE_ONLY_SELECTED] = this.handleSelectFareOnly, _ref26[_AppConstants.ActionTypes.SELECTING_CHEAPEST_FARE] = this.handleSelectingCheapestFare, _ref26[_AppConstants.ActionTypes.SELECTING_NON_CHEAPEST_FARE] = this.handleSelectingNonCheapestFare, _ref26[_AppConstants.ActionTypes.TRIP_UPDATED] = this.handleOrderTripCreated, _ref26[_AppConstants.ActionTypes.ORDER_PLUSBUS_UPDATED] = this.handleOrderTripCreated, _ref26[_AppConstants.ActionTypes.SEASON_TICKET_SELECTED] = this.handleSelectSeasonTicket, _ref26[_AppConstants.ActionTypes.SEASON_TICKET_PHOTOCARD_UPDATED] = this.handlePhotocardUpdate, _ref26[_AppConstants.ActionTypes.SEASON_TICKET_PHOTOCARD_FIELD_UPDATED] = this.handlePhotocardFieldUpdate, _ref26[_AppConstants.ActionTypes.SEASON_TICKET_PHOTOCARD_CLEAR] = this.handleClearPhotocard, _ref26[_AppConstants.ActionTypes.ORDER_TRIP_CREATED] = this.handleOrderTripCreated, _ref26[_AppConstants.ActionTypes.ORDER_CREATED] = this.handleOrderTripCreated, _ref26[_AppConstants.ActionTypes.PRESELECT_CHEAPEST] = this.handlePreselectCheapest, _ref26[_AppConstants.ActionTypes.UPDATE_DISPLAY_FILTERS] = this.handleUpdateDisplayFilters, _ref26[_AppConstants.ActionTypes.SEARCH_FAILED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.SEARCH_STARTED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.SEARCH_LOADED] = this.handleSearchUpdated, _ref26[_AppConstants.ActionTypes.SEARCH_UPDATED] = this.handleSearchUpdated, _ref26[_AppConstants.ActionTypes.SEARCH_FINISHED] = this.handleSearchFinished, _ref26[_AppConstants.ActionTypes.FARE_ONLY_SEARCH_STARTED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.SEASON_SEARCH_LOADED] = this.handleSearchUpdated, _ref26[_AppConstants.ActionTypes.SEASON_SEARCH_STARTED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.SEASON_SEARCH_FINISHED] = this.handleSeasonSearchFinished, _ref26[_AppConstants.ActionTypes.DAYSAVE_SEARCH_STARTED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.DAYSAVE_SEARCH_FINISHED] = this.handleOtherSearchFinished, _ref26[_AppConstants.ActionTypes.DAYSAVE_TICKET_SELECTED] = this.handleSelectDaySaveTicket, _ref26[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_STARTED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_FINISHED] = this.handleOtherSearchFinished, _ref26[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_LOADED] = this.handleSearchUpdated, _ref26[_AppConstants.ActionTypes.ROVERSRANGERS_TICKET_PASSENGERS_CHANGED] = this.handlePassengersUpdate, _ref26[_AppConstants.ActionTypes.ROVERSRANGERS_TICKET_SELECTED] = this.handleSelectRoversRangersTicket, _ref26[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_STARTED] = this.handleSearchStarted, _ref26[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_FINISHED] = this.handleSmartCarnetFinshed, _ref26[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_SELECTED] = this.handleSelectSmartCarnetTicket, _ref26[_AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_SELECTED] = this.handleSelectSmartCarnetTicketReturn, _ref26[_AppConstants.ActionTypes.ORDER_PAID] = this.handleClear, _ref26[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleClear, _ref26[_AppConstants.ActionTypes.TRIP_PLUSBUS_AVAILABILITY_LOADED] = this.handlePlusBusLoaded, _ref26[_AppConstants.ActionTypes.SHOW_EARLIER_TRAINS_STARTED] = this.handleSearchUpdated, _ref26[_AppConstants.ActionTypes.SHOW_LATER_TRAINS_STARTED] = this.handleSearchUpdated, _ref26[_AppConstants.ActionTypes.SHOW_EARLIER_TRAINS_FINISHED] = this.handleResultsUpdated, _ref26[_AppConstants.ActionTypes.SHOW_LATER_TRAINS_FINISHED] = this.handleResultsUpdated, _ref26[_AppConstants.ActionTypes.FARE_CATEGORY_SELECTED] = this.handleSelectFareCategory, _ref26[_AppConstants.ActionTypes.SEASON_RESULTS_FILTERS_CHANGE] = this.handleSeasonSearchFinished, _ref26[_AppConstants.ActionTypes.SET_TRIP_BIKES] = this.handleSetRequestBikeReservation, _ref26;
    };

    return CurrentTripStore;
}(_BaseStore3.default);

var instance = new CurrentTripStore({ storageKey: 'current-trip' });

exports.default = instance;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(288),
    baseClone = __webpack_require__(827),
    baseUnset = __webpack_require__(1726),
    castPath = __webpack_require__(187),
    copyObject = __webpack_require__(229),
    customOmitClone = __webpack_require__(1727),
    flatRest = __webpack_require__(792),
    getAllKeysIn = __webpack_require__(536);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */



/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function(obj) {
  var ret = {};
  var key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _FormControlFeedback = _interopRequireDefault(__webpack_require__(1983));

var _FormControlStatic = _interopRequireDefault(__webpack_require__(1984));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var propTypes = {
  componentClass: _elementType.default,

  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: _propTypes.default.string,

  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: _propTypes.default.string,

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: _propTypes.default.func
};
var defaultProps = {
  componentClass: 'input'
};
var contextTypes = {
  $bs_formGroup: _propTypes.default.object
};

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FormControl, _React$Component);

  function FormControl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControl.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;
    var _this$props = this.props,
        Component = _this$props.componentClass,
        type = _this$props.type,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? controlId : _this$props$id,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        bsSize = _this$props.bsSize,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? (0, _warning.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.

    var classes;

    if (type !== 'file') {
      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    } // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm


    if (bsSize) {
      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
      classes[(0, _bootstrapUtils.prefix)({
        bsClass: 'input'
      }, size)] = true;
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return FormControl;
}(_react.default.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;
FormControl.Feedback = _FormControlFeedback.default;
FormControl.Static = _FormControlStatic.default;

var _default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(206)('meta');
var isObject = __webpack_require__(48);
var has = __webpack_require__(120);
var setDesc = __webpack_require__(71).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(40)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(56)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(111)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(135);
var createDesc = __webpack_require__(299);
module.exports = __webpack_require__(124) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(497);
var defined = __webpack_require__(370);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(68),
    isKey = __webpack_require__(514),
    stringToPath = __webpack_require__(1469),
    toString = __webpack_require__(119);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(308);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(548);
var defined = __webpack_require__(397);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(167);
var createDesc = __webpack_require__(322);
module.exports = __webpack_require__(154) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(139);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(324);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _pickBy2 = __webpack_require__(161);

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _immutable = __webpack_require__(5);

var _Route = __webpack_require__(319);

var _Route2 = _interopRequireDefault(_Route);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _Railcard = __webpack_require__(241);

var _Railcard2 = _interopRequireDefault(_Railcard);

var _Photocard = __webpack_require__(279);

var _Photocard2 = _interopRequireDefault(_Photocard);

var _ValidityPeriod = __webpack_require__(395);

var _ValidityPeriod2 = _interopRequireDefault(_ValidityPeriod);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _Fulfilment = __webpack_require__(349);

var _Fulfilment2 = _interopRequireDefault(_Fulfilment);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Railcards = __webpack_require__(818);

var _SearchUrls = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    id: [_LinkMapper.fields.number],
    origin: [_LinkMapper.resolve.as(_Station2.default), new _Station2.default()],
    destination: [_LinkMapper.resolve.as(_Station2.default), new _Station2.default()],
    adults: [_LinkMapper.fields.number, 1],
    children: [_LinkMapper.fields.number, 0],
    passengerCount: [_LinkMapper.fields.number],
    route: [_LinkMapper.resolve.as(_Route2.default), new _Route2.default()],
    ticketType: [_LinkMapper.resolve.as(_TicketType2.default), new _TicketType2.default()],
    smartTicketType: [_LinkMapper.fields.string],
    railcards: [_LinkMapper.resolveAll.as(_Railcard2.default), new _immutable.List()],
    isSeason: [_LinkMapper.fields.boolean, false],
    isSmartcard: [_LinkMapper.fields.boolean, false],
    isOpenReturn: [_LinkMapper.fields.boolean, false],
    fareClass: [_LinkMapper.fields.string],
    duration: [_LinkMapper.fields.string],
    outwardPlusBusOrigin: [_LinkMapper.resolve.as(_Station2.default)],
    outwardPlusBusDestination: [_LinkMapper.resolve.as(_Station2.default)],
    returnPlusBusOrigin: [_LinkMapper.resolve.as(_Station2.default)],
    returnPlusBusDestination: [_LinkMapper.resolve.as(_Station2.default)],
    delivery: [_LinkMapper.resolve.as(_Fulfilment2.default)],
    photocard: [_LinkMapper.resolve.as(_Photocard2.default)],
    seasonExpiry: [_LinkMapper.fields.datetime, null],
    lastUsed: [_LinkMapper.fields.datetime, null]
};

var Favourite = function (_record) {
    (0, _inherits3.default)(Favourite, _record);

    function Favourite() {
        (0, _classCallCheck3.default)(this, Favourite);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Favourite.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Favourite, json, (0, _Records.getResolvers)(schema));
    };

    Favourite.prototype.toJSON = function toJSON() {
        var _this2 = this;

        return (0, _SearchUrls.serialize)({
            id: _SearchUrls.serializers.identity,
            origin: _SearchUrls.serializers.stationNlc,
            destination: _SearchUrls.serializers.stationNlc,
            adults: _SearchUrls.serializers.identity,
            children: _SearchUrls.serializers.identity,
            passengerCount: _SearchUrls.serializers.identity,
            route: _SearchUrls.serializers.code,
            ticketType: _SearchUrls.serializers.code,
            smartTicketType: _SearchUrls.serializers.identity,
            railcards: _SearchUrls.serializers.railcardCodes,
            isSmartcard: _SearchUrls.serializers.identity,
            isFlexi: function isFlexi() {
                return _this2.isFlexi();
            },
            isSeason: function isSeason() {
                return _this2.isSeason();
            },
            isOpenReturn: _SearchUrls.serializers.identity,
            fareClass: function fareClass() {
                return _AppConstants.FareClasses[_this2.isFirstClass() ? 'FIRST_CLASS' : 'STANDARD'];
            },
            duration: function duration(_duration) {
                return _duration ? [_duration] : null;
            },
            outwardPlusBusOrigin: function outwardPlusBusOrigin(_outwardPlusBusOrigin) {
                return _outwardPlusBusOrigin ? _SearchUrls.serializers.stationNlc : null;
            },
            outwardPlusBusDestination: function outwardPlusBusDestination(_outwardPlusBusDestination) {
                return _outwardPlusBusDestination ? _SearchUrls.serializers.stationNlc : null;
            },
            returnPlusBusOrigin: function returnPlusBusOrigin(_returnPlusBusOrigin) {
                return _returnPlusBusOrigin ? _SearchUrls.serializers.stationNlc : null;
            },
            returnPlusBusDestination: function returnPlusBusDestination(_returnPlusBusDestination) {
                return _returnPlusBusDestination ? _SearchUrls.serializers.stationNlc : null;
            },
            deliveryId: function deliveryId(_deliveryId) {
                return _deliveryId ? _SearchUrls.serializers.identity : null;
            },
            delivery: function delivery(_delivery) {
                return _delivery ? _delivery.id : null;
            },
            photocard: function photocard(_photocard) {
                return _photocard ? _photocard.number : null;
            },
            seasonExpiry: function seasonExpiry(_seasonExpiry) {
                return _seasonExpiry ? _SearchUrls.serializers.date : null;
            },
            lastUsed: function lastUsed(_lastUsed) {
                return _lastUsed ? _SearchUrls.serializers.date : null;
            }
        }, this);
    };

    Favourite.prototype.matchPlusBus = function matchPlusBus(orderTrip) {
        // Get plusbus station NLCs from the `Favourite`
        var reorderablePlusBus = {
            outwardOrigin: this.getIn(['outwardPlusBusOrigin', 'nlc']),
            outwardDestination: this.getIn(['outwardPlusBusDestination', 'nlc']),
            returnOrigin: this.getIn(['returnPlusBusOrigin', 'nlc']),
            returnDestination: this.getIn(['returnPlusBusDestination', 'nlc'])
        };

        // Get plusbus station NLCs from `OrderTrip`
        var plusBusFares = orderTrip.getPlusBus();
        var getPlusBusStation = function getPlusBusStation(direction, terminal) {
            return plusBusFares.getIn([direction, terminal, terminal, 'nlc']);
        };
        var orderTripPlusBus = {
            outwardOrigin: getPlusBusStation('outward', 'origin'),
            outwardDestination: getPlusBusStation('outward', 'destination'),
            returnOrigin: getPlusBusStation('return', 'origin'),
            returnDestination: getPlusBusStation('return', 'destination')
        };

        // Compare stations
        // Use _.pickBy to strip out null/undefined, etc
        return (0, _isEqual3.default)((0, _pickBy3.default)(reorderablePlusBus), (0, _pickBy3.default)(orderTripPlusBus));
    };

    /**
     * @param {OrderFare|Fare} fare
     * @param {OrderTrip} orderTrip
     */


    Favourite.prototype.matchFare = function matchFare(fare, orderTrip) {
        return this.origin.nlc === fare.origin.nlc && this.destination.nlc === fare.destination.nlc && this.adults === fare.adults() && this.children === fare.children() && this.route.code === fare.route.code && this.ticketType.code === fare.ticketType.code && this.ticketType.isSeason === fare.isSeason() && this.isOpenReturn === fare.isReturn() && this.isFirstClass() === fare.isFirstClass() && (this.duration && this.ticketType.isSeason && !this.ticketType.isFlexi ? this.duration === fare.getOutwardValidityPeriod().toISOString() : true) && (0, _Railcards.matchRailcards)(this, fare) && (orderTrip ? this.matchPlusBus(orderTrip) : true);
    };

    Favourite.prototype.getRailcardCounts = function getRailcardCounts() {
        var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'code';

        return this.railcards.filterNot(function (railcard) {
            return railcard.isGroupSave();
        }).reduce(function (counts, railcard) {
            return counts.update(railcard[property], 0, function (quantity) {
                return ++quantity;
            });
        }, new _immutable.Map());
    };

    Favourite.prototype.getPassengerRailcards = function getPassengerRailcards() {
        return this.getRailcardCounts('code').map(function (quantity, code) {
            return new _PassengerRailcard2.default({ code: code, quantity: quantity });
        }).toList();
    };

    /**
     * @param {OrderFare} orderFare
     * @return {Favourite}
     */


    Favourite.fromFare = function fromFare(orderFare) {
        return new Favourite({
            origin: orderFare.origin,
            destination: orderFare.destination,
            adults: orderFare.adults(),
            children: orderFare.children(),
            route: orderFare.route,
            ticketType: orderFare.ticketType,
            smartTicketType: orderFare.smartTicketType,
            railcards: orderFare.getAllRailcards(),
            isSmartcard: orderFare.isSmartcard(),
            isOpenReturn: orderFare.isReturn(),
            fareClass: _AppConstants.FareClasses[orderFare.isFirstClass() ? 'FIRST_CLASS' : 'STANDARD'],
            duration: orderFare.getOutwardValidityPeriod().toISOString(),
            passenger: orderFare.getPassengers().first()
        });
    };

    Favourite.prototype.hasRailcard = function hasRailcard() {
        return this.railcards.filterNot(function (railcard) {
            return railcard.isGroupSave();
        }).size > 0;
    };

    Favourite.prototype.hasPlusBus = function hasPlusBus() {
        return this.outwardPlusBusOrigin || this.outwardPlusBusDestination || this.returnPlusBusOrigin || this.returnPlusBusDestination;
    };

    Favourite.prototype.isTravelcard = function isTravelcard() {
        return this.origin && this.origin.isTravelcard() || this.destination && this.destination.isTravelcard();
    };

    Favourite.prototype.isFlexi = function isFlexi() {
        return this.ticketType.isFlexi;
    };

    Favourite.prototype.isSeason = function isSeason() {
        return this.ticketType.isSeason;
    };

    Favourite.prototype.isReorderable = function isReorderable() {
        return !(this.ticketType.isPlusBus() || this.ticketType.isAdvance || this.ticketType.isDaySave());
    };

    Favourite.prototype.isReturn = function isReturn() {
        return this.isOpenReturn;
    };

    Favourite.prototype.getAllRailcards = function getAllRailcards() {
        return this.railcards;
    };

    Favourite.prototype.isFirstClass = function isFirstClass() {
        return this.ticketType.isFirstClass;
    };

    Favourite.prototype.getDuration = function getDuration() {
        return _TrainTime2.default.duration(this.duration);
    };

    Favourite.prototype.getOutwardValidityPeriod = function getOutwardValidityPeriod() {
        var duration = this.getDuration(),
            days = duration.days(),
            months = duration.months() + duration.years() * 12;

        return new _ValidityPeriod2.default({ days: days, months: months });
    };

    Favourite.prototype.getPassengers = function getPassengers() {
        return _immutable.List.of(this.passenger);
    };

    Favourite.prototype.getPhotocard = function getPhotocard() {
        return this.photocard;
    };

    Favourite.prototype.hasPhotocard = function hasPhotocard() {
        return !!this.getPhotocard();
    };

    Favourite.prototype.hasDelivery = function hasDelivery() {
        return this.delivery;
    };

    Favourite.prototype.getMatchingTripFares = function getMatchingTripFares(trips) {
        var _this3 = this;

        return trips.filter(function (trip) {
            return trip.getJourneyFares().filter(function (fare) {
                return _this3.matchFare(fare, trip);
            }).isEmpty() === false;
        });
    };

    Favourite.prototype.hasMatchingTripFares = function hasMatchingTripFares(trips) {
        return this.getMatchingTripFares(trips).size > 0;
    };

    Favourite.prototype.getDaysToExpiry = function getDaysToExpiry() {
        return this.seasonExpiry && this.seasonExpiry.date() - (0, _TrainTime2.default)().date();
    };

    Favourite.prototype.isExpiringSoon = function isExpiringSoon() {
        if (!this.seasonExpiry) {
            return false;
        }

        var expiryDate = this.seasonExpiry.date();
        var todayDate = (0, _TrainTime2.default)().date();
        var dateDiff = expiryDate - todayDate;

        var isUpcoming = expiryDate >= todayDate;
        var withinThreshold = dateDiff >= 0 && dateDiff < _AppConstants.FavouriteSeasonExpiringSoonThresholdDays;

        return isUpcoming && withinThreshold;
    };

    (0, _createClass3.default)(Favourite, [{
        key: 'deliveryId',
        get: function get() {
            var deliveryId = this.getIn(['delivery', 'id']);
            return deliveryId && Number(deliveryId);
        }
    }]);
    return Favourite;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = Favourite;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _invokeMap2 = __webpack_require__(1003);

var _invokeMap3 = _interopRequireDefault(_invokeMap2);

var _some2 = __webpack_require__(284);

var _some3 = _interopRequireDefault(_some2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _immutable = __webpack_require__(5);

var _uuid = __webpack_require__(270);

var _uuid2 = _interopRequireDefault(_uuid);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _PlusBus = __webpack_require__(343);

var _PlusBus2 = _interopRequireDefault(_PlusBus);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _OverallCheapestSelection = __webpack_require__(539);

var _OverallCheapestSelection2 = _interopRequireDefault(_OverallCheapestSelection);

var _DaySaveSearch = __webpack_require__(420);

var _DaySaveSearch2 = _interopRequireDefault(_DaySaveSearch);

var _RoversRangersSearch = __webpack_require__(595);

var _RoversRangersSearch2 = _interopRequireDefault(_RoversRangersSearch);

var _SmartCarnetRecordSearch = __webpack_require__(436);

var _SmartCarnetRecordSearch2 = _interopRequireDefault(_SmartCarnetRecordSearch);

var _TripFares = __webpack_require__(1712);

var _TripFares2 = _interopRequireDefault(_TripFares);

var _Photocard = __webpack_require__(279);

var _Photocard2 = _interopRequireDefault(_Photocard);

var _DisplayFilters = __webpack_require__(1096);

var _DisplayFilters2 = _interopRequireDefault(_DisplayFilters);

var _SeatingPreferences = __webpack_require__(671);

var _SeatingPreferences2 = _interopRequireDefault(_SeatingPreferences);

var _Service = __webpack_require__(273);

var _Service2 = _interopRequireDefault(_Service);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _Passengers = __webpack_require__(652);

var _Passengers2 = _interopRequireDefault(_Passengers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    fares: new _TripFares2.default(),
    fareCategory: null,
    fareCategoryDetail: null,
    fareTicketTypeCode: null,
    fareRouteCode: null,
    fareDestination: null,
    fareOrigin: null,
    selectingCheapestFare: true,
    fareClass: null,
    outwardJourney: null,
    returnJourney: null,
    reservationPreferences: new _SeatingPreferences2.default(),
    photocard: new _Photocard2.default(),
    passengers: new _Passengers2.default(),
    orderTripId: null,
    search: new _Search2.default(),
    plusBusAvailability: null,
    cheapest: new _OverallCheapestSelection2.default(),
    cheapestFastest: new _OverallCheapestSelection2.default(),
    cheapestFirstClass: new _OverallCheapestSelection2.default(),
    filters: new _DisplayFilters2.default(),
    hasServiceProvider: false,
    listStep: null,
    raw: true,
    bikes: 0,
    isSeatsRequested: false
};

//HACK: make this better
function _searchClass(search, searchClassName) {
    if (searchClassName) {
        switch (searchClassName) {
            case 'DaySaveSearch':
                return _DaySaveSearch2.default;
            case 'SeasonSearch':
                return _SeasonSearch2.default;
            case 'RoversRangersSearch':
                return _RoversRangersSearch2.default;
            case 'SmartCarnetRecordSearch':
                return _SmartCarnetRecordSearch2.default;
            default:
                return _Search2.default;
        }
    }
    if (search.date && search.origin) {
        return _DaySaveSearch2.default;
    }
    if (search.date && search.ticketType) {
        return _RoversRangersSearch2.default;
    }
    if (search.dates) {
        return _SeasonSearch2.default;
    }
    return _Search2.default;
}

var Trip = function (_Record) {
    (0, _inherits3.default)(Trip, _Record);

    // eslint-disable-line new-cap

    function Trip() {
        var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3.default)(this, Trip);

        if (!values.id) {
            values.id = _uuid2.default.v1();
        }

        return (0, _possibleConstructorReturn3.default)(this, _Record.call(this, values));
    }

    Trip.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var searchClass = _searchClass(json.search, json.searchClass);

        return new Trip({
            id: json.id,
            fares: (0, _LinkMapper.resolve)(json.fares).as(_TripFares2.default),
            fareCategory: json.fareCategory,
            fareClass: json.fareClass,
            outwardJourney: (0, _LinkMapper.resolve)(json.outwardJourney).as(_Service2.default),
            returnJourney: (0, _LinkMapper.resolve)(json.returnJourney).as(_Service2.default),
            reservationPreferences: (0, _LinkMapper.resolve)(json.reservationPreferences).as(_SeatingPreferences2.default),
            photocard: (0, _LinkMapper.resolve)(json.photocard).as(_Photocard2.default),
            passengers: (0, _LinkMapper.resolve)(json.passengers).as(_Passengers2.default),
            orderTripId: json.orderTripId,
            search: (0, _LinkMapper.resolve)(json.search).as(searchClass),
            plusBusAvailability: (0, _LinkMapper.resolve)(json.plusBusAvailability).as(_PlusBus2.default),
            cheapest: (0, _LinkMapper.resolve)(json.cheapest).as(_OverallCheapestSelection2.default),
            cheapestFastest: (0, _LinkMapper.resolve)(json.cheapestFastest).as(_OverallCheapestSelection2.default),
            cheapestFirstClass: (0, _LinkMapper.resolve)(json.cheapestFirstClass).as(_OverallCheapestSelection2.default),
            filters: (0, _LinkMapper.resolve)(json.filters).as(_DisplayFilters2.default),
            hasServiceProvider: json.hasServiceProvider,
            listStep: json.listStep,
            raw: json.raw,
            bikes: json.bikes,
            isSeatsRequested: json.isSeatsRequested
        });
    };

    Trip.prototype.getType = function getType() {

        if (this.search instanceof _DaySaveSearch2.default) {
            return _AppConstants.TripTypes.DAYSAVE;
        }

        if (this.search instanceof _RoversRangersSearch2.default) {
            return _AppConstants.TripTypes.ROVERSRANGERS;
        }

        var isSeason = this.search instanceof _SeasonSearch2.default;

        if (this.isSmartcard()) {
            if (isSeason) {
                return _AppConstants.TripTypes.SMARTCARD_SEASON;
            }
            return _AppConstants.TripTypes.SMARTCARD_POINT;
        }

        if (isSeason) {
            return _AppConstants.TripTypes.SEASON;
        }
        return _AppConstants.TripTypes.POINT;
    };

    Trip.prototype.needsJourney = function needsJourney() {
        return this.getType() === _AppConstants.TripTypes.POINT || this.getType() === _AppConstants.TripTypes.SMARTCARD_POINT;
    };

    Trip.prototype.isPoint = function isPoint() {
        return this.search instanceof _Search2.default;
    };

    Trip.prototype.isSeason = function isSeason() {
        return this.search instanceof _SeasonSearch2.default;
    };

    Trip.prototype.isDaySave = function isDaySave() {
        return this.search instanceof _DaySaveSearch2.default;
    };

    Trip.prototype.isRovers = function isRovers() {
        return this.search instanceof _RoversRangersSearch2.default;
    };

    Trip.prototype.isSingle = function isSingle() {
        return !this.isSeason() && this.getTicketType() === _AppConstants.TicketTypes.SINGLE;
    };

    Trip.prototype.isReturn = function isReturn() {
        return !this.isSeason() && this.getTicketType() === _AppConstants.TicketTypes.RETURN;
    };

    Trip.prototype.isOpenReturn = function isOpenReturn() {
        return !this.isSeason() && this.getTicketType() === _AppConstants.TicketTypes.OPEN_RETURN;
    };

    Trip.prototype.getTicketType = function getTicketType() {
        return this.search.ticketType;
    };

    Trip.prototype.isSmartcard = function isSmartcard() {
        return !!this.search.smartcard;
    };

    Trip.prototype.isTransPennineStaffRover = function isTransPennineStaffRover() {
        var originNlc = (0, _get3.default)(this.search, 'origin.nlc', null);
        var destinationNlc = (0, _get3.default)(this.search, 'destination.nlc', null);

        if (!originNlc || !destinationNlc) {
            return false;
        }

        return originNlc === _AppConstants.TransPennineStaffRoverNlcCodes.ORIGIN && destinationNlc === _AppConstants.TransPennineStaffRoverNlcCodes.DESTINATION;
    };

    Trip.prototype.getFareForDirection = function getFareForDirection(direction) {
        if (direction === _AppConstants.JourneyDirections.INWARD) {
            return this.fares.returnSingle;
        }
        return this.fares.return || this.fares.outwardSingle;
    };

    Trip.prototype.getServiceForDirection = function getServiceForDirection(direction) {
        return direction === _AppConstants.JourneyDirections.INWARD ? this.returnJourney : this.outwardJourney;
    };

    Trip.prototype.setFareForDirection = function setFareForDirection(direction, fare) {
        var blankFares = new _TripFares2.default({
            plusBus: this.fares.plusBus
        });
        if (fare && fare.isReturn()) {
            return this.set('fares', blankFares.set('return', fare));
        }

        if (direction === _AppConstants.JourneyDirections.INWARD) {
            return this.set('fares', blankFares.set('returnSingle', fare).set('outwardSingle', this.fares.get('outwardSingle')));
        }

        return this.set('fares', blankFares.set('outwardSingle', fare).set('returnSingle', this.fares.get('returnSingle')));
    };

    Trip.prototype.setFareOnlyFare = function setFareOnlyFare(fare) {
        return this.set('fares', new _TripFares2.default({
            fareOnly: fare
        }));
    };

    Trip.prototype.resetFares = function resetFares() {
        return this.set('fares', new _TripFares2.default({
            plusBus: this.fares.plusBus
        }));
    };

    Trip.prototype.getOysterPrice = function getOysterPrice() {
        if (this.isSingle()) {
            if (this.outwardJourney) {
                return this.outwardJourney.oysterPrice || null;
            }
        }
        if (this.isReturn()) {
            if (this.outwardJourney && this.returnJourney) {
                if (this.outwardJourney.oysterPrice && this.returnJourney.oysterPrice) {
                    return this.outwardJourney.oysterPrice + this.returnJourney.oysterPrice;
                }
            }
        }
        return null;
    };

    Trip.prototype.resetSelected = function resetSelected(direction) {
        if (direction === _AppConstants.JourneyDirections.INWARD && this.search.targetLayout === _AppConstants.JourneyPlannerLayout.LIST) {
            return this.setIn(['fares', 'returnSingle'], null).set('returnJourney', null);
        }

        return this.set('fares', new _TripFares2.default()).set('fareClass', null).set('returnJourney', null).set('outwardJourney', null).set('photocard', new _Photocard2.default());
    };

    Trip.prototype.setServiceForDirection = function setServiceForDirection(direction, service) {
        var journeyKey = direction === _AppConstants.JourneyDirections.INWARD ? 'returnJourney' : 'outwardJourney';
        return this.set(journeyKey, service);
    };

    Trip.prototype.setSeatingPreferences = function setSeatingPreferences(seatingPreferences) {
        return this.set('reservationPreferences', seatingPreferences);
    };

    Trip.prototype.setSeatingForDirection = function setSeatingForDirection(direction, fare, service) {
        var shouldReserve = fare.isSeatCompulsory() || service.isSeatCompulsory() || service.isSeatAvailable();
        var newTrip = this.setIn(['reservationPreferences', direction], shouldReserve);

        if (!newTrip.reservationPreferences.shouldReserve()) {
            newTrip = newTrip.set('reservationPreferences', newTrip.reservationPreferences.resetPreferences());
        }
        return newTrip;
    };

    Trip.prototype.hasSeatingPreferences = function hasSeatingPreferences() {
        return this.reservationPreferences.hasPreferences();
    };

    Trip.prototype.getOutwardFare = function getOutwardFare() {
        return this.getFareForDirection(_AppConstants.JourneyDirections.OUTWARD);
    };

    Trip.prototype.hasOutwardFare = function hasOutwardFare() {
        return !!this.getOutwardFare();
    };

    Trip.prototype.getOutwardService = function getOutwardService() {
        return this.outwardJourney;
    };

    Trip.prototype.hasOutwardService = function hasOutwardService() {
        return !!this.getOutwardService();
    };

    Trip.prototype.getInwardFare = function getInwardFare() {
        return this.getFareForDirection(_AppConstants.JourneyDirections.INWARD);
    };

    Trip.prototype.hasInwardFare = function hasInwardFare() {
        return !!this.getInwardFare();
    };

    Trip.prototype.getFareOnlyFare = function getFareOnlyFare() {
        return this.fares.fareOnly;
    };

    Trip.prototype.hasFareOnlyFare = function hasFareOnlyFare() {
        return !!this.fares.fareOnly;
    };

    Trip.prototype.getReturnFare = function getReturnFare() {
        return this.fares.return;
    };

    Trip.prototype.hasReturnFare = function hasReturnFare() {
        return !!this.fares.return;
    };

    Trip.prototype.getInwardService = function getInwardService() {
        return this.returnJourney;
    };

    Trip.prototype.hasInwardService = function hasInwardService() {
        return !!this.getInwardService();
    };

    Trip.prototype.getPlusBus = function getPlusBus() {
        return this.fares.plusBus;
    };

    Trip.prototype.hasPlusBus = function hasPlusBus() {
        return Boolean(this.getPlusBus().count());
    };

    Trip.prototype.setPlusBus = function setPlusBus(plusBus) {
        return this.setIn(['fares', 'plusBus'], plusBus);
    };

    Trip.prototype.getServiceOrderForDirection = function getServiceOrderForDirection(direction) {
        var _search$getTimebandFo = this.search.getTimebandForDirection(direction),
            arriveDepart = _search$getTimebandFo.arriveDepart;

        return arriveDepart === _AppConstants.TimeTypes.DEPART ? 'origin' : 'destination';
    };

    Trip.prototype.isSeatingAvailable = function isSeatingAvailable() {
        var services = (0, _compact3.default)([this.getOutwardService(), this.getInwardService()]);

        return (0, _some3.default)((0, _invokeMap3.default)(services, 'isSeatAvailable'));
    };

    Trip.prototype.hasSeasonFare = function hasSeasonFare() {
        return !!this.getSeasonFare();
    };

    Trip.prototype.getSeasonFare = function getSeasonFare() {
        return this.fares.season;
    };

    Trip.prototype.setSeasonFare = function setSeasonFare(fare) {
        return this.setIn(['fares', 'season'], fare);
    };

    Trip.prototype.hasDaySaveFare = function hasDaySaveFare() {
        return !!this.getDaySaveFare();
    };

    Trip.prototype.getDaySaveFare = function getDaySaveFare() {
        return this.fares.daySave;
    };

    Trip.prototype.setDaySaveFare = function setDaySaveFare(fare) {
        return this.setIn(['fares', 'daySave'], fare);
    };

    Trip.prototype.hasRoversRangersFare = function hasRoversRangersFare() {
        return !!this.getRoversRangersFare();
    };

    Trip.prototype.getRoversRangersFare = function getRoversRangersFare() {
        return this.getOutwardFare() && this.getOutwardFare().isRoversRangers() ? this.getOutwardFare() : null;
    };

    Trip.prototype.setRoversRangersFare = function setRoversRangersFare(fare) {
        return this.setIn(['fares', 'roversRangers'], fare);
    };

    Trip.prototype.getTotalPrice = function getTotalPrice() {
        var total = this.getPlusBus().getTotalPrice();
        if (this.hasOutwardFare()) {
            total += this.getOutwardFare().getPrice();
        }
        if (this.hasInwardFare()) {
            total += this.getInwardFare().getPrice();
        }
        if (this.hasSeasonFare()) {
            total += this.getSeasonFare().getPrice();
        }
        if (this.hasFareOnlyFare()) {
            total += this.getFareOnlyFare().getPrice();
        }

        return total;
    };

    Trip.prototype.getTotalPriceWithoutPromo = function getTotalPriceWithoutPromo() {
        var total = this.getPlusBus().getTotalPrice();

        if (this.hasOutwardFare()) {
            total += this.getOutwardFare().getOriginalTotalPrice();
        }
        if (this.hasInwardFare()) {
            total += this.getInwardFare().getOriginalTotalPrice();
        }
        if (this.hasSeasonFare()) {
            total += this.getSeasonFare().getOriginalTotalPrice();
        }
        if (this.hasFareOnlyFare()) {
            total += this.getFareOnlyFare().getOriginalTotalPrice();
        }

        return total;
    };

    Trip.prototype.getTotalPriceWithoutDiscount = function getTotalPriceWithoutDiscount() {
        var total = this.getPlusBus().getTotalPrice();

        var getRailcardDiscount = function getRailcardDiscount(fare) {
            return fare.tickets.reduce(function (tot, ticket) {
                return tot + (ticket.railcardDiscount || 0);
            }, 0);
        };

        if (this.hasOutwardFare()) {
            total += this.getOutwardFare().getPrice() + getRailcardDiscount(this.getOutwardFare());
        }
        if (this.hasInwardFare()) {
            total += this.getInwardFare().getPrice() + getRailcardDiscount(this.getInwardFare());
        }
        if (this.hasSeasonFare()) {
            total += this.getSeasonFare().getPrice() + getRailcardDiscount(this.getSeasonFare());
        }
        if (this.hasFareOnlyFare()) {
            total += this.getFareOnlyFare().getPrice() + getRailcardDiscount(this.getFareOnlyFare());
        }

        return total;
    };

    Trip.prototype.isJPValid = function isJPValid() {
        if (this.hasFareOnlyFare()) {
            return true;
        }

        var outward = this.getOutwardFare();

        if (!this.hasOutwardService() || !this.hasOutwardFare()) {
            return false;
        }

        if (this.isReturn() && !outward.isReturn() && !this.hasInwardFare()) {
            return false;
        }

        if (this.isReturn() && outward.isReturn() && !this.hasInwardService()) {
            return false;
        }

        return !this.servicesOverlap();
    };

    /**
     * When you attempt to evaluate a seasons trip make sure if it isSmartcard() you check that
     * smartcard is set and that smartcard.canLoadProduct()
     *
     * @returns Boolean
     * */


    Trip.prototype.isSeasonsValid = function isSeasonsValid() {
        if (this.hasFareOnlyFare() && this.getFareOnlyFare().isSeason()) {
            return this.isSmartcard() || this.photocard.isComplete();
        }

        return this.search.isValid() && this.hasSeasonFare();
    };

    Trip.prototype.isDaySaveValid = function isDaySaveValid() {
        return this.search.isValid() && this.hasOutwardFare();
    };

    Trip.prototype.isRoversValid = function isRoversValid() {
        return this.search.isComplete() && this.hasOutwardFare() && this.passengers.isComplete();
    };

    Trip.prototype.isValid = function isValid() {
        if (this.isSeason()) {
            return this.isSeasonsValid();
        } else if (this.isDaySave()) {
            return this.isDaySaveValid();
        } else if (this.isRovers()) {
            return this.isRoversValid();
        }
        return this.isJPValid();
    };

    Trip.prototype.servicesOverlap = function servicesOverlap() {
        return this.isReturn() && this.hasInwardService() && this.hasOutwardService() && !this.getInwardService().getDepartureDateTime().isAfter(this.getOutwardService().getArrivalDateTime());
    };

    Trip.prototype.isCheapestFare = function isCheapestFare(fare) {
        return this.cheapest.isCheapestFare(fare);
    };

    Trip.prototype.getCheapestFareCategory = function getCheapestFareCategory() {
        var cheapest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.cheapest;

        if ((this.isReturn() || this.search.isReturnLondonTravelcard()) && cheapest.hasReturnFare()) {
            return cheapest.getReturnFare().category;
        } else if (this.isReturn() && (cheapest.hasOutwardFare() || cheapest.hasInwardFare())) {
            return _AppConstants.FareCategories.ADVANCE;
        } else if (cheapest.hasOutwardFare()) {
            return cheapest.getOutwardFare().category;
        }

        return _AppConstants.FareCategories.ADVANCE;
    };

    Trip.prototype.getCheapestFareClass = function getCheapestFareClass() {
        var cheapest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.cheapest;

        if (this.isReturn() && cheapest.hasReturnFare()) {
            return cheapest.getReturnFare().getClass();
        } else if (this.isReturn() && (cheapest.hasOutwardFare() || cheapest.hasInwardFare())) {
            return _AppConstants.FareClasses.STANDARD;
        } else if (cheapest.hasOutwardFare()) {
            return cheapest.getOutwardFare().getClass();
        }

        return _AppConstants.FareClasses.STANDARD;
    };

    Trip.prototype.getCheapestFareFromOverAll = function getCheapestFareFromOverAll(fareCategory, fareClass, journeyDirection) {
        if (this.getCheapestFareCategory() !== fareCategory || this.getCheapestFareClass() !== fareClass || fareCategory === _AppConstants.FareCategories.ADVANCE && this.cheapest.hasReturnFare() || fareCategory !== _AppConstants.FareCategories.ADVANCE && this.isReturn() && !this.cheapest.hasReturnFare()) {
            return null;
        }

        return this.cheapest.getFareForDirection(journeyDirection);
    };

    Trip.prototype.isPlusBusAvailable = function isPlusBusAvailable() {
        if (this.isSmartcard()) {
            return _config2.default.get('enablePlusBus') && _config2.default.get('enableSmartPlusBus');
        }
        return _config2.default.get('enablePlusBus');
    };

    Trip.prototype.getOutwardJourneyTrainRid = function getOutwardJourneyTrainRid() {
        return this.outwardJourney.journey.legs && this.outwardJourney.journey.legs.first() && this.outwardJourney.journey.legs.first().serviceDetails.trainRid;
    };

    return Trip;
}((0, _immutable.Record)(defaults));

exports.default = Trip;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(519);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.BadRequestError = exports.NotFoundError = exports.ForbiddenError = exports.UnauthorisedError = exports.ServerError = exports.RequestError = exports.ApiError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _findIndex2 = __webpack_require__(434);

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getErrorMessage() {
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var cocsError = function cocsError(e) {
        return e.code && e.code + ': ' + e.message;
    };
    var jpError = function jpError(e) {
        return e.failureType && e.failureType + ': ' + e.errorCode;
    };

    var messages = [].concat(errors).map(function (e) {
        return !!e && (cocsError(e) || jpError(e));
    }).filter(function (message) {
        return !!message;
    });

    return messages.length ? messages.join(', ') : null;
}

var ApiError = exports.ApiError = function (_ExtendableError) {
    (0, _inherits3.default)(ApiError, _ExtendableError);

    function ApiError(response, body, context) {
        (0, _classCallCheck3.default)(this, ApiError);

        var apiMessage = body && _getErrorMessage(body.errors);
        var httpError = response && response.statusText;

        var _this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call(this, apiMessage || httpError || 'Server Error', context));

        _this.name = 'ApiError';

        _this.response = response;
        _this.body = body;
        return _this;
    }

    ApiError.prototype.hasCode = function hasCode(code) {
        return (0, _findIndex3.default)(this.body.errors, ['code', code]) !== -1;
    };

    return ApiError;
}(_ExtendableError3.default);

var RequestError = exports.RequestError = function (_ApiError) {
    (0, _inherits3.default)(RequestError, _ApiError);

    function RequestError() {
        var _temp, _this2, _ret;

        (0, _classCallCheck3.default)(this, RequestError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ApiError.call.apply(_ApiError, [this].concat(args))), _this2), _this2.name = 'RequestError', _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
    }

    return RequestError;
}(ApiError);

var ServerError = exports.ServerError = function (_ApiError2) {
    (0, _inherits3.default)(ServerError, _ApiError2);

    function ServerError() {
        var _temp2, _this3, _ret2;

        (0, _classCallCheck3.default)(this, ServerError);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this3 = (0, _possibleConstructorReturn3.default)(this, _ApiError2.call.apply(_ApiError2, [this].concat(args))), _this3), _this3.name = 'ServerError', _temp2), (0, _possibleConstructorReturn3.default)(_this3, _ret2);
    }

    return ServerError;
}(ApiError);

var UnauthorisedError = exports.UnauthorisedError = function (_ApiError3) {
    (0, _inherits3.default)(UnauthorisedError, _ApiError3);

    function UnauthorisedError() {
        var _temp3, _this4, _ret3;

        (0, _classCallCheck3.default)(this, UnauthorisedError);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this4 = (0, _possibleConstructorReturn3.default)(this, _ApiError3.call.apply(_ApiError3, [this].concat(args))), _this4), _this4.name = 'UnauthorisedError', _temp3), (0, _possibleConstructorReturn3.default)(_this4, _ret3);
    }

    return UnauthorisedError;
}(ApiError);

var ForbiddenError = exports.ForbiddenError = function (_ApiError4) {
    (0, _inherits3.default)(ForbiddenError, _ApiError4);

    function ForbiddenError() {
        var _temp4, _this5, _ret4;

        (0, _classCallCheck3.default)(this, ForbiddenError);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return _ret4 = (_temp4 = (_this5 = (0, _possibleConstructorReturn3.default)(this, _ApiError4.call.apply(_ApiError4, [this].concat(args))), _this5), _this5.name = 'ForbiddenError', _temp4), (0, _possibleConstructorReturn3.default)(_this5, _ret4);
    }

    return ForbiddenError;
}(ApiError);

var NotFoundError = exports.NotFoundError = function (_RequestError) {
    (0, _inherits3.default)(NotFoundError, _RequestError);

    function NotFoundError() {
        var _temp5, _this6, _ret5;

        (0, _classCallCheck3.default)(this, NotFoundError);

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return _ret5 = (_temp5 = (_this6 = (0, _possibleConstructorReturn3.default)(this, _RequestError.call.apply(_RequestError, [this].concat(args))), _this6), _this6.name = 'NotFoundError', _temp5), (0, _possibleConstructorReturn3.default)(_this6, _ret5);
    }

    return NotFoundError;
}(RequestError);

var BadRequestError = exports.BadRequestError = function (_RequestError2) {
    (0, _inherits3.default)(BadRequestError, _RequestError2);

    function BadRequestError() {
        var _temp6, _this7, _ret6;

        (0, _classCallCheck3.default)(this, BadRequestError);

        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        return _ret6 = (_temp6 = (_this7 = (0, _possibleConstructorReturn3.default)(this, _RequestError2.call.apply(_RequestError2, [this].concat(args))), _this7), _this7.name = 'BadRequest', _temp6), (0, _possibleConstructorReturn3.default)(_this7, _ret6);
    }

    return BadRequestError;
}(RequestError);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isObject = __webpack_require__(77);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(116),
    overRest = __webpack_require__(764),
    setToString = __webpack_require__(515);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(331),
    baseZipObject = __webpack_require__(1498);

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

module.exports = zipObject;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(690);
var enumBugKeys = __webpack_require__(468);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(133);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(31);
var dPs = __webpack_require__(691);
var enumBugKeys = __webpack_require__(468);
var IE_PROTO = __webpack_require__(467)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(465)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(469).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(690);
var hiddenKeys = __webpack_require__(468).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(36);
var dP = __webpack_require__(71);
var DESCRIPTORS = __webpack_require__(66);
var SPECIES = __webpack_require__(56)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(131);
var call = __webpack_require__(703);
var isArrayIter = __webpack_require__(480);
var anObject = __webpack_require__(31);
var toLength = __webpack_require__(63);
var getIterFn = __webpack_require__(482);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(112);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1385)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(493)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(370);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1390);
var global = __webpack_require__(82);
var hide = __webpack_require__(182);
var Iterators = __webpack_require__(247);
var TO_STRING_TAG = __webpack_require__(94)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(742),
    baseEach = __webpack_require__(237),
    baseIteratee = __webpack_require__(102),
    baseReduce = __webpack_require__(1474),
    isArray = __webpack_require__(68);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(743),
    keys = __webpack_require__(127);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1443),
    getValue = __webpack_require__(1446);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    arrayOf = _propTypes2.default.arrayOf,
    oneOfType = _propTypes2.default.oneOfType,
    element = _propTypes2.default.element,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Indicates that navigation was caused by a call to history.push.
 */


exports.__esModule = true;
var PUSH = 'PUSH';

exports.PUSH = PUSH;
/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = 'REPLACE';

exports.REPLACE = REPLACE;
/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = 'POP';

exports.POP = POP;
exports['default'] = {
  PUSH: PUSH,
  REPLACE: REPLACE,
  POP: POP
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extractPath = extractPath;
exports.parsePath = parsePath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function extractPath(string) {
  var match = string.match(/^https?:\/\/[^\/]*/);

  if (match == null) return string;

  return string.substring(match[0].length);
}

function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function deprecate(fn, message) {
  return function () {
     false ? _warning2['default'](false, '[history] ' + message) : undefined;
    return fn.apply(this, arguments);
  };
}

exports['default'] = deprecate;
module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Discount = __webpack_require__(643);

var _Discount2 = _interopRequireDefault(_Discount);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    promoCode: null,
    discount: null,
    terms: null,
    validationError: null
};

var PromoCode = function (_record) {
    (0, _inherits3.default)(PromoCode, _record);

    function PromoCode() {
        (0, _classCallCheck3.default)(this, PromoCode);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PromoCode.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(PromoCode, json, {
            id: _LinkMapper.fields.string,
            discount: _LinkMapper.resolve.as(_Discount2.default),
            promoCode: _LinkMapper.fields.string,
            terms: _LinkMapper.fields.string,
            validationError: _LinkMapper.fields.string
        });
    };

    PromoCode.prototype.getSchema = function getSchema() {
        return {
            promoCode: _validation2.default.requiredString()
        };
    };

    PromoCode.prototype.getParsedTerms = function getParsedTerms() {
        return this.terms && this.terms.replace(/\n/g, '<br />');
    };

    PromoCode.prototype.isEmpty = function isEmpty() {
        return (0, _isEmpty3.default)(this.promoCode);
    };

    return PromoCode;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(PromoCode.prototype, _ValidationMixin2.default);

exports.default = PromoCode;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.PreferenceType = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreferenceType = exports.PreferenceType = {
    SMS: 'SMS',
    EMAIL: 'EMAIL'
};

var emailMarketingFields = ['emailServiceUpdates', 'emailPromotions', 'emailProducts'];
var smsMarketingFields = ['smsServiceUpdates', 'smsPromotions', 'smsProducts'];

var marketingFieldVisibleFlags = {
    emailServiceUpdates: 'enableServicePreference',
    emailPromotions: 'enablePromotionsPreference',
    emailProducts: 'enableProductsPreference',
    smsServiceUpdates: 'enableServicePreference',
    smsPromotions: 'enablePromotionsPreference',
    smsProducts: 'enableProductsPreference',
    autoDelayRepay: 'enableAutoDelayRepay'
};

var marketingFieldDisabledForUnder16s = {
    emailServiceUpdates: false,
    emailPromotions: true,
    emailProducts: true,
    smsServiceUpdates: false,
    smsPromotions: true,
    smsProducts: true,
    autoDelayRepay: false,
    autoDelayRepayApp: false,
    autoDelayRepayEmail: false
};

var schema = {
    emailServiceUpdates: [_LinkMapper.fields.boolean, false],
    smsServiceUpdates: [_LinkMapper.fields.boolean, false],
    emailPromotions: [_LinkMapper.fields.boolean, false],
    smsPromotions: [_LinkMapper.fields.boolean, false],
    emailProducts: [_LinkMapper.fields.boolean, false],
    smsProducts: [_LinkMapper.fields.boolean, false],
    autoDelayRepay: [_LinkMapper.fields.boolean, false],
    autoDelayRepayApp: [_LinkMapper.fields.boolean, false],
    autoDelayRepayEmail: [_LinkMapper.fields.boolean, false],
    delayRepayAmazonEmail: [_LinkMapper.fields.string],
    delayRepayAmazonCustomerId: [_LinkMapper.fields.string],
    timestamp: [_LinkMapper.fields.datetime]
};

var UserPreferences = function (_record) {
    (0, _inherits3.default)(UserPreferences, _record);

    function UserPreferences() {
        (0, _classCallCheck3.default)(this, UserPreferences);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    UserPreferences.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(UserPreferences, json, (0, _Records.getResolvers)(schema));
    };

    UserPreferences.prototype.getSchema = function getSchema() {
        return {
            emailServiceUpdates: _joi2.default.boolean(),
            smsServiceUpdates: _joi2.default.boolean(),
            emailPromotions: _joi2.default.boolean(),
            smsPromotions: _joi2.default.boolean(),
            emailProducts: _joi2.default.boolean(),
            smsProducts: _joi2.default.boolean(),
            autoDelayRepay: _joi2.default.boolean(),
            autoDelayRepayApp: _joi2.default.boolean(),
            autoDelayRepayEmail: _joi2.default.boolean()
        };
    };

    UserPreferences.prototype.toggleAllMarketingPreferences = function toggleAllMarketingPreferences(type, value, isOver16) {
        var relevantEmailFields = emailMarketingFields;

        var preferences = this;

        var updateFieldsConditionally = function updateFieldsConditionally(fields) {
            fields.forEach(function (field) {
                var shown = _FeatureFlagStore2.default.get(marketingFieldVisibleFlags[field]);
                var disabled = !isOver16 && marketingFieldDisabledForUnder16s[field];
                if (shown && !disabled) {
                    preferences = preferences.set(field, value);
                }
            });
        };

        if (type === PreferenceType.EMAIL) {
            updateFieldsConditionally(relevantEmailFields);
        }
        if (type === PreferenceType.SMS) {
            updateFieldsConditionally(smsMarketingFields);
        }

        return preferences;
    };

    UserPreferences.prototype.resetAllDisabledMarketingFields = function resetAllDisabledMarketingFields() {
        var preferences = this;

        var resetFieldsConditionally = function resetFieldsConditionally(fields) {
            fields.forEach(function (field) {
                if (marketingFieldDisabledForUnder16s[field]) {
                    preferences = preferences.set(field, false);
                }
            });
        };

        var allMarketingFields = emailMarketingFields.concat(smsMarketingFields);
        resetFieldsConditionally(allMarketingFields);
        return preferences;
    };

    UserPreferences.prototype.checkAllEnabledFieldsSetToTrue = function checkAllEnabledFieldsSetToTrue(fields, isOver16) {
        var _this2 = this;

        return fields.every(function (field) {
            var shown = _FeatureFlagStore2.default.get(marketingFieldVisibleFlags[field]);
            var disabled = !isOver16 && marketingFieldDisabledForUnder16s[field];
            return _this2.get(field) || disabled || !shown;
        });
    };

    UserPreferences.prototype.isEveryEnabledEmailPrefSetToTrue = function isEveryEnabledEmailPrefSetToTrue(isOver16) {
        var relevantFields = emailMarketingFields;
        return this.checkAllEnabledFieldsSetToTrue(relevantFields, isOver16);
    };

    UserPreferences.prototype.isEveryEnabledSmsPrefSetToTrue = function isEveryEnabledSmsPrefSetToTrue(isOver16) {
        return this.checkAllEnabledFieldsSetToTrue(smsMarketingFields, isOver16);
    };

    UserPreferences.prototype.isSomeSmsPrefSetToTrue = function isSomeSmsPrefSetToTrue() {
        var _this3 = this;

        return smsMarketingFields.some(function (field) {
            return _this3.get(field);
        });
    };

    UserPreferences.prototype.hasEmailProductsSetToTrue = function hasEmailProductsSetToTrue() {
        return this.emailProducts;
    };

    UserPreferences.prototype.hasEmailPromotionsSetToTrue = function hasEmailPromotionsSetToTrue() {
        return this.emailPromotions;
    };

    UserPreferences.prototype.hasDifferentPreferencesTo = function hasDifferentPreferencesTo(preference) {
        var _this4 = this;

        var allMarketingFields = emailMarketingFields.concat(smsMarketingFields);
        return allMarketingFields.some(function (field) {
            return _this4.get(field) !== preference.get(field);
        });
    };

    UserPreferences.prototype.isEveryUnsubscribeFieldSetToFalse = function isEveryUnsubscribeFieldSetToFalse() {
        var _this5 = this;

        return emailMarketingFields.every(function (field) {
            return !_this5.get(field);
        });
    };

    UserPreferences.prototype.hasMultipleEmailFieldsSetToTrue = function hasMultipleEmailFieldsSetToTrue() {
        var _this6 = this;

        var fields = emailMarketingFields;
        return fields.filter(function (field) {
            return _this6.get(field);
        }).length > 1;
    };

    UserPreferences.prototype.hasNoEmailFieldsSetToTrue = function hasNoEmailFieldsSetToTrue() {
        var _this7 = this;

        var fields = emailMarketingFields;
        return fields.every(function (field) {
            return !_this7.get(field);
        });
    };

    UserPreferences.prototype.toggleAllEmailFields = function toggleAllEmailFields(originalPreferences, value) {
        var fields = emailMarketingFields.filter(function (field) {
            return originalPreferences.get(field);
        });
        var preferences = this;
        fields.forEach(function (field) {
            preferences = preferences.set(field, value);
        });
        return preferences;
    };

    UserPreferences.getRegistrationPreferencesFields = function getRegistrationPreferencesFields(form) {
        return new _immutable.Map({
            emailServiceUpdates: form.get('emailServiceUpdates'),
            emailPromotions: form.get('emailPromotions'),
            emailProducts: form.get('emailProducts')
        });
    };

    return UserPreferences;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = UserPreferences;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(331),
    baseAssignValue = __webpack_require__(315);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isNil2 = __webpack_require__(329);

var _isNil3 = _interopRequireDefault(_isNil2);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makePropType(fn) {
    fn.isRequired = function (props, name) {
        if ((0, _isNil3.default)(props[name])) {
            return new Error(name + ' is a required prop');
        }

        for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            rest[_key - 2] = arguments[_key];
        }

        return fn.apply(undefined, [props, name].concat(rest));
    };
    return fn;
}

exports.default = {
    isMoment: makePropType(function (props, name) {
        if (props[name] && !_TrainTime2.default.isMoment(props[name])) {
            return new Error(name + ' must be a moment.js date instance');
        }
        return null;
    }),
    isTrainTime: makePropType(function (props, name) {
        if (props[name] && !_TrainTime2.default.isTrainTime(props[name])) {
            return new Error(name + ' must be a moment.js date instance in the correct timezone');
        }
        return null;
    }),
    isDuration: makePropType(function (props, name) {
        if (props[name] && !_TrainTime2.default.isDuration(props[name])) {
            return new Error(name + ' must be a moment.js duration');
        }
        return null;
    })
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Radio = __webpack_require__(924);

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This must be a stateful component because we want to be able to attach a `ref` to it so it can be focused
var RadioWrapper = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(RadioWrapper, _React$PureComponent);

    function RadioWrapper() {
        (0, _classCallCheck3.default)(this, RadioWrapper);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    RadioWrapper.prototype.render = function render() {
        var _props = this.props,
            label = _props.label,
            labelClassName = _props.labelClassName,
            srOnly = _props.srOnly,
            hasIcon = _props.hasIcon,
            hasBorder = _props.hasBorder,
            hasFocus = _props.hasFocus,
            radioClass = _props.radioClass,
            isFirstClass = _props.isFirstClass,
            isDisabled = _props.isDisabled,
            customDisabledMessage = _props.customDisabledMessage,
            props = (0, _objectWithoutProperties3.default)(_props, ['label', 'labelClassName', 'srOnly', 'hasIcon', 'hasBorder', 'hasFocus', 'radioClass', 'isFirstClass', 'isDisabled', 'customDisabledMessage']);


        if (srOnly) {
            return _react2.default.createElement(
                _Radio2.default,
                props,
                _react2.default.createElement(
                    'span',
                    { 'aria-hidden': 'true', className: labelClassName },
                    label
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    srOnly
                )
            );
        }

        var spanClasses = (0, _classnames2.default)({
            'radio-with-icon': hasIcon,
            'radio-with-border': hasBorder,
            'radio-disabled': isDisabled
        });

        return _react2.default.createElement(
            _Radio2.default,
            (0, _extends3.default)({ autoFocus: this.props.checked && hasFocus }, props, { className: radioClass }),
            _react2.default.createElement(
                'span',
                { className: spanClasses },
                hasIcon,
                label,
                isFirstClass && _react2.default.createElement(
                    'span',
                    { className: 'radio-first-class' },
                    'First Class'
                ),
                isDisabled && _react2.default.createElement(
                    'span',
                    { className: 'disabled-radio-message' },
                    customDisabledMessage || 'Unavailable in this type of ticket'
                )
            )
        );
    };

    return RadioWrapper;
}(_react2.default.PureComponent), _class.propTypes = {
    checked: _propTypes2.default.bool,
    label: _propTypes2.default.any,
    labelClassName: _propTypes2.default.string,
    srOnly: _propTypes2.default.string,
    hasIcon: _propTypes2.default.any,
    hasBorder: _propTypes2.default.bool,
    hasFocus: _propTypes2.default.bool,
    radioClass: _propTypes2.default.string,
    isFirstClass: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    customDisabledMessage: _propTypes2.default.string
}, _temp);
exports.default = RadioWrapper;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _delay2 = __webpack_require__(627);

var _delay3 = _interopRequireDefault(_delay2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationActions = {

    showNotification: function showNotification(notification) {
        var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3900;

        _AppDispatcher2.default.dispatch({
            notification: notification,
            actionType: _AppConstants.ActionTypes.NOTIFICATION_SHOW
        });

        (0, _delay3.default)(this.hideNotification, timeout, notification);
    },

    hideNotification: function hideNotification() {
        var notification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        _AppDispatcher2.default.dispatch({
            notification: notification,
            actionType: _AppConstants.ActionTypes.NOTIFICATION_HIDE
        });
    }
};

exports.default = NotificationActions;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1524), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.debugHook = debugHook;
exports.setHookName = setHookName;

exports.default = function (hookFunction, name) {
    return setHookName(debugHook(hookFunction), name);
};

var _react = __webpack_require__(0);

/**
 * Debugs the return value of a custom hook so that it can be easily viewed in react devtools
 *
 * @param {Function} hookFunction - A custom react hook
 */
function debugHook(hookFunction) {
    var wrapped = function wrapped() {
        var hookReturnValue = hookFunction.apply(undefined, arguments);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _react.useDebugValue)(hookReturnValue);
        return hookReturnValue;
    };
    return wrapped;
}

/**
 * Set the hook name, so that it can be identified in devtools even after the code has been minified
 *
 * @param {Function} hookFunction - A custom react hook function
 * @param {String} name - The name of the hook
 */
function setHookName(hookFunction, name) {
    Object.defineProperty(hookFunction, "name", { value: name });
    return hookFunction;
}

/**
 * Wrap a custom hook with some devtools tweaks
 *
 * @param {Function} hookFunction - A custom react hook function
 * @param {String} name - The name of the hook
 */

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1493);
moment.tz.load(__webpack_require__(1494));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(253),
    isArrayLike = __webpack_require__(143),
    isIndex = __webpack_require__(305),
    isObject = __webpack_require__(77);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(220),
    createBaseEach = __webpack_require__(1430);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1513), __esModule: true };

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Railcard = __webpack_require__(241);

var _Railcard2 = _interopRequireDefault(_Railcard);

var _Discount = __webpack_require__(1678);

var _Discount2 = _interopRequireDefault(_Discount);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _TicketIssued = __webpack_require__(1679);

var _TicketIssued2 = _interopRequireDefault(_TicketIssued);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    adults: 0,
    children: 0,
    id: null,
    price: null,
    statusCode: null,
    discount: null,
    discountCode: null,
    discountAmount: null,
    passenger: null,
    railcard: new _Railcard2.default(),
    refundState: null,
    refunded: false,
    amended: false,
    printed: null,
    issued: null,
    attachment: null,
    rewardPoints: null,
    ticketType: null,
    ticketTypeOverride: null,
    travelStartDate: null,
    promoCode: null,
    changeoverAction: null
};

var OrderTicket = function (_record) {
    (0, _inherits3.default)(OrderTicket, _record);

    function OrderTicket() {
        (0, _classCallCheck3.default)(this, OrderTicket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderTicket.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(OrderTicket, json, {
            adults: _LinkMapper.fields.number,
            children: _LinkMapper.fields.number,
            id: _LinkMapper.fields.number,
            passenger: _LinkMapper.resolve.with(_immutable.Map),
            price: _LinkMapper.fields.number,
            statusCode: _LinkMapper.fields.string,
            discount: _LinkMapper.resolve.as(_Discount2.default),
            discountCode: _LinkMapper.fields.string,
            discountAmount: _LinkMapper.fields.number,
            railcard: _LinkMapper.resolve.as(_Railcard2.default),
            refundState: _LinkMapper.fields.string,
            refunded: _LinkMapper.fields.string,
            amended: _LinkMapper.fields.bool,
            printed: _LinkMapper.fields.bool,
            issued: _LinkMapper.resolve.as(_TicketIssued2.default),
            attachment: _LinkMapper.fields.string,
            rewardPoints: _LinkMapper.fields.number,
            ticketType: _LinkMapper.fields.string,
            ticketTypeOverride: _LinkMapper.resolve.as(_TicketType2.default),
            travelStartDate: _LinkMapper.fields.string,
            promoCode: _LinkMapper.fields.string,
            changeoverAction: _LinkMapper.fields.string
        });
    };

    OrderTicket.prototype.canAmend = function canAmend() {
        return !this.amended && !this.isRefunded && !this.printed;
    };

    OrderTicket.prototype.canRefundOffline = function canRefundOffline() {
        return !(this.isRefunded || this.refundState === _AppConstants.TicketRefundStates.EXCEEDED_VALIDITY);
    };

    OrderTicket.prototype.isChildFlatFare = function isChildFlatFare() {
        return Boolean(this.ticketTypeOverride && this.ticketTypeOverride.code && ['CFF', 'CFS'].includes(this.ticketTypeOverride.code));
    };

    OrderTicket.prototype.isChildTicket = function isChildTicket() {
        return Boolean(this.children);
    };

    OrderTicket.prototype.isGroupSave = function isGroupSave() {
        return this.railcard && this.railcard.isGroupSave();
    };

    OrderTicket.prototype.hasRailcard = function hasRailcard(railcard) {
        return this.railcard && this.railcard.code === railcard.code;
    };

    OrderTicket.prototype.toComparable = function toComparable() {
        return this.delete('id');
    };

    OrderTicket.prototype.hasPromoDiscount = function hasPromoDiscount() {
        return this.discount && this.discount.isPromotional;
    };

    OrderTicket.prototype.hasDiscount = function hasDiscount(discount) {
        return discount && this.discount && this.discount.code === discount.discountCode;
    };

    OrderTicket.prototype.hasRailcardJCP = function hasRailcardJCP() {
        return this.railcard && this.railcard.code === _AppConstants.JOB_CENTRE_PLUS_RAILCARD_CODE;
    };

    OrderTicket.prototype.hasRailcard1617 = function hasRailcard1617() {
        return this.railcard && (this.railcard.code === _AppConstants.RAILCARD1617_CODE || this.railcard.code === _AppConstants.JOB_CENTRE_PLUS_RAILCARD_CODE);
    };

    OrderTicket.prototype.hasDisabledPeopleRailcard = function hasDisabledPeopleRailcard() {
        return this.railcard && _AppConstants.DisabledPeopleRailcards.includes(this.railcard.code);
    };

    OrderTicket.prototype.getTicketNumber = function getTicketNumber() {
        return this.getIn(['issued', 'issuedTicketNumber']);
    };

    OrderTicket.prototype.getSmartcardNumber = function getSmartcardNumber() {
        return this.getIn(['passenger', 'smartcardNumber']);
    };

    OrderTicket.prototype.getPhotocardNumber = function getPhotocardNumber() {
        return this.getIn(['passenger', 'photocardNumber']);
    };

    OrderTicket.prototype.getPassengerName = function getPassengerName() {
        return this.getIn(['passenger', 'name']);
    };

    OrderTicket.prototype.getPromoCode = function getPromoCode() {
        return this.get('promoCode');
    };

    (0, _createClass3.default)(OrderTicket, [{
        key: 'isRefunded',
        get: function get() {
            return this.refunded;
        }
    }, {
        key: 'isChangeoverRefund',
        get: function get() {
            return this.changeoverAction === _AppConstants.ChangeoverActions.REFUND;
        }
    }, {
        key: 'isRefundable',
        get: function get() {
            return this.refundState === _AppConstants.TicketRefundStates.REFUNDABLE;
        }
    }]);
    return OrderTicket;
}((0, _immutable.Record)(defaults));

exports.default = OrderTicket;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _isUndefined2 = __webpack_require__(278);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _Photo = __webpack_require__(445);

var _Photo2 = _interopRequireDefault(_Photo);

var _DateOfBirth = __webpack_require__(919);

var _DateOfBirth2 = _interopRequireDefault(_DateOfBirth);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var photocardAge = _TrainTime2.default.duration('P16Y');

var defaults = {
    signup: _AppConstants.SignupTypes.WITHOUT_SMARTCARD,
    selfRegistered: false,
    autoDrOptedIn: false,
    requiresOver16: false,
    dateOfBirth: new _DateOfBirth2.default(),
    photo: new _Photo2.default(),
    isrn: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    townCity: '',
    postcode: '',
    country: 'GBR',
    isOver16: false,
    // TODO: Use referrer instead of isMainRegistration
    isMainRegistration: false
};

var SmartcardRegistration = function (_record) {
    (0, _inherits3.default)(SmartcardRegistration, _record);

    function SmartcardRegistration() {
        (0, _classCallCheck3.default)(this, SmartcardRegistration);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartcardRegistration.prototype.getComputedValues = function getComputedValues() {
        var requiresPhotograph = this.withISRN() ? false : this.requiresPhotograph();
        var requiresISRN = this.withISRN();
        var fileSize = this.photo.selectedImage ? this.photo.selectedImage.size : 0;
        var imageOrientation = this.photo.getImageOrientation();
        var isValidDateOfBirth = this.isValidDateOfBirth();
        var fileFormat = this.photo.selectedImage ? this.photo.selectedImage.type : null;
        var fileWidth = this.photo.imageWidth;
        var fileHeight = this.photo.imageHeight;
        var isEnabledSmartcardRegistration = this.isEnabledSmartcardRegistration();

        return {
            isValidDateOfBirth: isValidDateOfBirth,
            fileSize: fileSize,
            requiresPhotograph: requiresPhotograph,
            imageOrientation: imageOrientation,
            fileFormat: fileFormat,
            requiresISRN: requiresISRN,
            fileWidth: fileWidth,
            fileHeight: fileHeight,
            isEnabledSmartcardRegistration: isEnabledSmartcardRegistration
        };
    };

    SmartcardRegistration.prototype.getSchema = function getSchema() {
        if (!this.withSmartcard()) {
            return {};
        }

        var _getComputedValues = this.getComputedValues(),
            fileWidth = _getComputedValues.fileWidth;

        return {
            addressLine1: _validation2.default.addressLine().required(),

            addressLine2: _validation2.default.textMaxLength(),

            addressLine3: _validation2.default.textMaxLength(),

            townCity: _validation2.default.townCity(),

            postcode: _validation2.default.postcode(),

            country: _joi2.default.any().only(defaults.country),

            isValidDateOfBirth: _joi2.default.boolean().only(true).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.invalid')
                    },
                    boolean: { base: (0, _I18n.translate)('alertmessage.date.invalid') }
                }
            }),

            isEnabledSmartcardRegistration: _joi2.default.boolean().only(true).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('account.register.smartcard.forbidden-child-smartcard-registering')
                    },
                    boolean: { base: (0, _I18n.translate)('account.register.smartcard.forbidden-child-smartcard-registering') }
                }
            }),

            isrn: _joi2.default.alternatives().when('requiresISRN', {
                is: true,
                then: _validation2.default.isrn(),
                otherwise: _joi2.default.any()
            }),

            isOver16: _joi2.default.alternatives().when('requiresISRN', {
                is: true,
                then: _validation2.default.isOver16(),
                otherwise: _joi2.default.alternatives().when('requiresOver16', {
                    is: true,
                    then: _validation2.default.isOver16(),
                    otherwise: _joi2.default.any()
                })
            }),

            photo: _joi2.default.alternatives().when('requiresPhotograph', {
                is: true,
                then: _joi2.default.object().keys({ photo: _validation2.default.requiredString() }),
                otherwise: _joi2.default.any()
            }),

            fileHeight: fileWidth && _joi2.default.alternatives().when('requiresPhotograph', {
                is: true,
                then: _joi2.default.number().min(fileWidth + 1),
                otherwise: _joi2.default.any()
            }),

            fileFormat: !(0, _isUndefined3.default)(window.FileReader) && _config2.default.get('smartcardPhotoMimeTypes') && _config2.default.get('smartcardPhotoMimeTypes').length ? _joi2.default.string().only(null, _config2.default.get('smartcardPhotoMimeTypes')) : _joi2.default.any()
        };
    };

    SmartcardRegistration.prototype.getAddress = function getAddress() {
        return new _Address2.default({
            line1: this.addressLine1,
            line2: this.addressLine2,
            line3: this.addressLine3,
            town: this.townCity,
            postCode: this.postcode,
            country: this.country
        });
    };

    SmartcardRegistration.prototype.getDateOfBirth = function getDateOfBirth() {
        return (0, _result3.default)(this.dateOfBirth, 'getDateOfBirth');
    };

    SmartcardRegistration.prototype.requiresPhotograph = function requiresPhotograph() {
        var dateOfBirth = this.getDateOfBirth();
        var photocardDate = (0, _TrainTime2.default)().subtract(photocardAge);

        return this.signup && !this.isOver16 && dateOfBirth && dateOfBirth.isAfter(photocardDate);
    };

    SmartcardRegistration.prototype.isValidDateOfBirth = function isValidDateOfBirth() {
        return this.isMainRegistration && this.isOver16 ? true : (0, _result3.default)(this.dateOfBirth, 'isComplete');
    };

    SmartcardRegistration.prototype.withSmartcard = function withSmartcard() {
        return this.signup === _AppConstants.SignupTypes.WITH_SMARTCARD;
    };

    SmartcardRegistration.prototype.withISRN = function withISRN() {
        return this.selfRegistered;
    };

    SmartcardRegistration.prototype.withoutSmartcard = function withoutSmartcard() {
        return this.signup === _AppConstants.SignupTypes.WITHOUT_SMARTCARD;
    };

    SmartcardRegistration.prototype.withTransfer = function withTransfer() {
        return this.signup === _AppConstants.SignupTypes.WITH_TRANSFER;
    };

    SmartcardRegistration.prototype.isDateOfBirthOver16YearsOld = function isDateOfBirthOver16YearsOld() {
        var dateOfBirth = this.getDateOfBirth();
        if (!dateOfBirth) {
            return false;
        }
        var sixteenYearsAgo = new Date();
        sixteenYearsAgo.setFullYear(sixteenYearsAgo.getFullYear() - 16);
        return dateOfBirth.isBefore(sixteenYearsAgo);
    };

    SmartcardRegistration.prototype.isEnabledSmartcardRegistration = function isEnabledSmartcardRegistration() {
        return this.isOver16 || _FeatureFlagStore2.default.get('enableChildSmartcardRegistration') || !this.isValidDateOfBirth() || this.isDateOfBirthOver16YearsOld();
    };

    return SmartcardRegistration;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(SmartcardRegistration.prototype, _ValidationMixin2.default);

exports.default = SmartcardRegistration;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Railcard = new _immutable.Record({
    id: null,
    name: null,
    code: '',
    minAdults: 0,
    maxAdults: 0,
    minChildren: 0,
    maxChildren: 0
});

Railcard.fromJSON = function (json) {
    json = json || {};

    var name = (0, _LinkMapper.resolve)(json.name).with(String);
    var code = (0, _LinkMapper.resolve)(json.code).with(String);
    var minAdults = (0, _LinkMapper.resolve)(json.minAdults).with(Number);
    var maxAdults = (0, _LinkMapper.resolve)(json.maxAdults).with(Number);
    var minChildren = (0, _LinkMapper.resolve)(json.minChildren).with(Number);
    var maxChildren = (0, _LinkMapper.resolve)(json.maxChildren).with(Number);

    var result = { name: name, code: code, minAdults: minAdults, maxAdults: maxAdults, minChildren: minChildren, maxChildren: maxChildren };

    return new Railcard(result);
};

(0, _assign2.default)(Railcard.prototype, {
    isGroupSave: function isGroupSave() {
        return this.code === _AppConstants.GROUP_SAVE_CODE;
    },
    mayApplyFareAndTimeRestrictions: function mayApplyFareAndTimeRestrictions() {
        return (0, _values2.default)(_AppConstants.RAILCARD_CODES_WITH_FARE_AND_TIME_RESTRICTIONS).includes(this.code);
    }
});

exports.default = Railcard;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(71).f;
var has = __webpack_require__(120);
var TAG = __webpack_require__(56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(132);
var TAG = __webpack_require__(56)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var defined = __webpack_require__(149);
var fails = __webpack_require__(40);
var spaces = __webpack_require__(471);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 246 */
/***/ (function(module, exports) {



/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(725);
var enumBugKeys = __webpack_require__(500);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(164);
var call = __webpack_require__(729);
var isArrayIter = __webpack_require__(730);
var anObject = __webpack_require__(136);
var toLength = __webpack_require__(372);
var getIterFn = __webpack_require__(501);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(87);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(87),
    stubFalse = __webpack_require__(1042);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(252)(module)))

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(744),
    baseKeysIn = __webpack_require__(1516),
    isArrayLike = __webpack_require__(143);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(103);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1542), __esModule: true };

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _cookiesJs = __webpack_require__(1607);

var _cookiesJs2 = _interopRequireDefault(_cookiesJs);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CookieHelper = {
    getNamespacedCookie: function getNamespacedCookie(name) {
        var namespace = _config2.default.get('namespace');
        return namespace ? namespace + '-' + name : name;
    },
    set: function set(cookieName, value) {
        var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var needToStringify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        var cookieDomain = _config2.default.get('cookieDomain');
        var domain = cookieDomain.find(function (d) {
            return window.location.hostname.endsWith(d);
        });
        attributes = (0, _extends3.default)({
            domain: domain,
            secure: true
        }, attributes);
        _cookiesJs2.default.set(this.getNamespacedCookie(cookieName), needToStringify ? (0, _stringify2.default)(value) : value, attributes);
    },
    get: function get(cookieName, shouldDecode) {
        try {
            var value = _cookiesJs2.default.get(this.getNamespacedCookie(cookieName));
            if ((0, _isString3.default)(value)) {
                if (shouldDecode) {
                    return JSON.parse(atob(value));
                }
                return JSON.parse(value);
            } else {
                return value;
            }
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    clear: function clear(cookieName) {
        var cookieDomain = _config2.default.get('cookieDomain');
        var domain = cookieDomain.find(function (d) {
            return window.location.hostname.endsWith(d);
        });
        _cookiesJs2.default.expire(this.getNamespacedCookie(cookieName), { domain: domain });
    },
    objectFromCookie: function objectFromCookie(cookieName, type) {
        var value = this.get(cookieName);
        if (type && type.fromJSON) {
            return (0, _LinkMapper.resolve)(value).as(type);
        } else if (type) {
            return (0, _LinkMapper.resolve)(value).with(type);
        } else {
            return value;
        }
    },
    objectToCookie: function objectToCookie(cookieName, value, expires) {
        this.set(cookieName, value, { expires: expires });
    }
};

exports.default = CookieHelper;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(397);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(843);
var enumBugKeys = __webpack_require__(553);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(845);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(855));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1795));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1797));

var _removeStyle = _interopRequireDefault(__webpack_require__(1798));

var _properties = __webpack_require__(562);

var _isTransform = _interopRequireDefault(__webpack_require__(1799));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(222);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0;

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenCount += 1;
    } else if (token === ')') {
      parenCount -= 1;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURIComponent(paramValue);
    } else {
      pathname += token;
    }
  }

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _queryString = __webpack_require__(1885);

var _runTransitionHook = __webpack_require__(577);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(225);

var _deprecate = __webpack_require__(226);

var _deprecate2 = _interopRequireDefault(_deprecate);

var SEARCH_BASE_KEY = '$searchBase';

function defaultStringifyQuery(query) {
  return _queryString.stringify(query).replace(/%20/g, '+');
}

var defaultParseQueryString = _queryString.parse;

function isNestedObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
  }return false;
}

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;

    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    function addQuery(location) {
      if (location.query == null) {
        var search = location.search;

        location.query = parseQueryString(search.substring(1));
        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
      }

      // TODO: Instead of all the book-keeping here, this should just strip the
      // stringified query from the search.

      return location;
    }

    function appendQuery(location, query) {
      var _extends2;

      var searchBaseSpec = location[SEARCH_BASE_KEY];
      var queryString = query ? stringifyQuery(query) : '';
      if (!searchBaseSpec && !queryString) {
        return location;
      }

       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var searchBase = undefined;
      if (searchBaseSpec && location.search === searchBaseSpec.search) {
        searchBase = searchBaseSpec.searchBase;
      } else {
        searchBase = location.search || '';
      }

      var search = searchBase;
      if (queryString) {
        search += (search ? '&' : '?') + queryString;
      }

      return _extends({}, location, (_extends2 = {
        search: search
      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
    }

    // Override all read methods with query-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addQuery(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addQuery(location));
      });
    }

    // Override all write methods with query-aware versions.
    function push(location) {
      history.push(appendQuery(location, location.query));
    }

    function replace(location) {
      history.replace(appendQuery(location, location.query));
    }

    function createPath(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;

      return history.createPath(appendQuery(location, query || location.query));
    }

    function createHref(location, query) {
       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;

      return history.createHref(appendQuery(location, query || location.query));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
      if (location.query) {
        fullLocation.query = location.query;
      }
      return addQuery(fullLocation);
    }

    // deprecated
    function pushState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path, { query: query }));
    }

    // deprecated
    function replaceState(state, path, query) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path, { query: query }));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useQueries;
module.exports = exports['default'];

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1953);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var PassengerRailcard = new _immutable.Record({
    code: '',
    quantity: 1
});

PassengerRailcard.fromJSON = function () {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return new PassengerRailcard({
        code: (0, _LinkMapper.resolve)(json.code).with(String),
        quantity: (0, _LinkMapper.resolve)(json.quantity).with(Number)
    });
};

exports.default = PassengerRailcard;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1522);
var v4 = __webpack_require__(1523);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FavouritesStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavouritesStore = exports.FavouritesStore = function (_BaseStore) {
    (0, _inherits3.default)(FavouritesStore, _BaseStore);

    function FavouritesStore() {
        (0, _classCallCheck3.default)(this, FavouritesStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    FavouritesStore.prototype.getInitialState = function getInitialState() {
        var favourites = new _immutable.List();
        return new _immutable.Map({ favourites: favourites });
    };

    FavouritesStore.prototype.getFavourite = function getFavourite(fare, orderTrip) {
        return this.getFavourites().find(function (favourite) {
            return favourite.matchFare(fare, orderTrip);
        });
    };

    FavouritesStore.prototype.getFavouriteById = function getFavouriteById(favouriteId) {
        return this.getFavourites().find(function (_ref) {
            var id = _ref.id;
            return id === favouriteId;
        });
    };

    FavouritesStore.prototype.getFavourites = function getFavourites() {
        return this.get('favourites');
    };

    FavouritesStore.prototype.handleFavouriteAdded = function handleFavouriteAdded(_ref2) {
        var favourite = _ref2.favourite;

        var favourites = this.getFavourites().push(favourite);
        this._setFavourites(favourites);
    };

    FavouritesStore.prototype.handleFavouritesLoaded = function handleFavouritesLoaded(_ref3) {
        var favourites = _ref3.favourites;

        this._setFavourites(favourites);
    };

    FavouritesStore.prototype.handleFavouriteRemoved = function handleFavouriteRemoved(_ref4) {
        var favourite = _ref4.favourite;

        var favourites = this.getFavourites().filterNot(function (fav) {
            return fav === favourite;
        });
        this._setFavourites(favourites);
    };

    FavouritesStore.prototype.handleFavouritePhotocardUpdated = function handleFavouritePhotocardUpdated(_ref5) {
        var favouriteId = _ref5.favouriteId,
            photocard = _ref5.photocard;

        var favourites = this.getFavourites();
        var index = favourites.findIndex(function (fav) {
            return fav.id === favouriteId;
        });
        this._setFavourites(favourites.setIn([index, 'photocard'], photocard));
    };

    FavouritesStore.prototype.handleFavouriteDeliveryAdded = function handleFavouriteDeliveryAdded(_ref6) {
        var favouriteId = _ref6.favouriteId,
            deliveryId = _ref6.deliveryId,
            delivery = _ref6.delivery;

        var favourites = this.getFavourites();
        var index = favourites.findIndex(function (fav) {
            return fav.id === favouriteId;
        });
        this._setFavourites(favourites.setIn([index, 'delivery'], delivery.set('id', deliveryId)));
    };

    FavouritesStore.prototype.handleFavouriteDeliveryUpdated = function handleFavouriteDeliveryUpdated(_ref7) {
        var favouriteId = _ref7.favouriteId,
            delivery = _ref7.delivery;

        var favourites = this.getFavourites();
        var index = favourites.findIndex(function (fav) {
            return fav.id === favouriteId;
        });
        this._setFavourites(favourites.setIn([index, 'delivery'], delivery));
    };

    FavouritesStore.prototype.handleFavouriteSeasonExpiryDateUpdated = function handleFavouriteSeasonExpiryDateUpdated(_ref8) {
        var favouriteId = _ref8.favouriteId,
            seasonExpiryDate = _ref8.seasonExpiryDate;

        var favourites = this.getFavourites();
        var index = favourites.findIndex(function (fav) {
            return fav.id === favouriteId;
        });
        this._setFavourites(favourites.setIn([index, 'seasonExpiry'], seasonExpiryDate));
    };

    FavouritesStore.prototype.handleFavouriteLastUsedDateUpdated = function handleFavouriteLastUsedDateUpdated(_ref9) {
        var favouriteId = _ref9.favouriteId,
            lastUsedDate = _ref9.lastUsedDate;

        var favourites = this.getFavourites();
        var index = favourites.findIndex(function (fav) {
            return fav.id === favouriteId;
        });
        this._setFavourites(favourites.setIn([index, 'lastUsed'], lastUsedDate));
    };

    // Firstly sort by season tickets expiring soon,
    // then by date last used


    FavouritesStore.prototype._sortFavourites = function _sortFavourites(favourites) {
        return favourites.sort(function (a, b) {
            // Compare season ticket expiry
            var compareExpiringSoon = 0;
            if (a.isExpiringSoon() && !b.isExpiringSoon()) {
                compareExpiringSoon = -1;
            } else if (!a.isExpiringSoon() && b.isExpiringSoon()) {
                compareExpiringSoon = 1;
            } else if (a.isExpiringSoon() && b.isExpiringSoon()) {
                compareExpiringSoon = a.getDaysToExpiry() - b.getDaysToExpiry();
            }

            // Compare date last used
            var compareLastUsed = 0;
            if (a.lastUsed && !b.lastUsed) {
                compareLastUsed = -1;
            } else if (!a.lastUsed && b.lastUsed) {
                compareLastUsed = 1;
            } else if (a.lastUsed && b.lastUsed) {
                compareLastUsed = b.lastUsed - a.lastUsed;
            }

            // Last resort, sort by most recently created
            var compareMostRecentlyCreated = b.id - a.id;

            return compareExpiringSoon || compareLastUsed || compareMostRecentlyCreated;
        });
    };

    FavouritesStore.prototype._setFavourites = function _setFavourites(favourites) {
        this.setState(this.state.set('favourites', this._sortFavourites(favourites)));
    };

    FavouritesStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref10;

        return _ref10 = {}, _ref10[_AppConstants.ActionTypes.FAVOURITES_ADDED] = this.handleFavouriteAdded, _ref10[_AppConstants.ActionTypes.FAVOURITES_REMOVED] = this.handleFavouriteRemoved, _ref10[_AppConstants.ActionTypes.FAVOURITES_LOADED] = this.handleFavouritesLoaded, _ref10[_AppConstants.ActionTypes.FAVOURITES_PHOTOCARD_UPDATED] = this.handleFavouritePhotocardUpdated, _ref10[_AppConstants.ActionTypes.FAVOURITES_DELIVERY_ADDED] = this.handleFavouriteDeliveryAdded, _ref10[_AppConstants.ActionTypes.FAVOURITES_DELIVERY_UPDATED] = this.handleFavouriteDeliveryUpdated, _ref10[_AppConstants.ActionTypes.FAVOURITES_SEASON_EXPIRY_DATE_UPDATED] = this.handleFavouriteSeasonExpiryDateUpdated, _ref10[_AppConstants.ActionTypes.FAVOURITES_LAST_USED_DATE_UPDATED] = this.handleFavouriteLastUsedDateUpdated, _ref10;
    };

    return FavouritesStore;
}(_BaseStore3.default);

exports.default = new FavouritesStore();

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _some2 = __webpack_require__(284);

var _some3 = _interopRequireDefault(_some2);

var _map2 = __webpack_require__(314);

var _map3 = _interopRequireDefault(_map2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _union2 = __webpack_require__(902);

var _union3 = _interopRequireDefault(_union2);

var _mergeWith2 = __webpack_require__(1917);

var _mergeWith3 = _interopRequireDefault(_mergeWith2);

var _isObject2 = __webpack_require__(77);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = __webpack_require__(68);

var _isArray3 = _interopRequireDefault(_isArray2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _inRange2 = __webpack_require__(1921);

var _inRange3 = _interopRequireDefault(_inRange2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _times2 = __webpack_require__(598);

var _times3 = _interopRequireDefault(_times2);

exports.serialiseRailcards = serialiseRailcards;

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AppConstants = __webpack_require__(6);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _Service = __webpack_require__(273);

var _Service2 = _interopRequireDefault(_Service);

var _PlusBus = __webpack_require__(343);

var _PlusBus2 = _interopRequireDefault(_PlusBus);

var _LinkMapper = __webpack_require__(8);

var _PromoCodeStore = __webpack_require__(342);

var _PromoCodeStore2 = _interopRequireDefault(_PromoCodeStore);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function serialiseRailcards(search) {
    return search.railcards.flatMap(function (r) {
        return (0, _times3.default)(r.quantity, function () {
            return r.code;
        });
    }).toJS();
}

var getPromoCode = function getPromoCode(searchRecord) {
    var currentOrder = _OrderStore2.default.getCurrent();

    var promo = !searchRecord.promoCode.isEmpty() ? searchRecord.promoCode : _PromoCodeStore2.default.getActive();
    if (!currentOrder || !promo) {
        return null;
    }

    var isThisPromoCodeHasAlreadyApplied = currentOrder.checkIfThisPromoCodeHasAlreadyApplied(promo.promoCode);

    if (promo && !isThisPromoCodeHasAlreadyApplied) {
        return promo.promoCode;
    }
    return null;
};

function requestSearch(searchRecord, user, delayRepayFiltering) {
    var url = '/jp/journey-plan';

    var requestBody = {
        origin: searchRecord.origin.nlc,
        destination: searchRecord.destination.nlc,
        outward: searchRecord.outboundDateTime.toRange({ truncateStart: (0, _TrainTime2.default)() }),
        openReturn: searchRecord.ticketType === _AppConstants.TicketTypes.OPEN_RETURN,
        adults: searchRecord.adults,
        children: searchRecord.children,
        disableGroupSavings: !searchRecord.groupSave,
        numJourneys: searchRecord.numJourneys,
        showCheapest: searchRecord.showCheapest,
        doRealTime: searchRecord.realTime,
        keepAllZoneFares: false,
        filterFares: true,
        delayRepayFiltering: delayRepayFiltering,
        isAmending: searchRecord.isAmending,
        orderId: searchRecord.orderId,
        preferences: {
            loadEarlier: searchRecord.searchPreferences.loadEarlier
        }
    };

    if (user && user.id) {
        requestBody.customerId = user.id;
    }

    if (searchRecord.email) {
        requestBody.customerEmail = searchRecord.email;
    }

    var serviceProviders = _config2.default.get('serviceProviders'),
        alwaysFilterByServiceProviders = _config2.default.get('alwaysFilterByServiceProviders');

    if (serviceProviders && (alwaysFilterByServiceProviders || searchRecord.tocSpecific)) {
        requestBody.serviceProviders = serviceProviders;
    }

    var promoCode = getPromoCode(searchRecord);
    if (promoCode) {
        requestBody.promoCode = promoCode;
    }

    var railcards = serialiseRailcards(searchRecord);
    if (railcards.length > 0) {
        requestBody.railcards = railcards;
    }

    var preferences = {};

    if (searchRecord.via.nlc || searchRecord.avoid.nlc) {
        preferences.via = searchRecord.via.nlc ? [searchRecord.via.nlc] : null;
        preferences.avoid = searchRecord.avoid.nlc ? [searchRecord.avoid.nlc] : null;
    }

    if (searchRecord.smartcard && user) {
        preferences.smartCard = true;
        if (user.isChild()) {
            (0, _assign2.default)(requestBody, { adults: 0, children: 1 });
        } else {
            (0, _assign2.default)(requestBody, { adults: 1, children: 0 });
        }
    }

    if (searchRecord.ticketType === _AppConstants.TicketTypes.RETURN) {
        var minReturnStart = searchRecord.outboundDateTime.getStart().add(15, 'minutes');
        var maxOutwardEnd = searchRecord.returnDateTime.getEnd().subtract(15, 'minutes');
        requestBody.outward = searchRecord.outboundDateTime.toRange({ truncateEnd: maxOutwardEnd });
        requestBody.return = searchRecord.returnDateTime.toRange({ truncateStart: minReturnStart });
    }

    if (!(0, _isEmpty3.default)(preferences)) {
        requestBody.preferences = preferences;
    }

    return _APIClient2.default.post(url, requestBody);
}

function qualifiesForGroupSave(_ref) {
    var adults = _ref.adults,
        children = _ref.children;

    var passengerCount = adults + children;
    var MIN = _AppConstants.GroupSavePassengers.MIN,
        MAX = _AppConstants.GroupSavePassengers.MAX;

    return (0, _inRange3.default)(passengerCount, MIN, MAX + 1);
}

function resolveResponse(responseBody) {
    var outward = (0, _result3.default)(responseBody.result, 'outward', []);
    var inward = (0, _result3.default)(responseBody.result, 'return', []);
    var hasServiceProvider = (0, _result3.default)(responseBody.result, 'useServiceProvider', false);

    var outServices = (0, _LinkMapper.resolveAll)(outward).as(_Service2.default);
    var inwardServices = (0, _LinkMapper.resolveAll)(inward).as(_Service2.default);

    return { outward: outServices, inward: inwardServices, hasServiceProvider: hasServiceProvider };
}

function mergeCheapest(left, right) {
    var cheapest = null;
    if (!(0, _isArray3.default)(left) && (0, _isObject3.default)(left) && (0, _result3.default)(left, 'totalPrice')) {
        cheapest = left;
    }

    if (!(0, _isArray3.default)(right) && (0, _isObject3.default)(right) && (0, _result3.default)(right, 'totalPrice') && parseInt((0, _result3.default)(cheapest, 'totalPrice')) > parseInt((0, _result3.default)(right, 'totalPrice'))) {
        cheapest = right;
    }

    return cheapest;
}

function mergeFares(left, right) {
    return (0, _mergeWith3.default)(left, right, function (l, r) {
        // eslint-disable-line  consistent-return
        if (Array.isArray(l) || Array.isArray(r)) {
            return (0, _union3.default)(l, r);
        }
        return mergeCheapest(l, r);
    });
}

function mergeServices(left, right) {
    var combinedServices = (0, _compact3.default)([].concat(left, right));
    var journeyFares = combinedServices.reduce(function (acc, _ref2) {
        var journey = _ref2.journey,
            fares = _ref2.fares;

        if (journey in acc) {
            acc[journey] = mergeFares(acc[journey], fares);
        } else {
            acc[journey] = fares;
        }
        return acc;
    }, {});
    return (0, _keys2.default)(journeyFares).reduce(function (services, journey) {
        services.push({
            journey: journey,
            fares: journeyFares[journey]
        });
        return services;
    }, []);
}

function mergeResponses(searchResponse, groupSaveResponse) {
    if (!groupSaveResponse) {
        return searchResponse;
    }

    var sources = [searchResponse, groupSaveResponse];

    return {
        result: {
            outward: mergeServices.apply(undefined, (0, _map3.default)(sources, 'result.outward')),
            return: mergeServices.apply(undefined, (0, _map3.default)(sources, 'result.return')),
            useServiceProvider: (0, _some3.default)((0, _map3.default)(sources, 'result.useServiceProvider'))
        }
    };
}

function findCheapestOpenReturn(serviceList) {
    return serviceList.outward.sortBy(function (_ref3) {
        var fares = _ref3.fares;
        return fares.cheapest.return.totalPrice;
    }).first();
}

var JourneyPlanService = {
    search: function search(options) {
        var _options$delayRepayFi = options.delayRepayFiltering,
            delayRepayFiltering = _options$delayRepayFi === undefined ? false : _options$delayRepayFi,
            search = options.search,
            user = options.user;

        var searches = [requestSearch(search, user, delayRepayFiltering)];

        if (qualifiesForGroupSave(search)) {
            var groupSaveSearch = search.set('groupSave', true);
            searches.push(requestSearch(groupSaveSearch, user));
        }

        return _promise2.default.all(searches).then(function (responses) {
            return resolveResponse(mergeResponses.apply(undefined, responses));
        });
    },
    getCheapestOpenReturn: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(searchRecord, user) {
            var serviceList, cheapestOpenReturn;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return this.search(searchRecord, user);

                        case 3:
                            serviceList = _context.sent;
                            cheapestOpenReturn = findCheapestOpenReturn(serviceList);

                            if (cheapestOpenReturn) {
                                _context.next = 7;
                                break;
                            }

                            throw new Error('No open return tickets available for this trip');

                        case 7:
                            return _context.abrupt('return', cheapestOpenReturn.fares.cheapest.return.totalPrice);

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            console.warn(_context.t0.message);
                            return _context.abrupt('return', null);

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 10]]);
        }));

        function getCheapestOpenReturn(_x, _x2) {
            return _ref4.apply(this, arguments);
        }

        return getCheapestOpenReturn;
    }(),
    plusBus: function plusBus(trip) {
        var search = trip.search;

        var url = '/jp/plusbus';
        var requestBody = {
            adults: search.adults,
            children: search.children
        };

        requestBody.outward = {
            origin: search.getIn(['origin', 'id']),
            destination: search.getIn(['destination', 'id']),
            date: search.outboundDateTime.datetime.format('YYYY-MM-DD')
        };

        if (trip.isReturn()) {
            requestBody.return = {
                origin: search.getIn(['destination', 'id']),
                destination: search.getIn(['origin', 'id']),
                date: search.returnDateTime.datetime.format('YYYY-MM-DD')
            };
        }

        var railcards = serialiseRailcards(search);
        if (railcards.length > 0) {
            requestBody.railcards = railcards;
        }

        return _APIClient2.default.post(url, requestBody).then(function (response) {
            return (0, _LinkMapper.resolve)(response.result).as(_PlusBus2.default);
        });
    },
    validatePromoCode: function validatePromoCode(customerId, promoCode) {
        var customerIdParam = customerId ? '&customerId=' + customerId : '';
        return _APIClient2.default.get('/jp/promotional-discounts?channel=web&promoCode=' + promoCode + customerIdParam);
    }
};

exports.default = JourneyPlanService;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _some2 = __webpack_require__(284);

var _some3 = _interopRequireDefault(_some2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _momentTimezone = __webpack_require__(235);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _Fares = __webpack_require__(605);

var _Fares2 = _interopRequireDefault(_Fares);

var _Journey = __webpack_require__(826);

var _Journey2 = _interopRequireDefault(_Journey);

var _LinkMapper = __webpack_require__(8);

var _Durations = __webpack_require__(430);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _brand = __webpack_require__(435);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    journey: new _Journey2.default(),
    fares: new _Fares2.default(),
    oysterPrice: null
};

var Service = function (_record) {
    (0, _inherits3.default)(Service, _record);

    function Service() {
        (0, _classCallCheck3.default)(this, Service);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Service.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(Service, json, {
            id: json.id || json.journey,
            journey: _LinkMapper.resolve.as(_Journey2.default),
            fares: _LinkMapper.resolve.as(_Fares2.default),
            oysterPrice: _LinkMapper.fields.number
        });
    };

    Service.prototype.isSeatReservable = function isSeatReservable() {
        return this.isSeatAvailable() && !this.isSeatCompulsory();
    };

    Service.prototype.isSeatAvailable = function isSeatAvailable() {
        return this.getIn(['journey', 'legs']).filter(function (leg) {
            return leg.serviceDetails.mode === _AppConstants.TransitModes.TRAIN && !leg.serviceDetails.isCountedPlace;
        }).map(function (leg) {
            return leg.getIn(['serviceDetails', 'reservable']);
        }).some(function (state) {
            return state !== _AppConstants.ReservableStates.NO;
        });
    };

    Service.prototype.isSeatCompulsory = function isSeatCompulsory() {
        return this.getIn(['journey', 'legs']).filterNot(function (leg) {
            return leg.getIn(['serviceDetails', 'isCountedPlace']);
        }).map(function (leg) {
            return leg.getIn(['serviceDetails', 'reservable']);
        }).some(function (state) {
            return state === _AppConstants.ReservableStates.COMPULSORY;
        });
    };

    Service.prototype.hasCountedPlaceWarning = function hasCountedPlaceWarning() {
        var tocs = _config2.default.get('showCountedPlaceWarnings');
        if (!tocs || tocs.length === 0) {
            return false;
        }

        var countedPlaces = this.journey.getCountedPlaceLegs();
        return countedPlaces.some(function (leg) {
            var isCompulsory = leg.getIn(['serviceDetails', 'reservable']) === _AppConstants.ReservableStates.COMPULSORY;
            var tocCode = leg.getIn(['serviceDetails', 'toc', 'code']);
            return isCompulsory && tocs.includes(tocCode);
        });
    };

    Service.prototype.getCheapestTotalPrice = function getCheapestTotalPrice() {
        return this.fares.getCheapestTotalPrice();
    };

    Service.prototype.getFaresWithout = function getFaresWithout(fare) {
        return this.fares.without(fare);
    };

    Service.prototype.getCheapestForDirection = function getCheapestForDirection(direction) {
        return this.fares.getCheapestForDirection(direction);
    };

    Service.prototype.getCheapestInwardSingle = function getCheapestInwardSingle() {
        return this.fares.getCheapestInwardSingle();
    };

    Service.prototype.getCheapestInwardSinglePrice = function getCheapestInwardSinglePrice() {
        return this.fares.getCheapestInwardSinglePrice();
    };

    Service.prototype.isValidWithFare = function isValidWithFare(fare) {
        var fareType = fare.isReturn() ? 'returns' : 'singles';
        return !!this.fares.get(fareType).find(function (serviceFare) {
            return serviceFare.id === fare.id;
        });
    };

    Service.prototype.isAdjustedDepartureTime = function isAdjustedDepartureTime() {
        return (0, _result3.default)(this.get('journey'), 'isAdjustedDepartureTime');
    };

    Service.prototype.isAdjustedArrivalTime = function isAdjustedArrivalTime() {
        return (0, _result3.default)(this.get('journey'), 'isAdjustedArrivalTime');
    };

    Service.prototype.getDepartureDelay = function getDepartureDelay() {
        return this.journey.getDepartureDateTime().calendarDiff(this.journey.getDepartureDateTime(false));
    };

    Service.prototype.getArrivalDelay = function getArrivalDelay() {
        return this.journey.getArrivalDateTime().calendarDiff(this.journey.getArrivalDateTime(false));
    };

    Service.prototype.isDelayed = function isDelayed() {
        return _momentTimezone2.default.duration(this.getArrivalDelay()).as('minutes') > _config2.default.get('minServiceDelay');
    };

    Service.prototype.getDepartureDateTime = function getDepartureDateTime() {
        var adjusted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        return this.journey.getDepartureDateTime(adjusted);
    };

    Service.prototype.getArrivalDateTime = function getArrivalDateTime() {
        var adjusted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        return this.journey.getArrivalDateTime(adjusted);
    };

    Service.prototype.getTripDuration = function getTripDuration() {
        return this.journey.getTripDuration();
    };

    Service.prototype.getReplacementBusCount = function getReplacementBusCount() {
        return this.getIn(['journey', 'legs']).filter(function (leg) {
            return leg.getIn(['serviceDetails', 'mode']) === _AppConstants.TransitModes.REPLACEMENT_BUS;
        }).size;
    };

    Service.prototype.getOriginStation = function getOriginStation() {
        return this.getIn(['journey', 'origin', 'station']);
    };

    Service.prototype.getDestinationStation = function getDestinationStation() {
        return this.getIn(['journey', 'destination', 'station']);
    };

    Service.prototype.getAllReturnTravelcards = function getAllReturnTravelcards() {
        return this.fares.returns.filter(function (item) {
            return item.ticketType.isReturnTravelcard();
        });
    };

    Service.prototype.hasReturnTravelcards = function hasReturnTravelcards() {
        return this.fares.returns.some(function (fare) {
            return fare.ticketType.isReturnTravelcard();
        });
    };

    Service.prototype.getChanges = function getChanges() {
        return this.getIn(['journey', 'changes']);
    };

    Service.prototype.hasReplacementBus = function hasReplacementBus() {
        return this.getReplacementBusCount() !== 0;
    };

    Service.prototype.isHistoric = function isHistoric() {
        return (0, _result3.default)(this.getDepartureDateTime(), 'isBefore');
    };

    Service.prototype.isOvertaken = function isOvertaken() {
        return this.getIn(['journey', 'isOvertaken']);
    };

    Service.prototype.isCollectable = function isCollectable() {
        var minTodOffset = this.getMinTodOffset();
        var collectionStart = _TrainTime2.default.duration(_config2.default.get(minTodOffset));
        return (0, _TrainTime2.default)().add(collectionStart).isBefore(this.getDepartureDateTime());
    };

    Service.prototype.isCollectableSmartcard = function isCollectableSmartcard() {
        var collectionStart = _TrainTime2.default.duration(_config2.default.get('minSmartcardOffset'));
        return (0, _TrainTime2.default)().add(collectionStart).isBefore(this.getDepartureDateTime());
    };

    Service.prototype.isBeforeServiceArrival = function isBeforeServiceArrival(service) {
        if (service) {
            return this.getDepartureDateTime().isBefore(service.getArrivalDateTime());
        } else {
            return false;
        }
    };

    Service.prototype.operators = function operators() {
        return this.journey.operators();
    };

    Service.prototype.includesBrandToc = function includesBrandToc() {
        return this.operators().some(function (toc) {
            return toc.code === _config2.default.get('tocCode');
        });
    };

    Service.prototype.isDisabled = function isDisabled() {
        var journeyStartDate = this.journey.getDepartureDateTime();
        var tocs = this.operators();

        var disabledServices = new _immutable.List(_config2.default.get('disabledServices'));

        var disabled = disabledServices.filter(function (_ref) {
            var tocCode = _ref.tocCode,
                startDate = _ref.startDate,
                endDate = _ref.endDate;

            var matchTOC = function matchTOC(toc) {
                return toc.code === tocCode;
            };

            return tocs.some(matchTOC) && journeyStartDate.isBetween(startDate, endDate);
        });

        if (disabled.size) {
            return (0, _I18n.translate)(disabled.first().message, { moreInfo: _config2.default.get('bannerMessageURL') });
        }

        return false;
    };

    Service.prototype.isCancelled = function isCancelled() {
        return (0, _result3.default)(this.get('journey'), 'isCancelled');
    };

    Service.prototype.isDisrupted = function isDisrupted() {
        return this.journey.isDisrupted();
    };

    Service.prototype.isDisabledForTrip = function isDisabledForTrip(trip) {
        return (0, _some3.default)([this.isDisabled(), this.isCancelled(), this.isHistoric(), !this.isCollectable(), !this.isCollectableSmartcard() && trip.isSmartcard()]);
    };

    Service.prototype.getCancellationMessage = function getCancellationMessage() {
        return this.journey.getCancellationMessage();
    };

    Service.prototype.hasBulletins = function hasBulletins() {
        return (0, _result3.default)(this.get('journey'), 'hasBulletins');
    };

    Service.prototype.hasFareCategoryAndMatchingRouteAndPrice = function hasFareCategoryAndMatchingRouteAndPrice(category, route) {
        return this.fares.getAllFares().some(function (fare) {
            return fare.category === category && fare.route.code === route.code;
        });
    };

    Service.prototype.getBulletins = function getBulletins() {
        return (0, _result3.default)(this.get('journey'), 'bulletins');
    };

    Service.prototype.hasP1bulletin = function hasP1bulletin() {
        return (0, _result3.default)(this.get('journey'), 'hasP1bulletin');
    };

    Service.prototype.getJourneyDateDescription = function getJourneyDateDescription() {
        return (0, _I18n.translate)('booking.journey.srDateDescription', {
            scheduledDepartureDate: this.getDepartureDateTime(false).format('ddd DD MMM YYYY'),
            scheduledDeparture: this.getDepartureDateTime(false).format('HH:mm'),
            scheduledArrival: this.getArrivalDateTime(false).format('HH:mm')
        });
    };

    Service.prototype.getShortDescription = function getShortDescription() {
        return (0, _I18n.translate)('booking.journey.srShortDescription', {
            scheduledDeparture: this.getDepartureDateTime(false).format('HH:mm'),
            origin: (0, _I18n.translate)('booking.journey.stationName', this.getOriginStation().toJS()),
            scheduledArrival: this.getArrivalDateTime(false).format('HH:mm'),
            destination: (0, _I18n.translate)('booking.journey.stationName', this.getDestinationStation().toJS())
        });
    };

    Service.prototype.getLongDescription = function getLongDescription() {
        var cancelled = this.isCancelled();
        var adjusted = this.isAdjustedArrivalTime();
        var delayed = this.journey.isArrivalDelayed() || this.journey.isIndeterminateDelay();
        var scheduledDeparture = this.getDepartureDateTime(false);
        var scheduledArrival = this.getArrivalDateTime(false);
        var duration = (0, _Durations.diffDuration)(scheduledDeparture, scheduledArrival);
        var delayText = '';
        if (cancelled) {
            delayText = (0, _I18n.translate)('booking.service-carousel.item.cancelled');
        } else if (!cancelled && delayed && adjusted) {
            var delayString = (0, _Durations.diffDuration)(scheduledArrival, this.getArrivalDateTime());
            delayText = (0, _I18n.translate)('booking.journey.delay', { delay: (0, _Durations.durationString)(delayString, { type: 'long' }) });
        } else if (!cancelled && delayed && !adjusted) {
            delayText = (0, _I18n.translate)('booking.service-carousel.item.delayed');
        } else if (!cancelled && !delayed && !adjusted) {
            delayText = (0, _I18n.translate)('booking.service-carousel.item.on-time');
        }

        var longDescription = (0, _I18n.translate)('booking.journey.srLongDescription', {
            scheduledDeparture: scheduledDeparture.format('HH:mm'),
            origin: (0, _I18n.translate)('booking.journey.stationName', this.getOriginStation().toJS()),
            scheduledArrival: scheduledArrival.format('HH:mm'),
            destination: (0, _I18n.translate)('booking.journey.stationName', this.getDestinationStation().toJS()),
            duration: (0, _Durations.durationString)(duration, { type: 'long' }),
            changes: (0, _I18n.translate)('booking.journey.srChanges', { changes: this.getChanges() }),
            delay: delayText
        });

        return !cancelled && delayed && adjusted ? longDescription + ' ' + (0, _I18n.translate)('booking.journey.srAdjustedTimes', {
            adjustedDeparture: this.getDepartureDateTime().format('HH:mm'),
            adjustedArrival: this.getArrivalDateTime().format('HH:mm')
        }) : longDescription;
    };

    Service.prototype.getMinTodOffset = function getMinTodOffset() {
        var _getBrandInfo = (0, _brand.getBrandInfo)(),
            isGTR = _getBrandInfo.isGTR;

        return isGTR ? 'minTodGTROffset' : 'minTodOffset';
    };

    Service.prototype.hasOtherAsServiceOperator = function hasOtherAsServiceOperator() {
        var _getBrandInfo2 = (0, _brand.getBrandInfo)(),
            isGTR = _getBrandInfo2.isGTR;

        return isGTR ? this.getIn(['journey', 'legs']).some(function (leg) {
            return leg.getIn(['serviceDetails', 'mode']) === 'Other';
        }) : false;
    };

    return Service;
}((0, _immutable.Record)(defaults));

exports.default = Service;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Loading(_ref) {
    var className = _ref.className,
        standalone = _ref.standalone,
        unwrapped = _ref.unwrapped,
        inline = _ref.inline,
        message = _ref.message,
        children = _ref.children;

    var loader = _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('loading', className, {
                'loading--standalone': standalone,
                'text-center': !inline,
                'loading--inline': inline
            }) },
        _react2.default.createElement('span', { className: 'otrl circle-spinner' }),
        message && _react2.default.createElement(
            'p',
            { className: 'loading-message' },
            (0, _I18n.translate)(message)
        ),
        children
    );
    return unwrapped || inline ? loader : _react2.default.createElement(
        'div',
        { className: 'left-col left-col--loading' },
        loader
    );
}

Loading.propTypes = {
    className: _propTypes2.default.string,
    message: _propTypes2.default.string,
    unwrapped: _propTypes2.default.bool,
    standalone: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    children: _propTypes2.default.any
};

Loading.defaultProps = {
    className: '',
    unwrapped: false,
    standalone: false,
    inline: false,
    children: null
};

exports.default = Loading;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(572);

var _Link2 = _interopRequireDefault(_Link);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _PropTypes = __webpack_require__(85);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Link(_ref) {
    var to = _ref.to,
        params = _ref.params,
        query = _ref.query,
        absolute = _ref.absolute,
        tabIndex = _ref.tabIndex,
        srOnly = _ref.srOnly,
        router = _ref.router,
        restProps = (0, _objectWithoutProperties3.default)(_ref, ['to', 'params', 'query', 'absolute', 'tabIndex', 'srOnly', 'router']);

    var expectedTabIndex = restProps.disabled ? -1 : tabIndex;
    if (_urls2.default.hasMatchingRoute(to) && !absolute) {
        var location = _urls2.default.location(to, params, query);
        var isCurrent = router && router.isActive(location);
        return _react2.default.createElement(
            _Link2.default,
            (0, _extends3.default)({
                to: location,
                activeClassName: 'active',
                tabIndex: expectedTabIndex,
                'aria-current': isCurrent ? 'page' : null
            }, restProps),
            srOnly && _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                srOnly
            ),
            restProps.children
        );
    } else {
        var url = _urls2.default.getUrl(to, params, query);
        return _react2.default.createElement(
            'a',
            (0, _extends3.default)({ href: url }, restProps, { tabIndex: expectedTabIndex }),
            srOnly && _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                srOnly
            ),
            restProps.children
        );
    }
}

Link.propTypes = {
    to: _propTypes2.default.string.isRequired,
    params: _propTypes2.default.object,
    query: _propTypes2.default.object,
    absolute: _propTypes2.default.bool,
    tabIndex: _propTypes2.default.string,
    router: _PropTypes.routerShape,
    srOnly: _propTypes2.default.string
};

Link.defaultProps = {
    params: null,
    query: null,
    absolute: false,
    tabIndex: "0",
    srOnly: ''
};

exports.default = (0, _withRouter2.default)(Link);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressLineOne = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(AddressLineOne, _PureRenderComponent);

    function AddressLineOne() {
        (0, _classCallCheck3.default)(this, AddressLineOne);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    AddressLineOne.prototype.renderLabel = function renderLabel() {
        if (this.props.hasLabels) {
            return _react2.default.createElement(
                'label',
                { htmlFor: this.props.id, className: 'label' },
                (0, _I18n.translate)('customerdetails.' + this.props.id)
            );
        }
        return null;
    };

    AddressLineOne.prototype.render = function render() {
        return _react2.default.createElement(
            'div',
            { className: this.props.id },
            this.renderLabel(),
            _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, this.props, {
                type: 'text',
                name: this.props.id,
                id: this.props.id,
                field: this.props.field,
                label: (0, _I18n.translate)('customerdetails.' + this.props.id),
                placeholder: this.props.hasLabels ? '' : (0, _I18n.translate)('customerdetails.' + this.props.id),
                labelClassName: 'sr-only'
            }))
        );
    };

    return AddressLineOne;
}(_PureRenderComponent3.default), _class.propTypes = (0, _extends3.default)({}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['id', 'form', 'onChange', 'required', 'disabled', 'visited', 'validation', 'field']), {
    hasLabels: _propTypes2.default.bool
}), _class.defaultProps = {
    'field': 'addressLine1',
    'id': 'addressline1'
}, _temp);
exports.default = AddressLineOne;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77),
    now = __webpack_require__(1509),
    toNumber = __webpack_require__(312);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _extends5 = __webpack_require__(13);

var _extends6 = _interopRequireDefault(_extends5);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _TicketMetadata = __webpack_require__(1685);

var _TicketMetadata2 = _interopRequireDefault(_TicketMetadata);

var _LinkMapper = __webpack_require__(8);

var _I18n = __webpack_require__(9);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var min5Yold = _TrainTime2.default.duration('P5Y');
var min16Yold = _TrainTime2.default.duration('P16Y');
var customerTitles = _config2.default.get('customerTitles') || [];

var defaultUserEmptyValues = ['id', 'title', 'firstName', 'lastName', 'isOver16', 'yearOfBirth', 'monthOfBirth', 'dayOfBirth', 'addressLine1', 'addressLine2', 'addressLine3', 'townCity', 'postcode', 'number', 'nickname', 'linkCard'];

var defaults = {
    id: null,
    ticketId: null,
    title: customerTitles[0],
    firstName: null,
    lastName: null,
    isOver16: true,
    yearOfBirth: null,
    monthOfBirth: null,
    dayOfBirth: null,
    addressLine1: null,
    addressLine2: null,
    addressLine3: null,
    townCity: null,
    country: _config2.default.get('defaultDeliveryCountry'),
    postcode: null,
    number: null,
    nickname: null,
    linkCard: false,
    metaData: null
};

var Photocard = function (_record) {
    (0, _inherits3.default)(Photocard, _record);

    function Photocard() {
        (0, _classCallCheck3.default)(this, Photocard);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Photocard.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Photocard, json, {
            id: _LinkMapper.fields.number,
            ticketId: _LinkMapper.fields.number,
            title: json.title ? _LinkMapper.fields.string : customerTitles[0],
            firstName: _LinkMapper.fields.string,
            lastName: _LinkMapper.fields.string,
            isOver16: !!json.isOver16,
            yearOfBirth: json.yearOfBirth ? _LinkMapper.fields.number : null,
            monthOfBirth: json.monthOfBirth ? _LinkMapper.fields.number : null,
            dayOfBirth: json.dayOfBirth ? _LinkMapper.fields.number : null,
            addressLine1: _LinkMapper.fields.string,
            addressLine2: _LinkMapper.fields.string,
            addressLine3: _LinkMapper.fields.string,
            townCity: _LinkMapper.fields.string,
            country: _config2.default.get('defaultDeliveryCountry'),
            postcode: _LinkMapper.fields.string,
            number: _LinkMapper.fields.string,
            nickname: _LinkMapper.fields.string,
            linkCard: _LinkMapper.fields.bool,
            metaData: (0, _LinkMapper.resolve)(json.metaData).as(_TicketMetadata2.default) || new _immutable.Map()
        });
    };

    Photocard.prototype.getComputedValues = function getComputedValues() {
        var dateOfBirth = this.getDateOfBirth();
        var isInFuture = !!(dateOfBirth && dateOfBirth.isValid() && dateOfBirth.isAfter((0, _TrainTime2.default)()));
        var isInvalidDate = !!(dateOfBirth && !dateOfBirth.isValid());
        var isTooYoung = !!(dateOfBirth && !isInvalidDate && this.isTooYoung(dateOfBirth, min5Yold, 'isAfter'));
        var isOver16WithoutFlag = !!(dateOfBirth && !isInvalidDate && this.isTooYoung(dateOfBirth, min16Yold, 'isBefore'));
        return {
            isInFuture: isInFuture,
            isInvalidDate: isInvalidDate,
            isTooYoung: isTooYoung,
            isOver16WithoutFlag: isOver16WithoutFlag
        };
    };

    Photocard.prototype.getSchema = function getSchema() {
        var defaultErrorMessage = {
            language: {
                number: {
                    base: (0, _I18n.translate)('alertmessage.choose')
                }
            }
        };

        return {
            title: _validation2.default.title((0, _I18n.translate)('alertmessage.required.short')).required(),
            firstName: _validation2.default.photocardHolder(),
            lastName: _validation2.default.photocardHolder((0, _I18n.translate)('alertmessage.badPhotocardLastName')),

            yearOfBirth: _joi2.default.alternatives().when('isOver16', {
                is: false,
                then: _joi2.default.number().integer().options(defaultErrorMessage),
                otherwise: _joi2.default.any()
            }),

            monthOfBirth: _joi2.default.alternatives().when('isOver16', {
                is: false,
                then: _joi2.default.number().integer().min(1).max(12).options(defaultErrorMessage),
                otherwise: _joi2.default.any()
            }),

            dayOfBirth: _joi2.default.alternatives().when('isOver16', {
                is: false,
                then: _joi2.default.number().integer().min(1).max(31).options(defaultErrorMessage),
                otherwise: _joi2.default.any()
            }),

            isInFuture: _joi2.default.boolean().optional().only(null, false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.future')
                    }
                }
            }),

            isInvalidDate: _joi2.default.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.invalid')
                    }
                }
            }),

            isTooYoung: _joi2.default.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.tooYoungPhotocard')
                    }
                }
            }),

            isOver16WithoutFlag: _joi2.default.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.under16Photocard')
                    }
                }
            }),

            addressLine1: _validation2.default.addressLine().required(),
            addressLine2: _validation2.default.textMaxLength(),
            addressLine3: _validation2.default.textMaxLength(),
            townCity: _validation2.default.townCity(),
            postcode: _validation2.default.postcode(),
            number: _joi2.default.any().when('nickname', {
                is: 'sTicket',
                then: _joi2.default.any(),
                otherwise: _validation2.default.requiredString(3, 11, 'alertmessage.photocardNumber')
            }),
            nickname: _joi2.default.any().when('linkCard', {
                is: true,
                then: _validation2.default.requiredString(),
                otherwise: _joi2.default.any()
            })
        };
    };

    Photocard.prototype._setDefaultFields = function _setDefaultFields(field, value) {
        if (value || value === false) {
            return value;
        } else {
            switch (field) {
                case 'title':
                    return customerTitles[0];
                case 'isOver16':
                    return true;
                case 'linkCard':
                    return false;
                default:
                    return null;
            }
        }
    };

    Photocard.getDeliveryPhotocard = function getDeliveryPhotocard() {
        var deliverySmartCard = new Photocard();
        return deliverySmartCard.set('metaData', new _TicketMetadata2.default());
    };

    Photocard.prototype.isStored = function isStored() {
        return !!this.id;
    };

    Photocard.prototype.isEmpty = function isEmpty() {
        var filterObjectProperty = function filterObjectProperty(schema) {
            return (0, _keys2.default)(schema).filter(function (key) {
                return defaultUserEmptyValues.includes(key);
            }).reduce(function (obj, key) {
                obj[key] = schema[key];
                return obj;
            }, {});
        };

        return (0, _isEqual3.default)(filterObjectProperty(this.toJS()), filterObjectProperty(defaults));
    };

    Photocard.prototype.equalToFirstPhotocard = function equalToFirstPhotocard(order) {
        var _this2 = this;

        return defaultUserEmptyValues.every(function (key) {
            return _this2[key] === order.delivery.photocards.get(0)[key];
        });
    };

    Photocard.prototype.setTicketData = function setTicketData(ticketId, metaData, storedData) {
        var _this3 = this;

        var getStoredData = function getStoredData() {
            if (storedData) {
                return (0, _extends6.default)({}, defaultUserEmptyValues.reduce(function (current, propertyName) {
                    var _extends2;

                    return (0, _extends6.default)({}, current, (_extends2 = {}, _extends2[propertyName] = _this3._setDefaultFields(propertyName, storedData.get(propertyName)), _extends2));
                }, {}));
            }
            return {};
        };
        return new Photocard((0, _extends6.default)({
            ticketId: ticketId,
            metaData: new _TicketMetadata2.default(metaData),
            linkCard: false
        }, getStoredData()));
    };

    Photocard.prototype.setAddressInformation = function setAddressInformation(address) {
        return this.merge({
            addressLine1: address.get('line1') || null,
            addressLine2: address.get('line2') || null,
            addressLine3: address.get('line3') || null,
            townCity: address.get('town') || null,
            postcode: address.get('postCode') || null
        });
    };

    Photocard.prototype.getAddressInformation = function getAddressInformation() {
        return new _Address2.default({
            line1: this.get('addressLine1'),
            line2: this.get('addressLine2'),
            line3: this.get('addressLine3'),
            town: this.get('townCity'),
            postCode: this.get('postcode')
        });
    };

    Photocard.prototype.mergeTicketData = function mergeTicketData(newObj) {
        var _this4 = this;

        return this.merge((0, _extends6.default)({
            linkCard: false
        }, defaultUserEmptyValues.reduce(function (current, propertyName) {
            var _extends3;

            return (0, _extends6.default)({}, current, (_extends3 = {}, _extends3[propertyName] = _this4._setDefaultFields(propertyName, newObj.get(propertyName)), _extends3));
        }, {})));
    };

    Photocard.prototype.unsetInformation = function unsetInformation() {
        var _this5 = this;

        return this.merge((0, _extends6.default)({}, defaultUserEmptyValues.reduce(function (current, propertyName) {
            var _extends4;

            return (0, _extends6.default)({}, current, (_extends4 = {}, _extends4[propertyName] = _this5._setDefaultFields(propertyName, null), _extends4));
        }, {})));
    };

    Photocard.prototype.unsetSaveStatus = function unsetSaveStatus() {
        return this.set('linkCard', false);
    };

    Photocard.prototype.hasAddressInformation = function hasAddressInformation() {
        return !!(this.addressLine1 || this.addressLine1 || this.addressLine3 || this.townCity || this.postcode);
    };

    Photocard.prototype.toString = function toString() {
        return this.nickname + ' - ' + this.firstName + ' ' + this.lastName + ' - ' + this.number;
    };

    Photocard.prototype.getDateOfBirth = function getDateOfBirth() {
        var dayOfBirth = this.dayOfBirth,
            monthOfBirth = this.monthOfBirth,
            yearOfBirth = this.yearOfBirth,
            isOver16 = this.isOver16;

        return !isOver16 && dayOfBirth && monthOfBirth && yearOfBirth && (0, _TrainTime2.default)(yearOfBirth + '-' + monthOfBirth + '-' + dayOfBirth, 'YYYY-MM-DD');
    };

    Photocard.prototype.isTooYoung = function isTooYoung(dateOfBirth, minAge, timePeriod) {
        var youngest = (0, _TrainTime2.default)().subtract(minAge);
        return dateOfBirth && dateOfBirth.isValid() && dateOfBirth[timePeriod](youngest);
    };

    return Photocard;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(Photocard.prototype, _ValidationMixin2.default);

exports.default = Photocard;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _isObject2 = __webpack_require__(77);

var _isObject3 = _interopRequireDefault(_isObject2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _immutable = __webpack_require__(5);

var _CustomerEndpoint = __webpack_require__(524);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _UserPreferences = __webpack_require__(228);

var _UserPreferences2 = _interopRequireDefault(_UserPreferences);

var _AuthToken = __webpack_require__(392);

var _AuthToken2 = _interopRequireDefault(_AuthToken);

var _PaperSeasonTicketResults = __webpack_require__(1133);

var _PaperSeasonTicketResults2 = _interopRequireDefault(_PaperSeasonTicketResults);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable camelcase */
var CustomerService = {
    create: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(registration) {
            var fullTelephoneNumber, isOver16, preferences, mutatedPrefs, customerData, response, customer;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            fullTelephoneNumber = registration.fullTelephoneNumber, isOver16 = registration.isOver16, preferences = registration.preferences;
                            mutatedPrefs = (0, _assign2.default)((0, _omit3.default)(preferences.toJS(), ['timestamp']), { isOver16: isOver16 });
                            customerData = (0, _assign2.default)((0, _pick3.default)(registration, ['title', 'firstNames', 'surname', 'email', 'password', 'referrer']), {
                                telephoneNumber: fullTelephoneNumber,
                                preferences: mutatedPrefs
                            });
                            _context.next = 5;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.create, customerData);

                        case 5:
                            response = _context.sent;
                            customer = response.result;
                            return _context.abrupt('return', (0, _LinkMapper.resolve)({ customer: customer }).as(_User2.default));

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function create(_x) {
            return _ref.apply(this, arguments);
        }

        return create;
    }(),
    createAmazon: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(registration, amazonToken) {
            var fullTelephoneNumber, isOver16, preferences, mutatedPrefs, customerData, response, customer;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            fullTelephoneNumber = registration.fullTelephoneNumber, isOver16 = registration.isOver16, preferences = registration.preferences;
                            mutatedPrefs = (0, _assign2.default)((0, _omit3.default)(preferences.toJS(), ['timestamp']), { isOver16: isOver16 });
                            customerData = (0, _assign2.default)((0, _pick3.default)(registration, ['title', 'firstNames', 'surname', 'email', 'password', 'referrer']), {
                                telephoneNumber: fullTelephoneNumber,
                                preferences: mutatedPrefs,
                                token: amazonToken
                            });
                            _context2.next = 5;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.createAmazon, customerData);

                        case 5:
                            response = _context2.sent;
                            customer = response.result;
                            return _context2.abrupt('return', (0, _LinkMapper.resolve)({ customer: customer }).as(_User2.default));

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function createAmazon(_x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return createAmazon;
    }(),
    auth: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(username, password) {
            var authData, response, token;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            authData = (0, _extends3.default)({
                                username: username,
                                password: password,
                                grant_type: _AppConstants.AuthGrantTypes.PASSWORD
                            }, !_InAppStore2.default.isInApp() && { session_short: _config2.default.get('sessionShort') });
                            _context3.next = 3;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.auth, authData);

                        case 3:
                            response = _context3.sent;
                            token = (0, _LinkMapper.resolve)(response.result).as(_AuthToken2.default);
                            return _context3.abrupt('return', token);

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function auth(_x4, _x5) {
            return _ref3.apply(this, arguments);
        }

        return auth;
    }(),
    fetch: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(token, user) {
            var userId, response, customer;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            userId = token.getCustomerId() || user && user.id;

                            if (!userId) {
                                _context4.next = 7;
                                break;
                            }

                            _context4.next = 4;
                            return _AuthenticatedAPIClient2.default.get(_CustomerEndpoint.URL.customer.replace('{id}', userId));

                        case 4:
                            response = _context4.sent;

                            // customer token misses some data present in auth token, overwrite it with the auth token
                            customer = (0, _assign2.default)({}, response.result, { accessToken: token });
                            return _context4.abrupt('return', (0, _LinkMapper.resolve)({ customer: customer }).as(_User2.default));

                        case 7:
                            return _context4.abrupt('return', null);

                        case 8:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function fetch(_x6, _x7) {
            return _ref4.apply(this, arguments);
        }

        return fetch;
    }(),
    logout: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(user) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!user.isLoggedIn()) {
                                _context5.next = 10;
                                break;
                            }

                            _context5.prev = 1;
                            _context5.next = 4;
                            return _AuthenticatedAPIClient2.default.delete(_CustomerEndpoint.URL.auth + '/' + user.accessToken);

                        case 4:
                            _context5.next = 10;
                            break;

                        case 6:
                            _context5.prev = 6;
                            _context5.t0 = _context5['catch'](1);

                            if (_context5.t0 instanceof _APIClient.NotFoundError) {
                                _context5.next = 10;
                                break;
                            }

                            throw _context5.t0;

                        case 10:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[1, 6]]);
        }));

        function logout(_x8) {
            return _ref5.apply(this, arguments);
        }

        return logout;
    }(),
    update: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(user, changes) {
            var fields, hasChanges, response, customer;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            fields = (0, _keys2.default)(changes);
                            hasChanges = !(0, _isEqual3.default)(changes, (0, _pick3.default)(user.customer, fields));

                            if (!hasChanges) {
                                _context6.next = 9;
                                break;
                            }

                            _context6.next = 5;
                            return _AuthenticatedAPIClient2.default.put(_CustomerEndpoint.URL.customer.replace('{id}', user.id), changes);

                        case 5:
                            response = _context6.sent;
                            customer = (0, _result3.default)(response, ['result']);

                            if (!customer) {
                                _context6.next = 9;
                                break;
                            }

                            return _context6.abrupt('return', (0, _LinkMapper.resolve)({ customer: customer }).as(_User2.default));

                        case 9:
                            return _context6.abrupt('return', user);

                        case 10:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function update(_x9, _x10) {
            return _ref6.apply(this, arguments);
        }

        return update;
    }(),
    updatePreferences: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(userId, form, omitAge) {
            var data, result;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            data = (0, _assign2.default)({}, form.get('preferences').toJS(), {
                                telephoneNumber: form.get('telephoneNumber')
                            });

                            if (!omitAge) {
                                data = (0, _assign2.default)(data, {
                                    isOver16: form.get('isOver16')
                                });
                            }
                            _context7.next = 4;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.preferences.replace('{id}', userId), data);

                        case 4:
                            result = _context7.sent;
                            return _context7.abrupt('return', (0, _LinkMapper.resolve)(result).as(_UserPreferences2.default));

                        case 6:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function updatePreferences(_x11, _x12, _x13) {
            return _ref7.apply(this, arguments);
        }

        return updatePreferences;
    }(),
    patchPreferences: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(userId, form) {
            var result;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return _AuthenticatedAPIClient2.default.patch(_CustomerEndpoint.URL.preferences.replace('{id}', userId), form.toJS());

                        case 2:
                            result = _context8.sent;
                            return _context8.abrupt('return', (0, _LinkMapper.resolve)(result).as(_UserPreferences2.default));

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function patchPreferences(_x14, _x15) {
            return _ref8.apply(this, arguments);
        }

        return patchPreferences;
    }(),
    fetchPreferences: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(userId) {
            var result;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return _AuthenticatedAPIClient2.default.get(_CustomerEndpoint.URL.preferences.replace('{id}', userId));

                        case 2:
                            result = _context9.sent;
                            return _context9.abrupt('return', (0, _LinkMapper.resolve)(result).as(_UserPreferences2.default));

                        case 4:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function fetchPreferences(_x16) {
            return _ref9.apply(this, arguments);
        }

        return fetchPreferences;
    }(),
    fetchEmailUserPreferences: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(userId, emailToken) {
            var result;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.next = 2;
                            return _APIClient2.default.get(_CustomerEndpoint.URL.preferences.replace('{id}', userId), { emailToken: emailToken });

                        case 2:
                            result = _context10.sent;
                            return _context10.abrupt('return', (0, _LinkMapper.resolve)(result).as(_UserPreferences2.default));

                        case 4:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        function fetchEmailUserPreferences(_x17, _x18) {
            return _ref10.apply(this, arguments);
        }

        return fetchEmailUserPreferences;
    }(),
    fetchIdentityProvider: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(userId, identityProvider) {
            var url;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            url = _CustomerEndpoint.URL.identityProvider.replace('{id}', userId).replace('{provider}', identityProvider);


                            _AuthenticatedAPIClient2.default.setAdditionalHeaders({
                                'accept-version': 'v2',
                                'x-brand-id': _config2.default.get('brand')
                            });

                            _context11.prev = 2;
                            _context11.next = 5;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 5:
                            _context11.next = 10;
                            break;

                        case 7:
                            _context11.prev = 7;
                            _context11.t0 = _context11['catch'](2);
                            return _context11.abrupt('return', false);

                        case 10:
                            _context11.prev = 10;

                            _AuthenticatedAPIClient2.default.setAdditionalHeaders(null);
                            return _context11.finish(10);

                        case 13:
                            return _context11.abrupt('return', true);

                        case 14:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this, [[2, 7, 10, 13]]);
        }));

        function fetchIdentityProvider(_x19, _x20) {
            return _ref11.apply(this, arguments);
        }

        return fetchIdentityProvider;
    }(),
    updateEmailUserPreferences: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(userId, emailToken, preferences) {
            var data;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            data = (0, _assign2.default)({}, preferences.toJS(), { emailToken: emailToken });
                            _context12.next = 3;
                            return _APIClient2.default.post(_CustomerEndpoint.URL.preferences.replace('{id}', userId), data);

                        case 3:
                            return _context12.abrupt('return', _promise2.default.resolve());

                        case 4:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function updateEmailUserPreferences(_x21, _x22, _x23) {
            return _ref12.apply(this, arguments);
        }

        return updateEmailUserPreferences;
    }(),
    refresh: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(user) {
            var refreshData, response, token;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            refreshData = (0, _extends3.default)({
                                grant_type: _AppConstants.AuthGrantTypes.REFRESH_TOKEN,
                                token: user.refreshToken
                            }, !_InAppStore2.default.isInApp() && { session_short: _config2.default.get('sessionShort') });
                            _context13.next = 3;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.refresh, refreshData);

                        case 3:
                            response = _context13.sent;
                            token = (0, _LinkMapper.resolve)(response.result).as(_AuthToken2.default);
                            return _context13.abrupt('return', token);

                        case 6:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this);
        }));

        function refresh(_x24) {
            return _ref13.apply(this, arguments);
        }

        return refresh;
    }(),
    requestResetPassword: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(email) {
            var resetLinkQueryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var response;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.next = 2;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.reset, (0, _extends3.default)({
                                email: email
                            }, resetLinkQueryParams && { resetLinkQueryParams: resetLinkQueryParams }));

                        case 2:
                            response = _context14.sent;
                            return _context14.abrupt('return', response);

                        case 4:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this);
        }));

        function requestResetPassword(_x26) {
            return _ref14.apply(this, arguments);
        }

        return requestResetPassword;
    }(),
    requestUnlockAccount: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(email) {
            var response;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.next = 2;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.reset, {
                                email: email,
                                isLocked: true
                            });

                        case 2:
                            response = _context15.sent;
                            return _context15.abrupt('return', response);

                        case 4:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this);
        }));

        function requestUnlockAccount(_x27) {
            return _ref15.apply(this, arguments);
        }

        return requestUnlockAccount;
    }(),
    resetPassword: function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(token, password) {
            var response;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            _context16.next = 2;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.reset + '/?token=' + token, {
                                password: password
                            });

                        case 2:
                            response = _context16.sent;

                            if (!(0, _isObject3.default)(response)) {
                                _context16.next = 5;
                                break;
                            }

                            return _context16.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_AuthToken2.default));

                        case 5:
                            return _context16.abrupt('return', null);

                        case 6:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, this);
        }));

        function resetPassword(_x28, _x29) {
            return _ref16.apply(this, arguments);
        }

        return resetPassword;
    }(),
    unsubscribe: function () {
        var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(id, token) {
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _context17.next = 2;
                            return _AuthenticatedAPIClient2.default.post('/customers/unsubscribe', { id: id, token: token });

                        case 2:
                            return _context17.abrupt('return', true);

                        case 3:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, this);
        }));

        function unsubscribe(_x30, _x31) {
            return _ref17.apply(this, arguments);
        }

        return unsubscribe;
    }(),
    activateSmartcard: function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(user) {
            var response;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            _context18.next = 2;
                            return _AuthenticatedAPIClient2.default.post(_CustomerEndpoint.URL.activateSmartcard.replace('{id}', user.id));

                        case 2:
                            response = _context18.sent;
                            return _context18.abrupt('return', response);

                        case 4:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, this);
        }));

        function activateSmartcard(_x32) {
            return _ref18.apply(this, arguments);
        }

        return activateSmartcard;
    }(),
    findSeasonTickets: function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(user, postCode, photocardId) {
            var url, response, result;
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            url = _CustomerEndpoint.URL.findSeasonTickets.replace('{id}', user.id);
                            _context19.next = 3;
                            return _AuthenticatedAPIClient2.default.post(url, { postCode: postCode, photocardId: photocardId }, { validErrorStatuses: [404] });

                        case 3:
                            response = _context19.sent;
                            result = (0, _get3.default)(response, 'result', {});
                            return _context19.abrupt('return', (0, _LinkMapper.resolve)(result).as(_PaperSeasonTicketResults2.default));

                        case 6:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, this);
        }));

        function findSeasonTickets(_x33, _x34, _x35) {
            return _ref19.apply(this, arguments);
        }

        return findSeasonTickets;
    }(),
    transferSeasonTicket: function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(user, transferForm, params) {
            var ticket, collectionStation, postcode, photocardNumber, data, url, response;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            ticket = transferForm.ticket, collectionStation = transferForm.collectionStation;
                            postcode = params.postcode, photocardNumber = params.photocardNumber;
                            data = {
                                origin: ticket.origin.nlc,
                                destination: ticket.destination.nlc,
                                route: ticket.route.code,
                                ticketType: ticket.ticketType.code,
                                saleTicketNumber: ticket.saleTicketNumber,
                                price: ticket.price,
                                validFrom: ticket.validFrom.format('YYYY-MM-DDTHH:mm:ss'),
                                validTo: ticket.validTo.format('YYYY-MM-DDTHH:mm:ss'),
                                validityPeriod: ticket.validityPeriod.toString(),
                                ticketClass: ticket.ticketClass,
                                methodOfPayment: ticket.methodOfPayment,
                                fulfilmentLocation: collectionStation,
                                replacement: false,
                                photocardId: photocardNumber,
                                postcode: postcode,
                                ticketId: ticket.id
                            };
                            url = _CustomerEndpoint.URL.transferSeasonTicket.replace('{id}', user.id);
                            _context20.next = 6;
                            return _AuthenticatedAPIClient2.default.post(url, data);

                        case 6:
                            response = _context20.sent;
                            return _context20.abrupt('return', response);

                        case 8:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, this);
        }));

        function transferSeasonTicket(_x36, _x37, _x38) {
            return _ref20.apply(this, arguments);
        }

        return transferSeasonTicket;
    }(),
    lookUpAddress: function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(postcode) {
            var response, _ref22, matches, outcode, incode, formattedPostcode;

            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            _context21.prev = 0;
                            _context21.next = 3;
                            return _APIClient2.default.get(_CustomerEndpoint.URL.postCodeLookUp, {
                                postcode: postcode.replace(/\s/g, '')
                            });

                        case 3:
                            response = _context21.sent;
                            _ref22 = postcode.match(_AppConstants.Validation.postcode) || [], matches = _ref22[0], outcode = _ref22[1], incode = _ref22[2];
                            formattedPostcode = matches ? (outcode + ' ' + incode).toUpperCase() : postcode;
                            return _context21.abrupt('return', (0, _LinkMapper.resolveAll)(response).as(_Address2.default).map(function (a) {
                                return a.set('postCode', formattedPostcode);
                            }));

                        case 9:
                            _context21.prev = 9;
                            _context21.t0 = _context21['catch'](0);

                            if (!(_context21.t0 instanceof _APIClient.ForbiddenError || _context21.t0 instanceof _APIClient.NotFoundError)) {
                                _context21.next = 13;
                                break;
                            }

                            return _context21.abrupt('return', new _immutable.List());

                        case 13:
                            throw _context21.t0;

                        case 14:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, this, [[0, 9]]);
        }));

        function lookUpAddress(_x39) {
            return _ref21.apply(this, arguments);
        }

        return lookUpAddress;
    }(),
    validateBacs: function () {
        var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(_ref23) {
            var sortCode = _ref23.sortCode,
                accountNumber = _ref23.accountNumber;
            var data;
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            _context22.prev = 0;
                            data = { sortCode: sortCode, accountNumber: accountNumber };
                            _context22.next = 4;
                            return _APIClient2.default.get(_CustomerEndpoint.URL.validateBacs, data);

                        case 4:
                            return _context22.abrupt('return', true);

                        case 7:
                            _context22.prev = 7;
                            _context22.t0 = _context22['catch'](0);

                            if (!(_context22.t0 instanceof _APIClient.BadRequestError)) {
                                _context22.next = 11;
                                break;
                            }

                            return _context22.abrupt('return', false);

                        case 11:
                            throw _context22.t0;

                        case 12:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, this, [[0, 7]]);
        }));

        function validateBacs(_x40) {
            return _ref24.apply(this, arguments);
        }

        return validateBacs;
    }(),
    checkEmailAddress: function () {
        var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(email) {
            var response;
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            _context23.next = 2;
                            return _AuthenticatedAPIClient2.default.get(_CustomerEndpoint.URL.checkEmail, { email: email });

                        case 2:
                            response = _context23.sent;
                            return _context23.abrupt('return', JSON.parse(response));

                        case 4:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, this);
        }));

        function checkEmailAddress(_x41) {
            return _ref25.apply(this, arguments);
        }

        return checkEmailAddress;
    }(),
    deleteCustomer: function () {
        var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(userId) {
            var url;
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            url = _CustomerEndpoint.URL.deleteCustomer.replace('{id}', userId);
                            _context24.next = 3;
                            return _AuthenticatedAPIClient2.default.post(url);

                        case 3:
                            return _context24.abrupt('return', true);

                        case 4:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, this);
        }));

        function deleteCustomer(_x42) {
            return _ref26.apply(this, arguments);
        }

        return deleteCustomer;
    }(),
    cancelDeletionRequest: function () {
        var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(userId, requestId) {
            var url;
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            url = _CustomerEndpoint.URL.cancelDeletionRequest.replace('{id}', userId).replace('{requestId}', requestId);
                            _context25.next = 3;
                            return _AuthenticatedAPIClient2.default.post(url);

                        case 3:
                            return _context25.abrupt('return', true);

                        case 4:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, this);
        }));

        function cancelDeletionRequest(_x43, _x44) {
            return _ref27.apply(this, arguments);
        }

        return cancelDeletionRequest;
    }()
};

exports.default = CustomerService;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isUndefined2 = __webpack_require__(278);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenStore = function (_BaseStore) {
    (0, _inherits3.default)(TokenStore, _BaseStore);

    function TokenStore() {
        (0, _classCallCheck3.default)(this, TokenStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    TokenStore.prototype.getDevice = function getDevice() {
        return this.state.get('device');
    };

    TokenStore.prototype.getCustomer = function getCustomer() {
        return _UserStore2.default.getCurrent().accessToken;
    };

    TokenStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.DEVICE_TOKEN_UPDATED] = this.handleNewToken, _ref;
    };

    TokenStore.prototype.handleNewToken = function handleNewToken(_ref2) {
        var token = _ref2.token;

        if ((0, _isUndefined3.default)(token)) {
            token = null;
        }
        this.setState(this.state.set('device', token));
    };

    return TokenStore;
}(_BaseStore3.default);

var instance = new TokenStore({ storageKey: 'tokens' });

exports.default = instance;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FareStations = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(FareStations, _PureRenderComponent);

    function FareStations() {
        (0, _classCallCheck3.default)(this, FareStations);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    FareStations.prototype.render = function render() {
        var _props = this.props,
            origin = _props.origin,
            destination = _props.destination,
            isReturn = _props.isReturn,
            forceFontWeight = _props.forceFontWeight,
            className = _props.className;

        var ReturnIcon = _react2.default.createElement(_Icon2.default, { icon: 'switch', className: 'otrl-rotate-90' });
        var SingleIcon = _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-180' });
        var classes = (0, _classnames2.default)('table-cell', {
            'text-weight--normal': forceFontWeight
        });

        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)("like-table fare-stations", className) },
            _react2.default.createElement(
                'div',
                { className: 'table-row' },
                _react2.default.createElement(
                    'div',
                    { className: classes },
                    (0, _get3.default)(origin, 'name') || ''
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'table-cell direction text-center' },
                    isReturn ? ReturnIcon : SingleIcon
                ),
                _react2.default.createElement(
                    'div',
                    { className: classes },
                    (0, _get3.default)(destination, 'name') || ''
                )
            )
        );
    };

    return FareStations;
}(_PureRenderComponent3.default), _class.propTypes = {
    origin: _propTypes2.default.instanceOf(_Station2.default).isRequired,
    destination: _propTypes2.default.instanceOf(_Station2.default).isRequired,
    isReturn: _propTypes2.default.bool,
    forceFontWeight: _propTypes2.default.bool,
    className: _propTypes2.default.string
}, _class.defaultProps = {
    origin: {},
    destination: {},
    isReturn: false,
    forceFontWeight: true
}, _temp);
exports.default = FareStations;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */
(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory(__webpack_require__(784), __webpack_require__(785), __webpack_require__(786));
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(784), __webpack_require__(785), __webpack_require__(786)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
  }
}(this, function (punycode, IPv6, SLD, root) {
  'use strict';
  /*global location, escape, unescape */
  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
  /*jshint camelcase: false */

  // save current URI variable, if any
  var _URI = root && root.URI;

  function URI(url, base) {
    var _urlSupplied = arguments.length >= 1;
    var _baseSupplied = arguments.length >= 2;

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof URI)) {
      if (_urlSupplied) {
        if (_baseSupplied) {
          return new URI(url, base);
        }

        return new URI(url);
      }

      return new URI();
    }

    if (url === undefined) {
      if (_urlSupplied) {
        throw new TypeError('undefined is not a valid argument for URI');
      }

      if (typeof location !== 'undefined') {
        url = location.href + '';
      } else {
        url = '';
      }
    }

    if (url === null) {
      if (_urlSupplied) {
        throw new TypeError('null is not a valid argument for URI');
      }
    }

    this.href(url);

    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
    if (base !== undefined) {
      return this.absoluteTo(base);
    }

    return this;
  }

  function isInteger(value) {
    return /^[0-9]+$/.test(value);
  }

  URI.version = '1.19.11';

  var p = URI.prototype;
  var hasOwn = Object.prototype.hasOwnProperty;

  function escapeRegEx(string) {
    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  function getType(value) {
    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
    if (value === undefined) {
      return 'Undefined';
    }

    return String(Object.prototype.toString.call(value)).slice(8, -1);
  }

  function isArray(obj) {
    return getType(obj) === 'Array';
  }

  function filterArrayValues(data, value) {
    var lookup = {};
    var i, length;

    if (getType(value) === 'RegExp') {
      lookup = null;
    } else if (isArray(value)) {
      for (i = 0, length = value.length; i < length; i++) {
        lookup[value[i]] = true;
      }
    } else {
      lookup[value] = true;
    }

    for (i = 0, length = data.length; i < length; i++) {
      /*jshint laxbreak: true */
      var _match = lookup && lookup[data[i]] !== undefined
        || !lookup && value.test(data[i]);
      /*jshint laxbreak: false */
      if (_match) {
        data.splice(i, 1);
        length--;
        i--;
      }
    }

    return data;
  }

  function arrayContains(list, value) {
    var i, length;

    // value may be string, number, array, regexp
    if (isArray(value)) {
      // Note: this can be optimized to O(n) (instead of current O(m * n))
      for (i = 0, length = value.length; i < length; i++) {
        if (!arrayContains(list, value[i])) {
          return false;
        }
      }

      return true;
    }

    var _type = getType(value);
    for (i = 0, length = list.length; i < length; i++) {
      if (_type === 'RegExp') {
        if (typeof list[i] === 'string' && list[i].match(value)) {
          return true;
        }
      } else if (list[i] === value) {
        return true;
      }
    }

    return false;
  }

  function arraysEqual(one, two) {
    if (!isArray(one) || !isArray(two)) {
      return false;
    }

    // arrays can't be equal if they have different amount of content
    if (one.length !== two.length) {
      return false;
    }

    one.sort();
    two.sort();

    for (var i = 0, l = one.length; i < l; i++) {
      if (one[i] !== two[i]) {
        return false;
      }
    }

    return true;
  }

  function trimSlashes(text) {
    var trim_expression = /^\/+|\/+$/g;
    return text.replace(trim_expression, '');
  }

  URI._parts = function() {
    return {
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      urn: null,
      port: null,
      path: null,
      query: null,
      fragment: null,
      // state
      preventInvalidHostname: URI.preventInvalidHostname,
      duplicateQueryParameters: URI.duplicateQueryParameters,
      escapeQuerySpace: URI.escapeQuerySpace
    };
  };
  // state: throw on invalid hostname
  // see https://github.com/medialize/URI.js/pull/345
  // and https://github.com/medialize/URI.js/issues/354
  URI.preventInvalidHostname = false;
  // state: allow duplicate query parameters (a=1&a=1)
  URI.duplicateQueryParameters = false;
  // state: replaces + with %20 (space in query strings)
  URI.escapeQuerySpace = true;
  // static properties
  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
  URI.idn_expression = /[^a-z0-9\._-]/i;
  URI.punycode_expression = /(xn--)/i;
  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  // credits to Rich Brown
  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
  // specification: http://www.ietf.org/rfc/rfc4291.txt
  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // expression used is "gruber revised" (@gruber v2) determined to be the
  // best solution in a regex-golf we did a couple of ages ago at
  // * http://mathiasbynens.be/demo/url-regex
  // * http://rodneyrehm.de/t/url-regex.html
  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
  URI.findUri = {
    // valid "scheme://" or "www."
    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
  };
  URI.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/
  // https://infra.spec.whatwg.org/#ascii-tab-or-newline
  URI.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g
  // http://www.iana.org/assignments/uri-schemes.html
  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
  URI.defaultPorts = {
    http: '80',
    https: '443',
    ftp: '21',
    gopher: '70',
    ws: '80',
    wss: '443'
  };
  // list of protocols which always require a hostname
  URI.hostProtocols = [
    'http',
    'https'
  ];

  // allowed hostname characters according to RFC 3986
  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
  // map DOM Elements to their URI attribute
  URI.domAttributes = {
    'a': 'href',
    'blockquote': 'cite',
    'link': 'href',
    'base': 'href',
    'script': 'src',
    'form': 'action',
    'img': 'src',
    'area': 'href',
    'iframe': 'src',
    'embed': 'src',
    'source': 'src',
    'track': 'src',
    'input': 'src', // but only if type="image"
    'audio': 'src',
    'video': 'src'
  };
  URI.getDomAttribute = function(node) {
    if (!node || !node.nodeName) {
      return undefined;
    }

    var nodeName = node.nodeName.toLowerCase();
    // <input> should only expose src for type="image"
    if (nodeName === 'input' && node.type !== 'image') {
      return undefined;
    }

    return URI.domAttributes[nodeName];
  };

  function escapeForDumbFirefox36(value) {
    // https://github.com/medialize/URI.js/issues/91
    return escape(value);
  }

  // encoding / decoding according to RFC3986
  function strictEncodeURIComponent(string) {
    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(string)
      .replace(/[!'()*]/g, escapeForDumbFirefox36)
      .replace(/\*/g, '%2A');
  }
  URI.encode = strictEncodeURIComponent;
  URI.decode = decodeURIComponent;
  URI.iso8859 = function() {
    URI.encode = escape;
    URI.decode = unescape;
  };
  URI.unicode = function() {
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
  };
  URI.characters = {
    pathname: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
        map: {
          // -._~!'()*
          '%24': '$',
          '%26': '&',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%3A': ':',
          '%40': '@'
        }
      },
      decode: {
        expression: /[\/\?#]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23'
        }
      }
    },
    reserved: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
        map: {
          // gen-delims
          '%3A': ':',
          '%2F': '/',
          '%3F': '?',
          '%23': '#',
          '%5B': '[',
          '%5D': ']',
          '%40': '@',
          // sub-delims
          '%21': '!',
          '%24': '$',
          '%26': '&',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '='
        }
      }
    },
    urnpath: {
      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
      // note that the colon character is not featured in the encoding map; this is because URI.js
      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
      // should not appear unencoded in a segment itself.
      // See also the note above about RFC3986 and capitalalized hex digits.
      encode: {
        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
        map: {
          '%21': '!',
          '%24': '$',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%40': '@'
        }
      },
      // These characters are the characters called out by RFC2141 as "reserved" characters that
      // should never appear in a URN, plus the colon character (see note above).
      decode: {
        expression: /[\/\?#:]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23',
          ':': '%3A'
        }
      }
    }
  };
  URI.encodeQuery = function(string, escapeQuerySpace) {
    var escaped = URI.encode(string + '');
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
  };
  URI.decodeQuery = function(string, escapeQuerySpace) {
    string += '';
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    try {
      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
    } catch(e) {
      // we're not going to mess with weird encodings,
      // give up and return the undecoded original string
      // see https://github.com/medialize/URI.js/issues/87
      // see https://github.com/medialize/URI.js/issues/92
      return string;
    }
  };
  // generate encode/decode path functions
  var _parts = {'encode':'encode', 'decode':'decode'};
  var _part;
  var generateAccessor = function(_group, _part) {
    return function(string) {
      try {
        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
          return URI.characters[_group][_part].map[c];
        });
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
  };

  for (_part in _parts) {
    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
  }

  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
    return function(string) {
      // Why pass in names of functions, rather than the function objects themselves? The
      // definitions of some functions (but in particular, URI.decode) will occasionally change due
      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
      // that the functions we use here are "fresh".
      var actualCodingFunc;
      if (!_innerCodingFuncName) {
        actualCodingFunc = URI[_codingFuncName];
      } else {
        actualCodingFunc = function(string) {
          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
        };
      }

      var segments = (string + '').split(_sep);

      for (var i = 0, length = segments.length; i < length; i++) {
        segments[i] = actualCodingFunc(segments[i]);
      }

      return segments.join(_sep);
    };
  };

  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');

  URI.encodeReserved = generateAccessor('reserved', 'encode');

  URI.parse = function(string, parts) {
    var pos;
    if (!parts) {
      parts = {
        preventInvalidHostname: URI.preventInvalidHostname
      };
    }

    string = string.replace(URI.leading_whitespace_expression, '')
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    string = string.replace(URI.ascii_tab_whitespace, '')

    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

    // extract fragment
    pos = string.indexOf('#');
    if (pos > -1) {
      // escaping?
      parts.fragment = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract query
    pos = string.indexOf('?');
    if (pos > -1) {
      // escaping?
      parts.query = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
    string = string.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, '$1://');
    // slashes and backslashes have lost all meaning for scheme relative URLs
    string = string.replace(/^[/\\]{2,}/i, '//');

    // extract protocol
    if (string.substring(0, 2) === '//') {
      // relative-scheme
      parts.protocol = null;
      string = string.substring(2);
      // extract "user:pass@host:port"
      string = URI.parseAuthority(string, parts);
    } else {
      pos = string.indexOf(':');
      if (pos > -1) {
        parts.protocol = string.substring(0, pos) || null;
        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
          // : may be within the path
          parts.protocol = undefined;
        } else if (string.substring(pos + 1, pos + 3).replace(/\\/g, '/') === '//') {
          string = string.substring(pos + 3);

          // extract "user:pass@host:port"
          string = URI.parseAuthority(string, parts);
        } else {
          string = string.substring(pos + 1);
          parts.urn = true;
        }
      }
    }

    // what's left must be the path
    parts.path = string;

    // and we're done
    return parts;
  };
  URI.parseHost = function(string, parts) {
    if (!string) {
      string = '';
    }

    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    // https://github.com/medialize/URI.js/pull/233
    string = string.replace(/\\/g, '/');

    // extract host:port
    var pos = string.indexOf('/');
    var bracketPos;
    var t;

    if (pos === -1) {
      pos = string.length;
    }

    if (string.charAt(0) === '[') {
      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
      bracketPos = string.indexOf(']');
      parts.hostname = string.substring(1, bracketPos) || null;
      parts.port = string.substring(bracketPos + 2, pos) || null;
      if (parts.port === '/') {
        parts.port = null;
      }
    } else {
      var firstColon = string.indexOf(':');
      var firstSlash = string.indexOf('/');
      var nextColon = string.indexOf(':', firstColon + 1);
      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
        // IPv6 host contains multiple colons - but no port
        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
        parts.hostname = string.substring(0, pos) || null;
        parts.port = null;
      } else {
        t = string.substring(0, pos).split(':');
        parts.hostname = t[0] || null;
        parts.port = t[1] || null;
      }
    }

    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
      pos++;
      string = '/' + string;
    }

    if (parts.preventInvalidHostname) {
      URI.ensureValidHostname(parts.hostname, parts.protocol);
    }

    if (parts.port) {
      URI.ensureValidPort(parts.port);
    }

    return string.substring(pos) || '/';
  };
  URI.parseAuthority = function(string, parts) {
    string = URI.parseUserinfo(string, parts);
    return URI.parseHost(string, parts);
  };
  URI.parseUserinfo = function(string, parts) {
    // extract username:password
    var _string = string
    var firstBackSlash = string.indexOf('\\');
    if (firstBackSlash !== -1) {
      string = string.replace(/\\/g, '/')
    }
    var firstSlash = string.indexOf('/');
    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
    var t;

    // authority@ must come before /path or \path
    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
      t = string.substring(0, pos).split(':');
      parts.username = t[0] ? URI.decode(t[0]) : null;
      t.shift();
      parts.password = t[0] ? URI.decode(t.join(':')) : null;
      string = _string.substring(pos + 1);
    } else {
      parts.username = null;
      parts.password = null;
    }

    return string;
  };
  URI.parseQuery = function(string, escapeQuerySpace) {
    if (!string) {
      return {};
    }

    // throw out the funky business - "?"[name"="value"&"]+
    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');

    if (!string) {
      return {};
    }

    var items = {};
    var splits = string.split('&');
    var length = splits.length;
    var v, name, value;

    for (var i = 0; i < length; i++) {
      v = splits[i].split('=');
      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;

      if (name === '__proto__') {
        // ignore attempt at exploiting JavaScript internals
        continue;
      } else if (hasOwn.call(items, name)) {
        if (typeof items[name] === 'string' || items[name] === null) {
          items[name] = [items[name]];
        }

        items[name].push(value);
      } else {
        items[name] = value;
      }
    }

    return items;
  };

  URI.build = function(parts) {
    var t = '';
    var requireAbsolutePath = false

    if (parts.protocol) {
      t += parts.protocol + ':';
    }

    if (!parts.urn && (t || parts.hostname)) {
      t += '//';
      requireAbsolutePath = true
    }

    t += (URI.buildAuthority(parts) || '');

    if (typeof parts.path === 'string') {
      if (parts.path.charAt(0) !== '/' && requireAbsolutePath) {
        t += '/';
      }

      t += parts.path;
    }

    if (typeof parts.query === 'string' && parts.query) {
      t += '?' + parts.query;
    }

    if (typeof parts.fragment === 'string' && parts.fragment) {
      t += '#' + parts.fragment;
    }
    return t;
  };
  URI.buildHost = function(parts) {
    var t = '';

    if (!parts.hostname) {
      return '';
    } else if (URI.ip6_expression.test(parts.hostname)) {
      t += '[' + parts.hostname + ']';
    } else {
      t += parts.hostname;
    }

    if (parts.port) {
      t += ':' + parts.port;
    }

    return t;
  };
  URI.buildAuthority = function(parts) {
    return URI.buildUserinfo(parts) + URI.buildHost(parts);
  };
  URI.buildUserinfo = function(parts) {
    var t = '';

    if (parts.username) {
      t += URI.encode(parts.username);
    }

    if (parts.password) {
      t += ':' + URI.encode(parts.password);
    }

    if (t) {
      t += '@';
    }

    return t;
  };
  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
    // URI.js treats the query string as being application/x-www-form-urlencoded
    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

    var t = '';
    var unique, key, i, length;
    for (key in data) {
      if (key === '__proto__') {
        // ignore attempt at exploiting JavaScript internals
        continue;
      } else if (hasOwn.call(data, key)) {
        if (isArray(data[key])) {
          unique = {};
          for (i = 0, length = data[key].length; i < length; i++) {
            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
              if (duplicateQueryParameters !== true) {
                unique[data[key][i] + ''] = true;
              }
            }
          }
        } else if (data[key] !== undefined) {
          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
        }
      }
    }

    return t.substring(1);
  };
  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
  };

  URI.addQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.addQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (data[name] === undefined) {
        data[name] = value;
        return;
      } else if (typeof data[name] === 'string') {
        data[name] = [data[name]];
      }

      if (!isArray(value)) {
        value = [value];
      }

      data[name] = (data[name] || []).concat(value);
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }
  };

  URI.setQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.setQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      data[name] = value === undefined ? null : value;
    } else {
      throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    }
  };

  URI.removeQuery = function(data, name, value) {
    var i, length, key;

    if (isArray(name)) {
      for (i = 0, length = name.length; i < length; i++) {
        data[name[i]] = undefined;
      }
    } else if (getType(name) === 'RegExp') {
      for (key in data) {
        if (name.test(key)) {
          data[key] = undefined;
        }
      }
    } else if (typeof name === 'object') {
      for (key in name) {
        if (hasOwn.call(name, key)) {
          URI.removeQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (value !== undefined) {
        if (getType(value) === 'RegExp') {
          if (!isArray(data[name]) && value.test(data[name])) {
            data[name] = undefined;
          } else {
            data[name] = filterArrayValues(data[name], value);
          }
        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
          data[name] = undefined;
        } else if (isArray(data[name])) {
          data[name] = filterArrayValues(data[name], value);
        }
      } else {
        data[name] = undefined;
      }
    } else {
      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    }
  };
  URI.hasQuery = function(data, name, value, withinArray) {
    switch (getType(name)) {
      case 'String':
        // Nothing to do here
        break;

      case 'RegExp':
        for (var key in data) {
          if (hasOwn.call(data, key)) {
            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
              return true;
            }
          }
        }

        return false;

      case 'Object':
        for (var _key in name) {
          if (hasOwn.call(name, _key)) {
            if (!URI.hasQuery(data, _key, name[_key])) {
              return false;
            }
          }
        }

        return true;

      default:
        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
    }

    switch (getType(value)) {
      case 'Undefined':
        // true if exists (but may be empty)
        return name in data; // data[name] !== undefined;

      case 'Boolean':
        // true if exists and non-empty
        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
        return value === _booly;

      case 'Function':
        // allow complex comparison
        return !!value(data[name], name, data);

      case 'Array':
        if (!isArray(data[name])) {
          return false;
        }

        var op = withinArray ? arrayContains : arraysEqual;
        return op(data[name], value);

      case 'RegExp':
        if (!isArray(data[name])) {
          return Boolean(data[name] && data[name].match(value));
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      case 'Number':
        value = String(value);
        /* falls through */
      case 'String':
        if (!isArray(data[name])) {
          return data[name] === value;
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      default:
        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
    }
  };


  URI.joinPaths = function() {
    var input = [];
    var segments = [];
    var nonEmptySegments = 0;

    for (var i = 0; i < arguments.length; i++) {
      var url = new URI(arguments[i]);
      input.push(url);
      var _segments = url.segment();
      for (var s = 0; s < _segments.length; s++) {
        if (typeof _segments[s] === 'string') {
          segments.push(_segments[s]);
        }

        if (_segments[s]) {
          nonEmptySegments++;
        }
      }
    }

    if (!segments.length || !nonEmptySegments) {
      return new URI('');
    }

    var uri = new URI('').segment(segments);

    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
      uri.path('/' + uri.path());
    }

    return uri.normalize();
  };

  URI.commonPath = function(one, two) {
    var length = Math.min(one.length, two.length);
    var pos;

    // find first non-matching character
    for (pos = 0; pos < length; pos++) {
      if (one.charAt(pos) !== two.charAt(pos)) {
        pos--;
        break;
      }
    }

    if (pos < 1) {
      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
    }

    // revert to last /
    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
      pos = one.substring(0, pos).lastIndexOf('/');
    }

    return one.substring(0, pos + 1);
  };

  URI.withinString = function(string, callback, options) {
    options || (options = {});
    var _start = options.start || URI.findUri.start;
    var _end = options.end || URI.findUri.end;
    var _trim = options.trim || URI.findUri.trim;
    var _parens = options.parens || URI.findUri.parens;
    var _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
      var match = _start.exec(string);
      if (!match) {
        break;
      }

      var start = match.index;
      if (options.ignoreHtml) {
        // attribut(e=["']?$)
        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
          continue;
        }
      }

      var end = start + string.slice(start).search(_end);
      var slice = string.slice(start, end);
      // make sure we include well balanced parens
      var parensEnd = -1;
      while (true) {
        var parensMatch = _parens.exec(slice);
        if (!parensMatch) {
          break;
        }

        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
        parensEnd = Math.max(parensEnd, parensMatchEnd);
      }

      if (parensEnd > -1) {
        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
      } else {
        slice = slice.replace(_trim, '');
      }

      if (slice.length <= match[0].length) {
        // the extract only contains the starting marker of a URI,
        // e.g. "www" or "http://"
        continue;
      }

      if (options.ignore && options.ignore.test(slice)) {
        continue;
      }

      end = start + slice.length;
      var result = callback(slice, start, end, string);
      if (result === undefined) {
        _start.lastIndex = end;
        continue;
      }

      result = String(result);
      string = string.slice(0, start) + result + string.slice(end);
      _start.lastIndex = start + result.length;
    }

    _start.lastIndex = 0;
    return string;
  };

  URI.ensureValidHostname = function(v, protocol) {
    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
    // they are not part of DNS and therefore ignored by URI.js

    var hasHostname = !!v; // not null and not an empty string
    var hasProtocol = !!protocol;
    var rejectEmptyHostname = false;

    if (hasProtocol) {
      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
    }

    if (rejectEmptyHostname && !hasHostname) {
      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
    } else if (v && v.match(URI.invalid_hostname_characters)) {
      // test punycode
      if (!punycode) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
      }
      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
      }
    }
  };

  URI.ensureValidPort = function (v) {
    if (!v) {
      return;
    }

    var port = Number(v);
    if (isInteger(port) && (port > 0) && (port < 65536)) {
      return;
    }

    throw new TypeError('Port "' + v + '" is not a valid port');
  };

  // noConflict
  URI.noConflict = function(removeAll) {
    if (removeAll) {
      var unconflicted = {
        URI: this.noConflict()
      };

      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
        unconflicted.URITemplate = root.URITemplate.noConflict();
      }

      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
        unconflicted.IPv6 = root.IPv6.noConflict();
      }

      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
      }

      return unconflicted;
    } else if (root.URI === this) {
      root.URI = _URI;
    }

    return this;
  };

  p.build = function(deferBuild) {
    if (deferBuild === true) {
      this._deferred_build = true;
    } else if (deferBuild === undefined || this._deferred_build) {
      this._string = URI.build(this._parts);
      this._deferred_build = false;
    }

    return this;
  };

  p.clone = function() {
    return new URI(this);
  };

  p.valueOf = p.toString = function() {
    return this.build(false)._string;
  };


  function generateSimpleAccessor(_part){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        this._parts[_part] = v || null;
        this.build(!build);
        return this;
      }
    };
  }

  function generatePrefixAccessor(_part, _key){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        if (v !== null) {
          v = v + '';
          if (v.charAt(0) === _key) {
            v = v.substring(1);
          }
        }

        this._parts[_part] = v;
        this.build(!build);
        return this;
      }
    };
  }

  p.protocol = generateSimpleAccessor('protocol');
  p.username = generateSimpleAccessor('username');
  p.password = generateSimpleAccessor('password');
  p.hostname = generateSimpleAccessor('hostname');
  p.port = generateSimpleAccessor('port');
  p.query = generatePrefixAccessor('query', '?');
  p.fragment = generatePrefixAccessor('fragment', '#');

  p.search = function(v, build) {
    var t = this.query(v, build);
    return typeof t === 'string' && t.length ? ('?' + t) : t;
  };
  p.hash = function(v, build) {
    var t = this.fragment(v, build);
    return typeof t === 'string' && t.length ? ('#' + t) : t;
  };

  p.pathname = function(v, build) {
    if (v === undefined || v === true) {
      var res = this._parts.path || (this._parts.hostname ? '/' : '');
      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
    } else {
      if (this._parts.urn) {
        this._parts.path = v ? URI.recodeUrnPath(v) : '';
      } else {
        this._parts.path = v ? URI.recodePath(v) : '/';
      }
      this.build(!build);
      return this;
    }
  };
  p.path = p.pathname;
  p.href = function(href, build) {
    var key;

    if (href === undefined) {
      return this.toString();
    }

    this._string = '';
    this._parts = URI._parts();

    var _URI = href instanceof URI;
    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
    if (href.nodeName) {
      var attribute = URI.getDomAttribute(href);
      href = href[attribute] || '';
      _object = false;
    }

    // window.location is reported to be an object, but it's not the sort
    // of object we're looking for:
    // * location.protocol ends with a colon
    // * location.query != object.search
    // * location.hash != object.fragment
    // simply serializing the unknown object should do the trick
    // (for location, not for everything...)
    if (!_URI && _object && href.pathname !== undefined) {
      href = href.toString();
    }

    if (typeof href === 'string' || href instanceof String) {
      this._parts = URI.parse(String(href), this._parts);
    } else if (_URI || _object) {
      var src = _URI ? href._parts : href;
      for (key in src) {
        if (key === 'query') { continue; }
        if (hasOwn.call(this._parts, key)) {
          this._parts[key] = src[key];
        }
      }
      if (src.query) {
        this.query(src.query, false);
      }
    } else {
      throw new TypeError('invalid input');
    }

    this.build(!build);
    return this;
  };

  // identification accessors
  p.is = function(what) {
    var ip = false;
    var ip4 = false;
    var ip6 = false;
    var name = false;
    var sld = false;
    var idn = false;
    var punycode = false;
    var relative = !this._parts.urn;

    if (this._parts.hostname) {
      relative = false;
      ip4 = URI.ip4_expression.test(this._parts.hostname);
      ip6 = URI.ip6_expression.test(this._parts.hostname);
      ip = ip4 || ip6;
      name = !ip;
      sld = name && SLD && SLD.has(this._parts.hostname);
      idn = name && URI.idn_expression.test(this._parts.hostname);
      punycode = name && URI.punycode_expression.test(this._parts.hostname);
    }

    switch (what.toLowerCase()) {
      case 'relative':
        return relative;

      case 'absolute':
        return !relative;

      // hostname identification
      case 'domain':
      case 'name':
        return name;

      case 'sld':
        return sld;

      case 'ip':
        return ip;

      case 'ip4':
      case 'ipv4':
      case 'inet4':
        return ip4;

      case 'ip6':
      case 'ipv6':
      case 'inet6':
        return ip6;

      case 'idn':
        return idn;

      case 'url':
        return !this._parts.urn;

      case 'urn':
        return !!this._parts.urn;

      case 'punycode':
        return punycode;
    }

    return null;
  };

  // component specific input validation
  var _protocol = p.protocol;
  var _port = p.port;
  var _hostname = p.hostname;

  p.protocol = function(v, build) {
    if (v) {
      // accept trailing ://
      v = v.replace(/:(\/\/)?$/, '');

      if (!v.match(URI.protocol_expression)) {
        throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
      }
    }

    return _protocol.call(this, v, build);
  };
  p.scheme = p.protocol;
  p.port = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      if (v === 0) {
        v = null;
      }

      if (v) {
        v += '';
        if (v.charAt(0) === ':') {
          v = v.substring(1);
        }

        URI.ensureValidPort(v);
      }
    }
    return _port.call(this, v, build);
  };
  p.hostname = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      var x = { preventInvalidHostname: this._parts.preventInvalidHostname };
      var res = URI.parseHost(v, x);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      v = x.hostname;
      if (this._parts.preventInvalidHostname) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }
    }

    return _hostname.call(this, v, build);
  };

  // compound accessors
  p.origin = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var protocol = this.protocol();
      var authority = this.authority();
      if (!authority) {
        return '';
      }

      return (protocol ? protocol + '://' : '') + this.authority();
    } else {
      var origin = URI(v);
      this
        .protocol(origin.protocol())
        .authority(origin.authority())
        .build(!build);
      return this;
    }
  };
  p.host = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildHost(this._parts) : '';
    } else {
      var res = URI.parseHost(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.authority = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
    } else {
      var res = URI.parseAuthority(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.userinfo = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var t = URI.buildUserinfo(this._parts);
      return t ? t.substring(0, t.length -1) : t;
    } else {
      if (v[v.length-1] !== '@') {
        v += '@';
      }

      URI.parseUserinfo(v, this._parts);
      this.build(!build);
      return this;
    }
  };
  p.resource = function(v, build) {
    var parts;

    if (v === undefined) {
      return this.path() + this.search() + this.hash();
    }

    parts = URI.parse(v);
    this._parts.path = parts.path;
    this._parts.query = parts.query;
    this._parts.fragment = parts.fragment;
    this.build(!build);
    return this;
  };

  // fraction accessors
  p.subdomain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    // convenience, return "www" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // grab domain and add another segment
      var end = this._parts.hostname.length - this.domain().length - 1;
      return this._parts.hostname.substring(0, end) || '';
    } else {
      var e = this._parts.hostname.length - this.domain().length;
      var sub = this._parts.hostname.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(sub));

      if (v && v.charAt(v.length - 1) !== '.') {
        v += '.';
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      if (v) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }

      this._parts.hostname = this._parts.hostname.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.domain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // convenience, return "example.org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // if hostname consists of 1 or 2 segments, it must be the domain
      var t = this._parts.hostname.match(/\./g);
      if (t && t.length < 2) {
        return this._parts.hostname;
      }

      // grab tld and add another segment
      var end = this._parts.hostname.length - this.tld(build).length - 1;
      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
      return this._parts.hostname.substring(end) || '';
    } else {
      if (!v) {
        throw new TypeError('cannot set domain empty');
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      URI.ensureValidHostname(v, this._parts.protocol);

      if (!this._parts.hostname || this.is('IP')) {
        this._parts.hostname = v;
      } else {
        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.tld = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // return "org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      var pos = this._parts.hostname.lastIndexOf('.');
      var tld = this._parts.hostname.substring(pos + 1);

      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
        return SLD.get(this._parts.hostname) || tld;
      }

      return tld;
    } else {
      var replace;

      if (!v) {
        throw new TypeError('cannot set TLD empty');
      } else if (v.match(/[^a-zA-Z0-9-]/)) {
        if (SLD && SLD.is(v)) {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        } else {
          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
        }
      } else if (!this._parts.hostname || this.is('IP')) {
        throw new ReferenceError('cannot set TLD on non-domain host');
      } else {
        replace = new RegExp(escapeRegEx(this.tld()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.directory = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path && !this._parts.hostname) {
        return '';
      }

      if (this._parts.path === '/') {
        return '/';
      }

      var end = this._parts.path.length - this.filename().length - 1;
      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');

      return v ? URI.decodePath(res) : res;

    } else {
      var e = this._parts.path.length - this.filename().length;
      var directory = this._parts.path.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(directory));

      // fully qualifier directories begin with a slash
      if (!this.is('relative')) {
        if (!v) {
          v = '/';
        }

        if (v.charAt(0) !== '/') {
          v = '/' + v;
        }
      }

      // directories always end with a slash
      if (v && v.charAt(v.length - 1) !== '/') {
        v += '/';
      }

      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.filename = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v !== 'string') {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var pos = this._parts.path.lastIndexOf('/');
      var res = this._parts.path.substring(pos+1);

      return v ? URI.decodePathSegment(res) : res;
    } else {
      var mutatedDirectory = false;

      if (v.charAt(0) === '/') {
        v = v.substring(1);
      }

      if (v.match(/\.?\//)) {
        mutatedDirectory = true;
      }

      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);

      if (mutatedDirectory) {
        this.normalizePath(build);
      } else {
        this.build(!build);
      }

      return this;
    }
  };
  p.suffix = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var filename = this.filename();
      var pos = filename.lastIndexOf('.');
      var s, res;

      if (pos === -1) {
        return '';
      }

      // suffix may only contain alnum characters (yup, I made this up.)
      s = filename.substring(pos+1);
      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
      return v ? URI.decodePathSegment(res) : res;
    } else {
      if (v.charAt(0) === '.') {
        v = v.substring(1);
      }

      var suffix = this.suffix();
      var replace;

      if (!suffix) {
        if (!v) {
          return this;
        }

        this._parts.path += '.' + URI.recodePath(v);
      } else if (!v) {
        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
      } else {
        replace = new RegExp(escapeRegEx(suffix) + '$');
      }

      if (replace) {
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.segment = function(segment, v, build) {
    var separator = this._parts.urn ? ':' : '/';
    var path = this.path();
    var absolute = path.substring(0, 1) === '/';
    var segments = path.split(separator);

    if (segment !== undefined && typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (segment !== undefined && typeof segment !== 'number') {
      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
    }

    if (absolute) {
      segments.shift();
    }

    if (segment < 0) {
      // allow negative indexes to address from the end
      segment = Math.max(segments.length + segment, 0);
    }

    if (v === undefined) {
      /*jshint laxbreak: true */
      return segment === undefined
        ? segments
        : segments[segment];
      /*jshint laxbreak: false */
    } else if (segment === null || segments[segment] === undefined) {
      if (isArray(v)) {
        segments = [];
        // collapse empty elements within array
        for (var i=0, l=v.length; i < l; i++) {
          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
            continue;
          }

          if (segments.length && !segments[segments.length -1].length) {
            segments.pop();
          }

          segments.push(trimSlashes(v[i]));
        }
      } else if (v || typeof v === 'string') {
        v = trimSlashes(v);
        if (segments[segments.length -1] === '') {
          // empty trailing elements have to be overwritten
          // to prevent results such as /foo//bar
          segments[segments.length -1] = v;
        } else {
          segments.push(v);
        }
      }
    } else {
      if (v) {
        segments[segment] = trimSlashes(v);
      } else {
        segments.splice(segment, 1);
      }
    }

    if (absolute) {
      segments.unshift('');
    }

    return this.path(segments.join(separator), build);
  };
  p.segmentCoded = function(segment, v, build) {
    var segments, i, l;

    if (typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (v === undefined) {
      segments = this.segment(segment, v, build);
      if (!isArray(segments)) {
        segments = segments !== undefined ? URI.decode(segments) : undefined;
      } else {
        for (i = 0, l = segments.length; i < l; i++) {
          segments[i] = URI.decode(segments[i]);
        }
      }

      return segments;
    }

    if (!isArray(v)) {
      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
    } else {
      for (i = 0, l = v.length; i < l; i++) {
        v[i] = URI.encode(v[i]);
      }
    }

    return this.segment(segment, v, build);
  };

  // mutating query string
  var q = p.query;
  p.query = function(v, build) {
    if (v === true) {
      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    } else if (typeof v === 'function') {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      var result = v.call(this, data);
      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else if (v !== undefined && typeof v !== 'string') {
      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else {
      return q.call(this, v, build);
    }
  };
  p.setQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);

    if (typeof name === 'string' || name instanceof String) {
      data[name] = value !== undefined ? value : null;
    } else if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          data[key] = name[key];
        }
      }
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }

    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.addQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.addQuery(data, name, value === undefined ? null : value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.removeQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.removeQuery(data, name, value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.hasQuery = function(name, value, withinArray) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    return URI.hasQuery(data, name, value, withinArray);
  };
  p.setSearch = p.setQuery;
  p.addSearch = p.addQuery;
  p.removeSearch = p.removeQuery;
  p.hasSearch = p.hasQuery;

  // sanitizing URLs
  p.normalize = function() {
    if (this._parts.urn) {
      return this
        .normalizeProtocol(false)
        .normalizePath(false)
        .normalizeQuery(false)
        .normalizeFragment(false)
        .build();
    }

    return this
      .normalizeProtocol(false)
      .normalizeHostname(false)
      .normalizePort(false)
      .normalizePath(false)
      .normalizeQuery(false)
      .normalizeFragment(false)
      .build();
  };
  p.normalizeProtocol = function(build) {
    if (typeof this._parts.protocol === 'string') {
      this._parts.protocol = this._parts.protocol.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizeHostname = function(build) {
    if (this._parts.hostname) {
      if (this.is('IDN') && punycode) {
        this._parts.hostname = punycode.toASCII(this._parts.hostname);
      } else if (this.is('IPv6') && IPv6) {
        this._parts.hostname = IPv6.best(this._parts.hostname);
      }

      this._parts.hostname = this._parts.hostname.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizePort = function(build) {
    // remove port of it's the protocol's default
    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
      this._parts.port = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizePath = function(build) {
    var _path = this._parts.path;
    if (!_path) {
      return this;
    }

    if (this._parts.urn) {
      this._parts.path = URI.recodeUrnPath(this._parts.path);
      this.build(!build);
      return this;
    }

    if (this._parts.path === '/') {
      return this;
    }

    _path = URI.recodePath(_path);

    var _was_relative;
    var _leadingParents = '';
    var _parent, _pos;

    // handle relative paths
    if (_path.charAt(0) !== '/') {
      _was_relative = true;
      _path = '/' + _path;
    }

    // handle relative files (as opposed to directories)
    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
      _path += '/';
    }

    // resolve simples
    _path = _path
      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
      .replace(/\/{2,}/g, '/');

    // remember leading parents
    if (_was_relative) {
      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
      if (_leadingParents) {
        _leadingParents = _leadingParents[0];
      }
    }

    // resolve parents
    while (true) {
      _parent = _path.search(/\/\.\.(\/|$)/);
      if (_parent === -1) {
        // no more ../ to resolve
        break;
      } else if (_parent === 0) {
        // top level cannot be relative, skip it
        _path = _path.substring(3);
        continue;
      }

      _pos = _path.substring(0, _parent).lastIndexOf('/');
      if (_pos === -1) {
        _pos = _parent;
      }
      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
    }

    // revert to relative
    if (_was_relative && this.is('relative')) {
      _path = _leadingParents + _path.substring(1);
    }

    this._parts.path = _path;
    this.build(!build);
    return this;
  };
  p.normalizePathname = p.normalizePath;
  p.normalizeQuery = function(build) {
    if (typeof this._parts.query === 'string') {
      if (!this._parts.query.length) {
        this._parts.query = null;
      } else {
        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
      }

      this.build(!build);
    }

    return this;
  };
  p.normalizeFragment = function(build) {
    if (!this._parts.fragment) {
      this._parts.fragment = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizeSearch = p.normalizeQuery;
  p.normalizeHash = p.normalizeFragment;

  p.iso8859 = function() {
    // expect unicode input, iso8859 output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = escape;
    URI.decode = decodeURIComponent;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.unicode = function() {
    // expect iso8859 input, unicode output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = strictEncodeURIComponent;
    URI.decode = unescape;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.readable = function() {
    var uri = this.clone();
    // removing username, password, because they shouldn't be displayed according to RFC 3986
    uri.username('').password('').normalize();
    var t = '';
    if (uri._parts.protocol) {
      t += uri._parts.protocol + '://';
    }

    if (uri._parts.hostname) {
      if (uri.is('punycode') && punycode) {
        t += punycode.toUnicode(uri._parts.hostname);
        if (uri._parts.port) {
          t += ':' + uri._parts.port;
        }
      } else {
        t += uri.host();
      }
    }

    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
      t += '/';
    }

    t += uri.path(true);
    if (uri._parts.query) {
      var q = '';
      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
        var kv = (qp[i] || '').split('=');
        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
          .replace(/&/g, '%26');

        if (kv[1] !== undefined) {
          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
            .replace(/&/g, '%26');
        }
      }
      t += '?' + q.substring(1);
    }

    t += URI.decodeQuery(uri.hash(), true);
    return t;
  };

  // resolving relative and absolute URLs
  p.absoluteTo = function(base) {
    var resolved = this.clone();
    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
    var basedir, i, p;

    if (this._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    if (!(base instanceof URI)) {
      base = new URI(base);
    }

    if (resolved._parts.protocol) {
      // Directly returns even if this._parts.hostname is empty.
      return resolved;
    } else {
      resolved._parts.protocol = base._parts.protocol;
    }

    if (this._parts.hostname) {
      return resolved;
    }

    for (i = 0; (p = properties[i]); i++) {
      resolved._parts[p] = base._parts[p];
    }

    if (!resolved._parts.path) {
      resolved._parts.path = base._parts.path;
      if (!resolved._parts.query) {
        resolved._parts.query = base._parts.query;
      }
    } else {
      if (resolved._parts.path.substring(-2) === '..') {
        resolved._parts.path += '/';
      }

      if (resolved.path().charAt(0) !== '/') {
        basedir = base.directory();
        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
        resolved.normalizePath();
      }
    }

    resolved.build();
    return resolved;
  };
  p.relativeTo = function(base) {
    var relative = this.clone().normalize();
    var relativeParts, baseParts, common, relativePath, basePath;

    if (relative._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    base = new URI(base).normalize();
    relativeParts = relative._parts;
    baseParts = base._parts;
    relativePath = relative.path();
    basePath = base.path();

    if (relativePath.charAt(0) !== '/') {
      throw new Error('URI is already relative');
    }

    if (basePath.charAt(0) !== '/') {
      throw new Error('Cannot calculate a URI relative to another relative URI');
    }

    if (relativeParts.protocol === baseParts.protocol) {
      relativeParts.protocol = null;
    }

    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
      return relative.build();
    }

    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
      return relative.build();
    }

    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
      relativeParts.hostname = null;
      relativeParts.port = null;
    } else {
      return relative.build();
    }

    if (relativePath === basePath) {
      relativeParts.path = '';
      return relative.build();
    }

    // determine common sub path
    common = URI.commonPath(relativePath, basePath);

    // If the paths have nothing in common, return a relative URL with the absolute path.
    if (!common) {
      return relative.build();
    }

    var parents = baseParts.path
      .substring(common.length)
      .replace(/[^\/]*$/, '')
      .replace(/.*?\//g, '../');

    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';

    return relative.build();
  };

  // comparing URIs
  p.equals = function(uri) {
    var one = this.clone();
    var two = new URI(uri);
    var one_map = {};
    var two_map = {};
    var checked = {};
    var one_query, two_query, key;

    one.normalize();
    two.normalize();

    // exact match
    if (one.toString() === two.toString()) {
      return true;
    }

    // extract query string
    one_query = one.query();
    two_query = two.query();
    one.query('');
    two.query('');

    // definitely not equal if not even non-query parts match
    if (one.toString() !== two.toString()) {
      return false;
    }

    // query parameters have the same length, even if they're permuted
    if (one_query.length !== two_query.length) {
      return false;
    }

    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);

    for (key in one_map) {
      if (hasOwn.call(one_map, key)) {
        if (!isArray(one_map[key])) {
          if (one_map[key] !== two_map[key]) {
            return false;
          }
        } else if (!arraysEqual(one_map[key], two_map[key])) {
          return false;
        }

        checked[key] = true;
      }
    }

    for (key in two_map) {
      if (hasOwn.call(two_map, key)) {
        if (!checked[key]) {
          // two contains a parameter not present in one
          return false;
        }
      }
    }

    return true;
  };

  // state
  p.preventInvalidHostname = function(v) {
    this._parts.preventInvalidHostname = !!v;
    return this;
  };

  p.duplicateQueryParameters = function(v) {
    this._parts.duplicateQueryParameters = !!v;
    return this;
  };

  p.escapeQuerySpace = function(v) {
    this._parts.escapeQuerySpace = !!v;
    return this;
  };

  return URI;
}));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(751),
    baseIteratee = __webpack_require__(102),
    baseSome = __webpack_require__(1675),
    isArray = __webpack_require__(68),
    isIterateeCall = __webpack_require__(236);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1545), __esModule: true };

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1414), __esModule: true };

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1511), __esModule: true };

/***/ }),
/* 288 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.legsToDisruptionAlertLegs = exports.formatLegsAsCustomerServiceChangeLeg = exports.formatDayOfWeek = exports.getDaysOptionFromDate = exports.isBankHoliday = exports.isSunday = exports.isSaturday = exports.isWeekday = exports.getStationType = exports.checkForReturnJourney = exports.getInitialFormState = exports.filterSameDayDeparturesOnly = exports.formatDisruptionAlertMuteResponse = exports.formatDisruptionAlertResponse = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _mapValues2 = __webpack_require__(1102);

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _DaySaveSearch = __webpack_require__(420);

var _DaySaveSearch2 = _interopRequireDefault(_DaySaveSearch);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _DisruptionAlertStore = __webpack_require__(345);

var _DisruptionAlertStore2 = _interopRequireDefault(_DisruptionAlertStore);

var _CustomerServiceChangeLeg = __webpack_require__(903);

var _CustomerServiceChangeLeg2 = _interopRequireDefault(_CustomerServiceChangeLeg);

var _DisruptionAlertLeg = __webpack_require__(904);

var _DisruptionAlertLeg2 = _interopRequireDefault(_DisruptionAlertLeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatDisruptionAlertResponse = function formatDisruptionAlertResponse(_ref) {
    var disruptionAlertId = _ref.disruptionAlertId,
        originStationDetail = _ref.originStationDetail,
        destinationStationDetail = _ref.destinationStationDetail,
        legs = _ref.legs,
        mutes = _ref.mutes,
        response = (0, _objectWithoutProperties3.default)(_ref, ['disruptionAlertId', 'originStationDetail', 'destinationStationDetail', 'legs', 'mutes']);
    return (0, _extends3.default)({}, response, {
        id: disruptionAlertId,
        origin: originStationDetail,
        destination: destinationStationDetail,
        legs: legs.map(function (_ref2) {
            var journeyLegId = _ref2.journeyLegId,
                legOriginStationDetail = _ref2.originStationDetail,
                legDestinationStationDetail = _ref2.destinationStationDetail,
                leg = (0, _objectWithoutProperties3.default)(_ref2, ['journeyLegId', 'originStationDetail', 'destinationStationDetail']);
            return (0, _extends3.default)({}, leg, {
                id: journeyLegId,
                origin: legOriginStationDetail,
                destination: legDestinationStationDetail
            });
        }),
        mutes: mutes.map(function (_ref3) {
            var muteId = _ref3.muteId,
                mute = (0, _objectWithoutProperties3.default)(_ref3, ['muteId']);
            return (0, _extends3.default)({}, mute, {
                id: muteId
            });
        })
    });
};

exports.formatDisruptionAlertResponse = formatDisruptionAlertResponse;
var formatDisruptionAlertMuteResponse = function formatDisruptionAlertMuteResponse(_ref4) {
    var muteId = _ref4.muteId,
        response = (0, _objectWithoutProperties3.default)(_ref4, ['muteId']);
    return (0, _extends3.default)({}, response, { id: muteId });
};

exports.formatDisruptionAlertMuteResponse = formatDisruptionAlertMuteResponse;
var filterSameDayDeparturesOnly = exports.filterSameDayDeparturesOnly = function filterSameDayDeparturesOnly(servicesList, searchDate) {
    return servicesList.filter(function (s) {
        return s.getDepartureDateTime().isSame(searchDate, 'day');
    });
};

var isInward = function isInward(direction) {
    return direction === _AppConstants.JourneyDirections.INWARD;
};

var getInitialFormState = exports.getInitialFormState = function getInitialFormState(alert, order, orderTrip, trip, isSeason, isDaySave, journeyDirection, prefillFromSearch) {
    var search = new _Search2.default();
    var defaultStartDate = search.getDefaultOutboundDateTime();

    var formState = {
        origin: new _Station2.default(),
        destination: new _Station2.default(),
        startDate: defaultStartDate,
        selectedServices: new _immutable.List(),
        duration: _AppConstants.DisruptionAlertDurationOptions[isSeason ? 'SIXMONTHS' : 'ONEOFF'],
        customEndDate: null,
        days: getDaysOptionFromDate(defaultStartDate),
        weekdays: (0, _mapValues3.default)(_AppConstants.DisruptionAlertWeekdays, function () {
            return true;
        })
    };

    if (alert) {
        search = createSearchFromAlert(alert, journeyDirection);

        var origin = alert.origin,
            destination = alert.destination,
            departureDate = alert.departureDate,
            departureTime = alert.departureTime,
            alertFrom = alert.alertFrom,
            alertTo = alert.alertTo,
            daysOfWeek = alert.daysOfWeek;


        var startDate = (0, _TrainTime2.default)();
        if (departureDate && departureTime) {
            startDate = departureDate.clone().set({
                hour: departureTime.hour(),
                minute: departureTime.minute()
            });
        } else if (alertFrom && departureTime) {
            startDate = alertFrom.clone().set({
                hour: departureTime.hour(),
                minute: departureTime.minute()
            });
        }

        var duration = void 0;
        if (alert.isForever()) {
            duration = _AppConstants.DisruptionAlertDurationOptions.INFINITE;
        } else if (alertFrom.isSame(alertTo)) {
            duration = _AppConstants.DisruptionAlertDurationOptions.ONEOFF;
        } else if (alertFrom.clone().add(6, 'months').isSame(alertTo)) {
            duration = _AppConstants.DisruptionAlertDurationOptions.SIXMONTHS;
        } else {
            duration = _AppConstants.DisruptionAlertDurationOptions.CUSTOM;
        }

        var days = void 0;
        var containsWeekdays = !daysOfWeek.isEmpty() && daysOfWeek.every(function (day) {
            return (0, _values3.default)(_AppConstants.DisruptionAlertWeekdays).includes(day);
        });

        if (daysOfWeek === ['SATURDAY'] || departureDate && isSaturday(departureDate)) {
            days = _AppConstants.DisruptionAlertDaysOptions.SATURDAYS;
        } else if (daysOfWeek === ['SUNDAY'] || departureDate && isSunday(departureDate)) {
            days = _AppConstants.DisruptionAlertDaysOptions.SUNDAYS;
        } else if (containsWeekdays || departureDate && isWeekday(departureDate)) {
            days = _AppConstants.DisruptionAlertDaysOptions.WEEKDAYS;
        }

        var weekdays = containsWeekdays ? (0, _mapValues3.default)(_AppConstants.DisruptionAlertWeekdays, function (day) {
            return daysOfWeek.includes(day);
        }) : (0, _mapValues3.default)(_AppConstants.DisruptionAlertWeekdays, function () {
            return true;
        });

        formState = (0, _extends3.default)({}, formState, {
            origin: isInward(journeyDirection) ? destination : origin,
            destination: isInward(journeyDirection) ? origin : destination,
            startDate: startDate,
            duration: duration,
            customEndDate: alertTo,
            days: days,
            weekdays: weekdays
        });
    } else {
        if (order && orderTrip) {
            // Should only ever be Season or Day Save tickets
            search = createSearchFromOrderTrip(orderTrip, isDaySave, journeyDirection);
        } else if (trip && prefillFromSearch) {
            var tripSearch = trip.search;

            if (tripSearch instanceof _SeasonSearch2.default) {
                search = createSearchFromSeasonSearch(tripSearch, journeyDirection);
            } else if (tripSearch instanceof _DaySaveSearch2.default) {
                search = createSearchFromDaySaveSearch(tripSearch, journeyDirection);
            } else {
                search = createSearchFromTripSearch(tripSearch, journeyDirection);
            }
        }

        var _origin = !search.origin.isGroupStation() ? search.origin : new _Station2.default();
        var _destination = !search.destination.isGroupStation() ? search.destination : new _Station2.default();
        var _startDate = search.getOutboundDateTime();

        formState = (0, _extends3.default)({}, formState, {
            origin: _origin,
            destination: _destination,
            startDate: _startDate,
            days: getDaysOptionFromDate(_startDate)
        });
    }

    return [search, formState];
};

var checkForReturnJourney = exports.checkForReturnJourney = function checkForReturnJourney(orderTrip, trip, journeyDirection, prefillFromSearch) {
    var isOutward = journeyDirection === _AppConstants.JourneyDirections.OUTWARD;
    var hasOrderTripReturn = orderTrip && (orderTrip.hasReturnJourney() || orderTrip.isSeason() || orderTrip.hasDaySaveFare());
    var hasSearchTripReturn = trip && (trip.hasReturnFare() || trip.isSeason() || trip.isDaySave());

    return prefillFromSearch && isOutward && (hasOrderTripReturn || hasSearchTripReturn);
};

var getStationType = exports.getStationType = function getStationType(smartcard, isSeason) {
    var stationType = _AppConstants.StationTypes;

    if (smartcard && isSeason) {
        stationType = _AppConstants.SmartcardSeasonStationTypes;
    } else if (smartcard) {
        stationType = _AppConstants.SmartcardStationTypes;
    } else if (isSeason) {
        stationType = _AppConstants.SeasonStationTypes;
    }

    return stationType;
};

var createSearchFromAlert = function createSearchFromAlert(alert, journeyDirection) {
    var search = new _Search2.default({
        origin: isInward(journeyDirection) ? alert.destination : alert.origin,
        destination: isInward(journeyDirection) ? alert.origin : alert.destination,
        ticketType: _AppConstants.TicketTypes.SINGLE
    });

    var outboundDateTime = alert.departureDate || alert.alertFrom;

    if (outboundDateTime) {
        return search.setOutboundDateTime(outboundDateTime);
    }

    return search;
};

var createSearchFromOrderTrip = function createSearchFromOrderTrip(orderTrip, isDaySave, journeyDirection) {
    return new _Search2.default({
        origin: isDaySave ? isInward(journeyDirection) ? new _Station2.default() : orderTrip.getDaySaveFare().origin : isInward(journeyDirection) ? orderTrip.getDestination() : orderTrip.getFirstOrigin(),
        destination: isDaySave ? isInward(journeyDirection) ? orderTrip.getDaySaveFare().origin : new _Station2.default() : isInward(journeyDirection) ? orderTrip.getFirstOrigin() : orderTrip.getDestination(),
        ticketType: _AppConstants.TicketTypes.SINGLE
    }).setOutboundDateTime(isDaySave ? orderTrip.getDaySaveFare().outwardJourney.validFrom.clone().hours(12) : orderTrip.isSeason() ? orderTrip.getSeasonFare().getValidFrom().clone().set({ hours: 12, minutes: 0 }) : orderTrip.getDepartureTime());
};

var createSearchFromTripSearch = function createSearchFromTripSearch(search, journeyDirection) {
    return new _Search2.default({
        origin: search[isInward(journeyDirection) ? 'destination' : 'origin'],
        destination: search[isInward(journeyDirection) ? 'origin' : 'destination'],
        ticketType: _AppConstants.TicketTypes.SINGLE
    }).setOutboundDateTime(isInward(journeyDirection) ? search.getReturnDateTime() : search.getOutboundDateTime());
};

var createSearchFromSeasonSearch = function createSearchFromSeasonSearch(seasonSearch, journeyDirection) {
    var outboundDateTime = seasonSearch.getStartDate().clone().hours(12);
    if (isInward(journeyDirection)) {
        outboundDateTime.add(6, 'days');
    }

    return new _Search2.default({
        origin: seasonSearch[isInward(journeyDirection) ? 'destination' : 'origin'],
        destination: seasonSearch[isInward(journeyDirection) ? 'origin' : 'destination'],
        ticketType: _AppConstants.TicketTypes.SINGLE
    }).setOutboundDateTime(outboundDateTime);
};

var createSearchFromDaySaveSearch = function createSearchFromDaySaveSearch(daySaveSearch, journeyDirection) {
    return new _Search2.default({
        origin: isInward(journeyDirection) ? new _Station2.default() : daySaveSearch.origin,
        destination: isInward(journeyDirection) ? daySaveSearch.origin : new _Station2.default()
    }).setOutboundDateTime(daySaveSearch.date.clone().hours(12));
};

var isWeekday = exports.isWeekday = function isWeekday(datetime) {
    return datetime.isoWeekday() >= 1 && datetime.isoWeekday() <= 5;
};
var isSaturday = exports.isSaturday = function isSaturday(datetime) {
    return datetime.isoWeekday() === 6;
};
var isSunday = exports.isSunday = function isSunday(datetime) {
    return datetime.isoWeekday() === 7;
};
var isBankHoliday = exports.isBankHoliday = function isBankHoliday(datetime) {
    return _DisruptionAlertStore2.default.getBankHolidays().find(function (date) {
        return date.isSame(datetime, 'day');
    });
};

var getDaysOptionFromDate = exports.getDaysOptionFromDate = function getDaysOptionFromDate(datetime) {
    return _AppConstants.DisruptionAlertDaysOptions[isSaturday(datetime) ? 'SATURDAYS' : isSunday(datetime) ? 'SUNDAYS' : 'WEEKDAYS'];
};

// e.g. 'MONDAY' => 'Monday' or 'Mon'
var formatDayOfWeek = exports.formatDayOfWeek = function formatDayOfWeek(dayStr) {
    var abbreviated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return dayStr.substring(0, abbreviated ? 3 : undefined).replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

var formatLegsAsCustomerServiceChangeLeg = exports.formatLegsAsCustomerServiceChangeLeg = function formatLegsAsCustomerServiceChangeLeg(legs) {
    return legs.filter(function (leg) {
        return leg.mode === _AppConstants.TransitModes.TRAIN;
    }).map(function (leg, legIndex) {
        return new _CustomerServiceChangeLeg2.default({
            trainUid: leg.tuid,
            origin: leg.origin.crs,
            originStationDetail: null,
            destination: leg.destination.crs,
            destinationStationDetail: null,
            departureDate: leg.departure,
            departureTime: leg.departure,
            arrivalTime: leg.arrival,
            legOrder: ++legIndex
        });
    });
};

var legsToDisruptionAlertLegs = exports.legsToDisruptionAlertLegs = function legsToDisruptionAlertLegs(legs) {
    return legs.filter(function (l) {
        return l.mode === _AppConstants.TransitModes.TRAIN;
    }).map(function (leg, legIndex) {
        return new _DisruptionAlertLeg2.default({
            trainUid: leg.tuid,
            origin: leg.origin,
            destination: leg.destination,
            departureTime: leg.departure,
            arrivalTime: leg.arrival,
            groupId: legIndex + 1,
            legOrder: ++legIndex
        });
    });
};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AmazonLoginService = __webpack_require__(1981);

var _AmazonLoginService2 = _interopRequireDefault(_AmazonLoginService);

var _AmazonPayService = __webpack_require__(1024);

var _AmazonPayService2 = _interopRequireDefault(_AmazonPayService);

var _AmazonLoginError = __webpack_require__(920);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonLoginActions = {
    authenticate: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
            var accessToken = _ref.accessToken;

            var _ref3, status, token, rethrow;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_STARTED
                            });

                            _context.prev = 1;
                            _context.next = 4;
                            return _AmazonLoginService2.default.authenticate({ accessToken: accessToken });

                        case 4:
                            _ref3 = _context.sent;
                            status = _ref3.status;
                            token = _ref3.token;


                            if (status === _AppConstants.AmazonLoginAuthStatus.MISMATCHED_EMAILS) {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                    status: _AppConstants.AmazonLoginStatus.SYNC_EMAIL_START,
                                    customer: token.customer.toJS()
                                });
                            }

                            if (!(token && token.isValid())) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 11;
                            return _CustomerActions2.default.loginWithToken({ token: token });

                        case 11:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                status: _AppConstants.AmazonLoginStatus.LOGIN_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 14:
                            throw new _AmazonLoginError.AmazonLoginError('No access token available in the auth response');

                        case 15:
                            _context.next = 31;
                            break;

                        case 17:
                            _context.prev = 17;
                            _context.t0 = _context['catch'](1);
                            rethrow = true;

                            if (!(_context.t0 instanceof _AmazonLoginError.AmazonLoginError)) {
                                _context.next = 30;
                                break;
                            }

                            _context.t1 = _context.t0.message;
                            _context.next = _context.t1 === _AppConstants.AmazonLoginAuthStatus.LINKING_REQUIRED ? 24 : _context.t1 === _AppConstants.AmazonLoginAuthStatus.LINKING_NOT_AVAILABLE ? 27 : 30;
                            break;

                        case 24:
                            rethrow = false;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                status: _AppConstants.AmazonLoginStatus.LINK_START,
                                customer: _context.t0.extra.customer
                            });
                            return _context.abrupt('break', 30);

                        case 27:
                            rethrow = false;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                status: _AppConstants.AmazonLoginStatus.REGISTER_START,
                                customer: _context.t0.extra.customer
                            });
                            return _context.abrupt('break', 30);

                        case 30:

                            if (rethrow) {
                                console.error(_context.t0);

                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                    status: _AppConstants.AmazonLoginStatus.LOGIN_ERROR
                                });
                            }

                        case 31:
                            _context.prev = 31;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_FINISHED
                            });
                            return _context.finish(31);

                        case 34:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 17, 31, 34]]);
        }));

        function authenticate(_x) {
            return _ref2.apply(this, arguments);
        }

        return authenticate;
    }(),
    resetStateToIdle: function resetStateToIdle() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
            status: _AppConstants.AmazonLoginStatus.IDLE
        });
    },
    handleOnError: function handleOnError(error) {
        console.error(error);

        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
            status: _AppConstants.AmazonLoginStatus.LOGIN_ERROR
        });
    },
    handleOnLoginComplete: function handleOnLoginComplete(hasLoginCompleted, accessToken) {
        var statusProps = accessToken ? { status: _AppConstants.AmazonLoginStatus.LOGIN_READY_TO_AUTH } : null;

        _AppDispatcher2.default.dispatch((0, _extends3.default)({
            actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_LOGIN_ACCESS_TOKEN,
            accessToken: accessToken,
            hasLoginCompleted: hasLoginCompleted
        }, statusProps));
    },
    handleOnRetrieveProfile: function handleOnRetrieveProfile(response) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_EMAIL,
            amazonEmail: response.profile.PrimaryEmail
        });
    },
    linkAccount: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref4) {
            var email = _ref4.email,
                password = _ref4.password;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_STARTED
                            });

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _AmazonLoginService2.default.linkAccount({ email: email, password: password });

                        case 4:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                status: _AppConstants.AmazonLoginStatus.LINK_SUCCESS
                            });

                            // Automatically log-in user as they authenticated themselves
                            // against their OTRL account during the linking process
                            _CustomerActions2.default.login({ username: email, password: password });
                            _context2.next = 15;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](1);

                            if (!(_context2.t0.name === 'UnauthorisedError')) {
                                _context2.next = 14;
                                break;
                            }

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                status: _AppConstants.AmazonLoginStatus.LINK_ERROR
                            });
                            _context2.next = 15;
                            break;

                        case 14:
                            throw _context2.t0;

                        case 15:
                            _context2.prev = 15;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_FINISHED
                            });
                            return _context2.finish(15);

                        case 18:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 8, 15, 18]]);
        }));

        function linkAccount(_x2) {
            return _ref5.apply(this, arguments);
        }

        return linkAccount;
    }(),
    load: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var defaults, options;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            defaults = {
                                isAmazonLogin: true,
                                responseType: _AppConstants.AmazonLoginResponseType.TOKEN
                            };
                            options = (0, _extends3.default)({}, defaults, _options);
                            _context3.next = 4;
                            return _AmazonPayService2.default.loadSdk({
                                options: options,
                                handleOnError: this.handleOnError,
                                handleOnLoginComplete: this.handleOnLoginComplete
                            });

                        case 4:

                            _AmazonLoginService2.default.init({
                                options: {
                                    handleOnRetrieveProfile: this.handleOnRetrieveProfile
                                }
                            });

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function load() {
            return _ref6.apply(this, arguments);
        }

        return load;
    }(),
    login: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _AmazonPayService2.default.authorizeLogin(function (accessToken) {
                                window.amazon.Login.retrieveProfile(accessToken, function () /* response */{
                                    // If you'd ever need to get customer's data (full name, email, postcode and Amazon ID)
                                    // from Amazon Login JavaScript SDK then response is the object you're looking for.
                                });
                            });

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function login() {
            return _ref7.apply(this, arguments);
        }

        return login;
    }(),
    logout: function logout() {
        if (window.amazon && window.amazon.Login) {
            window.amazon.Login.logout();
            // In Booking Engine there are two Amazon Login/Pay sign in buttons.
            // Because Amazon SDK keeps track of an exact URL that were used
            // for a sign-in in a given session it's impossible to sign in again
            // using a sign in button on a different URL as it will raise the
            // "proxy parent uri != topic target uri" error.
            //
            // To replicate an issue that below fixes. Try:
            // - signing in on the /delivery pages using Amazon Pay shortcut button
            // - click the logout Amazon button above the Amazon widgets
            // - try to sign in again on the /payment page
            //
            // As a workaround reload the page to unload the Amazon SDK JavaScript.
            setTimeout(function () {
                return window.location.reload();
            }, 250);
        } else {
            console.warn('Cannot log out from Amazon.');
        }
    },
    resetStatus: function resetStatus() {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _AppConstants.AmazonLoginStatus.IDLE;

        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
            status: status
        });
    },
    retrieveProfile: function retrieveProfile(accessToken) {
        _AmazonLoginService2.default.retrieveProfile(accessToken);
    },
    unlinkAccount: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_STARTED
                            });

                            _context5.prev = 1;
                            _context5.next = 4;
                            return _AmazonLoginService2.default.unlinkAccount();

                        case 4:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_STATUS,
                                status: _AppConstants.AmazonLoginStatus.UNLINK_SUCCESS
                            });
                            _context5.next = 10;
                            break;

                        case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5['catch'](1);
                            throw _context5.t0;

                        case 10:
                            _context5.prev = 10;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_FINISHED
                            });
                            return _context5.finish(10);

                        case 13:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[1, 7, 10, 13]]);
        }));

        function unlinkAccount() {
            return _ref8.apply(this, arguments);
        }

        return unlinkAccount;
    }()
};

exports.default = AmazonLoginActions;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(130);
var global = __webpack_require__(36);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(179) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(132);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(31);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(31);
var aFunction = __webpack_require__(93);
var SPECIES = __webpack_require__(56)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 300 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(135).f;
var has = __webpack_require__(184);
var TAG = __webpack_require__(94)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 302 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(373)('meta');
var isObject = __webpack_require__(103);
var has = __webpack_require__(184);
var setDesc = __webpack_require__(135).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(183)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1425),
    isObjectLike = __webpack_require__(104);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1428),
    baseUnary = __webpack_require__(350),
    nodeUtil = __webpack_require__(379);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1465),
    Map = __webpack_require__(508),
    Promise = __webpack_require__(1466),
    Set = __webpack_require__(757),
    WeakMap = __webpack_require__(758),
    baseGetTag = __webpack_require__(152),
    toSource = __webpack_require__(749);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(250),
    arrayMap = __webpack_require__(288),
    isArray = __webpack_require__(68),
    isSymbol = __webpack_require__(308);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(778),
    isObject = __webpack_require__(77),
    isSymbol = __webpack_require__(308);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1495), __esModule: true };

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(288),
    baseIteratee = __webpack_require__(102),
    baseMap = __webpack_require__(1497),
    isArray = __webpack_require__(68);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(765);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _desc, _value, _obj;

var _momentTimezone = __webpack_require__(235);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semver = __webpack_require__(599);

var _semver2 = _interopRequireDefault(_semver);

var _LinkMapper = __webpack_require__(8);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _appVersion = __webpack_require__(351);

var _appVersion2 = _interopRequireDefault(_appVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

/**
 * Adapted from Modernizr
 */
var localStorageAvailable = function supportsLocalStorage() {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}();

/**
 * Decorator, if localStorage is not available, short-circuit and return null
 */
function checkLocalStorage(target, name, descriptor) {
    var original = descriptor.value;
    descriptor.value = function () {
        if (!localStorageAvailable) {
            return null;
        }
        return original.apply(this, arguments);
    };
    return descriptor;
}

function getVersionRange() {
    var major = _semver2.default.major(_appVersion2.default.versionWithoutHotfix);
    var minor = _semver2.default.minor(_appVersion2.default.versionWithoutHotfix);

    return '~' + major + '.' + minor;
}

var LocalStorageHelper = (_obj = {
    getNamespacedKey: function getNamespacedKey(key) {
        var namespace = _config2.default.get('namespace');
        return namespace ? namespace + '-' + key : key;
    },


    /**
     * The default check as to whether stored data is allowed to be used.
     * Returns true if valid
     * @param  {Object} storedData  Object containing `version`, `expires`, `data` keys
     * @return {Boolean}
     */
    isValidStoredVersion: function isValidStoredVersion(_ref) {
        var version = _ref.version;

        return _semver2.default.satisfies(version, getVersionRange());
    },
    getExpiry: function getExpiry(key) {
        var wrappedSource = localStorage.getItem(this.getNamespacedKey(key));

        if (!wrappedSource) {
            return null;
        }

        var wrapped = JSON.parse(wrappedSource);
        return wrapped.expires ? (0, _momentTimezone2.default)(wrapped.expires) : null;
    },
    getItem: function getItem(key) {
        var validateStoredData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LocalStorageHelper.isValidStoredVersion;

        try {
            var wrappedSource = localStorage.getItem(this.getNamespacedKey(key));

            if (!wrappedSource) {
                return null;
            }

            var wrapped = JSON.parse(wrappedSource);
            var expires = wrapped.expires ? (0, _momentTimezone2.default)(wrapped.expires) : false;

            //Return nothing if the key has expired
            if (expires && _momentTimezone2.default.isMoment(expires)) {
                var now = (0, _momentTimezone2.default)();
                if (expires.isBefore(now)) {
                    return null;
                }
            }

            //Return nothing if stored data is not valid (i.e. from an old version)
            if (!wrapped.version || !validateStoredData(wrapped)) {
                return null;
            }

            return wrapped.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    setItem: function setItem(key, data) {
        var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var wrapped = {
            version: _appVersion2.default.versionWithoutHotfix,
            data: data,
            expires: false
        };

        if (expires !== false) {
            wrapped.expires = (0, _momentTimezone2.default)().add(expires, 'seconds').format();
        }

        //Try to set the key, if it fails remove it as we could be out of storage
        //so clean up to avoid inconsistent state
        try {
            return localStorage.setItem(this.getNamespacedKey(key), (0, _stringify2.default)(wrapped));
        } catch (e) {
            console.error('LocalStorage error', e);
            console.log('DEBUG key', key);
            return this.removeItem(this.getNamespacedKey(key));
        }
    },
    objectFromLocalStorage: function objectFromLocalStorage(key, type, validateStoredData) {

        var value = this.getItem(key, validateStoredData);

        if (value) {
            return type ? (0, _LinkMapper.resolve)(value).as(type) : value;
        }

        return null;
    },
    objectToLocalStorage: function objectToLocalStorage(key, object) {
        var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


        var value = (0, _result3.default)(object, 'toJS', object);

        return this.setItem(key, value, expires);
    },
    removeItem: function removeItem(key) {
        return localStorage.removeItem(this.getNamespacedKey(key));
    },


    //Set whether localStorage is available, useful for tests
    forceAvailable: function forceAvailable() {
        var available = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        localStorageAvailable = available;
    }
}, (_applyDecoratedDescriptor(_obj, 'getExpiry', [checkLocalStorage], (0, _getOwnPropertyDescriptor2.default)(_obj, 'getExpiry'), _obj), _applyDecoratedDescriptor(_obj, 'getItem', [checkLocalStorage], (0, _getOwnPropertyDescriptor2.default)(_obj, 'getItem'), _obj), _applyDecoratedDescriptor(_obj, 'setItem', [checkLocalStorage], (0, _getOwnPropertyDescriptor2.default)(_obj, 'setItem'), _obj), _applyDecoratedDescriptor(_obj, 'objectFromLocalStorage', [checkLocalStorage], (0, _getOwnPropertyDescriptor2.default)(_obj, 'objectFromLocalStorage'), _obj), _applyDecoratedDescriptor(_obj, 'objectToLocalStorage', [checkLocalStorage], (0, _getOwnPropertyDescriptor2.default)(_obj, 'objectToLocalStorage'), _obj), _applyDecoratedDescriptor(_obj, 'removeItem', [checkLocalStorage], (0, _getOwnPropertyDescriptor2.default)(_obj, 'removeItem'), _obj)), _obj);

exports.default = LocalStorageHelper;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1539)
var ieee754 = __webpack_require__(1540)
var isArray = __webpack_require__(1541)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hoek = __webpack_require__(96);
var Ref = __webpack_require__(153);

// Type modules are delay-loaded to prevent circular dependencies


// Declare internals

var internals = {
    any: null,
    date: __webpack_require__(531),
    string: __webpack_require__(802),
    number: __webpack_require__(804),
    boolean: __webpack_require__(805),
    alt: null,
    object: null
};

exports.schema = function (config) {

    internals.any = internals.any || new (__webpack_require__(137))();
    internals.alt = internals.alt || __webpack_require__(532);
    internals.object = internals.object || __webpack_require__(806);

    if (config !== undefined && config !== null && (typeof config === 'undefined' ? 'undefined' : (0, _typeof3.default)(config)) === 'object') {

        if (config.isJoi) {
            return config;
        }

        if (Array.isArray(config)) {
            return internals.alt.try(config);
        }

        if (config instanceof RegExp) {
            return internals.string.regex(config);
        }

        if (config instanceof Date) {
            return internals.date.valid(config);
        }

        return internals.object.keys(config);
    }

    if (typeof config === 'string') {
        return internals.string.valid(config);
    }

    if (typeof config === 'number') {
        return internals.number.valid(config);
    }

    if (typeof config === 'boolean') {
        return internals.boolean.valid(config);
    }

    if (Ref.isRef(config)) {
        return internals.any.valid(config);
    }

    Hoek.assert(config === null, 'Invalid schema content:', config);

    return internals.any.valid(null);
};

exports.ref = function (id) {

    return Ref.isRef(id) ? id : Ref.create(id);
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var Route = new _immutable.Record({
    id: null,
    name: null,
    code: null,
    description: null
});

Route.fromJSON = function (json) {
    json = json || {};

    var name = (0, _LinkMapper.resolve)(json.name).with(String);
    var code = (0, _LinkMapper.resolve)(json.code).with(String);
    var description = (0, _LinkMapper.resolve)(json.description).with(String);

    var result = { name: name, code: code, description: description };

    return new Route(result);
};

exports.default = Route;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(432);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1702),
    hasUnicode = __webpack_require__(259),
    unicodeToArray = __webpack_require__(1703);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 323 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(884);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _includes2 = __webpack_require__(535);

var _includes3 = _interopRequireDefault(_includes2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _uniq2 = __webpack_require__(619);

var _uniq3 = _interopRequireDefault(_uniq2);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _CustomDuration = __webpack_require__(823);

var _CustomDuration2 = _interopRequireDefault(_CustomDuration);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _SearchMixin = __webpack_require__(538);

var _SearchMixin2 = _interopRequireDefault(_SearchMixin);

var _SearchUrls = __webpack_require__(97);

var _FareOnlySearchPreferences = __webpack_require__(824);

var _FareOnlySearchPreferences2 = _interopRequireDefault(_FareOnlySearchPreferences);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    origin: new _Station2.default(),
    destination: new _Station2.default(),
    dates: new _CustomDuration2.default().setDuration({
        days: 11,
        months: 1
    }),
    passengerType: _AppConstants.PassengerTypes.ADULT,
    flexi: _FeatureFlagStore2.default.get('enableFlexiSeasonTickets'),
    weekly: _FeatureFlagStore2.default.get('enableWeeklySeasonTickets'),
    fourWeekly: false,
    monthly: true,
    quarterly: false,
    sixMonthly: false,
    annual: true,
    custom: false,
    railcard1617: null,
    railcardJobCentrePlus: null,
    railcardCode: null,
    submitted: false,
    searchPreferences: new _FareOnlySearchPreferences2.default(),
    showAdditionalRoutes: false,
    promoCode: new _PromoCode2.default(),
    orderId: null,
    isRailcard1617Checked: false
};

var ISO_WEEKEND_DAYS = [6, 7];

var SeasonSearch = function (_record) {
    (0, _inherits3.default)(SeasonSearch, _record);

    function SeasonSearch() {
        (0, _classCallCheck3.default)(this, SeasonSearch);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SeasonSearch.prototype.serialize = function serialize() {
        var railcardJobCentrePlus = this.railcardJobCentrePlus;


        var params = (0, _SearchUrls.serialize)({
            origin: _SearchUrls.serializers.station,
            destination: _SearchUrls.serializers.station,
            passengerType: _SearchUrls.serializers.identity,
            railcardCode: function railcardCode(code) {
                return (0, _uniq3.default)([code, railcardJobCentrePlus ? _AppConstants.JOB_CENTRE_PLUS_RAILCARD_CODE : null].filter(function (x) {
                    return Boolean(x);
                })).join(',');
            },
            startDate: _SearchUrls.serializers.durationStartDate('dates'),
            duration: _SearchUrls.serializers.durations('dates'),
            promoCode: _SearchUrls.serializers.promoCode
        }, this);

        var querySchema = {
            searchPreferences: function searchPreferences(preferences) {
                return preferences.toString();
            },
            showAdditionalRoutes: _SearchUrls.serializers.boolean,
            promoCode: _SearchUrls.serializers.promoCode,
            isRailcard1617Checked: function isRailcard1617Checked(_isRailcard1617Checked) {
                return _isRailcard1617Checked;
            }
        };

        var query = (0, _SearchUrls.serialize)(querySchema, this);

        return {
            params: params,
            query: query
        };
    };

    SeasonSearch.prototype.toFareOnlyJSON = function toFareOnlyJSON() {
        var _this2 = this;

        return (0, _SearchUrls.serialize)({
            origin: function origin(station) {
                return station.nlc;
            },
            destination: function destination(station) {
                return station.nlc;
            },
            outward: _SearchUrls.serializers.durationStartDate('dates'),
            adult: function adult() {
                return _this2.passengerType === _AppConstants.PassengerTypes.ADULT;
            },
            railcards: function railcards() {
                return _SearchUrls.serializers.identity(_this2.railcardCode);
            },
            searchPreferences: function searchPreferences(_searchPreferences) {
                return _searchPreferences.toJSON();
            },
            promoCode: function promoCode(_promoCode) {
                return _promoCode ? _promoCode.promoCode : null;
            }
        }, this);
    };

    SeasonSearch.prototype.isAdult = function isAdult() {
        return this.passengerType === _AppConstants.PassengerTypes.ADULT;
    };

    SeasonSearch.prototype.validateHasDuration = function validateHasDuration() {
        var durations = ['flexi', 'weekly', 'fourWeekly', 'monthly', 'quarterly', 'sixMonthly', 'annual', 'custom'];
        return (0, _compact3.default)((0, _values3.default)((0, _pick3.default)(this, durations))).length >= 1;
    };

    SeasonSearch.prototype.validateDatesInFuture = function validateDatesInFuture() {
        return this.getStartDate() && this.getStartDate().isSameOrAfter((0, _TrainTime2.default)(), 'day');
    };

    SeasonSearch.prototype.validateDateLessThanMax = function validateDateLessThanMax() {
        var max = (0, _TrainTime2.default)().add(_TrainTime2.default.duration(_config2.default.get('maxSeasonStartPeriod')));
        return this.getStartDate() && this.getStartDate().isSameOrBefore(max, 'day');
    };

    SeasonSearch.prototype.validateRailcard1617 = function validateRailcard1617() {
        var railcard1617 = this.railcard1617;

        if (railcard1617 && railcard1617.isPresent() && this.dates.getEndDate()) {
            var endDate = this.dates.getEndDate().clone();

            if (endDate.isSameOrAfter(railcard1617.getMaximumValidDate())) {
                return false;
            }
        }

        return true;
    };

    SeasonSearch.prototype.isAnnualAvailable = function isAnnualAvailable() {
        if (this.railcard1617 && this.railcard1617.isPresent()) {
            var startDate = this.getStartDate() ? this.getStartDate().clone() : (0, _TrainTime2.default)();
            var lastDayOfAnnualTicket = startDate.add({ years: 1 }).subtract({ days: 1 });

            return this.railcard1617.getMaximumValidDate().isSameOrAfter(lastDayOfAnnualTicket);
        }

        return true;
    };

    SeasonSearch.prototype.isValid = function isValid() {
        return this.getValidationErrors().isEmpty();
    };

    SeasonSearch.prototype.getValidationErrors = function getValidationErrors() {
        var _this3 = this;

        var tests = (0, _immutable.Set)(['validateStationsComplete', 'validateStationsNotEqual', 'validateHasDuration', 'validateDatesInFuture', 'validateDateLessThanMax', 'validateRailcard1617']);

        return tests.filterNot(function (test) {
            return _this3[test]();
        });
    };

    SeasonSearch.prototype.refreshDates = function refreshDates() {

        var now = (0, _TrainTime2.default)();
        var dates = this.dates || defaults.dates;

        if (this.getStartDate()) {
            if (dates.getStartDate().isBefore(now)) {
                return this.set('dates', dates.setStartDate((0, _TrainTime2.default)().startOf('day')));
            }
        }

        return this;
    };

    SeasonSearch.prototype.hasPromoCode = function hasPromoCode() {
        return !!this.getPromoCode();
    };

    SeasonSearch.prototype.getPromoCode = function getPromoCode() {
        return this.promoCode && this.promoCode.promoCode;
    };

    SeasonSearch.prototype.setPromoCode = function setPromoCode(promo) {
        return this.set('promoCode', promo);
    };

    SeasonSearch.prototype.isInFlexiLimbo = function isInFlexiLimbo() {
        // Temporary method. Can remove this & all related code after 28-June 2021
        return this.getStartDate().isBefore((0, _TrainTime2.default)('2021-06-28'));
    };

    SeasonSearch.prototype.getStartDate = function getStartDate() {
        return this.dates.getStartDate();
    };

    SeasonSearch.prototype.setStartDate = function setStartDate(date) {
        return this.set('dates', this.dates.setStartDate(date));
    };

    SeasonSearch.prototype.refreshFilters = function refreshFilters() {
        var search = this;
        if (this.disableFilters()) {
            search = this.merge({
                flexi: false,
                fourWeekly: false,
                monthly: false,
                annual: false,
                custom: false,
                sixMonthly: false,
                quarterly: false
            });
        }
        return search;
    };

    /**
     * Returns the next possible delivery date, taking into account weekends, from
     * a given moment in time.
     *
     * @param  {Moment} datetime
     * @return {Moment}
     */


    SeasonSearch.prototype.getNextDeliveryDateFrom = function getNextDeliveryDateFrom(datetime) {
        var leadTimeInDays = _config2.default.get('minDeliveryLeadTimeInDays');
        var nextDeliveryDate = datetime.clone().startOf('day');

        if (datetime.hour() >= _config2.default.get('pivotalPostalHour')) {
            nextDeliveryDate = nextDeliveryDate.clone().add(1, 'day');
        }

        while (leadTimeInDays > 0) {
            nextDeliveryDate = nextDeliveryDate.clone().add(1, 'day');
            leadTimeInDays--;

            if ((0, _includes3.default)(ISO_WEEKEND_DAYS, nextDeliveryDate.isoWeekday())) {
                leadTimeInDays++; // Add leadtime for weekend days
            }
        }

        return nextDeliveryDate.clone();
    };

    /**
     * Returns the next possible start date for a season ticket, based on its type using
     * the duration of its validity. Monthly and annual season tickets must be posted to the
     * customer for revenue protection reasons - weekly season tickets can be collected via TOD.
     *
     * @param  {Moment.Duration} duration
     * @return {Moment}
     */


    SeasonSearch.prototype.getNextPossibleStartDate = function getNextPossibleStartDate(duration) {
        if (duration.months() > 0 || duration.years() > 0) {
            return this.getNextDeliveryDateFrom((0, _TrainTime2.default)());
        } else {
            return (0, _TrainTime2.default)().startOf('day').clone();
        }
    };

    SeasonSearch.prototype.disableFilters = function disableFilters() {
        return (0, _TrainTime2.default)().addWorkingDays(3) > this.getStartDate();
    };

    SeasonSearch.prototype.getMinDate = function getMinDate() {
        return this.getNextDeliveryDateFrom((0, _TrainTime2.default)());
    };

    SeasonSearch.prototype.getMaxDate = function getMaxDate() {
        var maxPeriod = _config2.default.get('maxSeasonStartPeriod');

        return (0, _TrainTime2.default)().add(_TrainTime2.default.duration(maxPeriod));
    };

    SeasonSearch.prototype.getRouteOptions = function getRouteOptions() {
        var options = _config2.default.get('journeySelectorOptions');
        var additionalOptions = _config2.default.get('journeySelectorAdditionalOptions');
        if (this.showAdditionalRoutes) {
            return options.concat(additionalOptions);
        }
        return options;
    };

    SeasonSearch.prototype.matchesRouteOptions = function matchesRouteOptions() {
        var _this4 = this;

        // where options is a List of Lists which contain a pair of CRSs
        // (see journeySelectorOptions in config)
        return this.getRouteOptions().some(function (option) {
            return option.get(0) === _this4.origin.crs && option.get(1) === _this4.destination.crs;
        });
    };

    SeasonSearch.deserialize = function deserialize(params, query) {
        var source = (0, _assign2.default)({}, query, params);

        var _railcardCode = source.railcardCode;


        var schema = {
            origin: _SearchUrls.deserializers.station,
            destination: _SearchUrls.deserializers.station,
            passengerType: _SearchUrls.deserializers.identity,
            railcardCode: function railcardCode() {
                var _ref;

                return _railcardCode && _railcardCode.split(',').includes(_AppConstants.RAILCARD1617_CODE) ? (_ref = {}, _ref['railcardCode'] = _AppConstants.RAILCARD1617_CODE, _ref) : null;
            },
            duration: _SearchUrls.deserializers.durations,
            searchPreferences: function searchPreferences(value, data, name) {
                var _ref2;

                return _ref2 = {}, _ref2[name] = _FareOnlySearchPreferences2.default.fromString(value), _ref2;
            },
            showAdditionalRoutes: _SearchUrls.deserializers.boolean,
            railcardJobCentrePlus: function railcardJobCentrePlus() {
                var _ref3;

                return _railcardCode && _railcardCode.split(',').includes(_AppConstants.JOB_CENTRE_PLUS_RAILCARD_CODE) ? (_ref3 = {}, _ref3['railcardJobCentrePlus'] = true, _ref3) : null;
            },
            promoCode: _SearchUrls.deserializers.promoCode
        };

        return (0, _SearchUrls.deserialize)(schema, source).then(function (deserialized) {
            return new SeasonSearch(deserialized);
        });
    };

    SeasonSearch.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(SeasonSearch, json, {
            origin: _LinkMapper.resolve.as(_Station2.default),
            destination: _LinkMapper.resolve.as(_Station2.default),
            passengerType: _LinkMapper.resolve.with(String),
            railcardCode: _LinkMapper.resolve.with(String),
            dates: _LinkMapper.resolve.as(_CustomDuration2.default),
            flexi: _LinkMapper.resolve.with(Boolean),
            weekly: _LinkMapper.resolve.with(Boolean),
            monthly: _LinkMapper.resolve.with(Boolean),
            annual: _LinkMapper.resolve.with(Boolean),
            custom: _LinkMapper.resolve.with(Boolean),
            submitted: _LinkMapper.resolve.with(Boolean),
            searchPreferences: _LinkMapper.resolve.as(_FareOnlySearchPreferences2.default),
            showAdditionalRoutes: _LinkMapper.resolve.with(Boolean)
        });
    };

    SeasonSearch.fromFare = function fromFare(fare) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var validity = fare.getOutwardValidityPeriod();
        var custom = validity.isCustom();
        var match = validity.matchDurationType.bind(validity);
        var duration = validity.toDuration();
        if (!date) {
            var _search = new SeasonSearch();
            date = _search.getNextPossibleStartDate(duration);
        }
        var search = new SeasonSearch({
            origin: fare.origin,
            destination: fare.destination,
            dates: new _CustomDuration2.default({ startDate: date }).setDuration({ months: 1 }),
            passengerType: fare.children() ? _AppConstants.PassengerTypes.CHILD : _AppConstants.PassengerTypes.ADULT,
            weekly: match(_AppConstants.DurationTypes.WEEKLY),
            fourWeekly: match(_AppConstants.DurationTypes.FOUR_WEEKLY),
            monthly: match(_AppConstants.DurationTypes.MONTHLY),
            quarterly: match(_AppConstants.DurationTypes.QUARTERLY),
            sixMonthly: match(_AppConstants.DurationTypes.SIX_MONTHLY),
            annual: match(_AppConstants.DurationTypes.ANNUAL),
            custom: custom,
            searchPreferences: _FareOnlySearchPreferences2.default.fromFare(fare)
        });

        if (custom) {
            search = search.set('dates', search.dates.setDuration(duration));
        }

        return search;
    };

    /**
     * @param {Favourite} favourite
     * @param {trainTime} date
     * @return {SeasonSearch}
     */


    SeasonSearch.fromFavourite = function fromFavourite(favourite) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var duration = favourite.getDuration();
        var validity = favourite.getOutwardValidityPeriod();
        var custom = validity.isCustom();
        var match = validity.matchDurationType.bind(validity);
        if (!date) {
            var _search2 = new SeasonSearch();
            date = _search2.getNextPossibleStartDate(duration);
        }
        var search = new SeasonSearch({
            origin: favourite.origin,
            destination: favourite.destination,
            dates: new _CustomDuration2.default({ startDate: date }).setDuration({ months: 1 }),
            passengerType: favourite.children ? _AppConstants.PassengerTypes.CHILD : _AppConstants.PassengerTypes.ADULT,
            railcardCode: favourite.railcards.map(function (_ref4) {
                var code = _ref4.code;
                return code;
            }),
            weekly: match(_AppConstants.DurationTypes.WEEKLY),
            fourWeekly: match(_AppConstants.DurationTypes.FOUR_WEEKLY),
            monthly: match(_AppConstants.DurationTypes.MONTHLY),
            quarterly: match(_AppConstants.DurationTypes.QUARTERLY),
            sixMonthly: match(_AppConstants.DurationTypes.SIX_MONTHLY),
            annual: match(_AppConstants.DurationTypes.ANNUAL),
            custom: custom,
            searchPreferences: _FareOnlySearchPreferences2.default.fromFavourite(favourite)
        });

        if (custom) {
            search = search.set('dates', search.dates.setDuration(duration));
        }

        return search;
    };

    SeasonSearch.fromReorderable = function fromReorderable(reorderable) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (reorderable instanceof _Fare2.default) {
            return SeasonSearch.fromFare(reorderable, date);
        } else if (reorderable instanceof _Favourite2.default) {
            return SeasonSearch.fromFavourite(reorderable, date);
        }

        return null;
    };

    SeasonSearch.prototype.getJsonForJourneyNotification = function getJsonForJourneyNotification() {
        return {
            origin: this.origin.nlc,
            destination: this.destination.nlc,
            startDate: this.getStartDate().format('YYYY-MM-DD HH:mm:ss'),
            adult: this.passengerType === 'adult',
            child: this.passengerType === 'child'
        };
    };

    return SeasonSearch;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(SeasonSearch.prototype, _SearchMixin2.default);

exports.default = SeasonSearch;

/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(315),
    eq = __webpack_require__(253);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _tail2 = __webpack_require__(545);

var _tail3 = _interopRequireDefault(_tail2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _AppConstants = __webpack_require__(6);

var _Railcard = __webpack_require__(241);

var _Railcard2 = _interopRequireDefault(_Railcard);

var _SmartcardProduct = __webpack_require__(1053);

var _SmartcardProduct2 = _interopRequireDefault(_SmartcardProduct);

var _KeyGo = __webpack_require__(1757);

var _KeyGo2 = _interopRequireDefault(_KeyGo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    reference: [_LinkMapper.fields.string],
    cardType: [_LinkMapper.fields.string],
    cardStatus: [_LinkMapper.fields.string],
    expiryDate: [_LinkMapper.fields.datetime],
    isrn: [_LinkMapper.fields.string],
    cardDescription: [_LinkMapper.fields.string],
    availableForMoreProducts: [_LinkMapper.fields.boolean],
    passengerType: [_LinkMapper.fields.string],
    productAvailability: [_LinkMapper.fields.number],
    replacementInProgress: [_LinkMapper.fields.boolean],
    products: [_LinkMapper.resolveAll.as(_SmartcardProduct2.default), new _immutable.List()],
    railcard: [_LinkMapper.resolve.as(_Railcard2.default)],
    autoDrOptedIn: [_LinkMapper.fields.boolean],
    keyGo: [_LinkMapper.resolve.as(_KeyGo2.default)],
    cardHolderDateOfBirth: [_LinkMapper.fields.string]
};

var Smartcard = function (_record) {
    (0, _inherits3.default)(Smartcard, _record);

    function Smartcard() {
        (0, _classCallCheck3.default)(this, Smartcard);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Smartcard.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(Smartcard, json, (0, _Records.getResolvers)(schema));
    };

    Smartcard.prototype.getStatus = function getStatus() {
        return (this.get('cardStatus') || '').toUpperCase();
    };

    Smartcard.prototype.getCardNumber = function getCardNumber() {
        var isrn = this.isrn;

        var re = /(\d{6})(\d{4})(\d{4})(\d{4})/;
        var match = isrn && isrn.match(re);
        if (match) {
            return (0, _tail3.default)(match).join('-');
        }
        return null;
    };

    Smartcard.prototype.isActive = function isActive() {
        var status = this.getStatus();
        return status === _AppConstants.SmartcardStatus.ACTIVE || status === _AppConstants.SmartcardStatus.HOTLIST_ERROR;
    };

    Smartcard.prototype.isPending = function isPending() {
        return this.getStatus() === _AppConstants.SmartcardStatus.PENDING;
    };

    Smartcard.prototype.isHotlisted = function isHotlisted() {
        var status = this.getStatus();
        return status === _AppConstants.SmartcardStatus.HOTLISTED || status === _AppConstants.SmartcardStatus.HOTLIST_REQUESTED || status === _AppConstants.SmartcardStatus.HOTLIST_ACCEPTED || status === _AppConstants.SmartcardStatus.HOTLIST_LIVE;
    };

    Smartcard.prototype.isReplacementPending = function isReplacementPending() {
        return this.isPending() || this.getStatus() === _AppConstants.SmartcardStatus.REQUESTED; // SEFT is `REQUESTED`
    };

    Smartcard.prototype.isAwaitingProduct = function isAwaitingProduct() {
        return this.getStatus() === _AppConstants.SmartcardStatus.AWAITING_PRODUCT;
    };

    Smartcard.prototype.canSearchForProducts = function canSearchForProducts() {
        return this.isActive() || this.isAwaitingProduct();
    };

    //  A smartcard can load a product if its ACTIVE
    //  or if its preregistered, and awaiting a product to be loaded before it is created


    Smartcard.prototype.canLoadProduct = function canLoadProduct() {
        return this.isAwaitingProduct() || this.isActive() && this.get('availableForMoreProducts');
    };

    Smartcard.prototype.isActiveAndAvailableForMoreProducts = function isActiveAndAvailableForMoreProducts() {
        return this.isActive() && this.get('availableForMoreProducts');
    };

    Smartcard.prototype.isFull = function isFull() {
        return this.get('productAvailability') === 0;
    };

    Smartcard.prototype.getKeyGo = function getKeyGo() {
        return this.keyGo;
    };

    Smartcard.prototype.canRegisterKeyGo = function canRegisterKeyGo() {
        var keyGo = this.getKeyGo();
        return !keyGo || keyGo && keyGo.isClosed();
    };

    Smartcard.prototype.hasKeyGo = function hasKeyGo() {
        return this.getKeyGo() && (this.getKeyGo().isActive() || this.getKeyGo().isPendingClosure());
    };

    Smartcard.prototype.hasActiveKeyGo = function hasActiveKeyGo() {
        return this.getKeyGo() && (this.getKeyGo().isActive() || this.getKeyGo().isPending());
    };

    Smartcard.prototype.getAllKeyGoProducts = function getAllKeyGoProducts() {
        var keyGoProducts = this.products.filter(function (product) {
            return product.isKeyGo();
        });
        return keyGoProducts.sort(function (a, b) {
            return a.parameters.IssueDate.isAfter(b.parameters.IssueDate) ? -1 : 1;
        });
    };

    Smartcard.prototype.getKeyGoProduct = function getKeyGoProduct() {
        return this.getAllKeyGoProducts() && this.getAllKeyGoProducts().get(0);
    };

    Smartcard.prototype.getPendingProducts = function getPendingProducts() {
        var statuses = _AppConstants.SmartcardProductStatusGroup.PENDING;
        return this.products.filter(function (product) {
            return statuses.includes(product.status);
        });
    };

    Smartcard.prototype.getCurrentProducts = function getCurrentProducts() {
        var statuses = _AppConstants.SmartcardProductStatusGroup.CURRENT;
        return this.products.filter(function (product) {
            return statuses.includes(product.status);
        });
    };

    Smartcard.prototype.isChild = function isChild() {
        var passengerType = this.get('passengerType');
        return passengerType && passengerType.toLowerCase() === _AppConstants.PassengerTypes.CHILD;
    };

    Smartcard.prototype.canActivate = function canActivate() {
        return this.isActive() && this.products.isEmpty();
    };

    Smartcard.prototype.hasProductsForOrder = function hasProductsForOrder(orderId) {
        return this.products.some(function (product) {
            return product.getOrderId() === Number(orderId);
        });
    };

    Smartcard.prototype.getSecondsUntilAdult = function getSecondsUntilAdult() {
        if (!this.cardHolderDateOfBirth) {
            return null;
        }
        var today = (0, _moment2.default)();
        var adulthoodDate = (0, _moment2.default)(this.cardHolderDateOfBirth).add(16, 'years');
        return adulthoodDate.diff(today, 'seconds');
    };

    Smartcard.prototype.willBeAdultInLessThanAMonth = function willBeAdultInLessThanAMonth() {
        if (!this.cardHolderDateOfBirth) {
            return false;
        }
        var ageInMonths = (0, _moment2.default)().diff(this.cardHolderDateOfBirth, 'months');
        var fifteenYearsElevenMonths = 191;
        return ageInMonths === fifteenYearsElevenMonths;
    };

    return Smartcard;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = Smartcard;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.MULTI_LEGS_TYPE = exports.CONTACT_METHODS = exports.EDIT_PA_SECTION_NAMES = exports.EDIT_PA_SECTION_INDEXES = exports.ASSIST_REQUEST_STATUS = exports.BOOKING_PA_STATUSES = exports.CREATE_ACCESSIBILITY_PROFILE_ADDRESS = exports.CREATING_AP_PREFERENCES = exports.BOOKING_PA_PREFERENCES = exports.assistanceReasons = exports.assistanceLocationOther = exports.assistanceLocationConfig = exports.BOOK_PA_RETURN_JOURNEY_STEPS = exports.BOOK_PA_STEPS = exports.ACCESSIBILITY_PROFILE_STEPS = exports.ACCESSIBILITY_PROFILE_STATUSES = undefined;

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACCESSIBILITY_PROFILE_STATUSES = exports.ACCESSIBILITY_PROFILE_STATUSES = (0, _keymirror2.default)({
    CREATE: null,
    CREATED: null,
    EDIT: null,
    VIEW: null
});

var ACCESSIBILITY_PROFILE_STEPS = exports.ACCESSIBILITY_PROFILE_STEPS = {
    PERSONAL_DETAILS: {
        index: 0,
        title: 'Personal Details'
    },
    ASSISTANCE_POINT: {
        index: 1,
        title: 'Assistance Point'
    },
    REASON_FOR_ASSISTANCE: {
        index: 2,
        title: 'Reasons for assistance'
    },
    CONTACT_PREFERENCES: {
        index: 3,
        title: 'Contact preferences'
    },
    SUMMARY: {
        index: 4,
        title: 'Summary'
    }
};

var BOOK_PA_STEPS = exports.BOOK_PA_STEPS = {
    PERSONAL_DETAILS: {
        index: 0,
        title: 'Personal Details'
    },
    WHEN: {
        index: 1,
        title: 'When'
    },
    TRAIN: {
        index: 2,
        title: 'Train'
    },
    RETURN: {
        index: 3,
        title: 'Return'
    },
    PREFERENCES: {
        index: 4,
        title: 'Preferences'
    },
    SUMMARY: {
        index: 5,
        title: 'Summary'
    }
};

var BOOK_PA_RETURN_JOURNEY_STEPS = exports.BOOK_PA_RETURN_JOURNEY_STEPS = {
    QUESTION: 0,
    WHEN: 1,
    TRAIN: 2
};

var assistanceLocationConfig = exports.assistanceLocationConfig = [{
    label: 'All points (change of train is required)',
    value: 'all_points'
}, {
    label: 'Arrival station',
    value: 'arrival_station_only'
}, {
    label: 'Departure station',
    value: 'departure_station_only'
}, {
    label: 'Other',
    value: 'other'
}];

var assistanceLocationOther = exports.assistanceLocationOther = 'other';

var assistanceReasons = exports.assistanceReasons = {
    VISUALLY_IMPAIRED: {
        label: 'Visually Impaired',
        value: 'Visually Impaired'
    },
    ELDERLY: {
        label: 'Older Person',
        value: 'Elderly'
    },
    HEARING_IMPAIRED: {
        label: 'Hearing Impaired',
        value: 'Hearing Impaired'
    },
    LEARNING_DISABILITY: {
        label: 'Learning Disability',
        value: 'Learning Disability'
    },
    VERBALLY_IMPAIRED: {
        label: 'Verbally Impaired',
        value: 'Verbally Impaired'
    },
    OWN_WHEELCHAIR_USER: {
        label: 'Own Wheelchair User - help with transfer to seat',
        value: 'Own Wheelchair User - help with transfer to seat'
    },
    STATION_WHEELCHAIR_USER: {
        label: 'Station Wheelchair User - help with transfer to seat',
        value: 'Station Wheelchair User - help with transfer to seat'
    },
    PERMANENT_WHEELCHAIR_USER: {
        label: 'Permanent Wheelchair User',
        value: 'Permanent Wheelchair User'
    },
    SCOOTER_USER: {
        label: 'Scooter User',
        value: 'Scooter User'
    },
    MOBILITY_IMPAIRED_NO_RAMP: {
        label: 'Mobility Impaired - no ramp',
        value: 'Mobility Impaired - no ramp'
    },
    MOBILITY_IMPAIRED_WITH_RAMP: {
        label: 'Mobility Impaired - ramp needed',
        value: 'Mobility Impaired - ramp needed'
    },
    OTHER_PHYSICAL_CONDITION: {
        label: 'Other Physical Condition',
        value: 'Other Physical Condition'
    },
    OTHER: {
        label: 'Other',
        value: 'Other'
    }
};

var BOOKING_PA_PREFERENCES = exports.BOOKING_PA_PREFERENCES = [{
    question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.1',
    positiveAnswerLabel: 'Yes',
    negativeAnswerLabel: 'No',
    formKey: 'participateSurvey'
}, {
    question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.2',
    positiveAnswerLabel: 'Yes',
    negativeAnswerLabel: 'No',
    formKey: 'pushNotify'
}, {
    question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.3',
    positiveAnswerLabel: 'Yes',
    negativeAnswerLabel: 'No',
    formKey: 'participateImprovementSurvey'
}];

var CREATING_AP_PREFERENCES = exports.CREATING_AP_PREFERENCES = [{
    question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.1',
    positiveAnswerLabel: 'Yes',
    negativeAnswerLabel: 'No',
    formKey: 'participateSurvey'
}, {
    question: 'account.passenger-assist.accessibility-profile.form.contact-preferences.question.2',
    positiveAnswerLabel: 'Yes',
    negativeAnswerLabel: 'No',
    formKey: 'pushNotify'
}];

var CREATE_ACCESSIBILITY_PROFILE_ADDRESS = exports.CREATE_ACCESSIBILITY_PROFILE_ADDRESS = 'CREATE_ACCESSIBILITY_PROFILE_ADDRESS';

var BOOKING_PA_STATUSES = exports.BOOKING_PA_STATUSES = (0, _keymirror2.default)({
    BOOK_OUTWARD_JOURNEY: null,
    BOOK_RETURN_JOURNEY: null,
    EDIT_OUTWARD_JOURNEY: null,
    EDIT_RETURN_JOURNEY: null,
    CREATED: null,
    VIEW: null
});

var ASSIST_REQUEST_STATUS = exports.ASSIST_REQUEST_STATUS = {
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    PENDING: 'Pending'
};

var EDIT_PA_SECTION_INDEXES = exports.EDIT_PA_SECTION_INDEXES = {
    PERSONAL_DETAILS: 0,
    ASSISTANCE_POINT: 1,
    REASON_FOR_ASSISTANCE: 2,
    CONTACT_PREFERENCES: 3,
    OUTWARD_JOURNEY: 4,
    RETURN_JOURNEY: 5
};

var EDIT_PA_SECTION_NAMES = exports.EDIT_PA_SECTION_NAMES = ['personal-details', 'assistance-point', 'reason-for-assistance', 'contact-preferences', 'outward-journey', 'return-journey'];

var CONTACT_METHODS = exports.CONTACT_METHODS = {
    email: 'Email',
    phone: 'Phone'
};

var MULTI_LEGS_TYPE = exports.MULTI_LEGS_TYPE = (0, _keymirror2.default)({
    HIDE: null,
    MORE_DETAILS_BUTTON: null,
    EXPANDED: null
});

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _PassengerAssistService = __webpack_require__(1916);

var _PassengerAssistService2 = _interopRequireDefault(_PassengerAssistService);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _constants = __webpack_require__(333);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAutoPopulatedAccessibilityProfileFields = function getAutoPopulatedAccessibilityProfileFields() {
    var _UserStore$getCurrent = _UserStore2.default.getCurrent(),
        title = _UserStore$getCurrent.title,
        firstName = _UserStore$getCurrent.firstNames,
        surname = _UserStore$getCurrent.surname,
        phone = _UserStore$getCurrent.telephoneNumber;

    return {
        title: title,
        firstName: firstName,
        surname: surname,
        phone: phone
    };
};

var PassengerAssistActions = {
    setAccessibilityProfileForm: function setAccessibilityProfileForm(accessibilityProfileFields) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE_FORM,
                accessibilityProfileFields: accessibilityProfileFields
            });
        });
    },
    autoPopulateAccessibilityProfileForm: function autoPopulateAccessibilityProfileForm() {
        var accessibilityProfileFields = getAutoPopulatedAccessibilityProfileFields();

        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.AUTO_POPULATE_ACCESSIBILITY_PROFILE_FORM,
                accessibilityProfileFields: accessibilityProfileFields
            });
        });
    },
    resetAccessibilityProfileForm: function resetAccessibilityProfileForm() {
        var accessibilityProfileFields = getAutoPopulatedAccessibilityProfileFields();

        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.RESET_ACCESSIBILITY_PROFILE_FORM,
                accessibilityProfileFields: accessibilityProfileFields
            });
        });
    },
    setAccessibilityProfileStatus: function setAccessibilityProfileStatus(status) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE_STATUS,
                status: status
            });
        });
    },
    setBookingPAStatus: function setBookingPAStatus(status) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_BOOKING_PA_STATUS,
                status: status
            });
        });
    },
    setUseAccessibilityProfile: function setUseAccessibilityProfile(useAccessibilityProfile) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.USE_ACCESSIBILITY_PROFILE,
                useAccessibilityProfile: useAccessibilityProfile
            });
        });
    },
    resetOutwardJourney: function resetOutwardJourney() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.RESET_OUTWARD_JOURNEY
            });
        });
    },
    resetReturnJourney: function resetReturnJourney() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.RESET_RETURN_JOURNEY
            });
        });
    },
    setBookingPAEnterAccessibilityProfileStep: function setBookingPAEnterAccessibilityProfileStep(step) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_BOOKING_PA_ENTER_ACCESSIBILITY_PROFILE_STEP,
                step: step
            });
        });
    },
    setAccessibilityProfile: function setAccessibilityProfile(accessibilityProfile) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE,
                accessibilityProfile: accessibilityProfile
            });
        });
    },
    setNextAccessibilityProfileStep: function setNextAccessibilityProfileStep() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_NEXT_ACCESSIBILITY_PROFILE_STEP
            });
        });
    },
    setPrevAccessibilityProfileStep: function setPrevAccessibilityProfileStep() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_PREV_ACCESSIBILITY_PROFILE_STEP
            });
        });
    },
    setAccessibilityProfileStep: function setAccessibilityProfileStep(step) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_ACCESSIBILITY_PROFILE_STEP,
                step: step
            });
        });
    },
    setNextBookingPAStep: function setNextBookingPAStep() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_NEXT_BOOKING_PA_STEP
            });
        });
    },
    setPrevBookingPAStep: function setPrevBookingPAStep() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_PREV_BOOKING_PA_STEP
            });
        });
    },
    setBookingPAStep: function setBookingPAStep(step) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_BOOKING_PA_STEP,
                step: step
            });
        });
    },
    setTravelAssist: function setTravelAssist(travelAssist) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_TRAVEL_ASSIST,
                travelAssist: travelAssist
            });
        });
    },
    deleteTravelAssist: function deleteTravelAssist(travelAssist) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.DELETE_TRAVEL_ASSIST,
                travelAssist: travelAssist
            });
        });
    },
    setPendingTravelAssistRequests: function setPendingTravelAssistRequests(travelAssistRequests) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_PENDING_TRAVEL_ASSIST_REQUESTS,
                travelAssistRequests: travelAssistRequests
            });
        });
    },
    setPendingTravelAssistRequestEnabled: function setPendingTravelAssistRequestEnabled(params) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_PENDING_TRAVEL_ASSIST_REQUEST_ENABLED,
                params: params
            });
        });
    },
    resetTravelAssist: function resetTravelAssist() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.RESET_TRAVEL_ASSIST
            });
        });
    },
    setIsEditPAModeEnabled: function setIsEditPAModeEnabled(isEditPAModeEnabled) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_IS_EDIT_PA_MODE_ENABLED,
                isEditPAModeEnabled: isEditPAModeEnabled
            });
        });
    },
    setEditPASection: function setEditPASection(sectionIndex) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_EDIT_PA_SECTION,
                sectionIndex: sectionIndex
            });
        });
    },
    setShowBackToSearchResultsButton: function setShowBackToSearchResultsButton(showButton) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_SHOW_BACK_TO_SEARCH_RESULTS_BUTTON,
                showButton: showButton
            });
        });
    },
    loadCreatingAccessibilityProfileProps: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var accessibilityProfile;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.resetAccessibilityProfileForm();
                            this.setAccessibilityProfileStep(_constants.ACCESSIBILITY_PROFILE_STEPS.PERSONAL_DETAILS.index);

                            _context.next = 4;
                            return this.getAccessibilityProfile();

                        case 4:
                            accessibilityProfile = _context.sent;

                            if (!accessibilityProfile) {
                                this.autoPopulateAccessibilityProfileForm();
                            }

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadCreatingAccessibilityProfileProps() {
            return _ref.apply(this, arguments);
        }

        return loadCreatingAccessibilityProfileProps;
    }(),
    resetCreatingAccessibilityProfileProps: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.setShowBackToSearchResultsButton(false);

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function resetCreatingAccessibilityProfileProps() {
            return _ref2.apply(this, arguments);
        }

        return resetCreatingAccessibilityProfileProps;
    }(),
    loadBookingPassengerAssistProps: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var accessibilityProfile;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.setUseAccessibilityProfile(true);
                            this.resetAccessibilityProfileForm();
                            this.setBookingPAEnterAccessibilityProfileStep(_constants.ACCESSIBILITY_PROFILE_STEPS.PERSONAL_DETAILS.index);
                            this.setBookingPAStep(_constants.BOOK_PA_STEPS.PERSONAL_DETAILS.index);
                            this.setBookingPAStatus(_constants.BOOKING_PA_STATUSES.BOOK_OUTWARD_JOURNEY);
                            this.resetTravelAssist();
                            this.setIsEditPAModeEnabled(false);

                            _context3.next = 9;
                            return this.getAccessibilityProfile();

                        case 9:
                            accessibilityProfile = _context3.sent;

                            this.setUseAccessibilityProfile(!!accessibilityProfile);

                        case 11:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function loadBookingPassengerAssistProps() {
            return _ref3.apply(this, arguments);
        }

        return loadBookingPassengerAssistProps;
    }(),
    resetBookingPassengerAssistProps: function resetBookingPassengerAssistProps() {
        this.setUseAccessibilityProfile(true);
    },
    getAccessibilityProfile: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var _ref5, accessibilityProfile;

            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ACCESSIBILITY_PROFILE_STARTED
                                });
                            });
                            _context4.prev = 1;
                            _context4.next = 4;
                            return _PassengerAssistService2.default.getAccessibilityProfile();

                        case 4:
                            _ref5 = _context4.sent;
                            accessibilityProfile = _ref5.result;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ACCESSIBILITY_PROFILE_LOADED,
                                    accessibilityProfile: accessibilityProfile
                                });
                            });
                            return _context4.abrupt('return', accessibilityProfile);

                        case 10:
                            _context4.prev = 10;
                            _context4.t0 = _context4['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ACCESSIBILITY_PROFILE_FAILED,
                                    err: _context4.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.get-profile.failed' });
                            return _context4.abrupt('return', null);

                        case 15:
                            _context4.prev = 15;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ACCESSIBILITY_PROFILE_FINISHED
                                });
                            });
                            return _context4.finish(15);

                        case 18:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[1, 10, 15, 18]]);
        }));

        function getAccessibilityProfile() {
            return _ref4.apply(this, arguments);
        }

        return getAccessibilityProfile;
    }(),
    createAccessibilityProfile: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(accessibilityProfile) {
            var accessibilityProfileResponse;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CREATE_ACCESSIBILITY_PROFILE_STARTED
                                });
                            });
                            _context5.prev = 1;
                            _context5.next = 4;
                            return _PassengerAssistService2.default.createAccessibilityProfile(accessibilityProfile);

                        case 4:
                            accessibilityProfileResponse = _context5.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CREATE_ACCESSIBILITY_PROFILE_LOADED,
                                    accessibilityProfile: accessibilityProfileResponse
                                });
                            });
                            return _context5.abrupt('return', accessibilityProfileResponse);

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CREATE_ACCESSIBILITY_PROFILE_FAILED,
                                    err: _context5.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.create-profile.failed' });
                            return _context5.abrupt('return', null);

                        case 14:
                            _context5.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CREATE_ACCESSIBILITY_PROFILE_FINISHED
                                });
                            });
                            return _context5.finish(14);

                        case 17:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[1, 9, 14, 17]]);
        }));

        function createAccessibilityProfile(_x) {
            return _ref6.apply(this, arguments);
        }

        return createAccessibilityProfile;
    }(),
    updateAccessibilityProfile: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(accessibilityProfile) {
            var accessibilityProfileResponse;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_ACCESSIBILITY_PROFILE_STARTED
                                });
                            });
                            _context6.prev = 1;
                            _context6.next = 4;
                            return _PassengerAssistService2.default.updateAccessibilityProfile(accessibilityProfile);

                        case 4:
                            accessibilityProfileResponse = _context6.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_ACCESSIBILITY_PROFILE_LOADED,
                                    accessibilityProfile: accessibilityProfileResponse
                                });
                            });
                            return _context6.abrupt('return', accessibilityProfileResponse);

                        case 9:
                            _context6.prev = 9;
                            _context6.t0 = _context6['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_ACCESSIBILITY_PROFILE_FAILED,
                                    err: _context6.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.update-profile.failed' });
                            return _context6.abrupt('return', null);

                        case 14:
                            _context6.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_ACCESSIBILITY_PROFILE_FINISHED
                                });
                            });
                            return _context6.finish(14);

                        case 17:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[1, 9, 14, 17]]);
        }));

        function updateAccessibilityProfile(_x2) {
            return _ref7.apply(this, arguments);
        }

        return updateAccessibilityProfile;
    }(),
    deleteAccessibilityProfile: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.DELETE_ACCESSIBILITY_PROFILE_STARTED
                                });
                            });
                            _context7.prev = 1;
                            _context7.next = 4;
                            return _PassengerAssistService2.default.deleteAccessibilityProfile();

                        case 4:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.DELETE_ACCESSIBILITY_PROFILE_SUCCESS
                                });
                            });
                            _NotificationActions2.default.showNotification('notifications.accessibility-profile.deleted');
                            return _context7.abrupt('return', true);

                        case 9:
                            _context7.prev = 9;
                            _context7.t0 = _context7['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.DELETE_ACCESSIBILITY_PROFILE_FAILED,
                                    err: _context7.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.delete-profile.failed' });
                            return _context7.abrupt('return', false);

                        case 14:
                            _context7.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.DELETE_ACCESSIBILITY_PROFILE_FINISHED
                                });
                            });
                            return _context7.finish(14);

                        case 17:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[1, 9, 14, 17]]);
        }));

        function deleteAccessibilityProfile() {
            return _ref8.apply(this, arguments);
        }

        return deleteAccessibilityProfile;
    }(),
    getPreviousJourneys: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(departureDate) {
            var previousJourneys;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_PREVIOUS_JOURNEYS_STARTED
                                });
                            });
                            _context8.prev = 1;
                            _context8.next = 4;
                            return _PassengerAssistService2.default.getPreviousJourneys(departureDate.format('DD/MM/YYYY'));

                        case 4:
                            previousJourneys = _context8.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_PREVIOUS_JOURNEYS_SUCCESS,
                                    previousJourneys: previousJourneys,
                                    departureDate: departureDate
                                });
                            });
                            return _context8.abrupt('return', previousJourneys);

                        case 9:
                            _context8.prev = 9;
                            _context8.t0 = _context8['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_PREVIOUS_JOURNEYS_FAILED,
                                    err: _context8.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.get-previous-journeys.failed' });
                            return _context8.abrupt('return', null);

                        case 14:
                            _context8.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_PREVIOUS_JOURNEYS_FINISHED
                                });
                            });
                            return _context8.finish(14);

                        case 17:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this, [[1, 9, 14, 17]]);
        }));

        function getPreviousJourneys(_x3) {
            return _ref9.apply(this, arguments);
        }

        return getPreviousJourneys;
    }(),
    getAssistedTravelLocation: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(nlc) {
            var assistedTravelLocation;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_TRAVEL_LOCATION_STARTED
                                });
                            });
                            _context9.prev = 1;
                            _context9.next = 4;
                            return _PassengerAssistService2.default.getAssistedTravelLocation(nlc);

                        case 4:
                            assistedTravelLocation = _context9.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_TRAVEL_LOCATION_SUCCESS,
                                    assistedTravelLocation: assistedTravelLocation
                                });
                            });
                            return _context9.abrupt('return', assistedTravelLocation.result.location);

                        case 9:
                            _context9.prev = 9;
                            _context9.t0 = _context9['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_TRAVEL_LOCATION_FAILED,
                                    error: _context9.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.book-passenger-assist.failed' });
                            return _context9.abrupt('return', null);

                        case 14:
                            _context9.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_TRAVEL_LOCATION_FINISHED
                                });
                            });
                            return _context9.finish(14);

                        case 17:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this, [[1, 9, 14, 17]]);
        }));

        function getAssistedTravelLocation(_x4) {
            return _ref10.apply(this, arguments);
        }

        return getAssistedTravelLocation;
    }(),
    bookAssist: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(passengerAssist, context) {
            var bookedAssist;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_ASSIST_STARTED
                                });
                            });
                            _context10.prev = 1;
                            _context10.next = 4;
                            return _PassengerAssistService2.default.bookAssist(passengerAssist);

                        case 4:
                            bookedAssist = _context10.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_ASSIST_SUCCESS,
                                    bookedAssist: bookedAssist,
                                    context: context
                                });
                            });
                            return _context10.abrupt('return', bookedAssist);

                        case 9:
                            _context10.prev = 9;
                            _context10.t0 = _context10['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_ASSIST_FAILED,
                                    err: _context10.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.book-passenger-assist.failed' });
                            return _context10.abrupt('return', null);

                        case 14:
                            _context10.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_ASSIST_FINISHED
                                });
                            });
                            return _context10.finish(14);

                        case 17:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this, [[1, 9, 14, 17]]);
        }));

        function bookAssist(_x5, _x6) {
            return _ref11.apply(this, arguments);
        }

        return bookAssist;
    }(),
    bookManyAssists: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(manyAssists) {
            var bookedAssist;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_MANY_ASSISTS_STARTED
                                });
                            });
                            _context11.prev = 1;
                            _context11.next = 4;
                            return _PassengerAssistService2.default.bookManyAssists(manyAssists);

                        case 4:
                            bookedAssist = _context11.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_MANY_ASSISTS_SUCCESS,
                                    bookedAssist: bookedAssist
                                });
                            });
                            return _context11.abrupt('return', bookedAssist);

                        case 9:
                            _context11.prev = 9;
                            _context11.t0 = _context11['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_MANY_ASSISTS_FAILED,
                                    err: _context11.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.book-passenger-assist.failed' });
                            return _context11.abrupt('return', null);

                        case 14:
                            _context11.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.BOOK_MANY_ASSISTS_FINISHED
                                });
                            });
                            return _context11.finish(14);

                        case 17:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this, [[1, 9, 14, 17]]);
        }));

        function bookManyAssists(_x7) {
            return _ref12.apply(this, arguments);
        }

        return bookManyAssists;
    }(),
    getAssistedBooking: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(sysId) {
            var assistedBooking;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKING_STARTED
                                });
                            });
                            _context12.prev = 1;
                            _context12.next = 4;
                            return _PassengerAssistService2.default.getAssistedBooking(sysId);

                        case 4:
                            assistedBooking = _context12.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKING_SUCCESS,
                                    assistedBooking: assistedBooking.result.assistedTravelRequest
                                });
                            });
                            return _context12.abrupt('return', assistedBooking);

                        case 9:
                            _context12.prev = 9;
                            _context12.t0 = _context12['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKING_FAILED,
                                    error: _context12.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.get-assisted-booking.failed' });
                            return _context12.abrupt('return', null);

                        case 14:
                            _context12.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKING_FINISHED
                                });
                            });
                            return _context12.finish(14);

                        case 17:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this, [[1, 9, 14, 17]]);
        }));

        function getAssistedBooking(_x8) {
            return _ref13.apply(this, arguments);
        }

        return getAssistedBooking;
    }(),
    getAssistedBookings: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
            var response, assistedBookings;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKINGS_STARTED
                                });
                            });
                            _context13.prev = 1;
                            _context13.next = 4;
                            return _PassengerAssistService2.default.getAssistedBookings();

                        case 4:
                            response = _context13.sent;
                            assistedBookings = response.result.assistedTravelRequests;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKINGS_SUCCESS,
                                    assistedBookings: assistedBookings
                                });
                            });
                            return _context13.abrupt('return', assistedBookings);

                        case 10:
                            _context13.prev = 10;
                            _context13.t0 = _context13['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKINGS_FAILED,
                                    error: _context13.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.get-assisted-bookings.failed' });
                            return _context13.abrupt('return', null);

                        case 15:
                            _context13.prev = 15;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_ASSISTED_BOOKINGS_FINISHED
                                });
                            });
                            return _context13.finish(15);

                        case 18:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this, [[1, 10, 15, 18]]);
        }));

        function getAssistedBookings() {
            return _ref14.apply(this, arguments);
        }

        return getAssistedBookings;
    }(),
    onRequestPassengerAssistToggled: function onRequestPassengerAssistToggled(toggled) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_PASSENGER_ASSIST_WIDGET_TOGGLED,
                toggled: toggled
            });
        });
    },
    cancelAssistedBooking: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(sysId) {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_ASSISTED_BOOKING_STARTED
                                });
                            });
                            _context14.prev = 1;
                            _context14.next = 4;
                            return _PassengerAssistService2.default.cancelAssistedBooking(sysId);

                        case 4:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_ASSISTED_BOOKING_SUCCESS,
                                    sysId: sysId
                                });
                            });
                            _NotificationActions2.default.showNotification('notifications.pa-request.canceled');
                            _context14.next = 12;
                            break;

                        case 8:
                            _context14.prev = 8;
                            _context14.t0 = _context14['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_ASSISTED_BOOKING_FAILED,
                                    error: _context14.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.cancel-request.failed' });

                        case 12:
                            _context14.prev = 12;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_ASSISTED_BOOKING_FINISHED
                                });
                            });
                            return _context14.finish(12);

                        case 15:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this, [[1, 8, 12, 15]]);
        }));

        function cancelAssistedBooking(_x9) {
            return _ref15.apply(this, arguments);
        }

        return cancelAssistedBooking;
    }(),
    editAssistedBooking: function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(passengerAssist) {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.EDIT_ASSISTED_BOOKING_STARTED
                                });
                            });
                            _context15.prev = 1;
                            _context15.next = 4;
                            return _PassengerAssistService2.default.editAssistedBooking(passengerAssist);

                        case 4:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.EDIT_ASSISTED_BOOKING_SUCCESS,
                                    passengerAssist: passengerAssist
                                });
                            });
                            _NotificationActions2.default.showNotification('notifications.pa-request.updated');
                            _context15.next = 12;
                            break;

                        case 8:
                            _context15.prev = 8;
                            _context15.t0 = _context15['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.EDIT_ASSISTED_BOOKING_FAILED,
                                    error: _context15.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'account.passenger-assist.amend-request.failed' });

                        case 12:
                            _context15.prev = 12;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.EDIT_ASSISTED_BOOKING_FINISHED
                                });
                            });
                            return _context15.finish(12);

                        case 15:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this, [[1, 8, 12, 15]]);
        }));

        function editAssistedBooking(_x10) {
            return _ref16.apply(this, arguments);
        }

        return editAssistedBooking;
    }(),
    clearPendingTravelAssistRequests: function clearPendingTravelAssistRequests() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.CLEAR_PENDING_TRAVEL_ASSIST_REQUESTS
            });
        });
    },
    addOrderTripIdToMostRecentPassengerAssistRequest: function addOrderTripIdToMostRecentPassengerAssistRequest(orderTripId) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.ADD_ORDER_TRIP_ID_TO_PASSENGER_ASSIST_REQUEST,
                orderTripId: orderTripId
            });
        });
    }
};

exports.default = PassengerAssistActions;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _HelpModal = __webpack_require__(1150);

var _HelpModal2 = _interopRequireDefault(_HelpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpIcon = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(HelpIcon, _PureRenderComponent);

    function HelpIcon() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, HelpIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            showModal: false
        }, _this.toggleInfoModal = function (e) {
            _this.setState({ showModal: !_this.state.showModal });
            if (e && e.preventDefault) {
                e.preventDefault();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    HelpIcon.prototype.render = function render() {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'button',
                {
                    type: 'button',
                    className: 'btn help-icon otrl-inline btn-plain ' + this.props.buttonClassName,
                    title: (0, _I18n.translate)(this.props.heading),
                    onClick: this.props.onClick || this.toggleInfoModal,
                    'aria-label': (0, _I18n.translate)(this.props.heading),
                    role: 'link',
                    tabIndex: '0'
                },
                _react2.default.createElement(_Icon2.default, {
                    className: this.props.className,
                    icon: this.props.icon
                })
            ),
            _react2.default.createElement(
                _HelpModal2.default,
                {
                    show: this.state.showModal,
                    onClose: this.toggleInfoModal,
                    onOpen: this.props.onOpen,
                    icon: this.props.icon,
                    heading: (0, _I18n.translate)(this.props.heading),
                    message: this.props.message,
                    centerMessage: this.props.centerMessage,
                    className: this.props.modalClassName,
                    moreInfoText: this.props.moreInfoText
                },
                this.props.body
            )
        );
    };

    return HelpIcon;
}(_PureRenderComponent3.default), _class.propTypes = {
    body: _propTypes2.default.element,
    buttonClassName: _propTypes2.default.string,
    centerMessage: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    heading: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    message: _propTypes2.default.string,
    modalClassName: _propTypes2.default.string,
    moreInfoText: _propTypes2.default.element,
    onClick: _propTypes2.default.func,
    onOpen: _propTypes2.default.func
}, _class.defaultProps = {
    buttonClassName: '',
    centerMessage: false,
    className: '',
    heading: 'info.title',
    icon: 'info',
    onClick: null,
    onOpen: _noop3.default,
    modalClassName: 'modal--sm'
}, _temp2);
exports.default = HelpIcon;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SmartcardActivationError = exports.ACTError = exports.SmartcardAlreadyRegisteredError = exports.SmartcardPostcodeError = exports.SelfSmartcardRegistrationError = exports.SmartcardRegistrationError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class5, _temp6;

var _ExtendableError5 = __webpack_require__(91);

var _ExtendableError6 = _interopRequireDefault(_ExtendableError5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardRegistrationError = exports.SmartcardRegistrationError = function (_ExtendableError) {
    (0, _inherits3.default)(SmartcardRegistrationError, _ExtendableError);

    function SmartcardRegistrationError() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SmartcardRegistrationError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'SmartcardRegistrationError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return SmartcardRegistrationError;
}(_ExtendableError6.default);

var SelfSmartcardRegistrationError = exports.SelfSmartcardRegistrationError = function (_ExtendableError2) {
    (0, _inherits3.default)(SelfSmartcardRegistrationError, _ExtendableError2);

    function SelfSmartcardRegistrationError() {
        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, SelfSmartcardRegistrationError);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError2.call.apply(_ExtendableError2, [this].concat(args))), _this2), _this2.name = 'SelfSmartcardRegistrationError', _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    return SelfSmartcardRegistrationError;
}(_ExtendableError6.default);

var SmartcardPostcodeError = exports.SmartcardPostcodeError = function (_SmartcardRegistratio) {
    (0, _inherits3.default)(SmartcardPostcodeError, _SmartcardRegistratio);

    function SmartcardPostcodeError() {
        var _temp3, _this3, _ret3;

        (0, _classCallCheck3.default)(this, SmartcardPostcodeError);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, _SmartcardRegistratio.call.apply(_SmartcardRegistratio, [this].concat(args))), _this3), _this3.name = 'SmartcardPostcodeError', _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
    }

    return SmartcardPostcodeError;
}(SmartcardRegistrationError);

var SmartcardAlreadyRegisteredError = exports.SmartcardAlreadyRegisteredError = function (_SmartcardRegistratio2) {
    (0, _inherits3.default)(SmartcardAlreadyRegisteredError, _SmartcardRegistratio2);

    function SmartcardAlreadyRegisteredError() {
        var _temp4, _this4, _ret4;

        (0, _classCallCheck3.default)(this, SmartcardAlreadyRegisteredError);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return _ret4 = (_temp4 = (_this4 = (0, _possibleConstructorReturn3.default)(this, _SmartcardRegistratio2.call.apply(_SmartcardRegistratio2, [this].concat(args))), _this4), _this4.name = 'SmartcardAlreadyRegisteredError', _temp4), (0, _possibleConstructorReturn3.default)(_this4, _ret4);
    }

    return SmartcardAlreadyRegisteredError;
}(SmartcardRegistrationError);

var ACTError = exports.ACTError = (_temp6 = _class5 = function (_ExtendableError3) {
    (0, _inherits3.default)(ACTError, _ExtendableError3);

    function ACTError() {
        var _temp5, _this5, _ret5;

        (0, _classCallCheck3.default)(this, ACTError);

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return _ret5 = (_temp5 = (_this5 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError3.call.apply(_ExtendableError3, [this].concat(args))), _this5), _this5.name = 'ACTError', _temp5), (0, _possibleConstructorReturn3.default)(_this5, _ret5);
    }

    return ACTError;
}(_ExtendableError6.default), _class5.code = 3, _temp6);

var SmartcardActivationError = exports.SmartcardActivationError = function (_ExtendableError4) {
    (0, _inherits3.default)(SmartcardActivationError, _ExtendableError4);

    function SmartcardActivationError() {
        var _temp7, _this6, _ret6;

        (0, _classCallCheck3.default)(this, SmartcardActivationError);

        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        return _ret6 = (_temp7 = (_this6 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError4.call.apply(_ExtendableError4, [this].concat(args))), _this6), _this6.name = 'SmartcardActivationError', _temp7), (0, _possibleConstructorReturn3.default)(_this6, _ret6);
    }

    return SmartcardActivationError;
}(_ExtendableError6.default);

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DEFAULT_WINDOW_LENGTH = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_WINDOW_LENGTH = exports.DEFAULT_WINDOW_LENGTH = 3; // hours

var defaults = {
    datetime: (0, _TrainTime2.default)(),
    arriveDepart: _AppConstants.TimeTypes.DEPART,
    windowLength: DEFAULT_WINDOW_LENGTH
};

var Timeband = function (_record) {
    (0, _inherits3.default)(Timeband, _record);

    function Timeband() {
        (0, _classCallCheck3.default)(this, Timeband);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Timeband.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Timeband, json, {
            datetime: _LinkMapper.resolve.with(_TrainTime2.default),
            arriveDepart: _LinkMapper.resolve.with(String),
            windowLength: _LinkMapper.resolve.with(Number)
        });
    };

    Timeband.prototype.toRange = function toRange() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            truncateStart = _ref.truncateStart,
            truncateEnd = _ref.truncateEnd;

        var isPastDate = (0, _moment2.default)(this.datetime).isBefore((0, _moment2.default)());
        return isPastDate ? this.toRangePastDate() : this.toRangeFutureDate({ truncateStart: truncateStart, truncateEnd: truncateEnd });
    };

    Timeband.prototype.toRangeFutureDate = function toRangeFutureDate(_ref2) {
        var truncateStart = _ref2.truncateStart,
            truncateEnd = _ref2.truncateEnd;

        var rangeStart = this.getStart();
        var rangeEnd = this.getEnd();

        if (this.arriveDepart === _AppConstants.TimeTypes.DEPART) {
            if (truncateStart && truncateStart.isAfter(rangeStart)) {
                rangeStart = truncateStart;
            }
            if (truncateEnd && truncateEnd.isBefore(rangeEnd)) {
                rangeEnd = truncateEnd;
            }
        }

        return this._formatRange(rangeStart, rangeEnd);
    };

    Timeband.prototype.toRangePastDate = function toRangePastDate() {
        var rangeStart = this.getStartInThePast();
        var rangeEnd = this.getEndInThePast();

        if (rangeEnd.isBefore(rangeStart)) {
            rangeEnd = rangeStart.clone().add(1, 'minute');
        }

        return this._formatRange(rangeStart, rangeEnd);
    };

    Timeband.prototype._formatRange = function _formatRange(rangeStart, rangeEnd) {
        return {
            rangeStart: rangeStart.format(_AppConstants.API_ISO_FORMAT),
            rangeEnd: rangeEnd.format(_AppConstants.API_ISO_FORMAT),
            arriveDepart: this.arriveDepart
        };
    };

    Timeband.prototype.getWindowLength = function getWindowLength() {
        return { hours: this.windowLength };
    };

    Timeband.prototype.getStart = function getStart() {
        var start = this.datetime.clone();
        return this.arriveDepart === _AppConstants.TimeTypes.DEPART ? start : start.subtract(this.getWindowLength());
    };

    Timeband.prototype.getEnd = function getEnd() {
        var end = this.datetime.clone();
        return this.arriveDepart === _AppConstants.TimeTypes.ARRIVE ? end : end.add(this.getWindowLength());
    };

    Timeband.prototype.getStartInThePast = function getStartInThePast() {
        var datetime = this.datetime.clone();
        var timeThresholdAgo = (0, _moment2.default)().subtract(_config2.default.get('journeyPlannerAllowDepartedServiceSearchTimeLimit'), 'hours');
        var rangeStart = this.arriveDepart === _AppConstants.TimeTypes.ARRIVE ? datetime.subtract(this.getWindowLength()) : datetime;

        var start = rangeStart.isBefore(timeThresholdAgo) ? timeThresholdAgo : rangeStart;
        return start.add(1, 'minute');
    };

    Timeband.prototype.getEndInThePast = function getEndInThePast() {
        var datetime = this.datetime.clone();
        return this.arriveDepart === _AppConstants.TimeTypes.ARRIVE ? datetime.subtract(1, 'minute') : datetime.add(this.getWindowLength()).add(1, 'minute');
    };

    Timeband.prototype.getEarlier = function getEarlier(windowLength) {
        return this.subtract(windowLength ? { hours: windowLength } : this.getWindowLength());
    };

    Timeband.prototype.getLater = function getLater(windowLength) {
        return this.add(windowLength ? { hours: windowLength } : this.getWindowLength());
    };

    Timeband.prototype.add = function add() {
        var _datetime$clone;

        return this.set('datetime', (_datetime$clone = this.datetime.clone()).add.apply(_datetime$clone, arguments));
    };

    Timeband.prototype.subtract = function subtract() {
        var _datetime$clone2;

        return this.set('datetime', (_datetime$clone2 = this.datetime.clone()).subtract.apply(_datetime$clone2, arguments));
    };

    return Timeband;
}((0, _immutable.Record)(defaults));

exports.default = Timeband;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LocationContext = exports.RouterContext = undefined;
exports.RouterProvider = RouterProvider;
exports.default = useRouter;
exports.useLocation = useLocation;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PropTypes = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouterContext = exports.RouterContext = _react2.default.createContext();
var LocationContext = exports.LocationContext = _react2.default.createContext();

RouterProvider.propTypes = {
    router: _PropTypes.routerShape.isRequired,
    location: _PropTypes.locationShape.isRequired,
    children: _propTypes2.default.node.isRequired
};
function RouterProvider(_ref) {
    var router = _ref.router,
        location = _ref.location,
        children = _ref.children;

    return _react2.default.createElement(
        RouterContext.Provider,
        { value: router },
        _react2.default.createElement(
            LocationContext.Provider,
            { value: location },
            children
        )
    );
}

function useRouter() {
    return _react2.default.useContext(RouterContext);
}

function useLocation() {
    return _react2.default.useContext(LocationContext);
}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1979);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _Search = __webpack_require__(421);

var _DisruptionAlert = __webpack_require__(289);

var _DisruptionAlertMute = __webpack_require__(582);

var _DisruptionAlertMute2 = _interopRequireDefault(_DisruptionAlertMute);

var _DisruptionAlertService = __webpack_require__(456);

var _DisruptionAlertService2 = _interopRequireDefault(_DisruptionAlertService);

var _JourneyPlanService = __webpack_require__(272);

var _JourneyPlanService2 = _interopRequireDefault(_JourneyPlanService);

var _DisruptionAlerts = __webpack_require__(460);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisruptionAlertActions = {
    loadAlerts: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var alerts;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_LOAD_STARTED });

                            _context.prev = 1;
                            _context.next = 4;
                            return _DisruptionAlertService2.default.getAll(user);

                        case 4:
                            alerts = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_LOAD_FINISHED,
                                alerts: alerts
                            });
                            _context.next = 12;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_LOAD_FAILED });
                            throw _context.t0;

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 8]]);
        }));

        function loadAlerts(_x) {
            return _ref.apply(this, arguments);
        }

        return loadAlerts;
    }(),
    loadServiceChangeAlerts: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user) {
            var timetableAlerts;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.SERVICE_CHANGE_ALERTS_LOAD_STARTED });

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _DisruptionAlertService2.default.getServiceChangeAlerts(user);

                        case 4:
                            timetableAlerts = _context2.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SERVICE_CHANGE_ALERTS_LOAD_FINISHED,
                                timetableAlerts: timetableAlerts
                            });
                            _context2.next = 12;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.SERVICE_CHANGE_ALERTS_LOAD_FAILED });
                            throw _context2.t0;

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 8]]);
        }));

        function loadServiceChangeAlerts(_x2) {
            return _ref2.apply(this, arguments);
        }

        return loadServiceChangeAlerts;
    }(),
    createFromOrderJourney: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref3) {
            var user = _ref3.user,
                order = _ref3.order,
                orderTrip = _ref3.orderTrip,
                orderJourney = _ref3.orderJourney,
                context = _ref3.context,
                stationFacilityAlert = _ref3.stationFacilityAlert;
            var alert;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            alert = null;
                            _context3.prev = 1;
                            _context3.next = 4;
                            return _DisruptionAlertService2.default.createFromOrderJourney({ user: user, order: order, orderTrip: orderTrip, orderJourney: orderJourney, stationFacilityAlert: stationFacilityAlert });

                        case 4:
                            alert = _context3.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_CREATED,
                                alert: alert,
                                context: context
                            });
                            _context3.next = 11;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](1);

                            if (_context3.t0 instanceof _DisruptionAlerts.DisruptionAlertsLimitExceededError) {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                    type: _AppConstants.GlobalModals.ERROR,
                                    data: {
                                        heading: (0, _I18n.translate)('account.disruptionAlerts.unableToCreate'),
                                        title: (0, _I18n.translate)('account.disruptionAlerts.limitReached'),
                                        message: (0, _I18n.translate)('account.disruptionAlerts.create.maximumReached', { max: 10 })
                                    }
                                });
                            } else {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.MODAL_OPENED,
                                    type: _AppConstants.GlobalModals.ERROR,
                                    data: {
                                        heading: (0, _I18n.translate)('account.disruptionAlerts.unableToCreate'),
                                        message: (0, _I18n.translate)('account.disruptionAlerts.genericError')
                                    }
                                });
                            }

                        case 11:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[1, 8]]);
        }));

        function createFromOrderJourney(_x3) {
            return _ref4.apply(this, arguments);
        }

        return createFromOrderJourney;
    }(),
    createFromBuilder: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref5) {
            var user = _ref5.user,
                order = _ref5.order,
                orderTrip = _ref5.orderTrip,
                formData = _ref5.formData,
                context = _ref5.context,
                stationFacilityAlert = _ref5.stationFacilityAlert;
            var alert;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _DisruptionAlertService2.default.createFromBuilder({ user: user, order: order, orderTrip: orderTrip, formData: formData, stationFacilityAlert: stationFacilityAlert });

                        case 2:
                            alert = _context4.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_CREATED,
                                alert: alert,
                                context: context
                            });
                            return _context4.abrupt('return', alert);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function createFromBuilder(_x4) {
            return _ref6.apply(this, arguments);
        }

        return createFromBuilder;
    }(),
    update: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(user, alertData, context) {
            var alert;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return _DisruptionAlertService2.default.update(user, alertData);

                        case 2:
                            alert = _context5.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_UPDATED,
                                alert: alert,
                                context: context
                            });

                        case 4:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function update(_x5, _x6, _x7) {
            return _ref7.apply(this, arguments);
        }

        return update;
    }(),
    delete: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(user, alert, context) {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return _DisruptionAlertService2.default.delete(user, alert);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_DELETED,
                                alert: alert,
                                context: context
                            });

                        case 3:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function _delete(_x8, _x9, _x10) {
            return _ref8.apply(this, arguments);
        }

        return _delete;
    }(),
    createMute: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(user, alert, muteData, context) {
            var mute, alertMute;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            mute = new _DisruptionAlertMute2.default(muteData);
                            _context7.next = 3;
                            return _DisruptionAlertService2.default.createMute(user, alert, mute);

                        case 3:
                            alertMute = _context7.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_MUTE_CREATED,
                                alert: alert,
                                alertMute: alertMute,
                                context: context
                            });

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function createMute(_x11, _x12, _x13, _x14) {
            return _ref9.apply(this, arguments);
        }

        return createMute;
    }(),
    editMute: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(user, alert, alertMute, context) {
            var updatedAlertMute;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return _DisruptionAlertService2.default.editMute(user, alert, alertMute);

                        case 2:
                            updatedAlertMute = _context8.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_MUTE_UPDATED,
                                alert: alert,
                                alertMute: updatedAlertMute,
                                context: context
                            });

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function editMute(_x15, _x16, _x17, _x18) {
            return _ref10.apply(this, arguments);
        }

        return editMute;
    }(),
    deleteMute: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(user, alert, alertMute, context) {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return _DisruptionAlertService2.default.deleteMute(user, alert, alertMute);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_MUTE_DELETED,
                                alert: alert,
                                alertMute: alertMute,
                                context: context
                            });

                        case 3:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function deleteMute(_x19, _x20, _x21, _x22) {
            return _ref11.apply(this, arguments);
        }

        return deleteMute;
    }(),
    muteForDay: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(ddmUserId, alertId, token, muteAll) {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.next = 2;
                            return _DisruptionAlertService2.default.muteForDay(ddmUserId, alertId, token, muteAll);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERT_MUTED_FOR_DAY,
                                alertId: alertId,
                                muteAll: muteAll
                            });

                        case 3:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        function muteForDay(_x23, _x24, _x25, _x26) {
            return _ref12.apply(this, arguments);
        }

        return muteForDay;
    }(),
    serviceSearch: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(user, search) {
            var errors, result, sameDayServices;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            if (search.isValid()) {
                                _context11.next = 4;
                                break;
                            }

                            errors = search.getValidationErrors().toJS().join(', ');


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_FAILED,
                                search: search
                            });

                            throw new _Search.InvalidSearchError('Failed check: ' + errors, search);

                        case 4:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_STARTED,
                                search: search
                            });

                            _context11.next = 7;
                            return _JourneyPlanService2.default.search({ search: search, user: user });

                        case 7:
                            result = _context11.sent;
                            sameDayServices = (0, _DisruptionAlert.filterSameDayDeparturesOnly)(result.outward, search.getOutboundDateTime());


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_FINISHED,
                                search: search,
                                servicesList: sameDayServices
                            });

                            return _context11.abrupt('return', { search: search, result: result });

                        case 11:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this);
        }));

        function serviceSearch(_x27, _x28) {
            return _ref13.apply(this, arguments);
        }

        return serviceSearch;
    }(),
    showEarlierLaterServices: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(user, search, tripDirection, services, timeDirection) {
            var isEarlier, actionTypePrefix, updatedSearch, result, sameDayServices;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            if ((0, _values2.default)(_AppConstants.TimeDirections).includes(timeDirection)) {
                                _context12.next = 2;
                                break;
                            }

                            return _context12.abrupt('return', null);

                        case 2:
                            isEarlier = timeDirection === _AppConstants.TimeDirections.EARLIER;
                            actionTypePrefix = 'DISRUPTION_ALERTS_SEARCH_' + (isEarlier ? 'EARLIER' : 'LATER');
                            updatedSearch = isEarlier ? search.earlier(tripDirection, services) : search.later(tripDirection, services);


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes[actionTypePrefix + '_STARTED'],
                                search: updatedSearch
                            });

                            _context12.next = 8;
                            return _JourneyPlanService2.default.search({ search: updatedSearch, user: user });

                        case 8:
                            result = _context12.sent;
                            sameDayServices = (0, _DisruptionAlert.filterSameDayDeparturesOnly)(result.outward, search.getOutboundDateTime());


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes[actionTypePrefix + '_FINISHED'],
                                search: updatedSearch,
                                servicesList: sameDayServices
                            });

                            return _context12.abrupt('return', { updatedSearch: updatedSearch, result: result });

                        case 12:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function showEarlierLaterServices(_x29, _x30, _x31, _x32, _x33) {
            return _ref14.apply(this, arguments);
        }

        return showEarlierLaterServices;
    }(),
    clearServices: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_SERVICES_RESET });

                        case 1:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this);
        }));

        function clearServices() {
            return _ref15.apply(this, arguments);
        }

        return clearServices;
    }(),
    getBankHolidays: function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
            var dates;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_STARTED });

                            _context14.prev = 1;
                            _context14.next = 4;
                            return _DisruptionAlertService2.default.getBankHolidays();

                        case 4:
                            dates = _context14.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_FINISHED,
                                dates: dates
                            });
                            _context14.next = 12;
                            break;

                        case 8:
                            _context14.prev = 8;
                            _context14.t0 = _context14['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_FAILED });
                            throw _context14.t0;

                        case 12:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this, [[1, 8]]);
        }));

        function getBankHolidays() {
            return _ref16.apply(this, arguments);
        }

        return getBankHolidays;
    }(),
    setTimetableAlertsWidgetState: function setTimetableAlertsWidgetState(formState) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_TIMETABLE_ALERTS_WIDGET_STATE,
            formState: formState
        });
    },
    createTimetableChangesAlert: function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(_ref17) {
            var timetableChangesAlert = _ref17.timetableChangesAlert;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.next = 2;
                            return _DisruptionAlertService2.default.createServiceChangeAlert({ timetableChangesAlert: timetableChangesAlert });

                        case 2:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this);
        }));

        function createTimetableChangesAlert(_x34) {
            return _ref18.apply(this, arguments);
        }

        return createTimetableChangesAlert;
    }(),
    deleteServiceChangeAlert: function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(user, alrt) {
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            _context16.next = 2;
                            return _DisruptionAlertService2.default.deleteServiceChangeAlert(user, alrt);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SERVICE_CHANGE_ALERT_DELETED,
                                alrt: alrt
                            });

                        case 3:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, this);
        }));

        function deleteServiceChangeAlert(_x35, _x36) {
            return _ref19.apply(this, arguments);
        }

        return deleteServiceChangeAlert;
    }(),
    deleteServiceChangeAlertAnon: function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(_ref20) {
            var alertId = _ref20.alertId,
                ddmCustomerId = _ref20.ddmCustomerId,
                orderId = _ref20.orderId,
                securityToken = _ref20.securityToken,
                ticketIds = _ref20.ticketIds;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _context17.next = 2;
                            return _DisruptionAlertService2.default.deleteServiceChangeAlertAnon({ alertId: alertId, ddmCustomerId: ddmCustomerId, orderId: orderId, securityToken: securityToken, ticketIds: ticketIds });

                        case 2:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, this);
        }));

        function deleteServiceChangeAlertAnon(_x37) {
            return _ref21.apply(this, arguments);
        }

        return deleteServiceChangeAlertAnon;
    }(),
    addTimetableAlert: function addTimetableAlert() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.ADD_TIMETABLE_ALERT
        });
    },
    resetTimetableAlerts: function resetTimetableAlerts() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.RESET_TIMETABLE_ALERTS
        });
    }
};

exports.default = DisruptionAlertActions;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _mapKeys2 = __webpack_require__(783);

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

var _capitalize = __webpack_require__(1696);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _AppConstants = __webpack_require__(6);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TicketOffice = __webpack_require__(604);

var _TicketOffice2 = _interopRequireDefault(_TicketOffice);

var _LinkMapper = __webpack_require__(8);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataUrl = '/data/stations';
var configUrl = '/config/stations';
var stationCache = {};

function stationConfigResolver(stationConfig, station) {
    if (!station) {
        station = (0, _LinkMapper.resolve)(stationConfig.station).with(Object);
    }

    station.validity = (0, _assign2.default)({}, stationConfig.default, { DaySaveOrigin: stationConfig.daySaveOrigin }, (0, _mapKeys3.default)(stationConfig.season, function (x, type) {
        return 'season' + (0, _capitalize2.default)(type);
    }), (0, _mapKeys3.default)(stationConfig.smartcard, function (x, type) {
        return 'smartcard' + (0, _capitalize2.default)(type);
    }));
    station.id = stationConfig.station;
    station.onwardTaxiBookingAvailable = stationConfig.onwardTaxiBookingAvailable;

    return (0, _LinkMapper.resolve)(station).as(_Station2.default);
}

var StationService = {
    search: function search(term, stationType) {
        var filterByBrand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (stationType === 'TicketOnDeparture' || stationType === 'SmartcardCollection') {
            console.warn(stationType + ' station types not yet supported, defaulting to Origin');
            stationType = _AppConstants.StationTypes.ORIGIN;
        }

        var filterByBrandParam = filterByBrand ? { filterByBrand: true } : null;

        var params = (0, _extends3.default)({
            search: term
        }, filterByBrandParam);

        if (stationType) {
            if ((0, _values2.default)(_AppConstants.DelayRepayStationTypes).includes(stationType)) {
                params.type = stationType.replace(/^delayRepay/, '');
                params.delayrepay = true;
            } else {
                params.type = (0, _capitalize2.default)(stationType);
            }
        }

        return _APIClient2.default.get(configUrl, params).then(function (response) {
            return (0, _LinkMapper.resolveAll)(response.result).with(stationConfigResolver);
        });
    },
    get: function get(nlc) {
        if (stationCache[nlc]) {
            return stationCache[nlc];
        }

        stationCache[nlc] = _APIClient2.default.get(dataUrl + '/' + nlc).then(function (response) {
            if (response.result) {
                return (0, _LinkMapper.resolve)((0, _extends3.default)({}, response.result, { id: dataUrl + '/' + nlc })).as(_Station2.default);
            }
            return new _Station2.default();
        }).catch(function (error) {
            if (error instanceof _APIClient.NotFoundError) {
                return new _Station2.default();
            }
            delete stationCache[nlc];
            throw error;
        });

        return stationCache[nlc];
    },
    findNearest: function findNearest(latitude, longitude) {
        var numStations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

        return _APIClient2.default.get(configUrl, { latitude: latitude, longitude: longitude, num_stations: numStations }, { loader: true }) // eslint-disable-line camelcase
        .then(function (response) {
            return (0, _LinkMapper.resolveAll)(response.result).with(stationConfigResolver);
        });
    },
    getTicketOfficeDetails: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(station) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return _APIClient2.default.get('/data/ticket-offices/' + station.crs);

                        case 3:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_TicketOffice2.default));

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            if (!(_context.t0 instanceof _APIClient.NotFoundError)) {
                                _context.next = 12;
                                break;
                            }

                            console.warn('Ticket office not found for ' + station.crs, _context.t0.message);
                            return _context.abrupt('return', null);

                        case 12:
                            throw _context.t0;

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));

        function getTicketOfficeDetails(_x3) {
            return _ref.apply(this, arguments);
        }

        return getTicketOfficeDetails;
    }(),
    getStations: function getStations(nlc) {
        if (stationCache[nlc]) {
            return stationCache[nlc];
        }

        stationCache[nlc] = _AuthenticatedAPIClient2.default.get(configUrl + '?search=' + nlc).then(function (response) {
            return response.result || null;
        }).catch(function (error) {
            throw error;
        });

        return stationCache[nlc];
    }
};

exports.default = StationService;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PromoCodeStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromoCodeStore = exports.PromoCodeStore = function (_BaseStore) {
    (0, _inherits3.default)(PromoCodeStore, _BaseStore);

    function PromoCodeStore() {
        (0, _classCallCheck3.default)(this, PromoCodeStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    PromoCodeStore.prototype.getActive = function getActive() {
        return this.get('active');
    };

    PromoCodeStore.prototype.deserialize = function deserialize(serialized) {
        var state = new _immutable.Map();

        if (serialized && serialized.active) {
            state = state.set('active', _PromoCode2.default.fromJSON(serialized.active));
        }

        return state;
    };

    PromoCodeStore.prototype.handleApplied = function handleApplied(_ref) {
        var promoCode = _ref.promoCode;

        this.setState(this.state.set('active', promoCode));
    };

    PromoCodeStore.prototype.handleRemoved = function handleRemoved() {
        this.setState(this.state.set('active', null));
    };

    PromoCodeStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.PROMOCODE_APPLIED] = this.handleApplied, _ref2[_AppConstants.ActionTypes.PROMOCODE_REMOVED] = this.handleRemoved, _ref2[_AppConstants.ActionTypes.ORDER_PAID] = this.handleRemoved, _ref2[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleRemoved, _ref2;
    };

    return PromoCodeStore;
}(_BaseStore3.default);

var instance = new PromoCodeStore({
    storageKey: 'promoCode',
    expires: 60 * 60 * 3
});

exports.default = instance;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.options = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _reduce2 = __webpack_require__(219);

var _reduce3 = _interopRequireDefault(_reduce2);

var _filter2 = __webpack_require__(1120);

var _filter3 = _interopRequireDefault(_filter2);

var _immutable = __webpack_require__(5);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    outward: null,
    return: null
};

var options = exports.options = [['outward', 'destination'], ['outward', 'origin'], ['return', 'origin'], ['return', 'destination']];

function makePortionFares() {
    var portion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if ((0, _keys2.default)(portion).length === 0) {
        return null;
    }

    return new _immutable.Map({
        origin: (0, _LinkMapper.resolve)(portion.origin).as(_Fare2.default),
        destination: (0, _LinkMapper.resolve)(portion.destination).as(_Fare2.default)
    });
}

var PlusBus = function (_record) {
    (0, _inherits3.default)(PlusBus, _record);

    function PlusBus() {
        (0, _classCallCheck3.default)(this, PlusBus);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PlusBus.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


        // NOTE: Reserved naming issues may arise by using "return"
        var outward = (0, _LinkMapper.resolve)(json.outward).with(makePortionFares);
        var inward = (0, _LinkMapper.resolve)(json.return).with(makePortionFares);

        var result = { outward: outward, return: inward };

        return new PlusBus(result);
    };

    PlusBus.prototype.getPortion = function getPortion(direction) {
        return this.get(direction);
    };

    PlusBus.prototype.getFares = function getFares() {
        return new _immutable.List([this.getIn(['outward', 'origin']), this.getIn(['outward', 'destination']), this.getIn(['return', 'origin']), this.getIn(['return', 'destination'])]).filter(function (fare) {
            return !!fare;
        });
    };

    PlusBus.prototype.hasTerminal = function hasTerminal(direction, terminal) {
        var portion = this.getPortion(direction);
        return portion && portion.get(terminal);
    };

    PlusBus.prototype.setTerminal = function setTerminal(direction, terminal, value) {
        var portion = this.getPortion(direction);
        if (!portion) {
            portion = new _immutable.Map();
        }
        portion = portion.set(terminal, value);
        return this.set(direction, portion);
    };

    PlusBus.prototype.count = function count() {
        var _this2 = this;

        return (0, _filter3.default)(options, function (args) {
            return _this2.hasTerminal.apply(_this2, args);
        }).length;
    };

    PlusBus.prototype.getTotalPrice = function getTotalPrice() {
        var _this3 = this;

        return (0, _reduce3.default)(options, function (total, option) {
            var terminal = _this3.getTerminal.apply(_this3, option);
            if (terminal) {
                return total + terminal.getPrice();
            }
            return total;
        }, 0);
    };

    PlusBus.prototype.getCheapestTicket = function getCheapestTicket() {
        var outwardPrice = this.outward ? this.outward.map(function (e) {
            return (0, _get3.default)(e, 'totalPrice', 0);
        }) : new _immutable.Map();
        var returnPrice = this.return ? this.return.map(function (e) {
            return (0, _get3.default)(e, 'totalPrice', 0);
        }) : new _immutable.Map();

        return Math.min.apply(Math, [outwardPrice.get("destination"), outwardPrice.get("origin"), returnPrice.get("destination"), outwardPrice.get("origin")].filter(Boolean));
    };

    PlusBus.prototype.getTerminal = function getTerminal(direction, terminal) {
        var portion = this.getPortion(direction);
        return portion && portion.get(terminal);
    };

    PlusBus.prototype.getValidDate = function getValidDate(direction) {
        var portion = this.getPortion(direction);
        var fare = portion && (portion.get('origin') || portion.get('destination'));

        if (fare) {
            return fare.get('outwardValidity').get('until');
        }
        return null;
    };

    PlusBus.prototype.isSameDay = function isSameDay() {
        var outwardValidity = this.getValidDate('outward');
        var returnValidity = this.getValidDate('return');
        return outwardValidity && outwardValidity.isSame(returnValidity);
    };

    PlusBus.prototype.plusBusAvailable = function plusBusAvailable() {
        return this.outward && (this.outward.get('origin') || this.outward.get('destination')) || this.return && (this.return.get('origin') || this.return.get('destination'));
    };

    PlusBus.prototype.getDirectionKey = function getDirectionKey(direction, isSameDay) {
        var directionKey = isSameDay || this.isSameDay() || direction === _AppConstants.JourneyDirections.OUTWARD ? 'outward' : direction === _AppConstants.JourneyDirections.INWARD ? 'return' : null;
        return directionKey;
    };

    PlusBus.prototype.getFaresForDirection = function getFaresForDirection(direction, isSameDay) {
        return this.get(this.getDirectionKey(direction, isSameDay));
    };

    PlusBus.prototype.setFareForDirection = function setFareForDirection(direction, terminal, fare, isSameDay) {
        var directionKey = this.getDirectionKey(direction, isSameDay);
        var current = this.get(directionKey);
        if (!current) {
            current = new _immutable.Map();
        }
        current = current.set(terminal, fare);
        return this.set(directionKey, current);
    };

    PlusBus.prototype.matchWithOrderPlusBus = function matchWithOrderPlusBus(plusBus) {
        return _AppConstants.PlusBusOptions.reduce(function (acc, _ref) {
            var terminal = _ref.terminal,
                direction = _ref.direction;

            var fare = plusBus.getTerminal(direction, terminal);
            if (!plusBus.hasTerminal(direction, terminal) || !fare.tickets.some(function (ticket) {
                return !ticket.isRefunded;
            })) {
                acc = acc.setTerminal(direction, terminal, null);
            }
            return acc;
        }, this);
    };

    return PlusBus;
}((0, _immutable.Record)(defaults));

exports.default = PlusBus;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1695),
    findIndex = __webpack_require__(434);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DisruptionAlertStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _Services = __webpack_require__(600);

var _Services2 = _interopRequireDefault(_Services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toJson(search) {
    return (0, _stringify2.default)(search.serialize());
}

var DisruptionAlertState = new _immutable.Record({
    alerts: new _immutable.List(),
    alertsLoading: false,
    searchJsonString: null,
    services: new _Services2.default(),
    servicesLoading: false,
    bankHolidays: new _immutable.List(),
    timetableAlertsWidgetState: {
        alertsChecked: false,
        timetableChangesChecked: false,
        delaysChecked: false,
        stationAlertsChecked: false,
        emailChecked: false,
        appChecked: false,
        tripId: null,
        outwardTrainIds: [],
        inwardTrainIds: []
    },
    timetableAlerts: new _immutable.List(),
    timetableAlertsLoading: false
});

var DisruptionAlertStore = exports.DisruptionAlertStore = function (_BaseStore) {
    (0, _inherits3.default)(DisruptionAlertStore, _BaseStore);

    function DisruptionAlertStore() {
        (0, _classCallCheck3.default)(this, DisruptionAlertStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    DisruptionAlertStore.prototype.getInitialState = function getInitialState() {
        return new DisruptionAlertState();
    };

    DisruptionAlertStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_LOAD_STARTED] = this.handleAlertsLoadStarted, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_LOAD_FINISHED] = this.handleAlertsLoaded, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_LOAD_FAILED] = this.handleAlertsLoadFailed, _ref[_AppConstants.ActionTypes.SERVICE_CHANGE_ALERTS_LOAD_STARTED] = this.handleServiceChangeAlertsLoadStarted, _ref[_AppConstants.ActionTypes.SERVICE_CHANGE_ALERTS_LOAD_FINISHED] = this.handleServiceChangeAlertsLoaded, _ref[_AppConstants.ActionTypes.SERVICE_CHANGE_ALERTS_LOAD_FAILED] = this.handleServiceChangeAlertsLoadFailed, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_CREATED] = this.handleAlertCreated, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_UPDATED] = this.handleAlertUpdated, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_DELETED] = this.handleAlertDeleted, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_MUTE_CREATED] = this.handleAlertMuteCreated, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_MUTE_UPDATED] = this.handleAlertMuteUpdated, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_MUTE_DELETED] = this.handleAlertMuteDeleted, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_STARTED] = this.handleServiceSearchStarted, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_FINISHED] = this.handleServiceSearchFinished, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_FAILED] = this.handleServiceSearchFailed, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_EARLIER_STARTED] = this.handleServiceSearchStarted, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_EARLIER_FINISHED] = this.handleServiceSearchFinished, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_LATER_STARTED] = this.handleServiceSearchStarted, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SEARCH_LATER_FINISHED] = this.handleServiceSearchFinished, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_SERVICES_RESET] = this.handleServicesReset, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_FINISHED] = this.handleFetchBankHolidays, _ref[_AppConstants.ActionTypes.SET_TIMETABLE_ALERTS_WIDGET_STATE] = this.setTimetableAlertsWidgetState, _ref[_AppConstants.ActionTypes.GET_TIMETABLE_ALERTS_WIDGET_STATE] = this.getTimetableAlertsWidgetState, _ref[_AppConstants.ActionTypes.ADD_TIMETABLE_ALERT] = this.addTimetableAlert, _ref[_AppConstants.ActionTypes.RESET_TIMETABLE_ALERTS] = this.resetTimetableAlerts, _ref[_AppConstants.ActionTypes.SERVICE_CHANGE_ALERT_DELETED] = this.handleTimetableAlertDeleted, _ref;
    };

    DisruptionAlertStore.prototype.handleAlertsLoadStarted = function handleAlertsLoadStarted() {
        this.setState(this.state.merge({ alertsLoading: true }));
    };

    DisruptionAlertStore.prototype.handleAlertsLoaded = function handleAlertsLoaded(_ref2) {
        var alerts = _ref2.alerts;

        this.setState(this.state.merge({
            alerts: alerts,
            alertsLoading: false
        }));
    };

    DisruptionAlertStore.prototype.handleAlertsLoadFailed = function handleAlertsLoadFailed() {
        this.setState(this.state.merge({ alertsLoading: false }));
    };

    DisruptionAlertStore.prototype.handleServiceChangeAlertsLoadStarted = function handleServiceChangeAlertsLoadStarted() {
        this.setState(this.state.merge({ timetableAlertsLoading: true }));
    };

    DisruptionAlertStore.prototype.handleServiceChangeAlertsLoaded = function handleServiceChangeAlertsLoaded(_ref3) {
        var timetableAlerts = _ref3.timetableAlerts;

        this.setState(this.state.merge({
            timetableAlerts: timetableAlerts,
            timetableAlertsLoading: false
        }));
    };

    DisruptionAlertStore.prototype.handleServiceChangeAlertsLoadFailed = function handleServiceChangeAlertsLoadFailed() {
        this.setState(this.state.merge({ timetableAlertsLoading: false }));
    };

    DisruptionAlertStore.prototype.setTimetableAlertsWidgetState = function setTimetableAlertsWidgetState(_ref4) {
        var formState = _ref4.formState;

        this.setState(this.state.merge({ timetableAlertsWidgetState: formState }));
    };

    DisruptionAlertStore.prototype.addTimetableAlert = function addTimetableAlert() {
        var item = this.state.timetableAlertsWidgetState;
        this.setState(this.state.merge({ timetableAlerts: this.state.timetableAlerts.push(item) }));
    };

    DisruptionAlertStore.prototype.getTimetableAlertsWidgetState = function getTimetableAlertsWidgetState() {
        return this.get('timetableAlertsWidgetState');
    };

    DisruptionAlertStore.prototype.getTimetableAlerts = function getTimetableAlerts() {
        return this.get('timetableAlerts');
    };

    DisruptionAlertStore.prototype.resetTimetableAlerts = function resetTimetableAlerts() {
        this.setState(this.state.merge({ timetableAlerts: new _immutable.List() }));
    };

    DisruptionAlertStore.prototype.getAlerts = function getAlerts() {
        return this.get('alerts');
    };

    DisruptionAlertStore.prototype.hasMatchingAlert = function hasMatchingAlert(_ref5) {
        var order = _ref5.order,
            orderTrip = _ref5.orderTrip;

        return this.getAlerts().filter(function (alert) {
            return alert.matchesOrderTrip(order, orderTrip);
        }).size;
    };

    DisruptionAlertStore.prototype.handleAlertCreated = function handleAlertCreated(_ref6) {
        var alert = _ref6.alert;

        var alerts = this.getAlerts().push(alert);
        this.handleAlertsLoaded({ alerts: alerts });
    };

    DisruptionAlertStore.prototype.handleAlertUpdated = function handleAlertUpdated(_ref7) {
        var alert = _ref7.alert;

        var alerts = this.getAlerts();
        var index = alerts.findIndex(function (x) {
            return x.id === alert.id;
        });
        alerts = alerts.setIn([index], alert);
        this.handleAlertsLoaded({ alerts: alerts });
    };

    DisruptionAlertStore.prototype.handleAlertDeleted = function handleAlertDeleted(_ref8) {
        var alert = _ref8.alert;

        var alerts = this.getAlerts().filterNot(function (x) {
            return x === alert;
        });
        this.handleAlertsLoaded({ alerts: alerts });
    };

    DisruptionAlertStore.prototype.handleTimetableAlertDeleted = function handleTimetableAlertDeleted(_ref9) {
        var alrt = _ref9.alrt;

        var alerts = this.getTimetableAlerts().filterNot(function (x) {
            return x === alrt;
        });
        this.handleServiceChangeAlertsLoaded({ timetableAlerts: alerts });
    };

    DisruptionAlertStore.prototype.handleAlertMuteCreated = function handleAlertMuteCreated(_ref10) {
        var alert = _ref10.alert,
            alertMute = _ref10.alertMute;

        var alerts = this.getAlerts();
        var index = alerts.findIndex(function (x) {
            return x.id === alert.id;
        });
        var updatedAlert = alert.set('mutes', alert.mutes.push(alertMute));
        alerts = alerts.setIn([index], updatedAlert);
        this.handleAlertsLoaded({ alerts: alerts });
    };

    /*
        TO DO: 
        
        This method has proven difficult to unit test and may not
        actually work as expected in all cases.
         It probably needs refactoring, unit testing and regression testing.
    */


    DisruptionAlertStore.prototype.handleAlertMuteUpdated = function handleAlertMuteUpdated(_ref11) {
        var alert = _ref11.alert,
            alertMute = _ref11.alertMute;

        var alerts = this.getAlerts();
        var alertIndex = alerts.findIndex(function (x) {
            return x.id === alert.id;
        });
        var alertMuteIndex = alerts.getIn([alertIndex, 'mutes']).findIndex(function (x) {
            return x.id === alertMute.id;
        });
        var updatedAlert = alert.setIn([alertIndex, 'mutes', alertMuteIndex], alertMute);
        alerts = alerts.setIn([alertIndex], updatedAlert);
        this.handleAlertsLoaded({ alerts: alerts });
    };

    DisruptionAlertStore.prototype.handleAlertMuteDeleted = function handleAlertMuteDeleted(_ref12) {
        var alert = _ref12.alert,
            alertMute = _ref12.alertMute;

        var alerts = this.getAlerts();
        var alertIndex = alerts.findIndex(function (x) {
            return x.id === alert.id;
        });
        var updatedAlert = alert.set('mutes', alert.mutes.filterNot(function (x) {
            return x === alertMute;
        }));
        alerts = alerts.setIn([alertIndex], updatedAlert);
        this.handleAlertsLoaded({ alerts: alerts });
    };

    DisruptionAlertStore.prototype.handleServiceSearchStarted = function handleServiceSearchStarted(_ref13) {
        var search = _ref13.search;

        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            servicesLoading: true
        }));
    };

    DisruptionAlertStore.prototype.handleServiceSearchFinished = function handleServiceSearchFinished(_ref14) {
        var search = _ref14.search,
            servicesList = _ref14.servicesList;

        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            services: new _Services2.default({ outward: servicesList }).orderForSearch(search),
            servicesLoading: false
        }));
    };

    DisruptionAlertStore.prototype.handleServiceSearchFailed = function handleServiceSearchFailed() {
        this.setState(this.state.merge({ servicesLoading: false }));
    };

    DisruptionAlertStore.prototype.handleServicesReset = function handleServicesReset() {
        this.setState(this.state.merge({ services: new _Services2.default() }));
    };

    DisruptionAlertStore.prototype.handleFetchBankHolidays = function handleFetchBankHolidays(_ref15) {
        var dates = _ref15.dates;

        this.setState(this.state.merge({ bankHolidays: dates }));
    };

    DisruptionAlertStore.prototype.getBankHolidays = function getBankHolidays() {
        return this.get('bankHolidays');
    };

    return DisruptionAlertStore;
}(_BaseStore3.default);

exports.default = new DisruptionAlertStore();

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.serialiseTrip = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var serialiseTrip = exports.serialiseTrip = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(trip) {
        var outwardFare, inwardFare, shouldReserve, body, smartcard, promo;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        outwardFare = trip.getOutwardFare();
                        inwardFare = trip.getInwardFare();
                        shouldReserve = trip.reservationPreferences.shouldReserve();
                        _context.t0 = {
                            outwardSingle: outwardFare && !outwardFare.isReturn() ? outwardFare.id : null,
                            returnSingle: inwardFare ? inwardFare.id : null,
                            "return": outwardFare && outwardFare.isReturn() ? outwardFare.id : null,
                            plusBus: serialisePlusBus(trip.getPlusBus()),
                            season: trip.hasSeasonFare() ? trip.getSeasonFare().id : null,
                            fareOnly: trip.hasFareOnlyFare() ? trip.getFareOnlyFare().id : null
                        };
                        _context.next = 6;
                        return serializeJourney(trip, _AppConstants.JourneyDirections.OUTWARD);

                    case 6:
                        _context.t1 = _context.sent;
                        _context.next = 9;
                        return serializeJourney(trip, _AppConstants.JourneyDirections.INWARD);

                    case 9:
                        _context.t2 = _context.sent;
                        _context.t3 = trip.isSmartcard();
                        _context.t4 = shouldReserve ? trip.reservationPreferences.toCodes() : null;
                        _context.t5 = trip.isSeatsRequested;
                        body = {
                            fares: _context.t0,
                            outwardJourney: _context.t1,
                            returnJourney: _context.t2,
                            itso: _context.t3,
                            reservationPreferences: _context.t4,
                            isSeatsRequested: _context.t5
                        };


                        if (trip.bikes >= 1) {
                            body.bikes = trip.bikes;
                        }

                        if (trip.isSmartcard()) {
                            smartcard = _SmartcardStore2.default.get('smartcard');

                            body.fares.passenger = { smartcardNumber: smartcard.isrn };
                        } else if (trip.hasSeasonFare()) {
                            body.fares.passenger = serializePassenger(trip);
                        } else if (trip.hasRoversRangersFare() && trip.getRoversRangersFare().ticketType.isFamilyRanger() && trip.passengers[0]) {
                            body.fares.passenger = { name: trip.passengers[0] };
                        }

                        promo = _PromoCodeStore2.default.getActive();

                        if (promo) {
                            body.fares.promoCode = promo.promoCode;
                        }

                        return _context.abrupt('return', body);

                    case 19:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function serialiseTrip(_x) {
        return _ref.apply(this, arguments);
    };
}();

var serialiseOrder = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(order, trip, channel) {
        var parser, user, loggedIn, enableTPEStaffRover, hasTranspennineStaffRover, familyVerificationEmail, getEmailAddress;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        parser = new _uaParserJs2.default(navigator.userAgent);
                        user = _UserStore2.default.getCurrent();
                        loggedIn = user.isLoggedIn();
                        enableTPEStaffRover = _FeatureFlagStore2.default.get('enableTPEStaffRover');
                        hasTranspennineStaffRover = trip ? trip.isTransPennineStaffRover() : false;
                        familyVerificationEmail = _FamilyVerificationStore2.default.getEmail();

                        getEmailAddress = function getEmailAddress() {
                            // Put Customer User Group email instead of logged in email for TransPennine Staff Rover
                            if (enableTPEStaffRover && hasTranspennineStaffRover && familyVerificationEmail) {
                                return familyVerificationEmail;
                            }

                            if (loggedIn) {
                                return user.email;
                            }

                            return null;
                        };

                        _context2.next = 9;
                        return serialiseTrip(trip);

                    case 9:
                        _context2.t0 = _context2.sent;
                        _context2.t1 = channel;
                        _context2.t2 = {
                            customer: loggedIn ? '/customers/' + user.id : null,
                            deviceName: 'WEBSITE',
                            udid: null,
                            appVersion: _appVersion2.default.version,
                            deviceType: parser.getDevice().type || 'unknown'
                        };
                        _context2.t3 = getEmailAddress();
                        return _context2.abrupt('return', {
                            trip: _context2.t0,
                            channel: _context2.t1,
                            referrer: null,
                            campaign: null,
                            device: _context2.t2,
                            email: _context2.t3
                        });

                    case 14:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function serialiseOrder(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

var _uaParserJs = __webpack_require__(1910);

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

var _APIClient = __webpack_require__(52);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _appVersion = __webpack_require__(351);

var _appVersion2 = _interopRequireDefault(_appVersion);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _DeliveryOption = __webpack_require__(443);

var _DeliveryOption2 = _interopRequireDefault(_DeliveryOption);

var _AddressService = __webpack_require__(543);

var _AddressService2 = _interopRequireDefault(_AddressService);

var _CallingPointsActions = __webpack_require__(1010);

var _CallingPointsActions2 = _interopRequireDefault(_CallingPointsActions);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _PromoCodeStore = __webpack_require__(342);

var _PromoCodeStore2 = _interopRequireDefault(_PromoCodeStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _Order3 = __webpack_require__(625);

var _Changeover = __webpack_require__(1913);

var _Changeover2 = _interopRequireDefault(_Changeover);

var _FamilyVerificationStore = __webpack_require__(638);

var _FamilyVerificationStore2 = _interopRequireDefault(_FamilyVerificationStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataUrl = '/orders';

function serialisePlusBus(plusBus) {

    return {
        outward: {
            origin: plusBus.getIn(['outward', 'origin', 'id'], null),
            destination: plusBus.getIn(['outward', 'destination', 'id'], null)
        },
        'return': {
            origin: plusBus.getIn(['return', 'origin', 'id'], null),
            destination: plusBus.getIn(['return', 'destination', 'id'], null)
        }
    };
}

function serializeLegs(legs, callingPoints) {
    return legs.reduce(function (result, leg) {
        var origin = callingPoints.getLegOrigin(leg);
        var destination = callingPoints.getLegDestination(leg);

        if (origin && destination) {
            result.push({
                origin: origin.id,
                destination: destination.id,
                trainOrigin: callingPoints.getTrainOriginStation(leg).id,
                trainDestination: callingPoints.getTrainDestinationStation(leg).id,
                departure: leg.getDepartureTime() && leg.getDepartureTime().format('YYYY-MM-DDTHH:mm:ss'),
                arrival: leg.getArrivalTime() && leg.getArrivalTime().format('YYYY-MM-DDTHH:mm:ss'),
                mode: leg.serviceDetails.mode,
                toc: leg.serviceDetails.getIn(['toc', 'id'], null),
                reservable: leg.serviceDetails.reservable || null,
                facilities: leg.serviceDetails.facilities.toJS(),
                rsid: leg.serviceDetails.retailServiceId || '',
                tuid: leg.serviceDetails.trainUid || '',
                isTemporaryTrain: leg.serviceDetails.isTemporaryTrain,
                transferTime: leg.transferTime
            });
        }
        return result;
    }, []);
}

function serializeJourney(trip, direction) {
    //Season fares & day save require an outwardJourney for some reason, so we add an empty one
    if (!trip.needsJourney() && direction === _AppConstants.JourneyDirections.OUTWARD) {
        return { reserve: false, legs: [] };
    }

    var service = trip.getServiceForDirection(direction);
    if (!service || typeof service.id !== 'string') {
        return { reserve: false, legs: [] };
    }

    return _CallingPointsActions2.default.getFromService(service).then(function (callingPoints) {
        var shouldReserve = trip.reservationPreferences.shouldReserveDirection(direction);

        var legs = serializeLegs(service.journey.legs, callingPoints);

        return {
            reserve: shouldReserve,
            legs: legs
        };
    });
}

function serializePassenger(trip) {
    return {
        name: trip.photocard.name,
        photocardId: trip.photocard.number
    };
}

function serializeDelivery(order, disableAddress) {
    var delivery = order.delivery;

    var result = {
        name: delivery.displayName,
        deliveryMethodId: delivery.deliveryMethodId,
        price: delivery.price,
        fulfilmentMethod: delivery.fulfilmentMethod,
        address: delivery.isPostalDelivery() && !disableAddress ? delivery.getAddress().toJS() : null,
        collectionStartDate: null,
        collectionWindowDays: null
    };

    if (delivery.isCollection()) {
        result.collectionLocation = (0, _get3.default)(order, 'delivery.collectionLocation.nlc');
    }

    var enableETicketByPost = _FeatureFlagStore2.default.get('enableETicketByPost');
    if (delivery.isPostalDelivery() && enableETicketByPost) {
        result.isPrintedEticket = (0, _get3.default)(order, 'delivery.isPrintedEticket');
    }

    if (delivery.isSmartcard()) {
        var collectionlocation = order.getSmartcardCollectionLocation();
        if ((0, _isEmpty3.default)(collectionlocation)) {
            var smartcard = _SmartcardStore2.default.get('smartcard');
            // Fill collection location with origin station data if preload and collection location is "still" empty
            if (!(0, _isEmpty3.default)(smartcard) && smartcard.isAwaitingProduct()) {
                collectionlocation = order.getFirstOrigin();
            }
        }

        (0, _assign2.default)(result, {
            collectionLocation: collectionlocation ? collectionlocation.nlc : null,
            collectionStartDate: order.getCollectionStartDate().format(),
            collectionWindowDays: delivery.collectionWindowDays
        });

        if (order.hasSmartCarnetTrip() && !result.collectionLocation) {
            result.collectionStartDate = null;
        }
    }

    return result;
}

function serializeLeadPassengers(trips) {
    return trips.reduce(function (result, trip) {
        result[trip.id] = String(trip.selfPrintPassenger);
        return result;
    }, {});
}

function serializePhotocards(photocards) {
    return photocards.map(function (e) {
        return {
            ticketId: e.ticketId,
            photocardDetails: {
                id: e.id,
                photocardNumber: e.number,
                linkCard: e.linkCard,
                nickName: e.nickname,
                cardHolder: {
                    title: e.title,
                    firstName: e.firstName,
                    lastName: e.lastName,
                    isOver16: e.isOver16,
                    dob: e.isOver16 ? null : e.yearOfBirth + '-' + String(e.monthOfBirth).padStart(2, '0') + '-' + String(e.dayOfBirth).padStart(2, '0'),
                    address: {
                        line1: e.addressLine1,
                        line2: e.addressLine2,
                        line3: e.addressLine3,
                        town: e.townCity,
                        country: e.country,
                        postCode: e.postcode
                    }
                }
            },
            smartcardDetails: null
        };
    });
}

function serializeSmartcards(trips, smartcard) {
    var user = _UserStore2.default.getCurrent();
    return trips.map(function (e) {
        return e.getTickets().map(function (ticket) {
            return {
                customerId: user.id,
                ticketId: ticket.id,
                photocardDetails: null,
                smartcardDetails: {
                    smartcardNumber: smartcard.isrn
                }
            };
        });
    }).get(0);
}

function serializeLinkedSmartcards(trips, linkedSmartcards) {
    var user = _UserStore2.default.getCurrent();

    var associatedSmartcards = _SmartcardStore2.default.getAssociatedSmartcards();

    var passengers = trips.flatMap(function (e) {
        return e.getTickets().filter(function (ticket) {
            return !!linkedSmartcards.get(ticket.id);
        }).map(function (ticket) {
            var smartcardNumber = linkedSmartcards.getIn([ticket.id, 'smartcard', 'associatedSmartcardNumber']) || linkedSmartcards.getIn([ticket.id, 'ticket', 'passenger', 'smartcardNumber']);

            var associatedCard = associatedSmartcards.find(function (card) {
                return card.associatedSmartcardNumber === smartcardNumber;
            });
            var customerId = associatedCard && associatedCard.customerId || user.id;

            return {
                customerId: customerId,
                ticketId: ticket.id,
                photocardDetails: null,
                smartcardDetails: {
                    smartcardNumber: smartcardNumber || null
                }
            };
        });
    });

    return passengers;
}

var OrderService = {
    create: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(order, trip) {
            var channel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "web";
            var serializedOrder, response, deviceToken;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return serialiseOrder(order, trip, channel);

                        case 3:
                            serializedOrder = _context3.sent;
                            _context3.next = 6;
                            return _AuthenticatedAPIClient2.default.post(dataUrl, serializedOrder);

                        case 6:
                            response = _context3.sent;
                            deviceToken = response.result.deviceToken;
                            return _context3.abrupt('return', { order: (0, _LinkMapper.resolve)(response.result).as(_Order2.default), deviceToken: deviceToken });

                        case 11:
                            _context3.prev = 11;
                            _context3.t0 = _context3['catch'](0);
                            throw (0, _Order3.throwCorrectOrderError)(_context3.t0);

                        case 14:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 11]]);
        }));

        function create(_x6, _x7) {
            return _ref3.apply(this, arguments);
        }

        return create;
    }(),
    addTrip: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(order, trip) {
            var url, output, serializedTrip, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            url = dataUrl + '/' + order.id + '/trips';
                            output = order;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return serialiseTrip(trip);

                        case 5:
                            serializedTrip = _context4.sent;
                            _context4.next = 8;
                            return _AuthenticatedAPIClient2.default.post(url, serializedTrip);

                        case 8:
                            response = _context4.sent;


                            output = (0, _LinkMapper.resolve)(response.result).as(_Order2.default);
                            _context4.next = 15;
                            break;

                        case 12:
                            _context4.prev = 12;
                            _context4.t0 = _context4['catch'](2);
                            throw (0, _Order3.throwCorrectOrderError)(_context4.t0);

                        case 15:
                            return _context4.abrupt('return', output);

                        case 16:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[2, 12]]);
        }));

        function addTrip(_x8, _x9) {
            return _ref4.apply(this, arguments);
        }

        return addTrip;
    }(),
    deleteTrip: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(orderTrip) {
            var response;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(orderTrip.id);

                        case 3:
                            response = _context5.sent;
                            return _context5.abrupt('return', response);

                        case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5['catch'](0);
                            throw (0, _Order3.throwCorrectOrderError)(_context5.t0);

                        case 10:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[0, 7]]);
        }));

        function deleteTrip(_x10) {
            return _ref5.apply(this, arguments);
        }

        return deleteTrip;
    }(),
    updatePassengers: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(order, orderTrip, passengers) {
            var url;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            url = orderTrip.id + '/passengers';
                            _context6.prev = 1;
                            _context6.next = 4;
                            return _AuthenticatedAPIClient2.default.put(url, passengers.getRequestJSON());

                        case 4:
                            return _context6.abrupt('return', true);

                        case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](1);
                            throw (0, _Order3.throwCorrectOrderError)(_context6.t0);

                        case 10:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[1, 7]]);
        }));

        function updatePassengers(_x11, _x12, _x13) {
            return _ref6.apply(this, arguments);
        }

        return updatePassengers;
    }(),
    updateFulfilment: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(order) {
            var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref8$disableAddress = _ref8.disableAddress,
                disableAddress = _ref8$disableAddress === undefined ? false : _ref8$disableAddress,
                _ref8$linkedSmartcard = _ref8.linkedSmartcards,
                linkedSmartcards = _ref8$linkedSmartcard === undefined ? [] : _ref8$linkedSmartcard;

            var url, user, requestBody, smartcard, hasSmartcardAwaitingProduct, validLinkedSmartcards, hasValidSmartcard, response, updated, storedAddress, isUserAddressValid;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            url = dataUrl + '/' + order.id;
                            user = _UserStore2.default.getCurrent();
                            requestBody = {
                                email: user.isLoggedIn() ? user.email : order.email,
                                telephoneNumber: user.isLoggedIn() ? user.telephoneNumber : order.telephoneNumber,
                                delivery: serializeDelivery(order, disableAddress)
                            };


                            if (order.delivery.isPrintAtHome()) {
                                requestBody.trips = serializeLeadPassengers(order.trips);
                            }

                            if (order.delivery.hasSeasonTrip(order.trips) && (order.delivery.isCollection() || order.delivery.isPostalDelivery())) {
                                if (order.delivery.photocards.every(function (photocard) {
                                    return photocard.isComplete();
                                })) {
                                    requestBody.passengers = serializePhotocards(order.delivery.photocards);
                                }
                            }

                            if (order.delivery.isSTicket() && order.delivery.sTicketPhotocard.isComplete()) {
                                requestBody.passengers = serializePhotocards([order.delivery.sTicketPhotocard]);
                            }

                            if (order.delivery.isSmartcard()) {
                                smartcard = _SmartcardStore2.default.get('smartcard');
                                hasSmartcardAwaitingProduct = smartcard && smartcard.cardStatus === _AppConstants.SmartcardStatus.AWAITING_PRODUCT;

                                /*
                                    if no pre-encode, remove invalid smartcards from linked cards
                                    (pre-encode card appears in linkedSmartcards as an 'invalid' card that is always present, even when no pre-encode exists)
                                */

                                validLinkedSmartcards = linkedSmartcards;


                                if (!hasSmartcardAwaitingProduct) {
                                    linkedSmartcards.filter(function (x) {
                                        return x.get('smartcard') && x.get('smartcard').associatedSmartcardNumber;
                                    });
                                }

                                hasValidSmartcard = smartcard && (smartcard.isAwaitingProduct() || smartcard.isActiveAndAvailableForMoreProducts());

                                // Fulfilment for PAH Smartcard only (includes pre-encode for PAH)

                                if (hasValidSmartcard && (!validLinkedSmartcards || validLinkedSmartcards.size < 1)) {
                                    requestBody.passengers = serializeSmartcards(order.trips, smartcard);
                                }

                                // Linked cards scenario (includes using user's own Smartcard with other Linked cards as this is counted as a 'linked' card)
                                if (validLinkedSmartcards && validLinkedSmartcards.size && validLinkedSmartcards.size > 0) {
                                    requestBody.passengers = serializeLinkedSmartcards(order.trips, validLinkedSmartcards);
                                }
                            }

                            _context7.prev = 7;

                            if (!(order.delivery.isSmartcard() && (!requestBody.passengers || requestBody.passengers.size < order.getTickets().size))) {
                                _context7.next = 10;
                                break;
                            }

                            return _context7.abrupt('return', order);

                        case 10:
                            _context7.next = 12;
                            return _AuthenticatedAPIClient2.default.put(url, requestBody);

                        case 12:
                            response = _context7.sent;
                            updated = (0, _LinkMapper.resolve)(response.result).as(_Order2.default);

                            if (!(order.delivery.isPostalDelivery() && order.delivery.address)) {
                                _context7.next = 26;
                                break;
                            }

                            updated = updated.setIn(['delivery', 'address', 'toSave'], order.delivery.address.toSave);

                            // Make the storedAddress available to the Payment Complete page
                            // so we can update any postal favourites' delivery address
                            // with a customer's saved address
                            storedAddress = order.delivery.storedAddress;

                            if (!storedAddress) {
                                _context7.next = 23;
                                break;
                            }

                            _context7.next = 20;
                            return _AddressService2.default.get(user, storedAddress.get('id'));

                        case 20:
                            _context7.t0 = _context7.sent;
                            _context7.next = 24;
                            break;

                        case 23:
                            _context7.t0 = null;

                        case 24:
                            isUserAddressValid = _context7.t0;

                            _OrderStore2.default.setPostalFulfilmentStoredAddress(storedAddress && isUserAddressValid ? storedAddress : null);

                        case 26:
                            return _context7.abrupt('return', updated);

                        case 29:
                            _context7.prev = 29;
                            _context7.t1 = _context7['catch'](7);
                            throw (0, _Order3.throwCorrectOrderError)(_context7.t1);

                        case 32:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[7, 29]]);
        }));

        function updateFulfilment(_x15) {
            return _ref7.apply(this, arguments);
        }

        return updateFulfilment;
    }(),
    get: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(id) {
            var response;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.prev = 0;
                            _context8.next = 3;
                            return _AuthenticatedAPIClient2.default.get(dataUrl + '/' + id);

                        case 3:
                            response = _context8.sent;

                            if (!response.result) {
                                _context8.next = 6;
                                break;
                            }

                            return _context8.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Order2.default));

                        case 6:
                            return _context8.abrupt('return', null);

                        case 9:
                            _context8.prev = 9;
                            _context8.t0 = _context8['catch'](0);

                            if (!(_context8.t0 instanceof _APIClient.NotFoundError)) {
                                _context8.next = 13;
                                break;
                            }

                            return _context8.abrupt('return', new _Order2.default());

                        case 13:
                            throw _context8.t0;

                        case 14:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this, [[0, 9]]);
        }));

        function get(_x16) {
            return _ref9.apply(this, arguments);
        }

        return get;
    }(),
    getDeliveryOptions: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(id, smartcard) {
            var queryParams, response, options, price, method, sorted, deliveryWithMockStatus;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            queryParams = _FeatureFlagStore2.default.get('enableSmartcardSeasonEnforcement') === true ? '?isEnforcementApplicable=true' : '';
                            _context9.next = 3;
                            return _AuthenticatedAPIClient2.default.get('/delivery/options/' + id + queryParams);

                        case 3:
                            response = _context9.sent;
                            options = (0, _LinkMapper.resolveAll)(response.result).as(_DeliveryOption2.default);


                            options.map(function (opt) {
                                if (opt.errors) {
                                    opt.errors.map(function (err) {
                                        if (err.GTRInteropFlexiFareFound) {
                                            throw new _Order3.InteropError();
                                        }
                                        return err;
                                    });
                                }
                            });

                            price = function price(option) {
                                return option.price;
                            };

                            method = function method(option) {
                                return option.getOrder();
                            };

                            sorted = options.sortBy(price).sortBy(method);

                            if (_FeatureFlagStore2.default.get('disableSelfPrint')) {
                                sorted = sorted.filter(function (option) {
                                    return !option.isPrintAtHome();
                                });
                            }
                            if (_FeatureFlagStore2.default.get('disableETickets')) {
                                sorted = sorted.filter(function (option) {
                                    return !option.isETicket();
                                });
                            }
                            if (_FeatureFlagStore2.default.get('disableTOD')) {
                                sorted = sorted.filter(function (option) {
                                    return !option.isCollection();
                                });
                            }
                            if (_FeatureFlagStore2.default.get('disableCCST')) {
                                sorted = sorted.filter(function (option) {
                                    return !option.isPostalDelivery();
                                });
                            }

                            if (!(!_FeatureFlagStore2.default.get('enableProductPreload') && smartcard && smartcard.isAwaitingProduct())) {
                                _context9.next = 16;
                                break;
                            }

                            deliveryWithMockStatus = sorted.map(function (deliveryMethod) {
                                if (deliveryMethod.fulfilmentMethod === _AppConstants.FulfilmentType.SMARTCARD) {
                                    if (deliveryMethod.errors) {
                                        return deliveryMethod.set('errors', deliveryMethod.errors.concat({ DisabledPreEncodeError: {} }));
                                    } else {
                                        return deliveryMethod.set('errors', [{ DisabledPreEncodeError: {} }]);
                                    }
                                } else {
                                    return deliveryMethod;
                                }
                            });
                            return _context9.abrupt('return', deliveryWithMockStatus);

                        case 16:
                            return _context9.abrupt('return', sorted);

                        case 17:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function getDeliveryOptions(_x17, _x18) {
            return _ref10.apply(this, arguments);
        }

        return getDeliveryOptions;
    }(),
    delete: function _delete(order) {
        return _AuthenticatedAPIClient2.default.delete(dataUrl + '/' + order.id);
    },
    updatePlusBus: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(order, orderTrip, trip) {
            var url, body, response;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            url = dataUrl + '/' + order.id + '/trips/' + orderTrip.getCleanId() + '/plusbus';
                            body = {
                                plusBus: serialisePlusBus(trip.getPlusBus())
                            };
                            _context10.prev = 2;
                            _context10.next = 5;
                            return _AuthenticatedAPIClient2.default.put(url, body);

                        case 5:
                            response = _context10.sent;
                            return _context10.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Order2.default));

                        case 9:
                            _context10.prev = 9;
                            _context10.t0 = _context10['catch'](2);
                            throw (0, _Order3.throwCorrectOrderError)(_context10.t0);

                        case 12:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this, [[2, 9]]);
        }));

        function updatePlusBus(_x19, _x20, _x21) {
            return _ref11.apply(this, arguments);
        }

        return updatePlusBus;
    }(),
    getTicketUrl: function getTicketUrl(order, ticket) {
        return '/orders/' + order.id + '/tickets/' + ticket.id + '.pdf';
    },
    deleteSTicketPhoto: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(userId) {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.prev = 0;
                            _context11.next = 3;
                            return _AuthenticatedAPIClient2.default.delete('stickets/' + userId + '/image');

                        case 3:
                            _context11.next = 8;
                            break;

                        case 5:
                            _context11.prev = 5;
                            _context11.t0 = _context11['catch'](0);
                            throw _context11.t0;

                        case 8:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this, [[0, 5]]);
        }));

        function deleteSTicketPhoto(_x22) {
            return _ref12.apply(this, arguments);
        }

        return deleteSTicketPhoto;
    }(),
    updateSTicketPhoto: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(userId, binary) {
            var response;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.prev = 0;
                            _context12.next = 3;
                            return _AuthenticatedAPIClient2.default.postForm('/stickets/' + userId + '/image', {
                                photo: new Blob([binary])
                            });

                        case 3:
                            response = _context12.sent;
                            return _context12.abrupt('return', (0, _LinkMapper.resolve)(response.result));

                        case 7:
                            _context12.prev = 7;
                            _context12.t0 = _context12['catch'](0);
                            throw _context12.t0;

                        case 10:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this, [[0, 7]]);
        }));

        function updateSTicketPhoto(_x23, _x24) {
            return _ref13.apply(this, arguments);
        }

        return updateSTicketPhoto;
    }(),
    sendSTicketPhotoChangeRequest: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(userId, binary) {
            var response;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.prev = 0;
                            _context13.next = 3;
                            return _AuthenticatedAPIClient2.default.postForm('/stickets/' + userId + '/image/change', {
                                photo: new Blob([binary])
                            });

                        case 3:
                            response = _context13.sent;
                            return _context13.abrupt('return', (0, _LinkMapper.resolve)(response.result));

                        case 7:
                            _context13.prev = 7;
                            _context13.t0 = _context13['catch'](0);
                            throw _context13.t0;

                        case 10:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this, [[0, 7]]);
        }));

        function sendSTicketPhotoChangeRequest(_x25, _x26) {
            return _ref14.apply(this, arguments);
        }

        return sendSTicketPhotoChangeRequest;
    }(),
    getSTicketPhoto: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(userId) {
            var response;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.prev = 0;
                            _context14.next = 3;
                            return _AuthenticatedAPIClient2.default.get('/stickets/' + userId + '/image', {}, { validErrorStatuses: [404] });

                        case 3:
                            response = _context14.sent;
                            return _context14.abrupt('return', response);

                        case 7:
                            _context14.prev = 7;
                            _context14.t0 = _context14['catch'](0);
                            throw _context14.t0;

                        case 10:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this, [[0, 7]]);
        }));

        function getSTicketPhoto(_x27) {
            return _ref15.apply(this, arguments);
        }

        return getSTicketPhoto;
    }(),
    linkToAccount: function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(token, email) {
            var url, requestBody, requestOptions, response;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            url = dataUrl + '/linking';
                            requestBody = { email: email };
                            requestOptions = { headers: { 'x-jwt-token': token } };
                            _context15.prev = 3;
                            _context15.next = 6;
                            return _AuthenticatedAPIClient2.default.post(url, requestBody, requestOptions);

                        case 6:
                            response = _context15.sent;
                            return _context15.abrupt('return', (0, _LinkMapper.resolve)(response.result));

                        case 10:
                            _context15.prev = 10;
                            _context15.t0 = _context15['catch'](3);
                            throw _context15.t0;

                        case 13:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this, [[3, 10]]);
        }));

        function linkToAccount(_x28, _x29) {
            return _ref16.apply(this, arguments);
        }

        return linkToAccount;
    }(),
    applyDiscountCode: function () {
        var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(order, discountCode) {
            var url, requestBody, response;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            url = dataUrl + '/' + order.id + '/discount/trainhugger';
                            requestBody = { discountCode: discountCode };
                            _context16.prev = 2;
                            _context16.next = 5;
                            return _AuthenticatedAPIClient2.default.put(url, requestBody);

                        case 5:
                            response = _context16.sent;
                            return _context16.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Order2.default));

                        case 9:
                            _context16.prev = 9;
                            _context16.t0 = _context16['catch'](2);
                            throw _context16.t0;

                        case 12:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, this, [[2, 9]]);
        }));

        function applyDiscountCode(_x30, _x31) {
            return _ref17.apply(this, arguments);
        }

        return applyDiscountCode;
    }(),
    removeDiscountCode: function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(order, discountCode) {
            var url, response;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            url = dataUrl + '/' + order.id + '/discount/' + discountCode + '/trainhugger';
                            _context17.prev = 1;
                            _context17.next = 4;
                            return _AuthenticatedAPIClient2.default.delete(url);

                        case 4:
                            response = _context17.sent;
                            return _context17.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Order2.default));

                        case 8:
                            _context17.prev = 8;
                            _context17.t0 = _context17['catch'](1);
                            throw _context17.t0;

                        case 11:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, this, [[1, 8]]);
        }));

        function removeDiscountCode(_x32, _x33) {
            return _ref18.apply(this, arguments);
        }

        return removeDiscountCode;
    }(),
    lock: function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(order) {
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            return _context18.abrupt('return', _AuthenticatedAPIClient2.default.put('/orders/' + order.id + '/lock'));

                        case 1:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, this);
        }));

        function lock(_x34) {
            return _ref19.apply(this, arguments);
        }

        return lock;
    }(),
    unlock: function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(order) {
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            return _context19.abrupt('return', _AuthenticatedAPIClient2.default.delete('/orders/' + order.id + '/lock'));

                        case 1:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, this);
        }));

        function unlock(_x35) {
            return _ref20.apply(this, arguments);
        }

        return unlock;
    }(),
    loadChangeovers: function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(order, customerId) {
            var response;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            _context20.next = 2;
                            return _AuthenticatedAPIClient2.default.get('/changeover/order/' + order.id + '/customer/' + customerId);

                        case 2:
                            response = _context20.sent;
                            return _context20.abrupt('return', (0, _LinkMapper.resolveAll)(response).as(_Changeover2.default));

                        case 4:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, this);
        }));

        function loadChangeovers(_x36, _x37) {
            return _ref21.apply(this, arguments);
        }

        return loadChangeovers;
    }(),
    validateRewardCode: function () {
        var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(_ref22) {
            var orderId = _ref22.orderId,
                customerId = _ref22.customerId,
                rewardCode = _ref22.rewardCode;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            return _context21.abrupt('return', _AuthenticatedAPIClient2.default.post('/rewards/' + orderId + '/validate', {
                                customerId: customerId,
                                rewardCode: rewardCode
                            }));

                        case 1:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, this);
        }));

        function validateRewardCode(_x38) {
            return _ref23.apply(this, arguments);
        }

        return validateRewardCode;
    }()
};

exports.default = OrderService;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

var _interopRequireWildcard = __webpack_require__(89);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _parseInt2 = _interopRequireDefault(__webpack_require__(910));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _style = _interopRequireDefault(__webpack_require__(263));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireWildcard(__webpack_require__(408));

var _capitalize = _interopRequireDefault(__webpack_require__(941));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _collapseStyles;

var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
}; // reading a dimension prop will cause the browser to recalculate,
// which will let our animations work

function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem["offset" + (0, _capitalize.default)(dimension)];
  var margins = MARGINS[dimension];
  return value + (0, _parseInt2.default)((0, _style.default)(elem, margins[0]), 10) + (0, _parseInt2.default)((0, _style.default)(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[_Transition.EXITED] = 'collapse', _collapseStyles[_Transition.EXITING] = 'collapsing', _collapseStyles[_Transition.ENTERING] = 'collapsing', _collapseStyles[_Transition.ENTERED] = 'collapse in', _collapseStyles);
var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: _propTypes.default.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: _propTypes.default.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: _propTypes.default.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: _propTypes.default.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: _propTypes.default.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: _propTypes.default.oneOfType([_propTypes.default.oneOf(['height', 'width']), _propTypes.default.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: _propTypes.default.func,

  /**
   * ARIA role of collapsible element
   */
  role: _propTypes.default.string
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      triggerBrowserReflow(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }; // for testing


  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem["scroll" + (0, _capitalize.default)(dimension)] + "px";
  };
  /* -- Expanding -- */


  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);
    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = (0, _createChainedFunction.default)(this.handleEnter, onEnter);
    var handleEntering = (0, _createChainedFunction.default)(this.handleEntering, onEntering);
    var handleEntered = (0, _createChainedFunction.default)(this.handleEntered, onEntered);
    var handleExit = (0, _createChainedFunction.default)(this.handleExit, onExit);
    var handleExiting = (0, _createChainedFunction.default)(this.handleExiting, onExiting);
    return _react.default.createElement(_Transition.default, (0, _extends2.default)({}, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
        className: (0, _classnames.default)(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(_react.default.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
var _default = Collapse;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LinkingSmartcardsStore = exports.hasLinkedSmartcard = exports.LinkedSmartcardTypes = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ref2;

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkedSmartcardTypes = exports.LinkedSmartcardTypes = {
    ADULTS: 'adults',
    CHILDREN: 'children'
};

var hasLinkedSmartcard = exports.hasLinkedSmartcard = function hasLinkedSmartcard(_ref) {
    var linkedSmartcards = _ref.linkedSmartcards,
        smartcard = _ref.smartcard;

    return linkedSmartcards.map(function (link) {
        return link.getIn(['smartcard', 'associatedSmartcardNumber']);
    }).toList().includes(smartcard.associatedSmartcardNumber);
};

var DefaultState = new _immutable.Record((_ref2 = {}, _ref2[LinkedSmartcardTypes.ADULTS] = new _immutable.Map(), _ref2[LinkedSmartcardTypes.CHILDREN] = new _immutable.Map(), _ref2));

var LinkingSmartcardsStore = exports.LinkingSmartcardsStore = function (_BaseStore) {
    (0, _inherits3.default)(LinkingSmartcardsStore, _BaseStore);

    function LinkingSmartcardsStore() {
        (0, _classCallCheck3.default)(this, LinkingSmartcardsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    LinkingSmartcardsStore.prototype.getInitialState = function getInitialState() {
        return new DefaultState();
    };

    LinkingSmartcardsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.LINKING_SMARTCARDS_LINK] = this.handleLink, _ref3[_AppConstants.ActionTypes.ORDER_CREATED] = this.resetState, _ref3[_AppConstants.ActionTypes.ORDER_UPDATED] = this.handleOrderUpdated, _ref3;
    };

    LinkingSmartcardsStore.prototype.getAllLinkedSmartcards = function getAllLinkedSmartcards() {
        return this.getAdultsLinkedSmartcards().merge(this.getChildrenLinkedSmartcards());
    };

    LinkingSmartcardsStore.prototype.getAdultsLinkedSmartcards = function getAdultsLinkedSmartcards() {
        return this.state.get(LinkedSmartcardTypes.ADULTS);
    };

    LinkingSmartcardsStore.prototype.getAdultsLinkedSmartcardsForFare = function getAdultsLinkedSmartcardsForFare(ids) {
        return this.getAdultsLinkedSmartcards().filter(function (linked) {
            return ids.includes(linked.getIn(['ticket', 'id']));
        }).map(function (result) {
            return result.get('smartcard');
        }).sortBy(function (result) {
            return result.get('customerName');
        }).toList();
    };

    LinkingSmartcardsStore.prototype.getChildrenLinkedSmartcards = function getChildrenLinkedSmartcards() {
        return this.state.get(LinkedSmartcardTypes.CHILDREN);
    };

    LinkingSmartcardsStore.prototype.getChildrenLinkedSmartcardsForFare = function getChildrenLinkedSmartcardsForFare(ids) {
        return this.getChildrenLinkedSmartcards().filter(function (linked) {
            return ids.includes(linked.getIn(['ticket', 'id']));
        }).map(function (result) {
            return result.get('smartcard');
        }).sortBy(function (result) {
            return result.get('customerName');
        }).toList();
    };

    LinkingSmartcardsStore.prototype.linkSmartcard = function linkSmartcard(_ref4) {
        var type = _ref4.type,
            smartcard = _ref4.smartcard,
            ticket = _ref4.ticket;

        var linkedSmartcards = this.state.get(type);

        var newState = linkedSmartcards.filter(function (link) {
            return smartcard.associatedSmartcardNumber !== link.getIn(['smartcard', 'associatedSmartcardNumber']);
        });

        newState = newState.set(ticket.id, new _immutable.Map({ smartcard: smartcard, ticket: ticket }));

        this.setState(this.state.set(type, newState));
    };

    LinkingSmartcardsStore.prototype.unlinkSmartcard = function unlinkSmartcard(_ref5) {
        var type = _ref5.type,
            ticket = _ref5.ticket;

        var linkedSmartcards = this.state.get(type);

        var newState = linkedSmartcards.delete(ticket.id);

        this.setState(this.state.set(type, newState));
    };

    LinkingSmartcardsStore.prototype.handleLink = function handleLink(_ref6) {
        var smartcard = _ref6.smartcard,
            ticket = _ref6.ticket;

        var type = ticket.children > 0 && ticket.adults === 0 ? LinkedSmartcardTypes.CHILDREN : LinkedSmartcardTypes.ADULTS;

        if (smartcard) {
            this.linkSmartcard({ type: type, smartcard: smartcard, ticket: ticket });
        } else {
            this.unlinkSmartcard({ type: type, ticket: ticket });
        }
    };

    LinkingSmartcardsStore.prototype.handleOrderUpdated = function handleOrderUpdated(_ref7) {
        var _this2 = this;

        var order = _ref7.order;

        var linkingSmartcardsEnabled = _FeatureFlagStore2.default.get('enableSmartcardAssociations');

        if (!linkingSmartcardsEnabled) {
            return;
        }

        var tickets = order.getTickets();

        [LinkedSmartcardTypes.ADULTS, LinkedSmartcardTypes.CHILDREN].map(function (type) {
            var linkedSmartcards = _this2.state.get(type);

            // Remove a linked smartcard if a ticket is no longer in the basket
            var newState = linkedSmartcards.filter(function (link, ticketId) {
                return tickets.some(function (ticket) {
                    return ticket.id === ticketId;
                });
            });

            _this2.setState(_this2.state.set(type, newState));
        });
    };

    LinkingSmartcardsStore.prototype.resetState = function resetState() {
        return this.setState(this.getInitialState());
    };

    return LinkingSmartcardsStore;
}(_BaseStore3.default);

exports.default = new LinkingSmartcardsStore({
    storageKey: 'linking-smartcards',
    expires: 30 * 60
});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _DeliveryOption = __webpack_require__(443);

var _DeliveryOption2 = _interopRequireDefault(_DeliveryOption);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _Photocard = __webpack_require__(279);

var _Photocard2 = _interopRequireDefault(_Photocard);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AppConstants = __webpack_require__(6);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _STicketDelivery = __webpack_require__(1062);

var _STicketDelivery2 = _interopRequireDefault(_STicketDelivery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    deliveryMethodId: null,
    fulfilmentMethod: null,
    displayName: null,
    internalName: null,
    price: null,
    isTrackable: null,
    isSignedFor: null,
    isPrintedEticket: null,
    address: new _Address2.default(),
    photocards: new _immutable.List(),
    sTicketPhotocard: new _Photocard2.default(),
    sTicketDelivery: new _STicketDelivery2.default(),
    storedAddress: null,
    collectionLocation: null,
    collectionStartDate: null,
    collectionWindowDays: 9,
    collectionPoints: null
};

var OrderFulfilment = function (_record) {
    (0, _inherits3.default)(OrderFulfilment, _record);

    function OrderFulfilment() {
        (0, _classCallCheck3.default)(this, OrderFulfilment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderFulfilment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(OrderFulfilment, json, {
            id: _LinkMapper.fields.number,
            deliveryMethodId: _LinkMapper.fields.string,
            fulfilmentMethod: _LinkMapper.fields.string,
            displayName: _LinkMapper.fields.string,
            internalName: _LinkMapper.fields.string,
            price: _LinkMapper.fields.number,
            isTrackable: _LinkMapper.fields.bool,
            isSignedFor: _LinkMapper.fields.bool,
            isPrintedEticket: _LinkMapper.fields.bool,
            storedAddress: (0, _LinkMapper.resolve)(json.storedAddress).as(_Address2.default),
            address: (0, _LinkMapper.resolve)(json.address).as(_Address2.default) || new _Address2.default(),
            photocards: (0, _LinkMapper.resolveAll)(json.photocards).as(_Photocard2.default) || new _immutable.List(),
            collectionLocation: (0, _LinkMapper.resolve)(json.collectionLocation).as(_Station2.default),
            collectionStartDate: (0, _LinkMapper.resolve)(json.collectionStartDate).with(_TrainTime2.default),
            collectionWindowDays: (0, _LinkMapper.resolve)(json.collectionWindowDays).with(Number) - 1,
            collectionPoints: _LinkMapper.fields.bool
        });
    };

    /*
     * Only return keys related to the selected delivery method
     */


    OrderFulfilment.prototype.getPruned = function getPruned() {
        var additionalFields = {};

        if (this.isCollection()) {
            additionalFields = (0, _extends3.default)({}, this.collectionLocation && { collectionLocation: this.collectionLocation.nlc }, {
                collectionStartDate: this.collectionStartDate,
                collectionWindowDays: this.collectionWindowDays
            });
        } else if (this.isPostalDelivery()) {
            var enableETicketByPost = _FeatureFlagStore2.default.get('enableETicketByPost');
            additionalFields = (0, _extends3.default)({
                address: this.address ? this.address.id : null,
                isSignedFor: this.isSignedFor
            }, enableETicketByPost && { isPrintedEticket: this.isPrintedEticket }, {
                isTrackable: this.isTrackable,
                price: this.price
            });
        }

        return (0, _extends3.default)({
            deliveryMethodId: this.deliveryMethodId,
            displayName: this.displayName,
            fulfilmentMethod: this.fulfilmentMethod
        }, additionalFields);
    };

    OrderFulfilment.prototype.getAddress = function getAddress() {
        return this.storedAddress || this.address;
    };

    OrderFulfilment.prototype.requiresLocation = function requiresLocation() {
        return this.isCollection() || this.isSmartcard() && this.collectionPoints;
    };

    OrderFulfilment.prototype.hasFulfilmentMethod = function hasFulfilmentMethod() {
        return Boolean(this.fulfilmentMethod);
    };

    OrderFulfilment.prototype.isPrintAtHome = function isPrintAtHome() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.PRINT_AT_HOME;
    };

    OrderFulfilment.prototype.isETicket = function isETicket() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.E_TICKET;
    };

    OrderFulfilment.prototype.isSTicket = function isSTicket() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.S_TICKET;
    };

    OrderFulfilment.prototype.isCollection = function isCollection() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.COLLECTION;
    };

    OrderFulfilment.prototype.isPostalDelivery = function isPostalDelivery() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.POSTAL;
    };

    OrderFulfilment.prototype.isETicketByPost = function isETicketByPost() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.POSTAL && this.isPrintedEticket;
    };

    OrderFulfilment.prototype.isSmartcard = function isSmartcard() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.SMARTCARD;
    };

    OrderFulfilment.prototype.hasCollectionLocation = function hasCollectionLocation() {
        return !!this.collectionLocation;
    };

    OrderFulfilment.prototype.hasSeasonTrip = function hasSeasonTrip(trips) {
        return trips.some(function (trip) {
            return trip.getSeasonFare();
        });
    };

    OrderFulfilment.prototype.numberOfSeasonTrips = function numberOfSeasonTrips(trips) {
        return trips.filter(function (trip) {
            return trip.getSeasonFare();
        }).size;
    };

    OrderFulfilment.prototype.isValid = function isValid() {
        var trips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();

        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$disableAddressCh = _ref.disableAddressCheck,
            disableAddressCheck = _ref$disableAddressCh === undefined ? false : _ref$disableAddressCh,
            _ref$linkedSmartcards = _ref.linkedSmartcards,
            linkedSmartcards = _ref$linkedSmartcards === undefined ? false : _ref$linkedSmartcards;

        var smartCardDelivery = arguments[2];

        if (this.hasSeasonTrip(trips) && !this.photocards.every(function (e) {
            return e.isComplete();
        }) && !this.isSmartcard() && !this.isSTicket()) {
            return false; // TODO[limal] CORE-8307 no error message for user
        } else if (this.requiresLocation()) {
            var isValidCollection = !!this.collectionLocation;
            var enableSmartcardAssociations = _FeatureFlagStore2.default.get('enableSmartcardAssociations');

            if (this.isSmartcard()) {
                var isLinkedSmartcardsValid = true;
                if (enableSmartcardAssociations && linkedSmartcards) {
                    var tickets = trips.map(function (trip) {
                        return trip.getProducts();
                    }).flatten(1).map(function (fare) {
                        return fare.tickets;
                    }).flatten(1);
                    isLinkedSmartcardsValid = tickets.size === linkedSmartcards.size;
                }

                return isLinkedSmartcardsValid && isValidCollection;
            }

            return isValidCollection;
        } else if (this.isPostalDelivery()) {
            if (this.storedAddress) {
                return true;
            } else {
                return disableAddressCheck ? true : (0, _result3.default)(this.address, 'isComplete');
            }
        } else if (this.isPrintAtHome()) {
            return trips.every(function (trip) {
                return trip.selfPrintPassenger.isComplete();
            });
        } else if (this.isETicket()) {
            return true; // ticket is send to e-mail passed to payment form
        } else if (this.isSmartcard() && !smartCardDelivery.errors) {
            return true;
        } else if (this.isSTicket()) {
            return this.sTicketPhotocard.isComplete() && this.sTicketDelivery.isComplete();
        }

        return false;
    };

    OrderFulfilment.prototype.setOption = function setOption(option) {
        var _this2 = this;

        option = option || new _DeliveryOption2.default();
        var updated = this.merge({
            deliveryMethodId: option.id,
            fulfilmentMethod: option.fulfilmentMethod,
            displayName: option.displayName,
            internalName: option.internalName,
            price: option.price,
            isTrackable: option.isTrackable,
            isSignedFor: option.isSignedFor,
            collectionPoints: option.collectionPoints && option.collectionPoints.size > 0
        });

        var enableETicketByPost = _FeatureFlagStore2.default.get('enableETicketByPost');

        if (enableETicketByPost) {
            updated = updated.set('isPrintedEticket', option.isPrintedEticket);
        }

        if (updated.requiresLocation()) {
            if (option.collectionPoints.size) {
                var stillAvailable = this.collectionLocation && !!option.collectionPoints.find(function (point) {
                    return point.nlc === _this2.collectionLocation.nlc;
                });
                if (!stillAvailable) {
                    updated = updated.set('collectionLocation', option.suggestedCollectionPoint || null);
                }
            } else {
                updated = updated.set('collectionLocation', null);
            }
        }

        return updated;
    };

    return OrderFulfilment;
}((0, _immutable.Record)(defaults));

exports.default = OrderFulfilment;

/***/ }),
/* 350 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var appVersion = '0.0.0';

exports.default = {
    get version() {
        return appVersion;
    },

    get versionWithoutHotfix() {
        var dashIndex = appVersion.indexOf("-");

        if (dashIndex > -1) {
            return appVersion.substring(0, dashIndex);
        }
        return appVersion;
    },

    set version(version) {
        appVersion = version;
    }
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmazonLoginStore = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultAmazonLoginState = new _immutable.Record({
    amazonEmail: null,
    accessToken: null,
    customer: null,
    hasLoginCompleted: false,
    isProcessing: false,
    status: null,
    isAmazonUser: true
});

var AmazonLoginStore = exports.AmazonLoginStore = function (_BaseStore) {
    (0, _inherits3.default)(AmazonLoginStore, _BaseStore);

    function AmazonLoginStore() {
        (0, _classCallCheck3.default)(this, AmazonLoginStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    AmazonLoginStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return new DefaultAmazonLoginState({
                accessToken: serialized.accessToken
            });
        }
        return new DefaultAmazonLoginState();
    };

    AmazonLoginStore.prototype.handleEmail = function handleEmail(_ref) {
        var amazonEmail = _ref.amazonEmail;

        this.setState(this.state.set('amazonEmail', amazonEmail));
    };

    AmazonLoginStore.prototype.handleLoginAccessToken = function handleLoginAccessToken(_ref2) {
        var accessToken = _ref2.accessToken,
            hasLoginCompleted = _ref2.hasLoginCompleted,
            status = _ref2.status;

        var accessTokenProp = accessToken ? { accessToken: accessToken } : null;
        var statusProp = status ? { status: status } : null;

        this.setState(this.state.merge((0, _extends3.default)({}, accessTokenProp, {
            hasLoginCompleted: hasLoginCompleted
        }, statusProp)));
    };

    AmazonLoginStore.prototype.handleProcessingFinished = function handleProcessingFinished() {
        this.setState(this.state.set('isProcessing', false));
    };

    AmazonLoginStore.prototype.handleProcessingStarted = function handleProcessingStarted() {
        this.setState(this.state.merge({
            status: null,
            isProcessing: true
        }));
    };

    AmazonLoginStore.prototype.handleStatus = function handleStatus(_ref3) {
        var status = _ref3.status,
            customer = _ref3.customer;

        // Do not clear the customer if it's undefined
        var customerProps = typeof customer === 'undefined' ? null : { customer: customer };

        this.setState(this.state.merge((0, _extends3.default)({
            status: status
        }, customerProps)));
    };

    AmazonLoginStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref4;

        return _ref4 = {}, _ref4[_AppConstants.ActionTypes.AMAZON_LOGIN_LOGIN_ACCESS_TOKEN] = this.handleLoginAccessToken, _ref4[_AppConstants.ActionTypes.AMAZON_LOGIN_EMAIL] = this.handleEmail, _ref4[_AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_FINISHED] = this.handleProcessingFinished, _ref4[_AppConstants.ActionTypes.AMAZON_LOGIN_PROCESSING_STARTED] = this.handleProcessingStarted, _ref4[_AppConstants.ActionTypes.AMAZON_LOGIN_STATUS] = this.handleStatus, _ref4;
    };

    AmazonLoginStore.prototype.getAccessToken = function getAccessToken() {
        return this.get('accessToken');
    };

    AmazonLoginStore.prototype.getAmazonEmail = function getAmazonEmail() {
        return this.get('amazonEmail');
    };

    AmazonLoginStore.prototype.getCustomer = function getCustomer() {
        var customer = this.get('customer');
        return customer ? customer.toJS() : null;
    };

    AmazonLoginStore.prototype.getHasLoginCompleted = function getHasLoginCompleted() {
        return this.get('hasLoginCompleted');
    };

    AmazonLoginStore.prototype.getIsProcessing = function getIsProcessing() {
        return this.get('isProcessing');
    };

    AmazonLoginStore.prototype.getStatus = function getStatus() {
        return this.get('status');
    };

    return AmazonLoginStore;
}(_BaseStore3.default);

var instance = new AmazonLoginStore();

exports.default = instance;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Railcard = __webpack_require__(241);

var _Railcard2 = _interopRequireDefault(_Railcard);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    adults: 0,
    children: 0,
    price: null,
    railcard: new _Railcard2.default(),
    railcardDiscount: 0,
    ticketTypeOverride: null,
    statusCode: null,
    amended: false,
    promotionalDiscountId: null
};

var Ticket = function (_record) {
    (0, _inherits3.default)(Ticket, _record);

    function Ticket() {
        (0, _classCallCheck3.default)(this, Ticket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Ticket.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Ticket({
            adults: (0, _LinkMapper.resolve)(json.adults).with(Number),
            children: (0, _LinkMapper.resolve)(json.children).with(Number),
            price: (0, _LinkMapper.resolve)(json.price).with(Number),
            railcard: (0, _LinkMapper.resolve)(json.railcard).as(_Railcard2.default),
            railcardDiscount: (0, _LinkMapper.resolve)(json.railcardDiscount).with(Number),
            ticketTypeOverride: (0, _LinkMapper.resolve)(json.ticketTypeOverride).as(_TicketType2.default),
            statusCode: (0, _LinkMapper.resolve)(json.statusCode).with(String),
            amended: (0, _LinkMapper.resolve)(json.amended).with(Boolean),
            promotionalDiscountId: (0, _LinkMapper.resolve)(json.promotionalDiscountId).with(Number)
        });
    };

    Ticket.prototype.isGroupSave = function isGroupSave() {
        return this.railcard && this.railcard.isGroupSave();
    };

    Ticket.prototype.hasRailcard = function hasRailcard(railcard) {
        return this.railcard && this.railcard.code === railcard.code;
    };

    Ticket.prototype.hasPromoDiscount = function hasPromoDiscount() {
        return !!this.promotionalDiscountId;
    };

    return Ticket;
}((0, _immutable.Record)(defaults));

exports.default = Ticket;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultConsents = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaultConsents;

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultConsents = exports.defaultConsents = (_defaultConsents = {}, _defaultConsents[_AppConstants.CONSENTS.PHONE] = '', _defaultConsents[_AppConstants.CONSENTS.EMAIL_MARKETING] = false, _defaultConsents[_AppConstants.CONSENTS.PUSH_MARKETING] = false, _defaultConsents[_AppConstants.CONSENTS.SMS_Marketing] = false, _defaultConsents[_AppConstants.CONSENTS.OVER_16] = false, _defaultConsents);

var ConsentsForm = function (_record) {
    (0, _inherits3.default)(ConsentsForm, _record);

    function ConsentsForm() {
        (0, _classCallCheck3.default)(this, ConsentsForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ConsentsForm.fromJSON = function fromJSON() {
        var _construct;

        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(ConsentsForm, json, (_construct = {}, _construct[_AppConstants.CONSENTS.PHONE] = _LinkMapper.fields.number, _construct[_AppConstants.CONSENTS.EMAIL_MARKETING] = _LinkMapper.fields.boolean, _construct[_AppConstants.CONSENTS.PUSH_MARKETING] = _LinkMapper.fields.boolean, _construct[_AppConstants.CONSENTS.SMS_Marketing] = _LinkMapper.fields.boolean, _construct[_AppConstants.CONSENTS.OVER_16] = _LinkMapper.fields.boolean, _construct));
    };

    ConsentsForm.prototype.getSchema = function getSchema() {
        var _ref;

        if (!this.get(_AppConstants.CONSENTS.SMS_Marketing)) {
            return {};
        }

        return _ref = {}, _ref[_AppConstants.CONSENTS.PHONE] = _joi2.default.string().trim().regex(_AppConstants.Validation.telephone).min(10).max(20).required().options({
            language: {
                any: {
                    empty: (0, _I18n.translate)('alertmessage.badContactNumber')
                },
                string: {
                    base: (0, _I18n.translate)('alertmessage.badContactNumber'),
                    max: (0, _I18n.translate)('alertmessage.string.max', { num: 20 }),
                    regex: {
                        base: (0, _I18n.translate)('alertmessage.badContactNumber')
                    }
                }
            }
        }), _ref;
    };

    ConsentsForm.prototype.normalizeSaveConsents = function normalizeSaveConsents() {
        return {
            permissions: [{
                optionId: _AppConstants.CONSENTS.EMAIL_MARKETING,
                selected: this.get(_AppConstants.CONSENTS.EMAIL_MARKETING)
            }, {
                optionId: _AppConstants.CONSENTS.PUSH_MARKETING,
                selected: this.get(_AppConstants.CONSENTS.PUSH_MARKETING)
            }, {
                optionId: _AppConstants.CONSENTS.SMS_Marketing,
                selected: this.get(_AppConstants.CONSENTS.SMS_Marketing)
            }],
            singleChoicePreferences: [{
                reference: _AppConstants.CONSENTS.OVER_16,
                selectedChoice: this.get(_AppConstants.CONSENTS.OVER_16) ? _AppConstants.CONSENTS.I_CONFIRM_16_YEARS_OLD : _AppConstants.CONSENTS.UNDER_16
            }]
        };
    };

    ConsentsForm.prototype.normalizeConsentsResponse = function normalizeConsentsResponse(_ref2) {
        var consents = _ref2.consents,
            user = _ref2.user;

        var updatedConsents = {};
        consents.blocks.map(function (block) {
            switch (block.type) {
                case _AppConstants.CONSENTS.PERMISSIONS:
                    block.options.map(function (option) {
                        updatedConsents[option.optionId] = option.selected;
                    });
                    break;
                case _AppConstants.CONSENTS.SINGLE_CHOICE_PREFERENCE:
                    updatedConsents[_AppConstants.CONSENTS.OVER_16] = block.selectedChoice === _AppConstants.CONSENTS.I_CONFIRM_16_YEARS_OLD;
                    break;
            }
        });

        if (!this[_AppConstants.CONSENTS.PHONE] && user.telephoneNumber) {
            updatedConsents[_AppConstants.CONSENTS.PHONE] = user.telephoneNumber;
        }
        return this.merge(updatedConsents);
    };

    return ConsentsForm;
}((0, _immutable.Record)(defaultConsents));

(0, _assign2.default)(ConsentsForm.prototype, _ValidationMixin2.default);

exports.default = ConsentsForm;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _LinkMapper = __webpack_require__(8);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _UserPreferences = __webpack_require__(228);

var _UserPreferences2 = _interopRequireDefault(_UserPreferences);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerTitles = _config2.default.get('customerTitles') || [];
var defaults = {
    title: customerTitles[0],
    firstNames: null,
    surname: null,
    email: null,
    password: null,
    phone: null,
    photocardId: null,
    source: null,
    referrer: null,
    isOver16: false,
    preferences: new _UserPreferences2.default(),
    acceptedTAndCs: false,
    isAmazonRegistration: false,
    autoDrOptedIn: false,
    autoDelayRepayApp: false,
    autoDelayRepayEmail: false
};

var Registration = function (_record) {
    (0, _inherits3.default)(Registration, _record);

    function Registration() {
        (0, _classCallCheck3.default)(this, Registration);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Registration.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(Registration, json, {
            preferences: _LinkMapper.resolve.as(_UserPreferences2.default)
        });
    };

    Registration.prototype.getSchema = function getSchema() {
        var brand = _config2.default.get('brand');
        var isSouthEastern = brand === 'southeastern';

        var schema = {
            title: _validation2.default.title(),
            firstNames: _validation2.default.name(2, isSouthEastern ? 24 : 50),
            surname: _validation2.default.name(2, isSouthEastern ? 24 : 50),

            email: _validation2.default.email(),

            password: this.isAmazonRegistration ? _validation2.default.optional() : _validation2.default.passwordCreate().required()

            // acceptedTAndCs: validators.true().required()
        };

        if (this.preferences.isSomeSmsPrefSetToTrue()) {
            schema = (0, _assign2.default)(schema, {
                phone: _validation2.default.phone().required()
            });
        }

        return schema;
    };

    Registration.prototype.getValue = function getValue(property) {
        return property in defaults ? this[property] : null;
    };

    Registration.prototype.arePersonalDetailsValid = function arePersonalDetailsValid() {
        var _this2 = this;

        return ['firstNames', 'surname', 'email', 'password'].every(function (fieldName) {
            return _this2.isFieldValid(fieldName);
        });
    };

    (0, _createClass3.default)(Registration, [{
        key: 'fullTelephoneNumber',
        get: function get() {
            return this.phone;
        }
    }, {
        key: 'fullName',
        get: function get() {
            return [this.title, this.firstNames, this.surname].join(' ');
        }
    }]);
    return Registration;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(Registration.prototype, _ValidationMixin2.default);

exports.default = Registration;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(121);
var toLength = __webpack_require__(63);
var toAbsoluteIndex = __webpack_require__(208);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 357 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(132);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(133);
var defined = __webpack_require__(149);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(48);
var cof = __webpack_require__(132);
var MATCH = __webpack_require__(56)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(56)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(243);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(707);
var redefine = __webpack_require__(112);
var hide = __webpack_require__(111);
var fails = __webpack_require__(40);
var defined = __webpack_require__(149);
var wks = __webpack_require__(56);
var regexpExec = __webpack_require__(486);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(36);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(112);
var redefineAll = __webpack_require__(214);
var meta = __webpack_require__(180);
var forOf = __webpack_require__(213);
var anInstance = __webpack_require__(212);
var isObject = __webpack_require__(48);
var fails = __webpack_require__(40);
var $iterDetect = __webpack_require__(361);
var setToStringTag = __webpack_require__(242);
var inheritIfRequired = __webpack_require__(472);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var hide = __webpack_require__(111);
var uid = __webpack_require__(206);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(179) || !__webpack_require__(40)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(36)[K];
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(10);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(10);
var aFunction = __webpack_require__(93);
var ctx = __webpack_require__(131);
var forOf = __webpack_require__(213);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(136);
var dPs = __webpack_require__(1387);
var enumBugKeys = __webpack_require__(500);
var IE_PROTO = __webpack_require__(498)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(494)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(726).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(492);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 373 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(300);
var TAG = __webpack_require__(94)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(182);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(69);
var core = __webpack_require__(49);
var fails = __webpack_require__(183);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(94);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(746);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(252)(module)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(381),
    stackClear = __webpack_require__(1438),
    stackDelete = __webpack_require__(1439),
    stackGet = __webpack_require__(1440),
    stackHas = __webpack_require__(1441),
    stackSet = __webpack_require__(1442);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1433),
    listCacheDelete = __webpack_require__(1434),
    listCacheGet = __webpack_require__(1435),
    listCacheHas = __webpack_require__(1436),
    listCacheSet = __webpack_require__(1437);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(253);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1455);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(187),
    toKey = __webpack_require__(188);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(310),
    isObject = __webpack_require__(77);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(777),
    baseIsNaN = __webpack_require__(1487),
    strictIndexOf = __webpack_require__(1488);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _throttle2 = __webpack_require__(452);

var _throttle3 = _interopRequireDefault(_throttle2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _ConfigService = __webpack_require__(630);

var _ConfigService2 = _interopRequireDefault(_ConfigService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppActions = {
    initialize: function initialize() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.APP_INITIALIZED
        });
    },


    activityDetected: (0, _throttle3.default)(function (event) {
        _AppDispatcher2.default.dispatch({
            firedEvent: event,
            actionType: _AppConstants.ActionTypes.ACTIVITY_DETECTED
        });
    }, 15000, { leading: true }),

    loadBanner: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var banner;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return _ConfigService2.default.loadBannerConfig();

                        case 3:
                            banner = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.BANNER_CONFIG_LOADED,
                                banner: banner
                            });
                            _context.next = 10;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            // We don't want the user to see an error if the banner load Failed
                            // So just log it out
                            console.error('Failed to load banner config');

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));

        function loadBanner() {
            return _ref.apply(this, arguments);
        }

        return loadBanner;
    }(),
    dismissMessageBanner: function dismissMessageBanner(id) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.BANNER_DISMISSED,
            id: id
        });
    },
    routeChanged: function routeChanged(location) {
        _AppDispatcher2.default.dispatch({
            location: location,
            actionType: _AppConstants.ActionTypes.ROUTE_CHANGED
        });
    },
    toggleFeature: function toggleFeature(feature, value) {
        _AppDispatcher2.default.dispatch({
            feature: feature,
            value: value,
            actionType: _AppConstants.ActionTypes.FEATURE_TOGGLED
        });
    },
    setFeatureVariant: function setFeatureVariant(feature, variant) {
        _AppDispatcher2.default.dispatch({
            feature: feature,
            variant: variant,
            actionType: _AppConstants.ActionTypes.FEATURE_VARIANT_UPDATED
        });
    },
    enableTracking: function enableTracking() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.TRACKING_ENABLED
        });
    },
    disableTracking: function disableTracking() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.TRACKING_DISABLED
        });
    }
};

exports.default = AppActions;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(748);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    customer: null,
    tokenType: null,
    accessToken: null,
    expires: null,
    refreshToken: null,
    itsoSession: null,
    customerDevice: null,
    showPasswordChangeModal: null
};

var AuthToken = function (_Record) {
    (0, _inherits3.default)(AuthToken, _Record);

    function AuthToken() {
        (0, _classCallCheck3.default)(this, AuthToken);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    AuthToken.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var tokenData = {
            customer: (0, _LinkMapper.resolve)(json.customer).with(_immutable.Map),
            tokenType: (0, _LinkMapper.resolve)(json.tokenType).with(String),
            accessToken: (0, _LinkMapper.resolve)(json.accessToken).with(String),
            expires: (0, _TrainTime2.default)(json.expires),
            refreshToken: (0, _LinkMapper.resolve)(json.refreshToken).with(String),
            itsoSession: (0, _LinkMapper.resolve)(json.itsoSession).with(_immutable.Map),
            customerDevice: json.customerDevice,
            showPasswordChangeModal: (0, _LinkMapper.resolve)(json.showPasswordChangeModal).with(Boolean)
        };
        return new AuthToken(tokenData);
    };

    AuthToken.fromAmazon = function fromAmazon() {
        var amazonResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.resolve)((0, _extends3.default)({}, amazonResponse.accessToken, { customer: amazonResponse.customer })).as(AuthToken);
    };

    AuthToken.prototype.getCustomerId = function getCustomerId() {
        return this.customer ? this.customer.get('id') : undefined;
    };

    AuthToken.prototype.isValid = function isValid() {
        if (_InAppStore2.default.isInApp()) {
            return this.accessToken && this.expires && this.expires.isAfter((0, _TrainTime2.default)());
        } else {
            return this.accessToken;
        }
    };

    return AuthToken;
}((0, _immutable.Record)(defaults));

exports.default = AuthToken;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1556), __esModule: true };

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(791);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _some2 = __webpack_require__(284);

var _some3 = _interopRequireDefault(_some2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _lpad = __webpack_require__(440);

var _lpad2 = _interopRequireDefault(_lpad);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidityPeriod = function (_record) {
    (0, _inherits3.default)(ValidityPeriod, _record);

    function ValidityPeriod() {
        (0, _classCallCheck3.default)(this, ValidityPeriod);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ValidityPeriod.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(ValidityPeriod, json, {
            days: _LinkMapper.fields.number,
            months: _LinkMapper.fields.number
        });
    };

    ValidityPeriod.fromString = function fromString(string) {
        if (!string || string.length !== 4) {
            return new ValidityPeriod();
        }

        return ValidityPeriod.fromJSON({
            days: string.substring(2, 4),
            months: string.substring(0, 2)
        });
    };

    ValidityPeriod.prototype.toString = function toString() {
        var pad = function pad(value) {
            return (0, _lpad2.default)(value, 2, "0");
        };
        return '' + pad(this.months) + pad(this.days);
    };

    ValidityPeriod.prototype.toDuration = function toDuration() {
        return _moment2.default.duration({
            months: this.months,
            days: this.days
        });
    };

    ValidityPeriod.prototype.toISOString = function toISOString() {
        var string = 'P';
        if (this.months) {
            string += this.months + 'M';
        }

        if (this.days) {
            string += this.days + 'D';
        }

        return string;
    };

    ValidityPeriod.prototype.equals = function equals(period) {
        return this.days === period.days && this.months === period.months;
    };

    ValidityPeriod.prototype.matchDurationType = function matchDurationType(type) {
        var _DurationPeriods$type = _AppConstants.DurationPeriods[type],
            months = _DurationPeriods$type[0],
            days = _DurationPeriods$type[1];

        return this.months === months && this.days === days;
    };

    ValidityPeriod.prototype.isCustom = function isCustom() {
        return !(0, _some3.default)((0, _keys2.default)(_AppConstants.DurationPeriods), this.matchDurationType.bind(this));
    };

    return ValidityPeriod;
}((0, _immutable.Record)({ days: 0, months: 0 }));

exports.default = ValidityPeriod;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Meta
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Image metadata handling implementation
 * based on the help and contribution of
 * Achim Stöhr.
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, Promise, DataView, Uint8Array, ArrayBuffer */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var global = loadImage.global
  var originalTransform = loadImage.transform

  var blobSlice =
    global.Blob &&
    (Blob.prototype.slice ||
      Blob.prototype.webkitSlice ||
      Blob.prototype.mozSlice)

  var bufferSlice =
    (global.ArrayBuffer && ArrayBuffer.prototype.slice) ||
    function (begin, end) {
      // Polyfill for IE10, which does not support ArrayBuffer.slice
      // eslint-disable-next-line no-param-reassign
      end = end || this.byteLength - begin
      var arr1 = new Uint8Array(this, begin, end)
      var arr2 = new Uint8Array(end)
      arr2.set(arr1)
      return arr2.buffer
    }

  var metaDataParsers = {
    jpeg: {
      0xffe1: [], // APP1 marker
      0xffed: [] // APP13 marker
    }
  }

  /**
   * Parses image metadata and calls the callback with an object argument
   * with the following property:
   * - imageHead: The complete image head as ArrayBuffer
   * The options argument accepts an object and supports the following
   * properties:
   * - maxMetaDataSize: Defines the maximum number of bytes to parse.
   * - disableImageHead: Disables creating the imageHead property.
   *
   * @param {Blob} file Blob object
   * @param {Function} [callback] Callback function
   * @param {object} [options] Parsing options
   * @param {object} [data] Result data object
   * @returns {Promise<object>|undefined} Returns Promise if no callback given.
   */
  function parseMetaData(file, callback, options, data) {
    var that = this
    /**
     * Promise executor
     *
     * @param {Function} resolve Resolution function
     * @param {Function} reject Rejection function
     * @returns {undefined} Undefined
     */
    function executor(resolve, reject) {
      if (
        !(
          global.DataView &&
          blobSlice &&
          file &&
          file.size >= 12 &&
          file.type === 'image/jpeg'
        )
      ) {
        // Nothing to parse
        return resolve(data)
      }
      // 256 KiB should contain all EXIF/ICC/IPTC segments:
      var maxMetaDataSize = options.maxMetaDataSize || 262144
      if (
        !loadImage.readFile(
          blobSlice.call(file, 0, maxMetaDataSize),
          function (buffer) {
            // Note on endianness:
            // Since the marker and length bytes in JPEG files are always
            // stored in big endian order, we can leave the endian parameter
            // of the DataView methods undefined, defaulting to big endian.
            var dataView = new DataView(buffer)
            // Check for the JPEG marker (0xffd8):
            if (dataView.getUint16(0) !== 0xffd8) {
              return reject(
                new Error('Invalid JPEG file: Missing JPEG marker.')
              )
            }
            var offset = 2
            var maxOffset = dataView.byteLength - 4
            var headLength = offset
            var markerBytes
            var markerLength
            var parsers
            var i
            while (offset < maxOffset) {
              markerBytes = dataView.getUint16(offset)
              // Search for APPn (0xffeN) and COM (0xfffe) markers,
              // which contain application-specific metadata like
              // Exif, ICC and IPTC data and text comments:
              if (
                (markerBytes >= 0xffe0 && markerBytes <= 0xffef) ||
                markerBytes === 0xfffe
              ) {
                // The marker bytes (2) are always followed by
                // the length bytes (2), indicating the length of the
                // marker segment, which includes the length bytes,
                // but not the marker bytes, so we add 2:
                markerLength = dataView.getUint16(offset + 2) + 2
                if (offset + markerLength > dataView.byteLength) {
                  // eslint-disable-next-line no-console
                  console.log('Invalid JPEG metadata: Invalid segment size.')
                  break
                }
                parsers = metaDataParsers.jpeg[markerBytes]
                if (parsers && !options.disableMetaDataParsers) {
                  for (i = 0; i < parsers.length; i += 1) {
                    parsers[i].call(
                      that,
                      dataView,
                      offset,
                      markerLength,
                      data,
                      options
                    )
                  }
                }
                offset += markerLength
                headLength = offset
              } else {
                // Not an APPn or COM marker, probably safe to
                // assume that this is the end of the metadata
                break
              }
            }
            // Meta length must be longer than JPEG marker (2)
            // plus APPn marker (2), followed by length bytes (2):
            if (!options.disableImageHead && headLength > 6) {
              data.imageHead = bufferSlice.call(buffer, 0, headLength)
            }
            resolve(data)
          },
          reject,
          'readAsArrayBuffer'
        )
      ) {
        // No support for the FileReader interface, nothing to parse
        resolve(data)
      }
    }
    options = options || {} // eslint-disable-line no-param-reassign
    if (global.Promise && typeof callback !== 'function') {
      options = callback || {} // eslint-disable-line no-param-reassign
      data = options // eslint-disable-line no-param-reassign
      return new Promise(executor)
    }
    data = data || {} // eslint-disable-line no-param-reassign
    return executor(callback, callback)
  }

  /**
   * Replaces the head of a JPEG Blob
   *
   * @param {Blob} blob Blob object
   * @param {ArrayBuffer} oldHead Old JPEG head
   * @param {ArrayBuffer} newHead New JPEG head
   * @returns {Blob} Combined Blob
   */
  function replaceJPEGHead(blob, oldHead, newHead) {
    if (!blob || !oldHead || !newHead) return null
    return new Blob([newHead, blobSlice.call(blob, oldHead.byteLength)], {
      type: 'image/jpeg'
    })
  }

  /**
   * Replaces the image head of a JPEG blob with the given one.
   * Returns a Promise or calls the callback with the new Blob.
   *
   * @param {Blob} blob Blob object
   * @param {ArrayBuffer} head New JPEG head
   * @param {Function} [callback] Callback function
   * @returns {Promise<Blob|null>|undefined} Combined Blob
   */
  function replaceHead(blob, head, callback) {
    var options = { maxMetaDataSize: 1024, disableMetaDataParsers: true }
    if (!callback && global.Promise) {
      return parseMetaData(blob, options).then(function (data) {
        return replaceJPEGHead(blob, data.imageHead, head)
      })
    }
    parseMetaData(
      blob,
      function (data) {
        callback(replaceJPEGHead(blob, data.imageHead, head))
      },
      options
    )
  }

  loadImage.transform = function (img, options, callback, file, data) {
    if (loadImage.requiresMetaData(options)) {
      data = data || {} // eslint-disable-line no-param-reassign
      parseMetaData(
        file,
        function (result) {
          if (result !== data) {
            // eslint-disable-next-line no-console
            if (global.console) console.log(result)
            result = data // eslint-disable-line no-param-reassign
          }
          originalTransform.call(
            loadImage,
            img,
            options,
            callback,
            file,
            result
          )
        },
        options,
        data
      )
    } else {
      originalTransform.apply(loadImage, arguments)
    }
  }

  loadImage.blobSlice = blobSlice
  loadImage.bufferSlice = bufferSlice
  loadImage.replaceHead = replaceHead
  loadImage.parseMetaData = parseMetaData
  loadImage.metaDataParsers = metaDataParsers
})


/***/ }),
/* 397 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(550);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1783);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(324);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

var _interopRequireWildcard = __webpack_require__(89);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireWildcard(__webpack_require__(408));

var _fadeStyles;

var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: _propTypes.default.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: _propTypes.default.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: _propTypes.default.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: _propTypes.default.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the has component faded in
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired before the component fades out
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the component has faded out
   */
  onExited: _propTypes.default.func
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[_Transition.ENTERING] = 'in', _fadeStyles[_Transition.ENTERED] = 'in', _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Fade, _React$Component);

  function Fade() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
    return _react.default.createElement(_Transition.default, props, function (status, innerProps) {
      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
        className: (0, _classnames.default)('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(_react.default.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
var _default = Fade;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(400)('meta');
var isObject = __webpack_require__(139);
var has = __webpack_require__(189);
var setDesc = __webpack_require__(167).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(193)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(167).f;
var has = __webpack_require__(189);
var TAG = __webpack_require__(140)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _reactLifecyclesCompat = __webpack_require__(1838);

var _PropTypes = __webpack_require__(1839);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1840);

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = splitComponentProps;

var _entries = _interopRequireDefault(__webpack_require__(409));

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;
  var parentProps = {};
  var childProps = {};
  (0, _entries.default)(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });
  return [parentProps, childProps];
}

module.exports = exports["default"];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseMembrane = undefined;

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseMembrane = exports.canUseMembrane = false;

// No-op by default.
var deprecateObjectProperties = function deprecateObjectProperties(object) {
  return object;
};

if (false) {
  try {
    if (Object.defineProperty({}, 'x', {
      get: function get() {
        return true;
      }
    }).x) {
      exports.canUseMembrane = canUseMembrane = true;
    }
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

  if (canUseMembrane) {
    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
      // Wrap the deprecated object in a membrane to warn on property access.
      var membrane = {};

      var _loop = function _loop(prop) {
        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
          return 'continue';
        }

        if (typeof object[prop] === 'function') {
          // Can't use fat arrow here because of use of arguments below.
          membrane[prop] = function () {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop].apply(object, arguments);
          };
          return 'continue';
        }

        // These properties are non-enumerable to prevent React dev tools from
        // seeing them and causing spurious warnings when accessing them. In
        // principle this could be done with a proxy, but support for the
        // ownKeys trap on proxies is not universal, even among browsers that
        // otherwise support proxies.
        Object.defineProperty(membrane, prop, {
          get: function get() {
            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
            return object[prop];
          }
        });
      };

      for (var prop in object) {
        var _ret = _loop(prop);

        if (_ret === 'continue') continue;
      }

      return membrane;
    };
  }
}

exports.default = deprecateObjectProperties;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.getHashPath = getHashPath;
exports.replaceHashPath = replaceHashPath;
exports.getWindowPath = getWindowPath;
exports.go = go;
exports.getUserConfirmation = getUserConfirmation;
exports.supportsHistory = supportsHistory;
exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;

function addEventListener(node, event, listener) {
  if (node.addEventListener) {
    node.addEventListener(event, listener, false);
  } else {
    node.attachEvent('on' + event, listener);
  }
}

function removeEventListener(node, event, listener) {
  if (node.removeEventListener) {
    node.removeEventListener(event, listener, false);
  } else {
    node.detachEvent('on' + event, listener);
  }
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  return window.location.href.split('#')[1] || '';
}

function replaceHashPath(path) {
  window.location.replace(window.location.pathname + window.location.search + '#' + path);
}

function getWindowPath() {
  return window.location.pathname + window.location.search + window.location.hash;
}

function go(n) {
  if (n) window.history.go(n);
}

function getUserConfirmation(message, callback) {
  callback(window.confirm(message));
}

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
 */

function supportsHistory() {
  var ua = navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }
  return window.history && 'pushState' in window.history;
}

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  var ua = navigator.userAgent;
  return ua.indexOf('Firefox') === -1;
}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _deprecateObjectProperties = __webpack_require__(411);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

var _getRouteParams = __webpack_require__(1892);

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _RouteUtils = __webpack_require__(195);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var array = _propTypes2.default.array,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = function (_React$Component) {
  _inherits(RouterContext, _React$Component);

  function RouterContext() {
    var _temp, _this, _ret;

    _classCallCheck(this, RouterContext);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createElement = function (component, props) {
      return component == null ? null : _this.props.createElement(component, props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RouterContext.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        router = _props.router,
        history = _props.history,
        location = _props.location;

    if (!router) {
       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;

      router = _extends({}, history, {
        setRouteLeaveHook: history.listenBeforeLeavingRoute
      });
      delete router.listenBeforeLeavingRoute;
    }

    if (false) {
      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
    }

    return { history: history, location: location, router: router };
  };

  RouterContext.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        history = _props2.history,
        location = _props2.location,
        routes = _props2.routes,
        params = _props2.params,
        components = _props2.components;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          history: history,
          location: location,
          params: params,
          route: route,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this2.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this2.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  };

  return RouterContext;
}(_react2.default.Component);

RouterContext.propTypes = {
  history: object,
  router: object.isRequired,
  location: object.isRequired,
  routes: array.isRequired,
  params: object.isRequired,
  components: array.isRequired,
  createElement: func.isRequired
};
RouterContext.defaultProps = {
  createElement: _react2.default.createElement
};
RouterContext.childContextTypes = {
  history: object,
  location: object.isRequired,
  router: object.isRequired
};
exports.default = RouterContext;
module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FareValidity(_ref) {
    var from = _ref.from,
        to = _ref.to;

    return _react2.default.createElement(
        'div',
        { className: 'margin-top--sm' },
        _react2.default.createElement(
            'div',
            { className: 'text-sm text-weight--normal clearfix' },
            _react2.default.createElement(
                'div',
                { className: 'fix-width text-light pull-left' },
                (0, _I18n.translate)('order.summary.validFrom')
            ),
            _react2.default.createElement(
                'div',
                { className: 'pull-left' },
                from.format('dddd DD MMMM YYYY')
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'text-sm text-weight--normal clearfix' },
            _react2.default.createElement(
                'div',
                { className: 'fix-width text-light pull-left' },
                (0, _I18n.translate)('order.summary.validTo')
            ),
            _react2.default.createElement(
                'div',
                { className: 'pull-left' },
                to.format('dddd DD MMMM YYYY')
            )
        )
    );
}

FareValidity.propTypes = {
    from: _MomentPropTypes2.default.isMoment,
    to: _MomentPropTypes2.default.isMoment
};

exports.default = FareValidity;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _activeElement = _interopRequireDefault(__webpack_require__(561));

var _contains = _interopRequireDefault(__webpack_require__(194));

var _keycode = _interopRequireDefault(__webpack_require__(267));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _all = _interopRequireDefault(__webpack_require__(196));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(197));

var _uncontrollable = _interopRequireDefault(__webpack_require__(106));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _ButtonGroup = _interopRequireDefault(__webpack_require__(589));

var _DropdownMenu = _interopRequireDefault(__webpack_require__(2113));

var _DropdownToggle = _interopRequireDefault(__webpack_require__(949));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _PropTypes = __webpack_require__(946);

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var TOGGLE_ROLE = _DropdownToggle.default.defaultProps.bsRole;
var MENU_ROLE = _DropdownMenu.default.defaultProps.bsRole;
var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: _propTypes.default.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  componentClass: _elementType.default,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: (0, _all.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: _propTypes.default.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: _propTypes.default.bool,
  defaultOpen: _propTypes.default.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: _propTypes.default.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: _propTypes.default.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: _propTypes.default.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: _propTypes.default.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * @private
   */
  onMouseLeave: _propTypes.default.func
};
var defaultProps = {
  componentClass: _ButtonGroup.default
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Dropdown, _React$Component);

  function Dropdown(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = (0, _contains.default)(_reactDom.default.findDOMNode(this.menu), (0, _activeElement.default)(document));
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;
    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  _proto.focus = function focus() {
    var toggle = _reactDom.default.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  _proto.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu || !menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  _proto.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, {
      source: 'click'
    });
  };

  _proto.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case _keycode.default.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, {
            source: 'keydown'
          });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }

        event.preventDefault();
        break;

      case _keycode.default.codes.esc:
      case _keycode.default.codes.tab:
        this.handleClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  _proto.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "onSelect", "rootCloseEvent"]);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? (0, _warning.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = (0, _createChainedFunction.default)(child.ref, ref);
    }

    return (0, _react.cloneElement)(child, (0, _extends2.default)({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
      onClose: (0, _createChainedFunction.default)(child.props.onClose, this.handleClose),
      onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, {
          source: 'select'
        });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  _proto.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? (0, _warning.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = (0, _createChainedFunction.default)(child.ref, ref);
    }

    return (0, _react.cloneElement)(child, (0, _extends2.default)({}, props, {
      ref: ref,
      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
      onClick: (0, _createChainedFunction.default)(child.props.onClick, this.handleClick),
      onKeyDown: (0, _createChainedFunction.default)(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  _proto.render = function render() {
    var _classes,
        _this4 = this;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        id = _this$props.id,
        dropup = _this$props.dropup,
        disabled = _this$props.disabled,
        pullRight = _this$props.pullRight,
        open = _this$props.open,
        onSelect = _this$props.onSelect,
        role = _this$props.role,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);
    delete props.onToggle;
    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    } // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.


    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      className: (0, _classnames.default)(className, classes)
    }), _ValidComponentChildren.default.map(children, function (child) {
      switch (child.props.bsRole) {
        case TOGGLE_ROLE:
          return _this4.renderToggle(child, {
            id: id,
            disabled: disabled,
            open: open,
            role: role,
            bsClass: bsClass
          });

        case MENU_ROLE:
          return _this4.renderMenu(child, {
            id: id,
            open: open,
            pullRight: pullRight,
            bsClass: bsClass,
            onSelect: onSelect,
            rootCloseEvent: rootCloseEvent
          });

        default:
          return child;
      }
    }));
  };

  return Dropdown;
}(_react.default.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
var UncontrolledDropdown = (0, _uncontrollable.default)(Dropdown, {
  open: 'onToggle'
});
UncontrolledDropdown.Toggle = _DropdownToggle.default;
UncontrolledDropdown.Menu = _DropdownMenu.default;
var _default = UncontrolledDropdown;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _MediaBody = _interopRequireDefault(__webpack_require__(2124));

var _MediaHeading = _interopRequireDefault(__webpack_require__(2125));

var _MediaLeft = _interopRequireDefault(__webpack_require__(2126));

var _MediaList = _interopRequireDefault(__webpack_require__(2127));

var _MediaListItem = _interopRequireDefault(__webpack_require__(2128));

var _MediaRight = _interopRequireDefault(__webpack_require__(2129));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};

var Media =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Media, _React$Component);

  function Media() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Media.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Media;
}(_react.default.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;
Media.Heading = _MediaHeading.default;
Media.Body = _MediaBody.default;
Media.Left = _MediaLeft.default;
Media.Right = _MediaRight.default;
Media.List = _MediaList.default;
Media.ListItem = _MediaListItem.default;

var _default = (0, _bootstrapUtils.bsClass)('media', Media);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _AppConstants = __webpack_require__(6);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base component for components that contain forms to extend
 *
 * Replaces the focusOnError mixin
 */

var FormComponent = function (_PureRenderComponent) {
    (0, _inherits3.default)(FormComponent, _PureRenderComponent);

    function FormComponent() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FormComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            submitted: false
        }, _this._handlerForEnter = function (callback) {
            return function (event) {
                if (event.keyCode === _AppConstants.KeyCodes.ENTER) {
                    (0, _defer3.default)(callback);
                }
            };
        }, _this.captureFormRef = function (formRef) {
            _this._formRef = formRef;
        }, _this._focusOnError = function () {
            var form = _this.refs.form || _this._formRef;
            if (!form) {
                console.warn('Form ref not set, so cannot focus on errors. Use `ref={ this.captureFormRef }`');
            }
            var node = _reactDom2.default.findDOMNode(form);
            if (node) {
                var errors = node.querySelectorAll('.input--invalid, .checkbox--invalid, .alert-warning, .alert-danger');

                if (errors.length !== 0) {
                    errors[0].focus();
                    errors[0].scrollIntoView();
                }
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    FormComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this._shouldFocus(prevProps, prevState)) {
            (0, _defer3.default)(this._focusOnError);
        }
    };

    FormComponent.prototype._shouldFocus = function _shouldFocus(prevProps, prevState) {
        return !prevState.submitted && this.state.submitted;
    };

    return FormComponent;
}(_PureRenderComponent3.default);

exports.default = FormComponent;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PaymentState = exports.getCompatibleCardPaymentMethod = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _Form = __webpack_require__(995);

var _Form2 = _interopRequireDefault(_Form);

var _AuthRequest = __webpack_require__(1055);

var _AuthRequest2 = _interopRequireDefault(_AuthRequest);

var _AuthResponse = __webpack_require__(607);

var _AuthResponse2 = _interopRequireDefault(_AuthResponse);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _Payment = __webpack_require__(423);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCompatibleCardPaymentMethod = exports.getCompatibleCardPaymentMethod = function getCompatibleCardPaymentMethod(_ref) {
    var currentPaymentMethod = _ref.currentPaymentMethod,
        featurePay360ApiEnabled = _ref.featurePay360ApiEnabled,
        featurePay360HostedEnabled = _ref.featurePay360HostedEnabled,
        featureBraintreeCardPaymentsEnabled = _ref.featureBraintreeCardPaymentsEnabled;

    // Return the current payment method if it's not a card-related payment type
    if (currentPaymentMethod !== _AppConstants.PaymentType.CARD && currentPaymentMethod !== _AppConstants.PaymentType.PAY360_HOSTED) {
        return currentPaymentMethod;
    }

    // If Braintree is enabled, prioritize it
    if (featureBraintreeCardPaymentsEnabled) {
        return _AppConstants.PaymentType.BRAINTREE_CARD_CHECKOUT;
    }

    // Handle CARD method with Pay360 API and hosted feature flags
    if (currentPaymentMethod === _AppConstants.PaymentType.CARD) {
        if (!featurePay360ApiEnabled && featurePay360HostedEnabled) {
            return _AppConstants.PaymentType.PAY360_HOSTED;
        }
        return _AppConstants.PaymentType.CARD;
    }

    // Handle Pay360 Hosted method
    if (currentPaymentMethod === _AppConstants.PaymentType.PAY360_HOSTED && !featurePay360HostedEnabled) {
        return _AppConstants.PaymentType.CARD;
    }

    // Default to Pay360 Hosted if no conditions match
    return _AppConstants.PaymentType.PAY360_HOSTED;
};

var stateSchema = {
    form: [_LinkMapper.resolve.as(_Form2.default)],
    isProcessing: [_LinkMapper.fields.bool, false],
    is3DSecure: [_LinkMapper.fields.bool, false],
    authRequest: [_LinkMapper.resolve.as(_AuthRequest2.default)],
    authResponse: [_LinkMapper.resolve.as(_AuthResponse2.default)],
    authError: [_LinkMapper.fields.identity],
    errorMessage: [_LinkMapper.fields.identity],
    waitMessage: [_LinkMapper.fields.string],
    vouchersPreAuthedAmount: [_LinkMapper.fields.number, 0]
};
var defaultState = (0, _Records.getDefaults)(stateSchema);

var PaymentState = exports.PaymentState = function (_record) {
    (0, _inherits3.default)(PaymentState, _record);

    function PaymentState() {
        (0, _classCallCheck3.default)(this, PaymentState);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PaymentState.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(PaymentState, (0, _defaults3.default)(json, defaultState), (0, _Records.getResolvers)(stateSchema));
    };

    return PaymentState;
}((0, _immutable.Record)(defaultState));

var PaymentStore = function (_BaseStore) {
    (0, _inherits3.default)(PaymentStore, _BaseStore);

    function PaymentStore() {
        (0, _classCallCheck3.default)(this, PaymentStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    PaymentStore.prototype.resetState = function resetState() {
        // https://ontrackretail.slack.com/archives/C03KCFHMX/p1593180469005100
        this.setState(new PaymentState());
    };

    PaymentStore.prototype.serialize = function serialize() {
        // strip sensitive/unnecessary stuff
        return (0, _omit3.default)(_BaseStore.prototype.serialize.call(this), 'authRequest', 'authResponse');
    };

    PaymentStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.PAYMENT_FORM_CHANGED] = this.handlePaymentFormChanged, _ref2[_AppConstants.ActionTypes.PAYMENT_FORM_ERROR_MESSAGE] = this.handlePaymentFormErrorMessage, _ref2[_AppConstants.ActionTypes.PAYMENT_DISCOUNT_CODE_CHANGED] = this.handlePaymentDiscountCodeChanged, _ref2[_AppConstants.ActionTypes.PAYMENT_AUTH_STARTED] = this.handlePaymentAuthStarted, _ref2[_AppConstants.ActionTypes.PAYMENT_AUTH_FINISHED] = this.handlePaymentAuthFinished, _ref2[_AppConstants.ActionTypes.PAYMENT_AUTH_FAILED] = this.handlePaymentAuthFailed, _ref2[_AppConstants.ActionTypes.PAYMENT_AUTH_RESET] = this.handlePaymentAuthReset, _ref2[_AppConstants.ActionTypes.PAYMENT_AUTH_WAITING] = this.handlePaymentWaiting, _ref2[_AppConstants.ActionTypes.ORDER_REFRESH_LOADED] = this.handleOrderRefreshLoaded, _ref2[_AppConstants.ActionTypes.ORDER_REFRESH_FAILED] = this.handleOrderRefreshFailed, _ref2[_AppConstants.ActionTypes.PAYMENT_LEFT] = this.handlePaymentLeft, _ref2[_AppConstants.ActionTypes.ORDER_PAID] = this.resetForm, _ref2[_AppConstants.ActionTypes.BASKET_CLEARED] = this.resetState, _ref2[_AppConstants.ActionTypes.ORDER_EXPIRED] = this.resetState, _ref2[_AppConstants.ActionTypes.SEARCH_STARTED] = this.resetState, _ref2[_AppConstants.ActionTypes.SEASON_SEARCH_STARTED] = this.resetState, _ref2[_AppConstants.ActionTypes.DAYSAVE_SEARCH_STARTED] = this.resetState, _ref2[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_STARTED] = this.resetState, _ref2[_AppConstants.ActionTypes.AMAZON_PAY_INVALID_PAYMENT_METHOD] = this.handleAmazonPayInvalidPaymentMethod, _ref2[_AppConstants.ActionTypes.CUSTOMER_VOUCHERS_LOADED] = this.handleVouchersLoaded, _ref2[_AppConstants.ActionTypes.ORDER_UPDATED] = this.handleOrderUpdated, _ref2[_AppConstants.ActionTypes.ORDER_TRIP_CREATED] = this.handleOrderUpdated, _ref2[_AppConstants.ActionTypes.ORDER_TRIP_UPDATED] = this.handleOrderUpdated, _ref2[_AppConstants.ActionTypes.ORDER_TRIP_DELETED] = this.handleOrderUpdated, _ref2[_AppConstants.ActionTypes.PAYMENT_PRE_AUTH_VOUCHERS_RELEASED] = this.handleVoucherPreAuthRelease, _ref2[_AppConstants.ActionTypes.PAYMENT_PRE_AUTH_VOUCHERS_COMPLETED] = this.handleVoucherPreAuthComplete, _ref2[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetForm, _ref2[_AppConstants.ActionTypes.LOGGED_IN] = this.handleLogin, _ref2[_AppConstants.ActionTypes.APPLY_DISCOUNT_CODE_FINISHED] = this.handleDiscountApplied, _ref2;
    };

    PaymentStore.prototype.handleLogin = function handleLogin(_ref3) {
        var user = _ref3.user;
        var form = this.state.form;

        if (form) {
            this.setState(this.state.set('form', form.set('isLoggedIn', true).setContactDetails(user.email, user.phone)));
        }
    };

    PaymentStore.prototype.handleVouchersLoaded = function handleVouchersLoaded(_ref4) {
        var vouchers = _ref4.vouchers;

        if (!_FeatureFlagStore2.default.get('enableEVoucherCheckout')) {
            return;
        }

        var total = (0, _Immutable.sum)(vouchers, 'amount');
        var _state = this.state,
            form = _state.form,
            vouchersPreAuthedAmount = _state.vouchersPreAuthedAmount;

        if (form && form.getVouchersTotal() !== total + vouchersPreAuthedAmount) {
            this.setState(this.state.set('form', form.setVouchersTotal(total, vouchersPreAuthedAmount)));
        }
    };

    PaymentStore.prototype.handleOrderUpdated = function handleOrderUpdated(_ref5) {
        var order = _ref5.order;
        var form = this.state.form;

        if (form && form.basketTotal !== order.totalPrice) {
            this.setState(this.state.set('form', form.setBasketTotal(order.totalPrice)));
        }
    };

    PaymentStore.prototype.handleDiscountApplied = function handleDiscountApplied(_ref6) {
        var updatedOrder = _ref6.updatedOrder;

        this.handleOrderUpdated({ order: updatedOrder });
    };

    PaymentStore.prototype.handlePaymentFormErrorMessage = function handlePaymentFormErrorMessage(_ref7) {
        var errorMessage = _ref7.errorMessage;

        this.setState(this.state.set('errorMessage', errorMessage));
    };

    PaymentStore.prototype.handlePaymentFormChanged = function handlePaymentFormChanged(_ref8) {
        var form = _ref8.form;

        this.setState(this.state.set('form', form));
    };

    PaymentStore.prototype.handlePaymentDiscountCodeChanged = function handlePaymentDiscountCodeChanged(_ref9) {
        var discountCode = _ref9.discountCode;

        this.setState(this.state.setIn(['form', 'discountCode'], discountCode));
    };

    PaymentStore.prototype.handlePaymentAuthStarted = function handlePaymentAuthStarted() {
        var updatedState = this.state.withMutations(function (state) {
            return state.set('isProcessing', true).set('is3DSecure', false).set('authRequest', null).set('authResponse', null).set('authError', null);
        });
        this.setState(updatedState);
    };

    PaymentStore.prototype.handlePaymentAuthFinished = function handlePaymentAuthFinished(_ref10) {
        var authRequest = _ref10.authRequest,
            authResponse = _ref10.authResponse;

        var updatedState = this.state.withMutations(function (state) {
            return state.set('isProcessing', authResponse.isEnrolled()).set('is3DSecure', authResponse.isEnrolled()).set('authRequest', authRequest).set('authResponse', authResponse).set('authError', null);
        });
        this.setState(updatedState);
    };

    PaymentStore.prototype.handlePaymentAuthFailed = function handlePaymentAuthFailed(_ref11) {
        var authRequest = _ref11.authRequest,
            authError = _ref11.authError;

        var updatedState = this.state.withMutations(function (state) {
            return state.set('isProcessing', false).set('is3DSecure', false).set('authRequest', authRequest).set('authResponse', null).set('authError', authError).set('waitMessage', null);
        });
        this.setState(updatedState);
    };

    PaymentStore.prototype.handlePaymentLeft = function handlePaymentLeft() {
        this.resetState();
    };

    PaymentStore.prototype.handlePaymentWaiting = function handlePaymentWaiting(_ref12) {
        var message = _ref12.message;

        this.setState(this.state.set('waitMessage', message));
    };

    PaymentStore.prototype.handleOrderRefreshLoaded = function handleOrderRefreshLoaded(_ref13) {
        var order = _ref13.order;

        var updatedState = this.state.withMutations(function (state) {
            return state.set('isProcessing', false).set('is3DSecure', false).set('authError', !order.isPaid() && new _Payment.PaymentUnauthorizedError(order.state)).set('waitMessage', null);
        });
        this.setState(updatedState);
    };

    PaymentStore.prototype.handleOrderRefreshFailed = function handleOrderRefreshFailed(_ref14) {
        var error = _ref14.error;

        var updatedState = this.state.withMutations(function (state) {
            return state.set('isProcessing', false).set('is3DSecure', false).set('authError', new _Payment.PaymentUnauthorizedError(error.message)).set('waitMessage', null);
        });
        this.setState(updatedState);
    };

    PaymentStore.prototype.handlePaymentAuthReset = function handlePaymentAuthReset() {
        var updatedState = this.state.withMutations(function (state) {
            return state.set('isProcessing', false).set('is3DSecure', false).set('authRequest', null).set('authResponse', null).set('authError', null).set('waitMessage', null);
        });
        this.setState(updatedState);
    };

    PaymentStore.prototype.handleAmazonPayInvalidPaymentMethod = function handleAmazonPayInvalidPaymentMethod() {
        this.setState(this.state.merge({
            isProcessing: false
        }));
    };

    PaymentStore.prototype.handleVoucherPreAuthRelease = function handleVoucherPreAuthRelease() {
        this.setState(this.state.set('vouchersPreAuthedAmount', 0));
    };

    PaymentStore.prototype.handleVoucherPreAuthComplete = function handleVoucherPreAuthComplete(_ref15) {
        var amount = _ref15.amount;

        this.setState(this.state.set('vouchersPreAuthedAmount', amount));
    };

    PaymentStore.prototype.resetForm = function resetForm() {
        var updatedState = this.state.set('form', defaultState.form);
        this.setState(updatedState);
    };

    PaymentStore.prototype.getForm = function getForm() {
        return this.get('form');
    };

    PaymentStore.prototype.getValidation = function getValidation() {
        return this.get('validation');
    };

    PaymentStore.prototype.isProcessing = function isProcessing() {
        return this.get('isProcessing');
    };

    PaymentStore.prototype.is3DSecure = function is3DSecure() {
        return this.get('is3DSecure');
    };

    PaymentStore.prototype.getAuthRequest = function getAuthRequest() {
        return this.get('authRequest');
    };

    PaymentStore.prototype.getAuthResponse = function getAuthResponse() {
        return this.get('authResponse');
    };

    PaymentStore.prototype.getAuthError = function getAuthError() {
        return this.get('authError');
    };

    PaymentStore.prototype.getPaymentAmount = function getPaymentAmount() {
        if (!this.state.form) {
            return 0;
        }
        return this.state.form.getPaymentAmount();
    };

    return PaymentStore;
}(_BaseStore3.default);

var storeInstance = new PaymentStore({
    storageKey: 'payment',
    expires: 30 * 60,
    recordType: PaymentState
});
exports.default = storeInstance;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _ShowPassword = __webpack_require__(1986);

var _ShowPassword2 = _interopRequireDefault(_ShowPassword);

var _PasswordHints = __webpack_require__(1988);

var _PasswordHints2 = _interopRequireDefault(_PasswordHints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerPassword = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(CustomerPassword, _React$PureComponent);

    function CustomerPassword() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomerPassword);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            isPasswordShown: false
        }, _this.togglePasswordShown = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState(function (state) {
                return { isPasswordShown: !state.isPasswordShown };
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    CustomerPassword.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            form = _props.form,
            field = _props.field,
            label = _props.label,
            placeholder = _props.placeholder,
            validation = _props.validation,
            visited = _props.visited,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onBlur = _props.onBlur,
            outsideLabel = _props.outsideLabel,
            required = _props.required,
            showPasswordIcon = _props.showPasswordIcon,
            showPasswordHints = _props.showPasswordHints,
            autoComplete = _props.autoComplete,
            hideOptional = _props.hideOptional;
        var isPasswordShown = this.state.isPasswordShown;


        var passwordLabel = label || (0, _I18n.translate)('customerdetails.password');
        var ariaDescribedById = 'desc-' + field;
        var passwordError = (0, _get3.default)(validation, 'field') || form.getError(field);

        return _react2.default.createElement(
            'div',
            { className: 'create-password password-field' },
            _react2.default.createElement(_ValidatedField2.default, {
                field: field,
                form: form,
                id: id,
                isPasswordShown: isPasswordShown,
                label: passwordLabel,
                labelClassName: 'sr-only',
                onFocus: onFocus,
                onBlur: onBlur,
                onChange: onChange,
                placeholder: placeholder || passwordLabel,
                autoComplete: autoComplete,
                required: required,
                indicator: showPasswordIcon ? _react2.default.createElement(_ShowPassword2.default, {
                    active: isPasswordShown,
                    onClick: this.togglePasswordShown
                }) : null,
                type: isPasswordShown ? 'text' : 'password',
                validation: validation,
                visited: visited,
                errorClassName: showPasswordHints ? 'alert-danger' : null,
                hideOptional: hideOptional,
                outsideLabel: outsideLabel,
                'aria-describedby': showPasswordHints && ariaDescribedById
            }),
            showPasswordHints && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_PasswordHints2.default, { password: form.get(field) }),
                _react2.default.createElement(
                    'span',
                    { id: ariaDescribedById, className: 'sr-only', 'aria-hidden': 'true' },
                    (0, _I18n.translate)('customerdetails.password.restrictions'),
                    '.',
                    passwordError
                )
            )
        );
    };

    return CustomerPassword;
}(_react2.default.PureComponent), _class.propTypes = {
    id: _propTypes2.default.string,
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    field: _propTypes2.default.string,
    hideOptional: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    validation: _propTypes2.default.object,
    placeholder: _propTypes2.default.string,
    label: _propTypes2.default.string,
    visited: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    onBlur: _propTypes2.default.func,
    outsideLabel: _propTypes2.default.bool,
    onFocus: _propTypes2.default.func,
    showPasswordIcon: _propTypes2.default.bool,
    showPasswordHints: _propTypes2.default.bool,
    autoComplete: _propTypes2.default.string
}, _class.defaultProps = {
    id: 'password',
    validation: null,
    visited: false,
    required: true,
    placeholder: '',
    label: '',
    onFocus: _noop3.default,
    onBlur: _noop3.default,
    outsideLabel: false,
    showPasswordIcon: false,
    showPasswordHints: false,
    autoComplete: null
}, _temp2);
exports.default = CustomerPassword;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _SearchUrls = __webpack_require__(97);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _minDate() {
    if (_config2.default.get('daySaveAbsoluteDateRangeStart')) {
        return (0, _TrainTime2.default)(_config2.default.get('daySaveAbsoluteDateRangeStart')).startOf('day');
    }
    return (0, _TrainTime2.default)().add(_config2.default.get('daySaveRelativeDateRangeStart'), 'days').startOf('day');
}

function _maxDate() {
    if (_config2.default.get('daySaveAbsoluteDateRangeEnd')) {
        return (0, _TrainTime2.default)(_config2.default.get('daySaveAbsoluteDateRangeEnd')).endOf('day');
    }
    return (0, _TrainTime2.default)().add(_config2.default.get('daySaveRelativeDateRangeEnd'), 'days').endOf('day');
}

var defaults = {
    date: _minDate(),
    origin: new _Station2.default(),
    destinationNlc: _config2.default.get('daySaveDestinationNlc'),
    adults: 1,
    children: 0
};

var DaySaveSearch = function (_record) {
    (0, _inherits3.default)(DaySaveSearch, _record);

    function DaySaveSearch() {
        (0, _classCallCheck3.default)(this, DaySaveSearch);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DaySaveSearch.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        json = (0, _defaults3.default)(json, { adults: 0, children: 0 });
        return (0, _LinkMapper.construct)(DaySaveSearch, json, {
            date: _LinkMapper.fields.datetime,
            origin: _LinkMapper.resolve.as(_Station2.default),
            adults: _LinkMapper.fields.number,
            children: _LinkMapper.fields.number
        });
    };

    DaySaveSearch.prototype.serialize = function serialize() {
        return (0, _SearchUrls.serialize)({
            adults: _SearchUrls.serializers.identity,
            children: _SearchUrls.serializers.identity,
            origin: _SearchUrls.serializers.station,
            destinationNlc: _SearchUrls.serializers.identity,
            date: _SearchUrls.serializers.date
        }, this);
    };

    /**
     * Return a promise that resolves to a new DaySaveSearch, from the url params
     */


    DaySaveSearch.deserialize = function deserialize(source) {
        var schema = {
            adults: _SearchUrls.deserializers.int,
            children: _SearchUrls.deserializers.int,
            origin: _SearchUrls.deserializers.station,
            date: _SearchUrls.deserializers.date
        };

        return (0, _SearchUrls.deserialize)(schema, source).then(function (deserialized) {
            return new DaySaveSearch(deserialized);
        });
    };

    DaySaveSearch.prototype.refreshDates = function refreshDates() {
        if (this.date.isBefore(this.minimumDate)) {
            return this.set('date', this.minimumDate);
        }
        return this;
    };

    DaySaveSearch.prototype.getComputedValues = function getComputedValues() {
        return {
            date: this.date.format(),
            origin: this.origin.nlc
        };
    };

    //Hack for compatibility


    DaySaveSearch.prototype.isValid = function isValid() {
        return this.isComplete();
    };

    DaySaveSearch.prototype.getSchema = function getSchema() {
        var dateRange = _joi2.default.date().min(_minDate().format()).max(_maxDate().format());
        var isFuture = _joi2.default.date().min((0, _TrainTime2.default)().format());
        return {
            date: isFuture.concat(dateRange).required(),
            adults: _joi2.default.number().min(0).max(9).required(),
            children: _joi2.default.number().min(0).max(9).required(),
            origin: _validation2.default.requiredString()
        };
    };

    (0, _createClass3.default)(DaySaveSearch, [{
        key: 'minimumDate',
        get: function get() {
            return _minDate();
        }
    }, {
        key: 'maximumDate',
        get: function get() {
            return _maxDate();
        }
    }]);
    return DaySaveSearch;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(DaySaveSearch.prototype, _ValidationMixin2.default);

exports.default = DaySaveSearch;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InvalidSearchError = undefined;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvalidSearchError = exports.InvalidSearchError = function (_ExtendableError) {
    (0, _inherits3.default)(InvalidSearchError, _ExtendableError);

    function InvalidSearchError(message, search) {
        (0, _classCallCheck3.default)(this, InvalidSearchError);

        var params = (0, _stringify2.default)(search.serialize());

        var _this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call(this, message, { params: params }));

        _this.name = 'InvalidSearchError';
        return _this;
    }

    return InvalidSearchError;
}(_ExtendableError3.default);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _FavouritesService = __webpack_require__(1958);

var _FavouritesService2 = _interopRequireDefault(_FavouritesService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavouritesActions = function () {
    function FavouritesActions() {
        (0, _classCallCheck3.default)(this, FavouritesActions);
        this._requestAllPending = false;
    }

    FavouritesActions.prototype.add = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fare, orderTrip, delivery, user, context) {
            var favourite;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _FavouritesService2.default.addFavourite(fare, orderTrip, delivery, user);

                        case 2:
                            favourite = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_ADDED,
                                favourite: favourite,
                                context: context
                            });

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function add(_x, _x2, _x3, _x4, _x5) {
            return _ref.apply(this, arguments);
        }

        return add;
    }();

    FavouritesActions.prototype.remove = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(favourite, user, context) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _FavouritesService2.default.removeFavourite(favourite, user);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_REMOVED,
                                favourite: favourite,
                                context: context
                            });

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function remove(_x6, _x7, _x8) {
            return _ref2.apply(this, arguments);
        }

        return remove;
    }();

    FavouritesActions.prototype.getAll = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user) {
            var favourites;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(this._requestAllPending || !_FeatureFlagStore2.default.get('enableFavouriteTickets') || !user)) {
                                _context3.next = 2;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 2:
                            this._requestAllPending = true;
                            _context3.prev = 3;
                            _context3.next = 6;
                            return _FavouritesService2.default.getFavourites(user);

                        case 6:
                            favourites = _context3.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_LOADED,
                                favourites: favourites
                            });
                            _context3.next = 13;
                            break;

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](3);

                            console.error('Failed to load favourites', _context3.t0);

                        case 13:
                            _context3.prev = 13;

                            this._requestAllPending = false;
                            return _context3.finish(13);

                        case 16:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[3, 10, 13, 16]]);
        }));

        function getAll(_x9) {
            return _ref3.apply(this, arguments);
        }

        return getAll;
    }();

    FavouritesActions.prototype.updatePhotocard = function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(favourite, photocardNumber, user) {
            var updatedFavourite;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _FavouritesService2.default.updateFavouritePhotocard(favourite, photocardNumber, user);

                        case 2:
                            updatedFavourite = _context4.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_PHOTOCARD_UPDATED,
                                favouriteId: favourite.id,
                                photocard: updatedFavourite.photocard
                            });

                        case 4:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function updatePhotocard(_x10, _x11, _x12) {
            return _ref4.apply(this, arguments);
        }

        return updatePhotocard;
    }();

    FavouritesActions.prototype.addDelivery = function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(favourite, delivery, user) {
            var _ref6, id, fulfilment;

            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return _FavouritesService2.default.addFavouriteDelivery(favourite, delivery, user);

                        case 2:
                            _ref6 = _context5.sent;
                            id = _ref6.id;
                            fulfilment = _ref6.fulfilment;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_DELIVERY_ADDED,
                                favouriteId: favourite.id,
                                deliveryId: id,
                                delivery: fulfilment
                            });

                        case 6:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function addDelivery(_x13, _x14, _x15) {
            return _ref5.apply(this, arguments);
        }

        return addDelivery;
    }();

    FavouritesActions.prototype.updateDelivery = function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(favourite, delivery, user) {
            var updatedDelivery;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return _FavouritesService2.default.updateFavouriteDelivery(favourite, delivery, user);

                        case 2:
                            updatedDelivery = _context6.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_DELIVERY_UPDATED,
                                favouriteId: favourite.id,
                                delivery: updatedDelivery
                            });

                        case 4:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function updateDelivery(_x16, _x17, _x18) {
            return _ref7.apply(this, arguments);
        }

        return updateDelivery;
    }();

    FavouritesActions.prototype.updateSeasonExpiryDate = function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(favourite, user, seasonExpiryDate) {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return _FavouritesService2.default.updateFavouriteSeasonExpiryDate(favourite, seasonExpiryDate, user);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_SEASON_EXPIRY_DATE_UPDATED,
                                favouriteId: favourite.id,
                                seasonExpiryDate: seasonExpiryDate
                            });

                        case 3:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function updateSeasonExpiryDate(_x19, _x20, _x21) {
            return _ref8.apply(this, arguments);
        }

        return updateSeasonExpiryDate;
    }();

    FavouritesActions.prototype.updateLastUsedDate = function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(favourite, user) {
            var lastUsedDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _TrainTime2.default)();
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return _FavouritesService2.default.updateFavouriteLastUsedDate(favourite, lastUsedDate, user);

                        case 2:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITES_LAST_USED_DATE_UPDATED,
                                favouriteId: favourite.id,
                                lastUsedDate: lastUsedDate
                            });

                        case 3:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function updateLastUsedDate(_x23, _x24) {
            return _ref9.apply(this, arguments);
        }

        return updateLastUsedDate;
    }();

    FavouritesActions.prototype.addToBasket = function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(success) {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FAVOURITE_ADDED_TO_BASKET,
                                success: success
                            });

                        case 1:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function addToBasket(_x25) {
            return _ref10.apply(this, arguments);
        }

        return addToBasket;
    }();

    return FavouritesActions;
}();

exports.default = new FavouritesActions();

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PaymentUnauthorizedError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentUnauthorizedError = exports.PaymentUnauthorizedError = function (_ExtendableError) {
    (0, _inherits3.default)(PaymentUnauthorizedError, _ExtendableError);

    function PaymentUnauthorizedError() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PaymentUnauthorizedError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'PaymentUnauthorizedError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return PaymentUnauthorizedError;
}(_ExtendableError3.default);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDocumentTitle = __webpack_require__(1136);

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _I18n = __webpack_require__(9);

var _AppNotify = __webpack_require__(1846);

var _AppNotify2 = _interopRequireDefault(_AppNotify);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(Page, _PureRenderComponent);

    function Page() {
        (0, _classCallCheck3.default)(this, Page);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    Page.prototype._getTitle = function _getTitle(_ref) {
        var title = _ref.title,
            name = _ref.name;

        if (!title) {
            var key = 'pageTitles.' + name;
            var found = (0, _I18n.translate)(key);
            title = found !== key ? found : (0, _I18n.translate)('pageTitles.default');
        }
        return title;
    };

    Page.prototype.render = function render() {
        var _props = this.props,
            goBack = _props.goBack,
            children = _props.children;

        var title = this._getTitle(this.props);

        return _react2.default.createElement(
            _AppNotify2.default,
            { title: title, goBack: goBack },
            _react2.default.createElement(
                _reactDocumentTitle2.default,
                { title: title },
                children
            )
        );
    };

    return Page;
}(_PureRenderComponent3.default), _class.propTypes = {
    name: _propTypes2.default.string,
    title: _propTypes2.default.string,
    children: _propTypes2.default.any,
    goBack: _propTypes2.default.bool
}, _class.defaultProps = {
    goBack: true,
    name: 'default',
    title: null,
    children: null
}, _temp);
exports.default = Page;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _FormControl = __webpack_require__(178);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = __webpack_require__(611);

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _ControlLabel = __webpack_require__(461);

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Select, _React$PureComponent);

    function Select() {
        (0, _classCallCheck3.default)(this, Select);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    Select.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            id = _props.id,
            className = _props.className,
            label = _props.label,
            labelClassName = _props.labelClassName,
            groupClassName = _props.groupClassName,
            outerClassName = _props.outerClassName,
            children = _props.children,
            props = (0, _objectWithoutProperties3.default)(_props, ['id', 'className', 'label', 'labelClassName', 'groupClassName', 'outerClassName', 'children']);

        var classNames = (0, _classnames2.default)('input-field', className);

        return _react2.default.createElement(
            'div',
            { className: outerClassName },
            _react2.default.createElement(
                _FormGroup2.default,
                { controlId: id,
                    className: groupClassName },
                label && _react2.default.createElement(
                    _ControlLabel2.default,
                    { className: labelClassName },
                    label
                ),
                _react2.default.createElement(
                    _FormControl2.default,
                    (0, _extends3.default)({}, props, {
                        ref: function ref(el) {
                            _this2.inputElement = el;
                        },
                        componentClass: 'select',
                        className: classNames }),
                    children && children
                )
            ),
            _react2.default.createElement(_Icon2.default, { icon: 'dropdown' })
        );
    };

    (0, _createClass3.default)(Select, [{
        key: 'value',
        get: function get() {
            return _reactDom2.default.findDOMNode(this.inputElement).value;
        }
    }]);
    return Select;
}(_react2.default.PureComponent), _class.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    type: _propTypes2.default.string,
    className: _propTypes2.default.string,
    label: _propTypes2.default.any,
    labelClassName: _propTypes2.default.string,
    groupClassName: _propTypes2.default.string,
    outerClassName: _propTypes2.default.string,
    children: _propTypes2.default.any
}, _class.defaultProps = {
    id: null,
    type: null,
    className: null,
    label: null,
    labelClassName: null,
    groupClassName: null,
    outerClassName: null,
    children: null
}, _temp);
exports.default = Select;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _JourneyPlanService = __webpack_require__(272);

var _JourneyPlanService2 = _interopRequireDefault(_JourneyPlanService);

var _FareOnlyService = __webpack_require__(972);

var _FareOnlyService2 = _interopRequireDefault(_FareOnlyService);

var _AppConstants = __webpack_require__(6);

var _Search3 = __webpack_require__(421);

var _ConfigService = __webpack_require__(630);

var _ConfigService2 = _interopRequireDefault(_ConfigService);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _PromoCodeActions = __webpack_require__(958);

var _PromoCodeActions2 = _interopRequireDefault(_PromoCodeActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchActions = {
    loadFromParams: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params, query) {
            var search;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _Search2.default.deserialize(params, query);

                        case 2:
                            search = _context.sent;

                            search = search.set('submitted', true);

                            this.checkPromoFromQuery(search);

                            return _context.abrupt('return', this.load(search));

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadFromParams(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return loadFromParams;
    }(),
    load: function load(search) {
        _AppDispatcher2.default.dispatch({
            search: search,
            actionType: _AppConstants.ActionTypes.SEARCH_LOADED
        });
        return search;
    },
    update: function update(searchRecord) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SEARCH_UPDATED,
            search: searchRecord
        });
    },
    checkPromoFromQuery: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(search) {
            var promoCode, enablePromoDiscount, enablePromoDiscountValidation, validatedPromoCode, newSearch, promo, _newSearch;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            promoCode = search.getPromoCode();
                            enablePromoDiscount = _FeatureFlagStore2.default.get('enablePromoDiscount');
                            enablePromoDiscountValidation = _FeatureFlagStore2.default.get('enablePromoDiscountValidation');

                            if (!(!enablePromoDiscount || !promoCode)) {
                                _context2.next = 5;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 5:
                            if (!enablePromoDiscountValidation) {
                                _context2.next = 13;
                                break;
                            }

                            _context2.next = 8;
                            return _PromoCodeActions2.default.validatePromoCode(promoCode);

                        case 8:
                            validatedPromoCode = _context2.sent;
                            newSearch = search.setPromoCode(validatedPromoCode);


                            this.update(newSearch);
                            _context2.next = 18;
                            break;

                        case 13:
                            promo = new _PromoCode2.default({ promoCode: promoCode });
                            _context2.next = 16;
                            return _PromoCodeActions2.default.apply(promo);

                        case 16:
                            _newSearch = search.setPromoCode(promo);

                            this.update(_newSearch);

                        case 18:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function checkPromoFromQuery(_x3) {
            return _ref2.apply(this, arguments);
        }

        return checkPromoFromQuery;
    }(),
    preFillPromoFromQuery: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(query) {
            var enablePromoDiscount, newSearch;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            enablePromoDiscount = _FeatureFlagStore2.default.get('enablePromoDiscount');

                            if (enablePromoDiscount) {
                                _context3.next = 3;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 3:
                            newSearch = new _Search2.default({ promoCode: new _PromoCode2.default(query) });

                            this.update(newSearch);

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function preFillPromoFromQuery(_x4) {
            return _ref3.apply(this, arguments);
        }

        return preFillPromoFromQuery;
    }(),
    checkTocOnlyRoute: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(search) {
            var result;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _ConfigService2.default.checkTocOnlyRoute(search);

                        case 2:
                            result = _context4.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CHECK_TOC_ONLY_ADD,
                                search: search,
                                result: result
                            });
                            return _context4.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function checkTocOnlyRoute(_x5) {
            return _ref4.apply(this, arguments);
        }

        return checkTocOnlyRoute;
    }(),
    search: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref5) {
            var search = _ref5.search,
                user = _ref5.user;
            var errors, result;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (search.departNow) {
                                search = search.setOutwardTimeNow();
                            }

                            if (search.isValid()) {
                                _context5.next = 5;
                                break;
                            }

                            errors = search.getValidationErrors().toJS().join(', ');


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SEARCH_FAILED,
                                search: search
                            });

                            return _context5.abrupt('return', _promise2.default.reject(new _Search3.InvalidSearchError('Failed check: ' + errors, search)));

                        case 5:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SEARCH_STARTED,
                                search: search
                            });

                            _context5.next = 8;
                            return _JourneyPlanService2.default.search({ search: search, user: user });

                        case 8:
                            result = _context5.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SEARCH_FINISHED,
                                search: search,
                                outward: result.outward,
                                inward: result.inward,
                                hasServiceProvider: result.hasServiceProvider
                            });

                            return _context5.abrupt('return', {
                                search: search,
                                result: result
                            });

                        case 11:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function search(_x6) {
            return _ref6.apply(this, arguments);
        }

        return search;
    }(),
    searchFares: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref7) {
            var search = _ref7.search,
                user = _ref7.user;
            var errors, fares;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            if (search.isValid()) {
                                _context6.next = 4;
                                break;
                            }

                            errors = search.getValidationErrors().toJS().join(', ');


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_ONLY_SEARCH_FAILED,
                                search: search
                            });

                            return _context6.abrupt('return', _promise2.default.reject(new _Search3.InvalidSearchError('Failed check: ' + errors, search)));

                        case 4:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_ONLY_SEARCH_STARTED,
                                search: search
                            });

                            _context6.next = 7;
                            return _FareOnlyService2.default.search(search, user);

                        case 7:
                            fares = _context6.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_ONLY_SEARCH_FINISHED,
                                search: search,
                                fares: fares
                            });

                            return _context6.abrupt('return', {
                                search: search,
                                fares: fares
                            });

                        case 10:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function searchFares(_x7) {
            return _ref8.apply(this, arguments);
        }

        return searchFares;
    }(),
    showEarlier: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(user, search, tripDirection, services) {
            var updatedSearch, result;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            updatedSearch = search.earlier(tripDirection, services);


                            _AppDispatcher2.default.dispatch({
                                search: updatedSearch,
                                tripDirection: tripDirection,
                                actionType: _AppConstants.ActionTypes.SHOW_EARLIER_TRAINS_STARTED
                            });

                            _context7.next = 4;
                            return _JourneyPlanService2.default.search({ search: updatedSearch, user: user });

                        case 4:
                            result = _context7.sent;


                            _AppDispatcher2.default.dispatch({
                                user: user,
                                result: result,
                                tripDirection: tripDirection,
                                search: updatedSearch,
                                actionType: _AppConstants.ActionTypes.SHOW_EARLIER_TRAINS_FINISHED
                            });

                            return _context7.abrupt('return', {
                                updatedSearch: updatedSearch,
                                result: result
                            });

                        case 7:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function showEarlier(_x8, _x9, _x10, _x11) {
            return _ref9.apply(this, arguments);
        }

        return showEarlier;
    }(),
    showLater: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(user, search, tripDirection, services) {
            var updatedSearch, result;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            updatedSearch = search.later(tripDirection, services);


                            _AppDispatcher2.default.dispatch({
                                search: updatedSearch,
                                tripDirection: tripDirection,
                                actionType: _AppConstants.ActionTypes.SHOW_LATER_TRAINS_STARTED
                            });

                            _context8.next = 4;
                            return _JourneyPlanService2.default.search({ search: updatedSearch, user: user });

                        case 4:
                            result = _context8.sent;


                            _AppDispatcher2.default.dispatch({
                                user: user,
                                result: result,
                                tripDirection: tripDirection,
                                search: updatedSearch,
                                actionType: _AppConstants.ActionTypes.SHOW_LATER_TRAINS_FINISHED
                            });

                            return _context8.abrupt('return', {
                                updatedSearch: updatedSearch,
                                result: result
                            });

                        case 7:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function showLater(_x12, _x13, _x14, _x15) {
            return _ref10.apply(this, arguments);
        }

        return showLater;
    }(),
    resetJourneyStore: function resetJourneyStore() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.RESET_JOURNEY_STORE
            });
        });
    }
};

exports.default = SearchActions;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _identity2 = __webpack_require__(116);

var _identity3 = _interopRequireDefault(_identity2);

exports.getFoldedTickets = getFoldedTickets;

var _immutable = __webpack_require__(5);

var _Ticket = __webpack_require__(239);

var _Ticket2 = _interopRequireDefault(_Ticket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Folds similar tickets into each other to reduce repetition
 * e.g. Two "1 Adult with 16-25" tickets would become "2 Adults with 16-25"
 *
 * @return {Immutable.List}
 */
function getFoldedTickets(tickets) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity3.default;

    return tickets.groupBy(callback).reduce(function (newTickets, groupedTickets) {
        var reducedTicket = groupedTickets.shift().reduce(function (newTicket, currentTicket) {
            return newTicket.withMutations(function (ticket) {
                var addProps = function addProps(key) {
                    return newTicket.get(key) ? newTicket.get(key) + currentTicket.get(key) : newTicket.get(key);
                };
                if (ticket instanceof _Ticket2.default) {
                    return ticket.set('adults', addProps('adults')).set('children', addProps('children')).set('price', addProps('price'));
                }
                return ticket.set('adults', addProps('adults')).set('children', addProps('children')).set('price', addProps('price')).set('railcardDiscount', addProps('railcardDiscount'));
            });
        }, groupedTickets.first());
        return newTickets.push(reducedTicket);
    }, new _immutable.List());
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: _propTypes.default.bool,

  /**
   * You can use a custom element for this component
   */
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Grid, _React$Component);

  function Grid() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        fluid = _this$props.fluid,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["fluid", "componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Grid;
}(_react.default.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('container', Grid);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isNumber2 = __webpack_require__(651);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _immutable = __webpack_require__(5);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _StationService = __webpack_require__(341);

var _StationService2 = _interopRequireDefault(_StationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stations = new _immutable.Map();

var searches = new _immutable.Map();

var StationStore = {
    search: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(text) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var filterByBrand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var key, response, result;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            key = text + '/' + type;

                            if (!searches.has(key)) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt('return', searches.get(key));

                        case 3:
                            _context.prev = 3;
                            _context.next = 6;
                            return _StationService2.default.search(text, type, filterByBrand);

                        case 6:
                            response = _context.sent;
                            result = response.map(function (station) {
                                if (stations.has(station.nlc)) {
                                    return stations.get(station.nlc);
                                }
                                stations = stations.set(station.nlc, station);
                                return station;
                            });


                            searches = searches.set(key, result);

                            return _context.abrupt('return', result);

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            console.error('StationService.search failed:', _context.t0);
                            throw _context.t0;

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[3, 12]]);
        }));

        function search(_x3) {
            return _ref.apply(this, arguments);
        }

        return search;
    }(),
    get: function get(id) {
        var _this = this;

        return new _promise2.default(function (resolve) {
            if (!id) {
                resolve(new _Station2.default());
                return;
            }

            if (stations.has(id)) {
                resolve(stations.get(id));
                return;
            }

            //Do a get for numeric ids (nlc)
            if ((0, _isNumber3.default)(id) || /\d+/.exec(String(id))) {
                resolve(_StationService2.default.get(id).then(function (station) {
                    stations = stations.set(id, station);
                    return station;
                }).catch(function (e) {
                    console.error(e);
                    return new _Station2.default();
                }));
            } else {
                //And a search for anything else (crs)
                resolve(_this.search(id).then(function (results) {
                    var found = results.find(function (station) {
                        return station.crs === id;
                    });
                    if (found) {
                        stations = stations.set(id, found);
                        return found;
                    }
                    return new _Station2.default();
                }).catch(function (e) {
                    console.error(e);
                    return new _Station2.default();
                }));
            }
        });
    }
};

exports.default = StationStore;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.diffDuration = diffDuration;
exports.diffDurationMinutes = diffDurationMinutes;
exports.durationString = durationString;

var _I18n = __webpack_require__(9);

function diffDuration(start, end) {
    var diff = end.calendarDiff(start);
    return { hours: diff.days * 24 + diff.hours, minutes: diff.minutes };
}

function diffDurationMinutes(start, end) {
    var diff = end.calendarDiff(start);
    return diff.hours * 60 + diff.minutes;
}

/**
 * Format a duration as a string
 *
 * @param {Object} duration
 * @param {Number} duration.hours
 * @param {Number} duration.minutes
 * @param [Object] options options
 * @param ["short"|"medium"|"long"] options.type
 */
function durationString(duration) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'short' : _ref$type;

    var string = duration.hours > 0 ? (0, _I18n.translate)('time.hours.' + type, duration) + ' ' : '';
    string += (0, _I18n.translate)('time.minutes.' + type, duration);
    return string;
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(633),
    createInverter = __webpack_require__(1654),
    identity = __webpack_require__(116);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(identity));

module.exports = invert;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    pan: null,
    nickname: null,
    cardToken: null,
    cardType: null,
    holderName: null,
    expiryDate: null,
    isKeyGoCard: null,
    address: new _Address2.default(),
    link: null
};

var StoredPaymentCard = function (_record) {
    (0, _inherits3.default)(StoredPaymentCard, _record);

    function StoredPaymentCard() {
        (0, _classCallCheck3.default)(this, StoredPaymentCard);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    StoredPaymentCard.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new StoredPaymentCard({
            id: (0, _LinkMapper.resolve)(json.id).with(Number),
            pan: (0, _LinkMapper.resolve)(json.pan).with(String),
            nickname: (0, _LinkMapper.resolve)(json.nickname).with(String),
            cardToken: (0, _LinkMapper.resolve)(json.cardToken).with(String),
            cardType: (0, _LinkMapper.resolve)(json.cardType).with(String),
            holderName: (0, _LinkMapper.resolve)(json.holderName).with(String),
            expiryDate: (0, _LinkMapper.resolve)(json.expiryDate).with(String),
            isKeyGoCard: (0, _LinkMapper.resolve)(json.isKeyGoCard).with(Boolean),
            address: (0, _LinkMapper.resolve)(json.address).as(_Address2.default),
            link: (0, _LinkMapper.resolve)(json.link).with(String)
        });
    };

    StoredPaymentCard.prototype.getLastDigits = function getLastDigits() {
        return this.pan.substr(-4);
    };

    return StoredPaymentCard;
}((0, _immutable.Record)(defaults));

exports.default = StoredPaymentCard;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(777),
    baseIteratee = __webpack_require__(102),
    toInteger = __webpack_require__(200);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

exports.getBrandInfo = getBrandInfo;

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getBrandInfo() {
    var brand = _config2.default.get('brand');
    var isSouthEastern = brand === 'southeastern';
    var isGTR = (0, _values2.default)(_AppConstants.Brands).includes(brand);
    var isTranspennine = brand === 'transpennine';

    return { brand: brand, isSouthEastern: isSouthEastern, isGTR: isGTR, isTranspennine: isTranspennine };
}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SmartCarnetRecordSearch = exports.SmartCarnetSearchRecordShape = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _immutable = __webpack_require__(5);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _LinkMapper = __webpack_require__(8);

var _SearchUrls = __webpack_require__(97);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _SearchMixin = __webpack_require__(538);

var _SearchMixin2 = _interopRequireDefault(_SearchMixin);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartCarnetSearchRecordShape = exports.SmartCarnetSearchRecordShape = _propTypes2.default.shape({
    destination: _propTypes2.default.instanceOf(_Station2.default).isRequired,
    origin: _propTypes2.default.instanceOf(_Station2.default).isRequired,
    startingDate: _MomentPropTypes2.default.isTrainTime.isRequired
});

var defaults = {
    destination: new _Station2.default(),
    origin: new _Station2.default(),
    startingDate: (0, _TrainTime2.default)(),
    adults: 1
};

var SmartCarnetRecordSearch = exports.SmartCarnetRecordSearch = function (_record) {
    (0, _inherits3.default)(SmartCarnetRecordSearch, _record);

    function SmartCarnetRecordSearch() {
        (0, _classCallCheck3.default)(this, SmartCarnetRecordSearch);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartCarnetRecordSearch.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        json = (0, _defaults3.default)(json, { adults: 0 });
        return (0, _LinkMapper.construct)(SmartCarnetRecordSearch, json, {
            destination: _LinkMapper.resolve.as(_Station2.default),
            origin: _LinkMapper.resolve.as(_Station2.default),
            startingDate: _LinkMapper.fields.datetime,
            adults: _LinkMapper.fields.number
        });
    };

    SmartCarnetRecordSearch.prototype.serialize = function serialize() {
        return (0, _SearchUrls.serialize)({
            destination: _SearchUrls.serializers.station,
            origin: _SearchUrls.serializers.station,
            startingDate: _SearchUrls.serializers.date,
            adults: _SearchUrls.serializers.identity
        }, this);
    };

    SmartCarnetRecordSearch.deserialize = function deserialize(params, query) {
        var source = (0, _assign2.default)({}, query, params);
        var schema = {
            destination: _SearchUrls.deserializers.station,
            origin: _SearchUrls.deserializers.station,
            startingDate: _SearchUrls.deserializers.date
        };

        return (0, _SearchUrls.deserialize)(schema, source).then(function (deserialized) {
            return new SmartCarnetRecordSearch(deserialized);
        });
    };

    SmartCarnetRecordSearch.prototype.getComputedValues = function getComputedValues() {
        return {
            destination: this.destination.getName(),
            origin: this.origin.getName(),
            startingDate: _LinkMapper.fields.date
        };
    };

    SmartCarnetRecordSearch.prototype.validateDatesInFuture = function validateDatesInFuture() {
        return this.startingDate && this.startingDate.isSameOrAfter((0, _TrainTime2.default)(), 'day');
    };

    SmartCarnetRecordSearch.prototype.getValidationErrors = function getValidationErrors() {
        var _this2 = this;

        var tests = (0, _immutable.Set)(['validateStationsComplete', 'validateStationsNotEqual', 'validateDatesInFuture']);

        return tests.filterNot(function (test) {
            return _this2[test]();
        });
    };

    SmartCarnetRecordSearch.prototype.isValid = function isValid() {
        return this.getValidationErrors().isEmpty();
    };

    return SmartCarnetRecordSearch;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(SmartCarnetRecordSearch.prototype, _SearchMixin2.default);

exports.default = SmartCarnetRecordSearch;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    cardholderName: null,
    created: null,
    email: null,
    expired: null,
    expiryDate: null,
    firstName: null,
    id: null,
    isGuest: false,
    isPreferred: false,
    isSeason: false,
    lastName: null,
    railcardCode: '',
    railcardName: null,
    railcardNumber: null,
    seenRailcardApproved: null,
    seenSyncKeyGoNotification: null,
    state: null,
    syncedWithKeygo: false
};

var AccountRailcard = function (_record) {
    (0, _inherits3.default)(AccountRailcard, _record);

    function AccountRailcard() {
        (0, _classCallCheck3.default)(this, AccountRailcard);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AccountRailcard.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(AccountRailcard, json, {
            cardholderName: _LinkMapper.fields.string,
            created: _LinkMapper.fields.datetime,
            email: _LinkMapper.fields.string,
            expired: _LinkMapper.fields.bool,
            expiryDate: _LinkMapper.fields.datetime,
            firstName: _LinkMapper.fields.string,
            id: _LinkMapper.fields.number,
            isGuest: _LinkMapper.fields.bool,
            isPreferred: _LinkMapper.fields.bool,
            isSeason: _LinkMapper.fields.bool,
            lastName: _LinkMapper.fields.string,
            railcardCode: (0, _LinkMapper.resolve)(json.railcardCode).with(function (data) {
                return data.code;
            }) || _LinkMapper.fields.string,
            railcardName: _LinkMapper.fields.string,
            railcardNumber: _LinkMapper.fields.string,
            seenRailcardApproved: _LinkMapper.fields.bool,
            seenSyncKeyGoNotification: _LinkMapper.fields.bool,
            state: _LinkMapper.fields.string,
            syncedWithKeygo: _LinkMapper.fields.bool
        });
    };

    AccountRailcard.prototype.getMaximumValidDate = function getMaximumValidDate() {
        var railcard1617GracePeriod = _config2.default.get('railcard1617GracePeriod');

        if (this.expiryDate) {
            var maxValidDate = this.expiryDate.clone();
            return maxValidDate.add(railcard1617GracePeriod);
        } else {
            return (0, _TrainTime2.default)('1970-01-01');
        }
    };

    AccountRailcard.prototype.isPresent = function isPresent() {
        var railcardCode = this.railcardCode || '';
        return railcardCode === _AppConstants.RAILCARD1617_CODE;
    };

    AccountRailcard.prototype.isValid = function isValid() {
        var testTodayDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var railcardCode = this.railcardCode || '';
        var isExpired = true;

        if (this.expiryDate) {
            var expiryDate = this.expiryDate.clone();
            var todayDate = testTodayDate ? testTodayDate : (0, _TrainTime2.default)();

            if (todayDate.isSameOrBefore(expiryDate, 'days')) {
                isExpired = false;
            }
        }

        return this.get('state') === _AppConstants.Railcard1617States.ACCEPTED && railcardCode === _AppConstants.RAILCARD1617_CODE && !isExpired;
    };

    return AccountRailcard;
}((0, _immutable.Record)(defaults));

exports.default = AccountRailcard;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaymentRadio(_ref) {
    var isSelected = _ref.isSelected,
        className = _ref.className;


    var iconClassNames = (0, _classnames2.default)(className + " otrl", {
        'otrl-select': !isSelected,
        'otrl-selected': isSelected
    });

    return _react2.default.createElement("span", { className: iconClassNames });
}

PaymentRadio.propTypes = {
    isSelected: _propTypes2.default.bool,
    className: _propTypes2.default.string
};

exports.default = PaymentRadio;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AccessibilityCircleIcon = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccessibilityCircleIcon = exports.AccessibilityCircleIcon = function AccessibilityCircleIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { clipPath: "url(#clip0_743_5728)" },
            _react2.default.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#1E1D51" }),
            _react2.default.createElement("path", { d: "M12 7.5C11.5875 7.5 11.2344 7.35313 10.9406 7.05938C10.6469 6.76562 10.5 6.4125 10.5 6C10.5 5.5875 10.6469 5.23438 10.9406 4.94063C11.2344 4.64688 11.5875 4.5 12 4.5C12.4125 4.5 12.7656 4.64688 13.0594 4.94063C13.3531 5.23438 13.5 5.5875 13.5 6C13.5 6.4125 13.3531 6.76562 13.0594 7.05938C12.7656 7.35313 12.4125 7.5 12 7.5ZM10.5 19.5C10.0858 19.5 9.75 19.1642 9.75 18.75V9.75C9 9.6875 8.2375 9.59375 7.4625 9.46875C6.95466 9.38684 6.46292 9.29151 5.98729 9.18277C5.57631 9.0888 5.33199 8.67203 5.43424 8.26303C5.53903 7.84386 5.967 7.5936 6.38862 7.68804C7.13706 7.85568 7.92002 7.98362 8.7375 8.07188C9.8375 8.19063 10.925 8.25 12 8.25C13.075 8.25 14.1625 8.19063 15.2625 8.07188C16.08 7.98362 16.8629 7.85568 17.6114 7.68804C18.033 7.5936 18.461 7.84386 18.5658 8.26303C18.668 8.67203 18.4237 9.0888 18.0127 9.18277C17.5371 9.29151 17.0453 9.38684 16.5375 9.46875C15.7625 9.59375 15 9.6875 14.25 9.75V18.75C14.25 19.1642 13.9142 19.5 13.5 19.5C13.0858 19.5 12.75 19.1642 12.75 18.75V15.75C12.75 15.3358 12.4142 15 12 15C11.5858 15 11.25 15.3358 11.25 15.75V18.75C11.25 19.1642 10.9142 19.5 10.5 19.5Z", fill: "white" })
        ),
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement(
                "clipPath",
                { id: "clip0_743_5728" },
                _react2.default.createElement("rect", { width: "24", height: "24", rx: "12", fill: "white" })
            )
        )
    );
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var pad = __webpack_require__(1676);

module.exports = function lpad(str, length, padStr) {
  return pad(str, length, padStr);
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _AdjustedTime = __webpack_require__(1705);

var _AdjustedTime2 = _interopRequireDefault(_AdjustedTime);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    station: new _Station2.default(),
    time: new _AdjustedTime2.default(),
    platform: null,
    added: false,
    cancelled: false,
    pattern: null,
    boardAlight: null
};

var StationStop = function (_record) {
    (0, _inherits3.default)(StationStop, _record);

    function StationStop() {
        (0, _classCallCheck3.default)(this, StationStop);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    StationStop.fromJSON = function fromJSON(json) {
        json = json || {};

        var station = (0, _LinkMapper.resolve)(json.station).as(_Station2.default);
        var time = (0, _LinkMapper.resolve)(json.time).as(_AdjustedTime2.default);
        var platform = (0, _LinkMapper.resolve)(json.platform).with(String);
        var added = (0, _LinkMapper.resolve)(json.added).with(Boolean);
        var cancelled = (0, _LinkMapper.resolve)(json.cancelled).with(Boolean);
        var pattern = (0, _LinkMapper.resolve)(json.pattern).with(String);
        var boardAlight = (0, _LinkMapper.resolve)(json.boardAlight).with(String);

        var result = { station: station, time: time, platform: platform };

        if (added) {
            result.added = added;
        }
        if (cancelled) {
            result.cancelled = cancelled;
        }
        if (pattern) {
            result.pattern = pattern;
        }
        if (boardAlight) {
            result.boardAlight = boardAlight;
        }

        return new StationStop(result);
    };

    StationStop.prototype.isAdjustedTime = function isAdjustedTime() {
        if (!this.time) {
            return false;
        }
        return !this.getTime().isSame(this.getTime(false));
    };

    StationStop.prototype.isDelayed = function isDelayed() {
        return this.getIn(['time', 'delayed']);
    };

    StationStop.prototype.getTime = function getTime() {
        var adjusted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        return (0, _result3.default)(this.getIn(['time', adjusted ? 'adjustedTime' : 'scheduledTime']), 'clone');
    };

    return StationStop;
}((0, _immutable.Record)(defaults));

exports.default = StationStop;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _AppConstants = __webpack_require__(6);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _TripPlusbus = __webpack_require__(634);

var _TripPlusbus2 = _interopRequireDefault(_TripPlusbus);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _RemoveJourneyModal = __webpack_require__(635);

var _RemoveJourneyModal2 = _interopRequireDefault(_RemoveJourneyModal);

var _DownloadTicketsModal = __webpack_require__(935);

var _DownloadTicketsModal2 = _interopRequireDefault(_DownloadTicketsModal);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _AddFavouriteLink = __webpack_require__(614);

var _AddFavouriteLink2 = _interopRequireDefault(_AddFavouriteLink);

var _CreateAlert = __webpack_require__(632);

var _CreateAlert2 = _interopRequireDefault(_CreateAlert);

var _Fare = __webpack_require__(636);

var _Fare2 = _interopRequireDefault(_Fare);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _TicketCalculationsSummary = __webpack_require__(940);

var _TicketCalculationsSummary2 = _interopRequireDefault(_TicketCalculationsSummary);

var _CarbonFootprintButton = __webpack_require__(1040);

var _CarbonFootprintButton2 = _interopRequireDefault(_CarbonFootprintButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trip = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Trip, _React$PureComponent);

    function Trip() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Trip);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            open: _this.props.order.hasRefunds() ? false : _this.props.open,
            previousOpen: false,
            journeyToRemove: null,
            showDownloads: false
        }, _this._toggleOpen = function () {
            _this.setState({ open: !_this.state.open });
        }, _this._togglePreviousOpen = function () {
            _this.setState({ previousOpen: !_this.state.previousOpen });
        }, _this._showDownloads = function () {
            _this.setState({ showDownloads: true });
        }, _this._closeDownloads = function () {
            _this.setState({ showDownloads: false });
        }, _this._handleRemoveJourney = function (journey) {
            return function () {
                _this.setState({ journeyToRemove: journey });
            };
        }, _this._handleRemoveJourneyBack = function () {
            _this.setState({ journeyToRemove: null });
        }, _this._handleRemoveJourneyConfirm = function () {
            _OrderActions2.default.deleteTrip(_this.props.order, _this.props.orderTrip);
            _this.setState({ journeyToRemove: null });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Trip.prototype.getFare = function getFare() {
        var _props = this.props,
            isFareOnly = _props.isFareOnly,
            orderTrip = _props.orderTrip;

        return isFareOnly ? orderTrip.getFareOnlyFare() : orderTrip.getOutwardFare();
    };

    Trip.prototype._renderRemoveConfirm = function _renderRemoveConfirm() {
        var _this2 = this;

        if (this.state.journeyToRemove) {
            return _react2.default.createElement(_RemoveJourneyModal2.default, {
                journey: this.state.journeyToRemove,
                onBack: this._handleRemoveJourneyBack,
                onConfirm: function onConfirm() {
                    _this2._handleRemoveJourneyConfirm();
                    _this2.props.setBasketChanged();
                }
            });
        }

        return null;
    };

    Trip.prototype.renderRemoveJourney = function renderRemoveJourney(tripTitle) {
        if (!this.props.order.isPaid() && !this.props.isLocked) {
            return _react2.default.createElement(
                _Button2.default,
                { className: 'journey-remove hidden-print btn-plain pull-right', onClick: this._handleRemoveJourney(this.props.orderTrip) },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('order.summary.removeJourney'),
                    tripTitle
                ),
                _react2.default.createElement(_Icon2.default, { icon: 'bin' })
            );
        }

        return null;
    };

    Trip.prototype.getCalculation = function getCalculation(ticket) {
        var storedRefundCalculations = this.props.storedRefundCalculations;


        if (!ticket || !storedRefundCalculations || storedRefundCalculations.size === 0) {
            return null;
        }

        return storedRefundCalculations.tickets.find(function (c) {
            return c.getIn(['calculation', 'ticketId']) === ticket.id && c.getIn(['calculation', 'refundAmount']) > 0;
        });
    };

    Trip.prototype.renderRefundCalculations = function renderRefundCalculations(orderFare, tripTitle) {
        var _this3 = this;

        var _props2 = this.props,
            refundDetails = _props2.refundDetails,
            order = _props2.order,
            context = _props2.context;

        var RefundTitleTag = context === _AppConstants.OrderSummaryContexts.BASKET_MODAL ? 'h3' : 'h4';

        return _react2.default.createElement(
            'div',
            { className: 'margin-top border--top' },
            _react2.default.createElement(
                RefundTitleTag,
                { className: 'margin-top--sm text-weight--bold' },
                (0, _I18n.translate)('account.orders.refund.tickets')
            ),
            orderFare.tickets.map(function (ticket, index) {
                return _react2.default.createElement(_TicketCalculationsSummary2.default, {
                    hasSmartCarnetTrip: order.hasSmartCarnetTrip(),
                    key: index,
                    refundDetails: refundDetails,
                    storedRefundCalculation: _this3.getCalculation(ticket),
                    ticket: ticket,
                    tripTitle: tripTitle,
                    isSmartcard: order.isSmartcard()
                });
            })
        );
    };

    Trip.prototype.renderFavourite = function renderFavourite() {
        var fare = this.getFare();
        var _props3 = this.props,
            orderTrip = _props3.orderTrip,
            delivery = _props3.order.delivery;


        if (fare && !fare.isExcludedFromFavourites()) {
            return _react2.default.createElement(_AddFavouriteLink2.default, {
                buttonProps: {
                    className: "pull-right margin-top--sm margin-left--sm"
                },
                fare: fare,
                orderTrip: orderTrip,
                delivery: delivery,
                context: 'point-checkout'
            });
        }

        return null;
    };

    Trip.prototype.renderCreateAlert = function renderCreateAlert() {
        var _props4 = this.props,
            order = _props4.order,
            orderTrip = _props4.orderTrip;


        return _react2.default.createElement(_CreateAlert2.default, {
            buttonProps: {
                className: "pull-right margin-top--sm"
            },
            order: order,
            orderTrip: orderTrip,
            context: 'point-checkout'
        });
    };

    Trip.prototype.renderTripActions = function renderTripActions() {
        var _props5 = this.props,
            isLoggedIn = _props5.isLoggedIn,
            matchingTimetableAlert = _props5.matchingTimetableAlert,
            context = _props5.context;


        var fare = this.getFare();

        var alertProps = matchingTimetableAlert ? matchingTimetableAlert.toJS() : {};
        var delaysChecked = alertProps.delaysChecked;

        var carbonClassName = 'carbon-footprint__' + (context === _AppConstants.OrderSummaryContexts.BASKET_MODAL ? 'basket-modal' : 'payment-confirm-page');

        return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12, md: 6, className: 'fare-actions pull-right' },
                isLoggedIn && this.renderFavourite(),
                isLoggedIn && this.props.open && !delaysChecked && this.renderCreateAlert()
            ),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableCarbonCalculator' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, md: 6 },
                    _react2.default.createElement(_CarbonFootprintButton2.default, { fare: fare, className: carbonClassName })
                )
            )
        );
    };

    Trip.prototype.renderPrevious = function renderPrevious(fares) {
        var _this4 = this;

        var previousOpen = this.state.previousOpen;
        var orderTrip = this.props.orderTrip;

        var dropDownClassNames = (0, _classnames2.default)('hidden-print text-secondary', {
            'otrl-rotate-180': previousOpen
        });
        // the plusBus is always included in the amended journey if the original journey had a plusBus
        return _react2.default.createElement(
            'div',
            { className: 'border--top padding-top--sm margin-top--sm' },
            _react2.default.createElement(
                'p',
                { className: 'journey-toggler no-margin text-secondary text-weight--normal' },
                _react2.default.createElement(
                    _OnEnterTrigger2.default,
                    { element: 'span', onClick: this._togglePreviousOpen },
                    _react2.default.createElement(_Icon2.default, { icon: 'dropdown', className: dropDownClassNames }),
                    (0, _I18n.translate)('account.orders.amend.previousJourney')
                ),
                this.renderRemoveJourney()
            ),
            fares.map(function (fare) {
                return _react2.default.createElement(_Fare2.default, {
                    key: fare.fareId,
                    orderFare: fare,
                    open: previousOpen,
                    isFareOnly: _this4.props.isFareOnly,
                    isAmended: true
                });
            }),
            _react2.default.createElement(_TripPlusbus2.default, { key: '1', orderTrip: orderTrip, open: previousOpen })
        );
    };

    Trip.prototype.render = function render() {
        var _props6 = this.props,
            order = _props6.order,
            orderTrip = _props6.orderTrip,
            index = _props6.index,
            isFareOnly = _props6.isFareOnly,
            showAmendedTrip = _props6.showAmendedTrip,
            context = _props6.context,
            matchingTimetableAlert = _props6.matchingTimetableAlert,
            isLoggedIn = _props6.isLoggedIn;
        var open = this.state.open;

        var orderFare = this.getFare();
        var fares = orderTrip.getJourneyFares();
        var titleKey = orderTrip.isSmartcard() ? 'smartcard_title' : 'journey_title';
        var tripTitle = (0, _I18n.translate)('order.summary.' + titleKey, { number: index + 1 });
        var TripTitleTag = context === _AppConstants.OrderSummaryContexts.BASKET_MODAL ? 'h2' : 'h3';

        var classNames = (0, _classnames2.default)('order-summary__item', {
            'order-summary__item--expanded': open
        });
        var dropDownClassNames = (0, _classnames2.default)('hidden-print text-secondary', {
            'otrl-rotate-180': open
        });
        var amendedTickets = fares.flatMap(function (fare) {
            return fare.tickets.filter(function (ticket) {
                return order.isNewTicket(ticket.id);
            }).map(function (ticket) {
                return order.getOldFareFromNewTicketId(ticket.id);
            });
        });

        return _react2.default.createElement(
            'li',
            { className: classNames },
            this._renderRemoveConfirm(),
            _react2.default.createElement(
                'div',
                { className: 'box-headed box-headed--primary' },
                _react2.default.createElement(
                    'div',
                    { className: 'box-headed__header box--padded text-weight--normal' },
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 8 },
                            _react2.default.createElement(
                                TripTitleTag,
                                { className: 'journey-heading text-weight--normal fake-header' },
                                tripTitle
                            )
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 4, className: 'text-right price' },
                            _react2.default.createElement(_Price2.default, { price: orderTrip.getTotalPrice() })
                        )
                    )
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableTicketDownload' },
                    order.hasDownloadableTickets() && _react2.default.createElement(
                        'div',
                        { className: 'box box--padded box-headed__body' },
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xsOffset: 8, xs: 4, className: 'text-right price' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { onClick: this._showDownloads },
                                    (0, _I18n.translate)('order.summary.download.tickets')
                                ),
                                this.state.showDownloads && _react2.default.createElement(_DownloadTicketsModal2.default, (0, _extends3.default)({ onClose: this._closeDownloads }, { order: order, orderTrip: orderTrip }))
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'box-headed__body box--padded' },
                    _react2.default.createElement(
                        'p',
                        { className: 'journey-toggler no-margin text-secondary text-weight--normal' },
                        _react2.default.createElement(
                            _OnEnterTrigger2.default,
                            { element: 'span', role: 'button', onClick: this._toggleOpen },
                            _react2.default.createElement(_Icon2.default, { icon: 'dropdown', className: dropDownClassNames }),
                            (0, _I18n.translate)(showAmendedTrip && amendedTickets.count() ? 'account.orders.amend.journey' : 'order.summary.journey_details'),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                '. ',
                                open ? (0, _I18n.translate)('global.clickToCollapse') : (0, _I18n.translate)('global.clickToExpand')
                            )
                        ),
                        this.renderRemoveJourney(tripTitle)
                    ),
                    fares.map(function (fare, key) {
                        return _react2.default.createElement(_Fare2.default, {
                            orderFare: fare,
                            key: key,
                            open: open,
                            isFareOnly: isFareOnly,
                            isSmartcard: order.isSmartcard(),
                            matchingTimetableAlert: matchingTimetableAlert,
                            isLoggedIn: isLoggedIn,
                            orderTrip: orderTrip,
                            idx: key
                        });
                    }),
                    _react2.default.createElement(_TripPlusbus2.default, { key: '0', orderTrip: orderTrip, open: open }),
                    this.renderTripActions(),
                    showAmendedTrip && Boolean(amendedTickets.count()) && this.renderPrevious(amendedTickets),
                    order.hasRefunds() && orderFare.tickets.some(function (ticket) {
                        return ticket.isRefunded;
                    }) && this.renderRefundCalculations(orderFare, tripTitle)
                )
            )
        );
    };

    return Trip;
}(_react2.default.PureComponent), _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    open: _propTypes2.default.bool,
    isLocked: _propTypes2.default.bool,
    isLoggedIn: _propTypes2.default.bool,
    isFareOnly: _propTypes2.default.bool,
    showAmendedTrip: _propTypes2.default.bool,
    refundDetails: _propTypes2.default.instanceOf(_Order2.default),
    storedRefundCalculations: _propTypes2.default.instanceOf(_immutable.List),
    context: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.OrderSummaryContexts)),
    matchingTimetableAlert: _propTypes2.default.object,
    setBasketChanged: _propTypes2.default.func
}, _class.defaultProps = {
    open: false,
    isLocked: false,
    isLoggedIn: false,
    isFareOnly: false,
    showAmendedTrip: true,
    storedRefundCalculations: new _immutable.List(),
    context: null,
    matchingTimetableAlert: null,
    setBasketChanged: _noop3.default
}, _temp2);
exports.default = Trip;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DeliveryOptionOrder;

var _immutable = __webpack_require__(5);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var brand = _config2.default.get('brand');
var isSouthEastern = brand === 'southeastern';

var defaults = {
    id: null,
    fulfilmentMethod: null,
    internalName: null,
    displayName: null,
    price: null,
    collectionPoints: new _immutable.List(),
    suggestedCollectionPoint: null,
    isTrackable: null,
    isSignedFor: null,
    isPrintedEticket: null,
    isDeliverableOnTime: false,
    isEnforced: false,
    errors: null,
    promotionalDiscountDelivery: null
};

var DeliveryOptionOrder = (_DeliveryOptionOrder = {}, _DeliveryOptionOrder[_AppConstants.FulfilmentType.S_TICKET] = 1, _DeliveryOptionOrder[_AppConstants.FulfilmentType.SMARTCARD] = 2, _DeliveryOptionOrder[_AppConstants.FulfilmentType.E_TICKET] = 3, _DeliveryOptionOrder[_AppConstants.FulfilmentType.PRINT_AT_HOME] = 4, _DeliveryOptionOrder[_AppConstants.FulfilmentType.COLLECTION] = 5, _DeliveryOptionOrder[_AppConstants.FulfilmentType.POSTAL] = 6, _DeliveryOptionOrder);

if (isSouthEastern) {
    DeliveryOptionOrder[_AppConstants.FulfilmentType.SMARTCARD] = 3;
    DeliveryOptionOrder[_AppConstants.FulfilmentType.E_TICKET] = 2;
}

var DeliveryOption = function (_record) {
    (0, _inherits3.default)(DeliveryOption, _record);

    function DeliveryOption() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DeliveryOption);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _record.call.apply(_record, [this].concat(args))), _this), _this.getValidAssociatedSmartcards = function (_ref) {
            var fare = _ref.fare,
                associatedSmartcards = _ref.associatedSmartcards;

            if (!_FeatureFlagStore2.default.get('enableChildSmartcardTransitioning')) {
                return associatedSmartcards;
            }
            return associatedSmartcards.filter(function (card) {
                var fareValidTo = fare.getValidTo();

                if (fareValidTo.isAfter(card.getExpiryDateMoment())) {
                    return false;
                }

                if (card.isAdult) {
                    return true;
                }

                var cardHolderDateOfBirthMoment = card.getCardHolderDateOfBirthMoment();

                if (fare.isSeason()) {
                    return fareValidTo.diff(cardHolderDateOfBirthMoment, 'months') < 16 * 12 + 4;
                } else {
                    return fareValidTo.diff(cardHolderDateOfBirthMoment, 'years') < 16;
                }
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    DeliveryOption.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var filterCantDeliver = function filterCantDeliver(error) {
            return (0, _keys2.default)(error)[0] === _AppConstants.SmartcardErrorBlocking.CANT_DELIVER_IN_TIME;
        };
        var filterEverythingElse = function filterEverythingElse(error) {
            return (0, _keys2.default)(error)[0] !== _AppConstants.SmartcardErrorBlocking.CANT_DELIVER_IN_TIME;
        };

        // Move the "Can't deliver" error to the top of the list
        var reorderedErrors = json.errors && json.errors.length ? [].concat(json.errors.filter(filterCantDeliver), json.errors.filter(filterEverythingElse)) : json.errors;

        return (0, _LinkMapper.construct)(DeliveryOption, json, {
            id: _LinkMapper.fields.string,
            fulfilmentMethod: _LinkMapper.fields.string,
            internalName: _LinkMapper.fields.string,
            displayName: _LinkMapper.fields.string,
            price: _LinkMapper.fields.number,
            suggestedCollectionPoint: _LinkMapper.resolve.as(_Station2.default),
            collectionPoints: _LinkMapper.resolveAll.as(_Station2.default),
            isTrackable: _LinkMapper.fields.bool,
            isSignedFor: _LinkMapper.fields.bool,
            isPrintedEticket: _LinkMapper.fields.bool,
            isDeliverableOnTime: _LinkMapper.fields.bool,
            promotionalDiscountDelivery: _LinkMapper.resolve.with(Object),
            isEnforced: _LinkMapper.fields.bool,

            // This is an array of objects each with a single key which is the error code,
            // and the value is an empty object. This leads to some quite opaque and confusing code.
            // Might be better to refactor this to a simple array of error codes
            errors: (0, _LinkMapper.resolve)(reorderedErrors).with(Object)
        });
    };

    DeliveryOption.prototype.getOrder = function getOrder() {
        return DeliveryOptionOrder[this.fulfilmentMethod];
    };

    DeliveryOption.prototype.getFirstAvailableDeliveryOption = function getFirstAvailableDeliveryOption(delivery, deliveryOptions) {
        var isUserLoggedIn = _UserStore2.default.getCurrent().isLoggedIn();

        var SmartCardBlockingAdditional = isUserLoggedIn ? _AppConstants.SmartCardErrorBlockingForLoggedIn : {};

        var isSmartcard = delivery.fulfilmentMethod === _AppConstants.FulfilmentType.SMARTCARD;
        var isSTicket = delivery.fulfilmentMethod === _AppConstants.FulfilmentType.S_TICKET;

        var shouldSelectSTicket = _FeatureFlagStore2.default.get('enableSTicketsDelivery') && _FeatureFlagStore2.default.get('enableSTickets') && !this.errors;

        if (delivery.fulfilmentMethod && deliveryOptions.find(function (option) {
            return option.fulfilmentMethod === delivery.fulfilmentMethod;
        }) && !isSmartcard && !isSTicket) {
            return this.fulfilmentMethod === delivery.fulfilmentMethod;
        }

        if (this.fulfilmentMethod === _AppConstants.FulfilmentType.S_TICKET) {
            return shouldSelectSTicket;
        }

        if (_FeatureFlagStore2.default.get('enableSmartcardMaintenance') || !_FeatureFlagStore2.default.get('enableSmartcard')) {
            return this.fulfilmentMethod !== _AppConstants.FulfilmentType.SMARTCARD;
        }

        return !this.errors || !(0, _stringify2.default)(this.errors).match(new RegExp((0, _values2.default)((0, _extends3.default)({}, _AppConstants.SmartcardErrorBlocking, _AppConstants.SmartcardServiceErrors, SmartCardBlockingAdditional)).join('|'), 'g'));
    };

    DeliveryOption.prototype.isValidWithPromo = function isValidWithPromo() {
        if (!this.promotionalDiscountDelivery) {
            return true;
        }

        return this.promotionalDiscountDelivery.isApplicable;
    };

    DeliveryOption.prototype.getPrice = function getPrice() {
        var price = this.price;

        if (!this.isValidWithPromo()) {
            price += this.promotionalDiscountDelivery.value;
        }

        return price;
    };

    DeliveryOption.prototype.shouldHideSmartcard = function shouldHideSmartcard(smartcard, associatedSmartcards, allowMixedPreencodeAndLinkedFulfilment, includesChildPreencode) {
        if (includesChildPreencode) {
            return true;
        }

        var isUserLoggedIn = _UserStore2.default.getCurrent().isLoggedIn();

        var SmartCardBlockingAdditional = isUserLoggedIn ? _AppConstants.SmartCardErrorBlockingForLoggedIn : {};

        var errors = this.get('errors');

        var updatedErrors = errors || [];

        /*
         Note, we have to do this as sometimes the deliver options
         endpoint returns a 'SmartcardCantBeDeliveredInTimeError' error,
         but sometimes not, and just 'isDeliverableOnTime: false' instead.
        */
        if (isUserLoggedIn && this.isDeliverableOnTime === false && !smartcard && associatedSmartcards.size < 1) {
            updatedErrors[1] = {
                SmartcardCantBeDeliveredInTimeError: {}
            };
        }

        // Override for when we have the 'allowMixedPreencodeAndLinkedFulfilment' scenario
        var filteredDeliveryErrors = updatedErrors && updatedErrors.filter(function (e) {
            return allowMixedPreencodeAndLinkedFulfilment ? !(_AppConstants.SmartCardErrorBlockingForLoggedIn.NOT_ENOUGH_ACTIVE_SMARTCARDS_ERROR in e) : function () {
                return true;
            };
        });

        var deliveryErrors = (0, _stringify2.default)(filteredDeliveryErrors) || '';

        return (0, _values2.default)((0, _extends3.default)({}, _AppConstants.SmartcardErrorBlocking, SmartCardBlockingAdditional)).some(function (e) {
            return deliveryErrors.indexOf(e) > 0;
        });
    };

    DeliveryOption.prototype.requiresLocation = function requiresLocation() {
        return this.isCollection() || this.isSmartcard();
    };

    DeliveryOption.prototype.isPrintAtHome = function isPrintAtHome() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.PRINT_AT_HOME;
    };

    DeliveryOption.prototype.isETicket = function isETicket() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.E_TICKET;
    };

    DeliveryOption.prototype.isCollection = function isCollection() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.COLLECTION;
    };

    DeliveryOption.prototype.isPostalDelivery = function isPostalDelivery() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.POSTAL;
    };

    DeliveryOption.prototype.isETicketByPost = function isETicketByPost() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.POSTAL && this.isPrintedEticket;
    };

    DeliveryOption.prototype.isSmartcard = function isSmartcard() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.SMARTCARD;
    };

    DeliveryOption.prototype.isSTicket = function isSTicket() {
        return this.fulfilmentMethod === _AppConstants.FulfilmentType.S_TICKET;
    };

    DeliveryOption.prototype.hasError = function hasError(error) {
        return this.getErrors().some(function (deliveryError) {
            return deliveryError === error;
        });
    };

    DeliveryOption.prototype.hasDeliveryErrors = function hasDeliveryErrors() {
        return this.errors && this.errors.length > 0;
    };

    DeliveryOption.prototype.getErrors = function getErrors() {
        return this.hasDeliveryErrors() ? this.errors.map(function (error) {
            return (0, _keys2.default)(error)[0];
        }) : [];
    };

    DeliveryOption.prototype.getEarliestDeliveryDate = function getEarliestDeliveryDate() {
        var days = this.isSmartcard() ? _config2.default.get('minAwaitingSmartcardProductDays') : _config2.default.get('minDeliveryLeadTimeInDays');
        var earliest = (0, _TrainTime2.default)().addWorkingDays(days);

        if ((0, _TrainTime2.default)().hours() >= _config2.default.get('pivotalPostalHour')) {
            // If it's after last post, then make it the next day
            earliest = earliest.addWorkingDays(1);
        }
        return earliest;
    };

    DeliveryOption.prototype.hasSmartcardBlockingErrors = function hasSmartcardBlockingErrors() {
        if (this.errors) {
            // convert errors and known error constants to same format for comparison
            var smartcardErrorBlockingStrings = (0, _values2.default)((0, _extends3.default)({}, _AppConstants.SmartcardErrorBlocking, _AppConstants.SmartcardServiceErrors)).map(function (x) {
                return x.toLowerCase();
            });

            // convert errors and known error constants to same format for comparison
            var errorStrings = this.errors.map(function (err) {
                return (0, _keys2.default)(err).map(function (x) {
                    return x.toLowerCase();
                });
            }).flat();

            // check if fulfilment errors are 'blocking' errors
            return errorStrings.some(function (errString) {
                return smartcardErrorBlockingStrings.includes(errString);
            });
        } else {
            return false;
        }
    };

    return DeliveryOption;
}((0, _immutable.Record)(defaults));

exports.default = DeliveryOption;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _pickBy2 = __webpack_require__(161);

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _keys2 = __webpack_require__(127);

var _keys3 = _interopRequireDefault(_keys2);

var _immutable = __webpack_require__(5);

var _SearchUrls = __webpack_require__(97);

var _DisruptionAlert = __webpack_require__(289);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Customer = __webpack_require__(795);

var _Customer2 = _interopRequireDefault(_Customer);

var _DisruptionAlertLeg = __webpack_require__(904);

var _DisruptionAlertLeg2 = _interopRequireDefault(_DisruptionAlertLeg);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _DisruptionAlertMute = __webpack_require__(582);

var _DisruptionAlertMute2 = _interopRequireDefault(_DisruptionAlertMute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    id: [_LinkMapper.fields.number],
    customer: [_LinkMapper.resolve.as(_Customer2.default)],
    isEmailNotification: [_LinkMapper.fields.boolean, true],
    isCloudMessageNotification: [_LinkMapper.fields.boolean, false],
    orderId: [_LinkMapper.fields.number, null],
    tripId: [_LinkMapper.fields.number, null],
    origin: [_LinkMapper.resolve.as(_Station2.default)],
    destination: [_LinkMapper.resolve.as(_Station2.default)],
    departureDate: [_LinkMapper.resolve.with(_TrainTime2.default), null],
    departureTime: [_LinkMapper.resolve.with(function (time) {
        return (0, _TrainTime2.default)(time, 'HH:mm:ss');
    }), null],
    legs: [_LinkMapper.resolveAll.as(_DisruptionAlertLeg2.default), new _immutable.List()],
    alertForever: [_LinkMapper.fields.boolean, false],
    alertFrom: [_LinkMapper.resolve.with(_TrainTime2.default), null],
    alertTo: [_LinkMapper.resolve.with(_TrainTime2.default), null],
    daysOfWeek: [_LinkMapper.resolveAll.with(_LinkMapper.fields.string), new _immutable.List()],
    mutes: [_LinkMapper.resolveAll.as(_DisruptionAlertMute2.default), new _immutable.List()],
    isStationAlert: [_LinkMapper.fields.boolean, false]
};

var DisruptionAlert = function (_record) {
    (0, _inherits3.default)(DisruptionAlert, _record);

    function DisruptionAlert() {
        (0, _classCallCheck3.default)(this, DisruptionAlert);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DisruptionAlert.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DisruptionAlert, json, (0, _Records.getResolvers)(fieldSchema));
    };

    DisruptionAlert.createFromOrderJourney = function createFromOrderJourney(_ref) {
        var user = _ref.user,
            order = _ref.order,
            orderTrip = _ref.orderTrip,
            orderJourney = _ref.orderJourney,
            stationFacilityAlert = _ref.stationFacilityAlert,
            isEmailNotification = _ref.isEmailNotification,
            isCloudMessageNotification = _ref.isCloudMessageNotification;

        var legs = (0, _DisruptionAlert.legsToDisruptionAlertLegs)(orderJourney.legs);

        var journeyData = {
            origin: orderJourney.getOrigin(),
            destination: orderJourney.getDestination(),
            departureDate: orderJourney.getDepartureTime(),
            departureTime: orderJourney.getDepartureTime(),
            legs: legs
        };

        var optionsData = {
            alertFrom: orderJourney.getDepartureTime(),
            alertTo: orderJourney.getDepartureTime()
        };

        return new DisruptionAlert((0, _extends3.default)({
            customer: user.customer,
            orderId: order.id,
            tripId: parseInt(orderTrip.getCleanId(true)),
            isStationAlert: stationFacilityAlert,
            isEmailNotification: isEmailNotification,
            isCloudMessageNotification: isCloudMessageNotification
        }, journeyData, optionsData));
    };

    DisruptionAlert.createFromBuilder = function createFromBuilder(_ref2) {
        var user = _ref2.user,
            order = _ref2.order,
            orderTrip = _ref2.orderTrip,
            formData = _ref2.formData,
            stationFacilityAlert = _ref2.stationFacilityAlert,
            isEmailNotification = _ref2.isEmailNotification,
            isCloudMessageNotification = _ref2.isCloudMessageNotification;
        var startDate = formData.startDate,
            customEndDate = formData.customEndDate,
            selectedServices = formData.selectedServices,
            duration = formData.duration,
            days = formData.days,
            weekdays = formData.weekdays;


        var isIndefinite = duration === _AppConstants.DisruptionAlertDurationOptions.INFINITE;

        var isOneOff = duration === _AppConstants.DisruptionAlertDurationOptions.ONEOFF || duration === _AppConstants.DisruptionAlertDurationOptions.CUSTOM && startDate.isSame(customEndDate);

        var dateAdjustedServices = selectedServices.map(function (service) {
            return service;
        });

        var legs = dateAdjustedServices.reduce(function (legsAcc, service, serviceIndex) {
            var groupId = ++serviceIndex;
            var serviceLegs = service.journey.legs.filter(function (leg) {
                return leg.serviceDetails.mode === _AppConstants.TransitModes.TRAIN;
            }).map(function (leg, legIndex) {
                return new _DisruptionAlertLeg2.default({
                    trainUid: leg.getTrainUid(),
                    origin: leg.getOriginStation(),
                    destination: leg.getDestinationStation(),
                    departureTime: leg.getDepartureTime(),
                    arrivalTime: leg.getArrivalTime(),
                    groupId: groupId,
                    legOrder: ++legIndex
                });
            });

            if (serviceLegs) {
                return legsAcc.concat(serviceLegs);
            }

            return legsAcc;
        }, new _immutable.List());

        var journey = dateAdjustedServices.first().journey;
        var journeyData = (0, _extends3.default)({
            origin: journey.getOriginStation(),
            destination: journey.getDestinationStation()
        }, isOneOff && { departureDate: journey.getDepartureDateTime() }, {
            departureTime: legs.first().departureTime,
            legs: legs
        });

        var endDate = void 0;
        if (isIndefinite) {
            endDate = null;
        } else if (duration === _AppConstants.DisruptionAlertDurationOptions.SIXMONTHS) {
            endDate = startDate.clone().add(6, 'months');
        } else if (duration === _AppConstants.DisruptionAlertDurationOptions.ONEOFF) {
            endDate = startDate;
        } else if (duration === _AppConstants.DisruptionAlertDurationOptions.CUSTOM) {
            endDate = customEndDate;
        }

        var daysOfWeek = new _immutable.List();
        if (!isOneOff) {
            if (days === _AppConstants.DisruptionAlertDaysOptions.WEEKDAYS) {
                daysOfWeek = (0, _keys3.default)((0, _pickBy3.default)(weekdays));
            } else if (days === _AppConstants.DisruptionAlertDaysOptions.SATURDAYS) {
                daysOfWeek = ['SATURDAY'];
            } else if (days === _AppConstants.DisruptionAlertDaysOptions.SUNDAYS) {
                daysOfWeek = ['SUNDAY'];
            }
        }

        var optionsData = {
            alertFrom: isIndefinite ? null : startDate,
            alertTo: endDate,
            daysOfWeek: daysOfWeek
        };

        return new DisruptionAlert((0, _extends3.default)({
            customer: user.customer,
            orderId: order && order.id,
            tripId: orderTrip && parseInt(orderTrip.getCleanId(true)),
            isStationAlert: stationFacilityAlert,
            alertForever: isIndefinite,
            isEmailNotification: isEmailNotification,
            isCloudMessageNotification: isCloudMessageNotification
        }, journeyData, optionsData));
    };

    DisruptionAlert.prototype.toJSON = function toJSON() {
        var getAlertDetailsProp = function getAlertDetailsProp(alert, path) {
            return (0, _get3.default)(alert, path) || null;
        };
        return (0, _SearchUrls.serialize)({
            disruptionAlertId: function disruptionAlertId(__, alert) {
                return getAlertDetailsProp(alert, 'id');
            },
            cocsCustomerId: function cocsCustomerId(__, alert) {
                return getAlertDetailsProp(alert, 'customer.id');
            },
            isEmailNotification: _SearchUrls.serializers.identity,
            isCloudMessageNotification: _SearchUrls.serializers.identity,
            orderId: _SearchUrls.serializers.identity,
            tripId: _SearchUrls.serializers.identity,
            origin: _SearchUrls.serializers.stationCrs,
            destination: _SearchUrls.serializers.stationCrs,
            departureDate: function departureDate(_departureDate) {
                return _departureDate ? _SearchUrls.serializers.date(_departureDate) : null;
            },
            departureTime: function departureTime(_departureTime) {
                return _departureTime ? _SearchUrls.serializers.time(_departureTime) : null;
            },
            legs: function legs(_legs) {
                return _legs ? _legs.map(function (leg) {
                    return leg.toJSON();
                }) : [];
            },
            alertForever: _SearchUrls.serializers.identity,
            alertFrom: function alertFrom(_alertFrom) {
                return _alertFrom ? _SearchUrls.serializers.date(_alertFrom) : null;
            },
            alertTo: function alertTo(_alertTo) {
                return _alertTo ? _SearchUrls.serializers.date(_alertTo) : null;
            },
            daysOfWeek: _SearchUrls.serializers.identity,
            mutes: function mutes(_mutes) {
                return _mutes ? _mutes.map(function (mute) {
                    return mute.toJSON();
                }) : [];
            },
            isStationAlert: _SearchUrls.serializers.identity
        }, this);
    };

    DisruptionAlert.prototype.matchesOrderTrip = function matchesOrderTrip(order, orderTrip) {
        var orderId = this.orderId,
            tripId = this.tripId;

        return orderId === order.id && tripId === parseInt(orderTrip.getCleanId(true));
    };

    DisruptionAlert.prototype.getServices = function getServices() {
        return this.legs.groupBy(function (leg) {
            return leg.groupId;
        }).map(function (service) {
            return service.sortBy(function (leg) {
                return leg.legOrder;
            });
        });
    };

    DisruptionAlert.prototype.isForever = function isForever() {
        return this.alertForever;
    };

    DisruptionAlert.prototype.isOneOff = function isOneOff() {
        return !this.isForever() && this.alertFrom.isSame(this.alertTo);
    };

    DisruptionAlert.prototype.getDaysAlertedOn = function getDaysAlertedOn() {
        var daysOfWeek = this.daysOfWeek,
            departureDate = this.departureDate;


        if (daysOfWeek.size === 0) {
            return 'Weekdays';
        }

        if (this.isOneOff()) {
            return departureDate && departureDate.format('dddd');
        } else if (daysOfWeek.equals(new _immutable.List((0, _keys3.default)(_AppConstants.DisruptionAlertWeekdays)))) {
            return 'Weekdays';
        } else if (daysOfWeek.equals(new _immutable.List(['SATURDAY']))) {
            return 'Saturdays';
        } else if (daysOfWeek.equals(new _immutable.List(['SUNDAY']))) {
            return 'Sundays';
        } else {
            return daysOfWeek.size > 1 ? daysOfWeek.map(function (day) {
                return (0, _DisruptionAlert.formatDayOfWeek)(day, true);
            }).join(', ') : (0, _DisruptionAlert.formatDayOfWeek)(daysOfWeek.first()) + 's';
        }
    };

    DisruptionAlert.prototype.getOriginAndDestination = function getOriginAndDestination() {
        return {
            origin: this.origin.name,
            destination: this.destination.name
        };
    };

    DisruptionAlert.prototype.isMuted = function isMuted() {
        return !!this.mutes.size;
    };

    DisruptionAlert.prototype.getMutedUntil = function getMutedUntil() {
        return this.isMuted() && this.mutes.first().muteUntil;
    };

    return DisruptionAlert;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = DisruptionAlert;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getWidthDifferenceToReachRatio = exports.PHOTO_PORTRAIT_RATIO = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    photo: null,
    imageData: null,
    selectedImage: null,
    imageWidth: null,
    imageHeight: null,
    binary: null
};

var PHOTO_PORTRAIT_RATIO = exports.PHOTO_PORTRAIT_RATIO = 1.1;

var getWidthDifferenceToReachRatio = exports.getWidthDifferenceToReachRatio = function getWidthDifferenceToReachRatio(imageWidth, imageHeight, orientation) {
    var extraPixels = null;

    switch (orientation) {
        case 'portrait':
            // Solving an equation:
            //
            // PHOTO_PORTRAIT_RATIO = imageHeight / (imageWidth - extraWidth)
            //
            // The extraWidth tells us how many pixels the image is too wide
            // to be classified as a portrait orientated one.
            extraPixels = Math.ceil(-imageHeight / PHOTO_PORTRAIT_RATIO + imageWidth);
            break;
    }

    return extraPixels;
};

var Photo = function (_Record) {
    (0, _inherits3.default)(Photo, _Record);

    function Photo() {
        (0, _classCallCheck3.default)(this, Photo);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    Photo.prototype.getImageOrientation = function getImageOrientation() {
        var imageWidth = this.imageWidth,
            imageHeight = this.imageHeight;

        if (!imageWidth || !imageHeight) {
            return null;
        }

        var ratio = imageHeight / imageWidth;
        return ratio > PHOTO_PORTRAIT_RATIO ? 'portrait' : ratio < 0.9 ? 'landscape' : 'square';
    };

    return Photo;
}((0, _immutable.Record)(defaults));

exports.default = Photo;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenActions = {
    updateDevice: function updateDevice(token) {
        _AppDispatcher2.default.dispatch({
            token: token,
            actionType: _AppConstants.ActionTypes.DEVICE_TOKEN_UPDATED
        });
    }
};

exports.default = TokenActions;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CustomerAccountLocked = exports.CustomerAccountDormant = exports.CustomerMaxFailedLoginAttemptsReached = exports.CustomerRefreshError = exports.CustomerLoginError = exports.CustomerRegistrationError = exports.CustomerEmailInUseError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class5, _temp6, _class6, _temp8, _class7, _temp10;

var _ExtendableError5 = __webpack_require__(91);

var _ExtendableError6 = _interopRequireDefault(_ExtendableError5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerEmailInUseError = exports.CustomerEmailInUseError = function (_ExtendableError) {
    (0, _inherits3.default)(CustomerEmailInUseError, _ExtendableError);

    function CustomerEmailInUseError() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomerEmailInUseError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'CustomerEmailInUseError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return CustomerEmailInUseError;
}(_ExtendableError6.default);

var CustomerRegistrationError = exports.CustomerRegistrationError = function (_ExtendableError2) {
    (0, _inherits3.default)(CustomerRegistrationError, _ExtendableError2);

    function CustomerRegistrationError() {
        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, CustomerRegistrationError);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError2.call.apply(_ExtendableError2, [this].concat(args))), _this2), _this2.name = 'CustomerRegistrationError', _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    return CustomerRegistrationError;
}(_ExtendableError6.default);

var CustomerLoginError = exports.CustomerLoginError = function (_ExtendableError3) {
    (0, _inherits3.default)(CustomerLoginError, _ExtendableError3);

    function CustomerLoginError() {
        var _temp3, _this3, _ret3;

        (0, _classCallCheck3.default)(this, CustomerLoginError);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError3.call.apply(_ExtendableError3, [this].concat(args))), _this3), _this3.name = 'CustomerLoginError', _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
    }

    return CustomerLoginError;
}(_ExtendableError6.default);

var CustomerRefreshError = exports.CustomerRefreshError = function (_ExtendableError4) {
    (0, _inherits3.default)(CustomerRefreshError, _ExtendableError4);

    function CustomerRefreshError() {
        var _temp4, _this4, _ret4;

        (0, _classCallCheck3.default)(this, CustomerRefreshError);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return _ret4 = (_temp4 = (_this4 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError4.call.apply(_ExtendableError4, [this].concat(args))), _this4), _this4.name = 'CustomerRefreshError', _temp4), (0, _possibleConstructorReturn3.default)(_this4, _ret4);
    }

    return CustomerRefreshError;
}(_ExtendableError6.default);

var CustomerMaxFailedLoginAttemptsReached = exports.CustomerMaxFailedLoginAttemptsReached = (_temp6 = _class5 = function (_CustomerLoginError) {
    (0, _inherits3.default)(CustomerMaxFailedLoginAttemptsReached, _CustomerLoginError);

    function CustomerMaxFailedLoginAttemptsReached() {
        var _temp5, _this5, _ret5;

        (0, _classCallCheck3.default)(this, CustomerMaxFailedLoginAttemptsReached);

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return _ret5 = (_temp5 = (_this5 = (0, _possibleConstructorReturn3.default)(this, _CustomerLoginError.call.apply(_CustomerLoginError, [this].concat(args))), _this5), _this5.name = 'CustomerMaxFailedLoginAttemptsReached', _temp5), (0, _possibleConstructorReturn3.default)(_this5, _ret5);
    }

    return CustomerMaxFailedLoginAttemptsReached;
}(CustomerLoginError), _class5.code = 8034, _temp6);
var CustomerAccountDormant = exports.CustomerAccountDormant = (_temp8 = _class6 = function (_CustomerLoginError2) {
    (0, _inherits3.default)(CustomerAccountDormant, _CustomerLoginError2);

    function CustomerAccountDormant() {
        var _temp7, _this6, _ret6;

        (0, _classCallCheck3.default)(this, CustomerAccountDormant);

        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        return _ret6 = (_temp7 = (_this6 = (0, _possibleConstructorReturn3.default)(this, _CustomerLoginError2.call.apply(_CustomerLoginError2, [this].concat(args))), _this6), _this6.name = 'CustomerAccountDormant', _temp7), (0, _possibleConstructorReturn3.default)(_this6, _ret6);
    }

    return CustomerAccountDormant;
}(CustomerLoginError), _class6.code = 8035, _temp8);
var CustomerAccountLocked = exports.CustomerAccountLocked = (_temp10 = _class7 = function (_CustomerLoginError3) {
    (0, _inherits3.default)(CustomerAccountLocked, _CustomerLoginError3);

    function CustomerAccountLocked() {
        var _temp9, _this7, _ret7;

        (0, _classCallCheck3.default)(this, CustomerAccountLocked);

        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }

        return _ret7 = (_temp9 = (_this7 = (0, _possibleConstructorReturn3.default)(this, _CustomerLoginError3.call.apply(_CustomerLoginError3, [this].concat(args))), _this7), _this7.name = 'CustomerAccountLocked', _temp9), (0, _possibleConstructorReturn3.default)(_this7, _ret7);
    }

    return CustomerAccountLocked;
}(CustomerLoginError), _class7.code = 8036, _temp10);

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var booleanToYesNo = exports.booleanToYesNo = function booleanToYesNo(boolean) {
    return boolean ? 'Yes' : 'No';
};

var yesNoToBoolean = exports.yesNoToBoolean = function yesNoToBoolean(value) {
    if (typeof value === 'boolean') {
        return value;
    } else if (typeof value === 'string') {
        return value.toLowerCase() === 'yes';
    } else {
        return false;
    }
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ButtonSizes = undefined;

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _useRouter = __webpack_require__(338);

var _useRouter2 = _interopRequireDefault(_useRouter);

var _AppConstants = __webpack_require__(6);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonSizes = exports.ButtonSizes = (0, _keymirror2.default)({
    SM: null,
    MD: null
});

var AlertButton = function AlertButton(_ref) {
    var _cn;

    var className = _ref.className,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$hasMatchingAlert = _ref.hasMatchingAlert,
        hasMatchingAlert = _ref$hasMatchingAlert === undefined ? false : _ref$hasMatchingAlert,
        _ref$hideIcon = _ref.hideIcon,
        hideIcon = _ref$hideIcon === undefined ? false : _ref$hideIcon,
        _ref$hideText = _ref.hideText,
        hideText = _ref$hideText === undefined ? false : _ref$hideText,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? _noop3.default : _ref$onClick,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? ButtonSizes.MD : _ref$size,
        _ref$text = _ref.text,
        text = _ref$text === undefined ? (0, _I18n2.default)('disruptionAlerts.create.button') : _ref$text;

    var router = (0, _useRouter2.default)();

    var handleClick = hasMatchingAlert ? function () {
        return router.push(_urls2.default.location(_AppConstants.AccountPages.ACCOUNT_DISRUPTION_ALERTS));
    } : onClick;

    var baseClass = 'create-disruption-alert-btn';
    var classes = (0, _classnames2.default)(baseClass, 'btn-squarish', (_cn = {}, _cn[baseClass + '--sm'] = size === ButtonSizes.SM, _cn[baseClass + '--icon-only'] = hideText, _cn[baseClass + '--matching-alert'] = hasMatchingAlert, _cn), className);

    return _react2.default.createElement(
        _Button2.default,
        {
            className: classes,
            onClick: handleClick,
            disabled: disabled
        },
        !hideIcon && _react2.default.createElement(_Icon2.default, { icon: 'alert-active' }),
        _react2.default.createElement(
            'span',
            { className: hideText && 'sr-only' },
            hasMatchingAlert ? (0, _I18n2.default)('disruptionAlerts.create.button.matchingAlert') : text
        )
    );
};

AlertButton.propTypes = {
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    hasMatchingAlert: _propTypes2.default.bool,
    hideIcon: _propTypes2.default.bool,
    hideText: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    size: _propTypes2.default.oneOf([(0, _values3.default)(ButtonSizes)]),
    text: _propTypes2.default.string
};

exports.default = AlertButton;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = RailcardBadge;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Railcard = __webpack_require__(241);

var _Railcard2 = _interopRequireDefault(_Railcard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RailcardBadge(_ref) {
    var railcard = _ref.railcard;

    return _react2.default.createElement(
        'span',
        { className: 'fare__railcard-badge fare__railcard-badge--' + railcard.code.toLowerCase() + ' text-sm' },
        railcard.name
    );
}

RailcardBadge.propTypes = {
    railcard: _propTypes2.default.instanceOf(_Railcard2.default).isRequired
};

/***/ }),
/* 451 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(277),
    isObject = __webpack_require__(77);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(793);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1568), __esModule: true };

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LoadingStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identity = function identity(x) {
    return x;
};

var LoadingStore = exports.LoadingStore = function (_BaseStore) {
    (0, _inherits3.default)(LoadingStore, _BaseStore);

    function LoadingStore() {
        (0, _classCallCheck3.default)(this, LoadingStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    LoadingStore.prototype.getLoadingForType = function getLoadingForType(type) {
        return this.state.get(type, new _immutable.Map());
    };

    LoadingStore.prototype.setLoadingForType = function setLoadingForType(type, loading) {
        this.setState(this.state.set(type, loading));
    };

    LoadingStore.prototype.isLoading = function isLoading() {
        var _this2 = this;

        for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
            types[_key] = arguments[_key];
        }

        if (types.length) {
            var typesList = new _immutable.List(types);
            return !!typesList.find(function (type) {
                return _this2.getLoadingForType(type).find(identity);
            });
        }
        return !!this.state.flatten().find(identity);
    };

    LoadingStore.prototype.handleLoadStarted = function handleLoadStarted(_ref) {
        var type = _ref.type,
            id = _ref.id;

        var loading = this.getLoadingForType(type).set(id, true);
        this.setLoadingForType(type, loading);
    };

    LoadingStore.prototype.handleLoadStopped = function handleLoadStopped(_ref2) {
        var type = _ref2.type,
            id = _ref2.id;

        var loading = this.getLoadingForType(type).delete(id);
        this.setLoadingForType(type, loading);
    };

    LoadingStore.prototype.handleLoadersStopped = function handleLoadersStopped() {
        this.setState(new _immutable.Map());
    };

    LoadingStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.LOADING_STARTED] = this.handleLoadStarted, _ref3[_AppConstants.ActionTypes.LOADING_COMPLETED] = this.handleLoadStopped, _ref3[_AppConstants.ActionTypes.LOADING_FAILED] = this.handleLoadStopped, _ref3[_AppConstants.ActionTypes.LOADING_STOPPED] = this.handleLoadersStopped, _ref3;
    };

    return LoadingStore;
}(_BaseStore3.default);

var instance = new LoadingStore();

exports.default = instance;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _immutable = __webpack_require__(5);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _DisruptionAlert = __webpack_require__(444);

var _DisruptionAlert2 = _interopRequireDefault(_DisruptionAlert);

var _DisruptionAlertMute = __webpack_require__(582);

var _DisruptionAlertMute2 = _interopRequireDefault(_DisruptionAlertMute);

var _ServiceChangeAlert = __webpack_require__(1068);

var _ServiceChangeAlert2 = _interopRequireDefault(_ServiceChangeAlert);

var _LinkMapper = __webpack_require__(8);

var _DisruptionAlert3 = __webpack_require__(289);

var _DisruptionAlerts = __webpack_require__(460);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisruptionAlertService = {

    /**
     * @return {String}
     */
    getBaseUrl: function getBaseUrl() {
        return '/ddm-alerts';
    },


    /**
     * @param {User} user
     * @return {String}
     */
    getAuthenticatedBaseUrl: function getAuthenticatedBaseUrl(user) {
        return this.getBaseUrl() + '/customer/' + user.id;
    },


    /**
     * @param {User} user
     * @return {DisruptionAlert[]}
     */
    getAll: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var endpoint, response, alerts;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alerts';
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context.sent;
                            alerts = response['disruption-alerts'].map(function (alert) {
                                return (0, _DisruptionAlert3.formatDisruptionAlertResponse)(alert);
                            });
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(alerts).as(_DisruptionAlert2.default));

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0 instanceof _AuthenticatedAPIClient.NotFoundError) {
                                _context.next = 13;
                                break;
                            }

                            throw _context.t0;

                        case 13:
                            return _context.abrupt('return', new _immutable.List());

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 9]]);
        }));

        function getAll(_x) {
            return _ref.apply(this, arguments);
        }

        return getAll;
    }(),


    /**
     * @param {User} user
     * @param {Order} order
     * @param {OrderTrip} orderTrip
     * @param {OrderJourney} orderJourney
     * @return {DisruptionAlert}
     */
    createFromOrderJourney: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
            var user = _ref2.user,
                order = _ref2.order,
                orderTrip = _ref2.orderTrip,
                orderJourney = _ref2.orderJourney,
                stationFacilityAlert = _ref2.stationFacilityAlert;

            var preferences, isEmailNotification, isCloudMessageNotification, alert, endpoint, response, _response;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return DisruptionAlertService.getPreferences(user.id);

                        case 3:
                            preferences = _context2.sent;
                            isEmailNotification = preferences.isEmailNotification, isCloudMessageNotification = preferences.isCloudMessageNotification;
                            alert = _DisruptionAlert2.default.createFromOrderJourney({ user: user, order: order, orderTrip: orderTrip, orderJourney: orderJourney, stationFacilityAlert: stationFacilityAlert, isEmailNotification: isEmailNotification, isCloudMessageNotification: isCloudMessageNotification });
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alerts';
                            _context2.next = 9;
                            return _AuthenticatedAPIClient2.default.post(endpoint, alert.toJSON());

                        case 9:
                            response = _context2.sent;
                            return _context2.abrupt('return', (0, _LinkMapper.resolve)((0, _DisruptionAlert3.formatDisruptionAlertResponse)(response)).as(_DisruptionAlert2.default));

                        case 13:
                            _context2.prev = 13;
                            _context2.t0 = _context2['catch'](0);
                            _response = _context2.t0.response;

                            if (!(_response && _response.status === 422)) {
                                _context2.next = 18;
                                break;
                            }

                            throw new _DisruptionAlerts.DisruptionAlertsLimitExceededError();

                        case 18:
                            throw _context2.t0;

                        case 19:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 13]]);
        }));

        function createFromOrderJourney(_x2) {
            return _ref3.apply(this, arguments);
        }

        return createFromOrderJourney;
    }(),


    /**
     * @param {User} user
     * @param {Order} order
     * @param {OrderTrip} orderTrip
     * @param {Object} formData
     * @return {DisruptionAlert}
     */
    createFromBuilder: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref4) {
            var user = _ref4.user,
                order = _ref4.order,
                orderTrip = _ref4.orderTrip,
                formData = _ref4.formData,
                stationFacilityAlert = _ref4.stationFacilityAlert;

            var preferences, isEmailNotification, isCloudMessageNotification, alert, endpoint, response, _response2;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return DisruptionAlertService.getPreferences(user.id);

                        case 3:
                            preferences = _context3.sent;
                            isEmailNotification = preferences.isEmailNotification, isCloudMessageNotification = preferences.isCloudMessageNotification;
                            alert = _DisruptionAlert2.default.createFromBuilder({ user: user, order: order, orderTrip: orderTrip, formData: formData, stationFacilityAlert: stationFacilityAlert, isEmailNotification: isEmailNotification, isCloudMessageNotification: isCloudMessageNotification });
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alerts';
                            _context3.next = 9;
                            return _AuthenticatedAPIClient2.default.post(endpoint, alert.toJSON());

                        case 9:
                            response = _context3.sent;
                            return _context3.abrupt('return', (0, _LinkMapper.resolve)((0, _DisruptionAlert3.formatDisruptionAlertResponse)(response)).as(_DisruptionAlert2.default));

                        case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3['catch'](0);
                            _response2 = _context3.t0.response;

                            if (!(_response2 && _response2.status === 422)) {
                                _context3.next = 18;
                                break;
                            }

                            throw new _DisruptionAlerts.DisruptionAlertsLimitExceededError();

                        case 18:
                            throw _context3.t0;

                        case 19:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 13]]);
        }));

        function createFromBuilder(_x3) {
            return _ref5.apply(this, arguments);
        }

        return createFromBuilder;
    }(),


    /**
     * @param {User} user
     * @param {Object} alertData
     * @return {DisruptionAlert}
     */
    update: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(user, updatedAlert) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alerts/' + updatedAlert.id;
                            _context4.next = 3;
                            return _AuthenticatedAPIClient2.default.put(endpoint, updatedAlert.toJSON());

                        case 3:
                            response = _context4.sent;
                            return _context4.abrupt('return', (0, _LinkMapper.resolve)((0, _DisruptionAlert3.formatDisruptionAlertResponse)(response)).as(_DisruptionAlert2.default));

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function update(_x4, _x5) {
            return _ref6.apply(this, arguments);
        }

        return update;
    }(),


    /**
     * @param {User} user
     * @param {DisruptionAlert} alert
     */
    delete: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(user, alert) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alert/' + alert.id;
                            _context5.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(endpoint);

                        case 3:
                            return _context5.abrupt('return', true);

                        case 4:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function _delete(_x6, _x7) {
            return _ref7.apply(this, arguments);
        }

        return _delete;
    }(),


    /**
     * @param {User} user
     * @param {DisruptionAlert} alert
     * @param {DisruptionAlertMute} alertMute
     */
    createMute: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(user, alert, alertMute) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alert/' + alert.id + '/alert-mute';
                            _context6.next = 3;
                            return _AuthenticatedAPIClient2.default.post(endpoint, alertMute.toJSON());

                        case 3:
                            response = _context6.sent;
                            return _context6.abrupt('return', (0, _LinkMapper.resolve)((0, _DisruptionAlert3.formatDisruptionAlertMuteResponse)(response)).as(_DisruptionAlertMute2.default));

                        case 5:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function createMute(_x8, _x9, _x10) {
            return _ref8.apply(this, arguments);
        }

        return createMute;
    }(),


    /**
     * @param {User} user
     * @param {DisruptionAlert} alert
     * @param {DisruptionAlertMute} alertMute
     */
    editMute: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(user, alert, alertMute) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alert/' + alert.id + '/alert-mute/' + alertMute.id;
                            _context7.next = 3;
                            return _AuthenticatedAPIClient2.default.put(endpoint, alertMute.toJSON());

                        case 3:
                            response = _context7.sent;
                            return _context7.abrupt('return', (0, _LinkMapper.resolve)((0, _DisruptionAlert3.formatDisruptionAlertMuteResponse)(response)).as(_DisruptionAlertMute2.default));

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function editMute(_x11, _x12, _x13) {
            return _ref9.apply(this, arguments);
        }

        return editMute;
    }(),


    /**
     * @param {User} user
     * @param {DisruptionAlert} alert
     * @param {DisruptionAlertMute} alertMute
     */
    deleteMute: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(user, alert, alertMute) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/disruption-alert/' + alert.id + '/alert-mute/' + alertMute.id;
                            _context8.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(endpoint);

                        case 3:
                            return _context8.abrupt('return', true);

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function deleteMute(_x14, _x15, _x16) {
            return _ref10.apply(this, arguments);
        }

        return deleteMute;
    }(),


    /**
     * @param {Number} ddmUserId
     * @param {Number} alertId
     * @param {String} token
     * @param {Boolean} muteAll
     */
    muteForDay: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(customerId, disruptionAlertId, securityToken, muteAllAlerts) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.prev = 0;
                            endpoint = this.getBaseUrl() + '/alert-mute-for-day';
                            _context9.next = 4;
                            return _AuthenticatedAPIClient2.default.post(endpoint, {
                                customerId: customerId,
                                disruptionAlertId: disruptionAlertId,
                                securityToken: securityToken,
                                muteAllAlerts: muteAllAlerts
                            });

                        case 4:
                            return _context9.abrupt('return', true);

                        case 7:
                            _context9.prev = 7;
                            _context9.t0 = _context9['catch'](0);
                            response = _context9.t0.response;

                            if (!response) {
                                _context9.next = 17;
                                break;
                            }

                            _context9.t1 = response.status;
                            _context9.next = _context9.t1 === 400 ? 14 : _context9.t1 === 403 ? 15 : _context9.t1 === 409 ? 16 : 17;
                            break;

                        case 14:
                            throw new _DisruptionAlerts.DisruptionAlertsSecurityCheckFailureError();

                        case 15:
                            throw new _DisruptionAlerts.DisruptionAlertsMuteTokenExpiredError();

                        case 16:
                            throw new _DisruptionAlerts.DisruptionAlertsAlreadyMutedError();

                        case 17:
                            throw _context9.t0;

                        case 18:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this, [[0, 7]]);
        }));

        function muteForDay(_x17, _x18, _x19, _x20) {
            return _ref11.apply(this, arguments);
        }

        return muteForDay;
    }(),
    getBankHolidays: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            var endpoint, response, dates;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.prev = 0;
                            endpoint = this.getBaseUrl() + '/bank-holidays?excludePastDates=true';
                            _context10.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context10.sent;
                            dates = response['england-and-wales'].map(function (_ref13) {
                                var date = _ref13.date;
                                return date;
                            });
                            return _context10.abrupt('return', (0, _LinkMapper.resolveAll)(dates).with(_TrainTime2.default));

                        case 9:
                            _context10.prev = 9;
                            _context10.t0 = _context10['catch'](0);

                            if (_context10.t0 instanceof _AuthenticatedAPIClient.NotFoundError) {
                                _context10.next = 13;
                                break;
                            }

                            throw _context10.t0;

                        case 13:
                            return _context10.abrupt('return', new _immutable.List());

                        case 14:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this, [[0, 9]]);
        }));

        function getBankHolidays() {
            return _ref12.apply(this, arguments);
        }

        return getBankHolidays;
    }(),
    createServiceChangeAlert: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(_ref14) {
            var timetableChangesAlert = _ref14.timetableChangesAlert;
            var endpoint;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.prev = 0;
                            endpoint = this.getBaseUrl() + '/service-change';
                            _context11.next = 4;
                            return _AuthenticatedAPIClient2.default.post(endpoint, timetableChangesAlert);

                        case 4:
                            _context11.next = 10;
                            break;

                        case 6:
                            _context11.prev = 6;
                            _context11.t0 = _context11['catch'](0);

                            console.warn('createServiceChangeAlert err', _context11.t0);
                            throw _context11.t0;

                        case 10:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this, [[0, 6]]);
        }));

        function createServiceChangeAlert(_x21) {
            return _ref15.apply(this, arguments);
        }

        return createServiceChangeAlert;
    }(),
    deleteServiceChangeAlert: function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(user, alrt) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/service-change/' + alrt.serviceChangeAlertId;
                            _context12.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(endpoint);

                        case 3:
                            return _context12.abrupt('return', true);

                        case 4:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function deleteServiceChangeAlert(_x22, _x23) {
            return _ref16.apply(this, arguments);
        }

        return deleteServiceChangeAlert;
    }(),


    // eslint-disable-next-line
    deleteServiceChangeAlertAnon: function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(_ref17) {
            var alertId = _ref17.alertId,
                ddmCustomerId = _ref17.ddmCustomerId,
                orderId = _ref17.orderId,
                securityToken = _ref17.securityToken,
                ticketIds = _ref17.ticketIds;
            var endpoint;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.prev = 0;
                            endpoint = this.getBaseUrl() + '/service-change-alert-remove';

                            if (!orderId) {
                                _context13.next = 7;
                                break;
                            }

                            _context13.next = 5;
                            return _AuthenticatedAPIClient2.default.post(endpoint, {
                                orderId: orderId,
                                securityToken: securityToken,
                                ticketIds: ticketIds
                            });

                        case 5:
                            _context13.next = 9;
                            break;

                        case 7:
                            _context13.next = 9;
                            return _AuthenticatedAPIClient2.default.post(endpoint, {
                                alertId: alertId,
                                deleteThisAlert: true,
                                ddmCustomerId: ddmCustomerId,
                                securityToken: securityToken
                            });

                        case 9:
                            return _context13.abrupt('return', true);

                        case 12:
                            _context13.prev = 12;
                            _context13.t0 = _context13['catch'](0);
                            throw _context13.t0;

                        case 15:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this, [[0, 12]]);
        }));

        function deleteServiceChangeAlertAnon(_x24) {
            return _ref18.apply(this, arguments);
        }

        return deleteServiceChangeAlertAnon;
    }(),
    getServiceChangeAlerts: function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(user) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.prev = 0;
                            endpoint = this.getAuthenticatedBaseUrl(user) + '/service-change';
                            _context14.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context14.sent;
                            return _context14.abrupt('return', (0, _LinkMapper.resolveAll)(response['service-changes']).as(_ServiceChangeAlert2.default));

                        case 8:
                            _context14.prev = 8;
                            _context14.t0 = _context14['catch'](0);
                            throw _context14.t0;

                        case 11:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this, [[0, 8]]);
        }));

        function getServiceChangeAlerts(_x25) {
            return _ref19.apply(this, arguments);
        }

        return getServiceChangeAlerts;
    }(),
    getPreferences: function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(customerId) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            endpoint = this.getBaseUrl() + '/customer/' + customerId + '/preference';
                            _context15.next = 3;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 3:
                            response = _context15.sent;
                            return _context15.abrupt('return', response);

                        case 5:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this);
        }));

        function getPreferences(_x26) {
            return _ref20.apply(this, arguments);
        }

        return getPreferences;
    }(),
    setPreferences: function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(customerId, prefs) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            endpoint = this.getBaseUrl() + '/customer/' + customerId + '/preference';
                            _context16.next = 3;
                            return _AuthenticatedAPIClient2.default.put(endpoint, prefs);

                        case 3:
                            response = _context16.sent;
                            return _context16.abrupt('return', response);

                        case 5:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, this);
        }));

        function setPreferences(_x27, _x28) {
            return _ref21.apply(this, arguments);
        }

        return setPreferences;
    }()
};

exports.default = DisruptionAlertService;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _Countries = __webpack_require__(1605);

var _Countries2 = _interopRequireDefault(_Countries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Country = new _immutable2.default.Record({ name: null, iso2: null });

var countries = _immutable2.default.fromJS(_Countries2.default.map(function (_ref) {
    var name = _ref[0],
        iso2 = _ref[1];
    return new Country({ name: name, iso2: iso2 });
}));

var CountryStore = function () {
    function CountryStore() {
        (0, _classCallCheck3.default)(this, CountryStore);
    }

    CountryStore.prototype.getCountries = function getCountries() {
        return countries;
    };

    CountryStore.prototype.getCountry = function getCountry(iso2) {
        return countries.find(function (country) {
            return country.iso2 === iso2;
        });
    };

    return CountryStore;
}();

var storeInstance = new CountryStore();

exports.default = storeInstance;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.BannerStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Immutable = __webpack_require__(54);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BannerState = new _immutable.Record({
    banner: null,
    dismissed: new _immutable.List()
});

var BannerStore = exports.BannerStore = function (_BaseStore) {
    (0, _inherits3.default)(BannerStore, _BaseStore);

    function BannerStore() {
        (0, _classCallCheck3.default)(this, BannerStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    BannerStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.BANNER_CONFIG_LOADED] = this.handleBannerLoaded, _ref[_AppConstants.ActionTypes.BANNER_DISMISSED] = this.handleBannerDismissed, _ref;
    };

    BannerStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return new BannerState({ dismissed: _immutable2.default.fromJS(serialized.dismissed) });
        }
        return new BannerState();
    };

    BannerStore.prototype.serialize = function serialize() {
        var now = (0, _TrainTime2.default)();
        var notExpired = this.state.dismissed.filter(function (dismissedBanner) {
            return (0, _TrainTime2.default)(dismissedBanner.get('expiry')).isAfter(now);
        });
        var uniqueDismissed = (0, _Immutable.unique)(notExpired, function (dismissedBanner) {
            return dismissedBanner.get('id');
        });

        return {
            dismissed: uniqueDismissed.toJS()
        };
    };

    BannerStore.prototype.handleBannerLoaded = function handleBannerLoaded(_ref2) {
        var banner = _ref2.banner;

        this.setState(this.state.set('banner', banner));
    };

    BannerStore.prototype.handleBannerDismissed = function handleBannerDismissed(_ref3) {
        var id = _ref3.id;

        var expires = _config2.default.get('bannerMessageDismissExpires') || false;
        var dismissedBanner = new _immutable.Map({
            id: id,
            expiry: (0, _TrainTime2.default)().add(expires, 'seconds').format()
        });
        this.setState(this.state.set('dismissed', this.state.dismissed.push(dismissedBanner)));
    };

    BannerStore.prototype.isBannerDismissed = function isBannerDismissed(banner) {
        var dismissed = this.state.dismissed.findLast(function (dismissedBanner) {
            return dismissedBanner.get('id') === banner.id;
        });
        if (dismissed) {
            return (0, _TrainTime2.default)(dismissed.get('expiry')).isAfter((0, _TrainTime2.default)());
        }
        return false;
    };

    BannerStore.prototype.getActive = function getActive() {
        var banner = this.state.banner;

        if (banner && banner.isActive() && !this.isBannerDismissed(banner)) {
            return banner;
        }
        return null;
    };

    return BannerStore;
}(_BaseStore3.default);

var storeInstance = new BannerStore({ storageKey: 'banner' });

exports.default = storeInstance;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _ConsentsForm = __webpack_require__(354);

var _ConsentsForm2 = _interopRequireDefault(_ConsentsForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    form: new _ConsentsForm2.default(),
    response: {},
    template: {},
    isLoading: false
});

var ConsentsStore = function (_BaseStore) {
    (0, _inherits3.default)(ConsentsStore, _BaseStore);

    function ConsentsStore() {
        (0, _classCallCheck3.default)(this, ConsentsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    ConsentsStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            var form = serialized.form,
                response = serialized.response,
                template = serialized.template;

            return new State({
                form: form instanceof _ConsentsForm2.default ? form : new _ConsentsForm2.default(form || {}),
                response: response || {},
                template: template || {}
            });
        }
        return new State();
    };

    ConsentsStore.prototype.getInitialState = function getInitialState() {
        return new State();
    };

    ConsentsStore.prototype.handleConsentsLoaded = function handleConsentsLoaded(_ref) {
        var consents = _ref.consents;

        this.setState(this.state.set('response', consents));
    };

    ConsentsStore.prototype.handleTemplateLoaded = function handleTemplateLoaded(_ref2) {
        var consents = _ref2.consents;

        this.setState(this.state.set('template', consents));
    };

    ConsentsStore.prototype.setConsentsForm = function setConsentsForm(_ref3) {
        var payload = _ref3.payload;

        this.setState(this.state.set('form', this.state.form.merge(payload)));
    };

    ConsentsStore.prototype.handleGetTemplateStarted = function handleGetTemplateStarted() {
        this.setState(this.state.set('form', this.state.form.merge(_ConsentsForm.defaultConsents)).set('isLoading', true));
    };

    ConsentsStore.prototype.setIsLoading = function setIsLoading(value) {
        return function () {
            this.setState(this.state.set('isLoading', value));
        };
    };

    ConsentsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref4;

        return _ref4 = {}, _ref4[_AppConstants.ActionTypes.GET_USER_CONSENTS_SUCCESS] = this.handleConsentsLoaded, _ref4[_AppConstants.ActionTypes.GET_CONSENTS_TEMPLATE_SUCCESS] = this.handleTemplateLoaded, _ref4[_AppConstants.ActionTypes.SET_CONSENTS_FORM] = this.setConsentsForm, _ref4[_AppConstants.ActionTypes.GET_CONSENTS_TEMPLATE_STARTED] = this.handleGetTemplateStarted, _ref4[_AppConstants.ActionTypes.GET_USER_CONSENTS_STARTED] = this.setIsLoading(true), _ref4[_AppConstants.ActionTypes.GET_CONSENTS_TEMPLATE_FINISHED] = this.setIsLoading(false), _ref4[_AppConstants.ActionTypes.GET_USER_CONSENTS_FINISHED] = this.setIsLoading(false), _ref4;
    };

    (0, _createClass3.default)(ConsentsStore, [{
        key: 'form',
        get: function get() {
            return this.state.form;
        }
    }]);
    return ConsentsStore;
}(_BaseStore3.default);

var instance = new ConsentsStore({ storageKey: 'consents' });

exports.default = instance;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DisruptionAlertsAlreadyMutedError = exports.DisruptionAlertsMuteTokenExpiredError = exports.DisruptionAlertsSecurityCheckFailureError = exports.DisruptionAlertsLimitExceededError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError5 = __webpack_require__(91);

var _ExtendableError6 = _interopRequireDefault(_ExtendableError5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisruptionAlertsLimitExceededError = exports.DisruptionAlertsLimitExceededError = function (_ExtendableError) {
  (0, _inherits3.default)(DisruptionAlertsLimitExceededError, _ExtendableError);

  function DisruptionAlertsLimitExceededError() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DisruptionAlertsLimitExceededError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'DisruptionAlertsLimitExceededError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return DisruptionAlertsLimitExceededError;
}(_ExtendableError6.default);

var DisruptionAlertsSecurityCheckFailureError = exports.DisruptionAlertsSecurityCheckFailureError = function (_ExtendableError2) {
  (0, _inherits3.default)(DisruptionAlertsSecurityCheckFailureError, _ExtendableError2);

  function DisruptionAlertsSecurityCheckFailureError() {
    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, DisruptionAlertsSecurityCheckFailureError);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError2.call.apply(_ExtendableError2, [this].concat(args))), _this2), _this2.name = 'DisruptionAlertsSecurityCheckFailureError', _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  return DisruptionAlertsSecurityCheckFailureError;
}(_ExtendableError6.default);

var DisruptionAlertsMuteTokenExpiredError = exports.DisruptionAlertsMuteTokenExpiredError = function (_ExtendableError3) {
  (0, _inherits3.default)(DisruptionAlertsMuteTokenExpiredError, _ExtendableError3);

  function DisruptionAlertsMuteTokenExpiredError() {
    var _temp3, _this3, _ret3;

    (0, _classCallCheck3.default)(this, DisruptionAlertsMuteTokenExpiredError);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError3.call.apply(_ExtendableError3, [this].concat(args))), _this3), _this3.name = 'DisruptionAlertsMuteTokenExpiredError', _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
  }

  return DisruptionAlertsMuteTokenExpiredError;
}(_ExtendableError6.default);

var DisruptionAlertsAlreadyMutedError = exports.DisruptionAlertsAlreadyMutedError = function (_ExtendableError4) {
  (0, _inherits3.default)(DisruptionAlertsAlreadyMutedError, _ExtendableError4);

  function DisruptionAlertsAlreadyMutedError() {
    var _temp4, _this4, _ret4;

    (0, _classCallCheck3.default)(this, DisruptionAlertsAlreadyMutedError);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this4 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError4.call.apply(_ExtendableError4, [this].concat(args))), _this4), _this4.name = 'DisruptionAlertsAlreadyMutedError', _temp4), (0, _possibleConstructorReturn3.default)(_this4, _ret4);
  }

  return DisruptionAlertsAlreadyMutedError;
}(_ExtendableError6.default);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: _propTypes.default.string,
  srOnly: _propTypes.default.bool
};
var defaultProps = {
  srOnly: false
};
var contextTypes = {
  $bs_formGroup: _propTypes.default.object
};

var ControlLabel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ControlLabel, _React$Component);

  function ControlLabel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ControlLabel.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;
    var _this$props = this.props,
        _this$props$htmlFor = _this$props.htmlFor,
        htmlFor = _this$props$htmlFor === void 0 ? controlId : _this$props$htmlFor,
        srOnly = _this$props.srOnly,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["htmlFor", "srOnly", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? (0, _warning.default)(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      'sr-only': srOnly
    });
    return _react.default.createElement("label", (0, _extends2.default)({}, elementProps, {
      htmlFor: htmlFor,
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return ControlLabel;
}(_react.default.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _immutable = __webpack_require__(5);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _ConsentsService = __webpack_require__(1995);

var _ConsentsService2 = _interopRequireDefault(_ConsentsService);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _CustomerService = __webpack_require__(280);

var _CustomerService2 = _interopRequireDefault(_CustomerService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConsentsActions = {
    getConsentsTemplate: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var consents;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_CONSENTS_TEMPLATE_STARTED
                                });
                            });
                            _context.prev = 1;
                            _context.next = 4;
                            return _ConsentsService2.default.getConsentsTemplate();

                        case 4:
                            consents = _context.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_CONSENTS_TEMPLATE_SUCCESS,
                                    consents: consents
                                });
                            });
                            return _context.abrupt('return', consents);

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_CONSENTS_TEMPLATE_FAILED,
                                    error: _context.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'preference-centre.get-consents.error' });
                            return _context.abrupt('return', null);

                        case 14:
                            _context.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_CONSENTS_TEMPLATE_FINISHED
                                });
                            });
                            return _context.finish(14);

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 9, 14, 17]]);
        }));

        function getConsentsTemplate() {
            return _ref.apply(this, arguments);
        }

        return getConsentsTemplate;
    }(),
    getConsents: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var consents;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_USER_CONSENTS_STARTED
                                });
                            });
                            _context2.prev = 1;
                            _context2.next = 4;
                            return _ConsentsService2.default.getConsents();

                        case 4:
                            consents = _context2.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_USER_CONSENTS_SUCCESS,
                                    consents: consents
                                });
                            });
                            return _context2.abrupt('return', consents);

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_USER_CONSENTS_FAILED,
                                    error: _context2.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'preference-centre.get-consents.error' });
                            return _context2.abrupt('return', null);

                        case 14:
                            _context2.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_USER_CONSENTS_FINISHED
                                });
                            });
                            return _context2.finish(14);

                        case 17:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 9, 14, 17]]);
        }));

        function getConsents() {
            return _ref2.apply(this, arguments);
        }

        return getConsents;
    }(),
    updateConsents: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(payload, user) {
            var consents;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_USER_CONSENTS_STARTED
                                });
                            });
                            _context3.prev = 1;
                            _context3.next = 4;
                            return _ConsentsService2.default.updateConsents(payload);

                        case 4:
                            consents = _context3.sent;
                            _context3.next = 7;
                            return _CustomerService2.default.patchPreferences(user.id, (0, _immutable.fromJS)({}));

                        case 7:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_USER_CONSENTS_SUCCESS,
                                    consents: consents
                                });
                            });
                            return _context3.abrupt('return', consents);

                        case 11:
                            _context3.prev = 11;
                            _context3.t0 = _context3['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_USER_CONSENTS_FAILED,
                                    error: _context3.t0
                                });
                            });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: 'preference-centre.update-consents.error' });
                            return _context3.abrupt('return', null);

                        case 16:
                            _context3.prev = 16;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.UPDATE_USER_CONSENTS_FINISHED
                                });
                            });
                            return _context3.finish(16);

                        case 19:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[1, 11, 16, 19]]);
        }));

        function updateConsents(_x, _x2) {
            return _ref3.apply(this, arguments);
        }

        return updateConsents;
    }(),
    updateConsentsAndUser: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref4) {
            var form = _ref4.form,
                user = _ref4.user;
            var userChanges;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return this.updateConsents(form.normalizeSaveConsents(), user);

                        case 2:
                            userChanges = {};

                            if (form.get(_AppConstants.CONSENTS.SMS_Marketing) && form.get(_AppConstants.CONSENTS.PHONE) && form.get(_AppConstants.CONSENTS.PHONE) !== (user && user.telephoneNumber)) {
                                userChanges.telephoneNumber = form.get(_AppConstants.CONSENTS.PHONE);
                            }
                            if (form.get(_AppConstants.CONSENTS.OVER_16) !== user.isOver16) {
                                userChanges.isOver16 = form.get(_AppConstants.CONSENTS.OVER_16);
                            }

                            if ((0, _isEmpty3.default)(userChanges)) {
                                _context4.next = 8;
                                break;
                            }

                            _context4.next = 8;
                            return _CustomerActions2.default.updateAuthenticatedProperties({
                                user: user,
                                currentPassword: null,
                                changes: userChanges,
                                requireAuth: false
                            });

                        case 8:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function updateConsentsAndUser(_x3) {
            return _ref5.apply(this, arguments);
        }

        return updateConsentsAndUser;
    }(),
    setConsentsForm: function setConsentsForm(payload) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SET_CONSENTS_FORM,
                payload: payload
            });
        });
    }
};

exports.default = ConsentsActions;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    accountNumber: "",
    amazonCustomerId: null,
    amazonEmail: "",
    charity: null,
    method: null,
    paypalEmail: "",
    sortCode: ""
};

var ADRPaymentMethodsForm = function (_record) {
    (0, _inherits3.default)(ADRPaymentMethodsForm, _record);

    function ADRPaymentMethodsForm() {
        (0, _classCallCheck3.default)(this, ADRPaymentMethodsForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ADRPaymentMethodsForm.prototype.getSchema = function getSchema() {
        return {
            sortCode: _joi2.default.any().when('method', {
                is: 'bacs',
                then: _joi2.default.string().trim().min(6).max(6).required().options({
                    language: {
                        string: {
                            base: (0, _I18n.translate)('alertmessage.required'),
                            min: (0, _I18n.translate)('one-click-delay-repay.paymentMethods.sortCode.length'),
                            max: (0, _I18n.translate)('one-click-delay-repay.paymentMethods.sortCode.length')
                        }
                    }
                }), otherwise: _joi2.default.optional()
            }),
            accountNumber: _joi2.default.any().when('method', {
                is: 'bacs',
                then: _joi2.default.string().trim().min(8).max(8).required().options({
                    language: {
                        string: {
                            base: (0, _I18n.translate)('alertmessage.required'),
                            min: (0, _I18n.translate)('one-click-delay-repay.paymentMethods.accountNumber.length'),
                            max: (0, _I18n.translate)('one-click-delay-repay.paymentMethods.accountNumber.length')
                        }
                    }
                }), otherwise: _joi2.default.optional()
            }),
            paypalEmail: _joi2.default.any().when('method', {
                is: 'paypal',
                then: _validation2.default.email().options({
                    language: {
                        string: {
                            base: (0, _I18n.translate)('alertmessage.login.badEmail'),
                            email: (0, _I18n.translate)('alertmessage.login.badEmail')
                        }
                    }
                }), otherwise: _joi2.default.optional()
            })
        };
    };

    return ADRPaymentMethodsForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(ADRPaymentMethodsForm.prototype, _ValidationMixin2.default);

exports.default = ADRPaymentMethodsForm;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengerInfo = function PassengerInfo(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        ticket = _ref.ticket,
        hideISRN = _ref.hideISRN;

    if (!ticket || !ticket.passenger || !ticket.passenger.get('name') || !ticket.passenger.get('smartcardNumber')) {
        return null;
    }

    var isChild = ticket && ticket.children > 0;

    return _react2.default.createElement(
        'span',
        { className: className },
        _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                'strong',
                null,
                ticket.passenger.get('name')
            ),
            isChild && _react2.default.createElement(
                'span',
                { className: 'associated-smartcards__child-badge' },
                ' ' + (0, _I18n2.default)('global.child') + ' '
            )
        ),
        !hideISRN && _react2.default.createElement(
            'span',
            null,
            '\xA0',
            ticket.passenger.get('smartcardNumber')
        )
    );
};

PassengerInfo.propTypes = {
    ticket: _propTypes2.default.object,
    className: _propTypes2.default.string,
    hideISRN: _propTypes2.default.bool
};

exports.default = PassengerInfo;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var document = __webpack_require__(36).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(130);
var LIBRARY = __webpack_require__(179);
var wksExt = __webpack_require__(689);
var defineProperty = __webpack_require__(71).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(292)('keys');
var uid = __webpack_require__(206);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 468 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(36).document;
module.exports = document && document.documentElement;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(48);
var anObject = __webpack_require__(31);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(131)(Function.call, __webpack_require__(122).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var setPrototypeOf = __webpack_require__(470).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(133);
var defined = __webpack_require__(149);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 474 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 475 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(179);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(112);
var hide = __webpack_require__(111);
var Iterators = __webpack_require__(245);
var $iterCreate = __webpack_require__(477);
var setToStringTag = __webpack_require__(242);
var getPrototypeOf = __webpack_require__(123);
var ITERATOR = __webpack_require__(56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(209);
var descriptor = __webpack_require__(205);
var setToStringTag = __webpack_require__(242);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(111)(IteratorPrototype, __webpack_require__(56)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(360);
var defined = __webpack_require__(149);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(56)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(245);
var ITERATOR = __webpack_require__(56)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(71);
var createDesc = __webpack_require__(205);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(243);
var ITERATOR = __webpack_require__(56)('iterator');
var Iterators = __webpack_require__(245);
module.exports = __webpack_require__(130).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1274);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(73);
var toAbsoluteIndex = __webpack_require__(208);
var toLength = __webpack_require__(63);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(181);
var step = __webpack_require__(706);
var Iterators = __webpack_require__(245);
var toIObject = __webpack_require__(121);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(476)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(295);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(359)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(131);
var invoke = __webpack_require__(696);
var html = __webpack_require__(469);
var cel = __webpack_require__(465);
var global = __webpack_require__(36);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(132)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var macrotask = __webpack_require__(488).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(132)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(93);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(36);
var DESCRIPTORS = __webpack_require__(66);
var LIBRARY = __webpack_require__(179);
var $typed = __webpack_require__(366);
var hide = __webpack_require__(111);
var redefineAll = __webpack_require__(214);
var fails = __webpack_require__(40);
var anInstance = __webpack_require__(212);
var toInteger = __webpack_require__(133);
var toLength = __webpack_require__(63);
var toIndex = __webpack_require__(716);
var gOPN = __webpack_require__(210).f;
var dP = __webpack_require__(71).f;
var arrayFill = __webpack_require__(484);
var setToStringTag = __webpack_require__(242);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(297);
var $export = __webpack_require__(69);
var redefine = __webpack_require__(496);
var hide = __webpack_require__(182);
var Iterators = __webpack_require__(247);
var $iterCreate = __webpack_require__(1386);
var setToStringTag = __webpack_require__(301);
var getPrototypeOf = __webpack_require__(727);
var ITERATOR = __webpack_require__(94)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(103);
var document = __webpack_require__(82).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(103);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(182);


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(300);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(499)('keys');
var uid = __webpack_require__(373);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(49);
var global = __webpack_require__(82);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(297) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 500 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(374);
var ITERATOR = __webpack_require__(94)('iterator');
var Iterators = __webpack_require__(247);
module.exports = __webpack_require__(49).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(298);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 503 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(82);
var core = __webpack_require__(49);
var LIBRARY = __webpack_require__(297);
var wksExt = __webpack_require__(378);
var defineProperty = __webpack_require__(135).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(302);
var createDesc = __webpack_require__(299);
var toIObject = __webpack_require__(185);
var toPrimitive = __webpack_require__(495);
var has = __webpack_require__(184);
var IE8_DOM_DEFINE = __webpack_require__(724);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(124) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 507 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(87);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1447),
    mapCacheDelete = __webpack_require__(1454),
    mapCacheGet = __webpack_require__(1456),
    mapCacheHas = __webpack_require__(1457),
    mapCacheSet = __webpack_require__(1458);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1459),
    isObjectLike = __webpack_require__(104);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(755),
    stubArray = __webpack_require__(756);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(68),
    isSymbol = __webpack_require__(308);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1475),
    shortOut = __webpack_require__(766);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(310),
    baseLodash = __webpack_require__(517);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 517 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(312);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(116);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(254);
var defaultToWhiteSpace = __webpack_require__(781);
var nativeTrim = String.prototype.trim;

module.exports = function trim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrim) return nativeTrim.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(387),
    baseEach = __webpack_require__(237),
    castFunction = __webpack_require__(520),
    isArray = __webpack_require__(68);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    getPrototype = __webpack_require__(391),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var urlRoot = '/customers';
var urlV2Root = '/v2/customers';

var URL = exports.URL = {
    create: urlRoot,
    createAmazon: urlRoot + '/amazon',
    customer: urlRoot + '/{id}',
    auth: urlRoot + '/auth',
    refresh: urlRoot + '/auth/refresh',
    reset: urlRoot + '/reset-password',
    activateSmartcard: urlRoot + '/{id}/smartcard/activate',
    findSeasonTickets: urlRoot + '/{id}/ticket-search',
    identityProvider: urlRoot + '/auth/{provider}/{id}',
    transferSeasonTicket: urlRoot + '/{id}/product-swap',
    preferences: urlRoot + '/{id}/preferences',
    postCodeLookUp: urlRoot + '/address/postcode-lookup',
    setPasswordAndPreferences: urlRoot + '/set-password-and-preferences',
    validateBacs: urlRoot + '/validation/bacs-lookup',
    checkEmail: urlRoot + '/email',
    deleteCustomer: urlRoot + '/{id}/deactivate',
    cancelDeletionRequest: urlRoot + '/{id}/deactivate/{requestId}/cancel',
    consentsTemplate: urlV2Root + '/dataguard/consents/template',
    consents: urlV2Root + '/{id}/dataguard/consents'
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(164);
var IObject = __webpack_require__(497);
var toObject = __webpack_require__(217);
var toLength = __webpack_require__(372);
var asc = __webpack_require__(1529);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(82);
var $export = __webpack_require__(69);
var meta = __webpack_require__(303);
var fails = __webpack_require__(183);
var hide = __webpack_require__(182);
var redefineAll = __webpack_require__(376);
var forOf = __webpack_require__(249);
var anInstance = __webpack_require__(375);
var isObject = __webpack_require__(103);
var setToStringTag = __webpack_require__(301);
var dP = __webpack_require__(135).f;
var each = __webpack_require__(525)(0);
var DESCRIPTORS = __webpack_require__(124);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(69);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(69);
var aFunction = __webpack_require__(298);
var ctx = __webpack_require__(164);
var forOf = __webpack_require__(249);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 529 */
/***/ (function(module, exports) {



/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _isNan = __webpack_require__(454);

var _isNan2 = _interopRequireDefault(_isNan);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _symbol = __webpack_require__(286);

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hoek = __webpack_require__(96);
var Language = __webpack_require__(1570);

// Declare internals

var internals = {
    annotations: (0, _symbol2.default)('joi-annotations')
};

internals.stringify = function (value, wrapArrays) {

    var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);

    if (value === null) {
        return 'null';
    }

    if (type === 'string') {
        return value;
    }

    if (value instanceof exports.Err || type === 'function') {
        return value.toString();
    }

    if (type === 'object') {
        if (Array.isArray(value)) {
            var partial = '';

            for (var i = 0; i < value.length; ++i) {
                partial = partial + (partial.length ? ', ' : '') + internals.stringify(value[i], wrapArrays);
            }

            return wrapArrays ? '[' + partial + ']' : partial;
        }

        return value.toString();
    }

    return (0, _stringify2.default)(value);
};

exports.Err = function () {
    function _class(type, context, state, options, flags, message, template) {
        (0, _classCallCheck3.default)(this, _class);


        this.isJoi = true;
        this.type = type;
        this.context = context || {};
        this.context.key = state.key;
        this.path = state.path;
        this.options = options;
        this.flags = flags;
        this.message = message;
        this.template = template;
    }

    _class.prototype.toString = function toString() {
        var _this = this;

        if (this.message) {
            return this.message;
        }

        var format = void 0;

        if (this.template) {
            format = this.template;
        }

        var localized = this.options.language;

        if (this.flags.label) {
            this.context.key = this.flags.label;
        } else if (this.context.key === '' || this.context.key === null) {
            this.context.key = localized.root || Language.errors.root;
        }

        format = format || Hoek.reach(localized, this.type) || Hoek.reach(Language.errors, this.type);

        var wrapArrays = Hoek.reach(localized, 'messages.wrapArrays');
        if (typeof wrapArrays !== 'boolean') {
            wrapArrays = Language.errors.messages.wrapArrays;
        }

        if (format === null) {
            var childrenString = internals.stringify(this.context.reason, wrapArrays);
            if (wrapArrays) {
                return childrenString.slice(1, -1);
            }
            return childrenString;
        }

        var hasKey = /\{\{\!?key\}\}/.test(format);
        var skipKey = format.length > 2 && format[0] === '!' && format[1] === '!';

        if (skipKey) {
            format = format.slice(2);
        }

        if (!hasKey && !skipKey) {
            format = (Hoek.reach(localized, 'key') || Hoek.reach(Language.errors, 'key')) + format;
        }

        return format.replace(/\{\{(\!?)([^}]+)\}\}/g, function ($0, isSecure, name) {

            var value = Hoek.reach(_this.context, name);
            var normalized = internals.stringify(value, wrapArrays);
            return isSecure ? Hoek.escapeHtml(normalized) : normalized;
        });
    };

    return _class;
}();

exports.create = function (type, context, state, options, flags, message, template) {

    return new exports.Err(type, context, state, options, flags, message, template);
};

exports.process = function (errors, object) {

    if (!errors || !errors.length) {
        return null;
    }

    // Construct error

    var message = '';
    var details = [];

    var processErrors = function processErrors(localErrors, parent) {

        for (var i = 0; i < localErrors.length; ++i) {
            var item = localErrors[i];

            if (item instanceof Error) {
                return item;
            }

            if (item.flags.error && typeof item.flags.error !== 'function') {
                return item.flags.error;
            }

            var itemMessage = void 0;
            if (parent === undefined) {
                itemMessage = item.toString();
                message = message + (message ? '. ' : '') + itemMessage;
            }

            // Do not push intermediate errors, we're only interested in leafs

            if (item.context.reason && item.context.reason.length) {
                var _override = processErrors(item.context.reason, item.path);
                if (_override) {
                    return _override;
                }
            } else {
                details.push({
                    message: itemMessage || item.toString(),
                    path: internals.getPath(item),
                    type: item.type,
                    context: item.context
                });
            }
        }
    };

    var override = processErrors(errors);
    if (override) {
        return override;
    }

    var error = new Error(message);
    error.isJoi = true;
    error.name = 'ValidationError';
    error.details = details;
    error._object = object;
    error.annotate = internals.annotate;
    return error;
};

internals.getPath = function (item) {

    return item.path || item.context.key;
};

// Inspired by json-stringify-safe
internals.safeStringify = function (obj, spaces) {

    return (0, _stringify2.default)(obj, internals.serializer(), spaces);
};

internals.serializer = function () {

    var keys = [];
    var stack = [];

    var cycleReplacer = function cycleReplacer(key, value) {

        if (stack[0] === value) {
            return '[Circular ~]';
        }

        return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
    };

    return function (key, value) {

        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            if (~thisPos) {
                stack.length = thisPos + 1;
                keys.length = thisPos + 1;
                keys[thisPos] = key;
            } else {
                stack.push(this);
                keys.push(key);
            }

            if (~stack.indexOf(value)) {
                value = cycleReplacer.call(this, key, value);
            }
        } else {
            stack.push(value);
        }

        if (value) {
            var annotations = value[internals.annotations];
            if (annotations) {
                if (Array.isArray(value)) {
                    var annotated = [];

                    for (var i = 0; i < value.length; ++i) {
                        if (annotations.errors[i]) {
                            annotated.push('_$idx$_' + annotations.errors[i].sort().join(', ') + '_$end$_');
                        }
                        annotated.push(value[i]);
                    }

                    value = annotated;
                } else {
                    var errorKeys = (0, _keys2.default)(annotations.errors);
                    for (var _i = 0; _i < errorKeys.length; ++_i) {
                        var errorKey = errorKeys[_i];
                        value[errorKey + '_$key$_' + annotations.errors[errorKey].sort().join(', ') + '_$end$_'] = value[errorKey];
                        value[errorKey] = undefined;
                    }

                    var missingKeys = (0, _keys2.default)(annotations.missing);
                    for (var _i2 = 0; _i2 < missingKeys.length; ++_i2) {
                        var missingKey = missingKeys[_i2];
                        value['_$miss$_' + missingKey + '|' + annotations.missing[missingKey] + '_$end$_'] = '__missing__';
                    }
                }

                return value;
            }
        }

        if (value === Infinity || value === -Infinity || (0, _isNan2.default)(value) || typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'symbol') {
            return '[' + value.toString() + ']';
        }

        return value;
    };
};

internals.annotate = function (stripColorCodes) {

    var redFgEscape = stripColorCodes ? '' : '\x1B[31m';
    var redBgEscape = stripColorCodes ? '' : '\x1B[41m';
    var endColor = stripColorCodes ? '' : '\x1B[0m';

    if ((0, _typeof3.default)(this._object) !== 'object') {
        return this.details[0].message;
    }

    var obj = Hoek.clone(this._object || {});

    for (var i = this.details.length - 1; i >= 0; --i) {
        // Reverse order to process deepest child first
        var pos = i + 1;
        var error = this.details[i];
        var path = error.path.split('.');
        var ref = obj;
        for (var j = 0;; ++j) {
            var seg = path[j];

            if (ref.isImmutable) {
                ref = ref.clone(); // joi schemas are not cloned by hoek, we have to take this extra step
            }

            if (j + 1 < path.length && ref[seg] && typeof ref[seg] !== 'string') {

                ref = ref[seg];
            } else {
                var refAnnotations = ref[internals.annotations] = ref[internals.annotations] || { errors: {}, missing: {} };
                var value = ref[seg];

                if (value !== undefined) {
                    refAnnotations.errors[seg] = refAnnotations.errors[seg] || [];
                    refAnnotations.errors[seg].push(pos);
                } else {
                    refAnnotations.missing[seg] = pos;
                }

                break;
            }
        }
    }

    var replacers = {
        key: /_\$key\$_([, \d]+)_\$end\$_\"/g,
        missing: /\"_\$miss\$_([^\|]+)\|(\d+)_\$end\$_\"\: \"__missing__\"/g,
        arrayIndex: /\s*\"_\$idx\$_([, \d]+)_\$end\$_\",?\n(.*)/g,
        specials: /"\[(NaN|Symbol.*|-?Infinity|function.*|\(.*)\]"/g
    };

    var message = internals.safeStringify(obj, 2).replace(replacers.key, function ($0, $1) {
        return '" ' + redFgEscape + '[' + $1 + ']' + endColor;
    }).replace(replacers.missing, function ($0, $1, $2) {
        return redBgEscape + '"' + $1 + '"' + endColor + redFgEscape + ' [' + $2 + ']: -- missing --' + endColor;
    }).replace(replacers.arrayIndex, function ($0, $1, $2) {
        return '\n' + $2 + ' ' + redFgEscape + '[' + $1 + ']' + endColor;
    }).replace(replacers.specials, function ($0, $1) {
        return $1;
    });

    message = message + '\n' + redFgEscape;

    for (var _i3 = 0; _i3 < this.details.length; ++_i3) {
        var _pos = _i3 + 1;
        message = message + '\n[' + _pos + '] ' + this.details[_i3].message;
    }

    message = message + endColor;

    return message;
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Any = __webpack_require__(137);
var Ref = __webpack_require__(153);
var Hoek = __webpack_require__(96);

// Declare internals

var internals = {};

internals.isoDate = /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/;
internals.invalidDate = new Date('');
internals.isIsoDate = function () {

    var isoString = internals.isoDate.toString();

    return function (date) {

        return date && date.toString() === isoString;
    };
}();

internals.Date = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'date';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: options.convert && internals.Date.toDate(value, this._flags.format, this._flags.timestamp, this._flags.multiplier) || value
        };

        if (result.value instanceof Date && !isNaN(result.value.getTime())) {
            result.errors = null;
        } else if (!options.convert) {
            result.errors = this.createError('date.strict', null, state, options);
        } else {
            var type = void 0;
            if (internals.isIsoDate(this._flags.format)) {
                type = 'isoDate';
            } else if (this._flags.timestamp) {
                type = 'timestamp.' + this._flags.timestamp;
            } else {
                type = 'base';
            }

            result.errors = this.createError('date.' + type, null, state, options);
        }

        return result;
    };

    _class.toDate = function toDate(value, format, timestamp, multiplier) {

        if (value instanceof Date) {
            return value;
        }

        if (typeof value === 'string' || typeof value === 'number' && !isNaN(value) && isFinite(value)) {

            if (typeof value === 'string' && /^[+-]?\d+(\.\d+)?$/.test(value)) {

                value = parseFloat(value);
            }

            var date = void 0;
            if (format && internals.isIsoDate(format)) {
                date = format.test(value) ? new Date(value) : internals.invalidDate;
            } else if (timestamp && multiplier) {
                date = new Date(value * multiplier);
            } else {
                date = new Date(value);
            }

            if (!isNaN(date.getTime())) {
                return date;
            }
        }

        return null;
    };

    _class.prototype.iso = function iso() {

        if (this._flags.format === internals.isoDate) {
            return this;
        }

        var obj = this.clone();
        obj._flags.format = internals.isoDate;
        return obj;
    };

    _class.prototype.timestamp = function timestamp(type) {

        type = type || 'javascript';

        var allowed = ['javascript', 'unix'];
        Hoek.assert(allowed.indexOf(type) !== -1, '"type" must be one of "' + allowed.join('", "') + '"');

        if (this._flags.timestamp === type) {
            return this;
        }

        var obj = this.clone();
        obj._flags.timestamp = type;
        obj._flags.multiplier = type === 'unix' ? 1000 : 1;
        return obj;
    };

    _class.prototype._isIsoDate = function _isIsoDate(value) {

        return internals.isoDate.test(value);
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (date) {

        var isNow = date === 'now';
        var isRef = Ref.isRef(date);

        if (!isNow && !isRef) {
            date = internals.Date.toDate(date);
        }

        Hoek.assert(date, 'Invalid date format');

        return this._test(type, date, function (value, state, options) {

            var compareTo = void 0;
            if (isNow) {
                compareTo = Date.now();
            } else if (isRef) {
                compareTo = internals.Date.toDate(date(state.reference || state.parent, options));

                if (!compareTo) {
                    return this.createError('date.ref', { ref: date.key }, state, options);
                }

                compareTo = compareTo.getTime();
            } else {
                compareTo = date.getTime();
            }

            if (compare(value.getTime(), compareTo)) {
                return value;
            }

            return this.createError('date.' + type, { limit: new Date(compareTo) }, state, options);
        });
    };
};
internals.Date.prototype.min = internals.compare('min', function (value, date) {
    return value >= date;
});
internals.Date.prototype.max = internals.compare('max', function (value, date) {
    return value <= date;
});

module.exports = new internals.Date();

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hoek = __webpack_require__(96);
var Any = __webpack_require__(137);
var Cast = __webpack_require__(318);
var Ref = __webpack_require__(153);

// Declare internals

var internals = {};

internals.Alternatives = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'alternatives';
        _this._invalids.remove(null);
        _this._inner.matches = [];
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var errors = [];
        var il = this._inner.matches.length;
        var baseType = this._baseType;

        for (var i = 0; i < il; ++i) {
            var item = this._inner.matches[i];
            var schema = item.schema;
            if (!schema) {
                var failed = item.is._validate(item.ref(state.reference || state.parent, options), null, options, state.parent).errors;

                if (failed) {
                    if (item.otherwise) {
                        return item.otherwise._validate(value, state, options);
                    }
                } else if (item.then) {
                    return item.then._validate(value, state, options);
                }

                if (i === il - 1 && baseType) {
                    return baseType._validate(value, state, options);
                }

                continue;
            }

            var result = schema._validate(value, state, options);
            if (!result.errors) {
                // Found a valid match
                return result;
            }

            errors = errors.concat(result.errors);
        }

        if (errors.length) {
            return { errors: this.createError('alternatives.child', { reason: errors }, state, options) };
        }

        return { errors: this.createError('alternatives.base', null, state, options) };
    };

    _class.prototype.try = function _try() /* schemas */{

        var schemas = Hoek.flatten(Array.prototype.slice.call(arguments));
        Hoek.assert(schemas.length, 'Cannot add other alternatives without at least one schema');

        var obj = this.clone();

        for (var i = 0; i < schemas.length; ++i) {
            var cast = Cast.schema(schemas[i]);
            if (cast._refs.length) {
                obj._refs = obj._refs.concat(cast._refs);
            }
            obj._inner.matches.push({ schema: cast });
        }

        return obj;
    };

    _class.prototype.when = function when(ref, options) {

        Hoek.assert(Ref.isRef(ref) || typeof ref === 'string', 'Invalid reference:', ref);
        Hoek.assert(options, 'Missing options');
        Hoek.assert((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object', 'Invalid options');
        Hoek.assert(options.hasOwnProperty('is'), 'Missing "is" directive');
        Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');

        var obj = this.clone();
        var is = Cast.schema(options.is);

        if (options.is === null || !(Ref.isRef(options.is) || options.is instanceof Any)) {

            // Only apply required if this wasn't already a schema or a ref, we'll suppose people know what they're doing
            is = is.required();
        }

        var item = {
            ref: Cast.ref(ref),
            is: is,
            then: options.then !== undefined ? Cast.schema(options.then) : undefined,
            otherwise: options.otherwise !== undefined ? Cast.schema(options.otherwise) : undefined
        };

        if (obj._baseType) {

            item.then = item.then && obj._baseType.concat(item.then);
            item.otherwise = item.otherwise && obj._baseType.concat(item.otherwise);
        }

        Ref.push(obj._refs, item.ref);
        obj._refs = obj._refs.concat(item.is._refs);

        if (item.then && item.then._refs) {
            obj._refs = obj._refs.concat(item.then._refs);
        }

        if (item.otherwise && item.otherwise._refs) {
            obj._refs = obj._refs.concat(item.otherwise._refs);
        }

        obj._inner.matches.push(item);

        return obj;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);
        var alternatives = [];
        for (var i = 0; i < this._inner.matches.length; ++i) {
            var item = this._inner.matches[i];
            if (item.schema) {

                // try()

                alternatives.push(item.schema.describe());
            } else {

                // when()

                var when = {
                    ref: item.ref.toString(),
                    is: item.is.describe()
                };

                if (item.then) {
                    when.then = item.then.describe();
                }

                if (item.otherwise) {
                    when.otherwise = item.otherwise.describe();
                }

                alternatives.push(when);
            }
        }

        description.alternatives = alternatives;
        return description;
    };

    return _class;
}(Any);

module.exports = new internals.Alternatives();

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for Gatwick Express
 */

module.exports = new _immutable.Map({
    'app.owner': 'Gatwick Express',
    'app.owner.toc': 'GX',
    'app.owner.short': 'Gatwick Express',
    'delayrepay.text.successConfirmation': 'Thank you for submitting your delay repay claim. An acknowledgement will be sent within the next few days.',
    'delayrepay.intro.text': 'If your journey started / finished beyond Gatwick Airport please use the Southern Delay Repay <a href="http://www.southernrailway.com/your-journey/customer-services/delay-repay/">form</a>\n                              Delay Repay is a national compensation scheme that most train operating companies use to compensate customers for delays. You can claim compensation if your journey is delayed by 15 minutes or more (except when delays are caused by planned engineering work).',

    'delivery.1st-class-mail.detail': '<p>Tickets purchased by 16:00 will be processed and dispatched within 24 hours of booking using Royal Mail First Class post. Please allow five working days for delivery.</p><p>Please note we are unable to guarantee delivery of any unsigned for first class post, and would suggest using a ticket machine at the station as it\u2019s quicker, easier and free of charge.</p><p>Applicable to UK addresses only.</p><p>Don\u2019t forget you can get your tickets for free if have them fulfilled via eTicket purchase or collect from a ticket vending machine at a station. </p>',
    'delivery.royal-mail-signed-for-1st-class.detail': '<p>We now offer this service free for bookings over \xA3100.</p><p>For bookings less than \xA3100 you can select this delivery option for a cost of \xA32.50, it offers:</p><ul><li>Proof of postage.</li><li>Signature on delivery.</li><li>Online confirmation of delivery.</li></ul><p>Please note, we are unable to guarantee next day delivery, if this is a requirement then we recommend you use the Next Day Special Delivery option.</p><p>Don\u2019t forget you\n                                                        can get your tickets for free if you have them fulfilled via eTicket purchase or collect from a ticket vending machine at a station.</p>',

    'delivery.free-ticket-collection-info': 'You can get your tickets for free if you have them fulfilled via eTicket purchase or collect from a ticket vending machine at a station.',
    'delivery.e-ticket.detail': '\n        <p>eTickets are designed for use on Gatwick Express services which arrive at stations or platforms with barcode readers. Intermediate stations between London Victoria and Gatwick Airport are not equipped with barcode readers. Once your booking has been completed your ticket will be sent to you. Registered customers can download their unexpired eTickets from their My Account section. You can use a mobile device to present your ticket for inspection or to pass through a gateline.</p>\n        <p>Alternatively, you can print your ticket using plain white A4 paper.</p>\n        <p>eTickets are not accepted on London Underground services.</p>\n        {eTicketsFaqLink, select, null {} other {<p>{eTicketsFaqLink} for more information.</p>}}',
    'account.linkorder.error.message.customerservices': 'If you are still having problems, please contact Customer Services on 0345 850 1530',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.orders.refund.refundForm': '{url}',
    'confirmation.discoverMore': '<p>Find out more of our exciting <a href="{url}" target="_blank">partnership rewards</a></p>',

    'inApp.iOSUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://apps.apple.com/gb/app/gatwick-express/id1134559254">Update now</a>',
    'inApp.AndroidUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://play.google.com/store/apps/details?id=com.gatwickexpress.ontrack&hl=en">Update now</a>',

    'account.nav.disruptionAlerts': 'Disruption alerts',
    'delivery.sticket.details': '\n        <p>sTicket is a digital version of a Season ticket provided as a QR code. It is instantly available to download and accessed through the Gatwick Express app. No need to wait for an email or queue at the station.</p>\n        <p>Scan the QR code at the station ticket gate (where barcode scanners are available) or show to staff when asked.</p>\n        <p>If you\u2019re buying on behalf of another person, please do so from their account or select a different collection method.</p>\n        <p>Please note: sTickets are not accepted on London Underground services.</p>',

    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the Gatwick Express app.'
});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FeatureVariantStore = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _DataLayerStore = __webpack_require__(664);

var _DataLayerStore2 = _interopRequireDefault(_DataLayerStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function gtag() {
    var dataLayerName = _config2.default.get('gtmDataLayer');
    var enableTracking = _DataLayerStore2.default.isTrackingEnabled();

    if (window.hasOwnProperty(dataLayerName) && enableTracking) {
        window[dataLayerName].push(arguments);
    }
}

var FeatureVariantStore = exports.FeatureVariantStore = function (_BaseStore) {
    (0, _inherits3.default)(FeatureVariantStore, _BaseStore);

    function FeatureVariantStore() {
        (0, _classCallCheck3.default)(this, FeatureVariantStore);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, _BaseStore.call.apply(_BaseStore, [this].concat(args)));

        _this.waitForGO = function (callBack, fallBack) {
            var GOLoadingAttempts = 0;
            var intervalId = setInterval(function () {
                GOLoadingAttempts++;
                if (window.google_optimize !== undefined) {
                    callBack();
                    GOLoadingAttempts = 0;
                    clearInterval(intervalId);
                }
                if (GOLoadingAttempts > 4) {
                    if (typeof fallBack === 'function') {
                        fallBack();
                    }
                    GOLoadingAttempts = 0;
                    clearInterval(intervalId);
                }
            }, 100);
        };

        _this._googleOptimizeCallback = function (variantId, experimentId) {
            try {
                _this.setState(_this.state.set(_this._getFeatureName(experimentId), Number(variantId)));
            } catch (e) {
                console.error('Error updating variant: ' + experimentId + ' - "' + variantId + '"');
            }
        };

        gtag('event', 'optimize.callback', {
            callback: _this._googleOptimizeCallback
        });
        return _this;
    }

    FeatureVariantStore.prototype.has = function has(featureName) {
        return this.state.has(featureName) || _config2.default.has(featureName);
    };

    FeatureVariantStore.prototype.get = function get(featureName) {
        return this.state.get(featureName, _config2.default.get(featureName));
    };

    FeatureVariantStore.prototype.triggerEvent = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(triggerName) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!window.dataLayer) {
                                _context.next = 3;
                                break;
                            }

                            _context.next = 3;
                            return window.dataLayer.push({ event: triggerName });

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function triggerEvent(_x) {
            return _ref.apply(this, arguments);
        }

        return triggerEvent;
    }();

    FeatureVariantStore.prototype.getAll = function getAll() {
        var _this2 = this;

        var featureVariants = {};
        this.state.forEach(function (variantId, featureName) {
            var variantName = _this2._getVariantName(featureName, variantId);
            featureVariants[featureName] = { variantId: variantId, variantName: variantName };
        });
        return featureVariants;
    };

    FeatureVariantStore.prototype.isCurrentVariant = function isCurrentVariant(featureName, variant) {
        return this._getVariantId(featureName, variant) === this.get(featureName);
    };

    FeatureVariantStore.prototype._getFeatureName = function _getFeatureName(experimentId) {
        return _config2.default.get('featureExperimentIds').findKey(function (expId) {
            return expId === experimentId;
        }) || experimentId;
    };

    FeatureVariantStore.prototype._getVariantId = function _getVariantId(featureName, variantName) {
        if (typeof variantName === 'number') {
            return variantName;
        }
        var variants = _config2.default.get('featureVariants').getIn([featureName], new _immutable.List());
        return variants.indexOf(variantName);
    };

    FeatureVariantStore.prototype._getVariantName = function _getVariantName(featureName, variantId) {
        var variants = _config2.default.get('featureVariants').getIn([featureName], new _immutable.List());
        var variantName = variants.get(variantId);
        return variantName;
    };

    // set by booking-engine
    FeatureVariantStore.prototype._setFeatureVariant = function _setFeatureVariant(_ref2) {
        var feature = _ref2.feature,
            variant = _ref2.variant;

        var variantId = this._getVariantId(variant);
        if (variantId >= 0) {
            this.setState(this.state.set(feature, variantId));
        } else {
            console.warn('Unknown ' + feature + ' variant: ' + variant + ', setting anyway');
            this.setState(this.state.set(feature, variant));
        }
    };

    FeatureVariantStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.FEATURE_VARIANT_UPDATED] = this._setFeatureVariant, _ref3;
    };

    return FeatureVariantStore;
}(_BaseStore3.default);

exports.default = new FeatureVariantStore();

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(388),
    isArrayLike = __webpack_require__(143),
    isString = __webpack_require__(128),
    toInteger = __webpack_require__(200),
    values = __webpack_require__(92);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(754),
    getSymbolsIn = __webpack_require__(821),
    keysIn = __webpack_require__(255);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(661),
    arrayIncludes = __webpack_require__(663),
    arrayIncludesWith = __webpack_require__(1122),
    cacheHas = __webpack_require__(662),
    createSet = __webpack_require__(1704),
    setToArray = __webpack_require__(511);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getDepartureStationName: function getDepartureStationName() {
        return (0, _result3.default)(this.get('origin'), 'getName', null);
    },
    getArrivalStationName: function getArrivalStationName() {
        return (0, _result3.default)(this.get('destination'), 'getName', null);
    },
    getViaStationName: function getViaStationName() {
        return (0, _result3.default)(this.get('via'), 'getName', null);
    },
    getAvoidStationName: function getAvoidStationName() {
        return (0, _result3.default)(this.get('avoid'), 'getName', null);
    },
    hasViaStation: function hasViaStation() {
        return this.getViaStationName() !== null;
    },
    hasAvoidStation: function hasAvoidStation() {
        return this.getAvoidStationName() !== null;
    },
    getStationType: function getStationType(station, type) {
        // It's for group stations that don't have validity.
        // Looks like it's a temporary solution.
        if (station && !station.validity || station && station.getIn(['validity', type])) {
            return station;
        }
        return new _Station2.default();
    },
    validateStationsComplete: function validateStationsComplete() {
        return !!(this.getIn(['origin', 'nlc']) && this.getIn(['destination', 'nlc']));
    },
    validateStationsNotEqual: function validateStationsNotEqual() {
        if (this.validateStationsComplete()) {
            return this.getIn(['origin', 'nlc']) !== this.getIn(['destination', 'nlc']);
        }
        return true;
    }
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _CheapestFares = __webpack_require__(540);

var _CheapestFares2 = _interopRequireDefault(_CheapestFares);

var _Service = __webpack_require__(273);

var _Service2 = _interopRequireDefault(_Service);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    outwardService: null,
    inboundService: null,
    cheapestFares: null
};

var OverallCheapestSelection = function (_record) {
    (0, _inherits3.default)(OverallCheapestSelection, _record);

    function OverallCheapestSelection() {
        (0, _classCallCheck3.default)(this, OverallCheapestSelection);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OverallCheapestSelection.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(OverallCheapestSelection, json, {
            outwardService: _LinkMapper.resolve.as(_Service2.default),
            inboundService: _LinkMapper.resolve.as(_Service2.default),
            cheapestFares: _LinkMapper.resolve.as(_CheapestFares2.default)
        });
    };

    OverallCheapestSelection.fromServices = function fromServices(outward, inbound, trip) {
        var filter = function filter(service) {
            return !service.isDisabledForTrip(trip);
        };
        var cheapestFares = null,
            outwardService = new _Service2.default(),
            inboundService = new _Service2.default();

        outward.filter(filter).map(function (service) {
            if (!cheapestFares || service.getCheapestTotalPrice() < cheapestFares.totalPrice) {
                cheapestFares = service.fares.cheapest;
            }
        });

        inbound.filter(filter).map(function (service) {
            if (!cheapestFares || service.getCheapestTotalPrice() < cheapestFares.totalPrice) {
                cheapestFares = service.fares.cheapest.reverseSingles();
            }
        });

        if (!cheapestFares) {
            return new OverallCheapestSelection();
        }

        if (cheapestFares.outwardSingle) {
            outwardService = outward.find(function (service) {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.outwardSingle);
            });
        }

        if (cheapestFares.inboundSingle) {
            inboundService = inbound.find(function (service) {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.inboundSingle);
            });
        }

        if (cheapestFares.return) {
            outwardService = outward.find(function (service) {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.return);
            });

            inboundService = inbound.find(function (service) {
                return !service.isDisabledForTrip(trip) && service.isValidWithFare(cheapestFares.return);
            });
        }

        if (!outwardService && !inboundService) {
            return new OverallCheapestSelection();
        }

        return new OverallCheapestSelection({
            cheapestFares: cheapestFares,
            outwardService: outwardService,
            inboundService: inboundService
        });
    };

    OverallCheapestSelection.prototype.isCheapestFare = function isCheapestFare(fare) {
        return !!this.cheapestFares && this.cheapestFares.isCheapestFare(fare);
    };

    OverallCheapestSelection.prototype.getOutwardFare = function getOutwardFare() {
        return this.cheapestFares.outwardSingle;
    };

    OverallCheapestSelection.prototype.hasOutwardFare = function hasOutwardFare() {
        return Boolean(this.getIn(['cheapestFares', 'outwardSingle']));
    };

    OverallCheapestSelection.prototype.getInwardFare = function getInwardFare() {
        return this.cheapestFares.inboundSingle;
    };

    OverallCheapestSelection.prototype.hasInwardFare = function hasInwardFare() {
        return Boolean(this.getIn(['cheapestFares', 'inboundSingle']));
    };

    OverallCheapestSelection.prototype.getReturnFare = function getReturnFare() {
        return this.cheapestFares.return;
    };

    OverallCheapestSelection.prototype.hasReturnFare = function hasReturnFare() {
        return Boolean(this.getIn(['cheapestFares', 'return']));
    };

    OverallCheapestSelection.prototype.getFareForDirection = function getFareForDirection(direction) {
        if (!this.cheapestFares) {
            return null;
        }

        if (direction === _AppConstants.JourneyDirections.INWARD) {
            return this.getInwardFare();
        }
        return this.getReturnFare() || this.getOutwardFare();
    };

    OverallCheapestSelection.prototype.getServiceForDirection = function getServiceForDirection(direction) {
        return direction === _AppConstants.JourneyDirections.OUTWARD ? this.outwardService : this.inboundService;
    };

    OverallCheapestSelection.prototype.getTripDuration = function getTripDuration() {
        var outwardService = this.outwardService,
            inboundService = this.inboundService;

        return outwardService && outwardService.getTripDuration().add(inboundService && inboundService.getTripDuration());
    };

    OverallCheapestSelection.prototype.getPrice = function getPrice() {
        return this.cheapestFares && this.cheapestFares.totalPrice;
    };

    return OverallCheapestSelection;
}((0, _immutable.Record)(defaults));

exports.default = OverallCheapestSelection;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    outwardSingle: null,
    inboundSingle: null,
    return: null,
    totalPrice: null
};

var CheapestFares = function (_record) {
    (0, _inherits3.default)(CheapestFares, _record);

    function CheapestFares() {
        (0, _classCallCheck3.default)(this, CheapestFares);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CheapestFares.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CheapestFares, json, {
            outwardSingle: _LinkMapper.resolve.as(_Fare2.default),
            inboundSingle: _LinkMapper.resolve.as(_Fare2.default),
            return: _LinkMapper.resolve.as(_Fare2.default),
            totalPrice: _LinkMapper.resolve.with(Number)
        });
    };

    CheapestFares.prototype.isCheapestFare = function isCheapestFare(fare) {
        return this.return && fare.id === this.return.id || this.outwardSingle && fare.id === this.outwardSingle.id || this.inboundSingle && fare.id === this.inboundSingle.id;
    };

    CheapestFares.prototype.reverseSingles = function reverseSingles() {
        var outwardSingle = this.outwardSingle,
            inboundSingle = this.inboundSingle;

        return this.set('outwardSingle', inboundSingle).set('inboundSingle', outwardSingle);
    };

    return CheapestFares;
}((0, _immutable.Record)(defaults));

exports.default = CheapestFares;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(752);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NotificationCentreStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _BrandSplitModal = __webpack_require__(1132);

var _BrandSplitModal2 = _interopRequireDefault(_BrandSplitModal);

var _KeyGoIncompleteJourneyModal = __webpack_require__(1851);

var _KeyGoIncompleteJourneyModal2 = _interopRequireDefault(_KeyGoIncompleteJourneyModal);

var _PromptModal = __webpack_require__(1856);

var _PromptModal2 = _interopRequireDefault(_PromptModal);

var _KeyGoCardExpireModal = __webpack_require__(1858);

var _KeyGoCardExpireModal2 = _interopRequireDefault(_KeyGoCardExpireModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationCentreStore = exports.NotificationCentreStore = function (_BaseStore) {
    (0, _inherits3.default)(NotificationCentreStore, _BaseStore);

    function NotificationCentreStore() {
        (0, _classCallCheck3.default)(this, NotificationCentreStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    NotificationCentreStore.prototype.getInitialState = function getInitialState() {
        return this.calculateNotifications();
    };

    NotificationCentreStore.prototype.calculateNotifications = function calculateNotifications() {
        var user = _UserStore2.default.getCurrent();
        var smartcard = _SmartcardStore2.default.getCurrent();
        var keyGo = smartcard && smartcard.getKeyGo();
        var showBrandSplitModal = _FeatureFlagStore2.default.get('showBrandSplitModal');
        var enableKeyGoSelfCompleteJourneys = _FeatureFlagStore2.default.get('enableKeyGoSelfCompleteJourneys');
        var enableKeyGoPaymentCardExpiryReminder = _FeatureFlagStore2.default.get('enableKeyGoPaymentCardExpiryReminder');
        var notifications = new _immutable.List([{
            title: 'brand.split.header',
            description: 'notifications.brandSplit.description',
            shouldShow: function shouldShow() {
                return user && user.customer && !user.brandChosen && showBrandSplitModal;
            },
            onClick: function onClick() {
                _ModalActions2.default.open(_BrandSplitModal2.default);
            }
        }, {
            title: 'notifications.keyGoIncompleteJourney.text',
            description: 'account.heading.smartcard.keygo.incompletejourneys',
            shouldShow: function shouldShow() {
                if (user && user.smartcardRegistered) {
                    if (enableKeyGoSelfCompleteJourneys && keyGo && keyGo.hasIncompleteJourneys()) {
                        return true;
                    }
                }
                return false;
            },
            onClick: function onClick() {
                _ModalActions2.default.open(_KeyGoIncompleteJourneyModal2.default);
            }
        }, {
            title: 'preference-centre.notification.title',
            description: 'preference-centre.notification.description',
            shouldShow: function shouldShow() {
                if (user.preferences && user.preferences.get('timestamp')) {
                    return false;
                }
                return true;
            },
            onClick: function onClick() {
                _ModalActions2.default.open(_PromptModal2.default);
            }
        }, {
            title: 'notifications.keyGoCardExpire.title',
            description: 'notifications.keyGoCardExpire.description',
            shouldShow: function shouldShow() {
                return user && user.smartcardRegistered && enableKeyGoPaymentCardExpiryReminder && keyGo && keyGo.isPaymentCardExpiredOrAboutTo();
            },
            onClick: function onClick() {
                _ModalActions2.default.open(_KeyGoCardExpireModal2.default, { cardStatus: keyGo ? keyGo.getPaymentCardStatus() : _AppConstants.keyGoPaymentCardStatus.NO_CARD });
            }
        }]);
        return notifications.filter(function (notification) {
            return notification.shouldShow();
        });
    };

    NotificationCentreStore.prototype.updateNotifications = function updateNotifications() {
        this.setState(this.calculateNotifications());
    };

    NotificationCentreStore.prototype.getNotifications = function getNotifications() {
        return this.state;
    };

    NotificationCentreStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.AUTH_LOADED] = this.updateNotifications, _ref[_AppConstants.ActionTypes.USER_UPDATED] = this.updateNotifications, _ref[_AppConstants.ActionTypes.AUTH_REFRESHED] = this.updateNotifications, _ref[_AppConstants.ActionTypes.LOGGED_IN] = this.updateNotifications, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.updateNotifications, _ref[_AppConstants.ActionTypes.REGISTRATION_SUCCESS] = this.updateNotifications, _ref[_AppConstants.ActionTypes.SMARTCARD_LOADED] = this.updateNotifications, _ref[_AppConstants.ActionTypes.USER_PREFERENCES_UPDATED] = this.updateNotifications, _ref;
    };

    return NotificationCentreStore;
}(_BaseStore3.default);

var instance = new NotificationCentreStore();

exports.default = instance;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _immutable = __webpack_require__(5);

var _APIClient = __webpack_require__(52);

var _LinkMapper = __webpack_require__(8);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressService = {
    getBaseUrl: function getBaseUrl(user) {
        return '/customers/' + user.id;
    },
    getAll: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            endpoint = this.getBaseUrl(user) + '/addresses';
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Address2.default));

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0 instanceof _APIClient.NotFoundError) {
                                _context.next = 12;
                                break;
                            }

                            throw _context.t0;

                        case 12:
                            return _context.abrupt('return', new _immutable.List());

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 8]]);
        }));

        function getAll(_x) {
            return _ref.apply(this, arguments);
        }

        return getAll;
    }(),
    get: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user, addressId) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            endpoint = this.getBaseUrl(user) + '/addresses/' + addressId;
                            _context2.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context2.sent;
                            return _context2.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Address2.default));

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](0);
                            return _context2.abrupt('return', null);

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 8]]);
        }));

        function get(_x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return get;
    }(),
    create: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user, address) {
            var isDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var endpoint, updatedAddress, response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            endpoint = this.getBaseUrl(user) + '/addresses';
                            updatedAddress = address.set('default', isDefault);
                            _context3.next = 4;
                            return _AuthenticatedAPIClient2.default.post(endpoint, updatedAddress.toJS());

                        case 4:
                            response = _context3.sent;
                            return _context3.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Address2.default));

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function create(_x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return create;
    }(),
    delete: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(user, address) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            endpoint = this.getBaseUrl(user) + '/addresses/' + address.id;
                            _context4.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(endpoint);

                        case 3:
                            return _context4.abrupt('return', true);

                        case 4:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function _delete(_x7, _x8) {
            return _ref4.apply(this, arguments);
        }

        return _delete;
    }(),
    update: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(user, address) {
            var isDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var endpoint, updatedAddress, response;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            endpoint = this.getBaseUrl(user) + '/addresses/' + address.id;
                            updatedAddress = address.set('default', isDefault);
                            _context5.next = 4;
                            return _AuthenticatedAPIClient2.default.put(endpoint, updatedAddress.getUpdateRequestJSON());

                        case 4:
                            response = _context5.sent;
                            return _context5.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Address2.default));

                        case 6:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function update(_x10, _x11) {
            return _ref5.apply(this, arguments);
        }

        return update;
    }()
};

exports.default = AddressService;

/***/ }),
/* 544 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(432);

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

module.exports = tail;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createLoadingDecoratorFor = createLoadingDecoratorFor;

var _LoadingActions = __webpack_require__(787);

var _LoadingActions2 = _interopRequireDefault(_LoadingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createLoadingDecoratorFor(type) {
    return function withLoadingActions(target, name, descriptor) {
        var original = descriptor.value;
        descriptor.value = _LoadingActions2.default.wrap(type)(original);
        descriptor.value.__DECORATORS = ['withLoadingActions'].concat(original.__DECORATORS || []); // for unit tests
        return descriptor;
    };
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _events = _interopRequireDefault(__webpack_require__(851));

var _ownerDocument = _interopRequireDefault(__webpack_require__(222));

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(560));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _Modal = _interopRequireDefault(__webpack_require__(852));

var _isOverflowing = _interopRequireDefault(__webpack_require__(563));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _Fade = _interopRequireDefault(__webpack_require__(405));

var _ModalBody = _interopRequireDefault(__webpack_require__(868));

var _ModalDialog = _interopRequireDefault(__webpack_require__(870));

var _ModalFooter = _interopRequireDefault(__webpack_require__(871));

var _ModalHeader = _interopRequireDefault(__webpack_require__(872));

var _ModalTitle = _interopRequireDefault(__webpack_require__(873));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(410));

var _StyleConfig = __webpack_require__(90);

var propTypes = (0, _extends2.default)({}, _Modal.default.propTypes, _ModalDialog.default.propTypes, {
  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: _propTypes.default.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: _propTypes.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes.default.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: _propTypes.default.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: _elementType.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: _propTypes.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes.default.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: _propTypes.default.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: _propTypes.default.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes.default.func,

  /**
   * @private
   */
  container: _Modal.default.propTypes.container
});
var defaultProps = (0, _extends2.default)({}, _Modal.default.defaultProps, {
  animation: true,
  dialogComponentClass: _ModalDialog.default
});
var childContextTypes = {
  $bs_modal: _propTypes.default.shape({
    onHide: _propTypes.default.func
  })
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
    timeout: Modal.TRANSITION_DURATION
  }));
}

function BackdropTransition(props) {
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({}, props, {
    timeout: Modal.BACKDROP_TRANSITION_DURATION
  }));
}
/* eslint-enable no-use-before-define */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Modal, _React$Component);

  function Modal(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEntering = _this.handleEntering.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleExited = _this.handleExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleWindowResize = _this.handleWindowResize.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleDialogClick = _this.handleDialogClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.setModalRef = _this.setModalRef.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      style: {}
    };
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  _proto.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  _proto.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  _proto.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    _events.default.on(window, 'resize', this.handleWindowResize);

    this.updateStyle();
  };

  _proto.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    _events.default.off(window, 'resize', this.handleWindowResize);
  };

  _proto.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  _proto.updateStyle = function updateStyle() {
    if (!_inDOM.default) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();

    var dialogHeight = dialogNode.scrollHeight;
    var document = (0, _ownerDocument.default)(dialogNode);
    var bodyIsOverflowing = (0, _isOverflowing.default)(_reactDom.default.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        backdrop = _this$props.backdrop,
        backdropClassName = _this$props.backdropClassName,
        animation = _this$props.animation,
        show = _this$props.show,
        Dialog = _this$props.dialogComponentClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        onEntering = _this$props.onEntering,
        onExited = _this$props.onExited,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);

    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Modal.default),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';
    return _react.default.createElement(_Modal.default, (0, _extends2.default)({}, baseModalProps, {
      ref: this.setModalRef,
      show: show,
      containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
      transition: animation ? DialogTransition : undefined,
      backdrop: backdrop,
      backdropTransition: animation ? BackdropTransition : undefined,
      backdropClassName: (0, _classnames.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
      onEntering: (0, _createChainedFunction.default)(onEntering, this.handleEntering),
      onExited: (0, _createChainedFunction.default)(onExited, this.handleExited)
    }), _react.default.createElement(Dialog, (0, _extends2.default)({}, dialogProps, {
      style: (0, _extends2.default)({}, this.state.style, style),
      className: (0, _classnames.default)(className, inClassName),
      onClick: backdrop === true ? this.handleDialogClick : null
    }), children));
  };

  return Modal;
}(_react.default.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;
Modal.Body = _ModalBody.default;
Modal.Header = _ModalHeader.default;
Modal.Title = _ModalTitle.default;
Modal.Footer = _ModalFooter.default;
Modal.Dialog = _ModalDialog.default;
Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

var _default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(549);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 549 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 550 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(552)('keys');
var uid = __webpack_require__(400);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(78);
var global = __webpack_require__(138);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(399) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 553 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(139);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(192);
var dPs = __webpack_require__(1777);
var enumBugKeys = __webpack_require__(553);
var IE_PROTO = __webpack_require__(551)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(847)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1778).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(323);
var createDesc = __webpack_require__(322);
var toIObject = __webpack_require__(190);
var toPrimitive = __webpack_require__(554);
var has = __webpack_require__(189);
var IE8_DOM_DEFINE = __webpack_require__(846);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(154) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 557 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(222));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(403);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(222);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(191);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(140);


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(138);
var core = __webpack_require__(78);
var LIBRARY = __webpack_require__(399);
var wksExt = __webpack_require__(565);
var defineProperty = __webpack_require__(167).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(549);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(262);
var IObject = __webpack_require__(548);
var toObject = __webpack_require__(260);
var toLength = __webpack_require__(398);
var asc = __webpack_require__(1823);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(262);
var call = __webpack_require__(865);
var isArrayIter = __webpack_require__(866);
var anObject = __webpack_require__(192);
var toLength = __webpack_require__(398);
var getIterFn = __webpack_require__(867);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(139);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var propTypes = {
  label: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func
};
var defaultProps = {
  label: 'Close'
};

var CloseButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(CloseButton, _React$Component);

  function CloseButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CloseButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        onClick = _this$props.onClick;
    return _react.default.createElement("button", {
      type: "button",
      className: "close",
      onClick: onClick
    }, _react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"), _react.default.createElement("span", {
      className: "sr-only"
    }, label));
  };

  return CloseButton;
}(_react.default.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
var _default = CloseButton;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bool = _propTypes2.default.bool,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string,
    func = _propTypes2.default.func,
    oneOfType = _propTypes2.default.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function createLocationDescriptor(to, _ref) {
  var query = _ref.query,
      hash = _ref.hash,
      state = _ref.state;

  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (event.defaultPrevented) return;

      !_this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

      // If target prop is set (e.g. to "_blank"), let browser handle link.
      /* istanbul ignore if: untestable with Karma */
      if (_this.props.target) return;

      event.preventDefault();

      var _this$props = _this.props,
          to = _this$props.to,
          query = _this$props.query,
          hash = _this$props.hash,
          state = _this$props.state;

      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });

      _this.context.router.push(location);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        to = _props.to,
        query = _props.query,
        hash = _props.hash,
        state = _props.state,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;

    // Ignore if rendered outside the context of router, simplifies unit testing.
    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return _react2.default.createElement('a', props);
      }

      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
      props.href = router.createHref(location);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(location, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  };

  return Link;
}(_react2.default.Component);

Link.contextTypes = {
  router: _PropTypes.routerShape
};
Link.propTypes = {
  to: oneOfType([string, object]),
  query: object,
  hash: string,
  state: object,
  activeStyle: object,
  activeClassName: string,
  onlyActiveOnIndex: bool.isRequired,
  onClick: func,
  target: string
};
Link.defaultProps = {
  onlyActiveOnIndex: false,
  style: {}
};
exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(224);

var _PathUtils = __webpack_require__(225);

var _ExecutionEnvironment = __webpack_require__(326);

var _DOMUtils = __webpack_require__(412);

var _DOMStateStorage = __webpack_require__(881);

var _createDOMHistory = __webpack_require__(882);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

function isAbsolutePath(path) {
  return typeof path === 'string' && path.charAt(0) === '/';
}

function ensureSlash() {
  var path = _DOMUtils.getHashPath();

  if (isAbsolutePath(path)) return true;

  _DOMUtils.replaceHashPath('/' + path);

  return false;
}

function addQueryStringValueToPath(path, key, value) {
  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
}

function stripQueryStringValueFromPath(path, key) {
  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
}

function getQueryStringValueFromPath(path, key) {
  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
  return match && match[1];
}

var DefaultQueryKey = '_k';

function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;

  var queryKey = options.queryKey;

  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;

  function getCurrentLocation() {
    var path = _DOMUtils.getHashPath();

    var key = undefined,
        state = undefined;
    if (queryKey) {
      key = getQueryStringValueFromPath(path, queryKey);
      path = stripQueryStringValueFromPath(path, queryKey);

      if (key) {
        state = _DOMStateStorage.readState(key);
      } else {
        state = null;
        key = history.createKey();
        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
      }
    } else {
      key = state = null;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startHashChangeListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function hashChangeListener() {
      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.

      transitionTo(getCurrentLocation());
    }

    ensureSlash();
    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    var path = (basename || '') + pathname + search;

    if (queryKey) {
      path = addQueryStringValueToPath(path, queryKey, key);
      _DOMStateStorage.saveState(key, state);
    } else {
      // Drop key and state.
      location.key = location.state = null;
    }

    var currentHash = _DOMUtils.getHashPath();

    if (action === _Actions.PUSH) {
      if (currentHash !== path) {
        window.location.hash = path;
      } else {
         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
      }
    } else if (currentHash !== path) {
      // REPLACE
      _DOMUtils.replaceHashPath(path);
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopHashChangeListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopHashChangeListener();
    };
  }

  function push(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.push(location);
  }

  function replace(location) {
     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replace(location);
  }

  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();

  function go(n) {
     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;

    history.go(n);
  }

  function createHref(path) {
    return '#' + history.createHref(path);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopHashChangeListener();
  }

  // deprecated
  function pushState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.pushState(state, path);
  }

  // deprecated
  function replaceState(state, path) {
     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;

    history.replaceState(state, path);
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    push: push,
    replace: replace,
    go: go,
    createHref: createHref,

    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
    pushState: pushState, // deprecated - warning is in createHistory
    replaceState: replaceState // deprecated - warning is in createHistory
  });
}

exports['default'] = createHashHistory;
module.exports = exports['default'];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(886);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1876);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(575);
var GetIntrinsic = __webpack_require__(888);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
  }
}

exports['default'] = runTransitionHook;
module.exports = exports['default'];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _computeChangedRoutes2 = __webpack_require__(1887);

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = __webpack_require__(1888);

var _isActive2 = __webpack_require__(1889);

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = __webpack_require__(1890);

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = __webpack_require__(1891);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location) {
    var indexOnlyOrDeprecatedQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var deprecatedIndexOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var indexOnly = void 0;
    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
      indexOnly = deprecatedIndexOnly || false;
    } else {
      location = history.createLocation(location);
      indexOnly = indexOnlyOrDeprecatedQuery;
    }

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.reduce(function (hooks, route) {
      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
      return hooks;
    }, []);
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route, false);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    // TODO: Warn if they register for a route that isn't currently
    // active. They're probably doing something wrong, like re-creating
    // route objects on every location change.
    var routeID = getRouteID(route);
    var hooks = RouteHooks[routeID];

    if (!hooks) {
      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);

      RouteHooks[routeID] = [hook];

      if (thereWereNoRouteHooks) {
        // setup transition & beforeunload hooks
        unlistenBefore = history.listenBefore(transitionHook);

        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
      }
    } else {
      if (hooks.indexOf(hook) === -1) {
         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;

        hooks.push(hook);
      }
    }

    return function () {
      var hooks = RouteHooks[routeID];

      if (hooks) {
        var newHooks = hooks.filter(function (item) {
          return item !== hook;
        });

        if (newHooks.length === 0) {
          removeListenBeforeHooksForRoute(route);
        } else {
          RouteHooks[routeID] = newHooks;
        }
      }
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    // TODO: Only use a single history listener. Otherwise we'll
    // end up with multiple concurrent calls to match.
    return history.listen(function (location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    });
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

//export default useRoutes

module.exports = exports['default'];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(326);

var _PathUtils = __webpack_require__(225);

var _runTransitionHook = __webpack_require__(577);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(226);

var _deprecate2 = _interopRequireDefault(_deprecate);

function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);

    var basename = options.basename;

    var checkedBaseHref = false;

    function checkBaseHref() {
      if (checkedBaseHref) {
        return;
      }

      // Automatically use the value of <base href> in HTML
      // documents as basename if it's not explicitly given.
      if (basename == null && _ExecutionEnvironment.canUseDOM) {
        var base = document.getElementsByTagName('base')[0];
        var baseHref = base && base.getAttribute('href');

        if (baseHref != null) {
          basename = baseHref;

           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
        }
      }

      checkedBaseHref = true;
    }

    function addBasename(location) {
      checkBaseHref();

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    }

    function prependBasename(location) {
      checkBaseHref();

      if (!basename) return location;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      var pname = location.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, location, {
        pathname: pathname
      });
    }

    // Override all read methods with basename-aware versions.
    function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        _runTransitionHook2['default'](hook, addBasename(location), callback);
      });
    }

    function listen(listener) {
      return history.listen(function (location) {
        listener(addBasename(location));
      });
    }

    // Override all write methods with basename-aware versions.
    function push(location) {
      history.push(prependBasename(location));
    }

    function replace(location) {
      history.replace(prependBasename(location));
    }

    function createPath(location) {
      return history.createPath(prependBasename(location));
    }

    function createHref(location) {
      return history.createHref(prependBasename(location));
    }

    function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    }

    // deprecated
    function pushState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      push(_extends({ state: state }, path));
    }

    // deprecated
    function replaceState(state, path) {
      if (typeof path === 'string') path = _PathUtils.parsePath(path);

      replace(_extends({ state: state }, path));
    }

    return _extends({}, history, {
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation,

      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
    });
  };
}

exports['default'] = useBasename;
module.exports = exports['default'];

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(266);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(580);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    history.__v2_compatible__ = true;
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _SearchUrls = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    id: [_LinkMapper.fields.number],
    muteFrom: [_LinkMapper.resolve.with(_TrainTime2.default), null],
    muteUntil: [_LinkMapper.resolve.with(_TrainTime2.default), null]
};

var DisruptionAlertMute = function (_record) {
    (0, _inherits3.default)(DisruptionAlertMute, _record);

    function DisruptionAlertMute() {
        (0, _classCallCheck3.default)(this, DisruptionAlertMute);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DisruptionAlertMute.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DisruptionAlertMute, json, (0, _Records.getResolvers)(fieldSchema));
    };

    DisruptionAlertMute.prototype.toJSON = function toJSON() {
        return (0, _SearchUrls.serialize)({
            muteId: function muteId(_, mute) {
                return mute.id ? mute.id : null;
            },
            muteFrom: function muteFrom(_muteFrom) {
                return _muteFrom ? _SearchUrls.serializers.date(_muteFrom) : null;
            },
            muteUntil: function muteUntil(_muteUntil) {
                return _muteUntil ? _SearchUrls.serializers.date(_muteUntil) : null;
            }
        }, this);
    };

    return DisruptionAlertMute;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = DisruptionAlertMute;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Banner = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(Banner, _PureRenderComponent);

    function Banner() {
        (0, _classCallCheck3.default)(this, Banner);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    Banner.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var classes = document.body.className;
        document.body.className = classes + ' ' + this.props.bodyClassName;
    };

    Banner.prototype.componentWillUnmount = function componentWillUnmount() {
        var classes = document.body.className;
        document.body.className = classes.replace(this.props.bodyClassName, '');
    };

    Banner.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            children = _props.children,
            showDismiss = _props.showDismiss,
            onDismiss = _props.onDismiss;


        return _react2.default.createElement(
            'div',
            { className: 'banner text-inverse text-weight--normal hidden-print clearfix ' + className },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: showDismiss ? 10 : 12 },
                    children
                ),
                showDismiss && _react2.default.createElement(
                    _Col2.default,
                    { xs: 2 },
                    _react2.default.createElement(
                        _Button2.default,
                        { className: 'btn-plain btn-dismiss', onClick: onDismiss },
                        _react2.default.createElement(_Icon2.default, { icon: 'clear', className: 'otrl-inline' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'btn-dismiss__text' },
                            (0, _I18n.translate)('global.banner.dismiss')
                        )
                    )
                )
            )
        );
    };

    return Banner;
}(_PureRenderComponent3.default), _class.propTypes = {
    className: _propTypes2.default.string,
    bodyClassName: _propTypes2.default.string,
    children: _propTypes2.default.node,
    showDismiss: _propTypes2.default.bool,
    onDismiss: _propTypes2.default.func
}, _class.defaultProps = {
    className: '',
    bodyClassName: '',
    children: null,
    showDismiss: false,
    onDismiss: _noop3.default
}, _temp);
exports.default = Banner;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropDownItem(_ref) {
    var children = _ref.children;

    return _react2.default.createElement(
        'li',
        { role: 'menuitem' },
        children
    );
}

DropDownItem.propTypes = { children: _propTypes2.default.node.isRequired };

exports.default = DropDownItem;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.displayNotifications = undefined;

var _NotificationCentreStore = __webpack_require__(542);

var _NotificationCentreStore2 = _interopRequireDefault(_NotificationCentreStore);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _Modal = __webpack_require__(1935);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayNotifications = exports.displayNotifications = function displayNotifications() {
    var notifications = _NotificationCentreStore2.default.getNotifications();
    if (notifications.size === 1) {
        notifications.first().onClick();
    } else if (notifications.size > 1) {
        _ModalActions2.default.open(_Modal2.default, { notifications: notifications });
    }
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(194);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(857);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(264);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: _propTypes.default.string.isRequired
};

var Glyphicon =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Glyphicon, _React$Component);

  function Glyphicon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Glyphicon.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        glyph = _this$props.glyph,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["glyph", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
    return _react.default.createElement("span", (0, _extends3.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Glyphicon;
}(_react.default.Component);

Glyphicon.propTypes = propTypes;

var _default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(2000),
    hasUnicode = __webpack_require__(259),
    unicodeSize = __webpack_require__(2001);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _all = _interopRequireDefault(__webpack_require__(196));

var _Button = _interopRequireDefault(__webpack_require__(45));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  vertical: _propTypes.default.bool,
  justified: _propTypes.default.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: (0, _all.default)(_propTypes.default.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};
var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ButtonGroup, _React$Component);

  function ButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        block = _this$props.block,
        justified = _this$props.justified,
        vertical = _this$props.vertical,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["block", "justified", "vertical", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button.default.defaultProps, 'block')] = block, _extends2));
    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return ButtonGroup;
}(_react.default.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _uncontrollable = _interopRequireDefault(__webpack_require__(106));

var TAB = 'tab';
var PANE = 'pane';

var idPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);

var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },

  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: _propTypes.default.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: _propTypes.default.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: _propTypes.default.any
};
var childContextTypes = {
  $bs_tabContainer: _propTypes.default.shape({
    activeKey: _propTypes.default.any,
    onSelect: _propTypes.default.func.isRequired,
    getTabId: _propTypes.default.func.isRequired,
    getPaneId: _propTypes.default.func.isRequired
  })
};

var TabContainer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(TabContainer, _React$Component);

  function TabContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContainer.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        onSelect = _this$props.onSelect,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;

    var getId = generateChildId || function (key, type) {
      return id ? id + "-" + type + "-" + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["children"]);
    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;
    return _react.default.cloneElement(_react.default.Children.only(children), props);
  };

  return TabContainer;
}(_react.default.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;

var _default = (0, _uncontrollable.default)(TabContainer, {
  activeKey: 'onSelect'
});

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: _propTypes.default.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: _propTypes.default.bool
};
var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};
var contextTypes = {
  $bs_tabContainer: _propTypes.default.shape({
    activeKey: _propTypes.default.any
  })
};
var childContextTypes = {
  $bs_tabContent: _propTypes.default.shape({
    bsClass: _propTypes.default.string,
    animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
    activeKey: _propTypes.default.any,
    mountOnEnter: _propTypes.default.bool,
    unmountOnExit: _propTypes.default.bool,
    onPaneEnter: _propTypes.default.func.isRequired,
    onPaneExited: _propTypes.default.func.isRequired,
    exiting: _propTypes.default.bool.isRequired
  })
};

var TabContent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(TabContent, _React$Component);

  function TabContent(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handlePaneEnter = _this.handlePaneEnter.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handlePaneExited = _this.handlePaneExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))); // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.

    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit;
    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();
    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({
        activeKey: null,
        activeChild: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    } // It's possible that this child should be transitioning out.


    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });
    return true;
  };

  _proto.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        className = _this$props2.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["componentClass", "className"]);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
    }));
  };

  return TabContent;
}(_react.default.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;

var _default = (0, _bootstrapUtils.bsClass)('tab', TabContent);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(957);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.APIPager = exports.default = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty = __webpack_require__(313);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getOwnPropertyNames = __webpack_require__(799);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _zipObject2 = __webpack_require__(204);

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _clamp2 = __webpack_require__(1738);

var _clamp3 = _interopRequireDefault(_clamp2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// An Object.assign which can handle JS setters/getters
function copyProperties(target, source) {
    var props = (0, _getOwnPropertyNames2.default)(source);
    props.forEach(function (prop) {
        var descriptor = (0, _getOwnPropertyDescriptor2.default)(source, prop);
        (0, _defineProperty2.default)(target, prop, descriptor);
    });
}

var PaginationHelper = {
    goTo: function goTo(page) {
        var pages = this.pages;

        if (pages) {
            return this.set('page', (0, _clamp3.default)(page, 1, pages));
        } else {
            return this.set('page', 1);
        }
    },


    get next() {
        return this.goTo(this.page + 1);
    },

    get previous() {
        return this.goTo(this.page - 1);
    },

    get end() {
        return this.goTo(this.pages);
    },

    get beginning() {
        return this.goTo(1);
    }
};

var defaults = {
    'perPage': 5,
    'page': 1,
    'data': new _immutable.List()
};

var Pager = function (_record) {
    (0, _inherits3.default)(Pager, _record);

    function Pager() {
        (0, _classCallCheck3.default)(this, Pager);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    (0, _createClass3.default)(Pager, [{
        key: 'pages',
        get: function get() {
            return Math.ceil(this.data.size / this.perPage);
        }
    }, {
        key: 'pageData',
        get: function get() {
            var start = (this.page - 1) * this.perPage;
            var end = start + this.perPage;
            return this.data.slice(start, end);
        }
    }]);
    return Pager;
}((0, _immutable.Record)(defaults));

exports.default = Pager;

var APIPager = exports.APIPager = function (_record2) {
    (0, _inherits3.default)(APIPager, _record2);

    function APIPager() {
        (0, _classCallCheck3.default)(this, APIPager);
        return (0, _possibleConstructorReturn3.default)(this, _record2.apply(this, arguments));
    }

    APIPager.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if ('total' in json) {
            json = (0, _extends3.default)({}, json, {
                totalCount: json.total,
                totalPages: Math.ceil(json.total / json.limit)
            });
        }
        return (0, _LinkMapper.construct)(APIPager, json, {
            limit: _LinkMapper.resolve.with(Number),
            page: _LinkMapper.resolve.with(Number),
            totalCount: _LinkMapper.resolve.with(Number),
            totalPages: _LinkMapper.resolve.with(Number)
        });
    };

    (0, _createClass3.default)(APIPager, [{
        key: 'pages',
        get: function get() {
            return this.totalPages || 0;
        }
    }]);
    return APIPager;
}((0, _immutable.Record)((0, _zipObject3.default)(['limit', 'page', 'totalCount', 'totalPages'])));

copyProperties(Pager.prototype, PaginationHelper);
copyProperties(APIPager.prototype, PaginationHelper);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PrivacyPolicyLink = exports.TermsAndConditionsLink = undefined;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

exports.default = SignupTAndCs;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _Accordion = __webpack_require__(1991);

var _Accordion2 = _interopRequireDefault(_Accordion);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsAndConditionsLink = exports.TermsAndConditionsLink = function TermsAndConditionsLink(_ref) {
    var className = _ref.className,
        _ref$message = _ref.message,
        message = _ref$message === undefined ? (0, _I18n2.default)('form.termsAndConditions') : _ref$message;
    return _react2.default.createElement(_ExternalLink2.default, { className: className, message: message, href: _config2.default.get('legalUrl') });
};

var PrivacyPolicyLink = exports.PrivacyPolicyLink = function PrivacyPolicyLink(_ref2) {
    var className = _ref2.className,
        _ref2$message = _ref2.message,
        message = _ref2$message === undefined ? (0, _I18n2.default)('form.privacyPolicy') : _ref2$message;
    return _react2.default.createElement(_ExternalLink2.default, { className: className, message: message, href: _config2.default.get('privacyPolicyUrl') });
};

var termsPrivacySharedPropTypes = {
    message: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string
};
TermsAndConditionsLink.propTypes = termsPrivacySharedPropTypes;
PrivacyPolicyLink.propTypes = termsPrivacySharedPropTypes;

function SignupTAndCs(_ref3) {
    var form = _ref3.form,
        visited = _ref3.visited,
        onToggle = _ref3.onToggle;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'margin-bottom--sm' },
            _react2.default.createElement(_ValidatedField2.default, {
                form: form,
                visited: visited,
                field: 'acceptedTAndCs',
                checked: form.get('acceptedTAndCs'),
                type: 'checkbox',
                onChange: onToggle,
                label: _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: 'preference-centre.terms-and-conditions.warning',
                    termsAndConditions: _react2.default.createElement(TermsAndConditionsLink, null)
                }),
                externalFormGroup: true
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'margin-bottom' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, { className: 'text-sm', message: 'preference-centre.privacy-notice' }),
            (0, _I18n2.default)('preference-centre.privacy-notice.more').length > 1 && _react2.default.createElement(
                _Accordion2.default,
                { singleUse: true },
                _react2.default.createElement(_FormattedHTMLMessage2.default, { className: 'text-sm', message: 'preference-centre.privacy-notice.more' })
            )
        )
    );
}

SignupTAndCs.propTypes = {
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    visited: _propTypes2.default.bool,
    onToggle: _propTypes2.default.func
};

SignupTAndCs.defaultProps = {
    visited: false,
    onToggle: _noop3.default
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _RoversRangersTicketsService = __webpack_require__(1123);

var _RoversRangersTicketsService2 = _interopRequireDefault(_RoversRangersTicketsService);

var _Immutable = __webpack_require__(54);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _SearchUrls = __webpack_require__(97);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _minDate() {
    return (0, _TrainTime2.default)().add(3, 'days').startOf('day');
}

function _maxDate() {
    return (0, _TrainTime2.default)().add(_config2.default.get('maxOutboundDays'), 'days').endOf('day');
}

var defaults = {
    date: _minDate(),
    adults: 1,
    children: 0,
    ticketType: _RoversRangersTicketsService2.default.getFirst(),
    railcards: new _immutable.List()
};

var RoversRangersSearch = function (_record) {
    (0, _inherits3.default)(RoversRangersSearch, _record);

    function RoversRangersSearch() {
        (0, _classCallCheck3.default)(this, RoversRangersSearch);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    RoversRangersSearch.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        json = (0, _defaults3.default)(json, { adults: 0, children: 0 });
        return (0, _LinkMapper.construct)(RoversRangersSearch, json, {
            date: _LinkMapper.fields.datetime,
            adults: _LinkMapper.fields.number,
            children: _LinkMapper.fields.number,
            ticketType: _LinkMapper.resolve.as(_TicketType2.default),
            railcards: _LinkMapper.resolveAll.as(_PassengerRailcard2.default)
        });
    };

    RoversRangersSearch.prototype.serialize = function serialize() {
        return (0, _SearchUrls.serialize)({
            date: _SearchUrls.serializers.date,
            adults: _SearchUrls.serializers.identity,
            children: _SearchUrls.serializers.identity,
            ticketType: _SearchUrls.serializers.ticketType,
            railcards: _SearchUrls.serializers.railcards
        }, this);
    };

    /**
     * Return a promise that resolves to a new RoversRangersSearch, from the url params
     */


    RoversRangersSearch.deserialize = function deserialize(source) {
        var schema = {
            date: _SearchUrls.deserializers.date,
            adults: _SearchUrls.deserializers.int,
            children: _SearchUrls.deserializers.int,
            ticketType: _SearchUrls.deserializers.ticketType,
            railcards: _SearchUrls.deserializers.railcards
        };

        return (0, _SearchUrls.deserialize)(schema, source).then(function (deserialized) {
            return new RoversRangersSearch(deserialized);
        });
    };

    RoversRangersSearch.prototype.refreshDates = function refreshDates() {
        if (this.date.isBefore(_minDate())) {
            return this.set('date', _minDate());
        }
        return this;
    };

    RoversRangersSearch.prototype.getComputedValues = function getComputedValues() {
        return {
            date: this.date.format(),
            ticketTypeCode: this.ticketType.code,
            passengersNumber: this.adults + this.children,
            railcardsNumber: this.railcards ? (0, _Immutable.sum)(this.railcards, 'quantity') : 0
        };
    };

    RoversRangersSearch.prototype.isValid = function isValid() {
        return this.isComplete();
    };

    RoversRangersSearch.prototype.getSchema = function getSchema() {
        return {
            date: _joi2.default.date().min(_minDate().format()).max(_maxDate().format()).required(),
            ticketTypeCode: _validation2.default.requiredString(3, 3),
            passengersNumber: _joi2.default.number().min(1).max(9).required(),
            railcardsNumber: _validation2.default.railcardsNumber('passengersNumber')
        };
    };

    (0, _createClass3.default)(RoversRangersSearch, [{
        key: 'minimumDate',
        get: function get() {
            return _minDate();
        }
    }, {
        key: 'maximumDate',
        get: function get() {
            return _maxDate();
        }
    }]);
    return RoversRangersSearch;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(RoversRangersSearch.prototype, _ValidationMixin2.default);

exports.default = RoversRangersSearch;

/***/ }),
/* 596 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.deviceDetection = deviceDetection;
exports.browserDetection = browserDetection;

var _AppConstants = __webpack_require__(6);

function deviceDetection() {
    if (navigator.userAgent.match(/Android/i)) {
        return 'Android';
    } else if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)) {
        return 'iOS';
    } else {
        return 'Android';
    }
}

function browserDetection() {
    if (navigator.userAgent.match(/MSIE/i)) {
        return _AppConstants.Browsers.IE9_10;
    } else if (navigator.userAgent.match(/Trident\//i)) {
        return _AppConstants.Browsers.IE11;
    } else if (navigator.userAgent.match(/CriOS/i)) {
        return _AppConstants.Browsers.IOS_CHROME;
    } else {
        return _AppConstants.Browsers.CHROME;
    }
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(745),
    castFunction = __webpack_require__(520),
    toInteger = __webpack_require__(200);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = '(?:^|[^\\d])' +
              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:$|[^\\d])';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, options) {
  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }

  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = options.loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, options);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, options) {
  var v = parse(version, options);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, options) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), options);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, options) {
  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }
  if (version instanceof SemVer) {
    if (version.loose === options.loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, options);

  debug('SemVer', version, options);
  this.options = options;
  this.loose = !!options.loose;

  var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.options, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.options);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.options);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.options);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(new SemVer(b, loose));
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, options) {
  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }

  if (comp instanceof Comparator) {
    if (comp.loose === !!options.loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, options);

  debug('comparator', comp, options);
  this.options = options;
  this.loose = !!options.loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.options.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.options.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.options);

  return cmp(version, this.operator, this.semver, this.options);
};

Comparator.prototype.intersects = function(comp, options) {
  if (!(comp instanceof Comparator)) {
    throw new TypeError('a Comparator is required');
  }

  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }

  var rangeTmp;

  if (this.operator === '') {
    rangeTmp = new Range(comp.value, options);
    return satisfies(this.value, rangeTmp, options);
  } else if (comp.operator === '') {
    rangeTmp = new Range(this.value, options);
    return satisfies(comp.semver, rangeTmp, options);
  }

  var sameDirectionIncreasing =
    (this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '>=' || comp.operator === '>');
  var sameDirectionDecreasing =
    (this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '<=' || comp.operator === '<');
  var sameSemVer = this.semver.version === comp.semver.version;
  var differentDirectionsInclusive =
    (this.operator === '>=' || this.operator === '<=') &&
    (comp.operator === '>=' || comp.operator === '<=');
  var oppositeDirectionsLessThan =
    cmp(this.semver, '<', comp.semver, options) &&
    ((this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '<=' || comp.operator === '<'));
  var oppositeDirectionsGreaterThan =
    cmp(this.semver, '>', comp.semver, options) &&
    ((this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '>=' || comp.operator === '>'));

  return sameDirectionIncreasing || sameDirectionDecreasing ||
    (sameSemVer && differentDirectionsInclusive) ||
    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};


exports.Range = Range;
function Range(range, options) {
  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }

  if (range instanceof Range) {
    if (range.loose === !!options.loose &&
        range.includePrerelease === !!options.includePrerelease) {
      return range;
    } else {
      return new Range(range.raw, options);
    }
  }

  if (range instanceof Comparator) {
    return new Range(range.value, options);
  }

  if (!(this instanceof Range))
    return new Range(range, options);

  this.options = options;
  this.loose = !!options.loose;
  this.includePrerelease = !!options.includePrerelease

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.options.loose;
  range = range.trim();
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, this.options);
  }, this).join(' ').split(/\s+/);
  if (this.options.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, this.options);
  }, this);

  return set;
};

Range.prototype.intersects = function(range, options) {
  if (!(range instanceof Range)) {
    throw new TypeError('a Range is required');
  }

  return this.set.some(function(thisComparators) {
    return thisComparators.every(function(thisComparator) {
      return range.set.some(function(rangeComparators) {
        return rangeComparators.every(function(rangeComparator) {
          return thisComparator.intersects(rangeComparator, options);
        });
      });
    });
  });
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
  return new Range(range, options).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
  debug('comp', comp, options);
  comp = replaceCarets(comp, options);
  debug('caret', comp);
  comp = replaceTildes(comp, options);
  debug('tildes', comp);
  comp = replaceXRanges(comp, options);
  debug('xrange', comp);
  comp = replaceStars(comp, options);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, options);
  }).join(' ');
}

function replaceTilde(comp, options) {
  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }
  var r = options.loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, options);
  }).join(' ');
}

function replaceCaret(comp, options) {
  debug('caret', comp, options);
  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }
  var r = options.loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, options) {
  debug('replaceXRanges', comp, options);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, options);
  }).join(' ');
}

function replaceXRange(comp, options) {
  comp = comp.trim();
  if (!options || typeof options !== 'object')
    options = { loose: !!options, includePrerelease: false }
  var r = options.loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
  debug('replaceStars', comp, options);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.options);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version, this.options))
      return true;
  }
  return false;
};

function testSet(set, version, options) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (!options)
    options = {}

  if (version.prerelease.length && !options.includePrerelease) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, options) {
  try {
    range = new Range(range, options);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
  var max = null;
  var maxSV = null;
  try {
    var rangeObj = new Range(range, options);
  } catch (er) {
    return null;
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) { // satisfies(v, range, options)
      if (!max || maxSV.compare(v) === -1) { // compare(max, v, true)
        max = v;
        maxSV = new SemVer(max, options);
      }
    }
  })
  return max;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
  var min = null;
  var minSV = null;
  try {
    var rangeObj = new Range(range, options);
  } catch (er) {
    return null;
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) { // satisfies(v, range, options)
      if (!min || minSV.compare(v) === 1) { // compare(min, v, true)
        min = v;
        minSV = new SemVer(min, options);
      }
    }
  })
  return min;
}

exports.validRange = validRange;
function validRange(range, options) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, options).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
  return outside(version, range, '<', options);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
  return outside(version, range, '>', options);
}

exports.outside = outside;
function outside(version, range, hilo, options) {
  version = new SemVer(version, options);
  range = new Range(range, options);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, options)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, options)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, options)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, options) {
  var parsed = parse(version, options);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

exports.intersects = intersects;
function intersects(r1, r2, options) {
  r1 = new Range(r1, options)
  r2 = new Range(r2, options)
  return r1.intersects(r2)
}

exports.coerce = coerce;
function coerce(version) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  var match = version.match(re[COERCE]);

  if (match == null)
    return null;

  return parse((match[1] || '0') + '.' + (match[2] || '0') + '.' + (match[3] || '0')); 
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _Service = __webpack_require__(273);

var _Service2 = _interopRequireDefault(_Service);

var _Fares = __webpack_require__(605);

var _Fares2 = _interopRequireDefault(_Fares);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    outward: new _immutable.List(),
    inward: new _immutable.List()
};

function getOrderForDirection(direction, search) {
    var _search$getTimebandFo = search.getTimebandForDirection(direction),
        arriveDepart = _search$getTimebandFo.arriveDepart;

    return arriveDepart === _AppConstants.TimeTypes.DEPART ? 'origin' : 'destination';
}

function getOrderedForDirection(list, orderBy) {
    var timePath = ['journey', orderBy, 'time', 'scheduledTime'];
    return list.sort(function (a, b) {
        return a.getIn(timePath) - b.getIn(timePath) || a.getTripDuration() - b.getTripDuration();
    });
}

function getServiceFilter(trip) {
    return function (service) {
        return !service.isDisabledForTrip(trip);
    };
}

function getSingleFaresFromServiceList(services, trip) {
    var fares = new _immutable.List();
    services.filter(getServiceFilter(trip)).map(function (service) {
        fares = fares.concat(service.fares.getSingleFares(!trip.isReturn()));
    });

    return fares.toSet().toList().sortBy(function (fare) {
        return fare.getPrice();
    });
}

function getReturnFaresFromServiceList(services, trip) {
    var fares = new _immutable.List();
    services.filter(getServiceFilter(trip)).map(function (service) {
        fares = fares.concat(service.fares.getReturnFares());
    });

    return fares.toSet().toList().sortBy(function (fare) {
        return fare.getPrice();
    });
}

var Services = function (_record) {
    (0, _inherits3.default)(Services, _record);

    function Services() {
        (0, _classCallCheck3.default)(this, Services);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Services.fromJSON = function fromJSON(json) {
        return new Services({
            outward: (0, _LinkMapper.resolveAll)(json.outward).as(_Service2.default),
            inward: (0, _LinkMapper.resolveAll)(json.inward).as(_Service2.default)
        });
    };

    Services.prototype.orderForSearch = function orderForSearch(search) {
        return this.set('outward', getOrderedForDirection(this.outward, getOrderForDirection(_AppConstants.JourneyDirections.OUTWARD, search))).set('inward', getOrderedForDirection(this.inward, getOrderForDirection(_AppConstants.JourneyDirections.INWARD, search)));
    };

    Services.prototype.getServicesForDirection = function getServicesForDirection(direction) {
        return this[direction];
    };

    Services.prototype.getAllFares = function getAllFares(trip) {
        var includeFirstClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var fares = this.getAllSingleFares(trip).concat(this.getAllReturnFares(trip));

        if (!trip.filters.showStandard) {
            fares = fares.filterNot(_Fares2.default.isStandard);
        }

        if (!trip.filters.showFirstClass && !includeFirstClass) {
            fares = fares.filterNot(_Fares2.default.isFirstClass);
        }

        return fares;
    };

    Services.prototype.getAllSingleFares = function getAllSingleFares(trip) {
        return this.getAllSingleOutwardFares(trip).concat(this.getAllSingleInwardFares(trip)).groupBy(function (fare) {
            return fare.id;
        }).toList().map(function (x) {
            return x.first();
        }).sortBy(function (fare) {
            return fare.getPrice();
        });
    };

    Services.prototype.getAllReturnFares = function getAllReturnFares(trip) {
        return this.getAllReturnOutwardFares(trip).concat(this.getAllReturnInwardFares(trip)).groupBy(function (fare) {
            return fare.id;
        }).toList().map(function (x) {
            return x.first();
        }).sortBy(function (fare) {
            return fare.getPrice();
        });
    };

    Services.prototype.getAllSingleOutwardFares = function getAllSingleOutwardFares(trip) {
        return getSingleFaresFromServiceList(this.outward, trip);
    };

    Services.prototype.getAllSingleInwardFares = function getAllSingleInwardFares(trip) {
        return getSingleFaresFromServiceList(this.inward, trip);
    };

    Services.prototype.getAllReturnOutwardFares = function getAllReturnOutwardFares(trip) {
        return getReturnFaresFromServiceList(this.outward, trip);
    };

    Services.prototype.getAllReturnInwardFares = function getAllReturnInwardFares(trip) {
        return getReturnFaresFromServiceList(this.inward, trip);
    };

    Services.prototype.getLatestArrivingService = function getLatestArrivingService(journeyDirection) {
        return this.getServicesForDirection(journeyDirection).last();
    };

    Services.prototype.getEarliestLeavingService = function getEarliestLeavingService(journeyDirection) {
        return this.getServicesForDirection(journeyDirection).first();
    };

    Services.prototype.getAllReturnTravelcards = function getAllReturnTravelcards(trip) {
        return this.getAllReturnFares(trip).filter(function (item) {
            return item.ticketType.isReturnTravelcard();
        });
    };

    Services.prototype.hasDisruptedServices = function hasDisruptedServices() {
        var disruptedServices = this.outward.concat(this.inward).filter(function (service) {
            return service.isDisrupted();
        });
        return !disruptedServices.isEmpty();
    };

    Services.prototype.hasServices = function hasServices() {
        return !!this.outward.concat(this.inward).count();
    };

    Services.prototype.hasServicesInFuture = function hasServicesInFuture() {
        var services = this.outward.concat(this.inward);
        var servicesInFuture = services.filter(function (service) {
            var departureDateTime = service.getDepartureDateTime();
            return departureDateTime && departureDateTime.isAfter(Date.now());
        });
        return !!servicesInFuture.count();
    };

    Services.prototype.hasReturnTravelcards = function hasReturnTravelcards(trip) {
        return !!this.getAllReturnTravelcards(trip).count();
    };

    Services.prototype.hasCollectableServices = function hasCollectableServices(trip) {
        var collectableServices = this.outward.filter(function (service) {
            return trip.isSmartcard() ? service.isCollectableSmartcard() : service.isCollectable();
        });
        return !!collectableServices.count();
    };

    Services.prototype.isEarlierDisabled = function isEarlierDisabled(direction) {
        if (direction === _AppConstants.JourneyDirections.OUTWARD) {
            return false;
        }
        var latestArrivingService = this.getLatestArrivingService(_AppConstants.JourneyDirections.OUTWARD);
        var earliestLeavingService = this.getEarliestLeavingService(_AppConstants.JourneyDirections.INWARD);

        if (!latestArrivingService || !earliestLeavingService) {
            return true;
        }
        //Adding 50 minutes padding to avoid unpredictable JP response
        return latestArrivingService.getArrivalDateTime().add(50, 'minutes').isAfter(earliestLeavingService.getDepartureDateTime());
    };

    Services.prototype.isLaterDisabled = function isLaterDisabled(trip, direction) {
        if (direction === _AppConstants.JourneyDirections.INWARD || !trip.isReturn()) {
            return false;
        }
        var latestArrivingService = this.getLatestArrivingService(_AppConstants.JourneyDirections.OUTWARD);
        var earliestLeavingService = this.getEarliestLeavingService(_AppConstants.JourneyDirections.INWARD);

        if (!latestArrivingService || !earliestLeavingService) {
            return true;
        }

        return latestArrivingService.getArrivalDateTime().isAfter(earliestLeavingService.getDepartureDateTime());
    };

    Services.prototype.getFareById = function getFareById(trip, id, includeFirstClass) {
        if (id) {
            var addFares = this.getAllFares(trip, includeFirstClass);
            return addFares.find(function (fare) {
                return fare.id === id;
            });
        }

        return null;
    };

    return Services;
}((0, _immutable.Record)(defaults));

exports.default = Services;

/***/ }),
/* 601 */,
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(1034));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _desc, _value, _obj;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _JourneyPlanService = __webpack_require__(272);

var _JourneyPlanService2 = _interopRequireDefault(_JourneyPlanService);

var _Loading = __webpack_require__(546);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _PointFlow = __webpack_require__(980);

var _PointFlow2 = _interopRequireDefault(_PointFlow);

var _DisruptionAlertActions = __webpack_require__(340);

var _DisruptionAlertActions2 = _interopRequireDefault(_DisruptionAlertActions);

var _SearchActions = __webpack_require__(426);

var _SearchActions2 = _interopRequireDefault(_SearchActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var withTripLoadingActions = (0, _Loading.createLoadingDecoratorFor)(_AppConstants.LoadingTypes.TRIP);

var TripActions = (_obj = {
    preselectCheapest: function preselectCheapest(cheapestSelection) {
        _AppDispatcher2.default.dispatch({
            cheapestSelection: cheapestSelection,
            actionType: _AppConstants.ActionTypes.PRESELECT_CHEAPEST
        });
    },
    selectInwardService: function selectInwardService(service) {
        _AppDispatcher2.default.dispatch({
            service: service,
            actionType: _AppConstants.ActionTypes.INWARD_SERVICE_SELECTED
        });
    },
    selectOutwardService: function selectOutwardService(service) {
        _AppDispatcher2.default.dispatch({
            service: service,
            actionType: _AppConstants.ActionTypes.OUTWARD_SERVICE_SELECTED
        });
    },
    selectServiceForDirection: function selectServiceForDirection(direction, service) {
        return direction === _AppConstants.JourneyDirections.OUTWARD ? this.selectOutwardService(service) : this.selectInwardService(service);
    },
    selectFareCategory: function selectFareCategory(fareCategory, service, fareClass) {
        _AppDispatcher2.default.dispatch({
            fareCategory: fareCategory,
            service: service,
            fareClass: fareClass,
            actionType: _AppConstants.ActionTypes.FARE_CATEGORY_SELECTED
        });
    },
    selectFare: function selectFare(fare, direction, service, fareCategory, fareClass) {
        _AppDispatcher2.default.dispatch({
            fare: fare,
            direction: direction,
            service: service,
            fareCategory: fareCategory,
            fareClass: fareClass,
            actionType: _AppConstants.ActionTypes.FARE_SELECTED
        });
        return _promise2.default.delay(0); // bluebird
    },
    selectingCheapestFare: function selectingCheapestFare() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SELECTING_CHEAPEST_FARE
        });
    },
    selectingNonCheapestFare: function selectingNonCheapestFare() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SELECTING_NON_CHEAPEST_FARE
        });
    },
    selectFareOnlyFare: function selectFareOnlyFare(fare) {
        _AppDispatcher2.default.dispatch({
            fare: fare,
            actionType: _AppConstants.ActionTypes.FARE_ONLY_SELECTED
        });
        return _promise2.default.delay(0); // bluebird
    },
    updateTrip: function updateTrip(trip) {
        _AppDispatcher2.default.dispatch({
            trip: trip,
            actionType: _AppConstants.ActionTypes.TRIP_UPDATED
        });
    },
    loadPlusBusAvailability: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(trip) {
            var plusBus;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _JourneyPlanService2.default.plusBus(trip);

                        case 2:
                            plusBus = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                trip: trip, plusBus: plusBus,
                                actionType: _AppConstants.ActionTypes.TRIP_PLUSBUS_AVAILABILITY_LOADED
                            });

                            return _context.abrupt('return', plusBus);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadPlusBusAvailability(_x) {
            return _ref.apply(this, arguments);
        }

        return loadPlusBusAvailability;
    }(),
    addTripToBasket: function addTripToBasket(_ref2) {
        var trip = _ref2.trip,
            router = _ref2.router;

        if (trip.raw) {
            _TrackingActions2.default.jpCheckoutWithSuggestedProducts();
        }

        // Clear Journey Planner's cache to force allowance revalidation
        if (trip && trip.isTransPennineStaffRover()) {
            _SearchActions2.default.resetJourneyStore();
        }

        _PointFlow2.default.moveToNext(_AppConstants.GridPages.SERVICES, { trip: trip }, router);
        _DisruptionAlertActions2.default.addTimetableAlert();
    }
}, (_applyDecoratedDescriptor(_obj, 'loadPlusBusAvailability', [withTripLoadingActions], (0, _getOwnPropertyDescriptor2.default)(_obj, 'loadPlusBusAvailability'), _obj)), _obj);

exports.default = TripActions;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _AppConstants = __webpack_require__(6);

var _OpeningHours = __webpack_require__(1697);

var _OpeningHours2 = _interopRequireDefault(_OpeningHours);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    crs: [_LinkMapper.fields.string],
    openingHours: [_LinkMapper.resolve.as(_OpeningHours2.default)]
};

var TicketOffice = function (_record) {
    (0, _inherits3.default)(TicketOffice, _record);

    function TicketOffice() {
        (0, _classCallCheck3.default)(this, TicketOffice);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TicketOffice.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(TicketOffice, json, (0, _Records.getResolvers)(fieldSchema));
    };

    TicketOffice.prototype.getOpenStatus = function getOpenStatus() {
        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _TrainTime2.default)();

        var dayOfWeek = time.format('dddd');
        var todayHours = this.openingHours.get(dayOfWeek.toLowerCase());

        var timeWithinTimeSlot = function timeWithinTimeSlot(t, slot) {
            var openingTime = (0, _TrainTime2.default)(slot.get('startTime'), "HH:mm").day(dayOfWeek);
            var closingTime = (0, _TrainTime2.default)(slot.get('endTime'), "HH:mm").day(dayOfWeek);
            if (closingTime && closingTime.isBefore((0, _TrainTime2.default)(_AppConstants.TicketOfficeHours.CLOSING_CUT_OFF, "HH:mm").day(dayOfWeek))) {
                closingTime = closingTime.add(1, 'day');
            }
            return t.isAfter(openingTime) && t.isBefore(closingTime);
        };

        return todayHours.size ? todayHours.some(function (timeSlot) {
            return timeWithinTimeSlot(time, timeSlot);
        }) ? _AppConstants.TicketOfficeHours.OPEN : _AppConstants.TicketOfficeHours.CLOSED : _AppConstants.TicketOfficeHours.NOT_AVAILABLE;
    };

    TicketOffice.prototype.hasNoHours = function hasNoHours() {
        return !this.openingHours.toList().some(function (day) {
            return day.size;
        });
    };

    TicketOffice.prototype.getOpeningHours = function getOpeningHours() {
        return this.openingHours;
    };

    TicketOffice.prototype.getDailyHours = function getDailyHours(dayOfWeek) {
        return this.getOpeningHours()[dayOfWeek];
    };

    TicketOffice.prototype.getDailyOpeningDuration = function getDailyOpeningDuration(dayOfWeek) {
        var hours = 0;
        this.getDailyHours(dayOfWeek).forEach(function (slot) {
            var openingTime = (0, _TrainTime2.default)(slot.get('startTime'), "HH:mm").day(dayOfWeek);
            var closingTime = (0, _TrainTime2.default)(slot.get('endTime'), "HH:mm").day(dayOfWeek);
            if (closingTime && closingTime.isBefore((0, _TrainTime2.default)(_AppConstants.TicketOfficeHours.CLOSING_CUT_OFF, "HH:mm").day(dayOfWeek))) {
                closingTime = closingTime.add(1, 'day');
            }
            hours += closingTime ? closingTime.calendarDuration(openingTime).asHours() : 0;
        });
        return hours;
    };

    TicketOffice.prototype.isOpenOnBusinessDays = function isOpenOnBusinessDays() {
        var _this2 = this;

        var minHours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;

        var isOpenOnBusinessDays = _AppConstants.BusinessDays.reduce(function (isOpen, dayOfWeek) {
            return isOpen.push(_this2.getDailyOpeningDuration(dayOfWeek) >= minHours);
        }, new _immutable.List());
        return !isOpenOnBusinessDays.contains(false);
    };

    return TicketOffice;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = TicketOffice;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _sum2 = __webpack_require__(1030);

var _sum3 = _interopRequireDefault(_sum2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _Immutable = __webpack_require__(54);

var _CheapestFares = __webpack_require__(540);

var _CheapestFares2 = _interopRequireDefault(_CheapestFares);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    singles: new _immutable.List(),
    returns: new _immutable.List(),
    cheapest: new _immutable.Map()
};

var Fares = function (_record) {
    (0, _inherits3.default)(Fares, _record);

    function Fares() {
        (0, _classCallCheck3.default)(this, Fares);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Fares.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Fares, json, {
            singles: _LinkMapper.resolveAll.as(_Fare2.default),
            returns: _LinkMapper.resolveAll.as(_Fare2.default),
            cheapest: _LinkMapper.resolve.as(_CheapestFares2.default)
        });
    };

    Fares.isStandard = function isStandard(fare) {
        return fare.isStandard();
    };

    Fares.isFirstClass = function isFirstClass(fare) {
        return fare.isFirstClass();
    };

    Fares.isCarnet = function isCarnet(fare) {
        return fare.isCarnet();
    };

    Fares.isOffPeak = function isOffPeak(fare) {
        return fare.isOffPeak();
    };

    Fares.isAdvance = function isAdvance(fare) {
        return fare.isAdvance();
    };

    Fares.isAnytime = function isAnytime(fare) {
        return fare.isAnytime();
    };

    Fares.isSingle = function isSingle(fare) {
        return !fare.isReturn();
    };

    Fares.isReturn = function isReturn(fare) {
        return fare.isReturn();
    };

    Fares.isTravelcard = function isTravelcard(fare) {
        return fare.ticketType.isReturnTravelcard();
    };

    Fares.isSingleOrTravelcard = function isSingleOrTravelcard(fare) {
        return !fare.isReturn() || fare.ticketType.isReturnTravelcard();
    };

    Fares.prototype.getStandard = function getStandard() {
        return new _immutable.Map({
            singles: this.singles.filter(Fares.isStandard).filterNot(Fares.isCarnet),
            returns: this.returns.filter(Fares.isStandard).filterNot(Fares.isCarnet)
        });
    };

    Fares.prototype.getFirstClass = function getFirstClass() {
        return new _immutable.Map({
            singles: this.singles.filter(Fares.isFirstClass).filterNot(Fares.isCarnet),
            returns: this.returns.filter(Fares.isFirstClass).filterNot(Fares.isCarnet)
        });
    };

    Fares.prototype.getCarnets = function getCarnets() {
        return (0, _Immutable.toImmutable)([this.singles, this.returns]).flatten(true).filter(Fares.isCarnet);
    };

    Fares.prototype.getByClass = function getByClass() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.FareClasses.STANDARD] = this.getStandard(), _ref[_AppConstants.FareClasses.FIRST_CLASS] = this.getFirstClass(), _ref[_AppConstants.FareClasses.CARNET] = this.getCarnets(), _ref;
    };

    Fares.getCheapestFromList = function getCheapestFromList(list) {
        return list.sortBy(function (fare) {
            return fare.totalPrice;
        }).first();
    };

    Fares.prototype.getClosestPriceFromFares = function getClosestPriceFromFares(fares, price) {
        var sortedByLowestPrice = fares.sortBy(function (fare) {
            return fare.totalPrice;
        });
        var sortedByHighestPrice = sortedByLowestPrice.reverse();

        var fareWithMatchingOrLowerTicketPrice = sortedByLowestPrice.find(function (fare) {
            return fare.hasMatchingOrLowerTicketPrice(price);
        });
        var fareWithMatchingOrHigherTicketPrice = sortedByHighestPrice.find(function (fare) {
            return fare.hasMatchingOrHigherTicketPrice(price);
        });

        return fareWithMatchingOrLowerTicketPrice || fareWithMatchingOrHigherTicketPrice;
    };

    Fares.prototype.getClosestPriceListFromFares = function getClosestPriceListFromFares(fares, price, ticketType) {
        var sortedByPrice = fares.sortBy(function (fare) {
            return fare.totalPrice;
        });

        var sameTicketType = sortedByPrice.filter(function (fare) {
            return fare.ticketType.code === ticketType;
        });

        var firstClassFares = fares.filter(function (fare) {
            return fare.ticketType.isFirstClass;
        });
        var firstClassFare = this.getClosestPriceFromFares(firstClassFares, price);

        if (sameTicketType.size && firstClassFare) {
            // to avoid displaying 1st class ticket twice if original order is 1st class
            return firstClassFare.ticketType.code === ticketType ? sameTicketType : sameTicketType.push(firstClassFare);
        }

        var standardClassFares = fares.filter(function (fare) {
            return !fare.ticketType.isFirstClass;
        });
        var standardClassFare = this.getClosestPriceFromFares(standardClassFares, price);

        return _immutable.List.of(standardClassFare, firstClassFare).filter(function (f) {
            return f;
        });
    };

    Fares.getCheapestCompatibleWithServiceFromList = function getCheapestCompatibleWithServiceFromList(list, service) {
        var orderedList = list.filter(function (fare) {
            return service.isValidWithFare(fare);
        }).sortBy(function (fare) {
            return fare.totalPrice;
        });

        var first = orderedList.first();

        var cheapestList = orderedList.filter(function (fare) {
            return fare.totalPrice === first.totalPrice;
        });
        if (service.fares.cheapest.return && cheapestList.find(function (fare) {
            return fare.id === service.fares.cheapest.return.id;
        })) {
            return service.fares.cheapest.return;
        }
        return first;
    };

    Fares.prototype.getSingleFares = function getSingleFares() {
        var includeTravelcards = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (includeTravelcards) {
            return this.singles.concat(this.returns.filter(Fares.isTravelcard));
        }
        return this.singles;
    };

    Fares.prototype.getReturnFares = function getReturnFares() {
        return this.returns;
    };

    Fares.prototype.getAllFares = function getAllFares() {
        return this.singles.concat(this.returns);
    };

    Fares.prototype.getCheapestFare = function getCheapestFare() {
        var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var fares = this.getAllFares();
        filters.map(function (filter) {
            if (typeof filter === 'function') {
                fares = fares.filter(filter);
            }
        });

        return Fares.getCheapestFromList(fares);
    };

    Fares.prototype.getMatchingOrClosestFarePrice = function getMatchingOrClosestFarePrice(price) {
        var fares = this.getAllFares();
        var fareWithClosestPrice = this.getClosestPriceFromFares(fares, price);

        return fareWithClosestPrice && fareWithClosestPrice.totalPrice;
    };

    Fares.prototype.getCheapestOutwardSingle = function getCheapestOutwardSingle() {
        return this.getIn(['cheapest', 'outwardSingle']);
    };

    Fares.prototype.getCheapestReturn = function getCheapestReturn() {
        return this.getIn(['cheapest', 'return']);
    };

    Fares.prototype.getCheapestReturnPrice = function getCheapestReturnPrice() {
        return (0, _result3.default)(this.getCheapestReturn(), 'getPrice');
    };

    Fares.prototype.getCheapestSinglesPrice = function getCheapestSinglesPrice() {
        return (0, _sum3.default)([this.getCheapestOutwardSinglePrice(), this.getCheapestInwardSinglePrice()]);
    };

    Fares.prototype.getCheapestOutwardSinglePrice = function getCheapestOutwardSinglePrice() {
        return (0, _result3.default)(this.getCheapestOutwardSingle(), 'getPrice');
    };

    Fares.prototype.getCheapestInwardSingle = function getCheapestInwardSingle() {
        return this.getIn(['cheapest', 'inboundSingle']);
    };

    Fares.prototype.getCheapestInwardSinglePrice = function getCheapestInwardSinglePrice() {
        return (0, _result3.default)(this.getCheapestInwardSingle(), 'getPrice');
    };

    Fares.prototype.getCheapestTotalPrice = function getCheapestTotalPrice() {
        return this.getIn(['cheapest', 'totalPrice']);
    };

    Fares.prototype.getCheapestOutwardAny = function getCheapestOutwardAny() {
        var singlesPrice = this.getCheapestSinglesPrice() || Infinity;
        var returnsPrice = this.getCheapestReturnPrice() || Infinity;

        if (singlesPrice < returnsPrice) {
            return this.getCheapestOutwardSingle();
        }

        return this.getCheapestReturn();
    };

    Fares.prototype.getCheapestForDirection = function getCheapestForDirection(direction) {
        var _JourneyDirections$OU;

        return (_JourneyDirections$OU = {}, _JourneyDirections$OU[_AppConstants.JourneyDirections.OUTWARD] = this.getCheapestOutwardAny, _JourneyDirections$OU[_AppConstants.JourneyDirections.INWARD] = this.getCheapestInwardSingle, _JourneyDirections$OU)[direction].apply(this);
    };

    Fares.prototype.without = function without(fare) {
        if (!fare) {
            return this;
        }
        return this.withMutations(function (fares) {
            return fares.set('singles', (0, _Immutable.without)(fares.get('singles'), fare, 'id')).set('returns', (0, _Immutable.without)(fares.get('returns'), fare, 'id'));
        });
    };

    Fares.prototype.filteredByCategory = function filteredByCategory(category) {
        return this.withMutations(function (fares) {
            return fares.merge({
                singles: fares.singles.filter(function (x) {
                    return x.category === category;
                }),
                returns: fares.returns.filter(function (x) {
                    return x.category === category;
                })
            });
        });
    };

    Fares.prototype.filteredByRoute = function filteredByRoute(route, price, ticketType) {
        var _this2 = this;

        return this.withMutations(function (fares) {
            var singles = fares.singles.filter(function (x) {
                return x.route.code === route.code;
            });
            var returns = fares.returns.filter(function (x) {
                return x.route.code === route.code;
            });
            return fares.merge({
                singles: _this2.getClosestPriceListFromFares(singles, price, ticketType),
                returns: _this2.getClosestPriceListFromFares(returns, price, ticketType)
            });
        });
    };

    Fares.prototype.hasStandard = function hasStandard() {
        return !!this.getStandard().flatten(1).toSet().size;
    };

    Fares.prototype.hasFirstClass = function hasFirstClass() {
        return !!this.getFirstClass().flatten(1).toSet().size;
    };

    return Fares;
}((0, _immutable.Record)(defaults));

exports.default = Fares;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(1965));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _PaymentResponse = __webpack_require__(1770);

var _PaymentResponse2 = _interopRequireDefault(_PaymentResponse);

var _CocsResponse = __webpack_require__(1031);

var _CocsResponse2 = _interopRequireDefault(_CocsResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    cocs: null,
    payments: new _immutable.List()
};

var AuthResponse = function (_record) {
    (0, _inherits3.default)(AuthResponse, _record);

    function AuthResponse() {
        (0, _classCallCheck3.default)(this, AuthResponse);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AuthResponse.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (!json.payments) {
            return new AuthResponse({
                cocs: _CocsResponse2.default.fromJSON(json)
            });
        }

        return (0, _LinkMapper.construct)(AuthResponse, json, {
            payments: _LinkMapper.resolveAll.as(_PaymentResponse2.default)
        });
    };

    AuthResponse.prototype.isSuccess = function isSuccess() {
        if (this.cocs) {
            return this.cocs.isSuccess();
        }
        return this.payments && this.payments.every(function (p) {
            return p.success;
        });
    };

    AuthResponse.prototype.isFraud = function isFraud() {
        if (this.cocs) {
            return this.cocs.isFraud();
        }
        return false;
    };

    AuthResponse.prototype.isEnrolled = function isEnrolled() {
        if (this.cocs) {
            return this.cocs.isEnrolled();
        }
        return false;
    };

    AuthResponse.prototype.isError = function isError() {
        if (this.cocs) {
            return this.cocs.isError();
        }
        return this.payments && this.payments.some(function (p) {
            return !p.success;
        });
    };

    AuthResponse.prototype.isProcessing = function isProcessing() {
        if (this.cocs) {
            return this.cocs.isProcessing();
        }
        return this.payments && this.payments.some(function (p) {
            return p.processing;
        });
    };

    (0, _createClass3.default)(AuthResponse, [{
        key: 'id',
        get: function get() {
            return this.getIn(['cocs', 'id']);
        }
    }, {
        key: 'status',
        get: function get() {
            return this.getIn(['cocs', 'status']);
        }
    }, {
        key: 'code',
        get: function get() {
            return this.getIn(['cocs', 'code']);
        }
    }, {
        key: 'md',
        get: function get() {
            return this.getIn(['cocs', 'md']);
        }
    }, {
        key: 'pareq',
        get: function get() {
            return this.getIn(['cocs', 'pareq']);
        }
    }, {
        key: 'redirect',
        get: function get() {
            return this.getIn(['cocs', 'redirect']);
        }
    }, {
        key: 'message',
        get: function get() {
            return this.getIn(['cocs', 'message']);
        }
    }]);
    return AuthResponse;
}((0, _immutable.Record)(defaults));

exports.default = AuthResponse;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cachedRailcards = new _immutable.Record({
    cards: null,
    types: new _immutable.Map(),
    digitalRailcards: new _immutable.List()
})();

var RailcardsStore = function (_BaseStore) {
    (0, _inherits3.default)(RailcardsStore, _BaseStore);

    function RailcardsStore() {
        (0, _classCallCheck3.default)(this, RailcardsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    RailcardsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.ACCOUNT_RAILCARDS_LOADED] = this.handleAccountRailcardsLoaded, _ref[_AppConstants.ActionTypes.ACCOUNT_RAILCARD_DELETED] = this.handleAccountRailcardDeleted, _ref[_AppConstants.ActionTypes.RAILCARDS_LOADED] = this.handleLoaded, _ref[_AppConstants.ActionTypes.ACCOUNT_DRC_LOADED] = this.handleDRCLoaded, _ref[_AppConstants.ActionTypes.SET_FAVOURITE_DRC] = this.handleSetFavourite, _ref[_AppConstants.ActionTypes.REMOVED_DRC_DEVICE] = this.removeDrcDevice, _ref;
    };

    RailcardsStore.prototype.handleAccountRailcardsLoaded = function handleAccountRailcardsLoaded(_ref2) {
        var accountRailcards = _ref2.accountRailcards;

        this.setState(this.state.set('accountRailcards', accountRailcards).set('accountRailcardsLoaded', true));
    };

    RailcardsStore.prototype.handleAccountRailcardDeleted = function handleAccountRailcardDeleted(_ref3) {
        var accountRailcard = _ref3.accountRailcard;

        var current = this.getAccountRailcards();
        var index = current.indexOf(accountRailcard);
        var accountRailcards = current.delete(index);
        this.handleAccountRailcardsLoaded({ accountRailcards: accountRailcards });
    };

    RailcardsStore.prototype.getAccountRailcards = function getAccountRailcards() {
        return this.state.get('accountRailcards', new _immutable.List());
    };

    RailcardsStore.prototype.getAccountRailcardsLoaded = function getAccountRailcardsLoaded() {
        return this.state.get('accountRailcardsLoaded', false);
    };

    RailcardsStore.prototype.handleDRCLoaded = function handleDRCLoaded(_ref4) {
        var railcards = _ref4.railcards;

        cachedRailcards = cachedRailcards.set('digitalRailcards', new _immutable.List(railcards));
        this.emitChange();
    };

    RailcardsStore.prototype.getFavouriteDRC = function getFavouriteDRC() {
        return cachedRailcards.get('digitalRailcards').filter(function (_ref5) {
            var isFavourite = _ref5.isFavourite;
            return isFavourite;
        }).first();
    };

    RailcardsStore.prototype.handleSetFavourite = function handleSetFavourite(_ref6) {
        var railcardId = _ref6.railcardId;

        var mappedDRC = cachedRailcards.get('digitalRailcards').map(function (drc) {
            drc.isFavourite = drc.id === railcardId ? !drc.isFavourite : false;
            return drc;
        });

        cachedRailcards = cachedRailcards.set('digitalRailcards', mappedDRC);
        this.emitChange();
    };

    RailcardsStore.prototype.getAllDRC = function getAllDRC() {
        return cachedRailcards.get('digitalRailcards');
    };

    RailcardsStore.prototype.getNonPendindDRC = function getNonPendindDRC() {
        return this.getAllDRC().filter(function (_ref7) {
            var state = _ref7.state;
            return state !== _AppConstants.DRCStates.PENDING;
        });
    };

    RailcardsStore.prototype.removeDrcDevice = function removeDrcDevice(_ref8) {
        var railcardId = _ref8.railcardId,
            device1Id = _ref8.device1Id,
            device2Id = _ref8.device2Id;

        var mappedDRC = cachedRailcards.get('digitalRailcards').map(function (drc) {
            if (drc.id === railcardId) {
                if (device1Id) {
                    drc.device1 = null;
                }

                if (device2Id) {
                    drc.device2 = null;
                }
            }

            return drc;
        });

        cachedRailcards = cachedRailcards.set('digitalRailcards', mappedDRC);

        this.emitChange();
    };

    RailcardsStore.prototype.handleLoaded = function handleLoaded(_ref9) {
        var railcards = _ref9.railcards,
            smartcard = _ref9.smartcard;

        var type = smartcard ? 'smartcard' : 'all';
        var cards = railcards.reduce(function (acc, card) {
            return acc.set(card.code, card);
        }, cachedRailcards.cards || new _immutable.Map());

        cachedRailcards = cachedRailcards.set('cards', cards).setIn(['types', type], railcards);
        this.emitChange();
    };

    RailcardsStore.prototype.getAll = function getAll() {
        var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref10$smartcard = _ref10.smartcard,
            smartcard = _ref10$smartcard === undefined ? null : _ref10$smartcard;

        var type = smartcard ? 'smartcard' : 'all';
        return cachedRailcards.getIn(['types', type]);
    };

    RailcardsStore.prototype.getSome = function getSome(_ref11) {
        var smartcard = _ref11.smartcard,
            _ref11$filterOutRailc = _ref11.filterOutRailcards,
            filterOutRailcards = _ref11$filterOutRailc === undefined ? [] : _ref11$filterOutRailc;

        var type = smartcard ? 'smartcard' : 'all';
        var railcards = cachedRailcards.getIn(['types', type]);
        return railcards ? railcards.filter(function (_ref12) {
            var code = _ref12.code;
            return !filterOutRailcards.includes(code);
        }) : null;
    };

    RailcardsStore.prototype.get = function get(code) {
        return cachedRailcards.cards.get(code);
    };

    return RailcardsStore;
}(_BaseStore3.default);

var storeInstance = new RailcardsStore();

exports.default = storeInstance;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ConfirmModal(_ref) {
    var text = _ref.text,
        children = _ref.children,
        show = _ref.show,
        props = (0, _objectWithoutProperties3.default)(_ref, ['text', 'children', 'show']);

    if (!show) {
        return null;
    }

    return _react2.default.createElement(
        _BaseModal2.default,
        (0, _extends3.default)({
            className: 'modal--sm',
            continueText: 'button.text.confirm',
            closeText: 'button.text.cancel'
        }, props),
        _react2.default.createElement(
            'div',
            { className: 'vertical-align-parent full-height' },
            _react2.default.createElement(
                _BAlert2.default,
                { type: _BAlert.bAlertType.WARNING, className: 'padding-top' },
                _react2.default.createElement(
                    'span',
                    { className: 'confirm-modal__wrapper text-weight--normal' },
                    _react2.default.createElement(_Icon2.default, { icon: 'error' }),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: 'confirm-modal__text' },
                        text
                    )
                )
            ),
            children
        )
    );
}

ConfirmModal.propTypes = {
    text: _propTypes2.default.any.isRequired,
    children: _propTypes2.default.any,
    show: _propTypes2.default.bool
};

ConfirmModal.defaultProps = {
    show: false,
    titleText: 'confirmation.prompt'
};

exports.default = ConfirmModal;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _immutable = __webpack_require__(5);

var _Services = __webpack_require__(600);

var _Services2 = _interopRequireDefault(_Services);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toJson(search) {
    return (0, _stringify2.default)(search.serialize());
}

var defaultState = new _immutable.Map({
    services: new _Services2.default(),
    fares: new _immutable.List(),
    loading: false
});

var JourneyStore = function (_BaseStore) {
    (0, _inherits3.default)(JourneyStore, _BaseStore);

    function JourneyStore() {
        (0, _classCallCheck3.default)(this, JourneyStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    JourneyStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return new _immutable.Map({
                searchJsonString: serialized.searchJsonString,
                services: (0, _LinkMapper.resolve)(serialized.services).as(_Services2.default),
                fares: (0, _LinkMapper.resolveAll)(serialized.fares).as(_Fare2.default),
                loading: false
            });
        }

        return defaultState;
    };

    JourneyStore.prototype.getJourneys = function getJourneys() {
        return this.state.get('journeys', new _immutable.Map());
    };

    JourneyStore.prototype.getJourney = function getJourney() {
        return this.state;
    };

    JourneyStore.prototype.isCurrentSearch = function isCurrentSearch(search) {
        if (search.promoCode && search.promoCode.promoCode) {
            // prevent applying the same promo code twice
            return false;
        }
        return _toJson(search) === this.state.get('searchJsonString');
    };

    JourneyStore.prototype.handleSearchStarted = function handleSearchStarted(_ref) {
        var search = _ref.search;

        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            loading: true
        }));
    };

    JourneyStore.prototype.handleSearchFinished = function handleSearchFinished(_ref2) {
        var outward = _ref2.outward,
            inward = _ref2.inward,
            search = _ref2.search;

        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            services: new _Services2.default({ outward: outward, inward: inward }).orderForSearch(search),
            loading: false
        }));
    };

    JourneyStore.prototype.handleFareOnlySearchFinished = function handleFareOnlySearchFinished(_ref3) {
        var search = _ref3.search,
            fares = _ref3.fares;

        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            fares: fares,
            loading: false
        }));
    };

    JourneyStore.prototype.handleSearchUpdated = function handleSearchUpdated(_ref4) {
        var result = _ref4.result,
            search = _ref4.search;

        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            services: new _Services2.default({
                outward: result.outward,
                inward: result.inward
            }).orderForSearch(search),
            loading: false
        }));
    };

    JourneyStore.prototype.resetJourneyStore = function resetJourneyStore() {
        this.setState(defaultState);
    };

    JourneyStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref5;

        return _ref5 = {}, _ref5[_AppConstants.ActionTypes.SEARCH_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.SEARCH_FINISHED] = this.handleSearchFinished, _ref5[_AppConstants.ActionTypes.FARE_ONLY_SEARCH_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.FARE_ONLY_SEARCH_FINISHED] = this.handleFareOnlySearchFinished, _ref5[_AppConstants.ActionTypes.SHOW_EARLIER_TRAINS_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.SHOW_EARLIER_TRAINS_FINISHED] = this.handleSearchUpdated, _ref5[_AppConstants.ActionTypes.SHOW_LATER_TRAINS_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.SHOW_LATER_TRAINS_FINISHED] = this.handleSearchUpdated, _ref5[_AppConstants.ActionTypes.AMEND_SEARCH_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.AMEND_SEARCH_FINISHED] = this.handleSearchFinished, _ref5[_AppConstants.ActionTypes.AMEND_SHOW_EARLIER_TRAINS_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.AMEND_SHOW_EARLIER_TRAINS_FINISHED] = this.handleSearchUpdated, _ref5[_AppConstants.ActionTypes.AMEND_SHOW_LATER_TRAINS_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.AMEND_SHOW_LATER_TRAINS_FINISHED] = this.handleSearchUpdated, _ref5[_AppConstants.ActionTypes.RESET_JOURNEY_STORE] = this.resetJourneyStore, _ref5;
    };

    return JourneyStore;
}(_BaseStore3.default);

var instance = new JourneyStore({ storageKey: 'journeys' });

exports.default = instance;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: _propTypes.default.string,
  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null])
};
var childContextTypes = {
  $bs_formGroup: _propTypes.default.object.isRequired
};

var FormGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FormGroup, _React$Component);

  function FormGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        controlId = _this$props.controlId,
        validationState = _this$props.validationState;
    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  _proto.hasFeedback = function hasFeedback(children) {
    var _this = this;

    return _ValidComponentChildren.default.some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        validationState = _this$props2.validationState,
        className = _this$props2.className,
        children = _this$props2.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["validationState", "className", "children"]);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), children);
  };

  return FormGroup;
}(_react.default.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;

var _default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var compose = function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  }, function (arg) {
    return arg;
  });
};

var _default = compose;
exports.default = _default;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FormComponent2 = __webpack_require__(417);

var _FormComponent3 = _interopRequireDefault(_FormComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormWrapper = (_temp2 = _class = function (_FormComponent) {
    (0, _inherits3.default)(FormWrapper, _FormComponent);

    function FormWrapper() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FormWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _FormComponent.call.apply(_FormComponent, [this].concat(args))), _this), _this.state = {
            submitted: _this.props.submitted
        }, _this._formRef = null, _this.captureFormRef = function (element) {
            _this._formRef = element;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    FormWrapper.prototype.UNSAFE_componentWillUpdate = function UNSAFE_componentWillUpdate(_ref) {
        var submitted = _ref.submitted;

        if (submitted !== this.state.submitted) {
            this.setState({ submitted: submitted });
        }
    };

    FormWrapper.prototype.render = function render() {
        return _react2.default.createElement(
            'div',
            { className: this.props.className, ref: this.captureFormRef },
            this.props.children
        );
    };

    return FormWrapper;
}(_FormComponent3.default), _class.propTypes = {
    submitted: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    children: _propTypes2.default.any
}, _class.defaultProps = {
    submitted: false,
    className: ''
}, _temp2);
exports.default = FormWrapper;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AddFavouriteLink = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AppConstants = __webpack_require__(6);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _Fare3 = __webpack_require__(98);

var _Fare4 = _interopRequireDefault(_Fare3);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _Fulfilment = __webpack_require__(349);

var _Fulfilment2 = _interopRequireDefault(_Fulfilment);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _FavouritesStore = __webpack_require__(271);

var _FavouritesStore2 = _interopRequireDefault(_FavouritesStore);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _FavouritesActions = __webpack_require__(422);

var _FavouritesActions2 = _interopRequireDefault(_FavouritesActions);

var _Favourite3 = __webpack_require__(917);

var _FavouriteButton = __webpack_require__(998);

var _FavouriteButton2 = _interopRequireDefault(_FavouriteButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddFavouriteLink = exports.AddFavouriteLink = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(AddFavouriteLink, _React$PureComponent);

    function AddFavouriteLink() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AddFavouriteLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            loading: false
        }, _this._toggleFavourite = function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
                var _this$props, fare, orderTrip, delivery, user, favourite, context;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this$props = _this.props, fare = _this$props.fare, orderTrip = _this$props.orderTrip, delivery = _this$props.delivery, user = _this$props.user, favourite = _this$props.favourite, context = _this$props.context;


                                _this.setState({ loading: true });

                                if (_this.props.preventClickPropagation) {
                                    event.stopPropagation();
                                }

                                _context.prev = 3;

                                if (favourite) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 7;
                                return _FavouritesActions2.default.add(fare, orderTrip, delivery, user, context);

                            case 7:
                                _context.next = 11;
                                break;

                            case 9:
                                _context.next = 11;
                                return _FavouritesActions2.default.remove(favourite, user, context);

                            case 11:
                                _context.next = 20;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](3);

                                if (!(_context.t0 instanceof _Favourite3.FavouritesLimitExceededError)) {
                                    _context.next = 19;
                                    break;
                                }

                                _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, {
                                    title: 'favourites.error.limit.title',
                                    message: 'favourites.error.limit.message'
                                });
                                _context.next = 20;
                                break;

                            case 19:
                                throw _context.t0;

                            case 20:
                                _context.prev = 20;

                                _this.setState({ loading: false });
                                return _context.finish(20);

                            case 23:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[3, 13, 20, 23]]);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    AddFavouriteLink.prototype.render = function render() {
        var _props = this.props,
            buttonProps = _props.buttonProps,
            fare = _props.fare,
            favourite = _props.favourite,
            delivery = _props.delivery,
            smartcard = _props.smartcard,
            enabled = _props.enabled,
            user = _props.user;
        var loading = this.state.loading;

        // Check if fare is reorderable, if add to favourites is enabled and if user is logged in

        if (!fare.isReorderable() || !enabled || !user.isLoggedIn()) {
            return null;
        }

        // Check ticket delivery method is smartcard and if user has a valid smartcard
        if (delivery.isSmartcard() && !smartcard) {
            return null;
        }

        return _react2.default.createElement(_FavouriteButton2.default, (0, _extends3.default)({}, buttonProps, {
            favourite: favourite,
            loading: loading,
            onClick: this._toggleFavourite
        }));
    };

    return AddFavouriteLink;
}(_react2.default.PureComponent), _class.propTypes = {
    buttonProps: _propTypes2.default.object,
    fare: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Fare4.default).isRequired, _propTypes2.default.instanceOf(_Fare2.default).isRequired]),
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    delivery: _propTypes2.default.instanceOf(_Fulfilment2.default).isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    favourite: _propTypes2.default.instanceOf(_Favourite2.default),
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    context: _propTypes2.default.string,
    preventClickPropagation: _propTypes2.default.bool
}, _class.defaultProps = {
    favourite: null,
    smartcard: null,
    enabled: false,
    context: ''
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FavouritesStore2.default, _UserStore2.default, _SmartcardStore2.default, _FeatureFlagStore2.default], function (props) {
    return {
        favourite: _FavouritesStore2.default.getFavourite(props.fare, props.orderTrip),
        smartcard: _SmartcardStore2.default.getCurrent(),
        user: _UserStore2.default.getCurrent(),
        enabled: _FeatureFlagStore2.default.get('enableFavouriteTickets') && _FeatureFlagStore2.default.get('enableFavouriteTicketChanges')
    };
})(AddFavouriteLink);

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(203),
    createWrap = __webpack_require__(1092),
    getHolder = __webpack_require__(518),
    replaceHolders = __webpack_require__(389);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _flatten2 = __webpack_require__(453);

var _flatten3 = _interopRequireDefault(_flatten2);

var _reduce2 = __webpack_require__(219);

var _reduce3 = _interopRequireDefault(_reduce2);

var _immutable = __webpack_require__(5);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _StationStop = __webpack_require__(441);

var _StationStop2 = _interopRequireDefault(_StationStop);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CallingPoints = new _immutable.Record({
    id: null,
    route: new _immutable.Map()
});

(0, _assign2.default)(CallingPoints.prototype, {
    getOrigin: function getOrigin() {
        return this.route.first().first();
    },
    getDestination: function getDestination() {
        return this.route.last().last();
    },
    getTrainOrigin: function getTrainOrigin(leg) {
        return this.getIn(['route', leg.id], new _immutable.List()).first();
    },
    getTrainDestination: function getTrainDestination(leg) {
        return this.getIn(['route', leg.id], new _immutable.List()).last();
    },
    getTrainOriginStation: function getTrainOriginStation(leg) {
        var first = this.getTrainOrigin(leg);
        return first && first.station || new _Station2.default();
    },
    getTrainDestinationStation: function getTrainDestinationStation(leg) {
        var last = this.getTrainDestination(leg);
        return last && last.station || new _Station2.default();
    },
    getLeg: function getLeg(leg) {
        return this.getLegUnfiltered(leg).filter(function (stop) {
            return stop.station.latitude && stop.station.longitude;
        });
    },
    getLegUnfiltered: function getLegUnfiltered(leg) {
        if (!leg || !this.route.get(leg.id)) {
            return new _immutable.List();
        }
        return this.route.get(leg.id).skipUntil(function (stop) {
            if (stop.time && leg.origin.first().time) {
                return stop.time.adjustedTime.isSame(leg.origin.first().time.adjustedTime);
            } else {
                return stop;
            }
        }).skipUntil(function (stop) {
            return stop.station.nlc === leg.origin.first().station.nlc;
        }).reverse().skipUntil(function (stop) {
            return stop.station.nlc === leg.destination.first().station.nlc;
        }).reverse();
    },
    getLegOrigin: function getLegOrigin(leg) {
        var callingPoint = this.getLegUnfiltered(leg).first();
        return callingPoint && callingPoint.station;
    },
    getLegDestination: function getLegDestination(leg) {
        var callingPoint = this.getLegUnfiltered(leg).last();
        return callingPoint && callingPoint.station;
    },
    getLegStops: function getLegStops(leg) {
        return this.getLegUnfiltered(leg).filter(function (stop) {
            return stop.pattern !== _AppConstants.StopPatterns.PASSING;
        });
    },
    getLegStations: function getLegStations(leg) {
        return this.getLeg(leg).map(function (stop) {
            return stop.station;
        });
    },
    getLegStationStops: function getLegStationStops(leg) {
        return this.getLegStops(leg).map(function (stop) {
            return stop.station;
        });
    }
});

CallingPoints.fromJSON = function (json) {
    json = json || {};

    var callingPoints = (0, _reduce3.default)(json, function (acc, leg, id) {
        acc[id] = (0, _LinkMapper.resolveAll)((0, _flatten3.default)(leg)).as(_StationStop2.default);
        return acc;
    }, {});

    // We need the route part, since response is not
    // record friendly - potentially infinite possible keys
    var result = { route: new _immutable.Map(callingPoints) };

    return new CallingPoints(result);
};

exports.default = CallingPoints;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _truncate2 = __webpack_require__(1073);

var _truncate3 = _interopRequireDefault(_truncate2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TicketDescription = function TicketDescription(_ref) {
    var fare = _ref.fare;

    var key = 'tickettype.' + fare.ticketType.code;
    return (0, _I18n.hasMessage)(key) && _react2.default.createElement(
        'li',
        null,
        (0, _I18n2.default)(key)
    );
};

var TicketRestrictions = function TicketRestrictions(_ref2) {
    var fare = _ref2.fare;

    return fare.getDescription() ? _react2.default.createElement(
        'li',
        null,
        (0, _truncate3.default)(fare.getDescription(), { length: 100 })
    ) : null;
};

TicketRestrictions.propTypes = {
    fare: _propTypes2.default.instanceOf(_Fare2.default).isRequired
};

var FareRestrictions = function FareRestrictions(_ref3) {
    var fare = _ref3.fare,
        _ref3$useBootstrap = _ref3.useBootstrap,
        useBootstrap = _ref3$useBootstrap === undefined ? false : _ref3$useBootstrap;

    var restrictions = [_react2.default.createElement(
        'div',
        { key: 0, className: 'fare-restrictions__item' },
        _react2.default.createElement(TicketDescription, { fare: fare }),
        _react2.default.createElement(TicketRestrictions, { fare: fare })
    )];

    if (fare.isGroupSave()) {
        restrictions.push(_react2.default.createElement(
            'div',
            { key: restrictions.length, className: 'fare-restrictions__item' },
            (0, _I18n2.default)('order.summary.groupSave.text'),
            '\xA0',
            _react2.default.createElement(
                'a',
                { className: (0, _classnames2.default)({ 'text-sm': useBootstrap }), target: '_blank', href: _config2.default.get('groupSaveDetailsUrl') },
                (0, _I18n2.default)('order.summary.groupSave.link'),
                ' ',
                _react2.default.createElement(_Icon2.default, { icon: 'externallink', className: 'otrl-inline' })
            )
        ));
    }

    if (fare.isCarnet()) {
        restrictions.push(_react2.default.createElement(
            'div',
            { key: restrictions.length, className: 'fare-restrictions__item' },
            fare.getCarnetInformation().text
        ));
    }

    // TODO: Order refunding and changing your ticket...
    return useBootstrap ? restrictions : _react2.default.createElement(
        'div',
        { className: 'fare-restrictions' },
        restrictions
    );
};

FareRestrictions.propTypes = {
    fare: _propTypes2.default.instanceOf(_Fare2.default).isRequired,
    useBootstrap: _propTypes2.default.bool
};

FareRestrictions.defaultProps = {
    useBootstrap: false
};

exports.default = FareRestrictions;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CustomerAddress(_ref) {
    var className = _ref.className,
        address = _ref.address,
        includeContactName = _ref.includeContactName;

    return _react2.default.createElement(
        'address',
        { className: className },
        address.asList(includeContactName).map(function (line, key) {
            return _react2.default.createElement(
                'span',
                { key: key },
                line,
                _react2.default.createElement('br', null)
            );
        })
    );
}

CustomerAddress.propTypes = {
    address: _propTypes2.default.instanceOf(_Address2.default).isRequired,
    className: _propTypes2.default.string,
    includeContactName: _propTypes2.default.bool
};

CustomerAddress.defaultProps = {
    includeContactName: true
};

exports.default = CustomerAddress;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(537);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _map2 = __webpack_require__(314);

var _map3 = _interopRequireDefault(_map2);

var _immutable = __webpack_require__(5);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _Railcard = __webpack_require__(241);

var _Railcard2 = _interopRequireDefault(_Railcard);

var _AccountRailcard = __webpack_require__(437);

var _AccountRailcard2 = _interopRequireDefault(_AccountRailcard);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataUrl = '/data/railcards';
var railcardCache = {};

var RailcardsService = {
    getBaseUrl: function getBaseUrl(user) {
        return '/customers/' + user.id;
    },
    getRailcardCodesQuery: function getRailcardCodesQuery(filterRailcardCodes) {
        return filterRailcardCodes.length ? '&railcardCode=' + filterRailcardCodes.join('&railcardCode=') : '';
    },
    get: function get(code) {
        if (railcardCache[code]) {
            return railcardCache[code];
        }

        railcardCache[code] = _APIClient2.default.get(dataUrl + '/' + code).then(function (response) {
            if (response.result) {
                return (0, _LinkMapper.resolve)((0, _extends3.default)({}, response.result, { id: dataUrl + '/' + code })).as(_Railcard2.default);
            }
            return new _Railcard2.default();
        }).catch(function (error) {
            if (error instanceof _APIClient.NotFoundError) {
                return new _Railcard2.default();
            }
            delete railcardCache[code];
            throw error;
        });

        return railcardCache[code];
    },
    getAll: function getAll(options) {
        return _APIClient2.default.get('/config/railcards', options).then(function (response) {
            var railcards = (0, _map3.default)(response.result, 'railcard');
            if (!_FeatureFlagStore2.default.get('enableRailcardVeterans')) {
                return (0, _LinkMapper.resolveAll)(railcards).as(_Railcard2.default).filter(function (railcard) {
                    return railcard.get("code") !== "VET";
                });
            } else {
                return (0, _LinkMapper.resolveAll)(railcards).as(_Railcard2.default);
            }
        });
    },
    getAccountDRC: function getAccountDRC(userId) {
        return _AuthenticatedAPIClient2.default.get('/digital-railcards/' + userId + '/railcards');
    },
    setFavouriteDRC: function setFavouriteDRC(userId, railcardId) {
        return _AuthenticatedAPIClient2.default.put('/digital-railcards/' + userId + '/railcards/' + railcardId + '/favourite');
    },
    removeDRCDevice: function removeDRCDevice(userId, railcardId, body) {
        return _AuthenticatedAPIClient2.default.delete('/digital-railcards/' + userId + '/railcards/' + railcardId + '/device', body);
    },
    getAccountRailcards: function getAccountRailcards(user) {
        var filterRailcardCodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        return _AuthenticatedAPIClient2.default.get(this.getBaseUrl(user) + '/railcards?state=ACCEPTED&state=PENDING' + this.getRailcardCodesQuery(filterRailcardCodes)).then(function (response) {
            var railcards = response.result.map(function (railcard) {
                return (0, _extends3.default)({}, railcard, {
                    railcardName: response.links[railcard.railcardCode].name
                });
            });
            return (0, _LinkMapper.resolveAll)(railcards).as(_AccountRailcard2.default);
        }).catch(function () {
            return new _immutable.List();
        });
    },
    seenApprovedRailcards: function seenApprovedRailcards(user, accountRailcardsIds) {
        return _AuthenticatedAPIClient2.default.put(this.getBaseUrl(user) + '/railcards', { railcards: accountRailcardsIds });
    },
    seenSyncKeyGoNotification: function seenSyncKeyGoNotification(user, accountRailcardsIds) {
        return _AuthenticatedAPIClient2.default.put(this.getBaseUrl(user) + '/season-railcards', { railcards: accountRailcardsIds });
    },
    submitRailcardApplication: function submitRailcardApplication(user, data, files) {
        return _AuthenticatedAPIClient2.default.postForm(this.getBaseUrl(user) + '/railcards', data, files);
    },
    deleteAccountRailcard: function deleteAccountRailcard(user, railcard) {
        return _AuthenticatedAPIClient2.default.delete(this.getBaseUrl(user) + '/railcards/' + railcard.id);
    }
};

exports.default = RailcardsService;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PreviousSearchesStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _forEach2 = __webpack_require__(522);

var _forEach3 = _interopRequireDefault(_forEach2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _DaySaveSearch = __webpack_require__(420);

var _DaySaveSearch2 = _interopRequireDefault(_DaySaveSearch);

var _RoversRangersSearch = __webpack_require__(595);

var _RoversRangersSearch2 = _interopRequireDefault(_RoversRangersSearch);

var _SmartCarnetRecordSearch = __webpack_require__(436);

var _SmartCarnetRecordSearch2 = _interopRequireDefault(_SmartCarnetRecordSearch);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchTypes = new _immutable.Map({
    'point': _Search2.default,
    'season': _SeasonSearch2.default,
    'daySave': _DaySaveSearch2.default,
    'roversRangers': _RoversRangersSearch2.default,
    'smartCarnet': _SmartCarnetRecordSearch2.default
});

function _getDefaultState() {
    return searchTypes.map(function (Type) {
        return new Type();
    });
}

var PreviousSearchesStore = exports.PreviousSearchesStore = function (_BaseStore) {
    (0, _inherits3.default)(PreviousSearchesStore, _BaseStore);

    function PreviousSearchesStore() {
        (0, _classCallCheck3.default)(this, PreviousSearchesStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    PreviousSearchesStore.prototype.deserialize = function deserialize(serialized) {
        var state = _getDefaultState();

        if (serialized) {
            (0, _forEach3.default)(serialized, function (value, key) {
                if (state.has(key)) {
                    var SearchClass = searchTypes.get(key);
                    state = state.set(key, SearchClass.fromJSON(value));
                }
            });
        }

        return state;
    };

    PreviousSearchesStore.prototype.get = function get(type) {
        var SearchClass = searchTypes.get(type);
        return this.state.get(type, new SearchClass());
    };

    PreviousSearchesStore.prototype.handleNewSearch = function handleNewSearch(type, search) {
        this.setState(this.state.set(type, search));
    };

    PreviousSearchesStore.prototype.handleNewPointSearch = function handleNewPointSearch(_ref) {
        var search = _ref.search;

        this.handleNewSearch('point', search.set('submitted', true));
    };

    PreviousSearchesStore.prototype.handleNewSeasonSearch = function handleNewSeasonSearch(_ref2) {
        var search = _ref2.search;

        this.handleNewSearch('season', search.set('submitted', true));
    };

    PreviousSearchesStore.prototype.handleNewDaySaveSearch = function handleNewDaySaveSearch(_ref3) {
        var search = _ref3.search;

        this.handleNewSearch('daySave', search);
    };

    PreviousSearchesStore.prototype.handleNewRoversRangersSearch = function handleNewRoversRangersSearch(_ref4) {
        var search = _ref4.search;

        this.handleNewSearch('roversRangers', search);
    };

    PreviousSearchesStore.prototype.handleNewSmartCarnetSearch = function handleNewSmartCarnetSearch(_ref5) {
        var search = _ref5.search;

        this.handleNewSearch('smartCarnet', search);
    };

    PreviousSearchesStore.prototype.handleLoggedOut = function handleLoggedOut() {
        this.setState(new _immutable.Map({
            point: new _Search2.default(),
            season: new _SeasonSearch2.default(),
            daySave: new _DaySaveSearch2.default(),
            roversRangers: new _RoversRangersSearch2.default()
        }));
    };

    PreviousSearchesStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref6;

        return _ref6 = {}, _ref6[_AppConstants.ActionTypes.SEARCH_FAILED] = this.handleNewPointSearch, _ref6[_AppConstants.ActionTypes.SEARCH_STARTED] = this.handleNewPointSearch, _ref6[_AppConstants.ActionTypes.SEARCH_LOADED] = this.handleNewPointSearch, _ref6[_AppConstants.ActionTypes.SEARCH_UPDATED] = this.handleNewPointSearch, _ref6[_AppConstants.ActionTypes.SEASON_SEARCH_STARTED] = this.handleNewSeasonSearch, _ref6[_AppConstants.ActionTypes.SEASON_SEARCH_LOADED] = this.handleNewSeasonSearch, _ref6[_AppConstants.ActionTypes.SEASON_SEARCH_FAILED] = this.handleNewSeasonSearch, _ref6[_AppConstants.ActionTypes.SEASON_SEARCH_UPDATED] = this.handleNewSeasonSearch, _ref6[_AppConstants.ActionTypes.DAYSAVE_SEARCH_LOADED] = this.handleNewDaySaveSearch, _ref6[_AppConstants.ActionTypes.DAYSAVE_SEARCH_STARTED] = this.handleNewDaySaveSearch, _ref6[_AppConstants.ActionTypes.DAYSAVE_SEARCH_FAILED] = this.handleNewDaySaveSearch, _ref6[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_LOADED] = this.handleNewRoversRangersSearch, _ref6[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_STARTED] = this.handleNewRoversRangersSearch, _ref6[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_FAILED] = this.handleNewRoversRangersSearch, _ref6[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_LOADED] = this.handleNewSmartCarnetSearch, _ref6[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_STARTED] = this.handleNewSmartCarnetSearch, _ref6[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_FAILED] = this.handleNewSmartCarnetSearch, _ref6[_AppConstants.ActionTypes.FARE_ONLY_SEARCH_STARTED] = this.handleNewPointSearch, _ref6[_AppConstants.ActionTypes.FARE_ONLY_SEARCH_FAILED] = this.handleNewPointSearch, _ref6[_AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED] = this.handleNewSeasonSearch, _ref6[_AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_FAILED] = this.handleNewSeasonSearch, _ref6[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleLoggedOut, _ref6;
    };

    return PreviousSearchesStore;
}(_BaseStore3.default);

var instance = new PreviousSearchesStore({ storageKey: 'previous-searches' });

exports.default = instance;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _callingPointsStore = new _immutable.Map();

var CallingPointsStore = function (_BaseStore) {
    (0, _inherits3.default)(CallingPointsStore, _BaseStore);

    function CallingPointsStore() {
        (0, _classCallCheck3.default)(this, CallingPointsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    CallingPointsStore.prototype.get = function get(service) {
        var key = service.journey.callingPoints;
        return _callingPointsStore.get(key);
    };

    CallingPointsStore.prototype.handleLoaded = function handleLoaded(_ref) {
        var key = _ref.key,
            callingPoints = _ref.callingPoints;

        _callingPointsStore = _callingPointsStore.set(key, callingPoints);
        this.emitChange();
    };

    CallingPointsStore.prototype.handleLoadFailed = function handleLoadFailed(_ref2) {
        var key = _ref2.key;

        this.handleLoaded({ key: key, callingPoints: null });
    };

    CallingPointsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.CALLING_POINTS_LOADED] = this.handleLoaded, _ref3[_AppConstants.ActionTypes.CALLING_POINTS_LOAD_FAILED] = this.handleLoadFailed, _ref3;
    };

    return CallingPointsStore;
}(_BaseStore3.default);

var storeInstance = new CallingPointsStore();

exports.default = storeInstance;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(119),
    upperFirst = __webpack_require__(831);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useFeatureFlag = useFeatureFlag;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _hookUtils = __webpack_require__(234);

var _hookUtils2 = _interopRequireDefault(_hookUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _hookUtils2.default)(useFeatureFlag, 'useFeatureFlag');

/**
 * Hook to retrieve value (or values) of feature flags
 *
 * If you ask for a single flag, it will return the value
 * If you ask for an array of flags, it will return an object populated with the values of the flags
 * If you pass a function, it will return the value from the function (passed the FeatureFlagStore)
 *
 * @param {String|String[]|Function} - Which flag or flags to fetch
 */

function useFeatureFlag(flag) {
    var lookup = _react2.default.useMemo(function () {
        if (Array.isArray(flag)) {
            // connect to store, and populate an object with the values of all the flags
            return function (store) {
                var values = {};
                flag.forEach(function (f) {
                    values[f] = store.get(f);
                });
                return values;
            };
        } else {
            // pass the stateLookup directly to useStoreState
            return flag;
        }
    }, [flag]);
    return (0, _useStoreState2.default)(_FeatureFlagStore2.default, lookup);
}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InteropError = exports.NotEnoughAvailabilityError = exports.TooManyTicketsError = exports.InvalidOrderStateError = exports.OrderError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.throwCorrectOrderError = throwCorrectOrderError;

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

var _API = __webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderError = exports.OrderError = function (_ExtendableError) {
    (0, _inherits3.default)(OrderError, _ExtendableError);

    function OrderError() {
        (0, _classCallCheck3.default)(this, OrderError);
        return (0, _possibleConstructorReturn3.default)(this, _ExtendableError.apply(this, arguments));
    }

    return OrderError;
}(_ExtendableError3.default);

var InvalidOrderStateError = exports.InvalidOrderStateError = function (_OrderError) {
    (0, _inherits3.default)(InvalidOrderStateError, _OrderError);

    function InvalidOrderStateError() {
        (0, _classCallCheck3.default)(this, InvalidOrderStateError);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, _OrderError.call(this, 'Invalid order state'));

        _this2.name = "InvalidOrderStateError";
        return _this2;
    }

    return InvalidOrderStateError;
}(OrderError);

var TooManyTicketsError = exports.TooManyTicketsError = function (_OrderError2) {
    (0, _inherits3.default)(TooManyTicketsError, _OrderError2);

    function TooManyTicketsError() {
        var _temp, _this3, _ret;

        (0, _classCallCheck3.default)(this, TooManyTicketsError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this3 = (0, _possibleConstructorReturn3.default)(this, _OrderError2.call.apply(_OrderError2, [this].concat(args))), _this3), _this3.message = 'Cannot add more tickets to basket', _this3.name = 'TooManyTicketsError', _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
    }

    return TooManyTicketsError;
}(OrderError);

var NotEnoughAvailabilityError = exports.NotEnoughAvailabilityError = function (_OrderError3) {
    (0, _inherits3.default)(NotEnoughAvailabilityError, _OrderError3);

    function NotEnoughAvailabilityError() {
        var _temp2, _this4, _ret2;

        (0, _classCallCheck3.default)(this, NotEnoughAvailabilityError);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this4 = (0, _possibleConstructorReturn3.default)(this, _OrderError3.call.apply(_OrderError3, [this].concat(args))), _this4), _this4.message = 'No availability for requested product.', _this4.name = 'NotEnoughAvailabilityError', _temp2), (0, _possibleConstructorReturn3.default)(_this4, _ret2);
    }

    return NotEnoughAvailabilityError;
}(OrderError);

var InteropError = exports.InteropError = function (_OrderError4) {
    (0, _inherits3.default)(InteropError, _OrderError4);

    function InteropError() {
        var _temp3, _this5, _ret3;

        (0, _classCallCheck3.default)(this, InteropError);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this5 = (0, _possibleConstructorReturn3.default)(this, _OrderError4.call.apply(_OrderError4, [this].concat(args))), _this5), _this5.message = 'This fare is not available for this train operator', _this5.name = 'InteropError', _temp3), (0, _possibleConstructorReturn3.default)(_this5, _ret3);
    }

    return InteropError;
}(OrderError);

function throwCorrectOrderError(error) {
    if (error instanceof _API.ApiError) {
        switch (true) {
            case error.hasCode(6002):
                throw new InvalidOrderStateError();
            case error.hasCode(7001):
                throw new TooManyTicketsError();
            case error.hasCode(12000):
                throw new NotEnoughAvailabilityError();
        }
    }

    throw error;
}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(521);
var dasherize = __webpack_require__(2080);
var cleanDiacritics = __webpack_require__(2081);

module.exports = function slugify(str) {
  return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(794),
    baseRest = __webpack_require__(203),
    toNumber = __webpack_require__(312);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _slugify = __webpack_require__(626);

var _slugify2 = _interopRequireDefault(_slugify);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _StoredPaymentCard = __webpack_require__(433);

var _StoredPaymentCard2 = _interopRequireDefault(_StoredPaymentCard);

var _CardPayment = __webpack_require__(665);

var _CardPayment2 = _interopRequireDefault(_CardPayment);

var _HostedCardPayment = __webpack_require__(820);

var _HostedCardPayment2 = _interopRequireDefault(_HostedCardPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaymentCardDetails(_ref) {
    var card = _ref.card,
        className = _ref.className,
        highDefinition = _ref.highDefinition,
        showExpires = _ref.showExpires,
        mask = _ref.mask;
    var pan = card.pan,
        expiryDate = card.expiryDate,
        cardArtUrl = card.cardArtUrl;

    var cardType = card.cardType || '';

    var cardTypeSlug = (0, _slugify2.default)(cardType.toLowerCase());

    var highDefArtUrl = ['mc-credit', 'mc-debit', 'visa-credit', 'visa-debit', 'amex'].includes(cardTypeSlug);

    var cardClassNames = (0, _classnames2.default)(!highDefinition ? 'pan' : 'pan-hd', !cardArtUrl && !highDefinition ? 'card-' + cardTypeSlug : '', className);
    var visaCheckoutCardArt = _react2.default.createElement('img', { className: 'visacheckout-cart-art', src: cardArtUrl, alt: cardType });
    var highDefImageArt = highDefArtUrl ? _react2.default.createElement('img', { className: 'pan-hd__image', src: _Assets2.default.assetUrl('images/card-hd-' + cardTypeSlug + '.png'), alt: cardType }) : null;
    var cardExpiryDate = _react2.default.createElement(
        'p',
        null,
        ' ',
        (0, _I18n2.default)('paymentCard.expiryDate', { expiryDate: expiryDate })
    );
    var cardNumber = void 0;

    if (mask) {
        cardNumber = pan && '**** **** **** ' + pan.substring(pan.length - 4);
    } else {
        cardNumber = pan && pan.split(/(....)/).join(' ').trim();
    }

    return highDefinition ? _react2.default.createElement(
        'div',
        { className: cardClassNames },
        highDefImageArt,
        _react2.default.createElement(
            'div',
            { className: 'pan-hd__details' },
            cardNumber,
            showExpires && cardExpiryDate
        )
    ) : _react2.default.createElement(
        'div',
        { className: cardClassNames },
        cardArtUrl && visaCheckoutCardArt,
        cardNumber,
        showExpires && cardExpiryDate
    );
}

PaymentCardDetails.propTypes = {
    card: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_StoredPaymentCard2.default), _propTypes2.default.instanceOf(_CardPayment2.default), _propTypes2.default.instanceOf(_HostedCardPayment2.default)]).isRequired,
    className: _propTypes2.default.string,
    highDefinition: _propTypes2.default.bool,
    showExpires: _propTypes2.default.bool,
    mask: _propTypes2.default.bool
};

PaymentCardDetails.defaultProps = {
    className: '',
    showExpires: false,
    mask: true
};

exports.default = PaymentCardDetails;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationModalActions = {
    open: function open(onConfirm, message, _ref, closeText, confirmButtonText) {
        var confirmationProps = (0, _objectWithoutProperties3.default)(_ref, []);
        var title = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
        var messageValues = arguments[6];
        var onCancel = arguments[7];

        _AppDispatcher2.default.dispatch({
            type: _AppConstants.GlobalModals.CONFIRM,
            data: (0, _assign2.default)({
                onConfirm: onConfirm,
                onCancel: onCancel,
                message: message,
                messageValues: messageValues,
                closeText: closeText,
                confirmButtonText: confirmButtonText,
                title: title
            }, confirmationProps),
            actionType: _AppConstants.ActionTypes.MODAL_OPENED
        });
    }
};

exports.default = ConfirmationModalActions;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ConfigAPIClient = __webpack_require__(1510);

var _ConfigAPIClient2 = _interopRequireDefault(_ConfigAPIClient);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _LinkMapper = __webpack_require__(8);

var _Banner = __webpack_require__(809);

var _Banner2 = _interopRequireDefault(_Banner);

var _JourneyNotification = __webpack_require__(1609);

var _JourneyNotification2 = _interopRequireDefault(_JourneyNotification);

var _Reason = __webpack_require__(1118);

var _Reason2 = _interopRequireDefault(_Reason);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configServiceBrand = function configServiceBrand() {
    return _config2.default.get('configServiceBrand') || _config2.default.get('brand');
};
var base = function base() {
    return '/confsvc/brands/' + configServiceBrand() + '/environments/' + _config2.default.get('environment');
};

var ConfigService = {
    loadBannerConfig: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            endpoint = base() + '/banners';
                            _context.next = 3;
                            return _ConfigAPIClient2.default.get(endpoint);

                        case 3:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Banner2.default));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadBannerConfig() {
            return _ref.apply(this, arguments);
        }

        return loadBannerConfig;
    }(),
    loadJourneyNotifications: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            endpoint = base() + '/journey-notifications/search';
                            _context2.next = 3;
                            return _ConfigAPIClient2.default.post(endpoint, data);

                        case 3:
                            response = _context2.sent;

                            if (!response.result) {
                                _context2.next = 8;
                                break;
                            }

                            return _context2.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_JourneyNotification2.default));

                        case 8:
                            return _context2.abrupt('return', new _immutable.List());

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function loadJourneyNotifications() {
            return _ref2.apply(this, arguments);
        }

        return loadJourneyNotifications;
    }(),
    checkTocOnlyRoute: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(search) {
            var endpoint, originNlc, destinationNlc, response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            endpoint = '/config/tocs/route/availability';
                            originNlc = search.origin.nlc;
                            destinationNlc = search.destination.nlc;
                            _context3.next = 6;
                            return _APIClient2.default.get(endpoint, { originNlc: originNlc, destinationNlc: destinationNlc });

                        case 6:
                            response = _context3.sent;
                            return _context3.abrupt('return', response.result.isAvailable);

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](0);

                            if (!(_context3.t0 instanceof _ConfigAPIClient.NotFoundError)) {
                                _context3.next = 14;
                                break;
                            }

                            return _context3.abrupt('return', null);

                        case 14:
                            throw _context3.t0;

                        case 15:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 10]]);
        }));

        function checkTocOnlyRoute(_x2) {
            return _ref3.apply(this, arguments);
        }

        return checkTocOnlyRoute;
    }(),
    getKeyGoAmendmentReasons: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            endpoint = base() + '/reasons';
                            _context4.next = 3;
                            return _ConfigAPIClient2.default.get(endpoint);

                        case 3:
                            response = _context4.sent;

                            if (!response.result) {
                                _context4.next = 8;
                                break;
                            }

                            return _context4.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Reason2.default));

                        case 8:
                            return _context4.abrupt('return', new _immutable.List());

                        case 9:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function getKeyGoAmendmentReasons() {
            return _ref4.apply(this, arguments);
        }

        return getKeyGoAmendmentReasons;
    }()
};

exports.default = ConfigService;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(287);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _DisruptionAlertActions = __webpack_require__(340);

var _DisruptionAlertActions2 = _interopRequireDefault(_DisruptionAlertActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _useFeatureFlag = __webpack_require__(624);

var _useFeatureFlag2 = _interopRequireDefault(_useFeatureFlag);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _DisruptionAlertStore = __webpack_require__(345);

var _DisruptionAlertStore2 = _interopRequireDefault(_DisruptionAlertStore);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _NotificationPreferences = __webpack_require__(1086);

var _NotificationPreferences2 = _interopRequireDefault(_NotificationPreferences);

var _DisruptionAlertService = __webpack_require__(456);

var _DisruptionAlertService2 = _interopRequireDefault(_DisruptionAlertService);

var _AlertButton = __webpack_require__(449);

var _AlertButton2 = _interopRequireDefault(_AlertButton);

var _JourneySelectorModal = __webpack_require__(2041);

var _JourneySelectorModal2 = _interopRequireDefault(_JourneySelectorModal);

var _AlertBuilderModal = __webpack_require__(1160);

var _AlertBuilderModal2 = _interopRequireDefault(_AlertBuilderModal);

var _SuccessModal = __webpack_require__(1165);

var _SuccessModal2 = _interopRequireDefault(_SuccessModal);

var _DisruptionAlerts = __webpack_require__(460);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStateFromStores() {
    var user = _UserStore2.default.getCurrent();
    return { user: user };
}

var CreateAlert = function CreateAlert(_ref) {
    var buttonProps = _ref.buttonProps,
        _ref$context = _ref.context,
        context = _ref$context === undefined ? '' : _ref$context,
        _ref$offerReturnJourn = _ref.offerReturnJourneyAlert,
        offerReturnJourneyAlert = _ref$offerReturnJourn === undefined ? false : _ref$offerReturnJourn,
        order = _ref.order,
        orderTrip = _ref.orderTrip,
        prefillFromSearch = _ref.prefillFromSearch,
        user = _ref.user;

    var enableDisruptionAlerts = (0, _useFeatureFlag2.default)('enableDisruptionAlerts');
    var enableDisruptionAlertsCreateButton = (0, _useFeatureFlag2.default)('enableDisruptionAlertsCreateButton');

    var _useState = (0, _react.useState)(_AppConstants.JourneyDirections.OUTWARD),
        alertBuilderJourneyDirection = _useState[0],
        setAlertBuilderJourneyDirection = _useState[1];

    var _useState2 = (0, _react.useState)(offerReturnJourneyAlert),
        showCreateReturnAlertOption = _useState2[0],
        setShowCreateReturnAlertOption = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        alertCreationModalVisible = _useState3[0],
        setAlertCreationModalVisible = _useState3[1];

    var _useState4 = (0, _react.useState)(false),
        journeySelectorModalVisible = _useState4[0],
        setJourneySelectorModalVisible = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        successModalVisible = _useState5[0],
        setShowSuccessModalVisible = _useState5[1];

    var _useState6 = (0, _react.useState)(false),
        showNotificationPrefsModal = _useState6[0],
        setShowNotificationPrefsModal = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        isOneOffAlert = _useState7[0],
        setIsOneOffAlert = _useState7[1];

    var _useState8 = (0, _react.useState)(null),
        outwardAlert = _useState8[0],
        setOutwardAlert = _useState8[1];

    var showAlertCreationModal = function showAlertCreationModal() {
        return setAlertCreationModalVisible(true);
    };
    var hideAlertCreationModal = function hideAlertCreationModal() {
        return setAlertCreationModalVisible(false);
    };

    var showJourneySelectorModal = function showJourneySelectorModal() {
        return setJourneySelectorModalVisible(true);
    };
    var hideJourneySelectorModal = function hideJourneySelectorModal() {
        return setJourneySelectorModalVisible(false);
    };

    var showSuccessModal = function showSuccessModal() {
        return setShowSuccessModalVisible(true);
    };
    var hideSuccessModal = function hideSuccessModal() {
        return setShowSuccessModalVisible(false);
    };

    if (!enableDisruptionAlerts || !enableDisruptionAlertsCreateButton) {
        return null;
    }

    var onOpenModal = function onOpenModal() {
        return _TrackingActions2.default.genericModalOpen(_AppConstants.GenericModals.DISRUPTION_ALERT);
    };

    var onCreateAlert = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var preferences, isEmailNotification, isCloudMessageNotification;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(!user || !user.isLoggedIn())) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', _ModalActions2.default.open(_AppConstants.GlobalModals.LOGIN, {
                                onLogin: launchAlertCreationModal,
                                onRegisterSuccessClose: launchAlertCreationModal
                            }));

                        case 2:
                            _context.next = 4;
                            return _DisruptionAlertService2.default.getPreferences(user.id);

                        case 4:
                            preferences = _context.sent;
                            isEmailNotification = preferences.isEmailNotification, isCloudMessageNotification = preferences.isCloudMessageNotification;

                            if (!(!isEmailNotification && !isCloudMessageNotification)) {
                                _context.next = 8;
                                break;
                            }

                            return _context.abrupt('return', setShowNotificationPrefsModal(true));

                        case 8:
                            return _context.abrupt('return', launchAlertCreationModal());

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function onCreateAlert() {
            return _ref2.apply(this, arguments);
        };
    }();

    var launchAlertCreationModal = function launchAlertCreationModal() {
        // Decide which alert creation modal to show
        var journeySelectorTripTypes = new _immutable.List([_AppConstants.OrderTripTypes.SINGLE, _AppConstants.OrderTripTypes.RETURN, _AppConstants.OrderTripTypes.RETURN_SINGLE, _AppConstants.OrderTripTypes.RETURN_SINGLES]);

        if (order && orderTrip && journeySelectorTripTypes.some(function (type) {
            return orderTrip.getType() === type;
        })) {
            return showJourneySelectorModal();
        }

        return showAlertCreationModal();
    };

    var onJourneySelectorSubmit = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(orderJourneys) {
            var alertCreationError, _iterator, _isArray, _i, _ref4, orderJourney;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            hideJourneySelectorModal();

                            alertCreationError = false;
                            _iterator = orderJourneys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);

                        case 3:
                            if (!_isArray) {
                                _context2.next = 9;
                                break;
                            }

                            if (!(_i >= _iterator.length)) {
                                _context2.next = 6;
                                break;
                            }

                            return _context2.abrupt('break', 29);

                        case 6:
                            _ref4 = _iterator[_i++];
                            _context2.next = 13;
                            break;

                        case 9:
                            _i = _iterator.next();

                            if (!_i.done) {
                                _context2.next = 12;
                                break;
                            }

                            return _context2.abrupt('break', 29);

                        case 12:
                            _ref4 = _i.value;

                        case 13:
                            orderJourney = _ref4;
                            _context2.prev = 14;
                            _context2.next = 17;
                            return _DisruptionAlertActions2.default.createFromOrderJourney({ user: user, order: order, orderTrip: orderTrip, orderJourney: orderJourney, context: context });

                        case 17:
                            _context2.next = 27;
                            break;

                        case 19:
                            _context2.prev = 19;
                            _context2.t0 = _context2['catch'](14);

                            alertCreationError = true;

                            if (!(_context2.t0 instanceof _DisruptionAlerts.DisruptionAlertsLimitExceededError)) {
                                _context2.next = 26;
                                break;
                            }

                            return _context2.abrupt('return', _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, {
                                title: 'disruptionAlerts.modals.limitExceeded.title',
                                message: 'disruptionAlerts.modals.limitExceeded.message'
                            }));

                        case 26:
                            throw _context2.t0;

                        case 27:
                            _context2.next = 3;
                            break;

                        case 29:

                            if (!alertCreationError) {
                                setIsOneOffAlert(true);
                                showSuccessModal();
                            }

                            return _context2.abrupt('return', null);

                        case 31:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[14, 19]]);
        }));

        return function onJourneySelectorSubmit(_x) {
            return _ref3.apply(this, arguments);
        };
    }();

    var onAlertBuilderSubmit = function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref5) {
            var alrt = _ref5.alrt,
                success = _ref5.success,
                err = _ref5.err;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (success) {
                                if (outwardAlert) {
                                    setOutwardAlert(null);
                                } else {
                                    setOutwardAlert(showCreateReturnAlertOption ? alrt : null);
                                }
                                showSuccessModal();
                                hideAlertCreationModal();
                            } else if (err instanceof _DisruptionAlerts.DisruptionAlertsLimitExceededError) {
                                _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, {
                                    title: 'disruptionAlerts.modals.limitExceeded.title',
                                    message: 'disruptionAlerts.modals.limitExceeded.message'
                                });
                            }
                            setAlertBuilderJourneyDirection(_AppConstants.JourneyDirections.OUTWARD);

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function onAlertBuilderSubmit(_x2) {
            return _ref6.apply(this, arguments);
        };
    }();

    var onCreateReturnAlert = function onCreateReturnAlert() {
        setShowCreateReturnAlertOption(false);
        setAlertBuilderJourneyDirection(_AppConstants.JourneyDirections.INWARD);
        showAlertCreationModal();
    };

    var onHideSuccessModal = function onHideSuccessModal() {
        setShowCreateReturnAlertOption(offerReturnJourneyAlert);
        hideSuccessModal();
    };

    var matchingAlert = order && orderTrip && _DisruptionAlertStore2.default.hasMatchingAlert({ order: order, orderTrip: orderTrip });
    var alertButtonProps = (0, _extends3.default)({}, buttonProps, matchingAlert ? { hasMatchingAlert: true } : { onClick: onCreateAlert });

    var sharedModalProps = {
        disableBlur: true,
        headerClass: 'text-left',
        onEnterContinue: false,
        onOpen: onOpenModal,
        show: true,
        titleText: 'disruptionAlerts.modals.common.title'
    };

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_AlertButton2.default, alertButtonProps),
        showNotificationPrefsModal && _react2.default.createElement(_NotificationPreferences2.default, {
            user: user,
            isDDM: true,
            notificationPreferencesModalOpen: true,
            hideSummary: true,
            defaultNotificationPreference: _AppConstants.notificationPreferences.EMAIL,
            disableCloseWithoutChoosingPreference: true,
            onContinueAction: launchAlertCreationModal
        }),
        journeySelectorModalVisible && _react2.default.createElement(_JourneySelectorModal2.default, (0, _extends3.default)({}, sharedModalProps, {
            onClose: hideJourneySelectorModal,
            onConfirm: onJourneySelectorSubmit,
            order: order,
            orderTrip: orderTrip
        })),
        alertCreationModalVisible && _react2.default.createElement(_AlertBuilderModal2.default, (0, _extends3.default)({}, sharedModalProps, {
            journeyDirection: alertBuilderJourneyDirection,
            onAlertBuilderSubmit: onAlertBuilderSubmit,
            order: order,
            orderTrip: orderTrip,
            outwardAlert: outwardAlert,
            prefillFromSearch: prefillFromSearch,
            user: user,
            hideAlertCreationModal: hideAlertCreationModal
        })),
        successModalVisible && _react2.default.createElement(_SuccessModal2.default, (0, _extends3.default)({}, sharedModalProps, {
            isOneOffAlert: isOneOffAlert,
            onClose: onHideSuccessModal,
            onCreateReturnAlert: onCreateReturnAlert,
            showCreateReturnAlertOption: showCreateReturnAlertOption
        }))
    );
};

CreateAlert.propTypes = {
    buttonProps: _propTypes2.default.object,
    context: _propTypes2.default.string,
    order: _propTypes2.default.instanceOf(_Order2.default),
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default),
    prefillFromSearch: _propTypes2.default.bool,
    offerReturnJourneyAlert: _propTypes2.default.bool,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired
};

exports.default = (0, _connectToStores2.default)([_UserStore2.default], getStateFromStores)(CreateAlert);

/***/ }),
/* 633 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TripPlusbus = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(TripPlusbus, _PureRenderComponent);

    function TripPlusbus() {
        (0, _classCallCheck3.default)(this, TripPlusbus);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    TripPlusbus.prototype._renderItem = function _renderItem(group, name) {
        var total = group.reduce(function (result, fare) {
            return result + fare.getTotalPrice();
        }, 0);
        var passengers = group.reduce(function (result, fare) {
            return result + fare.adults() + fare.children();
        }, 0);

        return _react2.default.createElement(
            'li',
            { key: name, className: 'clearfix text-weight--normal plusbus-list__item' },
            _react2.default.createElement(
                'div',
                { className: 'price pull-right' },
                _react2.default.createElement(_Price2.default, { price: total })
            ),
            _react2.default.createElement(
                'span',
                null,
                passengers,
                ' x ',
                name,
                ' ',
                _react2.default.createElement(
                    'span',
                    { className: 'plusbus__name' },
                    (0, _I18n.translate)('order.summary.plusbus')
                )
            )
        );
    };

    TripPlusbus.prototype.render = function render() {
        var orderTrip = this.props.orderTrip;


        if (!orderTrip.hasPlusBus()) {
            return null;
        }

        var fares = orderTrip.getPlusBus().getFares();
        var groups = fares.groupBy(function (fare) {
            return fare.origin.name;
        });

        var classNames = (0, _classnames2.default)('fare-plusbus padding-top--sm margin-bottom--sm border-thick--top also-visible-print');

        return _react2.default.createElement(
            'div',
            { className: classNames },
            _react2.default.createElement(
                'ul',
                { className: 'plusbus-list padding-top--sm list-unstyled' },
                groups.map(this._renderItem).toList()
            )
        );
    };

    return TripPlusbus;
}(_PureRenderComponent3.default), _class.propTypes = {
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    open: _propTypes2.default.bool
}, _class.defaultProps = {
    open: false
}, _temp);
exports.default = TripPlusbus;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _FareShort = __webpack_require__(1159);

var _FareShort2 = _interopRequireDefault(_FareShort);

var _SeasonFareShort = __webpack_require__(2039);

var _SeasonFareShort2 = _interopRequireDefault(_SeasonFareShort);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RemoveJourneyModal(_ref) {
    var onBack = _ref.onBack,
        onConfirm = _ref.onConfirm,
        journey = _ref.journey;

    var modalProps = {
        titleText: 'order.summary.confirmRemoveJourney',
        closeText: 'button.text.cancel',
        continueText: 'button.text.removeJourney',
        onClose: onBack,
        onContinue: onConfirm,
        className: 'modal--sm modal--remove-journey'
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { sm: 12 },
                _react2.default.createElement(
                    'ul',
                    { className: 'order-summary__list list-unstyled' },
                    journey.getJourneyFares().map(function (fare, key) {
                        if (journey.hasSeasonFare()) {
                            return _react2.default.createElement(_SeasonFareShort2.default, { orderFare: fare, key: key, open: true });
                        }
                        return _react2.default.createElement(_FareShort2.default, { orderFare: fare, key: key, open: true });
                    })
                )
            )
        )
    );
}

RemoveJourneyModal.propTypes = {
    journey: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    onBack: _propTypes2.default.func.isRequired,
    onConfirm: _propTypes2.default.func.isRequired
};

exports.default = RemoveJourneyModal;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _Fares = __webpack_require__(427);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _LinkingSmartcardsStore = __webpack_require__(348);

var _LinkingSmartcardsStore2 = _interopRequireDefault(_LinkingSmartcardsStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _PreviousSearchesStore = __webpack_require__(621);

var _PreviousSearchesStore2 = _interopRequireDefault(_PreviousSearchesStore);

var _PassengerAssistStore = __webpack_require__(173);

var _PassengerAssistStore2 = _interopRequireDefault(_PassengerAssistStore);

var _FareJourneys = __webpack_require__(2051);

var _FareJourneys2 = _interopRequireDefault(_FareJourneys);

var _FareRestrictions = __webpack_require__(617);

var _FareRestrictions2 = _interopRequireDefault(_FareRestrictions);

var _FareSummary = __webpack_require__(2052);

var _FareSummary2 = _interopRequireDefault(_FareSummary);

var _FarePassengers = __webpack_require__(938);

var _FarePassengers2 = _interopRequireDefault(_FarePassengers);

var _Validity = __webpack_require__(1026);

var _Validity2 = _interopRequireDefault(_Validity);

var _LinkedSmartcards = __webpack_require__(939);

var _LinkedSmartcards2 = _interopRequireDefault(_LinkedSmartcards);

var _RewardPointsEarned = __webpack_require__(682);

var _RewardPointsEarned2 = _interopRequireDefault(_RewardPointsEarned);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStateFromStores = function getStateFromStores(_ref) {
    var orderFare = _ref.orderFare;

    return {
        enableSmartcardAssociations: _FeatureFlagStore2.default.get('enableSmartcardAssociations'),
        linkedAdults: _LinkingSmartcardsStore2.default.getAdultsLinkedSmartcardsForFare(orderFare.tickets.map(function (ticket) {
            return ticket.id;
        })),
        linkedChildren: _LinkingSmartcardsStore2.default.getChildrenLinkedSmartcardsForFare(orderFare.tickets.map(function (ticket) {
            return ticket.id;
        })),
        promoCode: _PreviousSearchesStore2.default.get('point').getPromoCode(),
        pendingPassengerAssistRequests: _PassengerAssistStore2.default.getPendingPassengerAssistRequests()
    };
};

var Fare = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Fare, _React$PureComponent);

    function Fare() {
        (0, _classCallCheck3.default)(this, Fare);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    Fare.prototype._renderFareValidityDates = function _renderFareValidityDates() {
        var orderFare = this.props.orderFare;

        return _react2.default.createElement(
            'div',
            { className: 'fare__details text-sm' },
            _react2.default.createElement(
                'h5',
                { className: 'text-weight--normal fare__details__header' },
                (0, _I18n.translate)('booking.fares.details.dates')
            ),
            _react2.default.createElement(
                'ul',
                { className: 'fare__valid-dates' },
                orderFare.outwardJourney && _react2.default.createElement(_Validity2.default, { type: 'outward',
                    from: orderFare.outwardJourney.validFrom,
                    to: orderFare.outwardJourney.validTo }),
                orderFare.returnJourney && _react2.default.createElement(_Validity2.default, { type: 'return',
                    from: orderFare.returnJourney.validFrom,
                    to: orderFare.returnJourney.validTo })
            )
        );
    };

    Fare.prototype.render = function render() {
        var _props = this.props,
            open = _props.open,
            orderFare = _props.orderFare,
            isFareOnly = _props.isFareOnly,
            isAmended = _props.isAmended,
            linkedAdults = _props.linkedAdults,
            linkedChildren = _props.linkedChildren,
            isSmartcard = _props.isSmartcard,
            matchingTimetableAlert = _props.matchingTimetableAlert,
            isLoggedIn = _props.isLoggedIn,
            promoCode = _props.promoCode,
            orderTrip = _props.orderTrip,
            idx = _props.idx;

        var tickets = (0, _Fares.getFoldedTickets)(orderFare.tickets);

        var hasRailcards = orderFare.getRailcards().some(function (railcard) {
            return !railcard.isGroupSave();
        });
        var showRailcardsMessage = hasRailcards && !isAmended;

        var alertsText = '';
        var prefs = [];

        if (matchingTimetableAlert) {
            var alertProps = matchingTimetableAlert.toJS();

            var delaysChecked = alertProps.delaysChecked,
                stationAlertsChecked = alertProps.stationAlertsChecked,
                timetableChangesChecked = alertProps.timetableChangesChecked;


            if (isLoggedIn) {
                if (delaysChecked) {
                    prefs.push('disruption');
                }
                if (stationAlertsChecked) {
                    prefs.push('station facility');
                }
                if (timetableChangesChecked) {
                    prefs.push('timetable');
                }
            } else {
                prefs.push('timetable');
            }

            var prefsString = prefs.join(', ').replace(/,(?=[^,]*$)/, ' and');

            alertsText = 'You will receive ' + prefsString + ' alerts if there any changes to this journey.';
        }

        var rewardPoints = tickets.reduce(function (sum, ticket) {
            return sum + ticket.rewardPoints;
        }, 0);

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_FareSummary2.default, this.props),
            open && _react2.default.createElement(
                'div',
                { className: 'fare-details also-visible-print' },
                isSmartcard ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    tickets.some(function (ticket) {
                        return ticket.adults > 0;
                    }) && _react2.default.createElement(_LinkedSmartcards2.default, {
                        linkedPassengers: linkedAdults,
                        tickets: tickets,
                        showRailcardsMessage: showRailcardsMessage
                    }),
                    tickets.some(function (ticket) {
                        return ticket.children > 0;
                    }) && _react2.default.createElement(_LinkedSmartcards2.default, {
                        isChild: true,
                        linkedPassengers: linkedChildren,
                        tickets: tickets,
                        showRailcardsMessage: showRailcardsMessage
                    })
                ) : _react2.default.createElement(_FarePassengers2.default, { orderFare: orderFare, isAmended: isAmended, promoCode: promoCode }),
                !isFareOnly && !orderTrip.isTransPennineStaffRover() && _react2.default.createElement(_FareJourneys2.default, { idx: idx, orderTrip: orderTrip, orderFare: orderFare, isAmended: isAmended }),
                isFareOnly && this._renderFareValidityDates(),
                matchingTimetableAlert && prefs.length > 0 && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_Icon2.default, { style: { marginTop: '3px', marginRight: '2px' }, icon: 'alert-active', className: 'pull-left grid-basket-summary-v2__alert__icon' }),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                alertsText
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'list-unstyled exceptions-list padding-bottom--sm text-sm text-light' },
                    _react2.default.createElement(_FareRestrictions2.default, { fare: orderFare, useBootstrap: true })
                )
            ),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableRewardPoints' },
                _react2.default.createElement(_RewardPointsEarned2.default, { rewardPoints: rewardPoints, className: "reward-points__earned pull-right" })
            )
        );
    };

    return Fare;
}(_react2.default.PureComponent), _class.propTypes = {
    orderFare: _propTypes2.default.instanceOf(_Fare2.default).isRequired,
    open: _propTypes2.default.bool,
    linkedAdults: _propTypes2.default.instanceOf(_immutable.List),
    linkedChildren: _propTypes2.default.instanceOf(_immutable.List),
    isFareOnly: _propTypes2.default.bool,
    isAmended: _propTypes2.default.bool,
    isSmartcard: _propTypes2.default.bool,
    matchingTimetableAlert: _propTypes2.default.object,
    isLoggedIn: _propTypes2.default.bool,
    promoCode: _propTypes2.default.string,
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default),
    idx: _propTypes2.default.number
}, _class.defaultProps = {
    open: false,
    isFareOnly: false,
    isAmended: false,
    isSmartcard: false,
    matchingTimetableAlert: null,
    isLoggedIn: false
}, _temp);
exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default, _LinkingSmartcardsStore2.default, _PreviousSearchesStore2.default], getStateFromStores)(Fare);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppConstants = __webpack_require__(6);

var _BacsServices = __webpack_require__(1692);

var _BacsServices2 = _interopRequireDefault(_BacsServices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    Checks for presence of any key in a given list of keys on a given object, returns
    true if any are found, false if none.
*/
var objectHasAnyKeyInList = function objectHasAnyKeyInList(obj, keys) {
    return Boolean(keys.find(function (key) {
        return obj.hasOwnProperty(key);
    }));
};

var includesChildPreencode = function includesChildPreencode(errors, numChildTickets, numChildSmartcards) {
    return errors && errors.some(function (err) {
        return objectHasAnyKeyInList(err, [_AppConstants.SmartcardErrorNonBlocking.NO_SMARTCARD]);
    }) && numChildTickets - numChildSmartcards === 1;
};

var chunk = function chunk(str, n) {
    var ret = [];
    for (var i = 0; i < str.length; i += n) {
        ret.push(str.substr(i, n));
    }
    return ret;
};

var isValidBACS = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(sortCode, accountNumber, setDisableContinue) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return _BacsServices2.default.validate(chunk(sortCode, 2).join('-'), accountNumber);

                    case 3:
                        res = _context.sent;

                        setDisableContinue(res);
                        return _context.abrupt('return', res);

                    case 8:
                        _context.prev = 8;
                        _context.t0 = _context['catch'](0);

                        console.warn('Error validating bacs details', _context.t0);
                        return _context.abrupt('return', false);

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[0, 8]]);
    }));

    return function isValidBACS(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var getRandomNumberInRange = function getRandomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
};

exports.default = {
    getRandomNumberInRange: getRandomNumberInRange,
    objectHasAnyKeyInList: objectHasAnyKeyInList,
    includesChildPreencode: includesChildPreencode,
    chunk: chunk,
    isValidBACS: isValidBACS
};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FamilyVerificationStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyVerificationState = new _immutable.Record({
    isVerified: false,
    token: null,
    email: null,
    availableTickets: null,
    isLoading: false,
    error: null,
    allowanceExceeded: false
});

var FamilyVerificationStore = exports.FamilyVerificationStore = function (_BaseStore) {
    (0, _inherits3.default)(FamilyVerificationStore, _BaseStore);

    function FamilyVerificationStore() {
        (0, _classCallCheck3.default)(this, FamilyVerificationStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    FamilyVerificationStore.prototype.getInitialState = function getInitialState() {
        return new FamilyVerificationState();
    };

    FamilyVerificationStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.FAMILY_VERIFICATION_STARTED] = this.handleVerificationStarted, _ref[_AppConstants.ActionTypes.FAMILY_VERIFICATION_VERIFIED] = this.handleSetVerified, _ref[_AppConstants.ActionTypes.FAMILY_VERIFICATION_FAILED] = this.handleVerificationFailed, _ref[_AppConstants.ActionTypes.FAMILY_VERIFICATION_RESET] = this.handleResetVerification, _ref[_AppConstants.ActionTypes.FAMILY_VERIFICATION_ALLOWANCE_EXCEEDED] = this.handleAllowanceExceeded, _ref;
    };

    FamilyVerificationStore.prototype.handleVerificationStarted = function handleVerificationStarted() {
        this.setState(this.state.merge({ isLoading: true, error: null, allowanceExceeded: false }));
    };

    FamilyVerificationStore.prototype.handleSetVerified = function handleSetVerified(_ref2) {
        var token = _ref2.token,
            email = _ref2.email,
            availableTickets = _ref2.availableTickets;

        this.setState(this.state.merge({
            isVerified: true,
            token: token,
            email: email,
            availableTickets: availableTickets,
            isLoading: false,
            error: null,
            allowanceExceeded: false
        }));
    };

    FamilyVerificationStore.prototype.handleVerificationFailed = function handleVerificationFailed(_ref3) {
        var error = _ref3.error;

        this.setState(this.state.merge({
            isLoading: false,
            error: error,
            isVerified: false
        }));
    };

    FamilyVerificationStore.prototype.handleResetVerification = function handleResetVerification() {
        this.setState(this.getInitialState());
    };

    FamilyVerificationStore.prototype.handleAllowanceExceeded = function handleAllowanceExceeded() {
        this.setState(this.state.merge({
            allowanceExceeded: true
        }));
    };

    FamilyVerificationStore.prototype.isVerified = function isVerified() {
        return this.get('isVerified');
    };

    FamilyVerificationStore.prototype.getToken = function getToken() {
        return this.get('token');
    };

    FamilyVerificationStore.prototype.getEmail = function getEmail() {
        return this.get('email');
    };

    FamilyVerificationStore.prototype.getAvailableTickets = function getAvailableTickets() {
        return this.get('availableTickets');
    };

    FamilyVerificationStore.prototype.isLoading = function isLoading() {
        return this.get('isLoading');
    };

    FamilyVerificationStore.prototype.getError = function getError() {
        return this.get('error');
    };

    FamilyVerificationStore.prototype.isAllowanceExceeded = function isAllowanceExceeded() {
        return this.get('allowanceExceeded');
    };

    FamilyVerificationStore.prototype.getVerifiedEmail = function getVerifiedEmail() {
        return this.isVerified() ? this.getEmail() : null;
    };

    return FamilyVerificationStore;
}(_BaseStore3.default);

var instance = new FamilyVerificationStore({
    storageKey: 'familyVerification',
    expires: 24 * 60 * 60 // 24 hours in seconds
});

exports.default = instance;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DateTime(_ref) {
    var className = _ref.className,
        dateTime = _ref.dateTime,
        format = _ref.format;

    return _react2.default.createElement(
        'time',
        { className: (0, _classnames2.default)('time', className),
            dateTime: dateTime && dateTime.toISOString() },
        dateTime && dateTime.format(format)
    );
}

DateTime.propTypes = {
    className: _propTypes2.default.string,
    dateTime: _propTypes2.default.object,
    format: _propTypes2.default.string
};

DateTime.defaultProps = {
    dateTime: (0, _TrainTime2.default)(),
    format: 'DD/MM/YYYY HH:mm'
};

exports.default = DateTime;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _Reservation = __webpack_require__(644);

var _Reservation2 = _interopRequireDefault(_Reservation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    reservations: new _immutable.List(),
    reservation: new _Reservation2.default(),
    isReservationLoading: false,
    isReservationFlowStarted: false,
    isReservationFlowCanceled: false,
    isReservationFlowCompleted: false,
    bikeReservation: null,
    seatReservation: null,
    reservationWidgetToggled: false,
    reservationCancellationStatus: null,
    totalPages: 0
});

var defaultState = new State();

var ReservationStore = function (_BaseStore) {
    (0, _inherits3.default)(ReservationStore, _BaseStore);

    function ReservationStore() {
        (0, _classCallCheck3.default)(this, ReservationStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    ReservationStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return defaultState.merge({
                reservations: (0, _LinkMapper.resolveAll)(serialized.reservations).as(_Reservation2.default)
            });
        }

        return defaultState;
    };

    ReservationStore.prototype.getTotalPages = function getTotalPages() {
        return this.state.get('totalPages');
    };

    ReservationStore.prototype.getUpcomingReservations = function getUpcomingReservations() {
        var reservations = this.state.get('reservations');
        var upcoming = reservations.filter(function (reservation) {
            return !reservation.isExpired && !reservation.isCancelled;
        });

        if (upcoming.size > 0) {
            return upcoming;
        }
        return null;
    };

    ReservationStore.prototype.getPreviousReservations = function getPreviousReservations() {
        var reservations = this.state.get('reservations');

        var previous = reservations.filter(function (reservation) {
            return reservation.isExpired || reservation.isCancelled;
        });

        if (previous.size > 0) {
            return previous;
        }

        return null;
    };

    ReservationStore.prototype.hasReservations = function hasReservations() {
        var reservations = this.state.get('reservations');
        return reservations.size > 0;
    };

    ReservationStore.prototype.getReservationsState = function getReservationsState() {
        return this.state.get('reservations');
    };

    ReservationStore.prototype.getReservation = function getReservation() {
        return this.state.get('reservation');
    };

    ReservationStore.prototype.getReservationCancellationStatus = function getReservationCancellationStatus() {
        return this.state.get('reservationCancellationStatus');
    };

    ReservationStore.prototype.handleClear = function handleClear() {
        this.setState(defaultState);
    };

    ReservationStore.prototype.setLoading = function setLoading(isLoading) {
        return function () {
            this.setState(this.state.set('isReservationLoading', isLoading));
        };
    };

    ReservationStore.prototype.setReservationWidgetToggled = function setReservationWidgetToggled(_ref) {
        var toggled = _ref.toggled;

        this.setState(this.state.set('reservationWidgetToggled', toggled));
    };

    ReservationStore.prototype.getIsReservationWidgetToggled = function getIsReservationWidgetToggled() {
        return this.state.get('reservationWidgetToggled');
    };

    ReservationStore.prototype.setIsReservationStarted = function setIsReservationStarted() {
        this.setState(this.state.set('isReservationFlowStarted', true));
    };

    ReservationStore.prototype.setIsReservationCanceled = function setIsReservationCanceled() {
        this.setState(this.state.set('isReservationFlowCanceled', true));
    };

    ReservationStore.prototype.setIsReservationCompleted = function setIsReservationCompleted() {
        this.setState(this.state.set('isReservationFlowCompleted', true));
    };

    ReservationStore.prototype.addBikeReservation = function addBikeReservation(_ref2) {
        var bikeReservation = _ref2.bikeReservation;

        this.setState(this.state.set('bikeReservation', bikeReservation));
    };

    ReservationStore.prototype.removeBikeReservation = function removeBikeReservation() {
        this.setState(this.state.set('bikeReservation', defaultState.bikeReservation));
    };

    ReservationStore.prototype.addSeatReservation = function addSeatReservation(_ref3) {
        var seatReservation = _ref3.seatReservation;

        this.setState(this.state.set('seatReservation', seatReservation));
    };

    ReservationStore.prototype.removeSeatReservation = function removeSeatReservation() {
        this.setState(this.state.set('seatReservation', defaultState.seatReservation));
    };

    ReservationStore.prototype.createReservation = function createReservation(_ref4) {
        var reservation = _ref4.reservation;

        this.setState(this.state.set('reservation', reservation));
    };

    ReservationStore.prototype.amendReservation = function amendReservation(_ref5) {
        var reservation = _ref5.reservation;

        this.setState(this.state.set('reservation', reservation));
    };

    ReservationStore.prototype.getReservations = function getReservations(_ref6) {
        var pagination = _ref6.pagination,
            reservations = _ref6.reservations;

        this.setState(this.state.set('reservations', reservations));
        this.setState(this.state.set('totalPages', pagination.totalPages));
    };

    ReservationStore.prototype.handleCancelReservationSuccess = function handleCancelReservationSuccess() {
        this.setState(this.state.set('reservationCancellationStatus', _AppConstants.RESERVATION_CANCELLATION_STATUS.SUCCESS));
    };

    ReservationStore.prototype.handleCancelReservationFailure = function handleCancelReservationFailure() {
        this.setState(this.state.set('reservationCancellationStatus', _AppConstants.RESERVATION_CANCELLATION_STATUS.FAILURE));
    };

    ReservationStore.prototype.clearCancelReservationStatus = function clearCancelReservationStatus() {
        this.setState(this.state.set('reservationCancellationStatus', null));
    };

    ReservationStore.prototype.getActionHandlers = function getActionHandlers() {
        var _this2 = this,
            _ref8;

        return _ref8 = {}, _ref8[_AppConstants.ActionTypes.START_RESERVATION_FLOW] = this.setIsReservationStarted, _ref8[_AppConstants.ActionTypes.CANCEL_RESERVATION_FLOW] = this.setIsReservationCanceled, _ref8[_AppConstants.ActionTypes.RESERVATION_COMPLETED] = this.setIsReservationCompleted, _ref8[_AppConstants.ActionTypes.ADD_BIKE_RESERVATION] = this.addBikeReservation, _ref8[_AppConstants.ActionTypes.REMOVE_BIKE_RESERVATION] = this.removeBikeReservation, _ref8[_AppConstants.ActionTypes.ADD_SEAT_RESERVATION] = this.addSeatReservation, _ref8[_AppConstants.ActionTypes.REMOVE_SEAT_RESERVATION] = this.removeSeatReservation, _ref8[_AppConstants.ActionTypes.CREATE_RESERVATION_STARTED] = this.setLoading(true), _ref8[_AppConstants.ActionTypes.CREATE_RESERVATION_LOADED] = this.createReservation, _ref8[_AppConstants.ActionTypes.CREATE_RESERVATION_FINISHED] = this.setLoading(false), _ref8[_AppConstants.ActionTypes.AMEND_RESERVATION_STARTED] = this.setLoading(true), _ref8[_AppConstants.ActionTypes.AMEND_RESERVATION_LOADED] = this.amendReservation, _ref8[_AppConstants.ActionTypes.AMEND_RESERVATION_FINISHED] = this.setLoading(false), _ref8[_AppConstants.ActionTypes.GET_RESERVATION_STARTED] = this.setLoading(true), _ref8[_AppConstants.ActionTypes.GET_RESERVATION_LOADED] = this.getReservations, _ref8[_AppConstants.ActionTypes.GET_RESERVATION_FINISHED] = this.setLoading(false), _ref8[_AppConstants.ActionTypes.RESERVATION_WIDGET_TOGGLED] = this.setReservationWidgetToggled, _ref8[_AppConstants.ActionTypes.CANCEL_RESERVATION_SUCCESS] = this.handleCancelReservationSuccess, _ref8[_AppConstants.ActionTypes.CANCEL_RESERVATION_FAILED] = this.handleCancelReservationFailure, _ref8[_AppConstants.ActionTypes.CANCEL_RESERVATION_FAILED] = this.handleCancelReservationFailure, _ref8[_AppConstants.ActionTypes.CLEAR_CANCEL_RESERVATION_STATUS] = this.clearCancelReservationStatus, _ref8[_AppConstants.ActionTypes.CLEAR_RESERVATION_STORE] = this.handleClear(), _ref8[_AppConstants.ActionTypes.SET_RESERVATION_PAGINATION] = function (_ref7) {
            var totalPages = _ref7.totalPages;

            _this2.setState(_this2.state.set('totalPages', totalPages));
        }, _ref8;
    };

    return ReservationStore;
}(_BaseStore3.default);

var instance = new ReservationStore({ storageKey: 'reservations' });

exports.default = instance;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _parseFloat = __webpack_require__(2005);

var _parseFloat2 = _interopRequireDefault(_parseFloat);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(_ref) {
    var completed = _ref.completed,
        total = _ref.total,
        _ref$containerStyle = _ref.containerStyle,
        containerStyle = _ref$containerStyle === undefined ? {} : _ref$containerStyle,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style;

    var clampedCompleted = completed > total ? total : completed;
    var percentage = (0, _parseFloat2.default)(clampedCompleted / total * 100).toFixed(2);

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('progress-bar', { 'progress-bar--completed': completed > total }), style: containerStyle },
        _react2.default.createElement('div', {
            className: 'progress-bar__line',
            style: (0, _extends3.default)({ width: percentage + '%' }, style) })
    );
};

ProgressBar.propTypes = {
    completed: _propTypes2.default.number,
    total: _propTypes2.default.number,
    containerStyle: _propTypes2.default.object,
    style: _propTypes2.default.object
};

ProgressBar.defaultProps = {
    completed: 0,
    total: 1,
    containerStyle: {},
    style: {}
};

exports.default = ProgressBar;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _DiscountRule = __webpack_require__(1699);

var _DiscountRule2 = _interopRequireDefault(_DiscountRule);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    allowAdult: null,
    allowChild: null,
    allowRailcard: null,
    brandId: null,
    description: null,
    name: null,
    discountCode: null,
    oneOffPromoCode: null,
    percent: null,
    promotionUrl: null,
    purchaseFrom: null,
    purchaseTo: null,
    travelFrom: null,
    travelTo: null,
    discountRules: new _immutable.List(),
    redirectTab: null,
    maxProducts: null
};

var searchStages = (0, _immutable.Map)({
    point: _AppConstants.PointStages.SEARCH,
    season: _AppConstants.SeasonStages.SEARCH,
    daySave: _AppConstants.DaySaveStages.SEARCH
});

var Discount = function (_record) {
    (0, _inherits3.default)(Discount, _record);

    function Discount() {
        (0, _classCallCheck3.default)(this, Discount);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Discount.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Discount, json, {
            id: _LinkMapper.fields.string,
            allowAdult: _LinkMapper.fields.boolean,
            allowChild: _LinkMapper.fields.boolean,
            allowRailcard: _LinkMapper.fields.boolean,
            brandId: _LinkMapper.fields.string,
            description: _LinkMapper.fields.string,
            name: _LinkMapper.fields.string,
            discountCode: _LinkMapper.fields.string,
            oneOffPromoCode: _LinkMapper.fields.boolean,
            percent: _LinkMapper.fields.number,
            promotionUrl: _LinkMapper.fields.string,
            purchaseFrom: _LinkMapper.fields.datetime,
            purchaseTo: _LinkMapper.fields.datetime,
            travelFrom: _LinkMapper.fields.datetime,
            travelTo: _LinkMapper.fields.datetime,
            discountRules: _LinkMapper.resolveAll.as(_DiscountRule2.default),
            redirectTab: _LinkMapper.fields.string,
            maxProducts: _LinkMapper.fields.number
        });
    };

    (0, _createClass3.default)(Discount, [{
        key: 'searchStage',
        get: function get() {
            return searchStages.get(this.redirectTab, searchStages.get('season'));
        }
    }]);
    return Discount;
}((0, _immutable.Record)(defaults));

exports.default = Discount;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _ReservationJourney = __webpack_require__(657);

var _ReservationJourney2 = _interopRequireDefault(_ReservationJourney);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reservation = new _immutable.Record({
    reservationId: null,
    orderId: null,
    bookingReference: null,
    collectionReference: null,
    expiry: null,
    outwardJourney: new _ReservationJourney2.default(),
    returnJourney: new _ReservationJourney2.default(),
    isCancelled: false,
    isExpired: false,
    created: null
});

(0, _assign2.default)(Reservation.prototype, {
    getBookingDate: function getBookingDate() {
        return this.created.format('ddd DD MMM HH:mm');
    },
    isAssociatedWithOrder: function isAssociatedWithOrder() {
        return Boolean(this.orderId);
    },
    getCollectionReference: function getCollectionReference() {
        // Reservations made in the ticket booking flow have only a booking reference, not a collection reference
        return this.collectionReference || this.bookingReference;
    },
    getOutwardDate: function getOutwardDate() {
        var date = this.outwardJourney.getFirstLeg().departure;
        return (0, _TrainTime2.default)(date).format('ddd, DD MMM YYYY');
    },
    isReturn: function isReturn() {
        return !!this.returnJourney;
    },
    getIsCancelled: function getIsCancelled() {
        return this.isCancelled;
    }
});

Reservation.fromJSON = function (json) {
    var res = (0, _LinkMapper.construct)(Reservation, json, {
        reservationId: _LinkMapper.fields.number,
        orderId: _LinkMapper.fields.number,
        bookingReference: _LinkMapper.fields.string,
        collectionReference: _LinkMapper.fields.string,
        expiry: _LinkMapper.resolve.with(_TrainTime2.default),
        outwardJourney: _LinkMapper.resolve.as(_ReservationJourney2.default),
        returnJourney: _LinkMapper.resolve.as(_ReservationJourney2.default),
        isCancelled: _LinkMapper.fields.bool,
        isExpired: _LinkMapper.fields.bool,
        created: _LinkMapper.resolve.with(_TrainTime2.default)
    });

    return res;
};

exports.default = Reservation;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;

var _RouteUtils = __webpack_require__(195);

Object.defineProperty(exports, 'createRoutes', {
  enumerable: true,
  get: function get() {
    return _RouteUtils.createRoutes;
  }
});

var _PropTypes2 = __webpack_require__(85);

Object.defineProperty(exports, 'locationShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.locationShape;
  }
});
Object.defineProperty(exports, 'routerShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes2.routerShape;
  }
});

var _PatternUtils = __webpack_require__(265);

Object.defineProperty(exports, 'formatPattern', {
  enumerable: true,
  get: function get() {
    return _PatternUtils.formatPattern;
  }
});

var _Router2 = __webpack_require__(1871);

var _Router3 = _interopRequireDefault(_Router2);

var _Link2 = __webpack_require__(572);

var _Link3 = _interopRequireDefault(_Link2);

var _IndexLink2 = __webpack_require__(1893);

var _IndexLink3 = _interopRequireDefault(_IndexLink2);

var _withRouter2 = __webpack_require__(159);

var _withRouter3 = _interopRequireDefault(_withRouter2);

var _IndexRedirect2 = __webpack_require__(1894);

var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);

var _IndexRoute2 = __webpack_require__(1895);

var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);

var _Redirect2 = __webpack_require__(896);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(1896);

var _Route3 = _interopRequireDefault(_Route2);

var _History2 = __webpack_require__(1897);

var _History3 = _interopRequireDefault(_History2);

var _Lifecycle2 = __webpack_require__(1898);

var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);

var _RouteContext2 = __webpack_require__(1899);

var _RouteContext3 = _interopRequireDefault(_RouteContext2);

var _useRoutes2 = __webpack_require__(1900);

var _useRoutes3 = _interopRequireDefault(_useRoutes2);

var _RouterContext2 = __webpack_require__(413);

var _RouterContext3 = _interopRequireDefault(_RouterContext2);

var _RoutingContext2 = __webpack_require__(1901);

var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);

var _PropTypes3 = _interopRequireDefault(_PropTypes2);

var _match2 = __webpack_require__(1902);

var _match3 = _interopRequireDefault(_match2);

var _useRouterHistory2 = __webpack_require__(581);

var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);

var _applyRouterMiddleware2 = __webpack_require__(1903);

var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);

var _browserHistory2 = __webpack_require__(1904);

var _browserHistory3 = _interopRequireDefault(_browserHistory2);

var _hashHistory2 = __webpack_require__(1905);

var _hashHistory3 = _interopRequireDefault(_hashHistory2);

var _createMemoryHistory2 = __webpack_require__(897);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Router = _Router3.default; /* components */

exports.Link = _Link3.default;
exports.IndexLink = _IndexLink3.default;
exports.withRouter = _withRouter3.default;

/* components (configuration) */

exports.IndexRedirect = _IndexRedirect3.default;
exports.IndexRoute = _IndexRoute3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;

/* mixins */

exports.History = _History3.default;
exports.Lifecycle = _Lifecycle3.default;
exports.RouteContext = _RouteContext3.default;

/* utils */

exports.useRoutes = _useRoutes3.default;
exports.RouterContext = _RouterContext3.default;
exports.RoutingContext = _RoutingContext3.default;
exports.PropTypes = _PropTypes3.default;
exports.match = _match3.default;
exports.useRouterHistory = _useRouterHistory3.default;
exports.applyRouterMiddleware = _applyRouterMiddleware3.default;

/* histories */

exports.browserHistory = _browserHistory3.default;
exports.hashHistory = _hashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _DelayRepayService = __webpack_require__(932);

var _DelayRepayService2 = _interopRequireDefault(_DelayRepayService);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DelayRepayActions = {
    subscribe: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user, notifyByPreference) {
            var enableInAppTokenRefreshOnPageLoad;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return _DelayRepayService2.default.subscribe(user, notifyByPreference);

                        case 3:
                            enableInAppTokenRefreshOnPageLoad = _FeatureFlagStore2.default.get('enableInAppTokenRefreshOnPageLoad');

                            // Get the updated user who is now subscribed to OCDR

                            _context.next = 6;
                            return _CustomerActions2.default.refresh(user, enableInAppTokenRefreshOnPageLoad);

                        case 6:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_OCDR_SUBSCRIBE_SUCCESS
                            });
                            _context.next = 12;
                            break;

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](0);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_OCDR_SUBSCRIBE_FAILURE
                            });

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 9]]);
        }));

        function subscribe(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return subscribe;
    }(),
    unsubscribe: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user) {
            var response, enableInAppTokenRefreshOnPageLoad;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _DelayRepayService2.default.unsubscribe(user.id);

                        case 3:
                            response = _context2.sent;
                            enableInAppTokenRefreshOnPageLoad = _FeatureFlagStore2.default.get('enableInAppTokenRefreshOnPageLoad');

                            // Get the updated user who is now unsubscribed from OCDR

                            _context2.next = 7;
                            return _CustomerActions2.default.refresh(user, enableInAppTokenRefreshOnPageLoad);

                        case 7:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_OCDR_UNSUBSCRIBE_SUCCESS
                            });
                            return _context2.abrupt('return', response);

                        case 11:
                            _context2.prev = 11;
                            _context2.t0 = _context2['catch'](0);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_OCDR_UNSUBSCRIBE_FAILURE
                            });
                            return _context2.abrupt('return', false);

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 11]]);
        }));

        function unsubscribe(_x3) {
            return _ref2.apply(this, arguments);
        }

        return unsubscribe;
    }(),
    updateSubscription: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user, notifyByPreference) {
            var enableInAppTokenRefreshOnPageLoad;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _DelayRepayService2.default.subscribe(user, notifyByPreference);

                        case 3:
                            enableInAppTokenRefreshOnPageLoad = _FeatureFlagStore2.default.get('enableInAppTokenRefreshOnPageLoad');

                            // Get the updated user who is now subscribed to OCDR

                            _context3.next = 6;
                            return _CustomerActions2.default.refresh(user, enableInAppTokenRefreshOnPageLoad);

                        case 6:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_OCDR_UPDATE_SUBSCRIPTION_SUCCESS
                            });
                            _context3.next = 12;
                            break;

                        case 9:
                            _context3.prev = 9;
                            _context3.t0 = _context3['catch'](0);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.USER_OCDR_UPDATE_SUBSCRIPTION_FAILURE
                            });

                        case 12:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 9]]);
        }));

        function updateSubscription(_x4, _x5) {
            return _ref3.apply(this, arguments);
        }

        return updateSubscription;
    }()
};

exports.default = DelayRepayActions;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _PaypalPayment = __webpack_require__(666);

var _PaypalPayment2 = _interopRequireDefault(_PaypalPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaypalPaymentDetails(_ref) {
    var payment = _ref.payment,
        small = _ref.small;

    var logo = small ? 'pp-acceptance-small.png' : 'PP_logo_h_100x26.png';

    return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('payment__paypal', { 'payment__paypal--small': small }) },
        _react2.default.createElement('img', { src: 'https://www.paypalobjects.com/webstatic/en_US/i/buttons/' + logo, alt: 'PayPal' }),
        _react2.default.createElement(
            'span',
            { className: 'payment__paypal-account' },
            (0, _I18n2.default)('payment.details.paypal', { paypalAccount: payment.paypalAccount })
        )
    );
}

PaypalPaymentDetails.propTypes = {
    payment: _propTypes2.default.instanceOf(_PaypalPayment2.default).isRequired,
    small: _propTypes2.default.bool
};

PaypalPaymentDetails.defaultProps = {
    small: false
};

exports.default = PaypalPaymentDetails;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AmazonPayPayment = __webpack_require__(667);

var _AmazonPayPayment2 = _interopRequireDefault(_AmazonPayPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonPayPaymentDetails = function AmazonPayPaymentDetails(_ref) {
    var payment = _ref.payment,
        small = _ref.small;
    return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)({ 'payment-details--small': small }) },
        _react2.default.createElement('img', { className: 'payment-details__image payment-details__image--amazon-pay', src: _Assets2.default.assetUrl("images/amazon-pay-only-logo-small.png"), alt: 'Amazon Pay logo' }),
        _react2.default.createElement(
            'span',
            { className: 'payment-details__account-name' },
            (0, _I18n2.default)('payment.details.amazonPay', { amazonPayAccount: payment.amazonPayAccount })
        )
    );
};

AmazonPayPaymentDetails.propTypes = {
    payment: _propTypes2.default.instanceOf(_AmazonPayPayment2.default).isRequired,
    small: _propTypes2.default.bool
};

AmazonPayPaymentDetails.defaultProps = {
    small: false
};

exports.default = AmazonPayPaymentDetails;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

exports.default = SmartcardAppIcons;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmartcardAppIcons(_ref) {
    var toggleAppModal = _ref.toggleAppModal,
        isAppStoreIcon = _ref.isAppStoreIcon,
        isPlayStoreIcon = _ref.isPlayStoreIcon;

    var brand = _config2.default.get('brand');

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        isAppStoreIcon && _react2.default.createElement(
            'button',
            { onClick: toggleAppModal },
            _react2.default.createElement('img', {
                src: '/images/mobile-apps/app-store-icon.png',
                alt: (0, _I18n.translate)('ontrackapp.widget.appstoreButtonAltText')
            })
        ),
        isPlayStoreIcon && _react2.default.createElement(
            'button',
            { onClick: toggleAppModal },
            _react2.default.createElement('img', {
                src: '/images/mobile-apps/play-store-icon.png',
                alt: (0, _I18n.translate)('ontrackapp.widget.googlePlayButtonAltText')
            })
        ),
        _react2.default.createElement(
            'button',
            { onClick: toggleAppModal },
            _react2.default.createElement('img', {
                className: 'app-logo',
                src: '/images/logos/' + brand + '-logo.png',
                alt: (0, _I18n.translate)('ontrackapp.widget.brandAltText', { brand: brand })
            })
        )
    );
}

SmartcardAppIcons.propTypes = {
    toggleAppModal: _propTypes2.default.func,
    isAppStoreIcon: _propTypes2.default.bool,
    isPlayStoreIcon: _propTypes2.default.bool
};

SmartcardAppIcons.defaultProps = {
    toggleAppModal: _noop3.default,
    isAppStoreIcon: false,
    isPlayStoreIcon: false
};

/***/ }),
/* 650 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/*** EXPORTS FROM exports-loader ***/
module.exports = window.fetch;
}.call(window));

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.Pax = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _uuid = __webpack_require__(270);

var _uuid2 = _interopRequireDefault(_uuid);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TicketPassenger = __webpack_require__(1728);

var _TicketPassenger2 = _interopRequireDefault(_TicketPassenger);

var _Ticket = __webpack_require__(353);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pax = exports.Pax = function (_record) {
    (0, _inherits3.default)(Pax, _record);

    function Pax() {
        (0, _classCallCheck3.default)(this, Pax);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Pax.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        json.id = _uuid2.default.v1();
        return (0, _LinkMapper.construct)(Pax, json, {
            id: _LinkMapper.fields.string,
            ticket: _LinkMapper.resolve.as(_Ticket2.default),
            name: _LinkMapper.fields.string,
            orderTicketId: _LinkMapper.fields.number
        });
    };

    Pax.prototype.getError = function getError() {
        var ticket = this.ticket,
            name = this.name;

        return new _TicketPassenger2.default({ ticket: ticket, name: name }).getError('name');
    };

    return Pax;
}((0, _immutable.Record)({ id: '', ticket: null, orderTicketId: null, name: '' }));

var Passengers = function (_record2) {
    (0, _inherits3.default)(Passengers, _record2);

    function Passengers() {
        (0, _classCallCheck3.default)(this, Passengers);
        return (0, _possibleConstructorReturn3.default)(this, _record2.apply(this, arguments));
    }

    Passengers.fromTickets = function fromTickets(ticketType) {
        var tickets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _immutable.List();

        var passengers = new Passengers({ ticketType: ticketType });
        tickets.forEach(function (ticket) {
            passengers = passengers.set('pax', passengers.pax.push(Pax.fromJSON({ ticket: ticket })));
        });
        return passengers;
    };

    Passengers.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Passengers, json, {
            pax: _LinkMapper.resolveAll.as(Pax),
            ticketType: _LinkMapper.resolve.as(_TicketType2.default)
        });
    };

    Passengers.prototype.getRequestJSON = function getRequestJSON() {
        return {
            passengers: this.pax.map(function (pax) {
                return new _TicketPassenger2.default({ ticket: pax.orderTicketId, name: pax.name });
            }).toJS()
        };
    };

    Passengers.prototype.setName = function setName(pax, name) {
        var paxIndex = this.pax.findIndex(function (p) {
            return p.id === pax.id;
        });
        if (paxIndex > -1) {
            return this.setIn(['pax', paxIndex, 'name'], name);
        }
        return this;
    };

    Passengers.prototype.setTicketIds = function setTicketIds(orderTickets) {
        var ticketPool = orderTickets.toSet();
        var passengers = this.pax.map(function (pax) {
            var _pax = pax,
                ticket = _pax.ticket;

            var orderTicket = ticketPool.find(function (ot) {
                return ticket.children === ot.children && ticket.adults === ot.adults && ticket.getIn(['railcard', 'code']) === ot.getIn(['railcard', 'code']);
            });
            if (orderTicket) {
                ticketPool = ticketPool.delete(orderTicket);
                pax = pax.set('orderTicketId', orderTicket.id);
            }
            return pax;
        });
        return this.set('pax', passengers);
    };

    Passengers.prototype.isComplete = function isComplete() {
        return this.pax.every(function (pax) {
            return !pax.getError();
        });
    };

    Passengers.prototype.isEmpty = function isEmpty() {
        return this.pax.size === 0;
    };

    return Passengers;
}((0, _immutable.Record)({ pax: new _immutable.List(), ticketType: null }));

exports.default = Passengers;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isNil2 = __webpack_require__(329);

var _isNil3 = _interopRequireDefault(_isNil2);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "tapId": [_LinkMapper.resolve.with(Number)],
    "locationCode": [_LinkMapper.resolve.with(String)],
    "locationName": [_LinkMapper.resolve.with(String)],
    "operatorName": [_LinkMapper.resolve.with(String)],
    "timestamp": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "type": [_LinkMapper.resolve.with(String)],
    "generationCause": [_LinkMapper.resolve.with(String)],
    "status": [_LinkMapper.resolve.with(String)]
};

var Tap = function (_record) {
    (0, _inherits3.default)(Tap, _record);

    function Tap() {
        (0, _classCallCheck3.default)(this, Tap);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Tap.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Tap, json, (0, _Records.getResolvers)(fieldSchema));
    };

    Tap.prototype.hasLocationCode = function hasLocationCode() {
        return !(0, _isNil3.default)(this.locationCode);
    };

    Tap.prototype.hasLocationName = function hasLocationName() {
        return !(0, _isNil3.default)(this.locationName);
    };

    Tap.prototype.hasTimestamp = function hasTimestamp() {
        return !(0, _isNil3.default)(this.timestamp);
    };

    Tap.prototype.refreshTimestamp = function refreshTimestamp(min, max) {
        var timestamp = this.timestamp || min;
        return this.set('timestamp', _TrainTime2.default.max(min, _TrainTime2.default.min(max, timestamp)));
    };

    Tap.prototype.getTapPairTimestamp = function getTapPairTimestamp() {
        var maxDurationBetweenTaps = _TrainTime2.default.duration(_config2.default.get('keyGoMaxDurationBetweenTaps'));
        if (this.isEntry()) {
            return this.timestamp.clone().add(maxDurationBetweenTaps);
        } else {
            return this.timestamp.clone().subtract(maxDurationBetweenTaps);
        }
    };

    Tap.prototype.isEntry = function isEntry() {
        return this.type === _AppConstants.KeyGoTapTypes.ENTRY;
    };

    Tap.prototype.isExit = function isExit() {
        return this.type === _AppConstants.KeyGoTapTypes.EXIT;
    };

    Tap.prototype.isGenerated = function isGenerated() {
        return this.status === _AppConstants.KeyGoTapStatus.GENERATED;
    };

    Tap.prototype.isCausedBy = function isCausedBy(event) {
        return event ? this.generationCause === event : false;
    };

    Tap.prototype.hasError = function hasError() {
        return this.isCausedBy(_AppConstants.KeyGoTapGenerationCause.UNKNOWN) || this.isCausedBy(_AppConstants.KeyGoTapGenerationCause.AUTOFILL);
    };

    Tap.prototype.isUnknown = function isUnknown() {
        return this.hasError() && this.isCausedBy(_AppConstants.KeyGoTapGenerationCause.UNKNOWN);
    };

    Tap.prototype.isAutofill = function isAutofill() {
        return this.hasError() && this.isCausedBy(_AppConstants.KeyGoTapGenerationCause.AUTOFILL);
    };

    Tap.prototype.isComplete = function isComplete() {
        return !this.hasError() || this.isAutofill();
    };

    return Tap;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Tap;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _Route = __webpack_require__(319);

var _Route2 = _interopRequireDefault(_Route);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _ValidityPeriod = __webpack_require__(395);

var _ValidityPeriod2 = _interopRequireDefault(_ValidityPeriod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "id": [_LinkMapper.fields.string],
    "customerUNID": [_LinkMapper.fields.string],
    "origin": [_LinkMapper.resolve.as(_Station2.default)],
    "destination": [_LinkMapper.resolve.as(_Station2.default)],
    "route": [_LinkMapper.resolve.as(_Route2.default)],
    "ticketType": [_LinkMapper.resolve.as(_TicketType2.default)],
    "saleTicketNumber": [_LinkMapper.fields.number],
    "price": [_LinkMapper.fields.number],
    "validFrom": [_LinkMapper.fields.datetime],
    "validTo": [_LinkMapper.fields.datetime],
    "validityPeriod": [_LinkMapper.resolve.with(_ValidityPeriod2.default.fromString)],
    "adults": [_LinkMapper.fields.number],
    "children": [_LinkMapper.fields.number],
    "ticketClass": [_LinkMapper.fields.string],
    "methodOfPayment": [_LinkMapper.fields.string]
};

var PaperSeasonTicket = function (_record) {
    (0, _inherits3.default)(PaperSeasonTicket, _record);

    function PaperSeasonTicket() {
        (0, _classCallCheck3.default)(this, PaperSeasonTicket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PaperSeasonTicket.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        json = (0, _assign2.default)({ id: (0, _uniqueId3.default)('paperseasonticket') }, json);
        return (0, _LinkMapper.construct)(PaperSeasonTicket, json, (0, _Records.getResolvers)(fieldSchema));
    };

    PaperSeasonTicket.prototype.isStandard = function isStandard() {
        return this.ticketClass === 'Standard';
    };

    PaperSeasonTicket.prototype.isFirstClass = function isFirstClass() {
        return this.ticketClass === "First";
    };

    return PaperSeasonTicket;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = PaperSeasonTicket;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _TicketRefundCalculation = __webpack_require__(836);

var _TicketRefundCalculation2 = _interopRequireDefault(_TicketRefundCalculation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    adminFee: null,
    tickets: null
};

var StoredRefundCalculations = function (_record) {
    (0, _inherits3.default)(StoredRefundCalculations, _record);

    function StoredRefundCalculations() {
        (0, _classCallCheck3.default)(this, StoredRefundCalculations);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    StoredRefundCalculations.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(StoredRefundCalculations, json, {
            adminFee: json.adminFee,
            tickets: (0, _LinkMapper.resolveAll)(json.tickets).as(_TicketRefundCalculation2.default)
        });
    };

    return StoredRefundCalculations;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = StoredRefundCalculations;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1790);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _ReservationLeg = __webpack_require__(1101);

var _ReservationLeg2 = _interopRequireDefault(_ReservationLeg);

var _ReservationStation = __webpack_require__(878);

var _ReservationStation2 = _interopRequireDefault(_ReservationStation);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationJourney = new _immutable.Record({
    id: null,
    origin: new _ReservationStation2.default(),
    destination: new _ReservationStation2.default(),
    ticketType: null,
    routeCode: null,
    type: null,
    legs: new _immutable.List()
});

(0, _assign2.default)(ReservationJourney.prototype, {
    getFirstLeg: function getFirstLeg() {
        var legs = this.get('legs');
        return legs && legs.size > 0 ? legs.first() : null;
    },
    getLastLeg: function getLastLeg() {
        var legs = this.get('legs');
        return legs && legs.size > 0 ? legs.last() : null;
    },
    isDirect: function isDirect() {
        var legs = this.get('legs');
        return legs && legs.size === 1;
    },
    getDepartureTime: function getDepartureTime() {
        var leg = this.getFirstLeg();
        if (leg && leg.departure) {
            return (0, _TrainTime2.default)(leg.departure).format('HH:mm');
        }
        return null;
    },
    getArrivalTime: function getArrivalTime() {
        var leg = this.getFirstLeg();
        if (leg && leg.arrival) {
            return (0, _TrainTime2.default)(leg.arrival).format('HH:mm');
        }
        return null;
    },
    getOriginName: function getOriginName() {
        var leg = this.getFirstLeg();
        return leg && leg.origin && leg.origin.name ? leg.origin.name : '';
    },
    getDestinationName: function getDestinationName() {
        var leg = this.getLastLeg();
        return leg && leg.destination && leg.destination.name ? leg.destination.name : '';
    }
});

ReservationJourney.fromJSON = function (json) {
    return (0, _LinkMapper.construct)(ReservationJourney, json, {
        id: _LinkMapper.fields.string,
        origin: _LinkMapper.resolve.as(_ReservationStation2.default),
        destination: _LinkMapper.resolve.as(_ReservationStation2.default),
        ticketType: _LinkMapper.fields.string,
        routeCode: _LinkMapper.fields.string,
        type: _LinkMapper.fields.string,
        legs: _LinkMapper.resolveAll.as(_ReservationLeg2.default)
    });
};

exports.default = ReservationJourney;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TickIcon = function TickIcon(_ref) {
    var className = _ref.className,
        props = (0, _objectWithoutProperties3.default)(_ref, ['className']);
    return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({ className: (0, _classnames2.default)('otrl-icon__shadow', className), xmlns: 'http://www.w3.org/2000/svg', id: 'svg835', version: '1.1', viewBox: '0 0 74.64 74.64', width: '120', height: '120' }, props),
        _react2.default.createElement('circle', { cx: '35.91', cy: '35.88', r: '22.12', style: { isolation: 'isolate' }, fill: 'currentColor' }),
        _react2.default.createElement('path', { d: 'M32.337 41.753l12.021-12.02a1 1 0 011.414 0 .91.91 0 010 1.287L34.41 42.383a1 1 0 01-1.414 0l-.644-.644z', style: { isolation: 'isolate' }, fill: '#fff' }),
        _react2.default.createElement('path', { d: 'M32.768 42.248l-4.582-4.582a1 1 0 010-1.414.74.74 0 011.047 0l4.766 4.766z', style: { isolation: 'isolate' }, fill: '#fff' })
    );
};

TickIcon.propTypes = {
    className: _propTypes2.default.string
};

TickIcon.defaultProps = {
    className: ''
};

exports.default = TickIcon;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _SmartcardRegistration = __webpack_require__(240);

var _SmartcardRegistration2 = _interopRequireDefault(_SmartcardRegistration);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _Registration = __webpack_require__(355);

var _Registration2 = _interopRequireDefault(_Registration);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _SmartcardRegistrationForm = __webpack_require__(1152);

var _SmartcardRegistrationForm2 = _interopRequireDefault(_SmartcardRegistrationForm);

var _RegisterOptions = __webpack_require__(2003);

var _RegisterOptions2 = _interopRequireDefault(_RegisterOptions);

var _FormWrapper = __webpack_require__(613);

var _FormWrapper2 = _interopRequireDefault(_FormWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterSmartcard = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(RegisterSmartcard, _PureRenderComponent);

    function RegisterSmartcard() {
        (0, _classCallCheck3.default)(this, RegisterSmartcard);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    RegisterSmartcard.prototype.render = function render() {
        var _props = this.props,
            smartcard = _props.smartcard,
            onChange = _props.onChange,
            forceSignup = _props.forceSignup,
            enableSmartcardTransferAtSignUp = _props.enableSmartcardTransferAtSignUp,
            enableKeyGoRegistrationAtSignup = _props.enableKeyGoRegistrationAtSignup,
            hideSmartcardCheckbox = _props.hideSmartcardCheckbox,
            showBenefits = _props.showBenefits,
            submitted = _props.submitted,
            hideSmartcardPromotionalText = _props.hideSmartcardPromotionalText,
            customPromotionalText = _props.customPromotionalText,
            user = _props.user;


        return _react2.default.createElement(
            _FormWrapper2.default,
            { submitted: submitted },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { md: 12 },
                    !hideSmartcardPromotionalText && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: _config2.default.get('smartcardReadMoreUrl'), target: '_blank' },
                            _react2.default.createElement('img', {
                                src: _config2.default.get('registerSmartcardImageUrl'),
                                alt: (0, _I18n2.default)('account.register.smartcard.alt'),
                                className: 'smartcard-signup__image padding--horiz pull-right hidden-mobile'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'smartcard-signup smartcard-checkbox' },
                            _react2.default.createElement(_RegisterOptions2.default, {
                                onChange: onChange,
                                smartcard: smartcard,
                                forceSignup: forceSignup,
                                enableSmartcardTransferAtSignUp: enableSmartcardTransferAtSignUp,
                                enableKeyGoRegistrationAtSignup: enableKeyGoRegistrationAtSignup,
                                hideSmartcardCheckbox: hideSmartcardCheckbox,
                                customPromotionalText: customPromotionalText,
                                showBenefits: showBenefits
                            })
                        )
                    ),
                    (smartcard.withSmartcard() || !user.created) && _react2.default.createElement(_SmartcardRegistrationForm2.default, this.props)
                )
            )
        );
    };

    return RegisterSmartcard;
}(_PureRenderComponent3.default), _class.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    smartcard: _propTypes2.default.instanceOf(_SmartcardRegistration2.default).isRequired,
    user: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_User2.default), _propTypes2.default.instanceOf(_Registration2.default)]),
    badPostcode: _propTypes2.default.string,
    forceSignup: _propTypes2.default.bool,
    enableSmartcardTransferAtSignUp: _propTypes2.default.bool,
    enableKeyGoRegistrationAtSignup: _propTypes2.default.bool,
    onSelectAddress: _propTypes2.default.func.isRequired,
    hideSmartcardCheckbox: _propTypes2.default.bool,
    submitted: _propTypes2.default.bool,
    showBenefits: _propTypes2.default.bool,
    smartcardSubmitted: _propTypes2.default.bool,
    hideSmartcardPromotionalText: _propTypes2.default.bool,
    customPromotionalText: _propTypes2.default.string,
    onAgeToggle: _propTypes2.default.func
}, _class.defaultProps = {
    badPostcode: '',
    forceSignup: false,
    enableSmartcardTransferAtSignUp: false,
    enableKeyGoRegistrationAtSignup: false,
    hideSmartcardCheckbox: false,
    showBenefits: false,
    submitted: false,
    smartcardSubmitted: false,
    hideSmartcardPromotionalText: false,
    onAgeToggle: _noop3.default
}, _temp);
exports.default = RegisterSmartcard;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _PushNotificationsService = __webpack_require__(2027);

var _PushNotificationsService2 = _interopRequireDefault(_PushNotificationsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PushNotificationsActions = {
    getPreference: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var preference;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _PushNotificationsService2.default.checkPushNotificationPreference(user);

                        case 2:
                            preference = _context.sent;
                            return _context.abrupt('return', preference);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function getPreference(_x) {
            return _ref.apply(this, arguments);
        }

        return getPreference;
    }()
};

exports.default = PushNotificationsActions;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(509),
    setCacheAdd = __webpack_require__(1460),
    setCacheHas = __webpack_require__(1461);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 662 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(388);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.cleanEventName = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _invert2 = __webpack_require__(431);

var _invert3 = _interopRequireDefault(_invert2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _isFunction2 = __webpack_require__(202);

var _isFunction3 = _interopRequireDefault(_isFunction2);

exports.location = location;

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _I18n = __webpack_require__(9);

var _HotJar = __webpack_require__(1119);

var _DataLayerEcommerce = __webpack_require__(1666);

var _DataLayerEcommerce2 = _interopRequireDefault(_DataLayerEcommerce);

var _Cookie = __webpack_require__(258);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function location() {
    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search;

    return pathname + search;
}

var cleanEventName = exports.cleanEventName = function cleanEventName(event) {
    return event.toLowerCase().replace(/ |_/g, '-');
};

var DataLayerStore = function (_BaseStore) {
    (0, _inherits3.default)(DataLayerStore, _BaseStore);

    function DataLayerStore() {
        (0, _classCallCheck3.default)(this, DataLayerStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    DataLayerStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.TRACKING_ENABLED] = this.trackingEnabled, _ref[_AppConstants.ActionTypes.TRACKING_DISABLED] = this.trackingDisabled, _ref[_AppConstants.ActionTypes.ROUTE_CHANGED] = this.pageView, _ref[_AppConstants.ActionTypes.MODAL_OPENED] = this.modalOpened, _ref[_AppConstants.ActionTypes.GENERIC_MODAL_OPEN] = this.genericModalOpened, _ref[_AppConstants.ActionTypes.LOGGED_IN] = this.loggedIn, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.simpleEvent, _ref[_AppConstants.ActionTypes.REGISTRATION_SUCCESS] = this.simpleEvent, _ref[_AppConstants.ActionTypes.SMARTCARD_REGISTERED] = this.simpleEvent, _ref[_AppConstants.ActionTypes.SMARTCARD_LINKED] = this.simpleEvent, _ref[_AppConstants.ActionTypes.KEYGO_REGISTRATION_COMPLETE] = this.simpleEvent, _ref[_AppConstants.ActionTypes.STATION_FINDER_SET_EXPANDED] = this.simpleEvent, _ref[_AppConstants.ActionTypes.SEARCH_FINISHED] = this.pointSearch, _ref[_AppConstants.ActionTypes.SEASON_SEARCH_FINISHED] = this.seasonSearch, _ref[_AppConstants.ActionTypes.SHOW_EARLIER_TRAINS_STARTED] = this.earlierLater(_AppConstants.TimeDirections.EARLIER), _ref[_AppConstants.ActionTypes.SHOW_LATER_TRAINS_STARTED] = this.earlierLater(_AppConstants.TimeDirections.LATER), _ref[_AppConstants.ActionTypes.DELIVERY_METHOD] = this.deliveryMethod, _ref[_AppConstants.ActionTypes.PAYMENT_METHOD] = this.paymentMethod, _ref[_AppConstants.ActionTypes.ORDER_PAID] = this.orderPaid, _ref[_AppConstants.ActionTypes.ORDER_CREATED] = this.orderCreated, _ref[_AppConstants.ActionTypes.ORDER_TRIP_CREATED] = this.addToBasket, _ref[_AppConstants.ActionTypes.ORDER_TRIP_DELETED] = this.removeFromBasket, _ref[_AppConstants.ActionTypes.BASKET_CLEARED] = this.event.bind(this, 'order:cleared', null), _ref[_AppConstants.ActionTypes.WIDGET_SEARCH_STATION_SELECT] = this.widgetStationSelector, _ref[_AppConstants.ActionTypes.WIDGET_SEARCH_STATION_SWITCH] = this.widgetStationSwitch, _ref[_AppConstants.ActionTypes.WIDGET_SEARCH_CLICK] = this.widgetSearchClick, _ref[_AppConstants.ActionTypes.WIDGET_SEARCH_DAY_SELECT] = this.widgetDaySelect, _ref[_AppConstants.ActionTypes.FARES_EXPAND] = this.faresExpand, _ref[_AppConstants.ActionTypes.PLUS_BUS_SELECT] = this.plusBusSelect, _ref[_AppConstants.ActionTypes.EXTERNAL_LINK] = this.externalLink, _ref[_AppConstants.ActionTypes.JP_CHANGE_LAYOUT] = this.jpChangeLayout, _ref[_AppConstants.ActionTypes.JP_FARE_CLASS_FILTER_CLICK] = this.jpChangeFareClassFilter, _ref[_AppConstants.ActionTypes.JP_FARE_SELECTION_FILTER_CLICK] = this.jpChangeFareSelectionFilter, _ref[_AppConstants.ActionTypes.JP_TOC_SPECIFIC_FILTER_RENDERED] = this.jpTocSpecificFilterRender, _ref[_AppConstants.ActionTypes.JP_TOC_SPECIFIC_FILTER_CLICK] = this.jpTocSpecificFilterClick, _ref[_AppConstants.ActionTypes.JP_ALL_FARES_ACCORDION_CLICK] = this.jpAllFaresAccordionClick, _ref[_AppConstants.ActionTypes.JP_CHECKOUT_WITH_SUGGESTED_PRODUCTS] = this.jpCheckoutWithSuggestedProducts, _ref[_AppConstants.ActionTypes.JP_CHANGE_SEARCH_TYPE] = this.jpChangedSearchType, _ref[_AppConstants.ActionTypes.TUTORIAL_TOGGLE] = this.handleTutorialToggle, _ref[_AppConstants.ActionTypes.STATION_FINDER_SEARCH_STARTED] = this.stationFinderSearch, _ref[_AppConstants.ActionTypes.STATION_FINDER_STATION_SELECTED] = this.stationFinderSelected, _ref[_AppConstants.ActionTypes.FAVOURITES_ADDED] = this.addFavourite, _ref[_AppConstants.ActionTypes.FAVOURITES_REMOVED] = this.removeFavourite, _ref[_AppConstants.ActionTypes.FAVOURITE_ADDED_TO_BASKET] = this.addFavouriteToBasket, _ref[_AppConstants.ActionTypes.REORDER_ADDED_TO_BASKET] = this.addReorderToBasket, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_CREATED] = this.addDisruptionAlert, _ref[_AppConstants.ActionTypes.DISRUPTION_ALERT_DELETED] = this.deleteDisruptionAlert, _ref[_AppConstants.ActionTypes.AUTO_DR_CLAIM_DISMISSED] = this.event.bind(this, 'page:event:auto_dr_claim_dismissed', null), _ref[_AppConstants.ActionTypes.AUTO_DR_CLAIM_SELECTED] = this.event.bind(this, 'page:event:auto_dr_claim_selected', null), _ref[_AppConstants.ActionTypes.AUTO_DR_CLAIM_SUBMITTED] = this.submitAutoDRClaim, _ref[_AppConstants.ActionTypes.RETURN_TRAVELCARD_CTA_CLICK] = this.returnTravelcardAdded, _ref[_AppConstants.ActionTypes.REFUND_COMPLETE] = this.refundComplete, _ref[_AppConstants.ActionTypes.AMEND_CTA_CLICKED] = this.event.bind(this, 'page:event:amend-cta-clicked', null), _ref[_AppConstants.ActionTypes.AMEND_CONFIRMED] = this.confirmAmendBooking, _ref[_AppConstants.ActionTypes.WIDGETS_RENDER_JP] = this.widgetsRender, _ref[_AppConstants.ActionTypes.WIDGETS_VIEW_RESULTS] = this.widgetsViewResults, _ref[_AppConstants.ActionTypes.RAILCARD_JOBCENTREPLUS_CHECKED] = this.toggleJobcenterPlusRailcard, _ref[_AppConstants.ActionTypes.SHOW_FLEXI_WARNING_MODAL] = this.showFlexiWarningModal, _ref[_AppConstants.ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_CHECKED] = this.flexiWarningModalAcknowledgementCheckboxChecked, _ref[_AppConstants.ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_UNCHECKED] = this.flexiWarningModalAcknowledgementCheckboxUnchecked, _ref[_AppConstants.ActionTypes.FLEXI_WARNING_MODAL_CLOSE] = this.flexiWarningModalClose, _ref[_AppConstants.ActionTypes.FLEXI_WARNING_MODAL_CONTINUE] = this.flexiWarningModalContinue, _ref[_AppConstants.ActionTypes.FLEXI_WARNING_MODAL_MORE_INFO_CLICKED] = this.flexiWarningModalMoreInfoClicked, _ref[_AppConstants.ActionTypes.USER_OPTED_IN] = this.userOptedIn, _ref[_AppConstants.ActionTypes.USER_OPTED_OUT] = this.userOptedOut, _ref[_AppConstants.ActionTypes.SELECT_NOTIFICATION_PREFERENCE] = this.selectNotificationPreference, _ref[_AppConstants.ActionTypes.SELECT_REPAYMENT_METHOD] = this.selectRepaymentMethod, _ref[_AppConstants.ActionTypes.AMEND_NOTIFICATION_PREFERENCE] = this.amendNotificationPreference, _ref[_AppConstants.ActionTypes.AMEND_REPAYMENT_METHOD] = this.amendRepaymentMethod, _ref[_AppConstants.ActionTypes.AMEND_ADDRESS] = this.amendAddress, _ref[_AppConstants.ActionTypes.SAVE_REGULAR_JOURNEY_WITH_OCDR_FAV_JOURNEY] = this.saveRegularJourneyWithOCDRFavJourney, _ref[_AppConstants.ActionTypes.WEBCHAT_OPENED] = this.webchatOpened, _ref[_AppConstants.ActionTypes.BACK_FROM_PAYMENT_PAGE] = this.pageEvent, _ref[_AppConstants.ActionTypes.ADD_ANOTHER_JOURNEY_ON_DELIVERY_PAGE] = this.pageEvent, _ref[_AppConstants.ActionTypes.ADD_ANOTHER_JOURNEY_ON_PAYMENT_PAGE] = this.pageEvent, _ref[_AppConstants.ActionTypes.ADD_ANOTHER_JOURNEY_ON_BASKET_MODAL] = this.modalEvent, _ref[_AppConstants.ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_REMOVED] = this.modalEvent, _ref[_AppConstants.ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_KEPT] = this.modalEvent, _ref[_AppConstants.ActionTypes.CREATE_ACCESSIBILITY_PROFILE_LOADED] = this.createAccessibilityProfile, _ref[_AppConstants.ActionTypes.UPDATE_ACCESSIBILITY_PROFILE_LOADED] = this.updateAccessibilityProfile, _ref[_AppConstants.ActionTypes.BOOK_ASSIST_SUCCESS] = this.bookPassengerAssist, _ref[_AppConstants.ActionTypes.BOOK_MANY_ASSISTS_SUCCESS] = this.bookPassengerAssistWithOrder, _ref[_AppConstants.ActionTypes.CANCEL_ASSISTED_BOOKING_SUCCESS] = this.cancelPassengerAssist, _ref[_AppConstants.ActionTypes.EDIT_ASSISTED_BOOKING_SUCCESS] = this.editPassengerAssist, _ref[_AppConstants.ActionTypes.FETCH_CHILD_SMARTCARD_REPLACEMENT_STARTED] = this.trackChildSmartcardReplacementPageView, _ref[_AppConstants.ActionTypes.REQUEST_CHILD_SMARTCARD_REPLACEMENT_STARTED] = this.trackChildSmartcardReplacementRequest, _ref;
    };

    DataLayerStore.prototype.simpleEvent = function simpleEvent(_ref2) {
        var actionType = _ref2.actionType;

        this.event(actionType.toLowerCase());

        if (actionType === _AppConstants.ActionTypes.LOGGED_OUT) {
            this.removeTripWithPassengerAssist();
        }
    };

    DataLayerStore.prototype.pageEvent = function pageEvent(_ref3) {
        var context = _ref3.context;

        this.event('page:event:' + context);
    };

    DataLayerStore.prototype.modalEvent = function modalEvent(_ref4) {
        var context = _ref4.context;

        this.event('modal:event:' + context);
    };

    DataLayerStore.prototype.event = function event(name, data) {
        if (this.name === 'order:cleared') {
            this.removeTripWithPassengerAssist();
        }

        var dataLayerName = _config2.default.get('gtmDataLayer');
        var enableTracking = this.isTrackingEnabled();

        var user = _UserStore2.default.getCurrent();

        var userID = user && user.customer && user.customer.id;

        if (window.hasOwnProperty(dataLayerName) && enableTracking) {
            var payload = (0, _assign2.default)({
                event: 'OTRL:' + name,
                userID: userID
            }, data);

            window[dataLayerName].push(payload);
        }
    };

    DataLayerStore.prototype.pointSearch = function pointSearch(_ref5) {
        var search = _ref5.search;

        var serialized = search.serialize();

        var data = (0, _assign2.default)(serialized.params, serialized.query, {
            originName: search.origin.name,
            destinationName: search.destination.name,
            journeyType: search.ticketType.toLowerCase(),
            smartcard: search.smartcard
        });
        this.event('search:point', data);
    };

    DataLayerStore.prototype.seasonSearch = function seasonSearch(_ref6) {
        var search = _ref6.search;

        var serialized = search.serialize();

        var data = (0, _assign2.default)(serialized.params, serialized.query, {
            originName: search.origin.name,
            destinationName: search.destination.name,
            smartcard: search.smartcard
        });
        this.event('search:season', data);
    };

    DataLayerStore.prototype.loggedIn = function loggedIn(_ref7) {
        var user = _ref7.user;

        this.event('login', {
            userID: user.id
        });
    };

    DataLayerStore.prototype.pageView = function pageView(_ref8) {
        var routeLocation = _ref8.location;

        var route = _urls2.default.resolve(routeLocation.pathname);
        var title = (0, _I18n.translate)('pageTitles.' + route.name, null, (0, _I18n.translate)('pageTitles.default'));
        this.event('page:' + route.name, {
            'pageURL': location(),
            'pageTitle': title
        });
    };

    DataLayerStore.prototype.widgetStationSelector = function widgetStationSelector(_ref9) {
        var search = _ref9.search;

        this.event('widget-search:event:select-' + search.type, {
            'pageURL': location(),
            'station': search.stationName
        });
    };

    DataLayerStore.prototype.widgetStationSwitch = function widgetStationSwitch() {
        this.event('widget-search:event:station-switch', {
            'pageURL': location()
        });
    };

    DataLayerStore.prototype.widgetSearchClick = function widgetSearchClick(_ref10) {
        var type = _ref10.type;

        this.event('widget-search:event:click-' + type.name, (0, _extends3.default)({}, type.value && { 'value': type.value }, {
            'pageURL': location()
        }));
    };

    DataLayerStore.prototype.widgetDaySelect = function widgetDaySelect(_ref11) {
        var data = _ref11.data;

        this.event('widget-search:event:calendar-day-select' + (data.type ? '-' + data.type : ''), {
            'value': data.date.toDate(),
            'pageURL': location()
        });
    };

    DataLayerStore.prototype.faresExpand = function faresExpand(_ref12) {
        var type = _ref12.type;

        this.event('fares-click:' + cleanEventName(type.name), {
            'pageURL': location()
        });
    };

    DataLayerStore.prototype.plusBusSelect = function plusBusSelect(_ref13) {
        var type = _ref13.type;

        this.event('plus-bus:' + type.action + ':' + type.name, {
            'pageURL': location()
        });
    };

    DataLayerStore.prototype.externalLink = function externalLink(_ref14) {
        var type = _ref14.type;

        this.event('click-external-link:' + type.name, {
            'pageURL': location()
        });
    };

    DataLayerStore.prototype.modalOpened = function modalOpened(_ref15) {
        var type = _ref15.type;

        function functionName(fun) {
            var out = fun.toString();
            out = out.substr('function '.length);
            out = out.substr(0, out.indexOf('('));
            return out;
        }
        if ((0, _isFunction3.default)(type)) {
            type = functionName(type);
        }
        this.event('modal:' + type.toLowerCase(), { 'pageURL': location() });
    };

    DataLayerStore.prototype.genericModalOpened = function genericModalOpened(_ref16) {
        var type = _ref16.type;

        var cleanModalName = cleanEventName(type);
        if (type === _AppConstants.GenericModals.JOURNEY_DETAILS_FORM) {
            (0, _HotJar.hotJarTrigger)(type);
        }
        this.event('modal:' + cleanModalName);
    };

    DataLayerStore.prototype.orderPaid = function orderPaid(_ref17) {
        var order = _ref17.order;

        var data = _DataLayerEcommerce2.default.purchase(order);
        data.extra = {
            'deliveryOption': order.delivery.displayName
        };

        this.event('order:paid', data);
    };

    DataLayerStore.prototype.orderCreated = function orderCreated(_ref18) {
        var order = _ref18.order,
            trip = _ref18.trip;

        this.event('order:started', _DataLayerEcommerce2.default.orderStarted(order.id));
        this.addToBasket({ orderTrip: order.trips.first(), trip: trip });
        this.addTripWithPassengerAssist();
    };

    DataLayerStore.prototype.deliveryMethod = function deliveryMethod(_ref19) {
        var order = _ref19.order,
            _ref19$eventType = _ref19.eventType,
            eventType = _ref19$eventType === undefined ? 'main' : _ref19$eventType;

        if (eventType === 'main') {
            this.event('order:deliveryMethods', _DataLayerEcommerce2.default.deliveryPage(order.id));
        } else {
            this.event('order:deliveryMethodSelected', _DataLayerEcommerce2.default.deliveryMethod(order.id, order.delivery.internalName));
        }
    };

    DataLayerStore.prototype.paymentMethod = function paymentMethod(_ref20) {
        var id = _ref20.id,
            _paymentMethod = _ref20.paymentMethod,
            _ref20$eventType = _ref20.eventType,
            eventType = _ref20$eventType === undefined ? 'main' : _ref20$eventType;

        if (eventType === 'main') {
            this.event('order:paymentMethods', _DataLayerEcommerce2.default.paymentPage(id));
        } else {
            this.event('order:paymentMethodSelected', _DataLayerEcommerce2.default.paymentMethod(id, _paymentMethod));
        }
    };

    DataLayerStore.prototype.addToBasket = function addToBasket(_ref21) {
        var orderTrip = _ref21.orderTrip,
            trip = _ref21.trip;

        var data = _DataLayerEcommerce2.default.addToBasket(orderTrip);
        if (trip.search.targetLayout) {
            data.extra = {
                jpLayout: trip.search.targetLayout.toLowerCase()
            };

            if (trip.search.targetLayout === _AppConstants.JourneyPlannerLayout.GRID || trip.search.targetLayout === _AppConstants.JourneyPlannerLayout.GRID_2) {
                data.extra.preselectedBasket = trip.raw ? 'yes' : 'no';
            }
        }
        this.event('order:addToBasket', data);
        this.addTripWithPassengerAssist();
    };

    DataLayerStore.prototype.removeFromBasket = function removeFromBasket(_ref22) {
        var orderTrip = _ref22.orderTrip;

        this.event('order:removeFromBasket', _DataLayerEcommerce2.default.removeFromBasket(orderTrip));
        this.removeTripWithPassengerAssist();
    };

    DataLayerStore.prototype.returnTravelcardAdded = function returnTravelcardAdded(_ref23) {
        var orderTrip = _ref23.orderTrip;

        if (orderTrip) {
            this.event('order:returnTravelcardUpgrade', _DataLayerEcommerce2.default.addToBasket(orderTrip));
        }
    };

    DataLayerStore.prototype.earlierLater = function earlierLater(timeDirection) {
        var _this2 = this;

        return function (_ref24) {
            var tripDirection = _ref24.tripDirection;

            _this2.event('page:event:' + tripDirection.toLowerCase() + '-' + timeDirection.toLowerCase() + '-click');
        };
    };

    DataLayerStore.prototype.jpChangedSearchType = function jpChangedSearchType(_ref25) {
        var searchType = _ref25.searchType;

        this.event('page:event:changed-search-type-to-' + searchType);
    };

    DataLayerStore.prototype.jpCheckoutWithSuggestedProducts = function jpCheckoutWithSuggestedProducts() {
        this.event('page:event:first-action-add-to-basket');
    };

    DataLayerStore.prototype.jpAllFaresAccordionClick = function jpAllFaresAccordionClick(_ref26) {
        var value = _ref26.value;

        this.event('page:event:view-all-fares-' + (value ? 'open' : 'close'));
    };

    DataLayerStore.prototype.jpTocSpecificFilterClick = function jpTocSpecificFilterClick(_ref27) {
        var value = _ref27.value;

        this.event('page:event:toc-specific-checkbox-' + (value ? 'on' : 'off'));
    };

    DataLayerStore.prototype.jpTocSpecificFilterRender = function jpTocSpecificFilterRender() {
        this.event('page:event:render:toc-specific-filter-rendered');
    };

    DataLayerStore.prototype.jpChangeFareClassFilter = function jpChangeFareClassFilter(_ref28) {
        var fareClass = _ref28.fareClass,
            value = _ref28.value;

        this.event('page:event:' + fareClass + '-checkbox-' + (value ? 'on' : 'off'));
    };

    DataLayerStore.prototype.jpChangeFareSelectionFilter = function jpChangeFareSelectionFilter(_ref29) {
        var selection = _ref29.selection;

        this.event('page:event:filter-' + selection.toLowerCase() + '-selected');
    };

    DataLayerStore.prototype.jpChangeLayout = function jpChangeLayout(_ref30) {
        var layout = _ref30.layout;

        this.event('page:event:' + layout.toLowerCase() + '-tab-click');
    };

    DataLayerStore.prototype.handleTutorialToggle = function handleTutorialToggle(_ref31) {
        var tutorialName = _ref31.tutorialName,
            open = _ref31.open,
            dismissed = _ref31.dismissed,
            lastStage = _ref31.lastStage,
            currentStage = _ref31.currentStage;

        var close = '-close-' + currentStage + '-of-' + lastStage;
        this.event('modal:tutorial-' + tutorialName + (open ? '' : close));
        if (dismissed) {
            this.event('modal:tutorial-' + tutorialName + '-dismissed');
        }
    };

    DataLayerStore.prototype.stationFinderSearch = function stationFinderSearch(_ref32) {
        var searchInteraction = _ref32.searchInteraction,
            latitude = _ref32.latitude,
            longitude = _ref32.longitude;

        this.event('page:event:find-station:' + searchInteraction + ':' + latitude + ',' + longitude);
    };

    DataLayerStore.prototype.stationFinderSelected = function stationFinderSelected(_ref33) {
        var originDest = _ref33.originDest,
            station = _ref33.station;

        this.event('page:event:found-station-used:' + originDest + ':' + station.nlc + '-' + station.name);
    };

    DataLayerStore.prototype.refundComplete = function refundComplete(_ref34) {
        var isFlexiRefund = _ref34.isFlexiRefund;

        this.event('page:event:refund-completed' + (isFlexiRefund ? ':is-flexi' : ''));
    };

    DataLayerStore.prototype.addFavourite = function addFavourite(_ref35) {
        var context = _ref35.context;

        this.event('page:event:favourite-add' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.toggleJobcenterPlusRailcard = function toggleJobcenterPlusRailcard(_ref36) {
        var type = _ref36.type;

        this.event(type);
    };

    DataLayerStore.prototype.removeFavourite = function removeFavourite(_ref37) {
        var context = _ref37.context;

        this.event('page:event:favourite-remove' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.addFavouriteToBasket = function addFavouriteToBasket(_ref38) {
        var success = _ref38.success;

        this.event('page:event:favourite-added-to-basket:' + (success ? 'successful' : 'failed'));
    };

    DataLayerStore.prototype.addReorderToBasket = function addReorderToBasket(_ref39) {
        var success = _ref39.success;

        this.event('page:event:reorder-added-to-basket:' + success);
    };

    DataLayerStore.prototype.addDisruptionAlert = function addDisruptionAlert(_ref40) {
        var context = _ref40.context;

        this.event('page:event:disruption-alert-add' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.deleteDisruptionAlert = function deleteDisruptionAlert(_ref41) {
        var context = _ref41.context;

        this.event('page:event:disruption-alert-delete' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.submitAutoDRClaim = function submitAutoDRClaim(_ref42) {
        var paymentId = _ref42.paymentId,
            editDelayLength = _ref42.editDelayLength;

        var paymentMethodString = (0, _get3.default)((0, _invert3.default)(_AppConstants.DelayRepayPaymentMethod), paymentId).toLowerCase();
        var amendDelayLenth = Boolean(editDelayLength);
        this.event('page:event:auto_dr_claim_submitted:amend-length-' + amendDelayLenth + ':payment-method-' + paymentMethodString);
    };

    DataLayerStore.prototype.confirmAmendBooking = function confirmAmendBooking(_ref43) {
        var description = _ref43.description;

        this.event('page:event:amend-booking-confirmed:' + description, null);
    };

    DataLayerStore.prototype.widgetsRender = function widgetsRender(_ref44) {
        var brand = _ref44.brand,
            tabs = _ref44.tabs,
            version = _ref44.version;

        this.event('widgets:loaded', { brand: brand, tabs: tabs, version: version });
    };

    DataLayerStore.prototype.widgetsViewResults = function widgetsViewResults(_ref45) {
        var brand = _ref45.brand,
            tab = _ref45.tab,
            resultsUrl = _ref45.resultsUrl,
            version = _ref45.version;

        this.event('widgets:search-results:' + tab, { brand: brand, resultsUrl: resultsUrl, version: version });
    };

    DataLayerStore.prototype.trackingEnabled = function trackingEnabled() {
        var cookie = _Cookie2.default.get(_AppConstants.CookieKeys.DO_NOT_TRACK);

        if (cookie) {
            _Cookie2.default.clear(_AppConstants.CookieKeys.DO_NOT_TRACK);
            window.location.reload();
        }
    };

    DataLayerStore.prototype.trackingDisabled = function trackingDisabled() {
        var cookie = _Cookie2.default.get(_AppConstants.CookieKeys.DO_NOT_TRACK);

        if (!cookie) {
            _Cookie2.default.set(_AppConstants.CookieKeys.DO_NOT_TRACK, true);
            window.location.reload();
        }
    };

    DataLayerStore.prototype.isTrackingEnabled = function isTrackingEnabled() {
        return !_Cookie2.default.get(_AppConstants.CookieKeys.DO_NOT_TRACK);
    };

    DataLayerStore.prototype.showFlexiWarningModal = function showFlexiWarningModal(_ref46) {
        var context = _ref46.context;

        this.event('modal:openFlexiKeyGoWarning' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.flexiWarningModalAcknowledgementCheckboxChecked = function flexiWarningModalAcknowledgementCheckboxChecked(_ref47) {
        var context = _ref47.context;

        this.event('modal:flexiKeyGoWarningAcknowledgementCheckboxChecked' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.flexiWarningModalAcknowledgementCheckboxUnchecked = function flexiWarningModalAcknowledgementCheckboxUnchecked(_ref48) {
        var context = _ref48.context;

        this.event('modal:flexiKeyGoWarningAcknowledgementCheckboxUnchecked' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.flexiWarningModalClose = function flexiWarningModalClose(_ref49) {
        var context = _ref49.context;

        this.event('modal:flexiKeyGoWarningClose' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.flexiWarningModalContinue = function flexiWarningModalContinue(_ref50) {
        var context = _ref50.context;

        this.event('modal:flexiKeyGoWarningContinue' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.flexiWarningModalMoreInfoClicked = function flexiWarningModalMoreInfoClicked(_ref51) {
        var context = _ref51.context;

        this.event('modal:flexiKeyGoWarningMoreInfoClicked' + (context ? ':' + context : ''));
    };

    DataLayerStore.prototype.userOptedIn = function userOptedIn(_ref52) {
        var from = _ref52.from;

        this.event('page:event:OCDR-opt-in-' + from);
    };

    DataLayerStore.prototype.userOptedOut = function userOptedOut() {
        this.event('page:event:OCDR-optout');
    };

    DataLayerStore.prototype.webchatOpened = function webchatOpened() {
        this.event('WCWidget:modal:open');
    };

    DataLayerStore.prototype.selectNotificationPreference = function selectNotificationPreference(_ref53) {
        var method = _ref53.method;

        this.event('page:event:OCDR-notification-' + (method ? method : 'none'));
    };

    DataLayerStore.prototype.selectRepaymentMethod = function selectRepaymentMethod(_ref54) {
        var method = _ref54.method;

        this.event('page:event:OCDR-repayment-' + method);
    };

    DataLayerStore.prototype.amendNotificationPreference = function amendNotificationPreference() {
        this.event('page:event:OCDR-notification-amended');
    };

    DataLayerStore.prototype.amendRepaymentMethod = function amendRepaymentMethod() {
        this.event('page:event:OCDR-repayment-amended');
    };

    DataLayerStore.prototype.amendAddress = function amendAddress() {
        this.event('page:event:OCDR-address-ammended');
    };

    DataLayerStore.prototype.saveRegularJourneyWithOCDRFavJourney = function saveRegularJourneyWithOCDRFavJourney() {
        this.event('page:event:OCDR-journey-with-notification');
    };

    DataLayerStore.prototype.createAccessibilityProfile = function createAccessibilityProfile(_ref55) {
        var accessibilityProfile = _ref55.accessibilityProfile;

        this.event('passenger-assist:accessibility-profile-created', { accessibilityProfile: accessibilityProfile });
    };

    DataLayerStore.prototype.updateAccessibilityProfile = function updateAccessibilityProfile(_ref56) {
        var accessibilityProfile = _ref56.accessibilityProfile;

        this.event('passenger-assist:accessibility-profile-updated', { accessibilityProfile: accessibilityProfile });
    };

    DataLayerStore.prototype.bookPassengerAssist = function bookPassengerAssist(_ref57) {
        var bookedAssist = _ref57.bookedAssist,
            context = _ref57.context;

        // Don't fire the event if we're on the payment confirmation page as there is a separate event to track PA bookings from there
        if (context !== 'paymentConfirmation') {
            this.event('passenger-assist:requested', { bookedAssist: bookedAssist });
        }
    };

    DataLayerStore.prototype.bookPassengerAssistWithOrder = function bookPassengerAssistWithOrder(_ref58) {
        var bookedAssist = _ref58.bookedAssist;

        this.event('passenger-assist:added-to-the-order', { bookedAssist: bookedAssist });
    };

    DataLayerStore.prototype.cancelPassengerAssist = function cancelPassengerAssist(_ref59) {
        var sysId = _ref59.sysId;

        this.event('passenger-assist:canceled', { sysId: sysId });
    };

    DataLayerStore.prototype.editPassengerAssist = function editPassengerAssist(_ref60) {
        var passengerAssist = _ref60.passengerAssist;

        this.event('passenger-assist:amended', { passengerAssist: passengerAssist });
    };

    DataLayerStore.prototype.addTripWithPassengerAssist = function addTripWithPassengerAssist() {
        this.event('passenger-assist:added-to-the-order');
    };

    DataLayerStore.prototype.removeTripWithPassengerAssist = function removeTripWithPassengerAssist() {
        this.event('passenger-assist:removed-from-the-order');
    };

    DataLayerStore.prototype.requestPassengerAssistWithOrder = function requestPassengerAssistWithOrder() {
        this.event('passenger-assist:requested-with-order');
    };

    DataLayerStore.prototype.trackChildSmartcardReplacementPageView = function trackChildSmartcardReplacementPageView(_ref61) {
        var userId = _ref61.userId;

        this.event('child-smartcard-replacement:page-view', { userId: userId });
    };

    DataLayerStore.prototype.trackChildSmartcardReplacementRequest = function trackChildSmartcardReplacementRequest(_ref62) {
        var userId = _ref62.userId;

        this.event('child-smartcard-replacement:request:confirm', { userId: userId });
    };

    return DataLayerStore;
}(_BaseStore3.default);

var storeInstance = new DataLayerStore();

exports.default = storeInstance;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    pan: null,
    cardType: null,
    cardHolderName: null,
    expiryDate: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    underReview: null,
    transactionReference: null,
    customerReference: null,
    billingId: null,
    created: null,
    refunded: null,
    latest: null,
    cardArtUrl: null
};

var CardPayment = function (_record) {
    (0, _inherits3.default)(CardPayment, _record);

    function CardPayment() {
        (0, _classCallCheck3.default)(this, CardPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CardPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        return (0, _LinkMapper.construct)(CardPayment, json, {
            id: _LinkMapper.fields.number,
            pan: _LinkMapper.fields.string,
            cardType: _LinkMapper.fields.string,
            cardHolderName: _LinkMapper.fields.string,
            expiryDate: _LinkMapper.fields.string,
            amount: _LinkMapper.fields.number,
            originalAmount: _LinkMapper.fields.number,
            amountRefunded: _LinkMapper.fields.number,
            underReview: _LinkMapper.fields.boolean,
            transactionReference: _LinkMapper.fields.string,
            customerReference: _LinkMapper.fields.string,
            billingId: _LinkMapper.fields.number,
            created: _LinkMapper.fields.datetime,
            refunded: _LinkMapper.fields.boolean,
            latest: _LinkMapper.fields.boolean,
            cardArtUrl: _LinkMapper.fields.string
        });
    };

    CardPayment.prototype.hasExpired = function hasExpired() {
        var expiryDate = (0, _TrainTime2.default)(this.expiryDate, 'MM/YYYY').endOf('month');
        return (0, _TrainTime2.default)().isAfter(expiryDate);
    };

    CardPayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    CardPayment.prototype.isRefundable = function isRefundable() {
        return this.hasAmount();
    };

    CardPayment.prototype.hasLatestPayment = function hasLatestPayment() {
        return this.latest;
    };

    CardPayment.prototype.getPaymentAmount = function getPaymentAmount() {
        return this.amount;
    };

    return CardPayment;
}((0, _immutable.Record)(defaults));

exports.default = CardPayment;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    created: null,
    refunded: null,
    paypalAccount: null
};

var PaypalPayment = function (_record) {
    (0, _inherits3.default)(PaypalPayment, _record);

    function PaypalPayment() {
        (0, _classCallCheck3.default)(this, PaypalPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PaypalPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(PaypalPayment, json, {
            id: _LinkMapper.fields.number,
            amount: _LinkMapper.fields.number,
            amountRefunded: _LinkMapper.fields.number,
            originalAmount: _LinkMapper.fields.number,
            created: _LinkMapper.fields.datetime,
            refunded: _LinkMapper.fields.bool,
            paypalAccount: _LinkMapper.fields.string
        });
    };

    PaypalPayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    PaypalPayment.prototype.isRefundable = function isRefundable() {
        return this.hasAmount();
    };

    return PaypalPayment;
}((0, _immutable.Record)(defaults));

exports.default = PaypalPayment;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    created: null,
    refunded: null,
    amazonPayAccount: null,
    transactionId: null
};

var AmazonPayPayment = function (_record) {
    (0, _inherits3.default)(AmazonPayPayment, _record);

    function AmazonPayPayment() {
        (0, _classCallCheck3.default)(this, AmazonPayPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AmazonPayPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(AmazonPayPayment, json, {
            id: _LinkMapper.fields.number,
            amount: _LinkMapper.fields.number,
            amountRefunded: _LinkMapper.fields.number,
            originalAmount: _LinkMapper.fields.number,
            created: _LinkMapper.fields.datetime,
            refunded: _LinkMapper.fields.bool,
            amazonPayAccount: _LinkMapper.fields.string,
            transactionId: _LinkMapper.fields.string
        });
    };

    AmazonPayPayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    AmazonPayPayment.prototype.isRefundable = function isRefundable() {
        return this.hasAmount();
    };

    return AmazonPayPayment;
}((0, _immutable.Record)(defaults));

exports.default = AmazonPayPayment;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    created: null,
    refunded: null,
    pan: null,
    transactionId: null
};

var GooglePayPayment = function (_record) {
    (0, _inherits3.default)(GooglePayPayment, _record);

    function GooglePayPayment() {
        (0, _classCallCheck3.default)(this, GooglePayPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    GooglePayPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(GooglePayPayment, json, {
            id: _LinkMapper.fields.number,
            amount: _LinkMapper.fields.number,
            amountRefunded: _LinkMapper.fields.number,
            originalAmount: _LinkMapper.fields.number,
            created: _LinkMapper.fields.datetime,
            refunded: _LinkMapper.fields.bool,
            pan: _LinkMapper.fields.string,
            transactionId: _LinkMapper.fields.string
        });
    };

    GooglePayPayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    GooglePayPayment.prototype.isRefundable = function isRefundable() {
        return this.hasAmount();
    };

    return GooglePayPayment;
}((0, _immutable.Record)(defaults));

exports.default = GooglePayPayment;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    created: null,
    refunded: null,
    pan: null,
    transactionId: null
};

var ApplePayPayment = function (_record) {
    (0, _inherits3.default)(ApplePayPayment, _record);

    function ApplePayPayment() {
        (0, _classCallCheck3.default)(this, ApplePayPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ApplePayPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(ApplePayPayment, json, {
            id: _LinkMapper.fields.number,
            amount: _LinkMapper.fields.number,
            amountRefunded: _LinkMapper.fields.number,
            originalAmount: _LinkMapper.fields.number,
            created: _LinkMapper.fields.datetime,
            refunded: _LinkMapper.fields.bool,
            pan: _LinkMapper.fields.string,
            transactionId: _LinkMapper.fields.string
        });
    };

    ApplePayPayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    ApplePayPayment.prototype.isRefundable = function isRefundable() {
        return this.hasAmount();
    };

    return ApplePayPayment;
}((0, _immutable.Record)(defaults));

exports.default = ApplePayPayment;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    amount: null,
    transactionId: null,
    cardPan: null,
    cardType: null,
    created: null,
    refunded: false,
    latest: false
};

var BraintreeCardPayment = function (_record) {
    (0, _inherits3.default)(BraintreeCardPayment, _record);

    function BraintreeCardPayment() {
        (0, _classCallCheck3.default)(this, BraintreeCardPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    BraintreeCardPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(BraintreeCardPayment, json, {
            id: _LinkMapper.fields.number,
            amount: _LinkMapper.fields.number,
            transactionId: _LinkMapper.fields.string,
            cardPan: _LinkMapper.fields.string,
            cardType: _LinkMapper.fields.string,
            created: _LinkMapper.fields.datetime,
            refunded: _LinkMapper.fields.bool,
            latest: _LinkMapper.fields.bool
        });
    };

    BraintreeCardPayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    BraintreeCardPayment.prototype.isRefundable = function isRefundable() {
        return this.hasAmount();
    };

    return BraintreeCardPayment;
}((0, _immutable.Record)(defaults));

exports.default = BraintreeCardPayment;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    inward: false,
    outward: false,
    direction: _AppConstants.SeatingPrefs.NONE,
    position: _AppConstants.SeatingPrefs.NONE,
    seatType: _AppConstants.SeatingPrefs.NONE,
    quietCoach: false,
    nearToilets: false,
    powerSocket: false,
    nearLuggageRack: false
};

var SeatingPreferences = function (_record) {
    (0, _inherits3.default)(SeatingPreferences, _record);

    function SeatingPreferences() {
        (0, _classCallCheck3.default)(this, SeatingPreferences);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SeatingPreferences.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(SeatingPreferences, json, {
            inward: _LinkMapper.resolve.with(Boolean),
            outward: _LinkMapper.resolve.with(Boolean),
            direction: _LinkMapper.resolve.with(String),
            position: _LinkMapper.resolve.with(String),
            seatType: _LinkMapper.resolve.with(String),
            quietCoach: _LinkMapper.resolve.with(Boolean),
            nearToilets: _LinkMapper.resolve.with(Boolean),
            powerSocket: _LinkMapper.resolve.with(Boolean),
            nearLuggageRack: _LinkMapper.resolve.with(Boolean)
        });
    };

    SeatingPreferences.prototype.shouldReserve = function shouldReserve() {
        return this.get('inward') || this.get('outward');
    };

    SeatingPreferences.prototype.shouldReserveDirection = function shouldReserveDirection(direction) {
        var _JourneyDirections$OU;

        return (_JourneyDirections$OU = {}, _JourneyDirections$OU[_AppConstants.JourneyDirections.OUTWARD] = this.get('outward'), _JourneyDirections$OU[_AppConstants.JourneyDirections.INWARD] = this.get('inward'), _JourneyDirections$OU)[direction];
    };

    SeatingPreferences.prototype.toCommonCodes = function toCommonCodes() {
        var codes = [this.direction, this.position, this.seatType];
        if (this.quietCoach) {
            codes.push(_AppConstants.SeatingPrefs.QUIET_COACH);
        }
        if (this.nearToilets) {
            codes.push(_AppConstants.SeatingPrefs.NEAR_TOILET);
        }
        if (this.powerSocket) {
            codes.push(_AppConstants.SeatingPrefs.POWER_SOCKET);
        }
        if (this.nearLuggageRack) {
            codes.push(_AppConstants.SeatingPrefs.NEAR_LUGGAGE);
        }
        return codes;
    };

    SeatingPreferences.prototype.toCodes = function toCodes() {
        return this.shouldReserve() ? this.toCommonCodes() : null;
    };

    SeatingPreferences.prototype.toReservationCodes = function toReservationCodes() {
        return this.toCommonCodes();
    };

    SeatingPreferences.prototype.hasPreferences = function hasPreferences() {
        var before = (0, _omit3.default)(defaults, ['inward', 'outward']);
        var after = (0, _omit3.default)(this.toJS(), ['inward', 'outward']);
        return !(0, _isEqual3.default)(before, after);
    };

    SeatingPreferences.prototype.resetPreferences = function resetPreferences() {
        return this.merge(defaults);
    };

    return SeatingPreferences;
}((0, _immutable.Record)(defaults));

exports.default = SeatingPreferences;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _TransactionHistoryRange = __webpack_require__(1730);

var _TransactionHistoryRange2 = _interopRequireDefault(_TransactionHistoryRange);

var _DailyTransaction = __webpack_require__(1731);

var _DailyTransaction2 = _interopRequireDefault(_DailyTransaction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "range": [_LinkMapper.resolve.as(_TransactionHistoryRange2.default)],
    "dailyTransactions": [_LinkMapper.resolveAll.as(_DailyTransaction2.default)]
};

var TransactionHistoryResults = function (_record) {
    (0, _inherits3.default)(TransactionHistoryResults, _record);

    function TransactionHistoryResults() {
        (0, _classCallCheck3.default)(this, TransactionHistoryResults);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TransactionHistoryResults.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(TransactionHistoryResults, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return TransactionHistoryResults;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = TransactionHistoryResults;

/***/ }),
/* 673 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _tail2 = __webpack_require__(545);

var _tail3 = _interopRequireDefault(_tail2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    customerId: null,
    customerName: null,
    email: null,
    associatedSmartcardNumber: null,
    associatedSmartcardStatus: null,
    isAdult: false,
    isMain: false,
    associationId: null,
    associationStatus: null,
    cardHolderDateOfBirth: null,
    expiryDate: null
};

var SmartcardAssociationInfo = function (_record) {
    (0, _inherits3.default)(SmartcardAssociationInfo, _record);

    function SmartcardAssociationInfo() {
        (0, _classCallCheck3.default)(this, SmartcardAssociationInfo);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartcardAssociationInfo.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new SmartcardAssociationInfo({
            customerId: (0, _LinkMapper.resolve)(json.customerId).with(Number),
            customerName: (0, _LinkMapper.resolve)(json.customerName).with(String),
            email: (0, _LinkMapper.resolve)(json.email).with(String),
            associatedSmartcardNumber: (0, _LinkMapper.resolve)(json.linkedSmartcardNumber).with(String),
            associatedSmartcardStatus: (0, _LinkMapper.resolve)(json.linkedSmartcardStatus).with(String),
            isAdult: (0, _LinkMapper.resolve)(json.isAdult).with(Boolean),
            isMain: (0, _LinkMapper.resolve)(json.isMain).with(Boolean),
            associationId: (0, _LinkMapper.resolve)(json.linkId).with(Number),
            associationStatus: (0, _LinkMapper.resolve)(json.linkStatus).with(String),
            cardHolderDateOfBirth: (0, _LinkMapper.resolve)(json.cardHolderDateOfBirth).with(String),
            expiryDate: (0, _LinkMapper.resolve)(json.expiryDate).with(String)
        });
    };

    SmartcardAssociationInfo.prototype.getCardNumber = function getCardNumber() {
        var associatedSmartcardNumber = this.associatedSmartcardNumber;

        var re = /(\d{6})(\d{4})(\d{4})(\d{4})/;
        var match = associatedSmartcardNumber && associatedSmartcardNumber.match(re);
        if (match) {
            return (0, _tail3.default)(match).join('-');
        }
        return null;
    };

    SmartcardAssociationInfo.prototype.getCustomerName = function getCustomerName() {
        return this.customerName;
    };

    SmartcardAssociationInfo.prototype.getCardHolderDateOfBirthMoment = function getCardHolderDateOfBirthMoment() {
        return this.cardHolderDateOfBirth ? (0, _moment2.default)(this.cardHolderDateOfBirth) : null;
    };

    SmartcardAssociationInfo.prototype.getExpiryDateMoment = function getExpiryDateMoment() {
        return this.expiryDate ? (0, _moment2.default)(this.expiryDate) : null;
    };

    return SmartcardAssociationInfo;
}((0, _immutable.Record)(defaults));

exports.default = SmartcardAssociationInfo;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaults = undefined;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _uuid = __webpack_require__(270);

var _uuid2 = _interopRequireDefault(_uuid);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _Immutable = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = exports.defaults = {
    id: _uuid2.default.v4(),
    tripId: null,
    orderTripId: null,
    journeyId: null,
    departureDate: (0, _moment2.default)(),
    outwardJourney: {},
    returnJourney: {},
    outwardEnabled: true,
    returnEnabled: true
};

var AssistedTravel = function (_record) {
    (0, _inherits3.default)(AssistedTravel, _record);

    function AssistedTravel() {
        (0, _classCallCheck3.default)(this, AssistedTravel);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AssistedTravel.prototype.hasJourney = function hasJourney(journey) {
        return Boolean((0, _keys2.default)((0, _Immutable.isImmutable)(journey) ? journey.toJS() : journey).length);
    };

    AssistedTravel.prototype.removeOutwardJourney = function removeOutwardJourney() {
        return this.set('outwardJourney', {});
    };

    AssistedTravel.prototype.removeReturnJourney = function removeReturnJourney() {
        return this.set('returnJourney', {});
    };

    AssistedTravel.prototype.setOutwardEnabled = function setOutwardEnabled(enabled) {
        return this.set('outwardEnabled', enabled);
    };

    AssistedTravel.prototype.setReturnEnabled = function setReturnEnabled(enabled) {
        return this.set('returnEnabled', enabled);
    };

    AssistedTravel.prototype.hasOutwardJourney = function hasOutwardJourney() {
        return this.hasJourney(this.outwardJourney);
    };

    AssistedTravel.prototype.hasReturnJourney = function hasReturnJourney() {
        return this.returnJourney && Boolean((0, _keys2.default)(this.returnJourney).length);
    };

    AssistedTravel.prototype.getOutwardArrivalMoment = function getOutwardArrivalMoment() {
        return (0, _moment2.default)(this.outwardJourney.arrivalDate, 'DD/MM/YYYY').set({ hour: this.outwardJourney.arrivalHour, minute: this.outwardJourney.arrivalMinutes });
    };

    AssistedTravel.prototype.getReturnDepartureMoment = function getReturnDepartureMoment() {
        return (0, _moment2.default)(this.returnJourney.departureDate, 'DD/MM/YYYY').set({ hour: this.returnJourney.departureHour, minute: this.returnJourney.departureMinutes });
    };

    AssistedTravel.prototype.getJourneyDepartureMoment = function getJourneyDepartureMoment(journey) {
        return (0, _moment2.default)(journey.departureDate, 'DD/MM/YYYY').set({ hour: journey.departureHour, minute: journey.departureMinutes });
    };

    AssistedTravel.prototype.getJourneyArrivalMoment = function getJourneyArrivalMoment(journey) {
        return (0, _moment2.default)(journey.arrivalDate, 'DD/MM/YYYY').set({ hour: journey.arrivalHour, minute: journey.arrivalMinutes });
    };

    AssistedTravel.prototype.getFormatedDepartureDate = function getFormatedDepartureDate() {
        return this.departureDate.format('D MMMM YYYY');
    };

    return AssistedTravel;
}((0, _immutable.Record)(defaults));

exports.default = AssistedTravel;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ReservationRequestStore = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _ReservationRequest = __webpack_require__(1100);

var _ReservationRequest2 = _interopRequireDefault(_ReservationRequest);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    reservationRequest: new _ReservationRequest2.default(),
    outwardService: null,
    outwardFare: null,
    inwardService: null,
    inwardFare: null
});

var defaultState = new State();

var ReservationRequestStore = exports.ReservationRequestStore = function (_BaseStore) {
    (0, _inherits3.default)(ReservationRequestStore, _BaseStore);

    function ReservationRequestStore() {
        (0, _classCallCheck3.default)(this, ReservationRequestStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    ReservationRequestStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return defaultState.merge({
                reservationRequest: (0, _LinkMapper.resolve)(serialized.reservationRequest).as(_ReservationRequest2.default)
            });
        }

        return defaultState;
    };

    ReservationRequestStore.prototype.getState = function getState() {
        return this.state;
    };

    ReservationRequestStore.prototype.getAvailabilityParams = function getAvailabilityParams() {
        return (0, _extends3.default)({}, this.state.get('selectedFare'), this.state.get('selectedJourneys'), this.state.get('bikesCount'), this.state.get('passengersCount'));
    };

    ReservationRequestStore.prototype.getInwardFare = function getInwardFare() {
        return this.state.get('inwardFare');
    };

    ReservationRequestStore.prototype.getOutwardFare = function getOutwardFare() {
        return this.state.get('outwardFare');
    };

    ReservationRequestStore.prototype.handleClear = function handleClear() {
        this.setState(defaultState);
    };

    ReservationRequestStore.prototype.getReservationRequest = function getReservationRequest() {
        return this.state.get('reservationRequest');
    };

    ReservationRequestStore.prototype.setPassengers = function setPassengers(_ref) {
        var passengers = _ref.passengers;

        this.setState(this.state.set('reservationRequest', this.state.get('reservationRequest').set('passengers', new _immutable.List(passengers))));
    };

    ReservationRequestStore.prototype.setBikes = function setBikes(_ref2) {
        var bikesQty = _ref2.bikesQty;

        this.setState(this.state.set('reservationRequest', this.state.get('reservationRequest').set('bikes', bikesQty)));
    };

    ReservationRequestStore.prototype.setRequestSeats = function setRequestSeats(_ref3) {
        var requestSeats = _ref3.requestSeats;

        this.setState(this.state.set('reservationRequest', this.state.get('reservationRequest').set('requestSeats', requestSeats)));
    };

    ReservationRequestStore.prototype.setOutwardService = function setOutwardService(_ref4) {
        var journey = _ref4.journey;

        this.setState(this.state.set('outwardService', journey));
        this.emitChange();
    };

    ReservationRequestStore.prototype.resetOutwardService = function resetOutwardService() {
        this.setState(this.state.set('outwardService', null));
        this.emitChange();
    };

    ReservationRequestStore.prototype.setInwardService = function setInwardService(_ref5) {
        var journey = _ref5.journey;

        this.setState(this.state.set('inwardService', journey));
        this.emitChange();
    };

    ReservationRequestStore.prototype.resetInwardService = function resetInwardService() {
        this.setState(this.state.set('inwardService', null));
        this.emitChange();
    };

    ReservationRequestStore.prototype.setOutwardFare = function setOutwardFare(_ref6) {
        var fare = _ref6.fare;

        this.setState(this.state.set('outwardFare', fare));
        this.emitChange();
    };

    ReservationRequestStore.prototype.resetOutwardFare = function resetOutwardFare() {
        this.setState(this.state.set('outwardFare', null));
        this.emitChange();
    };

    ReservationRequestStore.prototype.setInwardFare = function setInwardFare(_ref7) {
        var fare = _ref7.fare;

        this.setState(this.state.set('inwardFare', fare));
        this.emitChange();
    };

    ReservationRequestStore.prototype.resetInwardFare = function resetInwardFare() {
        this.setState(this.state.set('inwardFare', null));
        this.emitChange();
    };

    ReservationRequestStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref8;

        return _ref8 = {}, _ref8[_AppConstants.ActionTypes.SET_RESERVATION_REQUEST_PASSENGERS] = this.setPassengers, _ref8[_AppConstants.ActionTypes.SET_RESERVATION_REQUEST_BIKES] = this.setBikes, _ref8[_AppConstants.ActionTypes.CLEAR_RESERVATION_REQUEST_STORE] = this.handleClear, _ref8[_AppConstants.ActionTypes.CREATE_RESERVATION_FAILED] = this.handleClear, _ref8[_AppConstants.ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_SERVICE] = this.setOutwardService, _ref8[_AppConstants.ActionTypes.SET_RESERVATION_REQUEST_INBOUND_SERVICE] = this.setInwardService, _ref8[_AppConstants.ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_FARE] = this.setOutwardFare, _ref8[_AppConstants.ActionTypes.SET_RESERVATION_REQUEST_INBOUND_FARE] = this.setInwardFare, _ref8[_AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_SERVICE] = this.resetOutwardService, _ref8[_AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_SERVICE] = this.resetInwardService, _ref8[_AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_FARE] = this.resetOutwardFare, _ref8[_AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_FARE] = this.resetInwardFare, _ref8[_AppConstants.ActionTypes.SET_RESERVATION_REQUEST_SEATS] = this.setRequestSeats, _ref8;
    };

    return ReservationRequestStore;
}(_BaseStore3.default);

var instance = new ReservationRequestStore({ storageKey: 'reservation-request' });

exports.default = instance;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(143),
    isObjectLike = __webpack_require__(104);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _BaseModal = __webpack_require__(29);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _AddressLineOne = __webpack_require__(276);

var _AddressLineOne2 = _interopRequireDefault(_AddressLineOne);

var _AddressLineTwo = __webpack_require__(983);

var _AddressLineTwo2 = _interopRequireDefault(_AddressLineTwo);

var _AddressLineThree = __webpack_require__(984);

var _AddressLineThree2 = _interopRequireDefault(_AddressLineThree);

var _TownCity = __webpack_require__(985);

var _TownCity2 = _interopRequireDefault(_TownCity);

var _Postcode = __webpack_require__(986);

var _Postcode2 = _interopRequireDefault(_Postcode);

var _Country = __webpack_require__(987);

var _Country2 = _interopRequireDefault(_Country);

var _PostCodeLookUp = __webpack_require__(988);

var _PostCodeLookUp2 = _interopRequireDefault(_PostCodeLookUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerPostalAddress = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(CustomerPostalAddress, _React$PureComponent);

    function CustomerPostalAddress() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomerPostalAddress);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            showAddressFields: !_FeatureFlagStore2.default.get('enablePostCodeLookUp')
        }, _this._handleAddressLookup = function () {
            (0, _defer3.default)(function () {
                var addressSelect = document.querySelector('.otrl-postal-address-select');
                var smartcardRow = document.querySelector('.register-smartcard-top-row');
                if (addressSelect && smartcardRow) {
                    var addressSelectTop = addressSelect.getBoundingClientRect().top;
                    var registerTopRowTop = smartcardRow.getBoundingClientRect().top;
                    (0, _BaseModal.baseModalScrollTo)({ top: addressSelectTop - registerTopRowTop });
                }
            });
        }, _this._handleSelectAddress = function (address) {
            var index = _this.props.index;

            _this.setState({ showAddressFields: true });

            // Wait until React displays additional address fields between the address selector
            // and the date of birth drop downs.
            (0, _defer3.default)(function () {
                var dateOfBirthSelect = document.querySelector('.date-of-birth__select');
                var smartcardRow = document.querySelector('.register-smartcard-top-row');
                if (dateOfBirthSelect && smartcardRow) {
                    var dateOfBirthTop = dateOfBirthSelect.getBoundingClientRect().top;
                    var registerTopRowTop = smartcardRow.getBoundingClientRect().top;
                    (0, _BaseModal.baseModalScrollTo)({ top: dateOfBirthTop - registerTopRowTop });
                }
            });

            if (index >= 0 && index !== null) {
                _this.props.onSelectAddress(address, null, index);
            } else {
                _this.props.onSelectAddress(address);
            }
        }, _this._handleToggleShowAddress = function () {
            _this.setState({ showAddressFields: !_this.state.showAddressFields });
        }, _this._handleClearAddress = function () {
            _this.props.onSelectAddress(new _Address2.default());
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    CustomerPostalAddress.prototype.render = function render() {
        var showAddressFields = this.state.showAddressFields;
        var _props = this.props,
            label = _props.label,
            form = _props.form,
            alwaysShowAddressFields = _props.alwaysShowAddressFields,
            outsideLabel = _props.outsideLabel;

        return _react2.default.createElement(
            'div',
            { className: 'postal-address' },
            _react2.default.createElement(
                _Col2.default,
                { md: 12 },
                _react2.default.createElement(
                    'p',
                    { className: 'label' },
                    (0, _I18n.translate)(label)
                )
            ),
            _react2.default.createElement(
                _Col2.default,
                { md: 12 },
                _react2.default.createElement(_PostCodeLookUp2.default, { country: form.get('country'),
                    outsideLabel: outsideLabel,
                    onFoundAddressList: this._handleAddressLookup,
                    onSelectAddress: this._handleSelectAddress,
                    cols: { xs: 12, md: 6 } })
            ),
            _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, className: (0, _classnames2.default)('manual-address-col', { 'manual-address-col--no-margin': showAddressFields || alwaysShowAddressFields }) },
                    !showAddressFields && !alwaysShowAddressFields && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _Button2.default,
                            { className: 'btn-link manual-address-btn postal-address__manual-button', onClick: this._handleToggleShowAddress },
                            (0, _I18n.translate)('address.enterManually')
                        )
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, className: 'clear-address-col' },
                    (showAddressFields || alwaysShowAddressFields) && _react2.default.createElement(
                        _Button2.default,
                        { bsStyle: 'default', className: 'btn-default clear', onClick: this._handleClearAddress },
                        (0, _I18n.translate)('address.clearAddress')
                    )
                )
            ),
            (showAddressFields || alwaysShowAddressFields) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, xs: 12 },
                    _react2.default.createElement(_AddressLineOne2.default, (0, _extends3.default)({}, this.props, { required: true }))
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, xs: 12 },
                    _react2.default.createElement(_AddressLineTwo2.default, this.props)
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, xs: 12 },
                    _react2.default.createElement(_AddressLineThree2.default, this.props)
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, xs: 12 },
                    _react2.default.createElement(_TownCity2.default, (0, _extends3.default)({}, this.props, { required: true }))
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, xs: 12 },
                    _react2.default.createElement(_Postcode2.default, (0, _extends3.default)({}, this.props, { required: true }))
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 6, xs: 12 },
                    _react2.default.createElement(_Country2.default, (0, _extends3.default)({}, this.props, { disabled: true }))
                )
            )
        );
    };

    return CustomerPostalAddress;
}(_react2.default.PureComponent), _class.propTypes = {
    label: _propTypes2.default.string.isRequired,
    outsideLabel: _propTypes2.default.bool,
    validation: _propTypes2.default.object,
    onSelectAddress: _propTypes2.default.func.isRequired,
    visited: _propTypes2.default.bool,
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    alwaysShowAddressFields: _propTypes2.default.bool,
    index: _propTypes2.default.number
}, _class.defaultProps = {
    validation: null,
    visited: false,
    disabled: false,
    alwaysShowAddressFields: false,
    index: null
}, _temp2);
exports.default = CustomerPostalAddress;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RegisterSuccessModal = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _PropTypes = __webpack_require__(85);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AppConstants = __webpack_require__(6);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _TickIcon = __webpack_require__(658);

var _TickIcon2 = _interopRequireDefault(_TickIcon);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

var _RegisterHello = __webpack_require__(926);

var _RegisterHello2 = _interopRequireDefault(_RegisterHello);

var _Select = __webpack_require__(425);

var _Select2 = _interopRequireDefault(_Select);

var _ProgressBar = __webpack_require__(642);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISABLED_TIME_SECONDS = 10;

var successOptions = [{
    option: 'account.register.findDayTicketButtonText',
    location: _AppConstants.PointStages.SEARCH,
    extra: null,
    shouldInclude: function shouldInclude(props) {
        return !!props.smartcard && props.enableDayTicketPreload && props.smartcard.isAwaitingProduct();
    }
}, {
    option: 'account.register.findSeasonTicketButtonText',
    location: _AppConstants.SeasonStages.SEARCH,
    extra: null,
    shouldInclude: function shouldInclude(props) {
        return !!props.smartcard && props.productPreloadEnabled && props.smartcard.isAwaitingProduct();
    }
}, {
    option: 'account.register.transferTicketButtonText',
    location: _AppConstants.AccountPages.SMARTCARD_TRANSFER,
    extra: null,
    shouldInclude: function shouldInclude(props) {
        return props.smartcardPaperTransfersEnabled;
    }
}, {
    option: 'account.register.keygoButtonText',
    location: _AppConstants.AccountPages.SMARTCARD_KEYGO,
    extra: null,
    shouldInclude: function shouldInclude(props) {
        return props.enableKeyGoRegistrationAtSignup;
    }
}, {
    option: 'account.register.ocdrButtonText',
    extra: null,
    location: _AppConstants.AccountPages.ONE_CLICK_DELAY_REPAY,
    shouldInclude: function shouldInclude(props) {
        return props.oneClickDelayRepayEnabled;
    }
}];

var RegisterSuccessModal = exports.RegisterSuccessModal = function RegisterSuccessModal(props) {
    var timeoutID = null;

    var _useState = (0, _react.useState)({
        disabledWaitTime: DISABLED_TIME_SECONDS,
        timeCompleted: 0,
        selectedOption: null,
        isSubscribeModalOpen: false
    }),
        state = _useState[0],
        setComponentState = _useState[1];

    (0, _react.useEffect)(function () {
        var smartcard = props.smartcard;

        var isSmartcardAwaitingProduct = smartcard && smartcard.isAwaitingProduct();

        if (isSmartcardAwaitingProduct) {
            startCountdown();
        }
        return function () {
            clearTimeout(timeoutID);

            // Hacky! Scroll to the top of the app so that user can see the logged-in version of the header
            setTimeout(function () {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }, 500);
        };
        // eslint-disable-next-line
    }, []);

    var startCountdown = function startCountdown() {
        var timeleft = state.disabledWaitTime;
        var countdown = function countdown() {
            timeleft = timeleft - 1;
            setComponentState((0, _extends3.default)({}, state, {
                disabledWaitTime: timeleft,
                timeCompleted: DISABLED_TIME_SECONDS - (timeleft + 1)
            }));
            if (timeleft) {
                timeoutID = setTimeout(countdown, props.disableSuccessDropdown ? 0 : 1000);
            } else {
                var nextCtaScrollTop = (document.querySelector('.modal button') || document.querySelector('.modal select')).getBoundingClientRect().top;
                (0, _BaseModal.baseModalScrollTo)({ top: nextCtaScrollTop });
            }
        };

        countdown();
    };

    var handleCancel = function handleCancel() {
        var onSuccessClose = props.onSuccessClose;

        if (onSuccessClose) {
            onSuccessClose();
        }
        _ModalActions2.default.close();
    };

    var handleSelect = function handleSelect(event) {
        var selectedVal = event.target.value;
        var selectedOption = getSuccessActions().find(function (_ref) {
            var location = _ref.location;
            return location === selectedVal;
        });
        if (selectedOption) {
            setComponentState((0, _extends3.default)({}, state, { selectedOption: selectedOption }));
        }
    };

    var handleContinue = function handleContinue() {
        var selectedOption = state.selectedOption;
        var onOptInADR = props.onOptInADR;


        if (selectedOption.location === _AppConstants.AccountPages.ONE_CLICK_DELAY_REPAY) {
            onOptInADR();
            handleCancel();
        } else {
            pushRoute(selectedOption.location, null, selectedOption.extra);
        }
    };

    var pushRoute = function pushRoute(page, param, other) {
        props.router.push(_urls2.default.location(page, param, other));
        _ModalActions2.default.close();
    };

    var getSuccessActions = function getSuccessActions() {
        return successOptions.filter(function (opt) {
            return opt.shouldInclude(props);
        });
    };

    var onContinue = function onContinue() {
        var onOptInADR = props.onOptInADR;

        if (smartcardOnly) {
            handleCancel();
        } else {
            onOptInADR();
            // handleCancel();
        }
    };

    var smartcard = props.smartcard,
        smartcardOnly = props.smartcardOnly,
        productPreloadEnabled = props.productPreloadEnabled,
        enableKeyGoRegistrationAtSignup = props.enableKeyGoRegistrationAtSignup,
        disableSuccessDropdown = props.disableSuccessDropdown,
        user = props.user;
    var disabledWaitTime = state.disabledWaitTime,
        selectedOption = state.selectedOption,
        timeCompleted = state.timeCompleted;

    var isSmartcardAwaitingProduct = !!smartcard && productPreloadEnabled && smartcard.isAwaitingProduct();

    var modalProps = {
        disableBlur: !disableSuccessDropdown,
        disableEscape: !disableSuccessDropdown,
        titleText: smartcardOnly ? 'account.register.smartcardOnlySuccess' : 'account.register.success',
        continueText: 'auto-dr.account.signup',
        closeText: 'button.text.close',
        onContinue: onContinue,
        onClose: handleCancel,
        hideContinue: smartcard ? true : !_FeatureFlagStore2.default.get('enableOneClickDelayRepay'),
        className: 'modal--sm register-success-modal',
        header: false,
        showCloseFooterButton: true
    };

    if (isSmartcardAwaitingProduct) {
        (0, _assign2.default)(modalProps, {
            disableClose: !!disabledWaitTime,
            disableContinue: !!disabledWaitTime
        });
    }

    var preloadTimeLimit = _react2.default.createElement(
        'strong',
        null,
        _TrainTime2.default.duration(_config2.default.get('smartcardPreloadTimeLimit')).humanize()
    );
    var awaitSmartcardProductDays = _react2.default.createElement(
        'strong',
        null,
        (0, _TrainTime2.default)().addWorkingDays(_config2.default.get('minAwaitingSmartcardProductDays')).format('DD-MMM-YY')
    );

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'div',
                { className: 'vertical-align-parent full-height' },
                _react2.default.createElement(
                    'div',
                    {
                        className: (0, _classnames2.default)('confirmation text-center', {
                            'vertical-align': !isSmartcardAwaitingProduct
                        })
                    },
                    isSmartcardAwaitingProduct && _react2.default.createElement(_ProgressBar2.default, {
                        completed: timeCompleted,
                        total: DISABLED_TIME_SECONDS - 2
                    }),
                    _react2.default.createElement(_TickIcon2.default, null),
                    _react2.default.createElement(_RegisterHello2.default, { name: user.firstNames }),
                    smartcard ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _I18n2.default)('account.register.smartcardApplicationReceived'),
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    disabled: !!disabledWaitTime,
                                    onClick: handleCancel,
                                    to: _AppConstants.AccountPages.SMARTCARD_APPLY
                                },
                                (0, _I18n2.default)('account.register.viewAccount')
                            ),
                            '.\xA0'
                        ),
                        smartcardOnly && _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enableAutoDelayRepay' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                                    message: 'preference-centre.auto-delay-repay.link',
                                    preferenceCentreLink: _react2.default.createElement(
                                        _Link2.default,
                                        {
                                            disabled: !!disabledWaitTime,
                                            onClick: handleCancel,
                                            to: _AppConstants.AccountPages.ACCOUNT_PREFERENCE_CENTRE,
                                            absolute: true
                                        },
                                        (0, _I18n2.default)('preference-centre.linkName')
                                    )
                                })
                            )
                        )
                    ) : _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableOneClickDelayRepay' },
                        _react2.default.createElement(
                            'div',
                            { className: 'margin-top--md margin-bottom--sm text-left' },
                            _react2.default.createElement(
                                'h2',
                                { className: 'auto-dr__header auto-dr__header--post-registration' },
                                _react2.default.createElement('img', {
                                    src: _Assets2.default.assetUrl('images/1CDR-arrows.png'),
                                    alt: (0, _I18n2.default)('auto-dr.account.arrows'),
                                    className: 'titleImg'
                                }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'adr-title' },
                                    (0, _I18n2.default)('auto-dr.subscribe.heading')
                                )
                            ),
                            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'auto-dr.postRegistrationSignUp.info', splitParagraphs: true })
                        )
                    ),
                    isSmartcardAwaitingProduct && _react2.default.createElement(
                        'div',
                        { className: 'margin-top' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                                message: disableSuccessDropdown ? 'account.register.smartcardActivation' : enableKeyGoRegistrationAtSignup ? 'account.register.keyGoPreload' : 'account.register.smartcardPreload',
                                buyTicketsLink: _react2.default.createElement(
                                    _Link2.default,
                                    {
                                        to: _AppConstants.SeasonStages.SEARCH,
                                        query: { smartcard: true },
                                        absolute: true
                                    },
                                    (0, _I18n2.default)('account.register.smartcardPreload.new')
                                ),
                                paperTransferLink: _react2.default.createElement(
                                    _Link2.default,
                                    { to: _AppConstants.AccountPages.SMARTCARD_TRANSFER, absolute: true },
                                    (0, _I18n2.default)('account.register.smartcardPreload.existing')
                                ),
                                preloadTimeLimit: preloadTimeLimit,
                                awaitSmartcardProductDays: awaitSmartcardProductDays
                            })
                        ),
                        !disableSuccessDropdown && _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, sm: 12, className: 'margin-top--sm' },
                            _react2.default.createElement(
                                'div',
                                { className: 'register-modal__success__dropdown-wrapper' },
                                _react2.default.createElement(
                                    _Col2.default,
                                    { xs: 9 },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'register-modal__success-dropdown select-container' },
                                        _react2.default.createElement(
                                            'label',
                                            {
                                                className: 'sr-only',
                                                htmlFor: 'option__selector'
                                            },
                                            (0, _I18n2.default)('account.register.whatsNext')
                                        ),
                                        _react2.default.createElement(
                                            _Select2.default,
                                            {
                                                id: 'option__selector',
                                                type: 'select',
                                                onChange: handleSelect,
                                                disabled: !!disabledWaitTime
                                            },
                                            _react2.default.createElement(
                                                'option',
                                                {
                                                    value: -1,
                                                    key: -1,
                                                    disabled: true,
                                                    selected: true
                                                },
                                                (0, _I18n2.default)('account.register.whatsNext')
                                            ),
                                            getSuccessActions().map(function (_ref2) {
                                                var option = _ref2.option,
                                                    location = _ref2.location;
                                                return _react2.default.createElement(
                                                    'option',
                                                    {
                                                        value: location,
                                                        key: location
                                                    },
                                                    (0, _I18n2.default)(option)
                                                );
                                            })
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    _Col2.default,
                                    { xs: 3 },
                                    _react2.default.createElement(
                                        'button',
                                        {
                                            className: (0, _classnames2.default)('register-modal__success-button action-btn action-btn--primary modal__footer__button modal__footer__button--primary', {
                                                'modal__footer__button--inactive': !selectedOption
                                            }),
                                            onClick: handleContinue,
                                            disabled: !selectedOption
                                        },
                                        _react2.default.createElement(_Icon2.default, {
                                            icon: 'arrowrightslim',
                                            className: 'modal__footer__button__arrow'
                                        }),
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'modal__footer__button__text' },
                                            (0, _I18n2.default)('account.register.partialSuccess.button')
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

RegisterSuccessModal.propTypes = {
    router: _PropTypes.routerShape,
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    smartcardOnly: _propTypes2.default.bool,
    productPreloadEnabled: _propTypes2.default.bool,
    smartcardPaperTransfersEnabled: _propTypes2.default.bool,
    enableKeyGoRegistrationAtSignup: _propTypes2.default.bool,
    disableSuccessDropdown: _propTypes2.default.bool,
    enableDayTicketPreload: _propTypes2.default.bool,
    onSuccessClose: _propTypes2.default.func,
    user: _propTypes2.default.obj,
    onOptInADR: _propTypes2.default.func
};

RegisterSuccessModal.defaultProps = {
    smartcard: null,
    smartcardOnly: false,
    disableSuccessDropdown: false,
    enableDayTicketPreload: false
};

function getStateFromStores() {
    return {
        productPreloadEnabled: _FeatureFlagStore2.default.get('enableProductPreload'),
        smartcardPaperTransfersEnabled: _FeatureFlagStore2.default.get('enableSmartcardPaperTransfers'),
        enableKeyGoRegistrationAtSignup: _FeatureFlagStore2.default.get('enableKeyGoRegistrationAtSignup'),
        enableDayTicketPreload: _FeatureFlagStore2.default.get('enableDayTicketPreload'),
        user: _UserStore2.default.getCurrent()
    };
}

exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default, _UserStore2.default], getStateFromStores)((0, _withRouter2.default)(RegisterSuccessModal));

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrBar = function OrBar(_ref) {
    var className = _ref.className,
        horizontal = _ref.horizontal,
        tablet = _ref.tablet;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('or-bar', {
                'or-bar--tablet': tablet,
                'or-bar--horizontal': horizontal
            }, className) },
        _react2.default.createElement('span', { className: 'or-bar__bar' }),
        _react2.default.createElement(
            'span',
            { className: 'or-bar__text' },
            (0, _I18n2.default)('orBar.or')
        ),
        _react2.default.createElement('span', { className: 'or-bar__bar' })
    );
};

OrBar.propTypes = {
    className: _propTypes2.default.string,
    horizontal: _propTypes2.default.bool,
    tablet: _propTypes2.default.bool
};

OrBar.defaultProps = {
    className: '',
    horizontal: false,
    tablet: false
};

exports.default = OrBar;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _isNull2 = __webpack_require__(451);

var _isNull3 = _interopRequireDefault(_isNull2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorModal(_ref) {
    var heading = _ref.heading,
        title = _ref.title,
        message = _ref.message,
        closeText = _ref.closeText,
        onClose = _ref.onClose,
        _ref$customButton = _ref.customButton,
        customButton = _ref$customButton === undefined ? {} : _ref$customButton;


    function _getModalProps(headingText, _ref2) {
        var _this = this;

        var _ref2$text = _ref2.text,
            text = _ref2$text === undefined ? null : _ref2$text,
            _ref2$onClick = _ref2.onClick,
            onClick = _ref2$onClick === undefined ? _noop3.default : _ref2$onClick;

        var closeHandler = function closeHandler() {
            _ModalActions2.default.close(_AppConstants.GlobalModals.ERROR);
            onClose();
        };
        var customHandler = function customHandler() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            onClick.call.apply(onClick, [_this].concat(args));
            _ModalActions2.default.close(_AppConstants.GlobalModals.ERROR);
            onClose();
        };
        var props = {};

        if (!(0, _isNull3.default)(text)) {
            props = { continueText: text, closeText: closeText, onContinue: customHandler, onClose: closeHandler };
        }

        return (0, _assign2.default)({
            closeText: closeText,
            onClose: closeHandler,
            hideContinue: (0, _isNull3.default)(text),
            className: 'modal--sm',
            titleText: headingText
        }, props);
    }

    return _react2.default.createElement(
        _BaseModal2.default,
        _getModalProps(heading, customButton),
        _react2.default.createElement(
            'div',
            { className: 'vertical-align-parent full-height' },
            _react2.default.createElement(
                _BAlert2.default,
                { type: _BAlert.bAlertType.DANGER, className: 'padding-top' },
                _react2.default.createElement(
                    'p',
                    { className: 'text-weight--bold' },
                    _react2.default.createElement(_Icon2.default, { icon: 'error' }),
                    ' ',
                    (0, _I18n.translate)(title)
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n.translate)(message)
                )
            )
        )
    );
}

ErrorModal.propTypes = {
    heading: _propTypes2.default.string,
    title: _propTypes2.default.string,
    message: _propTypes2.default.string,
    closeText: _propTypes2.default.string,
    customButton: _propTypes2.default.shape({
        text: _propTypes2.default.string,
        onClick: _propTypes2.default.func
    }),
    onClose: _propTypes2.default.func
};

ErrorModal.defaultProps = {
    heading: 'error.title',
    title: 'error.general.title',
    message: 'error.general.message',
    closeText: 'button.text.close',
    onClose: _noop3.default
};

exports.default = ErrorModal;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _StarIcon = __webpack_require__(1007);

var _StarIcon2 = _interopRequireDefault(_StarIcon);

var _RewardPointsModal = __webpack_require__(1012);

var _RewardPointsModal2 = _interopRequireDefault(_RewardPointsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardPointsEarned = function RewardPointsEarned(_ref) {
    var rewardPoints = _ref.rewardPoints,
        className = _ref.className;

    var _useState = (0, _react.useState)(false),
        modalVisible = _useState[0],
        setModalVisible = _useState[1];

    if (!rewardPoints) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('reward-points__container', className) },
        _react2.default.createElement(_StarIcon2.default, null),
        _react2.default.createElement(
            'div',
            { className: 'reward-points__container__content' },
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n2.default)('rewardPoints.earned.pointsAmount', { rewardPoints: rewardPoints })
            ),
            _react2.default.createElement(
                _OnEnterTrigger2.default,
                {
                    onClick: function onClick(e) {
                        e.stopPropagation();
                        setModalVisible(true);
                    },
                    className: 'like-link'
                },
                (0, _I18n2.default)('rewardPoints.earned.findOutMore')
            )
        ),
        modalVisible && _react2.default.createElement(
            'span',
            { onClick: function onClick(e) {
                    return e.stopPropagation();
                } },
            _react2.default.createElement(_RewardPointsModal2.default, { onClose: function onClose() {
                    return setModalVisible(false);
                } })
        )
    );
};

RewardPointsEarned.propTypes = {
    rewardPoints: _propTypes2.default.number.isRequired,
    className: _propTypes2.default.string
};

exports.default = _react2.default.memo(RewardPointsEarned);

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _keycode = _interopRequireDefault(__webpack_require__(267));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _all = _interopRequireDefault(__webpack_require__(196));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
// TODO: This `bsStyle` is very unlike the others. Should we rename it?
// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.
var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: _propTypes.default.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: _propTypes.default.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: _propTypes.default.bool,
  justified: (0, _all.default)(_propTypes.default.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: _propTypes.default.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: _propTypes.default.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: _propTypes.default.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: _propTypes.default.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: _propTypes.default.bool
};
var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};
var contextTypes = {
  $bs_navbar: _propTypes.default.shape({
    bsClass: _propTypes.default.string,
    onSelect: _propTypes.default.func
  }),
  $bs_tabContainer: _propTypes.default.shape({
    activeKey: _propTypes.default.any,
    onSelect: _propTypes.default.func.isRequired,
    getTabId: _propTypes.default.func.isRequired,
    getPaneId: _propTypes.default.func.isRequired
  })
};

var Nav =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Nav, _React$Component);

  function Nav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Nav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;
    var children = this.props.children;

    var _this$getActiveProps = this.getActiveProps(),
        activeKey = _this$getActiveProps.activeKey,
        activeHref = _this$getActiveProps.activeHref;

    var activeChild = _ValidComponentChildren.default.find(children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    });

    var childrenArray = _ValidComponentChildren.default.toArray(children);

    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = _reactDom.default.findDOMNode(this).children;

    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  _proto.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? (0, _warning.default)(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
      return tabContainer;
    }

    return this.props;
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    var _this2 = this;

    var children = this.props.children;
    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _this$getActiveProps2 = this.getActiveProps(),
        activeKey = _this$getActiveProps2.activeKey,
        activeHref = _this$getActiveProps2.activeHref;

    var activeChild = _ValidComponentChildren.default.find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    }); // This assumes the active child is not disabled.


    var activeChildIndex = validChildren.indexOf(activeChild);

    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this3 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;

    if (tabContainer) {
       false ? (0, _warning.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = (0, _createChainedFunction.default)(function (event) {
        return _this3.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild;

    switch (event.keyCode) {
      case _keycode.default.codes.left:
      case _keycode.default.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;

      case _keycode.default.codes.right:
      case _keycode.default.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;

      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _extends2,
        _this4 = this;

    var _this$props = this.props,
        stacked = _this$props.stacked,
        justified = _this$props.justified,
        onSelect = _this$props.onSelect,
        propsRole = _this$props.role,
        propsNavbar = _this$props.navbar,
        pullRight = _this$props.pullRight,
        pullLeft = _this$props.pullLeft,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);
    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _this$getActiveProps3 = this.getActiveProps(),
        activeKey = _this$getActiveProps3.activeKey,
        activeHref = _this$getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().

    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName;
    var pullRightClassName;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || {
        bsClass: 'navbar'
      };
      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;
    return _react.default.createElement("ul", (0, _extends3.default)({}, elementProps, {
      role: role,
      className: (0, _classnames.default)(className, classes)
    }), _ValidComponentChildren.default.map(children, function (child) {
      var active = _this4.isActive(child, activeKey, activeHref);

      var childOnSelect = (0, _createChainedFunction.default)(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
      return (0, _react.cloneElement)(child, (0, _extends3.default)({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
        active: active,
        activeKey: activeKey,
        activeHref: activeHref,
        onSelect: childOnSelect
      }));
    }));
  };

  return Nav;
}(_react.default.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var propTypes = {
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  role: _propTypes.default.string,
  href: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  eventKey: _propTypes.default.any
};
var defaultProps = {
  active: false,
  disabled: false
};

var NavItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(NavItem, _React$Component);

  function NavItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = NavItem.prototype;

  _proto.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        className = _this$props.className,
        style = _this$props.style,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "disabled", "onClick", "className", "style"]);
    delete props.onSelect;
    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.

    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return _react.default.createElement("li", {
      role: "presentation",
      className: (0, _classnames.default)(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
      disabled: disabled,
      onClick: (0, _createChainedFunction.default)(onClick, this.handleClick)
    })));
  };

  return NavItem;
}(_react.default.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
var _default = NavItem;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Button = _interopRequireDefault(__webpack_require__(45));

var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: _propTypes.default.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: _propTypes.default.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: _propTypes.default.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: _propTypes.default.bool,

  /**
   * [onChange description]
   */
  onChange: _propTypes.default.func,

  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: _propTypes.default.any.isRequired
};

var ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ToggleButton, _React$Component);

  function ToggleButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        checked = _this$props.checked,
        type = _this$props.type,
        onChange = _this$props.onChange,
        value = _this$props.value,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "name", "checked", "type", "onChange", "value"]);
    var disabled = props.disabled;
    return _react.default.createElement(_Button.default, (0, _extends2.default)({}, props, {
      active: !!checked,
      componentClass: "label"
    }), _react.default.createElement("input", {
      name: name,
      type: type,
      autoComplete: "off",
      value: value,
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange
    }), children);
  };

  return ToggleButton;
}(_react.default.Component);

ToggleButton.propTypes = propTypes;
var _default = ToggleButton;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.sortReservations = exports.getReservationRequestJourney = exports.buildSalesReservationPayload = exports.stationDisplayName = undefined;

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stationDisplayName = exports.stationDisplayName = function stationDisplayName(station) {
    return station.crs ? (0, _I18n2.default)('booking.journey.stationName', (0, _pick3.default)(station.toJS(), ['name', 'crs'])) : station.name;
};

var buildSalesReservationPayload = exports.buildSalesReservationPayload = function buildSalesReservationPayload(_ref) {
    var outwardService = _ref.outwardService,
        inwardService = _ref.inwardService,
        outwardFare = _ref.outwardFare,
        inwardFare = _ref.inwardFare,
        _ref$passengers = _ref.passengers,
        passengers = _ref$passengers === undefined ? (0, _immutable.List)() : _ref$passengers,
        _ref$bikesCount = _ref.bikesCount,
        bikesCount = _ref$bikesCount === undefined ? 0 : _ref$bikesCount,
        _ref$requestSeats = _ref.requestSeats,
        requestSeats = _ref$requestSeats === undefined ? true : _ref$requestSeats;

    var buildLegs = function buildLegs(service, direction) {
        var legs = [];
        var serviceLegs = service && service.get('legs');

        if (serviceLegs && serviceLegs.size > 0) {
            for (var i = 0; i < serviceLegs.size; i++) {
                var leg = serviceLegs.get(i);

                var mode = leg.getIn(['serviceDetails', 'mode']);
                if (mode !== 'Train') {
                    continue; // Skip non-train legs
                }

                var origin = Array.isArray(leg.origin) ? leg.origin[0] : leg.get('origin') && leg.get('origin').get(0) || {};
                var destination = Array.isArray(leg.destination) ? leg.destination[0] : leg.get('destination') && leg.get('destination').get(0) || {};

                var originTime = origin && origin.time && origin.time.scheduledTime ? origin.time.scheduledTime : '';
                var formattedDate = originTime ? (0, _moment2.default)(originTime).format('YYYY-MM-DD') : '';

                var boardLocation = origin && (origin.station && origin.station.crs || origin.getIn && origin.getIn(['station', 'crs'])) || '';

                var alightLocation = destination && (destination.station && destination.station.crs || destination.getIn && destination.getIn(['station', 'crs'])) || '';

                var rsid = leg.getIn(['serviceDetails', 'retailServiceId']) || '';

                legs.push({
                    id: 'segment_' + (i + 1) + '_' + direction,
                    boardLocation: boardLocation,
                    alightLocation: alightLocation,
                    rsid: rsid,
                    serviceOriginDate: formattedDate
                });
            }
        } else {
            console.warn('Invalid or missing service legs.');
        }

        return legs;
    };

    var buildBundles = function buildBundles(_ref2) {
        var direction = _ref2.direction,
            ticketTypeCode = _ref2.ticketTypeCode,
            routeCode = _ref2.routeCode,
            passengerIds = _ref2.passengerIds,
            bikesCount = _ref2.bikesCount,
            requestSeats = _ref2.requestSeats;

        var bundles = [];

        if (requestSeats && ticketTypeCode) {
            var seatProducts = passengerIds.map(function (id, index) {
                return {
                    ticketTypeCode: ticketTypeCode,
                    routeCode: routeCode,
                    sequenceNumber: index + 1,
                    passengerIds: [id]
                };
            });

            bundles.push({
                id: 'SEATS_' + direction,
                products: seatProducts
            });
        }

        if (bikesCount > 0) {
            var bikeProducts = passengerIds.slice(0, bikesCount).map(function (id, index) {
                return {
                    ticketTypeCode: 'BIK',
                    routeCode: routeCode,
                    sequenceNumber: passengerIds.size + index + 1,
                    passengerIds: [id]
                };
            });

            bundles.push({
                id: 'BIKES_' + direction,
                products: bikeProducts
            });
        }

        return bundles;
    };

    var buildJourney = function buildJourney(_ref3) {
        var id = _ref3.id,
            direction = _ref3.direction,
            service = _ref3.service,
            fare = _ref3.fare;

        var originStation = service.getIn(['origin', 'station']);
        var destinationStation = service.getIn(['destination', 'station']);
        // eslint-disable-next-line
        var passengerIds = passengers.map(function (_, i) {
            return 'passenger_' + (i + 1);
        });

        var ticketTypeCode = fare && fare.getIn(['ticketType', 'code']) || '';

        var routeCode = fare && fare.getIn(['route', 'code']) || fare.route.code;

        return {
            id: id,
            direction: direction,
            journeyConditions: {
                journeyOD: {
                    journeyOrigin: originStation ? originStation.get('nlc') || '' : '',
                    journeyDestination: destinationStation ? destinationStation.get('nlc') || '' : ''
                }
            },
            legs: buildLegs(service, direction),
            bundles: buildBundles({
                direction: direction,
                ticketTypeCode: ticketTypeCode,
                routeCode: routeCode,
                passengerIds: passengerIds,
                bikesCount: bikesCount,
                requestSeats: requestSeats
            })
        };
    };

    var journeys = [];
    var formattedPassengers = [];

    for (var i = 0; i < passengers.size; i++) {
        var p = passengers.get(i);
        formattedPassengers.push({
            id: 'passenger_' + (i + 1),
            statusCode: p && p.statusCode ? p.statusCode : '000'
        });
    }

    if (outwardService && outwardFare) {
        journeys.push(buildJourney({
            id: 'journey_1',
            direction: 'OUTBOUND',
            service: outwardService,
            fare: outwardFare
        }));
    }

    if (inwardService && inwardFare) {
        journeys.push(buildJourney({
            id: 'journey_2',
            direction: 'INBOUND',
            service: inwardService,
            fare: inwardFare
        }));
    }

    return {
        salesFlowType: 'SALES',
        passengers: formattedPassengers,
        journeys: journeys
    };
};

var parseLegs = function parseLegs(legs) {
    return legs.map(function (_ref4) {
        var origin = _ref4.origin,
            destination = _ref4.destination,
            serviceDetails = _ref4.serviceDetails;

        var originFirst = origin.first();
        var destinationFirst = destination.first();

        return {
            date: (0, _TrainTime2.default)(originFirst.time.scheduledTime).format('YYYY-MM-DD'),
            retailServiceId: serviceDetails.retailServiceId,
            origin: {
                name: originFirst.station.name,
                nlc: originFirst.station.nlc
            },
            destination: {
                name: destinationFirst.station.name,
                nlc: destinationFirst.station.nlc
            },
            departure: originFirst.time.scheduledTime,
            arrival: destinationFirst.time.scheduledTime,
            reservable: serviceDetails.reservable,
            operator: serviceDetails.toc.code,
            mode: serviceDetails.mode
        };
    });
};

var getReservationRequestJourney = exports.getReservationRequestJourney = function getReservationRequestJourney(fare, journey) {
    var originStation = journey.origin.station;
    var destinationStation = journey.destination.station;


    return {
        origin: {
            name: originStation.name,
            nlc: originStation.nlc
        },
        destination: {
            name: destinationStation.name,
            nlc: destinationStation.nlc
        },
        ticketType: fare && fare.ticketType && fare.ticketType.code,
        routeCode: fare && fare.route && fare.route.code,
        reserve: false,
        legs: parseLegs(journey.legs.filter(function (leg) {
            return leg.isTrainLeg();
        }))
    };
};

var sortReservations = exports.sortReservations = function sortReservations(reservations) {
    return reservations.toArray().sort(function (a, b) {
        return (0, _moment2.default)(b.created).diff((0, _moment2.default)(a.created));
    });
};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1183);

__webpack_require__(1380);

__webpack_require__(1381);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(66) && !__webpack_require__(40)(function () {
  return Object.defineProperty(__webpack_require__(465)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(56);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(120);
var toIObject = __webpack_require__(121);
var arrayIndexOf = __webpack_require__(356)(false);
var IE_PROTO = __webpack_require__(467)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var anObject = __webpack_require__(31);
var getKeys = __webpack_require__(207);

module.exports = __webpack_require__(66) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(121);
var gOPN = __webpack_require__(210).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(66);
var getKeys = __webpack_require__(207);
var gOPS = __webpack_require__(357);
var pIE = __webpack_require__(294);
var toObject = __webpack_require__(73);
var IObject = __webpack_require__(293);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(40)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 694 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(93);
var isObject = __webpack_require__(48);
var invoke = __webpack_require__(696);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 696 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(36).parseInt;
var $trim = __webpack_require__(244).trim;
var ws = __webpack_require__(471);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(36).parseFloat;
var $trim = __webpack_require__(244).trim;

module.exports = 1 / $parseFloat(__webpack_require__(471) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(132);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(48);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 701 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(474);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(31);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(93);
var toObject = __webpack_require__(73);
var IObject = __webpack_require__(293);
var toLength = __webpack_require__(63);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(73);
var toAbsoluteIndex = __webpack_require__(208);
var toLength = __webpack_require__(63);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(486);
__webpack_require__(10)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(66) && /./g.flags != 'g') __webpack_require__(71).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(295)
});


/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(31);
var isObject = __webpack_require__(48);
var newPromiseCapability = __webpack_require__(490);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(712);
var validate = __webpack_require__(215);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(365)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(71).f;
var create = __webpack_require__(209);
var redefineAll = __webpack_require__(214);
var ctx = __webpack_require__(131);
var anInstance = __webpack_require__(212);
var forOf = __webpack_require__(213);
var $iterDefine = __webpack_require__(476);
var step = __webpack_require__(706);
var setSpecies = __webpack_require__(211);
var DESCRIPTORS = __webpack_require__(66);
var fastKey = __webpack_require__(180).fastKey;
var validate = __webpack_require__(215);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(712);
var validate = __webpack_require__(215);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(365)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(36);
var each = __webpack_require__(151)(0);
var redefine = __webpack_require__(112);
var meta = __webpack_require__(180);
var assign = __webpack_require__(693);
var weak = __webpack_require__(715);
var isObject = __webpack_require__(48);
var validate = __webpack_require__(215);
var NATIVE_WEAK_MAP = __webpack_require__(215);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(365)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(214);
var getWeak = __webpack_require__(180).getWeak;
var anObject = __webpack_require__(31);
var isObject = __webpack_require__(48);
var anInstance = __webpack_require__(212);
var forOf = __webpack_require__(213);
var createArrayMethod = __webpack_require__(151);
var $has = __webpack_require__(120);
var validate = __webpack_require__(215);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(133);
var toLength = __webpack_require__(63);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(210);
var gOPS = __webpack_require__(357);
var anObject = __webpack_require__(31);
var Reflect = __webpack_require__(36).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(358);
var isObject = __webpack_require__(48);
var toLength = __webpack_require__(63);
var ctx = __webpack_require__(131);
var IS_CONCAT_SPREADABLE = __webpack_require__(56)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(63);
var repeat = __webpack_require__(473);
var defined = __webpack_require__(149);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(66);
var getKeys = __webpack_require__(207);
var toIObject = __webpack_require__(121);
var isEnum = __webpack_require__(294).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(243);
var from = __webpack_require__(722);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(213);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 723 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(124) && !__webpack_require__(183)(function () {
  return Object.defineProperty(__webpack_require__(494)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(184);
var toIObject = __webpack_require__(185);
var arrayIndexOf = __webpack_require__(1388)(false);
var IE_PROTO = __webpack_require__(498)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(82).document;
module.exports = document && document.documentElement;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(184);
var toObject = __webpack_require__(217);
var IE_PROTO = __webpack_require__(498)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(136);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(247);
var ITERATOR = __webpack_require__(94)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(136);
var aFunction = __webpack_require__(298);
var SPECIES = __webpack_require__(94)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(164);
var invoke = __webpack_require__(1393);
var html = __webpack_require__(726);
var cel = __webpack_require__(494);
var global = __webpack_require__(82);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(300)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(136);
var isObject = __webpack_require__(103);
var newPromiseCapability = __webpack_require__(502);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(82);
var core = __webpack_require__(49);
var dP = __webpack_require__(135);
var DESCRIPTORS = __webpack_require__(124);
var SPECIES = __webpack_require__(94)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(94)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(124);
var getKeys = __webpack_require__(248);
var gOPS = __webpack_require__(503);
var pIE = __webpack_require__(302);
var toObject = __webpack_require__(217);
var IObject = __webpack_require__(497);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(183)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(300);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(185);
var gOPN = __webpack_require__(740).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(725);
var hiddenKeys = __webpack_require__(500).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1419), __esModule: true };

/***/ }),
/* 742 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1027);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(745),
    isArguments = __webpack_require__(304),
    isArray = __webpack_require__(68),
    isBuffer = __webpack_require__(251),
    isIndex = __webpack_require__(305),
    isTypedArray = __webpack_require__(306);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 745 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(330),
    nativeKeys = __webpack_require__(1429);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 748 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(661),
    arraySome = __webpack_require__(751),
    cacheHas = __webpack_require__(662);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 751 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(87);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(754),
    getSymbols = __webpack_require__(513),
    keys = __webpack_require__(127);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(512),
    isArray = __webpack_require__(68);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 756 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(87);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(87);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 760 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1472),
    hasPath = __webpack_require__(762);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(187),
    isArguments = __webpack_require__(304),
    isArray = __webpack_require__(68),
    isIndex = __webpack_require__(305),
    isLength = __webpack_require__(507),
    toKey = __webpack_require__(188);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 763 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(290);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(116),
    metaMap = __webpack_require__(768);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(758);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(770),
    composeArgsRight = __webpack_require__(771),
    countHolders = __webpack_require__(1478),
    createCtor = __webpack_require__(386),
    createRecurry = __webpack_require__(772),
    getHolder = __webpack_require__(518),
    reorder = __webpack_require__(1489),
    replaceHolders = __webpack_require__(389),
    root = __webpack_require__(87);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1479),
    setData = __webpack_require__(775),
    setWrapToString = __webpack_require__(776);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(768),
    noop = __webpack_require__(24);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(310),
    baseLodash = __webpack_require__(517);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(767),
    shortOut = __webpack_require__(766);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(1484),
    insertWrapDetails = __webpack_require__(1485),
    setToString = __webpack_require__(515),
    updateWrapDetails = __webpack_require__(1486);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1492);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    id: [_LinkMapper.fields.string],
    stations: [_LinkMapper.fields.bool],
    price: [_LinkMapper.fields.bool],
    bookSize: [_LinkMapper.fields.bool],
    ticketNumber: [_LinkMapper.fields.bool],
    oysterNumber: [_LinkMapper.fields.bool],
    smartcardNumber: [_LinkMapper.fields.bool],
    purchaseLocation: [_LinkMapper.fields.bool],
    pairWithOther: [_LinkMapper.fields.bool],
    pairWithSelf: [_LinkMapper.fields.bool],
    optionalReturn: [_LinkMapper.fields.bool],
    evidenceNotRequired: [_LinkMapper.fields.bool],
    evidenceIsOptional: [_LinkMapper.fields.bool, false],
    returnMustMatch: [_LinkMapper.fields.bool],
    weeklyExclusive: [_LinkMapper.fields.bool]
};

var NonSeasonTicketType = function (_record) {
    (0, _inherits3.default)(NonSeasonTicketType, _record);

    function NonSeasonTicketType() {
        (0, _classCallCheck3.default)(this, NonSeasonTicketType);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    NonSeasonTicketType.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(NonSeasonTicketType, json, (0, _Records.getResolvers)(schema));
    };

    NonSeasonTicketType.prototype.canPair = function canPair() {
        return Boolean(this.pairWithSelf || this.pairWithOther);
    };

    NonSeasonTicketType.prototype.mustPair = function mustPair() {
        return Boolean(this.canPair() && !this.optionalReturn);
    };

    NonSeasonTicketType.prototype.pairsWith = function pairsWith(otherType) {
        if (this === otherType) {
            return Boolean(this.pairWithSelf);
        }
        return this.pairWithOther && otherType.pairWithOther;
    };

    return NonSeasonTicketType;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = NonSeasonTicketType;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    id: [_LinkMapper.fields.string],
    requiresStation: [_LinkMapper.fields.bool],
    requiresOther: [_LinkMapper.fields.bool]
};

var CompensationPurchaseLocation = function (_record) {
    (0, _inherits3.default)(CompensationPurchaseLocation, _record);

    function CompensationPurchaseLocation() {
        (0, _classCallCheck3.default)(this, CompensationPurchaseLocation);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CompensationPurchaseLocation.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CompensationPurchaseLocation, json, (0, _Records.getResolvers)(schema));
    };

    return CompensationPurchaseLocation;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = CompensationPurchaseLocation;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var escapeRegExp = __webpack_require__(1502);

module.exports = function defaultToWhiteSpace(characters) {
  if (characters == null)
    return '\\s';
  else if (characters.source)
    return characters.source;
  else
    return '[' + escapeRegExp(characters) + ']';
};


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(124);
var getKeys = __webpack_require__(248);
var toIObject = __webpack_require__(185);
var isEnum = __webpack_require__(302).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(315),
    baseForOwn = __webpack_require__(220),
    baseIteratee = __webpack_require__(102);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(252)(module), __webpack_require__(81)))

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.IPv6 = factory(root);
  }
}(this, function (root) {
  'use strict';

  /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */

  // save current IPv6 variable, if any
  var _IPv6 = root && root.IPv6;

  function bestPresentation(address) {
    // based on:
    // Javascript to test an IPv6 address for proper format, and to
    // present the "best text representation" according to IETF Draft RFC at
    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
    // 8 Feb 2010 Rich Brown, Dartware, LLC
    // Please feel free to use this code as long as you provide a link to
    // http://www.intermapper.com
    // http://intermapper.com/support/tools/IPV6-Validator.aspx
    // http://download.dartware.com/thirdparty/ipv6validator.js

    var _address = address.toLowerCase();
    var segments = _address.split(':');
    var length = segments.length;
    var total = 8;

    // trim colons (:: or ::a:b:c… or …a:b:c::)
    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
      // must have been ::
      // remove first two items
      segments.shift();
      segments.shift();
    } else if (segments[0] === '' && segments[1] === '') {
      // must have been ::xxxx
      // remove the first item
      segments.shift();
    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
      // must have been xxxx::
      segments.pop();
    }

    length = segments.length;

    // adjust total segments for IPv4 trailer
    if (segments[length - 1].indexOf('.') !== -1) {
      // found a "." which means IPv4
      total = 7;
    }

    // fill empty segments them with "0000"
    var pos;
    for (pos = 0; pos < length; pos++) {
      if (segments[pos] === '') {
        break;
      }
    }

    if (pos < total) {
      segments.splice(pos, 1, '0000');
      while (segments.length < total) {
        segments.splice(pos, 0, '0000');
      }
    }

    // strip leading zeros
    var _segments;
    for (var i = 0; i < total; i++) {
      _segments = segments[i].split('');
      for (var j = 0; j < 3 ; j++) {
        if (_segments[0] === '0' && _segments.length > 1) {
          _segments.splice(0,1);
        } else {
          break;
        }
      }

      segments[i] = _segments.join('');
    }

    // find longest sequence of zeroes and coalesce them into one segment
    var best = -1;
    var _best = 0;
    var _current = 0;
    var current = -1;
    var inzeroes = false;
    // i; already declared

    for (i = 0; i < total; i++) {
      if (inzeroes) {
        if (segments[i] === '0') {
          _current += 1;
        } else {
          inzeroes = false;
          if (_current > _best) {
            best = current;
            _best = _current;
          }
        }
      } else {
        if (segments[i] === '0') {
          inzeroes = true;
          current = i;
          _current = 1;
        }
      }
    }

    if (_current > _best) {
      best = current;
      _best = _current;
    }

    if (_best > 1) {
      segments.splice(best, _best, '');
    }

    length = segments.length;

    // assemble remaining segments
    var result = '';
    if (segments[0] === '')  {
      result = ':';
    }

    for (i = 0; i < length; i++) {
      result += segments[i];
      if (i === length - 1) {
        break;
      }

      result += ':';
    }

    if (segments[length - 1] === '') {
      result += ':';
    }

    return result;
  }

  function noConflict() {
    /*jshint validthis: true */
    if (root.IPv6 === this) {
      root.IPv6 = _IPv6;
    }

    return this;
  }

  return {
    best: bestPresentation,
    noConflict: noConflict
  };
}));


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
  }
}(this, function (root) {
  'use strict';

  // save current SecondLevelDomains variable, if any
  var _SecondLevelDomains = root && root.SecondLevelDomains;

  var SLD = {
    // list of known Second Level Domains
    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
    // ----
    // publicsuffix.org is more current and actually used by a couple of browsers internally.
    // downside is it also contains domains like "dyndns.org" - which is fine for the security
    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
    // ----
    list: {
      'ac':' com gov mil net org ',
      'ae':' ac co gov mil name net org pro sch ',
      'af':' com edu gov net org ',
      'al':' com edu gov mil net org ',
      'ao':' co ed gv it og pb ',
      'ar':' com edu gob gov int mil net org tur ',
      'at':' ac co gv or ',
      'au':' asn com csiro edu gov id net org ',
      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
      'bb':' biz co com edu gov info net org store tv ',
      'bh':' biz cc com edu gov info net org ',
      'bn':' com edu gov net org ',
      'bo':' com edu gob gov int mil net org tv ',
      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
      'bs':' com edu gov net org ',
      'bz':' du et om ov rg ',
      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
      'ck':' biz co edu gen gov info net org ',
      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
      'co':' com edu gov mil net nom org ',
      'cr':' ac c co ed fi go or sa ',
      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
      'do':' art com edu gob gov mil net org sld web ',
      'dz':' art asso com edu gov net org pol ',
      'ec':' com edu fin gov info med mil net org pro ',
      'eg':' com edu eun gov mil name net org sci ',
      'er':' com edu gov ind mil net org rochest w ',
      'es':' com edu gob nom org ',
      'et':' biz com edu gov info name net org ',
      'fj':' ac biz com info mil name net org pro ',
      'fk':' ac co gov net nom org ',
      'fr':' asso com f gouv nom prd presse tm ',
      'gg':' co net org ',
      'gh':' com edu gov mil org ',
      'gn':' ac com gov net org ',
      'gr':' com edu gov mil net org ',
      'gt':' com edu gob ind mil net org ',
      'gu':' com edu gov net org ',
      'hk':' com edu gov idv net org ',
      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
      'id':' ac co go mil net or sch web ',
      'il':' ac co gov idf k12 muni net org ',
      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
      'iq':' com edu gov i mil net org ',
      'ir':' ac co dnssec gov i id net org sch ',
      'it':' edu gov ',
      'je':' co net org ',
      'jo':' com edu gov mil name net org sch ',
      'jp':' ac ad co ed go gr lg ne or ',
      'ke':' ac co go info me mobi ne or sc ',
      'kh':' com edu gov mil net org per ',
      'ki':' biz com de edu gov info mob net org tel ',
      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
      'kn':' edu gov net org ',
      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
      'kw':' com edu gov net org ',
      'ky':' com edu gov net org ',
      'kz':' com edu gov mil net org ',
      'lb':' com edu gov net org ',
      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
      'lr':' com edu gov net org ',
      'lv':' asn com conf edu gov id mil net org ',
      'ly':' com edu gov id med net org plc sch ',
      'ma':' ac co gov m net org press ',
      'mc':' asso tm ',
      'me':' ac co edu gov its net org priv ',
      'mg':' com edu gov mil nom org prd tm ',
      'mk':' com edu gov inf name net org pro ',
      'ml':' com edu gov net org presse ',
      'mn':' edu gov org ',
      'mo':' com edu gov net org ',
      'mt':' com edu gov net org ',
      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
      'mw':' ac co com coop edu gov int museum net org ',
      'mx':' com edu gob net org ',
      'my':' com edu gov mil name net org sch ',
      'nf':' arts com firm info net other per rec store web ',
      'ng':' biz com edu gov mil mobi name net org sch ',
      'ni':' ac co com edu gob mil net nom org ',
      'np':' com edu gov mil net org ',
      'nr':' biz com edu gov info net org ',
      'om':' ac biz co com edu gov med mil museum net org pro sch ',
      'pe':' com edu gob mil net nom org sld ',
      'ph':' com edu gov i mil net ngo org ',
      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
      'pr':' ac biz com edu est gov info isla name net org pro prof ',
      'ps':' com edu gov net org plo sec ',
      'pw':' belau co ed go ne or ',
      'ro':' arts com firm info nom nt org rec store tm www ',
      'rs':' ac co edu gov in org ',
      'sb':' com edu gov net org ',
      'sc':' com edu gov net org ',
      'sh':' co com edu gov net nom org ',
      'sl':' com edu gov net org ',
      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
      'sv':' com edu gob org red ',
      'sz':' ac co org ',
      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
      'tw':' club com ebiz edu game gov idv mil net org ',
      'mu':' ac co com gov net or org ',
      'mz':' ac co edu gov org ',
      'na':' co com ',
      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
      'pa':' abo ac com edu gob ing med net nom org sld ',
      'pt':' com edu gov int net nome org publ ',
      'py':' com edu gov mil net org ',
      'qa':' com edu gov mil net org ',
      're':' asso com nom ',
      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
      'rw':' ac co com edu gouv gov int mil net ',
      'sa':' com edu gov med net org pub sch ',
      'sd':' com edu gov info med net org tv ',
      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
      'sg':' com edu gov idn net org per ',
      'sn':' art com edu gouv org perso univ ',
      'sy':' com edu gov mil net news org ',
      'th':' ac co go in mi net or ',
      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
      'tz':' ac co go ne or ',
      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
      'ug':' ac co go ne or org sc ',
      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
      'us':' dni fed isa kids nsn ',
      'uy':' com edu gub mil net org ',
      've':' co com edu gob info mil net org web ',
      'vi':' co com k12 net org ',
      'vn':' ac biz com edu gov health info int name net org pro ',
      'ye':' co com gov ltd me net org plc ',
      'yu':' ac co edu gov org ',
      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
      'zm':' ac co com edu gov net org sch ',
      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
      'net': 'gb jp se uk ',
      'org': 'ae',
      'de': 'com '
    },
    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
    // in both performance and memory footprint. No initialization required.
    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
    // Following methods use lastIndexOf() rather than array.split() in order
    // to avoid any memory allocations.
    has: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
    },
    is: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset >= 0) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
    },
    get: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return null;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return null;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return null;
      }
      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
        return null;
      }
      return domain.slice(sldOffset+1);
    },
    noConflict: function(){
      if (root.SecondLevelDomains === this) {
        root.SecondLevelDomains = _SecondLevelDomains;
      }
      return this;
    }
  };

  return SLD;
}));


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingActions = {
    start: function start(type, id, extra) {
        _AppDispatcher2.default.dispatch((0, _assign2.default)({
            type: type, id: id,
            actionType: _AppConstants.ActionTypes.LOADING_STARTED
        }, extra));
    },
    fail: function fail(type, id, extra) {
        _AppDispatcher2.default.dispatch((0, _assign2.default)({
            type: type, id: id,
            actionType: _AppConstants.ActionTypes.LOADING_FAILED
        }, extra));
    },
    success: function success(type, id, extra) {
        _AppDispatcher2.default.dispatch((0, _assign2.default)({
            type: type, id: id,
            actionType: _AppConstants.ActionTypes.LOADING_COMPLETED
        }, extra));
    },


    /**
     * Wrap a async function so that it fires start, success and fail
     * loading events
     */
    wrap: function wrap(type) {
        var self = this;
        return function (fn) {
            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var id,
                    _len,
                    args,
                    _key,
                    result,
                    _args = arguments;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                id = (0, _uniqueId3.default)(type + '-');

                                self.start(type, id);
                                _context.prev = 2;

                                for (_len = _args.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                                    args[_key] = _args[_key];
                                }

                                _context.next = 6;
                                return fn.apply(this, args);

                            case 6:
                                result = _context.sent;

                                self.success(type, id, { result: result });
                                return _context.abrupt('return', result);

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](2);

                                self.fail(type, id, { error: _context.t0 });
                                throw _context.t0;

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[2, 11]]);
            }));
        };
    }
};

exports.default = LoadingActions;

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(385),
    baseSet = __webpack_require__(791),
    castPath = __webpack_require__(187);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(331),
    castPath = __webpack_require__(187),
    isIndex = __webpack_require__(305),
    isObject = __webpack_require__(77),
    toKey = __webpack_require__(188);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(453),
    overRest = __webpack_require__(764),
    setToString = __webpack_require__(515);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(512),
    isFlattenable = __webpack_require__(1535);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _AuthToken = __webpack_require__(392);

var _AuthToken2 = _interopRequireDefault(_AuthToken);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _UserPreferences = __webpack_require__(228);

var _UserPreferences2 = _interopRequireDefault(_UserPreferences);

var _DeactivationRequest = __webpack_require__(1606);

var _DeactivationRequest2 = _interopRequireDefault(_DeactivationRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childAge = _TrainTime2.default.duration('P16Y');

var schema = {
    id: [_LinkMapper.fields.number],
    title: [_LinkMapper.fields.string],
    firstNames: [_LinkMapper.fields.string],
    surname: [_LinkMapper.fields.string],
    email: [_LinkMapper.fields.string],
    telephoneNumber: [_LinkMapper.fields.string],
    created: [_LinkMapper.fields.datetime],
    lastLogin: [_LinkMapper.fields.datetime],
    lastUpdated: [_LinkMapper.fields.datetime],
    dateOfFirstPurchase: [_LinkMapper.fields.datetime],
    photocardId: [_LinkMapper.fields.string],
    source: [_LinkMapper.fields.string],
    dateOfBirth: [_LinkMapper.fields.datetime],
    accessToken: [_LinkMapper.resolve.as(_AuthToken2.default)],
    smartcardRegistered: [_LinkMapper.fields.boolean],
    brandChosen: [_LinkMapper.fields.boolean, false],
    addresses: [_LinkMapper.resolveAll.as(_Address2.default), new _immutable.List()],
    preferences: [_LinkMapper.resolve.as(_UserPreferences2.default)],
    isOver16: [_LinkMapper.fields.boolean],
    identityProviders: [_LinkMapper.resolveAll.with(_LinkMapper.fields.string), new _immutable.List()],
    deactivationRequests: [_LinkMapper.resolveAll.as(_DeactivationRequest2.default), new _immutable.List()],
    autoDrOptedIn: [_LinkMapper.fields.boolean, false],
    autoDelayRepayEmail: [_LinkMapper.fields.boolean, false],
    autoDelayRepayApp: [_LinkMapper.fields.boolean, false]
};

var Customer = function (_record) {
    (0, _inherits3.default)(Customer, _record);

    function Customer() {
        (0, _classCallCheck3.default)(this, Customer);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Customer.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Customer, json, (0, _Records.getResolvers)(schema));
    };

    Customer.prototype.isChild = function isChild() {
        var maxChildDate = (0, _TrainTime2.default)().subtract(childAge);
        return this.dateOfBirth && this.dateOfBirth.isAfter(maxChildDate);
    };

    Customer.prototype.hasIdentityProvider = function hasIdentityProvider(provider) {
        return this.identityProviders && this.identityProviders.some(function (p) {
            return p === provider;
        });
    };

    Customer.prototype.removeIdentityProvider = function removeIdentityProvider(provider) {
        return Customer.fromJSON((0, _extends3.default)({}, this.toJS(), {
            identityProviders: this.identityProviders.filter(function (p) {
                return p !== provider;
            })
        }));
    };

    return Customer;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = Customer;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1548), __esModule: true };

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(135).f;
var create = __webpack_require__(371);
var redefineAll = __webpack_require__(376);
var ctx = __webpack_require__(164);
var anInstance = __webpack_require__(375);
var forOf = __webpack_require__(249);
var $iterDefine = __webpack_require__(493);
var step = __webpack_require__(728);
var setSpecies = __webpack_require__(735);
var DESCRIPTORS = __webpack_require__(124);
var fastKey = __webpack_require__(303).fastKey;
var validate = __webpack_require__(256);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(374);
var from = __webpack_require__(1551);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1554), __esModule: true };

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1558), __esModule: true };

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ref = __webpack_require__(153);

module.exports = function () {
    function Set() {
        (0, _classCallCheck3.default)(this, Set);


        this._set = [];
    }

    Set.prototype.add = function add(value, refs) {

        if (!Ref.isRef(value) && this.has(value, null, null, false)) {

            return;
        }

        if (refs !== undefined) {
            // If it's a merge, we don't have any refs
            Ref.push(refs, value);
        }

        this._set.push(value);
        return this;
    };

    Set.prototype.merge = function merge(add, remove) {

        for (var i = 0; i < add._set.length; ++i) {
            this.add(add._set[i]);
        }

        for (var _i = 0; _i < remove._set.length; ++_i) {
            this.remove(remove._set[_i]);
        }

        return this;
    };

    Set.prototype.remove = function remove(value) {

        this._set = this._set.filter(function (item) {
            return value !== item;
        });
        return this;
    };

    Set.prototype.has = function has(value, state, options, insensitive) {

        for (var i = 0; i < this._set.length; ++i) {
            var items = this._set[i];

            if (state && Ref.isRef(items)) {
                // Only resolve references if there is a state, otherwise it's a merge
                items = items(state.reference || state.parent, options);
            }

            if (!Array.isArray(items)) {
                items = [items];
            }

            for (var j = 0; j < items.length; ++j) {
                var item = items[j];
                if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item))) {
                    continue;
                }

                if (value === item || value instanceof Date && item instanceof Date && value.getTime() === item.getTime() || insensitive && typeof value === 'string' && value.toLowerCase() === item.toLowerCase() || Buffer.isBuffer(value) && Buffer.isBuffer(item) && value.length === item.length && value.toString('binary') === item.toString('binary')) {

                    return true;
                }
            }
        }

        return false;
    };

    Set.prototype.values = function values(options) {

        if (options && options.stripUndefined) {
            var values = [];

            for (var i = 0; i < this._set.length; ++i) {
                var item = this._set[i];
                if (item !== undefined) {
                    values.push(item);
                }
            }

            return values;
        }

        return this._set.slice();
    };

    Set.prototype.slice = function slice() {

        var newSet = new Set();
        newSet._set = this._set.slice();

        return newSet;
    };

    Set.prototype.concat = function concat(source) {

        var newSet = new Set();
        newSet._set = this._set.concat(source._set);

        return newSet;
    };

    return Set;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(317).Buffer))

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Load modules

var _set = __webpack_require__(796);

var _set2 = _interopRequireDefault(_set);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _isSafeInteger = __webpack_require__(257);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Net = __webpack_require__(529);
var Hoek = __webpack_require__(96);
var Isemail = void 0; // Loaded on demand
var Any = __webpack_require__(137);
var Ref = __webpack_require__(153);
var JoiDate = __webpack_require__(531);
var Uri = __webpack_require__(1571);
var Ip = __webpack_require__(1572);

// Declare internals

var internals = {
    uriRegex: Uri.createUriRegex(),
    ipRegex: Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], 'optional'),
    guidBrackets: {
        '{': '}', '[': ']', '(': ')', '': ''
    },
    guidVersions: {
        uuidv1: '1',
        uuidv2: '2',
        uuidv3: '3',
        uuidv4: '4',
        uuidv5: '5'
    }
};

internals.String = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'string';
        _this._invalids.add('');
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        if (typeof value === 'string' && options.convert) {

            if (this._flags.case) {
                value = this._flags.case === 'upper' ? value.toLocaleUpperCase() : value.toLocaleLowerCase();
            }

            if (this._flags.trim) {
                value = value.trim();
            }

            if (this._inner.replacements) {

                for (var i = 0; i < this._inner.replacements.length; ++i) {
                    var replacement = this._inner.replacements[i];
                    value = value.replace(replacement.pattern, replacement.replacement);
                }
            }

            if (this._flags.truncate) {
                for (var _i = 0; _i < this._tests.length; ++_i) {
                    var test = this._tests[_i];
                    if (test.name === 'max') {
                        value = value.slice(0, test.arg);
                        break;
                    }
                }
            }
        }

        return {
            value: value,
            errors: typeof value === 'string' ? null : this.createError('string.base', { value: value }, state, options)
        };
    };

    _class.prototype.insensitive = function insensitive() {

        if (this._flags.insensitive) {
            return this;
        }

        var obj = this.clone();
        obj._flags.insensitive = true;
        return obj;
    };

    _class.prototype.creditCard = function creditCard() {

        return this._test('creditCard', undefined, function (value, state, options) {

            var i = value.length;
            var sum = 0;
            var mul = 1;

            while (i--) {
                var char = value.charAt(i) * mul;
                sum = sum + (char - (char > 9) * 9);
                mul = mul ^ 3;
            }

            var check = sum % 10 === 0 && sum > 0;
            return check ? value : this.createError('string.creditCard', { value: value }, state, options);
        });
    };

    _class.prototype.regex = function regex(pattern, patternOptions) {

        Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');

        var patternObject = {
            pattern: new RegExp(pattern.source, pattern.ignoreCase ? 'i' : undefined) // Future version should break this and forbid unsupported regex flags
        };

        if (typeof patternOptions === 'string') {
            patternObject.name = patternOptions;
        } else if ((typeof patternOptions === 'undefined' ? 'undefined' : (0, _typeof3.default)(patternOptions)) === 'object') {
            patternObject.invert = !!patternOptions.invert;

            if (patternOptions.name) {
                patternObject.name = patternOptions.name;
            }
        }

        var errorCode = ['string.regex', patternObject.invert ? '.invert' : '', patternObject.name ? '.name' : '.base'].join('');

        return this._test('regex', patternObject, function (value, state, options) {

            var patternMatch = patternObject.pattern.test(value);

            if (patternMatch ^ patternObject.invert) {
                return value;
            }

            return this.createError(errorCode, { name: patternObject.name, pattern: patternObject.pattern, value: value }, state, options);
        });
    };

    _class.prototype.alphanum = function alphanum() {

        return this._test('alphanum', undefined, function (value, state, options) {

            if (/^[a-zA-Z0-9]+$/.test(value)) {
                return value;
            }

            return this.createError('string.alphanum', { value: value }, state, options);
        });
    };

    _class.prototype.token = function token() {

        return this._test('token', undefined, function (value, state, options) {

            if (/^\w+$/.test(value)) {
                return value;
            }

            return this.createError('string.token', { value: value }, state, options);
        });
    };

    _class.prototype.email = function email(isEmailOptions) {

        if (isEmailOptions) {
            Hoek.assert((typeof isEmailOptions === 'undefined' ? 'undefined' : (0, _typeof3.default)(isEmailOptions)) === 'object', 'email options must be an object');
            Hoek.assert(typeof isEmailOptions.checkDNS === 'undefined', 'checkDNS option is not supported');
            Hoek.assert(typeof isEmailOptions.tldWhitelist === 'undefined' || (0, _typeof3.default)(isEmailOptions.tldWhitelist) === 'object', 'tldWhitelist must be an array or object');
            Hoek.assert(typeof isEmailOptions.minDomainAtoms === 'undefined' || (0, _isSafeInteger2.default)(isEmailOptions.minDomainAtoms) && isEmailOptions.minDomainAtoms > 0, 'minDomainAtoms must be a positive integer');
            Hoek.assert(typeof isEmailOptions.errorLevel === 'undefined' || typeof isEmailOptions.errorLevel === 'boolean' || (0, _isSafeInteger2.default)(isEmailOptions.errorLevel) && isEmailOptions.errorLevel >= 0, 'errorLevel must be a non-negative integer or boolean');
        }

        return this._test('email', isEmailOptions, function (value, state, options) {

            Isemail = Isemail || __webpack_require__(1573);

            try {
                var result = Isemail.validate(value, isEmailOptions);
                if (result === true || result === 0) {
                    return value;
                }
            } catch (e) {}

            return this.createError('string.email', { value: value }, state, options);
        });
    };

    _class.prototype.ip = function ip(ipOptions) {

        var regex = internals.ipRegex;
        ipOptions = ipOptions || {};
        Hoek.assert((typeof ipOptions === 'undefined' ? 'undefined' : (0, _typeof3.default)(ipOptions)) === 'object', 'options must be an object');

        if (ipOptions.cidr) {
            Hoek.assert(typeof ipOptions.cidr === 'string', 'cidr must be a string');
            ipOptions.cidr = ipOptions.cidr.toLowerCase();

            Hoek.assert(ipOptions.cidr in Ip.cidrs, 'cidr must be one of ' + (0, _keys2.default)(Ip.cidrs).join(', '));

            // If we only received a `cidr` setting, create a regex for it. But we don't need to create one if `cidr` is "optional" since that is the default
            if (!ipOptions.version && ipOptions.cidr !== 'optional') {
                regex = Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], ipOptions.cidr);
            }
        } else {

            // Set our default cidr strategy
            ipOptions.cidr = 'optional';
        }

        var versions = void 0;
        if (ipOptions.version) {
            if (!Array.isArray(ipOptions.version)) {
                ipOptions.version = [ipOptions.version];
            }

            Hoek.assert(ipOptions.version.length >= 1, 'version must have at least 1 version specified');

            versions = [];
            for (var i = 0; i < ipOptions.version.length; ++i) {
                var version = ipOptions.version[i];
                Hoek.assert(typeof version === 'string', 'version at position ' + i + ' must be a string');
                version = version.toLowerCase();
                Hoek.assert(Ip.versions[version], 'version at position ' + i + ' must be one of ' + (0, _keys2.default)(Ip.versions).join(', '));
                versions.push(version);
            }

            // Make sure we have a set of versions
            versions = Hoek.unique(versions);

            regex = Ip.createIpRegex(versions, ipOptions.cidr);
        }

        return this._test('ip', ipOptions, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            if (versions) {
                return this.createError('string.ipVersion', { value: value, cidr: ipOptions.cidr, version: versions }, state, options);
            }

            return this.createError('string.ip', { value: value, cidr: ipOptions.cidr }, state, options);
        });
    };

    _class.prototype.uri = function uri(uriOptions) {

        var customScheme = '';
        var allowRelative = false;
        var relativeOnly = false;
        var regex = internals.uriRegex;

        if (uriOptions) {
            Hoek.assert((typeof uriOptions === 'undefined' ? 'undefined' : (0, _typeof3.default)(uriOptions)) === 'object', 'options must be an object');

            if (uriOptions.scheme) {
                Hoek.assert(uriOptions.scheme instanceof RegExp || typeof uriOptions.scheme === 'string' || Array.isArray(uriOptions.scheme), 'scheme must be a RegExp, String, or Array');

                if (!Array.isArray(uriOptions.scheme)) {
                    uriOptions.scheme = [uriOptions.scheme];
                }

                Hoek.assert(uriOptions.scheme.length >= 1, 'scheme must have at least 1 scheme specified');

                // Flatten the array into a string to be used to match the schemes.
                for (var i = 0; i < uriOptions.scheme.length; ++i) {
                    var scheme = uriOptions.scheme[i];
                    Hoek.assert(scheme instanceof RegExp || typeof scheme === 'string', 'scheme at position ' + i + ' must be a RegExp or String');

                    // Add OR separators if a value already exists
                    customScheme = customScheme + (customScheme ? '|' : '');

                    // If someone wants to match HTTP or HTTPS for example then we need to support both RegExp and String so we don't escape their pattern unknowingly.
                    if (scheme instanceof RegExp) {
                        customScheme = customScheme + scheme.source;
                    } else {
                        Hoek.assert(/[a-zA-Z][a-zA-Z0-9+-\.]*/.test(scheme), 'scheme at position ' + i + ' must be a valid scheme');
                        customScheme = customScheme + Hoek.escapeRegex(scheme);
                    }
                }
            }

            if (uriOptions.allowRelative) {
                allowRelative = true;
            }

            if (uriOptions.relativeOnly) {
                relativeOnly = true;
            }
        }

        if (customScheme || allowRelative || relativeOnly) {
            regex = Uri.createUriRegex(customScheme, allowRelative, relativeOnly);
        }

        return this._test('uri', uriOptions, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            if (relativeOnly) {
                return this.createError('string.uriRelativeOnly', { value: value }, state, options);
            }

            if (customScheme) {
                return this.createError('string.uriCustomScheme', { scheme: customScheme, value: value }, state, options);
            }

            return this.createError('string.uri', { value: value }, state, options);
        });
    };

    _class.prototype.isoDate = function isoDate() {

        return this._test('isoDate', undefined, function (value, state, options) {

            if (JoiDate._isIsoDate(value)) {
                return value;
            }

            return this.createError('string.isoDate', { value: value }, state, options);
        });
    };

    _class.prototype.guid = function guid(guidOptions) {

        var versionNumbers = '';

        if (guidOptions && guidOptions.version) {
            if (!Array.isArray(guidOptions.version)) {
                guidOptions.version = [guidOptions.version];
            }

            Hoek.assert(guidOptions.version.length >= 1, 'version must have at least 1 valid version specified');
            var versions = new _set2.default();

            for (var i = 0; i < guidOptions.version.length; ++i) {
                var version = guidOptions.version[i];
                Hoek.assert(typeof version === 'string', 'version at position ' + i + ' must be a string');
                version = version.toLowerCase();
                var versionNumber = internals.guidVersions[version];
                Hoek.assert(versionNumber, 'version at position ' + i + ' must be one of ' + (0, _keys2.default)(internals.guidVersions).join(', '));
                Hoek.assert(!versions.has(versionNumber), 'version at position ' + i + ' must not be a duplicate.');

                versionNumbers += versionNumber;
                versions.add(versionNumber);
            }
        }

        var guidRegex = new RegExp('^([\\[{\\(]?)[0-9A-F]{8}([:-]?)[0-9A-F]{4}\\2?[' + (versionNumbers || '0-9A-F') + '][0-9A-F]{3}\\2?[' + (versionNumbers ? '89AB' : '0-9A-F') + '][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$', 'i');

        return this._test('guid', guidOptions, function (value, state, options) {

            var results = guidRegex.exec(value);

            if (!results) {
                return this.createError('string.guid', { value: value }, state, options);
            }

            // Matching braces
            if (internals.guidBrackets[results[1]] !== results[results.length - 1]) {
                return this.createError('string.guid', { value: value }, state, options);
            }

            return value;
        });
    };

    _class.prototype.hex = function hex() {

        var regex = /^[a-f0-9]+$/i;

        return this._test('hex', regex, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            return this.createError('string.hex', { value: value }, state, options);
        });
    };

    _class.prototype.base64 = function base64(base64Options) {

        base64Options = base64Options || {};

        // Validation.
        Hoek.assert((typeof base64Options === 'undefined' ? 'undefined' : (0, _typeof3.default)(base64Options)) === 'object', 'base64 options must be an object');
        Hoek.assert(typeof base64Options.paddingRequired === 'undefined' || typeof base64Options.paddingRequired === 'boolean', 'paddingRequired must be boolean');

        // Determine if padding is required.
        var paddingRequired = base64Options.paddingRequired === false ? base64Options.paddingRequired : base64Options.paddingRequired || true;

        // Set validation based on preference.
        var regex = paddingRequired ?
        // Padding is required.
        /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
        // Padding is optional.
        : /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/;

        return this._test('base64', regex, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            return this.createError('string.base64', { value: value }, state, options);
        });
    };

    _class.prototype.hostname = function hostname() {

        var regex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;

        return this._test('hostname', undefined, function (value, state, options) {

            if (value.length <= 255 && regex.test(value) || Net.isIPv6(value)) {

                return value;
            }

            return this.createError('string.hostname', { value: value }, state, options);
        });
    };

    _class.prototype.lowercase = function lowercase() {

        var obj = this._test('lowercase', undefined, function (value, state, options) {

            if (options.convert || value === value.toLocaleLowerCase()) {

                return value;
            }

            return this.createError('string.lowercase', { value: value }, state, options);
        });

        obj._flags.case = 'lower';
        return obj;
    };

    _class.prototype.uppercase = function uppercase() {

        var obj = this._test('uppercase', undefined, function (value, state, options) {

            if (options.convert || value === value.toLocaleUpperCase()) {

                return value;
            }

            return this.createError('string.uppercase', { value: value }, state, options);
        });

        obj._flags.case = 'upper';
        return obj;
    };

    _class.prototype.trim = function trim() {

        var obj = this._test('trim', undefined, function (value, state, options) {

            if (options.convert || value === value.trim()) {

                return value;
            }

            return this.createError('string.trim', { value: value }, state, options);
        });

        obj._flags.trim = true;
        return obj;
    };

    _class.prototype.replace = function replace(pattern, replacement) {

        if (typeof pattern === 'string') {
            pattern = new RegExp(Hoek.escapeRegex(pattern), 'g');
        }

        Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');
        Hoek.assert(typeof replacement === 'string', 'replacement must be a String');

        // This can not be considere a test like trim, we can't "reject"
        // anything from this rule, so just clone the current object
        var obj = this.clone();

        if (!obj._inner.replacements) {
            obj._inner.replacements = [];
        }

        obj._inner.replacements.push({
            pattern: pattern,
            replacement: replacement
        });

        return obj;
    };

    _class.prototype.truncate = function truncate(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.truncate === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.truncate = value;
        return obj;
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (limit, encoding) {

        var isRef = Ref.isRef(limit);

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');
        Hoek.assert(!encoding || Buffer.isEncoding(encoding), 'Invalid encoding:', encoding);

        return this._test(type, limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(0, _isSafeInteger2.default)(compareTo)) {
                    return this.createError('string.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (compare(value, compareTo, encoding)) {
                return value;
            }

            return this.createError('string.' + type, { limit: compareTo, value: value, encoding: encoding }, state, options);
        });
    };
};

internals.String.prototype.min = internals.compare('min', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length >= limit;
});

internals.String.prototype.max = internals.compare('max', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length <= limit;
});

internals.String.prototype.length = internals.compare('length', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length === limit;
});

// Aliases

internals.String.prototype.uuid = internals.String.prototype.guid;

module.exports = new internals.String();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(317).Buffer))

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules


// Delcare internals

var internals = {
  rfc3986: {}
};

internals.generate = function () {

  /**
   * elements separated by forward slash ("/") are alternatives.
   */
  var or = '|';

  /**
   * DIGIT = %x30-39 ; 0-9
   */
  var digit = '0-9';
  var digitOnly = '[' + digit + ']';

  /**
   * ALPHA = %x41-5A / %x61-7A   ; A-Z / a-z
   */
  var alpha = 'a-zA-Z';
  var alphaOnly = '[' + alpha + ']';

  /**
   * cidr       = DIGIT                ; 0-9
   *            / %x31-32 DIGIT         ; 10-29
   *            / "3" %x30-32           ; 30-32
   */
  internals.rfc3986.cidr = digitOnly + or + '[1-2]' + digitOnly + or + '3' + '[0-2]';

  /**
   * HEXDIG = DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
   */
  var hexDigit = digit + 'A-Fa-f';
  var hexDigitOnly = '[' + hexDigit + ']';

  /**
   * unreserved = ALPHA / DIGIT / "-" / "." / "_" / "~"
   */
  var unreserved = alpha + digit + '-\\._~';

  /**
   * sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
   */
  var subDelims = '!\\$&\'\\(\\)\\*\\+,;=';

  /**
   * pct-encoded = "%" HEXDIG HEXDIG
   */
  var pctEncoded = '%' + hexDigit;

  /**
   * pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
   */
  var pchar = unreserved + pctEncoded + subDelims + ':@';
  var pcharOnly = '[' + pchar + ']';

  /**
   * Rule to support zero-padded addresses.
   */
  var zeroPad = '0?';

  /**
   * dec-octet   = DIGIT                 ; 0-9
   *            / %x31-39 DIGIT         ; 10-99
   *            / "1" 2DIGIT            ; 100-199
   *            / "2" %x30-34 DIGIT     ; 200-249
   *            / "25" %x30-35          ; 250-255
   */
  var decOctect = '(?:' + zeroPad + zeroPad + digitOnly + or + zeroPad + '[1-9]' + digitOnly + or + '1' + digitOnly + digitOnly + or + '2' + '[0-4]' + digitOnly + or + '25' + '[0-5])';

  /**
   * IPv4address = dec-octet "." dec-octet "." dec-octet "." dec-octet
   */
  internals.rfc3986.IPv4address = '(?:' + decOctect + '\\.){3}' + decOctect;

  /**
   * h16 = 1*4HEXDIG ; 16 bits of address represented in hexadecimal
   * ls32 = ( h16 ":" h16 ) / IPv4address ; least-significant 32 bits of address
   * IPv6address =                            6( h16 ":" ) ls32
   *             /                       "::" 5( h16 ":" ) ls32
   *             / [               h16 ] "::" 4( h16 ":" ) ls32
   *             / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
   *             / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
   *             / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
   *             / [ *4( h16 ":" ) h16 ] "::"              ls32
   *             / [ *5( h16 ":" ) h16 ] "::"              h16
   *             / [ *6( h16 ":" ) h16 ] "::"
   */
  var h16 = hexDigitOnly + '{1,4}';
  var ls32 = '(?:' + h16 + ':' + h16 + '|' + internals.rfc3986.IPv4address + ')';
  var IPv6SixHex = '(?:' + h16 + ':){6}' + ls32;
  var IPv6FiveHex = '::(?:' + h16 + ':){5}' + ls32;
  var IPv6FourHex = '(?:' + h16 + ')?::(?:' + h16 + ':){4}' + ls32;
  var IPv6ThreeHex = '(?:(?:' + h16 + ':){0,1}' + h16 + ')?::(?:' + h16 + ':){3}' + ls32;
  var IPv6TwoHex = '(?:(?:' + h16 + ':){0,2}' + h16 + ')?::(?:' + h16 + ':){2}' + ls32;
  var IPv6OneHex = '(?:(?:' + h16 + ':){0,3}' + h16 + ')?::' + h16 + ':' + ls32;
  var IPv6NoneHex = '(?:(?:' + h16 + ':){0,4}' + h16 + ')?::' + ls32;
  var IPv6NoneHex2 = '(?:(?:' + h16 + ':){0,5}' + h16 + ')?::' + h16;
  var IPv6NoneHex3 = '(?:(?:' + h16 + ':){0,6}' + h16 + ')?::';
  internals.rfc3986.IPv6address = '(?:' + IPv6SixHex + or + IPv6FiveHex + or + IPv6FourHex + or + IPv6ThreeHex + or + IPv6TwoHex + or + IPv6OneHex + or + IPv6NoneHex + or + IPv6NoneHex2 + or + IPv6NoneHex3 + ')';

  /**
   * IPvFuture = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )
   */
  internals.rfc3986.IPvFuture = 'v' + hexDigitOnly + '+\\.[' + unreserved + subDelims + ':]+';

  /**
   * scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
   */
  internals.rfc3986.scheme = alphaOnly + '[' + alpha + digit + '+-\\.]*';

  /**
   * userinfo = *( unreserved / pct-encoded / sub-delims / ":" )
   */
  var userinfo = '[' + unreserved + pctEncoded + subDelims + ':]*';

  /**
   * IP-literal = "[" ( IPv6address / IPvFuture  ) "]"
   */
  var IPLiteral = '\\[(?:' + internals.rfc3986.IPv6address + or + internals.rfc3986.IPvFuture + ')\\]';

  /**
   * reg-name = *( unreserved / pct-encoded / sub-delims )
   */
  var regName = '[' + unreserved + pctEncoded + subDelims + ']{0,255}';

  /**
   * host = IP-literal / IPv4address / reg-name
   */
  var host = '(?:' + IPLiteral + or + internals.rfc3986.IPv4address + or + regName + ')';

  /**
   * port = *DIGIT
   */
  var port = digitOnly + '*';

  /**
   * authority   = [ userinfo "@" ] host [ ":" port ]
   */
  var authority = '(?:' + userinfo + '@)?' + host + '(?::' + port + ')?';

  /**
   * segment       = *pchar
   * segment-nz    = 1*pchar
   * path          = path-abempty    ; begins with "/" or is empty
   *               / path-absolute   ; begins with "/" but not "//"
   *               / path-noscheme   ; begins with a non-colon segment
   *               / path-rootless   ; begins with a segment
   *               / path-empty      ; zero characters
   * path-abempty  = *( "/" segment )
   * path-absolute = "/" [ segment-nz *( "/" segment ) ]
   * path-rootless = segment-nz *( "/" segment )
   */
  var segment = pcharOnly + '*';
  var segmentNz = pcharOnly + '+';
  var segmentNzNc = '[' + unreserved + pctEncoded + subDelims + '@' + ']+';
  var pathEmpty = '';
  var pathAbEmpty = '(?:\\/' + segment + ')*';
  var pathAbsolute = '\\/(?:' + segmentNz + pathAbEmpty + ')?';
  var pathRootless = segmentNz + pathAbEmpty;
  var pathNoScheme = segmentNzNc + pathAbEmpty;

  /**
   * hier-part = "//" authority path
   */
  internals.rfc3986.hierPart = '(?:' + '(?:\\/\\/' + authority + pathAbEmpty + ')' + or + pathAbsolute + or + pathRootless + ')';

  /**
   * relative-part = "//" authority path-abempty
   *                 / path-absolute
   *                 / path-noscheme
   *                 / path-empty
   */
  internals.rfc3986.relativeRef = '(?:' + '(?:\\/\\/' + authority + pathAbEmpty + ')' + or + pathAbsolute + or + pathNoScheme + or + pathEmpty + ')';

  /**
   * query = *( pchar / "/" / "?" )
   */
  internals.rfc3986.query = '[' + pchar + '\\/\\?]*(?=#|$)'; //Finish matching either at the fragment part or end of the line.

  /**
   * fragment = *( pchar / "/" / "?" )
   */
  internals.rfc3986.fragment = '[' + pchar + '\\/\\?]*';
};

internals.generate();

module.exports = internals.rfc3986;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _isSafeInteger = __webpack_require__(257);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Any = __webpack_require__(137);
var Ref = __webpack_require__(153);
var Hoek = __webpack_require__(96);

// Declare internals

var internals = {
    precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/
};

internals.Number = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'number';
        _this._invalids.add(Infinity);
        _this._invalids.add(-Infinity);
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            errors: null,
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            var number = parseFloat(value);
            result.value = isNaN(number) || !isFinite(value) ? NaN : number;
        }

        var isNumber = typeof result.value === 'number' && !isNaN(result.value);

        if (options.convert && 'precision' in this._flags && isNumber) {

            // This is conceptually equivalent to using toFixed but it should be much faster
            var precision = Math.pow(10, this._flags.precision);
            result.value = Math.round(result.value * precision) / precision;
        }

        result.errors = isNumber ? null : this.createError('number.base', null, state, options);
        return result;
    };

    _class.prototype.multiple = function multiple(base) {

        var isRef = Ref.isRef(base);

        if (!isRef) {
            Hoek.assert(typeof base === 'number' && isFinite(base), 'multiple must be a number');
            Hoek.assert(base > 0, 'multiple must be greater than 0');
        }

        return this._test('multiple', base, function (value, state, options) {

            var divisor = isRef ? base(state.reference || state.parent, options) : base;

            if (isRef && (typeof divisor !== 'number' || !isFinite(divisor))) {
                return this.createError('number.ref', { ref: base.key }, state, options);
            }

            if (value % divisor === 0) {
                return value;
            }

            return this.createError('number.multiple', { multiple: base, value: value }, state, options);
        });
    };

    _class.prototype.integer = function integer() {

        return this._test('integer', undefined, function (value, state, options) {

            return (0, _isSafeInteger2.default)(value) ? value : this.createError('number.integer', { value: value }, state, options);
        });
    };

    _class.prototype.negative = function negative() {

        return this._test('negative', undefined, function (value, state, options) {

            if (value < 0) {
                return value;
            }

            return this.createError('number.negative', { value: value }, state, options);
        });
    };

    _class.prototype.positive = function positive() {

        return this._test('positive', undefined, function (value, state, options) {

            if (value > 0) {
                return value;
            }

            return this.createError('number.positive', { value: value }, state, options);
        });
    };

    _class.prototype.precision = function precision(limit) {

        Hoek.assert((0, _isSafeInteger2.default)(limit), 'limit must be an integer');
        Hoek.assert(!('precision' in this._flags), 'precision already set');

        var obj = this._test('precision', limit, function (value, state, options) {

            var places = value.toString().match(internals.precisionRx);
            var decimals = Math.max((places[1] ? places[1].length : 0) - (places[2] ? parseInt(places[2], 10) : 0), 0);
            if (decimals <= limit) {
                return value;
            }

            return this.createError('number.precision', { limit: limit, value: value }, state, options);
        });

        obj._flags.precision = limit;
        return obj;
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (limit) {

        var isRef = Ref.isRef(limit);
        var isNumber = typeof limit === 'number' && !isNaN(limit);

        Hoek.assert(isNumber || isRef, 'limit must be a number or reference');

        return this._test(type, limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(typeof compareTo === 'number' && !isNaN(compareTo))) {
                    return this.createError('number.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (compare(value, compareTo)) {
                return value;
            }

            return this.createError('number.' + type, { limit: compareTo, value: value }, state, options);
        });
    };
};

internals.Number.prototype.min = internals.compare('min', function (value, limit) {
    return value >= limit;
});
internals.Number.prototype.max = internals.compare('max', function (value, limit) {
    return value <= limit;
});
internals.Number.prototype.greater = internals.compare('greater', function (value, limit) {
    return value > limit;
});
internals.Number.prototype.less = internals.compare('less', function (value, limit) {
    return value < limit;
});

module.exports = new internals.Number();

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Any = __webpack_require__(137);
var Hoek = __webpack_require__(96);

// Declare internals

var internals = {
    Set: __webpack_require__(801)
};

internals.Boolean = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'boolean';
        _this._flags.insensitive = true;
        _this._inner.truthySet = new internals.Set();
        _this._inner.falsySet = new internals.Set();
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            var normalized = this._flags.insensitive ? value.toLowerCase() : value;
            result.value = normalized === 'true' ? true : normalized === 'false' ? false : value;
        }

        if (typeof result.value !== 'boolean') {
            result.value = this._inner.truthySet.has(value, null, null, this._flags.insensitive) ? true : this._inner.falsySet.has(value, null, null, this._flags.insensitive) ? false : value;
        }

        result.errors = typeof result.value === 'boolean' ? null : this.createError('boolean.base', null, state, options);
        return result;
    };

    _class.prototype.truthy = function truthy() {

        var obj = this.clone();
        var values = Hoek.flatten(Array.prototype.slice.call(arguments));
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call truthy with undefined');
            obj._inner.truthySet.add(value);
        }
        return obj;
    };

    _class.prototype.falsy = function falsy() {

        var obj = this.clone();
        var values = Hoek.flatten(Array.prototype.slice.call(arguments));
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call falsy with undefined');
            obj._inner.falsySet.add(value);
        }
        return obj;
    };

    _class.prototype.insensitive = function insensitive(enabled) {

        var insensitive = enabled === undefined ? true : !!enabled;

        if (this._flags.insensitive === insensitive) {
            return this;
        }

        var obj = this.clone();
        obj._flags.insensitive = insensitive;
        return obj;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);
        description.truthy = [true].concat(this._inner.truthySet.values());
        description.falsy = [false].concat(this._inner.falsySet.values());
        return description;
    };

    return _class;
}(Any);

module.exports = new internals.Boolean();

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _isSafeInteger = __webpack_require__(257);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(393);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hoek = __webpack_require__(96);
var Topo = __webpack_require__(1574);
var Any = __webpack_require__(137);
var Errors = __webpack_require__(530);
var Cast = __webpack_require__(318);
var Ref = __webpack_require__(153);

// Declare internals

var internals = {};

internals.Object = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'object';
        _this._inner.children = null;
        _this._inner.renames = [];
        _this._inner.dependencies = [];
        _this._inner.patterns = [];
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var target = value;
        var errors = [];
        var finish = function finish() {

            return {
                value: target,
                errors: errors.length ? errors : null
            };
        };

        if (typeof value === 'string' && options.convert) {

            value = internals.safeParse(value);
        }

        var type = this._flags.func ? 'function' : 'object';
        if (!value || (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) !== type || Array.isArray(value)) {

            errors.push(this.createError(type + '.base', null, state, options));
            return finish();
        }

        // Skip if there are no other rules to test

        if (!this._inner.renames.length && !this._inner.dependencies.length && !this._inner.children && // null allows any keys
        !this._inner.patterns.length) {

            target = value;
            return finish();
        }

        // Ensure target is a local copy (parsed) or shallow copy

        if (target === value) {
            if (type === 'object') {
                target = (0, _create2.default)((0, _getPrototypeOf2.default)(value));
            } else {
                target = function target() {

                    return value.apply(this, arguments);
                };

                target.prototype = Hoek.clone(value.prototype);
            }

            var valueKeys = (0, _keys2.default)(value);
            for (var i = 0; i < valueKeys.length; ++i) {
                target[valueKeys[i]] = value[valueKeys[i]];
            }
        } else {
            target = value;
        }

        // Rename keys

        var renamed = {};
        for (var _i = 0; _i < this._inner.renames.length; ++_i) {
            var rename = this._inner.renames[_i];

            if (rename.options.ignoreUndefined && target[rename.from] === undefined) {
                continue;
            }

            if (!rename.options.multiple && renamed[rename.to]) {

                errors.push(this.createError('object.rename.multiple', { from: rename.from, to: rename.to }, state, options));
                if (options.abortEarly) {
                    return finish();
                }
            }

            if (Object.prototype.hasOwnProperty.call(target, rename.to) && !rename.options.override && !renamed[rename.to]) {

                errors.push(this.createError('object.rename.override', { from: rename.from, to: rename.to }, state, options));
                if (options.abortEarly) {
                    return finish();
                }
            }

            if (target[rename.from] === undefined) {
                delete target[rename.to];
            } else {
                target[rename.to] = target[rename.from];
            }

            renamed[rename.to] = true;

            if (!rename.options.alias) {
                delete target[rename.from];
            }
        }

        // Validate schema

        if (!this._inner.children && // null allows any keys
        !this._inner.patterns.length && !this._inner.dependencies.length) {

            return finish();
        }

        var unprocessed = Hoek.mapToObject((0, _keys2.default)(target));

        if (this._inner.children) {
            var stripProps = [];

            for (var _i2 = 0; _i2 < this._inner.children.length; ++_i2) {
                var child = this._inner.children[_i2];
                var key = child.key;
                var item = target[key];

                delete unprocessed[key];

                var localState = { key: key, path: (state.path || '') + (state.path && key ? '.' : '') + key, parent: target, reference: state.reference };
                var result = child.schema._validate(item, localState, options);
                if (result.errors) {
                    errors.push(this.createError('object.child', { key: key, child: child.schema._getLabel(key), reason: result.errors }, localState, options));

                    if (options.abortEarly) {
                        return finish();
                    }
                } else {
                    if (child.schema._flags.strip || result.value === undefined && result.value !== item) {
                        stripProps.push(key);
                        target[key] = result.finalValue;
                    } else if (result.value !== undefined) {
                        target[key] = result.value;
                    }
                }
            }

            for (var _i3 = 0; _i3 < stripProps.length; ++_i3) {
                delete target[stripProps[_i3]];
            }
        }

        // Unknown keys

        var unprocessedKeys = (0, _keys2.default)(unprocessed);
        if (unprocessedKeys.length && this._inner.patterns.length) {

            for (var _i4 = 0; _i4 < unprocessedKeys.length; ++_i4) {
                var _key = unprocessedKeys[_i4];
                var _localState = { key: _key, path: (state.path ? state.path + '.' : '') + _key, parent: target, reference: state.reference };
                var _item = target[_key];

                for (var j = 0; j < this._inner.patterns.length; ++j) {
                    var pattern = this._inner.patterns[j];

                    if (pattern.regex.test(_key)) {
                        delete unprocessed[_key];

                        var _result = pattern.rule._validate(_item, _localState, options);
                        if (_result.errors) {
                            errors.push(this.createError('object.child', { key: _key, child: pattern.rule._getLabel(_key), reason: _result.errors }, _localState, options));

                            if (options.abortEarly) {
                                return finish();
                            }
                        }

                        if (_result.value !== undefined) {
                            target[_key] = _result.value;
                        }
                    }
                }
            }

            unprocessedKeys = (0, _keys2.default)(unprocessed);
        }

        if ((this._inner.children || this._inner.patterns.length) && unprocessedKeys.length) {
            if (options.stripUnknown && this._flags.allowUnknown !== true || options.skipFunctions) {

                var stripUnknown = options.stripUnknown ? options.stripUnknown === true ? true : !!options.stripUnknown.objects : false;

                for (var _i5 = 0; _i5 < unprocessedKeys.length; ++_i5) {
                    var _key2 = unprocessedKeys[_i5];

                    if (stripUnknown) {
                        delete target[_key2];
                        delete unprocessed[_key2];
                    } else if (typeof target[_key2] === 'function') {
                        delete unprocessed[_key2];
                    }
                }

                unprocessedKeys = (0, _keys2.default)(unprocessed);
            }

            if (unprocessedKeys.length && (this._flags.allowUnknown !== undefined ? !this._flags.allowUnknown : !options.allowUnknown)) {

                for (var _i6 = 0; _i6 < unprocessedKeys.length; ++_i6) {
                    var unprocessedKey = unprocessedKeys[_i6];
                    errors.push(this.createError('object.allowUnknown', { child: unprocessedKey }, { key: unprocessedKey, path: state.path + (state.path ? '.' : '') + unprocessedKey }, options));
                }
            }
        }

        // Validate dependencies

        for (var _i7 = 0; _i7 < this._inner.dependencies.length; ++_i7) {
            var dep = this._inner.dependencies[_i7];
            var err = internals[dep.type].call(this, dep.key !== null && target[dep.key], dep.peers, target, { key: dep.key, path: (state.path || '') + (dep.key ? '.' + dep.key : '') }, options);
            if (err instanceof Errors.Err) {
                errors.push(err);
                if (options.abortEarly) {
                    return finish();
                }
            }
        }

        return finish();
    };

    _class.prototype._func = function _func() {

        var obj = this.clone();
        obj._flags.func = true;
        return obj;
    };

    _class.prototype.keys = function keys(schema) {

        Hoek.assert(schema === null || schema === undefined || (typeof schema === 'undefined' ? 'undefined' : (0, _typeof3.default)(schema)) === 'object', 'Object schema must be a valid object');
        Hoek.assert(!schema || !(schema instanceof Any), 'Object schema cannot be a joi schema');

        var obj = this.clone();

        if (!schema) {
            obj._inner.children = null;
            return obj;
        }

        var children = (0, _keys2.default)(schema);

        if (!children.length) {
            obj._inner.children = [];
            return obj;
        }

        var topo = new Topo();
        if (obj._inner.children) {
            for (var i = 0; i < obj._inner.children.length; ++i) {
                var child = obj._inner.children[i];

                // Only add the key if we are not going to replace it later
                if (children.indexOf(child.key) === -1) {
                    topo.add(child, { after: child._refs, group: child.key });
                }
            }
        }

        for (var _i8 = 0; _i8 < children.length; ++_i8) {
            var key = children[_i8];
            var _child = schema[key];
            try {
                var cast = Cast.schema(_child);
                topo.add({ key: key, schema: cast }, { after: cast._refs, group: key });
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = key + '.' + castErr.path;
                } else {
                    castErr.path = key;
                }
                throw castErr;
            }
        }

        obj._inner.children = topo.nodes;

        return obj;
    };

    _class.prototype.unknown = function unknown(allow) {

        var value = allow !== false;

        if (this._flags.allowUnknown === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.allowUnknown = value;
        return obj;
    };

    _class.prototype.length = function length(limit) {

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('length', limit, function (value, state, options) {

            if ((0, _keys2.default)(value).length === limit) {
                return value;
            }

            return this.createError('object.length', { limit: limit }, state, options);
        });
    };

    _class.prototype.arity = function arity(n) {

        Hoek.assert((0, _isSafeInteger2.default)(n) && n >= 0, 'n must be a positive integer');

        return this._test('arity', n, function (value, state, options) {

            if (value.length === n) {
                return value;
            }

            return this.createError('function.arity', { n: n }, state, options);
        });
    };

    _class.prototype.minArity = function minArity(n) {

        Hoek.assert((0, _isSafeInteger2.default)(n) && n > 0, 'n must be a strict positive integer');

        return this._test('minArity', n, function (value, state, options) {

            if (value.length >= n) {
                return value;
            }

            return this.createError('function.minArity', { n: n }, state, options);
        });
    };

    _class.prototype.maxArity = function maxArity(n) {

        Hoek.assert((0, _isSafeInteger2.default)(n) && n >= 0, 'n must be a positive integer');

        return this._test('maxArity', n, function (value, state, options) {

            if (value.length <= n) {
                return value;
            }

            return this.createError('function.maxArity', { n: n }, state, options);
        });
    };

    _class.prototype.min = function min(limit) {

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('min', limit, function (value, state, options) {

            if ((0, _keys2.default)(value).length >= limit) {
                return value;
            }

            return this.createError('object.min', { limit: limit }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('max', limit, function (value, state, options) {

            if ((0, _keys2.default)(value).length <= limit) {
                return value;
            }

            return this.createError('object.max', { limit: limit }, state, options);
        });
    };

    _class.prototype.pattern = function pattern(_pattern, schema) {

        Hoek.assert(_pattern instanceof RegExp, 'Invalid regular expression');
        Hoek.assert(schema !== undefined, 'Invalid rule');

        _pattern = new RegExp(_pattern.source, _pattern.ignoreCase ? 'i' : undefined); // Future version should break this and forbid unsupported regex flags

        try {
            schema = Cast.schema(schema);
        } catch (castErr) {
            if (castErr.hasOwnProperty('path')) {
                castErr.message = castErr.message + '(' + castErr.path + ')';
            }

            throw castErr;
        }

        var obj = this.clone();
        obj._inner.patterns.push({ regex: _pattern, rule: schema });
        return obj;
    };

    _class.prototype.schema = function schema() {

        return this._test('schema', null, function (value, state, options) {

            if (value instanceof Any) {
                return value;
            }

            return this.createError('object.schema', null, state, options);
        });
    };

    _class.prototype.with = function _with(key, peers) {

        return this._dependency('with', key, peers);
    };

    _class.prototype.without = function without(key, peers) {

        return this._dependency('without', key, peers);
    };

    _class.prototype.xor = function xor() {

        var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
        return this._dependency('xor', null, peers);
    };

    _class.prototype.or = function or() {

        var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
        return this._dependency('or', null, peers);
    };

    _class.prototype.and = function and() {

        var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
        return this._dependency('and', null, peers);
    };

    _class.prototype.nand = function nand() {

        var peers = Hoek.flatten(Array.prototype.slice.call(arguments));
        return this._dependency('nand', null, peers);
    };

    _class.prototype.requiredKeys = function requiredKeys(children) {

        children = Hoek.flatten(Array.prototype.slice.call(arguments));
        return this.applyFunctionToChildren(children, 'required');
    };

    _class.prototype.optionalKeys = function optionalKeys(children) {

        children = Hoek.flatten(Array.prototype.slice.call(arguments));
        return this.applyFunctionToChildren(children, 'optional');
    };

    _class.prototype.forbiddenKeys = function forbiddenKeys(children) {

        children = Hoek.flatten(Array.prototype.slice.call(arguments));
        return this.applyFunctionToChildren(children, 'forbidden');
    };

    _class.prototype.rename = function rename(from, to, options) {

        Hoek.assert(typeof from === 'string', 'Rename missing the from argument');
        Hoek.assert(typeof to === 'string', 'Rename missing the to argument');
        Hoek.assert(to !== from, 'Cannot rename key to same name:', from);

        for (var i = 0; i < this._inner.renames.length; ++i) {
            Hoek.assert(this._inner.renames[i].from !== from, 'Cannot rename the same key multiple times');
        }

        var obj = this.clone();

        obj._inner.renames.push({
            from: from,
            to: to,
            options: Hoek.applyToDefaults(internals.renameDefaults, options || {})
        });

        return obj;
    };

    _class.prototype.applyFunctionToChildren = function applyFunctionToChildren(children, fn, args, root) {

        children = [].concat(children);
        Hoek.assert(children.length > 0, 'expected at least one children');

        var groupedChildren = internals.groupChildren(children);
        var obj = void 0;

        if ('' in groupedChildren) {
            obj = this[fn].apply(this, args);
            delete groupedChildren[''];
        } else {
            obj = this.clone();
        }

        if (obj._inner.children) {
            root = root ? root + '.' : '';

            for (var i = 0; i < obj._inner.children.length; ++i) {
                var child = obj._inner.children[i];
                var group = groupedChildren[child.key];

                if (group) {
                    obj._inner.children[i] = {
                        key: child.key,
                        _refs: child._refs,
                        schema: child.schema.applyFunctionToChildren(group, fn, args, root + child.key)
                    };

                    delete groupedChildren[child.key];
                }
            }
        }

        var remaining = (0, _keys2.default)(groupedChildren);
        Hoek.assert(remaining.length === 0, 'unknown key(s)', remaining.join(', '));

        return obj;
    };

    _class.prototype._dependency = function _dependency(type, key, peers) {

        peers = [].concat(peers);
        for (var i = 0; i < peers.length; ++i) {
            Hoek.assert(typeof peers[i] === 'string', type, 'peers must be a string or array of strings');
        }

        var obj = this.clone();
        obj._inner.dependencies.push({ type: type, key: key, peers: peers });
        return obj;
    };

    _class.prototype.describe = function describe(shallow) {

        var description = Any.prototype.describe.call(this);

        if (description.rules) {
            for (var i = 0; i < description.rules.length; ++i) {
                var rule = description.rules[i];
                // Coverage off for future-proof descriptions, only object().assert() is use right now
                if ( /* $lab:coverage:off$ */rule.arg && (0, _typeof3.default)(rule.arg) === 'object' && rule.arg.schema && rule.arg.ref /* $lab:coverage:on$ */) {
                        rule.arg = {
                            schema: rule.arg.schema.describe(),
                            ref: rule.arg.ref.toString()
                        };
                    }
            }
        }

        if (this._inner.children && !shallow) {

            description.children = {};
            for (var _i9 = 0; _i9 < this._inner.children.length; ++_i9) {
                var child = this._inner.children[_i9];
                description.children[child.key] = child.schema.describe();
            }
        }

        if (this._inner.dependencies.length) {
            description.dependencies = Hoek.clone(this._inner.dependencies);
        }

        if (this._inner.patterns.length) {
            description.patterns = [];

            for (var _i10 = 0; _i10 < this._inner.patterns.length; ++_i10) {
                var pattern = this._inner.patterns[_i10];
                description.patterns.push({ regex: pattern.regex.toString(), rule: pattern.rule.describe() });
            }
        }

        if (this._inner.renames.length > 0) {
            description.renames = Hoek.clone(this._inner.renames);
        }

        return description;
    };

    _class.prototype.assert = function assert(ref, schema, message) {

        ref = Cast.ref(ref);
        Hoek.assert(ref.isContext || ref.depth > 1, 'Cannot use assertions for root level references - use direct key rules instead');
        message = message || 'pass the assertion test';

        try {
            schema = Cast.schema(schema);
        } catch (castErr) {
            if (castErr.hasOwnProperty('path')) {
                castErr.message = castErr.message + '(' + castErr.path + ')';
            }

            throw castErr;
        }

        var key = ref.path[ref.path.length - 1];
        var path = ref.path.join('.');

        return this._test('assert', { schema: schema, ref: ref }, function (value, state, options) {

            var result = schema._validate(ref(value), null, options, value);
            if (!result.errors) {
                return value;
            }

            var localState = Hoek.merge({}, state);
            localState.key = key;
            localState.path = path;
            return this.createError('object.assert', { ref: localState.path, message: message }, localState, options);
        });
    };

    _class.prototype.type = function type(constructor, name) {

        Hoek.assert(typeof constructor === 'function', 'type must be a constructor function');
        var typeData = {
            name: name || constructor.name,
            ctor: constructor
        };

        return this._test('type', typeData, function (value, state, options) {

            if (value instanceof constructor) {
                return value;
            }

            return this.createError('object.type', { type: typeData.name }, state, options);
        });
    };

    _class.prototype.ref = function ref() {

        return this._test('ref', null, function (value, state, options) {

            if (Ref.isRef(value)) {
                return value;
            }

            return this.createError('function.ref', null, state, options);
        });
    };

    return _class;
}(Any);

internals.safeParse = function (value) {

    try {
        return JSON.parse(value);
    } catch (parseErr) {}

    return value;
};

internals.renameDefaults = {
    alias: false, // Keep old value in place
    multiple: false, // Allow renaming multiple keys into the same target
    override: false // Overrides an existing key
};

internals.groupChildren = function (children) {

    children.sort();

    var grouped = {};

    for (var i = 0; i < children.length; ++i) {
        var child = children[i];
        Hoek.assert(typeof child === 'string', 'children must be strings');
        var group = child.split('.')[0];
        var childGroup = grouped[group] = grouped[group] || [];
        childGroup.push(child.substring(group.length + 1));
    }

    return grouped;
};

internals.keysToLabels = function (schema, keys) {

    var children = schema._inner.children;

    if (!children) {
        return keys;
    }

    var findLabel = function findLabel(key) {

        var matchingChild = children.find(function (child) {
            return child.key === key;
        });
        return matchingChild ? matchingChild.schema._getLabel(key) : key;
    };

    if (Array.isArray(keys)) {
        return keys.map(findLabel);
    }

    return findLabel(keys);
};

internals.with = function (value, peers, parent, state, options) {

    if (value === undefined) {
        return value;
    }

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (!Object.prototype.hasOwnProperty.call(parent, peer) || parent[peer] === undefined) {

            return this.createError('object.with', {
                main: state.key,
                mainWithLabel: internals.keysToLabels(this, state.key),
                peer: peer,
                peerWithLabel: internals.keysToLabels(this, peer)
            }, state, options);
        }
    }

    return value;
};

internals.without = function (value, peers, parent, state, options) {

    if (value === undefined) {
        return value;
    }

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            return this.createError('object.without', {
                main: state.key,
                mainWithLabel: internals.keysToLabels(this, state.key),
                peer: peer,
                peerWithLabel: internals.keysToLabels(this, peer)
            }, state, options);
        }
    }

    return value;
};

internals.xor = function (value, peers, parent, state, options) {

    var present = [];
    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            present.push(peer);
        }
    }

    if (present.length === 1) {
        return value;
    }

    var context = { peers: peers, peersWithLabels: internals.keysToLabels(this, peers) };

    if (present.length === 0) {
        return this.createError('object.missing', context, state, options);
    }

    return this.createError('object.xor', context, state, options);
};

internals.or = function (value, peers, parent, state, options) {

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {
            return value;
        }
    }

    return this.createError('object.missing', {
        peers: peers,
        peersWithLabels: internals.keysToLabels(this, peers)
    }, state, options);
};

internals.and = function (value, peers, parent, state, options) {

    var missing = [];
    var present = [];
    var count = peers.length;
    for (var i = 0; i < count; ++i) {
        var peer = peers[i];
        if (!Object.prototype.hasOwnProperty.call(parent, peer) || parent[peer] === undefined) {

            missing.push(peer);
        } else {
            present.push(peer);
        }
    }

    var aon = missing.length === count || present.length === count;

    if (!aon) {

        return this.createError('object.and', {
            present: present,
            presentWithLabels: internals.keysToLabels(this, present),
            missing: missing,
            missingWithLabels: internals.keysToLabels(this, missing)
        }, state, options);
    }
};

internals.nand = function (value, peers, parent, state, options) {

    var present = [];
    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            present.push(peer);
        }
    }

    var values = Hoek.clone(peers);
    var main = values.splice(0, 1)[0];
    var allPresent = present.length === peers.length;
    return allPresent ? this.createError('object.nand', {
        main: main,
        mainWithLabel: internals.keysToLabels(this, main),
        peers: values,
        peersWithLabels: internals.keysToLabels(this, values)
    }, state, options) : null;
};

module.exports = new internals.Object();

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.logoutUser = undefined;
exports.handleUnauthorisedError = handleUnauthorisedError;
exports.handleForbiddenError = handleForbiddenError;
exports.checkForbidden = checkForbidden;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _API = __webpack_require__(201);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoutUser = exports.logoutUser = function logoutUser(error) {
    _AppDispatcher2.default.dispatch({
        actionType: _AppConstants.ActionTypes.AUTH_ERROR,
        error: error
    });

    _AppDispatcher2.default.dispatch({
        actionType: _AppConstants.ActionTypes.LOGGED_OUT
    });

    _AppDispatcher2.default.dispatch({
        actionType: _AppConstants.ActionTypes.LOADING_STOPPED
    });

    _ModalActions2.default.open(_AppConstants.GlobalModals.LOGGED_OUT, {
        onClose: function onClose() {
            return _ModalActions2.default.close(_AppConstants.GlobalModals.LOGGED_OUT);
        }
    });
};

function handleUnauthorisedError(error) {
    if (error instanceof _API.UnauthorisedError) {
        logoutUser(error);
    } else {
        throw error;
    }
}

function handleForbiddenError(error) {
    if (error instanceof _API.ForbiddenError) {
        logoutUser(error);
    } else {
        throw error;
    }
}

function checkForbidden(target, name, descriptor) {
    var original = descriptor.value;

    descriptor.value = function () {
        return original.apply(this, arguments).catch(handleForbiddenError);
    };
    descriptor.value.__DECORATORS = ['checkForbidden'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    text: null,
    startDate: null,
    endDate: null
};

var Banner = function (_record) {
    (0, _inherits3.default)(Banner, _record);

    function Banner() {
        (0, _classCallCheck3.default)(this, Banner);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Banner.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Banner, json, {
            id: _LinkMapper.fields.string,
            text: _LinkMapper.fields.string,
            startDate: _LinkMapper.fields.datetime,
            endDate: _LinkMapper.fields.datetime
        });
    };

    Banner.prototype.isActive = function isActive() {
        var now = (0, _TrainTime2.default)();
        if (this.startDate && this.endDate) {
            return now.isBetween(this.startDate, this.endDate);
        }
        return false;
    };

    return Banner;
}((0, _immutable.Record)(defaults));

exports.default = Banner;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1615), __esModule: true };

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return props[name] === true || props[name] === 'true' || props[name] === name;
};

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// this is only true when in a browser-like environment
// (or someone seriously messed up)
exports.default = typeof window !== 'undefined';

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @module Passage
 */


var Route = __webpack_require__(1656);


module.exports = Route;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module route/nodes */


/**
 * Create a node for use with the parser, giving it a constructor that takes
 * props, children, and returns an object with props, children, and a
 * displayName.
 * @param  {String} displayName The display name for the node
 * @return {{displayName: string, props: Object, children: Array}}
 */
function createNode(displayName) {
  return function(props, children) {
    return {
      displayName: displayName,
      props: props,
      children: children || []
    };
  };
}

module.exports = {
  Root: createNode('Root'),
  Concat: createNode('Concat'),
  Literal: createNode('Literal'),
  Splat: createNode('Splat'),
  Param: createNode('Param'),
  Optional: createNode('Optional')
};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module route/visitors/create_visitor
 */

var nodeTypes = Object.keys(__webpack_require__(814));

/**
 * Helper for creating visitors. Take an object of node name to handler
 * mappings, returns an object with a "visit" method that can be called
 * @param  {Object.<string,function(node,context)>} handlers A mapping of node
 * type to visitor functions
 * @return {{visit: function(node,context)}}  A visitor object with a "visit"
 * method that can be called on a node with a context
 */
function createVisitor(handlers) {
  nodeTypes.forEach(function(nodeType) {
    if( typeof handlers[nodeType] === 'undefined') {
      throw new Error('No handler defined for ' + nodeType.displayName);
    }

  });

  return {
    /**
     * Call the given handler for this node type
     * @param  {Object} node    the AST node
     * @param  {Object} context context to pass through to handlers
     * @return {Object}
     */
    visit: function(node, context) {
      return this.handlers[node.displayName].call(this,node, context);
    },
    handlers: handlers
  };
}

module.exports = createVisitor;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _ValidityPeriod = __webpack_require__(395);

var _ValidityPeriod2 = _interopRequireDefault(_ValidityPeriod);

var _Leg = __webpack_require__(1680);

var _Leg2 = _interopRequireDefault(_Leg);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    validFrom: null,
    validTo: null,
    legs: new _immutable.List(),
    validityPeriod: null
};

var OrderJourney = function (_Record) {
    (0, _inherits3.default)(OrderJourney, _Record);

    function OrderJourney() {
        (0, _classCallCheck3.default)(this, OrderJourney);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    OrderJourney.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(OrderJourney, json, {
            id: _LinkMapper.fields.string,
            validFrom: _LinkMapper.fields.datetime,
            validTo: _LinkMapper.fields.datetime,
            legs: _LinkMapper.resolveAll.as(_Leg2.default),
            validityPeriod: _LinkMapper.fields.string
        });
    };

    OrderJourney.prototype.getDepartureTime = function getDepartureTime() {
        var transfer = 0;
        var current = this.legs.first();
        var index = 0;
        while (current && !current.departure) {
            transfer += current.transferTime;
            index++;
            current = this.legs.get(index);
        }

        return current ? current.departure.clone().subtract(transfer, 'minutes') : null;
    };

    OrderJourney.prototype.getArrivalTime = function getArrivalTime() {
        var transfer = 0;
        var current = this.legs.last();
        var index = this.legs.size - 1;
        while (current && !current.arrival) {
            transfer += current.transferTime;
            index--;
            current = this.legs.get(index);
        }

        return current ? current.arrival.clone().add(transfer, 'minutes') : null;
    };

    OrderJourney.prototype.getOrigin = function getOrigin() {
        return this.legs.first().origin;
    };

    OrderJourney.prototype.getDestination = function getDestination() {
        return this.legs.last().destination;
    };

    OrderJourney.prototype.getChanges = function getChanges() {
        return this.legs.size - 1; //TODO: get the api to return this?
    };

    OrderJourney.prototype.hasSeats = function hasSeats() {
        return this.legs.some(function (leg) {
            return leg.hasSeats();
        });
    };

    OrderJourney.prototype.getValidityPeriod = function getValidityPeriod() {
        return _ValidityPeriod2.default.fromString(this.validityPeriod);
    };

    OrderJourney.prototype.getBikeSeats = function getBikeSeats() {
        return this.legs.reduce(function (bikeSeats, leg) {
            var legBikeSeats = leg.getBikeSeats();
            if (legBikeSeats) {
                return bikeSeats.concat(legBikeSeats);
            }
            return bikeSeats;
        }, new _immutable.List());
    };

    /*
        * Returns the maximum number of bike seats available across all legs.
        * This is useful for determining the total capacity for bike reservations
        * in the entire journey.
        *
        * @returns {number} The maximum number of bike seats available.
    */


    OrderJourney.prototype.countBikeSeats = function countBikeSeats() {
        return this.legs.reduce(function (max, leg) {
            var bikeSeats = leg.bikeSeats;
            var count = bikeSeats && typeof bikeSeats.count === 'function' ? bikeSeats.count() : 0;
            return Math.max(max, count);
        }, 0);
    };

    OrderJourney.prototype.getSeatReservations = function getSeatReservations() {
        return this.legs.reduce(function (seats, leg) {
            var legSeats = leg.seats;
            if (legSeats) {
                return seats.concat(legSeats);
            }
            return seats;
        }, new _immutable.List());
    };

    /*
        * Returns the maximum number of seat reservations available across all legs.
        * This is useful for determining the total capacity for seat reservations
        * in the entire journey.
        *
        * @returns {number} The maximum number of seat reservations available.
    */


    OrderJourney.prototype.countSeatReservations = function countSeatReservations() {
        return this.legs.reduce(function (max, leg) {
            var seats = leg.seats;
            var hasCountedPlaceSeats = leg.hasCountedPlaceSeats();
            var count = seats && typeof seats.count === 'function' && !hasCountedPlaceSeats ? seats.count() : 0;
            return Math.max(max, count);
        }, 0);
    };

    return OrderJourney;
}((0, _immutable.Record)(defaults));

exports.default = OrderJourney;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var TOC = new _immutable.Record({
    id: null,
    code: null,
    name: null
});

TOC.fromJSON = function (json) {
    json = json || {};

    var code = (0, _LinkMapper.resolve)(json.code).with(String);
    var name = (0, _LinkMapper.resolve)(json.name).with(String);
    var id = json.id;

    var result = { id: id, code: code, name: name };

    return new TOC(result);
};

exports.default = TOC;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.matchRailcards = undefined;

var _immutable = __webpack_require__(5);

/**
 * Checks if the number of each railcard is at least as many as were applied to the reorderable
 */
var matchRailcards = exports.matchRailcards = function matchRailcards(reorderable, fare) {
  var fareRailcardCounts = new _immutable.Map(fare.getRailcardCounts());
  var reorderableRailcardCounts = reorderable.getRailcardCounts();

  return reorderable.getAllRailcards().count() === fare.getAllRailcards().count() && reorderableRailcardCounts.every(function (qty, code) {
    return fareRailcardCounts.get(code, 0) >= qty;
  });
};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    id: [_LinkMapper.fields.number],
    cardPan: [_LinkMapper.fields.string],
    cardType: [_LinkMapper.fields.string],
    cardHolderName: [_LinkMapper.fields.string],
    amount: [_LinkMapper.fields.number],
    originalAmount: [_LinkMapper.fields.number],
    amountRefunded: [_LinkMapper.fields.number],
    transactionId: [_LinkMapper.fields.string],
    created: [_LinkMapper.fields.datetime],
    refunded: [_LinkMapper.fields.boolean],
    latest: [_LinkMapper.fields.boolean]
};

var CardPayment = function (_record) {
    (0, _inherits3.default)(CardPayment, _record);

    function CardPayment() {
        (0, _classCallCheck3.default)(this, CardPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CardPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CardPayment, json, (0, _Records.getResolvers)(schema));
    };

    CardPayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    CardPayment.prototype.isRefundable = function isRefundable() {
        return this.hasAmount();
    };

    CardPayment.prototype.hasLatestPayment = function hasLatestPayment() {
        return this.latest;
    };

    CardPayment.prototype.getPaymentAmount = function getPaymentAmount() {
        return this.amount;
    };

    (0, _createClass3.default)(CardPayment, [{
        key: 'pan',
        get: function get() {
            return this.cardPan;
        }
    }, {
        key: 'transactionReference',
        get: function get() {
            return this.transactionId;
        }
    }]);
    return CardPayment;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = CardPayment;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(512),
    getPrototype = __webpack_require__(391),
    getSymbols = __webpack_require__(513),
    stubArray = __webpack_require__(756);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(385),
    baseSlice = __webpack_require__(432);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeUnits = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];

var anchor = {
    endDate: 'endDate',
    duration: 'duration'
};

var defaults = {
    startDate: null,
    endDate: null,
    duration: 0,
    unit: 'days',
    anchor: anchor.duration,
    min: _AppConstants.SeasonCustomRange.MIN,
    max: _AppConstants.SeasonCustomRange.MAX
};

var CustomDuration = function (_Record) {
    (0, _inherits3.default)(CustomDuration, _Record);

    function CustomDuration() {
        (0, _classCallCheck3.default)(this, CustomDuration);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    CustomDuration.prototype.setStartDate = function setStartDate(startDate) {
        startDate = _TrainTime2.default.isTrainTime(startDate) ? startDate.clone() : (0, _TrainTime2.default)(startDate);
        var self = this.set('startDate', startDate);

        if (this.anchor === anchor.endDate) {
            return self.setEndDate(self.endDate);
        } else if (this.anchor === anchor.duration) {
            return self.setDuration(self.duration);
        }
        return self;
    };

    CustomDuration.prototype.getStartDate = function getStartDate() {
        return this.startDate && this.startDate.clone();
    };

    CustomDuration.prototype.setEndDate = function setEndDate(endDate) {
        endDate = _TrainTime2.default.isTrainTime(endDate) ? endDate.clone() : (0, _TrainTime2.default)(endDate);
        endDate = this.getConstrainedEndDate(endDate);

        var self = this.set('endDate', endDate);
        if (self.startDate) {
            var duration = endDate.calendarDuration(self.startDate).add(1, self.unit);
            self = self.set('duration', duration);
        }
        return self.set('anchor', anchor.endDate);
    };

    CustomDuration.prototype.getEndDate = function getEndDate() {
        return this.endDate && this.endDate.clone();
    };

    CustomDuration.prototype.setDuration = function setDuration(duration) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        duration = _TrainTime2.default.isDuration(duration) ? duration : _TrainTime2.default.duration.apply(_TrainTime2.default, [duration].concat(args));
        duration = this.getConstrainedDuration(duration);
        var self = this.set('duration', duration);

        if (self.startDate) {
            var endDate = self.addDuration(self.startDate, duration);

            self = self.set('endDate', endDate.subtract(1, self.unit));
        }
        return self.set('anchor', anchor.duration);
    };

    CustomDuration.prototype.formatDuration = function formatDuration() {
        return this.duration.toJSON();
    };

    CustomDuration.prototype.getDuration = function getDuration() {
        return _TrainTime2.default.duration({
            years: this.duration.years(),
            months: this.duration.months(),
            days: this.duration.days()
        });
    };

    CustomDuration.prototype.getConstrainedDuration = function getConstrainedDuration(duration) {
        var min = this.min,
            max = this.max;

        if (min) {
            min = _TrainTime2.default.duration(min);
            if (duration.asMilliseconds() <= min.asMilliseconds()) {
                return min;
            }
        }

        if (max) {
            max = _TrainTime2.default.duration(max);
            if (duration.asMilliseconds() >= max.asMilliseconds()) {
                return max;
            }
        }

        return duration;
    };

    CustomDuration.prototype.getConstrainedEndDate = function getConstrainedEndDate(endDate) {
        if (this.startDate) {
            var duration = this.getConstrainedDuration(endDate.calendarDuration(this.startDate).add(1, this.unit));
            endDate = this.addDuration(this.startDate, duration).subtract(1, this.unit);
        }
        return endDate;
    };

    CustomDuration.prototype.addDuration = function addDuration(date, duration) {
        return timeUnits.reduce(function (acc, unit) {
            return acc.add(duration.get(unit), unit);
        }, date.clone());
    };

    return CustomDuration;
}((0, _immutable.Record)(defaults));

CustomDuration.fromJSON = function () {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var obj = new CustomDuration({
        startDate: (0, _LinkMapper.resolve)(json.startDate).with(_TrainTime2.default),
        unit: (0, _LinkMapper.resolve)(json.unit).with(String),
        anchor: (0, _LinkMapper.resolve)(json.anchor).with(String)
    });

    if (json.anchor === anchor.duration) {
        return obj.setDuration(json.duration, obj.unit);
    }
    if (json.anchor === anchor.endDate) {
        return obj.setEndDate(json.endDate);
    }
    return null;
};

exports.default = CustomDuration;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _split2 = __webpack_require__(1700);

var _split3 = _interopRequireDefault(_split2);

var _uniq2 = __webpack_require__(619);

var _uniq3 = _interopRequireDefault(_uniq2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _SearchUrls = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    routeCode: null,
    ticketTypes: null,
    ticketCategory: null,
    duration: null,
    loadEarlier: true
};

function getFareOnlyTicketTypes(ticket) {
    return (0, _uniq3.default)([_SearchUrls.serializers.code(ticket.ticketType), ticket.smartTicketType].filter(Boolean));
}

var FareOnlySearchPreferences = function (_record) {
    (0, _inherits3.default)(FareOnlySearchPreferences, _record);

    function FareOnlySearchPreferences() {
        (0, _classCallCheck3.default)(this, FareOnlySearchPreferences);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    FareOnlySearchPreferences.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(FareOnlySearchPreferences, json, {
            routeCode: _LinkMapper.resolve.with(String),
            ticketTypes: _LinkMapper.resolve.with(Array),
            ticketCategory: _LinkMapper.resolve.with(String),
            duration: _LinkMapper.resolve.with(String),
            loadEarlier: _LinkMapper.resolve.with(Boolean)
        });
    };

    FareOnlySearchPreferences.fromString = function fromString(dataString) {
        var dataArray = (0, _split3.default)(dataString, ',');
        var json = {
            routeCode: dataArray[0] ? dataArray[0] : null,
            ticketTypes: dataArray[1] ? dataArray[1] : null,
            ticketCategory: dataArray[2] ? dataArray[2] : null,
            duration: dataArray[3] ? dataArray[3] : null,
            loadEarlier: true
        };
        return FareOnlySearchPreferences.fromJSON(json);
    };

    FareOnlySearchPreferences.prototype.toJSON = function toJSON() {
        return (0, _SearchUrls.serialize)({
            routeCode: _SearchUrls.serializers.identity,
            ticketTypes: _SearchUrls.serializers.identity,
            ticketCategory: _SearchUrls.serializers.identity,
            duration: _SearchUrls.serializers.identity,
            loadEarlier: _SearchUrls.serializers.identity
        }, this);
    };

    FareOnlySearchPreferences.prototype.toString = function toString() {
        var toStringify = [_SearchUrls.serializers.identity(this.routeCode), _SearchUrls.serializers.identity(this.ticketTypes), _SearchUrls.serializers.identity(this.ticketCategory), _SearchUrls.serializers.identity(this.duration), _SearchUrls.serializers.identity(this.loadEarlier)];
        return toStringify.join(',');
    };

    FareOnlySearchPreferences.fromFare = function fromFare(fare) {
        return new FareOnlySearchPreferences({
            routeCode: _SearchUrls.serializers.code(fare.route),
            ticketTypes: getFareOnlyTicketTypes(fare),
            duration: fare.isFlexi() ? 'FLEXI' : fare.getOutwardValidityPeriod().toISOString()
        });
    };

    FareOnlySearchPreferences.fromFavourite = function fromFavourite(favourite) {
        return new FareOnlySearchPreferences({
            routeCode: _SearchUrls.serializers.code(favourite.route),
            ticketTypes: getFareOnlyTicketTypes(favourite),
            duration: favourite.isFlexi() ? 'FLEXI' : favourite.duration
        });
    };

    return FareOnlySearchPreferences;
}((0, _immutable.Record)(defaults));

exports.default = FareOnlySearchPreferences;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1701),
    baseUnary = __webpack_require__(350),
    nodeUtil = __webpack_require__(379);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _Leg = __webpack_require__(981);

var _Leg2 = _interopRequireDefault(_Leg);

var _Bulletin = __webpack_require__(1708);

var _Bulletin2 = _interopRequireDefault(_Bulletin);

var _StationStop = __webpack_require__(441);

var _StationStop2 = _interopRequireDefault(_StationStop);

var _CallingPoints = __webpack_require__(616);

var _CallingPoints2 = _interopRequireDefault(_CallingPoints);

var _CancellationReason = __webpack_require__(1709);

var _CancellationReason2 = _interopRequireDefault(_CancellationReason);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    origin: new _StationStop2.default(),
    destination: new _StationStop2.default(),
    changes: 0,
    legs: new _immutable.List(),
    bulletins: new _immutable.List(),
    callingPoints: new _CallingPoints2.default(),
    isOvertaken: false,
    isCancelled: false,
    status: _AppConstants.JourneyStatus.SUCCESSFUL,
    cancellationReason: null
};

var Journey = function (_record) {
    (0, _inherits3.default)(Journey, _record);

    function Journey() {
        (0, _classCallCheck3.default)(this, Journey);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Journey.fromJSON = function fromJSON(json) {
        var legs = (0, _LinkMapper.resolveAll)(json.legs).as(_Leg2.default);
        var changes = legs.count() - 1 || 0;

        return new Journey({
            origin: (0, _LinkMapper.resolve)(json.origin).as(_StationStop2.default),
            destination: (0, _LinkMapper.resolve)(json.destination).as(_StationStop2.default),
            changes: (0, _LinkMapper.resolve)(changes).with(Number),
            legs: legs,
            bulletins: (0, _LinkMapper.resolveAll)(json.bulletins).as(_Bulletin2.default),
            callingPoints: json.callingPoints,
            isOvertaken: (0, _LinkMapper.resolve)(json.isOvertaken).with(Boolean),
            isCancelled: (0, _LinkMapper.resolve)(json.isCancelled).with(Boolean),
            status: (0, _LinkMapper.resolve)(json.status).with(String),
            cancellationReason: (0, _LinkMapper.resolve)(json.cancellationReason).as(_CancellationReason2.default)
        });
    };

    Journey.prototype.getOriginStation = function getOriginStation() {
        return this.origin.station;
    };

    Journey.prototype.getOriginStationCrs = function getOriginStationCrs() {
        return this.getOriginStation().crs;
    };

    Journey.prototype.getDestinationStation = function getDestinationStation() {
        return this.destination.station;
    };

    Journey.prototype.getDestinationStationCrs = function getDestinationStationCrs() {
        return this.destination.station.crs;
    };

    Journey.prototype.isAdjustedDepartureTime = function isAdjustedDepartureTime() {
        return (0, _result3.default)(this.origin, 'isAdjustedTime');
    };

    Journey.prototype.isAdjustedArrivalTime = function isAdjustedArrivalTime() {
        return (0, _result3.default)(this.destination, 'isAdjustedTime');
    };

    Journey.prototype.isArrivalDelayed = function isArrivalDelayed() {
        return (0, _result3.default)(this.destination, 'isDelayed');
    };

    Journey.prototype.isIndeterminateDelay = function isIndeterminateDelay() {
        return this.destination.time.confidence === _AppConstants.AdjustedTimeConfidence.UNCERTAIN && this.isArrivalDelayed();
    };

    Journey.prototype.getDepartureDateTime = function getDepartureDateTime() {
        var adjusted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        return (0, _result3.default)(this.origin.getTime(adjusted), 'clone');
    };

    Journey.prototype.getArrivalDateTime = function getArrivalDateTime() {
        var adjusted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        return (0, _result3.default)(this.destination.getTime(adjusted), 'clone');
    };

    Journey.prototype.getTripDuration = function getTripDuration() {
        return _moment2.default.duration(this.getArrivalDateTime().diff(this.getDepartureDateTime()));
    };

    Journey.prototype.operators = function operators() {
        return this.legs.map(function (leg) {
            return leg.getIn(['serviceDetails', 'toc']);
        }).toSet().filter(function (toc) {
            return toc;
        }).toList();
    };

    Journey.prototype.isDisrupted = function isDisrupted() {
        return this.status !== _AppConstants.JourneyStatus.SUCCESSFUL;
    };

    Journey.prototype.getCancellationMessage = function getCancellationMessage() {
        return (0, _result3.default)(this.cancellationReason, 'message');
    };

    Journey.prototype.hasBulletins = function hasBulletins() {
        return !this.bulletins.isEmpty();
    };

    Journey.prototype.hasP1bulletin = function hasP1bulletin() {
        return this.hasBulletins() && this.bulletins.some(function (bulletin) {
            return bulletin.isP1();
        });
    };

    Journey.prototype.getCountedPlaceLegs = function getCountedPlaceLegs() {
        return this.legs.filter(function (leg) {
            return leg.getIn(['serviceDetails', 'isCountedPlace']);
        });
    };

    Journey.prototype.getDepartureDelay = function getDepartureDelay() {
        return this.getDepartureDateTime().calendarDiff(this.getDepartureDateTime(false));
    };

    return Journey;
}((0, _immutable.Record)(defaults));

exports.default = Journey;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(380),
    arrayEach = __webpack_require__(387),
    assignValue = __webpack_require__(331),
    baseAssign = __webpack_require__(1713),
    baseAssignIn = __webpack_require__(1714),
    cloneBuffer = __webpack_require__(828),
    copyArray = __webpack_require__(311),
    copySymbols = __webpack_require__(1715),
    copySymbolsIn = __webpack_require__(1716),
    getAllKeys = __webpack_require__(753),
    getAllKeysIn = __webpack_require__(536),
    getTag = __webpack_require__(307),
    initCloneArray = __webpack_require__(1717),
    initCloneByTag = __webpack_require__(1718),
    initCloneObject = __webpack_require__(830),
    isArray = __webpack_require__(68),
    isBuffer = __webpack_require__(251),
    isMap = __webpack_require__(1722),
    isObject = __webpack_require__(77),
    isSet = __webpack_require__(1724),
    keys = __webpack_require__(127),
    keysIn = __webpack_require__(255);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(87);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(252)(module)))

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(541);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(310),
    getPrototype = __webpack_require__(391),
    isPrototype = __webpack_require__(330);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1732);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayoutStore = function (_BaseStore) {
    (0, _inherits3.default)(LayoutStore, _BaseStore);

    function LayoutStore() {
        (0, _classCallCheck3.default)(this, LayoutStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    LayoutStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.IN_APP_SESSION_STARTED] = this.handleEmbeddedLayout, _ref[_AppConstants.ActionTypes.SEARCH_WIDGET_LOADED] = this.handleEmbeddedLayout, _ref[_AppConstants.ActionTypes.LAYOUT_SET_EMBEDDED] = this.handleSetEmbedded, _ref;
    };

    LayoutStore.prototype.isEmbeddedLayout = function isEmbeddedLayout() {
        return Boolean(this.state.get('isEmbedded'));
    };

    LayoutStore.prototype.handleEmbeddedLayout = function handleEmbeddedLayout() {
        this.setState(this.state.set('isEmbedded', true));
    };

    LayoutStore.prototype.handleSetEmbedded = function handleSetEmbedded(_ref2) {
        var isEmbedded = _ref2.isEmbedded;

        this.setState(this.state.set('isEmbedded', isEmbedded));
    };

    return LayoutStore;
}(_BaseStore3.default);

var storeInstance = new LayoutStore({ storageKey: 'layout' });

exports.default = storeInstance;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalStore = function (_BaseStore) {
    (0, _inherits3.default)(ModalStore, _BaseStore);

    function ModalStore() {
        (0, _classCallCheck3.default)(this, ModalStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    ModalStore.prototype.getActive = function getActive() {
        return this.state.get('active');
    };

    ModalStore.prototype.getData = function getData() {
        return this.state.get('data');
    };

    ModalStore.prototype.close = function close(_ref) {
        var type = _ref.type;

        if (!type || type === this.getActive()) {
            this.setState(this.state.delete('active'));
        }
    };

    ModalStore.prototype.open = function open(_ref2) {
        var type = _ref2.type,
            data = _ref2.data;

        this.setState(this.state.set('active', type).set('data', data));
    };

    ModalStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.MODAL_OPENED] = this.open, _ref3[_AppConstants.ActionTypes.MODAL_CLOSED] = this.close, _ref3;
    };

    return ModalStore;
}(_BaseStore3.default);

var storeInstance = new ModalStore();

exports.default = storeInstance;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NotFoundError = exports.UnauthorisedError = exports.BadRequestError = exports.ServerError = exports.RequestError = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _pickBy2 = __webpack_require__(161);

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _API = __webpack_require__(201);

Object.defineProperty(exports, 'RequestError', {
    enumerable: true,
    get: function get() {
        return _API.RequestError;
    }
});
Object.defineProperty(exports, 'ServerError', {
    enumerable: true,
    get: function get() {
        return _API.ServerError;
    }
});
Object.defineProperty(exports, 'BadRequestError', {
    enumerable: true,
    get: function get() {
        return _API.BadRequestError;
    }
});
Object.defineProperty(exports, 'UnauthorisedError', {
    enumerable: true,
    get: function get() {
        return _API.UnauthorisedError;
    }
});
Object.defineProperty(exports, 'NotFoundError', {
    enumerable: true,
    get: function get() {
        return _API.NotFoundError;
    }
});

var _APIClient2 = __webpack_require__(52);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _TokenStore = __webpack_require__(281);

var _TokenStore2 = _interopRequireDefault(_TokenStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IblocksAPIClient = function (_APIClient) {
    (0, _inherits3.default)(IblocksAPIClient, _APIClient);

    function IblocksAPIClient() {
        (0, _classCallCheck3.default)(this, IblocksAPIClient);
        return (0, _possibleConstructorReturn3.default)(this, _APIClient.apply(this, arguments));
    }

    IblocksAPIClient.prototype.getHeaders = function getHeaders() {
        return (0, _assign2.default)({}, _APIClient.prototype.getHeaders.call(this), (0, _pickBy3.default)({
            'x-customer-token': _TokenStore2.default.getCustomer(),
            'x-customer-device': _TokenStore2.default.getDevice(),
            'user-id': '' + _UserStore2.default.getCurrent().id,
            'user-role': 'CUSTOMER'
        }, _isString3.default));
    };

    return IblocksAPIClient;
}(_APIClient2.APIClient);

exports.default = new IblocksAPIClient();

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isUndefined2 = __webpack_require__(278);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _negate2 = __webpack_require__(673);

var _negate3 = _interopRequireDefault(_negate2);

var _pickBy2 = __webpack_require__(161);

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _immutable = __webpack_require__(5);

var _APIClient = __webpack_require__(52);

var _LinkMapper = __webpack_require__(8);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _CustomerOrdersList = __webpack_require__(1737);

var _CustomerOrdersList2 = _interopRequireDefault(_CustomerOrdersList);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _StoredRefundCalculations = __webpack_require__(655);

var _StoredRefundCalculations2 = _interopRequireDefault(_StoredRefundCalculations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderHistoryService = {
    search: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                limit = _ref2.limit,
                page = _ref2.page,
                refundable = _ref2.refundable;

            var userId, params, response, pagination, result, data;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            userId = user.id;
                            params = (0, _pickBy3.default)({ limit: limit, page: page, refundable: refundable }, (0, _negate3.default)(_isUndefined3.default));
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get('/customers/' + userId + '/orders', params);

                        case 4:
                            response = _context.sent;
                            pagination = response.pagination, result = response.result;
                            data = {
                                pagination: pagination,
                                orders: result
                            };
                            return _context.abrupt('return', (0, _LinkMapper.resolve)(data).as(_CustomerOrdersList2.default));

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function search(_x2) {
            return _ref.apply(this, arguments);
        }

        return search;
    }(),
    fetch: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(orderId) {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _AuthenticatedAPIClient2.default.get('/orders/' + orderId);

                        case 2:
                            response = _context2.sent;
                            return _context2.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Order2.default));

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function fetch(_x3) {
            return _ref3.apply(this, arguments);
        }

        return fetch;
    }(),
    fetchRefundCalculations: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(orderId) {
            var response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _AuthenticatedAPIClient2.default.get('/orders/' + orderId + '/refund/calculations');

                        case 2:
                            response = _context3.sent;
                            return _context3.abrupt('return', (0, _LinkMapper.resolve)(response).as(_StoredRefundCalculations2.default));

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function fetchRefundCalculations(_x4) {
            return _ref4.apply(this, arguments);
        }

        return fetchRefundCalculations;
    }(),
    getOrderHistory: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(orderId) {
            var response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return _AuthenticatedAPIClient2.default.get('/orders/' + orderId + '/filter-refunded-tickets');

                        case 3:
                            response = _context4.sent;
                            return _context4.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Order2.default));

                        case 7:
                            _context4.prev = 7;
                            _context4.t0 = _context4['catch'](0);

                            if (_context4.t0 instanceof _APIClient.NotFoundError) {
                                _context4.next = 11;
                                break;
                            }

                            throw _context4.t0;

                        case 11:
                            return _context4.abrupt('return', new _immutable.Record());

                        case 12:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 7]]);
        }));

        function getOrderHistory(_x5) {
            return _ref5.apply(this, arguments);
        }

        return getOrderHistory;
    }()
};

exports.default = OrderHistoryService;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Calculation = __webpack_require__(1078);

var _Calculation2 = _interopRequireDefault(_Calculation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    refundId: [_LinkMapper.fields.number],
    initiatedBy: [_LinkMapper.fields.string],
    caseReference: [_LinkMapper.fields.string],
    reasonCode: [_LinkMapper.fields.number],
    otherReason: [_LinkMapper.fields.string],
    adminFee: [_LinkMapper.fields.number],
    created: [_LinkMapper.resolve.with(_TrainTime2.default)],
    refundVia: [_LinkMapper.fields.string],
    calculation: [_LinkMapper.resolve.as(_Calculation2.default)]
};

var TicketRefundCalculation = function (_record) {
    (0, _inherits3.default)(TicketRefundCalculation, _record);

    function TicketRefundCalculation() {
        (0, _classCallCheck3.default)(this, TicketRefundCalculation);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TicketRefundCalculation.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(TicketRefundCalculation, json, (0, _Records.getResolvers)(fieldSchema));
    };

    TicketRefundCalculation.prototype.getRefundDate = function getRefundDate() {
        return this.created.format('DD MMMM YYYY');
    };

    return TicketRefundCalculation;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = TicketRefundCalculation;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _immutable = __webpack_require__(5);

var _APIClient = __webpack_require__(52);

var _LinkMapper = __webpack_require__(8);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _Photocard = __webpack_require__(279);

var _Photocard2 = _interopRequireDefault(_Photocard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handlePhotocardResponse = function handlePhotocardResponse(photocard) {
    return {
        id: photocard.id,
        title: (0, _get3.default)(photocard, 'cardHolder.title'),
        firstName: (0, _get3.default)(photocard, 'cardHolder.firstName'),
        lastName: (0, _get3.default)(photocard, 'cardHolder.lastName'),
        isOver16: (0, _get3.default)(photocard, 'cardHolder.isOver16'),
        yearOfBirth: (0, _get3.default)(photocard, 'cardHolder.dob') && photocard.cardHolder.dob.split('-')[0],
        monthOfBirth: (0, _get3.default)(photocard, 'cardHolder.dob') && photocard.cardHolder.dob.split('-')[1],
        dayOfBirth: (0, _get3.default)(photocard, 'cardHolder.dob') && photocard.cardHolder.dob.split('-')[2],
        addressLine1: (0, _get3.default)(photocard, 'cardHolder.address.line1'),
        addressLine2: (0, _get3.default)(photocard, 'cardHolder.address.line2'),
        addressLine3: (0, _get3.default)(photocard, 'cardHolder.address.line3'),
        townCity: (0, _get3.default)(photocard, 'cardHolder.address.town'),
        country: (0, _get3.default)(photocard, 'cardHolder.address.country'),
        postcode: (0, _get3.default)(photocard, 'cardHolder.address.postCode'),
        number: photocard.number,
        nickname: photocard.nickname
    };
};

var PhotocardService = {
    getBaseUrl: function getBaseUrl(user) {
        return '/customers/' + user.id;
    },
    getAll: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var endpoint, response, photocards;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            endpoint = this.getBaseUrl(user) + '/photocards/all';
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context.sent;
                            photocards = response.result.map(function (photocard) {
                                return handlePhotocardResponse(photocard);
                            });
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(photocards).as(_Photocard2.default));

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0 instanceof _APIClient.NotFoundError) {
                                _context.next = 13;
                                break;
                            }

                            throw _context.t0;

                        case 13:
                            return _context.abrupt('return', new _immutable.List());

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 9]]);
        }));

        function getAll(_x) {
            return _ref.apply(this, arguments);
        }

        return getAll;
    }(),
    getByNumber: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user, number) {
            var endpoint, response, photocard;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            endpoint = this.getBaseUrl(user) + '/photocard/number/' + number;
                            _context2.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context2.sent;
                            photocard = handlePhotocardResponse(response.result);
                            return _context2.abrupt('return', (0, _LinkMapper.resolve)(photocard).as(_Photocard2.default));

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](0);

                            if (_context2.t0 instanceof _APIClient.NotFoundError) {
                                _context2.next = 13;
                                break;
                            }

                            throw _context2.t0;

                        case 13:
                            return _context2.abrupt('return', null);

                        case 14:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 9]]);
        }));

        function getByNumber(_x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return getByNumber;
    }(),
    updateSTicketCard: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user, photocard) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            endpoint = this.getBaseUrl(user) + '/photocard/number/sticket/' + photocard.number;
                            return _context3.abrupt('return', _AuthenticatedAPIClient2.default.patch(endpoint, photocard));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function updateSTicketCard(_x4, _x5) {
            return _ref3.apply(this, arguments);
        }

        return updateSTicketCard;
    }(),
    create: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(user, photocard) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            endpoint = this.getBaseUrl(user) + '/photocard';
                            _context4.next = 3;
                            return _AuthenticatedAPIClient2.default.post(endpoint, photocard.toJS());

                        case 3:
                            response = _context4.sent;
                            return _context4.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Photocard2.default));

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function create(_x6, _x7) {
            return _ref4.apply(this, arguments);
        }

        return create;
    }(),
    delete: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(user, photocard) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            endpoint = this.getBaseUrl(user) + '/photocard/' + photocard.id;
                            _context5.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(endpoint);

                        case 3:
                            return _context5.abrupt('return', true);

                        case 4:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function _delete(_x8, _x9) {
            return _ref5.apply(this, arguments);
        }

        return _delete;
    }()
};

exports.default = PhotocardService;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Scaling
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var originalTransform = loadImage.transform

  loadImage.createCanvas = function (width, height, offscreen) {
    if (offscreen && loadImage.global.OffscreenCanvas) {
      return new OffscreenCanvas(width, height)
    }
    var canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    return canvas
  }

  loadImage.transform = function (img, options, callback, file, data) {
    originalTransform.call(
      loadImage,
      loadImage.scale(img, options, data),
      options,
      callback,
      file,
      data
    )
  }

  // Transform image coordinates, allows to override e.g.
  // the canvas orientation based on the orientation option,
  // gets canvas, options and data passed as arguments:
  loadImage.transformCoordinates = function () {}

  // Returns transformed options, allows to override e.g.
  // maxWidth, maxHeight and crop options based on the aspectRatio.
  // gets img, options, data passed as arguments:
  loadImage.getTransformedOptions = function (img, options) {
    var aspectRatio = options.aspectRatio
    var newOptions
    var i
    var width
    var height
    if (!aspectRatio) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.crop = true
    width = img.naturalWidth || img.width
    height = img.naturalHeight || img.height
    if (width / height > aspectRatio) {
      newOptions.maxWidth = height * aspectRatio
      newOptions.maxHeight = height
    } else {
      newOptions.maxWidth = width
      newOptions.maxHeight = width / aspectRatio
    }
    return newOptions
  }

  // Canvas render method, allows to implement a different rendering algorithm:
  loadImage.drawImage = function (
    img,
    canvas,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    destWidth,
    destHeight,
    options
  ) {
    var ctx = canvas.getContext('2d')
    if (options.imageSmoothingEnabled === false) {
      ctx.msImageSmoothingEnabled = false
      ctx.imageSmoothingEnabled = false
    } else if (options.imageSmoothingQuality) {
      ctx.imageSmoothingQuality = options.imageSmoothingQuality
    }
    ctx.drawImage(
      img,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      0,
      0,
      destWidth,
      destHeight
    )
    return ctx
  }

  // Determines if the target image should be a canvas element:
  loadImage.requiresCanvas = function (options) {
    return options.canvas || options.crop || !!options.aspectRatio
  }

  // Scales and/or crops the given image (img or canvas HTML element)
  // using the given options:
  loadImage.scale = function (img, options, data) {
    // eslint-disable-next-line no-param-reassign
    options = options || {}
    // eslint-disable-next-line no-param-reassign
    data = data || {}
    var useCanvas =
      img.getContext ||
      (loadImage.requiresCanvas(options) &&
        !!loadImage.global.HTMLCanvasElement)
    var width = img.naturalWidth || img.width
    var height = img.naturalHeight || img.height
    var destWidth = width
    var destHeight = height
    var maxWidth
    var maxHeight
    var minWidth
    var minHeight
    var sourceWidth
    var sourceHeight
    var sourceX
    var sourceY
    var pixelRatio
    var downsamplingRatio
    var tmp
    var canvas
    /**
     * Scales up image dimensions
     */
    function scaleUp() {
      var scale = Math.max(
        (minWidth || destWidth) / destWidth,
        (minHeight || destHeight) / destHeight
      )
      if (scale > 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    /**
     * Scales down image dimensions
     */
    function scaleDown() {
      var scale = Math.min(
        (maxWidth || destWidth) / destWidth,
        (maxHeight || destHeight) / destHeight
      )
      if (scale < 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    if (useCanvas) {
      // eslint-disable-next-line no-param-reassign
      options = loadImage.getTransformedOptions(img, options, data)
      sourceX = options.left || 0
      sourceY = options.top || 0
      if (options.sourceWidth) {
        sourceWidth = options.sourceWidth
        if (options.right !== undefined && options.left === undefined) {
          sourceX = width - sourceWidth - options.right
        }
      } else {
        sourceWidth = width - sourceX - (options.right || 0)
      }
      if (options.sourceHeight) {
        sourceHeight = options.sourceHeight
        if (options.bottom !== undefined && options.top === undefined) {
          sourceY = height - sourceHeight - options.bottom
        }
      } else {
        sourceHeight = height - sourceY - (options.bottom || 0)
      }
      destWidth = sourceWidth
      destHeight = sourceHeight
    }
    maxWidth = options.maxWidth
    maxHeight = options.maxHeight
    minWidth = options.minWidth
    minHeight = options.minHeight
    if (useCanvas && maxWidth && maxHeight && options.crop) {
      destWidth = maxWidth
      destHeight = maxHeight
      tmp = sourceWidth / sourceHeight - maxWidth / maxHeight
      if (tmp < 0) {
        sourceHeight = (maxHeight * sourceWidth) / maxWidth
        if (options.top === undefined && options.bottom === undefined) {
          sourceY = (height - sourceHeight) / 2
        }
      } else if (tmp > 0) {
        sourceWidth = (maxWidth * sourceHeight) / maxHeight
        if (options.left === undefined && options.right === undefined) {
          sourceX = (width - sourceWidth) / 2
        }
      }
    } else {
      if (options.contain || options.cover) {
        minWidth = maxWidth = maxWidth || minWidth
        minHeight = maxHeight = maxHeight || minHeight
      }
      if (options.cover) {
        scaleDown()
        scaleUp()
      } else {
        scaleUp()
        scaleDown()
      }
    }
    if (useCanvas) {
      pixelRatio = options.pixelRatio
      if (
        pixelRatio > 1 &&
        // Check if the image has not yet had the device pixel ratio applied:
        !(
          img.style.width &&
          Math.floor(parseFloat(img.style.width, 10)) ===
            Math.floor(width / pixelRatio)
        )
      ) {
        destWidth *= pixelRatio
        destHeight *= pixelRatio
      }
      // Check if workaround for Chromium orientation crop bug is required:
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1074354
      if (
        loadImage.orientationCropBug &&
        !img.getContext &&
        (sourceX || sourceY || sourceWidth !== width || sourceHeight !== height)
      ) {
        // Write the complete source image to an intermediate canvas first:
        tmp = img
        // eslint-disable-next-line no-param-reassign
        img = loadImage.createCanvas(width, height, true)
        loadImage.drawImage(
          tmp,
          img,
          0,
          0,
          width,
          height,
          width,
          height,
          options
        )
      }
      downsamplingRatio = options.downsamplingRatio
      if (
        downsamplingRatio > 0 &&
        downsamplingRatio < 1 &&
        destWidth < sourceWidth &&
        destHeight < sourceHeight
      ) {
        while (sourceWidth * downsamplingRatio > destWidth) {
          canvas = loadImage.createCanvas(
            sourceWidth * downsamplingRatio,
            sourceHeight * downsamplingRatio,
            true
          )
          loadImage.drawImage(
            img,
            canvas,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            canvas.width,
            canvas.height,
            options
          )
          sourceX = 0
          sourceY = 0
          sourceWidth = canvas.width
          sourceHeight = canvas.height
          // eslint-disable-next-line no-param-reassign
          img = canvas
        }
      }
      canvas = loadImage.createCanvas(destWidth, destHeight)
      loadImage.transformCoordinates(canvas, options, data)
      if (pixelRatio > 1) {
        canvas.style.width = canvas.width / pixelRatio + 'px'
      }
      loadImage
        .drawImage(
          img,
          canvas,
          sourceX,
          sourceY,
          sourceWidth,
          sourceHeight,
          destWidth,
          destHeight,
          options
        )
        .setTransform(1, 0, 0, 1, 0, 0) // reset to the identity matrix
      return canvas
    }
    img.width = destWidth
    img.height = destHeight
    return img
  }
})


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, DataView */

/* eslint-disable no-console */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166), __webpack_require__(396)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  /**
   * Exif tag map
   *
   * @name ExifMap
   * @class
   * @param {number|string} tagCode IFD tag code
   */
  function ExifMap(tagCode) {
    if (tagCode) {
      Object.defineProperty(this, 'map', {
        value: this.ifds[tagCode].map
      })
      Object.defineProperty(this, 'tags', {
        value: (this.tags && this.tags[tagCode]) || {}
      })
    }
  }

  ExifMap.prototype.map = {
    Orientation: 0x0112,
    Thumbnail: 'ifd1',
    Blob: 0x0201, // Alias for JPEGInterchangeFormat
    Exif: 0x8769,
    GPSInfo: 0x8825,
    Interoperability: 0xa005
  }

  ExifMap.prototype.ifds = {
    ifd1: { name: 'Thumbnail', map: ExifMap.prototype.map },
    0x8769: { name: 'Exif', map: {} },
    0x8825: { name: 'GPSInfo', map: {} },
    0xa005: { name: 'Interoperability', map: {} }
  }

  /**
   * Retrieves exif tag value
   *
   * @param {number|string} id Exif tag code or name
   * @returns {object} Exif tag value
   */
  ExifMap.prototype.get = function (id) {
    return this[id] || this[this.map[id]]
  }

  /**
   * Returns the Exif Thumbnail data as Blob.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Thumbnail data offset
   * @param {number} length Thumbnail data length
   * @returns {undefined|Blob} Returns the Thumbnail Blob or undefined
   */
  function getExifThumbnail(dataView, offset, length) {
    if (!length) return
    if (offset + length > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid thumbnail data.')
      return
    }
    return new Blob(
      [loadImage.bufferSlice.call(dataView.buffer, offset, offset + length)],
      {
        type: 'image/jpeg'
      }
    )
  }

  var ExifTagTypes = {
    // byte, 8-bit unsigned int:
    1: {
      getValue: function (dataView, dataOffset) {
        return dataView.getUint8(dataOffset)
      },
      size: 1
    },
    // ascii, 8-bit byte:
    2: {
      getValue: function (dataView, dataOffset) {
        return String.fromCharCode(dataView.getUint8(dataOffset))
      },
      size: 1,
      ascii: true
    },
    // short, 16 bit int:
    3: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint16(dataOffset, littleEndian)
      },
      size: 2
    },
    // long, 32 bit int:
    4: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint32(dataOffset, littleEndian)
      },
      size: 4
    },
    // rational = two long values, first is numerator, second is denominator:
    5: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return (
          dataView.getUint32(dataOffset, littleEndian) /
          dataView.getUint32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    },
    // slong, 32 bit signed int:
    9: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getInt32(dataOffset, littleEndian)
      },
      size: 4
    },
    // srational, two slongs, first is numerator, second is denominator:
    10: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return (
          dataView.getInt32(dataOffset, littleEndian) /
          dataView.getInt32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    }
  }
  // undefined, 8-bit byte, value depending on field:
  ExifTagTypes[7] = ExifTagTypes[1]

  /**
   * Returns Exif tag value.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {number} offset Tag offset
   * @param {number} type Tag type
   * @param {number} length Tag length
   * @param {boolean} littleEndian Little endian encoding
   * @returns {object} Tag value
   */
  function getExifValue(
    dataView,
    tiffOffset,
    offset,
    type,
    length,
    littleEndian
  ) {
    var tagType = ExifTagTypes[type]
    var tagSize
    var dataOffset
    var values
    var i
    var str
    var c
    if (!tagType) {
      console.log('Invalid Exif data: Invalid tag type.')
      return
    }
    tagSize = tagType.size * length
    // Determine if the value is contained in the dataOffset bytes,
    // or if the value at the dataOffset is a pointer to the actual data:
    dataOffset =
      tagSize > 4
        ? tiffOffset + dataView.getUint32(offset + 8, littleEndian)
        : offset + 8
    if (dataOffset + tagSize > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid data offset.')
      return
    }
    if (length === 1) {
      return tagType.getValue(dataView, dataOffset, littleEndian)
    }
    values = []
    for (i = 0; i < length; i += 1) {
      values[i] = tagType.getValue(
        dataView,
        dataOffset + i * tagType.size,
        littleEndian
      )
    }
    if (tagType.ascii) {
      str = ''
      // Concatenate the chars:
      for (i = 0; i < values.length; i += 1) {
        c = values[i]
        // Ignore the terminating NULL byte(s):
        if (c === '\u0000') {
          break
        }
        str += c
      }
      return str
    }
    return values
  }

  /**
   * Determines if the given tag should be included.
   *
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   * @param {number|string} tagCode Tag code to check
   * @returns {boolean} True if the tag should be included
   */
  function shouldIncludeTag(includeTags, excludeTags, tagCode) {
    return (
      (!includeTags || includeTags[tagCode]) &&
      (!excludeTags || excludeTags[tagCode] !== true)
    )
  }

  /**
   * Parses Exif tags.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {number} dirOffset Directory offset
   * @param {boolean} littleEndian Little endian encoding
   * @param {ExifMap} tags Map to store parsed exif tags
   * @param {ExifMap} tagOffsets Map to store parsed exif tag offsets
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   * @returns {number} Next directory offset
   */
  function parseExifTags(
    dataView,
    tiffOffset,
    dirOffset,
    littleEndian,
    tags,
    tagOffsets,
    includeTags,
    excludeTags
  ) {
    var tagsNumber, dirEndOffset, i, tagOffset, tagNumber, tagValue
    if (dirOffset + 6 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory offset.')
      return
    }
    tagsNumber = dataView.getUint16(dirOffset, littleEndian)
    dirEndOffset = dirOffset + 2 + 12 * tagsNumber
    if (dirEndOffset + 4 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory size.')
      return
    }
    for (i = 0; i < tagsNumber; i += 1) {
      tagOffset = dirOffset + 2 + 12 * i
      tagNumber = dataView.getUint16(tagOffset, littleEndian)
      if (!shouldIncludeTag(includeTags, excludeTags, tagNumber)) continue
      tagValue = getExifValue(
        dataView,
        tiffOffset,
        tagOffset,
        dataView.getUint16(tagOffset + 2, littleEndian), // tag type
        dataView.getUint32(tagOffset + 4, littleEndian), // tag length
        littleEndian
      )
      tags[tagNumber] = tagValue
      if (tagOffsets) {
        tagOffsets[tagNumber] = tagOffset
      }
    }
    // Return the offset to the next directory:
    return dataView.getUint32(dirEndOffset, littleEndian)
  }

  /**
   * Parses tags in a given IFD (Image File Directory).
   *
   * @param {object} data Data object to store exif tags and offsets
   * @param {number|string} tagCode IFD tag code
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {boolean} littleEndian Little endian encoding
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   */
  function parseExifIFD(
    data,
    tagCode,
    dataView,
    tiffOffset,
    littleEndian,
    includeTags,
    excludeTags
  ) {
    var dirOffset = data.exif[tagCode]
    if (dirOffset) {
      data.exif[tagCode] = new ExifMap(tagCode)
      if (data.exifOffsets) {
        data.exifOffsets[tagCode] = new ExifMap(tagCode)
      }
      parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + dirOffset,
        littleEndian,
        data.exif[tagCode],
        data.exifOffsets && data.exifOffsets[tagCode],
        includeTags && includeTags[tagCode],
        excludeTags && excludeTags[tagCode]
      )
    }
  }

  loadImage.parseExifData = function (dataView, offset, length, data, options) {
    if (options.disableExif) {
      return
    }
    var includeTags = options.includeExifTags
    var excludeTags = options.excludeExifTags || {
      0x8769: {
        // ExifIFDPointer
        0x927c: true // MakerNote
      }
    }
    var tiffOffset = offset + 10
    var littleEndian
    var dirOffset
    var thumbnailIFD
    // Check for the ASCII code for "Exif" (0x45786966):
    if (dataView.getUint32(offset + 4) !== 0x45786966) {
      // No Exif data, might be XMP data instead
      return
    }
    if (tiffOffset + 8 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid segment size.')
      return
    }
    // Check for the two null bytes:
    if (dataView.getUint16(offset + 8) !== 0x0000) {
      console.log('Invalid Exif data: Missing byte alignment offset.')
      return
    }
    // Check the byte alignment:
    switch (dataView.getUint16(tiffOffset)) {
      case 0x4949:
        littleEndian = true
        break
      case 0x4d4d:
        littleEndian = false
        break
      default:
        console.log('Invalid Exif data: Invalid byte alignment marker.')
        return
    }
    // Check for the TIFF tag marker (0x002A):
    if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002a) {
      console.log('Invalid Exif data: Missing TIFF marker.')
      return
    }
    // Retrieve the directory offset bytes, usually 0x00000008 or 8 decimal:
    dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian)
    // Create the exif object to store the tags:
    data.exif = new ExifMap()
    if (!options.disableExifOffsets) {
      data.exifOffsets = new ExifMap()
      data.exifTiffOffset = tiffOffset
      data.exifLittleEndian = littleEndian
    }
    // Parse the tags of the main image directory (IFD0) and retrieve the
    // offset to the next directory (IFD1), usually the thumbnail directory:
    dirOffset = parseExifTags(
      dataView,
      tiffOffset,
      tiffOffset + dirOffset,
      littleEndian,
      data.exif,
      data.exifOffsets,
      includeTags,
      excludeTags
    )
    if (dirOffset && shouldIncludeTag(includeTags, excludeTags, 'ifd1')) {
      data.exif.ifd1 = dirOffset
      if (data.exifOffsets) {
        data.exifOffsets.ifd1 = tiffOffset + dirOffset
      }
    }
    Object.keys(data.exif.ifds).forEach(function (tagCode) {
      parseExifIFD(
        data,
        tagCode,
        dataView,
        tiffOffset,
        littleEndian,
        includeTags,
        excludeTags
      )
    })
    thumbnailIFD = data.exif.ifd1
    // Check for JPEG Thumbnail offset and data length:
    if (thumbnailIFD && thumbnailIFD[0x0201]) {
      thumbnailIFD[0x0201] = getExifThumbnail(
        dataView,
        tiffOffset + thumbnailIFD[0x0201],
        thumbnailIFD[0x0202] // Thumbnail data length
      )
    }
  }

  // Registers the Exif parser for the APP1 JPEG metadata segment:
  loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData)

  loadImage.exifWriters = {
    // Orientation writer:
    0x0112: function (buffer, data, value) {
      var orientationOffset = data.exifOffsets[0x0112]
      if (!orientationOffset) return buffer
      var view = new DataView(buffer, orientationOffset + 8, 2)
      view.setUint16(0, value, data.exifLittleEndian)
      return buffer
    }
  }

  loadImage.writeExifData = function (buffer, data, id, value) {
    return loadImage.exifWriters[data.exif.map[id]](buffer, data, value)
  }

  loadImage.ExifMap = ExifMap

  // Adds the following properties to the parseMetaData callback data:
  // - exif: The parsed Exif tags
  // - exifOffsets: The parsed Exif tag offsets
  // - exifTiffOffset: TIFF header offset (used for offset pointers)
  // - exifLittleEndian: little endian order if true, big endian if false

  // Adds the following options to the parseMetaData method:
  // - disableExif: Disables Exif parsing when true.
  // - disableExifOffsets: Disables storing Exif tag offsets when true.
  // - includeExifTags: A map of Exif tags to include for parsing.
  // - excludeExifTags: A map of Exif tags to exclude from parsing.
})


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, DataView */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166), __webpack_require__(396)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  /**
   * IPTC tag map
   *
   * @name IptcMap
   * @class
   */
  function IptcMap() {}

  IptcMap.prototype.map = {
    ObjectName: 5
  }

  IptcMap.prototype.types = {
    0: 'Uint16', // ApplicationRecordVersion
    200: 'Uint16', // ObjectPreviewFileFormat
    201: 'Uint16', // ObjectPreviewFileVersion
    202: 'binary' // ObjectPreviewData
  }

  /**
   * Retrieves IPTC tag value
   *
   * @param {number|string} id IPTC tag code or name
   * @returns {object} IPTC tag value
   */
  IptcMap.prototype.get = function (id) {
    return this[id] || this[this.map[id]]
  }

  /**
   * Retrieves string for the given DataView and range
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Offset start
   * @param {number} length Offset length
   * @returns {string} String value
   */
  function getStringValue(dataView, offset, length) {
    var outstr = ''
    var end = offset + length
    for (var n = offset; n < end; n += 1) {
      outstr += String.fromCharCode(dataView.getUint8(n))
    }
    return outstr
  }

  /**
   * Retrieves tag value for the given DataView and range
   *
   * @param {number} tagCode tag code
   * @param {IptcMap} map IPTC tag map
   * @param {DataView} dataView Data view interface
   * @param {number} offset Range start
   * @param {number} length Range length
   * @returns {object} Tag value
   */
  function getTagValue(tagCode, map, dataView, offset, length) {
    if (map.types[tagCode] === 'binary') {
      return new Blob([dataView.buffer.slice(offset, offset + length)])
    }
    if (map.types[tagCode] === 'Uint16') {
      return dataView.getUint16(offset)
    }
    return getStringValue(dataView, offset, length)
  }

  /**
   * Combines IPTC value with existing ones.
   *
   * @param {object} value Existing IPTC field value
   * @param {object} newValue New IPTC field value
   * @returns {object} Resulting IPTC field value
   */
  function combineTagValues(value, newValue) {
    if (value === undefined) return newValue
    if (value instanceof Array) {
      value.push(newValue)
      return value
    }
    return [value, newValue]
  }

  /**
   * Parses IPTC tags.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} segmentOffset Segment offset
   * @param {number} segmentLength Segment length
   * @param {object} data Data export object
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   */
  function parseIptcTags(
    dataView,
    segmentOffset,
    segmentLength,
    data,
    includeTags,
    excludeTags
  ) {
    var value, tagSize, tagCode
    var segmentEnd = segmentOffset + segmentLength
    var offset = segmentOffset
    while (offset < segmentEnd) {
      if (
        dataView.getUint8(offset) === 0x1c && // tag marker
        dataView.getUint8(offset + 1) === 0x02 // record number, only handles v2
      ) {
        tagCode = dataView.getUint8(offset + 2)
        if (
          (!includeTags || includeTags[tagCode]) &&
          (!excludeTags || !excludeTags[tagCode])
        ) {
          tagSize = dataView.getInt16(offset + 3)
          value = getTagValue(tagCode, data.iptc, dataView, offset + 5, tagSize)
          data.iptc[tagCode] = combineTagValues(data.iptc[tagCode], value)
          if (data.iptcOffsets) {
            data.iptcOffsets[tagCode] = offset
          }
        }
      }
      offset += 1
    }
  }

  /**
   * Tests if field segment starts at offset.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Segment offset
   * @returns {boolean} True if '8BIM<EOT><EOT>' exists at offset
   */
  function isSegmentStart(dataView, offset) {
    return (
      dataView.getUint32(offset) === 0x3842494d && // Photoshop segment start
      dataView.getUint16(offset + 4) === 0x0404 // IPTC segment start
    )
  }

  /**
   * Returns header length.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Segment offset
   * @returns {number} Header length
   */
  function getHeaderLength(dataView, offset) {
    var length = dataView.getUint8(offset + 7)
    if (length % 2 !== 0) length += 1
    // Check for pre photoshop 6 format
    if (length === 0) {
      // Always 4
      length = 4
    }
    return length
  }

  loadImage.parseIptcData = function (dataView, offset, length, data, options) {
    if (options.disableIptc) {
      return
    }
    var markerLength = offset + length
    while (offset + 8 < markerLength) {
      if (isSegmentStart(dataView, offset)) {
        var headerLength = getHeaderLength(dataView, offset)
        var segmentOffset = offset + 8 + headerLength
        if (segmentOffset > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment offset.')
          break
        }
        var segmentLength = dataView.getUint16(offset + 6 + headerLength)
        if (offset + segmentLength > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment size.')
          break
        }
        // Create the iptc object to store the tags:
        data.iptc = new IptcMap()
        if (!options.disableIptcOffsets) {
          data.iptcOffsets = new IptcMap()
        }
        parseIptcTags(
          dataView,
          segmentOffset,
          segmentLength,
          data,
          options.includeIptcTags,
          options.excludeIptcTags || { 202: true } // ObjectPreviewData
        )
        return
      }
      // eslint-disable-next-line no-param-reassign
      offset += 1
    }
  }

  // Registers this IPTC parser for the APP13 JPEG metadata segment:
  loadImage.metaDataParsers.jpeg[0xffed].push(loadImage.parseIptcData)

  loadImage.IptcMap = IptcMap

  // Adds the following properties to the parseMetaData callback data:
  // - iptc: The iptc tags, parsed by the parseIptcData method

  // Adds the following options to the parseMetaData method:
  // - disableIptc: Disables IPTC parsing when true.
  // - disableIptcOffsets: Disables storing IPTC tag offsets when true.
  // - includeIptcTags: A map of IPTC tags to include for parsing.
  // - excludeIptcTags: A map of IPTC tags to exclude from parsing.
})


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    amount: 0,
    expiry: null,
    caseReference: null,
    customer: null,
    voucherId: null
};

var Voucher = function (_record) {
    (0, _inherits3.default)(Voucher, _record);

    function Voucher() {
        (0, _classCallCheck3.default)(this, Voucher);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Voucher.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Voucher({
            voucherId: (0, _LinkMapper.resolve)(json.id).with(Number),
            customer: (0, _LinkMapper.resolve)(json.customer).with(Number),
            amount: (0, _LinkMapper.resolve)(json.amount).with(Number),
            expiry: (0, _LinkMapper.resolve)(json.expiry).with(_TrainTime2.default),
            caseReference: (0, _LinkMapper.resolve)(json.caseReference).with(String)
        });
    };

    return Voucher;
}((0, _immutable.Record)(defaults));

exports.default = Voucher;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1771);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(189);
var toIObject = __webpack_require__(190);
var arrayIndexOf = __webpack_require__(1773)(false);
var IE_PROTO = __webpack_require__(551)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(88);
var core = __webpack_require__(78);
var fails = __webpack_require__(193);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(154) && !__webpack_require__(193)(function () {
  return Object.defineProperty(__webpack_require__(847)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(139);
var document = __webpack_require__(138).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1775);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1780);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(261);
var gOPS = __webpack_require__(557);
var pIE = __webpack_require__(323);
var toObject = __webpack_require__(260);
var IObject = __webpack_require__(548);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(193)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(558));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(559));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1785));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1787));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(561);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(194);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(168);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(402);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(1788);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(26);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(64);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(853);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(856);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(1802);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(857);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(1803);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(404);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(264);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(1791);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(263);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(560);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(563);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1800);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1794));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(402);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(404);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(264);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1801);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(558);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(559);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(843);
var hiddenKeys = __webpack_require__(553).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 859 */
/***/ (function(module, exports) {



/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1814)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(861)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(399);
var $export = __webpack_require__(88);
var redefine = __webpack_require__(564);
var hide = __webpack_require__(191);
var Iterators = __webpack_require__(325);
var $iterCreate = __webpack_require__(1815);
var setToStringTag = __webpack_require__(407);
var getPrototypeOf = __webpack_require__(1816);
var ITERATOR = __webpack_require__(140)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1817);
var global = __webpack_require__(138);
var hide = __webpack_require__(191);
var Iterators = __webpack_require__(325);
var TO_STRING_TAG = __webpack_require__(140)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(191);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(192);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(325);
var ITERATOR = __webpack_require__(140)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1826);
var ITERATOR = __webpack_require__(140)('iterator');
var Iterators = __webpack_require__(325);
module.exports = __webpack_require__(78).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};

var ModalBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ModalBody, _React$Component);

  function ModalBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return ModalBody;
}(_react.default.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(261);
var toIObject = __webpack_require__(190);
var isEnum = __webpack_require__(323).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: _propTypes.default.string
};

var ModalDialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ModalDialog, _React$Component);

  function ModalDialog() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalDialog.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        dialogClassName = _this$props.dialogClassName,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["dialogClassName", "className", "style", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
    var modalStyle = (0, _extends3.default)({
      display: 'block'
    }, style);
    var dialogClasses = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
      tabIndex: "-1",
      role: "dialog",
      style: modalStyle,
      className: (0, _classnames.default)(className, bsClassName)
    }), _react.default.createElement("div", {
      className: (0, _classnames.default)(dialogClassName, dialogClasses)
    }, _react.default.createElement("div", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'content'),
      role: "document"
    }, children)));
  };

  return ModalDialog;
}(_react.default.Component);

ModalDialog.propTypes = propTypes;

var _default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};

var ModalFooter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ModalFooter, _React$Component);

  function ModalFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return ModalFooter;
}(_react.default.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _CloseButton = _interopRequireDefault(__webpack_require__(571));

// TODO: `aria-label` should be `closeLabel`.
var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: _propTypes.default.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: _propTypes.default.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: _propTypes.default.func
};
var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var contextTypes = {
  $bs_modal: _propTypes.default.shape({
    onHide: _propTypes.default.func
  })
};

var ModalHeader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ModalHeader, _React$Component);

  function ModalHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        closeLabel = _this$props.closeLabel,
        closeButton = _this$props.closeButton,
        onHide = _this$props.onHide,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["closeLabel", "closeButton", "onHide", "className", "children"]);
    var modal = this.context.$bs_modal;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), closeButton && _react.default.createElement(_CloseButton.default, {
      label: closeLabel,
      onClick: (0, _createChainedFunction.default)(modal && modal.onHide, onHide)
    }), children);
  };

  return ModalHeader;
}(_react.default.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ModalTitle, _React$Component);

  function ModalTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return ModalTitle;
}(_react.default.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ModalManagerContext = undefined;

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

exports.ModalManagerProvider = ModalManagerProvider;
exports.default = useModalManager;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalManagerContext = exports.ModalManagerContext = _react2.default.createContext();

ModalManagerProvider.propTypes = {
    children: _propTypes2.default.node.isRequired
};
function ModalManagerProvider(_ref) {
    var children = _ref.children;

    var _React$useState = _react2.default.useState(new _immutable.OrderedMap()),
        modals = _React$useState[0],
        setModals = _React$useState[1];

    // Add reference to `modals` so that `addModal`, and `onPopState` can be immutable


    var modalsRef = _react2.default.useRef();
    modalsRef.current = modals;

    // This will help us keep track of when the last modal is being closed
    var isLastModal = _react2.default.useRef(false);

    // An immutable function that adds a modal to the list along with its cleanup function
    // which is also returned to the caller
    var addModal = _react2.default.useCallback(function (onCloseRefOrFn) {
        var modalId = (0, _uniqueId3.default)('modal');

        // Add the modal along with its cleanup function
        setModals(function (_modals) {
            if (_modals.isEmpty()) {
                // Now: INITIAL STATE
                // ...
                // When opening the 1st modal, we push onto the history
                // so that if the user presses back while there is an open
                // modal, we stay on the current route. We will clean this up later
                // when the last modal is closed.
                window.history.pushState(window.history.state, null);
                // Now: INITIAL STATE + 1
            }
            return _modals.set(modalId, onCloseRefOrFn);
        });

        // A function to remove the modal from state, when
        var removeModal = function removeModal() {
            return setModals(function (_modals) {
                var updated = _modals.remove(modalId);
                // We are removing the last modal, so we should make sure to remove the temporary state
                // that we pushed earlier. So that the user doesn't have to press "BACK" twice after closing
                // the last modal.
                isLastModal.current = updated.isEmpty() && _modals.has(modalId);
                return updated;
            });
        };

        // Return the modal cleanup function
        return removeModal;
    }, []);

    // Add a popstate handler
    _react2.default.useEffect(function () {
        // When the user goes back, stop tracking the modal & manage the history
        var onPopState = function onPopState(event) {
            // The user went "back" in their history
            // Now: INITIAL STATE
            if (!modalsRef.current.isEmpty()) {
                // If we are tracking open modals, then we should close the most recently opened
                // modal, and push onto the history

                var _modalsRef$current$en = modalsRef.current.entrySeq().last(),
                    currentModalId = _modalsRef$current$en[0],
                    onCloseRefOrFn = _modalsRef$current$en[1];
                // console.log(`%c intercepting for ${currentModalId}`, "background-color: yellow; color: black; font-size: 2em;");

                // Remove it from the list


                var updated = modalsRef.current.remove(currentModalId);

                // Go back to INITIAL STATE + 1
                // We do this even if there are no more tracked modals, so that we can have consistent
                // cleanup using `isLastModal` regardless of how the last modal is closed
                window.history.pushState(event.state, null);

                // Call the modals `onClose` handler - hopefully this will close the modal
                var onClose = onCloseRefOrFn && onCloseRefOrFn.current || onCloseRefOrFn;
                if (onClose) {
                    onClose();
                }

                // Stop tracking the modal
                setModals(updated);

                // We keep track of when we just closed the last modal
                isLastModal.current = updated.isEmpty();
            } else if (isLastModal.current) {
                // The last modal was already closed
                isLastModal.current = false;
                window.history.back();
            }
        };

        window.addEventListener('popstate', onPopState, true);
    }, []);

    return _react2.default.createElement(
        ModalManagerContext.Provider,
        { value: addModal },
        children
    );
}

function useModalManager() {
    return _react2.default.useContext(ModalManagerContext);
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ModalCounterContext = undefined;
exports.ModalCounterProvider = ModalCounterProvider;
exports.default = useModalCounter;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalCounterContext = exports.ModalCounterContext = _react2.default.createContext();

ModalCounterProvider.propTypes = {
    children: _propTypes2.default.node.isRequired,
    onChange: _propTypes2.default.func.isRequired
};
function ModalCounterProvider(_ref) {
    var children = _ref.children,
        onChange = _ref.onChange;

    var _React$useState = _react2.default.useState(0),
        count = _React$useState[0],
        setCount = _React$useState[1];

    _react2.default.useEffect(function () {
        onChange(count);
    }, [count, onChange]);

    return _react2.default.createElement(
        ModalCounterContext.Provider,
        { value: setCount },
        children
    );
}

function useModalCounter() {
    return _react2.default.useContext(ModalCounterContext);
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationStore = function (_BaseStore) {
    (0, _inherits3.default)(NotificationStore, _BaseStore);

    function NotificationStore() {
        (0, _classCallCheck3.default)(this, NotificationStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    NotificationStore.prototype.getActive = function getActive() {
        return this.state.get('active');
    };

    NotificationStore.prototype.hide = function hide(_ref) {
        var notification = _ref.notification;

        if (!notification || notification === this.getActive() || Date.now() - this.get('timestamp') > _AppConstants.MAX_NOTIFICATION_TIME) {
            this.setState(this.state.delete('active'));
        }
    };

    NotificationStore.prototype.open = function open(_ref2) {
        var notification = _ref2.notification;

        this.setState(this.state.merge({
            active: notification,
            timestamp: Date.now()
        }));
    };

    NotificationStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.NOTIFICATION_SHOW] = this.open, _ref3[_AppConstants.ActionTypes.NOTIFICATION_HIDE] = this.hide, _ref3;
    };

    return NotificationStore;
}(_BaseStore3.default);

var storeInstance = new NotificationStore();

exports.default = storeInstance;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RecentStationsStore = exports.stationsKeys = exports.stationsMap = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _forEach2 = __webpack_require__(522);

var _forEach3 = _interopRequireDefault(_forEach2);

var _ref, _ref2, _ref3;

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _RecentStations = __webpack_require__(1864);

var _RecentStations2 = _interopRequireDefault(_RecentStations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stationsMap = exports.stationsMap = new _immutable.Map((_ref = {}, _ref[_AppConstants.StationTypes.ORIGIN] = [_AppConstants.RecentStationsTypes.POINT, _AppConstants.StationTypes.ORIGIN], _ref[_AppConstants.StationTypes.DESTINATION] = [_AppConstants.RecentStationsTypes.POINT, _AppConstants.StationTypes.DESTINATION], _ref[_AppConstants.StationTypes.VIAAVOID] = [_AppConstants.RecentStationsTypes.POINT, _AppConstants.StationTypes.VIAAVOID], _ref[_AppConstants.SmartcardStationTypes.ORIGIN] = [_AppConstants.RecentStationsTypes.SMARTCARD, _AppConstants.StationTypes.ORIGIN], _ref[_AppConstants.SmartcardStationTypes.DESTINATION] = [_AppConstants.RecentStationsTypes.SMARTCARD, _AppConstants.StationTypes.DESTINATION], _ref[_AppConstants.SmartcardStationTypes.VIAAVOID] = [_AppConstants.RecentStationsTypes.SMARTCARD, _AppConstants.StationTypes.VIAAVOID], _ref[_AppConstants.SeasonStationTypes.ORIGIN] = [_AppConstants.RecentStationsTypes.SEASON, _AppConstants.StationTypes.ORIGIN], _ref[_AppConstants.SeasonStationTypes.DESTINATION] = [_AppConstants.RecentStationsTypes.SEASON, _AppConstants.StationTypes.DESTINATION], _ref[_AppConstants.SmartcardSeasonStationTypes.ORIGIN] = [_AppConstants.RecentStationsTypes.SMARTCARDSEASON, _AppConstants.StationTypes.ORIGIN], _ref[_AppConstants.SmartcardSeasonStationTypes.DESTINATION] = [_AppConstants.RecentStationsTypes.SMARTCARDSEASON, _AppConstants.StationTypes.DESTINATION], _ref[_AppConstants.DaySaveStationTypes.ORIGIN] = [_AppConstants.RecentStationsTypes.DAYSAVE, _AppConstants.StationTypes.ORIGIN], _ref[_AppConstants.DelayRepayStationTypes.ORIGIN] = [_AppConstants.RecentStationsTypes.DELAY_REPAY, _AppConstants.StationTypes.ORIGIN], _ref[_AppConstants.DelayRepayStationTypes.DESTINATION] = [_AppConstants.RecentStationsTypes.DELAY_REPAY, _AppConstants.StationTypes.DESTINATION], _ref[_AppConstants.DelayRepayStationTypes.VIAAVOID] = [_AppConstants.RecentStationsTypes.DELAY_REPAY, _AppConstants.StationTypes.VIAAVOID], _ref));

var stationsKeys = exports.stationsKeys = new _immutable.Map((_ref2 = {}, _ref2[_AppConstants.RecentStationsTypes.POINT] = _AppConstants.StationTypes, _ref2[_AppConstants.RecentStationsTypes.SEASON] = _AppConstants.SeasonStationTypes, _ref2[_AppConstants.RecentStationsTypes.SMARTCARD] = _AppConstants.SmartcardStationTypes, _ref2[_AppConstants.RecentStationsTypes.SMARTCARDSEASON] = _AppConstants.SmartcardSeasonStationTypes, _ref2[_AppConstants.RecentStationsTypes.DAYSAVE] = _AppConstants.DaySaveStationTypes, _ref2));

var recentStations = new _immutable.Map((_ref3 = {}, _ref3[_AppConstants.RecentStationsTypes.POINT] = _RecentStations2.default, _ref3[_AppConstants.RecentStationsTypes.SEASON] = _RecentStations2.default, _ref3[_AppConstants.RecentStationsTypes.SMARTCARD] = _RecentStations2.default, _ref3[_AppConstants.RecentStationsTypes.SMARTCARDSEASON] = _RecentStations2.default, _ref3[_AppConstants.RecentStationsTypes.DAYSAVE] = _RecentStations2.default, _ref3));

var _getDefaultState = function _getDefaultState() {
    return recentStations.map(function (Type) {
        return new Type();
    });
};

var _prepStations = function _prepStations(key, type, stations, searchStation) {
    var validityKey = stationsKeys.get(key)[type];
    if (!searchStation || searchStation.isEmpty() || !searchStation.getIn(['validity', validityKey])) {
        return stations;
    }

    var output = stations;
    var index = output.findIndex(function (val) {
        return val.equals(searchStation);
    });

    if (index >= 0) {
        output = output.delete(index);
    }
    if (output.count() === 5) {
        output = output.shift();
    }

    return output.push(searchStation);
};

var RecentStationsStore = exports.RecentStationsStore = function (_BaseStore) {
    (0, _inherits3.default)(RecentStationsStore, _BaseStore);

    function RecentStationsStore() {
        (0, _classCallCheck3.default)(this, RecentStationsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    RecentStationsStore.prototype.deserialize = function deserialize(serialized) {
        var state = _getDefaultState();

        if (serialized) {
            (0, _forEach3.default)(serialized, function (value, key) {
                if (state.has(key)) {
                    var RecentStationsClass = recentStations.get(key);
                    state = state.set(key, RecentStationsClass.fromJSON(value));
                }
            });
        }

        return state;
    };

    RecentStationsStore.prototype.get = function get() {
        var stationType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _AppConstants.StationTypes.ORIGIN;

        return this.state.getIn(stationsMap.get(stationType));
    };

    RecentStationsStore.prototype.handleSearchStarted = function handleSearchStarted(_ref4) {
        var search = _ref4.search;

        var state = this.state;
        var searchOrigin = search.origin,
            searchDestination = search.destination,
            searchVia = search.via,
            searchAvoid = search.avoid;

        var searchViaAvoid = searchVia && searchVia.isEmpty() ? searchAvoid : searchVia;

        state = state.reduce(function (acc, _ref5, key) {
            var _ref6;

            var origin = _ref5[_AppConstants.StationTypes.ORIGIN],
                destination = _ref5[_AppConstants.StationTypes.DESTINATION],
                viaAvoid = _ref5[_AppConstants.StationTypes.VIAAVOID];

            return acc.set(key, new _RecentStations2.default((_ref6 = {}, _ref6[_AppConstants.StationTypes.ORIGIN] = _prepStations(key, 'ORIGIN', origin, searchOrigin), _ref6[_AppConstants.StationTypes.DESTINATION] = _prepStations(key, 'DESTINATION', destination, searchDestination), _ref6[_AppConstants.StationTypes.VIAAVOID] = _prepStations(key, 'VIAAVOID', viaAvoid, searchViaAvoid), _ref6)));
        }, state);

        this.setState(state);
    };

    RecentStationsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref7;

        return _ref7 = {}, _ref7[_AppConstants.ActionTypes.SEARCH_STARTED] = this.handleSearchStarted, _ref7[_AppConstants.ActionTypes.SEASON_SEARCH_STARTED] = this.handleSearchStarted, _ref7[_AppConstants.ActionTypes.FARE_ONLY_SEARCH_STARTED] = this.handleSearchStarted, _ref7[_AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED] = this.handleSearchStarted, _ref7[_AppConstants.ActionTypes.DAYSAVE_SEARCH_STARTED] = this.handleSearchStarted, _ref7;
    };

    return RecentStationsStore;
}(_BaseStore3.default);

var instance = new RecentStationsStore({ storageKey: 'recent-stations' });

exports.default = instance;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationStation = new _immutable.Record({
    nlc: null,
    name: null
});

(0, _assign2.default)(ReservationStation.prototype, {
    getStationName: function getStationName() {
        return this.name;
    }
});

ReservationStation.fromJSON = function (json) {
    return (0, _LinkMapper.construct)(ReservationStation, json, {
        nlc: _LinkMapper.fields.string,
        name: _LinkMapper.fields.string
    });
};

exports.default = ReservationStation;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _Trip = __webpack_require__(199);

var _Trip2 = _interopRequireDefault(_Trip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TripsStore = function (_BaseStore) {
    (0, _inherits3.default)(TripsStore, _BaseStore);

    function TripsStore() {
        (0, _classCallCheck3.default)(this, TripsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    TripsStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return _immutable2.default.fromJS(serialized).map(function (trip) {
                return _Trip2.default.fromJSON(trip.toJS());
            });
        }
        return new _immutable.Map();
    };

    TripsStore.prototype.handleOrderTripCreated = function handleOrderTripCreated(_ref) {
        var trip = _ref.trip,
            orderTrip = _ref.orderTrip;

        this.setState(this.state.set(orderTrip.id, trip));
    };

    TripsStore.prototype.handleOrderTripDeleted = function handleOrderTripDeleted(_ref2) {
        var orderTrip = _ref2.orderTrip;

        this.setState(this.state.delete(orderTrip.id));
    };

    TripsStore.prototype.handleOrderCreated = function handleOrderCreated(_ref3) {
        var trip = _ref3.trip,
            order = _ref3.order;

        var orderTrip = order.trips.first();
        this.handleOrderTripCreated({ trip: trip, orderTrip: orderTrip });
    };

    TripsStore.prototype.handleClear = function handleClear() {
        this.setState(new _immutable.Map());
    };

    TripsStore.prototype.isSmartCard = function isSmartCard() {
        return this.state.size && this.state.first().isSmartcard();
    };

    TripsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref4;

        return _ref4 = {}, _ref4[_AppConstants.ActionTypes.ORDER_TRIP_CREATED] = this.handleOrderTripCreated, _ref4[_AppConstants.ActionTypes.ORDER_TRIP_DELETED] = this.handleOrderTripDeleted, _ref4[_AppConstants.ActionTypes.ORDER_CREATED] = this.handleOrderCreated, _ref4[_AppConstants.ActionTypes.ORDER_PLUSBUS_UPDATED] = this.handleOrderTripCreated, _ref4[_AppConstants.ActionTypes.ORDER_PAID] = this.handleClear, _ref4[_AppConstants.ActionTypes.BASKET_CLEARED] = this.handleClear, _ref4[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleClear, _ref4;
    };

    return TripsStore;
}(_BaseStore3.default);

var instance = new TripsStore({ storageKey: 'trips' });

exports.default = instance;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WidgetAuthStore = function (_BaseStore) {
    (0, _inherits3.default)(WidgetAuthStore, _BaseStore);

    function WidgetAuthStore() {
        (0, _classCallCheck3.default)(this, WidgetAuthStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    WidgetAuthStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.WIDGET_AUTH_SESSION_STARTED] = this.handleSessionStarted, _ref;
    };

    WidgetAuthStore.prototype.isWidgetAuth = function isWidgetAuth() {
        return this.state.get('widgetAuth');
    };

    WidgetAuthStore.prototype.handleSessionStarted = function handleSessionStarted() {
        var state = this.state.merge({
            widgetAuth: true
        });
        this.setState(state);
    };

    return WidgetAuthStore;
}(_BaseStore3.default);

var instance = new WidgetAuthStore();

exports.default = instance;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint-disable no-empty */


exports.__esModule = true;
exports.saveState = saveState;
exports.readState = readState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var KeyPrefix = '@@History/';
var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];

var SecurityError = 'SecurityError';

function createKey(key) {
  return KeyPrefix + key;
}

function saveState(key, state) {
  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;

      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;

      return;
    }

    throw error;
  }
}

function readState(key) {
  var json = undefined;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;

      return null;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return null;
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(326);

var _DOMUtils = __webpack_require__(412);

var _createHistory = __webpack_require__(883);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createDOMHistory(options) {
  var history = _createHistory2['default'](_extends({
    getUserConfirmation: _DOMUtils.getUserConfirmation
  }, options, {
    go: _DOMUtils.go
  }));

  function listen(listener) {
    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;

    return history.listen(listener);
  }

  return _extends({}, history, {
    listen: listen
  });
}

exports['default'] = createDOMHistory;
module.exports = exports['default'];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _deepEqual = __webpack_require__(1872);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _PathUtils = __webpack_require__(225);

var _AsyncUtils = __webpack_require__(1884);

var _Actions = __webpack_require__(224);

var _createLocation2 = __webpack_require__(893);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _runTransitionHook = __webpack_require__(577);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _deprecate = __webpack_require__(226);

var _deprecate2 = _interopRequireDefault(_deprecate);

function createRandomKey(length) {
  return Math.random().toString(36).substr(2, length);
}

function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search &&
  //a.action === b.action && // Different action !== location change.
  a.key === b.key && _deepEqual2['default'](a.state, b.state);
}

var DefaultKeyLength = 6;

function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var finishTransition = options.finishTransition;
  var saveState = options.saveState;
  var go = options.go;
  var getUserConfirmation = options.getUserConfirmation;
  var keyLength = options.keyLength;

  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;

  var transitionHooks = [];

  function listenBefore(hook) {
    transitionHooks.push(hook);

    return function () {
      transitionHooks = transitionHooks.filter(function (item) {
        return item !== hook;
      });
    };
  }

  var allKeys = [];
  var changeListeners = [];
  var location = undefined;

  function getCurrent() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) {
      return allKeys.indexOf(pendingLocation.key);
    } else if (location) {
      return allKeys.indexOf(location.key);
    } else {
      return -1;
    }
  }

  function updateLocation(newLocation) {
    var current = getCurrent();

    location = newLocation;

    if (location.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
    } else if (location.action === _Actions.REPLACE) {
      allKeys[current] = location.key;
    }

    changeListeners.forEach(function (listener) {
      listener(location);
    });
  }

  function listen(listener) {
    changeListeners.push(listener);

    if (location) {
      listener(location);
    } else {
      var _location = getCurrentLocation();
      allKeys = [_location.key];
      updateLocation(_location);
    }

    return function () {
      changeListeners = changeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function confirmTransitionTo(location, callback) {
    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
        if (result != null) {
          done(result);
        } else {
          next();
        }
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  }

  var pendingLocation = undefined;

  function transitionTo(nextLocation) {
    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted.

      if (ok) {
        // treat PUSH to current path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = createPath(location);
          var nextPath = createPath(nextLocation);

          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
      } else if (location && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(location.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
      }
    });
  }

  function push(location) {
    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
  }

  function replace(location) {
    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function createKey() {
    return createRandomKey(keyLength);
  }

  function createPath(location) {
    if (location == null || typeof location === 'string') return location;

    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;

    var result = pathname;

    if (search) result += search;

    if (hash) result += hash;

    return result;
  }

  function createHref(location) {
    return createPath(location);
  }

  function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];

    if (typeof action === 'object') {
       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

      if (typeof location === 'string') location = _PathUtils.parsePath(location);

      location = _extends({}, location, { state: action });

      action = key;
      key = arguments[3] || createKey();
    }

    return _createLocation3['default'](location, action, key);
  }

  // deprecated
  function setState(state) {
    if (location) {
      updateLocationState(location, state);
      updateLocation(location);
    } else {
      updateLocationState(getCurrentLocation(), state);
    }
  }

  function updateLocationState(location, state) {
    location.state = _extends({}, location.state, state);
    saveState(location.key, location.state);
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    transitionHooks = transitionHooks.filter(function (item) {
      return item !== hook;
    });
  }

  // deprecated
  function pushState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    push(_extends({ state: state }, path));
  }

  // deprecated
  function replaceState(state, path) {
    if (typeof path === 'string') path = _PathUtils.parsePath(path);

    replace(_extends({ state: state }, path));
  }

  return {
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: createPath,
    createHref: createHref,
    createLocation: createLocation,

    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
  };
}

exports['default'] = createHistory;
module.exports = exports['default'];

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(885);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1873);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(888);

var callBind = __webpack_require__(576);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1875)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(575);
var hasOwn = __webpack_require__(1877);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(889);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(891);

var supportsDescriptors = __webpack_require__(327).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _Actions = __webpack_require__(224);

var _PathUtils = __webpack_require__(225);

function createLocation() {
  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  if (typeof location === 'string') location = _PathUtils.parsePath(location);

  if (typeof action === 'object') {
     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;

    location = _extends({}, location, { state: action });

    action = key || _Actions.POP;
    key = _fourthArg;
  }

  var pathname = location.pathname || '/';
  var search = location.search || '';
  var hash = location.hash || '';
  var state = location.state || null;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
}

exports['default'] = createLocation;
module.exports = exports['default'];

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeStateWithLocation;

var _deprecateObjectProperties = __webpack_require__(411);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeStateWithLocation(state, location) {
  if (false) {
    var stateWithLocation = _extends({}, state);

    // I don't use deprecateObjectProperties here because I want to keep the
    // same code path between development and production, in that we just
    // assign extra properties to the copy of the state object in both cases.

    var _loop = function _loop(prop) {
      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
        return 'continue';
      }

      Object.defineProperty(stateWithLocation, prop, {
        get: function get() {
          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
          return location[prop];
        }
      });
    };

    for (var prop in location) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }

    return stateWithLocation;
  }

  return _extends({}, state, location);
}
module.exports = exports['default'];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.createRoutingHistory = createRoutingHistory;

var _deprecateObjectProperties = __webpack_require__(411);

var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRouterObject(history, transitionManager) {
  return _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });
}

// deprecated
function createRoutingHistory(history, transitionManager) {
  history = _extends({}, history, transitionManager);

  if (false) {
    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
  }

  return history;
}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(195);

var _PatternUtils = __webpack_require__(265);

var _InternalPropTypes = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var string = _propTypes2.default.string,
    object = _propTypes2.default.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.createRouteFromReactElement = function createRouteFromReactElement(element) {
    var route = (0, _RouteUtils.createRouteFromReactElement)(element);

    if (route.from) route.path = route.from;

    route.onEnter = function (nextState, replace) {
      var location = nextState.location,
          params = nextState.params;


      var pathname = void 0;
      if (route.to.charAt(0) === '/') {
        pathname = (0, _PatternUtils.formatPattern)(route.to, params);
      } else if (!route.to) {
        pathname = location.pathname;
      } else {
        var routeIndex = nextState.routes.indexOf(route);
        var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
        var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
        pathname = (0, _PatternUtils.formatPattern)(pattern, params);
      }

      replace({
        pathname: pathname,
        query: route.query || location.query,
        state: route.state || location.state
      });
    };

    return route;
  };

  Redirect.getRoutePattern = function getRoutePattern(routes, routeIndex) {
    var parentPattern = '';

    for (var i = routeIndex; i >= 0; i--) {
      var route = routes[i];
      var pattern = route.path || '';

      parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

      if (pattern.indexOf('/') === 0) break;
    }

    return '/' + parentPattern;
  };

  /* istanbul ignore next: sanity check */
  Redirect.prototype.render = function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  };

  return Redirect;
}(_react2.default.Component);

Redirect.propTypes = {
  path: string,
  from: string, // Alias for path
  to: string.isRequired,
  query: object,
  state: object,
  onEnter: _InternalPropTypes.falsy,
  children: _InternalPropTypes.falsy
};
exports.default = Redirect;
module.exports = exports['default'];

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = __webpack_require__(266);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(580);

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = __webpack_require__(898);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useRoutes` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  history.__v2_compatible__ = true;
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _PathUtils = __webpack_require__(225);

var _Actions = __webpack_require__(224);

var _createHistory = __webpack_require__(883);

var _createHistory2 = _interopRequireDefault(_createHistory);

function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
}

function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var history = _createHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: saveState,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;

  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    var key = history.createKey();

    if (typeof entry === 'string') return { pathname: entry, key: key };

    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });

     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
  }

  var storage = createStateStorage(entries);

  function saveState(key, state) {
    storage[key] = state;
  }

  function readState(key) {
    return storage[key];
  }

  function getCurrentLocation() {
    var entry = entries[current];
    var basename = entry.basename;
    var pathname = entry.pathname;
    var search = entry.search;

    var path = (basename || '') + pathname + (search || '');

    var key = undefined,
        state = undefined;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    } else {
      key = history.createKey();
      state = null;
      entry.key = key;
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  }

  function go(n) {
    if (n) {
      if (!canGo(n)) {
         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
        return;
      }

      current += n;

      var currentLocation = getCurrentLocation();

      // change action to POP
      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
    }
  }

  function finishTransition(location) {
    switch (location.action) {
      case _Actions.PUSH:
        current += 1;

        // if we are not on the top of stack
        // remove rest and push new
        if (current < entries.length) entries.splice(current);

        entries.push(location);
        saveState(location.key, location.state);
        break;
      case _Actions.REPLACE:
        entries[current] = location;
        saveState(location.key, location.state);
        break;
    }
  }

  return history;
}

exports['default'] = createMemoryHistory;
module.exports = exports['default'];

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _Actions = __webpack_require__(224);

var _PathUtils = __webpack_require__(225);

var _ExecutionEnvironment = __webpack_require__(326);

var _DOMUtils = __webpack_require__(412);

var _DOMStateStorage = __webpack_require__(881);

var _createDOMHistory = __webpack_require__(882);

var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve URLs.
 */
function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;

  var forceRefresh = options.forceRefresh;

  var isSupported = _DOMUtils.supportsHistory();
  var useRefresh = !isSupported || forceRefresh;

  function getCurrentLocation(historyState) {
    try {
      historyState = historyState || window.history.state || {};
    } catch (e) {
      historyState = {};
    }

    var path = _DOMUtils.getWindowPath();
    var _historyState = historyState;
    var key = _historyState.key;

    var state = undefined;
    if (key) {
      state = _DOMStateStorage.readState(key);
    } else {
      state = null;
      key = history.createKey();

      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
    }

    var location = _PathUtils.parsePath(path);

    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
  }

  function startPopStateListener(_ref) {
    var transitionTo = _ref.transitionTo;

    function popStateListener(event) {
      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.

      transitionTo(getCurrentLocation(event.state));
    }

    _DOMUtils.addEventListener(window, 'popstate', popStateListener);

    return function () {
      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
    };
  }

  function finishTransition(location) {
    var basename = location.basename;
    var pathname = location.pathname;
    var search = location.search;
    var hash = location.hash;
    var state = location.state;
    var action = location.action;
    var key = location.key;

    if (action === _Actions.POP) return; // Nothing to do.

    _DOMStateStorage.saveState(key, state);

    var path = (basename || '') + pathname + search + hash;
    var historyState = {
      key: key
    };

    if (action === _Actions.PUSH) {
      if (useRefresh) {
        window.location.href = path;
        return false; // Prevent location update.
      } else {
          window.history.pushState(historyState, null, path);
        }
    } else {
      // REPLACE
      if (useRefresh) {
        window.location.replace(path);
        return false; // Prevent location update.
      } else {
          window.history.replaceState(historyState, null, path);
        }
    }
  }

  var history = _createDOMHistory2['default'](_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    finishTransition: finishTransition,
    saveState: _DOMStateStorage.saveState
  }));

  var listenerCount = 0,
      stopPopStateListener = undefined;

  function listenBefore(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listenBefore(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  function listen(listener) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    var unlisten = history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopPopStateListener();
    };
  }

  // deprecated
  function registerTransitionHook(hook) {
    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);

    history.registerTransitionHook(hook);
  }

  // deprecated
  function unregisterTransitionHook(hook) {
    history.unregisterTransitionHook(hook);

    if (--listenerCount === 0) stopPopStateListener();
  }

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    registerTransitionHook: registerTransitionHook,
    unregisterTransitionHook: unregisterTransitionHook
  });
}

exports['default'] = createBrowserHistory;
module.exports = exports['default'];

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = __webpack_require__(581);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _ExecutionEnvironment = __webpack_require__(326);

var _DOMUtils = __webpack_require__(412);

var _deprecate = __webpack_require__(226);

var _deprecate2 = _interopRequireDefault(_deprecate);

function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
  function listener(event) {
    var message = getBeforeUnloadPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }
  }

  _DOMUtils.addEventListener(window, 'beforeunload', listener);

  return function () {
    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
  };
}

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
function useBeforeUnload(createHistory) {
  return function (options) {
    var history = createHistory(options);

    var stopBeforeUnloadListener = undefined;
    var beforeUnloadHooks = [];

    function getBeforeUnloadPromptMessage() {
      var message = undefined;

      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
        message = beforeUnloadHooks[i].call();
      }return message;
    }

    function listenBeforeUnload(hook) {
      beforeUnloadHooks.push(hook);

      if (beforeUnloadHooks.length === 1) {
        if (_ExecutionEnvironment.canUseDOM) {
          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
        } else {
           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
        }
      }

      return function () {
        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
          return item !== hook;
        });

        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
          stopBeforeUnloadListener();
          stopBeforeUnloadListener = null;
        }
      };
    }

    // deprecated
    function registerBeforeUnloadHook(hook) {
      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
        beforeUnloadHooks.push(hook);

        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
      }
    }

    // deprecated
    function unregisterBeforeUnloadHook(hook) {
      if (beforeUnloadHooks.length > 0) {
        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
          return item !== hook;
        });

        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
      }
    }

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload,

      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
    });
  };
}

exports['default'] = useBeforeUnload;
module.exports = exports['default'];

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(793),
    baseRest = __webpack_require__(203),
    baseUniq = __webpack_require__(537),
    isArrayLikeObject = __webpack_require__(677);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _SearchUrls = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    trainUid: [_LinkMapper.fields.number],
    origin: [_LinkMapper.fields.string],
    originStationDetail: null,
    destination: [_LinkMapper.fields.string],
    destinationStationDetail: null,
    departureDate: [_LinkMapper.resolve.with(function (date) {
        return (0, _TrainTime2.default)(date, 'YYYY-MM-DD');
    })],
    departureTime: [_LinkMapper.resolve.with(function (time) {
        return (0, _TrainTime2.default)(time, 'HH:mm:ss');
    })],
    arrivalTime: [_LinkMapper.resolve.with(function (date) {
        return (0, _TrainTime2.default)(date, 'YYYY-MM-DD');
    })],
    legOrder: [_LinkMapper.fields.number],
    groupId: [_LinkMapper.fields.string, null]
};

var CustomerServiceChangeLeg = function (_record) {
    (0, _inherits3.default)(CustomerServiceChangeLeg, _record);

    function CustomerServiceChangeLeg() {
        (0, _classCallCheck3.default)(this, CustomerServiceChangeLeg);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CustomerServiceChangeLeg.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CustomerServiceChangeLeg, json, (0, _Records.getResolvers)(fieldSchema));
    };

    CustomerServiceChangeLeg.prototype.toJSON = function toJSON() {
        return (0, _SearchUrls.serialize)({
            trainUid: _SearchUrls.serializers.identity,
            origin: _SearchUrls.serializers.identity,
            originStationDetail: _SearchUrls.serializers.identity,
            destination: _SearchUrls.serializers.identity,
            destinationStationDetail: _SearchUrls.serializers.identity,
            departureDate: function departureDate(_departureDate) {
                return _departureDate ? _SearchUrls.serializers.date(_departureDate) : null;
            },
            departureTime: function departureTime(_departureTime) {
                return _departureTime ? _SearchUrls.serializers.time(_departureTime) : null;
            },
            arrivalTime: function arrivalTime(departureTime) {
                return departureTime ? _SearchUrls.serializers.time(departureTime) : null;
            },
            legOrder: _SearchUrls.serializers.identity,
            groupId: _SearchUrls.serializers.identity
        }, this);
    };

    return CustomerServiceChangeLeg;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = CustomerServiceChangeLeg;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _SearchUrls = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    id: [_LinkMapper.fields.number],
    trainUid: [_LinkMapper.fields.number],
    origin: [_LinkMapper.resolve.as(_Station2.default)],
    destination: [_LinkMapper.resolve.as(_Station2.default)],
    departureTime: [_LinkMapper.resolve.with(function (time) {
        return (0, _TrainTime2.default)(time, 'HH:mm:ss');
    })],
    arrivalTime: [_LinkMapper.resolve.with(function (time) {
        return (0, _TrainTime2.default)(time, 'HH:mm:ss');
    })],
    groupId: [_LinkMapper.fields.number],
    legOrder: [_LinkMapper.fields.number]
};

var DisruptionAlertLeg = function (_record) {
    (0, _inherits3.default)(DisruptionAlertLeg, _record);

    function DisruptionAlertLeg() {
        (0, _classCallCheck3.default)(this, DisruptionAlertLeg);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DisruptionAlertLeg.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DisruptionAlertLeg, json, (0, _Records.getResolvers)(fieldSchema));
    };

    DisruptionAlertLeg.prototype.toJSON = function toJSON() {
        return (0, _SearchUrls.serialize)({
            journeyLegId: function journeyLegId(_, alert) {
                return alert.id ? alert.id : null;
            },
            trainUid: _SearchUrls.serializers.identity,
            origin: _SearchUrls.serializers.stationCrs,
            destination: _SearchUrls.serializers.stationCrs,
            departureTime: _SearchUrls.serializers.time,
            arrivalTime: _SearchUrls.serializers.time,
            groupId: _SearchUrls.serializers.identity,
            legOrder: _SearchUrls.serializers.identity
        }, this);
    };

    return DisruptionAlertLeg;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = DisruptionAlertLeg;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(315),
    eq = __webpack_require__(253);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _reactOnclickoutside = __webpack_require__(991);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _BannerStore = __webpack_require__(458);

var _BannerStore2 = _interopRequireDefault(_BannerStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStateFromStores = function getStateFromStores() {
    return {
        viewportHeight: _DimensionsStore2.default.get('height'),
        hasBanner: Boolean(_BannerStore2.default.getActive())
    };
};

function DropDown(_ref) {
    var children = _ref.children,
        show = _ref.show,
        onClose = _ref.onClose,
        viewportHeight = _ref.viewportHeight,
        hasBanner = _ref.hasBanner;

    var _React$useState = _react2.default.useState('initial'),
        maxHeight = _React$useState[0],
        setMaxHeight = _React$useState[1];

    var menuRef = _react2.default.useRef();

    (0, _react.useEffect)(function () {
        if (show) {
            var boundingClientRect = menuRef.current.getBoundingClientRect();
            var distanceFromTop = boundingClientRect.y;
            var footerHeight = 40;
            setMaxHeight(viewportHeight - distanceFromTop - footerHeight);
        }
    }, [viewportHeight, hasBanner, show]);

    DropDown.handleClickOutside = function () {
        return onClose();
    };

    var dropdownClasses = (0, _classnames2.default)('nav-list__dropdown', 'list-unstyled', 'no-margin', 'clearfix', {
        hidden: !show
    });

    return _react2.default.createElement(
        'ul',
        { ref: menuRef, className: dropdownClasses, role: 'menu', style: { maxHeight: maxHeight }, 'aria-hidden': !show },
        children
    );
}

var clickOutsideConfig = {
    handleClickOutside: function handleClickOutside() {
        return DropDown.handleClickOutside;
    }
};

DropDown.propTypes = {
    children: _propTypes2.default.node.isRequired,
    show: _propTypes2.default.bool,
    onClose: _propTypes2.default.func,
    viewportHeight: _propTypes2.default.number,
    hasBanner: _propTypes2.default.bool
};

DropDown.defaultProps = {
    show: false,
    onClose: _noop3.default
};

exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default, _BannerStore2.default], getStateFromStores)((0, _reactOnclickoutside2.default)(DropDown, clickOutsideConfig));

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

// TODO: `pullRight` doesn't belong here. There's no special handling here.
var propTypes = {
  pullRight: _propTypes.default.bool
};
var defaultProps = {
  pullRight: false
};

var Badge =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Badge, _React$Component);

  function Badge() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Badge.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;

    _react.default.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        pullRight = _this$props.pullRight,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["pullRight", "className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      'pull-right': pullRight,
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });
    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), children);
  };

  return Badge;
}(_react.default.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('badge', Badge);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _end = _interopRequireDefault(__webpack_require__(1937));

exports.end = _end.default;

var _properties = _interopRequireDefault(__webpack_require__(562));

exports.properties = _properties.default;
var _default = {
  end: _end.default,
  properties: _properties.default
};
exports.default = _default;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1938);

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1942);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(26);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(856);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1946);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(586);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(194));

var _isWindow = _interopRequireDefault(__webpack_require__(403));

var _ownerDocument = _interopRequireDefault(__webpack_require__(222));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(403));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1951);

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FavouritesLimitExceededError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavouritesLimitExceededError = exports.FavouritesLimitExceededError = function (_ExtendableError) {
  (0, _inherits3.default)(FavouritesLimitExceededError, _ExtendableError);

  function FavouritesLimitExceededError() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FavouritesLimitExceededError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'FavouritesLimitExceededError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return FavouritesLimitExceededError;
}(_ExtendableError3.default);

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var onEnterPress = exports.onEnterPress = function onEnterPress(onPress) {
  return function (_ref) {
    var key = _ref.key;
    return key === 'Enter' && onPress();
  };
};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minAge = _TrainTime2.default.duration('P5Y');

var defaults = {
    year: null,
    month: null,
    day: null,
    isDirty: false
};

var DateOfBirth = function (_record) {
    (0, _inherits3.default)(DateOfBirth, _record);

    function DateOfBirth() {
        (0, _classCallCheck3.default)(this, DateOfBirth);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DateOfBirth.prototype.getComputedValues = function getComputedValues() {
        var dateOfBirth = this.getDateOfBirth();
        var isInvalidDate = !!(dateOfBirth && !dateOfBirth.isValid());
        var isTooYoung = !!(dateOfBirth && !isInvalidDate && this.isTooYoung(dateOfBirth));
        var isInFuture = !!(dateOfBirth && dateOfBirth.isValid() && dateOfBirth.isAfter((0, _TrainTime2.default)()));
        return {
            isInFuture: isInFuture,
            isInvalidDate: isInvalidDate,
            isTooYoung: isTooYoung
        };
    };

    DateOfBirth.prototype.getSchema = function getSchema() {
        return {
            day: _joi2.default.number().integer().min(1).max(31).options({
                language: {
                    number: {
                        base: (0, _I18n.translate)('alertmessage.choose')
                    }
                }
            }),
            month: _joi2.default.number().integer().min(1).max(12).options({
                language: {
                    number: {
                        base: (0, _I18n.translate)('alertmessage.choose')
                    }
                }
            }),
            year: _joi2.default.number().integer().options({
                language: {
                    number: {
                        base: (0, _I18n.translate)('alertmessage.choose')
                    }
                }
            }),
            isInFuture: _joi2.default.boolean().optional().only(null, false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.future')
                    }
                }
            }),
            isInvalidDate: _joi2.default.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.invalid')
                    }
                }
            }),
            isTooYoung: _joi2.default.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.date.tooYoung')
                    }
                }
            })
        };
    };

    DateOfBirth.prototype.getDateOfBirth = function getDateOfBirth() {
        var day = this.day,
            month = this.month,
            year = this.year;

        return day && month && year && (0, _TrainTime2.default)(year + '-' + month + '-' + day, 'YYYY-MM-DD');
    };

    DateOfBirth.prototype.isTooYoung = function isTooYoung(dateOfBirth) {
        var youngest = (0, _TrainTime2.default)().subtract(minAge);
        return dateOfBirth && dateOfBirth.isValid() && dateOfBirth.isAfter(youngest);
    };

    DateOfBirth.prototype.isOverAge = function isOverAge(years) {
        var DoB = this.getDateOfBirth();
        if (DoB) {
            return DoB.isBefore((0, _TrainTime2.default)().subtract(years, 'years'));
        }
        return undefined;
    };

    return DateOfBirth;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(DateOfBirth.prototype, _ValidationMixin2.default);

exports.default = DateOfBirth;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmazonLoginError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonLoginError = exports.AmazonLoginError = function (_ExtendableError) {
    (0, _inherits3.default)(AmazonLoginError, _ExtendableError);

    function AmazonLoginError() {
        (0, _classCallCheck3.default)(this, AmazonLoginError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args)));

        _this.name = 'AmazonLoginError';
        return _this;
    }

    return AmazonLoginError;
}(_ExtendableError3.default);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _pickBy2 = __webpack_require__(161);

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _APIClient2 = __webpack_require__(52);

var _TokenStore = __webpack_require__(281);

var _TokenStore2 = _interopRequireDefault(_TokenStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonPayAPIClient = function (_APIClient) {
    (0, _inherits3.default)(AmazonPayAPIClient, _APIClient);

    function AmazonPayAPIClient() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AmazonPayAPIClient);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _APIClient.call.apply(_APIClient, [this].concat(args))), _this), _this.additionalHeaders = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    AmazonPayAPIClient.prototype.getHeaders = function getHeaders() {
        return (0, _extends3.default)({}, _APIClient.prototype.getHeaders.call(this), (0, _pickBy3.default)((0, _extends3.default)({
            'x-customer-device': _TokenStore2.default.getDevice()
        }, this.additionalHeaders), _isString3.default));
    };

    AmazonPayAPIClient.prototype.wrapHeaders = function wrapHeaders(func, additionalHeaders) {
        this.setAdditionalHeaders(additionalHeaders);
        var response = func();
        this.setAdditionalHeaders(null);

        return response;
    };

    AmazonPayAPIClient.prototype.delete = function _delete(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var _this2 = this;

        var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var authenticated = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        if (authenticated) {
            additionalHeaders = (0, _extends3.default)({}, additionalHeaders, {
                'x-customer-token': _TokenStore2.default.getCustomer()
            });
        }

        return this.wrapHeaders(function () {
            return _APIClient.prototype.delete.call(_this2, path, data, options);
        }, additionalHeaders);
    };

    AmazonPayAPIClient.prototype.get = function get(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _this3 = this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        return this.wrapHeaders(function () {
            return _APIClient.prototype.get.call(_this3, path, data, options);
        }, additionalHeaders);
    };

    AmazonPayAPIClient.prototype.post = function post(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _this4 = this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        return this.wrapHeaders(function () {
            return _APIClient.prototype.post.call(_this4, path, data, options);
        }, additionalHeaders);
    };

    AmazonPayAPIClient.prototype.put = function put(path) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _this5 = this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        return this.wrapHeaders(function () {
            return _APIClient.prototype.put.call(_this5, path, data, options);
        }, additionalHeaders);
    };

    AmazonPayAPIClient.prototype.setAdditionalHeaders = function setAdditionalHeaders(headers) {
        this.additionalHeaders = headers;
    };

    return AmazonPayAPIClient;
}(_APIClient2.APIClient);

exports.default = new AmazonPayAPIClient();

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.serviceUnavailable = serviceUnavailable;
function serviceUnavailable(code) {
    switch (code) {
        case 500:
        case 501:
        case 502:
        case 503:
            return true;
        default:
            return false;
    }
}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _bootstrapUtils = __webpack_require__(21);

/* eslint-disable jsx-a11y/label-has-for */
var propTypes = {
  inline: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  title: _propTypes.default.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: _propTypes.default.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = _react.default.createElement("input", (0, _extends2.default)({}, elementProps, {
      ref: inputRef,
      type: "checkbox",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? (0, _warning.default)(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return _react.default.createElement("label", {
        className: (0, _classnames.default)(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return _react.default.createElement("div", {
      className: (0, _classnames.default)(className, classes),
      style: style
    }, _react.default.createElement("label", {
      title: title
    }, input, children));
  };

  return Checkbox;
}(_react.default.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _bootstrapUtils = __webpack_require__(21);

/* eslint-disable jsx-a11y/label-has-for */
var propTypes = {
  inline: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  title: _propTypes.default.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: _propTypes.default.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: _propTypes.default.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Radio, _React$Component);

  function Radio() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = _react.default.createElement("input", (0, _extends2.default)({}, elementProps, {
      ref: inputRef,
      type: "radio",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? (0, _warning.default)(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return _react.default.createElement("label", {
        className: (0, _classnames.default)(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return _react.default.createElement("div", {
      className: (0, _classnames.default)(className, classes),
      style: style
    }, _react.default.createElement("label", {
      title: title
    }, input, children));
  };

  return Radio;
}(_react.default.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('radio', Radio);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = AgeCheckbox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _HelpIcon = __webpack_require__(335);

var _HelpIcon2 = _interopRequireDefault(_HelpIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AgeCheckbox(_ref) {
    var isOver16 = _ref.isOver16,
        onToggle = _ref.onToggle;

    // eslint-disable-next-line react/jsx-wrap-multilines
    var CheckBoxLabel = _react2.default.createElement(
        'span',
        null,
        (0, _I18n2.default)('preference-centre.age-restriction'),
        _react2.default.createElement(_HelpIcon2.default, { message: (0, _I18n2.default)('preference-centre.age-restriction.modal-text'), centerMessage: true })
    );

    return _react2.default.createElement(
        'div',
        { className: 'margin-bottom--sm' },
        _react2.default.createElement(_Checkbox2.default, { className: 'marketing-preferences__age-toggle',
            onChange: onToggle,
            checked: isOver16,
            label: CheckBoxLabel })
    );
}

AgeCheckbox.propTypes = {
    onToggle: _propTypes2.default.func.isRequired,
    isOver16: _propTypes2.default.bool
};

AgeCheckbox.defaultProps = {
    isOver16: false
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterHello = function RegisterHello(_ref) {
    var className = _ref.className,
        name = _ref.name;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('register-modal__success-message', className) },
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            className: 'register-modal__success-message__html',
            message: 'account.register.successMessage',
            name: name,
            brand: (0, _I18n2.default)('app.owner.short')
        })
    );
};

RegisterHello.propTypes = {
    className: _propTypes2.default.string,
    name: _propTypes2.default.string
};

RegisterHello.defaultProps = {
    className: '',
    name: ''
};

exports.default = RegisterHello;

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalTabsContext = _react2.default.createContext();

var ModalTabs = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(ModalTabs, _React$PureComponent);

    function ModalTabs() {
        (0, _classCallCheck3.default)(this, ModalTabs);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    ModalTabs.prototype.render = function render() {
        var _props = this.props,
            activeTab = _props.activeTab,
            children = _props.children;


        return _react2.default.createElement(
            ModalTabsContext.Provider,
            { value: activeTab },
            _react2.default.createElement(
                'div',
                { className: 'modal__tabs' },
                children
            )
        );
    };

    return ModalTabs;
}(_react2.default.PureComponent), _class.propTypes = {
    activeTab: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.any
}, _temp);


var Tab = function Tab(_ref) {
    var onClick = _ref.onClick,
        name = _ref.name,
        title = _ref.title;

    return _react2.default.createElement(
        ModalTabsContext.Consumer,
        null,
        function (activeTab) {
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('modal__tabs__tab', { 'modal__tabs__tab--active': name === activeTab }) },
                name === activeTab && _react2.default.createElement('div', { className: 'modal__tabs__tab__left-corner' }),
                _react2.default.createElement(
                    'span',
                    { onClick: onClick },
                    title
                )
            );
        }
    );
};

Tab.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    name: _propTypes2.default.string,
    title: _propTypes2.default.string
};

ModalTabs.Tab = Tab;

exports.default = ModalTabs;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _AppConstants = __webpack_require__(6);

var _AmazonLoginStore = __webpack_require__(352);

var _AmazonLoginStore2 = _interopRequireDefault(_AmazonLoginStore);

var _AmazonLogin = __webpack_require__(2015);

var _AmazonLogin2 = _interopRequireDefault(_AmazonLogin);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        enableAmazonLogin: _FeatureFlagStore2.default.get('enableAmazonLogin'),
        enableAmazonRegistration: _FeatureFlagStore2.default.get('enableAmazonRegistration'),
        error: _AmazonLoginStore2.default.getStatus() === _AppConstants.AmazonLoginStatus.LOGIN_ERROR
    };
};

var AmazonLoginCTA = function AmazonLoginCTA(_ref) {
    var closeModal = _ref.closeModal,
        enableAmazonLogin = _ref.enableAmazonLogin,
        enableAmazonRegistration = _ref.enableAmazonRegistration,
        error = _ref.error,
        isVertical = _ref.isVertical,
        onButtonClick = _ref.onButtonClick,
        type = _ref.type;

    var isEnabled = enableAmazonLogin && (type !== _AppConstants.AmazonLoginCTATypes.REGISTER || enableAmazonRegistration);

    if (!isEnabled) {
        return null;
    }

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: 'amazon-login__cta-wrapper' },
            error && _react2.default.createElement(
                _BAlert2.default,
                { type: _AppConstants.BAlertTypes.DANGER, className: 'margin-bottom--sm' },
                (0, _I18n2.default)('login.amazon.error')
            ),
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('amazon-login__cta', { 'amazon-login__cta--vertical': isVertical }) },
                _react2.default.createElement(
                    'div',
                    { className: 'amazon-login__cta__text' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'amazon-login__cta__text__top' },
                        (0, _I18n2.default)('account.register.cta.side', { brand: (0, _I18n2.default)('app.owner.short') })
                    ),
                    _react2.default.createElement(
                        'h3',
                        { className: 'amazon-login__cta__text__bottom' },
                        (0, _I18n2.default)('account.register.cta.main')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'amazon-login__cta__button' },
                    _react2.default.createElement(_AmazonLogin2.default, {
                        onButtonClick: onButtonClick,
                        closeModal: closeModal,
                        hideErrors: true,
                        isAlreadyRegistering: true,
                        isLongButton: isVertical
                    })
                )
            )
        )
    );
};

AmazonLoginCTA.propTypes = {
    closeModal: _propTypes2.default.func.isRequired,
    enableAmazonLogin: _propTypes2.default.bool,
    enableAmazonRegistration: _propTypes2.default.bool,
    error: _propTypes2.default.bool.isRequired,
    isVertical: _propTypes2.default.bool,
    onButtonClick: _propTypes2.default.func,
    type: _propTypes2.default.string
};

AmazonLoginCTA.defaultProps = {
    enableAmazonLogin: false,
    enableAmazonRegistration: false,
    type: _AppConstants.AmazonLoginCTATypes.LOGIN,
    isVertical: false,
    onButtonClick: _noop3.default
};

exports.default = (0, _connectToStores2.default)([_AmazonLoginStore2.default, _FeatureFlagStore2.default], _getStateFromStores)(AmazonLoginCTA);

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    username: null,
    password: null
};

var Login = function (_Record) {
    (0, _inherits3.default)(Login, _Record);

    function Login() {
        (0, _classCallCheck3.default)(this, Login);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    Login.prototype.getSchema = function getSchema() {
        return {
            username: _validation2.default.email().options({
                language: {
                    string: {
                        base: (0, _I18n.translate)('alertmessage.login.badEmail'),
                        email: (0, _I18n.translate)('alertmessage.login.badEmail')
                    }
                }
            }),
            password: _validation2.default.passwordEntry()
        };
    };

    return Login;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(Login.prototype, _ValidationMixin2.default);

exports.default = Login;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindKey = __webpack_require__(1036),
    baseForOwn = __webpack_require__(220),
    baseIteratee = __webpack_require__(102);

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
}

module.exports = findKey;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _DelayRepayEndpoint = __webpack_require__(2024);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DelayRepayService = {
    subscribe: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user, notifyByPreference) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return _AuthenticatedAPIClient2.default.put(_DelayRepayEndpoint.URL.subscribe.replace('{id}', user.id), {
                                customerId: user.id,
                                emailOptedIn: notifyByPreference === 'email' || notifyByPreference === 'appAndEmail',
                                appOptedIn: notifyByPreference === 'app' || notifyByPreference === 'appAndEmail'
                            });

                        case 3:
                            response = _context.sent;
                            return _context.abrupt('return', response);

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            console.warn('error calling OCDR subscribe service', _context.t0);
                            return _context.abrupt('return', false);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));

        function subscribe(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return subscribe;
    }(),
    unsubscribe: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(customerId) {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(_DelayRepayEndpoint.URL.subscribe.replace('{id}', customerId), {
                                customerId: customerId
                            });

                        case 3:
                            response = _context2.sent;
                            return _context2.abrupt('return', response);

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](0);

                            console.warn('error calling OCDR unsubscribe service', _context2.t0);
                            return _context2.abrupt('return', false);

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 7]]);
        }));

        function unsubscribe(_x3) {
            return _ref2.apply(this, arguments);
        }

        return unsubscribe;
    }(),
    getCharities: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _APIClient2.default.get('/delay-repay/charity');

                        case 3:
                            return _context3.abrupt('return', _context3.sent);

                        case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3['catch'](0);
                            return _context3.abrupt('return', []);

                        case 9:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 6]]);
        }));

        function getCharities() {
            return _ref3.apply(this, arguments);
        }

        return getCharities;
    }()
};

exports.default = DelayRepayService;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Grid = __webpack_require__(428);

var _Grid2 = _interopRequireDefault(_Grid);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _PaymentRadio = __webpack_require__(438);

var _PaymentRadio2 = _interopRequireDefault(_PaymentRadio);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotifyBy = function NotifyBy(_ref) {
    var notifyByPreference = _ref.notifyByPreference,
        setNotifyByPreference = _ref.setNotifyByPreference,
        hasPushNotifications = _ref.hasPushNotifications,
        isDDM = _ref.isDDM,
        isOCDR = _ref.isOCDR;

    var showAppStoreLinks = !hasPushNotifications && (notifyByPreference === _AppConstants.notificationPreferences.APP || notifyByPreference === _AppConstants.notificationPreferences.APP_AND_EMAIL);

    return _react2.default.createElement(
        _Grid2.default,
        null,
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                'h2',
                { className: 'auto-dr__header' },
                (0, _I18n.translate)(isDDM ? 'ddm.notify.heading' : 'auto-dr.notify.heading')
            ),
            isOCDR && _react2.default.createElement(
                'p',
                null,
                'Optional'
            ),
            isDDM && _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('ddm.notify.text')
            ),
            _react2.default.createElement(
                'div',
                { className: 'auto-delay-repay-notification-preferences' },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'auto-dr__payment-item auto-dr__payment-item--notification-preference'
                    },
                    _react2.default.createElement(
                        _OnEnterTrigger2.default,
                        {
                            className: (0, _classnames2.default)('payment__selector', {
                                'payment__selector--selected': notifyByPreference === _AppConstants.notificationPreferences.EMAIL
                            }),
                            onClick: function onClick() {
                                return setNotifyByPreference(_AppConstants.notificationPreferences.EMAIL);
                            },
                            srOnly: (0, _I18n.translate)('auto-dr.subscribe.modal-checkbox-email'),
                            disabled: false
                        },
                        _react2.default.createElement(_PaymentRadio2.default, {
                            className: 'payment__selector__radio-icon small',
                            isSelected: notifyByPreference === _AppConstants.notificationPreferences.EMAIL
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'auto-dr__payment-item__label' },
                            (0, _I18n.translate)('auto-dr.subscribe.modal-checkbox-email')
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'auto-dr__payment-item auto-dr__payment-item--notification-preference'
                    },
                    _react2.default.createElement(
                        _OnEnterTrigger2.default,
                        {
                            className: (0, _classnames2.default)('payment__selector', {
                                'payment__selector--selected': notifyByPreference === _AppConstants.notificationPreferences.APP
                            }),
                            onClick: function onClick() {
                                return setNotifyByPreference(_AppConstants.notificationPreferences.APP);
                            },
                            srOnly: (0, _I18n.translate)('auto-dr.subscribe.modal-checkbox-app')
                        },
                        _react2.default.createElement(_PaymentRadio2.default, {
                            className: 'payment__selector__radio-icon small',
                            isSelected: notifyByPreference === _AppConstants.notificationPreferences.APP
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'auto-dr__payment-item__label' },
                            (0, _I18n.translate)('auto-dr.subscribe.modal-checkbox-app')
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'auto-dr__payment-item auto-dr__payment-item--notification-preference'
                    },
                    _react2.default.createElement(
                        _OnEnterTrigger2.default,
                        {
                            className: (0, _classnames2.default)('payment__selector', {
                                'payment__selector--selected': notifyByPreference === _AppConstants.notificationPreferences.APP_AND_EMAIL
                            }),
                            onClick: function onClick() {
                                return setNotifyByPreference(_AppConstants.notificationPreferences.APP_AND_EMAIL);
                            },
                            srOnly: (0, _I18n.translate)('auto-dr.subscribe.modal-checkbox-app-and-email')
                        },
                        _react2.default.createElement(_PaymentRadio2.default, {
                            className: 'payment__selector__radio-icon small',
                            isSelected: notifyByPreference === _AppConstants.notificationPreferences.APP_AND_EMAIL
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'auto-dr__payment-item__label' },
                            (0, _I18n.translate)('auto-dr.subscribe.modal-checkbox-app-and-email')
                        )
                    )
                )
            ),
            _react2.default.createElement('br', null),
            showAppStoreLinks && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'p',
                    { className: '' },
                    (0, _I18n.translate)('auto-dr.subscribe.mobile-app-description')
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'load-smartcard-modal__app-badges' },
                    _react2.default.createElement(
                        'a',
                        { href: _config2.default.get('appStoreAppUrl'), target: '_blank' },
                        _react2.default.createElement('img', {
                            src: '/images/mobile-apps/app-store.png',
                            alt: (0, _I18n.translate)('ontrackapp.widget.appstoreButtonAltText')
                        })
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: _config2.default.get('googlePlayAppUrl'), target: '_blank' },
                        _react2.default.createElement('img', {
                            src: '/images/mobile-apps/google-play.png',
                            alt: (0, _I18n.translate)('ontrackapp.widget.googlePlayButtonAltText')
                        })
                    )
                )
            )
        )
    );
};

NotifyBy.propTypes = {
    notifyByPreference: _propTypes2.default.bool.isRequired,
    hasPushNotifications: _propTypes2.default.bool.isRequired,
    isDDM: _propTypes2.default.bool,
    isOCDR: _propTypes2.default.bool,
    setNotifyByPreference: _propTypes2.default.func.isRequired
};

exports.default = NotifyBy;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = PromptPasswordChangeModal;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _PasswordChange = __webpack_require__(2032);

var _PasswordChange2 = _interopRequireDefault(_PasswordChange);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _NotificationCentre = __webpack_require__(585);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _BAlert = __webpack_require__(101);

var _Password = __webpack_require__(419);

var _Password2 = _interopRequireDefault(_Password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PromptPasswordChangeModal(_ref) {
    var _this = this;

    var _ref$user = _ref.user,
        user = _ref$user === undefined ? _UserStore2.default.getCurrent() : _ref$user;

    var _React$useState = _react2.default.useState(),
        error = _React$useState[0],
        setError = _React$useState[1];

    var _React$useState2 = _react2.default.useState(new _PasswordChange2.default()),
        form = _React$useState2[0],
        updateForm = _React$useState2[1];

    var onChange = function onChange(field, value) {
        updateForm(function (current) {
            return current.set(field, value);
        });
        setError(null);
    };

    var _React$useState3 = _react2.default.useState(false),
        isCancelling = _React$useState3[0],
        setCancelling = _React$useState3[1];

    var onClose = function onClose() {
        _ModalActions2.default.close();
        (0, _NotificationCentre.displayNotifications)();
    };

    var _React$useState4 = _react2.default.useState(),
        submitted = _React$useState4[0],
        setSubmitted = _React$useState4[1];

    var changePassword = _react2.default.useCallback((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        setSubmitted(true);

                        if (form.isComplete()) {
                            _context.next = 3;
                            break;
                        }

                        return _context.abrupt('return');

                    case 3:
                        _context.prev = 3;
                        _context.next = 6;
                        return _CustomerActions2.default.updateAuthenticatedProperties({
                            user: user,
                            currentPassword: form.currentPassword,
                            changes: {
                                password: form.newPassword
                            }
                        });

                    case 6:
                        _NotificationActions2.default.showNotification('login.promptPasswordChange.success');
                        onClose();
                        _context.next = 13;
                        break;

                    case 10:
                        _context.prev = 10;
                        _context.t0 = _context['catch'](3);

                        setError(_context.t0);

                    case 13:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[3, 10]]);
    })), [form, user]);

    var modalProps = {
        header: false,
        disableEscape: true,
        isAutofocusing: false,
        variant: 'light'
    };

    if (isCancelling) {
        return _react2.default.createElement(
            _BaseModal2.default,
            (0, _extends3.default)({}, modalProps, {
                className: 'modal--sm',
                onClose: onClose,
                onContinue: function onContinue() {
                    return setCancelling(!isCancelling);
                },
                continueText: 'login.promptPasswordChange.button.back'
            }),
            _react2.default.createElement(
                'h2',
                null,
                (0, _I18n2.default)('login.promptPasswordChange.cancel.title', { firstNames: user.firstNames })
            ),
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'login.promptPasswordChange.cancel.confirm',
                tagName: 'p',
                className: 'text-weight--bold padding--vert-sm',
                splitParagraphs: true
            })
        );
    }

    return _react2.default.createElement(
        _BaseModal2.default,
        (0, _extends3.default)({}, modalProps, {
            onContinue: changePassword,
            onClose: function onClose() {
                return setCancelling(!isCancelling);
            },
            continueText: 'login.promptPasswordChange.button.save'
        }),
        _react2.default.createElement(
            'h2',
            null,
            (0, _I18n2.default)('login.promptPasswordChange.title', { firstNames: user.firstNames })
        ),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'login.promptPasswordChange.information',
            tagName: 'p',
            className: 'text-weight--bold padding--vert-sm'
        }),
        _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'login.promptPasswordChange.supplementary', tagName: 'p' }),
        _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'login.promptPasswordChange.defer', tagName: 'p' }),
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { sm: 6 },
                _react2.default.createElement(_Password2.default, {
                    field: 'currentPassword',
                    form: form,
                    onChange: onChange,
                    visited: submitted,
                    label: (0, _I18n2.default)('login.promptPasswordChange.currentPassword'),
                    showPasswordIcon: true
                })
            ),
            _react2.default.createElement(
                _Col2.default,
                { sm: 6 },
                _react2.default.createElement(_Password2.default, {
                    id: 'newPassword',
                    field: 'newPassword',
                    form: form,
                    onChange: onChange,
                    visited: submitted,
                    label: (0, _I18n2.default)('login.promptPasswordChange.newPassword'),
                    autoComplete: 'new-password',
                    showPasswordHints: true,
                    showPasswordIcon: true
                })
            )
        ),
        error && _react2.default.createElement(
            _BAlert.VisibleBAlert,
            { type: _BAlert.bAlertType.DANGER },
            (0, _I18n2.default)('login.promptPasswordChange.error')
        ),
        submitted && !form.isComplete() && _react2.default.createElement(
            _BAlert.VisibleBAlert,
            { type: _BAlert.bAlertType.DANGER },
            (0, _I18n2.default)('login.promptPasswordChange.validationError')
        )
    );
}

PromptPasswordChangeModal.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default).isRequired
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _APIClient = __webpack_require__(52);

var _OrderService = __webpack_require__(346);

var _OrderService2 = _interopRequireDefault(_OrderService);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FareStations = __webpack_require__(282);

var _FareStations2 = _interopRequireDefault(_FareStations);

var _Ticket = __webpack_require__(2040);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _ticketUrl(order, ticket) {
    return (0, _APIClient.makeUrl)(_OrderService2.default.getTicketUrl(order, ticket));
}

var DownloadTicketsModal = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(DownloadTicketsModal, _PureRenderComponent);

    function DownloadTicketsModal() {
        (0, _classCallCheck3.default)(this, DownloadTicketsModal);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    DownloadTicketsModal.prototype._getFareName = function _getFareName(fare) {
        return _react2.default.createElement(_FareStations2.default, { origin: fare.origin, destination: fare.destination, isReturn: fare.isReturn() });
    };

    DownloadTicketsModal.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            order = _props.order,
            orderTrip = _props.orderTrip,
            onClose = _props.onClose;


        return _react2.default.createElement(
            _BaseModal2.default,
            {
                onClose: onClose,
                hideContinue: true,
                titleText: 'order.summary.download.title',
                className: 'modal--xs download-tickets__modal' },
            orderTrip.getJourneyFares().map(function (tripFare) {
                return _react2.default.createElement(
                    'div',
                    { key: tripFare.fareId, className: 'box margin-top--sm padding--horiz' },
                    _react2.default.createElement(
                        _Row2.default,
                        { className: 'padding-top--sm padding-bottom--sm padding--horiz-sm' },
                        _react2.default.createElement(
                            _Col2.default,
                            { className: 'fare__name' },
                            _this2._getFareName(tripFare)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ticket__downloads margin-bottom--sm' },
                        tripFare.tickets.map(function (ticket) {
                            return _react2.default.createElement(
                                _Row2.default,
                                { key: ticket.id },
                                _react2.default.createElement(
                                    _Col2.default,
                                    { xs: 9 },
                                    _react2.default.createElement(_Ticket2.default, { ticket: ticket })
                                ),
                                _react2.default.createElement(
                                    _Col2.default,
                                    { xs: 3, className: 'text-right' },
                                    ticket.isRefunded && 'Refunded',
                                    !ticket.isRefunded && ticket.attachment && _react2.default.createElement(
                                        _Button2.default,
                                        { className: 'btn btn-link' },
                                        _react2.default.createElement(_Icon2.default, { icon: 'document' }),
                                        _react2.default.createElement(
                                            'a',
                                            { href: _ticketUrl(order, ticket), download: (0, _I18n.translate)('app.owner') + ' ' + (0, _I18n.translate)('order.summary.download.ticketName', { id: ticket.id }) },
                                            (0, _I18n.translate)('order.summary.download')
                                        )
                                    ),
                                    !ticket.isRefunded && !ticket.attachment && (0, _I18n.translate)('order.summary.download.generating')
                                )
                            );
                        })
                    )
                );
            })
        );
    };

    return DownloadTicketsModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    onClose: _propTypes2.default.func
}, _class.defaultProps = {
    onClose: _noop3.default
}, _temp);
exports.default = DownloadTicketsModal;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.hours = undefined;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormControl = __webpack_require__(178);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _lpad = __webpack_require__(440);

var _lpad2 = _interopRequireDefault(_lpad);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hours = exports.hours = (0, _range3.default)(0, 24);

var changeHandler = function changeHandler(callback) {
    return function (e) {
        return callback(parseInt(e.target.value, 10));
    };
};

function HourSelector(_ref) {
    var hour = _ref.hour,
        onChange = _ref.onChange,
        disabled = _ref.disabled,
        min = _ref.min,
        max = _ref.max;

    var uniqueId = (0, _uniqueId3.default)('hour__selector_');
    return _react2.default.createElement(
        'div',
        { className: 'hours select-container' },
        _react2.default.createElement(_Icon2.default, { icon: 'dropdown' }),
        _react2.default.createElement(
            'label',
            { htmlFor: uniqueId, className: 'sr-only' },
            (0, _I18n2.default)('booking.time.labels.hours')
        ),
        _react2.default.createElement(
            _FormControl2.default,
            {
                componentClass: 'select',
                disabled: disabled,
                name: 'hours',
                id: uniqueId,
                className: 'hours__form-control',
                value: hour,
                onChange: changeHandler(onChange)
            },
            hours.map(function (num) {
                return _react2.default.createElement(
                    'option',
                    {
                        key: num,
                        value: num,
                        disabled: num > max || num < min
                    },
                    (0, _lpad2.default)(num, 2, "0")
                );
            })
        )
    );
}

HourSelector.propTypes = {
    hour: _propTypes2.default.oneOf(hours),
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    min: _propTypes2.default.oneOf(hours),
    max: _propTypes2.default.oneOf(hours)
};

HourSelector.defaultProps = {
    hour: 12,
    onChange: _noop3.default,
    disabled: false,
    min: 0,
    max: 23
};

exports.default = HourSelector;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.roundMinutes = exports.minutes = undefined;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormControl = __webpack_require__(178);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _lpad = __webpack_require__(440);

var _lpad2 = _interopRequireDefault(_lpad);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STEP = 15;

var minutes = exports.minutes = function minutes(minuteStep) {
    return (0, _range3.default)(0, 60, minuteStep);
};

var roundMinutes = exports.roundMinutes = function roundMinutes(value) {
    var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_STEP;
    return Math.ceil(value / step) * step;
};

var changeHandler = function changeHandler(callback) {
    return function (e) {
        return callback(parseInt(e.target.value, 10));
    };
};

function MinuteSelector(_ref) {
    var minute = _ref.minute,
        minuteStep = _ref.minuteStep,
        onChange = _ref.onChange,
        disabled = _ref.disabled,
        min = _ref.min,
        max = _ref.max;

    var uniqueId = (0, _uniqueId3.default)('minute__selector_');
    return _react2.default.createElement(
        'div',
        { className: 'minutes select-container' },
        _react2.default.createElement(_Icon2.default, { icon: 'dropdown' }),
        _react2.default.createElement(
            'label',
            { htmlFor: uniqueId, className: 'sr-only' },
            (0, _I18n2.default)('booking.time.labels.minutes')
        ),
        _react2.default.createElement(
            _FormControl2.default,
            {
                componentClass: 'select',
                disabled: disabled,
                name: 'minutes',
                id: uniqueId,
                className: 'minutes__form-control',
                value: roundMinutes(minute, minuteStep),
                onChange: changeHandler(onChange)
            },
            minutes(minuteStep).map(function (num) {
                return _react2.default.createElement(
                    'option',
                    {
                        key: num,
                        value: num,
                        disabled: num > max || num < min
                    },
                    (0, _lpad2.default)(num, 2, "0")
                );
            })
        )
    );
}

MinuteSelector.propTypes = {
    minute: _propTypes2.default.number,
    minuteStep: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    min: _propTypes2.default.number,
    max: _propTypes2.default.number
};

MinuteSelector.defaultProps = {
    minute: 0,
    minuteStep: DEFAULT_STEP,
    onChange: _noop3.default,
    disabled: false,
    min: 0,
    max: 59
};

exports.default = MinuteSelector;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _I18n = __webpack_require__(9);

var _Fares = __webpack_require__(427);

var _TicketDetails = __webpack_require__(1037);

var _TicketDetails2 = _interopRequireDefault(_TicketDetails);

var _FareRefundsInfo = __webpack_require__(1038);

var _FareRefundsInfo2 = _interopRequireDefault(_FareRefundsInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FarePassengers = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FarePassengers, _React$PureComponent);

    function FarePassengers(props) {
        (0, _classCallCheck3.default)(this, FarePassengers);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call(this, props));
    }

    FarePassengers.prototype._renderPassengerList = function _renderPassengerList() {
        var _this2 = this;

        return _react2.default.createElement(
            'ul',
            { className: 'fare__passengers' },
            (0, _Fares.getFoldedTickets)(this.props.orderFare.tickets, function (ticket) {
                return ticket.toComparable();
            }).map(function (ticket, index) {
                return _react2.default.createElement(_TicketDetails2.default, { key: index, ticket: ticket, fare: _this2.props.orderFare, isCarnet: _this2.props.orderFare.isCarnet(), isSmartCarnet: _this2.props.orderFare.isSmartCarnet() });
            })
        );
    };

    FarePassengers.prototype._renderPromoCode = function _renderPromoCode(promoCode) {
        var tickets = this.props.orderFare.tickets;

        var hasPromoDiscount = tickets.some(function (ticket) {
            return ticket.hasPromoDiscount();
        });

        if (!hasPromoDiscount) {
            return null;
        }

        return _react2.default.createElement(
            'div',
            { className: 'applied-code' },
            (0, _I18n.translate)('booking.promoCode.applied', {
                promoCode: promoCode
            })
        );
    };

    FarePassengers.prototype.render = function render() {
        var _props = this.props,
            orderFare = _props.orderFare,
            className = _props.className,
            isAmended = _props.isAmended,
            promoCode = _props.promoCode;

        var hasRailcards = orderFare.getRailcards().some(function (railcard) {
            return !railcard.isGroupSave();
        });
        var showRailcardsMessage = hasRailcards && !isAmended;

        return _react2.default.createElement(
            'div',
            { className: 'fare-passengers ' + className },
            this._renderPassengerList(),
            _react2.default.createElement(_FareRefundsInfo2.default, { fare: orderFare, small: true }),
            this._renderPromoCode(promoCode),
            showRailcardsMessage && _react2.default.createElement(
                'p',
                { className: 'text-secondary no-margin text-sm' },
                ' ',
                (0, _I18n.translate)('order.summary.bring_railcard')
            )
        );
    };

    return FarePassengers;
}(_react2.default.PureComponent), _class.propTypes = {
    orderFare: _propTypes2.default.instanceOf(_Fare2.default).isRequired,
    className: _propTypes2.default.string,
    isAmended: _propTypes2.default.bool,
    promoCode: _propTypes2.default.string
}, _class.defaultProps = {
    className: 'margin-bottom padding-bottom border-thick--bottom',
    isAmended: false
}, _temp);
exports.default = FarePassengers;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _PassengerInfo = __webpack_require__(464);

var _PassengerInfo2 = _interopRequireDefault(_PassengerInfo);

var _RailcardBadge = __webpack_require__(450);

var _RailcardBadge2 = _interopRequireDefault(_RailcardBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkedSmartcards = function LinkedSmartcards(_ref) {
    var isChild = _ref.isChild,
        linkedPassengers = _ref.linkedPassengers,
        tickets = _ref.tickets,
        showRailcardsMessage = _ref.showRailcardsMessage,
        hideISRN = _ref.hideISRN;

    var isMatchingTicket = function isMatchingTicket(ticket) {
        return ticket.adults > 0 && !isChild || ticket.children > 0 && isChild;
    };

    var getLinkedTicket = function getLinkedTicket(passenger) {
        return tickets.find(function (ticket) {
            return ticket.getSmartcardNumber() === passenger.associatedSmartcardNumber;
        });
    };

    return _react2.default.createElement(
        'div',
        { className: 'clearfix' },
        linkedPassengers.size > 0 ? linkedPassengers.map(function (smartcard) {
            var matchingTicket = getLinkedTicket(smartcard);
            return _react2.default.createElement(
                'div',
                { className: 'order-summary-narrow__fare__ticket' },
                _react2.default.createElement(
                    'div',
                    { className: 'order-summary-narrow__fare__price__linked-smartcard' },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            smartcard.getCustomerName && smartcard.getCustomerName()
                        ),
                        isChild && _react2.default.createElement(
                            'span',
                            { className: 'associated-smartcards__child-badge' },
                            ' ' + (0, _I18n2.default)('global.child') + ' '
                        )
                    ),
                    !hideISRN && _react2.default.createElement(
                        'span',
                        null,
                        '\xA0',
                        smartcard.associatedSmartcardNumber
                    )
                ),
                showRailcardsMessage && matchingTicket && matchingTicket.railcard && _react2.default.createElement(_RailcardBadge2.default, { railcard: matchingTicket.railcard })
            );
        }) : _react2.default.createElement(
            'div',
            { className: 'margin-bottom--xs' },
            tickets.filter(isMatchingTicket).map(function (ticket) {
                return _react2.default.createElement(
                    'div',
                    {
                        key: ticket.id,
                        className: 'order-summary-narrow__fare__ticket'
                    },
                    _react2.default.createElement(_PassengerInfo2.default, {
                        className: 'order-summary-narrow__fare__price__linked-smartcard',
                        hideISRN: hideISRN,
                        ticket: ticket
                    }),
                    showRailcardsMessage && ticket.railcard && _react2.default.createElement(_RailcardBadge2.default, { railcard: ticket.railcard })
                );
            })
        )
    );
};

LinkedSmartcards.propTypes = {
    isChild: _propTypes2.default.bool,
    hideISRN: _propTypes2.default.bool,
    showRailcardsMessage: _propTypes2.default.bool,
    linkedPassengers: _propTypes2.default.instanceOf(_immutable.List),
    tickets: _propTypes2.default.instanceOf(_immutable.List)
};

exports.default = LinkedSmartcards;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Collapse = __webpack_require__(347);

var _Collapse2 = _interopRequireDefault(_Collapse);

var _I18n = __webpack_require__(9);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _TicketRefundCalculation = __webpack_require__(836);

var _TicketRefundCalculation2 = _interopRequireDefault(_TicketRefundCalculation);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Ticket = __webpack_require__(239);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _TicketCalculationsSummaryHeader = __webpack_require__(2055);

var _TicketCalculationsSummaryHeader2 = _interopRequireDefault(_TicketCalculationsSummaryHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TicketCalculationsSummary = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(TicketCalculationsSummary, _React$PureComponent);

    function TicketCalculationsSummary() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TicketCalculationsSummary);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            showRefundDetail: false
        }, _this.showMoreDetails = function () {
            _this.setState({
                showRefundDetail: !_this.state.showRefundDetail
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    TicketCalculationsSummary.prototype.render = function render() {
        var showRefundDetail = this.state.showRefundDetail;
        var _props = this.props,
            storedRefundCalculation = _props.storedRefundCalculation,
            ticket = _props.ticket,
            refundDetails = _props.refundDetails,
            shouldUseCalculations = _props.shouldUseCalculations,
            hasSmartCarnetTrip = _props.hasSmartCarnetTrip;


        var calc = storedRefundCalculation && storedRefundCalculation.get('calculation');
        var initiatedBy = storedRefundCalculation && storedRefundCalculation.get('initiatedBy');

        if (!refundDetails || !ticket.isRefunded) {
            return null;
        }

        if (!calc || initiatedBy === _AppConstants.RefundCalculation.initiatedByCustomer) {
            return _react2.default.createElement(
                'div',
                { className: 'refund-ticket' },
                _react2.default.createElement(_TicketCalculationsSummaryHeader2.default, {
                    showRefundDetail: showRefundDetail,
                    storedRefundCalculation: storedRefundCalculation,
                    ticket: ticket,
                    onClick: this.showMoreDetails,
                    hasSmartCarnetTrip: hasSmartCarnetTrip
                }),
                _react2.default.createElement(
                    _Collapse2.default,
                    { 'in': showRefundDetail },
                    _react2.default.createElement(
                        'div',
                        { className: 'refund-ticket__body' },
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                (0, _I18n.translate)('account.orders.refund.initiatedBy')
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right' },
                                (0, _I18n.translate)('account.orders.refund.customer')
                            )
                        ),
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                (0, _I18n.translate)('order.summary.total_paid')
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right' },
                                _react2.default.createElement(_Price2.default, { price: ticket.price })
                            )
                        ),
                        _react2.default.createElement(
                            _Row2.default,
                            { className: 'text-weight--normal' },
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                (0, _I18n.translate)('account.orders.refund.itso.valueUsed'),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'sr-only' },
                                    '. '
                                )
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right price' },
                                _react2.default.createElement(_Price2.default, { price: calc && calc.totalUsed }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'sr-only' },
                                    '. '
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _Row2.default,
                            { className: 'text-weight--normal' },
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                (0, _I18n.translate)('account.orders.refund.ticketValue'),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'sr-only' },
                                    '. '
                                )
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right price' },
                                _react2.default.createElement(_Price2.default, { price: calc && calc.refundAmount }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'sr-only' },
                                    '. '
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 12 },
                                _react2.default.createElement('hr', { className: 'refund-ticket__body__divisor' })
                            )
                        ),
                        _react2.default.createElement(
                            _Row2.default,
                            { className: 'text-weight--bold' },
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                (0, _I18n.translate)('account.orders.refund.summary.totalRefunded')
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right' },
                                _react2.default.createElement(_Price2.default, { price: calc && calc.refundAmount })
                            )
                        )
                    )
                )
            );
        }

        return _react2.default.createElement(
            'div',
            { className: 'refund-ticket' },
            _react2.default.createElement(_TicketCalculationsSummaryHeader2.default, {
                showRefundDetail: showRefundDetail,
                storedRefundCalculation: storedRefundCalculation,
                ticket: ticket,
                onClick: this.showMoreDetails
            }),
            _react2.default.createElement(
                _Collapse2.default,
                { 'in': showRefundDetail },
                _react2.default.createElement(
                    'div',
                    { className: 'refund-ticket__body' },
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 8 },
                            (0, _I18n.translate)('account.orders.refund.initiatedBy')
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 4, className: 'text-right' },
                            (0, _I18n.translate)('account.orders.refund.customerService')
                        )
                    ),
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 8 },
                            (0, _I18n.translate)('order.summary.total_paid')
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 4, className: 'text-right' },
                            _react2.default.createElement(_Price2.default, { price: calc.originalAmount })
                        )
                    ),
                    shouldUseCalculations && _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 7 },
                            (0, _I18n.translate)('account.orders.refund.itso.valueUsed'),
                            _react2.default.createElement(
                                _FeatureFlag2.default,
                                { name: 'enableSeasonRefundsMoreInfo' },
                                _react2.default.createElement(
                                    'a',
                                    { target: '_blank', href: _config2.default.get('smartcardRefundInformationUrl') },
                                    _react2.default.createElement(_Icon2.default, { icon: 'info', className: 'margin-left--xs otrl-sm' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 5, className: 'text-right' },
                            calc.totalUsed > 0 && _react2.default.createElement(_FormattedHTMLMessage2.default, {
                                message: 'account.orders.refund.itso.deduction.amount',
                                amount: _react2.default.createElement(_Price2.default, { price: calc.totalUsed })
                            }),
                            calc.totalUsed === 0 && _react2.default.createElement(_Price2.default, { price: calc.totalUsed })
                        )
                    ),
                    !shouldUseCalculations && _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 7 },
                            (0, _I18n.translate)('account.orders.refund.dayticket.valueRefunded')
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 5, className: 'text-right' },
                            _react2.default.createElement(_Price2.default, { price: calc.refundAmount })
                        )
                    ),
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12 },
                            _react2.default.createElement('hr', { className: 'refund-ticket__body__divisor' })
                        )
                    ),
                    _react2.default.createElement(
                        _Row2.default,
                        { className: 'text-weight--bold' },
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 8 },
                            (0, _I18n.translate)('account.orders.refund.summary.totalRefunded')
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 4, className: 'text-right' },
                            _react2.default.createElement(_Price2.default, { price: calc.refundAmount })
                        )
                    )
                )
            )
        );
    };

    return TicketCalculationsSummary;
}(_react2.default.PureComponent), _class.propTypes = {
    storedRefundCalculation: _propTypes2.default.instanceOf(_TicketRefundCalculation2.default),
    ticket: _propTypes2.default.instanceOf(_Ticket2.default),
    refundDetails: _propTypes2.default.instanceOf(_Order2.default),
    shouldUseCalculations: _propTypes2.default.bool,
    isSmartcard: _propTypes2.default.bool,
    hasSmartCarnetTrip: _propTypes2.default.bool
}, _temp2);
exports.default = TicketCalculationsSummary;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = capitalize;

function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

module.exports = exports["default"];

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreenPlanetIcon = function GreenPlanetIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#75C043" }),
        _react2.default.createElement(
            "mask",
            { id: "mask0_764_8029", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24" },
            _react2.default.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "white" })
        ),
        _react2.default.createElement(
            "g",
            { mask: "url(#mask0_764_8029)" },
            _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.56237 -0.918977C3.76867 -1.01012 4.01059 -0.945356 4.14375 -0.763337C4.80394 0.139058 5.74123 1.63429 6.41832 3.20619C6.75703 3.99253 7.03651 4.81152 7.17992 5.59405C7.32248 6.37189 7.33741 7.1502 7.10857 7.83268C6.65108 9.19703 5.88213 9.80047 5.22911 10.3129L5.2238 10.3171C4.78746 10.6595 4.44487 10.934 4.19086 11.3618C3.94136 11.7821 3.75351 12.3967 3.75351 13.4401C3.75351 14.2835 4.04145 14.7897 4.44621 15.1577C4.8807 15.5527 5.467 15.8074 6.12722 16.0884C6.14176 16.0946 6.15637 16.1008 6.17102 16.107C6.75852 16.3569 7.42722 16.6412 7.90603 17.0973C8.44097 17.6067 8.71624 18.3004 8.57714 19.2684C8.50679 19.7579 8.45708 20.347 8.40302 20.9899L8.40193 21.0029C8.32702 21.8937 8.24409 22.8799 8.08359 23.7583C7.92576 24.622 7.67849 25.475 7.21762 26.0308C6.9766 26.3215 6.66461 26.5463 6.27028 26.6325C5.87988 26.7179 5.46393 26.6555 5.03324 26.4748C4.19179 26.1219 3.18408 25.2714 1.94428 23.8335C-1.03257 20.3811 -2.88 15.2279 -2.88 10.4401C-2.88 5.64834 -1.01899 1.10516 3.56237 -0.918977ZM21.565 0.483458C21.6906 0.468473 21.8171 0.503687 21.9169 0.581443C25.3382 3.2472 27.1284 5.92351 27.6648 8.54364C28.2027 11.171 27.4622 13.6545 26.0029 15.8915C23.1063 20.3318 17.2976 23.9303 12.4534 26.1015C11.7929 26.4462 11.1779 26.6972 10.6587 26.8585C10.4124 26.935 10.1497 26.8032 10.0637 26.5601C9.97777 26.3169 10.0993 26.0493 10.3389 25.954C10.8862 25.7364 11.4536 25.4972 12.0343 25.2373C14.6709 23.8539 18.132 20.845 18.7309 15.7837C18.8534 14.7487 18.9113 13.9941 18.9146 13.4462C18.918 12.8845 18.8625 12.5963 18.8009 12.4559C18.7743 12.3953 18.7546 12.3814 18.7546 12.3814C18.7546 12.3814 18.7514 12.379 18.7462 12.377C18.7405 12.3747 18.7291 12.371 18.7093 12.368C18.6019 12.3517 18.4434 12.3728 18.1324 12.4248L18.1133 12.428C17.5683 12.5192 16.7678 12.6532 15.8543 12.2828C14.9316 11.9088 13.9733 11.0574 12.9972 9.35929C12.1742 7.92746 12.0088 6.63586 12.3688 5.4996C12.7238 4.3793 13.5632 3.49429 14.5811 2.80638C16.6082 1.43641 19.5206 0.727331 21.565 0.483458ZM13.8891 18.0904C13.5652 18.2408 13.194 18.3201 12.8148 18.2259C12.5669 18.1643 12.3335 18.0558 12.1625 17.8683C11.9815 17.6699 11.9123 17.429 11.9197 17.1931C11.9328 16.772 12.189 16.3486 12.453 16.0041C13.0056 15.2831 13.9103 14.5118 14.5653 14.0225C14.9342 13.7179 15.2626 13.5047 15.5483 13.4164C15.6951 13.3711 15.8799 13.3432 16.068 13.4018C16.2772 13.4671 16.4185 13.6167 16.4933 13.7867C16.5608 13.9399 16.572 14.1008 16.5663 14.2331C16.5605 14.3706 16.5345 14.5143 16.4979 14.6556C16.4246 14.9383 16.2966 15.256 16.1358 15.5757C15.8149 16.2137 15.3323 16.9207 14.7877 17.4456C14.5153 17.7082 14.2116 17.9406 13.8891 18.0904Z", fill: "#32AE57" })
        )
    );
};

exports.default = GreenPlanetIcon;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(2065);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _class, _temp2;

var _immutable = __webpack_require__(5);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _AppConstants = __webpack_require__(6);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _I18n = __webpack_require__(9);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _FareStations = __webpack_require__(282);

var _FareStations2 = _interopRequireDefault(_FareStations);

var _RemoveJourneyModal = __webpack_require__(635);

var _RemoveJourneyModal2 = _interopRequireDefault(_RemoveJourneyModal);

var _FareValidity = __webpack_require__(414);

var _FareValidity2 = _interopRequireDefault(_FareValidity);

var _AddFavouriteLink = __webpack_require__(614);

var _AddFavouriteLink2 = _interopRequireDefault(_AddFavouriteLink);

var _CreateAlert = __webpack_require__(632);

var _CreateAlert2 = _interopRequireDefault(_CreateAlert);

var _TicketCalculationsSummary = __webpack_require__(940);

var _TicketCalculationsSummary2 = _interopRequireDefault(_TicketCalculationsSummary);

var _LinkingSmartcardsStore = __webpack_require__(348);

var _LinkingSmartcardsStore2 = _interopRequireDefault(_LinkingSmartcardsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _LinkedSmartcards = __webpack_require__(939);

var _LinkedSmartcards2 = _interopRequireDefault(_LinkedSmartcards);

var _Fares = __webpack_require__(427);

var _RailcardBadge = __webpack_require__(450);

var _RailcardBadge2 = _interopRequireDefault(_RailcardBadge);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _RewardPointsEarned = __webpack_require__(682);

var _RewardPointsEarned2 = _interopRequireDefault(_RewardPointsEarned);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStateFromStores = function getStateFromStores(_ref) {
    var orderTrip = _ref.orderTrip;

    return {
        enableSmartcardAssociations: _FeatureFlagStore2.default.get('enableSmartcardAssociations'),
        linkedAdults: _LinkingSmartcardsStore2.default.getAdultsLinkedSmartcardsForFare(orderTrip.getSeasonFare().tickets.map(function (ticket) {
            return ticket.id;
        })),
        linkedChildren: _LinkingSmartcardsStore2.default.getChildrenLinkedSmartcardsForFare(orderTrip.getSeasonFare().tickets.map(function (ticket) {
            return ticket.id;
        }))
    };
};

var SeasonTrip = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(SeasonTrip, _React$PureComponent);

    function SeasonTrip() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SeasonTrip);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            open: _this.props.open,
            journeyToRemove: null
        }, _this._handleRemoveJourney = function (journey) {
            return function () {
                _this.setState({ journeyToRemove: journey });
            };
        }, _this._handleRemoveJourneyBack = function () {
            _this.setState({ journeyToRemove: null });
        }, _this._handleRemoveJourneyConfirm = function () {
            _OrderActions2.default.deleteTrip(_this.props.order, _this.props.orderTrip);
            _this.setState({ journeyToRemove: null });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    SeasonTrip.prototype._renderRemoveConfirm = function _renderRemoveConfirm() {
        var _this2 = this;

        if (this.state.journeyToRemove) {
            return _react2.default.createElement(_RemoveJourneyModal2.default, {
                journey: this.state.journeyToRemove,
                onBack: this._handleRemoveJourneyBack,
                onConfirm: function onConfirm() {
                    _this2._handleRemoveJourneyConfirm();
                    _this2.props.setBasketChanged();
                }
            });
        }

        return null;
    };

    SeasonTrip.prototype._renderRemoveJourney = function _renderRemoveJourney() {
        if (!this.props.order.isPaid()) {
            return _react2.default.createElement(
                _Button2.default,
                { className: 'journey-remove hidden-print btn-plain pull-right', onClick: this._handleRemoveJourney(this.props.orderTrip) },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('order.summary.removeJourney')
                ),
                _react2.default.createElement(_Icon2.default, { icon: 'bin' })
            );
        }

        return null;
    };

    SeasonTrip.prototype.renderFavourite = function renderFavourite() {
        var fare = this.getFare();
        var _props = this.props,
            orderTrip = _props.orderTrip,
            delivery = _props.order.delivery;


        if (fare && !fare.isExcludedFromFavourites()) {
            return _react2.default.createElement(_AddFavouriteLink2.default, {
                buttonProps: {
                    className: "pull-right margin-top--sm margin-left--sm"
                },
                fare: fare,
                orderTrip: orderTrip,
                delivery: delivery,
                context: fare.isFlexi() ? "flexi-checkout" : "season-checkout"
            });
        }

        return null;
    };

    SeasonTrip.prototype.renderCreateAlert = function renderCreateAlert() {
        var _props2 = this.props,
            order = _props2.order,
            orderTrip = _props2.orderTrip;


        return _react2.default.createElement(_CreateAlert2.default, {
            buttonProps: {
                className: "pull-right margin-top--sm"
            },
            order: order,
            orderTrip: orderTrip,
            context: 'point-checkout'
        });
    };

    SeasonTrip.prototype.renderTripActions = function renderTripActions() {
        var isLoggedIn = this.props.isLoggedIn;


        return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12, className: 'fare-actions pull-right' },
                isLoggedIn && this.renderFavourite(),
                isLoggedIn && this.props.open && this.renderCreateAlert()
            )
        );
    };

    SeasonTrip.prototype.getCalculation = function getCalculation(ticket) {
        var storedRefundCalculations = this.props.storedRefundCalculations;


        if (!ticket || !storedRefundCalculations || storedRefundCalculations.size === 0) {
            return null;
        }

        return storedRefundCalculations.tickets.find(function (c) {
            return c.getIn(['calculation', 'ticketId']) === ticket.id && c.getIn(['calculation', 'refundAmount']) > 0;
        });
    };

    SeasonTrip.prototype.renderRefundCalculations = function renderRefundCalculations(orderFare, tripTitle) {
        var _this3 = this;

        var _props3 = this.props,
            refundDetails = _props3.refundDetails,
            order = _props3.order,
            context = _props3.context;

        var RefundTitleTag = context === _AppConstants.OrderSummaryContexts.BASKET_MODAL ? 'h3' : 'h4';

        return _react2.default.createElement(
            'div',
            { className: 'margin-top border--top' },
            _react2.default.createElement(
                RefundTitleTag,
                { className: 'margin-top--sm margin-bottom--sm text-weight--bold' },
                (0, _I18n.translate)('account.orders.refund.tickets')
            ),
            orderFare.tickets.map(function (ticket, index) {
                return _react2.default.createElement(_TicketCalculationsSummary2.default, {
                    hasSmartCarnetTrip: order.hasSmartCarnetTrip(),
                    key: index,
                    refundDetails: refundDetails,
                    storedRefundCalculation: _this3.getCalculation(ticket),
                    ticket: ticket,
                    shouldUseCalculations: (0, _get3.default)(ticket, 'railcard.code') !== 'TSU',
                    tripTitle: tripTitle,
                    isSmartcard: order.isSmartcard()
                });
            })
        );
    };

    SeasonTrip.prototype.getFare = function getFare() {
        var _props4 = this.props,
            isFareOnly = _props4.isFareOnly,
            orderTrip = _props4.orderTrip;

        return isFareOnly ? orderTrip.getFareOnlyFare() : orderTrip.getSeasonFare();
    };

    SeasonTrip.prototype.render = function render() {
        var _props5 = this.props,
            orderTrip = _props5.orderTrip,
            index = _props5.index,
            order = _props5.order,
            enableSmartcardAssociations = _props5.enableSmartcardAssociations,
            linkedAdults = _props5.linkedAdults,
            linkedChildren = _props5.linkedChildren,
            context = _props5.context;


        var titleKey = orderTrip.isSmartcard() ? 'smartcard_title' : 'journey_title';
        var tripTitle = (0, _I18n.translate)('order.summary.' + titleKey, { number: index + 1 });
        var TripTitleTag = context === _AppConstants.OrderSummaryContexts.BASKET_MODAL ? 'h2' : 'h3';

        var orderFare = this.getFare();
        var tickets = (0, _Fares.getFoldedTickets)(orderFare.tickets);
        var rewardPoints = orderFare.tickets.reduce(function (sum, ticket) {
            return sum + ticket.rewardPoints;
        }, 0);

        var activeRailcardCode = null;

        if (orderTrip.hasJCPRailcard()) {
            activeRailcardCode = 'JCP';
        } else if (orderTrip.has1617Railcard()) {
            activeRailcardCode = 'TSU';
        }

        var railcardName = (0, _I18n.translate)('booking.railcard.' + activeRailcardCode);

        return _react2.default.createElement(
            'li',
            { className: 'order-summary__item margin-bottom order-summary__item--expanded' },
            this._renderRemoveConfirm(),
            _react2.default.createElement(
                'div',
                { className: 'box-headed box-headed--primary' },
                _react2.default.createElement(
                    'div',
                    { className: 'box-headed__header box--padded text-weight--normal' },
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 8 },
                            _react2.default.createElement(
                                TripTitleTag,
                                { className: 'journey-heading text-weight--normal' },
                                tripTitle
                            )
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 4, className: 'text-right price' },
                            _react2.default.createElement(_Price2.default, { price: orderTrip.getTotalPrice() })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'box-headed__body box--padded' },
                    _react2.default.createElement(
                        _Row2.default,
                        { className: 'fare-summary' },
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, md: 6 },
                            _react2.default.createElement(_FareStations2.default, {
                                origin: orderFare.origin,
                                destination: orderFare.destination
                            })
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, md: 6, lg: 6, className: 'text-weight--normal ticket-type' },
                            orderFare.getName()
                        )
                    ),
                    orderFare.tickets.every(function (ticket) {
                        return ticket.isRefunded;
                    }) && _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, md: 6, className: 'refunded pull-right' },
                            _react2.default.createElement(
                                'span',
                                { className: 'alert-success text-light pull-right' },
                                (0, _I18n.translate)('account.orders.refund.ticket.refunded')
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        activeRailcardCode && _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, sm: 10 },
                            _react2.default.createElement(
                                'p',
                                { className: 'text-primary text-sm' },
                                ' ',
                                (0, _I18n.translate)('account.orders.railcards', { railcardName: railcardName })
                            )
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, sm: 8 },
                            _react2.default.createElement(_FareValidity2.default, {
                                from: orderFare.outwardJourney.validFrom,
                                to: orderFare.outwardJourney.validTo
                            })
                        ),
                        !enableSmartcardAssociations && tickets.first().railcard && _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, sm: 4 },
                            _react2.default.createElement(
                                'div',
                                { className: 'pull-right' },
                                _react2.default.createElement(_RailcardBadge2.default, { railcard: tickets.first().railcard })
                            )
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, sm: 4 },
                            this._renderRemoveJourney()
                        )
                    ),
                    enableSmartcardAssociations && tickets.first().adults > 0 && _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, className: 'order-summary__item' },
                            _react2.default.createElement(_LinkedSmartcards2.default, { linkedPassengers: linkedAdults, tickets: tickets, showRailcardsMessage: true })
                        )
                    ),
                    enableSmartcardAssociations && tickets.first().children > 0 && _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12, className: 'order-summary__item' },
                            _react2.default.createElement(_LinkedSmartcards2.default, { linkedPassengers: linkedChildren, tickets: tickets, isChild: true, showRailcardsMessage: true })
                        )
                    ),
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableRewardPoints' },
                        _react2.default.createElement(_RewardPointsEarned2.default, { rewardPoints: rewardPoints, className: 'reward-points__earned pull-right' })
                    ),
                    this.renderTripActions(),
                    order.hasRefunds() && orderFare.tickets.some(function (ticket) {
                        return ticket.isRefunded;
                    }) && this.renderRefundCalculations(orderFare, tripTitle)
                )
            )
        );
    };

    return SeasonTrip;
}(_react2.default.PureComponent), _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    refundDetails: _propTypes2.default.instanceOf(_Order2.default),
    storedRefundCalculations: _propTypes2.default.instanceOf(_immutable.List),
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    open: _propTypes2.default.bool,
    isLoggedIn: _propTypes2.default.bool,
    isFareOnly: _propTypes2.default.bool,
    linkedAdults: _propTypes2.default.instanceOf(_immutable.List),
    linkedChildren: _propTypes2.default.instanceOf(_immutable.List),
    enableSmartcardAssociations: _propTypes2.default.bool,
    context: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.OrderSummaryContexts)),
    setBasketChanged: _propTypes2.default.func
}, _class.defaultProps = {
    open: false,
    isLoggedIn: false,
    isFareOnly: false,
    context: null,
    setBasketChanged: _noop3.default
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default, _SmartcardStore2.default, _LinkingSmartcardsStore2.default], getStateFromStores)(SeasonTrip);

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _uncontrollable = _interopRequireDefault(__webpack_require__(106));

var _bootstrapUtils = __webpack_require__(21);

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var _PropTypes = __webpack_require__(946);

var propTypes = {
  accordion: _propTypes.default.bool,

  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: _propTypes.default.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: _propTypes.default.func,

  /**
   * An HTML role attribute
   */
  role: _propTypes.default.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: _propTypes.default.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: (0, _PropTypes.generatedId)('PanelGroup')
};
var defaultProps = {
  accordion: false
};
var childContextTypes = {
  $bs_panelGroup: _propTypes.default.shape({
    getId: _propTypes.default.func,
    headerRole: _propTypes.default.string,
    panelRole: _propTypes.default.string,
    activeKey: _propTypes.default.any,
    onToggle: _propTypes.default.func
  })
};

var PanelGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelGroup, _React$Component);

  function PanelGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    };

    return _this;
  }

  var _proto = PanelGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        accordion = _this$props.accordion,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;
    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + "-" + type + "-" + key : null;
      };
    }

    return {
      $bs_panelGroup: (0, _extends2.default)({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        accordion = _this$props2.accordion,
        className = _this$props2.className,
        children = _this$props2.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["accordion", "className", "children"]);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), _ValidComponentChildren.default.map(children, function (child) {
      return (0, _react.cloneElement)(child, {
        bsStyle: child.props.bsStyle || bsProps.bsStyle
      });
    }));
  };

  return PanelGroup;
}(_react.default.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;

var _default = (0, _uncontrollable.default)((0, _bootstrapUtils.bsClass)('panel-group', PanelGroup), {
  activeKey: 'onSelect'
});

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.generatedId = generatedId;
exports.requiredRoles = requiredRoles;
exports.exclusiveRoles = exclusiveRoles;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _createChainableTypeChecker = _interopRequireDefault(__webpack_require__(324));

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var idPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);

function generatedId(name) {
  return function (props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
      }
    }

    return error;
  };
}

function requiredRoles() {
  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
    var missing;
    roles.every(function (role) {
      if (!_ValidComponentChildren.default.some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return (0, _createChainableTypeChecker.default)(function (props, propName, component) {
    var duplicate;
    roles.every(function (role) {
      var childrenWithRole = _ValidComponentChildren.default.filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: _propTypes.default.bool,

  /**
   * `href` attribute for the inner `a` element
   */
  href: _propTypes.default.string,

  /**
   * `title` attribute for the inner `a` element
   */
  title: _propTypes.default.node,

  /**
   * `target` attribute for the inner `a` element
   */
  target: _propTypes.default.string
};
var defaultProps = {
  active: false
};

var BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        href = _this$props.href,
        title = _this$props.title,
        target = _this$props.target,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.

    var linkProps = {
      href: href,
      title: title,
      target: target
    };
    return _react.default.createElement("li", {
      className: (0, _classnames.default)(className, {
        active: active
      })
    }, active ? _react.default.createElement("span", props) : _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, linkProps)));
  };

  return BreadcrumbItem;
}(_react.default.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
var _default = BreadcrumbItem;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _transition = _interopRequireDefault(__webpack_require__(909));

var propTypes = {
  direction: _propTypes.default.oneOf(['prev', 'next']),
  onAnimateOutEnd: _propTypes.default.func,
  active: _propTypes.default.bool,
  animateIn: _propTypes.default.bool,
  animateOut: _propTypes.default.bool,
  index: _propTypes.default.number
};
var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({
        direction: null
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;
    var prevActive = prevProps.active;

    if (!active && prevActive) {
      _transition.default.end(_reactDom.default.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  _proto.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        direction = _this$props.direction,
        active = _this$props.active,
        animateIn = _this$props.animateIn,
        animateOut = _this$props.animateOut,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["direction", "active", "animateIn", "animateOut", "className"]);
    delete props.onAnimateOutEnd;
    delete props.index;
    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };

    if (direction && active && animateIn) {
      classes[direction] = true;
    }

    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return CarouselItem;
}(_react.default.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;
var _default = CarouselItem;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _Button = _interopRequireDefault(__webpack_require__(45));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  noCaret: _propTypes.default.bool,
  open: _propTypes.default.bool,
  title: _propTypes.default.string,
  useAnchor: _propTypes.default.bool
};
var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);

  function DropdownToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        noCaret = _this$props.noCaret,
        open = _this$props.open,
        useAnchor = _this$props.useAnchor,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);
    delete props.bsRole;
    var Component = useAnchor ? _SafeAnchor.default : _Button.default;
    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.
    // FIXME: Should this really fall back to `title` as children?

    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      role: "button",
      className: (0, _classnames.default)(className, bsClass),
      "aria-haspopup": true,
      "aria-expanded": open
    }), children || props.title, useCaret && ' ', useCaret && _react.default.createElement("span", {
      className: "caret"
    }));
  };

  return DropdownToggle;
}(_react.default.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _values = _interopRequireDefault(__webpack_require__(125));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var propTypes = {
  active: _propTypes.default.any,
  disabled: _propTypes.default.any,
  header: _propTypes.default.node,
  listItem: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  href: _propTypes.default.string,
  type: _propTypes.default.string
};
var defaultProps = {
  listItem: false
};

var ListGroupItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ListGroupItem, _React$Component);

  function ListGroupItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroupItem.prototype;

  _proto.renderHeader = function renderHeader(header, headingClassName) {
    if (_react.default.isValidElement(header)) {
      return (0, _react.cloneElement)(header, {
        className: (0, _classnames.default)(header.props.className, headingClassName)
      });
    }

    return _react.default.createElement("h4", {
      className: headingClassName
    }, header);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        className = _this$props.className,
        header = _this$props.header,
        listItem = _this$props.listItem,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "disabled", "className", "header", "listItem", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      active: active,
      disabled: disabled
    });
    var Component;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = (0, _classnames.default)(className, classes); // TODO: Deprecate `header` prop.

    if (header) {
      return _react.default.createElement(Component, elementProps, this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')), _react.default.createElement("p", {
        className: (0, _bootstrapUtils.prefix)(bsProps, 'text')
      }, children));
    }

    return _react.default.createElement(Component, elementProps, children);
  };

  return ListGroupItem;
}(_react.default.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), ListGroupItem));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var contextTypes = {
  $bs_navbar: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};

var NavbarBrand =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(NavbarBrand, _React$Component);

  function NavbarBrand() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarBrand.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');

    if (_react.default.isValidElement(children)) {
      return _react.default.cloneElement(children, {
        className: (0, _classnames.default)(children.props.className, className, bsClassName)
      });
    }

    return _react.default.createElement("span", (0, _extends2.default)({}, props, {
      className: (0, _classnames.default)(className, bsClassName)
    }), children);
  };

  return NavbarBrand;
}(_react.default.Component);

NavbarBrand.contextTypes = contextTypes;
var _default = NavbarBrand;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Overlay = _interopRequireDefault(__webpack_require__(913));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _Fade = _interopRequireDefault(__webpack_require__(405));

var propTypes = (0, _extends2.default)({}, _Overlay.default.propTypes, {
  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes.default.bool,

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: _propTypes.default.bool,

  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: _propTypes.default.func,

  /**
   * Use animation
   */
  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes.default.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left'])
});
var defaultProps = {
  animation: _Fade.default,
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Overlay, _React$Component);

  function Overlay() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overlay.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        animation = _this$props.animation,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["animation", "children"]);
    var transition = animation === true ? _Fade.default : animation || null;
    var child;

    if (!transition) {
      child = (0, _react.cloneElement)(children, {
        className: (0, _classnames.default)(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return _react.default.createElement(_Overlay.default, (0, _extends2.default)({}, props, {
      transition: transition
    }), child);
  };

  return Overlay;
}(_react.default.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
var _default = Overlay;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var propTypes = {
  disabled: _propTypes.default.bool,
  previous: _propTypes.default.bool,
  next: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  eventKey: _propTypes.default.any
};
var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PagerItem, _React$Component);

  function PagerItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = PagerItem.prototype;

  _proto.handleSelect = function handleSelect(e) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        previous = _this$props2.previous,
        next = _this$props2.next,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["disabled", "previous", "next", "onClick", "className", "style"]);
    delete props.onSelect;
    delete props.eventKey;
    return _react.default.createElement("li", {
      className: (0, _classnames.default)(className, {
        disabled: disabled,
        previous: previous,
        next: next
      }),
      style: style
    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
      disabled: disabled,
      onClick: (0, _createChainedFunction.default)(onClick, this.handleSelect)
    })));
  };

  return PagerItem;
}(_react.default.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;
var _default = PagerItem;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var _Collapse = _interopRequireDefault(__webpack_require__(347));

var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: _propTypes.default.func
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    headingId: _propTypes.default.string,
    bodyId: _propTypes.default.string,
    bsClass: _propTypes.default.string,
    expanded: _propTypes.default.bool
  })
};

var PanelCollapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelCollapse, _React$Component);

  function PanelCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelCollapse.prototype;

  _proto.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
      in: expanded
    }, props), _react.default.createElement("div", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse')
    }, children));
  };

  return PanelCollapse;
}(_react.default.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelCollapse);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _elementType = _interopRequireDefault(__webpack_require__(268));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: _propTypes.default.func,

  /**
   * You can use a custom element for this component
   */
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: _SafeAnchor.default
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bodyId: _propTypes.default.string,
    onToggle: _propTypes.default.func,
    expanded: _propTypes.default.bool
  })
};

var PanelToggle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelToggle, _React$Component);

  function PanelToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = PanelToggle.prototype;

  _proto.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        componentClass = _this$props.componentClass,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onClick", "className", "componentClass"]);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;
    props.onClick = (0, _createChainedFunction.default)(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = (0, _classnames.default)(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return _react.default.createElement(Component, props);
  };

  return PanelToggle;
}(_react.default.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;
var _default = PanelToggle;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _Fade = _interopRequireDefault(__webpack_require__(405));

var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: _propTypes.default.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),

  /** @private * */
  id: _propTypes.default.string,

  /** @private * */
  'aria-labelledby': _propTypes.default.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: _propTypes.default.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: _propTypes.default.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: _propTypes.default.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: _propTypes.default.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: _propTypes.default.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: _propTypes.default.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: _propTypes.default.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: _propTypes.default.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: _propTypes.default.bool
};
var contextTypes = {
  $bs_tabContainer: _propTypes.default.shape({
    getTabId: _propTypes.default.func,
    getPaneId: _propTypes.default.func
  }),
  $bs_tabContent: _propTypes.default.shape({
    bsClass: _propTypes.default.string,
    animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
    activeKey: _propTypes.default.any,
    mountOnEnter: _propTypes.default.bool,
    unmountOnExit: _propTypes.default.bool,
    onPaneEnter: _propTypes.default.func.isRequired,
    onPaneExited: _propTypes.default.func.isRequired,
    exiting: _propTypes.default.bool.isRequired
  })
};
/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */

var childContextTypes = {
  $bs_tabContainer: _propTypes.default.oneOf([null])
};

var TabPane =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(TabPane, _React$Component);

  function TabPane(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEnter = _this.handleEnter.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleExited = _this.handleExited.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.in = false;
    return _this;
  }

  var _proto = TabPane.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  _proto.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  _proto.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  _proto.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  _proto.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;
    return this.props.eventKey === activeKey;
  };

  _proto.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        className = _this$props.className,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        onExited = _this$props.onExited,
        propsMountOnEnter = _this$props.mountOnEnter,
        propsUnmountOnExit = _this$props.unmountOnExit,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);
    var _this$context = this.context,
        tabContent = _this$context.$bs_tabContent,
        tabContainer = _this$context.$bs_tabContainer;

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();
    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? _Fade.default : animation || null;

    if (tabContent) {
      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
    }

    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? (0, _warning.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      role: "tabpanel",
      "aria-hidden": !active,
      className: (0, _classnames.default)(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;
      return _react.default.createElement(Transition, {
        in: active && !exiting,
        onEnter: (0, _createChainedFunction.default)(this.handleEnter, onEnter),
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: (0, _createChainedFunction.default)(this.handleExited, onExited),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
      }, pane);
    }

    return pane;
  };

  return TabPane;
}(_react.default.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;

var _default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 957 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

var _JourneyPlanService = __webpack_require__(272);

var _JourneyPlanService2 = _interopRequireDefault(_JourneyPlanService);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromoCodeActions = {
    apply: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(promoCode) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                promoCode: promoCode,
                                actionType: _AppConstants.ActionTypes.PROMOCODE_APPLIED
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function apply(_x) {
            return _ref.apply(this, arguments);
        }

        return apply;
    }(),
    validatePromoCode: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(promoCode) {
            var user, promoProps, _ref3, result, errors;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            promoProps = {};

                            if (!(promoCode.length > 20)) {
                                _context2.next = 5;
                                break;
                            }

                            promoProps.validationError = (0, _I18n2.default)('booking.promoCode.char.limit.error');
                            return _context2.abrupt('return', new _PromoCode2.default(promoProps));

                        case 5:
                            _context2.prev = 5;
                            _context2.next = 8;
                            return _JourneyPlanService2.default.validatePromoCode(user.id, promoCode);

                        case 8:
                            _ref3 = _context2.sent;
                            result = _ref3.result;
                            errors = _ref3.errors;


                            if (errors) {
                                promoProps.validationError = errors[0].message;
                            }

                            if (result) {
                                promoProps.promoCode = result.promoCode;
                                promoProps.terms = result.limitationsCopy;
                            }
                            _context2.next = 18;
                            break;

                        case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2['catch'](5);

                            promoProps.validationError = (0, _I18n2.default)('booking.promoCode.generic.error');

                        case 18:
                            return _context2.abrupt('return', new _PromoCode2.default(promoProps));

                        case 19:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[5, 15]]);
        }));

        function validatePromoCode(_x2) {
            return _ref2.apply(this, arguments);
        }

        return validatePromoCode;
    }()
};

exports.default = PromoCodeActions;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PhoneNumber(props) {

    return _react2.default.createElement(
        'div',
        { className: 'phone-number' },
        _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, props, {
            type: 'tel',
            id: 'contactPhoneNumber',
            field: props.field,
            label: (0, _I18n.translate)('customerdetails.telephone'),
            placeholder: props.placeholder,
            labelClassName: 'sr-only'
        }))
    );
}

PhoneNumber.propTypes = (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'field', 'onChange', 'disabled', 'required', 'visited', 'validation', 'placeholder']);

PhoneNumber.defaultProps = {
    field: 'phone',
    placeholder: (0, _I18n.translate)('customerdetails.telephone')
};

exports.default = PhoneNumber;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _TokenActions = __webpack_require__(446);

var _TokenActions2 = _interopRequireDefault(_TokenActions);

var _AppNotifyService = __webpack_require__(1848);

var _AppNotifyService2 = _interopRequireDefault(_AppNotifyService);

var _LayoutActions = __webpack_require__(962);

var _LayoutActions2 = _interopRequireDefault(_LayoutActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InAppActions = {
    startSession: function startSession() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            deviceToken = _ref.deviceToken,
            appVersion = _ref.appVersion,
            channel = _ref.channel,
            disableAutoLogout = _ref.disableAutoLogout,
            disableAccountNavigationLogout = _ref.disableAccountNavigationLogout;

        _AppDispatcher2.default.dispatch({
            appVersion: appVersion,
            channel: channel,
            disableAutoLogout: disableAutoLogout,
            disableAccountNavigationLogout: disableAccountNavigationLogout,
            actionType: _AppConstants.ActionTypes.IN_APP_SESSION_STARTED
        });
        _LayoutActions2.default.setEmbedded(true);
        _TokenActions2.default.updateDevice(deviceToken);
    },
    notifyNavbar: function notifyNavbar(title, goBack) {
        return _AppNotifyService2.default.notify('navbar', { title: title, goBack: goBack });
    },
    notifyOrderComplete: function notifyOrderComplete() {
        return _AppNotifyService2.default.notify('order-complete');
    },
    reorderTrip: function reorderTrip(params) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.MOBILE_APP_RE_ORDER,
            params: params
        });
    },
    trigerMobileAppRating: function trigerMobileAppRating() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.MOBILE_APP_RATING_TRIGGERED
        });
    },
    setIsInApp: function setIsInApp(value) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_IN_APP,
            value: value
        });
    }
};

exports.default = InAppActions;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    isBankable: null,
    requiresAccount: null,
    countries: null,
    isOtherType: null,
    message: null,
    disabled: false
};

var DelayRepayPaymentMethod = function (_record) {
    (0, _inherits3.default)(DelayRepayPaymentMethod, _record);

    function DelayRepayPaymentMethod() {
        (0, _classCallCheck3.default)(this, DelayRepayPaymentMethod);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DelayRepayPaymentMethod.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DelayRepayPaymentMethod, json, {
            id: _LinkMapper.fields.string,
            isBankable: _LinkMapper.fields.bool,
            requiresAccount: _LinkMapper.fields.bool,
            countries: _LinkMapper.resolveAll.with(String),
            isOtherType: _LinkMapper.fields.bool,
            message: _LinkMapper.fields.string,
            disabled: _LinkMapper.fields.bool
        });
    };

    DelayRepayPaymentMethod.prototype.isAllowedForCustomer = function isAllowedForCustomer(customer) {
        if (this.countries && !this.countries.isEmpty()) {
            var country = customer.address.country;
            return this.countries.includes(country);
        }
        return true;
    };

    return DelayRepayPaymentMethod;
}((0, _immutable.Record)(defaults));

exports.default = DelayRepayPaymentMethod;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayoutActions = {
    setEmbedded: function setEmbedded(isEmbedded) {
        if (!window.ReactNativeWebView) {
            _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.LAYOUT_SET_EMBEDDED,
                isEmbedded: false
            });
        } else {
            _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.LAYOUT_SET_EMBEDDED,
                isEmbedded: isEmbedded
            });
        }
    }
};

exports.default = LayoutActions;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.TutorialStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultTutorialState = new _immutable.Record({
    tutorials: _config2.default.get('tutorials'),
    dismissed: new _immutable.List()
});

var TutorialStore = exports.TutorialStore = function (_BaseStore) {
    (0, _inherits3.default)(TutorialStore, _BaseStore);

    function TutorialStore() {
        (0, _classCallCheck3.default)(this, TutorialStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    TutorialStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.TUTORIAL_TOGGLE] = this.handleTutorialToggle, _ref;
    };

    TutorialStore.prototype.validateStoredData = function validateStoredData(_ref2) {
        var data = _ref2.data;

        return Array.isArray(data.dismissed);
    };

    TutorialStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return new DefaultTutorialState({ dismissed: new _immutable.List(serialized.dismissed) });
        }
        return new DefaultTutorialState();
    };

    TutorialStore.prototype.serialize = function serialize() {
        return {
            dismissed: this.state.dismissed.toJS()
        };
    };

    TutorialStore.prototype.handleTutorialToggle = function handleTutorialToggle(_ref3) {
        var tutorialName = _ref3.tutorialName,
            open = _ref3.open,
            dismissed = _ref3.dismissed;

        if (!dismissed && !open) {
            this.setState(this.state.set('dismissed', this.state.dismissed.filterNot(function (name) {
                return name === tutorialName;
            })));
        } else if (dismissed && !open) {
            this.setState(this.state.set('dismissed', this.state.dismissed.push(tutorialName).toSet().toList()));
        }
    };

    TutorialStore.prototype.getTutorialByName = function getTutorialByName(tutorialName) {
        return this.state.get('tutorials').find(function (tutorial) {
            return tutorial.name === tutorialName;
        });
    };

    TutorialStore.prototype.isTutorialDismissed = function isTutorialDismissed(tutorialName) {
        return this.state.get('dismissed').includes(tutorialName);
    };

    return TutorialStore;
}(_BaseStore3.default);

var storeInstance = new TutorialStore({ storageKey: 'tutorial' });

exports.default = storeInstance;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Stage = undefined;

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _forOwn2 = __webpack_require__(1093);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stage = exports.Stage = function () {
    function Stage() {
        var _this = this;

        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3.default)(this, Stage);
        this.name = null;
        this.title = null;
        this.text = null;
        this.image = false;
        this.video = null;

        (0, _forOwn3.default)(this, function (value, key) {
            if (params[key]) {
                _this[key] = params[key];
            }
        });
    }

    Stage.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Stage(json);
    };

    return Stage;
}();

var defaults = {
    name: null,
    defaultOpen: true,
    currentIndex: 0,
    hideProgression: false,
    stages: []
};

var Tutorial = function (_record) {
    (0, _inherits3.default)(Tutorial, _record);

    function Tutorial() {
        (0, _classCallCheck3.default)(this, Tutorial);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Tutorial.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Tutorial, json, {
            name: _LinkMapper.fields.string,
            defaultOpen: _LinkMapper.fields.boolean,
            currentIndex: 0,
            hideProgression: _LinkMapper.fields.boolean,
            stages: _LinkMapper.resolveAll.as(Stage)
        });
    };

    Tutorial.prototype.hasNext = function hasNext() {
        return this.stages.count() && this.stages.count() > this.currentIndex + 1;
    };

    Tutorial.prototype.hasPrev = function hasPrev() {
        return this.stages.count() && this.currentIndex > 0;
    };

    Tutorial.prototype.goTo = function goTo(targetStageName) {
        var index = this.stages.findIndex(function (stage) {
            return stage.name === targetStageName;
        });
        if (index > -1) {
            return this.setCurrentStage(index);
        }
        return this;
    };

    Tutorial.prototype.getCurrentStage = function getCurrentStage() {
        return this.stages.get(this.currentIndex);
    };

    Tutorial.prototype.setCurrentStage = function setCurrentStage(stageIndex) {
        return this.set('currentIndex', stageIndex);
    };

    Tutorial.prototype.moveToNext = function moveToNext() {
        if (this.hasNext()) {
            return this.setCurrentStage(this.currentIndex + 1);
        }
        return this;
    };

    Tutorial.prototype.moveToPrev = function moveToPrev() {
        if (this.hasPrev()) {
            return this.setCurrentStage(this.currentIndex - 1);
        }
        return this;
    };

    Tutorial.prototype.stageCount = function stageCount() {
        return this.stages.count();
    };

    Tutorial.prototype.showToggle = function showToggle() {
        return this.defaultOpen;
    };

    return Tutorial;
}((0, _immutable.Record)(defaults));

exports.default = Tutorial;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

exports.default = PrefsTable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _CheckedMarketingOption = __webpack_require__(1992);

var _CheckedMarketingOption2 = _interopRequireDefault(_CheckedMarketingOption);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrefsTable(_ref) {
    var form = _ref.form,
        onChange = _ref.onChange,
        isOver16 = _ref.isOver16,
        enableEmailMarketing = _ref.enableEmailMarketing,
        enableSmsMarketing = _ref.enableSmsMarketing,
        hideAutoDrOption = _ref.hideAutoDrOption,
        isHalfOnState = _ref.isHalfOnState,
        isEmailProducts = _ref.isEmailProducts;

    var _useState = (0, _react.useState)(isHalfOnState),
        updatedHalfOnState = _useState[0],
        setUpdatedIsHalfOnState = _useState[1];

    var isSouthEastern = _config2.default.get('brand') === 'southeastern';

    var _handleTogglePreference = function _handleTogglePreference(field, value) {
        var preferences = form.set(field, value);
        var updatedPreferences = isSouthEastern ? preferences.set('emailProducts', preferences.emailPromotions) : preferences;

        if (field === 'emailPromotions' && isSouthEastern) {
            setUpdatedIsHalfOnState(false);
        }

        onChange('preferences', updatedPreferences);
    };

    var defaultProps = {
        enableEmailMarketing: enableEmailMarketing,
        enableSmsMarketing: enableSmsMarketing
    };

    var defaultMarketingProps = (0, _assign2.default)({}, defaultProps, {
        onChange: _handleTogglePreference,
        form: form
    });

    return _react2.default.createElement(
        'fieldset',
        { className: 'hidden-fieldset margin-bottom' },
        enableEmailMarketing && _react2.default.createElement(
            'legend',
            { className: 'checked-option__row checked-option__header' },
            (0, _I18n2.default)('account.details.emailMarketing')
        ),
        enableSmsMarketing && _react2.default.createElement(
            'legend',
            { className: 'checked-option__row checked-option__header' },
            (0, _I18n2.default)('account.details.smsMarketing')
        ),
        _react2.default.createElement(
            'ul',
            { className: 'margin-bottom--0' },
            _react2.default.createElement(_CheckedMarketingOption2.default, (0, _extends3.default)({}, defaultMarketingProps, {
                flag: 'enableServicePreference',
                helpIconFeatureFlag: 'enableServicePreferenceHelpIcon',
                emailField: 'emailServiceUpdates',
                smsField: 'smsServiceUpdates',
                text: (0, _I18n2.default)('preference-centre.service-updates'),
                helpModalText: (0, _I18n2.default)('preference-centre.service-updates.help')
            })),
            _react2.default.createElement(_CheckedMarketingOption2.default, (0, _extends3.default)({}, defaultMarketingProps, {
                flag: 'enablePromotionsPreference',
                helpIconFeatureFlag: 'enablePromotionsPreferenceHelpIcon',
                emailField: 'emailPromotions',
                smsField: 'smsPromotions',
                text: (0, _I18n2.default)('preference-centre.promotions'),
                disabled: !isOver16,
                helpModalText: (0, _I18n2.default)('preference-centre.promotions.help'),
                isHalfOnState: updatedHalfOnState && isSouthEastern,
                isEmailProducts: isEmailProducts,
                southeasternId: isSouthEastern && "emailPromotionsAndProducts"
            })),
            _react2.default.createElement(_CheckedMarketingOption2.default, (0, _extends3.default)({}, defaultMarketingProps, {
                flag: 'enableProductsPreference',
                emailField: 'emailProducts',
                smsField: 'smsProducts',
                text: (0, _I18n2.default)('preference-centre.products'),
                disabled: !isOver16,
                helpModalText: (0, _I18n2.default)('preference-centre.products.help')
            })),
            !hideAutoDrOption && _react2.default.createElement(_CheckedMarketingOption2.default, (0, _extends3.default)({}, defaultMarketingProps, {
                flag: 'enableAutoDelayRepay',
                emailField: 'autoDelayRepay',
                hideSmsField: true,
                text: (0, _I18n2.default)('account.register.autoDelayRepay'),
                helpModalText: 'account.register.autoDelayRepay.description'
            }))
        )
    );
}

PrefsTable.propTypes = {
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    onChange: _propTypes2.default.func,
    isOver16: _propTypes2.default.bool,
    enableEmailMarketing: _propTypes2.default.bool,
    enableSmsMarketing: _propTypes2.default.bool,
    hideAutoDrOption: _propTypes2.default.bool,
    isHalfOnState: _propTypes2.default.bool,
    isEmailProducts: _propTypes2.default.bool
};

PrefsTable.defaultProps = {
    onChange: _noop3.default,
    isOver16: false,
    enableEmailMarketing: true,
    enableSmsMarketing: true,
    hideAutoDrOption: false
};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(763),
    basePropertyDeep = __webpack_require__(1473),
    isKey = __webpack_require__(514),
    toKey = __webpack_require__(188);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    id: [_LinkMapper.fields.string],
    class: [_LinkMapper.fields.string],
    ticketNumber: [_LinkMapper.fields.bool],
    photocardNumber: [_LinkMapper.fields.bool],
    smartcardNumber: [_LinkMapper.fields.bool],
    contactlessNumber: [_LinkMapper.fields.bool],
    oysterNumber: [_LinkMapper.fields.bool],
    ticketUpload: [_LinkMapper.fields.bool],
    statementUpload: [_LinkMapper.fields.bool],
    requiresUpload: [_LinkMapper.fields.bool],
    uploadHint: [_LinkMapper.fields.bool],
    dates: [_LinkMapper.fields.bool],
    price: [_LinkMapper.fields.bool],
    purchaseLocation: [_LinkMapper.fields.bool],
    travelcard: [_LinkMapper.fields.bool],
    weeklyCap: [_LinkMapper.fields.bool],
    fixedDuration: [_LinkMapper.fields.duration]
};

var CompensationTicketType = function (_record) {
    (0, _inherits3.default)(CompensationTicketType, _record);

    function CompensationTicketType() {
        (0, _classCallCheck3.default)(this, CompensationTicketType);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CompensationTicketType.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CompensationTicketType, json, (0, _Records.getResolvers)(schema));
    };

    (0, _createClass3.default)(CompensationTicketType, [{
        key: 'acceptsUpload',
        get: function get() {
            return this.ticketUpload || this.statementUpload;
        }
    }]);
    return CompensationTicketType;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = CompensationTicketType;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    id: [_LinkMapper.fields.string],
    comments: [_LinkMapper.fields.bool],
    allowPreviousUpload: [_LinkMapper.fields.bool],
    onlyFor: [_LinkMapper.resolveAll.with(_LinkMapper.fields.string)]
};

var EvidenceType = function (_record) {
    (0, _inherits3.default)(EvidenceType, _record);

    function EvidenceType() {
        (0, _classCallCheck3.default)(this, EvidenceType);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    EvidenceType.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(EvidenceType, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return EvidenceType;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = EvidenceType;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var standardizeVersion = exports.standardizeVersion = function standardizeVersion(appVer) {
    var appVersionLength = appVer.split('.').length;

    if (appVersionLength === 1) {
        return appVer + '.0.0';
    }

    if (appVersionLength === 2) {
        return appVer + '.0';
    }

    return appVer;
};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(203),
    isIterateeCall = __webpack_require__(236);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.enrichFavouritesResponse = exports.enrichFavouriteDeliveryResponse = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var enrichFavouriteDeliveryResponse = exports.enrichFavouriteDeliveryResponse = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(delivery, user) {
        var addressId, collectionNlc, _ref2, address, collectionLocation;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (delivery) {
                            _context.next = 2;
                            break;
                        }

                        return _context.abrupt('return', null);

                    case 2:
                        addressId = delivery.address, collectionNlc = delivery.collectionLocation;
                        _context.next = 5;
                        return _promise2.default.all([addressId ? _AddressService2.default.get(user, addressId) : _promise2.default.resolve(null), collectionNlc ? _StationService2.default.get(collectionNlc) : _promise2.default.resolve(null)]);

                    case 5:
                        _ref2 = _context.sent;
                        address = _ref2[0];
                        collectionLocation = _ref2[1];
                        return _context.abrupt('return', (0, _extends3.default)({}, delivery, {
                            address: null,
                            storedAddress: address,
                            collectionLocation: collectionLocation
                        }));

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function enrichFavouriteDeliveryResponse(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var enrichFavouritesResponse = exports.enrichFavouritesResponse = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(favourite, user) {
        var getRailcards, getStation, getPhotocard, _ref4, destination, origin, route, ticketType, railcards, outwardPlusBusOrigin, outwardPlusBusDestination, returnPlusBusOrigin, returnPlusBusDestination, delivery, photocard, lastUsed;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        getRailcards = function getRailcards(railcards) {
                            var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

                            return railcards ? _promise2.default.all(railcards.map(function (code) {
                                return _RailcardsService2.default.get(code);
                            })) : _promise2.default.resolve(fallback);
                        };

                        getStation = function getStation(nlc) {
                            return nlc ? _StationService2.default.get(nlc) : _promise2.default.resolve(null);
                        };

                        getPhotocard = function getPhotocard(photocardNumber) {
                            return photocardNumber ? _PhotocardService2.default.getByNumber(user, photocardNumber) : _promise2.default.resolve(null);
                        };

                        _context2.next = 5;
                        return _promise2.default.all([getStation(favourite.destination), getStation(favourite.origin), _RouteService2.default.get(favourite.route), _TicketTypeService2.default.get(favourite.ticketType), getRailcards(favourite.railcards), getStation(favourite.outwardPlusBusOrigin), getStation(favourite.outwardPlusBusDestination), getStation(favourite.returnPlusBusOrigin), getStation(favourite.returnPlusBusDestination), enrichFavouriteDeliveryResponse(favourite.delivery, user), getPhotocard(favourite.photocard)]);

                    case 5:
                        _ref4 = _context2.sent;
                        destination = _ref4[0];
                        origin = _ref4[1];
                        route = _ref4[2];
                        ticketType = _ref4[3];
                        railcards = _ref4[4];
                        outwardPlusBusOrigin = _ref4[5];
                        outwardPlusBusDestination = _ref4[6];
                        returnPlusBusOrigin = _ref4[7];
                        returnPlusBusDestination = _ref4[8];
                        delivery = _ref4[9];
                        photocard = _ref4[10];


                        // Remap response.dateLastUsed => Fulfilment.lastUsed
                        lastUsed = favourite.dateLastUsed;
                        return _context2.abrupt('return', (0, _extends3.default)({}, favourite, {
                            destination: destination,
                            origin: origin,
                            route: route,
                            ticketType: ticketType,
                            railcards: railcards,
                            outwardPlusBusOrigin: outwardPlusBusOrigin,
                            outwardPlusBusDestination: outwardPlusBusDestination,
                            returnPlusBusOrigin: returnPlusBusOrigin,
                            returnPlusBusDestination: returnPlusBusDestination,
                            delivery: delivery,
                            photocard: photocard,
                            lastUsed: lastUsed
                        }));

                    case 19:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function enrichFavouritesResponse(_x3, _x4) {
        return _ref3.apply(this, arguments);
    };
}();

exports.getPlusBus = getPlusBus;

var _StationService = __webpack_require__(341);

var _StationService2 = _interopRequireDefault(_StationService);

var _RouteService = __webpack_require__(1959);

var _RouteService2 = _interopRequireDefault(_RouteService);

var _TicketTypeService = __webpack_require__(1960);

var _TicketTypeService2 = _interopRequireDefault(_TicketTypeService);

var _RailcardsService = __webpack_require__(620);

var _RailcardsService2 = _interopRequireDefault(_RailcardsService);

var _AddressService = __webpack_require__(543);

var _AddressService2 = _interopRequireDefault(_AddressService);

var _PhotocardService = __webpack_require__(837);

var _PhotocardService2 = _interopRequireDefault(_PhotocardService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPlusBus(orderTrip) {
    var plusBus = {};

    if (orderTrip.hasPlusBus()) {
        var plusBusFares = orderTrip.getPlusBus();

        var getPlusBusStation = function getPlusBusStation(direction, terminal) {
            return plusBusFares.getIn([direction, terminal, terminal, 'nlc']);
        };
        (0, _assign2.default)(plusBus, {
            outwardPlusBusOrigin: getPlusBusStation('outward', 'origin'),
            outwardPlusBusDestination: getPlusBusStation('outward', 'destination'),
            returnPlusBusOrigin: getPlusBusStation('return', 'origin'),
            returnPlusBusDestination: getPlusBusStation('return', 'destination')
        });
    }

    return plusBus;
}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _LinkMapper = __webpack_require__(8);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FareOnlyService = {

    /**
     * @param {Search} search
     * @return {Fare[]}
     */
    search: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_search) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _AuthenticatedAPIClient2.default.post('/jp/tickets/fare-only', _search.toFareOnlyJSON());

                        case 2:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Fare2.default));

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function search(_x) {
            return _ref.apply(this, arguments);
        }

        return search;
    }(),


    /**
     * @param {SeasonSearch} search
     * @return {Fare[]}
     */
    seasonSearch: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(search) {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _AuthenticatedAPIClient2.default.post('/jp/season-tickets/fare-only', search.toFareOnlyJSON());

                        case 2:
                            response = _context2.sent;
                            return _context2.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Fare2.default));

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function seasonSearch(_x2) {
            return _ref2.apply(this, arguments);
        }

        return seasonSearch;
    }()
};

exports.default = FareOnlyService;

/***/ }),
/* 973 */,
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SectionErrors(_ref) {
    var errors = _ref.errors;

    if (!errors.length) {
        return null;
    }
    return _react2.default.createElement(
        'div',
        { tabIndex: '0', className: 'alert alert-warning' },
        _react2.default.createElement(
            'ul',
            null,
            errors.map(function (error, key) {
                return _react2.default.createElement(
                    'li',
                    { key: key },
                    (0, _I18n.translate)(error)
                );
            })
        )
    );
}

SectionErrors.propTypes = {
    errors: _propTypes2.default.array
};

SectionErrors.defaultProps = {
    errors: []
};

exports.default = SectionErrors;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _momentTimezone = __webpack_require__(235);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _ui = __webpack_require__(1969);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Calendar = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(Calendar, _PureRenderComponent);

    function Calendar() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Calendar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.calendarRef = _react2.default.createRef(), _this._onChange = function (date) {
            _this.props.onChange((0, _momentTimezone2.default)(date));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _props = this.props,
            show = _props.show,
            autoFocus = _props.autoFocus;

        var datePicker = (0, _get3.default)(this.calendarRef, 'current');
        if (autoFocus && show && !prevProps.show && datePicker) {
            // Consider adding this functionality to the DatePicker itself
            var datePickerEl = _reactDom2.default.findDOMNode(datePicker);
            var selected = datePickerEl.querySelector('.DayPicker-Day--selected');
            var firstAvailableDay = datePickerEl.querySelector('.DayPicker-Day:not(.DayPicker-Day--disabled)');
            var wrapper = datePickerEl.querySelector('[tabindex="0"]');
            (selected || firstAvailableDay || wrapper).focus();
        }
    };

    Calendar.prototype.render = function render() {
        var _props2 = this.props,
            className = _props2.className,
            selected = _props2.selected,
            min = _props2.min,
            max = _props2.max,
            initialMonth = _props2.initialMonth,
            _props2$numberOfMonth = _props2.numberOfMonths,
            numberOfMonths = _props2$numberOfMonth === undefined ? 1 : _props2$numberOfMonth;


        var calendarProps = {
            selected: selected ? selected.toDate() : null,
            onChange: this._onChange,
            numberOfMonths: numberOfMonths
        };

        if (min) {
            calendarProps.minDate = min.toDate();
        }
        if (max) {
            calendarProps.maxDate = max.toDate();
        }
        if (initialMonth) {
            calendarProps.initialMonthDate = initialMonth.toDate();
        }

        return _react2.default.createElement(
            'div',
            { className: 'otrl-ui__widget--vertical', ref: this.calendarRef },
            _react2.default.createElement(_ui.DatePicker, (0, _extends3.default)({}, calendarProps, { className: className }))
        );
    };

    return Calendar;
}(_PureRenderComponent3.default), _class.propTypes = {
    show: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    selected: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    min: _MomentPropTypes2.default.isMoment,
    initialMonth: _MomentPropTypes2.default.isMoment,
    onChange: _propTypes2.default.func,
    className: _propTypes2.default.string
}, _class.defaultProps = {
    selected: null,
    max: null,
    min: null,
    initialMonth: null,
    onChange: _noop3.default,
    show: false,
    autoFocus: false
}, _temp2);
exports.default = Calendar;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.StationSelector = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _StationStore = __webpack_require__(429);

var _StationStore2 = _interopRequireDefault(_StationStore);

var _RecentStationsStore = __webpack_require__(877);

var _RecentStationsStore2 = _interopRequireDefault(_RecentStationsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Immutable = __webpack_require__(54);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _Autocomplete = __webpack_require__(1162);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _StationListItem = __webpack_require__(2045);

var _StationListItem2 = _interopRequireDefault(_StationListItem);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var includes = function includes(baseStr, testStr) {
    return (baseStr || '').toLowerCase().includes((testStr || '').toLowerCase());
};

var StationSelector = exports.StationSelector = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(StationSelector, _React$PureComponent);

    function StationSelector() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StationSelector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            results: (0, _Immutable.compact)((0, _Immutable.toImmutable)([_this.props.station])),
            searchValue: null
        }, _this._doSearch = function (value, stationType) {
            var _this$props = _this.props,
                customSearchService = _this$props.customSearchService,
                filterByBrand = _this$props.filterByBrand;

            return customSearchService ? customSearchService(value, stationType, filterByBrand) : _StationStore2.default.search(value, stationType, filterByBrand);
        }, _this._handleSearch = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var searchValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var results;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!searchValue) {
                                _context.next = 7;
                                break;
                            }

                            _context.next = 3;
                            return _this._doSearch(searchValue, _this.props.stationType);

                        case 3:
                            results = _context.sent;

                            _this.setState({ results: results, searchValue: searchValue });
                            _context.next = 8;
                            break;

                        case 7:
                            _this.props.onChange(new _Station2.default());

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        })), _this._handleClear = function () {
            _this.props.onChange(new _Station2.default());
        }, _this._handleSelect = function (value) {
            var name = _this.props.name;

            var results = (0, _immutable.List)().concat(_this.state.results, _this.props.recentStationsList);
            var stationResult = results.find(function (station) {
                return station.nlc === value;
            });
            _TrackingActions2.default.widgetStationSearch({ type: name, stationName: stationResult.name });
            _this.setState({ results: (0, _Immutable.toImmutable)([stationResult]) }, _this.props.onChange.bind(null, stationResult));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    StationSelector.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        this.setState({ results: (0, _Immutable.compact)((0, _Immutable.toImmutable)([newProps.station])) });
    };

    StationSelector.prototype._prepareResults = function _prepareResults() {
        var excludeGroupStations = this.props.excludeGroupStations;


        return _Immutable.union.apply(undefined, arguments).reduce(function (acc) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var value = data.nlc,
                label = data.name;


            if (excludeGroupStations && new _Station2.default(data).isGroupStation()) {
                return acc;
            }

            return value ? acc.concat({ value: value, label: label, data: data }) : acc;
        }, []);
    };

    StationSelector.prototype._resultsFilter = function _resultsFilter(inputValue, _ref2) {
        var _ref2$data = _ref2.data,
            _ref2$data$name = _ref2$data.name,
            name = _ref2$data$name === undefined ? '' : _ref2$data$name,
            _ref2$data$crs = _ref2$data.crs,
            crs = _ref2$data$crs === undefined ? '' : _ref2$data$crs;

        return !inputValue || includes(name, inputValue) || includes(crs, inputValue);
    };

    StationSelector.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            debounce = _props.debounce,
            disabled = _props.disabled,
            error = _props.error,
            floatyPlaceholder = _props.floatyPlaceholder,
            focused = _props.focused,
            label = _props.label,
            title = _props.title,
            name = _props.name,
            overlayResults = _props.overlayResults,
            placeholder = _props.placeholder,
            recentStationsList = _props.recentStationsList,
            required = _props.required,
            station = _props.station,
            isInvalid = _props.isInvalid,
            errorMessage = _props.errorMessage,
            id = _props.id;
        var _state = this.state,
            searchValue = _state.searchValue,
            results = _state.results;


        return _react2.default.createElement(
            'div',
            { className: 'station-selector' },
            _react2.default.createElement(_Autocomplete2.default, {
                name: name,
                placeholder: placeholder,
                floatyPlaceholder: floatyPlaceholder,
                defaultValue: station ? station.nlc : null,
                defaultInputValue: station ? station.name : null,
                results: this._prepareResults(recentStationsList.reverse(), results),
                searchValue: searchValue,
                className: className,
                onSearch: this._handleSearch,
                onSelect: this._handleSelect,
                onClear: this._handleClear,
                optionElement: _StationListItem2.default,
                debounce: debounce,
                resultsFilter: this._resultsFilter,
                required: required,
                label: label,
                resultsLabel: (0, _I18n.translate)('stationSelector.results.aria'),
                title: title,
                overlayResults: overlayResults,
                disabled: disabled,
                focused: focused,
                isInvalid: isInvalid,
                errorMessage: errorMessage,
                id: id
            }),
            error && _react2.default.createElement(_Error2.default, { message: error })
        );
    };

    return StationSelector;
}(_react2.default.PureComponent), _class.propTypes = {
    name: _propTypes2.default.string,
    stationType: _propTypes2.default.string,
    station: _propTypes2.default.instanceOf(_Station2.default),
    placeholder: _propTypes2.default.string,
    floatyPlaceholder: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    debounce: _propTypes2.default.bool,
    recentStationsList: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    required: _propTypes2.default.bool,
    label: _propTypes2.default.node,
    title: _propTypes2.default.string,
    error: _propTypes2.default.string,
    customSearchService: _propTypes2.default.func,
    overlayResults: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    focused: _propTypes2.default.bool,
    filterByBrand: _propTypes2.default.bool,
    excludeGroupStations: _propTypes2.default.bool,
    isInvalid: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string,
    id: _propTypes2.default.string
}, _class.defaultProps = {
    name: '',
    station: null,
    placeholder: '',
    floatyPlaceholder: false,
    onChange: _noop3.default,
    className: '',
    stationType: null,
    debounce: true,
    recentStationsList: (0, _immutable.List)(),
    required: false,
    label: null,
    error: null,
    customSearchService: null,
    overlayResults: false,
    disabled: false,
    focused: false,
    filterByBrand: false,
    excludeGroupStations: false,
    isInvalid: false,
    errorMessage: null,
    id: 'station'
}, _temp2);
exports.default = (0, _connectToStores2.default)([_RecentStationsStore2.default], function (_ref3) {
    var stationType = _ref3.stationType;
    return {
        recentStationsList: _RecentStationsStore2.default.get(stationType)
    };
})(StationSelector);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useScreenDimensions = useScreenDimensions;

var _react = __webpack_require__(0);

var _hookUtils = __webpack_require__(234);

var _hookUtils2 = _interopRequireDefault(_hookUtils);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _hookUtils2.default)(useScreenDimensions, 'useScreenDimensions');
function useScreenDimensions() {
    var state = (0, _useStoreState2.default)(_DimensionsStore2.default, getStoreState);
    (0, _react.useDebugValue)(state);
    return state;
}

function getStoreState() {
    return {
        width: _DimensionsStore2.default.get('width'),
        height: _DimensionsStore2.default.get('height'),
        isMobileWidth: _DimensionsStore2.default.isMobileWidth(),
        isTabletWidth: _DimensionsStore2.default.isTabletWidth(),
        isDesktopWidth: _DimensionsStore2.default.isDesktopWidth(),
        isDesktopLWidth: _DimensionsStore2.default.isDesktopLWidth(),
        isDesktopXLWidth: _DimensionsStore2.default.isDesktopXLWidth()
    };
}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    showCollectionLocation: false,
    collectionLocation: null,
    nickname: _AppConstants.KEYGO_NICKNAME,
    cardHolderName: null,
    cardNumber: null,
    expiryMonth: null,
    expiryYear: null,
    cv2: null,
    addressLine1: null,
    addressLine2: null,
    addressLine3: null,
    townCity: null,
    postcode: null,
    country: 'GBR'
};

var KeyGoForm = function (_record) {
    (0, _inherits3.default)(KeyGoForm, _record);

    function KeyGoForm() {
        (0, _classCallCheck3.default)(this, KeyGoForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    KeyGoForm.prototype.getComputedValues = function getComputedValues() {
        var expiryMonth = parseInt(this.expiryMonth, 10);
        var expiryYear = parseInt(this.expiryYear, 10);
        var isExpired = (0, _moment2.default)().isAfter((0, _moment2.default)(expiryMonth + '-' + expiryYear, 'MM-YYYY').endOf('month'));
        return {
            isExpired: Boolean(expiryMonth) && Boolean(expiryYear) && isExpired
        };
    };

    KeyGoForm.prototype.getSchema = function getSchema() {
        return {
            collectionLocation: _validation2.default.collectionLocation(this.showCollectionLocation),
            cardHolderName: _validation2.default.cardHolderName(),
            cardNumber: _validation2.default.cardNumber(),
            expiryMonth: _validation2.default.expiryMonth(),
            expiryYear: _validation2.default.expiryYear(),
            cv2: _validation2.default.cv2(),
            addressLine1: _validation2.default.addressLine().required(),
            townCity: _validation2.default.townCity(),
            postcode: _validation2.default.postcode(),
            country: _validation2.default.country(),
            isExpired: _joi2.default.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.cardExpired')
                    }
                }
            })
        };
    };

    return KeyGoForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(KeyGoForm.prototype, _ValidationMixin2.default);

exports.default = KeyGoForm;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _CombinedTimeSelector = __webpack_require__(2049);

var _CombinedTimeSelector2 = _interopRequireDefault(_CombinedTimeSelector);

var _HourSelector = __webpack_require__(936);

var _HourSelector2 = _interopRequireDefault(_HourSelector);

var _MinuteSelector = __webpack_require__(937);

var _MinuteSelector2 = _interopRequireDefault(_MinuteSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TimeSelector(_ref) {
    var combined = _ref.combined,
        disabled = _ref.disabled,
        datetime = _ref.datetime,
        min = _ref.min,
        max = _ref.max,
        onChange = _ref.onChange,
        className = _ref.className,
        minuteStep = _ref.minuteStep,
        ariaLabel = _ref.ariaLabel;


    var minHour = 0;
    var minMinute = 0;
    var maxHour = 23;
    var maxMinute = 59;

    if (min && datetime.isSame(min, 'day')) {
        minHour = min.hour();
        if (datetime.isSame(min, 'hour')) {
            minMinute = min.minute();
        }
    }

    if (max && datetime.isSame(max, 'day')) {
        maxHour = max.hour();
        if (datetime.isSame(max, 'hour')) {
            maxMinute = max.minute();
        }
    }

    var handleTimeChangeCombined = function handleTimeChangeCombined(newDatetime) {
        var updated = newDatetime.clone().set({
            hour: newDatetime.hour(),
            minute: newDatetime.minute()
        });
        onChange(updated);
    };

    var handleTimeChangeFor = function handleTimeChangeFor(field) {
        return function (value) {
            var _datetime$clone$set;

            var updated = datetime.clone().set((_datetime$clone$set = {}, _datetime$clone$set[field] = value, _datetime$clone$set));
            onChange(updated);
        };
    };

    return _react2.default.createElement(
        'div',
        { className: className },
        combined ? _react2.default.createElement(_CombinedTimeSelector2.default, {
            datetime: datetime,
            minuteStep: minuteStep,
            onChange: handleTimeChangeCombined,
            disabled: disabled,
            min: min,
            max: max,
            ariaLabel: ariaLabel
        }) : _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(_HourSelector2.default, {
                hour: datetime.hour(),
                onChange: handleTimeChangeFor('hour'),
                disabled: disabled,
                min: minHour,
                max: maxHour
            }),
            _react2.default.createElement(_MinuteSelector2.default, {
                minute: datetime.minute(),
                minuteStep: minuteStep,
                onChange: handleTimeChangeFor('minute'),
                disabled: disabled,
                min: minMinute,
                max: maxMinute
            })
        )
    );
}

TimeSelector.propTypes = {
    combined: _propTypes2.default.bool,
    datetime: _MomentPropTypes2.default.isMoment,
    onChange: _propTypes2.default.func,
    min: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    disabled: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    minuteStep: _propTypes2.default.number,
    ariaLabel: _propTypes2.default.string
};

TimeSelector.defaultProps = {
    combined: false,
    datetime: (0, _TrainTime2.default)(),
    onChange: _noop3.default,
    disabled: false,
    min: null,
    max: null,
    className: '',
    minuteStep: 15
};

exports.default = TimeSelector;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pickBy2 = __webpack_require__(161);

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _STAGES;

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _Flow = __webpack_require__(1013);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Config for the defined stages, could be moved out later to allow different flows
 * for different brands
 */
var STAGES = (_STAGES = {}, _STAGES[_AppConstants.PointStages.SEARCH] = new _Flow.Stage({
    next: function next(current, state) {
        if (state.search.targetLayout === _AppConstants.JourneyPlannerLayout.LIST) {
            return _AppConstants.PointStages.CHOOSE_OUTWARD;
        }

        return _AppConstants.GridPages.SERVICES;
    }
}), _STAGES[_AppConstants.GridPages.SERVICES] = new _Flow.Stage({
    previous: function previous() {
        return _AppConstants.PointStages.SEARCH;
    },
    next: function next(current, _ref) {
        var trip = _ref.trip,
            smartcard = _ref.smartcard;

        if (!trip.isValid()) {
            return false;
        }
        if (trip.isSmartcard() && smartcard && !smartcard.canLoadProduct()) {
            return false;
        }
        //Skip the delivery page if the smartcard is waiting for a product
        //as it will be delivered with the smartcard
        if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
            return _AppConstants.CheckoutStages.PAYMENT;
        }
        return _AppConstants.CheckoutStages.DELIVERY;
    },

    nextAction: function nextAction(current, state) {
        var trip = state.trip,
            smartcard = state.smartcard;

        if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
            return _OrderActions2.default.createOrderForPreRegisteredSmartcard.bind(_OrderActions2.default);
        }
        return _OrderActions2.default.createOrUpdate.bind(_OrderActions2.default);
    },

    getParams: function getParams(_ref2) {
        var search = _ref2.search,
            trip = _ref2.trip;

        search = trip ? trip.search : search;
        return search.serialize().params;
    },
    getQuery: function getQuery(_ref3) {
        var search = _ref3.search,
            trip = _ref3.trip,
            promptJourneyDetails = _ref3.promptJourneyDetails,
            _ref3$gridVersion = _ref3.gridVersion,
            gridVersion = _ref3$gridVersion === undefined ? _AppConstants.JourneyPlannerLayout.GRID : _ref3$gridVersion;

        search = trip ? trip.search : search;
        search = search.setTargetLayout(gridVersion);
        return (0, _pickBy3.default)((0, _extends3.default)({}, search.serialize().query, { promptJourneyDetails: promptJourneyDetails }));
    }
}), _STAGES[_AppConstants.PointStages.CHOOSE_OUTWARD] = new _Flow.Stage({
    previous: function previous() {
        return _AppConstants.PointStages.SEARCH;
    },
    next: function next(current, _ref4) {
        var trip = _ref4.trip,
            smartcard = _ref4.smartcard;

        if (!trip.isValid()) {
            return false;
        }
        if (trip.isSmartcard() && smartcard && !smartcard.canLoadProduct()) {
            return false;
        }
        //Skip the delivery page if the smartcard is waiting for a product
        //as it will be delivered with the smartcard
        if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
            return _AppConstants.CheckoutStages.PAYMENT;
        }
        return _AppConstants.CheckoutStages.DELIVERY;
    },

    nextAction: function nextAction(current, state) {
        var trip = state.trip,
            smartcard = state.smartcard;

        if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
            return _OrderActions2.default.createOrderForPreRegisteredSmartcard.bind(_OrderActions2.default);
        }
        return _OrderActions2.default.createOrUpdate.bind(_OrderActions2.default);
    },

    getParams: function getParams(_ref5) {
        var search = _ref5.search,
            trip = _ref5.trip;

        search = trip ? trip.search : search;
        return search.serialize().params;
    },
    getQuery: function getQuery(_ref6) {
        var search = _ref6.search,
            trip = _ref6.trip,
            promptJourneyDetails = _ref6.promptJourneyDetails;

        search = trip ? trip.search : search;
        search = search.setTargetLayout(_AppConstants.JourneyPlannerLayout.LIST);
        var step = trip ? trip.listStep : null;
        return (0, _pickBy3.default)((0, _assign2.default)({ step: step, promptJourneyDetails: promptJourneyDetails }, search.serialize().query));
    }
}), _STAGES[_AppConstants.CheckoutStages.DELIVERY] = new _Flow.Stage({
    previous: function previous() {
        return _AppConstants.GridPages.SERVICES;
    }
}), _STAGES[_AppConstants.CheckoutStages.PAYMENT] = new _Flow.Stage({
    previous: function previous() {
        return _AppConstants.PointStages.SEARCH;
    }
}), _STAGES);

exports.default = new _Flow.Flow(STAGES);

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _StationStop = __webpack_require__(441);

var _StationStop2 = _interopRequireDefault(_StationStop);

var _ServiceDetails = __webpack_require__(1706);

var _ServiceDetails2 = _interopRequireDefault(_ServiceDetails);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Leg = new _immutable.Record({
    id: null,
    origin: new _immutable.List(),
    destination: new _immutable.List(),
    serviceDetails: new _ServiceDetails2.default(),
    transferTime: 0
});

Leg.fromJSON = function (json) {
    json = json || {};

    var id = json.id;

    // Some services may have multiple origins/destinations
    // e.g Trains joining together or breaking apart at certain points
    var origin = (0, _LinkMapper.resolveAll)(json.origin).as(_StationStop2.default);
    var destination = (0, _LinkMapper.resolveAll)(json.destination).as(_StationStop2.default);

    var serviceDetails = (0, _LinkMapper.resolve)(json.serviceDetails).as(_ServiceDetails2.default);
    var transferTime = (0, _LinkMapper.resolve)(json.transferTime || 0).with(Number);

    var result = { id: id, origin: origin, destination: destination, serviceDetails: serviceDetails, transferTime: transferTime };

    return new Leg(result);
};

(0, _assign2.default)(Leg.prototype, {
    getOriginStation: function getOriginStation() {
        return this.origin.first().station;
    },
    getDestinationStation: function getDestinationStation() {
        return this.destination.first().station;
    },
    getDepartureTime: function getDepartureTime() {
        return this.origin.first().getIn(['time', 'scheduledTime']);
    },
    getArrivalTime: function getArrivalTime() {
        return this.destination.first().getIn(['time', 'scheduledTime']);
    },
    getTrainUid: function getTrainUid() {
        return this.serviceDetails.trainUid;
    },
    getIsMetro: function getIsMetro() {
        return this.serviceDetails.mode === _AppConstants.TransitModes.METRO;
    },
    isTrainLeg: function isTrainLeg() {
        return this.serviceDetails.mode === _AppConstants.TransitModes.TRAIN;
    }
});

exports.default = Leg;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ResponsiveRender = ResponsiveRender;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ResponsiveRender(_ref) {
    var forceRender = _ref.forceRender,
        height = _ref.height,
        width = _ref.width,
        minHeight = _ref.minHeight,
        minWidth = _ref.minWidth,
        maxHeight = _ref.maxHeight,
        maxWidth = _ref.maxWidth,
        children = _ref.children;


    if (maxHeight && maxHeight < minHeight) {
        console.warn('maxHeight ' + maxHeight + ' is less than minHeight ' + minHeight + ' so this will never render');
    }
    if (maxWidth && maxWidth < minWidth) {
        console.warn('maxWidth ' + maxWidth + ' is less than minWidth ' + minWidth + ' so this will never render');
    }

    if (!forceRender && (minHeight > height || minWidth > width || maxHeight && maxHeight < height || maxWidth && maxWidth < width)) {
        return null;
    }
    return children;
}

ResponsiveRender.propTypes = {
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    minWidth: _propTypes2.default.number,
    minHeight: _propTypes2.default.number,
    maxWidth: _propTypes2.default.number,
    maxHeight: _propTypes2.default.number,
    forceRender: _propTypes2.default.bool,
    children: _propTypes2.default.node
};

ResponsiveRender.defaultProps = {
    minWidth: 0,
    maxWidth: 0,
    minHeight: 0,
    maxHeight: 0,
    forceRender: false
};

exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default], function () {
    return _DimensionsStore2.default.getAll().toJS();
})(ResponsiveRender);

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _AddressLineOne2 = __webpack_require__(276);

var _AddressLineOne3 = _interopRequireDefault(_AddressLineOne2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressLineTwo = (_temp = _class = function (_AddressLineOne) {
    (0, _inherits3.default)(AddressLineTwo, _AddressLineOne);

    function AddressLineTwo() {
        (0, _classCallCheck3.default)(this, AddressLineTwo);
        return (0, _possibleConstructorReturn3.default)(this, _AddressLineOne.apply(this, arguments));
    }

    return AddressLineTwo;
}(_AddressLineOne3.default), _class.defaultProps = {
    'field': 'addressLine2',
    'id': 'addressline2'
}, _temp);
exports.default = AddressLineTwo;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _AddressLineOne2 = __webpack_require__(276);

var _AddressLineOne3 = _interopRequireDefault(_AddressLineOne2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressLineThree = (_temp = _class = function (_AddressLineOne) {
    (0, _inherits3.default)(AddressLineThree, _AddressLineOne);

    function AddressLineThree() {
        (0, _classCallCheck3.default)(this, AddressLineThree);
        return (0, _possibleConstructorReturn3.default)(this, _AddressLineOne.apply(this, arguments));
    }

    return AddressLineThree;
}(_AddressLineOne3.default), _class.defaultProps = {
    'field': 'addressLine3',
    'id': 'addressline3'
}, _temp);
exports.default = AddressLineThree;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _AddressLineOne2 = __webpack_require__(276);

var _AddressLineOne3 = _interopRequireDefault(_AddressLineOne2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TownCity = (_temp = _class = function (_AddressLineOne) {
    (0, _inherits3.default)(TownCity, _AddressLineOne);

    function TownCity() {
        (0, _classCallCheck3.default)(this, TownCity);
        return (0, _possibleConstructorReturn3.default)(this, _AddressLineOne.apply(this, arguments));
    }

    return TownCity;
}(_AddressLineOne3.default), _class.defaultProps = {
    'field': 'townCity',
    'id': 'towncity',
    'name': 'towncity'
}, _temp);
exports.default = TownCity;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _AddressLineOne2 = __webpack_require__(276);

var _AddressLineOne3 = _interopRequireDefault(_AddressLineOne2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostCode = (_temp = _class = function (_AddressLineOne) {
    (0, _inherits3.default)(PostCode, _AddressLineOne);

    function PostCode() {
        (0, _classCallCheck3.default)(this, PostCode);
        return (0, _possibleConstructorReturn3.default)(this, _AddressLineOne.apply(this, arguments));
    }

    return PostCode;
}(_AddressLineOne3.default), _class.defaultProps = {
    'field': 'postcode',
    'id': 'postcode'
}, _temp);
exports.default = PostCode;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _clone2 = __webpack_require__(1996);

var _clone3 = _interopRequireDefault(_clone2);

var _set2 = __webpack_require__(394);

var _set3 = _interopRequireDefault(_set2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _CountryStore = __webpack_require__(457);

var _CountryStore2 = _interopRequireDefault(_CountryStore);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Country(props) {

    var countries = _CountryStore2.default.getCountries();
    var disabled = props.countryDisabled || props.disabled;
    var appliedProps = (0, _set3.default)((0, _clone3.default)(props), 'disabled', disabled);

    var labelProps = props.hasLabels ? {} : {
        label: (0, _I18n.translate)('customerdetails.country'),
        placeholder: (0, _I18n.translate)('customerdetails.country'),
        labelClassName: "sr-only"
    };

    return _react2.default.createElement(
        'div',
        { className: 'country' },
        props.hasLabels && _react2.default.createElement(
            'label',
            { htmlFor: 'country', className: 'label' },
            (0, _I18n.translate)('customerdetails.country')
        ),
        _react2.default.createElement(
            _ValidatedField2.default,
            (0, _extends3.default)({}, appliedProps, {
                type: 'select',
                id: 'country',
                field: 'country',
                groupClassName: 'select-container',
                hideOptional: true
            }, labelProps),
            _react2.default.createElement(
                'option',
                { value: '' },
                (0, _I18n.translate)('customerdetails.country.select')
            ),
            countries.map(function (country, i) {
                return _react2.default.createElement(
                    'option',
                    { key: i, value: country.get('iso2') },
                    country.get('name')
                );
            })
        )
    );
}

Country.propTypes = (0, _extends3.default)({}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'countryDisabled', 'required', 'visited', 'validation']), {
    hasLabels: _propTypes2.default.bool
});

exports.default = Country;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PostCodeLookUp = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBootstrap = __webpack_require__(100);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _API = __webpack_require__(201);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _CustomerService = __webpack_require__(280);

var _CustomerService2 = _interopRequireDefault(_CustomerService);

var _PostcodeLookUp = __webpack_require__(1997);

var _PostcodeLookUp2 = _interopRequireDefault(_PostcodeLookUp);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _Select = __webpack_require__(425);

var _Select2 = _interopRequireDefault(_Select);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    var enablePostCodeLookUp = _FeatureFlagStore2.default.get('enablePostCodeLookUp');
    return { enablePostCodeLookUp: enablePostCodeLookUp };
}

var PostCodeLookUp = exports.PostCodeLookUp = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(PostCodeLookUp, _React$PureComponent);

    function PostCodeLookUp() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PostCodeLookUp);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            lookUpForm: new _PostcodeLookUp2.default(),
            loading: false,
            addressOptions: null,
            showInvalidError: false,
            showNotFoundError: false
        }, _this.handlePostCodeChange = function (field, value) {
            var updatedForm = _this.state.lookUpForm.set(field, value);
            _this.setState({ lookUpForm: updatedForm, showInvalidError: false, showNotFoundError: false, addressOptions: null });
        }, _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.lookUpPostCode();
        }, _this.lookUpPostCode = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var onFoundAddressList, lookUpForm, addressOptions;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            onFoundAddressList = _this.props.onFoundAddressList;
                            lookUpForm = _this.state.lookUpForm;

                            if (!(lookUpForm.get('postcode') && !lookUpForm.getValidationSummary().postcode)) {
                                _context.next = 18;
                                break;
                            }

                            _this.setState({ loading: true });
                            addressOptions = new _immutable.List();
                            _context.prev = 5;
                            _context.next = 8;
                            return _CustomerService2.default.lookUpAddress(lookUpForm.get('postcode'));

                        case 8:
                            addressOptions = _context.sent;

                            if (!addressOptions.size) {
                                _this.setState({ showNotFoundError: true });
                            } else {
                                onFoundAddressList();
                            }
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](5);

                            if (_context.t0 instanceof _API.BadRequestError) {
                                _this.setState({ showInvalidError: true });
                            } else {
                                console.error(_context.t0);
                                _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR);
                            }

                        case 15:
                            _context.prev = 15;

                            _this.setState({ addressOptions: addressOptions, loading: false });
                            return _context.finish(15);

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[5, 12, 15, 18]]);
        })), _this.handleSelectAddress = function (e) {
            var selectedAddress = _this.state.addressOptions.find(function (option) {
                return option.toString() === e.target.value;
            });
            var updatedAddress = selectedAddress.merge({
                line1: selectedAddress.get('line1') || '',
                line2: selectedAddress.get('line2') || '',
                line3: selectedAddress.get('line3') || '',
                town: selectedAddress.get('town') || ''
            });
            _this.props.onSelectAddress(updatedAddress);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    PostCodeLookUp.prototype.render = function render() {
        if (!this.props.enablePostCodeLookUp) {
            return null;
        }

        var _props = this.props,
            country = _props.country,
            cols = _props.cols,
            disabled = _props.disabled,
            outsideLabel = _props.outsideLabel;


        if (country !== _config2.default.get('defaultDeliveryCountry')) {
            return null;
        }

        var _state = this.state,
            addressOptions = _state.addressOptions,
            loading = _state.loading,
            lookUpForm = _state.lookUpForm,
            showInvalidError = _state.showInvalidError,
            showNotFoundError = _state.showNotFoundError;

        var disableSearch = !lookUpForm.get('postcode') || !!lookUpForm.getValidationSummary().postcode || loading;

        return _react2.default.createElement(
            'div',
            { className: 'postcode-lookup-with-select' },
            _react2.default.createElement(
                _reactBootstrap.Row,
                null,
                _react2.default.createElement(
                    _reactBootstrap.Col,
                    (0, _extends3.default)({}, cols, { md: cols.md || 6 }),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)("postcode-lookup form-group", { "postcode-lookup--outside-label": outsideLabel }) },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group' },
                            _react2.default.createElement(
                                'form',
                                { onSubmit: this.handleSubmit },
                                _react2.default.createElement(_ValidatedField2.default, {
                                    className: (0, _classnames2.default)("bold-placeholder", { "with-addon": !outsideLabel }),
                                    form: this.state.lookUpForm,
                                    field: 'postcode',
                                    type: 'text',
                                    id: 'postCodeLookUp',
                                    value: this.state.lookUpForm.get('postcode'),
                                    disabled: disabled,
                                    label: (0, _I18n2.default)('postcode-lookup.input.placeholder'),
                                    placeholder: (0, _I18n2.default)('postcode-lookup.input.placeholder'),
                                    onChange: this.handlePostCodeChange,
                                    noFloatyPlaceholder: true,
                                    externalFormGroup: true,
                                    hideOptional: outsideLabel,
                                    showRequired: outsideLabel,
                                    outsideLabel: outsideLabel
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)({ "input-group-addon": !outsideLabel, "input-group-addon--outside-label": outsideLabel }) },
                                _react2.default.createElement(
                                    _OnEnterTrigger2.default,
                                    { className: 'postcode-search-button',
                                        element: 'span',
                                        role: 'button',
                                        onClick: this.lookUpPostCode,
                                        disabled: disableSearch,
                                        'aria-label': (0, _I18n2.default)('postcode-lookup.button.label')
                                    },
                                    loading ? _react2.default.createElement(_Icon2.default, { icon: 'spinner', className: 'otrl-spin' }) : _react2.default.createElement(_Icon2.default, { icon: 'search' })
                                )
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                _reactBootstrap.Row,
                null,
                _react2.default.createElement(
                    _reactBootstrap.Col,
                    (0, _extends3.default)({}, cols, { md: outsideLabel ? 12 : cols.md || 6 }),
                    addressOptions && !!addressOptions.size && _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)("select-container otrl-postal-address-select", { "postal-address-select--outside-label": outsideLabel }) },
                        _react2.default.createElement(
                            _Select2.default,
                            { type: 'select',
                                onChange: this.handleSelectAddress,
                                defaultValue: '',
                                label: (0, _I18n2.default)('postcode-lookup.select.placeholder'),
                                labelClassName: 'sr-only' },
                            _react2.default.createElement(
                                'option',
                                { value: '', disabled: true },
                                (0, _I18n2.default)('postcode-lookup.select.placeholder')
                            ),
                            addressOptions.map(function (option, index) {
                                return _react2.default.createElement(
                                    'option',
                                    { value: option.toString(), key: index },
                                    option.toString()
                                );
                            })
                        )
                    ),
                    addressOptions && !addressOptions.size && showInvalidError && _react2.default.createElement(_Error2.default, { className: 'postcode-lookup__error',
                        message: (0, _I18n2.default)('postcode-lookup.error.invalid') }),
                    addressOptions && !addressOptions.size && showNotFoundError && _react2.default.createElement(_Error2.default, { className: 'postcode-lookup__error',
                        message: (0, _I18n2.default)('postcode-lookup.error.not-found') })
                )
            )
        );
    };

    return PostCodeLookUp;
}(_react2.default.PureComponent), _class.propTypes = {
    country: _propTypes2.default.string.isRequired,
    onSelectAddress: _propTypes2.default.func.isRequired,
    onFoundAddressList: _propTypes2.default.func,
    cols: _propTypes2.default.object,
    disabled: _propTypes2.default.bool,
    enablePostCodeLookUp: _propTypes2.default.bool,
    outsideLabel: _propTypes2.default.bool

}, _class.defaultProps = {
    cols: { xs: 12 },
    disabled: false,
    enablePostCodeLookUp: true,
    onFoundAddressList: _noop3.default
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default], _getStateFromStores)(PostCodeLookUp);

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    cardHolderName: '',
    cardNumber: '',
    expiryMonth: 0,
    expiryYear: 0,
    cv2: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    townCity: '',
    postcode: '',
    country: 'GBR',
    store: false,
    nickname: null,
    storedCard: null
};

var CardForm = function (_record) {
    (0, _inherits3.default)(CardForm, _record);

    function CardForm() {
        (0, _classCallCheck3.default)(this, CardForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CardForm.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new CardForm(json);
    };

    CardForm.prototype.getComputedValues = function getComputedValues() {
        // momentjs is creating dates from invalid strings like `01-Expiry year`
        var expiryMonth = parseInt(this.expiryMonth, 10);
        var expiryYear = parseInt(this.expiryYear, 10);
        var isExpired = (0, _moment2.default)().isAfter((0, _moment2.default)(expiryMonth + '-' + expiryYear, 'MM-YYYY').endOf('month'));

        return {
            isExpired: Boolean(expiryMonth) && Boolean(expiryYear) && isExpired
        };
    };

    CardForm.prototype.getSchema = function getSchema() {
        if (this.storedCard) {
            return {
                storedCard: _joi2.default.any(),
                cv2: _validation2.default.cv2()
            };
        }

        return {
            cardHolderName: _validation2.default.cardHolderName(),
            cardNumber: _validation2.default.cardNumber(),
            expiryMonth: _validation2.default.expiryMonth(),
            expiryYear: _validation2.default.expiryYear(),
            cv2: _validation2.default.cv2(),
            store: _joi2.default.boolean(),
            nickname: _joi2.default.any().when('store', {
                is: true,
                then: _validation2.default.name(1, 20),
                otherwise: _joi2.default.any()
            }),
            addressLine1: _validation2.default.addressLine().required(),
            addressLine2: _validation2.default.textMaxLength(),
            addressLine3: _validation2.default.textMaxLength(),
            townCity: _validation2.default.townCity(),
            postcode: _joi2.default.any().when('country', {
                is: defaults.country,
                then: _validation2.default.postcode(),
                otherwise: _validation2.default.optional()
            }),
            country: _validation2.default.country(),
            isExpired: _joi2.default.boolean().optional().only(false).options({
                language: {
                    any: {
                        allowOnly: (0, _I18n.translate)('alertmessage.cardExpired')
                    }
                }
            })
        };
    };

    CardForm.prototype.getAddress = function getAddress() {
        return new _Address2.default({
            line1: this.addressLine1,
            line2: this.addressLine2,
            line3: this.addressLine3,
            town: this.townCity,
            postCode: this.postcode,
            country: this.country
        });
    };

    CardForm.prototype.debugPrint = function debugPrint() {
        return [this.addressLine1, this.addressLine2, this.addressLine3, this.townCity, this.postcode, this.country].join(', ');
    };

    CardForm.prototype.setAddress = function setAddress(address) {
        return this.merge({
            addressLine1: address.line1,
            addressLine2: address.line2,
            addressLine3: address.line3,
            townCity: address.town,
            postcode: address.postCode,
            country: address.country
        });
    };

    return CardForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(CardForm.prototype, _ValidationMixin2.default);

exports.default = CardForm;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.StationFinderStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationFinderState = new _immutable.Record({
    latitude: null,
    longitude: null,
    error: null,
    stations: new _immutable.List(),
    isExpanded: false
});

var StationFinderStore = exports.StationFinderStore = function (_BaseStore) {
    (0, _inherits3.default)(StationFinderStore, _BaseStore);

    function StationFinderStore() {
        (0, _classCallCheck3.default)(this, StationFinderStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    StationFinderStore.prototype.getInitialState = function getInitialState() {
        return new StationFinderState();
    };

    StationFinderStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.STATION_FINDER_SEARCH_STARTED] = this.handleSearchStarted, _ref[_AppConstants.ActionTypes.STATION_FINDER_SEARCH_COMPLETE] = this.handleSearchComplete, _ref[_AppConstants.ActionTypes.STATION_FINDER_SEARCH_FAILED] = this.handleSearchFailed, _ref[_AppConstants.ActionTypes.STATION_FINDER_STATIONS_CLEARED] = this.handleStationsCleared, _ref[_AppConstants.ActionTypes.STATION_FINDER_ERROR_CLEARED] = this.handleErrorCleared, _ref[_AppConstants.ActionTypes.STATION_FINDER_SET_EXPANDED] = this.handleExpand, _ref;
    };

    StationFinderStore.prototype.getBounds = function getBounds() {
        var stations = this.state.stations;

        var boundsArray = [];
        if (this.state.latitude && this.state.longitude) {
            boundsArray.push({ lat: this.state.latitude, lng: this.state.longitude });
        }

        if (!stations || !stations.size) {
            return boundsArray;
        }

        stations.map(function (s) {
            return boundsArray.push(s.getLatLng());
        });
        return boundsArray;
    };

    StationFinderStore.prototype.handleSearchStarted = function handleSearchStarted(_ref2) {
        var latitude = _ref2.latitude,
            longitude = _ref2.longitude;

        this.setState(this.state.merge({
            error: null,
            latitude: latitude,
            longitude: longitude,
            stations: new _immutable.List()
        }));
    };

    StationFinderStore.prototype.handleSearchComplete = function handleSearchComplete(_ref3) {
        var stations = _ref3.stations;

        this.setState(this.state.set('stations', stations));
    };

    StationFinderStore.prototype.handleStationsCleared = function handleStationsCleared() {
        this.setState(this.state.set('stations', new _immutable.List()));
    };

    StationFinderStore.prototype.handleErrorCleared = function handleErrorCleared() {
        this.setState(this.state.set('error', null));
    };

    StationFinderStore.prototype.handleExpand = function handleExpand(_ref4) {
        var value = _ref4.value;

        this.setState(this.state.set('isExpanded', value));
    };

    StationFinderStore.prototype.handleSearchFailed = function handleSearchFailed(_ref5) {
        var error = _ref5.error;

        this.setState(this.state.set('error', error));
    };

    return StationFinderStore;
}(_BaseStore3.default);

exports.default = new StationFinderStore();

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _Immutable = __webpack_require__(54);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _Currency = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    note: null,
    reason: null,
    fares: new _immutable.Map(),
    voucherAmount: 0,
    feePaid: false,
    maxCashReturn: 0,
    plusBus: new _immutable.Map(),
    isSmartcard: false,
    itsoAnnualGoldCardAccepted: false, // Checkbox for annual customers only, that have a Goldcard
    shouldSurrenderGoldCard: false,
    itsoWMCAccepted: false, // Checkbox for weekly, monthly and custom customers
    isWMC: false,
    totalUsed: 0,
    bookingFee: 0,
    googlePayAmount: 0,
    applePayAmount: 0,
    braintreeCardPaymentAmount: 0
};

var RefundRequest = function (_record) {
    (0, _inherits3.default)(RefundRequest, _record);

    function RefundRequest() {
        (0, _classCallCheck3.default)(this, RefundRequest);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    RefundRequest.prototype.getComputedValues = function getComputedValues() {
        return {
            reason: this.reasonCode,
            tickets: this.tickets.size,
            total: this.total,
            totalUsed: this.totalUsed,
            itsoAnnualGoldCardAccepted: this.itsoAnnualGoldCardAccepted,
            itsoWMCAccepted: this.itsoWMCAccepted
        };
    };

    RefundRequest.prototype.getSchema = function getSchema() {
        return {
            note: this.getIn(['reason', 'moreDetailsRequired'], false) ? _validation2.default.requiredString(1, 300) : _joi2.default.any(),
            reason: !this.isSmartcard ? _joi2.default.any().required() : _joi2.default.any(),
            tickets: _joi2.default.number().min(1),
            total: _joi2.default.number().min(1),
            totalUsed: _joi2.default.number(),
            itsoAnnualGoldCardAccepted: this.isSmartcard && this.shouldSurrenderGoldCard ? _validation2.default.true().required() : _joi2.default.boolean(),
            itsoWMCAccepted: this.isSmartcard && this.isWMC ? _validation2.default.true().required() : _joi2.default.boolean()
        };
    };

    RefundRequest.prototype.hasValidSelection = function hasValidSelection(trip) {
        var _this2 = this;

        var fares = this.fares.keySeq().toSet();
        return !!fares.size && fares.every(function (fare) {
            return !_this2.getFareWarnings(fare, trip);
        });
    };

    RefundRequest.prototype.hasChildFlatFareWarning = function hasChildFlatFareWarning(fare, selectedTickets, remainingTickets) {
        var hasChildFlatFareTickets = fare && fare.tickets && fare.tickets.some(function (ticket) {
            return ticket.isChildFlatFare();
        });

        var hasSelectedTickets = selectedTickets && selectedTickets.size > 0;

        if (!hasSelectedTickets || !hasChildFlatFareTickets) {
            return false;
        }

        var numRemainingAdultTickets = remainingTickets.reduce(function (total, ticket) {
            return total + (ticket.adults ? 1 : 0);
        }, 0);

        var numRemainingChildFlatTickets = remainingTickets.reduce(function (total, ticket) {
            return total + (ticket.isChildFlatFare() ? 1 : 0);
        }, 0);

        var hasRemainingAdultTickets = numRemainingAdultTickets > 0;

        var hasRemainingChildFlatTickets = numRemainingChildFlatTickets > 0;

        // Check if there are any remaining child flat tickets left to select
        // before issuing a warning (crucial for GroupSave to work)
        return !hasRemainingAdultTickets && hasRemainingChildFlatTickets;
    };

    RefundRequest.prototype.hasNotSelectedAllChildren = function hasNotSelectedAllChildren(fare, selectedTickets, remainingTickets) {
        var hasChildTickets = fare && fare.tickets && fare.tickets.some(function (ticket) {
            return ticket.isChildTicket();
        });
        var hasSelectedTickets = selectedTickets && selectedTickets.size > 0;
        var hasSelectedAdultTicket = hasSelectedTickets ? selectedTickets.some(function (ticket) {
            return ticket.adults;
        }) : false;
        var numRemainingChildTickets = remainingTickets.reduce(function (total, ticket) {
            return total + (ticket.isChildTicket() ? 1 : 0);
        }, 0);
        var hasRemainingChildTickets = numRemainingChildTickets > 0;

        if (hasSelectedTickets && hasChildTickets && hasSelectedAdultTicket && hasRemainingChildTickets) {
            return true;
        }

        return false;
    };

    RefundRequest.prototype.getFareWarnings = function getFareWarnings(fare, trip) {
        var selectedTickets = this.fares.get(fare);
        var remainingTickets = fare.getRefundableTickets().toSet().subtract(selectedTickets);
        var railcards = fare.getRailcards(remainingTickets);
        var warnings = railcards.reduce(function (result, railcard) {
            var railcardTickets = fare.getTicketsWithRailCard(railcard, remainingTickets);
            return railcardTickets.isValid() ? result : result.add('account.orders.refund.warning.' + railcard.code);
        }, new _immutable.Set());

        if (trip.hasPlusBus() && trip.hasFare(fare) && !this.plusBusValid(selectedTickets, trip, fare)) {
            warnings = warnings.add('account.orders.refund.warning.requiresPlusBus');
        }

        if (this.hasChildFlatFareWarning(fare, selectedTickets, remainingTickets)) {
            warnings = warnings.add('account.orders.refund.warning.childFlatFare');
        }

        if (this.hasNotSelectedAllChildren(fare, selectedTickets, remainingTickets)) {
            warnings = warnings.add('account.orders.refund.warning.notAllChildrenAdded');
        }

        return warnings.size ? warnings : null;
    };

    RefundRequest.prototype.plusBusValid = function plusBusValid(selectedTickets, trip, fare) {
        var _this3 = this;

        if (!!selectedTickets && !fare.isPlusBus()) {
            var tripPlusbus = trip.getProducts().filter(function (f) {
                return f.isPlusBus() && f.hasRefundableTickets();
            });
            var tripPlusbusTickets = tripPlusbus.map(function (f) {
                return f.tickets;
            }).flatten(1);

            if (tripPlusbus.size <= 0) {
                // there are no refundable plusbus tickets so
                // nothing to worry about
                return true;
            }

            if (!this.plusBus.size > 0) {
                return false;
            }

            var selectedTripPlusbus = trip.getProducts().map(function (f) {
                if (_this3.plusBus.has(f)) {
                    return _this3.plusBus.get(f);
                }
                return new _immutable.Set();
            }).flatten(1);

            // if there's only plusbus selected, then it's fine
            if (this.plusBus.size > 0 && selectedTickets.size === 0) {
                return true;
            }
            // ticket can have multiple plus bus
            return selectedTripPlusbus.size === tripPlusbusTickets.size;
        }

        return true;
    };

    RefundRequest.prototype.addTicket = function addTicket(ticket, fare, calculation) {
        var fares = void 0;
        if (this.fares.has(fare)) {
            fares = this.fares.set(fare, this.fares.get(fare).add(ticket));
        } else {
            fares = this.fares.set(fare, _immutable.Set.of(ticket));
        }

        var plusBus = this.plusBus;
        if (fare.isPlusBus() && this.plusBus.has(fare)) {
            plusBus = this.plusBus.set(fare, this.plusBus.get(fare).add(ticket));
        } else if (fare.isPlusBus()) {
            plusBus = this.plusBus.set(fare, _immutable.Set.of(ticket));
        }

        var totalUsed = this.totalUsed;

        if (calculation) {
            totalUsed += calculation.totalUsed;
        }

        return this.set('fares', fares).set('plusBus', plusBus).setTotalUsed(totalUsed);
    };

    RefundRequest.prototype.removeTicket = function removeTicket(ticket, fare, calculation) {
        var fares = this.fares.set(fare, this.fares.get(fare).remove(ticket));
        if (this.fares.get(fare).size === 0) {
            this.fares.remove(fare);
        }

        var plusBus = this.plusBus;
        if (fare.isPlusBus()) {
            plusBus = this.plusBus.set(fare, this.plusBus.get(fare).remove(ticket));

            if (this.plusBus.get(fare).size === 0) {
                this.plusBus.remove(fare);
            }
        }

        var totalUsed = this.totalUsed;

        if (calculation) {
            totalUsed -= calculation.totalUsed;
        }

        return this.set('fares', fares).set('plusBus', plusBus).setTotalUsed(totalUsed);
    };

    RefundRequest.prototype.clearFares = function clearFares() {
        return this.set('fares', new _immutable.Map());
    };

    RefundRequest.prototype.setFeePaid = function setFeePaid() {
        return this.set('feePaid', true);
    };

    RefundRequest.prototype.setIsSmartcard = function setIsSmartcard() {
        return this.set('isSmartcard', true);
    };

    RefundRequest.prototype.setIsWMC = function setIsWMC() {
        return this.set('isWMC', true);
    };

    RefundRequest.prototype.setShouldSurrenderGoldCard = function setShouldSurrenderGoldCard() {
        return this.set('shouldSurrenderGoldCard', true);
    };

    RefundRequest.prototype.setRequestChecks = function setRequestChecks(field, value) {
        return this.set(field, value);
    };

    RefundRequest.prototype.setTotalUsed = function setTotalUsed(value) {
        return this.set('totalUsed', value);
    };

    RefundRequest.prototype.setVoucherAmount = function setVoucherAmount(amount) {
        var voucherAmount = amount;

        if (!amount || amount < this.minVoucherAmount) {
            voucherAmount = this.minVoucherAmount;
        } else if (amount > this.total) {
            voucherAmount = this.total;
        }

        return this.set('voucherAmount', voucherAmount);
    };

    RefundRequest.prototype.setGooglePayAmount = function setGooglePayAmount(amount) {
        return this.set('googlePayAmount', amount);
    };

    RefundRequest.prototype.setApplePayAmount = function setApplePayAmount(amount) {
        return this.set('applePayAmount', amount);
    };

    RefundRequest.prototype.setBraintreeCardPaymentAmount = function setBraintreeCardPaymentAmount(amount) {
        return this.set('braintreeCardPaymentAmount', amount);
    };

    RefundRequest.prototype.setBookingFee = function setBookingFee(value) {
        return this.set('bookingFee', value);
    };

    (0, _createClass3.default)(RefundRequest, [{
        key: 'tickets',
        get: function get() {
            return this.fares.toSet().flatten(true);
        }
    }, {
        key: 'reasonCode',
        get: function get() {
            return this.getIn(['reason', 'code']);
        }
    }, {
        key: 'subTotal',
        get: function get() {
            return (0, _Immutable.sum)(this.tickets, 'price') + this.bookingFee;
        }
    }, {
        key: 'fee',
        get: function get() {
            return this.feePaid ? 0 : this.getIn(['reason', 'fee'], 0);
        }
    }, {
        key: 'total',
        get: function get() {
            if (this.isSmartcard) {
                return this.subTotal - this.totalUsed - this.fee - this.bookingFee;
            }
            return this.subTotal - this.fee - this.bookingFee;
        }
    }, {
        key: 'cardAmount',
        get: function get() {
            return this.total - this.voucherAmount;
        }
    }, {
        key: 'paypalAmount',
        get: function get() {
            return this.total - this.voucherAmount;
        }
    }, {
        key: 'amazonPayAmount',
        get: function get() {
            return this.total - this.voucherAmount;
        }
    }, {
        key: 'googlePayAmount',
        get: function get() {
            return this.total - this.voucherAmount;
        }
    }, {
        key: 'applePayAmount',
        get: function get() {
            return this.total - this.voucherAmount;
        }
    }, {
        key: 'braintreeCardPaymentAmount',
        get: function get() {
            return this.total - this.voucherAmount;
        }
    }, {
        key: 'voucherAmountPound',
        get: function get() {
            return (0, _Currency.toPounds)(this.voucherAmount);
        }
    }, {
        key: 'minVoucherAmount',
        get: function get() {
            var amount = this.total - this.maxCashReturn;

            return amount > 0 ? amount : 0;
        }
    }]);
    return RefundRequest;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(RefundRequest.prototype, _ValidationMixin2.default);

exports.default = RefundRequest;

/***/ }),
/* 993 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _AmazonLoginActions = __webpack_require__(291);

var _AmazonLoginActions2 = _interopRequireDefault(_AmazonLoginActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _AmazonLoginCTA = __webpack_require__(929);

var _AmazonLoginCTA2 = _interopRequireDefault(_AmazonLoginCTA);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Form = __webpack_require__(1158);

var _Form2 = _interopRequireDefault(_Form);

var _LoginModalHeader = __webpack_require__(2034);

var _LoginModalHeader2 = _interopRequireDefault(_LoginModalHeader);

var _LoginModalFooter = __webpack_require__(2035);

var _LoginModalFooter2 = _interopRequireDefault(_LoginModalFooter);

var _OrBar = __webpack_require__(680);

var _OrBar2 = _interopRequireDefault(_OrBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        enableAmazonLogin: _FeatureFlagStore2.default.get('enableAmazonLogin'),
        isMobileWidth: _DimensionsStore2.default.isMobileWidth()
    };
};

var LoginModal = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(LoginModal, _React$PureComponent);

    function LoginModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LoginModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            isAmazonLoginChosen: false,
            isLoginFormComplete: false
        }, _this.closeModal = function () {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref$canRedirect = _ref.canRedirect,
                canRedirect = _ref$canRedirect === undefined ? true : _ref$canRedirect;

            (0, _defer3.default)(function () {
                _ModalActions2.default.close(_AppConstants.GlobalModals.LOGIN);
                _this.props.onCancel({ canRedirect: canRedirect });
            });
        }, _this._handleCancel = function () {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref2$canRedirect = _ref2.canRedirect,
                canRedirect = _ref2$canRedirect === undefined ? false : _ref2$canRedirect;

            _AmazonLoginActions2.default.resetStateToIdle();
            _this.closeModal({ canRedirect: canRedirect });
        }, _this.handleRegister = function () {
            _this.props.onCancel({ canRedirect: false });
            _ModalActions2.default.open(_AppConstants.GlobalModals.REGISTER, {
                onSuccessClose: _this.props.onRegisterSuccessClose
            });
        }, _this.onAmazonButtonClick = function () {
            _this.setState({ isAmazonLoginChosen: true });
        }, _this.onUserFieldBlur = function (_field, _value, resetVisited) {
            if (_this.state.isAmazonLoginChosen) {
                resetVisited();
            }
        }, _this.onFormChange = function (form) {
            _this.setState({ isLoginFormComplete: form.isComplete() });
        }, _this.onUserFieldChange = function () {
            // User has typed his username. He's probably given up on login via Amazon Login.
            // Start showing username's field errors.
            _this.setState({ isAmazonLoginChosen: false });
        }, _this.renderModal = function (props) {
            var modalProps = {
                onClose: _this._handleCancel,
                onContinue: props.onLogin,
                className: 'modal--login modal--xs',
                titleText: _this.props.titleText,
                disableContinue: props.isLoggingIn,
                header: _react2.default.createElement(_LoginModalHeader2.default, {
                    closeModal: _this.closeModal,
                    handleRegister: _this.props.handleRegister || _this.handleRegister,
                    onClose: _this._handleCancel,
                    hideClose: _this.props.hideClose
                }),
                footer: _react2.default.createElement(_LoginModalFooter2.default, {
                    handleLogin: props.onLogin,
                    handleRegister: _this.props.handleRegister || _this.handleRegister,
                    nextButtonActive: true
                }),
                headerClass: 'modal__header',
                isAutofocusing: true,
                useFlex: true,
                bodyAriaLabel: (0, _I18n2.default)('login.modal.body.ariaLabel'),
                disableBlur: _this.props.disableBlur,
                disableEscape: _this.props.disableEscape
            };

            var hasLoginProviders = _this.props.enableAmazonLogin;

            return _react2.default.createElement(
                _BaseModal2.default,
                modalProps,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'login' },
                        _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enableAmazonLogin' },
                            _react2.default.createElement(
                                'section',
                                { className: 'login__providers' },
                                _react2.default.createElement(_AmazonLoginCTA2.default, {
                                    closeModal: _this.closeModal,
                                    onButtonClick: _this.onAmazonButtonClick,
                                    isVertical: true
                                }),
                                _react2.default.createElement(_OrBar2.default, { isTablet: true })
                            )
                        ),
                        _react2.default.createElement(
                            'section',
                            { className: (0, _classnames2.default)('login__standard', { 'login__standard--no-providers': !hasLoginProviders }) },
                            _react2.default.createElement(
                                _Row2.default,
                                null,
                                _react2.default.createElement(
                                    _Col2.default,
                                    { xs: 12 },
                                    _react2.default.createElement(
                                        'h1',
                                        { className: 'login__heading' },
                                        _this.props.isMobileWidth ? (0, _I18n2.default)('login.subtitle') : (0, _I18n2.default)('account.login')
                                    ),
                                    _this.props.moreInfoText && _react2.default.createElement(
                                        'p',
                                        { className: 'login__more-info' },
                                        (0, _I18n2.default)('' + _this.props.moreInfoText)
                                    ),
                                    props.loginComponent
                                )
                            )
                        )
                    )
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    LoginModal.prototype.render = function render() {
        var _props = this.props,
            registerTitleText = _props.registerTitleText,
            titleText = _props.titleText,
            onLogin = _props.onLogin,
            onCancel = _props.onCancel,
            onCancelRegister = _props.onCancelRegister,
            onRegisterSuccessClose = _props.onRegisterSuccessClose,
            forceSmartcardSignup = _props.forceSmartcardSignup,
            onCloseSmartcardError = _props.onCloseSmartcardError,
            hideSmartcardCheckbox = _props.hideSmartcardCheckbox,
            hideSmartcardPromotionalText = _props.hideSmartcardPromotionalText,
            withISRN = _props.withISRN,
            disableSuccessDropdown = _props.disableSuccessDropdown,
            onSmartcardSuccess = _props.onSmartcardSuccess,
            emailDefaultValue = _props.emailDefaultValue,
            withoutNotifications = _props.withoutNotifications,
            isBrochureRedirect = _props.isBrochureRedirect,
            isMobileWidth = _props.isMobileWidth,
            initialPath = _props.initialPath;


        var handleLogin = function handleLogin() {
            _ModalActions2.default.close(_AppConstants.GlobalModals.LOGIN);
            onLogin();
        };

        return _react2.default.createElement(
            _Form2.default,
            {
                onLogin: handleLogin,
                registerTitleText: registerTitleText,
                titleText: titleText,
                onCancel: onCancel,
                onCancelRegister: onCancelRegister,
                onRegisterSuccessClose: onRegisterSuccessClose,
                onFormChange: this.onFormChange,
                forceSmartcardSignup: forceSmartcardSignup,
                disableSuccessDropdown: disableSuccessDropdown,
                onUserFieldBlur: this.onUserFieldBlur,
                onUserFieldChange: this.onUserFieldChange,
                onSmartcardSuccess: onSmartcardSuccess,
                emailDefaultValue: emailDefaultValue,
                hideSmartcardCheckbox: hideSmartcardCheckbox,
                hideSmartcardPromotionalText: hideSmartcardPromotionalText,
                onCloseSmartcardError: onCloseSmartcardError,
                withISRN: withISRN,
                withoutNotifications: withoutNotifications,
                isBrochureRedirect: isBrochureRedirect,
                isMobileWidth: isMobileWidth,
                initialPath: initialPath
            },
            this.renderModal
        );
    };

    return LoginModal;
}(_react2.default.PureComponent), _class.propTypes = {
    titleText: _propTypes2.default.string,
    registerTitleText: _propTypes2.default.string,
    onLogin: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    onCancelRegister: _propTypes2.default.func,
    onRegisterSuccessClose: _propTypes2.default.func,
    moreInfoText: _propTypes2.default.string,
    forceSmartcardSignup: _propTypes2.default.bool,
    onCloseSmartcardError: _propTypes2.default.func,
    hideSmartcardCheckbox: _propTypes2.default.bool,
    hideSmartcardPromotionalText: _propTypes2.default.bool,
    withISRN: _propTypes2.default.bool,
    disableSuccessDropdown: _propTypes2.default.bool,
    onSmartcardSuccess: _propTypes2.default.func,
    emailDefaultValue: _propTypes2.default.string,
    withoutNotifications: _propTypes2.default.bool,
    enableAmazonLogin: _propTypes2.default.bool,
    isMobileWidth: _propTypes2.default.bool,
    disableBlur: _propTypes2.default.bool,
    disableEscape: _propTypes2.default.bool,
    hideClose: _propTypes2.default.bool,
    handleRegister: _propTypes2.default.func,
    isBrochureRedirect: _propTypes2.default.bool,
    initialPath: _propTypes2.default.string
}, _class.defaultProps = {
    titleText: 'account.login',
    registerTitleText: 'account.register',
    onLogin: _noop3.default,
    onCancel: _noop3.default,
    onCancelRegister: _noop3.default,
    onRegisterSuccessClose: _noop3.default,
    onCloseSmartcardError: _noop3.default,
    moreInfoText: null,
    forceSmartcardSignup: false,
    hideSmartcardCheckbox: false,
    hideSmartcardPromotionalText: false,
    withISRN: false,
    disableSuccessDropdown: false,
    onSmartcardSuccess: _noop3.default,
    emailDefaultValue: null,
    withoutNotifications: false,
    enableAmazonLogin: false,
    isMobileWidth: false,
    disableBlur: false,
    disableEscape: false,
    hideClose: false,
    handleRegister: null,
    isBrochureRedirect: false,
    initialPath: ''
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default, _DimensionsStore2.default], _getStateFromStores)(LoginModal);

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _trim2 = __webpack_require__(1140);

var _trim3 = _interopRequireDefault(_trim2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _VoucherForm = __webpack_require__(1099);

var _VoucherForm2 = _interopRequireDefault(_VoucherForm);

var _CardForm = __webpack_require__(989);

var _CardForm2 = _interopRequireDefault(_CardForm);

var _ContactForm = __webpack_require__(1863);

var _ContactForm2 = _interopRequireDefault(_ContactForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    vouchers: [_LinkMapper.resolve.as(_VoucherForm2.default), new _VoucherForm2.default()],
    card: [_LinkMapper.resolve.as(_CardForm2.default), new _CardForm2.default()],
    contact: [_LinkMapper.resolve.as(_ContactForm2.default), new _ContactForm2.default()],
    paymentMethod: [_LinkMapper.fields.string, null],
    isLoggedIn: [_LinkMapper.fields.boolean, false],
    visaCards: [_LinkMapper.resolveAll.with(Object)],
    discountCode: [_LinkMapper.fields.string, ""]
};

var PaymentForm = function (_record) {
    (0, _inherits3.default)(PaymentForm, _record);

    function PaymentForm() {
        (0, _classCallCheck3.default)(this, PaymentForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PaymentForm.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(PaymentForm, (0, _defaults3.default)(json, (0, _Records.getDefaults)(schema)), (0, _Records.getResolvers)(schema));
    };

    PaymentForm.prototype.getComputedValues = function getComputedValues() {
        var values = this.getPaymentRecords().map(_ValidationMixin.getValues);
        return _assign2.default.apply(Object, [{}].concat(values, [this.contact.toJS()]));
    };

    PaymentForm.prototype.getSchema = function getSchema() {
        var schemas = this.getPaymentRecords().map(function (form) {
            return form.getSchema();
        });

        if (!this.isLoggedIn && this.isCardPayment() && this.requiresPayment()) {
            schemas.push(this.contact.getSchema());
        }

        return _assign2.default.apply(Object, [{
            paymentMethod: _joi2.default.string().required(),
            discountCode: _joi2.default.string().allow('').trim().optional().min(3).max(100).options({
                language: {
                    any: {
                        empty: (0, _I18n.translate)('alertmessage.badDiscountCode')
                    },
                    string: {
                        base: (0, _I18n.translate)('alertmessage.badDiscountCode'),
                        min: (0, _I18n.translate)('alertmessage.badDiscountCode'),
                        max: (0, _I18n.translate)('alertmessage.badDiscountCode')
                    }
                }
            })
        }].concat(schemas));
    };

    PaymentForm.prototype.debugPrintCard = function debugPrintCard() {
        return this.card.debugPrint();
    };

    PaymentForm.prototype.canUseVouchers = function canUseVouchers() {
        return !!this.vouchers.vouchersTotal;
    };

    PaymentForm.prototype.hasVoucherPayment = function hasVoucherPayment() {
        return this.getVoucherAmount() > 0;
    };

    PaymentForm.prototype.getVoucherAmount = function getVoucherAmount() {
        return this.canUseVouchers() && this.vouchers.useVouchers ? this.vouchers.voucherAmountPence : 0;
    };

    PaymentForm.prototype.getPreAuthVoucherAmount = function getPreAuthVoucherAmount() {
        return this.requiresPreAuthVouchers() ? this.getVoucherAmount() : 0;
    };

    PaymentForm.prototype.requiresPayment = function requiresPayment() {
        return this.getPaymentAmount() > 0;
    };

    PaymentForm.prototype.requiresPreAuthVouchers = function requiresPreAuthVouchers() {
        if (this.hasVoucherPayment() && this.getPaymentAmount() === 0) {
            // must NOT pre-auth if the payment is voucher-only
            return false;
        } else if (!this.isCardPayment() && !this.isVisaCheckout()) {
            // All payment methods _except_ Pay360 API & Visa Checkout support pre-auth
            return true;
        }
        return false;
    };

    PaymentForm.prototype.getPaymentAmount = function getPaymentAmount() {
        var _vouchers = this.vouchers,
            voucherAmountPence = _vouchers.voucherAmountPence,
            basketTotal = _vouchers.basketTotal;

        if (this.hasVoucherPayment()) {
            var amount = basketTotal - voucherAmountPence;
            return Math.max(0, amount);
        } else {
            return basketTotal;
        }
    };

    PaymentForm.prototype.isAmazonPay = function isAmazonPay() {
        return this.paymentMethod === _AppConstants.PaymentType.AMAZON_PAY;
    };

    PaymentForm.prototype.isPayPal = function isPayPal() {
        return this.paymentMethod === _AppConstants.PaymentType.PAYPAL;
    };

    PaymentForm.prototype.isCardPayment = function isCardPayment() {
        return this.paymentMethod === _AppConstants.PaymentType.CARD;
    };

    PaymentForm.prototype.isVisaCheckout = function isVisaCheckout() {
        return this.paymentMethod === _AppConstants.PaymentType.VISA_CHECKOUT;
    };

    PaymentForm.prototype.isPay360Hosted = function isPay360Hosted() {
        return this.paymentMethod === _AppConstants.PaymentType.PAY360_HOSTED;
    };

    PaymentForm.prototype.isBraintreeCardPayment = function isBraintreeCardPayment() {
        return this.paymentMethod === _AppConstants.PaymentType.BRAINTREE_CARD_CHECKOUT;
    };

    PaymentForm.prototype.hasStoredCard = function hasStoredCard() {
        return this.isCardPayment() && this.card.storedCard;
    };

    PaymentForm.prototype.getPaymentRecords = function getPaymentRecords() {
        var methods = [];
        if (this.hasVoucherPayment()) {
            methods.push(this.vouchers);
        }
        if (this.isCardPayment() && this.requiresPayment()) {
            methods.push(this.card);
        }
        return methods;
    };

    PaymentForm.prototype.setAddress = function setAddress(address) {
        return this.set('card', this.card.setAddress(address));
    };

    PaymentForm.prototype.getVouchersTotal = function getVouchersTotal() {
        return this.getIn(['vouchers', 'total']);
    };

    PaymentForm.prototype.setVouchersTotal = function setVouchersTotal(total, preAuthedAmount) {
        return this.set('vouchers', this.vouchers.setVouchersTotal(total, preAuthedAmount));
    };

    PaymentForm.prototype.setBasketTotal = function setBasketTotal(total) {
        return this.set('vouchers', this.vouchers.setBasketTotal(total));
    };

    PaymentForm.prototype.setContactDetails = function setContactDetails(email, phone) {
        return this.set('contact', this.contact.setContactDetails(email, phone));
    };

    PaymentForm.prototype.hasPendingDiscountCode = function hasPendingDiscountCode() {
        // discountCode is emptied after it is applied
        return (0, _trim3.default)(this.discountCode).length > 0;
    };

    (0, _createClass3.default)(PaymentForm, [{
        key: 'basketTotal',
        get: function get() {
            return this.getIn(['vouchers', 'basketTotal'], 0);
        }
    }]);
    return PaymentForm;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

(0, _assign2.default)(PaymentForm.prototype, _ValidationMixin2.default);

exports.default = PaymentForm;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AccountRailcard = __webpack_require__(437);

var _AccountRailcard2 = _interopRequireDefault(_AccountRailcard);

var _Railcard1617Form = __webpack_require__(1066);

var _Railcard1617Form2 = _interopRequireDefault(_Railcard1617Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Railcard1617Store = function (_BaseStore) {
    (0, _inherits3.default)(Railcard1617Store, _BaseStore);

    function Railcard1617Store() {
        (0, _classCallCheck3.default)(this, Railcard1617Store);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    Railcard1617Store.prototype.getInitialState = function getInitialState() {
        return _BaseStore.prototype.getInitialState.call(this).merge({
            checked: null,
            flashCheckbox: false,
            form: new _Railcard1617Form2.default({
                railcardNumber: '',
                firstName: '',
                lastName: '',
                syncKeyGo: false
            }),
            guestRailcardErrors: new _immutable.Map(),
            isRailcard1617Available: false,
            submitting: false,
            railcard: new _AccountRailcard2.default(),
            railcards: new _immutable.List(),
            validation: new _immutable.Map(),
            validationSuccess: false
        });
    };

    Railcard1617Store.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.handleUserLoggedOut, _ref[_AppConstants.ActionTypes.RAILCARD1617_CHECKED] = this.handleChecked, _ref[_AppConstants.ActionTypes.RAILCARD1617_FLASH_CHECKBOX] = this.handleFlashCheckbox, _ref[_AppConstants.ActionTypes.RAILCARD1617_FORM_CHANGED] = this.handleFormChanged, _ref[_AppConstants.ActionTypes.RAILCARD1617_LOADED] = this.handleLoaded, _ref[_AppConstants.ActionTypes.RAILCARD1617_LOAD_STARTED] = this.handleLoadStarted, _ref[_AppConstants.ActionTypes.RAILCARD1617_REMOVE] = this.handleRemove, _ref[_AppConstants.ActionTypes.RAILCARD1617_RESET_VALIDATION] = this.handleResetValidation, _ref[_AppConstants.ActionTypes.RAILCARD1617_VALIDATION_STARTED] = this.handleValidationStarted, _ref[_AppConstants.ActionTypes.RAILCARD1617_VALIDATION_COMPLETED] = this.handleValidationCompleted, _ref[_AppConstants.ActionTypes.RAILCARD1617_VALIDATION_FAILED] = this.handleValidationFailed, _ref;
    };

    Railcard1617Store.prototype.getForm = function getForm() {
        return this.get('form');
    };

    Railcard1617Store.prototype.getRailcard = function getRailcard() {
        return this.get('railcard');
    };

    Railcard1617Store.prototype.getGuestRailcardErrors = function getGuestRailcardErrors() {
        return this.get('guestRailcardErrors');
    };

    Railcard1617Store.prototype.hasRailcard1617Saver = function hasRailcard1617Saver() {
        return !!(this.get('railcard') && this.get('railcard').railcardCode && this.get('railcard').railcardCode === _AppConstants.RAILCARD1617_CODE);
    };

    Railcard1617Store.prototype.handleChecked = function handleChecked(_ref2) {
        var checked = _ref2.checked;

        this.setState(this.state.merge({ checked: checked }));
    };

    Railcard1617Store.prototype.handleFlashCheckbox = function handleFlashCheckbox(_ref3) {
        var flashCheckbox = _ref3.flashCheckbox;

        this.setState(this.state.merge({ flashCheckbox: flashCheckbox }));
    };

    Railcard1617Store.prototype.handleFormChanged = function handleFormChanged(_ref4) {
        var field = _ref4.field,
            value = _ref4.value;

        var form = this.get('form').set(field, value);

        var validation = this.get('validation').merge(form.getValidationSummary());
        this.setState(this.state.merge({ form: form, validation: validation }));
    };

    Railcard1617Store.prototype.handleLoaded = function handleLoaded(_ref5) {
        var railcards = _ref5.railcards;

        // Pick the railcard with the latest expiry date
        var railcard = railcards.sortBy(function (rc) {
            return rc.getMaximumValidDate().unix();
        }).last();

        // Do not override the existing railcard from the state with a null from the request
        if (railcard) {
            this.setState(this.state.merge({
                isRailcard1617Available: true,
                railcard: railcard,
                railcards: railcards
            }));
        }
    };

    Railcard1617Store.prototype.handleLoadStarted = function handleLoadStarted() {
        this.setState(this.state.merge({
            'isRailcard1617Available': false
        }));
    };

    Railcard1617Store.prototype.handleUserLoggedOut = function handleUserLoggedOut() {
        this.setState(this.getInitialState());
    };

    Railcard1617Store.prototype.handleRemove = function handleRemove() {
        this.setState(this.state.set('railcard', new _AccountRailcard2.default()));
    };

    Railcard1617Store.prototype.handleValidationCompleted = function handleValidationCompleted(_ref6) {
        var railcardNumber = _ref6.railcardNumber,
            firstName = _ref6.firstName,
            lastName = _ref6.lastName,
            expiryDate = _ref6.expiryDate;

        this.setState(this.state.merge({
            checked: true,
            isRailcard1617Available: true,
            railcard: _AccountRailcard2.default.fromJSON({
                expiryDate: expiryDate,
                cardholderName: firstName + ' ' + lastName,
                isGuest: true,
                railcardCode: _AppConstants.RAILCARD1617_CODE,
                railcardNumber: railcardNumber,
                state: 'ACCEPTED'
            }),
            submitting: false,
            validationSuccess: true
        }));
    };

    Railcard1617Store.prototype.handleValidationStarted = function handleValidationStarted() {
        this.setState(this.state.merge({
            guestRailcardErrors: new _immutable.Map(),
            isRailcard1617Available: false,
            submitting: true,
            validationSuccess: false
        }));
    };

    Railcard1617Store.prototype.handleValidationFailed = function handleValidationFailed(_ref7) {
        var message = _ref7.message;

        this.setState(this.state.merge({
            checked: false,
            guestRailcardErrors: new _immutable.Map({ invalid: message || "booking.railcard1617.errors.unknown" }),
            isRailcard1617Available: false,
            railcard: new _AccountRailcard2.default(),
            submitting: false,
            validationSuccess: false
        }));
    };

    Railcard1617Store.prototype.handleResetValidation = function handleResetValidation() {
        this.setState(this.state.merge({ validationSuccess: false }));
    };

    return Railcard1617Store;
}(_BaseStore3.default);

var storeInstance = new Railcard1617Store();

exports.default = storeInstance;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _Immutable = __webpack_require__(54);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _Voucher = __webpack_require__(841);

var _Voucher2 = _interopRequireDefault(_Voucher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherStore = function (_BaseStore) {
    (0, _inherits3.default)(VoucherStore, _BaseStore);

    function VoucherStore() {
        (0, _classCallCheck3.default)(this, VoucherStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    VoucherStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            failed: false,
            loading: false,
            vouchers: new _immutable.List()
        });
    };

    VoucherStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return new _immutable.Map({
                failed: false,
                loading: false,
                vouchers: (0, _LinkMapper.resolveAll)(serialized.fares).as(_Voucher2.default)
            });
        }

        return this.getInitialState();
    };

    VoucherStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.CUSTOMER_VOUCHERS_STARTED] = this.handleStarted, _ref[_AppConstants.ActionTypes.CUSTOMER_VOUCHERS_LOADED] = this.handleLoaded, _ref[_AppConstants.ActionTypes.CUSTOMER_VOUCHERS_FAILED] = this.handleFailed, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref;
    };

    VoucherStore.prototype.handleStarted = function handleStarted() {
        this.setState(this.state.set('failed', false).set('loading', true));
    };

    VoucherStore.prototype.handleLoaded = function handleLoaded(_ref2) {
        var vouchers = _ref2.vouchers;

        this.setState(this.state.set('failed', false).set('loading', true).set('vouchers', vouchers.sortBy(function (voucher) {
            return voucher.expiry.unix();
        })));
    };

    VoucherStore.prototype.handleFailed = function handleFailed() {
        this.setState(this.state.set('failed', true).set('loading', false));
    };

    VoucherStore.prototype.getTotal = function getTotal() {
        return (0, _Immutable.sum)(this.get('vouchers'), 'amount');
    };

    return VoucherStore;
}(_BaseStore3.default);

var instance = new VoucherStore({ storageKey: 'vouchers' });

exports.default = instance;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ButtonSizes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonSizes = exports.ButtonSizes = (0, _keymirror2.default)({
    SM: null,
    MD: null
});

var FavouriteButton = function FavouriteButton(_ref) {
    var _cn;

    var ariaLabel = _ref.ariaLabel,
        className = _ref.className,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        favourite = _ref.favourite,
        _ref$fullWidth = _ref.fullWidth,
        fullWidth = _ref$fullWidth === undefined ? false : _ref$fullWidth,
        loading = _ref.loading,
        onClick = _ref.onClick,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? ButtonSizes.MD : _ref$size,
        _ref$activeText = _ref.activeText,
        activeText = _ref$activeText === undefined ? 'account.orders.favourite.added' : _ref$activeText,
        _ref$notActiveText = _ref.notActiveText,
        notActiveText = _ref$notActiveText === undefined ? 'account.orders.favourite.add' : _ref$notActiveText,
        _ref$noText = _ref.noText,
        noText = _ref$noText === undefined ? false : _ref$noText;

    var baseClass = 'favourite-btn';
    var buttonClassNames = (0, _classnames2.default)(baseClass, 'btn-squarish', (_cn = {}, _cn[baseClass + '--sm'] = size === ButtonSizes.SM, _cn[baseClass + '--full-width'] = fullWidth, _cn), className);

    var iconName = 'favourite-add';
    var iconClassName = void 0;
    if (loading) {
        iconName = 'spinner';
        iconClassName = 'otrl-spin';
    } else if (favourite) {
        iconName = 'favourite';
    }

    var renderText = function renderText() {
        if (noText) {
            return null;
        }
        return _react2.default.createElement(
            'span',
            { className: 'favourite-btn__text' },
            favourite ? (0, _I18n2.default)(activeText) : (0, _I18n2.default)(notActiveText)
        );
    };

    return _react2.default.createElement(
        _Button2.default,
        {
            'aria-label': ariaLabel,
            className: buttonClassNames,
            disabled: loading || disabled,
            onClick: onClick,
            type: 'button'
        },
        _react2.default.createElement(_Icon2.default, { className: iconClassName, icon: iconName }),
        renderText()
    );
};

FavouriteButton.propTypes = {
    ariaLabel: _propTypes2.default.string,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    favourite: _propTypes2.default.instanceOf(_Favourite2.default),
    fullWidth: _propTypes2.default.bool,
    loading: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired,
    size: _propTypes2.default.bool,
    activeText: _propTypes2.default.string,
    notActiveText: _propTypes2.default.string,
    noText: _propTypes2.default.bool
};

exports.default = FavouriteButton;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getPAModalJourneyData = exports.normalizeJourney = exports.normalizeAssistedBooking = exports.normalizeAccessibilityProfile = exports.normalizeJourneyDetails = exports.normalizeNLC = exports.getHourMinutes = exports.normalizeTime = exports.getEditPassengerAssistRequestBody = exports.getBookPassengerAssistRequestBody = exports.getBookPAAccessibilityProfile = exports.bookPAJourneyDetails = exports.normalizeBookPAJourney = exports.areJourneysIdentical = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _immutable = __webpack_require__(5);

var _constants = __webpack_require__(333);

var _text = __webpack_require__(448);

var _PassengerAssistActions = __webpack_require__(334);

var _PassengerAssistActions2 = _interopRequireDefault(_PassengerAssistActions);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _Immutable = __webpack_require__(54);

var _PassengerAssistStore3 = __webpack_require__(173);

var _PassengerAssistStore4 = _interopRequireDefault(_PassengerAssistStore3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var areJourneysIdentical = exports.areJourneysIdentical = function areJourneysIdentical(journey1, journey2) {
    var isMatchingLegsTrainUids = (0, _isEqual3.default)(journey1.legs.map(function (leg) {
        return leg.trainUid || '';
    }).sort(), journey2.legs.map(function (leg) {
        return leg.trainUid || '';
    }).sort());

    return journey1 && journey2 && journey1.origin && journey2.origin && journey1.origin.nlc === journey2.origin.nlc && journey1.destination && journey2.destination && journey1.destination.nlc === journey2.destination.nlc && journey1.departureHour === journey2.departureHour && journey1.arrivalHour === journey2.arrivalHour && journey1.arrivalMinutes === journey2.arrivalMinutes && isMatchingLegsTrainUids;
};

var normalizeBookPAJourney = exports.normalizeBookPAJourney = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(journey) {
        var parsedJourney;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        parsedJourney = (0, _Immutable.isImmutable)(journey) ? journey.toJS() : journey;
                        _context2.next = 3;
                        return _promise2.default.all(parsedJourney.legs.map(function () {
                            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(leg) {
                                var _ref3, departureNLS, _ref4, arrivalNLS, departure, arrival;

                                return _regenerator2.default.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _ref3 = leg.origin || leg.departure, departureNLS = _ref3.nlc;
                                                _ref4 = leg.destination || leg.arrival, arrivalNLS = _ref4.nlc;
                                                _context.next = 4;
                                                return _PassengerAssistActions2.default.getAssistedTravelLocation(departureNLS);

                                            case 4:
                                                departure = _context.sent;
                                                _context.next = 7;
                                                return _PassengerAssistActions2.default.getAssistedTravelLocation(arrivalNLS);

                                            case 7:
                                                arrival = _context.sent;
                                                return _context.abrupt('return', {
                                                    departure: departure,
                                                    arrival: arrival,
                                                    departureDate: leg.departureDate || '',
                                                    departureHour: leg.departureHour || '',
                                                    departureMinutes: leg.departureMinutes || '',
                                                    arrivalDate: leg.arrivalDate || '',
                                                    arrivalHour: leg.arrivalHour || '',
                                                    arrivalMinutes: leg.arrivalMinutes || '',
                                                    trainUid: leg.trainUid || '',
                                                    changeAt: null
                                                });

                                            case 9:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, undefined);
                            }));

                            return function (_x2) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));

                    case 3:
                        return _context2.abrupt('return', _context2.sent);

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function normalizeBookPAJourney(_x) {
        return _ref.apply(this, arguments);
    };
}();

var bookPAJourneyDetails = exports.bookPAJourneyDetails = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(travelAssist) {
        var outwardJourney, returnJourney;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (!travelAssist.hasOutwardJourney()) {
                            _context3.next = 6;
                            break;
                        }

                        _context3.next = 3;
                        return normalizeBookPAJourney(travelAssist.outwardJourney);

                    case 3:
                        _context3.t0 = _context3.sent;
                        _context3.next = 7;
                        break;

                    case 6:
                        _context3.t0 = [];

                    case 7:
                        outwardJourney = _context3.t0;

                        if (!travelAssist.hasReturnJourney()) {
                            _context3.next = 14;
                            break;
                        }

                        _context3.next = 11;
                        return normalizeBookPAJourney(travelAssist.returnJourney);

                    case 11:
                        _context3.t1 = _context3.sent;
                        _context3.next = 15;
                        break;

                    case 14:
                        _context3.t1 = [];

                    case 15:
                        returnJourney = _context3.t1;


                        if (!outwardJourney.length && returnJourney.length) {
                            outwardJourney = returnJourney;
                            returnJourney = [];
                        }

                        return _context3.abrupt('return', { outwardJourney: outwardJourney, returnJourney: returnJourney });

                    case 18:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined);
    }));

    return function bookPAJourneyDetails(_x3) {
        return _ref5.apply(this, arguments);
    };
}();

var getBookPAAccessibilityProfile = exports.getBookPAAccessibilityProfile = function getBookPAAccessibilityProfile(_ref6) {
    var accessibilityProfileForm = _ref6.accessibilityProfileForm;

    var _UserStore$getCurrent = _UserStore2.default.getCurrent(),
        email = _UserStore$getCurrent.email;

    var _ref7 = (0, _Immutable.isImmutable)(accessibilityProfileForm) ? accessibilityProfileForm.toJS() : accessibilityProfileForm,
        title = _ref7.title,
        firstName = _ref7.firstName,
        lastName = _ref7.surname,
        addressLine1 = _ref7.line1,
        addressLine2 = _ref7.line2,
        addressLine3 = _ref7.line3,
        town = _ref7.town,
        county = _ref7.country,
        postCode = _ref7.postCode,
        contactNumber = _ref7.phone,
        contactMethod = _ref7.contactMethod,
        assistanceLocation = _ref7.assistanceLocation,
        otherAssistanceLocation = _ref7.otherAssistanceLocation,
        reasonForAssistance = _ref7.reasonForAssistance,
        otherAssistanceType = _ref7.otherAssistanceType,
        participateSurvey = _ref7.participateSurvey,
        participateImprovementSurvey = _ref7.participateImprovementSurvey,
        pushNotify = _ref7.pushNotify;

    return {
        personalDetails: {
            title: title,
            firstName: firstName,
            lastName: lastName,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            addressLine3: addressLine3,
            town: town,
            county: county,
            postCode: postCode,
            contactNumber: contactNumber,
            email: email
        },
        caseDetails: {
            contactMethod: contactMethod,
            assistanceLocation: assistanceLocation,
            otherAssistanceLocation: otherAssistanceLocation,
            reasonForAssistance: reasonForAssistance,
            otherAssistanceType: reasonForAssistance.includes(_constants.assistanceReasons.OTHER.value) ? otherAssistanceType : '',
            participateSurvey: (0, _text.booleanToYesNo)(participateSurvey).toLowerCase(),
            participateImprovementSurvey: (0, _text.booleanToYesNo)(participateImprovementSurvey).toLowerCase(),
            pushNotify: pushNotify
        }
    };
};

var getBookPassengerAssistRequestBody = exports.getBookPassengerAssistRequestBody = function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var travelAssist, accessibilityProfileForm, journeyDetails, _getBookPAAccessibili, personalDetails, caseDetails, pushNotify;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        travelAssist = payload.travelAssist || _PassengerAssistStore4.default.get('travelAssist');
                        accessibilityProfileForm = _PassengerAssistStore4.default.get('accessibilityProfileForm');
                        _context4.next = 4;
                        return bookPAJourneyDetails(travelAssist);

                    case 4:
                        journeyDetails = _context4.sent;
                        _getBookPAAccessibili = getBookPAAccessibilityProfile({ accessibilityProfileForm: accessibilityProfileForm }), personalDetails = _getBookPAAccessibili.personalDetails, caseDetails = _getBookPAAccessibili.caseDetails;
                        pushNotify = caseDetails.pushNotify;
                        return _context4.abrupt('return', {
                            personalDetails: personalDetails,
                            caseDetails: caseDetails,
                            journeyDetails: (0, _extends3.default)({}, journeyDetails, {
                                pushNotify: pushNotify,
                                orderId: payload.orderId
                            })
                        });

                    case 8:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, undefined);
    }));

    return function getBookPassengerAssistRequestBody() {
        return _ref8.apply(this, arguments);
    };
}();

var getEditPassengerAssistRequestBody = exports.getEditPassengerAssistRequestBody = function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        var travelAssist, accessibilityProfileForm, _PassengerAssistStore, number, sysId, customerId, link, journeyDetails, _PassengerAssistStore2, meetingPoint, bookTicket, ticketReference, _ref10, outwardJourney, returnJourney, _getBookPAAccessibili2, personalDetails, _getBookPAAccessibili3, contactMethod, assistanceLocation, otherAssistanceLocation, reasonForAssistance, otherAssistanceType, participateSurvey, participateImprovementSurvey, pushNotify;

        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        travelAssist = _PassengerAssistStore4.default.get('travelAssist');
                        accessibilityProfileForm = _PassengerAssistStore4.default.get('accessibilityProfileForm');
                        _PassengerAssistStore = _PassengerAssistStore4.default.get('assistedBooking'), number = _PassengerAssistStore.number, sysId = _PassengerAssistStore.sysId, customerId = _PassengerAssistStore.customerId, link = _PassengerAssistStore.link, journeyDetails = _PassengerAssistStore.journeyDetails, _PassengerAssistStore2 = _PassengerAssistStore.caseDetails, meetingPoint = _PassengerAssistStore2.meetingPoint, bookTicket = _PassengerAssistStore2.bookTicket, ticketReference = _PassengerAssistStore2.ticketReference;
                        _context5.next = 5;
                        return bookPAJourneyDetails(travelAssist);

                    case 5:
                        _ref10 = _context5.sent;
                        outwardJourney = _ref10.outwardJourney;
                        returnJourney = _ref10.returnJourney;
                        _getBookPAAccessibili2 = getBookPAAccessibilityProfile({ accessibilityProfileForm: accessibilityProfileForm }), personalDetails = _getBookPAAccessibili2.personalDetails, _getBookPAAccessibili3 = _getBookPAAccessibili2.caseDetails, contactMethod = _getBookPAAccessibili3.contactMethod, assistanceLocation = _getBookPAAccessibili3.assistanceLocation, otherAssistanceLocation = _getBookPAAccessibili3.otherAssistanceLocation, reasonForAssistance = _getBookPAAccessibili3.reasonForAssistance, otherAssistanceType = _getBookPAAccessibili3.otherAssistanceType, participateSurvey = _getBookPAAccessibili3.participateSurvey, participateImprovementSurvey = _getBookPAAccessibili3.participateImprovementSurvey, pushNotify = _getBookPAAccessibili3.pushNotify;
                        return _context5.abrupt('return', {
                            personalDetails: personalDetails,
                            caseDetails: {
                                contactMethod: contactMethod,
                                assistanceLocation: assistanceLocation,
                                otherAssistanceLocation: otherAssistanceLocation,
                                reasonForAssistance: reasonForAssistance,
                                otherAssistanceType: otherAssistanceType,
                                participateSurvey: participateSurvey,
                                participateImprovementSurvey: participateImprovementSurvey,
                                meetingPoint: meetingPoint,
                                bookTicket: bookTicket,
                                ticketReference: ticketReference,
                                pushNotify: pushNotify
                            },
                            journeyDetails: (0, _extends3.default)({}, journeyDetails, {
                                outwardJourney: outwardJourney,
                                returnJourney: returnJourney,
                                pushNotify: pushNotify
                            }),
                            customerId: customerId,
                            number: number,
                            sysId: sysId,
                            link: link
                        });

                    case 10:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, undefined);
    }));

    return function getEditPassengerAssistRequestBody() {
        return _ref9.apply(this, arguments);
    };
}();

var normalizeTime = exports.normalizeTime = function normalizeTime(time) {
    return time ? time.toString().padStart(2, '0') : null;
};

var getHourMinutes = exports.getHourMinutes = function getHourMinutes(hour, minutes) {
    return hour && minutes ? hour + ':' + minutes : null;
};

var normalizeNLC = exports.normalizeNLC = function normalizeNLC(number) {
    return Math.floor(number / 100).toString();
};

var normalizeJourneyDetails = exports.normalizeJourneyDetails = function normalizeJourneyDetails(journey) {
    if (!(journey && journey.length)) {
        return null;
    }
    var firstJourney = journey[0];
    var lastJourney = journey[journey.length - 1];
    var firstJourneyDeparture = firstJourney.departure;
    var lastJourneyArrival = lastJourney.arrival;

    var departureDate = firstJourney.departureDate,
        departureHour = firstJourney.departureHour,
        departureMinutes = firstJourney.departureMinutes;
    var arrivalDate = lastJourney.arrivalDate,
        arrivalHour = lastJourney.arrivalHour,
        arrivalMinutes = lastJourney.arrivalMinutes;


    return {
        origin: {
            name: firstJourneyDeparture.name,
            nlc: normalizeNLC(firstJourneyDeparture.nlc),
            threeLetterCode: firstJourneyDeparture.threeLetterCode,
            sysId: firstJourneyDeparture.sysId
        },
        destination: {
            name: lastJourneyArrival.name,
            nlc: normalizeNLC(lastJourneyArrival.nlc),
            threeLetterCode: lastJourneyArrival.threeLetterCode,
            sysId: lastJourneyArrival.sysId
        },
        departureDate: departureDate,
        departureHour: normalizeTime(departureHour),
        departureMinutes: normalizeTime(departureMinutes),
        arrivalDate: arrivalDate,
        arrivalHour: normalizeTime(arrivalHour),
        arrivalMinutes: normalizeTime(arrivalMinutes),
        legs: new _immutable.List(journey.map(function (leg) {
            return (0, _extends3.default)({}, leg, {
                departureHour: normalizeTime(leg.departureHour),
                departureMinutes: normalizeTime(leg.departureMinutes),
                arrivalHour: normalizeTime(leg.arrivalHour),
                arrivalMinutes: normalizeTime(leg.arrivalMinutes)
            });
        }))
    };
};

var normalizeAccessibilityProfile = exports.normalizeAccessibilityProfile = function normalizeAccessibilityProfile(_ref11) {
    var personalDetails = _ref11.personalDetails,
        caseDetails = _ref11.caseDetails,
        journeyDetails = _ref11.journeyDetails;
    var title = personalDetails.title,
        firstName = personalDetails.firstName,
        surname = personalDetails.lastName,
        phone = personalDetails.contactNumber,
        postCode = personalDetails.postCode,
        line1 = personalDetails.addressLine1,
        line2 = personalDetails.addressLine2,
        line3 = personalDetails.addressLine3,
        town = personalDetails.town,
        country = personalDetails.county;
    var assistanceLocation = caseDetails.assistanceLocation,
        otherAssistanceLocation = caseDetails.otherAssistanceLocation,
        reasonForAssistance = caseDetails.reasonForAssistance,
        otherAssistanceType = caseDetails.otherAssistanceType,
        participateSurvey = caseDetails.participateSurvey,
        participateImprovementSurvey = caseDetails.participateImprovementSurvey,
        contactMethod = caseDetails.contactMethod;
    var pushNotify = journeyDetails.pushNotify;


    return {
        title: title,
        firstName: firstName,
        surname: surname,
        phone: phone,
        postCode: postCode,
        line1: line1,
        line2: line2,
        line3: line3,
        town: town,
        country: country,
        contactMethod: contactMethod,
        assistanceLocation: assistanceLocation,
        otherAssistanceLocation: otherAssistanceLocation,
        reasonForAssistance: new _immutable.List(reasonForAssistance),
        otherAssistanceType: otherAssistanceType,
        participateSurvey: (0, _text.yesNoToBoolean)(participateSurvey),
        participateImprovementSurvey: (0, _text.yesNoToBoolean)(participateImprovementSurvey),
        pushNotify: pushNotify,
        id: null
    };
};

var normalizeAssistedBooking = exports.normalizeAssistedBooking = function normalizeAssistedBooking(assistedBooking) {
    if ((0, _isEmpty3.default)(assistedBooking)) {
        return {};
    }

    try {
        var sysId = assistedBooking.sysId,
            number = assistedBooking.number,
            _assistedBooking$jour = assistedBooking.journeyDetails,
            outwardJourney = _assistedBooking$jour.outwardJourney,
            returnJourney = _assistedBooking$jour.returnJourney,
            returnJourneyState = _assistedBooking$jour.returnJourneyState,
            outwardJourneyState = _assistedBooking$jour.outwardJourneyState;


        return {
            outwardJourney: normalizeJourneyDetails(outwardJourney),
            returnJourney: normalizeJourneyDetails(returnJourney),
            accessibilityProfile: normalizeAccessibilityProfile(assistedBooking),
            sysId: sysId,
            status: returnJourney.length ? returnJourneyState : outwardJourneyState,
            number: number,
            legs: new _immutable.List()
        };
    } catch (error) {
        console.error('normalizeAssistedBooking error: ', error);
        return {};
    }
};

var normalizeJourney = exports.normalizeJourney = function normalizeJourney(journeyRecord) {
    var journeyDepartureDateTime = void 0;
    var journeyArrivalDateTime = void 0;
    var journeyOriginStation = void 0;
    var journeyDestinationStation = void 0;

    try {
        journeyDepartureDateTime = journeyRecord.getDepartureDateTime();
        journeyArrivalDateTime = journeyRecord.getArrivalDateTime();
        journeyOriginStation = journeyRecord.getOriginStation();
        journeyDestinationStation = journeyRecord.getDestinationStation();

        return {
            origin: {
                name: journeyOriginStation.getName(),
                nlc: journeyOriginStation.get('nlc')
            },
            destination: {
                name: journeyDestinationStation.getName(),
                nlc: journeyDestinationStation.get('nlc')
            },
            changeAt: null,
            departureDate: journeyDepartureDateTime.format('DD/MM/YYYY'),
            departureHour: journeyDepartureDateTime.format('HH'),
            departureMinutes: journeyDepartureDateTime.format('mm'),
            arrivalDate: journeyArrivalDateTime.format('DD/MM/YYYY'),
            arrivalHour: journeyArrivalDateTime.format('HH'),
            arrivalMinutes: journeyArrivalDateTime.format('mm'),
            hasMetroLeg: !!journeyRecord.get('legs').find(function (leg) {
                return leg.getIsMetro();
            }),
            legs: journeyRecord.get('legs').map(function (leg) {
                var departureTime = void 0;
                var arrivalTime = void 0;
                var originStation = void 0;
                var destinationStation = void 0;

                departureTime = leg.getDepartureTime();
                arrivalTime = leg.getArrivalTime();
                originStation = leg.getOriginStation();
                destinationStation = leg.getDestinationStation();

                return {
                    trainUid: leg.getTrainUid(),
                    origin: {
                        nlc: originStation.get('nlc'),
                        name: originStation.getName()
                    },
                    destination: {
                        nlc: destinationStation.get('nlc'),
                        name: destinationStation.getName()
                    },
                    departureHour: departureTime && departureTime.format('HH'),
                    departureMinutes: departureTime && departureTime.format('mm'),
                    departureDate: departureTime && departureTime.format('DD/MM/YYYY'),
                    arrivalHour: arrivalTime && arrivalTime.format('HH'),
                    arrivalMinutes: arrivalTime && arrivalTime.format('mm'),
                    arrivalDate: arrivalTime && arrivalTime.format('DD/MM/YYYY')
                };
            }).filter(function (obj) {
                return obj.trainUid;
            })
        };
    } catch (error) {
        console.error('normalizeJourney error: ', error);
        return error;
    }
};

var getPAModalJourneyData = exports.getPAModalJourneyData = function getPAModalJourneyData(journey) {
    try {
        return {
            origin: journey.getOriginStation(),
            destination: journey.getDestinationStation(),
            departureTime: journey.getDepartureDateTime(),
            arrivalTime: journey.getArrivalDateTime()
        };
    } catch (error) {
        console.error('getPAModalJourneyData error: ', error);
        return {
            origin: {},
            destination: {},
            departureTime: null,
            arrivalTime: null
        };
    }
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.JourneyNotificationStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Immutable = __webpack_require__(54);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JourneyNotificationState = new _immutable.Record({
    latestMessages: new _immutable.List(),
    dismissed: new _immutable.List()
});

var JourneyNotificationStore = exports.JourneyNotificationStore = function (_BaseStore) {
    (0, _inherits3.default)(JourneyNotificationStore, _BaseStore);

    function JourneyNotificationStore() {
        (0, _classCallCheck3.default)(this, JourneyNotificationStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    JourneyNotificationStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.JOURNEY_NOTIFICATIONS_LOADED] = this.handleJourneyNotificationsLoaded, _ref[_AppConstants.ActionTypes.JOURNEY_NOTIFICATIONS_DISMISSED] = this.handleJourneyNotificationsDismissed, _ref;
    };

    JourneyNotificationStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            return new JourneyNotificationState({ dismissed: _immutable2.default.fromJS(serialized.dismissed) });
        }
        return new JourneyNotificationState();
    };

    JourneyNotificationStore.prototype.serialize = function serialize() {
        var now = (0, _TrainTime2.default)();
        var notExpired = this.state.dismissed.filter(function (dismissedMessage) {
            return (0, _TrainTime2.default)(dismissedMessage.get('expiry')).isAfter(now);
        });
        var uniqueDismissed = (0, _Immutable.unique)(notExpired, function (journeyNotification) {
            return journeyNotification.get('id');
        });

        return {
            dismissed: uniqueDismissed.toJS()
        };
    };

    JourneyNotificationStore.prototype.handleJourneyNotificationsLoaded = function handleJourneyNotificationsLoaded(_ref2) {
        var _this2 = this;

        var messages = _ref2.messages;


        var now = (0, _TrainTime2.default)();
        var notExpired = this.state.dismissed.filter(function (dismissedMessage) {
            return (0, _TrainTime2.default)(dismissedMessage.get('expiry')).isAfter(now);
        });

        this.setState(this.state.set('dismissed', notExpired));

        var filteredMessages = messages.filter(function (message) {
            return !_this2.isJourneyNotificationDismissed(message.id);
        });

        this.setState(this.state.set('latestMessages', filteredMessages));
    };

    JourneyNotificationStore.prototype.handleJourneyNotificationsDismissed = function handleJourneyNotificationsDismissed() {
        var _state = this.state,
            latestMessages = _state.latestMessages,
            dismissed = _state.dismissed;

        if (latestMessages.size > 0) {
            var expires = _config2.default.get('journeyNotificationDismissExpires') || 3600;
            var dismissedMessages = latestMessages.map(function (message) {
                return new _immutable.Map({
                    id: message.id,
                    expiry: (0, _TrainTime2.default)().add(expires, 'seconds').format()
                });
            });
            this.setState(this.state.set('dismissed', dismissed.concat(dismissedMessages)).set('latestMessages', new _immutable.List()));
        }
    };

    JourneyNotificationStore.prototype.isJourneyNotificationDismissed = function isJourneyNotificationDismissed(messageId) {
        var dismissed = this.state.dismissed.find(function (dismissedMessage) {
            return dismissedMessage.get('id') === messageId;
        });
        if (dismissed) {
            return (0, _TrainTime2.default)(dismissed.get('expiry')).isAfter((0, _TrainTime2.default)());
        }
        return false;
    };

    return JourneyNotificationStore;
}(_BaseStore3.default);

var storeInstance = new JourneyNotificationStore('journey-notification');

exports.default = storeInstance;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _Durations = __webpack_require__(430);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Duration(_ref) {
    var startTime = _ref.startTime,
        endTime = _ref.endTime,
        className = _ref.className;

    var duration = (0, _Durations.diffDuration)(startTime, endTime);
    return _react2.default.createElement(
        'time',
        { className: (0, _classnames2.default)('duration', className),
            dateTime: (0, _I18n.translate)('time.duration', duration),
            title: (0, _Durations.durationString)(duration, { type: 'long' })
        },
        (0, _Durations.durationString)(duration)
    );
}

Duration.propTypes = {
    className: _propTypes2.default.string,
    startTime: _propTypes2.default.object,
    endTime: _propTypes2.default.object
};

Duration.defaultProps = {
    startTime: (0, _TrainTime2.default)(),
    endTime: (0, _TrainTime2.default)()
};

exports.default = Duration;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmazonPayStore = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultAmazonPayState = new _immutable.Record({
  addressConsentToken: null,
  addressError: null,
  amazonOrderReferenceId: null,
  errorText: null,
  errorTimestamp: null,
  errorType: null,
  hasLoginCompleted: false,
  isAmazonMFASuccessful: false,
  isInvalidPaymentMethod: false,
  isProcessing: false
});

var AmazonPayStore = exports.AmazonPayStore = function (_BaseStore) {
  (0, _inherits3.default)(AmazonPayStore, _BaseStore);

  function AmazonPayStore() {
    (0, _classCallCheck3.default)(this, AmazonPayStore);
    return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
  }

  AmazonPayStore.prototype.deserialize = function deserialize(serialized) {
    if (serialized) {
      return new DefaultAmazonPayState({
        addressConsentToken: serialized.addressConsentToken,
        amazonOrderReferenceId: serialized.amazonOrderReferenceId
      });
    }
    return new DefaultAmazonPayState();
  };

  AmazonPayStore.prototype.handleAddressError = function handleAddressError(_ref) {
    var _ref$countryCode = _ref.countryCode,
        countryCode = _ref$countryCode === undefined ? null : _ref$countryCode;

    var newAddressError = null;

    if (countryCode) {
      newAddressError = (0, _I18n2.default)('payment.amazonPay.chooseCorrectAddress', { countryCode: countryCode });
    }
    this.setState(this.state.merge({
      addressError: newAddressError
    }));
  };

  AmazonPayStore.prototype.handleClearError = function handleClearError() {
    this.setState(this.state.merge({
      errorTimestamp: null
    }));
  };

  AmazonPayStore.prototype.handleError = function handleError(_ref2) {
    var errorText = _ref2.errorText,
        errorType = _ref2.errorType;

    this.setState(this.state.merge({
      errorText: errorText,
      errorTimestamp: Date.now(), // add timestamp to trigger UI update even when errorText didn't change
      errorType: errorType,
      isAmazonMFASuccessful: false
    }));
  };

  AmazonPayStore.prototype.handleInvalidPaymentMethod = function handleInvalidPaymentMethod(_ref3) {
    var isInvalidPaymentMethod = _ref3.isInvalidPaymentMethod;

    this.setState(this.state.merge({
      hasLoginCompleted: true,
      isInvalidPaymentMethod: isInvalidPaymentMethod,
      isProcessing: false
    }));
  };

  AmazonPayStore.prototype.handleLoginComplete = function handleLoginComplete(_ref4) {
    var addressConsentToken = _ref4.addressConsentToken,
        hasLoginCompleted = _ref4.hasLoginCompleted;

    var clearErrors = void 0;

    if (hasLoginCompleted === true) {
      clearErrors = {
        errorText: null,
        errorTimestamp: null,
        errorType: null
      };
    }

    var addressConsentTokenProp = typeof addressConsentToken !== 'undefined' ? { addressConsentToken: addressConsentToken } : null;

    this.setState(this.state.merge((0, _extends3.default)({}, addressConsentTokenProp, {
      hasLoginCompleted: hasLoginCompleted
    }, clearErrors)));
  };

  AmazonPayStore.prototype.handleMFASuccessful = function handleMFASuccessful(_ref5) {
    var isAmazonMFASuccessful = _ref5.isAmazonMFASuccessful;

    this.setState(this.state.merge({
      isAmazonMFASuccessful: isAmazonMFASuccessful
    }));
  };

  AmazonPayStore.prototype.handleProcessing = function handleProcessing(_ref6) {
    var _ref6$isProcessing = _ref6.isProcessing,
        isProcessing = _ref6$isProcessing === undefined ? false : _ref6$isProcessing,
        amazonOrderReferenceId = _ref6.amazonOrderReferenceId;

    this.setState(this.state.merge({
      isProcessing: isProcessing
    }));

    if (amazonOrderReferenceId) {
      this.setState(this.state.merge({
        amazonOrderReferenceId: amazonOrderReferenceId
      }));
    }
  };

  AmazonPayStore.prototype.resetAmazonTemporaryFlags = function resetAmazonTemporaryFlags() {
    this.setState(this.state.merge({
      addressConsentToken: null,
      addressError: null,
      amazonOrderReferenceId: null,
      errorText: null,
      errorTimestamp: null,
      errorType: null,
      isAmazonMFASuccessful: false,
      isInvalidPaymentMethod: false,
      isProcessing: false
    }));
  };

  AmazonPayStore.prototype.getActionHandlers = function getActionHandlers() {
    var _ref7;

    return _ref7 = {}, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_ADDRESS_ERROR] = this.handleAddressError, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_CLEAR_ERROR] = this.handleClearError, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_ERROR] = this.handleError, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_INVALID_PAYMENT_METHOD] = this.handleInvalidPaymentMethod, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_LOGIN_COMPLETE] = this.handleLoginComplete, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_LOGOUT] = this.resetState, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_MFA_SUCCESSFUL] = this.handleMFASuccessful, _ref7[_AppConstants.ActionTypes.AMAZON_PAY_PROCESSING] = this.handleProcessing, _ref7[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref7[_AppConstants.ActionTypes.PAYMENT_AUTH_RESET] = this.resetAmazonTemporaryFlags, _ref7[_AppConstants.ActionTypes.PAYMENT_AUTH_FINISHED] = this.resetAmazonTemporaryFlags, _ref7;
  };

  return AmazonPayStore;
}(_BaseStore3.default);

var instance = new AmazonPayStore({ storageKey: 'amazonPay' });

exports.default = instance;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(290),
    baseEach = __webpack_require__(237),
    baseInvoke = __webpack_require__(1694),
    baseRest = __webpack_require__(203),
    isArrayLike = __webpack_require__(143);

/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = baseRest(function(collection, path, args) {
  var index = -1,
      isFunc = typeof path == 'function',
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value) {
    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
  });
  return result;
});

module.exports = invokeMap;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoStore = function (_BaseStore) {
    (0, _inherits3.default)(KeyGoStore, _BaseStore);

    function KeyGoStore() {
        (0, _classCallCheck3.default)(this, KeyGoStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    KeyGoStore.prototype.getInitialState = function getInitialState() {
        var form = new _KeyGoForm2.default();
        var validation = new _immutable.Map(form.getValidationSummary());
        return new _immutable.Map({ form: form, validation: validation });
    };

    KeyGoStore.prototype.updateForm = function updateForm(form) {
        var validation = this.get('validation').merge(form.getValidationSummary());
        this.setState(this.state.merge({ form: form, validation: validation }));
    };

    KeyGoStore.prototype.handlePaymentFormChanged = function handlePaymentFormChanged(_ref) {
        var field = _ref.field,
            value = _ref.value;

        var form = this.get('form').set(field, value);
        this.updateForm(form);
    };

    KeyGoStore.prototype.handlePaymentAddressSelected = function handlePaymentAddressSelected(_ref2) {
        var address = _ref2.address;

        var form = this.get('form').merge({
            addressLine1: address.get('line1'),
            addressLine2: address.get('line2'),
            addressLine3: address.get('line3'),
            townCity: address.get('town'),
            postcode: address.get('postCode')
        });
        this.updateForm(form);
    };

    KeyGoStore.prototype.handlePaymentSucceeded = function handlePaymentSucceeded() {
        this.setState(this.getInitialState().merge({
            paymentSucceeded: true
        }));
    };

    KeyGoStore.prototype.handlePaymentFormRetry = function handlePaymentFormRetry() {
        this.setState(this.state.remove('error'));
    };

    KeyGoStore.prototype.handlePropertyChange = function handlePropertyChange(name) {
        var _this2 = this;

        return function (payload) {
            return _this2.setState(_this2.state.set(name, payload[name]));
        };
    };

    KeyGoStore.prototype.handleSmartcardStatus = function handleSmartcardStatus(_ref3) {
        var smartcard = _ref3.smartcard;

        if (smartcard && !smartcard.isAwaitingProduct()) {
            var form = this.get('form').set('showCollectionLocation', true);
            this.setState(this.state.merge({
                form: form,
                validation: this.get('validation').merge(form.getValidationSummary())
            }));
        }
    };

    KeyGoStore.prototype.handleSetShowCollectionLocation = function handleSetShowCollectionLocation(_ref4) {
        var showCollectionLocation = _ref4.showCollectionLocation;

        this.setState(this.state.merge({ form: this.get('form').set('showCollectionLocation', !!showCollectionLocation) }));
    };

    KeyGoStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref5;

        return _ref5 = {}, _ref5[_AppConstants.ActionTypes.KEYGO_FORM_CHANGED] = this.handlePaymentFormChanged, _ref5[_AppConstants.ActionTypes.KEYGO_ADDRESS_SELECTED] = this.handlePaymentAddressSelected, _ref5[_AppConstants.ActionTypes.KEYGO_FORM_RETRY] = this.handlePaymentFormRetry, _ref5[_AppConstants.ActionTypes.KEYGO_REGISTRATION_COMPLETE] = this.handlePaymentSucceeded, _ref5[_AppConstants.ActionTypes.KEYGO_UPDATE_COMPLETE] = this.handlePaymentSucceeded, _ref5[_AppConstants.ActionTypes.KEYGO_REGISTRATION_FAILED] = this.handlePropertyChange('error'), _ref5[_AppConstants.ActionTypes.KEYGO_UPDATE_FAILED] = this.handlePropertyChange('error'), _ref5[_AppConstants.ActionTypes.KEYGO_FORM_RESET] = this.resetState, _ref5[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref5[_AppConstants.ActionTypes.SMARTCARD_LOADED] = this.handleSmartcardStatus, _ref5[_AppConstants.ActionTypes.SMARTCARD_SET_SHOW_COLLECTION_LOCATION] = this.handleSetShowCollectionLocation, _ref5;
    };

    return KeyGoStore;
}(_BaseStore3.default);

exports.default = new KeyGoStore();

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _flatten2 = __webpack_require__(453);

var _flatten3 = _interopRequireDefault(_flatten2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _immutable = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeasonFilters = new _immutable.Record({
    flexi: true,
    weekly: true,
    fourWeekly: true,
    monthly: true,
    quarterly: true,
    sixMonthly: true,
    annual: true,
    custom: true,
    standard: true,
    firstClass: true,
    travelcards: true,
    routes: new _immutable.List()
});

(0, _assign2.default)(SeasonFilters.prototype, {
    getRoute: function getRoute(route) {
        return this.routes.find(function (o) {
            return o.get('route').id === route.id;
        });
    },
    updateRoute: function updateRoute(item) {
        var routes = this.routes.map(function (o) {
            return o.get('route').id === item.get('route').id ? item : o;
        });
        return this.set('routes', routes);
    },
    getCheckedRoutes: function getCheckedRoutes() {
        return this.routes.filter(function (r) {
            return r.get('checked');
        });
    },
    getCount: function getCount() {
        var routes = this.getCheckedRoutes().map(function (x) {
            return x.get('checked');
        }).toArray();

        return (0, _compact3.default)((0, _flatten3.default)([this.flexi, this.weekly, this.monthly, this.annual, this.custom, this.quarterly, this.sixMonthly, this.standard, this.firstClass, routes])).length;
    },
    durationFilter: function durationFilter(search) {
        var _this = this;

        return function (fare) {
            var period = fare.outwardValidity.period;
            var _search$dates = search.dates,
                startDate = _search$dates.startDate,
                endDate = _search$dates.endDate;

            var customDiff = endDate.clone().add(1, 'day').calendarDiff(startDate);
            var validUntil = startDate.clone().add(period.toJS());
            var matchesDuration = function matchesDuration(expected) {
                var expectedEndDate = startDate.clone().add(expected);
                return validUntil.isSame(expectedEndDate);
            };

            return (0, _compact3.default)([_this.flexi && fare.isFlexi(), _this.weekly && matchesDuration({ days: 7 }), _this.fourWeekly && matchesDuration({ days: 28 }), _this.monthly && matchesDuration({ months: 1 }), _this.quarterly && matchesDuration({ months: 3 }), _this.sixMonthly && matchesDuration({ months: 6 }), _this.annual && matchesDuration({ months: 12 }), _this.custom && matchesDuration(customDiff)]).length > 0;
        };
    },
    classFilter: function classFilter() {
        var _this2 = this;

        return function (fare) {
            return (0, _compact3.default)([_this2.standard && !fare.isFirstClass(), _this2.firstClass && fare.isFirstClass()]).length > 0;
        };
    },
    travelcardFilter: function travelcardFilter() {
        var _this3 = this;

        return function (fare) {
            return !_this3.travelcards && fare.tickets ? fare.tickets.some(function (ticket) {
                return ticket.railcard;
            }) : true;
        };
    },
    routesFilter: function routesFilter() {
        var _this4 = this;

        return function (fare) {
            var found = _this4.getRoute(fare.route);
            return found && found.get('checked') === true;
        };
    }
});

exports.default = SeasonFilters;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StarIcon = function StarIcon(props) {
    return React.createElement(
        "svg",
        (0, _extends3.default)({ id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 468 432" }, props),
        React.createElement(
            "defs",
            null,
            React.createElement(
                "style",
                null,
                '.cls-1{fill:#f69b00}.cls-3{fill:#ffcd78}.cls-4{fill:#1d1e1c}'
            )
        ),
        React.createElement("path", {
            style: {
                fill: '#ffac00'
            },
            d: "M450 144h-72v-18h-72V90h-18V54h-18V18h-18V0h-36v18h-18v36h-18v36h-18v36H90v18H0v36h18v18h18v18h18v18h18v18h18v18h18v36H90v54H72v54h18v18h18v-18h36v-18h36v-18h36v-18h36v18h36v18h36v18h36v18h18v-18h18v-54h-18v-54h-18v-36h18v-18h18v-18h18v-18h18v-18h18v-18h18v-36h-18z"
        }),
        React.createElement("path", {
            className: "cls-3",
            d: "M18 162h18v18H18zM36 162h18v18H36zM54 162h18v18H54zM72 162h18v18H72zM90 162h18v18H90zM90 144h18v18H90zM108 144h18v18h-18zM126 144h18v18h-18zM144 144h18v18h-18zM162 144h18v18h-18zM162 126h18v18h-18zM180 126h18v18h-18zM180 108h18v18h-18zM180 90h18v18h-18zM198 90h18v18h-18zM198 72h18v18h-18zM198 54h18v18h-18zM216 54h18v18h-18zM216 36h18v18h-18zM216 18h18v18h-18zM234 18h18v18h-18zM234 36h18v18h-18zM234 54h18v18h-18zM234 72h18v18h-18zM216 72h18v18h-18zM216 90h18v18h-18zM216 108h18v18h-18zM198 108h18v18h-18zM198 126h18v18h-18zM198 144h18v18h-18zM180 144h18v18h-18zM180 162h18v18h-18zM162 162h18v18h-18zM144 162h18v18h-18zM126 162h18v18h-18zM108 162h18v18h-18zM108 180h18v18h-18zM90 180h18v18H90zM72 180h18v18H72zM54 180h18v18H54zM36 180h18v18H36z"
        }),
        React.createElement("path", { className: "cls-3", d: "M54 180h18v18H54z" }),
        React.createElement("path", { className: "cls-1", d: "M360 396h18v18h-18z" }),
        React.createElement("path", {
            className: "cls-1",
            d: "M360 396h18v18h-18zM360 378h18v18h-18zM360 360h18v18h-18zM342 360h18v18h-18zM342 378h18v18h-18zM324 378h18v18h-18zM324 360h18v18h-18zM324 342h18v18h-18zM342 342h18v18h-18zM342 324h18v18h-18zM342 306h18v18h-18zM324 306h18v18h-18zM324 324h18v18h-18z"
        }),
        React.createElement("path", {
            className: "cls-1",
            d: "M324 342h18v18h-18zM306 342h18v18h-18zM306 360h18v18h-18zM288 360h18v18h-18zM288 342h18v18h-18zM270 342h18v18h-18zM252 342h18v18h-18zM252 324h18v18h-18zM234 324h18v18h-18z"
        }),
        React.createElement("path", {
            className: "cls-1",
            d: "M252 324h18v18h-18zM270 324h18v18h-18zM288 324h18v18h-18zM306 324h18v18h-18zM306 306h18v18h-18zM216 324h18v18h-18zM198 324h18v18h-18z"
        }),
        React.createElement("path", {
            className: "cls-1",
            d: "M216 324h18v18h-18zM216 306h18v18h-18zM234 306h18v18h-18zM234 288h18v18h-18zM252 288h18v18h-18zM252 270h18v18h-18zM270 270h18v18h-18zM288 270h18v18h-18zM288 252h18v18h-18zM306 252h18v18h-18z"
        }),
        React.createElement("path", { className: "cls-1", d: "M288 252h18v18h-18zM414 162h18v18h-18zM432 162h18v18h-18z" }),
        React.createElement("path", {
            className: "cls-1",
            d: "M414 162h18v18h-18zM414 180h18v18h-18zM396 180h18v18h-18zM396 198h18v18h-18zM378 198h18v18h-18zM378 216h18v18h-18zM360 216h18v18h-18zM360 234h18v18h-18zM342 234h18v18h-18zM342 252h18v18h-18zM324 252h18v18h-18zM324 270h18v18h-18zM324 288h18v18h-18zM306 288h18v18h-18zM288 288h18v18h-18zM288 306h18v18h-18zM270 306h18v18h-18zM252 306h18v18h-18z"
        }),
        React.createElement("path", {
            className: "cls-1",
            d: "M270 306h18v18h-18zM270 288h18v18h-18zM288 288h18v18h-18zM288 270h18v18h-18zM306 270h18v18h-18zM324 252h18v18h-18zM324 234h18v18h-18z"
        }),
        React.createElement("path", {
            className: "cls-1",
            d: "M324 252h18v18h-18zM342 234h18v18h-18zM360 216h18v18h-18zM342 216h18v18h-18zM360 198h18v18h-18zM378 198h18v18h-18zM378 180h18v18h-18zM198 342h18v18h-18zM180 342h18v18h-18zM162 342h18v18h-18zM162 360h18v18h-18zM144 360h18v18h-18zM126 360h18v18h-18zM126 378h18v18h-18zM108 378h18v18h-18zM90 378h18v18H90zM90 360h18v18H90zM108 360h18v18h-18zM126 342h18v18h-18zM144 342h18v18h-18zM144 324h18v18h-18zM162 324h18v18h-18zM180 324h18v18h-18zM180 306h18v18h-18zM198 306h18v18h-18zM216 306h18v18h-18zM216 288h18v18h-18zM234 288h18v18h-18zM252 288h18v18h-18zM252 270h18v18h-18zM90 396h18v18H90z"
        }),
        React.createElement("path", {
            className: "cls-4",
            d: "M216 0h18v18h-18zM198 18h18v18h-18zM198 36h18v18h-18zM180 54h18v18h-18zM180 72h18v18h-18zM162 90h18v18h-18zM162 108h18v18h-18zM144 126h18v18h-18zM126 126h18v18h-18zM108 126h18v18h-18zM90 126h18v18H90zM72 144h18v18H72zM54 144h18v18H54zM36 144h18v18H36zM18 144h18v18H18zM0 144h18v18H0zM0 162h18v18H0zM18 180h18v18H18zM36 198h18v18H36zM54 216h18v18H54zM72 234h18v18H72zM90 252h18v18H90zM108 270h18v18h-18zM108 288h18v18h-18zM90 306h18v18H90zM90 324h18v18H90zM90 342h18v18H90zM72 360h18v18H72zM72 378h18v18H72zM72 396h18v18H72zM90 414h18v18H90zM108 396h18v18h-18zM126 396h18v18h-18zM144 378h18v18h-18zM162 378h18v18h-18zM180 360h18v18h-18zM198 360h18v18h-18zM216 342h18v18h-18z"
        }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 243 9)", d: "M234 0h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 261 27)", d: "M252 18h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 261 45)", d: "M252 36h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 279 63)", d: "M270 54h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 279 81)", d: "M270 72h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 297 99)", d: "M288 90h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 297 117)", d: "M288 108h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 315 135)", d: "M306 126h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 333 135)", d: "M324 126h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 351 135)", d: "M342 126h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 369 135)", d: "M360 126h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 387 153)", d: "M378 144h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 405 153)", d: "M396 144h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 423 153)", d: "M414 144h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 441 153)", d: "M432 144h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 459 153)", d: "M450 144h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 459 171)", d: "M450 162h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 441 189)", d: "M432 180h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 423 207)", d: "M414 198h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 405 225)", d: "M396 216h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 387 243)", d: "M378 234h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 369 261)", d: "M360 252h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 351 279)", d: "M342 270h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 351 297)", d: "M342 288h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 369 315)", d: "M360 306h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 369 333)", d: "M360 324h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 369 351)", d: "M360 342h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 387 369)", d: "M378 360h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 387 387)", d: "M378 378h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 387 405)", d: "M378 396h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 369 423)", d: "M360 414h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 351 405)", d: "M342 396h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 333 405)", d: "M324 396h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 315 387)", d: "M306 378h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 297 387)", d: "M288 378h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 279 369)", d: "M270 360h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 261 369)", d: "M252 360h18v18h-18z" }),
        React.createElement("path", { className: "cls-4", transform: "rotate(-180 243 351)", d: "M234 342h18v18h-18z" })
    );
};

exports.default = StarIcon;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CollectionStationsStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionStationsState = new _immutable.Record({
    loading: false,
    error: null,
    stations: new _immutable.List(),
    selectedStationNlc: null
});

var CollectionStationsStore = exports.CollectionStationsStore = function (_BaseStore) {
    (0, _inherits3.default)(CollectionStationsStore, _BaseStore);

    function CollectionStationsStore() {
        (0, _classCallCheck3.default)(this, CollectionStationsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    CollectionStationsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.GET_COLLECTION_STATIONS_STARTED] = this.handleGetCollectionStationStarted, _ref[_AppConstants.ActionTypes.GET_COLLECTION_STATIONS_ENDED] = this.handleGetCollectionStationEnded, _ref[_AppConstants.ActionTypes.GET_COLLECTION_STATIONS_FAILED] = this.handleGetCollectionStationFailed, _ref[_AppConstants.ActionTypes.KEYGO_REGISTRATION_STARTED] = this.handleSetCollectionStation, _ref;
    };

    CollectionStationsStore.prototype.handleGetCollectionStationStarted = function handleGetCollectionStationStarted() {
        this.setState(this.state.set('loading', true));
    };

    CollectionStationsStore.prototype.handleGetCollectionStationFailed = function handleGetCollectionStationFailed(_ref2) {
        var error = _ref2.error;

        this.setState(this.state.merge({ loading: false, error: error }));
    };

    CollectionStationsStore.prototype.handleGetCollectionStationEnded = function handleGetCollectionStationEnded(_ref3) {
        var stations = _ref3.stations;

        this.setState(this.state.merge({ loading: false, stations: stations }));
    };

    CollectionStationsStore.prototype.handleSetCollectionStation = function handleSetCollectionStation(_ref4) {
        var collectionLocation = _ref4.collectionLocation;

        this.setState(this.state.set('selectedStationNlc', collectionLocation));
    };

    CollectionStationsStore.prototype.getInitialState = function getInitialState() {
        return new CollectionStationsState();
    };

    CollectionStationsStore.prototype.getSelectedLocationName = function getSelectedLocationName() {
        var _this2 = this;

        var locationObj = this.get('stations').find(function (location) {
            return location.nlc === _this2.get('selectedStationNlc');
        });
        return locationObj ? locationObj.name : null;
    };

    return CollectionStationsStore;
}(_BaseStore3.default);

var storeInstance = new CollectionStationsStore();

exports.default = storeInstance;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    isStepFreeEnabled: false,
    isSeatAvailabilityEnabled: false,
    isJourneySupportModalOpen: false
});

var JourneySupportStore = function (_BaseStore) {
    (0, _inherits3.default)(JourneySupportStore, _BaseStore);

    function JourneySupportStore() {
        (0, _classCallCheck3.default)(this, JourneySupportStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    JourneySupportStore.prototype.getInitialState = function getInitialState() {
        return new State();
    };

    JourneySupportStore.prototype.toggleStepFree = function toggleStepFree() {
        this.setState(this.state.set('isStepFreeEnabled', !this.state.get('isStepFreeEnabled')));
    };

    JourneySupportStore.prototype.toggleSeatAvailability = function toggleSeatAvailability() {
        this.setState(this.state.set('isSeatAvailabilityEnabled', !this.state.get('isSeatAvailabilityEnabled')));
    };

    JourneySupportStore.prototype.toggleJourneySupportModal = function toggleJourneySupportModal() {
        this.setState(this.state.set('isJourneySupportModalOpen', !this.state.get('isJourneySupportModalOpen')));
    };

    JourneySupportStore.prototype.getJourneySupportModalStatus = function getJourneySupportModalStatus() {
        return this.state.get('isJourneySupportModalOpen');
    };

    JourneySupportStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.TOGGLE_STEP_FREE] = this.toggleStepFree, _ref[_AppConstants.ActionTypes.TOGGLE_SEAT_AVAILABILITY] = this.toggleSeatAvailability, _ref[_AppConstants.ActionTypes.TOGGLE_JOURNEY_SUPPORT_MODAL] = this.toggleJourneySupportModal, _ref;
    };

    return JourneySupportStore;
}(_BaseStore3.default);

exports.default = new JourneySupportStore();

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _CallingPointsService = __webpack_require__(1912);

var _CallingPointsService2 = _interopRequireDefault(_CallingPointsService);

var _CallingPointsStore = __webpack_require__(622);

var _CallingPointsStore2 = _interopRequireDefault(_CallingPointsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CallingPointsActions = {
    getFromService: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(service) {
            var cached, callingPoints, result;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            cached = _CallingPointsStore2.default.get(service);

                            if (!cached) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt('return', cached);

                        case 3:
                            callingPoints = service.journey.callingPoints;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CALLING_POINTS_LOAD_STARTED,
                                key: callingPoints
                            });
                            _context.prev = 5;
                            _context.next = 8;
                            return _CallingPointsService2.default.get(callingPoints);

                        case 8:
                            result = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CALLING_POINTS_LOADED,
                                key: callingPoints,
                                callingPoints: result
                            });
                            return _context.abrupt('return', result);

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](5);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CALLING_POINTS_LOAD_FAILED,
                                key: callingPoints
                            });
                            throw _context.t0;

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[5, 13]]);
        }));

        function getFromService(_x) {
            return _ref.apply(this, arguments);
        }

        return getFromService;
    }()
};

exports.default = CallingPointsActions;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardPointsService = {
    getPointsForFare: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(setter, ticketType, ticketCost, purchaseDate, travelDate) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return _AuthenticatedAPIClient2.default.post('/reward-point/journey-reward', {
                                setter: setter,
                                ticketType: ticketType,
                                ticketCost: ticketCost,
                                purchaseDate: purchaseDate,
                                travelDate: travelDate
                            });

                        case 3:
                            response = _context.sent;
                            return _context.abrupt('return', response);

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            console.warn('error getting reward points', _context.t0);
                            return _context.abrupt('return', {
                                points: 0
                            });

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));

        function getPointsForFare(_x, _x2, _x3, _x4, _x5) {
            return _ref.apply(this, arguments);
        }

        return getPointsForFare;
    }(),
    registerTicketsForReward: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(orderId, purchaseDate, hasPreferredDelivery, tickets, customerId, customerEmail) {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _AuthenticatedAPIClient2.default.post('/reward-point/customer-reward', {
                                orderId: orderId,
                                purchaseDate: purchaseDate,
                                hasPreferredDelivery: hasPreferredDelivery,
                                tickets: tickets,
                                customerId: customerId,
                                customerEmail: customerEmail
                            });

                        case 3:
                            response = _context2.sent;
                            return _context2.abrupt('return', response);

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](0);

                            console.warn('error registering ticket(s) for reward points', _context2.t0);
                            return _context2.abrupt('return', false);

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 7]]);
        }));

        function registerTicketsForReward(_x6, _x7, _x8, _x9, _x10, _x11) {
            return _ref2.apply(this, arguments);
        }

        return registerTicketsForReward;
    }()
};

exports.default = RewardPointsService;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardPointsModal = function RewardPointsModal(_ref) {
    var onClose = _ref.onClose;

    return _react2.default.createElement(
        _BaseModal2.default,
        {
            className: 'modal--sm reward-points__modal',
            onClose: onClose,
            titleText: (0, _I18n2.default)('rewardPoints.modal.title'),
            hideContinue: true
        },
        _react2.default.createElement(
            'h3',
            null,
            (0, _I18n2.default)('rewardPoints.modal.heading')
        ),
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n2.default)('rewardPoints.modal.schemeEnding')
        ),
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n2.default)('rewardPoints.modal.existingRewardCodes'),
            ' ',
            _react2.default.createElement(
                'a',
                { target: '_blank', href: 'https://www.nextlevelrewards.co.uk/' },
                '(Next Level Rewards)'
            ),
            ' ',
            (0, _I18n2.default)('rewardPoints.modal.existingRewardCodesUntil')
        )
    );
};

RewardPointsModal.propTypes = {
    onClose: _propTypes2.default.func
};

exports.default = _react2.default.memo(RewardPointsModal);

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Flow = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

exports.Stage = Stage;

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _ReservationStore = __webpack_require__(641);

var _ReservationStore2 = _interopRequireDefault(_ReservationStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A stage object has methods for determining the next and previous stages, and the action
 * to perform on transitioning.
 * each method will be passed the current stage and the current state
 */
function Stage(params) {
    var defaultStage = {
        /**
         * Should return an action creator that returns a promise
         * The action creator will be passed the current state, and should
         * return any changed state
         */
        nextAction: function nextAction() {
            return null;
        },

        /**
         * Do we need to wait for the action before continuing
         */
        waitForAction: true,

        /**
         * Should return the next stage
         */
        next: function next() {
            throw new Error('No next stage defined');
        },

        /**
         * Should return the previous stage
         */
        previous: function previous() {
            throw new Error('No previous stage defined');
        },

        getParams: function getParams() {
            return null;
        },

        getQuery: function getQuery() {
            return null;
        }
    };
    return (0, _assign2.default)(defaultStage, params);
} /* eslint-disable no-debugger */

var Flow = exports.Flow = function () {
    function Flow(stages) {
        (0, _classCallCheck3.default)(this, Flow);

        this.stages = stages;
    }

    Flow.prototype.nextAction = function nextAction(current, state) {
        var action = this.stages[current].nextAction(current, state);
        return action;
    };

    Flow.prototype.nextStage = function nextStage(current, state) {
        return this.stages[current].next(current, state);
    };

    Flow.prototype.previousStage = function previousStage(current, state) {
        return this.stages[current].previous(current, state);
    };

    Flow.prototype.canContinue = function canContinue(current, state) {
        return this.nextStage(current, state);
    };

    Flow.prototype.mustWait = function mustWait(current) {
        return this.stages[current].waitForAction;
    };

    Flow.prototype.makeTransition = function makeTransition(router, route, state) {
        var _this = this;

        var replace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return function () {
            var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var mergedState = (0, _assign2.default)({}, state, newState);

            var stage = _this.stages[route];

            if (stage) {
                var params = stage.getParams(mergedState);
                var query = stage.getQuery(mergedState);
                var pathname = _urls2.default.reverse(route, params);
                if (replace) {
                    return router.replace(_urls2.default.location(route, params, query));
                }
                return router.push({ pathname: pathname, query: query });
            }
            return null;
        };
    };

    Flow.prototype.moveToNext = function moveToNext(current, state, router) {
        var _this2 = this,
            _arguments = arguments;

        var replace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var action = this.nextAction(current, state);
        var next = this.nextStage(current, state);

        var handlePassengerAssistBooking = function handlePassengerAssistBooking(onContinue) {
            if (current === _AppConstants.GridPages.SERVICES && next === _AppConstants.CheckoutStages.DELIVERY) {

                _ModalActions2.default.open(_AppConstants.GlobalModals.BOOK_PASSENGER_ASSIST, {
                    hideClose: true,
                    disableClose: true,
                    onClose: function onClose() {
                        return _ModalActions2.default.close(_AppConstants.GlobalModals.BOOK_PASSENGER_ASSIST);
                    },
                    onContinue: onContinue,
                    titleText: (0, _I18n2.default)('account.passenger-assist.book-passenger-assist.title'),
                    router: router
                });
            } else {
                onContinue();
            }
        };

        var handleBikeReservations = function handleBikeReservations(onContinue) {
            if (current === _AppConstants.GridPages.SERVICES && next === _AppConstants.CheckoutStages.DELIVERY) {

                _ModalActions2.default.open(_AppConstants.GlobalModals.RESERVATIONS, {
                    hideClose: true,
                    disableClose: true,
                    onClose: function onClose() {
                        return _ModalActions2.default.close(_AppConstants.GlobalModals.RESERVATIONS);
                    },
                    onContinue: onContinue,
                    titleText: 'Seat & Bike reservations',
                    router: router
                });
            } else {
                onContinue();
            }
        };

        var proceedToNext = function proceedToNext() {
            var transition = _this2.makeTransition(router, next, state, replace);

            if (action) {
                var p = action(state);

                if (_this2.mustWait(current)) {
                    return p.then(function (result) {
                        if (result) {
                            _ModalActions2.default.close(_AppConstants.GlobalModals.BOOK_PASSENGER_ASSIST);
                            return transition.call.apply(transition, _arguments);
                        }
                        console.error('Transition aborted as action returned false');
                        return null;
                    });
                }
            }

            _ModalActions2.default.close(_AppConstants.GlobalModals.BOOK_PASSENGER_ASSIST);
            return _promise2.default.resolve(transition());
        };

        if (_FeatureFlagStore2.default.get('enablePassengerAssist')) {
            return handlePassengerAssistBooking(proceedToNext);
        }

        if (_FeatureFlagStore2.default.get('enableReservations') && _ReservationStore2.default.get('reservationWidgetToggled')) {
            return handleBikeReservations(proceedToNext);
        }

        return _promise2.default.resolve(proceedToNext());
    };

    Flow.prototype.moveToPrevious = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(current, state, router) {
            var previous, transition;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            previous = this.previousStage(current, state);
                            transition = this.makeTransition(router, previous, state);
                            return _context.abrupt('return', transition(state));

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function moveToPrevious(_x4, _x5, _x6) {
            return _ref.apply(this, arguments);
        }

        return moveToPrevious;
    }();

    return Flow;
}();

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.TocOnlyStore = exports.TocOnlyAvailability = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TocOnlyAvailability = exports.TocOnlyAvailability = new _immutable.Record({
    origin: null,
    destination: null,
    result: null
});

var TocOnlyStore = exports.TocOnlyStore = function (_BaseStore) {
    (0, _inherits3.default)(TocOnlyStore, _BaseStore);

    function TocOnlyStore() {
        (0, _classCallCheck3.default)(this, TocOnlyStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    TocOnlyStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.CHECK_TOC_ONLY_ADD] = this.handleNewStations, _ref;
    };

    TocOnlyStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.List();
    };

    TocOnlyStore.prototype.handleNewStations = function handleNewStations(_ref2) {
        var search = _ref2.search,
            result = _ref2.result;

        var origin = search.origin.nlc;
        var destination = search.destination.nlc;
        this.setState(this.state.push(new TocOnlyAvailability({
            origin: origin,
            destination: destination,
            result: result
        })));
    };

    TocOnlyStore.prototype.handleExistingStations = function handleExistingStations() {
        this.emitChange();
    };

    TocOnlyStore.prototype.getAvailability = function getAvailability(search) {
        return this.state.find(function (entry) {
            if (entry.origin === search.origin.nlc && entry.destination === search.destination.nlc) {
                return true;
            }
            return false;
        });
    };

    return TocOnlyStore;
}(_BaseStore3.default);

exports.default = new TocOnlyStore();

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    billingAddress: null,
    callId: null,
    cardArtFileName: null,
    cardBrand: null,
    cardHolderName: null,
    cardType: null,
    deliveryAddress: null,
    emailAddress: null,
    expirationDate: null,
    expired: true,
    lastFourDigits: null
};

var VisaCheckoutCardInfoResponse = function (_record) {
    (0, _inherits3.default)(VisaCheckoutCardInfoResponse, _record);

    function VisaCheckoutCardInfoResponse() {
        (0, _classCallCheck3.default)(this, VisaCheckoutCardInfoResponse);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    VisaCheckoutCardInfoResponse.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(VisaCheckoutCardInfoResponse, json, {
            billingAddress: (0, _LinkMapper.resolve)(json.address).with(function (data) {
                return data;
            }),
            callId: _LinkMapper.fields.string,
            cardArtFileName: _LinkMapper.fields.string,
            cardBrand: _LinkMapper.fields.string,
            cardHolderName: _LinkMapper.fields.string,
            cardType: _LinkMapper.fields.string,
            deliveryAddress: (0, _LinkMapper.resolve)(json.shippingAddress).with(function (data) {
                return data;
            }),
            emailAddress: _LinkMapper.fields.string,
            expirationDate: _LinkMapper.fields.string,
            expired: _LinkMapper.fields.bool,
            lastFourDigits: _LinkMapper.fields.string
        });
    };

    VisaCheckoutCardInfoResponse.prototype.isValid = function isValid() {
        return this.callId && !this.expired;
    };

    return VisaCheckoutCardInfoResponse;
}((0, _immutable.Record)(defaults));

exports.default = VisaCheckoutCardInfoResponse;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.unloadScript = exports.ScriptLoadError = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var unloadScript = exports.unloadScript = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(scriptPromise) {
        var script;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(scriptPromise instanceof _promise2.default)) {
                            _context.next = 8;
                            break;
                        }

                        _context.next = 3;
                        return scriptPromise;

                    case 3:
                        script = _context.sent;

                        script.parentNode.removeChild(script);
                        return _context.abrupt('return', true);

                    case 8:
                        if (scriptPromise.parentNode) {
                            scriptPromise.parentNode.removeChild(scriptPromise);
                        }

                    case 9:
                        return _context.abrupt('return', true);

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function unloadScript(_x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.loadScript = loadScript;

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScriptLoadError = exports.ScriptLoadError = function (_ExtendableError) {
    (0, _inherits3.default)(ScriptLoadError, _ExtendableError);

    function ScriptLoadError(src, loadError) {
        (0, _classCallCheck3.default)(this, ScriptLoadError);

        var _this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call(this, 'Error loading script: ' + src, { loadError: loadError }));

        _this.name = 'ScriptLoadError';

        _this.loadError = loadError;
        return _this;
    }

    return ScriptLoadError;
}(_ExtendableError3.default);

function loadScript(src) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return new _promise2.default(function (resolve, reject) {
        var script = document.createElement('script');
        if (id) {
            script.setAttribute('id', id);
        }

        script.setAttribute('src', src);
        document.head.appendChild(script);

        // All normal amazing browsers
        if (script.onload) {
            script.onload = function () {
                return resolve(script);
            };
            script.onerror = function (error) {
                return reject(new ScriptLoadError(src, error));
            };
        }

        // Microsofts stupid annoying browsers
        if (script.addEventListener) {
            script.addEventListener('load', function () {
                return resolve(script);
            }, false);
            script.addEventListener('error', function (error) {
                return reject(new ScriptLoadError(src, error));
            }, false);
        } else if (script.readyState) {
            script.onreadystatechange = function () {
                return resolve(script);
            };
            script.onerror = function (error) {
                return reject(new ScriptLoadError(src, error));
            };
        }
    });
}

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.WithLoading = undefined;

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WithLoading = exports.WithLoading = function WithLoading(_ref) {
    var isLoading = _ref.isLoading,
        children = _ref.children,
        className = _ref.className;

    if (isLoading) {
        return _react2.default.createElement(
            'div',
            { className: 'with-loading__container ' + className },
            _react2.default.createElement(_Icon2.default, { icon: 'spinner', className: 'otrl otrl-spinner otrl-spin' })
        );
    }
    return children;
};

WithLoading.defaultProps = {
    isLoading: false,
    children: null,
    className: ''
};

WithLoading.propTypes = {
    isLoading: _propTypes2.default.bool.required,
    children: _propTypes2.default.node.required,
    className: _propTypes2.default.string
};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchesPlusbusTicket = function matchesPlusbusTicket(ticket) {
    return function (plusBusTicket) {
        var sameAdults = plusBusTicket.adults === ticket.adults;
        var sameChildren = plusBusTicket.children === ticket.children;
        var passengersMatch = sameAdults || sameChildren;
        var ticketHasRailcard = !!ticket.railcard;
        var plusBusHasRailcard = !!plusBusTicket.railcard;

        if (ticketHasRailcard && !plusBusHasRailcard) {
            return false;
        } else if (!ticketHasRailcard && plusBusHasRailcard) {
            return false;
        } else if (ticketHasRailcard && plusBusHasRailcard) {
            return passengersMatch && ticket.railcard.code === plusBusTicket.railcard.code && !plusBusTicket.isRefunded;
        }

        return passengersMatch && !plusBusTicket.isRefunded;
    };
};

var matchesPlusbusFare = function matchesPlusbusFare(fare, trip) {
    return function (plusBus) {
        var outwardMatches = trip.getPlusBus().matchesOriginOrDestination(plusBus, _AppConstants.PlusBusDirections.OUTWARD);
        var inwardMatches = trip.getPlusBus().matchesOriginOrDestination(plusBus, _AppConstants.PlusBusDirections.RETURN);
        var sameDay = fare.getValidFrom().diff(plusBus.getValidFrom(), 'days') === 0;

        return (outwardMatches || inwardMatches) && sameDay && plusBus.hasAmendableTickets();
    };
};

function fareSetter(fares, fare, ticket) {
    if (!ticket) {
        return fares;
    }

    if (fares.has(fare)) {
        return fares.set(fare, fares.get(fare).add(ticket));
    }

    return fares.set(fare, _immutable.Set.of(ticket));
}

function fareRemover(fares, fare, ticket) {
    fares = fares.set(fare, fares.get(fare).remove(ticket));

    if (fares.get(fare).size === 0) {
        return fares.remove(fare);
    }

    return fares;
}

var defaults = {
    order: null,
    trip: new _Trip2.default(),
    fares: new _immutable.Map(),
    selectedRailcards: {}
};

var AmendRequest = function (_record) {
    (0, _inherits3.default)(AmendRequest, _record);

    function AmendRequest() {
        (0, _classCallCheck3.default)(this, AmendRequest);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AmendRequest.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(AmendRequest, json, {
            order: _LinkMapper.resolve.as(_Order2.default),
            trip: _LinkMapper.resolve.as(_Trip2.default),
            fare: _LinkMapper.resolve.as(_Fare2.default),
            selectedRailcards: _LinkMapper.resolve.as(Object)
        });
    };

    AmendRequest.prototype.isValid = function isValid() {
        var _this2 = this;

        var fares = this.fares.keySeq().toSet();
        return !!fares.size && fares.every(function (fare) {
            return !_this2.getFareWarnings(fare);
        });
    };

    AmendRequest.prototype.hasOutwardFare = function hasOutwardFare() {
        var trip = this.trip,
            fares = this.fares;

        return fares && trip && fares.has(trip.fares.outwardSingle);
    };

    AmendRequest.prototype.hasReturnFare = function hasReturnFare() {
        var trip = this.trip,
            fares = this.fares;

        return fares && trip && fares.has(trip.fares.returnSingle);
    };

    AmendRequest.prototype.getAllValidRailcards = function getAllValidRailcards(_ref) {
        var passengers = _ref.passengers;

        var selectedRailcardsArray = (0, _values2.default)(this.selectedRailcards).map(function (railcard) {
            return {
                code: railcard.code,
                quantity: Math.min(passengers, railcard.quantity)
            };
        });
        return new _immutable.List(selectedRailcardsArray);
    };

    AmendRequest.prototype.areRailcardsValidWithFare = function areRailcardsValidWithFare(fare) {
        var selectedTickets = this.fares.get(fare);
        var railcards = fare.getRailcards(selectedTickets);
        return railcards.every(function (railcard) {
            var railcardTickets = fare.getTicketsWithRailCard(railcard, selectedTickets);
            return railcardTickets.isValid();
        });
    };

    AmendRequest.prototype.getFareWarnings = function getFareWarnings(fare) {
        var selectedTickets = this.fares.get(fare);
        var remainingTickets = fare.tickets.toSet().subtract(selectedTickets);
        var railcards = fare.getRailcards(remainingTickets);
        var warnings = railcards.reduce(function (result, railcard) {
            var railcardTickets = fare.getTicketsWithRailCard(railcard, remainingTickets);
            return railcardTickets.isValid() ? result : result.add('account.orders.refund.warning.' + railcard.code);
        }, new _immutable.Set());

        return warnings.size ? warnings : null;
    };

    AmendRequest.prototype.setOrder = function setOrder(order) {
        return this.set('order', order);
    };

    AmendRequest.prototype.transformFares = function transformFares() {
        var _this3 = this;

        return this.fares.keySeq().toSet().map(function (item) {
            return item.set('tickets', _this3.fares.get(item).toList);
        }).toList();
    };

    AmendRequest.prototype.setPlusBusTickets = function setPlusBusTickets(plusBusFares, ticket, fares) {
        // Automaticaly select the equivalent plusbus fare for a given
        // ticket. When amending, it's like for like, so if a fare has
        // an equivalent plusbus fare that must be selected too. We
        // filter out so that only adults or children are selected.
        var next = fares;
        plusBusFares.map(function (plusBusFare) {
            var selectedTickets = fares.get(plusBusFare);
            var plusBusTicket = plusBusFare.tickets.toSet().subtract(selectedTickets).filter(matchesPlusbusTicket(ticket)).first();
            next = fareSetter(next, plusBusFare, plusBusTicket);
        });

        return next;
    };

    AmendRequest.prototype.removePlusBusTicket = function removePlusBusTicket(plusBusFares, ticket, fares) {
        var next = fares;
        plusBusFares.map(function (plusBusFare) {
            var selectedTickets = fares.get(plusBusFare);
            var plusBusTicket = selectedTickets.filter(matchesPlusbusTicket(ticket)).first();
            next = fareRemover(next, plusBusFare, plusBusTicket);
        });
        return next;
    };

    AmendRequest.prototype.resetSelectedRailcards = function resetSelectedRailcards() {
        var _this4 = this;

        (0, _keys2.default)(this.selectedRailcards).forEach(function (key) {
            return delete _this4.selectedRailcards[key];
        });
    };

    AmendRequest.prototype.addSelectedRailcards = function addSelectedRailcards(fare, ticket) {
        var _this5 = this;

        if (!this.areRailcardsValidWithFare(fare) || fare.isPlusBus()) {
            return;
        }
        var cards = fare.getRailcards();
        if (!(cards && cards.size)) {
            return;
        }
        cards.forEach(function (card) {
            if (_this5.selectedRailcards[card.code]) {
                _this5.selectedRailcards[card.code] = {
                    code: card.code,
                    quantity: _this5.selectedRailcards[card.code].quantity + ticket.adults + ticket.children
                };
            } else {
                _this5.selectedRailcards[card.code] = {
                    code: card.code,
                    quantity: 1
                };
            }
        });
    };

    AmendRequest.prototype.addTicket = function addTicket(fare, ticket) {
        this.addSelectedRailcards(fare, ticket);

        var fares = fareSetter(this.fares, fare, ticket);

        if (this.trip.hasPlusBus()) {
            var plusBusFares = this.trip.getPlusBusFares().filter(matchesPlusbusFare(fare, this.trip));
            fares = this.setPlusBusTickets(plusBusFares, ticket, fares);
        }

        return this.set('fares', fares);
    };

    AmendRequest.prototype.removeSelectedRailcards = function removeSelectedRailcards(fare, ticket) {
        var _this6 = this;

        if (!this.areRailcardsValidWithFare(fare) || fare.isPlusBus()) {
            return;
        }
        var cards = fare.getRailcards();
        if (!(cards && cards.size)) {
            return;
        }
        cards.forEach(function (card) {
            if (!_this6.selectedRailcards[card.code]) {
                return;
            }
            var newQuantity = _this6.selectedRailcards[card.code].quantity - ticket.adults - ticket.children;
            if (newQuantity > 0) {
                _this6.selectedRailcards[card.code] = {
                    code: card.code,
                    quantity: newQuantity
                };
            } else {
                delete _this6.selectedRailcards[card.code];
            }
        });
    };

    AmendRequest.prototype.removeTicket = function removeTicket(fare, ticket) {
        this.removeSelectedRailcards(fare, ticket);

        var fares = fareRemover(this.fares, fare, ticket);

        if (this.trip.hasPlusBus()) {
            var plusBusFares = this.trip.getPlusBusFares().filter(matchesPlusbusFare(fare, this.trip));
            fares = this.removePlusBusTicket(plusBusFares, ticket, fares);
        }

        return this.set('fares', fares);
    };

    AmendRequest.prototype.getAdults = function getAdults(fare) {
        return (0, _Immutable.sum)(this.fares.get(fare), 'adults');
    };

    AmendRequest.prototype.getChildren = function getChildren(fare) {
        return (0, _Immutable.sum)(this.fares.get(fare), 'children');
    };

    AmendRequest.prototype.totalAdminFee = function totalAdminFee(config) {
        var ticketCount = this.getTicketCount();
        return ticketCount * config.adminFeePerTicket + config.adminFeePerOrder;
    };

    AmendRequest.prototype.getAmendedTickets = function getAmendedTickets() {
        return this.fares.toList().flatten(1);
    };

    AmendRequest.prototype.getAmendedTicketIds = function getAmendedTicketIds() {
        return this.getAmendedTickets().map(function (ticket) {
            return ticket.id;
        });
    };

    AmendRequest.prototype.getTicketCount = function getTicketCount() {
        var _this7 = this;

        return this.fares.keySeq().filter(function (x) {
            return !x.isPlusBus();
        }).map(function (x) {
            return _this7.fares.get(x);
        }).toList().flatten(1).size;
    };

    AmendRequest.prototype.isSelected = function isSelected(fare) {
        return this.fares.has(fare);
    };

    AmendRequest.prototype.isAmendingInwardReturnOnly = function isAmendingInwardReturnOnly() {
        return this.hasReturnFare() && !this.hasOutwardFare();
    };

    // this method only returns an accurate description once the request's order has been updated with new trip


    AmendRequest.prototype.getAmendmentDescription = function getAmendmentDescription() {
        if (!this.trip.isReturn()) {
            return 'single-outward';
        }

        var amendedPortion = this.order.trips.last().get('fares');

        if (amendedPortion.get('outwardSingle') && amendedPortion.get('returnSingle')) {
            return 'return-both';
        }

        var amendedOrigin = amendedPortion.get('outwardSingle').origin.nlc;
        var amendedDestination = amendedPortion.get('outwardSingle').destination.nlc;
        var originalOrigin = this.trip.fares.outwardSingle.origin.nlc;
        var originalDestination = this.trip.fares.outwardSingle.destination.nlc;

        if (amendedOrigin === originalOrigin && amendedDestination === originalDestination) {
            return 'return-outward';
        }
        if (amendedOrigin === originalDestination && amendedDestination === originalOrigin) {
            return 'return-inward';
        }
        console.error('Amend bookings description not found');
        return '';
    };

    AmendRequest.prototype.getTotalPrice = function getTotalPrice(direction) {
        var fares = this.fares.keySeq().toSet();
        var fare = direction === 'inward' ? fares.last() : fares.first();
        var tickets = this.fares.get(fare);
        return (0, _Immutable.sum)(tickets, 'price');
    };

    AmendRequest.prototype.getHighestTicketPrice = function getHighestTicketPrice(direction) {
        var fares = this.fares.keySeq().toSet();
        var fare = direction === 'inward' ? fares.last() : fares.first();
        var tickets = this.fares.get(fare).sortBy(function (ticket) {
            return ticket.price;
        });
        return tickets.last().price;
    };

    AmendRequest.prototype.getTicketTypeCode = function getTicketTypeCode(direction) {
        var list = void 0;
        if (direction === 'inward') {
            list = this.trip.fares.returnSingle;
        } else {
            list = this.trip.fares.outwardSingle;
        }
        return list.ticketType.code;
    };

    return AmendRequest;
}((0, _immutable.Record)(defaults));

exports.default = AmendRequest;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    adminFeePerTicket: 0,
    adminFeePerOrder: 0
};

var AmendConfig = function (_record) {
    (0, _inherits3.default)(AmendConfig, _record);

    function AmendConfig() {
        (0, _classCallCheck3.default)(this, AmendConfig);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AmendConfig.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(AmendConfig, json, {
            adminFeePerTicket: _LinkMapper.fields.number,
            adminFeePerOrder: _LinkMapper.fields.number
        });
    };

    return AmendConfig;
}((0, _immutable.Record)(defaults));

exports.default = AmendConfig;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _isUndefined2 = __webpack_require__(278);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

exports.getCustomerKeyGoUrl = getCustomerKeyGoUrl;
exports.getCustomerSmartcardKeyGoUrl = getCustomerSmartcardKeyGoUrl;
exports.trimMillis = trimMillis;

var _LinkMapper = __webpack_require__(8);

var _IblocksAPIClient = __webpack_require__(834);

var _IblocksAPIClient2 = _interopRequireDefault(_IblocksAPIClient);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _TransactionHistoryResults = __webpack_require__(672);

var _TransactionHistoryResults2 = _interopRequireDefault(_TransactionHistoryResults);

var _ReimbursementResponse = __webpack_require__(1735);

var _ReimbursementResponse2 = _interopRequireDefault(_ReimbursementResponse);

var _Tap = __webpack_require__(653);

var _Tap2 = _interopRequireDefault(_Tap);

var _Location = __webpack_require__(1063);

var _Location2 = _interopRequireDefault(_Location);

var _CollectionLocation = __webpack_require__(1736);

var _CollectionLocation2 = _interopRequireDefault(_CollectionLocation);

var _KeyGo = __webpack_require__(1134);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCustomerKeyGoUrl() {
    var user = _UserStore2.default.getCurrent();
    return '/smartcard/' + user.id + '/keygo';
}

function getCustomerSmartcardKeyGoUrl() {
    var user = _UserStore2.default.getCurrent();
    return '/customers/' + user.id + '/smartcard/keygo';
}

function trimMillis(datetime) {
    return datetime.toISOString().split('.')[0] + 'Z';
}

var KeyGoService = {
    getKeyGoTransactions: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var url, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = getCustomerKeyGoUrl() + '/journey-history';
                            _context.next = 3;
                            return _IblocksAPIClient2.default.get(url, data);

                        case 3:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolve)(response).as(_TransactionHistoryResults2.default));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function getKeyGoTransactions() {
            return _ref.apply(this, arguments);
        }

        return getKeyGoTransactions;
    }(),
    completeJourney: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
            var journeyId = _ref2.journeyId,
                incompleteTap = _ref2.incompleteTap,
                reason = _ref2.reason,
                switchEntryExit = _ref2.switchEntryExit;
            var url, completeJourneyResponse, status, message;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            url = getCustomerKeyGoUrl() + ('/complete-journey/' + journeyId);
                            _context2.prev = 1;
                            _context2.next = 4;
                            return _IblocksAPIClient2.default.post(url, {
                                locationCode: incompleteTap.locationCode,
                                locationName: incompleteTap.locationName,
                                timestamp: trimMillis(incompleteTap.timestamp),
                                reasonCode: reason.title,
                                reasonId: reason.id,
                                switchEntryExit: switchEntryExit
                            });

                        case 4:
                            completeJourneyResponse = _context2.sent;
                            return _context2.abrupt('return', (0, _LinkMapper.resolve)(completeJourneyResponse).as(_Tap2.default));

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](1);

                            if (!_context2.t0.body) {
                                _context2.next = 18;
                                break;
                            }

                            status = _context2.t0.body.status;
                            message = _context2.t0.body.message;

                            if (!(status === 409 || status === 400)) {
                                _context2.next = 17;
                                break;
                            }

                            throw new _KeyGo.IBlocksCompleteJourneyError(message.code);

                        case 17:
                            throw new _KeyGo.IBlocksApiError(message.message, message.code);

                        case 18:
                            throw _context2.t0;

                        case 19:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 8]]);
        }));

        function completeJourney(_x2) {
            return _ref3.apply(this, arguments);
        }

        return completeJourney;
    }(),
    getCollectionLocations: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _AuthenticatedAPIClient2.default.get('/delivery/collection-points/smartcard/keygo');

                        case 2:
                            response = _context3.sent;
                            return _context3.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_CollectionLocation2.default));

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function getCollectionLocations() {
            return _ref4.apply(this, arguments);
        }

        return getCollectionLocations;
    }(),
    getKeyGoLocations: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var url, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            url = getCustomerKeyGoUrl() + '/locations?filter=SUPPORTED_AREA';
                            _context4.next = 3;
                            return _IblocksAPIClient2.default.get(url);

                        case 3:
                            response = _context4.sent;
                            return _context4.abrupt('return', (0, _LinkMapper.resolveAll)(response.locations).as(_Location2.default));

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function getKeyGoLocations() {
            return _ref5.apply(this, arguments);
        }

        return getKeyGoLocations;
    }(),
    withdrawKeyGoBalance: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            var url, response;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            url = getCustomerSmartcardKeyGoUrl() + '/reimbursement';
                            _context5.next = 3;
                            return _IblocksAPIClient2.default.post(url);

                        case 3:
                            response = _context5.sent;
                            return _context5.abrupt('return', (0, _LinkMapper.resolve)(response).as(_ReimbursementResponse2.default));

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function withdrawKeyGoBalance() {
            return _ref6.apply(this, arguments);
        }

        return withdrawKeyGoBalance;
    }(),
    withdrawKeyGoBalanceWithCheque: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(reimbursementId) {
            var url, response;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            if (!(0, _isUndefined3.default)(reimbursementId)) {
                                _context6.next = 4;
                                break;
                            }

                            return _context6.abrupt('return', _promise2.default.reject());

                        case 4:
                            url = getCustomerSmartcardKeyGoUrl() + '/reimbursement/' + reimbursementId;
                            _context6.next = 7;
                            return _IblocksAPIClient2.default.put(url);

                        case 7:
                            response = _context6.sent;
                            return _context6.abrupt('return', (0, _LinkMapper.resolve)(response));

                        case 9:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function withdrawKeyGoBalanceWithCheque(_x3) {
            return _ref7.apply(this, arguments);
        }

        return withdrawKeyGoBalanceWithCheque;
    }(),
    validateKeygo: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            var collectionLocationNlc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var user, data, url;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            data = {
                                collectionLocationNlc: collectionLocationNlc
                            };
                            url = '/smartcard/' + user.id + '/validate-keygo';
                            _context7.prev = 3;
                            _context7.next = 6;
                            return _AuthenticatedAPIClient2.default.post(url, data);

                        case 6:
                            return _context7.abrupt('return', true);

                        case 9:
                            _context7.prev = 9;
                            _context7.t0 = _context7['catch'](3);

                            console.warn('validateKeygo error', _context7.t0);
                            return _context7.abrupt('return', false);

                        case 13:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[3, 9]]);
        }));

        function validateKeygo() {
            return _ref8.apply(this, arguments);
        }

        return validateKeygo;
    }()
};

exports.default = KeyGoService;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderHistoryStore = function (_BaseStore) {
    (0, _inherits3.default)(OrderHistoryStore, _BaseStore);

    function OrderHistoryStore() {
        (0, _classCallCheck3.default)(this, OrderHistoryStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    OrderHistoryStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            loading: false,
            orders: null,
            pagination: null,
            currentOrder: null,
            currentOrderRefundCalculations: null
        });
    };

    OrderHistoryStore.prototype.handleSearching = function handleSearching() {
        this.setState(this.state.set('loading', true));
    };

    OrderHistoryStore.prototype.handleOrders = function handleOrders(_ref) {
        var orders = _ref.orders,
            pagination = _ref.pagination;

        this.setState(this.state.merge({
            loading: false,
            orders: orders,
            pagination: pagination
        }));
    };

    OrderHistoryStore.prototype.handleOrderDetails = function handleOrderDetails(_ref2) {
        var order = _ref2.order,
            refundCalculations = _ref2.refundCalculations;

        this.setState(this.state.merge({
            currentOrder: order,
            currentOrderRefundCalculations: refundCalculations
        }));
    };

    OrderHistoryStore.prototype.getOrder = function getOrder(orderId) {
        var order = this.state.get('currentOrder');
        if ((0, _result3.default)(order, 'id') === orderId) {
            return order;
        }

        var orders = this.state.get('orders');
        return orders && orders.find(function (o) {
            return o.id === orderId;
        }) || undefined;
    };

    OrderHistoryStore.prototype.getOrderRefundCalculations = function getOrderRefundCalculations() {
        return this.state.get('currentOrderRefundCalculations');
    };

    OrderHistoryStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.CUSTOMER_ORDERS_SEARCHING] = this.handleSearching, _ref3[_AppConstants.ActionTypes.CUSTOMER_ORDERS_LOADED] = this.handleOrders, _ref3[_AppConstants.ActionTypes.CUSTOMER_ORDER_LOADED] = this.handleOrderDetails, _ref3[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref3[_AppConstants.ActionTypes.ORDER_PAID] = this.resetState, _ref3[_AppConstants.ActionTypes.REFUND_COMPLETE] = this.resetState, _ref3;
    };

    /*
        * Returns the refund calculation for a specific order.
        * @param {number}
        * 
        * Helper method added only for unit testing purposes.
    */


    OrderHistoryStore.prototype.getRefundCalculationForOrder = function getRefundCalculationForOrder(orderId) {
        var map = this.state.get('currentOrderRefundCalculations');
        if (!map || typeof map.get !== 'function') return null;
        return map.get(String(orderId)) || null;
    };

    return OrderHistoryStore;
}(_BaseStore3.default);

exports.default = new OrderHistoryStore();

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    seatingAvailability: new _immutable.List(),
    showSeatfinder: false
});

var SeatingStore = function (_BaseStore) {
    (0, _inherits3.default)(SeatingStore, _BaseStore);

    function SeatingStore() {
        (0, _classCallCheck3.default)(this, SeatingStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SeatingStore.prototype.getInitialState = function getInitialState() {
        return new State();
    };

    SeatingStore.prototype.setSeatingAvailability = function setSeatingAvailability(_ref) {
        var seatingAvailability = _ref.seatingAvailability;

        this.setState(this.state.set('seatingAvailability', new _immutable.List(seatingAvailability)));
    };

    SeatingStore.prototype.getSeatingAvailability = function getSeatingAvailability() {
        return this.state.get('seatingAvailability');
    };

    SeatingStore.prototype.toggleSeatfinder = function toggleSeatfinder() {
        this.setState(this.state.set('showSeatfinder', !this.state.get('showSeatfinder')));
    };

    SeatingStore.prototype.getSeatfinderStatus = function getSeatfinderStatus() {
        return this.state.get('showSeatfinder');
    };

    SeatingStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.SEATING_AVAILABILITY_LOADED] = this.setSeatingAvailability, _ref2[_AppConstants.ActionTypes.TOGGLE_SEATFINDER] = this.toggleSeatfinder, _ref2;
    };

    return SeatingStore;
}(_BaseStore3.default);

var instance = new SeatingStore({ storageKey: 'seating' });

exports.default = instance;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FareClassBadge(_ref) {
    var _classnames;

    var isFirstClass = _ref.isFirstClass,
        className = _ref.className;

    var baseClass = 'fare__class-badge';
    var fareClassBadge = (0, _classnames3.default)(className, baseClass, (_classnames = {}, _classnames[baseClass + '--first'] = isFirstClass, _classnames[baseClass + '--standard'] = !isFirstClass, _classnames));

    return _react2.default.createElement(
        'span',
        { className: fareClassBadge },
        isFirstClass ? (0, _I18n.translate)('booking.fares.details.class.1st') : (0, _I18n.translate)('booking.fares.details.class.standard')
    );
}

FareClassBadge.propTypes = {
    isFirstClass: _propTypes2.default.bool.isRequired,
    className: _propTypes2.default.string
};

exports.default = FareClassBadge;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ERROR_AMAZON_TIMEOUT = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _times2 = __webpack_require__(598);

var _times3 = _interopRequireDefault(_times2);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AmazonAPIClient = __webpack_require__(921);

var _AmazonAPIClient2 = _interopRequireDefault(_AmazonAPIClient);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _PaymentStore = __webpack_require__(418);

var _PaymentStore2 = _interopRequireDefault(_PaymentStore);

var _ExternalScript = __webpack_require__(1016);

var _Payment = __webpack_require__(423);

var _AmazonPayError = __webpack_require__(1059);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ERROR_AMAZON_TIMEOUT = exports.ERROR_AMAZON_TIMEOUT = 'OTRL_AMAZON_SDK_TIMEOUT_ERROR';
var AMAZON_SCOPE = 'profile postal_code profile:user_id payments:widget payments:shipping_address payments:billing_address';
var SDK_CHECK_INTERVAL_MS = 100;
var SDK_FAILURE_TIMEOUT_MS = 10000;

var sellerId = _config2.default.get('amazonSellerId'); // Merchant ID
var accessToken = null;
var amazonOrderReferenceId = '';
var timeoutSdkId = null;
var intervalSdkId = null;
var options = {};
var csrfToken = null;

var waitForAmazonSdk = function waitForAmazonSdk() {
    return new _promise2.default(function (resolve, reject) {
        // clear any previous timers
        clearTimeout(timeoutSdkId);
        clearInterval(intervalSdkId);

        timeoutSdkId = setTimeout(function () {
            reject();
            throw ERROR_AMAZON_TIMEOUT;
        }, SDK_FAILURE_TIMEOUT_MS);
        intervalSdkId = setInterval(function () {
            if (typeof window.amazon !== 'undefined' && typeof window.amazon.Login !== 'undefined') {
                clearTimeout(timeoutSdkId);
                clearInterval(intervalSdkId);
                resolve();
            }
        }, SDK_CHECK_INTERVAL_MS);
    });
};

var getCrossSiteRequestForgeryToken = function getCrossSiteRequestForgeryToken() {
    var token = void 0;

    if (window.crypto) {
        // 512-bits token
        token = btoa(window.crypto.getRandomValues(new Uint32Array(16)).join(''));
    } else {
        token = (0, _times3.default)(10, function () {
            return Math.random().toString(36).slice(2);
        }).join('');
    }

    csrfToken = token;

    return token;
};

var AmazonPayService = {
    authorizeLogin: function authorizeLogin(_ref) {
        var _ref$useRedirect = _ref.useRedirect,
            useRedirect = _ref$useRedirect === undefined ? false : _ref$useRedirect;

        // Amazon supports two methods of authentication
        // 1. Popup - optimised for mobile and desktop web which works similar to PayPal pop-up modal window
        // 2. Redirect - required for mobile webviews inside native apps as they do not support pop-up browser windows
        var popup = !useRedirect;

        var loginOptions = {
            response_type: options.responseType,
            popup: popup,
            scope: AMAZON_SCOPE,
            scope_data: {
                profile: { essential: true }
            },
            state: getCrossSiteRequestForgeryToken()
        };
        var redirectUrl = _urls2.default.getCurrentHostUrl(_AppConstants.CheckoutStages.PAYMENT_AMAZON_PAY);

        // must defer here otherwise Payment.js won't get the state updated with Amazon Pay payment method
        (0, _defer3.default)(function () {
            return options.handleOnLoginComplete(false);
        });

        if (useRedirect) {
            window.amazon.Login.authorize(loginOptions, redirectUrl);
        } else {
            window.amazon.Login.authorize(loginOptions, function (response) {
                if (!AmazonPayService.validateCsrf(response.state, csrfToken)) {
                    throw 'CSRF tokens mismatch error';
                }

                if (response.error) {
                    (0, _defer3.default)(function () {
                        return options.handleOnError(response.error);
                    });
                } else {
                    accessToken = response.access_token;
                    (0, _defer3.default)(function () {
                        return options.handleOnLoginComplete(true, accessToken);
                    });
                }
            });
        }
    },

    getAmazonOrderReferenceId: function getAmazonOrderReferenceId() {
        return amazonOrderReferenceId;
    },
    loadSdk: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
            var _options = _ref2.options,
                handleOrderReferenceId = _ref2.handleOrderReferenceId,
                handleOnPaymentSelect = _ref2.handleOnPaymentSelect,
                handleOnAddressSelect = _ref2.handleOnAddressSelect,
                handleOnLoginComplete = _ref2.handleOnLoginComplete,
                handleOnError = _ref2.handleOnError;
            var defaults, isButtonVisible, isAmazonLoginButtonVisible, amazonPaySdkUrl;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            defaults = {
                                addressBook: false,
                                addressBookId: _AppConstants.AmazonIds.ADDRESS_BOOK,
                                buttonColor: 'Gold',
                                buttonId: _AppConstants.AmazonIds.BUTTON,
                                buttonSize: 'small',
                                buttonType: 'PwA',
                                handleOnAddressSelect: handleOnAddressSelect,
                                handleOnError: handleOnError,
                                handleOnLoad: _noop3.default,
                                handleOnLoginComplete: handleOnLoginComplete,
                                handleOnPaymentSelect: handleOnPaymentSelect,
                                handleOrderReferenceId: handleOrderReferenceId,
                                isAddressReadOnly: false,
                                isAmazonLogin: false,
                                language: "en-UK",
                                loginButtonID: _AppConstants.AmazonIds.LOGIN_BUTTON,
                                overrideAmazonOrderReferenceId: null,
                                responseType: _AppConstants.AmazonLoginResponseType.TOKEN,
                                size: _config2.default.get('amazonPaySize'),
                                walletId: _AppConstants.AmazonIds.WALLET
                            };


                            options = (0, _extends3.default)({}, defaults, _options);

                            isButtonVisible = document.getElementById(options.buttonId) && document.getElementById(options.buttonId).hasChildNodes();
                            isAmazonLoginButtonVisible = document.getElementById(options.loginButtonId) && document.getElementById(options.loginButtonId).hasChildNodes();

                            if (!(accessToken === null || !isButtonVisible || options.isAmazonLogin && !isAmazonLoginButtonVisible)) {
                                _context.next = 13;
                                break;
                            }

                            window.onAmazonLoginReady = otrlOnAmazonLoginReady;
                            window.onAmazonPaymentsReady = otrlOnAmazonPaymentsReady({ handleOrderReferenceId: handleOrderReferenceId, handleOnPaymentSelect: handleOnPaymentSelect, handleOnAddressSelect: handleOnAddressSelect, handleOnLoginComplete: handleOnLoginComplete, handleOnError: handleOnError });

                            amazonPaySdkUrl = _config2.default.get('amazonPaySdkUrls')[_config2.default.get('amazonPayEnvironment')];
                            _context.next = 10;
                            return (0, _ExternalScript.loadScript)(amazonPaySdkUrl);

                        case 10:
                            _context.next = 12;
                            return waitForAmazonSdk();

                        case 12:

                            options.handleOnLoad();

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadSdk(_x) {
            return _ref3.apply(this, arguments);
        }

        return loadSdk;
    }(),
    cancelOrder: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(orderReferenceId) {
            var url, error, response, currentOrderId, request;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            url = '/payments/amazonpay/order-reference';
                            error = void 0, response = void 0;
                            currentOrderId = _OrderStore2.default.getCurrent().get('id');
                            request = {
                                amazonOrderReferenceId: orderReferenceId,
                                orderId: currentOrderId
                            };
                            _context2.prev = 4;
                            _context2.next = 7;
                            return _AmazonAPIClient2.default.delete(url, request);

                        case 7:
                            response = _context2.sent;
                            _context2.next = 13;
                            break;

                        case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2['catch'](4);

                            error = _context2.t0;

                        case 13:
                            return _context2.abrupt('return', { error: error, response: response });

                        case 14:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[4, 10]]);
        }));

        function cancelOrder(_x2) {
            return _ref4.apply(this, arguments);
        }

        return cancelOrder;
    }(),
    confirmOrder: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(orderReferenceId) {
            var url, error, response, currentOrderId, request;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            url = '/payments/amazonpay/order-reference';
                            error = void 0, response = void 0;
                            currentOrderId = _OrderStore2.default.getCurrent().get('id');
                            request = {
                                amazonOrderReferenceId: orderReferenceId,
                                orderId: currentOrderId,
                                successUrl: _urls2.default.getCurrentHostUrl(_AppConstants.CheckoutStages.AMAZON_PAY_MFA_SUCCESS),
                                failureUrl: _urls2.default.getCurrentHostUrl(_AppConstants.CheckoutStages.AMAZON_PAY_MFA_FAILURE)
                            };
                            _context3.prev = 4;
                            _context3.next = 7;
                            return _AmazonAPIClient2.default.post(url, request);

                        case 7:
                            response = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](4);

                            error = _context3.t0;

                        case 13:
                            return _context3.abrupt('return', { error: error, response: response });

                        case 14:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[4, 10]]);
        }));

        function confirmOrder(_x3) {
            return _ref5.apply(this, arguments);
        }

        return confirmOrder;
    }(),
    logout: function logout() {
        window.amazon.Login.logout();
        document.cookie = "amazon_Login_accessToken=;expires=Thu, 01 Jan 1970 00:00:00 GMT"; // delete cookie for redirection
    },
    getOrderDetails: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var addressConsentToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : accessToken;
            var orderReferenceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getAmazonOrderReferenceId();
            var url, error, response, currentOrderId, request;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            url = '/payments/amazonpay/order-address-details';
                            error = void 0, response = void 0;
                            currentOrderId = _OrderStore2.default.getCurrent().get('id');
                            request = {
                                amazonOrderReferenceId: orderReferenceId,
                                addressConsentToken: addressConsentToken,
                                orderId: currentOrderId
                            };
                            _context4.prev = 4;
                            _context4.next = 7;
                            return _AmazonAPIClient2.default.post(url, request);

                        case 7:
                            response = _context4.sent;
                            _context4.next = 13;
                            break;

                        case 10:
                            _context4.prev = 10;
                            _context4.t0 = _context4['catch'](4);

                            error = _context4.t0;

                        case 13:
                            return _context4.abrupt('return', { error: error, response: response });

                        case 14:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[4, 10]]);
        }));

        function getOrderDetails() {
            return _ref6.apply(this, arguments);
        }

        return getOrderDetails;
    }(),
    setOrderDetails: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            var orderReferenceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getAmazonOrderReferenceId();
            var url, error, response, currentOrderId, amount, request;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!options.overrideAmazonOrderReferenceId) {
                                _context5.next = 2;
                                break;
                            }

                            return _context5.abrupt('return', { response: 'InvalidPaymentMethod' });

                        case 2:
                            url = '/payments/amazonpay/order-details';
                            error = void 0, response = void 0;
                            currentOrderId = _OrderStore2.default.getCurrent().get('id');
                            amount = _PaymentStore2.default.getPaymentAmount();
                            request = {
                                amazonOrderReferenceId: orderReferenceId,
                                orderId: currentOrderId,
                                amount: amount
                            };
                            _context5.prev = 7;
                            _context5.next = 10;
                            return _AmazonAPIClient2.default.post(url, request);

                        case 10:
                            response = _context5.sent;
                            _context5.next = 16;
                            break;

                        case 13:
                            _context5.prev = 13;
                            _context5.t0 = _context5['catch'](7);

                            error = _context5.t0;

                        case 16:
                            return _context5.abrupt('return', { error: error, response: response });

                        case 17:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[7, 13]]);
        }));

        function setOrderDetails() {
            return _ref7.apply(this, arguments);
        }

        return setOrderDetails;
    }(),
    authorizeOrder: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(orderReferenceId, addressConsentToken) {
            var url, response, currentOrderId, amount, request;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            url = '/payments/amazonpay/authorize';
                            response = void 0;
                            currentOrderId = _OrderStore2.default.getCurrent().get('id');
                            amount = _PaymentStore2.default.getPaymentAmount();
                            request = {
                                amazonOrderReferenceId: orderReferenceId,
                                orderId: currentOrderId,
                                amount: amount,
                                addressConsentToken: addressConsentToken ? addressConsentToken : accessToken
                            };
                            _context6.prev = 5;
                            _context6.next = 8;
                            return _AmazonAPIClient2.default.post(url, request);

                        case 8:
                            response = _context6.sent;
                            _context6.next = 14;
                            break;

                        case 11:
                            _context6.prev = 11;
                            _context6.t0 = _context6['catch'](5);
                            throw new _AmazonPayError.AmazonPayError(_context6.t0);

                        case 14:
                            return _context6.abrupt('return', response);

                        case 15:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[5, 11]]);
        }));

        function authorizeOrder(_x7, _x8) {
            return _ref8.apply(this, arguments);
        }

        return authorizeOrder;
    }(),
    confirmOrderWithFlow: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(orderReferenceId) {
            var _this = this;

            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            window.OffAmazonPayments.initConfirmationFlow(sellerId, amazonOrderReferenceId, function () {
                                var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(confirmationFlow) {
                                    var stage, response;
                                    return _regenerator2.default.wrap(function _callee7$(_context7) {
                                        while (1) {
                                            switch (_context7.prev = _context7.next) {
                                                case 0:
                                                    stage = 'confirmation';
                                                    _context7.next = 3;
                                                    return AmazonPayService.confirmOrder(orderReferenceId);

                                                case 3:
                                                    response = _context7.sent;

                                                    if (response.error) {
                                                        _context7.next = 7;
                                                        break;
                                                    }

                                                    confirmationFlow.success();

                                                    return _context7.abrupt('return', response.response);

                                                case 7:

                                                    confirmationFlow.error();
                                                    throw new _Payment.PaymentUnauthorizedError('AmazonPay error at stage \'' + stage + '\'.', _AppConstants.PaymentAuthCodes.API_ERROR);

                                                case 9:
                                                case 'end':
                                                    return _context7.stop();
                                            }
                                        }
                                    }, _callee7, _this);
                                }));

                                return function (_x10) {
                                    return _ref10.apply(this, arguments);
                                };
                            }());

                        case 1:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function confirmOrderWithFlow(_x9) {
            return _ref9.apply(this, arguments);
        }

        return confirmOrderWithFlow;
    }(),


    // eslint-disable-next-line no-shadow
    setCookies: function setCookies(accessToken) {
        document.cookie = 'amazon_Login_accessToken=' + accessToken + ';secure';
    },
    validateCsrf: function validateCsrf(responseToken, originalToken) {
        return responseToken === originalToken;
    }
};

var onOrderReferenceCreate = function onOrderReferenceCreate(handleOrderReferenceId) {
    return function (orderReference) {
        amazonOrderReferenceId = orderReference.getAmazonOrderReferenceId();

        if (typeof handleOrderReferenceId === 'function') {
            handleOrderReferenceId(amazonOrderReferenceId);
        }
    };
};

var otrlOnAmazonLoginReady = function otrlOnAmazonLoginReady() {
    var clientId = _config2.default.get('amazonPayEnvironment') === 'sandbox' ? _config2.default.get('amazonPayClientIdSandbox') : _config2.default.get('amazonPayClientId');
    // eslint-disable-next-line no-console
    console.log('%c* ClientId', 'background: #fc0; color: #333', clientId);
    if (!clientId) {
        throw new Error('No Amazon Pay client ID set. Please try again');
    }

    window.amazon.Login.setClientId(clientId);
    window.amazon.Login.setUseCookie(true);
};

var otrlOnAmazonPaymentsReady = function otrlOnAmazonPaymentsReady(_ref11) {
    var handleOrderReferenceId = _ref11.handleOrderReferenceId,
        handleOnPaymentSelect = _ref11.handleOnPaymentSelect,
        handleOnError = _ref11.handleOnError;
    return function () {
        // It's important that Amazon Login calls the createWalletWidget.
        // If it won't call it even if 'LwA' option is passed the Amazon SDK
        // will expect a real Amazon login instaead of a sandbox.

        var createWalletWidget = function createWalletWidget() {
            // Use either the amazonOrderReferenceId from the current Amazon session
            // or use the overriden value (useful for InvalidPaymentMethod).
            var orderReferenceId = options.overrideAmazonOrderReferenceId ? options.overrideAmazonOrderReferenceId : amazonOrderReferenceId;

            // If there's an address book connect the wallet with the address book with the current (or overriden)
            // reference id. Otherwise for wallet-only payments don't pass any order reference and rely on
            // the new order reference created by Amazon Pay SDK.
            var passAmazonOrderReferenceId = options.addressBook || options.overrideAmazonOrderReferenceId ? { amazonOrderReferenceId: orderReferenceId } : null;

            new window.OffAmazonPayments.Widgets.Wallet((0, _extends3.default)({
                sellerId: sellerId,
                scope: AMAZON_SCOPE
            }, passAmazonOrderReferenceId, {
                // If there's an address book present do not retrieve the order reference as both has to be the same.
                // Otherwise, for the wallet-only payments, run a callback to get the order reference.
                onOrderReferenceCreate: options.addressBook ? _noop3.default : onOrderReferenceCreate(handleOrderReferenceId),
                onPaymentSelect: function onPaymentSelect() {
                    if (typeof handleOnPaymentSelect === 'function') {
                        handleOnPaymentSelect();
                    }
                },
                design: {
                    designMode: 'responsive'
                },
                onError: function onError(error) {
                    handleOnError(error);
                }
            })).bind(options.walletId);
        };

        if (options.addressBook) {
            // Read-only mode is required for InvalidPaymentOnly authorisation errors so that
            // user can choose another payment method  but cannot alter the address.
            var passDisplayMode = options.isAddressReadOnly ? { displayMode: 'Read' } : null;
            // Same as above for the wallet case. If there's an order reference that should be retained
            // (for InvalidPaymentMethod we want to use the same order reference so that Amazon Pay
            // can display a better UI in their widgets) then use it otherwise let Amazon Pay SDK
            // create it for you via their onOrderReferenceCreate callback.
            var passOrderReference = options.overrideAmazonOrderReferenceId ? { amazonOrderReferenceId: options.overrideAmazonOrderReferenceId } : { onOrderReferenceCreate: onOrderReferenceCreate(handleOrderReferenceId) };

            new window.OffAmazonPayments.Widgets.AddressBook((0, _extends3.default)({
                sellerId: sellerId,
                scope: AMAZON_SCOPE
            }, passDisplayMode, passOrderReference, {
                onAddressSelect: function onAddressSelect(address) {
                    // do stuff here like recalculate tax and/or shipping
                    options.handleOnAddressSelect(address);
                },
                design: {
                    designMode: 'responsive'
                },
                onError: function onError(error) {
                    handleOnError(error);
                },
                onReady: createWalletWidget
            })).bind(options.addressBookId);
        } else {
            createWalletWidget();
        }

        // var authRequest;

        // eslint-disable-next-line new-cap
        // window.OffAmazonPayments.Button("AmazonPayButton", sellerId, {
        //     type: options.buttonType,
        //     color: options.buttonColor,
        //     size: options.buttonSize,

        //     authorization: function () {
        //         const loginOptions = {
        //             scope: AMAZON_SCOPE,
        //             popup: true
        //         };

        //         const redirectUrl = 'https://' + config.get('bookingEngineHost') + urls.location(CheckoutStages.PAYMENT_AMAZON_PAY).pathname;

        //         window.amazon.Login.authorize(loginOptions, redirectUrl);
        //     },

        //     onError: function (error) {
        //         console.error(`Amazon Pay error: ${error.getErrorCode()} - ${error.getErrorMessage()}`);
        //     }
        // });
    };
};

exports.default = AmazonPayService;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleInputSimple = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(ToggleInputSimple, _React$PureComponent);

    function ToggleInputSimple() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ToggleInputSimple);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            checked: !!_this.props.checked
        }, _this._handleChange = function () {
            var checked = _this.state.checked;
            var _this$props = _this.props,
                field = _this$props.field,
                index = _this$props.index;


            var dynamicArguments = function dynamicArguments() {
                /* passing field name, toggle status and index of the element if necessary
                (used for photocards, but it can be useful for other iterable element). */
                if (_this.props.field) {
                    return [field, !checked, index];
                } else {
                    return !checked;
                }
            };

            if (!_this.props.disabled) {
                var _this$props$onChange;

                _this.setState({ checked: !checked }, (_this$props$onChange = _this.props.onChange).bind.apply(_this$props$onChange, [null].concat(dynamicArguments())));
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ToggleInputSimple.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.checked !== this.props.checked) {
            this.setState({ checked: !!newProps.checked });
        }
    };

    ToggleInputSimple.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            value = _props.value,
            label = _props.label,
            labelClassName = _props.labelClassName,
            className = _props.className,
            disabled = _props.disabled,
            disableInputOnly = _props.disableInputOnly,
            onClick = _props.onClick,
            isJourneySupport = _props.isJourneySupport,
            title = _props.title,
            titleId = _props.titleId,
            isHalfOnState = _props.isHalfOnState,
            infoId = _props.infoId,
            southeasternId = _props.southeasternId;
        var checked = this.state.checked;

        var containerClasses = (0, _classnames2.default)(className, 'clearfix', 'toggle-simple', {
            'toggle-simple--checked': checked,
            'toggle-simple--disabled': disabled && !disableInputOnly,
            'toggle-simple--half': isHalfOnState
        });
        var toggleClasses = (0, _classnames2.default)('toggle-simple__lane pull-left', {
            'journey-support': isJourneySupport
        });
        var toggleStateClasses = (0, _classnames2.default)('toggle-simple__handle', {
            'half-state': isHalfOnState
        });

        return _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: containerClasses },
                _react2.default.createElement(
                    'title',
                    { className: 'sr-only', id: titleId },
                    title
                ),
                _react2.default.createElement('input', { type: 'checkbox',
                    id: southeasternId ? southeasternId : id,
                    className: (0, _classnames2.default)({ 'toggle-simple--disabled': disabled && disableInputOnly }),
                    name: value,
                    disabled: disabled,
                    defaultChecked: checked,
                    onChange: this._handleChange,
                    onClick: onClick,
                    'aria-describedby': isHalfOnState ? infoId : titleId,
                    'aria-checked': checked,
                    'aria-label': title }),
                _react2.default.createElement(
                    'div',
                    { className: 'toggle-simple-inner-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: toggleClasses },
                        _react2.default.createElement('div', { className: toggleStateClasses })
                    ),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: southeasternId ? southeasternId : id, className: labelClassName },
                        label
                    )
                )
            )
        );
    };

    return ToggleInputSimple;
}(_react2.default.PureComponent), _class.propTypes = {
    id: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.object.isRequired]),
    field: _propTypes2.default.string,
    labelClassName: _propTypes2.default.string,
    checked: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    disableInputOnly: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    className: _propTypes2.default.string,
    index: _propTypes2.default.number,
    isJourneySupport: _propTypes2.default.bool,
    title: _propTypes2.default.string,
    titleId: _propTypes2.default.string,
    isHalfOnState: _propTypes2.default.bool,
    infoId: _propTypes2.default.string,
    southeasternId: _propTypes2.default.string
}, _class.defaultProps = {
    value: '',
    label: '',
    field: '',
    labelClassName: '',
    defaultChecked: true,
    onChange: _noop3.default,
    onClick: _noop3.default,
    className: '',
    disabled: false,
    disableInputOnly: false,
    isJourneySupport: false,
    title: '',
    titleId: ''
}, _temp2);
exports.default = ToggleInputSimple;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Validity(_ref) {
    var type = _ref.type,
        from = _ref.from,
        to = _ref.to;

    if (!from || !to) {
        return null;
    }
    var dateFormat = 'ddd DD MMM YYYY';
    var isSame = from.isSame(to, 'day');

    return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
            'span',
            { className: 'fix-width' },
            (0, _I18n.translate)('booking.fares.details.dates.' + type)
        ),
        _react2.default.createElement(
            'span',
            { className: 'text-weight--normal' },
            (0, _I18n.translate)('booking.fares.details.dates.period', {
                from: from.format(dateFormat),
                until: to.format(dateFormat),
                showRange: isSame ? 0 : 1
            })
        )
    );
}

Validity.propTypes = {
    type: _propTypes2.default.string.isRequired,
    from: _MomentPropTypes2.default.isMoment,
    to: _MomentPropTypes2.default.isMoment
};

exports.default = Validity;

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    numberOfTickets: 0,
    text: ''
};

var CarnetInformation = function (_record) {
    (0, _inherits3.default)(CarnetInformation, _record);

    function CarnetInformation() {
        (0, _classCallCheck3.default)(this, CarnetInformation);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CarnetInformation.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CarnetInformation, json, {
            numberOfTickets: _LinkMapper.fields.number,
            text: _LinkMapper.fields.string
        });
    };

    return CarnetInformation;
}((0, _immutable.Record)(defaults));

exports.default = CarnetInformation;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _ValidityPeriod = __webpack_require__(395);

var _ValidityPeriod2 = _interopRequireDefault(_ValidityPeriod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    from: null,
    until: null,
    period: new _ValidityPeriod2.default({ days: 1 }),
    break: false
};

var Validity = function (_record) {
    (0, _inherits3.default)(Validity, _record);

    function Validity() {
        (0, _classCallCheck3.default)(this, Validity);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Validity.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Validity, json, {
            from: _LinkMapper.fields.datetime,
            until: _LinkMapper.fields.datetime,
            period: _LinkMapper.resolve.as(_ValidityPeriod2.default),
            break: _LinkMapper.fields.boolean
        });
    };

    return Validity;
}((0, _immutable.Record)(defaults));

exports.default = Validity;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var baseSum = __webpack_require__(819),
    identity = __webpack_require__(116);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    status: null,
    code: null,
    redirect: null,
    md: null,
    pareq: null,
    message: null,
    threeDSServerTransId: null
};

// When these codes are given
// the user can proceed further
var ContinueCodes = [_AppConstants.PaymentAuthCodes.ENROLLED, _AppConstants.PaymentAuthCodes.OK, _AppConstants.PaymentAuthCodes.PENDING, _AppConstants.PaymentAuthCodes.FRAUD, _AppConstants.PaymentAuthCodes.UNDER_REVIEW];

var CocsResponse = function (_record) {
    (0, _inherits3.default)(CocsResponse, _record);

    function CocsResponse() {
        (0, _classCallCheck3.default)(this, CocsResponse);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CocsResponse.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        json.id = json.pid;
        return (0, _LinkMapper.construct)(CocsResponse, json, {
            id: _LinkMapper.fields.number,
            status: _LinkMapper.fields.string,
            code: _LinkMapper.fields.string,
            redirect: _LinkMapper.fields.string,
            md: _LinkMapper.fields.string,
            pareq: _LinkMapper.fields.string,
            message: _LinkMapper.fields.string,
            threeDSServerTransId: _LinkMapper.fields.string
        });
    };

    CocsResponse.prototype.isSuccess = function isSuccess() {
        return ContinueCodes.includes(this.code);
    };

    CocsResponse.prototype.isFraud = function isFraud() {
        return this.status === _AppConstants.PaymentAuthStatuses.FRAUD;
    };

    CocsResponse.prototype.isEnrolled = function isEnrolled() {
        return this.status === _AppConstants.PaymentAuthStatuses.ENROLLED;
    };

    CocsResponse.prototype.isError = function isError() {
        return this.status !== _AppConstants.PaymentAuthStatuses.SUCCESS && !this.isFraud();
    };

    CocsResponse.prototype.isProcessing = function isProcessing() {
        return this.code === _AppConstants.PaymentAuthCodes.PROCESSING;
    };

    return CocsResponse;
}((0, _immutable.Record)(defaults));

exports.default = CocsResponse;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SmartCarnetStore = exports.groupTicketsIntoJourneys = exports.getMinReturnFaresPrice = exports.MAX_SMART_CARNET_TOTAL_PASSES = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _entries = __webpack_require__(238);

var _entries2 = _interopRequireDefault(_entries);

var _min2 = __webpack_require__(1868);

var _min3 = _interopRequireDefault(_min2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _SmartCarnetRecordFilters = __webpack_require__(1058);

var _SmartCarnetRecordFilters2 = _interopRequireDefault(_SmartCarnetRecordFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_SMART_CARNET_BOOKS = 6;

var MAX_SMART_CARNET_TOTAL_PASSES = exports.MAX_SMART_CARNET_TOTAL_PASSES = MAX_SMART_CARNET_BOOKS * _AppConstants.SmartCarnetValidation.PASSES_PER_BOOK;

/*
    * Returns the minimum price of all fares.
    * If no fares are available, returns null.
    * @param {List} fares - List of fare objects with a totalPrice property.
    * @returns {number|null} - Minimum total price or null if no fares are available.

    Unit tests have discovered that this function does not actually work correctly
*/
var getMinReturnFaresPrice = exports.getMinReturnFaresPrice = function getMinReturnFaresPrice(fares) {
    if (fares.size > 0) {
        return (0, _min3.default)(fares.map(function (fare) {
            return fare.totalPrice;
        }).toJS());
    }

    return null;
};

var groupTicketsIntoJourneys = exports.groupTicketsIntoJourneys = function groupTicketsIntoJourneys(tickets) {
    var journeys = {};

    tickets.forEach(function (ticket) {
        var destIndex = ticket.originCode + '-' + ticket.destinationCode + '-' + ticket.description.trim();
        if (typeof journeys[destIndex] === 'undefined') {
            journeys[destIndex] = {
                id: destIndex,
                description: ticket.description,
                isOffPeak: ticket.description.includes('OFF'),
                originCode: ticket.originCode,
                originName: ticket.originName,
                destinationCode: ticket.destinationCode,
                destinationName: ticket.destinationName,
                tickets: []
            };
        }

        journeys[destIndex].tickets.push(ticket.set('isExpired', ticket.get('validityEndDate').add(1, 'day').isBefore((0, _TrainTime2.default)())));
    });

    var result = (0, _entries2.default)(journeys).map(function (value) {
        var journey = value[1];
        var sortedTickets = (0, _immutable.fromJS)(journey.tickets).sortBy(function (ticket) {
            return ticket.validityStartDate;
        });

        return (0, _extends3.default)({}, journey, {
            remainingPassCount: journey.tickets.reduce(function (acc, ticket) {
                return acc += ticket.remainingPassCount;
            }, 0),
            tickets: sortedTickets
        });
    });

    return result;
};

var SmartCarnetState = new _immutable.Record({
    journeys: new _immutable.List(),
    limitError: null,
    loading: true,
    loadingPasses: null,
    loadingTickets: null,
    fares: new _immutable.List(),
    filters: new _SmartCarnetRecordFilters2.default(),
    returnFares: new _immutable.List(),
    returnLoading: true,
    returnLimitError: null,
    ticketCode: null,
    tickets: new _immutable.List(),
    ticketsError: null
});

var SmartCarnetStore = exports.SmartCarnetStore = function (_BaseStore) {
    (0, _inherits3.default)(SmartCarnetStore, _BaseStore);

    function SmartCarnetStore() {
        (0, _classCallCheck3.default)(this, SmartCarnetStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SmartCarnetStore.prototype.getInitialState = function getInitialState() {
        return new SmartCarnetState();
    };

    SmartCarnetStore.prototype.getFares = function getFares() {
        return this.state.fares;
    };

    SmartCarnetStore.prototype.getJourneys = function getJourneys() {
        return this.state.journeys;
    };

    SmartCarnetStore.prototype.getReturnFares = function getReturnFares() {
        return this.state.returnFares;
    };

    SmartCarnetStore.prototype.getReturnLoading = function getReturnLoading() {
        return this.state.returnLoading;
    };

    SmartCarnetStore.prototype.getFilters = function getFilters() {
        return this.state.filters;
    };

    SmartCarnetStore.prototype.getLimitError = function getLimitError() {
        return this.state.limitError;
    };

    SmartCarnetStore.prototype.getLoading = function getLoading() {
        return this.state.loading;
    };

    SmartCarnetStore.prototype.getLoadingPasses = function getLoadingPasses() {
        return this.state.loadingPasses;
    };

    SmartCarnetStore.prototype.hasActivePasses = function hasActivePasses() {
        return this.state.journeys.some(function (journeys) {
            return journeys.get("remainingPassCount") > 0;
        });
    };

    SmartCarnetStore.prototype.getLoadingTickets = function getLoadingTickets() {
        return this.state.loadingTickets;
    };

    SmartCarnetStore.prototype.getReturnLimitError = function getReturnLimitError() {
        return this.state.returnLimitError;
    };

    SmartCarnetStore.prototype.getTicketCode = function getTicketCode() {
        return this.state.ticketCode;
    };

    SmartCarnetStore.prototype.getTickets = function getTickets() {
        return this.state.tickets;
    };

    /* Search */


    SmartCarnetStore.prototype.handleSearchStarted = function handleSearchStarted() {
        this.setState(this.state.set('loading', true));
    };

    SmartCarnetStore.prototype.handleFareSearchFailed = function handleFareSearchFailed() {
        this.setState(this.state.merge({
            loading: false,
            fares: new _immutable.List() // reset the fares
        }));
    };

    SmartCarnetStore.prototype.handleFareSearchFinished = function handleFareSearchFinished(_ref) {
        var fares = _ref.fares;

        this.setState(this.state.merge({
            loading: false,
            fares: fares
        }));
    };

    /* Return search */


    SmartCarnetStore.prototype.handleReturnSearchStarted = function handleReturnSearchStarted() {
        this.setState(this.state.set('returnLoading', true));
    };

    SmartCarnetStore.prototype.handleReturnSearchFailed = function handleReturnSearchFailed() {
        this.setState(this.state.set('returnLoading', false));
    };

    SmartCarnetStore.prototype.handleReturnSearchFinished = function handleReturnSearchFinished(_ref2) {
        var fares = _ref2.fares;

        this.setState(this.state.merge({
            returnLoading: false,
            returnFares: fares
        }));
    };

    SmartCarnetStore.prototype.handleReturnClosed = function handleReturnClosed() {
        this.setState(this.state.merge({
            returnLoading: false,
            returnLimitError: false
        }));
    };

    /* Filters */


    SmartCarnetStore.prototype.handleFilterChanged = function handleFilterChanged(_ref3) {
        var filterType = _ref3.filterType,
            value = _ref3.value;

        this.setState(this.state.set('filters', this.state.filters.updateFilter(filterType, value)));
    };

    SmartCarnetStore.prototype.handlePassesStarted = function handlePassesStarted(_ref4) {
        var _state$merge;

        var ticketCode = _ref4.ticketCode,
            _ref4$isReturn = _ref4.isReturn,
            isReturn = _ref4$isReturn === undefined ? false : _ref4$isReturn;

        this.setState(this.state.merge((_state$merge = {}, _state$merge[isReturn ? 'returnLimitError' : 'limitError'] = null, _state$merge.loadingPasses = true, _state$merge.ticketCode = ticketCode, _state$merge)));
    };

    SmartCarnetStore.prototype.handlePassesFailed = function handlePassesFailed(_ref5) {
        var _state$merge2;

        var _ref5$limitError = _ref5.limitError,
            limitError = _ref5$limitError === undefined ? null : _ref5$limitError,
            _ref5$isReturn = _ref5.isReturn,
            isReturn = _ref5$isReturn === undefined ? false : _ref5$isReturn;

        this.setState(this.state.merge((_state$merge2 = {
            loadingPasses: false,
            ticketCode: null
        }, _state$merge2[isReturn ? 'returnLimitError' : 'limitError'] = limitError, _state$merge2)));
    };

    SmartCarnetStore.prototype.handlePassesFinished = function handlePassesFinished() {
        this.setState(this.state.merge({
            loadingPasses: false,
            ticketCode: null
        }));
    };

    SmartCarnetStore.prototype.handleTicketsStarted = function handleTicketsStarted() {
        this.setState(this.state.merge({
            loadingTickets: true,
            ticketsError: null
        }));
    };

    SmartCarnetStore.prototype.handleTicketsFailed = function handleTicketsFailed(_ref6) {
        var _ref6$error = _ref6.error,
            error = _ref6$error === undefined ? null : _ref6$error;

        this.setState(this.state.merge({
            loadingTickets: false,
            ticketsError: error
        }));
    };

    SmartCarnetStore.prototype.handleTicketsFinished = function handleTicketsFinished(_ref7) {
        var tickets = _ref7.tickets;

        this.setState(this.state.merge({
            journeys: groupTicketsIntoJourneys(tickets),
            loadingTickets: false,
            tickets: tickets
        }));
    };

    SmartCarnetStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref8;

        return _ref8 = {}, _ref8[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_STARTED] = this.handleSearchStarted, _ref8[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_FAILED] = this.handleFareSearchFailed, _ref8[_AppConstants.ActionTypes.SMART_CARNET_SEARCH_FINISHED] = this.handleFareSearchFinished, _ref8[_AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_STARTED] = this.handleReturnSearchStarted, _ref8[_AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_FAILED] = this.handleReturnSearchFailed, _ref8[_AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_FINISHED] = this.handleReturnSearchFinished, _ref8[_AppConstants.ActionTypes.SMART_CARNET_RETURN_CLOSED] = this.handleReturnClosed, _ref8[_AppConstants.ActionTypes.SMART_CARNET_FILTER_CHANGED] = this.handleFilterChanged, _ref8[_AppConstants.ActionTypes.SMART_CARNET_PASSES_STARTED] = this.handlePassesStarted, _ref8[_AppConstants.ActionTypes.SMART_CARNET_PASSES_FAILED] = this.handlePassesFailed, _ref8[_AppConstants.ActionTypes.SMART_CARNET_PASSES_FINISHED] = this.handlePassesFinished, _ref8[_AppConstants.ActionTypes.SMART_CARNET_TICKETS_STARTED] = this.handleTicketsStarted, _ref8[_AppConstants.ActionTypes.SMART_CARNET_TICKETS_FAILED] = this.handleTicketsFailed, _ref8[_AppConstants.ActionTypes.SMART_CARNET_TICKETS_FINISHED] = this.handleTicketsFinished, _ref8;
    };

    return SmartCarnetStore;
}(_BaseStore3.default);

var storeInstance = new SmartCarnetStore();

window.carnetState = storeInstance;

exports.default = storeInstance;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoginLink(_ref) {
    var onClick = _ref.onClick,
        showIcon = _ref.showIcon,
        className = _ref.className;


    var _handleClick = function _handleClick() {
        return _ModalActions2.default.open(_AppConstants.GlobalModals.LOGIN) && onClick();
    };

    return _react2.default.createElement(
        'button',
        { type: 'button',
            'aria-label': (0, _I18n.translate)('ariaLabel.openLogin'),
            className: className,
            onClick: _handleClick },
        showIcon && _react2.default.createElement(_Icon2.default, { icon: 'user' }),
        (0, _I18n.translate)('account.login')
    );
}

LoginLink.propTypes = {
    className: _propTypes2.default.string,
    showIcon: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

LoginLink.defaultProps = {
    className: 'btn btn-primary btn-lg btn-login',
    showIcon: true,
    onClick: _noop3.default
};

exports.default = LoginLink;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Page = __webpack_require__(424);

var _Page2 = _interopRequireDefault(_Page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StepHeader(_ref) {
    var number = _ref.number,
        label = _ref.label,
        active = _ref.active,
        className = _ref.className;

    var classes = (0, _classnames2.default)('step-header', className, 'text-weight--normal', {
        'step-header--active': active
    });
    return _react2.default.createElement(
        _Page2.default,
        { title: label },
        _react2.default.createElement(
            'h2',
            { className: classes },
            _react2.default.createElement(
                'span',
                { className: 'step-header__number' },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n2.default)('global.step'),
                    ' '
                ),
                number,
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    '. '
                )
            ),
            _react2.default.createElement(
                'legend',
                { className: 'step-header__legend' },
                label
            )
        )
    );
}

StepHeader.propTypes = {
    number: _propTypes2.default.number,
    label: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    className: _propTypes2.default.string
};

StepHeader.defaultProps = {
    number: 0,
    label: '',
    active: false,
    className: ''
};

exports.default = StepHeader;

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

module.exports = baseFindKey;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Ticket = __webpack_require__(353);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _Fare3 = __webpack_require__(76);

var _Fare4 = _interopRequireDefault(_Fare3);

var _Ticket3 = __webpack_require__(239);

var _Ticket4 = _interopRequireDefault(_Ticket3);

var _PassengerInfo = __webpack_require__(464);

var _PassengerInfo2 = _interopRequireDefault(_PassengerInfo);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _RailcardBadge = __webpack_require__(450);

var _RailcardBadge2 = _interopRequireDefault(_RailcardBadge);

var _NRETicketLink = __webpack_require__(2053);

var _NRETicketLink2 = _interopRequireDefault(_NRETicketLink);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TicketDetails(_ref) {
    var fare = _ref.fare,
        ticket = _ref.ticket,
        isFlexi = _ref.isFlexi,
        isCarnet = _ref.isCarnet,
        isSmartCarnet = _ref.isSmartCarnet;
    var adults = ticket.adults,
        children = ticket.children,
        railcard = ticket.railcard,
        price = ticket.price,
        ticketTypeOverride = ticket.ticketTypeOverride;

    var ticketType = 'ticket';

    if (isCarnet && !isSmartCarnet) {
        ticketType = 'carnet';
    }

    if (isSmartCarnet) {
        ticketType = 'smartCarnet';
    }

    return _react2.default.createElement(
        'li',
        { className: 'clearfix text-weight--normal' },
        _react2.default.createElement(
            _Row2.default,
            { className: 'passenger-row' },
            _react2.default.createElement(
                _Col2.default,
                { xs: 8, sm: 6, className: 'pull-left' },
                _react2.default.createElement(
                    'div',
                    { className: 'padding-bottom--xs' },
                    _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'booking.fares.details.' + ticketType,
                        adults: isFlexi ? 1 : adults,
                        children: children,
                        individualPrice: _react2.default.createElement(_Price2.default, { price: price / (adults + children) }),
                        passes: fare.getNumberOfPasses(),
                        ticketTypeOverride: ticketTypeOverride ? ticketTypeOverride.shortenName() : 0,
                        className: 'text-sm' }),
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableSmartcardAssociations' },
                        _react2.default.createElement(_PassengerInfo2.default, { className: 'passenger-row__linked-smartcard', ticket: ticket })
                    ),
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'showNRETicketLink' },
                        ' ',
                        _react2.default.createElement(_NRETicketLink2.default, {
                            ticket: ticket,
                            fare: fare
                        })
                    )
                ),
                railcard && _react2.default.createElement(_RailcardBadge2.default, { railcard: railcard })
            ),
            _react2.default.createElement(
                _Col2.default,
                { xs: 4, sm: 6, className: 'text-right' },
                _react2.default.createElement(_Price2.default, { price: price, className: 'passenger-row__price text-sm' })
            )
        )
    );
}

TicketDetails.propTypes = {
    fare: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Fare2.default), _propTypes2.default.instanceOf(_Fare4.default)]),
    ticket: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Ticket2.default), _propTypes2.default.instanceOf(_Ticket4.default)]),
    isCarnet: _propTypes2.default.bool,
    isSmartCarnet: _propTypes2.default.bool,
    isFlexi: _propTypes2.default.bool
};

exports.default = TicketDetails;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _Fare3 = __webpack_require__(76);

var _Fare4 = _interopRequireDefault(_Fare3);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FareRefundsInfo(_ref) {
    var fare = _ref.fare,
        small = _ref.small;

    var refundTextMessage = '';

    if (!fare.isRoversRangers()) {
        if (fare.isFlexi()) {
            refundTextMessage = 'booking.fareDetails.refunds.flexiTicket';
        } else if (fare.isSeason()) {
            refundTextMessage = 'booking.fareDetails.refunds.seasonTicket';
        } else if (fare.isAdvance()) {
            refundTextMessage = 'booking.fareDetails.refunds.advanceTicket';
        } else if (fare.isDaySaveOffPeak()) {
            refundTextMessage = 'booking.fareDetails.refunds.daySaveOffPeak';
        } else {
            refundTextMessage = 'booking.fareDetails.refunds.dayTicket';
        }
    }

    return _react2.default.createElement(_FormattedHTMLMessage2.default, {
        message: refundTextMessage,
        className: 'margin-top--sm margin-bottom--0 ' + (small ? 'text-sm' : ''),
        tagName: 'p'
    });
}

FareRefundsInfo.propTypes = {
    fare: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Fare2.default), _propTypes2.default.instanceOf(_Fare4.default)]).isRequired,
    small: _propTypes2.default.bool
};

exports.default = FareRefundsInfo;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _SmartCarnetService = __webpack_require__(2056);

var _SmartCarnetService2 = _interopRequireDefault(_SmartCarnetService);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _SmartCarnetRecordSearch = __webpack_require__(436);

var _SmartCarnetRecordSearch2 = _interopRequireDefault(_SmartCarnetRecordSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartCarnetActions = {
    loadFromParams: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
            var search;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _SmartCarnetRecordSearch2.default.deserialize(params);

                        case 2:
                            search = _context.sent;
                            return _context.abrupt('return', search);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadFromParams(_x) {
            return _ref.apply(this, arguments);
        }

        return loadFromParams;
    }(),
    getFares: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
            var fare = _ref2.fare,
                fares = _ref2.fares,
                products = _ref2.products,
                _ref2$isReturn = _ref2.isReturn,
                isReturn = _ref2$isReturn === undefined ? false : _ref2$isReturn,
                search = _ref2.search;
            var user, isValid, newFares, newFare, replacedFares;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_PASSES_STARTED,
                                ticketCode: fare.ticketType.code,
                                isReturn: isReturn
                            });

                            if (!(user && user.id)) {
                                _context2.next = 7;
                                break;
                            }

                            _context2.next = 5;
                            return SmartCarnetActions.validate({
                                destination: isReturn ? fare.origin : fare.destination,
                                origin: isReturn ? fare.destination : fare.origin,
                                isReturn: isReturn,
                                products: products
                            });

                        case 5:
                            isValid = _context2.sent;


                            if (!isValid) {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.SMART_CARNET_PASSES_FAILED,
                                    limitError: {
                                        fare: fare,
                                        products: products
                                    },
                                    isReturn: isReturn
                                });
                            }

                        case 7:
                            _context2.prev = 7;
                            newFares = void 0;
                            newFare = void 0;

                            if (!(fares.filter(function (f) {
                                return f.ticketType.code === fare.ticketType.code && f.tickets.size === products;
                            }).size > 0)) {
                                _context2.next = 16;
                                break;
                            }

                            // If a fare's ticket type has been already fetched do not fetch it again
                            newFares = fares;
                            newFare = newFares.filter(function (f) {
                                return f.ticketType.code === fare.ticketType.code;
                            }).get(0);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_PASSES_FINISHED
                            });
                            _context2.next = 30;
                            break;

                        case 16:
                            if (!isReturn) {
                                _context2.next = 22;
                                break;
                            }

                            _context2.next = 19;
                            return _SmartCarnetService2.default.searchReturn({ search: search, products: products });

                        case 19:
                            _context2.t0 = _context2.sent;
                            _context2.next = 25;
                            break;

                        case 22:
                            _context2.next = 24;
                            return _SmartCarnetService2.default.search({ search: search, products: products });

                        case 24:
                            _context2.t0 = _context2.sent;

                        case 25:
                            newFares = _context2.t0;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_PASSES_FINISHED
                            });

                            newFare = newFares.filter(function (f) {
                                return f.ticketType.code === fare.ticketType.code;
                            }).get(0);
                            replacedFares = fares.set(fares.findIndex(function (f) {
                                return f.ticketType.code === fare.ticketType.code;
                            }), newFare);


                            _AppDispatcher2.default.dispatch({
                                actionType: isReturn ? _AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_FINISHED : _AppConstants.ActionTypes.SMART_CARNET_SEARCH_FINISHED,
                                fares: replacedFares
                            });

                        case 30:
                            if (isReturn) {
                                _context2.next = 34;
                                break;
                            }

                            SmartCarnetActions.setSelectedFare(newFare, products * _AppConstants.SmartCarnetValidation.PASSES_PER_BOOK);
                            _context2.next = 35;
                            break;

                        case 34:
                            return _context2.abrupt('return', newFare);

                        case 35:
                            _context2.next = 41;
                            break;

                        case 37:
                            _context2.prev = 37;
                            _context2.t1 = _context2['catch'](7);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_PASSES_FAILED,
                                error: _context2.t1
                            });

                            throw _context2.t1;

                        case 41:
                            return _context2.abrupt('return', null);

                        case 42:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[7, 37]]);
        }));

        function getFares(_x2) {
            return _ref3.apply(this, arguments);
        }

        return getFares;
    }(),
    search: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref4) {
            var search = _ref4.search;
            var result;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_SEARCH_STARTED,
                                search: search
                            });

                            SmartCarnetActions.setSelectedFare(null);

                            _context3.prev = 2;
                            _context3.next = 5;
                            return _SmartCarnetService2.default.search({ search: search });

                        case 5:
                            result = _context3.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_SEARCH_FINISHED,
                                fares: result
                            });

                            return _context3.abrupt('return', {
                                result: result,
                                search: search
                            });

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](2);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_SEARCH_FAILED,
                                error: _context3.t0,
                                search: search
                            });

                        case 13:
                            return _context3.abrupt('return', null);

                        case 14:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[2, 10]]);
        }));

        function search(_x3) {
            return _ref5.apply(this, arguments);
        }

        return search;
    }(),
    searchReturn: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref6) {
            var search = _ref6.search;
            var result;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_STARTED,
                                search: search
                            });

                            _context4.prev = 1;
                            _context4.next = 4;
                            return _SmartCarnetService2.default.searchReturn({ search: search });

                        case 4:
                            result = _context4.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_FINISHED,
                                fares: result
                            });

                            return _context4.abrupt('return', {
                                result: result,
                                search: search
                            });

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_FAILED,
                                error: _context4.t0
                            });

                        case 12:
                            return _context4.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[1, 9]]);
        }));

        function searchReturn(_x4) {
            return _ref7.apply(this, arguments);
        }

        return searchReturn;
    }(),
    setSelectedFare: function setSelectedFare(fare, numberOfPasses) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SMART_CARNET_SEARCH_SELECTED,
            fare: fare,
            numberOfPasses: numberOfPasses
        });
    },
    setSelectedFareReturn: function setSelectedFareReturn(fare) {
        var numberOfPasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SMART_CARNET_RETURN_SEARCH_SELECTED,
            fare: fare,
            numberOfPasses: numberOfPasses
        });
    },
    resetReturnModal: function resetReturnModal() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SMART_CARNET_RETURN_CLOSED
        });
    },
    updateFilter: function updateFilter(_ref8) {
        var filterType = _ref8.filterType,
            value = _ref8.value;

        (0, _defer3.default)(function () {
            _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.SMART_CARNET_FILTER_CHANGED,
                filterType: filterType,
                value: value
            });
        });
    },
    validate: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref9) {
            var destination = _ref9.destination,
                _ref9$isReturn = _ref9.isReturn,
                isReturn = _ref9$isReturn === undefined ? false : _ref9$isReturn,
                origin = _ref9.origin,
                products = _ref9.products;
            var order, user, originQuery, destinationQuery, getPassesFromOrder, existingOrderProducts;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            order = _OrderStore2.default.getCurrent();
                            user = _UserStore2.default.getCurrent();

                            if (user) {
                                _context5.next = 4;
                                break;
                            }

                            return _context5.abrupt('return', true);

                        case 4:
                            originQuery = isReturn ? destination : origin;
                            destinationQuery = isReturn ? origin : destination;

                            // eslint-disable-next-line no-shadow

                            getPassesFromOrder = function getPassesFromOrder(_ref11) {
                                var origin = _ref11.origin,
                                    destination = _ref11.destination,
                                    order = _ref11.order;

                                var matchingFares = order.getSmartCarnetTrips().map(function (trip) {
                                    return trip.getIn(['fares', 'outwardSingle']);
                                }).filter(function (fare) {
                                    return fare.origin.nlc === origin.nlc && fare.destination.nlc === destination.nlc;
                                });

                                return matchingFares.reduce(function (acc, cur) {
                                    return acc += cur.tickets.size * _AppConstants.SmartCarnetValidation.PASSES_PER_BOOK;
                                }, 0);
                            };

                            existingOrderProducts = getPassesFromOrder({
                                origin: originQuery,
                                destination: destinationQuery,
                                order: order
                            });
                            _context5.prev = 8;
                            _context5.next = 11;
                            return _SmartCarnetService2.default.validatePasses({
                                newTickets: existingOrderProducts + products * _AppConstants.SmartCarnetValidation.PASSES_PER_BOOK,
                                destination: destinationQuery,
                                origin: originQuery,
                                user: user
                            });

                        case 11:
                            return _context5.abrupt('return', true);

                        case 14:
                            _context5.prev = 14;
                            _context5.t0 = _context5['catch'](8);

                            if (!(_context5.t0.body && _context5.t0.body.status === 404)) {
                                _context5.next = 18;
                                break;
                            }

                            return _context5.abrupt('return', true);

                        case 18:
                            return _context5.abrupt('return', false);

                        case 19:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[8, 14]]);
        }));

        function validate(_x6) {
            return _ref10.apply(this, arguments);
        }

        return validate;
    }(),
    getSmartCarnetTicketDetails: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(ticketID) {
            var result;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_TICKET_DETAILS_STARTED,
                                ticketID: ticketID
                            });

                            _context6.prev = 1;
                            _context6.next = 4;
                            return _SmartCarnetService2.default.getSingleTicket(ticketID);

                        case 4:
                            result = _context6.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_TICKET_DETAILS_FINISHED,
                                ticketID: ticketID
                            });

                            return _context6.abrupt('return', result);

                        case 9:
                            _context6.prev = 9;
                            _context6.t0 = _context6['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_TICKET_DETAILS_FAILED,
                                error: _context6.t0
                            });

                        case 12:
                            return _context6.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[1, 9]]);
        }));

        function getSmartCarnetTicketDetails(_x7) {
            return _ref12.apply(this, arguments);
        }

        return getSmartCarnetTicketDetails;
    }(),
    getTickets: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(ticketStatus) {
            var user, tickets;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_TICKETS_STARTED
                            });

                            _context7.prev = 2;
                            _context7.next = 5;
                            return _SmartCarnetService2.default.getTickets({ ticketStatus: ticketStatus, user: user });

                        case 5:
                            tickets = _context7.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_TICKETS_FINISHED,
                                tickets: tickets
                            });
                            _context7.next = 13;
                            break;

                        case 9:
                            _context7.prev = 9;
                            _context7.t0 = _context7['catch'](2);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.SMART_CARNET_TICKETS_FAILED,
                                error: _context7.t0
                            });

                            throw _context7.t0;

                        case 13:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[2, 9]]);
        }));

        function getTickets(_x8) {
            return _ref13.apply(this, arguments);
        }

        return getTickets;
    }()
};

exports.default = SmartCarnetActions;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _carbonEmissionsUtils = __webpack_require__(2057);

var _I18n = __webpack_require__(9);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _CarbonFootprintModal = __webpack_require__(2058);

var _CarbonFootprintModal2 = _interopRequireDefault(_CarbonFootprintModal);

var _GreenPlanetIcon = __webpack_require__(942);

var _GreenPlanetIcon2 = _interopRequireDefault(_GreenPlanetIcon);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _Trip = __webpack_require__(199);

var _Trip2 = _interopRequireDefault(_Trip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarbonFootprintButton = function CarbonFootprintButton(_ref) {
    var className = _ref.className,
        fare = _ref.fare;

    var _useState = (0, _react.useState)(false),
        isOpen = _useState[0],
        setModalStatus = _useState[1];

    var toggleModal = function toggleModal(value) {
        return function () {
            return setModalStatus(value);
        };
    };

    var originStation = fare.origin,
        destinationStation = fare.destination;


    var carbonCalculationData = (0, _carbonEmissionsUtils.calculateCarbonEmissions)({ fare: fare, originStation: originStation, destinationStation: destinationStation });
    var savedCO2e = carbonCalculationData.savedCO2e;


    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: className },
            _react2.default.createElement(
                _OnEnterTrigger2.default,
                { onClick: toggleModal(true), className: 'carbon-footprint__button' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'carbon-footprint__button--title-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'carbon-footprint__button--icon' },
                            _react2.default.createElement(_GreenPlanetIcon2.default, null)
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'carbon-footprint__button--text' },
                            _react2.default.createElement(
                                'strong',
                                null,
                                (0, _I18n.translate)('carbonFootprint.saved', { savedCO2e: savedCO2e })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'carbon-footprint__button--info-container' },
                        _react2.default.createElement(
                            'p',
                            { className: 'carbon-footprint__button--text' },
                            (0, _I18n.translate)('carbonFootprint.button.info')
                        ),
                        _react2.default.createElement(_Icon2.default, { icon: 'chevronslim', className: 'carbon-footprint__button--chevron-icon' })
                    )
                )
            )
        ),
        _react2.default.createElement(_CarbonFootprintModal2.default, {
            toggleModal: toggleModal,
            show: isOpen,
            carbonCalculationData: carbonCalculationData
        })
    );
};

CarbonFootprintButton.propTypes = {
    className: _propTypes2.default.string,
    fare: _propTypes2.default.instanceOf(_Fare2.default).isRequired,
    trip: _propTypes2.default.instanceOf(_Trip2.default)
};

CarbonFootprintButton.defaultProps = {
    className: ''
};

exports.default = CarbonFootprintButton;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InvalidSeasonSearchError = undefined;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _FareOnlyService = __webpack_require__(972);

var _FareOnlyService2 = _interopRequireDefault(_FareOnlyService);

var _SeasonTicketsService = __webpack_require__(2228);

var _SeasonTicketsService2 = _interopRequireDefault(_SeasonTicketsService);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

var _Search = __webpack_require__(421);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _PromoCodeActions = __webpack_require__(958);

var _PromoCodeActions2 = _interopRequireDefault(_PromoCodeActions);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvalidSeasonSearchError = exports.InvalidSeasonSearchError = function (_ExtendableError) {
    (0, _inherits3.default)(InvalidSeasonSearchError, _ExtendableError);

    function InvalidSeasonSearchError(message, search) {
        (0, _classCallCheck3.default)(this, InvalidSeasonSearchError);

        var params = (0, _stringify2.default)(search.serialize());

        var _this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call(this, message, { params: params }));

        _this.name = 'InvalidSeasonSearchError';
        return _this;
    }

    return InvalidSeasonSearchError;
}(_ExtendableError3.default);

var SeasonSearchActions = {
    loadFromParams: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params, query) {
            var search;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _SeasonSearch2.default.deserialize(params, query);

                        case 2:
                            search = _context.sent;

                            search = search.set('submitted', true);

                            this.checkPromoFromQuery(search);

                            return _context.abrupt('return', this.load(search));

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadFromParams(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return loadFromParams;
    }(),
    load: function load(search) {
        _AppDispatcher2.default.dispatch({
            search: search,
            actionType: _AppConstants.ActionTypes.SEASON_SEARCH_LOADED
        });
        return search;
    },
    update: function update(search) {
        _AppDispatcher2.default.dispatch({
            search: search,
            actionType: _AppConstants.ActionTypes.SEASON_SEARCH_UPDATED
        });
    },
    checkPromoFromQuery: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(search) {
            var promoCode, enablePromoDiscount, enablePromoDiscountValidation, validatedPromoCode, newSearch, promo, _newSearch;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            promoCode = search.getPromoCode();
                            enablePromoDiscount = _FeatureFlagStore2.default.get('enablePromoDiscount');
                            enablePromoDiscountValidation = _FeatureFlagStore2.default.get('enablePromoDiscountValidation');

                            if (!(!enablePromoDiscount || !promoCode)) {
                                _context2.next = 5;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 5:
                            if (!enablePromoDiscountValidation) {
                                _context2.next = 13;
                                break;
                            }

                            _context2.next = 8;
                            return _PromoCodeActions2.default.validatePromoCode(promoCode);

                        case 8:
                            validatedPromoCode = _context2.sent;
                            newSearch = search.setPromoCode(validatedPromoCode);


                            this.update(newSearch);
                            _context2.next = 18;
                            break;

                        case 13:
                            promo = new _PromoCode2.default({ promoCode: promoCode });
                            _context2.next = 16;
                            return _PromoCodeActions2.default.apply(promo);

                        case 16:
                            _newSearch = search.setPromoCode(promo);


                            this.update(_newSearch);

                        case 18:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function checkPromoFromQuery(_x3) {
            return _ref2.apply(this, arguments);
        }

        return checkPromoFromQuery;
    }(),
    preFillPromoFromQuery: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(query) {
            var enablePromoDiscount, newSearch;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            enablePromoDiscount = _FeatureFlagStore2.default.get('enablePromoDiscount');

                            if (enablePromoDiscount) {
                                _context3.next = 3;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 3:
                            newSearch = new _SeasonSearch2.default({ promoCode: new _PromoCode2.default(query) });


                            this.update(newSearch);

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function preFillPromoFromQuery(_x4) {
            return _ref3.apply(this, arguments);
        }

        return preFillPromoFromQuery;
    }(),
    search: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref4) {
            var search = _ref4.search,
                user = _ref4.user;
            var errors, result;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (search.isValid()) {
                                _context4.next = 4;
                                break;
                            }

                            errors = search.getValidationErrors().toJS().join(', ');


                            _AppDispatcher2.default.dispatch({
                                search: search,
                                actionType: _AppConstants.ActionTypes.SEASON_SEARCH_FAILED
                            });

                            throw new InvalidSeasonSearchError('Failed check: ' + errors, search);

                        case 4:

                            _AppDispatcher2.default.dispatch({
                                search: search,
                                actionType: _AppConstants.ActionTypes.SEASON_SEARCH_STARTED
                            });

                            _context4.next = 7;
                            return _SeasonTicketsService2.default.search(search, user);

                        case 7:
                            result = _context4.sent;

                            search = search.set('submitted', true);
                            _AppDispatcher2.default.dispatch({
                                search: search,
                                actionType: _AppConstants.ActionTypes.SEASON_SEARCH_FINISHED,
                                seasonTickets: result
                            });

                            return _context4.abrupt('return', {
                                search: search,
                                result: result
                            });

                        case 11:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function search(_x5) {
            return _ref5.apply(this, arguments);
        }

        return search;
    }(),
    searchFares: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref6) {
            var search = _ref6.search,
                user = _ref6.user;
            var errors, fares;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (search.isValid()) {
                                _context5.next = 4;
                                break;
                            }

                            errors = search.getValidationErrors().toJS().join(', ');


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_FAILED,
                                search: search
                            });

                            return _context5.abrupt('return', _promise2.default.reject(new _Search.InvalidSearchError('Failed check: ' + errors, search)));

                        case 4:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED,
                                search: search
                            });

                            _context5.next = 7;
                            return _FareOnlyService2.default.seasonSearch(search, user);

                        case 7:
                            fares = _context5.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_FINISHED,
                                search: search,
                                fares: fares
                            });

                            return _context5.abrupt('return', {
                                search: search,
                                fares: fares
                            });

                        case 10:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function searchFares(_x6) {
            return _ref7.apply(this, arguments);
        }

        return searchFares;
    }(),
    changeSeasonTicketFilters: function changeSeasonTicketFilters(seasonTickets, filters) {
        _AppDispatcher2.default.dispatch({
            seasonTickets: seasonTickets,
            filters: filters,
            actionType: _AppConstants.ActionTypes.SEASON_RESULTS_FILTERS_CHANGE
        });
    }
};

exports.default = SeasonSearchActions;

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    charityOption: {
        accountNumber: '',
        charityName: '',
        description: '',
        donationAmount: 0,
        id: null,
        link: '',
        logoUrlDark: '',
        logoUrlLight: '',
        sortCode: ''
    },
    isLoading: false,
    hasError: false
});

var CharityStore = function (_BaseStore) {
    (0, _inherits3.default)(CharityStore, _BaseStore);

    function CharityStore() {
        (0, _classCallCheck3.default)(this, CharityStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    CharityStore.prototype.deserialize = function deserialize(serialized) {
        if (serialized) {
            var charityOption = serialized.charityOption,
                isLoading = serialized.isLoading,
                hasError = serialized.hasError;

            return new State({
                charityOption: charityOption,
                isLoading: isLoading,
                hasError: hasError
            });
        }
        return new State();
    };

    CharityStore.prototype.getInitialState = function getInitialState() {
        return new State();
    };

    CharityStore.prototype.setIsLoading = function setIsLoading(value) {
        return function () {
            this.setState(this.state.set('isLoading', value));
        };
    };

    CharityStore.prototype.setError = function setError() {
        this.setState(this.state.set('hasError', true));
    };

    CharityStore.prototype.resetError = function resetError() {
        this.setState(this.state.set('hasError', false));
    };

    CharityStore.prototype.setCharityOptions = function setCharityOptions(_ref) {
        var charityOption = _ref.charityOption;

        if (charityOption) {
            this.setState(this.state.set('charityOption', charityOption).set('hasError', false));
        } else {
            this.setState(this.state.set('hasError', true));
        }
    };

    CharityStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.GET_ORDER_CHARITY_OPTIONS_STARTED] = this.setIsLoading(true), _ref2[_AppConstants.ActionTypes.GET_ORDER_CHARITY_OPTIONS_SUCCESS] = this.setCharityOptions, _ref2[_AppConstants.ActionTypes.GET_ORDER_CHARITY_OPTIONS_FAILED] = this.setError, _ref2[_AppConstants.ActionTypes.GET_ORDER_CHARITY_OPTIONS_FINISHED] = this.setIsLoading(false), _ref2[_AppConstants.ActionTypes.SET_ORDER_CHARITY_OPTIONS_SUCCESS] = this.resetError, _ref2[_AppConstants.ActionTypes.SET_ORDER_CHARITY_OPTIONS_FAILED] = this.setError, _ref2[_AppConstants.ActionTypes.DELETE_ORDER_CHARITY_OPTIONS_SUCCESS] = this.resetError, _ref2[_AppConstants.ActionTypes.DELETE_ORDER_CHARITY_OPTIONS_FAILED] = this.setError, _ref2;
    };

    return CharityStore;
}(_BaseStore3.default);

var instance = new CharityStore({ storageKey: 'charity' });

exports.default = instance;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _immutable = __webpack_require__(5);

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Users need to complete their payment before the auth token expires (refresh not possible during hosted session)
// Guest users can have more time
var USER_SESSION_TIMEOUT = { minutes: 4, seconds: 30 };
var GUEST_SESSION_TIMEOUT = { minutes: 10 };

// Pay360 states, we'll map various combinations of these to a single Pay360SessionState
var Pay360 = (0, _keymirror2.default)({
    TERMINATED: null,
    SUCCESS: null,
    STARTED: null,
    PROCESSING: null,
    FAILED: null,
    NOT_SUBMITTED: null
});

var stateSchema = {
    redirectUrl: [_LinkMapper.fields.string],
    sessionId: [_LinkMapper.fields.string],
    sessionStatus: [_LinkMapper.fields.string],
    sessionCreated: [_LinkMapper.fields.datetime],
    sessionExpires: [_LinkMapper.fields.datetime],
    isGuestSession: [_LinkMapper.fields.bool]
};
var defaultState = (0, _Records.getDefaults)(stateSchema);

var Pay360State = function (_record) {
    (0, _inherits3.default)(Pay360State, _record);

    function Pay360State() {
        (0, _classCallCheck3.default)(this, Pay360State);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Pay360State.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Pay360State, (0, _defaults3.default)(json, defaultState), (0, _Records.getResolvers)(stateSchema));
    };

    return Pay360State;
}((0, _immutable.Record)(defaultState));

var Pay360Store = function (_BaseStore) {
    (0, _inherits3.default)(Pay360Store, _BaseStore);

    function Pay360Store() {
        (0, _classCallCheck3.default)(this, Pay360Store);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    Pay360Store.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.PAY360_SESSION_CREATE_STARTED] = this.handleSessionCreating, _ref[_AppConstants.ActionTypes.PAY360_SESSION_CREATED] = this.handleSessionCreated, _ref[_AppConstants.ActionTypes.PAY360_SESSION_LOADED] = this.handleSessionLoaded, _ref[_AppConstants.ActionTypes.PAYMENT_FORM_CHANGED] = this.resetState, _ref[_AppConstants.ActionTypes.ORDER_EXPIRED] = this.resetState, _ref[_AppConstants.ActionTypes.PAYMENT_LEFT] = this.resetState, _ref[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref;
    };

    Pay360Store.prototype.handleSessionCreating = function handleSessionCreating() {
        this.setState(new Pay360State({ sessionStatus: _AppConstants.Pay360SessionState.CREATING }));
    };

    Pay360Store.prototype.handleSessionCreated = function handleSessionCreated(_ref2) {
        var session = _ref2.session,
            isGuest = _ref2.isGuest;

        var created = (0, _TrainTime2.default)();
        var expires = created.clone().add(session.isGuest ? GUEST_SESSION_TIMEOUT : USER_SESSION_TIMEOUT);

        this.setState(this.state.merge({
            redirectUrl: session.redirectUrl,
            sessionId: session.sessionId,
            sessionStatus: _AppConstants.Pay360SessionState.READY,
            sessionCreated: created,
            sessionExpires: expires,
            isGuestSession: isGuest
        }));
    };

    Pay360Store.prototype.handleSessionLoaded = function handleSessionLoaded(_ref3) {
        var session = _ref3.session;

        var current = this.state.sessionStatus;
        if (session.status === Pay360.FAILED) {
            current = _AppConstants.Pay360SessionState.INVALID;
        } else if (session.status === Pay360.SUCCESS) {
            var _session$hostedSessio = session.hostedSessionStatus,
                sessionState = _session$hostedSessio.sessionState,
                transactionState = _session$hostedSessio.transactionState.transactionState;


            if (sessionState === Pay360.TERMINATED) {
                if (transactionState === Pay360.SUCCESS) {
                    current = _AppConstants.Pay360SessionState.SUCCESS;
                } else if (transactionState === Pay360.FAILED) {
                    current = _AppConstants.Pay360SessionState.FAILED;
                } else if (transactionState === Pay360.NOT_SUBMITTED) {
                    current = _AppConstants.Pay360SessionState.CANCELLED;
                }
            }
        }
        if (current !== this.state.sessionStatus) {
            this.setState(this.state.set('sessionStatus', current));
        }
    };

    return Pay360Store;
}(_BaseStore3.default);

var storeInstance = new Pay360Store({
    storageKey: 'pay360',
    expires: 30 * 60,
    recordType: Pay360State
});

exports.default = storeInstance;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.VisaCheckoutStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _VisaCheckoutCardInfoResponse = __webpack_require__(1015);

var _VisaCheckoutCardInfoResponse2 = _interopRequireDefault(_VisaCheckoutCardInfoResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VisaCheckoutStore = exports.VisaCheckoutStore = function (_BaseStore) {
    (0, _inherits3.default)(VisaCheckoutStore, _BaseStore);

    function VisaCheckoutStore() {
        (0, _classCallCheck3.default)(this, VisaCheckoutStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    VisaCheckoutStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            amount: 0,
            addressUpdated: false,
            cardDetails: new _VisaCheckoutCardInfoResponse2.default(),
            loading: false,
            storedPaymentCallId: null,
            storePaymentCard: false
        });
    };

    VisaCheckoutStore.prototype.handleAmount = function handleAmount(_ref) {
        var amount = _ref.amount;

        this.setState(this.state.merge({
            amount: amount
        }));
    };

    VisaCheckoutStore.prototype.handleStorePaymentCard = function handleStorePaymentCard(_ref2) {
        var store = _ref2.store;

        this.setState(this.state.merge({
            storePaymentCard: store
        }));
    };

    VisaCheckoutStore.prototype.handleGetCardDetails = function handleGetCardDetails() {
        this.setState(this.state.merge({
            loading: true
        }));
    };

    VisaCheckoutStore.prototype.handleCardInfo = function handleCardInfo(_ref3) {
        var cardDetails = _ref3.cardDetails;

        this.setState(this.state.merge({
            loading: false,
            cardDetails: cardDetails
        }));
    };

    VisaCheckoutStore.prototype.handleStoredCardInfo = function handleStoredCardInfo(_ref4) {
        var cardDetails = _ref4.cardDetails;

        this.setState(this.state.merge({
            storedPaymentCallId: cardDetails.callId,
            cardDetails: cardDetails
        }));
    };

    VisaCheckoutStore.prototype.handleDeliveryAddressUpdated = function handleDeliveryAddressUpdated(_ref5) {
        var addressUpdated = _ref5.addressUpdated;

        this.setState(this.state.merge({
            addressUpdated: addressUpdated
        }));
    };

    VisaCheckoutStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref6;

        return _ref6 = {}, _ref6[_AppConstants.ActionTypes.VISA_CO_SETUP] = this.handleAmount, _ref6[_AppConstants.ActionTypes.VISA_CO_UPDATE_AMOUNT] = this.handleAmount, _ref6[_AppConstants.ActionTypes.VISA_CO_STORE_PAYMENT_CARD] = this.handleStorePaymentCard, _ref6[_AppConstants.ActionTypes.VISA_CO_GET_CARD_DETAILS] = this.handleGetCardDetails, _ref6[_AppConstants.ActionTypes.VISA_CO_CARD_DETAILS_LOADED] = this.handleCardInfo, _ref6[_AppConstants.ActionTypes.VISA_CO_STORED_PAYMENT_CARD_LOADED] = this.handleStoredCardInfo, _ref6[_AppConstants.ActionTypes.VISA_CO_DELIVERY_ADDRESS_UPDATED] = this.handleDeliveryAddressUpdated, _ref6[_AppConstants.ActionTypes.PAYMENT_LEFT] = this.resetState, _ref6;
    };

    return VisaCheckoutStore;
}(_BaseStore3.default);

var instance = new VisaCheckoutStore();

exports.default = instance;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RegisterLink(_ref) {
    var onClick = _ref.onClick,
        className = _ref.className,
        isSmartcardDelivery = _ref.isSmartcardDelivery;


    var externalRegistrationLink = _config2.default.get('externalRegistrationLink');

    var _handleClick = function _handleClick() {
        if (externalRegistrationLink) {
            _TrackingActions2.default.externalLink({ name: 'register' });
            window.open(externalRegistrationLink);
        } else {
            _ModalActions2.default.open(_AppConstants.GlobalModals.REGISTER, {
                forceSmartcardSignup: isSmartcardDelivery,
                disableSuccessDropdown: isSmartcardDelivery
            });
            onClick();
        }
    };

    return _react2.default.createElement(
        'button',
        {
            role: externalRegistrationLink ? 'link' : 'button',
            type: 'button',
            'aria-label': (0, _I18n.translate)('ariaLabel.openRegister'),
            className: className,
            onClick: _handleClick
        },
        (0, _I18n.translate)('account.register')
    );
}

RegisterLink.propTypes = {
    className: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    isSmartcardDelivery: _propTypes2.default.bool
};

RegisterLink.defaultProps = {
    className: 'btn btn-primary btn-lg btn-register',
    isSmartcardDelivery: false,
    onClick: _noop3.default
};

exports.default = RegisterLink;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CustomerName(_ref) {
    var form = _ref.form,
        validation = _ref.validation,
        visited = _ref.visited,
        onChange = _ref.onChange,
        vertical = _ref.vertical,
        disabled = _ref.disabled,
        userTitle = _ref.userTitle,
        props = (0, _objectWithoutProperties3.default)(_ref, ['form', 'validation', 'visited', 'onChange', 'vertical', 'disabled', 'userTitle']);

    var isTitleInvalid = function isTitleInvalid(title) {
        return (0, _isString3.default)(title) && !_config2.default.get('customerTitles').includes(title);
    };
    var hasInvalidTitle = isTitleInvalid(userTitle) || isTitleInvalid(form.title);
    var disableTitle = disabled && !hasInvalidTitle;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _Col2.default,
            { md: vertical ? 6 : 2, className: vertical ? 'col-md-offset-right-6' : '' },
            _react2.default.createElement(
                _ValidatedField2.default,
                (0, _extends3.default)({ type: 'select',
                    form: form,
                    validation: validation,
                    onChange: onChange,
                    id: 'title',
                    field: 'title',
                    outsideLabel: false,
                    label: (0, _I18n.translate)('customerdetails.title'),
                    placeholder: (0, _I18n.translate)('customerdetails.title'),
                    labelClassName: 'sr-only',
                    groupClassName: 'select-container',
                    visited: visited,
                    disabled: disableTitle,
                    required: true
                }, props),
                hasInvalidTitle && _react2.default.createElement(
                    'option',
                    { disabled: true, key: 'invalid-title' },
                    userTitle
                ),
                _config2.default.get('customerTitles').map(function (title, i) {
                    return _react2.default.createElement(
                        'option',
                        { key: i },
                        title
                    );
                })
            )
        ),
        _react2.default.createElement(
            _Col2.default,
            { md: vertical ? 6 : 5 },
            _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({ type: 'text',
                form: form,
                validation: validation,
                onChange: onChange,
                id: 'firstName',
                field: 'firstNames',
                placeholder: (0, _I18n.translate)('customerdetails.name'),
                label: (0, _I18n.translate)('customerdetails.name'),
                labelClassName: 'sr-only',
                visited: visited,
                disabled: disabled,
                required: true
            }, props))
        ),
        _react2.default.createElement(
            _Col2.default,
            { md: vertical ? 6 : 5 },
            _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({ type: 'text',
                form: form,
                validation: validation,
                onChange: onChange,
                id: 'surname',
                field: 'surname',
                placeholder: (0, _I18n.translate)('customerdetails.surname'),
                label: (0, _I18n.translate)('customerdetails.surname'),
                labelClassName: 'sr-only',
                visited: visited,
                disabled: disabled,
                required: true
            }, props))
        )
    );
}

CustomerName.propTypes = {
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    validation: _propTypes2.default.object,
    visited: _propTypes2.default.bool,
    vertical: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    userTitle: _propTypes2.default.string
};

CustomerName.defaultProps = {
    validation: null,
    visited: false,
    vertical: false,
    disabled: false,
    userTitle: null
};

exports.default = CustomerName;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DownloadTicketsModal = __webpack_require__(935);

var _DownloadTicketsModal2 = _interopRequireDefault(_DownloadTicketsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadTicketsModal = function (_RegularDownloadTicke) {
    (0, _inherits3.default)(DownloadTicketsModal, _RegularDownloadTicke);

    function DownloadTicketsModal() {
        (0, _classCallCheck3.default)(this, DownloadTicketsModal);
        return (0, _possibleConstructorReturn3.default)(this, _RegularDownloadTicke.apply(this, arguments));
    }

    DownloadTicketsModal.prototype._getFareName = function _getFareName(fare) {
        return _react2.default.createElement(
            'span',
            { className: 'text-weight--normal no-margin' },
            fare.getName()
        );
    };

    return DownloadTicketsModal;
}(_DownloadTicketsModal2.default);

exports.default = DownloadTicketsModal;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _PanelGroup = _interopRequireDefault(__webpack_require__(945));

var Accordion =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Accordion, _React$Component);

  function Accordion() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    return _react.default.createElement(_PanelGroup.default, (0, _extends2.default)({}, this.props, {
      accordion: true
    }), this.props.children);
  };

  return Accordion;
}(_react.default.Component);

var _default = Accordion;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _PaginationItem = _interopRequireWildcard(__webpack_require__(2141));

var _bootstrapUtils = __webpack_require__(21);

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Pagination, _React$Component);

  function Pagination() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), children);
  };

  return Pagination;
}(_react.default.Component);

(0, _bootstrapUtils.bsClass)('pagination', Pagination);
Pagination.First = _PaginationItem.First;
Pagination.Prev = _PaginationItem.Prev;
Pagination.Ellipsis = _PaginationItem.Ellipsis;
Pagination.Item = _PaginationItem.default;
Pagination.Next = _PaginationItem.Next;
Pagination.Last = _PaginationItem.Last;
var _default = Pagination;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _assign = _interopRequireDefault(__webpack_require__(401));

var _values = _interopRequireDefault(__webpack_require__(125));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _uncontrollable = _interopRequireDefault(__webpack_require__(106));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var _PanelBody = _interopRequireDefault(__webpack_require__(2142));

var _PanelHeading = _interopRequireDefault(__webpack_require__(2143));

var _PanelTitle = _interopRequireDefault(__webpack_require__(2144));

var _PanelFooter = _interopRequireDefault(__webpack_require__(2145));

var _PanelToggle = _interopRequireDefault(__webpack_require__(955));

var _PanelCollapse = _interopRequireDefault(__webpack_require__(954));

var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + "--" + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: _propTypes.default.bool,

  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: _propTypes.default.func,
  eventKey: _propTypes.default.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: _propTypes.default.string
};
var contextTypes = {
  $bs_panelGroup: _propTypes.default.shape({
    getId: _propTypes.default.func,
    activeKey: _propTypes.default.any,
    onToggle: _propTypes.default.func
  })
};
var childContextTypes = {
  $bs_panel: _propTypes.default.shape({
    headingId: _propTypes.default.string,
    bodyId: _propTypes.default.string,
    bsClass: _propTypes.default.string,
    onToggle: _propTypes.default.func,
    expanded: _propTypes.default.bool
  })
};

var Panel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Panel, _React$Component);

  function Panel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    };

    return _this;
  }

  var _proto = Panel.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        id = _this$props.id;
    var idKey = eventKey == null ? id : eventKey;
    var ids;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: (0, _extends2.default)({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  _proto.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? (0, _warning.default)(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children;

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.getClassSet)(bsProps))
    }), children);
  };

  return Panel;
}(_react.default.Component);

Panel.propTypes = propTypes;
Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;
var UncontrolledPanel = (0, _uncontrollable.default)((0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel)), {
  expanded: 'onToggle'
});
(0, _assign.default)(UncontrolledPanel, {
  Heading: _PanelHeading.default,
  Title: _PanelTitle.default,
  Body: _PanelBody.default,
  Footer: _PanelFooter.default,
  Toggle: _PanelToggle.default,
  Collapse: _PanelCollapse.default
});
var _default = UncontrolledPanel;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _jsonp = __webpack_require__(1752);

var _jsonp2 = _interopRequireDefault(_jsonp);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardLockService = {
    getToken: function getToken(cardNumber, securityCode) {
        return new _promise2.default(function (resolve, reject) {
            var endpoint = _config2.default.get('cardLockUrl').replace('{cardNumber}', cardNumber).replace('{securityCode}', securityCode).replace('{publishableId}', _config2.default.get('cardLockId'));

            (0, _jsonp2.default)(endpoint, function (error, response) {
                if (error) {
                    reject(error);
                } else if (response.status !== _AppConstants.CardLockStatus.SUCCESS) {
                    reject(new Error(response.status));
                } else {
                    resolve(response.token);
                }
            });
        });
    }
};

exports.default = CardLockService;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.MIN_KEYGO_BALANCE_TO_WITHDRAW = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _SmartcardProductParameters = __webpack_require__(1756);

var _SmartcardProductParameters2 = _interopRequireDefault(_SmartcardProductParameters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    serviceName: null,
    orderId: null,
    reference: null,
    oid: null,
    typ: null,
    ptyp: null,
    status: null,
    serviceBlocked: null,
    parameters: null,
    flexi: null
};

var MIN_KEYGO_BALANCE_TO_WITHDRAW = exports.MIN_KEYGO_BALANCE_TO_WITHDRAW = 0;

var SmartcardProduct = function (_record) {
    (0, _inherits3.default)(SmartcardProduct, _record);

    function SmartcardProduct() {
        (0, _classCallCheck3.default)(this, SmartcardProduct);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartcardProduct.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(SmartcardProduct, json, {
            serviceName: _LinkMapper.resolve.with(String),
            reference: _LinkMapper.resolve.with(String),
            orderId: _LinkMapper.resolve.with(Number),
            oid: _LinkMapper.resolve.with(Number),
            typ: _LinkMapper.resolve.with(Number),
            ptyp: _LinkMapper.resolve.with(Number),
            status: _LinkMapper.resolve.with(String),
            serviceBlocked: _LinkMapper.resolve.with(Boolean),
            parameters: _LinkMapper.resolve.as(_SmartcardProductParameters2.default),
            flexi: _LinkMapper.resolve.with(Object)
        });
    };

    SmartcardProduct.prototype.isActive = function isActive() {
        return this.status === _AppConstants.SmartcardProductStatus.ACTIVE;
    };

    SmartcardProduct.prototype.getDescription = function getDescription() {
        var ticketType = (0, _I18n.translate)('itso.typ' + this.typ + '.ptyp' + this.ptyp);
        return this.parameters.Description || (0, _I18n.translate)('app.owner.short') + ' ' + ticketType;
    };

    SmartcardProduct.prototype.getOriginName = function getOriginName() {
        return this.parameters.Origin || this.parameters.OriginName;
    };

    SmartcardProduct.prototype.getOriginNlc = function getOriginNlc() {
        return this.parameters.originNlc;
    };

    SmartcardProduct.prototype.getDestinationName = function getDestinationName() {
        return this.parameters.Destination || this.parameters.DestinationName;
    };

    SmartcardProduct.prototype.getDestinationNlc = function getDestinationNlc() {
        return this.parameters.destinationNlc;
    };

    SmartcardProduct.prototype.getPrice = function getPrice() {
        return this.parameters.AmountPaid;
    };

    SmartcardProduct.prototype.getValidFrom = function getValidFrom() {
        var validFrom = this.parameters.StartDate || this.parameters.ExpiryDate;
        return validFrom.clone().startOf('day');
    };

    SmartcardProduct.prototype.getValidTo = function getValidTo() {
        return this.parameters.ExpiryDate && this.parameters.ExpiryDate.clone().endOf('day');
    };

    SmartcardProduct.prototype.getOrderDate = function getOrderDate() {
        return this.parameters.IssueDate;
    };

    SmartcardProduct.prototype.isSeason = function isSeason() {
        return this.typ === 22 && this.ptyp === 1;
    };

    SmartcardProduct.prototype.isSingle = function isSingle() {
        return this.typ === 23 && [1, 2].includes(this.ptyp);
    };

    SmartcardProduct.prototype.isReturn = function isReturn() {
        return this.typ === 23 && [3, 4].includes(this.ptyp);
    };

    SmartcardProduct.prototype.isFlexi = function isFlexi() {
        return this.typ === 22 && this.ptyp === 5;
    };

    SmartcardProduct.prototype.isDaySave = function isDaySave() {
        return this.typ === 22 && this.ptyp === 28;
    };

    SmartcardProduct.prototype.isTravelCard = function isTravelCard() {
        return this.typ === 22 && this.ptyp === 19;
    };

    SmartcardProduct.prototype.isFirstClass = function isFirstClass() {
        return this.parameters.Class === 'First' || this.parameters.TravelClass === '1';
    };

    SmartcardProduct.prototype.getRoute = function getRoute() {
        var route = this.parameters.RouteName || this.parameters.routeCode;
        // Workaround CMS quirks
        return route && route.match(/\D/) ? route : undefined;
    };

    SmartcardProduct.prototype.isKeyGo = function isKeyGo() {
        return this.typ === 22 && this.ptyp === 4;
    };

    SmartcardProduct.prototype.getLastTopupDate = function getLastTopupDate() {
        return this.parameters.LAST_TOPUP_DATE;
    };

    SmartcardProduct.prototype.getLastTopupAmount = function getLastTopupAmount() {
        return this.parameters.LAST_TOPUP_AMOUNT;
    };

    SmartcardProduct.prototype.hasIncompleteJourneys = function hasIncompleteJourneys() {
        return this.parameters.PROVISIONAL_INCOMPLETE_COUNT > 0;
    };

    SmartcardProduct.prototype.getPassesRemaining = function getPassesRemaining() {
        return this.parameters.NumberRemainingPasses;
    };

    SmartcardProduct.prototype.getDateOfLastUsedPass = function getDateOfLastUsedPass() {
        return this.parameters.dateOfLastUsedPass;
    };

    SmartcardProduct.prototype.getExpiryDate = function getExpiryDate() {
        return this.parameters.expiryDateOfPasses;
    };

    SmartcardProduct.prototype.getStatus = function getStatus() {
        return this.status;
    };

    SmartcardProduct.prototype.getOrderId = function getOrderId() {
        return this.orderId;
    };

    return SmartcardProduct;
}((0, _immutable.Record)(defaults));

exports.default = SmartcardProduct;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _UserPreferences = __webpack_require__(228);

var _UserPreferences2 = _interopRequireDefault(_UserPreferences);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    preferences: new _UserPreferences2.default(),
    isOver16: false,
    telephoneNumber: null
};

var EditPreferencesForm = function (_record) {
    (0, _inherits3.default)(EditPreferencesForm, _record);

    function EditPreferencesForm() {
        (0, _classCallCheck3.default)(this, EditPreferencesForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    EditPreferencesForm.fromUser = function fromUser(user) {
        return new EditPreferencesForm({
            preferences: user.preferences || new _UserPreferences2.default(),
            isOver16: user.isOver16,
            telephoneNumber: user.telephoneNumber
        });
    };

    EditPreferencesForm.prototype.getSchema = function getSchema() {
        var schema = {};
        if (this.preferences.isSomeSmsPrefSetToTrue()) {
            schema = (0, _assign2.default)(schema, {
                telephoneNumber: _validation2.default.phone().required()
            });
        }
        return schema;
    };

    EditPreferencesForm.prototype.hasBeenEdited = function hasBeenEdited(user) {
        var preferencesChanged = this.preferences.hasDifferentPreferencesTo(user.preferences || new _UserPreferences2.default());
        var over16Changed = this.isOver16 !== !!user.isOver16;
        var numberChanged = this.telephoneNumber !== user.telephoneNumber;
        return preferencesChanged || over16Changed || numberChanged;
    };

    return EditPreferencesForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(EditPreferencesForm.prototype, _ValidationMixin2.default);

exports.default = EditPreferencesForm;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    orderId: null,
    email: null,
    phone: null,
    vouchers: new _immutable.List(),
    card: null,
    cardToken: null,
    cardAmount: 0,
    storedCard: null,
    cv2: null,
    amazonPayOrderReferenceId: null,
    paypalNonce: null,
    paypalDevice: null,
    visaCards: null
};

var AuthRequest = function (_record) {
    (0, _inherits3.default)(AuthRequest, _record);

    function AuthRequest() {
        (0, _classCallCheck3.default)(this, AuthRequest);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AuthRequest.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new AuthRequest({ json: json, vouchers: new _immutable.List(json.vouchers) });
    };

    AuthRequest.prototype.justVouchers = function justVouchers() {
        return this.vouchers.size && !this.card && !this.storedCard && !this.paypalNonce;
    };

    AuthRequest.prototype.serialize = function serialize() {
        return {
            orderId: this.orderId,
            payments: (0, _compact3.default)([this._serializeCard(), this._serializeStoredCard(), this._serializePaypal(), this._serializeVisaCards()])
        };
    };

    AuthRequest.prototype.serializeCocs = function serializeCocs() {
        var _ref2;

        var isAmend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var vouchers = this.vouchers.toJS().reduce(function (dict, _ref) {
            var id = _ref.id,
                amount = _ref.amount;

            dict[id] = { amount: amount };
            return dict;
        }, {});

        var storedCards = this.storedCard && (_ref2 = {}, _ref2[this.storedCard] = {
            amount: this.cardAmount,
            cv2: this.cv2
        }, _ref2);

        if (!storedCards && isAmend) {
            storedCards = {};
        }

        return {
            email: this.email,
            phone: this.phone,
            cards: (0, _compact3.default)([this._serializeCard()]),
            storedCards: storedCards,
            vouchers: vouchers,
            visaCards: (0, _compact3.default)([this._serializeVisaCards()])
        };
    };

    AuthRequest.prototype._serializeVoucher = function _serializeVoucher(voucher, id) {
        return {
            id: 'voucher-' + id,
            type: _AppConstants.PaymentType.VOUCHER,
            url: voucher.id,
            amount: voucher.amount
        };
    };

    AuthRequest.prototype._serializeCard = function _serializeCard() {
        var card = this.card,
            email = this.email,
            phone = this.phone;

        var result = this.cardToken && {
            id: 'card',
            type: _AppConstants.PaymentType.CARD,
            amount: this.cardAmount,
            token: this.cardToken,
            cardHolderName: card.cardHolderName,
            expiryDate: card.expiryMonth + '/' + card.expiryYear,
            email: email,
            phone: phone,
            address: {
                line1: card.addressLine1,
                line2: card.addressLine2,
                line3: card.addressLine3,
                town: card.townCity,
                postCode: card.postcode,
                country: card.country
            },
            store: !!card.store,
            nickname: card.store ? card.nickname : null
        };

        return result;
    };

    AuthRequest.prototype._serializeStoredCard = function _serializeStoredCard() {
        return this.storedCard && {
            id: 'stored-card',
            type: _AppConstants.PaymentType.STORED_CARD,
            amount: this.cardAmount,
            url: this.storedCard,
            cv2: this.cv2
        };
    };

    AuthRequest.prototype._serializePaypal = function _serializePaypal() {
        return this.paypalNonce && {
            id: 'paypal',
            type: _AppConstants.PaymentType.PAYPAL,
            amount: this.cardAmount,
            nonce: this.paypalNonce,
            deviceData: this.paypalDevice
        };
    };

    AuthRequest.prototype._serializeVisaCards = function _serializeVisaCards() {
        var visaCards = this.visaCards;

        return visaCards && {
            id: 'visa-checkout',
            type: _AppConstants.PaymentType.VISA_CHECKOUT,
            amount: visaCards.first().amount,
            callId: visaCards.first().callId,
            cardHolderName: visaCards.first().cardHolderName,
            emailAddress: visaCards.first().emailAddress,
            storeCard: visaCards.first().storeCard
        };
    };

    return AuthRequest;
}((0, _immutable.Record)(defaults));

exports.default = AuthRequest;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PaypalStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaypalStore = exports.PaypalStore = function (_BaseStore) {
    (0, _inherits3.default)(PaypalStore, _BaseStore);

    function PaypalStore() {
        (0, _classCallCheck3.default)(this, PaypalStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    PaypalStore.prototype.getInitialState = function getInitialState() {
        return _BaseStore.prototype.getInitialState.call(this).merge({
            addressError: null,
            clientToken: null
        });
    };

    PaypalStore.prototype.getClientToken = function getClientToken() {
        return this.get('clientToken');
    };

    PaypalStore.prototype.handleAddressError = function handleAddressError(_ref) {
        var countryCode = _ref.countryCode;

        var newAddressError = null;

        if (countryCode) {
            newAddressError = (0, _I18n2.default)('payment.paypal.chooseCorrectAddress', { countryCode: countryCode });
        }
        this.setState(this.state.merge({
            addressError: newAddressError
        }));
    };

    PaypalStore.prototype.handleToken = function handleToken(_ref2) {
        var token = _ref2.token;

        this.setState(this.state.set('clientToken', token));
    };

    PaypalStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.PAYPAL_ADDRESS_ERROR] = this.handleAddressError, _ref3[_AppConstants.ActionTypes.PAYPAL_CLIENT_TOKEN_LOADED] = this.handleToken, _ref3[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref3;
    };

    return PaypalStore;
}(_BaseStore3.default);

var instance = new PaypalStore();

exports.default = instance;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _UtnDetail = __webpack_require__(1141);

var _UtnDetail2 = _interopRequireDefault(_UtnDetail);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    utnDetails: new _immutable.List()
};

var UtnDetails = function (_record) {
    (0, _inherits3.default)(UtnDetails, _record);

    function UtnDetails() {
        (0, _classCallCheck3.default)(this, UtnDetails);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    UtnDetails.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(UtnDetails, json, {
            utnDetails: _LinkMapper.resolveAll.as(_UtnDetail2.default)
        });
    };

    UtnDetails.prototype.isTicketUsed = function isTicketUsed(ticketId) {
        var utnDetail = this.utnDetails.find(function (detail) {
            return detail.ticketId === ticketId;
        });
        if (!utnDetail) {
            return false;
        }
        return utnDetail.state === 'Used';
    };

    return UtnDetails;
}((0, _immutable.Record)(defaults));

exports.default = UtnDetails;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    route: [_AppConstants.SmartCarnetFiltersRoute.ANY_PERMITTED, _AppConstants.SmartCarnetFiltersRoute.BRAND_ONLY],
    service: [_AppConstants.SmartCarnetFiltersService.OFF_PEAK, _AppConstants.SmartCarnetFiltersService.PEAK]
};

var filterOffPeak = function filterOffPeak(fares) {
    return fares.filter(function (fare) {
        return fare.ticketType.code !== _AppConstants.SmartCarnetTicketCodes.OFF_PEAK;
    });
};
var filterPeak = function filterPeak(fares) {
    return fares.filter(function (fare) {
        return fare.ticketType.code !== _AppConstants.SmartCarnetTicketCodes.PEAK;
    });
};
var filterDates = function filterDates(fares) {
    return fares.filter(function (fare) {
        return fare.outwardValidity.from.isBefore((0, _TrainTime2.default)().endOf('day').add(1, 'month') // Filter out outside a time window
        );
    });
};

var SmartCarnetRecordFilters = function (_record) {
    (0, _inherits3.default)(SmartCarnetRecordFilters, _record);

    function SmartCarnetRecordFilters() {
        (0, _classCallCheck3.default)(this, SmartCarnetRecordFilters);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartCarnetRecordFilters.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new SmartCarnetRecordFilters({
            route: json.route,
            service: json.service
        });
    };

    SmartCarnetRecordFilters.prototype.getAllSelected = function getAllSelected() {
        return [].concat(this.route.filter(Boolean), this.service.filter(Boolean));
    };

    SmartCarnetRecordFilters.prototype.getCount = function getCount() {
        return this.getAllSelected().length;
    };

    SmartCarnetRecordFilters.prototype.getFilteredFares = function getFilteredFares(fares) {
        var result = fares;

        if (!this.isSelected(_AppConstants.SmartCarnetFilterTypes.SERVICE, _AppConstants.SmartCarnetFiltersService.OFF_PEAK)) {
            result = filterOffPeak(result);
        }

        if (!this.isSelected(_AppConstants.SmartCarnetFilterTypes.SERVICE, _AppConstants.SmartCarnetFiltersService.PEAK)) {
            result = filterPeak(result);
        }

        result = filterDates(result);

        return result;
    };

    SmartCarnetRecordFilters.prototype.isLastActiveFilter = function isLastActiveFilter(type) {
        return this[type].length === 1;
    };

    SmartCarnetRecordFilters.prototype.isSelected = function isSelected(type, value) {
        return this[type].includes(value);
    };

    SmartCarnetRecordFilters.prototype.updateFilter = function updateFilter(type, value) {
        if (this[type].includes(value)) {
            if (!this.isLastActiveFilter(type)) {
                return this.set(type, this[type].filter(function (v) {
                    return v !== value;
                }));
            } else {
                // Do not remove the filter as it's the last remaining one in the group
                return this;
            }
        } else {
            return this.set(type, [].concat(this[type], [value]));
        }
    };

    return SmartCarnetRecordFilters;
}((0, _immutable.Record)(defaults));

exports.default = SmartCarnetRecordFilters;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmazonPayError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _invert2 = __webpack_require__(431);

var _invert3 = _interopRequireDefault(_invert2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonPayError = exports.AmazonPayError = function (_ExtendableError) {
    (0, _inherits3.default)(AmazonPayError, _ExtendableError);

    function AmazonPayError(error) {
        (0, _classCallCheck3.default)(this, AmazonPayError);

        var _this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call(this));

        _this.name = 'AmazonPayError';
        var _error$body = error.body,
            code = _error$body.code,
            reason = _error$body.reason;

        var errorCode = code;

        if (code === 'PaymentRejected' && reason === _AppConstants.PaymentAuthCodes.AMAZON_PAY_INVALID_PAYMENT_METHOD_ERROR) {
            errorCode = _AppConstants.PaymentAuthCodes.AMAZON_PAY_INVALID_PAYMENT_METHOD_ERROR;
        }

        var messages = (0, _invert3.default)(_AppConstants.PaymentAuthCodes);
        _this.code = errorCode;
        _this.message = messages[code] || messages[_AppConstants.PaymentAuthCodes.UNKNOWN_ERROR];

        return _this;
    }

    return AmazonPayError;
}(_ExtendableError3.default);

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _immutable = __webpack_require__(5);

var _urijs = __webpack_require__(283);

var _urijs2 = _interopRequireDefault(_urijs);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    origin: null,
    destination: null,
    errormsg: null,
    pagenotif: null,
    handoffid: null,
    hostname: null,
    referrer: null,
    value: null,
    orderid: null
};

var Handoff = function (_record) {
    (0, _inherits3.default)(Handoff, _record);

    function Handoff() {
        (0, _classCallCheck3.default)(this, Handoff);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Handoff.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Handoff, json, {
            origin: _LinkMapper.fields.string,
            destination: _LinkMapper.fields.string,
            errormsg: _LinkMapper.fields.string,
            pagenotif: _LinkMapper.fields.string,
            handoffid: _LinkMapper.fields.string,
            hostname: _LinkMapper.fields.string,
            referrer: _LinkMapper.fields.string,
            value: _LinkMapper.fields.string,
            orderid: _LinkMapper.fields.number
        });
    };

    Handoff.prototype.getReferralQueryString = function getReferralQueryString() {
        return _urijs2.default.buildQuery((0, _omit3.default)(this.toJS(), 'orderid'), false);
    };

    Handoff.prototype.getTransactionQueryString = function getTransactionQueryString(orderid) {
        var params = (0, _extends3.default)({}, (0, _omit3.default)(this.toJS(), 'errormsg', 'pagenotif'), { orderid: orderid });
        return _urijs2.default.buildQuery(params, false);
    };

    return Handoff;
}((0, _immutable.Record)(defaults));

exports.default = Handoff;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _ReservationsService = __webpack_require__(2158);

var _ReservationsService2 = _interopRequireDefault(_ReservationsService);

var _ReservationRequestStore = __webpack_require__(676);

var _ReservationRequestStore2 = _interopRequireDefault(_ReservationRequestStore);

var _reservationUtils = __webpack_require__(686);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationActions = {
    setIsReservationStarted: function setIsReservationStarted() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.START_RESERVATION_FLOW
            });
        });
    },
    setIsReservationCanceled: function setIsReservationCanceled() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.CANCEL_RESERVATION_FLOW
            });
        });
    },
    setIsReservationCompleted: function setIsReservationCompleted() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.RESERVATION_COMPLETED
            });
        });
    },
    addBikeReservation: function addBikeReservation(bikeReservation) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.ADD_BIKE_RESERVATION,
                bikeReservation: bikeReservation
            });
        });
    },
    removeBikeReservation: function removeBikeReservation() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.REMOVE_BIKE_RESERVATION
            });
        });
    },
    addSeatReservation: function addSeatReservation(seatReservation) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.ADD_SEAT_RESERVATION,
                seatReservation: seatReservation
            });
        });
    },
    removeSeatReservation: function removeSeatReservation() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.REMOVE_SEAT_RESERVATION
            });
        });
    },
    setReservationWidgetToggled: function setReservationWidgetToggled(toggled) {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.RESERVATION_WIDGET_TOGGLED,
                toggled: toggled
            });
        });

        if (toggled) {
            (0, _defer3.default)(function () {
                return _AppDispatcher2.default.dispatch({
                    actionType: _AppConstants.ActionTypes.START_RESERVATION_FLOW,
                    toggled: toggled
                });
            });
        } else {
            (0, _defer3.default)(function () {
                return _AppDispatcher2.default.dispatch({
                    actionType: _AppConstants.ActionTypes.CANCEL_RESERVATION_FLOW,
                    toggled: toggled
                });
            });
        }
    },
    clearReservationStore: function clearReservationStore() {
        (0, _defer3.default)(function () {
            return _AppDispatcher2.default.dispatch({
                actionType: _AppConstants.ActionTypes.CLEAR_RESERVATION_STORE
            });
        });
    },


    /*
        Check the availability of reservations for the current reservation request
        or for the provided options.
    */
    checkAvailabilityForReservation: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(opts) {
            var reservationRequestStoreState, outwardService, inwardService, outwardFare, inwardFare, bikesCount, passengers, requestSeats, isBookingFlow, isBasicAvailabilityCheck, reservationRequest, availabilityParams, availabilityResponse, requiredBundles, bundleAvailabilityMap, i, journey, j, bundle, hasFullOutboundAvailability, hasFullInboundAvailability, k, bundleId;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            reservationRequestStoreState = _ReservationRequestStore2.default.getState();
                            outwardService = null;
                            inwardService = null;
                            outwardFare = null;
                            inwardFare = null;
                            bikesCount = 0;
                            passengers = null;
                            requestSeats = false;
                            isBookingFlow = opts && opts.context === _AppConstants.ReservationContexts.TICKET_BOOKING;
                            isBasicAvailabilityCheck = opts && opts.isBasicAvailabilityCheck;


                            passengers = opts.passengers || reservationRequestStoreState.reservationRequest.passengers;

                            if (isBookingFlow) {
                                bikesCount = opts.bikesCount;
                                requestSeats = opts.requestSeats;

                                outwardService = opts.outwardService;
                                inwardService = opts.inwardService;
                                outwardFare = opts.outwardFare;
                                inwardFare = opts.inwardFare;
                            } else {
                                reservationRequest = reservationRequestStoreState.reservationRequest;

                                bikesCount = isBasicAvailabilityCheck ? 1 : reservationRequest.get('bikes');

                                requestSeats = isBasicAvailabilityCheck ? true : reservationRequest.get('requestSeats');

                                outwardService = reservationRequestStoreState.outwardService;
                                inwardService = reservationRequestStoreState.inwardService;
                                outwardFare = reservationRequestStoreState.outwardFare;
                                inwardFare = reservationRequestStoreState.inwardFare;
                            }

                            availabilityParams = (0, _reservationUtils.buildSalesReservationPayload)({
                                outwardService: outwardService,
                                inwardService: inwardService,
                                outwardFare: outwardFare,
                                inwardFare: inwardFare,
                                passengers: passengers,
                                bikesCount: bikesCount,
                                requestSeats: requestSeats
                            });
                            _context.next = 15;
                            return ReservationActions.getReservationsAvailability(availabilityParams);

                        case 15:
                            availabilityResponse = _context.sent;


                            // Determine which bundles are required
                            requiredBundles = [];

                            if (!(!passengers || passengers.size < 1)) {
                                _context.next = 19;
                                break;
                            }

                            return _context.abrupt('return', false);

                        case 19:

                            if (requestSeats) {
                                requiredBundles.push('SEATS_OUTBOUND');
                                if (inwardService && inwardFare) {
                                    requiredBundles.push('SEATS_INBOUND');
                                }
                            }

                            if (bikesCount > 0) {
                                requiredBundles.push('BIKES_OUTBOUND');
                                if (inwardService && inwardFare) {
                                    requiredBundles.push('BIKES_INBOUND');
                                }
                            }

                            // Create a lookup for bundle outcomes
                            bundleAvailabilityMap = {};


                            if (availabilityResponse && availabilityResponse.journeys && Array.isArray(availabilityResponse.journeys)) {
                                for (i = 0; i < availabilityResponse.journeys.length; i++) {
                                    journey = availabilityResponse.journeys[i];

                                    if (journey.bundles && Array.isArray(journey.bundles)) {
                                        for (j = 0; j < journey.bundles.length; j++) {
                                            bundle = journey.bundles[j];

                                            bundleAvailabilityMap[bundle.id] = bundle.bundleOutcome;
                                        }
                                    }
                                }
                            }

                            // Check outbound and inbound availability separately using requiredBundles as source of truth
                            hasFullOutboundAvailability = true;
                            hasFullInboundAvailability = true;


                            for (k = 0; k < requiredBundles.length; k++) {
                                bundleId = requiredBundles[k];

                                if (bundleId.indexOf('OUTBOUND') !== -1) {
                                    if (bundleAvailabilityMap[bundleId] !== _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY) {
                                        hasFullOutboundAvailability = false;
                                    }
                                }
                                if (bundleId.indexOf('INBOUND') !== -1) {
                                    if (bundleAvailabilityMap[bundleId] !== _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY) {
                                        hasFullInboundAvailability = false;
                                    }
                                }
                            }

                            return _context.abrupt('return', {
                                bundleAvailabilityMap: bundleAvailabilityMap,
                                requiredBundles: requiredBundles,
                                hasFullOutboundAvailability: hasFullOutboundAvailability,
                                hasFullInboundAvailability: hasFullInboundAvailability,
                                hasFullAvailability: hasFullOutboundAvailability && hasFullInboundAvailability
                            });

                        case 27:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function checkAvailabilityForReservation(_x) {
            return _ref.apply(this, arguments);
        }

        return checkAvailabilityForReservation;
    }(),


    /*
        Create a standalone reservation based on the current reservation request state.
         This is not used by the bike reservation widget, but is used by the standalone booking flow
        to create a reservation based on the current reservation request state.
         The Booking flow just adds seats/bikes to the trip/order.
    */
    createReservation: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var reservation, reservationRequestStoreState, reservationRequest, outwardService, inwardService, outwardFare, inwardFare, reservationRequestWithJourneys, _ref3, hasFullAvailability, error;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CREATE_RESERVATION_STARTED
                            });

                            _context2.prev = 1;
                            reservation = null;
                            reservationRequestStoreState = _ReservationRequestStore2.default.getState();
                            reservationRequest = reservationRequestStoreState.reservationRequest;
                            outwardService = reservationRequestStoreState.outwardService;
                            inwardService = reservationRequestStoreState.inwardService;
                            outwardFare = reservationRequestStoreState.outwardFare;
                            inwardFare = reservationRequestStoreState.inwardFare;
                            reservationRequestWithJourneys = reservationRequest.set('outwardJourney', (0, _reservationUtils.getReservationRequestJourney)(outwardFare, outwardService));


                            if (inwardService && inwardFare) {
                                reservationRequestWithJourneys = reservationRequestWithJourneys.set('returnJourney', (0, _reservationUtils.getReservationRequestJourney)(inwardFare, inwardService));
                            }

                            _context2.next = 13;
                            return ReservationActions.checkAvailabilityForReservation({
                                context: _AppConstants.ReservationContexts.STANDALONE_BOOKING,
                                isBasicAvailabilityCheck: false // We want to check full availability when actually trying to make a reservation
                            });

                        case 13:
                            _ref3 = _context2.sent;
                            hasFullAvailability = _ref3.hasFullAvailability;

                            if (!hasFullAvailability) {
                                _context2.next = 23;
                                break;
                            }

                            _context2.next = 18;
                            return _ReservationsService2.default.createReservation(reservationRequestWithJourneys);

                        case 18:
                            reservation = _context2.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CREATE_RESERVATION_LOADED,
                                reservation: reservation
                            });

                            return _context2.abrupt('return', {
                                error: null,
                                reservation: reservation
                            });

                        case 23:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CREATE_RESERVATION_FAILED,
                                err: 'Unfortunately, there are no reservations available for these service(s)'
                            });
                            return _context2.abrupt('return', {
                                err: 'Unfortunately, there are no reservations available for these service(s)',
                                reservation: null
                            });

                        case 25:
                            _context2.next = 38;
                            break;

                        case 27:
                            _context2.prev = 27;
                            _context2.t0 = _context2['catch'](1);

                            if (!(_context2.t0.body && _context2.t0.body.errors && _context2.t0.body.errors.errorType === _AppConstants.ReservationErrorCodes.RESERVATION_LIMIT_REACHED)) {
                                _context2.next = 36;
                                break;
                            }

                            error = new Error('You’ve reached the maximum number of reservations allowed for this week. Please check back next week or contact support if you need further assistance.');

                            error.code = _AppConstants.ReservationErrorCodes.RESERVATION_LIMIT_REACHED;
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CREATE_RESERVATION_FAILED,
                                err: error
                            });
                            return _context2.abrupt('return', {
                                err: error,
                                reservation: null
                            });

                        case 36:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CREATE_RESERVATION_FAILED,
                                err: _context2.t0
                            });
                            return _context2.abrupt('return', {
                                err: _context2.t0,
                                reservation: null
                            });

                        case 38:
                            _context2.prev = 38;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.CREATE_RESERVATION_FINISHED
                            });
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_SERVICE
                            });
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_SERVICE
                            });
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_FARE
                            });
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_FARE
                            });
                            return _context2.finish(38);

                        case 45:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 27, 38, 45]]);
        }));

        function createReservation() {
            return _ref2.apply(this, arguments);
        }

        return createReservation;
    }(),
    amendReservation: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(reservation) {
            var _ref5, amendedReservation;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.AMEND_RESERVATION_STARTED
                                });
                            });
                            _context3.prev = 1;
                            _context3.next = 4;
                            return _ReservationsService2.default.amendReservation(reservation);

                        case 4:
                            _ref5 = _context3.sent;
                            amendedReservation = _ref5.result;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.AMEND_RESERVATION_LOADED,
                                    amendedReservation: amendedReservation
                                });
                            });
                            return _context3.abrupt('return', reservation);

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.AMEND_RESERVATION_FAILED,
                                    err: _context3.t0
                                });
                            });
                            return _context3.abrupt('return', null);

                        case 14:
                            _context3.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.AMEND_RESERVATION_FINISHED
                                });
                            });
                            return _context3.finish(14);

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[1, 10, 14, 17]]);
        }));

        function amendReservation(_x2) {
            return _ref4.apply(this, arguments);
        }

        return amendReservation;
    }(),
    getReservations: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var _ref7, reservations, pagination;

            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATION_STARTED
                                });
                            });
                            _context4.prev = 1;
                            _context4.next = 4;
                            return _ReservationsService2.default.getReservations(page);

                        case 4:
                            _ref7 = _context4.sent;
                            reservations = _ref7.reservations;
                            pagination = _ref7.pagination;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATION_LOADED,
                                    reservations: reservations,
                                    pagination: pagination
                                });
                            });
                            return _context4.abrupt('return', reservations);

                        case 11:
                            _context4.prev = 11;
                            _context4.t0 = _context4['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATION_FAILED,
                                    err: _context4.t0
                                });
                            });
                            return _context4.abrupt('return', null);

                        case 15:
                            _context4.prev = 15;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATION_FINISHED
                                });
                            });
                            return _context4.finish(15);

                        case 18:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[1, 11, 15, 18]]);
        }));

        function getReservations() {
            return _ref6.apply(this, arguments);
        }

        return getReservations;
    }(),
    cancelReservation: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(reservationId) {
            var reservation;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_RESERVATION_STARTED
                                });
                            });
                            _context5.prev = 1;
                            _context5.next = 4;
                            return _ReservationsService2.default.cancelReservation(reservationId);

                        case 4:
                            reservation = _context5.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_RESERVATION_SUCCESS
                                });
                            });

                            return _context5.abrupt('return', reservation);

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](1);

                            console.warn('Error canceling reservation:', _context5.t0);
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_RESERVATION_FAILED,
                                    err: _context5.t0
                                });
                            });
                            return _context5.abrupt('return', null);

                        case 14:
                            _context5.prev = 14;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.CANCEL_RESERVATION_FINISHED
                                });
                            });
                            return _context5.finish(14);

                        case 17:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[1, 9, 14, 17]]);
        }));

        function cancelReservation(_x4) {
            return _ref8.apply(this, arguments);
        }

        return cancelReservation;
    }(),
    getReservationsAvailability: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref9) {
            var journeys = _ref9.journeys,
                passengers = _ref9.passengers;
            var response;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATIONS_AVAILABILITY_STARTED
                                });
                            });
                            _context6.prev = 1;
                            _context6.next = 4;
                            return _ReservationsService2.default.getReservationsAvailability({
                                journeys: journeys,
                                passengers: passengers
                            });

                        case 4:
                            response = _context6.sent;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATIONS_AVAILABILITY_SUCCESS
                                });
                            });
                            return _context6.abrupt('return', response);

                        case 9:
                            _context6.prev = 9;
                            _context6.t0 = _context6['catch'](1);

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATIONS_AVAILABILITY_FAILED,
                                    err: _context6.t0
                                });
                            });
                            return _context6.abrupt('return', null);

                        case 13:
                            _context6.prev = 13;

                            (0, _defer3.default)(function () {
                                return _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.GET_RESERVATIONS_AVAILABILITY_FINISHED
                                });
                            });
                            return _context6.finish(13);

                        case 16:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[1, 9, 13, 16]]);
        }));

        function getReservationsAvailability(_x5) {
            return _ref10.apply(this, arguments);
        }

        return getReservationsAvailability;
    }()
};

exports.default = ReservationActions;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _LinkMapper = __webpack_require__(8);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _Photo = __webpack_require__(445);

var _Photo2 = _interopRequireDefault(_Photo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerTitles = _config2.default.get('customerTitles') || [];
var defaults = {
    title: customerTitles[0],
    firstNames: null,
    surname: null,
    photo: new _Photo2.default(),
    hasPhotoChanged: false,
    hasInfoChanged: false,
    isFlexi: false
};

var STicketDelivery = function (_record) {
    (0, _inherits3.default)(STicketDelivery, _record);

    function STicketDelivery() {
        (0, _classCallCheck3.default)(this, STicketDelivery);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    STicketDelivery.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(STicketDelivery, json, {
            photo: (0, _LinkMapper.resolve)(json.photo).with(_Photo2.default) || new _Photo2.default(),
            title: json.title,
            firstNames: json.firstNames,
            surname: json.surname,
            isFlexi: json.isFlexi
        });
    };

    STicketDelivery.prototype.getSchema = function getSchema() {
        var schema = {
            title: _validation2.default.title(),
            firstNames: _validation2.default.name(2, 50),
            surname: _validation2.default.name(2, 50),
            photo: _joi2.default.any().when('isFlexi', {
                is: true,
                then: _joi2.default.any(),
                otherwise: _joi2.default.object().keys({ imageData: _validation2.default.requiredString() })
            }),
            isFlexi: _joi2.default.boolean()
        };

        return schema;
    };

    STicketDelivery.prototype.getValue = function getValue(property) {
        return property in defaults ? this[property] : null;
    };

    return STicketDelivery;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(STicketDelivery.prototype, _ValidationMixin2.default);

exports.default = STicketDelivery;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "transitMode": [_LinkMapper.resolve.with(String)],
    "locationCode": [_LinkMapper.resolve.with(String)],
    "locationName": [_LinkMapper.resolve.with(String)]
};

var Location = function (_record) {
    (0, _inherits3.default)(Location, _record);

    function Location() {
        (0, _classCallCheck3.default)(this, Location);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Location.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Location, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return Location;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Location;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _StoredPaymentCard = __webpack_require__(433);

var _StoredPaymentCard2 = _interopRequireDefault(_StoredPaymentCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentCardStore = function (_BaseStore) {
    (0, _inherits3.default)(PaymentCardStore, _BaseStore);

    function PaymentCardStore() {
        (0, _classCallCheck3.default)(this, PaymentCardStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    PaymentCardStore.prototype.getInitialState = function getInitialState() {
        var cards = new _immutable.List();
        return new _immutable.Map({ cards: cards });
    };

    PaymentCardStore.prototype.getKeyGoCard = function getKeyGoCard() {
        var cards = this.state.get('cards');
        return cards.find(function (card) {
            return card.isKeyGoCard && card.cardToken;
        }) || new _StoredPaymentCard2.default();
    };

    PaymentCardStore.prototype.hasCards = function hasCards() {
        return !this.state.get('cards').isEmpty();
    };

    PaymentCardStore.prototype.handleCardsLoaded = function handleCardsLoaded(_ref) {
        var cards = _ref.cards;

        this.setState(this.state.set('cards', cards));
    };

    PaymentCardStore.prototype.handleCardDeleted = function handleCardDeleted(_ref2) {
        var deleted = _ref2.deleted;

        var cards = (0, _Immutable.without)(this.state.get('cards'), deleted);
        this.setState(this.state.set('cards', cards));
    };

    PaymentCardStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.CUSTOMER_PAYMENTCARDS_LOADED] = this.handleCardsLoaded, _ref3[_AppConstants.ActionTypes.CUSTOMER_PAYMENTCARD_DELETED] = this.handleCardDeleted, _ref3[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref3;
    };

    return PaymentCardStore;
}(_BaseStore3.default);

exports.default = new PaymentCardStore();

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PhotocardStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotocardStore = exports.PhotocardStore = function (_BaseStore) {
    (0, _inherits3.default)(PhotocardStore, _BaseStore);

    function PhotocardStore() {
        (0, _classCallCheck3.default)(this, PhotocardStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    PhotocardStore.prototype.handleLoaded = function handleLoaded(_ref) {
        var photocards = _ref.photocards;

        var regularCards = photocards.filter(function (_ref2) {
            var nickname = _ref2.nickname;
            return nickname !== _AppConstants.STICKET_PHOTOCARD;
        });
        var sTicketCard = photocards.find(function (_ref3) {
            var nickname = _ref3.nickname;
            return nickname === _AppConstants.STICKET_PHOTOCARD;
        }) || null;
        this.setState(this.state.set('cards', regularCards));
        this.setState(this.state.set('sTicketCard', sTicketCard));
        this.emitChange();
    };

    PhotocardStore.prototype.getCards = function getCards() {
        return this.state.get('cards', new _immutable.List());
    };

    PhotocardStore.prototype.getSTicketCard = function getSTicketCard() {
        return this.state.get('sTicketCard');
    };

    PhotocardStore.prototype.handleCreated = function handleCreated(_ref4) {
        var photocard = _ref4.photocard;

        var photocards = this.getCards().push(photocard);
        this.handleLoaded({ photocards: photocards });
    };

    PhotocardStore.prototype.handleDeleted = function handleDeleted(_ref5) {
        var photocard = _ref5.photocard;

        var current = this.getCards();
        var index = current.indexOf(photocard);
        var photocards = current.delete(index);
        this.handleLoaded({ photocards: photocards });
    };

    PhotocardStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref6;

        return _ref6 = {}, _ref6[_AppConstants.ActionTypes.PHOTOCARDS_LOADED] = this.handleLoaded, _ref6[_AppConstants.ActionTypes.PHOTOCARD_CREATED] = this.handleCreated, _ref6[_AppConstants.ActionTypes.PHOTOCARD_DELETED] = this.handleDeleted, _ref6;
    };

    return PhotocardStore;
}(_BaseStore3.default);

var storeInstance = new PhotocardStore();

exports.default = storeInstance;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    railcardNumber: null,
    firstName: null,
    lastName: null,
    syncKeyGo: null,
    expiryDate: null
};

var Railcard1617Form = function (_record) {
    (0, _inherits3.default)(Railcard1617Form, _record);

    function Railcard1617Form() {
        (0, _classCallCheck3.default)(this, Railcard1617Form);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Railcard1617Form.prototype.getSchema = function getSchema() {
        return {
            railcardNumber: _validation2.default.requiredString(15),
            firstName: _validation2.default.required(),
            lastName: _validation2.default.required(),
            syncKeyGo: _validation2.default.optional(),
            expiryDate: _validation2.default.required()
        };
    };

    return Railcard1617Form;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(Railcard1617Form.prototype, _ValidationMixin2.default);

exports.default = Railcard1617Form;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Reason = __webpack_require__(1080);

var _Reason2 = _interopRequireDefault(_Reason);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    refundValidityDays: 0,
    reasons: new _immutable.List()
};

var RefundConfig = function (_record) {
    (0, _inherits3.default)(RefundConfig, _record);

    function RefundConfig() {
        (0, _classCallCheck3.default)(this, RefundConfig);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    RefundConfig.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(RefundConfig, json, {
            refundValidityDays: _LinkMapper.fields.number,
            reasons: _LinkMapper.resolveAll.as(_Reason2.default)
        });
    };

    return RefundConfig;
}((0, _immutable.Record)(defaults));

exports.default = RefundConfig;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.fieldSchema = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _SearchUrls = __webpack_require__(97);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _CustomerServiceChangeLeg = __webpack_require__(903);

var _CustomerServiceChangeLeg2 = _interopRequireDefault(_CustomerServiceChangeLeg);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = exports.fieldSchema = {
    serviceChangeAlertId: [_LinkMapper.fields.string, null],
    cocsCustomerId: [_LinkMapper.fields.string, null],
    customerName: [_LinkMapper.fields.string, null], // anon users only
    email: [_LinkMapper.fields.string, null], // anon users only
    isEmailNotification: [_LinkMapper.fields.boolean, true],
    isCloudMessageNotification: [_LinkMapper.fields.boolean, false],
    isStationNotification: [_LinkMapper.fields.boolean, false],
    origin: [_LinkMapper.fields.string, null],
    originStationDetail: [_LinkMapper.resolve.as(_Station2.default)],
    destination: [_LinkMapper.fields.string, null],
    destinationStationDetail: [_LinkMapper.resolve.as(_Station2.default)],
    departure_time: [_LinkMapper.fields.string, null],
    departure_date: [_LinkMapper.fields.string, null],
    arrival_time: [_LinkMapper.fields.string, null],
    legs: [_LinkMapper.resolveAll.as(_CustomerServiceChangeLeg2.default), new _immutable.List()],
    orderId: [_LinkMapper.fields.number, null],
    ticketId: [_LinkMapper.fields.number, null]
};

var ServiceChangeAlert = function (_record) {
    (0, _inherits3.default)(ServiceChangeAlert, _record);

    function ServiceChangeAlert() {
        (0, _classCallCheck3.default)(this, ServiceChangeAlert);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ServiceChangeAlert.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(ServiceChangeAlert, json, (0, _Records.getResolvers)(fieldSchema));
    };

    ServiceChangeAlert.prototype.toJSON = function toJSON() {
        return (0, _SearchUrls.serialize)({
            serviceChangeAlertId: _SearchUrls.serializers.identity,
            cocsCustomerId: _SearchUrls.serializers.identity,
            customerName: _SearchUrls.serializers.identity, // anon users only
            email: _SearchUrls.serializers.identity, // anon users only
            isEmailNotification: _SearchUrls.serializers.identity,
            isCloudMessageNotification: _SearchUrls.serializers.identity,
            origin: _SearchUrls.serializers.identity,
            destination: _SearchUrls.serializers.identity,
            /*
                When serialising, we need to omit the originStationDetail and destinationStationDetail
                as the API does not accept these params when creating a ServiceChangeAlert
            */
            departure_time: _SearchUrls.serializers.identity,
            departure_date: _SearchUrls.serializers.identity,
            arrival_time: _SearchUrls.serializers.identity,
            legs: function legs(_legs) {
                return _legs ? _legs.map(function (leg) {
                    return leg.toJSON();
                }) : [];
            },
            orderId: _SearchUrls.serializers.identity,
            ticketId: _SearchUrls.serializers.identity
        }, this);
    };

    ServiceChangeAlert.prototype.getServices = function getServices() {
        return this.legs.groupBy(function (leg) {
            return leg.groupId;
        }).map(function (service) {
            return service.sortBy(function (leg) {
                return leg.legOrder;
            });
        });
    };

    return ServiceChangeAlert;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = ServiceChangeAlert;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = CustomerEmail;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CustomerEmail(props) {
    return _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({ type: 'email',
        id: props.field,
        labelClassName: 'sr-only',
        standalone: true
    }, props));
}

CustomerEmail.propTypes = {
    field: _propTypes2.default.string.isRequired,
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    label: _propTypes2.default.any,
    placeholder: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    validation: _propTypes2.default.object,
    visited: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    required: _propTypes2.default.bool
};

CustomerEmail.defaultProps = {
    field: 'email',
    label: (0, _I18n2.default)('customerdetails.confirmemail'),
    placeholder: (0, _I18n2.default)('customerdetails.email'),
    validation: null,
    visited: false,
    disabled: false,
    required: true
};

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(81)))

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _head2 = __webpack_require__(993);

var _head3 = _interopRequireDefault(_head2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _I18n = __webpack_require__(9);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _UploadButton = __webpack_require__(1083);

var _UploadButton2 = _interopRequireDefault(_UploadButton);

var _Photo = __webpack_require__(445);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoUpload = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(PhotoUpload, _React$PureComponent);

    function PhotoUpload() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PhotoUpload);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            fileName: null,
            image: null
        }, _this._handlePhotoUpdate = function (event) {
            var _event$target = event.target,
                value = _event$target.value,
                files = _event$target.files;

            var selectedImage = (0, _head3.default)(files);
            _this.setState({ fileName: selectedImage.name });
            var photo = _this.props.form.get(_this.props.field).set('photo', value);

            if (selectedImage && window.FileReader) {
                var reader = new FileReader();
                var bufferReader = new FileReader();

                reader.onload = function (readerEvent) {
                    var imageData = readerEvent.target.result;
                    var image = new Image();

                    image.src = imageData;
                    image.onload = function () {
                        photo = photo.merge({
                            selectedImage: selectedImage,
                            imageData: imageData,
                            imageWidth: image.width,
                            imageHeight: image.height
                        });

                        _this.setState({ image: { width: image.width, height: image.height } });
                        bufferReader.readAsArrayBuffer(selectedImage);
                    };
                };

                bufferReader.onload = function () {
                    var binary = bufferReader.result;
                    photo = photo.merge({
                        binary: binary
                    });
                    _this.props.onChange(_this.props.field, photo);
                };

                reader.readAsDataURL(selectedImage);
            } else {
                photo = photo.remove('selectedImage').remove('imageData').remove('imageWidth').remove('imageHeight');
                _this.props.onChange(_this.props.field, photo);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    PhotoUpload.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.reset && nextProps.reset) {
            this.setState({ fileName: null });
        }
    };

    PhotoUpload.prototype._renderPhoto = function _renderPhoto(_ref) {
        var form = _ref.form,
            field = _ref.field;
        var existingPhoto = this.props.existingPhoto;

        var _form$get = form.get(field),
            imageData = _form$get.imageData;

        if (imageData) {
            return _react2.default.createElement('div', {
                className: 'smartcard-user-photo',
                style: { backgroundImage: 'url(' + imageData + ')' }
            });
        }

        if (existingPhoto) {
            return _react2.default.createElement('img', {
                src: existingPhoto,
                className: 'img-responsive',
                alt: 'Existing smartcard user photo'
            });
        }

        var placeholderIcon = this.props.placeholderIcon;

        return placeholderIcon ? _react2.default.createElement(_Icon2.default, { icon: placeholderIcon }) : null;
    };

    PhotoUpload.prototype._renderFormatRequirements = function _renderFormatRequirements() {
        var _props = this.props,
            acceptedFormats = _props.acceptedFormats,
            hideFormats = _props.hideFormats;


        if (Array.isArray(acceptedFormats) && acceptedFormats.length && !hideFormats) {
            return _react2.default.createElement(
                'li',
                null,
                (0, _I18n.translate)('photoupload.format-requirements-label').concat(acceptedFormats.join(', '))
            );
        } else {
            return null;
        }
    };

    PhotoUpload.prototype._getFileErrors = function _getFileErrors(_ref2) {
        var submitted = _ref2.submitted,
            validation = _ref2.validation,
            visited = _ref2.visited;
        var image = this.state.image;


        if (submitted && validation['photo.imageData']) {
            return (0, _I18n.translate)('photoupload.error.required');
        } else if (visited && validation['photo.photo']) {
            return (0, _I18n.translate)('photoupload.error.required');
        } else if (validation.fileSize) {
            return (0, _I18n.translate)('photoupload.error.fileSize');
        } else if (validation.imageOrientation) {
            if (image) {
                return (0, _I18n.translate)('photoupload.error.imageOrientationWithDifference', {
                    difference: (0, _Photo.getWidthDifferenceToReachRatio)(image.width, image.height, 'portrait')
                });
            } else {
                return (0, _I18n.translate)('photoupload.error.imageOrientation');
            }
        } else if (validation.fileFormat) {
            return (0, _I18n.translate)('photoupload.error.unacceptedFileFormat');
        } else if (validation.fileHeight) {
            return (0, _I18n.translate)('account.details.photoWrongDimensions');
        }

        return null;
    };

    PhotoUpload.prototype.render = function render() {
        var _props2 = this.props,
            acceptedFormats = _props2.acceptedFormats,
            bodyText = _props2.bodyText,
            field = _props2.field,
            form = _props2.form,
            orientation = _props2.orientation,
            uploadConditions = _props2.uploadConditions,
            buttonText = _props2.buttonText,
            footerTextFeatureFlag = _props2.footerTextFeatureFlag,
            footerText = _props2.footerText,
            reset = _props2.reset,
            onDelete = _props2.onDelete,
            onUploadClick = _props2.onUploadClick,
            isDisabled = _props2.isDisabled,
            existingPhoto = _props2.existingPhoto;


        var error = this._getFileErrors(this.props);

        var _form$get2 = form.get(field),
            imageData = _form$get2.imageData;

        var onUploadClickProp = onUploadClick ? { onUploadClick: onUploadClick } : {};

        return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { md: 12, className: 'margin-top--sm' },
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { md: 12, className: 'photo-upload-container' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'smartcard-photo-upload' },
                            _react2.default.createElement(
                                'div',
                                { className: 'box box--rounded ' + orientation + '-upload' },
                                this._renderPhoto(this.props),
                                (existingPhoto || imageData) && typeof onDelete === 'function' && _react2.default.createElement(
                                    _Button2.default,
                                    { className: 'photo-upload__delete hidden-print btn-plain', onClick: onDelete },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'sr-only' },
                                        (0, _I18n.translate)('order.summary.removeJourney')
                                    ),
                                    _react2.default.createElement(_Icon2.default, { icon: 'bin', className: 'photo-upload__delete__icon' })
                                )
                            ),
                            error && _react2.default.createElement(
                                'h3',
                                { className: 'alert alert-danger smartcard-passenger__error' },
                                error
                            ),
                            _react2.default.createElement(
                                _UploadButton2.default,
                                (0, _extends3.default)({
                                    fileName: this.state.fileName,
                                    error: error
                                }, onUploadClickProp, {
                                    accept: acceptedFormats,
                                    onChange: this._handlePhotoUpdate,
                                    reset: reset,
                                    isDisabled: isDisabled,
                                    className: 'photo-upload__btn'
                                }),
                                buttonText
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'p',
                                null,
                                bodyText
                            ),
                            uploadConditions && _react2.default.createElement(
                                'ul',
                                { className: 'list-styled ' + orientation + '-upload--conditions' },
                                uploadConditions.map(function (condition) {
                                    return _react2.default.createElement(
                                        'li',
                                        { key: condition },
                                        condition
                                    );
                                }),
                                this._renderFormatRequirements()
                            )
                        )
                    )
                ),
                footerTextFeatureFlag && footerText && _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: footerTextFeatureFlag },
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { md: 12 },
                            _react2.default.createElement(
                                'p',
                                { className: 'margin-top--sm text-size--normal' },
                                footerText
                            )
                        )
                    )
                )
            )
        );
    };

    return PhotoUpload;
}(_react2.default.PureComponent), _class.propTypes = {
    acceptedFormats: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    bodyText: _propTypes2.default.string,
    buttonText: _propTypes2.default.string,
    footerText: _propTypes2.default.string,
    footerTextFeatureFlag: _propTypes2.default.string,
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    field: _propTypes2.default.string.isRequired,
    reset: _propTypes2.default.bool,
    hideFormats: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onDelete: _propTypes2.default.func,
    orientation: _propTypes2.default.oneOf(['portrait', 'landscape']),
    placeholderIcon: _propTypes2.default.string,
    uploadConditions: _propTypes2.default.array,
    validation: _propTypes2.default.object,
    visited: _propTypes2.default.bool,
    existingPhoto: _propTypes2.default.oneOf(['object', 'string']),
    onUploadClick: _propTypes2.default.func,
    isDisabled: _propTypes2.default.bool,
    submitted: _propTypes2.default.bool
}, _class.defaultProps = {
    acceptedFormats: ['image/jpeg', 'image/jpg'],
    buttonText: (0, _I18n.translate)('photoupload.buttontext'),
    reset: false,
    hideFormats: false,
    orientation: 'portrait',
    placeholderIcon: '',
    existingPhoto: null,
    onUploadClick: null,
    isDisabled: false,
    onDelete: function onDelete() {}
}, _temp2);
exports.default = PhotoUpload;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _AppConstants = __webpack_require__(6);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _RegisterSmartcard = __webpack_require__(659);

var _RegisterSmartcard2 = _interopRequireDefault(_RegisterSmartcard);

var _SmartcardRegistration = __webpack_require__(240);

var _SmartcardRegistration2 = _interopRequireDefault(_SmartcardRegistration);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _RegisterSuccessModal = __webpack_require__(679);

var _RegisterSuccessModal2 = _interopRequireDefault(_RegisterSuccessModal);

var _Smartcard = __webpack_require__(336);

var _ServiceUnavailable = __webpack_require__(922);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardModal = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(SmartcardModal, _PureRenderComponent);

    function SmartcardModal() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SmartcardModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            showModal: true,
            smartcard: new _SmartcardRegistration2.default({
                signup: _AppConstants.SignupTypes.WITH_SMARTCARD,
                selfRegistered: _this.props.withISRN,
                autoDrOptedIn: true
            }),
            submitted: false
        }, _this._handleSmartcardUpdate = function (field, value) {
            _this.setState({ smartcard: _this.state.smartcard.set(field, value) });
        }, _this._handleSmartcardAddressSelected = function (address) {
            var updatedSmartcard = _this.state.smartcard.merge({
                addressLine1: address.get('line1'),
                addressLine2: address.get('line2'),
                addressLine3: address.get('line3'),
                townCity: address.get('town'),
                postcode: address.get('postCode')
            });
            _this.setState({
                smartcard: updatedSmartcard,
                submitted: false
            });
        }, _this._onCancel = function () {
            _this.setState({ showModal: false });
            _this.props.onCancel();
            _ModalActions2.default.close(_AppConstants.GlobalModals.REGISTER_SMARTCARD);
        }, _this._onSave = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var smartcard, _this$props, user, onSmartcardSuccess, withISRN, onSuccessClose, onCloseSmartcardError, newSmartcard;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            smartcard = _this.state.smartcard;
                            _this$props = _this.props, user = _this$props.user, onSmartcardSuccess = _this$props.onSmartcardSuccess, withISRN = _this$props.withISRN, onSuccessClose = _this$props.onSuccessClose, onCloseSmartcardError = _this$props.onCloseSmartcardError;


                            _this.setState({
                                submitted: true
                            });

                            _context.prev = 3;

                            if (!withISRN) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 7;
                            return _CustomerActions2.default.linkSmartcard(user, smartcard, { isUpdate: true });

                        case 7:
                            _context.t0 = _context.sent;
                            _context.next = 13;
                            break;

                        case 10:
                            _context.next = 12;
                            return _CustomerActions2.default.registerSmartcard(user, smartcard);

                        case 12:
                            _context.t0 = _context.sent;

                        case 13:
                            newSmartcard = _context.t0;


                            if (onSmartcardSuccess) {
                                onSmartcardSuccess();
                            }

                            _this.setState({
                                showModal: false
                            });

                            if (newSmartcard) {
                                _ModalActions2.default.open(_RegisterSuccessModal2.default, {
                                    smartcard: !withISRN && newSmartcard,
                                    disableSuccessDropdown: _this.props.disableSuccessDropdown,
                                    onSuccessClose: onSuccessClose
                                });
                            }

                            _this.props.onRegister();

                            _context.next = 28;
                            break;

                        case 20:
                            _context.prev = 20;
                            _context.t1 = _context['catch'](3);

                            if (!(_context.t1 instanceof _Smartcard.SelfSmartcardRegistrationError)) {
                                _context.next = 26;
                                break;
                            }

                            _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
                                type: 'warning',
                                title: 'account.register.selfSmartcardError',
                                message: (0, _ServiceUnavailable.serviceUnavailable)(_context.t1.extra.error.body.status) ? 'error.general.message' : 'account.register.selfSmartcardErrorMessage',
                                onClose: function onClose() {
                                    return onCloseSmartcardError(user, _AppConstants.SmartcardSelfRegistrationStatuses.NEW_SMARTCARD);
                                }
                            });
                            _context.next = 28;
                            break;

                        case 26:
                            _this.setState({ submitted: false });
                            throw _context.t1;

                        case 28:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[3, 20]]);
        })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    SmartcardModal.prototype.render = function render() {
        if (!this.state.showModal) {
            return null;
        }

        var _props = this.props,
            user = _props.user,
            hideSmartcardCheckbox = _props.hideSmartcardCheckbox,
            modalSize = _props.modalSize,
            titleText = _props.titleText,
            customPromotionalText = _props.customPromotionalText;
        var _state = this.state,
            smartcard = _state.smartcard,
            submitted = _state.submitted;


        return _react2.default.createElement(
            _BaseModal2.default,
            {
                onClose: this._onCancel,
                onContinue: this._onSave,
                closeText: 'button.text.cancel',
                continueText: 'account.register',
                disableContinue: !(smartcard.withSmartcard() && smartcard.isComplete()) || submitted,
                className: (modalSize || 'modal--sm') + ' modal--standard',
                titleText: titleText
            },
            _react2.default.createElement(_RegisterSmartcard2.default, {
                ref: 'smartcard',
                user: user,
                smartcard: smartcard,
                onChange: this._handleSmartcardUpdate,
                onSelectAddress: this._handleSmartcardAddressSelected,
                hideSmartcardCheckbox: hideSmartcardCheckbox,
                customPromotionalText: customPromotionalText
            })
        );
    };

    return SmartcardModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    onRegister: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    hideSmartcardCheckbox: _propTypes2.default.bool,
    disableSuccessDropdown: _propTypes2.default.bool,
    onSmartcardSuccess: _propTypes2.default.func,
    withISRN: _propTypes2.default.bool,
    onSuccessClose: _propTypes2.default.func,
    onCloseSmartcardError: _propTypes2.default.func,
    modalSize: _propTypes2.default.string,
    titleText: _propTypes2.default.string,
    customPromotionalText: _propTypes2.default.string
}, _class.defaultProps = {
    onRegister: _noop3.default,
    onCancel: _noop3.default,
    onSuccessClose: _noop3.default,
    hideSmartcardCheckbox: false,
    disableSuccessDropdown: false,
    onSmartcardSuccess: _noop3.default,
    withISRN: false,
    modalSize: false,
    titleText: 'account.heading.smartcard.apply'
}, _temp2);
exports.default = SmartcardModal;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(309),
    castSlice = __webpack_require__(320),
    hasUnicode = __webpack_require__(259),
    isObject = __webpack_require__(77),
    isRegExp = __webpack_require__(825),
    stringSize = __webpack_require__(588),
    stringToArray = __webpack_require__(321),
    toInteger = __webpack_require__(200),
    toString = __webpack_require__(119);

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);

  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

module.exports = truncate;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(742),
    deburr = __webpack_require__(2083),
    words = __webpack_require__(2085);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1518),
    hasPath = __webpack_require__(762);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator2 = __webpack_require__(287);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _isNan = __webpack_require__(454);

var _isNan2 = _interopRequireDefault(_isNan);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _symbol = __webpack_require__(286);

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var strictUriEncode = __webpack_require__(1661);
var decodeComponent = __webpack_require__(1662);
var splitOnFirst = __webpack_require__(1663);
var filterObject = __webpack_require__(1664);

var isNullOrUndefined = function isNullOrUndefined(value) {
	return value === null || value === undefined;
};

var encodeFragmentIdentifier = (0, _symbol2.default)('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return function (key) {
				return function (result, value) {
					var index = result.length;

					if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
						return result;
					}

					if (value === null) {
						return [].concat(result, [[encode(key, options), '[', index, ']'].join('')]);
					}

					return [].concat(result, [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
				};
			};

		case 'bracket':
			return function (key) {
				return function (result, value) {
					if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
						return result;
					}

					if (value === null) {
						return [].concat(result, [[encode(key, options), '[]'].join('')]);
					}

					return [].concat(result, [[encode(key, options), '[]=', encode(value, options)].join('')]);
				};
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator':
			{
				var keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';

				return function (key) {
					return function (result, value) {
						if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
							return result;
						}

						// Translate null to an empty string so that it doesn't serialize as 'null'
						value = value === null ? '' : value;

						if (result.length === 0) {
							return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
						}

						return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
					};
				};
			}

		default:
			return function (key) {
				return function (result, value) {
					if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
						return result;
					}

					if (value === null) {
						return [].concat(result, [encode(key, options)]);
					}

					return [].concat(result, [[encode(key, options), '=', encode(value, options)].join('')]);
				};
			};
	}
}

function parserForArrayFormat(options) {
	var result = void 0;

	switch (options.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return function (key, value, accumulator) {
				var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
				value = isEncodedArray ? decode(value, options) : value;
				var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function (item) {
					return decode(item, options);
				}) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return function (key, value, accumulator) {
				var isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function (item) {
					return decode(item, options);
				});

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if ((typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input)) === 'object') {
		return keysSorter((0, _keys2.default)(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function removeHash(input) {
	var hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	var hash = '';
	var hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	var queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !(0, _isNan2.default)(Number(value)) && typeof value === 'string' && value.trim() !== '') {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = (0, _assign2.default)({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	var formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	var ret = (0, _create2.default)(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (var _iterator = query.split('&'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var param = _ref;

		if (param === '') {
			continue;
		}

		var _splitOnFirst = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '='),
		    key = _splitOnFirst[0],
		    value = _splitOnFirst[1];

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters


		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (var _iterator2 = (0, _keys2.default)(ret), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		var _ref2;

		if (_isArray2) {
			if (_i2 >= _iterator2.length) break;
			_ref2 = _iterator2[_i2++];
		} else {
			_i2 = _iterator2.next();
			if (_i2.done) break;
			_ref2 = _i2.value;
		}

		var key = _ref2;

		var value = ret[key];
		if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
			for (var _iterator3 = (0, _keys2.default)(value), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
				var _ref3;

				if (_isArray3) {
					if (_i3 >= _iterator3.length) break;
					_ref3 = _iterator3[_i3++];
				} else {
					_i3 = _iterator3.next();
					if (_i3.done) break;
					_ref3 = _i3.value;
				}

				var k = _ref3;

				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? (0, _keys2.default)(ret).sort() : (0, _keys2.default)(ret).sort(options.sort)).reduce(function (result, key) {
		var value = ret[key];
		if (Boolean(value) && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, (0, _create2.default)(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (object, options) {
	if (!object) {
		return '';
	}

	options = (0, _assign2.default)({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	var shouldFilter = function shouldFilter(key) {
		return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
	};

	var formatter = encoderForArrayFormat(options);

	var objectCopy = {};

	for (var _iterator4 = (0, _keys2.default)(object), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		var _ref4;

		if (_isArray4) {
			if (_i4 >= _iterator4.length) break;
			_ref4 = _iterator4[_i4++];
		} else {
			_i4 = _iterator4.next();
			if (_i4.done) break;
			_ref4 = _i4.value;
		}

		var key = _ref4;

		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	var keys = (0, _keys2.default)(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(function (key) {
		var value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value.reduce(formatter(key), []).join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&');
};

exports.parseUrl = function (url, options) {
	options = (0, _assign2.default)({
		decode: true
	}, options);

	var _splitOnFirst2 = splitOnFirst(url, '#'),
	    url_ = _splitOnFirst2[0],
	    hash = _splitOnFirst2[1];

	return (0, _assign2.default)({
		url: url_.split('?')[0] || '',
		query: parse(extract(url), options)
	}, options && options.parseFragmentIdentifier && hash ? { fragmentIdentifier: decode(hash, options) } : {});
};

exports.stringifyUrl = function (object, options) {
	var _Object$assign2;

	options = (0, _assign2.default)((_Object$assign2 = {
		encode: true,
		strict: true
	}, _Object$assign2[encodeFragmentIdentifier] = true, _Object$assign2), options);

	var url = removeHash(object.url).split('?')[0] || '';
	var queryFromUrl = exports.extract(object.url);
	var parsedQueryFromUrl = exports.parse(queryFromUrl, { sort: false });

	var query = (0, _assign2.default)(parsedQueryFromUrl, object.query);
	var queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = '?' + queryString;
	}

	var hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = '#' + (options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
	}

	return '' + url + queryString + hash;
};

exports.pick = function (input, filter, options) {
	var _Object$assign3;

	options = (0, _assign2.default)((_Object$assign3 = {
		parseFragmentIdentifier: true
	}, _Object$assign3[encodeFragmentIdentifier] = false, _Object$assign3), options);

	var _exports$parseUrl = exports.parseUrl(input, options),
	    url = _exports$parseUrl.url,
	    query = _exports$parseUrl.query,
	    fragmentIdentifier = _exports$parseUrl.fragmentIdentifier;

	return exports.stringifyUrl({
		url: url,
		query: filterObject(query, filter),
		fragmentIdentifier: fragmentIdentifier
	}, options);
};

exports.exclude = function (input, filter, options) {
	var exclusionFilter = Array.isArray(filter) ? function (key) {
		return !filter.includes(key);
	} : function (key, value) {
		return !filter(key, value);
	};

	return exports.pick(input, exclusionFilter, options);
};

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _Tap = __webpack_require__(653);

var _Tap2 = _interopRequireDefault(_Tap);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "journeyId": [_LinkMapper.resolve.with(Number)],
    "description": [_LinkMapper.resolve.with(String)],
    "originName": [_LinkMapper.resolve.with(String)],
    "destinationName": [_LinkMapper.resolve.with(String)],
    "route": [_LinkMapper.resolve.with(String)],
    "startTimestamp": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "endTimestamp": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "type": [_LinkMapper.resolve.with(String)],
    "state": [_LinkMapper.resolve.with(String)],
    "transitMode": [_LinkMapper.resolve.with(String)],
    "taps": [_LinkMapper.resolveAll.as(_Tap2.default)],
    "weeklyCapApplied": [_LinkMapper.resolve.with(Boolean)],
    "weeklySeasonSaving": [_LinkMapper.resolve.with(Number)]
};

var Journey = function (_record) {
    (0, _inherits3.default)(Journey, _record);

    function Journey() {
        (0, _classCallCheck3.default)(this, Journey);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Journey.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Journey, json, (0, _Records.getResolvers)(fieldSchema));
    };

    Journey.prototype.getTap = function getTap() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _AppConstants.KeyGoTapTypes.ENTRY;

        var tap = this.taps.find(function (t) {
            return t.type === type;
        });
        return tap ? tap : new _Tap2.default({
            type: type,
            generationCause: _AppConstants.KeyGoTapGenerationCause.UNKNOWN,
            status: _AppConstants.KeyGoTapStatus.GENERATED
        });
    };

    Journey.prototype.isFinalIncomplete = function isFinalIncomplete() {
        return this.state === _AppConstants.KeyGoJourneyStates.INCOMPLETE_FINAL;
    };

    Journey.prototype.isProvisionalIncomplete = function isProvisionalIncomplete() {
        return this.state === _AppConstants.KeyGoJourneyStates.INCOMPLETE_PROVISIONAL;
    };

    Journey.prototype.isBus = function isBus() {
        return this.transitMode.toUpperCase() === _AppConstants.IBlocksTransitModes.BUS;
    };

    return Journey;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Journey;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _SearchUrls = __webpack_require__(97);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _DatePeriod = __webpack_require__(1739);

var _DatePeriod2 = _interopRequireDefault(_DatePeriod);

var _TimePeriod = __webpack_require__(1740);

var _TimePeriod2 = _interopRequireDefault(_TimePeriod);

var _CalculationBreakdown = __webpack_require__(1741);

var _CalculationBreakdown2 = _interopRequireDefault(_CalculationBreakdown);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    ticketId: [_LinkMapper.fields.number],
    collected: [_LinkMapper.fields.boolean],
    originalAmount: [_LinkMapper.fields.number],
    refundAmount: [_LinkMapper.fields.number],
    totalUsed: [_LinkMapper.fields.number],
    surrenderDate: [_LinkMapper.resolve.with(_TrainTime2.default)],
    durationUsed: [_LinkMapper.resolve.as(_TimePeriod2.default)],
    dateUsed: [_LinkMapper.resolve.as(_DatePeriod2.default)],
    dateUnused: [_LinkMapper.resolve.as(_DatePeriod2.default)],
    breakdown: [_LinkMapper.resolve.as(_CalculationBreakdown2.default)]
};

function _formatDatePair(from, to) {
    var _formatDate = function _formatDate(date) {
        return date && date.format('ddd DD MMM YYYY');
    };
    if (from.isSame(to)) {
        return _formatDate(from);
    } else if (from.isBefore(to)) {
        return (0, _I18n.translate)('account.orders.refund.itso.datePeriodPair', { startDate: _formatDate(from), endDate: _formatDate(to) });
    } else {
        return '-';
    }
}

var Calculation = function (_record) {
    (0, _inherits3.default)(Calculation, _record);

    function Calculation() {
        (0, _classCallCheck3.default)(this, Calculation);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Calculation.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Calculation, json, (0, _Records.getResolvers)(fieldSchema));
    };

    Calculation.prototype.serialize = function serialize() {
        return (0, _SearchUrls.serialize)({
            ticketId: _SearchUrls.serializers.identity,
            collected: _SearchUrls.serializers.identity,
            originalAmount: _SearchUrls.serializers.identity,
            refundAmount: _SearchUrls.serializers.identity,
            totalUsed: _SearchUrls.serializers.identity,
            surrenderDate: _SearchUrls.serializers.isoDateTime,
            durationUsed: _SearchUrls.serializers.identity,
            dateUsed: _SearchUrls.serializers.serializedIdentity,
            dateUnused: _SearchUrls.serializers.serializedIdentity,
            breakdown: _SearchUrls.serializers.identity
        }, this);
    };

    Calculation.prototype.getUsedDates = function getUsedDates() {
        var from = this.dateUsed.from.clone().startOf('day');
        var to = this.dateUsed.to.clone().startOf('day');
        return _formatDatePair(from, to);
    };

    Calculation.prototype.getUnusedDates = function getUnusedDates() {
        var from = this.dateUnused.from.clone().startOf('day');
        var to = this.dateUnused.to.clone().startOf('day');
        return _formatDatePair(from, to);
    };

    Calculation.prototype.isIncomplete = function isIncomplete() {
        return this.getIn(['breakdown', 'isIncomplete']);
    };

    (0, _createClass3.default)(Calculation, [{
        key: 'availableToRefund',
        get: function get() {
            return this.refundAmount > 0 ? this.refundAmount : 0;
        }
    }]);
    return Calculation;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Calculation;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RefundStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _LocalStorage = __webpack_require__(316);

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

var _Config = __webpack_require__(1067);

var _Config2 = _interopRequireDefault(_Config);

var _Request = __webpack_require__(992);

var _Request2 = _interopRequireDefault(_Request);

var _UtnDetails = __webpack_require__(1057);

var _UtnDetails2 = _interopRequireDefault(_UtnDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = 'refundConfig';
var CONFIG_TTL = 60 * 60;

var RefundStore = exports.RefundStore = function (_BaseStore) {
    (0, _inherits3.default)(RefundStore, _BaseStore);

    function RefundStore() {
        (0, _classCallCheck3.default)(this, RefundStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    RefundStore.prototype.getInitialState = function getInitialState() {
        var config = _LocalStorage2.default.getItem(STORAGE_KEY);
        return new _immutable.Map({
            config: config && _Config2.default.fromJSON(config),
            request: new _Request2.default(),
            order: null,
            calculations: null,
            utnDetails: new _UtnDetails2.default()
        });
    };

    RefundStore.prototype.handleConfig = function handleConfig(_ref) {
        var config = _ref.config;

        _LocalStorage2.default.setItem(STORAGE_KEY, config.toJS(), CONFIG_TTL);
        this.setState(this.state.set('config', config));
    };

    RefundStore.prototype.handleRefundDetails = function handleRefundDetails(_ref2) {
        var order = _ref2.order;

        var cardPayments = order.getCardPayments();
        var paypalPayment = order.getPaypalPayment();
        var googlePayment = order.getGooglePayPayment();
        var applePayment = order.getApplePayPayment();
        var amazonPayPayment = order.getAmazonPayPayment();
        var braintreeCardPayment = order.getBraintreeCardPayment();

        var maxCashReturn = void 0;
        if (cardPayments && cardPayments.size > 0) {
            maxCashReturn = (0, _Immutable.sum)(cardPayments, 'amount');
        } else if (paypalPayment && paypalPayment.amount > 0) {
            maxCashReturn = paypalPayment.amount;
        } else if (amazonPayPayment && amazonPayPayment.amount > 0) {
            maxCashReturn = amazonPayPayment.amount;
        } else if (googlePayment && googlePayment.amount > 0) {
            maxCashReturn = googlePayment.amount;
        } else if (applePayment && applePayment.amount > 0) {
            maxCashReturn = applePayment.amount;
        } else if (braintreeCardPayment && braintreeCardPayment.amount > 0) {
            maxCashReturn = braintreeCardPayment.amount;
        } else {
            maxCashReturn = 0;
        }

        var request = this.state.get('request').set('maxCashReturn', maxCashReturn);

        if ((!cardPayments || cardPayments.size === 0) && !paypalPayment && !googlePayment && !applePayment && !amazonPayPayment && !braintreeCardPayment) {
            request = request.setVoucherAmount(request.total);
        }

        if (googlePayment) {
            request = request.setGooglePayAmount(googlePayment.amount);
        }

        if (applePayment) {
            request = request.setApplePayAmount(applePayment.amount);
        }

        if (braintreeCardPayment) {
            request = request.setBraintreeCardPaymentAmount(braintreeCardPayment.amount);
        }

        request = request.setBookingFee(order.getBookingFeePrice());

        this.setState(this.state.merge({
            order: order,
            request: order.alreadyPaidForRefund ? request.setFeePaid() : request
        }));
    };

    RefundStore.prototype.handleITSORefundCalculations = function handleITSORefundCalculations(_ref3) {
        var calculations = _ref3.calculations;

        var order = this.get('order');
        var request = this.get('request');
        var fare = void 0;

        var trips = order.hasChangeoverTickets() ? order.getChangeoverTrips() : order.trips;
        var trip = trips.first();

        if (trip.hasSeasonFare()) {
            fare = trip.getSeasonFare();
        } else {
            fare = trip.getOutwardFare() || trip.getInwardFare();
        }

        var ticket = fare.tickets.first();

        var totalUsed = calculations.getIn([0, 'totalUsed']);

        var _get = this.get('config'),
            reasons = _get.reasons;

        var itsoReasons = reasons.filter(function (rc) {
            return rc.itso;
        });

        if (fare && ticket) {
            request = request.setIsSmartcard().setTotalUsed(order.isMultiSmartcard() ? 0 : totalUsed).set('reason', totalUsed > 0 ? itsoReasons.find(function (ir) {
                return ir.code === 7;
            }) : // Used
            itsoReasons.find(function (ir) {
                return ir.code === 6;
            })); // Not-Used
        }

        if (!fare.getOutwardValidityPeriod().matchDurationType(_AppConstants.DurationTypes.ANNUAL)) {
            // If not annual then Weekly, Monthly or Custom
            request = request.setIsWMC();
        }

        if ((fare.origin.isWithinGoldcardArea() || fare.destination.isWithinGoldcardArea()) && fare.getOutwardValidityPeriod().matchDurationType(_AppConstants.DurationTypes.ANNUAL)) {
            request = request.setShouldSurrenderGoldCard();
        }

        if (order.hasVoucherPayment()) {
            request = request.setVoucherAmount();
        }

        request = request.setBookingFee(order.getBookingFeePrice());

        this.setState(this.state.merge({
            request: request,
            calculations: calculations
        }));
    };

    RefundStore.prototype.handleRefundCalculations = function handleRefundCalculations(_ref4) {
        var calculations = _ref4.calculations;

        var request = this.get('request');

        this.setState(this.state.merge({
            request: request,
            calculations: calculations
        }));
    };

    RefundStore.prototype.handleUpdated = function handleUpdated(_ref5) {
        var refundRequest = _ref5.refundRequest,
            reasonChanged = _ref5.reasonChanged;

        var request = refundRequest;
        var _request = request,
            voucherAmount = _request.voucherAmount,
            minVoucherAmount = _request.minVoucherAmount;


        if (reasonChanged) {
            request = request.clearFares();
        }
        if (voucherAmount < minVoucherAmount) {
            request = request.set('voucherAmount', minVoucherAmount);
        }

        this.setState(this.state.set('request', request));
    };

    RefundStore.prototype.handleUtnDetails = function handleUtnDetails(_ref6) {
        var utnDetails = _ref6.utnDetails;

        this.setState(this.state.set('utnDetails', utnDetails));
    };

    RefundStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref7;

        return _ref7 = {}, _ref7[_AppConstants.ActionTypes.REFUND_CONFIG_LOADED] = this.handleConfig, _ref7[_AppConstants.ActionTypes.REFUND_DETAILS_LOADED] = this.handleRefundDetails, _ref7[_AppConstants.ActionTypes.REFUND_CALCULATIONS_LOADED] = this.handleRefundCalculations, _ref7[_AppConstants.ActionTypes.REFUND_ITSO_CALCULATIONS_LOADED] = this.handleITSORefundCalculations, _ref7[_AppConstants.ActionTypes.REFUND_UPDATED] = this.handleUpdated, _ref7[_AppConstants.ActionTypes.REFUND_RESET] = this.resetState, _ref7[_AppConstants.ActionTypes.UTN_DETAILS] = this.handleUtnDetails, _ref7;
    };

    return RefundStore;
}(_BaseStore3.default);

var instance = new RefundStore();

exports.default = instance;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TicketType = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    code: 0,
    name: "",
    fee: 0,
    moreDetailsRequired: false,
    automated: false,
    itso: false,
    isEticket: false,
    isSeasonTicket: false,
    isHidden: false
};

var RefundReason = function (_record) {
    (0, _inherits3.default)(RefundReason, _record);

    function RefundReason() {
        (0, _classCallCheck3.default)(this, RefundReason);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    RefundReason.prototype.availableOnline = function availableOnline() {
        return this.automated;
    };

    RefundReason.prototype.isApplicable = function isApplicable(ticketCode) {
        if (_TicketType.daySaveTypes.includes(ticketCode) && this.code !== 3) {
            return false;
        }

        return true;
    };

    RefundReason.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(RefundReason, json, {
            code: _LinkMapper.fields.number,
            name: _LinkMapper.fields.string,
            fee: _LinkMapper.fields.number,
            moreDetailsRequired: _LinkMapper.fields.bool,
            automated: _LinkMapper.fields.bool,
            itso: _LinkMapper.fields.bool,
            isEticket: _LinkMapper.fields.bool,
            isSeasonTicket: _LinkMapper.fields.bool,
            isHidden: _LinkMapper.fields.bool
        });
    };

    return RefundReason;
}((0, _immutable.Record)(defaults));

exports.default = RefundReason;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _Cookie = __webpack_require__(258);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardCTAStore = function (_BaseStore) {
    (0, _inherits3.default)(SmartcardCTAStore, _BaseStore);

    function SmartcardCTAStore() {
        (0, _classCallCheck3.default)(this, SmartcardCTAStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SmartcardCTAStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            dismissed: Boolean(_Cookie2.default.objectFromCookie(_AppConstants.CookieKeys.SMARTCARD_CTA_DISMISSED))
        });
    };

    SmartcardCTAStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.SMARTCARD_CTA_DISMISSED] = this.handleCTADismissed, _ref;
    };

    SmartcardCTAStore.prototype.handleCTADismissed = function handleCTADismissed() {
        _Cookie2.default.set(_AppConstants.CookieKeys.SMARTCARD_CTA_DISMISSED, true);
        this.setState(this.state.set('dismissed', true));
    };

    SmartcardCTAStore.prototype.resetState = function resetState() {
        _Cookie2.default.clear(_AppConstants.CookieKeys.SMARTCARD_CTA_DISMISSED);
        _BaseStore.prototype.resetState.call(this);
    };

    return SmartcardCTAStore;
}(_BaseStore3.default);

exports.default = new SmartcardCTAStore();

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoweredBy = function PoweredBy(_ref) {
    var className = _ref.className;

    return _react2.default.createElement(
        'a',
        { target: '_blank', href: _config2.default.get('poweredByUrl'), className: (0, _classnames2.default)('powered-by', className) },
        (0, _I18n2.default)('poweredBy.text'),
        _react2.default.createElement('img', {
            src: _Assets2.default.assetUrl('images/otrl-logo-circle.png'),
            alt: '',
            className: 'powered-by__logo'
        }),
        _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            (0, _I18n2.default)('global.externalLink')
        )
    );
};

PoweredBy.propTypes = {
    className: _propTypes2.default.string
};

exports.default = _react2.default.memo(PoweredBy);

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadButton = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(UploadButton, _React$PureComponent);

    function UploadButton() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, UploadButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            visited: _this.props.visited
        }, _this.onFileChange = function (event) {
            var files = event.target.files;
            var file = files[0];

            if (file) {
                _this.props.onChange(event);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    UploadButton.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(_ref) {
        var fileName = _ref.fileName,
            reset = _ref.reset,
            visited = _ref.visited;

        if (fileName && fileName !== this.props.fileName) {
            this.setState({ visited: false });
        } else if (visited !== this.state.visited) {
            this.setState({ visited: visited });
        }
        if (reset && !this.props.reset) {
            this.refs.fileselect.value = '';
        }
    };

    UploadButton.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            bsStyle = _props.bsStyle,
            children = _props.children,
            accept = _props.accept,
            fileName = _props.fileName,
            error = _props.error,
            visited = _props.visited,
            id = _props.id,
            label = _props.label,
            onUploadClick = _props.onUploadClick,
            isDisabled = _props.isDisabled,
            className = _props.className;


        var selectFile = function selectFile() {
            _this2.refs.fileselect.click();
        };

        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)({ 'input--invalid btn-upload-error': !!error }) },
            _react2.default.createElement(
                'div',
                { className: 'upload__wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'upload-btn__wrapper' },
                    _react2.default.createElement(
                        _Button2.default,
                        { bsStyle: bsStyle, onClick: function onClick() {
                                return onUploadClick(selectFile);
                            }, disabled: isDisabled, className: className },
                        children,
                        _react2.default.createElement(
                            'label',
                            { htmlFor: id, className: 'sr-only' },
                            label
                        ),
                        _react2.default.createElement('input', { id: id,
                            type: 'file',
                            ref: 'fileselect',
                            onChange: this.onFileChange,
                            style: { display: 'none' },
                            accept: accept })
                    ),
                    _react2.default.createElement('div', { className: 'gradient-overlay' })
                ),
                fileName && _react2.default.createElement(
                    'p',
                    { className: (0, _classnames2.default)('fileName', { 'fileName--accepted': !error }) },
                    fileName
                )
            ),
            (visited || fileName) && error && _react2.default.createElement(_Error2.default, { message: error })
        );
    };

    return UploadButton;
}(_react2.default.PureComponent), _class.propTypes = {
    fileName: _propTypes2.default.string,
    bsStyle: _propTypes2.default.string,
    accept: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    onChange: _propTypes2.default.func,
    error: _propTypes2.default.string,
    children: _propTypes2.default.any.isRequired,
    visited: _propTypes2.default.bool,
    id: _propTypes2.default.string,
    label: _propTypes2.default.string,
    reset: _propTypes2.default.bool,
    onUploadClick: _propTypes2.default.func,
    isDisabled: _propTypes2.default.bool,
    className: _propTypes2.default.string
}, _class.defaultProps = {
    fileName: null,
    bsStyle: 'default',
    accept: ['image/jpeg', 'image/jpg'],
    onChange: _noop3.default,
    error: null,
    visited: false,
    id: '',
    label: '',
    reset: false,
    onUploadClick: function onUploadClick(callback) {
        return callback();
    },
    className: ''
}, _temp2);
exports.default = UploadButton;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SubscribeDelayRepay = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectPaymentMethod = __webpack_require__(1155);

var _SelectPaymentMethod2 = _interopRequireDefault(_SelectPaymentMethod);

var _NotifyBy = __webpack_require__(933);

var _NotifyBy2 = _interopRequireDefault(_NotifyBy);

var _SelectAddress = __webpack_require__(2025);

var _SelectAddress2 = _interopRequireDefault(_SelectAddress);

var _Success = __webpack_require__(2026);

var _Success2 = _interopRequireDefault(_Success);

var _ADRPaymentMethodsForm = __webpack_require__(463);

var _ADRPaymentMethodsForm2 = _interopRequireDefault(_ADRPaymentMethodsForm);

var _ReimbursementService = __webpack_require__(1157);

var _ReimbursementService2 = _interopRequireDefault(_ReimbursementService);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _PushNotificationActions = __webpack_require__(660);

var _PushNotificationActions2 = _interopRequireDefault(_PushNotificationActions);

var _DelayRepayActions = __webpack_require__(646);

var _DelayRepayActions2 = _interopRequireDefault(_DelayRepayActions);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _fpUtils = __webpack_require__(637);

var _fpUtils2 = _interopRequireDefault(_fpUtils);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _Form = __webpack_require__(2029);

var _Form2 = _interopRequireDefault(_Form);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _useRouter = __webpack_require__(338);

var _useRouter2 = _interopRequireDefault(_useRouter);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STEPS_AMOUNT = 4;

var SubscribeDelayRepay = function SubscribeDelayRepay(_ref) {
    var handleClose = _ref.handleClose,
        modalOpen = _ref.modalOpen,
        user = _ref.user,
        shouldRedirectToAccountScreen = _ref.shouldRedirectToAccountScreen,
        _ref$setIsJourneyCard = _ref.setIsJourneyCardModalOpen,
        setIsJourneyCardModalOpen = _ref$setIsJourneyCard === undefined ? _noop3.default : _ref$setIsJourneyCard,
        preferenceCentre = _ref.preferenceCentre,
        optedInFrom = _ref.optedInFrom,
        paymentConfirmation = _ref.paymentConfirmation,
        isTabletWidth = _ref.isTabletWidth,
        props = (0, _objectWithoutProperties3.default)(_ref, ['handleClose', 'modalOpen', 'user', 'shouldRedirectToAccountScreen', 'setIsJourneyCardModalOpen', 'preferenceCentre', 'optedInFrom', 'paymentConfirmation', 'isTabletWidth']);

    var _useState = (0, _react.useState)(0),
        step = _useState[0],
        setStep = _useState[1];

    var _useState2 = (0, _react.useState)(null),
        notifyByPreference = _useState2[0],
        setNotifyByPreference = _useState2[1];

    var _useState3 = (0, _react.useState)(true),
        isBankDetailsVerified = _useState3[0],
        setIsBankDetailsVerified = _useState3[1];

    var _useState4 = (0, _react.useState)(false),
        hasPushNotifications = _useState4[0],
        setHasPushNotifications = _useState4[1];

    var isLoggedIn = user && user.isLoggedIn();

    var addresses = isLoggedIn && user.customer.addresses;

    var router = (0, _useRouter2.default)();
    var location = (0, _useRouter.useLocation)();

    var initialForm = new _ADRPaymentMethodsForm2.default({
        accountNumber: "",
        amazonCustomerId: null,
        amazonEmail: "",
        charity: null,
        method: null,
        paypalEmail: "",
        sortCode: ""
    });

    var _useState5 = (0, _react.useState)(initialForm),
        form = _useState5[0],
        handleFormChange = _useState5[1];

    var initialAddressForm = new _Form2.default({
        country: 'GBR'
    });

    var _useState6 = (0, _react.useState)(initialAddressForm),
        addressForm = _useState6[0],
        setAddressForm = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        addNewAddress = _useState7[0],
        setAddNewAddress = _useState7[1];

    var _useState8 = (0, _react.useState)(true),
        showPaymentForm = _useState8[0],
        setShowPaymentForm = _useState8[1];

    var _useState9 = (0, _react.useState)([]),
        paymentInfo = _useState9[0],
        setPaymentInfo = _useState9[1];

    var _useState10 = (0, _react.useState)(false),
        hasReimbursementErrors = _useState10[0],
        setHasReimbursementErrors = _useState10[1];

    var _useState11 = (0, _react.useState)(),
        selectedAddress = _useState11[0],
        setSelectedAddress = _useState11[1];

    var handleIsValidBACS = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(sortCode, accountNumber) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _fpUtils2.default.isValidBACS(sortCode, accountNumber, setIsBankDetailsVerified);

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function handleIsValidBACS(_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }();

    var resetPaymentInfo = function resetPaymentInfo() {
        setPaymentInfo([]);
    };

    var onSubmitPaymentInfo = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var paymentInfoFields, setReimbursementSuccess;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            paymentInfoFields = (0, _extends3.default)({}, form.toJS());
                            setReimbursementSuccess = false;
                            _context2.next = 4;
                            return _ReimbursementService2.default.setReimbursement(user.id, paymentInfoFields);

                        case 4:
                            setReimbursementSuccess = _context2.sent;


                            if (setReimbursementSuccess) {
                                setPaymentInfo([].concat(paymentInfo, [paymentInfoFields]));
                                setHasReimbursementErrors(false);
                            } else {
                                setHasReimbursementErrors(true);
                            }

                            return _context2.abrupt('return', setReimbursementSuccess);

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function onSubmitPaymentInfo() {
            return _ref3.apply(this, arguments);
        };
    }();

    var closeModal = function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(preferenceCentre && step === 3)) {
                                _context3.next = 3;
                                break;
                            }

                            _context3.next = 3;
                            return _DelayRepayActions2.default.subscribe(user, notifyByPreference);

                        case 3:
                            handleClose();
                            setNotifyByPreference(null);
                            resetPaymentInfo();
                            setShowPaymentForm(true);
                            setStep(0);
                            setIsBankDetailsVerified(true);
                            setHasReimbursementErrors(false);

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function closeModal() {
            return _ref4.apply(this, arguments);
        };
    }();

    var onChange = function onChange(field, val) {
        setAddressForm(function (prevState) {
            return prevState.set(field, val);
        });
    };

    var handleContinue = function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var paymentInfoSet, address, _address, query;

            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            paymentInfoSet = false;

                            if (step === 0) {
                                _TrackingActions2.default.selectNotificationPreference(notifyByPreference === 'appAndEmail' ? 'app-and-email' : notifyByPreference);
                            }

                            if (!(STEPS_AMOUNT > step + 1)) {
                                _context4.next = 40;
                                break;
                            }

                            if (!(step === 1)) {
                                _context4.next = 8;
                                break;
                            }

                            _TrackingActions2.default.selectRepaymentMethod(form.method === _AppConstants.oneClickDelayRepayReimbursementMethods.BACS ? 'BACS' : form.method === _AppConstants.oneClickDelayRepayReimbursementMethods.PAYPAL ? 'PayPal' : form.method === _AppConstants.oneClickDelayRepayReimbursementMethods.CHARITY ? 'charity' : 'eVoucher');
                            _context4.next = 7;
                            return onSubmitPaymentInfo();

                        case 7:
                            paymentInfoSet = _context4.sent;

                        case 8:
                            if (!(step === 2)) {
                                _context4.next = 37;
                                break;
                            }

                            _context4.prev = 9;

                            if (!addNewAddress) {
                                _context4.next = 22;
                                break;
                            }

                            address = new _Address2.default({
                                contactName: user.title + ' ' + user.firstNames + ' ' + user.surname,
                                line1: addressForm.addressLine1,
                                line2: addressForm.addressLine2,
                                line3: addressForm.addressLine3,
                                town: addressForm.townCity,
                                postCode: addressForm.postcode,
                                country: addressForm.country
                            });

                            if (!address.isComplete()) {
                                _context4.next = 17;
                                break;
                            }

                            _context4.next = 15;
                            return _CustomerActions2.default.createAddress(user, address, true);

                        case 15:
                            _context4.next = 20;
                            break;

                        case 17:
                            address = addresses.find(function (x) {
                                return x.id === selectedAddress;
                            });
                            _context4.next = 20;
                            return _CustomerActions2.default.updateAddress(user, address, true);

                        case 20:
                            _context4.next = 25;
                            break;

                        case 22:
                            _address = addresses.find(function (x) {
                                return x.id === selectedAddress;
                            });
                            _context4.next = 25;
                            return _CustomerActions2.default.updateAddress(user, _address, true);

                        case 25:
                            if (preferenceCentre) {
                                _context4.next = 28;
                                break;
                            }

                            _context4.next = 28;
                            return _DelayRepayActions2.default.subscribe(user, notifyByPreference);

                        case 28:
                            _TrackingActions2.default.userOptedIn(optedInFrom);
                            setStep(step + 1);
                            _context4.next = 35;
                            break;

                        case 32:
                            _context4.prev = 32;
                            _context4.t0 = _context4['catch'](9);

                            console.warn('error subscribing user to OCDR', _context4.t0);

                        case 35:
                            _context4.next = 38;
                            break;

                        case 37:
                            if (step === 1) {
                                if (paymentInfoSet) {
                                    setStep(step + 1);
                                }
                            } else {
                                setStep(step + 1);
                            }

                        case 38:
                            _context4.next = 43;
                            break;

                        case 40:
                            setStep(0);
                            handleClose();

                            if (shouldRedirectToAccountScreen) {
                                query = {
                                    shouldOpenAddJourneyModal: true
                                };

                                router.push(_urls2.default.location(_AppConstants.AccountPages.ONE_CLICK_DELAY_REPAY, {}, query));
                            } else {
                                setIsJourneyCardModalOpen(true);
                            }

                        case 43:
                            if (!(preferenceCentre && step === 3)) {
                                _context4.next = 47;
                                break;
                            }

                            _context4.next = 46;
                            return _DelayRepayActions2.default.subscribe(user, notifyByPreference);

                        case 46:
                            router.push(_urls2.default.location(_AppConstants.AccountPages.ONE_CLICK_DELAY_REPAY, {}, { accountPreferenceCentre: true }));

                        case 47:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined, [[9, 32]]);
        }));

        return function handleContinue() {
            return _ref5.apply(this, arguments);
        };
    }();

    var BackButton = _react2.default.createElement(
        _Button2.default,
        {
            className: 'back-button margin-left--xs margin-top--0',
            onClick: function onClick() {
                return setStep(step - 1);
            }
        },
        '\u276E',
        _react2.default.createElement(
            'span',
            { className: 'back-button-text' },
            (0, _I18n2.default)('auto-dr.subscribe.back')
        )
    );

    var paymentSection = function paymentSection() {
        switch (step) {
            case 0:
                return _react2.default.createElement(_NotifyBy2.default, {
                    notifyByPreference: notifyByPreference,
                    setNotifyByPreference: setNotifyByPreference,
                    hasPushNotifications: hasPushNotifications
                });
            case 1:
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    BackButton,
                    _react2.default.createElement(_SelectPaymentMethod2.default, {
                        form: form,
                        handleFormChange: handleFormChange,
                        showPaymentForm: showPaymentForm,
                        setShowPaymentForm: setShowPaymentForm,
                        paymentInfo: paymentInfo,
                        isValidBACS: handleIsValidBACS
                    })
                );
            case 2:
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    BackButton,
                    _react2.default.createElement(_SelectAddress2.default, {
                        addresses: addresses,
                        addressForm: addressForm,
                        setAddressForm: setAddressForm,
                        addNewAddress: addNewAddress,
                        selectedAddress: selectedAddress,
                        setSelectedAddress: setSelectedAddress,
                        setAddNewAddress: setAddNewAddress,
                        onChange: onChange,
                        user: user
                    })
                );
            case 3:
                return _react2.default.createElement(_Success2.default, null);
            default:
                return null;
        }
    };

    var disableContinue = step === 1 && (showPaymentForm && !form.isComplete() || !form.method || !isBankDetailsVerified) || form.method === _AppConstants.oneClickDelayRepayReimbursementMethods.CHARITY && !form.charity || step === 2 && (!addNewAddress && !selectedAddress || addNewAddress && typeof selectedAddress !== 'number' && !addressForm.isComplete());

    (0, _react.useEffect)(function () {
        var fetchUserPushNotificationPreferences = function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                var preferences;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _PushNotificationActions2.default.getPreference(user);

                            case 2:
                                preferences = _context5.sent;

                                if (preferences) {
                                    setHasPushNotifications(preferences.length > 0);
                                }

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            return function fetchUserPushNotificationPreferences() {
                return _ref6.apply(this, arguments);
            };
        }();

        if (location.query.paymentConfirmation || location.query.accountPreferenceCentre) {
            setIsJourneyCardModalOpen(true);
        }

        if (isLoggedIn) {
            (0, _defer3.default)(function () {
                return fetchUserPushNotificationPreferences();
            });
            (0, _defer3.default)(_CustomerActions2.default.loadAddresses, user);
        }
        // eslint-disable-next-line
    }, []);

    var successText = (0, _I18n2.default)('auto-dr.subscribe.continue');

    if (paymentConfirmation && step === 3 && isTabletWidth) {
        successText = (0, _I18n2.default)('auto-dr.subscribe.modal-close');
    } else if (step === 3 && !paymentConfirmation) {
        successText = (0, _I18n2.default)('auto-dr.subscribe.add-journey');
    }

    return _react2.default.createElement(
        _BaseModal2.default,
        (0, _extends3.default)({}, props, {
            className: 'modal--med',
            show: modalOpen,
            onClose: closeModal,
            disableContinue: disableContinue,
            onContinue: handleContinue,
            closeText: 'auto-dr.subscribe.modal-close',
            titleText: 'auto-dr.subscribe.modal-title',
            hideHeader: step === 3,
            continueText: successText,
            hideContinue: paymentConfirmation && step === 3 && !isTabletWidth
        }),
        _react2.default.createElement(
            'section',
            { className: 'text-left' },
            paymentSection()
        ),
        !isBankDetailsVerified && form.method === "bacs" && _react2.default.createElement(
            _Col2.default,
            { xs: 12, className: 'margin-bottom--sm' },
            _react2.default.createElement(
                _BAlert2.default,
                { type: _BAlert.bAlertType.DANGER },
                (0, _I18n2.default)('auto-dr.subscribe.bacs-error')
            )
        ),
        hasReimbursementErrors && _react2.default.createElement(
            _Col2.default,
            { xs: 12, className: 'margin-bottom--sm' },
            _react2.default.createElement(
                _BAlert2.default,
                { type: _BAlert.bAlertType.DANGER },
                (0, _I18n2.default)('auto-dr.account.repayment.method.error')
            )
        )
    );
};

exports.SubscribeDelayRepay = SubscribeDelayRepay;
SubscribeDelayRepay.propTypes = {
    handleClose: _propTypes2.default.func,
    setIsJourneyCardModalOpen: _propTypes2.default.func,
    modalOpen: _propTypes2.default.bool,
    user: _propTypes2.default.obj,
    optedInFrom: _propTypes2.default.string,
    shouldRedirectToAccountScreen: _propTypes2.default.bool,
    preferenceCentre: _propTypes2.default.bool,
    paymentConfirmation: _propTypes2.default.bool,
    isTabletWidth: _propTypes2.default.bool
};

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _class, _temp2;

var _immutable = __webpack_require__(5);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(645);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _I18n = __webpack_require__(9);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _Trip = __webpack_require__(442);

var _Trip2 = _interopRequireDefault(_Trip);

var _Trip3 = __webpack_require__(2073);

var _Trip4 = _interopRequireDefault(_Trip3);

var _SeasonTrip = __webpack_require__(944);

var _SeasonTrip2 = _interopRequireDefault(_SeasonTrip);

var _FareOnlyTrip = __webpack_require__(2077);

var _FareOnlyTrip2 = _interopRequireDefault(_FareOnlyTrip);

var _EmptyBasket = __webpack_require__(2078);

var _EmptyBasket2 = _interopRequireDefault(_EmptyBasket);

var _PaymentInformation = __webpack_require__(2079);

var _PaymentInformation2 = _interopRequireDefault(_PaymentInformation);

var _RefundInformation = __webpack_require__(2082);

var _RefundInformation2 = _interopRequireDefault(_RefundInformation);

var _Totals = __webpack_require__(1168);

var _Totals2 = _interopRequireDefault(_Totals);

var _DeliveryInformation = __webpack_require__(1169);

var _DeliveryInformation2 = _interopRequireDefault(_DeliveryInformation);

var _TransactionFrame = __webpack_require__(2091);

var _TransactionFrame2 = _interopRequireDefault(_TransactionFrame);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _RewardPointsInformation = __webpack_require__(1175);

var _RewardPointsInformation2 = _interopRequireDefault(_RewardPointsInformation);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _Changeovers = __webpack_require__(2092);

var _Changeovers2 = _interopRequireDefault(_Changeovers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderSummary = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(OrderSummary, _React$PureComponent);

    function OrderSummary() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OrderSummary);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.brand = _config2.default.get('brand'), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    OrderSummary.prototype._goBackToJourneyPlanner = function _goBackToJourneyPlanner() {
        _TrackingActions2.default.addAnotherJourneyOnBasketModal("add-another-journey");
        _ModalActions2.default.close(_AppConstants.GlobalModals.BASKET);
    };

    OrderSummary.prototype._renderTrips = function _renderTrips() {
        var _props = this.props,
            order = _props.order,
            isLocked = _props.isLocked,
            isLoggedIn = _props.isLoggedIn,
            refundDetails = _props.refundDetails,
            storedRefundCalculations = _props.storedRefundCalculations,
            context = _props.context,
            timetableAlerts = _props.timetableAlerts,
            setBasketChanged = _props.setBasketChanged,
            pendingTravelAssistRequests = _props.pendingTravelAssistRequests;


        var trips = order.hasChangeoverTickets() ? order.getChangeoverTrips() : order.trips;

        //sort by filtering the amended tickets with mapping out the new trips which ids correspond to amendedTicket ids
        return trips.sortBy(function (trip) {
            return trip.getJourneyFares().flatMap(function (fare) {
                return fare.tickets.filter(function (ticket) {
                    return order.isNewTicket(ticket.id);
                }).map(function (ticket) {
                    return order.getOldFareFromNewTicketId(ticket.id);
                });
            }).count();
        }).reverse().map(function (orderTrip, index) {
            var matchingTimetableAlert = null;
            var hasMatchingPAJourney = false;

            var _orderTrip$fares = orderTrip.fares,
                outwardSingle = _orderTrip$fares.outwardSingle,
                returnFare = _orderTrip$fares.return;


            var orderJourney = null;

            if (outwardSingle) {
                orderJourney = outwardSingle.outwardJourney;
            } else if (returnFare) {
                orderJourney = returnFare.outwardJourney;
            }

            var orderJourneyLegs = orderJourney && orderJourney.legs;

            if (_FeatureFlagStore2.default.get('enableTimetableAlertsWidget') && orderJourney) {
                var trainLegs = orderJourneyLegs.filter(function (l) {
                    return l.mode === _AppConstants.TransitModes.TRAIN;
                });

                // if all train UIDs on the orderJourney match the train UIDs from the JP journey, match
                matchingTimetableAlert = timetableAlerts.find(function (timetableAlert) {
                    var sortedLegs = trainLegs.map(function (l) {
                        return l.tuid;
                    }).toJS() && trainLegs.map(function (l) {
                        return l.tuid;
                    }).toJS().sort();

                    var outwardTrainIds = timetableAlert.get('outwardTrainIds') && timetableAlert.get('outwardTrainIds').toJS();
                    var inwardTrainIds = timetableAlert.get('inwardTrainIds') && timetableAlert.get('inwardTrainIds').toJS();

                    return (0, _isEqual3.default)(outwardTrainIds && outwardTrainIds.sort(), sortedLegs) || (0, _isEqual3.default)(inwardTrainIds && inwardTrainIds.sort(), sortedLegs);
                });
            }

            if (_FeatureFlagStore2.default.get('enablePassengerAssist') && orderJourney) {
                var matchingRequest = null;

                if (pendingTravelAssistRequests) {
                    matchingRequest = pendingTravelAssistRequests.find(function (req) {
                        return req.orderTripId === orderTrip.id;
                    });
                }

                var _ref = matchingRequest || {},
                    outwardEnabled = _ref.outwardEnabled,
                    returnEnabled = _ref.returnEnabled;

                if (outwardSingle) {
                    hasMatchingPAJourney = outwardEnabled;
                } else if (returnFare) {
                    hasMatchingPAJourney = returnEnabled;
                }
            }

            var sharedProps = {
                key: index,
                index: index,
                order: order,
                orderTrip: orderTrip,
                refundDetails: refundDetails,
                isLocked: isLocked,
                isLoggedIn: isLoggedIn,
                open: order.isPaid(),
                storedRefundCalculations: storedRefundCalculations,
                context: context,
                setBasketChanged: setBasketChanged,
                hasMatchingPAJourney: hasMatchingPAJourney
            };

            if (orderTrip.hasSeasonFare()) {
                return _react2.default.createElement(_SeasonTrip2.default, sharedProps);
            }
            if (orderTrip.hasRoversRangersFare()) {
                return _react2.default.createElement(_Trip4.default, sharedProps);
            }
            if (orderTrip.hasFareOnlyFare()) {
                return _react2.default.createElement(_FareOnlyTrip2.default, sharedProps);
            }

            return _react2.default.createElement(_Trip2.default, (0, _extends3.default)({}, sharedProps, { matchingTimetableAlert: matchingTimetableAlert }));
        });
    };

    OrderSummary.prototype._renderDelayRepayInfo = function _renderDelayRepayInfo() {
        return _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableBookingConfirmationDelayRepayInfo' },
            _react2.default.createElement(
                'div',
                { className: 'box--light box--rounded bg--white margin-bottom--sm margin-top--sm' },
                _react2.default.createElement(
                    'div',
                    { className: 'order-summary__delay-repay-info margin-top--sm margin-bottom--sm text-weight--normal' },
                    this.brand === 'southeastern' && _react2.default.createElement(
                        'p',
                        null,
                        (0, _I18n.translate)('confirmation.delayRepayInfo.сarbonFootprintCalculator'),
                        _react2.default.createElement(_ExternalLink2.default, {
                            message: (0, _I18n.translate)('confirmation.delayRepayInfo.сarbonFootprintCalculator.link'),
                            href: 'https://www.southeasternrailway.co.uk/environment'
                        })
                    ),
                    _react2.default.createElement(
                        'h3',
                        { className: 'text-primary text-weight--normal' },
                        (0, _I18n.translate)('confirmation.delayRepayInfo.title')
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        (0, _I18n.translate)('confirmation.delayRepayInfo.message')
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_ExternalLink2.default, {
                            message: (0, _I18n.translate)('confirmation.delayRepayInfo.link'),
                            href: 'https://' + _config2.default.get('delayRepayHost') + '/'
                        })
                    )
                )
            )
        );
    };

    OrderSummary.prototype.render = function render() {
        var _props2 = this.props,
            order = _props2.order,
            refundDetails = _props2.refundDetails,
            showHeader = _props2.showHeader,
            isLoggedIn = _props2.isLoggedIn,
            isInApp = _props2.isInApp,
            adminFee = _props2.adminFee,
            storedRefundCalculations = _props2.storedRefundCalculations,
            context = _props2.context;

        var isFullRefund = (0, _get3.default)(refundDetails, 'isFullRefund');

        if (order.isEmpty()) {
            return _react2.default.createElement(_EmptyBasket2.default, null);
        }

        return _react2.default.createElement(
            'section',
            null,
            refundDetails && order.hasRefunds() && _react2.default.createElement(
                'div',
                { className: 'box-headed__body box--padded margin-bottom--sm' },
                (0, _I18n.translate)('account.orders.' + (refundDetails.isFullRefund ? 'refunded' : 'partialRefund'))
            ),
            _react2.default.createElement(
                'div',
                { className: 'box--light box--rounded bg--white margin-bottom--sm margin-top' },
                showHeader ? _react2.default.createElement(
                    'div',
                    { className: 'margin-bottom--sm hidden-print' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'header--h1 border--bottom padding-bottom--sm text-center' },
                        (0, _I18n.translate)('order.summary.heading')
                    )
                ) : "",
                _react2.default.createElement(
                    'div',
                    { className: 'order-summary__total hidden-print' },
                    !isFullRefund && _react2.default.createElement(_DeliveryInformation2.default, { order: order, isLoggedIn: isLoggedIn }),
                    _react2.default.createElement(_PaymentInformation2.default, { order: order }),
                    _react2.default.createElement(_RefundInformation2.default, { isFullRefund: isFullRefund, refund: refundDetails })
                ),
                _react2.default.createElement(_Totals2.default, {
                    order: order,
                    refund: refundDetails,
                    adminFee: adminFee
                })
            ),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableRewardPoints' },
                context !== _AppConstants.OrderSummaryContexts.PAYMENT_CONFIRMATION && context !== _AppConstants.OrderSummaryContexts.BASKET_MODAL && _react2.default.createElement(
                    'div',
                    { className: 'box--light box--rounded bg--white margin-bottom--sm margin-top padding--horiz-md padding--vert-sm' },
                    _react2.default.createElement(_RewardPointsInformation2.default, { paidOrder: order })
                )
            ),
            _react2.default.createElement(
                'ul',
                { className: 'order-summary__list list-unstyled' },
                this._renderTrips()
            ),
            _react2.default.createElement(_Changeovers2.default, { order: order }),
            _react2.default.createElement(
                'div',
                { className: 'box--light box--rounded bg--white margin-bottom--sm margin-top--sm' },
                _react2.default.createElement(_Totals2.default, {
                    order: order,
                    refund: refundDetails,
                    adminFee: adminFee,
                    storedRefundCalculations: storedRefundCalculations
                })
            ),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableNREHandoffLogging' },
                _react2.default.createElement(_TransactionFrame2.default, { order: order })
            ),
            order.isPaid() && this._renderDelayRepayInfo(),
            !isInApp ? _react2.default.createElement(
                'div',
                { className: 'order-summary__button-container' },
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/search', tabIndex: '-1' },
                    _react2.default.createElement(
                        'button',
                        {
                            onClick: this._goBackToJourneyPlanner,
                            className: 'action-btn action-btn--secondary-bold--icon action-btn--secondary-bold'
                        },
                        _react2.default.createElement('i', { className: 'otrl otrl-add' }),
                        (0, _I18n.translate)('button.text.addjourney')
                    )
                )
            ) : null
        );
    };

    return OrderSummary;
}(_react2.default.PureComponent), _class.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    refundDetails: _propTypes2.default.instanceOf(_Order2.default),
    storedRefundCalculations: _propTypes2.default.instanceOf(_immutable.List),
    showHeader: _propTypes2.default.bool,
    isLocked: _propTypes2.default.bool,
    isLoggedIn: _propTypes2.default.bool,
    isInApp: _propTypes2.default.bool,
    adminFee: _propTypes2.default.number,
    context: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.OrderSummaryContexts)),
    timetableAlerts: _propTypes2.default.array,
    setBasketChanged: _propTypes2.default.func
}, _class.defaultProps = {
    storedRefundCalculations: new _immutable.List(),
    showHeader: true,
    isLocked: false,
    isLoggedIn: false,
    isInApp: false,
    context: null,
    timetableAlerts: [],
    setBasketChanged: _noop3.default
}, _temp2);
exports.default = OrderSummary;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

var _NotifyBy = __webpack_require__(933);

var _NotifyBy2 = _interopRequireDefault(_NotifyBy);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PushNotificationActions = __webpack_require__(660);

var _PushNotificationActions2 = _interopRequireDefault(_PushNotificationActions);

var _DelayRepayActions = __webpack_require__(646);

var _DelayRepayActions2 = _interopRequireDefault(_DelayRepayActions);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _AppConstants = __webpack_require__(6);

var _DisruptionAlertService = __webpack_require__(456);

var _DisruptionAlertService2 = _interopRequireDefault(_DisruptionAlertService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPreferences = function NotificationPreferences(_ref) {
    var user = _ref.user,
        preferenceCentre = _ref.preferenceCentre,
        isDDM = _ref.isDDM,
        isOCDR = _ref.isOCDR,
        notificationPreferencesModalOpen = _ref.notificationPreferencesModalOpen,
        hideSummary = _ref.hideSummary,
        defaultNotificationPreference = _ref.defaultNotificationPreference,
        disableCloseWithoutChoosingPreference = _ref.disableCloseWithoutChoosingPreference,
        onContinueAction = _ref.onContinueAction;

    var _useState = (0, _react.useState)(notificationPreferencesModalOpen),
        isNotificationPreferencesModalOpen = _useState[0],
        setIsNotificationPreferencesModalOpen = _useState[1];

    var _useState2 = (0, _react.useState)(defaultNotificationPreference),
        notifyByPreference = _useState2[0],
        setNotifyByPreference = _useState2[1];

    var _useState3 = (0, _react.useState)(null),
        notifyByPreferenceNew = _useState3[0],
        setNotifyByPreferenceNew = _useState3[1];

    var _useState4 = (0, _react.useState)(false),
        hasPushNotifications = _useState4[0],
        setHasPushNotifications = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        isSaving = _useState5[0],
        setIsSaving = _useState5[1];

    var closeModal = function closeModal(prefChosen) {
        if (disableCloseWithoutChoosingPreference && !prefChosen) {
            return false;
        }
        setNotifyByPreferenceNew(null);
        setIsNotificationPreferencesModalOpen(false);

        if (onContinueAction) {
            onContinueAction();
        }

        return true;
    };

    var handleContinue = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var chosenPreference, chosenPreferences;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            chosenPreference = notifyByPreferenceNew || defaultNotificationPreference;

                            if (!chosenPreference) {
                                _context.next = 14;
                                break;
                            }

                            setIsSaving(true);

                            if (!isOCDR) {
                                _context.next = 9;
                                break;
                            }

                            _context.next = 6;
                            return _DelayRepayActions2.default.subscribe(user, chosenPreference);

                        case 6:
                            _TrackingActions2.default.amendNotificationPreference();
                            _context.next = 13;
                            break;

                        case 9:
                            chosenPreferences = null;


                            if (chosenPreference === _AppConstants.notificationPreferences.APP_AND_EMAIL) {
                                chosenPreferences = { "isEmailNotification": true, "isCloudMessageNotification": true };
                            } else if (chosenPreference === _AppConstants.notificationPreferences.APP) {
                                chosenPreferences = { "isEmailNotification": false, "isCloudMessageNotification": true };
                            } else {
                                chosenPreferences = { "isEmailNotification": true, "isCloudMessageNotification": false };
                            }

                            _context.next = 13;
                            return _DisruptionAlertService2.default.setPreferences(user.id, chosenPreferences);

                        case 13:

                            setIsSaving(false);

                        case 14:
                            closeModal(true);

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function handleContinue() {
            return _ref2.apply(this, arguments);
        };
    }();

    var customer = user && user.customer || {};
    var autoDelayRepayApp = void 0,
        autoDelayRepayEmail = void 0;
    if (customer && customer.preferences) {
        autoDelayRepayApp = customer.preferences.autoDelayRepayApp;
        autoDelayRepayEmail = customer.preferences.autoDelayRepayEmail;
    }

    (0, _react.useEffect)(function () {
        var fetchUserPushNotificationPreferences = function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var preferences;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _PushNotificationActions2.default.getPreference(user);

                            case 2:
                                preferences = _context2.sent;

                                if (preferences) {
                                    setHasPushNotifications(preferences.length > 0);
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            return function fetchUserPushNotificationPreferences() {
                return _ref3.apply(this, arguments);
            };
        }();

        var fetchUserDDMPreferences = function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var preferences, isEmailNotification, isCloudMessageNotification;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _DisruptionAlertService2.default.getPreferences(user.id);

                            case 2:
                                preferences = _context3.sent;
                                isEmailNotification = preferences.isEmailNotification, isCloudMessageNotification = preferences.isCloudMessageNotification;


                                if (isEmailNotification && isCloudMessageNotification) {
                                    setNotifyByPreference(_AppConstants.notificationPreferences.APP_AND_EMAIL);
                                } else if (isEmailNotification) {
                                    setNotifyByPreference(_AppConstants.notificationPreferences.EMAIL);
                                } else if (isCloudMessageNotification) {
                                    setNotifyByPreference(_AppConstants.notificationPreferences.APP);
                                }

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            return function fetchUserDDMPreferences() {
                return _ref4.apply(this, arguments);
            };
        }();

        if (user && user.customer) {
            (0, _defer3.default)(function () {
                return fetchUserPushNotificationPreferences();
            });
            if (isDDM) {
                (0, _defer3.default)(function () {
                    return fetchUserDDMPreferences();
                });
            }
        }

        if (isOCDR) {
            if (autoDelayRepayApp && autoDelayRepayEmail) {
                setNotifyByPreference(_AppConstants.notificationPreferences.APP_AND_EMAIL);
            } else if (autoDelayRepayApp) {
                setNotifyByPreference(_AppConstants.notificationPreferences.APP);
            } else if (autoDelayRepayEmail) {
                setNotifyByPreference(_AppConstants.notificationPreferences.EMAIL);
            }
        }
    }, [autoDelayRepayApp, autoDelayRepayEmail, user, isDDM, isOCDR, notifyByPreferenceNew]);

    var notifyByPreferenceText = null;

    if (notifyByPreference === _AppConstants.notificationPreferences.APP_AND_EMAIL) {
        notifyByPreferenceText = 'app and email';
    } else if (notifyByPreference === _AppConstants.notificationPreferences.APP) {
        notifyByPreferenceText = 'app';
    } else if (notifyByPreference === _AppConstants.notificationPreferences.EMAIL) {
        notifyByPreferenceText = 'email';
    }

    return _react2.default.createElement(
        'div',
        { className: hideSummary ? "" : "border--bottom" },
        !hideSummary && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'preference-centre-subscribe__text' },
                notifyByPreference ? _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n2.default)('preference-centre.subscribe.preference.text', { notifyByPreferenceText: notifyByPreferenceText }),
                    (notifyByPreference === _AppConstants.notificationPreferences.APP_AND_EMAIL || notifyByPreference === _AppConstants.notificationPreferences.EMAIL) && (0, _I18n2.default)('preference-centre.subscribe.preference.to', { userEmail: user.email })
                ) : _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n2.default)('preference-centre.subscribe.preference.noPrefSet')
                )
            ),
            _react2.default.createElement(
                _reactBootstrap.Button,
                {
                    bsStyle: 'link',
                    className: 'adr-edit-address-btn margin-bottom--sm',
                    onClick: function onClick() {
                        return setIsNotificationPreferencesModalOpen(true);
                    }
                },
                _react2.default.createElement(_Icon2.default, { className: 'adr-edit-address-btn-icon', icon: 'pen' }),
                (0, _I18n2.default)(preferenceCentre ? 'preference-centre.subscribe.preference.edit.button' : 'notification-settings.edit.button')
            )
        ),
        isNotificationPreferencesModalOpen && _react2.default.createElement(
            _BaseModal2.default,
            {
                className: 'modal--med',
                show: isNotificationPreferencesModalOpen,
                onClose: function onClose() {
                    return closeModal();
                },
                disableContinue: false,
                disableClose: disableCloseWithoutChoosingPreference,
                onContinue: handleContinue,
                closeText: 'auto-dr.subscribe.modal-close',
                titleText: 'auto-dr.account.notifications.modal.title',
                continueText: 'Confirm'
            },
            _react2.default.createElement(
                'section',
                { className: 'text-left' },
                isSaving ? _react2.default.createElement(_Loading2.default, {
                    message: (0, _I18n2.default)('preference-centre.subscribe.preference.updating'),
                    unwrapped: true,
                    standalone: true
                }) : _react2.default.createElement(_NotifyBy2.default, {
                    notifyByPreference: notifyByPreferenceNew || notifyByPreference,
                    setNotifyByPreference: setNotifyByPreferenceNew,
                    hasPushNotifications: hasPushNotifications,
                    isDDM: isDDM,
                    isOCDR: isOCDR
                })
            )
        )
    );
};

NotificationPreferences.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default),
    preferenceCentre: _propTypes2.default.bool,
    isDDM: _propTypes2.default.bool,
    isOCDR: _propTypes2.default.bool,
    notificationPreferencesModalOpen: _propTypes2.default.bool,
    hideSummary: _propTypes2.default.bool,
    defaultNotificationPreference: _propTypes2.default.string,
    disableCloseWithoutChoosingPreference: _propTypes2.default.bool,
    onContinueAction: _propTypes2.default.func
};

exports.default = NotificationPreferences;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _slugify = __webpack_require__(626);

var _slugify2 = _interopRequireDefault(_slugify);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _BraintreeCardPayment = __webpack_require__(670);

var _BraintreeCardPayment2 = _interopRequireDefault(_BraintreeCardPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BraintreePaymentCardDetails(_ref) {
    var highDefinition = _ref.highDefinition,
        card = _ref.payment,
        mask = _ref.mask;
    var pan = card.cardPan;

    var cardType = card.cardType || '';

    var cardTypeSlug = (0, _slugify2.default)(cardType.toLowerCase());

    var highDefImageArt = _react2.default.createElement('img', { className: 'pan-hd__image', src: _Assets2.default.assetUrl('images/card-hd-' + cardTypeSlug + '.png'), alt: cardType });
    var cardNumber = void 0;

    if (mask) {
        cardNumber = pan && '**** **** **** ' + pan.substring(pan.length - 4);
    } else {
        cardNumber = pan && pan.split(/(....)/).join(' ').trim();
    }

    return highDefinition ? _react2.default.createElement(
        'div',
        null,
        highDefImageArt,
        _react2.default.createElement(
            'div',
            { className: 'pan-hd__details' },
            cardNumber
        )
    ) : _react2.default.createElement(
        'div',
        null,
        cardNumber
    );
}

BraintreePaymentCardDetails.propTypes = {
    highDefinition: _propTypes2.default.bool,
    payment: _propTypes2.default.instanceOf(_BraintreeCardPayment2.default).isRequired,
    mask: _propTypes2.default.bool
};

BraintreePaymentCardDetails.defaultProps = {
    highDefinition: true,
    mask: true
};

exports.default = BraintreePaymentCardDetails;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(1074),
    upperFirst = __webpack_require__(831);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isNull2 = __webpack_require__(451);

var _isNull3 = _interopRequireDefault(_isNull2);

var _omitBy2 = __webpack_require__(1090);

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    email: null,
    firstNames: null,
    surname: null,
    title: null,
    confirmemail: null,
    password: null,
    newPassword: null,
    telephoneNumber: null,
    changeEmail: false,
    changePassword: false,
    changePhone: false,
    changeName: false
};

var CustomerUserChange = function (_record) {
    (0, _inherits3.default)(CustomerUserChange, _record);

    function CustomerUserChange() {
        (0, _classCallCheck3.default)(this, CustomerUserChange);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CustomerUserChange.prototype.getSchema = function getSchema() {
        return {
            email: _joi2.default.alternatives().when('changeEmail', {
                is: true,
                then: _validation2.default.email(),
                otherwise: _joi2.default.any()
            }),
            confirmemail: _joi2.default.alternatives().when('changeEmail', {
                is: true,
                then: _validation2.default.confirmEmail(),
                otherwise: _joi2.default.any()
            }),

            password: _joi2.default.alternatives().when('changePassword', {
                is: true,
                then: _validation2.default.passwordEntry(),
                otherwise: _joi2.default.any()
            }),

            newPassword: _joi2.default.alternatives().when('changePassword', {
                is: true,
                then: _validation2.default.passwordCreate().required(),
                otherwise: _joi2.default.any()
            }),

            telephoneNumber: _joi2.default.alternatives().when('changePhone', {
                is: true,
                then: _validation2.default.phone().allow('', null),
                otherwise: _joi2.default.any()
            }),

            firstNames: _joi2.default.alternatives().when('changeName', {
                is: true,
                then: _validation2.default.name(2, 50),
                otherwise: _joi2.default.any()
            }),

            surname: _joi2.default.alternatives().when('changeName', {
                is: true,
                then: _validation2.default.name(2, 50),
                otherwise: _joi2.default.any()
            }),

            title: _joi2.default.alternatives().when('changeName', {
                is: true,
                then: _validation2.default.title(),
                otherwise: _joi2.default.any()
            })
        };
    };

    CustomerUserChange.prototype.hasChanges = function hasChanges() {
        return this.changeEmail || this.changePassword || this.changePhone || this.changeName;
    };

    (0, _createClass3.default)(CustomerUserChange, [{
        key: 'changes',
        get: function get() {
            return (0, _omitBy3.default)({
                email: this.changeEmail ? this.email : null,
                password: this.changePassword ? this.newPassword : null,
                telephoneNumber: this.changePhone ? this.telephoneNumber : null,
                firstNames: this.changeName ? this.firstNames : null,
                surname: this.changeName ? this.surname : null,
                title: this.changeName ? this.title : null
            }, _isNull3.default);
        }
    }]);
    return CustomerUserChange;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(CustomerUserChange.prototype, _ValidationMixin2.default);

exports.default = CustomerUserChange;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(102),
    negate = __webpack_require__(673),
    pickBy = __webpack_require__(161);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _values = _interopRequireDefault(__webpack_require__(125));

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;

  _react.default.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */


    var element = _react.default.createElement(ProgressBar, null);

    if (child.type === element.type) return;
    var childIdentifier = _react.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });

  return error;
}

var propTypes = {
  min: _propTypes.default.number,
  now: _propTypes.default.number,
  max: _propTypes.default.number,
  label: _propTypes.default.node,
  srOnly: _propTypes.default.bool,
  striped: _propTypes.default.bool,
  active: _propTypes.default.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: _propTypes.default.bool
};
var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ProgressBar, _React$Component);

  function ProgressBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBar.prototype;

  _proto.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
      active: active
    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
      role: "progressbar",
      className: (0, _classnames.default)(className, classes),
      style: (0, _extends3.default)({
        width: getPercentage(now, min, max) + "%"
      }, style),
      "aria-valuenow": now,
      "aria-valuemin": min,
      "aria-valuemax": max
    }), srOnly ? _react.default.createElement("span", {
      className: "sr-only"
    }, label) : label);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isChild = _this$props.isChild,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["isChild"]);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);
    return _react.default.createElement("div", (0, _extends3.default)({}, wrapperProps, {
      className: (0, _classnames.default)(className, 'progress')
    }), children ? _ValidComponentChildren.default.map(children, function (child) {
      return (0, _react.cloneElement)(child, {
        isChild: true
      });
    }) : this.renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      srOnly: srOnly,
      striped: striped,
      active: active,
      bsClass: bsClass,
      bsStyle: bsStyle
    }));
  };

  return ProgressBar;
}(_react.default.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), ProgressBar));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(767),
    createBind = __webpack_require__(1476),
    createCurry = __webpack_require__(1477),
    createHybrid = __webpack_require__(769),
    createPartial = __webpack_require__(1490),
    getData = __webpack_require__(773),
    mergeData = __webpack_require__(1491),
    setData = __webpack_require__(775),
    setWrapToString = __webpack_require__(776),
    toInteger = __webpack_require__(200);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(220),
    castFunction = __webpack_require__(520);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmendStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _LocalStorage = __webpack_require__(316);

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

var _Request = __webpack_require__(1018);

var _Request2 = _interopRequireDefault(_Request);

var _Config = __webpack_require__(1019);

var _Config2 = _interopRequireDefault(_Config);

var _Trip = __webpack_require__(199);

var _Trip2 = _interopRequireDefault(_Trip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = 'amendConfig';
var CONFIG_TTL = 60 * 60;

var AmendStore = function (_BaseStore) {
    (0, _inherits3.default)(AmendStore, _BaseStore);

    function AmendStore() {
        (0, _classCallCheck3.default)(this, AmendStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    AmendStore.prototype.getInitialState = function getInitialState() {
        var config = _LocalStorage2.default.objectFromLocalStorage(STORAGE_KEY, _Config2.default);

        return new _immutable.Map({
            config: config,
            request: new _Request2.default(),
            currentTrip: null,
            tookPayment: true
        });
    };

    AmendStore.prototype.handleAuthFinished = function handleAuthFinished(_ref) {
        var order = _ref.order;

        var request = this.get('request');
        this.setState(this.state.set('request', request.setOrder(order)));
    };

    AmendStore.prototype.handleConfig = function handleConfig(_ref2) {
        var config = _ref2.config;

        _LocalStorage2.default.objectToLocalStorage(STORAGE_KEY, config, CONFIG_TTL);
        this.setState(this.state.set('config', config));
    };

    AmendStore.prototype.handleUpdated = function handleUpdated(_ref3) {
        var amendRequest = _ref3.amendRequest;

        this.setState(this.state.set('request', amendRequest));
    };

    AmendStore.prototype.handleSearchStarted = function handleSearchStarted(_ref4) {
        var search = _ref4.search;

        this.setState(this.state.set('currentTrip', new _Trip2.default({ search: search })));
    };

    AmendStore.prototype.handleSearchUpdated = function handleSearchUpdated(_ref5) {
        var search = _ref5.search;

        var trip = this.state.get('currentTrip');
        this.setState(this.state.set('currentTrip', trip.set('search', search)));
    };

    AmendStore.prototype.handleResultsUpdated = function handleResultsUpdated(_ref6) {
        var result = _ref6.result,
            tripDirection = _ref6.tripDirection;

        var trip = this.state.get('currentTrip');
        var nextTrip = trip.set('hasServiceProvider', result.hasServiceProvider).resetSelected(tripDirection);

        this.setState(this.state.set('currentTrip', nextTrip));
    };

    AmendStore.prototype.handleSearchFinished = function handleSearchFinished(_ref7) {
        var hasServiceProvider = _ref7.hasServiceProvider;

        var trip = this.state.get('currentTrip');
        var nextTrip = trip.set('hasServiceProvider', hasServiceProvider);

        this.setState(this.state.set('currentTrip', nextTrip));
    };

    AmendStore.prototype.handleInwardServiceSelected = function handleInwardServiceSelected(_ref8) {
        var service = _ref8.service;

        var trip = this.state.get('currentTrip');
        var nextTrip = trip.set('returnJourney', service).set('raw', false).setIn(['fares', 'returnSingle'], null);

        this.setState(this.state.set('currentTrip', nextTrip));
    };

    AmendStore.prototype.handleOutwardServiceSelected = function handleOutwardServiceSelected(_ref9) {
        var service = _ref9.service;

        var trip = this.state.get('currentTrip');
        var nextTrip = trip.set('outwardJourney', service).set('raw', false).resetFares();

        this.setState(this.state.set('currentTrip', nextTrip));
    };

    AmendStore.prototype.handleServiceSelected = function handleServiceSelected(_ref10) {
        var service = _ref10.service,
            direction = _ref10.direction;

        if (direction === _AppConstants.JourneyDirections.OUTWARD) {
            this.handleOutwardServiceSelected({ service: service });
        }

        if (direction === _AppConstants.JourneyDirections.INWARD) {
            this.handleInwardServiceSelected({ service: service });
        }
    };

    AmendStore.prototype.handleSelectFare = function handleSelectFare(_ref11) {
        var fare = _ref11.fare,
            direction = _ref11.direction,
            service = _ref11.service,
            fareCategory = _ref11.fareCategory,
            fareClass = _ref11.fareClass;

        var trip = this.state.get('currentTrip');
        var nextTrip = trip.set('fareCategory', fareCategory).set('fareClass', fareClass).setFareForDirection(direction, fare).setServiceForDirection(direction, service).setSeatingForDirection(direction, fare, service).set('raw', false);

        this.setState(this.state.set('currentTrip', nextTrip));
    };

    AmendStore.prototype.handleTripFinished = function handleTripFinished(_ref12) {
        var amendRequest = _ref12.amendRequest;

        this.handleUpdated({ amendRequest: amendRequest });
    };

    AmendStore.prototype.handlePlusBusSet = function handlePlusBusSet(_ref13) {
        var trip = _ref13.trip;

        this.setState(this.state.set('currentTrip', trip));
    };

    AmendStore.prototype.handleTookPayment = function handleTookPayment(_ref14) {
        var tookPayment = _ref14.tookPayment;

        this.setState(this.state.set('tookPayment', tookPayment));
    };

    AmendStore.prototype.cancel = function cancel() {
        this.resetState();
    };

    AmendStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref15;

        return _ref15 = {}, _ref15[_AppConstants.ActionTypes.AMEND_CONFIG_LOADED] = this.handleConfig, _ref15[_AppConstants.ActionTypes.AMEND_UPDATED] = this.handleUpdated, _ref15[_AppConstants.ActionTypes.AMEND_CANCELLED] = this.cancel, _ref15[_AppConstants.ActionTypes.AMEND_RESET] = this.resetState, _ref15[_AppConstants.ActionTypes.AMEND_PAYMENT_AUTH_FINISHED] = this.handleAuthFinished, _ref15[_AppConstants.ActionTypes.AMEND_SHOW_EARLIER_TRAINS_STARTED] = this.handleSearchUpdated, _ref15[_AppConstants.ActionTypes.AMEND_SHOW_LATER_TRAINS_STARTED] = this.handleSearchUpdated, _ref15[_AppConstants.ActionTypes.AMEND_SHOW_EARLIER_TRAINS_FINISHED] = this.handleResultsUpdated, _ref15[_AppConstants.ActionTypes.AMEND_SHOW_LATER_TRAINS_FINISHED] = this.handleResultsUpdated, _ref15[_AppConstants.ActionTypes.AMEND_SEARCH_FAILED] = this.handleSearchStarted, _ref15[_AppConstants.ActionTypes.AMEND_SEARCH_STARTED] = this.handleSearchStarted, _ref15[_AppConstants.ActionTypes.AMEND_SEARCH_LOADED] = this.handleSearchUpdated, _ref15[_AppConstants.ActionTypes.AMEND_SEARCH_UPDATED] = this.handleSearchUpdated, _ref15[_AppConstants.ActionTypes.AMEND_SEARCH_FINISHED] = this.handleSearchFinished, _ref15[_AppConstants.ActionTypes.AMEND_SERVICE_SELECTED] = this.handleServiceSelected, _ref15[_AppConstants.ActionTypes.AMEND_FARE_SELECTED] = this.handleSelectFare, _ref15[_AppConstants.ActionTypes.AMEND_TRIP_STARTED] = this.handleTripStarted, _ref15[_AppConstants.ActionTypes.AMEND_TRIP_FAILED] = this.handleTripFailed, _ref15[_AppConstants.ActionTypes.AMEND_TRIP_FINISHED] = this.handleTripFinished, _ref15[_AppConstants.ActionTypes.AMEND_SET_FINISHED] = this.handleSetFinished, _ref15[_AppConstants.ActionTypes.AMEND_PLUSBUS_SET] = this.handlePlusBusSet, _ref15[_AppConstants.ActionTypes.AMEND_TOOK_PAYMENT] = this.handleTookPayment, _ref15;
    };

    return AmendStore;
}(_BaseStore3.default);

var instance = new AmendStore();

exports.default = instance;
exports.AmendStore = AmendStore;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(102),
    baseSum = __webpack_require__(819);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    showStandard: true,
    showFirstClass: false,
    selection: _AppConstants.FareFilterSelections.CHEAPEST
};

var DisplayFilters = function (_record) {
    (0, _inherits3.default)(DisplayFilters, _record);

    function DisplayFilters() {
        (0, _classCallCheck3.default)(this, DisplayFilters);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DisplayFilters.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new DisplayFilters({
            showStandard: json.showStandard,
            showFirstClass: json.showFirstClass,
            selection: json.selection || _AppConstants.FareFilterSelections.CHEAPEST
        });
    };

    return DisplayFilters;
}((0, _immutable.Record)(defaults));

exports.default = DisplayFilters;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.BraintreeStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BraintreeStore = exports.BraintreeStore = function (_BaseStore) {
    (0, _inherits3.default)(BraintreeStore, _BaseStore);

    function BraintreeStore() {
        (0, _classCallCheck3.default)(this, BraintreeStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    BraintreeStore.prototype.getInitialState = function getInitialState() {
        return _BaseStore.prototype.getInitialState.call(this).merge({
            clientToken: null,
            paymentProcessing: false
        });
    };

    BraintreeStore.prototype.getClientToken = function getClientToken() {
        return this.get('clientToken');
    };

    BraintreeStore.prototype.getPaymentProcessing = function getPaymentProcessing() {
        return this.get('paymentProcessing');
    };

    BraintreeStore.prototype.handleToken = function handleToken(_ref) {
        var token = _ref.token;

        this.setState(this.state.set('clientToken', token));
    };

    BraintreeStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.BRAINTREE_CLIENT_TOKEN_LOADED] = this.handleToken, _ref2[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref2;
    };

    return BraintreeStore;
}(_BaseStore3.default);

var instance = new BraintreeStore();

exports.default = instance;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DigitSpinner(_ref) {
    var number = _ref.number;

    var string = number.toString();
    var output = [];

    for (var i = 0, len = string.length; i < len; i += 1) {
        if (isNaN(string.charAt(i))) {
            output.push(_react2.default.createElement(
                'span',
                { className: 'digit-spinner__character',
                    key: 'digit-spinner-' + i },
                string.charAt(i)
            ));
        } else {
            output.push(_react2.default.createElement(
                'span',
                { className: 'digit-spinner__digit digit-spinner__digit--animate',
                    key: 'digit-spinner-' + i,
                    'data-number': string.charAt(i) },
                _react2.default.createElement(
                    'span',
                    null,
                    '0'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '1'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '2'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '3'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '4'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '5'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '6'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '7'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '8'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '9'
                )
            ));
        }
    }

    return _react2.default.createElement(
        'span',
        { className: 'digit-spinner', 'aria-hidden': 'true' },
        output
    );
}

DigitSpinner.propTypes = {
    number: _propTypes2.default.string.isRequired
};

exports.default = DigitSpinner;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _Currency = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    basketTotal: 0,
    vouchersTotal: 0,
    maxVoucherAmount: 0,
    voucherAmount: '0',
    useVouchers: true
};

var VoucherForm = function (_record) {
    (0, _inherits3.default)(VoucherForm, _record);

    function VoucherForm() {
        (0, _classCallCheck3.default)(this, VoucherForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    VoucherForm.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new VoucherForm(json);
    };

    VoucherForm.prototype.getSchema = function getSchema() {
        return {
            voucherAmount: _validation2.default.voucherAmount((0, _Currency.toPounds)(this.maxVoucherAmount))
        };
    };

    VoucherForm.prototype.setVouchersTotal = function setVouchersTotal(vouchersTotal, preAuthedAmount) {
        return this._recalculate({ vouchersTotal: vouchersTotal, preAuthedAmount: preAuthedAmount });
    };

    VoucherForm.prototype.setBasketTotal = function setBasketTotal(basketTotal) {
        return this._recalculate({ basketTotal: basketTotal });
    };

    VoucherForm.prototype._recalculate = function _recalculate(_ref) {
        var _ref$vouchersTotal = _ref.vouchersTotal,
            vouchersTotal = _ref$vouchersTotal === undefined ? this.vouchersTotal : _ref$vouchersTotal,
            _ref$basketTotal = _ref.basketTotal,
            basketTotal = _ref$basketTotal === undefined ? this.basketTotal : _ref$basketTotal,
            _ref$preAuthedAmount = _ref.preAuthedAmount,
            preAuthedAmount = _ref$preAuthedAmount === undefined ? 0 : _ref$preAuthedAmount;

        var allVoucherTotal = vouchersTotal + preAuthedAmount;
        var maxVoucherAmount = Math.min(allVoucherTotal, basketTotal);

        var voucherAmountPence = this.voucherAmountPence || preAuthedAmount;
        var voucherTotalChanged = allVoucherTotal !== this.vouchersTotal;
        var voucherAmount = this.voucherAmount;

        if (preAuthedAmount && preAuthedAmount < allVoucherTotal) {
            voucherAmount = (0, _Currency.toPounds)(preAuthedAmount).toFixed(2);
        } else if (voucherAmountPence > maxVoucherAmount || !voucherAmountPence && voucherTotalChanged) {
            voucherAmount = (0, _Currency.toPounds)(maxVoucherAmount).toFixed(2);
        }

        return this.merge({
            basketTotal: basketTotal,
            vouchersTotal: allVoucherTotal,
            maxVoucherAmount: maxVoucherAmount,
            voucherAmount: voucherAmount
        });
    };

    (0, _createClass3.default)(VoucherForm, [{
        key: 'voucherAmountPence',
        get: function get() {
            return parseFloat((0, _Currency.toPence)(this.voucherAmount));
        }
    }]);
    return VoucherForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(VoucherForm.prototype, _ValidationMixin2.default);

exports.default = VoucherForm;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _LinkMapper = __webpack_require__(8);

var _ReservationRequestPassenger = __webpack_require__(1865);

var _ReservationRequestPassenger2 = _interopRequireDefault(_ReservationRequestPassenger);

var _ReservationJourney = __webpack_require__(657);

var _ReservationJourney2 = _interopRequireDefault(_ReservationJourney);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationRequest = new _immutable.Record({
    passengers: new _immutable.List(),
    outwardJourney: new _ReservationJourney2.default(),
    returnJourney: new _ReservationJourney2.default(),
    bikes: 0,
    requestSeats: false
});

(0, _assign2.default)(ReservationRequest.prototype, {
    toJSON: function toJSON() {
        return {
            passengers: this.passengers.toJS(),
            outwardJourney: this.outwardJourney.toJSON(),
            returnJourney: this.returnJourney.toJSON(),
            bikes: this.bikes
        };
    },
    formatForAPI: function formatForAPI() {
        var formatDateTime = function formatDateTime(dt) {
            return dt ? (0, _moment2.default)(dt).format(_AppConstants.API_ISO_FORMAT) : undefined;
        };

        var transformJourney = function transformJourney(journey) {
            return {
                origin: {
                    nlc: journey.origin.nlc,
                    name: journey.origin.name
                },
                destination: {
                    nlc: journey.destination.nlc,
                    name: journey.destination.name
                },
                ticketTypeCode: journey.ticketType,
                routeCode: journey.routeCode,
                reserve: true,
                legs: journey.legs.map(function (leg) {
                    return {
                        date: (0, _moment2.default)(leg.date).format('YYYY-MM-DD'),
                        retailServiceId: leg.retailServiceId,
                        origin: {
                            nlc: leg.origin.nlc,
                            name: leg.origin.name
                        },
                        destination: {
                            nlc: leg.destination.nlc,
                            name: leg.destination.name
                        },
                        departure: formatDateTime(leg.departure),
                        arrival: formatDateTime(leg.arrival),
                        reservable: leg.reservable,
                        operator: leg.operator,
                        mode: leg.mode
                    };
                })
            };
        };

        var formatted = (0, _extends3.default)({
            passengers: this.passengers.map(function (p) {
                return {
                    statusCode: p.statusCode,
                    attributes: p.attributes
                };
            })
        }, this.bikes > 0 ? { bikes: this.bikes } : {});

        if (this.outwardJourney) {
            formatted.outwardJourney = transformJourney(this.outwardJourney);
        }

        if (this.returnJourney && this.returnJourney.legs.size > 0) {
            formatted.returnJourney = transformJourney(this.returnJourney);
        }

        return formatted;
    }
});

ReservationRequest.fromJSON = function (json) {
    return (0, _LinkMapper.construct)(ReservationRequest, json, {
        passengers: _LinkMapper.resolveAll.as(_ReservationRequestPassenger2.default),
        outwardJourney: _LinkMapper.resolve.as(_ReservationJourney2.default),
        returnJourney: _LinkMapper.resolve.as(_ReservationJourney2.default),
        bikes: _LinkMapper.fields.number,
        requestSeats: _LinkMapper.fields.boolean
    });
};

exports.default = ReservationRequest;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _ReservationSeat = __webpack_require__(1866);

var _ReservationSeat2 = _interopRequireDefault(_ReservationSeat);

var _ReservationStation = __webpack_require__(878);

var _ReservationStation2 = _interopRequireDefault(_ReservationStation);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationLeg = new _immutable.Record({
    arrival: null,
    departure: null,
    origin: new _ReservationStation2.default(),
    destination: new _ReservationStation2.default(),
    retailServiceId: null,
    seats: new _immutable.List(),
    bikeSeats: new _immutable.List(),
    supplement: null,
    ticketType: null,
    seatReservation: null,
    bikeSeatReservation: null
});

(0, _assign2.default)(ReservationLeg.prototype, {
    getDepartureTime: function getDepartureTime() {
        return this.departure ? (0, _TrainTime2.default)(this.departure).format('HH:mm') : null;
    },
    getArrivalTime: function getArrivalTime() {
        return this.arrival ? (0, _TrainTime2.default)(this.arrival).format('HH:mm') : null;
    },
    getOriginName: function getOriginName() {
        return this.origin.name;
    },
    getDestinationName: function getDestinationName() {
        return this.destination.name;
    },
    isSeatReservationUnavailable: function isSeatReservationUnavailable() {
        return this.isSeatReservation() && this.seatReservation === _AppConstants.RESERVATION_NOT_POSSIBLE;
    },
    isSeatReservation: function isSeatReservation() {
        return this.seats.size > 0;
    },
    isBikeReservation: function isBikeReservation() {
        return this.bikeSeats.size > 0;
    }
});

ReservationLeg.fromJSON = function (json) {
    return (0, _LinkMapper.construct)(ReservationLeg, json, {
        arrival: _LinkMapper.fields.string,
        departure: _LinkMapper.fields.string,
        origin: _LinkMapper.resolve.as(_ReservationStation2.default),
        destination: _LinkMapper.resolve.as(_ReservationStation2.default),
        retailServiceId: _LinkMapper.fields.string,
        seats: _LinkMapper.resolveAll.as(_ReservationSeat2.default),
        bikeSeats: _LinkMapper.resolveAll.as(_ReservationSeat2.default),
        supplement: _LinkMapper.fields.string,
        ticketType: _LinkMapper.fields.string,
        seatReservation: _LinkMapper.fields.string,
        bikeSeatReservation: _LinkMapper.fields.string
    });
};

exports.default = ReservationLeg;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(315),
    baseForOwn = __webpack_require__(220),
    baseIteratee = __webpack_require__(102);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _lifecycle2 = __webpack_require__(1962);

var _lifecycle3 = _interopRequireDefault(_lifecycle2);

var _compose2 = __webpack_require__(612);

var _compose3 = _interopRequireDefault(_compose2);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _setWrappedDisplayName = __webpack_require__(1966);

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollComponent() {
    _reactDom2.default.findDOMNode(this).scrollIntoViewIfNeeded();
}

exports.default = (0, _compose3.default)((0, _setWrappedDisplayName2.default)('scrollComponentIntoView'), (0, _lifecycle3.default)({
    componentDidMount: scrollComponent,
    componentDidUpdate: scrollComponent
}));

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RegisterModal = exports.RegisterSteps = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _class2, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _a11y = __webpack_require__(918);

var _I18n = __webpack_require__(9);

var _Registration = __webpack_require__(355);

var _Registration2 = _interopRequireDefault(_Registration);

var _SmartcardRegistration = __webpack_require__(240);

var _SmartcardRegistration2 = _interopRequireDefault(_SmartcardRegistration);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _AmazonLoginActions = __webpack_require__(291);

var _AmazonLoginActions2 = _interopRequireDefault(_AmazonLoginActions);

var _AppConstants = __webpack_require__(6);

var _Customer = __webpack_require__(447);

var _Smartcard = __webpack_require__(336);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _ServiceUnavailable = __webpack_require__(922);

var _ExclamationIcon = __webpack_require__(1982);

var _ExclamationIcon2 = _interopRequireDefault(_ExclamationIcon);

var _TickIcon = __webpack_require__(658);

var _TickIcon2 = _interopRequireDefault(_TickIcon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

var _Email = __webpack_require__(1069);

var _Email2 = _interopRequireDefault(_Email);

var _Name = __webpack_require__(1047);

var _Name2 = _interopRequireDefault(_Name);

var _Password = __webpack_require__(419);

var _Password2 = _interopRequireDefault(_Password);

var _SignupOptions = __webpack_require__(1107);

var _SignupOptions2 = _interopRequireDefault(_SignupOptions);

var _RegisterHello = __webpack_require__(926);

var _RegisterHello2 = _interopRequireDefault(_RegisterHello);

var _RegisterSmartcard = __webpack_require__(659);

var _RegisterSmartcard2 = _interopRequireDefault(_RegisterSmartcard);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _FormComponent2 = __webpack_require__(417);

var _FormComponent3 = _interopRequireDefault(_FormComponent2);

var _RegisterSuccessModal = __webpack_require__(679);

var _RegisterSuccessModal2 = _interopRequireDefault(_RegisterSuccessModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _WayPointWrapper = __webpack_require__(2010);

var _WayPointWrapper2 = _interopRequireDefault(_WayPointWrapper);

var _RegisterModalFooter = __webpack_require__(2013);

var _RegisterModalFooter2 = _interopRequireDefault(_RegisterModalFooter);

var _RegisterModalHeader = __webpack_require__(2014);

var _RegisterModalHeader2 = _interopRequireDefault(_RegisterModalHeader);

var _OrBar = __webpack_require__(680);

var _OrBar2 = _interopRequireDefault(_OrBar);

var _AmazonLoginCTA = __webpack_require__(929);

var _AmazonLoginCTA2 = _interopRequireDefault(_AmazonLoginCTA);

var _StepsNavigation = __webpack_require__(2019);

var _StepsNavigation2 = _interopRequireDefault(_StepsNavigation);

var _StepDetail = __webpack_require__(2020);

var _StepDetail2 = _interopRequireDefault(_StepDetail);

var _DateOfBirth = __webpack_require__(919);

var _DateOfBirth2 = _interopRequireDefault(_DateOfBirth);

var _BrandUsps = __webpack_require__(2021);

var _BrandUsps2 = _interopRequireDefault(_BrandUsps);

var _subscribeDelayRepay = __webpack_require__(1084);

var _ConsentsStore = __webpack_require__(459);

var _ConsentsStore2 = _interopRequireDefault(_ConsentsStore);

var _ConsentsForm = __webpack_require__(354);

var _ConsentsForm2 = _interopRequireDefault(_ConsentsForm);

var _ConsentsActions = __webpack_require__(462);

var _ConsentsActions2 = _interopRequireDefault(_ConsentsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIEWPORT_BREAK_POINT_WIDTH = 992;

var REGISTER_NO_STEP_COMPLETED = 0;

var RegisterSteps = exports.RegisterSteps = {
    DETAILS: 1,
    SMARTCARD: 2,
    PREFERENCES: 3
};

var RegisterModal = exports.RegisterModal = (0, _withRouter2.default)(_class = (_temp2 = _class2 = function (_FormComponent) {
    (0, _inherits3.default)(RegisterModal, _FormComponent);

    function RegisterModal() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RegisterModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _FormComponent.call.apply(_FormComponent, [this].concat(args))), _this), _this.state = {
            amazonAccessToken: _this.props.amazonAccessToken,
            form: new _Registration2.default((0, _extends3.default)({
                email: _this.props.emailDefaultValue,
                referrer: _AppConstants.RegistrationReferrers.REGISTER_MODAL
            }, _this.props.customer, {
                isAmazonRegistration: !!_this.props.customer
            })),
            smartcard: new _SmartcardRegistration2.default({
                signup: _this.props.forceSmartcardSignup ? _AppConstants.SignupTypes.WITH_SMARTCARD : _AppConstants.SignupTypes.WITHOUT_SMARTCARD,
                selfRegistered: _this.props.withISRN,
                isMainRegistration: true
            }),
            badPostcode: null,
            emailInUse: null,
            furthestStep: REGISTER_NO_STEP_COMPLETED,
            isAmazonRegistration: !!_this.props.customer,
            isDirty: false,
            loading: false,
            scrollComplete: false,
            step: _this.props.initialStep || RegisterSteps.DETAILS,
            submitted: false,
            smartcardSubmitted: false,
            isSubscribeModalOpen: false
        }, _this._closeModal = function (status) {
            (0, _defer3.default)(function () {
                _ModalActions2.default.close();

                if (status === _AppConstants.AmazonLoginStatus.LOGIN_SUCCESS) {
                    _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
                        heading: (0, _I18n.translate)('account.register.alreadyAmazon.heading'),
                        title: (0, _I18n.translate)('account.register.alreadyAmazon.title'),
                        message: (0, _I18n.translate)('account.register.alreadyAmazon.message'),
                        customIcon: _react2.default.createElement(_TickIcon2.default, null),
                        disableHeader: true
                    });
                }
            });
        }, _this._handleCancel = function () {
            _this.props.onCancel();
            _AmazonLoginActions2.default.resetStateToIdle();
            _ModalActions2.default.close(_AppConstants.GlobalModals.REGISTER);
        }, _this._handleSubmission = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _this$state, amazonAccessToken, form, smartcard, step, _this$props, onSmartcardSuccess, disableSuccessDropdown, withISRN, onSuccessClose, onCloseSmartcardError, isRegistering, enableMarketingConsents, consentsForm, router, onRegister, postcodeLookup, newSmartcard, isLoggedIn, user, updatedForm, state;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$state = _this.state, amazonAccessToken = _this$state.amazonAccessToken, form = _this$state.form, smartcard = _this$state.smartcard, step = _this$state.step;
                            _this$props = _this.props, onSmartcardSuccess = _this$props.onSmartcardSuccess, disableSuccessDropdown = _this$props.disableSuccessDropdown, withISRN = _this$props.withISRN, onSuccessClose = _this$props.onSuccessClose, onCloseSmartcardError = _this$props.onCloseSmartcardError, isRegistering = _this$props.isRegistering, enableMarketingConsents = _this$props.enableMarketingConsents, consentsForm = _this$props.consentsForm, router = _this$props.router, onRegister = _this$props.onRegister;

                            if (!isRegistering) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt('return', null);

                        case 4:

                            if (step === RegisterSteps.SMARTCARD) {
                                _this.setState({ smartcardSubmitted: true });
                            }

                            if (!(!form.isComplete() || !smartcard.isComplete() && smartcard.withSmartcard())) {
                                _context.next = 9;
                                break;
                            }

                            _this.setState({ submitted: true });

                            if (form.isComplete() && smartcard.withSmartcard() && !smartcard.get('addressLine1')) {
                                postcodeLookup = document.getElementById('postCodeLookUp');

                                setTimeout(function () {
                                    postcodeLookup.focus();
                                }, 100);
                            }

                            return _context.abrupt('return', null);

                        case 9:

                            _this.setState({ loading: true });

                            _context.prev = 10;
                            newSmartcard = null;
                            isLoggedIn = _this.props.user.isLoggedIn();
                            user = null;

                            if (!isLoggedIn) {
                                _context.next = 18;
                                break;
                            }

                            user = _this.props.user;
                            _context.next = 22;
                            break;

                        case 18:
                            updatedForm = _FeatureFlagStore2.default.get('enableOneClickDelayRepay') ? form.setIn(['preferences', 'autoDelayRepay'], false) : form;
                            _context.next = 21;
                            return _CustomerActions2.default.register(updatedForm, amazonAccessToken);

                        case 21:
                            user = _context.sent;

                        case 22:
                            if (!smartcard.withSmartcard()) {
                                _context.next = 33;
                                break;
                            }

                            if (!withISRN) {
                                _context.next = 29;
                                break;
                            }

                            _context.next = 26;
                            return _CustomerActions2.default.linkSmartcard(user, smartcard);

                        case 26:
                            _context.t0 = _context.sent;
                            _context.next = 32;
                            break;

                        case 29:
                            _context.next = 31;
                            return _CustomerActions2.default.registerSmartcard(user, smartcard);

                        case 31:
                            _context.t0 = _context.sent;

                        case 32:
                            newSmartcard = _context.t0;

                        case 33:
                            if (smartcard.withTransfer()) {
                                router.push(_urls2.default.location(_AppConstants.AccountPages.SMARTCARD_TRANSFER));
                                _ModalActions2.default.close();
                            } else {
                                onRegister();
                                _ModalActions2.default.open(_RegisterSuccessModal2.default, {
                                    smartcard: !withISRN && newSmartcard,
                                    disableSuccessDropdown: disableSuccessDropdown,
                                    onSuccessClose: onSuccessClose,
                                    onOptInADR: _FeatureFlagStore2.default.get('enableOneClickDelayRepay') ? _this.handleSubscribeModalOpen : function () {
                                        return null;
                                    }
                                });
                            }

                            if (onSmartcardSuccess) {
                                onSmartcardSuccess();
                            }

                            if (!enableMarketingConsents) {
                                _context.next = 38;
                                break;
                            }

                            _context.next = 38;
                            return _ConsentsActions2.default.updateConsentsAndUser({ form: consentsForm, user: user });

                        case 38:
                            _context.next = 65;
                            break;

                        case 40:
                            _context.prev = 40;
                            _context.t1 = _context['catch'](10);
                            state = { loading: false };

                            if (!(_context.t1 instanceof _Customer.CustomerEmailInUseError)) {
                                _context.next = 48;
                                break;
                            }

                            state.emailInUse = form.email;
                            state.step = RegisterSteps.DETAILS;
                            _context.next = 64;
                            break;

                        case 48:
                            if (!(_context.t1 instanceof _Smartcard.SmartcardPostcodeError)) {
                                _context.next = 53;
                                break;
                            }

                            state.badPostcode = _this.state.smartcard.postcode;
                            state.step = RegisterSteps.SMARTCARD;
                            _context.next = 64;
                            break;

                        case 53:
                            if (!(_context.t1 instanceof _Smartcard.SmartcardRegistrationError)) {
                                _context.next = 58;
                                break;
                            }

                            console.error('Smartcard registration error', _context.t1);
                            return _context.abrupt('return', _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
                                title: 'account.register.partialSuccess',
                                message: 'account.register.partialSuccessMessage',
                                customIcon: _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    _react2.default.createElement(_RegisterHello2.default, {
                                        name: _this.state.form.firstNames,
                                        className: 'register-modal__success-message--heading'
                                    }),
                                    _react2.default.createElement(_ExclamationIcon2.default, null)
                                ),
                                disableHeader: true,
                                disableBorderFooter: true
                            }));

                        case 58:
                            if (!(_context.t1 instanceof _Smartcard.SelfSmartcardRegistrationError)) {
                                _context.next = 63;
                                break;
                            }

                            console.error('Smartcard self registration error', _context.t1);
                            _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
                                type: 'warning',
                                title: 'account.register.selfSmartcardError',
                                message: (0, _ServiceUnavailable.serviceUnavailable)(_context.t1.extra.error.body.status) ? 'error.general.message' : 'account.register.selfSmartcardErrorMessagePartial',
                                onClose: function onClose() {
                                    return onCloseSmartcardError(_this.props.user, _AppConstants.SmartcardSelfRegistrationStatuses.NEW_SMARTCARD);
                                }
                            });
                            _context.next = 64;
                            break;

                        case 63:
                            throw _context.t1;

                        case 64:
                            _this.setState(state);

                        case 65:
                            return _context.abrupt('return', null);

                        case 66:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[10, 40]]);
        })), _this._handleLogin = function () {
            var _this$props2 = _this.props,
                loginTitleText = _this$props2.loginTitleText,
                titleText = _this$props2.titleText,
                onCancel = _this$props2.onCancel,
                onCancelLogin = _this$props2.onCancelLogin;

            _ModalActions2.default.close(_AppConstants.GlobalModals.REGISTER);

            if (_config2.default.get('name') !== _AppConstants.AppName.DELAY_REPAY) {
                _ModalActions2.default.open(_AppConstants.GlobalModals.LOGIN, {
                    titleText: loginTitleText,
                    registerTitleText: titleText,
                    onCancel: onCancelLogin,
                    onCancelRegister: onCancel
                });
            }
        }, _this._handleAgeToggled = function (isOver16, updatedPreferences) {
            var consentsForm = _this.props.consentsForm;


            var form = _this.state.form.set('preferences', updatedPreferences).set('isOver16', isOver16);

            var smartcard = _this.state.smartcard.set('isOver16', isOver16);

            if (!isOver16) {
                smartcard = smartcard.set('dateOfBirth', new _DateOfBirth2.default());
            }
            if (_FeatureFlagStore2.default.get('enableMarketingConsents')) {
                _ConsentsActions2.default.setConsentsForm(consentsForm.set(_AppConstants.CONSENTS.OVER_16, isOver16));
            }
            _this.setState({ smartcard: smartcard, form: form });
        }, _this._handleFieldChange = function (field, value) {
            var form = _this.state.form.set(field, value);
            if (!form.preferences.isSomeSmsPrefSetToTrue()) {
                form = form.set('phone', null);
            }

            _this.setState({
                form: form,
                isDirty: true,
                submitted: false
            });
        }, _this._isStepValid = function (step) {
            var _this$state2 = _this.state,
                form = _this$state2.form,
                smartcard = _this$state2.smartcard,
                currentStep = _this$state2.step;

            var isValid = false;

            step = step ? step : currentStep;

            switch (step) {
                case RegisterSteps.DETAILS:
                    isValid = form.arePersonalDetailsValid();
                    break;

                case RegisterSteps.SMARTCARD:
                    isValid = smartcard.isComplete();
                    break;

                case RegisterSteps.PREFERENCES:
                    isValid = form.isComplete();
                    break;
            }

            return isValid;
        }, _this._handleSmartcardUpdate = function (field, value) {
            var _this$state3 = _this.state,
                form = _this$state3.form,
                smartcard = _this$state3.smartcard;
            var consentsForm = _this.props.consentsForm;


            if (field === 'dateOfBirth') {
                if (value.isOverAge(16)) {
                    smartcard = smartcard.set('isOver16', true);
                    form = form.set('isOver16', true);
                    if (_FeatureFlagStore2.default.get('enableMarketingConsents')) {
                        _ConsentsActions2.default.setConsentsForm(consentsForm.set(_AppConstants.CONSENTS.OVER_16, true));
                    }
                }
            }

            if (_this.props.enableAutoDelayRepay) {
                if (field === 'signup') {
                    smartcard = smartcard.set('autoDrOptedIn', value === _AppConstants.SignupTypes.WITH_SMARTCARD);
                    form = form.setIn(['preferences', 'autoDelayRepay'], value === _AppConstants.SignupTypes.WITH_SMARTCARD);
                }
            }

            _this.setState({
                form: form,
                smartcard: smartcard.set(field, value),
                submitted: false
            });
        }, _this._handleSmartcardAddressSelected = function (address) {
            var updatedSmartcard = _this.state.smartcard.merge({
                addressLine1: address.get('line1'),
                addressLine2: address.get('line2'),
                addressLine3: address.get('line3'),
                townCity: address.get('town'),
                postcode: address.get('postCode')
            });
            _this.setState({
                smartcard: updatedSmartcard,
                submitted: false
            });
        }, _this._handleScrollComplete = function () {
            _this.setState({ scrollComplete: true });
        }, _this._scrollModalBodyToTop = function () {
            var modalBody = document.querySelector('.modal-body');

            if (modalBody) {
                modalBody.scrollTop = 0;
            }
        }, _this._handleContinueRegistration = function () {
            var enableSmartcard = _this.props.enableSmartcard;
            var _this$state4 = _this.state,
                furthestStep = _this$state4.furthestStep,
                step = _this$state4.step;


            var nextStep = step;
            var isCurrentStepValid = _this._isStepValid();

            if (isCurrentStepValid) {
                switch (step) {
                    case RegisterSteps.DETAILS:
                        if (enableSmartcard) {
                            nextStep = RegisterSteps.SMARTCARD;
                        } else {
                            nextStep = RegisterSteps.PREFERENCES;
                        }
                        break;

                    case RegisterSteps.SMARTCARD:
                        nextStep = RegisterSteps.PREFERENCES;
                        break;
                }
            } else {
                nextStep = null;
            }

            if (nextStep !== null) {
                _this.setState({
                    step: nextStep,
                    submitted: false
                });

                _this._scrollModalBodyToTop();

                if (nextStep > furthestStep) {
                    _this.setState({ furthestStep: nextStep });
                }
            } else {
                _this._handleSubmission();
            }
        }, _this._handleStep = function (stepNumber) {
            return function () {
                var _this$state5 = _this.state,
                    furthestStep = _this$state5.furthestStep,
                    step = _this$state5.step;


                var areStepsInbetweenValid = (0, _range3.default)(1, stepNumber).every(_this._isStepValid);

                // A user might have invaliated an earlier visited step
                // so check again before proceeding to the next one.
                if (stepNumber > step && !areStepsInbetweenValid) {
                    _this._handleSubmission();
                } else {
                    _this.setState({ step: stepNumber });

                    if (stepNumber > furthestStep) {
                        _this.setState({ furthestStep: stepNumber - 1 });
                    }

                    _this._scrollModalBodyToTop();
                }
            };
        }, _this._handleStepBack = function (stepNumber) {
            _this.setState({ step: stepNumber });
            _this._scrollModalBodyToTop();
        }, _this.handleSubscribeModalOpen = function () {
            _ModalActions2.default.open(_subscribeDelayRepay.SubscribeDelayRepay, {
                user: _this.props.user,
                modalOpen: true,
                optedInFrom: 'new-registration',
                handleClose: function handleClose() {
                    _ModalActions2.default.close();
                },
                shouldRedirectToAccountScreen: true
            });
            _this.setState({ isSubscribeModalOpen: true });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    RegisterModal.prototype.componentDidMount = function componentDidMount() {
        if (this.state.isAmazonRegistration) {
            this._handleContinueRegistration();
        }
    };

    RegisterModal.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this._shouldFocus(prevProps, prevState)) {
            (0, _defer3.default)(this._focusOnError);
        }
    };

    RegisterModal.prototype._renderComponent = function _renderComponent(Component) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _state = this.state,
            form = _state.form,
            submitted = _state.submitted;

        return _react2.default.createElement(Component, (0, _extends3.default)({
            form: form,
            onChange: this._handleFieldChange,
            visited: submitted
        }, options));
    };

    RegisterModal.prototype._renderEmailError = function _renderEmailError() {
        var _state2 = this.state,
            emailInUse = _state2.emailInUse,
            form = _state2.form;

        if (emailInUse && emailInUse === form.email) {
            return _react2.default.createElement(
                _Col2.default,
                { md: 12 },
                _react2.default.createElement(
                    _BAlert2.default,
                    { className: 'register-step__form-error', type: 'danger' },
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'alertmessage.registration.failed.emailInUse',
                        learnMoreUrl: _config2.default.get('yourAccountHelpUrl')
                    })
                )
            );
        }
        return null;
    };

    RegisterModal.prototype.render = function render() {
        var _props = this.props,
            enableAmazonLogin = _props.enableAmazonLogin,
            enableAmazonRegistration = _props.enableAmazonRegistration,
            enableSmartcard = _props.enableSmartcard,
            enableSmartcardTransferAtSignUp = _props.enableSmartcardTransferAtSignUp,
            enableForceScrollRegistration = _props.enableForceScrollRegistration,
            enableKeyGoRegistrationAtSignup = _props.enableKeyGoRegistrationAtSignup,
            hideSmartcardCheckbox = _props.hideSmartcardCheckbox,
            hideSmartcardPromotionalText = _props.hideSmartcardPromotionalText,
            isRegistering = _props.isRegistering,
            isDesktopWidth = _props.isDesktopWidth,
            isTabletCustomBreakpoint = _props.isTabletCustomBreakpoint,
            titleText = _props.titleText,
            hideClose = _props.hideClose,
            handleLogin = _props.handleLogin,
            consentsForm = _props.consentsForm;
        var _state3 = this.state,
            badPostcode = _state3.badPostcode,
            emailInUse = _state3.emailInUse,
            form = _state3.form,
            furthestStep = _state3.furthestStep,
            isAmazonRegistration = _state3.isAmazonRegistration,
            isDirty = _state3.isDirty,
            loading = _state3.loading,
            smartcard = _state3.smartcard,
            step = _state3.step,
            submitted = _state3.submitted,
            smartcardSubmitted = _state3.smartcardSubmitted;

        var validation = form.getValidationSummary();

        var isAmazonLoginEnabled = enableAmazonLogin && enableAmazonRegistration;
        var emailErrorProp = emailInUse && emailInUse === form.email ? { error: (0, _I18n.translate)('account.register.emailInUse'), autoFocus: true } : null;
        var showExtraOptions = step === RegisterSteps.DETAILS;
        var hideRegisterSteps = enableSmartcard ? [] : ['SMARTCARD'];

        var componentOptions = {
            validation: validation,
            smartcard: smartcard,
            visited: submitted,
            onAgeToggle: this._handleAgeToggled,
            vertical: true,
            outsideLabel: true,
            noTandC: true,
            noOptDescription: true,
            noPreferenceNotice: false
        };

        var modalProps = {
            className: 'modal--register',
            closeText: 'button.text.cancel',
            continueText: 'account.register',
            disableContinue: loading || enableForceScrollRegistration && !this.state.scrollComplete,
            disableEscape: true,
            footer: isTabletCustomBreakpoint && _react2.default.createElement(_RegisterModalFooter2.default, {
                handleContinueRegistration: this._handleContinueRegistration,
                handleSubmission: this._handleSubmission,
                isFirstStep: step === RegisterSteps.DETAILS,
                isSmartcardStep: step === RegisterSteps.SMARTCARD,
                isLastStep: step === RegisterSteps.PREFERENCES,
                isRegistering: isRegistering,
                onSmartcardUpdate: this._handleSmartcardUpdate,
                onClose: this._handleCancel,
                handleLogin: handleLogin,
                consentsForm: consentsForm,
                isOver16: form.get('isOver16')
            }),
            header: _react2.default.createElement(_RegisterModalHeader2.default, {
                closeModal: this._closeModal,
                furthestStep: furthestStep,
                handleLogin: handleLogin || this._handleLogin,
                handleStep: this._handleStep,
                handleStepBack: this._handleStepBack,
                isAmazonRegistration: isAmazonRegistration,
                amazonEmail: this.state.form.email,
                isFormDirty: isDirty,
                hideClose: hideClose,
                onClose: this._handleCancel,
                onClosePress: (0, _a11y.onEnterPress)(this._handleCancel),
                showExtraOptions: step === RegisterSteps.DETAILS,
                step: step,
                dictionaryPrefix: 'account.register.steps.back.',
                hideSteps: hideRegisterSteps,
                steps: RegisterSteps
            }),
            headerClass: 'modal__header',
            isAutofocusing: false,
            onEnterContinue: false,
            titleText: titleText,
            useFlex: true
        };

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'div',
                { className: 'content-wrapper' },
                isDesktopWidth && _react2.default.createElement(
                    'div',
                    { className: 'content-wrapper__usps' },
                    _react2.default.createElement(_BrandUsps2.default, {
                        steps: RegisterSteps,
                        currentStep: step,
                        dictionaryPrefix: 'account.register.'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'content-wrapper__form' },
                    showExtraOptions && _react2.default.createElement(
                        'div',
                        {
                            className: (0, _classnames2.default)('modal__header__wrapper modal__header__wrapper--vertical-center modal__header__wrapper--register', {
                                'modal__header__wrapper--register--mobile': isTabletCustomBreakpoint
                            })
                        },
                        isAmazonLoginEnabled && !isAmazonRegistration ? _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(_OrBar2.default, {
                                className: (0, _classnames2.default)({
                                    'or-bar--active-breakpoint': isTabletCustomBreakpoint
                                })
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal__header__right modal__header__right--no-grow' },
                                _react2.default.createElement(_AmazonLoginCTA2.default, {
                                    closeModal: this._closeModal,
                                    type: _AppConstants.AmazonLoginCTATypes.REGISTER
                                })
                            )
                        ) : null
                    ),
                    _react2.default.createElement(_StepsNavigation2.default, {
                        currentStep: step,
                        furthestStep: furthestStep,
                        dictionaryPrefix: 'account.register.steps.',
                        onClick: this._handleStep,
                        steps: RegisterSteps,
                        hideSteps: hideRegisterSteps
                    }),
                    !isDesktopWidth && _react2.default.createElement(_StepDetail2.default, {
                        currentStep: step,
                        steps: RegisterSteps,
                        hideSteps: hideRegisterSteps,
                        stepTitleTagName: 'h1',
                        dictionaryPrefix: 'account.register.'
                    }),
                    _react2.default.createElement(
                        'section',
                        { className: 'register-wrapper', ref: this.captureFormRef },
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 12 },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: (0, _classnames2.default)('register-step register-details', {
                                            'register-step--active': step === RegisterSteps.DETAILS
                                        })
                                    },
                                    _react2.default.createElement(
                                        'form',
                                        { onSubmit: this._handleContinueRegistration },
                                        _react2.default.createElement('input', { type: 'submit', className: 'hidden' }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'register-personal' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'register-personal__personal-info' },
                                                !badPostcode && _react2.default.createElement(
                                                    _react2.default.Fragment,
                                                    null,
                                                    _react2.default.createElement(
                                                        _Row2.default,
                                                        null,
                                                        this._renderEmailError()
                                                    ),
                                                    _react2.default.createElement(
                                                        _Row2.default,
                                                        null,
                                                        this._renderComponent(_Name2.default, componentOptions)
                                                    )
                                                ),
                                                isAmazonRegistration ? _react2.default.createElement(
                                                    _Row2.default,
                                                    null,
                                                    _react2.default.createElement(
                                                        _Col2.default,
                                                        { md: 6 },
                                                        _react2.default.createElement(_Email2.default, {
                                                            form: this.state.form,
                                                            disabled: true,
                                                            outsideLabel: true,
                                                            required: false
                                                        })
                                                    )
                                                ) : !badPostcode && _react2.default.createElement(
                                                    _react2.default.Fragment,
                                                    null,
                                                    _react2.default.createElement(
                                                        _Row2.default,
                                                        null,
                                                        _react2.default.createElement(
                                                            _Col2.default,
                                                            { md: 12 },
                                                            _react2.default.createElement(_Email2.default, (0, _extends3.default)({}, emailErrorProp, {
                                                                form: form,
                                                                onChange: this._handleFieldChange,
                                                                validation: validation,
                                                                visited: submitted,
                                                                label: (0, _I18n.translate)('customerdetails.email'),
                                                                outsideLabel: true
                                                            }))
                                                        ),
                                                        _react2.default.createElement(
                                                            _Col2.default,
                                                            {
                                                                md: 12,
                                                                className: 'margin-bottom'
                                                            },
                                                            _react2.default.createElement(_Password2.default, {
                                                                form: form,
                                                                field: 'password',
                                                                onChange: this._handleFieldChange,
                                                                showPasswordIcon: true,
                                                                showPasswordHints: true,
                                                                validation: validation,
                                                                visited: submitted,
                                                                outsideLabel: true
                                                            })
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: (0, _classnames2.default)('register-step register-smartcard', {
                                            'register-step--active': step === RegisterSteps.SMARTCARD
                                        })
                                    },
                                    badPostcode && _react2.default.createElement(_Error2.default, {
                                        message: (0, _I18n.translate)('alertmessage.registration.failed.postcodeInvalid')
                                    }),
                                    _react2.default.createElement(
                                        _FeatureFlag2.default,
                                        { name: 'enableSmartcard' },
                                        _react2.default.createElement(
                                            _FeatureFlag2.default,
                                            { name: 'enableSmartcardAtSignup' },
                                            _react2.default.createElement(_RegisterSmartcard2.default, {
                                                ref: 'smartcard',
                                                smartcard: smartcard,
                                                onChange: this._handleSmartcardUpdate,
                                                onAgeToggle: this._handleAgeToggled,
                                                onSelectAddress: this._handleSmartcardAddressSelected,
                                                user: this.state.form,
                                                badPostcode: badPostcode,
                                                enableSmartcardTransferAtSignUp: enableSmartcardTransferAtSignUp,
                                                enableKeyGoRegistrationAtSignup: enableKeyGoRegistrationAtSignup,
                                                hideSmartcardCheckbox: hideSmartcardCheckbox,
                                                hideSmartcardPromotionalText: hideSmartcardPromotionalText,
                                                submitted: submitted,
                                                smartcardSubmitted: smartcardSubmitted
                                            })
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: (0, _classnames2.default)('register-step register-preferences', {
                                            'register-step--active': step === RegisterSteps.PREFERENCES
                                        })
                                    },
                                    !badPostcode && _react2.default.createElement(
                                        _Row2.default,
                                        null,
                                        this._renderComponent(_SignupOptions2.default, componentOptions),
                                        isTabletCustomBreakpoint && (0, _I18n.translate)('preference-centre.privacy-notice').length > 1 && _react2.default.createElement(
                                            _Col2.default,
                                            { md: 12 },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'margin-top--sm margin-bottom' },
                                                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                                                    className: 'text-sm',
                                                    message: 'preference-centre.privacy-notice'
                                                })
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(_WayPointWrapper2.default, { onEnter: this._handleScrollComplete }),
                                !isTabletCustomBreakpoint && _react2.default.createElement(_RegisterModalFooter2.default, {
                                    isDesktop: true,
                                    handleContinueRegistration: this._handleContinueRegistration,
                                    handleSubmission: this._handleSubmission,
                                    handleLogin: handleLogin || this._handleLogin,
                                    isFormDirty: isDirty,
                                    isFirstStep: step === RegisterSteps.DETAILS,
                                    isSmartcardStep: step === RegisterSteps.SMARTCARD,
                                    isLastStep: step === RegisterSteps.PREFERENCES,
                                    isRegistering: isRegistering,
                                    onClose: this._handleCancel,
                                    onSmartcardUpdate: this._handleSmartcardUpdate,
                                    consentsForm: consentsForm,
                                    isOver16: form.get('isOver16')
                                })
                            )
                        )
                    )
                )
            )
        );
    };

    return RegisterModal;
}(_FormComponent3.default), _class2.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default),
    customer: _propTypes2.default.object,
    onRegister: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    onCancelLogin: _propTypes2.default.func,
    forceSmartcardSignup: _propTypes2.default.bool,
    enableAmazonLogin: _propTypes2.default.bool,
    enableAmazonRegistration: _propTypes2.default.bool,
    enableSmartcard: _propTypes2.default.bool,
    enableSmartcardTransferAtSignUp: _propTypes2.default.bool,
    enableForceScrollRegistration: _propTypes2.default.bool,
    enableKeyGoRegistrationAtSignup: _propTypes2.default.bool,
    enableAutoDelayRepay: _propTypes2.default.bool,
    enableMarketingConsents: _propTypes2.default.bool,
    isDesktopWidth: _propTypes2.default.bool,
    isTabletCustomBreakpoint: _propTypes2.default.bool,
    hideSmartcardCheckbox: _propTypes2.default.bool,
    hideSmartcardPromotionalText: _propTypes2.default.bool,
    loginTitleText: _propTypes2.default.string,
    initialStep: _propTypes2.default.number,
    titleText: _propTypes2.default.string,
    onSmartcardSuccess: _propTypes2.default.func,
    withISRN: _propTypes2.default.bool,
    emailDefaultValue: _propTypes2.default.string,
    onSuccessClose: _propTypes2.default.func,
    onCloseSmartcardError: _propTypes2.default.func,
    disableBlur: _propTypes2.default.bool,
    disableEscape: _propTypes2.default.bool,
    hideClose: _propTypes2.default.bool,
    handleLogin: _propTypes2.default.func,
    consentsForm: _propTypes2.default.instanceOf(_ConsentsForm2.default)
}, _class2.defaultProps = {
    user: null,
    customer: null,
    emailDefaultValue: null,
    onRegister: _noop3.default,
    onCancel: _noop3.default,
    onCancelLogin: _noop3.default,
    forceSmartcardSignup: false,
    enableAmazonLogin: false,
    enableAmazonRegistration: false,
    enableSmartcard: false,
    enableSmartcardTransferAtSignUp: false,
    enableForceScrollRegistration: false,
    enableKeyGoRegistrationAtSignup: false,
    enableAutoDelayRepay: false,
    enableMarketingConsents: false,
    isDesktopWidth: false,
    isTabletCustomBreakpoint: false,
    hideSmartcardCheckbox: true,
    hideSmartcardPromotionalText: true,
    withISRN: false,
    loginTitleText: 'account.login',
    initialStep: null,
    titleText: 'account.register',
    onSmartcardSuccess: _noop3.default,
    onSuccessClose: _noop3.default,
    disableBlur: false,
    disableEscape: false,
    hideClose: false,
    handleLogin: null,
    consentsForm: new _ConsentsForm2.default()
}, _temp2)) || _class;

function _getStateFromStores(props) {
    return {
        user: _UserStore2.default.getCurrent(),
        forceSmartcardSignup: props.forceSmartcardSignup || _FeatureFlagStore2.default.get('enableDefaultSmartcardAtSignup'),
        enableAmazonLogin: _FeatureFlagStore2.default.get('enableAmazonLogin'),
        enableAmazonRegistration: _FeatureFlagStore2.default.get('enableAmazonRegistration'),
        enableSmartcard: _FeatureFlagStore2.default.get('enableSmartcard'),
        enableSmartcardTransferAtSignUp: _FeatureFlagStore2.default.get('enableSmartcardTransferAtSignUp'),
        enableForceScrollRegistration: _FeatureFlagStore2.default.get('enableForceScrollRegistration'),
        enableKeyGoRegistrationAtSignup: _FeatureFlagStore2.default.get('enableKeyGoRegistrationAtSignup'),
        enableAutoDelayRepay: _FeatureFlagStore2.default.get('enableAutoDelayRepay'),
        enableMarketingConsents: _FeatureFlagStore2.default.get('enableMarketingConsents'),
        isDesktopWidth: _DimensionsStore2.default.isDesktopWidth(),
        isTabletCustomBreakpoint: _DimensionsStore2.default.getWindowSize().get('width') <= VIEWPORT_BREAK_POINT_WIDTH,
        isRegistering: _UserStore2.default.getIsRegistering(),
        consentsForm: _ConsentsStore2.default.form
    };
}

exports.default = (0, _connectToStores2.default)([_UserStore2.default, _FeatureFlagStore2.default, _DimensionsStore2.default, _ConsentsStore2.default], _getStateFromStores)(RegisterModal);

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = usePrevious;

var _react = __webpack_require__(0);

function usePrevious(value) {
    var previousRef = (0, _react.useRef)();
    (0, _react.useEffect)(function () {
        previousRef.current = value;
    }, [value]);
    return previousRef.current;
}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _throttle2 = __webpack_require__(452);

var _throttle3 = _interopRequireDefault(_throttle2);

exports.useResizeObserver = useResizeObserver;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _resizeObserverPolyfill = __webpack_require__(1070);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _hookUtils = __webpack_require__(234);

var _hookUtils2 = _interopRequireDefault(_hookUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInitialSize = function getInitialSize() {
    return {
        width: undefined,
        height: undefined
    };
};

exports.default = (0, _hookUtils2.default)(useResizeObserver, 'useResizeObserver');

/**
 * Measures the size of a DOM element.
 * You can either pass in a `ref` or use the returned `ref` reference to select which DOM element to measure.
 * `width` and `height` are returned from the hook, and will trigger a render when they update.
 * You can also pass in an `onResize` callback to receive those values.
 *
 * @param {Object} options
 * @param {React.MutableRefObject} [options.ref] - Optional react reference to DOM element to measure size of
 * @param {Function} [options.onResize] - Optional callback to receive size changes
 * @returns {{width: Number, height: number, ref: React.MutableRefObject}}
 */

function useResizeObserver() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        ref = _ref.ref,
        onResize = _ref.onResize;

    var internalRef = React.useRef();
    var targetRef = ref || internalRef;
    var targetElement = targetRef.current;

    var resizeObserverRef = React.useRef();

    var _React$useState = React.useState(getInitialSize),
        size = _React$useState[0],
        setSize = _React$useState[1];

    var previous = React.useRef((0, _assign2.default)({}, size));

    var onResizeRef = React.useRef();
    onResizeRef.current = onResize;

    React.useEffect(function () {
        if (!targetElement) {
            return undefined;
        }

        var handleResize = (0, _throttle3.default)(function (newSize) {
            if (typeof onResizeRef.current === 'function') {
                onResizeRef.current(newSize);
            }
            setSize(newSize);
        }, 50, { maxWait: 200 });

        resizeObserverRef.current = new _resizeObserverPolyfill2.default(function (entries) {
            if (!Array.isArray(entries) || !entries.length) {
                return;
            }
            var entry = entries[0];


            var newWidth = Math.round(entry.contentRect.width);
            var newHeight = Math.round(entry.contentRect.height);

            if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
                var newSize = { width: newWidth, height: newHeight };
                (0, _assign2.default)(previous.current, newSize);
                (0, _defer3.default)(function () {
                    return handleResize(newSize);
                });
            }
        });

        resizeObserverRef.current.observe(targetElement);

        return function () {
            previous.current = getInitialSize();
            setSize(previous.current);
            if (targetElement.parentElement) {
                // element may have been removed from DOM
                resizeObserverRef.current.unobserve(targetElement);
            }
        };
    }, [targetElement]);

    return React.useMemo(function () {
        return (0, _assign2.default)({ ref: internalRef }, size);
    }, [size, internalRef]);
}

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CustomerSignupOptions = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _I18n = __webpack_require__(9);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _SmartcardRegistration = __webpack_require__(240);

var _SmartcardRegistration2 = _interopRequireDefault(_SmartcardRegistration);

var _PhoneNumber = __webpack_require__(959);

var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);

var _AgeCheckbox = __webpack_require__(925);

var _AgeCheckbox2 = _interopRequireDefault(_AgeCheckbox);

var _SignupTAndCs = __webpack_require__(594);

var _SignupTAndCs2 = _interopRequireDefault(_SignupTAndCs);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _PrefsTable = __webpack_require__(965);

var _PrefsTable2 = _interopRequireDefault(_PrefsTable);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

var _Consents = __webpack_require__(1151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    var enableEmailMarketing = _FeatureFlagStore2.default.get('enableEmailMarketing');
    var enableSmsMarketing = _FeatureFlagStore2.default.get('enableSmsMarketing');
    var enablePrefCentreUnder16Warning = _FeatureFlagStore2.default.get('enablePrefCentreUnder16Warning');
    var enableMarketingConsents = _FeatureFlagStore2.default.get('enableMarketingConsents');
    return {
        enableEmailMarketing: enableEmailMarketing,
        enableSmsMarketing: enableSmsMarketing,
        enablePrefCentreUnder16Warning: enablePrefCentreUnder16Warning,
        enableMarketingConsents: enableMarketingConsents
    };
};

var CustomerSignupOptions = exports.CustomerSignupOptions = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(CustomerSignupOptions, _React$PureComponent);

    function CustomerSignupOptions() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomerSignupOptions);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.alwaysShowAgeToggle = false, _this._handleToggleAge = function () {
            _this.alwaysShowAgeToggle = true;

            var _this$props = _this.props,
                onAgeToggle = _this$props.onAgeToggle,
                form = _this$props.form;

            var isOver16 = form.get('isOver16');
            var preferences = form.get('preferences');
            if (isOver16) {
                preferences = preferences.resetAllDisabledMarketingFields();
            }
            onAgeToggle(!isOver16, preferences);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    CustomerSignupOptions.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.smartcard !== this.props.smartcard) {
            if (!newProps.smartcard.withSmartcard() && this.props.smartcard.withSmartcard()) {
                var _props = this.props,
                    onChange = _props.onChange,
                    form = _props.form;

                var updatedPreferences = form.get('preferences').set('autoDelayRepay', false);
                onChange('preferences', updatedPreferences);
            }
        }
    };

    CustomerSignupOptions.prototype.render = function render() {
        var _props2 = this.props,
            enableEmailMarketing = _props2.enableEmailMarketing,
            enableSmsMarketing = _props2.enableSmsMarketing,
            form = _props2.form,
            smartcard = _props2.smartcard,
            onChange = _props2.onChange,
            visited = _props2.visited,
            includePhoneField = _props2.includePhoneField,
            enablePrefCentreUnder16Warning = _props2.enablePrefCentreUnder16Warning,
            enableMarketingConsents = _props2.enableMarketingConsents,
            noTandC = _props2.noTandC,
            noOptDescription = _props2.noOptDescription,
            noPreferenceNotice = _props2.noPreferenceNotice;

        var isOver16 = form.get('isOver16');
        var showNoPreferences = !enableEmailMarketing && !enableSmsMarketing;
        var showAgeToggle = smartcard && !smartcard.withSmartcard() && !smartcard.isValidDateOfBirth() || !smartcard;

        if (enableMarketingConsents) {
            return _react2.default.createElement(
                _Col2.default,
                { md: 12, className: 'signup-options form--vertical' },
                _react2.default.createElement(_Consents.Consents, null)
            );
        }

        return _react2.default.createElement(
            _Col2.default,
            { md: 12, className: 'signup-options form--vertical' },
            (showAgeToggle || this.alwaysShowAgeToggle) && _react2.default.createElement(_AgeCheckbox2.default, { isOver16: isOver16, onToggle: this._handleToggleAge }),
            !noOptDescription && _react2.default.createElement(
                'p',
                { className: 'margin-top--sm margin-bottom--sm' },
                (0, _I18n.translate)('account.register.opt.description')
            ),
            enablePrefCentreUnder16Warning && !isOver16 && _react2.default.createElement(_Error2.default, { message: (0, _I18n.translate)('preference-centre.age-restriction.warning') }),
            !showNoPreferences && _react2.default.createElement(_PrefsTable2.default, {
                form: form.get('preferences'),
                onChange: onChange,
                isOver16: isOver16,
                enableEmailMarketing: enableEmailMarketing,
                enableSmsMarketing: enableSmsMarketing,
                hideAutoDrOption: true
            }),
            !showNoPreferences && form.preferences.isSomeSmsPrefSetToTrue() && includePhoneField && _react2.default.createElement(_PhoneNumber2.default, {
                form: form,
                onChange: onChange,
                visited: visited,
                required: true
            }),
            !noPreferenceNotice && _react2.default.createElement(
                'p',
                { className: 'text-size--normal' },
                _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'preference-centre.edit-notice.short' })
            ),
            !noTandC && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: 'preference-centre.edit-notice',
                    privacyPolicy: _react2.default.createElement(_SignupTAndCs.PrivacyPolicyLink, null)
                })
            ),
            !noTandC && _react2.default.createElement(_SignupTAndCs2.default, { form: form, visited: visited, onToggle: onChange })
        );
    };

    return CustomerSignupOptions;
}(_react2.default.PureComponent), _class.propTypes = {
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onAgeToggle: _propTypes2.default.func.isRequired,
    smartcard: _propTypes2.default.instanceOf(_SmartcardRegistration2.default),
    visited: _propTypes2.default.bool,
    enableEmailMarketing: _propTypes2.default.bool,
    enableSmsMarketing: _propTypes2.default.bool,
    enablePrefCentreUnder16Warning: _propTypes2.default.bool,
    enableMarketingConsents: _propTypes2.default.bool,
    includePhoneField: _propTypes2.default.bool,
    noTandC: _propTypes2.default.bool,
    noOptDescription: _propTypes2.default.bool,
    noPreferenceNotice: _propTypes2.default.bool
}, _class.defaultProps = {
    smartcard: null,
    visited: false,
    enableEmailMarketing: false,
    enableSmsMarketing: false,
    enablePrefCentreUnder16Warning: false,
    enableMarketingConsents: false,
    includePhoneField: true,
    noPreferenceNotice: true
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default], _getStateFromStores)(CustomerSignupOptions);

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var createPadding = __webpack_require__(1999),
    stringSize = __webpack_require__(588),
    toInteger = __webpack_require__(200),
    toString = __webpack_require__(119);

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (createPadding(length - strLength, chars) + string)
    : string;
}

module.exports = padStart;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _FavouriteJourneysEndpoint = __webpack_require__(2050);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavouriteJourneysService = {
    getFavouriteJourneys: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            endpoint = _FavouriteJourneysEndpoint.URL.getFavouriteJourneys.replace('{id}', user.id);
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context.sent;
                            return _context.abrupt('return', response);

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);

                            console.warn('error calling OCDR get favourite journeys service', _context.t0);
                            return _context.abrupt('return', false);

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 8]]);
        }));

        function getFavouriteJourneys(_x) {
            return _ref.apply(this, arguments);
        }

        return getFavouriteJourneys;
    }(),
    saveFavouriteJourney: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user, journey) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            endpoint = _FavouriteJourneysEndpoint.URL.saveFavouriteJourney.replace('{id}', user.id);
                            _context2.next = 3;
                            return _AuthenticatedAPIClient2.default.post(endpoint, journey);

                        case 3:
                            response = _context2.sent;
                            return _context2.abrupt('return', response);

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function saveFavouriteJourney(_x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return saveFavouriteJourney;
    }(),
    deleteFavouriteJourney: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user, journeyId) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            endpoint = _FavouriteJourneysEndpoint.URL.deleteFavouriteJourney.replace('{userId}', user.id).replace('{journeyId}', journeyId);
                            _context3.next = 4;
                            return _AuthenticatedAPIClient2.default.delete(endpoint, user, journeyId);

                        case 4:
                            response = _context3.sent;
                            return _context3.abrupt('return', response);

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](0);

                            console.warn('error calling OCDR delete favourite journey service', _context3.t0);
                            return _context3.abrupt('return', false);

                        case 12:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 8]]);
        }));

        function deleteFavouriteJourney(_x4, _x5) {
            return _ref3.apply(this, arguments);
        }

        return deleteFavouriteJourney;
    }(),
    editFavouriteJourney: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(user, journey) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            endpoint = _FavouriteJourneysEndpoint.URL.editFavouriteJourney.replace('{userId}', user.id).replace('{journeyId}', journey.journeyId);
                            _context4.next = 4;
                            return _AuthenticatedAPIClient2.default.put(endpoint, journey);

                        case 4:
                            response = _context4.sent;
                            return _context4.abrupt('return', response);

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](0);

                            console.warn('error calling OCDR edit favourite journey service', _context4.t0);
                            return _context4.abrupt('return', false);

                        case 12:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 8]]);
        }));

        function editFavouriteJourney(_x6, _x7) {
            return _ref4.apply(this, arguments);
        }

        return editFavouriteJourney;
    }()
};

exports.default = FavouriteJourneysService;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _ApplePayPayment = __webpack_require__(669);

var _ApplePayPayment2 = _interopRequireDefault(_ApplePayPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApplePayPaymentDetails = function ApplePayPaymentDetails(_ref) {
    var small = _ref.small,
        payment = _ref.payment;
    return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('payment-details', { 'payment-details--small': small }) },
        _react2.default.createElement('img', { className: 'payment-details__image payment-details__image--apple-pay', src: _Assets2.default.assetUrl("images/apple-pay-only-logo-small.png"), alt: 'Apple Pay logo' }),
        _react2.default.createElement(
            'span',
            { className: 'payment-details__account-name payment-details__account-name--apple-pay' },
            (0, _I18n2.default)('payment.details.applePay', { applePayAccount: payment.pan })
        )
    );
};

ApplePayPaymentDetails.propTypes = {
    payment: _propTypes2.default.instanceOf(_ApplePayPayment2.default).isRequired,
    small: _propTypes2.default.bool
};

ApplePayPaymentDetails.defaultProps = {
    small: false
};

exports.default = ApplePayPaymentDetails;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _GooglePayPayment = __webpack_require__(668);

var _GooglePayPayment2 = _interopRequireDefault(_GooglePayPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GooglePayPaymentDetails = function GooglePayPaymentDetails(_ref) {
    var small = _ref.small,
        payment = _ref.payment;
    return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('payment-details', { 'payment-details--small': small }) },
        _react2.default.createElement('img', { className: 'payment-details__image payment-details__image--google-pay', src: _Assets2.default.assetUrl("images/google-pay-only-logo-small.png"), alt: 'Google Pay logo' }),
        _react2.default.createElement(
            'span',
            { className: 'payment-details__account-name payment-details__account-name--google-pay' },
            (0, _I18n2.default)('payment.details.googlePay', { googlePayAccount: payment.pan })
        )
    );
};

GooglePayPaymentDetails.propTypes = {
    payment: _propTypes2.default.instanceOf(_GooglePayPayment2.default).isRequired,
    small: _propTypes2.default.bool
};

GooglePayPaymentDetails.defaultProps = {
    small: false
};

exports.default = GooglePayPaymentDetails;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = SmartcardLoadingDetails;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmartcardLoadingDetails() {
    return _react2.default.createElement(
        'div',
        { className: 'vertical-align-parent load-smartcard-modal__body' },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: 'text-weight--bold margin-bottom--sm' },
                (0, _I18n.translate)('booking.delivery.smartcard.modal.body', {
                    brand: (0, _I18n.translate)('app.owner.short')
                })
            ),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('booking.delivery.smartcard.modal.cta')
            ),
            _react2.default.createElement(
                'div',
                { className: 'load-smartcard-modal__app-badges' },
                _react2.default.createElement(
                    'a',
                    { href: _config2.default.get('appStoreAppUrl'), target: '_blank' },
                    _react2.default.createElement('img', {
                        src: '/images/mobile-apps/app-store.png',
                        alt: (0, _I18n.translate)('ontrackapp.widget.appstoreButtonAltText')
                    })
                ),
                _react2.default.createElement(
                    'a',
                    { href: _config2.default.get('googlePlayAppUrl'), target: '_blank' },
                    _react2.default.createElement('img', {
                        src: '/images/mobile-apps/google-play.png',
                        alt: (0, _I18n.translate)('ontrackapp.widget.googlePlayButtonAltText')
                    })
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'load-smartcard-modal__illustration' },
            _react2.default.createElement('img', {
                src: _config2.default.get('loadSmartcardIllustration'),
                alt: (0, _I18n.translate)('booking.delivery.loadSmartcardIllustration')
            })
        )
    );
}

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AlertIcon = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertIcon = exports.AlertIcon = function AlertIcon(_ref) {
    var _ref$fill = _ref.fill,
        fill = _ref$fill === undefined ? "#9E7200" : _ref$fill,
        className = _ref.className;
    return _react2.default.createElement(
        'svg',
        { className: className, width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13.6336 4.93841C12.9065 3.6872 11.0935 3.6872 10.3664 4.93841L3.25624 17.1777C2.52917 18.4289 3.43565 20 4.8898 20H19.1102C20.5644 20 21.4708 18.4289 20.7438 17.1777L13.6336 4.93841ZM5.09154 18H18.9085L12 6.10797L5.09154 18Z', fill: fill }),
        _react2.default.createElement('path', { d: 'M11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V9Z', fill: fill }),
        _react2.default.createElement('path', { d: 'M11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z', fill: fill })
    );
};

AlertIcon.propTypes = {
    fill: _propTypes2.default.string,
    className: _propTypes2.default.string
};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationRequestActions = {
    setPassengers: function setPassengers(passengers) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_RESERVATION_REQUEST_PASSENGERS,
            passengers: passengers
        });
    },
    setRequestSeats: function setRequestSeats(requestSeats) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_RESERVATION_REQUEST_SEATS,
            requestSeats: requestSeats
        });
    },
    setOutboundService: function setOutboundService(journey) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_SERVICE,
            journey: journey
        });
    },
    setInboundService: function setInboundService(journey) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_RESERVATION_REQUEST_INBOUND_SERVICE,
            journey: journey
        });
    },
    setOutboundFare: function setOutboundFare(fare) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_FARE,
            fare: fare
        });
    },
    setInboundFare: function setInboundFare(fare) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_RESERVATION_REQUEST_INBOUND_FARE,
            fare: fare
        });
    },
    resetAllServicesAndFares: function resetAllServicesAndFares() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_SERVICE
        });
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_SERVICE
        });
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_FARE
        });
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_FARE
        });
    },
    setBikes: function setBikes(bikesQty) {
        if (typeof bikesQty !== 'number' || bikesQty < 0) {
            console.error('Invalid bikesQty:', bikesQty);
            return;
        }

        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SET_RESERVATION_REQUEST_BIKES,
            bikesQty: bikesQty
        });
    },
    clearReservationRequestStore: function clearReservationRequestStore() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.CLEAR_RESERVATION_REQUEST_STORE
        });
    }
};

exports.default = ReservationRequestActions;

/***/ }),
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isNil2 = __webpack_require__(329);

var _isNil3 = _interopRequireDefault(_isNil2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "id": [_LinkMapper.resolve.with(Number)],
    "title": [_LinkMapper.resolve.with(String)],
    "sendEmail": [_LinkMapper.resolve.with(Boolean)]
};

var Reason = function (_record) {
    (0, _inherits3.default)(Reason, _record);

    function Reason() {
        (0, _classCallCheck3.default)(this, Reason);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Reason.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Reason, json, (0, _Records.getResolvers)(fieldSchema));
    };

    Reason.prototype.hasId = function hasId() {
        return !(0, _isNil3.default)(this.id);
    };

    Reason.prototype.hasTitle = function hasTitle() {
        return !(0, _isNil3.default)(this.title);
    };

    return Reason;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Reason;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var cleanEventName = function cleanEventName(event) {
    return event.toLowerCase().replace(/ |_/g, '-');
};

var hotJarTrigger = exports.hotJarTrigger = function hotJarTrigger(eventTrigger) {
    if (window.hj) {
        window.hj('trigger', cleanEventName(eventTrigger));
    }
};

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(755),
    baseFilter = __webpack_require__(1671),
    baseIteratee = __webpack_require__(102),
    isArray = __webpack_require__(68);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    amendedTicket: null,
    newTicket: null,
    amended: false,
    amendedTrip: null
};

var AmendedTicket = function (_record) {
    (0, _inherits3.default)(AmendedTicket, _record);

    function AmendedTicket() {
        (0, _classCallCheck3.default)(this, AmendedTicket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AmendedTicket.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(AmendedTicket, json, {
            amendedTicket: json.amendedTicket,
            newTicket: json.newTicket,
            amended: json.amended,
            amendedTrip: (0, _LinkMapper.resolve)(json.amendedTrip).as(_Trip2.default)
        });
    };

    AmendedTicket.prototype.isNewTicket = function isNewTicket(id) {
        return this.newTicket === id;
    };

    AmendedTicket.prototype.getOldFare = function getOldFare() {
        return this.amendedTrip.getFareByTicketId(this.amendedTicket);
    };

    return AmendedTicket;
}((0, _immutable.Record)(defaults));

exports.default = AmendedTicket;

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _LinkMapper = __webpack_require__(8);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoversRangersTicketsService = {
    getAll: function getAll() {
        return (0, _LinkMapper.resolveAll)(_config2.default.get('roversRangersTicketTypes')).as(_TicketType2.default);
    },
    getFirst: function getFirst() {
        return (0, _LinkMapper.resolve)(_config2.default.get('roversRangersTicketTypes')[0]).as(_TicketType2.default);
    }
};

exports.default = RoversRangersTicketsService;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DaySaveStore = function (_BaseStore) {
    (0, _inherits3.default)(DaySaveStore, _BaseStore);

    function DaySaveStore() {
        (0, _classCallCheck3.default)(this, DaySaveStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    DaySaveStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            results: new _immutable.Map()
        });
    };

    DaySaveStore.prototype.getKey = function getKey(search) {
        return (0, _stringify2.default)(search.serialize());
    };

    DaySaveStore.prototype.setResult = function setResult(search, result) {
        this.setState(this.state.setIn(['results', this.getKey(search)], result));
    };

    DaySaveStore.prototype.getResults = function getResults(search) {
        return this.state.getIn(['results', this.getKey(search)], null);
    };

    DaySaveStore.prototype.handleSearchStarted = function handleSearchStarted(_ref) {
        var search = _ref.search;

        var searchResults = new _immutable.Map({ pending: true });
        this.setResult(search, searchResults);
    };

    DaySaveStore.prototype.handleSearchFinished = function handleSearchFinished(_ref2) {
        var search = _ref2.search,
            searchResults = _ref2.searchResults;

        this.setResult(search, searchResults);
    };

    DaySaveStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref3;

        return _ref3 = {}, _ref3[_AppConstants.ActionTypes.DAYSAVE_SEARCH_STARTED] = this.handleSearchStarted, _ref3[_AppConstants.ActionTypes.DAYSAVE_SEARCH_FINISHED] = this.handleSearchFinished, _ref3;
    };

    return DaySaveStore;
}(_BaseStore3.default);

var storeInstance = new DaySaveStore();

exports.default = storeInstance;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DiscountStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduce2 = __webpack_require__(219);

var _reduce3 = _interopRequireDefault(_reduce2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

var _Discount = __webpack_require__(643);

var _Discount2 = _interopRequireDefault(_Discount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscountStore = exports.DiscountStore = function (_BaseStore) {
    (0, _inherits3.default)(DiscountStore, _BaseStore);

    function DiscountStore() {
        (0, _classCallCheck3.default)(this, DiscountStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    DiscountStore.prototype.handleLoaded = function handleLoaded(_ref) {
        var discount = _ref.discount;

        this.setState(this.state.set(discount.promotionUrl, discount));
    };

    DiscountStore.prototype.deserialize = function deserialize(serialized) {
        var state = new _immutable.Map();
        if (serialized) {
            return (0, _reduce3.default)(serialized, function (discounts, discount) {
                return discounts.set(discount.promotionUrl, _Discount2.default.fromJSON(discount));
            }, state);
        }
        return state;
    };

    DiscountStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.DISCOUNT_LOADED] = this.handleLoaded, _ref2;
    };

    return DiscountStore;
}(_BaseStore3.default);

var instance = new DiscountStore({ storageKey: 'discounts' });

exports.default = instance;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EligibleServicesStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EligibleServicesState = new _immutable.Record({
    services: new _immutable.List(),
    loading: true,
    error: null
});

var EligibleServicesStore = exports.EligibleServicesStore = function (_BaseStore) {
    (0, _inherits3.default)(EligibleServicesStore, _BaseStore);

    function EligibleServicesStore() {
        (0, _classCallCheck3.default)(this, EligibleServicesStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    EligibleServicesStore.prototype.getInitialState = function getInitialState() {
        return new EligibleServicesState();
    };

    EligibleServicesStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.ELIGIBLE_SERVICES_SEARCH_STARTED] = this.handleSearchStarted, _ref[_AppConstants.ActionTypes.ELIGIBLE_SERVICES_SEARCH_FINISHED] = this.handleSearchFinished, _ref[_AppConstants.ActionTypes.ELIGIBLE_SERVICES_SEARCH_FAILED] = this.handleSearchFailed, _ref[_AppConstants.ActionTypes.ELIGIBLE_SERVICES_RESET] = this.handleReset, _ref;
    };

    EligibleServicesStore.prototype.handleSearchStarted = function handleSearchStarted() {
        this.setState(this.state.set('loading', true));
    };

    EligibleServicesStore.prototype.handleSearchFinished = function handleSearchFinished(_ref2) {
        var _this2 = this;

        var services = _ref2.services;

        setTimeout(function () {
            _this2.setState(_this2.state.merge({
                services: services,
                loading: false
            }));
        }, 2000);
    };

    EligibleServicesStore.prototype.handleSearchFailed = function handleSearchFailed(_ref3) {
        var error = _ref3.error;

        this.setState(this.state.merge({ loading: false, error: error }));
    };

    EligibleServicesStore.prototype.handleReset = function handleReset() {
        this.setState(this.state.merge({ loading: true, error: null }));
    };

    return EligibleServicesStore;
}(_BaseStore3.default);

var storeInstance = new EligibleServicesStore();

exports.default = storeInstance;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FareHandOffStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FareHandOffStore = exports.FareHandOffStore = function (_BaseStore) {
    (0, _inherits3.default)(FareHandOffStore, _BaseStore);

    function FareHandOffStore() {
        (0, _classCallCheck3.default)(this, FareHandOffStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    FareHandOffStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            loading: false,
            reorderable: null
        });
    };

    FareHandOffStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.FARE_HANDOFF_LOADING] = this.handleFareHandOffLoading, _ref[_AppConstants.ActionTypes.FARE_HANDOFF_LOADED] = this.handleFareHandOffLoaded, _ref;
    };

    FareHandOffStore.prototype.handleFareHandOffLoading = function handleFareHandOffLoading() {
        this.setState(this.state.merge({ loading: true }));
    };

    FareHandOffStore.prototype.handleFareHandOffLoaded = function handleFareHandOffLoaded(_ref2) {
        var reorderable = _ref2.reorderable;

        this.setState(this.state.merge({ loading: false, reorderable: reorderable }));
    };

    return FareHandOffStore;
}(_BaseStore3.default);

exports.default = new FareHandOffStore();

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoTapsStore = function (_BaseStore) {
    (0, _inherits3.default)(KeyGoTapsStore, _BaseStore);

    function KeyGoTapsStore() {
        (0, _classCallCheck3.default)(this, KeyGoTapsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    KeyGoTapsStore.prototype.getInitialState = function getInitialState() {
        var taps = new _immutable.List();
        return new _immutable.Map({ taps: taps });
    };

    KeyGoTapsStore.prototype.hasTaps = function hasTaps() {
        return !this.state.get('taps').isEmpty();
    };

    KeyGoTapsStore.prototype.handleTapsLoaded = function handleTapsLoaded(_ref) {
        var taps = _ref.taps;

        this.setState(this.state.set('taps', taps));
    };

    KeyGoTapsStore.prototype.byDay = function byDay() {
        return this.get('taps').groupBy(function (transaction) {
            return transaction.dateTime.format('YYYY-MM-DD');
        });
    };

    KeyGoTapsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.KEYGO_TAPS_LOADED] = this.handleTapsLoaded, _ref2[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref2;
    };

    return KeyGoTapsStore;
}(_BaseStore3.default);

exports.default = new KeyGoTapsStore();

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _TransactionHistoryResults = __webpack_require__(672);

var _TransactionHistoryResults2 = _interopRequireDefault(_TransactionHistoryResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoTransactionsStore = function (_BaseStore) {
    (0, _inherits3.default)(KeyGoTransactionsStore, _BaseStore);

    function KeyGoTransactionsStore() {
        (0, _classCallCheck3.default)(this, KeyGoTransactionsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    KeyGoTransactionsStore.prototype.getInitialState = function getInitialState() {
        var transactionHistory = new _TransactionHistoryResults2.default({ dailyTransactions: new _immutable.List() });
        var loading = false;
        return new _immutable.Map({ transactionHistory: transactionHistory, loading: loading });
    };

    KeyGoTransactionsStore.prototype.handleTransactionsLoaded = function handleTransactionsLoaded(_ref) {
        var transactionHistory = _ref.transactionHistory;

        var updated = this.state.set('transactionHistory', transactionHistory).set('loading', false);
        this.setState(updated);
    };

    KeyGoTransactionsStore.prototype.handleTransactionsLoading = function handleTransactionsLoading() {
        this.setState(this.state.set('loading', true));
    };

    KeyGoTransactionsStore.prototype.getTransactionHistory = function getTransactionHistory() {
        return this.get('transactionHistory');
    };

    KeyGoTransactionsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.KEYGO_TRANSACTIONS_LOADING] = this.handleTransactionsLoading, _ref2[_AppConstants.ActionTypes.KEYGO_TRANSACTIONS_LOADED] = this.handleTransactionsLoaded, _ref2[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref2;
    };

    (0, _createClass3.default)(KeyGoTransactionsStore, [{
        key: 'loading',
        get: function get() {
            return this.get('loading');
        }
    }]);
    return KeyGoTransactionsStore;
}(_BaseStore3.default);

exports.default = new KeyGoTransactionsStore();

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _capitalize2 = __webpack_require__(623);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _JourneyPattern = __webpack_require__(1733);

var _JourneyPattern2 = _interopRequireDefault(_JourneyPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "transactionId": [_LinkMapper.resolve.with(Number)],
    "description": [_LinkMapper.resolve.with(String)],
    "timestamp": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "type": [_LinkMapper.resolve.with(String)],
    "value": [_LinkMapper.resolve.with(Number)],
    "balance": [_LinkMapper.resolve.with(Number)],
    "status": [_LinkMapper.resolve.with(String)],
    "journeyPattern": [_LinkMapper.resolve.as(_JourneyPattern2.default)],
    "reasonDescription": [_LinkMapper.fields.string],
    "reasonCode": [_LinkMapper.fields.string]
};

var actOnEachWord = function actOnEachWord(string, func) {
    return string.split(' ').map(function (str) {
        return func(str);
    }).join(' ');
};

var capitalizeAsTitle = function capitalizeAsTitle(str) {
    if (/^(for|on)$/.test(str.toLowerCase())) {
        return str;
    }
    return (0, _capitalize3.default)(str);
};

var Transaction = function (_record) {
    (0, _inherits3.default)(Transaction, _record);

    function Transaction() {
        (0, _classCallCheck3.default)(this, Transaction);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Transaction.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var returnVal = (0, _LinkMapper.construct)(Transaction, json, (0, _Records.getResolvers)(fieldSchema));
        return returnVal;
    };

    Transaction.prototype.isParsedTransaction = function isParsedTransaction() {
        return this.reasonDescription && this.reasonCode;
    };

    Transaction.prototype.isBalanceAdjustment = function isBalanceAdjustment() {
        return this.isParsedTransaction() && /\|\|\|/.test(this.reasonDescription);
    };

    Transaction.prototype.isReimbursement = function isReimbursement() {
        return this.isParsedTransaction() && !/\|\|\|/.test(this.reasonDescription);
    };

    Transaction.prototype.parseAdjustedTransactionDescription = function parseAdjustedTransactionDescription() {
        return this.reasonDescription.replace(/.*\|\|\|/, '');
    };

    Transaction.prototype.parseAdjustedTransactionReason = function parseAdjustedTransactionReason() {
        return this.reasonDescription.split(/\|\|\|/)[0];
    };

    Transaction.prototype.getDescription = function getDescription() {
        if (this.isBalanceAdjustment()) {
            return actOnEachWord(this.parseAdjustedTransactionDescription(), capitalizeAsTitle);
        }
        if (this.isReimbursement()) {
            return (0, _I18n2.default)('account.smartcard.keygo.reimbursement.description');
        }
        return actOnEachWord(this.description, _capitalize3.default);
    };

    Transaction.prototype.getType = function getType() {
        if (this.isBalanceAdjustment()) {
            return (0, _I18n2.default)('account.smartcard.keygo.balanceAdjustmentCode.' + this.reasonCode);
        }
        if (this.isReimbursement()) {
            return (0, _I18n2.default)('account.smartcard.keygo.manualRefundCode.' + this.reasonCode);
        }
        return this.type.toLowerCase();
    };

    return Transaction;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Transaction;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _Journey = __webpack_require__(1077);

var _Journey2 = _interopRequireDefault(_Journey);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "ticketId": [_LinkMapper.resolve.with(Number)],
    "description": [_LinkMapper.resolve.with(String)],
    "destinationCode": [_LinkMapper.resolve.with(String)],
    "destinationName": [_LinkMapper.resolve.with(String)],
    "fare": [_LinkMapper.resolve.with(Number)],
    "fulfilmentType": [_LinkMapper.resolve.with(String)],
    "journeys": [_LinkMapper.resolveAll.as(_Journey2.default)],
    "originalFare": [_LinkMapper.resolve.with(Number)],
    "originCode": [_LinkMapper.resolve.with(String)],
    "originName": [_LinkMapper.resolve.with(String)],
    "railcard": [_LinkMapper.resolve.with(String)],
    "reasonCode": [_LinkMapper.resolve.with(String)],
    "saleType": [_LinkMapper.resolve.with(String)],
    "ticketCategory": [_LinkMapper.resolve.with(String)],
    "transitMode": [_LinkMapper.resolve.with(String)],
    "validityEndDate": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "validityStartDate": [_LinkMapper.resolve.with(_TrainTime2.default)]
};

var Ticket = function (_record) {
    (0, _inherits3.default)(Ticket, _record);

    function Ticket() {
        (0, _classCallCheck3.default)(this, Ticket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Ticket.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Ticket, json, (0, _Records.getResolvers)(fieldSchema));
    };

    Ticket.prototype.isBus = function isBus() {
        return this.transitMode.toUpperCase() === _AppConstants.IBlocksTransitModes.BUS;
    };

    Ticket.prototype.isSmartCarnet = function isSmartCarnet() {
        return this.fulfilmentType && this.fulfilmentType.toUpperCase().trim() === 'CLOUD' && this.saleType.toUpperCase().trim() === 'PREPAID' && this.ticketCategory.toUpperCase().trim() === 'FLEXI_PASS';
    };

    Ticket.prototype.isSmartCarnetOffPeak = function isSmartCarnetOffPeak() {
        return this.description.toLowerCase().includes('off');
    };

    return Ticket;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Ticket;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _BrandSplitSuccess = __webpack_require__(1850);

var _BrandSplitSuccess2 = _interopRequireDefault(_BrandSplitSuccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandSplitModal = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(BrandSplitModal, _React$PureComponent);

    function BrandSplitModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BrandSplitModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            brandChosen: 'thameslink'
        }, _this._handleContinue = function () {
            _CustomerActions2.default.setPreferredBrand(_UserStore2.default.getCurrent(), _this.state.brandChosen);
            _ModalActions2.default.open(_BrandSplitSuccess2.default, { brand: _this.state.brandChosen });
        }, _this._renderHeader = function () {
            return _react2.default.createElement(
                'h4',
                { className: 'modal-title text-left' },
                (0, _I18n.translate)('brand.split.header')
            );
        }, _this._handleSelection = function (brandChosen) {
            return function () {
                return _this.setState({ brandChosen: brandChosen });
            };
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    BrandSplitModal.prototype._renderOption = function _renderOption(brandName) {
        var logo = '/images/logos/' + brandName + '-logo-mobile.png';
        var selected = this.state.brandChosen === brandName;

        var iconClassNames = (0, _classnames2.default)('brand-selector__radio otrl', {
            'otrl-select': !selected,
            'otrl-selected': selected
        });
        var classes = (0, _classnames2.default)('brand-selector ' + brandName + ' box box--padded box--rounded box--clickable');
        return _react2.default.createElement(
            'div',
            { id: 'brand-container', className: classes, onClick: this._handleSelection(brandName) },
            _react2.default.createElement('img', { src: logo, alt: brandName }),
            _react2.default.createElement(
                'div',
                { className: 'pull-right text-right' },
                _react2.default.createElement(
                    'span',
                    { className: iconClassNames },
                    _react2.default.createElement('input', { type: 'radio',
                        name: 'brandChosen',
                        checked: selected,
                        onChange: this._handleSelection(brandName) })
                )
            )
        );
    };

    BrandSplitModal.prototype.render = function render() {
        var modalProps = {
            show: this.props.show,
            className: 'modal--xs',
            onContinue: this._handleContinue,
            continueText: 'button.text.select',
            header: this._renderHeader(),
            hideClose: true,
            disableEscape: true
        };
        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'div',
                { className: 'vertical-align-parent full-height' },
                _react2.default.createElement(
                    'form',
                    { name: 'brand' },
                    _react2.default.createElement(
                        'div',
                        { className: 'padding-top--sm' },
                        _react2.default.createElement(
                            'p',
                            { className: 'text-secondary text-weight--normal' },
                            (0, _I18n.translate)('brand.split.text')
                        ),
                        this._renderOption('thameslink'),
                        this._renderOption('greatnorthern')
                    )
                )
            )
        );
    };

    return BrandSplitModal;
}(_react2.default.PureComponent), _class.propTypes = {
    show: _propTypes2.default.bool
}, _class.defaultProps = {
    show: true
}, _temp2);
exports.default = BrandSplitModal;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TicketOffice = __webpack_require__(604);

var _TicketOffice2 = _interopRequireDefault(_TicketOffice);

var _PaperSeasonTicket = __webpack_require__(654);

var _PaperSeasonTicket2 = _interopRequireDefault(_PaperSeasonTicket);

var _InvalidPaperSeasonTicket = __webpack_require__(1734);

var _InvalidPaperSeasonTicket2 = _interopRequireDefault(_InvalidPaperSeasonTicket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "collectionLocation": [_LinkMapper.resolveAll.as(_Station2.default), new _immutable.List()],
    "ticketOffices": [_LinkMapper.resolveAll.as(_TicketOffice2.default), new _immutable.List()],
    "tickets": [_LinkMapper.resolveAll.as(_PaperSeasonTicket2.default), new _immutable.List()],
    "invalidTickets": [_LinkMapper.resolveAll.as(_InvalidPaperSeasonTicket2.default), new _immutable.List()]
};

var PaperSeasonTicketResults = function (_record) {
    (0, _inherits3.default)(PaperSeasonTicketResults, _record);

    function PaperSeasonTicketResults() {
        (0, _classCallCheck3.default)(this, PaperSeasonTicketResults);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PaperSeasonTicketResults.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(PaperSeasonTicketResults, json, (0, _Records.getResolvers)(fieldSchema));
    };

    PaperSeasonTicketResults.prototype.hasTickets = function hasTickets() {
        return this.tickets && this.tickets.size > 0;
    };

    PaperSeasonTicketResults.prototype.hasInvalidTickets = function hasInvalidTickets() {
        return this.invalidTickets && this.invalidTickets.size > 0;
    };

    return PaperSeasonTicketResults;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = PaperSeasonTicketResults;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.IBlocksApiError = exports.IBlocksCompleteJourneyError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError3 = __webpack_require__(91);

var _ExtendableError4 = _interopRequireDefault(_ExtendableError3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IBlocksCompleteJourneyError = exports.IBlocksCompleteJourneyError = function (_ExtendableError) {
  (0, _inherits3.default)(IBlocksCompleteJourneyError, _ExtendableError);

  function IBlocksCompleteJourneyError() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IBlocksCompleteJourneyError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'IBlocksCompleteJourneyError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return IBlocksCompleteJourneyError;
}(_ExtendableError4.default);

var IBlocksApiError = exports.IBlocksApiError = function (_ExtendableError2) {
  (0, _inherits3.default)(IBlocksApiError, _ExtendableError2);

  function IBlocksApiError() {
    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, IBlocksApiError);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ExtendableError2.call.apply(_ExtendableError2, [this].concat(args))), _this2), _this2.name = 'IBlocksApiError', _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  return IBlocksApiError;
}(_ExtendableError4.default);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _findIndex2 = __webpack_require__(434);

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

exports.getCustomerSmartcardLinkedAccountsUrl = getCustomerSmartcardLinkedAccountsUrl;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _Image = __webpack_require__(1745);

var _Payment = __webpack_require__(423);

var _Smartcard = __webpack_require__(336);

var _CardLockService = __webpack_require__(1052);

var _CardLockService2 = _interopRequireDefault(_CardLockService);

var _Smartcard2 = __webpack_require__(332);

var _Smartcard3 = _interopRequireDefault(_Smartcard2);

var _KeyGoTransaction = __webpack_require__(1758);

var _KeyGoTransaction2 = _interopRequireDefault(_KeyGoTransaction);

var _SmartcardJourneyRecord = __webpack_require__(1761);

var _SmartcardJourneyRecord2 = _interopRequireDefault(_SmartcardJourneyRecord);

var _SmartcardAssociationInfo = __webpack_require__(674);

var _SmartcardAssociationInfo2 = _interopRequireDefault(_SmartcardAssociationInfo);

var _SmartcardAccountInfo = __webpack_require__(1762);

var _SmartcardAccountInfo2 = _interopRequireDefault(_SmartcardAccountInfo);

var _SmartcardAssociationConfirmation = __webpack_require__(1763);

var _SmartcardAssociationConfirmation2 = _interopRequireDefault(_SmartcardAssociationConfirmation);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCustomerSmartcardUrl(user) {
    return '/customers/:id/smartcard'.replace(/:id\b/, user.id);
}

function getCustomerSmartcardPhotoUrl(user) {
    return '/smartcard/:id/child/photo'.replace(/:id\b/, user.id);
}

function getCustomerLinkSmartcardUrl(user) {
    return '/smartcard/:id/self-registration'.replace(/:id\b/, user.id);
}

function getCustomerSmartcardsUrl(user) {
    return '/customers/:id/smartcards'.replace(/:id\b/, user.id);
}

function getCustomerSmartcardLinkedAccountsUrl(user) {
    return 'customers/:id/smartcard/linked-accounts'.replace(/:id\b/, decodeURIComponent(user.id));
}

function getCustomerSmartcardActiveLinkedAccountsUrl(user) {
    return 'smartcard/linked-accounts/:id/active'.replace(/:id\b/, decodeURIComponent(user.id));
}

function getCustomerUnlinkSmartcardUrl(user, associatedSmartcard) {
    return '/smartcard/linked-accounts/:id/unlink/:linkId'.replace(/:id\b/, decodeURIComponent(user.id)).replace(/:linkId\b/, associatedSmartcard.associationId);
}

function getConfirmSmartcardLinkUrl(customerId, choice, token) {
    return '/smartcard/linked-accounts/:customerId/:choice/:token'.replace(/:customerId\b/, customerId).replace(/:choice\b/, choice).replace(/:token\b/, decodeURIComponent(token));
}

function getCustomerKeyGoResumeUrl(user, paymentId) {
    return '/customers/:customerId/keygo/resume/:paymentId'.replace(/:customerId\b/, user).replace(/:paymentId\b/, paymentId);
}

var SmartcardService = {
    getSmartcard: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var enableCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var options, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(user.isLoggedIn() && user.smartcardRegistered)) {
                                _context.next = 6;
                                break;
                            }

                            options = enableCache ? {} : { headers: { 'x-non-cached': 'true' } };
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get(getCustomerSmartcardUrl(user), {}, options);

                        case 4:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Smartcard3.default));

                        case 6:
                            return _context.abrupt('return', null);

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function getSmartcard(_x2) {
            return _ref.apply(this, arguments);
        }

        return getSmartcard;
    }(),
    getSmartcardPhoto: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user) {
            var response, typ, value;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(user.isLoggedIn() && user.smartcardRegistered)) {
                                _context2.next = 12;
                                break;
                            }

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _AuthenticatedAPIClient2.default.get(getCustomerSmartcardPhotoUrl(user));

                        case 4:
                            response = _context2.sent;
                            typ = response.typ, value = response.value;
                            return _context2.abrupt('return', value ? 'data:' + typ + ';base64,' + value : null);

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](1);
                            return _context2.abrupt('return', null);

                        case 12:
                            return _context2.abrupt('return', null);

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 9]]);
        }));

        function getSmartcardPhoto(_x3) {
            return _ref2.apply(this, arguments);
        }

        return getSmartcardPhoto;
    }(),
    uploadNewSmartcardPhoto: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user, photo) {
            var processedPhoto, typ;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return (0, _Image.processImage)({ file: photo.selectedImage, maxWidth: 4096, maxHeight: 4096, useBase64: true });

                        case 3:
                            processedPhoto = _context3.sent;
                            typ = photo.selectedImage.type.replace('image/', '').replace('jpeg', 'jpg'); // SE systems don't support jpeg file extension so just use 'jpg'

                            _context3.next = 7;
                            return _AuthenticatedAPIClient2.default.post(getCustomerSmartcardPhotoUrl(user), { typ: typ, value: processedPhoto });

                        case 7:
                            return _context3.abrupt('return', true);

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](0);

                            _NotificationActions2.default.showNotification('account.details.updateErrorNewPhoto');
                            return _context3.abrupt('return', false);

                        case 14:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 10]]);
        }));

        function uploadNewSmartcardPhoto(_x4, _x5) {
            return _ref3.apply(this, arguments);
        }

        return uploadNewSmartcardPhoto;
    }(),
    getAllSmartcards: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(user) {
            var response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!user.isLoggedIn()) {
                                _context4.next = 5;
                                break;
                            }

                            _context4.next = 3;
                            return _AuthenticatedAPIClient2.default.get(getCustomerSmartcardsUrl(user));

                        case 3:
                            response = _context4.sent;
                            return _context4.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Smartcard3.default));

                        case 5:
                            return _context4.abrupt('return', null);

                        case 6:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function getAllSmartcards(_x6) {
            return _ref4.apply(this, arguments);
        }

        return getAllSmartcards;
    }(),
    registerKeyGo: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(user, form) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return this.submitKeyGo(user, form);

                        case 2:
                            return _context5.abrupt('return', _context5.sent);

                        case 3:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function registerKeyGo(_x7, _x8) {
            return _ref5.apply(this, arguments);
        }

        return registerKeyGo;
    }(),
    getSmartcardFormData: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(user, form) {
            var isOver16, files, data, processedPhoto;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            isOver16 = form.isOver16 || form.dateOfBirth.isOverAge(16);
                            files = void 0;
                            data = (0, _extends3.default)({
                                contactName: user.fullName,
                                line1: form.addressLine1 || '',
                                line2: form.addressLine2 || '',
                                line3: form.addressLine3 || '',
                                postCode: form.postcode || '',
                                town: form.townCity,
                                country: form.country,
                                autoDrOptedIn: Boolean(form.autoDrOptedIn)
                            }, !isOver16 && { dateOfBirth: form.dateOfBirth.getDateOfBirth().format('YYYY-MM-DD') });

                            if (!form.requiresPhotograph()) {
                                _context6.next = 8;
                                break;
                            }

                            _context6.next = 6;
                            return (0, _Image.processImage)({ file: form.photo.selectedImage, maxWidth: 4096, maxHeight: 4096 });

                        case 6:
                            processedPhoto = _context6.sent;


                            files = {
                                photo: processedPhoto || form.photo.selectedImage
                            };

                        case 8:
                            return _context6.abrupt('return', [data, files]);

                        case 9:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function getSmartcardFormData(_x9, _x10) {
            return _ref6.apply(this, arguments);
        }

        return getSmartcardFormData;
    }(),
    getLinkedSmartcardData: function getLinkedSmartcardData(user, form) {
        var isOver16 = form.isOver16 || form.dateOfBirth.isOverAge(16);

        var data = (0, _extends3.default)({
            title: user.title,
            forename: user.firstNames,
            surname: user.surname,
            address: {
                line1: form.addressLine1 || '',
                line2: form.addressLine2 || '',
                line3: form.addressLine3 || '',
                postCode: form.postcode || '',
                town: form.townCity
            },
            email: user.email,
            smartcardNumber: form.isrn.split('-').join('')
        }, !isOver16 && { dateOfBirth: form.dateOfBirth.getDateOfBirth().format('YYYY-MM-DD') });
        return data;
    },
    handleSmartcardErrors: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(fn) {
            var errors, errorMessage;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.prev = 0;
                            _context7.next = 3;
                            return fn();

                        case 3:
                            return _context7.abrupt('return', _context7.sent);

                        case 6:
                            _context7.prev = 6;
                            _context7.t0 = _context7['catch'](0);
                            errors = (0, _result3.default)(_context7.t0, ['body', 'errors'], []);

                            if (!('SmartcardServiceError' in errors)) {
                                _context7.next = 16;
                                break;
                            }

                            console.error(_context7.t0);
                            errorMessage = errors.SmartcardServiceError[0];

                            if (!(errorMessage.indexOf('User already registered') !== -1)) {
                                _context7.next = 14;
                                break;
                            }

                            throw new _Smartcard.SmartcardAlreadyRegisteredError('User already registered in SEFT/smartcard');

                        case 14:
                            if (!(errorMessage.indexOf('locationAddrPostcode=FIELD_IS_BADLY_FORMATTED') !== -1)) {
                                _context7.next = 16;
                                break;
                            }

                            throw new _Smartcard.SmartcardPostcodeError('Failed postcode check', { error: _context7.t0 });

                        case 16:
                            throw _context7.t0;

                        case 17:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[0, 6]]);
        }));

        function handleSmartcardErrors(_x11) {
            return _ref7.apply(this, arguments);
        }

        return handleSmartcardErrors;
    }(),
    registerSmartcard: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(user, form) {
            var _this = this;

            var _ref9, data, files, url;

            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return this.getSmartcardFormData(user, form);

                        case 2:
                            _ref9 = _context9.sent;
                            data = _ref9[0];
                            files = _ref9[1];
                            url = getCustomerSmartcardUrl(user);
                            return _context9.abrupt('return', this.handleSmartcardErrors((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
                                return _regenerator2.default.wrap(function _callee8$(_context8) {
                                    while (1) {
                                        switch (_context8.prev = _context8.next) {
                                            case 0:
                                                _context8.next = 2;
                                                return _AuthenticatedAPIClient2.default.postForm(url, data, files);

                                            case 2:
                                                return _context8.abrupt('return', _context8.sent);

                                            case 3:
                                            case 'end':
                                                return _context8.stop();
                                        }
                                    }
                                }, _callee8, _this);
                            }))));

                        case 7:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function registerSmartcard(_x12, _x13) {
            return _ref8.apply(this, arguments);
        }

        return registerSmartcard;
    }(),
    linkSmartcard: function linkSmartcard(user, form) {
        var _this2 = this;

        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _type$isUpdate = type.isUpdate,
            isUpdate = _type$isUpdate === undefined ? false : _type$isUpdate;

        var data = this.getLinkedSmartcardData(user, form);
        var url = getCustomerLinkSmartcardUrl(user);
        return this.handleSmartcardErrors((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.next = 2;
                            return _AuthenticatedAPIClient2.default[isUpdate ? 'put' : 'post'](url, data);

                        case 2:
                            return _context10.abrupt('return', _context10.sent);

                        case 3:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this2);
        })));
    },
    updateKeyGo: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(user, form) {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.next = 2;
                            return this.submitKeyGo(user, form, 'put');

                        case 2:
                            return _context11.abrupt('return', _context11.sent);

                        case 3:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this);
        }));

        function updateKeyGo(_x15, _x16) {
            return _ref12.apply(this, arguments);
        }

        return updateKeyGo;
    }(),
    keyGoResume: function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(userId, paymentId) {
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return _AuthenticatedAPIClient2.default.get(getCustomerKeyGoResumeUrl(userId, paymentId));

                        case 2:
                            return _context12.abrupt('return', _context12.sent);

                        case 3:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function keyGoResume(_x17, _x18) {
            return _ref13.apply(this, arguments);
        }

        return keyGoResume;
    }(),
    submitKeyGo: function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(user, form) {
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
            var token, url, requestBody, response, message, errors;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.next = 2;
                            return _CardLockService2.default.getToken(form.cardNumber, form.cv2);

                        case 2:
                            token = _context13.sent;
                            url = getCustomerSmartcardUrl(user) + '/keygo';
                            requestBody = {
                                collectionLocationNlc: form.collectionLocation,
                                cards: [{
                                    token: token,
                                    nickname: form.nickname,
                                    cardHolderName: form.cardHolderName,
                                    expiryDate: form.expiryMonth + '/' + form.expiryYear,
                                    email: user.email,
                                    phone: '00000000000',
                                    address: {
                                        line1: form.addressLine1,
                                        line2: form.addressLine2,
                                        line3: form.addressLine3,
                                        town: form.townCity,
                                        postCode: form.postcode,
                                        country: form.country
                                    }
                                }]
                            };
                            _context13.prev = 5;
                            _context13.next = 8;
                            return _AuthenticatedAPIClient2.default[method](url, requestBody);

                        case 8:
                            response = _context13.sent;

                            if (!((0, _result3.default)(response, 'status') === 'failed')) {
                                _context13.next = 11;
                                break;
                            }

                            throw new _Payment.PaymentUnauthorizedError(response.message);

                        case 11:
                            return _context13.abrupt('return', response);

                        case 14:
                            _context13.prev = 14;
                            _context13.t0 = _context13['catch'](5);
                            message = _context13.t0.message;
                            errors = (0, _result3.default)(_context13.t0, ['body', 'errors'], []);

                            if (!((0, _findIndex3.default)(errors, 'code', _Smartcard.ACTError.code) !== -1)) {
                                _context13.next = 22;
                                break;
                            }

                            throw new _Smartcard.ACTError(message);

                        case 22:
                            throw new _Payment.PaymentUnauthorizedError(message);

                        case 23:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, this, [[5, 14]]);
        }));

        function submitKeyGo(_x20, _x21) {
            return _ref14.apply(this, arguments);
        }

        return submitKeyGo;
    }(),
    cancelKeyGo: function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(user) {
            var url;
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            url = getCustomerSmartcardUrl(user) + '/keygo';
                            _context14.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(url);

                        case 3:
                            return _context14.abrupt('return', _context14.sent);

                        case 4:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, this);
        }));

        function cancelKeyGo(_x22) {
            return _ref15.apply(this, arguments);
        }

        return cancelKeyGo;
    }(),
    getKeyGoTaps: function getKeyGoTaps(user, smartcard) {
        if (!smartcard.hasKeyGo()) {
            return _promise2.default.reject();
        }

        var url = getCustomerSmartcardUrl(user) + '/keygo/taps';
        var format = 'YYYY-MM-DD';
        var keyGoStart = smartcard.getKeyGoProduct().parameters.StartDate;

        var today = (0, _TrainTime2.default)().startOf('day');
        var start = (0, _TrainTime2.default)().subtract(2, 'months').startOf('day');
        if (start.isBefore(keyGoStart)) {
            start = keyGoStart.clone();
        }

        var requests = [];

        while (start.isBefore(today)) {
            var end = start.clone().add(1, 'month');
            if (end.isAfter(today)) {
                end = today.clone();
            }

            var startDate = start.format(format);
            var endDate = end.format(format);
            requests.push(_AuthenticatedAPIClient2.default.get(url, { startDate: startDate, endDate: endDate }));

            start = end.clone();
        }

        return _promise2.default.all(requests).then(function (responses) {
            var _ref16;

            var taps = responses.map(function (response) {
                return (0, _LinkMapper.resolveAll)(response.transactions).as(_KeyGoTransaction2.default);
            });
            return (_ref16 = new _immutable.List()).concat.apply(_ref16, taps).sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(b.dateTime) - new Date(a.dateTime);
            });
        });
    },
    getJourneys: function () {
        var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(user, smartcard) {
            var url, response;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            if (!smartcard.hasKeyGo()) {
                                _context15.next = 2;
                                break;
                            }

                            return _context15.abrupt('return', _promise2.default.reject());

                        case 2:
                            url = getCustomerSmartcardUrl(user) + '/journeys';
                            _context15.next = 5;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 5:
                            response = _context15.sent;
                            return _context15.abrupt('return', (0, _LinkMapper.resolveAll)(response).as(_SmartcardJourneyRecord2.default).filter(function (record) {
                                return record.isJourney();
                            }));

                        case 7:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, this);
        }));

        function getJourneys(_x23, _x24) {
            return _ref17.apply(this, arguments);
        }

        return getJourneys;
    }(),
    fetchChildSmartcardReplacement: function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(user) {
            var url;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            url = '/smartcard/' + user.id + '/preferences';
                            _context16.next = 3;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 3:
                            return _context16.abrupt('return', _context16.sent);

                        case 4:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, this);
        }));

        function fetchChildSmartcardReplacement(_x25) {
            return _ref18.apply(this, arguments);
        }

        return fetchChildSmartcardReplacement;
    }(),
    requestChildSmartcardReplacement: function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(_ref19) {
            var user = _ref19.user,
                isCardReplacementRequested = _ref19.isCardReplacementRequested;
            var url;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            url = '/smartcard/' + user.id + '/preferences';
                            _context17.next = 3;
                            return _AuthenticatedAPIClient2.default.put(url, { isCardReplacementRequested: isCardReplacementRequested });

                        case 3:
                            return _context17.abrupt('return', _context17.sent);

                        case 4:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, this);
        }));

        function requestChildSmartcardReplacement(_x26) {
            return _ref20.apply(this, arguments);
        }

        return requestChildSmartcardReplacement;
    }(),
    replaceSmartcard: function () {
        var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(user, _ref21) {
            var reason = _ref21.reason,
                additionalDetails = _ref21.additionalDetails,
                crimeNumber = _ref21.crimeNumber;
            var url;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            url = getCustomerSmartcardUrl(user) + '/replacement';
                            _context18.next = 3;
                            return _AuthenticatedAPIClient2.default.post(url, { reason: reason, additionalDetails: additionalDetails, crimeNumber: crimeNumber });

                        case 3:
                            return _context18.abrupt('return', _context18.sent);

                        case 4:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, this);
        }));

        function replaceSmartcard(_x27, _x28) {
            return _ref22.apply(this, arguments);
        }

        return replaceSmartcard;
    }(),
    getActiveAssociatedSmartcards: function () {
        var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(user) {
            var url, result;
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            url = getCustomerSmartcardActiveLinkedAccountsUrl(user);
                            _context19.prev = 1;
                            _context19.next = 4;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 4:
                            result = _context19.sent;
                            return _context19.abrupt('return', result);

                        case 8:
                            _context19.prev = 8;
                            _context19.t0 = _context19['catch'](1);

                            console.warn(_context19.t0);
                            throw _context19.t0;

                        case 12:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, this, [[1, 8]]);
        }));

        function getActiveAssociatedSmartcards(_x29) {
            return _ref23.apply(this, arguments);
        }

        return getActiveAssociatedSmartcards;
    }(),
    getAssociatedSmartcards: function () {
        var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(user, onlyActiveSmartcards) {
            var result, url, response, activeSmartcards;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            result = void 0;
                            _context20.prev = 1;
                            url = getCustomerSmartcardLinkedAccountsUrl(user) + '/smartcards';
                            _context20.next = 5;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 5:
                            response = _context20.sent;

                            if (!onlyActiveSmartcards) {
                                _context20.next = 13;
                                break;
                            }

                            _context20.next = 9;
                            return this.getActiveAssociatedSmartcards(user);

                        case 9:
                            activeSmartcards = _context20.sent;

                            result = response.result.reduce(function (acc, smartcard) {
                                var activeSmartcard = activeSmartcards.find(function (_ref25) {
                                    var isrn = _ref25.isrn;
                                    return isrn === smartcard.linkedSmartcardNumber;
                                });
                                if (activeSmartcard) {
                                    acc.push((0, _extends3.default)({}, smartcard, {
                                        expiryDate: activeSmartcard.expiryDate,
                                        cardHolderDateOfBirth: activeSmartcard.cardHolderDateOfBirth
                                    }));
                                }
                                return acc;
                            }, []);
                            _context20.next = 14;
                            break;

                        case 13:
                            result = response.result;

                        case 14:
                            _context20.next = 20;
                            break;

                        case 16:
                            _context20.prev = 16;
                            _context20.t0 = _context20['catch'](1);

                            console.warn(_context20.t0);
                            throw _context20.t0;

                        case 20:
                            return _context20.abrupt('return', (0, _LinkMapper.resolveAll)(result).as(_SmartcardAssociationInfo2.default));

                        case 21:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, this, [[1, 16]]);
        }));

        function getAssociatedSmartcards(_x30, _x31) {
            return _ref24.apply(this, arguments);
        }

        return getAssociatedSmartcards;
    }(),
    getAssociatedAccounts: function () {
        var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(user) {
            var url, response;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            url = getCustomerSmartcardLinkedAccountsUrl(user) + '/accounts';
                            response = void 0;
                            _context21.prev = 2;
                            _context21.next = 5;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 5:
                            response = _context21.sent;
                            _context21.next = 12;
                            break;

                        case 8:
                            _context21.prev = 8;
                            _context21.t0 = _context21['catch'](2);

                            console.warn(_context21.t0);
                            throw _context21.t0;

                        case 12:
                            return _context21.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_SmartcardAssociationInfo2.default));

                        case 13:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, this, [[2, 8]]);
        }));

        function getAssociatedAccounts(_x32) {
            return _ref26.apply(this, arguments);
        }

        return getAssociatedAccounts;
    }(),
    queryAvailableAssociations: function () {
        var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(user, query) {
            var url, response;
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            url = getCustomerSmartcardLinkedAccountsUrl(user) + '/search';
                            _context22.next = 3;
                            return _AuthenticatedAPIClient2.default.get(url, query);

                        case 3:
                            response = _context22.sent;
                            return _context22.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_SmartcardAccountInfo2.default));

                        case 5:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, this);
        }));

        function queryAvailableAssociations(_x33, _x34) {
            return _ref27.apply(this, arguments);
        }

        return queryAvailableAssociations;
    }(),
    associateSmartcard: function () {
        var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(user, smartcardNumber) {
            var url;
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            url = getCustomerSmartcardLinkedAccountsUrl(user) + '/link';
                            _context23.next = 3;
                            return _AuthenticatedAPIClient2.default.post(url, { smartcardNumber: smartcardNumber });

                        case 3:
                            return _context23.abrupt('return', _context23.sent);

                        case 4:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, this);
        }));

        function associateSmartcard(_x35, _x36) {
            return _ref28.apply(this, arguments);
        }

        return associateSmartcard;
    }(),
    dissociateSmartcard: function () {
        var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(user, associatedSmartcard) {
            var url;
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            url = getCustomerUnlinkSmartcardUrl(user, associatedSmartcard);
                            _context24.next = 3;
                            return _AuthenticatedAPIClient2.default.put(url);

                        case 3:
                            return _context24.abrupt('return', _context24.sent);

                        case 4:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, this);
        }));

        function dissociateSmartcard(_x37, _x38) {
            return _ref29.apply(this, arguments);
        }

        return dissociateSmartcard;
    }(),
    dissociateAccount: function () {
        var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(user, associatedSmartcard) {
            var url;
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            url = getCustomerUnlinkSmartcardUrl(user, associatedSmartcard);
                            _context25.next = 3;
                            return _AuthenticatedAPIClient2.default.put(url);

                        case 3:
                            return _context25.abrupt('return', _context25.sent);

                        case 4:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, this);
        }));

        function dissociateAccount(_x39, _x40) {
            return _ref30.apply(this, arguments);
        }

        return dissociateAccount;
    }(),
    confirmAssociation: function () {
        var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(customerId, choice, token) {
            var url, response;
            return _regenerator2.default.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            url = getConfirmSmartcardLinkUrl(customerId, choice, token);
                            _context26.next = 3;
                            return _AuthenticatedAPIClient2.default.put(url);

                        case 3:
                            response = _context26.sent;
                            return _context26.abrupt('return', (0, _LinkMapper.resolve)(response).as(_SmartcardAssociationConfirmation2.default));

                        case 5:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, this);
        }));

        function confirmAssociation(_x41, _x42, _x43) {
            return _ref31.apply(this, arguments);
        }

        return confirmAssociation;
    }()
};

exports.default = SmartcardService;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
    PropTypes = __webpack_require__(2),
    withSideEffect = __webpack_require__(1845);

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.title;
  }
}

function handleStateChangeOnClient(title) {
  var nextTitle = title || '';
  if (nextTitle !== document.title) {
    document.title = nextTitle;
  }
}

function DocumentTitle() {}
DocumentTitle.prototype = Object.create(React.Component.prototype);

DocumentTitle.displayName = 'DocumentTitle';
DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired
};

DocumentTitle.prototype.render = function() {
  if (this.props.children) {
    return React.Children.only(this.props.children);
  } else {
    return null;
  }
};

module.exports = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(DocumentTitle);


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.OpenGolfStore = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _OpenTicketSelector = __webpack_require__(1138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-unused-vars */
var DefaultOpenGolfState = new _immutable.Record({
    error: null,
    isLoadingTickets: false,
    loadingTrips: new _immutable.List(),
    tickets: null
});

var OpenGolfStore = exports.OpenGolfStore = function (_BaseStore) {
    (0, _inherits3.default)(OpenGolfStore, _BaseStore);

    function OpenGolfStore() {
        (0, _classCallCheck3.default)(this, OpenGolfStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    OpenGolfStore.prototype.deserialize = function deserialize() {
        return new DefaultOpenGolfState();
    };

    OpenGolfStore.prototype.handleAddTrip = function handleAddTrip(_ref) {
        var trip = _ref.trip;

        this.setState(this.state.merge({
            loadingTrips: this.getLoadingTrips().push(trip)
        }));
    };

    OpenGolfStore.prototype.handleOrderCreated = function handleOrderCreated() {
        this.setState(this.state.merge({
            loadingTrips: new _immutable.List()
        }));
    };

    OpenGolfStore.prototype.handleOrderTripCreated = function handleOrderTripCreated(_ref2) {
        var trip = _ref2.trip;

        this.setState(this.state.merge({
            loadingTrips: new _immutable.List()
        }));
    };

    OpenGolfStore.prototype.handleOrderTripDeleted = function handleOrderTripDeleted(_ref3) {
        var trip = _ref3.orderTrip;

        this.setState(this.state.merge({
            loadingTrips: new _immutable.List()
        }));
    };

    OpenGolfStore.prototype.handleGetTicketsStarted = function handleGetTicketsStarted() {
        this.setState(this.state.merge({
            error: null,
            isLoadingTickets: true
        }));
    };

    OpenGolfStore.prototype.handleGetTicketsEnded = function handleGetTicketsEnded(_ref4) {
        var tickets = _ref4.tickets;

        this.setState(this.state.merge({
            tickets: tickets,
            isLoadingTickets: false
        }));
    };

    OpenGolfStore.prototype.handleGetTicketsFailed = function handleGetTicketsFailed(_ref5) {
        var error = _ref5.error;

        this.setState(this.state.merge({
            error: error,
            isLoadingTickets: false
        }));
    };

    OpenGolfStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref6;

        return _ref6 = {}, _ref6[_AppConstants.ActionTypes.OPEN_GOLF_GET_TICKETS_STARTED] = this.handleGetTicketsStarted, _ref6[_AppConstants.ActionTypes.OPEN_GOLF_GET_TICKETS_ENDED] = this.handleGetTicketsEnded, _ref6[_AppConstants.ActionTypes.OPEN_GOLF_GET_TICKETS_FAILED] = this.handleGetTicketsFailed, _ref6[_AppConstants.ActionTypes.OPEN_GOLF_ADD_TRIP] = this.handleAddTrip, _ref6[_AppConstants.ActionTypes.ORDER_CREATED] = this.handleOrderCreated, _ref6[_AppConstants.ActionTypes.ORDER_TRIP_CREATED] = this.handleOrderTripCreated, _ref6[_AppConstants.ActionTypes.ORDER_TRIP_DELETED] = this.handleOrderTripDeleted, _ref6;
    };

    OpenGolfStore.prototype.getError = function getError() {
        return this.get('error');
    };

    OpenGolfStore.prototype.getIsLoadingTickets = function getIsLoadingTickets() {
        return this.get('isLoadingTickets');
    };

    OpenGolfStore.prototype.getLoadingTrips = function getLoadingTrips() {
        return this.get('loadingTrips');
    };

    OpenGolfStore.prototype.getTickets = function getTickets() {
        return this.get('tickets');
    };

    return OpenGolfStore;
}(_BaseStore3.default);

var instance = new OpenGolfStore();

exports.default = instance;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compareTrips = undefined;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPEN_TICKET_DATE_FORMAT = 'ddd Do';

var compareTrips = exports.compareTrips = function compareTrips(orderFare, ticketFare) {
    var areEqual = false;

    var orderFareMap = new _immutable.Map(orderFare.outwardValidity ? orderFare.outwardValidity : orderFare.outwardJourney);
    var ticketFareMap = new _immutable.Map(ticketFare.outwardValidity ? ticketFare.outwardValidity : ticketFare.outwardJourney);
    var orderFareValidity = {
        from: orderFareMap.get('validFrom') || orderFareMap.get('from'),
        until: orderFareMap.get('validTo') || orderFareMap.get('until')
    };
    var ticketFareValidity = {
        from: ticketFareMap.get('validFrom') || ticketFareMap.get('from'),
        until: ticketFareMap.get('validTo') || ticketFareMap.get('until')
    };

    if (orderFare.origin && ticketFare.origin && orderFare.origin.nlc === ticketFare.origin.nlc && orderFare.destination.nlc === ticketFare.destination.nlc && orderFare.ticketType.code === ticketFare.ticketType.code && orderFareValidity.from.isSame(ticketFareValidity.from, 'day') && orderFareValidity.until.isSame(ticketFareValidity.until, 'day')) {
        areEqual = true;
    }

    return areEqual;
};

var OpenTicketSelector = function OpenTicketSelector(_ref) {
    var _ref$currentTicket = _ref.currentTicket,
        currentTicket = _ref$currentTicket === undefined ? null : _ref$currentTicket,
        _ref$isExpanded = _ref.isExpanded,
        isExpanded = _ref$isExpanded === undefined ? false : _ref$isExpanded,
        _ref$loadingTrips = _ref.loadingTrips,
        loadingTrips = _ref$loadingTrips === undefined ? [] : _ref$loadingTrips,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? _noop3.default : _ref$onClick,
        _ref$onTicketSelect = _ref.onTicketSelect,
        onTicketSelect = _ref$onTicketSelect === undefined ? _noop3.default : _ref$onTicketSelect,
        _ref$order = _ref.order,
        order = _ref$order === undefined ? null : _ref$order,
        _ref$tickets = _ref.tickets,
        tickets = _ref$tickets === undefined ? [] : _ref$tickets;

    var isSelected = function isSelected(fare) {
        var isTicketLoading = false;
        var isTicketSelected = false;
        var orderTrip = null;

        if (order) {
            order.trips.map(function (trip) {
                if (trip && trip.fares && trip.fares.return) {
                    if (compareTrips(trip.fares.return, fare)) {
                        orderTrip = trip;
                        isTicketSelected = true;
                    }
                }
            });
        }

        if (loadingTrips) {
            loadingTrips.map(function (trip) {
                if (compareTrips(trip, fare)) {
                    isTicketLoading = true;
                }
            });
        }

        return { isTicketSelected: isTicketSelected, isTicketLoading: isTicketLoading, orderTrip: orderTrip };
    };

    var getFromValidDate = function getFromValidDate(ticket) {
        return (0, _TrainTime2.default)(ticket.outwardValidity.from).format(OPEN_TICKET_DATE_FORMAT);
    };
    var getUntilValidDate = function getUntilValidDate(ticket) {
        return (0, _TrainTime2.default)(ticket.outwardValidity.until).format(OPEN_TICKET_DATE_FORMAT);
    };

    var sortedTickets = tickets ? [].concat(tickets.toJS().filter(function (ticket) {
        return ticket.outwardValidity && ticket.ticketType.code === 'OG' + currentTicket;
    })).sort(function (a, b) {
        return a.outwardValidity.from.isAfter(b.outwardValidity.from) ? 1 : -1;
    }) : [];

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)('open-ticket-selector', {
                'open-ticket-selector--expanded': isExpanded
            })
        },
        _react2.default.createElement(
            'div',
            { className: 'open-ticket-selector__header', onClick: onClick },
            _react2.default.createElement(
                'div',
                { className: 'open-ticket-selector__header__titles' },
                _react2.default.createElement(
                    'h4',
                    { className: 'open-ticket-selector__header__title' },
                    (0, _I18n2.default)('openGolf.tickets.day' + currentTicket)
                ),
                _react2.default.createElement(
                    'h5',
                    { className: 'open-ticket-selector__header__subtitle' },
                    (0, _I18n2.default)('openGolf.selector.subtitle')
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Icon2.default, { icon: 'chevron', className: 'open-ticket-selector__header__icon otrl-rotate-' + (isExpanded ? 270 : 90) })
            )
        ),
        _react2.default.createElement(
            'table',
            { className: 'open-ticket-selector__tickets' },
            _react2.default.createElement(
                'tbody',
                null,
                isExpanded && sortedTickets && sortedTickets.map(function (ticket) {
                    var _isSelected = isSelected(ticket),
                        isTicketSelected = _isSelected.isTicketSelected,
                        isTicketLoading = _isSelected.isTicketLoading,
                        orderTrip = _isSelected.orderTrip;

                    var appliedRailcards = ticket.tickets.map(function (cur) {
                        return cur.railcard;
                    }).filter(function (cur) {
                        return !!cur;
                    });
                    var hasRailcards = appliedRailcards.length > 0;
                    var isPriceReduced = ticket.totalPrice < ticket.originalTotalPrice;
                    return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            'tr',
                            { className: (0, _classnames2.default)('open-ticket-selector__tickets__ticket', { 'open-ticket-selector__tickets__ticket--no-railcards': hasRailcards }), key: ticket.id },
                            _react2.default.createElement(
                                'td',
                                { className: 'open-ticket-selector__tickets__ticket__date' },
                                getFromValidDate(ticket) === getUntilValidDate(ticket) ? getFromValidDate(ticket) : getFromValidDate(ticket) + ' - ' + getUntilValidDate(ticket)
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'open-ticket-selector__tickets__ticket__price' },
                                isPriceReduced ? _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    _react2.default.createElement(_Price2.default, { price: ticket.totalPrice }),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'open-ticket-selector__tickets__ticket__price__reduced' },
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(_Price2.default, { price: ticket.originalTotalPrice })
                                    )
                                ) : _react2.default.createElement(_Price2.default, { price: ticket.totalPrice })
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'open-ticket-selector__tickets__ticket__cta' },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: (0, _classnames2.default)('btn-compact open-ticket-selector__tickets__ticket__cta__button', { 'open-ticket-selector__tickets__ticket__cta__button--remove': isTicketSelected }),
                                        onClick: !isTicketLoading ? onTicketSelect(ticket.id, orderTrip) : _noop3.default
                                    },
                                    isTicketLoading ? _react2.default.createElement('span', { className: 'otrl circle-spinner otrl circle-spinner--small' }) : isTicketSelected ? _react2.default.createElement(
                                        _react2.default.Fragment,
                                        null,
                                        _react2.default.createElement(_Icon2.default, { icon: 'bin' }),
                                        ' ',
                                        (0, _I18n2.default)('openGolf.ticket.remove')
                                    ) : (0, _I18n2.default)('openGolf.ticket.add')
                                )
                            )
                        ),
                        hasRailcards && _react2.default.createElement(
                            'tr',
                            { className: 'open-ticket-selector__tickets__ticket-railcards' },
                            _react2.default.createElement(
                                'td',
                                { colSpan: '3', className: 'open-ticket-selector__tickets__ticket-railcards__column' },
                                appliedRailcards.map(function (railcard) {
                                    return _react2.default.createElement(
                                        'span',
                                        { className: 'open-ticket-selector__tickets__ticket-railcards__column__railcard' },
                                        railcard.name
                                    );
                                })
                            )
                        )
                    );
                })
            )
        )
    );
};

OpenTicketSelector.propTypes = {
    currentTicket: _propTypes2.default.number,
    isExpanded: _propTypes2.default.bool,
    loadingTrips: _propTypes2.default.object,
    onClick: _propTypes2.default.func,
    onTicketSelect: _propTypes2.default.func,
    order: _propTypes2.default.object,
    tickets: _propTypes2.default.object
};

exports.default = OpenTicketSelector;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(309),
    baseTrim = __webpack_require__(778),
    castSlice = __webpack_require__(320),
    charsEndIndex = __webpack_require__(1861),
    charsStartIndex = __webpack_require__(1862),
    stringToArray = __webpack_require__(321),
    toString = __webpack_require__(119);

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    utn: null,
    issuer: null,
    state: null,
    nlc: null,
    orderId: null,
    ticketId: null
};

var UtnDetail = function (_record) {
    (0, _inherits3.default)(UtnDetail, _record);

    function UtnDetail() {
        (0, _classCallCheck3.default)(this, UtnDetail);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    UtnDetail.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(UtnDetail, json, {
            utn: _LinkMapper.fields.string,
            issuer: _LinkMapper.fields.string,
            state: _LinkMapper.fields.string,
            nlc: _LinkMapper.fields.string,
            orderId: _LinkMapper.fields.number,
            ticketId: _LinkMapper.fields.number
        });
    };

    return UtnDetail;
}((0, _immutable.Record)(defaults));

exports.default = UtnDetail;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoversRangersStore = function (_BaseStore) {
    (0, _inherits3.default)(RoversRangersStore, _BaseStore);

    function RoversRangersStore() {
        (0, _classCallCheck3.default)(this, RoversRangersStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    RoversRangersStore.prototype.getInitialState = function getInitialState() {
        return new _immutable.Map({
            fares: new _immutable.Map(),
            pending: new _immutable.Map()
        });
    };

    RoversRangersStore.prototype.getFares = function getFares(search) {
        return this.state.getIn(['fares', this._getKey(search)], new _immutable.List());
    };

    RoversRangersStore.prototype.isPending = function isPending(search) {
        return this.state.getIn(['pending', this._getKey(search)], false);
    };

    RoversRangersStore.prototype._getKey = function _getKey(search) {
        return (0, _stringify2.default)(search.serialize());
    };

    RoversRangersStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_STARTED] = this._handleSearchStarted, _ref[_AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_FINISHED] = this._handleSearchFinished, _ref;
    };

    RoversRangersStore.prototype._handleSearchStarted = function _handleSearchStarted(_ref2) {
        var search = _ref2.search;

        this.setState(this.state.setIn(['pending', this._getKey(search)], true));
    };

    RoversRangersStore.prototype._handleSearchFinished = function _handleSearchFinished(_ref3) {
        var search = _ref3.search,
            searchResults = _ref3.searchResults;

        this.setState(this.state.setIn(['pending', this._getKey(search)], false).setIn(['fares', this._getKey(search)], searchResults));
    };

    return RoversRangersStore;
}(_BaseStore3.default);

var storeInstance = new RoversRangersStore();

exports.default = storeInstance;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _SeasonFilters = __webpack_require__(1006);

var _SeasonFilters2 = _interopRequireDefault(_SeasonFilters);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var seasonFilters = new _SeasonFilters2.default();

var getUniqueRoutes = function getUniqueRoutes(fares) {
    return fares.reduce(function (acc, fare) {
        var found = acc.find(function (r) {
            return r.id === fare.route.id;
        });
        return found ? acc : acc.push(fare.route);
    }, new _immutable.List());
};

var buildRouteFilters = function buildRouteFilters(routes) {
    return routes.map(function (route) {
        return new _immutable.Map({ route: route, checked: true });
    });
};

var SeasonFiltersStore = function (_BaseStore) {
    (0, _inherits3.default)(SeasonFiltersStore, _BaseStore);

    function SeasonFiltersStore() {
        (0, _classCallCheck3.default)(this, SeasonFiltersStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SeasonFiltersStore.prototype.getCurrent = function getCurrent() {
        return seasonFilters;
    };

    SeasonFiltersStore.prototype.setCurrent = function setCurrent(newSeasonFilters) {
        seasonFilters = newSeasonFilters;
        return this.getCurrent();
    };

    SeasonFiltersStore.prototype.handleSearchStarted = function handleSearchStarted(_ref) {
        var search = _ref.search;

        var options = (0, _pick3.default)(search.toJS(), 'flexi', 'weekly', 'fourWeekly', 'monthly', 'quarterly', 'sixMonthly', 'annual', 'custom');
        options.firstClass = _config2.default.get('brand') !== 'southeastern';
        var newSeasonFilters = new _SeasonFilters2.default(options);

        this.setCurrent(newSeasonFilters);
        this.emitChange();
    };

    SeasonFiltersStore.prototype.handlePointSearchFinished = function handlePointSearchFinished(_ref2) {
        var seasonTickets = _ref2.seasonTickets;

        this.handleSearchFinished(seasonTickets);
    };

    SeasonFiltersStore.prototype.handleFareSearchFinished = function handleFareSearchFinished(_ref3) {
        var fares = _ref3.fares;

        this.handleSearchFinished(fares);
    };

    SeasonFiltersStore.prototype.handleSearchFinished = function handleSearchFinished(fares) {
        var newRoutes = buildRouteFilters(getUniqueRoutes(fares));
        var newSeasonFilters = seasonFilters.set('routes', newRoutes);
        this.setCurrent(newSeasonFilters);
        this.emitChange();
    };

    SeasonFiltersStore.prototype.handleResultsFilterChange = function handleResultsFilterChange(_ref4) {
        var filters = _ref4.filters;

        this.setCurrent(filters);
        this.emitChange();
    };

    SeasonFiltersStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref5;

        return _ref5 = {}, _ref5[_AppConstants.ActionTypes.SEASON_SEARCH_STARTED] = this.handleSearchStarted, _ref5[_AppConstants.ActionTypes.SEASON_SEARCH_FINISHED] = this.handlePointSearchFinished, _ref5[_AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_FINISHED] = this.handleFareSearchFinished, _ref5[_AppConstants.ActionTypes.SEASON_RESULTS_FILTERS_CHANGE] = this.handleResultsFilterChange, _ref5;
    };

    return SeasonFiltersStore;
}(_BaseStore3.default);

var storeInstance = new SeasonFiltersStore();

exports.default = storeInstance;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SeasonTicketsStore = undefined;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var State = new _immutable.Record({
    search: null,
    loading: true,
    fares: new _immutable.List()
});

var SeasonTicketsStore = exports.SeasonTicketsStore = function (_BaseStore) {
    (0, _inherits3.default)(SeasonTicketsStore, _BaseStore);

    function SeasonTicketsStore() {
        (0, _classCallCheck3.default)(this, SeasonTicketsStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SeasonTicketsStore.prototype.getInitialState = function getInitialState() {
        return new State();
    };

    SeasonTicketsStore.prototype.getKey = function getKey(search) {
        return (0, _stringify2.default)(search.serialize());
    };

    SeasonTicketsStore.prototype.isCurrentSearch = function isCurrentSearch(search) {
        return this.state.search && this.getKey(search) === this.getKey(this.state.search);
    };

    SeasonTicketsStore.prototype.handleSearchStarted = function handleSearchStarted(_ref) {
        var search = _ref.search;

        this.setState(new State({ search: search }));
    };

    SeasonTicketsStore.prototype.handlePointSearchFinished = function handlePointSearchFinished(_ref2) {
        var search = _ref2.search,
            seasonTickets = _ref2.seasonTickets;

        this.handleSearchFinished(search, seasonTickets);
    };

    SeasonTicketsStore.prototype.handleFareSearchFinished = function handleFareSearchFinished(_ref3) {
        var search = _ref3.search,
            fares = _ref3.fares;

        this.handleSearchFinished(search, fares);
    };

    SeasonTicketsStore.prototype.handleSearchFinished = function handleSearchFinished(search, fares) {
        var updated = this.state.set('loading', false).set('search', search).set('fares', fares);

        this.setState(updated);
    };

    SeasonTicketsStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref4;

        return _ref4 = {}, _ref4[_AppConstants.ActionTypes.SEASON_SEARCH_STARTED] = this.handleSearchStarted, _ref4[_AppConstants.ActionTypes.SEASON_SEARCH_FINISHED] = this.handlePointSearchFinished, _ref4[_AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED] = this.handleSearchStarted, _ref4[_AppConstants.ActionTypes.FARE_ONLY_SEASON_SEARCH_FINISHED] = this.handleFareSearchFinished, _ref4;
    };

    (0, _createClass3.default)(SeasonTicketsStore, [{
        key: 'fares',
        get: function get() {
            return this.state.fares;
        }
    }, {
        key: 'loading',
        get: function get() {
            return this.state.loading;
        }
    }]);
    return SeasonTicketsStore;
}(_BaseStore3.default);

var storeInstance = new SeasonTicketsStore();

exports.default = storeInstance;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardJourneyStore = function (_BaseStore) {
    (0, _inherits3.default)(SmartcardJourneyStore, _BaseStore);

    function SmartcardJourneyStore() {
        (0, _classCallCheck3.default)(this, SmartcardJourneyStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SmartcardJourneyStore.prototype.getInitialState = function getInitialState() {
        var journeys = new _immutable.List();
        return new _immutable.Map({ journeys: journeys });
    };

    SmartcardJourneyStore.prototype.hasJourneys = function hasJourneys() {
        return !this.state.get('journeys').isEmpty();
    };

    SmartcardJourneyStore.prototype.handleJourneysLoaded = function handleJourneysLoaded(_ref) {
        var journeys = _ref.journeys;

        this.setState(this.state.set('journeys', journeys));
    };

    SmartcardJourneyStore.prototype.byDay = function byDay() {
        return this.get('journeys').groupBy(function (transaction) {
            return transaction.dateTime.format('YYYY-MM-DD');
        });
    };

    SmartcardJourneyStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref2;

        return _ref2 = {}, _ref2[_AppConstants.ActionTypes.SMARTCARD_JOURNEYS_LOADED] = this.handleJourneysLoaded, _ref2[_AppConstants.ActionTypes.LOGGED_OUT] = this.resetState, _ref2;
    };

    return SmartcardJourneyStore;
}(_BaseStore3.default);

exports.default = new SmartcardJourneyStore();

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _RewardPointsService = __webpack_require__(1011);

var _RewardPointsService2 = _interopRequireDefault(_RewardPointsService);

var _OrderService = __webpack_require__(346);

var _OrderService2 = _interopRequireDefault(_OrderService);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardPointsActions = {
    registerTicketsForRewardPoints: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(order) {
            var customerId, email, id, purchaseDate, trips, allTickets, tickets, smartcard, deliveryOptions, eTicketOption, smartcardOption, smartcardErrors, canChooseSmartcard, smartcardErrorBlockingStrings, errorStrings, hasPreferredDelivery;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            customerId = order.customerId, email = order.email, id = order.id;
                            purchaseDate = (0, _TrainTime2.default)().format('YYYY-MM-DD');
                            trips = order.trips;
                            allTickets = [];


                            trips.map(function (trip) {
                                var tickets = trip.getTicketsWithTicketTypeAndValidity();
                                allTickets.push(tickets.toJS());
                            });

                            tickets = allTickets.flat().map(function (ticket) {
                                return {
                                    ticketId: ticket.id,
                                    travelStartDate: _TrainTime2.default.isoDate(ticket.travelStartDate),
                                    ticketType: ticket.ticketType,
                                    ticketCost: ticket.price,
                                    setter: ''
                                };
                            });
                            smartcard = _SmartcardStore2.default.getCurrent();
                            _context.next = 10;
                            return _OrderService2.default.getDeliveryOptions(order.id, smartcard);

                        case 10:
                            deliveryOptions = _context.sent;
                            eTicketOption = deliveryOptions.find(function (option) {
                                return option.isETicket();
                            });
                            smartcardOption = deliveryOptions.find(function (option) {
                                return option.isSmartcard();
                            });
                            smartcardErrors = smartcardOption && smartcardOption.errors;
                            canChooseSmartcard = !!smartcardOption;

                            /*
                                If there are any 'blocking' errors that make Smartcard
                                unavailable as a fulfilment option, we will give reward
                                points for eligible fares when 'non preferred' delivery
                                methods are chosen.
                            */

                            if (smartcardErrors) {
                                // convert errors and known error constants to same format for comparison
                                smartcardErrorBlockingStrings = (0, _values2.default)(_AppConstants.SmartcardErrorBlocking).map(function (x) {
                                    return x.toLowerCase();
                                });

                                // convert errors and known error constants to same format for comparison

                                errorStrings = smartcardErrors.map(function (err) {
                                    return (0, _keys2.default)(err).map(function (x) {
                                        return x.toLowerCase();
                                    });
                                }).flat();

                                // check if fulfilment errors are 'blocking' errors

                                errorStrings.map(function (errString) {
                                    if (smartcardErrorBlockingStrings.includes(errString)) {
                                        canChooseSmartcard = false;
                                    }
                                });
                            }

                            hasPreferredDelivery = !!eTicketOption || canChooseSmartcard;
                            _context.next = 19;
                            return _RewardPointsService2.default.registerTicketsForReward(id, purchaseDate, hasPreferredDelivery, tickets, customerId, email);

                        case 19:
                            _context.next = 24;
                            break;

                        case 21:
                            _context.prev = 21;
                            _context.t0 = _context['catch'](0);

                            console.warn('error registering tickets for reward points', _context.t0);

                        case 24:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 21]]);
        }));

        function registerTicketsForRewardPoints(_x) {
            return _ref.apply(this, arguments);
        }

        return registerTicketsForRewardPoints;
    }()
};

exports.default = RewardPointsActions;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = FavouriteDetails;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FareStations = __webpack_require__(282);

var _FareStations2 = _interopRequireDefault(_FareStations);

var _FareClassBadge = __webpack_require__(1023);

var _FareClassBadge2 = _interopRequireDefault(_FareClassBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

FavouriteDetails.propTypes = {
    favourite: _propTypes2.default.instanceOf(_Favourite2.default)
};

function FavouriteDetails(_ref) {
    var favourite = _ref.favourite;

    var isFlexi = favourite.ticketType.code === 'FL1';
    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'h2',
            { className: 'favourite-list__item__title' },
            _react2.default.createElement(_FareClassBadge2.default, { className: 'pull-left', isFirstClass: favourite.isFirstClass() }),
            _react2.default.createElement(
                'span',
                { className: 'pull-left' },
                '\xA0\xA0'
            ),
            _react2.default.createElement(_FareStations2.default, {
                forceFontWeight: false,
                origin: favourite.origin,
                destination: favourite.destination,
                isReturn: favourite.isOpenReturn
            })
        ),
        _react2.default.createElement(
            'h3',
            { className: 'favourite-list__item__sub-title', title: favourite.ticketType.code },
            favourite.ticketType.name,
            ' ',
            favourite.isTravelcard() && _react2.default.createElement(_Icon2.default, { icon: 'londontravelcard' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'favourite-list__item__passengers' },
            (0, _I18n2.default)('booking.passengers.summary.text', {
                adults: isFlexi ? favourite.passengerCount : favourite.adults,
                children: favourite.children
            })
        ),
        favourite.hasRailcard() && _react2.default.createElement(
            'ul',
            { className: 'favourite-list__item__railcards' },
            favourite.getRailcardCounts('name').entrySeq().map(function (_ref2) {
                var name = _ref2[0],
                    quantity = _ref2[1];
                return _react2.default.createElement(
                    'li',
                    { key: name },
                    (0, _I18n2.default)('booking.railcardsCount', { quantity: quantity, name: name })
                );
            })
        )
    );
}

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _find2 = __webpack_require__(344);

var _find3 = _interopRequireDefault(_find2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _StepHeader = __webpack_require__(1035);

var _StepHeader2 = _interopRequireDefault(_StepHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SteppableList = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(SteppableList, _React$PureComponent);

    function SteppableList() {
        (0, _classCallCheck3.default)(this, SteppableList);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    SteppableList.prototype.getCurrentStep = function getCurrentStep() {
        return (0, _find3.default)(this.props.steps, ['number', this.props.currentStep]);
    };

    SteppableList.prototype.render = function render() {
        var step = this.getCurrentStep();
        var _props = this.props,
            customHeader = _props.customHeader,
            headerElement = _props.headerElement;

        if (!step) {
            return null;
        }

        var Element = step.element;
        var TitleElement = customHeader ? headerElement : function () {
            return _react2.default.createElement(_StepHeader2.default, { active: true,
                className: 'margin-bottom--sm',
                label: (0, _I18n2.default)(step.title),
                number: step.number });
        };
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(TitleElement, null),
            _react2.default.createElement(Element, null)
        );
    };

    return SteppableList;
}(_react2.default.PureComponent), _class.propTypes = {
    steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        number: _propTypes2.default.number,
        title: _propTypes2.default.string,
        element: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
    })).isRequired,
    currentStep: _propTypes2.default.number.isRequired,
    customHeader: _propTypes2.default.bool,
    headerElement: _propTypes2.default.func
}, _class.defaultProps = {
    customHeader: false,
    headerElement: _noop3.default
}, _temp);
exports.default = SteppableList;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _debounce2 = __webpack_require__(277);

var _debounce3 = _interopRequireDefault(_debounce2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FormControl = __webpack_require__(178);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _ControlLabel = __webpack_require__(461);

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _FocusableWrapper = __webpack_require__(1985);

var _FocusableWrapper2 = _interopRequireDefault(_FocusableWrapper);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Select = __webpack_require__(425);

var _Select2 = _interopRequireDefault(_Select);

var _Radio = __webpack_require__(231);

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getValueByType(type, target) {
    var valueTypes = {
        text: target.value,
        number: target.value,
        checkbox: target.checked,
        radio: target.checked
    };
    return type in valueTypes ? valueTypes[type] : valueTypes.text;
}

function _getLabelByType(type, label, required) {
    var labelTypes = {
        text: required ? label + (0, _I18n.translate)('required') : label,
        checkbox: label,
        select: label,
        radio: label
    };
    return type in labelTypes ? labelTypes[type] : labelTypes.text;
}

var wrappedCheckbox = (0, _FocusableWrapper2.default)(_Checkbox2.default);
var wrappedSelect = (0, _FocusableWrapper2.default)(_Select2.default);
var wrappedFormControl = (0, _FocusableWrapper2.default)(_FormControl2.default);
var wrappedRadio = (0, _FocusableWrapper2.default)(_Radio2.default);

var FormField = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FormField, _React$PureComponent);

    function FormField() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FormField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = function () {
            return {
                value: _this.props.value === undefined ? _this.props.form[_this.props.field] : _this.props.value
            };
        }(), _this._handleChange = function (_ref) {
            var target = _ref.target;

            // Set up a debounced change handler, to avoid a callback on every keystroke
            if (!_this.parentChangeHandler) {
                _this.parentChangeHandler = (0, _debounce3.default)(_this.props.onChange, 300, { leading: true });
            }

            var value = _getValueByType(_this.props.type, target);
            _this.setState({ value: value });
            if (_this.props.index !== null && _this.props.index >= 0) {
                _this.parentChangeHandler(_this.props.field, value, _this.props.index);
            } else {
                _this.parentChangeHandler(_this.props.field, value);
            }
        }, _this._handlePaste = function (e) {
            if (_this.props.avoidPaste) {
                e.preventDefault();
            } else {
                _this._handleChange(e);
            }
        }, _this._handleKeyDown = function (event) {
            if (event.keyCode === _AppConstants.KeyCodes.ENTER) {
                if (_this.props.index !== null && _this.props.index >= 0) {
                    _this.props.onChange(_this.props.field, _this.state.value, _this.props.index);
                } else {
                    _this.props.onChange(_this.props.field, _this.state.value);
                }
            }
        }, _this._handleBlur = function () {
            if (_this.props.index !== null && _this.props.index >= 0) {
                _this.props.onBlur(_this.props.field, _this.state.value, _this.props.index);
            } else {
                _this.props.onBlur(_this.props.field, _this.state.value);
            }
        }, _this._handleFocus = function () {
            if (_this.props.index !== null && _this.props.index >= 0) {
                _this.props.onFocus(_this.props.field, _this.state.value, _this.props.index);
            } else {
                _this.props.onFocus(_this.props.field, _this.state.value);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    FormField.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        // on IE, onChange event might come after actual value of an element
        // have changed. We detect this and render element as-is, hoping that
        // next onChange will eventually come and bring our modifications anyways.
        // Ignoring this causes skipped letters in controlled components
        // https://github.com/r0man/sablono/commit/579f3d77271afd9edacc4fa0813f93ff42fe33a6
        if (!['checkbox', 'select'].includes(this.props.type)) {
            var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this.inputElement),
                nodeValue = _ReactDOM$findDOMNode.value;

            var stateValue = (0, _isString3.default)(this.state.value) ? this.state.value : '';
            if (stateValue !== nodeValue) {
                this.setState({ value: nodeValue });
                return;
            }
        }

        var current = this.props.form[this.props.field];
        var next = nextProps.value === undefined ? nextProps.form[this.props.field] : nextProps.value;

        if (current !== next) {
            this.setState({ value: next });
        }
    };

    FormField.prototype._renderPlaceholder = function _renderPlaceholder() {
        var _props = this.props,
            placeholder = _props.placeholder,
            noFloatyPlaceholder = _props.noFloatyPlaceholder,
            outsideLabel = _props.outsideLabel;
        var value = this.state.value;


        if (value && placeholder && !noFloatyPlaceholder && !outsideLabel) {
            return _react2.default.createElement(
                'span',
                { className: 'placeholder text-sm' },
                placeholder
            );
        }
        return null;
    };

    FormField.prototype.render = function render() {
        var _this2 = this;

        var _props2 = this.props,
            children = _props2.children,
            className = _props2.className,
            externalFormGroup = _props2.externalFormGroup,
            field = _props2.field,
            focused = _props2.focused,
            hideOptional = _props2.hideOptional,
            indicator = _props2.indicator,
            label = _props2.label,
            labelText = _props2.labelText,
            labelClassName = _props2.labelClassName,
            outsideLabel = _props2.outsideLabel,
            placeholder = _props2.placeholder,
            required = _props2.required,
            showPlaceholder = _props2.showPlaceholder,
            showRequired = _props2.showRequired,
            type = _props2.type;

        var typeLabel = _getLabelByType(type, label, required);
        var props = (0, _pick3.default)(this.props, ['id', 'placeholder', 'disabled', 'checked', 'required', 'value', 'type', 'groupClassName', 'labelClassName', 'autoFocus', 'maxLength', 'autoComplete', 'aria-describedby', 'aria-invalid']);
        if (!props.id) {
            props.id = (0, _uniqueId3.default)(field);
        }

        var Element = void 0;
        var classNames = className;
        var separateLabel = false;
        var noLabel = false;
        var omittedProps = ['labelClassName'];

        if (outsideLabel) {
            omittedProps.push('placeholder');
        }

        switch (type) {
            case 'checkbox':
                Element = wrappedCheckbox;
                break;
            case 'select':
                Element = wrappedSelect;
                noLabel = true;
                break;
            case 'radio':
                Element = wrappedRadio;
                break;
            default:
                Element = wrappedFormControl;
                classNames = (0, _classnames2.default)('input-field', classNames);
                separateLabel = !outsideLabel;

                props = (0, _omit3.default)(props, omittedProps);
                break;
        }

        if (type === 'textarea') {
            (0, _assign2.default)(props, {
                componentClass: type,
                rows: this.props.rows
            });
        }

        var placeholderProp = showPlaceholder ? { placeholder: placeholder } : null;

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            outsideLabel && _react2.default.createElement(
                'label',
                { htmlFor: props.id, 'aria-hidden': 'true', className: 'outside-label' },
                labelText || label,
                ' ',
                required && _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('required')
                ),
                !required && !hideOptional && _react2.default.createElement(
                    'span',
                    { className: 'outside-label__optional' },
                    (0, _I18n.translate)('form.optional')
                )
            ),
            _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('form-field', {
                        'form-group': !externalFormGroup,
                        'form-field--outside-label': outsideLabel,
                        'form-field--with-indicator': Boolean(indicator)
                    }, indicator && classNames)
                },
                _react2.default.createElement(
                    Element,
                    (0, _extends3.default)({}, props, {
                        ref: function ref(el) {
                            _this2.inputElement = el;
                        },
                        className: !indicator && classNames,
                        value: this.state.value || '',
                        onChange: this._handleChange,
                        label: noLabel ? null : !separateLabel ? typeLabel : null,
                        onKeyDown: this._handleKeyDown,
                        onBlur: this._handleBlur,
                        focused: focused,
                        onFocus: this._handleFocus,
                        onPaste: this._handlePaste
                    }, placeholderProp),
                    children && children
                ),
                typeLabel && separateLabel && _react2.default.createElement(
                    _ControlLabel2.default,
                    { srOnly: true, htmlFor: props.id, className: labelClassName },
                    label
                ),
                (required || showRequired) && _react2.default.createElement(_Icon2.default, { icon: 'mandatory' }),
                indicator,
                this._renderPlaceholder()
            )
        );
    };

    return FormField;
}(_react2.default.PureComponent), _class.propTypes = {
    autoFocus: _propTypes2.default.bool,
    checked: _propTypes2.default.bool,
    children: _propTypes2.default.any,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    externalFormGroup: _propTypes2.default.bool,
    field: _propTypes2.default.string.isRequired,
    focused: _propTypes2.default.bool,
    form: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_immutable.Record), _propTypes2.default.object]).isRequired,
    hideOptional: _propTypes2.default.bool,
    id: _propTypes2.default.string,
    index: _propTypes2.default.number,
    indicator: _propTypes2.default.element,
    isPasswordShown: _propTypes2.default.bool,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    labelClassName: _propTypes2.default.string,
    labelText: _propTypes2.default.string,
    noFloatyPlaceholder: _propTypes2.default.bool,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    outsideLabel: _propTypes2.default.bool,
    placeholder: _propTypes2.default.string,
    required: _propTypes2.default.bool,
    rows: _propTypes2.default.number,
    showPlaceholder: _propTypes2.default.bool,
    showRequired: _propTypes2.default.bool,
    type: _propTypes2.default.string,
    avoidPaste: _propTypes2.default.bool,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool])
}, _class.defaultProps = {
    autoFocus: false,
    checked: false,
    disabled: false,
    externalFormGroup: false,
    focused: false,
    index: null,
    isPasswordShown: false,
    label: '',
    labelText: null,
    noFloatyPlaceholder: false,
    onBlur: _noop3.default,
    onChange: _noop3.default,
    onFocus: _noop3.default,
    outsideLabel: false,
    placeholder: null,
    required: false,
    type: 'text',
    avoidPaste: false
}, _temp2);
exports.default = FormField;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HelpModal(_ref) {
    var className = _ref.className,
        icon = _ref.icon,
        heading = _ref.heading,
        message = _ref.message,
        centerMessage = _ref.centerMessage,
        children = _ref.children,
        moreInfoText = _ref.moreInfoText,
        onClose = _ref.onClose,
        show = _ref.show,
        onOpen = _ref.onOpen;

    var messageClass = (0, _classnames2.default)({ 'text-center': centerMessage });
    return _react2.default.createElement(
        _BaseModal2.default,
        {
            show: show,
            onClose: onClose,
            onOpen: onOpen,
            className: (0, _classnames2.default)("modal-help", className),
            titleText: heading,
            hideContinue: true
        },
        _react2.default.createElement(
            'section',
            { className: 'text-center' },
            !children && _react2.default.createElement(_Icon2.default, { icon: icon + ' margin-top margin-bottom otrl-xl' }),
            _react2.default.createElement(
                'div',
                { className: 'text-left' },
                children || _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    splitParagraphs: true,
                    tagName: 'p',
                    message: message,
                    className: messageClass
                }),
                moreInfoText && _react2.default.createElement(
                    'p',
                    null,
                    moreInfoText
                )
            )
        )
    );
}

HelpModal.propTypes = {
    show: _propTypes2.default.bool,
    icon: _propTypes2.default.string,
    heading: _propTypes2.default.string.isRequired,
    onClose: _propTypes2.default.func,
    onOpen: _propTypes2.default.func,
    message: _propTypes2.default.string,
    centerMessage: _propTypes2.default.bool,
    moreInfoText: _propTypes2.default.element,
    children: _propTypes2.default.element,
    className: _propTypes2.default.string,
    checkProps: function checkProps(props, propName, componentName) {
        if (!props.message && !props.children) {
            throw new Error('Missing prop \'message\' or \'children\' for ' + componentName);
        }
    }
};

HelpModal.defaultProps = {
    show: false,
    icon: 'success',
    heading: 'info.title',
    onClose: _noop3.default,
    onOpen: _noop3.default,
    centerMessage: false,
    className: 'modal--sm'
};

exports.default = HelpModal;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Consents = undefined;

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _Radio = __webpack_require__(231);

var _Radio2 = _interopRequireDefault(_Radio);

var _reactBootstrap = __webpack_require__(100);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _AppConstants = __webpack_require__(6);

var _WithLoading = __webpack_require__(1017);

var _useConsents2 = __webpack_require__(1994);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ConsentsActions = __webpack_require__(462);

var _ConsentsActions2 = _interopRequireDefault(_ConsentsActions);

var _ConsentsForm = __webpack_require__(354);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Consents = exports.Consents = function Consents() {
    var _useConsents = (0, _useConsents2.useConsents)(),
        consents = _useConsents.consents,
        consentsForm = _useConsents.consentsForm,
        onCheckNotificationMethod = _useConsents.onCheckNotificationMethod,
        onChangePhoneNumber = _useConsents.onChangePhoneNumber,
        onChangeIsOver16 = _useConsents.onChangeIsOver16,
        handleSubmit = _useConsents.handleSubmit,
        submitLoading = _useConsents.submitLoading,
        consentsLoading = _useConsents.consentsLoading,
        showSubmitButton = _useConsents.showSubmitButton;

    var _useState = (0, _react.useState)(false),
        phoneVisited = _useState[0],
        setPhoneVisited = _useState[1];

    var notificationMethods = (0, _get3.default)(consents, 'blocks[0].options', []);
    var over16Title = (0, _get3.default)(consents, 'blocks[1].title', '');
    var over16Choices = (0, _get3.default)(consents, 'blocks[1].choices', []);
    var isOver16 = consentsForm.get(_AppConstants.CONSENTS.OVER_16);
    var privacyPolicyURL = (0, _get3.default)(consents, 'privacyPolicy.policyUrl');

    /* eslint-disable react-hooks/exhaustive-deps */
    /*
        * Reset the consents form to default when the component unmounts
        * This ensures that the form is reset for the next time it is rendered.
        * This wipes any invalid / unsaved changes to avoid user confusion
    */
    (0, _react.useEffect)(function () {
        return function () {
            var resetForm = consentsForm.merge(_ConsentsForm.defaultConsents);
            _ConsentsActions2.default.setConsentsForm(resetForm);
        };
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */

    return _react2.default.createElement(
        _WithLoading.WithLoading,
        { isLoading: consentsLoading },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n2.default)('preference-centre.consents.title')
            ),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n2.default)('preference-centre.consents.title_2')
            ),
            _react2.default.createElement(
                'ul',
                null,
                notificationMethods.map(function (method) {
                    var optionId = method.optionId,
                        label = method.label;

                    return _react2.default.createElement(
                        'li',
                        { key: optionId },
                        _react2.default.createElement(_Checkbox2.default, {
                            label: label,
                            'aria-label': label,
                            onChange: onCheckNotificationMethod(method),
                            checked: consentsForm.get(optionId),
                            value: optionId
                        })
                    );
                })
            ),
            consentsForm.get(_AppConstants.CONSENTS.SMS_Marketing) && _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'label',
                    { htmlFor: _AppConstants.CONSENTS.PHONE, className: 'label' },
                    (0, _I18n2.default)('preference-centre.consents.phoneNumber')
                ),
                _react2.default.createElement(_ValidatedField2.default, {
                    type: 'text',
                    form: consentsForm,
                    id: _AppConstants.CONSENTS.PHONE,
                    field: _AppConstants.CONSENTS.PHONE,
                    className: 'input-field margin-bottom--sm consents__input',
                    maxLength: 21,
                    onChange: function onChange(field, value) {
                        setPhoneVisited(true);
                        var schema = consentsForm.getSchema()[field];
                        if (schema) {
                            var result = schema.validate(value);

                            if (result.error) {
                                // Patch local form state to show validation error
                                var patchedForm = consentsForm.set(field, value);
                                _ConsentsActions2.default.setConsentsForm(patchedForm);

                                // Trigger validation display
                                patchedForm.validateField(field);
                                return;
                            }
                        }

                        // Only update if validation passed
                        onChangePhoneNumber(field, value);
                    },
                    onBlur: function onBlur() {
                        return setPhoneVisited(true);
                    },
                    label: (0, _I18n2.default)('preference-centre.consents.phoneNumber'),
                    'aria-label': (0, _I18n2.default)('preference-centre.consents.phoneNumber.sr'),
                    validation: consentsForm.getValidationSummary(),
                    visited: phoneVisited,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                over16Title
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    (0, _I18n2.default)('preference-centre.consents.confirmAge')
                )
            ),
            _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_Radio2.default, {
                        radioClass: 'regular-radio',
                        label: (0, _get3.default)(over16Choices, '[0].label', ''),
                        'aria-label': (0, _get3.default)(over16Choices, '[0].label', ''),
                        checked: isOver16,
                        onChange: onChangeIsOver16((0, _get3.default)(over16Choices, '[0]', {}))
                    })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_Radio2.default, {
                        radioClass: 'regular-radio',
                        label: (0, _get3.default)(over16Choices, '[1].label', ''),
                        'aria-label': (0, _get3.default)(over16Choices, '[1].label', ''),
                        checked: !isOver16,
                        onChange: onChangeIsOver16((0, _get3.default)(over16Choices, '[1]', {}))
                    })
                )
            )
        ),
        _react2.default.createElement(
            'p',
            { className: 'margin-bottom--md' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'preference-centre.consents.privacyPolicy',
                link: _react2.default.createElement(_ExternalLink2.default, {
                    message: 'preference-centre.consents.privacyPolicyLink',
                    href: privacyPolicyURL
                })
            })
        ),
        showSubmitButton && _react2.default.createElement(
            _reactBootstrap.Button,
            {
                className: 'btn-blue',
                disabled: submitLoading || consentsForm.get(_AppConstants.CONSENTS.SMS_Marketing) && !!consentsForm.getError(_AppConstants.CONSENTS.PHONE),
                onClick: handleSubmit
            },
            submitLoading ? _react2.default.createElement(_Icon2.default, { icon: 'spinner', className: 'otrl-spin' }) : (0, _I18n2.default)('button.text.submit')
        )
    );
};

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _SmartcardRegistration = __webpack_require__(240);

var _SmartcardRegistration2 = _interopRequireDefault(_SmartcardRegistration);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _Registration = __webpack_require__(355);

var _Registration2 = _interopRequireDefault(_Registration);

var _SmartcardNumberHelp = __webpack_require__(1153);

var _SmartcardNumberHelp2 = _interopRequireDefault(_SmartcardNumberHelp);

var _AgeCheckbox = __webpack_require__(925);

var _AgeCheckbox2 = _interopRequireDefault(_AgeCheckbox);

var _FormComponent2 = __webpack_require__(417);

var _FormComponent3 = _interopRequireDefault(_FormComponent2);

var _PostalAddress = __webpack_require__(678);

var _PostalAddress2 = _interopRequireDefault(_PostalAddress);

var _PhotoUpload = __webpack_require__(1071);

var _PhotoUpload2 = _interopRequireDefault(_PhotoUpload);

var _DateOfBirth = __webpack_require__(1998);

var _DateOfBirth2 = _interopRequireDefault(_DateOfBirth);

var _HelpIcon = __webpack_require__(335);

var _HelpIcon2 = _interopRequireDefault(_HelpIcon);

var _Isrn = __webpack_require__(2002);

var _Isrn2 = _interopRequireDefault(_Isrn);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardRegistrationForm = (_temp2 = _class = function (_FormComponent) {
    (0, _inherits3.default)(SmartcardRegistrationForm, _FormComponent);

    function SmartcardRegistrationForm() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SmartcardRegistrationForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _FormComponent.call.apply(_FormComponent, [this].concat(args))), _this), _this._handleToggleAge = function () {
            var _this$props = _this.props,
                onAgeToggle = _this$props.onAgeToggle,
                smartcard = _this$props.smartcard,
                user = _this$props.user;

            var isOver16 = smartcard.get('isOver16');
            var preferences = user.get('preferences');
            if (isOver16) {
                preferences = preferences.resetAllDisabledMarketingFields();
            }
            onAgeToggle(!isOver16, preferences);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    SmartcardRegistrationForm.prototype.render = function render() {
        var _props = this.props,
            smartcard = _props.smartcard,
            onChange = _props.onChange,
            submitted = _props.submitted,
            smartcardSubmitted = _props.smartcardSubmitted,
            badPostcode = _props.badPostcode,
            allowPhotoUpload = _props.allowPhotoUpload,
            onSelectAddress = _props.onSelectAddress,
            outsideLabel = _props.outsideLabel,
            user = _props.user;


        var isOver16 = smartcard.get('isOver16');

        var validation = smartcard.getValidationSummary();

        if (badPostcode && badPostcode === smartcard.postcode) {
            validation.postcode = (0, _I18n2.default)('alertmessage.badPostCode');
        }

        var sharedProps = {
            onChange: onChange,
            form: smartcard,
            validation: validation,
            visited: submitted,
            onSelectAddress: onSelectAddress
        };

        var photoUploadProps = {
            acceptedFormats: _config2.default.get('smartcardPhotoMimeTypes'),
            bodyText: (0, _I18n2.default)('account.smartcardsignup.children'),
            footerTextFeatureFlag: "enableChildSmartcardMessage",
            footerText: (0, _I18n2.default)('account.smartcardsignup.children.requirements', { brand: (0, _I18n2.default)('app.owner.short') }),
            placeholderIcon: 'smiley',
            uploadConditions: [(0, _I18n2.default)('account.smartcardsignup.children.condition1')]
        };

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'form',
                { ref: this.captureFormRef, className: 'register-smartcard' },
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(_PostalAddress2.default, (0, _extends3.default)({
                        outsideLabel: outsideLabel,
                        alwaysShowAddressFields: smartcardSubmitted,
                        label: (0, _I18n2.default)('account.smartcardsignup.address')
                    }, sharedProps))
                ),
                !user.created && _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { md: 12 },
                        _react2.default.createElement(_AgeCheckbox2.default, {
                            isOver16: isOver16,
                            onToggle: this._handleToggleAge })
                    )
                ),
                !isOver16 && _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(_DateOfBirth2.default, (0, _extends3.default)({
                        field: 'dateOfBirth',
                        outsideLabel: outsideLabel,
                        label: (0, _I18n2.default)('account.smartcardsignup.dob'),
                        customValidationMessage: validation.isOver16
                    }, sharedProps))
                ),
                !smartcard.selfRegistered && allowPhotoUpload && smartcard.requiresPhotograph() && _react2.default.createElement(_PhotoUpload2.default, (0, _extends3.default)({ field: 'photo' }, sharedProps, photoUploadProps)),
                smartcard.selfRegistered && _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12 },
                        _react2.default.createElement(
                            'p',
                            { className: 'label' },
                            (0, _I18n2.default)('account.smartcard.text.label')
                        ),
                        _react2.default.createElement(_HelpIcon2.default, {
                            heading: 'delayrepay.help.smartcardNumber.title',
                            body: _react2.default.createElement(_SmartcardNumberHelp2.default, null)
                        })
                    ),
                    _react2.default.createElement(_Isrn2.default, (0, _extends3.default)({
                        field: 'isrn',
                        label: (0, _I18n2.default)('account.smartcard.text.label')
                    }, sharedProps))
                ),
                validation.isEnabledSmartcardRegistration && _react2.default.createElement(_Error2.default, { message: validation.isEnabledSmartcardRegistration })
            )
        );
    };

    return SmartcardRegistrationForm;
}(_FormComponent3.default), _class.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    smartcard: _propTypes2.default.instanceOf(_SmartcardRegistration2.default).isRequired,
    submitted: _propTypes2.default.bool,
    smartcardSubmitted: _propTypes2.default.bool,
    user: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_User2.default), _propTypes2.default.instanceOf(_Registration2.default)]),
    badPostcode: _propTypes2.default.string,
    allowPhotoUpload: _propTypes2.default.bool,
    onSelectAddress: _propTypes2.default.func.isRequired,
    onAgeToggle: _propTypes2.default.func,
    outsideLabel: _propTypes2.default.bool
}, _class.defaultProps = {
    allowPhotoUpload: true,
    badPostcode: null,
    submitted: false,
    smartcardSubmitted: false,
    outsideLabel: true
}, _temp2);
exports.default = SmartcardRegistrationForm;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = SmartcardNumberHelp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmartcardNumberHelp() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_FormattedHTMLMessage2.default, { splitParagraphs: true, tagName: 'p', message: 'delayrepay.help.smartcardNumber' }),
        _react2.default.createElement('div', { className: 'delayrepay--smartcard-number-help' })
    );
}

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

module.exports = baseRepeat;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _PaymentRadio = __webpack_require__(438);

var _PaymentRadio2 = _interopRequireDefault(_PaymentRadio);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _I18n = __webpack_require__(9);

var _reactBootstrap = __webpack_require__(100);

var _PaymentForms = __webpack_require__(2023);

var _ADRPaymentMethodsForm = __webpack_require__(463);

var _ADRPaymentMethodsForm2 = _interopRequireDefault(_ADRPaymentMethodsForm);

var _AppConstants = __webpack_require__(6);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentMethodsList = [{ label: 'Electronic Bank Transfer', key: _AppConstants.oneClickDelayRepayReimbursementMethods.BACS }, { label: 'eVoucher', key: _AppConstants.oneClickDelayRepayReimbursementMethods.EVOUCHERS }, { label: 'PayPal', key: _AppConstants.oneClickDelayRepayReimbursementMethods.PAYPAL }, { label: 'Charity', key: _AppConstants.oneClickDelayRepayReimbursementMethods.CHARITY }];

var SelectPaymentMethod = function SelectPaymentMethod(_ref) {
    var form = _ref.form,
        handleFormChange = _ref.handleFormChange,
        showPaymentForm = _ref.showPaymentForm,
        isValidBACS = _ref.isValidBACS;
    var method = form.method;


    var updateFormField = function updateFormField(field, value) {
        handleFormChange(function (prevForm) {
            return prevForm.set(field, value);
        });
    };

    return _react2.default.createElement(
        _reactBootstrap.Col,
        { xs: 12 },
        _react2.default.createElement(
            'h2',
            { className: 'auto-dr__header' },
            (0, _I18n.translate)('auto-dr.subscribe.modal-payment')
        ),
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('auto-dr.subscribe.compliance'),
            '.'
        ),
        showPaymentForm && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'auto-delay-repay-notification-preferences auto-dr__payment-wrapper' },
                paymentMethodsList.map(function (_ref2) {
                    var key = _ref2.key,
                        label = _ref2.label;

                    if (key === _AppConstants.oneClickDelayRepayReimbursementMethods.CHARITY && !_FeatureFlagStore2.default.get('enableOcdrCharityReimbursementMethod')) {
                        return null;
                    }

                    return _react2.default.createElement(
                        'div',
                        {
                            className: 'auto-dr__payment-item auto-dr__payment-item--notification-preference'
                        },
                        _react2.default.createElement(
                            _OnEnterTrigger2.default,
                            {
                                className: (0, _classnames2.default)('payment__selector', {
                                    'payment__selector--selected': method === key
                                }),
                                onClick: function onClick(e) {
                                    e.preventDefault();
                                    updateFormField('method', key);
                                },
                                srOnly: label,
                                disabled: false
                            },
                            _react2.default.createElement(_PaymentRadio2.default, {
                                className: 'payment__selector__radio-icon small',
                                isSelected: method === key
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'auto-dr__payment-item__label' },
                                label
                            )
                        )
                    );
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'auto-delay-repay-notification-preferences margin-left--sm margin-right--sm' },
                _react2.default.createElement(_PaymentForms.PaymentForms, { form: form, updateFormField: updateFormField, isValidBACS: isValidBACS }),
                _react2.default.createElement(
                    'p',
                    { className: 'margin-top--sm' },
                    (0, _I18n.translate)('auto-dr.subscribe.change'),
                    '.'
                )
            )
        )
    );
};

SelectPaymentMethod.propTypes = {
    handleFormChange: _propTypes2.default.func.isRequired,
    form: _propTypes2.default.instanceOf(_ADRPaymentMethodsForm2.default).isRequired,
    isValidBACS: _propTypes2.default.func,
    showPaymentForm: _propTypes2.default.bool,
    setShowPaymentForm: _propTypes2.default.func
};

exports.default = SelectPaymentMethod;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var OcdrCharity = exports.OcdrCharity = {
    RAILWAY_CHILDREN: 'railway-children',
    DAME_KELLY_HOLMES_TRUST: 'DKHT',
    SAMARITANS: 'samaritans',
    CRUK: 'CRUK',
    GREAT_ORMOND_STREET: 'great-ormond-street',
    NHS: 'nhs',
    DEC: 'dec'
};

var OcdrCharities = exports.OcdrCharities = [{
    value: OcdrCharity.RAILWAY_CHILDREN,
    imageUrl: 'images/charity-railway-children.png',
    nameKey: 'charity.name.railway-children',
    descriptionKey: 'charity.description.railway-children',
    website: 'https://www.railwaychildren.org.uk/',
    linkText: 'www.railwaychildren.org.uk',
    featureFlagName: 'enableRailwayChildrenCharity'
}, {
    value: OcdrCharity.DAME_KELLY_HOLMES_TRUST,
    imageUrl: 'images/charity-dame-kelly.png',
    nameKey: 'charity.name.dame-kelly',
    descriptionKey: 'charity.description.dame-kelly',
    website: 'https://www.damekellyholmestrust.org/',
    linkText: 'www.damekellyholmestrust.org',
    featureFlagName: 'enableDameKellyHolmesCharity'
}, {
    value: OcdrCharity.SAMARITANS,
    imageUrl: 'images/charity-samaritans.png',
    nameKey: 'charity.name.samaritans',
    descriptionKey: 'charity.description.samaritans',
    website: 'https://www.samaritans.org/',
    linkText: 'www.samaritans.org',
    featureFlagName: 'enableSamaritansCharity'
}, {
    value: OcdrCharity.CRUK,
    imageUrl: 'images/charity-cruk.png',
    nameKey: 'charity.name.cruk',
    descriptionKey: 'charity.description.cruk',
    website: 'https://www.cancerresearchuk.org/',
    linkText: 'www.cancerresearchuk.org',
    featureFlagName: 'enableCancerResearchCharity'
}, {
    value: OcdrCharity.GREAT_ORMOND_STREET,
    imageUrl: 'images/charity-great-ormond-street.png',
    nameKey: 'charity.name.great-ormond-street',
    descriptionKey: 'charity.description.great-ormond-street',
    website: 'https://www.gosh.org/',
    linkText: 'www.gosh.org',
    featureFlagName: 'enableGreatOrmondStreetCharity'
}, {
    value: OcdrCharity.NHS,
    imageUrl: 'images/charity-nhs.png',
    nameKey: 'charity.name.nhs',
    descriptionKey: 'charity.description.nhs',
    website: 'https://www.nhscharitiestogether.co.uk/what-we-do/',
    linkText: 'www.nhscharitiestogether.co.uk',
    featureFlagName: 'enableNhsCharity'
}, {
    value: OcdrCharity.DEC,
    imageUrl: 'images/charity-dec.png',
    nameKey: 'charity.name.dec',
    descriptionKey: 'charity.description.dec',
    website: 'https://www.dec.org.uk/',
    linkText: 'www.dec.org.uk',
    featureFlagName: 'enableDecCharity'
}];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReimbursementService = {
    setReimbursement: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(userId, data) {
            var sortCode, accountNumber, method, paypalEmail, charity;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            sortCode = data.sortCode, accountNumber = data.accountNumber, method = data.method, paypalEmail = data.paypalEmail, charity = data.charity;
                            _context.prev = 1;
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.put('/delay-repay/auto/customer/' + userId + '/reimbursement', {
                                method: method,
                                sortCode: sortCode,
                                accountNumber: accountNumber,
                                paypalEmail: paypalEmail,
                                amazonCustomerId: null,
                                charity: charity
                            });

                        case 4:
                            return _context.abrupt('return', true);

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](1);

                            console.warn('error saving reimbursement preference', _context.t0);
                            return _context.abrupt('return', false);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 7]]);
        }));

        function setReimbursement(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return setReimbursement;
    }(),
    getReimbursement: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(userId) {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _AuthenticatedAPIClient2.default.get('/delay-repay/auto/customer/' + userId + '/reimbursement');

                        case 3:
                            response = _context2.sent;
                            return _context2.abrupt('return', response);

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](0);

                            console.warn('error getting reimbursement preference', _context2.t0);
                            return _context2.abrupt('return', false);

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 7]]);
        }));

        function getReimbursement(_x3) {
            return _ref2.apply(this, arguments);
        }

        return getReimbursement;
    }()
};

exports.default = ReimbursementService;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LoginForm = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _PropTypes = __webpack_require__(85);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Login = __webpack_require__(930);

var _Login2 = _interopRequireDefault(_Login);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Customer = __webpack_require__(447);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _NotificationCentre = __webpack_require__(585);

var _FormWrapper = __webpack_require__(613);

var _FormWrapper2 = _interopRequireDefault(_FormWrapper);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _DefaultLoginLayout = __webpack_require__(2030);

var _DefaultLoginLayout2 = _interopRequireDefault(_DefaultLoginLayout);

var _Password = __webpack_require__(419);

var _Password2 = _interopRequireDefault(_Password);

var _AccountLockedModal = __webpack_require__(2031);

var _AccountLockedModal2 = _interopRequireDefault(_AccountLockedModal);

var _PromptPasswordChangeModal = __webpack_require__(934);

var _PromptPasswordChangeModal2 = _interopRequireDefault(_PromptPasswordChangeModal);

var _childSmartCardExpiration = __webpack_require__(2033);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStateFromStores = function getStateFromStores() {
    return {
        user: _UserStore2.default.getCurrent()
    };
};

var LoginForm = exports.LoginForm = (0, _withRouter2.default)(_class = (_temp2 = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(LoginForm, _React$PureComponent);

    function LoginForm() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LoginForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            loginForm: new _Login2.default({
                username: _this.props.emailDefaultValue
            }),
            submitted: false,
            isLoggingIn: false,
            error: null
        }, _this.handleFieldChange = function (field, value) {
            if (field === 'username') {
                _this.props.onUserFieldChange();
            }

            _this.safeSetState({
                loginForm: _this.state.loginForm.set(field, value),
                submitted: false,
                error: null
            }, _this.props.onFormChange(_this.state.loginForm));
        }, _this.handleForgotPassword = function () {
            _ModalActions2.default.open(_AppConstants.GlobalModals.FORGOT_PASSWORD, {
                isBrochureRedirect: _this.props.isBrochureRedirect
            });
        }, _this.handleRegister = function () {
            var _this$props = _this.props,
                registerTitleText = _this$props.registerTitleText,
                titleText = _this$props.titleText,
                onCancel = _this$props.onCancel,
                onCancelRegister = _this$props.onCancelRegister,
                onRegisterSuccessClose = _this$props.onRegisterSuccessClose,
                forceSmartcardSignup = _this$props.forceSmartcardSignup,
                disableSuccessDropdown = _this$props.disableSuccessDropdown,
                onSmartcardSuccess = _this$props.onSmartcardSuccess,
                hideSmartcardCheckbox = _this$props.hideSmartcardCheckbox,
                hideSmartcardPromotionalText = _this$props.hideSmartcardPromotionalText,
                withISRN = _this$props.withISRN,
                onCloseSmartcardError = _this$props.onCloseSmartcardError;


            _ModalActions2.default.open(_AppConstants.GlobalModals.REGISTER, {
                titleText: registerTitleText,
                loginTitleText: titleText,
                onCancel: onCancelRegister,
                onCancelLogin: onCancel,
                onSuccessClose: onRegisterSuccessClose,
                forceSmartcardSignup: forceSmartcardSignup,
                disableSuccessDropdown: disableSuccessDropdown,
                onSmartcardSuccess: onSmartcardSuccess,
                hideSmartcardCheckbox: hideSmartcardCheckbox,
                hideSmartcardPromotionalText: hideSmartcardPromotionalText,
                withISRN: withISRN,
                onCloseSmartcardError: onCloseSmartcardError
            });
        }, _this.handleLogin = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _this$props2, withoutNotifications, router, initialPath, loginForm, user, smartCard;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$props2 = _this.props, withoutNotifications = _this$props2.withoutNotifications, router = _this$props2.router, initialPath = _this$props2.initialPath;
                            loginForm = _this.state.loginForm;

                            _this.safeSetState({
                                submitted: true,
                                isLoggingIn: loginForm.isComplete()
                            });

                            if (loginForm.isComplete()) {
                                _context.next = 5;
                                break;
                            }

                            return _context.abrupt('return');

                        case 5:
                            _context.prev = 5;
                            _context.next = 8;
                            return _CustomerActions2.default.login(loginForm);

                        case 8:
                            user = _context.sent;

                            _this.props.onLogin(user);
                            _this.safeSetState({ loginForm: new _Login2.default(), submitted: false });

                            if (!user.smartcardRegistered) {
                                _context.next = 16;
                                break;
                            }

                            _context.next = 14;
                            return _CustomerActions2.default.getSmartcard(user);

                        case 14:
                            smartCard = _context.sent;

                            (0, _childSmartCardExpiration.checkIfChildSmartCardWillExpireSoon)(smartCard);

                        case 16:

                            if (!withoutNotifications) {
                                if (user.authToken.showPasswordChangeModal) {
                                    (0, _defer3.default)(_ModalActions2.default.open, _PromptPasswordChangeModal2.default, { user: user });
                                } else {
                                    (0, _defer3.default)(_NotificationCentre.displayNotifications);
                                }
                            }

                            (0, _defer3.default)(_CustomerActions2.default.getVouchers, user);
                            if (initialPath) {
                                router.push(initialPath);
                            }
                            _context.next = 26;
                            break;

                        case 21:
                            _context.prev = 21;
                            _context.t0 = _context['catch'](5);

                            console.error(_context.t0);
                            _this.safeSetState({ error: _context.t0 });
                            if (_context.t0 instanceof _Customer.CustomerMaxFailedLoginAttemptsReached) {
                                _ModalActions2.default.open(_AccountLockedModal2.default, { email: loginForm.username });
                            } else if (_context.t0 instanceof _Customer.CustomerAccountDormant) {
                                _ModalActions2.default.open(_AccountLockedModal2.default, { email: loginForm.username, isDormant: true });
                            } else if (_context.t0 instanceof _Customer.CustomerAccountLocked) {
                                _ModalActions2.default.open(_AccountLockedModal2.default, { isLocked: true });
                            }

                        case 26:
                            _context.prev = 26;

                            _this.safeSetState({ isLoggingIn: false });
                            return _context.finish(26);

                        case 29:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[5, 21, 26, 29]]);
        })), _this.makeInput = function (_ref2) {
            var field = _ref2.field,
                label = _ref2.label,
                onBlur = _ref2.onBlur,
                type = _ref2.type;
            var _this$state = _this.state,
                loginForm = _this$state.loginForm,
                submitted = _this$state.submitted,
                isLoggingIn = _this$state.isLoggingIn;

            return _react2.default.createElement(_ValidatedField2.default, {
                form: loginForm,
                onChange: _this.handleFieldChange,
                type: type,
                id: field,
                field: field,
                label: label,
                placeholder: label,
                labelClassName: 'sr-only',
                visited: submitted,
                disabled: isLoggingIn,
                onBlur: onBlur,
                showRequired: true,
                hideOptional: true,
                outsideLabel: true
            });
        }, _this.makeLinkButton = function (_ref3) {
            var onClick = _ref3.onClick,
                label = _ref3.label;
            return _react2.default.createElement(
                _Button2.default,
                { className: 'like-link text-sm', onClick: onClick },
                label
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    LoginForm.prototype.componentDidMount = function componentDidMount() {
        this._isMounted = true;
    };

    LoginForm.prototype.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
    };

    LoginForm.prototype.safeSetState = function safeSetState() {
        if (this._isMounted) {
            this.setState.apply(this, arguments);
        }
    };

    LoginForm.prototype.render = function render() {
        var _props = this.props,
            user = _props.user,
            withSubmitButton = _props.withSubmitButton,
            Layout = _props.children,
            onUserFieldBlur = _props.onUserFieldBlur;
        var _state = this.state,
            loginForm = _state.loginForm,
            submitted = _state.submitted,
            isLoggingIn = _state.isLoggingIn,
            error = _state.error;


        var isLoggedIn = (0, _result3.default)(user, 'isFullyLoaded');
        if (isLoggedIn) {
            return null;
        }

        var userInput = this.makeInput({
            field: 'username',
            label: (0, _I18n2.default)('login.username'),
            onBlur: onUserFieldBlur,
            type: 'email'
        });

        var passwordInput = _react2.default.createElement(_Password2.default, {
            field: 'password',
            form: loginForm,
            onChange: this.handleFieldChange,
            showPasswordIcon: true,
            visited: submitted,
            showRequired: true,
            outsideLabel: true
        });

        var forgotPasswordButton = this.makeLinkButton({
            onClick: this.handleForgotPassword,
            label: (0, _I18n2.default)('login.forgotPassword.link')
        });

        var props = {
            userInput: userInput,
            passwordInput: passwordInput,
            forgotPasswordButton: forgotPasswordButton,
            withSubmitButton: withSubmitButton,
            submitted: submitted,
            isLoggingIn: isLoggingIn,
            form: loginForm,
            error: error && (0, _I18n2.default)('alertmessage.login.failed'),
            onInputChange: this.handleFieldChange,
            onRegister: this.handleRegister,
            onForgotPassword: this.handleForgotPassword,
            onLogin: this.handleLogin
        };

        return _react2.default.createElement(
            _FormWrapper2.default,
            { submitted: submitted },
            _react2.default.createElement(Layout, (0, _extends3.default)({}, props, {
                loginComponent: _react2.default.createElement(_DefaultLoginLayout2.default, props)
            }))
        );
    };

    return LoginForm;
}(_react2.default.PureComponent), _class2.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    withSubmitButton: _propTypes2.default.bool,
    onLogin: _propTypes2.default.func,
    children: _propTypes2.default.func,
    registerTitleText: _propTypes2.default.string,
    titleText: _propTypes2.default.string,
    onCancel: _propTypes2.default.func,
    onCancelRegister: _propTypes2.default.func,
    onRegisterSuccessClose: _propTypes2.default.func,
    onFormChange: _propTypes2.default.func,
    forceSmartcardSignup: _propTypes2.default.bool,
    onCloseSmartcardError: _propTypes2.default.func,
    disableSuccessDropdown: _propTypes2.default.bool,
    onUserFieldBlur: _propTypes2.default.func,
    onUserFieldChange: _propTypes2.default.func,
    onSmartcardSuccess: _propTypes2.default.func,
    router: _PropTypes.routerShape.isRequired,
    hideSmartcardCheckbox: _propTypes2.default.bool,
    hideSmartcardPromotionalText: _propTypes2.default.bool,
    withISRN: _propTypes2.default.bool,
    withoutNotifications: _propTypes2.default.bool,
    emailDefaultValue: _propTypes2.default.string,
    isBrochureRedirect: _propTypes2.default.bool,
    initialPath: _propTypes2.default.string
}, _class2.defaultProps = {
    withSubmitButton: false,
    children: _DefaultLoginLayout2.default,
    onLogin: _noop3.default,
    onRegisterSuccessClose: _noop3.default,
    forceSmartcardSignup: false,
    disableSuccessDropdown: false,
    onFormChange: _noop3.default,
    onUserFieldBlur: _noop3.default,
    onUserFieldChange: _noop3.default,
    hideSmartcardCheckbox: false,
    hideSmartcardPromotionalText: false,
    withISRN: false,
    onSmartcardSuccess: _noop3.default,
    onCloseSmartcardError: _noop3.default,
    withoutNotifications: false,
    emailDefaultValue: null,
    isBrochureRedirect: false
}, _temp2)) || _class;

exports.default = (0, _connectToStores2.default)([_UserStore2.default], getStateFromStores)(LoginForm);

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _I18n = __webpack_require__(9);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _DateTime = __webpack_require__(640);

var _DateTime2 = _interopRequireDefault(_DateTime);

var _FareStations = __webpack_require__(282);

var _FareStations2 = _interopRequireDefault(_FareStations);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FareShort = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(FareShort, _PureRenderComponent);

    function FareShort() {
        (0, _classCallCheck3.default)(this, FareShort);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    FareShort.prototype._renderFareDate = function _renderFareDate(text, journey, directionIcon) {
        if (!journey.legs.size) {
            return null;
        }
        return _react2.default.createElement(
            'div',
            { key: text, className: 'text-sm clearfix' },
            _react2.default.createElement(
                'p',
                { className: 'direction no-margin text-light text-weight--normal' },
                _react2.default.createElement(_Icon2.default, { icon: 'inbound', className: directionIcon + ' text-light text-primary' }),
                (0, _I18n.translate)(text) + ' ',
                _react2.default.createElement(_DateTime2.default, {
                    className: 'text-primary',
                    dateTime: journey.getDepartureTime(),
                    format: 'HH:mm ddd DD MMM YYYY'
                })
            )
        );
    };

    FareShort.prototype._renderFareDates = function _renderFareDates(fare) {
        var dates = [];
        var outwardJourney = fare.outwardJourney;
        var returnJourney = fare.returnJourney;

        dates.push(this._renderFareDate('order.summary.out', outwardJourney, 'otrl-rotate-180'));

        if (returnJourney) {
            dates.push(this._renderFareDate('order.summary.return', returnJourney, null));
        }

        return dates;
    };

    FareShort.prototype.render = function render() {
        var orderFare = this.props.orderFare;


        return _react2.default.createElement(
            'li',
            { className: 'order-summary__item order-summary__item--short margin-bottom' },
            _react2.default.createElement(
                _Row2.default,
                { className: 'fare-summary' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, md: 6, lg: 6 },
                    _react2.default.createElement(_FareStations2.default, {
                        origin: orderFare.origin,
                        destination: orderFare.destination,
                        isReturn: orderFare.isReturn()
                    })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, md: 6, lg: 6, className: 'text-weight--normal ticket-type no-margin' },
                    _react2.default.createElement(
                        'p',
                        { className: 'text-weight--normal ticket-type no-margin' },
                        orderFare.getName(),
                        '\xA0',
                        orderFare.isGroupSave() && (0, _I18n.translate)('order.summary.groupSave')
                    )
                )
            ),
            this._renderFareDates(orderFare)
        );
    };

    return FareShort;
}(_PureRenderComponent3.default), _class.propTypes = {
    orderFare: _propTypes2.default.instanceOf(_Fare2.default).isRequired
}, _temp);
exports.default = FareShort;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DisruptionAlert = __webpack_require__(289);

var _AppConstants = __webpack_require__(6);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _DisruptionAlert2 = __webpack_require__(444);

var _DisruptionAlert3 = _interopRequireDefault(_DisruptionAlert2);

var _AddRegularJourneyModal = __webpack_require__(1161);

var _AddRegularJourneyModal2 = _interopRequireDefault(_AddRegularJourneyModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertBuilderModal = function AlertBuilderModal(_ref) {
    var hideAlertCreationModal = _ref.hideAlertCreationModal,
        journeyDirection = _ref.journeyDirection,
        onAlertBuilderSubmit = _ref.onAlertBuilderSubmit,
        order = _ref.order,
        orderTrip = _ref.orderTrip,
        outwardAlert = _ref.outwardAlert,
        prefillFromSearch = _ref.prefillFromSearch,
        user = _ref.user,
        isEditingAlert = _ref.isEditingAlert,
        editingAlert = _ref.editingAlert;

    var trip = (0, _useStoreState2.default)(_CurrentTripStore2.default);
    var isSeason = orderTrip && orderTrip.isSeason() || prefillFromSearch && trip && trip.isSeason() || false;

    var _getInitialFormState = (0, _DisruptionAlert.getInitialFormState)(outwardAlert, order, orderTrip, trip, isSeason, false, journeyDirection, prefillFromSearch),
        initialSearch = _getInitialFormState[0];

    var prepopulatedSearch = initialSearch;

    var presetWeekday = null;

    if (outwardAlert) {
        if (outwardAlert.daysOfWeek.includes('SATURDAY')) {
            presetWeekday = 'saturday';
        } else if (outwardAlert.daysOfWeek.includes('SUNDAY')) {
            presetWeekday = 'sunday';
        } else {
            presetWeekday = 'weekday';
        }
    }

    return _react2.default.createElement(_AddRegularJourneyModal2.default, {
        mode: 'ddm',
        prepopulatedSearch: prepopulatedSearch,
        remainingJourneys: Infinity // let the API handle informing us that the user cannot add any more alerts
        , setIsJourneyCardModalOpen: hideAlertCreationModal,
        setEditingJourney: _noop3.default,
        successCallback: function successCallback(_ref2) {
            var alrt = _ref2.alrt,
                err = _ref2.err,
                success = _ref2.success;
            return onAlertBuilderSubmit({
                alrt: alrt,
                err: err,
                success: success
            });
        },
        user: user,
        isEditingAlert: isEditingAlert,
        editingAlert: editingAlert,
        presetWeekday: presetWeekday
    });
};

AlertBuilderModal.propTypes = {
    hideAlertCreationModal: _propTypes2.default.func,
    journeyDirection: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.JourneyDirections)),
    onAlertBuilderSubmit: _propTypes2.default.func,
    order: _propTypes2.default.instanceOf(_Order2.default),
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default),
    outwardAlert: _propTypes2.default.instanceOf(_DisruptionAlert3.default),
    prefillFromSearch: _propTypes2.default.bool,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    isEditingAlert: _propTypes2.default.bool,
    editingAlert: _propTypes2.default.instanceOf(_DisruptionAlert3.default)
};

exports.default = AlertBuilderModal;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _AddJourneyForm = __webpack_require__(2042);

var _AddJourneyForm2 = _interopRequireDefault(_AddJourneyForm);

var _DisruptionAlertActions = __webpack_require__(340);

var _DisruptionAlertActions2 = _interopRequireDefault(_DisruptionAlertActions);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _FavouriteJourneysService = __webpack_require__(1109);

var _FavouriteJourneysService2 = _interopRequireDefault(_FavouriteJourneysService);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

var _DisruptionAlertStore = __webpack_require__(345);

var _DisruptionAlertStore2 = _interopRequireDefault(_DisruptionAlertStore);

var _JourneyPlanService = __webpack_require__(272);

var _JourneyPlanService2 = _interopRequireDefault(_JourneyPlanService);

var _DisruptionAlert = __webpack_require__(444);

var _DisruptionAlert2 = _interopRequireDefault(_DisruptionAlert);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _DisruptionAlert3 = __webpack_require__(289);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultBusinessDays = [{ id: 1, day: _AppConstants.WeekdayNames.MONDAY, checked: true }, { id: 2, day: _AppConstants.WeekdayNames.TUESDAY, checked: true }, { id: 3, day: _AppConstants.WeekdayNames.WEDNESDAY, checked: true }, { id: 4, day: _AppConstants.WeekdayNames.THURSDAY, checked: true }, { id: 5, day: _AppConstants.WeekdayNames.FRIDAY, checked: true }];

var AddRegularJourneyModal = function AddRegularJourneyModal(_ref) {
    var editingJourney = _ref.editingJourney,
        editingAlert = _ref.editingAlert,
        enableRegularJourneyCreation = _ref.enableRegularJourneyCreation,
        getFavouriteJourneys = _ref.getFavouriteJourneys,
        isEditingAlert = _ref.isEditingAlert,
        _ref$mode = _ref.mode,
        mode = _ref$mode === undefined ? 'ocdr' : _ref$mode,
        prepopulatedSearch = _ref.prepopulatedSearch,
        presetWeekday = _ref.presetWeekday,
        remainingJourneys = _ref.remainingJourneys,
        _ref$setEditingJourne = _ref.setEditingJourney,
        setEditingJourney = _ref$setEditingJourne === undefined ? _noop3.default : _ref$setEditingJourne,
        _ref$setIsJourneyCard = _ref.setIsJourneyCardModalOpen,
        setIsJourneyCardModalOpen = _ref$setIsJourneyCard === undefined ? _noop3.default : _ref$setIsJourneyCard,
        successCallback = _ref.successCallback,
        user = _ref.user;

    var isOCDRMode = mode === 'ocdr';

    var bankHolidays = (0, _useStoreState2.default)(_DisruptionAlertStore2.default, 'bankHolidays');

    var getNewSearch = function getNewSearch() {
        return new _Search2.default({ numJourneys: 5 });
    };

    var _useState = (0, _react.useState)(defaultBusinessDays),
        businessDays = _useState[0],
        setBusinessDays = _useState[1];

    var _useState2 = (0, _react.useState)(_AppConstants.InitialWeekDayJourney),
        weekday = _useState2[0],
        setWeekday = _useState2[1];

    var _useState3 = (0, _react.useState)(prepopulatedSearch || getNewSearch()),
        search = _useState3[0],
        setSearch = _useState3[1];

    var _useState4 = (0, _react.useState)(getNewSearch()),
        journeySearchResults = _useState4[0],
        setJourneySearchResults = _useState4[1];

    var _useState5 = (0, _react.useState)([]),
        selectedJourneys = _useState5[0],
        setSelectedJourneys = _useState5[1];

    var _useState6 = (0, _react.useState)(enableRegularJourneyCreation),
        saveRegularJourneyAlert = _useState6[0],
        setSaveRegularJourneyAlert = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        stationFacilityAlert = _useState7[0],
        setStationFacilityAlert = _useState7[1];

    var _useState8 = (0, _react.useState)(false),
        showErrorWell = _useState8[0],
        setShowErrorWell = _useState8[1];

    var _useState9 = (0, _react.useState)(''),
        errorWellText = _useState9[0],
        setShowErrorWellText = _useState9[1];

    var _useState10 = (0, _react.useState)(true),
        disabledSaveJourney = _useState10[0],
        setDisabledSaveJourney = _useState10[1];

    var _useState11 = (0, _react.useState)(false),
        timeAdjusted = _useState11[0],
        setTimeAdjusted = _useState11[1];

    var outward = journeySearchResults.outward;


    var outwardJourneys = outward && outward.map(function (x) {
        return x.journey;
    }).filter(function (x) {
        return x.origin.time.scheduledTime.isSame(search.outboundDateTime.datetime, 'day');
    });

    var routeCode = outward && outward.first() && outward.first().fares && outward.first().fares.singles.first().route.code;

    var originNlc = search && search.origin && search.origin.nlc;
    var destinationNlc = search && search.destination && search.destination.nlc;

    var resetAddJourneyForm = function resetAddJourneyForm() {
        setSearch(getNewSearch());
        setJourneySearchResults(getNewSearch());
        setSelectedJourneys([]);
        setBusinessDays(defaultBusinessDays);
        setWeekday(_AppConstants.InitialWeekDayJourney);
        setEditingJourney(null);
    };

    var setJourneyTime = function setJourneyTime(datetime) {
        var outboundDateTime = new _Timeband2.default({ datetime: datetime });
        setSearch(search.set('outboundDateTime', outboundDateTime));
        setTimeAdjusted(true);
    };

    var formatLeg = function formatLeg(leg, ddmFormat) {
        var origin = leg.origin.first();
        var destination = leg.destination.first();

        if (!origin) {
            return false;
        }

        return {
            origin: ddmFormat ? origin.station : origin.station.nlc,
            destination: ddmFormat ? destination.station : destination.station.nlc,
            departure: origin.getTime(),
            arrival: destination.getTime(),
            transferTime: leg.transferTime,
            mode: leg.serviceDetails.mode,
            toc: leg.serviceDetails.toc && leg.serviceDetails.toc.id,
            seats: [],
            reservable: leg.serviceDetails.reservable,
            facilities: '',
            rsid: leg.rsid,
            tuid: leg.serviceDetails.trainUid,
            isTemporaryTrain: leg.serviceDetails.isTemporaryTrain
        };
    };

    var formatJourney = function formatJourney(journey, ddmFormat) {
        if (ddmFormat) {
            return journey.legs.map(function (x) {
                return formatLeg(x, true);
            });
        }
        return {
            time: journey.getDepartureDateTime().format('HH:mm'),
            legs: journey.legs.map(function (leg) {
                return formatLeg(leg, false);
            })
        };
    };

    var saveFavouriteJourney = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var hasErrors, services, daysOfWeek, journey, days, origin, destination, wrappedServices, formData, formattedLegs, allLegs, disruptionAlertLegs, updatedAlert, alrt;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setShowErrorWell(false);
                            setShowErrorWellText('');
                            hasErrors = false;
                            services = selectedJourneys.map(function (service) {
                                return formatJourney(service, false);
                            });
                            daysOfWeek = [];


                            if (weekday === 'saturday' || weekday === 'sunday') {
                                daysOfWeek = [weekday];
                            } else {
                                daysOfWeek = businessDays.filter(function (day) {
                                    return day.checked;
                                }).map(function (day) {
                                    return day.day;
                                });
                            }

                            journey = {
                                journeyId: editingJourney ? editingJourney.journeyId : null,
                                journeyType: weekday,
                                origin: search.origin.nlc,
                                destination: search.destination.nlc,
                                routeCode: routeCode,
                                services: services,
                                daysOfWeek: daysOfWeek
                            };

                            if (!isOCDRMode) {
                                _context.next = 24;
                                break;
                            }

                            _context.prev = 8;

                            if (!editingJourney) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 12;
                            return _FavouriteJourneysService2.default.editFavouriteJourney(user, journey);

                        case 12:
                            _context.next = 16;
                            break;

                        case 14:
                            _context.next = 16;
                            return _FavouriteJourneysService2.default.saveFavouriteJourney(user, journey);

                        case 16:
                            _context.next = 24;
                            break;

                        case 18:
                            _context.prev = 18;
                            _context.t0 = _context['catch'](8);

                            console.warn('error saving Regular Journey', _context.t0);
                            setShowErrorWell(true);
                            hasErrors = true;
                            setShowErrorWellText((0, _I18n2.default)('one-click-delay-repay.error-setting-up-regular-journey', {
                                alert: 'Favourite Journey'
                            }));

                        case 24:
                            if (!((saveRegularJourneyAlert || !isOCDRMode) && !hasErrors)) {
                                _context.next = 55;
                                break;
                            }

                            days = _AppConstants.DisruptionAlertDaysOptions.WEEKDAYS;


                            if (weekday === 'saturday') {
                                days = _AppConstants.DisruptionAlertDaysOptions.SATURDAYS;
                            } else if (weekday === 'sunday') {
                                days = _AppConstants.DisruptionAlertDaysOptions.SUNDAYS;
                            }

                            origin = search.origin, destination = search.destination;
                            wrappedServices = selectedJourneys.map(function (x) {
                                return { journey: x };
                            });
                            formData = {
                                customEndDate: null,
                                days: days,
                                destination: destination,
                                duration: _AppConstants.DisruptionAlertDurationOptions.INFINITE,
                                origin: origin,
                                selectedServices: new _immutable.List(wrappedServices),
                                startDate: search.outboundDateTime.datetime,
                                weekdays: {
                                    MONDAY: daysOfWeek.includes('monday'),
                                    TUESDAY: daysOfWeek.includes('tuesday'),
                                    WEDNESDAY: daysOfWeek.includes('wednesday'),
                                    THURSDAY: daysOfWeek.includes('thursday'),
                                    FRIDAY: daysOfWeek.includes('friday')
                                }
                            };

                            if (!isEditingAlert) {
                                _context.next = 41;
                                break;
                            }

                            formattedLegs = selectedJourneys.map(function (x) {
                                return formatJourney(x, true);
                            });
                            allLegs = [];


                            formattedLegs.map(function (list) {
                                list.map(function (leg) {
                                    return allLegs.push(leg);
                                });
                            });

                            disruptionAlertLegs = (0, _DisruptionAlert3.legsToDisruptionAlertLegs)(allLegs);
                            updatedAlert = editingAlert.set('departureTime', disruptionAlertLegs[0].departureTime).set('legs', disruptionAlertLegs).set('daysOfWeek', daysOfWeek.map(function (day) {
                                return day.toUpperCase();
                            })).set('customer', user);
                            _context.next = 38;
                            return _DisruptionAlertActions2.default.update(user, updatedAlert);

                        case 38:

                            successCallback({ success: true });
                            _context.next = 55;
                            break;

                        case 41:
                            _context.prev = 41;
                            _context.next = 44;
                            return _DisruptionAlertActions2.default.createFromBuilder({ user: user, formData: formData, stationFacilityAlert: stationFacilityAlert });

                        case 44:
                            alrt = _context.sent;

                            _TrackingActions2.default.saveRegularJourneyAlertWithOCDRFavJourney();
                            if (!isOCDRMode) {
                                successCallback({
                                    alrt: alrt,
                                    success: true
                                });
                            }
                            _context.next = 55;
                            break;

                        case 49:
                            _context.prev = 49;
                            _context.t1 = _context['catch'](41);

                            setShowErrorWell(true);
                            hasErrors = true;
                            setShowErrorWellText((0, _I18n2.default)('one-click-delay-repay.error-setting-up-regular-journey', {
                                alert: 'Journey Alert'
                            }));
                            if (!isOCDRMode) {
                                successCallback({ err: _context.t1, success: true });
                            }

                        case 55:
                            if (hasErrors) {
                                _context.next = 61;
                                break;
                            }

                            if (!isOCDRMode) {
                                _context.next = 59;
                                break;
                            }

                            _context.next = 59;
                            return getFavouriteJourneys(user);

                        case 59:
                            setIsJourneyCardModalOpen(false);
                            resetAddJourneyForm();

                        case 61:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[8, 18], [41, 49]]);
        }));

        return function saveFavouriteJourney() {
            return _ref2.apply(this, arguments);
        };
    }();

    var searchOrigin = search.origin;
    var searchDestination = search.destination;
    var searchDatetime = search.outboundDateTime.datetime;

    (0, _react.useEffect)(function () {
        var searchJourneys = function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var outboundDateTime, isOutboundTravelDay, isBankHoliday, journeys;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                outboundDateTime = search.outboundDateTime.datetime;

                                isOutboundTravelDay = function isOutboundTravelDay(x) {
                                    return outboundDateTime.isSame(x, 'day');
                                };

                                isBankHoliday = bankHolidays.some(isOutboundTravelDay);

                                /*
                                    We need to use a while loop because it is
                                    possible that there are two bank holiday Mondays in a row
                                    (this happens in December if Christmas and New Year fall on a Monday)
                                */

                                while (isBankHoliday) {
                                    outboundDateTime = outboundDateTime.add(7, 'days');
                                    isBankHoliday = bankHolidays.some(isOutboundTravelDay);
                                }

                                _context2.next = 6;
                                return _JourneyPlanService2.default.search({
                                    delayRepayFiltering: isOCDRMode,
                                    search: search,
                                    user: user
                                });

                            case 6:
                                journeys = _context2.sent;


                                setJourneySearchResults(journeys);

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            return function searchJourneys() {
                return _ref3.apply(this, arguments);
            };
        }();

        if (timeAdjusted && search && search.origin.nlc && search.destination.nlc && search.isValid()) {
            (0, _defer3.default)(searchJourneys);
        }
        // eslint-disable-next-line
    }, [searchOrigin, searchDestination, searchDatetime, presetWeekday]);

    /*
        if user changes stations, we need to remove previously selected journeys
        as only journeys from one set of stations at a time can be saved
    */
    (0, _react.useEffect)(function () {
        setSelectedJourneys([]);
    }, [weekday, originNlc, destinationNlc]);

    (0, _react.useEffect)(function () {
        (0, _defer3.default)(_DisruptionAlertActions2.default.getBankHolidays);

        if (prepopulatedSearch) {
            var initialDay = _AppConstants.InitialWeekDayJourney;

            initialDay = prepopulatedSearch.outboundDateTime.datetime.format('dddd').toLowerCase();

            if (presetWeekday) {
                setWeekday(presetWeekday);
            } else if (initialDay !== 'saturday' && initialDay !== 'sunday') {
                setWeekday('weekday');
            } else {
                setWeekday(initialDay);
            }
        }
    }, [prepopulatedSearch, presetWeekday]);

    return _react2.default.createElement(
        _BaseModal2.default,
        {
            className: 'modal--med',
            modalTitleClass: 'journey-cards-modal-title',
            titleText: 'auto-dr.account.subscribe.journeys.modal.title',
            continueText: isOCDRMode ? "auto-dr.account.subscribe.journeys.modal.save" : "ddm.account.subscribe.journeys.modal.save",
            disableContinue: disabledSaveJourney,
            onContinue: saveFavouriteJourney,
            onClose: function onClose() {
                setIsJourneyCardModalOpen(false);
                resetAddJourneyForm();
                setShowErrorWell(false);
                setShowErrorWellText('');
            }
        },
        _react2.default.createElement(_AddJourneyForm2.default, {
            businessDays: businessDays,
            setBusinessDays: setBusinessDays,
            weekday: weekday,
            setWeekday: setWeekday,
            setJourneyTime: setJourneyTime,
            setDisabledSaveJourney: setDisabledSaveJourney,
            search: search,
            searchErrors: search.getValidationErrors(),
            setSearch: setSearch,
            journeySearchResults: journeySearchResults,
            selectedJourneys: selectedJourneys,
            setSelectedJourneys: setSelectedJourneys,
            outwardJourneys: outwardJourneys,
            remainingJourneys: remainingJourneys,
            editingJourney: editingJourney,
            saveRegularJourneyAlert: saveRegularJourneyAlert,
            setSaveRegularJourneyAlert: setSaveRegularJourneyAlert,
            showErrorWell: showErrorWell,
            errorWellText: errorWellText,
            enableRegularJourneyCreation: enableRegularJourneyCreation,
            setStationFacilityAlert: setStationFacilityAlert,
            stationFacilityAlert: stationFacilityAlert,
            isOCDRMode: isOCDRMode
        })
    );
};

AddRegularJourneyModal.propTypes = {
    editingAlert: _propTypes2.default.instanceOf(_DisruptionAlert2.default),
    editingJourney: _propTypes2.default.string,
    enableRegularJourneyCreation: _propTypes2.default.bool,
    getFavouriteJourneys: _propTypes2.default.func,
    isEditingAlert: _propTypes2.default.bool,
    mode: _propTypes2.default.string,
    prepopulatedSearch: _propTypes2.default.instanceOf(_Search2.default),
    presetWeekday: (0, _propTypes.oneOf)(['weekday', 'saturday', 'sunday']),
    remainingJourneys: _propTypes2.default.number,
    setEditingJourney: _propTypes2.default.func,
    setIsJourneyCardModalOpen: _propTypes2.default.func,
    successCallback: _propTypes2.default.func,
    user: _propTypes2.default.instanceOf(_User2.default)
};

exports.default = AddRegularJourneyModal;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _uniqBy2 = __webpack_require__(1163);

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

var _debounce2 = __webpack_require__(277);

var _debounce3 = _interopRequireDefault(_debounce2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _AutocompleteOption = __webpack_require__(2044);

var _AutocompleteOption2 = _interopRequireDefault(_AutocompleteOption);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_UP = 38;
var KEY_DOWN = 40;
var KEY_ESCAPE = 27;
var KEY_ENTER = 13;
var KEY_TAB = 9;

var Autocomplete = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Autocomplete, _React$PureComponent);

    Autocomplete.prototype.getDefaultState = function getDefaultState() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$open = _ref.open,
            open = _ref$open === undefined ? false : _ref$open;

        return {
            open: open,
            value: this.props.defaultValue,
            inputValue: this.props.defaultInputValue,
            searching: false,
            highlighted: -1
        };
    };

    function Autocomplete(props) {
        (0, _classCallCheck3.default)(this, Autocomplete);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call(this, props));

        _this.handleChange = function (event) {
            var value = event.target.value;
            if (value === _this.state.inputValue) {
                return;
            }

            if (value.length >= 3) {
                _this.setState({
                    inputValue: value,
                    searching: true
                }, function () {
                    if (_this.props.debounce) {
                        _this.onSearch.cancel();
                    }
                    _this.onSearch(value);
                });
            } else {
                _this.setState({
                    inputValue: value,
                    searching: false,
                    results: []
                });

                if (!value) {
                    _this.props.onClear(value);
                }
            }
        };

        _this.handleKeyDown = function (event) {
            var _handlers;

            var key = event.keyCode;

            var handlers = (_handlers = {}, _handlers[KEY_UP] = _this.togglePrevious, _handlers[KEY_DOWN] = _this.toggleNext, _handlers[KEY_ENTER] = _this.selectHighlighted, _handlers[KEY_TAB] = _this.selectHighlighted, _handlers[KEY_ESCAPE] = _this.hideResults, _handlers);

            if (handlers[key]) {
                handlers[key].call(_this);
                if (key !== KEY_TAB) {
                    event.preventDefault();
                }
            }
        };

        _this._handleClear = function () {
            _this.refs.input.focus();
            _this.setState({ open: true }, _this.props.onClear);
        };

        _this.handleBlur = function () {
            if (_this.state.open && _this.state.inputValue) {
                _this.selectHighlighted();
            } else {
                _this.hideResults();
            }
        };

        _this.handleFocus = function () {
            if (!_this.state.value && _this.getResults().length) {
                _this.setState({ open: true });
            }
        };

        _this.state = _this.getDefaultState();
        return _this;
    }

    Autocomplete.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        var newState = void 0;

        if (newProps.defaultInputValue !== this.props.defaultInputValue || newProps.defaultValue !== this.props.defaultValue) {

            newState = this.getDefaultState({ open: this.state.open });
            newState.value = newProps.defaultValue;
            newState.inputValue = newProps.defaultInputValue;
        }

        if (this.state.searching && newProps.results !== this.props.results && newProps.searchValue === this.state.inputValue) {

            newState = {
                searching: false,
                open: true
            };
        }

        if (newState) {
            this.setState(newState);
        }
    };

    Autocomplete.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        if (this.props.debounce) {
            this.onSearch = (0, _debounce3.default)(this.props.onSearch, 200);
        } else {
            this.onSearch = this.props.onSearch;
        }
    };

    Autocomplete.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.props.focused) {
            this.refs.input.focus();
        }
    };

    Autocomplete.prototype.togglePrevious = function togglePrevious() {
        var highlighted = this.state.highlighted;

        if (this.getResults().length && !this.state.searching) {
            if (highlighted !== 0) {
                highlighted = this.state.highlighted - 1;
            }

            this.setState({
                open: true,
                highlighted: highlighted
            });
        }
    };

    Autocomplete.prototype.toggleNext = function toggleNext() {
        var highlighted = this.state.highlighted;

        if (this.getResults().length && !this.state.searching) {
            if (highlighted !== this.getResults().length - 1) {
                highlighted = this.state.highlighted + 1;
            }

            this.setState({
                open: true,
                highlighted: highlighted
            });
        }
    };

    Autocomplete.prototype.hideResults = function hideResults() {
        this.setState({
            open: false,
            searching: false,
            highlighted: -1
        });
    };

    Autocomplete.prototype.selectHighlighted = function selectHighlighted() {
        if (this.getResults().length) {
            var highlighted = this.state.highlighted >= 0 ? this.state.highlighted : 0;
            var result = this.getResults()[highlighted];
            this.selectValue(result.value, result.label);
        }
    };

    Autocomplete.prototype._handleOptionSelect = function _handleOptionSelect(result) {
        var _this2 = this;

        return function (e) {
            _this2.selectValue(result.value, result.label);
            e.preventDefault();
        };
    };

    Autocomplete.prototype.selectValue = function selectValue(value, label) {
        var _this3 = this;

        var newState = this.getDefaultState();
        this.setState((0, _assign2.default)(newState, { value: value, label: label }), function () {
            return _this3.props.onSelect(value);
        });
    };

    Autocomplete.prototype.getOptionId = function getOptionId(index) {
        return 'autocomplete-' + this.props.name + '-option-' + index;
    };

    Autocomplete.prototype.getActiveDescendentId = function getActiveDescendentId() {
        var highlighted = this.state.highlighted;

        return highlighted === -1 ? null : this.getOptionId(highlighted);
    };

    Autocomplete.prototype.renderResults = function renderResults() {
        var _this4 = this;

        var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (!this.state.open) {
            return null;
        }

        if (results.length) {
            return results.map(function (result, index) {
                var isActive = index === _this4.state.highlighted;
                return _react2.default.createElement(
                    'li',
                    {
                        key: result.value,
                        id: _this4.getOptionId(index),
                        role: 'option',
                        'aria-selected': isActive,
                        onClick: _this4._handleOptionSelect(result)
                    },
                    _react2.default.createElement(_AutocompleteOption2.default, { value: result.value,
                        search: _this4.state.inputValue,
                        label: result.label,
                        data: result.data,
                        highlighted: isActive,
                        optionElement: _this4.props.optionElement })
                );
            });
        }

        if (!this.state.searching) {
            return this.renderNoResults();
        }

        return null;
    };

    Autocomplete.prototype.renderNoResults = function renderNoResults() {
        return _react2.default.createElement(
            'div',
            { className: 'autocomplete__noResults', role: 'status' },
            'No results found'
        );
    };

    Autocomplete.prototype.renderSearchIcon = function renderSearchIcon() {
        if (!this.state.searching) {
            return null;
        }

        return _react2.default.createElement('i', { className: 'autocomplete__spinner otrl otrl-spinner otrl-spin' });
    };

    Autocomplete.prototype.renderClearButton = function renderClearButton() {
        if (!this.props.defaultValue || this.state.searching) {
            return null;
        }

        var buttonProps = {
            type: 'button',
            'aria-label': (0, _I18n.translate)('ariaLabel.clearContent'),
            onClick: this._handleClear,
            className: 'autocomplete__clear',
            tabIndex: '0'
        };

        return _react2.default.createElement(
            'button',
            buttonProps,
            _react2.default.createElement(_Icon2.default, { icon: 'clear' }),
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _I18n.translate)('booking.journey.clear')
            )
        );
    };

    Autocomplete.prototype.renderPlaceholder = function renderPlaceholder() {
        if (this.state.inputValue && this.props.placeholder && this.props.floatyPlaceholder) {
            return _react2.default.createElement(
                'span',
                { className: 'placeholder text-sm' },
                this.props.placeholder
            );
        }
        return null;
    };

    Autocomplete.prototype.preventBlur = function preventBlur(e) {
        e.preventDefault();
        e.stopPropagation();
    };

    Autocomplete.prototype.getResults = function getResults() {
        var _props = this.props,
            resultsFilter = _props.resultsFilter,
            results = _props.results;
        var _state$inputValue = this.state.inputValue,
            inputValue = _state$inputValue === undefined ? '' : _state$inputValue;


        return (0, _uniqBy3.default)(resultsFilter ? results.filter(resultsFilter.bind(null, inputValue)) : results, 'value');
    };

    Autocomplete.prototype.render = function render() {
        var _this5 = this;

        var _props2 = this.props,
            disabled = _props2.disabled,
            label = _props2.label,
            resultsLabel = _props2.resultsLabel,
            name = _props2.name,
            title = _props2.title,
            overlayResults = _props2.overlayResults,
            placeholder = _props2.placeholder,
            required = _props2.required,
            isInvalid = _props2.isInvalid,
            errorMessage = _props2.errorMessage;
        var _state = this.state,
            open = _state.open,
            inputValue = _state.inputValue,
            searching = _state.searching;

        var resultsList = this.getResults();
        var containerClasses = (0, _classnames2.default)('autocomplete__container', {
            'input-field--autocomplete': overlayResults
        });
        var classes = (0, _classnames2.default)(this.props.className, {
            'autocomplete': true,
            'autocomplete--open': open
        });

        var showResultsList = open && !searching;
        var resultsId = 'autocomplete-' + name + '-results';
        return _react2.default.createElement(
            'div',
            {
                className: containerClasses
            },
            _react2.default.createElement(
                'label',
                null,
                label,
                _react2.default.createElement('input', {
                    type: 'text',
                    name: name,
                    className: classes,
                    ref: 'input',
                    autoComplete: 'off',
                    autoCorrect: 'off',
                    spellCheck: 'false',
                    title: title || name,
                    value: inputValue || '',
                    placeholder: placeholder,
                    onChange: this.handleChange,
                    onKeyDown: this.handleKeyDown,
                    onFocus: this.handleFocus,
                    onBlur: this.handleBlur,
                    disabled: disabled,
                    required: required,
                    role: 'combobox',
                    'aria-haspopup': 'listbox',
                    'aria-owns': open ? resultsId : null,
                    'aria-expanded': open,
                    'aria-autocomplete': 'list',
                    'aria-controls': open ? resultsId : null,
                    'aria-activedescendant': this.getActiveDescendentId(),
                    'aria-invalid': isInvalid ? "true" : "false",
                    'aria-errormessage': errorMessage
                })
            ),
            showResultsList && resultsList.length ? _react2.default.createElement(
                'div',
                { className: 'sr-only', role: 'status' },
                (0, _I18n.translate)('autocomplete.resultCount', { count: resultsList.length })
            ) : null,
            required && _react2.default.createElement(_Icon2.default, { icon: 'mandatory' }),
            !disabled && this.renderClearButton(),
            this.renderSearchIcon(),
            this.renderPlaceholder(),
            showResultsList && _react2.default.createElement(
                'ul',
                {
                    id: resultsId,
                    ref: function ref(el) {
                        _this5.resultsListElement = el;
                    },
                    className: 'autocomplete__results',
                    onMouseDown: this.preventBlur,
                    onClick: this.preventBlur,
                    'aria-label': resultsLabel,
                    role: 'listbox'
                },
                this.renderResults(resultsList)
            )
        );
    };

    return Autocomplete;
}(_react2.default.PureComponent), _class.propTypes = {
    name: _propTypes2.default.string.isRequired,
    defaultValue: _propTypes2.default.any,
    defaultInputValue: _propTypes2.default.any,
    placeholder: _propTypes2.default.string,
    floatyPlaceholder: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    results: _propTypes2.default.array,
    searchValue: _propTypes2.default.string,
    onSearch: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    onClear: _propTypes2.default.func,
    optionElement: _propTypes2.default.func,
    debounce: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    resultsFilter: _propTypes2.default.func,
    label: _propTypes2.default.node,
    resultsLabel: _propTypes2.default.string,
    overlayResults: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    focused: _propTypes2.default.bool,
    title: _propTypes2.default.string,
    isInvalid: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
}, _class.defaultProps = {
    name: '',
    defaultInputValue: '',
    defaultValue: '',
    defaultLabel: '',
    placeholder: null,
    floatyPlaceholder: false,
    onSearch: _noop3.default,
    onSelect: _noop3.default,
    onClear: _noop3.default,
    className: '',
    results: [],
    searchValue: '',
    optionElement: null,
    debounce: true,
    required: false,
    resultsFilter: null,
    label: null,
    resultsLabel: null,
    overlayResults: false,
    disabled: false,
    focused: false,
    title: null,
    isInvalid: false,
    errorMessage: null
}, _temp);
exports.default = Autocomplete;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(102),
    baseUniq = __webpack_require__(537);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _escapeRegExp2 = __webpack_require__(2046);

var _escapeRegExp3 = _interopRequireDefault(_escapeRegExp2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HighlightedText(_ref) {
    var text = _ref.text,
        textToHighlight = _ref.textToHighlight,
        className = _ref.className,
        highlightClass = _ref.highlightClass;

    if (!textToHighlight) {
        return _react2.default.createElement(
            'span',
            null,
            text
        );
    }

    var regex = new RegExp((0, _escapeRegExp3.default)(textToHighlight), 'i');
    var match = text.match(regex);

    if (!match) {
        return _react2.default.createElement(
            'span',
            null,
            text
        );
    }

    var index = match.index;
    var matchedText = match[0];

    return _react2.default.createElement(
        'span',
        { className: className },
        text.substring(0, index),
        _react2.default.createElement(
            'span',
            { className: highlightClass },
            matchedText
        ),
        text.substring(index + matchedText.length)
    );
}

HighlightedText.propTypes = {
    text: _propTypes2.default.string,
    textToHighlight: _propTypes2.default.string,
    highlightClass: _propTypes2.default.string,
    className: _propTypes2.default.string
};

HighlightedText.defaultProps = {
    text: '',
    textToHighlight: null,
    highlightClass: null,
    className: null
};

exports.default = HighlightedText;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _AlertButton = __webpack_require__(449);

var _AlertButton2 = _interopRequireDefault(_AlertButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessModal = function SuccessModal(_ref) {
    var isOneOffAlert = _ref.isOneOffAlert,
        onClose = _ref.onClose,
        _ref$onCreateReturnAl = _ref.onCreateReturnAlert,
        onCreateReturnAlert = _ref$onCreateReturnAl === undefined ? false : _ref$onCreateReturnAl,
        showCreateReturnAlertOption = _ref.showCreateReturnAlertOption,
        modalProps = (0, _objectWithoutProperties3.default)(_ref, ['isOneOffAlert', 'onClose', 'onCreateReturnAlert', 'showCreateReturnAlertOption']);

    var baseClass = 'disruption-alerts-success-modal';

    var modalFooter = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12, className: baseClass + '__footer-actions' },
                _react2.default.createElement(
                    _reactBootstrap.Button,
                    {
                        bsStyle: 'default',
                        onClick: onClose,
                        className: 'close action-btn action-btn--auto action-btn--secondary'
                    },
                    (0, _I18n2.default)('button.text.close')
                ),
                showCreateReturnAlertOption && _react2.default.createElement(_AlertButton2.default, {
                    onClick: onCreateReturnAlert,
                    text: (0, _I18n2.default)('disruptionAlerts.modals.success.createReturnAlert')
                })
            )
        )
    );

    return _react2.default.createElement(
        _BaseModal2.default,
        (0, _extends3.default)({}, modalProps, {
            className: baseClass + ' modal--xs text-center',
            header: false,
            footer: modalFooter,
            disableBorderFooter: true,
            hideContinue: true
        }),
        _react2.default.createElement(_Icon2.default, { className: baseClass + '__tick', icon: 'selected' }),
        _react2.default.createElement(
            'h1',
            { className: baseClass + '__heading text-lg text-weight--semi-bold' },
            (0, _I18n2.default)('disruptionAlerts.modals.success.heading')
        ),
        _react2.default.createElement(
            'p',
            { className: 'margin-bottom--0 padding--horiz-sm' },
            (0, _I18n2.default)('disruptionAlerts.modals.success.message.' + (isOneOffAlert ? 'oneOff' : 'ongoing'))
        )
    );
};

SuccessModal.propTypes = {
    isOneOffAlert: _propTypes2.default.bool.isRequired,
    modalProps: _propTypes2.default.object,
    onClose: _propTypes2.default.func.isRequired,
    onCreateReturnAlert: _propTypes2.default.func.isRequired,
    showCreateReturnAlertOption: _propTypes2.default.bool
};

exports.default = SuccessModal;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _react = __webpack_require__(0);

var _SmartCarnetActions = __webpack_require__(1039);

var _SmartCarnetActions2 = _interopRequireDefault(_SmartCarnetActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useSmartCarnetTicketDetails = function useSmartCarnetTicketDetails(ticketID, hasSmartCarnetTrip) {
    var _useState = (0, _react.useState)({}),
        smartCarnetTicketDetails = _useState[0],
        setSmartCarnetTicketDetails = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        isLoadingSmartCarnetTicketDetails = _useState2[0],
        setIsLoadingSmartCarnetTicketDetails = _useState2[1];

    (0, _react.useEffect)(function () {
        if (ticketID && hasSmartCarnetTrip) {
            (0, _defer3.default)((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var result;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                setIsLoadingSmartCarnetTicketDetails(true);
                                _context.prev = 1;
                                _context.next = 4;
                                return _SmartCarnetActions2.default.getSmartCarnetTicketDetails(ticketID);

                            case 4:
                                result = _context.sent;

                                setSmartCarnetTicketDetails(result);
                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](1);

                                setSmartCarnetTicketDetails({});

                            case 11:
                                _context.prev = 11;

                                setIsLoadingSmartCarnetTicketDetails(false);
                                return _context.finish(11);

                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, undefined, [[1, 8, 11, 14]]);
            })));
        }
    }, [ticketID, hasSmartCarnetTrip]);

    return {
        smartCarnetTicketDetails: smartCarnetTicketDetails,
        isLoadingSmartCarnetTicketDetails: isLoadingSmartCarnetTicketDetails
    };
};

exports.default = useSmartCarnetTicketDetails;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    ticketId: null,
    cancellationDate: null,
    description: null,
    destinationCode: null,
    destinationName: null,
    externalIdentifierType: null,
    fare: null,
    fulfilmentType: null,
    initialPassCount: null,
    isExpired: null,
    nlc: null,
    orderId: null,
    originCode: null,
    originName: null,
    otrlTicketId: null,
    receivedDate: null,
    refundAmount: null,
    remainingPassCount: null,
    routeCode: null,
    routeName: null,
    saleType: null,
    ticketCategory: null,
    transitMode: null,
    validityEndDate: null,
    validityStartDate: null
};

var TicketSmartCarnet = function (_record) {
    (0, _inherits3.default)(TicketSmartCarnet, _record);

    function TicketSmartCarnet() {
        (0, _classCallCheck3.default)(this, TicketSmartCarnet);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TicketSmartCarnet.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new TicketSmartCarnet({
            ticketId: (0, _LinkMapper.resolve)(json.ticketId).with(Number),
            cancellationDate: (0, _LinkMapper.resolve)(json.cancellationDate).with(_TrainTime2.default),
            description: (0, _LinkMapper.resolve)(json.description).with(String),
            destinationCode: (0, _LinkMapper.resolve)(json.destinationCode).with(Number),
            destinationName: (0, _LinkMapper.resolve)(json.destinationName).with(String),
            externalIdentifierType: (0, _LinkMapper.resolve)(json.externalIdentifierType).with(String),
            fare: (0, _LinkMapper.resolve)(json.fare).with(Number),
            fulfilmentType: (0, _LinkMapper.resolve)(json.fulfilmentType).with(String),
            initialPassCount: (0, _LinkMapper.resolve)(json.initialPassCount).with(Number),
            isExpired: (0, _LinkMapper.resolve)(json.isExpired).with(Boolean),
            nlc: (0, _LinkMapper.resolve)(json.nlc).with(Number),
            orderId: (0, _LinkMapper.resolve)(json.orderId).with(String),
            originCode: (0, _LinkMapper.resolve)(json.originCode).with(Number),
            originName: (0, _LinkMapper.resolve)(json.originName).with(String),
            otrlTicketId: (0, _LinkMapper.resolve)(json.otrlTicketId).with(Number),
            receivedDate: (0, _LinkMapper.resolve)(json.receivedDate).with(_TrainTime2.default),
            refundAmount: (0, _LinkMapper.resolve)(json.refundAmount).with(Number),
            remainingPassCount: (0, _LinkMapper.resolve)(json.remainingPassCount).with(Number),
            routeCode: (0, _LinkMapper.resolve)(json.routeCode).with(Number),
            routeName: (0, _LinkMapper.resolve)(json.routeName).with(String),
            saleType: (0, _LinkMapper.resolve)(json.saleType).with(String),
            ticketCategory: (0, _LinkMapper.resolve)(json.ticketCategory).with(String),
            transitMode: (0, _LinkMapper.resolve)(json.transitMode).with(String),
            validityEndDate: (0, _LinkMapper.resolve)(json.validityEndDate).with(_TrainTime2.default),
            validityStartDate: (0, _LinkMapper.resolve)(json.validityStartDate).with(_TrainTime2.default)
        });
    };

    return TicketSmartCarnet;
}((0, _immutable.Record)(defaults));

exports.default = TicketSmartCarnet;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _startCase2 = __webpack_require__(1088);

var _startCase3 = _interopRequireDefault(_startCase2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _StoredRefundCalculations = __webpack_require__(655);

var _StoredRefundCalculations2 = _interopRequireDefault(_StoredRefundCalculations);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _HelpIcon = __webpack_require__(335);

var _HelpIcon2 = _interopRequireDefault(_HelpIcon);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Totals = function Totals(_ref) {
    var order = _ref.order,
        refund = _ref.refund,
        adminFee = _ref.adminFee,
        storedRefundCalculations = _ref.storedRefundCalculations;
    var delivery = order.delivery,
        charity = order.charity;


    var deliveryMessage = delivery && delivery.fulfilmentMethod ? 'delivery.' + delivery.internalName : null;

    return _react2.default.createElement(
        'div',
        { className: 'order-summary__total margin-top--sm margin-bottom--sm' },
        deliveryMessage && _react2.default.createElement(
            _Row2.default,
            { key: 'fulfilment', className: 'text-weight--normal margin-bottom--xs' },
            _react2.default.createElement(
                _Col2.default,
                { xs: 8 },
                (0, _I18n.hasMessage)(deliveryMessage) ? _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: deliveryMessage,
                    trademark: _react2.default.createElement(
                        'b',
                        null,
                        '\u2122'
                    )
                }) : delivery.fulfilmentMethod === _AppConstants.FulfilmentType.S_TICKET ? delivery.displayName : (0, _startCase3.default)(delivery.displayName),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    '. '
                )
            ),
            _react2.default.createElement(
                _Col2.default,
                { xs: 4, className: 'text-right price' },
                _react2.default.createElement(_Price2.default, { price: delivery.price, showFree: true }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    '. '
                )
            )
        ),
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableDiscountCode' },
            order.getDiscountCodeValue() && _react2.default.createElement(
                _Row2.default,
                { key: 'discountCode', className: 'text-weight--normal margin-bottom--xs' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    (0, _I18n2.default)('order.summary.discount_code'),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    '- ',
                    _react2.default.createElement(_Price2.default, { price: order.getDiscountCodeValue() }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                )
            )
        ),
        order.getDiscountCode() && _react2.default.createElement(
            _Row2.default,
            { key: 'discount', className: 'text-weight--normal margin-bottom--xs' },
            _react2.default.createElement(
                _Col2.default,
                { xs: 8 },
                (0, _I18n2.default)('order.summary.discount'),
                ' (',
                order.getDiscountCode(),
                ')',
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    '. '
                )
            ),
            _react2.default.createElement(
                _Col2.default,
                { xs: 4, className: 'text-right price' },
                order.getTotalDiscount() ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    '- ',
                    _react2.default.createElement(_Price2.default, { price: order.getTotalDiscount() }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                ) : _react2.default.createElement(_HelpIcon2.default, {
                    icon: 'info',
                    heading: order.getIn(['discount', 'name']),
                    message: order.getIn(['discount', 'description'])
                })
            )
        ),
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableBookingFee' },
            _react2.default.createElement(
                _Row2.default,
                { key: 'bookingFee', className: 'text-weight--normal margin-bottom--xs' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    (0, _I18n2.default)('order.summary.booking_fee'),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: order.getBookingFeePrice(), showFree: true }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                )
            )
        ),
        order.hasRefunds() && refund && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                _Row2.default,
                { key: 'originalPrice', className: 'text-weight--normal margin-bottom--xs' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    (0, _I18n2.default)('order.summary.total_paid'),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: order.getOriginalTotalPrice() }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                )
            ),
            (0, _get3.default)(storedRefundCalculations, 'tickets') && (0, _get3.default)(storedRefundCalculations, 'tickets').size > 0 && _react2.default.createElement(
                _Row2.default,
                { className: 'text-weight--norma margin-bottom--xsl' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    (0, _I18n2.default)('account.orders.refund.ticketsValue'),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, {
                        price: storedRefundCalculations.tickets.reduce(function (a, e) {
                            return a + e.calculation.refundAmount;
                        }, 0)
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                )
            ),
            (0, _get3.default)(storedRefundCalculations, 'tickets') && (0, _get3.default)(storedRefundCalculations, 'tickets').size > 0 && _react2.default.createElement(
                _Row2.default,
                { className: 'text-weight--normal margin-bottom--xs' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    'Total used',
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, {
                        price: storedRefundCalculations.tickets.reduce(function (a, e) {
                            return a + e.calculation.totalUsed;
                        }, 0)
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                )
            ),
            _react2.default.createElement(
                _Row2.default,
                { key: 'refund', className: 'text-weight--normal margin-bottom--xs' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    (0, _I18n2.default)('order.summary.adminFee')
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: adminFee })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    (0, _I18n2.default)('order.summary.total_refund'),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: refund.getRefundAmount() }),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        '. '
                    )
                )
            )
        ),
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableCharityRoundUp' },
            charity && charity.donationAmount && _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    _Row2.default,
                    { key: 'charity', className: 'text-weight--normal margin-bottom--xs' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        (0, _I18n2.default)('order.summary.charity_donation'),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            '. '
                        )
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right price' },
                        _react2.default.createElement(_Price2.default, { price: charity.donationAmount }),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            '. '
                        )
                    )
                ),
                _react2.default.createElement(
                    _Row2.default,
                    { key: 'tickets', className: 'text-weight--normal margin-bottom--xs' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        order.get('trips').size > 1 ? (0, _I18n2.default)('booking.tickets') : (0, _I18n2.default)('booking.ticket'),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            '. '
                        )
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right price' },
                        _react2.default.createElement(_Price2.default, { price: order.getTripsPrice() }),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            '. '
                        )
                    )
                )
            )
        ),
        !order.hasRefunds() && _react2.default.createElement(
            _Row2.default,
            { key: 'total', className: 'text-md text-weight--normal text-primary' },
            _react2.default.createElement(
                _Col2.default,
                { xs: 8 },
                (0, _I18n2.default)('order.summary.total_all'),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    '. '
                )
            ),
            _react2.default.createElement(
                _Col2.default,
                { xs: 4, className: 'text-right price' },
                _react2.default.createElement(_Price2.default, { price: order.getTotalPrice() }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    '. '
                )
            )
        )
    );
};

Totals.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    refund: _propTypes2.default.instanceOf(_Order2.default),
    storedRefundCalculations: _propTypes2.default.instanceOf(_StoredRefundCalculations2.default),
    adminFee: _propTypes2.default.number
};

Totals.defaultProps = {
    adminFee: 0
};

exports.default = Totals;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _I18n = __webpack_require__(9);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _DeliveryInformationCollection = __webpack_require__(2089);

var _DeliveryInformationCollection2 = _interopRequireDefault(_DeliveryInformationCollection);

var _DeliveryInformationPostal = __webpack_require__(1170);

var _DeliveryInformationPostal2 = _interopRequireDefault(_DeliveryInformationPostal);

var _DeliveryInformationPrintAtHome = __webpack_require__(1171);

var _DeliveryInformationPrintAtHome2 = _interopRequireDefault(_DeliveryInformationPrintAtHome);

var _DeliveryInformationETicket = __webpack_require__(1172);

var _DeliveryInformationETicket2 = _interopRequireDefault(_DeliveryInformationETicket);

var _SmartOrderSummary = __webpack_require__(1173);

var _SmartOrderSummary2 = _interopRequireDefault(_SmartOrderSummary);

var _DeliveryInformationSTicket = __webpack_require__(2090);

var _DeliveryInformationSTicket2 = _interopRequireDefault(_DeliveryInformationSTicket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryInformation = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(DeliveryInformation, _PureRenderComponent);

    function DeliveryInformation() {
        (0, _classCallCheck3.default)(this, DeliveryInformation);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    DeliveryInformation.prototype.render = function render() {
        var order = this.props.order;
        var delivery = order.delivery;
        var isInterop = order.isInterop;


        if (!order.isPaid()) {
            return null;
        }

        var hasFlexiFares = order.getFares().some(function (x) {
            return x.isFlexi();
        });

        if (delivery.isCollection()) {
            return _react2.default.createElement(_DeliveryInformationCollection2.default, this.props);
        } else if (delivery.isPostalDelivery()) {
            return _react2.default.createElement(_DeliveryInformationPostal2.default, this.props);
        } else if (delivery.isSmartcard() && !order.hasCollectionWindowEnded() && !order.isFullRefund) {
            var message = '';
            if (order.isSmartcardWithProductDelivery()) {
                message = (0, _I18n.translate)('order.details.smartcardWithProductDelivery');
            } else if (delivery.hasCollectionLocation()) {
                message = _react2.default.createElement(_SmartOrderSummary2.default, {
                    location: delivery.collectionLocation.name,
                    brand: (0, _I18n.translate)('app.owner.short'),
                    isInterop: isInterop,
                    hasFlexiFares: hasFlexiFares
                });
            }
            return _react2.default.createElement(
                'p',
                null,
                message
            );
        } else if (delivery.isSTicket()) {
            return _react2.default.createElement(_DeliveryInformationSTicket2.default, { brand: (0, _I18n.translate)('app.owner.short') });
        } else if (delivery.isPrintAtHome()) {
            return _react2.default.createElement(_DeliveryInformationPrintAtHome2.default, this.props);
        } else if (delivery.isETicket()) {
            return _react2.default.createElement(_DeliveryInformationETicket2.default, { email: order.get('email'),
                isGuest: order.isGuestOrder(),
                isPaypal: order.hasPaypalPayment(),
                isAmazonPay: order.hasAmazonPayPayment() });
        }

        return null;
    };

    return DeliveryInformation;
}(_PureRenderComponent3.default), _class.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    isLoggedIn: _propTypes2.default.bool
}, _class.defaultProps = {
    isLoggedIn: false
}, _temp);
exports.default = DeliveryInformation;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _capitalize2 = __webpack_require__(623);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _I18n = __webpack_require__(9);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _Address = __webpack_require__(618);

var _Address2 = _interopRequireDefault(_Address);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryInformationPostal = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(DeliveryInformationPostal, _PureRenderComponent);

    function DeliveryInformationPostal() {
        (0, _classCallCheck3.default)(this, DeliveryInformationPostal);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    DeliveryInformationPostal.prototype.render = function render() {
        var order = this.props.order;
        var delivery = order.delivery;


        return _react2.default.createElement(
            'div',
            null,
            order.isETicketByPostDelivery() && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: 'order.details.postalDelivery.description',
                    here: _react2.default.createElement(_ExternalLink2.default, {
                        message: (0, _capitalize3.default)((0, _I18n.translate)('global.clickHere')),
                        href: _config2.default.get('eTicketsUrl')
                    })
                })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: 'order.details.postalDelivery',
                    deliveryMethod: _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: delivery.displayName,
                        trademark: _react2.default.createElement(
                            'b',
                            null,
                            '\u2122'
                        )
                    }) })
            ),
            _react2.default.createElement(_Address2.default, { address: delivery.getAddress(), className: 'margin-bottom--sm text-weight--normal' })
        );
    };

    return DeliveryInformationPostal;
}(_PureRenderComponent3.default), _class.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired
}, _temp);
exports.default = DeliveryInformationPostal;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DeliveryInformationPrintAtHome(_ref) {
    var order = _ref.order,
        isLoggedIn = _ref.isLoggedIn;

    var isPaid = (0, _result3.default)(order, 'isPaid');
    var tickets = (0, _result3.default)(order, 'getTickets.size', 0);
    var downloadableTickets = (0, _result3.default)(order, 'hasDownloadableTickets');
    return _react2.default.createElement(
        'div',
        null,
        isPaid && !downloadableTickets && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: 'text-primary' },
                _react2.default.createElement(
                    'strong',
                    null,
                    (0, _I18n.translate)('confirmation.delivery.printAtHome.emailDetails', { tickets: tickets })
                )
            ),
            isLoggedIn && _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableTicketDownload' },
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n.translate)('confirmation.delivery.printAtHome.downloadShortly', { tickets: tickets })
                )
            )
        ),
        isPaid && downloadableTickets && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: 'text-primary' },
                _react2.default.createElement(
                    'strong',
                    null,
                    (0, _I18n.translate)('confirmation.delivery.printAtHome.emailed', { tickets: tickets, email: order.email })
                )
            ),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableTicketDownload' },
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n.translate)('confirmation.delivery.printAtHome.download', { tickets: tickets })
                )
            )
        ),
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('confirmation.delivery.printAtHome.printInstructions')
        )
    );
}

DeliveryInformationPrintAtHome.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    isLoggedIn: _propTypes2.default.bool
};

exports.default = DeliveryInformationPrintAtHome;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = DeliveryInformationETicket;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DeliveryInformationETicket(_ref) {
    var email = _ref.email,
        _ref$isGuest = _ref.isGuest,
        isGuest = _ref$isGuest === undefined ? false : _ref$isGuest,
        _ref$isPaypal = _ref.isPaypal,
        isPaypal = _ref$isPaypal === undefined ? false : _ref$isPaypal,
        _ref$isAmazonPay = _ref.isAmazonPay,
        isAmazonPay = _ref$isAmazonPay === undefined ? false : _ref$isAmazonPay;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'order.details.eTicketDelivery',
                email: email,
                isGuest: isGuest,
                isPaypal: isPaypal,
                isAmazonPay: isAmazonPay })
        )
    );
}

DeliveryInformationETicket.propTypes = {
    email: _propTypes2.default.string.isRequired,
    isGuest: _propTypes2.default.bool,
    isPaypal: _propTypes2.default.bool,
    isAmazonPay: _propTypes2.default.bool
};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _I18n = __webpack_require__(9);

var _SmartcardLoadingDetails = __webpack_require__(1112);

var _SmartcardLoadingDetails2 = _interopRequireDefault(_SmartcardLoadingDetails);

var _SmartcardAppIcons = __webpack_require__(649);

var _SmartcardAppIcons2 = _interopRequireDefault(_SmartcardAppIcons);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmartOrderSummary(_ref) {
    var location = _ref.location,
        brand = _ref.brand,
        isInterop = _ref.isInterop,
        hasFlexiFares = _ref.hasFlexiFares;

    var _useState = (0, _react.useState)(false),
        showAppModal = _useState[0],
        setShowAppModal = _useState[1];

    var toggleAppModal = function toggleAppModal() {
        return setShowAppModal(!showAppModal);
    };

    var renderModal = function renderModal() {
        return _react2.default.createElement(
            _BaseModal2.default,
            {
                titleText: (0, _I18n.translate)('booking.delivery.smartcard.modal.title'),
                className: 'modal--lg load-smartcard-modal',
                onClose: toggleAppModal,
                hideContinue: true
            },
            _react2.default.createElement(_SmartcardLoadingDetails2.default, null)
        );
    };

    if (brand === 'Southeastern') {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'order-summary__load-smartcard-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n.translate)('confirmation.loadTickets.app'),
                    ' ',
                    _react2.default.createElement(_SmartcardAppIcons2.default, { toggleAppModal: toggleAppModal })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n.translate)('confirmation.loadTickets.station', {
                        location: location
                    })
                )
            ),
            showAppModal && renderModal()
        );
    }

    // GTR only below

    if (!hasFlexiFares) {
        return _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('confirmation.smartcardNormal', { location: location, brand: brand })
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'order-summary__load-smartcard-info' },
        isInterop && _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('booking.delivery.loadingdate.downloadGTRPaymentConfirmation', { brand: (0, _I18n.translate)('app.owner.appName') })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    _react.Fragment,
                    null,
                    (0, _I18n.translate)('booking.delivery.loadingdate.downloadGTR', { brand: (0, _I18n.translate)('app.owner.appName') }),
                    _react2.default.createElement(
                        'div',
                        { className: 'smartcard-app-and-help-icons' },
                        _react2.default.createElement(_SmartcardAppIcons2.default, { toggleAppModal: toggleAppModal }),
                        _react2.default.createElement(
                            'button',
                            { onClick: toggleAppModal },
                            _react2.default.createElement('i', { className: 'otrl otrl-info' })
                        )
                    )
                )
            )
        ),
        isInterop && _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('booking.delivery.loading.info.interop')
        ),
        !isInterop && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('booking.delivery.loadingdate.orderInfoGTRPartOne', { location: location }),
                _react2.default.createElement('img', { className: 'tap-smartcard-icon', src: '/images/registration/register-smartcard.png', alt: (0, _I18n.translate)('account.register.smartcard.alt') }),
                (0, _I18n.translate)('booking.delivery.loadingdate.orderInfoGTRPartTwo')
            )
        ),
        _react2.default.createElement(
            'div',
            null,
            !isInterop && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    (0, _I18n.translate)('booking.delivery.loading.important.gtr1')
                ),
                (0, _I18n.translate)('booking.delivery.loading.important.gtr2')
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    (0, _I18n.translate)('booking.delivery.loading.info.gtr')
                )
            )
        ),
        _react2.default.createElement(
            'div',
            null,
            showAppModal && renderModal()
        )
    );
}

SmartOrderSummary.propTypes = {
    location: _propTypes2.default.string.isRequired,
    brand: _propTypes2.default.string.isRequired,
    isInterop: _propTypes2.default.bool,
    hasFlexiFares: _propTypes2.default.bool
};

exports.default = SmartOrderSummary;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = STicketLoadingDetails;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function STicketLoadingDetails() {
    return _react2.default.createElement(
        'div',
        { className: 'vertical-align-parent load-smartcard-modal__body' },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: 'text-weight--bold margin-bottom--sm' },
                (0, _I18n.translate)('booking.delivery.sticket.modal.body', {
                    brand: (0, _I18n.translate)('app.owner.short')
                })
            ),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('booking.delivery.smartcard.modal.cta')
            ),
            _react2.default.createElement(
                'div',
                { className: 'load-smartcard-modal__app-badges' },
                _react2.default.createElement(
                    'a',
                    { href: _config2.default.get('appStoreAppUrl'), target: '_blank' },
                    _react2.default.createElement('img', {
                        src: '/images/mobile-apps/app-store.png',
                        alt: (0, _I18n.translate)('ontrackapp.widget.appstoreButtonAltText')
                    })
                ),
                _react2.default.createElement(
                    'a',
                    { href: _config2.default.get('googlePlayAppUrl'), target: '_blank' },
                    _react2.default.createElement('img', {
                        src: '/images/mobile-apps/google-play.png',
                        alt: (0, _I18n.translate)('ontrackapp.widget.googlePlayButtonAltText')
                    })
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'load-smartcard-modal__illustration load-smartcard-modal__illustration--sticket' },
            _react2.default.createElement('img', {
                src: _config2.default.get('loadSTicketIllustration'),
                alt: (0, _I18n.translate)('booking.delivery.loadSmartcardIllustration')
            })
        )
    );
}

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _RewardPointsInstruction = __webpack_require__(1176);

var _RewardPointsInstruction2 = _interopRequireDefault(_RewardPointsInstruction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RewardPointsInformation(_ref) {
    var paidOrder = _ref.paidOrder,
        className = _ref.className;
    var totalRewardPoints = paidOrder.totalRewardPoints,
        rewardPointUid = paidOrder.rewardPointUid;


    if (!totalRewardPoints || !rewardPointUid) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('reward-points__order-history', className) },
        _react2.default.createElement(
            'div',
            { className: 'reward-points__container__content' },
            _react2.default.createElement(
                'p',
                { className: 'reward-points__order-history__highlight' },
                (0, _I18n2.default)('rewardPoints.information.pointsAmount', { totalRewardPoints: totalRewardPoints })
            ),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n2.default)('rewardPoints.information.acknowledgment')
            )
        ),
        _react2.default.createElement(_RewardPointsInstruction2.default, {
            rewardPointUid: rewardPointUid,
            listClassName: 'reward-points__order-history__list'
        })
    );
}

RewardPointsInformation.propTypes = {
    paidOrder: _propTypes2.default.object.isRequired,
    className: _propTypes2.default.object
};

exports.default = RewardPointsInformation;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RewardPointsInstruction(_ref) {
    var rewardPointUid = _ref.rewardPointUid,
        listClassName = _ref.listClassName;

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n2.default)('rewardPoints.instruction.list.heading'),
            _react2.default.createElement(
                'ol',
                { className: listClassName },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'rewardPoints.instruction.list.firstStep',
                        rewardPointsUrl: _react2.default.createElement(
                            'a',
                            {
                                target: '_blank',
                                className: 'btn btn-plain reward-points__link',
                                href: _config2.default.get('rewardPointsUrl')
                            },
                            (0, _I18n2.default)('rewardPoints.instruction.list.firstStep.url')
                        )
                    })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    (0, _I18n2.default)('rewardPoints.instruction.list.secondStep')
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'rewardPoints.instruction.list.thirdStep',
                        rewardPointUid: _react2.default.createElement(
                            'span',
                            { className: 'reward-code' },
                            rewardPointUid
                        )
                    })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    (0, _I18n2.default)('rewardPoints.instruction.list.fourthStep')
                )
            )
        ),
        _react2.default.createElement(
            'p',
            { className: 'reward-points__reminder' },
            (0, _I18n2.default)('rewardPoints.instruction.reminder')
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'rewardPoints.instruction.tsAndCs',
                rewardPointsTermsUrl: _react2.default.createElement(
                    'a',
                    {
                        target: '_blank',
                        className: 'btn btn-plain reward-points__link',
                        href: _config2.default.get('rewardPointsTermsUrl')
                    },
                    (0, _I18n2.default)('rewardPoints.instruction.tsAndCs.url')
                )
            })
        )
    );
}

RewardPointsInstruction.propTypes = {
    rewardPointUid: _propTypes2.default.string.isRequired,
    listClassName: _propTypes2.default.string
};

exports.default = RewardPointsInstruction;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NREHeader() {
    return _react2.default.createElement(
        'div',
        { className: 'transfer-images margin-bottom margin-top' },
        _react2.default.createElement('img', { src: _Assets2.default.assetUrl("images/national-rail-logo.png"), alt: (0, _I18n.translate)('nre.logoAltText') }),
        _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-180 text-secondary' }),
        _react2.default.createElement('img', { src: '/images/logos/' + _config2.default.get('brand') + '-logo.png', alt: 'brand logo' })
    );
}

exports.default = NREHeader;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _TabContainer = _interopRequireDefault(__webpack_require__(590));

var _TabContent = _interopRequireDefault(__webpack_require__(591));

var _TabPane = _interopRequireDefault(__webpack_require__(956));

var propTypes = (0, _extends2.default)({}, _TabPane.default.propTypes, {
  disabled: _propTypes.default.bool,
  title: _propTypes.default.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: _propTypes.default.string
});

var Tab =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var props = (0, _extends2.default)({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.

    delete props.title;
    delete props.disabled;
    delete props.tabClassName;
    return _react.default.createElement(_TabPane.default, props);
  };

  return Tab;
}(_react.default.Component);

Tab.propTypes = propTypes;
Tab.Container = _TabContainer.default;
Tab.Content = _TabContent.default;
Tab.Pane = _TabPane.default;
var _default = Tab;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(197));

var _uncontrollable = _interopRequireDefault(__webpack_require__(106));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _Nav = _interopRequireDefault(__webpack_require__(683));

var _NavItem = _interopRequireDefault(__webpack_require__(684));

var _TabContainer = _interopRequireDefault(__webpack_require__(590));

var _TabContent = _interopRequireDefault(__webpack_require__(591));

var _bootstrapUtils = __webpack_require__(21);

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var TabContainer = _TabContainer.default.ControlledComponent;
var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: _propTypes.default.any,

  /**
   * Navigation style
   */
  bsStyle: _propTypes.default.oneOf(['tabs', 'pills']),

  /**
   * Sets a default animation strategy. Use `false` to disable, `true`
   * to enable the default `<Fade>` animation, or a react-transition-group
   * v2 `<Transition/>` component.
   */
  animation: _propTypes.default.oneOfType([_propTypes.default.bool, _elementType.default]),
  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: _propTypes.default.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: _propTypes.default.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: _propTypes.default.bool
};
var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;

  _ValidComponentChildren.default.forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Tabs, _React$Component);

  function Tabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tabs.prototype;

  _proto.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return _react.default.createElement(_NavItem.default, {
      eventKey: eventKey,
      disabled: disabled,
      className: tabClassName
    }, title);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        onSelect = _this$props.onSelect,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        _this$props$activeKey = _this$props.activeKey,
        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);
    return _react.default.createElement(TabContainer, {
      id: id,
      activeKey: activeKey,
      onSelect: onSelect,
      className: className,
      style: style
    }, _react.default.createElement("div", null, _react.default.createElement(_Nav.default, (0, _extends2.default)({}, props, {
      role: "tablist"
    }), _ValidComponentChildren.default.map(children, this.renderTab)), _react.default.createElement(_TabContent.default, {
      bsClass: bsClass,
      animation: animation,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, children)));
  };

  return Tabs;
}(_react.default.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
(0, _bootstrapUtils.bsClass)('tab', Tabs);

var _default = (0, _uncontrollable.default)(Tabs, {
  activeKey: 'onSelect'
});

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _invariant = _interopRequireDefault(__webpack_require__(72));

var _uncontrollable = _interopRequireDefault(__webpack_require__(106));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var _ButtonGroup = _interopRequireDefault(__webpack_require__(589));

var _ToggleButton = _interopRequireDefault(__webpack_require__(685));

var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: _propTypes.default.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: _propTypes.default.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: _propTypes.default.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: _propTypes.default.oneOf(['checkbox', 'radio']).isRequired
};
var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getValues = function getValues() {
    var value = this.props.value;
    return value == null ? [] : [].concat(value);
  };

  _proto.handleToggle = function handleToggle(value) {
    var _this$props = this.props,
        type = _this$props.type,
        onChange = _this$props.onChange;
    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }

      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange(values.concat([value]));
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        type = _this$props2.type,
        name = _this$props2.name,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["children", "type", "name"]);
    var values = this.getValues();
    !(type !== 'radio' || !!name) ?  false ? (0, _invariant.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : invariant(false) : void 0;
    delete props.onChange;
    delete props.value; // the data attribute is required b/c twbs css uses it in the selector

    return _react.default.createElement(_ButtonGroup.default, (0, _extends2.default)({}, props, {
      "data-toggle": "buttons"
    }), _ValidComponentChildren.default.map(children, function (child) {
      var _child$props = child.props,
          value = _child$props.value,
          onChange = _child$props.onChange;

      var handler = function handler() {
        return _this.handleToggle(value);
      };

      return _react.default.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(value) !== -1,
        onChange: (0, _createChainedFunction.default)(onChange, handler)
      });
    }));
  };

  return ToggleButtonGroup;
}(_react.default.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;
var UncontrolledToggleButtonGroup = (0, _uncontrollable.default)(ToggleButtonGroup, {
  value: 'onChange'
});
UncontrolledToggleButtonGroup.Button = _ToggleButton.default;
var _default = UncontrolledToggleButtonGroup;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var Well =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Well, _React$Component);

  function Well() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Well.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Well;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extractErrorMessage = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _from = __webpack_require__(285);

var _from2 = _interopRequireDefault(_from);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Radio = __webpack_require__(231);

var _Radio2 = _interopRequireDefault(_Radio);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _AppConstants = __webpack_require__(6);

var _SeatingPreferences = __webpack_require__(671);

var _SeatingPreferences2 = _interopRequireDefault(_SeatingPreferences);

var _RadioGroups = __webpack_require__(2156);

var _RadioGroups2 = _interopRequireDefault(_RadioGroups);

var _FeatureCheckboxes = __webpack_require__(2157);

var _FeatureCheckboxes2 = _interopRequireDefault(_FeatureCheckboxes);

var _useStoreState = __webpack_require__(145);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

var _reservationUtils = __webpack_require__(686);

var _ReservationRequestActions = __webpack_require__(1114);

var _ReservationRequestActions2 = _interopRequireDefault(_ReservationRequestActions);

var _ReservationActions = __webpack_require__(1061);

var _ReservationActions2 = _interopRequireDefault(_ReservationActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _TripActions = __webpack_require__(603);

var _TripActions2 = _interopRequireDefault(_TripActions);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _RadioGroupsData = __webpack_require__(2159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extractErrorMessage = exports.extractErrorMessage = function extractErrorMessage(err) {
    return typeof err === 'string' ? err : err && err.message || 'An unexpected error occurred when trying to create a reservation';
};

var AddReservationModal = function AddReservationModal(props) {
    var _props$show = props.show,
        show = _props$show === undefined ? true : _props$show,
        onClose = props.onClose,
        onContinue = props.onContinue,
        _props$context = props.context,
        context = _props$context === undefined ? _AppConstants.ReservationContexts.TICKET_BOOKING : _props$context,
        currentJourneyData = props.currentJourneyData;

    var trip = (0, _useStoreState.useStoreState)(_CurrentTripStore2.default);
    var isSeatingAvailable = trip.isSeatingAvailable();

    var _useState = (0, _react.useState)(false),
        seatSelected = _useState[0],
        setSeatSelected = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        bikeSelected = _useState2[0],
        setBikeSelected = _useState2[1];

    var _useState3 = (0, _react.useState)(1),
        bikesQty = _useState3[0],
        setBikesQty = _useState3[1];

    var _useState4 = (0, _react.useState)(new _SeatingPreferences2.default({
        outward: !!trip.outwardJourney,
        inward: !!trip.returnjourney
    })),
        seatingPreferences = _useState4[0],
        setSeatingPreferences = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        showSeatPrefError = _useState5[0],
        setShowSeatPrefError = _useState5[1];

    var _useState6 = (0, _react.useState)(true),
        tripHasBikeReservationCapability = _useState6[0],
        setTripHasBikeReservationCapability = _useState6[1];

    var _useState7 = (0, _react.useState)(true),
        tripHasSeatingCapability = _useState7[0],
        setTripHasSeatingCapability = _useState7[1];

    var _useState8 = (0, _react.useState)(false),
        bikeAvailabilityError = _useState8[0],
        setBikeAvailabilityError = _useState8[1];

    var search = trip.search;
    var origin = search.origin,
        destination = search.destination,
        adults = search.adults,
        children = search.children;


    var adultCount = adults || 0;
    var childrenCount = children || 0;
    var totalPassengerCount = adultCount + childrenCount;
    var maxBikeQty = Math.max(1, totalPassengerCount); // Don't allow more bikes than passengers

    /*
        Update the amount of bikes in the reservation request store when the bike selection changes.
         This is used to ensure that the reservation request has the correct number of bikes
        when the user clicks continue in the modal.
    */
    (0, _react.useEffect)(function () {
        (0, _defer3.default)(function () {
            _ReservationRequestActions2.default.setBikes(bikeSelected ? bikesQty : 0);
        });
    }, [bikeSelected, bikesQty]);

    /*
        When the modal is shown, we need to set the passengers in the reservation request store
        with the current seating preferences and the number of adults and children.
        This is used to ensure that the reservation request has the correct passengers
        when the user clicks continue in the modal.
    */
    (0, _react.useEffect)(function () {
        if (show) {
            var attributes = seatingPreferences.toReservationCodes();

            var passengerData = new _immutable.List([].concat((0, _from2.default)({ length: adultCount }).map(function () {
                return {
                    statusCode: '000',
                    attributes: seatSelected ? attributes : []
                };
            }), (0, _from2.default)({ length: childrenCount }).map(function () {
                return {
                    statusCode: '001',
                    attributes: seatSelected ? attributes : []
                };
            })));

            _ReservationRequestActions2.default.setPassengers(passengerData);
        }
    }, [show, adultCount, childrenCount, seatingPreferences, seatSelected]);

    /*
        If the user has selected a bike, we need to ensure that the number of bikes
        does not exceed the total number of passengers. This is to prevent the user
        from selecting more bikes than there are passengers, which would not make sense.
    */
    (0, _react.useEffect)(function () {
        if (bikeSelected && bikesQty > totalPassengerCount) {
            setBikesQty(totalPassengerCount);
        }
    }, [totalPassengerCount, bikeSelected, bikesQty]);

    /*
        When the modal is shown, we need to check if the trip has seating and bike reservation capabilities.
        This is done by checking the trip's outward and return journeys for their respective services and fares.
         If there is no availability for seating or bike reservations, we disable the respective options in the modal.
    */
    (0, _react.useEffect)(function () {
        if (show) {
            // eslint-disable-next-line
            var checkTripAvailability = function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    var dummyPassengerData, outwardService, inwardService, outwardFare, inwardFare, params, _ref2, bundleAvailabilityMap, requiredBundles, outboundSeatAvailable, inboundSeatAvailable, outboundBikeAvailable, inboundBikeAvailable, hasSeatingAvailability, hasBikeAvailability;

                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    dummyPassengerData = new _immutable.List([].concat((0, _from2.default)({ length: adultCount }).map(function () {
                                        return {
                                            statusCode: '000',
                                            attributes: []
                                        };
                                    }), (0, _from2.default)({ length: childrenCount }).map(function () {
                                        return {
                                            statusCode: '001',
                                            attributes: []
                                        };
                                    })));

                                    /*
                                        We get the journeys from the trip for the GridView, or the currentJourneyData for the ListView.
                                         For the ListView, only the outward or inward will be present at one time depending on whether
                                        the user is choosing the outward or return journey.
                                    */

                                    outwardService = trip.getIn(['outwardJourney', 'journey']) || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.OUTWARD ? currentJourneyData.service.journey : null);
                                    inwardService = trip.getIn(['returnJourney', 'journey']) || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.INWARD ? currentJourneyData.service.journey : null);
                                    outwardFare = trip.getOutwardFare() || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.OUTWARD ? currentJourneyData.fare : null);
                                    inwardFare = trip.getReturnFare() || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.INWARD ? currentJourneyData.fare : null);
                                    params = {
                                        bikesCount: 1,
                                        passengers: dummyPassengerData,
                                        requestSeats: true,
                                        outwardService: outwardService,
                                        inwardService: inwardService,
                                        outwardFare: outwardFare,
                                        inwardFare: inwardFare,
                                        context: context,
                                        isBasicAvailabilityCheck: true
                                    };
                                    _context.prev = 6;
                                    _context.next = 9;
                                    return _ReservationActions2.default.checkAvailabilityForReservation(params);

                                case 9:
                                    _ref2 = _context.sent;
                                    bundleAvailabilityMap = _ref2.bundleAvailabilityMap;
                                    requiredBundles = _ref2.requiredBundles;
                                    // opts, isBookingFlow

                                    /*
                                        Always check outbound availability for seats and bikes.
                                        Additionally check inbound only if it's required.
                                    */
                                    outboundSeatAvailable = requiredBundles.includes('SEATS_OUTBOUND') && bundleAvailabilityMap.SEATS_OUTBOUND === _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY;
                                    inboundSeatAvailable = requiredBundles.includes('SEATS_INBOUND') && bundleAvailabilityMap.SEATS_INBOUND === _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY;
                                    outboundBikeAvailable = requiredBundles.includes('BIKES_OUTBOUND') && bundleAvailabilityMap.BIKES_OUTBOUND === _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY;
                                    inboundBikeAvailable = requiredBundles.includes('BIKES_INBOUND') && bundleAvailabilityMap.BIKES_INBOUND === _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY;

                                    /*
                                        Capability is enabled only if outbound is available
                                        AND (inbound is either not required OR also available).
                                    */

                                    hasSeatingAvailability = isSeatingAvailable && outboundSeatAvailable && (!requiredBundles.includes('SEATS_INBOUND') || inboundSeatAvailable);
                                    hasBikeAvailability = outboundBikeAvailable && (!requiredBundles.includes('BIKES_INBOUND') || inboundBikeAvailable);

                                    // if the check for availability fails, just assume full availability and let them try to book

                                    if (!(0, _isEmpty3.default)(bundleAvailabilityMap)) {
                                        _context.next = 20;
                                        break;
                                    }

                                    return _context.abrupt('return', false);

                                case 20:

                                    setTripHasSeatingCapability(hasSeatingAvailability);
                                    setTripHasBikeReservationCapability(hasBikeAvailability);
                                    _context.next = 27;
                                    break;

                                case 24:
                                    _context.prev = 24;
                                    _context.t0 = _context['catch'](6);

                                    console.error('Error checking availability on show:', _context.t0);

                                case 27:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, undefined, [[6, 24]]);
                }));

                return function checkTripAvailability() {
                    return _ref.apply(this, arguments);
                };
            }();

            checkTripAvailability();
        }
    }, [trip, adultCount, childrenCount, show, currentJourneyData, context, isSeatingAvailable]);

    /*
        If the trip does not have seating or bike reservation capabilities, we reset the selection states.
        This ensures that if the availability changes after the modal is opened,
        the user cannot select options that are not available.
    */
    (0, _react.useEffect)(function () {
        if (!tripHasSeatingCapability) {
            setSeatSelected(false);
        }
        if (!tripHasBikeReservationCapability) {
            setBikeSelected(false);
        }
    }, [tripHasSeatingCapability, tripHasBikeReservationCapability]);

    /*
        Handle the continue button click.
        This function checks if the user has selected a seat or bike, validates the seating preferences,
        and then proceeds to create the reservation or continue with the booking flow.
    */
    var handleContinue = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var prefs, preferenceFields, hasAtLeastOneValidPref, attributes, passengerData, _ref4, err, reservation, errorMessage, _errorMessage, outwardService, inwardService, outwardFare, inwardFare, params, _ref5, bundleAvailabilityMap, bikeOutcome, updatedTrip;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            setShowSeatPrefError(false);
                            setBikeAvailabilityError(false);

                            if (!(context !== _AppConstants.ReservationContexts.TICKET_BOOKING && !seatSelected && !bikeSelected)) {
                                _context2.next = 5;
                                break;
                            }

                            console.error('No seat or bike selected');
                            return _context2.abrupt('return');

                        case 5:
                            if (!seatSelected) {
                                _context2.next = 12;
                                break;
                            }

                            prefs = seatingPreferences.toJS();
                            preferenceFields = ['direction', 'position', 'seatType'];
                            hasAtLeastOneValidPref = preferenceFields.some(function (field) {
                                return prefs[field] !== _AppConstants.SeatingPrefs.NONE;
                            });

                            if (hasAtLeastOneValidPref) {
                                _context2.next = 12;
                                break;
                            }

                            setShowSeatPrefError(true);
                            return _context2.abrupt('return');

                        case 12:
                            attributes = seatingPreferences.toReservationCodes();
                            passengerData = new _immutable.List([].concat((0, _from2.default)({ length: adultCount }).map(function () {
                                return {
                                    statusCode: '000',
                                    attributes: seatSelected ? attributes : []
                                };
                            }), (0, _from2.default)({ length: childrenCount }).map(function () {
                                return {
                                    statusCode: '001',
                                    attributes: seatSelected ? attributes : []
                                };
                            })));

                            if (!(context === _AppConstants.ReservationContexts.STANDALONE_BOOKING)) {
                                _context2.next = 33;
                                break;
                            }

                            // For when the context is the reservation widget via the My Account section
                            _ReservationRequestActions2.default.setPassengers(passengerData);
                            _ReservationRequestActions2.default.setRequestSeats(seatSelected);
                            _ReservationRequestActions2.default.setBikes(bikeSelected ? bikesQty : 0);

                            _context2.prev = 18;
                            _context2.next = 21;
                            return _ReservationActions2.default.createReservation();

                        case 21:
                            _ref4 = _context2.sent;
                            err = _ref4.err;
                            reservation = _ref4.reservation;

                            if (reservation) {
                                onContinue();
                            } else {
                                _ReservationActions2.default.clearReservationStore();
                                _ReservationRequestActions2.default.clearReservationRequestStore();
                                errorMessage = extractErrorMessage(err);


                                if (err.code === _AppConstants.ReservationErrorCodes.RESERVATION_LIMIT_REACHED) {
                                    _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { title: "We’re unable to complete your reservation", message: errorMessage });
                                } else {
                                    _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: errorMessage });
                                }

                                onClose();
                            }
                            _context2.next = 31;
                            break;

                        case 27:
                            _context2.prev = 27;
                            _context2.t0 = _context2['catch'](18);
                            _errorMessage = extractErrorMessage(_context2.t0);

                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { message: _errorMessage });

                        case 31:
                            _context2.next = 52;
                            break;

                        case 33:
                            if (!(seatSelected || bikeSelected)) {
                                _context2.next = 51;
                                break;
                            }

                            outwardService = trip.getIn(['outwardJourney', 'journey']) || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.OUTWARD ? currentJourneyData.service.journey : null);
                            inwardService = trip.getIn(['returnJourney', 'journey']) || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.INWARD ? currentJourneyData.service.journey : null);
                            outwardFare = trip.getOutwardFare() || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.OUTWARD ? currentJourneyData.fare : null);
                            inwardFare = trip.getReturnFare() || (currentJourneyData && currentJourneyData.direction === _AppConstants.JourneyDirections.INWARD ? currentJourneyData.fare : null);
                            params = {
                                bikesCount: bikeSelected ? bikesQty : 0,
                                passengers: passengerData,
                                requestSeats: seatSelected,
                                outwardService: outwardService,
                                inwardService: inwardService,
                                outwardFare: outwardFare,
                                inwardFare: inwardFare,
                                context: context,
                                isBasicAvailabilityCheck: false // We want to check full availability when actually trying to make a reservation
                            };
                            _context2.next = 41;
                            return _ReservationActions2.default.checkAvailabilityForReservation(params);

                        case 41:
                            _ref5 = _context2.sent;
                            bundleAvailabilityMap = _ref5.bundleAvailabilityMap;
                            // opts, isBookingFlow

                            bikeOutcome = bundleAvailabilityMap.BIKES_OUTBOUND;

                            if (!(bikeSelected && bikeOutcome !== _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY)) {
                                _context2.next = 47;
                                break;
                            }

                            setBikeAvailabilityError(true);
                            return _context2.abrupt('return');

                        case 47:
                            updatedTrip = trip;


                            if (trip.isSeatingAvailable()) {
                                updatedTrip = updatedTrip.setSeatingPreferences(seatingPreferences);
                            }

                            if (bikeOutcome === _AppConstants.ReservationBundleOutcome.FULL_AVAILABILITY && bikeSelected) {
                                updatedTrip = updatedTrip.set('bikes', bikesQty);
                            }

                            if (updatedTrip !== trip) {
                                _TripActions2.default.updateTrip(updatedTrip);
                            }

                        case 51:

                            /*
                                Continue with the booking flow or the next step in the reservation process.
                                This will either proceed to the next stage in the booking flow or close the modal
                                and trigger the onContinue callback if provided.
                                 If the context is the reservation widget, we just close the modal and trigger onContinue.
                                 If the context is the booking flow, we will proceed to the next step in the flow.
                                 If the context is the ListView, we will also proceed to the next step in the flow.
                                 If the context is the GridView, we will also proceed to the next step in the flow.
                                 In all cases, we will close the modal and trigger the onContinue callback if provided.
                                 We also reset the reservation widget to be toggled off. If the user wants to add a reservation
                                to another trip or order, they will need to open the modal again.
                            */
                            (0, _defer3.default)(function () {
                                onContinue();
                                onClose();

                                if (context === _AppConstants.ReservationContexts.TICKET_BOOKING) {
                                    (0, _defer3.default)(function () {
                                        _ReservationActions2.default.setReservationWidgetToggled(false);
                                    });
                                }
                            });

                        case 52:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[18, 27]]);
        }));

        return function handleContinue() {
            return _ref3.apply(this, arguments);
        };
    }();

    var handleSeatingPreferenceChange = function handleSeatingPreferenceChange(field) {
        return function (event) {
            var value = event.target.value;

            setSeatingPreferences(function (prev) {
                return prev.set(field, value);
            });
            setShowSeatPrefError(false);
        };
    };

    var handleCheckboxChange = function handleCheckboxChange(field) {
        return function (event) {
            var checked = event.target.checked;

            setSeatingPreferences(function (prev) {
                return prev.set(field, checked);
            });
        };
    };

    /*
        Don't force the user to actually set seat or bike reservation data if the context is the reservation widget.
        Just let them proceed without any selections and add the ticket to the basket.
    */
    var canProceed = context === _AppConstants.ReservationContexts.TICKET_BOOKING ? true : seatSelected || bikeSelected;

    var modalProps = {
        show: show,
        className: 'grid-modal modal--large add-reservation-modal',
        onClose: onClose,
        titleText: 'account.reservation.add-reservation-modal.title',
        headerClass: 'text-left',
        hideClose: true,
        showBack: true,
        onBack: onClose || _noop3.default,
        onContinue: handleContinue,
        disableContinue: !canProceed
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            'p',
            { className: 'sr-only' },
            (0, _I18n2.default)('account.reservation.add-reservation-modal.title'),
            '.'
        ),
        _react2.default.createElement(
            'div',
            { className: 'add-reservation-modal' },
            _react2.default.createElement(
                'div',
                { className: 'title' },
                (0, _reservationUtils.stationDisplayName)(origin),
                ' ',
                (0, _I18n2.default)('global.to'),
                ' ',
                (0, _reservationUtils.stationDisplayName)(destination)
            ),
            _react2.default.createElement(
                'div',
                { className: 'passengers' },
                (0, _I18n2.default)('booking.passengers.summary.text', { adults: adults, children: children })
            ),
            bikeAvailabilityError && _react2.default.createElement(
                'div',
                { className: 'bike-container__alert' },
                _react2.default.createElement(
                    _BAlert2.default,
                    {
                        type: _BAlert.bAlertType.DANGER,
                        focusOnload: true
                    },
                    'Not enough bike spaces available for your selected trip.'
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'radio-container margin-top' },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)("radio-item", { "disabled-radio": !tripHasSeatingCapability }) },
                    _react2.default.createElement(_Radio2.default, {
                        radioClass: 'add-reservation-radio',
                        hasIcon: _react2.default.createElement(_Icon2.default, { icon: 'seatlogo' }),
                        label: _react2.default.createElement(
                            'span',
                            { className: 'label' },
                            (0, _I18n2.default)('account.reservation.add-reservation-modal.seat.title')
                        ),
                        checked: seatSelected,
                        onClick: function onClick() {
                            if (!tripHasSeatingCapability) {
                                return;
                            }
                            setSeatSelected(!seatSelected);
                            setShowSeatPrefError(false);
                        },
                        isDisabled: !tripHasSeatingCapability,
                        customDisabledMessage: (0, _I18n2.default)('account.reservation.add-reservation-modal.seat.disabledMessage')
                    }),
                    seatSelected && _react2.default.createElement(
                        'div',
                        { className: 'seat-container' },
                        _RadioGroupsData.radioGroups.map(function (group) {
                            return _react2.default.createElement(_RadioGroups2.default, (0, _extends3.default)({
                                key: group.name
                            }, group, {
                                seatingPreferences: seatingPreferences,
                                handleSeatingPreferenceChange: handleSeatingPreferenceChange
                            }));
                        }),
                        _react2.default.createElement(_FeatureCheckboxes2.default, {
                            seatingPreferences: seatingPreferences,
                            handleCheckboxChange: handleCheckboxChange
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'seat-container__message' },
                            _react2.default.createElement(_Icon2.default, { icon: 'addreservationinfo', className: 'otrl' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Seat preferences cannot be guaranteed'
                            )
                        ),
                        showSeatPrefError && _react2.default.createElement(
                            'div',
                            { className: 'seat-container__alert' },
                            _react2.default.createElement(
                                _BAlert2.default,
                                {
                                    type: _BAlert.bAlertType.DANGER,
                                    focusOnload: true
                                },
                                'Please select a value for at least one seat preference before continuing.'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)("radio-item", { "disabled-radio": !tripHasBikeReservationCapability }) },
                    _react2.default.createElement(_Radio2.default, {
                        radioClass: 'add-reservation-radio',
                        hasIcon: _react2.default.createElement(_Icon2.default, { icon: 'bike' }),
                        label: _react2.default.createElement(
                            'span',
                            { className: 'label' },
                            (0, _I18n2.default)('account.reservation.add-reservation-modal.bike.title')
                        ),
                        checked: bikeSelected,
                        onClick: function onClick() {
                            // eslint-disable-next-line
                            if (!tripHasBikeReservationCapability) return;
                            setBikeSelected(!bikeSelected);
                        },
                        isDisabled: !tripHasBikeReservationCapability,
                        customDisabledMessage: (0, _I18n2.default)('account.reservation.add-reservation-modal.bike.disabledMessage')
                    }),
                    bikeSelected && tripHasBikeReservationCapability && _react2.default.createElement(
                        'div',
                        { className: 'bike-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'bike-container__title' },
                            (0, _I18n2.default)('account.reservation.add-reservation-modal.bike.select.title')
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-4 col-xs-4' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'select-container' },
                                    _react2.default.createElement(_Icon2.default, { icon: 'dropdown' }),
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'sr-only' },
                                            (0, _I18n2.default)('ariaLabel.add-reservation-modal.bikesSelect')
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            {
                                                type: 'select',
                                                value: bikesQty,
                                                onChange: function onChange(e) {
                                                    return setBikesQty(Number(e.target.value));
                                                }
                                            },
                                            (0, _from2.default)({ length: maxBikeQty }, function (_, i) {
                                                return i + 1;
                                            }).map(function (num) {
                                                return _react2.default.createElement(
                                                    'option',
                                                    { key: num, value: num },
                                                    num
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

AddReservationModal.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    onContinue: _propTypes2.default.func,
    onBack: _propTypes2.default.func,
    context: _propTypes2.default.string,
    currentJourneyData: _propTypes2.default.object
};

exports.default = AddReservationModal;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1184);
__webpack_require__(1187);
__webpack_require__(1188);
__webpack_require__(1189);
__webpack_require__(1190);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(1196);
__webpack_require__(1197);
__webpack_require__(1198);
__webpack_require__(1199);
__webpack_require__(1200);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1203);
__webpack_require__(1204);
__webpack_require__(1205);
__webpack_require__(1206);
__webpack_require__(1207);
__webpack_require__(1208);
__webpack_require__(1209);
__webpack_require__(1210);
__webpack_require__(1211);
__webpack_require__(1212);
__webpack_require__(1213);
__webpack_require__(1214);
__webpack_require__(1215);
__webpack_require__(1216);
__webpack_require__(1217);
__webpack_require__(1218);
__webpack_require__(1219);
__webpack_require__(1220);
__webpack_require__(1221);
__webpack_require__(1222);
__webpack_require__(1223);
__webpack_require__(1224);
__webpack_require__(1225);
__webpack_require__(1226);
__webpack_require__(1227);
__webpack_require__(1228);
__webpack_require__(1229);
__webpack_require__(1230);
__webpack_require__(1231);
__webpack_require__(1232);
__webpack_require__(1233);
__webpack_require__(1234);
__webpack_require__(1235);
__webpack_require__(1236);
__webpack_require__(1237);
__webpack_require__(1238);
__webpack_require__(1239);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1242);
__webpack_require__(1243);
__webpack_require__(1244);
__webpack_require__(1245);
__webpack_require__(1246);
__webpack_require__(1247);
__webpack_require__(1248);
__webpack_require__(1249);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1254);
__webpack_require__(1255);
__webpack_require__(1256);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1259);
__webpack_require__(1260);
__webpack_require__(1261);
__webpack_require__(1262);
__webpack_require__(1264);
__webpack_require__(1265);
__webpack_require__(1267);
__webpack_require__(1268);
__webpack_require__(1269);
__webpack_require__(1270);
__webpack_require__(1271);
__webpack_require__(1272);
__webpack_require__(1273);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1281);
__webpack_require__(1282);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1287);
__webpack_require__(485);
__webpack_require__(1288);
__webpack_require__(707);
__webpack_require__(1289);
__webpack_require__(708);
__webpack_require__(1290);
__webpack_require__(1291);
__webpack_require__(1292);
__webpack_require__(1293);
__webpack_require__(1294);
__webpack_require__(711);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(1295);
__webpack_require__(1296);
__webpack_require__(1297);
__webpack_require__(1298);
__webpack_require__(1299);
__webpack_require__(1300);
__webpack_require__(1301);
__webpack_require__(1302);
__webpack_require__(1303);
__webpack_require__(1304);
__webpack_require__(1305);
__webpack_require__(1306);
__webpack_require__(1307);
__webpack_require__(1308);
__webpack_require__(1309);
__webpack_require__(1310);
__webpack_require__(1311);
__webpack_require__(1312);
__webpack_require__(1313);
__webpack_require__(1314);
__webpack_require__(1315);
__webpack_require__(1316);
__webpack_require__(1317);
__webpack_require__(1318);
__webpack_require__(1319);
__webpack_require__(1320);
__webpack_require__(1321);
__webpack_require__(1322);
__webpack_require__(1323);
__webpack_require__(1324);
__webpack_require__(1325);
__webpack_require__(1326);
__webpack_require__(1327);
__webpack_require__(1328);
__webpack_require__(1329);
__webpack_require__(1330);
__webpack_require__(1331);
__webpack_require__(1332);
__webpack_require__(1333);
__webpack_require__(1334);
__webpack_require__(1335);
__webpack_require__(1336);
__webpack_require__(1337);
__webpack_require__(1338);
__webpack_require__(1339);
__webpack_require__(1340);
__webpack_require__(1341);
__webpack_require__(1342);
__webpack_require__(1343);
__webpack_require__(1344);
__webpack_require__(1345);
__webpack_require__(1346);
__webpack_require__(1347);
__webpack_require__(1348);
__webpack_require__(1349);
__webpack_require__(1350);
__webpack_require__(1351);
__webpack_require__(1352);
__webpack_require__(1353);
__webpack_require__(1354);
__webpack_require__(1355);
__webpack_require__(1356);
__webpack_require__(1357);
__webpack_require__(1358);
__webpack_require__(1359);
__webpack_require__(1360);
__webpack_require__(1361);
__webpack_require__(1362);
__webpack_require__(1363);
__webpack_require__(1364);
__webpack_require__(1365);
__webpack_require__(1366);
__webpack_require__(1367);
__webpack_require__(1368);
__webpack_require__(1369);
__webpack_require__(1370);
__webpack_require__(1371);
__webpack_require__(1372);
__webpack_require__(1373);
__webpack_require__(1374);
__webpack_require__(1375);
__webpack_require__(1376);
__webpack_require__(1377);
__webpack_require__(1378);
__webpack_require__(1379);
module.exports = __webpack_require__(130);


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(36);
var has = __webpack_require__(120);
var DESCRIPTORS = __webpack_require__(66);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(112);
var META = __webpack_require__(180).KEY;
var $fails = __webpack_require__(40);
var shared = __webpack_require__(292);
var setToStringTag = __webpack_require__(242);
var uid = __webpack_require__(206);
var wks = __webpack_require__(56);
var wksExt = __webpack_require__(689);
var wksDefine = __webpack_require__(466);
var enumKeys = __webpack_require__(1186);
var isArray = __webpack_require__(358);
var anObject = __webpack_require__(31);
var isObject = __webpack_require__(48);
var toObject = __webpack_require__(73);
var toIObject = __webpack_require__(121);
var toPrimitive = __webpack_require__(148);
var createDesc = __webpack_require__(205);
var _create = __webpack_require__(209);
var gOPNExt = __webpack_require__(692);
var $GOPD = __webpack_require__(122);
var $GOPS = __webpack_require__(357);
var $DP = __webpack_require__(71);
var $keys = __webpack_require__(207);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(210).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(294).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(179)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(111)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(292)('native-function-to-string', Function.toString);


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(207);
var gOPS = __webpack_require__(357);
var pIE = __webpack_require__(294);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(209) });


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(66), 'Object', { defineProperty: __webpack_require__(71).f });


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(66), 'Object', { defineProperties: __webpack_require__(691) });


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(121);
var $getOwnPropertyDescriptor = __webpack_require__(122).f;

__webpack_require__(150)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(73);
var $getPrototypeOf = __webpack_require__(123);

__webpack_require__(150)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(73);
var $keys = __webpack_require__(207);

__webpack_require__(150)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(150)('getOwnPropertyNames', function () {
  return __webpack_require__(692).f;
});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(180).onFreeze;

__webpack_require__(150)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(180).onFreeze;

__webpack_require__(150)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(180).onFreeze;

__webpack_require__(150)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(48);

__webpack_require__(150)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(48);

__webpack_require__(150)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(48);

__webpack_require__(150)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(10);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(693) });


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(10);
$export($export.S, 'Object', { is: __webpack_require__(694) });


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(10);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(470).set });


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(243);
var test = {};
test[__webpack_require__(56)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(112)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(10);

$export($export.P, 'Function', { bind: __webpack_require__(695) });


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(66) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(123);
var HAS_INSTANCE = __webpack_require__(56)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(71).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseInt = __webpack_require__(697);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseFloat = __webpack_require__(698);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(36);
var has = __webpack_require__(120);
var cof = __webpack_require__(132);
var inheritIfRequired = __webpack_require__(472);
var toPrimitive = __webpack_require__(148);
var fails = __webpack_require__(40);
var gOPN = __webpack_require__(210).f;
var gOPD = __webpack_require__(122).f;
var dP = __webpack_require__(71).f;
var $trim = __webpack_require__(244).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(209)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(66) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(112)(global, NUMBER, $Number);
}


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toInteger = __webpack_require__(133);
var aNumberValue = __webpack_require__(699);
var repeat = __webpack_require__(473);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(40)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $fails = __webpack_require__(40);
var aNumberValue = __webpack_require__(699);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(10);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(10);
var _isFinite = __webpack_require__(36).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(10);

$export($export.S, 'Number', { isInteger: __webpack_require__(700) });


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(10);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(10);
var isInteger = __webpack_require__(700);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(10);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(10);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseFloat = __webpack_require__(698);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseInt = __webpack_require__(697);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(10);
var log1p = __webpack_require__(701);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(10);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(10);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(10);
var sign = __webpack_require__(474);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(10);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(10);
var $expm1 = __webpack_require__(475);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { fround: __webpack_require__(702) });


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(10);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(10);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(40)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { log1p: __webpack_require__(701) });


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { sign: __webpack_require__(474) });


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(475);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(40)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(475);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(208);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var toIObject = __webpack_require__(121);
var toLength = __webpack_require__(63);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(244)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(359)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(476)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $at = __webpack_require__(359)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(10);
var toLength = __webpack_require__(63);
var context = __webpack_require__(478);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(479)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(10);
var context = __webpack_require__(478);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(479)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(473)
});


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(10);
var toLength = __webpack_require__(63);
var context = __webpack_require__(478);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(479)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(113)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(113)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(113)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(113)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(113)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(113)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(113)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(113)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(113)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(113)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(113)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(113)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(113)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(10);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(73);
var toPrimitive = __webpack_require__(148);

$export($export.P + $export.F * __webpack_require__(40)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(10);
var toISOString = __webpack_require__(1263);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(40);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(112)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(56)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(111)(proto, TO_PRIMITIVE, __webpack_require__(1266));


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(31);
var toPrimitive = __webpack_require__(148);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(10);

$export($export.S, 'Array', { isArray: __webpack_require__(358) });


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(131);
var $export = __webpack_require__(10);
var toObject = __webpack_require__(73);
var call = __webpack_require__(703);
var isArrayIter = __webpack_require__(480);
var toLength = __webpack_require__(63);
var createProperty = __webpack_require__(481);
var getIterFn = __webpack_require__(482);

$export($export.S + $export.F * !__webpack_require__(361)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var createProperty = __webpack_require__(481);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(40)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(10);
var toIObject = __webpack_require__(121);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(293) != Object || !__webpack_require__(134)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var html = __webpack_require__(469);
var cof = __webpack_require__(132);
var toAbsoluteIndex = __webpack_require__(208);
var toLength = __webpack_require__(63);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(40)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var aFunction = __webpack_require__(93);
var toObject = __webpack_require__(73);
var fails = __webpack_require__(40);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(134)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $forEach = __webpack_require__(151)(0);
var STRICT = __webpack_require__(134)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var isArray = __webpack_require__(358);
var SPECIES = __webpack_require__(56)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $map = __webpack_require__(151)(1);

$export($export.P + $export.F * !__webpack_require__(134)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $filter = __webpack_require__(151)(2);

$export($export.P + $export.F * !__webpack_require__(134)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $some = __webpack_require__(151)(3);

$export($export.P + $export.F * !__webpack_require__(134)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $every = __webpack_require__(151)(4);

$export($export.P + $export.F * !__webpack_require__(134)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $reduce = __webpack_require__(704);

$export($export.P + $export.F * !__webpack_require__(134)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $reduce = __webpack_require__(704);

$export($export.P + $export.F * !__webpack_require__(134)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $indexOf = __webpack_require__(356)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(134)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toIObject = __webpack_require__(121);
var toInteger = __webpack_require__(133);
var toLength = __webpack_require__(63);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(134)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(10);

$export($export.P, 'Array', { copyWithin: __webpack_require__(705) });

__webpack_require__(181)('copyWithin');


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(10);

$export($export.P, 'Array', { fill: __webpack_require__(484) });

__webpack_require__(181)('fill');


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(10);
var $find = __webpack_require__(151)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(181)(KEY);


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(10);
var $find = __webpack_require__(151)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(181)(KEY);


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(211)('Array');


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var inheritIfRequired = __webpack_require__(472);
var dP = __webpack_require__(71).f;
var gOPN = __webpack_require__(210).f;
var isRegExp = __webpack_require__(360);
var $flags = __webpack_require__(295);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(66) && (!CORRECT_NEW || __webpack_require__(40)(function () {
  re2[__webpack_require__(56)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(112)(global, 'RegExp', $RegExp);
}

__webpack_require__(211)('RegExp');


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(708);
var anObject = __webpack_require__(31);
var $flags = __webpack_require__(295);
var DESCRIPTORS = __webpack_require__(66);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(112)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(40)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(31);
var toLength = __webpack_require__(63);
var advanceStringIndex = __webpack_require__(487);
var regExpExec = __webpack_require__(362);

// @@match logic
__webpack_require__(363)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(31);
var toObject = __webpack_require__(73);
var toLength = __webpack_require__(63);
var toInteger = __webpack_require__(133);
var advanceStringIndex = __webpack_require__(487);
var regExpExec = __webpack_require__(362);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(363)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(31);
var sameValue = __webpack_require__(694);
var regExpExec = __webpack_require__(362);

// @@search logic
__webpack_require__(363)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(360);
var anObject = __webpack_require__(31);
var speciesConstructor = __webpack_require__(296);
var advanceStringIndex = __webpack_require__(487);
var toLength = __webpack_require__(63);
var callRegExpExec = __webpack_require__(362);
var regexpExec = __webpack_require__(486);
var fails = __webpack_require__(40);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(363)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(179);
var global = __webpack_require__(36);
var ctx = __webpack_require__(131);
var classof = __webpack_require__(243);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(48);
var aFunction = __webpack_require__(93);
var anInstance = __webpack_require__(212);
var forOf = __webpack_require__(213);
var speciesConstructor = __webpack_require__(296);
var task = __webpack_require__(488).set;
var microtask = __webpack_require__(489)();
var newPromiseCapabilityModule = __webpack_require__(490);
var perform = __webpack_require__(709);
var userAgent = __webpack_require__(364);
var promiseResolve = __webpack_require__(710);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(56)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(214)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(242)($Promise, PROMISE);
__webpack_require__(211)(PROMISE);
Wrapper = __webpack_require__(130)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(361)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(715);
var validate = __webpack_require__(215);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(365)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $typed = __webpack_require__(366);
var buffer = __webpack_require__(491);
var anObject = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(208);
var toLength = __webpack_require__(63);
var isObject = __webpack_require__(48);
var ArrayBuffer = __webpack_require__(36).ArrayBuffer;
var speciesConstructor = __webpack_require__(296);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(40)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(211)(ARRAY_BUFFER);


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
$export($export.G + $export.W + $export.F * !__webpack_require__(366).ABV, {
  DataView: __webpack_require__(491).DataView
});


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(10);
var aFunction = __webpack_require__(93);
var anObject = __webpack_require__(31);
var rApply = (__webpack_require__(36).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(40)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(10);
var create = __webpack_require__(209);
var aFunction = __webpack_require__(93);
var anObject = __webpack_require__(31);
var isObject = __webpack_require__(48);
var fails = __webpack_require__(40);
var bind = __webpack_require__(695);
var rConstruct = (__webpack_require__(36).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(71);
var $export = __webpack_require__(10);
var anObject = __webpack_require__(31);
var toPrimitive = __webpack_require__(148);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(40)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(10);
var gOPD = __webpack_require__(122).f;
var anObject = __webpack_require__(31);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(31);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(477)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(122);
var getPrototypeOf = __webpack_require__(123);
var has = __webpack_require__(120);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(48);
var anObject = __webpack_require__(31);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(122);
var $export = __webpack_require__(10);
var anObject = __webpack_require__(31);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(10);
var getProto = __webpack_require__(123);
var anObject = __webpack_require__(31);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(10);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(31);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(10);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(717) });


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(31);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(71);
var gOPD = __webpack_require__(122);
var getPrototypeOf = __webpack_require__(123);
var has = __webpack_require__(120);
var $export = __webpack_require__(10);
var createDesc = __webpack_require__(205);
var anObject = __webpack_require__(31);
var isObject = __webpack_require__(48);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(10);
var setProto = __webpack_require__(470);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(10);
var $includes = __webpack_require__(356)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(181)('includes');


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(10);
var flattenIntoArray = __webpack_require__(718);
var toObject = __webpack_require__(73);
var toLength = __webpack_require__(63);
var aFunction = __webpack_require__(93);
var arraySpeciesCreate = __webpack_require__(483);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(181)('flatMap');


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(10);
var flattenIntoArray = __webpack_require__(718);
var toObject = __webpack_require__(73);
var toLength = __webpack_require__(63);
var toInteger = __webpack_require__(133);
var arraySpeciesCreate = __webpack_require__(483);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(181)('flatten');


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(10);
var $at = __webpack_require__(359)(true);
var $fails = __webpack_require__(40);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(10);
var $pad = __webpack_require__(719);
var userAgent = __webpack_require__(364);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(10);
var $pad = __webpack_require__(719);
var userAgent = __webpack_require__(364);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(244)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(244)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(10);
var defined = __webpack_require__(149);
var toLength = __webpack_require__(63);
var isRegExp = __webpack_require__(360);
var getFlags = __webpack_require__(295);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(477)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(466)('asyncIterator');


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(466)('observable');


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(10);
var ownKeys = __webpack_require__(717);
var toIObject = __webpack_require__(121);
var gOPD = __webpack_require__(122);
var createProperty = __webpack_require__(481);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(10);
var $values = __webpack_require__(720)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(10);
var $entries = __webpack_require__(720)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(73);
var aFunction = __webpack_require__(93);
var $defineProperty = __webpack_require__(71);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(66) && $export($export.P + __webpack_require__(367), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(73);
var aFunction = __webpack_require__(93);
var $defineProperty = __webpack_require__(71);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(66) && $export($export.P + __webpack_require__(367), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(73);
var toPrimitive = __webpack_require__(148);
var getPrototypeOf = __webpack_require__(123);
var getOwnPropertyDescriptor = __webpack_require__(122).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(66) && $export($export.P + __webpack_require__(367), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(73);
var toPrimitive = __webpack_require__(148);
var getPrototypeOf = __webpack_require__(123);
var getOwnPropertyDescriptor = __webpack_require__(122).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(66) && $export($export.P + __webpack_require__(367), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(10);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(721)('Map') });


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(10);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(721)('Set') });


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(368)('Map');


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(368)('Set');


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(368)('WeakMap');


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(368)('WeakSet');


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(369)('Map');


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(369)('Set');


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(369)('WeakMap');


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(369)('WeakSet');


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(10);

$export($export.G, { global: __webpack_require__(36) });


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(10);

$export($export.S, 'System', { global: __webpack_require__(36) });


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(10);
var cof = __webpack_require__(132);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);
var scale = __webpack_require__(723);
var fround = __webpack_require__(702);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', { scale: __webpack_require__(723) });


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(10);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(10);
var core = __webpack_require__(130);
var global = __webpack_require__(36);
var speciesConstructor = __webpack_require__(296);
var promiseResolve = __webpack_require__(710);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(490);
var perform = __webpack_require__(709);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(123);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(713);
var from = __webpack_require__(722);
var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(123);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(123);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(163);
var anObject = __webpack_require__(31);
var aFunction = __webpack_require__(93);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(10);
var microtask = __webpack_require__(489)();
var process = __webpack_require__(36).process;
var isNode = __webpack_require__(132)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(10);
var global = __webpack_require__(36);
var core = __webpack_require__(130);
var microtask = __webpack_require__(489)();
var OBSERVABLE = __webpack_require__(56)('observable');
var aFunction = __webpack_require__(93);
var anObject = __webpack_require__(31);
var anInstance = __webpack_require__(212);
var redefineAll = __webpack_require__(214);
var hide = __webpack_require__(111);
var forOf = __webpack_require__(213);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(211)('Observable');


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(36);
var $export = __webpack_require__(10);
var userAgent = __webpack_require__(364);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $task = __webpack_require__(488);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(485);
var getKeys = __webpack_require__(207);
var redefine = __webpack_require__(112);
var global = __webpack_require__(36);
var hide = __webpack_require__(111);
var Iterators = __webpack_require__(245);
var wks = __webpack_require__(56);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1382);
module.exports = __webpack_require__(130).RegExp.escape;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(10);
var $re = __webpack_require__(1383)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(246);
__webpack_require__(216);
__webpack_require__(218);
__webpack_require__(1392);
__webpack_require__(1396);
__webpack_require__(1397);
module.exports = __webpack_require__(49).Promise;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(492);
var defined = __webpack_require__(370);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(371);
var descriptor = __webpack_require__(299);
var setToStringTag = __webpack_require__(301);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(182)(IteratorPrototype, __webpack_require__(94)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(135);
var anObject = __webpack_require__(136);
var getKeys = __webpack_require__(248);

module.exports = __webpack_require__(124) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(185);
var toLength = __webpack_require__(372);
var toAbsoluteIndex = __webpack_require__(1389);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(492);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1391);
var step = __webpack_require__(728);
var Iterators = __webpack_require__(247);
var toIObject = __webpack_require__(185);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(493)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(297);
var global = __webpack_require__(82);
var ctx = __webpack_require__(164);
var classof = __webpack_require__(374);
var $export = __webpack_require__(69);
var isObject = __webpack_require__(103);
var aFunction = __webpack_require__(298);
var anInstance = __webpack_require__(375);
var forOf = __webpack_require__(249);
var speciesConstructor = __webpack_require__(731);
var task = __webpack_require__(732).set;
var microtask = __webpack_require__(1394)();
var newPromiseCapabilityModule = __webpack_require__(502);
var perform = __webpack_require__(733);
var userAgent = __webpack_require__(1395);
var promiseResolve = __webpack_require__(734);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(94)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(376)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(301)($Promise, PROMISE);
__webpack_require__(735)(PROMISE);
Wrapper = __webpack_require__(49)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(736)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(82);
var macrotask = __webpack_require__(732).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(300)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(82);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(69);
var core = __webpack_require__(49);
var global = __webpack_require__(82);
var speciesConstructor = __webpack_require__(731);
var promiseResolve = __webpack_require__(734);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(69);
var newPromiseCapability = __webpack_require__(502);
var perform = __webpack_require__(733);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.3
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");
var util = _dereq_("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

function _drainQueue(queue) {
    while (queue.length() > 0) {
        _drainQueueStep(queue);
    }
}

function _drainQueueStep(queue) {
    var fn = queue.shift();
    if (typeof fn !== "function") {
        fn._settlePromises();
    } else {
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
}

Async.prototype._drainQueues = function () {
    _drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    _drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var es5 = _dereq_("./es5");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    var self = this;
    setTimeout(function() {
        self._notifyUnhandledRejection();
    }, 1);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var eventData = {
                    detail: event,
                    cancelable: true
                };
                es5.defineProperty(
                    eventData, "promise", {value: event.promise});
                es5.defineProperty(eventData, "reason", {value: event.reason});
                var domEvent = new CustomEvent(name.toLowerCase(), eventData);
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                es5.defineProperty(domEvent, "promise", {value: event.promise});
                es5.defineProperty(domEvent, "reason", {value: event.reason});
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._dereferenceTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function longStackTracesDereferenceTrace() {
    this._trace = undefined;
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./es5":13,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = _dereq_("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
        this._dereferenceTrace();
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.5.3";
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./call_get.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./filter.js')(Promise, INTERNAL);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var receiver = new FakeConstructor();
    function ic() {
        return typeof receiver.foo;
    }
    ic();
    ic();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    typeof process.env !== "undefined";

function env(key) {
    return hasEnvVariables ? process.env[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186), __webpack_require__(81), __webpack_require__(1399).setImmediate))

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1400);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81), __webpack_require__(186)))

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1402);
module.exports = __webpack_require__(49).Object.assign;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(69);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(737) });


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1404);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(504),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(504),q=__webpack_require__(1406);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1407);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

exports.default = createApp;

__webpack_require__(687);

var _Polyfills = __webpack_require__(1409);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _appVersion = __webpack_require__(351);

var _appVersion2 = _interopRequireDefault(_appVersion);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppActions = __webpack_require__(390);

var _AppActions2 = _interopRequireDefault(_AppActions);

var _BaseStore = __webpack_require__(22);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Async/await and regenerator currently throw lots of bluebird warnings, so disable them
// Polyfills
_promise2.default.config({
    warnings: false
});

/* eslint-disable no-console */

function createApp(onInit, onRender) {
    return {
        info: function info() {
            console.log(('OTRL\n                ====\n                App: ' + _config2.default.get('name') + '\n                Version: ' + _appVersion2.default.version + '\n                Assets: ' + _Assets2.default.assetVersion + '\n                Environment: ' + _config2.default.get('environment') + '\n                Brand: ' + _config2.default.get('brand')).replace(/^\s*/mg, ''));

            transformReactErrorsToWarnings();
        },
        initDebug: function initDebug() {
            if (_config2.default.get('debug')) {
                _AppDispatcher2.default.register(_AppDispatcher.logActionHandler);
                if (_config2.default.get('a11y')) {
                    var a11y = __webpack_require__(1610).default;
                    a11y(_react2.default, _reactDom2.default);
                }
            }
        },
        init: function init(appConfig, version, assetVersion) {
            var _this = this;

            (0, _Polyfills.polyfillsReady)().then(function () {
                _config2.default.init(appConfig);
                _appVersion2.default.version = version;
                _Assets2.default.assetVersion = assetVersion;

                onInit();

                _this.info();
                _this.initDebug();
                _AppActions2.default.initialize();
                _BaseStore.PersistedStores.map(function (store) {
                    return store.loadPersistedState();
                });
                var containerEl = document.getElementById('container');
                onRender(containerEl);
            });
        },


        /**
         * Expose some functions for the app to use
         */
        appActions: {
            openModal: function openModal(type, props) {
                _ModalActions2.default.open(type.toUpperCase(), props);
            },
            closeModal: function closeModal() {
                _ModalActions2.default.close();
            },
            toggleFeature: function toggleFeature(featureName, value) {
                _AppActions2.default.toggleFeature(featureName, value);
            },
            listFeatures: function listFeatures() {
                var FeatureFlagStore = __webpack_require__(27).default;
                var features = _config2.default.keys().filter(function (key) {
                    return key.match(/^(?:enable|disable)/);
                });
                var table = features.reduce(function (flags, name) {
                    flags[name] = { value: FeatureFlagStore.get(name) };
                    return flags;
                }, {});
                console.table(table);
            },
            setFeatureVariant: function setFeatureVariant(feature, variant) {
                _AppActions2.default.setFeatureVariant(feature, variant);
            },
            listFeatureVariants: function listFeatureVariants() {
                var FeatureVariantStore = __webpack_require__(534).default;
                console.table(FeatureVariantStore.getAll());
            },
            enableTracking: function enableTracking() {
                _AppActions2.default.enableTracking();
            },
            disableTracking: function disableTracking() {
                _AppActions2.default.disableTracking();
            }
        }
    };
}

var transformReactErrorsToWarnings = function transformReactErrorsToWarnings() {
    var matchedMessages = ['Warning:'];
    var oldConsoleError = console.error;

    console.error = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var consoleFunction = oldConsoleError;

        if (typeof args[0] === 'string' && matchedMessages.some(function (error) {
            return args[0].startsWith(error);
        })) {
            consoleFunction = console.warn;
        }

        consoleFunction.apply(undefined, args);
    };
};

/* eslint-enable no-console */

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

exports.polyfillsReady = polyfillsReady;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Load polyfills only when required.
 * Each function checks if the polyfill is needed, then uses
 * requre.ensure to load it.
 *
 * polyfillsReady resolves when all necessary polyfills have loaded
 */

function intl() {
    return new _promise2.default(function (resolve) {
        if (!global.Intl) {
            __webpack_require__.e/* require.ensure */(0).then((function (require) {
                __webpack_require__(1115);
                __webpack_require__(2205);
                resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
            resolve();
        }
    });
}

function placeholders() {
    return new _promise2.default(function (resolve) {
        var test = document.createElement('input');
        var nativeSupport = test.placeholder !== void 0;
        if (!nativeSupport) {
            __webpack_require__.e/* require.ensure */(1).then((function (require) {
                __webpack_require__(1116);
                resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
            resolve();
        }
    });
}

function scrollIntoViewIfNeeded() {
    return new _promise2.default(function (resolve) {
        if (!Element.prototype.scrollIntoViewIfNeeded) {
            __webpack_require__.e/* require.ensure */(2).then((function (require) {
                __webpack_require__(1117);
                resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        } else {
            resolve();
        }
    });
}

function polyfillsReady() {
    return _promise2.default.all([intl(), placeholders(), scrollIntoViewIfNeeded()]);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1411);
module.exports = __webpack_require__(49).Object.keys;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(217);
var $keys = __webpack_require__(248);

__webpack_require__(377)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1413), __esModule: true };

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(216);
__webpack_require__(218);
module.exports = __webpack_require__(378).f('iterator');


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1415);
__webpack_require__(246);
__webpack_require__(1417);
__webpack_require__(1418);
module.exports = __webpack_require__(49).Symbol;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(82);
var has = __webpack_require__(184);
var DESCRIPTORS = __webpack_require__(124);
var $export = __webpack_require__(69);
var redefine = __webpack_require__(496);
var META = __webpack_require__(303).KEY;
var $fails = __webpack_require__(183);
var shared = __webpack_require__(499);
var setToStringTag = __webpack_require__(301);
var uid = __webpack_require__(373);
var wks = __webpack_require__(94);
var wksExt = __webpack_require__(378);
var wksDefine = __webpack_require__(505);
var enumKeys = __webpack_require__(1416);
var isArray = __webpack_require__(738);
var anObject = __webpack_require__(136);
var isObject = __webpack_require__(103);
var toObject = __webpack_require__(217);
var toIObject = __webpack_require__(185);
var toPrimitive = __webpack_require__(495);
var createDesc = __webpack_require__(299);
var _create = __webpack_require__(371);
var gOPNExt = __webpack_require__(739);
var $GOPD = __webpack_require__(506);
var $GOPS = __webpack_require__(503);
var $DP = __webpack_require__(135);
var $keys = __webpack_require__(248);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(740).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(302).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(297)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(182)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(248);
var gOPS = __webpack_require__(503);
var pIE = __webpack_require__(302);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(505)('asyncIterator');


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(505)('observable');


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1420);
module.exports = __webpack_require__(49).Object.setPrototypeOf;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(69);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1421).set });


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(103);
var anObject = __webpack_require__(136);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(164)(Function.call, __webpack_require__(506).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1423);
var $Object = __webpack_require__(49).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(69);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(371) });


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    tocCode: null,
    startDate: null,
    endDate: null,
    message: null
};

var DisabledService = function (_record) {
    (0, _inherits3.default)(DisabledService, _record);

    function DisabledService() {
        (0, _classCallCheck3.default)(this, DisabledService);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DisabledService.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DisabledService, json, {
            tocCode: _LinkMapper.fields.string,
            startDate: _LinkMapper.fields.string,
            endDate: _LinkMapper.fields.string,
            message: _LinkMapper.fields.string
        });
    };

    return DisabledService;
}((0, _immutable.Record)(defaults));

exports.default = DisabledService;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(250);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isLength = __webpack_require__(507),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(748);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(143);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1432),
    getMatchData = __webpack_require__(1467),
    matchesStrictComparable = __webpack_require__(760);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(380),
    baseIsEqual = __webpack_require__(510);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(382);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(382);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(382);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(382);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(381);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1440 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1441 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(381),
    Map = __webpack_require__(508),
    MapCache = __webpack_require__(509);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(202),
    isMasked = __webpack_require__(1444),
    isObject = __webpack_require__(77),
    toSource = __webpack_require__(749);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1445);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(87);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1446 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1448),
    ListCache = __webpack_require__(381),
    Map = __webpack_require__(508);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1449),
    hashDelete = __webpack_require__(1450),
    hashGet = __webpack_require__(1451),
    hashHas = __webpack_require__(1452),
    hashSet = __webpack_require__(1453);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(383);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(383);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(383);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(383);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(384);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(384);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(384);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(384);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(380),
    equalArrays = __webpack_require__(750),
    equalByTag = __webpack_require__(1462),
    equalObjects = __webpack_require__(1464),
    getTag = __webpack_require__(307),
    isArray = __webpack_require__(68),
    isBuffer = __webpack_require__(251),
    isTypedArray = __webpack_require__(306);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(250),
    Uint8Array = __webpack_require__(752),
    eq = __webpack_require__(253),
    equalArrays = __webpack_require__(750),
    mapToArray = __webpack_require__(1463),
    setToArray = __webpack_require__(511);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(753);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(87);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(87);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(759),
    keys = __webpack_require__(127);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(510),
    get = __webpack_require__(61),
    hasIn = __webpack_require__(761),
    isKey = __webpack_require__(514),
    isStrictComparable = __webpack_require__(759),
    matchesStrictComparable = __webpack_require__(760),
    toKey = __webpack_require__(188);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1470);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1471);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(509);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1472 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(385);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1474 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(633),
    defineProperty = __webpack_require__(765),
    identity = __webpack_require__(116);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(386),
    root = __webpack_require__(87);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(290),
    createCtor = __webpack_require__(386),
    createHybrid = __webpack_require__(769),
    createRecurry = __webpack_require__(772),
    getHolder = __webpack_require__(518),
    replaceHolders = __webpack_require__(389),
    root = __webpack_require__(87);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1478 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(516),
    getData = __webpack_require__(773),
    getFuncName = __webpack_require__(1480),
    lodash = __webpack_require__(1482);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1481);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 1481 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(516),
    LodashWrapper = __webpack_require__(774),
    baseLodash = __webpack_require__(517),
    isArray = __webpack_require__(68),
    isObjectLike = __webpack_require__(104),
    wrapperClone = __webpack_require__(1483);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(516),
    LodashWrapper = __webpack_require__(774),
    copyArray = __webpack_require__(311);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1484 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1485 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(387),
    arrayIncludes = __webpack_require__(663);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1487 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1488 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(311),
    isIndex = __webpack_require__(305);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(290),
    createCtor = __webpack_require__(386),
    root = __webpack_require__(87);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(770),
    composeArgsRight = __webpack_require__(771),
    replaceHolders = __webpack_require__(389);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1492 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.45
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(67)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(67)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.45",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	function closest (num, arr) {
		var len = arr.length;
		if (num < arr[0]) {
			return 0;
		} else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) {
			return len - 1;
		} else if (num >= arr[len - 1]) {
			return -1;
		}

		var mid;
		var lo = 0;
		var hi = len - 1;
		while (hi - lo > 1) {
			mid = Math.floor((lo + hi) / 2);
			if (arr[mid] <= num) {
				lo = mid;
			} else {
				hi = mid;
			}
		}
		return hi;
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			i = closest(target, untils);
			if (i >= 0) {
				return i;
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			lastOffset = last.offset,
			offsets = [last],
			change, next, nextOffset, i;

		for (i = 1; i < 48; i++) {
			nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
			if (nextOffset !== lastOffset) {
				// Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
				next = new OffsetAt(new Date(startYear, i, 1));
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				last = next;
				lastOffset = nextOffset;
			}
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			checkedOffsets = {},
			i, j, offset, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			offset = offsets[i].offset;
			if (checkedOffsets.hasOwnProperty(offset)) {
				continue;
			}
			guessesOffset = guesses[offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
			checkedOffsets[offset] = true;
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			out  = moment.utc.apply(null, args),
			zone;

		if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports = {"version":"2024a","links":[],"zones":["Etc/UTC|UTC|0|0||","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6"]}

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1496);
var $Object = __webpack_require__(49).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(69);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(124), 'Object', { defineProperty: __webpack_require__(135).f });


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(237),
    isArrayLike = __webpack_require__(143);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

module.exports = baseZipObject;


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    id: [_LinkMapper.fields.string],
    group: [_LinkMapper.fields.string],
    ticketNumber: [_LinkMapper.fields.bool],
    photocardNumber: [_LinkMapper.fields.bool],
    smartcardNumber: [_LinkMapper.fields.bool],
    contactlessNumber: [_LinkMapper.fields.bool],
    ticketUpload: [_LinkMapper.fields.bool],
    statementUpload: [_LinkMapper.fields.bool],
    allowPreviousUpload: [_LinkMapper.fields.bool]
};

var DelayRepayTicketType = function (_record) {
    (0, _inherits3.default)(DelayRepayTicketType, _record);

    function DelayRepayTicketType() {
        (0, _classCallCheck3.default)(this, DelayRepayTicketType);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DelayRepayTicketType.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DelayRepayTicketType, json, (0, _Records.getResolvers)(schema));
    };

    return DelayRepayTicketType;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = DelayRepayTicketType;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    moreDetailsRequired: null,
    moreDetailsOptional: null,
    maxTicketDays: null
};

var DelayRepayReason = function (_record) {
    (0, _inherits3.default)(DelayRepayReason, _record);

    function DelayRepayReason() {
        (0, _classCallCheck3.default)(this, DelayRepayReason);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DelayRepayReason.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DelayRepayReason, json, {
            id: _LinkMapper.fields.string,
            moreDetailsRequired: _LinkMapper.fields.bool,
            moreDetailsOptional: _LinkMapper.fields.bool,
            maxTicketDays: _LinkMapper.fields.number
        });
    };

    return DelayRepayReason;
}((0, _immutable.Record)(defaults));

exports.default = DelayRepayReason;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    value: null,
    minDate: null
};

var DelayRepayTime = function (_record) {
    (0, _inherits3.default)(DelayRepayTime, _record);

    function DelayRepayTime() {
        (0, _classCallCheck3.default)(this, DelayRepayTime);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DelayRepayTime.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DelayRepayTime, json, {
            id: _LinkMapper.fields.string,
            value: _LinkMapper.fields.string,
            minDate: _LinkMapper.fields.datetime
        });
    };

    DelayRepayTime.prototype.isValid = function isValid() {
        return !this.minDate || this.minDate.isBefore((0, _TrainTime2.default)());
    };

    return DelayRepayTime;
}((0, _immutable.Record)(defaults));

exports.default = DelayRepayTime;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(254);

module.exports = function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(254);
var defaultToWhiteSpace = __webpack_require__(781);
var nativeTrimRight = String.prototype.trimRight;

module.exports = function rtrim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrimRight) return nativeTrimRight.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp(characters + '+$'), '');
};


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

module.exports.Dispatcher = __webpack_require__(1505);


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Dispatcher
 * 
 * @preventMunge
 */



exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__(1506);

var _prefix = 'ID_';

/**
 * Dispatcher is used to broadcast payloads to registered callbacks. This is
 * different from generic pub-sub systems in two ways:
 *
 *   1) Callbacks are not subscribed to particular events. Every payload is
 *      dispatched to every registered callback.
 *   2) Callbacks can be deferred in whole or part until other callbacks have
 *      been executed.
 *
 * For example, consider this hypothetical flight destination form, which
 * selects a default city when a country is selected:
 *
 *   var flightDispatcher = new Dispatcher();
 *
 *   // Keeps track of which country is selected
 *   var CountryStore = {country: null};
 *
 *   // Keeps track of which city is selected
 *   var CityStore = {city: null};
 *
 *   // Keeps track of the base flight price of the selected city
 *   var FlightPriceStore = {price: null}
 *
 * When a user changes the selected city, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'city-update',
 *     selectedCity: 'paris'
 *   });
 *
 * This payload is digested by `CityStore`:
 *
 *   flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'city-update') {
 *       CityStore.city = payload.selectedCity;
 *     }
 *   });
 *
 * When the user selects a country, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'country-update',
 *     selectedCountry: 'australia'
 *   });
 *
 * This payload is digested by both stores:
 *
 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       CountryStore.country = payload.selectedCountry;
 *     }
 *   });
 *
 * When the callback to update `CountryStore` is registered, we save a reference
 * to the returned token. Using this token with `waitFor()`, we can guarantee
 * that `CountryStore` is updated before the callback that updates `CityStore`
 * needs to query its data.
 *
 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       // `CountryStore.country` may not be updated.
 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
 *       // `CountryStore.country` is now guaranteed to be updated.
 *
 *       // Select the default city for the new country
 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
 *     }
 *   });
 *
 * The usage of `waitFor()` can be chained, for example:
 *
 *   FlightPriceStore.dispatchToken =
 *     flightDispatcher.register(function(payload) {
 *       switch (payload.actionType) {
 *         case 'country-update':
 *         case 'city-update':
 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
 *           FlightPriceStore.price =
 *             getFlightPriceStore(CountryStore.country, CityStore.city);
 *           break;
 *     }
 *   });
 *
 * The `country-update` payload will be guaranteed to invoke the stores'
 * registered callbacks in order: `CountryStore`, `CityStore`, then
 * `FlightPriceStore`.
 */

var Dispatcher = (function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this._callbacks = {};
    this._isDispatching = false;
    this._isHandled = {};
    this._isPending = {};
    this._lastID = 1;
  }

  /**
   * Registers a callback to be invoked with every dispatched payload. Returns
   * a token that can be used with `waitFor()`.
   */

  Dispatcher.prototype.register = function register(callback) {
    var id = _prefix + this._lastID++;
    this._callbacks[id] = callback;
    return id;
  };

  /**
   * Removes a callback based on its token.
   */

  Dispatcher.prototype.unregister = function unregister(id) {
    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
    delete this._callbacks[id];
  };

  /**
   * Waits for the callbacks specified to be invoked before continuing execution
   * of the current callback. This method should only be used by a callback in
   * response to a dispatched payload.
   */

  Dispatcher.prototype.waitFor = function waitFor(ids) {
    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
    for (var ii = 0; ii < ids.length; ii++) {
      var id = ids[ii];
      if (this._isPending[id]) {
        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
        continue;
      }
      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
      this._invokeCallback(id);
    }
  };

  /**
   * Dispatches a payload to all registered callbacks.
   */

  Dispatcher.prototype.dispatch = function dispatch(payload) {
    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
    this._startDispatching(payload);
    try {
      for (var id in this._callbacks) {
        if (this._isPending[id]) {
          continue;
        }
        this._invokeCallback(id);
      }
    } finally {
      this._stopDispatching();
    }
  };

  /**
   * Is this Dispatcher currently dispatching.
   */

  Dispatcher.prototype.isDispatching = function isDispatching() {
    return this._isDispatching;
  };

  /**
   * Call the callback stored with the given id. Also do some internal
   * bookkeeping.
   *
   * @internal
   */

  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
    this._isPending[id] = true;
    this._callbacks[id](this._pendingPayload);
    this._isHandled[id] = true;
  };

  /**
   * Set up bookkeeping needed when dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
    for (var id in this._callbacks) {
      this._isPending[id] = false;
      this._isHandled[id] = false;
    }
    this._pendingPayload = payload;
    this._isDispatching = true;
  };

  /**
   * Clear bookkeeping used for dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
    delete this._pendingPayload;
    this._isDispatching = false;
  };

  return Dispatcher;
})();

module.exports = Dispatcher;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1508);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1508 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(87);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NotFoundError = exports.UnauthorisedError = exports.BadRequestError = exports.ServerError = exports.RequestError = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _API = __webpack_require__(201);

Object.defineProperty(exports, 'RequestError', {
    enumerable: true,
    get: function get() {
        return _API.RequestError;
    }
});
Object.defineProperty(exports, 'ServerError', {
    enumerable: true,
    get: function get() {
        return _API.ServerError;
    }
});
Object.defineProperty(exports, 'BadRequestError', {
    enumerable: true,
    get: function get() {
        return _API.BadRequestError;
    }
});
Object.defineProperty(exports, 'UnauthorisedError', {
    enumerable: true,
    get: function get() {
        return _API.UnauthorisedError;
    }
});
Object.defineProperty(exports, 'NotFoundError', {
    enumerable: true,
    get: function get() {
        return _API.NotFoundError;
    }
});

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _APIClient2 = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfigAPIClient = function (_APIClient) {
    (0, _inherits3.default)(ConfigAPIClient, _APIClient);

    function ConfigAPIClient() {
        (0, _classCallCheck3.default)(this, ConfigAPIClient);
        return (0, _possibleConstructorReturn3.default)(this, _APIClient.apply(this, arguments));
    }

    ConfigAPIClient.prototype.getHeaders = function getHeaders() {
        var headers = _APIClient.prototype.getHeaders.call(this);
        var configApiAccessToken = _config2.default.get('configApiAccessToken');
        if (configApiAccessToken) {
            return (0, _assign2.default)(headers, { 'x-access-token': configApiAccessToken });
        }
        return headers;
    };

    ConfigAPIClient.prototype.makeUrl = function makeUrl(path) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var configApiHost = _config2.default.get('configApiHost');
        if (configApiHost) {
            options = (0, _assign2.default)({}, options, {
                apiHost: configApiHost
            });
        }
        return _APIClient.prototype.makeUrl.call(this, path, options);
    };

    return ConfigAPIClient;
}(_APIClient2.APIClient);

exports.default = new ConfigAPIClient();

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(218);
__webpack_require__(216);
module.exports = __webpack_require__(1512);


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(136);
var get = __webpack_require__(501);
module.exports = __webpack_require__(49).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1514);
module.exports = __webpack_require__(49).Object.entries;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(69);
var $entries = __webpack_require__(782)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(49);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77),
    isPrototype = __webpack_require__(330),
    nativeKeysIn = __webpack_require__(1517);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1517 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1518 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _transform2 = __webpack_require__(1520);

var _transform3 = _interopRequireDefault(_transform2);

var _isPlainObject2 = __webpack_require__(523);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.trimPayload = trimPayload;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trimPayload(payload) {
    if ((0, _isPlainObject3.default)(payload)) {
        return (0, _transform3.default)(payload, function (result, value, key) {
            result[key] = trimPayload(value);
            return result;
        });
    } else if (Array.isArray(payload)) {
        return payload.map(function (item) {
            return trimPayload(item);
        });
    } else if ((0, _isString3.default)(payload)) {
        return payload.trim();
    } else {
        return payload;
    }
}

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(387),
    baseCreate = __webpack_require__(310),
    baseForOwn = __webpack_require__(220),
    baseIteratee = __webpack_require__(102),
    getPrototype = __webpack_require__(391),
    isArray = __webpack_require__(68),
    isBuffer = __webpack_require__(251),
    isFunction = __webpack_require__(202),
    isObject = __webpack_require__(77),
    isTypedArray = __webpack_require__(306);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _uuid = __webpack_require__(270);

var _uuid2 = _interopRequireDefault(_uuid);

var _LocalStorage = __webpack_require__(316);

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = 'trace-token';

function generateToken() {
    return _uuid2.default.v1().replace(/-/g, '');
}

var TraceToken = function () {
    function TraceToken() {
        (0, _classCallCheck3.default)(this, TraceToken);
        this.count = 0;

        var token = _LocalStorage2.default.getItem(STORAGE_KEY);
        var sessionToken = void 0,
            count = void 0;

        if (token) {
            var _token$split = token.split('-');

            sessionToken = _token$split[0];
            count = _token$split[1];
        }

        if (!sessionToken) {
            this.refresh();
        } else {
            this.sessionToken = sessionToken;
            this.count = count;
        }
    }

    TraceToken.prototype._store = function _store() {
        _LocalStorage2.default.setItem(STORAGE_KEY, this.sessionToken + '-' + this.count);
    };

    TraceToken.prototype.refresh = function refresh() {
        var sessionToken = generateToken();
        this.sessionToken = sessionToken;
        this.count = 0;
        this._store();
    };

    TraceToken.prototype.getToken = function getToken() {
        this.count++;
        this._store();
        return this.sessionToken + '-' + this.count;
    };

    return TraceToken;
}();

var instance = new TraceToken();

exports.default = instance;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(788);
var bytesToUuid = __webpack_require__(789);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(788);
var bytesToUuid = __webpack_require__(789);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1525);
var $Object = __webpack_require__(49).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(185);
var $getOwnPropertyDescriptor = __webpack_require__(506).f;

__webpack_require__(377)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1527), __esModule: true };

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(246);
__webpack_require__(218);
__webpack_require__(1528);
__webpack_require__(1532);
__webpack_require__(1533);
module.exports = __webpack_require__(49).WeakMap;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(82);
var each = __webpack_require__(525)(0);
var redefine = __webpack_require__(496);
var meta = __webpack_require__(303);
var assign = __webpack_require__(737);
var weak = __webpack_require__(1531);
var isObject = __webpack_require__(103);
var validate = __webpack_require__(256);
var NATIVE_WEAK_MAP = __webpack_require__(256);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(526)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1530);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(103);
var isArray = __webpack_require__(738);
var SPECIES = __webpack_require__(94)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(376);
var getWeak = __webpack_require__(303).getWeak;
var anObject = __webpack_require__(136);
var isObject = __webpack_require__(103);
var anInstance = __webpack_require__(375);
var forOf = __webpack_require__(249);
var createArrayMethod = __webpack_require__(525);
var $has = __webpack_require__(184);
var validate = __webpack_require__(256);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(527)('WeakMap');


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(528)('WeakMap');


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(790),
    hasIn = __webpack_require__(761);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(250),
    isArguments = __webpack_require__(304),
    isArray = __webpack_require__(68);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1538);
module.exports = __webpack_require__(49).Object.values;


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(69);
var $values = __webpack_require__(782)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1540 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1541 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1543);
module.exports = __webpack_require__(49).Number.isSafeInteger;


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(69);
var isInteger = __webpack_require__(1544);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(103);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(216);
__webpack_require__(1546);
module.exports = __webpack_require__(49).Array.from;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(164);
var $export = __webpack_require__(69);
var toObject = __webpack_require__(217);
var call = __webpack_require__(729);
var isArrayIter = __webpack_require__(730);
var toLength = __webpack_require__(372);
var createProperty = __webpack_require__(1547);
var getIterFn = __webpack_require__(501);

$export($export.S + $export.F * !__webpack_require__(736)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(135);
var createDesc = __webpack_require__(299);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(246);
__webpack_require__(216);
__webpack_require__(218);
__webpack_require__(1549);
__webpack_require__(1550);
__webpack_require__(1552);
__webpack_require__(1553);
module.exports = __webpack_require__(49).Set;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(797);
var validate = __webpack_require__(256);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(526)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(69);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(798)('Set') });


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(249);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(527)('Set');


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(528)('Set');


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1555);
var $Object = __webpack_require__(49).Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(377)('getOwnPropertyNames', function () {
  return __webpack_require__(739).f;
});


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1557);
module.exports = __webpack_require__(49).Object.getPrototypeOf;


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(217);
var $getPrototypeOf = __webpack_require__(727);

__webpack_require__(377)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(246);
__webpack_require__(216);
__webpack_require__(218);
__webpack_require__(1559);
__webpack_require__(1560);
__webpack_require__(1561);
__webpack_require__(1562);
module.exports = __webpack_require__(49).Map;


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(797);
var validate = __webpack_require__(256);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(526)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(69);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(798)('Map') });


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(527)('Map');


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(528)('Map');


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1565);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1566);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Declare internals

var internals = {};

exports.escapeJavaScript = function (input) {

    if (!input) {
        return '';
    }

    var escaped = '';

    for (var i = 0; i < input.length; ++i) {

        var charCode = input.charCodeAt(i);

        if (internals.isSafe(charCode)) {
            escaped += input[i];
        } else {
            escaped += internals.escapeJavaScriptChar(charCode);
        }
    }

    return escaped;
};

exports.escapeHtml = function (input) {

    if (!input) {
        return '';
    }

    var escaped = '';

    for (var i = 0; i < input.length; ++i) {

        var charCode = input.charCodeAt(i);

        if (internals.isSafe(charCode)) {
            escaped += input[i];
        } else {
            escaped += internals.escapeHtmlChar(charCode);
        }
    }

    return escaped;
};

exports.escapeJson = function (input) {

    if (!input) {
        return '';
    }

    var lessThan = 0x3C;
    var greaterThan = 0x3E;
    var andSymbol = 0x26;
    var lineSeperator = 0x2028;

    // replace method
    var charCode = void 0;
    return input.replace(/[<>&\u2028\u2029]/g, function (match) {

        charCode = match.charCodeAt(0);

        if (charCode === lessThan) {
            return '\\u003c';
        } else if (charCode === greaterThan) {
            return '\\u003e';
        } else if (charCode === andSymbol) {
            return '\\u0026';
        } else if (charCode === lineSeperator) {
            return '\\u2028';
        }
        return '\\u2029';
    });
};

internals.escapeJavaScriptChar = function (charCode) {

    if (charCode >= 256) {
        return '\\u' + internals.padLeft('' + charCode, 4);
    }

    var hexValue = new Buffer(String.fromCharCode(charCode), 'ascii').toString('hex');
    return '\\x' + internals.padLeft(hexValue, 2);
};

internals.escapeHtmlChar = function (charCode) {

    var namedEscape = internals.namedHtml[charCode];
    if (typeof namedEscape !== 'undefined') {
        return namedEscape;
    }

    if (charCode >= 256) {
        return '&#' + charCode + ';';
    }

    var hexValue = new Buffer(String.fromCharCode(charCode), 'ascii').toString('hex');
    return '&#x' + internals.padLeft(hexValue, 2) + ';';
};

internals.padLeft = function (str, len) {

    while (str.length < len) {
        str = '0' + str;
    }

    return str;
};

internals.isSafe = function (charCode) {

    return typeof internals.safeCharCodes[charCode] !== 'undefined';
};

internals.namedHtml = {
    '38': '&amp;',
    '60': '&lt;',
    '62': '&gt;',
    '34': '&quot;',
    '160': '&nbsp;',
    '162': '&cent;',
    '163': '&pound;',
    '164': '&curren;',
    '169': '&copy;',
    '174': '&reg;'
};

internals.safeCharCodes = function () {

    var safe = {};

    for (var i = 32; i < 123; ++i) {

        if (i >= 97 || // a-z
        i >= 65 && i <= 90 || // A-Z
        i >= 48 && i <= 57 || // 0-9
        i === 32 || // space
        i === 46 || // .
        i === 44 || // ,
        i === 45 || // -
        i === 58 || // :
        i === 95) {
            // _

            safe[i] = null;
        }
    }

    return safe;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(317).Buffer))

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1569);
module.exports = __webpack_require__(49).Number.isNaN;


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(69);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules


// Declare internals

var internals = {};

exports.errors = {
    root: 'value',
    key: '"{{!key}}" ',
    messages: {
        wrapArrays: true
    },
    any: {
        unknown: 'is not allowed',
        invalid: 'contains an invalid value',
        empty: 'is not allowed to be empty',
        required: 'is required',
        allowOnly: 'must be one of {{valids}}',
        default: 'threw an error when running default method'
    },
    alternatives: {
        base: 'not matching any of the allowed alternatives',
        child: null
    },
    array: {
        base: 'must be an array',
        includes: 'at position {{pos}} does not match any of the allowed types',
        includesSingle: 'single value of "{{!key}}" does not match any of the allowed types',
        includesOne: 'at position {{pos}} fails because {{reason}}',
        includesOneSingle: 'single value of "{{!key}}" fails because {{reason}}',
        includesRequiredUnknowns: 'does not contain {{unknownMisses}} required value(s)',
        includesRequiredKnowns: 'does not contain {{knownMisses}}',
        includesRequiredBoth: 'does not contain {{knownMisses}} and {{unknownMisses}} other required value(s)',
        excludes: 'at position {{pos}} contains an excluded value',
        excludesSingle: 'single value of "{{!key}}" contains an excluded value',
        min: 'must contain at least {{limit}} items',
        max: 'must contain less than or equal to {{limit}} items',
        length: 'must contain {{limit}} items',
        ordered: 'at position {{pos}} fails because {{reason}}',
        orderedLength: 'at position {{pos}} fails because array must contain at most {{limit}} items',
        ref: 'references "{{ref}}" which is not a positive integer',
        sparse: 'must not be a sparse array',
        unique: 'position {{pos}} contains a duplicate value'
    },
    boolean: {
        base: 'must be a boolean'
    },
    binary: {
        base: 'must be a buffer or a string',
        min: 'must be at least {{limit}} bytes',
        max: 'must be less than or equal to {{limit}} bytes',
        length: 'must be {{limit}} bytes'
    },
    date: {
        base: 'must be a number of milliseconds or valid date string',
        format: 'must be a string with one of the following formats {{format}}',
        strict: 'must be a valid date',
        min: 'must be larger than or equal to "{{limit}}"',
        max: 'must be less than or equal to "{{limit}}"',
        isoDate: 'must be a valid ISO 8601 date',
        timestamp: {
            javascript: 'must be a valid timestamp or number of milliseconds',
            unix: 'must be a valid timestamp or number of seconds'
        },
        ref: 'references "{{ref}}" which is not a date'
    },
    function: {
        base: 'must be a Function',
        arity: 'must have an arity of {{n}}',
        minArity: 'must have an arity greater or equal to {{n}}',
        maxArity: 'must have an arity lesser or equal to {{n}}',
        ref: 'must be a Joi reference'
    },
    lazy: {
        base: '!!schema error: lazy schema must be set',
        schema: '!!schema error: lazy schema function must return a schema'
    },
    object: {
        base: 'must be an object',
        child: '!!child "{{!child}}" fails because {{reason}}',
        min: 'must have at least {{limit}} children',
        max: 'must have less than or equal to {{limit}} children',
        length: 'must have {{limit}} children',
        allowUnknown: '!!"{{!child}}" is not allowed',
        with: '!!"{{mainWithLabel}}" missing required peer "{{peerWithLabel}}"',
        without: '!!"{{mainWithLabel}}" conflict with forbidden peer "{{peerWithLabel}}"',
        missing: 'must contain at least one of {{peersWithLabels}}',
        xor: 'contains a conflict between exclusive peers {{peersWithLabels}}',
        or: 'must contain at least one of {{peersWithLabels}}',
        and: 'contains {{presentWithLabels}} without its required peers {{missingWithLabels}}',
        nand: '!!"{{mainWithLabel}}" must not exist simultaneously with {{peersWithLabels}}',
        assert: '!!"{{ref}}" validation failed because "{{ref}}" failed to {{message}}',
        rename: {
            multiple: 'cannot rename child "{{from}}" because multiple renames are disabled and another key was already renamed to "{{to}}"',
            override: 'cannot rename child "{{from}}" because override is disabled and target "{{to}}" exists'
        },
        type: 'must be an instance of "{{type}}"',
        schema: 'must be a Joi instance'
    },
    number: {
        base: 'must be a number',
        min: 'must be larger than or equal to {{limit}}',
        max: 'must be less than or equal to {{limit}}',
        less: 'must be less than {{limit}}',
        greater: 'must be greater than {{limit}}',
        float: 'must be a float or double',
        integer: 'must be an integer',
        negative: 'must be a negative number',
        positive: 'must be a positive number',
        precision: 'must have no more than {{limit}} decimal places',
        ref: 'references "{{ref}}" which is not a number',
        multiple: 'must be a multiple of {{multiple}}'
    },
    string: {
        base: 'must be a string',
        min: 'length must be at least {{limit}} characters long',
        max: 'length must be less than or equal to {{limit}} characters long',
        length: 'length must be {{limit}} characters long',
        alphanum: 'must only contain alpha-numeric characters',
        token: 'must only contain alpha-numeric and underscore characters',
        regex: {
            base: 'with value "{{!value}}" fails to match the required pattern: {{pattern}}',
            name: 'with value "{{!value}}" fails to match the {{name}} pattern',
            invert: {
                base: 'with value "{{!value}}" matches the inverted pattern: {{pattern}}',
                name: 'with value "{{!value}}" matches the inverted {{name}} pattern'
            }
        },
        email: 'must be a valid email',
        uri: 'must be a valid uri',
        uriRelativeOnly: 'must be a valid relative uri',
        uriCustomScheme: 'must be a valid uri with a scheme matching the {{scheme}} pattern',
        isoDate: 'must be a valid ISO 8601 date',
        guid: 'must be a valid GUID',
        hex: 'must only contain hexadecimal characters',
        base64: 'must be a valid base64 string',
        hostname: 'must be a valid hostname',
        lowercase: 'must only contain lowercase characters',
        uppercase: 'must only contain uppercase characters',
        trim: 'must not have leading or trailing whitespace',
        creditCard: 'must be a credit card',
        ref: 'references "{{ref}}" which is not a number',
        ip: 'must be a valid ip address with a {{cidr}} CIDR',
        ipVersion: 'must be a valid ip address of one of the following versions {{version}} with a {{cidr}} CIDR'
    }
};

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load Modules

var RFC3986 = __webpack_require__(803);

// Declare internals

var internals = {
    Uri: {
        createUriRegex: function createUriRegex(optionalScheme, allowRelative, relativeOnly) {

            var scheme = RFC3986.scheme;
            var prefix = void 0;

            if (relativeOnly) {
                prefix = '(?:' + RFC3986.relativeRef + ')';
            } else {
                // If we were passed a scheme, use it instead of the generic one
                if (optionalScheme) {

                    // Have to put this in a non-capturing group to handle the OR statements
                    scheme = '(?:' + optionalScheme + ')';
                }

                var withScheme = '(?:' + scheme + ':' + RFC3986.hierPart + ')';

                prefix = allowRelative ? '(?:' + withScheme + '|' + RFC3986.relativeRef + ')' : withScheme;
            }

            /**
             * URI = scheme ":" hier-part [ "?" query ] [ "#" fragment ]
             *
             * OR
             *
             * relative-ref = relative-part [ "?" query ] [ "#" fragment ]
             */
            return new RegExp('^' + prefix + '(?:\\?' + RFC3986.query + ')?' + '(?:#' + RFC3986.fragment + ')?$');
        }
    }
};

module.exports = internals.Uri;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var RFC3986 = __webpack_require__(803);

// Declare internals

var internals = {
    Ip: {
        cidrs: {
            required: '\\/(?:' + RFC3986.cidr + ')',
            optional: '(?:\\/(?:' + RFC3986.cidr + '))?',
            forbidden: ''
        },
        versions: {
            ipv4: RFC3986.IPv4address,
            ipv6: RFC3986.IPv6address,
            ipvfuture: RFC3986.IPvFuture
        }
    }
};

internals.Ip.createIpRegex = function (versions, cidr) {

    var regex = void 0;
    for (var i = 0; i < versions.length; ++i) {
        var version = versions[i];
        if (!regex) {
            regex = '^(?:' + internals.Ip.versions[version];
        }
        regex = regex + '|' + internals.Ip.versions[version];
    }

    return new RegExp(regex + ')' + internals.Ip.cidrs[cidr] + '$');
};

module.exports = internals.Ip;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// Load modules

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dns = __webpack_require__(529);

// Declare internals

var internals = {
    hasOwn: Object.prototype.hasOwnProperty,
    indexOf: Array.prototype.indexOf,
    defaultThreshold: 16,
    maxIPv6Groups: 8,

    categories: {
        valid: 1,
        dnsWarn: 7,
        rfc5321: 15,
        cfws: 31,
        deprecated: 63,
        rfc5322: 127,
        error: 255
    },

    diagnoses: {

        // Address is valid

        valid: 0,

        // Address is valid, but the DNS check failed

        dnsWarnNoMXRecord: 5,
        dnsWarnNoRecord: 6,

        // Address is valid for SMTP but has unusual elements

        rfc5321TLD: 9,
        rfc5321TLDNumeric: 10,
        rfc5321QuotedString: 11,
        rfc5321AddressLiteral: 12,

        // Address is valid for message, but must be modified for envelope

        cfwsComment: 17,
        cfwsFWS: 18,

        // Address contains deprecated elements, but may still be valid in some contexts

        deprecatedLocalPart: 33,
        deprecatedFWS: 34,
        deprecatedQTEXT: 35,
        deprecatedQP: 36,
        deprecatedComment: 37,
        deprecatedCTEXT: 38,
        deprecatedIPv6: 39,
        deprecatedCFWSNearAt: 49,

        // Address is only valid according to broad definition in RFC 5322, but is otherwise invalid

        rfc5322Domain: 65,
        rfc5322TooLong: 66,
        rfc5322LocalTooLong: 67,
        rfc5322DomainTooLong: 68,
        rfc5322LabelTooLong: 69,
        rfc5322DomainLiteral: 70,
        rfc5322DomainLiteralOBSDText: 71,
        rfc5322IPv6GroupCount: 72,
        rfc5322IPv62x2xColon: 73,
        rfc5322IPv6BadCharacter: 74,
        rfc5322IPv6MaxGroups: 75,
        rfc5322IPv6ColonStart: 76,
        rfc5322IPv6ColonEnd: 77,

        // Address is invalid for any purpose

        errExpectingDTEXT: 129,
        errNoLocalPart: 130,
        errNoDomain: 131,
        errConsecutiveDots: 132,
        errATEXTAfterCFWS: 133,
        errATEXTAfterQS: 134,
        errATEXTAfterDomainLiteral: 135,
        errExpectingQPair: 136,
        errExpectingATEXT: 137,
        errExpectingQTEXT: 138,
        errExpectingCTEXT: 139,
        errBackslashEnd: 140,
        errDotStart: 141,
        errDotEnd: 142,
        errDomainHyphenStart: 143,
        errDomainHyphenEnd: 144,
        errUnclosedQuotedString: 145,
        errUnclosedComment: 146,
        errUnclosedDomainLiteral: 147,
        errFWSCRLFx2: 148,
        errFWSCRLFEnd: 149,
        errCRNoLF: 150,
        errUnknownTLD: 160,
        errDomainTooShort: 161
    },

    components: {
        localpart: 0,
        domain: 1,
        literal: 2,
        contextComment: 3,
        contextFWS: 4,
        contextQuotedString: 5,
        contextQuotedPair: 6
    }
};

// $lab:coverage:off$
internals.defer = typeof process !== 'undefined' && process && typeof process.nextTick === 'function' ? process.nextTick.bind(process) : function (callback) {

    return setTimeout(callback, 0);
};
// $lab:coverage:on$


internals.specials = function () {

    var specials = '()<>[]:;@\\,."'; // US-ASCII visible characters not valid for atext (http://tools.ietf.org/html/rfc5322#section-3.2.3)
    var lookup = new Array(0x100);
    for (var i = 0xff; i >= 0; --i) {
        lookup[i] = false;
    }

    for (var _i = 0; _i < specials.length; ++_i) {
        lookup[specials.charCodeAt(_i)] = true;
    }

    return function (code) {

        return lookup[code];
    };
}();

internals.regex = {
    ipV4: /\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipV6: /^[a-fA-F\d]{0,4}$/
};

internals.checkIpV6 = function (items) {

    return items.every(function (value) {
        return internals.regex.ipV6.test(value);
    });
};

internals.validDomain = function (tldAtom, options) {

    if (options.tldBlacklist) {
        if (Array.isArray(options.tldBlacklist)) {
            return internals.indexOf.call(options.tldBlacklist, tldAtom) === -1;
        }

        return !internals.hasOwn.call(options.tldBlacklist, tldAtom);
    }

    if (Array.isArray(options.tldWhitelist)) {
        return internals.indexOf.call(options.tldWhitelist, tldAtom) !== -1;
    }

    return internals.hasOwn.call(options.tldWhitelist, tldAtom);
};

/**
 * Check that an email address conforms to RFCs 5321, 5322 and others
 *
 * We distinguish clearly between a Mailbox as defined by RFC 5321 and an
 * addr-spec as defined by RFC 5322. Depending on the context, either can be
 * regarded as a valid email address. The RFC 5321 Mailbox specification is
 * more restrictive (comments, white space and obsolete forms are not allowed).
 *
 * @param {string} email The email address to check. See README for specifics.
 * @param {Object} options The (optional) options:
 *   {boolean} checkDNS If true then will check DNS for MX records. If
 *     true this call to isEmail _will_ be asynchronous.
 *   {*} errorLevel Determines the boundary between valid and invalid
 *     addresses.
 *   {*} tldBlacklist The set of domains to consider invalid.
 *   {*} tldWhitelist The set of domains to consider valid.
 *   {*} minDomainAtoms The minimum number of domain atoms which must be present
 *     for the address to be valid.
 * @param {function(number|boolean)} callback The (optional) callback handler.
 * @return {*}
 */

exports.validate = internals.validate = function (email, options, callback) {

    options = options || {};

    if (typeof options === 'function') {
        callback = options;
        options = {};
    }

    if (typeof callback !== 'function') {
        if (options.checkDNS) {
            throw new TypeError('expected callback function for checkDNS option');
        }

        callback = null;
    }

    var diagnose = void 0;
    var threshold = void 0;

    if (typeof options.errorLevel === 'number') {
        diagnose = true;
        threshold = options.errorLevel;
    } else {
        diagnose = !!options.errorLevel;
        threshold = internals.diagnoses.valid;
    }

    if (options.tldWhitelist) {
        if (typeof options.tldWhitelist === 'string') {
            options.tldWhitelist = [options.tldWhitelist];
        } else if ((0, _typeof3.default)(options.tldWhitelist) !== 'object') {
            throw new TypeError('expected array or object tldWhitelist');
        }
    }

    if (options.tldBlacklist) {
        if (typeof options.tldBlacklist === 'string') {
            options.tldBlacklist = [options.tldBlacklist];
        } else if ((0, _typeof3.default)(options.tldBlacklist) !== 'object') {
            throw new TypeError('expected array or object tldBlacklist');
        }
    }

    if (options.minDomainAtoms && (options.minDomainAtoms !== (+options.minDomainAtoms | 0) || options.minDomainAtoms < 0)) {
        throw new TypeError('expected positive integer minDomainAtoms');
    }

    var maxResult = internals.diagnoses.valid;
    var updateResult = function updateResult(value) {

        if (value > maxResult) {
            maxResult = value;
        }
    };

    var context = {
        now: internals.components.localpart,
        prev: internals.components.localpart,
        stack: [internals.components.localpart]
    };

    var prevToken = '';

    var parseData = {
        local: '',
        domain: ''
    };
    var atomData = {
        locals: [''],
        domains: ['']
    };

    var elementCount = 0;
    var elementLength = 0;
    var crlfCount = 0;
    var charCode = void 0;

    var hyphenFlag = false;
    var assertEnd = false;

    var emailLength = email.length;

    var token = void 0; // Token is used outside the loop, must declare similarly
    for (var i = 0; i < emailLength; ++i) {
        token = email[i];

        switch (context.now) {
            // Local-part
            case internals.components.localpart:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   local-part      =   dot-atom / quoted-string / obs-local-part
                //
                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
                //
                //   dot-atom-text   =   1*atext *("." 1*atext)
                //
                //   quoted-string   =   [CFWS]
                //                       DQUOTE *([FWS] qcontent) [FWS] DQUOTE
                //                       [CFWS]
                //
                //   obs-local-part  =   word *("." word)
                //
                //   word            =   atom / quoted-string
                //
                //   atom            =   [CFWS] 1*atext [CFWS]
                switch (token) {
                    // Comment
                    case '(':
                        if (elementLength === 0) {
                            // Comments are OK at the beginning of an element
                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsComment : internals.diagnoses.deprecatedComment);
                        } else {
                            updateResult(internals.diagnoses.cfwsComment);
                            // Cannot start a comment in an element, should be end
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // Next dot-atom element
                    case '.':
                        if (elementLength === 0) {
                            // Another dot, already?
                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
                        } else {
                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
                            if (assertEnd) {
                                updateResult(internals.diagnoses.deprecatedLocalPart);
                            }

                            // CFWS & quoted strings are OK again now we're at the beginning of an element (although they are obsolete forms)
                            assertEnd = false;
                            elementLength = 0;
                            ++elementCount;
                            parseData.local += token;
                            atomData.locals[elementCount] = '';
                        }

                        break;

                    // Quoted string
                    case '"':
                        if (elementLength === 0) {
                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
                            updateResult(elementCount === 0 ? internals.diagnoses.rfc5321QuotedString : internals.diagnoses.deprecatedLocalPart);

                            parseData.local += token;
                            atomData.locals[elementCount] += token;
                            ++elementLength;

                            // Quoted string must be the entire element
                            assertEnd = true;
                            context.stack.push(context.now);
                            context.now = internals.components.contextQuotedString;
                        } else {
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        }

                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        if (elementLength === 0) {
                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsFWS : internals.diagnoses.deprecatedFWS);
                        } else {
                            // We can't start FWS in the middle of an element, better be end
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    case '@':
                        // At this point we should have a valid local-part
                        // $lab:coverage:off$
                        if (context.stack.length !== 1) {
                            throw new Error('unexpected item on context stack');
                        }
                        // $lab:coverage:on$

                        if (parseData.local.length === 0) {
                            // Fatal error
                            updateResult(internals.diagnoses.errNoLocalPart);
                        } else if (elementLength === 0) {
                            // Fatal error
                            updateResult(internals.diagnoses.errDotEnd);
                        }
                        // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.1 the maximum total length of a user name or other local-part is 64
                        //    octets
                        else if (parseData.local.length > 64) {
                                updateResult(internals.diagnoses.rfc5322LocalTooLong);
                            }
                            // http://tools.ietf.org/html/rfc5322#section-3.4.1 comments and folding white space SHOULD NOT be used around "@" in the
                            //    addr-spec
                            //
                            // http://tools.ietf.org/html/rfc2119
                            // 4. SHOULD NOT this phrase, or the phrase "NOT RECOMMENDED" mean that there may exist valid reasons in particular
                            //    circumstances when the particular behavior is acceptable or even useful, but the full implications should be understood
                            //    and the case carefully weighed before implementing any behavior described with this label.
                            else if (context.prev === internals.components.contextComment || context.prev === internals.components.contextFWS) {
                                    updateResult(internals.diagnoses.deprecatedCFWSNearAt);
                                }

                        // Clear everything down for the domain parsing
                        context.now = internals.components.domain;
                        context.stack[0] = internals.components.domain;
                        elementCount = 0;
                        elementLength = 0;
                        assertEnd = false; // CFWS can only appear at the end of the element
                        break;

                    // ATEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
                        //            "!" / "#" /     ;  characters not including
                        //            "$" / "%" /     ;  specials.  Used for atoms.
                        //            "&" / "'" /
                        //            "*" / "+" /
                        //            "-" / "/" /
                        //            "=" / "?" /
                        //            "^" / "_" /
                        //            "`" / "{" /
                        //            "|" / "}" /
                        //            "~"
                        if (assertEnd) {
                            // We have encountered atext where it is no longer valid
                            switch (context.prev) {
                                case internals.components.contextComment:
                                case internals.components.contextFWS:
                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
                                    break;

                                case internals.components.contextQuotedString:
                                    updateResult(internals.diagnoses.errATEXTAfterQS);
                                    break;

                                // $lab:coverage:off$
                                default:
                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
                                // $lab:coverage:on$
                            }
                        } else {
                            context.prev = context.now;
                            charCode = token.charCodeAt(0);

                            // Especially if charCode == 10
                            if (charCode < 33 || charCode > 126 || internals.specials(charCode)) {

                                // Fatal error
                                updateResult(internals.diagnoses.errExpectingATEXT);
                            }

                            parseData.local += token;
                            atomData.locals[elementCount] += token;
                            ++elementLength;
                        }
                }

                break;

            case internals.components.domain:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   domain          =   dot-atom / domain-literal / obs-domain
                //
                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
                //
                //   dot-atom-text   =   1*atext *("." 1*atext)
                //
                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
                //
                //   dtext           =   %d33-90 /          ; Printable US-ASCII
                //                       %d94-126 /         ;  characters not including
                //                       obs-dtext          ;  "[", "]", or "\"
                //
                //   obs-domain      =   atom *("." atom)
                //
                //   atom            =   [CFWS] 1*atext [CFWS]

                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   Mailbox        = Local-part "@" ( Domain / address-literal )
                //
                //   Domain         = sub-domain *("." sub-domain)
                //
                //   address-literal  = "[" ( IPv4-address-literal /
                //                    IPv6-address-literal /
                //                    General-address-literal ) "]"
                //                    ; See Section 4.1.3

                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //      Note: A liberal syntax for the domain portion of addr-spec is
                //      given here.  However, the domain portion contains addressing
                //      information specified by and used in other protocols (e.g.,
                //      [RFC1034], [RFC1035], [RFC1123], [RFC5321]).  It is therefore
                //      incumbent upon implementations to conform to the syntax of
                //      addresses for the context in which they are used.
                //
                // is_email() author's note: it's not clear how to interpret this in
                // he context of a general email address validator. The conclusion I
                // have reached is this: "addressing information" must comply with
                // RFC 5321 (and in turn RFC 1035), anything that is "semantically
                // invisible" must comply only with RFC 5322.
                switch (token) {
                    // Comment
                    case '(':
                        if (elementLength === 0) {
                            // Comments at the start of the domain are deprecated in the text, comments at the start of a subdomain are obs-domain
                            // http://tools.ietf.org/html/rfc5322#section-3.4.1
                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedComment);
                        } else {
                            // We can't start a comment mid-element, better be at the end
                            assertEnd = true;
                            updateResult(internals.diagnoses.cfwsComment);
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // Next dot-atom element
                    case '.':
                        if (elementLength === 0) {
                            // Another dot, already? Fatal error.
                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
                        } else if (hyphenFlag) {
                            // Previous subdomain ended in a hyphen. Fatal error.
                            updateResult(internals.diagnoses.errDomainHyphenEnd);
                        } else if (elementLength > 63) {
                            // Nowhere in RFC 5321 does it say explicitly that the domain part of a Mailbox must be a valid domain according to the
                            // DNS standards set out in RFC 1035, but this *is* implied in several places. For instance, wherever the idea of host
                            // routing is discussed the RFC says that the domain must be looked up in the DNS. This would be nonsense unless the
                            // domain was designed to be a valid DNS domain. Hence we must conclude that the RFC 1035 restriction on label length
                            // also applies to RFC 5321 domains.
                            //
                            // http://tools.ietf.org/html/rfc1035#section-2.3.4
                            // labels          63 octets or less

                            updateResult(internals.diagnoses.rfc5322LabelTooLong);
                        }

                        // CFWS is OK again now we're at the beginning of an element (although
                        // it may be obsolete CFWS)
                        assertEnd = false;
                        elementLength = 0;
                        ++elementCount;
                        atomData.domains[elementCount] = '';
                        parseData.domain += token;

                        break;

                    // Domain literal
                    case '[':
                        if (parseData.domain.length === 0) {
                            // Domain literal must be the only component
                            assertEnd = true;
                            ++elementLength;
                            context.stack.push(context.now);
                            context.now = internals.components.literal;
                            parseData.domain += token;
                            atomData.domains[elementCount] += token;
                            parseData.literal = '';
                        } else {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        }

                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        if (elementLength === 0) {
                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedFWS);
                        } else {
                            // We can't start FWS in the middle of an element, so this better be the end
                            updateResult(internals.diagnoses.cfwsFWS);
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // This must be ATEXT
                    default:
                        // RFC 5322 allows any atext...
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
                        //            "!" / "#" /     ;  characters not including
                        //            "$" / "%" /     ;  specials.  Used for atoms.
                        //            "&" / "'" /
                        //            "*" / "+" /
                        //            "-" / "/" /
                        //            "=" / "?" /
                        //            "^" / "_" /
                        //            "`" / "{" /
                        //            "|" / "}" /
                        //            "~"

                        // But RFC 5321 only allows letter-digit-hyphen to comply with DNS rules
                        //   (RFCs 1034 & 1123)
                        // http://tools.ietf.org/html/rfc5321#section-4.1.2
                        //   sub-domain     = Let-dig [Ldh-str]
                        //
                        //   Let-dig        = ALPHA / DIGIT
                        //
                        //   Ldh-str        = *( ALPHA / DIGIT / "-" ) Let-dig
                        //
                        if (assertEnd) {
                            // We have encountered ATEXT where it is no longer valid
                            switch (context.prev) {
                                case internals.components.contextComment:
                                case internals.components.contextFWS:
                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
                                    break;

                                case internals.components.literal:
                                    updateResult(internals.diagnoses.errATEXTAfterDomainLiteral);
                                    break;

                                // $lab:coverage:off$
                                default:
                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
                                // $lab:coverage:on$
                            }
                        }

                        charCode = token.charCodeAt(0);
                        // Assume this token isn't a hyphen unless we discover it is
                        hyphenFlag = false;

                        if (charCode < 33 || charCode > 126 || internals.specials(charCode)) {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        } else if (token === '-') {
                            if (elementLength === 0) {
                                // Hyphens cannot be at the beginning of a subdomain, fatal error
                                updateResult(internals.diagnoses.errDomainHyphenStart);
                            }

                            hyphenFlag = true;
                        }
                        // Check if it's a neither a number nor a latin letter
                        else if (charCode < 48 || charCode > 122 || charCode > 57 && charCode < 65 || charCode > 90 && charCode < 97) {
                                // This is not an RFC 5321 subdomain, but still OK by RFC 5322
                                updateResult(internals.diagnoses.rfc5322Domain);
                            }

                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        ++elementLength;
                }

                break;

            // Domain literal
            case internals.components.literal:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
                //
                //   dtext           =   %d33-90 /          ; Printable US-ASCII
                //                       %d94-126 /         ;  characters not including
                //                       obs-dtext          ;  "[", "]", or "\"
                //
                //   obs-dtext       =   obs-NO-WS-CTL / quoted-pair
                switch (token) {
                    // End of domain literal
                    case ']':
                        if (maxResult < internals.categories.deprecated) {
                            // Could be a valid RFC 5321 address literal, so let's check

                            // http://tools.ietf.org/html/rfc5321#section-4.1.2
                            //   address-literal  = "[" ( IPv4-address-literal /
                            //                    IPv6-address-literal /
                            //                    General-address-literal ) "]"
                            //                    ; See Section 4.1.3
                            //
                            // http://tools.ietf.org/html/rfc5321#section-4.1.3
                            //   IPv4-address-literal  = Snum 3("."  Snum)
                            //
                            //   IPv6-address-literal  = "IPv6:" IPv6-addr
                            //
                            //   General-address-literal  = Standardized-tag ":" 1*dcontent
                            //
                            //   Standardized-tag  = Ldh-str
                            //                     ; Standardized-tag MUST be specified in a
                            //                     ; Standards-Track RFC and registered with IANA
                            //
                            //   dcontent      = %d33-90 / ; Printable US-ASCII
                            //                 %d94-126 ; excl. "[", "\", "]"
                            //
                            //   Snum          = 1*3DIGIT
                            //                 ; representing a decimal integer
                            //                 ; value in the range 0 through 255
                            //
                            //   IPv6-addr     = IPv6-full / IPv6-comp / IPv6v4-full / IPv6v4-comp
                            //
                            //   IPv6-hex      = 1*4HEXDIG
                            //
                            //   IPv6-full     = IPv6-hex 7(":" IPv6-hex)
                            //
                            //   IPv6-comp     = [IPv6-hex *5(":" IPv6-hex)] "::"
                            //                 [IPv6-hex *5(":" IPv6-hex)]
                            //                 ; The "::" represents at least 2 16-bit groups of
                            //                 ; zeros.  No more than 6 groups in addition to the
                            //                 ; "::" may be present.
                            //
                            //   IPv6v4-full   = IPv6-hex 5(":" IPv6-hex) ":" IPv4-address-literal
                            //
                            //   IPv6v4-comp   = [IPv6-hex *3(":" IPv6-hex)] "::"
                            //                 [IPv6-hex *3(":" IPv6-hex) ":"]
                            //                 IPv4-address-literal
                            //                 ; The "::" represents at least 2 16-bit groups of
                            //                 ; zeros.  No more than 4 groups in addition to the
                            //                 ; "::" and IPv4-address-literal may be present.

                            var index = -1;
                            var addressLiteral = parseData.literal;
                            var matchesIP = internals.regex.ipV4.exec(addressLiteral);

                            // Maybe extract IPv4 part from the end of the address-literal
                            if (matchesIP) {
                                index = matchesIP.index;
                                if (index !== 0) {
                                    // Convert IPv4 part to IPv6 format for futher testing
                                    addressLiteral = addressLiteral.slice(0, index) + '0:0';
                                }
                            }

                            if (index === 0) {
                                // Nothing there except a valid IPv4 address, so...
                                updateResult(internals.diagnoses.rfc5321AddressLiteral);
                            } else if (addressLiteral.slice(0, 5).toLowerCase() !== 'ipv6:') {
                                updateResult(internals.diagnoses.rfc5322DomainLiteral);
                            } else {
                                var match = addressLiteral.slice(5);
                                var maxGroups = internals.maxIPv6Groups;
                                var groups = match.split(':');
                                index = match.indexOf('::');

                                if (!~index) {
                                    // Need exactly the right number of groups
                                    if (groups.length !== maxGroups) {
                                        updateResult(internals.diagnoses.rfc5322IPv6GroupCount);
                                    }
                                } else if (index !== match.lastIndexOf('::')) {
                                    updateResult(internals.diagnoses.rfc5322IPv62x2xColon);
                                } else {
                                    if (index === 0 || index === match.length - 2) {
                                        // RFC 4291 allows :: at the start or end of an address with 7 other groups in addition
                                        ++maxGroups;
                                    }

                                    if (groups.length > maxGroups) {
                                        updateResult(internals.diagnoses.rfc5322IPv6MaxGroups);
                                    } else if (groups.length === maxGroups) {
                                        // Eliding a single "::"
                                        updateResult(internals.diagnoses.deprecatedIPv6);
                                    }
                                }

                                // IPv6 testing strategy
                                if (match[0] === ':' && match[1] !== ':') {
                                    updateResult(internals.diagnoses.rfc5322IPv6ColonStart);
                                } else if (match[match.length - 1] === ':' && match[match.length - 2] !== ':') {
                                    updateResult(internals.diagnoses.rfc5322IPv6ColonEnd);
                                } else if (internals.checkIpV6(groups)) {
                                    updateResult(internals.diagnoses.rfc5321AddressLiteral);
                                } else {
                                    updateResult(internals.diagnoses.rfc5322IPv6BadCharacter);
                                }
                            }
                        } else {
                            updateResult(internals.diagnoses.rfc5322DomainLiteral);
                        }

                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        ++elementLength;
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    case '\\':
                        updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        updateResult(internals.diagnoses.cfwsFWS);

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // DTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.4.1
                        //   dtext         =   %d33-90 /  ; Printable US-ASCII
                        //                     %d94-126 / ;  characters not including
                        //                     obs-dtext  ;  "[", "]", or "\"
                        //
                        //   obs-dtext     =   obs-NO-WS-CTL / quoted-pair
                        //
                        //   obs-NO-WS-CTL =   %d1-8 /    ; US-ASCII control
                        //                     %d11 /     ;  characters that do not
                        //                     %d12 /     ;  include the carriage
                        //                     %d14-31 /  ;  return, line feed, and
                        //                     %d127      ;  white space characters
                        charCode = token.charCodeAt(0);

                        // '\r', '\n', ' ', and '\t' have already been parsed above
                        if (charCode > 127 || charCode === 0 || token === '[') {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingDTEXT);
                            break;
                        } else if (charCode < 33 || charCode === 127) {
                            updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
                        }

                        parseData.literal += token;
                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        ++elementLength;
                }

                break;

            // Quoted string
            case internals.components.contextQuotedString:
                // http://tools.ietf.org/html/rfc5322#section-3.2.4
                //   quoted-string = [CFWS]
                //                   DQUOTE *([FWS] qcontent) [FWS] DQUOTE
                //                   [CFWS]
                //
                //   qcontent      = qtext / quoted-pair
                switch (token) {
                    // Quoted pair
                    case '\\':
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space. Spaces are allowed as regular characters inside a quoted string - it's only FWS if we include '\t' or '\r\n'
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case '\t':
                        // http://tools.ietf.org/html/rfc5322#section-3.2.2
                        //   Runs of FWS, comment, or CFWS that occur between lexical tokens in
                        //   a structured header field are semantically interpreted as a single
                        //   space character.

                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
                        //   the CRLF in any FWS/CFWS that appears within the quoted-string [is]
                        //   semantically "invisible" and therefore not part of the
                        //   quoted-string

                        parseData.local += ' ';
                        atomData.locals[elementCount] += ' ';
                        ++elementLength;

                        updateResult(internals.diagnoses.cfwsFWS);
                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // End of quoted string
                    case '"':
                        parseData.local += token;
                        atomData.locals[elementCount] += token;
                        ++elementLength;
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    // QTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
                        //   qtext          =   %d33 /             ; Printable US-ASCII
                        //                      %d35-91 /          ;  characters not including
                        //                      %d93-126 /         ;  "\" or the quote character
                        //                      obs-qtext
                        //
                        //   obs-qtext      =   obs-NO-WS-CTL
                        //
                        //   obs-NO-WS-CTL  =   %d1-8 /            ; US-ASCII control
                        //                      %d11 /             ;  characters that do not
                        //                      %d12 /             ;  include the carriage
                        //                      %d14-31 /          ;  return, line feed, and
                        //                      %d127              ;  white space characters
                        charCode = token.charCodeAt(0);

                        if (charCode > 127 || charCode === 0 || charCode === 10) {
                            updateResult(internals.diagnoses.errExpectingQTEXT);
                        } else if (charCode < 32 || charCode === 127) {
                            updateResult(internals.diagnoses.deprecatedQTEXT);
                        }

                        parseData.local += token;
                        atomData.locals[elementCount] += token;
                        ++elementLength;
                }

                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   If the string can be represented as a dot-atom (that is, it contains
                //   no characters other than atext characters or "." surrounded by atext
                //   characters), then the dot-atom form SHOULD be used and the quoted-
                //   string form SHOULD NOT be used.

                break;
            // Quoted pair
            case internals.components.contextQuotedPair:
                // http://tools.ietf.org/html/rfc5322#section-3.2.1
                //   quoted-pair     =   ("\" (VCHAR / WSP)) / obs-qp
                //
                //   VCHAR           =  %d33-126   ; visible (printing) characters
                //   WSP             =  SP / HTAB  ; white space
                //
                //   obs-qp          =   "\" (%d0 / obs-NO-WS-CTL / LF / CR)
                //
                //   obs-NO-WS-CTL   =   %d1-8 /   ; US-ASCII control
                //                       %d11 /    ;  characters that do not
                //                       %d12 /    ;  include the carriage
                //                       %d14-31 / ;  return, line feed, and
                //                       %d127     ;  white space characters
                //
                // i.e. obs-qp       =  "\" (%d0-8, %d10-31 / %d127)
                charCode = token.charCodeAt(0);

                if (charCode > 127) {
                    // Fatal error
                    updateResult(internals.diagnoses.errExpectingQPair);
                } else if (charCode < 31 && charCode !== 9 || charCode === 127) {
                    // ' ' and '\t' are allowed
                    updateResult(internals.diagnoses.deprecatedQP);
                }

                // At this point we know where this qpair occurred so we could check to see if the character actually needed to be quoted at all.
                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   the sending system SHOULD transmit the form that uses the minimum quoting possible.

                context.prev = context.now;
                // End of qpair
                context.now = context.stack.pop();
                token = '\\' + token;

                switch (context.now) {
                    case internals.components.contextComment:
                        break;

                    case internals.components.contextQuotedString:
                        parseData.local += token;
                        atomData.locals[elementCount] += token;

                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
                        elementLength += 2;
                        break;

                    case internals.components.literal:
                        parseData.domain += token;
                        atomData.domains[elementCount] += token;

                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
                        elementLength += 2;
                        break;

                    // $lab:coverage:off$
                    default:
                        throw new Error('quoted pair logic invoked in an invalid context: ' + context.now);
                    // $lab:coverage:on$
                }
                break;

            // Comment
            case internals.components.contextComment:
                // http://tools.ietf.org/html/rfc5322#section-3.2.2
                //   comment  = "(" *([FWS] ccontent) [FWS] ")"
                //
                //   ccontent = ctext / quoted-pair / comment
                switch (token) {
                    // Nested comment
                    case '(':
                        // Nested comments are ok
                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // End of comment
                    case ')':
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    // Quoted pair
                    case '\\':
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        updateResult(internals.diagnoses.cfwsFWS);

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // CTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //   ctext         = %d33-39 /  ; Printable US-ASCII
                        //                   %d42-91 /  ;  characters not including
                        //                   %d93-126 / ;  "(", ")", or "\"
                        //                   obs-ctext
                        //
                        //   obs-ctext     = obs-NO-WS-CTL
                        //
                        //   obs-NO-WS-CTL = %d1-8 /    ; US-ASCII control
                        //                   %d11 /     ;  characters that do not
                        //                   %d12 /     ;  include the carriage
                        //                   %d14-31 /  ;  return, line feed, and
                        //                   %d127      ;  white space characters
                        charCode = token.charCodeAt(0);

                        if (charCode > 127 || charCode === 0 || charCode === 10) {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingCTEXT);
                            break;
                        } else if (charCode < 32 || charCode === 127) {
                            updateResult(internals.diagnoses.deprecatedCTEXT);
                        }
                }

                break;

            // Folding white space
            case internals.components.contextFWS:
                // http://tools.ietf.org/html/rfc5322#section-3.2.2
                //   FWS     =   ([*WSP CRLF] 1*WSP) /  obs-FWS
                //                                   ; Folding white space

                // But note the erratum:
                // http://www.rfc-editor.org/errata_search.php?rfc=5322&eid=1908:
                //   In the obsolete syntax, any amount of folding white space MAY be
                //   inserted where the obs-FWS rule is allowed.  This creates the
                //   possibility of having two consecutive "folds" in a line, and
                //   therefore the possibility that a line which makes up a folded header
                //   field could be composed entirely of white space.
                //
                //   obs-FWS =   1*([CRLF] WSP)

                if (prevToken === '\r') {
                    if (token === '\r') {
                        // Fatal error
                        updateResult(internals.diagnoses.errFWSCRLFx2);
                        break;
                    }

                    if (++crlfCount > 1) {
                        // Multiple folds => obsolete FWS
                        updateResult(internals.diagnoses.deprecatedFWS);
                    } else {
                        crlfCount = 1;
                    }
                }

                switch (token) {
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                        }

                        break;

                    case ' ':
                    case '\t':
                        break;

                    default:
                        if (prevToken === '\r') {
                            // Fatal error
                            updateResult(internals.diagnoses.errFWSCRLFEnd);
                        }

                        crlfCount = 0;

                        // End of FWS
                        context.prev = context.now;
                        context.now = context.stack.pop();

                        // Look at this token again in the parent context
                        --i;
                }

                prevToken = token;
                break;

            // Unexpected context
            // $lab:coverage:off$
            default:
                throw new Error('unknown context: ' + context.now);
            // $lab:coverage:on$
        } // Primary state machine

        if (maxResult > internals.categories.rfc5322) {
            // Fatal error, no point continuing
            break;
        }
    } // Token loop

    // Check for errors
    if (maxResult < internals.categories.rfc5322) {
        // Fatal errors
        if (context.now === internals.components.contextQuotedString) {
            updateResult(internals.diagnoses.errUnclosedQuotedString);
        } else if (context.now === internals.components.contextQuotedPair) {
            updateResult(internals.diagnoses.errBackslashEnd);
        } else if (context.now === internals.components.contextComment) {
            updateResult(internals.diagnoses.errUnclosedComment);
        } else if (context.now === internals.components.literal) {
            updateResult(internals.diagnoses.errUnclosedDomainLiteral);
        } else if (token === '\r') {
            updateResult(internals.diagnoses.errFWSCRLFEnd);
        } else if (parseData.domain.length === 0) {
            updateResult(internals.diagnoses.errNoDomain);
        } else if (elementLength === 0) {
            updateResult(internals.diagnoses.errDotEnd);
        } else if (hyphenFlag) {
            updateResult(internals.diagnoses.errDomainHyphenEnd);
        }

        // Other errors
        else if (parseData.domain.length > 255) {
                // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.2
                //   The maximum total length of a domain name or number is 255 octets.
                updateResult(internals.diagnoses.rfc5322DomainTooLong);
            } else if (parseData.local.length + parseData.domain.length + /* '@' */1 > 254) {
                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   Forward-path   = Path
                //
                //   Path           = "<" [ A-d-l ":" ] Mailbox ">"
                //
                // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.3
                //   The maximum total length of a reverse-path or forward-path is 256 octets (including the punctuation and element separators).
                //
                // Thus, even without (obsolete) routing information, the Mailbox can only be 254 characters long. This is confirmed by this verified
                // erratum to RFC 3696:
                //
                // http://www.rfc-editor.org/errata_search.php?rfc=3696&eid=1690
                //   However, there is a restriction in RFC 2821 on the length of an address in MAIL and RCPT commands of 254 characters.  Since
                //   addresses that do not fit in those fields are not normally useful, the upper limit on address lengths should normally be considered
                //   to be 254.
                updateResult(internals.diagnoses.rfc5322TooLong);
            } else if (elementLength > 63) {
                // http://tools.ietf.org/html/rfc1035#section-2.3.4
                // labels   63 octets or less
                updateResult(internals.diagnoses.rfc5322LabelTooLong);
            } else if (options.minDomainAtoms && atomData.domains.length < options.minDomainAtoms) {
                updateResult(internals.diagnoses.errDomainTooShort);
            } else if (options.tldWhitelist || options.tldBlacklist) {
                var tldAtom = atomData.domains[elementCount];

                if (!internals.validDomain(tldAtom, options)) {
                    updateResult(internals.diagnoses.errUnknownTLD);
                }
            }
    } // Check for errors

    var dnsPositive = false;
    var finishImmediately = false;

    var finish = function finish() {

        if (!dnsPositive && maxResult < internals.categories.dnsWarn) {
            // Per RFC 5321, domain atoms are limited to letter-digit-hyphen, so we only need to check code <= 57 to check for a digit
            var code = atomData.domains[elementCount].charCodeAt(0);
            if (code <= 57) {
                updateResult(internals.diagnoses.rfc5321TLDNumeric);
            } else if (elementCount === 0) {
                updateResult(internals.diagnoses.rfc5321TLD);
            }
        }

        if (maxResult < threshold) {
            maxResult = internals.diagnoses.valid;
        }

        var finishResult = diagnose ? maxResult : maxResult < internals.defaultThreshold;

        if (callback) {
            if (finishImmediately) {
                callback(finishResult);
            } else {
                internals.defer(callback.bind(null, finishResult));
            }
        }

        return finishResult;
    }; // Finish

    if (options.checkDNS && maxResult < internals.categories.dnsWarn) {
        // http://tools.ietf.org/html/rfc5321#section-2.3.5
        //   Names that can be resolved to MX RRs or address (i.e., A or AAAA) RRs (as discussed in Section 5) are permitted, as are CNAME RRs whose
        //   targets can be resolved, in turn, to MX or address RRs.
        //
        // http://tools.ietf.org/html/rfc5321#section-5.1
        //   The lookup first attempts to locate an MX record associated with the name.  If a CNAME record is found, the resulting name is processed
        //   as if it were the initial name. ... If an empty list of MXs is returned, the address is treated as if it was associated with an implicit
        //   MX RR, with a preference of 0, pointing to that host.
        //
        // isEmail() author's note: We will regard the existence of a CNAME to be sufficient evidence of the domain's existence. For performance
        // reasons we will not repeat the DNS lookup for the CNAME's target, but we will raise a warning because we didn't immediately find an MX
        // record.
        if (elementCount === 0) {
            // Checking TLD DNS only works if you explicitly check from the root
            parseData.domain += '.';
        }

        var dnsDomain = parseData.domain;
        Dns.resolveMx(dnsDomain, function (err, mxRecords) {

            // If we have a fatal error, then we must assume that there are no records
            if (err && err.code !== Dns.NODATA) {
                updateResult(internals.diagnoses.dnsWarnNoRecord);
                return finish();
            }

            if (mxRecords && mxRecords.length) {
                dnsPositive = true;
                return finish();
            }

            var count = 3;
            var done = false;
            updateResult(internals.diagnoses.dnsWarnNoMXRecord);

            var handleRecords = function handleRecords(ignoreError, records) {

                if (done) {
                    return;
                }

                --count;

                if (records && records.length) {
                    done = true;
                    return finish();
                }

                if (count === 0) {
                    // No usable records for the domain can be found
                    updateResult(internals.diagnoses.dnsWarnNoRecord);
                    done = true;
                    finish();
                }
            };

            Dns.resolveCname(dnsDomain, handleRecords);
            Dns.resolve4(dnsDomain, handleRecords);
            Dns.resolve6(dnsDomain, handleRecords);
        });

        finishImmediately = true;
    } else {
        var result = finish();
        finishImmediately = true;
        return result;
    } // CheckDNS
};

exports.diagnoses = internals.validate.diagnoses = function () {

    var diag = {};
    var keys = (0, _keys2.default)(internals.diagnoses);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        diag[key] = internals.diagnoses[key];
    }

    return diag;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hoek = __webpack_require__(96);

// Declare internals

var internals = {};

exports = module.exports = internals.Topo = function () {

    this._items = [];
    this.nodes = [];
};

internals.Topo.prototype.add = function (nodes, options) {
    var _this = this;

    options = options || {};

    // Validate rules

    var before = [].concat(options.before || []);
    var after = [].concat(options.after || []);
    var group = options.group || '?';
    var sort = options.sort || 0; // Used for merging only

    Hoek.assert(before.indexOf(group) === -1, 'Item cannot come before itself:', group);
    Hoek.assert(before.indexOf('?') === -1, 'Item cannot come before unassociated items');
    Hoek.assert(after.indexOf(group) === -1, 'Item cannot come after itself:', group);
    Hoek.assert(after.indexOf('?') === -1, 'Item cannot come after unassociated items');

    [].concat(nodes).forEach(function (node, i) {

        var item = {
            seq: _this._items.length,
            sort: sort,
            before: before,
            after: after,
            group: group,
            node: node
        };

        _this._items.push(item);
    });

    // Insert event

    var error = this._sort();
    Hoek.assert(!error, 'item', group !== '?' ? 'added into group ' + group : '', 'created a dependencies error');

    return this.nodes;
};

internals.Topo.prototype.merge = function (others) {

    others = [].concat(others);
    for (var i = 0; i < others.length; ++i) {
        var other = others[i];
        if (other) {
            for (var j = 0; j < other._items.length; ++j) {
                var item = Hoek.shallow(other._items[j]);
                this._items.push(item);
            }
        }
    }

    // Sort items

    this._items.sort(internals.mergeSort);
    for (var _i = 0; _i < this._items.length; ++_i) {
        this._items[_i].seq = _i;
    }

    var error = this._sort();
    Hoek.assert(!error, 'merge created a dependencies error');

    return this.nodes;
};

internals.mergeSort = function (a, b) {

    return a.sort === b.sort ? 0 : a.sort < b.sort ? -1 : 1;
};

internals.Topo.prototype._sort = function () {

    // Construct graph

    var graph = {};
    var graphAfters = (0, _create2.default)(null); // A prototype can bungle lookups w/ false positives
    var groups = (0, _create2.default)(null);

    for (var i = 0; i < this._items.length; ++i) {
        var item = this._items[i];
        var seq = item.seq; // Unique across all items
        var group = item.group;

        // Determine Groups

        groups[group] = groups[group] || [];
        groups[group].push(seq);

        // Build intermediary graph using 'before'

        graph[seq] = item.before;

        // Build second intermediary graph with 'after'

        var after = item.after;
        for (var j = 0; j < after.length; ++j) {
            graphAfters[after[j]] = (graphAfters[after[j]] || []).concat(seq);
        }
    }

    // Expand intermediary graph

    var graphNodes = (0, _keys2.default)(graph);
    for (var _i2 = 0; _i2 < graphNodes.length; ++_i2) {
        var node = graphNodes[_i2];
        var expandedGroups = [];

        var graphNodeItems = (0, _keys2.default)(graph[node]);
        for (var _j = 0; _j < graphNodeItems.length; ++_j) {
            var _group = graph[node][graphNodeItems[_j]];
            groups[_group] = groups[_group] || [];

            for (var k = 0; k < groups[_group].length; ++k) {
                expandedGroups.push(groups[_group][k]);
            }
        }
        graph[node] = expandedGroups;
    }

    // Merge intermediary graph using graphAfters into final graph

    var afterNodes = (0, _keys2.default)(graphAfters);
    for (var _i3 = 0; _i3 < afterNodes.length; ++_i3) {
        var _group2 = afterNodes[_i3];

        if (groups[_group2]) {
            for (var _j2 = 0; _j2 < groups[_group2].length; ++_j2) {
                var _node = groups[_group2][_j2];
                graph[_node] = graph[_node].concat(graphAfters[_group2]);
            }
        }
    }

    // Compile ancestors

    var children = void 0;
    var ancestors = {};
    graphNodes = (0, _keys2.default)(graph);
    for (var _i4 = 0; _i4 < graphNodes.length; ++_i4) {
        var _node2 = graphNodes[_i4];
        children = graph[_node2];

        for (var _j3 = 0; _j3 < children.length; ++_j3) {
            ancestors[children[_j3]] = (ancestors[children[_j3]] || []).concat(_node2);
        }
    }

    // Topo sort

    var visited = {};
    var sorted = [];

    for (var _i5 = 0; _i5 < this._items.length; ++_i5) {
        var next = _i5;

        if (ancestors[_i5]) {
            next = null;
            for (var _j4 = 0; _j4 < this._items.length; ++_j4) {
                if (visited[_j4] === true) {
                    continue;
                }

                if (!ancestors[_j4]) {
                    ancestors[_j4] = [];
                }

                var shouldSeeCount = ancestors[_j4].length;
                var seenCount = 0;
                for (var _k = 0; _k < shouldSeeCount; ++_k) {
                    if (sorted.indexOf(ancestors[_j4][_k]) >= 0) {
                        ++seenCount;
                    }
                }

                if (seenCount === shouldSeeCount) {
                    next = _j4;
                    break;
                }
            }
        }

        if (next !== null) {
            next = next.toString(); // Normalize to string TODO: replace with seq
            visited[next] = true;
            sorted.push(next);
        }
    }

    if (sorted.length !== this._items.length) {
        return new Error('Invalid dependencies');
    }

    var seqIndex = {};
    for (var _i6 = 0; _i6 < this._items.length; ++_i6) {
        var _item = this._items[_i6];
        seqIndex[_item.seq] = _item;
    }

    var sortedNodes = [];
    this._items = sorted.map(function (value) {

        var sortedItem = seqIndex[value];
        sortedNodes.push(sortedItem.node);
        return sortedItem;
    });

    this.nodes = sortedNodes;
};

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Joi = __webpack_require__(62);

// Declare internals

var internals = {};

exports.options = Joi.object({
    abortEarly: Joi.boolean(),
    convert: Joi.boolean(),
    allowUnknown: Joi.boolean(),
    skipFunctions: Joi.boolean(),
    stripUnknown: [Joi.boolean(), Joi.object({ arrays: Joi.boolean(), objects: Joi.boolean() }).or('arrays', 'objects')],
    language: Joi.object(),
    presence: Joi.string().only('required', 'optional', 'forbidden', 'ignore'),
    raw: Joi.boolean(),
    context: Joi.object(),
    strip: Joi.boolean(),
    noDefaults: Joi.boolean()
}).strict();

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Any = __webpack_require__(137);
var Hoek = __webpack_require__(96);

// Declare internals

var internals = {};

internals.Lazy = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'lazy';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = { value: value };
        var lazy = this._flags.lazy;

        if (!lazy) {
            result.errors = this.createError('lazy.base', null, state, options);
            return result;
        }

        var schema = lazy();

        if (!(schema instanceof Any)) {
            result.errors = this.createError('lazy.schema', null, state, options);
            return result;
        }

        return schema._validate(value, state, options);
    };

    _class.prototype.set = function set(fn) {

        Hoek.assert(typeof fn === 'function', 'You must provide a function as first argument');

        var obj = this.clone();
        obj._flags.lazy = fn;
        return obj;
    };

    return _class;
}(Any);

module.exports = new internals.Lazy();

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _map = __webpack_require__(800);

var _map2 = _interopRequireDefault(_map);

var _isSafeInteger = __webpack_require__(257);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Any = __webpack_require__(137);
var Cast = __webpack_require__(318);
var Ref = __webpack_require__(153);
var Hoek = __webpack_require__(96);

// Declare internals

var internals = {};

internals.fastSplice = function (arr, i) {

    var pos = i;
    while (pos < arr.length) {
        arr[pos++] = arr[pos];
    }

    --arr.length;
};

internals.Array = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'array';
        _this._inner.items = [];
        _this._inner.ordereds = [];
        _this._inner.inclusions = [];
        _this._inner.exclusions = [];
        _this._inner.requireds = [];
        _this._flags.sparse = false;
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            internals.safeParse(value, result);
        }

        var isArray = Array.isArray(result.value);
        var wasArray = isArray;
        if (options.convert && this._flags.single && !isArray) {
            result.value = [result.value];
            isArray = true;
        }

        if (!isArray) {
            result.errors = this.createError('array.base', null, state, options);
            return result;
        }

        if (this._inner.inclusions.length || this._inner.exclusions.length || this._inner.requireds.length || this._inner.ordereds.length || !this._flags.sparse) {

            // Clone the array so that we don't modify the original
            if (wasArray) {
                result.value = result.value.slice(0);
            }

            result.errors = this._checkItems.call(this, result.value, wasArray, state, options);

            if (result.errors && wasArray && options.convert && this._flags.single) {

                // Attempt a 2nd pass by putting the array inside one.
                var previousErrors = result.errors;

                result.value = [result.value];
                result.errors = this._checkItems.call(this, result.value, wasArray, state, options);

                if (result.errors) {

                    // Restore previous errors and value since this didn't validate either.
                    result.errors = previousErrors;
                    result.value = result.value[0];
                }
            }
        }

        return result;
    };

    _class.prototype._checkItems = function _checkItems(items, wasArray, state, options) {

        var errors = [];
        var errored = void 0;

        var requireds = this._inner.requireds.slice();
        var ordereds = this._inner.ordereds.slice();
        var inclusions = this._inner.inclusions.concat(requireds);

        var il = items.length;
        for (var i = 0; i < il; ++i) {
            errored = false;
            var item = items[i];
            var isValid = false;
            var key = wasArray ? i : state.key;
            var path = wasArray ? (state.path ? state.path + '.' : '') + i : state.path;
            var localState = { key: key, path: path, parent: state.parent, reference: state.reference };
            var res = void 0;

            // Sparse

            if (!this._flags.sparse && item === undefined) {
                errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                if (options.abortEarly) {
                    return errors;
                }

                continue;
            }

            // Exclusions

            for (var j = 0; j < this._inner.exclusions.length; ++j) {
                res = this._inner.exclusions[j]._validate(item, localState, {}); // Not passing options to use defaults

                if (!res.errors) {
                    errors.push(this.createError(wasArray ? 'array.excludes' : 'array.excludesSingle', { pos: i, value: item }, { key: state.key, path: localState.path }, options));
                    errored = true;

                    if (options.abortEarly) {
                        return errors;
                    }

                    break;
                }
            }

            if (errored) {
                continue;
            }

            // Ordered
            if (this._inner.ordereds.length) {
                if (ordereds.length > 0) {
                    var ordered = ordereds.shift();
                    res = ordered._validate(item, localState, options);
                    if (!res.errors) {
                        if (ordered._flags.strip) {
                            internals.fastSplice(items, i);
                            --i;
                            --il;
                        } else if (!this._flags.sparse && res.value === undefined) {
                            errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                            if (options.abortEarly) {
                                return errors;
                            }

                            continue;
                        } else {
                            items[i] = res.value;
                        }
                    } else {
                        errors.push(this.createError('array.ordered', { pos: i, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
                        if (options.abortEarly) {
                            return errors;
                        }
                    }
                    continue;
                } else if (!this._inner.items.length) {
                    errors.push(this.createError('array.orderedLength', { pos: i, limit: this._inner.ordereds.length }, { key: state.key, path: localState.path }, options));
                    if (options.abortEarly) {
                        return errors;
                    }
                    continue;
                }
            }

            // Requireds

            var requiredChecks = [];
            var jl = requireds.length;
            for (var _j = 0; _j < jl; ++_j) {
                res = requiredChecks[_j] = requireds[_j]._validate(item, localState, options);
                if (!res.errors) {
                    items[i] = res.value;
                    isValid = true;
                    internals.fastSplice(requireds, _j);
                    --_j;
                    --jl;

                    if (!this._flags.sparse && res.value === undefined) {
                        errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                        if (options.abortEarly) {
                            return errors;
                        }
                    }

                    break;
                }
            }

            if (isValid) {
                continue;
            }

            // Inclusions

            var stripUnknown = options.stripUnknown ? options.stripUnknown === true ? true : !!options.stripUnknown.arrays : false;

            jl = inclusions.length;
            for (var _j2 = 0; _j2 < jl; ++_j2) {
                var inclusion = inclusions[_j2];

                // Avoid re-running requireds that already didn't match in the previous loop
                var previousCheck = requireds.indexOf(inclusion);
                if (previousCheck !== -1) {
                    res = requiredChecks[previousCheck];
                } else {
                    res = inclusion._validate(item, localState, options);

                    if (!res.errors) {
                        if (inclusion._flags.strip) {
                            internals.fastSplice(items, i);
                            --i;
                            --il;
                        } else if (!this._flags.sparse && res.value === undefined) {
                            errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));
                            errored = true;
                        } else {
                            items[i] = res.value;
                        }
                        isValid = true;
                        break;
                    }
                }

                // Return the actual error if only one inclusion defined
                if (jl === 1) {
                    if (stripUnknown) {
                        internals.fastSplice(items, i);
                        --i;
                        --il;
                        isValid = true;
                        break;
                    }

                    errors.push(this.createError(wasArray ? 'array.includesOne' : 'array.includesOneSingle', { pos: i, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
                    errored = true;

                    if (options.abortEarly) {
                        return errors;
                    }

                    break;
                }
            }

            if (errored) {
                continue;
            }

            if (this._inner.inclusions.length && !isValid) {
                if (stripUnknown) {
                    internals.fastSplice(items, i);
                    --i;
                    --il;
                    continue;
                }

                errors.push(this.createError(wasArray ? 'array.includes' : 'array.includesSingle', { pos: i, value: item }, { key: state.key, path: localState.path }, options));

                if (options.abortEarly) {
                    return errors;
                }
            }
        }

        if (requireds.length) {
            this._fillMissedErrors.call(this, errors, requireds, state, options);
        }

        if (ordereds.length) {
            this._fillOrderedErrors.call(this, errors, ordereds, state, options);
        }

        return errors.length ? errors : null;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);

        if (this._inner.ordereds.length) {
            description.orderedItems = [];

            for (var i = 0; i < this._inner.ordereds.length; ++i) {
                description.orderedItems.push(this._inner.ordereds[i].describe());
            }
        }

        if (this._inner.items.length) {
            description.items = [];

            for (var _i = 0; _i < this._inner.items.length; ++_i) {
                description.items.push(this._inner.items[_i].describe());
            }
        }

        return description;
    };

    _class.prototype.items = function items() {

        var obj = this.clone();

        Hoek.flatten(Array.prototype.slice.call(arguments)).forEach(function (type, index) {

            try {
                type = Cast.schema(type);
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = index + '.' + castErr.path;
                } else {
                    castErr.path = index;
                }
                castErr.message = castErr.message + '(' + castErr.path + ')';
                throw castErr;
            }

            obj._inner.items.push(type);

            if (type._flags.presence === 'required') {
                obj._inner.requireds.push(type);
            } else if (type._flags.presence === 'forbidden') {
                obj._inner.exclusions.push(type.optional());
            } else {
                obj._inner.inclusions.push(type);
            }
        });

        return obj;
    };

    _class.prototype.ordered = function ordered() {

        var obj = this.clone();

        Hoek.flatten(Array.prototype.slice.call(arguments)).forEach(function (type, index) {

            try {
                type = Cast.schema(type);
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = index + '.' + castErr.path;
                } else {
                    castErr.path = index;
                }
                castErr.message = castErr.message + '(' + castErr.path + ')';
                throw castErr;
            }
            obj._inner.ordereds.push(type);
        });

        return obj;
    };

    _class.prototype.min = function min(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('min', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!((0, _isSafeInteger2.default)(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length >= compareTo) {
                return value;
            }

            return this.createError('array.min', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('max', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!((0, _isSafeInteger2.default)(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length <= compareTo) {
                return value;
            }

            return this.createError('array.max', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.length = function length(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('length', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!((0, _isSafeInteger2.default)(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length === compareTo) {
                return value;
            }

            return this.createError('array.length', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.unique = function unique(comparator) {

        Hoek.assert(comparator === undefined || typeof comparator === 'function' || typeof comparator === 'string', 'comparator must be a function or a string');

        var settings = {};

        if (typeof comparator === 'string') {
            settings.path = comparator;
        } else if (typeof comparator === 'function') {
            settings.comparator = comparator;
        }

        return this._test('unique', settings, function (value, state, options) {

            var found = {
                string: {},
                number: {},
                undefined: {},
                boolean: {},
                object: new _map2.default(),
                function: new _map2.default(),
                custom: new _map2.default()
            };

            var compare = settings.comparator || Hoek.deepEqual;

            for (var i = 0; i < value.length; ++i) {
                var item = settings.path ? Hoek.reach(value[i], settings.path) : value[i];
                var records = settings.comparator ? found.custom : found[typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)];

                // All available types are supported, so it's not possible to reach 100% coverage without ignoring this line.
                // I still want to keep the test for future js versions with new types (eg. Symbol).
                if ( /* $lab:coverage:off$ */records /* $lab:coverage:on$ */) {
                        if (records instanceof _map2.default) {
                            var entries = records.entries();
                            var current = void 0;
                            while (!(current = entries.next()).done) {
                                if (compare(current.value[0], item)) {
                                    var localState = {
                                        key: state.key,
                                        path: (state.path ? state.path + '.' : '') + i,
                                        parent: state.parent,
                                        reference: state.reference
                                    };

                                    var context = {
                                        pos: i,
                                        value: value[i],
                                        dupePos: current.value[1],
                                        dupeValue: value[current.value[1]]
                                    };

                                    if (settings.path) {
                                        context.path = settings.path;
                                    }

                                    return this.createError('array.unique', context, localState, options);
                                }
                            }

                            records.set(item, i);
                        } else {
                            if (records[item] !== undefined) {
                                var _localState = {
                                    key: state.key,
                                    path: (state.path ? state.path + '.' : '') + i,
                                    parent: state.parent,
                                    reference: state.reference
                                };

                                var _context = {
                                    pos: i,
                                    value: value[i],
                                    dupePos: records[item],
                                    dupeValue: value[records[item]]
                                };

                                if (settings.path) {
                                    _context.path = settings.path;
                                }

                                return this.createError('array.unique', _context, _localState, options);
                            }

                            records[item] = i;
                        }
                    }
            }

            return value;
        });
    };

    _class.prototype.sparse = function sparse(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.sparse === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.sparse = value;
        return obj;
    };

    _class.prototype.single = function single(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.single === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.single = value;
        return obj;
    };

    _class.prototype._fillMissedErrors = function _fillMissedErrors(errors, requireds, state, options) {

        var knownMisses = [];
        var unknownMisses = 0;
        for (var i = 0; i < requireds.length; ++i) {
            var label = requireds[i]._getLabel();
            if (label) {
                knownMisses.push(label);
            } else {
                ++unknownMisses;
            }
        }

        if (knownMisses.length) {
            if (unknownMisses) {
                errors.push(this.createError('array.includesRequiredBoth', { knownMisses: knownMisses, unknownMisses: unknownMisses }, { key: state.key, path: state.path }, options));
            } else {
                errors.push(this.createError('array.includesRequiredKnowns', { knownMisses: knownMisses }, { key: state.key, path: state.path }, options));
            }
        } else {
            errors.push(this.createError('array.includesRequiredUnknowns', { unknownMisses: unknownMisses }, { key: state.key, path: state.path }, options));
        }
    };

    _class.prototype._fillOrderedErrors = function _fillOrderedErrors(errors, ordereds, state, options) {

        var requiredOrdereds = [];

        for (var i = 0; i < ordereds.length; ++i) {
            var presence = Hoek.reach(ordereds[i], '_flags.presence');
            if (presence === 'required') {
                requiredOrdereds.push(ordereds[i]);
            }
        }

        if (requiredOrdereds.length) {
            this._fillMissedErrors.call(this, errors, requiredOrdereds, state, options);
        }
    };

    return _class;
}(Any);

internals.safeParse = function (value, result) {

    try {
        var converted = JSON.parse(value);
        if (Array.isArray(converted)) {
            result.value = converted;
        }
    } catch (e) {}
};

module.exports = new internals.Array();

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Load modules

var _isSafeInteger = __webpack_require__(257);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Any = __webpack_require__(137);
var Hoek = __webpack_require__(96);

// Declare internals

var internals = {};

internals.Binary = function (_Any) {
    (0, _inherits3.default)(_class, _Any);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);

        var _this = (0, _possibleConstructorReturn3.default)(this, _Any.call(this));

        _this._type = 'binary';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            try {
                result.value = new Buffer(value, this._flags.encoding);
            } catch (e) {}
        }

        result.errors = Buffer.isBuffer(result.value) ? null : this.createError('binary.base', null, state, options);
        return result;
    };

    _class.prototype.encoding = function encoding(_encoding) {

        Hoek.assert(Buffer.isEncoding(_encoding), 'Invalid encoding:', _encoding);

        if (this._flags.encoding === _encoding) {
            return this;
        }

        var obj = this.clone();
        obj._flags.encoding = _encoding;
        return obj;
    };

    _class.prototype.min = function min(limit) {

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('min', limit, function (value, state, options) {

            if (value.length >= limit) {
                return value;
            }

            return this.createError('binary.min', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('max', limit, function (value, state, options) {

            if (value.length <= limit) {
                return value;
            }

            return this.createError('binary.max', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.length = function length(limit) {

        Hoek.assert((0, _isSafeInteger2.default)(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('length', limit, function (value, state, options) {

            if (value.length === limit) {
                return value;
            }

            return this.createError('binary.length', { limit: limit, value: value }, state, options);
        });
    };

    return _class;
}(Any);

module.exports = new internals.Binary();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(317).Buffer))

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports = {"_args":[["joi@10.6.0","/home/runner/work/booking-engine/booking-engine"]],"_from":"joi@10.6.0","_id":"joi@10.6.0","_inBundle":false,"_integrity":"sha512-hBF3LcqyAid+9X/pwg+eXjD2QBZI5eXnBFJYaAkH4SK3mp9QSRiiQnDYlmlz5pccMvnLcJRS4whhDOTCkmsAdQ==","_location":"/joi","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"joi@10.6.0","name":"joi","escapedName":"joi","rawSpec":"10.6.0","saveSpec":null,"fetchSpec":"10.6.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/joi/-/joi-10.6.0.tgz","_spec":"10.6.0","_where":"/home/runner/work/booking-engine/booking-engine","bugs":{"url":"https://github.com/hapijs/joi/issues"},"dependencies":{"hoek":"4.x.x","isemail":"2.x.x","items":"2.x.x","topo":"2.x.x"},"description":"Object schema validation","devDependencies":{"code":"4.x.x","hapitoc":"1.x.x","lab":"13.x.x"},"engines":{"node":">=4.0.0"},"homepage":"https://github.com/hapijs/joi","keywords":["hapi","schema","validation"],"license":"BSD-3-Clause","main":"lib/index.js","name":"joi","repository":{"type":"git","url":"git://github.com/hapijs/joi.git"},"scripts":{"test":"lab -t 100 -a code -L","test-cov-html":"lab -r html -o coverage.html -a code","test-debug":"lab -a code","toc":"hapitoc","version":"npm run toc && git add API.md README.md"},"version":"10.6.0"}

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(288);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1582)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1589);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1583), src$en$$ = __webpack_require__(1588);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(807), src$es5$$ = __webpack_require__(1584), src$compiler$$ = __webpack_require__(1585), intl$messageformat$parser$$ = __webpack_require__(1586);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(807);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1587)['default'];
exports['default'] = exports;


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1591)['default'];
exports['default'] = exports;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(1592);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _humanSize = __webpack_require__(1594);

var _humanSize2 = _interopRequireDefault(_humanSize);

var _AppConstants = __webpack_require__(6);

var _gatwick = __webpack_require__(533);

var _gatwick2 = _interopRequireDefault(_gatwick);

var _gatwickBa = __webpack_require__(1595);

var _gatwickBa2 = _interopRequireDefault(_gatwickBa);

var _gatwickRyanair = __webpack_require__(1596);

var _gatwickRyanair2 = _interopRequireDefault(_gatwickRyanair);

var _southeastern = __webpack_require__(1597);

var _southeastern2 = _interopRequireDefault(_southeastern);

var _southern = __webpack_require__(1598);

var _southern2 = _interopRequireDefault(_southern);

var _thameslink = __webpack_require__(1599);

var _thameslink2 = _interopRequireDefault(_thameslink);

var _greatnorthern = __webpack_require__(1600);

var _greatnorthern2 = _interopRequireDefault(_greatnorthern);

var _ontrackretail = __webpack_require__(1601);

var _ontrackretail2 = _interopRequireDefault(_ontrackretail);

var _ticketyboo = __webpack_require__(1602);

var _ticketyboo2 = _interopRequireDefault(_ticketyboo);

var _transpennine = __webpack_require__(1603);

var _transpennine2 = _interopRequireDefault(_transpennine);

var _trainhugger = __webpack_require__(1604);

var _trainhugger2 = _interopRequireDefault(_trainhugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dictionary of strings for the app. Uses ICU message syntax
 * http://userguide.icu-project.org/formatparse/messages
 */

var defaultMessages = new _immutable.Map({
    'global.none': 'None',
    'global.from': 'from',
    'global.start': 'Start',
    'global.end': 'End',
    'global.back': 'Back',
    'global.next': 'Next',
    'global.to': 'to',
    'global.go': 'Go',
    'global.leg': 'Leg',
    'global.select': 'Select',
    'global.selected': 'Selected',
    'global.and': 'and',
    'global.here': 'here',
    'global.moreInfo': 'More info',
    'global.lessInfo': 'Less info',
    'global.was': 'was',
    'global.loading': 'Loading...',
    'global.save': 'Save',
    'global.continue': 'Continue',
    'global.filters': 'Filters',
    'global.backToMainSite': 'Back to {brand} website',
    'global.banner.beta.logo.text': 'BETA',
    'global.banner.beta.text': 'We have updated the way you find and buy tickets.',
    'global.banner.beta.help': 'Need help?',
    'global.banner.existing': 'If you already have an account with us, please',
    'global.banner.dismiss': 'Dismiss',
    'global.banner.readmore': 'Read more',
    'global.banner.existing.reset': 'reset your password',
    'global.banner.existing.before': 'before {date}',
    'global.strike.message': "Tickets are not currently available online for these services due to industrial action - <a href='{moreInfo}' target='_blank'>more info</a>",
    'global.key': 'Key',
    'global.keyGo': 'keyGo',
    'global.theKey': 'The Key',
    'global.directions.outward': 'Outward',
    'global.directions.inward': 'Return',
    'global.smartcard': 'Smartcard',
    'global.smartcardUppercase': 'Smartcard',
    'global.smartcards': 'Smartcards',
    'global.smartcardTicket': 'Smartcard ticket',
    'global.smartcardTicketUppercase': 'Smartcard Ticket',
    'global.clickHere': 'click here',
    'global.clickFor': 'click for ',
    'global.clickToSelect': 'click to select',
    'global.clickForMoreInfo': 'click for more info',
    'global.clickToExpand': 'Click to expand',
    'global.clickToCollapse': 'Click to collapse',
    'global.searchFor': 'Search for',
    'global.passenger': 'Passenger',
    'global.adult': 'Adult',
    'global.child': 'Child',
    'global.externalLink': ' opens in a new window',
    'global.yes': 'Yes',
    'global.no': 'No',
    'global.showMore': 'Show more',
    'global.showLess': 'Show less',
    'global.gotIt': 'Got it',
    'global.timeDuration.ariaLabel': '{hours, plural, =0 {} =1 {# hour} other {# hours}} {minutes, plural, =0 {} =1 {# minute} other {# minutes}}',
    'global.timeDuration.fastest.ariaLabel': '{hours, plural, =0 {} =1 {# hour} other {# hours}} {minutes, plural, =0 {} =1 {# minute} other {# minutes}}. This is the fastest journey time displayed.',
    'global.step': 'Step',
    'global.stepCounter': '({currentStep}/{stepCount})',
    'global.stepCounter.aria': '<{global.step}> {currentStep} of {stepCount}.',

    'help.openReturn.title': 'What is an Open Return?',
    'help.openReturn.message': 'Open Returns are flexible tickets as you do not need to specify the exact time and date you want to return on. \nThe tickets are valid for one calendar month from the outward date printed.',
    'help.seasonTickets.custom.title': 'What is a Custom season ticket?',
    'help.seasonTickets.custom.message': 'You can select a specific end date or validity for your season ticket, for any period from one month to 10 months and 12 days. Tickets for longer than 10 months and 12 days are priced the same as the annual ticket.',
    'help.seasonTickets.flexi.title': 'What is a Flexi Season ticket?',
    'help.seasonTickets.flexi.message': 'Flexi Season tickets are valid for a 28-Day period and entitle you to 8 days of travelling between the stations specified, within that 28-Day period. \n If you make the same journey twice a week you will find that, on most routes, Flexi Season tickets offer better value for money compared to buying daily tickets. \n You can travel at peak and off peak times, and you don’t need to tell us in advance what days you plan to travel. \n You must activate a day’s worth of travel in your Flexi Season before you board a train service. \n Flexi Season tickets can be purchased online and at some ticket offices.',
    'help.seasonTickets.flexi.moreInfo': 'Learn more about {moreInfoLink}',
    'help.seasonTickets.flexi.moreInfo.link.text': 'Flexi Season tickets',
    'help.seasonTickets.flexi.moreInfo.link.aria': 'Learn more about Flexi Season tickets',
    'help.railcard1617.title': 'What is 16/17 Saver?',
    'help.railcardJobCentrePlus.title': 'What is a Jobcentre Plus railcard?',
    'help.railcard1617.message': '<p>If you are 16 to 17 years old you may be eligible for the 16-17 Saver railcard. If you have a valid 16-17 Saver railcard you can take advantage of 50% discounted travel.</p><p>Please ensure you carry your valid railcard with you to avoid being charged a penalty fare.</p><p>For more information, please <a href="{railcard1617WebsiteUrl}" target="_blank">click here</a>.</p>',
    'help.jobcentreplus.message': '<p>This is provided to those unemployed claiming Jobseekers Allowance or Universal Credit for 3-9 months (18-24 year olds) or 3-12 months (over 25s).</p><p>Other benefit recipients may receive a Jobcentre Plus Travel Discount Card from 3 months of their claim and if they are actively engaged with a Jobcentre Plus adviser. Cardholders are entitled to a 50% discount on selected rail tickets.</p>',
    'help.jobcentreplus.validityInfo': 'Only valid for Flexi Season tickets',

    'help.tocSpecific.title': 'Search for the cheapest {toc} fares',
    'help.tocSpecific.message': "<p>You can search for the cheapest {toc} fares available for your selected journey by choosing '<{booking.operator.specifictoc}>'.</p><p>Alternatively, where multiple operators serve your selected journey, you can view all available fares by choosing '<{booking.operator.all}>'.</p>",

    'notifications.accountActions.text': 'Account Actions',
    'notifications.accountActions.title': 'You have multiple account actions available',
    'notifications.keyGoIncompleteJourney.text': 'account.smartcard.keygo.incompleteJourneys.heading',
    'notifications.brandSplit.header': 'Select the network you travel on',
    'notifications.brandSplit.description': 'Select the network you travel on',
    'notifications.keyGoCardExpire.title': 'account.smartcard.keygo.cardExpire.heading',
    'notifications.keyGoCardExpire.description': 'Update your payment details now to continue using <{global.keyGo}>',
    'notifications.railcard.applicationSubmitted': 'Your railcard application has been submitted.\nWe aim to review this within 5 working days.',
    'notifications.railcard.deleted': 'Please note – this railcard entitlement will now be removed from your account',
    'notifications.pa-request.canceled': 'Passenger Assist request canceled',
    'notifications.pa-request.updated': 'Passenger Assist request updated',
    'notifications.accessibility-profile.created': 'Accessibility profile created',
    'notifications.accessibility-profile.updated': 'Accessibility profile updated',
    'notifications.accessibility-profile.deleted': 'Accessibility profile deleted',

    'pageTitles.default': 'app.owner',
    'pageTitles.point-search': 'Find train tickets',
    'pageTitles.season-search': 'Find season tickets',
    'pageTitles.other-search': 'Find other tickets',
    'pageTitles.daysave-search': 'Find DaySave tickets',
    'pageTitles.roversrangers-search': 'Find Rover tickets',
    'pageTitles.season-results': 'season.results.heading',
    'pageTitles.season-details': 'season.photocard.header',
    'pageTitles.daysave-results': 'daySave.results.heading',
    'pageTitles.roversrangers-results': 'roversRangers.results.heading',
    'pageTitles.delivery': 'booking.delivery.header',
    'pageTitles.payment': 'booking.payment.header',
    'pageTitles.payment-confirmation': 'Payment successful',
    'pageTitles.account': 'nav.myaccount',
    'pageTitles.account-menu': 'pageTitles.account',
    'pageTitles.account-payment': 'account.nav.paymentdetails',
    'pageTitles.account-addresses': 'account.nav.addresses',
    'pageTitles.account-ordersrefunds': 'account.nav.orders-refunds',
    'pageTitles.account-orderdetails': 'Order details',
    'pageTitles.account-refunddetails': 'Refund options',
    'pageTitles.account-photocards-railcards': 'account.nav.photocards-railcards',
    'pageTitles.account-smart-carnet': 'account.nav.smart-carnet',
    'pageTitles.account-disruption-alerts': 'account.nav.disruptionAlerts',
    'pageTitles.account-reservation': 'account.nav.reservation',
    'pageTitles.smartcard-apply': 'account.nav.smartcard',
    'pageTitles.smartcard-tickets': '<{global.theKey}> <{global.smartcard}> - tickets',
    'pageTitles.smartcard-history': '<{global.theKey}> <{global.smartcard}> - journey history',
    'pageTitles.smartcard-keygo': '<{global.theKey}> <{global.smartcard}> - <{global.keyGo}> account',
    'pageTitles.smartcard-replacement': '<{global.theKey}> <{global.smartcard}> - replacement',
    'pageTitles.smartcard-transfer': 'account.heading.smartcard.transfer',
    'pageTitles.smartcard-transfer-results': 'account.heading.smartcard.transfer',
    'pageTitles.smartcard-transfer-confirmation': 'account.heading.smartcard.transfer',
    'pageTitles.evouchers': 'account.nav.evouchers',
    'pageTitles.disruption-alerts': 'account.nav.disruptionAlerts',
    'pageTitles.newsletter-unsubscribe': 'Unsubscribe',
    'pageTitles.auto-dr-claims': 'One Click Delay Repay',
    'pageTitles.se.main.page': 'Buy tickets with no fees!',

    'notifications.basket.cleared': 'Basket cleared successfully',
    'notifications.basket.itemAdded': 'Journey added to basket',
    'notifications.basket.itemDeleted': 'Journey removed from basket',

    'app.owner': 'Thameslink Railway',
    'app.owner.short': 'Thameslink',
    'app.owner.appName': 'Thameslink',

    // Used for <time></time> datetime attribute
    'time.duration': 'PT{hours}H {minutes}M',

    'time.minutes.short': '{minutes}m',
    'time.hours.short': '{hours}hr',

    'time.minutes.medium': '{minutes, plural, =1{min} other {#mins}}',
    'time.hours.medium': '{hours, plural, =1{hr} other {#hrs}}',

    'time.minutes.long': '{minutes, plural, =1 {1 minute} other {# minutes}}',
    'time.hours.long': '{hours, plural, =1 {1 hour} other {# hours}}',
    'time.days.long': '{days, plural, =1 {1 day} other {# days}}',
    'time.months': '{months} {months, plural, =1{month} other{months}}',

    'time.minutes.late': '{minutes} mins late',

    'booking.search.show': 'Show',
    'booking.search.point': 'Find trains',
    'booking.search.season': 'Show tickets',
    'booking.search.other': 'Show tickets',
    'booking.search.earlier': 'Show earlier',
    'booking.search.later': 'Show later',
    'booking.search.earlier.short': 'Earlier',
    'booking.search.later.short': 'Later',
    'booking.search.earlierLater.label': 'Show {period, select, earlier {earlier} other {later}} trains',
    'booking.search.hiddenServices': '{ticketName} is not available on {count} services.',
    'booking.search.showHiddenServices': 'Show',
    'booking.search.hideInvalidServices': 'Hide',
    'booking.search.departNowLabel': 'Depart now',
    'booking.search.journey-notification.modal.title': 'Service Information for your journey',

    'brand.split.header': 'Your network',
    'brand.split.text': 'Select the network you travel on below:',
    'brand.split.success': 'Selection successful',
    'brand.split.message': 'Your account has now been updated to be associated with',

    'skipToContent': 'Skip to content',

    'nav.heading': 'Book your tickets',
    'nav.pointTickets': 'Tickets',
    'nav.seasonTickets': 'Season tickets',
    'nav.otherTickets': 'Other tickets',
    'nav.welcome': 'Welcome back, {name}',
    'nav.myaccount': 'My account',

    'info.title': 'Information',

    'error.title': 'Error',
    'error.general.title': 'We are very sorry.',
    'error.general.message': 'An unknown error occurred when trying to complete your request. Please try again and if you still see this message - please contact us.',

    'error.smartcard.heading': '<{global.smartcardUppercase}> Error',
    'error.smartcard.title': '<{global.smartcardUppercase}> not available',
    'error.smartcard.message': 'An unknown error occurred when loading details for your <{global.key}> <{global.smartcard}>. Some <{global.smartcard}> functions will not be available. This may be a temporary problem. Please contact us if the problems persist.',

    'error.submit-railcard-application.message': 'An error occurred when trying to submit your railcard application. Please try again and if you still see this message - please contact us.',
    'error.railcardNotFound.title': 'Railcard not found',
    'error.railcardAlreadyExist.heading': 'Railcard registration error',
    'error.railcardAlreadyExist.title': 'Railcard already exists',
    'error.railcardAlreadyExist.message': 'The railcard you are trying to register already exists. Please check your details and try again.',

    'error.remove-railcard.message': 'An error occurred when trying to remove your railcard. Please try again and if you still see this message - please contact us.',

    'booking.ticket': 'Ticket',
    'booking.tickets': 'Tickets',
    'booking.toggle.paperRadio': 'Paper ticket fares',
    'booking.toggle.keyRadio': '<{global.key}> <{global.smartcard}> fares',
    'booking.smartcard.info': 'Buying a ticket for the <{global.key}> <{global.smartcard}>? ',
    'booking.smartcard.info.header': 'An easier way to use your <{global.key}> <{global.smartcard}>!',
    'booking.smartcard.info.body': 'When buying Season tickets, you no longer need to select <{global.key}> <{global.smartcard}> fares in advance. Just enter your route as normal, select the ticket you need, and your <{global.key}> <{global.smartcard}> will be offered as a delivery option if available.',
    'booking.smartcard.passenger.adult': 'One adult',
    'booking.smartcard.passenger.child': 'One child',
    'booking.smartcard.railcard': 'Railcard',
    'booking.smartcard.info.awaitingProductMinOffset': 'During preload period, you can only search for tickets for one adult and starting after {date}, to ensure that you receive them in time for your journey',
    'booking.smartcard.warning.cardFull': 'You have reached the maximum {count, plural, =3 {of three} =5 {of five} other {number of}} tickets. ',
    'booking.smartcard.warning.cannotLoadProduct': 'You\'re not able to purchase any further <{global.key}> <{global.smartcard}> tickets until your previous purchase has been loaded onto your card. ',
    'booking.smartcard.moreInformation': 'More information',
    'booking.smartcard.warning.downForMaintenance': 'Due to essential maintenance, it is currently not possible to purchase a <{global.key}> <{global.smartcardTicket}>. Please try again later.',

    'booking.addons.travelcard': 'Travelcard',
    'booking.addons.plusbus': 'PlusBus',
    'booking.addons.plusbus.outwardJourney': 'Outbound journey',
    'booking.addons.plusbus.returnJourney': 'Return journey',
    'booking.addons.plusbus.info': "{plusBusLink} gives you unlimited bus and tram* travel on participating operators' services around the whole urban area of your selected stations. The prices shown cover PlusBus travel for ALL passengers.",
    'booking.addons.plusbus.select.sr': 'Press to add or remove Plusbus on your journey',
    'booking.addons.plusbus.footnotes': '* where tram services are available and operators participate in the PlusBus scheme',

    'booking.info.payg': 'Pay As You Go',
    'booking.info.payg.intro': 'Pay as you go is a convenient way to pay for your travel in and around London on most National Rail, bus, Tube, tram and DLR services. Pay as you go is available with an Oyster card or when using contactless.',
    'booking.info.payg.oyster-card-fare': '<p><b>The Oyster card fare for the journey currently selected would be £{price}</b></p>',
    'booking.info.payg.oyster.title': 'Oyster',
    'booking.info.payg.oyster.summary': 'You can use Oyster Pay As You Go on all suburban trains stopping in Zones 1 – 9',
    'booking.info.payg.oyster.bullets': 'Daily capping of fares\n                                            Set up Auto top-up so you never run out of credit\n                                            Add Railcard or Annual Gold Card discounts\n                                            Get Child or Student discounts with an Oyster photocard\n                                            Add Season tickets and Travelcards for more than one day of travel',
    'booking.info.payg.oyster.link': 'Contactless and Oyster - find out more',
    'booking.info.payg.contactless.title': 'Contactless',
    'booking.info.payg.contactless.summary': 'Use contactless debit/credit cards or mobile payments for pay as you go travel',
    'booking.info.payg.contactless.bullets': 'Same Adult fare as Oyster\n                                                No need to top-up\n                                                Daily capping of fares\n                                                Monday to Sunday capping of fares\n                                                Please note: No Child, Railcard, Annual Gold Card, or concessionary discounts apply',
    'booking.info.payg.contactless.link': 'Contactless - find out more',

    'booking.loading.results': 'Loading trains and fares...',
    'booking.loading.callingPoints': 'Loading calling points...',
    'booking.loading.addons': 'Checking available extras...',

    'booking.noResults.header': 'Sorry, we couldn’t find a journey that matched:',
    'booking.noResults.searchDescriptionVia': '{departureStation} to {arrivalStation} via {viaStation}',
    'booking.noResults.searchDescriptionAvoid': '{departureStation} to {arrivalStation} avoiding {avoidStation}',
    'booking.noResults.searchDescription': '{departureStation} to {arrivalStation}',
    'booking.noResults.text': 'Please try another search, or contact us for more information.',
    'booking.noResults.tryAnother': 'Try another search',
    'booking.noResults.singles': 'singles',
    'booking.noResults.dayReturns': 'day returns',
    'booking.noResults.seeSinglesOrReturns': 'There are no open returns available on this route / date. Would you like to see {singles} or {returns} instead?',
    'booking.noResults.isInFlexiLimbo': 'Searching for the new Flexi Season? Make sure you search from the 28th June onwards to get the full details and fares.',

    'booking.incompleteResults.noReturns': 'Sorry, there are no return journeys available for the following search:',
    'booking.incompleteResults.pleaseTryDifferentDateTime': 'Please try another search using a different return date / time, or contact us for more information.',

    'booking.select.outward.time': 'Select an outward time',
    'booking.select.inward.time': 'Select a return time',
    'booking.select.outward.fare': 'Select an outward fare',
    'booking.select.inward.fare': 'Select a return fare',

    'booking.ticketType.single': 'Single',
    'booking.ticketType.return': 'Return',
    'booking.ticketType.openReturn': 'Open return',
    'booking.ticketType.remove-return': 'No return',

    'booking.promotion.pinCode': 'Pin Code',
    'booking.promotion.invalidPin': 'Sorry that pin code was incorrect',
    'booking.promotion.helpText': 'Please enter your pin code in order to plan your journey',
    'booking.promoCode.applied': 'Code {promoCode} applied',
    'booking.promoCode.terms.header': 'Promotional discount',
    'booking.promoCode.delivery.notAvailable': 'Unfortunately, your discount code is not valid with this ticket collection method',
    'booking.promoCode.delivery.option.notAvailable': 'If you select this delivery method, your chosen discount code cannot be applied, and you will be charged the full price for your tickets.',
    'booking.promoCode.input.aria': 'No discount code applied, tap to input discount code',
    'booking.promoCode.theSame.discount.error': 'This promo code has already been used for one of the journeys in your current order',
    'booking.promoCode.one.discount.error': 'Only one discount can be used per order',
    'booking.promoCode.generic.error': 'There was an error applying your discount code, please try again later',
    'booking.promoCode.char.limit.error': 'Discount code should be a maximum of 20 characters',

    'promotion.tocFamily.subheading': 'Log in',
    'promotion.tocFamily.text': 'Enter your work or assigned email address to receive a magic login link and access the site.',
    'promotion.tocFamily.email.label': 'Email Address',
    'promotion.tocFamily.email.placeholder': 'Enter your email address',
    'promotion.tocFamily.button.sr': 'Request login link',
    'promotion.tocFamily.button.text': 'Submit',
    'promotion.tocFamily.button.progress': 'Sending...',
    'promotion.tocFamily.success.text': 'Please check your email for your login link.',
    'promotion.tocFamily.success.subtext': 'You will be able to request a new magic link again in 2 minutes.',
    'promotion.tocFamily.success.countdown': 'Time remaining: {countdown}',
    'promotion.tocFamily.error': 'Failed to send login link. Please try again',
    'promotion.tocFamily.error.invalidEmail': 'Invalid email, please contact {toc}',
    'promotion.tocFamily.verify.title': 'Closed User Group Terms & Conditions',
    'promotion.tocFamily.verify.availableTickets': 'You have {count} tickets available to purchase',
    'promotion.tocFamily.verify.terms': 'As a member of our Closed User Group, you have access to exclusive ticket offers. By accepting these terms, you acknowledge that these tickets are for personal use only and cannot be resold. Please review our terms and conditions carefully before proceeding.',
    'promotion.tocFamily.verify.termsAndConditions': '<a href={url} target="_blank">Terms & Conditions</a>',
    'promotion.tocFamily.verify.accept': 'Accept',
    'promotion.tocFamily.results.heading': 'Select <b>fare</b>',

    'promotion.tocFamily.verify.error.title': 'Error',
    'promotion.tocFamily.verify.error.heading': 'There was an error verifying your token',
    'promotion.tocFamily.verify.error.message': 'Please try again or contact {toc} for help.',

    'promotion.tocFamily.allowanceExceeded.title': "You've reached your limit of discounted tickets this year",
    'promotion.tocFamily.allowanceExceeded.message': "As part of this promotion, you're only entitled to purchase {count} tickets per year. Your quota of tickets will reset on the 1st of Jan {year}.",
    'promotion.tocFamily.allowanceExceeded.continue': 'Buy regular tickets',

    'promotion.tocFamily.rover.header': 'Buy Staff Rover',
    'promotion.tocFamily.rover.buttonText': 'Get Rover tickets',
    'promotion.tocFamily.rover.title': 'Rover tickets',
    'promotion.tocFamily.rover.description': 'Choose your start date and number of passengers to purchase Rover tickets',
    'promotion.tocFamily.rover.dateField': 'Start date',
    'promotion.tocFamily.rover.passengers': '{value, plural, =1{passenger} other{passengers}}',
    'promotion.tocFamily.rover.searchOtherJourneys': 'Search for other journeys',
    'promotion.tocFamily.rover.error': 'You only have {tickets} {tickets, plural, =1{available ticket} other{available tickets}} left for purchase',

    'season.passengers.header': 'Passengers',
    'season.passenger.adult': 'Adult',
    'season.passenger.child': 'Child (5-15)',
    'season.summary.text': 'Starting',
    'season.custom.summary.text': 'Until',
    'season.date.modal.title': 'Season ticket start date?',
    'season.custom.modal.title': 'Season ticket end date?',
    'season.select.startDate': 'Please choose a start date',
    'season.select.endDate': 'Please choose a end date',
    'season.custom.orfor': 'or for',
    'season.validUntil': 'Valid until',
    'season.ticketNumber': 'Ticket number',
    'season.duration.months': '{months} {months, plural, =1{month} other{months}}',
    'season.duration.labels.months': 'Months',
    'season.duration.days': '{days, number} {days, plural, =1{day} other{days}}',
    'season.duration.labels.days': 'Days',
    'season.options.duration': 'Duration',
    'season.options.class': 'Class',
    'season.options.travelcards': 'Travelcards',
    'season.options.routes': 'Routes',
    'season.options.labels.flexi': 'Flexi Season',
    'season.options.labels.flexi.supplementary': 'New',
    'season.options.labels.weekly': 'Weekly',
    'season.options.labels.fourWeekly': 'Four weekly',
    'season.options.labels.monthly': 'Monthly',
    'season.options.labels.quarterly': 'Quarterly',
    'season.options.labels.sixMonthly': 'Six Monthly',
    'season.options.labels.annual': 'Annual',
    'season.options.labels.custom': 'Custom',
    'season.options.labels.railcard1617': '16/17 Saver',
    'season.options.labels.railcardJobCentrePlus': 'Jobcentre Plus',
    'season.options.labels.travelcards': 'Show fares with Travelcards',
    'season.results.heading': 'Season tickets',
    'season.results.passengers': '{adults, plural,\n            =0    {}\n            other {Adults: #}\n        }{children, plural,\n            =0    {}\n            other {Children: #}\n        }\n    ',
    'season.results.editJourney': 'Edit your journey',
    'season.filters.heading': 'Filters',
    'season.filters.showingText': 'Showing results with <strong>{ filterNum } filters</strong>',
    'season.filters.editText': 'Edit',
    'season.filters.hide': 'Hide',
    'season.photocard.notes': 'We cannot sell a Season Ticket without a valid photocard. Please enter your photocard details.',
    'season.photocard.header': 'Photocard details',
    'season.photocard.number': 'Photocard number',
    'season.photocard.ticket': 'Photocard for:',
    'season.photocard.multiple': 'Use a single photocard for all tickets',
    'season.ticket.firstClass': '1st Class',
    'season.label.customDuration': '{months, plural, =0{} =1{1 month} other{# months}} {days, plural, =0{} =1{1 day} other{# days}}',
    'season.warning.requiresFutureStartDate': 'Requires a start date of {startDate} or later for postal delivery',

    'otherTickets.daySave.title': 'DaySave',
    'otherTickets.roversRangers.title': 'Rover tickets',

    'daySave.search.title': 'otherTickets.daySave.title',
    'daySave.results.heading': 'DaySave tickets',
    'daySave.results.no-results.heading': 'No results',
    'daySave.results.no-results.text': 'Sorry, there were no DaySave tickets found that match your search. Please try a different date or origin station.',
    'daySave.results.backToSearch': 'Try a different search',
    'daySave.passengers.mustHaveAdult': 'There must be at least 1 adult travelling',

    'booking.error.noSmartcard': 'You need an active <{global.key}> <{global.smartcard}> with no pending tickets to buy <{global.smartcard}> tickets',

    'roversRangers.search.title': 'otherTickets.roversRangers.title',
    'roversRangers.search.dateInputPrefix': 'Start date',
    'roversRangers.search.dateModalTitle': 'Rover ticket start date',
    'roversRangers.search.familyRangerPassengerInfo': 'This ticket is valid for a maximum of 2 Adults and 4 Children',
    'roversRangers.search.dayRangerInfo': 'Are you travelling with up to 2 adults and 4 children, the WM Family Day Ranger may work out cheaper. You can select it from the dropdown list on the search page',

    'roversRangers.results.heading': 'Rover tickets',
    'roversRangers.results.no-results.heading': 'daySave.results.no-results.heading',
    'roversRangers.results.no-results.text': 'Sorry, there were no Rover tickets found that match your search. Please try a different date or ticket type.',
    'roversRangers.results.backToSearch': 'daySave.results.backToSearch',

    'roversRangers.passengers.header': 'Passengers',
    'roversRangers.passengers.leadPassenger': 'Lead passenger name',
    'roversRangers.passengers.placeholder': 'Name of {adults, plural, =0{} one{adult}}{children, plural, =0{} one{child}}',
    'roversRangers.passengers.withRailcard': 'with {railcard}',
    'roversRangers.passengers.withoutRailcard': 'without Railcard',

    'roversRangers.ticketInfo.all': 'Other Rovers are available - <a target="_blank" aria-label="click here for details about Other Rovers" href="https://www.nationalrail.co.uk/tickets-railcards-and-offers/ticket-types/ranger-tickets-and-rover-tickets/">click here for details</a>',
    'roversRangers.ticketInfo.14R': 'First class All-Line Rovers are also available - <a target="_blank" aria-label="click here for details about First class All-Line Rovers" href="https://www.nationalrail.co.uk/times_fares/pr569241c35ce74100fb0de1b9798124.aspx">click here for details</a>',
    'roversRangers.ticketInfo.R07': 'First class All-Line Rovers are also available - <a target="_blank" aria-label="click here for details about First class All-Line Rovers" href="https://www.nationalrail.co.uk/times_fares/pr20780b0a0400020167ed620a7e504e.aspx">click here for details</a>',

    'roversRangers.ticketTypeName.14R': 'All Line Rover (14 Days)',
    'roversRangers.ticketTypeName.R07': 'All Line Rover (7 Days)',
    'roversRangers.ticketTypeName.MTR': 'Kent Rover',
    'roversRangers.ticketTypeName.H37': 'Heart of England 3 in 7 Days',
    'roversRangers.ticketTypeName.HE7': 'Heart of England 7 Day Rover',
    'roversRangers.ticketTypeName.WM1': 'West Midlands Day Ranger',
    'roversRangers.ticketTypeName.WM3': 'West Midlands Family Day Ranger',
    'booking.journey.origin': 'Leaving from...',
    'booking.journey.origin.label': 'Leaving from (origin)',
    'booking.journey.destination': 'Going to...',
    'booking.journey.destination.label': 'Going to (destination)',
    'booking.journey.mandatoryField': 'This field is required',
    'booking.journey.switch': 'Switch origin and destination',
    'booking.journey.clear': 'Clear',
    'booking.journey.viaAvoid': 'Travel via or avoid',
    'booking.journey.via': 'Travel via',
    'booking.journey.avoid': 'Avoid',
    'booking.journey.viaStation': 'Travelling via {station}',
    'booking.journey.avoidStation': 'Avoid {station}',
    'booking.journey.viaLabel': 'Select a station to travel via.',
    'booking.journey.avoidLabel': 'Select a station to avoid.',
    'booking.journey.viaPlaceholder': 'Travelling via...',
    'booking.journey.avoidPlaceholder': 'Avoiding...',
    'booking.journey.chooseAJourney': 'Choose a journey',
    'booking.journey.chooseTicket': 'Choose ticket type',
    'booking.journey.stationName': '{name}({crs})',
    'booking.journey.description': '{origin} to {destination}',
    'booking.journey.delay': '{delay} late',
    'booking.journey.srDateDescription': '{scheduledDepartureDate}, {scheduledDeparture} to {scheduledArrival}',
    'booking.journey.srShortDescription': '{scheduledDeparture} from {origin} arriving at {destination} at {scheduledArrival}',
    'booking.journey.srLongDescription': '<{booking.journey.srShortDescription}>. This service takes {duration}, {changes} and is currently {delay}.',
    'booking.journey.srAdjustedTimes': 'It will now depart at {adjustedDeparture} and arrive at {adjustedArrival}. ',
    'booking.journey.srChanges': '{changes, plural, =0 {is Direct} =1 {has 1 change} other {has # changes}}. ',
    'booking.journey.additional-options': 'Show all routes',

    'booking.journey.errors.sameStation': 'Origin and destination stations must be different',
    'booking.journey.errors.missingOrigin': 'Please enter the station you are leaving from',
    'booking.journey.errors.missingDestination': 'Please enter the station you are going to',
    'booking.journey.errors.viaSameStation': 'You cannot travel via your origin or destination',
    'booking.journey.errors.avoidSameStation': 'You cannot avoid travelling via your origin or destination',

    'booking.dates.errors.departAfterArrive': 'Your return journey is earlier than your outward journey',
    'booking.dates.errors.invalidDate': 'A date entered is invalid',
    'booking.dates.errors.pastDate': 'A date entered is in the past',
    'booking.dates.errors.smartcardPeriodReturn': 'Only day returns are currently available on <{global.theKey}> <{global.smartcard}>. Please choose a return time on the same date as your outbound journey',
    'booking.dates.errors.datesAfterMax': 'You can only book travel up to {maxOutboundDays} days into the future',
    'booking.dates.errors.datesAfterMaxPeriod': 'You can only book travel up to {maxPeriod} into the future',
    'booking.dates.errors.datesBeforeSmartcardAwaitingPeriod': 'You can only book travel that starts {days, plural, =1{# working day} other{# working days}} since today',
    'booking.dates.errors.railcard1617Expiry': 'Your 16-17 Saver railcard allowance expires on {date}',
    'booking.railcard1617.enterDetails': 'Please enter your 16/17 Saver railcard details',
    'booking.railcard1617.form.firstName': 'First name',
    'booking.railcard1617.form.surname': 'Surname',
    'booking.railcard1617.form.railcardNumber': 'Railcard number',
    'booking.railcard1617.keyGoLinkingLabel': 'Click here to save this railcard to keyGo account <b>"{email}"</b>.',
    'booking.railcard1617.keyGoLinkingWarning': '<div class="railcard1617-modal__keygo-warning"><i class="otrl otrl-warning b-alert__icon b-alert__icon--multiline railcard1617__keygo-warning__icon"></i>You can remove this railcard from your keyGo account by visiting your Photocards/Railcards menu.  If you then wish to add this railcard to another account after removing it, you will need to contact Customer Services.</div>',
    'booking.railcard1617.railcardDetails': 'Railcard details',
    'booking.railcard1617.errors.alreadyExists': 'The railcard you are trying to register is already registered. Please check your details and try again.',
    'booking.railcard1617.errors.invalid': 'The entered 16-17 Saver railcard number does not match the entered name',
    'booking.railcard1617.errors.unknown': 'There was an error while trying to validate your railcard. Please try again later.',
    'booking.railcard1617.validationSuccess': 'Your 16-17 Saver railcard has been applied to the search',

    'booking.season.errors.durationMissing': 'Please select your season ticket duration',

    'booking.journey.leg.callingPoints': 'Calling points',
    'booking.journey.leg.platform': 'Platform {platform}',
    'booking.journey.leg.replacementBus': 'Rail replacement bus',
    'booking.journey.leg.journeyTime': 'Journey time: {journeyTime}',
    'booking.journey.leg.facilities': 'Train facilities',
    'booking.journey.leg.facilities.firstClass': 'First Class',
    'booking.journey.leg.facilities.firstClassMeal': 'First Class meal',
    'booking.journey.leg.facilities.firstClassRestaurant': 'First Class restaurant',
    'booking.journey.leg.facilities.hotFood': 'Hot food',
    'booking.journey.leg.facilities.buffet': 'Buffet',
    'booking.journey.leg.facilities.restaurant': 'Restaurant',
    'booking.journey.leg.facilities.trolley': 'Trolley',
    'booking.journey.leg.facilities.wheelchair': 'Wheelchair access',
    'booking.journey.leg.details.operator': 'Service operator',
    'booking.journey.leg.details.service': 'Service',
    'booking.journey.leg.details.journeyTime': 'Journey time',
    'booking.journey.leg.toggle': '{show, select, true {Hide} other {Show}} calling points',

    'booking.dates.addReturn': 'Add return',
    'booking.dates.return': 'Return',
    'booking.dates.outbound': 'Outbound',
    'booking.dates.departing': 'Leaving at',
    'booking.dates.arriving': 'Arriving',
    'booking.dates.departing.short': 'Dep ',
    'booking.dates.arriving.short': 'Arr',
    'booking.dates.now': 'Now',
    'booking.dates.todayAt': 'Today',
    'booking.dates.tomorrowAt': 'Tomorrow',
    'booking.dates.sameDay': 'Same day',
    'booking.dates.nextDay': 'Next day',
    'booking.dates.openReturn-title': 'Open return',
    'booking.dates.openReturn': 'You have chosen an Open Return ticket, these tickets are valid for one calendar month from the outward date',
    'booking.dates.openReturn-title-v2': 'Return',
    'booking.dates.openReturn-v2': 'Within a month',
    'booking.dates.modal.title.outward.Depart': 'When would you like to leave?',
    'booking.dates.modal.title.outward.Arrive': 'When would you like to arrive?',
    'booking.dates.modal.title.inward.Depart': 'When would you like to come back?',
    'booking.dates.modal.title.inward.Arrive': 'When would you like to arrive back?',
    'booking.dates.addOpenReturn': 'Get an <span class="like-link"><strong>open return ticket</strong></span> and return within a month for an extra',
    'booking.dates.addOpenReturn.equal': 'Get an <span class="like-link"><strong>open return ticket</strong></span> and return within a month <strong>at not additional cost</strong>',
    'booking.dates.addOpenReturn.cheaper': 'Get an <span class="like-link"><strong>open return ticket</strong></span> and return within a month saving',

    'booking.time.labels.time': 'Time',
    'booking.time.labels.hours': 'Hours',
    'booking.time.labels.minutes': 'Minutes',

    'booking.operator.all': 'All operators',
    'booking.operator.specifictoc': 'Only {toc} services',

    'booking.passengers.adults': '{adults, plural,\n            =0    {}\n            one   {# x Adult}\n            other {# x Adults}\n        }\n    ',
    'booking.passengers.children': '{children, plural,\n            =0    {}\n            one   {# x Child}\n            other {# x Children}\n        }\n    ',
    'booking.passengers.errors.atLeastOne': 'You must select at least 1 passenger',
    'booking.passengers.errors.upToNine': 'You can select up to a maximum of 9 passengers',
    'booking.passengers.summary.text': '{adults, plural,\n            =0    {}\n            one   {1 Adult {children, plural, =0{} other{ & }}}\n            other {# Adults {children, plural, =0{} other{ & }}}\n        }{children, plural,\n            =0    {}\n            one   {1 Child}\n            other {# Children}\n        }\n    ',
    'booking.passengers.names.text': '{adults, plural,\n            =0    {}\n            one   {adult}\n        }{children, plural,\n            =0    {}\n            one   {child}\n        }\n    ',
    'booking.passengers.modal.title.withRailcards': 'Passengers and Railcards',
    'booking.passengers.modal.title': 'Passengers',
    'booking.passenger.child-fare.info': 'Children under 5 travel free. Under 16s are eligible for child fares. Passengers aged 16 or over must buy an adult ticket.',

    'booking.railcards': 'Railcards',
    'booking.railcardsCount': '{ quantity } x { name }',
    'booking.railcards.season.railcard1617.heading': 'Validate your 16-17 Saver railcard',
    'booking.railcards.season.railcard1617.warning': 'If you have a 16-17 Saver Railcard click above to validate it and receive discounts on Season tickets',
    'booking.railcards.select': 'Select a Railcard',
    'booking.railcards.add': 'Add Railcard',
    'booking.railcards.remove': 'Remove Railcard',
    'booking.railcards.errors.moreThanPassengers': 'alertmessage.form.moreRailcardsThanPassengers',
    'booking.railcards.summary': '{railcards, plural,\n        =0    {No Railcards}\n        one   {1 Railcard}\n        other {# Railcards}\n    }',
    'booking.railcards.summary-v2': '{railcards, plural,\n        =0    {No railcards}\n        one   {1 Railcard}\n        other {# Railcards}\n    }',
    'booking.general.discount': 'Discount applied',
    'booking.railcards.discount': '{railcard} discount applied',
    'booking.railcards.discount.warning': 'Minimum fare and time restrictions may apply',
    'booking.railcard.2TR': 'Two Together Railcard',
    'booking.railcard.DIC': 'Disabled Child Railcard',
    'booking.railcard.DIS': 'Disabled Persons Railcard',
    'booking.railcard.FAM': 'Family & Friends Railcard',
    'booking.railcard.HMF': 'HM Forces Railcard',
    'booking.railcard.JCP': 'Jobcentre Plus Travel Discount Card',
    'booking.railcard.NEW': 'Network Railcard',
    'booking.railcard.NGC': 'Annual Gold Card',
    'booking.railcard.SRN': 'Senior Railcard',
    'booking.railcard.TST': '26-30 Railcard',
    'booking.railcard.TSU': '16-17 Saver Railcard',
    'booking.railcard.VET': 'Veterans Railcard',
    'booking.railcard.YNG': '16-25 Railcard',

    'booking.railcards.season.warning': 'Please be advised that Young Scot Railcard discounts on season tickets are not available on this site',

    'booking.summary.title': '{ticketType, select, single{Single} other{Return}} journey from {origin} to {destination}',
    'booking.summary.modalTitle': 'Your basket',
    'booking.summary.confirmClear': 'Please confirm that you wish to clear your basket',
    'booking.summary.emptyBasket': 'Clear basket',
    'booking.summary.pickOutbound': 'Choose your outbound ticket...',
    'booking.summary.pickReturn': 'Choose your return ticket...',
    'booking.summary.action.editJourney': 'Edit journey',
    'booking.summary.action.continue': 'Continue',
    'booking.summary.action.goBack': 'Go back',
    'booking.summary.totalLabel': 'Sub-total',
    'booking.summary.thisJourneyLabel': 'Current journey:',
    'booking.summary.returnHeading': 'Return',
    'booking.summary.outboundHeading': 'Outbound',
    'booking.summary.addAnotherJourney': 'Add another journey',

    'booking.railcards.stepper.adult': '{adults, plural, =1{Adult} other{Adults}}',
    'booking.railcards.stepper.child': '{children, plural, =1{Child} other{Children}}',

    'boooking.railcards.checkExpiry': 'Please check the expiry date of your Railcard, to make sure it is still valid on your date of travel',

    'booking.preferences': 'Preferences',

    'booking.preferences.directOnly': 'Show direct services only',
    'booking.preferences.preferThames': 'Prefer Thameslink trains',
    'booking.preferences.smartcardOnly': 'Show <{global.key}> <{global.smartcard}> fares only',
    'booking.preferences.sleepersOnly': 'Show sleeper services only',
    'booking.preferences.additionalTime': 'Additional change time',

    'booking.fares.modal.pickOutbound': 'Select your outbound ticket',
    'booking.fares.modal.pickInbound': 'Select your inbound ticket',

    'booking.fares.name.withSubtypes': '{ticketName} with {subTypes}',
    'booking.fares.standard': 'Standard',
    'booking.fares.firstClass': 'First Class',
    'booking.fares.carnet': 'Carnet',
    'booking.fares.railcards': 'Railcards',
    'booking.fares.railcards.discounted': 'Railcard {discountPercent, select, false{discounted} other {+ {discountPercent}% discount}}',
    'booking.fares.discount': 'Discount',
    'booking.fares.discounted': 'Discounted {discountPercent}%',
    'booking.fares.discounted.fixed': 'Discounted {discountFixed}',
    'booking.fares.originalPrice': 'Original price: {price}',
    'booking.fares.save': 'save',
    'booking.fares.tickets.singles': 'Single tickets',
    'booking.fares.tickets.more-singles': 'Other single tickets',
    'booking.fares.tickets.no-singles': 'There are no single tickets available',
    'booking.fares.tickets.no-more-singles': 'There are no more single tickets available',
    'booking.fares.tickets.returns': 'Return tickets',
    'booking.fares.tickets.more-returns': 'Other return tickets',
    'booking.fares.tickets.no-returns': 'There are no return tickets available',
    'booking.fares.tickets.no-more-returns': 'There are no more return tickets available',
    'booking.fares.details.short': 'Ticket details',
    'booking.fares.details': 'Show ticket details',
    'booking.fares.details.hide': 'Hide ticket details',
    'booking.fares.groupsave': 'GroupSave',
    'booking.fares.groupsave.discounted': 'GroupSave {discountPercent, select, false{discounted} other {+ {discountPercent}% discount}}',
    'booking.fares.details.route': 'Valid routes',
    'booking.fares.details.dates': 'Valid dates',
    'booking.fares.details.dates.outward': 'Outward',
    'booking.fares.details.dates.return': 'Return',
    'booking.fares.details.dates.period': '{from} {showRange, plural, =1 {- {until}} other {}}',
    'booking.fares.detail.alternate.origin': 'Valid from',
    'booking.fares.detail.alternate.destination': 'Valid to',
    'booking.fares.detail.alternate.info': 'Your ticket is only valid for travel {direction} the following London Terminal stations:',
    'booking.fares.details.ticket': '{adults, plural,\n            =0    {}\n            one   {1 Adult}\n            other {# Adults at {individualPrice}}\n        }{children, plural,\n            =0    {}\n            one   {1 Child}\n            other {# Children at {individualPrice}}\n        } {ticketTypeOverride, plural,\n            =0    {}\n            other {{ticketTypeOverride} }}',
    'booking.fares.details.carnetTicket': '{adults, plural,\n            =0    {}\n            one   {1 Adult ticket}\n            other {# Adult tickets at {individualPrice}}\n        }{children, plural,\n            =0    {}\n            one   {1 Child}\n            other {# Child tickets at {individualPrice}}\n        } {ticketTypeOverride, plural,\n            =0    {}\n            other {{ticketTypeOverride} }\n        }',
    'booking.fares.details.smartCarnet': '{passes, plural,\n        =0    {}\n        one   {1 Adult x 1 pass }\n        other {1 Adult x # passes }\n    }',
    'booking.fares.details.carnet': 'Carnet information',
    'booking.fares.details.discount': 'Discount info',
    'booking.fares.details.discount.summary': 'This ticket has been discounted by {discountPercent}%',
    'booking.fares.details.restriction': 'Show ticket restrictions',
    'booking.fares.details.groupSave.children': 'To ensure you get the best value, some children have been treated as adults to qualify for the GroupSave discount.',
    'booking.fares.details.railcards.exception': 'Railcards were not applied to this search',
    'booking.fares.details.railcards.reminder': 'You must bring your Railcard(s) with you on your journey',
    'booking.fares.details.bestfare.part1': 'Select another single ticket in the next step from just ',
    'booking.fares.details.bestfare.part2': ' to get the best value of ',
    'booking.fares.details.bestfare.part3': ' for two single tickets',
    'booking.fares.details.seefares': 'See return',
    'booking.fares.details.breakOfJourney': 'Break of journey',
    'booking.fares.details.breakOfJourney.outward': 'Outward',
    'booking.fares.details.breakOfJourney.return': 'Return',
    'booking.fares.details.breakOfJourney.allowed': 'You can break and resume your journey',
    'booking.fares.details.breakOfJourney.notAllowed': 'You cannot break and resume your journey',
    'booking.fares.details.breakOfJourney.smartCarnet': 'You can break and resume your journey. You must start at the origin station and end your journey at the destination of keyGo Carnet ticket. Any break of journey must be made along the line of this route.',
    'booking.fares.details.daysave.childFareRestriction': 'Child fares are only available to accompanied children under the age of 16. No more than four children may accompany each adult or group at the child fare',
    'booking.fares.details.daysave.offPeakRestriction.1': 'Anytime on Saturdays, Sundays and Bank Holidays',
    'booking.fares.details.daysave.offPeakRestriction.2': 'Not before 10:00 Monday to Friday (except Bank Holidays)',
    'booking.fares.details.daysave.offPeakRestriction.3': 'Not between 16:15 and 19:15 Monday to Friday when boarding trains from East Croydon, London stations (Victoria, London Bridge and Clapham Junction)',
    'booking.fares.details.daysave.moreInfo': 'More information',
    'booking.fares.details.comparison-percentage': '{percentage}% cheaper',
    'booking.fares.details.comparison-caveat.P7D': 'vs {ticketNum} x Anytime Day Return Ticket',
    'booking.fares.details.comparison-caveat.P1M': 'vs {ticketNum} x Weekly equivalent season ticket',
    'booking.fares.details.comparison-caveat.P1Y': 'vs {ticketNum} x Monthly equivalent season ticket',
    'booking.fares.details.comparison-caveat.P3M': 'vs {ticketNum} x Weekly equivalent season ticket',
    'booking.fares.details.comparison-caveat.P6M': 'vs {ticketNum} x Weekly equivalent season ticket',
    'booking.fares.details.comparison-caveat.FL1': 'vs {ticketNum} x Anytime Day Return ticket',
    'booking.fares.details.comparison-caveat.CFO': 'vs {ticketNum} x Anytime Day Ticket',
    'booking.fares.details.comparison-caveat.CFP': 'vs {ticketNum} x Anytime Day Ticket',
    'booking.fares.details.comparison-caveat.0BK': 'vs {ticketNum} x Off Peak Day Ticket',
    'booking.fares.details.comparison-caveat.0BI': 'vs {ticketNum} x Anytime Day Ticket',
    'booking.fares.details.comparison-sr-only-caveat.P7D': 'this ticket is £{cheaperAmount} ({cheaperPercentage}%) cheaper compared to {ticketNum} Anytime Day Return Tickets,',
    'booking.fares.details.comparison-sr-only-caveat.P1M': 'this ticket is £{cheaperAmount} ({cheaperPercentage}%) cheaper compared to {ticketNum} Weekly equivalent season tickets,',
    'booking.fares.details.comparison-sr-only-caveat.P1Y': 'this ticket is £{cheaperAmount} ({cheaperPercentage}%) cheaper compared to {ticketNum} Monthly equivalent season tickets,',
    'booking.fares.details.comparison-sr-only-caveat.P3M': 'this ticket is £{cheaperAmount} ({cheaperPercentage}%) cheaper compared to {ticketNum} Weekly equivalent season tickets,',
    'booking.fares.details.comparison-sr-only-caveat.P6M': 'this ticket is £{cheaperAmount} ({cheaperPercentage}%) cheaper compared to {ticketNum} Weekly equivalent season tickets,',
    'booking.fares.details.no-comparison': 'No comparison available',
    'booking.fares.details.accessibility.warning': "First class areas on <{app.owner.short}> don't have wheelchair accommodation, or wheelchair access to accessible toilets. If you are travelling with another operator, please check with them",
    'booking.fare.select-ticket': '£{price} {class}, {ticketType} ticket valid on the {description}, {action}',
    'booking.fare.select-cheapest-ticket': 'Cheapest ticket £{price} {class} class {ticketType} ticket valid on the {description}, {action}',
    'booking.fare.select-season-ticket': '£{price}, {ticketClass}, {duration} {type} from {origin} to {destination}, {comparison} {description}, {action}',
    'booking.fare.selected-season-ticket': 'You have selected a £{price}, {ticketClass}, {duration} {type} from {origin} to {destination}, it is valid from {validityStart} to {validityEnd}, click for more info.',
    'booking.fare.select-rovers-ticket': '£{price}, {ticketClass}, {ticketName} ticket, it is valid from {validityStart}, {action}',
    'booking.fare.selected-rovers-ticket': 'You have selected a £{price}, {ticketClass}, {ticketName} ticket, it is valid from {validityStart}, click for more info.',
    'booking.fare.select-daysave-ticket': '<{booking.fare.select-rovers-ticket}>',
    'booking.fare.selected-daysave-ticket': '<{booking.fare.selected-rovers-ticket}>',
    'booking.fare.cheapest': 'CHEAPEST',
    'booking.fare.cheapest.label': '\n        This is the cheapest service available.\n        {count, plural,\n            =0 {}\n            =1 {There is 1 other service in this list with the same low price.}\n            other {There are # other services in this list with the same low price.}\n        }',
    'booking.fare.cheapest-list': 'Cheapest Ticket',
    'booking.fare.remaining-availability': '{availability} left',
    'booking.fare.remaining-availability-prompt': '<b>Hurry!</b> {availability} Left',
    'booking.fare.limited-availability': 'Limited Availability',
    'booking.fare.unavailable': 'Fare unavailable',
    'booking.fare.info.validServices': 'Services valid with this ticket',
    'booking.fare.eligibleServicesModal.title': 'Services valid with this ticket',
    'booking.fare.eligibleServicesModal.outwardJourney': 'Outward journey',
    'booking.fare.eligibleServicesModal.returnJourney': 'Return journey',
    'booking.fare.eligibleServicesModal.serviceSelected': 'Service selected:',
    'booking.fare.eligibleServicesModal.ticketSelected': 'Ticket selected:',
    'booking.fare.eligibleServicesModal.rtn': 'Rtn: ',
    'booking.fare.eligibleServicesModal.validUntil': 'Valid until:',
    'booking.fare.eligibleServicesModal.one-month': '(1 month)',
    'booking.fare.eligibleServicesModal.description': '<p>Minimum fare and time restrictions may apply when using a railcard. Check <a target="_blank" href="https://www.nationalrail.co.uk/railcards/">Railcards | National Rail</a> before you travel.</p>',

    'booking.fare.eligibleServicesModal.table.earlier': 'Earlier',
    'booking.fare.eligibleServicesModal.table.earlier.ariaLabel': 'Show earlier trains',
    'booking.fare.eligibleServicesModal.table.later.ariaLabel': 'Show later trains',
    'booking.fare.eligibleServicesModal.table.show': 'Show',
    'booking.fare.eligibleServicesModal.table.later': 'Later',
    'booking.fare.eligibleServicesModal.table.departing': 'Departing',
    'booking.fare.eligibleServicesModal.table.from': 'From',
    'booking.fare.eligibleServicesModal.table.to': 'To',
    'booking.fare.eligibleServicesModal.table.duration': 'Duration',
    'booking.fare.eligibleServicesModal.table.changes': 'Changes',
    'booking.fare.eligibleServicesModal.table.status': 'Status',
    'booking.fare.eligibleServicesModal.table.serviceDetails': 'Service details',
    'booking.fare.eligibleServicesModal.table.error': 'Unable to load eligible services',
    'booking.fare.eligibleServicesModal.table.noServices': 'No services found',
    'booking.fare.eligibleServicesModal.table.ariaDescription': '\n        Showing {\n            count,\n            plural,\n            =0 {0 services}\n            =1 {1 service}\n            other {# services departing between {earliest} and {latest}}\n        }\n    ',

    'booking.fares.details.class.1st': '1st',
    'booking.fares.details.class.standard': 'Std',
    'booking.fares.details.class.1st.full': 'First Class',
    'booking.fares.details.class.standard.full': 'Standard',
    'booking.fares.no-results': 'There are no results available for this search.',
    'booking.fares.no-results.link': 'Try changing your search parameters.',
    'booking.fares.nre-link.text': 'Details',

    'journey.tocDetails.service': 'A {toc} service',
    'journey.tocDetails.single': '{toc}',
    'journey.tocDetails.multiple': '{toc} plus other operators',

    'journey.duration.direct': 'Direct',
    'journey.duration': 'Duration',
    'journey.duration.changes': '{changes, plural, =0 {Direct} =1 {Changes 1 } other {Changes #}}',
    'journey.duration.changesInverted': '{changes, plural, =0 {Direct} =1 {1 change } other {# changes }}',
    'journey.duration.on-time': 'On time',
    'journey.duration.late': 'late',
    'journey.duration.train-cancelled': 'Train cancelled',

    'journey.warnings.replacementBus': 'This journey includes {busCount} replacement {busCount, plural, =1{bus} other{buses}}.',
    'journey.warnings.delayed-departure': 'Departure has been delayed by {departureDelay}.',
    'journey.warnings.delayed-arrival': 'Arrival has been delayed by {arrivalDelay}.',
    'journey.warnings.delayed': 'This journey has been delayed.',
    'journey.warnings.notAvailableWithTicket': '{ticketName} not available.',
    'journey.warnings.cancelled': 'This train has been cancelled.',
    'journey.warnings.cancelled-with-reason': '{journeyCancellationReason}.',
    'journey.warnings.serviceInThePast': 'This train has already left the station.',
    'journey.warnings.overtaken': 'This train will be overtaken by a later service.',
    'journey.warnings.notCollectable': 'This train departs in less than {minTodOffset} and ticket collection is not possible.',
    'journey.warnings.noneOutwardCollectable': 'All outward trains depart in less than {minTodOffset} and ticket collection is not possible.',
    'journey.warnings.notCollectableSmartcard': 'This train departs in less than {minSmartcardOffset} and ticket collection is not possible.',
    'journey.warnings.arrivalAfterReturnDepart': 'This train departs before your selected outbound train arrives.',
    'journey.warnings.hasCountedPlace': 'Please note this service has mandatory reservations.',
    'journey.warnings.hasOtherAsServiceOperator': 'This journey requires a connection involving an alternative method of transport, that will not be covered by your rail ticket. Please plan ahead and check before you travel.',

    'booking.seating': 'Reserve a seat',
    'booking.seating.preferences': 'Reserve Seating',
    'booking.seating.noPreference': 'No preference',
    'booking.seating.direction': 'Direction',
    'booking.seating.direction.forwards': 'Forwards',
    'booking.seating.direction.backwards': 'Backwards',
    'booking.seating.position': 'Position',
    'booking.seating.position.aisle': 'Aisle seat',
    'booking.seating.position.window': 'Window seat',
    'booking.seating.position.individual': 'Single seat (First Class only)',
    'booking.seating.seatType': 'Seat type',
    'booking.seating.seatType.airline': 'Row seat',
    'booking.seating.seatType.table': 'Table seat',
    'booking.seating.features': 'Features',
    'booking.seating.features.quietCoach': 'Quiet Coach',
    'booking.seating.features.nearToilets': 'Near toilets',
    'booking.seating.features.powerSocket': 'Power socket',
    'booking.seating.features.nearLuggageRack': 'Near luggage rack',

    'booking.seating.noPromises': 'Seat preferences cannot be guaranteed.',
    'booking.seating.outbound': 'Outbound',
    'booking.seating.inbound': 'Return',
    'booking.seating.seat': 'Seat',
    'booking.seating.coachSeat': 'Coach {coach}, Seat {seat}',
    'booking.seating.youAskedUsFor': 'You asked us for',
    'booking.seating.expires': 'Reservation expires',
    'booking.seating.loading': 'Reserving you some seats...',
    'booking.seating.none': 'Seat reservations are not available on this service',

    'booking.seating.describe.direction': '{direction, select, FACE{Forward facing} BACK{Backwards facing} other{}}',
    'booking.seating.describe.position': '{position, select, AISL{Aisle seat} WIND{Window seat} INDL{Single seat (First class only)} other{}}',
    'booking.seating.describe.seatType': '{seatType, select, AIRL{Row seat} TABL{Table seat} other{}}',

    'booking.seating.usualSeatingAvailability.modalTitle': 'SeatFinder',
    'booking.seating.usualSeatingAvailability.update': 'Update service selection',
    'booking.seating.usualSeatingAvailability.bodyCopy1': 'Check how busy your train is before you travel.',
    'booking.seating.usualSeatingAvailability.changes.direct': 'Direct',
    'booking.seating.usualSeatingAvailability.changes.changes': '{changes, plural, =1 {# change} other {# changes}}',
    'booking.seating.usualSeatingAvailability.seating.many': 'Usually many seats available',
    'booking.seating.usualSeatingAvailability.seating.plenty': 'Usually plenty of seats available',
    'booking.seating.usualSeatingAvailability.seating.some': 'Usually some seats available',
    'booking.seating.usualSeatingAvailability.seating.few': 'Usually only a few seats available',
    'booking.seating.usualSeatingAvailability.seating.standing': 'Usually standing room only',
    'booking.seating.usualSeatingAvailability.seating.noData': 'Seating data unavailable',
    'booking.seating.usualSeatingAvailability.seating.noDataForLeg': 'No data available for this journey leg',
    'booking.seating.usualSeatingAvailability.serviceFareMismatch': 'This service is not valid with your currently selected ticket type.',
    'booking.seating.usualSeatingAvailability.serviceHeading': 'Service',
    'booking.seating.usualSeatingAvailability.serviceSelectionLegend.outward': 'Select outward service',
    'booking.seating.usualSeatingAvailability.serviceSelectionLegend.inward': 'Select inward service',
    'booking.seating.usualSeatingAvailability.serviceTableHeading.select': 'Select this service',
    'booking.seating.usualSeatingAvailability.serviceTableHeading.punctuality': 'Service punctuality',
    'booking.seating.usualSeatingAvailability.serviceTableHeading.departureTime': 'Service departure time',
    'booking.seating.usualSeatingAvailability.serviceTableHeading.arrivalTime': 'Service arrival time',
    'booking.seating.usualSeatingAvailability.serviceTableHeading.duration': 'Service duration',
    'booking.seating.usualSeatingAvailability.serviceTableHeading.changeCount': 'Number of changes for this service',
    'booking.seating.usualSeatingAvailability.serviceTableHeading.seatingAvailability': 'Service seating availability',
    'booking.seating.usualSeatingAvailability.serviceTable.selectService': 'Select this service',
    'booking.seating.usualSeatingAvailability.loadEarlierServices': 'Earlier',
    'booking.seating.usualSeatingAvailability.loadEarlierServicesAriaLabel.outward': 'Load earlier outward services',
    'booking.seating.usualSeatingAvailability.loadEarlierServicesAriaLabel.inward': 'Load earlier inward services',
    'booking.seating.usualSeatingAvailability.loadLaterServices': 'Later',
    'booking.seating.usualSeatingAvailability.placeholder': 'No Return Selected',
    'booking.seating.usualSeatingAvailability.loadLaterServicesAriaLabel.outward': 'Load later outward services',
    'booking.seating.usualSeatingAvailability.loadLaterServicesAriaLabel.inward': 'Load later outward services',
    'booking.seating.usualSeatingAvailability.serviceTable.key.many': 'Many seats available',
    'booking.seating.usualSeatingAvailability.serviceTable.key.plenty': 'Plenty of seats available',
    'booking.seating.usualSeatingAvailability.serviceTable.key.some': 'Some seats available',
    'booking.seating.usualSeatingAvailability.serviceTable.key.few': 'Only a few seats available',
    'booking.seating.usualSeatingAvailability.serviceTable.key.standing': 'Standing room only',
    'booking.seating.usualSeatingAvailability.serviceTable.key.noData': 'Data unavailable ',
    'booking.seating.usualSeatingAvailability.serviceTable.title': 'Usual seating availability',

    'booking.stepFreeAccess.full': 'Step-free access',
    'booking.stepFreeAccess.partially': 'Some step-free access',
    'booking.stepFreeAccess.not': 'No step-free access',

    'booking.stepFreeAccess.button.info': 'Press to find out more about step-free access at {station}',

    'booking.journeySupport.title': 'Journey support',
    'booking.journeySupport.toggle.stepFree': 'Press to display step-free information for each journey',
    'booking.journeySupport.toggle.seatAvailability': 'Press to display seat availability information for each journey',
    'booking.journeySupport.toggle.stepFree.hide': 'Press to hide step-free information for each journey',
    'booking.journeySupport.toggle.seatAvailability.hide': 'Press to hide seat availability information for each journey',
    'booking.journeySupport.toggle.title.stepFree': 'Step-free access',
    'booking.journeySupport.toggle.title.seatAvailability': 'SeatFinder',
    'booking.journeySupport.toggle.title.stepFree.show': 'Show Step-free access information for your journey',
    'booking.journeySupport.toggle.title.seatAvailability.show': 'Show train seating capacity for journey',
    'booking.journeySupport.toggle.title.stepFree.hide': 'Hide Step-free access information for your journey',
    'booking.journeySupport.toggle.title.seatAvailability.hide': 'Hide train seating capacity for journey',

    'booking.journeySupport.modal.title': 'Journey Support',
    'booking.journeySupport.modal.key': 'Journey support key',
    'booking.journeySupport.modal.seatFinder.title': 'SeatFinder',
    'booking.journeySupport.modal.seatFinder.info': '<p>SeatFinder data tells you how busy our trains usually are, to help you find a quieter time to travel. SeatFinder data is only available for Southeastern-operated services.</p>',
    'booking.journeySupport.modal.stepFree.title': 'Step-free access',
    'booking.journeySupport.modal.stepFree.info': '\n        <p>Step-free access stations have lifts or ramps, or a combination of both, so you don\u2019t have to use escalators or stairs to access the platforms.</p>\n        <p>If there are any short-term changes to a station\u2019s step-free status, an alert will be shown in our journey planner results.</p>\n        <p>Step-free access - This is a Category A station, it has step-free access to all platforms.</p>\n        <p>Some step-free access - This is a Category B station, it has a degree of step-free access to the platforms, which may be in both directions or in one direction only - please check details.</p>\n        <p>No step-free access - This is a Category C station, it has no step-free access to any platform.</p>',
    'booking.journeySupport.modal.label.show': 'Press to display journey support key',
    'booking.journeySupport.modal.label.hide': 'Press to hide journey support key',

    'seating.error': 'Sorry, we couldn\'t reserve you any seats. This could be because your ticket selection is too close to the time of departure.',
    'seating.error.failedNotRequired': 'Seat reservations not required.',

    'header.favourites': 'Favourites',
    'header.welcome': 'Welcome back,',
    'header.basket.journeyText': '{journeys, plural, =1 {# journey} other {# journeys}}',

    'favourites.modal.title': 'Favourite tickets',
    'favourites.modal.error.NoMatchingFareError': 'Sorry, We could not find a ticket that matches your previous order.',
    'favourites.modal.step1Title': 'Choose a ticket',
    'favourites.modal.step1Text': 'These are your saved tickets, select one to re-order it.',
    'favourites.modal.step2Title': 'Choose a date',
    'favourites.modal.step3Title': 'Add PlusBus',
    'favourites.modal.reorder': 'Re-order',
    'favourites.modal.noPlusBus': 'PlusBus is not available on this route. You can continue to reorder your selected {count, plural, =1 {ticket} other {tickets}} without PlusBus.',
    'favourites.error.limit.title': 'We could not save your favourite ticket',
    'favourites.error.limit.message': 'You have saved the maximum amount of favourites. Please remove one or more favourites and try again.',

    'button.text.close': 'Close',
    'button.text.cancel': 'Cancel',
    'button.text.select': 'Select',
    'button.text.done': 'Done',
    'button.text.apply': 'Apply',
    'button.text.search': 'Search',
    'button.text.searchExistingUser': 'Search your email',
    'button.text.save': 'Save',
    'button.text.delete': 'Delete',
    'button.text.continue': 'Continue',
    'button.text.next': 'Next',
    'button.text.check': 'Check',
    'button.text.back': 'Back',
    'button.text.confirm': 'Confirm',
    'button.text.submit': 'Submit',
    'button.text.edit': 'Edit',
    'button.text.removeJourney': 'Remove journey',
    'button.text.addjourney': 'Add another journey',
    'button.text.paymentDetails': 'Continue',
    'button.text.paymentDetailsOthers': 'Other payment options',
    'button.text.checkout': 'Checkout',
    'button.text.cancelaccount': 'Cancel my account',
    'button.text.showFilters': 'Show filters',
    'button.text.confirmSmartcardReceived': 'Confirm <{global.smartcard}> received',
    'button.text.prev-tip': 'Previous tip',
    'button.text.next-tip': 'Next tip',
    'button.text.amend': 'Amend',
    'button.text.updatePaymentDetails': 'Update payment details',
    'button.text.refresh': 'Refresh',
    'button.text.cancelReservation': 'Cancel reservation',
    'button.text.upcomingJourneys': 'Your upcoming journeys',
    'button.text.previousJourneys': 'Your previous journeys',

    'icon.disruption.cancelled.aria': 'Cancelled',
    'icon.disruption.disabled.aria': 'Disabled for trip',
    'icon.disruption.delayed.aria': 'Delayed',
    'icon.disruption.disruption.aria': 'Disruption',
    'icon.disruption.replacementBus.aria': 'Bus replacement',

    'booking.delivery.header': 'Select a delivery option',
    'booking.delivery.stationSelect': 'Select a station',

    'booking.delivery.ticketondeparture.available': 'In { todCollectionMinimumTime }, you can collect your ticket(s) from a self-service machine at {origin} or any other enabled station. You just need to bring any payment card and the collection reference number provided in your order confirmation.',
    'booking.delivery.ticketondeparture.notavailable': 'In { todCollectionMinimumTime }, you can collect your ticket(s) from a self-service machine at any enabled station. You just need to bring any payment card and the collection reference number provided in your order confirmation.',
    'booking.delivery.ticketondeparture.stationNotEnabledWarning': 'Unfortunately, {origin} does not have a self-service machine. Please choose another station you would prefer to collect your tickets from.',
    'booking.delivery.ticketondeparture.differingCollectionStationWarning': 'Your preferred collection station is different to your first departure station. Please keep this in mind when collecting your tickets.',

    'booking.delivery.leadPassenger.useForAllTrips': 'Use this name for all journeys',
    'booking.delivery.loadingdate.secondaryInfoLinking': 'Your ticket will also be ready for collection from the gates at <b>{station}</b> in 2 hours.',
    'booking.delivery.loadingdate.chooseAnotherStation': 'To choose another station, ',

    'sticket.photo.upload.title': 'sTicket Photo',
    'sticket.photo.upload.confirm.message': "As you have an active sTicket, we have to approve your change of photo. While your photo is awaiting approval, you can continue using your active sTicket.\n\nPlease note, if a member of rail staff can't confirm you are the ticket holder, you may be charged the full ticket price or a penalty fare.",
    'sticket.photo.upload.confirm.title': 'Changing your photo',
    'sticket.photo.upload.delete.title': 'Delete photo',
    'sticket.photo.upload.delete.confirm.text': 'Are you sure you want to delete your sTicket photo?',
    'sticket.photo.upload.delete.confirm.button': 'Delete',
    'sticket.photo.change.notification': 'Photo change request has been successfully sent',
    'sticket.photo.waiting': '<b>Your new photo is waiting to be approved</b>. While your new photo is awaiting approval, you can continue using any active sTickets with your current photo.',
    'delivery.sticket.photo.unavailable.title': 'sTicket unavailable',
    'delivery.sticket.photo.unavailable.text': 'Unfortunately, STickets are currently unavailable for this line or route. Please choose another delivery method',
    'delivery.sticket.photo.title': 'Please make sure your image:',
    'delivery.sticket.photo.bullet1': 'Is instantly recognisable as you',
    'delivery.sticket.photo.bullet2': 'Is a Passport style photograph',
    'delivery.sticket.photo.bullet3': 'There is nothing covering your face',
    'delivery.sticket.photo.bullet4': 'Do not use an image filter',
    'delivery.sticket.photo.bullet5': "Please note, if a member of rail staff can't confirm you are the ticket holder, you may be charged the full ticket price or liable to a penalty fare",
    'delivery.sticket.errors.SticketDeliveryOptionIsNotAvailableOnRoute': 'sTickets are only available for journeys on the Southeastern network and on selected routes enabled by other Train Operating Companies. Please note:<ul><li>sTickets are not available for journeys which allow travel on London Underground services (such as Travelcards)</li><li>Early Bird discounted Season tickets are not available as sTickets</li></ul>',
    'delivery.sticket.errors.TooManyTicketsInBasketError': 'You can only purchase one sTicket at a time.',
    'delivery.sticket.details': '\n        <p>sTicket is a digital version of a Season ticket provided as a QR code. It is instantly available to download and accessed through the {appName} app. No need to wait for an email or queue at the station.</p>\n        <p>Scan the QR code at the station ticket gate (where barcode scanners are available) or show to staff when asked.</p>\n        <p>If you\u2019re buying on behalf of another person, please do so from their account or select a different collection method.</p>\n        <p>Please note: sTickets are not accepted on London Underground services.</p>',
    'delivery.sticket.recommended': 'Recommended',
    'delivery.moreInfo': 'more info',
    'delivery.moreInfoTitle': 'More info',
    'delivery.moreInfo.aria': 'Click here for more information about {optionName} option.',
    'delivery.collect-from-station': 'Collect ticket from station',
    'delivery.e-ticket': 'Download eTicket',
    'delivery.e-ticket.gPass': 'Google Pass',
    'delivery.e-ticket.aPass': 'Apple Pass',
    'delivery.e-ticket.detail': '\n        <p>An eTicket is a digital ticket with a QR code. Once your booking is complete, you will be sent a separate email with your download options:</p>\n        <ul class="list-bullets-modal">\n            <li>Add the eTicket to your Apple or Google Wallet (recommended)</li>\n            <li>Print the PDF document with your eTicket</li>\n            <li>Forward the PDF attachment to the intended user so that they can print or add the eTicket to their mobile.</li>\n        </ul>\n        <p>Scan the QR code at the ticket gate at the station (where barcode scanners are available) or show to staff when asked.</p>\n        <p>Please note: eTickets are not accepted on London Underground services.</p>\n        {eTicketsFaqLink, select, null {} other {<p>See {eTicketsFaqLink} for more information.</p>}}',
    'delivery.e-ticket.faqsLinkText': 'eTicket FAQs page',
    'delivery.e-ticket.recommended': 'Recommended',
    'delivery.e-ticket.firstBenefit': 'Instantly available to download on your phone, no need to queue at the station.',
    'delivery.e-ticket.warning.message': 'eTickets are not available for Travelcards, Boundary Zone tickets and journeys involving London Underground.',
    'delivery.e-ticket.postal.message': 'You will receive a printed eTicket.',
    'delivery.sTicket.firstBenefit': 'Instantly available to download in the Southeastern app. No need to wait for an email or queue at the station',
    'delivery.print.daySave.message': '<p>Our new tickets have been designed to be more sustainable and easier to recycle. Just scan the barcode on the gate at the station and show to staff when asked.</p>',
    'delivery.print-at-home': 'Print@Home Ticket',
    'delivery.print-at-home.detail': '<p>Print at Home tickets are only valid when presented with a valid form of identification (ID) issued in the name of the person holding the ticket. This can be in the form of a Credit/Debit card, Passport or Driving License. You may be asked to show your ID along with your Print at Home ticket if requested by a member of staff.</p><p>Your ticket is only valid on Gatwick Express trains and will not be accepted on trains run by any other operator.</p><p>Once your booking has been completed your ticket will be sent to you. This must be printed by you on plain white A4 paper prior to making your journey.</p>',
    'delivery.print-at-home.instructions': 'Lead passenger <strong>MUST</strong> be travelling and will need to show ID when asked.</br><strong>ALL</strong> passengers must travel together.',
    'delivery.1st-class-mail': '1st Class Mail',
    'delivery.1st-class-mail.detail': '<p>Tickets purchased by 16:00 will be processed and dispatched within 24 hours of booking using Royal Mail First Class post. Please allow five working days for delivery.</p><p>Please note we are unable to guarantee delivery of any unsigned for first class post, and would suggest using a ticket machine at the station as it’s quicker, easier and free of charge.</p><p>Applicable to UK addresses only.</p><p>Don’t forget you can get your tickets for free if you purchase them on the <{global.key}> <{global.smartcard}> or collect from a ticket vending machine at a station.</p>',
    'delivery.royal-mail-signed-for-1st-class.detail': '<p>We now offer this service free for bookings over £100.</p><p>For bookings less than £100 you can select this delivery option for a cost of £2.00, it offers:</p><ul><li>Proof of postage.</li><li>Signature on delivery.</li><li>Online confirmation of delivery.</li></ul><p>Please note, we are unable to guarantee next day delivery, if this is a requirement then we recommend you use the Next Day Special Delivery option.</p>',
    'delivery.royal-mail-special-delivery-guaranteed': 'Royal Mail Special Delivery Guaranteed{trademark}',
    'delivery.royal-mail-special-delivery-guaranteed.detail': '<p>Order your tickets by 16:00 and we will guarantee delivery the next working day*.</p><p>{price} (inclusive of VAT) guarantees delivery before 13:00 and provides insurance up to £500.00.</p><p>*Remote areas and Islands of Scotland will take longer to reach. Orders placed on Saturday or Sunday are dispatched on Monday and delivered on Tuesday. Orders placed on a Bank Holiday are dispatched on Tuesday and delivered on Wednesday.</p>',
    'delivery.royal-mail-special-delivery-insured.detail': '<p>Order your tickets by 16:00 and we will guarantee delivery the next working day*.</p><p>{price} (inclusive of VAT) guarantees delivery before 13:00 and provides insurance up to £2500.00.</p><p>*Remote areas and Islands of Scotland will take longer to reach. Orders placed on Saturday or Sunday are dispatched on Monday and delivered on Tuesday. Orders placed on a Bank Holiday are dispatched on Tuesday and delivered on Wednesday.</p>',
    'delivery.add-to-my-key-smartcard.AddAnotherJourneyInfo': 'You can\'t add an another journey because only one ticket can be purchased at a time with the <{global.smartcard}>',
    'delivery.add-to-my-key-smartcard.TooManyTicketsOnSmartcardError': 'Unavailable because you have reached the maximum number of tickets on your <{global.smartcard}>.',
    'delivery.add-to-my-key-smartcard.TooManyTicketsInBasketError': 'Unavailable because only one smart ticket can be purchased at a time.',
    'delivery.add-to-my-key-smartcard.TooManyAdultTicketsInBasketError': '<p>To use your <{global.key}> <{global.smartcard}> you need to remove a ticket(s) from the basket to match the smartcards on your account.</p><p>Find out more about linking accounts click <a href={url}>here</a></p>',
    'delivery.add-to-my-key-smartcard.TooManyChildTicketsInBasketError': '<p>To use your <{global.key}> <{global.smartcard}> you need to remove a ticket(s) from the basket to match the smartcards on your account.</p><p>Find out more about linking accounts click <a href={url}>here</a></p>',
    'delivery.add-to-my-key-smartcard.NotEnoughActiveSmartcardsError': '<p>Unavailable because you have <strong>{adultTicketCount} adult ticket{adultTicketCount, plural, =1{} other{s}}</strong> and <strong>{childTicketCount} child ticket{childTicketCount, plural, =1{} other{s}}</strong> in your basket but only <strong>{adultSmartcardCount} adult <{global.key}> <{global.smartcard}>{adultSmartcardCount, plural, =1{} other{s}}</strong> and <strong>{childSmartcardCount} child <{global.key}> <{global.smartcard}>{childSmartcardCount, plural, =1{} other{s}}</strong> linked to your account.</p><p>To use <{global.key}> <{global.smartcard}> you need to <strong>remove a ticket(s)</strong> from the basket to match the <{global.smartcards}> on your account.</p>',
    'delivery.add-to-my-key-smartcard.SmartcardCantBeDeliveredInTimeError': '<strong>Unavailable as there is not enough time to guarantee delivery before start date. Please allow five working days for delivery.</strong>',
    'delivery.add-to-my-key-smartcard.PendingSmartcardError': 'Unavailable because your new <{global.smartcard}> request is being processed.',
    'delivery.add-to-my-key-smartcard.PendingActionlistError': 'Unavailable because you have a previous smart ticket still to be collected onto your <{global.smartcard}>.',
    'delivery.add-to-my-key-smartcard.ExpiredSmartcardError': 'Unavailable because your <{global.smartcard}> has expired.',
    'delivery.add-to-my-key-smartcard.InvalidSmartcardStatusError': 'Unavailable because your <{global.smartcard}> is not valid.',
    'delivery.add-to-my-key-smartcard.InvalidKeygoError': 'To continue with your <{global.keyGo}> Carnet purchase, you need to register for <{global.keyGo}>.',
    'delivery.add-to-my-key-smartcard.InvalidKeygoError.button': 'Register for <{global.keyGo}>',
    'delivery.add-to-my-key-smartcard.NotEnoughTimeToActionlistTicketError': 'There is not enough time to action list the ticket for customers with a <{global.smartcard}>.',
    'delivery.add-to-my-key-smartcard.NotCorrectAgeForFareError': 'This fare is not valid for your <{global.smartcard}> due to age restrictions.',
    'delivery.add-to-my-key-smartcard.DisabledPreEncodeError': 'Unfortunately, you cannot currently load this ticket onto your <{global.smartcard}>.',
    'delivery.add-to-my-key-smartcard.SmartCarnetExceededNumberOfPassesError': '<p><{global.keyGo}> carnet in your basket have exceeded the maximum limit of 30.</p><p><strong>Please reduce the number of <{global.keyGo}> carnet from your basket to proceed.</strong></p>',
    'delivery.add-to-my-key-smartcard.InvalidCarnetTicketTypeError': '<p>Your basket contains <{global.keyGo}> carnets and other types of tickets.</p><p><strong>Please remove non <{global.keyGo}> carnet tickets from your basket to proceed.</strong></p',
    'delivery.add-to-my-key-smartcard.AssignToNewSmartcardError': 'Select a linked <{global.key}> <{global.smartcard}> below. If this ticket is intended for you, please choose a start date of <b>{deliveryDate}</b> or later to allow delivery of your new <{global.key}> <{global.smartcard}>.',
    'delivery.add-to-my-key-smartcard.NoSmartcardError': 'You do not have a <{global.key}> <{global.smartcard}> with which to collect your ticket.',
    'delivery.smartcard.firstBenefit': '<{global.key}> <{global.smartcard}> won’t wear out like paper tickets',
    'delivery.smartcard.secondBenefit': 'If you lose your <{global.key}> <{global.smartcard}>, we’ll send you a replacement free of charge',
    'delivery.smartcard.thirdBenefit': 'One Click Delay Repay notifications – Sign up and we’ll prepare a claim for you if you are delayed 15 mins or more.',
    'delivery.fulfilment-options-info': 'Details on all <strong>fulfilment options</strong>',

    'delivery.smartcard-passengers.assign-instruction': 'Assign ticket(s) to your <{global.key}> <{global.smartcard}> or linked <{global.key}> <{global.smartcard}> accounts',
    'delivery.smartcard-passengers.assign-select-placeholder': 'Assign to a <{global.key}> <{global.smartcard}>',
    'delivery.smartcard-passengers.error': 'You must assign the ticket to either your Key Smartcard or a linked Smartcard account from the list above.',
    'delivery.smartcard-passengers.your-smartcard': 'Your <{global.key}> <{global.smartcard}>',
    'delivery.smartcard-passengers.new-smartcard': 'New <{global.key}> <{global.smartcard}>',
    'delivery.smartcard-passengers.card-ending': 'Card number ending',
    'delivery.smartcard-passengers.instruction': 'Tickets must be loaded onto each individual Smartcard before travel',
    'delivery.royal-mail-recorded-delivery.detail': 'delivery.royal-mail-signed-for-1st-class.detail',
    'delivery.royal-mail-special-delivery.detail': 'delivery.royal-mail-special-delivery-guaranteed.detail',
    'delivery.the-key-smartcard': 'Load to the <{global.key}> <{global.smartcard}>(s)',
    'delivery.more-info.postal.paper-tickets-info': '(Paper Tickets)',

    'delivery.smartcard.flexiWarning.heading': 'Important information',
    'delivery.smartcard.flexiWarning.bodyCopy1': 'Do you have <{global.keyGo}> registered on your Key Smartcard?',
    'delivery.smartcard.flexiWarning.bodyCopy2': 'If so, you\'ll need to register for a second Key Smartcard before you buy your Flexi Season ticket, more details can be found below.',
    'delivery.smartcard.flexiWarning.moreInfo': 'More information about keyGo and Flexi Season',
    'delivery.smartcard.flexiWarning.acknowledge': 'Yes, I understand',
    'delivery.smartcard.flexiWarning.continue': 'Continue to payment',

    'delivery.smartcard.button.another-station': 'Press to choose another station to collect your ticket',

    'delivery.name': 'Full name',

    'delivery.sticket.benefits.card.first.title': 'Immediate Access',
    'delivery.sticket.benefits.card.first.info': 'Available immediately in the Southeastern app',
    'delivery.sticket.benefits.card.second.title': 'Easy access',
    'delivery.sticket.benefits.card.second.info': 'Stored securely in the Southeastern app ready to use',
    'delivery.sticket.benefits.card.third.title': 'Scan through',
    'delivery.sticket.benefits.card.third.info': 'No need to hang around the station, just scan and go',

    'delivery.eticket.benefits.card.first.title': 'Quick delivery',
    'delivery.eticket.benefits.card.first.info': 'Barcode ticket available immediately by email',
    'delivery.eticket.benefits.card.second.title': 'Easy access',
    'delivery.eticket.benefits.card.second.info': 'Add your eTicket to your phone wallet or print at home',
    'delivery.eticket.benefits.card.third.title': 'Scan through',
    'delivery.eticket.benefits.card.third.info': 'No need to hang around the station, just scan and go',

    'delivery.smartcard.benefits.card.first.title': 'Quick delivery',
    'delivery.smartcard.benefits.card.first.info': 'Load your ticket at home with the Southeastern app within 5 mins',
    'delivery.smartcard.benefits.card.second.title': 'Tap through',
    'delivery.smartcard.benefits.card.second.info': 'No need to hang around the station, just tap and go',
    'delivery.smartcard.benefits.card.third.title': 'Travelcard ready',
    'delivery.smartcard.benefits.card.third.info': 'Can include TfL travel in London when you buy a Travelcard ticket',

    'delivery.option.type.eTicket': 'eticket',
    'delivery.option.type.sTicket': 'sticket',
    'delivery.option.type.smartcard': 'smartcard',

    'booking.delivery.ToD': 'Collect from station',
    'booking.delivery.notAvailable': 'Sorry. There are no collection or delivery options available for your order.',
    'booking.delivery.notAvailable.paper': 'Sorry. There are no collection or delivery options available for your order. This may be because you are attempting to buy a paper ticket within { todCollectionMinimumTime } of your time of departure.',
    'booking.delivery.smartcardCollectionNotPossible': '<{global.smartcardUppercase}> ticket collection not possible',
    'booking.delivery.smartcardWithinTwoHours': 'You cannot buy a <{global.smartcard}> ticket where your journey starts less than 2 hours after your purchase time, as it may take up to 2 hours before your ticket is ready to collect.',
    'booking.delivery.smartcardFull': 'Your <{global.smartcard}> is currently full, and has no capacity to load another product.',
    'booking.delivery.smartcardBusy': 'There is another ticket awaiting collection on your card.',
    'booking.delivery.smartcardLoginOrRegister': 'Add to a new, or existing, <{global.key}> <{global.smartcard}> ',
    'booking.delivery.smartcardApply': 'Add to a new <{global.key}> <{global.smartcard}> ',
    'booking.delivery.smartcardUnavailable': '<{global.key}> <{global.smartcard}> unavailable',
    'booking.delivery.smartcard.modal.title': 'Download your tickets at home, instantly',
    'booking.delivery.smartcard.modal.body': 'Using the {brand} On Track mobile app, load your ticket straight onto your <{global.key}> <{global.smartcard}> by simply tapping the <{global.smartcard}> onto the back of your phone after purchase.',
    'booking.delivery.smartcard.modal.cta': 'Download our app from the App Store or Google Play',
    'booking.delivery.loadSmartcardIllustration': 'Load <{global.smartcard}> illustration',
    'booking.delivery.sticket.modal.title': 'Download your sTickets at home, instantly',
    'booking.delivery.tryAnotherSearch': 'Try another search',
    'booking.delivery.free': 'Free',
    'booking.delivery.unavailable': 'Unavailable',
    'booking.delivery.unavailable.body': "We're sorry, but you won't be able to pick up this Season ticket from the station or receive it via post. Please choose another way to collect it instead",
    'booking.delivery.unavailable.smartcard': "Sorry, we couldn't find any ways to collect this ticket right now because of a technical problem. Please come back later and try again.",
    'booking.delivery.smartcard.differingCollectionStationWarning': 'booking.delivery.ticketondeparture.differingCollectionStationWarning',

    'booking.delivery.header.smartcard': '<{global.key}> <{global.smartcard}> ticket collection',
    'booking.delivery.loadingstation': 'Select the station that you would like to load your tickets from',
    'booking.delivery.loadingdate': 'Choose a loading date',

    'booking.delivery.loading.info.gtr': 'Activate your Flexi Pass just before you travel. Once activated, Flexi Passes cannot be cancelled and are non-refundable',

    'booking.delivery.loading.important.gtr1': 'Please note',
    'booking.delivery.loading.important.gtr2': ' – when collecting from station gate or validator, your Flexi day pass will also be activated at the same time.',

    'booking.delivery.loadingdate.info': 'Please allow a minimum of two hours after purchase before loading the ticket(s) to the <{global.key}> <{global.smartcard}>(s) or use the {brand} On Track mobile app to load the ticket(s) now.',
    'booking.delivery.loading.info.interop': 'You can also load your Flexi Season ticket at one of our ticket offices near you, please allow a minimum of two hours after purchasing for loading via ticket offices.',
    'booking.delivery.loadingdate.info.short': 'You can now load your tickets onto your <{global.key}> <{global.smartcard}> instantly using our app',

    'booking.delivery.loadingdate.downloadGTR': 'You can load and activate your Flexi Season tickets within 15 minutes via our {brand} On Track mobile app. ',
    'booking.delivery.loadingdate.downloadGTRPaymentConfirmation': 'Please use the {brand} On Track mobile app to load your ticket to your Key Smartcard now.',
    'booking.delivery.loading.collectViaAppNow': 'Please use the {brand} On Track mobile app to load the ticket to your Key Smartcard.',
    'booking.delivery.loading.collectViaAppNowLinking': 'Please use the {brand} On Track mobile app to load the ticket(s) to your Key Smartcard(s).',
    'booking.delivery.loadingdate.secondaryInfoGTRPartOne': 'You can load and activate your Flexi Season by placing your smartcard at the station gates and validators.',
    'booking.delivery.loadingdate.secondaryInfoGTRPartTwo': 'Please select the station that you would like to load and activate Flexi Season from. Please allow a minimum of two hours after purchasing to load via station gates and validators.',

    'booking.delivery.loadingdate.orderInfoGTRPartOne': 'You can load and activate your Flexi Season by placing your smartcard at {location} station gates and validators. ',
    'booking.delivery.loadingdate.orderInfoGTRPartTwo': 'Please allow a minimum of two hours after purchasing to load via station gates and validators.',

    'booking.delivery.smartcard.number': '<{global.key}> <{global.smartcard}> number',
    'booking.delivery.smartcard.noselected': "Are you sure you don't want to proceed with a <{global.key}> <{global.smartcard}>?",
    'booking.delivery.smartcard.noselected.back': 'Continue with <{global.key}> <{global.smartcard}>',
    'booking.delivery.smartcard.noselected.continue': "Yes, I'm sure",
    'booking.delivery.button.back': 'Go back',
    'booking.delivery.goBack.modal.title': 'Go back options',

    'booking.additional-fares-collapsible.trigger': 'View all available fares',

    'booking.additional-fares-collapsible.trigger-v2-show': 'See <b>all</b> available fares',
    'booking.additional-fares-collapsible.trigger-v2-hide': 'Hide <b>all</b> available fares',

    'booking.fare-category.select-one': 'Select an outward fare',

    'booking.fare-category.go': 'Go',
    'booking.fare-category.cta': 'View <span>{type}</span> tickets',

    'booking.fare-category.cheapest': 'Cheapest',
    'booking.fare-category.return': '(Rtn)',
    'booking.fare-category.title.Advance': 'Advance',
    'booking.fare-category.title.Advance.return': 'Singles',
    'booking.fare-category.title.OffPeak': 'Off Peak',
    'booking.fare-category.title.OffPeak.return': 'Off Peak',
    'booking.fare-category.title.Anytime': 'Anytime',
    'booking.fare-category.title.Anytime.return': 'Anytime',

    'booking.fare-category.sub-title.Advance': 'Non-Flexible',
    'booking.fare-category.sub-title.Advance.return': 'For most ticket types, including Advance',
    'booking.fare-category.sub-title.OffPeak': 'Semi-flexible tickets, often with time and/or date restrictions',
    'booking.fare-category.sub-title.OffPeak.return': 'Semi-flexible tickets, often with time and/or date restrictions (Return)',
    'booking.fare-category.sub-title.Anytime': 'Fully flexible, for travel at any time of day',
    'booking.fare-category.sub-title.Anytime.return': 'Fully flexible, for travel at any time of day (Return)',

    'booking.fare-category.description.Advance': '<p><span class="main-title">Advance</span> - book in advance for travel on a specific service.</p><p>Advance tickets are single fares offering great value for money on many journeys. In most cases you must book in advance up to the day before travel and these tickets are subject to availability.</p> <p>Generally, the earlier you book the better the deal. Tickets are normally available up to 12 weeks before travel – earlier on some routes. You will need to choose a specific train at the time of booking and must travel on that service. No break of journey is allowed except to change between trains.</p> <p>Advance fares are valid only on the date and train shown on the ticket. Advance tickets are non-refundable but may be amended prior to the date and time of travel.</p>',
    'booking.fare-category.description.OffPeak': '<p><span class="main-title">Off-Peak Single tickets</span> - semi-flexible tickets with time and/or date restrictions.</p><p>Off-Peak tickets are for use on trains that are less busy and are cheaper than Anytime tickets. You will have to travel at certain times of the day and/or days of the week, and sometimes on specific routes or operators. Some train companies sell even cheaper Super Off-Peak tickets which are valid on the least busy services.</p> <p>In most cases you may break your journey at any point, or more than once if you wish. Where this is not the case it will be stated in the restrictions shown for that ticket, available at the time of purchase.</p> <ul class="list-fancy"><li>Off-Peak Day Single tickets are valid for one single journey on the date shown on the ticket</li> <li><p>Off-Peak Single tickets are valid for one single journey on the date shown on the ticket. If you cannot complete your journey on the same day you will be allowed to finish it the following day.</p> <p>If you board a train at a time when your Off-Peak ticket is not valid, you will be charged the difference between the fare you’ve paid and the cheapest valid fare for the service concerned.</p></li></ul>',
    'booking.fare-category.description.Anytime': '<p><span class="main-title">Anytime Single tickets</span> - fully flexible, for travel at any time of day.</p> <ul class="list-fancy"><li>Anytime Day Single tickets are valid for one single journey on the date shown on the ticket.</li> <li>Anytime Single tickets are valid for one single journey, and are valid for two days beginning from the date shown on the ticket. You may need to travel by a specific route or train company but the ticket will state this. You are allowed to break your journey at any point, or more than once if you wish. This means that you do not have to make the whole of your journey at the same time or, where allowed, on the same day.</li></ul>',
    'booking.fare-category.description.Advance.return': '<{booking.fare-category.description.Advance}> <{booking.fare-category.description.OffPeak}> <{booking.fare-category.description.Anytime}> ',
    'booking.fare-category.description.OffPeak.return': '<p><span class="main-title">Off-Peak Return tickets</span> - semi-flexible tickets with time and/or date restrictions.</p><p>Off-Peak tickets are for use on trains that are less busy and are cheaper than Anytime tickets. You will have to travel at certain times of the day and/or days of the week, and sometimes on specific routes or operators. Some train companies sell even cheaper Super Off-Peak tickets which are valid on the least busy services.</p> <p>In most cases you may break your journey at any point, or more than once if you wish. Where this is not the case it will be stated in the restrictions shown for that ticket, available at the time of purchase.</p><ul class="list-fancy"><li>Off-Peak Day Return tickets are valid for one return journey on the date shown on the ticket</li><li>Off-Peak Return tickets are valid for one return journey. The outward part is valid for travel on the date shown on the ticket, if the return part has not been used. If you cannot complete your journey on the same day, you will be allowed to finish it the following day. The return part is valid for one calendar month from the start date shown on the ticket.</li></ul> <p>If you board a train at a time when your Off-Peak ticket is not valid, you will be charged the difference between the fare you’ve paid and the cheapest valid fare for the service concerned.</p>',
    'booking.fare-category.description.Anytime.return': '<p><span class="main-title">Anytime Return tickets</span> - fully flexible, for travel at any time of day.</p><ul class="list-fancy"><li>Anytime Day Return tickets are valid for one return journey on the date shown on the ticket.</li><li>Anytime Return tickets are valid for one return journey. The outward part is valid for five days unless otherwise shown and the return part is valid for one calendar month from the start date shown on the ticket.</li></ul><p>You may need to travel by a specific route or train company but the ticket will state this. You are allowed to break your journey at any point, or more than once if you wish. This means that you do not have to make the whole of your journey at the same time or, where allowed, on the same day.</p>',

    'booking.fare-category.restriction.Advance': 'Advance fares are valid only on the date and train shown on the ticket. Advance tickets are non-refundable but may be amended prior to the date and time of travel',

    'booking.fare-category.standard': 'Standard',
    'booking.fare-category.first-class': 'First Class',

    'booking.journey-modal.title': 'Update your search',
    'booking.basket-modal.title': 'Selected tickets',

    'booking.fare-row.more-info': 'More info',

    'booking.toc-specific-search.button': 'Show cheapest {toc} fares',
    'booking.usp.noBookingFees.banner': 'No booking fees!',
    'booking.usp.noBookingFees.inline': 'No booking fee',

    'booking.search-type-caveat.cheapest-start': 'Above tickets are for services on the <b>cheapest available trains.</b> Click',
    'booking.search-type-caveat.cheapest-end': 'to check if faster services are available.',
    'booking.search-type-caveat.fastest-start': 'The fares above are based on the <b>fastest available trains.</b> Click',
    'booking.search-type-caveat.fastest-end': 'to check if slower routes with cheaper fares are available.',

    'booking.service-carousel.no-results': 'No results for this search, ',
    'booking.service-carousel.no-results-link': 'try changing your search parameters',

    'booking.service-carousel.no-results-v2': 'No results found',
    'booking.service-carousel.no-results-link-v2': 'No results for this search, try changing your search parameters',

    'booking.service-carousel.title.outward': 'Outward',
    'booking.service-carousel.title.inward': 'Return',
    'booking.service-carousel.item.cancelled': 'Cancelled',
    'booking.service-carousel.item.delayed': 'Delayed',
    'booking.service-carousel.item.on-time': '<{journey.duration.on-time}>',
    'booking.service-carousel.item.late': '<{journey.duration.late}>',
    'booking.service-carousel.item.tocDetails.single': '{toc} Service',
    'booking.service-carousel.item.tocDetails.multiple': 'Part {toc}',
    'booking.service-carousel.overtaken': 'Overtaken',

    'booking.service.departure-label': 'Leaves at:',
    'booking.service.arrival-label': 'Arrives at:',
    'booking.service.duration-label': 'Duration:',
    'booking.service.changes-label': 'Changes:',
    'booking.service.select-service': 'Select service, ',
    'booking.service.selected-service': 'Selected service, ',

    'booking.basket.addReturn': 'Add return from {price}',
    'booking.basket.collapse': 'Hide selected',
    'booking.basket.expand': 'Show selected',
    'booking.basket.sub-total': 'Total:',
    'booking.basket.basket-total': 'Basket total:',
    'booking.basket.continue': 'Continue',
    'booking.basket.add-to-basket': 'Add to basket',
    'booking.basket.or': 'or',
    'booking.basket.get-refund': 'Proceed to refund',
    'booking.basket.back': 'Back',
    'booking.basket.cheapest-selected': 'We have selected the cheapest shown tickets for you',
    'booking.basket.item.more-info': 'More info',
    'booking.basket.item.title-to': 'to',
    'booking.basket.item.single-outward': 'Out',
    'booking.basket.item.single-inward': 'Rtn',
    'booking.basket.item.return': 'Out',
    'booking.basket.item.open-return': '<b>Open Return:</b>within 1 month',
    'booking.basket.travelcard-fares': 'Travelcard fare',
    'booking.basket.travelcard.cta': 'Click to see available fares',
    'booking.basket.price-label': 'Total',
    'booking.basket.continue-button': 'Continue',
    'booking.basket.help.select-day-save-fare': 'To continue, you need to select a DaySave ticket',
    'booking.basket.help.select-rovers-fare': 'To continue, you need to select a Rover ticket',
    'booking.basket.help.passenger-details': 'To continue, you need to fill in all required passenger details',
    'booking.basket.help.select-season-fare': 'To continue, you need to select a season ticket',
    'booking.basket.help.select-outward-fare': 'To continue, you need to select an outward ticket',
    'booking.basket.help.select-both-fares': 'To continue, you need to select an outward and a return ticket',
    'booking.basket.help.select-inward-fare': 'To continue, you need to select a return ticket',
    'booking.basket.help.open-golf': 'To continue, you need to add at least one ticket to the basket',
    'booking.basket.help.select-non-overlapping-services': 'The return train you have chosen will already have departed when your outward train arrives at its destination.',
    'booking.basket.seating-reservation.trigger': 'Reserve seats',
    'booking.basket.seating-reservation.trigger.edit': 'Change seats',
    'booking.basket.seating-reservation-v2.trigger': 'Reserve my seats',
    'booking.basket.seating-reservation-v2.trigger.edit': 'Change selected seats',
    'booking.basket.plusbus.trigger': 'Buy PlusBus',
    'booking.basket.plusbus.trigger.edit': 'Change PlusBus',
    'booking.basket.plusbus-v2.trigger': 'Add PlusBus from',
    'booking.basket.plusbus-v2.trigger.edit': 'Modify PlusBus',
    'booking.basket.photo-card-trigger': 'Photocard details',
    'booking.basket.passengers-trigger': 'Passenger details',
    'booking.basket.oyster-trigger': 'With Contactless',
    'booking.basket.oyster-weekly-cap.trigger': 'Contactless Weekly Capping',
    'booking.basket.travelcard-trigger': 'Get a Travelcard from ',

    'booking.header.edit-journey': 'Change journey details',
    'booking.header.edit-journey-v2': 'Amend search',
    'booking.header.tabs.sr-optimised': '. This view is optimised for screen readers',
    'booking.header.tabs.list': 'List',
    'booking.header.tabs.grid': 'Grid',
    'booking.tutorial.railcard': '<strong>Great!</strong> 1/3 off prices have been applied to your tickets below',

    'booking.filters.go-cheaper': 'Go Cheaper',
    'booking.filters.go-faster': 'Go Faster',
    'booking.filters.go-1st-class': 'Go 1st Class',

    'booking.filters.go-cheaper.sr-only': 'select the cheapest fare',
    'booking.filters.go-faster.sr-only': 'select the fastest fare',
    'booking.filters.go-1st-class.sr-only': 'select the cheapest first class fare',

    'booking.layout.grid': 'Use grid view',
    'booking.layout.list': 'Use list view',

    'booking.payment.button.back': 'Go back',
    'booking.payment.button.addjourney': 'Add another journey',
    'booking.payment.header': 'Payment details',
    'booking.payment.choosePaymentMethod': 'Choose your payment method',
    'booking.payment.paymentOption.google-pay': 'Google Pay',
    'booking.payment.paymentOption.apple-pay': 'Apple Pay',
    'booking.payment.choosePaymentMethodDeliveryAddress': 'Choose your payment method and delivery address',
    'booking.payment.help.select-payment-method': "To continue, you need to select a payment method",
    'booking.payment.reward.apply.aria': 'Apply reward code',
    'booking.payment.reward.remove.aria': 'Remove reward code',
    'booking.payment.reward.title': 'Reward code',
    'booking.payment.reward.remove': 'Remove code',
    'booking.payment.reward.login': 'If you have a Reward code, please {loginButton} to apply it to your order',
    'booking.payment.reward.loggedIn': 'If you have a Reward code, please input it here. The reward will be available in your booking confirmation email',
    'booking.payment.reward.confirmation.title': 'You’ve earned a reward for this order',
    'booking.payment.reward.confirmation.description': 'Details of how to claim your reward can be found in your booking confirmation email',
    'booking.service-list.outward.returnPrice': 'Return {isSingle, select, true {from } other {}}',
    'booking.service-list.inward.returnPrice': 'Total ',
    'booking.service-list.services.title': 'Choose <b>{direction, select, outward {Outbound} inward {Return} other {}}</b>',
    'booking.service-list.service.moreFares': 'Other fares available',
    'booking.service-list.service.moreFares.sr': 'press to find other fares for this journey',
    'booking.service-list.service.moreInfo': 'Journey info',
    'booking.service-list.service.reservations': 'Journey info & reserve seating',
    'booking.service-list.service.reservations.sr': 'press to find out more information about this journey',
    'booking.service-list.service.cancelled': 'Train cancelled',
    'booking.service-list.service.warningsMore': '{count} more',
    'booking.service-list.service.warningsMore.label': '{count} more service-related message{count, plural, =1{} other{s}}',
    'booking.service-list.service.fare.label': 'Featured fare',
    'booking.service-list.service.selectFare.label': '{price, select, false{} other{{price}.}} Press to select the cheapest fare for this service',
    'booking.service-list.service.selectFixedFare.label': 'Press to select this return service',
    'booking.service-list.service.fastestJourney.label': 'This is the fastest journey time displayed.',
    'booking.service-list.service-modal.button.viewServices': 'View other services',
    'booking.service-list.service-modal.button.selectReturn': 'Select this return service',
    'booking.service-list.service-modal.button.viewFares': 'Other fares for this service',
    'booking.service-list.service-modal.button.selectFare': 'Add to basket',
    'booking.service-list.fares.title': 'Choose your ticket',
    'booking.service-list.fares.changeService': 'Change service',
    'booking.service-list.fares.toggleFirstClass': '<b>1st Class</b> (from £{cheapestPrice})',
    'booking.service-list.fare.title': '{name} ({code})',
    'booking.service-list.fare.moreInfo': 'More info',
    'booking.service-list.fare.moreInfo.label': 'More info for this fare',
    'booking.service-list.fare.selectFare.label': '{price, select, false{} other{{price}.}} Press to select {name}',
    'booking.service-list.fare.class': '{class, select, standard {Standard} other {First Class}}',
    'booking.service-list.fare.class.label': '{class, select, standard {Standard class} other {First Class}}',
    'booking.service-list.fares.classCheapest': '(from £{cheapestPrice})',
    'booking.service-list.views.label': 'Choose journey planner view',
    'booking.service-list.views.title': 'View',
    'booking.service-list.views.list': 'List',
    'booking.service-list.views.list.label': 'List view',
    'booking.service-list.views.grid': 'Grid',
    'booking.service-list.views.grid.label': 'Grid view',
    'booking.service-list.loading.label': 'Loading trains',
    'booking.service-list.results.label': '{count, plural, =1{1 journey} other{# journeys}} found',
    'booking.service-list.noResults.label': 'No journeys found',
    'service-info.modal.title': 'Journey info',
    'service-info.modal.heading': '{direction, select, outward {Outbound} other {Return}} journey',
    'booking.smartCarnet.offPeak': 'Off Peak',
    'booking.smartCarnet.peak': 'Peak',

    'booking.fareDetails.refunds.advanceTicket': "Advance fares are valid only on the date and time shown on the ticket. Advance tickets are non-refundable but may be amended prior to the date and time of travel, subject to a £10 administration fee.<br><br>If your journey is cancelled or disrupted, arrangements will be made to accommodate you on another train. If the train you purchased a ticket for is cancelled or delayed, and as a result you decide not to travel, a full refund will be available, and you will not be charged an administration fee.",
    'booking.fareDetails.refunds.dayTicket': "This ticket is refundable. If you decide not to use your ticket to make all or part of your intended journey, you can get a refund within 28 days of the journey date.<br><br>You may be required to pay an administration fee, up to a maximum of £5 per order. The refund amount will normally consider any use you have made of the ticket and in some circumstances no refund will be paid.",
    'booking.fareDetails.refunds.daySaveOffPeak': 'This ticket cannot be changed or refunded.',
    'booking.fareDetails.refunds.seasonTicket': "This ticket is refundable. If you decide not to use your ticket to make all or part of your intended journeys, you can get a refund within 28 days of the ticket expiry date.<br><br>You will be required to pay an administration fee, up to a maximum of £5 per order. Any refund is calculated from the date the Season ticket is returned and will be the difference between the price you paid and the cost of a ticket or tickets for the period for which you have actually used the ticket. In some circumstances no refund will be due.<br><br>Please make sure you bring your Railcard(s) with you.",
    'booking.fareDetails.refunds.flexiTicket': "This ticket is refundable. Most Flexi Season tickets will need at least two passes remaining for a refund to be possible. But there are some routes that may need more or fewer passes remaining.<br><br>You must apply for a refund before the end of the Flexi Season ticket's 28-day validity period.<br><br> You will be required to pay an administration fee, up to a maximum of £5 per order. Any refund is calculated from the date the Season ticket is returned and will be the difference between the price you paid and the cost of a ticket or tickets for the period for which you have actually used the ticket. In some circumstances no refund will be due.<br><br>Please make sure you bring your Railcard(s) with you.",

    'customerdetails.title': 'Title',
    'customerdetails.initials': 'Initials',
    'customerdetails.initial': 'Initial',
    'customerdetails.name': 'First Name',
    'customerdetails.surname': 'Surname',
    'customerdetails.contactname': 'Contact Name',
    'customerdetails.addressline1': 'Address line 1',
    'customerdetails.addressline2': 'Address line 2',
    'customerdetails.addressline3': 'Address line 3',
    'customerdetails.towncity': 'Town/City',
    'customerdetails.postcode': 'Postcode',
    'customerdetails.country': 'Country',
    'customerdetails.country.select': 'Choose a country...',
    'customerdetails.email': 'Email Address',
    'customerdetails.confirmemail': 'Confirm email address',
    'customerdetails.telephone': 'Contact phone number',
    'customerdetails.countrycode': 'Country Code',
    'customerdetails.mobilephone': 'Mobile phone number',
    'customerdetails.password': 'Password',
    'customerdetails.password.show': 'Show password',
    'customerdetails.password.hide': 'Hide password',
    'customerdetails.password.shown': 'Password visible',
    'customerdetails.password.hidden': 'Password hidden',
    'customerdetails.password.restrictions': 'Must contain min. 8 characters, 1 lowercase, 1 uppercase and 1 digit',
    'customerdetails.photocardFirstname': 'First Name on photocard',
    'customerdetails.photocardLastname': 'Last Name on photocard',
    'customerdetails.photocardNumber': 'Photocard number',
    'customerdetails.photocardAddress': 'Photocard Address:',
    'customerdetails.addressName': 'Address name',

    'customerdetails.dob.day': 'Day',
    'customerdetails.dob.dd': 'DD',
    'customerdetails.dob.mm': 'MM',
    'customerdetails.dob.month': 'Month',
    'customerdetails.dob.year': 'Year',
    'customerdetails.dob.yyyy': 'YYYY',

    'customerdetails.payment.existingcard': 'Use existing card',
    'customerdetails.payment.savecard': 'Save card to speed up future purchases',
    'customerdetails.payment.cardSummary': '{nickname} (**{lastDigits})',
    'customerdetails.payment.cardName': 'Card name',
    'customerdetails.payment.cardholder': 'Cardholder name',
    'customerdetails.payment.cardnumber': 'Card number',
    'customerdetails.payment.cardnumber.placeholder': '0000 0000 0000 0000',
    'customerdetails.payment.expirymonth': 'Expiry month',
    'customerdetails.payment.expirymonth.defaultOption': 'MM',
    'customerdetails.payment.expiryyear': 'Expiry year',
    'customerdetails.payment.expiryyear.defaultOption': 'YYYY',
    'customerdetails.payment.cvv': 'CVV',
    'customerdetails.paymentRegistration.a11y': 'Optional, add a password to create an account',
    'customerdetails.paymentRegistration.title': 'Add a password to create an account',
    'customerdetails.paymentRegistration.subtitle': 'Reasons to create an account:',
    'customerdetails.paymentRegistration.benefits.1': 'Faster checkouts',
    'customerdetails.paymentRegistration.benefits.2': 'Refunds',
    'customerdetails.paymentRegistration.benefits.3': 'Purchase history',

    'passwordHint.length': '{minLength} characters',
    'passwordHint.lowercase': '1 lowercase',
    'passwordHint.uppercase': '1 uppercase',
    'passwordHint.digit': '1 digit',
    'passwordHint.itemOk': 'ok',
    'passwordHint.itemNotOk': 'not ok',
    'paymentCard.none': 'You don’t currently have any card details saved. The next time you buy a ticket you can save your card details by ticking the ‘Save card’ box on the payment screen.',
    'paymentCard.delete': 'Delete card',
    'paymentCard.confirmDelete': 'Please confirm that you wish delete the following saved card:',
    'paymentCard.deleteKeyGoCard': 'This card is associated with a {keygobrand} product on your <{global.key}> <{global.smartcard}>. If you change your method of payment for {keygobrand}, then you will be able to remove this card.',
    'paymentCard.expires': 'Card expiry date',
    'paymentCard.expiryDate': 'Expires: {expiryDate}',

    'orBar.or': 'or',

    'account.login': 'Log in',
    'account.logout': 'Log out',
    'account.login.registerLabel': 'Don\'t have an account?',

    'login.username': 'Email Address',
    'login.password': 'Password',
    'login.link.password': '{accountType} password',
    'login.subtitle': 'Log in to your account',
    'login.modal.body.ariaLabel': 'Login Modal, please enter your email address and password.',

    'login.register.or': 'or',

    'login.forgotPassword.link': 'Forgotten your password?',
    'login.forgotPassword': 'Forgotten password',
    'login.buyTickets': 'Buy tickets',
    'login.resetPassword.help': 'Please choose a new password',
    'login.forgotPassword.help': 'Please enter your email address and we\'ll send you instructions for resetting your password.',
    'login.forgotPassword.submitted': 'You have been sent instructions on how to reset your password.',
    'login.resetPassword.header': 'Reset password',
    'login.resetPassword.success': 'Your password reset was successful and you are now logged in.',
    'login.resetPassword.error': 'Your password reset request may have expired so please try again.',
    'login.register.link': 'Not registered?',
    'login.setPasswordAndPreferences.heading': 'Set Password and Preferences',
    'login.setPasswordAndPreferences.form.action': 'Save',
    'login.setPasswordAndPreferences.modal.title': 'Your password and marketing preferences',
    'login.setPasswordAndPreferences.modal.success.message': 'Your password and preferences have been saved successfully. You are now logged in.',
    'login.setPasswordAndPreferences.modal.error.message': "There's been a problem saving your password and marketing preferences. Please try again and if you still see this message - please contact us.",

    'login.link.amazon.message': 'We have found an existing {accountType} account<br/><b>{email}</b><br/>that matches your Amazon email.',
    'login.link.amazon.loginAccount': 'Please login below to link your {accountType} account with your Amazon account.',
    'login.link.amazon.close': 'Cancel',
    'login.link.amazon.confirm': 'OK',
    'login.link.amazon.title': 'Link your account with Amazon',
    'login.link.amazon.continueText': 'Link accounts',
    'login.link.amazon.closeText': 'Cancel',
    'login.link.amazon.error': 'Wrong {accountType} password. Please try again.',
    'login.link.amazon.success.heading': 'Linking of accounts successful',
    'login.link.amazon.success.message': 'From now on you can also login using just the Amazon Login button.',
    'login.link.amazon.success.title': 'You have successfully linked your Amazon and {accountType} accounts',
    'login.amazon.error': 'Login with Amazon failed. Please try again later.',

    'login.registerFirst.message': 'You don\'t have a <b>{accountType}</b> account yet.<br><br> Please register now in order to use Amazon Login to <span class="text-nowrap">sign you in</span>.',
    'login.registerFirst.title': 'Register',
    'login.registerFirst.closeText': 'Cancel',
    'login.registerFirst.continueText': 'Register',

    'login.syncEmail.amazon.message': 'Your Amazon email <b>{amazonEmail}</b> is different than your {accountType}\'s account email <b>{accountEmail}</b>.<br/><br/>Would you like to update your account email to match the Amazon one?',
    'login.syncEmail.amazon.title': 'Update email',
    'login.syncEmail.amazon.closeText': 'Maybe later',
    'login.syncEmail.amazon.continueText': 'Update email',

    'amazonLogin.name': 'Amazon Login',

    'login.promptPasswordChange.title': 'Welcome back to <{app.owner}>, {firstNames}',
    'login.promptPasswordChange.information': 'We\'re updating our password requirements to help enhance the security of our website and your data.',
    'login.promptPasswordChange.supplementary': 'To help us do this we would like you to choose a brand new password, it should have a minimum of 8 characters, including 1 uppercase letter and 1 number.',
    'login.promptPasswordChange.defer': 'You may choose to do this another time if you prefer.',
    'login.promptPasswordChange.currentPassword': 'Current password',
    'login.promptPasswordChange.newPassword': 'New password',
    'login.promptPasswordChange.error': 'There was a problem changing your password. Please check you have entered your current password correctly, and that your new password fulfils all the criteria.',
    'login.promptPasswordChange.validationError': 'Please check you have entered your current password correctly, and that your new password fulfils all the criteria.',
    'login.promptPasswordChange.success': 'Password successfully updated',
    'login.promptPasswordChange.button.save': 'Save changes',
    'login.promptPasswordChange.button.back': 'Change my password',
    'login.promptPasswordChange.cancel.title': 'Review complete',
    'login.promptPasswordChange.cancel.confirm': 'Thank you for reviewing your security and deciding that you\u2019re happy with your current password.\n                                                You can change your password anytime by going to your Account Details.',

    'login.accountLocked.requestedReset': 'Password reset requested',
    'login.accountLocked.button.reactivate': 'Reactivate',
    'login.accountLocked.titleDefault': 'Action required',
    'login.accountLocked.messageDefault': 'Your account has been locked as you have entered an incorrect password a number of times in succession. In order to regain access to your account, please press the reactivate button below and follow the instructions emailed to you.',
    'login.accountLocked.titleDormant': 'Welcome back',
    'login.accountLocked.messageDormant': 'To help keep your details safe we have temporarily locked your account. Just click Reactivate below and we\'ll send you an email to unlock your account.',
    'login.accountLocked.messageLocked': 'Your account has been locked. Please get in touch with customer services to unlock your account.',
    'login.accountLocked.error': 'There was a problem reactivating your account at this time',

    'photoupload.format-requirements-label': 'Must be in one of the following formats: ',
    'photoupload.buttontext': 'Upload photo',
    'photoupload.error.imageOrientation': 'Image has to be a portrait. Its height must be considerable greater than its width.',
    'photoupload.error.imageOrientationWithDifference': 'Image has to be a portrait. It\'s {difference} pixel(s) too wide.',
    'photoupload.error.fileSize': 'The selected file is too large, please choose another',
    'photoupload.error.unacceptedFileFormat': 'Cannot upload the file. The format is not supported',
    'photoupload.error.required': 'Please upload a valid passport style photo',

    'account.register': 'Register',
    'account.register.smartcard': 'Log in or Register to use your <{global.key}> <{global.smartcard}>',
    'account.register.success': 'Registration successful',
    'account.register.smartcardOnlySuccess': '<{global.smartcardUppercase}> application received',
    'account.register.successMessage': '<dt>Hello, {name}!</dt><dd>Welcome to {brand}.</dd>',
    'account.register.success.button': 'Continue',
    'account.register.partialSuccess': 'There was a problem applying for a <{global.key}> <{global.smartcard}>',
    'account.register.partialSuccessMessage': 'Your account has been registered, and you are now logged in. Please try to apply for a <{global.smartcard}> in the Account section, or contact customer services if the problem persists.',
    'account.register.partialSuccess.button': 'Go',
    'account.register.address': 'Address (Please use your home address)',
    'account.register.opt.description': "We would like to keep you updated about changes to your services, ticket expiries and renewals, and special offers. Please tick the boxes below to let us know which communications you'd like to receive.",
    'account.register.confirm.terms': 'I have read and accept the {terms}',
    'account.register.confirm.privacypolicy': 'I have read and accept the {privacypolicy}',
    'account.register.smartcardActivation': 'You can purchase a smart Season Ticket within the next {preloadTimeLimit}. It will come pre-loaded onto your <{global.key}> card when it is delivered to your home address.',
    'account.register.smartcardPreload': 'You can purchase a smart Season Ticket within the next {preloadTimeLimit}. It will come pre-loaded onto your <{global.key}> card when it is delivered to your home address. Your ticket must start after {awaitSmartcardProductDays} to ensure that you receive it on time.',
    'account.register.smartcardPreload.new': 'new',
    'account.register.smartcardPreload.existing': 'existing',
    'account.register.selfSmartcardError': 'There was a problem applying for a <{global.key}> <{global.smartcard}>',
    'account.register.selfSmartcardErrorMessagePartial': 'Your account has been registered but the <{global.smartcard}> number you have entered is incorrect or is already in use. Please try again with a different <{global.smartcard}> number or contact customer support for further assistance.',
    'account.register.selfSmartcardErrorMessage': 'The <{global.smartcard}> number you have entered is incorrect or is already assigned to another account. Please try again with a different <{global.smartcard}> number or contact customer support for further assistance.',
    'account.register.keyGoPreload': 'You can purchase a smart Season Ticket or add <{global.keyGo}> within the next {preloadTimeLimit}. It will come pre-loaded onto your <{global.key}> <{global.smartcard}> and ready to use when it is delivered to your home address. Your ticket must start after {awaitSmartcardProductDays} to ensure that you receive it on time.',
    'account.register.findDayTicketButtonText': 'Search for Day Tickets',
    'account.register.findSeasonTicketButtonText': 'Search for Season Tickets',
    'account.register.ocdrButtonText': 'Sign up to One Click Delay Repay',
    'auto-dr.account.signup': 'Sign up',
    'account.register.transferTicketButtonText': 'Transfer a ticket',
    'account.register.keygoButtonText': 'Register for <{global.keyGo}>',
    'account.register.loadingStation.fieldLabel': 'Loading station',
    'account.register.loadingStation.fieldPlaceholder': 'Select loading station',
    'account.register.loadingStation.fieldDescription': 'Please allow a minimum of two hours after purchase before loading your ticket onto your <{global.key}> <{global.smartcard}>.',
    'account.register.whatsNext': "What's next?",
    'account.register.smartcardApplicationReceived': 'You can view the progress of your application in your ',
    'account.register.swapSeasonTicket': 'Swap your current paper season ticket for a Key <{global.smartcard}> Season',
    'account.register.viewAccount': 'account',
    'account.register.autoDelayRepay': 'Auto Delay Repay',
    'account.register.oneClickDelayRepay': 'One Click Delay Repay',
    'account.register.autoDelayRepay.description': 'When you travel with us using your new <{global.key}> <{global.smartcard}>, in many cases we can determine when you may have been delayed and create a Delay Repay claim for you. All you have to do is log in and verify the delay and choose how you would like to be reimbursed.\n        Whenever we determine you have been delayed, we will also send you an email alert.',
    'account.register.autoDelayRepay.label': 'I wish to receive One Click Delay Repay email notifications',
    'account.register.withoutSmartcard': 'Continue without registering for a <{global.theKey}> <{global.smartcard}>',
    'account.register.withoutSmartcardAndKeygo': 'Continue without registering for a <{global.theKey}> <{global.smartcard}> and <{global.keyGo}>',
    'account.register.withPaperTransfers.details': 'Transfer a current paper season to a <{global.theKey}> <{global.smartcard}>',
    'account.register.loginLabel': 'Already have an account?',
    'account.register.loginButton': 'Log in',
    'account.register.emailInUse': 'Email address already in use',

    'account.register.alreadyAmazon.heading': 'Register',
    'account.register.alreadyAmazon.title': 'You already have registered with that Amazon account',
    'account.register.alreadyAmazon.message': 'We have logged you in automatically.',
    'account.register.steps.count': 'Step {stepNumber} of {totalSteps}',
    'account.register.steps.details': 'Your details',
    'account.register.steps.smartcard': 'Key smartcard',
    'account.register.steps.preferences': 'Preferences',
    'account.register.steps.back.details': 'Back to your details',
    'account.register.steps.back.smartcard': 'Back to the <{global.key}> <{global.smartcard}>',
    'account.register.password': 'Password',
    'account.register.next': 'Continue',
    'account.register.submit': 'Submit',
    'account.register.subtitle': 'Create an account',
    'account.register.cta.side': 'No {brand} account needed',
    'account.register.cta.main': 'Log in with Amazon',
    'account.register.closeConfirm': 'Are you sure you want to close the form? You will lose all data entered',
    'account.register.footer.close': 'No, go back',
    'account.register.footer.continue': 'Yes, close the form',
    'account.register.continueWithout': 'Continue without',
    'account.register.create': 'Create an account',
    'account.register.continue': 'Continue',
    'account.register.smartcard.labelLong': 'Get the <{global.key}> <{global.smartcard}>',
    'account.register.smartcard.labelShort': 'Continue',
    'account.register.smartcard.forbidden-child-smartcard-registering': 'Children under 16 are not eligible to register for a <{global.smartcard}>.',

    'account.register.details.title': 'Create an account',
    'account.register.details.body': 'Create an account and benefit from:',
    'account.register.details.alt': 'User creating a {brand} account on a laptop',
    'account.register.create.benefits.checkout': 'Faster checkout',
    'account.register.create.benefits.refunds': 'Easy refunds and ticket changes',
    'account.register.create.benefits.history': 'View your purchase history',
    'account.register.create.benefits.updates': 'Service updates and promotions',

    'account.register.smartcard.title': 'Get the<br /> <{global.key}> <{global.smartcard}><br />with your account',
    'account.register.smartcard.title-mobile': 'Get the <{global.key}> <{global.smartcard}><br />with your account',
    'account.register.smartcard.logo.alt': '<{global.smartcard}> logo',
    'account.register.smartcard.body': 'Our <{global.key}> <{global.smartcard}> is a smarter alternative to paper tickets, making it quicker and easier to buy a ticket.',
    'account.register.smartcard.alt': 'User tapping <{global.key}> <{global.smartcard}> on a card reader',
    'account.register.smartcard.benefits.tickets': 'Load season tickets',
    'account.register.smartcard.benefits.app': 'Buy and download your tickets at home with our app',
    'account.register.smartcard.benefits.queues': 'Fast-track through the station and avoid the queues',
    'account.register.smartcard.benefits.contactless': 'Contactless travel, just tap and go',
    'account.register.smartcard.benefits.refunds': 'Quicker refunds',

    'account.register.preferences.title': 'One last thing...',
    'account.register.preferences.body': 'We would like to keep you updated about changes to your services and special offers.',
    'account.register.preferences.alt': 'User receiving notification from {brand} on a mobile device',

    'account.register.amazon.logout.info': 'Your Amazon account is <em>{ email }</em>.',
    'account.register.amazon.logout.action': 'Log out',

    'account.nav.collapse.btn.label': 'Expand the Account Menu Section {title}',
    'account.nav.accountdetails': 'Account details',
    'account.nav.paymentdetails': 'Payment details',
    'account.nav.addresses': 'Addresses',
    'account.nav.preferences': 'My preferences',
    'account.nav.photocards': 'Photocards',
    'account.nav.railcards': 'Railcards',
    'account.nav.photocards-railcards': 'Photocards / Railcards',
    'account.nav.stickets': 'sTickets',
    'account.nav.purchases': 'Purchases',
    'account.nav.upcomingjourneys': 'Upcoming journeys',
    'account.nav.seasontickets': 'Season tickets',
    'account.nav.orders-refunds': 'Manage my tickets / refunds',
    'account.nav.smart-carnet': '<{global.keyGo}> Carnet',
    'account.nav.linkorder': 'Link Order',
    'account.nav.smartcard': '<{global.theKey}> <{global.smartcard}>',
    'account.nav.smartcard.replacement': '<{global.theKey}> replacement',
    'account.nav.smartcard.keygoaccount': '<{global.keyGo}> account',
    'account.nav.smartcard.keygohistory': '<{global.key}> <{global.smartcard}> history',
    'account.nav.smartcard.keygosignup': 'Sign up for <{global.keyGo}>',
    'account.nav.smartcard.keygo': '<{global.keyGo}>',
    'account.nav.smartcard.keygo.payment': '<{global.keyGo}> payment',
    'account.nav.smartcard.link': 'The <{global.key}> - Linked Accounts',
    'account.nav.smartcard.tickets': '<{global.theKey}> tickets',
    'account.nav.smartcard.key-tickets': 'Key Tickets',
    'account.nav.smartcard.journeyhistory': '<{global.theKey}> journey history',
    'account.nav.evouchers': 'eVouchers',
    'account.nav.delayrepay': 'Delay Repay',
    'account.nav.auto-delay-repay': 'Auto Delay Repay',
    'account.menu.showNavigation': 'Show navigation',
    'account.nav.etickets': 'eTickets',
    'account.nav.disruptionAlerts': 'Disruption alerts',
    'account.nav.myTrees': 'My Trees',
    'account.nav.flexi': 'Flexi Season Tickets',
    'account.nav.passengerAssist': 'Passenger Assist',
    'account.nav.bookPassengerAssist': 'Book Passenger Assist',
    'account.nav.bookedAssistance': 'View Booked Assistance',
    'account.nav.accessibilityProfile': 'View My Accessibility Profile',
    'account.nav.reservation': 'Make a seat / bike reservation',

    'account.delete.heading': 'Delete this item',
    'account.delete.text': 'Please confirm that you wish delete the following item',

    'account.edit.heading': 'Edit this item',

    'account.drc.title': 'Digital Railcards',
    'account.drc.description': 'Tap the heart icon to choose your favourite Digital Railcard and we will automatically apply the railcard to all your ticket searches.',
    'account.drc.setFavourite': 'Save as favourite',
    'account.drc.removeFavourite': 'Your favourite railcard',
    'account.drc.blockDevice': 'Remove from device',
    'account.drc.firstDevice': 'Device ID 1',
    'account.drc.secondDevice': 'Device ID 2',
    'account.drc.primaryHolder': 'Primary holder',
    'account.drc.secondaryHolder': 'Secondary holder',
    'account.drc.empty': 'You don’t currently have any digital railcard',
    'account.drc.renew': 'Renew railcard',

    'account.details.name': 'Name',
    'account.details.email': 'Email',
    'account.details.confirm.email': 'Confirm Email',
    'account.details.confirm.changes': 'Confirm changes',
    'account.details.password': 'Password',
    'account.details.password.new': 'New password',
    'account.details.telephoneNumber': 'Contact phone number',
    'account.details.dateOfBirth': 'Date of Birth',
    'account.details.userSince': 'User since',
    'account.details.deleteUser': 'Request to delete my account',
    'account.details.deleteUser.sr': 'Click to request your account deletion',
    'account.details.emailMarketing': 'Email preferences:',
    'account.details.smsMarketing': 'SMS preferences:',
    'account.details.smsMarketing.phoneRequired': 'Please set a contact telephone number to fully activate SMS notifications',
    'account.details.updated': 'User preferences updated successfully',
    'account.details.password.current': 'Current password',
    'account.details.password.change': 'Password change confirmation',
    'account.details.password.previous.confirm': 'Confirm previous password',
    'account.details.password.previous': 'Previous password',
    'account.details.updateErrorEmail': 'We could not update your account at this time. Please note that we cannot change your email address if we already have an account using that email address.',
    'account.details.updateErrorGeneral': 'We could not update your account at this time. Please try again later.',
    'account.details.updateErrorNewPhoto': 'We could not upload a new photo at this time. Please try again later.',
    'account.details.photoWrongDimensions': 'Error, photo is not in portrait orientation.',

    'account.details.updatePhoto': 'This is your current Smartcard photo. Please update it if you wish to use a new photo with your replacement Smartcard.',
    'account.details.updatePhotoNoExistingPhoto': 'Please upload a new photo for your replacement Smartcard.',

    'account.details.loginProviders': 'You can log in to your account using the following identity providers:',
    'account.details.amazon.unlink': 'Unlink Amazon account',
    'account.details.amazon.unlink.confirm.message': 'Are you sure you want to unlink your account from Amazon?<br><br>You will be able to link your account with Amazon again if needed.',
    'account.details.amazon.unlink.confirm.closeText': 'Cancel',
    'account.details.amazon.unlink.confirm.continueText': 'Unlink',
    'account.details.amazon.unlink.confirm.title': 'Confirm unlinking',
    'account.details.amazon.unlink.success.heading': 'Unlinking of accounts successful',
    'account.details.amazon.unlink.success.message': 'You can link your Amazon account with your {accountType} account again the next time you use the Amazon Login button.<br><br>If you have never set your {accountType} password click the <i>"Forgotten your password?"</i> link the next time you are logging in.',
    'account.details.amazon.unlink.success.title': 'You have successfully unlinked your Amazon and {accountType} accounts',
    'account.details.pendingDeletion.timeframe': 'You have asked for your account to be deleted which has been passed on to our team to action, we will send confirmation of when this has been completed within 28 days.',
    'account.details.pendingDeletion.ico': 'If you wish to know more about the right to be forgotten and exemptions that may apply, please visit ',
    'account.details.pendingDeletion.privacy': 'You can find our ',
    'account.details.pendingDeletion.privacy.link': 'Privacy Policy here',
    'account.details.pendingDeletion': 'To keep your account open you can ',
    'account.details.pendingDeletion.button': 'cancel this request',
    'account.details.pendingDeletion.button.sr': 'Click here to cancel the account deletion request',
    'account.details.pendingDeletion.modal.text': 'Are you sure you would like to cancel the account deletion process?',
    'account.deleteUserModal.title': 'Delete account',
    'account.deleteUserModal.continueButton': 'Delete my account',
    'account.deleteUserModal.smartcard': 'Not having an account with us means you will no longer be able to use your Key smartcard, you will have to transfer any valid Key smartcard tickets to paper tickets.',
    'account.deleteUserModal.information': 'It also means it will take longer to complete some actions on our app and website, such as buying a ticket, claiming compensation and getting a refund, and you will no longer receive offers or important updates.',
    'account.deleteUserModal.ico': 'If you wish to know more about the right to be forgotten and exemptions that may apply, please visit ',
    'account.deleteUserModal.privacy': 'You can find our ',
    'account.deleteUserModal.privacy.link': 'Privacy Policy here',
    'account.deleteUserModal.password': 'To confirm you still want to delete your account, please verify your password.',
    'account.deleteUserModal.timeframe': 'We will respond to your request within 28 days.',
    'account.deleteUserModal.success': 'Your account is pending deletion, please check your emails for confirmation.',
    'account.deleteUserModal.error.password': 'The password you provided is incorrect',
    'account.deleteUserModal.error.unknown': 'There was an unknown error, please try again later',

    'account.confirm.smartcardsignup': 'Get <{global.theKey}> <{global.smartcard}> with my account',
    'account.smartcardsignup.readmore': 'Find out more about <{global.theKey}> <{global.smartcard}>',
    'account.smartcardsignup.details': '<{global.theKey}> <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets. {readmore}',
    'account.smartcardsignup.flexi': 'A Flexi Ticket can only be used with a Key Smartcard. Apply for your Key Smartcard below.',
    'account.smartcardsignup.address': 'Delivery Address',
    'account.smartcardsignup.dob': 'Date of birth',
    'account.smartcardsignup.isrn.placeholder': '(e.g. 633597-0000-0000-0000)',
    'account.smartcardsignup.children': 'For children under 16, a passport style photo is required.',
    'account.smartcardreplacement.children': 'You can upload a new photo for your replacement smartcard here.',
    'account.smartcardsignup.children.requirements': 'Once the photograph has been approved, you will receive email confirmation. To complete the registration process you will also be requested to submit an age verification document such as copy of the child’s passport or birth certificate which should be submitted at any {brand} Key valid station. Once this is done a new Key <{global.smartcard}> will be issued to the address registered within <{global.theKey}> account.',
    'account.smartcardsignup.children.condition1': 'Must be portrait facing forwards',
    'account.smartcardsignup.uploadphoto': 'Upload photo',
    'account.smartcardsignup.keygoSignUp': 'Get <{global.theKey}> <{global.smartcard}> and <{global.keyGo}> with my account',
    'account.smartcardsignup.autoDelayRepay': 'If we see from your tap ins and out that you’ve been delayed 15 mins or more on our services, we will prepare a Delay Repay claim for you and email you to confirm. {moreInformation}',
    'account.smartcardsignup.moreInformation': 'For more information, please click here.',
    'account.smartcardsignup.benefit1': 'Beat the queues',
    'account.smartcardsignup.benefit2': 'Load season tickets',
    'account.smartcardsignup.benefit3': 'Auto delay repay',
    'account.smartcardsignup.benefit4': 'Tap & Go',
    'account.smartcardsignup.benefit5': '',

    'account.smartcardstatus.loading': 'Loading <{global.smartcard}> status',
    'account.smartcardstatus.replacementSmartcard': 'Your request for a replacement <{global.smartcard}> is being processed.',
    'account.smartcardstatus.pendingSmartcard': 'Your application for a <{global.smartcard}> is being processed.',
    'account.smartcardstatus.hotlisted': 'Your card is hotlisted please apply for a new one.',
    'account.smartcardstatus.applicationSubmitted': '1. Application submitted',
    'account.smartcardstatus.applicationProcessed': '2. Application processed',
    'account.smartcardstatus.smartcardPrinted': '3. <{global.key}> <{global.smartcard}> printed',
    'account.smartcardstatus.smartcardSent': '4. <{global.key}> <{global.smartcard}> in post',
    'account.smartcardstatus.notStarted': 'Pending',
    'account.smartcardstatus.inProgress': 'In progress',
    'account.smartcardstatus.completed': 'Completed',
    'account.smartcardstatus.applicationStatus': 'Application status',
    'account.smartcardstatus.replacementStatus': 'Replacement status',
    'account.smartcardstatus.replacementServiceUnavailable': 'Replacement <{global.smartcard}> requests are unavailable at this time, please try again later.',

    'account.smartcard.product.status.pending': 'Pending',
    'account.smartcard.product.status.sendingToStation': 'Sending to station',
    'account.smartcard.product.status.sendingTopupToStation': 'Sending topup to station',
    'account.smartcard.product.status.readyToCollect': 'Ready to collect',
    'account.smartcard.product.status.topupReadyToCollect': 'Top up ready to collect',
    'account.smartcard.product.status.loadedOnCard': 'Loaded on card',
    'account.smartcard.product.status.productBlocked': 'Product blocked',
    'account.smartcard.product.status.productRemovedFromCard': 'Product removed from card',
    'account.smartcard.product.status.errorPleaseContact': 'Error - please contact us',
    'account.smartcard.product.status.cancelled': 'Cancelled',

    'account.smartcard.text.dateapplied': 'Date applied',
    'account.smartcard.text.label': '<{global.smartcard}> number',
    'account.smartcard.text.number': '<{global.key}> <{global.smartcard}> number',
    'account.smartcard.text.description': '({cardDescription})',
    'account.smartcard.text.capacity': '<{global.key}> <{global.smartcard}> capacity',
    'account.smartcard.text.cardExpiry': '<{global.key}> <{global.smartcard}> expiry',
    'account.smartcard.text.cardStatus': '<{global.key}> <{global.smartcard}> status',
    'account.smartcard.text.available': '{available} tickets available',
    'account.smartcard.text.cardFull': 'Ticket limit reached. You\'re not able to purchase any more tickets on your <{global.key}> <{global.smartcard}> until one of your existing tickets has expired',
    'account.smartcard.text.collectionWarning': 'You\'re not able to purchase any further <{global.key}> <{global.smartcard}> tickets online until you have loaded these tickets onto your <{global.key}> <{global.smartcard}>',
    'account.smartcard.text.cardtype': 'Card type',
    'account.smartcard.text.paymentcard': 'Card number',
    'account.smartcard.text.name': 'Cardholder name',
    'account.smartcard.text.customerName': 'Customer name',
    'account.smartcard.text.keygo': '<span class="text-keygo">key</span><i class="text-keygo--light">Go</i>',
    'account.smartcard.text.keygo.cancel': 'Are you sure you want to close your keyGo account?  Please note:',
    'account.smartcard.text.keygo.cancel.warning.general': "Railcard details will be removed from your online account will need to be re-added if you sign up to keyGo again",
    'account.smartcard.text.keygo.cancel.warning.carnet': "Any keyGo Carnets tickets will no longer be available to use and cannot be refunded without an active keyGo account. Refund any complete bundles now before cancelling your keyGo account.",
    'account.smartcard.text.keygo.notReady': 'Account already has keyGo, or <{global.smartcard}> not ready for keyGo.',
    'account.smartcard.text.keygo.hosted.error.header': "The keyGo activation wasn't successful.",
    'account.smartcard.text.keygo.hosted.error.message': 'Please try again later or contact customer services.',
    'account.smartcard.text.balance': 'balance',
    'account.smartcard.text.lasttopup': 'Most recent top-up',
    'account.smartcard.text.validfromdate': 'Valid from',
    'account.smartcard.text.validuntildate': 'Valid until',
    'account.smartcard.text.validfromdateFlexi': 'Passes valid from',
    'account.smartcard.text.validuntildateFlexi': 'Passes expire on',
    'account.smartcard.text.status': 'Status',
    'account.smartcard.text.class': 'Class',
    'account.smartcard.text.class.first': 'First Class',
    'account.smartcard.text.class.standard': 'Standard',
    'account.smartcard.text.route': 'Route',
    'account.smartcard.text.autotopup': 'Auto top-up amount',
    'account.smartcard.text.noactivetickets': 'No <{global.key}> <{global.smartcard}> tickets are currently active',
    'account.smartcard.text.incompletejourney': 'You have incomplete journeys that should be completed immediately.',
    'account.smartcard.text.replacementinfo': 'You can apply for up to two replacement cards free of charge; further requests may incur a fee and you will need to call our <{global.smartcard}> team on {phoneNumber} to continue your application.',
    'account.smartcard.text.replacementinfo.tickets.pre-replacement': 'Whilst waiting for your new card to arrive you will need to buy paper tickets to travel. Please keep these tickets as you will be able to claim a refund for them.',
    'account.smartcard.text.replacementinfo.tickets.post-replacement': 'Whilst waiting for your new card to arrive you will need to buy paper tickets to travel. Please keep these tickets as you will be able to claim a refund for them.',
    'account.smartcard.text.replacementinfo.flexi': 'If you hold a flexi season ticket and aren\'t able to use all your passes due to waiting for the delivery of your replacement, you must apply for a refund for any remaining passes through your online account before the expiry of your flexi season ticket.',
    'account.smartcard.text.replacementinfo.season': 'A refund will be given to annual season ticket holders providing the season ticket is active at the time of loss. A £5 admin fee will be applied to all tickets as per our refund policy',
    'account.smartcard.text.replacementinfo.refundpolicy': 'Refund policy',
    'account.smartcard.text.journeysFor': 'Showing journeys for {month}',
    'account.smartcard.text.journeyhistory': 'Your journey history details are available for a maximum of 8 weeks.',
    'account.smartcard.text.journeyhistory.noresults': 'There are no journeys to display.',
    'account.smartcard.text.journeysbetween': 'Showing journeys between {startDate} and {endDate}',
    'account.smartcard.text.calltocomplete': 'Please contact customer services on {phoneNumber} to inform them of the correct journey details so they can update your account',
    'account.smartcard.text.replacementReason': 'Select a replacement reason',
    'account.smartcard.text.cardNo': 'Card number',
    'account.smartcard.text.blockedDate': 'Blocked date:',
    'account.smartcard.text.replacementReason.title': 'Replacement reason:',
    'account.smartcard.text.replacementReason.NOT_WORKING': 'Card not working',
    'account.smartcard.text.replacementReason.LOST': 'Card lost',
    'account.smartcard.text.replacementReason.STOLEN': 'Card stolen',
    'account.smartcard.text.replacementReason.NOT_RECEIVED': 'Card not received',
    'account.smartcard.text.replacementReason.NAME_CHANGE': 'Change of name',
    'account.smartcard.text.additionalDetails': 'Additional details',
    'account.smartcard.text.crimeNumber': 'Crime number',
    'account.smartcard.text.conditionsLink': 'National Rail Conditions of Travel',
    'account.smartcard.text.address': 'your new Smartcard will be posted to the following address. If the address is not correct, please update your address before requesting a new card.',
    'account.smartcard.text.declaration': 'I declare that the information I have given is to the best of my knowledge a true statement of the facts. I realise that I may be prosecuted if I knowingly make a false statement. I hereby give authority for the making of such enquiries as are reasonably necessary to verify the information that I have given in respect of this application is correct. I agree to accept the {link}, in particular Condition 34.',
    'account.smartcard.text.replacement.cancellationWarning': '<p><strong>Please note:</strong> your existing Key smartcard will be cancelled as soon as your replacement request is submitted.</p>',
    'account.smartcard.text.replacement.success': 'We are processing your request to replace your <{global.key}> <{global.smartcard}>.',
    'account.smartcard.text.replacement.warning': 'We are processing your request to replace your <{global.key}> <{global.smartcard}>. Information shown here reflects your most recent <{global.key}> <{global.smartcard}>. Some information may not be available at this time',
    'account.smartcard.text.replacement.linkText': 'View the progress of your <{global.key}> <{global.smartcard}> replacement',
    'account.smartcard.button.completeyourjourney': 'Complete your <{global.key}> <{global.smartcard}> journey',
    'account.smartcard.button.replacemycard': 'Request a new <{global.key}> <{global.smartcard}>',
    'account.smartcard.button.buynewticket': 'Buy a new <{global.key}> <{global.smartcard}> ticket',
    'account.smartcard.status.pending': 'Pending',
    'account.smartcard.status.active': 'Active',
    'account.smartcard.status.expired': 'Expired',
    'account.smartcard.status.full': 'Full',
    'account.smartcard.text.cancel': 'Are you sure you wish to cancel?',
    'account.smartcard.text.touchin': 'Touch in',
    'account.smartcard.text.touchout': 'Touch out',
    'account.smartcard.text.purchaseHistory.link': 'Click here to manage your tickets including refunds',
    'account.smartcard.text.refund.link': 'Click here to apply for a refund for <{global.smartcardTicketUppercase}>s',
    'account.smartcard.activation.status.activating': 'ACTIVATING',
    'account.smartcard.activation.status.ready': 'READY TO BE ACTIVATED',
    'account.smartcard.activation.text.heading': '<{global.key}> <{global.smartcard}> needs to be activated',
    'account.smartcard.activation.text.warning': 'Please activate your <{global.smartcard}> when you have received it',
    'account.smartcard.activation.text.message': 'You need to activate your <{global.smartcard}> in order to buy tickets.',
    'account.heading.smartcard.transfer': 'Transfer a paper season ticket',
    'account.heading.smartcard.replacement': '<{global.key}> <{global.smartcard}> - replacement',
    'account.heading.smartcard.replacement.warning': '<{global.key}> <{global.smartcard}> - replacement in progress',
    'account.heading.smartcard.replacement.request': 'Request a new <{global.key}> <{global.smartcard}>',
    'account.heading.smartcard.previous': 'Previous <{global.key}> {count, plural, =1{<{global.smartcard}>} other{<{global.smartcards}>}}',
    'account.heading.smartcard.apply': 'Apply for <{global.theKey}> <{global.smartcard}>',
    'account.heading.smartcard.register': 'Register <{global.theKey}> <{global.smartcard}>',
    'account.heading.smartcard.status': '<{global.key}> <{global.smartcard}> status',
    'account.heading.smartcard.tickets': '<{global.key}> <{global.smartcard}> - tickets',
    'account.heading.smartcard.journeyhistory': '<{global.key}> <{global.smartcard}> - journey history',
    'account.heading.smartcard.incompletejourneys': '<{global.key}> <{global.smartcard}> incomplete journeys',
    'account.heading.smartcard.activetickets': '<{global.key}> <{global.smartcard}> tickets available to use',
    'account.heading.smartcard.pendingtickets': 'Tickets yet to be loaded to your <{global.key}> <{global.smartcard}>',
    'account.heading.smartcard.keygo': '{keygobrand} sign up',
    'account.heading.smartcard.keygoaccount': '{keygobrand} account',
    'account.heading.smartcard.disabled': '<{global.key}> <{global.smartcard}> - currently offline',
    'account.heading.smartcard.activity': '<{global.key}> <{global.smartcard}> - activity',
    'account.heading.smartcard.link': 'The <{global.key}> - Linked Accounts',
    'account.heading.keygocancel.cancelModal': 'Cancel my <{global.keyGo}> account',
    'account.heading.keygoupdate.updateModal': 'Update my <{global.keyGo}> account',
    'account.heading.flexi': 'Flexi Season tickets',
    'account.heading.flexi-disabled': 'Flexi - currently offline',
    'account.smartcard.keygo.reimbursement.description': 'Manual Refund',
    'account.smartcard.keygo.manualRefundCode.MANUAL_REFUND': 'Via Card',
    'account.smartcard.keygo.manualRefundCode.USER_DESIRE': 'Via Cheque',
    'account.smartcard.keygo.reimbursement.card.failureMessage': 'Unfortunately we were unable to refund your keyGo balance to your payment card.\n                                                                  Do you want to request a cheque for {balance} instead?\n                                                                  This will be sent to your saved <{global.smartcard}> address and can take up to 10 days to process.',
    'account.smartcard.keygo.reimbursement.card.successMessage': 'You have successfully refunded your <{global.keyGo}> balance to your payment card.',
    'account.smartcard.keygo.reimbursement.cheque.failureMessage': 'Unfortunately we were unable to process your request at this time. Please try again later.',
    'account.smartcard.keygo.reimbursement.cheque.successMessage': 'Your request for a cheque has been submitted. Please allow up to 10 days for this to be processed.',
    'account.smartcard.keygo.reimbursement.modal.title': 'Withdraw <{global.keyGo}> balance',
    'account.smartcard.keygo.reimbursement.modal.cheque.confirm': 'Yes, please send a cheque',
    'account.smartcard.keygo.reimbursement.modal.cheque.deny': "No, I don't",
    'account.smartcard.keygo.reimbursement.modal.withdrawText': 'Please confirm that you wish to withdraw {balance} from your keyGo account?\n                                                                 This will be refunded back to your payment card ending {cardNumber}.',
    'account.heading.smartcard.keygo.incompletejourneys': 'You have incomplete journeys on your <{global.keyGo}> account',
    'account.smartcard.keygo.add': 'Add <{global.keyGo}> to your <{global.smartcard}>',
    'account.smartcard.keygo.byContinuingYouAccept': 'By clicking "Sign up to keyGo" you confirm that you have read, and that you accept, {termsAndConditions}.',
    'account.smartcard.keygo.cancel': 'Cancelling your {keygobrand} account',
    'account.smartcard.keygo.cancelation.pending': 'Your {keygobrand} account is now blocked. Please contact customer services if you have any queries.',
    'account.smartcard.keygo.cancelled.successMessage': 'Your {keygobrand} account has been cancelled. Any credit will be returned within four days.',
    'account.smartcard.keygo.cancelation.balance.warning': 'Please update your payment details to clear your balance. Once cleared, you will be able to sign up for <{global.keyGo}> again. This process may take up to five days',
    'account.smartcard.keygo.cardBusy': 'There is a ticket awaiting collection on your card',
    'account.smartcard.keygo.cardFull': 'Your card is full',
    'account.smartcard.keygo.cardTypes': 'For recurring {keygobrand} payments we only accept Visa, Visa Debit, MasterCard, MasterCard Debit and American Express.',
    'account.smartcard.keygo.closeaccount': 'Click below to close your account',
    'account.smartcard.keygo.collect.info': 'Your new <{global.key}> <{global.smartcard}> will arrive with {keygobrand} pre-loaded and ready to use at any station on the {keygobrand} map.',
    'account.smartcard.keygo.collect.map': '{keygobrand} map link.',
    'account.smartcard.keygo.completeJourney.error.locationName': 'Please enter the station of your missing tap',
    'account.smartcard.keygo.completeJourney.error.timestamp': 'Please enter the date and the time of your missing tap',
    'account.smartcard.keygo.completeJourney.error.tapOutBeforeTapIn': 'Tap out should be after tap in time',
    'account.smartcard.keygo.completeJourney.error.tapInAfterTapOut': 'Tap in should be before tap out time',
    'account.smartcard.keygo.completeJourney.error.reason': 'Please choose one reason',
    'account.smartcard.keygo.completeJourney.form.footer': 'Once you press confirm, you will no longer be able to make edits to this journey online.',
    'account.smartcard.keygo.completeJourney.form.heading.missingTapOut': 'Update your journey from {tapInLocation}',
    'account.smartcard.keygo.completeJourney.form.heading.missingTapIn': 'Update your journey to {tapOutLocation}',
    'account.smartcard.keygo.completeJourney.form.reason': "Please tell us why you didn't tap",
    'account.smartcard.keygo.completeJourney.form.reason.defaultOption': 'Please select a reason',
    'account.smartcard.keygo.completeJourney.form.success': 'You have successfully completed your journey. The changes will be reflected in your account in 24 hours.',
    'account.smartcard.keygo.completeJourney.form.location.placeHolder': '{tapType} at...',
    'account.smartcard.keygo.completeJourney.form.location.knownTap': '{tapType} at {location}',
    'account.smartcard.keygo.completeJourney.form.location.label': '{tapType} location',
    'account.smartcard.keygo.completeJourney.form.timestamp.label': '{tapType} time',
    'account.smartcard.keygo.completeJourney.infoModal.heading.failure': 'Unable to complete the journey',
    'account.smartcard.keygo.completeJourney.infoModal.heading.success': 'Journey completed successfully',
    'account.smartcard.keygo.completeJourney.reason.FORGOT_TO_TAP': 'Forgot to tap',
    'account.smartcard.keygo.completeJourney.reason.VALIDATOR_OUT_OF_ORDER': 'Card reader not working',
    'account.smartcard.keygo.completeJourney.reason.TRAVEL_DISRUPTION': 'Travel Disruption',
    'account.smartcard.keygo.completeJourney.tapIn': 'Tap in',
    'account.smartcard.keygo.completeJourney.tapOut': 'Tap out',
    'account.smartcard.keygo.confirmterms': 'I have read and accept the Terms and Conditions',
    'account.smartcard.keygo.delayrepay': 'If you would like to claim Delay Repay for a journey covered by {keygobrand} please visit our {delayRepayGuide}',
    'account.smartcard.keygo.railcard': 'Already have a railcard? Apply it to your smartcard {railcard} to enjoy discounted KeyGo travel',
    'account.smartcard.keygo.delayrepayguide': 'Delay Repay guide',
    'account.smartcard.keygo.details': 'Add <{global.keyGo}> to your Key Smartcard to travel smarter and easier when You Pay As You Go.',
    'account.smartcard.keygo.moreDetails': "<p>Once you have KeyGo on your Key Smartcard, all your entry and exit taps across the network will be analysed to calculate the best day fare for your journeys based upon the tickets you could have purchased that day. KeyGo will then charge the most appropriate ticket(s) for the journeys you made that day against your nominated payment card.</p><p>If you hold a Season ticket on your Key Smartcard, KeyGo will only charge you for the journeys you make beyond Season ticket's validity. {learnMoreLink}</p>",
    'account.smartcard.keygo.moreDetails.link': 'Learn more about <{global.keyGo}> and see the full route',
    'account.smartcard.keygo.details.reminder': 'Reminder:',
    'account.smartcard.keygo.details.1': 'By signing up to <{global.keyGo}>:',
    'account.smartcard.keygo.details.2': 'You are agreeing to a Continuous Payment Authority and providing express consent for us to deduct automatic payment via your debit or credit card.\n                                          You agree to keep your payment card and contact details up to date.\n                                          You agree to tap in and out on all your journeys as per the <{global.keyGo}> Conditions of Use.\n                                          You understand where <{global.keyGo}> is valid for travel as described on the <{global.keyGo}> map.\n                                          You have read and understood the <{global.keyGo}> Conditions of Use.',
    'account.smartcard.keygo.loadingStation': 'Please allow a minimum of two hours after purchase before loading your ticket onto your <{global.keyGo}> before loading it onto your <{global.key}> <{global.smartcard}>. Or you can now load <{global.keyGo}> onto your <{global.key}> <{global.smartcard}> using our app. {findMoreLink}',
    'account.smartcard.keygo.loadingStation.findMore': 'Find out more',
    'account.smartcard.keygo.signup': 'You can also add <{global.keyGo}> to your <{global.key}> <{global.smartcard}> to travel smarter and easier when you Pay As You Go.',
    'account.smartcard.keygo.signupButton': 'Sign up to KeyGo',

    'account.smartcard.keygo.flexiWarning.heading': 'Important information',
    'account.smartcard.keygo.flexiWarning.bodyCopy1': 'Do you have Flexi Season loaded on your Key Smartcard?',
    'account.smartcard.keygo.flexiWarning.bodyCopy2': 'If so, you\'ll need to register for a second Key Smartcard before you sign up for <{global.keyGo}>, more details can be found below.',
    'account.smartcard.keygo.flexiWarning.moreInfo': 'More information about keyGo and Flexi Season',
    'account.smartcard.keygo.flexiWarning.acknowledge': 'Yes, I understand',
    'account.smartcard.keygo.flexiWarning.continue': 'Continue to KeyGo registration',

    'account.smartcard.keygo.cardDetails': 'Card details',
    'account.smartcard.keygo.registrationWarning.title': 'Important information',
    'account.smartcard.keygo.registrationWarning.alert': 'Before you complete the signup process for {keygobrand} - please be aware that:',
    'account.smartcard.keygo.registrationWarning.list': 'You must touch in and out on all your journeys so that we know where you have travelled from and to\n            This applies even if you hold a season ticket\n            If you do not touch in and out you will be charged a \xA350 incomplete journey charge every time you fail to touch\n            Continued misuse may lead to us closing your account\n            You can only use {keygobrand} on Gatwick Express, Great Northern, Southern and Thameslink service (there are some exceptions to this, details can be found {moreDetails}&nbsp;)',
    'account.smartcard.keygo.registrationWarning.confirm': 'Accept and proceed',
    'account.smartcard.keygo.iblocks.error.ACCOUNT_CLOSED': 'Unable to complete your journey, Amendment is only available for an account with active keyGo.',
    'account.smartcard.keygo.iblocks.error.CONFLICT': 'Journey is already complete.',
    'account.smartcard.keygo.iblocks.error.REACHED_TAP_LIMIT': 'You have reached the monthly limit of incomplete taps that you can amend.',
    'account.smartcard.keygo.iblocks.error.INVALID_TAP_TIME': 'Cannot complete the journey as tap time provided will exceed journey time allowed.',
    'account.smartcard.keygo.iblocks.error.UNKNOWN_ERROR': 'An error occurred while handling your request. Please try again.',
    'account.smartcard.keygo.cardExpire.heading': '<{global.keyGo}> Payment Card',
    'account.smartcard.keygo.cardExpire.pending': 'The payment card linked to your <{global.keyGo}> account <strong>is expiring soon</strong>. Update your payment details now to continue using <{global.keyGo}>.',
    'account.smartcard.keygo.cardExpire.expired': 'The payment card linked to your <{global.keyGo}> account <strong>has expired</strong>. Update your payment details now to continue using <{global.keyGo}>.',
    'account.smartcard.keygo.incomplete': 'Incomplete',
    'account.smartcard.keygo.incompleteJourneys.body': 'You have incomplete <{account.smartcard.text.keygo}> journeys on your account.  Complete them now to pay the correct fare and avoid an Incomplete Journey Charge.',
    'account.smartcard.keygo.incompleteJourneys.heading': 'Incomplete <{global.keyGo}> Journeys',
    'account.smartcard.keygo.journeyhistory.time': 'Time: ',
    'account.smartcard.keygo.journeyhistory.operatorName': 'Operator Name: ',
    'account.smartcard.keygo.journeyhistory.routeName': 'Route: ',
    'account.smartcard.keygo.journeyhistory.location': 'Location: ',
    'account.smartcard.keygo.journeyhistory.type': 'Type: ',
    'account.smartcard.keygo.journeyhistory.amendBefore': 'Amend before ',
    'account.smartcard.keygo.journeyhistory.autoSameStationExit': 'Same Station Exit',
    'account.smartcard.keygo.journeyhistory.autofill': 'Autofill',
    'account.smartcard.keygo.journeyhistory.charged': 'Charged',
    'account.smartcard.keygo.journeyhistory.correction': 'Correction',
    'account.smartcard.keygo.journeyhistory.edit': 'Edit',
    'account.smartcard.keygo.journeyhistory.gatelineAutocomplete': 'Gateline Autocomplete',
    'account.smartcard.keygo.journeyhistory.hideJourney': 'Hide journey',
    'account.smartcard.keygo.journeyhistory.manualfill': 'Journey Amended',
    'account.smartcard.keygo.journeyhistory.multiUseBoundary': 'Season Boundary',
    'account.smartcard.keygo.journeyhistory.pendingCharge': 'Pending charge',
    'account.smartcard.keygo.journeyhistory.route': '{origin} to {destination}',
    'account.smartcard.keygo.journeyhistory.showJourney': 'Show journey',
    'account.smartcard.keygo.journeyhistory.singleUseBoundary': 'Prepaid Boundary',
    'account.smartcard.keygo.journeyhistory.smartCarnet.peak': 'keyGo Carnet Peak',
    'account.smartcard.keygo.journeyhistory.smartCarnet.offPeak': 'keyGo Carnet Off-Peak',
    'account.smartcard.keygo.journeyhistory.touch': 'Touch',
    'account.smartcard.keygo.journeyhistory.unknown': 'Unknown',
    'account.smartcard.keygo.journeyhistory.updateNow': 'Update now',
    'account.smartcard.keygo.balanceAdjustmentCode.INCORRECT_FARE': 'Incorrect fare calculation',
    'account.smartcard.keygo.balanceAdjustmentCode.GOODWILL_ADJUSTMENT': 'Goodwill adjustment',
    'account.smartcard.keygo.balanceAdjustmentCode.OTHER_REASON': 'Other',
    'account.smartcard.keygo.reasonsGiven': 'Reasons given:',
    'account.smartcard.keygo.keygoBalance': '<{global.keyGo}> balance',
    'account.smartcard.keygo.lastUpdated': '{amount} on {date}',
    'account.smartcard.keygo.minimumTopup': 'A minimum automatic top-up of £25 applies',
    'account.smartcard.keygo.noTopup': 'A £0.01 pre-authorisation will be charged to your payment card to set up your account. This will automatically be refunded in 3-5 working days.',
    'account.smartcard.keygo.updatePayment': 'A £0.01 pre-authorisation will be charged to your payment card to update your details. This will automatically be refunded in 3-5 working days.',
    'account.smartcard.keygo.notAvailable': 'Registration not currently available:',
    'account.smartcard.keygo.pay.edit': 'Edit details',
    'account.smartcard.keygo.ready': 'You have chosen {location} to start your first journey. {keygobrand} will be ready for use two hours from registration. Place your <{global.key}> <{global.smartcard}> on the card reader at the station within the next 30 days to enable {keygobrand}.',
    'account.smartcard.keygo.text.journeyhistory': 'Your journey history details are available for a maximum of 8 weeks.',
    'account.smartcard.keygo.text.journeyhistory.weeklyCapApplied.1': 'Weekly cap applied saving ',
    'account.smartcard.keygo.text.journeyhistory.weeklyCapApplied.2': ' today',
    'account.smartcard.keygo.warn.incompletejourney': 'To avoid additional charges due to missing information, please review your recent activity.',
    'account.smartcard.keygo.text.incompletejourney': 'You can amend up to 3 journeys online within 28 days. Please update your journey with the correct information before the amendment deadline specified for each journey.</br>If you’ve tapped in and out at the same station without making a journey – please contact Customer Services to avoid a penalty charge.',
    'account.smartcard.keygo.updated.successMessage': 'Your {keygobrand} payment details have been updated.',
    'account.smartcard.pay': 'Confirm payment',
    'account.smartcard.paymentdetails': 'Payment details',
    'account.smartcard.noPaymentCard': 'To view your <{global.keyGo}> account details, please log into the website you originally used to sign up to <{global.keyGo}>.',
    'account.smartcard.status.balance': 'Your balance may take up to four days to refresh',
    'account.smartcard.keygo.routes': 'Automatically pay the best value fare on rail and bus services.',
    'account.smartcard.keygo.registration.disabled': 'We are currently making exciting changes to <{global.keyGo}>. New registrations have been disabled until {date} while we put these improvements in place',
    'account.smartcard.keygo.withdraw': 'Withdraw',

    'account.smartcard.transfer.searchButton': 'Find paper season tickets',
    'account.smartcard.transfer.searchHelp': 'Please enter your photocard number and your postcode to help us find your current paper season ticket(s).',
    'account.smartcard.transfer.searchIntro': 'If you have an existing paper season ticket we can add it to your new <{global.smartcard}> providing that your ticket:',
    'account.smartcard.transfer.searchRules': 'Is on a line of route where the {brand} <{global.key}> <{global.smartcard}> is enabled\n                                                Has a minimum of one month\'s validity before it expires\n                                                Was purchased from the {brand} website or from a {brand} ticket office\n                                                Is a full-priced Adult Season Ticket (any discounted Season Ticket will not be eligible for transfer)\n                                                Is not a Dual-availability Season Ticket',
    'account.smartcard.transfer.searchSupport': 'For any <{global.key}> card queries please contact Customer Services on {smartcardPhoneNumber} (calls charged at local rate and may be recorded)',
    'account.smartcard.transfer.searchNoResults': 'We could not find any valid tickets to swap over with the details that you supplied.',
    'account.smartcard.transfer.searchNoResults.retry': 'Please check that:',
    'account.smartcard.transfer.searchNoResults.reasons': 'The photocard and postcode you entered are correct.\n                                                            The ticket has more than one month\'s validity remaining.\n                                                            It is an adult ticket.\n                                                            The ticket is valid entirely on {brand}.\n                                                            You did not purchase the ticket at a discounted price.',
    'account.smartcard.transfer.searchResultsHeading': 'We found the following paper season {count, plural, =1{ticket} other{tickets}} which are eligible for transfer onto your new <{global.key}> card, please select {count, plural, =1{} other {the one you would like to transfer, and}} a collection station:',
    'account.smartcard.transfer.searchResultsInvalidHeading': 'We found {count} paper season {count, plural, =1{ticket which is} other{tickets which are}} not eligible for transfer.',
    'account.smartcard.transfer.showInvalid': 'Show details',
    'account.smartcard.transfer.ticketOffice.openingHours': 'Opening hours for the ticket office at this station: ',
    'account.smartcard.transfer.ticketOffice.closed': 'Closed',
    'account.smartcard.transfer.ticketOffice.opens': 'Opens: {time}',
    'account.smartcard.transfer.ticketOffice.closes': 'Closes: {time}',
    'account.smartcard.transfer.hideInvalid': 'Hide details',
    'account.smartcard.transfer.collectionStationLong': 'Please select a collection station',
    'account.smartcard.transfer.collectionStation': 'Collection station',
    'account.smartcard.transfer.smartcardDetails': ' Please enter the following details to apply for a <{global.key}> <{global.smartcard}>:',
    'account.smartcard.transfer.submit': 'Submit',
    'account.smartcard.transfer.searchAgain': 'Back to search',
    'account.smartcard.transfer.ticketRequired': 'Please select a ticket',
    'account.smartcard.transfer.cardFull': 'You have reached the maximum number of tickets, so cannot transfer any more tickets to your <{global.key}> <{global.smartcard}>.',
    'account.smartcard.transfer.cannotTransfer': 'You are not able to transfer tickets onto an existing <{global.key}> <{global.smartcard}>. ',
    'account.smartcard.transfer.childError': 'Please note, we are unable to perform ticket transfers on Child tickets.',
    'account.smartcard.transfer.success': 'Your application to transfer your season ticket has been successfully submitted.',
    'account.smartcard.transfer.smartcardSuccess': 'You can collect your new <{global.smartcard}> from the designated station after 5 days. You can also monitor the progress of your application in your account section.',

    'account.sticket.utn': 'UTN',
    'account.sticket.date': 'Date',
    'account.sticket.event': 'Scan event',
    'account.sticket.location': 'Location',
    'account.sticket.order': 'Order',
    'sticket.table.viewOrder': 'View order',
    'account.sticket.scanType.Blacklist': 'Blacklist',
    'account.sticket.scanType.Entry': 'Entry',
    'account.sticket.scanType.Exit': 'Exit',
    'account.sticket.scanType.Surface': 'Surface',
    'account.sticket.scanType.Unknown': 'Unknown',
    'account.sticket.empty': '<p><b>You don\u2019t have any active sTickets.</b></p><p>sTicket is the digital version of a Season ticket provided as a barcode, that is instantly available to download in the Southeastern app. No need to wait for an email or queue at the station.</p>',

    'account.orders.reorder': 'Re-order',
    'account.orders.reorder.title': 'Re-order tickets',
    'account.orders.reorder.date': 'Choose a new travel date',
    'account.orders.reorder.fallback.header': 'Re-order in progress. Please continue.',
    'account.orders.reorder.fallback.button': 'Continue',
    'account.orders.reorder.noMatching.header': 'We could not find a matching ticket',
    'account.orders.reorder.noMatching.description': 'Sorry, We could not find a ticket that matches your previous order. If you would like to perform a search with the same details please click continue and you will be taken to the search page.',

    'account.orders.refunded': 'This order has been refunded',
    'account.orders.disclaimer': 'This page only shows tickets purchased through this website. If you purchased your Smart ticket at the station please click {here} for a refund.',
    'account.orders.partialRefund': 'This order is partially refunded',
    'account.orders.none': 'No orders found',
    'account.orders.reference': 'Order reference',
    'account.orders.reference.details': 'Details for order reference',
    'account.orders.back': 'Back to purchase history',
    'account.orders.viewOrder': 'View order details',
    'account.orders.viewOrderAndDownloads': 'View order details and download tickets',
    'account.orders.collectionReady': 'Available for collection, with reference {collectionReference}',
    'account.orders.paymentDetails': 'Payment details',
    'account.orders.refundDetails': 'Refund details',
    'account.orders.eVoucherPayment': '{count, plural, =1 {eVoucher} other {eVouchers}}',
    'account.orders.refundOptionsLink': 'View refund options',
    'account.orders.refundLink': 'Click here to apply for a refund on this ticket',
    'account.orders.viewEtickets': 'View order eTickets',
    'account.orders.viewEtickets.short': 'View eTickets',
    'account.orders.delayRepayLink': 'Claim Delay Repay',

    'account.orders.amend.isAmended': 'Amended Order',
    'account.orders.amend.badge': 'Amended',
    'account.orders.amend.journey': 'Amended Journey',
    'account.orders.amend.unamended': 'Unamended Journey',
    'account.orders.amend.previousJourney': 'Previous Journey',
    'account.orders.amend.amendedTicket': 'Original ticket',
    'account.orders.amend.back': 'Back to amend details',
    'account.orders.amend.bookingLink': 'Amend selected',
    'account.orders.amend.bullet1': 'You can amend an Advance purchase ticket for another Advance purchase ticket',
    'account.orders.amend.bullet2': 'Tickets can be amended right up to the day before travel',
    'account.orders.amend.bullet3': 'You cannot amend the origin and destination',
    'account.orders.amend.bullet4': 'You can amend the date, time and class of travel',
    'account.orders.amend.bullet5': 'You will not receive a refund if the ticket you are amending to is cheaper than your original booking',
    'account.orders.amend.confirmation.details.email': 'Details of your amendment have been emailed to {email}',
    'account.orders.amend.confirmation.success': 'Order successfully amended',
    'account.orders.amend.selectTicket': 'Select ticket for amendment',
    'account.orders.amend.selectFare': 'Select fare',
    'account.orders.amend.doAmend': 'Amend tickets',
    'account.orders.amend.header': 'Amend for Order #{id}',
    'account.orders.amend.newTicket': 'New ticket',
    'account.orders.amend.optionsLink': 'View amend options',
    'account.orders.amend.reason.default': 'This order cannot be amended',
    'account.orders.amend.search.noServices': 'There are no services available to amend a ticket to. Please go back and try a different date and time.',
    'account.orders.amend.outwardDate': 'Outward date',
    'account.orders.amend.returnDate': 'Return date',
    'account.orders.amend.step1Title': 'Choose tickets',
    'account.orders.amend.step2Title': 'Choose date',
    'account.orders.amend.step3Title': 'Choose outward service',
    'account.orders.amend.step4Title': 'Choose outward fare',
    'account.orders.amend.step5Title': 'Choose inward service',
    'account.orders.amend.step6Title': 'Choose inward fare',
    'account.orders.amend.step7Title': 'Confirm',
    'account.orders.amend.step8Title': 'Summary',
    'account.orders.amend.ticket': '{adults, plural, =0 {} =1 {1 Adult} other {# Adults}}{children, plural, =0 {} =1 {1 Child} other {# Children}}',
    'account.orders.amend.summary.ticketCount': 'You are amending {count} ticket(s)',
    'account.orders.amend.summary.newTravelDate': 'Updated travel date: ',
    'account.orders.amend.summary.existingBooking': 'Existing booking:',
    'account.orders.amend.summary.fee': 'Administration fee:',
    'account.orders.amend.summary.leftToPay': 'Left to pay:',
    'account.orders.amend.summary.newTripCost': 'New ticket(s) cost:',
    'account.orders.amend.summary.moreDetails': 'More details',
    'account.orders.amend.summary.lessDetails': 'Less details',
    'account.orders.amend.warning.isAmending': 'This order is already being amended. Please finish the current amendment before amending again.',
    'account.orders.amend.warning.notAmendable': 'This order cannot be amended',
    'account.orders.amend.warning.requiresPlusBus': 'This order contains a Plusbus fare and both the ticket fare and the Plusbus fare must be amended',
    'account.orders.refund.header': 'Refund details for order {id}',
    'account.orders.refund.dayticket.valueRefunded': 'Value remaining',
    'account.orders.refund.initiatedBy': 'Refund initiated by',
    'account.orders.refund.ticketValue': 'Ticket value',
    'account.orders.refund.ticketsValue': 'Ticket(s) value',
    'account.orders.refund.customer': 'Customer',
    'account.orders.refund.customerService': 'Customer Service',
    'account.orders.refund.tickets': 'Tickets Refunded: ',
    'account.orders.refund.smartcardNumber': '<{global.key}> <{global.smartcard}> number: {smartcardNumber}',
    'account.orders.refund.unusedTickets': 'Unused passes',
    'account.orders.refund.itso.initiatedBy': 'Refund initiated by: {who}',
    'account.orders.refund.itso.refundDetails': 'Refund details',
    'account.orders.refund.itso.refundDate': 'Refunded on: {date}',
    'account.orders.refund.itso.cardAmount': 'Amount refunded to card ',
    'account.orders.refund.itso.voucherAmount': 'Amount refunded in vouchers',
    'account.orders.refund.itso.paypalAmount': 'Amount refunded to paypal account ',
    'account.orders.refund.itso.datePeriodPair': '{startDate} to {endDate}',
    'account.orders.refund.itso.description': 'If you are applying for anything other than a standard refund or there are any circumstances you may need us to consider you should apply using the form  {here}.',
    'account.orders.refund.itso.flexi-description': '- You can apply for an online refund of unused Flexi passes. Expired passes can not be refunded.',
    'account.orders.refund.itso.flexi-description-secondary': '- No administration fee.',
    'account.orders.refund.itso.keySmartcardTicket': '<{global.key}> <{global.smartcard}> ticket',
    'account.orders.refund.itso.sticket': 'sTicket',
    'account.orders.refund.itso.refundCalculation': 'Refund calculation',
    'account.orders.refund.itso.modal.refundForm': 'refund form',
    'account.orders.refund.itso.modal.refundFailureMessage': 'Please re-attempt to initiate a refund request through your online account after sometime or fill in the {form} to request refund through Customer Service.',
    'account.orders.refund.itso.refundForm.text': 'If you are applying for anything other than a standard refund or there are any circumstances you may need us to consider you should apply using the form {here}.',
    'account.orders.refund.itso.checks.returnGoldCard': 'I acknowledge that I must return my Gold Record Card to a <{app.owner.short}> station. By applying for a refund you will be unable to use your ticket from today.',
    'account.orders.refund.itso.checks.invalidateSameDay': 'By applying for a refund you will be unable to use your ticket as from today.',
    'account.orders.refund.itso.timePeriod': '{m} {m, plural, =1 {month} other {months}} and {d} {d, plural, =1 {day} other {days}}',
    'account.orders.refund.itso.timePeriod.noMonth': '{d} {d, plural, =1 {day} other {days}}',
    'account.orders.refund.itso.unavailable.daysUsed': 'Days Used: ',
    'account.orders.refund.itso.unavailable.originalCost': 'Original ticket cost: ',
    'account.orders.refund.itso.unavailable.refundAmount': 'Refund amount: ',
    'account.orders.refund.itso.unavailable.seasonTicketUnused': 'Season ticket unused: ',
    'account.orders.refund.itso.unavailable.seasonTicketUsed': 'Season ticket used: ',
    'account.orders.refund.itso.unavailable.ticketUsed': 'Ticket used: ',
    'account.orders.refund.itso.valueUsed': 'Value used',
    'account.orders.refund.itso.deduction.amount': '- {amount}',
    'account.orders.refund.itso.manualRefundedIn.VOUCHER': 'Amount refunded in vouchers',
    'account.orders.refund.itso.manualRefundedIn.CHEQUE': 'Amount refunded by cheque',
    'account.orders.refund.itso.manualRefundedIn.CARD': 'Amount refunded to alternative card',
    'account.orders.refund.itso.warning.manualRefund': 'You can apply for a refund by submitting the {form}',
    'account.orders.refund.itso.warning.manualRefundForm': 'Key Smartcard refund form',
    'account.orders.refund.itso.valueAvailable': 'Value available for refund',
    'account.orders.refund.itso.showRefundBreakdown': 'Show refund breakdown',
    'account.orders.refund.itso.hideRefundBreakdown': 'Hide refund breakdown',
    'account.orders.refund.itso.sticket.unavailable': 'Sorry, this ticket cannot be refunded online at the moment.',
    'account.orders.refund.itso.assignedTo': 'Assigned to',
    'account.orders.refund.warning.requiresPlusBus': 'This order contains a Plusbus fare and the ticket fare cannot be refunded without refunding the Plusbus fare',
    'account.orders.refund.warning.alreadyCollected': 'This order has already been collected from the ticket machine.',
    'account.orders.refund.warning.unavailable': 'This order contains no tickets which are refundable online.',
    'account.orders.refund.warning.nonRefundablePayment': 'This order was bought with a non-refundable payment type',
    'account.orders.refund.warning.refundsLocked': 'We cannot process this refund for your account due to suspicious activity; if you think there has been an error, please contact customer services.',
    'account.orders.refund.warning.nonRefundable': 'This order is now non-refundable',
    'account.orders.refund.warning.nonRefundable.onUserBrand': '{orderBrand, select,\n            southern {Please log onto Southern to request a refund}\n            greatnorthern {Please log onto Great Northern to request a refund}\n            thameslink {Please log onto Thameslink to request a refund}\n            gatwick {Please log onto Gatwick Express to request a refund}\n            other {This order is now non-refundable}\n        }',
    'account.orders.refund.warning.manualRefund': 'You can apply for a refund by completing {form} and returning it along with the tickets to the freepost address.',
    'account.orders.refund.refundForm': 'this refund form',
    'account.orders.refund.warning.manualRefund.contactUs': '{url}',
    'account.orders.refund.warning.manualRefund.smart': 'If you have a smart ticket on the Key - please complete ',
    'account.orders.refund.warning.manualRefund.paper': 'If you have a paper ticket - please complete ',
    'account.orders.refund.warning.manualRefund.eTicket': 'If you have an eTicket - please complete ',
    'account.orders.refund.warning.manualRefund.form': 'this refund form ',
    'account.orders.refund.selectTickets': 'Select the tickets that you would like to have refunded',
    'account.orders.refund.bullet1': 'You can refund unused tickets online',
    'account.orders.refund.bullet2': 'Tickets are refundable within {days} days of the ticket expiry date',
    'account.orders.refund.bullet3': '<b>Disruption Refund</b>: If there is disruption and you decide not to travel, please apply for your refund {link}',
    'account.orders.refund.bullet4': '<b>Industrial Action Refund</b>: If you purchased any of these ticket types - Anytime, Off-Peak, Super Off-Peak, One Day Travelcard, Advance or PlusBus Day Tickets dated specifically for a date affected by Industrial Action, please apply for your refund {refundUrl}. See Industrial Action dates {industrialActionUrl}',
    'account.orders.refund.moreInfo': 'More information about refunds can be found here',
    'account.orders.refund.selectReason': 'Please select reason for refund',
    'account.orders.refund.moreDetails': 'Please tell us more information',
    'account.orders.refund.fee': 'Administration fee: {fee}',
    'account.orders.refund.fee.waived': 'waived',
    'account.orders.refund.fee.alreadyPaid': '({fee} already paid)',
    'account.orders.refund.until': ' - refundable until {expires}',
    'account.orders.refund.ticket.refunded': 'Refunded',
    'account.orders.refund.ticket.notRefundable': 'Not Refundable',
    'account.orders.refund.ticket.used': 'Used',
    'account.orders.refund.ticket.unused': 'Unused',
    'account.orders.refund.ticket.partlyUsed': 'Partly used',
    'account.orders.refund.ticket.invalid-reason': 'Selected refund reason is not applicable for {ticketName}.',
    'account.orders.refund.notRefundableOnline': 'Sorry, these tickets are currently not refundable online.',
    'account.orders.refund.reason.advance-ticket': 'Advance tickets are not refundable online.',
    'account.orders.refund.reason.season-ticket': 'Season tickets are not currently refundable online.',
    'account.orders.refund.notRefundableIn24hours': 'eTickets purchased for the same date of travel are refundable after 24 hours.',
    'account.orders.refund.reason.exceeded-validity': 'The {days} day period for refunds has expired for {tickets, plural, =1 {this ticket} other {these tickets}} and {tickets, plural, =1 {it is} other {they are}} no longer refundable.',
    'account.orders.refund.reason.default': '{tickets, plural, =1 {This ticket is} other {These tickets are}} not refundable online.',
    'account.orders.refund.warning.GS3': 'These tickets contain a GroupSave discount. GroupSave discounts only apply to parties of 3 or more. The ticket(s) you are trying to refund would take you below that threshold. Please amend your refund request to ensure that there are at least 3 tickets remaining, alternatively you can choose to refund all of the tickets purchased.',
    'account.orders.refund.warning.2TR': 'These tickets contain a Two Together discount. Two Together discount is valid only for journeys where the 2 named railcard holders travel together. You will need to apply for a refund on both of these tickets',
    'account.orders.refund.warning.DIC': 'These tickets contain a disabled child discount. The disabled child discount is valid only for 1 adult travelling with a disabled child. You can only refund the adult ticket or both the adult and the child ticket.',
    'account.orders.refund.warning.DIS': 'The Disabled Person discount is valid for up to 2 adults. Please check your selected tickets and ensure you meet these requirements',
    'account.orders.refund.warning.FAM': 'Family & Friends discount discount requires at least one adult travelling with a child. Please amend your ticket selection so that any remaining tickets satisfy this requirement',
    'account.orders.refund.warning.HMF': 'Your HM Forces Railcard discount would not be valid for the remaining tickets if we proceed with this refund. Please check your ticket selection and revise it if necessary to meet the railcard terms and conditions. If necessary you can refund all the tickets and re-plan your journey.',
    'account.orders.refund.warning.NEW': 'Your Network Railcard discount would not be valid for the remaining tickets if we proceed with this refund. Please check your ticket selection and revise it if necessary to meet the railcard terms and conditions. If necessary you can refund all the tickets and re-plan your journey.',
    'account.orders.refund.warning.NGC': 'Your Annual Gold Card discount would not be valid for the remaining tickets if we proceed with this refund. Please check your ticket selection and revise it if necessary to meet the railcard terms and conditions. If necessary you can refund all the tickets and re-plan your journey.',
    'account.orders.refund.warning.SRN': 'Your Senior Railcard discount would not be valid for the remaining tickets if we proceed with this refund. Please check your ticket selection and revise it if necessary to meet the railcard terms and conditions. If necessary you can refund all the tickets and re-plan your journey.',
    'account.orders.refund.warning.YNG': 'Your 16-25 railcard discount would not be valid for the remaining tickets if we proceed with this refund. Please check your ticket selection and revise it if necessary to meet the railcard terms and conditions. If necessary you can refund all the tickets and re-plan your journey.',
    'account.orders.refund.warning.fallback': 'The selection of tickets you have chosen cannot be refunded. There might be railcard or ticket restrictions preventing this. Please try a different combination of tickets.',
    'account.orders.refund.warning.childFlatFare': 'To refund an adult ticket you must also select the associated child ticket(s).',
    'account.orders.refund.warning.notAllChildrenAdded': 'To refund a ticket you must also select the associated ticket(s).',
    'account.orders.refund.ticket': '{adults, plural, =0 {} =1 {1 Adult} other {# Adults}}{children, plural, =0 {} =1 {1 Child} other {# Children}}',
    'account.orders.refund.plusbus': 'PlusBus',
    'account.orders.refund.summary.subTotal': 'Sub-total',
    'account.orders.refund.summary.fee': 'Administration fee',
    'account.orders.refund.durationUsed': 'Passes used',
    'account.orders.refund.summary.bookingFee': 'Booking fee',
    'account.orders.refund.summary.total': 'Total to be refunded',
    'account.orders.refund.summary.totalRefunded': 'Total refunded',
    'account.orders.refund.summary.cardNotice': 'Refunds can only be made to the original method(s) of payment.',
    'account.orders.refund.summary.cardMaximum': 'Maximum of {amount}',
    'account.orders.refund.summary.cardMaxed': 'Card is already refunded to its full amount',
    'account.orders.refund.summary.cardExpired': 'Card has expired',
    'account.orders.refund.summary.button': 'Apply for refund',
    'account.orders.refund.confirmation.title': 'Confirm refund request',
    'account.orders.refund.confirmation': 'You have selected {tickets} {count, plural, =1{ticket} other {tickets}}. Please check the amount before confirming the refund request.',
    'account.orders.refund.incomplete': 'Sorry, we are unable to process your refund on this occasion.',
    'account.orders.refund.incomplete.reason': 'Please select a reason for your refund.',
    'account.orders.refund.incomplete.note': 'You have chosen "Other" as the reason for your refund. Please give us some more information.',
    'account.orders.refund.incomplete.tickets': 'Please select one or more tickets to refund.',
    'account.orders.refund.incomplete.total': '{tickets, plural, =1 {This ticket is} other {These tickets are}} not refundable as the refund amount is less than the administration fee.',
    'account.orders.refund.voucherAmount': 'Amount to refund in eVouchers',
    'account.orders.refund.cardAmount': 'Amount to refund to card',
    'account.orders.refund.paypalAmount': 'Amount to refund to PayPal',
    'account.orders.refund.successNotification': 'Your {count, plural, =1 {ticket has} other {tickets have}} been refunded',
    'account.orders.refund.success.title': 'Refund successful',
    'account.orders.refund.success.summary': 'Your refund of {total} for {count, plural, =1{your ticket has} other{# tickets have}} been approved.',
    'account.orders.refund.success.cardRefund': 'It might take up to five working days for this to be processed back to your original payment method.',
    'account.orders.refund.success.voucherRefund': '{voucherAmount} has been refunded in the form of eVouchers. These are available to use immediately from your account.',
    'account.orders.refund.error.title': 'Refund unsuccessful',
    'account.orders.refund.error.invalid': 'Your request was invalid',
    'account.orders.refund.error.message': 'Please re-attempt to initiate a refund request through your online account after sometime or fill in the refund form to request refund through Customer Service.',
    'account.orders.refund.error.message.title': 'Unfortunately, your refund could not be processed.',
    'account.orders.refund.ticket.unusedConfirmation': 'I confirm that the ticket I am submitting for a refund is unused. <{app.owner.short}> reserve the right to check the validity of all refund requests and I understand that if this claim is suspected of being fraudulent, appropriate actions may be taken.',

    'account.orders.favourite.add': 'Add to favourites',
    'account.orders.favourite.added': 'Ticket added to favourites',
    'account.orders.favourite.remove': 'Remove favourite',

    'account.orders.railcards': 'Please make sure you bring your {railcardName} with you',

    'account.etickets.login': 'Log in to access eTickets',
    'account.etickets.oldETickets': 'Find your eTickets from our old app and website',
    'account.etickets.oldETickets.link': 'here',

    'account.historicETickets.title': 'Old eTickets',
    'account.historicETickets.error': 'Error loading tickets',
    'account.historicETickets.back': 'Back to eTickets',

    'account.linkorder.register.heading': 'Link your order to an account',
    'account.linkorder.login.heading': 'Link your order to an account',
    'account.linkorder.loading.message': 'Adding the order to your account',
    'account.linkorder.success.message': 'Your order has been linked to your account. You can find your order in the Manage my tickets / refunds section',
    'account.linkorder.error.message': 'We were unable to link your order to this account. To try again, please re-click the link in your booking confirmation email',
    'account.linkorder.error.message.alreadylinked': 'This order is already linked to an account. Check the Manage my tickets / refunds section.',
    'account.linkorder.error.message.customerservices': 'If you are still having problems, please contact Customer Services',

    'account.disruptionAlerts.headingText': 'account.nav.disruptionAlerts',
    'account.disruptionAlerts.serviceAlertsHeadingText': 'Timetable Service Alerts',
    'account.disruptionAlerts.descriptionText': 'Our new service will email you an alert if there is a delay or disruption to your journey.\n                                                 You can personalise the alerts by choosing which services you want to be alerted on and the frequency of these alerts.',
    'account.serviceTimetableChangeAlerts.descriptionText': 'We will alert you if there is a timetable change to your service.',
    'account.disruptionAlerts.alertsHeadingText': 'Your active alerts',
    'account.disruptionAlerts.timetableAlertsHeadingText': 'Your active service timetable change alerts',
    'account.disruptionAlerts.noAlerts': 'No alerts saved.',
    'account.disruptionAlerts.noServiceChangeAlerts': 'No service timetable change alerts saved.',
    'account.disruptionAlerts.create.supportingText': 'You can get disruption alerts on up to {max} {max, plural, =1 {journey} other {journeys}}.',
    'account.disruptionAlerts.create.maximumReached': 'You have reached the maximum number of {max} {max, plural, =1 {journey} other {journeys}} allowed.',
    'account.disruptionAlerts.limitReached': 'You have saved the maximum amount of disruption alerts',
    'account.disruptionAlerts.genericError': 'An error occured whilst trying to create your disruption alert',
    'account.disruptionAlerts.unableToCreate': 'We could not create your disruption alert',
    'account.disruptionAlerts.alertHeading.aria': '{origin} to {destination}',
    'account.disruptionAlerts.servicesText': 'Alerted on {count} {count, plural, =1{train} other{trains}}',
    'account.disruptionAlerts.stationAlerts': 'You will also be notified of station issues at {origin} and {destination}',
    'account.disruptionAlerts.alertedOnText': 'Only alerted on: ',
    'account.disruptionAlerts.alertDurationText': 'Alert duration: ',
    'account.disruptionAlerts.alertDuration.forever': 'Ongoing',
    'account.disruptionAlerts.alertDuration.oneOff': ' only',
    'account.disruptionAlerts.alertDuration.fromTo': ' until ',
    'account.disruptionAlerts.create': 'Create alert',
    'account.disruptionAlerts.edit': 'Edit alert',
    'account.disruptionAlerts.mute': 'Pause alert',
    'account.disruptionAlerts.mutedUntil': 'Paused {date, select, null {indefinitely} other {until {date}}} – ',
    'account.disruptionAlerts.unmute': 'Reactivate',
    'account.disruptionAlerts.delete': 'Delete alert',
    'account.disruptionAlerts.delete.confirm.text': 'Are you sure you want to delete this alert?',
    'account.disruptionAlerts.delete.confirm.button': 'account.disruptionAlerts.delete',
    'account.disruptionAlerts.delete.cancel.button': 'Cancel',

    'account.loggedOut': 'Logged out',
    'account.loggedOut.youWereloggedOut': 'Automatic log out',
    'account.loggedOut.possibleReasons': 'As you were inactive for over {autoLogoutMinutes} minutes, we logged you out for your security',

    'account.logoutWarning': 'Log out warning',
    'account.logoutWarning.almostTime': 'Automatic log out',
    'account.logoutWarning.possibleReasons': 'As you have been inactive for nearly {autoLogoutMinutes} minutes, you will be logged out soon for your security',

    'account.confirm-smartcard.title': 'Please confirm your Key Smartcard details',
    'account.confirm-smartcard.fetch-smartcard-confirmation.failed': 'An error occurred whilst attempting to retrieve your smartcard confirmation data. Please try again later. If the issue persists, please contact customer services.',
    'account.confirm-smartcard.request-smartcard-confirmation.failed': 'An error occurred whilst attempting to replace your smartcard. Please try again later. If the issue persists, please contact customer services.',
    'account.confirm-smartcard.address': 'Please confirm your Smartcard details are correct',
    'account.confirm-smartcard.confirm-question': 'Please confirm you would like a replacement adult smartcard',
    'account.confirm-smartcard.confirm-notification': 'If you do not confirm to have your Key renewed before your current one expires, we will assume that you no longer require a Key Smartcard, and your account will be updated accordingly. You can always order a new Key later.',
    'account.confirm-smartcard.confirm-modal.title': 'Your New Adult Key Smartcard',
    'account.confirm-smartcard.confirm-modal.body': 'Thank you for confirming you would like to receive a new Adult Key Smartcard. Once your current Child Key Smartcard expires, you will be sent your new Smartcard within 7 working days.',
    'account.passenger-assist.accessibility-profile.title': 'My accessibility profile',
    'account.passenger-assist.accessibility-profile.description': 'Create your accessibility profile to make it even quicker to request assistance.',
    'account.passenger-assist.accessibility-profile.form.title': 'Title',
    'account.passenger-assist.accessibility-profile.form.firstName': 'First name',
    'account.passenger-assist.accessibility-profile.form.surname': 'Surname',
    'account.passenger-assist.accessibility-profile.form.email': 'Email',
    'account.passenger-assist.accessibility-profile.form.confirmEmail': 'Confirm new email',
    'account.passenger-assist.accessibility-profile.form.phone': 'Contact phone number',
    'account.passenger-assist.accessibility-profile.form.contactMethod': 'Preferred contact method',
    'account.passenger-assist.accessibility-profile.form.contactMethod.email': 'Email',
    'account.passenger-assist.accessibility-profile.form.contactMethod.phone': 'Phone',
    'account.passenger-assist.accessibility-profile.form.assistance-location.title': 'Points of the journey requiring assistance:',
    'account.passenger-assist.accessibility-profile.form.otherAssistanceLocation': 'Other',
    'account.passenger-assist.accessibility-profile.form.assistance-reason.title': 'Reasons for assistance:',
    'account.passenger-assist.accessibility-profile.form.otherAssistanceType': 'Other',
    'account.passenger-assist.accessibility-profile.form.contact-preferences.title': 'Contact preferences',
    'account.passenger-assist.accessibility-profile.form.contact-preferences.question.1': 'Would you like to be reminded of your assistance?',
    'account.passenger-assist.accessibility-profile.form.contact-preferences.question.2': 'Do you agree to be contacted via email regarding your experience?',
    'account.passenger-assist.accessibility-profile.form.contact-preferences.question.3': 'Can we contact you after your journey to discuss how it went?',
    'account.passenger-assist.accessibility-profile.form.contact-preferences.answer.yes': 'Yes',
    'account.passenger-assist.accessibility-profile.form.contact-preferences.answer.no': 'No',
    'account.passenger-assist.accessibility-profile.delete-btn': 'Delete profile',
    'account.passenger-assist.accessibility-profile.delete-confirm': 'Are you sure you want to delete this accessibility profile?',
    'account.passenger-assist.accessibility-profile.delete-confirm.yes': 'Yes, delete profile',
    'account.passenger-assist.accessibility-profile.delete-confirm.no': 'No, go back',
    'account.passenger-assist.accessibility-profile.back-to-results-screen.button': 'Return to booking',
    'account.passenger-assist.accessibility-profile.edit-btn.aria-label': 'Edit {sectionTitle}',
    'account.passenger-assist.accessibility-profile.section-personal-details.title': 'Personal Details',
    'account.passenger-assist.accessibility-profile.section-assistance-points.title': 'Assistance points',
    'account.passenger-assist.accessibility-profile.section-assistance-reason.title': 'Reason for assistance',
    'account.passenger-assist.accessibility-profile.section-contact-preferences.title': 'Contact Preferences',

    'account.passenger-assist.book-passenger-assist.title': 'Book Passenger Assist',
    'account.passenger-assist.book-passenger-assist.personal-details.title': 'Do you want to use your accessibility profile to book passenger assist?',
    'account.passenger-assist.book-passenger-assist.personal-details.use-ap': 'Use my accessibility profile',
    'account.passenger-assist.book-passenger-assist.personal-details.dont-use-ap': 'Don’t use my accessibility profile',
    'account.passenger-assist.book-passenger-assist.enter-personal-details.title': 'Please Enter your details',
    'account.passenger-assist.book-passenger-assist.when.title': 'When do you need assistance?',
    'account.passenger-assist.book-passenger-assist.train.title': 'Which journey do you need assistance with?',
    'account.passenger-assist.book-passenger-assist.train.subtitle': 'These are some journeys that you have booked an assistance for in the past.',
    'account.passenger-assist.book-passenger-assist.train-outward-search.title': 'Provide your outward journey details',
    'account.passenger-assist.book-passenger-assist.train-return-search.title': 'Provide your return journey details',
    'account.passenger-assist.book-passenger-assist.train-search.recommendation': 'We recommend you book at least 2 hours in advance of travelling.',
    'account.passenger-assist.book-passenger-assist.train-search.alert': 'Please be aware that passenger assistance can only be provided on National Rail parts of your journey.',
    'account.passenger-assist.book-passenger-assist.train-previous-pa-search.alert': 'We couldn\'t find any services that matched your selected previous journey.',
    'account.passenger-assist.book-passenger-assist.train-search.note': 'If you journey involves another train company we may need to confirm part of journey with them, this might depend on their contact centre opening hours.',
    'account.passenger-assist.book-passenger-assist.train-search.departing-station': 'Departing station',
    'account.passenger-assist.book-passenger-assist.train-search.arrival-station': 'Arrival station',
    'account.passenger-assist.book-passenger-assist.train-search.departure-time': 'Departure time',
    'account.passenger-assist.book-passenger-assist.train-search.journey-is-not-listed.button': 'My journey isn\'t listed',
    'account.passenger-assist.book-passenger-assist.train-search.more-details.button': 'more details',
    'account.passenger-assist.book-passenger-assist.train-search.hide-details.button': 'hide details',
    'account.passenger-assist.book-passenger-assist.return.title': 'Do you want to book assistance for the return journey?',
    'account.passenger-assist.book-passenger-assist.return.no-label': 'No, I do not want to book assistance for the return journey',
    'account.passenger-assist.book-passenger-assist.return.yes-label': 'Yes, I want to book assistance for the return journey"',
    'account.passenger-assist.book-passenger-assist.return.back-to-outward': 'Back to outward journey search',
    'account.passenger-assist.book-passenger-assist.contact-preferences.title': 'Contact Preferences',
    'account.passenger-assist.book-passenger-assist.save.accessibility-profile.question': 'Would you like to save your details and create an accessibility profile for future use?',
    'account.passenger-assist.book-passenger-assist.save.accessibility-profile.yes.aria-label': 'Yes – Save details to an accessibility profile',
    'account.passenger-assist.book-passenger-assist.save.accessibility-profile.no.aria-label': 'No – Do not save details',
    'account.passenger-assist.book-passenger-assist.summary.title': 'Check all your details are correct',
    'account.passenger-assist.book-passenger-assist.summary.subtitle-outward-journey': 'Outward journey',
    'account.passenger-assist.book-passenger-assist.summary.edit-outward-journey': 'Edit outward journey',
    'account.passenger-assist.book-passenger-assist.summary.subtitle-return-journey': 'Return journey',
    'account.passenger-assist.book-passenger-assist.summary.edit-return-journey': 'Edit return journey',
    'account.passenger-assist.book-passenger-assist.summary.cancel-confirm': 'Are you sure you want to cancel the passenger assistance booking?',
    'account.passenger-assist.book-passenger-assist.summary.cancel-confirm.yes': 'Yes, cancel the booking',
    'account.passenger-assist.book-passenger-assist.summary.cancel-confirm.no': 'No, keep the booking',
    'account.passenger-assist.edit.outward-journey': 'Edit outward journey details',
    'account.passenger-assist.edit.return-journey': 'Edit return journey details',
    'account.passenger-assist.book-passenger-assist.train.legs-badge.direct': 'Direct',
    'account.passenger-assist.book-passenger-assist.train.legs-badge.multi-leg': 'Multi Leg',
    'account.passenger-assist.book-passenger-assist.train.legs-change': 'Change',
    'account.passenger-assist.create-profile.failed': 'An error occurred whilst attempting to create your accessibility profile. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.update-profile.failed': 'An error occurred whilst attempting to update your accessibility profile. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.delete-profile.failed': 'An error occurred whilst attempting to delete your accessibility profile. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.cancel-request.failed': 'An error occurred whilst attempting to cancel your passenger assist request. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.amend-request.failed': 'An error occurred whilst attempting to amend your passenger assist request. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.get-profile.failed': 'An error occurred whilst attempting to retrieve your accessibility profile. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.get-previous-journeys.failed': 'An error occurred whilst attempting to retrieve your previous journeys. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.book-passenger-assist.failed': 'An error occurred whilst attempting to book your passenger assist. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.get-assisted-bookings.failed': 'An error occurred whilst attempting to get your assisted bookings. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.get-assisted-booking.failed': 'An error occurred whilst attempting to get your assisted booking. Please try again later. If the issue persists, please contact customer services.',
    'account.passenger-assist.edit.outward-journey.error': 'The arrival time of the outward journey cannot be after the departure time of the return journey.',
    'account.passenger-assist.edit.return-journey.error': 'The return journey cannot depart before the outward journey arrives.',

    'account.passenger-assist.view-booked-assistance.title': 'View booked assistance',
    'account.passenger-assist.amend-booked-assistance.title': 'Amend your Passenger Assist request',
    'account.passenger-assist.accessibility-profile.section-booking-details.title': 'Booking details',
    'account.passenger-assist.accessibility-profile.booking-reference.label': 'Booking reference:',
    'account.passenger-assist.accessibility-profile.status.label': 'Status:',
    'account.passenger-assist.accessibility-profile.outward-journey.label': 'Outward journey',
    'account.passenger-assist.accessibility-profile.return-journey.label': 'Return journey',
    'account.passenger-assist.view-booked-assistance.your-pa-requests.title': 'Your Passenger Assist requests',
    'account.passenger-assist.view-booked-assistance.cancel-request.button': 'Cancel request',
    'account.passenger-assist.view-booked-assistance.cancel-request-confirm': 'Are you sure you want to cancel this Passenger Assist request?',
    'account.passenger-assist.view-booked-assistance.cancel-request-confirm.yes': 'Yes, cancel request',
    'account.passenger-assist.view-booked-assistance.cancel-request-confirm.no': 'No, go back',
    'account.passenger-assist.view-booked-assistance.section.amend-request.button': 'Amend request',
    'account.passenger-assist.view-booked-assistance.journey.status-label': 'Status: ',
    'account.passenger-assist.view-booked-assistance.journey.outward-label': 'Outward:',
    'account.passenger-assist.view-booked-assistance.journey.return-label': 'Return:',

    'account.passenger-assist.success-message.create-accessibility-profile.title': 'Your Passenger Assist profile has been created',
    'account.passenger-assist.success-message.create-accessibility-profile.message': 'You can contact us to request Passenger Assist at any time of the day. If your journey involves another train company we may need to confirm part of your journey with them. This might depend on their contact centre opening hours. If this is the case, we will discuss options with you.',
    'account.passenger-assist.success-message.create-accessibility-profile.button': 'Book Passenger Assist',
    'account.passenger-assist.success-message.book-pa.title': 'Passenger Assist request submitted',
    'account.passenger-assist.success-message.book-pa.subtitle1': 'What happens next?',
    'account.passenger-assist.success-message.book-pa.subtitle2': 'We will send you an email when your booking has been confirmed',
    'account.passenger-assist.success-message.book-pa.message': 'View booked assistance to check the status of your booking or make changes',
    'account.passenger-assist.success-message.book-pa.button': 'View booking assistance',
    'account.passenger-assist.need-help': 'Need help?',

    'account.passenger-assist.view-profile': 'View my accessibility profile',
    'account.passenger-assist.book-passenger-assist.direct': 'Direct',
    'account.passenger-assist.book-passenger-assist.multi-leg': 'Multi Leg',

    'account.reservation.no-upcoming': 'You have no upcoming reservations.',
    'account.reservation.no-previous': 'You have no past reservations.',
    'account.reservation.button': 'Make a seat / bike reservation',
    'account.reservation.service-modal.title.inward': 'Select inward service',
    'account.reservation.service-modal.title.outward': 'Select outward service',
    'account.services-modal.ticket-type-list.title.outward': "Please choose type of ticket:",
    'account.services-modal.ticket-type-list.title.single': 'Your Single ticket:',
    'account.services-modal.ticket-type-list.title.return': 'Your Return ticket:',
    'account.reservation.add-reservation-modal.title': 'Add reservation',
    'account.reservation.bike-reservation-modal.title': 'Select bike reservations',
    'account.reservation.add-reservation-modal.seat.title': 'I would like to reserve a seat',
    'account.reservation.add-reservation-modal.bike.title': 'I would like to reserve a bike space',
    'account.reservation.add-reservation-modal.bike.select.title': 'Number of reservations',
    'account.reservation.reservation-summary-modal.title': 'Reservation Summary',
    'account.reservation.reservation-summary-modal.success': 'Your reservations have been successful!',
    'account.reservation.reservation-cancellation-modal.title': 'Cancel Reservation',
    'account.reservation.reservation-cancellation-modal.failed': 'We were unable to process your cancellation. Please try again later or contact customer support.',
    'account.reservation.reservation-cancellation-modal.cancelled': 'Your reservation has been successfully cancelled.',
    'account.reservation.reservation-summary-modal.badge.direct': 'Direct',
    'account.reservation.reservation-summary-modal.badge.multileg': 'Multi-leg',
    'account.reservation.reservation-summary-modal.email.title': 'A copy of your reservation has been sent to <span class="highlighted-text">{email}</span>. To collect your reservations, use the reservation code provided at a ticket machine at the station.',
    'account.reservation.item.title': 'Seat and Bike reservation',
    'account.reservation.item.message': 'This is a reservation only. A valid train ticket is required to travel.',
    'account.reservation.item.message.unavailable': 'Unavailable for this leg.',
    'account.reservation.outbound': 'Outbound',
    'account.reservation.return': 'Return',
    'account.reservation.seat': 'Seat reservation',
    'account.reservation.bike': 'Bike reservation',
    'account.reservation.reference': 'Collection reference',
    'account.reservation.date': 'Booking date :',
    'account.reservation.none': 'You have no upcoming or past reservations',

    "account.reservation.seating.any": "{count, plural, one {You can sit in any vacant seat for your class of travel} other {You can sit in any vacant seats for your class of travel}}",

    'account.reservation.bike.count': '{count, plural, one {# bike space reserved.} other {# bike spaces reserved.}}',
    'account.reservation.add-reservation-modal.bike.no-availability': 'There are not enough bike spaces available for this service.',
    'account.reservation.add-reservation-modal.seat.disabledMessage': 'Seat reservations are not available for this service.',
    'account.reservation.add-reservation-modal.bike.disabledMessage': 'Bike reservations are not available for this service.',

    'booking.fares.seats_reserved_header': 'Seat reservations',
    'booking.fares.bike_seats_reserved_header': 'Bike reservations',

    'booking.fares.seats_reserved': '{count, plural, one {# seat reserved} other {# seats reserved}}',
    'booking.fares.bike_seats_reserved': '{count, plural, one {# bike space reserved} other {# bikes spaces reserved}}',

    'passenger-assist.modal.text': 'If your accessibility details have recently changed, please amend your accessibility profile.',
    'passenger-assist.modal.no-trips.warning': 'You’re trying to proceed to checkout without choosing the journey(s) you require assistance for. \nPlease choose the journeys you require above.',
    'passenger-assist.modal.no-contact-answer.warning': 'Please choose "Can we contact you after your journey to discuss how it went?" above.',

    'alertmessage.required': 'This field is required',
    'alertmessage.required.short': 'Is required',
    'alertmessage.empty': 'This field is not allowed to be empty',
    'alertmessage.choose': 'Please choose from the list',
    'alertmessage.fieldsNoMatch': '{field} fields do not match',
    'alertmessage.badCardHolder': 'Please enter a valid cardholder name',
    'alertmessage.badPhotocardFirstName': 'Please enter a valid photocard first name',
    'alertmessage.badPhotocardLastName': 'Please enter a valid photocard last name',
    'alertmessage.badCardNumber': 'Please enter a valid card number',
    'alertmessage.photocardNumber': 'Please enter a valid photocard number',
    'alertmessage.badExpiryMonth': 'Please enter an expiry month',
    'alertmessage.badExpiryYear': 'Please enter an expiry year',
    'alertmessage.cardExpired': 'Provided card is expired',
    'alertmessage.badCvv': 'Please enter a valid CVV',
    'alertmessage.badSortCode': 'Please enter a valid sort code',
    'alertmessage.badAccountNumber': 'Please enter a valid account number',
    'alertmessage.badBacs': 'Please enter a valid sort code and account number, and then confirm to validate',
    'alertmessage.bacsValidation.failure': 'The information you have provided appears to be invalid. Please check your details and try again',
    'alertmessage.bacsValidation.success': 'Your sort code and account number fields match.',
    'alertmessage.badAddressLine': 'Please enter a valid address line',
    'alertmessage.badTownCity': 'Please enter a valid town/city',
    'alertmessage.badPostCode': 'Please enter a valid post code',
    'alertmessage.badCountry': 'Please enter a country',
    'alertmessage.badContactNumber': 'Please enter a valid contact number',
    'alertmessage.badMobileNumber': 'Please enter a valid mobile phone number',
    'alertmessage.badEmail': 'Please enter a valid email address',
    'alertmessage.nonMatchingconfirmEmail': 'Emails must match',
    'alertmessage.badPassword': 'Please enter a strong password (min 8 chars)',
    'alertmessage.badPassword.tooShort': 'At least 8 characters are required',
    'alertmessage.badName': 'Please only enter letters A-Z',
    'alertmessage.incorrectPassword': 'Authentication failed. Please check and try again.',
    'alertmessage.termsConditions': 'Please read and accept the Terms & Conditions',
    'alertmessage.registration.failed': 'Sorry but we could not register your account at this time. Please try again later',
    'alertmessage.registration.failed.emailInUse': 'You already have an account with us (Southern, Thameslink, Great Northern, Gatwick Express). All you need to do is log in or register with a different email address. <a href="{learnMoreUrl}" target="_blank">Learn more <i class="external-link external-link-no-underline"><i class="otrl otrl-externallink"></i></i></a>.',
    'alertmessage.paymentRegistration.failed.emailInUse': 'You already have an account with us (Southern, Thameslink, Great Northern, Gatwick Express). All you need to do is log in or register with a different email address. <a href="{learnMoreUrl} target="_blank">Learn more <i class="external-link external-link-no-underline"><i class="otrl otrl-externallink"></i></i></a>.',
    'alertmessage.registration.failed.postcodeInvalid': 'Your account has been successfully created. We could not complete your <{global.key}> <{global.smartcard}> registration as the postcode given appears to be invalid',
    'alertmessage.login.failed': 'Login failed. Please check your details and try again',
    'alertmessage.date.future': 'The date entered is in the future',
    'alertmessage.date.invalid': 'An invalid date has been entered',
    'alertmessage.time.invalid': 'An invalid time has been entered',
    'alertmessage.date.tooYoung': 'Children under 5 travel for free on the rail network. Please apply for a <{global.smartcard}> when the child reaches 5 years of age.',
    'alertmessage.date.tooYoungPhotocard': 'Children under 5 travel for free on the rail network.',
    'alertmessage.date.under16Photocard': 'If you are over 16, please switch the toggle.',
    'alertmessage.date.over16': 'You must be over 16 for the self registred <{global.smartcard}>',
    'alertmessage.login.badPassword': 'Please enter your password (min 8 chars)',
    'alertmessage.login.badEmail': 'Please enter your email address',
    'alertmessage.regex': 'Please enter a valid {fieldName}',
    'alertmessage.regex.fieldName': 'value',
    'alertmessage.disruptedServicesPart1': 'One or more of the services shown are disrupted, click ',
    'alertmessage.disruptedServicesPart2': ' to see if there are alternative routes available',
    'alertmessage.realTimeSearchPart1': 'You have chosen to search for realtime services, click ',
    'alertmessage.realTimeSearchPart2': ' to search for scheduled services',
    'alertmessage.smartcard': 'A valid {fieldName} is 18 digits long and starts with 633',
    'alertmessage.railcard-number.character-length-16-17': 'Must be at least 15 characters long',

    'alertmessage.string.min': 'Must be {num} or more characters long',
    'alertmessage.string.max': 'Must be {num, plural, =1 { a single character} other {{num} characters or fewer}}',

    'alertmessage.form.moreRailcardsThanPassengers': 'You cannot have more Railcards than passengers',
    'alertmessage.price': 'Please enter a valid price',

    'alertmessage.badDiscountCode': 'Please enter a valid discount',
    'alertmessage.discountCodeNotApplied': 'Please apply this discount and proceed',

    'payment.aboutToPay': 'You are about to pay',
    'payment.chooseAmount': 'Amount',
    'payment.deliveryDetails': 'Delivery address',
    'payment.viewDetails': 'View details',
    'payment.email.verification': 'Verify email address',
    'payment.billingAddress': 'Billing address',
    'payment.billingAddress.useShippingAddress': 'Use delivery address',
    'payment.sameAsDeliveryAddress': 'Same as delivery address',
    'payment.sameAsBillingAddress': 'Same as billing address',
    'payment.sameAsBillingAddressDisabled': 'Same as billing address (must be a UK address)',
    'payment.contactDetails': 'Contact details',
    'payment.payNow': 'Pay {basketTotal}',
    'payment.notReady.amazonPayInvalid': 'Please log in to your Amazon Pay account first',
    'payment.notReady.cardFormErrors': 'Please fix errors in your form',
    'payment.notReady.missingPaymentMethod': 'Please select your payment method',
    'payment.notReady.visaCheckoutNotValid': 'Your Visa Checkout card details are not valid. Please try again.',
    'payment.notReady.visaCheckoutAddressNotValid': 'Your Visa Checkout delivery address is outside United Kingdom. Please select UK delivery address to continue.',
    'payment.processing': 'We are processing your payment now...',
    'payment.processing.title': 'Please wait',
    'payment.processing.slowly.1': 'Please wait while your payment is processed.',
    'payment.processing.slowly.2': 'Thank you for waiting. Your payment is currently being processed.',
    'payment.processing.slowly.3': 'Thank you for waiting. We apologise for the delay while your payment is being processed.',
    'payment.processing.slowly.4': 'We are very sorry that it is taking a long time to complete your purchase.\n                                    We are waiting for confirmation that your payment has been processed.\n                                    In very rare circumstances this can take several minutes.\n                                    We thank you for your patience.',
    'payment.processing.slowly.5': 'We apologise that you are being made to wait a long time for confirmation that your payment has completed.\n                                    Our payment provider is experiencing some difficulties.\n                                    Your payment has been submitted, and we are waiting for the response.\n                                    We ask you to please wait a little longer. Please do not close this page.',
    'payment.processing.slowly.6': 'We are still waiting for confirmation that your payment has succeeded.\n                                    In very rare circumstances this can take several minutes.\n                                    Please do not try to purchase your tickets again until we know the state of this order,\n                                    as this might result in you paying for tickets twice.\n                                    If you are concerned about this situation, our customer service team will be happy to help on {customerServicesPhoneNumber}',
    'payment.amountPayable': 'Amount payable is {payableAmount}',
    'payment.chooseMethod': 'Payment method',
    'payment.chooseMethod.amazonPay': 'Pay with your Amazon account',
    'payment.chooseMethod.card': 'Pay by card',
    'payment.chooseMethod.paypal': 'Pay with PayPal',
    'payment.chooseMethod.visacheckout': 'Pay with Visa Checkout',
    'payment.goBack': 'Go back',
    'payment.goBackAndChooseDifferent': 'Go back and choose different payment method',
    'payment.details': '{paymentMethod} {amount}',
    'payment.details.paypal': '{ paypalAccount }',
    'payment.details.amazonPay': '{ amazonPayAccount }',
    'payment.details.applePay': '**** **** **** { applePayAccount }',
    'payment.details.googlePay': '**** **** **** { googlePayAccount }',
    'payment.evouchers': 'eVouchers',
    'payment.card.enterDetails': 'Please enter your card details',
    'payment.cardType.text': 'We accept Visa, Visa Debit, MasterCard, MasterCard Debit, Maestro and American Express.',
    'payment.cardType.visa': 'Visa',
    'payment.cardType.mastercard': 'MasterCard',
    'payment.cardType.maestro': 'Maestro',
    'payment.cardType.amex': 'American Express',
    'payment.security.safekey': 'Safe Key',

    'payment.method.paypal': 'PayPal',
    'payment.paypal.chooseCorrectAddress': "Please choose a UK delivery address in PayPal widget to continue. You chose an address with '{countryCode}' country code.",

    'payment.warning.paypal-etickets': 'Your e-Ticket will be sent to your registered PayPal email address. Please ensure you have access to this email account before selecting paypal',
    'payment.visacheckout.noAddress': 'Please select your Visa Checkout delivery address by clicking the "Edit" link next to the card',
    'payment.visacheckout.payment.card.expired': 'Your Visa Checkout saved card has expired.\n                                                  You will need to click on the Edit link and select another card.',
    'payment.visacheckout.review.message': 'Return to {brand} to complete your purchase.',
    'payment.visacheckout.continue': 'Continue',
    'payment.visacheckout.edit': 'Edit',
    'payment.visacheckout': 'Visa Checkout',
    'payment.visacheckout.saveCardDetails': 'Save payment details',
    'payment.visacheckout.cardInfo': '{brand} ** ** {lastFourDigits}',
    'payment.visacheckout.cardExpiryDate': 'Expiry {date}',
    'payment.visacheckout.tellMeMore': 'Tell me more',

    'payment.amazonPay.chooseCorrectAddress': "Please choose a UK delivery address in Amazon Pay address book to continue. You chose an address with '{countryCode}' country code.",
    'payment.amazonPay.buttonAltText': 'Click here to pay with Amazon Pay',
    'payment.amazonPay.errors.otrlGeneralError': 'There was a problem with your Amazon Pay session. You have NOT been charged. Please click the Amazon Pay button to try again.',
    'payment.amazonPay.errors.sessionExpired': 'Your Amazon Pay session expired. Please click the Amazon Pay button to try again.',
    'payment.amazonPay.header': 'Please select your Amazon Pay method',
    'payment.amazonPay.invalidPaymentMethod': 'Your payment could not be processed. Please place the order again using another payment method.',

    'payment.registration.termsAndConditions': 'By creating an account you confirm that you have read, and that you accept, our {termsAndConditions} and {privacyPolicy}.',

    // These error messages are based on codes returned to us by the API
    // they are subject to change but we can show a friendly message for each
    'payment.error.API_ERROR': 'There was an issue with the API. Please try again',
    'payment.error.BAD_PRICE': 'Amount does not match total',
    'payment.error.BAD_TRANSACTION_REFERENCE': 'Bad transaction reference',
    'payment.error.BRAND_NOT_FOUND': 'Sorry, your transaction has been declined by your bank, please contact your bank for more information',
    'payment.error.CANCELLED': 'Purchase cancelled by customer',
    'payment.error.CARD_NOT_FOUND': 'Saved card not found',
    'payment.error.DECLINED_BY_UPSTREAM_PROCESSOR': 'Sorry, your transaction has been declined by your bank, please contact your bank for more information',
    'payment.error.EXPIRED': 'Purchase expired during authorisation',
    'payment.error.NO_RESULT': 'No result returned',
    'payment.error.ORDER_NOT_FOUND': 'Order not found',
    'payment.error.ORDER_PAID': 'Order already paid',
    'payment.error.REJECTED_BY_FRAUD': 'Your card cannot be processed at this time, please contact customer services to continue',
    'payment.error.UNKNOWN_ERROR': 'There was an issue while processing your payment. Please try again',
    'payment.error.UNSUPPORTED_TYPE': 'We’re sorry, but we do not accept this card type',
    'payment.error.USER_NOT_VOUCHER_OWNER': 'Invalid voucher used',
    'payment.error.VOIDED': 'Connection failure. Please try again',
    'payment.error.VOUCHER_NOT_FOUND_OR_EXPIRED': 'Voucher not found or expired',
    'payment.error.VOUCHER_INSUFFICIENT_AMOUNT': 'Voucher does not cover amount',
    'payment.error.AMAZON_PAY_MFA_FAILURE': 'The multi-factor authorisation of your Amazon Pay payment has failed. Please try again.',
    "payment.error.AMAZON_PAY_INVALID_PAYMENT_METHOD_ERROR": 'InvalidPaymentMehotd',
    'payment.error.PAY360_TIMEOUT': 'Your payment session timed out. Please try again, or choose another payment method.',
    'payment.error.PAGE_REFRESHED': 'The page has been refreshed and cannot be recovered. Please try again.',
    'payment.braintree.payWithGooglePay': 'Pay with Google Pay',
    'payment.braintree.payWithApplePay': 'Pay with Apple Pay',

    required: ' (required)',
    'required.fields': 'Required fields',

    'order.summary.heading': 'Order summary',
    'order.summary.discount': 'Promotion',
    'order.summary.total': 'Total:',
    'order.summary.total_all': "Total",
    'order.summary.adminFee': "Admin Fee",
    'order.summary.total_paid': "Total paid",
    'order.summary.total_used': "Total used",
    'order.summary.total_journey': "Total - journey {number}",
    'order.summary.total_refund': "Amount refunded",
    'order.summary.voucherAmount': 'eVouchers selected',
    'order.summary.paymentAmount': 'Amount due',
    'order.summary.discount_code': 'Discount code',
    'order.summary.booking_fee': 'Booking fee',
    'order.summary.charity_donation': 'Charity Donation ',
    'order.summary.restrictions': 'See restrictions',
    'order.summary.smartcard_title': '<{global.key}> <{global.smartcardTicket}>',
    'order.summary.journey_title': 'Journey {number}',
    'order.summary.to': 'to',
    'order.summary.out': 'Out',
    'order.summary.dep': 'Depart',
    'order.summary.arr': 'Arrive',
    'order.summary.return': 'Return',
    'order.summary.duration': 'Duration',
    'order.summary.journey_date': '{date} depart {station} at {time}',
    'order.summary.journey_details': 'Journey details',
    'order.summary.journeyDetails.title': 'Journey details',
    'order.summary.travelBy': 'Travel by',
    'order.summary.seats': 'Seat reservations',
    'order.summary.bikes': 'Bike reservations',
    'order.summary.refunding': 'Refunding and changing your ticket',
    'order.summary.bring_railcard': 'Please make sure you bring your Railcard(s) with you.',
    'order.summary.passengers.adult': '{number} x Adult',
    'order.summary.passengers.adultRailcard': '{number} x Adult with railcard',
    'order.summary.passengers.adult.carnet': '{number} Adult tickets',
    'order.summary.passengers.adult_railcard': '{number} x Adult with Railcard',
    'order.summary.passengers.adult_groupsave': '{number} x Adult with Groupsave',
    'order.summary.passengers.adult_railcard.carnet': '{number} Adult tickets with Railcard',
    'order.summary.passengers.adultRefunded': '{number} x Adult (Refunded)',
    'order.summary.passengers.adultRefunded.carnet': '{number} Adult tickets (Refunded)',
    'order.summary.passengers.child': '{number} x Child',
    'order.summary.passengers.child.carnet': '{number} Child tickets',
    'order.summary.passengers.child_railcard': '{number} x Child with Railcard',
    'order.summary.passengers.child_groupsave': '{number} x Child with Groupsave',
    'order.summary.passengers.child_railcard.carnet': '{number} Child tickets with Railcard',
    'order.summary.passengers.childRefunded': '{number} x Child (Refunded)',
    'order.summary.passengers.childRefunded.carnet': '{number} Child tickets (Refunded)',
    'order.summary.railcardDiscount.JCP': 'Jobcentre Plus Travel Discount Card discount applied',
    'order.summary.railcardDiscount.TSU': '16-17 Saver discount applied',
    'order.summary.plusbus': 'PlusBus',
    'order.summary.validFrom': 'Valid from',
    'order.summary.validTo': 'Valid to',
    'order.summary.removeJourney': 'remove',
    'order.summary.confirmRemoveJourney': 'Are you sure you want to remove this journey?',
    'order.summary.groupSave': '(GroupSave)',
    'order.summary.groupSave.name': 'GroupSave',
    'order.summary.groupSave.text': 'This fare contains a GroupSave discount and is only valid if all passengers travel together.',
    'order.summary.groupSave.link': 'See details of exclusions and restrictions.',
    'order.summary.roversRangers.text': 'TODO order.summary.roversRangers.text',
    'order.summary.roversRangers.link': 'TODO order.summary.roversRangers.link',
    'order.summary.seating.coachSeat': 'Coach {coach}, Seat {seat}',
    'order.summary.duration.changes': '{changes, plural, =0 {Direct} =1 {Changes} other {Changes}}',
    'order.summary.change_trains': 'Change trains',
    'order.summary.download.tickets': 'Download tickets',
    'order.summary.download.title': 'Download tickets',
    'order.summary.download': 'Download',
    'order.summary.download.generating': 'Generating',
    'order.summary.download.ticketName': 'ticket {id}.pdf',
    'order.charity.title': 'Donate to the {charityName}',
    'order.charity.description-1': 'Donation is non-refundable.',
    'order.charity.description-2': 'You must be over 16 to donate.',
    'order.charity.checkbox-label': 'Round up',

    'order.invalidStateModal.heading': 'Order already paid',
    'order.invalidStateModal.paymentConfirmation': 'View Payment Confirmation',
    'order.invalidStateModal.planJourney': 'Plan another journey',
    'order.invalidStateModal.message': 'Sorry, but your current basket has already been paid for. This can happen if you have multiple tabs open, or it could be an error on our part. Your basket has been cleared, you can view your payment confirmation or start an new order.',

    'order.interopErrorModal.heading': 'Fare unavailable',
    'order.interopError.message': 'Sorry, but this fare is not available via this train operator.',
    'order.interopError.messageHelp': 'Please contact us if you require assistance.',

    'basket.empty': 'Your basket is empty.',
    'basket.expired': 'Basket expired',
    'basket.expired.chosenJourneys': 'Your basket has expired. It might be that it has been a while since you added to it, or perhaps {journeys, plural, =1 {your planned journey} other {one of your planned journeys}} is no longer available.',
    'basket.expired.pleaseTryAgain': 'Please try again',
    'basket.error.tooManyTrips': 'You can only buy one <{global.key}> <{global.smartcardTicket}> at a time. Please complete your order with this ticket, or clear your basket.',
    'basket.error.tripsLimit': "Sorry, we can't add this journey because it will exceed the max number of tickets.",
    'basket.error.smartcardTicketConflict': 'You cannot buy <{global.key}> <{global.smartcard}> tickets with paper tickets. Please complete your current order first, or clear your basket. ',
    'basket.error.noAvailability': "Sorry, we can't add this journey because there are not enough available seats.",

    'confirmation.keygo.success': 'You have successfully signed up to <{global.keyGo}>',
    'confirmation.success': 'Your payment was successful',
    'confirmation.details.email': 'Details of your purchase have been emailed to {email}',
    'confirmation.details.tracking.email': 'Details of your purchase and a tracking link have been emailed to {email}',
    'confirmation.reference': 'Order reference number',
    'confirmation.normalTod': 'To collect your tickets at {stationName}, bring any payment card and this collection reference.',
    'confirmation.collectionreference': 'Collection reference',
    'confirmation.collectionReferenceByEmail': 'You will receive your collection reference by email shortly.',
    'confirmation.postalDelivery': 'Your order will be sent to you by {deliveryMethod} to the following address:',
    'confirmation.delivery.address': 'customer name and address',
    'confirmation.delivery.printAtHome.emailDetails': 'Your {tickets, plural, =1{ticket} other{tickets}} will be emailed to you in a few minutes.',
    'confirmation.delivery.printAtHome.emailed': 'Your {tickets, plural, =1{ticket was} other{tickets were}} emailed to {email}',
    'confirmation.delivery.printAtHome.download': 'You can download and print your {tickets, plural, =1{ticket} other{tickets}} any time before your journey by clicking the download button beside your journey',
    'confirmation.delivery.printAtHome.downloadShortly': 'Your {tickets, plural, =1{ticket} other{tickets}} will also be available to download shortly from your purchase history.',
    'confirmation.delivery.printAtHome.printInstructions': 'Please ensure you print your ticket on plain white A4 paper.',
    'confirmation.smartcardNormal': 'Place your <{global.key}> <{global.smartcard}> on the gate reader or validator at {location} to load your ticket. Please allow a minimum of two hours after purchase before loading your ticket or use the {brand} On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> now.',
    'confirmation.fraud': 'Payment Failed',
    'confirmation.decline': 'Sorry, your payment has been declined for the following reason:',
    'confirmation.paymentgateway': 'Payment gateway error: {message}',
    'confirmation.externalError': 'External Service Error: {message}',
    'confirmation.externalErrorMessage': 'This error has been logged, please try again later',
    'confirmation.printPage': 'Print confirmation page',
    'confirmation.backToPayment': 'Back to payment details',
    'confirmation.viewOrderSummary': 'View order summary',
    'confirmation.planAnotherJourney': 'Plan another journey',
    'confirmation.prompt': 'Please confirm',
    'confirmation.discoverMore': '<p>Discover more with our partnership offers, saving you money on great days out. Click on the link: <a href="{url}" target="_blank">Discover More</a></p>',
    'confirmation.accessibilityInfo': '<p>Please click <a href="{url}" target="_blank">here</a> to request any assisted travel requirements ahead of time.</p>',
    'confirmation.tryAgain': 'Try again',
    'confirmation.trackAndTrace.info': 'Protect your loved ones. Download the <a href="{url}" target="_blank">NHS Track and Trace App</a>, and when out and about simply turn on ‘contact tracing’.',
    'confirmation.nhsTrackAndTraceApp': 'NHS Track and Track App',
    'confirmation.delayRepayInfo.title': 'Money back if your train is delayed',
    'confirmation.delayRepayInfo.сarbonFootprintCalculator': 'Discover the environmental impact of your journey with our new ',
    'confirmation.delayRepayInfo.сarbonFootprintCalculator.link': 'Carbon Footprint Calculator',
    'confirmation.delayRepayInfo.message': 'If you arrive 15 minutes or more late at your destination because of a delay or cancellation to a service, you can claim Delay Repay compensation. Delay Repay is a national scheme train companies use to compensate passengers for delays or cancellations. Claims can be made up to 28 days after your journey.',
    'confirmation.delayRepayInfo.link': 'Claim Delay Repay',

    'order.details.collectionreference': 'Collection reference {ref}',
    'order.details.collectionReferenceByEmail': 'You will receive your collection reference by email shortly',
    'order.details.todWithAnyCard': 'In {deliveryTime} minutes your ticket(s) will be ready for collection from <strong>{stationName}</strong>, or any other station where ticket collection facilities are available.<br><br>To collect your tickets from a ticket machine you will need both your collection reference <strong>{ref}</strong> and <strong>any credit or debit card with a magnetic strip</strong>  (your card will not be charged but is still required in order to collect tickets).',
    'order.details.eTicketDelivery': 'Your tickets will be emailed to {isGuest, select,\n            true {{\n                isPaypal, select,\n                true {to your PayPal registered address}\n                false {{\n                    isAmazonPay, select,\n                    true {to your Amazon Pay registered address}\n                    false {{email}}\n                }}\n            }}\n            false {{email}}\n        }, if not received please check junk/spam inboxes. You have the option to download your eTickets to your native ticket wallet. Registered customers can download their unexpired eTickets from their My Account. You can use a mobile device to present your ticket for inspection or to pass through a gateline. Alternatively, you can print your ticket using plain white A4 paper.',
    'order.details.postalDelivery': '{deliveryMethod} to the following address:',
    'order.details.postalDelivery.description': 'Your ticket will arrive as a printed eTicket, designed to be more sustainable and easier to recycle. Just scan the barcode on the gate at the station and show the ticket to staff when asked. {here} for more information about eTickets.',
    'order.details.smartcardWithProductDelivery': 'Your ticket will be preloaded onto your new <{global.key}> <{global.smartcard}>.',
    'order.details.smartcard': 'Use the Southeastern mobile app to load your purchase(s) to the Key Smartcard(s) now. Alternatively, please allow a minimum of two hours after purchase to load your ticket(s) at a gate reader or validator at {location}.',

    'voucher.showDetails': 'Show details',
    'voucher.hideDetails': 'Hide details',
    'voucher.reference': 'eVoucher reference',
    'voucher.expiryDate': 'Expiry date',
    'voucher.amount': 'Amount',
    'voucher.total': 'Total {voucherTotal}',
    'voucher.youHaveAvailable': 'You have <strong>{voucherTotal}</strong> in eVouchers available.',
    'voucher.noneAvailable': 'You do not have any eVouchers to view.',
    'voucher.payUsing': 'Pay using eVouchers',
    'voucher.error.number.base': 'Amount must be a number',
    'voucher.error.number.min': 'Amount must be greater than or equal to £0.00',
    'voucher.error.number.max': 'Amount must be less than or equal to £{maxAmount}',

    'ariaLabel.toggleMap': 'Toggle size of map',
    'ariaLabel.plusBusModal': 'Add PlusBus',
    'ariaLabel.showFares': 'Show fares',
    'ariaLabel.showJourneyDetails': 'Show journey details',
    'ariaLabel.showFromToJourneyDetails': 'Show {stations} journey details',
    'ariaLabel.showFromToJourneyDetails.stations': '{from} to {to}',
    'ariaLabel.openSeatingPrefs': 'Add seating preferences',
    'ariaLabel.openDaySaveTicketSearch': 'Open DaySave tickets search form',
    'ariaLabel.openRoversRangersTicketSearch': 'Open Rover tickets search form',
    'ariaLabel.clearContent': 'Clear content',
    'ariaLabel.openBasket': 'Open basket',
    'ariaLabel.basketButton': '{journeys, plural,\n            =0 {Basket is empty, 0 journeys \xA30.00}\n            =1 {1 journey in basket totalling {price}}\n            other {# journeys in basket totalling {price}}\n        }. <{ariaLabel.openBasket}>.',
    'ariaLabel.showLoginDropdown': 'Log in / register',
    'ariaLabel.openLogin': 'Log in',
    'ariaLabel.openRegister': 'Register',
    'ariaLabel.openFavourites': 'Open favourite tickets',
    'ariaLabel.editSection': 'Edit section ',
    'ariaLabel.booking.delivery.stationSelect': 'Select the station that you would like to collect your tickets from.',
    'ariaLabel.passengerInfo': '. Click to edit passengers',
    'ariaLabel.stepperInput': '{label, select,\n            Children {Currently {value, plural, =1{# child} other{# children}}, click to {direction} 1 child.}\n            Adults {Currently {value, plural, =1{# adult} other{# adults}}, click to {direction} 1 adult.}\n            other {Currently {value} {label}, click to {direction} 1 {label}.}\n        }\n    ',
    'ariaLabel.seasonPassenger': '{passenger} ticket selected. Toggle to change',
    'ariaLabel.seasonDuration': 'Include {duration} season tickets',
    'ariaLabel.setFieldDescription': 'set {field} as ',
    'ariaLabel.fieldDescription': '{field} is set as ',
    'ariaLabel.clickToChange': '. Click to change.',
    'ariaLabel.startDateField': 'start date ',
    'ariaLabel.outboundDateField': 'outbound date',
    'ariaLabel.returnDateField': 'return date',
    'ariaLabel.webchatButton': 'Open a web chat to our support team',
    'ariaLabel.add-reservation-modal.bikesSelect': 'Choose the number of bikes',

    'form.dateSelector.placeholder': 'Select a date',
    'form.dateModal.selectDate': 'form.dateSelector.placeholder',
    'form.termsAndConditions': 'terms and conditions',
    'form.keyGoTermsAndConditions': '<{global.keyGo}> Conditions of Use',
    'form.termsYouAgreeTo': 'By clicking pay you agree that our {termsAndConditions} and the {nationalRailTerms}\n         govern your purchase and the terms of your journey.',
    'form.termsAndConditions.capitalised': 'Terms & Conditions',
    'form.registration.termsAndConditions': 'By clicking “Create my account” you confirm that you have read, and that you accept, our {termsAndConditions} and {privacyPolicy}',
    'form.nationalRailConditions': 'National Rail Conditions of Travel',
    'form.privacyPolicy': 'privacy policy',
    'form.optional': '(optional)',
    'form.required': '(required)',
    'form.fieldset.optional': 'Optional',
    'autocomplete.resultCount': '{count, plural, =1{# item} other{# items}} available',
    'selectCustom.resultCount': '{count, plural, =1{# item} other{# items}} available',

    'form.discountCode.placeholder': 'Discount code',
    'form.discountCode.error.server': 'Server error',
    'form.discountCode.error.login': 'You need to login to use this discount code.',
    'form.discountCode.error.invalidCode': 'Invalid discount code.',
    'form.discountCode.error.invalidDiscount': 'Invalid discount code.',
    'form.discountCode.button': 'Apply',
    'form.discountCode.remove': 'Remove promotion',

    'footer.legal': 'Legal',
    'footer.accessibilityStatement': 'Accessibility statement',
    'footer.owner': 'Govia',
    'footer.faqs': 'FAQs',
    'footer.contact': 'Contact us',

    'poweredBy.text': 'Powered by OnTrack Retail',

    'address.useSavedAddress': 'Use a saved address',
    'address.saveAddress': 'Save this address',
    'address.noName': 'No Name',
    'address.delete': 'Delete address',
    'address.edit': 'Edit address',
    'address.noAddresses': 'You have no saved addresses.',
    'address.none': 'You don’t currently have any addresses saved. The next time you buy a ticket you can save your address details by ticking the ‘Save this address’ box on the payment screen.',
    'address.confirmDelete': 'Please confirm that you wish delete the following address:',
    'address.confirmDeleteOCDR': 'This is your One Click Delay Repay address. If you delete this address, you will be opted out of One Click Delay Repay.\n        Please confirm that you wish delete the following address:',
    'address.max': "Sorry, you've reached the maximum number of saved addresses allowed",
    'address.noAllowedEdit': 'Until your <{global.key}> <{global.smartcard}> is active, you are not allowed to edit your address.',
    'address.enterManually': 'Enter address manually',
    'address.clearAddress': 'Clear address',

    'photocard.confirmDelete': 'Please confirm that you wish delete the following photocard:',
    'photocard.updateOldRecord': 'We now require additional information to validate your photocard record, please provide the missing information in order for us to update your record and continue with your season ticket purchase.',
    'photocard.delete': 'Delete photocard',
    'photocard.nophotocards': 'You don’t currently have any photocard details saved. The next time you buy a paper season ticket you can save your photocard by ticking the ‘Save this photocard’ box on the ticket collection option screen.',
    'photocard.useSavedPhotocard': 'Use a saved photocard',
    'photocard.savePhotocard': 'Save this photocard',
    'photocard.nickname': 'Nickname',
    'photocard.addPhotocard': 'Add a photocard',
    'photocard.more-info.trigger': 'More info',
    'photocard.more-info.title': 'Photocard details',
    'photocard.more-info.text': '<p>We cannot sell a Season Ticket without a valid photocard. Any period Season Ticket requires a photocard.</p> <p>You can use your existing photocard if you are renewing your season ticket.</p> <p>If you do not have a photocard, you can acquire one free of charge from your local station. You will need to provide a passport sized photo.</p> <p>Your photocard and ticket will need to be presented for inspection when travelling.</p>',
    'photocard.deliveryAddress': 'Address',
    'railcard.norailcards': 'You have no saved railcards',
    'railcard.add.info': 'To add a Railcard to your online account, please complete the form below. We aim to review this within 5 working days.',
    'railcard.add.first-name': 'First name',
    'railcard.add.last-name': 'Last name',
    'railcard.add.railcard-type': 'Railcard type',
    'railcard.add.railcard-number': 'Railcard number',
    'railcard.add.railcard-number.error.character-length-16-17': 'alertmessage.railcard-number.character-length-16-17',
    'railcard.add.railcard-number.help': 'Railcard number here',
    'railcard.add.railcard-info.help': 'Where can I find my Railcard number?',
    'railcard.add.disabled-person-example-physical': 'disabled-person-example-physical',
    'railcard.add.disabled-person-example-digital': 'disabled-person-example-digital',
    'railcard.add.expiry-date': 'Expiry date',
    'railcard.add.railcard-image': 'Image of your Railcard:',
    'railcard.add.uploadcondition1': 'Required',
    'railcard.add.uploadcondition2': 'Must be below ' + (0, _humanSize2.default)(_AppConstants.UploadSize5mb) + ' in size',
    'railcard.add.apply': 'Apply',
    'railcard.list.railcard-type': 'Railcard type',
    'railcard.list.railcard-number': 'Railcard',
    'railcard.list.railcard-status': 'Status',
    'railcard.list.keyGoEnabled': 'keyGo enabled',
    'railcard.list.expiry': 'Expiry',
    'railcard.list.added': 'Added',
    'railcard.list.pending': 'Pending approval',
    'railcard.list.remove': 'Remove',
    'railcard.list.addKeyGo': 'Add to keyGo',
    'railcard.delete.modal.confirmDelete': 'Please confirm that you wish to delete the following railcard:',
    'railcard.delete.modal.railcard-type': 'Railcard type:',
    'railcard.delete.modal.railcard-number': 'Railcard number:',
    'railcard.delete.modal.expiry': 'Expiry:',
    'railcard.delete.modal.added': 'Added:',
    'railcard.link.modal.confirmLinkKeyGo': 'Do you want to add this railcard to the keyGo account <strong>{email}</strong>?',
    'railcard.link.modal.failure': 'There was a problem linking your railcard to your keyGo account. Please try again later.',
    'railcard.link.modal.success': 'Your railcard has been successfully linked to your keyGo account.',
    'railcard.newlyApprovedRailcards.modal.title': 'New Railcard',
    'railcard.newlyApprovedRailcards.modal.message.one': 'Good news, {railcardName} has now been added to your keyGo account. Discounts will be applied automatically when you travel using keyGo',
    'railcard.newlyApprovedRailcards.modal.message.multiple': 'Good news, {railcardCount} railcards have now been added to your online account, discounts will be applied automatically when you travel using keyGo',
    'railcard.newlyApprovedRailcards.modal.confirmButtonText': 'View railcards',
    'railcard.syncKeyGoRailcards.modal.title': 'Sync with keyGo',
    'railcard.syncKeyGoRailcards.modal.message': 'Good news, you are now registered for keyGo. You can now add railcards to your keyGo to enjoy discounted travel',
    'railcard.syncKeyGoRailcards.modal.confirmButtonText': 'View railcards',

    // Disruption alerts
    'disruptionAlerts.create.button': 'Create alert',
    'disruptionAlerts.create.button.generic': 'Regular journey alerts',
    'disruptionAlerts.create.button.matchingAlert': 'Alert created',
    'disruptionAlerts.modals.common.title': 'Journey alerts',
    'disruptionAlerts.modals.common.intro': "We'll keep you updated on delays and disruptions to your journey with real time information straight to your inbox.",
    'disruptionAlerts.modals.common.disclaimer': 'By clicking "Create alert" you agree to receiving emails concerning delays and disruptions on chosen services',
    'disruptionAlerts.modals.journeySelect.items': '{totalJourneys, plural, =1{We will only alert you to delays and disruption to the following journey:} other{Select which journeys you want to be alerted on:}}',
    'disruptionAlerts.modals.builder.services.heading': 'What services would you like to be alerted on?',
    'disruptionAlerts.modals.builder.duration.heading': 'Alert duration',
    'disruptionAlerts.modals.builder.duration.aria': 'Select how long you want the alert to last',
    'disruptionAlerts.modals.builder.duration.bankHolidayRestrictionNotice': 'Options limited due to the start date falling on a bank holiday',
    'disruptionAlerts.modals.builder.duration.sixMonths.label': '6 months',
    'disruptionAlerts.modals.builder.duration.sixMonths.supporting': 'This alert will remain active until {date}',
    'disruptionAlerts.modals.builder.duration.datePicker.chooseDate': 'Choose a date',
    'disruptionAlerts.modals.builder.duration.datePicker.changeDate': 'Change',
    'disruptionAlerts.modals.builder.duration.oneOff.label': 'One-off',
    'disruptionAlerts.modals.builder.duration.oneOff.today': 'Today',
    'disruptionAlerts.modals.builder.duration.oneOff.tomorrow': 'Tomorrow',
    'disruptionAlerts.modals.builder.duration.oneOff.supporting': 'You will only be alerted on {date}',
    'disruptionAlerts.modals.builder.duration.custom.label': 'Custom',
    'disruptionAlerts.modals.builder.duration.custom.startDate': 'Start date: ',
    'disruptionAlerts.modals.builder.duration.custom.supporting': 'End date: ',
    'disruptionAlerts.modals.builder.duration.custom.supporting.endDateChosen': 'This alert will remain active until ',
    'disruptionAlerts.modals.builder.days.heading': 'What days do you want to be alerted on?',
    'disruptionAlerts.modals.builder.days.aria': 'Select when you want to be alerted',
    'disruptionAlerts.modals.builder.days.weekdays.label': 'Weekdays',
    'disruptionAlerts.modals.builder.days.weekdays.aria': 'Select which weekdays you want to be alerted on',
    'disruptionAlerts.modals.builder.days.weekdays.monday': 'Monday',
    'disruptionAlerts.modals.builder.days.weekdays.tuesday': 'Tuesday',
    'disruptionAlerts.modals.builder.days.weekdays.wednesday': 'Wednesday',
    'disruptionAlerts.modals.builder.days.weekdays.thursday': 'Thursday',
    'disruptionAlerts.modals.builder.days.weekdays.friday': 'Friday',
    'disruptionAlerts.modals.builder.days.saturdays.label': 'Saturdays',
    'disruptionAlerts.modals.builder.days.sundays.label': 'Sundays',
    'disruptionAlerts.modals.success.heading': 'Journey alert created',
    'disruptionAlerts.modals.success.message.oneOff': 'You will only be alerted to the service(s) you plan on travelling on. The alert will be cancelled when your train has reached your destination.',
    'disruptionAlerts.modals.success.message.ongoing': 'You can change your alert preferences at any point by going into \'My Account\' and updating what you\'d like to receive.',
    'disruptionAlerts.modals.success.createReturnAlert': 'Create return journey alert',
    'disruptionAlerts.modals.limitExceeded.title': 'We could not create your alert',
    'disruptionAlerts.modals.limitExceeded.message': 'You have saved the maximum amount of disruption alerts. Please remove one or more alerts and try again.',
    'disruptionAlerts.modals.error.title': 'We could edit create your alert',
    'disruptionAlerts.modals.mute.title': 'Pause your journey alert',
    'disruptionAlerts.modals.mute.muteFrom': 'Pause alert from',
    'disruptionAlerts.modals.mute.reactivation': 'When do you want to reactivate your alert from {origin} to {destination}?',
    'disruptionAlerts.modals.mute.reactivation.never.label': "Deactivate",
    'disruptionAlerts.modals.mute.reactivation.never.supporting': 'This alert will remain paused until you reactivate it within your account',
    'disruptionAlerts.modals.mute.reactivation.day.label': "1 day",
    'disruptionAlerts.modals.mute.reactivation.week.label': '1 week',
    'disruptionAlerts.modals.mute.reactivation.month.label': '1 month',
    'disruptionAlerts.modals.mute.reactivation.custom.label': 'Select a date',
    'disruptionAlerts.modals.mute.reactivation.custom.endDate': 'Reactivation date: ',
    'disruptionAlerts.modals.mute.disclaimer': 'You will not be alerted on any disruption to this journey whilst the alert is paused',
    'disruptionAlerts.modals.mute.confirm.button': 'Pause alert',
    'disruptionAlerts.serviceSelector.stations.origin.label': 'booking.journey.origin.label',
    'disruptionAlerts.serviceSelector.stations.origin': 'booking.journey.origin',
    'disruptionAlerts.serviceSelector.stations.destination.label': 'booking.journey.destination.label',
    'disruptionAlerts.serviceSelector.stations.destination': 'booking.journey.destination',
    'disruptionAlerts.serviceSelector.departureDatetime.part1': 'Alert me on services starting from ',
    'disruptionAlerts.serviceSelector.departureDatetime.part2': ' departing around ',
    'disruptionAlerts.serviceSelector.departureDatetime.changeDate': '(change)',
    'disruptionAlerts.serviceSelector.noServicesFound': 'No services found',
    'disruptionAlerts.serviceSelector.earlier': 'Earlier',
    'disruptionAlerts.serviceSelector.later': 'Later',
    'disruptionAlerts.serviceSelector.table.caption': 'List of services',
    'disruptionAlerts.serviceSelector.table.departs': 'Departs',
    'disruptionAlerts.serviceSelector.table.arrives': 'Arrives',
    'disruptionAlerts.serviceSelector.table.from': 'From',
    'disruptionAlerts.serviceSelector.table.to': 'To',
    'disruptionAlerts.serviceSelector.table.duration': 'Duration',
    'disruptionAlerts.serviceSelector.table.changes': 'Changes',
    'disruptionAlerts.serviceSelector.table.setUpAlert': 'Set up alert',
    'disruptionAlerts.serviceSelector.serviceCount': '\n        {count, plural,\n            =0 {Receive alerts for up to 5 services}\n            =1 {Alerts set up for # service}\n            other {Alerts set up for # services}\n        }',
    'disruptionAlerts.serviceSelector.selectionLimitExceeded': 'Too many services selected (maximum {max})',
    'disruptionAlerts.serviceSelector.clearSelection': 'Clear selection',
    'disruptionAlerts.landing.mute.heading': 'account.nav.disruptionAlerts',
    'disruptionAlerts.landing.mute.confirm.text': 'Are you sure you wish to mute {muteAll, select, true {all alerts} other {this alert}} for the day?',
    'disruptionAlerts.landing.mute.confirm.button': 'Mute {muteAll, select, true {all alerts} other {alert}}',
    'disruptionAlerts.landing.mute.successModal.title': '{muteAll, select, true {Alerts} other {Alert}} paused',
    'disruptionAlerts.landing.mute.successModal.message': 'You will no longer receive disruption notifications for {muteAll, select, true {any of your existing alerts} other {this alert}} today.',
    'disruptionAlerts.landing.mute.errors.common.title': 'We could not mute your {muteAll, select, true {alerts} other {alert}}',
    'disruptionAlerts.landing.mute.errors.invalidURL.message': 'Please double-check the link from your email and try again.',
    'disruptionAlerts.landing.mute.errors.securityCheckFailure.message': 'Invalid security token.',
    'disruptionAlerts.landing.mute.errors.tokenExpired.message': 'Security token expired.',
    'disruptionAlerts.landing.mute.errors.alreadyMuted.message': 'This alert is already muted.',

    'disruptionAlerts.landing.delete.heading': 'Disruption alerts',
    'disruptionAlerts.landing.delete.errors.general': 'Your alert could not be deleted',
    'disruptionAlerts.landing.delete.errors.invalidURL.message': 'Please double-check the link from your email and try again.',
    'disruptionAlerts.landing.delete.successModal.title': 'Alert deleted',
    'disruptionAlerts.landing.delete.successModal.message': 'You will no longer receive disruption change notifications for this journey',
    'disruptionAlerts.landing.delete.errors.common.title': 'We could not delete your alert',
    'disruptionAlerts.landing.delete.confirm.text': 'Are you sure you wish to delete this alert?',
    'disruptionAlerts.landing.delete.confirm.button': 'Delete alert',

    'nre.journeyPlanner.linkText': 'You can view more information about your ticket here',
    'nre.transferModal.failure.sorry': 'Sorry, something went wrong.',
    'nre.transferModal.failure.text': 'We were unable to transfer your basket from National Rail to the {brand} ticketing website.',
    'nre.transferModal.failure.text2': 'Please plan your journey again here.',

    'nre.transferModal.success.text': 'We have transferred your basket from National Rail to the {brand} ticketing website.',
    'nre.transferModal.success.text2': 'You can now continue with your purchase.',
    'nre.landingPage.transferring': 'Transferring your basket',
    'nre.logoAltText': 'national rail logo',

    // Travelcards
    'tickettype.ADT': 'Valid at all times. Includes unlimited travel on trains, London Underground, buses, DLR and Tramlink services within the zones specified. Refundable.',
    'tickettype.FDT': 'tickettype.ADT',

    'tickettype.1ST': 'Valid at off-peak times only. Includes unlimited travel on trains, London Underground, buses, DLR and Tramlink services within the zones specified. Refundable.',
    'tickettype.1DT': 'tickettype.CST',
    'tickettype.AM3': 'tickettype.1ST',
    'tickettype.FTX': 'tickettype.1ST',
    'tickettype.ODT': 'tickettype.1ST',
    'tickettype.OTF': 'tickettype.1ST',
    'tickettype.SNT': 'tickettype.1ST',
    'tickettype.SOT': 'tickettype.1ST',
    'tickettype.STO': 'tickettype.1ST',
    'tickettype.STP': 'tickettype.1ST',
    'tickettype.WDT': 'tickettype.1ST',
    'tickettype.WKC': 'tickettype.1ST',
    'tickettype.WRE': 'tickettype.1ST',
    'tickettype.WTC': 'tickettype.1ST',

    // Off-Peak Single
    'tickettype.SVS': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.BVS': 'tickettype.SVS',
    'tickettype.FSS': 'tickettype.SVS',
    'tickettype.BFS': 'tickettype.SVS',

    // Off-Peak Day Single
    'tickettype.CDS': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.SVH': 'tickettype.CDS',

    // Off-Peak Return
    'tickettype.SVR': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.BVR': 'tickettype.SVR',
    'tickettype.FSR': 'tickettype.SVR',
    'tickettype.BFR': 'tickettype.SVR',
    'tickettype.SFR': 'tickettype.SVR',

    // Off-Peak Day Return
    'tickettype.CDR': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.1DR': 'tickettype.CDR',
    'tickettype.FCD': 'tickettype.CDR',
    'tickettype.FCR': 'tickettype.CDR',
    'tickettype.GE1': 'tickettype.CDR',

    // Super Off-Peak Single
    'tickettype.SSS': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.OPS': 'tickettype.SSS',

    // Super Off-Peak Day Single
    'tickettype.SWS': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.OPD': 'tickettype.SWS',
    'tickettype.GDS': 'tickettype.SWS',
    'tickettype.PDS': 'tickettype.SWS',

    // Super Off-Peak Return
    'tickettype.SSR': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.OPR': 'tickettype.SSR',
    'tickettype.SOP': 'tickettype.SSR',

    // Super Off-Peak Day Return
    'tickettype.SRR': 'Flexible ticket valid for travel on off-peak trains only',
    'tickettype.SCO': 'tickettype.SRR',
    'tickettype.PDR': 'tickettype.SRR',
    'tickettype.C1R': 'tickettype.SRR',
    'tickettype.CBA': 'tickettype.SRR',
    'tickettype.GDR': 'tickettype.SRR',
    'tickettype.FSO': 'tickettype.SRR',

    // Super Off-Peak Day Return
    'tickettype.SOS': 'Flexible ticket with no time restrictions on when you can travel',
    'tickettype.FOS': 'tickettype.SOS',
    'tickettype.GFS': 'tickettype.SOS',

    // Anytime Day Single
    'tickettype.SDS': 'Flexible ticket with no time restrictions on when you can travel',
    'tickettype.FDS': 'tickettype.SDS',

    // Anytime Return
    'tickettype.SOR': 'Flexible ticket with no time restrictions on when you can travel',
    'tickettype.GOR': 'tickettype.SOR',
    'tickettype.FOR': 'tickettype.SOR',
    'tickettype.GFR': 'tickettype.SOR',

    // Anytime Day Return
    'tickettype.SDR': 'Flexible ticket with no time restrictions on when you can travel',
    'tickettype.GPR': 'tickettype.SDR',
    'tickettype.FDR': 'tickettype.SDR',

    // Day Save
    'tickettype.SDP': 'A pass available for unlimited travel on Southern services at anytime on the date shown on the ticket',
    'tickettype.SD1': 'An off-peak pass available for unlimited travel on off-peak Southern services on the date shown on the ticket',
    'tickettype.SD4': 'An off-peak pass available for 3 or 4 people travelling together (which can be a combination of Adults and Children) unlimited travel on off-peak Southern services on the date shown on the ticket',

    // ITSO product descriptions
    'itso.typ22.ptyp1': 'Season ticket',
    'itso.typ22.ptyp5': 'Flexi Season Pass',
    'itso.typ22.ptyp4': 'keyGo',
    'itso.typ22.ptyp19': 'Travelcard',
    'itso.typ22.ptyp28': 'DaySave',
    'itso.typ22.ptyp29': 'PlusBus',
    'itso.typ22.ptyp30': 'Gateline Pass',
    'itso.typ22.ptyp31': 'Staff Pass',
    'itso.typ23.ptyp1': 'Peak Single',
    'itso.typ23.ptyp2': 'Off-Peak Single',
    'itso.typ23.ptyp3': 'Peak Return',
    'itso.typ23.ptyp4': 'Off-Peak Return',

    'maintenance.title': 'Temporarily down for maintenance',
    'maintenance.heading': 'Temporarily down for maintenance',
    'maintenance.description': "Sorry for the inconvenience but we're performing some scheduled maintenance at the moment, and should be back online shortly.",

    'newsletter.unsubscribe.heading': 'Unsubscribe from marketing emails',
    'newsletter.unsubscribe.button': 'Unsubscribe',
    'newsletter.unsubscribe.option.sr-only': 'Check this box if you would like to unsubscribe from emails with {option}',

    'newsletter.unsubscribed.heading': 'You have been successfully unsubscribed',
    'newsletter.unsubscribed.body': 'Your changes have been saved. Please allow up to 14 days for any changes to take effect. If you want to get our great offers again, you can change your preferences at anytime',

    'smartcardCTA.message.smartcard': 'The <{global.key}> <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets.',
    'smartcardCTA.message.keyGo': '{keygobrand} allows you to use your <{global.key}> much like Pay As You Go Oyster.{br} It works by charging your online account the best value ticket for the journeys you made that day.',
    'smartcardCTA.message.signup.keyGo': '<{global.keyGo}> sign up',
    'smartcardCTA.button.submit.smartcard': 'Get one now',
    'smartcardCTA.button.submit.keyGo': 'Start using it',

    // Delay Repay
    'delayrepay.error.title': 'We are very sorry.',
    'delayrepay.error.message': 'An error occurred when trying to complete your request, and this has been logged. Please try again and if you still see this message please visit our { faq }.',
    'delayrepay.error.faq': 'troubleshooting guide',
    'delayrepay.error.description.upload': 'There was a problem uploading "{ file }"',
    'delayrepay.error.description.submit': 'There was a problem submitting your claim details',
    'delayrepay.error.description.realex': 'There was a problem authorising your card',
    'delayrepay.error.description.captcha': 'There was a problem validating your captcha response',
    'delayrepay.step.delayrepay-customer': 'delayrepay.section.customerdetails',
    'delayrepay.step.delayrepay-claims': 'delayrepay.section.claims',
    'delayrepay.step.delayrepay-payment': 'delayrepay.section.payment',
    'delayrepay.step.delayrepay-confirm': 'Done',
    'delayrepay.apply.title': 'Delay Repay',
    'delayrepay.info': 'Welcome to Delay Repay, the compensation scheme for train delays. Please log in to continue.',
    'delayrepay.intro.text': 'Delay Repay is a national compensation scheme that most train operating companies use to compensate customers for delays. You can claim compensation if your journey is delayed by 15 minutes or more (except when delays are caused by planned engineering work).',
    'delayrepay.moreInfo.text': 'For more information about the delay repay scheme, please visit our {moreInfo}.',
    'delayrepay.moreInfo.link': 'guide to delay repay',
    'delayrepay.details.myAccount': 'My Account',
    'delayrepay.details.warning': 'Please go to {myAccount} to make changes to your personal details.',
    'delayrepay.action.uploadsInProgress': 'Please wait: {uploadsInProgress, plural, =1 {# upload} other {# uploads}} in progress',
    'delayrepay.action.submit': 'Submit',
    'delayrepay.action.carddetails': 'Card details',
    'delayrepay.account.login': 'Log in to Delay Repay',
    'delayrepay.button.start': 'Start application',
    'delayrepay.section.customerdetails': 'Your details',
    'delayrepay.section.claims': 'Claim details',
    'delayrepay.section.claim': 'Claim { index }',
    'delayrepay.section.payment': 'Payment method',
    'delayrepay.section.confirm': 'Confirmation',
    'delayrepay.registration.description': 'Add a password to create an account saving time the next time you claim delay repay or wish to purchase a ticket',
    'delayrepay.label.address': 'Postal address',
    'delayrepay.label.ticketType': 'Type of ticket',
    'delayrepay.label.price': 'Cost of ticket (e.g. 10.95)',
    'delayrepay.label.ticketNumber': 'Ticket number',
    'delayrepay.placeholder.ticketNumber': '5-digit number',
    'delayrepay.placeholder.issueNumber': 'Ticket number',
    'delayrepay.label.photocardNumber': 'Photocard number',
    'delayrepay.label.smartcardNumber': '<{global.smartcardUppercase}> number',
    'delayrepay.placeholder.smartcardNumber': '(e.g. 633597-0000-0000-0000)',
    'delayrepay.label.contactlessNumber': '<{global.smartcardUppercase}> number',
    'delayrepay.label.date': 'Date of journey',
    'delayrepay.label.issueDate': 'Issue date',
    'delayrepay.label.time': 'Timetabled departure time',
    'delayrepay.label.arrivalDate': 'Arrival date',
    'delayrepay.label.arrivalTime': 'Timetabled arrival time',
    'delayrepay.label.ticketOrigin': 'Origin',
    'delayrepay.label.origin': 'Departing',
    'delayrepay.label.originStation': 'From',
    'delayrepay.label.ticketOriginStation': 'Ticket origin',
    'delayrepay.label.via': 'Via',
    'delayrepay.label.viaStation': 'Changing at',
    'delayrepay.label.destination': 'Arriving',
    'delayrepay.label.destinationStation': 'To',
    'delayrepay.label.ticketDestination': 'Destination',
    'delayrepay.label.ticketDestinationStation': 'Ticket destination',
    'delayrepay.label.reason': 'Reason for claim',
    'delayrepay.label.reasonDetails': 'Please supply further information (max 250 characters)',
    'delayrepay.label.delay': 'Length of delay',
    'delayrepay.label.uploadButton': 'Choose image',
    'delayrepay.label.ticketScan': 'Upload a scanned copy/photo of your ticket',
    'delayrepay.label.statementScan': 'Upload a scanned copy/photo of your statement/receipt',
    'delayrepay.label.previousUpload': 'I have previously provided you with a copy of my monthly or longer season ticket, that is in date and valid for the journey being claimed for.',
    'delayrepay.label.reimbursementMethod': 'Reimbursement method',
    'delayrepay.ticketType.default': 'Please select type of ticket',
    'delayrepay.ticketType.group.non-season': 'Non season ticket holders',
    'delayrepay.ticketType.group.electronic': 'e-ticket',
    'delayrepay.ticketType.group.season': 'Season ticket holders',
    'delayrepay.ticketType.group.contactless': 'Oyster and contactless card holders',
    'delayrepay.ticketType.single': 'Single journey',
    'delayrepay.ticketType.return': 'Return journey',
    'delayrepay.ticketType.selfprint-single': 'e-ticket single',
    'delayrepay.ticketType.selfprint-return': 'e-ticket return',
    'delayrepay.ticketType.season-weekly': '7 Day',
    'delayrepay.ticketType.season-six-monthly': '6 Monthly',
    'delayrepay.ticketType.season-quarterly': 'Quarterly',
    'delayrepay.ticketType.season-monthly': 'Monthly',
    'delayrepay.ticketType.season-annual': 'Annual',
    'delayrepay.ticketType.season-other': 'Other',
    'delayrepay.ticketType.season-oyster': 'Oyster season',
    'delayrepay.ticketType.contactless-key': '<{global.key}> <{global.smartcardUppercase}>',
    'delayrepay.ticketType.contactless-paygo': 'Oyster Pay as You Go or Contactless',
    'delayrepay.ticketType.contactless-other': 'Other <{global.smartcard}>',
    'delayrepay.ticketType.advance': 'Advance',
    'delayrepay.ticketType.anytime-day-return': 'Anytime day return',
    'delayrepay.ticketType.anytime-day-single': 'Anytime day single',
    'delayrepay.ticketType.anytime-return': 'Anytime return',
    'delayrepay.ticketType.anytime-single': 'Anytime single',
    'delayrepay.ticketType.offpeak-day-return': 'Off-peak day return',
    'delayrepay.ticketType.offpeak-day-single': 'Off-peak day single',
    'delayrepay.ticketType.offpeak-return': 'Off-peak return',
    'delayrepay.ticketType.offpeak-single': 'Off-peak single',
    'delayrepay.ticketType.rover-ranger': 'Rail rover/ranger',
    'delayrepay.station.default': 'Please select...',
    'delayrepay.reason.default': 'Please select...',
    'delayrepay.reason.Delayed Departure': 'Delayed departure',
    'delayrepay.reason.Delayed on Route': 'Delayed en route',
    'delayrepay.reason.Train Diverted': 'Train diverted',
    'delayrepay.reason.Train Cancelled': 'Train cancelled',
    'delayrepay.reason.Train short formed': 'Train short formed',
    'delayrepay.reason.Missed Connection': 'Missed connection',
    'delayrepay.reason.Resubmitted Claim': 'Resubmitted claim',
    'delayrepay.reason.Abandoned Journey': 'Journey abandoned',
    'delayrepay.reason.Strike Action': 'Strike action',
    'delayrepay.reason.Other': 'Other – tell us more about your delay',
    'delayrepay.reasonDetails.Train Cancelled': 'If the train you intended to catch was cancelled, we will check the next available train you could have taken unless you provide further information',
    'delayrepay.reasonDetails.Resubmitted Claim': 'Please include your previous claim number for our records',
    'delayrepay.time.default': 'Please select...',
    'delayrepay.time.very-short': '15-29 minutes',
    'delayrepay.time.short': '30-59 minutes',
    'delayrepay.time.medium': '1 hour to 1 hour 59 minutes',
    'delayrepay.time.long': '2 hours or more',
    'delayrepay.charities.texts.railway-children': 'The Railway Children fights for children at risk of abuse and exploitation on the streets of Africa, India and here in the UK. Their work in this country focuses on those finding themselves in danger in and around the transport network, and makes sure they are kept safe. Using their strong links with rail industry partners and the British Transport Police they race to reach vulnerable young people before an abuser can.',
    'delayrepay.charities.texts.samaritans': 'Every six seconds somebody contacts Samaritans. The charity responds to more than 5.7 million calls for help a year. Its team of 20,000 specially trained volunteers, based in 201 branches across the UK and Ireland, are there to listen to and support anyone who’s struggling to cope.',
    'delayrepay.charities.texts.nhs': 'As the National membership organisation for NHS Charities, we represent, champion and support the work of more than 140 member charities. These fantastic NHS Charities give over £1 million everyday to the NHS enhancing patient experience and care.',
    'delayrepay.claim.add': 'Add another claim',
    'delayrepay.claim.clone': 'Copy details from claim 1',
    'delayrepay.claim.remove': 'Remove claim',
    'delayrepay.claim.maxLengthModal': 'Please only claim for the delay you experienced, as we use live train running information to automate verification of customer claims and the process may take longer if the information you provide is inaccurate. \nWe also reserve the right to take further action if knowingly inaccurate claims are submitted',
    'delayrepay.claim.maxLengthModal.title': 'Please check your delay duration is correct',
    'delayrepay.help.ticketScan.title': 'Sending us a copy of your ticket',
    'delayrepay.help.ticketScan': 'A photo or scan of your ticket is required so that we can validate your claim.\n                                    Please note that you can only upload one image per single claim, so you will need to scan the tickets onto a single page and upload as one image or add another claim by using the button.\n                                    File uploads are limited to 5MB.',
    'delayrepay.help.statementScan.title': 'Sending us a copy of your statement/receipt',
    'delayrepay.help.statementScan': 'A photo or scan of your statement/receipt is required so that we can validate your claim.',
    'delayrepay.help.statementScan.season-oyster': 'A photo or scan of your Oyster statement/receipt is required so that we can validate your claim.\n                                    For Oyster Season you must provide a receipt showing the date of purchase, the price you paid and the zones covered by your Oyster card.\n                                    File uploads are limited to 5MB.',
    'delayrepay.help.statementScan.contactless-paygo': 'A photo or scan of your Oyster statement/receipt is required so that we can validate your claim.\n                                    For Oyster pay as you go or Contactless you must provide a journey statement.\n                                    File uploads are limited to 5MB.',
    'delayrepay.help.statementScan.contactless-other': 'A photo or scan of your contactless statement/receipt is required so that we can validate your claim.\n                                    File uploads are limited to 5MB.',
    'delayrepay.help.ticketNumber.title': 'delayrepay.label.ticketNumber',
    'delayrepay.help.ticketNumber': 'Please provide your ticket number to allow us to assess your claim more quickly.\n                                    The ticket number is composed of two parts as indicated on the sample images below: - a 5 digit number (this is marked in the sample images in turquoise), and a ticket number (this is marked in dark blue).',
    'delayrepay.help.ticketNumber.imageHelp': 'Tickets can come in a number of formats. One of these sample tickets should help you locate the ticket number on your ticket. If you cannot identify your ticket number please type 00000 00000 into the ticket number box fields – but this will slow down the processing of your claim',
    'delayrepay.help.ticketNumber.imageLabel': 'Sample ticket {image} of {total}',
    'delayrepay.help.smartcardNumber.title': '<{global.smartcardUppercase}> number',
    'delayrepay.help.smartcardNumber': 'Your <{global.smartcardUppercase}> number can be found in the top left corner on the reverse of your <{global.key}> <{global.smartcardUppercase}>.',
    'delayrepay.payment.intro': 'You have a statutory right to receive your compensation in the same way as you paid for your ticket, however, you are free to choose from any of the options below. Additional information on these options is available on our {delayRepayLink}',
    'delayrepay.payment.methods': 'Please select your preferred payment method carefully. Once submitted, this cannot be changed.',
    'delayrepay.payment.linkText': 'website',
    'delayrepay.payment.showOtherOptions': 'Show other repayment types',
    'delayrepay.paymentMethod.bacs': 'Electronic bank transfer (BACS)',
    'delayrepay.paymentMethod.e-vouchers': 'eVoucher',
    'delayrepay.paymentMethod.paypal': 'PayPal',
    'delayrepay.paymentMethod.credit/debit card': 'Visa Debit/Credit',
    'delayrepay.paymentMethod.cashable voucher': 'Cashable voucher',
    'delayrepay.paymentMethod.cheque': 'Cheque',
    'delayrepay.paymentMethod.rail-charity': 'Charity',
    'delayrepay.paymentMethod.enableOption': 'to enable this option',
    'delayrepay.paymentMethod.message.longer': 'This option will take longer to process and send than other payment methods',
    'delayrepay.paymentMethodUnavailable': 'Apologies, this repayment is not available at the moment, please choose another repayment option',
    'delayrepay.paymentMethodUnavailable.credit/debit card': 'We have temporarily removed this repayment option due to an issue with the banks and we apologise for any inconvenience. This will be reinstated when the issue has been resolved.',
    'delayrepay.paymentMethodUnavailable.e-vouchers': 'Apologies, but eVoucher repayment is not available at the moment, please choose another repayment option. We are working to resolve this problem as soon as we can',
    'delayrepay.paymentMethod.amazon-incentives': 'Amazon account balance',
    'delayrepay.paymentMethod.amazon.description': 'Please login to Amazon and grant access to your amazon email address and customer id, so that we can reimburse your delay repay claim into your Amazon account balance. You have the option to associate these details with your <{app.owner.short}> account to speed up this process in future.',
    'delayrepay.paymentMethod.amazon.login': 'Login with Amazon',
    'delayrepay.paymentMethod.amazon.selectedAccount': 'Payment to Amazon account: {account}',
    'delayrepay.paymentMethod.amazon.useAnother': 'Use a different account',
    'delayrepay.paymentMethod.amazon.required': 'Please login to Amazon to continue, or choose another payment method',
    'delayrepay.paymentMethod.amazon.saveAccount': 'Remember this for future claims',
    'delayrepay.paymentMethod.amazon.savedAccount': 'This account is saved in your user preferences. If you do not wish to use this account, you can choose to remove this account from your preferences, or use another account for this claim.',
    'delayrepay.paymentMethod.amazon.forgetSavedAccount': 'Forget saved account',
    'delayrepay.paymentMethod.amazon.confirmForgetSavedAccount': 'Are you sure you want to remove this Amazon account from your preferences?',
    'delayrepay.paymentMethod.charity.selectCharity': 'Please select a charity you would like to donate your compensation to.',
    'delayrepay.paymentMethod.charity.required': 'Please select a charity or choose another payment method',
    'delayrepay.label.sortCode': 'Sort code',
    'delayrepay.placeholder.sortCode': 'e.g, 12-34-56, 10 20 30, or 112233',
    'delayrepay.label.accountNumber': 'Account number',
    'delayrepay.label.paypalEmail': 'PayPal email address',
    'delayrepay.label.agreeTerms': 'Please tick this box to confirm you are making this claim on your own behalf and that you have made or intended to make the journey you are claiming for.',
    'delayrepay.label.bankMonthly': 'Monthly',
    'delayrepay.label.bankQuarterly': 'Quarterly',
    'delayrepay.label.bankAnnually': 'Annually',
    'delayrepay.label.bankNone': 'Do not bank',
    'delayrepay.text.bankPayment': "If you'd like to bank your claim, please tell us when you would like to receive your compensation below.",
    'delayrepay.text.success': 'Your application has been submitted successfully.',
    'delayrepay.text.successConfirmation': 'You will receive an acknowledgement email within the next {timePeriod}.',
    'delayrepay.button.submitAnother': 'Submit another claim',
    'delayrepay.button.buyTickets': 'Buy tickets',
    'delayrepay.signedup': 'Account created, you are now signed in',
    'delayrepay.upload.success': 'Uploaded',
    'delayrepay.upload.cancel': 'Cancel',
    'delayrepay.upload.remove': 'Remove',
    'delayrepay.upload.retry': 'Try again',
    'delayrepay.error.uploadSize.min': 'Chosen file is too small, please choose another',
    'delayrepay.error.uploadSize.max': 'Chosen file is too large, please choose another',
    'delayrepay.error.fileType': 'Please choose a valid JPG or PNG image, or a PDF',
    'delayrepay.error.upload': 'Upload failed, please choose another image',
    'delayrepay.error.journeyTime': 'This departure time is in the future. Please select a new time or date',
    'delayrepay.error.arrivalTime': 'This is before your departure time. Please check your train times',
    'delayrepay.error.destination': 'Please choose a different station to your departure station',
    'delayrepay.error.via.sameAsOrigin': 'This is the same as your departure station. Please choose another station, or remove this if your journey did not require a change',
    'delayrepay.error.via.sameAsDestination': 'This is the same as your destination station. Please choose another station, or remove this if your journey did not require a change',
    'delayrepay.error.lengthOfDelay': 'Not valid for claims before {date}',
    'delayrepay.address.default': 'Default',
    'delay-repay.maintenance.description': 'We are sorry but the Delay Repay form is currently unavailable. We are aware and working to fix the problem as quickly as possible. Please be aware that Customer Relations will not be able to accept claims by phone and we suggest that you try again later. We are sorry for the inconvenience.',

    'auto-dr.account.help-title': 'What is Auto Delay Repay?',
    'auto-dr.account.modal-description': 'What is One Click Delay Repay?',
    'auto-dr.account.modal-subscribe': 'Subscribe to One Click Delay Repay',
    'auto-dr.subscribe.modal-title': 'Sign up to One Click Delay Repay',
    'auto-dr.subscribe.add-journey': 'Add journey',
    'auto-dr.subscribe.add-journey-max': 'You can only add a maximum of {maxJourneys} journeys',
    'auto-dr.subscribe.continue': 'Continue',
    'auto-dr.subscribe.modal-address-title': 'In case we need to contact you by post, please tell us your address.',
    'auto-dr.subscribe.modal-address-subtitle': 'Select one of the options below.',
    'auto-dr.subscribe.modal-address-item.selected': 'Selected address item',
    'auto-dr.subscribe.modal-address-item.select': 'Select this address item',
    'auto-dr.subscribe.modal-address.add-new-address': 'Add new address',
    'auto-dr.subscribe.modal-checkbox-email': 'Email',
    'auto-dr.subscribe.modal-checkbox-app': 'Southeastern app notification',
    'auto-dr.subscribe.modal-checkbox-app-and-email': 'Email and app notification',
    'auto-dr.subscribe.modal-add-another-payment-method': 'Add another repayment method',
    'auto-dr.subscribe.modal-payment': 'How would you like to receive your compensation?',
    'auto-dr.subscribe.compliance': 'Your payment details will be stored in accordance with our Privacy Policy, to allow us to pay your One Click Delay Repay compensation',
    'auto-dr.subscribe.change': 'You can change your repayment method at any time through your account',
    'auto-dr.subscribe.mobile-app-description': 'To get app One Click Delay Repay notifications you will need to download and be logged into the Southeastern App',
    'auto-dr.subscribe.modal-close': 'Close',
    'auto-dr.subscribe.back': 'Back',
    'auto-dr.subscribe.bacs-error': 'The information you have provided appears to be invalid. Please check your details and try again',
    'auto-dr.account.info': 'In many cases we can determine when you may have been delayed and create a claim for you. These are stored and shown here in the Auto Delay Repay section of your account. Claims will be visible for a period of {claimWindow} days, unless you choose to click the \u2018dismiss\u2019 button. Claims which have already been processed will be greyed out.\n        Claims are generated based on your entry and exit taps so delay length should always be correct. In the event that you disagree with the stated delay length, click the claim button where you will be able to change this. You will be prompted to provide an explanation of your delay and all such claims will be referred to an adviser for assessment which will result in your claim taking longer to process.',
    'auto-dr.account.subscription.title': 'Notification settings',
    'auto-dr.account.optout': 'You have been opted out of One Click Delay Repay',
    'auto-dr.account.subscription.info': 'Whenever we determine you have been delayed, we can send you an email alert for free.',
    'auto-dr.account.subscribed': 'We will alert you at {emailAddress} when we generate a new Auto Delay Repay claim',
    'auto-dr.account.unsubscribed': 'You are not currently subscribed to the Auto Delay Repay service',
    'auto-dr.account.subscribe.claims.history.text': 'Check your Delay Repay claim history to see if you have any One Click claims',
    'auto-dr.account.subscribe.claims.history.button': 'Claim history',
    'auto-dr.account.subscribe.claims.history.opt-out-1': 'If you no longer want to receive One Click Delay Repay claims, you can',
    'auto-dr.account.subscribe.claims.history.opt-out-2': 'opt out',
    'auto-dr.account.subscribe.claims.history.opt-out-error': 'There was an error attempting to opt out of One Click Delay Repay',
    'auto-dr.account.add.journey': 'Add regular journey',
    'auto-dr.journey.heading': "Add this journey to One Click Delay Repay",
    'auto-dr.journey.info': "To help determine which service you have been travelling on, please provide us with the Southeastern journey(s) that you frequently make.",
    'auto-dr.unsubscribed.text': 'One Click Delay Repay is a quicker and easier way to claim compensation if your journey has been delayed. It’s available to all our Key Smartcard customers and anyone who buys an eTicket or a paper Advance ticket through our website or app, when travelling on the Southeastern network.',
    'auto-dr.account.booking.unsubscribed.title': 'One Click Delay Repay',
    'auto-dr.account.booking.unsubscribed': 'Sign Up',
    'auto-dr.account.subscribe': 'Sign up',
    'auto-dr.account.unsubscribe': 'Opt out',
    'auto-dr.account.subscribe.button': 'Add journey',
    'auto-dr.account.login': 'Log in to One Click Delay Repay',
    'auto-dr.subscribe.heading': 'Sign up to One Click Delay Repay',
    'ddm.notify.text': 'Your preference will be saved for all journey alerts. This can be changed at any point through your account.',
    'auto-dr.notify.heading': 'How would you like to receive your One Click Delay Repay claims?',
    'ddm.notify.heading': 'How would you like to be notified of disruption?',
    'ddm.account.subscribe.journeys.modal.save': 'Save Alert',
    'auto-dr.account.subscribe.heading': 'Your One Click Delay Repay Journeys',
    'auto-dr.account.subscribe.address.title': 'Address',
    'auto-dr.account.address.edit.button': 'Edit address',
    'auto-dr.account.repayment.modal.title': 'Change reimbursement method',
    'auto-dr.account.notifications.modal.title': 'Change notification preferences',
    'auto-dr.account.repayment.method': 'You have chosen to receive email notifications:',
    'auto-dr.account.repayment.method.button': 'Change repayment method',
    'auto-dr.account.repayment.method.error': 'Error saving chosen reimbursement method',
    'auto-dr.account.repayment.method.name': 'You have chosen to receive One Click Delay Repay compensation by {method}',
    'auto-dr.account.repayment.method.bacs': 'BACS',
    'auto-dr.account.repayment.method.paypal': 'PayPal',
    'auto-dr.account.repayment.method.e-vouchers': 'e-Vouchers',
    'auto-dr.account.repayment.method.sort-code': 'Sort code',
    'auto-dr.account.repayment.method.account-number': 'Account number',
    'auto-dr.account.repayment.method.paypal-email-address': 'PayPal email address',
    'auto-dr.account.repayment.method.charity': 'You have chosen to donate your One Click Delay Repay compensation to the charity: {charityName}',
    'auto-dr.account.arrows': 'arrows',
    'auto-dr.account.journey.title': 'Saved journeys:',
    'auto-dr.account.journey.delete': 'Delete journey',
    'auto-dr.account.journey.edit': 'Edit journey',
    'auto-dr.account.journey.heading': 'Your regular journeys',
    'auto-dr.account.journey.action-summary-text': 'journey from ${journeyOriginName} to ${journeyDestinationName} that you regularly take on ${uniqueFormattedDays} at ${uniqueSortedServiceTimes}',
    'auto-dr.account.journey.delete-aria-text': 'Delete {a11yString}',
    'auto-dr.account.journey.edit-aria-text': 'Edit {a11yString}',
    'auto-dr.account.journey.max-favourite-journeys': 'You have reached the maximum journeys allowed. Please edit or delete your saved regular journeys to be able to add more journeys.',
    'auto-dr.account.journey.help-text': 'Entering regular journeys helps us to determine which trains you travel on.',
    'auto-dr.subscribe.info': 'Whenever we determine that you have been delayed by 15 mins or more when travelling on a Southeastern service, we can send you an alert for free. We can send this alert via email or through the Southeastern app.',
    'auto-dr.account.subscribe.info': 'To help determine which service you have been travelling on, please provide us with the Southeastern journey(s) that you frequently make. ',
    'auto-dr.account.subscribe.info.bold': 'If you do not provide your Southeastern journeys, we may be unable to create One Click Delay Repay claims when you have been delayed on our services.',
    'auto-dr.account.subscribe.journeys.modal.error': 'Please select at least one day of the week you travel on',
    'journey.modal.travel.table.from': 'From',
    'journey.modal.travel.table.departureTime': 'Departing',
    'journey.modal.travel.table.to': 'To',
    'journey.modal.travel.table.duration': 'Duration',
    'journey.modal.travel.table.changes': 'Changes',
    'journey.modal.travel.table.selected': 'Select journey',
    'journey.modal.travel.table.selected.mobile': 'Select',
    'auto-dr.account.subscribe.journeys.modal.title': 'Add your regular journey',
    'auto-dr.account.subscribe.journeys.modal.save': 'Save Journey',
    'auto-dr.account.subscribe.journeys.modal.info': 'Enter your journey information',
    'auto-dr.account.subscribe.journeys.modal.usually': 'What days do you usually make this journey?',
    'auto-dr.account.subscribe.journeys.modal.departing': 'Journeys departing around',
    'auto-dr.account.subscribe.journeys.modal.labels.weekday': 'Weekday',
    'auto-dr.account.subscribe.journeys.modal.labels.time': 'Time departing',
    'auto-dr.account.subscribe.journeys.add': 'Add a',
    'auto-dr.account.subscribe.journeys.addJourney': 'Add a {weekday} journey',
    'auto-dr.account.subscribe.journeys.departingAround': 'Search for journeys departing around',
    'auto-dr.account.subscribe.journeys': 'journey',
    'auto-dr.account.subscribe.journeys.modal.no-compatible-journeys': 'No compatible journeys found',
    'auto-dr.account.subscribe.journeys.modal.loading-journeys': 'Loading journeys',
    'auto-dr.account.subscribe.journeys.modal.travel.from-to-aria-label': '{departing} from {from} to {to}, duration {duration}, changes {changes}',
    'auto-dr.account.subscribe.journeys.modal.travel': 'Select the journeys you travel on',
    'auto-dr.account.subscribe.journeys.modal.travel.selected': '{journeysQuantity}/{maxJourneys} journeys selected',
    'auto-dr.account.subscribe.journeys.modal.travel.return.journey': 'If you wish to set up the return journey, this must be added as an individual journey.',
    'auto-dr.account.subscribe.info.limit.journeys': 'You can set up {maxSavedAddresses} journeys per day. Return journeys must be added as individual journeys. You have reached the maximum journeys allowed. Please edit or delete your saved One Click Delay Repay journeys to be able to add more journeys',
    'auto-dr.account.subscribe.info.regularJourneyAlert': 'Set up regular journey alert',
    'auto-dr.account.subscribe.info.includeStationFacilityAlerts': 'Include station facility alerts',
    '': '',
    'auto-dr.subscribe.confirm': 'Do you want to subscribe to emails notifying you of new One Click Delay Repay claims?',
    'auto-dr.subscribe.button': 'Subscribe now',
    'auto-dr.subscribe.success.heading': 'You are now subscribed',
    'auto-dr.subscribe.success.message': 'We hope you find this service useful.',
    'auto-dr.subscribe.success.changeOfMind': 'If you change your mind and wish to unsubscribe from One Click Delay Repay notification emails you can',
    'auto-dr.unsubscribe.heading': 'Unsubscribe from One Click Delay Repay',
    'auto-dr.unsubscribe.confirm': 'Do you want to unsubscribe from emails notifying you of new One Click Delay Repay claims?',
    'auto-dr.unsubscribe.button': 'Unsubscribe now',
    'auto-dr.unsubscribe.success.heading': 'You are now unsubscribed',
    'auto-dr.unsubscribe.success.message': 'We are sorry to see you go.',
    'auto-dr.unsubscribe.success.changeOfMind': 'If you change your mind and wish to sign up to One Click Delay Repay notification emails you can',
    'auto-dr.subscription.signupAccountSettings.loggedOut': 'to change your preferences in the One Click Delay Repay section in My Account',
    'auto-dr.subscription.signupAccountSettings.loggedIn': 'change your preferences in',
    'auto-dr.claims.title': 'Claim notifications',
    'auto-dr.claims.summary': 'You have {totalClaims} with a total value of {value}',
    'auto-dr.claims.zeroTotalValue.summary.1Paragraph': 'As keyGo weekly capping may be applied to your {journeyOrJourneys} this week we cannot provide a compensation value at this time. This is due to the cost of your travel becoming less expensive the more you travel within a specified time. This also means we cannot easily confirm the value of your Delay Repay claim until the monitoring period has elapsed as that amount will also change as it is linked to the cost of your travel.',
    'auto-dr.claims.zeroTotalValue.summary.2Paragraph': 'Your claim will take longer than usual to fully process because we have to wait for the monitoring period to end. You can find more information {here}.',
    'auto-dr.claims.zeroTotalValue.summary.2Paragraph.noHereLink': 'Your claim will take longer than usual to fully process because we have to wait for the monitoring period to end.',
    'auto-dr.claims.count': '{totalClaims, plural, =1{1 claim} other{# claims}}',
    'auto-dr.claims.expiry': 'Your oldest claim will expire {expiry}',
    'auto-dr.claims.no-claims': 'You have no pending Auto Delay Repay claims.',
    'auto-dr.claims.loading-error': 'There was an error loading claim notifications.',
    'auto-dr.claims.retry': 'Retry',
    'auto-dr.claims.pagination': 'Showing {count} of {totalClaims, plural, =1{1 claim} other{# claims}}',
    'auto-dr.claims.more': 'Load more',
    'auto-dr.claim.journey.title': '{journeyDate} at {journeyTime}',
    'auto-dr.claim.delay.length': '{length} mins',
    'auto-dr.claim.delay.reason': '{reason}',
    'auto-dr.claim.expires': 'Expires {date}',
    'auto-dr.claim.expired': 'Expired {date}',
    'auto-dr.claim.button.process': 'Claim',
    'auto-dr.claim.button.dismiss': 'Dismiss',
    'auto-dr.claim.notification.submitted': 'Claim submitted',
    'auto-dr.claim-form.title': 'Submit claim',
    'auto-dr.claim-form.button.submit': 'Submit claim',
    'auto-dr.claim-form.step.review': 'Review your claim',
    'auto-dr.claim-form.step.contact': 'Contact details',
    'auto-dr.claim-form.step.reimbursement': 'Reimbursement method',
    'auto-dr.claim-form.editWarning': 'Your claim is pre-approved for a delay of {length} minutes.\n                                    If you want to change the length of the delay, please give us more information about your delay, so we can assess the validity of the claim.',
    'auto-dr.claim-form.delayLength.edit': 'Change delay length',
    'auto-dr.claim-form.delayLength.choose': 'Please choose...',
    'auto-dr.claim-form.delayLength.cancel': 'Cancel editing',
    'auto-dr.claim-form.address.edit': 'Edit',
    'auto-dr.claim-form.reimbursementMethod.choose': 'Please choose...',
    'auto-dr.claim-form.reimbursementMethodUnavailable.credit/debit card': 'We have temporarily removed the Debit/Credit card repayment option due to an issue with the banks and we apologise for any inconvenience. This will be reinstated when the issue has been resolved.',
    'auto-dr.claim-form.sortCode': 'Sort code (e.g, 12-34-56, 10 20 30)',
    'auto-dr.claim-form.sortCodeAriaLabel': 'Sort code {sortCode}',
    'auto-dr.claim-form.sortCodeLabel': 'Sort code',
    'auto-dr.claim-form.sortCodePlaceholder': 'e.g. 123456',
    'auto-dr.claim-form.accountNumber': 'Account number',
    'auto-dr.claim-form.accountNumberAriaLabel': 'Account number {accountNumber}',
    'auto-dr.claim-form.accountNumberLabel': 'Account number',
    'auto-dr.claim-form.accountNumberPlaceholder': 'e.g 12345678',
    'auto-dr.claim-form.error': 'An error occurred, please try again',
    'auto-dr.dismiss.title': 'Dismiss claim',
    'auto-dr.dismiss.confirm': 'Are you sure you would like to dismiss this claim?',
    'auto-dr.dismiss.error': 'An error occurred, please try again',
    'auto-dr.claim.notification.dismissed': 'Claim dismissed',

    'one-click-delay-repay.optIn.success.header': 'You are now signed up to One Click Delay Repay',
    'one-click-delay-repay.optIn.success.copy': 'If you have a Key Smartcard ticket or travel with eTickets, please tell us your regular journeys to help us determine which trains you travel on. Just click the \u201CAdd journey\u201D button below.\nPlease remember to tap in and out where possible with your Key Smartcard or scan your eTicket barcode, as we will need to see at least one tap or scan to see you\u2019ve travelled.\nIf you have an Advance ticket, please travel on the train you\u2019ve booked for. If it\u2019s delayed by 15 minutes or more, we\u2019ll notify you of a One Click claim.',

    'one-click-delay-repay.paymentMethods.sortCode.length': 'Sort code must be 6 characters.',
    'one-click-delay-repay.paymentMethods.accountNumber.length': 'Account number must be 8 characters',

    'one-click-delay-repay.error-setting-up-regular-journey': 'Unfortunately there was an error when setting up your {alert}',

    'compensation.title': 'Additional Compensation for Thameslink and Great Northern customers',
    'compensation.section.customer': 'Start your claim',
    'compensation.section.address': 'Your address',
    'compensation.section.routes': 'Tell us about your tickets',
    'compensation.section.tickets': 'Tell us about your tickets',
    'compensation.section.amount': 'Check your claim amount',
    'compensation.section.payment': 'Confirm your payment method',
    'compensation.section.done': 'Done',
    'compensation.next': 'Continue',
    'compensation.tickets.next': 'Continue to payment',
    'compensation.help.title': 'What you\'ll need to complete your claim',
    'compensation.help.season.text': 'When making your application, you will need to provide as much information as possible about qualifying season tickets you held between 20th May and 28th July 2018. This may include:',
    'compensation.help.season.checklist': 'A scan or photograph of your season ticket(s) and photocard\n        The ticket receipt (if you no longer have your ticket)\n        Great Northern, Southern, Thameslink Key smartcard number (found on the front of your smartcard)\n        For a Smartcard issued by another operator; your Smartcard number and an upload of a receipt or booking confirmation showing details of the tickets held on your smartcard\n        Oyster season ticket: a receipt showing the date of purchase, the price you paid and the zones covered by your Oyster card, plus your travel statement. This must be scanned onto a single attachment per ticket and uploaded\n        Contactless statement showing weekly caps\n        Where you normally travel from and to\n        How you purchased your ticket and where you purchased it from',
    'compensation.help.season.footnote': '<p>We understand that you might not have all this information available but by providing as much evidence as possible, this will help us to verify your claim as quickly as possible. If you need any assistance, please contact us at 0345 026 4700.',
    'compensation.season.preamble.title': 'Am I eligible?',
    'compensation.season.preamble': 'Please go to our {link} to confirm that you are eligible',
    'compensation.season.preamble.linkText': 'eligibility checker',
    'compensation.nonSeason.login.savedSession': 'A partial claim is saved on this device. It will expire {timeToExpire}',
    'compensation.nonSeason.requiresLogin': 'Use your existing online login details which you would normally use to buy a ticket or make a delay repay claim. If you don’t have an account already, you need to register here.',
    'compensation.help.nonSeason.text': 'Please supply as much information as you can about your journeys between 20 May and 28 July 2018. This may include uploading attachments to support proof of travel, which must be <u>no more than 5mb each</u>.\n        You can also give us further details to support your claim, by selecting \u2018Other evidence\u2019 which gives you the option to provide us with further written information.\n        You may need to provide proof of travel for each journey so we suggest you have this information to hand before beginning your claim. You will have the option to save a partially completed claim and log back in within 1 week to finish it but this must be on the same device you began the claim on.\n        The information you may need to provide includes:',
    'compensation.help.nonSeason.checklist': 'Where you travel from and to\n        A scan or photograph of your ticket(s)\n        The ticket receipt (if you no longer have your ticket)\n        Oystercard number and journey statements (optional)\n        Contactless journey statement\n        Redacted bank statement showing relevant purchases\n        Details about where you bought your ticket from',
    'compensation.help.nonSeason.footnote': '<p>We understand that you might not have all this information available but by providing as much evidence as possible, this will help us to assess your claim as quickly as possible. If you are concerned that you do not have the required evidence to support your travel over the qualifying period please visit our {faqLink}. If you believe you’re eligible but don’t have all the evidence, we encourage you to still make a claim. If you need any assistance, please contact us at {phoneNumber}.</p>',
    'compensation.nonSeason.preamble.title': 'Am I eligible?',
    'compensation.nonSeason.preamble': 'Please go to our {link} to confirm that you are eligible',
    'compensation.nonSeason.preamble.linkText': 'eligibility checker',
    'compensation.no-code.whitelist.text': 'If you don\'t have an email or letter containing a code, but you believe you are entitled to compensation you can apply online',
    'compensation.no-code.whitelist.linkText': 'when the scheme opens fully',
    'compensation.no-code.season.text': 'If you don\'t have an email or letter containing a code, but you believe you are entitled to compensation',
    'compensation.no-code.season.linkText': 'you can still apply online',
    'compensation.help.whitelist.checklist': 'Email or letter stating compensation\n        Your unique code reference\n        Your photocard',
    'compensation.whitelist.preamble': 'If you have been directed to this page, it is because we have been able to confirm that you are eligible for compensation under this scheme.',
    'compensation.whitelist.no-code': 'I don\'t have a unique code',
    'compensation.whitelist.text': 'Please fill in the following details, so that we can find your pre-approved claim.',
    'compensation.whitelist.photocardNumber': 'Photocard number is required if you received your passcode in a letter',
    'compensation.customer.text': 'In order to process your claim efficiently, please supply as much information as you possibly can. This will speed up the time taken to process your claim.',
    'compensation.amount.calculation': 'We have automatically calculated your compensation amount at:',
    'compensation.amount.evidence': 'This is based upon the eligibility of your season ticket(s) during the scheme period. See {link} for more information',
    'compensation.amount.evidence.linkText': 'our FAQ',
    'compensation.payment.text': 'Please choose your preferred repayment method',
    'compensation.done.title': 'Thank you',
    'compensation.done.whitelist': 'There’s nothing else you need to do, we’re just making some final checks and then we will be able to confirm your compensation payment which we’ll do by email in the next 24 hours.',
    'compensation.done.season': 'What\'s next...\n        We will review your claim within 20 working days. You will receive an additional email once your claim has been assessed to advise you of the outcome.',
    'compensation.done.nonSeason': 'compensation.done.season',
    'compensation.done.text': 'If you require any further assistance, please contact a member of our team on {customerServicesPhoneNumber}.\n        For more information about the Additional Industry Compensation Scheme, please visit {compensationLink}',
    'compensation.done.linkText': 'our dedicated website',
    'compensation.route.instructions': 'Please enter the origin and destination stations displayed on your ticket. If your ticket is a travelcard, please choose the stations you usually travel between.',
    'compensation.route.validate': 'Validate route',
    'compensation.route.validate.reminder': 'Please validate that this route is eligible for compensation',
    'compensation.route.delete.confirm': 'Are you sure you wish to delete this route?',
    'compensation.routeCode.default': 'Please select the route',
    'compensation.routeCode.label': 'Route code',
    'compensation.eligiblity.none': 'Unfortunately this route does not qualify for additional compensation',
    'compensation.eligiblity.QUALIFIES_WEEKLY_CAP': 'This route is eligible for compensation of 1 week',
    'compensation.eligiblity.QUALIFIES_MONTHLY_CAP': 'This route is eligible for compensation of up to 4 weeks',
    'compensation.route.add': 'Add another route',
    'compensation.route.addTicket': 'Add a ticket to this route',
    'compensation.placeholder.compensationCode': 'Your unique code',
    'compensation.placeholder.ticketNumber': '5-digit Ticket number',
    'compensation.placeholder.ticketNumber.caption': 'If available please provide the number of one of your Carnet tickets.',
    'compensation.help.ticketNumber.imageHelp': 'Tickets can come in a number of formats. One of these sample tickets should help you locate the ticket number on your ticket.',
    'compensation.help.ticketNumber': 'Please provide your ticket number to allow us to assess your claim more quickly.',
    'compensation.placeholder.photocardNumber': 'Photocard number',
    'compensation.placeholder.smartcardNumber': '<{global.theKey}> <{global.smartcard}> number',
    'compensation.placeholder.contactlessNumber': 'Smartcard number',
    'compensation.placeholder.oysterNumber': 'Oyster card number',
    'compensation.label.oysterNumber': 'Oyster card number',
    'compensation.help.ticketNumber.title': 'compensation.placeholder.ticketNumber',
    'compensation.label.purchaseLocation': 'Place of purchase',
    'compensation.label.purchaseLocationStationStation': 'Station',
    'compensation.label.originStation': 'Leaving from',
    'compensation.label.destinationStation': 'Going to',
    'compensation.label.travelcardStation': 'Travelcard zones',
    'compensation.travelcardStation.default': 'Please choose zones...',
    'compensation.label.weeklyCap': 'Weekly cap',
    'compensation.weeklyCap.default': 'Please choose zones...',
    'compensation.placeholder.purchaseLocationOther': 'Please specify',
    'compensation.purchaseLocation.default': 'Place of purchase',
    'compensation.purchaseLocation.ticket-office': 'Station',
    'compensation.purchaseLocation.online': '<{app.owner}> website',
    'compensation.purchaseLocation.other': 'Somewhere else',
    'compensation.placeholder.date.validFrom': 'Start date',
    'compensation.placeholder.date.validUntil': 'Valid until',
    'compensation.label.ticket': 'Ticket #{number}',
    'compensation.label.price': 'Ticket cost (e.g. 10.95)',
    'compensation.ticket.add': 'Add ticket to this route',
    'compensation.label.ticketType': 'Type of ticket',
    'compensation.ticketType.default': 'Please select type of ticket',
    'compensation.ticketType.season-standard-class': 'Standard class paper ticket',
    'compensation.ticketType.season-first-class': 'First class paper ticket',
    'compensation.ticketType.season-oyster': 'Oyster season',
    'compensation.ticketType.season-oyster.callToAction': 'By providing your Oystercard number you consent to GTR checking TfL data to validate the journeys made and cost of travel.',
    'compensation.ticketType.contactless-key': '<{global.key}> <{global.smartcardUppercase}> (Thameslink, Great Northern & Southern only)',
    'compensation.ticketType.contactless-paygo': 'Weekly Capped Contactless',
    'compensation.ticketType.contactless-other': 'Other smartcard',
    'compensation.label.duration': 'Season duration',
    'compensation.duration.default': 'Please select duration',
    'compensation.duration.weekly': 'Weekly',
    'compensation.duration.monthly': 'Monthly',
    'compensation.duration.annual': 'Annual',
    'compensation.duration.custom': 'Other',
    'compensation.label.months': 'Months',
    'compensation.label.days': 'Days',
    'compensation.upload.hint.season-oyster': 'Oyster season ticket holders – you will need to provide a receipt showing the date of purchase, the price you paid and the zones covered by your Oyster card, plus your travel statement. This must be scanned onto a single attachment per ticket and uploaded',
    'compensation.label.ticketUpload': 'Upload a scanned copy/photo of your ticket',
    'compensation.label.statementUpload': 'Upload a scanned copy/photo of your statement/receipt',
    'compensation.label.skipFileUpload': 'I cannot upload a scan because I no longer have this ticket',
    'compensation.label.agreeTerms': 'We reserve the right to check the validity of all claims we receive and we treat seriously any applications we believe may be fraudulent. We may take further action if appropriate. This could include, making further checks, refusing a claim or seeking recovery of any sums paid in error.',
    'compensation.alert.customerValidation': 'Our records show that you have been pre-approved for additional compensation - you will have been notified by email or letter. If you\'ve not received either of these please call us on 0345 026 4700',
    'compensation.alert.whitelistValidation': 'We cannot find your pre-approved claim using the details you have entered, or you may have submitted a claim previously, with the same credentials. Please check to ensure you have entered your passcode correctly and you are using the same email address that your claim details were sent to.',
    'compensation.alert.paymentMethod': 'Please choose a method of reimbursement',
    'compensation.alert.customDuration': 'Please specify duration length (min. 1 month)',
    'compensation.alert.eligibleDuration': 'This ticket is not eligible for compensation as the ticket was not valid during the compensation period',
    'compensation.alert.needsMoreEvidence': 'In order for us to process your application we have to have at least {expectedDays} days of ticket history for you, currently you have only told us about {actualDays} days worth. Please add more tickets',
    'compensation.ticket.delete.confirm': 'Are you sure you wish to delete this ticket?',
    'compensation.ticket.uploading': 'Uploading...',
    'compensation.ticket.uploadFailed': 'Upload failed',
    'compensation.alert.isUploading': 'Image {count, plural, =1{upload} other{uploads}} in progress. Please wait for {count, plural, =1{upload} other{uploads}} to complete before continuing',
    'compensation.alert.illegalTicket': 'You have entered a photocard number ({photocardNumber}) which has been used in a previous claim. Please correct before proceeding',
    'compensation.alert.hasFailedUploads': '{count, plural, =1{# image upload} other{# image uploads}}. Please check and try again',
    'compensation.whitelist.message.schemeClosed': '\n            <p>This scheme has now closed for applications.\n            If you have a claim in progress, this will be completed within the timescales advised.\n            If you require an update, please contact the team on 0345&nbsp;026&nbsp;4700&nbsp;(option&nbsp;1)</p>\n            <p>For further details about the scheme, please visit <a href="{schemeUrl}">{schemeUrl}</a></p>',
    'compensation.season.message.schemeClosed': 'compensation.whitelist.message.schemeClosed',
    'compensation.nonSeason.message.schemeClosed': 'compensation.whitelist.message.schemeClosed',
    'compensation.evidenceType.label': 'Evidence type',
    'compensation.evidenceType.default': 'Choose evidence type',
    'compensation.evidenceType.ticket-mixture': 'Ticket combination (of Carnet and a different ticket type)',
    'compensation.evidenceType.ticket-image': 'Original ticket',
    'compensation.evidenceType.receipt': 'Ticket receipt',
    'compensation.evidenceType.bank-statement': 'Redacted bank statement',
    'compensation.evidenceType.bank-statement.description': 'Please remove any sensitive information by striking it out in marker pen. We just need to be able to see your name and the relevant purchases made for tickets to assess your claim.',
    'compensation.evidenceType.journey-history': 'Oyster/CPAY journey statement',
    'compensation.evidenceType.freedom-pass-image': 'Freedom pass picture/Scan',
    'compensation.evidenceType.further-information': 'Other evidence',
    'compensation.evidenceType.further-information.description': 'Please upload the evidence you have available to support your claim and provide a short explanation in the freetext box of what you are providing and why.',
    'compensation.evidenceType.no-evidence': 'No evidence',
    'compensation.evidenceType.no-evidence.description': 'If you are unable to provide sufficient evidence of your travel during the qualifying period, please provide us with as much information as you can including evidence of more recent regular journeys that correspond to the journeys you are claiming for.',
    'compensation.nonSeason.travelWeek.heading': 'Week #{index}',
    'compensation.nonSeason.travelWeek.choose': 'Travel week',
    'compensation.nonSeason.travelWeek.range': '{from} - {to}',
    'compensation.nonSeason.travelWeek.chooseButton': 'Choose',
    'compensation.nonSeason.travelWeek.incomplete': 'This week is incomplete. Please click to expand this week and make the necessary amendments',
    'compensation.nonSeason.travelWeek.instructions': 'You must evidence a minimum of 3 return journeys in any one week (Monday-Sunday) during the qualifying period. If you use a Carnet ticket please select the date of purchases/first day of use.',
    'compensation.nonSeason.travelWeek.add': 'Add another week',
    'compensation.nonSeason.travelWeek.delete': 'Delete this week and all tickets',
    'compensation.nonSeason.travelWeek.confirmDelete': '\n            Are you sure you wish to delete this week?\n            {numDays, plural,\n                =0 {}\n                =1 {It has tickets assigned to 1 day.}\n                other {It has tickets assigned to # days.}\n            }',
    'compensation.nonSeason.travelWeek.full.header': 'This week is full',
    'compensation.nonSeason.travelWeek.journeys.required': 'You need {days, plural, =1 {1 more day} other {# more days}} worth of journey details.',
    'compensation.nonSeason.travelWeek.full': 'You can not add any more tickets this week.',
    'compensation.nonSeason.dayPicker.choose': 'Choose a date',
    'compensation.nonSeason.dayPicker.manage': 'Add / edit ticket',
    'compensation.nonSeason.dayPicker.label': '{hasTickets, select, true {View/edit tickets on} other {Add tickets to}} {date}',
    'compensation.nonSeason.ticketModal.header': 'Ticket details',
    'compensation.nonSeason.ticketModal.confirmDelete': 'Are you sure you want to remove these tickets?',
    'compensation.nonSeason.ticketType.single': 'Paper ticket (single)',
    'compensation.nonSeason.ticketType.return': 'Paper ticket (return)',
    'compensation.nonSeason.ticketType.carnet': 'Carnet - Book of 5',
    'compensation.nonSeason.ticketType.freedom-pass': 'Freedom Pass',
    'compensation.nonSeason.ticketType.contactless-key': '<{global.key}> <{global.smartcardUppercase}>/<{global.keyGo}> (Thameslink, Great Northern & Southern only)',
    'compensation.nonSeason.ticketType.contactless-paygo': 'TfL Oyster pay as you go',
    'compensation.nonSeason.ticketType.contactless-other': 'Contactless payment card',
    'compensation.nonSeason.ticketType.single.short': 'Single',
    'compensation.nonSeason.ticketType.return.short': 'Return',
    'compensation.nonSeason.ticketType.contactless-key.short': '<{global.key}> <{global.smartcardUppercase}>/<{global.keyGo}>',
    'compensation.nonSeason.ticketType.contactless-paygo.short': 'Oyster',
    'compensation.nonSeason.ticketType.contactless-other.short': 'Contactless',
    'compensation.nonSeason.ticketType.contactless-paygo.callToAction': 'compensation.ticketType.season-oyster.callToAction',
    'compensation.nonSeason.outward.title': 'Ticket details for {date}',
    'compensation.nonSeason.return.title': 'Return journey',
    'compensation.nonSeason.return.optional': 'Please provide details about your return journey if it was not using {ticketType}.',
    'compensation.nonSeason.return.add': 'Add return ticket',
    'compensation.nonSeason.ticket.delete': 'Delete tickets',
    'compensation.routeSelector.label': 'Route',
    'compensation.routeSelector.default': 'Please select a route',
    'compensation.routeSelector.other': 'Other',
    'compensation.routeSelector.route': '{origin} to {destination}',
    'compensation.routeSelector.swapStations': 'Swap stations',
    'compensation.nonSeason.ticketEvidence.uploadButton': 'Upload evidence',
    'compensation.nonSeason.ticketEvidence.notRequired': 'No evidence is required for this ticket type',
    'compensation.nonSeason.ticketEvidence.skipUpload': 'I have already uploaded this for another day this week',
    'compensation.nonSeason.ticketEvidence.comments': 'Please supply further information (max 500 characters)',
    'compensation.nonSeason.ticketEvidence.comments.placeholder': 'Briefly explain what information you are supplying to help us assess your claim: Max 500 characters',
    'compensation.ticket.warning.route.nonCircular': 'The return portion single ticket should be the reverse of your outward journey. You will need to provide us with an explanation of your journey pattern using the \'Other evidence\' option to help us assess your claim',
    'compensation.ticket.error.exceedLevel2': 'Level 2 stations are only eligible for 1 week of compensation. As you have claimed for a level 2 station in a previous week, this is the maximum allowed',
    'compensation.ticket.error.returnMismatch.route': 'The return carnet ticket should be the reverse of your outward journey',
    'compensation.ticket.error.returnMismatch.eligibility': 'This journey has a different compensation level to your outward journey. To qualify, both journeys must be the same compensation level',
    'compensation.ticket.error.ticketType.carnet': 'A carnet must be the only ticket in a week. Please remove other tickets before adding this ticket',
    'compensation.ticket.error.ticketType': 'This ticket type must be the only ticket in a week. Please remove other tickets before adding this ticket',
    'compensation.ticket.error.maxBookSize': 'You have already added the maximum number of carnet tickets',
    'compensation.resumeSession.title': 'Resume session?',
    'compensation.resumeSession.description': 'We have an incomplete claim which was started by another user on this device. If you would like to continue that application, please log out and log back in with the correct user account. Or you can start a fresh application - this will clear the saved application',
    'compensation.resumeSession.abort': 'Start fresh application',
    'compensation.resumeSession.resume': 'Log out',
    'compensation.resumeSession.modal.title': 'Claim saved for later',
    'compensation.resumeSession.modal.heading': 'You have logged out',
    'compensation.resumeSession.modal.message': 'Your claim will be saved for 1 week. You must log back in on the same device to complete your application',

    'ontrackapp.widget.title': 'Meet the On Track App',
    'ontrackapp.widget.desc': 'Download the fastest, easiest and smartest train assistant.',
    'ontrackapp.widget.appstoreButtonAltText': 'App Store logo',
    'ontrackapp.widget.googlePlayButtonAltText': 'Google Play Store logo',
    'ontrackapp.widget.smartphoneImgAltText': '{brand} mobile app screenshot',

    'tutorial.dismiss-checkbox-label': "Don't show me again",

    'jp-list-tutorial.trigger': 'Open List view tutorial',
    'jp-list-tutorial.intro.title': 'Quick Tutorial',
    'jp-list-tutorial.intro.text': "Welcome to our website tutorial, it aims to help you find the best deal using our new and improved features. Please click '<{button.text.next-tip}>' to continue, or '<{button.text.close}>' to skip this tutorial.",
    'jp-list-tutorial.tabs.title': 'Two New Views',
    'jp-list-tutorial.tabs.text': 'We have two new views that you can use to buy tickets on, a List View and a Grid View. Check them out like this. We will remember the last view you used and show you that view again next time!',
    'jp-list-tutorial.list-view.title': 'The List View',
    'jp-list-tutorial.list-view.text': 'This is the List View, where you have each step of the service and ticket selection process presented to you, a screen at a time.',
    'jp-list-tutorial.toc-filter.title': 'Cheapest Fares',
    'jp-list-tutorial.toc-filter.text': 'Clicking this button enhances your journey search, to display the best priced fares on London Midland trains only. De-select the button to view all operator fares available for that journey.',
    'jp-list-tutorial.select-service.title': 'Selecting a Service',
    'jp-list-tutorial.select-service.text': 'You start by selecting the service you want to travel on. You can use the “Show earlier” and “Show later” links to see more services.',
    'jp-list-tutorial.service-info.title': 'Service Details',
    'jp-list-tutorial.service-info.text': 'Here, you can see detailed information about each service, like calling points, interchanges, facilities available on the train, and a mapped out route of the journey.',
    'jp-list-tutorial.select-fare.title': 'Selecting a Ticket',
    'jp-list-tutorial.select-fare.text': 'You can then select that ticket that you want. You can filter them by 1ST and Standard Class. We always show the cheapest ticket first.',
    'jp-list-tutorial.ticket-details.title': 'Ticket Details',
    'jp-list-tutorial.ticket-details.text': 'You can click on “Show ticket details" to see more information about your ticket, such as the ticket type, when you can use your ticket, which routes you can use it on and the restrictions of your ticket.',
    'jp-list-tutorial.return-service.title': 'Return Services',
    'jp-list-tutorial.return-service.text': 'On this screen you can see the return services that your chosen ticket is valid on. Again, you can use the “Show earlier” and “Show later” to see more services. You can also add Plus Bus and choose reservations, if required.',
    'jp-list-tutorial.preferences.title': 'Reservations and PlusBus',
    'jp-list-tutorial.preferences.text': 'You can choose your reservation preferences here, or buy PlusBus, if they are applicable to your journey.',

    'jp-grid-tutorial.trigger': 'Open Grid view tutorial',
    'jp-grid-tutorial.intro.title': 'jp-list-tutorial.intro.title',
    'jp-grid-tutorial.intro.text': 'jp-list-tutorial.intro.text',
    'jp-grid-tutorial.tabs.title': 'jp-list-tutorial.tabs.title',
    'jp-grid-tutorial.tabs.text': 'jp-list-tutorial.tabs.text',
    'jp-grid-tutorial.grid-view.title': 'The Grid View',
    'jp-grid-tutorial.grid-view.text': 'This is the Grid View, where you can see outward and return journeys side-by-side.',
    'jp-grid-tutorial.toc-filter.title': 'jp-list-tutorial.toc-filter.title',
    'jp-grid-tutorial.toc-filter.text': 'jp-list-tutorial.toc-filter.text',
    'jp-grid-tutorial.service-carousel.title': 'The Services Carousel',
    'jp-grid-tutorial.service-carousel.text': 'This is the services carousel, where you can search for earlier or later trains and see the running time, duration and changes for the services shown. You can also click anywhere on the carousel to see more detailed service information.',
    'jp-grid-tutorial.service-info.title': 'jp-list-tutorial.service-info.title',
    'jp-grid-tutorial.service-info.text': 'jp-list-tutorial.service-info.text',
    'jp-grid-tutorial.ticket-categories.title': 'Ticket Categories',
    'jp-grid-tutorial.ticket-categories.text': 'This is where you choose your tickets, we organise them into the following categories, Singles, Off-Peak and Anytime. We highlight and pre-select the cheapest fares for you. If you can’t see the ticket that you are looking for, press “View All Available Fares” to see a full list of tickets.',
    'jp-grid-tutorial.ticket-details.title': 'jp-list-tutorial.ticket-details.title',
    'jp-grid-tutorial.ticket-details.text': 'jp-list-tutorial.ticket-details.text',
    'jp-grid-tutorial.preferences.title': 'jp-list-tutorial.preferences.title',
    'jp-grid-tutorial.preferences.text': 'jp-list-tutorial.preferences.text',

    'seasons-tutorial.trigger': 'Open Season ticket view tutorial',
    'seasons-tutorial.intro.title': 'jp-list-tutorial.intro.title',
    'seasons-tutorial.intro.text': 'jp-list-tutorial.intro.text',
    'seasons-tutorial.filters.title': 'Filters',
    'seasons-tutorial.filters.text': 'You can filter the season ticket results by route, duration and class.',
    'seasons-tutorial.comparison.title': 'Comparison Pricing',
    'seasons-tutorial.comparison.text': 'Where possible we show you the saving against purchasing a season ticket of a shorter duration.',

    'sync-1617-keygo.tutorial.intro.title': 'Sync 1617 title',
    'sync-1617-keygo.tutorial.intro.text': 'TODO: Display a custom modal message asking the customer to go to Photocards/Railcards if they wish to add their 16-17 Saver railcard to their keyGo account',

    'confirmation-modal.delete-item': 'Please confirm you wish to delete this item!',

    'stationSelector.results.aria': 'List of station results.',

    'station-finder-tutorial.trigger': 'Open Station finder tutorial',
    'station-finder.intro.title': 'Find a station',
    'station-finder.intro.text': 'Not sure where you are going to? Use the station finder to search for the nearest stations to your destination. If you have location sharing enabled on your device, you can search for the stations that are closest to you!',
    'station-finder.origin-destination.title': 'Adding station to the journey planner',
    'station-finder.origin-destination.text': 'When you click on a station icon, you can choose to use it as an origin or a destination. You can also see information about the facilities available at that station',

    'stationFinder.expand.buttonLabel': 'Find stations',
    'stationFinder.shrink.buttonLabel': 'Close station finder',
    'stationFinder.search.placeholder': 'Find stations near street/town/postcode',
    'stationFinder.search.buttonText': 'Go',
    'stationFinder.search.useCurrentPosition': 'Use my current location',
    'stationFinder.geolocation.error.permissionDenied': 'Please enable location sharing on your device. Alternatively, type in a street/city/postcode and we will show you nearby stations.',
    'stationFinder.geolocation.error': 'Unable to determine your location. Please try later, or type a street/town/postcode into the search box',
    'stationFinder.label.error': 'Sorry, we could not find ',
    'stationFinder.noLabel.error': 'Please enter a street/town/postcode into the search box',
    'stationFinder.search.error': 'No stations found. Please try a different location',
    'stationFinder.modal.mainText': 'Would you like to add this station to your journey planner?',
    'stationFinder.modal.origin': 'Make this my<br /><strong>Origin</strong> station',
    'stationFinder.modal.noOrigin': '<strong>Origin</strong> is not available for this search type',
    'stationFinder.modal.destination': 'Make this my<br /><strong>Destination</strong> station',
    'stationFinder.modal.noDestination': '<strong>Destination</strong> is not available for this search type',
    'stationFinder.modal.link': 'Find a station',
    'stationFinder.modal.title': 'Search for a station',
    'stationFinder.modal.update': 'station updated to',
    'stationFinder.modal.facilities': 'Facilities',
    'stationFinder.modal.openingHours': 'Ticket office hours',
    'stationFinder.modal.openingHoursChecking': 'Checking for ticket office opening hours...',
    'stationFinder.modal.openingHoursNotAvailable': 'Sorry, opening hours are not available for this station',
    'stationFinder.nextDay.modal.heading': 'No available journeys for the selected date',
    'stationFinder.nextDay.modal.message': 'There are no outbound journeys available on the day you selected. We have returned the nearest available journey.',
    'stationFinder.modal.openingHours.unknown': 'n/a',
    'stationFinder.station': 'Station',
    'stationFinder.status.open': 'The ticket office at this station is: Open',
    'stationFinder.status.closed': 'The ticket office at this station is: Closed',
    'stationFinder.status.opening-soon': 'The ticket office at this station is: Opening Soon',
    'stationFinder.status.no-office': 'This station does not have a ticket office',
    'stationFinder.status.not-available': 'Opening status is not available for the ticket office at this station',

    'etickets.results.none-available': 'You have no upcoming trips with eTickets',
    'etickets.results.none-available.filtered': "You don't have any eTickets with this Order ID",
    'etickets.table.start-date': 'Start Date',
    'etickets.table.route': 'Route',
    'eticket.table.help.sr-only': 'What is an eTicket? Click to open modal.',
    'eticket.table.pdf': 'PDF',
    'eticket.table.order': 'Order',
    'eticket.table.download-eticket.sr-only': 'Click to download your eTicket.',
    'eticket.table.download-pdf.sr-only': 'Click to download your PDF ticket.',
    'eticket.table.view-order': 'View order',
    'etickets.filter.placeholder': 'Filter by order ref',
    'etickets.filter.error': 'Order IDs should be numbers',
    'etickets.filter.warning': 'This is a filtered set of your eTickets. You may have other valid eTickets available for download.',
    'etickets.filter.see-all': 'Click here to see all of your eTickets',
    'etickets.modal.apple.sr-only': 'eTickets are compatible with Apple mobile devices',
    'etickets.modal.android.sr-only': 'eTickets are compatible with Android mobile devices',
    'etickets.modal.content': 'This is an eTicket which provides you with an alternative way of downloading the eTicket directly to your devices. By simply clicking on the icon, the eTicket will be automatically added to your native iOS or Android wallet.',

    'widgets.journeyPlanner.tabs.search': 'nav.pointTickets',
    'widgets.journeyPlanner.tabs.season': 'nav.seasonTickets',
    'widgets.journeyPlanner.button.search': 'Find trains',
    'widgets.journeyPlanner.button.season': 'Show tickets',
    'widgets.poweredBy': 'Search results powered by <a href="{href}" target="_blank"><{app.owner.short}></a>',

    'openGolf.header.help': 'About these train tickets',
    'openGolf.header.title': 'Choose your tickets for The Open',
    'openGolf.help': 'TODO openGolf.help',
    'openGolf.search.backToSearch': 'Try a different search',
    'openGolf.search.button': 'Search tickets',
    'openGolf.search.noResults.heading': 'Sorry, there were no Open tickets found that match your search.',
    'openGolf.search.noResults.text': 'Please try a different date or origin station.',
    'openGolf.selector.subtitle': 'Choose day of validity',
    'openGolf.ticket.add': 'Add to basket',
    'openGolf.ticket.remove': 'Remove',
    'openGolf.tickets.day1': '1 Day ticket',
    'openGolf.tickets.day2': '2 Day ticket',
    'openGolf.tickets.day3': '3 Day ticket',
    'openGolf.tickets.day4': '4 Day ticket',
    'openGolf.tickets.day8': '8 Day ticket',

    'findTicketsSearch.title': 'Buy your tickets to<br/>Sandwich for The Open',
    'findTicketsSearch.subtitle': 'Where will you be travelling from?',
    'findTicketsSearch.submit': 'Find tickets',

    'timetableWidget.checkTimes': 'Check times',
    'timetableWidget.date.label': 'What day are you travelling on?',
    'timetableWidget.results.view.earlier': 'View earlier trains',
    'timetableWidget.results.view.later': 'View later trains',
    'timetableWidget.results.departure': 'Departure',
    'timetableWidget.results.arrival': 'Arrival',
    'timetableWidget.results.duration': 'Duration',
    'timetableWidget.results.destination': 'Destination',
    'timetableWidget.search.errors.default': 'There was an error while performing a search. Please try again later.',
    'timetableWidget.search.errors.datetimeInPast': 'A date/time entered is in the past. Please change.',
    'timetableWidget.time.label': 'Leaving at...',

    'timetableWidget.app-links-description': 'To get app notifications you will need to download and be logged into the Southeastern App',

    'timetableWidget.info': 'We will let you know if there is a change to your booked journey because of a timetable change. Timetable changes can be caused by engineering work and major disruption, and could result in your train being cancelled or retimed.\nDisruption alerts are sent up to the day before travel.',

    'preference-centre.title': 'Preference Centre',
    'preference-centre.intro': 'From time to time we share information about changes to your services, ticket expiries and renewals, and special offers. You can update your subscription preferences by ticking the following options and clicking submit. Please read our {privacyPolicy} for more information.',
    'preference-centre.service-updates': 'Travel and service updates',
    'preference-centre.promotions': 'Days out inspiration and exclusive promotions',
    'preference-centre.products': 'New products and services',
    'preference-centre.all': 'Select all',
    'preference-centre.service-updates.help': 'Get contacted about service announcements and important travel information, such as planned engineering work reminders, Key smartcard updates and season ticket renewals.',
    'preference-centre.promotions.help': 'Get inspiring days out ideas and receive the latest fare promotions, competitions and other exclusive deals from us and our partners. We will not share your details with any of our partners.',
    'preference-centre.products.help': 'Find out about the latest products and services we are developing to make your journeys easier and more comfortable.',
    'preference-centre.edit-notice.short': 'Once registered, you can change your preferences at any point by going into \'My Account\' and updating what you would like to receive.',
    'preference-centre.edit-notice': "Once registered, you can change your preferences at any point by going into 'My Account' and updating what you would like to receive. Please read our {privacyPolicy} for more information.",
    'preference-centre.terms-and-conditions.warning': 'By ticking this box I confirm that I have read and accepted the {termsAndConditions}',
    'preference-centre.privacy-notice': '<p >Please note, you are registering with Govia Thameslink Railway through <{app.owner.short}>. <{app.owner.short}> is a trading name of Govia Thameslink Railway Limited which includes the following brands: Gatwick Express, Great Northern, Southern and Thameslink.</p>',
    'preference-centre.privacy-notice.more': '<p>We will not pass on your personal information to any organisation outside of Govia Thameslink Railway Limited. Should we no longer operate the <{app.owner.short}> franchise, please be aware that we will pass your details to the Successor franchise or Secretary of State for Transport to allow you to continue using your customer account and receive marketing emails if you have consented to them.</p>',
    'preference-centre.privacy-notice.extra': '<p>We will not pass on your personal information to any organisation outside of <{app.owner.short}>. Should we no longer operate the <{app.owner.short}> franchise, please be aware that we will pass your details to the Successor franchise or Secretary of State for Transport to allow you to continue using your customer account and receive marketing emails if you have consented to them.</p>',
    'preference-centre.age-restriction': 'I am 16 or over',
    'preference-centre.age-restriction.warning': 'If you are under 16 we can only send you Travel updates.',
    'preference-centre.age-restriction.modal-text': 'To comply with data protection laws and to additionally protect minors we by default choose not to send under 16’s any marketing or promotional material.',
    'preference-centre.age-restriction.update': 'If you are over 16 please update your date of birth in the form above.',
    'preference-centre.option.sr-only': 'Please check this box if you wish to receive {option} via {method}',
    'preference-centre.update-success.notification': 'Your changes have been saved. Please allow up to 14 days for any changes to take effect.',
    'preference-centre.age-verification': 'Age Verification:',
    'preference-centre.select-communication-preferences': 'Choose what commmunications you would like to receive.',
    'preference-centre.tutorial.title': 'account.nav.preferences',
    'preference-centre.tutorial.text': 'Welcome to our preferences centre tutorial, it aims to inform you of why you need to update your preferences and how to do so.',
    'preference-centre.form.action': 'Confirm',
    'preference-centre.preference.title': 'One Click Delay Repay preferences:',
    'preference-centre.ddm-preference.title': 'Regular journey alert preferences:',
    'preference-centre.ddm-and-timetable-alerts-preference.title': 'Regular journey alert and timetable change preferences',
    'preference-centre-unsubscribe.button': 'Sign up ',
    'preference-centre.subscribe.preference.text': 'You have chosen to receive {notifyByPreferenceText} notifications',
    'preference-centre.subscribe.preference.to': ' to {userEmail}',
    'preference-centre.subscribe.preference.noPrefSet': 'You do not have any notification preference set.',
    'preference-centre.subscribe.preference.updating': 'Updating notification preferences',
    'preference-centre.subscribe.preference.edit.button': 'Edit One Click Delay Repay preferences',
    'notification-settings.edit.button': 'Edit journey alert and timetable change preferences',
    'notification-settings.title': 'Notification Settings',
    'preference-centre.unsubscribe.preference.subtitle': 'You are not currently signed up to One Click Delay Repay',
    'preference-centre.unsubscribe.preference.text': 'If you\u2019re delayed by 15 minutes or more on the Southeastern network, you can claim Delay Repay in just One Click.\nWe will automatically create a Delay Repay claim for you. We can send you the claim by email or through the Southeastern app, or you can log into your account to check. To receive your compensation, all you have to do is confirm the journey details and we\u2019ll take care of the rest.\nOne Click is available to all our Key smartcard customers and anyone who buys an sTicket, eTicket or paper Advance ticket through our website or app.',
    'preference-centre.notification.title': 'preference-centre.prompt-modal.title',
    'preference-centre.notification.description': 'Please update your preferences',
    'preference-centre.prompt-modal.title': 'Your marketing preferences',
    'preference-centre.prompt-modal.text': '<p>Your privacy is important to us. We have updated our preference centre so that you can tell us what emails you would like to receive. Please check and update your preferences.</p>',
    'preference-centre.prompt-modal.continue-text': 'View Preferences',
    'preference-centre.linkName': 'My Preferences',
    'preference-centre.auto-delay-repay.link': 'You now have the option to subscribe to One Click Delay Repay notifications. Find out more and update your preferences in your {preferenceCentreLink} page.',
    'preference-centre.unsubscribe.title': 'Please choose what you would like to unsubscribe from',
    'preference-centre.unsubscribe.empty.title': 'You have been unsubscribed from <{app.owner.short}> emails',
    'preference-centre.unsubscribe.empty.disclaimer': 'If you have JavaScript disabled or are running Ad-Blocking software please allow up to 30 days for this change to take effect.',
    'preference-centre.toggle.info.emailProducts': 'You are currently only opted in to receive new products and services updates.',
    'preference-centre.toggle.info.emailPromotions': 'You are currently only opted in to receive promotions and reward updates.',
    'preference-centre.consents.title': 'At TransPennine Express we want you to have access to special offers, exclusive competitions and the best travel tips. Sound good?',
    'preference-centre.consents.title_2': 'Yes, keep me in the loop by:',
    'preference-centre.consents.phoneNumber': 'Phone Number',
    'preference-centre.consents.phoneNumber.sr': 'Enter your Phone Number to receive SMS',
    'preference-centre.consents.confirmAge': 'Please confirm your age:',
    'preference-centre.consents.privacyPolicy': "Marketing communications will only come from TransPennine Trains Limited trading as TransPennine Express or any successor operator. Don't worry, if you change your mind, you can opt out at any time. To find out more, read our {link}",
    'preference-centre.consents.privacyPolicyLink': 'Privacy Policy',
    'preference-centre.consents.getError': 'There was an issue retrieving your consent, please check your internet and try again',
    'preference-centre.get-consents.error': 'An error occurred whilst attempting to retrieve your consents. Please try again later. If the issue persists, please contact customer services.',
    'preference-centre.update-consents.error': 'An error occurred whilst attempting to update your consents. Please try again later. If the issue persists, please contact customer services.',

    'postcode-lookup.error.invalid': 'This postcode appears to be invalid. Please check and try again',
    'postcode-lookup.error.not-found': "Sorry, we can't find any addresses for this postcode. Please enter manually",
    'postcode-lookup.input.placeholder': 'Enter your postcode',
    'postcode-lookup.select.placeholder': 'Select your address',
    'postcode-lookup.button.label': 'Search address',

    'inApp.updateRequired': 'Update Required',
    'inApp.iOSUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="#">Update now</a>',
    'inApp.AndroidUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="#">Update now</a>',

    'smartSelfRegistration.cta.title': 'The <{global.key}> <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets.',
    'smartSelfRegistration.warning.tryAnotherEmail': 'Try with another email ',
    'smartSelfRegistration.warning.requestReplacement': 'Request a replacement',
    'smartSelfRegistration.warning.accountFound': 'Account found. Please login.',
    'smartSelfRegistration.warning.noAccount': 'No account found. Please register.',
    'smartSelfRegistration.warning.smartcardFound': 'Existing <{global.smartcard}> found.',
    'smartSelfRegistration.warning.pendingSmartcard': 'Unfortunately, you are not able to use this service at this time as you have already requested a new <{global.smartcard}> which is on its way to you.',
    'smartSelfRegistration.warning.replacementSmartcard': 'You already have an Active <{global.smartcard}> on your account. If your <{global.smartcard}> is lost or stolen, please click below to request a replacement.',
    'smartSelfRegistration.warning.linkSmartcard': 'There is already a <{global.smartcard}> linked to your account, however, it doesn’t currently have any active products on it. If you would like to replace it, please enter your new <{global.smartcard}>’s number below.',
    'smartSelfRegistration.warning.noSmartcard': '<{global.smartcard}> not found. Please register your new <{global.smartcard}>.',
    'smartSelfRegistration.warning.childSmartcardReplacement': 'Unfortunately, child <{global.smartcard}> holders are not eligible to register for an adult <{global.smartcard}>. If your <{global.smartcard}> is lost or stolen, please click above to request a replacement.',
    'smartSelfRegistration.warning.childSmartcardActivation': 'Unfortunately, child <{global.smartcard}> holders are not eligible to register for an adult <{global.smartcard}>.',

    'smartcardKeyGo.register': 'Get a <{global.key}> <{global.smartcard}> & <{global.keyGo}>',
    'smartcardKeyGo.register-mobile': 'Sign up for <{global.keyGo}>',
    'smartcardKeyGo.register-onlyKeyGo': 'Sign up for <{global.keyGo}>',
    'smartcardKeyGo.title': 'Apply for the <{global.key}> <{global.smartcard}> & <{global.keyGo}>',
    'smartcardKeyGo.title-onlyKeyGo': 'Apply for <{global.keyGo}>',
    'smartcardKeyGo.heading': 'KeyGo Carnet tickets can only be used with a Key Smartcard with keyGo. Please register for keyGo below before purchasing keyGo Carnet ticket.',
    'smartcardKeyGo.errors.smartcard': 'There was a problem applying for a <{global.key}> <{global.smartcard}>. Please try again later',

    'refundWidget.title': 'Refund calculator',
    'refundWidget.field.price': 'Ticket price',
    'refundWidget.field.startDate': 'Ticket start date',
    'refundWidget.field.endDate': 'Ticket end date',
    'refundWidget.field.surrenderDate': 'Date ticket no longer needed from',
    'refundWidget.field.duration': 'Duration',
    'refundWidget.field.day': 'Select a date',
    'refundWidget.field.duration.option.annual': 'Annual',
    'refundWidget.field.duration.option.custom': 'Custom',
    'refundWidget.field.validation.oneMonthAndOneDayBetweenStartSurrender': 'Unfortunately, we can only calculate refunds if you have used your ticket for more than a month.',
    'refundWidget.field.validation.endDateBeforeSurrender': 'The "Ticket end date" should be equal/after the "Date of last use".',
    'refundWidget.field.validation.lessThenOneYearBetweenStartSurrender': 'Unfortunately, we can only calculate refunds for periods shorter then one year.',
    'refundWidget.confirm': 'Calculate refund',
    'refundWidget.totalRefund': 'Estimated refund amount:',
    'refundWidget.adminFee': 'Admin fee:',
    'refundWidget.total': 'Total:',
    'refundWidget.note': 'The exact amount may vary depending on the final validation of the refund application.',
    'refundWidget.poweredBy-text': 'Powered by OnTrack Retail',
    'refundWidget.poweredBy-alt': 'OnTrack Retail logo',
    'refundWidget.poweredBy-ownersite': 'https://www.ontrackretail.co.uk/',

    'transitioning-child-smartcard.modal.title': 'Your Smartcard is expiring',
    'transitioning-child-smartcard.modal.paragraph.1': 'As your 16th birthday is approaching, please be aware that your child smartcard is due to expire.',
    'transitioning-child-smartcard.modal.paragraph.2': 'While season tickets on your child smartcard remain valid for up to four months after your 16th birthday, you will no longer be able to purchase day tickets with it.',
    'transitioning-child-smartcard.modal.paragraph.3': 'Once you have turned 16 and have no active season ticket, we will upgrade your account and issue you an adult smartcard, which you should receive within seven days.If you have an active child season ticket during this transition and need to purchase single or return tickets, please buy adult eTickets while you await your new adult smartcard.',
    'transitioning-child-smartcard.modal.paragraph.4': 'Your new Smartcard will be sent to the following address:',
    'transitioning-child-smartcard.modal.paragraph.5.1': 'If your address has changed, please go to the ',
    'transitioning-child-smartcard.modal.paragraph.5.address.link': 'Address',
    'transitioning-child-smartcard.modal.paragraph.5.2': ' section of your account, and amend it before you current Smartcard expires.',

    'smartcard.pending.cards.list.summary': '{total, plural, =1{# <{global.key}> <{global.smartcard}> is} other{# <{global.smartcard}>s are}} pending approval',
    'smartcard.associated.cards.list.title': 'These <{global.key}> <{global.smartcard}>s are linked to your account',
    'smartcard.associated.cards.list.description': 'You can buy ticket(s) for the following <{global.key}> <{global.smartcard}>s:',
    'smartcard.associated.cards.list.empty': 'You have no <{global.key}> <{global.smartcard}> accounts linked to your account. After requesting to link an account, you will have to wait until the linking request is approved.',
    'smartcard.associated.cards.list.remove': 'Remove linked <{global.key}> <{global.smartcard}>',
    'smartcard.associated.accounts.list.title': 'The following account(s) can buy tickets for your <{global.key}> <{global.smartcard}>:',
    'smartcard.pending.accounts.list.summary': 'You have been sent {total} \'Linking <{global.key}> <{global.smartcard}> request(s)\'! Please check your email and click approve to allow them to buy tickets for your <{global.key}> <{global.smartcard}>.',
    'smartcard.associated.accounts.list.description': 'Manage who can buy ticket(s) for your <{global.key}> <{global.smartcard}> here.  Once you have approved their request to link your <{global.key}> (sent by email), their name will appear below.',
    'smartcard.associated.accounts.list.empty': 'Manage who can buy tickets for your <{global.key}> <{global.smartcard}> here. Once you have approved their request to link your Key (sent by email), their name will appear below.',
    'smartcard.associated.accounts.list.remove': 'Unlink your <{global.key}> <{global.smartcard}>',
    'smartcard.associated.accounts.list.awaiting': 'This link awaits your confirmation',
    'smartcard.association.details.number': '<{global.key}> <{global.smartcard}> Number:',
    'smartcard.association.details.status': '<{global.key}> <{global.smartcard}> Status:',
    'smartcard.association.details.email': 'Account email address:',
    'smartcard.associate.title': 'Link another <{global.key}> <{global.smartcard}> to your account',
    'smartcard.associate.description': 'You can buy and manage ticket(s) for friends and family, including children’s school travel, to download to their <{global.key}> card. Find out more <a href="https://www.southeasternrailway.co.uk/Tickets/Tickets-explained/the-key-smart-Tickets" target="_blank">here</a>.',
    'smartcard.associate.instruction': 'Type the <{global.key}> <{global.smartcard}> number or the email address belonging to the <{global.key}> card account you wish to link.',
    'smartcard.associate.process-description': 'An email will be sent to the recipient to approve your request.',
    'smartcard.associate.button.label': 'Request to link account',
    'smartcard.associate.field.label': '<{global.smartcard}> to associate',
    'smartcard.associate.confirm.heading': 'Request pending',
    'smartcard.associate.confirm.message': 'An email has been sent to the recipient to approve your request.',
    'smartcard.associate.awaiting.title': 'Awaiting confirmation',
    'smartcard.remove-card-association.modal.title': 'Remove linked <{global.key}> <{global.smartcard}>',
    'smartcard.remove-card-association.modal.description': 'Are you sure you want to unlink {name}’s card? You will no longer be able to buy tickets for them.',
    'smartcard.remove-account-association.modal.title': 'Unlink your <{global.key}> <{global.smartcard}>',
    'smartcard.remove-account-association.modal.description': 'Are you sure you want to unlink your <{global.key}> card from {name}’s account? They will no longer be able to buy smart tickets for you.',
    'smartcard.associate.field.required': 'Valid email or smartcard number required',
    'smartcard.dissociate.error.heading': 'Unlink account error',
    'smartcard.associate.error.heading': 'Link account error',
    'smartcard.associate.error.unknown.title': 'No <{global.smartcard}>',
    'smartcard.associate.error.unknown.message': 'Sorry we couldn’t find a <{global.smartcard}> with that account. Please check your details and try again.',
    'smartcard.associate.error.smartcardNotFound.title': '<{global.smartcard}> not found',
    'smartcard.associate.error.notFound.title': 'Account not found',
    'smartcard.associate.error.notFound.email.message': 'Sorry, we couldn’t find an account with those details. Please try again.',
    'smartcard.associate.error.notFound.isrn.message': 'Sorry, we couldn’t find an account with those details. Please try again.',
    'smartcard.associate.error.invalid.title': 'Invalid <{global.smartcard}>',
    'smartcard.associate.error.own.message': 'You can\'t link your own account. Try with your friends or family’s <{global.key}> <{global.smartcard}>s.',
    'smartcard.associate.error.alreadyRequested.message': '<{global.smartcard}> is already linked to this account or same request has been submitted.',
    'smartcard.associate.error.inactive.message': '<{global.smartcard}> is not active, it can\'t be linked.',
    'smartcard.associate.error.remove-association.title': 'Cannot unlink account',
    'smartcard.associate.confirmation.title': 'Request to link your <{global.key}> <{global.smartcard}>',
    'smartcard.associate.confirmation.approve': 'Your Key Smartcard is now linked to {name}’s account',
    'smartcard.associate.confirmation.reject': 'You have rejected {name}’s request to link your <{global.key}> <{global.smartcard}> to their account',

    'smartCarnet.passes': 'passes',
    'smartCarnet.filters.routes': 'Routes',
    'smartCarnet.filters.anyPermitted': 'Any Permitted',
    'smartCarnet.filters.brandOnly': 'ThamesLink Only',
    'smartCarnet.filters.services': 'Services',
    'smartCarnet.filters.peak': 'Peak',
    'smartCarnet.filters.offPeak': 'Off Peak',
    'smartCarnet.ticketFare.numberOfPasses': 'Number of passes:',
    'smartCarnet.return.warning': 'A carnet ticket only allows for one way travel. Return journey from {price}',
    'smartCarnet.return.noResults': 'Sorry, there were no Smart Carnet tickets found for return journey. Please try a different date or stations.',
    'smartCarnet.fare.passes': '<strong>Passes:</strong> {numOfTickets}',
    'smartCarnet.fare.validFor': '(valid for {months} months)',
    'smartCarnet.fare.validUntil': 'Valid until',
    'smartCarnet.error.maxPassesReached': 'You cannot add this ticket to the basket as it would exceed the <strong>{limit} passes limit</strong> for a journey from <strong>{origin}</strong> to <strong>{destination}</strong> on your account.<br/><br/>Please try lowering the number of passes to purchase.',
    'smartCarnet.refund.numberOfPasses': 'Passes:',
    'smartCarnet.refund.notRefundable': 'not refundable',
    'smartCarnet.account.anyRoute': 'Travel is allowed via any permitted route',
    'smartCarnet.account.filters.active': 'Remaining tickets',
    'smartCarnet.account.filters.expired': 'Expired tickets',
    'smartCarnet.account.filters.all': 'Show all',
    'smartCarnet.account.description': 'If you have multiple <{global.keyGo}> Carnet tickets, passes that expire at an earlier date will be used first.',
    'smartCarnet.account.noResults': 'No <strong>{ticketStatus}</strong> <{global.keyGo}> Carnet tickets found.',
    'smartCarnet.account.orderReference': 'Order reference',
    'smartCarnet.account.remainingPasses': '{passes} passes remaining',
    'smartCarnet.account.ticket.remainingPasses': '<strong>Remaining passes:</strong> {passes}',
    'smartCarnet.account.ticket.usedPasses': '<strong>Used passes:</strong> {passes}',
    'smartCarnet.account.ticket.validity': '<strong>Valid:</strong> {startDate} - {endDate}',
    'smartCarnet.account.title': '<{global.keyGo}> Carnet tickets',
    'smartCarnet.account.refundsLink': 'Click here to manage your tickets including refunds',
    'smartCarnet.ticketStatus.1': 'active',
    'smartCarnet.ticketStatus.2': 'expired',
    'smartCarnet.ticketStatus.3': 'active or expired',
    'smartCarnet.account.journey.offPeak': 'keyGo Carnet Off-Peak (Adult)',
    'smartCarnet.account.journey.peak': 'keyGo Carnet Peak (Adult)',
    'flexi.name': 'Flexi Season',
    'flexi.ticketName': 'Flexi Season ticket',
    'flexi.tickets': 'Passes',
    'flexi.perPass': 'per pass',
    'flexi.passesLower': 'passes',
    'flexi.fare.tickets': '{numOfTickets} passes',
    'flexi.fare.validFor': 'valid for {days} days from start date',
    'flexi.fare.validityInfo': 'Each pass allows you to travel all-day with unlimited travel that day between the two stations you\'ve selected',
    'flexi.fare.validUntil': 'Valid until',
    'flexi.account.remainingTickets': 'Remaining passes',
    'flexi.account.ticketsRemaining': 'passes remaining',
    'flexi.account.usedTickets': 'Used passes',
    'flexi.account.ticketsActivatedOn': 'Passes activated on',
    'flexi.account.validFrom': 'Passes valid from',
    'flexi.account.validTo': 'Passes expire on',
    'flexi.account.empty': 'No results found',
    'flexi.account.refundLink': 'Refund {origin}, to {destination}. {route} Flexi Season ticket',
    'flexi.account.addToFavourites': 'Add {origin}, to {destination}. {route} Flexi Season ticket to your favourite tickets',
    'flexi.account.ticketSummary': 'From {origin} to {destination}. {route}. {remainingTickets} passes remaining. Passes activated on {activationDates}',
    'flexi.account.validityInfo': 'Passes must all be used before the expiry date. Any unused passes that are remaining beyond this validity date will not be able to be refunded',
    'flexi.londonFaresWarning': 'Flexi Season tickets are not available for journeys between two stations within the London Travelcard Zones 1-9',
    'flexi.londonFaresWarningLinkText': 'find out more',
    'flexi.londonFaresWarningLinkText.aria': 'Find out more with flexi Season FAQs',
    'fareHandOff.title': 'Add fare',
    'fareHandOff.title.ERROR': 'Error',
    'fareHandOff.state.INITIAL': 'Initialising',
    'fareHandOff.state.ERROR': 'There is a problem',
    'fareHandOff.state.CHECKING_RAILCARD': 'Checking 16/17 Saver',
    'fareHandOff.state.RAILCARD_ENTRY': 'Checking 16/17 Saver',
    'fareHandOff.state.RAILCARD_INCOMPLETE': 'Checking 16/17 Saver',
    'fareHandOff.state.SEARCHING': 'Searching for fares',
    'fareHandOff.state.SEARCH_COMPLETE': 'Searching for fares',
    'fareHandOff.state.FARE_NOT_FOUND': 'Fare not found',
    'fareHandOff.state.FARE_SELECTED': 'Adding fare to basket',
    'fareHandOff.state.FARE_ADDED': 'Adding fare to basket',
    'fareHandOff.state.ADDING_PLUSBUS': 'Adding PlusBus',
    'fareHandOff.state.CHECKING_DELIVERY': 'Checking delivery',
    'fareHandOff.state.REDIRECT_DELIVERY': ' ',
    'fareHandOff.state.REDIRECT_PAYMENT': ' ',
    'fareHandOff.state.REDIRECT_SEARCH_RESULTS': ' ',
    'fareHandOff.message.FARE_NOT_FOUND': 'We could not find the fare you are looking for. Would you like to see a list of available fares?',
    'fareHandOff.message.RAILCARD_INCOMPLETE': 'The fare that you chose includes a 16/17 saver discount, but we could not validate your railcard for the period of your ticket. Would you like to try again, or view prices without the 16/17 railcard?',
    'fareHandOff.button.viewFares': 'View available fares',
    'fareHandOff.button.retryRailcard': 'Retry 16/17 Railcard',
    'charity.name.railway-children': 'Railway Children',
    'charity.description.railway-children': '<p>Every year in the UK, almost 10,000 children are found in danger on the rail network. They might be running away from crisis in the home, unknowingly running towards danger at the hands of criminals, or in the worst cases, trying to end their lives.</p><p>The charity Railway Children is working in partnership with British Transport Police to create a safety net to provide immediate protection, followed by individualised support plans, for these children to help change the direction of their lives, setting them onto the path to a brighter, happier future.</p><p style="margin-bottom: 0;">You can learn more about Railway Children’s work in the UK, as well as across India and Tanzania by visiting <a href="{charityUrl}" target="_blank">{urlText}</a></p>',
    'charity.name.dame-kelly': 'Dame Kelly Holmes Trust',
    'charity.description.dame-kelly': '<p>Dame Kelly Holmes Trust puts world class athletes shoulder to shoulder with young people. Equipping them with a winning mindset and shaping their futures - it’s a teammate like no other. Whether that’s building relationship skills, improving self-esteem or learning to stay focused, our sporting champions help the next generation move forward with confidence. Our goal is to improve the health and wellbeing of 10,000 young people across the UK facing challenges in their everyday lives.</p><p style="margin-bottom: 0;"><a href="{charityUrl}" target="_blank">{urlText}</a></p>',
    'charity.name.samaritans': 'Samaritans',
    'charity.description.samaritans': '<p>Every 10 seconds, Samaritans responds to a call for help.</p><p>We’re here, day or night, for anyone who’s struggling to cope, who needs someone to listen without judgement or pressure. Samaritans is not only for the moment of crisis, we’re taking action to prevent the crisis.</p><p>We give people ways to cope and the skills to be there for others. And we encourage, promote and celebrate those moments of connection between people that can save lives.</p><p style="margin-bottom: 0;"><a href="{charityUrl}" target="_blank">{urlText}</a></p>',
    'charity.name.cruk': 'Cancer Research UK',
    'charity.description.cruk': '<p>Thanks to supporters like you, our pioneering work into how to prevent, diagnose and treat cancer has benefitted millions of lives. Giving as little as £2 a month could fund something as big as a new research centre or as small as glass slides to analyse cancer cells.</p><p style="margin-bottom: 0;"><a href="{charityUrl}" target="_blank">{urlText}</a></p>',
    'charity.name.great-ormond-street': 'Great Ormond Street Hospital Children\'s Charity',
    'charity.description.great-ormond-street': '<p>Every day brings new challenges at Great Ormond Street Hospital (GOSH). Every day, around 600 children and young people from across the UK arrive. Every day, doctors and nurses battle the most complex illnesses, and the brightest minds come together to achieve pioneering medical breakthroughs. This extraordinary hospital has always depended on charitable support to give seriously ill children the best chance to fulfil their potential, and every day is a chance for you to make a difference. By donating today, you will positively impact so many seriously ill children treated at GOSH. 100% of your donation is given by South Eastern Railway to Great Ormond Street Hospital Children’s Charity (Registered charity no. 1160024).</p><p style="margin-bottom: 0;"><a href="{charityUrl}" target="_blank">{urlText}</a></p>',
    'charity.name.nhs': 'NHS',
    'charity.description.nhs': '<p style="margin-bottom: 0;"><a href="{charityUrl}" target="_blank">{urlText}</a></p>',
    'charity.name.dec': 'Disasters Emergency Committee',
    'charity.description.dec': '<p style="margin-bottom: 0;"><a href="{charityUrl}" target="_blank">{urlText}</a></p>',
    'charity.loading.error': 'There are no charities available at this moment, please try again later.',
    'seatfinder.title': 'Click here to check how busy your train may be with <u>SeatFinder</u>',
    'timetableAlertsWidget.notificationPreference': 'Notification preference:',
    'rewardPoints.information.pointsAmount': 'Congratulations you have earned {totalRewardPoints} reward points.',
    'rewardPoints.information.acknowledgment': 'Thank you for booking directly with us.',
    'rewardPoints.instruction.list.heading': 'Follow these steps to exchange your points for rewards:',
    'rewardPoints.instruction.list.firstStep': 'Go to the{rewardPointsUrl}',
    'rewardPoints.instruction.list.firstStep.url': 'Next Level Rewards website',
    'rewardPoints.instruction.list.secondStep': 'Create an account',
    'rewardPoints.instruction.list.thirdStep': 'Enter your reward ID, {rewardPointUid} (Please note reward points will be available to redeem from the day after purchase)',
    'rewardPoints.instruction.list.fourthStep': 'Choose your rewards',
    'rewardPoints.instruction.reminder': 'Remember, the more points you have the greater the reward you can claim!',
    'rewardPoints.instruction.tsAndCs': 'Subject to Terms and Conditions. Please visit{rewardPointsTermsUrl}for more details.',
    'rewardPoints.instruction.tsAndCs.url': 'Next Level Rewards',
    'rewardPoints.earned.pointsAmount': 'You’ve earned {rewardPoints} rewards points',
    'rewardPoints.earned.findOutMore': 'Find out more about our Reward program',
    'rewardPoints.toGet.pointsAmount': 'You’ll earn {rewardPoints} rewards points',
    'rewardPoints.toGet.findOutMore': 'Find out more about our Reward program',
    'rewardPoints.modal.title': 'Southern Rail Reward Program',
    'rewardPoints.modal.heading': 'Commute more, collect more, with Southern Rewards',
    'rewardPoints.modal.howToGet': 'You can earn 3 points for every £1 you spend on Anytime, Flexi Season and Season tickets bought directly from our website and fulfilled using an eTicket or Key Smartcard, until 31st March 2023 (T’s and C’s apply).',
    'rewardPoints.modal.usage': 'Use your points to claim amazing rewards, such as days out, meals out, free cinema tickets and coffees, or even online training courses. Upon signing up to the rewards programme you will also be automatically entered into a prize draw where you can win even more!',
    'rewardPoints.modal.findOutMore': 'Find out more',
    'rewardPoints.modal.schemeEnding': 'As of 1st April, you will no longer receive reward points for your Anytime, Flexi Season and Season tickets bought directly from the Southern Railway website and fulfilled using an eTicket or Key Smartcard.',
    'rewardPoints.modal.existingRewardCodes': 'Existing reward codes can still be logged via the Southern Next Level Rewards website',
    'rewardPoints.modal.existingRewardCodesUntil': 'until 31st May.',

    'carbonFootprint.button.info': 'How we work out your carbon footprint',
    'carbonFootprint.modal.title': 'Carbon Footprint',
    'carbonFootprint.modal.paragraph1': "Travelling by train is one of the most environmentally friendly ways to travel, with lower carbon emissions than most cars.",
    'carbonFootprint.modal.paragraph2': 'The environmental impact of your journey for both train and car travel is shown below.',
    'carbonFootprint.modal.paragraph3': 'To help you draw comparisons from the CO2e savings we have provided CO2e equivalents. Data from these is provided by the ',
    'carbonFootprint.modal.paragraph3.link': 'EPA Carbon Calculator',
    'carbonFootprint.modal.paragraph4': ' and ',
    'carbonFootprint.modal.paragraph4.link': 'Carbon Footprint',
    'carbonFootprint.modal.paragraph5': '.',
    'carbonFootprint.saved': "Good news! You will save {savedCO2e}kg CO2e because you're taking the train instead of the car.",
    'carbonFootprint.modal.info.title': 'CO2e emissions for this {distance} mile journey between {origin} and {destination}:',
    'carbonFootprint.modal.info.card-train.title': 'By train',
    'carbonFootprint.modal.info.card-car.title': 'By car',
    'carbonFootprint.modal.info.card.subtitle': 'Emissions for this journey:',
    'carbonFootprint.modal.info.card.emission': '{emission} kg CO2e',
    'carbonFootprint.modal.info.paragraph1': 'Distance is calculated as the direct distance between the origin and destination stations.',
    'carbonFootprint.modal.info.paragraph2': "These calculations are based on:<br><br>Car = Average petrol car 0.22469 kg CO2e/passenger mile<br>Train = National Rail 0.07150 kg CO2e/passenger mile",
    'carbonFootprint.modal.info.paragraph3': 'Conversion factors are taken from ',
    'carbonFootprint.modal.alternative.info.title': 'The {savedCO2e}kg CO2e that you will save by taking the train instead of the car is similar to:',
    'carbonFootprint.modal.alternative.card.battery.title': 'Fully Charging',
    'carbonFootprint.modal.alternative.card.battery.info': '{value} smartphones',
    'carbonFootprint.modal.alternative.card.washingMachine.title': 'Using a washing machine',
    'carbonFootprint.modal.alternative.card.washingMachine.info': '{value} times',
    'carbonFootprint.modal.alternative.card.tv.title': 'Watching',
    'carbonFootprint.modal.alternative.card.tv.info': '{value} hours of TV',
    'carbonFootprint.modal.alternative.card.kettle.title': 'Boiling',
    'carbonFootprint.modal.alternative.card.kettle.info': '{value} kettles',
    'carbonFootprint.modal.alternative.card.bulb.title': 'Leaving a light on for',
    'carbonFootprint.modal.alternative.card.bulb.info': '{value} hours',
    'carbonFootprint.modal.alternative.card.microwave.title': 'Using a microwave',
    'carbonFootprint.modal.alternative.card.microwave.info': '{value} times',

    'confirmation.sTicket.app.description': 'Go to the ‘My Tickets’ section of the app to download and view your sTicket, you will need to be logged in.<br/>If you don’t have the { brand } app, you can download it on the App Store or Google Play.',
    'booking.delivery.sticket.modal.body': 'Go to the ‘My Tickets’ section of the app to download and view your sTicket, you will need to be logged in.',

    'ontrackapp.widget.brandAltText': '{brand} logo',

    'modals.assistance-helplines.title': 'Assistance helplines',
    'modals.assistance-helpline.preamble': 'To make a passenger assist request by phone or for any travel queries please call:',
    'modals.assistance-helplines.heading-1': 'Passenger Assist:',
    'modals.assistance-helplines.item-1': '0800 783 4524',
    'modals.assistance-helplines.heading-2': 'Text Relay number:',
    'modals.assistance-helplines.item-2': '18001 0800 783 4524',
    'modals.assistance-helplines.footer': 'These numbers are available 24 hours a day, 7 days a week.',

    'delivery.e-ticket.bikeReservation': 'eTicket is not available for orders with bike reservations.'
});

exports.default = {
    gatwick: defaultMessages.merge(_gatwick2.default),
    'gatwick-android': defaultMessages.merge(_gatwick2.default),
    'gatwick-ios': defaultMessages.merge(_gatwick2.default),
    'gatwick-ba': defaultMessages.merge(_gatwickBa2.default),
    'gatwick-ryanair': defaultMessages.merge(_gatwickRyanair2.default),
    'gatwick-easyjet': defaultMessages.merge(_gatwick2.default),
    southeastern: defaultMessages.merge(_southeastern2.default),
    southern: defaultMessages.merge(_southern2.default),
    thameslink: defaultMessages.merge(_thameslink2.default),
    greatnorthern: defaultMessages.merge(_greatnorthern2.default),
    ontrackretail: defaultMessages.merge(_ontrackretail2.default),
    ticketyboo: defaultMessages.merge(_ticketyboo2.default),
    transpennine: defaultMessages.merge(_transpennine2.default),
    trainhugger: defaultMessages.merge(_trainhugger2.default)
};

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports = humanSize;

var mags = ' KMGTPEZY';

function humanSize(bytes, precision) {
  var magnitude = Math.min(Math.log(bytes) / Math.log(1024) | 0, mags.length - 1);
  var result = bytes / Math.pow(1024, magnitude);
  var suffix = mags[magnitude].trim() + 'B';
  return result.toFixed(precision) + suffix;
}


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

var _gatwick = __webpack_require__(533);

var _gatwick2 = _interopRequireDefault(_gatwick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Custom messages for Gatwick Express - British Airways
 */

var micrositeMessages = new _immutable.Map({
  'app.owner': 'Gatwick Express - British Airways'
});

module.exports = _gatwick2.default.merge(micrositeMessages);

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

var _gatwick = __webpack_require__(533);

var _gatwick2 = _interopRequireDefault(_gatwick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Custom messages for Gatwick Express - Ryanair
 */

var micrositeMessages = new _immutable.Map({
  'app.owner': 'Gatwick Express - Ryanair'
});

module.exports = _gatwick2.default.merge(micrositeMessages);

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for south eastern
 */

module.exports = new _immutable.Map({
    'global.smartcardTicket': 'smart ticket',
    'global.smartcardTicketUppercase': 'Smart Ticket',
    'global.continue': 'Proceed to checkout',

    'app.owner': 'Southeastern Railway',
    'app.owner.toc': 'SE',
    'app.owner.short': 'Southeastern',
    'app.owner.appName': 'Southeastern',
    'footer.link': 'Southeastern',
    'footer.accessibilityStatement': 'Site accessibility',

    // Override message because SE don't have a delayRepayFaq url ready yet.
    'delayrepay.error.message': 'error.general.message',
    'delayrepay.intro.text': "Delay Repay is a national scheme train companies use to compensate passengers for delays. You can claim compensation if you're delayed by 30 minutes or more when you travel with us (except when delays are caused by planned engineering work).",

    'pageTitles.smartcard-replacement': '<{global.key}> card - replacement',
    'account.heading.smartcard.replacement': '<{global.key}> card - replacement',
    'account.confirm.smartcardsignup': 'Get <{global.theKey}> with my account',
    'account.smartcardsignup.readmore': 'Find out more about <{global.theKey}>',
    'account.smartcard.text.replacementinfo': 'You can apply for a replacement <{global.key}> free of charge. If you have any issues, please contact Customer Services on {phoneNumber} (calls are charged at a local rate, and may be recorded).',
    'account.smartcard.text.replacementinfo.tickets.pre-replacement': 'While waiting for your new <{global.key}> to arrive, please buy paper tickets to travel. Keep these paper tickets, as you may be able to claim a refund. If you purchase them from another company, this may slow down your refund,',
    'account.smartcard.text.replacementinfo.tickets.post-replacement': 'While waiting for your new <{global.key}> to arrive, please buy paper tickets to travel. Any valid smart tickets previously on your <{global.key}> card will be pre-loaded on your new card. You may be able to claim a refund on the additional tickets you purchased as per our refund policy.',
    'account.smartcard.text.replacementinfo.season': 'If you have a Season Ticket on your <{global.key}> card, refunds will be available providing the paper tickets are valid for the same time and journey of your Season Ticket. For Flexi Seasons and other tickets, please check our refund policy for more details.',
    'account.heading.smartcard.replacement.request': 'Request a new <{global.key}> card',
    'account.smartcard.button.replacemycard': 'Request a new <{global.key}> card',
    'account.smartcard.text.number': '<{global.key}> card number',
    'account.smartcardsignup.benefit1': 'Buy single, return and season tickets',
    'account.smartcardsignup.benefit2': 'Buy and download your tickets at home with our app',
    'account.smartcardsignup.benefit3': 'Fast-track through the station and avoid the queues',
    'account.smartcardsignup.benefit4': 'Contactless travel, just tap and go',
    'account.smartcardsignup.benefit5': 'Quicker refunds',

    'delivert.1st-class-mail.detail': '<p>Tickets purchased by 16:00 will be processed and dispatched within 24 hours of booking using Royal Mail First Class post. Please allow five working days for delivery.</p><p>Please note, we are unable to guarantee delivery for first class and shall not be obliged to change, cancel, replace or refund a ticket once it has been posted.</p><p>Applicable to UK addresses only.</p>',
    'delivery.royal-mail-recorded-delivery.detail': '\n        <p>Tickets purchased by 16:00 weekdays, will be dispatched that day.</p>\n        <ul class="list-bullets-modal"><li>Aims to deliver the next working day including Saturdays</li><li>Signature required on delivery</li><li>Applicable to UK addresses only</li></ul>\n        <p>We are unable to guarantee delivery of any unsigned for 1st class post, and would recommend a digital ticket fulfilment method or collect from station as it\u2019s quicker and free of charge.</p>',
    'delivery.add-to-my-key-smartcard.TooManyTicketsOnSmartcardError': 'Key card fulfilment is unavailable because you have reached the maximum number of tickets on your <{global.smartcard}>.',
    'delivery.add-to-my-key-smartcard.TooManyTicketsInBasketError': 'Key card fulfilment is unavailable because only one ticket can be added to your <{global.smartcard}> at a time.',
    'delivery.add-to-my-key-smartcard.SmartcardCantBeDeliveredInTimeError': '<p>This ticket is not available for the Key card because:</p><ul><li>The ticket start date is too soon. Please choose a start date of <b>{deliveryDate}</b> or later to allow delivery of your new <{global.key}> <{global.smartcard}>.</li><li>There are insufficient child and/or adult Key Smartcards linked to your account to fulfil this order.</li></ul>',
    'delivery.add-to-my-key-smartcard.PendingSmartcardError': 'Key card fulfilment is unavailable because your new <{global.smartcard}> request is being processed.',
    'delivery.add-to-my-key-smartcard.NotCorrectAgeForFareError': 'The ticket(s) selected does not match the type of <{global.key}> <{global.smartcard}> on your account.',
    'delivery.add-to-my-key-smartcard.NotEnoughActiveSmartcardsError': '<p>To use your <{global.key}> <{global.smartcard}> you need to remove a ticket(s) from the basket to match the smartcards on your account.</p><p>Find out more about linking accounts click <a target="_blank" href="https://www.southeasternrailway.co.uk/tickets/the-key">here</a></p></p>',
    'delivery.royal-mail-special-delivery.detail': '\n        <p>Tickets purchased by 16:00 weekdays will be delivered by 1pm* the next working day.</p>\n        <ul class="list-bullets-modal"><li>Full tracking</li><li>Photo and signature on delivery</li><li>Guaranteed delivery next day by 1pm*</li><li>Compensation cover up to \xA3750</li><li>Applicable to UK addresses only</li></ul>\n        <p>* Remote areas and Islands of Scotland will take longer to reach. Orders placed on Saturday or Sunday are dispatched on Monday and delivered on Tuesday. Orders placed on a Bank Holiday are dispatched and delivered on Wednesday.</p>',
    'delivery.1st-class-mail.detail': '<p>Tickets purchased by 16:00 weekdays, will be dispatched that day.</p>\n        <ul class="list-bullets-modal"><li>Aims to deliver the next working day including Saturdays</li><li>Applicable to UK addresses only</li></ul>\n        <p>We are unable to guarantee delivery of any unsigned for 1st class post, and would recommend a digital ticket fulfilment method or collect from station as it\u2019s quicker and free of charge.</p>',
    'delivery.royal-mail-special-delivery-insured.detail': '\n        <p>Tickets purchased by 16:00 weekdays will be delivered by 1pm* the next working day.</p>\n        <ul class="list-bullets-modal"><li>Full tracking</li><li>Photo and signature on delivery</li><li>Guaranteed delivery next day by 1pm*</li><li>Compensation cover up to \xA32500</li><li>Applicable to UK addresses only</li></ul>\n        <p>* Remote areas and Islands of Scotland will take longer to reach. Orders placed on Saturday or Sunday are dispatched on Monday and delivered on Tuesday. Orders placed on a Bank Holiday are dispatched and delivered on Wednesday.</p>',
    'account.smartcardsignup.address': '<{global.key}> card delivery address',
    'account.register.smartcard.benefits.tickets': 'Buy single, return and season tickets',
    'account.register.smartcard.labelShort': 'Continue with the <{global.key}>',
    'account.register.opt.description': 'We’d like to keep you updated about changes to your service, ticket renewals and special offers. Please let us know below which emails you’d like to receive.',
    'account.register.smartcardActivation': 'If you purchase a smart Season Ticket within the next 2 hours it will come pre-loaded onto your <{global.key}> card when it is delivered to your home address.',
    'account.register.smartcardPreload': 'If you purchase a smart ticket within the next 2 hours it will come pre-loaded onto your <{global.key}> card when it is delivered to your home address. <br /><br />If you would like to transfer your paper Season Ticket onto your <{global.key}> card, you must do so within the next 2 hours. Once complete, your <{global.key}> card will be delivered to your local station for collection.',
    'account.smartcardstatus.pendingSmartcard': 'Your <{global.key}> card application is being processed.',
    'account.smartcardsignup.details': '<{global.theKey}> is our contactless smartcard which means you can buy and download single, return and season tickets at home, fast-track through the station and avoid the queues. {readmore}',
    'account.smartcard.transfer.searchRules': 'Is on a {brand} Key-enabled route\n                                                Has a minimum of one month\'s validity before it expires\n                                                Was purchased from the {brand} website or from a {brand} ticket office\n                                                Is a full-priced Season Ticket (any discounted Season Ticket will not be eligible for transfer)\n                                                Is an adult ticket',
    'preference-centre.service-updates': 'Travel updates',
    'preference-centre.promotions': 'Promotions, products, services and rewards',
    'preference-centre.privacy-notice': '<p>We will not pass on your personal information to any organisation outside of <{app.owner.short}>. Should we no longer operate the <{app.owner.short}> franchise, please be aware that we will pass your details to the successor operator of the <{app.owner.short}> franchise to allow you to continue using your customer account and receive marketing emails if you have consented to them.</p>',
    'preference-centre.privacy-notice.more': '_',
    'preference-centre.privacy-notice.extra': '_',
    'preference-centre.service-updates.help': 'Get emails about new timetables, planned engineering work and major service disruption.',
    'preference-centre.promotions.help': 'Get inspiration for days out, news about promotions, competitions, rewards and new products.',
    'preference-centre.edit-notice.short': 'Once registered, you can change your preferences at any point by going into \'My Account\' and updating what you would like to receive. You can also create personalised journey alerts when buying your ticket from our website or app.',
    'booking.smartcard.info': 'How to buy a ticket using a <{global.key}> <{global.smartcard}>? ',
    'booking.smartcard.info.body': 'Just enter your route as normal, select the ticket you need, and your Key smartcard will be offered as an option if available.',
    'booking.delivery.smartcard.differingCollectionStationWarning': 'IMPORTANT: Your ticket can only be loaded onto your <{global.key}> at your chosen station',
    'booking.delivery.smartcardLoginOrRegister': 'Add to a new, or existing, <{global.key}> <{global.smartcard}>',
    'booking.delivery.smartcardApply': 'Add to a new, or existing, <{global.key}> <{global.smartcard}>',
    'booking.delivery.header': 'Ticket collection options',
    'booking.delivery.loadingstation': 'Select the station that you would like to load your ticket(s) from:',
    'booking.delivery.smartcard.modal.body': 'Using the {brand} mobile app, load your ticket straight onto your <{global.key}> <{global.smartcard}> by simply tapping the <{global.smartcard}> onto the back of your phone after purchase.',
    'booking.delivery.sticket.modal.body': 'Go to the ‘My Tickets’ section of the app to download and view your sTicket, you will need to be logged in.',
    'booking.delivery.loadingdate.download': 'Download the Southeastern app to load your ticket instantly',
    'booking.delivery.loadingdate.secondaryInfo': 'Alternatively, please allow a minimum of two hours after purchase to load your ticket at the station',
    'booking.delivery.loadingdate.info': 'Please allow a minimum of two hours after purchase before loading the ticket(s) at the selected station.',
    'booking.delivery.loadingdate.downloadGTR': 'You can load and activate your Flexi Season tickets within 15 minutes via our {brand} mobile app. ',
    'booking.delivery.loadingdate.downloadGTRPaymentConfirmation': 'Please use the {brand} mobile app to load your ticket to your Key Smartcard now.',
    'booking.delivery.loading.collectViaAppNow': 'Please use the {brand} mobile app to load the ticket to your Key Smartcard.',
    'booking.fares.details.accessibility.warning': "Some First class areas don't have wheelchair accommodation, or wheelchair access to accessible toilets. If you are travelling with another operator, please check with them",
    'account.linkorder.error.message.customerservices': 'If you are still having problems, please contact Customer Services on 0345 322 7021',
    'account.orders.refund.itso.description': 'We have automatically calculated the amount that you will be refunded for your season ticket(s).',
    'account.orders.refund.itso.deduction.amount': '{amount}',
    'account.orders.refund.itso.footer.description': 'If you are applying for a refund due to sickness or disagree with the refund amount then please click {here}.',
    'account.orders.refund.itso.modal.refundFailureMessage': 'Please contact customer services on {phoneNumber} or raise a refund request by clicking {form}.',
    'account.orders.refund.itso.modal.refundForm': '<{global.here}>',
    'account.orders.refund.reason.advance-ticket': 'Advanced tickets are non-refundable.',
    'account.orders.refund.warning.refundsLocked': 'We cannot process this refund automatically, due to the high volume of refunds on your account. To discuss this and your refund, please contact Customer Services.',
    'account.orders.refund.warning.manualRefund.advance-ticket': 'However, if your train was cancelled or delayed and you decided not to travel because of this we can offer a refund on the unused tickets. The administration fee will be waived. <br /><br /> <p>So, if you decided not to travel because of disruption, please complete our <a target="_blank" class="btn btn-plain" href="https://www.southeasternrailway.co.uk/help-and-contact/get-in-touch/refunds">refund form <i class="otrl otrl-externallink otrl-inline"></i></a> and return it along with your tickets to the freepost address.</p> <p>If there was another reason you couldn’t travel due to exceptional circumstances, please upload a copy of your unused ticket to our <a target="_blank" class="btn btn-plain" href="https://www.southeasternrailway.co.uk/help-and-contact/get-in-touch/contact-us">contact us form <i class="otrl otrl-externallink otrl-inline"></i></a> with a brief explanation and any supporting documentation. We’ll happily consider a refund for you.</p>',
    'account.orders.refund.warning.manualRefund': '<ul><li>If you have a smart ticket on the <{global.key}> - please complete <a href="https://www.southeasternrailway.co.uk/the-key-online-ticket-refund" target="_blank">this refund form</a>.</li><li>If you have a paper ticket - please complete <a href="https://www.southeasternrailway.co.uk/help-and-contact/get-in-touch/refunds" target="_blank">this refund form</a>.</li><li>If you have an eTicket - please complete <a href="https://www.southeasternrailway.co.uk/help-and-contact/get-in-touch/refunds" target="_blank">this refund form</a>.</li></ul>',
    'account.orders.refund.itso.sticket.warning': 'Sorry this ticket doesn’t have enough remaining validity to be eligible for a refund.',
    'account.orders.refund.itso.sticket.contact': '<p>Please contact our Customer Services team if you need refund support.</p><p>See <a target="_blank" class="btn btn-plain" href="https://www.southeasternrailway.co.uk/help-and-contact/get-in-touch/refunds">refund form <i class="otrl otrl-externallink otrl-inline"></i></a> for more details.</p>',

    'account.orders.changeover.originalSeasonTicket': 'Original season ticket',
    'account.orders.changeover.newSeasonTicket': 'New season ticket',
    'account.orders.changeover.daysRemaining': 'Days remaining',
    'account.orders.changeover.creditRemaining': 'Credit remaining on season ticket',
    'account.orders.changeover.amountDue': 'Amount due for new season ticket',
    'account.orders.changeover.totalAmount': 'Total amount',

    'confirmation.loadTickets.app': 'Use the Southeastern app to load ticket(s) to your <{global.key}> <{global.smartcard}> instantly.',
    'confirmation.loadTickets.station': 'Alternatively, please allow a minimum of two hours after purchase to load the ticket(s) at a gate reader or validator at {location}.',
    'confirmation.smartcardNormal': 'Use the Southeastern mobile app to load your purchase(s) to your <{global.key}> <{global.smartcard}>(s) now. Alternatively, please allow a minimum of two hours after purchase to load your ticket(s) at a gate reader or validator at {location}.',
    'confirmation.delayRepayInfo.message': 'If you arrive 15 minutes or more late at your destination because of a delay or cancellation to a Southeastern service, you can claim Delay Repay compensation. Delay Repay is a national scheme train companies use to compensate passengers for delays or cancellations. Claims can be made up to 28 days after your journey.',
    'order.details.smartcard': 'Use the Southeastern mobile app to load your purchase(s) to your <{global.key}> <{global.smartcard}>(s) now. Alternatively, please allow a minimum of two hours after purchase to load your ticket(s) at a gate reader or validator at {location}.',
    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the Southeastern app.',

    'pageTitles.daysave-search': 'Find SuperSaturday tickets',
    'otherTickets.daySave.title': 'SuperSaturday',
    'daySave.results.heading': 'SuperSaturday tickets',
    'daySave.results.no-results.text': 'Sorry, there were no SuperSaturday tickets found that match your search. Please try a different date or origin station.',
    'booking.basket.help.select-day-save-fare': 'To continue, you need to select a SuperSaturday ticket',
    'ariaLabel.openDaySaveTicketSearch': 'Open SuperSaturday tickets search form',
    'itso.typ22.ptyp28': 'SuperSaturday',
    'account.orders.refund.itso.moreInfo': 'More information about your refund',
    'alertmessage.registration.failed.emailInUse': 'Registration failed - this account already exists. Please log in or enter a different email address',
    'alertmessage.paymentRegistration.failed.emailInUse': 'An account with the same email address already exists. Please log in or enter a different email address',
    'booking.delivery.smartcardUnavailable': '<{global.key}> <{global.smartcard}> unavailable (<a target= "_blank" href="https://www.southeasternrailway.co.uk/help-and-contact/help/faqs/the-key">FAQ</a>)',
    'booking.delivery.loadingdate.info.short': 'Load your tickets onto your <{global.key}> <{global.smartcard}> instantly using our app',
    'booking.delivery.loadingdate.info.part11Only': 'Load your tickets onto your <{global.key}> <{global.smartcard}>',
    'booking.fareDetails.refunds.advanceTicket': "Advance fares are valid only on the date and time shown on the ticket. Advance tickets are non-refundable but may be amended prior to the date and time of travel, subject to a £10 administration fee per ticket.<br><br>If your journey is cancelled or disrupted, arrangements will be made to accommodate you on another train. If the train you purchased a ticket for is cancelled or delayed, and as a result you decide not to travel, a full refund will be available, and you will not be charged an administration fee.",
    'delivery.smartcard.firstBenefit': 'Buy and download your tickets at home, fast-track through the station and avoid the queues.',
    'delivery.smartcard.secondBenefit': 'The <{global.key}> won’t wear out like paper tickets. It’s also wipeable and easy to clean.',
    'delivery.smartcard.thirdBenefit': 'If your <{global.key}> is lost or stolen, we’ll block it and replace for free.',
    'delivery.smartcard-passengers.instruction': 'Ticket(s) must be loaded onto each <{global.key}> <{global.smartcard}> before travel',
    'smartSelfRegistration.cta.title': '<{global.theKey}> is our contactless smartcard which means you can buy and download single, return and season tickets at home, fast-track through the station and avoid the queues. Find out more about <{global.key}> <{global.smartcard}> <a target="_blank" href="https://www.southeasternrailway.co.uk/help-and-contact/help/faqs/the-key">here</a>.',
    'delayrepay.help.smartcardNumber': 'Your <{global.smartcardUppercase}> number can be found in the centre of your <{global.key}> <{global.smartcardUppercase}>.',

    'inApp.iOSUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://apps.apple.com/gb/app/southeastern-on-track-uk-train-times-and-tickets/id783634895">Update now</a>',
    'inApp.AndroidUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://play.google.com/store/apps/details?id=com.southeastern.ontrack&hl=en">Update now</a>',

    'ontrackapp.widget.title': 'The new Southeastern app is here',
    'ontrackapp.widget.desc': 'Plan your journey with confidence with our new app.',

    'flexi.londonFaresWarning': 'Flexi Season tickets are not available for journeys between two stations within the London Travelcard Zones 1-9',
    'flexi.account.validityInfo': 'Passes must all be used on or before the expiry date. Any unused passes that are remaining beyond this validity date will not be able to be refunded',
    'account.smartcard.text.address': 'Your new Key card will be posted to the following address. If this is not correct, please update your address below before submitting your new Key card request.',
    'account.smartcard.text.declaration': 'I understand that when I submit my request, my current Key will be blocked immediately and any tickets on the smartcard can no longer be used. My new Key will arrive in the post ready to use with my valid tickets preloaded. I will have to buy separate tickets to travel until I receive my new Key and may be eligible to a refund on these as per the refund policy.',
    'account.smartcard.text.replacementReason.LOST': 'Card lost/stolen',

    'refundWidget.field.surrenderDate': 'Date ticket surrendered',
    'order.details.todWithAnyCard': 'To collect your tickets at {stationName}, bring any payment card and your collection reference. A debit or credit payment card is required as identification when collecting tickets bought via PayPal. Payment cards presented on collection are only for identification purposes and will not be charged.',

    'account.nav.orders-refunds': 'Order history and refunds',
    'account.nav.auto-delay-repay': 'Auto Delay Repay',
    'account.nav.one-click-delay-repay': 'One Click Delay Repay',
    'account.nav.reservations': 'Reservations',
    'account.nav.smartcard.replacement': '<{global.theKey}> - Replacement',
    'account.nav.smartcard.tickets': '<{global.theKey}> Tickets',
    'account.nav.smartcard.journeyhistory': '<{global.theKey}> Journey History',

    'auto-dr.account.info': 'One Click Delay Repay is a quicker and easier way to claim compensation if your journey has been delayed. It\u2019s available to all our sTicket customers, Key Smartcard customers, and anyone who buys an eTicket or a paper Advance ticket through our website or app, when travelling on the Southeastern network.\nIf you\u2019ve been delayed by 15 minutes or more, we will automatically create a Delay Repay claim for you, which you can submit in just One Click. We calculate the delay based on when you tap in and out with your Key Smartcard or scan an eTicket / sTicket barcode, compared to how long the journey should have taken. If it isn\u2019t possible to tap or scan in and out at both stations, you can save your regular journeys to help make sure you receive a One Click Delay Repay claim if you\u2019re delayed.\nWe will then send you the pre-filled claim by email or through the Southeastern app, or you can log into your account to check and submit to us in just One Click.',

    'auto-dr.account.help-title': 'What is One Click Delay Repay?',
    'auto-dr.account.help-review': 'Please be aware that your regular journeys may change when a new timetable comes into effect. Please review your saved journeys regularly.',
    'auto-dr.account.modal-description': 'What is One Click Delay Repay?',
    'auto-dr.claims.no-claims': 'You have no pending One Click Delay Repay claims.',
    'auto-dr.account.unsubscribed': 'You are not currently subscribed to the One Click Delay Repay service',
    'auto-dr.account.subscribed': 'We will alert you at {emailAddress} when we generate a new One Click Delay Repay claim',

    'auto-dr.subscribe.info': 'If you’re delayed by 15 minutes or more on the Southeastern network, you can claim Delay Repay in just One Click.\nWe will automatically create a Delay Repay claim for you. We can send you the claim by email or through the Southeastern app, or you can log into your account to check. To receive your compensation, all you have to do is confirm the journey details and we’ll take care of the rest.\nOne Click is available to all our Key smartcard customers and anyone who buys an sTicket, eTicket or paper Advance ticket through our website or app.\nPlease be aware that your regular journeys may change when a new timetable comes into effect. Please review your saved journeys regularly.',
    'auto-dr.postRegistrationSignUp.info': 'One Click Delay Repay is a quicker and easier way to claim compensation if your journey has been delayed. It is available to all our sTicket customers and Key smartcard customers. \nIf we think you’ve been delayed by 15 minutes or more we will automatically create a Delay Repay claim for you. We can send you the claim by email or through the Southeastern app, or you can log into your account to check. To receive your compensation, all you have to do is confirm the journey details and we’ll take care of the rest.',

    'one-click-delay-repay.optIn.success.copy': 'If you have a Key Smartcard ticket or travel with eTickets, please tell us your regular journeys to help us determine which trains you travel on. Just click the “Add journey” button below.\nPlease remember to tap in and out where possible with your Key Smartcard or scan your eTicket barcode, as we will need to see at least one tap or scan to see you’ve travelled.\nIf you have an Advance ticket, please travel on the train you’ve booked for. If it’s delayed by 15 minutes or more, we’ll notify you of a One Click claim.\nPlease be aware that your regular journeys may change when a new timetable comes into effect. Please review your saved journeys regularly.'

});

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for southern
 */

module.exports = new _immutable.Map({
    'app.owner': 'Southern Railway',
    'app.owner.toc': 'SN',
    'app.owner.short': 'Southern',
    'app.owner.appName': 'Southern',
    'delayrepay.text.successConfirmation': 'Thank you for submitting your delay repay claim. An acknowledgement will be sent within the next few days.',

    'delivery.royal-mail-signed-for-1st-class.detail': '<p>We now offer this service free for bookings over \xA3100.</p><p>For bookings less than \xA3100 you can select this delivery option for a cost of \xA32.50, it offers:</p><ul><li>Proof of postage.</li><li>Signature on delivery.</li><li>Online confirmation of delivery.</li></ul><p>Please note, we are unable to guarantee next day delivery, if this is a requirement then we recommend you use the Next Day Special Delivery option.</p><p>Don\u2019t forget you\n                                                        can get your tickets for free if you purchase them on the <{global.key}> <{global.smartcard}> or collect from a ticket vending machine at a station.</p>',
    'account.nav.smartcard.replacement': '<{global.key}> <{global.smartcard}> replacement',
    'account.nav.smartcard.tickets': '<{global.key}> <{global.smartcard}> tickets',
    'account.nav.smartcard.journeyhistory': '<{global.key}> <{global.smartcard}> journey history',
    'account.smartcardsignup.children.requirements': 'Once the photograph has been approved, you will receive email confirmation. To complete the registration process you will also be requested to submit an age verification document such as copy of the child’s passport or birth certificate which should be submitted at any {brand} <{global.key}> <{global.smartcard}> valid station. Once this is done a new <{global.key}> <{global.smartcard}> will be issued to the address registered within <{global.theKey}> <{global.smartcard}> account.',
    'account.smartcard.transfer.searchSupport': 'For any <{global.key}> <{global.smartcard}> queries please contact Customer Services on {smartcardPhoneNumber} (calls charged at local rate and may be recorded)',
    'account.smartcard.transfer.searchResultsHeading': 'We found the following paper season {count, plural, =1{ticket} other{tickets}} which are eligible for transfer onto your new <{global.key}> <{global.smartcard}>, please select {count, plural, =1{} other {the one you would like to transfer, and}} a collection station:',
    'smartcardCTA.message.keyGo': '{keygobrand} allows you to use your <{global.key}> <{global.smartcard}> much like Pay As You Go Oyster.{br} It works by charging your online account the best value ticket for the journeys you made that day.',
    'account.smartcardstatus.pendingSmartcard': 'Your application for a <{global.key}> <{global.smartcard}> is being processed.',
    'account.register.partialSuccessMessage': 'Your account has been registered, and you are now logged in. Please try to apply for a <{global.key}> <{global.smartcard}> in the Account section, or contact customer services if the problem persists.',
    'account.heading.smartcard.tickets': '<{global.theKey}> <{global.smartcard}> - tickets',
    'account.linkorder.error.message.customerservices': 'If you are still having problems, please contact Customer Services on 03451 27 29 20',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.orders.refund.refundForm': '{url}',
    'booking.delivery.smartcardUnavailable': '<{global.key}> <{global.smartcard}> unavailable (<a target= "_blank" href="https://www.southernrailway.com/help-and-support/contact-us/faqs/the-key-smartcard">FAQ</a>)',
    'booking.delivery.loadingdate.info': 'Please allow a minimum of two hours after purchase before loading your ticket onto your <{global.key}> <{global.smartcard}> or use the <{app.owner.short}> On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',
    'booking.delivery.smartcard.modal.body': 'Using the Southern On Track mobile app, load your ticket straight onto your <{global.key}> <{global.smartcard}> by simply tapping the <{global.smartcard}> onto the back of your phone 15 minutes after purchase.',
    'smartSelfRegistration.cta.title': 'The <{global.key}> <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets. Find out more about <{global.key}> <{global.smartcard}> <a target="_blank" href="https://www.southernrailway.com/tickets/the-key-smartcard">here</a>.',

    'inApp.iOSUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://apps.apple.com/gb/app/southern-on-track/id779618917">Update now</a>',
    'inApp.AndroidUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://play.google.com/store/apps/details?id=com.southern.ontrack&hl=en">Update now</a>',

    'flexi.londonFaresWarning': 'Flexi Season tickets are not available for journeys between two stations within the London Travelcard Zones 1-6',

    'confirmation.smartcardNormal': 'Place your <{global.key}> <{global.smartcard}> on the gate reader or validator at {location} to load your ticket. Please allow a minimum of two hours after purchase before loading your ticket or use the Southern On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',
    'order.details.smartcard': 'Place your <{global.key}> <{global.smartcard}> on the gate reader or validator at {location} to load your ticket. Please allow a minimum of two hours after purchase before loading your ticket or use the Southern On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',

    'account.smartcard.text.address': 'your new Smartcard will be posted to the following address. If this address is not correct, please update your address before requesting a new Smartcard.',
    'account.nav.disruptionAlerts': 'Disruption alerts',
    'rewardPoints.information.acknowledgment': 'Thank you for booking directly through Southern.',
    'rewardPoints.modal.howToGet': 'You can earn 3 points for every £1 you spend on Anytime, Flexi Season and Season tickets bought directly from the Southern Railway website and fulfilled using an eTicket or Key Smartcard, until 31st March 2023 (T’s and C’s apply).',
    'delivery.sticket.details': '\n        <p>sTicket is a digital version of a Season ticket provided as a QR code. It is instantly available to download and accessed through the Southern app. No need to wait for an email or queue at the station.</p>\n        <p>Scan the QR code at the station ticket gate (where barcode scanners are available) or show to staff when asked.</p>\n        <p>If you\u2019re buying on behalf of another person, please do so from their account or select a different collection method.</p>\n        <p>Please note: sTickets are not accepted on London Underground services.</p>',

    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the Southern app.',

    'ontrackapp.widget.title': 'Meet the {brand} App'
});

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for thameslink
 */

module.exports = new _immutable.Map({
    'app.owner': 'Thameslink Railway',
    'app.owner.toc': 'TL',
    'app.owner.short': 'Thameslink',
    'app.owner.appName': 'Thameslink',
    'delayrepay.text.successConfirmation': 'Thank you for submitting your delay repay claim. An acknowledgement will be sent within the next few days.',

    'delivery.royal-mail-signed-for-1st-class.detail': '<p>We now offer this service free for bookings over \xA3100.</p><p>For bookings less than \xA3100 you can select this delivery option for a cost of \xA32.50, it offers:</p><ul><li>Proof of postage.</li><li>Signature on delivery.</li><li>Online confirmation of delivery.</li></ul><p>Please note, we are unable to guarantee next day delivery, if this is a requirement then we recommend you use the Next Day Special Delivery option.</p><p>Don\u2019t forget you\n                                                        can get your tickets for free if you purchase them on the <{global.key}> <{global.smartcard}> or collect from a ticket vending machine at a station.</p>',
    'account.nav.smartcard.replacement': '<{global.key}> <{global.smartcard}> replacement',
    'account.nav.smartcard.tickets': '<{global.key}> <{global.smartcard}> tickets',
    'account.nav.smartcard.journeyhistory': '<{global.key}> <{global.smartcard}> journey history',
    'account.smartcardsignup.children.requirements': 'Once the photograph has been approved, you will receive email confirmation. To complete the registration process you will also be requested to submit an age verification document such as copy of the child’s passport or birth certificate which should be submitted at any {brand} <{global.key}> <{global.smartcard}> valid station. Once this is done a new <{global.key}> <{global.smartcard}> will be issued to the address registered within <{global.theKey}> <{global.smartcard}> account.',
    'account.smartcard.transfer.searchSupport': 'For any <{global.key}> <{global.smartcard}> queries please contact Customer Services on {smartcardPhoneNumber} (calls charged at local rate and may be recorded)',
    'account.smartcard.transfer.searchResultsHeading': 'We found the following paper season {count, plural, =1{ticket} other{tickets}} which are eligible for transfer onto your new <{global.key}> <{global.smartcard}>, please select {count, plural, =1{} other {the one you would like to transfer, and}} a collection station:',
    'smartcardCTA.message.keyGo': '{keygobrand} allows you to use your <{global.key}> <{global.smartcard}> much like Pay As You Go Oyster.{br} It works by charging your online account the best value ticket for the journeys you made that day.',
    'account.smartcardstatus.pendingSmartcard': 'Your application for a <{global.key}> <{global.smartcard}> is being processed.',
    'account.register.partialSuccessMessage': 'Your account has been registered, and you are now logged in. Please try to apply for a <{global.key}> <{global.smartcard}> in the Account section, or contact customer services if the problem persists.',
    'account.heading.smartcard.tickets': '<{global.theKey}> <{global.smartcard}> - tickets',
    'account.linkorder.error.message.customerservices': 'If you are still having problems, please contact Customer Services on 0345 026 4700',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.orders.refund.refundForm': '{url}',
    'booking.delivery.smartcardUnavailable': '<{global.key}> <{global.smartcard}> unavailable (<a target= "_blank" href="https://www.thameslinkrailway.com/help-and-support/contact-us/faqs/the-key-smartcard">FAQ</a>)',
    'booking.delivery.loadingdate.info': 'Please allow a minimum of two hours after purchase before loading your ticket onto your <{global.key}> <{global.smartcard}> or use the <{app.owner.short}> On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',
    'booking.delivery.smartcard.modal.body': 'Using the Thameslink On Track mobile app, load your ticket straight onto your <{global.key}> <{global.smartcard}> by simply tapping the <{global.smartcard}> onto the back of your phone 15 minutes after purchase.',
    'smartSelfRegistration.cta.title': 'The <{global.key}> <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets. Find out more about <{global.key}> <{global.smartcard}> <a target="_blank" href="https://www.thameslinkrailway.com/tickets/the-key-smartcard">here</a>.',

    'inApp.iOSUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://apps.apple.com/us/app/thameslink-on-track/id908805038">Update now</a>',
    'inApp.AndroidUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://play.google.com/store/apps/details?id=com.thameslinkgreatnorthern.ontrack&hl=en">Update now</a>',

    'flexi.londonFaresWarning': 'Flexi Season tickets are not available for journeys between two stations within the London Travelcard Zones 1-6',

    'confirmation.smartcardNormal': 'Place your <{global.key}> <{global.smartcard}> on the gate reader or validator at {location} to load your ticket. Please allow a minimum of two hours after purchase before loading your ticket or use the Thameslink On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',
    'order.details.smartcard': 'Place your <{global.key}> <{global.smartcard}> on the gate reader or validator at {location} to load your ticket. Please allow a minimum of two hours after purchase before loading your ticket or use the Thameslink On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',

    'account.smartcard.text.address': 'your new Smartcard will be posted to the following address. If this address is not correct, please update your address before requesting a new Smartcard.',

    'account.nav.disruptionAlerts': 'Disruption alerts',

    'delivery.sticket.details': '\n        <p>sTicket is a digital version of a Season ticket provided as a QR code. It is instantly available to download and accessed through the Thameslink app. No need to wait for an email or queue at the station.</p>\n        <p>Scan the QR code at the station ticket gate (where barcode scanners are available) or show to staff when asked.</p>\n        <p>If you\u2019re buying on behalf of another person, please do so from their account or select a different collection method.</p>\n        <p>Please note: sTickets are not accepted on London Underground services.</p>',

    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the Thameslink app.',

    'ontrackapp.widget.title': 'Meet the {brand} App'
});

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for greatnorthern
 */

module.exports = new _immutable.Map({
    'app.owner': 'Great Northern Rail',
    'app.owner.toc': 'GN',
    'app.owner.short': 'Great Northern',
    'app.owner.appName': 'Great Northern',
    'delayrepay.text.successConfirmation': 'Thank you for submitting your delay repay claim. An acknowledgement will be sent within the next few days.',

    'delivery.royal-mail-signed-for-1st-class.detail': '<p>We now offer this service free for bookings over \xA3100.</p><p>For bookings less than \xA3100 you can select this delivery option for a cost of \xA32.50, it offers:</p><ul><li>Proof of postage.</li><li>Signature on delivery.</li><li>Online confirmation of delivery.</li></ul><p>Please note, we are unable to guarantee next day delivery, if this is a requirement then we recommend you use the Next Day Special Delivery option.</p><p>Don\u2019t forget you\n                                                          can get your tickets for free if you purchase them on the <{global.key}> <{global.smartcard}> or collect from a ticket vending machine at a station.</p>',
    'account.nav.smartcard.replacement': '<{global.key}> <{global.smartcard}> replacement',
    'account.nav.smartcard.tickets': '<{global.key}> <{global.smartcard}> tickets',
    'account.nav.smartcard.journeyhistory': '<{global.key}> <{global.smartcard}> journey history',
    'account.smartcardsignup.children.requirements': 'Once the photograph has been approved, you will receive email confirmation. To complete the registration process you will also be requested to submit an age verification document such as copy of the child’s passport or birth certificate which should be submitted at any {brand} <{global.key}> <{global.smartcard}> valid station. Once this is done a new <{global.key}> <{global.smartcard}> will be issued to the address registered within <{global.theKey}> <{global.smartcard}> account.',
    'account.smartcard.transfer.searchSupport': 'For any <{global.key}> <{global.smartcard}> queries please contact Customer Services on {smartcardPhoneNumber} (calls charged at local rate and may be recorded)',
    'account.smartcard.transfer.searchResultsHeading': 'We found the following paper season {count, plural, =1{ticket} other{tickets}} which are eligible for transfer onto your new <{global.key}> <{global.smartcard}>, please select {count, plural, =1{} other {the one you would like to transfer, and}} a collection station:',
    'smartcardCTA.message.keyGo': '{keygobrand} allows you to use your <{global.key}> <{global.smartcard}> much like Pay As You Go Oyster.{br} It works by charging your online account the best value ticket for the journeys you made that day.',
    'account.smartcardstatus.pendingSmartcard': 'Your application for a <{global.key}> <{global.smartcard}> is being processed.',
    'account.register.partialSuccessMessage': 'Your account has been registered, and you are now logged in. Please try to apply for a <{global.key}> <{global.smartcard}> in the Account section, or contact customer services if the problem persists.',
    'account.heading.smartcard.tickets': '<{global.theKey}> <{global.smartcard}> - tickets',
    'account.linkorder.error.message.customerservices': 'If you are still having problems, please contact Customer Services on 0345 026 4700',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.orders.refund.refundForm': '{url}',
    'booking.delivery.smartcardUnavailable': '<{global.key}> <{global.smartcard}> unavailable (<a target= "_blank" href="https://www.greatnorthernrail.com/help-and-support/contact-us/faq/the-key-smartcard">FAQ</a>)',
    'booking.delivery.loadingdate.info': 'Please allow a minimum of two hours after purchase before loading your ticket onto your <{global.key}> <{global.smartcard}> or use the Great Northern On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',
    'booking.delivery.smartcard.modal.body': 'Using the Great Northern On Track mobile app, load your ticket straight onto your <{global.key}> <{global.smartcard}> by simply tapping the <{global.smartcard}> onto the back of your phone 15 minutes after purchase.',
    'smartSelfRegistration.cta.title': 'The <{global.key}> <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets. Find out more about <{global.key}> <{global.smartcard}> <a target="_blank" href="https://www.greatnorthernrail.com/tickets/the-key-smartcard">here</a>.',

    'inApp.iOSUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://apps.apple.com/us/app/thameslink-on-track/id908805038">Update now</a>',
    'inApp.AndroidUpdateMessage': 'To continue buying online tickets you need to update the app to the latest version.<a class="app-update-cta" href="https://play.google.com/store/apps/details?id=com.thameslinkgreatnorthern.ontrack&hl=en">Update now</a>',

    'confirmation.smartcardNormal': 'Place your <{global.key}> <{global.smartcard}> on the gate reader or validator at {location} to load your ticket. Please allow a minimum of two hours after purchase before loading your ticket or use the Great Northern On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',
    'order.details.smartcard': 'Place your <{global.key}> <{global.smartcard}> on the gate reader or validator at {location} to load your ticket. Please allow a minimum of two hours after purchase before loading your ticket or use the Great Northern On Track mobile app to load your ticket to your <{global.key}> <{global.smartcard}> 15 minutes after purchase.',

    'flexi.londonFaresWarning': 'Flexi Season tickets are not available for journeys between two stations within the London Travelcard Zones 1-6',

    'account.smartcard.text.address': 'your new Smartcard will be posted to the following address. If this address is not correct, please update your address before requesting a new Smartcard.',

    'account.nav.disruptionAlerts': 'Disruption alerts',
    'delivery.sticket.details': '\n        <p>sTicket is a digital version of a Season ticket provided as a QR code. It is instantly available to download and accessed through the Great Northern app. No need to wait for an email or queue at the station.</p>\n        <p>Scan the QR code at the station ticket gate (where barcode scanners are available) or show to staff when asked.</p>\n        <p>If you\u2019re buying on behalf of another person, please do so from their account or select a different collection method.</p>\n        <p>Please note: sTickets are not accepted on London Underground services.</p>',

    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the Great Northern app.',

    'ontrackapp.widget.title': 'Meet the {brand} App'
});

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for ontrack retail
 */

module.exports = new _immutable.Map({
    'app.owner': 'OnTrack Retail',
    'app.owner.short': 'OnTrack',
    'preference-centre.privacy-notice': 'We will not pass on your personal information to any organisation outside of <{app.owner.short}>.',
    'alertmessage.registration.failed.emailInUse': 'Registration failed - this account already exists. Please log in or enter a different email address',
    'alertmessage.paymentRegistration.failed.emailInUse': 'An account with the same email address already exists. Please log in or enter a different email address'
});

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for Ticketyboo
 */

module.exports = new _immutable.Map({
    'app.owner': 'TicketyBoo',
    'app.owner.short': 'TicketyBoo',
    'app.owner.appName': 'TicketyBoo',

    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.orders.refund.warning.manualRefund.contactUs': 'Frequently Asked Questions',

    'alertmessage.registration.failed.emailInUse': 'You already have an account with TicketyBoo. Please log in or use a different email address.',
    'alertmessage.paymentRegistration.failed.emailInUse': 'An account with the same email address already exists. Please log in or enter a different email address',

    'booking.delivery.loadingdate.download': 'Download the TicketyBoo app to load your ticket instantly',

    'booking.usp.noBookingFees.banner': 'No fees, No faff',
    'booking.usp.noBookingFees.inline': 'No fees, No faff',

    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the TicketyBoo app.',

    'ontrackapp.widget.title': 'The new TicketyBoo app is here',

    'refundWidget.field.surrenderDate': 'Date ticket surrendered',

    'preference-centre.promotions': 'TicketyBoo promotions, rewards and offers',

    'preference-centre.privacy-notice': 'We will not pass on your personal information to any organisation outside of <{app.owner.short}>.',

    'preference-centre.privacy-notice.more': '_',
    'preference-centre.privacy-notice.extra': '_'
});

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for transpennine
 */

module.exports = new _immutable.Map({
    'app.owner': 'TransPennine Express',
    'app.owner.toc': 'TPE',
    'app.owner.short': 'TransPennine Express',
    'app.owner.appName': 'TransPennine Express',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.nav.reservations': 'Reservations',

    'login.username': 'Email address',
    'customerdetails.email': 'Email address',
    'promotion.tocFamily.email.label': 'Email address',

    'ontrackapp.widget.title': 'Meet the {brand} App',

    'preference-centre.privacy-notice': '_',
    'preference-centre.privacy-notice.more': '_',
    'preference-centre.privacy-notice.extra': '_',

    'alertmessage.registration.failed.emailInUse': 'You already have an account with TransPennine Express. Please log in or use a different email address.',
    'booking.delivery.notAvailable.paper': 'Sorry. There are no collection or delivery options available for your order. This may be because you are attempting to buy a paper ticket within { todCollectionMinimumTime } of your time of departure. It may also be because you have bike reservations and the only available delivery method is eTicket.',
    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the TransPennine Express app.',

    'account.nav.smartcard.key-tickets': 'Smart Tickets',
    'account.nav.smartcard': 'Your <{global.smartcard}>',
    'account.nav.smartcard.replacement': '<{global.smartcard}> replacement',
    'account.nav.smartcard.tickets': 'Your Smart tickets',
    'account.nav.smartcard.journeyhistory': 'Your Smart journeys',
    'account.register.withoutSmartcard': 'Continue without registering for a <{global.smartcard}>',
    'account.register.withoutSmartcardAndKeygo': 'Continue without registering for a <{global.smartcard}> and <{global.keyGo}>',
    'account.register.withPaperTransfers.details': 'Transfer a current paper season to a <{global.smartcard}>',
    'account.register.steps.smartcard': '<{global.smartcard}>',
    'account.register.smartcard.labelLong': 'Get a <{global.smartcard}>',
    'account.register.smartcard.labelShort': 'Get a <{global.smartcard}>',
    'account.register.smartcard.title': 'Get a<br /> <{global.smartcard}><br />with your account',
    'account.register.smartcard.title-mobile': 'Get a <{global.smartcard}><br />with your account',
    'account.register.smartcard.body': 'Our <{global.smartcard}> is a smarter alternative to paper tickets, making it quicker and easier to buy a ticket.',
    'account.confirm.smartcardsignup': 'Get a <{global.smartcard}> with my account',
    'account.smartcardsignup.keygoSignUp': 'Get a <{global.smartcard}> and <{global.keyGo}> with my account',
    'account.smartcardsignup.readmore': 'Find out more about a <{global.smartcard}>',
    'account.smartcardsignup.details': 'A <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets.',
    'account.heading.smartcard.apply': 'Apply for a <{global.smartcard}>',
    'account.heading.smartcard.register': 'Register a <{global.smartcard}>',
    'account.heading.smartcard.status': '<{global.smartcard}> status',
    'account.heading.smartcard.tickets': '<{global.smartcard}> tickets',
    'account.heading.smartcard.journeyhistory': '<{global.smartcard}> - journey history',
    'account.heading.smartcard.incompletejourneys': '<{global.smartcard}> incomplete journeys',
    'account.heading.smartcard.activetickets': '<{global.smartcard}> tickets available to use',
    'account.heading.smartcard.pendingtickets': 'Tickets yet to be loaded to your <{global.smartcard}>',
    'booking.delivery.smartcardApply': 'Add to a new <{global.smartcard}> ',
    'booking.delivery.smartcardUnavailable': '<{global.smartcard}> unavailable',
    'booking.delivery.smartcardLoginOrRegister': 'Add to a new, or existing, <{global.smartcard}>',
    'delivery.smartcard.firstBenefit': 'A <{global.smartcard}> won’t wear out like paper tickets',
    'delivery.smartcard.secondBenefit': 'If you lose your <{global.smartcard}>, we’ll send you a replacement free of charge',
    'delivery.the-key-smartcard': 'Load to your <{global.smartcard}>(s)',
    'pageTitles.smartcard-tickets': '<{global.smartcard}> - tickets',
    'pageTitles.smartcard-history': '<{global.smartcard}> - journey history',
    'pageTitles.smartcard-replacement': '<{global.smartcard}> - replacement',
    'account.heading.smartcard.replacement': '<{global.smartcard}> - replacement',
    'booking.dates.errors.smartcardPeriodReturn': 'Only day returns are currently available on a <{global.smartcard}>. Please choose a return time on the same date as your outbound journey',
    'compensation.placeholder.smartcardNumber': '<{global.smartcard}> number',
    'account.smartcard.text.number': '<{global.smartcard}> number',
    'account.smartcard.text.capacity': '<{global.smartcard}> capacity',
    'account.smartcard.text.cardStatus': '<{global.smartcard}> status',
    'account.smartcard.text.cardExpiry': '<{global.smartcard}> expiry',
    'account.heading.smartcard.replacement.request': 'Request a new <{global.smartcard}>',
    'account.smartcard.text.replacement.cancellationWarning': '<p><strong>Please note:</strong> your existing smartcard will be cancelled as soon as your replacement request is submitted.</p>',
    'account.smartcard.text.replacement.success': 'We are processing your request to replace your <{global.smartcard}>.',
    'account.smartcard.text.replacement.warning': 'We are processing your request to replace your <{global.smartcard}>. Information shown here reflects your most recent <{global.smartcard}>. Some information may not be available at this time',
    'account.smartcard.text.replacement.linkText': 'View the progress of your<{global.smartcard}> replacement',
    'account.smartcard.button.completeyourjourney': 'Complete your <{global.smartcard}> journey',
    'account.smartcard.button.replacemycard': 'Request a new <{global.smartcard}>',
    'account.smartcard.text.noactivetickets': 'No <{global.smartcard}> tickets are currently active'
});

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _immutable = __webpack_require__(5);

/**
 * Custom messages for Trainhugger
 */

module.exports = new _immutable.Map({
    'app.owner': 'Trainhugger',
    'app.owner.short': 'Trainhugger',
    'preference-centre.privacy-notice': 'We\'d like to keep you updated about your trees, <{app.owner.short}> projects, your journeys and other relevant information. You can unsubscribe at any time.',
    'alertmessage.registration.failed.emailInUse': 'Registration failed - this account already exists. Please log in or enter a different email address',
    'alertmessage.paymentRegistration.failed.emailInUse': 'An account with the same email address already exists. Please log in or enter a different email address',
    'account.orders.refund.warning.manualRefund': 'For refund options, please visit ',
    'account.orders.refund.refundForm': '{url}',
    'header.welcome': 'Welcome,',
    'account.register.opt.description': 'We’d like to keep you updated about your trees, Trainhugger eco projects, ticket expiries and renewals, and other relevant information. You can unsubscribe at any time.',
    'preference-centre.promotions': 'Yes, I’d like to receive updates about my trees, my journeys and other relevant information.',
    'form.termsAndConditions.capitalised': 'OnTrack Retail\'s Terms & Conditions',
    'form.termsYouAgreeTo': 'By clicking pay you agree to {termsAndConditions} and that the {nationalRailTerms}\n         govern your purchase and the terms of your journey.',
    'button.text.paymentDetailsOthers': 'Back',
    'account.deleteUserModal.information': 'Not having an account with us means it will take longer to complete some actions on our app and website, such as buying a ticket, claiming compensation and getting a refund, and you will no longer receive offers or important updates.',

    'account.nav.disruptionAlerts': 'Disruption alerts'
});

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// Data from https://countrycode.org/customer/countryCode/downloadCountryCodes
// Converted to JS @ https://shancarter.github.io/mr-data-converter/

exports.default = [["Afghanistan", "AFG"], ["Albania", "ALB"], ["Algeria", "DZA"], ["American Samoa", "ASM"], ["Andorra", "AND"], ["Angola", "AGO"], ["Anguilla", "AIA"], ["Antarctica", "ATA"], ["Antigua and Barbuda", "ATG"], ["Argentina", "ARG"], ["Armenia", "ARM"], ["Aruba", "ABW"], ["Australia", "AUS"], ["Austria", "AUT"], ["Azerbaijan", "AZE"], ["Bahamas", "BHS"], ["Bahrain", "BHR"], ["Bangladesh", "BGD"], ["Barbados", "BRB"], ["Belarus", "BLR"], ["Belgium", "BEL"], ["Belize", "BLZ"], ["Benin", "BEN"], ["Bermuda", "BMU"], ["Bhutan", "BTN"], ["Bolivia", "BOL"], ["Bosnia and Herzegovina", "BIH"], ["Botswana", "BWA"], ["Brazil", "BRA"], ["British Indian Ocean Territory", "IOT"], ["British Virgin Islands", "VGB"], ["Brunei", "BRN"], ["Bulgaria", "BGR"], ["Burkina Faso", "BFA"], ["Burundi", "BDI"], ["Cambodia", "KHM"], ["Cameroon", "CMR"], ["Canada", "CAN"], ["Cape Verde", "CPV"], ["Cayman Islands", "CYM"], ["Central African Republic", "CAF"], ["Chad", "TCD"], ["Chile", "CHL"], ["China", "CHN"], ["Christmas Island", "CXR"], ["Cocos Islands", "CCK"], ["Colombia", "COL"], ["Comoros", "COM"], ["Cook Islands", "COK"], ["Costa Rica", "CRI"], ["Croatia", "HRV"], ["Cuba", "CUB"], ["Curacao", "CUW"], ["Cyprus", "CYP"], ["Czech Republic", "CZE"], ["Democratic Republic of the Congo", "COD"], ["Denmark", "DNK"], ["Djibouti", "DJI"], ["Dominica", "DMA"], ["Dominican Republic", "DOM"], ["East Timor", "TLS"], ["Ecuador", "ECU"], ["Egypt", "EGY"], ["El Salvador", "SLV"], ["Equatorial Guinea", "GNQ"], ["Eritrea", "ERI"], ["Estonia", "EST"], ["Ethiopia", "ETH"], ["Falkland Islands", "FLK"], ["Faroe Islands", "FRO"], ["Fiji", "FJI"], ["Finland", "FIN"], ["France", "FRA"], ["French Polynesia", "PYF"], ["Gabon", "GAB"], ["Gambia", "GMB"], ["Georgia", "GEO"], ["Germany", "DEU"], ["Ghana", "GHA"], ["Gibraltar", "GIB"], ["Greece", "GRC"], ["Greenland", "GRL"], ["Grenada", "GRD"], ["Guam", "GUM"], ["Guatemala", "GTM"], ["Guernsey", "GGY"], ["Guinea", "GIN"], ["Guinea-Bissau", "GNB"], ["Guyana", "GUY"], ["Haiti", "HTI"], ["Honduras", "HND"], ["Hong Kong", "HKG"], ["Hungary", "HUN"], ["Iceland", "ISL"], ["India", "IND"], ["Indonesia", "IDN"], ["Iran", "IRN"], ["Iraq", "IRQ"], ["Ireland", "IRL"], ["Isle of Man", "IMN"], ["Israel", "ISR"], ["Italy", "ITA"], ["Ivory Coast", "CIV"], ["Jamaica", "JAM"], ["Japan", "JPN"], ["Jersey", "JEY"], ["Jordan", "JOR"], ["Kazakhstan", "KAZ"], ["Kenya", "KEN"], ["Kiribati", "KIR"], ["Kosovo", "XKX"], ["Kuwait", "KWT"], ["Kyrgyzstan", "KGZ"], ["Laos", "LAO"], ["Latvia", "LVA"], ["Lebanon", "LBN"], ["Lesotho", "LSO"], ["Liberia", "LBR"], ["Libya", "LBY"], ["Liechtenstein", "LIE"], ["Lithuania", "LTU"], ["Luxembourg", "LUX"], ["Macao", "MAC"], ["Macedonia", "MKD"], ["Madagascar", "MDG"], ["Malawi", "MWI"], ["Malaysia", "MYS"], ["Maldives", "MDV"], ["Mali", "MLI"], ["Malta", "MLT"], ["Marshall Islands", "MHL"], ["Mauritania", "MRT"], ["Mauritius", "MUS"], ["Mayotte", "MYT"], ["Mexico", "MEX"], ["Micronesia", "FSM"], ["Moldova", "MDA"], ["Monaco", "MCO"], ["Mongolia", "MNG"], ["Montenegro", "MNE"], ["Montserrat", "MSR"], ["Morocco", "MAR"], ["Mozambique", "MOZ"], ["Myanmar", "MMR"], ["Namibia", "NAM"], ["Nauru", "NRU"], ["Nepal", "NPL"], ["Netherlands", "NLD"], ["Netherlands Antilles", "ANT"], ["New Caledonia", "NCL"], ["New Zealand", "NZL"], ["Nicaragua", "NIC"], ["Niger", "NER"], ["Nigeria", "NGA"], ["Niue", "NIU"], ["North Korea", "PRK"], ["Northern Mariana Islands", "MNP"], ["Norway", "NOR"], ["Oman", "OMN"], ["Pakistan", "PAK"], ["Palau", "PLW"], ["Palestine", "PSE"], ["Panama", "PAN"], ["Papua New Guinea", "PNG"], ["Paraguay", "PRY"], ["Peru", "PER"], ["Philippines", "PHL"], ["Pitcairn", "PCN"], ["Poland", "POL"], ["Portugal", "PRT"], ["Puerto Rico", "PRI"], ["Qatar", "QAT"], ["Republic of the Congo", "COG"], ["Reunion", "REU"], ["Romania", "ROU"], ["Russia", "RUS"], ["Rwanda", "RWA"], ["Saint Barthelemy", "BLM"], ["Saint Helena", "SHN"], ["Saint Kitts and Nevis", "KNA"], ["Saint Lucia", "LCA"], ["Saint Martin", "MAF"], ["Saint Pierre and Miquelon", "SPM"], ["Saint Vincent and the Grenadines", "VCT"], ["Samoa", "WSM"], ["San Marino", "SMR"], ["Sao Tome and Principe", "STP"], ["Saudi Arabia", "SAU"], ["Senegal", "SEN"], ["Serbia", "SRB"], ["Seychelles", "SYC"], ["Sierra Leone", "SLE"], ["Singapore", "SGP"], ["Sint Maarten", "SXM"], ["Slovakia", "SVK"], ["Slovenia", "SVN"], ["Solomon Islands", "SLB"], ["Somalia", "SOM"], ["South Africa", "ZAF"], ["South Korea", "KOR"], ["South Sudan", "SSD"], ["Spain", "ESP"], ["Sri Lanka", "LKA"], ["Sudan", "SDN"], ["Suriname", "SUR"], ["Svalbard and Jan Mayen", "SJM"], ["Swaziland", "SWZ"], ["Sweden", "SWE"], ["Switzerland", "CHE"], ["Syria", "SYR"], ["Taiwan", "TWN"], ["Tajikistan", "TJK"], ["Tanzania", "TZA"], ["Thailand", "THA"], ["Togo", "TGO"], ["Tokelau", "TKL"], ["Tonga", "TON"], ["Trinidad and Tobago", "TTO"], ["Tunisia", "TUN"], ["Turkey", "TUR"], ["Turkmenistan", "TKM"], ["Turks and Caicos Islands", "TCA"], ["Tuvalu", "TUV"], ["U.S. Virgin Islands", "VIR"], ["Uganda", "UGA"], ["Ukraine", "UKR"], ["United Arab Emirates", "ARE"], ["United Kingdom", "GBR"], ["United States", "USA"], ["Uruguay", "URY"], ["Uzbekistan", "UZB"], ["Vanuatu", "VUT"], ["Vatican", "VAT"], ["Venezuela", "VEN"], ["Vietnam", "VNM"], ["Wallis and Futuna", "WLF"], ["Western Sahara", "ESH"], ["Yemen", "YEM"], ["Zambia", "ZMB"], ["Zimbabwe", "ZWE"]];

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    customerId: [_LinkMapper.fields.number],
    email: [_LinkMapper.fields.string],
    created: [_LinkMapper.fields.datetime],
    id: [_LinkMapper.fields.number],
    state: [_LinkMapper.fields.string],
    updated: [_LinkMapper.fields.datetime]
};

var DeactivationRequest = function (_record) {
    (0, _inherits3.default)(DeactivationRequest, _record);

    function DeactivationRequest() {
        (0, _classCallCheck3.default)(this, DeactivationRequest);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DeactivationRequest.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DeactivationRequest, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return DeactivationRequest;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

(0, _assign2.default)(DeactivationRequest.prototype, _ValidationMixin2.default);

exports.default = DeactivationRequest;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Cookies.js - 1.2.3
 * https://github.com/ScottHamper/Cookies
 *
 * This is free and unencumbered software released into the public domain.
 */
(function (global, undefined) {
    'use strict';

    var factory = function (window) {
        if (typeof window.document !== 'object') {
            throw new Error('Cookies.js requires a `window` with a `document` object');
        }

        var Cookies = function (key, value, options) {
            return arguments.length === 1 ?
                Cookies.get(key) : Cookies.set(key, value, options);
        };

        // Allows for setter injection in unit tests
        Cookies._document = window.document;

        // Used to ensure cookie keys do not collide with
        // built-in `Object` properties
        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
        
        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');

        Cookies.defaults = {
            path: '/',
            secure: false
        };

        Cookies.get = function (key) {
            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
                Cookies._renewCache();
            }
            
            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];

            return value === undefined ? undefined : decodeURIComponent(value);
        };

        Cookies.set = function (key, value, options) {
            options = Cookies._getExtendedOptions(options);
            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);

            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);

            return Cookies;
        };

        Cookies.expire = function (key, options) {
            return Cookies.set(key, undefined, options);
        };

        Cookies._getExtendedOptions = function (options) {
            return {
                path: options && options.path || Cookies.defaults.path,
                domain: options && options.domain || Cookies.defaults.domain,
                expires: options && options.expires || Cookies.defaults.expires,
                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
            };
        };

        Cookies._isValidDate = function (date) {
            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
        };

        Cookies._getExpiresDate = function (expires, now) {
            now = now || new Date();

            if (typeof expires === 'number') {
                expires = expires === Infinity ?
                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
            } else if (typeof expires === 'string') {
                expires = new Date(expires);
            }

            if (expires && !Cookies._isValidDate(expires)) {
                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
            }

            return expires;
        };

        Cookies._generateCookieString = function (key, value, options) {
            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
            options = options || {};

            var cookieString = key + '=' + value;
            cookieString += options.path ? ';path=' + options.path : '';
            cookieString += options.domain ? ';domain=' + options.domain : '';
            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
            cookieString += options.secure ? ';secure' : '';

            return cookieString;
        };

        Cookies._getCacheFromString = function (documentCookie) {
            var cookieCache = {};
            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];

            for (var i = 0; i < cookiesArray.length; i++) {
                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);

                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
                }
            }

            return cookieCache;
        };

        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
            var separatorIndex = cookieString.indexOf('=');

            // IE omits the "=" when the cookie value is an empty string
            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;

            var key = cookieString.substr(0, separatorIndex);
            var decodedKey;
            try {
                decodedKey = decodeURIComponent(key);
            } catch (e) {
                if (console && typeof console.error === 'function') {
                    console.error('Could not decode cookie with key "' + key + '"', e);
                }
            }
            
            return {
                key: decodedKey,
                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
            };
        };

        Cookies._renewCache = function () {
            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
            Cookies._cachedDocumentCookie = Cookies._document.cookie;
        };

        Cookies._areEnabled = function () {
            var testKey = 'cookies.js';
            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
            Cookies.expire(testKey);
            return areEnabled;
        };

        Cookies.enabled = Cookies._areEnabled();

        return Cookies;
    };
    var cookiesExport = (global && typeof global.document === 'object') ? factory(global) : factory;

    // AMD support
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return cookiesExport; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    // CommonJS/Node.js support
    } else if (typeof exports === 'object') {
        // Support Node.js specific `module.exports` (which can be a function)
        if (typeof module === 'object' && typeof module.exports === 'object') {
            exports = module.exports = cookiesExport;
        }
        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
        exports.Cookies = cookiesExport;
    } else {
        global.Cookies = cookiesExport;
    }
})(typeof window === 'undefined' ? this : window);

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RefreshTokenError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefreshTokenError = exports.RefreshTokenError = function (_ExtendableError) {
    (0, _inherits3.default)(RefreshTokenError, _ExtendableError);

    function RefreshTokenError() {
        (0, _classCallCheck3.default)(this, RefreshTokenError);

        var _this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call(this));

        _this.name = 'RefreshTokenError';


        _this.message = 'Refresh token error';
        return _this;
    }

    return RefreshTokenError;
}(_ExtendableError3.default);

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    name: null,
    message: null
};

var JourneyNotification = function (_record) {
    (0, _inherits3.default)(JourneyNotification, _record);

    function JourneyNotification() {
        (0, _classCallCheck3.default)(this, JourneyNotification);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    JourneyNotification.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(JourneyNotification, json, {
            id: _LinkMapper.fields.number,
            name: _LinkMapper.fields.string,
            message: _LinkMapper.fields.string
        });
    };

    return JourneyNotification;
}((0, _immutable.Record)(defaults));

exports.default = JourneyNotification;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _a11y = __webpack_require__(1611);

var _a11y2 = _interopRequireDefault(_a11y);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = false;
var a11y = function a11y() {
    for (var _len = arguments.length, opts = Array(_len), _key = 0; _key < _len; _key++) {
        opts[_key] = arguments[_key];
    }

    if (instance) {
        throw new Error('react-a11y is already installed');
    } else {
        instance = new (Function.prototype.bind.apply(_a11y2.default, [null].concat(opts)))();
    }
};

a11y.restoreAll = function () {
    if (instance) {
        // restore handlers
        instance.restoreAll();

        // remove instance
        instance = false;
    }
};

exports.default = a11y;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _after = __webpack_require__(1612);

var _after2 = _interopRequireDefault(_after);

var _options2 = __webpack_require__(1613);

var _options3 = _interopRequireDefault(_options2);

var _browser = __webpack_require__(812);

var _browser2 = _interopRequireDefault(_browser);

var _test = __webpack_require__(1625);

var _test2 = _interopRequireDefault(_test);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var A11y = function () {

    /**
     * @arg {object} React    - The React instance you want to patch
     * @arg {object} ReactDOM - The ReactDOM instance you'll be using
     * @arg {object} options  - the options
     * @returns {A11y} The react-a11y instance
     */
    function A11y() {
        (0, _classCallCheck3.default)(this, A11y);

        var _validate = _options3.default.apply(undefined, arguments),
            React = _validate.React,
            ReactDOM = _validate.ReactDOM,
            options = (0, _objectWithoutProperties3.default)(_validate, ['React', 'ReactDOM']);

        this.options = options;
        this.React = React;
        this.ReactDOM = ReactDOM;
        this.suite = new _test2.default(React, ReactDOM, this.options);
        this.patchReact();
    }

    /**
     * Patch React, replacing its createElement by our implementation
     * so we can run the tests
     * @returns {undefined}
     */


    (0, _createClass3.default)(A11y, [{
        key: 'patchReact',
        value: function patchReact() {
            // save old createElement
            this._createElement = this.React.createElement;

            var _this = this;
            this.React.createElement = function (klass) {
                var _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                // fix for props = null
                var props = _props || {};

                // create a refs object to hold the ref.
                // this needs to be an object so that it can be passed
                // by reference, and hold changing state.
                var refs = typeof props.ref === 'string' || (0, _typeof3.default)(props.ref) === 'object' ? props.ref : {};
                var ref = typeof props.ref === 'string' || (0, _typeof3.default)(props.ref) === 'object' ? props.ref : function (node) {
                    refs.node = node;

                    // maintain behaviour when ref prop was already set
                    if (typeof props.ref === 'function') {
                        props.ref(node);
                    }
                };

                var newProps = typeof klass === 'string' ? (0, _extends3.default)({}, props, { ref: ref }) : props;

                for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                    children[_key - 2] = arguments[_key];
                }

                var reactEl = _this._createElement.apply(_this, [klass, newProps].concat(children));

                // only test html elements
                if (typeof klass === 'string') {
                    var handler = _this.failureHandler(reactEl, refs);
                    var childrenForTest = children.length === 0 ? props.children || [] : children;

                    _this.suite.test(klass, props, childrenForTest, handler);
                }

                return reactEl;
            };
        }

        /**
         * Restore React and all components as if we were never here
         * @returns {undefined}
        */

    }, {
        key: 'restoreAll',
        value: function restoreAll() {
            this.React.createElement = this._createElement;
            _after2.default.restorePatchedMethods();
        }

        /**
         * Creates a failure handler based on the element that was created
         * @arg {object} reactEl - The react element this failure is for
         * @arg {object} ref     - The object that holds the DOM node (passed by ref)
         * @returns {function} A handler that knows everything it needs to know
         */

    }, {
        key: 'failureHandler',
        value: function failureHandler(reactEl, ref) {
            var _options = this.options,
                reporter = _options.reporter,
                filterFn = _options.filterFn;

            /**
             * @arg {string} errInfo  - All the error info (see docs what this means)
             * @returns {undefined}
             */

            return function (errInfo) {
                // get the owning component (the one that has
                // the element in its render fn)
                var owner = reactEl._owner;

                // if there is an owner, use its name
                // if not, use the tagname of the violating elemnent
                var displayName = '';
                if (owner) {
                    displayName = owner.type ? owner.type.name : owner.getName();
                } else {
                    displayName = errInfo.tagName + '#' + errInfo.props.id;
                }

                // stop if we're not allowed to proceed
                if (!filterFn(displayName, errInfo.props.id, errInfo.msg)) {
                    return;
                }

                // gather all info for the reporter
                var info = (0, _extends3.default)({}, errInfo, {
                    displayName: displayName
                });

                var DOMNode = false;
                if (_browser2.default && !this.__sync) {
                    // Make a best-effort attempt to grab the DOMNode
                    var instance = owner && owner._instance;
                    if (owner && owner.stateNode) {
                        // Fiber
                        DOMNode = this.ReactDOM.findDOMNode(owner.stateNode);
                    } else if (typeof ref === 'string' && instance) {
                        DOMNode = this.ReactDOM.findDOMNode(instance.refs[ref]); // TODO: replace use of findDOMNode
                    } else if ('node' in ref) {
                        DOMNode = ref.node;
                    }
                }
                if (DOMNode) {
                    reporter((0, _extends3.default)({}, info, { DOMNode: DOMNode }));
                } else {
                    reporter(info);
                }
            }.bind(this);
        }
    }]);
    return A11y;
}();

exports.default = A11y;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// store how to undo these changes
var restoreFunctions = [];

// does nothing
var noop = function noop() {
    return null;
};

var after = function after(host, name, cb) {
    if (!host) {
        throw new Error('cannot replace function on undefined');
    }

    // save original
    var original = host[name] || noop;

    // override host
    host[name] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        // perform original
        original.apply(host, args);
        // perform cb
        cb.apply(undefined, args);
    };

    // save restoring function
    restoreFunctions.push(function () {
        host[name] = original;
    });
};

after.restorePatchedMethods = function () {
    // perform each restoring function
    restoreFunctions.forEach(function (restore) {
        return restore();
    });

    // clear the list of functions to restore
    restoreFunctions = [];
};

after.render = function (component, fn) {
    after(component, 'componentDidMount', fn);
    after(component, 'componentDidUpdate', fn);
};

exports.default = after;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(1614);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(1617);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = function () {
    // signature is a11y(React, opts) or a11y(React, ReactDOM, opts)
    // so destructure args based on number of args passed
    var props = [];

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
    }

    if (args.length === 2) {
        if (args[1].findDOMNode === undefined) {
            props = [args[0], null, args[1] || {}];
        } else {
            props = [args[0], args[1], {}];
        }
    } else {
        props = args;
    }

    var _props = props,
        _props2 = (0, _slicedToArray3.default)(_props, 3),
        React = _props2[0],
        ReactDOM = _props2[1],
        opts = _props2[2];

    if (!React || !React.createElement) {
        throw new Error(LOG_PREFIX + ' missing argument \'React\'');
    }

    // make sure ReactDOM is passed in in browser code
    if (_util.browser && !(ReactDOM && ReactDOM.findDOMNode)) {
        throw new Error(LOG_PREFIX + ' missing argument \'ReactDOM\'');
    }

    deprecate(opts, 'includeSrcNode', msg);
    deprecate(opts, 'throw', msg);
    deprecate(opts, 'warningPrefix', msg);

    var _opts$reporter = opts.reporter,
        reporter = _opts$reporter === undefined ? mkReporter(opts) : _opts$reporter,
        _opts$filterFn = opts.filterFn,
        filterFn = _opts$filterFn === undefined ? always : _opts$filterFn,
        _opts$plugins = opts.plugins,
        plugins = _opts$plugins === undefined ? [] : _opts$plugins,
        _opts$rules = opts.rules,
        rules = _opts$rules === undefined ? {} : _opts$rules;


    return {
        React: React,
        ReactDOM: ReactDOM,
        filterFn: filterFn,
        reporter: reporter,
        plugins: plugins,
        rules: rules
    };
};

var _util = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG_PREFIX = '[react-a11y]:';

/**
 * Throws an error based on the warning
 * If the last argument is a DOM node, it
 * coerces it to a string before throwing.
 * @returns {undefined}
 */
/* eslint-disable babel/new-cap,no-console */
var throwError = function throwError() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (last.outerHTML) {
        args[args.length - 1] = 'Element: \n  ' + last.outerHTML;
    }

    var error = new Error(args.join(' '));
    error.element = last;

    throw error;
};

/**
 * Show a warning
 * @returns {undefined}
 */
var showWarning = function showWarning() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    if (_util.browser) {
        var _console;

        (_console = console).warn.apply(_console, args);
    } else {
        console.warn(args.join('\n  '));
    }
};

/**
 * Creates a reporter function based on deprecated options
 * @arg {object} opts - The options passed by the user
 * @returns {function} The reporter
 */
var mkReporter = function mkReporter(opts) {
    var _opts$doThrow = opts.doThrow,
        doThrow = _opts$doThrow === undefined ? false : _opts$doThrow,
        _opts$warningPrefix = opts.warningPrefix,
        warningPrefix = _opts$warningPrefix === undefined ? LOG_PREFIX : _opts$warningPrefix;


    return function (info) {
        var msg = info.msg,
            displayName = info.displayName,
            DOMNode = info.DOMNode,
            url = info.url,
            tagName = info.tagName,
            severity = info.severity,
            AX = info.AX;

        // build warning

        var warning = [warningPrefix, (displayName || tagName) + ' - ' + msg].concat((0, _toConsumableArray3.default)(url ? ['See \'' + url + '\' for more info.'] : []), (0, _toConsumableArray3.default)(AX ? ['See \'' + (0, _util.AXURL)(AX) + '\' for more info.'] : []), [DOMNode || tagName]);

        if (doThrow || severity === 'error') {
            throwError.apply(undefined, (0, _toConsumableArray3.default)(warning));
        } else {
            showWarning.apply(undefined, (0, _toConsumableArray3.default)(warning));
        }
    };
};

/**
 * Generate a deprecation warning when a key is present
 * in the options object
 * @arg {object} opts - the options object under scrutiny
 * @arg {string} name - the name of the deprecated option
 * @arg {string} msg  - an optional reason for the deprecation
 * @returns {undefined}
 */
var deprecate = function deprecate(opts, name) {
    var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    if (name in opts) {
        console.warn(LOG_PREFIX + ' the `' + name + '` options is deprecated. ' + msg);
    }
};

/**
 * Make a certain option mandatory
 * @arg {object} opts - the options object under scrutiny
 * @arg {string} name - the name of the mandatory option
 * @arg {string} msg  - an optional reason
 * @returns {undefined}
 */
var mandatory = function mandatory(opts, name) {
    var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    if (!(name in opts)) {
        throw new Error(LOG_PREFIX + ' the `' + name + '` option is mandatory. ' + msg);
    }
};

// always resolve to true
var always = function always() {
    return true;
};

// deprecation message
var msg = 'Use the `reporter` option to change how warnings are displayed.';

/**
 * Normalize and validate the options that the user passed in.
 * @arg {object} opts - The opts the user passed in
 * @returns {object} the validated options
 */

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(810);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(287);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(218);
__webpack_require__(216);
module.exports = __webpack_require__(1616);


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(374);
var ITERATOR = __webpack_require__(94)('iterator');
var Iterators = __webpack_require__(247);
module.exports = __webpack_require__(49).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(285);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var interactive = {
    button: true,
    input: function input(props) {
        return props.type !== 'hidden';
    },

    textarea: true,
    select: true,
    option: true,
    // eslint-disable-next-line id-length
    a: function a(props) {
        var hasHref = typeof props.href === 'string';
        var hasTabIndex = props.tabIndex !== null;
        return hasHref || !hasHref && hasTabIndex;
    }
};

exports.default = function (tagName, props) {
    var tag = interactive[tagName];
    return typeof tag === 'function' ? tag(props) : tag;
};

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (props) {
    return (0, _trueish2.default)(props, 'aria-hidden');
};

var _trueish = __webpack_require__(811);

var _trueish2 = _interopRequireDefault(_trueish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var name = arguments[1];

    return typeof props[name] === 'function';
};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var hasProp = function hasProp(props, any) {
    if (Array.isArray(any)) {
        return any.reduce(function (acc, prop) {
            return acc || hasProp(props, prop);
        }, false);
    }
    return props && any && any in props;
};

exports.default = hasProp;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'aria-activedescendant': {
        type: 'string'
    },
    'aria-atomic': {
        type: 'boolean'
    },
    'aria-autocomplete': {
        type: 'token',
        values: ['inline', 'list', 'both', 'none']
    },
    'aria-busy': {
        type: 'boolean'
    },
    'aria-checked': {
        type: 'tristate'
    },
    'aria-controls': {
        type: 'string'
    },
    'aria-describedby': {
        type: 'string'
    },
    'aria-disabled': {
        type: 'boolean'
    },
    'aria-dropeffect': {
        type: 'tokenlist',
        values: ['copy', 'move', 'link', 'execute', 'popup', 'none']
    },
    'aria-expanded': {
        type: 'boolean',
        allowundefined: true
    },
    'aria-flowto': {
        type: 'string'
    },
    'aria-grabbed': {
        type: 'boolean',
        allowundefined: true
    },
    'aria-haspopup': {
        type: 'boolean'
    },
    'aria-hidden': {
        type: 'boolean'
    },
    'aria-invalid': {
        type: 'token',
        values: ['grammar', 'false', 'spelling', 'true']
    },
    'aria-label': {
        type: 'string'
    },
    'aria-labelledby': {
        type: 'string'
    },
    'aria-level': {
        type: 'integer'
    },
    'aria-live': {
        type: 'token',
        values: ['off', 'polite', 'assertive']
    },
    'aria-multiline': {
        type: 'boolean'
    },
    'aria-multiselectable': {
        type: 'boolean'
    },
    'aria-orientation': {
        type: 'token',
        values: ['vertical', 'horizontal']
    },
    'aria-owns': {
        type: 'string'
    },
    'aria-posinset': {
        type: 'integer'
    },
    'aria-pressed': {
        type: 'tristate'
    },
    'aria-readonly': {
        type: 'boolean'
    },
    'aria-relevant': {
        type: 'tokenlist',
        values: ['additions', 'removals', 'text', 'all']
    },
    'aria-required': {
        type: 'boolean'
    },
    'aria-selected': {
        type: 'boolean',
        allowundefined: true
    },
    'aria-setsize': {
        type: 'integer'
    },
    'aria-sort': {
        type: 'token',
        values: ['ascending', 'descending', 'none', 'other']
    },
    'aria-valuemax': {
        type: 'number'
    },
    'aria-valuemin': {
        type: 'number'
    },
    'aria-valuenow': {
        type: 'number'
    },
    'aria-valuetext': {
        type: 'string'
    }
};

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable id-length */
exports.default = {
    a: {},
    abbr: {},
    address: {},
    area: {},
    article: {},
    aside: {},
    audio: {},
    b: {},
    base: {
        reserved: true
    },
    bdi: {},
    bdo: {},
    big: {},
    blockquote: {},
    body: {},
    br: {},
    button: {},
    canvas: {},
    caption: {},
    cite: {},
    code: {},
    col: {
        reserved: true
    },
    colgroup: {
        reserved: true
    },
    data: {},
    datalist: {},
    dd: {},
    del: {},
    details: {},
    dfn: {},
    dialog: {},
    div: {},
    dl: {},
    dt: {},
    em: {},
    embed: {},
    fieldset: {},
    figcaption: {},
    figure: {},
    footer: {},
    form: {},
    h1: {},
    h2: {},
    h3: {},
    h4: {},
    h5: {},
    h6: {},
    head: {
        reserved: true
    },
    header: {},
    hgroup: {},
    hr: {},
    html: {
        reserved: true
    },
    i: {},
    iframe: {},
    img: {},
    input: {},
    ins: {},
    kbd: {},
    keygen: {},
    label: {},
    legend: {},
    li: {},
    link: {
        reserved: true
    },
    main: {},
    map: {},
    mark: {},
    menu: {},
    menuitem: {},
    meta: {
        reserved: true
    },
    meter: {},
    nav: {},
    noscript: {
        reserved: true
    },
    object: {},
    ol: {},
    optgroup: {},
    option: {},
    output: {},
    p: {},
    param: {
        reserved: true
    },
    path: {},
    picture: {
        reserved: true
    },
    pre: {},
    progress: {},
    q: {},
    rp: {},
    rt: {},
    ruby: {},
    s: {},
    samp: {},
    script: {
        reserved: true
    },
    section: {},
    select: {},
    small: {},
    source: {
        reserved: true
    },
    span: {},
    strong: {},
    style: {
        reserved: true
    },
    sub: {},
    summary: {},
    sup: {},
    svg: {},
    table: {},
    tbody: {},
    td: {},
    textarea: {},
    tfoot: {},
    th: {},
    thead: {},
    time: {},
    title: {
        reserved: true
    },
    tr: {},
    track: {
        reserved: true
    },
    u: {},
    ul: {},
    var: {},
    video: {},
    wbr: {}
};

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    alert: {
        requiredprops: []
    },
    alertdialog: {
        requiredprops: []
    },
    application: {
        requiredprops: []
    },
    article: {
        requiredprops: []
    },
    banner: {
        requiredprops: []
    },
    button: {
        requiredprops: []
    },
    checkbox: {
        requiredprops: ['aria-checked']
    },
    columnheader: {
        requiredprops: []
    },
    combobox: {
        requiredprops: ['aria-expanded']
    },
    complementary: {
        requiredprops: []
    },
    contentinfo: {
        requiredprops: []
    },
    definition: {
        requiredprops: []
    },
    dialog: {
        requiredprops: []
    },
    directory: {
        requiredprops: []
    },
    document: {
        requiredprops: []
    },
    form: {
        requiredprops: []
    },
    grid: {
        requiredprops: []
    },
    gridcell: {
        requiredprops: []
    },
    group: {
        requiredprops: []
    },
    heading: {
        requiredprops: []
    },
    img: {
        requiredprops: []
    },
    link: {
        requiredprops: []
    },
    list: {
        requiredprops: []
    },
    listbox: {
        requiredprops: []
    },
    listitem: {
        requiredprops: []
    },
    log: {
        requiredprops: []
    },
    main: {
        requiredprops: []
    },
    marquee: {
        requiredprops: []
    },
    math: {
        requiredprops: []
    },
    menu: {
        requiredprops: []
    },
    menubar: {
        requiredprops: []
    },
    menuitem: {
        requiredprops: []
    },
    menuitemcheckbox: {
        requiredprops: []
    },
    menuitemradio: {
        requiredprops: []
    },
    navigation: {
        requiredprops: []
    },
    note: {
        requiredprops: []
    },
    option: {
        requiredprops: []
    },
    presentation: {
        requiredprops: []
    },
    progressbar: {
        requiredprops: []
    },
    radio: {
        requiredprops: []
    },
    radiogroup: {
        requiredprops: []
    },
    region: {
        requiredprops: []
    },
    row: {
        requiredprops: []
    },
    rowgroup: {
        requiredprops: []
    },
    rowheader: {
        requiredprops: []
    },
    scrollbar: {
        requiredprops: ['aria-controls', 'aria-orientation', 'aria-valuemax', 'aria-valuemin', 'aria-valuenow']
    },
    search: {
        requiredprops: []
    },
    separator: {
        requiredprops: []
    },
    slider: {
        requiredprops: ['aria-valuemax', 'aria-valuemin', 'aria-valuenow']
    },
    spinbutton: {
        requiredprops: ['aria-valuemax', 'aria-valuemin', 'aria-valuenow']
    },
    status: {
        requiredprops: []
    },
    tab: {
        requiredprops: []
    },
    tablist: {
        requiredprops: []
    },
    tabpanel: {
        requiredprops: []
    },
    textbox: {
        requiredprops: []
    },
    timer: {
        requiredprops: []
    },
    toolbar: {
        requiredprops: []
    },
    tooltip: {
        requiredprops: []
    },
    tree: {
        requiredprops: []
    },
    treegrid: {
        requiredprops: []
    },
    treeitem: {
        requiredprops: []
    }
};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toArray2 = __webpack_require__(1626);

var _toArray3 = _interopRequireDefault(_toArray2);

var _defineProperty2 = __webpack_require__(1627);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(13);

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _rules = __webpack_require__(1628);

var _rules2 = _interopRequireDefault(_rules);

var _util = __webpack_require__(57);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allDevices = (0, _keys2.default)(util.devices).map(function (key) {
    return util.devices[key];
});

var severity = function severity(val) {
    switch (val) {
        case 0:
        case 'off':
            return 'off';

        case 1:
        case 'warn':
            return 'warn';

        case 2:
        case 'error':
            return 'error';

        default:
            throw new Error('react-a11y: invalid severity ' + val);
    }
};

var normalize = function normalize() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'off';

    if (Array.isArray(opts)) {
        opts[0] = severity(opts[0]);
        return opts;
    }
    return [severity(opts)];
};

var getTests = function getTests(defns) {
    return Array.isArray(defns) ? defns : [defns];
};

var Suite = function () {
    function Suite(React, ReactDOM, options) {
        (0, _classCallCheck3.default)(this, Suite);

        this.options = options;
        this.React = React;
        this.ReactDOM = ReactDOM;

        if (!this.React && !this.React.createElement) {
            throw new Error('Missing parameter: React');
        }

        var _options$plugins = this.options.plugins,
            plugins = _options$plugins === undefined ? [] : _options$plugins;

        // prepare all rules by including every plugin and saving their rules
        // namespaced like plugin/rule

        this.rules = plugins.map(function (name) {
            try {
                // eslint-disable-next-line global-require,import/no-dynamic-require
                var mod = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                var rules = 'default' in mod ? mod.default.rules : mod.rules;
                return (0, _keys2.default)(rules).reduce(function (acc, key) {
                    return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, name + '/' + key, rules[key]));
                }, {});
            } catch (err) {
                throw new Error('Could not find react-a11y-plugin-' + name);
            }
        }).reduce(function (acc, next) {
            return (0, _extends4.default)({}, acc, next);
        }, _rules2.default);
    }

    (0, _createClass3.default)(Suite, [{
        key: 'test',
        value: function test(tagName, props, children, done) {
            var _this = this;

            (0, _keys2.default)(this.options.rules).forEach(function (key) {
                var rule = _this.rules[key];

                // ensure that the rule exists
                if (!rule) {
                    throw new Error('react-a11y: rule ' + key + ' not found, ' + 'maybe you\'re missing a plugin?');
                }

                // get options for rule

                var _normalize = normalize(_this.options.rules[key]),
                    _normalize2 = (0, _toArray3.default)(_normalize),
                    sev = _normalize2[0],
                    options = _normalize2.slice(1);

                if (sev !== 'off') {
                    var ctx = {
                        options: options,
                        React: _this.React,
                        ReactDOM: _this.ReactDOM
                    };

                    getTests(rule).reduce(function () {
                        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(pprev, defn) {
                            var prev, tagNames, msg, url, AX, test, _defn$affects, affects, pass;

                            return _regenerator2.default.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _context.next = 2;
                                            return pprev;

                                        case 2:
                                            prev = _context.sent;

                                            if (prev) {
                                                _context.next = 5;
                                                break;
                                            }

                                            return _context.abrupt('return', prev);

                                        case 5:
                                            tagNames = defn.tagName, msg = defn.msg, url = defn.url, AX = defn.AX, test = defn.test, _defn$affects = defn.affects, affects = _defn$affects === undefined ? allDevices : _defn$affects;

                                            // filter by tagName

                                            if (!Array.isArray(tagNames)) {
                                                _context.next = 11;
                                                break;
                                            }

                                            if (!(tagNames.indexOf(tagName) < 0)) {
                                                _context.next = 9;
                                                break;
                                            }

                                            return _context.abrupt('return', prev);

                                        case 9:
                                            _context.next = 14;
                                            break;

                                        case 11:
                                            if (!tagNames) {
                                                _context.next = 14;
                                                break;
                                            }

                                            if (!(tagName !== tagNames)) {
                                                _context.next = 14;
                                                break;
                                            }

                                            return _context.abrupt('return', prev);

                                        case 14:

                                            // perform the test
                                            pass = void 0;
                                            // try/catch so that exceptions are not silently swallowed by await

                                            _context.prev = 15;
                                            _context.next = 18;
                                            return test(tagName, props, children, ctx);

                                        case 18:
                                            pass = _context.sent;
                                            _context.next = 25;
                                            break;

                                        case 21:
                                            _context.prev = 21;
                                            _context.t0 = _context['catch'](15);

                                            console.log(_context.t0);
                                            pass = false;

                                        case 25:

                                            if (!pass) {
                                                done({
                                                    tagName: tagName,
                                                    msg: msg,
                                                    url: url,
                                                    AX: AX,
                                                    props: props,
                                                    children: children,
                                                    severity: sev,
                                                    rule: key,
                                                    affects: affects
                                                });
                                            }

                                            return _context.abrupt('return', prev && pass);

                                        case 27:
                                        case 'end':
                                            return _context.stop();
                                    }
                                }
                            }, _callee, _this, [[15, 21]]);
                        }));

                        return function (_x2, _x3) {
                            return _ref.apply(this, arguments);
                        };
                    }(), true);
                }
            });
        }
    }]);
    return Suite;
}();

exports.default = Suite;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(285);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(313);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable global-require */
exports.default = {
    'click-events-have-key-events': __webpack_require__(1629).default,
    'hidden-uses-tabindex': __webpack_require__(1630).default,
    'img-uses-alt': __webpack_require__(1631).default,
    'label-has-for': __webpack_require__(1632).default,
    'mouse-events-have-key-events': __webpack_require__(1633).default,
    'onclick-uses-role': __webpack_require__(1634).default,
    'interactive-supports-focus': __webpack_require__(1635).default,
    'no-access-key': __webpack_require__(1636).default,
    'no-hash-ref': __webpack_require__(1637).default,
    'img-redundant-alt': __webpack_require__(1638).default,
    'no-onchange': __webpack_require__(1639).default,
    'aria-role': __webpack_require__(1640).default,
    'tabindex-no-positive': __webpack_require__(1641).default,
    'tabindex-uses-button': __webpack_require__(1642).default,
    'aria-unsupported-elements': __webpack_require__(1643).default,

    // DEPRECATED RULES
    'avoid-positive-index': __webpack_require__(1644).default,
    'button-role-space': __webpack_require__(1645).default,
    'label-uses-for': __webpack_require__(1646).default,
    'mouse-events-map-to-key-events': __webpack_require__(1647).default,
    'onclick-uses-tabindex': __webpack_require__(1648).default,
    'redundant-alt': __webpack_require__(1649).default,
    'use-onblur-not-onchange': __webpack_require__(1650).default,
    'valid-aria-role': __webpack_require__(1651).default,
    'no-unsupported-elements-use-aria': __webpack_require__(1652).default
};

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = {
    msg: 'You have an `onClick` handler but did not define an `onKeyDown`, `onKeyUp` or `onKeyPress` handler. ' + 'Add it, and have the "Space" key do the same thing as an `onClick` handler.',
    url: 'https://www.w3.org/WAI/GL/wiki/Making_actions_keyboard_accessible_by_using_keyboard_event_handlers_with_WAI-ARIA_controls',
    affects: [_util.devices.keyboardOnly],
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var onClick = (0, _util.listensTo)(props, 'onClick');
        var onKeyDown = (0, _util.listensTo)(props, 'onKeyDown');
        var onKeyUp = (0, _util.listensTo)(props, 'onKeyUp');
        var onKeyPress = (0, _util.listensTo)(props, 'onKeyPress');

        // rule passes when element is hidden,
        // has onClick and has an onKeyDown, onKeyUp or onKeyPress prop
        return hidden || !onClick || onKeyDown || onKeyUp || onKeyPress;
    }
};
var pass = exports.pass = [{
    when: 'there is an onClick handler and there is an onKeyDown handler.',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn, onKeyDown: _util.fn });
    }
}, {
    when: 'there is an onClick handler and there is an onKeyUp handler.',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn, onKeyUp: _util.fn });
    }
}, {
    when: 'there is an onClick handler and there is an onKeyPress handler.',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn, onKeyPress: _util.fn });
    }
}, {
    when: 'there is no onClick',
    render: function render(React) {
        return React.createElement(
            'div',
            null,
            'derp'
        );
    }
}, {
    when: 'the element is aria-hidden',
    render: function render(React) {
        return React.createElement('div', { 'aria-hidden': true, role: 'button' });
    }
}];

var fail = exports.fail = [{
    when: 'there is an onClick handler but no `onKeyDown`, `onKeyUp` or `onKeyPress` is present',
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn });
    }
}];

var description = exports.description = '\nEnforce that elements which have the `role="button"`\nalso have an `onKeyDown` or `onKeyPress` handler that handles Space or Enter\n(this is isn\'t actually checked) for people that are using a\nkeyboard-only device.\n';

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    msg: 'You have `aria-hidden="true"` applied to an interactive element but have not ' + 'removed it from the tab flow. This could result in a hidden tab stop for ' + 'users of screen readers.',
    url: 'http://john.foliot.ca/aria-hidden',
    affects: [_util.devices.keyboardOnly, _util.devices.screenReaders],
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var interactive = (0, _util.isInteractive)(tagName, props);
        var tabIndex = props.tabIndex === -1;

        return !hidden || !interactive || tabIndex;
    }
}];
var pass = exports.pass = [{
    when: 'an interactive element is aria-hidden and has tabindex="-1"',
    render: function render(React) {
        return React.createElement('input', { 'aria-hidden': true, tabIndex: -1 });
    }
}, {
    when: 'the element is not interactive',
    render: function render(React) {
        return React.createElement('div', { 'aria-hidden': true });
    }
}, {
    when: 'an interactive element is not aria-hidden',
    render: function render(React) {
        return React.createElement('input', null);
    }
}];

var fail = exports.fail = [{
    when: 'an interactive element is hidden but has no tabindex',
    render: function render(React) {
        return React.createElement('input', { 'aria-hidden': true });
    }
}, {
    when: 'an interactive element is hidden but has a bad tabindex',
    // eslint-disable-next-line jsx-a11y/tabindex-no-positive
    render: function render(React) {
        return React.createElement('input', { 'aria-hidden': true, tabIndex: 2 });
    }
}];

var description = exports.description = '\nEnforce that interactive elements that have been removed from\nthe accessibility tree usign `aria-hidden` are also removed from\nthe tab flow by setting `tabIndex={-1}`.  If not, this could result\nin a hidden tab stop for screen reader users.\n';

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

// test will be run in order
exports.default = [{
    tagName: 'img',
    msg: 'The img does not have an `alt` prop, screen-readers will not know what it is',
    url: 'https://dev.w3.org/html5/alt-techniques',
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var alt = (0, _util.hasProp)(props, 'alt');

        return hidden || alt;
    },

    affects: [_util.devices.screenReaders]
}, {
    tagName: 'img',
    msg: 'The `alt` prop cannot be empty string if role="presentation" is not set.',
    url: 'https://www.w3.org/TR/wai-aria/roles#presentation',
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var empty = props.alt === '';
        var pres = props.role === 'presentation';

        return hidden || !empty || pres;
    },

    affects: [_util.devices.screenReaders]
}];
var pass = exports.pass = [{
    when: 'the img has an `alt`',
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'nice' });
    }
}, {
    when: 'the img has an empty `alt` and role="presentation"',
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: '', role: 'presentation' });
    }
}, {
    when: 'the img is aria-hidden',
    // eslint-disable-next-line jsx-a11y/img-has-alt
    render: function render(React) {
        return React.createElement('img', { src: 'foo', 'aria-hidden': true });
    }
}];

var fail = exports.fail = [{
    when: 'the img doen\'t have an `alt`',
    // eslint-disable-next-line jsx-a11y/img-has-alt
    render: function render(React) {
        return React.createElement('img', { src: 'foo' });
    }
}, {
    when: 'the img has alt="" but no role="presentation"',
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: '' });
    }
}];

var description = exports.description = '\nEnforce that an `img` element contains the `alt` prop. The `alt` attribute specifies\nan alternate text for an image, if the image cannot be displayed.\n';

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    tagName: 'label',
    msg: 'Form controls using a label to identify them must be ' + 'programmatically associated with the control using htmlFor',
    url: 'https://www.w3.org/WAI/tutorials/forms/labels',
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var hasfor = typeof props.htmlFor === 'string';
        return hidden || hasfor;
    }
}];
var pass = exports.pass = [{
    when: 'the label is hidden',
    // eslint-disable-next-line jsx-a11y/label-has-for
    render: function render(React) {
        return React.createElement('label', { 'aria-hidden': true });
    }
}, {
    when: 'the label has a valid `htmlFor` prop',
    render: function render(React) {
        return React.createElement('label', { htmlFor: 'foo' });
    }
}, {
    when: 'it is not a label',
    render: function render(React) {
        return React.createElement('div', null);
    }
}];

var fail = exports.fail = [{
    when: 'a label is not hidden and has no `htmlFor`',
    // eslint-disable-next-line jsx-a11y/label-has-for
    render: function render(React) {
        return React.createElement('label', null);
    }
}];

var description = exports.description = '\nEnforce label tags have `htmlFor` attribute. Form controls using a `label` to\nidentify them must have only one label that is programmatically associated with\nthe control using: `<label htmlFor={/* ID or name of control*/}>...</label>`.\n';

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.pass = exports.fail = undefined;

var _util = __webpack_require__(57);

var url = 'http://webaim.org/techniques/javascript/eventhandlers#onmouseover';
var affects = [_util.devices.keyboardOnly];

exports.default = [{
    msg: 'onMouseOver must be accompanied by onFocus for accessibility.',
    url: url,
    affects: affects,
    test: function test(tagName, props) {
        var mouseOver = (0, _util.listensTo)(props, 'onMouseOver');
        var focus = (0, _util.listensTo)(props, 'onFocus');

        return !mouseOver || focus;
    }
}, {
    msg: 'onMouseOut must be accompanied by onBlur for accessibility.',
    url: url,
    affects: affects,
    test: function test(tagName, props) {
        var mouseOut = (0, _util.listensTo)(props, 'onMouseOut');
        var blur = (0, _util.listensTo)(props, 'onBlur');

        return !mouseOut || blur;
    }
}];
var fail = exports.fail = [{
    when: 'there is `onMouseOver` but no `onFocus`',
    render: function render(React) {
        return React.createElement('div', { onMouseOver: _util.fn });
    }
}, {
    when: 'there is `onMouseOut` but no `onBlur`',
    render: function render(React) {
        return React.createElement('div', { onMouseOut: _util.fn });
    }
}];

var pass = exports.pass = [{
    when: 'there is no `onMouseOver` or `onMouseOut`',
    render: function render(React) {
        return React.createElement('div', null);
    }
}, {
    when: 'there is `onMouseOver` but and `onFocus`',
    render: function render(React) {
        return React.createElement('div', { onMouseOver: _util.fn, onFocus: _util.fn });
    }
}, {
    when: 'there is `onMouseOut` but and `onBlur`',
    render: function render(React) {
        return React.createElement('div', { onMouseOut: _util.fn, onBlur: _util.fn });
    }
}];

var description = exports.description = '\nEnforce `onMouseOver`/`onMouseOut` are accompanied by\n`onFocus`/`onBlur`. Coding for the keyboard is important for users with\nphysical disabilities who cannot use a mouse, AT compatability, and screenreader\nusers.\n';

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.pass = exports.fail = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    msg: 'You have a click handler on a non-interactive element but no `role` DOM property. ' + 'It will be unclear what this element is supposed to do to a screen-reader user.',
    url: 'https://www.w3.org/WAI/PF/aria/roles#role_definitions',
    affects: [_util.devices.screenReaders],
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var interactive = (0, _util.isInteractive)(tagName, props);
        var onClick = (0, _util.listensTo)(props, 'onClick');
        var role = 'role' in props;

        return hidden || interactive || !onClick || role;
    }
}];
var fail = exports.fail = [{
    when: 'there is an `onClick` with no `role`',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn });
    }
}];

var pass = exports.pass = [{
    when: 'the element is hidden from aria',
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn, 'aria-hidden': true });
    }
}, {
    when: 'there is an `onClick` with a `role`',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn, role: 'button' });
    }
}, {
    when: 'the element is interactive',
    render: function render(React) {
        return React.createElement('button', { onClick: _util.fn });
    }
}];

var description = exports.description = '\nEnforce visible, non-interactive elements with click handlers use role\nattribute. Visible means that it is not hidden from a screen reader. Examples of\nnon-interactive elements are `div`, `section`, and a elements without a `href`\nprop.The purpose of the role attribute is to identify to screenreaders the exact\nfunction of an element.\n';

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    msg: 'You have a click handler on a non-interactive element but no `tabIndex` DOM property. ' + 'The element will not be navigable or interactive by keyboard users.',
    url: 'http://www.w3.org/TR/wai-aria-practices/#focus_tabindex',
    affects: [_util.devices.keyboardOnly],
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var interactive = (0, _util.isInteractive)(tagName, props);
        var onClick = (0, _util.listensTo)(props, 'onClick');
        var tabIndex = props.tabIndex !== undefined;

        return hidden || interactive || !onClick || tabIndex;
    }
}];
var pass = exports.pass = [{
    when: 'when there is an `onClick` with a `tabIndex`',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn, tabIndex: 0 });
    }
}, {
    when: 'the element is hidden from aria',
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn, 'aria-hidden': true });
    }
}, {
    when: 'the element is interactive',
    render: function render(React) {
        return React.createElement('button', { onClick: _util.fn });
    }
}];

var fail = exports.fail = [{
    when: 'there is an `onClick` with no `tabIndex`',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn });
    }
}];

var description = exports.description = '\nEnforce that elements that have an `onClick` handler also have\na `tabIndex` property.  If not, they will not be navigable by\nkeyboard users.\n';

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.pass = exports.fail = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    msg: 'No `accessKey` attribute allowed. Inconsistencies ' + 'between keyboard shortcuts and keyboard comments used by screenreader ' + 'and keyboard only users create a11y complications.',
    url: 'http://webaim.org/techniques/keyboard/accesskey#spec',
    affects: [_util.devices.screenReader, _util.devices.keyboardOnly],
    test: function test(tagName, props) {
        var accessKey = (0, _util.hasProp)(props, 'accessKey');
        return !accessKey;
    }
}];
var fail = exports.fail = [{
    when: 'there is an `accessKey` prop',
    // eslint-disable-next-line jsx-a11y/no-access-key
    render: function render(React) {
        return React.createElement('div', { accessKey: 'a' });
    }
}];

var pass = exports.pass = [{
    when: 'there is an no `accessKey` prop',
    render: function render(React) {
        return React.createElement('div', null);
    }
}];

var description = exports.description = '\nEnforce no accessKey prop on element. Access keys are HTML elements that allow\nweb developers to assign keyboard shortcuts to elements.  Inconsistencies between\nkeyboard shortcuts and keyboard commands used by screenreader and keyboard only\nusers create accessibility complications so to avoid complications, access keys\nshould not be used.\n';

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    tagName: 'a',
    msg: 'Links must not point to `#`. ' + 'Use a more descriptive href or use a button instead.',
    url: 'http://webaim.org/techniques/hypertext/',
    test: function test(tagName, props) {
        var hashRef = props.href && props.href === '#';
        return !hashRef;
    }
}];
var pass = exports.pass = [{
    when: 'the `href` is not `#`',
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    render: function render(React) {
        return React.createElement('a', { href: 'foo#bar' });
    }
}];

var fail = exports.fail = [{
    when: 'the `href` is `#`',
    // eslint-disable-next-line jsx-a11y/href-no-hash,jsx-a11y/anchor-has-content
    render: function render(React) {
        return React.createElement('a', { href: '#' });
    }
}];

var description = exports.description = '\nEnforce an anchor element\'s href prop value is not just `"#"`. You should use\nsomething more descriptive, or use a button instead.\n';

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.options = exports.description = exports.pass = exports.fail = undefined;

var _util = __webpack_require__(57);

var def = ['image', 'picture', 'photo'];

exports.default = [{
    tagName: 'img',
    msg: 'Redundant `alt` attribute. Screen-readers already announce `img` tags as an image. ' + 'You don\'t need to use the words like `image`, `photo,` or `picture` in the alt prop.',
    url: 'http://webaim.org/techniques/alttext',
    affects: [_util.devices.screenReaders],
    test: function test(_, props, _c, ctx) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var alt = (props.alt || '').toLowerCase();
        var words = ctx.options[0] || def;
        var contains = words.reduce(function (acc, word) {
            return acc || alt.indexOf(word) >= 0;
        }, false);

        return hidden || !contains;
    }
}];
var fail = exports.fail = [{
    when: 'is a redundant alt message',
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'bar image foo' });
    }
}, {
    when: 'is a redundant alt message (different opts)',
    opts: [['foto']],
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'bar foto' });
    }
}];

var pass = exports.pass = [{
    when: 'the `alt` does not contain redundant words',
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'nice' });
    }
}, {
    when: 'the `alt` does not contain redundant words (different opts)',
    opts: [['foto']],
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'image' });
    }
}, {
    when: 'the element is aria-hidden',
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'nice', 'aria-hidden': true });
    }
}];

var description = exports.description = '\nEnforce img alt attribute does not contain the word image, picture, or photo.\nScreenreaders already announce `img` elements as an image. There is no need to use\nwords such as *image*, *photo*, and/or *picture*.\n';

var options = exports.options = [{
    type: 'Array(String)',
    description: 'Words to look for when looking for redudant words.',
    def: def
}];

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    msg: '`onBlur` should be preferred over `onChange`, unless absolutely necessary ' + 'and it has no negative consequences for keyboard only or screen-reader users.',
    url: 'http://webaim.org/techniques/javascript/eventhandlers#onchange',
    affects: [_util.devices.keyboardOnly, _util.devices.screenReaders],
    test: function test(tagName, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var disabled = (0, _util.trueish)(props, 'aria-disabled');
        var readOnly = (0, _util.trueish)(props, 'aria-readonly');
        var onChange = (0, _util.listensTo)(props, 'onChange');
        var onBlur = (0, _util.listensTo)(props, 'onBlur');

        return hidden || disabled || readOnly || !onChange || onChange && onBlur;
    }
}];
var pass = exports.pass = [{
    when: 'there is no `onChange` prop',
    render: function render(React) {
        return React.createElement('input', null);
    }
}, {
    when: 'the element is aria-hidden',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, 'aria-hidden': true });
    }
}, {
    when: 'the element is aria-disabled',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, 'aria-disabled': true });
    }
}, {
    when: 'the element is aria-readonly',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, 'aria-readonly': true });
    }
}, {
    when: 'the `onChange` prop is present along with an `onBlur` prop',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, onBlur: _util.fn });
    }
}];

var fail = exports.fail = [{
    when: 'the `onChange` prop is present without an `onBlur` prop',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn });
    }
}];

var description = exports.description = '\nEnforce usage of onBlur over onChange for accessibility. onBlur must be used\ninstead of onChange, unless absolutely necessary and it causes no negative\nconsequences for keyboard only or screen reader users.\n';

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.pass = exports.fail = undefined;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roles = (0, _keys2.default)(_util.role);

exports.default = [{
    msg: 'Elements with ARIA roles must use a valid, non-abstract ARIA role.',
    url: 'https://www.w3.org/TR/wai-aria/roles',
    AX: 'AX_ARIA_01',
    test: function test(tagName, props) {
        var hasRole = (0, _util.hasProp)(props, 'role');
        return !hasRole || roles.indexOf(props.role) >= 0;
    }
}];
var fail = exports.fail = [{
    when: 'there is an invalid `role`',
    // eslint-disable-next-line jsx-a11y/aria-role
    render: function render(React) {
        return React.createElement('div', { role: 'foo' });
    }
}];

var pass = exports.pass = [{
    when: 'there is a role and it is valid',
    render: function render(React) {
        return React.createElement('div', { role: 'button' });
    }
}, {
    when: 'there is no `role`',
    render: function render(React) {
        return React.createElement('div', null);
    }
}];

var description = exports.description = '\nThe ARIA roles model requires that elements with a role attribute use a valid,\nnon-abstract ARIA role. Each non-abstract ARIA role is mapped on to a known set\nof behavior by the user agent or assistive technology, so using an unknown role\nwill result in the desired behavior not being available to the user.\n\nYou can find a list of valid ARIA roles, along with descriptions and information\non additional required attributes, on the\n[WAI-ARIA](http://www.w3.org/TR/wai-aria/roles#roles_categorization) site.\n';

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fail = exports.pass = exports.description = undefined;

var _util = __webpack_require__(57);

var description = exports.description = '\nKeyboard users move focus from one form control to the next by using the tab\nkey. By default focus order is determined by source order.\n\nThe `tabIndex` prop allows the author to specify an alternative tab order.\nElements with a `tabIndex` value greater than zero will receive focus in numerical\norder, ahead of focusable elements with a `tabIndex` of zero.\n\nIt is recommended that authors avoid positive values for the `tabIndex` attribute\nbecause it is brittle (any focusable elements added to the page without an\nexplicit `tabIndex` value greater than zero will come last in the tab order) and\ncan easily result in a page which is extremely difficult to navigate, causing\naccessibility problems.\n';

exports.default = [{
    msg: 'Avoid positive integer values for `tabIndex`.',
    AX: 'AX_FOCUS_03',
    test: function test(_, props) {
        var tabIndex = (0, _util.hasProp)(props, 'tabIndex');
        return !tabIndex || props.tabIndex <= 0;
    }
}];
var pass = exports.pass = [{
    when: 'the element has no tabIndex',
    render: function render(React) {
        return React.createElement('div', null);
    }
}, {
    when: 'the element has a negative tabIndex',
    render: function render(React) {
        return React.createElement('div', { tabIndex: -1 });
    }
}, {
    when: 'the element has a tabIndex of zero',
    render: function render(React) {
        return React.createElement('div', { tabIndex: '0' });
    }
}];

var fail = exports.fail = [{
    when: 'the element has a positive tabIndex',
    // eslint-disable-next-line jsx-a11y/tabindex-no-positive
    render: function render(React) {
        return React.createElement('div', { tabIndex: 2 });
    }
}];

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.pass = exports.fail = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    tagName: 'a',
    msg: 'You have an anchor with a `tabIndex`, no `href` and no `role` DOM property. ' + 'Add `role="button"` or better yet, use a `<button/>`.',
    url: 'https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_button_role',
    test: function test(_, props) {
        var hidden = (0, _util.hiddenFromAT)(props);
        var href = 'href' in props;
        var button = props.role === 'button';
        var tabIndex = 'tabIndex' in props;

        return hidden || !tabIndex || href || button;
    }
}];
var fail = exports.fail = [{
    when: 'anchor has tabIndexbut no button',
    // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/tabindex-no-positive
    render: function render(React) {
        return React.createElement('a', { tabIndex: 1 });
    }
}];

var pass = exports.pass = [{
    when: 'anchor has no `tabIndex`',
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    render: function render(React) {
        return React.createElement('a', null);
    }
}, {
    when: 'anchor has `role="button"`',
    // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/tabindex-no-positive
    render: function render(React) {
        return React.createElement('a', { role: 'button', tabIndex: 1 });
    }
}, {
    when: 'anchor has a `href`',
    // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/tabindex-no-positive
    render: function render(React) {
        return React.createElement('a', { href: 'foo', tabIndex: 1 });
    }
}, {
    when: 'the anchor is hidden',
    // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/tabindex-no-positive
    render: function render(React) {
        return React.createElement('a', { tabIndex: 1, 'aria-hidden': true });
    }
}];

var description = exports.description = '\nWhen an anchor has a `tabIndex`, but no `href` and no `role` properties,\nit is likely you are using it to emulate a `button`.  Prefer using `role="button"`\nor just use the `<button` element.\n';

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pass = exports.fail = exports.description = undefined;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    msg: 'This element does not support ARIA roles, states and properties.',
    AX: 'AX_ARIA_12',
    test: function test(tagName, props) {
        var reserved = Object.prototype.hasOwnProperty.call(_util.DOM, tagName) && _util.DOM[tagName].reserved || false;
        var prop = (0, _util.hasProp)(props, (0, _keys2.default)(_util.aria).concat('role'));

        return !reserved || !prop;
    }
}];
var description = exports.description = '\nCertain reserved DOM elements do not support ARIA roles, states and properties.\nThis is often because they are not visible, for example `meta`, `html`, `script`,\n`style`. This rule enforces that these DOM elements do not contain the `role` and/or\n`aria-*` props.\n';

var fail = exports.fail = [{
    when: 'the element should not be given any ARIA attributes',
    // eslint-disable-next-line jsx-a11y/aria-unsupported-elements
    render: function render(React) {
        return React.createElement('meta', { charSet: 'UTF-8', 'aria-hidden': 'false' });
    }
}];

var pass = exports.pass = [{
    when: 'the reserved element is not given an illegal prop',
    render: function render(React) {
        return React.createElement('meta', { charSet: 'UTF-8' });
    }
}, {
    when: 'an illegal prop is given to a non-reserved element',
    render: function render(React) {
        return React.createElement('div', { 'aria-hidden': true });
    }
}, {
    when: 'an illegal prop is given to an unknown element',
    render: function render(React) {
        return React.createElement('g', { 'aria-hidden': true });
    }
}];

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fail = exports.pass = exports.description = undefined;

var _util = __webpack_require__(57);

var description = exports.description = '\nKeyboard users move focus from one form control to the next by using the tab\nkey. By default focus order is determined by source order.\n\nThe `tabIndex` prop allows the author to specify an alternative tab order.\nElements with a `tabIndex` value greater than zero will receive focus in numerical\norder, ahead of focusable elements with a `tabIndex` of zero.\n\nIt is recommended that authors avoid positive values for the `tabIndex` attribute\nbecause it is brittle (any focusable elements added to the page without an\nexplicit `tabIndex` value greater than zero will come last in the tab order) and\ncan easily result in a page which is extremely difficult to navigate, causing\naccessibility problems.\n';

exports.default = [{
    msg: 'Avoid positive integer values for `tabIndex`.',
    AX: 'AX_FOCUS_03',
    test: function test(_, props) {
        (0, _util.warnRuleDeprecated)('avoid-positive-index', 'tabindex-no-positive');
        var tabIndex = (0, _util.hasProp)(props, 'tabIndex');
        return !tabIndex || props.tabIndex <= 0;
    }
}];
var pass = exports.pass = [{
    when: 'the element has no tabIndex',
    render: function render(React) {
        return React.createElement('div', null);
    }
}, {
    when: 'the element has a negative tabIndex',
    render: function render(React) {
        return React.createElement('div', { tabIndex: -1 });
    }
}, {
    when: 'the element has a tabIndex of zero',
    render: function render(React) {
        return React.createElement('div', { tabIndex: '0' });
    }
}];

var fail = exports.fail = [{
    when: 'the element has a positive tabIndex',
    // eslint-disable-next-line jsx-a11y/tabindex-no-positive
    render: function render(React) {
        return React.createElement('div', { tabIndex: 2 });
    }
}];

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = {
    msg: 'You have an `onClick` handler but did not define an `onKeyDown`, `onKeyUp` or `onKeyPress` handler. ' + 'Add it, and have the "Space" key do the same thing as an `onClick` handler.',
    url: 'https://www.w3.org/WAI/GL/wiki/Making_actions_keyboard_accessible_by_using_keyboard_event_handlers_with_WAI-ARIA_controls',
    affects: [_util.devices.keyboardOnly],
    test: function test(tagName, props) {
        (0, _util.warnRuleDeprecated)('button-role-space', 'click-events-have-key-events');
        var hidden = (0, _util.hiddenFromAT)(props);
        var onClick = (0, _util.listensTo)(props, 'onClick');
        var onKeyDown = (0, _util.listensTo)(props, 'onKeyDown');
        var onKeyUp = (0, _util.listensTo)(props, 'onKeyUp');
        var onKeyPress = (0, _util.listensTo)(props, 'onKeyPress');

        // rule passes when element is hidden,
        // has onClick and has an onKeyDown, onKeyUp or onKeyPress prop
        return hidden || !onClick || onKeyDown || onKeyUp || onKeyPress;
    }
};
var pass = exports.pass = [{
    when: 'there is an onClick handler and there is an onKeyDown handler.',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn, onKeyDown: _util.fn });
    }
}, {
    when: 'there is an onClick handler and there is an onKeyUp handler.',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn, onKeyUp: _util.fn });
    }
}, {
    when: 'there is an onClick handler and there is an onKeyPress handler.',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn, onKeyPress: _util.fn });
    }
}, {
    when: 'there is no onClick',
    render: function render(React) {
        return React.createElement(
            'div',
            null,
            'derp'
        );
    }
}, {
    when: 'the element is aria-hidden',
    render: function render(React) {
        return React.createElement('div', { 'aria-hidden': true, role: 'button' });
    }
}];

var fail = exports.fail = [{
    when: 'there is an onClick handler but no `onKeyDown`, `onKeyUp` or `onKeyPress` is present',
    render: function render(React) {
        return React.createElement('div', { onClick: _util.fn });
    }
}];

var description = exports.description = '\nEnforce that elements which have the `role="button"`\nalso have an `onKeyDown` or `onKeyPress` handler that handles Space or Enter\n(this is isn\'t actually checked) for people that are using a\nkeyboard-only device.\n';

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    tagName: 'label',
    msg: 'Form controls using a label to identify them must be ' + 'programmatically associated with the control using htmlFor',
    url: 'https://www.w3.org/WAI/tutorials/forms/labels',
    test: function test(tagName, props) {
        (0, _util.warnRuleDeprecated)('label-uses-for', 'label-has-for');
        var hidden = (0, _util.hiddenFromAT)(props);
        var hasfor = typeof props.htmlFor === 'string';
        return hidden || hasfor;
    }
}];
var pass = exports.pass = [{
    when: 'the label is hidden',
    // eslint-disable-next-line jsx-a11y/label-has-for
    render: function render(React) {
        return React.createElement('label', { 'aria-hidden': true });
    }
}, {
    when: 'the label has a valid `htmlFor` prop',
    render: function render(React) {
        return React.createElement('label', { htmlFor: 'foo' });
    }
}, {
    when: 'it is not a label',
    render: function render(React) {
        return React.createElement('div', null);
    }
}];

var fail = exports.fail = [{
    when: 'a label is not hidden and has no `htmlFor`',
    // eslint-disable-next-line jsx-a11y/label-has-for
    render: function render(React) {
        return React.createElement('label', null);
    }
}];

var description = exports.description = '\nEnforce label tags have `htmlFor` attribute. Form controls using a `label` to\nidentify them must have only one label that is programmatically associated with\nthe control using: `<label htmlFor={/* ID or name of control*/}>...</label>`.\n';

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.pass = exports.fail = undefined;

var _util = __webpack_require__(57);

var url = 'http://webaim.org/techniques/javascript/eventhandlers#onmouseover';
var affects = [_util.devices.keyboardOnly];

exports.default = [{
    msg: 'onMouseOver must be accompanied by onFocus for accessibility.',
    url: url,
    affects: affects,
    test: function test(tagName, props) {
        (0, _util.warnRuleDeprecated)('mouse-events-map-to-key-events', 'mouse-events-have-key-events');
        var mouseOver = (0, _util.listensTo)(props, 'onMouseOver');
        var focus = (0, _util.listensTo)(props, 'onFocus');

        return !mouseOver || focus;
    }
}, {
    msg: 'onMouseOut must be accompanied by onBlur for accessibility.',
    url: url,
    affects: affects,
    test: function test(tagName, props) {
        var mouseOut = (0, _util.listensTo)(props, 'onMouseOut');
        var blur = (0, _util.listensTo)(props, 'onBlur');

        return !mouseOut || blur;
    }
}];
var fail = exports.fail = [{
    when: 'there is `onMouseOver` but no `onFocus`',
    render: function render(React) {
        return React.createElement('div', { onMouseOver: _util.fn });
    }
}, {
    when: 'there is `onMouseOut` but no `onBlur`',
    render: function render(React) {
        return React.createElement('div', { onMouseOut: _util.fn });
    }
}];

var pass = exports.pass = [{
    when: 'there is no `onMouseOver` or `onMouseOut`',
    render: function render(React) {
        return React.createElement('div', null);
    }
}, {
    when: 'there is `onMouseOver` but and `onFocus`',
    render: function render(React) {
        return React.createElement('div', { onMouseOver: _util.fn, onFocus: _util.fn });
    }
}, {
    when: 'there is `onMouseOut` but and `onBlur`',
    render: function render(React) {
        return React.createElement('div', { onMouseOut: _util.fn, onBlur: _util.fn });
    }
}];

var description = exports.description = '\nEnforce `onMouseOver`/`onMouseOut` are accompanied by\n`onFocus`/`onBlur`. Coding for the keyboard is important for users with\nphysical disabilities who cannot use a mouse, AT compatability, and screenreader\nusers.\n';

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    msg: 'You have a click handler on a non-interactive element but no `tabIndex` DOM property. ' + 'The element will not be navigable or interactive by keyboard users.',
    url: 'http://www.w3.org/TR/wai-aria-practices/#focus_tabindex',
    affects: [_util.devices.keyboardOnly],
    test: function test(tagName, props) {
        (0, _util.warnRuleDeprecated)('onclick-uses-tabindex', 'interactive-supports-focus');
        var hidden = (0, _util.hiddenFromAT)(props);
        var interactive = (0, _util.isInteractive)(tagName, props);
        var onClick = (0, _util.listensTo)(props, 'onClick');
        var tabIndex = props.tabIndex !== undefined;

        return hidden || interactive || !onClick || tabIndex;
    }
}];
var pass = exports.pass = [{
    when: 'when there is an `onClick` with a `tabIndex`',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn, tabIndex: 0 });
    }
}, {
    when: 'the element is hidden from aria',
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn, 'aria-hidden': true });
    }
}, {
    when: 'the element is interactive',
    render: function render(React) {
        return React.createElement('button', { onClick: _util.fn });
    }
}];

var fail = exports.fail = [{
    when: 'there is an `onClick` with no `tabIndex`',
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    render: function render(React) {
        return React.createElement('span', { onClick: _util.fn });
    }
}];

var description = exports.description = '\nEnforce that elements that have an `onClick` handler also have\na `tabIndex` property.  If not, they will not be navigable by\nkeyboard users.\n';

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.options = exports.description = exports.pass = exports.fail = undefined;

var _util = __webpack_require__(57);

var def = ['image', 'picture', 'photo'];

exports.default = [{
    tagName: 'img',
    msg: 'Redundant `alt` attribute. Screen-readers already announce `img` tags as an image. ' + 'You don\'t need to use the words like `image`, `photo,` or `picture` in the alt prop.',
    url: 'http://webaim.org/techniques/alttext',
    affects: [_util.devices.screenReaders],
    test: function test(_, props, _c, ctx) {
        (0, _util.warnRuleDeprecated)('redundant-alt', 'img-redundant-alt');
        var hidden = (0, _util.hiddenFromAT)(props);
        var alt = (props.alt || '').toLowerCase();
        var words = ctx.options[0] || def;
        var contains = words.reduce(function (acc, word) {
            return acc || alt.indexOf(word) >= 0;
        }, false);

        return hidden || !contains;
    }
}];
var fail = exports.fail = [{
    when: 'is a redundant alt message',
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'bar image foo' });
    }
}, {
    when: 'is a redundant alt message (different opts)',
    opts: [['foto']],
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'bar foto' });
    }
}];

var pass = exports.pass = [{
    when: 'the `alt` does not contain redundant words',
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'nice' });
    }
}, {
    when: 'the `alt` does not contain redundant words (different opts)',
    opts: [['foto']],
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'image' });
    }
}, {
    when: 'the element is aria-hidden',
    render: function render(React) {
        return React.createElement('img', { src: 'foo', alt: 'nice', 'aria-hidden': true });
    }
}];

var description = exports.description = '\nEnforce img alt attribute does not contain the word image, picture, or photo.\nScreenreaders already announce `img` elements as an image. There is no need to use\nwords such as *image*, *photo*, and/or *picture*.\n';

var options = exports.options = [{
    type: 'Array(String)',
    description: 'Words to look for when looking for redudant words.',
    def: def
}];

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.fail = exports.pass = undefined;

var _util = __webpack_require__(57);

exports.default = [{
    msg: '`onBlur` should be preferred over `onChange`, unless absolutely necessary ' + 'and it has no negative consequences for keyboard only or screen-reader users.',
    url: 'http://webaim.org/techniques/javascript/eventhandlers#onchange',
    affects: [_util.devices.keyboardOnly, _util.devices.screenReaders],
    test: function test(tagName, props) {
        (0, _util.warnRuleDeprecated)('use-onblur-not-onchange', 'no-onchange');
        var hidden = (0, _util.hiddenFromAT)(props);
        var disabled = (0, _util.trueish)(props, 'aria-disabled');
        var readOnly = (0, _util.trueish)(props, 'aria-readonly');
        var onChange = (0, _util.listensTo)(props, 'onChange');
        var onBlur = (0, _util.listensTo)(props, 'onBlur');

        return hidden || disabled || readOnly || !onChange || onChange && onBlur;
    }
}];
var pass = exports.pass = [{
    when: 'there is no `onChange` prop',
    render: function render(React) {
        return React.createElement('input', null);
    }
}, {
    when: 'the element is aria-hidden',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, 'aria-hidden': true });
    }
}, {
    when: 'the element is aria-disabled',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, 'aria-disabled': true });
    }
}, {
    when: 'the element is aria-readonly',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, 'aria-readonly': true });
    }
}, {
    when: 'the `onChange` prop is present along with an `onBlur` prop',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn, onBlur: _util.fn });
    }
}];

var fail = exports.fail = [{
    when: 'the `onChange` prop is present without an `onBlur` prop',
    render: function render(React) {
        return React.createElement('input', { onChange: _util.fn });
    }
}];

var description = exports.description = '\nEnforce usage of onBlur over onChange for accessibility. onBlur must be used\ninstead of onChange, unless absolutely necessary and it causes no negative\nconsequences for keyboard only or screen reader users.\n';

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.description = exports.pass = exports.fail = undefined;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roles = (0, _keys2.default)(_util.role);

exports.default = [{
    msg: 'Elements with ARIA roles must use a valid, non-abstract ARIA role.',
    url: 'https://www.w3.org/TR/wai-aria/roles',
    AX: 'AX_ARIA_01',
    test: function test(tagName, props) {
        (0, _util.warnRuleDeprecated)('valid-aria-role', 'aria-role');
        var hasRole = (0, _util.hasProp)(props, 'role');
        return !hasRole || roles.indexOf(props.role) >= 0;
    }
}];
var fail = exports.fail = [{
    when: 'there is an invalid `role`',
    // eslint-disable-next-line jsx-a11y/aria-role
    render: function render(React) {
        return React.createElement('div', { role: 'foo' });
    }
}];

var pass = exports.pass = [{
    when: 'there is a role and it is valid',
    render: function render(React) {
        return React.createElement('div', { role: 'button' });
    }
}, {
    when: 'there is no `role`',
    render: function render(React) {
        return React.createElement('div', null);
    }
}];

var description = exports.description = '\nThe ARIA roles model requires that elements with a role attribute use a valid,\nnon-abstract ARIA role. Each non-abstract ARIA role is mapped on to a known set\nof behavior by the user agent or assistive technology, so using an unknown role\nwill result in the desired behavior not being available to the user.\n\nYou can find a list of valid ARIA roles, along with descriptions and information\non additional required attributes, on the\n[WAI-ARIA](http://www.w3.org/TR/wai-aria/roles#roles_categorization) site.\n';

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pass = exports.fail = exports.description = undefined;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _util = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    msg: 'This element does not support ARIA roles, states and properties.',
    AX: 'AX_ARIA_12',
    test: function test(tagName, props) {
        (0, _util.warnRuleDeprecated)('no-unsupported-elements-use-aria', 'aria-unsupported-elements');
        var reserved = Object.prototype.hasOwnProperty.call(_util.DOM, tagName) && _util.DOM[tagName].reserved || false;
        var prop = (0, _util.hasProp)(props, (0, _keys2.default)(_util.aria).concat('role'));

        return !reserved || !prop;
    }
}];
var description = exports.description = '\nCertain reserved DOM elements do not support ARIA roles, states and properties.\nThis is often because they are not visible, for example `meta`, `html`, `script`,\n`style`. This rule enforces that these DOM elements do not contain the `role` and/or\n`aria-*` props.\n';

var fail = exports.fail = [{
    when: 'the element should not be given any ARIA attributes',
    // eslint-disable-next-line jsx-a11y/aria-unsupported-elements
    render: function render(React) {
        return React.createElement('meta', { charSet: 'UTF-8', 'aria-hidden': 'false' });
    }
}];

var pass = exports.pass = [{
    when: 'the reserved element is not given an illegal prop',
    render: function render(React) {
        return React.createElement('meta', { charSet: 'UTF-8' });
    }
}, {
    when: 'an illegal prop is given to a non-reserved element',
    render: function render(React) {
        return React.createElement('div', { 'aria-hidden': true });
    }
}, {
    when: 'an illegal prop is given to an unknown element',
    render: function render(React) {
        return React.createElement('g', { 'aria-hidden': true });
    }
}];

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 1653;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

var baseInverter = __webpack_require__(1655);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(220);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Parser = __webpack_require__(1657),
    RegexpVisitor = __webpack_require__(1659),
    ReverseVisitor = __webpack_require__(1660);

Route.prototype = Object.create(null)

/**
 * Match a path against this route, returning the matched parameters if
 * it matches, false if not.
 * @example
 * var route = new Route('/this/is/my/route')
 * route.match('/this/is/my/route') // -> {}
 * @example
 * var route = new Route('/:one/:two')
 * route.match('/foo/bar/') // -> {one: 'foo', two: 'bar'}
 * @param  {string} path the path to match this route against
 * @return {(Object.<string,string>|false)} A map of the matched route
 * parameters, or false if matching failed
 */
Route.prototype.match = function(path) {
  var re = RegexpVisitor.visit(this.ast),
      matched = re.match(path);

  return matched ? matched : false;

};

/**
 * Reverse a route specification to a path, returning false if it can't be
 * fulfilled
 * @example
 * var route = new Route('/:one/:two')
 * route.reverse({one: 'foo', two: 'bar'}) -> '/foo/bar'
 * @param  {Object} params The parameters to fill in
 * @return {(String|false)} The filled in path
 */
Route.prototype.reverse = function(params) {
  return ReverseVisitor.visit(this.ast, params);
};

/**
 * Represents a route
 * @example
 * var route = Route('/:foo/:bar');
 * @example
 * var route = Route('/:foo/:bar');
 * @param {string} spec -  the string specification of the route.
 *     use :param for single portion captures, *param for splat style captures,
 *     and () for optional route branches
 * @constructor
 */
function Route(spec) {
  var route;
  if (this) {
    // constructor called with new
    route = this;
  } else {
    // constructor called as a function
    route = Object.create(Route.prototype);
  }
  if( typeof spec === 'undefined' ) {
    throw new Error('A route spec is required');
  }
  route.spec = spec;
  route.ast = Parser.parse(spec);
  return route;
}

module.exports = Route;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @module route/parser
 */


/** Wrap the compiled parser with the context to create node objects */
var parser = __webpack_require__(1658).parser;
parser.yy = __webpack_require__(814);
module.exports = parser;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

/* parser generated by jison 0.4.17 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,9],$V1=[1,10],$V2=[1,11],$V3=[1,12],$V4=[5,11,12,13,14,15];
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"root":3,"expressions":4,"EOF":5,"expression":6,"optional":7,"literal":8,"splat":9,"param":10,"(":11,")":12,"LITERAL":13,"SPLAT":14,"PARAM":15,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",11:"(",12:")",13:"LITERAL",14:"SPLAT",15:"PARAM"},
productions_: [0,[3,2],[3,1],[4,2],[4,1],[6,1],[6,1],[6,1],[6,1],[7,3],[8,1],[9,1],[10,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
return new yy.Root({},[$$[$0-1]])
break;
case 2:
return new yy.Root({},[new yy.Literal({value: ''})])
break;
case 3:
this.$ = new yy.Concat({},[$$[$0-1],$$[$0]]);
break;
case 4: case 5:
this.$ = $$[$0];
break;
case 6:
this.$ = new yy.Literal({value: $$[$0]});
break;
case 7:
this.$ = new yy.Splat({name: $$[$0]});
break;
case 8:
this.$ = new yy.Param({name: $$[$0]});
break;
case 9:
this.$ = new yy.Optional({},[$$[$0-1]]);
break;
case 10:
this.$ = yytext;
break;
case 11: case 12:
this.$ = yytext.slice(1);
break;
}
},
table: [{3:1,4:2,5:[1,3],6:4,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},{1:[3]},{5:[1,13],6:14,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},{1:[2,2]},o($V4,[2,4]),o($V4,[2,5]),o($V4,[2,6]),o($V4,[2,7]),o($V4,[2,8]),{4:15,6:4,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},o($V4,[2,10]),o($V4,[2,11]),o($V4,[2,12]),{1:[2,1]},o($V4,[2,3]),{6:14,7:5,8:6,9:7,10:8,11:$V0,12:[1,16],13:$V1,14:$V2,15:$V3},o($V4,[2,9])],
defaultActions: {3:[2,2],13:[2,1]},
parseError: function parseError(str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        function _parseError (msg, hash) {
            this.message = msg;
            this.hash = hash;
        }
        _parseError.prototype = Error;

        throw new _parseError(str, hash);
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function (match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex() {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState() {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState(condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:return "(";
break;
case 1:return ")";
break;
case 2:return "SPLAT";
break;
case 3:return "PARAM";
break;
case 4:return "LITERAL";
break;
case 5:return "LITERAL";
break;
case 6:return "EOF";
break;
}
},
rules: [/^(?:\()/,/^(?:\))/,/^(?:\*+\w+)/,/^(?::+\w+)/,/^(?:[\w%\-~\n]+)/,/^(?:.)/,/^(?:$)/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (true) {
exports.parser = parser;
exports.Parser = parser.Parser;
exports.parse = function () { return parser.parse.apply(parser, arguments); };
}

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createVisitor  = __webpack_require__(815),
    escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;

/**
 * @class
 * @private
 */
function Matcher(options) {
  this.captures = options.captures;
  this.re = options.re;
}

/**
 * Try matching a path against the generated regular expression
 * @param  {String} path The path to try to match
 * @return {Object|false}      matched parameters or false
 */
Matcher.prototype.match = function (path) {
  var match = this.re.exec(path),
      matchParams = {};

  if( !match ) {
    return;
  }

  this.captures.forEach( function(capture, i) {
    if( typeof match[i+1] === 'undefined' ) {
      matchParams[capture] = undefined;
    }
    else {
      matchParams[capture] = decodeURIComponent(match[i+1]);
    }
  });

  return matchParams;
};

/**
 * Visitor for the AST to create a regular expression matcher
 * @class RegexpVisitor
 * @borrows Visitor-visit
 */
var RegexpVisitor = createVisitor({
  'Concat': function(node) {
    return node.children
      .reduce(
        function(memo, child) {
          var childResult = this.visit(child);
          return {
            re: memo.re + childResult.re,
            captures: memo.captures.concat(childResult.captures)
          };
        }.bind(this),
        {re: '', captures: []}
      );
  },
  'Literal': function(node) {
    return {
      re: node.props.value.replace(escapeRegExp, '\\$&'),
      captures: []
    };
  },

  'Splat': function(node) {
    return {
      re: '([^?]*?)',
      captures: [node.props.name]
    };
  },

  'Param': function(node) {
    return {
      re: '([^\\/\\?]+)',
      captures: [node.props.name]
    };
  },

  'Optional': function(node) {
    var child = this.visit(node.children[0]);
    return {
      re: '(?:' + child.re + ')?',
      captures: child.captures
    };
  },

  'Root': function(node) {
    var childResult = this.visit(node.children[0]);
    return new Matcher({
      re: new RegExp('^' + childResult.re + '(?=\\?|$)' ),
      captures: childResult.captures
    });
  }
});

module.exports = RegexpVisitor;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createVisitor  = __webpack_require__(815);

/**
 * Visitor for the AST to construct a path with filled in parameters
 * @class ReverseVisitor
 * @borrows Visitor-visit
 */
var ReverseVisitor = createVisitor({
  'Concat': function(node, context) {
    var childResults =  node.children
      .map( function(child) {
        return this.visit(child,context);
      }.bind(this));

    if( childResults.some(function(c) { return c === false; }) ) {
      return false;
    }
    else {
      return childResults.join('');
    }
  },

  'Literal': function(node) {
    return decodeURI(node.props.value);
  },

  'Splat': function(node, context) {
    if( context[node.props.name] ) {
      return context[node.props.name];
    }
    else {
      return false;
    }
  },

  'Param': function(node, context) {
    if( context[node.props.name] ) {
      return context[node.props.name];
    }
    else {
      return false;
    }
  },

  'Optional': function(node, context) {
    var childResult = this.visit(node.children[0], context);
    if( childResult ) {
      return childResult;
    }
    else {
      return '';
    }
  },

  'Root': function(node, context) {
    context = context || {};
    var childResult = this.visit(node.children[0], context);
    if( !childResult ) {
      return false;
    }
    return encodeURI(childResult);
  }
});

module.exports = ReverseVisitor;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return '%' + x.charCodeAt(0).toString(16).toUpperCase();
  });
};

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	var separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ref;

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

/*
    Note: Besides defining DR routes, this is used also by build/buildConfig.js
          for the dev build.

    If you make any changes/additions to these URLs, you might need to restart
    your local dev server to see the changes.
*/

exports.default = new _immutable.Map((_ref = {}, _ref[_AppConstants.DelayRepayPages.CUSTOMER] = '/customer-details', _ref[_AppConstants.DelayRepayPages.CLAIMS] = '/claims', _ref[_AppConstants.DelayRepayPages.PAYMENT] = '/payment-method', _ref[_AppConstants.DelayRepayPages.CONFIRM] = '/confirm', _ref[_AppConstants.CompensationPages.DETAILS] = '/compensation', _ref[_AppConstants.CompensationPages.PRE_APPROVED] = '/compensation/pre-approved', _ref[_AppConstants.CompensationPages.SEASON] = '/compensation/apply', _ref[_AppConstants.CompensationPages.NON_SEASON] = '/compensation/non-season', _ref[_AppConstants.AutoDelayRepayPages.SUBSCRIPTION] = '/auto/:action/:token', _ref[_AppConstants.AccountPages.AUTO_DELAY_REPAY] = '/account/auto-delay-repay', _ref));

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Currency = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  See https://developers.google.com/tag-manager/enhanced-ecommerce
 *  and https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce
 *  and https://www.simoahava.com/analytics/enhanced-ecommerce-guide-for-google-tag-manager/
 */

var EcommerceHelper = {
    wrapper: function wrapper(data) {
        return {
            ecommerce: data
        };
    },
    purchase: function purchase(order) {
        var _this = this;

        var products = order.trips.reduce(function (p, trip) {
            return p.concat(_this.productsFromTrip(trip));
        }, new _immutable.List());

        return this.wrapper({
            'purchase': {
                'actionField': {
                    'id': order.id,
                    'affiliation': _config2.default.get('brand'),
                    'revenue': (0, _Currency.toPounds)(order.totalPrice),
                    'tax': 0,
                    'shipping': (0, _Currency.toPounds)(order.delivery.price)
                },
                products: products.toJS()
            }
        });
    },
    getTocs: function getTocs(fare) {
        var journeys = [fare.outwardJourney, fare.returnJourney];
        var tocs = [];

        journeys.map(function (journey) {
            if (journey) {
                journey.legs.map(function (_ref) {
                    var toc = _ref.toc;

                    if (toc && tocs.indexOf(toc.name) === -1) {
                        tocs.push(toc.name);
                    }
                });
            }
        });

        return tocs.sort().join(', ');
    },
    productFromTicket: function productFromTicket(fare, ticket) {
        var adults = ticket.adults,
            children = ticket.children,
            railcard = ticket.railcard,
            price = ticket.price;
        var origin = fare.origin,
            destination = fare.destination,
            route = fare.route,
            ticketType = fare.ticketType,
            restrictionCode = fare.restrictionCode,
            crossLondon = fare.crossLondon,
            discountCode = fare.discountCode,
            returnJourney = fare.returnJourney;
        var isReturn = ticketType.isReturn,
            isSeason = ticketType.isSeason,
            isAdvance = ticketType.isAdvance,
            isPackage = ticketType.isPackage,
            isFirstClass = ticketType.isFirstClass,
            validityCode = ticketType.validityCode;

        var id = [origin.nlc, destination.nlc, route.code, ticketType.code].join('-');
        var name = [ticketType.name, origin.name, destination.name, route.description].join(' - ');
        var category = ticketType.name;
        var originCodeName = [origin.nlc, origin.name].join(' - ');
        var destinationCodeName = [destination.nlc, destination.name].join(' - ');
        var routeCodeName = [route.code, route.name].join(' - ');

        var product = {
            id: id,
            name: name,
            price: (0, _Currency.toPounds)(price),
            quantity: adults || children,
            variant: children ? 'child' : 'adult',
            brand: this.getTocs(fare),
            category: category,
            dimension6: originCodeName,
            dimension7: destinationCodeName,
            dimension8: routeCodeName,
            dimension9: isReturn,
            dimension10: isSeason,
            dimension11: isAdvance,
            dimension12: isPackage,
            dimension13: isFirstClass,
            dimension14: validityCode,
            dimension15: restrictionCode || 'none',
            dimension16: crossLondon,
            dimension17: discountCode || 'none',
            dimension18: fare.getDepartureTime() ? fare.getDepartureTime().format('YYYY-MM-DDTHH:mm:ss') : 'none',
            dimension19: returnJourney && returnJourney.getDepartureTime() ? returnJourney.getDepartureTime().format('YYYY-MM-DDTHH:mm:ss') : 'none'
        };

        if (railcard) {
            product.coupon = railcard.name;
        }

        return product;
    },
    productsFromTrip: function productsFromTrip(orderTrip) {
        var _this2 = this;

        var fares = orderTrip.getProducts();
        var products = fares.map(function (fare) {
            return fare.tickets.map(function (ticket) {
                var data = _this2.productFromTicket(fare, ticket);
                return fare.isFlexi() ? (0, _assign2.default)(data, { quantity: 1 }) : data;
            });
        }).flatten(1).toJS();
        return products;
    },
    addToBasket: function addToBasket(orderTrip) {
        return this.wrapper({
            currencyCode: 'GBP',
            'add': {
                products: this.productsFromTrip(orderTrip)
            }
        });
    },
    orderStarted: function orderStarted(id) {
        return this.wrapper({
            'checkout': {
                'id': id,
                'actionField': { 'step': 1, 'option': 'order-started' }
            }
        });
    },
    deliveryPage: function deliveryPage(id) {
        return this.wrapper({
            'checkout': {
                'id': id,
                'actionField': { 'step': 2 }
            }
        });
    },
    deliveryMethod: function deliveryMethod(id, _deliveryMethod) {
        return this.wrapper({
            'checkout_option': {
                'id': id,
                'actionField': { 'step': 2, 'option': _deliveryMethod }
            }
        });
    },
    paymentPage: function paymentPage(id) {
        return this.wrapper({
            'checkout': {
                'id': id,
                'actionField': { 'step': 3 }
            }
        });
    },
    paymentMethod: function paymentMethod(id, _paymentMethod) {
        return this.wrapper({
            'checkout_option': {
                'id': id,
                'actionField': { 'step': 3, 'option': _paymentMethod }
            }
        });
    },
    removeFromBasket: function removeFromBasket(orderTrip) {
        return this.wrapper({
            'remove': {
                products: this.productsFromTrip(orderTrip)
            }
        });
    }
};

exports.default = EcommerceHelper;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(87);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AmazonLoginStore.js": 352,
	"./AmazonPayStore.js": 1002,
	"./AmendStore.js": 1094,
	"./BannerStore.js": 458,
	"./BaseStore.js": 22,
	"./BraintreeStore.js": 1097,
	"./CallingPointsStore.js": 622,
	"./CharityStore.js": 1043,
	"./CollectionStationsStore.js": 1008,
	"./ConsentsStore.js": 459,
	"./CountryStore.js": 457,
	"./CurrentTripStore.js": 175,
	"./DataLayerStore.js": 664,
	"./DaySaveStore.js": 1124,
	"./DimensionsStore.js": 115,
	"./DiscountStore.js": 1125,
	"./DisruptionAlertStore.js": 345,
	"./EligibleServicesStore.js": 1126,
	"./FamilyVerificationStore.js": 638,
	"./FareHandOffStore.js": 1127,
	"./FavouritesStore.js": 271,
	"./FeatureFlagStore.js": 27,
	"./FeatureVariantStore.js": 534,
	"./InAppStore.js": 160,
	"./JourneyNotificationStore.js": 1000,
	"./JourneyStore.js": 610,
	"./JourneySupportStore.js": 1009,
	"./KeyGoStore.js": 1004,
	"./KeyGoTapsStore.js": 1128,
	"./KeyGoTransactionsStore.js": 1129,
	"./LayoutStore.js": 832,
	"./LinkingSmartcardsStore.js": 348,
	"./LoadingStore.js": 455,
	"./ModalStore.js": 833,
	"./NotificationCentreStore.js": 542,
	"./NotificationStore.js": 876,
	"./OpenGolfStore.js": 1137,
	"./OrderHistoryStore.js": 1021,
	"./OrderStore.js": 80,
	"./PassengerAssistStore.js": 173,
	"./Pay360Store.js": 1044,
	"./PaymentCardStore.js": 1064,
	"./PaymentStore.js": 418,
	"./PaypalStore.js": 1056,
	"./PhotocardStore.js": 1065,
	"./PreviousSearchesStore.js": 621,
	"./PromoCodeStore.js": 342,
	"./Railcard1617Store.js": 996,
	"./RailcardsStore.js": 608,
	"./RecentStationsStore.js": 877,
	"./RefundStore.js": 1079,
	"./ReservationRequestStore.js": 676,
	"./ReservationStore.js": 641,
	"./RoversRangersStore.js": 1142,
	"./SeasonFiltersStore.js": 1143,
	"./SeasonTicketsStore.js": 1144,
	"./SeatingStore.js": 1022,
	"./SelectedStore.js": 1867,
	"./SmartCarnetStore.js": 1032,
	"./SmartcardCTAStore.js": 1081,
	"./SmartcardJourneyStore.js": 1145,
	"./SmartcardStore.js": 129,
	"./StationFinderStore.js": 990,
	"./StationStore.js": 429,
	"./TocOnlyStore.js": 1014,
	"./TokenStore.js": 281,
	"./TripsStore.js": 879,
	"./TutorialStore.js": 963,
	"./UserStore.js": 32,
	"./VisaCheckoutStore.js": 1045,
	"./VoucherStore.js": 997,
	"./WidgetAuthStore.js": 880,
	"./useStoreState.js": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1668;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _immutable = __webpack_require__(5);

var _PlusBus = __webpack_require__(1670);

var _PlusBus2 = _interopRequireDefault(_PlusBus);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    outwardSingle: null,
    returnSingle: null,
    'return': null,
    season: null,
    fareOnly: null,
    plusBus: new _PlusBus2.default()
};

var OrderTripFares = function (_record) {
    (0, _inherits3.default)(OrderTripFares, _record);

    function OrderTripFares() {
        (0, _classCallCheck3.default)(this, OrderTripFares);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderTripFares.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(OrderTripFares, json, {
            outwardSingle: _LinkMapper.resolve.as(_Fare2.default),
            returnSingle: _LinkMapper.resolve.as(_Fare2.default),
            'return': _LinkMapper.resolve.as(_Fare2.default),
            season: _LinkMapper.resolve.as(_Fare2.default),
            fareOnly: _LinkMapper.resolve.as(_Fare2.default),
            plusBus: _LinkMapper.resolve.as(_PlusBus2.default)
        });
    };

    OrderTripFares.prototype.getDaySaveFare = function getDaySaveFare() {
        return this.find(function (fare) {
            return fare instanceof _Fare2.default && fare.isDaySave();
        });
    };

    OrderTripFares.prototype.getRoversRangersFare = function getRoversRangersFare() {
        return this.find(function (fare) {
            return fare instanceof _Fare2.default && fare.isRoversRangers();
        });
    };

    OrderTripFares.prototype.getSmartCarnetFare = function getSmartCarnetFare() {
        return this.find(function (fare) {
            return fare instanceof _Fare2.default && fare.isSmartCarnet();
        });
    };

    OrderTripFares.prototype.isOpenReturn = function isOpenReturn() {
        return this.return && (0, _result3.default)(this, 'return.returnJourney.legs.isEmpty');
    };

    OrderTripFares.prototype.hasTravelcard = function hasTravelcard() {
        return this.outwardSingle && this.outwardSingle.isTravelcard() || this.returnSingle && this.returnSingle.isTravelcard() || this.return && this.return.isTravelcard() || this.season && this.season.isTravelcard() || this.fareOnly && this.fareOnly.isTravelcard();
    };

    OrderTripFares.prototype.isCrossLondon = function isCrossLondon() {
        return this.outwardSingle && this.outwardSingle.isCrossLondon() || this.returnSingle && this.returnSingle.isCrossLondon() || this.return && this.return.isCrossLondon() || this.season && this.season.isCrossLondon() || this.fareOnly && this.fareOnly.isCrossLondon();
    };

    return OrderTripFares;
}((0, _immutable.Record)(defaults));

exports.default = OrderTripFares;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _reduce2 = __webpack_require__(219);

var _reduce3 = _interopRequireDefault(_reduce2);

var _immutable = __webpack_require__(5);

var _PlusBus2 = __webpack_require__(343);

var _PlusBus3 = _interopRequireDefault(_PlusBus2);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makePortionFares(portion) {
    if (!portion) {
        return null;
    }

    return new _immutable.Map({
        origin: (0, _LinkMapper.resolve)(portion.origin).as(_Fare2.default),
        destination: (0, _LinkMapper.resolve)(portion.destination).as(_Fare2.default)
    });
}

var OrderPlusBus = function (_PlusBus) {
    (0, _inherits3.default)(OrderPlusBus, _PlusBus);

    function OrderPlusBus() {
        (0, _classCallCheck3.default)(this, OrderPlusBus);
        return (0, _possibleConstructorReturn3.default)(this, _PlusBus.apply(this, arguments));
    }

    OrderPlusBus.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


        // NOTE: Reserved naming issues may arise by using "return"
        var outward = (0, _LinkMapper.resolve)(json.outward).with(makePortionFares);
        var inward = (0, _LinkMapper.resolve)(json.return).with(makePortionFares);

        var result = { outward: outward, return: inward };

        return new OrderPlusBus(result);
    };

    OrderPlusBus.prototype.getTotalPrice = function getTotalPrice() {
        var _this2 = this;

        return (0, _reduce3.default)(_PlusBus2.options, function (total, option) {
            var terminal = _this2.getTerminal.apply(_this2, option);
            if (terminal) {
                return total + terminal.getTotalPrice();
            }
            return total;
        }, 0);
    };

    OrderPlusBus.prototype.matchesOriginOrDestination = function matchesOriginOrDestination(fare, direction) {
        var _this3 = this;

        var matches = (0, _compact3.default)(["origin", "destination"].map(function (val) {
            var portion = _this3.getPortion(direction);
            if (!portion) {
                return false;
            }

            var plusBus = portion.get(val);
            if (!plusBus) {
                return false;
            }

            return plusBus.destination.equals(fare.destination) && plusBus.origin.equals(fare.origin);
        }));

        return matches.length >= 1;
    };

    return OrderPlusBus;
}(_PlusBus3.default);

exports.default = OrderPlusBus;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(237);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var Setter = new _immutable.Record({
    code: null,
    name: null
});

Setter.fromJSON = function (json) {
    json = json || {};

    var _resolve$with = (0, _LinkMapper.resolve)(json).with(Object),
        code = _resolve$with.code,
        name = _resolve$with.name;

    return new Setter({
        code: code,
        name: name
    });
};

exports.default = Setter;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    numberOfTickets: 0,
    text: ''
};

var FlexiInformation = function (_record) {
    (0, _inherits3.default)(FlexiInformation, _record);

    function FlexiInformation() {
        (0, _classCallCheck3.default)(this, FlexiInformation);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    FlexiInformation.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(FlexiInformation, json, {
            numberOfTickets: _LinkMapper.fields.number,
            text: _LinkMapper.fields.string
        });
    };

    return FlexiInformation;
}((0, _immutable.Record)(defaults));

exports.default = FlexiInformation;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Currency = __webpack_require__(169);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    differenceAmount: null,
    differenceInPercentage: null,
    numberOfTickets: null,
    priceOfTicketToCompare: null,
    ticketTypeRef: null
};

var FarePriceComparison = function (_record) {
    (0, _inherits3.default)(FarePriceComparison, _record);

    function FarePriceComparison() {
        (0, _classCallCheck3.default)(this, FarePriceComparison);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    FarePriceComparison.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(FarePriceComparison, json, {
            differenceAmount: _LinkMapper.fields.number,
            differenceInPercentage: _LinkMapper.fields.number,
            numberOfTickets: _LinkMapper.fields.number,
            priceOfTicketToCompare: _LinkMapper.fields.number,
            ticketTypeRef: _LinkMapper.resolve.as(_TicketType2.default)
        });
    };

    FarePriceComparison.prototype.isEmpty = function isEmpty() {
        return this.differenceInPercentage === null;
    };

    FarePriceComparison.prototype.getComparedTicketName = function getComparedTicketName() {
        return this.ticketTypeRef.name;
    };

    FarePriceComparison.prototype.getRoundedDifference = function getRoundedDifference() {
        return Math.floor((0, _Currency.toPounds)(this.differenceAmount));
    };

    return FarePriceComparison;
}((0, _immutable.Record)(defaults));

exports.default = FarePriceComparison;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(237);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(254);
var strRepeat = __webpack_require__(1677);

module.exports = function pad(str, length, padStr, type) {
  str = makeString(str);
  length = ~~length;

  var padlen = 0;

  if (!padStr)
    padStr = ' ';
  else if (padStr.length > 1)
    padStr = padStr.charAt(0);

  switch (type) {
  case 'right':
    padlen = length - str.length;
    return str + strRepeat(padStr, padlen);
  case 'both':
    padlen = length - str.length;
    return strRepeat(padStr, Math.ceil(padlen / 2)) + str + strRepeat(padStr, Math.floor(padlen / 2));
  default: // 'left'
    padlen = length - str.length;
    return strRepeat(padStr, padlen) + str;
  }
};


/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports = function strRepeat(str, qty){
  if (qty < 1) return '';
  var result = '';
  while (qty > 0) {
    if (qty & 1) result += str;
    qty >>= 1, str += str;
  }
  return result;
};


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    code: null,
    description: null,
    name: null,
    percentage: null,
    isPromotional: null
};

var Discount = function (_record) {
    (0, _inherits3.default)(Discount, _record);

    function Discount() {
        (0, _classCallCheck3.default)(this, Discount);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Discount.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Discount, json, {
            code: _LinkMapper.fields.string,
            description: _LinkMapper.fields.string,
            name: _LinkMapper.fields.string,
            percentage: _LinkMapper.fields.number,
            isPromotional: _LinkMapper.fields.boolean
        });
    };

    return Discount;
}((0, _immutable.Record)(defaults));

exports.default = Discount;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    id: [_LinkMapper.fields.number],
    orderId: [_LinkMapper.fields.number],
    ticketId: [_LinkMapper.fields.number],
    created: [_LinkMapper.fields.datetime],
    issuedDate: [_LinkMapper.fields.datetime],
    issuedTicketNumber: [_LinkMapper.fields.number]
};
var defaults = (0, _Records.getDefaults)(schema);

var OrderTicket = function (_record) {
    (0, _inherits3.default)(OrderTicket, _record);

    function OrderTicket() {
        (0, _classCallCheck3.default)(this, OrderTicket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderTicket.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(OrderTicket, (0, _defaults3.default)(json, defaults), (0, _Records.getResolvers)(schema));
    };

    return OrderTicket;
}((0, _immutable.Record)(defaults));

exports.default = OrderTicket;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = __webpack_require__(5);

var _TOC = __webpack_require__(817);

var _TOC2 = _interopRequireDefault(_TOC);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _BikeSeat = __webpack_require__(1681);

var _BikeSeat2 = _interopRequireDefault(_BikeSeat);

var _Seat = __webpack_require__(1682);

var _Seat2 = _interopRequireDefault(_Seat);

var _AppConstants = __webpack_require__(6);

var _LinkMapper = __webpack_require__(8);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    origin: new _Station2.default(),
    destination: new _Station2.default(),
    departure: null,
    arrival: null,
    transferTime: null,
    mode: null,
    toc: null,
    facilities: new _immutable.List(),
    seats: new _immutable.List(),
    bikeSeats: new _immutable.List(),
    rsid: null,
    tuid: null,
    isTemporaryTrain: false
};

var LONDON_TERMINALS = "LT";

var OrderLeg = function (_record) {
    (0, _inherits3.default)(OrderLeg, _record);

    function OrderLeg() {
        (0, _classCallCheck3.default)(this, OrderLeg);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderLeg.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var reducedFacilities = (0, _classnames2.default)(json.facilities).split(' ');

        return new OrderLeg({
            id: (0, _LinkMapper.resolve)(json.id).with(String),
            origin: (0, _LinkMapper.resolve)(json.origin).as(_Station2.default),
            destination: (0, _LinkMapper.resolve)(json.destination).as(_Station2.default),
            departure: (0, _LinkMapper.resolve)(json.departure).with(_TrainTime2.default),
            arrival: (0, _LinkMapper.resolve)(json.arrival).with(_TrainTime2.default),
            transferTime: (0, _LinkMapper.resolve)(json.transferTime).with(Number),
            mode: (0, _LinkMapper.resolve)(json.mode).with(String),
            toc: (0, _LinkMapper.resolve)(json.toc).as(_TOC2.default),
            facilities: (0, _LinkMapper.resolveAll)((0, _compact3.default)(reducedFacilities)).with(String),
            seats: (0, _LinkMapper.resolveAll)(json.seats).as(_Seat2.default),
            bikeSeats: (0, _LinkMapper.resolveAll)(json.bikeSeats).as(_BikeSeat2.default),
            rsid: (0, _LinkMapper.resolve)(json.rsid).with(String),
            tuid: (0, _LinkMapper.resolve)(json.tuid).with(String),
            isTemporaryTrain: (0, _LinkMapper.resolve)(json.isTemporaryTrain).with(Boolean)
        });
    };

    OrderLeg.prototype.getTrainUid = function getTrainUid() {
        return this.get('tuid');
    };

    OrderLeg.prototype.getSeats = function getSeats() {
        var brand = _config2.default.get('brand');
        var seats = this.get('seats');

        if (brand === 'transpennine') {
            return seats;
        }

        return seats.filterNot(function (seat) {
            return seat.isCountedPlace();
        });
    };

    OrderLeg.prototype.getBikeSeats = function getBikeSeats() {
        return this.get('bikeSeats');
    };

    OrderLeg.prototype.hasCountedPlaceSeats = function hasCountedPlaceSeats() {
        return this.get('seats').some(function (seat) {
            return seat.isCountedPlace();
        });
    };

    OrderLeg.prototype.isTrain = function isTrain() {
        return this.get('mode') === _AppConstants.TransitModes.TRAIN;
    };

    OrderLeg.prototype.hasSeats = function hasSeats() {
        return this.isTrain() && this.getSeats().size;
    };

    OrderLeg.prototype.isLondonTerminals = function isLondonTerminals() {
        return this.toc.code === LONDON_TERMINALS;
    };

    OrderLeg.prototype.getIsMetro = function getIsMetro() {
        return this.mode === _AppConstants.TransitModes.METRO;
    };

    return OrderLeg;
}((0, _immutable.Record)(defaults));

exports.default = OrderLeg;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    seat: null,
    coach: null,
    attributes: new _immutable.List(),
    supplement: new _immutable.Map()
};

var BikeSeat = function (_record) {
    (0, _inherits3.default)(BikeSeat, _record);

    function BikeSeat() {
        (0, _classCallCheck3.default)(this, BikeSeat);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    BikeSeat.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new BikeSeat({
            seat: (0, _LinkMapper.resolve)(json.seat).with(String),
            coach: (0, _LinkMapper.resolve)(json.coach).with(String),
            attributes: (0, _LinkMapper.resolveAll)(json.attributes).with(String),
            supplement: (0, _LinkMapper.resolve)(json.supplement).with(_Immutable.toImmutable)
        });
    };

    BikeSeat.prototype.getCoach = function getCoach() {
        return this.coach;
    };

    BikeSeat.prototype.getSeat = function getSeat() {
        return this.seat;
    };

    BikeSeat.prototype.getAttributes = function getAttributes() {
        return this.attributes;
    };

    BikeSeat.prototype.getSupplementCode = function getSupplementCode() {
        return this.supplement && this.supplement.get('code') || null;
    };

    return BikeSeat;
}((0, _immutable.Record)(defaults));

exports.default = BikeSeat;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _some2 = __webpack_require__(284);

var _some3 = _interopRequireDefault(_some2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _Immutable = __webpack_require__(54);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    seat: null,
    coach: null,
    attributes: new _immutable.List(),
    supplement: new _immutable.Map()
};

var Seat = function (_record) {
    (0, _inherits3.default)(Seat, _record);

    function Seat() {
        (0, _classCallCheck3.default)(this, Seat);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Seat.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Seat({
            seat: (0, _LinkMapper.resolve)(json.seat).with(String),
            coach: (0, _LinkMapper.resolve)(json.coach).with(String),
            attributes: (0, _LinkMapper.resolveAll)(json.attributes).with(String),
            supplement: (0, _LinkMapper.resolve)(json.supplement).with(_Immutable.toImmutable)
        });
    };

    Seat.prototype.getCoach = function getCoach() {
        return this.coach;
    };

    Seat.prototype.getSeat = function getSeat() {
        return this.seat;
    };

    Seat.prototype.getAttributeNames = function getAttributeNames() {
        return this.attributes
        // We want to only display the seat attributes we know about
        .filter(function (attribute) {
            return (0, _values3.default)(_AppConstants.SeatingPrefs).includes(attribute);
        }).map(function (attribute) {
            return (0, _I18n.translate)(_AppConstants.SeatingPrefNames[attribute]);
        });
    };

    Seat.prototype.isCountedPlace = function isCountedPlace() {
        return (0, _some3.default)([this.getCoach() === _AppConstants.COUNTED_PLACE, this.getSeat() === _AppConstants.COUNTED_PLACE]);
    };

    return Seat;
}((0, _immutable.Record)(defaults));

exports.default = Seat;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    tickets: new _immutable.Set()
};

var RailcardTickets = function (_record) {
    (0, _inherits3.default)(RailcardTickets, _record);

    function RailcardTickets() {
        (0, _classCallCheck3.default)(this, RailcardTickets);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    RailcardTickets.prototype.add = function add(ticket) {
        return this.set('tickets', this.tickets.add(ticket));
    };

    RailcardTickets.prototype.delete = function _delete(ticket) {
        return this.set('tickets', this.tickets.delete(ticket));
    };

    RailcardTickets.prototype.concat = function concat() {
        var _tickets;

        return this.set('tickets', (_tickets = this.tickets).concat.apply(_tickets, arguments));
    };

    RailcardTickets.prototype.count = function count() {
        return this.tickets.size;
    };

    RailcardTickets.prototype.isValid = function isValid() {
        var railcard = this.railcard,
            railcardCount = this.railcardCount,
            adults = this.adults,
            children = this.children;

        if (railcardCount === 0) {
            return true;
        }

        var minChildren = railcard.minChildren,
            maxChildren = railcard.maxChildren,
            minAdults = railcard.minAdults,
            maxAdults = railcard.maxAdults;

        return children >= minChildren * railcardCount && children <= maxChildren * railcardCount && adults >= minAdults * railcardCount && adults <= maxAdults * railcardCount;
    };

    (0, _createClass3.default)(RailcardTickets, [{
        key: 'adults',
        get: function get() {
            return (0, _Immutable.sum)(this.tickets, 'adults');
        }
    }, {
        key: 'children',
        get: function get() {
            return (0, _Immutable.sum)(this.tickets, 'children');
        }
    }, {
        key: 'railcard',
        get: function get() {
            return this.tickets.toList().getIn([0, 'railcard']);
        }
    }, {
        key: 'railcardCount',
        get: function get() {
            var railcard = this.railcard,
                adults = this.adults,
                children = this.children;

            if (!railcard) {
                return 0;
            }

            var maxChildren = railcard.maxChildren,
                maxAdults = railcard.maxAdults;

            var numRailcards = Math.max(maxAdults > 0 ? Math.ceil(adults / maxAdults) : 0, maxChildren > 0 ? Math.ceil(children / maxChildren) : 0);
            return numRailcards;
        }
    }]);
    return RailcardTickets;
}((0, _immutable.Record)(defaults));

exports.default = RailcardTickets;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isString2 = __webpack_require__(128);

var _isString3 = _interopRequireDefault(_isString2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerTitles = _config2.default.get('customerTitles') || [];

var LeadPassenger = function (_record) {
    (0, _inherits3.default)(LeadPassenger, _record);

    function LeadPassenger() {
        (0, _classCallCheck3.default)(this, LeadPassenger);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    LeadPassenger.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        //HACK: Handle cocs using a single field for lead passenger
        if ((0, _isString3.default)(json)) {
            var parts = json.split(" ");
            return new LeadPassenger({
                title: parts.shift(),
                initial: parts.shift(),
                surname: parts.join(" ")
            });
        }
        return new LeadPassenger(json);
    };

    LeadPassenger.prototype.getSchema = function getSchema() {
        return {
            title: _validation2.default.title(),
            initial: _joi2.default.string().trim().required().min(1).max(1).options({
                language: {
                    any: {
                        required: (0, _I18n.translate)('alertmessage.string.max', { num: 1 })
                    },
                    string: {
                        base: (0, _I18n.translate)('alertmessage.string.max', { num: 1 }),
                        min: (0, _I18n.translate)('alertmessage.string.max', { num: 1 }),
                        max: (0, _I18n.translate)('alertmessage.string.max', { num: 1 })
                    }
                }
            }),
            surname: _validation2.default.name()
        };
    };

    LeadPassenger.prototype.toString = function toString() {
        return this.title + ' ' + this.initial + ' ' + this.surname;
    };

    return LeadPassenger;
}((0, _immutable.Record)({ title: customerTitles[0], initial: null, surname: null }));

(0, _assign2.default)(LeadPassenger.prototype, _ValidationMixin2.default);

exports.default = LeadPassenger;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    validityPeriod: null,
    dateRange: null,
    originDestination: null,
    adult: null,
    children: null,
    firstClass: null
};

var TicketMetadata = function (_record) {
    (0, _inherits3.default)(TicketMetadata, _record);

    function TicketMetadata() {
        (0, _classCallCheck3.default)(this, TicketMetadata);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TicketMetadata.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(TicketMetadata, json, {
            validityPeriod: _LinkMapper.fields.number,
            dateRange: _LinkMapper.fields.string,
            originDestination: _LinkMapper.fields.string,
            adult: _LinkMapper.fields.string,
            children: _LinkMapper.fields.string,
            firstClass: _LinkMapper.fields.string
        });
    };

    TicketMetadata.prototype.isEmpty = function isEmpty() {
        return !this.some(function (x) {
            return !!x;
        });
    };

    TicketMetadata.prototype.setFromOrderTrip = function setFromOrderTrip(OrderTrip) {
        var season = OrderTrip.getSeasonFare();
        var adults = season.adults();
        var children = season.children();

        return new _immutable.Map({
            validityPeriod: season.getOutwardValidityPeriod().days,
            dateRange: " (" + season.getValidFrom().format("DD") + " " + season.getValidFrom().format("MMM") + " / " + season.getValidTo().format("DD") + " " + season.getValidTo().format("MMM") + ") ",
            originDestination: " " + OrderTrip.getFirstOrigin().name + " to " + OrderTrip.getDestination().name + " ",
            adult: adults ? " " + (0, _I18n2.default)('booking.passengers.adults', { adults: adults }) + " " : false,
            children: children ? " " + (0, _I18n2.default)('booking.passengers.children', { children: children }) + " " : false,
            firstClass: season.isFirstClass() && " - " + (0, _I18n2.default)('season.ticket.firstClass')
        });
    };

    return TicketMetadata;
}((0, _immutable.Record)(defaults));

exports.default = TicketMetadata;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _sumBy2 = __webpack_require__(1095);

var _sumBy3 = _interopRequireDefault(_sumBy2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _CardPayment = __webpack_require__(665);

var _CardPayment2 = _interopRequireDefault(_CardPayment);

var _HostedCardPayment = __webpack_require__(820);

var _HostedCardPayment2 = _interopRequireDefault(_HostedCardPayment);

var _WarrantPayment = __webpack_require__(1687);

var _WarrantPayment2 = _interopRequireDefault(_WarrantPayment);

var _PaypalPayment = __webpack_require__(666);

var _PaypalPayment2 = _interopRequireDefault(_PaypalPayment);

var _AlternativePayment = __webpack_require__(1688);

var _AlternativePayment2 = _interopRequireDefault(_AlternativePayment);

var _AmazonPayPayment = __webpack_require__(667);

var _AmazonPayPayment2 = _interopRequireDefault(_AmazonPayPayment);

var _GooglePayPayment = __webpack_require__(668);

var _GooglePayPayment2 = _interopRequireDefault(_GooglePayPayment);

var _ApplePayPayment = __webpack_require__(669);

var _ApplePayPayment2 = _interopRequireDefault(_ApplePayPayment);

var _BraintreeCardPayment = __webpack_require__(670);

var _BraintreeCardPayment2 = _interopRequireDefault(_BraintreeCardPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    cards: null,
    hostedCards: null,
    warrants: null,
    paypal: null,
    amazonPay: null,
    alternative: null,
    googlePay: null,
    applePay: null,
    cardCheckout: null
};

var OrderPayments = function (_record) {
    (0, _inherits3.default)(OrderPayments, _record);

    function OrderPayments() {
        (0, _classCallCheck3.default)(this, OrderPayments);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderPayments.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(OrderPayments, json, {
            cards: Array.isArray(json.cards) ? _LinkMapper.resolveAll.as(_CardPayment2.default) : (0, _LinkMapper.resolveAll)((0, _get3.default)(json, 'cards.transactions')).as(_CardPayment2.default),
            hostedCards: _LinkMapper.resolveAll.as(_HostedCardPayment2.default),
            warrants: _LinkMapper.resolveAll.as(_WarrantPayment2.default),
            paypal: _LinkMapper.resolveAll.as(_PaypalPayment2.default),
            alternative: _LinkMapper.resolveAll.as(_AlternativePayment2.default),
            amazonPay: _LinkMapper.resolveAll.as(_AmazonPayPayment2.default),
            googlePay: _LinkMapper.resolveAll.as(_GooglePayPayment2.default),
            applePay: _LinkMapper.resolveAll.as(_ApplePayPayment2.default),
            cardCheckout: _LinkMapper.resolveAll.as(_BraintreeCardPayment2.default)
        });
    };

    OrderPayments.prototype.getCards = function getCards() {
        return this.cards.size ? this.cards : this.hostedCards;
    };

    OrderPayments.prototype.hasNonHostedCards = function hasNonHostedCards() {
        var cards = this.cards;

        return cards && cards.size > 0;
    };

    OrderPayments.prototype.hasHostedCards = function hasHostedCards() {
        var hostedCards = this.hostedCards;

        return hostedCards && hostedCards.size > 0;
    };

    OrderPayments.prototype.hasLatestVoucherPayment = function hasLatestVoucherPayment() {
        return this.warrants.some(function (warrant) {
            return warrant.hasLatestPayment();
        });
    };

    OrderPayments.prototype.hasLatestCardPayment = function hasLatestCardPayment() {
        return this.getCards().some(function (card) {
            return card.hasLatestPayment();
        });
    };

    OrderPayments.prototype.getLatestVoucherPayment = function getLatestVoucherPayment() {
        return this.warrants.find(function (warrant) {
            return warrant.hasLatestPayment();
        }).getPaymentAmount();
    };

    OrderPayments.prototype.getLatestCardPayment = function getLatestCardPayment() {
        return this.getCards().find(function (card) {
            return card.hasLatestPayment();
        }).getPaymentAmount();
    };

    OrderPayments.prototype.getLatestCardDetails = function getLatestCardDetails() {
        return this.getCards().find(function (card) {
            return card.hasLatestPayment();
        });
    };

    OrderPayments.prototype.getTotal = function getTotal() {
        return (0, _values2.default)(this.toJS()).reduce(function (total, payment) {
            return total + (0, _sumBy3.default)(payment, 'amount');
        }, 0);
    };

    return OrderPayments;
}((0, _immutable.Record)(defaults));

exports.default = OrderPayments;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    voucherId: null,
    created: null,
    refunded: null,
    latest: null
};

var WarrantPayment = function (_record) {
    (0, _inherits3.default)(WarrantPayment, _record);

    function WarrantPayment() {
        (0, _classCallCheck3.default)(this, WarrantPayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    WarrantPayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        return (0, _LinkMapper.construct)(WarrantPayment, json, {
            id: _LinkMapper.fields.number,
            amount: _LinkMapper.fields.number,
            amountRefunded: _LinkMapper.fields.number,
            originalAmount: _LinkMapper.fields.number,
            voucherId: _LinkMapper.fields.number,
            created: _LinkMapper.fields.datetime,
            refunded: _LinkMapper.fields.boolean,
            latest: _LinkMapper.fields.boolean
        });
    };

    WarrantPayment.prototype.hasLatestPayment = function hasLatestPayment() {
        return this.latest;
    };

    WarrantPayment.prototype.getPaymentAmount = function getPaymentAmount() {
        return this.amount;
    };

    return WarrantPayment;
}((0, _immutable.Record)(defaults));

exports.default = WarrantPayment;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "id": [_LinkMapper.resolve.with(Number)],
    "refundId": [_LinkMapper.resolve.with(Number)],
    "paymentType": [_LinkMapper.resolve.with(String)],
    "amount": [_LinkMapper.resolve.with(Number)],
    "reason": [_LinkMapper.resolve.with(String)],
    "created": [_LinkMapper.resolve.with(_TrainTime2.default)]
};

var AlternativePayment = function (_record) {
    (0, _inherits3.default)(AlternativePayment, _record);

    function AlternativePayment() {
        (0, _classCallCheck3.default)(this, AlternativePayment);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AlternativePayment.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(AlternativePayment, json, (0, _Records.getResolvers)(fieldSchema));
    };

    AlternativePayment.prototype.hasAmount = function hasAmount() {
        return this.amount > 0;
    };

    return AlternativePayment;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = AlternativePayment;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    code: null,
    price: null,
    refunded: false,
    name: null
};

var OrderSundry = function (_record) {
    (0, _inherits3.default)(OrderSundry, _record);

    function OrderSundry() {
        (0, _classCallCheck3.default)(this, OrderSundry);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderSundry.fromJSON = function fromJSON(json) {
        return new OrderSundry({
            id: json.id,
            code: json.code,
            price: json.price,
            refunded: json.refunded,
            name: json.name
        });
    };

    OrderSundry.prototype.isBookingFee = function isBookingFee() {
        return this.code === _AppConstants.SundryCodes.BOOKING_FEE;
    };

    OrderSundry.prototype.isDiscountCode = function isDiscountCode() {
        return this.code === _AppConstants.SundryCodes.TRAINHUGGER_DISCOUNT;
    };

    return OrderSundry;
}((0, _immutable.Record)(defaults));

exports.default = OrderSundry;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    code: null,
    description: null,
    fixedAmount: null,
    name: null,
    percentage: null
};

var OrderDiscount = function (_record) {
    (0, _inherits3.default)(OrderDiscount, _record);

    function OrderDiscount() {
        (0, _classCallCheck3.default)(this, OrderDiscount);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OrderDiscount.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(OrderDiscount, json, {
            code: _LinkMapper.fields.string,
            description: _LinkMapper.fields.string,
            fixedAmount: _LinkMapper.fields.number,
            name: _LinkMapper.fields.string,
            percentage: _LinkMapper.fields.number
        });
    };

    return OrderDiscount;
}((0, _immutable.Record)(defaults));

exports.default = OrderDiscount;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandoffState = undefined;
exports.getJourneyState = getJourneyState;
exports.validateOrderJourneys = validateOrderJourneys;
exports.tripIsUnsupported = tripIsUnsupported;
exports.ticketIsLive = ticketIsLive;
exports.hasLiveTickets = hasLiveTickets;
exports.isJourneyWithinClaimWindow = isJourneyWithinClaimWindow;
exports.isJourneyOnSupportedToc = isJourneyOnSupportedToc;

var _immutable = __webpack_require__(5);

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StandardClaimWindowDays = _config2.default.get('delayRepayMaxTicketDays');

/**
 * @typedef {import('../records/Order')} Order
 * @typedef {import('../records/OrderTrip')} OrderTrip
 * @typedef {import('../records/OrderFare')} OrderFare
 * @typedef {import('../records/OrderJourney')} OrderJourney
 */

var HandoffState = exports.HandoffState = (0, _keymirror2.default)({
    UNSUPPORTED_TRIP: null,
    REFUNDED_FARE: null,
    OUTSIDE_CLAIM_WINDOW: null,
    NO_ACTIVE_TICKETS: null,
    NO_VALID_TOC: null,
    CLAIMABLE: null
});

/**
 * Get the handoff state for a journey
 * @param {Order} order
 * @param {OrderFare} fare
 * @param {OrderTrip} trip
 * @param {OrderJourney} journey
 * @param {String[]} tocGroup
 * @returns {keyof HandoffState}
 */
function getJourneyState(order, trip, fare, journey) {
    var tocGroup = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    if (!journey) {
        return null;
    }

    var status = void 0;
    if (tripIsUnsupported(trip)) {
        status = HandoffState.UNSUPPORTED_TRIP;
    } else if (!hasLiveTickets(order, fare)) {
        status = HandoffState.NO_ACTIVE_TICKETS;
    } else if (!isJourneyWithinClaimWindow(journey)) {
        status = HandoffState.OUTSIDE_CLAIM_WINDOW;
    } else if (!isJourneyOnSupportedToc(journey, tocGroup)) {
        status = HandoffState.NO_VALID_TOC;
    } else {
        status = HandoffState.CLAIMABLE;
    }

    return status;
}

/**
 * Get the handoff status for each journey in the order.
 * @param {Order} order
 * @param {String[]} tocGroup
 * @returns {List<{trip: OrderTrip, fare: OrderFare, journey: OrderJourney, status: keyof HandoffState}>}
 */
function validateOrderJourneys(order) {
    var tocGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var mergeJourneyState = function mergeJourneyState(trip, fare, journey) {
        var status = getJourneyState(order, trip, fare, journey, tocGroup);
        return status && { trip: trip, fare: fare, journey: journey, status: status };
    };

    // Create a new List of tuples: [OrderTrip, OrderFare, OrderJourney, status]
    var fareJourneys = order.trips.flatMap(function (trip) {
        return trip.getJourneyFares().flatMap(function (fare) {
            return _immutable.List.of(mergeJourneyState(trip, fare, fare.outwardJourney), mergeJourneyState(trip, fare, fare.returnJourney)).filter(Boolean);
        });
    });

    return fareJourneys;
}

/**
 * Returns true if the order trip is for an unsupported type (e.g. season, daysave, ...)
 * @param {OrderTrip} trip
 * @return {boolean}
 */
function tripIsUnsupported(trip) {
    // Return false for open return and other trip types
    var notApplicable = [_AppConstants.OrderTripTypes.SEASON, _AppConstants.OrderTripTypes.DAYSAVE, _AppConstants.OrderTripTypes.ROVERSRANGERS];
    return trip.isOpenReturn() || notApplicable.includes(trip.getType());
}

/**
 * Returns true if the ticket is not refunded
 * @param {Order} order
 * @param {OrderTicket} ticket
 * @returns {boolean}
 */
function ticketIsLive(order, ticket) {
    return !ticket.refunded && (order.isETicket() || ticket.getTicketNumber() || ticket.getSmartcardNumber());
}

/**
 * Returns true if there are tickets which are not refunded
 * @param {OrderOrder} order
 * @param {OrderFare} fare
 * @returns {boolean}
 */
function hasLiveTickets(order, fare) {
    return fare && fare.tickets.some(function (ticket) {
        return ticketIsLive(order, ticket);
    });
}

/**
 * Returns true if the journey departed within the valid 28-day claim window
 * @param {OrderJourney} journey
 * @return {boolean}
 */
function isJourneyWithinClaimWindow(journey) {
    var departure = journey && journey.getDepartureTime();
    return departure && departure.isBefore() && departure.isAfter((0, _TrainTime2.default)().startOf('day').subtract(StandardClaimWindowDays, 'days'));
}

/**
 * Returns true if there journey has legs on at least one specified TOC
 * @param {OrderJourney} journey
 * @param {String[]} tocGroup TOC short code
 * @return {boolean}
 */
function isJourneyOnSupportedToc(journey) {
    var tocGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var legs = journey.legs.filter(function (leg) {
        return leg.toc;
    });
    return legs.some(function (leg) {
        return leg.toc && tocGroup.includes(leg.toc.code);
    });
}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _APIClient = __webpack_require__(52);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BacsService = {
    validate: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(sortCode, accountNumber) {
            var data;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            data = { sortCode: sortCode, accountNumber: accountNumber };
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get('/customers/validation/bacs-lookup', data);

                        case 4:
                            return _context.abrupt('return', true);

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            if (!(_context.t0 instanceof _APIClient.BadRequestError)) {
                                _context.next = 11;
                                break;
                            }

                            return _context.abrupt('return', false);

                        case 11:
                            throw _context.t0;

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));

        function validate(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return validate;
    }()
};

exports.default = BacsService;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    changeoverTicket: null,
    newTicket: null,
    changeover: false,
    changeoverTrip: null
};

var ChangeoverTicket = function (_record) {
    (0, _inherits3.default)(ChangeoverTicket, _record);

    function ChangeoverTicket() {
        (0, _classCallCheck3.default)(this, ChangeoverTicket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ChangeoverTicket.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(ChangeoverTicket, json, {
            changeoverTicket: json.changeoverTicket,
            newTicket: json.newTicket,
            changeover: json.changeover,
            changeoverTrip: (0, _LinkMapper.resolve)(json.changeoverTrip).as(_Trip2.default)
        });
    };

    ChangeoverTicket.prototype.isNewTicket = function isNewTicket(id) {
        return this.newTicket === id;
    };

    ChangeoverTicket.prototype.getOldFare = function getOldFare() {
        return this.changeoverTrip.getFareByTicketId(this.changeoverTicket);
    };

    return ChangeoverTicket;
}((0, _immutable.Record)(defaults));

exports.default = ChangeoverTicket;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(290),
    castPath = __webpack_require__(187),
    last = __webpack_require__(596),
    parent = __webpack_require__(822),
    toKey = __webpack_require__(188);

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

module.exports = baseInvoke;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(102),
    isArrayLike = __webpack_require__(143),
    keys = __webpack_require__(127);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(254);

module.exports = function capitalize(str, lowercaseRest) {
  str = makeString(str);
  var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();

  return str.charAt(0).toUpperCase() + remainingChars;
};


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _fieldSchema;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _AppConstants = __webpack_require__(6);

var _Timeslot = __webpack_require__(1698);

var _Timeslot2 = _interopRequireDefault(_Timeslot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = (_fieldSchema = {}, _fieldSchema[_AppConstants.WeekdayNames.MONDAY] = [_LinkMapper.resolveAll.as(_Timeslot2.default)], _fieldSchema[_AppConstants.WeekdayNames.TUESDAY] = [_LinkMapper.resolveAll.as(_Timeslot2.default)], _fieldSchema[_AppConstants.WeekdayNames.WEDNESDAY] = [_LinkMapper.resolveAll.as(_Timeslot2.default)], _fieldSchema[_AppConstants.WeekdayNames.THURSDAY] = [_LinkMapper.resolveAll.as(_Timeslot2.default)], _fieldSchema[_AppConstants.WeekdayNames.FRIDAY] = [_LinkMapper.resolveAll.as(_Timeslot2.default)], _fieldSchema[_AppConstants.WeekdayNames.SATURDAY] = [_LinkMapper.resolveAll.as(_Timeslot2.default)], _fieldSchema[_AppConstants.WeekdayNames.SUNDAY] = [_LinkMapper.resolveAll.as(_Timeslot2.default)], _fieldSchema);

var OpeningHours = function (_record) {
    (0, _inherits3.default)(OpeningHours, _record);

    function OpeningHours() {
        (0, _classCallCheck3.default)(this, OpeningHours);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OpeningHours.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(OpeningHours, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return OpeningHours;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = OpeningHours;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeString = function timeString(hhmm) {
    return (/^\d\d:\d\d$/.test(hhmm) ? hhmm : null
    );
};

var fieldSchema = {
    startTime: [_LinkMapper.resolve.with(timeString)],
    endTime: [_LinkMapper.resolve.with(timeString)]
};

var Timeslot = function (_record) {
    (0, _inherits3.default)(Timeslot, _record);

    function Timeslot() {
        (0, _classCallCheck3.default)(this, Timeslot);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Timeslot.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Timeslot, json, (0, _Records.getResolvers)(fieldSchema));
    };

    Timeslot.prototype.toString = function toString() {
        return this.startTime + '-' + this.endTime;
    };

    return Timeslot;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Timeslot;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    discountId: null,
    origin: null,
    destination: null
};

var DiscountRule = function (_record) {
    (0, _inherits3.default)(DiscountRule, _record);

    function DiscountRule() {
        (0, _classCallCheck3.default)(this, DiscountRule);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DiscountRule.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DiscountRule, json, {
            id: _LinkMapper.fields.string,
            discountId: _LinkMapper.fields.string,
            origin: _LinkMapper.fields.string,
            destination: _LinkMapper.fields.string
        });
    };

    return DiscountRule;
}((0, _immutable.Record)(defaults));

exports.default = DiscountRule;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(309),
    castSlice = __webpack_require__(320),
    hasUnicode = __webpack_require__(259),
    isIterateeCall = __webpack_require__(236),
    isRegExp = __webpack_require__(825),
    stringToArray = __webpack_require__(321),
    toString = __webpack_require__(119);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(152),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1702 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1703 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(757),
    noop = __webpack_require__(24),
    setToArray = __webpack_require__(511);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdjustedTime = new _immutable.Record({
    id: null,
    scheduledTime: (0, _TrainTime2.default)(),
    adjustedTime: (0, _TrainTime2.default)(),
    confidence: 'Uncertain',
    delayed: false
});

AdjustedTime.fromJSON = function (json) {
    json = json || {};

    var scheduledTime = (0, _LinkMapper.resolve)(json.scheduledTime).with(_TrainTime2.default);
    var adjustedTime = (0, _LinkMapper.resolve)(json.adjustedTime).with(_TrainTime2.default);
    var confidence = (0, _LinkMapper.resolve)(json.confidence).with(String);
    var delayed = (0, _LinkMapper.resolve)(json.delayed).with(Boolean);

    var result = { scheduledTime: scheduledTime, adjustedTime: adjustedTime, confidence: confidence, delayed: delayed };

    return new AdjustedTime(result);
};

exports.default = AdjustedTime;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _TOC = __webpack_require__(817);

var _TOC2 = _interopRequireDefault(_TOC);

var _Facilities = __webpack_require__(1707);

var _Facilities2 = _interopRequireDefault(_Facilities);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceDetails = new _immutable.Record({
    id: null,
    mode: null,
    toc: null,
    reservable: null,
    facilities: new _Facilities2.default(),
    isTemporaryTrain: false,
    isCountedPlace: false,
    retailServiceId: null,
    trainUid: null,
    trainRid: null
});

ServiceDetails.prototype.getFacilities = function () {
    return this.facilities.reduce(function (a, v, k) {
        return v ? a.push(k) : a;
    }, new _immutable.List());
};

ServiceDetails.fromJSON = function (json) {
    json = json || {};

    var id = (0, _LinkMapper.resolve)(json.id).with(Number);
    var mode = (0, _LinkMapper.resolve)(json.mode).with(String);
    var toc = (0, _LinkMapper.resolve)(json.toc).as(_TOC2.default);
    var reservable = (0, _LinkMapper.resolve)(json.reservable).with(String);
    var isTemporaryTrain = (0, _LinkMapper.resolve)(json.isTemporaryTrain).with(Boolean);
    var isCountedPlace = (0, _LinkMapper.resolve)(json.isCountedPlace).with(Boolean);

    var facilities = (0, _LinkMapper.resolve)(json.facilities).as(_Facilities2.default) || new _Facilities2.default();
    var retailServiceId = json.retailServiceId;
    var trainUid = json.trainUid;
    var trainRid = json.trainRid;

    var result = { id: id, mode: mode, toc: toc, reservable: reservable, facilities: facilities, isTemporaryTrain: isTemporaryTrain, isCountedPlace: isCountedPlace, retailServiceId: retailServiceId, trainUid: trainUid, trainRid: trainRid };

    return new ServiceDetails(result);
};

exports.default = ServiceDetails;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    "firstClass": false,
    "firstClassMeal": false,
    "firstClassRestaurant": false,
    "hotFood": false,
    "buffet": false,
    "restaurant": false,
    "trolley": false,
    "wheelchair": false
};

var Facilities = function (_Record) {
    (0, _inherits3.default)(Facilities, _Record);

    function Facilities() {
        (0, _classCallCheck3.default)(this, Facilities);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    Facilities.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Facilities(json);
    };

    return Facilities;
}((0, _immutable.Record)(defaults));

exports.default = Facilities;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    category: null,
    severity: null,
    title: null,
    description: null,
    url: null
};

var Bulletin = function (_record) {
    (0, _inherits3.default)(Bulletin, _record);

    function Bulletin() {
        (0, _classCallCheck3.default)(this, Bulletin);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Bulletin.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Bulletin(json);
    };

    Bulletin.prototype.isP1 = function isP1() {
        return this.severity === _AppConstants.BulletinSeverity.P1;
    };

    return Bulletin;
}((0, _immutable.Record)(defaults));

exports.default = Bulletin;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    message: null
};

var CancellationReason = function (_record) {
    (0, _inherits3.default)(CancellationReason, _record);

    function CancellationReason() {
        (0, _classCallCheck3.default)(this, CancellationReason);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CancellationReason.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CancellationReason, json, {
            id: _LinkMapper.fields.number,
            message: _LinkMapper.fields.string
        });
    };

    return CancellationReason;
}((0, _immutable.Record)(defaults));

exports.default = CancellationReason;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1711);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _PlusBus = __webpack_require__(343);

var _PlusBus2 = _interopRequireDefault(_PlusBus);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TripFares = new _immutable.Record({
    outwardSingle: null,
    returnSingle: null,
    'return': null,
    season: null,
    fareOnly: null,
    daySave: null,
    roversRangers: null,
    plusBus: new _PlusBus2.default()
});

TripFares.fromJSON = function () {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return new TripFares({
        outwardSingle: (0, _LinkMapper.resolve)(json.outwardSingle).as(_Fare2.default),
        returnSingle: (0, _LinkMapper.resolve)(json.returnSingle).as(_Fare2.default),
        'return': (0, _LinkMapper.resolve)(json.return).as(_Fare2.default),
        season: (0, _LinkMapper.resolve)(json.season).as(_Fare2.default),
        fareOnly: (0, _LinkMapper.resolve)(json.fareOnly).as(_Fare2.default),
        daySave: (0, _LinkMapper.resolve)(json.daySave).as(_Fare2.default),
        roversRangers: (0, _LinkMapper.resolve)(json.roversRangers).as(_Fare2.default),
        plusBus: (0, _LinkMapper.resolve)(json.plusBus).as(_PlusBus2.default)
    });
};

exports.default = TripFares;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(229),
    keys = __webpack_require__(127);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(229),
    keysIn = __webpack_require__(255);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(229),
    getSymbols = __webpack_require__(513);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(229),
    getSymbolsIn = __webpack_require__(821);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1717 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(541),
    cloneDataView = __webpack_require__(1719),
    cloneRegExp = __webpack_require__(1720),
    cloneSymbol = __webpack_require__(1721),
    cloneTypedArray = __webpack_require__(829);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(541);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1720 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(250);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1723),
    baseUnary = __webpack_require__(350),
    nodeUtil = __webpack_require__(379);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(307),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1725),
    baseUnary = __webpack_require__(350),
    nodeUtil = __webpack_require__(379);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(307),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(187),
    last = __webpack_require__(596),
    parent = __webpack_require__(822),
    toKey = __webpack_require__(188);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(523);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    ticket: null,
    name: ''
};

var TicketPassenger = function (_record) {
    (0, _inherits3.default)(TicketPassenger, _record);

    function TicketPassenger() {
        (0, _classCallCheck3.default)(this, TicketPassenger);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TicketPassenger.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new TicketPassenger(json);
    };

    TicketPassenger.prototype.getSchema = function getSchema() {
        return {
            ticket: _validation2.default.requiredString(),
            name: _validation2.default.requiredString(2)
        };
    };

    TicketPassenger.prototype.toString = function toString() {
        return this.ticket + ' - ' + this.name;
    };

    return TicketPassenger;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(TicketPassenger.prototype, _ValidationMixin2.default);

exports.default = TicketPassenger;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Immutable = __webpack_require__(54);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _Service = __webpack_require__(273);

var _Service2 = _interopRequireDefault(_Service);

var _OverallCheapestSelection = __webpack_require__(539);

var _OverallCheapestSelection2 = _interopRequireDefault(_OverallCheapestSelection);

var _CheapestFares = __webpack_require__(540);

var _CheapestFares2 = _interopRequireDefault(_CheapestFares);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-use-before-define */
var schema = {
    // services
    outwardServices: [_LinkMapper.resolveAll.as(_Service2.default)],
    inwardServices: [_LinkMapper.resolveAll.as(_Service2.default)],

    // singles
    outwardSingles: [_LinkMapper.resolveAll.as(_Fare2.default)],
    inwardSingles: [_LinkMapper.resolveAll.as(_Fare2.default)],
    totalSinglePrice: [_LinkMapper.fields.number],

    // returns
    returns: [_LinkMapper.resolveAll.as(_Fare2.default)],
    totalReturnPrice: [_LinkMapper.fields.number]
};

/**
 * @callback fareFilterCallback
 * @param {Fare} fare - a candidate Fare to test against criteria for the journey
 * @returns {Boolean} true if the fare is eligible according to the criteria
 */

var CheapestMatchingFares = function (_record) {
    (0, _inherits3.default)(CheapestMatchingFares, _record);

    function CheapestMatchingFares() {
        (0, _classCallCheck3.default)(this, CheapestMatchingFares);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CheapestMatchingFares.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CheapestMatchingFares, json, (0, _Records.getResolvers)(schema));
    };

    /**
     * Finds the cheapest fares in the given outward/inward services that match an _optional_
     * fare filer
     * It is possible that the cheapest "singles" (out+in) are the same price as the cheapest
     * "return", in which case, return both, otherwise only return the cheapest fare type
     *
     * @param {Service[]} outwardServices - list of services forming the outward part of the journey
     * @param {Service[]} [inwardServices] - optional list of services forming the return part of the journey
     * @param {fareFilterCallback} [fareFilter] - an optional filter to create a subset of fares to check against
     * @returns {CheapestMatchingFares}
     */


    CheapestMatchingFares.fromServices = function fromServices(outwardServices, inwardServices, fareFilter) {
        var getFarePrice = function getFarePrice(fares) {
            return fares && fares.first().totalPrice;
        };

        var cheapest = new CheapestMatchingFares({ outwardServices: outwardServices, inwardServices: inwardServices });

        // Find the cheapest fares in each fare type

        var _getCheapestFares = getCheapestFares(outwardServices, inwardServices, fareFilter),
            outwardSingles = _getCheapestFares.outwardSingles,
            inwardSingles = _getCheapestFares.inwardSingles,
            returns = _getCheapestFares.returns;

        // return only outward singles if it's just an outward journey


        if (!inwardServices || inwardServices.isEmpty()) {
            return cheapest.merge({
                outwardSingles: outwardSingles,
                totalSinglePrice: getFarePrice(outwardSingles)
            });
        }

        // Add singles *only* if we have singles in both directions
        var cheapestSingles = cheapest;
        if (outwardSingles && inwardSingles) {
            cheapestSingles = cheapestSingles.merge({
                outwardSingles: outwardSingles,
                inwardSingles: inwardSingles,
                totalSinglePrice: getFarePrice(outwardSingles) + getFarePrice(inwardSingles)
            });
        }

        if (returns) {
            // Temporary record for returns
            var cheapestReturns = cheapest.merge({
                returns: returns,
                totalReturnPrice: getFarePrice(returns)
            });
            if (cheapestReturns.totalReturnPrice < cheapestSingles.totalSinglePrice) {
                // filter out singles if they are more expensive
                cheapest = cheapestReturns;
            } else if (cheapestReturns.totalReturnPrice === cheapestSingles.totalSinglePrice) {
                // merge returns with singles if they are the same price
                cheapest = cheapestSingles.merge({
                    returns: cheapestReturns.returns,
                    totalReturnPrice: cheapestReturns.totalReturnPrice
                });
            } else {
                cheapest = cheapestSingles;
            }
        } else {
            cheapest = cheapestSingles;
        }

        return cheapest;
    };

    CheapestMatchingFares.prototype.hasFare = function hasFare() {
        return Boolean(this.getPrice());
    };

    CheapestMatchingFares.prototype.getPrice = function getPrice() {
        return this.totalReturnPrice || this.totalSinglePrice;
    };

    /**
     * @returns {OverallCheapestSelection} the *fastest* matching fare as an `OverallCheapestSelection`
     */


    CheapestMatchingFares.prototype.getOverallCheapest = function getOverallCheapest() {
        var _this2 = this;

        var getDuration = function getDuration(service) {
            return service.getTripDuration();
        };
        var serviceHasFare = function serviceHasFare(fare) {
            return function (service) {
                return service.isValidWithFare(fare);
            };
        };

        // Sort the services - fastest first
        var outwardServices = this.outwardServices && this.outwardServices.sortBy(getDuration);
        var inwardServices = this.inwardServices ? this.inwardServices.sortBy(getDuration) : new _immutable.List();

        // A helper to find the fastest Service that is valid for the given Fare
        var getFastestService = function getFastestService(fare, sortedServices) {
            return sortedServices.find(serviceHasFare(fare));
        };

        /**
         * Given:
         * * "single" tickets are valid in only one direction
         * * there could be *multiple* singles which are the same price
         * * they might not be valid on the same service
         * ... we look through each fare, and find the fastest service for that fare
         * and then we sort them (fastest first), and pull out the fastest one
         *
         * @param {Fare[]} fares
         * @param {Service[]} fromServices - A sorted list of services
         * @returns {Array} Array containing the duration (in millis), the fare, and the service
         */
        var getFastestSingle = function getFastestSingle(fares, fromServices) {
            return fares && !fares.isEmpty() && fares.map(function (fare) {
                var service = getFastestService(fare, fromServices);
                return service && [getDuration(service).asMilliseconds(), fare, service];
            }).filter(Boolean).sortBy(function (_ref) {
                var journeyTime = _ref[0];
                return journeyTime;
            }).first();
        };

        /**
         * Given:
         * * "return" tickets are valid in **BOTH** directions
         * * there could be *multiple* returns which are the same price
         * * they might not be valid on the same service
         * ... we look through each fare, and find the fastest outward & inward services for that fare
         * and then we sort them by the **combined** duration (fastest first), and pull out the fastest one
         *
         * @param {Fare[]} fares
         * @param {Service[]} fromServices - A sorted list of services
         * @returns {Array} Array containing the duration (in millis), the fare, and the service
         */
        var getFastestReturn = function getFastestReturn(fares) {
            return fares && !fares.isEmpty() && fares.map(function (fare) {
                var outService = getFastestService(fare, _this2.outwardServices);
                var inService = getFastestService(fare, _this2.inwardServices);
                var duration = outService && inService && getDuration(outService).add(getDuration(inService));
                return duration && [duration.asMilliseconds(), fare, outService, inService];
            }).filter(Boolean).sortBy(function (_ref2) {
                var journeyTime = _ref2[0];
                return journeyTime;
            }).first();
        };

        var _ref3 = getFastestSingle(this.outwardSingles, outwardServices) || [],
            outwardSingleTime = _ref3[0],
            outwardSingleFare = _ref3[1],
            outwardSingleService = _ref3[2];

        var _ref4 = getFastestSingle(this.inwardSingles, inwardServices) || [],
            returnSingleTime = _ref4[0],
            inboundSingleFare = _ref4[1],
            inwardSingleService = _ref4[2];

        var _ref5 = getFastestReturn(this.returns, outwardServices, inwardServices) || [],
            returnTime = _ref5[0],
            returnFare = _ref5[1],
            outwardService = _ref5[2],
            inboundService = _ref5[3];

        var singleTime = (outwardSingleTime || 0) + (returnSingleTime || 0);

        if (singleTime && (!returnTime || singleTime <= returnTime)) {
            // the overall cheapest/fastest fare are singles
            return new _OverallCheapestSelection2.default({
                outwardService: outwardSingleService,
                inboundService: inwardSingleService,
                cheapestFares: new _CheapestFares2.default({
                    outwardSingle: outwardSingleFare,
                    inboundSingle: inboundSingleFare,
                    totalPrice: outwardSingleFare.totalPrice + (inboundSingleFare ? inboundSingleFare.totalPrice : 0)
                })
            });
        } else if (returnTime && (!singleTime || returnTime <= singleTime)) {
            // the overall cheapest/fastest fare is a return fare
            return new _OverallCheapestSelection2.default({
                outwardService: outwardService,
                inboundService: inboundService,
                cheapestFares: new _CheapestFares2.default({
                    return: returnFare,
                    totalPrice: returnFare.totalPrice
                })
            });
        }
        return new _OverallCheapestSelection2.default();
    };

    return CheapestMatchingFares;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

/**
 * Find the cheapest fares in the given services that match the optional `fareFilter`
 * Each fare type returned will be the _same_ lowest price, but the combined outward+inward singles
 * price may differ from the return price. We will reduce to the cheapest journey fare later on
 *
 * @param {Service[]} outwardServices - list of services forming the outward part of the journey
 * @param {Service[]} [inwardServices] - optional list of services forming the return part of the journey
 * @param {fareFilterCallback} [fareFilter] - an optional filter to create a subset of fares to check against
 * @returns {Object} cheapest
 * @returns {Fare[]} cheapest.outwardSingles
 * @returns {Fare[]} cheapest.inwardSingles
 * @returns {Fare[]} cheapest.returns
 */


exports.default = CheapestMatchingFares;
function getCheapestFares(outwardServices, inwardServices) {
    var fareFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (fare) {
        return fare;
    };

    var getFares = function getFares(type) {
        return function (service) {
            return service.fares.get(type);
        };
    };
    var getId = function getId(fare) {
        return fare.id;
    };
    var getPrice = function getPrice(fare) {
        return fare.totalPrice;
    };
    var isValidReturn = function isValidReturn(fare) {
        return inwardServices.some(function (service) {
            return service.isValidWithFare(fare);
        });
    };

    var getCheapest = function getCheapest(services, fareGetter) {
        var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (fare) {
            return fare;
        };

        // Find the matching fares
        var matchingFares = services.flatMap(fareGetter).filter(function (fare) {
            return fareFilter(fare) && filter(fare);
        });
        // de-dupe, group by price and then return all the fares at the cheapest price
        return (0, _Immutable.unique)(matchingFares, getId).sortBy(getPrice).groupBy(getPrice).first();
    };

    // Get the cheapest fares
    var outwardSingles = outwardServices && getCheapest(outwardServices, getFares('singles'));
    var inwardSingles = inwardServices && getCheapest(inwardServices, getFares('singles'));
    var returns = inwardServices && outwardServices && getCheapest(outwardServices, getFares('returns'), isValidReturn);

    return { outwardSingles: outwardSingles, inwardSingles: inwardSingles, returns: returns };
}

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "accountId": [_LinkMapper.resolve.with(Number)],
    "startDate": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "endDate": [_LinkMapper.resolve.with(_TrainTime2.default)]
};

var TransactionHistoryRange = function (_record) {
    (0, _inherits3.default)(TransactionHistoryRange, _record);

    function TransactionHistoryRange() {
        (0, _classCallCheck3.default)(this, TransactionHistoryRange);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TransactionHistoryRange.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(TransactionHistoryRange, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return TransactionHistoryRange;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = TransactionHistoryRange;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _Transaction = __webpack_require__(1130);

var _Transaction2 = _interopRequireDefault(_Transaction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "date": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "editable": [_LinkMapper.resolve.with(Boolean)],
    "transactions": [_LinkMapper.resolveAll.as(_Transaction2.default)],
    "editableUntil": [_LinkMapper.resolve.with(_TrainTime2.default)]
};

var DailyTransaction = function (_record) {
    (0, _inherits3.default)(DailyTransaction, _record);

    function DailyTransaction() {
        (0, _classCallCheck3.default)(this, DailyTransaction);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DailyTransaction.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DailyTransaction, json, (0, _Records.getResolvers)(fieldSchema));
    };

    DailyTransaction.prototype.isEditable = function isEditable() {
        return this.editable;
    };

    return DailyTransaction;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = DailyTransaction;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(320),
    hasUnicode = __webpack_require__(259),
    stringToArray = __webpack_require__(321),
    toString = __webpack_require__(119);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _Ticket = __webpack_require__(1131);

var _Ticket2 = _interopRequireDefault(_Ticket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "journeyPatternId": [_LinkMapper.resolve.with(Number)],
    "processingDate": [_LinkMapper.resolve.with(_TrainTime2.default)],
    "status": [_LinkMapper.resolve.with(String)],
    "journeyCount": [_LinkMapper.resolve.with(Number)],
    "incompleteJourneyCount": [_LinkMapper.resolve.with(Number)],
    "autofillJourneyCount": [_LinkMapper.resolve.with(Number)],
    "tickets": [_LinkMapper.resolveAll.as(_Ticket2.default)]
};

var JourneyPattern = function (_record) {
    (0, _inherits3.default)(JourneyPattern, _record);

    function JourneyPattern() {
        (0, _classCallCheck3.default)(this, JourneyPattern);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    JourneyPattern.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(JourneyPattern, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return JourneyPattern;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = JourneyPattern;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _PaperSeasonTicket = __webpack_require__(654);

var _PaperSeasonTicket2 = _interopRequireDefault(_PaperSeasonTicket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "reasons": [_LinkMapper.resolveAll.with(String)],
    "ticket": [_LinkMapper.resolve.as(_PaperSeasonTicket2.default)]
};

var InvalidPaperSeasonTicket = function (_record) {
    (0, _inherits3.default)(InvalidPaperSeasonTicket, _record);

    function InvalidPaperSeasonTicket() {
        (0, _classCallCheck3.default)(this, InvalidPaperSeasonTicket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    InvalidPaperSeasonTicket.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(InvalidPaperSeasonTicket, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return InvalidPaperSeasonTicket;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = InvalidPaperSeasonTicket;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    "reimbursementId": [_LinkMapper.resolve.with(Number)],
    "status": [_LinkMapper.resolve.with(String)],
    "amountRefunded": [_LinkMapper.resolve.with(Number)]
};

var ReimbursementResponse = function (_record) {
    (0, _inherits3.default)(ReimbursementResponse, _record);

    function ReimbursementResponse() {
        (0, _classCallCheck3.default)(this, ReimbursementResponse);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ReimbursementResponse.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(ReimbursementResponse, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return ReimbursementResponse;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = ReimbursementResponse;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    name: [_LinkMapper.fields.string],
    nlc: [_LinkMapper.fields.string]
};

var CollectionLocation = function (_record) {
    (0, _inherits3.default)(CollectionLocation, _record);

    function CollectionLocation() {
        (0, _classCallCheck3.default)(this, CollectionLocation);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CollectionLocation.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(CollectionLocation, json, (0, _Records.getResolvers)(schema));
    };

    return CollectionLocation;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = CollectionLocation;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Pager = __webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerOrdersList = function (_record) {
    (0, _inherits3.default)(CustomerOrdersList, _record);

    function CustomerOrdersList() {
        (0, _classCallCheck3.default)(this, CustomerOrdersList);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CustomerOrdersList.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CustomerOrdersList, json, {
            pagination: _LinkMapper.resolve.as(_Pager.APIPager),
            orders: _LinkMapper.resolveAll.as(_Order2.default)
        });
    };

    return CustomerOrdersList;
}((0, _immutable.Record)({ pagination: null, orders: null }));

exports.default = CustomerOrdersList;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(544),
    toNumber = __webpack_require__(312);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _SearchUrls = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    from: [_LinkMapper.resolve.with(_TrainTime2.default)],
    to: [_LinkMapper.resolve.with(_TrainTime2.default)]
};

var DatePeriod = function (_record) {
    (0, _inherits3.default)(DatePeriod, _record);

    function DatePeriod() {
        (0, _classCallCheck3.default)(this, DatePeriod);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DatePeriod.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DatePeriod, json, (0, _Records.getResolvers)(fieldSchema));
    };

    DatePeriod.prototype.serialize = function serialize() {
        return (0, _SearchUrls.serialize)({
            from: _SearchUrls.serializers.isoDateTime,
            to: _SearchUrls.serializers.isoDateTime
        }, this);
    };

    return DatePeriod;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = DatePeriod;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    months: [_LinkMapper.fields.number],
    days: [_LinkMapper.fields.number]
};

var TimePeriod = function (_record) {
    (0, _inherits3.default)(TimePeriod, _record);

    function TimePeriod() {
        (0, _classCallCheck3.default)(this, TimePeriod);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    TimePeriod.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(TimePeriod, json, (0, _Records.getResolvers)(fieldSchema));
    };

    TimePeriod.prototype.toString = function toString() {
        return this.months > 0 ? (0, _I18n.translate)('account.orders.refund.itso.timePeriod', { m: this.months, d: this.days }) : (0, _I18n.translate)('account.orders.refund.itso.timePeriod.noMonth', { d: this.days });
    };

    TimePeriod.prototype.toDuration = function toDuration() {
        return _moment2.default.duration({
            months: this.months,
            days: this.days
        });
    };

    return TimePeriod;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = TimePeriod;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

var _Cost = __webpack_require__(1742);

var _Cost2 = _interopRequireDefault(_Cost);

var _DiscountInfo = __webpack_require__(1743);

var _DiscountInfo2 = _interopRequireDefault(_DiscountInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    weekday: [_LinkMapper.resolve.as(_Cost2.default)],
    saturday: [_LinkMapper.resolve.as(_Cost2.default)],
    weekly: [_LinkMapper.resolve.as(_Cost2.default)],
    monthly: [_LinkMapper.resolve.as(_Cost2.default)],
    discountInfo: [_LinkMapper.resolve.as(_DiscountInfo2.default)],
    isIncomplete: [_LinkMapper.fields.boolean],
    isChild: [_LinkMapper.fields.boolean],
    isFirstClass: [_LinkMapper.fields.boolean]
};

var CalculationBreakdown = function (_record) {
    (0, _inherits3.default)(CalculationBreakdown, _record);

    function CalculationBreakdown() {
        (0, _classCallCheck3.default)(this, CalculationBreakdown);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    CalculationBreakdown.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(CalculationBreakdown, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return CalculationBreakdown;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = CalculationBreakdown;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    cost: [_LinkMapper.fields.number],
    count: [_LinkMapper.fields.number],
    fareType: [_LinkMapper.fields.string],
    discounted: [_LinkMapper.fields.boolean]
};

var Cost = function (_record) {
    (0, _inherits3.default)(Cost, _record);

    function Cost() {
        (0, _classCallCheck3.default)(this, Cost);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Cost.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Cost, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return Cost;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = Cost;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _Records = __webpack_require__(25);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldSchema = {
    percent: [_LinkMapper.fields.number],
    discountTypes: [_LinkMapper.fields.string]
};

var DiscountInfo = function (_record) {
    (0, _inherits3.default)(DiscountInfo, _record);

    function DiscountInfo() {
        (0, _classCallCheck3.default)(this, DiscountInfo);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    DiscountInfo.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(DiscountInfo, json, (0, _Records.getResolvers)(fieldSchema));
    };

    return DiscountInfo;
}((0, _immutable.Record)((0, _Records.getDefaults)(fieldSchema)));

exports.default = DiscountInfo;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _immutable = __webpack_require__(5);

var _APIClient = __webpack_require__(52);

var _LinkMapper = __webpack_require__(8);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _StoredPaymentCard = __webpack_require__(433);

var _StoredPaymentCard2 = _interopRequireDefault(_StoredPaymentCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeStoredCard(userId) {
    return function (json) {
        json.link = '/customers/' + userId + '/saved-card/' + json.id;
        return _StoredPaymentCard2.default.fromJSON(json);
    };
}

var PaymentCardService = {
    getAll: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var userId, endpoint, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (user) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', false);

                        case 2:
                            _context.prev = 2;
                            userId = user.id;
                            endpoint = '/v2/customers/' + userId + '/saved-cards';
                            _context.next = 7;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 7:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(response.cards).with(makeStoredCard(userId)));

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](2);

                            if (_context.t0 instanceof _APIClient.NotFoundError) {
                                _context.next = 15;
                                break;
                            }

                            throw _context.t0;

                        case 15:
                            return _context.abrupt('return', new _immutable.List());

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[2, 11]]);
        }));

        function getAll(_x) {
            return _ref.apply(this, arguments);
        }

        return getAll;
    }(),
    delete: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user, card) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            /*
                                Pay360 hosted cards have a card token, and are deleted differently to 'regular' cards.
                                 we need to support both while transitioning from 'regular' cards to hosted card payments as the user may
                                have a mix of both card types in their account.
                            */
                            endpoint = card.cardToken ? '/v2/customers/' + user.id + '/saved-cards/' + card.cardToken : '/customers/' + user.id + '/saved-cards/' + card.id;
                            _context2.next = 3;
                            return _AuthenticatedAPIClient2.default.delete(endpoint);

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function _delete(_x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return _delete;
    }()
};

exports.default = PaymentCardService;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.processImage = exports.ImageOrientations = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

__webpack_require__(1746);

var _blueimpLoadImage = __webpack_require__(1747);

var _blueimpLoadImage2 = _interopRequireDefault(_blueimpLoadImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageOrientations = exports.ImageOrientations = {
    NONE: 1,
    LANDSCAPE: 2,
    PORTRAIT: 3
};

var processImage = exports.processImage = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
        var file = _ref.file,
            _ref$maxWidth = _ref.maxWidth,
            maxWidth = _ref$maxWidth === undefined ? 2048 : _ref$maxWidth,
            _ref$maxHeight = _ref.maxHeight,
            maxHeight = _ref$maxHeight === undefined ? 2048 : _ref$maxHeight,
            _ref$format = _ref.format,
            format = _ref$format === undefined ? 'image/jpeg' : _ref$format,
            _ref$useBase = _ref.useBase64,
            useBase64 = _ref$useBase === undefined ? false : _ref$useBase,
            _ref$quality = _ref.quality,
            quality = _ref$quality === undefined ? 0.6 : _ref$quality;
        var canvas;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (file) {
                            _context.next = 3;
                            break;
                        }

                        console.error('No image file specified for processImage');
                        return _context.abrupt('return', null);

                    case 3:
                        _context.prev = 3;
                        _context.next = 6;
                        return new _promise2.default(function (resolve) {
                            return (0, _blueimpLoadImage2.default)(file, resolve, { canvas: true, orientation: true, maxWidth: maxWidth, maxHeight: maxHeight });
                        });

                    case 6:
                        canvas = _context.sent;
                        return _context.abrupt('return', new _promise2.default(function (resolve) {
                            try {
                                if (useBase64) {
                                    var encoded = canvas.toDataURL(file.type.replace('jpg', 'jpeg')); // jpg is not a valid encoding
                                    var split = encoded.split('base64,');
                                    resolve(split[1]); // The endpoint just wants the raw base64 string without encoding metadata
                                } else {
                                    canvas.toBlob(function (blob) {
                                        return resolve(blob);
                                    }, format, quality);
                                }
                            } catch (e) {
                                console.error('processImage canvas error: ', e);
                                return null; // Use a fallback image
                            }

                            return null;
                        }));

                    case 10:
                        _context.prev = 10;
                        _context.t0 = _context['catch'](3);

                        console.error('processImage error: ', _context.t0);

                        return _context.abrupt('return', null);

                    case 14:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[3, 10]]);
    }));

    return function processImage(_x) {
        return _ref2.apply(this, arguments);
    };
}();

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Canvas to Blob
 * https://github.com/blueimp/JavaScript-Canvas-to-Blob
 *
 * Copyright 2012, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on stackoverflow user Stoive's code snippet:
 * http://stackoverflow.com/q/4998908
 */

/* global define, Uint8Array, ArrayBuffer, module */

;(function (window) {
  'use strict'

  var CanvasPrototype =
    window.HTMLCanvasElement && window.HTMLCanvasElement.prototype
  var hasBlobConstructor =
    window.Blob &&
    (function () {
      try {
        return Boolean(new Blob())
      } catch (e) {
        return false
      }
    })()
  var hasArrayBufferViewSupport =
    hasBlobConstructor &&
    window.Uint8Array &&
    (function () {
      try {
        return new Blob([new Uint8Array(100)]).size === 100
      } catch (e) {
        return false
      }
    })()
  var BlobBuilder =
    window.BlobBuilder ||
    window.WebKitBlobBuilder ||
    window.MozBlobBuilder ||
    window.MSBlobBuilder
  var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/
  var dataURLtoBlob =
    (hasBlobConstructor || BlobBuilder) &&
    window.atob &&
    window.ArrayBuffer &&
    window.Uint8Array &&
    function (dataURI) {
      var matches,
        mediaType,
        isBase64,
        dataString,
        byteString,
        arrayBuffer,
        intArray,
        i,
        bb
      // Parse the dataURI components as per RFC 2397
      matches = dataURI.match(dataURIPattern)
      if (!matches) {
        throw new Error('invalid data URI')
      }
      // Default to text/plain;charset=US-ASCII
      mediaType = matches[2]
        ? matches[1]
        : 'text/plain' + (matches[3] || ';charset=US-ASCII')
      isBase64 = !!matches[4]
      dataString = dataURI.slice(matches[0].length)
      if (isBase64) {
        // Convert base64 to raw binary data held in a string:
        byteString = atob(dataString)
      } else {
        // Convert base64/URLEncoded data component to raw binary:
        byteString = decodeURIComponent(dataString)
      }
      // Write the bytes of the string to an ArrayBuffer:
      arrayBuffer = new ArrayBuffer(byteString.length)
      intArray = new Uint8Array(arrayBuffer)
      for (i = 0; i < byteString.length; i += 1) {
        intArray[i] = byteString.charCodeAt(i)
      }
      // Write the ArrayBuffer (or ArrayBufferView) to a blob:
      if (hasBlobConstructor) {
        return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
          type: mediaType
        })
      }
      bb = new BlobBuilder()
      bb.append(arrayBuffer)
      return bb.getBlob(mediaType)
    }
  if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
    if (CanvasPrototype.mozGetAsFile) {
      CanvasPrototype.toBlob = function (callback, type, quality) {
        var self = this
        setTimeout(function () {
          if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
            callback(dataURLtoBlob(self.toDataURL(type, quality)))
          } else {
            callback(self.mozGetAsFile('blob', type))
          }
        })
      }
    } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
      if (CanvasPrototype.msToBlob) {
        CanvasPrototype.toBlob = function (callback, type, quality) {
          var self = this
          setTimeout(function () {
            if (
              ((type && type !== 'image/png') || quality) &&
              CanvasPrototype.toDataURL &&
              dataURLtoBlob
            ) {
              callback(dataURLtoBlob(self.toDataURL(type, quality)))
            } else {
              callback(self.msToBlob(type))
            }
          })
        }
      } else {
        CanvasPrototype.toBlob = function (callback, type, quality) {
          var self = this
          setTimeout(function () {
            callback(dataURLtoBlob(self.toDataURL(type, quality)))
          })
        }
      }
    }
  }
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return dataURLtoBlob
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    module.exports = dataURLtoBlob
  } else {
    window.dataURLtoBlob = dataURLtoBlob
  }
})(window)


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

/* global module, require */

module.exports = __webpack_require__(166)

__webpack_require__(838)
__webpack_require__(396)
__webpack_require__(1748)
__webpack_require__(839)
__webpack_require__(1749)
__webpack_require__(840)
__webpack_require__(1750)
__webpack_require__(1751)


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(fetch) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Fetch
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2017, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, Promise */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var global = loadImage.global

  if (
    global.fetch &&
    global.Request &&
    global.Response &&
    global.Response.prototype.blob
  ) {
    loadImage.fetchBlob = function (url, callback, options) {
      /**
       * Fetch response handler.
       *
       * @param {Response} response Fetch response
       * @returns {Blob} Fetched Blob.
       */
      function responseHandler(response) {
        return response.blob()
      }
      if (global.Promise && typeof callback !== 'function') {
        return fetch(new Request(url, callback)).then(responseHandler)
      }
      fetch(new Request(url, options))
        .then(responseHandler)
        .then(callback)
        [
          // Avoid parsing error in IE<9, where catch is a reserved word.
          // eslint-disable-next-line dot-notation
          'catch'
        ](function (err) {
          callback(null, err)
        })
    }
  } else if (
    global.XMLHttpRequest &&
    // https://xhr.spec.whatwg.org/#the-responsetype-attribute
    new XMLHttpRequest().responseType === ''
  ) {
    loadImage.fetchBlob = function (url, callback, options) {
      /**
       * Promise executor
       *
       * @param {Function} resolve Resolution function
       * @param {Function} reject Rejection function
       */
      function executor(resolve, reject) {
        options = options || {} // eslint-disable-line no-param-reassign
        var req = new XMLHttpRequest()
        req.open(options.method || 'GET', url)
        if (options.headers) {
          Object.keys(options.headers).forEach(function (key) {
            req.setRequestHeader(key, options.headers[key])
          })
        }
        req.withCredentials = options.credentials === 'include'
        req.responseType = 'blob'
        req.onload = function () {
          resolve(req.response)
        }
        req.onerror =
          req.onabort =
          req.ontimeout =
            function (err) {
              if (resolve === reject) {
                // Not using Promises
                reject(null, err)
              } else {
                reject(err)
              }
            }
        req.send(options.body)
      }
      if (global.Promise && typeof callback !== 'function') {
        options = callback // eslint-disable-line no-param-reassign
        return new Promise(executor)
      }
      return executor(callback, callback)
    }
  }
})

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(650)))

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Exif tags mapping based on
 * https://github.com/jseidelin/exif-js
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166), __webpack_require__(839)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-exif'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var ExifMapProto = loadImage.ExifMap.prototype

  ExifMapProto.tags = {
    // =================
    // TIFF tags (IFD0):
    // =================
    0x0100: 'ImageWidth',
    0x0101: 'ImageHeight',
    0x0102: 'BitsPerSample',
    0x0103: 'Compression',
    0x0106: 'PhotometricInterpretation',
    0x0112: 'Orientation',
    0x0115: 'SamplesPerPixel',
    0x011c: 'PlanarConfiguration',
    0x0212: 'YCbCrSubSampling',
    0x0213: 'YCbCrPositioning',
    0x011a: 'XResolution',
    0x011b: 'YResolution',
    0x0128: 'ResolutionUnit',
    0x0111: 'StripOffsets',
    0x0116: 'RowsPerStrip',
    0x0117: 'StripByteCounts',
    0x0201: 'JPEGInterchangeFormat',
    0x0202: 'JPEGInterchangeFormatLength',
    0x012d: 'TransferFunction',
    0x013e: 'WhitePoint',
    0x013f: 'PrimaryChromaticities',
    0x0211: 'YCbCrCoefficients',
    0x0214: 'ReferenceBlackWhite',
    0x0132: 'DateTime',
    0x010e: 'ImageDescription',
    0x010f: 'Make',
    0x0110: 'Model',
    0x0131: 'Software',
    0x013b: 'Artist',
    0x8298: 'Copyright',
    0x8769: {
      // ExifIFDPointer
      0x9000: 'ExifVersion', // EXIF version
      0xa000: 'FlashpixVersion', // Flashpix format version
      0xa001: 'ColorSpace', // Color space information tag
      0xa002: 'PixelXDimension', // Valid width of meaningful image
      0xa003: 'PixelYDimension', // Valid height of meaningful image
      0xa500: 'Gamma',
      0x9101: 'ComponentsConfiguration', // Information about channels
      0x9102: 'CompressedBitsPerPixel', // Compressed bits per pixel
      0x927c: 'MakerNote', // Any desired information written by the manufacturer
      0x9286: 'UserComment', // Comments by user
      0xa004: 'RelatedSoundFile', // Name of related sound file
      0x9003: 'DateTimeOriginal', // Date and time when the original image was generated
      0x9004: 'DateTimeDigitized', // Date and time when the image was stored digitally
      0x9010: 'OffsetTime', // Time zone when the image file was last changed
      0x9011: 'OffsetTimeOriginal', // Time zone when the image was stored digitally
      0x9012: 'OffsetTimeDigitized', // Time zone when the image was stored digitally
      0x9290: 'SubSecTime', // Fractions of seconds for DateTime
      0x9291: 'SubSecTimeOriginal', // Fractions of seconds for DateTimeOriginal
      0x9292: 'SubSecTimeDigitized', // Fractions of seconds for DateTimeDigitized
      0x829a: 'ExposureTime', // Exposure time (in seconds)
      0x829d: 'FNumber',
      0x8822: 'ExposureProgram', // Exposure program
      0x8824: 'SpectralSensitivity', // Spectral sensitivity
      0x8827: 'PhotographicSensitivity', // EXIF 2.3, ISOSpeedRatings in EXIF 2.2
      0x8828: 'OECF', // Optoelectric conversion factor
      0x8830: 'SensitivityType',
      0x8831: 'StandardOutputSensitivity',
      0x8832: 'RecommendedExposureIndex',
      0x8833: 'ISOSpeed',
      0x8834: 'ISOSpeedLatitudeyyy',
      0x8835: 'ISOSpeedLatitudezzz',
      0x9201: 'ShutterSpeedValue', // Shutter speed
      0x9202: 'ApertureValue', // Lens aperture
      0x9203: 'BrightnessValue', // Value of brightness
      0x9204: 'ExposureBias', // Exposure bias
      0x9205: 'MaxApertureValue', // Smallest F number of lens
      0x9206: 'SubjectDistance', // Distance to subject in meters
      0x9207: 'MeteringMode', // Metering mode
      0x9208: 'LightSource', // Kind of light source
      0x9209: 'Flash', // Flash status
      0x9214: 'SubjectArea', // Location and area of main subject
      0x920a: 'FocalLength', // Focal length of the lens in mm
      0xa20b: 'FlashEnergy', // Strobe energy in BCPS
      0xa20c: 'SpatialFrequencyResponse',
      0xa20e: 'FocalPlaneXResolution', // Number of pixels in width direction per FPRUnit
      0xa20f: 'FocalPlaneYResolution', // Number of pixels in height direction per FPRUnit
      0xa210: 'FocalPlaneResolutionUnit', // Unit for measuring the focal plane resolution
      0xa214: 'SubjectLocation', // Location of subject in image
      0xa215: 'ExposureIndex', // Exposure index selected on camera
      0xa217: 'SensingMethod', // Image sensor type
      0xa300: 'FileSource', // Image source (3 == DSC)
      0xa301: 'SceneType', // Scene type (1 == directly photographed)
      0xa302: 'CFAPattern', // Color filter array geometric pattern
      0xa401: 'CustomRendered', // Special processing
      0xa402: 'ExposureMode', // Exposure mode
      0xa403: 'WhiteBalance', // 1 = auto white balance, 2 = manual
      0xa404: 'DigitalZoomRatio', // Digital zoom ratio
      0xa405: 'FocalLengthIn35mmFilm',
      0xa406: 'SceneCaptureType', // Type of scene
      0xa407: 'GainControl', // Degree of overall image gain adjustment
      0xa408: 'Contrast', // Direction of contrast processing applied by camera
      0xa409: 'Saturation', // Direction of saturation processing applied by camera
      0xa40a: 'Sharpness', // Direction of sharpness processing applied by camera
      0xa40b: 'DeviceSettingDescription',
      0xa40c: 'SubjectDistanceRange', // Distance to subject
      0xa420: 'ImageUniqueID', // Identifier assigned uniquely to each image
      0xa430: 'CameraOwnerName',
      0xa431: 'BodySerialNumber',
      0xa432: 'LensSpecification',
      0xa433: 'LensMake',
      0xa434: 'LensModel',
      0xa435: 'LensSerialNumber'
    },
    0x8825: {
      // GPSInfoIFDPointer
      0x0000: 'GPSVersionID',
      0x0001: 'GPSLatitudeRef',
      0x0002: 'GPSLatitude',
      0x0003: 'GPSLongitudeRef',
      0x0004: 'GPSLongitude',
      0x0005: 'GPSAltitudeRef',
      0x0006: 'GPSAltitude',
      0x0007: 'GPSTimeStamp',
      0x0008: 'GPSSatellites',
      0x0009: 'GPSStatus',
      0x000a: 'GPSMeasureMode',
      0x000b: 'GPSDOP',
      0x000c: 'GPSSpeedRef',
      0x000d: 'GPSSpeed',
      0x000e: 'GPSTrackRef',
      0x000f: 'GPSTrack',
      0x0010: 'GPSImgDirectionRef',
      0x0011: 'GPSImgDirection',
      0x0012: 'GPSMapDatum',
      0x0013: 'GPSDestLatitudeRef',
      0x0014: 'GPSDestLatitude',
      0x0015: 'GPSDestLongitudeRef',
      0x0016: 'GPSDestLongitude',
      0x0017: 'GPSDestBearingRef',
      0x0018: 'GPSDestBearing',
      0x0019: 'GPSDestDistanceRef',
      0x001a: 'GPSDestDistance',
      0x001b: 'GPSProcessingMethod',
      0x001c: 'GPSAreaInformation',
      0x001d: 'GPSDateStamp',
      0x001e: 'GPSDifferential',
      0x001f: 'GPSHPositioningError'
    },
    0xa005: {
      // InteroperabilityIFDPointer
      0x0001: 'InteroperabilityIndex'
    }
  }

  // IFD1 directory can contain any IFD0 tags:
  ExifMapProto.tags.ifd1 = ExifMapProto.tags

  ExifMapProto.stringValues = {
    ExposureProgram: {
      0: 'Undefined',
      1: 'Manual',
      2: 'Normal program',
      3: 'Aperture priority',
      4: 'Shutter priority',
      5: 'Creative program',
      6: 'Action program',
      7: 'Portrait mode',
      8: 'Landscape mode'
    },
    MeteringMode: {
      0: 'Unknown',
      1: 'Average',
      2: 'CenterWeightedAverage',
      3: 'Spot',
      4: 'MultiSpot',
      5: 'Pattern',
      6: 'Partial',
      255: 'Other'
    },
    LightSource: {
      0: 'Unknown',
      1: 'Daylight',
      2: 'Fluorescent',
      3: 'Tungsten (incandescent light)',
      4: 'Flash',
      9: 'Fine weather',
      10: 'Cloudy weather',
      11: 'Shade',
      12: 'Daylight fluorescent (D 5700 - 7100K)',
      13: 'Day white fluorescent (N 4600 - 5400K)',
      14: 'Cool white fluorescent (W 3900 - 4500K)',
      15: 'White fluorescent (WW 3200 - 3700K)',
      17: 'Standard light A',
      18: 'Standard light B',
      19: 'Standard light C',
      20: 'D55',
      21: 'D65',
      22: 'D75',
      23: 'D50',
      24: 'ISO studio tungsten',
      255: 'Other'
    },
    Flash: {
      0x0000: 'Flash did not fire',
      0x0001: 'Flash fired',
      0x0005: 'Strobe return light not detected',
      0x0007: 'Strobe return light detected',
      0x0009: 'Flash fired, compulsory flash mode',
      0x000d: 'Flash fired, compulsory flash mode, return light not detected',
      0x000f: 'Flash fired, compulsory flash mode, return light detected',
      0x0010: 'Flash did not fire, compulsory flash mode',
      0x0018: 'Flash did not fire, auto mode',
      0x0019: 'Flash fired, auto mode',
      0x001d: 'Flash fired, auto mode, return light not detected',
      0x001f: 'Flash fired, auto mode, return light detected',
      0x0020: 'No flash function',
      0x0041: 'Flash fired, red-eye reduction mode',
      0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
      0x0047: 'Flash fired, red-eye reduction mode, return light detected',
      0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
      0x004d:
        'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
      0x004f:
        'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
      0x0059: 'Flash fired, auto mode, red-eye reduction mode',
      0x005d:
        'Flash fired, auto mode, return light not detected, red-eye reduction mode',
      0x005f:
        'Flash fired, auto mode, return light detected, red-eye reduction mode'
    },
    SensingMethod: {
      1: 'Undefined',
      2: 'One-chip color area sensor',
      3: 'Two-chip color area sensor',
      4: 'Three-chip color area sensor',
      5: 'Color sequential area sensor',
      7: 'Trilinear sensor',
      8: 'Color sequential linear sensor'
    },
    SceneCaptureType: {
      0: 'Standard',
      1: 'Landscape',
      2: 'Portrait',
      3: 'Night scene'
    },
    SceneType: {
      1: 'Directly photographed'
    },
    CustomRendered: {
      0: 'Normal process',
      1: 'Custom process'
    },
    WhiteBalance: {
      0: 'Auto white balance',
      1: 'Manual white balance'
    },
    GainControl: {
      0: 'None',
      1: 'Low gain up',
      2: 'High gain up',
      3: 'Low gain down',
      4: 'High gain down'
    },
    Contrast: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    Saturation: {
      0: 'Normal',
      1: 'Low saturation',
      2: 'High saturation'
    },
    Sharpness: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    SubjectDistanceRange: {
      0: 'Unknown',
      1: 'Macro',
      2: 'Close view',
      3: 'Distant view'
    },
    FileSource: {
      3: 'DSC'
    },
    ComponentsConfiguration: {
      0: '',
      1: 'Y',
      2: 'Cb',
      3: 'Cr',
      4: 'R',
      5: 'G',
      6: 'B'
    },
    Orientation: {
      1: 'Original',
      2: 'Horizontal flip',
      3: 'Rotate 180° CCW',
      4: 'Vertical flip',
      5: 'Vertical flip + Rotate 90° CW',
      6: 'Rotate 90° CW',
      7: 'Horizontal flip + Rotate 90° CW',
      8: 'Rotate 90° CCW'
    }
  }

  ExifMapProto.getText = function (name) {
    var value = this.get(name)
    switch (name) {
      case 'LightSource':
      case 'Flash':
      case 'MeteringMode':
      case 'ExposureProgram':
      case 'SensingMethod':
      case 'SceneCaptureType':
      case 'SceneType':
      case 'CustomRendered':
      case 'WhiteBalance':
      case 'GainControl':
      case 'Contrast':
      case 'Saturation':
      case 'Sharpness':
      case 'SubjectDistanceRange':
      case 'FileSource':
      case 'Orientation':
        return this.stringValues[name][value]
      case 'ExifVersion':
      case 'FlashpixVersion':
        if (!value) return
        return String.fromCharCode(value[0], value[1], value[2], value[3])
      case 'ComponentsConfiguration':
        if (!value) return
        return (
          this.stringValues[name][value[0]] +
          this.stringValues[name][value[1]] +
          this.stringValues[name][value[2]] +
          this.stringValues[name][value[3]]
        )
      case 'GPSVersionID':
        if (!value) return
        return value[0] + '.' + value[1] + '.' + value[2] + '.' + value[3]
    }
    return String(value)
  }

  ExifMapProto.getAll = function () {
    var map = {}
    var prop
    var obj
    var name
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        obj = this[prop]
        if (obj && obj.getAll) {
          map[this.ifds[prop].name] = obj.getAll()
        } else {
          name = this.tags[prop]
          if (name) map[name] = this.getText(name)
        }
      }
    }
    return map
  }

  ExifMapProto.getName = function (tagCode) {
    var name = this.tags[tagCode]
    if (typeof name === 'object') return this.ifds[tagCode].name
    return name
  }

  // Extend the map of tag names to tag codes:
  ;(function () {
    var tags = ExifMapProto.tags
    var prop
    var ifd
    var subTags
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        ifd = ExifMapProto.ifds[prop]
        if (ifd) {
          subTags = tags[prop]
          for (prop in subTags) {
            if (Object.prototype.hasOwnProperty.call(subTags, prop)) {
              ifd.map[subTags[prop]] = Number(prop)
            }
          }
        } else {
          ExifMapProto.map[tags[prop]] = Number(prop)
        }
      }
    }
  })()
})


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 *
 * IPTC tags mapping based on
 * https://iptc.org/standards/photo-metadata
 * https://exiftool.org/TagNames/IPTC.html
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166), __webpack_require__(840)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-iptc'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var IptcMapProto = loadImage.IptcMap.prototype

  IptcMapProto.tags = {
    0: 'ApplicationRecordVersion',
    3: 'ObjectTypeReference',
    4: 'ObjectAttributeReference',
    5: 'ObjectName',
    7: 'EditStatus',
    8: 'EditorialUpdate',
    10: 'Urgency',
    12: 'SubjectReference',
    15: 'Category',
    20: 'SupplementalCategories',
    22: 'FixtureIdentifier',
    25: 'Keywords',
    26: 'ContentLocationCode',
    27: 'ContentLocationName',
    30: 'ReleaseDate',
    35: 'ReleaseTime',
    37: 'ExpirationDate',
    38: 'ExpirationTime',
    40: 'SpecialInstructions',
    42: 'ActionAdvised',
    45: 'ReferenceService',
    47: 'ReferenceDate',
    50: 'ReferenceNumber',
    55: 'DateCreated',
    60: 'TimeCreated',
    62: 'DigitalCreationDate',
    63: 'DigitalCreationTime',
    65: 'OriginatingProgram',
    70: 'ProgramVersion',
    75: 'ObjectCycle',
    80: 'Byline',
    85: 'BylineTitle',
    90: 'City',
    92: 'Sublocation',
    95: 'State',
    100: 'CountryCode',
    101: 'Country',
    103: 'OriginalTransmissionReference',
    105: 'Headline',
    110: 'Credit',
    115: 'Source',
    116: 'CopyrightNotice',
    118: 'Contact',
    120: 'Caption',
    121: 'LocalCaption',
    122: 'Writer',
    125: 'RasterizedCaption',
    130: 'ImageType',
    131: 'ImageOrientation',
    135: 'LanguageIdentifier',
    150: 'AudioType',
    151: 'AudioSamplingRate',
    152: 'AudioSamplingResolution',
    153: 'AudioDuration',
    154: 'AudioOutcue',
    184: 'JobID',
    185: 'MasterDocumentID',
    186: 'ShortDocumentID',
    187: 'UniqueDocumentID',
    188: 'OwnerID',
    200: 'ObjectPreviewFileFormat',
    201: 'ObjectPreviewFileVersion',
    202: 'ObjectPreviewData',
    221: 'Prefs',
    225: 'ClassifyState',
    228: 'SimilarityIndex',
    230: 'DocumentNotes',
    231: 'DocumentHistory',
    232: 'ExifCameraInfo',
    255: 'CatalogSets'
  }

  IptcMapProto.stringValues = {
    10: {
      0: '0 (reserved)',
      1: '1 (most urgent)',
      2: '2',
      3: '3',
      4: '4',
      5: '5 (normal urgency)',
      6: '6',
      7: '7',
      8: '8 (least urgent)',
      9: '9 (user-defined priority)'
    },
    75: {
      a: 'Morning',
      b: 'Both Morning and Evening',
      p: 'Evening'
    },
    131: {
      L: 'Landscape',
      P: 'Portrait',
      S: 'Square'
    }
  }

  IptcMapProto.getText = function (id) {
    var value = this.get(id)
    var tagCode = this.map[id]
    var stringValue = this.stringValues[tagCode]
    if (stringValue) return stringValue[value]
    return String(value)
  }

  IptcMapProto.getAll = function () {
    var map = {}
    var prop
    var name
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        name = this.tags[prop]
        if (name) map[name] = this.getText(name)
      }
    }
    return map
  }

  IptcMapProto.getName = function (tagCode) {
    return this.tags[tagCode]
  }

  // Extend the map of tag names to tag codes:
  ;(function () {
    var tags = IptcMapProto.tags
    var map = IptcMapProto.map || {}
    var prop
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        map[tags[prop]] = Number(prop)
      }
    }
  })()
})


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Orientation
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/*
Exif orientation values to correctly display the letter F:

    1             2
  ██████        ██████
  ██                ██
  ████            ████
  ██                ██
  ██                ██

    3             4
      ██        ██
      ██        ██
    ████        ████
      ██        ██
  ██████        ██████

    5             6
██████████    ██
██  ██        ██  ██
██            ██████████

    7             8
        ██    ██████████
    ██  ██        ██  ██
██████████            ██

*/

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(166), __webpack_require__(838), __webpack_require__(396)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(
      require('./load-image'),
      require('./load-image-scale'),
      require('./load-image-meta')
    )
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var originalTransform = loadImage.transform
  var originalRequiresCanvas = loadImage.requiresCanvas
  var originalRequiresMetaData = loadImage.requiresMetaData
  var originalTransformCoordinates = loadImage.transformCoordinates
  var originalGetTransformedOptions = loadImage.getTransformedOptions

  ;(function ($) {
    // Guard for non-browser environments (e.g. server-side rendering):
    if (!$.global.document) return
    // black+white 3x2 JPEG, with the following meta information set:
    // - EXIF Orientation: 6 (Rotated 90° CCW)
    // Image data layout (B=black, F=white):
    // BFF
    // BBB
    var testImageURL =
      'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' +
      'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' +
      'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' +
      'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/x' +
      'ABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAA' +
      'AAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQ' +
      'voP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXw' +
      'H/9k='
    var img = document.createElement('img')
    img.onload = function () {
      // Check if the browser supports automatic image orientation:
      $.orientation = img.width === 2 && img.height === 3
      if ($.orientation) {
        var canvas = $.createCanvas(1, 1, true)
        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 1, 1, 1, 1, 0, 0, 1, 1)
        // Check if the source image coordinates (sX, sY, sWidth, sHeight) are
        // correctly applied to the auto-orientated image, which should result
        // in a white opaque pixel (e.g. in Safari).
        // Browsers that show a transparent pixel (e.g. Chromium) fail to crop
        // auto-oriented images correctly and require a workaround, e.g.
        // drawing the complete source image to an intermediate canvas first.
        // See https://bugs.chromium.org/p/chromium/issues/detail?id=1074354
        $.orientationCropBug =
          ctx.getImageData(0, 0, 1, 1).data.toString() !== '255,255,255,255'
      }
    }
    img.src = testImageURL
  })(loadImage)

  /**
   * Determines if the orientation requires a canvas element.
   *
   * @param {object} [options] Options object
   * @param {boolean} [withMetaData] Is metadata required for orientation
   * @returns {boolean} Returns true if orientation requires canvas/meta
   */
  function requiresCanvasOrientation(options, withMetaData) {
    var orientation = options && options.orientation
    return (
      // Exif orientation for browsers without automatic image orientation:
      (orientation === true && !loadImage.orientation) ||
      // Orientation reset for browsers with automatic image orientation:
      (orientation === 1 && loadImage.orientation) ||
      // Orientation to defined value, requires meta for orientation reset only:
      ((!withMetaData || loadImage.orientation) &&
        orientation > 1 &&
        orientation < 9)
    )
  }

  /**
   * Determines if the image requires an orientation change.
   *
   * @param {number} [orientation] Defined orientation value
   * @param {number} [autoOrientation] Auto-orientation based on Exif data
   * @returns {boolean} Returns true if an orientation change is required
   */
  function requiresOrientationChange(orientation, autoOrientation) {
    return (
      orientation !== autoOrientation &&
      ((orientation === 1 && autoOrientation > 1 && autoOrientation < 9) ||
        (orientation > 1 && orientation < 9))
    )
  }

  /**
   * Determines orientation combinations that require a rotation by 180°.
   *
   * The following is a list of combinations that return true:
   *
   * 2 (flip) => 5 (rot90,flip), 7 (rot90,flip), 6 (rot90), 8 (rot90)
   * 4 (flip) => 5 (rot90,flip), 7 (rot90,flip), 6 (rot90), 8 (rot90)
   *
   * 5 (rot90,flip) => 2 (flip), 4 (flip), 6 (rot90), 8 (rot90)
   * 7 (rot90,flip) => 2 (flip), 4 (flip), 6 (rot90), 8 (rot90)
   *
   * 6 (rot90) => 2 (flip), 4 (flip), 5 (rot90,flip), 7 (rot90,flip)
   * 8 (rot90) => 2 (flip), 4 (flip), 5 (rot90,flip), 7 (rot90,flip)
   *
   * @param {number} [orientation] Defined orientation value
   * @param {number} [autoOrientation] Auto-orientation based on Exif data
   * @returns {boolean} Returns true if rotation by 180° is required
   */
  function requiresRot180(orientation, autoOrientation) {
    if (autoOrientation > 1 && autoOrientation < 9) {
      switch (orientation) {
        case 2:
        case 4:
          return autoOrientation > 4
        case 5:
        case 7:
          return autoOrientation % 2 === 0
        case 6:
        case 8:
          return (
            autoOrientation === 2 ||
            autoOrientation === 4 ||
            autoOrientation === 5 ||
            autoOrientation === 7
          )
      }
    }
    return false
  }

  // Determines if the target image should be a canvas element:
  loadImage.requiresCanvas = function (options) {
    return (
      requiresCanvasOrientation(options) ||
      originalRequiresCanvas.call(loadImage, options)
    )
  }

  // Determines if metadata should be loaded automatically:
  loadImage.requiresMetaData = function (options) {
    return (
      requiresCanvasOrientation(options, true) ||
      originalRequiresMetaData.call(loadImage, options)
    )
  }

  loadImage.transform = function (img, options, callback, file, data) {
    originalTransform.call(
      loadImage,
      img,
      options,
      function (img, data) {
        if (data) {
          var autoOrientation =
            loadImage.orientation && data.exif && data.exif.get('Orientation')
          if (autoOrientation > 4 && autoOrientation < 9) {
            // Automatic image orientation switched image dimensions
            var originalWidth = data.originalWidth
            var originalHeight = data.originalHeight
            data.originalWidth = originalHeight
            data.originalHeight = originalWidth
          }
        }
        callback(img, data)
      },
      file,
      data
    )
  }

  // Transforms coordinate and dimension options
  // based on the given orientation option:
  loadImage.getTransformedOptions = function (img, opts, data) {
    var options = originalGetTransformedOptions.call(loadImage, img, opts)
    var exifOrientation = data.exif && data.exif.get('Orientation')
    var orientation = options.orientation
    var autoOrientation = loadImage.orientation && exifOrientation
    if (orientation === true) orientation = exifOrientation
    if (!requiresOrientationChange(orientation, autoOrientation)) {
      return options
    }
    var top = options.top
    var right = options.right
    var bottom = options.bottom
    var left = options.left
    var newOptions = {}
    for (var i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.orientation = orientation
    if (
      (orientation > 4 && !(autoOrientation > 4)) ||
      (orientation < 5 && autoOrientation > 4)
    ) {
      // Image dimensions and target dimensions are switched
      newOptions.maxWidth = options.maxHeight
      newOptions.maxHeight = options.maxWidth
      newOptions.minWidth = options.minHeight
      newOptions.minHeight = options.minWidth
      newOptions.sourceWidth = options.sourceHeight
      newOptions.sourceHeight = options.sourceWidth
    }
    if (autoOrientation > 1) {
      // Browsers which correctly apply source image coordinates to
      // auto-oriented images
      switch (autoOrientation) {
        case 2:
          // Horizontal flip
          right = options.left
          left = options.right
          break
        case 3:
          // 180° Rotate CCW
          top = options.bottom
          right = options.left
          bottom = options.top
          left = options.right
          break
        case 4:
          // Vertical flip
          top = options.bottom
          bottom = options.top
          break
        case 5:
          // Horizontal flip + 90° Rotate CCW
          top = options.left
          right = options.bottom
          bottom = options.right
          left = options.top
          break
        case 6:
          // 90° Rotate CCW
          top = options.left
          right = options.top
          bottom = options.right
          left = options.bottom
          break
        case 7:
          // Vertical flip + 90° Rotate CCW
          top = options.right
          right = options.top
          bottom = options.left
          left = options.bottom
          break
        case 8:
          // 90° Rotate CW
          top = options.right
          right = options.bottom
          bottom = options.left
          left = options.top
          break
      }
      // Some orientation combinations require additional rotation by 180°:
      if (requiresRot180(orientation, autoOrientation)) {
        var tmpTop = top
        var tmpRight = right
        top = bottom
        right = left
        bottom = tmpTop
        left = tmpRight
      }
    }
    newOptions.top = top
    newOptions.right = right
    newOptions.bottom = bottom
    newOptions.left = left
    // Account for defined browser orientation:
    switch (orientation) {
      case 2:
        // Horizontal flip
        newOptions.right = left
        newOptions.left = right
        break
      case 3:
        // 180° Rotate CCW
        newOptions.top = bottom
        newOptions.right = left
        newOptions.bottom = top
        newOptions.left = right
        break
      case 4:
        // Vertical flip
        newOptions.top = bottom
        newOptions.bottom = top
        break
      case 5:
        // Vertical flip + 90° Rotate CW
        newOptions.top = left
        newOptions.right = bottom
        newOptions.bottom = right
        newOptions.left = top
        break
      case 6:
        // 90° Rotate CW
        newOptions.top = right
        newOptions.right = bottom
        newOptions.bottom = left
        newOptions.left = top
        break
      case 7:
        // Horizontal flip + 90° Rotate CW
        newOptions.top = right
        newOptions.right = top
        newOptions.bottom = left
        newOptions.left = bottom
        break
      case 8:
        // 90° Rotate CCW
        newOptions.top = left
        newOptions.right = top
        newOptions.bottom = right
        newOptions.left = bottom
        break
    }
    return newOptions
  }

  // Transform image orientation based on the given EXIF orientation option:
  loadImage.transformCoordinates = function (canvas, options, data) {
    originalTransformCoordinates.call(loadImage, canvas, options, data)
    var orientation = options.orientation
    var autoOrientation =
      loadImage.orientation && data.exif && data.exif.get('Orientation')
    if (!requiresOrientationChange(orientation, autoOrientation)) {
      return
    }
    var ctx = canvas.getContext('2d')
    var width = canvas.width
    var height = canvas.height
    var sourceWidth = width
    var sourceHeight = height
    if (
      (orientation > 4 && !(autoOrientation > 4)) ||
      (orientation < 5 && autoOrientation > 4)
    ) {
      // Image dimensions and target dimensions are switched
      canvas.width = height
      canvas.height = width
    }
    if (orientation > 4) {
      // Destination and source dimensions are switched
      sourceWidth = height
      sourceHeight = width
    }
    // Reset automatic browser orientation:
    switch (autoOrientation) {
      case 2:
        // Horizontal flip
        ctx.translate(sourceWidth, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        // 180° Rotate CCW
        ctx.translate(sourceWidth, sourceHeight)
        ctx.rotate(Math.PI)
        break
      case 4:
        // Vertical flip
        ctx.translate(0, sourceHeight)
        ctx.scale(1, -1)
        break
      case 5:
        // Horizontal flip + 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.scale(-1, 1)
        break
      case 6:
        // 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-sourceWidth, 0)
        break
      case 7:
        // Vertical flip + 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-sourceWidth, sourceHeight)
        ctx.scale(1, -1)
        break
      case 8:
        // 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -sourceHeight)
        break
    }
    // Some orientation combinations require additional rotation by 180°:
    if (requiresRot180(orientation, autoOrientation)) {
      ctx.translate(sourceWidth, sourceHeight)
      ctx.rotate(Math.PI)
    }
    switch (orientation) {
      case 2:
        // Horizontal flip
        ctx.translate(width, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        // 180° Rotate CCW
        ctx.translate(width, height)
        ctx.rotate(Math.PI)
        break
      case 4:
        // Vertical flip
        ctx.translate(0, height)
        ctx.scale(1, -1)
        break
      case 5:
        // Vertical flip + 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.scale(1, -1)
        break
      case 6:
        // 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -height)
        break
      case 7:
        // Horizontal flip + 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(width, -height)
        ctx.scale(-1, 1)
        break
      case 8:
        // 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-width, 0)
        break
    }
  }
})


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(1753)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1754);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)))

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1755);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1755 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    Status: null,
    ProductType: null,
    OrderReference: null,
    PromotionCode: null,
    AmountPaid: null,
    Description: null,
    OriginName: null,
    originNlc: null,
    Origin: null,
    DestinationName: null,
    destinationNlc: null,
    Destination: null,
    IssuingLocationName: null,
    IssuingLocationCode: null,
    IssueDate: null,
    StartDate: null,
    ExpiryDate: null,
    TYP22ValueFlags: null,
    Class: null,
    routeCode: null,
    RouteName: null,
    RSPTicketID: null,
    TicketCode: null,
    Refundable: null,
    // KeyGo-related:
    ACCOUNT_ID: null,
    ACCOUNT_STATUS: null,
    ACCOUNT_TYPE: null,
    BALANCE: null,
    Balance: null,
    LAST_TOPUP_AMOUNT: null,
    LAST_TOPUP_DATE: null,
    TOPUP_FAILURE_COUNT: null,
    TOPUP_STATUS: null,
    TOTAL_INCOMPLETE_COUNT: null,
    PROVISIONAL_INCOMPLETE_COUNT: null,
    TravelClass: null
};

function convertToTrainTime(format) {
    return function (timeStr) {
        var datetime = (0, _TrainTime2.default)(timeStr, format);
        // Workaround CMS quirks
        return datetime.isValid() && datetime.year() > 2000 ? datetime : undefined;
    };
}

var SmartcardProductParameters = function (_record) {
    (0, _inherits3.default)(SmartcardProductParameters, _record);

    function SmartcardProductParameters() {
        (0, _classCallCheck3.default)(this, SmartcardProductParameters);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartcardProductParameters.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(SmartcardProductParameters, json, {
            Status: _LinkMapper.resolve.with(String),
            ProductType: _LinkMapper.resolve.with(String),
            OrderReference: _LinkMapper.resolve.with(String),
            PromotionCode: _LinkMapper.resolve.with(String),
            AmountPaid: _LinkMapper.resolve.with(Number),
            Description: _LinkMapper.resolve.with(String),
            OriginName: _LinkMapper.resolve.with(String),
            originNlc: _LinkMapper.resolve.with(String),
            Origin: _LinkMapper.resolve.with(String),
            DestinationName: _LinkMapper.resolve.with(String),
            destinationNlc: _LinkMapper.resolve.with(String),
            Destination: _LinkMapper.resolve.with(String),
            IssuingLocationName: _LinkMapper.resolve.with(String),
            IssuingLocationCode: _LinkMapper.resolve.with(String),
            IssueDate: _LinkMapper.resolve.with(convertToTrainTime()),
            StartDate: _LinkMapper.resolve.with(convertToTrainTime()),
            ExpiryDate: _LinkMapper.resolve.with(convertToTrainTime()),
            TYP22ValueFlags: _LinkMapper.resolve.with(String),
            Class: _LinkMapper.resolve.with(String),
            routeCode: _LinkMapper.resolve.with(String),
            RouteName: _LinkMapper.resolve.with(String),
            RSPTicketID: _LinkMapper.resolve.with(String),
            TicketCode: _LinkMapper.resolve.with(String),
            Refundable: _LinkMapper.resolve.with(String),
            target: _LinkMapper.resolve.with(String),
            expiryDateOfPasses: _LinkMapper.resolve.with(convertToTrainTime()),
            dateOfLastUsedPass: _LinkMapper.resolve.with(convertToTrainTime()),
            NumberRemainingPasses: _LinkMapper.resolve.with(Number),
            PassDuration: _LinkMapper.resolve.with(String),
            ITSOTicketID: _LinkMapper.resolve.with(String),
            ACCOUNT_ID: _LinkMapper.resolve.with(Number),
            ACCOUNT_STATUS: _LinkMapper.resolve.with(String),
            ACCOUNT_TYPE: _LinkMapper.resolve.with(String),
            BALANCE: _LinkMapper.resolve.with(Number),
            Balance: _LinkMapper.resolve.with(Number),
            LAST_TOPUP_AMOUNT: _LinkMapper.resolve.with(Number),
            LAST_TOPUP_DATE: _LinkMapper.resolve.with(convertToTrainTime('ddd MMM DD HH:mm:SS ZZZ YYYY')),
            TOPUP_FAILURE_COUNT: _LinkMapper.resolve.with(Number),
            TOPUP_STATUS: _LinkMapper.resolve.with(String),
            TOTAL_INCOMPLETE_COUNT: _LinkMapper.resolve.with(Number),
            PROVISIONAL_INCOMPLETE_COUNT: _LinkMapper.resolve.with(Number),
            TravelClass: _LinkMapper.resolve.with(String)
        });
    };

    return SmartcardProductParameters;
}((0, _immutable.Record)(defaults));

exports.default = SmartcardProductParameters;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    enabled: [_LinkMapper.fields.boolean],
    status: [_LinkMapper.fields.string],
    incompleteJourneys: [_LinkMapper.fields.boolean],
    paymentCardStatus: [_LinkMapper.fields.string],
    manualFillCount: [_LinkMapper.fields.number],
    balance: [_LinkMapper.fields.number]
};

var KeyGo = function (_record) {
    (0, _inherits3.default)(KeyGo, _record);

    function KeyGo() {
        (0, _classCallCheck3.default)(this, KeyGo);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    KeyGo.fromJSON = function fromJSON(json) {
        return (0, _LinkMapper.construct)(KeyGo, json, (0, _Records.getResolvers)(schema));
    };

    KeyGo.prototype.isActive = function isActive() {
        return _AppConstants.KeyGoProductStatus.LIVE === this.status;
    };

    KeyGo.prototype.isPending = function isPending() {
        return _AppConstants.KeyGoProductStatus.PENDING === this.status;
    };

    KeyGo.prototype.isPendingClosure = function isPendingClosure() {
        return _AppConstants.KeyGoProductStatus.PENDING_CLOSURE === this.status;
    };

    KeyGo.prototype.isClosed = function isClosed() {
        return _AppConstants.KeyGoProductStatus.CLOSED === this.status;
    };

    KeyGo.prototype.hasIncompleteJourneys = function hasIncompleteJourneys() {
        return this.get('incompleteJourneys');
    };

    KeyGo.prototype.getBalance = function getBalance() {
        return this.get('balance');
    };

    KeyGo.prototype.hasNegativeBalance = function hasNegativeBalance() {
        return this.getBalance() < 0;
    };

    KeyGo.prototype.getPaymentCardStatus = function getPaymentCardStatus() {
        return this.get('paymentCardStatus');
    };

    KeyGo.prototype.isPaymentCardPending = function isPaymentCardPending() {
        return this.getPaymentCardStatus() === _AppConstants.keyGoPaymentCardStatus.EXPIRES_THIS_MONTH;
    };

    KeyGo.prototype.isPaymentCardExpired = function isPaymentCardExpired() {
        return this.getPaymentCardStatus() === _AppConstants.keyGoPaymentCardStatus.EXPIRED;
    };

    KeyGo.prototype.isPaymentCardExpiredOrAboutTo = function isPaymentCardExpiredOrAboutTo() {
        return this.isPaymentCardPending() || this.isPaymentCardExpired();
    };

    return KeyGo;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

exports.default = KeyGo;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _zipObject2 = __webpack_require__(204);

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _KeyGoJourneyPattern = __webpack_require__(1759);

var _KeyGoJourneyPattern2 = _interopRequireDefault(_KeyGoJourneyPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = (0, _zipObject3.default)(['transactionId', 'dateTime', 'description', 'value', 'balance', 'reasonCode', 'reasonDescription', 'journeyPattern']);

var KeyGoTransaction = function (_record) {
    (0, _inherits3.default)(KeyGoTransaction, _record);

    function KeyGoTransaction() {
        (0, _classCallCheck3.default)(this, KeyGoTransaction);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    KeyGoTransaction.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var data = {
            transactionId: (0, _LinkMapper.resolve)(json.transactionId).with(Number),
            dateTime: (0, _LinkMapper.resolve)(json.dateTime).with(_TrainTime2.default),
            description: (0, _LinkMapper.resolve)(json.description).with(String),
            value: (0, _LinkMapper.resolve)(json.value).with(Number),
            balance: (0, _LinkMapper.resolve)(json.balance).with(Number),
            reasonCode: (0, _LinkMapper.resolve)(json.reasonCode).with(String),
            reasonDescription: (0, _LinkMapper.resolve)(json.reasonDescription).with(String),
            journeyPattern: (0, _LinkMapper.resolveAll)(json.journeyPattern).as(_KeyGoJourneyPattern2.default)
        };
        return new KeyGoTransaction(data);
    };

    KeyGoTransaction.prototype.isDaily = function isDaily() {
        return this.description === "Daily Fares";
    };

    return KeyGoTransaction;
}((0, _immutable.Record)(defaults));

exports.default = KeyGoTransaction;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _zipObject2 = __webpack_require__(204);

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _KeyGoTap = __webpack_require__(1760);

var _KeyGoTap2 = _interopRequireDefault(_KeyGoTap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = (0, _zipObject3.default)(['journeyId', 'description', 'transitMode', 'origin', 'destination', 'routeName', 'fare', 'startTime', 'endTime', 'type', 'taps']);

var KeyGoJourneyPattern = function (_record) {
    (0, _inherits3.default)(KeyGoJourneyPattern, _record);

    function KeyGoJourneyPattern() {
        (0, _classCallCheck3.default)(this, KeyGoJourneyPattern);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    KeyGoJourneyPattern.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var data = {
            journeyId: (0, _LinkMapper.resolve)(json.journeyId).with(Number),
            description: (0, _LinkMapper.resolve)(json.description).with(String),
            transitMode: (0, _LinkMapper.resolve)(json.transitMode).with(String),
            origin: (0, _LinkMapper.resolve)(json.origin).with(String),
            destination: (0, _LinkMapper.resolve)(json.destination).with(String),
            routeName: (0, _LinkMapper.resolve)(json.routeName).with(String),
            fare: (0, _LinkMapper.resolve)(json.fare).with(Number),
            startTime: (0, _LinkMapper.resolve)(json.startTime).with(_TrainTime2.default),
            endTime: (0, _LinkMapper.resolve)(json.endTime).with(_TrainTime2.default),
            type: (0, _LinkMapper.resolve)(json.type).with(String),
            taps: (0, _LinkMapper.resolveAll)(json.taps).as(_KeyGoTap2.default)
        };
        return new KeyGoJourneyPattern(data);
    };

    return KeyGoJourneyPattern;
}((0, _immutable.Record)(defaults));

exports.default = KeyGoJourneyPattern;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _zipObject2 = __webpack_require__(204);

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _immutable = __webpack_require__(5);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = (0, _zipObject3.default)(['description', 'transitMode', 'dateTime', 'type', 'status']);

var KeyGoTap = function (_record) {
    (0, _inherits3.default)(KeyGoTap, _record);

    function KeyGoTap() {
        (0, _classCallCheck3.default)(this, KeyGoTap);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    KeyGoTap.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var data = {
            description: (0, _LinkMapper.resolve)(json.description).with(String),
            transitMode: (0, _LinkMapper.resolve)(json.transitMode).with(String),
            dateTime: (0, _LinkMapper.resolve)(json.dateTime).with(_TrainTime2.default),
            type: (0, _LinkMapper.resolve)(json.type).with(String),
            status: (0, _LinkMapper.resolve)(json.status).with(String)
        };
        return new KeyGoTap(data);
    };

    return KeyGoTap;
}((0, _immutable.Record)(defaults));

exports.default = KeyGoTap;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    reference: null,
    dateTime: null,
    type: null,
    attributes: null
};

var SmartcardJourneyRecord = function (_record) {
    (0, _inherits3.default)(SmartcardJourneyRecord, _record);

    function SmartcardJourneyRecord() {
        (0, _classCallCheck3.default)(this, SmartcardJourneyRecord);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartcardJourneyRecord.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(SmartcardJourneyRecord, json, {
            reference: _LinkMapper.resolve.with(String),
            dateTime: _LinkMapper.resolve.with(_TrainTime2.default),
            type: _LinkMapper.resolve.with(String),
            attributes: _LinkMapper.resolve.with(_immutable.Map)
        });
    };

    SmartcardJourneyRecord.prototype.isJourney = function isJourney() {
        return this.type.match(/^Journey record/);
    };

    SmartcardJourneyRecord.prototype.isJourneyStart = function isJourneyStart() {
        return this.type === 'Journey record - Check in';
    };

    SmartcardJourneyRecord.prototype.isJourneyEnd = function isJourneyEnd() {
        return this.type === 'Journey record - Check out';
    };

    SmartcardJourneyRecord.prototype.getLocation = function getLocation() {
        if (this.isJourneyStart()) {
            return this.attributes.get('Origin');
        }
        if (this.isJourneyEnd()) {
            return this.attributes.get('Destination');
        }
        return null;
    };

    return SmartcardJourneyRecord;
}((0, _immutable.Record)(defaults));

exports.default = SmartcardJourneyRecord;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _tail2 = __webpack_require__(545);

var _tail3 = _interopRequireDefault(_tail2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    customerId: null,
    customerName: null,
    email: null,
    smartcardNumber: null,
    smartcardStatus: null,
    isAdult: false
};

var SmartcardAccountInfo = function (_record) {
    (0, _inherits3.default)(SmartcardAccountInfo, _record);

    function SmartcardAccountInfo() {
        (0, _classCallCheck3.default)(this, SmartcardAccountInfo);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartcardAccountInfo.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new SmartcardAccountInfo({
            customerId: (0, _LinkMapper.resolve)(json.customerId).with(Number),
            customerName: (0, _LinkMapper.resolve)(json.customerName).with(String),
            email: (0, _LinkMapper.resolve)(json.email).with(String),
            smartcardNumber: (0, _LinkMapper.resolve)(json.smartcardNumber).with(String),
            smartcardStatus: (0, _LinkMapper.resolve)(json.smartcardStatus).with(String),
            isAdult: (0, _LinkMapper.resolve)(json.isAdult).with(Boolean)
        });
    };

    SmartcardAccountInfo.prototype.getCardNumber = function getCardNumber() {
        var smartcardNumber = this.smartcardNumber;

        var re = /(\d{6})(\d{4})(\d{4})(\d{4})/;
        var match = smartcardNumber && smartcardNumber.match(re);
        if (match) {
            return (0, _tail3.default)(match).join('-');
        }
        return null;
    };

    return SmartcardAccountInfo;
}((0, _immutable.Record)(defaults));

exports.default = SmartcardAccountInfo;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    requestorName: null
};

var SmartcardAssociationConfirmation = function (_record) {
    (0, _inherits3.default)(SmartcardAssociationConfirmation, _record);

    function SmartcardAssociationConfirmation() {
        (0, _classCallCheck3.default)(this, SmartcardAssociationConfirmation);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    SmartcardAssociationConfirmation.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new SmartcardAssociationConfirmation({
            requestorName: (0, _LinkMapper.resolve)(json.requestorName).with(String)
        });
    };

    return SmartcardAssociationConfirmation;
}((0, _immutable.Record)(defaults));

exports.default = SmartcardAssociationConfirmation;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Voucher = __webpack_require__(841);

var _Voucher2 = _interopRequireDefault(_Voucher);

var _APIClient = __webpack_require__(52);

var _LinkMapper = __webpack_require__(8);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherService = {
    getAll: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var userId, endpoint, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            userId = user.id;
                            endpoint = '/customers/' + userId + '/vouchers';
                            _context.next = 5;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 5:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Voucher2.default));

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0 instanceof _APIClient.NotFoundError) {
                                _context.next = 13;
                                break;
                            }

                            throw _context.t0;

                        case 13:
                            return _context.abrupt('return', null);

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 9]]);
        }));

        function getAll(_x) {
            return _ref.apply(this, arguments);
        }

        return getAll;
    }()
};

exports.default = VoucherService;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _LinkMapper = __webpack_require__(8);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _STicket = __webpack_require__(1766);

var _STicket2 = _interopRequireDefault(_STicket);

var _STicketCoupon = __webpack_require__(1767);

var _STicketCoupon2 = _interopRequireDefault(_STicketCoupon);

var _Pager = __webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STicketService = {
    loadSTickets: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(userId) {
            var url, result;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = '/stickets/' + userId + '/tickets';
                            _context.next = 3;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 3:
                            result = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(result).as(_STicket2.default).sort(function (a, b) {
                                return a.purchaseDateTime.isBefore(b.purchaseDateTime) ? 1 : -1;
                            }));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadSTickets(_x) {
            return _ref.apply(this, arguments);
        }

        return loadSTickets;
    }(),
    getAllSurfacedCoupons: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(userId) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var url, _ref3, result, pagination;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            url = '/stickets/' + userId + '/coupons/surfaced' + search;
                            _context2.next = 3;
                            return _AuthenticatedAPIClient2.default.get(url);

                        case 3:
                            _ref3 = _context2.sent;
                            result = _ref3.result;
                            pagination = _ref3.pagination;
                            return _context2.abrupt('return', { coupons: (0, _LinkMapper.resolveAll)(result).as(_STicketCoupon2.default), pagination: new _Pager.APIPager(pagination) });

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function getAllSurfacedCoupons(_x3) {
            return _ref2.apply(this, arguments);
        }

        return getAllSurfacedCoupons;
    }(),
    loadSTicketPhotoRequests: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user) {
            var url;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            url = '/stickets/image/' + user.id + '/changes?status=pending';
                            return _context3.abrupt('return', _AuthenticatedAPIClient2.default.get(url));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function loadSTicketPhotoRequests(_x4) {
            return _ref4.apply(this, arguments);
        }

        return loadSTicketPhotoRequests;
    }()
};

exports.default = STicketService;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    brand: null,
    destination: new _Station2.default(),
    orderId: null,
    origin: new _Station2.default(),
    purchaseDateTime: null,
    ticketId: null,
    ticketNumber: null,
    ticketTypeCode: null,
    validFromDate: null,
    validityPeriod: null,
    validToDate: null,
    status: null,
    isFlexi: false
};

var STicket = function (_record) {
    (0, _inherits3.default)(STicket, _record);

    function STicket() {
        (0, _classCallCheck3.default)(this, STicket);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    STicket.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(STicket, json, {
            id: _LinkMapper.fields.string,
            brand: _LinkMapper.fields.string,
            destination: _LinkMapper.resolve.as(_Station2.default),
            orderId: _LinkMapper.fields.string,
            origin: _LinkMapper.resolve.as(_Station2.default),
            purchaseDateTime: _LinkMapper.fields.datetime,
            ticketId: _LinkMapper.fields.string,
            ticketNumber: _LinkMapper.fields.string,
            ticketTypeCode: _LinkMapper.fields.string,
            validFromDate: _LinkMapper.fields.datetime,
            validityPeriod: _LinkMapper.fields.string,
            validToDate: _LinkMapper.fields.datetime,
            status: _LinkMapper.fields.string,
            isFlexi: _LinkMapper.fields.bool
        });
    };

    return STicket;
}((0, _immutable.Record)(defaults));

exports.default = STicket;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _STicketScan = __webpack_require__(1768);

var _STicketScan2 = _interopRequireDefault(_STicketScan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    brand: null,
    createdDate: null,
    destination: new _Station2.default(),
    orderId: null,
    origin: new _Station2.default(),
    scans: [],
    subUtn: null,
    ticketId: null,
    ticketNumber: null,
    ticketTypeCode: null,
    utn: null,
    validTo: null
};

var STicketCoupon = function (_record) {
    (0, _inherits3.default)(STicketCoupon, _record);

    function STicketCoupon() {
        (0, _classCallCheck3.default)(this, STicketCoupon);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    STicketCoupon.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(STicketCoupon, json, {
            id: _LinkMapper.fields.string,
            brand: _LinkMapper.fields.string,
            createdDate: _LinkMapper.fields.datetime,
            destination: _LinkMapper.resolve.as(_Station2.default),
            orderId: _LinkMapper.fields.string,
            origin: _LinkMapper.resolve.as(_Station2.default),
            scans: _LinkMapper.resolveAll.as(_STicketScan2.default),
            subUtn: _LinkMapper.fields.string,
            ticketId: _LinkMapper.fields.string,
            ticketNumber: _LinkMapper.fields.string,
            ticketTypeCode: _LinkMapper.fields.string,
            utn: _LinkMapper.fields.string,
            validTo: _LinkMapper.fields.datetime
        });
    };

    return STicketCoupon;
}((0, _immutable.Record)(defaults));

exports.default = STicketCoupon;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    date: null,
    event: null,
    location: new _Station2.default()
};

var STicketScan = function (_record) {
    (0, _inherits3.default)(STicketScan, _record);

    function STicketScan() {
        (0, _classCallCheck3.default)(this, STicketScan);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    STicketScan.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(STicketScan, json, {
            date: _LinkMapper.fields.datetime,
            event: _LinkMapper.fields.string,
            location: _LinkMapper.resolve.as(_Station2.default)
        });
    };

    return STicketScan;
}((0, _immutable.Record)(defaults));

exports.default = STicketScan;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AccountRailcardSubmissionError = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ExtendableError2 = __webpack_require__(91);

var _ExtendableError3 = _interopRequireDefault(_ExtendableError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountRailcardSubmissionError = exports.AccountRailcardSubmissionError = function (_ExtendableError) {
  (0, _inherits3.default)(AccountRailcardSubmissionError, _ExtendableError);

  function AccountRailcardSubmissionError() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AccountRailcardSubmissionError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ExtendableError.call.apply(_ExtendableError, [this].concat(args))), _this), _this.name = 'AccountRailcardSubmissionError', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return AccountRailcardSubmissionError;
}(_ExtendableError3.default);

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    type: null,
    amount: 0,
    customer: null,
    success: false,
    processing: false
};

var PaymentResponse = function (_Record) {
    (0, _inherits3.default)(PaymentResponse, _Record);

    function PaymentResponse() {
        (0, _classCallCheck3.default)(this, PaymentResponse);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    PaymentResponse.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(PaymentResponse, json, {
            id: _LinkMapper.fields.string,
            type: _LinkMapper.fields.string,
            amount: _LinkMapper.fields.number,
            customer: _LinkMapper.fields.string,
            success: _LinkMapper.fields.boolean
        });
    };

    return PaymentResponse;
}((0, _immutable.Record)(defaults));

exports.default = PaymentResponse;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1772);
module.exports = __webpack_require__(78).Object.keys;


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(260);
var $keys = __webpack_require__(261);

__webpack_require__(844)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(190);
var toLength = __webpack_require__(398);
var toAbsoluteIndex = __webpack_require__(1774);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(550);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1776);
var $Object = __webpack_require__(78).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(88);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(555) });


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(167);
var anObject = __webpack_require__(192);
var getKeys = __webpack_require__(261);

module.exports = __webpack_require__(154) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(138).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$setPrototypeOf = __webpack_require__(849);

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = _Object$setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1781);
module.exports = __webpack_require__(78).Object.setPrototypeOf;


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(88);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1782).set });


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(139);
var anObject = __webpack_require__(192);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(262)(Function.call, __webpack_require__(556).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1784);
module.exports = __webpack_require__(78).Object.assign;


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(88);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(850) });


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(194));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(1786));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var _on = _interopRequireDefault(__webpack_require__(558));

var _off = _interopRequireDefault(__webpack_require__(559));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(1789);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(1792));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(1793));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(854));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(854));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1796));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(855));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(402);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(404);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(264);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(1805);

var _Symbol$iterator = __webpack_require__(1812);

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1806);

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1807);
__webpack_require__(859);
__webpack_require__(1810);
__webpack_require__(1811);
module.exports = __webpack_require__(78).Symbol;


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(138);
var has = __webpack_require__(189);
var DESCRIPTORS = __webpack_require__(154);
var $export = __webpack_require__(88);
var redefine = __webpack_require__(564);
var META = __webpack_require__(406).KEY;
var $fails = __webpack_require__(193);
var shared = __webpack_require__(552);
var setToStringTag = __webpack_require__(407);
var uid = __webpack_require__(400);
var wks = __webpack_require__(140);
var wksExt = __webpack_require__(565);
var wksDefine = __webpack_require__(566);
var enumKeys = __webpack_require__(1808);
var isArray = __webpack_require__(567);
var anObject = __webpack_require__(192);
var isObject = __webpack_require__(139);
var toObject = __webpack_require__(260);
var toIObject = __webpack_require__(190);
var toPrimitive = __webpack_require__(554);
var createDesc = __webpack_require__(322);
var _create = __webpack_require__(555);
var gOPNExt = __webpack_require__(1809);
var $GOPD = __webpack_require__(556);
var $GOPS = __webpack_require__(557);
var $DP = __webpack_require__(167);
var $keys = __webpack_require__(261);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(858).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(323).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(399)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(191)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(261);
var gOPS = __webpack_require__(557);
var pIE = __webpack_require__(323);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(190);
var gOPN = __webpack_require__(858).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(566)('asyncIterator');


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(566)('observable');


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1813);

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(860);
__webpack_require__(862);
module.exports = __webpack_require__(565).f('iterator');


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(550);
var defined = __webpack_require__(397);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(555);
var descriptor = __webpack_require__(322);
var setToStringTag = __webpack_require__(407);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(191)(IteratorPrototype, __webpack_require__(140)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(189);
var toObject = __webpack_require__(260);
var IE_PROTO = __webpack_require__(551)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1818);
var step = __webpack_require__(1819);
var Iterators = __webpack_require__(325);
var toIObject = __webpack_require__(190);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(861)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1821);

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(859);
__webpack_require__(862);
__webpack_require__(1822);
__webpack_require__(1828);
__webpack_require__(1830);
module.exports = __webpack_require__(78).WeakMap;


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(138);
var each = __webpack_require__(568)(0);
var redefine = __webpack_require__(564);
var meta = __webpack_require__(406);
var assign = __webpack_require__(850);
var weak = __webpack_require__(1825);
var isObject = __webpack_require__(139);
var validate = __webpack_require__(570);
var NATIVE_WEAK_MAP = __webpack_require__(570);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(1827)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1824);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(139);
var isArray = __webpack_require__(567);
var SPECIES = __webpack_require__(140)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(863);
var getWeak = __webpack_require__(406).getWeak;
var anObject = __webpack_require__(192);
var isObject = __webpack_require__(139);
var anInstance = __webpack_require__(864);
var forOf = __webpack_require__(569);
var createArrayMethod = __webpack_require__(568);
var $has = __webpack_require__(189);
var validate = __webpack_require__(570);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(549);
var TAG = __webpack_require__(140)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(138);
var $export = __webpack_require__(88);
var meta = __webpack_require__(406);
var fails = __webpack_require__(193);
var hide = __webpack_require__(191);
var redefineAll = __webpack_require__(863);
var forOf = __webpack_require__(569);
var anInstance = __webpack_require__(864);
var isObject = __webpack_require__(139);
var setToStringTag = __webpack_require__(407);
var dP = __webpack_require__(167).f;
var each = __webpack_require__(568)(0);
var DESCRIPTORS = __webpack_require__(154);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(1829)('WeakMap');


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(88);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(1831)('WeakMap');


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(88);
var aFunction = __webpack_require__(845);
var ctx = __webpack_require__(262);
var forOf = __webpack_require__(569);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1833);

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1834);
var $Object = __webpack_require__(78).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(88);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(154), 'Object', { defineProperty: __webpack_require__(167).f });


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1836);

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1837);
var $Object = __webpack_require__(78).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(190);
var $getOwnPropertyDescriptor = __webpack_require__(556).f;

__webpack_require__(844)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1841);
module.exports = __webpack_require__(78).Object.entries;


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(88);
var $entries = __webpack_require__(869)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1843);
module.exports = __webpack_require__(78).Object.values;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(88);
var $values = __webpack_require__(869)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.modalContainer = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ModalManager2 = __webpack_require__(853);

var _ModalManager3 = _interopRequireDefault(_ModalManager2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Create a container for the modal (instead of document.body)
// This is for the purposes of being able to scope CSS
var modalContainer = exports.modalContainer = createContainer();

function createContainer() {
    var container = void 0;
    if (typeof document !== 'undefined' && typeof document.body.append === 'function') {
        container = document.createElement('section');
        container.classList.add('otrl-body', 'otrl-container');
        document.body.append(container);
    }
    return container;
}

var ReactOverlayManager = function (_ModalManager) {
    (0, _inherits3.default)(ReactOverlayManager, _ModalManager);

    function ReactOverlayManager() {
        (0, _classCallCheck3.default)(this, ReactOverlayManager);

        // Keep track of the current modal
        var _this = (0, _possibleConstructorReturn3.default)(this, _ModalManager.call(this));

        _this.currentIndex = -1;

        // Methods are not on prototype, so cannot subclass/use super()
        // Need to override/wrap in constructor
        var add = _this.add,
            remove = _this.remove;


        _this.add = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            // add modal to container
            add.apply(_this, args);

            _this.currentIndex++;
        };

        _this.remove = function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            // remove modal
            remove.apply(_this, args);

            _this.currentIndex--;

            // Workaround an accessibility issue with multiple dialogs.
            // When `hideSiblingNodes=true` (the default), it will add `[aria-hidden=true]` to any siblings
            // when you open a new modal. This causes a problem when modal1 opens modal2.
            // In this scenario, modal1 becomes `aria-hidden` which is not removed when modal2 closes!
            // This is a bug, and may be fixed in later versions of react-overlays, but this would require
            // upgrading react-bootstrap also.
            //
            // It would be possible to workaround this by setting `hideSiblingNodes=false`, but
            // This has a drawback: since all modals are accessible, it's possible for the user to
            // accidentally find themselves in modal1 when modal2 is still open.
            //
            // Instead, we will keep the default behaviour, but patch it by removing `[aria-hidden]`
            // from the last-added modal whenever you are closing a modal.

            var modals = modalContainer ? modalContainer.children : [];
            var currentModal = modals[_this.currentIndex];
            if (currentModal) {
                currentModal.removeAttribute('aria-hidden');
            }
        };
        return _this;
    }

    return ReactOverlayManager;
}(_ModalManager3.default);

exports.default = ReactOverlayManager;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(1005));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.appNotifyFactory = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _debounce2 = __webpack_require__(277);

var _debounce3 = _interopRequireDefault(_debounce2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _reactSideEffect = __webpack_require__(1847);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

var _InAppActions = __webpack_require__(960);

var _InAppActions2 = _interopRequireDefault(_InAppActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleStateChangeOnClient(state) {
    if (!_InAppStore2.default.isInApp()) {
        return;
    }

    var title = state.title,
        goBack = state.goBack;

    _InAppActions2.default.notifyNavbar(title, goBack);
}

var AppNotify = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(AppNotify, _Component);

    function AppNotify() {
        (0, _classCallCheck3.default)(this, AppNotify);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
    }

    AppNotify.prototype.render = function render() {
        return _react.Children.only(this.props.children);
    };

    return AppNotify;
}(_react.Component), _class.propTypes = {
    title: _propTypes2.default.string.isRequired,
    goBack: _propTypes2.default.bool,
    children: _propTypes2.default.any
}, _temp);


function reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) {
        return innermostProps;
    }
    return null;
}

var appNotifyFactory = exports.appNotifyFactory = function appNotifyFactory() {
    var debounce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _debounce3.default;
    return (0, _reactSideEffect2.default)(reducePropsToState, debounce(handleStateChangeOnClient))(AppNotify);
};

exports.default = appNotifyFactory();

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _semver = __webpack_require__(599);

var _semver2 = _interopRequireDefault(_semver);

var _urijs = __webpack_require__(283);

var _urijs2 = _interopRequireDefault(_urijs);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _DeviceDetection = __webpack_require__(597);

var _InAppHelpers = __webpack_require__(969);

var _APIClient = __webpack_require__(52);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppNotifyService = {
    notify: function notify(path) {
        var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // new app
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage((0, _stringify2.default)({
                source: 'otrl',
                event: path,
                data: query
            }));
        }

        // Old app
        var url = _urijs2.default.build({
            protocol: 'https',
            hostname: 'otrl',
            path: path,
            query: _urijs2.default.buildQuery(query, false, false)
        });

        return (0, _APIClient.fetcher)(url, { loader: false }).catch(function () {
            var hasAppSupport = _InAppStore2.default.getAppVersion() && _semver2.default.satisfies((0, _InAppHelpers.standardizeVersion)(_InAppStore2.default.getAppVersion()), _config2.default.get('gaAjaxHandlerAppVersion'));
            var isIOS = (0, _DeviceDetection.deviceDetection)() === 'iOS';
            if (_InAppStore2.default.isInApp() && hasAppSupport && isIOS) {
                // The iOS version of the app requires that all custom queries
                // starts with gaajaxhandler:// custom scheme.
                window.location = 'gaajaxhandler://' + url;
            }
        });
    }
};

exports.default = AppNotifyService;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = BaseModalTracker;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _useFeatureFlag = __webpack_require__(624);

var _useFeatureFlag2 = _interopRequireDefault(_useFeatureFlag);

var _ModalManager = __webpack_require__(874);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _ModalCounter = __webpack_require__(875);

var _ModalCounter2 = _interopRequireDefault(_ModalCounter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

BaseModalTracker.propTypes = {
    show: _propTypes2.default.bool,
    onClose: _propTypes2.default.func,
    disableClose: _propTypes2.default.bool,
    disableEscape: _propTypes2.default.bool
};

function BaseModalTracker(_ref) {
    var show = _ref.show,
        onClose = _ref.onClose,
        disableClose = _ref.disableClose,
        disableEscape = _ref.disableEscape,
        disableBlur = _ref.disableBlur;

    // Modal counting
    var setCount = (0, _ModalCounter2.default)();
    React.useEffect(function () {
        if (show && setCount) {
            setCount(function (c) {
                return ++c;
            });
            return function () {
                return setCount(function (c) {
                    return Math.max(--c, 0);
                });
            };
        }
        return undefined;
    }, [setCount, show]);

    // History tracking
    var addModal = (0, _ModalManager2.default)(onClose);
    var enableHistoryTracking = (0, _useFeatureFlag2.default)('enableModalHistoryTracking');

    // Don't manage the modal state in the history if closing the modal is disabled
    var canManageHistory = enableHistoryTracking && !(disableBlur && disableClose && disableEscape);
    var manageOpenModal = canManageHistory && show && addModal;
    var onCloseRef = React.useRef();
    onCloseRef.current = onClose;
    React.useEffect(function () {
        var cleanup = void 0;
        if (manageOpenModal) {
            cleanup = manageOpenModal(onCloseRef);
        }

        return function () {
            if (cleanup) {
                cleanup();
            }
        };
    }, [manageOpenModal]);

    return null;
}

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandSplitSuccess = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(BrandSplitSuccess, _React$PureComponent);

    function BrandSplitSuccess() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BrandSplitSuccess);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleCancel = function () {
            _ModalActions2.default.close();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    BrandSplitSuccess.prototype.render = function render() {
        var logo = '/images/logos/' + this.props.brand + '-logo-mobile.png';
        var modalProps = {
            disableEscape: true,
            titleText: 'brand.split.success',
            closeText: 'button.text.close',
            onClose: this.handleCancel,
            hideContinue: true,
            className: "modal--sm"
        };

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'div',
                { className: 'vertical-align-parent full-height' },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('success text-center') },
                    _react2.default.createElement(
                        'p',
                        { className: 'text-secondary text-weight--normal' },
                        (0, _I18n.translate)('brand.split.message')
                    ),
                    _react2.default.createElement('img', { src: logo, alt: this.props.brand })
                )
            )
        );
    };

    return BrandSplitSuccess;
}(_react2.default.PureComponent), _class.propTypes = {
    brand: _propTypes2.default.string
}, _class.defaultProps = {
    brand: ''
}, _temp2);
exports.default = BrandSplitSuccess;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(85);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoIncompleteJourneyModal = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(KeyGoIncompleteJourneyModal, _React$PureComponent);

    function KeyGoIncompleteJourneyModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, KeyGoIncompleteJourneyModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleClose = function () {
            _ModalActions2.default.close();
        }, _this._handleIncompleteJourney = function () {
            _this.props.router.push(_urls2.default.location(_AppConstants.AccountPages.SMARTCARD_KEYGO_HISTORY));
            _ModalActions2.default.close();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    KeyGoIncompleteJourneyModal.prototype.render = function render() {
        var modalProps = {
            onClose: this._handleClose,
            onContinue: this._handleIncompleteJourney,
            closeText: 'global.banner.dismiss',
            continueText: 'button.text.amend',
            className: 'modal--standard modal--xs',
            titleText: 'account.smartcard.keygo.incompleteJourneys.heading',
            disableEscape: true
        };
        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'div',
                { className: 'padding-top padding-bottom padding--horiz' },
                _react2.default.createElement(
                    'section',
                    { className: 'text-center' },
                    _react2.default.createElement(_Icon2.default, { icon: 'warning', className: 'journey-notification__icon' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'text-justify' },
                        _react2.default.createElement(_FormattedHTMLMessage2.default, {
                            message: 'account.smartcard.keygo.incompleteJourneys.body'
                        })
                    )
                )
            )
        );
    };

    return KeyGoIncompleteJourneyModal;
}(_react2.default.PureComponent), _class.propTypes = {
    onClose: _propTypes2.default.func,
    onContinue: _propTypes2.default.func,
    router: _PropTypes.routerShape
}, _class.defaultProps = {
    onClose: _noop3.default,
    onContinue: _noop3.default
}, _temp2);
exports.default = KeyGoIncompleteJourneyModal;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

var escapeHtmlChar = __webpack_require__(1853),
    toString = __webpack_require__(119);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(639);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

module.exports = escapeHtmlChar;


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1855);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(504),l=__webpack_require__(0);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,w=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.fundamental"):60117,la=t?Symbol.for("react.scope"):60119,C=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;C.hasOwnProperty("ReactCurrentDispatcher")||(C.ReactCurrentDispatcher={current:null});C.hasOwnProperty("ReactCurrentBatchConfig")||(C.ReactCurrentBatchConfig={suspense:null});
function ma(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
function D(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case w:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return D(a.type);case ja:if(a=1===a._status?a._result:null)return D(a)}return null}var na={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}function oa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=na;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var pa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,qa=Object.prototype.hasOwnProperty,ra={},sa={};
function ta(a){if(qa.call(sa,a))return!0;if(qa.call(ra,a))return!1;if(pa.test(a))return sa[a]=!0;ra[a]=!0;return!1}function ua(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function va(a,b,c,d){if(null===b||"undefined"===typeof b||ua(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var wa=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=wa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function xa(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||va(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+"="+('"'+N(b)+'"')}return ta(a)?a+"="+('"'+N(b)+'"'):""}function ya(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var za="function"===typeof Object.is?Object.is:ya,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Aa(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ba(){null===Q?null===P?(R=!1,P=Q=Aa()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Aa()):(R=!0,Q=Q.next);return Q}function Ca(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Da(a,b){return"function"===typeof b?b(a):b}
function Ea(a,b,c){O=W();Q=Ba();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Da?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Fa.bind(null,O,a);return[Q.memoizedState,a]}
function Fa(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ga(){}
var X=0,Ha={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ba();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!za(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ea,useRef:function(a){O=W();Q=Ba();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Ea(Da,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ga,useEffect:Ga,useDebugValue:Ga,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ia={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Ka={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},La=k({menuitem:!0},Ka),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ma=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Ma.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Na=/([A-Z])/g,Oa=/^ms-/,Z=l.Children.toArray,Pa=C.ReactCurrentDispatcher,Qa={listing:!0,pre:!0,textarea:!0},Ra=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Sa={},Ta={};function Ua(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Va=Object.prototype.hasOwnProperty,Wa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Xa(a,b){if(void 0===a)throw Error(q(152,D(b)||"Component"));}
function Ya(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=oa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var v=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=v&&(e.state=k({},e.state,v))}}else if(O={},e=g(d.props,
f,m),e=Ca(g,d.props,e,f),null==e||null==e.render){a=e;Xa(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{v=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,v,d.props,f):p;null!=p&&(y?(y=!1,v=k({},v,p)):k(v,p))}e.state=v}}else x=null;a=e.render();Xa(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,D(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
typeof g)break;d(f,g)}return{child:a,context:b}}
var Za=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ia.html,children:a,childIndex:0,context:na,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Pa.current;Pa.current=Ha;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
v="";try{v+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=v}}return g[0]}finally{Pa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Ya(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Ca(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case w:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ka:throw Error(q(338));case ja:switch(c=a.type,ma(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
}case la:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ia.html&&Ja(c);if(!Sa.hasOwnProperty(c)){if(!Ra.test(c))throw Error(q(65,c));Sa[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Ua(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:h,children:I})}}if(h=d){if(La[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Va.call(h,z)){var m=h[z];if(null!=m){if("style"===
z){n=void 0;var v="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ta.hasOwnProperty(A))A=Ta[A];else{var T=A.replace(Na,"-$1").toLowerCase().replace(Oa,"-ms-");A=Ta[A]=T}v+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";v+=y;r=";"}}m=v||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0}y?Wa.hasOwnProperty(z)||(n=z,n=ta(n)&&null!=m?n+"="+('"'+N(m)+'"'):""):n=xa(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";Ka.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Qa[c]&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?Ja(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),$a={renderToString:function(a){a=new Za(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Za(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
},version:"16.12.0"},ab={default:$a},bb=ab&&$a||ab;module.exports=bb.default||bb;


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = PromptModal;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PromptModal() {
    var footer = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _Link2.default,
            { to: _AppConstants.AccountPages.ACCOUNT_PREFERENCE_CENTRE, onClick: function onClick() {
                    return _ModalActions2.default.close(PromptModal);
                } },
            _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'primary', className: 'pull-right' },
                (0, _I18n2.default)('preference-centre.prompt-modal.continue-text')
            )
        )
    );

    var modalProps = {
        className: 'modal--xs',
        titleText: 'preference-centre.prompt-modal.title',
        disableEscape: true,
        footer: footer
    };
    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'preference-centre.prompt-modal.text', splitParagraphs: true })
    );
}

PromptModal.contextTypes = {
    router: _propTypes2.default.shape({
        push: _propTypes2.default.func
    })
};

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.KeyGoCardExpireModal = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _PropTypes = __webpack_require__(85);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoCardExpireModal = exports.KeyGoCardExpireModal = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(KeyGoCardExpireModal, _React$PureComponent);

    function KeyGoCardExpireModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, KeyGoCardExpireModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handleClose = function () {
            _ModalActions2.default.close();
        }, _this._handlePaymentDetails = function () {
            _this.props.router.push(_urls2.default.location(_AppConstants.AccountPages.SMARTCARD_KEYGO));
            _ModalActions2.default.close();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    KeyGoCardExpireModal.prototype.render = function render() {
        var modalProps = {
            onClose: this._handleClose,
            onContinue: this._handlePaymentDetails,
            closeText: 'button.text.close',
            continueText: 'button.text.updatePaymentDetails',
            className: 'modal--standard modal--xs',
            titleText: 'account.smartcard.keygo.cardExpire.heading',
            disableEscape: true
        };
        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'div',
                { className: 'padding-top padding-bottom padding--horiz' },
                _react2.default.createElement(
                    'section',
                    { className: 'text-center' },
                    _react2.default.createElement(_Icon2.default, { icon: 'warning', className: 'keygo-card-payment-status__icon' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'text-justify' },
                        _react2.default.createElement(_FormattedHTMLMessage2.default, {
                            message: this.props.cardStatus === _AppConstants.keyGoPaymentCardStatus.EXPIRES_THIS_MONTH ? 'account.smartcard.keygo.cardExpire.pending' : 'account.smartcard.keygo.cardExpire.expired'
                        })
                    )
                )
            )
        );
    };

    return KeyGoCardExpireModal;
}(_react2.default.PureComponent), _class.propTypes = {
    router: _PropTypes.routerShape,
    onClose: _propTypes2.default.func,
    onContinue: _propTypes2.default.func,
    cardStatus: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
    onClose: _noop3.default,
    onContinue: _noop3.default,
    cardStatus: _AppConstants.keyGoPaymentCardStatus.EXPIRES_THIS_MONTH
}, _temp2);
exports.default = KeyGoCardExpireModal;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultAccessibilityProfile = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _constants = __webpack_require__(333);

var _text = __webpack_require__(448);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerTitles = _config2.default.get('customerTitles') || [];

var defaultAccessibilityProfile = exports.defaultAccessibilityProfile = {
    title: customerTitles[0] || '',
    firstName: '',
    surname: '',
    phone: '',
    postCode: '',
    line1: '',
    line2: '',
    line3: '',
    town: '',
    country: _config2.default.get('defaultDeliveryCountry'),
    contactMethod: '',
    assistanceLocation: '',
    otherAssistanceLocation: '',
    reasonForAssistance: new _immutable.List(),
    otherAssistanceType: '',
    participateSurvey: null,
    participateImprovementSurvey: null,
    pushNotify: null,
    id: null
};

var AccessibilityProfileForm = function (_record) {
    (0, _inherits3.default)(AccessibilityProfileForm, _record);

    function AccessibilityProfileForm() {
        (0, _classCallCheck3.default)(this, AccessibilityProfileForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    AccessibilityProfileForm.prototype.getSchema = function getSchema() {
        var brand = _config2.default.get('brand');
        var isSouthEastern = brand === 'southeastern';

        return {
            title: _validation2.default.title().required(),
            firstName: _validation2.default.name(2, isSouthEastern ? 24 : 50).required(),
            surname: _validation2.default.name(2, isSouthEastern ? 24 : 50).required(),
            phone: _validation2.default.phone().required(),
            postCode: _validation2.default.required(),
            line1: _validation2.default.required(),
            town: _validation2.default.required(),
            country: _validation2.default.required(),
            contactMethod: _validation2.default.required()
        };
    };

    AccessibilityProfileForm.prototype.normalizeSaveAccessibilityProfile = function normalizeSaveAccessibilityProfile() {
        var formObj = this.toJS();
        return {
            title: formObj.title,
            firstNames: formObj.firstName,
            surname: formObj.surname,
            contactNumber: formObj.phone,
            postCode: formObj.postCode,
            addressLine1: formObj.line1,
            addressLine2: formObj.line2,
            addressLine3: formObj.line3,
            town: formObj.town,
            county: formObj.country,
            contactMethod: formObj.contactMethod,
            assistanceLocation: formObj.assistanceLocation,
            otherAssistanceLocation: formObj.assistanceLocation === _constants.assistanceLocationOther ? this.otherAssistanceLocation : '',
            reasonForAssistance: formObj.reasonForAssistance,
            otherAssistanceType: formObj.reasonForAssistance.includes(_constants.assistanceReasons.OTHER.value) ? this.otherAssistanceType : '',
            participateSurvey: (0, _text.booleanToYesNo)(formObj.participateSurvey).toLowerCase(),
            participateImprovementSurvey: 'no', // ToDo: remove this field when BE will make it optional https://ontrackretail.atlassian.net/browse/CORE-16129
            pushNotify: formObj.pushNotify
        };
    };

    AccessibilityProfileForm.prototype.arePersonalDetailsValid = function arePersonalDetailsValid() {
        var _this2 = this;

        return ['title', 'firstName', 'surname', 'phone', 'postCode', 'line1', 'town', 'country', 'contactMethod'].every(function (fieldName) {
            return _this2.isFieldValid(fieldName);
        });
    };

    AccessibilityProfileForm.prototype.isAssistanceLocationValid = function isAssistanceLocationValid() {
        return Boolean(this.get('assistanceLocation') === _constants.assistanceLocationOther ? this.get('otherAssistanceLocation') : this.get('assistanceLocation'));
    };

    AccessibilityProfileForm.prototype.areReasonsForAssistanceValid = function areReasonsForAssistanceValid() {
        var reasonForAssistance = this.get('reasonForAssistance').toJS();
        return Boolean(reasonForAssistance.includes(_constants.assistanceReasons.OTHER.value) ? this.get('otherAssistanceType') : reasonForAssistance.length);
    };

    AccessibilityProfileForm.prototype.areAccessibilityProfilePreferencesValid = function areAccessibilityProfilePreferencesValid() {
        var _this3 = this;

        return ['participateSurvey', 'pushNotify'].every(function (fieldName) {
            return typeof _this3.get(fieldName) === 'boolean';
        });
    };

    AccessibilityProfileForm.prototype.areBookingPassengerAssistPreferencesValid = function areBookingPassengerAssistPreferencesValid() {
        var _this4 = this;

        return ['participateSurvey', 'participateImprovementSurvey', 'pushNotify'].every(function (fieldName) {
            return typeof _this4.get(fieldName) === 'boolean';
        });
    };

    AccessibilityProfileForm.prototype.isAccessibilityProfileFormValid = function isAccessibilityProfileFormValid() {
        return this.arePersonalDetailsValid() && this.isAssistanceLocationValid() && this.areReasonsForAssistanceValid() && this.areAccessibilityProfilePreferencesValid();
    };

    return AccessibilityProfileForm;
}((0, _immutable.Record)(defaultAccessibilityProfile));

(0, _assign2.default)(AccessibilityProfileForm.prototype, _ValidationMixin2.default);

exports.default = AccessibilityProfileForm;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    activeStep: 0,
    steps: new _immutable.List()
};

var Stepper = function (_record) {
    (0, _inherits3.default)(Stepper, _record);

    function Stepper() {
        (0, _classCallCheck3.default)(this, Stepper);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Stepper.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Stepper, json, {
            activeStep: _LinkMapper.fields.number,
            steps: new _immutable.List(defaults)
        });
    };

    Stepper.prototype.setActiveStep = function setActiveStep(step) {
        return this.set('activeStep', step);
    };

    Stepper.prototype.handleNextStep = function handleNextStep() {
        return this.set('activeStep', this.activeStep + 1);
    };

    Stepper.prototype.handlePrevStep = function handlePrevStep() {
        return this.set('activeStep', this.activeStep - 1);
    };

    return Stepper;
}((0, _immutable.Record)(defaults));

exports.default = Stepper;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(388);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(388);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    email: '',
    confirmEmail: '',
    phone: ''
};

var ContactForm = function (_record) {
    (0, _inherits3.default)(ContactForm, _record);

    function ContactForm() {
        (0, _classCallCheck3.default)(this, ContactForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ContactForm.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new ContactForm(json);
    };

    ContactForm.prototype.getSchema = function getSchema() {
        return {
            email: _validation2.default.email(),
            confirmEmail: _validation2.default.confirmEmail(),
            phone: _validation2.default.phone().allow('')
        };
    };

    ContactForm.prototype.setContactDetails = function setContactDetails(email, phone, confirmEmail) {
        return this.merge({ email: email, phone: phone, confirmEmail: confirmEmail });
    };

    return ContactForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(ContactForm.prototype, _ValidationMixin2.default);

exports.default = ContactForm;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = (_defaults = {}, _defaults[_AppConstants.StationTypes.ORIGIN] = (0, _immutable.List)([]), _defaults[_AppConstants.StationTypes.DESTINATION] = (0, _immutable.List)([]), _defaults[_AppConstants.StationTypes.VIAAVOID] = (0, _immutable.List)([]), _defaults);

var RecentStations = function (_record) {
    (0, _inherits3.default)(RecentStations, _record);

    function RecentStations() {
        (0, _classCallCheck3.default)(this, RecentStations);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    RecentStations.fromJSON = function fromJSON() {
        var _construct;

        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(RecentStations, json, (_construct = {}, _construct[_AppConstants.StationTypes.ORIGIN] = _LinkMapper.resolveAll.as(_Station2.default), _construct[_AppConstants.StationTypes.DESTINATION] = _LinkMapper.resolveAll.as(_Station2.default), _construct[_AppConstants.StationTypes.VIAAVOID] = _LinkMapper.resolveAll.as(_Station2.default), _construct));
    };

    return RecentStations;
}((0, _immutable.Record)(defaults));

exports.default = RecentStations;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var ReservationPassenger = new _immutable.Record({
    statusCode: null,
    attributes: new _immutable.List()
});

ReservationPassenger.fromJSON = function (json) {
    return (0, _LinkMapper.construct)(ReservationPassenger, json, {
        statusCode: _LinkMapper.fields.string,
        attributes: _LinkMapper.fields.list
    });
};

exports.default = ReservationPassenger;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationSeat = new _immutable.Record({
    seat: null,
    attributes: [],
    coach: null
});

(0, _assign2.default)(ReservationSeat.prototype, {
    getAttributes: function getAttributes() {
        return this.attributes.map(function (pref) {
            return _AppConstants.SeatingPrefNames[pref];
        }).filter(Boolean).map(function (i18nKey) {
            return (0, _I18n.translate)(i18nKey);
        }).join(', ');
    }
});

ReservationSeat.fromJSON = function (json) {
    return (0, _LinkMapper.construct)(ReservationSeat, json, {
        seat: _LinkMapper.fields.string,
        attributes: (0, _LinkMapper.resolveAll)(json.attributes).with(String),
        coach: _LinkMapper.fields.string
    });
};

exports.default = ReservationSeat;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _BaseStore2 = __webpack_require__(22);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _selectedStore = new _immutable.Map({
    service: null,
    leg: null
});

var SelectedStore = function (_BaseStore) {
    (0, _inherits3.default)(SelectedStore, _BaseStore);

    function SelectedStore() {
        (0, _classCallCheck3.default)(this, SelectedStore);
        return (0, _possibleConstructorReturn3.default)(this, _BaseStore.apply(this, arguments));
    }

    SelectedStore.prototype.getService = function getService() {
        return _selectedStore.get('service');
    };

    SelectedStore.prototype.getLeg = function getLeg() {
        return _selectedStore.get('leg');
    };

    SelectedStore.prototype.handleServiceSelected = function handleServiceSelected(action) {
        var isSameService = action.service === _selectedStore.get('service');
        var activeService = !isSameService ? action.service : null;

        _selectedStore = _selectedStore.set('service', activeService).set('leg', null);

        this.emitChange();
    };

    SelectedStore.prototype.handleLegSelected = function handleLegSelected(action) {
        var isSameLeg = action.leg === _selectedStore.get('leg');
        var activeLeg = !isSameLeg ? action.leg : null;
        _selectedStore = _selectedStore.set('leg', activeLeg);

        this.emitChange();
    };

    SelectedStore.prototype.handleSearchStarted = function handleSearchStarted() {
        _selectedStore = _selectedStore.set('leg', null).set('service', null);
        this.emitChange();
    };

    SelectedStore.prototype.getActionHandlers = function getActionHandlers() {
        var _ref;

        return _ref = {}, _ref[_AppConstants.ActionTypes.SERVICE_SELECTED] = this.handleServiceSelected, _ref[_AppConstants.ActionTypes.LEG_SELECTED] = this.handleLegSelected, _ref[_AppConstants.ActionTypes.SEARCH_STARTED] = this.handleSearchStarted, _ref;
    };

    return SelectedStore;
}(_BaseStore3.default);

var storeInstance = new SelectedStore();

exports.default = storeInstance;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(1869),
    baseLt = __webpack_require__(1870),
    identity = __webpack_require__(116);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(308);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 1870 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHashHistory = __webpack_require__(573);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _useQueries = __webpack_require__(266);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager = __webpack_require__(578);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _InternalPropTypes = __webpack_require__(223);

var _RouterContext = __webpack_require__(413);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = __webpack_require__(195);

var _RouterUtils = __webpack_require__(895);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isDeprecatedHistory(history) {
  return !history || !history.__v2_compatible__;
}

/* istanbul ignore next: sanity check */
function isUnsupportedHistory(history) {
  // v3 histories expose getCurrentLocation, but aren't currently supported.
  return history && history.getCurrentLocation;
}

var func = _propTypes2.default.func,
    object = _propTypes2.default.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      location: null,
      routes: null,
      params: null,
      components: null
    }, _this.handleError = function (error) {
      if (_this.props.onError) {
        _this.props.onError.call(_this, error);
      } else {
        // Throw errors by default so we don't silently swallow them!
        throw error; // This error probably occurred in getChildRoutes or getComponents.
      }
    }, _this.createRouterObjects = function () {
      var matchContext = _this.props.matchContext;

      if (matchContext) {
        return matchContext;
      }

      var history = _this.props.history;
      var _this$props = _this.props,
          routes = _this$props.routes,
          children = _this$props.children;


      !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;

      if (isDeprecatedHistory(history)) {
        history = _this.wrapDeprecatedHistory(history);
      }

      var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
      var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

      return { history: routingHistory, transitionManager: transitionManager, router: router };
    }, _this.wrapDeprecatedHistory = function (history) {
      var _this$props2 = _this.props,
          parseQueryString = _this$props2.parseQueryString,
          stringifyQuery = _this$props2.stringifyQuery;


      var createHistory = void 0;
      if (history) {
         false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
        createHistory = function createHistory() {
          return history;
        };
      } else {
         false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
        createHistory = _createHashHistory2.default;
      }

      return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        parseQueryString = _props.parseQueryString,
        stringifyQuery = _props.stringifyQuery;

     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;

    var _createRouterObjects = this.createRouterObjects(),
        history = _createRouterObjects.history,
        transitionManager = _createRouterObjects.transitionManager,
        router = _createRouterObjects.router;

    this._unlisten = transitionManager.listen(function (error, state) {
      if (error) {
        _this2.handleError(error);
      } else {
        _this2.setState(state, _this2.props.onUpdate);
      }
    });

    this.history = history;
    this.router = router;
  };

  /* istanbul ignore next: sanity check */
  Router.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  };

  Router.prototype.render = function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      history: this.history,
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  };

  return Router;
}(_react2.default.Component);

Router.propTypes = {
  history: object,
  children: _InternalPropTypes.routes,
  routes: _InternalPropTypes.routes, // alias for children
  render: func,
  createElement: func,
  onError: func,
  onUpdate: func,

  // Deprecated:
  parseQueryString: func,
  stringifyQuery: func,

  // PRIVATE: For client-side rehydration of server match.
  matchContext: object
};
Router.defaultProps = {
  render: function render(props) {
    return _react2.default.createElement(_RouterContext2.default, props);
  }
};
exports.default = Router;
module.exports = exports['default'];

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(884);
var isArguments = __webpack_require__(1874);
var is = __webpack_require__(1878);
var isRegex = __webpack_require__(1880);
var flags = __webpack_require__(1881);
var isDate = __webpack_require__(1883);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(885); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(574)();
var callBound = __webpack_require__(887);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(886);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(575);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(327);
var callBind = __webpack_require__(576);

var implementation = __webpack_require__(889);
var getPolyfill = __webpack_require__(890);
var shim = __webpack_require__(1879);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(890);
var define = __webpack_require__(327);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(887);
var hasToStringTag = __webpack_require__(574)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(327);
var callBind = __webpack_require__(576);

var implementation = __webpack_require__(891);
var getPolyfill = __webpack_require__(892);
var shim = __webpack_require__(1882);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(327).supportsDescriptors;
var getPolyfill = __webpack_require__(892);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(574)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var _slice = Array.prototype.slice;
exports.loopAsync = loopAsync;

function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = undefined;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(_slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1886);

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		key = decodeURIComponent(key);

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
};

exports.stringify = function (obj) {
	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return key;
		}

		if (Array.isArray(val)) {
			return val.slice().sort().map(function (val2) {
				return strictUriEncode(key) + '=' + strictUriEncode(val2);
			}).join('&');
		}

		return strictUriEncode(key) + '=' + strictUriEncode(val);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(265);

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = __webpack_require__(579);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTransitionHook(hook, route, asyncArity) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (hook.length < asyncArity) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));

    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location, deprecatedPathname, deprecatedQuery) {
    if (deprecatedPathname) {
       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
      redirectInfo = {
        pathname: deprecatedPathname,
        query: deprecatedQuery,
        state: location
      };

      return;
    }

    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](nextState, replace, next);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    hooks[index](state, nextState, replace, next);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = __webpack_require__(265);

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(579);

var _makeStateWithLocation = __webpack_require__(894);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (!getComponent) {
    callback();
    return;
  }

  var location = nextState.location;

  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);

  getComponent.call(route, nextStateWithLocation, callback);
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = matchRoutes;

var _AsyncUtils = __webpack_require__(579);

var _makeStateWithLocation = __webpack_require__(894);

var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);

var _PatternUtils = __webpack_require__(265);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);

    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });
  } else if (route.childRoutes) {
    var pathless = route.childRoutes.filter(function (childRoute) {
      return !childRoute.path;
    });

    (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
      getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
        if (error || indexRoute) {
          var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
          done(error, routes);
        } else {
          next();
        }
      });
    }, function (err, routes) {
      callback(null, routes);
    });
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(265);

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(572);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = function (_React$Component) {
  _inherits(IndexLink, _React$Component);

  function IndexLink() {
    _classCallCheck(this, IndexLink);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  IndexLink.prototype.render = function render() {
    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
  };

  return IndexLink;
}(_react2.default.Component);

exports.default = IndexLink;
module.exports = exports['default'];

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _Redirect = __webpack_require__(896);

var _Redirect2 = _interopRequireDefault(_Redirect);

var _InternalPropTypes = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var string = _propTypes2.default.string,
    object = _propTypes2.default.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */

var IndexRedirect = function (_React$Component) {
  _inherits(IndexRedirect, _React$Component);

  function IndexRedirect() {
    _classCallCheck(this, IndexRedirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  IndexRedirect.createRouteFromReactElement = function createRouteFromReactElement(element, parentRoute) {
    /* istanbul ignore else: sanity check */
    if (parentRoute) {
      parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
    } else {
       false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
    }
  };

  /* istanbul ignore next: sanity check */
  IndexRedirect.prototype.render = function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  };

  return IndexRedirect;
}(_react2.default.Component);

IndexRedirect.propTypes = {
  to: string.isRequired,
  query: object,
  state: object,
  onEnter: _InternalPropTypes.falsy,
  children: _InternalPropTypes.falsy
};
exports.default = IndexRedirect;
module.exports = exports['default'];

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(195);

var _InternalPropTypes = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var func = _propTypes2.default.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */

var IndexRoute = function (_React$Component) {
  _inherits(IndexRoute, _React$Component);

  function IndexRoute() {
    _classCallCheck(this, IndexRoute);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  IndexRoute.createRouteFromReactElement = function createRouteFromReactElement(element, parentRoute) {
    /* istanbul ignore else: sanity check */
    if (parentRoute) {
      parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
    } else {
       false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
    }
  };

  /* istanbul ignore next: sanity check */
  IndexRoute.prototype.render = function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  };

  return IndexRoute;
}(_react2.default.Component);

IndexRoute.propTypes = {
  path: _InternalPropTypes.falsy,
  component: _InternalPropTypes.component,
  components: _InternalPropTypes.components,
  getComponent: func,
  getComponents: func
};
exports.default = IndexRoute;
module.exports = exports['default'];

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(195);

var _InternalPropTypes = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var string = _propTypes2.default.string,
    func = _propTypes2.default.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    _classCallCheck(this, Route);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  /* istanbul ignore next: sanity check */
  Route.prototype.render = function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  };

  return Route;
}(_react2.default.Component);

Route.createRouteFromReactElement = _RouteUtils.createRouteFromReactElement;
Route.propTypes = {
  path: string,
  component: _InternalPropTypes.component,
  components: _InternalPropTypes.components,
  getComponent: func,
  getComponents: func
};
exports.default = Route;
module.exports = exports['default'];

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _InternalPropTypes = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A mixin that adds the "history" instance variable to components.
 */
var History = {

  contextTypes: {
    history: _InternalPropTypes.history
  },

  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
    this.history = this.context.history;
  }
};

exports.default = History;
module.exports = exports['default'];

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _propTypes2.default.object;

/**
 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
 * component that may be used to cancel a transition or prompt the user
 * for confirmation.
 *
 * On standard transitions, routerWillLeave receives a single argument: the
 * location we're transitioning to. To cancel the transition, return false.
 * To prompt the user for confirmation, return a prompt message (string).
 *
 * During the beforeunload event (assuming you're using the useBeforeUnload
 * history enhancer), routerWillLeave does not receive a location object
 * because it isn't possible for us to know the location we're transitioning
 * to. In this case routerWillLeave must return a prompt message to prevent
 * the user from closing the window/tab.
 */

var Lifecycle = {

  contextTypes: {
    history: object.isRequired,
    // Nested children receive the route as context, either
    // set by the route component using the RouteContext mixin
    // or by some other ancestor.
    route: object
  },

  propTypes: {
    // Route components receive the route object as a prop.
    route: object
  },

  componentDidMount: function componentDidMount() {
     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;

    var route = this.props.route || this.context.route;

    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;

    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
  }
};

exports.default = Lifecycle;
module.exports = exports['default'];

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _propTypes2.default.object;

/**
 * The RouteContext mixin provides a convenient way for route
 * components to set the route in context. This is needed for
 * routes that render elements that want to use the Lifecycle
 * mixin to prevent transitions.
 */

var RouteContext = {

  propTypes: {
    route: object.isRequired
  },

  childContextTypes: {
    route: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      route: this.props.route
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
  }
};

exports.default = RouteContext;
module.exports = exports['default'];

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _useQueries = __webpack_require__(266);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _createTransitionManager = __webpack_require__(578);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know about routing.
 *
 * Enhances history objects with the following methods:
 *
 * - listen((error, nextState) => {})
 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
 * - match(location, (error, redirectLocation, nextState) => {})
 * - isActive(pathname, query, indexOnly=false)
 */
function useRoutes(createHistory) {
   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;

  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var routes = _ref.routes,
        options = _objectWithoutProperties(_ref, ['routes']);

    var history = (0, _useQueries2.default)(createHistory)(options);
    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
    return _extends({}, history, transitionManager);
  };
}

exports.default = useRoutes;
module.exports = exports['default'];

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(413);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoutingContext = function (_React$Component) {
  _inherits(RoutingContext, _React$Component);

  function RoutingContext() {
    _classCallCheck(this, RoutingContext);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RoutingContext.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
  };

  RoutingContext.prototype.render = function render() {
    return _react2.default.createElement(_RouterContext2.default, this.props);
  };

  return RoutingContext;
}(_react2.default.Component);

exports.default = RoutingContext;
module.exports = exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Actions = __webpack_require__(224);

var _invariant = __webpack_require__(72);

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = __webpack_require__(897);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = __webpack_require__(578);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = __webpack_require__(195);

var _RouterUtils = __webpack_require__(895);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  var unlisten = void 0;

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    // Pick up the location from the history via synchronous history.listen
    // call if needed.
    unlisten = history.listen(function (historyLocation) {
      location = historyLocation;
    });
  }

  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
      history: history,
      router: router,
      matchContext: { history: history, transitionManager: transitionManager, router: router }
    }));

    // Defer removing the listener to here to prevent DOM histories from having
    // to unwind DOM event listeners unnecessarily, in case callback renders a
    // <Router> and attaches another history listener.
    if (unlisten) {
      unlisten();
    }
  });
}

exports.default = match;
module.exports = exports['default'];

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(413);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(83);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
};

module.exports = exports['default'];

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createBrowserHistory = __webpack_require__(899);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = __webpack_require__(900);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHashHistory = __webpack_require__(573);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _createRouterHistory = __webpack_require__(900);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deprecate = __webpack_require__(226);

var _deprecate2 = _interopRequireDefault(_deprecate);

var _createLocation2 = __webpack_require__(893);

var _createLocation3 = _interopRequireDefault(_createLocation2);

var _createBrowserHistory = __webpack_require__(899);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

exports.createHistory = _createBrowserHistory2['default'];

var _createHashHistory2 = __webpack_require__(573);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

exports.createHashHistory = _createHashHistory3['default'];

var _createMemoryHistory2 = __webpack_require__(898);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

exports.createMemoryHistory = _createMemoryHistory3['default'];

var _useBasename2 = __webpack_require__(580);

var _useBasename3 = _interopRequireDefault(_useBasename2);

exports.useBasename = _useBasename3['default'];

var _useBeforeUnload2 = __webpack_require__(901);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

exports.useBeforeUnload = _useBeforeUnload3['default'];

var _useQueries2 = __webpack_require__(266);

var _useQueries3 = _interopRequireDefault(_useQueries2);

exports.useQueries = _useQueries3['default'];

var _Actions2 = __webpack_require__(224);

var _Actions3 = _interopRequireDefault(_Actions2);

exports.Actions = _Actions3['default'];

// deprecated

var _enableBeforeUnload2 = __webpack_require__(1907);

var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);

exports.enableBeforeUnload = _enableBeforeUnload3['default'];

var _enableQueries2 = __webpack_require__(1908);

var _enableQueries3 = _interopRequireDefault(_enableQueries2);

exports.enableQueries = _enableQueries3['default'];
var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
exports.createLocation = createLocation;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deprecate = __webpack_require__(226);

var _deprecate2 = _interopRequireDefault(_deprecate);

var _useBeforeUnload = __webpack_require__(901);

var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);

exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
module.exports = exports['default'];

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _deprecate = __webpack_require__(226);

var _deprecate2 = _interopRequireDefault(_deprecate);

var _useQueries = __webpack_require__(266);

var _useQueries2 = _interopRequireDefault(_useQueries);

exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
module.exports = exports['default'];

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEqual2 = __webpack_require__(170);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _dec, _class, _class2, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(85);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _useRouter = __webpack_require__(338);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

var _WidgetAuthStore = __webpack_require__(880);

var _WidgetAuthStore2 = _interopRequireDefault(_WidgetAuthStore);

var _LayoutStore = __webpack_require__(832);

var _LayoutStore2 = _interopRequireDefault(_LayoutStore);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _AppActions = __webpack_require__(390);

var _AppActions2 = _interopRequireDefault(_AppActions);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _RailcardsStore = __webpack_require__(608);

var _RailcardsStore2 = _interopRequireDefault(_RailcardsStore);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _WindowActions = __webpack_require__(1923);

var _WindowActions2 = _interopRequireDefault(_WindowActions);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _tabSwitch = __webpack_require__(1924);

var _tabSwitch2 = _interopRequireDefault(_tabSwitch);

var _BetaBanner = __webpack_require__(1925);

var _BetaBanner2 = _interopRequireDefault(_BetaBanner);

var _MessageBanner = __webpack_require__(1926);

var _MessageBanner2 = _interopRequireDefault(_MessageBanner);

var _MicrositeBanner = __webpack_require__(1928);

var _MicrositeBanner2 = _interopRequireDefault(_MicrositeBanner);

var _SkipToContentLink = __webpack_require__(1929);

var _SkipToContentLink2 = _interopRequireDefault(_SkipToContentLink);

var _Header = __webpack_require__(1930);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(1974);

var _Footer2 = _interopRequireDefault(_Footer);

var _FooterPoweredBy = __webpack_require__(1977);

var _FooterPoweredBy2 = _interopRequireDefault(_FooterPoweredBy);

var _GlobalModals = __webpack_require__(1978);

var _GlobalModals2 = _interopRequireDefault(_GlobalModals);

var _Page = __webpack_require__(424);

var _Page2 = _interopRequireDefault(_Page);

var _LoadingLine = __webpack_require__(2160);

var _LoadingLine2 = _interopRequireDefault(_LoadingLine);

var _Notifications = __webpack_require__(2161);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _ModalManager = __webpack_require__(874);

var _ModalCounter = __webpack_require__(875);

var _Webchat = __webpack_require__(2162);

var _Webchat2 = _interopRequireDefault(_Webchat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _stateFromStores() {
    return {
        accountRailcardsLoaded: _RailcardsStore2.default.getAccountRailcardsLoaded(),
        isInApp: _InAppStore2.default.isInApp(),
        isWidgetAuth: _WidgetAuthStore2.default.isWidgetAuth(),
        isEmbeddedLayout: _LayoutStore2.default.isEmbeddedLayout(),
        user: _UserStore2.default.getCurrent(),
        order: _OrderStore2.default.getCurrent(),
        warnAutoLogout: _UserStore2.default.shouldAutoLogoutWarn(),
        shouldAutoLogout: _UserStore2.default.shouldAutoLogout(),
        enableInAppTokenRefreshOnPageLoad: _FeatureFlagStore2.default.get('enableInAppTokenRefreshOnPageLoad'),
        externalRegistrationLink: _FeatureFlagStore2.default.get('externalRegistrationLink'),
        hasFooterPoweredByOn: _FeatureFlagStore2.default.get('hasFooterPoweredByOn')
    };
}

var App = (_dec = (0, _connectToStores2.default)([_UserStore2.default, _InAppStore2.default, _WidgetAuthStore2.default, _OrderStore2.default, _RailcardsStore2.default, _LayoutStore2.default], _stateFromStores), (0, _withRouter2.default)(_class = _dec(_class = (_temp2 = _class2 = function (_React$Component) {
    (0, _inherits3.default)(App, _React$Component);

    function App() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            modalCount: 0
        }, _this.handleVisibilityChange = function () {
            if (!document[(0, _tabSwitch2.default)().hiddenTab] && !_this.props.user.isLoggedIn()) {
                _CustomerActions2.default.checkUserCookie();
            }
        }, _this._checkUserActivity = function (_ref) {
            var user = _ref.user,
                warnAutoLogout = _ref.warnAutoLogout,
                shouldAutoLogout = _ref.shouldAutoLogout;
            var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;

            if (shouldAutoLogout && !prevProps.shouldAutoLogout) {
                _CustomerActions2.default.logout(user).then(function () {
                    if (_AppConstants.SkipAutoLogoutRedirectRoutes.includes(_urls2.default.resolve(_this.props.location.pathname).name)) {
                        return null;
                    }
                    return _this.props.router.push(_urls2.default.location(_AppConstants.PointStages.SEARCH));
                }).then(function () {
                    _ModalActions2.default.open(_AppConstants.GlobalModals.LOGGED_OUT, {
                        onClose: function onClose() {
                            return _ModalActions2.default.close(_AppConstants.GlobalModals.LOGGED_OUT);
                        }
                    });
                });
            } else if (warnAutoLogout && !prevProps.warnAutoLogout) {
                _ModalActions2.default.open(_AppConstants.GlobalModals.LOGOUT_WARNING, {
                    onClose: function onClose() {
                        return _ModalActions2.default.close(_AppConstants.GlobalModals.LOGOUT_WARNING);
                    }
                });
            }
        }, _this._checkExpiredOrder = function () {
            _OrderActions2.default.checkBasket();
            setTimeout(function () {
                return _this._checkExpiredOrder();
            }, 60 * 1000);
        }, _this._handleModalCount = function (modalCount) {
            _this.setState({ modalCount: modalCount });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    App.prototype.getChildContext = function getChildContext() {
        return {
            routes: this.props.routes
        };
    };

    App.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        var oldLocation = this.props.location;
        var newLocation = nextProps.location;


        if (!(0, _isEqual3.default)(oldLocation, newLocation)) {
            _AppActions2.default.routeChanged(newLocation);
        }

        this._checkUserActivity(nextProps);
    };

    App.prototype.componentDidMount = function componentDidMount() {
        if (this.props.externalRegistrationLink) {
            document.addEventListener((0, _tabSwitch2.default)().visibilityChange, this.handleVisibilityChange, false);
        }
    };

    App.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var _props = this.props,
            location = _props.location,
            user = _props.user,
            isInApp = _props.isInApp,
            isWidgetAuth = _props.isWidgetAuth,
            enableInAppTokenRefreshOnPageLoad = _props.enableInAppTokenRefreshOnPageLoad;


        _WindowActions2.default.startListeners();

        _AppActions2.default.routeChanged(location);

        if (location.query && location.query.modal) {
            _ModalActions2.default.open(location.query.modal.toUpperCase(), location.query);
        }

        if (isInApp) {
            var disableAppTracking = _FeatureFlagStore2.default.get('disableAppTracking');

            var isTravelCompanionApp = [_AppConstants.NATIVE_BOOKING_FLOW_APP_CHANNEL, _AppConstants.WEBVIEW_BOOKING_FLOW_APP_CHANNEL, _AppConstants.GATWICK_APP_CHANNEL, _AppConstants.GREATNORTHERN_APP_CHANNEL, _AppConstants.SOUTHERN_APP_CHANNEL, _AppConstants.THAMESLINK_APP_CHANNEL].includes(_InAppStore2.default.getChannel());

            if (disableAppTracking && isTravelCompanionApp) {
                /*
                    For Travel Companion app only for now
                     Hide cookie consent pop-up
                    and disable all tracking within the app webviews
                */
                _AppActions2.default.disableTracking();
                document.cookie = "CookieConsent={stamp:%27Tke7RiU7rNx4t6IZP0T16n53jSFhdBKFHjPI3h0yITls09pHpOQwig==%27%2Cnecessary:true%2Cpreferences:false%2Cstatistics:false%2Cmarketing:false%2Cver:4%2Cutc:1664468272652%2Cregion:%27gb%27}";
            }

            document.body.classList.add('inapp');
            if (user.accessToken) {
                _CustomerActions2.default.refresh(user, enableInAppTokenRefreshOnPageLoad);
            }
        } else if (isWidgetAuth) {
            document.body.classList.add('widget-auth');
        } else if (user.isLoggedIn() && !user.get('customer').get('id')) {
            _CustomerActions2.default.fetchUser(user.authToken);
        }

        if (!isInApp) {
            document.addEventListener('click', _AppActions2.default.activityDetected);
            document.addEventListener('keypress', _AppActions2.default.activityDetected);
            document.addEventListener('mousemove', _AppActions2.default.activityDetected);
            document.addEventListener('touchstart', _AppActions2.default.activityDetected);

            this._checkUserActivity(this.props, {});
        }

        this._checkExpiredOrder();
    };

    App.prototype.componentWillUnmount = function componentWillUnmount() {
        _WindowActions2.default.stopListeners();

        if (this.props.externalRegistrationLink) {
            document.removeEventListener((0, _tabSwitch2.default)().visibilityChange, this.handleVisibilityChange);
        }

        if (!this.props.isInApp) {
            document.removeEventListener('click', _AppActions2.default.activityDetected);
            document.removeEventListener('keypress', _AppActions2.default.activityDetected);
            document.removeEventListener('mousemove', _AppActions2.default.activityDetected);
            document.removeEventListener('touchstart', _AppActions2.default.activityDetected);

            clearInterval(this.interval);
        }
    };

    App.prototype._getCurrentRoute = function _getCurrentRoute() {
        return _urls2.default.resolve(this.props.location.pathname);
    };

    App.prototype.render = function render() {
        var _props2 = this.props,
            hasFooterPoweredByOn = _props2.hasFooterPoweredByOn,
            isEmbeddedLayout = _props2.isEmbeddedLayout,
            children = _props2.children,
            restProps = (0, _objectWithoutProperties3.default)(_props2, ['hasFooterPoweredByOn', 'isEmbeddedLayout', 'children']);

        var classes = (0, _classnames2.default)('content container-fluid', {
            'inapp': isEmbeddedLayout,
            'container-self-smartcard': children.props && children.props.route.name === _AppConstants.SmartcardPages.SELF_REGISTERED
        });

        var canAutoRefocus = !this.props.routes.some(function (route) {
            return route.shouldRefocusRouteContent && !route.shouldRefocusRouteContent();
        });
        var hasModals = Boolean(this.state.modalCount);

        var shouldHideHeaderLogin = children.props.route.name === _AppConstants.PromotionPages.TOC_FAMILY || children.props.route.name === _AppConstants.PromotionPages.TOC_FAMILY_VERIFY;

        return _react2.default.createElement(
            _useRouter.RouterProvider,
            { router: this.props.router, location: this.props.location },
            _react2.default.createElement(
                _ModalManager.ModalManagerProvider,
                null,
                _react2.default.createElement(
                    _ModalCounter.ModalCounterProvider,
                    { onChange: this._handleModalCount },
                    _react2.default.createElement(
                        _Page2.default,
                        { name: '' + this._getCurrentRoute().name },
                        _react2.default.createElement(
                            'div',
                            {
                                className: (0, _classnames2.default)('brand-' + _config2.default.get('brand'), { 'has-modals': hasModals }),
                                'aria-hidden': hasModals ? 'true' : null
                            },
                            _react2.default.createElement(_GlobalModals2.default, null),
                            !isEmbeddedLayout && _react2.default.createElement(
                                _FeatureFlag2.default,
                                { name: 'enableBetaBanner', expires: 'disableBetaBannerDate' },
                                _react2.default.createElement(_BetaBanner2.default, null)
                            ),
                            !isEmbeddedLayout && _react2.default.createElement(_MessageBanner2.default, null),
                            _react2.default.createElement(
                                _FeatureFlag2.default,
                                { name: 'enableMicrositeBanner' },
                                _react2.default.createElement(_MicrositeBanner2.default, null)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'fixed-container' },
                                !isEmbeddedLayout && _react2.default.createElement(
                                    _react.Fragment,
                                    null,
                                    _react2.default.createElement(_SkipToContentLink2.default, null),
                                    _react2.default.createElement(_Header2.default, {
                                        user: this.props.user,
                                        order: this.props.order,
                                        disableNav: children.props.route.name === _AppConstants.SmartcardPages.SELF_REGISTERED,
                                        disableLogin: shouldHideHeaderLogin
                                    })
                                ),
                                _react2.default.createElement(
                                    'section',
                                    {
                                        id: 'route__content',
                                        className: classes,
                                        role: 'main',
                                        tabIndex: canAutoRefocus ? -1 : undefined
                                    },
                                    _react2.default.cloneElement(children, restProps)
                                ),
                                !isEmbeddedLayout && _react2.default.createElement(_Footer2.default, { hasFooterPoweredByOn: hasFooterPoweredByOn }),
                                hasFooterPoweredByOn && _react2.default.createElement(_FooterPoweredBy2.default, null)
                            ),
                            _react2.default.createElement(_LoadingLine2.default, null),
                            _react2.default.createElement(_Notifications2.default, null),
                            _react2.default.createElement(_Webchat2.default, null)
                        )
                    )
                )
            )
        );
    };

    return App;
}(_react2.default.Component), _class2.propTypes = {
    router: _PropTypes.routerShape,
    routes: _propTypes2.default.any.isRequired,
    location: _PropTypes.locationShape,
    children: _propTypes2.default.any.isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    isInApp: _propTypes2.default.bool,
    isWidgetAuth: _propTypes2.default.bool,
    isEmbeddedLayout: _propTypes2.default.bool,
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    externalRegistrationLink: _propTypes2.default.bool,
    hasFooterPoweredByOn: _propTypes2.default.bool,
    enableInAppTokenRefreshOnPageLoad: _propTypes2.default.bool
}, _class2.childContextTypes = {
    routes: _propTypes2.default.any
}, _class2.defaultProps = {
    hasFooterPoweredByOn: false
}, _temp2)) || _class) || _class);
exports.default = App;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.19
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.19',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga)\/((\d+)?[\w\.]+)/i                              // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)\s/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [
            /(mz)-([\w-]{2,})/i                                                 // Meizu Phone
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(1911)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 1911 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _LinkMapper = __webpack_require__(8);

var _CallingPoints = __webpack_require__(616);

var _CallingPoints2 = _interopRequireDefault(_CallingPoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CallingPointsService = {
    get: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _APIClient2.default.get(id);

                        case 2:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_CallingPoints2.default));

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function get(_x) {
            return _ref.apply(this, arguments);
        }

        return get;
    }()
};

exports.default = CallingPointsService;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    id: null,
    orderId: null,
    customerId: null,
    brand: null,
    status: null,
    fromOrigin: new _Station2.default(),
    fromDestination: new _Station2.default(),
    toOrigin: new _Station2.default(),
    toDestination: new _Station2.default(),
    fromRouteCode: null,
    toRouteCode: null,
    oldPrice: null,
    newPrice: null,
    credit: null,
    amountDue: null,
    difference: null,
    daysRemaining: null,
    created: null
};

var Changeover = function (_record) {
    (0, _inherits3.default)(Changeover, _record);

    function Changeover() {
        (0, _classCallCheck3.default)(this, Changeover);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    Changeover.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(Changeover, json, {
            id: _LinkMapper.fields.number,
            orderId: _LinkMapper.fields.number,
            customerId: _LinkMapper.fields.number,
            brand: _LinkMapper.fields.string,
            status: _LinkMapper.fields.string,
            fromOrigin: _LinkMapper.resolve.as(_Station2.default),
            fromDestination: _LinkMapper.resolve.as(_Station2.default),
            toOrigin: _LinkMapper.resolve.as(_Station2.default),
            toDestination: _LinkMapper.resolve.as(_Station2.default),
            fromRouteCode: _LinkMapper.fields.string,
            toRouteCode: _LinkMapper.fields.string,
            oldPrice: _LinkMapper.fields.number,
            newPrice: _LinkMapper.fields.number,
            credit: _LinkMapper.fields.number,
            amountDue: _LinkMapper.fields.number,
            difference: _LinkMapper.fields.number,
            daysRemaining: _LinkMapper.fields.number,
            created: _LinkMapper.fields.datetime
        });
    };

    return Changeover;
}((0, _immutable.Record)(defaults));

exports.default = Changeover;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.checkOrderExpiry = checkOrderExpiry;
exports.handleOrderErrors = handleOrderErrors;
exports.setOrderDataCookie = setOrderDataCookie;
exports.deleteMatchingPassengerAssistRequests = deleteMatchingPassengerAssistRequests;

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _OrderService = __webpack_require__(346);

var _OrderService2 = _interopRequireDefault(_OrderService);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _Order = __webpack_require__(625);

var _Customer = __webpack_require__(808);

var _orderUtils = __webpack_require__(1915);

var _PassengerAssistActions = __webpack_require__(334);

var _PassengerAssistActions2 = _interopRequireDefault(_PassengerAssistActions);

var _PassengerAssistStore = __webpack_require__(173);

var _PassengerAssistStore2 = _interopRequireDefault(_PassengerAssistStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkOrderExpiry(target, name, descriptor) {
    var original = descriptor.value;
    descriptor.value = function () {
        var currentOrder = _OrderStore2.default.getCurrent();
        if (currentOrder && currentOrder.hasExpired()) {

            if (currentOrder.hasRecentlyExpired()) {
                _OrderService2.default.delete(currentOrder).catch(function (e) {
                    console.warn('delete expired order', e);
                });

                return _ModalActions2.default.open(_AppConstants.GlobalModals.BASKET_EXPIRED, {
                    order: currentOrder,
                    onClose: function onClose() {
                        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.ORDER_EXPIRED });
                        _ModalActions2.default.close(_AppConstants.GlobalModals.BASKET_EXPIRED);
                    }
                });
            }

            (0, _orderUtils.updateOrderCookie)({});
            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.ORDER_EXPIRED });
        }
        return original.apply(this, arguments);
    };
    descriptor.value.__DECORATORS = ['checkOrderExpiry'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

function handleOrderError(error) {
    switch (true) {
        case error instanceof _Order.TooManyTicketsError:
            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, {
                message: 'basket.error.tripsLimit',
                customButton: {
                    text: 'ariaLabel.openBasket',
                    onClick: _ModalActions2.default.open.bind(null, _AppConstants.GlobalModals.BASKET)
                }
            });
            return false;
        case error instanceof _Order.InvalidOrderStateError:
            _ModalActions2.default.open(_AppConstants.GlobalModals.ORDER_STATE_ERROR);
            return false;
        case error instanceof _Order.NotEnoughAvailabilityError:
            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, {
                message: 'basket.error.noAvailability'
            });
            return false;
        case error instanceof _Order.InteropError:
            _ModalActions2.default.open(_AppConstants.GlobalModals.INTEROP_ERROR);
            return false;
        default:
            return (0, _Customer.handleUnauthorisedError)(error);
    }
}

function handleOrderErrors(target, name, descriptor) {
    var original = descriptor.value;
    descriptor.value = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var result,
            _args = arguments;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return original.apply(this, _args);

                    case 3:
                        result = _context.sent;
                        return _context.abrupt('return', result);

                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context['catch'](0);
                        return _context.abrupt('return', handleOrderError(_context.t0));

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[0, 7]]);
    }));
    descriptor.value.__DECORATORS = ['handleOrderErrors'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

function setOrderDataCookie(target, name, descriptor) {
    var original = descriptor.value;
    descriptor.value = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var result,
            _args2 = arguments;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return original.apply(this, _args2);

                    case 2:
                        result = _context2.sent;
                        // call the original logic first and then execute this descriptor logic.
                        (0, _orderUtils.updateOrderCookie)();
                        return _context2.abrupt('return', result);

                    case 5:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));
    descriptor.value.__DECORATORS = ['setOrderDataCookie'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

function deleteMatchingPassengerAssistRequests(target, name, descriptor) {
    var original = descriptor.value;
    descriptor.value = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var orderTrip, outwardJourney, returnJourney, passengerAssistRequests, matchingRequest, _ref4, outwardEnabled, returnEnabled, hasMatchingPAJourney;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        orderTrip = args[1];
                        outwardJourney = orderTrip.getOutwardJourney();
                        returnJourney = orderTrip.getReturnJourney();

                        // Find and delete any matching Passenger Assist requests

                        passengerAssistRequests = _PassengerAssistStore2.default.getPendingPassengerAssistRequests();


                        if (passengerAssistRequests) {
                            matchingRequest = passengerAssistRequests.find(function (req) {
                                return req.orderTripId === orderTrip.id;
                            });
                            _ref4 = matchingRequest || {}, outwardEnabled = _ref4.outwardEnabled, returnEnabled = _ref4.returnEnabled;
                            hasMatchingPAJourney = false;


                            if (outwardJourney) {
                                hasMatchingPAJourney = outwardEnabled;
                            } else if (returnJourney) {
                                hasMatchingPAJourney = returnEnabled;
                            }

                            if (hasMatchingPAJourney) {
                                _PassengerAssistActions2.default.deleteTravelAssist(matchingRequest);
                            }
                        }

                        return _context3.abrupt('return', original.apply(this, args));

                    case 6:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));
    descriptor.value.__DECORATORS = ['deleteMatchingPassengerAssistRequests'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.updateOrderCookie = undefined;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _union2 = __webpack_require__(902);

var _union3 = _interopRequireDefault(_union2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _TokenStore = __webpack_require__(281);

var _TokenStore2 = _interopRequireDefault(_TokenStore);

var _Cookie = __webpack_require__(258);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOrderCookieJourneys = function getOrderCookieJourneys(currentOrder) {
    return currentOrder.trips.reduce(function (acc, orderTrip) {
        var fares = orderTrip.getJourneyFares();

        fares.forEach(function (fare) {
            var journey = {
                id: orderTrip.id,
                isReturn: orderTrip.isReturn(),
                ticketType: fare.ticketType.name,
                adults: fare.adults(),
                children: fare.children(),
                railcards: fare.getRailcards().map(function (r) {
                    return r.name;
                }).toJS(),
                restrictions: fare.getDescription(),
                price: fare.getTotalPrice(),
                origin: (0, _get3.default)(fare, 'origin.name') || (0, _get3.default)(fare, 'outwardJourney.getOrigin().name'),
                destination: (0, _get3.default)(fare, 'destination.name') || (0, _get3.default)(fare, 'outwardJourney.getDestination().name')
            };

            var returnJourney = orderTrip.isReturn() && acc.find(function (_ref) {
                var id = _ref.id;
                return id === orderTrip.id;
            });
            if (returnJourney) {
                acc = acc.map(function (outboundJourney) {
                    return outboundJourney.id === orderTrip.id ? (0, _extends3.default)({}, outboundJourney, {
                        originReturn: journey.origin,
                        destinationReturn: journey.destination,
                        ticketTypeReturn: journey.ticketType,
                        restrictionsReturn: journey.restrictions,
                        price: journey.price + outboundJourney.price,
                        railcards: (0, _union3.default)(outboundJourney.railcards, journey.railcards)
                    }) : outboundJourney;
                });
            } else {
                acc = [].concat(acc, [journey]);
            }
        });
        return acc;
    }, []);
};

var prepareOrderCookie = function prepareOrderCookie(currentOrder) {
    return {
        id: currentOrder.id,
        totalPrice: currentOrder.totalPrice,
        journeysAmount: currentOrder.trips.size,
        journeys: getOrderCookieJourneys(currentOrder)
    };
};

var updateOrderCookie = exports.updateOrderCookie = function updateOrderCookie(order) {
    if (_FeatureFlagStore2.default.get('enableBasketWidget')) {
        var currentOrder = _OrderStore2.default.getCurrent();

        var orderData = {
            device: _TokenStore2.default.getDevice(),
            order: order || prepareOrderCookie(currentOrder)
        };

        var orderDataJSON = (0, _stringify2.default)(orderData);
        var encodedOrderData = btoa(orderDataJSON);

        _Cookie2.default.set(_AppConstants.CookieKeys.ORDER, encodedOrderData, {}, false);
    }
};

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _PassengerAssistStore = __webpack_require__(173);

var _PassengerAssistStore2 = _interopRequireDefault(_PassengerAssistStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengerAssist = {
    getAccessibilityProfile: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = '/travel-assist/customer/' + user.id + '/accessibility-profile';
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            return _context.abrupt('return', _context.sent);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function getAccessibilityProfile() {
            return _ref.apply(this, arguments);
        }

        return getAccessibilityProfile;
    }(),
    createAccessibilityProfile: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(payload) {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = '/travel-assist/customer/' + user.id + '/accessibility-profile';
                            _context2.next = 4;
                            return _AuthenticatedAPIClient2.default.post(endpoint, payload);

                        case 4:
                            return _context2.abrupt('return', _context2.sent);

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function createAccessibilityProfile(_x) {
            return _ref2.apply(this, arguments);
        }

        return createAccessibilityProfile;
    }(),
    deleteAccessibilityProfile: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var user, accessibilityProfileId, endpoint;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            accessibilityProfileId = _PassengerAssistStore2.default.getAccessibilityProfileId();
                            endpoint = '/travel-assist/customer/' + user.id + '/accessibility-profile/' + accessibilityProfileId;
                            _context3.next = 5;
                            return _AuthenticatedAPIClient2.default.delete(endpoint);

                        case 5:
                            return _context3.abrupt('return', _context3.sent);

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function deleteAccessibilityProfile() {
            return _ref3.apply(this, arguments);
        }

        return deleteAccessibilityProfile;
    }(),
    updateAccessibilityProfile: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(payload) {
            var user, accessibilityProfileId, endpoint;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            accessibilityProfileId = _PassengerAssistStore2.default.getAccessibilityProfileId();
                            endpoint = '/travel-assist/customer/' + user.id + '/accessibility-profile/' + accessibilityProfileId;
                            _context4.next = 5;
                            return _AuthenticatedAPIClient2.default.put(endpoint, payload);

                        case 5:
                            return _context4.abrupt('return', _context4.sent);

                        case 6:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function updateAccessibilityProfile(_x2) {
            return _ref4.apply(this, arguments);
        }

        return updateAccessibilityProfile;
    }(),
    getPreviousJourneys: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(date) {
            var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = '/travel-assist/' + user.id + '/previous-journeys/?size=' + size + '&date=' + date;
                            _context5.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            return _context5.abrupt('return', _context5.sent);

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function getPreviousJourneys(_x4) {
            return _ref5.apply(this, arguments);
        }

        return getPreviousJourneys;
    }(),
    getAssistedTravelLocation: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(nlc) {
            var endpoint;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            endpoint = '/travel-assist/assisted-travel/location?nlc=' + nlc;
                            _context6.next = 3;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 3:
                            return _context6.abrupt('return', _context6.sent);

                        case 4:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function getAssistedTravelLocation(_x5) {
            return _ref6.apply(this, arguments);
        }

        return getAssistedTravelLocation;
    }(),
    bookAssist: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(payload) {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = '/travel-assist/' + user.id + '/assisted-travel/create';
                            _context7.next = 4;
                            return _AuthenticatedAPIClient2.default.post(endpoint, payload);

                        case 4:
                            return _context7.abrupt('return', _context7.sent);

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function bookAssist(_x6) {
            return _ref7.apply(this, arguments);
        }

        return bookAssist;
    }(),
    bookManyAssists: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(payload) {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = '/travel-assist/' + user.id + '/assisted-travel/create-many';
                            _context8.next = 4;
                            return _AuthenticatedAPIClient2.default.post(endpoint, payload);

                        case 4:
                            return _context8.abrupt('return', _context8.sent);

                        case 5:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function bookManyAssists(_x7) {
            return _ref8.apply(this, arguments);
        }

        return bookManyAssists;
    }(),
    getAssistedBooking: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(sysId) {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = 'travel-assist/' + user.id + '/assisted-travel/' + sysId;
                            _context9.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            return _context9.abrupt('return', _context9.sent);

                        case 5:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function getAssistedBooking(_x8) {
            return _ref9.apply(this, arguments);
        }

        return getAssistedBooking;
    }(),
    getAssistedBookings: function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = 'travel-assist/' + user.id + '/assisted-travels/requests';
                            _context10.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            return _context10.abrupt('return', _context10.sent);

                        case 5:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        function getAssistedBookings() {
            return _ref10.apply(this, arguments);
        }

        return getAssistedBookings;
    }(),
    cancelAssistedBooking: function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(sysId) {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = '/travel-assist/' + user.id + '/assisted-travel/' + sysId + '/cancel';
                            _context11.next = 4;
                            return _AuthenticatedAPIClient2.default.put(endpoint);

                        case 4:
                            return _context11.abrupt('return', _context11.sent);

                        case 5:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this);
        }));

        function cancelAssistedBooking(_x9) {
            return _ref11.apply(this, arguments);
        }

        return cancelAssistedBooking;
    }(),
    editAssistedBooking: function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(payload) {
            var user, sysId, endpoint;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            sysId = payload.sysId;
                            endpoint = '/travel-assist/' + user.id + '/assisted-travel/' + sysId + '/update';
                            _context12.next = 5;
                            return _AuthenticatedAPIClient2.default.put(endpoint, payload);

                        case 5:
                            return _context12.abrupt('return', _context12.sent);

                        case 6:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function editAssistedBooking(_x10) {
            return _ref12.apply(this, arguments);
        }

        return editAssistedBooking;
    }()
};

exports.default = PassengerAssist;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1918),
    createAssigner = __webpack_require__(970);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(380),
    assignMergeValue = __webpack_require__(905),
    baseFor = __webpack_require__(743),
    baseMergeDeep = __webpack_require__(1919),
    isObject = __webpack_require__(77),
    keysIn = __webpack_require__(255),
    safeGet = __webpack_require__(906);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(905),
    cloneBuffer = __webpack_require__(828),
    cloneTypedArray = __webpack_require__(829),
    copyArray = __webpack_require__(311),
    initCloneObject = __webpack_require__(830),
    isArguments = __webpack_require__(304),
    isArray = __webpack_require__(68),
    isArrayLikeObject = __webpack_require__(677),
    isBuffer = __webpack_require__(251),
    isFunction = __webpack_require__(202),
    isObject = __webpack_require__(77),
    isPlainObject = __webpack_require__(523),
    isTypedArray = __webpack_require__(306),
    safeGet = __webpack_require__(906),
    toPlainObject = __webpack_require__(1920);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(229),
    keysIn = __webpack_require__(255);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

var baseInRange = __webpack_require__(1922),
    toFinite = __webpack_require__(519),
    toNumber = __webpack_require__(312);

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite(end);
  }
  number = toNumber(number);
  return baseInRange(number, start, end);
}

module.exports = inRange;


/***/ }),
/* 1922 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

module.exports = baseInRange;


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _throttle2 = __webpack_require__(452);

var _throttle3 = _interopRequireDefault(_throttle2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oldHandler = null;
var WindowActions = {

    resize: (0, _throttle3.default)(function () {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.WINDOW_RESIZED
        });
    }, 500),

    startListeners: function startListeners() {
        oldHandler = window.onresize;
        window.onresize = this.resize;
    },
    stopListeners: function stopListeners() {
        window.onresize = oldHandler;
    }
};

exports.default = WindowActions;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var tabSwitch = function tabSwitch() {
    var hiddenTab = null;
    var visibilityChange = null;
    if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        hiddenTab = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hiddenTab = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hiddenTab = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }

    return {
        hiddenTab: hiddenTab,
        visibilityChange: visibilityChange
    };
};

exports.default = tabSwitch;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _Banner = __webpack_require__(583);

var _Banner2 = _interopRequireDefault(_Banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BetaBanner() {
    return _react2.default.createElement(
        _Banner2.default,
        { className: 'banner--beta', bodyClassName: 'body--banner-beta' },
        _react2.default.createElement(
            'div',
            { className: 'pull-left' },
            _react2.default.createElement(
                'span',
                { className: 'banner--beta__beta' },
                (0, _I18n.translate)('global.banner.beta.logo.text')
            ),
            ' ' + (0, _I18n.translate)('global.banner.beta.text') + ' ',
            _react2.default.createElement(
                'a',
                { className: 'text-weight--bold', href: _config2.default.get('helpUrl'), target: '_blank' },
                (0, _I18n.translate)('global.banner.beta.help')
            )
        )
    );
}

exports.default = BetaBanner;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.MessageBanner = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AppActions = __webpack_require__(390);

var _AppActions2 = _interopRequireDefault(_AppActions);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _BannerStore = __webpack_require__(458);

var _BannerStore2 = _interopRequireDefault(_BannerStore);

var _Banner = __webpack_require__(809);

var _Banner2 = _interopRequireDefault(_Banner);

var _Banner3 = __webpack_require__(583);

var _Banner4 = _interopRequireDefault(_Banner3);

var _CroppedMessage = __webpack_require__(1927);

var _CroppedMessage2 = _interopRequireDefault(_CroppedMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageBanner = exports.MessageBanner = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(MessageBanner, _React$PureComponent);

    function MessageBanner() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MessageBanner);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleDismiss = function () {
            _AppActions2.default.dismissMessageBanner(_this.props.banner.id);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    MessageBanner.prototype.componentDidMount = function componentDidMount() {
        _AppActions2.default.loadBanner();
    };

    MessageBanner.prototype.render = function render() {
        var banner = this.props.banner;


        if (!banner) {
            return null;
        }

        var bannerProps = {
            className: 'banner--message',
            bodyClassName: 'body--banner-message',
            onDismiss: this.handleDismiss,
            showDismiss: true
        };

        var regex = /(<a\b[^>]*>)[^<>]*(<\/a>)/i;

        var getTextFromHyperlink = function getTextFromHyperlink(linkText) {
            return linkText.match(/<a [^>]+>([^<]+)<\/a>/)[1];
        };

        var replacedBannerText = null;

        try {
            replacedBannerText = banner.text.replace(regex, '$1<span class="external-link">\n                ' + getTextFromHyperlink(banner.text) + '</span>\n                <span class="external-link__spacer">&nbsp;</span>\n                <i class="otrl otrl-externallink"></i>\n                <span class="sr-only"> opens in a new window</span>$2');
        } catch (e) {
            console.log('cannot format anchor link', e); // eslint-disable-line
        }

        return _react2.default.createElement(
            _Banner4.default,
            bannerProps,
            _react2.default.createElement(
                'div',
                { className: 'pull-left' },
                _react2.default.createElement(_CroppedMessage2.default, { message: replacedBannerText || banner.text })
            )
        );
    };

    return MessageBanner;
}(_react2.default.PureComponent), _class.propTypes = {
    banner: _propTypes2.default.instanceOf(_Banner2.default),
    isMobileWidth: _propTypes2.default.bool
}, _class.defaultProps = {
    banner: null,
    isMobileWidth: false
}, _temp2);


function getStateFromStores() {
    return {
        banner: _BannerStore2.default.getActive()
    };
}

exports.default = (0, _connectToStores2.default)([_BannerStore2.default], getStateFromStores)(MessageBanner);

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CroppedMessage = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders either a complete message or a cropped one and
 * will display the complete message in the modal.
 */
var CroppedMessage = exports.CroppedMessage = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(CroppedMessage, _React$PureComponent);

    function CroppedMessage() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CroppedMessage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            showModal: false
        }, _this._toggleModal = function () {
            _this.setState({
                showModal: !_this.state.showModal
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    CroppedMessage.prototype._shouldCrop = function _shouldCrop(message) {
        var _props = this.props,
            isMobileWidth = _props.isMobileWidth,
            maxLength = _props.maxLength;

        return isMobileWidth && message.length > maxLength;
    };

    CroppedMessage.prototype._adjustedText = function _adjustedText(shouldCrop, message) {
        var maxLength = this.props.maxLength;


        if (!shouldCrop) {
            return message;
        }

        // crop the text accordingly
        return message.substring(0, maxLength) + ' ... ';
    };

    CroppedMessage.prototype._renderReadMoreModal = function _renderReadMoreModal() {
        var message = this.props.message;
        var showModal = this.state.showModal;


        if (!showModal) {
            return null;
        }

        return _react2.default.createElement(
            _BaseModal2.default,
            {
                continueText: 'global.banner.dismiss',
                titleText: 'global.banner.readmore',
                onContinue: this._toggleModal,
                hideClose: true },
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: message })
        );
    };

    CroppedMessage.prototype.render = function render() {
        var message = this.props.message;

        var shouldCrop = this._shouldCrop(message);
        var text = this._adjustedText(shouldCrop, message);

        return _react2.default.createElement(
            'div',
            null,
            this._renderReadMoreModal(),
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: text }),
            shouldCrop && _react2.default.createElement(
                _Button2.default,
                {
                    className: 'btn-link',
                    onClick: this._toggleModal },
                (0, _I18n2.default)('global.banner.readmore')
            )
        );
    };

    return CroppedMessage;
}(_react2.default.PureComponent), _class.propTypes = {
    isMobileWidth: _propTypes2.default.bool,
    maxLength: _propTypes2.default.number,
    message: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
    isMobileWidth: false,
    maxLength: 250
}, _temp2);


function getStateFromStores() {
    return {
        isMobileWidth: _DimensionsStore2.default.isMobileWidth()
    };
}

exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default], getStateFromStores)(CroppedMessage);

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _Banner = __webpack_require__(583);

var _Banner2 = _interopRequireDefault(_Banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BetaBanner() {
    return _react2.default.createElement(
        _Banner2.default,
        { className: 'banner--microsite', bodyClassName: 'body--banner-microsite' },
        _react2.default.createElement(
            'div',
            { className: 'text-center' },
            _react2.default.createElement('img', { src: _config2.default.get('micrositeLogo'), alt: (0, _I18n.translate)('app.owner') })
        )
    );
}

exports.default = BetaBanner;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkipToContentLink = function SkipToContentLink() {
    return _react2.default.createElement(
        'a',
        { href: '#route__content', className: 'skip-to-content-link padding--vert-sm padding--horiz' },
        (0, _I18n2.default)('skipToContent')
    );
};

exports.default = SkipToContentLink;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _LoggedOutLinks = __webpack_require__(1931);

var _LoggedOutLinks2 = _interopRequireDefault(_LoggedOutLinks);

var _LoggedInLinks = __webpack_require__(1932);

var _LoggedInLinks2 = _interopRequireDefault(_LoggedInLinks);

var _BasketLink = __webpack_require__(1955);

var _BasketLink2 = _interopRequireDefault(_BasketLink);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _FavouritesLink = __webpack_require__(1957);

var _FavouritesLink2 = _interopRequireDefault(_FavouritesLink);

var _WebchatLink = __webpack_require__(1972);

var _WebchatLink2 = _interopRequireDefault(_WebchatLink);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Logo = __webpack_require__(1973);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header(_ref) {
    var isMobile = _ref.isMobile,
        user = _ref.user,
        order = _ref.order,
        disableLogin = _ref.disableLogin,
        disableNav = _ref.disableNav;


    var brandedAccountMenuNav = _config2.default.get('brandedAccountMenuNav');

    return _react2.default.createElement(
        'header',
        { className: 'container-fluid header', role: 'banner' },
        _react2.default.createElement(
            'nav',
            { role: 'navigation', className: 'pull-left header__container' },
            _react2.default.createElement(_Logo.Logo, null),
            brandedAccountMenuNav && brandedAccountMenuNav.filter(function (_ref2) {
                var name = _ref2.name;
                return name === "account.nav.myTrees";
            }).map(function (_ref3) {
                var destination = _ref3.destination,
                    icon = _ref3.icon;
                return _react2.default.createElement(
                    'a',
                    { href: destination, className: 'header__tree-icon' },
                    _react2.default.createElement('i', { className: (0, _classnames2.default)('otrl', icon) })
                );
            })
        ),
        !disableNav && _react2.default.createElement(
            'nav',
            { role: 'navigation', className: 'header__nav pull-right hidden-print' },
            _react2.default.createElement(
                'ul',
                { className: 'no-margin list-unstyled clearfix nav-list' },
                !disableLogin && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    user.isLoggedIn() ? _react2.default.createElement(_LoggedInLinks2.default, { user: user }) : _react2.default.createElement(_LoggedOutLinks2.default, null)
                ),
                isMobile && _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableWebchat' },
                    _react2.default.createElement(
                        'li',
                        { className: 'pull-right nav-list__item nav-list__item--webchat' },
                        _react2.default.createElement(_WebchatLink2.default, null)
                    )
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableHeaderBasket' },
                    _react2.default.createElement(
                        'li',
                        { className: 'pull-right nav-list__item nav-list__item--basket' },
                        _react2.default.createElement(_BasketLink2.default, { order: order })
                    )
                ),
                user.isLoggedIn() && _react2.default.createElement(_FavouritesLink2.default, { user: user })
            )
        )
    );
}

Header.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    isMobile: _propTypes2.default.bool.isRequired,
    disableNav: _propTypes2.default.bool,
    disableLogin: _propTypes2.default.bool
};

exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default], function () {
    return {
        isMobile: _DimensionsStore2.default.isMobileWidth()
    };
})(Header);

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _LoginLink = __webpack_require__(1033);

var _LoginLink2 = _interopRequireDefault(_LoginLink);

var _RegisterLink = __webpack_require__(1046);

var _RegisterLink2 = _interopRequireDefault(_RegisterLink);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _DropDown = __webpack_require__(907);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _DropDownItem = __webpack_require__(584);

var _DropDownItem2 = _interopRequireDefault(_DropDownItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedOutLinks = function (_PureRenderComponent) {
    (0, _inherits3.default)(LoggedOutLinks, _PureRenderComponent);

    function LoggedOutLinks() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LoggedOutLinks);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = { showDropdown: false }, _this._toggleDropdown = function () {
            return _this.setState({ showDropdown: !_this.state.showDropdown });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    LoggedOutLinks.prototype.render = function render() {
        var classNames = (0, _classnames2.default)('navlink__login btn like-link', {
            'active': this.state.showDropdown
        });

        var ariaExpandedState = this.state.showDropdown ? "true" : "false";

        return _react2.default.createElement(
            'li',
            { className: 'pull-right nav-list__item nav-list__item--login' },
            _react2.default.createElement(_LoginLink2.default, null),
            _react2.default.createElement(_RegisterLink2.default, null),
            _react2.default.createElement(
                'button',
                { type: 'button',
                    'aria-label': (0, _I18n.translate)('ariaLabel.showLoginDropdown'),
                    'aria-haspopup': 'true',
                    'aria-expanded': ariaExpandedState,
                    className: classNames,
                    onClick: this._toggleDropdown },
                _react2.default.createElement(_Icon2.default, { icon: 'user' }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('account.login')
                ),
                _react2.default.createElement(_Icon2.default, { icon: 'dropdown' })
            ),
            _react2.default.createElement(
                _DropDown2.default,
                { show: this.state.showDropdown },
                _react2.default.createElement(
                    _DropDownItem2.default,
                    null,
                    _react2.default.createElement(_LoginLink2.default, { onClick: this._toggleDropdown })
                ),
                _react2.default.createElement(
                    _DropDownItem2.default,
                    null,
                    _react2.default.createElement(_RegisterLink2.default, { onClick: this._toggleDropdown })
                )
            )
        );
    };

    return LoggedOutLinks;
}(_PureRenderComponent3.default);

exports.default = LoggedOutLinks;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LoggedInLinks = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _class, _class2, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(85);

var _immutable = __webpack_require__(5);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _DropDown = __webpack_require__(907);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _DropDownItem = __webpack_require__(584);

var _DropDownItem2 = _interopRequireDefault(_DropDownItem);

var _DropDownSubGroup = __webpack_require__(1933);

var _DropDownSubGroup2 = _interopRequireDefault(_DropDownSubGroup);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ResponsiveRender = __webpack_require__(982);

var _ResponsiveRender2 = _interopRequireDefault(_ResponsiveRender);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _NavTrigger = __webpack_require__(1934);

var _NavTrigger2 = _interopRequireDefault(_NavTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _stateFromStores(_ref) {
    var user = _ref.user;

    var smartcard = _SmartcardStore2.default.get('smartcard');
    var isReplacementPending = _SmartcardStore2.default.isReplacementPending();
    var canUseSmartcard = smartcard && smartcard.isActive() || isReplacementPending;
    var hasSmartcard = !!smartcard;
    var smartcardAwaitingProduct = hasSmartcard && smartcard.isAwaitingProduct();
    var isHotlisted = smartcard && smartcard.isHotlisted();
    var canPreloadKeyGo = _FeatureFlagStore2.default.get('enableKeyGoRegistrationAtSignup') && smartcardAwaitingProduct;
    var canRegisterKeyGo = hasSmartcard && smartcard.canRegisterKeyGo();
    var isKeyGo = !!(smartcard && smartcard.getKeyGoProduct());
    var isKeyGoActive = smartcard && smartcard.hasActiveKeyGo();
    var canTransferProduct = (!smartcard || smartcard.isAwaitingProduct()) && user.isAdult();
    var redirectOnLogout = _FeatureFlagStore2.default.get('enableLogoutRedirect');
    var enableKeyGo = _FeatureFlagStore2.default.get('enableKeyGo');
    var enableKeyGoSelfCompleteJourneys = _FeatureFlagStore2.default.get('enableKeyGoSelfCompleteJourneys');
    var canAutoDelayRepay = _SmartcardStore2.default.canAutoDelayRepay();

    return {
        hasSmartcard: hasSmartcard,
        canUseSmartcard: canUseSmartcard,
        canTransferProduct: canTransferProduct,
        canAutoDelayRepay: canAutoDelayRepay,
        isHotlisted: isHotlisted,
        canRegisterKeyGo: canRegisterKeyGo,
        isKeyGo: isKeyGo,
        isKeyGoActive: isKeyGoActive,
        redirectOnLogout: redirectOnLogout,
        enableKeyGo: enableKeyGo,
        enableKeyGoSelfCompleteJourneys: enableKeyGoSelfCompleteJourneys,
        canPreloadKeyGo: canPreloadKeyGo,
        enableSmartCarnet: _FeatureFlagStore2.default.get('enableSmartCarnet')
    };
}

var LoggedInLinks = exports.LoggedInLinks = (0, _withRouter2.default)(_class = (_temp2 = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(LoggedInLinks, _PureRenderComponent);

    function LoggedInLinks() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LoggedInLinks);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = { showDropdown: false }, _this._toggleDropdown = function () {
            return _this.setState({ showDropdown: !_this.state.showDropdown });
        }, _this._closeMenu = function () {
            return _this.setState({ showDropdown: false });
        }, _this._handleLogOut = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this._closeMenu();
                            if (_this.props.redirectOnLogout) {
                                _this.props.router.push(_urls2.default.location(_AppConstants.PointStages.SEARCH));
                            }
                            _context.next = 4;
                            return _CustomerActions2.default.logout(_this.props.user);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    LoggedInLinks.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        if (_SmartcardStore2.default.shouldGetSmartcard()) {
            (0, _defer3.default)(_CustomerActions2.default.getSmartcard, this.props.user);
        }
    };

    LoggedInLinks.prototype._renderDropDownLink = function _renderDropDownLink(destination, content) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var _ref3 = options.anchor ? ['a', { href: destination, target: '_blank' }] : [_Link2.default, { to: destination }],
            LinkTag = _ref3[0],
            linkProps = _ref3[1];

        return _react2.default.createElement(
            _DropDownItem2.default,
            { key: content },
            _react2.default.createElement(
                LinkTag,
                (0, _extends3.default)({
                    role: 'menuitem',
                    className: 'btn',
                    tabIndex: '0',
                    onClick: this._closeMenu
                }, linkProps),
                options.icon && options.hasIconOnLeft && _react2.default.createElement('i', { className: (0, _classnames2.default)('otrl', options.icon, 'margin-right--xs') }),
                content,
                options.icon && !options.hasIconOnLeft && _react2.default.createElement('i', { className: (0, _classnames2.default)('otrl', options.icon, 'margin-left--xs') })
            )
        );
    };

    LoggedInLinks.prototype.render = function render() {
        var _this3 = this;

        var classNames = (0, _classnames2.default)('btn navlink__account', {
            'active': this.state.showDropdown
        });
        var _props = this.props,
            canAutoDelayRepay = _props.canAutoDelayRepay,
            canPreloadKeyGo = _props.canPreloadKeyGo,
            canRegisterKeyGo = _props.canRegisterKeyGo,
            canTransferProduct = _props.canTransferProduct,
            canUseSmartcard = _props.canUseSmartcard,
            enableKeyGo = _props.enableKeyGo,
            enableKeyGoSelfCompleteJourneys = _props.enableKeyGoSelfCompleteJourneys,
            enableSmartCarnet = _props.enableSmartCarnet,
            hasSmartcard = _props.hasSmartcard,
            isHotlisted = _props.isHotlisted,
            isKeyGo = _props.isKeyGo,
            isKeyGoActive = _props.isKeyGoActive,
            user = _props.user;


        var showPhotocardsRailcardsPage = _FeatureFlagStore2.default.get('enableSavedPhotocards') || _FeatureFlagStore2.default.get('enableAccountRailcards');
        var brandedMenuNav = new _immutable.List(_config2.default.get('brandedMenuNav'));

        var paperTransferLink = _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableSmartcardPaperTransfers', disabled: !canTransferProduct },
            this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_TRANSFER, (0, _I18n.translate)('account.heading.smartcard.transfer'))
        );

        return _react2.default.createElement(
            'li',
            { className: 'pull-right nav-list__item nav-list__item--account' },
            _react2.default.createElement(
                'button',
                { className: classNames,
                    tabIndex: '0',
                    type: 'button',
                    'aria-expanded': this.state.showDropdown,
                    onClick: this._toggleDropdown,
                    role: 'link' },
                _react2.default.createElement(
                    'div',
                    { className: 'navlink__welcome hidden-mobile hidden-tablet-portrait pull-left' },
                    (0, _I18n.translate)('header.welcome')
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'navlink__name truncate pull-left' },
                    user.firstNames
                ),
                _react2.default.createElement(_Icon2.default, { icon: 'dropdown' })
            ),
            _react2.default.createElement(
                _DropDown2.default,
                { show: this.state.showDropdown, onClose: this._closeMenu, outsideClickIgnoreClass: 'navlink__account' },
                _react2.default.createElement(_NavTrigger2.default, { closeMenu: this._closeMenu }),
                brandedMenuNav && brandedMenuNav.map(function (_ref4) {
                    var name = _ref4.name,
                        destination = _ref4.destination,
                        anchor = _ref4.anchor,
                        icon = _ref4.icon,
                        hasIconOnLeft = _ref4.hasIconOnLeft;
                    return _this3._renderDropDownLink(destination, (0, _I18n.translate)(name), { anchor: anchor, icon: icon, hasIconOnLeft: hasIconOnLeft });
                }),
                this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_DETAILS, (0, _I18n.translate)('nav.myaccount')),
                _react2.default.createElement(
                    _ResponsiveRender2.default,
                    { minWidth: _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH,
                        minHeight: _AppConstants.BreakPoints.DROPDOWN_SMALL_HEIGHT },
                    _react2.default.createElement(
                        _DropDownSubGroup2.default,
                        null,
                        this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_DETAILS, (0, _I18n.translate)('account.nav.accountdetails')),
                        _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enableUserAddresses' },
                            this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_ADDRESSES, (0, _I18n.translate)('account.nav.addresses'))
                        ),
                        _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enablePay360Api' },
                            this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_PAYMENT, (0, _I18n.translate)('account.nav.paymentdetails'))
                        ),
                        _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enableEticketAccountSection' },
                            this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_ETICKETS, (0, _I18n.translate)('account.nav.etickets'))
                        ),
                        _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enableSTickets' },
                            _react2.default.createElement(
                                _FeatureFlag2.default,
                                { name: 'enableSTicketsList' },
                                this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_STICKETS, (0, _I18n.translate)('account.nav.stickets'))
                            )
                        ),
                        _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enableEVouchers' },
                            this._renderDropDownLink(_AppConstants.AccountPages.EVOUCHERS, (0, _I18n.translate)('account.nav.evouchers'))
                        ),
                        showPhotocardsRailcardsPage && this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_PHOTOCARDS_RAILCARDS, (0, _I18n.translate)('account.nav.photocards-railcards')),
                        this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_ORDERS_REFUNDS, (0, _I18n.translate)('account.nav.orders-refunds')),
                        _react2.default.createElement(
                            _FeatureFlag2.default,
                            { name: 'enableDisruptionAlerts' },
                            this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_DISRUPTION_ALERTS, (0, _I18n.translate)('account.nav.disruptionAlerts'))
                        )
                    )
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableSmartcard', disabled: canUseSmartcard },
                    hasSmartcard && this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_APPLY, (0, _I18n.translate)('account.heading.smartcard.status')),
                    enableKeyGo && canPreloadKeyGo && this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_KEYGO, (0, _I18n.translate)('account.nav.smartcard.keygosignup')),
                    !hasSmartcard && _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableSmartcardAccountApplication' },
                        this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_APPLY, (0, _I18n.translate)('account.heading.smartcard.apply'))
                    ),
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableSmartcardPaperTransfers', disabled: !canTransferProduct },
                        _react2.default.createElement(
                            _DropDownSubGroup2.default,
                            null,
                            paperTransferLink
                        )
                    ),
                    isHotlisted && _react2.default.createElement(
                        _DropDownSubGroup2.default,
                        null,
                        this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_REPLACEMENT, (0, _I18n.translate)('account.nav.smartcard.replacement'))
                    )
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableSmartcard', disabled: !canUseSmartcard },
                    this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_TICKETS, (0, _I18n.translate)('account.nav.smartcard')),
                    _react2.default.createElement(
                        _ResponsiveRender2.default,
                        { maxWidth: _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH },
                        _react2.default.createElement(
                            _DropDownSubGroup2.default,
                            null,
                            paperTransferLink
                        )
                    ),
                    _react2.default.createElement(
                        _ResponsiveRender2.default,
                        { minWidth: _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH,
                            minHeight: _AppConstants.BreakPoints.DROPDOWN_MEDIUM_HEIGHT },
                        _react2.default.createElement(
                            _DropDownSubGroup2.default,
                            null,
                            paperTransferLink,
                            this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_TICKETS, (0, _I18n.translate)('account.nav.smartcard.tickets')),
                            !enableKeyGoSelfCompleteJourneys && this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_HISTORY, (0, _I18n.translate)('account.nav.smartcard.journeyhistory')),
                            enableKeyGoSelfCompleteJourneys && this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_KEYGO_HISTORY, (0, _I18n.translate)('account.nav.smartcard.keygohistory')),
                            this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_REPLACEMENT, (0, _I18n.translate)('account.nav.smartcard.replacement')),
                            enableSmartCarnet && isKeyGoActive && this._renderDropDownLink(_AppConstants.AccountPages.ACCOUNT_SMART_CARNET, (0, _I18n.translate)('account.nav.smart-carnet')),
                            enableKeyGo && isKeyGo && this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_KEYGO, canRegisterKeyGo ? _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.nav.smartcard.keygosignup' }) : _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' }))
                        )
                    )
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableSmartcardAssociations' },
                    this._renderDropDownLink(_AppConstants.AccountPages.SMARTCARD_LINK, (0, _I18n.translate)('account.nav.smartcard.link'))
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enablePassengerAssist' },
                    this._renderDropDownLink(_AppConstants.AccountPages.BOOK_PASSENGER_ASSIST, (0, _I18n.translate)('account.nav.passengerAssist'))
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableDelayRepay' },
                    this._renderDropDownLink('https://' + _config2.default.get('delayRepayHost') + '/', (0, _I18n.translate)('account.nav.delayrepay'), { anchor: true }),
                    !_FeatureFlagStore2.default.get('enableOneClickDelayRepay') && _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableAutoDelayRepay', disabled: !user.autoDrOptedIn && !canAutoDelayRepay },
                        _react2.default.createElement(
                            _DropDownSubGroup2.default,
                            null,
                            this._renderDropDownLink('https://' + _config2.default.get('autoDelayRepayHost') + _urls2.default.location(_AppConstants.AccountPages.AUTO_DELAY_REPAY).pathname, (0, _I18n.translate)('account.nav.auto-delay-repay'), { anchor: true })
                        )
                    ),
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableOneClickDelayRepay' },
                        _react2.default.createElement(
                            _DropDownSubGroup2.default,
                            null,
                            this._renderDropDownLink(_AppConstants.AccountPages.ONE_CLICK_DELAY_REPAY, (0, _I18n.translate)('account.nav.one-click-delay-repay'))
                        )
                    )
                ),
                _react2.default.createElement(
                    _DropDownItem2.default,
                    null,
                    _react2.default.createElement(
                        'button',
                        { 'aria-label': (0, _I18n.translate)('account.logout'),
                            role: 'menuitem',
                            type: 'button',
                            className: 'btn',
                            tabIndex: '0',
                            onClick: this._handleLogOut,
                            'data-role': 'logout' },
                        (0, _I18n.translate)('account.logout')
                    )
                )
            )
        );
    };

    return LoggedInLinks;
}(_PureRenderComponent3.default), _class2.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    router: _PropTypes.routerShape,
    hasSmartcard: _propTypes2.default.bool,
    canUseSmartcard: _propTypes2.default.bool,
    canTransferProduct: _propTypes2.default.bool,
    canAutoDelayRepay: _propTypes2.default.bool,
    isHotlisted: _propTypes2.default.bool,
    canRegisterKeyGo: _propTypes2.default.bool,
    isKeyGo: _propTypes2.default.bool,
    isKeyGoActive: _propTypes2.default.bool,
    redirectOnLogout: _propTypes2.default.bool,
    enableKeyGo: _propTypes2.default.bool,
    enableKeyGoSelfCompleteJourneys: _propTypes2.default.bool,
    enableSmartCarnet: _propTypes2.default.bool
}, _class2.defaultProps = {
    hasSmartcard: false,
    canRegisterKeyGo: false,
    enableKeyGoSelfCompleteJourneys: false
}, _temp2)) || _class;

exports.default = (0, _connectToStores2.default)([_SmartcardStore2.default], _stateFromStores)(LoggedInLinks);

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropDownSubGroup(_ref) {
    var children = _ref.children;

    return _react2.default.createElement(
        'ul',
        { role: 'menu', className: 'nav-list__dropdown-sub list-unstyled no-margin clearfix' },
        children
    );
}

DropDownSubGroup.propTypes = {
    children: _propTypes2.default.node.isRequired
};

exports.default = DropDownSubGroup;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NavTrigger = NavTrigger;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _Badge = __webpack_require__(908);

var _Badge2 = _interopRequireDefault(_Badge);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _NotificationCentre = __webpack_require__(585);

var _I18n = __webpack_require__(9);

var _NotificationCentreStore = __webpack_require__(542);

var _NotificationCentreStore2 = _interopRequireDefault(_NotificationCentreStore);

var _DropDownItem = __webpack_require__(584);

var _DropDownItem2 = _interopRequireDefault(_DropDownItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NavTrigger(_ref) {
    var closeMenu = _ref.closeMenu,
        notifications = _ref.notifications;

    if (!notifications.size) {
        return null;
    }
    var clickHandler = function clickHandler() {
        closeMenu();
        (0, _NotificationCentre.displayNotifications)();
    };
    return _react2.default.createElement(
        _DropDownItem2.default,
        null,
        _react2.default.createElement(
            'button',
            { className: 'btn btn-default text-sm', onClick: clickHandler },
            _react2.default.createElement(
                'span',
                null,
                (0, _I18n.translate)('notifications.accountActions.text')
            ),
            _react2.default.createElement(
                _Badge2.default,
                { className: 'badge_notification text-center', pullRight: true },
                notifications.size
            )
        )
    );
}

NavTrigger.propTypes = {
    closeMenu: _propTypes2.default.func.isRequired,
    notifications: _propTypes2.default.instanceOf(_immutable.List)
};

var _getStateFromStores = function _getStateFromStores() {
    var notifications = _NotificationCentreStore2.default.getNotifications();
    return { notifications: notifications };
};

exports.default = (0, _connectToStores2.default)([_NotificationCentreStore2.default], _getStateFromStores)(NavTrigger);

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = NotificationCentreModal;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _ListItem = __webpack_require__(1954);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotificationCentreModal(_ref) {
    var _this = this;

    var show = _ref.show,
        notifications = _ref.notifications;

    var closeModal = function closeModal() {
        return _ModalActions2.default.close(_this);
    };
    var footer = _react2.default.createElement(
        _reactBootstrap.Button,
        {
            bsStyle: 'default',
            onClick: closeModal,
            className: 'close btn-md pull-left' },
        (0, _I18n2.default)('button.text.close')
    );
    return _react2.default.createElement(
        _BaseModal2.default,
        {
            show: show,
            footer: footer,
            titleText: 'notifications.accountActions.text',
            className: 'modal--xs' },
        _react2.default.createElement(
            'ul',
            { className: 'notification-list' },
            notifications.map(function (notification, index) {
                return _react2.default.createElement(_ListItem2.default, { key: index,
                    notification: notification });
            })
        )
    );
}

NotificationCentreModal.propTypes = {
    show: _propTypes2.default.bool,
    notifications: _propTypes2.default.instanceOf(_immutable.List).isRequired
};

NotificationCentreModal.defaultProps = {
    show: true
};

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.isReactComponent = isReactComponent;

var _invariant = _interopRequireDefault(__webpack_require__(72));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _properties = _interopRequireDefault(__webpack_require__(562));

var _style = _interopRequireDefault(__webpack_require__(263));

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;
  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties.default.end) {
    node.addEventListener(_properties.default.end, done, false);
    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;
var _default = onEnd;
exports.default = _default;

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

module.exports = exports["default"];

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1939);
module.exports = __webpack_require__(78).parseInt;


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(88);
var $parseInt = __webpack_require__(1940);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(138).parseInt;
var $trim = __webpack_require__(1941).trim;
var ws = __webpack_require__(911);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(88);
var defined = __webpack_require__(397);
var fails = __webpack_require__(193);
var spaces = __webpack_require__(911);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(860);
__webpack_require__(1943);
module.exports = __webpack_require__(78).Array.from;


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(262);
var $export = __webpack_require__(88);
var toObject = __webpack_require__(260);
var call = __webpack_require__(865);
var isArrayIter = __webpack_require__(866);
var toLength = __webpack_require__(398);
var createProperty = __webpack_require__(1944);
var getIterFn = __webpack_require__(867);

$export($export.S + $export.F * !__webpack_require__(1945)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(167);
var createDesc = __webpack_require__(322);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(140)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(402);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1947);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(404);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(264);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(914);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(1948);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(915);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(264);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(631));

var _offset = _interopRequireDefault(__webpack_require__(914));

var _offsetParent = _interopRequireDefault(__webpack_require__(1949));

var _scrollTop = _interopRequireDefault(__webpack_require__(915));

var _scrollLeft = _interopRequireDefault(__webpack_require__(1950));

var _style = _interopRequireDefault(__webpack_require__(263));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(222));

var _style = _interopRequireDefault(__webpack_require__(263));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(403));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1952);
module.exports = __webpack_require__(78).Array.isArray;


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(88);

$export($export.S, 'Array', { isArray: __webpack_require__(567) });


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = NotificationListItem;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotificationListItem(_ref) {
    var notification = _ref.notification;

    return _react2.default.createElement(
        _OnEnterTrigger2.default,
        { element: 'li',
            role: 'button',
            onClick: notification.onClick,
            className: 'notification-list__item' },
        _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(
                            'h2',
                            { className: 'notification-list__item__title' },
                            (0, _I18n2.default)(notification.title)
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'notification-list__item__description' },
                            (0, _I18n2.default)(notification.description)
                        )
                    ),
                    _react2.default.createElement(
                        'td',
                        { width: '58' },
                        _react2.default.createElement(
                            'button',
                            { className: 'notification-list__item__cta', tabIndex: '-1', onClick: notification.onClick, 'aria-hidden': 'true' },
                            (0, _I18n2.default)('global.go')
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            '. ',
            (0, _I18n2.default)('global.clickForMoreInfo')
        )
    );
}

NotificationListItem.propTypes = {
    notification: _propTypes2.default.shape({
        title: _propTypes2.default.string.isRequired,
        description: _propTypes2.default.string.isRequired,
        onClick: _propTypes2.default.func.isRequired
    }).isRequired
};

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Currency = __webpack_require__(169);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _ShoppingBasketIcon = __webpack_require__(1956);

var _ShoppingBasketIcon2 = _interopRequireDefault(_ShoppingBasketIcon);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BasketLink(_ref) {
    var order = _ref.order,
        showIcon = _ref.showIcon,
        className = _ref.className,
        onClick = _ref.onClick;


    var _handleClick = function _handleClick() {
        return _ModalActions2.default.open(_AppConstants.GlobalModals.BASKET) && onClick();
    };

    return _react2.default.createElement(
        'button',
        {
            key: order.trips.size,
            type: 'button',
            'aria-label': (0, _I18n.translate)('ariaLabel.basketButton', { journeys: order.trips.size, price: '\xA3' + (0, _Currency.toPounds)(order.getTotalPrice()).toFixed(2) }),
            className: className,
            onClick: _handleClick,
            role: 'link',
            tabIndex: '0'
        },
        showIcon && _react2.default.createElement(_ShoppingBasketIcon2.default, null),
        _react2.default.createElement(
            'span',
            { className: 'navlink__journey-count--mobile visible-mobile visible-tablet-portrait' },
            order.trips.size
        ),
        _react2.default.createElement(
            'span',
            { className: 'hidden-mobile hidden-tablet-portrait' },
            _react2.default.createElement(
                'span',
                { className: 'navlink__journey-count' },
                (0, _I18n.translate)('header.basket.journeyText', { journeys: order.trips.size })
            ),
            _react2.default.createElement(_Price2.default, { price: order.getTotalPrice() })
        )
    );
}

BasketLink.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    className: _propTypes2.default.string,
    showIcon: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

BasketLink.defaultProps = {
    className: 'navlink__basket btn',
    showIcon: true,
    onClick: _noop3.default
};

exports.default = BasketLink;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShoppingBasketIcon = function ShoppingBasketIcon(_ref) {
    var fill = _ref.fill;
    return _react2.default.createElement(
        'svg',
        {
            width: '18',
            height: '16',
            viewBox: '0 0 18 16',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
        },
        _react2.default.createElement('path', {
            d: 'M13.2627 5.9014C13.2627 5.9014 9.6709 0.37239 9.6709 0.37239C9.3436 -0.12413 8.6318 -0.12413 8.3127 0.37239C8.3127 0.37239 4.72091 5.9014 4.72091 5.9014C4.72091 5.9014 0.81818 5.9014 0.81818 5.9014C0.36818 5.9014 0 6.2801 0 6.7429C0 6.8187 0.0081799 6.8944 0.0327301 6.9702C0.0327301 6.9702 2.11091 14.7713 2.11091 14.7713C2.29909 15.4782 2.92909 16 3.68182 16C3.68182 16 14.3182 16 14.3182 16C15.0709 16 15.7009 15.4782 15.8973 14.7713C15.8973 14.7713 17.9755 6.9702 17.9755 6.9702C17.9755 6.9702 18 6.7429 18 6.7429C18 6.2801 17.6318 5.9014 17.1818 5.9014C17.1818 5.9014 13.2627 5.9014 13.2627 5.9014ZM9 3C9 3 11 6 11 6L7 6C7 6 9 3 9 3ZM7 11C7 12.1 7.9 13 9 13C10.1 13 11 12.1 11 11C11 9.9 10.1 9 9 9C7.9 9 7 9.9 7 11Z',
            fill: fill,
            fillRule: 'evenodd'
        })
    );
};

ShoppingBasketIcon.propTypes = {
    fill: _propTypes2.default.string
};

ShoppingBasketIcon.defaultProps = {
    fill: '#1e1e50'
};

exports.default = ShoppingBasketIcon;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FavouritesLink = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _FavouritesStore = __webpack_require__(271);

var _FavouritesStore2 = _interopRequireDefault(_FavouritesStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _FavouritesActions = __webpack_require__(422);

var _FavouritesActions2 = _interopRequireDefault(_FavouritesActions);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FavouritesModal = __webpack_require__(1961);

var _FavouritesModal2 = _interopRequireDefault(_FavouritesModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavouritesLink = exports.FavouritesLink = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(FavouritesLink, _PureRenderComponent);

    function FavouritesLink() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FavouritesLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            showFavouritesModal: false
        }, _this._toggleModal = function () {
            return _this.setState({ showFavouritesModal: !_this.state.showFavouritesModal });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    FavouritesLink.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var _props = this.props,
            enabled = _props.enabled,
            user = _props.user;

        if (enabled && user.isLoggedIn()) {
            _FavouritesActions2.default.getAll(user);
        }
    };

    FavouritesLink.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        var enabled = nextProps.enabled,
            user = nextProps.user;

        if (enabled && user.isLoggedIn() && this.isUserChanged(user, this.props.user)) {
            _FavouritesActions2.default.getAll(user);
        }
    };

    FavouritesLink.prototype.isUserChanged = function isUserChanged(user, oldUser) {
        return user.id !== oldUser.id;
    };

    FavouritesLink.prototype.render = function render() {
        var _props2 = this.props,
            favourites = _props2.favourites,
            enabled = _props2.enabled,
            user = _props2.user;


        if (favourites.isEmpty() || !enabled || !user.isLoggedIn()) {
            return null;
        }

        return _react2.default.createElement(
            'li',
            { className: 'pull-right nav-list__item nav-list__item--favourites' },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'navlink__favourites btn', role: 'link',
                        'aria-label': (0, _I18n.translate)('ariaLabel.openFavourites'),
                        onClick: this._toggleModal },
                    _react2.default.createElement(_Icon2.default, { icon: 'favourite' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'hidden-mobile hidden-tablet-portrait' },
                        '\xA0',
                        (0, _I18n.translate)('header.favourites')
                    )
                ),
                this.state.showFavouritesModal && _react2.default.createElement(_FavouritesModal2.default, {
                    favourites: favourites,
                    onCancel: this._toggleModal,
                    user: user })
            )
        );
    };

    return FavouritesLink;
}(_PureRenderComponent3.default), _class.propTypes = {
    favourites: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    enabled: _propTypes2.default.bool.isRequired
}, _class.defaultProps = {
    favourites: new _immutable.List(),
    enabled: false
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FavouritesStore2.default, _UserStore2.default, _FeatureFlagStore2.default], function () {
    return {
        favourites: _FavouritesStore2.default.getFavourites(),
        user: _UserStore2.default.getCurrent(),
        enabled: _FeatureFlagStore2.default.get('enableFavouriteTickets')
    };
})(FavouritesLink);

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _Fulfilment = __webpack_require__(349);

var _Fulfilment2 = _interopRequireDefault(_Fulfilment);

var _Favourite3 = __webpack_require__(917);

var _Favourites = __webpack_require__(971);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavouritesService = {

    /**
     * @param {OrderFare} fare
     * @param {OrderTrip} orderTrip
     * @param {OrderFulfilment} delivery
     * @param {User} user
     * @return {Favourite}
     */
    addFavourite: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fare, orderTrip, delivery, user) {
            var favourite, deliveryOption, plusBus, photocardNumber, response, _response;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            favourite = _Favourite2.default.fromFare(fare).toJSON();
                            deliveryOption = delivery.hasFulfilmentMethod() ? delivery.getPruned() : null;
                            plusBus = orderTrip ? (0, _Favourites.getPlusBus)(orderTrip) : {};
                            photocardNumber = fare.hasPhotocardNumber() ? fare.getPhotocardNumber() : null;
                            _context.next = 7;
                            return _AuthenticatedAPIClient2.default.post('/favourite-ticket/customer/' + user.id + '/one-click', (0, _extends3.default)({}, favourite, plusBus, {
                                photocard: photocardNumber,
                                delivery: deliveryOption
                            }));

                        case 7:
                            response = _context.sent;
                            _context.t0 = _LinkMapper.resolve;
                            _context.next = 11;
                            return (0, _Favourites.enrichFavouritesResponse)(response, user);

                        case 11:
                            _context.t1 = _context.sent;
                            _context.t2 = _Favourite2.default;
                            return _context.abrupt('return', (0, _context.t0)(_context.t1).as(_context.t2));

                        case 16:
                            _context.prev = 16;
                            _context.t3 = _context['catch'](0);
                            _response = _context.t3.response;

                            if (!(_response && _response.status === 422)) {
                                _context.next = 21;
                                break;
                            }

                            throw new _Favourite3.FavouritesLimitExceededError();

                        case 21:
                            throw _context.t3;

                        case 22:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 16]]);
        }));

        function addFavourite(_x, _x2, _x3, _x4) {
            return _ref.apply(this, arguments);
        }

        return addFavourite;
    }(),


    /**
     * @param {Favourite} favourite
     * @param {User} user
     */
    removeFavourite: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(favourite, user) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _AuthenticatedAPIClient2.default.delete('/favourite-ticket/customer/' + user.id + '/one-click/' + favourite.id);

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function removeFavourite(_x5, _x6) {
            return _ref2.apply(this, arguments);
        }

        return removeFavourite;
    }(),


    /**
     * @param {User} user
     * @return {Favourite[]}
     */
    getFavourites: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(user) {
            var response, favourites;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _AuthenticatedAPIClient2.default.get('/favourite-ticket/customer/' + user.id + '/one-click', {}, { loader: false });

                        case 2:
                            response = _context3.sent;
                            _context3.next = 5;
                            return _promise2.default.all(response.result.map(function (favourite) {
                                return (0, _Favourites.enrichFavouritesResponse)(favourite, user);
                            }));

                        case 5:
                            favourites = _context3.sent;
                            return _context3.abrupt('return', (0, _LinkMapper.resolveAll)(favourites).as(_Favourite2.default));

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function getFavourites(_x7) {
            return _ref3.apply(this, arguments);
        }

        return getFavourites;
    }(),


    /**
     * @param {Favourite} favourite
     * @param {String} photocardNumber
     * @param {User} user
     * @return {Favourite}
     */
    updateFavouritePhotocard: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(favourite, photocardNumber, user) {
            var favouriteId, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            favouriteId = favourite.id;
                            _context4.next = 3;
                            return _AuthenticatedAPIClient2.default.patch('/favourite-ticket/customer/' + user.id + '/one-click/' + favouriteId + '/photocard', {
                                photocard: photocardNumber
                            });

                        case 3:
                            response = _context4.sent;
                            _context4.t0 = _LinkMapper.resolve;
                            _context4.next = 7;
                            return (0, _Favourites.enrichFavouritesResponse)(response, user);

                        case 7:
                            _context4.t1 = _context4.sent;
                            _context4.t2 = _Favourite2.default;
                            return _context4.abrupt('return', (0, _context4.t0)(_context4.t1).as(_context4.t2));

                        case 10:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function updateFavouritePhotocard(_x8, _x9, _x10) {
            return _ref4.apply(this, arguments);
        }

        return updateFavouritePhotocard;
    }(),


    /**
     * @param {Favourite} favourite
     * @param {OrderFulfilment} delivery
     * @param {User} user
     * @return {OrderFulfilment}
     */
    addFavouriteDelivery: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(favourite, delivery, user) {
            var favouriteId, deliveryOption, response, newDelivery, id, fulfilment;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            favouriteId = favourite.id;
                            deliveryOption = delivery.getPruned();
                            _context5.next = 4;
                            return _AuthenticatedAPIClient2.default.post('/favourite-ticket/customer/' + user.id + '/one-click/' + favouriteId + '/delivery', deliveryOption);

                        case 4:
                            response = _context5.sent;
                            _context5.next = 7;
                            return (0, _Favourites.enrichFavouriteDeliveryResponse)(response, user);

                        case 7:
                            newDelivery = _context5.sent;
                            id = response.id;
                            fulfilment = (0, _LinkMapper.resolve)(newDelivery).as(_Fulfilment2.default);
                            return _context5.abrupt('return', {
                                id: id,
                                fulfilment: fulfilment
                            });

                        case 11:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function addFavouriteDelivery(_x11, _x12, _x13) {
            return _ref5.apply(this, arguments);
        }

        return addFavouriteDelivery;
    }(),


    /**
     * @param {Favourite} favourite
     * @param {OrderFulfilment} delivery
     * @param {User} user
     * @return {OrderFulfilment}
     */
    updateFavouriteDelivery: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(favourite, delivery, user) {
            var favouriteId, deliveryId, deliveryOption, response, updatedDelivery;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            favouriteId = favourite.id;
                            deliveryId = favourite.deliveryId;
                            deliveryOption = delivery.getPruned();
                            _context6.next = 5;
                            return _AuthenticatedAPIClient2.default.put('/favourite-ticket/customer/' + user.id + '/one-click/' + favouriteId + '/delivery/' + deliveryId, deliveryOption);

                        case 5:
                            response = _context6.sent;
                            _context6.next = 8;
                            return (0, _Favourites.enrichFavouriteDeliveryResponse)(response, user);

                        case 8:
                            updatedDelivery = _context6.sent;
                            return _context6.abrupt('return', (0, _LinkMapper.resolve)(updatedDelivery).as(_Fulfilment2.default));

                        case 10:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function updateFavouriteDelivery(_x14, _x15, _x16) {
            return _ref6.apply(this, arguments);
        }

        return updateFavouriteDelivery;
    }(),


    /**
     * @param {Favourite} favourite
     * @param {trainTime} seasonExpiryDate
     * @param {User} user
     * @return {Favourite}
     */
    updateFavouriteSeasonExpiryDate: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(favourite, seasonExpiryDate, user) {
            var response;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return _AuthenticatedAPIClient2.default.patch('/favourite-ticket/customer/' + user.id + '/one-click/' + favourite.id + '/season-expiry-date', {
                                date: _TrainTime2.default.isoDate(seasonExpiryDate)
                            });

                        case 2:
                            response = _context7.sent;
                            _context7.t0 = _LinkMapper.resolve;
                            _context7.next = 6;
                            return (0, _Favourites.enrichFavouritesResponse)(response, user);

                        case 6:
                            _context7.t1 = _context7.sent;
                            _context7.t2 = _Favourite2.default;
                            return _context7.abrupt('return', (0, _context7.t0)(_context7.t1).as(_context7.t2));

                        case 9:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function updateFavouriteSeasonExpiryDate(_x17, _x18, _x19) {
            return _ref7.apply(this, arguments);
        }

        return updateFavouriteSeasonExpiryDate;
    }(),


    /**
     * @param {Favourite} favourite
     * @param {trainTime} lastUsedDate
     * @param {User} user
     * @return {Favourite}
     */
    updateFavouriteLastUsedDate: function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(favourite, lastUsedDate, user) {
            var response;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return _AuthenticatedAPIClient2.default.patch('/favourite-ticket/customer/' + user.id + '/one-click/' + favourite.id + '/used-date', {
                                date: _TrainTime2.default.isoDate(lastUsedDate)
                            });

                        case 2:
                            response = _context8.sent;
                            _context8.t0 = _LinkMapper.resolve;
                            _context8.next = 6;
                            return (0, _Favourites.enrichFavouritesResponse)(response, user);

                        case 6:
                            _context8.t1 = _context8.sent;
                            _context8.t2 = _Favourite2.default;
                            return _context8.abrupt('return', (0, _context8.t0)(_context8.t1).as(_context8.t2));

                        case 9:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function updateFavouriteLastUsedDate(_x20, _x21, _x22) {
            return _ref8.apply(this, arguments);
        }

        return updateFavouriteLastUsedDate;
    }()
};

exports.default = FavouritesService;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _Route = __webpack_require__(319);

var _Route2 = _interopRequireDefault(_Route);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataUrl = '/data/routes';
var routeCache = {};

var RouteService = {
    get: function get(code) {
        if (routeCache[code]) {
            return routeCache[code];
        }

        routeCache[code] = _APIClient2.default.get(dataUrl + '/' + code).then(function (response) {
            if (response.result) {
                return (0, _LinkMapper.resolve)((0, _extends3.default)({}, response.result, { id: dataUrl + '/' + code })).as(_Route2.default);
            }
            return new _Route2.default();
        }).catch(function (error) {
            if (error instanceof _APIClient.NotFoundError) {
                return new _Route2.default();
            }
            delete routeCache[code];
            throw error;
        });

        return routeCache[code];
    }
};

exports.default = RouteService;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataUrl = '/data/ticket-types';
var cache = {};

var TicketTypeService = {
    get: function get(code) {
        if (cache[code]) {
            return cache[code];
        }

        cache[code] = _APIClient2.default.get(dataUrl + '/' + code).then(function (response) {
            if (response.result) {
                return (0, _LinkMapper.resolve)((0, _extends3.default)({}, response.result, { id: dataUrl + '/' + code })).as(_TicketType2.default);
            }
            return new _TicketType2.default();
        }).catch(function (error) {
            if (error instanceof _APIClient.NotFoundError) {
                return new _TicketType2.default();
            }
            delete cache[code];
            throw error;
        });

        return cache[code];
    }
};

exports.default = TicketTypeService;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FavouritesModal = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _find2 = __webpack_require__(344);

var _find3 = _interopRequireDefault(_find2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _compose2 = __webpack_require__(612);

var _compose3 = _interopRequireDefault(_compose2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _PropTypes = __webpack_require__(85);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _FavouritesActions = __webpack_require__(422);

var _FavouritesActions2 = _interopRequireDefault(_FavouritesActions);

var _ConfirmationModalActions = __webpack_require__(629);

var _ConfirmationModalActions2 = _interopRequireDefault(_ConfirmationModalActions);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _FavouriteList = __webpack_require__(1967);

var _FavouriteList2 = _interopRequireDefault(_FavouriteList);

var _Calendar = __webpack_require__(975);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _SteppableList = __webpack_require__(1148);

var _SteppableList2 = _interopRequireDefault(_SteppableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        isDesktop: _DimensionsStore2.default.isDesktopWidth()
    };
};

function _getSearchFromFavourite(favourite) {
    return favourite.isSeason() ? _SeasonSearch2.default.fromReorderable(favourite) : _Search2.default.fromReorderable(favourite);
}

var CHOOSE_FAVOURITE_STEP = 'choose-favourite';
var CHOOSE_DATE_STEP = 'choose-date';

var FavouritesModal = exports.FavouritesModal = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FavouritesModal, _React$PureComponent);

    function FavouritesModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FavouritesModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            selectedFavourite: null,
            date: null,
            error: null,
            currentStep: 1
        }, _this.selectFavourite = function (favourite) {
            _this.setState({
                selectedFavourite: favourite,
                date: null,
                error: null
            });
            _this.nextStep();
        }, _this.deleteFavourite = function (favourite) {
            _ConfirmationModalActions2.default.open(function () {
                return _FavouritesActions2.default.remove(favourite, _this.props.user);
            }, 'confirmation-modal.delete-item', { icon: 'bin' });
        }, _this.handleDateChange = function (date) {
            _this.setState({ date: date, error: null });
        }, _this.nextStep = function () {
            var step = _this.getCurrentStep();
            var nextStep = step.nextStep();

            _this.moveToStep(nextStep);
            step.nextAction();
        }, _this.onBack = function () {
            var step = _this.getCurrentStep();

            if (step.number - 1 <= 1) {
                _this.setState({
                    selectedFavourite: null,
                    error: null,
                    currentStep: 1
                });
            } else {
                _this.setState({
                    currentStep: _this.state.currentStep - 1
                });
            }
        }, _this.renderFavourites = function () {
            if (_this.state.selectedFavourite) {
                return null;
            }

            return _react2.default.createElement(_FavouriteList2.default, { favourites: _this.props.favourites, onSelect: _this.selectFavourite, onDelete: _this.deleteFavourite });
        }, _this.renderCalendar = function () {
            var _this$state = _this.state,
                selectedFavourite = _this$state.selectedFavourite,
                date = _this$state.date;

            var search = selectedFavourite ? _getSearchFromFavourite(selectedFavourite) : null;

            return _react2.default.createElement(_Calendar2.default, { tabIndex: '0',
                selected: date,
                onChange: _this.handleDateChange,
                min: search.getMinDate(),
                max: search.getMaxDate() });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    FavouritesModal.prototype.steps = function steps() {
        var _this2 = this;

        return [{
            number: 1,
            name: CHOOSE_FAVOURITE_STEP,
            title: 'favourites.modal.step1Title',
            element: this.renderFavourites,
            nextAction: _noop3.default,
            nextStep: function nextStep() {
                return CHOOSE_DATE_STEP;
            }
        }, {
            number: 2,
            name: CHOOSE_DATE_STEP,
            title: 'favourites.modal.step2Title',
            element: this.renderCalendar,
            continueTitle: 'favourites.modal.reorder',
            nextDisabled: function nextDisabled(state) {
                return !state.date;
            },
            nextStep: function nextStep() {
                return null;
            },
            nextAction: function nextAction() {
                var _props = _this2.props,
                    router = _props.router,
                    onCancel = _props.onCancel;
                var _state = _this2.state,
                    selectedFavourite = _state.selectedFavourite,
                    date = _state.date;

                var pathname = _AppConstants.HandOffPages.FARE;
                var query = {
                    reorder: selectedFavourite.id,
                    startDate: date.format('YYYY-MM-DD'),
                    useDeliveryPreference: true
                };
                router.push(_urls2.default.location(pathname, null, query));
                onCancel();
            }
        }];
    };

    FavouritesModal.prototype.getCurrentStep = function getCurrentStep() {
        return (0, _find3.default)(this.steps(), ['number', this.state.currentStep]);
    };

    FavouritesModal.prototype.moveToStep = function moveToStep(name) {
        var targetStep = (0, _find3.default)(this.steps(), ['name', name]);

        if (targetStep) {
            this.setState({
                currentStep: targetStep.number
            });
        }
    };

    FavouritesModal.prototype.renderFooter = function renderFooter() {
        var _props2 = this.props,
            onCancel = _props2.onCancel,
            isDesktop = _props2.isDesktop;

        var step = this.getCurrentStep();

        if (!step || step.number > this.steps().length || step.number === 1 && !isDesktop) {
            return null;
        }

        return _react2.default.createElement(
            'div',
            null,
            isDesktop && _react2.default.createElement(
                _Button2.default,
                {
                    bsStyle: 'default',
                    onClick: onCancel,
                    className: 'close action-btn action-btn--secondary pull-left'
                },
                (0, _I18n2.default)('button.text.close')
            ),
            _react2.default.createElement(
                'span',
                { className: 'pull-right' },
                step.number > 1 && step.number <= this.steps().length && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        _Button2.default,
                        {
                            bsStyle: 'default',
                            onClick: this.onBack,
                            className: 'btn-md btn-primary previous'
                        },
                        (0, _I18n2.default)('global.back')
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        {
                            bsStyle: 'default',
                            onClick: this.nextStep,
                            className: 'btn-md btn-primary continue',
                            disabled: step.nextDisabled(this.state)
                        },
                        (0, _I18n2.default)(step.continueTitle)
                    )
                )
            )
        );
    };

    FavouritesModal.prototype.render = function render() {
        var _state2 = this.state,
            error = _state2.error,
            currentStep = _state2.currentStep;


        var modalProps = {
            titleText: 'favourites.modal.title',
            className: 'modal--xs',
            show: true,
            footer: this.renderFooter(),
            hideContinue: !this.props.isDesktop && currentStep === 1,
            onClose: this.props.onCancel
        };

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            error && _react2.default.createElement(
                _BAlert2.default,
                { className: 'margin-bottom--sm', type: 'danger' },
                (0, _I18n2.default)('favourites.modal.error.' + error.name)
            ),
            _react2.default.createElement(_SteppableList2.default, { steps: this.steps(),
                currentStep: currentStep })
        );
    };

    return FavouritesModal;
}(_react2.default.PureComponent), _class.propTypes = {
    favourites: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    onCancel: _propTypes2.default.func,
    router: _PropTypes.routerShape,
    isDesktop: _propTypes2.default.bool
}, _class.defaultProps = {
    favourites: new _immutable.List(),
    onCancel: _noop3.default,
    isDesktop: true
}, _temp2);
exports.default = (0, _compose3.default)(_withRouter2.default, (0, _connectToStores2.default)([_DimensionsStore2.default], _getStateFromStores))(FavouritesModal);

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(55);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(631));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(1963));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(606));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(602));

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(Lifecycle, _Component);

      function Lifecycle() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = Lifecycle.prototype;

      _proto.render = function render() {
        return factory((0, _extends2.default)({}, this.props, this.state));
      };

      return Lifecycle;
    }(_react.Component);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'lifecycle'))(Lifecycle);
    }

    return Lifecycle;
  };
};

var _default = lifecycle;
exports.default = _default;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1964);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _wrapDisplayName2 = __webpack_require__(602);

var _wrapDisplayName3 = _interopRequireDefault(_wrapDisplayName2);

var _setDisplayName2 = __webpack_require__(606);

var _setDisplayName3 = _interopRequireDefault(_setDisplayName2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (name) {
  return function (BaseComponent) {
    return (0, _setDisplayName3.default)((0, _wrapDisplayName3.default)(BaseComponent, name))(BaseComponent);
  };
};

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

exports.default = FavouriteList;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _FavouriteListItem = __webpack_require__(1968);

var _FavouriteListItem2 = _interopRequireDefault(_FavouriteListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FavouriteList(_ref) {
    var favourites = _ref.favourites,
        onSelect = _ref.onSelect,
        onDelete = _ref.onDelete;


    return _react2.default.createElement(
        'ul',
        { className: 'favourite-list' },
        favourites.map(function (favourite) {
            return _react2.default.createElement(_FavouriteListItem2.default, { key: favourite.id, favourite: favourite, onSelect: onSelect, onDelete: onDelete });
        })
    );
}

FavouriteList.propTypes = {
    favourites: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    onSelect: _propTypes2.default.func,
    onDelete: _propTypes2.default.func
};

FavouriteList.defaultProps = {
    favourites: new _immutable.List(),
    onSelect: _noop3.default,
    onDelete: _noop3.default
};

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

exports.default = FavouriteListItem;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _FavouriteDetails = __webpack_require__(1147);

var _FavouriteDetails2 = _interopRequireDefault(_FavouriteDetails);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FavouriteListItem(_ref) {
    var favourite = _ref.favourite,
        onSelect = _ref.onSelect,
        onDelete = _ref.onDelete;

    var selectFavourite = function selectFavourite() {
        return onSelect(favourite);
    };
    var deleteFavourite = function deleteFavourite() {
        return onDelete(favourite);
    };

    var permitChanges = _FeatureFlagStore2.default.get('enableFavouriteTicketChanges');
    var descriptionClasses = (0, _classnames2.default)('favourite-list__item__description', {
        'favourite-list__item__description--full-width': !permitChanges
    });

    return _react2.default.createElement(
        'li',
        { className: 'favourite-list__item' },
        _react2.default.createElement(
            _OnEnterTrigger2.default,
            { className: descriptionClasses, title: (0, _I18n2.default)('button.text.select'), tabIndex: '0', role: 'button', onClick: selectFavourite },
            _react2.default.createElement(_FavouriteDetails2.default, { favourite: favourite })
        ),
        permitChanges && _react2.default.createElement(_OnEnterTrigger2.default, { className: 'favourite-list__item__action', title: (0, _I18n2.default)('button.text.delete'), tabIndex: '0', role: 'button', onClick: deleteFavourite })
    );
}

FavouriteListItem.propTypes = {
    favourite: _propTypes2.default.instanceOf(_Favourite2.default).isRequired,
    onSelect: _propTypes2.default.func,
    onDelete: _propTypes2.default.func
};

FavouriteListItem.defaultProps = {
    onSelect: _noop3.default,
    onDelete: _noop3.default
};

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _toStringTag = __webpack_require__(1970);

var _toStringTag2 = _interopRequireDefault(_toStringTag);

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _setPrototypeOf = __webpack_require__(741);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(165);

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = __webpack_require__(393);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty = __webpack_require__(313);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getIterator2 = __webpack_require__(287);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _isIterable2 = __webpack_require__(810);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _symbol = __webpack_require__(286);

var _symbol2 = _interopRequireDefault(_symbol);

var _from = __webpack_require__(285);

var _from2 = _interopRequireDefault(_from);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*! For license information please see otrl-ui.bundle.js.LICENSE.txt */
!function (e, t) {
  "object" == ( false ? "undefined" : (0, _typeof3.default)(exports)) && "object" == ( false ? "undefined" : (0, _typeof3.default)(module)) ? module.exports = t(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? exports.otrlUI = t(require("react")) : e.otrlUI = t(e.React);
}(global, function (e) {
  return function () {
    var t = { 258: function _(e, t, r) {
        "use strict";
        r.r(t), r.d(t, { DatePicker: function DatePicker() {
            return ke;
          }, DateTimeTitle: function DateTimeTitle() {
            return Le;
          }, ModalDatePicker: function ModalDatePicker() {
            return st;
          } });var n = r(698),
            a = r.n(n),
            o = r(184),
            i = r.n(o),
            s = r(737);function u(e, t) {
          if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
        }function l(e) {
          u(1, arguments);var t = Object.prototype.toString.call(e);return e instanceof Date || "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && "[object Date]" === t ? new Date(e.getTime()) : "number" == typeof e || "[object Number]" === t ? new Date(e) : ("string" != typeof e && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
        }function c(e) {
          u(1, arguments);var t = l(e),
              r = t.getFullYear();return r;
        }function d(e) {
          u(1, arguments);var t = l(e);return !isNaN(t);
        }var f = { lessThanXSeconds: { one: "less than a second", other: "less than {{count}} seconds" }, xSeconds: { one: "1 second", other: "{{count}} seconds" }, halfAMinute: "half a minute", lessThanXMinutes: { one: "less than a minute", other: "less than {{count}} minutes" }, xMinutes: { one: "1 minute", other: "{{count}} minutes" }, aboutXHours: { one: "about 1 hour", other: "about {{count}} hours" }, xHours: { one: "1 hour", other: "{{count}} hours" }, xDays: { one: "1 day", other: "{{count}} days" }, aboutXWeeks: { one: "about 1 week", other: "about {{count}} weeks" }, xWeeks: { one: "1 week", other: "{{count}} weeks" }, aboutXMonths: { one: "about 1 month", other: "about {{count}} months" }, xMonths: { one: "1 month", other: "{{count}} months" }, aboutXYears: { one: "about 1 year", other: "about {{count}} years" }, xYears: { one: "1 year", other: "{{count}} years" }, overXYears: { one: "over 1 year", other: "over {{count}} years" }, almostXYears: { one: "almost 1 year", other: "almost {{count}} years" } };function h(e) {
          return function (t) {
            var r = t || {},
                n = r.width ? String(r.width) : e.defaultWidth;return e.formats[n] || e.formats[e.defaultWidth];
          };
        }var p,
            m = { date: h({ formats: { full: "EEEE, MMMM do, y", long: "MMMM do, y", medium: "MMM d, y", short: "MM/dd/yyyy" }, defaultWidth: "full" }), time: h({ formats: { full: "h:mm:ss a zzzz", long: "h:mm:ss a z", medium: "h:mm:ss a", short: "h:mm a" }, defaultWidth: "full" }), dateTime: h({ formats: { full: "{{date}} 'at' {{time}}", long: "{{date}} 'at' {{time}}", medium: "{{date}}, {{time}}", short: "{{date}}, {{time}}" }, defaultWidth: "full" }) },
            y = { lastWeek: "'last' eeee 'at' p", yesterday: "'yesterday at' p", today: "'today at' p", tomorrow: "'tomorrow at' p", nextWeek: "eeee 'at' p", other: "P" };function g(e) {
          return function (t, r) {
            var n,
                a = r || {};if ("formatting" === (a.context ? String(a.context) : "standalone") && e.formattingValues) {
              var o = e.defaultFormattingWidth || e.defaultWidth,
                  i = a.width ? String(a.width) : o;n = e.formattingValues[i] || e.formattingValues[o];
            } else {
              var s = e.defaultWidth,
                  u = a.width ? String(a.width) : e.defaultWidth;n = e.values[u] || e.values[s];
            }return n[e.argumentCallback ? e.argumentCallback(t) : t];
          };
        }function b(e) {
          return function (t, r) {
            var n = String(t),
                a = r || {},
                o = a.width,
                i = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth],
                s = n.match(i);if (!s) return null;var u,
                l = s[0],
                c = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth];return u = "[object Array]" === Object.prototype.toString.call(c) ? function (e, t) {
              for (var r = 0; r < e.length; r++) {
                if (e[r].test(l)) return r;
              }
            }(c) : function (e, t) {
              for (var r in e) {
                if (e.hasOwnProperty(r) && e[r].test(l)) return r;
              }
            }(c), u = e.valueCallback ? e.valueCallback(u) : u, { value: u = a.valueCallback ? a.valueCallback(u) : u, rest: n.slice(l.length) };
          };
        }var v = { code: "en-US", formatDistance: function formatDistance(e, t, r) {
            var n;return r = r || {}, n = "string" == typeof f[e] ? f[e] : 1 === t ? f[e].one : f[e].other.replace("{{count}}", t), r.addSuffix ? r.comparison > 0 ? "in " + n : n + " ago" : n;
          }, formatLong: m, formatRelative: function formatRelative(e, t, r, n) {
            return y[e];
          }, localize: { ordinalNumber: function ordinalNumber(e, t) {
              var r = Number(e),
                  n = r % 100;if (n > 20 || n < 10) switch (n % 10) {case 1:
                  return r + "st";case 2:
                  return r + "nd";case 3:
                  return r + "rd";}return r + "th";
            }, era: g({ values: { narrow: ["B", "A"], abbreviated: ["BC", "AD"], wide: ["Before Christ", "Anno Domini"] }, defaultWidth: "wide" }), quarter: g({ values: { narrow: ["1", "2", "3", "4"], abbreviated: ["Q1", "Q2", "Q3", "Q4"], wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"] }, defaultWidth: "wide", argumentCallback: function argumentCallback(e) {
                return Number(e) - 1;
              } }), month: g({ values: { narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"], abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] }, defaultWidth: "wide" }), day: g({ values: { narrow: ["S", "M", "T", "W", "T", "F", "S"], short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] }, defaultWidth: "wide" }), dayPeriod: g({ values: { narrow: { am: "a", pm: "p", midnight: "mi", noon: "n", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" }, abbreviated: { am: "AM", pm: "PM", midnight: "midnight", noon: "noon", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" }, wide: { am: "a.m.", pm: "p.m.", midnight: "midnight", noon: "noon", morning: "morning", afternoon: "afternoon", evening: "evening", night: "night" } }, defaultWidth: "wide", formattingValues: { narrow: { am: "a", pm: "p", midnight: "mi", noon: "n", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" }, abbreviated: { am: "AM", pm: "PM", midnight: "midnight", noon: "noon", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" }, wide: { am: "a.m.", pm: "p.m.", midnight: "midnight", noon: "noon", morning: "in the morning", afternoon: "in the afternoon", evening: "in the evening", night: "at night" } }, defaultFormattingWidth: "wide" }) }, match: { ordinalNumber: (p = { matchPattern: /^(\d+)(th|st|nd|rd)?/i, parsePattern: /\d+/i, valueCallback: function valueCallback(e) {
                return parseInt(e, 10);
              } }, function (e, t) {
              var r = String(e),
                  n = t || {},
                  a = r.match(p.matchPattern);if (!a) return null;var o = a[0],
                  i = r.match(p.parsePattern);if (!i) return null;var s = p.valueCallback ? p.valueCallback(i[0]) : i[0];return { value: s = n.valueCallback ? n.valueCallback(s) : s, rest: r.slice(o.length) };
            }), era: b({ matchPatterns: { narrow: /^(b|a)/i, abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i, wide: /^(before christ|before common era|anno domini|common era)/i }, defaultMatchWidth: "wide", parsePatterns: { any: [/^b/i, /^(a|c)/i] }, defaultParseWidth: "any" }), quarter: b({ matchPatterns: { narrow: /^[1234]/i, abbreviated: /^q[1234]/i, wide: /^[1234](th|st|nd|rd)? quarter/i }, defaultMatchWidth: "wide", parsePatterns: { any: [/1/i, /2/i, /3/i, /4/i] }, defaultParseWidth: "any", valueCallback: function valueCallback(e) {
                return e + 1;
              } }), month: b({ matchPatterns: { narrow: /^[jfmasond]/i, abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i, wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i }, defaultMatchWidth: "wide", parsePatterns: { narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i], any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i] }, defaultParseWidth: "any" }), day: b({ matchPatterns: { narrow: /^[smtwf]/i, short: /^(su|mo|tu|we|th|fr|sa)/i, abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i, wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i }, defaultMatchWidth: "wide", parsePatterns: { narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i], any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i] }, defaultParseWidth: "any" }), dayPeriod: b({ matchPatterns: { narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i, any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i }, defaultMatchWidth: "any", parsePatterns: { any: { am: /^a/i, pm: /^p/i, midnight: /^mi/i, noon: /^no/i, morning: /morning/i, afternoon: /afternoon/i, evening: /evening/i, night: /night/i } }, defaultParseWidth: "any" }) }, options: { weekStartsOn: 0, firstWeekContainsDate: 1 } };function w(e) {
          if (null === e || !0 === e || !1 === e) return NaN;var t = Number(e);return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
        }function k(e, t) {
          u(2, arguments);var r = l(e).getTime(),
              n = w(t);return new Date(r + n);
        }function _(e, t) {
          u(2, arguments);var r = w(t);return k(e, -r);
        }function _D(e, t) {
          for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t;) {
            n = "0" + n;
          }return r + n;
        }var M = function M(e, t) {
          var r = e.getUTCFullYear(),
              n = r > 0 ? r : 1 - r;return _D("yy" === t ? n % 100 : n, t.length);
        },
            x = function x(e, t) {
          var r = e.getUTCMonth();return "M" === t ? String(r + 1) : _D(r + 1, 2);
        },
            P = function P(e, t) {
          return _D(e.getUTCDate(), t.length);
        },
            O = function O(e, t) {
          return _D(e.getUTCHours() % 12 || 12, t.length);
        },
            N = function N(e, t) {
          return _D(e.getUTCHours(), t.length);
        },
            T = function T(e, t) {
          return _D(e.getUTCMinutes(), t.length);
        },
            C = function C(e, t) {
          return _D(e.getUTCSeconds(), t.length);
        },
            E = function E(e, t) {
          var r = t.length,
              n = e.getUTCMilliseconds();return _D(Math.floor(n * Math.pow(10, r - 3)), t.length);
        };var S = 864e5;function j(e) {
          u(1, arguments);var t = 1,
              r = l(e),
              n = r.getUTCDay(),
              a = (n < t ? 7 : 0) + n - t;return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
        }function W(e) {
          u(1, arguments);var t = l(e),
              r = t.getUTCFullYear(),
              n = new Date(0);n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);var a = j(n),
              o = new Date(0);o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);var i = j(o);return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= i.getTime() ? r : r - 1;
        }function U(e) {
          u(1, arguments);var t = W(e),
              r = new Date(0);r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);var n = j(r);return n;
        }var A = 6048e5;function B(e, t) {
          u(1, arguments);var r = t || {},
              n = r.locale,
              a = n && n.options && n.options.weekStartsOn,
              o = null == a ? 0 : w(a),
              i = null == r.weekStartsOn ? o : w(r.weekStartsOn);if (!(i >= 0 && i <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var s = l(e),
              c = s.getUTCDay(),
              d = (c < i ? 7 : 0) + c - i;return s.setUTCDate(s.getUTCDate() - d), s.setUTCHours(0, 0, 0, 0), s;
        }function R(e, t) {
          u(1, arguments);var r = l(e, t),
              n = r.getUTCFullYear(),
              a = t || {},
              o = a.locale,
              i = o && o.options && o.options.firstWeekContainsDate,
              s = null == i ? 1 : w(i),
              c = null == a.firstWeekContainsDate ? s : w(a.firstWeekContainsDate);if (!(c >= 1 && c <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var d = new Date(0);d.setUTCFullYear(n + 1, 0, c), d.setUTCHours(0, 0, 0, 0);var f = B(d, t),
              h = new Date(0);h.setUTCFullYear(n, 0, c), h.setUTCHours(0, 0, 0, 0);var p = B(h, t);return r.getTime() >= f.getTime() ? n + 1 : r.getTime() >= p.getTime() ? n : n - 1;
        }function F(e, t) {
          u(1, arguments);var r = t || {},
              n = r.locale,
              a = n && n.options && n.options.firstWeekContainsDate,
              o = null == a ? 1 : w(a),
              i = null == r.firstWeekContainsDate ? o : w(r.firstWeekContainsDate),
              s = R(e, t),
              l = new Date(0);l.setUTCFullYear(s, 0, i), l.setUTCHours(0, 0, 0, 0);var c = B(l, t);return c;
        }var q = 6048e5;function Y(e, t) {
          var r = e > 0 ? "-" : "+",
              n = Math.abs(e),
              a = Math.floor(n / 60),
              o = n % 60;if (0 === o) return r + String(a);var i = t || "";return r + String(a) + i + _D(o, 2);
        }function I(e, t) {
          return e % 60 == 0 ? (e > 0 ? "-" : "+") + _D(Math.abs(e) / 60, 2) : L(e, t);
        }function L(e, t) {
          var r = t || "",
              n = e > 0 ? "-" : "+",
              a = Math.abs(e);return n + _D(Math.floor(a / 60), 2) + r + _D(a % 60, 2);
        }var z = { G: function G(e, t, r) {
            var n = e.getUTCFullYear() > 0 ? 1 : 0;switch (t) {case "G":case "GG":case "GGG":
                return r.era(n, { width: "abbreviated" });case "GGGGG":
                return r.era(n, { width: "narrow" });case "GGGG":default:
                return r.era(n, { width: "wide" });}
          }, y: function y(e, t, r) {
            if ("yo" === t) {
              var n = e.getUTCFullYear(),
                  a = n > 0 ? n : 1 - n;return r.ordinalNumber(a, { unit: "year" });
            }return M(e, t);
          }, Y: function Y(e, t, r, n) {
            var a = R(e, n),
                o = a > 0 ? a : 1 - a;return "YY" === t ? _D(o % 100, 2) : "Yo" === t ? r.ordinalNumber(o, { unit: "year" }) : _D(o, t.length);
          }, R: function R(e, t) {
            return _D(W(e), t.length);
          }, u: function u(e, t) {
            return _D(e.getUTCFullYear(), t.length);
          }, Q: function Q(e, t, r) {
            var n = Math.ceil((e.getUTCMonth() + 1) / 3);switch (t) {case "Q":
                return String(n);case "QQ":
                return _D(n, 2);case "Qo":
                return r.ordinalNumber(n, { unit: "quarter" });case "QQQ":
                return r.quarter(n, { width: "abbreviated", context: "formatting" });case "QQQQQ":
                return r.quarter(n, { width: "narrow", context: "formatting" });case "QQQQ":default:
                return r.quarter(n, { width: "wide", context: "formatting" });}
          }, q: function q(e, t, r) {
            var n = Math.ceil((e.getUTCMonth() + 1) / 3);switch (t) {case "q":
                return String(n);case "qq":
                return _D(n, 2);case "qo":
                return r.ordinalNumber(n, { unit: "quarter" });case "qqq":
                return r.quarter(n, { width: "abbreviated", context: "standalone" });case "qqqqq":
                return r.quarter(n, { width: "narrow", context: "standalone" });case "qqqq":default:
                return r.quarter(n, { width: "wide", context: "standalone" });}
          }, M: function M(e, t, r) {
            var n = e.getUTCMonth();switch (t) {case "M":case "MM":
                return x(e, t);case "Mo":
                return r.ordinalNumber(n + 1, { unit: "month" });case "MMM":
                return r.month(n, { width: "abbreviated", context: "formatting" });case "MMMMM":
                return r.month(n, { width: "narrow", context: "formatting" });case "MMMM":default:
                return r.month(n, { width: "wide", context: "formatting" });}
          }, L: function L(e, t, r) {
            var n = e.getUTCMonth();switch (t) {case "L":
                return String(n + 1);case "LL":
                return _D(n + 1, 2);case "Lo":
                return r.ordinalNumber(n + 1, { unit: "month" });case "LLL":
                return r.month(n, { width: "abbreviated", context: "standalone" });case "LLLLL":
                return r.month(n, { width: "narrow", context: "standalone" });case "LLLL":default:
                return r.month(n, { width: "wide", context: "standalone" });}
          }, w: function w(e, t, r, n) {
            var a = function (e, t) {
              u(1, arguments);var r = l(e),
                  n = B(r, t).getTime() - F(r, t).getTime();return Math.round(n / q) + 1;
            }(e, n);return "wo" === t ? r.ordinalNumber(a, { unit: "week" }) : _D(a, t.length);
          }, I: function I(e, t, r) {
            var n = function (e) {
              u(1, arguments);var t = l(e),
                  r = j(t).getTime() - U(t).getTime();return Math.round(r / A) + 1;
            }(e);return "Io" === t ? r.ordinalNumber(n, { unit: "week" }) : _D(n, t.length);
          }, d: function d(e, t, r) {
            return "do" === t ? r.ordinalNumber(e.getUTCDate(), { unit: "date" }) : P(e, t);
          }, D: function D(e, t, r) {
            var n = function (e) {
              u(1, arguments);var t = l(e),
                  r = t.getTime();t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);var n = t.getTime(),
                  a = r - n;return Math.floor(a / S) + 1;
            }(e);return "Do" === t ? r.ordinalNumber(n, { unit: "dayOfYear" }) : _D(n, t.length);
          }, E: function E(e, t, r) {
            var n = e.getUTCDay();switch (t) {case "E":case "EE":case "EEE":
                return r.day(n, { width: "abbreviated", context: "formatting" });case "EEEEE":
                return r.day(n, { width: "narrow", context: "formatting" });case "EEEEEE":
                return r.day(n, { width: "short", context: "formatting" });case "EEEE":default:
                return r.day(n, { width: "wide", context: "formatting" });}
          }, e: function e(_e2, t, r, n) {
            var a = _e2.getUTCDay(),
                o = (a - n.weekStartsOn + 8) % 7 || 7;switch (t) {case "e":
                return String(o);case "ee":
                return _D(o, 2);case "eo":
                return r.ordinalNumber(o, { unit: "day" });case "eee":
                return r.day(a, { width: "abbreviated", context: "formatting" });case "eeeee":
                return r.day(a, { width: "narrow", context: "formatting" });case "eeeeee":
                return r.day(a, { width: "short", context: "formatting" });case "eeee":default:
                return r.day(a, { width: "wide", context: "formatting" });}
          }, c: function c(e, t, r, n) {
            var a = e.getUTCDay(),
                o = (a - n.weekStartsOn + 8) % 7 || 7;switch (t) {case "c":
                return String(o);case "cc":
                return _D(o, t.length);case "co":
                return r.ordinalNumber(o, { unit: "day" });case "ccc":
                return r.day(a, { width: "abbreviated", context: "standalone" });case "ccccc":
                return r.day(a, { width: "narrow", context: "standalone" });case "cccccc":
                return r.day(a, { width: "short", context: "standalone" });case "cccc":default:
                return r.day(a, { width: "wide", context: "standalone" });}
          }, i: function i(e, t, r) {
            var n = e.getUTCDay(),
                a = 0 === n ? 7 : n;switch (t) {case "i":
                return String(a);case "ii":
                return _D(a, t.length);case "io":
                return r.ordinalNumber(a, { unit: "day" });case "iii":
                return r.day(n, { width: "abbreviated", context: "formatting" });case "iiiii":
                return r.day(n, { width: "narrow", context: "formatting" });case "iiiiii":
                return r.day(n, { width: "short", context: "formatting" });case "iiii":default:
                return r.day(n, { width: "wide", context: "formatting" });}
          }, a: function a(e, t, r) {
            var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";switch (t) {case "a":case "aa":case "aaa":
                return r.dayPeriod(n, { width: "abbreviated", context: "formatting" });case "aaaaa":
                return r.dayPeriod(n, { width: "narrow", context: "formatting" });case "aaaa":default:
                return r.dayPeriod(n, { width: "wide", context: "formatting" });}
          }, b: function b(e, t, r) {
            var n,
                a = e.getUTCHours();switch (n = 12 === a ? "noon" : 0 === a ? "midnight" : a / 12 >= 1 ? "pm" : "am", t) {case "b":case "bb":case "bbb":
                return r.dayPeriod(n, { width: "abbreviated", context: "formatting" });case "bbbbb":
                return r.dayPeriod(n, { width: "narrow", context: "formatting" });case "bbbb":default:
                return r.dayPeriod(n, { width: "wide", context: "formatting" });}
          }, B: function B(e, t, r) {
            var n,
                a = e.getUTCHours();switch (n = a >= 17 ? "evening" : a >= 12 ? "afternoon" : a >= 4 ? "morning" : "night", t) {case "B":case "BB":case "BBB":
                return r.dayPeriod(n, { width: "abbreviated", context: "formatting" });case "BBBBB":
                return r.dayPeriod(n, { width: "narrow", context: "formatting" });case "BBBB":default:
                return r.dayPeriod(n, { width: "wide", context: "formatting" });}
          }, h: function h(e, t, r) {
            if ("ho" === t) {
              var n = e.getUTCHours() % 12;return 0 === n && (n = 12), r.ordinalNumber(n, { unit: "hour" });
            }return O(e, t);
          }, H: function H(e, t, r) {
            return "Ho" === t ? r.ordinalNumber(e.getUTCHours(), { unit: "hour" }) : N(e, t);
          }, K: function K(e, t, r) {
            var n = e.getUTCHours() % 12;return "Ko" === t ? r.ordinalNumber(n, { unit: "hour" }) : _D(n, t.length);
          }, k: function k(e, t, r) {
            var n = e.getUTCHours();return 0 === n && (n = 24), "ko" === t ? r.ordinalNumber(n, { unit: "hour" }) : _D(n, t.length);
          }, m: function m(e, t, r) {
            return "mo" === t ? r.ordinalNumber(e.getUTCMinutes(), { unit: "minute" }) : T(e, t);
          }, s: function s(e, t, r) {
            return "so" === t ? r.ordinalNumber(e.getUTCSeconds(), { unit: "second" }) : C(e, t);
          }, S: function S(e, t) {
            return E(e, t);
          }, X: function X(e, t, r, n) {
            var a = (n._originalDate || e).getTimezoneOffset();if (0 === a) return "Z";switch (t) {case "X":
                return I(a);case "XXXX":case "XX":
                return L(a);case "XXXXX":case "XXX":default:
                return L(a, ":");}
          }, x: function x(e, t, r, n) {
            var a = (n._originalDate || e).getTimezoneOffset();switch (t) {case "x":
                return I(a);case "xxxx":case "xx":
                return L(a);case "xxxxx":case "xxx":default:
                return L(a, ":");}
          }, O: function O(e, t, r, n) {
            var a = (n._originalDate || e).getTimezoneOffset();switch (t) {case "O":case "OO":case "OOO":
                return "GMT" + Y(a, ":");case "OOOO":default:
                return "GMT" + L(a, ":");}
          }, z: function z(e, t, r, n) {
            var a = (n._originalDate || e).getTimezoneOffset();switch (t) {case "z":case "zz":case "zzz":
                return "GMT" + Y(a, ":");case "zzzz":default:
                return "GMT" + L(a, ":");}
          }, t: function t(e, _t, r, n) {
            var a = n._originalDate || e;return _D(Math.floor(a.getTime() / 1e3), _t.length);
          }, T: function T(e, t, r, n) {
            return _D((n._originalDate || e).getTime(), t.length);
          } };function K(e, t) {
          switch (e) {case "P":
              return t.date({ width: "short" });case "PP":
              return t.date({ width: "medium" });case "PPP":
              return t.date({ width: "long" });case "PPPP":default:
              return t.date({ width: "full" });}
        }function H(e, t) {
          switch (e) {case "p":
              return t.time({ width: "short" });case "pp":
              return t.time({ width: "medium" });case "ppp":
              return t.time({ width: "long" });case "pppp":default:
              return t.time({ width: "full" });}
        }var Q = { p: H, P: function P(e, t) {
            var r,
                n = e.match(/(P+)(p+)?/),
                a = n[1],
                o = n[2];if (!o) return K(e, t);switch (a) {case "P":
                r = t.dateTime({ width: "short" });break;case "PP":
                r = t.dateTime({ width: "medium" });break;case "PPP":
                r = t.dateTime({ width: "long" });break;case "PPPP":default:
                r = t.dateTime({ width: "full" });}return r.replace("{{date}}", K(a, t)).replace("{{time}}", H(o, t));
          } };var X = 6e4;function V(e) {
          return e.getTime() % X;
        }function G(e) {
          var t = new Date(e.getTime()),
              r = Math.ceil(t.getTimezoneOffset());t.setSeconds(0, 0);var n = r > 0 ? (X + V(t)) % X : V(t);return r * X + n;
        }var Z = ["D", "DD"],
            J = ["YY", "YYYY"];function $(e) {
          return -1 !== Z.indexOf(e);
        }function ee(e) {
          return -1 !== J.indexOf(e);
        }function te(e) {
          if ("YYYY" === e) throw new RangeError("Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr");if ("YY" === e) throw new RangeError("Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr");if ("D" === e) throw new RangeError("Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr");if ("DD" === e) throw new RangeError("Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr");
        }var re = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
            ne = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
            ae = /^'([^]*?)'?$/,
            oe = /''/g,
            ie = /[a-zA-Z]/;function se(e, t, r) {
          u(2, arguments);var n = String(t),
              a = r || {},
              o = a.locale || v,
              i = o.options && o.options.firstWeekContainsDate,
              s = null == i ? 1 : w(i),
              c = null == a.firstWeekContainsDate ? s : w(a.firstWeekContainsDate);if (!(c >= 1 && c <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var f = o.options && o.options.weekStartsOn,
              h = null == f ? 0 : w(f),
              p = null == a.weekStartsOn ? h : w(a.weekStartsOn);if (!(p >= 0 && p <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");if (!o.localize) throw new RangeError("locale must contain localize property");if (!o.formatLong) throw new RangeError("locale must contain formatLong property");var m = l(e);if (!d(m)) throw new RangeError("Invalid time value");var y = G(m),
              g = _(m, y),
              b = { firstWeekContainsDate: c, weekStartsOn: p, locale: o, _originalDate: m },
              k = n.match(ne).map(function (e) {
            var t = e[0];return "p" === t || "P" === t ? (0, Q[t])(e, o.formatLong, b) : e;
          }).join("").match(re).map(function (e) {
            if ("''" === e) return "'";var t = e[0];if ("'" === t) return ue(e);var r = z[t];if (r) return !a.useAdditionalWeekYearTokens && ee(e) && te(e), !a.useAdditionalDayOfYearTokens && $(e) && te(e), r(g, e, o.localize, b);if (t.match(ie)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");return e;
          }).join("");return k;
        }function ue(e) {
          return e.match(ae)[1].replace(oe, "'");
        }var le = function le() {};function ce() {
          return (ce = _assign2.default || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }return e;
          }).apply(this, arguments);
        }var de = function de(e) {
          return n.createElement("svg", ce({ width: 7, height: 12, xmlns: "http://www.w3.org/2000/svg" }, e), n.createElement("path", { fill: "#6D7278", d: "M0 1.41L1.332 0 7 6l-5.668 6L0 10.59 4.327 6z", fillRule: "evenodd" }));
        };var fe = r(379),
            he = r.n(fe),
            pe = r(976),
            me = { injectType: "singletonStyleTag", attributes: { "data-id": "otrlUICSS" }, insert: "head", singleton: !0 };he()(pe.Z, me), pe.Z.locals;var ye = r(592),
            ge = { injectType: "singletonStyleTag", attributes: { "data-id": "otrlUICSS" }, insert: "head", singleton: !0 };function be() {
          return (be = _assign2.default || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }return e;
          }).apply(this, arguments);
        }he()(ye.Z, ge), ye.Z.locals;var ve = ["S", "M", "T", "W", "T", "F", "S"],
            we = function we(_ref) {
          var e = _ref.onPreviousClick,
              t = _ref.onNextClick;
          var r = function r(e) {
            "ArrowUp" !== e.key && "ArrowDown" !== e.key || (e.preventDefault(), e.stopPropagation());
          };return a().createElement("div", { className: "otrl-ui__date-picker__month-selector" }, a().createElement("button", { className: "otrl-ui__date-picker__month-selector__button otrl-ui__date-picker__month-selector__button--prev", onClick: function onClick() {
              return e();
            }, onKeyDown: r, tabIndex: "-1", type: "button" }, a().createElement(de, { className: "otrl-ui__date-picker__month-selector__button__arrow-left" })), a().createElement("button", { className: "otrl-ui__date-picker__month-selector__button otrl-ui__date-picker__month-selector__button--next", onClick: function onClick() {
              return t();
            }, onKeyDown: r, tabIndex: "-1", type: "button" }, a().createElement(de, { className: "otrl-ui__date-picker__month-selector__button__arrow-left" })));
        },
            ke = function ke(_ref2) {
          var _ref2$formatTitle = _ref2.formatTitle,
              e = _ref2$formatTitle === undefined ? "MMMM yyyy" : _ref2$formatTitle,
              _ref2$onChange = _ref2.onChange,
              t = _ref2$onChange === undefined ? le : _ref2$onChange,
              r = _ref2.selected,
              n = _ref2.maxDate,
              o = _ref2.minDate,
              u = _ref2.initialMonthDate,
              l = _ref2.className,
              d = (0, _objectWithoutProperties3.default)(_ref2, ["formatTitle", "onChange", "selected", "maxDate", "minDate", "initialMonthDate", "className"]);
          return a().createElement(s.ZP, be({ className: i()("otrl-ui__date-picker", l), disabledDays: [(0, _extends3.default)({}, o ? { before: o } : { before: new Date() }, n && { after: n })], initialMonth: u || r, fromMonth: new Date(), weekdaysShort: ve, localeUtils: (0, _extends3.default)({}, s.dl, { formatMonthTitle: function formatMonthTitle(t) {
                var r = e.includes("yyy") || c(new Date()) === c(t) ? "" : " " + se(t, "yyyy");return a().createElement("span", null, se(t, e), r);
              } }), modifiers: { disabled: (0, _extends3.default)({}, o ? { before: o } : { before: new Date() }, n && { after: n }) }, navbarElement: a().createElement(we, null), onDayClick: function onDayClick(e, _ref3) {
              var r = _ref3.disabled;
              r || t(e);
            }, selectedDays: r }, d));
        };function _e(e, t) {
          u(2, arguments);var r = l(e),
              n = l(t);return r.getTime() > n.getTime();
        }var De = "H:mm",
            Me = "ARRIVING_AT",
            xe = "DEPART_NOW";function Pe(e) {
          u(1, arguments);var t = l(e);return t.setHours(0, 0, 0, 0), t;
        }function Oe(e, t) {
          u(2, arguments);var r = Pe(e),
              n = Pe(t);return r.getTime() === n.getTime();
        }function Ne(e) {
          return u(1, arguments), Oe(e, Date.now());
        }function Te(e, t) {
          u(2, arguments);var r = l(e),
              n = w(t);return isNaN(n) ? new Date(NaN) : n ? (r.setDate(r.getDate() + n), r) : r;
        }function Ce(e) {
          return u(1, arguments), Oe(e, Te(Date.now(), 1));
        }function Ee(e, t) {
          u(2, arguments);var r = l(e),
              n = l(t);return r.getTime() - n.getTime();
        }var Se = 36e5;function je(e, t) {
          u(2, arguments);var r = l(e),
              n = l(t),
              a = r.getTime() - n.getTime();return a < 0 ? -1 : a > 0 ? 1 : a;
        }function We(e, t) {
          u(2, arguments);var r = l(e),
              n = l(t),
              a = r.getFullYear() - n.getFullYear(),
              o = r.getMonth() - n.getMonth();return 12 * a + o;
        }function Ue(e, t) {
          u(2, arguments);var r = l(e),
              n = l(t),
              a = je(r, n),
              o = Math.abs(We(r, n));r.setMonth(r.getMonth() - a * o);var i = je(r, n) === -a,
              s = a * (o - i);return 0 === s ? 0 : s;
        }function Ae(e, t) {
          u(2, arguments);var r = Ee(e, t) / 1e3;return r > 0 ? Math.floor(r) : Math.ceil(r);
        }function Be(e) {
          return function (e, t) {
            if (null == e) throw new TypeError("assign requires that input parameter not be null or undefined");for (var r in t = t || {}) {
              t.hasOwnProperty(r) && (e[r] = t[r]);
            }return e;
          }({}, e);
        }var Re = 1440,
            Fe = 43200;function qe(e) {
          u(1, arguments);var t = l(e),
              r = t.getMonth();return r;
        }var Ye = r(225),
            Ie = { injectType: "singletonStyleTag", attributes: { "data-id": "otrlUICSS" }, insert: "head", singleton: !0 };he()(Ye.Z, Ie), Ye.Z.locals;var Le = function Le(_ref4) {
          var e = _ref4.dateTime,
              _ref4$isSeason = _ref4.isSeason,
              t = _ref4$isSeason === undefined ? !1 : _ref4$isSeason,
              _ref4$isOther = _ref4.isOther,
              r = _ref4$isOther === undefined ? !1 : _ref4$isOther,
              _ref4$isReturn = _ref4.isReturn,
              n = _ref4$isReturn === undefined ? !1 : _ref4$isReturn,
              _ref4$disableTimePick = _ref4.disableTimePicker,
              o = _ref4$disableTimePick === undefined ? !1 : _ref4$disableTimePick;
          var i = "",
              s = "";if (t || r) _e(e.toDate(), new Date()) ? Ne(e.toDate()) ? i = "Today" : Ce(e.toDate()) ? i = "Tomorrow" : (s = " on", i = "" + e.format("EEE do MMMM")) : i = "";else if (_e(e.toDate(), new Date())) {
            if (Ne(e.toDate())) i = "Today", o || (i = function (e, t) {
              u(2, arguments);var r = Ee(e, t) / Se;return r > 0 ? Math.floor(r) : Math.ceil(r);
            }(e.toDate(), new Date()) < 4 ? a().createElement(a().Fragment, null, "Today", " ", a().createElement("span", { className: "otrl-ui__date-time-title__time__exact--conjunction" }, " ", "in", " "), function (e, t, r) {
              u(2, arguments);var n = r || {},
                  a = n.locale || v;if (!a.formatDistance) throw new RangeError("locale must contain formatDistance property");var o = je(e, t);if (isNaN(o)) throw new RangeError("Invalid time value");var i,
                  s,
                  c = Be(n);c.addSuffix = Boolean(n.addSuffix), c.comparison = o, o > 0 ? (i = l(t), s = l(e)) : (i = l(e), s = l(t));var d,
                  f = Ae(s, i),
                  h = (G(s) - G(i)) / 1e3,
                  p = Math.round((f - h) / 60);if (p < 2) return n.includeSeconds ? f < 5 ? a.formatDistance("lessThanXSeconds", 5, c) : f < 10 ? a.formatDistance("lessThanXSeconds", 10, c) : f < 20 ? a.formatDistance("lessThanXSeconds", 20, c) : f < 40 ? a.formatDistance("halfAMinute", null, c) : f < 60 ? a.formatDistance("lessThanXMinutes", 1, c) : a.formatDistance("xMinutes", 1, c) : 0 === p ? a.formatDistance("lessThanXMinutes", 1, c) : a.formatDistance("xMinutes", p, c);if (p < 45) return a.formatDistance("xMinutes", p, c);if (p < 90) return a.formatDistance("aboutXHours", 1, c);if (p < Re) {
                var m = Math.round(p / 60);return a.formatDistance("aboutXHours", m, c);
              }if (p < 2520) return a.formatDistance("xDays", 1, c);if (p < Fe) {
                var y = Math.round(p / Re);return a.formatDistance("xDays", y, c);
              }if (p < 86400) return d = Math.round(p / Fe), a.formatDistance("aboutXMonths", d, c);if ((d = Ue(s, i)) < 12) {
                var g = Math.round(p / Fe);return a.formatDistance("xMonths", g, c);
              }var b = d % 12,
                  w = Math.floor(d / 12);return b < 3 ? a.formatDistance("aboutXYears", w, c) : b < 9 ? a.formatDistance("overXYears", w, c) : a.formatDistance("almostXYears", w + 1, c);
            }(new Date(), e.toDate())) : a().createElement(a().Fragment, null, "Today", a().createElement("span", { className: "otrl-ui__date-time-title__time__exact--conjunction" }, " ", "at", " "), e.format(De)));else if (Ce(e.toDate())) i = "Tomorrow", o || (i = a().createElement(a().Fragment, null, "Tomorrow", " ", a().createElement("span", { className: "otrl-ui__date-time-title__time__exact--conjunction" }, " ", "at", " "), " ", e.format(De)));else {
              var _t2 = qe(new Date()) !== qe(e.toDate()) ? "do MMMM" : "EEEE do";i = e.format(_t2), o || (s = " on", i = a().createElement(a().Fragment, null, i, a().createElement("span", { className: "otrl-ui__date-time-title__time__exact--conjunction" }, " ", "at", " "), e.format(De)));
            }
          } else i = "";return a().createElement("div", { className: "otrl-ui__date-time-title__title-wrapper" }, t ? a().createElement(a().Fragment, null, a().createElement("h1", { className: "otrl-ui__date-time-title__title" }, "Season ticket", a().createElement("span", { className: "otrl-ui__date-time-title__title__color" }, n ? " ends " : " starts ", s)), a().createElement("h2", { className: "otrl-ui__date-time-title__time" }, a().createElement("span", { className: "otrl-ui__date-time-title__time__exact" }, i))) : a().createElement(a().Fragment, null, a().createElement("h1", { className: "otrl-ui__date-time-title__title" }, "I'm", a().createElement("span", { className: "otrl-ui__date-time-title__title__color" }, e.timeType === Me ? " arriving " : n ? " returning " : " departing ", s)), a().createElement("h2", { className: "otrl-ui__date-time-title__time" }, a().createElement("span", { className: "otrl-ui__date-time-title__time__exact" }, r ? i : e.isDepartingNow() ? "Now" : i))));
        };var ze = r(286),
            Ke = { injectType: "singletonStyleTag", attributes: { "data-id": "otrlUICSS" }, insert: "head", singleton: !0 };function He() {
          return (He = _assign2.default || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }return e;
          }).apply(this, arguments);
        }he()(ze.Z, Ke), ze.Z.locals;var Qe = a().forwardRef(function (_ref5, u) {
          var e = _ref5.className,
              _ref5$disabled = _ref5.disabled,
              t = _ref5$disabled === undefined ? !1 : _ref5$disabled,
              r = _ref5.name,
              n = _ref5.text,
              _ref5$type = _ref5.type,
              o = _ref5$type === undefined ? "submit" : _ref5$type,
              s = (0, _objectWithoutProperties3.default)(_ref5, ["className", "disabled", "name", "text", "type"]);
          return a().createElement("button", He({ className: i()("otrl-ui__button", { "otrl-ui__button--disabled": t }, e), disabled: t, name: r, ref: u, type: o }, s), n);
        });var Xe = r(107),
            Ve = { injectType: "singletonStyleTag", attributes: { "data-id": "otrlUICSS" }, insert: "head", singleton: !0 };function Ge() {
          return (Ge = _assign2.default || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }return e;
          }).apply(this, arguments);
        }he()(Xe.Z, Ve), Xe.Z.locals;var Ze = function Ze(_ref6) {
          var e = _ref6.children,
              t = _ref6.className,
              r = _ref6.name,
              _ref6$onChange = _ref6.onChange,
              n = _ref6$onChange === undefined ? le : _ref6$onChange,
              _ref6$options = _ref6.options,
              o = _ref6$options === undefined ? [] : _ref6$options,
              s = _ref6.value,
              u = (0, _objectWithoutProperties3.default)(_ref6, ["children", "className", "name", "onChange", "options", "value"]);
          return a().createElement("select", Ge({ className: i()("otrl-ui__select", t), name: r, onChange: function onChange(e) {
              n(e.target.value);
            }, value: s }, u), o.map(function (e, t) {
            return a().createElement("option", { key: t, value: e.value }, e.label);
          }), e);
        };var Je = r(415),
            $e = { injectType: "singletonStyleTag", attributes: { "data-id": "otrlUICSS" }, insert: "head", singleton: !0 };he()(Je.Z, $e), Je.Z.locals;var et = (15, (0, _from2.default)({ length: 96 }, function (e, t) {
          var r = Math.floor(15 * t / 60),
              n = 15 * t - 60 * r;return n < 10 && (n = "0" + n), r + ":" + n;
        })).map(function (e) {
          return { label: e, value: e };
        });var tt = function tt(_ref7) {
          var e = _ref7.dateTime,
              t = _ref7.onTimeChange,
              r = _ref7.onTimeTypeChange,
              n = _ref7.isReturn;
          var o = n ? [] : [{ value: xe, label: "Now" }];return a().createElement("div", { className: i()("otrl-ui__time-input-container", { "otrl-ui__time-input-container--time-type": !0 }) }, a().createElement(Ze, { name: "timeType", className: "otrl-ui__time-input", onChange: r, options: [{ value: "LEAVING_AT", label: "Leaving at" }, { value: Me, label: "Arriving at" }], value: e.getTimeType() }), a().createElement(Ze, { name: "time", className: i()("otrl-ui__time-input", "otrl-ui__time-input--hour-minute"), onChange: t, options: [].concat(o, et), value: e.isDepartingNow() ? "Depart now" : e.getTimeString() }));
        };function rt() {
          return (rt = _assign2.default || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }return e;
          }).apply(this, arguments);
        }var nt = function nt(e) {
          return n.createElement("svg", rt({ width: 15, height: 15, xmlns: "http://www.w3.org/2000/svg" }, e), n.createElement("path", { d: "M13.75 0L15 1.25 8.75 7.5 15 13.75 13.75 15 7.5 8.75 1.25 15 0 13.75 6.25 7.5 0 1.25 1.25 0 7.5 6.25 13.75 0z", fill: "currentColor", fillRule: "evenodd" }));
        };var at = r(975),
            ot = { injectType: "singletonStyleTag", attributes: { "data-id": "otrlUICSS" }, insert: "head", singleton: !0 };function it(e, t) {
          (null == t || t > e.length) && (t = e.length);for (var r = 0, n = new Array(t); r < t; r++) {
            n[r] = e[r];
          }return n;
        }function st(_ref8) {
          var e = _ref8.className,
              t = _ref8.datePickerClassName,
              r = _ref8.dateTime,
              o = _ref8.isReturn,
              s = _ref8.isSeason,
              u = _ref8.isOther,
              _ref8$onClose = _ref8.onClose,
              l = _ref8$onClose === undefined ? le : _ref8$onClose,
              _ref8$onSave = _ref8.onSave,
              c = _ref8$onSave === undefined ? le : _ref8$onSave,
              d = _ref8.maxDate,
              f = _ref8.minDate,
              _ref8$disableTimePick = _ref8.disableTimePicker,
              h = _ref8$disableTimePick === undefined ? !1 : _ref8$disableTimePick;
          var p = (b = a().useState(r.clone()), v = 2, function (e) {
            if (Array.isArray(e)) return e;
          }(b) || function (e, t) {
            if ("undefined" != typeof _symbol2.default && (0, _isIterable3.default)(Object(e))) {
              var r = [],
                  n = !0,
                  a = !1,
                  o = void 0;try {
                for (var i, s = (0, _getIterator3.default)(e); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {}
              } catch (e) {
                a = !0, o = e;
              } finally {
                try {
                  n || null == s.return || s.return();
                } finally {
                  if (a) throw o;
                }
              }return r;
            }
          }(b, v) || function (e, t) {
            if (e) {
              if ("string" == typeof e) return it(e, t);var r = Object.prototype.toString.call(e).slice(8, -1);return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? (0, _from2.default)(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? it(e, t) : void 0;
            }
          }(b, v) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }()),
              m = p[0],
              y = p[1],
              g = _e(new Date(), m.toDate());var b, v;return (0, n.useEffect)(function () {
            g && y(m.produce({ timeType: xe }));
          }, []), a().createElement("div", { className: i()("otrl-ui__modal-date-picker", e) }, a().createElement("div", { className: "otrl-ui__modal-date-picker__header" }, a().createElement("div", { className: "otrl-ui__modal-date-picker__header__bar", onClick: function onClick() {
              l();
            } }, a().createElement("div", { className: "otrl-ui__modal-date-picker__header__title-wrapper" }, a().createElement(Le, { dateTime: m, isReturn: o, isSeason: s, isOther: u, disableTimePicker: h })), a().createElement("button", { className: "otrl-ui__modal-date-picker__close", "aria-label": "Close" }, a().createElement(nt, null)))), a().createElement("div", { className: "otrl-ui__modal-date-picker__datetime-container" }, a().createElement("div", { className: "otrl-ui__modal-date-picker__wrapper" }, a().createElement(ke, { formatTitle: "MMMM", onChange: function onChange(e) {
              y(m.produce({ date: e }));
            }, selected: m.toDate(), maxDate: d, minDate: f, className: t })), !h && !s && !u && a().createElement(tt, { dateTime: m, onTimeChange: function onTimeChange(e) {
              y(e === xe ? m.produce({ timeType: xe }) : m.produce({ time: e }));
            }, onTimeTypeChange: function onTimeTypeChange(e) {
              y(m.produce({ timeType: e }));
            }, isReturn: o })), a().createElement(Qe, { className: "otrl-ui__button--full-width", disabled: g, text: "Done", onClick: function onClick() {
              c(m), l();
            } }));
        }he()(at.Z, ot), at.Z.locals;
      }, 184: function _(e, t) {
        var r;!function () {
          "use strict";
          var n = {}.hasOwnProperty;function a() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var r = arguments[t];if (r) {
                var o = typeof r === "undefined" ? "undefined" : (0, _typeof3.default)(r);if ("string" === o || "number" === o) e.push(r);else if (Array.isArray(r) && r.length) {
                  var i = a.apply(null, r);i && e.push(i);
                } else if ("object" === o) for (var s in r) {
                  n.call(r, s) && r[s] && e.push(s);
                }
              }
            }return e.join(" ");
          }e.exports ? (a.default = a, e.exports = a) : void 0 === (r = function () {
            return a;
          }.apply(t, [])) || (e.exports = r);
        }();
      }, 976: function _(e, t, r) {
        "use strict";
        r.d(t, { Z: function Z() {
            return o;
          } });var n = r(645),
            a = r.n(n)()(function (e) {
          return e[1];
        });a.push([e.id, '.DayPicker{display:inline-block;font-size:1rem}.DayPicker-wrapper{position:relative;flex-direction:row;padding-bottom:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-Months{display:flex;flex-wrap:wrap;justify-content:center}.DayPicker-Month{display:table;margin:0 1em;margin-top:1em;border-spacing:0;border-collapse:collapse;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-NavButton{position:absolute;top:1em;right:1.5em;left:auto;display:inline-block;margin-top:2px;width:1.25em;height:1.25em;background-position:center;background-size:50%;background-repeat:no-repeat;color:#8b9898;cursor:pointer}.DayPicker-NavButton:hover{opacity:.8}.DayPicker-NavButton--prev{margin-right:1.5em;background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC")}.DayPicker-NavButton--next{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==")}.DayPicker-NavButton--interactionDisabled{display:none}.DayPicker-Caption{display:table-caption;margin-bottom:.5em;padding:0 .5em;text-align:left}.DayPicker-Caption>div{font-weight:500;font-size:1.15em}.DayPicker-Weekdays{display:table-header-group;margin-top:1em}.DayPicker-WeekdaysRow{display:table-row}.DayPicker-Weekday{display:table-cell;padding:.5em;color:#8b9898;text-align:center;font-size:.875em}.DayPicker-Weekday abbr[title]{border-bottom:none;text-decoration:none}.DayPicker-Body{display:table-row-group}.DayPicker-Week{display:table-row}.DayPicker-Day{display:table-cell;padding:.5em;border-radius:50%;vertical-align:middle;text-align:center;cursor:pointer}.DayPicker-WeekNumber{display:table-cell;padding:.5em;min-width:1em;border-right:1px solid #eaecec;color:#8b9898;vertical-align:middle;text-align:right;font-size:.75em;cursor:pointer}.DayPicker--interactionDisabled .DayPicker-Day{cursor:default}.DayPicker-Footer{padding-top:.5em}.DayPicker-TodayButton{border:none;background-color:transparent;background-image:none;box-shadow:none;color:#4a90e2;font-size:.875em;cursor:pointer}.DayPicker-Day--today{color:#d0021b;font-weight:700}.DayPicker-Day--outside{color:#8b9898;cursor:default}.DayPicker-Day--disabled{color:#dce0e0;cursor:default}.DayPicker-Day--sunday{background-color:#f7f8f8}.DayPicker-Day--sunday:not(.DayPicker-Day--today){color:#dce0e0}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){position:relative;background-color:#4a90e2;color:#f0f8ff}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover{background-color:#51a0fa}.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{background-color:#f0f8ff}.DayPickerInput{display:inline-block}.DayPickerInput-OverlayWrapper{position:relative}.DayPickerInput-Overlay{position:absolute;left:0;z-index:1;background:#fff;box-shadow:0 2px 5px rgba(0,0,0,.15)}', ""]);var o = a;
      }, 592: function _(e, t, r) {
        "use strict";
        r.d(t, { Z: function Z() {
            return o;
          } });var n = r(645),
            a = r.n(n)()(function (e) {
          return e[1];
        });a.push([e.id, '.otrl-ui__date-picker{font-size:13px}.otrl-ui__widget--vertical .otrl-ui__date-picker{width:100%}@media(max-width: 1129px){.otrl-ui__date-picker{width:100%}}.otrl-ui__date-picker--full-width{width:100%}.otrl-ui__date-picker__month-selector{display:flex;justify-content:space-between}.otrl-ui__date-picker__month-selector__button{background:none;border:none;color:var(--otrl-ui-grey-color);cursor:pointer;font-size:14px;font-weight:normal;z-index:4}.otrl-ui__date-picker__month-selector__button--next,.otrl-ui__date-picker__month-selector__button--prev{color:var(--otrl-ui-text-color);height:30px;position:absolute;text-align:right;width:40px;top:-10px}.otrl-ui__date-picker__month-selector__button--prev{left:0;transform:rotate(180deg)}.otrl-ui__widget--vertical .otrl-ui__date-picker__month-selector__button--prev{top:-3px}@media(max-width: 1129px){.otrl-ui__date-picker__month-selector__button--prev{top:-3px}}.otrl-ui__date-picker__month-selector__button--next{right:0;top:-6px}.otrl-ui__widget--vertical .otrl-ui__date-picker__month-selector__button--next{top:-1px}@media(max-width: 1129px){.otrl-ui__date-picker__month-selector__button--next{top:-1px}}.otrl-ui__date-picker .DayPicker{display:block}.otrl-ui__date-picker .DayPicker-wrapper{padding-bottom:0}.otrl-ui__date-picker .DayPicker-Months{flex-direction:row;flex-wrap:nowrap}.otrl-ui__date-picker .DayPicker-Month{margin:0}.otrl-ui__date-picker .DayPicker-Month:first-child{margin-right:32px;position:relative}.otrl-ui__date-picker .DayPicker-Month:first-child:after{content:" ";border-right:solid 2px var(--otrl-ui--border-color);bottom:0;height:70%;position:absolute;right:-16px;width:1px}.otrl-ui__widget--vertical .otrl-ui__date-picker .DayPicker-Month{width:100%}.otrl-ui__widget--vertical .otrl-ui__date-picker .DayPicker-Month:first-child{margin-right:0}.otrl-ui__widget--vertical .otrl-ui__date-picker .DayPicker-Month:first-child:after{display:none}@media(max-width: 1129px){.otrl-ui__date-picker .DayPicker-Month{width:100%}.otrl-ui__date-picker .DayPicker-Month:first-child{margin-right:0}.otrl-ui__date-picker .DayPicker-Month:first-child:after{display:none}}.otrl-ui__date-picker .DayPicker-WeekdaysRow{border-bottom:solid 1px var(--otrl-ui--border-color);display:flex;justify-content:space-between;width:100%;margin:0 0 5px 0}.otrl-ui__date-picker .DayPicker-Week{display:flex;justify-content:space-between}.otrl-ui__date-picker .DayPicker-Weekday{display:inline;width:18px;font-size:13px}.otrl-ui__widget--vertical .otrl-ui__date-picker .DayPicker-Weekday{font-size:16px}@media(max-width: 1129px){.otrl-ui__date-picker .DayPicker-Weekday{font-size:16px}}.otrl-ui__date-picker .DayPicker-Caption{text-align:center}.otrl-ui__date-picker .DayPicker-Caption>div{color:var(--otrl-ui-grey-color);font-size:14px;font-weight:800}.otrl-ui__widget--vertical .otrl-ui__date-picker .DayPicker-Caption>div{font-size:20px}@media(max-width: 1129px){.otrl-ui__date-picker .DayPicker-Caption>div{font-size:20px}}.otrl-ui__date-picker .DayPicker-Day{width:20px;height:20px;display:flex;justify-content:center;align-items:center;padding:5px;font-size:13px}.otrl-ui__widget--vertical .otrl-ui__date-picker .DayPicker-Day{padding:8px;font-size:16px}@media(max-width: 1129px){.otrl-ui__date-picker .DayPicker-Day{padding:8px;font-size:16px}}.otrl-ui__date-picker .DayPicker-Day--today{color:var(--otrl-ui-secondary-color)}.otrl-ui__date-picker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){background:var(--otrl-ui--date-picker-active-color)}', ""]);var o = a;
      }, 225: function _(e, t, r) {
        "use strict";
        r.d(t, { Z: function Z() {
            return o;
          } });var n = r(645),
            a = r.n(n)()(function (e) {
          return e[1];
        });a.push([e.id, ".otrl-ui__date-time-title{background:var(--otrl-ui--body-background);color:var(--otrl-ui-text-color);display:flex;flex-direction:column}.otrl-ui__date-time-title__bar{display:flex;align-items:flex-start;justify-content:space-between}.otrl-ui__date-time-title__title-wrapper{display:flex;flex-direction:column}.otrl-ui__date-time-title__title{color:var(--otrl-ui-text-color);font-size:24px;line-height:20px;margin:0}.otrl-ui__date-time-title__title__color{color:var(--otrl-ui-text-secondary-color)}.otrl-ui__date-time-title__time{color:var(--otrl-ui-text-color);line-height:16px;margin:0;margin-top:16px}.otrl-ui__date-time-title__time__exact{font-size:27px;line-height:27px;font-weight:800}.otrl-ui__date-time-title__time__exact--conjunction{font-weight:normal}", ""]);var o = a;
      }, 975: function _(e, t, r) {
        "use strict";
        r.d(t, { Z: function Z() {
            return o;
          } });var n = r(645),
            a = r.n(n)()(function (e) {
          return e[1];
        });a.push([e.id, ".otrl-ui__modal-date-picker{box-shadow:0 0 10px 0 rgba(0,0,0,.1);display:flex;align-items:center;flex-direction:column;padding:20px}.otrl-ui__modal-date-picker *:focus{border-radius:4px;outline:0;box-shadow:0 0 0 2px var(--otrl-ui--outline-color);z-index:5}.otrl-ui__modal-date-picker__header{color:var(--otrl-ui-text-color);display:flex;flex-direction:column;width:100%}.otrl-ui__modal-date-picker__header__bar{display:flex;align-items:flex-start;justify-content:space-between}.otrl-ui__modal-date-picker__header__title-wrapper{display:flex;flex-direction:column}.otrl-ui__modal-date-picker__header__title{color:var(--otrl-ui-text-color);font-size:24px;line-height:24px;margin:0}.otrl-ui__modal-date-picker__header__title__color{color:var(--otrl-ui-text-secondary-color)}.otrl-ui__modal-date-picker__header__time{color:var(--otrl-ui-text-color);margin:0}.otrl-ui__modal-date-picker__header__time__exact{font-size:1.05em;line-height:1em}.otrl-ui__modal-date-picker__close{background:none;border:none;color:var(--otrl-ui--modal-close-button-color);cursor:pointer;font-size:16px;padding:0}.otrl-ui__modal-date-picker__wrapper{margin:30px 0 12px 0}.otrl-ui__modal-date-picker__wrapper .DayPicker-Month{margin:0}.otrl-ui__modal-date-picker__datetime-container{margin:0 0 24px 0;width:100%}", ""]);var o = a;
      }, 286: function _(e, t, r) {
        "use strict";
        r.d(t, { Z: function Z() {
            return o;
          } });var n = r(645),
            a = r.n(n)()(function (e) {
          return e[1];
        });a.push([e.id, ".otrl-ui__button{padding:12px;border:none;border-radius:4px;box-shadow:0 2px 4px 0 rgba(0,0,0,.15);color:var(--otrl-ui--button-text-color);cursor:pointer;font-size:20px;font-family:var(--otrl-ui--button-font-family);font-weight:var(--otrl-ui--font-weight-bold);background-color:var(--otrl-ui--button-background)}.otrl-ui__button--disabled{opacity:.5}.otrl-ui__button--full-width{box-sizing:border-box;width:100%}.otrl-ui__button__price-label{display:block}.otrl-ui__button-link{background:none;border:none;color:var(--otrl-ui-text-color);cursor:pointer;font-weight:bold;margin:8px 0;padding:0;text-decoration:underline}.otrl-ui__button-unstyled{background:none;border:none;padding:0;cursor:pointer}", ""]);var o = a;
      }, 107: function _(e, t, r) {
        "use strict";
        r.d(t, { Z: function Z() {
            return o;
          } });var n = r(645),
            a = r.n(n)()(function (e) {
          return e[1];
        });a.push([e.id, ".otrl-ui__select{-moz-appearance:none;-webkit-appearance:none;appearance:none;background-color:var(--otrl-ui--select-background, #fff);background-image:url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.467 4.301' height='16.254' width='32'%3E%3Cpath d='M8.467 0L6.35 2.15 4.233 4.3 2.117 2.15 0 0h4.233z' fill='%23444444'/%3E%3C/svg%3E%0A\"),linear-gradient(to bottom, var(--otrl-ui--select-background, var(--otrl-ui--select-background-top, #fff)) 0%, var(--otrl-ui--select-background, var(--otrl-ui--select-background-bottom, #fff)) 100%);background-position:right .7em top 50%,0 0;background-repeat:no-repeat,repeat;background-size:.65em auto,100%;border-radius:5px;border:1px solid var(--otrl-ui--select-border-color, var(--otrl-ui--select-color, #444));box-shadow:0 0 12px 0 rgba(0,0,0,.1);box-sizing:border-box;color:var(--otrl-ui--select-color, #444);display:block;font-size:var(--otrl-ui--select-font-size, 16px);line-height:1.3;margin:0;max-width:100%;padding:.6em 1.4em .5em .8em;width:100%;height:100%}.otrl-ui__select::-ms-expand{display:none}.otrl-ui__select:hover{border-color:var(--otrl-ui--outline-color, #888)}.otrl-ui__select option{font-weight:normal}", ""]);var o = a;
      }, 415: function _(e, t, r) {
        "use strict";
        r.d(t, { Z: function Z() {
            return o;
          } });var n = r(645),
            a = r.n(n)()(function (e) {
          return e[1];
        });a.push([e.id, ".otrl-ui__time-input-container{display:flex;justify-content:center;flex-basis:320px}.otrl-ui__widget--vertical .otrl-ui__time-input-container{padding:0}@media(max-width: 1129px){.otrl-ui__time-input-container{padding:0}}.otrl-ui__time-input-container--time-type .otrl-ui__time-input:first-child{margin-right:14px}.otrl-ui__time-input--disabled{display:none}", ""]);var o = a;
      }, 645: function _(e) {
        "use strict";
        e.exports = function (e) {
          var t = [];return t.toString = function () {
            return this.map(function (t) {
              var r = e(t);return t[2] ? "@media ".concat(t[2], " {").concat(r, "}") : r;
            }).join("");
          }, t.i = function (e, r, n) {
            "string" == typeof e && (e = [[null, e, ""]]);var a = {};if (n) for (var o = 0; o < this.length; o++) {
              var i = this[o][0];null != i && (a[i] = !0);
            }for (var s = 0; s < e.length; s++) {
              var u = [].concat(e[s]);n && a[u[0]] || (r && (u[2] ? u[2] = "".concat(r, " and ").concat(u[2]) : u[2] = r), t.push(u));
            }
          }, t;
        };
      }, 703: function _(e, t, r) {
        "use strict";
        var n = r(414);function a() {}function o() {}o.resetWarningCache = a, e.exports = function () {
          function e(e, t, r, a, o, i) {
            if (i !== n) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name = "Invariant Violation", s;
            }
          }function t() {
            return e;
          }e.isRequired = e;var r = { array: e, bool: e, func: e, number: e, object: e, string: e, symbol: e, any: e, arrayOf: t, element: e, elementType: e, instanceOf: t, node: e, objectOf: t, oneOf: t, oneOfType: t, shape: t, exact: t, checkPropTypes: o, resetWarningCache: a };return r.PropTypes = r, r;
        };
      }, 697: function _(e, t, r) {
        e.exports = r(703)();
      }, 414: function _(e) {
        "use strict";
        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }, 346: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
          function e(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, _defineProperty2.default)(e, n.key, n);
            }
          }return function (t, r, n) {
            return r && e(t.prototype, r), n && e(t, n), t;
          };
        }(),
            a = r(698),
            o = l(a),
            i = l(r(697)),
            s = l(r(727)),
            u = r(946);function l(e) {
          return e && e.__esModule ? e : { default: e };
        }var c = function (e) {
          function t(e) {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t);var r = function (e, t) {
              if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "function" != typeof t ? e : t;
            }(this, (t.__proto__ || (0, _getPrototypeOf2.default)(t)).call(this, e));return r.handleKeyUp = r.handleKeyUp.bind(r), r;
          }return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)));e.prototype = (0, _create2.default)(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(e, t) : e.__proto__ = t);
          }(t, e), n(t, [{ key: "shouldComponentUpdate", value: function value(e) {
              return e.locale !== this.props.locale || e.classNames !== this.props.classNames || e.date.getMonth() !== this.props.date.getMonth() || e.date.getFullYear() !== this.props.date.getFullYear();
            } }, { key: "handleKeyUp", value: function value(e) {
              e.keyCode === u.ENTER && this.props.onClick(e);
            } }, { key: "render", value: function value() {
              var e = this.props,
                  t = e.classNames,
                  r = e.date,
                  n = e.months,
                  a = e.locale,
                  i = e.localeUtils,
                  s = e.onClick;return o.default.createElement("div", { className: t.caption, role: "heading" }, o.default.createElement("div", { onClick: s, onKeyUp: this.handleKeyUp }, n ? n[r.getMonth()] + " " + r.getFullYear() : i.formatMonthTitle(r, a)));
            } }]), t;
        }(a.Component);c.propTypes = { date: i.default.instanceOf(Date), months: i.default.arrayOf(i.default.string), locale: i.default.string, localeUtils: i.default.object, onClick: i.default.func, classNames: i.default.shape({ caption: i.default.string.isRequired }).isRequired }, c.defaultProps = { localeUtils: s.default }, t.default = c;
      }, 167: function _(e, t) {
        "use strict";
        function r(e) {
          return new Date(e.getTime());
        }function n(e) {
          return e instanceof Date && !isNaN(e.valueOf());
        }function a(e, t) {
          var n = r(e);return n.setMonth(e.getMonth() + t), n;
        }function o(e, t) {
          return !(!e || !t) && e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
        }function i(e, t) {
          return !(!e || !t) && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
        }function s(e, t) {
          return r(e).setHours(0, 0, 0, 0) < r(t).setHours(0, 0, 0, 0);
        }function u(e, t) {
          return r(e).setHours(0, 0, 0, 0) > r(t).setHours(0, 0, 0, 0);
        }function l(e) {
          var t = new Date();return t.setHours(0, 0, 0, 0), s(e, t);
        }function c(e) {
          var t = new Date(new Date().getTime() + 864e5);return t.setHours(0, 0, 0, 0), e >= t;
        }function d(e, t, n) {
          var a = r(e);return a.setHours(0, 0, 0, 0), u(a, t) && s(a, n) || u(a, n) && s(a, t);
        }function f(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { from: null, to: null },
              r = t.from,
              n = t.to;return r ? r && n && o(r, n) && o(e, r) ? (r = null, n = null) : n && s(e, r) ? r = e : n && o(e, n) ? (r = e, n = e) : s(n = e, r) && (n = r, r = e) : r = e, { from: r, to: n };
        }function h(e, t) {
          var r = t.from,
              n = t.to;return r && o(e, r) || n && o(e, n) || r && n && d(e, r, n);
        }function p(e) {
          var t = r(e);return t.setHours(0, 0, 0), t.setDate(t.getDate() + 4 - (t.getDay() || 7)), Math.ceil(((t - new Date(t.getFullYear(), 0, 1)) / 864e5 + 1) / 7);
        }Object.defineProperty(t, "__esModule", { value: !0 }), t.clone = r, t.isDate = n, t.addMonths = a, t.isSameDay = o, t.isSameMonth = i, t.isDayBefore = s, t.isDayAfter = u, t.isPastDay = l, t.isFutureDay = c, t.isDayBetween = d, t.addDayToRange = f, t.isDayInRange = h, t.getWeekNumber = p, t.default = { addDayToRange: f, addMonths: a, clone: r, getWeekNumber: p, isDate: n, isDayAfter: u, isDayBefore: s, isDayBetween: d, isDayInRange: h, isFutureDay: c, isPastDay: l, isSameDay: o, isSameMonth: i };
      }, 777: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });var n = _assign2.default || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];for (var n in r) {
              Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
          }return e;
        },
            a = function () {
          function e(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, _defineProperty2.default)(e, n.key, n);
            }
          }return function (t, r, n) {
            return r && e(t.prototype, r), n && e(t, n), t;
          };
        }(),
            o = r(698),
            i = d(o),
            s = d(r(697)),
            u = r(167),
            l = r(858),
            c = d(r(653));function d(e) {
          return e && e.__esModule ? e : { default: e };
        }function f(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }function h(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "function" != typeof t ? e : t;
        }function p(e, t, r) {
          if (e) return function (n) {
            n.persist(), e(t, r, n);
          };
        }var m = function (e) {
          function t() {
            return f(this, t), h(this, (t.__proto__ || (0, _getPrototypeOf2.default)(t)).apply(this, arguments));
          }return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)));e.prototype = (0, _create2.default)(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(e, t) : e.__proto__ = t);
          }(t, e), a(t, [{ key: "shouldComponentUpdate", value: function value(e) {
              var t = this,
                  r = (0, _keys2.default)(this.props),
                  n = (0, _keys2.default)(e);return r.length !== n.length || r.some(function (r) {
                if ("modifiers" === r || "modifiersStyles" === r || "classNames" === r) {
                  var n = t.props[r],
                      a = e[r],
                      o = (0, _keys2.default)(n),
                      i = (0, _keys2.default)(a);return o.length !== i.length || o.some(function (e) {
                    return !(0, l.hasOwnProp)(a, e) || n[e] !== a[e];
                  });
                }return "day" === r ? !(0, u.isSameDay)(t.props[r], e[r]) : !(0, l.hasOwnProp)(e, r) || t.props[r] !== e[r];
              });
            } }, { key: "render", value: function value() {
              var e = this.props,
                  t = e.classNames,
                  r = e.modifiersStyles,
                  a = e.day,
                  o = e.tabIndex,
                  s = e.empty,
                  u = e.modifiers,
                  l = e.onMouseEnter,
                  d = e.onMouseLeave,
                  f = e.onMouseUp,
                  h = e.onMouseDown,
                  m = e.onClick,
                  y = e.onKeyDown,
                  g = e.onTouchStart,
                  b = e.onTouchEnd,
                  v = e.onFocus,
                  w = e.ariaLabel,
                  k = e.ariaDisabled,
                  _ = e.ariaSelected,
                  D = e.children,
                  M = t.day;t !== c.default ? M += " " + (0, _keys2.default)(u).join(" ") : M += (0, _keys2.default)(u).map(function (e) {
                return " " + M + "--" + e;
              }).join("");var x = void 0;return r && (0, _keys2.default)(u).filter(function (e) {
                return !!r[e];
              }).forEach(function (e) {
                x = n({}, x, r[e]);
              }), s ? i.default.createElement("div", { "aria-disabled": !0, className: M, style: x }) : i.default.createElement("div", { className: M, tabIndex: o, style: x, role: "gridcell", "aria-label": w, "aria-disabled": k, "aria-selected": _, onClick: p(m, a, u), onKeyDown: p(y, a, u), onMouseEnter: p(l, a, u), onMouseLeave: p(d, a, u), onMouseUp: p(f, a, u), onMouseDown: p(h, a, u), onTouchEnd: p(b, a, u), onTouchStart: p(g, a, u), onFocus: p(v, a, u) }, D);
            } }]), t;
        }(o.Component);m.propTypes = { classNames: s.default.shape({ day: s.default.string.isRequired }).isRequired, day: s.default.instanceOf(Date).isRequired, children: s.default.node.isRequired, ariaDisabled: s.default.bool, ariaLabel: s.default.string, ariaSelected: s.default.bool, empty: s.default.bool, modifiers: s.default.object, modifiersStyles: s.default.object, onClick: s.default.func, onKeyDown: s.default.func, onMouseEnter: s.default.func, onMouseLeave: s.default.func, onMouseDown: s.default.func, onMouseUp: s.default.func, onTouchEnd: s.default.func, onTouchStart: s.default.func, onFocus: s.default.func, tabIndex: s.default.number }, m.defaultProps = { tabIndex: -1 }, m.defaultProps = { modifiers: {}, modifiersStyles: {}, empty: !1 }, t.default = m;
      }, 306: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), t.ModifiersUtils = t.LocaleUtils = t.DateUtils = t.DayPicker = void 0;var n = _assign2.default || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];for (var n in r) {
              Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
          }return e;
        },
            a = function () {
          function e(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, _defineProperty2.default)(e, n.key, n);
            }
          }return function (t, r, n) {
            return r && e(t.prototype, r), n && e(t, n), t;
          };
        }(),
            o = r(698),
            i = v(o),
            s = v(r(697)),
            u = v(r(346)),
            l = v(r(34)),
            c = v(r(599)),
            d = v(r(823)),
            f = b(r(858)),
            h = b(r(167)),
            p = b(r(727)),
            m = b(r(72)),
            y = v(r(653)),
            g = r(946);function b(e) {
          if (e && e.__esModule) return e;var t = {};if (null != e) for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }return t.default = e, t;
        }function v(e) {
          return e && e.__esModule ? e : { default: e };
        }var w = t.DayPicker = function (e) {
          function t(e) {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t);var r = function (e, t) {
              if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "function" != typeof t ? e : t;
            }(this, (t.__proto__ || (0, _getPrototypeOf2.default)(t)).call(this, e));r.dayPicker = null, r.showNextMonth = function (e) {
              if (r.allowNextMonth()) {
                var t = r.props.pagedNavigation ? r.props.numberOfMonths : 1,
                    n = h.addMonths(r.state.currentMonth, t);r.showMonth(n, e);
              }
            }, r.showPreviousMonth = function (e) {
              if (r.allowPreviousMonth()) {
                var t = r.props.pagedNavigation ? r.props.numberOfMonths : 1,
                    n = h.addMonths(r.state.currentMonth, -t);r.showMonth(n, e);
              }
            }, r.handleKeyDown = function (e) {
              switch (e.persist(), e.keyCode) {case g.LEFT:
                  "rtl" === r.props.dir ? r.showNextMonth() : r.showPreviousMonth(), f.cancelEvent(e);break;case g.RIGHT:
                  "rtl" === r.props.dir ? r.showPreviousMonth() : r.showNextMonth(), f.cancelEvent(e);break;case g.UP:
                  r.showPreviousYear(), f.cancelEvent(e);break;case g.DOWN:
                  r.showNextYear(), f.cancelEvent(e);}r.props.onKeyDown && r.props.onKeyDown(e);
            }, r.handleDayKeyDown = function (e, t, n) {
              switch (n.persist(), n.keyCode) {case g.LEFT:
                  f.cancelEvent(n), "rtl" === r.props.dir ? r.focusNextDay(n.target) : r.focusPreviousDay(n.target);break;case g.RIGHT:
                  f.cancelEvent(n), "rtl" === r.props.dir ? r.focusPreviousDay(n.target) : r.focusNextDay(n.target);break;case g.UP:
                  f.cancelEvent(n), r.focusPreviousWeek(n.target);break;case g.DOWN:
                  f.cancelEvent(n), r.focusNextWeek(n.target);break;case g.ENTER:case g.SPACE:
                  f.cancelEvent(n), r.props.onDayClick && r.handleDayClick(e, t, n);}r.props.onDayKeyDown && r.props.onDayKeyDown(e, t, n);
            }, r.handleDayClick = function (e, t, n) {
              n.persist(), t[r.props.classNames.outside] && r.props.enableOutsideDaysClick && r.handleOutsideDayClick(e), r.props.onDayClick && r.props.onDayClick(e, t, n);
            }, r.handleTodayButtonClick = function (e) {
              var t = new Date(),
                  n = new Date(t.getFullYear(), t.getMonth());r.showMonth(n), e.target.blur(), r.props.onTodayButtonClick && (e.persist(), r.props.onTodayButtonClick(new Date(t.getFullYear(), t.getMonth(), t.getDate()), m.getModifiersForDay(t, r.props.modifiers), e));
            };var n = r.getCurrentMonthFromProps(e);return r.state = { currentMonth: n }, r;
          }return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)));e.prototype = (0, _create2.default)(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(e, t) : e.__proto__ = t);
          }(t, e), a(t, [{ key: "componentDidUpdate", value: function value(e) {
              if (e.month !== this.props.month && !h.isSameMonth(e.month, this.props.month)) {
                var t = this.getCurrentMonthFromProps(this.props);this.setState({ currentMonth: t });
              }
            } }, { key: "getCurrentMonthFromProps", value: function value(e) {
              var t = f.startOfMonth(e.month || e.initialMonth || new Date());if (e.pagedNavigation && e.numberOfMonths > 1 && e.fromMonth) {
                var r = f.startOfMonth(e.fromMonth),
                    n = f.getMonthsDiff(r, t);t = h.addMonths(r, Math.floor(n / e.numberOfMonths) * e.numberOfMonths);
              } else e.toMonth && e.numberOfMonths > 1 && f.getMonthsDiff(t, e.toMonth) <= 0 && (t = h.addMonths(f.startOfMonth(e.toMonth), 1 - this.props.numberOfMonths));return t;
            } }, { key: "getNextNavigableMonth", value: function value() {
              return h.addMonths(this.state.currentMonth, this.props.numberOfMonths);
            } }, { key: "getPreviousNavigableMonth", value: function value() {
              return h.addMonths(this.state.currentMonth, -1);
            } }, { key: "allowPreviousMonth", value: function value() {
              var e = h.addMonths(this.state.currentMonth, -1);return this.allowMonth(e);
            } }, { key: "allowNextMonth", value: function value() {
              var e = h.addMonths(this.state.currentMonth, this.props.numberOfMonths);return this.allowMonth(e);
            } }, { key: "allowMonth", value: function value(e) {
              var t = this.props,
                  r = t.fromMonth,
                  n = t.toMonth;return !(!t.canChangeMonth || r && f.getMonthsDiff(r, e) < 0 || n && f.getMonthsDiff(n, e) > 0);
            } }, { key: "allowYearChange", value: function value() {
              return this.props.canChangeMonth;
            } }, { key: "showMonth", value: function value(e, t) {
              var r = this;this.allowMonth(e) && this.setState({ currentMonth: f.startOfMonth(e) }, function () {
                t && t(), r.props.onMonthChange && r.props.onMonthChange(r.state.currentMonth);
              });
            } }, { key: "showNextYear", value: function value() {
              if (this.allowYearChange()) {
                var e = h.addMonths(this.state.currentMonth, 12);this.showMonth(e);
              }
            } }, { key: "showPreviousYear", value: function value() {
              if (this.allowYearChange()) {
                var e = h.addMonths(this.state.currentMonth, -12);this.showMonth(e);
              }
            } }, { key: "focus", value: function value() {
              this.wrapper.focus();
            } }, { key: "focusFirstDayOfMonth", value: function value() {
              f.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
            } }, { key: "focusLastDayOfMonth", value: function value() {
              var e = f.getDayNodes(this.dayPicker, this.props.classNames);e[e.length - 1].focus();
            } }, { key: "focusPreviousDay", value: function value(e) {
              var t = this,
                  r = f.getDayNodes(this.dayPicker, this.props.classNames),
                  n = f.nodeListToArray(r).indexOf(e);-1 !== n && (0 === n ? this.showPreviousMonth(function () {
                return t.focusLastDayOfMonth();
              }) : r[n - 1].focus());
            } }, { key: "focusNextDay", value: function value(e) {
              var t = this,
                  r = f.getDayNodes(this.dayPicker, this.props.classNames),
                  n = f.nodeListToArray(r).indexOf(e);-1 !== n && (n === r.length - 1 ? this.showNextMonth(function () {
                return t.focusFirstDayOfMonth();
              }) : r[n + 1].focus());
            } }, { key: "focusNextWeek", value: function value(e) {
              var t = this,
                  r = f.getDayNodes(this.dayPicker, this.props.classNames),
                  n = f.nodeListToArray(r).indexOf(e);n > r.length - 8 ? this.showNextMonth(function () {
                var e = 7 - (r.length - n);f.getDayNodes(t.dayPicker, t.props.classNames)[e].focus();
              }) : r[n + 7].focus();
            } }, { key: "focusPreviousWeek", value: function value(e) {
              var t = this,
                  r = f.getDayNodes(this.dayPicker, this.props.classNames),
                  n = f.nodeListToArray(r).indexOf(e);n <= 6 ? this.showPreviousMonth(function () {
                var e = f.getDayNodes(t.dayPicker, t.props.classNames);e[e.length - 7 + n].focus();
              }) : r[n - 7].focus();
            } }, { key: "handleOutsideDayClick", value: function value(e) {
              var t = this.state.currentMonth,
                  r = this.props.numberOfMonths,
                  n = f.getMonthsDiff(t, e);n > 0 && n >= r ? this.showNextMonth() : n < 0 && this.showPreviousMonth();
            } }, { key: "renderNavbar", value: function value() {
              var e = this.props,
                  t = e.labels,
                  r = e.locale,
                  n = e.localeUtils,
                  a = e.canChangeMonth,
                  o = e.navbarElement,
                  s = function (e, t) {
                var r = {};for (var n in e) {
                  t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                }return r;
              }(e, ["labels", "locale", "localeUtils", "canChangeMonth", "navbarElement"]);if (!a) return null;var u = { month: this.state.currentMonth, classNames: this.props.classNames, className: this.props.classNames.navBar, nextMonth: this.getNextNavigableMonth(), previousMonth: this.getPreviousNavigableMonth(), showPreviousButton: this.allowPreviousMonth(), showNextButton: this.allowNextMonth(), onNextClick: this.showNextMonth, onPreviousClick: this.showPreviousMonth, dir: s.dir, labels: t, locale: r, localeUtils: n };return i.default.isValidElement(o) ? i.default.cloneElement(o, u) : i.default.createElement(o, u);
            } }, { key: "renderMonths", value: function value() {
              for (var e = [], t = f.getFirstDayOfWeekFromProps(this.props), r = 0; r < this.props.numberOfMonths; r += 1) {
                var a = h.addMonths(this.state.currentMonth, r);e.push(i.default.createElement(c.default, n({ key: r }, this.props, { month: a, firstDayOfWeek: t, onDayKeyDown: this.handleDayKeyDown, onDayClick: this.handleDayClick })));
              }return this.props.reverseMonths && e.reverse(), e;
            } }, { key: "renderFooter", value: function value() {
              return this.props.todayButton ? i.default.createElement("div", { className: this.props.classNames.footer }, this.renderTodayButton()) : null;
            } }, { key: "renderTodayButton", value: function value() {
              return i.default.createElement("button", { type: "button", tabIndex: 0, className: this.props.classNames.todayButton, "aria-label": this.props.todayButton, onClick: this.handleTodayButtonClick }, this.props.todayButton);
            } }, { key: "render", value: function value() {
              var e = this,
                  t = this.props.classNames.container;return this.props.onDayClick || (t = t + " " + this.props.classNames.interactionDisabled), this.props.className && (t = t + " " + this.props.className), i.default.createElement("div", n({}, this.props.containerProps, { className: t, ref: function ref(t) {
                  return e.dayPicker = t;
                }, lang: this.props.locale }), i.default.createElement("div", { className: this.props.classNames.wrapper, ref: function ref(t) {
                  return e.wrapper = t;
                }, tabIndex: this.props.canChangeMonth && void 0 !== this.props.tabIndex ? this.props.tabIndex : -1, onKeyDown: this.handleKeyDown, onFocus: this.props.onFocus, onBlur: this.props.onBlur }, this.renderNavbar(), i.default.createElement("div", { className: this.props.classNames.months }, this.renderMonths()), this.renderFooter()));
            } }]), t;
        }(o.Component);w.propTypes = { initialMonth: s.default.instanceOf(Date), month: s.default.instanceOf(Date), numberOfMonths: s.default.number, fromMonth: s.default.instanceOf(Date), toMonth: s.default.instanceOf(Date), canChangeMonth: s.default.bool, reverseMonths: s.default.bool, pagedNavigation: s.default.bool, todayButton: s.default.string, showWeekNumbers: s.default.bool, showWeekDays: s.default.bool, selectedDays: s.default.oneOfType([s.default.object, s.default.func, s.default.array]), disabledDays: s.default.oneOfType([s.default.object, s.default.func, s.default.array]), modifiers: s.default.object, modifiersStyles: s.default.object, dir: s.default.string, firstDayOfWeek: s.default.oneOf([0, 1, 2, 3, 4, 5, 6]), labels: s.default.shape({ nextMonth: s.default.string.isRequired, previousMonth: s.default.string.isRequired }), locale: s.default.string, localeUtils: s.default.shape({ formatMonthTitle: s.default.func, formatWeekdayShort: s.default.func, formatWeekdayLong: s.default.func, getFirstDayOfWeek: s.default.func }), months: s.default.arrayOf(s.default.string), weekdaysLong: s.default.arrayOf(s.default.string), weekdaysShort: s.default.arrayOf(s.default.string), showOutsideDays: s.default.bool, enableOutsideDaysClick: s.default.bool, fixedWeeks: s.default.bool, classNames: s.default.shape({ body: s.default.string, container: s.default.string, day: s.default.string.isRequired, disabled: s.default.string.isRequired, footer: s.default.string, interactionDisabled: s.default.string, months: s.default.string, month: s.default.string, navBar: s.default.string, outside: s.default.string.isRequired, selected: s.default.string.isRequired, today: s.default.string.isRequired, todayButton: s.default.string, week: s.default.string, wrapper: s.default.string }), className: s.default.string, containerProps: s.default.object, tabIndex: s.default.number, renderDay: s.default.func, renderWeek: s.default.func, weekdayElement: s.default.oneOfType([s.default.element, s.default.func, s.default.instanceOf(o.Component)]), navbarElement: s.default.oneOfType([s.default.element, s.default.func, s.default.instanceOf(o.Component)]), captionElement: s.default.oneOfType([s.default.element, s.default.func, s.default.instanceOf(o.Component)]), onBlur: s.default.func, onFocus: s.default.func, onKeyDown: s.default.func, onDayClick: s.default.func, onDayKeyDown: s.default.func, onDayMouseEnter: s.default.func, onDayMouseLeave: s.default.func, onDayMouseDown: s.default.func, onDayMouseUp: s.default.func, onDayTouchStart: s.default.func, onDayTouchEnd: s.default.func, onDayFocus: s.default.func, onMonthChange: s.default.func, onCaptionClick: s.default.func, onWeekClick: s.default.func, onTodayButtonClick: s.default.func }, w.defaultProps = { classNames: y.default, tabIndex: 0, numberOfMonths: 1, labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, locale: "en", localeUtils: p, showOutsideDays: !1, enableOutsideDaysClick: !0, fixedWeeks: !1, canChangeMonth: !0, reverseMonths: !1, pagedNavigation: !1, showWeekNumbers: !1, showWeekDays: !0, renderDay: function renderDay(e) {
            return e.getDate();
          }, renderWeek: function renderWeek(e) {
            return e;
          }, weekdayElement: i.default.createElement(d.default, null), navbarElement: i.default.createElement(l.default, { classNames: y.default }), captionElement: i.default.createElement(u.default, { classNames: y.default }) }, w.VERSION = "7.4.8", w.DateUtils = h, w.LocaleUtils = p, w.ModifiersUtils = m, t.DateUtils = h, t.LocaleUtils = p, t.ModifiersUtils = m, t.default = w;
      }, 858: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });var n = _assign2.default || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];for (var n in r) {
              Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
          }return e;
        };t.cancelEvent = function (e) {
          e.preventDefault(), e.stopPropagation();
        }, t.getFirstDayOfMonth = u, t.getDaysInMonth = l, t.getModifiersFromProps = function (e) {
          var t = n({}, e.modifiers);return e.selectedDays && (t[e.classNames.selected] = e.selectedDays), e.disabledDays && (t[e.classNames.disabled] = e.disabledDays), t;
        }, t.getFirstDayOfWeekFromProps = function (e) {
          var t = e.firstDayOfWeek,
              r = e.locale,
              n = void 0 === r ? "en" : r,
              a = e.localeUtils,
              o = void 0 === a ? {} : a;return isNaN(t) ? o.getFirstDayOfWeek ? o.getFirstDayOfWeek(n) : 0 : t;
        }, t.isRangeOfDates = function (e) {
          return !!(e && e.from && e.to);
        }, t.getMonthsDiff = function (e, t) {
          return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
        }, t.getWeekArray = function (e) {
          for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, i.getFirstDayOfWeek)(), r = arguments[2], n = l(e), a = [], s = [], u = [], c = 1; c <= n; c += 1) {
            a.push(new Date(e.getFullYear(), e.getMonth(), c, 12));
          }a.forEach(function (e) {
            s.length > 0 && e.getDay() === t && (u.push(s), s = []), s.push(e), a.indexOf(e) === a.length - 1 && u.push(s);
          });for (var d = u[0], f = 7 - d.length; f > 0; f -= 1) {
            var h = (0, o.clone)(d[0]);h.setDate(d[0].getDate() - 1), d.unshift(h);
          }for (var p = u[u.length - 1], m = p.length; m < 7; m += 1) {
            var y = (0, o.clone)(p[p.length - 1]);y.setDate(p[p.length - 1].getDate() + 1), p.push(y);
          }if (r && u.length < 6) for (var g = void 0, b = u.length; b < 6; b += 1) {
            for (var v = (g = u[u.length - 1])[g.length - 1], w = [], k = 0; k < 7; k += 1) {
              var _ = (0, o.clone)(v);_.setDate(v.getDate() + k + 1), w.push(_);
            }u.push(w);
          }return u;
        }, t.startOfMonth = function (e) {
          var t = (0, o.clone)(e);return t.setDate(1), t.setHours(12, 0, 0, 0), t;
        }, t.getDayNodes = function (e, t) {
          var r = void 0;r = t === s.default ? t.day + "--" + t.outside : "" + t.outside;var n = "." + t.day.replace(/ /g, ".") + ":not(." + r.replace(/ /g, ".") + ")";return e.querySelectorAll(n);
        }, t.nodeListToArray = function (e) {
          return Array.prototype.slice.call(e, 0);
        }, t.hasOwnProp = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        };var a,
            o = r(167),
            i = r(727),
            s = (a = r(653)) && a.__esModule ? a : { default: a };function u(e) {
          return new Date(e.getFullYear(), e.getMonth(), 1, 12);
        }function l(e) {
          var t = u(e);return t.setMonth(t.getMonth() + 1), t.setDate(t.getDate() - 1), t.getDate();
        }
      }, 727: function _(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), t.formatDay = o, t.formatMonthTitle = i, t.formatWeekdayShort = s, t.formatWeekdayLong = u, t.getFirstDayOfWeek = l, t.getMonths = c;var r = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            n = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            a = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];function o(e) {
          return e.toDateString();
        }function i(e) {
          return a[e.getMonth()] + " " + e.getFullYear();
        }function s(e) {
          return n[e];
        }function u(e) {
          return r[e];
        }function l() {
          return 0;
        }function c() {
          return a;
        }t.default = { formatDay: o, formatMonthTitle: i, formatWeekdayShort: s, formatWeekdayLong: u, getFirstDayOfWeek: l, getMonths: c };
      }, 72: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), t.dayMatchesModifier = o, t.getModifiersForDay = i;var n = r(167),
            a = r(858);function o(e, t) {
          return !!t && (Array.isArray(t) ? t : [t]).some(function (t) {
            return !!t && (t instanceof Date ? (0, n.isSameDay)(e, t) : (0, a.isRangeOfDates)(t) ? (0, n.isDayInRange)(e, t) : t.after && t.before && (0, n.isDayAfter)(t.before, t.after) ? (0, n.isDayAfter)(e, t.after) && (0, n.isDayBefore)(e, t.before) : t.after && t.before && ((0, n.isDayAfter)(t.after, t.before) || (0, n.isSameDay)(t.after, t.before)) ? (0, n.isDayAfter)(e, t.after) || (0, n.isDayBefore)(e, t.before) : t.after ? (0, n.isDayAfter)(e, t.after) : t.before ? (0, n.isDayBefore)(e, t.before) : t.daysOfWeek ? t.daysOfWeek.some(function (t) {
              return e.getDay() === t;
            }) : "function" == typeof t && t(e));
          });
        }function i(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};return (0, _keys2.default)(t).reduce(function (r, n) {
            var a = t[n];return o(e, a) && r.push(n), r;
          }, []);
        }t.default = { dayMatchesModifier: o, getModifiersForDay: i };
      }, 599: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
          function e(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, _defineProperty2.default)(e, n.key, n);
            }
          }return function (t, r, n) {
            return r && e(t.prototype, r), n && e(t, n), t;
          };
        }(),
            a = r(698),
            o = p(a),
            i = p(r(697)),
            s = p(r(920)),
            u = p(r(777)),
            l = r(946),
            c = h(r(72)),
            d = h(r(858)),
            f = h(r(167));function h(e) {
          if (e && e.__esModule) return e;var t = {};if (null != e) for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }return t.default = e, t;
        }function p(e) {
          return e && e.__esModule ? e : { default: e };
        }function m(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }function y(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "function" != typeof t ? e : t;
        }var g = function (e) {
          function t() {
            var e, r, n;m(this, t);for (var a = arguments.length, i = Array(a), s = 0; s < a; s++) {
              i[s] = arguments[s];
            }return r = n = y(this, (e = t.__proto__ || (0, _getPrototypeOf2.default)(t)).call.apply(e, [this].concat(i))), n.renderDay = function (e) {
              var t = n.props.month.getMonth(),
                  r = d.getModifiersFromProps(n.props),
                  a = c.getModifiersForDay(e, r);f.isSameDay(e, new Date()) && !Object.prototype.hasOwnProperty.call(r, n.props.classNames.today) && a.push(n.props.classNames.today), e.getMonth() !== t && a.push(n.props.classNames.outside);var i = e.getMonth() !== t,
                  s = -1;n.props.onDayClick && !i && 1 === e.getDate() && (s = n.props.tabIndex);var l = "" + e.getFullYear() + e.getMonth() + e.getDate(),
                  h = {};return a.forEach(function (e) {
                h[e] = !0;
              }), o.default.createElement(u.default, { key: (i ? "outside-" : "") + l, classNames: n.props.classNames, day: e, modifiers: h, modifiersStyles: n.props.modifiersStyles, empty: i && !n.props.showOutsideDays && !n.props.fixedWeeks, tabIndex: s, ariaLabel: n.props.localeUtils.formatDay(e, n.props.locale), ariaDisabled: i || a.indexOf(n.props.classNames.disabled) > -1, ariaSelected: a.indexOf(n.props.classNames.selected) > -1, onClick: n.props.onDayClick, onFocus: n.props.onDayFocus, onKeyDown: n.props.onDayKeyDown, onMouseEnter: n.props.onDayMouseEnter, onMouseLeave: n.props.onDayMouseLeave, onMouseDown: n.props.onDayMouseDown, onMouseUp: n.props.onDayMouseUp, onTouchEnd: n.props.onDayTouchEnd, onTouchStart: n.props.onDayTouchStart }, n.props.renderDay(e, h));
            }, y(n, r);
          }return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)));e.prototype = (0, _create2.default)(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(e, t) : e.__proto__ = t);
          }(t, e), n(t, [{ key: "render", value: function value() {
              var e = this,
                  t = this.props,
                  r = t.classNames,
                  n = t.month,
                  a = t.months,
                  i = t.fixedWeeks,
                  u = t.captionElement,
                  c = t.weekdayElement,
                  h = t.locale,
                  p = t.localeUtils,
                  m = t.weekdaysLong,
                  y = t.weekdaysShort,
                  g = t.firstDayOfWeek,
                  b = t.onCaptionClick,
                  v = t.showWeekNumbers,
                  w = t.showWeekDays,
                  k = t.onWeekClick,
                  _ = { date: n, classNames: r, months: a, localeUtils: p, locale: h, onClick: b ? function (e) {
                  return b(n, e);
                } : void 0 },
                  D = o.default.isValidElement(u) ? o.default.cloneElement(u, _) : o.default.createElement(u, _),
                  M = d.getWeekArray(n, g, i);return o.default.createElement("div", { className: r.month, role: "grid" }, D, w && o.default.createElement(s.default, { classNames: r, weekdaysShort: y, weekdaysLong: m, firstDayOfWeek: g, showWeekNumbers: v, locale: h, localeUtils: p, weekdayElement: c }), o.default.createElement("div", { className: r.body, role: "rowgroup" }, M.map(function (t) {
                var a = void 0;return v && (a = f.getWeekNumber(t[6])), o.default.createElement("div", { key: t[0].getTime(), className: r.week, role: "row" }, v && o.default.createElement("div", { className: r.weekNumber, tabIndex: k ? 0 : -1, role: "gridcell", onClick: k ? function (e) {
                    return k(a, t, e);
                  } : void 0, onKeyUp: k ? function (e) {
                    return e.keyCode === l.ENTER && k(a, t, e);
                  } : void 0 }, e.props.renderWeek(a, t, n)), t.map(e.renderDay));
              })));
            } }]), t;
        }(a.Component);g.propTypes = { classNames: i.default.shape({ body: i.default.string.isRequired, month: i.default.string.isRequired, outside: i.default.string.isRequired, today: i.default.string.isRequired, week: i.default.string.isRequired, weekNumber: i.default.string.isRequired, disabled: i.default.string.isRequired, selected: i.default.string.isRequired }).isRequired, tabIndex: i.default.number, month: i.default.instanceOf(Date).isRequired, months: i.default.arrayOf(i.default.string), modifiersStyles: i.default.object, showWeekDays: i.default.bool, showOutsideDays: i.default.bool, renderDay: i.default.func.isRequired, renderWeek: i.default.func.isRequired, captionElement: i.default.oneOfType([i.default.element, i.default.func, i.default.instanceOf(o.default.Component)]).isRequired, weekdayElement: i.default.oneOfType([i.default.element, i.default.func, i.default.instanceOf(o.default.Component)]), fixedWeeks: i.default.bool, showWeekNumbers: i.default.bool, locale: i.default.string.isRequired, localeUtils: i.default.object.isRequired, weekdaysLong: i.default.arrayOf(i.default.string), weekdaysShort: i.default.arrayOf(i.default.string), firstDayOfWeek: i.default.number.isRequired, onCaptionClick: i.default.func, onDayClick: i.default.func, onDayFocus: i.default.func, onDayKeyDown: i.default.func, onDayMouseEnter: i.default.func, onDayMouseLeave: i.default.func, onDayMouseDown: i.default.func, onDayMouseUp: i.default.func, onDayTouchEnd: i.default.func, onDayTouchStart: i.default.func, onWeekClick: i.default.func }, t.default = g;
      }, 34: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
          function e(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, _defineProperty2.default)(e, n.key, n);
            }
          }return function (t, r, n) {
            return r && e(t.prototype, r), n && e(t, n), t;
          };
        }(),
            a = r(698),
            o = l(a),
            i = l(r(697)),
            s = l(r(653)),
            u = r(946);function l(e) {
          return e && e.__esModule ? e : { default: e };
        }function c(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }function d(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "function" != typeof t ? e : t;
        }var f = function (e) {
          function t() {
            var e, r, n;c(this, t);for (var a = arguments.length, o = Array(a), i = 0; i < a; i++) {
              o[i] = arguments[i];
            }return r = n = d(this, (e = t.__proto__ || (0, _getPrototypeOf2.default)(t)).call.apply(e, [this].concat(o))), n.handleNextClick = function () {
              n.props.onNextClick && n.props.onNextClick();
            }, n.handlePreviousClick = function () {
              n.props.onPreviousClick && n.props.onPreviousClick();
            }, n.handleNextKeyDown = function (e) {
              e.keyCode !== u.ENTER && e.keyCode !== u.SPACE || (e.preventDefault(), n.handleNextClick());
            }, n.handlePreviousKeyDown = function (e) {
              e.keyCode !== u.ENTER && e.keyCode !== u.SPACE || (e.preventDefault(), n.handlePreviousClick());
            }, d(n, r);
          }return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)));e.prototype = (0, _create2.default)(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(e, t) : e.__proto__ = t);
          }(t, e), n(t, [{ key: "shouldComponentUpdate", value: function value(e) {
              return e.labels !== this.props.labels || e.dir !== this.props.dir || this.props.showPreviousButton !== e.showPreviousButton || this.props.showNextButton !== e.showNextButton;
            } }, { key: "render", value: function value() {
              var e = this.props,
                  t = e.classNames,
                  r = e.className,
                  n = e.showPreviousButton,
                  a = e.showNextButton,
                  i = e.labels,
                  s = e.dir,
                  u = void 0,
                  l = void 0,
                  c = void 0,
                  d = void 0,
                  f = void 0,
                  h = void 0;"rtl" === s ? (u = this.handleNextClick, l = this.handlePreviousClick, c = this.handleNextKeyDown, d = this.handlePreviousKeyDown, h = n, f = a) : (u = this.handlePreviousClick, l = this.handleNextClick, c = this.handlePreviousKeyDown, d = this.handleNextKeyDown, h = a, f = n);var p = f ? t.navButtonPrev : t.navButtonPrev + " " + t.navButtonInteractionDisabled,
                  m = h ? t.navButtonNext : t.navButtonNext + " " + t.navButtonInteractionDisabled,
                  y = o.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": i.previousMonth, key: "previous", className: p, onKeyDown: f ? c : void 0, onClick: f ? u : void 0 }),
                  g = o.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": i.nextMonth, key: "right", className: m, onKeyDown: h ? d : void 0, onClick: h ? l : void 0 });return o.default.createElement("div", { className: r || t.navBar }, "rtl" === s ? [g, y] : [y, g]);
            } }]), t;
        }(a.Component);f.propTypes = { classNames: i.default.shape({ navBar: i.default.string.isRequired, navButtonPrev: i.default.string.isRequired, navButtonNext: i.default.string.isRequired, navButtonInteractionDisabled: i.default.string.isRequired }), className: i.default.string, showPreviousButton: i.default.bool, showNextButton: i.default.bool, onPreviousClick: i.default.func, onNextClick: i.default.func, dir: i.default.string, labels: i.default.shape({ previousMonth: i.default.string.isRequired, nextMonth: i.default.string.isRequired }) }, f.defaultProps = { classNames: s.default, dir: "ltr", labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, showPreviousButton: !0, showNextButton: !0 }, t.default = f;
      }, 823: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
          function e(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, _defineProperty2.default)(e, n.key, n);
            }
          }return function (t, r, n) {
            return r && e(t.prototype, r), n && e(t, n), t;
          };
        }(),
            a = r(698),
            o = s(a),
            i = s(r(697));function s(e) {
          return e && e.__esModule ? e : { default: e };
        }function u(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }function l(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "function" != typeof t ? e : t;
        }var c = function (e) {
          function t() {
            return u(this, t), l(this, (t.__proto__ || (0, _getPrototypeOf2.default)(t)).apply(this, arguments));
          }return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)));e.prototype = (0, _create2.default)(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(e, t) : e.__proto__ = t);
          }(t, e), n(t, [{ key: "shouldComponentUpdate", value: function value(e) {
              return this.props !== e;
            } }, { key: "render", value: function value() {
              var e,
                  t = this.props,
                  r = t.weekday,
                  n = t.className,
                  a = t.weekdaysLong,
                  i = t.weekdaysShort,
                  s = t.localeUtils,
                  u = t.locale;e = a ? a[r] : s.formatWeekdayLong(r, u);var l;return l = i ? i[r] : s.formatWeekdayShort(r, u), o.default.createElement("div", { className: n, role: "columnheader" }, o.default.createElement("abbr", { title: e }, l));
            } }]), t;
        }(a.Component);c.propTypes = { weekday: i.default.number, className: i.default.string, locale: i.default.string, localeUtils: i.default.object, weekdaysLong: i.default.arrayOf(i.default.string), weekdaysShort: i.default.arrayOf(i.default.string) }, t.default = c;
      }, 920: function _(e, t, r) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
          function e(e, t) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, _defineProperty2.default)(e, n.key, n);
            }
          }return function (t, r, n) {
            return r && e(t.prototype, r), n && e(t, n), t;
          };
        }(),
            a = r(698),
            o = s(a),
            i = s(r(697));function s(e) {
          return e && e.__esModule ? e : { default: e };
        }function u(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }function l(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "function" != typeof t ? e : t;
        }var c = function (e) {
          function t() {
            return u(this, t), l(this, (t.__proto__ || (0, _getPrototypeOf2.default)(t)).apply(this, arguments));
          }return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)));e.prototype = (0, _create2.default)(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(e, t) : e.__proto__ = t);
          }(t, e), n(t, [{ key: "shouldComponentUpdate", value: function value(e) {
              return this.props !== e;
            } }, { key: "render", value: function value() {
              for (var e = this.props, t = e.classNames, r = e.firstDayOfWeek, n = e.showWeekNumbers, a = e.weekdaysLong, i = e.weekdaysShort, s = e.locale, u = e.localeUtils, l = e.weekdayElement, c = [], d = 0; d < 7; d += 1) {
                var f = (d + r) % 7,
                    h = { key: d, className: t.weekday, weekday: f, weekdaysLong: a, weekdaysShort: i, localeUtils: u, locale: s },
                    p = o.default.isValidElement(l) ? o.default.cloneElement(l, h) : o.default.createElement(l, h);c.push(p);
              }return o.default.createElement("div", { className: t.weekdays, role: "rowgroup" }, o.default.createElement("div", { className: t.weekdaysRow, role: "row" }, n && o.default.createElement("div", { className: t.weekday }), c));
            } }]), t;
        }(a.Component);c.propTypes = { classNames: i.default.shape({ weekday: i.default.string.isRequired, weekdays: i.default.string.isRequired, weekdaysRow: i.default.string.isRequired }).isRequired, firstDayOfWeek: i.default.number.isRequired, weekdaysLong: i.default.arrayOf(i.default.string), weekdaysShort: i.default.arrayOf(i.default.string), showWeekNumbers: i.default.bool, locale: i.default.string.isRequired, localeUtils: i.default.object.isRequired, weekdayElement: i.default.oneOfType([i.default.element, i.default.func, i.default.instanceOf(o.default.Component)]) }, t.default = c;
      }, 653: function _(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { container: "DayPicker", wrapper: "DayPicker-wrapper", interactionDisabled: "DayPicker--interactionDisabled", months: "DayPicker-Months", month: "DayPicker-Month", navBar: "DayPicker-NavBar", navButtonPrev: "DayPicker-NavButton DayPicker-NavButton--prev", navButtonNext: "DayPicker-NavButton DayPicker-NavButton--next", navButtonInteractionDisabled: "DayPicker-NavButton--interactionDisabled", caption: "DayPicker-Caption", weekdays: "DayPicker-Weekdays", weekdaysRow: "DayPicker-WeekdaysRow", weekday: "DayPicker-Weekday", body: "DayPicker-Body", week: "DayPicker-Week", weekNumber: "DayPicker-WeekNumber", day: "DayPicker-Day", footer: "DayPicker-Footer", todayButton: "DayPicker-TodayButton", today: "today", selected: "selected", disabled: "disabled", outside: "outside" };
      }, 737: function _(e, t, r) {
        "use strict";
        var n = r(306);Object.defineProperty(t, "ZP", { enumerable: !0, get: function get() {
            return o(n).default;
          } });r(167);var a = r(727);Object.defineProperty(t, "dl", { enumerable: !0, get: function get() {
            return o(a).default;
          } });r(72);function o(e) {
          return e && e.__esModule ? e : { default: e };
        }
      }, 946: function _(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }), t.LEFT = 37, t.UP = 38, t.RIGHT = 39, t.DOWN = 40, t.ENTER = 13, t.SPACE = 32, t.ESC = 27, t.TAB = 9;
      }, 379: function _(e, t, r) {
        "use strict";
        var n,
            a = function () {
          var e = {};return function (t) {
            if (void 0 === e[t]) {
              var r = document.querySelector(t);if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                r = r.contentDocument.head;
              } catch (e) {
                r = null;
              }e[t] = r;
            }return e[t];
          };
        }(),
            o = [];function i(e) {
          for (var t = -1, r = 0; r < o.length; r++) {
            if (o[r].identifier === e) {
              t = r;break;
            }
          }return t;
        }function s(e, t) {
          for (var r = {}, n = [], a = 0; a < e.length; a++) {
            var s = e[a],
                u = t.base ? s[0] + t.base : s[0],
                l = r[u] || 0,
                c = "".concat(u, " ").concat(l);r[u] = l + 1;var d = i(c),
                f = { css: s[1], media: s[2], sourceMap: s[3] };-1 !== d ? (o[d].references++, o[d].updater(f)) : o.push({ identifier: c, updater: m(f, t), references: 1 }), n.push(c);
          }return n;
        }function u(e) {
          var t = document.createElement("style"),
              n = e.attributes || {};if (void 0 === n.nonce) {
            var o = r.nc;o && (n.nonce = o);
          }if ((0, _keys2.default)(n).forEach(function (e) {
            t.setAttribute(e, n[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var i = a(e.insert || "head");if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");i.appendChild(t);
          }return t;
        }var l,
            c = (l = [], function (e, t) {
          return l[e] = t, l.filter(Boolean).join("\n");
        });function d(e, t, r, n) {
          var a = r ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;if (e.styleSheet) e.styleSheet.cssText = c(t, a);else {
            var o = document.createTextNode(a),
                i = e.childNodes;i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(o, i[t]) : e.appendChild(o);
          }
        }function f(e, t, r) {
          var n = r.css,
              a = r.media,
              o = r.sourceMap;if (a ? e.setAttribute("media", a) : e.removeAttribute("media"), o && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent((0, _stringify2.default)(o)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
            for (; e.firstChild;) {
              e.removeChild(e.firstChild);
            }e.appendChild(document.createTextNode(n));
          }
        }var h = null,
            p = 0;function m(e, t) {
          var r, n, a;if (t.singleton) {
            var o = p++;r = h || (h = u(t)), n = d.bind(null, r, o, !1), a = d.bind(null, r, o, !0);
          } else r = u(t), n = f.bind(null, r, t), a = function a() {
            !function (e) {
              if (null === e.parentNode) return !1;e.parentNode.removeChild(e);
            }(r);
          };return n(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;n(e = t);
            } else a();
          };
        }e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = (void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n));var r = s(e = e || [], t);return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var n = 0; n < r.length; n++) {
                var a = i(r[n]);o[a].references--;
              }for (var u = s(e, t), l = 0; l < r.length; l++) {
                var c = i(r[l]);0 === o[c].references && (o[c].updater(), o.splice(c, 1));
              }r = u;
            }
          };
        };
      }, 698: function _(t) {
        "use strict";
        t.exports = e;
      } },
        r = {};function n(e) {
      if (r[e]) return r[e].exports;var a = r[e] = { id: e, exports: {} };return t[e](a, a.exports, n), a.exports;
    }return n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return n.d(t, { a: t }), t;
    }, n.d = function (e, t) {
      for (var r in t) {
        n.o(t, r) && !n.o(e, r) && (0, _defineProperty2.default)(e, r, { enumerable: !0, get: t[r] });
      }
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof _symbol2.default && _toStringTag2.default && (0, _defineProperty2.default)(e, _toStringTag2.default, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
    }, n(258);
  }();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81), __webpack_require__(252)(module)))

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1971), __esModule: true };

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(246);
module.exports = __webpack_require__(378).f('toStringTag');


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WebchatLink() {
    var url = (0, _react.useMemo)(function () {
        return _config2.default.get('webchatIframeSrc');
    }, []);

    var handleClick = function handleClick() {
        _TrackingActions2.default.webchatOpened();
    };

    return _react2.default.createElement(
        'a',
        {
            href: url,
            className: 'navlink__webchat btn',
            'aria-label': (0, _I18n.translate)('ariaLabel.webchatButton'),
            target: '_blank',
            tabIndex: '0',
            onClick: handleClick
        },
        _react2.default.createElement(_Icon2.default, { icon: 'chat' })
    );
}

WebchatLink.propTypes = {};

exports.default = WebchatLink;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Logo = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

var _AppConstants = __webpack_require__(6);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = exports.Logo = function Logo() {
    var brandMainSiteUrl = _config2.default.get('mainSiteUrl');
    var isProd = _config2.default.get('environment') === 'prod';
    var enableLogoRedirectToSearchPage = !isProd || _FeatureFlagStore2.default.get('enableLogoRedirectToSearchPage');

    var commonProps = {
        tabIndex: '0',
        className: 'header__logo sr-container'
    };

    var LogoContent = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement('img', { 'area-hidden': 'true', src: '/images/logos/' + _config2.default.get('brand') + '-logo.png', alt: (0, _I18n.translate)('app.owner') + ' logo' }),
        _react2.default.createElement(
            'span',
            { className: 'sr-text' },
            (0, _I18n.translate)('app.owner')
        )
    );

    if (enableLogoRedirectToSearchPage) {
        return _react2.default.createElement(
            _Link2.default,
            (0, _extends3.default)({ to: _AppConstants.PointStages.SEARCH }, commonProps),
            LogoContent
        );
    }

    return _react2.default.createElement(
        'a',
        (0, _extends3.default)({ href: brandMainSiteUrl }, commonProps),
        LogoContent
    );
};

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _brand = __webpack_require__(435);

var _AppConstants = __webpack_require__(6);

var _PaymentMethods = __webpack_require__(1975);

var _PaymentMethods2 = _interopRequireDefault(_PaymentMethods);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _InternalLink = __webpack_require__(1976);

var _InternalLink2 = _interopRequireDefault(_InternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FooterLink(_ref) {
    var _ref$url = _ref.url,
        url = _ref$url === undefined ? '' : _ref$url,
        _ref$message = _ref.message,
        message = _ref$message === undefined ? '' : _ref$message,
        _ref$isInternal = _ref.isInternal,
        isInternal = _ref$isInternal === undefined ? false : _ref$isInternal;

    var Link = isInternal ? _InternalLink2.default : _ExternalLink2.default;

    return url ? _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(Link, {
            href: url,
            message: message,
            className: 'footer__main-link'
        })
    ) : null;
}

FooterLink.propTypes = {
    url: _propTypes2.default.string,
    message: _propTypes2.default.string,
    isInternal: _propTypes2.default.bool
};

var Footer = function Footer(_ref2) {
    var hasFooterPoweredByOn = _ref2.hasFooterPoweredByOn;

    var helpUrl = _config2.default.get('name') === _AppConstants.AppName.DELAY_REPAY ? 'delayRepayUrl' : 'helpUrl';

    var internalLinks = _config2.default.get('enableFooterLinkInternal');
    var Link = internalLinks.includes('mainSiteUrl') ? _InternalLink2.default : _ExternalLink2.default;

    var getLinkProps = function getLinkProps(key) {
        return {
            key: key,
            url: _config2.default.get(key),
            isInternal: internalLinks.includes(key)
        };
    };

    var onOpenPreferences = function onOpenPreferences() {
        if (window.UC_UI) {
            window.UC_UI.showSecondLayer();
        }
    };

    var _getBrandInfo = (0, _brand.getBrandInfo)(),
        isSouthEastern = _getBrandInfo.isSouthEastern;

    return _react2.default.createElement(
        'footer',
        {
            className: (0, _classnames2.default)("container-fluid footer fx-powered-by-on hidden-print", {
                "footer--with-powered-by-on": hasFooterPoweredByOn
            })
        },
        _react2.default.createElement(
            'nav',
            { role: 'navigation' },
            _react2.default.createElement(
                'ul',
                { className: 'pull-right no-margin list-inline list-styled' },
                _react2.default.createElement(FooterLink, (0, _extends3.default)({}, getLinkProps('legalUrl'), {
                    message: 'footer.legal'
                })),
                isSouthEastern && _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'footer__link-btn',
                            type: 'button',
                            onClick: onOpenPreferences
                        },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Change Preferences'
                        ),
                        _react2.default.createElement('i', { className: 'otrl otrl-externallink' })
                    )
                ),
                _react2.default.createElement(FooterLink, (0, _extends3.default)({}, getLinkProps('accessibilityStatementUrl'), {
                    message: 'footer.accessibilityStatement'
                })),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableFooterOwnerLink' },
                    _react2.default.createElement(FooterLink, (0, _extends3.default)({}, getLinkProps('ownerUrl'), {
                        message: 'footer.owner'
                    }))
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableFooterFaqsLink' },
                    _react2.default.createElement(FooterLink, (0, _extends3.default)({}, getLinkProps('faqUrl'), {
                        message: 'footer.faqs'
                    }))
                ),
                _react2.default.createElement(FooterLink, (0, _extends3.default)({}, getLinkProps('contactUrl'), {
                    message: 'footer.contact'
                })),
                _react2.default.createElement(FooterLink, (0, _extends3.default)({}, getLinkProps('helpUrl'), {
                    url: _config2.default.get(helpUrl),
                    message: 'global.banner.beta.help'
                }))
            )
        ),
        _react2.default.createElement(Link, {
            href: _config2.default.get('mainSiteUrl'),
            message: (0, _I18n.translate)('global.backToMainSite', {
                brand: (0, _I18n.translate)('footer.link', null, (0, _I18n.translate)('app.owner'))
            }),
            className: 'footer__main-link pull-left'
        }),
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableFooterPaymentMethods' },
            _react2.default.createElement(_PaymentMethods2.default, { className: 'padding--horiz' })
        )
    );
};

Footer.propTypes = {
    hasFooterPoweredByOn: _propTypes2.default.bool
};

Footer.defaultProps = {
    hasFooterPoweredByOn: false
};

exports.default = Footer;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = PaymentMethods;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaymentMethods(_ref) {
    var className = _ref.className;

    return _react2.default.createElement(
        'ul',
        { className: 'payment-methods-list ' + className },
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableAmazonPay' },
            _react2.default.createElement(
                'li',
                { className: 'payment-methods--amazonpay' },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('payment.method.amazonPay')
                )
            )
        ),
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enablePaypal' },
            _react2.default.createElement(
                'li',
                { className: 'payment-methods--paypal' },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('payment.method.paypal')
                )
            )
        ),
        _react2.default.createElement(
            'li',
            { className: 'payment-methods--visa' },
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _I18n.translate)('payment.cardType.visa')
            )
        ),
        _react2.default.createElement(
            'li',
            { className: 'payment-methods--mastercard' },
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _I18n.translate)('payment.cardType.mastercard')
            )
        ),
        _react2.default.createElement(
            'li',
            { className: 'payment-methods--maestro' },
            _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _I18n.translate)('payment.cardType.maestro')
            )
        ),
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableAmexPayments' },
            _react2.default.createElement(
                'li',
                { className: 'payment-methods--amex' },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('payment.cardType.amex')
                )
            )
        ),
        _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableSafeKey' },
            _react2.default.createElement(
                'li',
                { className: 'payment-methods--safekey' },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)('payment.security.safekey')
                )
            )
        )
    );
}

PaymentMethods.propTypes = {
    className: _propTypes2.default.string
};

PaymentMethods.defaultProps = {
    className: ''
};

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InternalLink(_ref) {
    var message = _ref.message,
        href = _ref.href,
        className = _ref.className,
        noUnderline = _ref.noUnderline;

    var messageClassName = (0, _classnames2.default)('internal-link', {
        'internal-link-no-underline': noUnderline
    });

    return _react2.default.createElement(
        'a',
        { href: href, className: (0, _classnames2.default)('external-link-no-underline', className) },
        _react2.default.createElement(_FormattedHTMLMessage2.default, { className: messageClassName, message: message })
    );
}

InternalLink.propTypes = {
    message: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    noUnderline: _propTypes2.default.bool,
    srOnly: _propTypes2.default.string
};

InternalLink.defaultProps = {
    className: '',
    noUnderline: false,
    srOnly: ''
};

exports.default = InternalLink;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PoweredBy = __webpack_require__(1082);

var _PoweredBy2 = _interopRequireDefault(_PoweredBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterPoweredBy = function FooterPoweredBy() {
    return _react2.default.createElement(
        "div",
        { className: "footer-powered-by" },
        _react2.default.createElement(_PoweredBy2.default, null)
    );
};

exports.default = _react2.default.memo(FooterPoweredBy);

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isFunction2 = __webpack_require__(202);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _ModalComponents, _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _ModalStore = __webpack_require__(833);

var _ModalStore2 = _interopRequireDefault(_ModalStore);

var _AppConstants = __webpack_require__(6);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _PropTypes = __webpack_require__(85);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _RegisterModal = __webpack_require__(1104);

var _RegisterModal2 = _interopRequireDefault(_RegisterModal);

var _LoginModal = __webpack_require__(994);

var _LoginModal2 = _interopRequireDefault(_LoginModal);

var _SmartcardModal = __webpack_require__(1072);

var _SmartcardModal2 = _interopRequireDefault(_SmartcardModal);

var _ErrorModal = __webpack_require__(681);

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

var _InfoModal = __webpack_require__(2036);

var _InfoModal2 = _interopRequireDefault(_InfoModal);

var _ConfirmationModal = __webpack_require__(2037);

var _ConfirmationModal2 = _interopRequireDefault(_ConfirmationModal);

var _BasketModal = __webpack_require__(2038);

var _BasketModal2 = _interopRequireDefault(_BasketModal);

var _BasketExpiredModal = __webpack_require__(2094);

var _BasketExpiredModal2 = _interopRequireDefault(_BasketExpiredModal);

var _ForgotPassword = __webpack_require__(2095);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _LoggedOutModal = __webpack_require__(2097);

var _LoggedOutModal2 = _interopRequireDefault(_LoggedOutModal);

var _LogoutWarningModal = __webpack_require__(2098);

var _LogoutWarningModal2 = _interopRequireDefault(_LogoutWarningModal);

var _TransferModal = __webpack_require__(2099);

var _TransferModal2 = _interopRequireDefault(_TransferModal);

var _OrderStateErrorModal = __webpack_require__(2102);

var _OrderStateErrorModal2 = _interopRequireDefault(_OrderStateErrorModal);

var _InteropErrorModal = __webpack_require__(2103);

var _InteropErrorModal2 = _interopRequireDefault(_InteropErrorModal);

var _AmazonSyncEmailModal = __webpack_require__(2104);

var _AmazonSyncEmailModal2 = _interopRequireDefault(_AmazonSyncEmailModal);

var _PromptPasswordChangeModal = __webpack_require__(934);

var _PromptPasswordChangeModal2 = _interopRequireDefault(_PromptPasswordChangeModal);

var _PassengerAssistBookingModal = __webpack_require__(2105);

var _PassengerAssistBookingModal2 = _interopRequireDefault(_PassengerAssistBookingModal);

var _ChildSmartCardExpirationModal = __webpack_require__(2155);

var _AddReservationModal = __webpack_require__(1182);

var _AddReservationModal2 = _interopRequireDefault(_AddReservationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalComponents = (_ModalComponents = {}, _ModalComponents[_AppConstants.GlobalModals.REGISTER] = _react2.default.createFactory(_RegisterModal2.default), _ModalComponents[_AppConstants.GlobalModals.LOGIN] = _react2.default.createFactory(_LoginModal2.default), _ModalComponents[_AppConstants.GlobalModals.REGISTER_SMARTCARD] = _react2.default.createFactory(_SmartcardModal2.default), _ModalComponents[_AppConstants.GlobalModals.ERROR] = _react2.default.createFactory(_ErrorModal2.default), _ModalComponents[_AppConstants.GlobalModals.INFO] = _react2.default.createFactory(_InfoModal2.default), _ModalComponents[_AppConstants.GlobalModals.BASKET] = _react2.default.createFactory(_BasketModal2.default), _ModalComponents[_AppConstants.GlobalModals.BASKET_EXPIRED] = _react2.default.createFactory(_BasketExpiredModal2.default), _ModalComponents[_AppConstants.GlobalModals.FORGOT_PASSWORD] = _react2.default.createFactory(_ForgotPassword2.default), _ModalComponents[_AppConstants.GlobalModals.LOGGED_OUT] = _react2.default.createFactory(_LoggedOutModal2.default), _ModalComponents[_AppConstants.GlobalModals.LOGOUT_WARNING] = _react2.default.createFactory(_LogoutWarningModal2.default), _ModalComponents[_AppConstants.GlobalModals.NRE] = _react2.default.createFactory(_TransferModal2.default), _ModalComponents[_AppConstants.GlobalModals.ORDER_STATE_ERROR] = _react2.default.createFactory(_OrderStateErrorModal2.default), _ModalComponents[_AppConstants.GlobalModals.INTEROP_ERROR] = _react2.default.createFactory(_InteropErrorModal2.default), _ModalComponents[_AppConstants.GlobalModals.CONFIRM] = _react2.default.createFactory(_ConfirmationModal2.default), _ModalComponents[_AppConstants.GlobalModals.SYNC_EMAIL_AMAZON_LOGIN] = _react2.default.createFactory(_AmazonSyncEmailModal2.default), _ModalComponents[_AppConstants.GlobalModals.PROMPT_PASSWORD_CHANGE] = _react2.default.createFactory(_PromptPasswordChangeModal2.default), _ModalComponents[_AppConstants.GlobalModals.BOOK_PASSENGER_ASSIST] = _react2.default.createFactory(_PassengerAssistBookingModal2.default), _ModalComponents[_AppConstants.GlobalModals.CHILD_SMART_CARD_EXPIRATION] = _react2.default.createFactory(_ChildSmartCardExpirationModal.ChildSmartCardExpirationModal), _ModalComponents[_AppConstants.GlobalModals.RESERVATIONS] = _react2.default.createFactory(_AddReservationModal2.default), _ModalComponents);

function _stateFromStores() {
    return {
        active: _ModalStore2.default.getActive(),
        data: _ModalStore2.default.getData()
    };
}

var GlobalModalsComponent = (_dec = (0, _connectToStores2.default)([_ModalStore2.default], _stateFromStores), (0, _withRouter2.default)(_class = _dec(_class = (_temp = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(GlobalModalsComponent, _PureRenderComponent);

    function GlobalModalsComponent() {
        (0, _classCallCheck3.default)(this, GlobalModalsComponent);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    GlobalModalsComponent.prototype.render = function render() {
        var _props = this.props,
            active = _props.active,
            data = _props.data,
            router = _props.router;


        if (!active) {
            return null;
        }

        var props = (0, _assign2.default)({ router: router }, data);

        if ((0, _isFunction3.default)(active)) {
            return _react2.default.createFactory(active)(props);
        }
        return ModalComponents[active](props);
    };

    return GlobalModalsComponent;
}(_PureRenderComponent3.default), _class2.propTypes = {
    router: _PropTypes.routerShape,
    active: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    data: _propTypes2.default.any
}, _temp)) || _class) || _class);
exports.default = GlobalModalsComponent;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1980),
    isIterateeCall = __webpack_require__(236),
    toFinite = __webpack_require__(519);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1980 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AMAZON_AUTHENTICATED = exports.AMAZON_LOGIN_ADDITONAL_HEADERS = exports.AMAZON_LOGIN_API_AUTHENTICATE = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _AmazonLoginError = __webpack_require__(920);

var _AmazonAPIClient = __webpack_require__(921);

var _AmazonAPIClient2 = _interopRequireDefault(_AmazonAPIClient);

var _AuthToken = __webpack_require__(392);

var _AuthToken2 = _interopRequireDefault(_AuthToken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AMAZON_LOGIN_API_AUTHENTICATE = exports.AMAZON_LOGIN_API_AUTHENTICATE = '/customers/auth/amazon';
var AMAZON_LOGIN_ADDITONAL_HEADERS = exports.AMAZON_LOGIN_ADDITONAL_HEADERS = { 'Accept-version': 'v2' };
var AMAZON_AUTHENTICATED = exports.AMAZON_AUTHENTICATED = true;

var options = void 0;

var AmazonLoginService = {
    authenticate: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
            var accessToken = _ref.accessToken;
            var response, request, token;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            response = void 0;
                            request = {
                                token: accessToken
                            };
                            _context.prev = 2;
                            _context.next = 5;
                            return _AmazonAPIClient2.default.post(AMAZON_LOGIN_API_AUTHENTICATE, request, options, AMAZON_LOGIN_ADDITONAL_HEADERS);

                        case 5:
                            response = _context.sent;


                            AmazonLoginService.retrieveProfile(accessToken);

                            token = _AuthToken2.default.fromAmazon(response);
                            return _context.abrupt('return', { token: token, status: response.status });

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](2);

                            if (!(_context.t0.body && _context.t0.body.status)) {
                                _context.next = 15;
                                break;
                            }

                            throw new _AmazonLoginError.AmazonLoginError(_context.t0.body.status, { customer: _context.t0.body.customer });

                        case 15:
                            throw new _AmazonLoginError.AmazonLoginError(_context.t0);

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[2, 11]]);
        }));

        function authenticate(_x) {
            return _ref2.apply(this, arguments);
        }

        return authenticate;
    }(),
    init: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref3) {
            var _options = _ref3.options;
            var defaults;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            defaults = {
                                handleOnRetrieveProfile: _noop3.default
                            };

                            options = (0, _extends3.default)({}, defaults, _options);

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function init(_x2) {
            return _ref4.apply(this, arguments);
        }

        return init;
    }(),
    linkAccount: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref5) {
            var _ref5$email = _ref5.email,
                email = _ref5$email === undefined ? '' : _ref5$email,
                _ref5$password = _ref5.password,
                password = _ref5$password === undefined ? '' : _ref5$password;
            var request;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            request = {
                                email: email,
                                password: password
                            };
                            _context3.next = 3;
                            return _AmazonAPIClient2.default.put(AMAZON_LOGIN_API_AUTHENTICATE, request, options, AMAZON_LOGIN_ADDITONAL_HEADERS);

                        case 3:
                            return _context3.abrupt('return', _context3.sent);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function linkAccount(_x3) {
            return _ref6.apply(this, arguments);
        }

        return linkAccount;
    }(),
    retrieveProfile: function retrieveProfile(accessToken) {
        if (window.amazon && window.amazon.Login) {
            var callback = options && typeof options.handleOnRetrieveProfile === 'function' ? options.handleOnRetrieveProfile : _noop3.default;
            window.amazon.Login.retrieveProfile(accessToken, callback);
        }
    },
    unlinkAccount: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _AmazonAPIClient2.default.delete(AMAZON_LOGIN_API_AUTHENTICATE, null, options, AMAZON_LOGIN_ADDITONAL_HEADERS, AMAZON_AUTHENTICATED);

                        case 2:
                            return _context4.abrupt('return', _context4.sent);

                        case 3:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function unlinkAccount() {
            return _ref7.apply(this, arguments);
        }

        return unlinkAccount;
    }()
};

exports.default = AmazonLoginService;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExclamationIcon = function ExclamationIcon(_ref) {
    var className = _ref.className,
        props = (0, _objectWithoutProperties3.default)(_ref, ['className']);
    return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({ className: (0, _classnames2.default)('otrl-icon__shadow', className), xmlns: 'http://www.w3.org/2000/svg', id: 'svg1589', version: '1.1', viewBox: '0 0 74.4 74.64', width: '120', height: '120' }, props),
        _react2.default.createElement('circle', { cx: '35.8', cy: '35.94', r: '22.12', fill: 'currentColor' }),
        _react2.default.createElement('path', { d: 'M35.08 39.54a1.32 1.32 0 01-.35-.82l-1-10.89v-.28a1.72 1.72 0 01.6-1.38 2.5 2.5 0 013 0 1.72 1.72 0 01.6 1.38v.31l-1 10.86a1.27 1.27 0 01-.35.82 1 1 0 01-.71.28 1 1 0 01-.79-.28zm-.77 5.55a2.19 2.19 0 010-3 2.14 2.14 0 013 0 2.19 2.19 0 010 3 2.11 2.11 0 01-3 0z', fill: '#fff' })
    );
};

ExclamationIcon.propTypes = {
    className: _propTypes2.default.string
};

ExclamationIcon.defaultProps = {
    className: ''
};

exports.default = ExclamationIcon;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Glyphicon = _interopRequireDefault(__webpack_require__(587));

var _bootstrapUtils = __webpack_require__(21);

var defaultProps = {
  bsRole: 'feedback'
};
var contextTypes = {
  $bs_formGroup: _propTypes.default.object
};

var FormControlFeedback =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlFeedback.prototype;

  _proto.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';

      case 'warning':
        return 'warning-sign';

      case 'error':
        return 'remove';

      default:
        return null;
    }
  };

  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);

    if (!glyph) {
      return null;
    }

    return _react.default.createElement(_Glyphicon.default, (0, _extends2.default)({}, elementProps, {
      glyph: glyph,
      className: (0, _classnames.default)(className, classes)
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(_react.default.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(FormControlStatic, _React$Component);

  function FormControlStatic() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlStatic.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return FormControlStatic;
}(_react.default.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(176);

var _omit3 = _interopRequireDefault(_omit2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Rules for using this component:
 * - the input element that you're trying to focus must NOT be the
 *   outermost element of your InputComponent
 *   (querySelector only finds descendents of the elt it's acting on)
 * - you need to pass the InputComponent's className prop down to
 *   the input element
 * - you can't have several instances of this component trying to focus
 *   at the same time
 */

function focusableWrapper(InputComponent) {
    var _class, _temp;

    return _temp = _class = function (_React$PureComponent) {
        (0, _inherits3.default)(_class, _React$PureComponent);

        function _class() {
            (0, _classCallCheck3.default)(this, _class);
            return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
        }

        _class.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
            if (!prevProps.focused && this.props.focused) {
                var focusedElt = _reactDom2.default.findDOMNode(this.inputElement).querySelector('.input--focused');
                if (focusedElt) {
                    focusedElt.focus();
                    focusedElt.scrollIntoView();
                }
            }
        };

        _class.prototype.render = function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                focused = _props.focused;

            var classNames = (0, _classnames2.default)(className, { 'input--focused': focused });

            var newProps = (0, _omit3.default)(this.props, ['className', 'focused']);
            return _react2.default.createElement(InputComponent, (0, _extends3.default)({
                ref: function ref(el) {
                    _this2.inputElement = el;
                }
            }, newProps, {
                className: classNames }));
        };

        return _class;
    }(_react2.default.PureComponent), _class.propTypes = {
        className: _propTypes2.default.string,
        focused: _propTypes2.default.bool
    }, _class.defaultProps = {
        className: '',
        focused: false
    }, _temp;
}

exports.default = focusableWrapper;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _isNil2 = __webpack_require__(329);

var _isNil3 = _interopRequireDefault(_isNil2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _usePrevious = __webpack_require__(1105);

var _usePrevious2 = _interopRequireDefault(_usePrevious);

var _ShowPasswordIcon = __webpack_require__(1987);

var _ShowPasswordIcon2 = _interopRequireDefault(_ShowPasswordIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowPassword = function ShowPassword(_ref) {
    var active = _ref.active,
        onClick = _ref.onClick;

    var showPasswordLabel = (0, _I18n2.default)('customerdetails.password.show');

    var title = void 0,
        status = void 0;
    if (active) {
        title = (0, _I18n2.default)('customerdetails.password.hide');
        status = (0, _I18n2.default)('customerdetails.password.shown');
    } else {
        title = showPasswordLabel;
        status = (0, _I18n2.default)('customerdetails.password.hidden');
    }

    var previous = (0, _usePrevious2.default)(active);
    var changed = !(0, _isNil3.default)(previous) && previous !== active; // do not announce initial state

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'button',
            {
                type: 'button',
                className: 'show-password',
                onClick: onClick,
                title: title,
                'aria-pressed': Boolean(active),
                'aria-label': showPasswordLabel
            },
            _react2.default.createElement(_ShowPasswordIcon2.default, { active: active })
        ),
        changed && _react2.default.createElement(
            'div',
            { role: 'status', className: 'sr-only', 'aria-hidden': 'true' },
            status
        )
    );
};

ShowPassword.propTypes = {
    active: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

ShowPassword.defaultProps = {
    active: false,
    onClick: _noop3.default
};

exports.default = ShowPassword;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowPasswordIcon = function ShowPasswordIcon(_ref) {
    var _ref$active = _ref.active,
        active = _ref$active === undefined ? false : _ref$active,
        props = (0, _objectWithoutProperties3.default)(_ref, ['active']);
    return active ? _react2.default.createElement(
        'svg',
        (0, _extends3.default)({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 3.873 3.457', height: '13.065', width: '14.639' }, props),
        _react2.default.createElement('path', { d: 'M1.95.35C1.223.338.535.773.166 1.39c-.065.14-.211.287-.15.451.204.41.521.768.91 1.011.145.09.299.166.461.22.04.013.082.024.124.032.401.069.826.032 1.205-.12a2.6 2.6 0 00.965-.836c.075-.132.193-.261.193-.42-.065-.21-.196-.396-.33-.568a2.258 2.258 0 00-.56-.499A1.934 1.934 0 001.95.35zm-.046.526a.91.91 0 01.644.213c.006.005.01.013.016.018.348.327.345.936.001 1.264a.779.779 0 01-.29.2c-.21.056-.44.08-.653.026a.827.827 0 01-.28-.188 1.135 1.135 0 01-.2-.272c-.208-.403-.059-.964.358-1.168a1.09 1.09 0 01.404-.093zm.028.371a.46.46 0 00-.408.228c-.138.2-.114.508.07.665a.39.39 0 00.11.07.558.558 0 00.597-.114c.205-.182.179-.518-.01-.699a.438.438 0 00-.082-.063.477.477 0 00-.277-.087z', fill: 'currentColor' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#fff', strokeWidth: '.661', strokeMiterlimit: '10', d: 'M4.631-1.09l-5.08 5.406' }),
        _react2.default.createElement('path', { fill: 'none', stroke: 'currentColor', strokeWidth: '.265', strokeMiterlimit: '10', d: 'M.442 3.366L3.52.09' })
    ) : _react2.default.createElement(
        'svg',
        (0, _extends3.default)({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 3.873 3.457', height: '13.066', width: '14.639' }, props),
        _react2.default.createElement('path', { d: 'M1.95.335C1.223.323.535.759.166 1.375c-.065.14-.211.287-.15.451.204.41.521.768.91 1.011.145.09.299.166.461.22.04.013.082.024.124.032.401.069.826.032 1.205-.12a2.6 2.6 0 00.965-.836c.075-.132.193-.261.193-.42-.065-.21-.196-.396-.33-.568a2.258 2.258 0 00-.56-.499A1.934 1.934 0 001.95.335zM1.905.86a.911.911 0 01.644.213c.006.005.01.013.016.018.348.327.345.936.001 1.264a.778.778 0 01-.29.2c-.21.056-.44.08-.653.026a.827.827 0 01-.28-.188 1.135 1.135 0 01-.2-.272c-.207-.403-.059-.964.358-1.168a1.09 1.09 0 01.404-.093zm.028.372a.46.46 0 00-.408.227c-.138.2-.114.508.07.665a.39.39 0 00.11.07.558.558 0 00.597-.114c.205-.182.179-.518-.01-.699a.438.438 0 00-.082-.063.477.477 0 00-.277-.086z', fill: 'currentColor' })
    );
};

ShowPasswordIcon.propTypes = {
    active: _propTypes2.default.bool
};

ShowPasswordIcon.defaultProps = {
    active: false
};

exports.default = ShowPasswordIcon;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _PasswordHint = __webpack_require__(1989);

var _PasswordHint2 = _interopRequireDefault(_PasswordHint);

var _useContainerQuery2 = __webpack_require__(1990);

var _useContainerQuery3 = _interopRequireDefault(_useContainerQuery2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REGEX_LOWERCASE = /[a-z]/;
var REGEX_UPPERCASE = /[A-Z]/;
var REGEX_DIGIT = /\d/;

var MINI_SIZE = '350px';

function PasswordHints(_ref) {
    var _ref$password = _ref.password,
        password = _ref$password === undefined ? '' : _ref$password;

    var minLength = _config2.default.get('minPasswordLength');
    password = typeof password === 'string' ? password : '';

    var lengthOk = password.length >= minLength;
    var lowerCaseOk = REGEX_LOWERCASE.test(password);
    var upperCaseOk = REGEX_UPPERCASE.test(password);
    var digitsOk = REGEX_DIGIT.test(password);

    var _useContainerQuery = (0, _useContainerQuery3.default)({ widthBreaks: [MINI_SIZE] }),
        ref = _useContainerQuery.ref,
        widths = _useContainerQuery.widths;

    var isMini = widths[MINI_SIZE];

    return _react2.default.createElement(
        'div',
        {
            ref: ref,
            className: (0, _classnames2.default)('password-hints', { 'password-hints--mini': isMini })
        },
        _react2.default.createElement(_PasswordHint2.default, { type: 'length', mini: isMini, ok: lengthOk, labelProps: { minLength: minLength } }),
        _react2.default.createElement(_PasswordHint2.default, { type: 'lowercase', mini: isMini, ok: lowerCaseOk, labelProps: { minLength: minLength } }),
        _react2.default.createElement(_PasswordHint2.default, { type: 'uppercase', mini: isMini, ok: upperCaseOk, labelProps: { minLength: minLength } }),
        _react2.default.createElement(_PasswordHint2.default, { type: 'digit', mini: isMini, ok: digitsOk, labelProps: { minLength: minLength } })
    );
}

PasswordHints.propTypes = {
    password: _propTypes2.default.string
};

exports.default = PasswordHints;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = PasswordHint;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

PasswordHint.propTypes = {
    type: _propTypes2.default.string.isRequired,
    ok: _propTypes2.default.bool,
    mini: _propTypes2.default.bool,
    labelProps: _propTypes2.default.object
};

function PasswordHint(_ref) {
    var type = _ref.type,
        _ref$ok = _ref.ok,
        ok = _ref$ok === undefined ? false : _ref$ok,
        _ref$mini = _ref.mini,
        mini = _ref$mini === undefined ? false : _ref$mini,
        _ref$labelProps = _ref.labelProps,
        labelProps = _ref$labelProps === undefined ? {} : _ref$labelProps;

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)('password-hint', 'password-hint__' + type, 'sr-container', {
                'password-hint__ok': ok
            })
        },
        mini && _react2.default.createElement(_Icon2.default, { icon: 'tick', className: 'otrl-inline margin-right--xs' }),
        (0, _I18n2.default)('passwordHint.' + type, labelProps),
        '\xA0',
        ok && !mini && _react2.default.createElement(_Icon2.default, { icon: 'tick-circle', srOnly: (0, _I18n2.default)('passwordHint.itemOk') }),
        '\xA0',
        _react2.default.createElement(
            'span',
            { className: 'sr-text' },
            ok ? (0, _I18n2.default)('passwordHint.itemOk') : (0, _I18n2.default)('passwordHint.itemNotOk')
        )
    );
}

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _isNan = __webpack_require__(454);

var _isNan2 = _interopRequireDefault(_isNan);

exports.useContainerQuery = useContainerQuery;

var _reactDom = __webpack_require__(46);

var _hookUtils = __webpack_require__(234);

var _hookUtils2 = _interopRequireDefault(_hookUtils);

var _useResizeObserver2 = __webpack_require__(1106);

var _useResizeObserver3 = _interopRequireDefault(_useResizeObserver2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _hookUtils2.default)(useContainerQuery, 'useContainerQuery');

/**
 * Hook that returns list of matching width/height breakpoints which the element at `ref` is
 * greater than or equal to
 *
 * Width/height dimensions can be given in pixels (without a unit), or CSS units (e.g. vw, vh, rem, ch, etc)
 *
 * @param {object} props
 * @param {Array<number|string>} props.widthBreaks - dimensions of widths you are interested in
 * @param {Array<number|string>} props.heightBreaks - dimensions of heights you are interested in
 * @returns {{widths: Array<number|string>, height: Array<number|string>, ref: React.MutableRefObject}}
 */

function useContainerQuery() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$widthBreaks = _ref.widthBreaks,
        widthBreaks = _ref$widthBreaks === undefined ? [] : _ref$widthBreaks,
        _ref$heightBreaks = _ref.heightBreaks,
        heightBreaks = _ref$heightBreaks === undefined ? [] : _ref$heightBreaks;

    var _useResizeObserver = (0, _useResizeObserver3.default)({ ref: ref }),
        width = _useResizeObserver.width,
        height = _useResizeObserver.height,
        ref = _useResizeObserver.ref;

    var widths = {};
    widthBreaks.forEach(function (unit) {
        widths[unit] = width <= getPixels(ref.current, unit);
    });

    var heights = {};
    heightBreaks.forEach(function (unit) {
        heights[unit] = height <= getPixels(ref.current, unit);
    });

    return { widths: widths, heights: heights, ref: ref };
}

/**
 * Helper to get convert a CSS unit into pixels
 *
 * @param {HTMLElement} el
 * @param {String|number} width
 */
function getPixels(el, width) {
    var maybePixels = Number(width);
    if (!(0, _isNan2.default)(maybePixels)) {
        return maybePixels;
    }

    if (!el) {
        return null;
    }

    var node = (0, _reactDom.findDOMNode)(el);

    // A 'test' element is required for measurement
    var test = document.createElement('div');
    (0, _assign2.default)(test.style, {
        // Absolute positioning to free element for resizing
        // and avoid potential jumps/jank
        position: 'absolute',
        width: width
    });
    node.appendChild(test);
    // The value needed is offsetWidth
    var pixels = test.offsetWidth;
    node.removeChild(test);
    return pixels;
}

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordion = function (_React$PureComponent) {
    (0, _inherits3.default)(Accordion, _React$PureComponent);

    function Accordion() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Accordion);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            isHidden: _this.props.isHidden,
            hasBeenUsed: false
        }, _this._toggleHidden = function () {
            _this.setState(function (state) {
                return {
                    hasBeenUsed: true,
                    isHidden: !state.isHidden
                };
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Accordion.prototype.render = function render() {
        var _props = this.props,
            children = _props.children,
            singleUse = _props.singleUse;
        var _state = this.state,
            hasBeenUsed = _state.hasBeenUsed,
            isHidden = _state.isHidden;

        var canShowToggle = !singleUse || !hasBeenUsed;

        return _react2.default.createElement(
            'div',
            { className: 'otrl-accordion' },
            canShowToggle && _react2.default.createElement(
                'span',
                { onClick: this._toggleHidden, className: 'otrl-accordion__toggle' },
                (0, _I18n2.default)(isHidden ? 'global.showMore' : 'global.showLess')
            ),
            !isHidden && children
        );
    };

    return Accordion;
}(_react2.default.PureComponent);

Accordion.propTypes = {
    children: _propTypes2.default.array,
    isHidden: _propTypes2.default.bool,
    singleUse: _propTypes2.default.bool
};

Accordion.defaultProps = {
    isHidden: true,
    singleUse: false
};

exports.default = Accordion;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = CheckedMarketingOption;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _CheckedOption = __webpack_require__(1993);

var _CheckedOption2 = _interopRequireDefault(_CheckedOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CheckedMarketingOption(_ref) {
    var form = _ref.form,
        flag = _ref.flag,
        helpIconFeatureFlag = _ref.helpIconFeatureFlag,
        restProps = (0, _objectWithoutProperties3.default)(_ref, ['form', 'flag', 'helpIconFeatureFlag']);

    return _react2.default.createElement(
        _FeatureFlag2.default,
        { name: flag },
        _react2.default.createElement(_CheckedOption2.default, (0, _extends3.default)({
            emailChecked: form.get(restProps.emailField),
            smsChecked: form.get(restProps.smsField),
            helpIconFeatureFlag: helpIconFeatureFlag
        }, restProps))
    );
}

CheckedMarketingOption.propTypes = {
    form: _propTypes2.default.instanceOf(_immutable.Record).isRequired,
    flag: _propTypes2.default.string,
    emailField: _propTypes2.default.string,
    smsField: _propTypes2.default.string,
    helpIconFeatureFlag: _propTypes2.default.string
};

CheckedMarketingOption.defaultProps = {
    flag: '',
    emailField: '',
    smsField: '',
    helpIconFeatureFlag: ''
};

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

exports.default = CheckedOption;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _ToggleInputSimple = __webpack_require__(1025);

var _ToggleInputSimple2 = _interopRequireDefault(_ToggleInputSimple);

var _HelpIcon = __webpack_require__(335);

var _HelpIcon2 = _interopRequireDefault(_HelpIcon);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CheckedOption(_ref) {
    var onChange = _ref.onChange,
        enableEmailMarketing = _ref.enableEmailMarketing,
        enableSmsMarketing = _ref.enableSmsMarketing,
        emailField = _ref.emailField,
        smsField = _ref.smsField,
        emailChecked = _ref.emailChecked,
        smsChecked = _ref.smsChecked,
        text = _ref.text,
        disabled = _ref.disabled,
        helpModalText = _ref.helpModalText,
        hideSmsField = _ref.hideSmsField,
        helpIconFeatureFlag = _ref.helpIconFeatureFlag,
        isHalfOnState = _ref.isHalfOnState,
        isEmailProducts = _ref.isEmailProducts,
        southeasternId = _ref.southeasternId;


    var handleToggle = function handleToggle(field) {
        return function () {
            onChange(field, field === emailField ? !emailChecked : !smsChecked);
        };
    };

    var textClass = (0, _classnames2.default)({ "text-light": disabled });

    var infoId = isEmailProducts ? (0, _I18n2.default)('new-products-and-services-updates') : (0, _I18n2.default)('promotions-and-reward-updates');

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'li',
            { className: 'checked-option__row' },
            enableEmailMarketing && _react2.default.createElement(
                'div',
                { className: 'checked-option__cell' },
                _react2.default.createElement(_ToggleInputSimple2.default, { className: 'marketing-preference__checkbox',
                    id: emailField,
                    label: emailField,
                    labelClassName: 'sr-only',
                    onChange: handleToggle(emailField),
                    checked: emailChecked,
                    disabled: disabled,
                    isHalfOnState: isHalfOnState,
                    titleId: isEmailProducts ? (0, _I18n2.default)('') : (0, _I18n2.default)(''),
                    infoId: infoId,
                    southeasternId: southeasternId
                })
            ),
            enableSmsMarketing && _react2.default.createElement(
                'div',
                { className: 'checked-option__cell' },
                !hideSmsField && _react2.default.createElement(_ToggleInputSimple2.default, { className: 'marketing-preference__checkbox',
                    id: smsField,
                    label: smsField,
                    labelClassName: 'sr-only',
                    onChange: handleToggle(smsField),
                    checked: smsChecked,
                    disabled: disabled
                })
            ),
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('checked-option__label', textClass) },
                text,
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: helpIconFeatureFlag },
                    helpModalText && _react2.default.createElement(_HelpIcon2.default, { message: helpModalText, centerMessage: true })
                )
            )
        ),
        isHalfOnState && _react2.default.createElement(
            'div',
            { className: 'checked-option__info', id: infoId },
            isEmailProducts ? (0, _I18n2.default)('preference-centre.toggle.info.emailProducts') : (0, _I18n2.default)('preference-centre.toggle.info.emailPromotions')
        )
    );
}

CheckedOption.propTypes = {
    enableEmailMarketing: _propTypes2.default.bool,
    emailField: _propTypes2.default.string,
    enableSmsMarketing: _propTypes2.default.bool,
    smsField: _propTypes2.default.string,
    text: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    emailChecked: _propTypes2.default.bool,
    smsChecked: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    helpModalText: _propTypes2.default.string,
    hideSmsField: _propTypes2.default.bool,
    helpIconFeatureFlag: _propTypes2.default.string,
    isHalfOnState: _propTypes2.default.bool,
    isEmailProducts: _propTypes2.default.bool,
    southeasternId: _propTypes2.default.string
};

CheckedOption.defaultProps = {
    enableEmailMarketing: false,
    emailField: '',
    enableSmsMarketing: false,
    smsField: '',
    text: '',
    onChange: _noop3.default,
    emailChecked: false,
    smsChecked: false,
    disabled: false,
    helpModalText: '',
    hideSmsField: false,
    helpIconFeatureFlag: ''
};

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useConsents = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _UserStore = __webpack_require__(32);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _ConsentsActions = __webpack_require__(462);

var _ConsentsActions2 = _interopRequireDefault(_ConsentsActions);

var _useStoreState = __webpack_require__(145);

var _ConsentsStore = __webpack_require__(459);

var _ConsentsStore2 = _interopRequireDefault(_ConsentsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useConsents = exports.useConsents = function useConsents() {
    var user = (0, _UserStore.useCurrentUser)();
    var hasUser = user && user.id;

    var consents = (0, _useStoreState.useStoreState)(_ConsentsStore2.default);
    var form = consents.form;

    var fetchConsents = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var consentsResponse, updatedConsentsForm;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!hasUser) {
                                _context.next = 8;
                                break;
                            }

                            _context.next = 3;
                            return _ConsentsActions2.default.getConsents();

                        case 3:
                            consentsResponse = _context.sent;
                            updatedConsentsForm = form.normalizeConsentsResponse({ consents: consentsResponse, user: user });

                            _ConsentsActions2.default.setConsentsForm(updatedConsentsForm);
                            _context.next = 10;
                            break;

                        case 8:
                            _context.next = 10;
                            return _ConsentsActions2.default.getConsentsTemplate();

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function fetchConsents() {
            return _ref.apply(this, arguments);
        };
    }();

    (0, _react.useEffect)(function () {
        fetchConsents();
        // eslint-disable-next-line
    }, []);

    var onCheckNotificationMethod = function onCheckNotificationMethod(_ref2) {
        var optionId = _ref2.optionId;
        return function () {
            var _updatedConsentsFormO;

            var updatedConsentsFormObj = (_updatedConsentsFormO = {}, _updatedConsentsFormO[optionId] = !consents.form.get(optionId), _updatedConsentsFormO);
            if (optionId === _AppConstants.CONSENTS.SMS_Marketing && consents.form.get(optionId)) {
                updatedConsentsFormObj[_AppConstants.CONSENTS.PHONE] = '';
            }
            var updatedConsentsForm = form.merge(updatedConsentsFormObj);
            _ConsentsActions2.default.setConsentsForm(updatedConsentsForm);
        };
    };

    var onChangePhoneNumber = function onChangePhoneNumber(field, value) {
        var updatedConsentsForm = form.set(field, value);
        _ConsentsActions2.default.setConsentsForm(updatedConsentsForm);
    };

    var onChangeIsOver16 = function onChangeIsOver16(choice) {
        return function () {
            var updatedConsentsForm = form.set(_AppConstants.CONSENTS.OVER_16, choice.reference === _AppConstants.CONSENTS.I_CONFIRM_16_YEARS_OLD);
            _ConsentsActions2.default.setConsentsForm(updatedConsentsForm);
        };
    };

    var _useState = (0, _react.useState)(false),
        submitLoading = _useState[0],
        setSubmitLoading = _useState[1];

    var handleSubmit = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!form.isComplete()) {
                                _context2.next = 7;
                                break;
                            }

                            setSubmitLoading(true);
                            _context2.next = 4;
                            return _ConsentsActions2.default.updateConsentsAndUser({ form: form, user: user });

                        case 4:
                            setSubmitLoading(false);

                            _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
                                type: 'success',
                                title: 'preference-centre.update-success.notification'
                            });

                            fetchConsents();

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function handleSubmit() {
            return _ref3.apply(this, arguments);
        };
    }();

    return {
        consents: hasUser ? consents.response : consents.template,
        consentsForm: form,
        onCheckNotificationMethod: onCheckNotificationMethod,
        onChangePhoneNumber: onChangePhoneNumber,
        onChangeIsOver16: onChangeIsOver16,
        handleSubmit: handleSubmit,
        submitLoading: submitLoading,
        consentsLoading: consents.isLoading,
        showSubmitButton: hasUser
    };
};

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _CustomerEndpoint = __webpack_require__(524);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConsentsService = {
    getConsentsTemplate: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', _AuthenticatedAPIClient2.default.get(_CustomerEndpoint.URL.consentsTemplate));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function getConsentsTemplate() {
            return _ref.apply(this, arguments);
        }

        return getConsentsTemplate;
    }(),
    getConsents: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = _CustomerEndpoint.URL.consents.replace('{id}', user.id);
                            return _context2.abrupt('return', _AuthenticatedAPIClient2.default.get(endpoint));

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function getConsents() {
            return _ref2.apply(this, arguments);
        }

        return getConsents;
    }(),
    updateConsents: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(payload) {
            var user, endpoint;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            endpoint = _CustomerEndpoint.URL.consents.replace('{id}', user.id);
                            return _context3.abrupt('return', _AuthenticatedAPIClient2.default.post(endpoint, payload));

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function updateConsents(_x) {
            return _ref3.apply(this, arguments);
        }

        return updateConsents;
    }()
};

exports.default = ConsentsService;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(827);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    postcode: null
};

var PostcodeLookUp = function (_record) {
    (0, _inherits3.default)(PostcodeLookUp, _record);

    function PostcodeLookUp() {
        (0, _classCallCheck3.default)(this, PostcodeLookUp);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PostcodeLookUp.prototype.getSchema = function getSchema() {
        return {
            postcode: _joi2.default.string().trim().regex(_AppConstants.Validation.postcode).allow([null, '']).options({
                language: {
                    any: {
                        empty: (0, _I18n2.default)('alertmessage.badPostCode')
                    },
                    string: {
                        base: (0, _I18n2.default)('alertmessage.badPostCode'),
                        regex: {
                            base: (0, _I18n2.default)('alertmessage.badPostCode')
                        }
                    }
                }
            })
        };
    };

    return PostcodeLookUp;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(PostcodeLookUp.prototype, _ValidationMixin2.default);

exports.default = PostcodeLookUp;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _padStart2 = __webpack_require__(1108);

var _padStart3 = _interopRequireDefault(_padStart2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _FormControl = __webpack_require__(178);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _I18n = __webpack_require__(9);

var _Error = __webpack_require__(174);

var _Error2 = _interopRequireDefault(_Error);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerDateOfBirth = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(CustomerDateOfBirth, _PureRenderComponent);

    function CustomerDateOfBirth() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomerDateOfBirth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this._handleChange = function (fieldName, value) {
            var field = _this.props.field;

            var dob = _this.props.form.get(field);
            _this.props.onChange(field, dob.set(fieldName, value).set('isDirty', true));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    CustomerDateOfBirth.prototype.render = function render() {
        var _props = this.props,
            customValidationMessage = _props.customValidationMessage,
            form = _props.form,
            field = _props.field,
            label = _props.label,
            visited = _props.visited,
            outsideLabel = _props.outsideLabel;

        var dob = form.get(field);
        var dateString = dob.getDateOfBirth() && dob.getDateOfBirth().format('YYYY-MM-DD') || '';
        var thisYear = (0, _TrainTime2.default)().year();
        var validation = dob.getValidationSummary();
        var hideError = form.get('signup') === _AppConstants.SignupTypes.WITHOUT_SMARTCARD && !dob.get('isDirty');

        return _react2.default.createElement(
            _Col2.default,
            { md: 12, className: 'date-of-birth' },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(_FormControl2.default, { type: 'hidden', name: field, value: dateString }),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 12 },
                    _react2.default.createElement(
                        'p',
                        { className: 'label' },
                        label
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, sm: 4, md: 4, lg: 4, className: 'date-of-birth__select date-of-birth__select--first' },
                    _react2.default.createElement(
                        _ValidatedField2.default,
                        { type: 'select',
                            visited: visited,
                            form: dob,
                            validation: validation,
                            id: 'day',
                            name: 'day',
                            field: 'day',
                            onChange: this._handleChange,
                            hideOptional: true,
                            hideError: hideError,
                            outsideLabel: outsideLabel,
                            label: _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('customerdetails.dob.day')
                            ),
                            placeholder: (0, _I18n.translate)('customerdetails.dob.dd'),
                            labelClassName: 'sr-only',
                            groupClassName: 'select-container' },
                        _react2.default.createElement(
                            'option',
                            { value: '' },
                            (0, _I18n.translate)('customerdetails.dob.dd')
                        ),
                        (0, _range3.default)(1, 32).map(function (dom) {
                            return _react2.default.createElement(
                                'option',
                                { key: dom, value: dom },
                                (0, _padStart3.default)(dom, 2, '0')
                            );
                        })
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, sm: 4, md: 4, lg: 4, className: 'date-of-birth__select' },
                    _react2.default.createElement(
                        _ValidatedField2.default,
                        { type: 'select',
                            visited: visited,
                            form: dob,
                            validation: validation,
                            id: 'month',
                            name: 'month',
                            field: 'month',
                            onChange: this._handleChange,
                            hideOptional: true,
                            hideError: hideError,
                            outsideLabel: outsideLabel,
                            label: _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('customerdetails.dob.month')
                            ),
                            placeholder: (0, _I18n.translate)('customerdetails.dob.mm'),
                            labelClassName: 'sr-only',
                            groupClassName: 'select-container' },
                        _react2.default.createElement(
                            'option',
                            { value: '' },
                            (0, _I18n.translate)('customerdetails.dob.mm')
                        ),
                        (0, _range3.default)(1, 13).map(function (mon) {
                            return _react2.default.createElement(
                                'option',
                                { key: mon, value: mon },
                                _TrainTime2.default.months(mon - 1)
                            );
                        })
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, sm: 4, md: 4, lg: 4, className: 'date-of-birth__select date-of-birth__select--last' },
                    _react2.default.createElement(
                        _ValidatedField2.default,
                        { type: 'select',
                            visited: visited,
                            form: dob,
                            validation: validation,
                            id: 'year',
                            name: 'year',
                            field: 'year',
                            onChange: this._handleChange,
                            hideOptional: true,
                            hideError: hideError,
                            outsideLabel: outsideLabel,
                            label: _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('customerdetails.dob.year')
                            ),
                            placeholder: (0, _I18n.translate)('customerdetails.dob.yyyy'),
                            labelClassName: 'sr-only',
                            groupClassName: 'select-container' },
                        _react2.default.createElement(
                            'option',
                            { value: '' },
                            (0, _I18n.translate)('customerdetails.dob.yyyy')
                        ),
                        (0, _range3.default)(thisYear, thisYear - 99, -1).map(function (yr) {
                            return _react2.default.createElement(
                                'option',
                                { key: yr, value: yr },
                                yr
                            );
                        })
                    )
                ),
                customValidationMessage ? _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, className: 'margin-top-negative' },
                    _react2.default.createElement(_Error2.default, { message: customValidationMessage })
                ) : _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    validation.isInvalidDate && _react2.default.createElement(_Error2.default, { message: validation.isInvalidDate }),
                    validation.isTooYoung && _react2.default.createElement(_Error2.default, { message: validation.isTooYoung }),
                    validation.isInFuture && _react2.default.createElement(_Error2.default, { message: validation.isInFuture })
                )
            )
        );
    };

    return CustomerDateOfBirth;
}(_PureRenderComponent3.default), _class.propTypes = (0, _assign2.default)({
    label: _propTypes2.default.string.isRequired,
    validation: _propTypes2.default.object
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'visited'])), _temp2);
exports.default = CustomerDateOfBirth;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

var baseRepeat = __webpack_require__(1154),
    baseToString = __webpack_require__(309),
    castSlice = __webpack_require__(320),
    hasUnicode = __webpack_require__(259),
    stringSize = __webpack_require__(588),
    stringToArray = __webpack_require__(321);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

module.exports = createPadding;


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(763);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 2001 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Isrn = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(Isrn, _PureRenderComponent);

    function Isrn() {
        (0, _classCallCheck3.default)(this, Isrn);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    Isrn.prototype.render = function render() {
        return _react2.default.createElement(
            _Col2.default,
            { md: 12 },
            _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, this.props, {
                type: 'text',
                name: this.props.id,
                placeholder: (0, _I18n2.default)('account.smartcardsignup.isrn.placeholder'),
                labelClassName: 'sr-only'
            }))
        );
    };

    return Isrn;
}(_PureRenderComponent3.default), _class.propTypes = (0, _assign2.default)({
    label: _propTypes2.default.string.isRequired,
    validation: _propTypes2.default.object
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['id', 'form', 'onChange', 'required', 'disabled', 'visited', 'validation', 'field'])), _temp);
exports.default = Isrn;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RegisterOptions = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _SmartcardRegistration = __webpack_require__(240);

var _SmartcardRegistration2 = _interopRequireDefault(_SmartcardRegistration);

var _AppConstants = __webpack_require__(6);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _SmartcardBenefits = __webpack_require__(2004);

var _SmartcardBenefits2 = _interopRequireDefault(_SmartcardBenefits);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    return {
        currentOrder: _OrderStore2.default.getCurrent()
    };
}

var RegisterOptions = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(RegisterOptions, _React$PureComponent);

    function RegisterOptions() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RegisterOptions);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._renderSignupDetails = function () {
            var _this$props = _this.props,
                smartcard = _this$props.smartcard,
                currentOrder = _this$props.currentOrder,
                enableSmartcardTransferAtSignUp = _this$props.enableSmartcardTransferAtSignUp,
                enableKeyGoRegistrationAtSignup = _this$props.enableKeyGoRegistrationAtSignup,
                customPromotionalText = _this$props.customPromotionalText,
                showBenefits = _this$props.showBenefits;


            var hasFlexiFare = currentOrder && currentOrder.getFares().some(function (x) {
                return x.isFlexi();
            });

            if (smartcard.withSmartcard() || smartcard.withoutSmartcard() && !enableSmartcardTransferAtSignUp) {
                return _react2.default.createElement(
                    'div',
                    null,
                    hasFlexiFare && _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            (0, _I18n2.default)('account.smartcardsignup.flexi')
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        customPromotionalText || _react2.default.createElement(_FormattedHTMLMessage2.default, {
                            message: 'account.smartcardsignup.details',
                            readmore: _react2.default.createElement(_ExternalLink2.default, {
                                message: (0, _I18n2.default)('account.smartcardsignup.readmore'),
                                href: _config2.default.get('smartcardReadMoreUrl')
                            })
                        })
                    ),
                    showBenefits && _react2.default.createElement(_SmartcardBenefits2.default, null),
                    enableKeyGoRegistrationAtSignup && _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.keygo.signup' })
                    ),
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableAutoDelayRepay' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                                message: 'account.smartcardsignup.autoDelayRepay',
                                moreInformation: _react2.default.createElement(_ExternalLink2.default, {
                                    message: (0, _I18n2.default)('account.smartcardsignup.moreInformation'),
                                    href: _config2.default.get('autoDelayRepayInformationUrl')
                                })
                            })
                        )
                    )
                );
            } else if (smartcard.withTransfer()) {
                return _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.register.withPaperTransfers.details' })
                );
            }
            return null;
        }, _this._handleSignupToggle = function () {
            var _this$props2 = _this.props,
                onChange = _this$props2.onChange,
                smartcard = _this$props2.smartcard;

            var signupType = smartcard.withSmartcard() ? _AppConstants.SignupTypes.WITHOUT_SMARTCARD : _AppConstants.SignupTypes.WITH_SMARTCARD;
            onChange('signup', signupType);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    RegisterOptions.prototype.render = function render() {
        var _props = this.props,
            smartcard = _props.smartcard,
            _onChange = _props.onChange,
            forceSignup = _props.forceSignup,
            enableSmartcardTransferAtSignUp = _props.enableSmartcardTransferAtSignUp,
            hideSmartcardCheckbox = _props.hideSmartcardCheckbox;


        if (enableSmartcardTransferAtSignUp) {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_ValidatedField2.default, { type: 'radio',
                    form: smartcard,
                    id: 'signup',
                    field: 'signup',
                    label: (0, _I18n2.default)('account.confirm.smartcardsignup'),
                    onChange: function onChange() {
                        _onChange('signup', _AppConstants.SignupTypes.WITH_SMARTCARD);
                    },
                    checked: smartcard.withSmartcard() || forceSignup,
                    disabled: forceSignup }),
                smartcard.withSmartcard() && this._renderSignupDetails(),
                enableSmartcardTransferAtSignUp && _react2.default.createElement(_ValidatedField2.default, { type: 'radio',
                    form: smartcard,
                    id: 'transfer',
                    field: 'signup',
                    label: (0, _I18n2.default)('account.register.swapSeasonTicket'),
                    onChange: function onChange() {
                        return _onChange('signup', _AppConstants.SignupTypes.WITH_TRANSFER);
                    },
                    checked: smartcard.withTransfer(),
                    disabled: forceSignup }),
                enableSmartcardTransferAtSignUp && smartcard.withTransfer() && this._renderSignupDetails(),
                _react2.default.createElement(_ValidatedField2.default, { type: 'radio',
                    form: smartcard,
                    id: 'none',
                    field: 'signup',
                    label: (0, _I18n2.default)('account.register.withoutSmartcard'),
                    onChange: function onChange() {
                        return _onChange('signup', _AppConstants.SignupTypes.WITHOUT_SMARTCARD);
                    },
                    checked: smartcard.withoutSmartcard(),
                    disabled: forceSignup })
            );
        } else {
            return _react2.default.createElement(
                'div',
                null,
                this._renderSignupDetails(),
                !hideSmartcardCheckbox && _react2.default.createElement(_ValidatedField2.default, {
                    autoFocus: true,
                    className: 'register__smartcard-checkbox',
                    type: 'checkbox',
                    form: smartcard,
                    id: 'signup',
                    field: 'signup',
                    label: (0, _I18n2.default)('account.confirm.smartcardsignup'),
                    onChange: this._handleSignupToggle,
                    checked: smartcard.withSmartcard() || forceSignup,
                    disabled: forceSignup,
                    externalFormGroup: true
                })
            );
        }
    };

    return RegisterOptions;
}(_react2.default.PureComponent), _class.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    onContinueWithoutSmartcard: _propTypes2.default.func,
    smartcard: _propTypes2.default.instanceOf(_SmartcardRegistration2.default).isRequired,
    enableKeyGoRegistrationAtSignup: _propTypes2.default.bool,
    enableSmartcardTransferAtSignUp: _propTypes2.default.bool,
    forceSignup: _propTypes2.default.bool,
    hideSmartcardCheckbox: _propTypes2.default.bool,
    onContintueWithoutSmartcard: _propTypes2.default.func,
    customPromotionalText: _propTypes2.default.string,
    showBenefits: _propTypes2.default.bool,
    currentOrder: _propTypes2.default.object
}, _class.defaultProps = {
    forceSignup: false,
    enableSmartcardTransferAtSignUp: false,
    enableKeyGoRegistrationAtSignup: false,
    hideSmartcardCheckbox: false,
    showBenefits: false,
    currentOrder: null,
    onContinueWithoutSmartcard: _noop3.default
}, _temp2);
exports.RegisterOptions = RegisterOptions;
exports.default = (0, _connectToStores2.default)([_OrderStore2.default], _getStateFromStores)(RegisterOptions);

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = SmartcardBenefits;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmartcardBenefits() {
    var getBenefitText = function getBenefitText(num) {
        var key = 'account.smartcardsignup.benefit' + num;
        var text = (0, _I18n2.default)(key);
        if (text === key) {
            return null;
        }
        return text;
    };
    var benefits = [1, 2, 3, 4, 5].map(getBenefitText).filter(Boolean);
    var count = benefits.length;

    var classes = 'smartcard-signup__benefits smartcard-signup__benefits-count-' + count;
    return _react2.default.createElement(
        'ul',
        { className: classes },
        benefits.map(function (benefit) {
            return _react2.default.createElement(
                'li',
                { key: benefit },
                _react2.default.createElement(_Icon2.default, { inline: true, icon: 'tick' }),
                '\xA0',
                benefit
            );
        })
    );
}

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2006), __esModule: true };

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2007);
module.exports = __webpack_require__(49).Number.parseFloat;


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(69);
var $parseFloat = __webpack_require__(2008);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(82).parseFloat;
var $trim = __webpack_require__(2009).trim;

module.exports = 1 / $parseFloat(__webpack_require__(927) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(69);
var defined = __webpack_require__(370);
var fails = __webpack_require__(183);
var spaces = __webpack_require__(927);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = __webpack_require__(2011);

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// WayPointWrapper fix non detectable 0px elements (i.e Firefox Mac)
var WayPointWrapper = function WayPointWrapper(_ref) {
    var onEnter = _ref.onEnter,
        wrapperHeight = _ref.wrapperHeight;

    return _react2.default.createElement(
        'div',
        { style: { display: 'block', height: wrapperHeight } },
        _react2.default.createElement(_reactWaypoint2.default, { onEnter: onEnter })
    );
};

WayPointWrapper.propTypes = {
    onEnter: _propTypes2.default.func.isRequired,
    wrapperHeight: _propTypes2.default.string
};

WayPointWrapper.defaultProps = {
    wrapperHeight: '1px'
};

exports.default = WayPointWrapper;

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_consolidated_events__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);





/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}

var constants = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};

function debugLog() {
  if (false) {
    console.log(arguments); // eslint-disable-line no-console
  }
}

var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage$1);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return constants.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return constants.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return constants.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return constants.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return constants.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return constants.above;
  }

  return constants.invisible;
}

var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function () {
    function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      var index = timeoutQueue.indexOf(cb);
      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }

    return unsubscribe;
  }();
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function () {
    function onEnter() {}

    return onEnter;
  }(),
  onLeave: function () {
    function onLeave() {}

    return onLeave;
  }(),
  onPositionChange: function () {
    function onPositionChange() {}

    return onPositionChange;
  }(),

  fireOnRapidScroll: true
};

// React.PureComponent was added in React 15.3.0
var BaseClass = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent : __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;

// Calls a function when you scroll to the element.

var Waypoint = function (_BaseClass) {
  _inherits(Waypoint, _BaseClass);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        ensureChildrenIsValid(this.props.children);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        // this._ref may occasionally not be set at this time. To help ensure that
        // this works smoothly and to avoid layout thrashing, we want to delay the
        // initial execution until the next tick.
        this.cancelOnNextTick = onNextTick(function () {
          _this2.cancelOnNextTick = null;

          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

          _this2._handleScroll = _this2._handleScroll.bind(_this2);
          _this2.scrollableAncestor = _this2._findScrollableAncestor();

          if (false) {
            debugLog('scrollableAncestor', _this2.scrollableAncestor);
          }

          _this2.scrollEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

          _this2.resizeEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(window, 'resize', _this2._handleScroll, { passive: true });

          _this2._handleScroll(null);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        ensureChildrenIsValid(newProps.children);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var _this3 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        if (!this.scrollableAncestor) {
          // The Waypoint has not yet initialized.
          return;
        }

        // The element may have moved, so we need to recompute its position on the
        // page. This happens via handleScroll in a way that forces layout to be
        // computed.
        //
        // We want this to be deferred to avoid forcing layout during render, which
        // causes layout thrashing. And, if we already have this work enqueued, we
        // can just wait for that to happen instead of enqueueing again.
        if (this.cancelOnNextTick) {
          return;
        }

        this.cancelOnNextTick = onNextTick(function () {
          _this3.cancelOnNextTick = null;
          _this3._handleScroll(null);
        });
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (this.scrollEventListenerUnsubscribe) {
          this.scrollEventListenerUnsubscribe();
        }
        if (this.resizeEventListenerUnsubscribe) {
          this.resizeEventListenerUnsubscribe();
        }

        if (this.cancelOnNextTick) {
          this.cancelOnNextTick();
        }
      }

      return componentWillUnmount;
    }()

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function () {
      function _findScrollableAncestor() {
        var _props = this.props,
            horizontal = _props.horizontal,
            scrollableAncestor = _props.scrollableAncestor;


        if (scrollableAncestor) {
          return resolveScrollableAncestorProp(scrollableAncestor);
        }

        var node = this._ref;

        while (node.parentNode) {
          node = node.parentNode;

          if (node === document.body) {
            // We've reached all the way to the root node.
            return window;
          }

          var style = window.getComputedStyle(node);
          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
          var overflow = overflowDirec || style.getPropertyValue('overflow');

          if (overflow === 'auto' || overflow === 'scroll') {
            return node;
          }
        }

        // A scrollable ancestor element was not found, which means that we need to
        // do stuff on window.
        return window;
      }

      return _findScrollableAncestor;
    }()

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function () {
      function _handleScroll(event) {
        if (!this._ref) {
          // There's a chance we end up here after the component has been unmounted.
          return;
        }

        var bounds = this._getBounds();
        var currentPosition = getCurrentPosition(bounds);
        var previousPosition = this._previousPosition;

        if (false) {
          debugLog('currentPosition', currentPosition);
          debugLog('previousPosition', previousPosition);
        }

        // Save previous position as early as possible to prevent cycles
        this._previousPosition = currentPosition;

        if (previousPosition === currentPosition) {
          // No change since last trigger
          return;
        }

        var callbackArg = {
          currentPosition: currentPosition,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        };
        this.props.onPositionChange.call(this, callbackArg);

        if (currentPosition === constants.inside) {
          this.props.onEnter.call(this, callbackArg);
        } else if (previousPosition === constants.inside) {
          this.props.onLeave.call(this, callbackArg);
        }

        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;

        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
          // If the scroll event isn't fired often enough to occur while the
          // waypoint was visible, we trigger both callbacks anyway.
          this.props.onEnter.call(this, {
            currentPosition: constants.inside,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
          this.props.onLeave.call(this, {
            currentPosition: currentPosition,
            previousPosition: constants.inside,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
        }
      }

      return _handleScroll;
    }()
  }, {
    key: '_getBounds',
    value: function () {
      function _getBounds() {
        var horizontal = this.props.horizontal;

        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
            left = _ref$getBoundingClien.left,
            top = _ref$getBoundingClien.top,
            right = _ref$getBoundingClien.right,
            bottom = _ref$getBoundingClien.bottom;

        var waypointTop = horizontal ? left : top;
        var waypointBottom = horizontal ? right : bottom;

        var contextHeight = void 0;
        var contextScrollTop = void 0;
        if (this.scrollableAncestor === window) {
          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
          contextScrollTop = 0;
        } else {
          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
        }

        if (false) {
          debugLog('waypoint top', waypointTop);
          debugLog('waypoint bottom', waypointBottom);
          debugLog('scrollableAncestor height', contextHeight);
          debugLog('scrollableAncestor scrollTop', contextScrollTop);
        }

        var _props2 = this.props,
            bottomOffset = _props2.bottomOffset,
            topOffset = _props2.topOffset;

        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
        var contextBottom = contextScrollTop + contextHeight;

        return {
          waypointTop: waypointTop,
          waypointBottom: waypointBottom,
          viewportTop: contextScrollTop + topOffsetPx,
          viewportBottom: contextBottom - bottomOffsetPx
        };
      }

      return _getBounds;
    }()

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var children = this.props.children;


        if (!children) {
          // We need an element that we can locate in the DOM to determine where it is
          // rendered relative to the top of its context.
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
        }

        if (isDOMElement(children) || Object(__WEBPACK_IMPORTED_MODULE_3_react_is__["isForwardRef"])(children.type)) {
          var ref = function () {
            function ref(node) {
              _this4.refElement(node);
              if (children.ref) {
                if (typeof children.ref === 'function') {
                  children.ref(node);
                } else {
                  children.ref.current = node;
                }
              }
            }

            return ref;
          }();

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { ref: ref });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { innerRef: this.refElement });
      }

      return render;
    }()
  }]);

  return Waypoint;
}(BaseClass);


Waypoint.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  debug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onPositionChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  fireOnRapidScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  scrollableAncestor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

  // `topOffset` can either be a number, in which case its a distance from the
  // top of the container in pixels, or a string value. Valid string values are
  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
  // as a percentage of the height of the containing element.
  // For instance, if you pass "-20%", and the containing element is 100px tall,
  // then the waypoint will be triggered when it has been scrolled 20px beyond
  // the top of the containing element.
  topOffset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),

  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
  bottomOffset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};

Waypoint.above = constants.above;
Waypoint.below = constants.below;
Waypoint.inside = constants.inside;
Waypoint.invisible = constants.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';

/* harmony default export */ __webpack_exports__["default"] = (Waypoint);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(81)))

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}




/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useSubmitButtonDisabled = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _AppConstants = __webpack_require__(6);

var _SignupTAndCs = __webpack_require__(594);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _ConsentsForm = __webpack_require__(354);

var _ConsentsForm2 = _interopRequireDefault(_ConsentsForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useSubmitButtonDisabled = exports.useSubmitButtonDisabled = function useSubmitButtonDisabled(_ref) {
    var isLastStep = _ref.isLastStep,
        isSmartcardStep = _ref.isSmartcardStep,
        consentsForm = _ref.consentsForm,
        isOver16 = _ref.isOver16;

    var _useState = (0, _react.useState)(false),
        isDisabled = _useState[0],
        setIsDisabled = _useState[1];

    (0, _react.useEffect)(function () {
        if (isSmartcardStep) {
            var enableSmartcardRegistration = isOver16 ? true : _FeatureFlagStore2.default.get('enableChildSmartcardRegistration');
            setIsDisabled(!enableSmartcardRegistration);
        } else if (isLastStep) {
            if (_FeatureFlagStore2.default.get('enableMarketingConsents')) {
                var isConsentsFormComplete = consentsForm.isComplete();
                setIsDisabled(!isConsentsFormComplete);
            } else {
                setIsDisabled(false);
            }
        }
    }, [isLastStep, isSmartcardStep, consentsForm, isOver16]);

    return { isDisabled: isDisabled };
};

var RegisterModalFooter = function RegisterModalFooter(_ref2) {
    var handleContinueRegistration = _ref2.handleContinueRegistration,
        handleSubmission = _ref2.handleSubmission,
        handleLogin = _ref2.handleLogin,
        isFirstStep = _ref2.isFirstStep,
        isSmartcardStep = _ref2.isSmartcardStep,
        isLastStep = _ref2.isLastStep,
        isDesktop = _ref2.isDesktop,
        onSmartcardUpdate = _ref2.onSmartcardUpdate,
        isRegistering = _ref2.isRegistering,
        consentsForm = _ref2.consentsForm,
        isOver16 = _ref2.isOver16;

    var _useSubmitButtonDisab = useSubmitButtonDisabled({ isLastStep: isLastStep, isSmartcardStep: isSmartcardStep, consentsForm: consentsForm, isOver16: isOver16 }),
        isDisabled = _useSubmitButtonDisab.isDisabled;

    var onContinueWithout = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return onSmartcardUpdate('signup', _AppConstants.SignupTypes.WITHOUT_SMARTCARD);

                        case 2:
                            handleContinueRegistration();

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function onContinueWithout() {
            return _ref3.apply(this, arguments);
        };
    }();

    var handleSmartcardSubmission = function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return onSmartcardUpdate('signup', _AppConstants.SignupTypes.WITH_SMARTCARD);

                        case 2:
                            handleContinueRegistration();

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function handleSmartcardSubmission() {
            return _ref4.apply(this, arguments);
        };
    }();

    var smartcardLabel = isDesktop ? (0, _I18n2.default)('account.register.smartcard.labelLong') : (0, _I18n2.default)('account.register.smartcard.labelShort');

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)('modal-footer__wrapper', {
                'modal-footer__wrapper-smartcard': isSmartcardStep
            })
        },
        isSmartcardStep && _react2.default.createElement(
            'button',
            {
                className: 'action-btn action-btn--secondary modal__footer__button modal__footer__button--secondary modal-footer__button modal-footer__button-secondary',
                onClick: onContinueWithout
            },
            _react2.default.createElement(
                'span',
                { className: 'modal__footer__button__text' },
                (0, _I18n2.default)('account.register.continueWithout')
            ),
            _react2.default.createElement(_Icon2.default, { icon: 'chevronslim', className: 'modal__footer__button__arrow' })
        ),
        isLastStep && _react2.default.createElement(
            'div',
            {
                className: (0, _classnames2.default)('text-sm text-weight--semi-bold', {
                    'margin-bottom': isDesktop,
                    'margin-bottom--sm': !isDesktop
                })
            },
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'form.registration.termsAndConditions',
                privacyPolicy: _react2.default.createElement(_SignupTAndCs.PrivacyPolicyLink, { className: 'text-capitalise' }),
                termsAndConditions: _react2.default.createElement(_SignupTAndCs.TermsAndConditionsLink, {
                    message: (0, _I18n2.default)('form.termsAndConditions.capitalised')
                })
            })
        ),
        _react2.default.createElement(
            'button',
            {
                className: (0, _classnames2.default)('action-btn action-btn--primary modal__footer__button modal__footer__button--primary modal-footer__button modal-footer__button-primary', { 'modal__footer__button--processing': isRegistering }),
                onClick: isLastStep ? handleSubmission : isSmartcardStep ? handleSmartcardSubmission : handleContinueRegistration,
                disabled: isDisabled
            },
            _react2.default.createElement(
                'span',
                { className: 'modal__footer__button__text' },
                (0, _I18n2.default)(isLastStep ? 'account.register.create' : isSmartcardStep ? smartcardLabel : 'account.register.continue')
            ),
            _react2.default.createElement(_Icon2.default, { icon: 'chevronslim', className: 'modal__footer__button__arrow' })
        ),
        isFirstStep && isDesktop && _react2.default.createElement(
            'div',
            { className: 'modal-footer__link' },
            (0, _I18n2.default)('account.register.loginLabel'),
            ' ',
            _react2.default.createElement(
                _Button2.default,
                { className: 'like-link', onClick: handleLogin },
                (0, _I18n2.default)('account.login')
            )
        ),
        isLastStep && isDesktop && _react2.default.createElement(
            'div',
            { className: 'modal-footer__privacy-notice' },
            (0, _I18n2.default)('preference-centre.privacy-notice').length > 1 && _react2.default.createElement(_FormattedHTMLMessage2.default, {
                className: 'text-xs text-center',
                message: 'preference-centre.privacy-notice'
            }),
            (0, _I18n2.default)('preference-centre.privacy-notice.extra').length > 1 && _react2.default.createElement(_FormattedHTMLMessage2.default, {
                className: 'text-xs text-center',
                message: 'preference-centre.privacy-notice.extra'
            })
        )
    );
};

RegisterModalFooter.propTypes = {
    handleContinueRegistration: _propTypes2.default.func,
    handleSubmission: _propTypes2.default.func,
    handleLogin: _propTypes2.default.func,
    isFirstStep: _propTypes2.default.bool,
    isSmartcardStep: _propTypes2.default.bool,
    isLastStep: _propTypes2.default.bool,
    isDesktop: _propTypes2.default.bool,
    onSmartcardUpdate: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    isRegistering: _propTypes2.default.bool,
    consentsForm: _propTypes2.default.instanceOf(_ConsentsForm2.default),
    isOver16: _propTypes2.default.bool
};

exports.default = RegisterModalFooter;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _entries = __webpack_require__(238);

var _entries2 = _interopRequireDefault(_entries);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AmazonLoginActions = __webpack_require__(291);

var _AmazonLoginActions2 = _interopRequireDefault(_AmazonLoginActions);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ConfirmModal = __webpack_require__(609);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _ModalTabs = __webpack_require__(928);

var _ModalTabs2 = _interopRequireDefault(_ModalTabs);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterModalHeader = function (_React$PureComponent) {
    (0, _inherits3.default)(RegisterModalHeader, _React$PureComponent);

    function RegisterModalHeader() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RegisterModalHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            isConfirmVisible: false,
            logoutAmazon: false
        }, _this.filteredSteps = [], _this.getFilteredSteps = function () {
            var _this$props = _this.props,
                steps = _this$props.steps,
                hideSteps = _this$props.hideSteps;

            return (0, _entries2.default)(steps).filter(function (_ref) {
                var stepName = _ref[0];
                return !hideSteps.includes(stepName);
            });
        }, _this.handleContinueLoginTab = function () {
            var _this$props2 = _this.props,
                handleLogin = _this$props2.handleLogin,
                onClose = _this$props2.onClose;
            var logoutAmazon = _this.state.logoutAmazon;


            if (logoutAmazon) {
                _AmazonLoginActions2.default.logout();
            }

            onClose();
            handleLogin();
        }, _this.getPreviousStepDetails = function () {
            var step = _this.props.step;

            var filteredSteps = _this.filteredSteps;
            var currentStepIndex = filteredSteps.findIndex(function (i) {
                return i[1] === step;
            });
            return filteredSteps[currentStepIndex - 1];
        }, _this.getPreviousStepName = function () {
            return _this.getPreviousStepDetails()[0];
        }, _this.getPreviousStepNumber = function () {
            return _this.getPreviousStepDetails()[1];
        }, _this.handleStep = function () {
            var handleStepBack = _this.props.handleStepBack;

            var prevStepNumber = _this.getPreviousStepNumber();

            handleStepBack(prevStepNumber);
        }, _this.isFirstStep = function () {
            return !_this.getPreviousStepDetails();
        }, _this.toggleModal = function () {
            return _this.setState(function (state) {
                return { isConfirmVisible: !state.isConfirmVisible };
            });
        }, _this.logoutAmazon = function (e) {
            e.preventDefault();

            _this.setState({ logoutAmazon: true });
            _this.toggleModal();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    RegisterModalHeader.prototype.componentDidMount = function componentDidMount() {
        this.filteredSteps = this.getFilteredSteps();
    };

    RegisterModalHeader.prototype.render = function render() {
        var _props = this.props,
            amazonEmail = _props.amazonEmail,
            hideClose = _props.hideClose,
            onClose = _props.onClose,
            isAmazonRegistration = _props.isAmazonRegistration,
            dictionaryPrefix = _props.dictionaryPrefix;
        var isConfirmVisible = this.state.isConfirmVisible;


        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_ConfirmModal2.default, {
                className: 'modal--sm modal--small-confirm',
                closeText: 'No, go back',
                continueText: 'Yes, close the form',
                onClose: this.toggleModal,
                onContinue: onClose,
                header: false,
                show: isConfirmVisible,
                text: (0, _I18n2.default)('account.register.closeConfirm')
            }),
            this.isFirstStep() ? _react2.default.createElement(
                _ModalTabs2.default,
                { activeTab: 'register' },
                _react2.default.createElement(_ModalTabs2.default.Tab, { name: 'register', title: (0, _I18n2.default)('account.register') }),
                _react2.default.createElement(_ModalTabs2.default.Tab, { name: 'login', onClick: this.handleContinueLoginTab, title: (0, _I18n2.default)('account.login') })
            ) : _react2.default.createElement(
                'div',
                { className: 'modal__header--go-back', onClick: this.handleStep },
                _react2.default.createElement(_Icon2.default, { icon: 'chevronslim' }),
                (0, _I18n2.default)('' + dictionaryPrefix + this.getPreviousStepName().toLowerCase())
            ),
            !hideClose && _react2.default.createElement(
                _Button2.default,
                { className: 'btn btn-link modal-header__close-button', onClick: this.toggleModal },
                _react2.default.createElement(_Icon2.default, { icon: 'close', srOnly: (0, _I18n2.default)('button.text.close') })
            ),
            _react2.default.createElement(
                'div',
                { className: 'modal__header__wrapper modal__header__wrapper--hide-mobile' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal__header__right modal__header__right--login' },
                    isAmazonRegistration && _react2.default.createElement(
                        'span',
                        { className: 'modal__header__amazon-logout' },
                        _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.register.amazon.logout.info', email: amazonEmail }),
                        ' ',
                        _react2.default.createElement(
                            'a',
                            { href: '#', onClick: this.logoutAmazon },
                            (0, _I18n2.default)('account.register.amazon.logout.action')
                        )
                    )
                )
            )
        );
    };

    return RegisterModalHeader;
}(_react2.default.PureComponent);

RegisterModalHeader.propTypes = {
    handleLogin: _propTypes2.default.func,
    isAmazonRegistration: _propTypes2.default.bool,
    isFormDirty: _propTypes2.default.bool,
    hideClose: _propTypes2.default.bool,
    onClose: _propTypes2.default.func,
    showExtraOptions: _propTypes2.default.bool,
    amazonEmail: _propTypes2.default.string,
    step: _propTypes2.default.object,
    steps: _propTypes2.default.object,
    hideSteps: _propTypes2.default.object,
    handleStepBack: _propTypes2.default.func,
    dictionaryPrefix: _propTypes2.default.string
};

RegisterModalHeader.defaultProps = {
    handleLogin: _noop3.default,
    isAmazonRegistration: false,
    isFormDirty: false,
    hideClose: false,
    onClose: _noop3.default,
    showExtraOptions: false,
    amazonEmail: '',
    step: {},
    steps: {},
    hideSteps: [],
    handleStepBack: _noop3.default,
    dictionaryPrefix: ''
};

exports.default = RegisterModalHeader;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

var _Login = __webpack_require__(930);

var _Login2 = _interopRequireDefault(_Login);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _AmazonLinkModal = __webpack_require__(2016);

var _AmazonLinkModal2 = _interopRequireDefault(_AmazonLinkModal);

var _AmazonLoginButton = __webpack_require__(2017);

var _AmazonLoginButton2 = _interopRequireDefault(_AmazonLoginButton);

var _AmazonLoginActions = __webpack_require__(291);

var _AmazonLoginActions2 = _interopRequireDefault(_AmazonLoginActions);

var _AmazonLoginStore = __webpack_require__(352);

var _AmazonLoginStore2 = _interopRequireDefault(_AmazonLoginStore);

var _AmazonRegisterFirstModal = __webpack_require__(2018);

var _AmazonRegisterFirstModal2 = _interopRequireDefault(_AmazonRegisterFirstModal);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        accessToken: _AmazonLoginStore2.default.getAccessToken(),
        amazonEmail: _AmazonLoginStore2.default.getAmazonEmail(),
        customer: _AmazonLoginStore2.default.getCustomer(),
        enableAmazonRegistration: _FeatureFlagStore2.default.get('enableAmazonRegistration'),
        hasLoginCompleted: _AmazonLoginStore2.default.getHasLoginCompleted(),
        isLoginProcessing: _AmazonLoginStore2.default.getIsProcessing(),
        status: _AmazonLoginStore2.default.getStatus()
    };
};

var AmazonLogin = (_temp2 = _class = function (_PureComponent) {
    (0, _inherits3.default)(AmazonLogin, _PureComponent);

    function AmazonLogin() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AmazonLogin);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
            disableContinue: true,
            loginForm: new _Login2.default(),
            isProcessing: false,
            showLinkModal: false,
            showRegisterFirstModal: false,
            submitted: false
        }, _this.closeRegisterFirstModal = function () {
            return _this.setState({ showRegisterFirstModal: false });
        }, _this.handleLoginClick = function () {
            _this.props.onButtonClick();
            _AmazonLoginActions2.default.login();
        }, _this.handleCancelLink = function () {
            _this.setState({ showLinkModal: false });
            _AmazonLoginActions2.default.resetStateToIdle();
        }, _this.handleFieldChange = function (field, value) {
            var _this$state = _this.state,
                loginForm = _this$state.loginForm,
                submitted = _this$state.submitted;


            _this.setState({
                disableContinue: !loginForm.isFieldValid('password', { 'password': value }) || submitted,
                loginForm: _this.state.loginForm.set(field, value),
                submitted: false,
                status: null
            });
        }, _this.linkAccount = function () {
            var customer = _this.props.customer;
            var _this$state2 = _this.state,
                loginForm = _this$state2.loginForm,
                submitted = _this$state2.submitted;


            if (loginForm.isFieldValid('password') && !submitted) {
                _this.setState({ submitted: true });
                _AmazonLoginActions2.default.linkAccount({
                    email: customer.email,
                    password: loginForm.password
                });
            }
        }, _this.openLinkAccountModal = function () {
            _this.setState({ showLinkModal: true });
        }, _this.showRegistrationForm = function () {
            var _this$props = _this.props,
                accessToken = _this$props.accessToken,
                closeModal = _this$props.closeModal,
                customer = _this$props.customer,
                enableAmazonRegistration = _this$props.enableAmazonRegistration;


            closeModal();

            // Wait with opening a new modal after the previous one closes
            (0, _defer3.default)(function () {
                _ModalActions2.default.open(_AppConstants.GlobalModals.REGISTER, enableAmazonRegistration ? { amazonAccessToken: accessToken, customer: customer } : null);
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    AmazonLogin.prototype.componentWillMount = function componentWillMount() {
        _AmazonLoginActions2.default.load();
    };

    AmazonLogin.prototype.componentDidUpdate = function componentDidUpdate(_ref) {
        var _this2 = this;

        var prevStatus = _ref.status;
        var _props = this.props,
            accessToken = _props.accessToken,
            closeModal = _props.closeModal,
            customer = _props.customer,
            isAlreadyRegistering = _props.isAlreadyRegistering,
            status = _props.status;


        if (status && status !== prevStatus) {
            this.setState({ submitted: false });

            switch (status) {
                case _AppConstants.AmazonLoginStatus.LINK_START:
                    (0, _defer3.default)(_AmazonLoginActions2.default.resetStatus);
                    this.openLinkAccountModal();
                    break;

                case _AppConstants.AmazonLoginStatus.LINK_SUCCESS:
                    (0, _defer3.default)(function () {
                        _AmazonLoginActions2.default.resetStatus();
                        _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
                            type: 'success',
                            heading: (0, _I18n2.default)('login.link.amazon.success.heading'),
                            title: (0, _I18n2.default)('login.link.amazon.success.title', { accountType: (0, _I18n2.default)('app.owner.short') }),
                            message: (0, _I18n2.default)('login.link.amazon.success.message')
                        });
                    });
                    break;

                case _AppConstants.AmazonLoginStatus.LOGIN_READY_TO_AUTH:
                    (0, _defer3.default)(function () {
                        _AmazonLoginActions2.default.resetStatus();
                        _AmazonLoginActions2.default.authenticate({ accessToken: accessToken });
                    });
                    break;

                case _AppConstants.AmazonLoginStatus.LOGIN_SUCCESS:
                    (0, _defer3.default)(_AmazonLoginActions2.default.resetStatus);
                    closeModal(status);
                    break;

                case _AppConstants.AmazonLoginStatus.REGISTER_START:
                    (0, _defer3.default)(function () {
                        _AmazonLoginActions2.default.resetStatus();

                        if (isAlreadyRegistering) {
                            _this2.showRegistrationForm();
                        } else {
                            _this2.setState({ showRegisterFirstModal: true });
                        }
                    });
                    break;

                case _AppConstants.AmazonLoginStatus.SYNC_EMAIL_START:
                    (0, _defer3.default)(function () {
                        _AmazonLoginActions2.default.resetStatus();
                        _ModalActions2.default.open(_AppConstants.GlobalModals.SYNC_EMAIL_AMAZON_LOGIN, { customer: customer });
                    });
                    break;
            }
        }
    };

    AmazonLogin.prototype.render = function render() {
        var _props2 = this.props,
            customer = _props2.customer,
            hideErrors = _props2.hideErrors,
            isLoginProcessing = _props2.isLoginProcessing,
            isLongButton = _props2.isLongButton,
            status = _props2.status;
        var _state = this.state,
            isProcessing = _state.isProcessing,
            loginForm = _state.loginForm,
            showLinkModal = _state.showLinkModal,
            showRegisterFirstModal = _state.showRegisterFirstModal,
            submitted = _state.submitted;


        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            showLinkModal && _react2.default.createElement(_AmazonLinkModal2.default, {
                customer: customer,
                disableContinue: this.disableContinue,
                handleFieldChange: this.handleFieldChange,
                isProcessing: isProcessing,
                loginForm: loginForm,
                onClose: this.handleCancelLink,
                onContinue: this.linkAccount,
                status: status,
                submitted: submitted }),
            showRegisterFirstModal && _react2.default.createElement(_AmazonRegisterFirstModal2.default, {
                onContinue: this.showRegistrationForm,
                onClose: this.closeRegisterFirstModal }),
            _react2.default.createElement(
                'div',
                { className: 'amazon-login' },
                isLoginProcessing ? _react2.default.createElement(_Loading2.default, {
                    message: (0, _I18n2.default)('global.loading'),
                    unwrapped: true,
                    standalone: true
                }) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    status === _AppConstants.AmazonLoginStatus.LOGIN_ERROR && !hideErrors && _react2.default.createElement(
                        _BAlert2.default,
                        { type: _BAlert.bAlertType.DANGER, className: 'margin-bottom--sm' },
                        (0, _I18n2.default)('login.amazon.error')
                    ),
                    _react2.default.createElement(_AmazonLoginButton2.default, { isLongButton: isLongButton, onClick: this.handleLoginClick })
                )
            )
        );
    };

    return AmazonLogin;
}(_react.PureComponent), _class.propTypes = {
    accessToken: _propTypes2.default.string,
    amazonEmail: _propTypes2.default.string,
    closeModal: _propTypes2.default.func,
    code: _propTypes2.default.string,
    customer: _propTypes2.default.object,
    enableAmazonRegistration: _propTypes2.default.bool,
    hasLoginCompleted: _propTypes2.default.bool,
    hideErrors: _propTypes2.default.bool,
    isAlreadyRegistering: _propTypes2.default.bool,
    isLoginProcessing: _propTypes2.default.bool,
    isLongButton: _propTypes2.default.bool,
    onButtonClick: _propTypes2.default.func,
    status: _propTypes2.default.string
}, _class.defaultProps = {
    accessToken: null,
    amazonEmail: null,
    closeModal: _noop3.default,
    code: null,
    customer: null,
    enableAmazonRegistration: false,
    hasLoginCompleted: false,
    hideErrors: false,
    isAlreadyRegistering: false,
    isLoginProcessing: false,
    isLongButton: false,
    onButtonClick: _noop3.default,
    status: null
}, _temp2);
exports.default = (0, _connectToStores2.default)([_AmazonLoginStore2.default, _FeatureFlagStore2.default], _getStateFromStores)(AmazonLogin);

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _AmazonLoginActions = __webpack_require__(291);

var _AmazonLoginActions2 = _interopRequireDefault(_AmazonLoginActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeInput = function makeInput(_ref) {
    var autoFocus = _ref.autoFocus,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        field = _ref.field,
        handleFieldChange = _ref.handleFieldChange,
        isProcessing = _ref.isProcessing,
        label = _ref.label,
        loginForm = _ref.loginForm,
        submitted = _ref.submitted,
        type = _ref.type,
        value = _ref.value;


    return _react2.default.createElement(_ValidatedField2.default, {
        autoFocus: autoFocus,
        disabled: disabled || isProcessing,
        field: field,
        form: loginForm,
        id: field,
        label: label,
        labelClassName: 'sr-only',
        onChange: handleFieldChange,
        placeholder: label,
        required: true,
        type: type,
        value: value,
        visited: submitted
    });
}; /* eslint-disable react/prop-types */
/* we can re-enable this when (if) AmazonLogin is ever revived (dead feature) */


var AmazonLinkModal = function AmazonLinkModal(_ref2) {
    var customer = _ref2.customer,
        disableContinue = _ref2.disableContinue,
        handleFieldChange = _ref2.handleFieldChange,
        isProcessing = _ref2.isProcessing,
        loginForm = _ref2.loginForm,
        onContinue = _ref2.onContinue,
        onClose = _ref2.onClose,
        status = _ref2.status,
        submitted = _ref2.submitted;

    var passwordInput = makeInput({
        autoFocus: true,
        field: 'password',
        handleFieldChange: handleFieldChange,
        isProcessing: isProcessing,
        label: (0, _I18n2.default)('login.link.password', { accountType: (0, _I18n2.default)('app.owner.short') }),
        loginForm: loginForm,
        submitted: submitted,
        type: 'password'
    });

    var closeModal = function closeModal() {
        _AmazonLoginActions2.default.logout(); // Log out the Amazon user in case they want to use another Amazon acccount
        onClose();
    };

    var modalProps = {
        className: 'modal--xs',
        closeText: (0, _I18n2.default)('login.link.amazon.closeText'),
        continueText: (0, _I18n2.default)('login.link.amazon.continueText'),
        disableContinue: disableContinue,
        onClose: closeModal,
        onContinue: onContinue,
        titleText: (0, _I18n2.default)('login.link.amazon.title')
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'login.link.amazon.message',
                        accountType: (0, _I18n2.default)('app.owner.short'),
                        email: customer.email })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'header__logo' },
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        (0, _I18n2.default)('app.owner')
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'login.link.amazon.loginAccount', accountType: (0, _I18n2.default)('app.owner.short') })
                ),
                status === _AppConstants.AmazonLoginStatus.LINK_ERROR && _react2.default.createElement(
                    _BAlert2.default,
                    { type: _BAlert.bAlertType.DANGER, className: 'margin-bottom--sm' },
                    (0, _I18n2.default)('login.link.amazon.error', { accountType: (0, _I18n2.default)('app.owner.short') })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    passwordInput
                )
            )
        )
    );
};

AmazonLinkModal.propTypes = {
    onClose: _propTypes2.default.func,
    onRegister: _propTypes2.default.func
};

AmazonLinkModal.defaultProps = {
    onClose: _noop3.default,
    onRegister: _noop3.default
};

exports.default = AmazonLinkModal;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LONG_BUTTON_IMAGE_SRC = '/images/amazon-login-with-amazon-button.png';
var SHORT_BUTTON_IMAGE_SRC = '/images/amazon-login-button.png';

var AmazonLoginButton = function AmazonLoginButton(_ref) {
    var onClick = _ref.onClick,
        isLongButton = _ref.isLongButton;
    return _react2.default.createElement(
        'div',
        { className: 'amazon-login__button-wrapper' },
        _react2.default.createElement('img', {
            className: (0, _classnames2.default)('amazon-login__button', {
                'amazon-login__button--sandbox': _config2.default.get('amazonPayEnvironment') === 'sandbox',
                'amazon-login__button--long': isLongButton
            }),
            onClick: onClick,
            src: isLongButton ? LONG_BUTTON_IMAGE_SRC : SHORT_BUTTON_IMAGE_SRC }),
        isLongButton && _react2.default.createElement('img', {
            className: (0, _classnames2.default)('amazon-login__button amazon-login__button--short', { 'amazon-login__button--sandbox': _config2.default.get('amazonPayEnvironment') === 'sandbox' }),
            onClick: onClick,
            src: SHORT_BUTTON_IMAGE_SRC })
    );
};

AmazonLoginButton.propTypes = {
    isLongButton: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};

AmazonLoginButton.defaultProps = {
    isLongButton: false
};

exports.default = AmazonLoginButton;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonRegisterFirstModal = function AmazonRegisterFirstModal(_ref) {
    var onClose = _ref.onClose,
        onContinue = _ref.onContinue;

    var modalProps = {
        className: 'modal--xs',
        closeText: (0, _I18n2.default)('login.registerFirst.closeText'),
        continueText: (0, _I18n2.default)('login.registerFirst.continueText'),
        onClose: onClose,
        onContinue: onContinue,
        titleText: (0, _I18n2.default)('login.registerFirst.title')
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'login.registerFirst.message', accountType: (0, _I18n2.default)('app.owner.short') })
                )
            )
        )
    );
};

AmazonRegisterFirstModal.propTypes = {
    onClose: _propTypes2.default.func,
    onContinue: _propTypes2.default.func
};

AmazonRegisterFirstModal.defaultProps = {
    onClose: _noop3.default,
    onContinue: _noop3.default
};

exports.default = AmazonRegisterFirstModal;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _entries = __webpack_require__(238);

var _entries2 = _interopRequireDefault(_entries);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _a11y = __webpack_require__(918);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepsNavigation = function StepsNavigation(_ref) {
    var currentStep = _ref.currentStep,
        dictionaryPrefix = _ref.dictionaryPrefix,
        furthestStep = _ref.furthestStep,
        hideSteps = _ref.hideSteps,
        onClick = _ref.onClick,
        steps = _ref.steps;

    var filteredSteps = (0, _entries2.default)(steps).filter(function (_ref2) {
        var stepName = _ref2[0];
        return !hideSteps.includes(stepName);
    });

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: 'steps-navigation' },
            filteredSteps.map(function (_ref3) {
                var stepName = _ref3[0],
                    stepNumber = _ref3[1];

                return _react2.default.createElement(
                    'div',
                    {
                        key: stepNumber,
                        tabIndex: '0',
                        className: (0, _classnames2.default)('steps-navigation__step', {
                            'steps-navigation__step--visited': stepNumber <= furthestStep,
                            'steps-navigation__step--completed': stepNumber <= currentStep,
                            'steps-navigation__step--active': stepNumber === currentStep
                        }),
                        onClick: onClick(stepNumber),
                        onKeyPress: (0, _a11y.onEnterPress)(stepNumber)
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'steps-navigation__step__text' },
                        (0, _I18n2.default)('' + dictionaryPrefix + stepName.toLowerCase())
                    )
                );
            })
        )
    );
};

StepsNavigation.propTypes = {
    currentStep: _propTypes2.default.number,
    dictionaryPrefix: _propTypes2.default.string,
    furthestStep: _propTypes2.default.number,
    hideSteps: _propTypes2.default.array,
    onClick: _propTypes2.default.func,
    steps: _propTypes2.default.object
};

StepsNavigation.defaultProps = {
    dictionaryPrefix: '',
    currentStep: 0,
    furthestStep: 0,
    hideSteps: [],
    onClick: _noop3.default,
    steps: {}
};

exports.default = StepsNavigation;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _entries = __webpack_require__(238);

var _entries2 = _interopRequireDefault(_entries);

var _findKey2 = __webpack_require__(931);

var _findKey3 = _interopRequireDefault(_findKey2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepDetail = function StepDetail(_ref) {
    var steps = _ref.steps,
        currentStep = _ref.currentStep,
        hideSteps = _ref.hideSteps,
        stepTitleTagName = _ref.stepTitleTagName,
        dictionaryPrefix = _ref.dictionaryPrefix;


    var currentStepName = (0, _findKey3.default)(steps, function (step) {
        return step === currentStep;
    });
    var isSmartcardStep = currentStepName === 'SMARTCARD';

    var filteredSteps = (0, _entries2.default)(steps).filter(function (_ref2) {
        var stepName = _ref2[0];
        return !hideSteps.includes(stepName);
    });

    var getStepNumber = function getStepNumber() {
        var index = filteredSteps.findIndex(function (step) {
            return step[1] === currentStep;
        });
        return index + 1;
    };

    return _react2.default.createElement(
        'div',
        { className: 'step-detail' },
        _react2.default.createElement(
            'span',
            { className: 'step-detail__count' },
            (0, _I18n2.default)('account.register.steps.count', {
                stepNumber: getStepNumber(),
                totalSteps: filteredSteps.length
            })
        ),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: '' + dictionaryPrefix + currentStepName.toLowerCase() + (isSmartcardStep ? '.title-mobile' : '.title'),
            tagName: stepTitleTagName,
            className: (0, _classnames2.default)('step-detail__heading', {
                'step-detail__heading--smartcard': isSmartcardStep
            })
        }),
        isSmartcardStep && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n2.default)('account.register.smartcard.body')
            ),
            _react2.default.createElement(
                'a',
                { href: _config2.default.get('smartcardReadMoreUrl'), target: '_blank' },
                _react2.default.createElement('img', {
                    src: _config2.default.get('smartcardLogo'),
                    alt: (0, _I18n2.default)('account.register.smartcard.logo.alt'),
                    className: 'step-detail__smartcard-logo'
                })
            )
        )
    );
};

StepDetail.propTypes = {
    steps: _propTypes2.default.object,
    currentStep: _propTypes2.default.number,
    hideSteps: _propTypes2.default.func,
    stepTitleTagName: _propTypes2.default.string,
    dictionaryPrefix: _propTypes2.default.string
};

StepDetail.defaultProps = {
    steps: {},
    currentStep: 0,
    hideSteps: [],
    stepTitleTagName: 'h4',
    dictionaryPrefix: ''
};

exports.default = StepDetail;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _findKey2 = __webpack_require__(931);

var _findKey3 = _interopRequireDefault(_findKey2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _RegistrationBenefits = __webpack_require__(2022);

var _RegistrationBenefits2 = _interopRequireDefault(_RegistrationBenefits);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandUsps = function BrandUsps(_ref) {
    var steps = _ref.steps,
        currentStep = _ref.currentStep,
        dictionaryPrefix = _ref.dictionaryPrefix;

    var stepName = (0, _findKey3.default)(steps, function (step) {
        return step === currentStep;
    });

    var brand = _config2.default.get('brand');
    var headingMessage = (0, _I18n2.default)('' + dictionaryPrefix + stepName.toLowerCase() + '.title');
    var headingClass = (0, _classnames2.default)('content-wrapper__usps__heading text-weight--bold', {
        'text-left': currentStep === 2,
        'content-wrapper__usps__heading--tp': brand === 'transpennine'
    });

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: headingMessage,
            tagName: 'h1',
            className: headingClass
        }),
        currentStep === 1 && _react2.default.createElement('img', {
            src: _config2.default.get('registerDetailsImageUrl'),
            alt: (0, _I18n2.default)('account.register.details.alt', {
                brand: _config2.default.get('brand')
            }),
            className: 'content-wrapper__usps__details-image'
        }),
        _react2.default.createElement(
            'p',
            { className: (0, _classnames2.default)('content-wrapper__usps__body-text', { 'content-wrapper__usps__body-text--create': currentStep === 1 }) },
            (0, _I18n2.default)('' + dictionaryPrefix + stepName.toLowerCase() + '.body')
        ),
        currentStep === 1 && _react2.default.createElement(_RegistrationBenefits2.default, { benefits: _config2.default.get('createAccountBenefits') }),
        currentStep === 2 && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_RegistrationBenefits2.default, { benefits: _config2.default.get('smartcardRegistrationBenefits') }),
            _react2.default.createElement('img', {
                src: _config2.default.get('registerSmartcardImageUrl'),
                alt: (0, _I18n2.default)('account.register.smartcard.alt'),
                className: 'content-wrapper__usps__smartcard-image'
            })
        ),
        currentStep === 3 && _react2.default.createElement('img', {
            src: _config2.default.get('registerPreferencesImageUrl'),
            alt: (0, _I18n2.default)('account.register.preferences.alt', {
                brand: _config2.default.get('brand')
            }),
            className: 'content-wrapper__usps__preferences-image'
        })
    );
};

BrandUsps.propTypes = {
    steps: _propTypes2.default.object,
    currentStep: _propTypes2.default.number,
    dictionaryPrefix: _propTypes2.default.string
};

BrandUsps.defaultProps = {
    steps: {},
    currentStep: 0,
    dictionaryPrefix: ''
};

exports.default = BrandUsps;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = RegistrationBenefits;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RegistrationBenefits(_ref) {
    var benefits = _ref.benefits;

    return _react2.default.createElement(
        'div',
        { className: 'content-wrapper__usps__benefits' },
        benefits.map(function (benefit) {
            return _react2.default.createElement(
                'div',
                { key: benefit },
                _react2.default.createElement('i', { className: 'otrl otrl-tick' }),
                _react2.default.createElement(
                    'span',
                    null,
                    (0, _I18n2.default)(benefit)
                )
            );
        })
    );
}

RegistrationBenefits.propTypes = {
    benefits: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PaymentForms = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _ADRPaymentMethodsForm = __webpack_require__(463);

var _ADRPaymentMethodsForm2 = _interopRequireDefault(_ADRPaymentMethodsForm);

var _AppConstants = __webpack_require__(6);

var _Radio = __webpack_require__(231);

var _Radio2 = _interopRequireDefault(_Radio);

var _Assets = __webpack_require__(147);

var _Assets2 = _interopRequireDefault(_Assets);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _OcdrCharities = __webpack_require__(1156);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _DelayRepayService = __webpack_require__(932);

var _DelayRepayService2 = _interopRequireDefault(_DelayRepayService);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentForms = exports.PaymentForms = function PaymentForms(_ref) {
    var form = _ref.form,
        updateFormField = _ref.updateFormField,
        isValidBACS = _ref.isValidBACS;

    var _useState = (0, _react.useState)([]),
        activeCharities = _useState[0],
        setActiveCharities = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        charitiesLoading = _useState2[0],
        setCharitiesLoading = _useState2[1];

    var method = form.method,
        sortCode = form.sortCode,
        accountNumber = form.accountNumber,
        charity = form.charity;


    (0, _react.useEffect)(function () {
        if (method === _AppConstants.oneClickDelayRepayReimbursementMethods.BACS && form.isComplete()) {
            isValidBACS(sortCode, accountNumber);
        }
    }, [sortCode, accountNumber, isValidBACS, form, method]);

    (0, _react.useEffect)(function () {
        var fetchCharities = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var charities;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                setCharitiesLoading(true);
                                _context.next = 3;
                                return _DelayRepayService2.default.getCharities();

                            case 3:
                                charities = _context.sent;

                                setActiveCharities(charities);
                                setCharitiesLoading(false);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, undefined);
            }));

            return function fetchCharities() {
                return _ref2.apply(this, arguments);
            };
        }();

        fetchCharities();
    }, []);

    return _react2.default.createElement(
        _reactBootstrap.Row,
        null,
        _react2.default.createElement(
            'form',
            {
                className: method === _AppConstants.oneClickDelayRepayReimbursementMethods.PAYPAL ? 'auto-dr__payment-form margin-right' : '',
                onSubmit: function onSubmit(e) {
                    return e.preventDefault();
                }
            },
            _react2.default.createElement(
                _reactBootstrap.Row,
                { className: 'margin-left--xs margin-right--xs' },
                method === _AppConstants.oneClickDelayRepayReimbursementMethods.PAYPAL && _react2.default.createElement(
                    _reactBootstrap.FormGroup,
                    null,
                    _react2.default.createElement(
                        _reactBootstrap.ControlLabel,
                        null,
                        (0, _I18n2.default)('auto-dr.account.repayment.method.paypal-email-address')
                    ),
                    _react2.default.createElement(_ValidatedField2.default, {
                        type: 'email',
                        field: 'paypalEmail',
                        form: form,
                        id: 'paypal-email',
                        className: 'input-field margin-bottom--sm',
                        onChange: updateFormField,
                        required: true,
                        label: 'PayPal email address'
                    })
                ),
                method === _AppConstants.oneClickDelayRepayReimbursementMethods.BACS && _react2.default.createElement(
                    'div',
                    { className: 'auto-dr__charity--bacs' },
                    _react2.default.createElement(
                        _reactBootstrap.FormGroup,
                        null,
                        _react2.default.createElement(
                            _reactBootstrap.ControlLabel,
                            null,
                            (0, _I18n2.default)('auto-dr.account.repayment.method.sort-code')
                        ),
                        _react2.default.createElement(_ValidatedField2.default, {
                            type: 'text',
                            form: form,
                            id: 'sort-code',
                            field: 'sortCode',
                            className: 'input-field margin-bottom--sm',
                            placeholder: (0, _I18n2.default)('auto-dr.claim-form.sortCodePlaceholder'),
                            onChange: updateFormField,
                            required: true,
                            label: (0, _I18n2.default)('auto-dr.claim-form.sortCodeLabel'),
                            'aria-label': (0, _I18n2.default)('auto-dr.claim-form.sortCodeAriaLabel', { sortCode: sortCode }),
                            speakDigits: true
                        }),
                        _react2.default.createElement(
                            _reactBootstrap.ControlLabel,
                            null,
                            (0, _I18n2.default)('auto-dr.account.repayment.method.account-number')
                        ),
                        _react2.default.createElement(_ValidatedField2.default, {
                            type: 'text',
                            form: form,
                            field: 'accountNumber',
                            id: 'account-number',
                            className: 'input-field margin-bottom--sm',
                            placeholder: (0, _I18n2.default)('auto-dr.claim-form.accountNumberPlaceholder'),
                            onChange: updateFormField,
                            required: true,
                            label: (0, _I18n2.default)('auto-dr.claim-form.accountNumber'),
                            'aria-label': (0, _I18n2.default)('auto-dr.claim-form.accountNumberAriaLabel', { accountNumber: accountNumber }),
                            speakDigits: true
                        })
                    )
                ),
                method === _AppConstants.oneClickDelayRepayReimbursementMethods.CHARITY && _react2.default.createElement(
                    _reactBootstrap.Col,
                    null,
                    charitiesLoading ? _react2.default.createElement(_Icon2.default, { icon: 'spinner', className: 'otrl otrl-spinner otrl-spin' }) : activeCharities && activeCharities.length === 0 ? _react2.default.createElement(
                        'p',
                        { className: 'text-center' },
                        (0, _I18n2.default)('charity.loading.error')
                    ) : _react2.default.createElement(
                        _reactBootstrap.FormGroup,
                        { role: 'radiogroup' },
                        _OcdrCharities.OcdrCharities.map(function (_ref3) {
                            var value = _ref3.value,
                                imageUrl = _ref3.imageUrl,
                                nameKey = _ref3.nameKey,
                                descriptionKey = _ref3.descriptionKey,
                                website = _ref3.website,
                                linkText = _ref3.linkText,
                                featureFlagName = _ref3.featureFlagName;

                            if (!_config2.default.get(featureFlagName)) {
                                return null;
                            }

                            if (!activeCharities || !activeCharities.find(function (activeCharity) {
                                return activeCharity.name === value;
                            })) {
                                return null;
                            }

                            var selected = charity === value;

                            return _react2.default.createElement(_Radio2.default, {
                                className: selected ? "auto-dr__charity--radio-selected" : "auto-dr__charity--radio",
                                name: 'type-horizontal',
                                label: _react2.default.createElement(
                                    'div',
                                    { className: 'auto-dr__charity--label' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'auto-dr__charity--label-heading' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'delivery-message' },
                                            (0, _I18n2.default)(nameKey)
                                        ),
                                        _react2.default.createElement('img', {
                                            src: _Assets2.default.assetUrl(imageUrl),
                                            alt: (0, _I18n2.default)(nameKey),
                                            className: "auto-dr__charity--logo"
                                        })
                                    ),
                                    selected && _react2.default.createElement(
                                        _reactBootstrap.ControlLabel,
                                        { className: 'margin-top--xs' },
                                        _react2.default.createElement(_FormattedHTMLMessage2.default, {
                                            message: descriptionKey,
                                            charityUrl: website,
                                            urlText: linkText
                                        })
                                    )
                                ),
                                'aria-hidden': 'false',
                                tabIndex: 0,
                                'aria-checked': selected,
                                'aria-label': (0, _I18n2.default)(nameKey) + ' ' + (0, _I18n2.default)(descriptionKey, { charityUrl: website, urlText: linkText }),
                                role: 'radio',
                                value: value,
                                checked: selected,
                                onChange: function onChange() {
                                    return updateFormField('charity', value);
                                },
                                hasFocus: true
                            });
                        })
                    )
                )
            )
        )
    );
};

PaymentForms.propTypes = {
    method: _propTypes2.default.string.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    updateFormField: _propTypes2.default.func.isRequired,
    form: _propTypes2.default.instanceOf(_ADRPaymentMethodsForm2.default).isRequired,
    isValidBACS: _propTypes2.default.func
};

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var urlRoot = '/delay-repay';

var URL = exports.URL = {
    subscribe: urlRoot + '/auto/subscribe'
};

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _identity2 = __webpack_require__(116);

var _identity3 = _interopRequireDefault(_identity2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _PaymentRadio = __webpack_require__(438);

var _PaymentRadio2 = _interopRequireDefault(_PaymentRadio);

var _I18n = __webpack_require__(9);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBootstrap = __webpack_require__(100);

var _propTypes = __webpack_require__(2);

var _PostalAddress = __webpack_require__(678);

var _PostalAddress2 = _interopRequireDefault(_PostalAddress);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectAddress = function SelectAddress(_ref) {
    var addresses = _ref.addresses,
        addressForm = _ref.addressForm,
        setAddressForm = _ref.setAddressForm,
        addNewAddress = _ref.addNewAddress,
        setAddNewAddress = _ref.setAddNewAddress,
        selectedAddress = _ref.selectedAddress,
        setSelectedAddress = _ref.setSelectedAddress,
        onChange = _ref.onChange;

    return _react2.default.createElement(
        _reactBootstrap.Grid,
        null,
        _react2.default.createElement(
            'h2',
            { className: 'auto-dr__header' },
            (0, _I18n.translate)('auto-dr.subscribe.modal-address-title')
        ),
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('auto-dr.subscribe.modal-address-subtitle')
        ),
        _react2.default.createElement(
            'ul',
            { className: 'auto-dr__address-wrapper margin-top--md margin-bottom--sm' },
            addresses.map(function (_ref2) {
                var id = _ref2.id,
                    line1 = _ref2.line1,
                    line2 = _ref2.line2,
                    line3 = _ref2.line3,
                    town = _ref2.town,
                    postCode = _ref2.postCode,
                    country = _ref2.country;

                var isSelected = selectedAddress === id;

                var addressParts = [line1, line2, line3, town, postCode, country].filter(_identity3.default).join(', ');

                var ariaText = (isSelected ? (0, _I18n.translate)('auto-dr.subscribe.modal-address-item.selected') : (0, _I18n.translate)('auto-dr.subscribe.modal-address-item.select')) + ': ' + addressParts;

                return _react2.default.createElement(
                    'li',
                    {
                        className: 'auto-dr__address-item ',
                        key: id
                    },
                    _react2.default.createElement(
                        _OnEnterTrigger2.default,
                        {
                            className: (0, _classnames2.default)('address__selector', {
                                'address__selector--selected': selectedAddress === id
                            }),
                            onClick: function onClick() {
                                return setSelectedAddress(id);
                            },
                            srOnly: ariaText
                        },
                        _react2.default.createElement(_PaymentRadio2.default, {
                            className: 'address__selector__radio-icon small',
                            isSelected: isSelected
                        }),
                        _react2.default.createElement(
                            'address',
                            { className: 'auto-dr__address-item__label text-left' },
                            line1 ? _react2.default.createElement(
                                'p',
                                null,
                                line1
                            ) : null,
                            line2 ? _react2.default.createElement(
                                'p',
                                null,
                                line2
                            ) : null,
                            line3 ? _react2.default.createElement(
                                'p',
                                null,
                                line3
                            ) : null,
                            town ? _react2.default.createElement(
                                'p',
                                null,
                                town
                            ) : null,
                            postCode ? _react2.default.createElement(
                                'p',
                                null,
                                postCode
                            ) : null,
                            country
                        )
                    )
                );
            })
        ),
        _react2.default.createElement(
            _Button2.default,
            {
                bsStyle: 'primary',
                className: 'js-continue',
                onClick: function onClick() {
                    return setAddNewAddress(true);
                }
            },
            (0, _I18n.translate)('auto-dr.subscribe.modal-address.add-new-address')
        ),
        addNewAddress && _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(_PostalAddress2.default, { form: addressForm, onChange: onChange, onSelectAddress: function onSelectAddress(address) {
                    setAddressForm(addressForm.merge({
                        addressLine1: address.get('line1') || '',
                        addressLine2: address.get('line2') || '',
                        addressLine3: address.get('line3') || '',
                        townCity: address.get('town') || '',
                        postcode: address.get('postCode') || ''
                    }));
                    setSelectedAddress(address);
                } })
        )
    );
};

SelectAddress.propTypes = {
    form: _propTypes.PropTypes.object,
    addressForm: _propTypes.PropTypes.func,
    setAddressForm: _propTypes.PropTypes.func,
    addNewAddress: _propTypes.PropTypes.bool,
    setAddNewAddress: _propTypes.PropTypes.func,
    selectedAddress: _propTypes.PropTypes.object,
    setSelectedAddress: _propTypes.PropTypes.func,
    onChange: _propTypes.PropTypes.func,
    addresses: _propTypes.PropTypes.instanceOf(_immutable.List)
};

exports.default = SelectAddress;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Success = function Success() {
    return _react2.default.createElement(
        _reactBootstrap.Grid,
        null,
        _react2.default.createElement(
            _reactBootstrap.Row,
            { className: 'auto-dr__payment-wrapper flex-column margin-top--md margin-bottom--sm' },
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: '12' },
                _react2.default.createElement('img', { className: 'auto-dr__success-screen-icon', src: '/images/blue-tick-circle.svg', alt: 'Tick icon in a circle' })
            ),
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: '12' },
                _react2.default.createElement(
                    'h2',
                    { className: 'auto-dr__header auto-dr-header--subscribe-success' },
                    (0, _I18n2.default)('one-click-delay-repay.optIn.success.header')
                ),
                _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'one-click-delay-repay.optIn.success.copy', splitParagraphs: true })
            )
        )
    );
};

exports.default = Success;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _PushNotificationsEndpoint = __webpack_require__(2028);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PushNotificationsService = {
    checkPushNotificationPreference: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var _ref2, result;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _AuthenticatedAPIClient2.default.get(_PushNotificationsEndpoint.URL.pushNotifications.replace('{id}', user.id));

                        case 2:
                            _ref2 = _context.sent;
                            result = _ref2.result;
                            return _context.abrupt('return', result);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function checkPushNotificationPreference(_x) {
            return _ref.apply(this, arguments);
        }

        return checkPushNotificationPreference;
    }()
};

exports.default = PushNotificationsService;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var urlRoot = '/customers';

var URL = exports.URL = {
    pushNotifications: urlRoot + '/{id}/device-registration'
};

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults2 = __webpack_require__(144);

var _defaults3 = _interopRequireDefault(_defaults2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    townCity: '',
    postcode: '',
    country: 'GBR'
};

var ADRSubscribeForm = function (_record) {
    (0, _inherits3.default)(ADRSubscribeForm, _record);

    function ADRSubscribeForm() {
        (0, _classCallCheck3.default)(this, ADRSubscribeForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ADRSubscribeForm.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(ADRSubscribeForm, (0, _defaults3.default)(json, (0, _Records.getDefaults)(schema)), (0, _Records.getResolvers)(schema));
    };

    ADRSubscribeForm.prototype.getSchema = function getSchema() {
        return {
            addressLine1: _validation2.default.addressLine().required(),
            addressLine2: _validation2.default.textMaxLength(),
            addressLine3: _validation2.default.textMaxLength(),
            townCity: _validation2.default.townCity(),
            postcode: _joi2.default.any().when('country', {
                is: schema.country,
                then: _validation2.default.postcode(),
                otherwise: _validation2.default.optional()
            }),
            country: _validation2.default.country()
        };
    };

    return ADRSubscribeForm;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

(0, _assign2.default)(ADRSubscribeForm.prototype, _ValidationMixin2.default);

exports.default = ADRSubscribeForm;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultLoginLayout = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(DefaultLoginLayout, _React$PureComponent);

    function DefaultLoginLayout() {
        (0, _classCallCheck3.default)(this, DefaultLoginLayout);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    DefaultLoginLayout.prototype.render = function render() {
        var _props = this.props,
            userInput = _props.userInput,
            passwordInput = _props.passwordInput,
            onLogin = _props.onLogin,
            forgotPasswordButton = _props.forgotPasswordButton,
            isLoggingIn = _props.isLoggingIn,
            error = _props.error,
            withSubmitButton = _props.withSubmitButton;


        var errorMessage = error && _react2.default.createElement(
            _BAlert2.default,
            {
                type: _BAlert.bAlertType.DANGER,
                className: 'margin-bottom',
                focusOnload: true
            },
            error
        );

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { style: { position: 'relative' } },
                _react2.default.createElement(
                    'div',
                    {
                        className: (0, _classnames2.default)('login-form', {
                            'loading-backdrop': isLoggingIn
                        })
                    },
                    errorMessage,
                    userInput,
                    passwordInput
                ),
                isLoggingIn && _react2.default.createElement(_Loading2.default, { unwrapped: true, className: 'loading--centered' })
            ),
            forgotPasswordButton,
            withSubmitButton && _react2.default.createElement(
                _Button2.default,
                {
                    bsStyle: 'primary',
                    className: 'show btn-lg margin-top--sm',
                    onClick: onLogin,
                    disabled: isLoggingIn
                },
                (0, _I18n2.default)('account.login')
            )
        );
    };

    return DefaultLoginLayout;
}(_react2.default.PureComponent), _class.propTypes = {
    userInput: _propTypes2.default.node.isRequired,
    passwordInput: _propTypes2.default.node.isRequired,
    onLogin: _propTypes2.default.func,
    forgotPasswordButton: _propTypes2.default.node,
    error: _propTypes2.default.string,
    isLoggingIn: _propTypes2.default.bool,
    withSubmitButton: _propTypes2.default.bool
}, _class.defaultProps = {
    onLogin: _noop3.default,
    forgotPasswordButton: null,
    isLoggingIn: false,
    withSubmitButton: false
}, _temp);
exports.default = DefaultLoginLayout;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = AccountLockedModal;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _CustomerService = __webpack_require__(280);

var _CustomerService2 = _interopRequireDefault(_CustomerService);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATE = (0, _keymirror2.default)({
    IDLE: null,
    LOADING: null,
    ERROR: null,
    SUCCESS: null
});

function reducer(state, action) {
    switch (action.type) {
        case 'RESET_REQUESTED':
            if ([STATE.LOADING, STATE.SUCCESS].includes(state)) {
                return state;
            }
            return STATE.LOADING;
        case 'RESET_COMPLETED':
            return STATE.SUCCESS;
        case 'RESET_FAILED':
            return STATE.ERROR;
        default:
            return state;
    }
}

function AccountLockedModal(_ref) {
    var _this = this;

    var email = _ref.email,
        _ref$isDormant = _ref.isDormant,
        isDormant = _ref$isDormant === undefined ? false : _ref$isDormant,
        _ref$isLocked = _ref.isLocked,
        isLocked = _ref$isLocked === undefined ? false : _ref$isLocked;

    var _React$useReducer = _react2.default.useReducer(reducer, STATE.IDLE),
        state = _React$useReducer[0],
        dispatch = _React$useReducer[1];

    var requestPasswordReset = _react2.default.useCallback((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;

                        dispatch({ type: 'RESET_REQUESTED' });
                        _context.next = 4;
                        return _CustomerService2.default.requestUnlockAccount(email);

                    case 4:
                        dispatch({ type: 'RESET_COMPLETED' });
                        _context.next = 10;
                        break;

                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context['catch'](0);

                        dispatch({ type: 'RESET_FAILED', error: _context.t0 });

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 7]]);
    })), [email]);

    var modalProps = {
        header: false,
        disableEscape: true,
        hideContinue: isLocked,
        variant: 'light',
        className: 'modal--xs',
        continueText: 'login.accountLocked.button.reactivate',
        disableContinue: [STATE.LOADING, STATE.SUCCESS].includes(state),
        onContinue: requestPasswordReset,
        onClose: function onClose() {
            return _ModalActions2.default.close(AccountLockedModal);
        }
    };

    var title = (0, _react.useMemo)(function () {
        if (isDormant) {
            return 'login.accountLocked.titleDormant';
        }

        if (isLocked) {
            return null;
        }

        return 'login.accountLocked.titleDefault';
    }, [isDormant, isLocked]);

    var message = (0, _react.useMemo)(function () {
        if (isDormant) {
            return 'login.accountLocked.messageDormant';
        }

        if (isLocked) {
            return 'login.accountLocked.messageLocked';
        }

        return 'login.accountLocked.messageDefault';
    }, [isDormant, isLocked]);

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            'section',
            { className: 'confirmation text-center' },
            _react2.default.createElement(_Icon2.default, { icon: 'error', className: 'margin-top margin-bottom otrl-xl' }),
            title ? _react2.default.createElement(
                'p',
                { className: 'text-lg' },
                (0, _I18n2.default)(title)
            ) : null
        ),
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n2.default)(message)
        ),
        state === STATE.ERROR && _react2.default.createElement(
            _BAlert2.default,
            { type: _BAlert.bAlertType.DANGER },
            (0, _I18n2.default)('login.accountLocked.error')
        ),
        state === STATE.SUCCESS && _react2.default.createElement(
            _BAlert2.default,
            { type: _BAlert.bAlertType.SUCCESS },
            (0, _I18n2.default)('login.accountLocked.requestedReset')
        )
    );
}

AccountLockedModal.propTypes = {
    email: _propTypes2.default.string.isRequired,
    isDormant: _propTypes2.default.bool,
    isLocked: _propTypes2.default.bool
};

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Records = __webpack_require__(25);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = {
    currentPassword: [_LinkMapper.fields.string],
    newPassword: [_LinkMapper.fields.string]
};

var PasswordChange = function (_record) {
    (0, _inherits3.default)(PasswordChange, _record);

    function PasswordChange() {
        (0, _classCallCheck3.default)(this, PasswordChange);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PasswordChange.prototype.getSchema = function getSchema() {
        return {
            currentPassword: _validation2.default.passwordEntry(),
            newPassword: _validation2.default.passwordCreate().required()
        };
    };

    return PasswordChange;
}((0, _immutable.Record)((0, _Records.getDefaults)(schema)));

(0, _assign2.default)(PasswordChange.prototype, _ValidationMixin2.default);

exports.default = PasswordChange;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkIfChildSmartCardWillExpireSoon = undefined;

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _LocalStorage = __webpack_require__(316);

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = 'child-smart_card-expiration';

var checkIfChildSmartCardWillExpireSoon = exports.checkIfChildSmartCardWillExpireSoon = function checkIfChildSmartCardWillExpireSoon(smartCard) {
    if (!_FeatureFlagStore2.default.get('enableChildSmartcardTransitioning')) {
        return;
    }

    if (!smartCard) {
        return;
    }

    var isChildWillBeAdultInLessThanAMonth = smartCard.isChild() && smartCard.isActive() && smartCard.willBeAdultInLessThanAMonth();
    if (!isChildWillBeAdultInLessThanAMonth) {
        return;
    }

    var hasShownModal = _LocalStorage2.default.getItem(STORAGE_KEY);
    if (hasShownModal) {
        return;
    }

    (0, _defer3.default)(function () {
        return _ModalActions2.default.open(_AppConstants.GlobalModals.CHILD_SMART_CARD_EXPIRATION);
    });

    _LocalStorage2.default.setItem(STORAGE_KEY, true, smartCard.getSecondsUntilAdult());
};

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _ModalTabs = __webpack_require__(928);

var _ModalTabs2 = _interopRequireDefault(_ModalTabs);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginModalHeader = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(LoginModalHeader, _React$PureComponent);

    function LoginModalHeader() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LoginModalHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleRegisterTab = function () {
            var _this$props = _this.props,
                handleRegister = _this$props.handleRegister,
                onClose = _this$props.onClose;

            var externalRegistrationLink = _config2.default.get('externalRegistrationLink');

            if (externalRegistrationLink) {
                _TrackingActions2.default.externalLink({ name: 'register' });
                window.open(externalRegistrationLink);
            } else {
                onClose();
                handleRegister();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    LoginModalHeader.prototype.render = function render() {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                _ModalTabs2.default,
                { activeTab: 'login' },
                _react2.default.createElement(_ModalTabs2.default.Tab, { name: 'register', onClick: this.handleRegisterTab, title: (0, _I18n2.default)('account.register') }),
                _react2.default.createElement(_ModalTabs2.default.Tab, { name: 'login', title: (0, _I18n2.default)('account.login') })
            ),
            !this.props.hideClose && _react2.default.createElement(
                'div',
                { className: 'modal__header__wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal__header__right modal__header__right--login' },
                    _react2.default.createElement(
                        _Button2.default,
                        { className: 'btn btn-link modal-header__close-button', onClick: this.props.closeModal },
                        _react2.default.createElement(_Icon2.default, { icon: 'close', srOnly: (0, _I18n2.default)('button.text.close') })
                    )
                )
            )
        );
    };

    return LoginModalHeader;
}(_react2.default.PureComponent), _class.propTypes = {
    closeModal: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    hideClose: _propTypes2.default.bool,
    handleRegister: _propTypes2.default.func
}, _temp2);
exports.default = LoginModalHeader;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginModalFooter = function (_React$PureComponent) {
    (0, _inherits3.default)(LoginModalFooter, _React$PureComponent);

    function LoginModalFooter() {
        (0, _classCallCheck3.default)(this, LoginModalFooter);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    LoginModalFooter.prototype.render = function render() {
        var _props = this.props,
            handleLogin = _props.handleLogin,
            nextButtonActive = _props.nextButtonActive,
            handleRegister = _props.handleRegister;

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'button',
                {
                    className: (0, _classnames2.default)('action-btn action-btn--primary modal__footer__button modal__footer__button--primary', { 'modal__footer__button--inactive': !nextButtonActive }),
                    onClick: handleLogin
                },
                _react2.default.createElement(_Icon2.default, { icon: 'chevronslim', className: 'modal__footer__button__arrow' }),
                _react2.default.createElement(
                    'span',
                    { className: 'modal__footer__button__text' },
                    (0, _I18n2.default)('account.login')
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'text-center text-weight--bold margin-top--sm margin-bottom' },
                (0, _I18n2.default)('account.login.registerLabel'),
                ' ',
                _react2.default.createElement(
                    _Button2.default,
                    { onClick: handleRegister, className: 'like-link modal__footer__link' },
                    (0, _I18n2.default)('account.register')
                )
            )
        );
    };

    return LoginModalFooter;
}(_react2.default.PureComponent);

LoginModalFooter.propTypes = {
    handleLogin: _propTypes2.default.func,
    handleRegister: _propTypes2.default.func,
    nextButtonActive: _propTypes2.default.bool
};

exports.default = LoginModalFooter;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icons = {
    info: 'info',
    success: 'selected',
    warning: 'error'
};

function InfoModal(_ref) {
    var type = _ref.type,
        heading = _ref.heading,
        title = _ref.title,
        message = _ref.message,
        onClose = _ref.onClose,
        hideClose = _ref.hideClose,
        disableEscape = _ref.disableEscape,
        disableBlur = _ref.disableBlur,
        disableBorderFooter = _ref.disableBorderFooter,
        disableHeader = _ref.disableHeader,
        disableFooter = _ref.disableFooter,
        customIcon = _ref.customIcon;

    var icon = icons[type];
    var headerDisableProp = disableHeader ? { header: false } : null;
    var footerDisablerProp = disableFooter ? { footer: false } : null;

    var handeCloseButton = function handeCloseButton() {
        if (onClose) {
            (0, _defer3.default)(onClose);
        }
        (0, _defer3.default)(function () {
            _ModalActions2.default.close(_AppConstants.GlobalModals.INFO);
        });
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        (0, _extends3.default)({
            onClose: handeCloseButton,
            hideContinue: true,
            hideClose: hideClose,
            disableEscape: disableEscape,
            disableBlur: disableBlur,
            disableBorderFooter: disableBorderFooter,
            className: 'modal--sm',
            titleText: heading
        }, headerDisableProp, footerDisablerProp),
        _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
                'div',
                { className: 'confirmation text-center' },
                customIcon ? customIcon : icon && _react2.default.createElement(_Icon2.default, { icon: icon + ' margin-top margin-bottom otrl-xl' }),
                _react2.default.createElement(
                    'p',
                    { className: 'text-secondary text-weight--normal' },
                    (0, _I18n.translate)(title)
                ),
                message && _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_FormattedHTMLMessage2.default, { message: (0, _I18n.translate)(message) })
                )
            )
        )
    );
}

InfoModal.propTypes = {
    title: _propTypes2.default.string.isRequired,
    customIcon: _propTypes2.default.any,
    message: _propTypes2.default.string,
    onClose: _propTypes2.default.func,
    hideClose: _propTypes2.default.bool,
    disableEscape: _propTypes2.default.bool,
    disableBlur: _propTypes2.default.bool,
    disableBorderFooter: _propTypes2.default.bool,
    disableFooter: _propTypes2.default.bool,
    disableHeader: _propTypes2.default.bool,
    heading: _propTypes2.default.string,
    type: _propTypes2.default.string
};

InfoModal.defaultProps = {
    customIcon: null,
    disableFooter: false,
    disableBorderFooter: false,
    disableHeader: false,
    heading: 'info.title',
    type: 'success'
};

exports.default = InfoModal;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(85);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ConfirmationModal(_ref) {
    var confirmButtonText = _ref.confirmButtonText,
        icon = _ref.icon,
        message = _ref.message,
        messageValues = _ref.messageValues,
        onCancel = _ref.onCancel,
        onConfirm = _ref.onConfirm,
        closeText = _ref.closeText,
        router = _ref.router,
        title = _ref.title,
        hideClose = _ref.hideClose;

    var onContinue = function onContinue() {
        onConfirm(router);
        _ModalActions2.default.close(_AppConstants.GlobalModals.CONFIRM);
    };
    var onClose = function onClose() {
        onCancel(router);
        _ModalActions2.default.close(_AppConstants.GlobalModals.CONFIRM);
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        {
            onClose: onClose,
            onContinue: onContinue,
            closeText: closeText,
            continueText: confirmButtonText,
            className: 'modal--xs',
            titleText: title,
            hideClose: hideClose
        },
        _react2.default.createElement(
            'section',
            { className: 'confirmation text-center' },
            icon && _react2.default.createElement(_Icon2.default, { icon: icon, className: 'margin-top margin-bottom otrl-xl' }),
            message && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_FormattedHTMLMessage2.default, (0, _extends3.default)({ message: message }, messageValues))
            )
        )
    );
}

ConfirmationModal.propTypes = {
    message: _propTypes2.default.string.isRequired,
    messageValues: _propTypes2.default.object,
    icon: _propTypes2.default.string,
    title: _propTypes2.default.string,
    confirmButtonText: _propTypes2.default.string,
    closeText: _propTypes2.default.string,
    onCancel: _propTypes2.default.func,
    onConfirm: _propTypes2.default.func,
    router: _PropTypes.routerShape.isRequired,
    hideClose: _propTypes2.default.bool
};

ConfirmationModal.defaultProps = {
    messageValues: {},
    icon: '',
    title: 'button.text.confirm',
    confirmButtonText: 'button.text.confirm',
    onCancel: _noop3.default,
    onConfirm: _noop3.default,
    hideClose: false
};

exports.default = ConfirmationModal;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _class2, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _immutable = __webpack_require__(5);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _I18n = __webpack_require__(9);

var _TripsStore = __webpack_require__(879);

var _TripsStore2 = _interopRequireDefault(_TripsStore);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _PaymentStore = __webpack_require__(418);

var _PaymentStore2 = _interopRequireDefault(_PaymentStore);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Trip = __webpack_require__(199);

var _Trip2 = _interopRequireDefault(_Trip);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _ConfirmModal = __webpack_require__(609);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _OrderSummary = __webpack_require__(1085);

var _OrderSummary2 = _interopRequireDefault(_OrderSummary);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _stateFromStores() {
    return {
        currentOrder: _OrderStore2.default.getCurrent(),
        trips: _TripsStore2.default.getAll(),
        trip: _CurrentTripStore2.default.get(),
        smartcard: _SmartcardStore2.default.getCurrent(),
        isProcessing: _PaymentStore2.default.isProcessing(),
        is3DSecure: _PaymentStore2.default.is3DSecure(),
        isLoggedIn: _UserStore2.default.getCurrent().isLoggedIn()
    };
}

var BasketModal = (_dec = (0, _connectToStores2.default)([_OrderStore2.default, _TripsStore2.default, _SmartcardStore2.default, _CurrentTripStore2.default, _PaymentStore2.default, _UserStore2.default], _stateFromStores), _dec(_class = (_temp2 = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(BasketModal, _PureRenderComponent);

    function BasketModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BasketModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            modalOpen: false,
            basketChanged: false
        }, _this._clearBasket = function () {
            _OrderActions2.default.clearBasket(_this.props.currentOrder);
            _this._toggleModal();
            _this._handleClose();
        }, _this._toggleModal = function () {
            _this.setState({ modalOpen: !_this.state.modalOpen });
        }, _this._handleClose = function () {
            _ModalActions2.default.close(_AppConstants.GlobalModals.BASKET);
            if (_this.state.basketChanged) {
                _this.props.router.push(_urls2.default.location(_AppConstants.CheckoutStages.DELIVERY));
            }
            _this.props.onCancel();
        }, _this._handleCheckout = function () {
            _this.props.router.push(_urls2.default.location(_AppConstants.CheckoutStages.DELIVERY));
            _this._handleClose();
        }, _this._renderConfirmClear = function () {
            var _this$props = _this.props,
                isProcessing = _this$props.isProcessing,
                is3DSecure = _this$props.is3DSecure;

            var isLocked = isProcessing || is3DSecure;

            return _react2.default.createElement(_ConfirmModal2.default, {
                titleText: (0, _I18n.translate)('booking.summary.emptyBasket'),
                show: _this.state.modalOpen,
                text: (0, _I18n.translate)('booking.summary.confirmClear'),
                className: 'modal--sm',
                continueText: 'button.text.confirm',
                closeText: 'button.text.cancel',
                disableContinue: isLocked,
                onClose: _this._toggleModal,
                onContinue: _this._clearBasket
            });
        }, _this.goBackToJourneyPlanner = function () {
            _TrackingActions2.default.addAnotherJourneyOnBasketModal("add-another-journey");
            _ModalActions2.default.close(_AppConstants.GlobalModals.BASKET);
            _this.props.router.push(_AppConstants.PointStages.SEARCH);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    BasketModal.prototype._renderTripError = function _renderTripError(_ref) {
        var trips = _ref.trips,
            trip = _ref.trip,
            currentOrder = _ref.currentOrder;

        var test = trips.first();
        var isSmartcardOrder = !!(test && test.isSmartcard());

        if (test && trip.isSmartcard() !== isSmartcardOrder) {
            return _react2.default.createElement(
                'div',
                { className: 'box--padded margin-top--sm' },
                _react2.default.createElement(
                    'div',
                    { className: 'confirmation text-center' },
                    _react2.default.createElement(_Icon2.default, { icon: 'error margin-bottom--sm otrl-xl' }),
                    _react2.default.createElement(
                        'p',
                        { className: 'alert-warning no-margin text-weight--normal' },
                        (0, _I18n.translate)('basket.error.smartcardTicketConflict')
                    )
                )
            );
        }

        if (!currentOrder.isEmpty() && trip.isSmartcard()) {
            return _react2.default.createElement(
                'div',
                { className: 'box--padded margin-top--sm' },
                _react2.default.createElement(
                    'div',
                    { className: 'confirmation text-center' },
                    _react2.default.createElement(_Icon2.default, { icon: 'error margin-bottom--sm otrl-xl' }),
                    _react2.default.createElement(
                        'p',
                        { className: 'alert-warning no-margin text-weight--normal' },
                        (0, _I18n.translate)('basket.error.tooManyTrips')
                    )
                )
            );
        }

        return null;
    };

    BasketModal.prototype._renderEmptyButton = function _renderEmptyButton(_ref2) {
        var currentOrder = _ref2.currentOrder;

        if (currentOrder.isEmpty()) {
            return null;
        }
        return _react2.default.createElement(
            'span',
            { className: 'multiple-buttons' },
            _react2.default.createElement(
                _Button2.default,
                { className: 'action-btn action-btn--secondary', onClick: this._toggleModal },
                (0, _I18n.translate)('booking.summary.emptyBasket')
            ),
            _react2.default.createElement(
                _Button2.default,
                { className: 'action-btn action-btn--secondary', onClick: this.goBackToJourneyPlanner },
                (0, _I18n.translate)('booking.summary.addAnotherJourney')
            )
        );
    };

    BasketModal.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            currentOrder = _props.currentOrder,
            isProcessing = _props.isProcessing,
            is3DSecure = _props.is3DSecure,
            isLoggedIn = _props.isLoggedIn;

        var isLocked = currentOrder.isEmpty() || isProcessing || is3DSecure;

        var setBasketChanged = function setBasketChanged() {
            return _this2.setState({ basketChanged: true });
        };

        return _react2.default.createElement(
            _BaseModal2.default,
            {
                titleText: 'booking.summary.modalTitle',
                className: 'modal--basket',
                onClose: this._handleClose,
                onContinue: this._handleCheckout,
                continueText: 'button.text.checkout',
                closeText: 'button.text.close',
                disableContinue: isLocked,
                footerContent: this._renderEmptyButton(this.props),
                onEnterContinue: false },
            this._renderTripError(this.props),
            this._renderConfirmClear(),
            _react2.default.createElement(_OrderSummary2.default, {
                order: currentOrder,
                showHeader: false,
                isLocked: isLocked,
                isLoggedIn: isLoggedIn,
                context: _AppConstants.OrderSummaryContexts.BASKET_MODAL,
                setBasketChanged: setBasketChanged
            })
        );
    };

    return BasketModal;
}(_PureRenderComponent3.default), _class2.propTypes = {
    router: _propTypes2.default.any.isRequired,
    currentOrder: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    trips: _propTypes2.default.instanceOf(_immutable.Map).isRequired,
    trip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    onCancel: _propTypes2.default.func,
    isProcessing: _propTypes2.default.bool,
    is3DSecure: _propTypes2.default.bool,
    isLoggedIn: _propTypes2.default.bool
}, _class2.defaultProps = {
    onCancel: _noop3.default,
    isProcessing: false,
    is3DSecure: false,
    isLoggedIn: false
}, _temp2)) || _class);
exports.default = BasketModal;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FareValidity = __webpack_require__(414);

var _FareValidity2 = _interopRequireDefault(_FareValidity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SeasonFareShort(_ref) {
    var orderFare = _ref.orderFare;

    return _react2.default.createElement(
        'li',
        { className: 'order-summary__item season-fare-short order-summary__item--short margin-bottom' },
        _react2.default.createElement(
            _Row2.default,
            { className: 'fare-summary' },
            _react2.default.createElement(
                _Col2.default,
                { xs: 12, md: 6, lg: 6 },
                _react2.default.createElement(
                    'div',
                    { className: 'like-table' },
                    _react2.default.createElement(
                        'div',
                        { className: 'table-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'table-cell text-weight--normal' },
                            orderFare.origin.name
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'table-cell direction text-center' },
                            _react2.default.createElement(_Icon2.default, { icon: 'switch', className: 'otrl-rotate-90' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'table-cell text-weight--normal' },
                            orderFare.destination.name
                        )
                    )
                )
            ),
            _react2.default.createElement(
                _Col2.default,
                { xs: 12, md: 6, lg: 6, className: 'text-weight--normal ticket-type no-margin' },
                _react2.default.createElement(
                    'p',
                    { className: 'text-weight--normal ticket-type no-margin' },
                    orderFare.getName()
                )
            )
        ),
        _react2.default.createElement(_FareValidity2.default, {
            from: orderFare.outwardJourney.validFrom,
            to: orderFare.outwardJourney.validTo
        })
    );
}

SeasonFareShort.propTypes = {
    orderFare: _propTypes2.default.instanceOf(_Fare2.default).isRequired,
    open: _propTypes2.default.bool
};

SeasonFareShort.defaultProps = {
    open: false
};

exports.default = SeasonFareShort;

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = OrderTicket;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Ticket = __webpack_require__(239);

var _Ticket2 = _interopRequireDefault(_Ticket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderTicket(_ref) {
    var ticket = _ref.ticket;

    var number = ticket.adults || ticket.children;
    var type = ticket.adults ? 'adult' : 'child';
    var hasRailcard = ticket.railcard && !ticket.isGroupSave();

    var modifier = hasRailcard ? '_railcard' : '';
    if (ticket.isRefunded) {
        modifier = 'Refunded';
    }
    return _react2.default.createElement(
        'span',
        null,
        (0, _I18n.translate)('order.summary.passengers.' + type + modifier, { number: number })
    );
}

OrderTicket.propTypes = {
    ticket: _propTypes2.default.instanceOf(_Ticket2.default)
};

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = __webpack_require__(5);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _Journey = __webpack_require__(816);

var _Journey2 = _interopRequireDefault(_Journey);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _AlertButton = __webpack_require__(449);

var _AlertButton2 = _interopRequireDefault(_AlertButton);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JourneySelectionItem = function JourneySelectionItem(_ref) {
    var _cn;

    var journey = _ref.journey,
        checked = _ref.checked,
        onChange = _ref.onChange,
        _ref$hideCheckbox = _ref.hideCheckbox,
        hideCheckbox = _ref$hideCheckbox === undefined ? false : _ref$hideCheckbox;

    var baseClass = 'disruption-alerts-journey-selection-item';
    var classes = (0, _classnames2.default)(baseClass, (_cn = {}, _cn[baseClass + '--checkable'] = !hideCheckbox, _cn));

    var labelClass = baseClass + '-label';
    var label = _react2.default.createElement(
        'div',
        { className: labelClass },
        _react2.default.createElement(
            'p',
            { className: labelClass + '__stations' },
            journey.getOrigin().name + ' to ' + journey.getDestination().name
        ),
        _react2.default.createElement(
            'p',
            { className: labelClass + '__time' },
            'Out: ' + journey.getDepartureTime().format('ddd Do MMM YYYY HH:mm')
        )
    );

    return _react2.default.createElement(
        'div',
        { className: classes },
        hideCheckbox ? label : _react2.default.createElement(_Checkbox2.default, {
            groupClassName: 'disruption-alerts-journey-selection-item__checkbox',
            name: 'selectedJourneys',
            label: label,
            checked: checked,
            onChange: onChange(journey),
            value: 'yes',
            darkBackground: true
        })
    );
};

var JourneySelectorModal = function JourneySelectorModal(_ref2) {
    var orderTrip = _ref2.orderTrip,
        onClose = _ref2.onClose,
        onConfirm = _ref2.onConfirm,
        modalProps = (0, _objectWithoutProperties3.default)(_ref2, ['orderTrip', 'onClose', 'onConfirm']);

    var journeys = orderTrip.isOpenReturn() ? new _immutable.List([orderTrip.getOutwardJourney()]) : orderTrip.getJourneys();

    var initialState = journeys.reduce(function (map, journey) {
        return map.set(journey, true);
    }, // Pre-select all journeys
    new _immutable.Map());

    var _useState = (0, _react.useState)(initialState),
        selectedJourneys = _useState[0],
        setSelectedJourneys = _useState[1];

    if (journeys.isEmpty()) {
        return null;
    }

    var toggleJourney = function toggleJourney(journey) {
        return function () {
            return setSelectedJourneys(function (prevSelectedJourneys) {
                return prevSelectedJourneys.set(journey, !prevSelectedJourneys.get(journey));
            });
        };
    };

    var handleConfirm = function handleConfirm() {
        return onConfirm(new _immutable.List(selectedJourneys.filter(function (selected) {
            return selected;
        }).keys()));
    };

    var baseClass = 'disruption-alerts-journey-selector-modal';

    var modalFooter = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            _reactBootstrap.Row,
            { className: 'margin-bottom--sm' },
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12, className: 'text-left' },
                (0, _I18n2.default)('disruptionAlerts.modals.common.disclaimer')
            )
        ),
        _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12, className: baseClass + '__footer-actions' },
                _react2.default.createElement(
                    _reactBootstrap.Button,
                    {
                        bsStyle: 'default',
                        onClick: onClose,
                        className: 'close action-btn action-btn--auto action-btn--secondary'
                    },
                    (0, _I18n2.default)('button.text.close')
                ),
                _react2.default.createElement(_AlertButton2.default, {
                    onClick: handleConfirm,
                    disabled: !selectedJourneys.includes(true)
                })
            )
        )
    );

    return _react2.default.createElement(
        _BaseModal2.default,
        (0, _extends3.default)({}, modalProps, {
            className: (0, _classnames2.default)('' + baseClass, 'modal--sm'),
            useFlex: true,
            footer: modalFooter,
            onClose: onClose,
            hideContinue: true
        }),
        _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12 },
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n2.default)('disruptionAlerts.modals.common.intro')
                )
            )
        ),
        _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12 },
                _react2.default.createElement(
                    'p',
                    { className: 'margin-bottom--xs' },
                    (0, _I18n2.default)('disruptionAlerts.modals.journeySelect.items', { totalJourneys: journeys.size })
                ),
                journeys.map(function (journey) {
                    return _react2.default.createElement(JourneySelectionItem, {
                        journey: journey,
                        checked: selectedJourneys.get(journey),
                        onChange: toggleJourney,
                        hideCheckbox: journeys.size === 1
                    });
                })
            )
        )
    );
};

JourneySelectionItem.propTypes = {
    journey: _propTypes2.default.instanceOf(_Journey2.default).isRequired,
    checked: _propTypes2.default.bool.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    hideCheckbox: _propTypes2.default.bool
};

JourneySelectorModal.propTypes = {
    modalProps: _propTypes2.default.object,
    onClose: _propTypes2.default.func.isRequired,
    onConfirm: _propTypes2.default.func.isRequired,
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired
};

exports.default = JourneySelectorModal;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(100);

var _FormControl = __webpack_require__(178);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _immutable = __webpack_require__(5);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AddJourneyModalTravelForm = __webpack_require__(2043);

var _AddJourneyModalTravelForm2 = _interopRequireDefault(_AddJourneyModalTravelForm);

var _AddJourneyModalTravelTable = __webpack_require__(2047);

var _AddJourneyModalTravelTable2 = _interopRequireDefault(_AddJourneyModalTravelTable);

var _AddJourneyModalUsualDays = __webpack_require__(2048);

var _AddJourneyModalUsualDays2 = _interopRequireDefault(_AddJourneyModalUsualDays);

var _AppConstants = __webpack_require__(6);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

var _TimeSelector = __webpack_require__(979);

var _TimeSelector2 = _interopRequireDefault(_TimeSelector);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _StationService = __webpack_require__(341);

var _StationService2 = _interopRequireDefault(_StationService);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddJourneyForm = function AddJourneyForm(_ref) {
    var businessDays = _ref.businessDays,
        editingJourney = _ref.editingJourney,
        enableRegularJourneyCreation = _ref.enableRegularJourneyCreation,
        errorWellText = _ref.errorWellText,
        isOCDRMode = _ref.isOCDRMode,
        outwardJourneys = _ref.outwardJourneys,
        remainingJourneys = _ref.remainingJourneys,
        saveRegularJourneyAlert = _ref.saveRegularJourneyAlert,
        search = _ref.search,
        searchErrors = _ref.searchErrors,
        selectedJourneys = _ref.selectedJourneys,
        setBusinessDays = _ref.setBusinessDays,
        setDisabledSaveJourney = _ref.setDisabledSaveJourney,
        setJourneyData = _ref.setJourneyData,
        setJourneyTime = _ref.setJourneyTime,
        setSaveRegularJourneyAlert = _ref.setSaveRegularJourneyAlert,
        setStationFacilityAlert = _ref.setStationFacilityAlert,
        setSearch = _ref.setSearch,
        setWeekday = _ref.setWeekday,
        setSelectedJourneys = _ref.setSelectedJourneys,
        showErrorWell = _ref.showErrorWell,
        stationFacilityAlert = _ref.stationFacilityAlert,
        weekday = _ref.weekday;

    var _useState = (0, _react.useState)((0, _moment2.default)()),
        newTime = _useState[0],
        setNewTime = _useState[1];

    var _useState2 = (0, _react.useState)(weekday),
        newWeekday = _useState2[0],
        setNewWeekday = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        isLoading = _useState3[0],
        setIsLoading = _useState3[1];

    var _useState4 = (0, _react.useState)(false),
        isChangedStation = _useState4[0],
        setIsChangedStation = _useState4[1];

    var getTime = function getTime() {
        var _newTime$toObject = newTime.toObject(),
            hours = _newTime$toObject.hours,
            minutes = _newTime$toObject.minutes;

        var newDatetime = null;

        if (newWeekday === 'weekday') {
            var time = (0, _moment2.default)(newTime).startOf('isoWeek');

            var today = (0, _moment2.default)();

            /*
                If the Monday of the current week is today (today is Monday)
                or the Monday of the current week is in the past,
                we need to jump one week ahead else we won't get services returned for all
                possible search times
            */
            if (time.isBefore(today) || time.isSame(today, 'day')) {
                time = time.add(1, 'week');
            }

            newDatetime = time.set({ hours: hours, minutes: minutes });
        } else {
            var dayInt = newWeekday === 'saturday' ? 6 : 7;
            newDatetime = (0, _moment2.default)().day(dayInt).set({ hours: hours, minutes: minutes, second: 0 });
        }

        return newDatetime;
    };

    var setTime = function setTime() {
        setJourneyTime(getTime());
    };

    (0, _react.useEffect)(function () {
        setTime();
        // eslint-disable-next-line
    }, [newWeekday, newTime]);

    var hasOutwardJourneys = outwardJourneys && outwardJourneys.size > 0;

    (0, _react.useEffect)(function () {
        var setStationsAndWeekday = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var prepopulatedOriginNlc, prepopulatedDestinationNlc, originStation, destinationStation;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                prepopulatedOriginNlc = editingJourney && editingJourney.origin.nlc;
                                prepopulatedDestinationNlc = editingJourney && editingJourney.destination.nlc;

                                if (!(!hasOutwardJourneys && !isChangedStation)) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 5;
                                return _StationService2.default.get(prepopulatedOriginNlc);

                            case 5:
                                originStation = _context.sent;
                                _context.next = 8;
                                return _StationService2.default.get(prepopulatedDestinationNlc);

                            case 8:
                                destinationStation = _context.sent;


                                (0, _defer3.default)(function () {
                                    return setSearch(search.set('origin', originStation).set('destination', destinationStation).set('outboundDateTime', new _Timeband2.default({ datetime: getTime() })));
                                });

                            case 10:
                                setIsLoading(false);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, undefined);
            }));

            return function setStationsAndWeekday() {
                return _ref2.apply(this, arguments);
            };
        }();

        if (editingJourney) {
            setIsLoading(true);
            setStationsAndWeekday();

            var originalTime = editingJourney.serviceTimes[0].split(':');

            var journeyType = editingJourney.journeyType;

            setNewWeekday(journeyType);
            setWeekday(journeyType);
            setNewTime(newTime.set({
                hour: originalTime[0],
                minute: originalTime[1]
            }));
        }
        // eslint-disable-next-line
    }, [editingJourney]);

    var shouldShowStationAlertsCheckbox = !isOCDRMode || saveRegularJourneyAlert;

    if (isLoading) {
        return _react2.default.createElement(_Loading2.default, { message: 'Loading journey details', unwrapped: true, standalone: true });
    }

    return _react2.default.createElement(
        'form',
        { className: 'journey-modal-form', onSubmit: function onSubmit(e) {
                return e.preventDefault();
            } },
        _react2.default.createElement(
            'div',
            { className: 'journey-modal-weekday-select margin-left--xs margin-bottom--sm' },
            _react2.default.createElement(
                'span',
                { 'aria-hidden': 'true' },
                (0, _I18n2.default)('auto-dr.account.subscribe.journeys.add')
            ),
            _react2.default.createElement(
                _FormControl2.default,
                {
                    'aria-label': (0, _I18n2.default)('auto-dr.account.subscribe.journeys.addJourney', { weekday: weekday }),
                    componentClass: 'select',
                    className: 'journey-modal-weekday margin-left--xs margin-right--xs padding--vert-xs',
                    name: 'weekday',
                    id: 'weekday',
                    value: weekday,
                    onChange: function onChange(e) {
                        setWeekday(e.target.value);
                        setNewWeekday(e.target.value);
                    }
                },
                _AppConstants.WeekDaysJourney.map(function (day) {
                    return _react2.default.createElement(
                        'option',
                        { key: day, value: day },
                        day[0].toUpperCase() + day.slice(1)
                    );
                })
            ),
            _react2.default.createElement(
                'span',
                { 'aria-hidden': 'true' },
                (0, _I18n2.default)('auto-dr.account.subscribe.journeys')
            )
        ),
        _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12 },
                weekday === _AppConstants.InitialWeekDayJourney && _react2.default.createElement(_AddJourneyModalUsualDays2.default, {
                    businessDays: businessDays,
                    setBusinessDays: setBusinessDays
                })
            )
        ),
        _react2.default.createElement(
            _reactBootstrap.Row,
            { className: 'journey-modal-info-row padding--horiz-sm margin-bottom--sm margin-left--xs margin-right--xs' },
            _react2.default.createElement(_AddJourneyModalTravelForm2.default, {
                editingJourney: editingJourney,
                search: search,
                searchErrors: searchErrors,
                setSearch: setSearch,
                outwardJourneys: outwardJourneys,
                setIsChangedStation: setIsChangedStation
            })
        ),
        showErrorWell && _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12 },
                _react2.default.createElement(
                    _BAlert2.default,
                    { type: _BAlert.bAlertType.DANGER },
                    errorWellText
                )
            )
        ),
        _react2.default.createElement(
            _reactBootstrap.Row,
            { className: 'journey-modal-info-row no-border' },
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12, className: 'journey-modal-info-departing' },
                (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.departing'),
                '\xA0',
                _react2.default.createElement(_TimeSelector2.default, {
                    className: 'disruption-alerts-service-selector__time',
                    combined: true,
                    dateTime: search.outboundDateTime.datetime,
                    onChange: function onChange(datetime) {
                        setNewTime(datetime);
                    },
                    ariaLabel: (0, _I18n2.default)('auto-dr.account.subscribe.journeys.departingAround')
                })
            ),
            _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12 },
                outwardJourneys && _react2.default.createElement(_AddJourneyModalTravelTable2.default, {
                    editingJourney: editingJourney,
                    setJourneyData: setJourneyData,
                    outwardJourneys: outwardJourneys,
                    selectedJourneys: selectedJourneys,
                    setSelectedJourneys: setSelectedJourneys,
                    remainingJourneys: remainingJourneys,
                    businessDays: businessDays,
                    setDisabledSaveJourney: setDisabledSaveJourney,
                    weekday: weekday,
                    search: search,
                    setNewTime: setNewTime,
                    setSearch: setSearch
                })
            ),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableDisruptionAlerts' },
                enableRegularJourneyCreation && _react2.default.createElement(
                    _reactBootstrap.Col,
                    { xs: 12 },
                    _react2.default.createElement(_Checkbox2.default, {
                        className: 'journey-modal-days-checkbox',
                        label: (0, _I18n2.default)('auto-dr.account.subscribe.info.regularJourneyAlert'),
                        'aria-label': 'Set up regular journey alert for this journey',
                        onChange: function onChange() {
                            if (saveRegularJourneyAlert) {
                                setStationFacilityAlert(false);
                            }
                            setSaveRegularJourneyAlert(!saveRegularJourneyAlert);
                        },
                        checked: saveRegularJourneyAlert
                    })
                ),
                shouldShowStationAlertsCheckbox && _react2.default.createElement(
                    _reactBootstrap.Col,
                    { xs: 12 },
                    _react2.default.createElement(_Checkbox2.default, {
                        className: 'journey-modal-days-checkbox',
                        label: (0, _I18n2.default)('auto-dr.account.subscribe.info.includeStationFacilityAlerts'),
                        'aria-label': 'Include station facility alerts for this regular journey alert',
                        onChange: function onChange() {
                            return setStationFacilityAlert(!stationFacilityAlert);
                        },
                        checked: stationFacilityAlert
                    })
                )
            ),
            outwardJourneys && outwardJourneys.size > 0 && _react2.default.createElement(
                _reactBootstrap.Col,
                { xs: 12, className: 'margin-bottom--xs margin-left--xs margin-right--xs' },
                _react2.default.createElement(
                    'p',
                    { className: 'padding-top' },
                    (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.travel.return.journey')
                )
            )
        )
    );
};

AddJourneyForm.propTypes = {
    businessDays: _propTypes2.default.array.isRequired,
    editingJourney: _propTypes2.default.string,
    enableRegularJourneyCreation: _propTypes2.default.bool,
    errorWellText: _propTypes2.default.string,
    isOCDRMode: _propTypes2.default.bool,
    outwardJourneys: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    remainingJourneys: _propTypes2.default.number.isRequired,
    saveRegularJourneyAlert: _propTypes2.default.bool,
    search: _propTypes2.default.instanceOf(_Search2.default).isRequired,
    searchErrors: _propTypes2.default.instanceOf(_immutable.Set),
    selectedJourneys: _propTypes2.default.array.isRequired,
    setBusinessDays: _propTypes2.default.func.isRequired,
    setDisabledSaveJourney: _propTypes2.default.func.isRequired,
    setJourneyData: _propTypes2.default.func.isRequired,
    setJourneyTime: _propTypes2.default.func.isRequired,
    setSaveRegularJourneyAlert: _propTypes2.default.func.isRequired,
    setSearch: _propTypes2.default.func.isRequired,
    setSelectedJourneys: _propTypes2.default.func.isRequired,
    setStationFacilityAlert: _propTypes2.default.func.isRequired,
    setWeekday: _propTypes2.default.func.isRequired,
    showErrorWell: _propTypes2.default.bool,
    stationFacilityAlert: _propTypes2.default.bool,
    weekday: _propTypes2.default.string.isRequired
};

exports.default = AddJourneyForm;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(100);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(5);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _AppConstants = __webpack_require__(6);

var _StationSelector = __webpack_require__(976);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SectionErrors = __webpack_require__(974);

var _SectionErrors2 = _interopRequireDefault(_SectionErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddJourneyModalTravelForm = function AddJourneyModalTravelForm(_ref) {
    var search = _ref.search,
        searchErrors = _ref.searchErrors,
        setSearch = _ref.setSearch,
        setIsChangedStation = _ref.setIsChangedStation;

    var errors = (0, _react.useMemo)(function () {
        var errs = new _immutable.Map();
        if (searchErrors.has('validateStationsNotEqual')) {
            errs = errs.set('origin', 'booking.journey.errors.sameStation').set('destination', 'booking.journey.errors.sameStation');
        }

        return errs;
    }, [searchErrors]);

    var handleStationChange = function handleStationChange(name, currentStation) {
        setIsChangedStation(true);
        setSearch(search.set(name, currentStation));
    };

    var renderStation = function renderStation(name, type) {
        var placeholder = (0, _I18n2.default)('booking.journey.' + name);

        return _react2.default.createElement(_StationSelector.StationSelector, {
            className: 'journey-modal-info-field',
            excludeGroupStations: true,
            onChange: function onChange(currentStation) {
                return handleStationChange(name, currentStation);
            },
            station: search[name],
            placeholder: placeholder,
            stationType: type,
            name: name
        });
    };

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 12, className: 'journey-modal-info-title margin-top--sm' },
            (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.info')
        ),
        _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 12, className: 'journey-modal-info-errors' },
            _react2.default.createElement(_SectionErrors2.default, { errors: errors.toSet().toList().toArray() })
        ),
        _react2.default.createElement(
            _reactBootstrap.Col,
            { sm: 5, xs: 12, className: 'journey-modal-info-field-col margin-top--sm margin-bottom--sm' },
            _react2.default.createElement(_Icon2.default, { icon: 'mandatory', className: 'journey-modal-info-mandatory' }),
            renderStation('origin', _AppConstants.StationTypes.ORIGIN)
        ),
        _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 2, className: 'journey-modal-info-arrowback text-center padding--vert-sm margin-top--sm margin-bottom--sm' },
            _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-180 journey-modal-info-arrow' })
        ),
        _react2.default.createElement(
            _reactBootstrap.Col,
            { sm: 5, xs: 12, className: 'journey-modal-info-field-col margin-top--sm margin-bottom--sm' },
            _react2.default.createElement(_Icon2.default, { icon: 'mandatory', className: 'journey-modal-info-mandatory' }),
            renderStation('destination', _AppConstants.StationTypes.DESTINATION)
        )
    );
};

AddJourneyModalTravelForm.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default).isRequired,
    searchErrors: _propTypes2.default.instanceOf(_immutable.Set),
    setSearch: _propTypes2.default.func.isRequired,
    setIsChangedStation: _propTypes2.default.func.isRequired
};

AddJourneyModalTravelForm.defaultProps = {
    searchErrors: new _immutable.Set()
};

exports.default = AddJourneyModalTravelForm;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutocompleteOption = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(AutocompleteOption, _PureRenderComponent);

    function AutocompleteOption() {
        (0, _classCallCheck3.default)(this, AutocompleteOption);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    AutocompleteOption.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.highlighted && !prevProps.highlighted) {
            this.refs.option.scrollIntoViewIfNeeded(false);
        }
    };

    AutocompleteOption.prototype._renderOptionChild = function _renderOptionChild() {
        if (!this.props.optionElement) {
            return this.props.label;
        }
        var OptionComponent = this.props.optionElement;

        return _react2.default.createElement(OptionComponent, {
            data: this.props.data,
            search: this.props.search
        });
    };

    AutocompleteOption.prototype.render = function render() {
        var highlighted = this.props.highlighted;


        var classes = (0, _classnames2.default)('autocomplete__option', {
            'autocomplete__option--highlighted': highlighted
        });

        return _react2.default.createElement(
            'div',
            { ref: 'option', className: classes },
            this._renderOptionChild()
        );
    };

    return AutocompleteOption;
}(_PureRenderComponent3.default), _class.propTypes = {
    search: _propTypes2.default.string,
    value: _propTypes2.default.any.isRequired,
    label: _propTypes2.default.string,
    data: _propTypes2.default.any,
    highlighted: _propTypes2.default.bool,
    optionElement: _propTypes2.default.func
}, _class.defaultProps = {
    role: 'option',
    label: '',
    highlighted: false,
    data: {},
    optionElement: null,
    search: null
}, _temp);
exports.default = AutocompleteOption;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _HighlightedText = __webpack_require__(1164);

var _HighlightedText2 = _interopRequireDefault(_HighlightedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StationListItem(_ref) {
    var data = _ref.data,
        search = _ref.search;

    return _react2.default.createElement(
        'div',
        { className: 'station-selector__item station-name' },
        _react2.default.createElement(_HighlightedText2.default, {
            text: data.name,
            textToHighlight: search,
            highlightClass: 'station-selector__item--highlight'
        }),
        _react2.default.createElement(
            'span',
            { className: 'station-selector__item-code pull-right' },
            data.crs.toUpperCase()
        )
    );
}

StationListItem.propTypes = {
    data: _propTypes2.default.instanceOf(_Station2.default).isRequired,
    search: _propTypes2.default.string
};

StationListItem.defaultProps = {
    search: null
};

exports.default = StationListItem;

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(119);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Durations = __webpack_require__(430);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _LoadingStore = __webpack_require__(455);

var _LoadingStore2 = _interopRequireDefault(_LoadingStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _useScreenDimensions2 = __webpack_require__(977);

var _useScreenDimensions3 = _interopRequireDefault(_useScreenDimensions2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderNoJourneySearchResults = function renderNoJourneySearchResults(loading) {
    return _react2.default.createElement(
        _BAlert2.default,
        { className: 'margin-bottom--sm margin-top--sm', type: loading ? _BAlert.bAlertType.SUCCESS : _BAlert.bAlertType.DANGER },
        (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.' + (loading ? 'loading-journeys' : 'no-compatible-journeys'))
    );
};

var AddJourneyModalTravelTable = function AddJourneyModalTravelTable(_ref) {
    var businessDays = _ref.businessDays,
        outwardJourneys = _ref.outwardJourneys,
        remainingJourneys = _ref.remainingJourneys,
        search = _ref.search,
        selectedJourneys = _ref.selectedJourneys,
        setDisabledSaveJourney = _ref.setDisabledSaveJourney,
        setNewTime = _ref.setNewTime,
        setSelectedJourneys = _ref.setSelectedJourneys,
        weekday = _ref.weekday,
        editingJourney = _ref.editingJourney,
        loading = _ref.loading;

    var maxJourneys = _config2.default.get('autoDelayRepayMaxJourneys');

    var _useState = (0, _react.useState)(true),
        canLoadEarlierServices = _useState[0],
        setCanLoadEarlierServices = _useState[1];

    var _useState2 = (0, _react.useState)(true),
        canLoadLaterServices = _useState2[0],
        setCanLoadLaterServices = _useState2[1];

    var selectedDays = weekday === 'weekday' ? businessDays.filter(function (day) {
        return day.checked;
    }) : [weekday];

    var journeysQuantity = maxJourneys - remainingJourneys - (editingJourney ? editingJourney.serviceTimes.length * editingJourney.daysOfWeek.length : 0) + (selectedJourneys ? selectedJourneys.length * selectedDays.length : 0);

    var _useScreenDimensions = (0, _useScreenDimensions3.default)(),
        isMobileWidth = _useScreenDimensions.isMobileWidth;

    var handleJourney = function handleJourney(journey) {
        if (!selectedJourneys.find(function (x) {
            return x.id === journey.id;
        })) {
            setSelectedJourneys([].concat(selectedJourneys, [journey]));
        } else {
            setSelectedJourneys([].concat(selectedJourneys).filter(function (x) {
                return x.id !== journey.id;
            }));
        }
    };

    (0, _react.useEffect)(function () {
        if (!search.origin.nlc || !search.destination.nlc || !businessDays.some(function (day) {
            return day.checked;
        }) || journeysQuantity > maxJourneys || selectedJourneys.length < 1) {
            setDisabledSaveJourney(true);
        } else {
            setDisabledSaveJourney(false);
        }
        // eslint-disable-next-line
    }, [journeysQuantity, maxJourneys, selectedJourneys.length, search.origin, search.destination]);

    var searchTime = search.outboundDateTime.datetime;

    (0, _react.useEffect)(function () {
        setCanLoadEarlierServices(searchTime.isSame(searchTime.clone().subtract(1, 'hours'), 'day'));
        setCanLoadLaterServices(searchTime.isSame(searchTime.clone().add(1, 'hours'), 'day'));
    }, [searchTime]);

    var loadEarlierOrLaterServices = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(isLater) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (isLater) {
                                setNewTime(searchTime.add(1, 'hours'));
                            } else {
                                setNewTime(searchTime.subtract(1, 'hours'));
                            }

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function loadEarlierOrLaterServices(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var sortedJourneys = outwardJourneys.sort(function (a, b) {
        return a.origin.time.scheduledTime.valueOf() - b.origin.time.scheduledTime.valueOf();
    });

    var loadEarlierServices = function loadEarlierServices(e) {
        e.preventDefault();
        loadEarlierOrLaterServices();
    };

    var loadLaterServices = function loadLaterServices(e) {
        e.preventDefault();
        loadEarlierOrLaterServices(true);
    };

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        outwardJourneys.size > 0 ? _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'row margin-left--xs margin-right--xs' },
                canLoadEarlierServices && _react2.default.createElement(
                    _reactBootstrap.Col,
                    { xs: 12, className: 'journey-modal-travel-title margin-top--sm margin-bottom--xs' },
                    (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.travel'),
                    _react2.default.createElement(
                        'a',
                        {
                            onClick: loadEarlierServices,
                            href: '#',
                            className: 'service-pager pull-right',
                            'aria-label': (0, _I18n2.default)('booking.fare.eligibleServicesModal.table.earlier.ariaLabel') },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            _react2.default.createElement('i', { className: 'otrl otrl-chevron otrl-rotate-270', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                'Show'
                            ),
                            'Earlier'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'journey-modal-travel-table-wrapper' },
                    _react2.default.createElement(
                        _reactBootstrap.Table,
                        { xs: 12, className: 'journey-modal-travel-table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                { className: 'journey-modal-travel-table-title' },
                                _react2.default.createElement(
                                    'th',
                                    { className: 'journey-modal-travel-table-title-departing' },
                                    (0, _I18n2.default)('journey.modal.travel.table.departureTime')
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    (0, _I18n2.default)('journey.modal.travel.table.from')
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    (0, _I18n2.default)('journey.modal.travel.table.to')
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'journey-modal-travel-table-duration' },
                                    (0, _I18n2.default)('journey.modal.travel.table.duration')
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'journey-modal-travel-table-title-changed' },
                                    (0, _I18n2.default)('journey.modal.travel.table.changes')
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'journey-modal-travel-table-title-selected' },
                                    (0, _I18n2.default)(isMobileWidth ? 'journey.modal.travel.table.selected.mobile' : 'journey.modal.travel.table.selected')
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            sortedJourneys.map(function (journey) {
                                var departing = (0, _TrainTime2.default)(journey.origin.time.scheduledTime).format('HH:mm');
                                var from = journey.origin.station.name;
                                var to = journey.destination.station.name;
                                var mobileFrom = journey.origin.station.crs;
                                var mobileTo = journey.destination.station.crs;

                                var duration = journey.getTripDuration();

                                var legs = journey.legs;


                                var changes = legs && legs.size - 1;
                                var fullDurationString = (0, _Durations.durationString)({
                                    hours: duration._data.hours,
                                    minutes: duration._data.minutes
                                });
                                var checked = selectedJourneys.find(function (x) {
                                    return x.id === journey.id;
                                });

                                var ariaLabel = (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.travel.from-to-aria-label', {
                                    departing: departing,
                                    from: from,
                                    to: to,
                                    duration: '' + fullDurationString.replace('m', 'minutes'),
                                    changes: changes
                                });

                                return _react2.default.createElement(
                                    'tr',
                                    { key: journey.id, className: 'journey-modal-travel-table-row' },
                                    _react2.default.createElement(
                                        'td',
                                        { 'aria-hidden': true, className: 'journey-modal-travel-table-departing journey-modal-travel-table-cell-bold' },
                                        departing
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { 'aria-hidden': true, className: 'journey-modal-travel-table-from journey-modal-travel-table-cell-bold' },
                                        isMobileWidth ? mobileFrom : from,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'journey-modal-travel-table-icon-wrap' },
                                            _react2.default.createElement(_Icon2.default, {
                                                icon: 'arrowback',
                                                className: 'otrl-rotate-180 journey-modal-travel-table-icon'
                                            })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { 'aria-hidden': true, className: 'journey-modal-travel-table-cell-bold' },
                                        isMobileWidth ? mobileTo : to
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { 'aria-hidden': true, className: 'journey-modal-travel-table-duration journey-modal-travel-table-cell-bold' },
                                        fullDurationString
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { 'aria-hidden': true, className: 'journey-modal-travel-table-changes' },
                                        changes
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        { 'aria-hidden': true, className: 'journey-modal-travel-table-select' },
                                        legs.size < 1 ? 'No ' + (0, _I18n2.default)('app.owner.short') + ' legs' : _react2.default.createElement(_Checkbox2.default, {
                                            className: 'journey-modal-table-checkbox',
                                            onChange: function onChange() {
                                                return handleJourney(journey);
                                            },
                                            checked: checked,
                                            'aria-label': ariaLabel
                                        })
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Col,
                    { xs: 12, className: 'journey-modal-travel-selected margin-top--sm margin-bottom--xs' },
                    _react2.default.createElement(
                        _reactBootstrap.Row,
                        null,
                        _react2.default.createElement(
                            _reactBootstrap.Col,
                            { xs: 10, className: 'journey-modal-travel-selected-time' },
                            selectedJourneys && selectedJourneys.map(function (j) {
                                return _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'journey-card-time-col padding--vert-xs padding--horiz-xs margin-right--xs'
                                    },
                                    j.origin.getTime().format('HH:mm'),
                                    _react2.default.createElement(
                                        'button',
                                        {
                                            onClick: function onClick() {
                                                return handleJourney(j);
                                            },
                                            className: 'modal-header__close-button',
                                            'aria-label': 'Delete this journey: ' + j.origin.getTime().format('HH:mm')
                                        },
                                        _react2.default.createElement(_Icon2.default, { icon: 'close' })
                                    )
                                );
                            }),
                            journeysQuantity >= _config2.default.get('autoDelayRepayMaxJourneys') - _config2.default.get('autoDelayRepayRemainingJourneysWarningThreshold') && _react2.default.createElement(
                                'div',
                                null,
                                (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.travel.selected', {
                                    journeysQuantity: journeysQuantity,
                                    maxJourneys: _config2.default.get('autoDelayRepayMaxJourneys')
                                })
                            )
                        ),
                        canLoadLaterServices && _react2.default.createElement(
                            _reactBootstrap.Col,
                            { xs: 2, className: 'journey-modal-travel-load-later' },
                            _react2.default.createElement(
                                'a',
                                {
                                    onClick: loadLaterServices,
                                    href: '#',
                                    className: 'service-pager pull-right',
                                    'aria-label': (0, _I18n2.default)('booking.fare.eligibleServicesModal.table.later.ariaLabel') },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    _react2.default.createElement('i', { className: 'otrl otrl-chevron otrl-rotate-90', 'aria-hidden': 'true' }),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'sr-only' },
                                        (0, _I18n2.default)('booking.fare.eligibleServicesModal.table.show')
                                    ),
                                    (0, _I18n2.default)('booking.fare.eligibleServicesModal.table.later')
                                )
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                _reactBootstrap.Row,
                null,
                _react2.default.createElement(
                    _reactBootstrap.Col,
                    { xs: 12, className: 'margin-bottom--sm margin-top--sm' },
                    journeysQuantity > maxJourneys && _react2.default.createElement(
                        _BAlert2.default,
                        { type: _BAlert.bAlertType.DANGER },
                        (0, _I18n2.default)('auto-dr.subscribe.add-journey-max', { maxJourneys: maxJourneys }),
                        '.'
                    )
                )
            )
        ) : renderNoJourneySearchResults(loading)
    );
};

AddJourneyModalTravelTable.propTypes = {
    businessDays: _propTypes2.default.array.isRequired,
    journeys: _propTypes2.default.array.isRequired,
    outwardJourneys: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    remainingJourneys: _propTypes2.default.number.isRequired,
    search: _propTypes2.default.instanceOf(_Search2.default).isRequired,
    selectedJourneys: _propTypes2.default.array.isRequired,
    setDisabledSaveJourney: _propTypes2.default.func.isRequired,
    setNewTime: _propTypes2.default.func.isRequired,
    setJourneyData: _propTypes2.default.func.isRequired,
    setSelectedJourneys: _propTypes2.default.func.isRequired,
    weekday: _propTypes2.default.string.isRequired,
    editingJourney: _propTypes2.default.instanceOf(_immutable.List),
    loading: _propTypes2.default.bool.isRequired
};

function _getStateFromStores() {
    return {
        loading: _LoadingStore2.default.isLoading()
    };
}

exports.default = (0, _connectToStores2.default)([_LoadingStore2.default], _getStateFromStores)(AddJourneyModalTravelTable);

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(100);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddJourneyModalUsualDays = function AddJourneyModalUsualDays(_ref) {
    var businessDays = _ref.businessDays,
        setBusinessDays = _ref.setBusinessDays;

    var checkDays = function checkDays(id) {
        var updatedDays = businessDays.map(function (day) {
            return day.id === id ? (0, _extends3.default)({}, day, { checked: !day.checked }) : day;
        });

        setBusinessDays(updatedDays);
    };

    return _react2.default.createElement(
        _reactBootstrap.Row,
        { className: 'margin-left--xs margin-right--xs margin-bottom--sm margin-top--sm' },
        _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 12, className: 'journey-modal-usually-title' },
            (0, _I18n2.default)('auto-dr.account.subscribe.journeys.modal.usually')
        ),
        _react2.default.createElement(
            _reactBootstrap.Col,
            { xs: 12, className: 'journey-modal-usually-days margin-top--sm' },
            businessDays.map(function (_ref2) {
                var day = _ref2.day,
                    checked = _ref2.checked,
                    id = _ref2.id;
                return _react2.default.createElement(_Checkbox2.default, {
                    key: day,
                    className: 'journey-modal-days-checkbox',
                    label: day[0].toUpperCase() + day.slice(1),
                    'aria-label': day,
                    onChange: function onChange() {
                        return checkDays(id);
                    },
                    checked: checked
                });
            })
        )
    );
};

AddJourneyModalUsualDays.propTypes = {
    businessDays: _propTypes2.default.array,
    setBusinessDays: _propTypes2.default.func
};

exports.default = AddJourneyModalUsualDays;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormControl = __webpack_require__(178);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _HourSelector = __webpack_require__(936);

var _MinuteSelector = __webpack_require__(937);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIME_FORMAT = 'HH:mm';

function CombinedTimeSelector(_ref) {
    var datetime = _ref.datetime,
        minuteStep = _ref.minuteStep,
        onChange = _ref.onChange,
        disabled = _ref.disabled,
        min = _ref.min,
        max = _ref.max,
        ariaLabel = _ref.ariaLabel;

    var roundedDatetime = datetime.clone().minute((0, _MinuteSelector.roundMinutes)(datetime.minute(), minuteStep));

    var _useState = (0, _react.useState)(roundedDatetime),
        value = _useState[0],
        setValue = _useState[1];

    var uniqueId = (0, _uniqueId3.default)('time__selector_');

    var changeHandler = function changeHandler(callback) {
        return function (e) {
            var timeStr = e.target.value;
            var time = (0, _TrainTime2.default)(timeStr, TIME_FORMAT);
            var updatedDatetime = roundedDatetime.clone().set({
                hour: time.hour(),
                minute: time.minute()
            });
            setValue(updatedDatetime);
            callback(updatedDatetime);
        };
    };

    return _react2.default.createElement(
        'div',
        { className: 'time select-container' },
        _react2.default.createElement(_Icon2.default, { icon: 'dropdown' }),
        _react2.default.createElement(
            'label',
            { htmlFor: uniqueId, className: 'sr-only' },
            ariaLabel ? ariaLabel + ' ' + value.format(TIME_FORMAT) : (0, _I18n2.default)('booking.time.labels.time')
        ),
        _react2.default.createElement(
            _FormControl2.default,
            {
                componentClass: 'select',
                disabled: disabled,
                name: 'time',
                id: uniqueId,
                className: 'time__form-control',
                value: value.format(TIME_FORMAT),
                onChange: changeHandler(onChange)
            },
            _HourSelector.hours.map(function (hour) {
                return (0, _MinuteSelector.minutes)(minuteStep).map(function (minute) {
                    var time = datetime.clone().set({ hour: hour, minute: minute });
                    var timeStr = time.format(TIME_FORMAT);
                    return _react2.default.createElement(
                        'option',
                        {
                            key: timeStr,
                            value: timeStr,
                            disabled: time.isAfter(max) || time.isBefore(min)
                        },
                        timeStr
                    );
                });
            })
        )
    );
}

CombinedTimeSelector.propTypes = {
    datetime: _MomentPropTypes2.default.isMoment,
    minuteStep: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    min: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    ariaLabel: _propTypes2.default.string
};

CombinedTimeSelector.defaultProps = {
    datetime: (0, _TrainTime2.default)(),
    minuteStep: 15,
    onChange: _noop3.default,
    disabled: false,
    min: null,
    max: null
};

exports.default = CombinedTimeSelector;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var urlRoot = '/delay-repay';

var URL = exports.URL = {
    getFavouriteJourneys: urlRoot + '/favourite-journey/customer/{id}/journeys',
    saveFavouriteJourney: urlRoot + '/favourite-journey/customer/{id}',
    deleteFavouriteJourney: urlRoot + '/favourite-journey/customer/{userId}/journeys/{journeyId}',
    editFavouriteJourney: urlRoot + '/favourite-journey/customer/{userId}/journeys/{journeyId}'
};

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _DateTime = __webpack_require__(640);

var _DateTime2 = _interopRequireDefault(_DateTime);

var _Duration = __webpack_require__(1001);

var _Duration2 = _interopRequireDefault(_Duration);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _PassengerAssistStore = __webpack_require__(173);

var _PassengerAssistStore2 = _interopRequireDefault(_PassengerAssistStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _AccessibilityCircleIcon = __webpack_require__(439);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _seatDescription(seat) {
    return (0, _I18n.translate)('booking.seating.coachSeat', {
        coach: seat.getCoach(),
        seat: seat.getSeat()
    });
}

function _attributesList(seat) {
    return { attributes: seat.getAttributeNames().join(', ') };
}

var FareJourneys = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(FareJourneys, _PureRenderComponent);

    function FareJourneys() {
        (0, _classCallCheck3.default)(this, FareJourneys);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    FareJourneys.prototype._renderLeg = function _renderLeg(leg, key) {
        var isAmended = this.props.isAmended;

        var toc = leg.toc;
        var operatorClass = '';
        if (toc && toc.name) {
            operatorClass = 'leg--' + toc.name.replace(/\s+/g, '-').toLowerCase();
        }
        var modeClass = 'row padding-bottom leg--' + leg.mode.toLowerCase();
        var modeIconClass = 'leg__mode--' + leg.mode.replace(/\s+/g, '-').toLowerCase();
        var busReplacement = leg.mode === _AppConstants.TransitModes.REPLACEMENT_BUS ? (0, _I18n.translate)('booking.journey.leg.replacementBus') : null;
        var showSeatsReservation = leg.getSeats().size > 0 && !isAmended;

        var sortedSeats = leg.getSeats().sortBy(function (seat) {
            return seat.coach;
        }).groupBy(function (seat) {
            return seat.coach;
        }).toOrderedSet().flatMap(function (seats) {
            return seats.sortBy(function (seat) {
                return seat.seat;
            });
        });

        return _react2.default.createElement(
            'li',
            { key: key, className: modeClass + ' ' + operatorClass },
            _react2.default.createElement(
                'ol',
                { className: 'leg__stations list-unstyled col-md-12 col-lg-6' },
                _react2.default.createElement(
                    'li',
                    { className: 'leg__station text-weight--normal' },
                    leg.departure && leg.arrival ? _react2.default.createElement(_DateTime2.default, {
                        dateTime: leg.departure,
                        format: 'HH:mm',
                        className: 'pull-left leg__station__time text-secondary text-weight--normal'
                    }) : '',
                    _react2.default.createElement(
                        'div',
                        { className: 'leg__station__name' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-weight--normal' },
                            leg.origin.name
                        )
                    )
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'leg__operator text-weight--normal' },
                    _react2.default.createElement('i', { className: "leg__mode " + modeIconClass }),
                    _react2.default.createElement(
                        'div',
                        { className: 'leg__operator-name' },
                        leg.toc ? leg.toc.name : leg.mode
                    ),
                    busReplacement && _react2.default.createElement(
                        'div',
                        { className: 'leg__replacement-text' },
                        busReplacement
                    )
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'leg__station text-weight--normal' },
                    leg.departure && leg.arrival ? _react2.default.createElement(_DateTime2.default, {
                        dateTime: leg.arrival,
                        format: 'HH:mm',
                        className: 'pull-left leg__station__time text-secondary text-weight--normal'
                    }) : '',
                    _react2.default.createElement(
                        'div',
                        { className: 'leg__station__name' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-weight--normal' },
                            leg.destination.name
                        )
                    )
                )
            ),
            _react2.default.createElement(
                _Col2.default,
                { md: 12, lg: 6 },
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableSeatingPreferences' },
                        showSeatsReservation && _react2.default.createElement(
                            _Col2.default,
                            { md: 12, className: 'seats margin-bottom--md' },
                            _react2.default.createElement(
                                'p',
                                { className: 'text-primary text-weight--normal margin-bottom--sm' },
                                _react2.default.createElement(_Icon2.default, { icon: 'seat' }),
                                (0, _I18n.translate)('order.summary.seats')
                            ),
                            _react2.default.createElement(
                                'table',
                                { className: 'seating-table' },
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    sortedSeats.map(function (seat, index) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: index, className: 'text-sm' },
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'fix-width text-weight--normal' },
                                                _seatDescription(seat)
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'text-light' },
                                                _attributesList(seat).attributes
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _FeatureFlag2.default,
                        { name: 'enableReservations' },
                        leg.bikeSeats && leg.bikeSeats.size > 0 && _react2.default.createElement(
                            _Col2.default,
                            { md: 12, className: 'bike-seats' },
                            _react2.default.createElement(
                                'p',
                                { className: 'text-primary text-weight--normal margin-bottom--sm' },
                                _react2.default.createElement(_Icon2.default, { icon: 'bike' }),
                                (0, _I18n.translate)('order.summary.bikes')
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'list-unstyled leg__bike-reservations' },
                                leg.bikeSeats.map(function (bike) {
                                    return _react2.default.createElement(
                                        'li',
                                        { className: 'text-sm text-weight--normal' },
                                        'Coach ' + bike.coach + ', seat ' + bike.seat
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'span',
                { className: 'leg__change-trains text-sm text-weight--normal text-primary' },
                (0, _I18n.translate)('order.summary.change_trains')
            )
        );
    };

    FareJourneys.prototype._renderOpenJourney = function _renderOpenJourney(directionText, journey, directionIcon) {
        return _react2.default.createElement(
            _Col2.default,
            { md: 12, lg: 12, className: 'margin-bottom' },
            _react2.default.createElement(
                'div',
                { className: 'border-thick--bottom' },
                directionText && _react2.default.createElement(
                    'p',
                    { className: 'direction no-margin text-md text-light text-weight--normal' },
                    _react2.default.createElement(_Icon2.default, { icon: 'inbound', className: directionIcon + ' text-light text-primary' }),
                    (0, _I18n.translate)(directionText) + ' '
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'list-unstyled trip-details border--bottom padding-bottom--sm' },
                    _react2.default.createElement(
                        'li',
                        { className: 'text-sm text-weight--normal' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-light fix-width--md' },
                            (0, _I18n.translate)('order.summary.validFrom')
                        ),
                        _react2.default.createElement(_DateTime2.default, {
                            dateTime: journey.validFrom,
                            format: 'ddd DD MMM YYYY HH:mm'
                        })
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'text-sm text-weight--normal' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-light fix-width--md' },
                            (0, _I18n.translate)('order.summary.validTo')
                        ),
                        _react2.default.createElement(_DateTime2.default, {
                            dateTime: journey.validTo,
                            format: 'ddd DD MMM YYYY HH:mm'
                        })
                    )
                )
            )
        );
    };

    FareJourneys.prototype._renderJourney = function _renderJourney(directionText, journey, directionIcon, direction) {
        var _this2 = this;

        var _props = this.props,
            idx = _props.idx,
            orderTrip = _props.orderTrip,
            passengerAssistRequests = _props.passengerAssistRequests;


        if (!journey.legs.size) {
            return this._renderOpenJourney(directionText, journey, directionIcon);
        }
        var departureTime = journey.getDepartureTime();
        var arrivalTime = journey.getArrivalTime();

        var matchingRequest = null;

        if (passengerAssistRequests) {
            matchingRequest = passengerAssistRequests.find(function (req) {
                return req.orderTripId === orderTrip.id;
            });
        }

        var _ref = matchingRequest || {},
            outwardEnabled = _ref.outwardEnabled,
            returnEnabled = _ref.returnEnabled;

        var isTwoSingles = !!(orderTrip.fares.outwardSingle && orderTrip.fares.returnSingle);

        var hasMatchingPAJourney = false;

        if (isTwoSingles) {
            if (idx === 0) {
                hasMatchingPAJourney = outwardEnabled;
            } else {
                hasMatchingPAJourney = returnEnabled;
            }
        } else {
            if (direction === 'Return') {
                hasMatchingPAJourney = returnEnabled;
            } else {
                hasMatchingPAJourney = outwardEnabled;
            }
        }

        return _react2.default.createElement(
            _Col2.default,
            { md: 12, lg: 12, className: 'margin-bottom' },
            _react2.default.createElement(
                'div',
                { className: 'border-thick--bottom' },
                hasMatchingPAJourney && _react2.default.createElement(_AccessibilityCircleIcon.AccessibilityCircleIcon, null),
                _react2.default.createElement(
                    'p',
                    { className: 'direction no-margin text-md text-light text-weight--normal' },
                    _react2.default.createElement(_Icon2.default, { icon: 'inbound', className: directionIcon + ' text-light text-primary' }),
                    (0, _I18n.translate)(directionText) + ' ',
                    departureTime && _react2.default.createElement(_DateTime2.default, {
                        className: 'text-primary',
                        dateTime: departureTime,
                        format: 'HH:mm ddd DD MMM YYYY'
                    })
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'list-unstyled trip-details border--bottom padding-bottom--sm ' },
                    _react2.default.createElement(
                        'li',
                        { className: 'text-sm text-weight--normal' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-light fix-width--sm' },
                            (0, _I18n.translate)('order.summary.dep')
                        ),
                        departureTime && _react2.default.createElement(_DateTime2.default, {
                            dateTime: departureTime,
                            format: 'HH:mm'
                        }),
                        '\xA0',
                        journey.getOrigin().name
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'text-sm text-weight--normal' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-light fix-width--sm' },
                            (0, _I18n.translate)('order.summary.arr')
                        ),
                        arrivalTime && _react2.default.createElement(_DateTime2.default, {
                            dateTime: arrivalTime,
                            format: 'HH:mm'
                        }),
                        '\xA0',
                        journey.getDestination().name
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'text-sm text-weight--normal no-margin' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-light fix-width--sm' },
                            (0, _I18n.translate)('order.summary.duration')
                        ),
                        departureTime && arrivalTime && _react2.default.createElement(_Duration2.default, {
                            className: 'text-sm',
                            startTime: departureTime,
                            endTime: arrivalTime
                        })
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'text-sm text-weight--normal no-margin' },
                        _react2.default.createElement(
                            'span',
                            { className: 'changes' },
                            _react2.default.createElement(
                                'span',
                                { className: 'text-light fix-width--sm' },
                                ' ',
                                (0, _I18n.translate)('order.summary.duration.changes', { changes: journey.getChanges() }) + ' '
                            ),
                            journey.getChanges() > 0 ? journey.getChanges() : null
                        )
                    )
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'list-unstyled margin-top clearfix leg__list' },
                    journey.legs.map(function (leg, key) {
                        return _this2._renderLeg(leg, key);
                    })
                )
            )
        );
    };

    FareJourneys.prototype.render = function render() {
        var orderFare = this.props.orderFare;

        var outwardJourney = orderFare.outwardJourney;
        var returnJourney = orderFare.returnJourney;
        var outText = !orderFare.isDaySave() && 'order.summary.out';

        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('fare-info', { 'margin-top--sm': orderFare.isSmartcard() }) },
            _react2.default.createElement(
                _Row2.default,
                null,
                this._renderJourney(outText, outwardJourney, 'otrl-rotate-180', 'Outward'),
                returnJourney ? this._renderJourney('order.summary.return', returnJourney, null, 'Return') : null
            )
        );
    };

    return FareJourneys;
}(_PureRenderComponent3.default), _class.propTypes = {
    orderFare: _propTypes2.default.instanceOf(_Fare2.default).isRequired,
    isAmended: _propTypes2.default.bool
}, _class.defaultProps = {
    isAmended: false
}, _temp);


var _getPropsFromStores = function _getPropsFromStores() {
    return {
        passengerAssistRequests: _PassengerAssistStore2.default.get('pendingTravelAssistRequests')
    };
};

exports.default = (0, _connectToStores2.default)([_PassengerAssistStore2.default], _getPropsFromStores)(FareJourneys);

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _I18n = __webpack_require__(9);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _FareStations = __webpack_require__(282);

var _FareStations2 = _interopRequireDefault(_FareStations);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _AccessibilityCircleIcon = __webpack_require__(439);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FareSummary = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FareSummary, _React$PureComponent);

    function FareSummary() {
        (0, _classCallCheck3.default)(this, FareSummary);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    FareSummary.prototype.render = function render() {
        var _props = this.props,
            hasMatchingPAJourney = _props.hasMatchingPAJourney,
            orderFare = _props.orderFare;


        return _react2.default.createElement(
            'div',
            { className: 'fare-summary padding-bottom--sm' },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, md: 6, lg: 6 },
                    hasMatchingPAJourney && _react2.default.createElement(_AccessibilityCircleIcon.AccessibilityCircleIcon, null),
                    _react2.default.createElement(_FareStations2.default, {
                        origin: orderFare.origin,
                        destination: orderFare.destination,
                        isReturn: orderFare.isReturn() })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, md: 6, lg: 6, className: 'text-weight--normal ticket-type' },
                    orderFare.getName(),
                    '\xA0',
                    orderFare.isGroupSave() && (0, _I18n.translate)('order.summary.groupSave')
                )
            ),
            orderFare.hasCountedPlaceWarning() && _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, className: 'fare-summary__warning text-sm' },
                    _react2.default.createElement(_Icon2.default, { inline: true, icon: 'warning', 'aria-hidden': 'true' }),
                    '\xA0',
                    (0, _I18n.translate)('journey.warnings.hasCountedPlace')
                )
            ),
            orderFare.hasRefundedTickets() && !this.props.isAmended && _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { lg: 6, md: 6, xs: 12, className: 'refunded pull-right' },
                    _react2.default.createElement(
                        'span',
                        { className: 'alert-success text-light pull-right' },
                        (0, _I18n.translate)('account.orders.refund.ticket.refunded')
                    )
                )
            )
        );
    };

    return FareSummary;
}(_react2.default.PureComponent), _class.propTypes = {
    orderFare: _propTypes2.default.instanceOf(_Fare2.default).isRequired,
    isAmended: _propTypes2.default.bool
}, _class.defaultProps = {
    isAmended: false
}, _temp);
exports.default = FareSummary;

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _Ticket = __webpack_require__(353);

var _Ticket2 = _interopRequireDefault(_Ticket);

var _Fare3 = __webpack_require__(76);

var _Fare4 = _interopRequireDefault(_Fare3);

var _Ticket3 = __webpack_require__(239);

var _Ticket4 = _interopRequireDefault(_Ticket3);

var _Currency = __webpack_require__(169);

var _NRETicketLink = __webpack_require__(2054);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NRETicketLink(_ref) {
    var fare = _ref.fare,
        ticket = _ref.ticket;

    if (ticket.railcard && _AppConstants.NREIncompatibleRailcards.includes(ticket.railcard.code) || fare.isSeason() || fare.isRoversRangers() || fare.isDaySave()) {
        return null;
    }

    var quantity = ticket.adults || ticket.children;
    var price = (0, _Currency.toPounds)(ticket.price / quantity).toFixed(2);

    var passenger = (0, _I18n2.default)('global.adult');
    if (ticket.children > 0) {
        passenger = (0, _I18n2.default)('global.child');
    }

    var linkParams = (0, _assign2.default)({ price: price, passenger: passenger }, fare.getNRELinkParams());

    var linkQuery = (0, _NRETicketLink.queryBuilder)(fare, ticket);

    return _react2.default.createElement(
        'div',
        { className: 'nre-link' },
        _react2.default.createElement(_ExternalLink2.default, { message: (0, _I18n2.default)('booking.fares.nre-link.text'),
            href: (0, _NRETicketLink.getUrl)(linkParams, linkQuery), className: 'text-sm' })
    );
}

NRETicketLink.propTypes = {
    fare: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Fare2.default), _propTypes2.default.instanceOf(_Fare4.default)]),
    ticket: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Ticket2.default), _propTypes2.default.instanceOf(_Ticket4.default)])
};

exports.default = NRETicketLink;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _set2 = __webpack_require__(394);

var _set3 = _interopRequireDefault(_set2);

exports.queryBuilder = queryBuilder;
exports.getUrl = getUrl;

var _routeParser = __webpack_require__(813);

var _routeParser2 = _interopRequireDefault(_routeParser);

var _urijs = __webpack_require__(283);

var _urijs2 = _interopRequireDefault(_urijs);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// business logic:
// - we apply the disabled child's railcard ('DIC') to both the child and their accompanying adult
// - the disabled person's railcard ('DIS') rate is then applied to the adult's ticket,
//   rather than a discount on the child ticket
function queryBuilder(fare, ticket) {
    var linkQuery = fare.getNRELinkQuery();
    if (ticket.railcard && ticket.railcard.code !== 'DIC') {
        (0, _set3.default)(linkQuery, 'railCard', ticket.railcard.code);
    }
    if (ticket.railcard && ticket.railcard.code === 'DIC' && ticket.adults > 0) {
        (0, _set3.default)(linkQuery, 'railCard', 'DIS');
    }
    return linkQuery;
}

function getUrl(params, query) {
    var route = new _routeParser2.default('/:origin/:destination/:outwardDate/:price/:fareClass/:passenger');
    var path = route.reverse(params);
    var queryString = query ? _urijs2.default.buildQuery(query, false, false) : '';
    return '' + _config2.default.get('myTicketLinkNRE') + path + '?' + queryString;
}

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _I18n = __webpack_require__(9);

var _PassengerInfo = __webpack_require__(464);

var _PassengerInfo2 = _interopRequireDefault(_PassengerInfo);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _useSmartCarnetTicketDetails = __webpack_require__(1166);

var _useSmartCarnetTicketDetails2 = _interopRequireDefault(_useSmartCarnetTicketDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TicketCalculationsSummaryHeader = function TicketCalculationsSummaryHeader(_ref) {
    var showRefundDetail = _ref.showRefundDetail,
        storedRefundCalculation = _ref.storedRefundCalculation,
        ticket = _ref.ticket,
        onClick = _ref.onClick,
        hasSmartCarnetTrip = _ref.hasSmartCarnetTrip;

    var _useSmartCarnetTicket = (0, _useSmartCarnetTicketDetails2.default)(ticket.id, hasSmartCarnetTrip),
        smartCarnetTicketDetails = _useSmartCarnetTicket.smartCarnetTicketDetails;

    var ticketAdults = 1; // Override the ticket.adults = 5 as each ticket's pass is counted as 1 adult
    var ticketChildren = ticket.children;

    var smartCarnetTicketID = (0, _get3.default)(smartCarnetTicketDetails, 'ticketId');
    var remainingPassCount = (0, _get3.default)(smartCarnetTicketDetails, 'remainingPassCount');
    var initialPassCount = (0, _get3.default)(smartCarnetTicketDetails, 'initialPassCount');

    return _react2.default.createElement(
        _OnEnterTrigger2.default,
        { className: 'refund-ticket__header', onClick: onClick },
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 6, className: 'refund-ticket__header__title' },
                (0, _I18n.translate)('booking.passengers.summary.text', {
                    adults: ticketAdults,
                    children: ticketChildren
                }),
                smartCarnetTicketID && _react2.default.createElement(
                    'span',
                    null,
                    '- ',
                    (0, _I18n.translate)('smartCarnet.refund.numberOfPasses'),
                    ' ',
                    remainingPassCount,
                    ' / ',
                    initialPassCount
                ),
                storedRefundCalculation && _react2.default.createElement(
                    'div',
                    { className: 'refund-ticket__header__date' },
                    (0, _I18n.translate)('account.orders.refund.itso.refundDate', { date: storedRefundCalculation.getRefundDate() })
                ),
                _react2.default.createElement(_PassengerInfo2.default, { className: 'refund-ticket__header__passenger', ticket: ticket })
            ),
            _react2.default.createElement(
                _Col2.default,
                { xs: 6, className: 'refund-ticket__header__price text-weight--bold' },
                _react2.default.createElement(_Price2.default, { price: ticket.price })
            ),
            _react2.default.createElement(
                'div',
                { className: 'refund-ticket__header__arrow' },
                _react2.default.createElement(_Icon2.default, { icon: 'dropdown', className: showRefundDetail ? "otrl-rotate-180" : '' })
            )
        )
    );
};

TicketCalculationsSummaryHeader.propTypes = {
    showRefundDetail: _propTypes2.default.any,
    storedRefundCalculation: _propTypes2.default.any,
    ticket: _propTypes2.default.any,
    onClick: _propTypes2.default.any,
    hasSmartCarnetTrip: _propTypes2.default.bool
};

exports.default = TicketCalculationsSummaryHeader;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _IblocksAPIClient = __webpack_require__(834);

var _IblocksAPIClient2 = _interopRequireDefault(_IblocksAPIClient);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _TicketSmartCarnet = __webpack_require__(1167);

var _TicketSmartCarnet2 = _interopRequireDefault(_TicketSmartCarnet);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH_URL = '/jp/carnet-in-the-cloud';

var getSingleTicketUrl = function getSingleTicketUrl(customerId, ticketId) {
    return 'smartcard/' + customerId + '/keygo/carnet/tickets/' + ticketId;
};

var getTicketsUrl = function getTicketsUrl(customerId, ticketStatus) {
    var params = '?fulfilmentType=CLOUD';

    switch (ticketStatus) {
        case _AppConstants.SmartCarnetTicketStatus.ACTIVE:
            {
                params += '&sortAsc=true';
                break;
            }

        case _AppConstants.SmartCarnetTicketStatus.EXPIRED:
            {
                var yesterday = (0, _TrainTime2.default)().add(-1, 'day').format('YYYY-MM-DD');
                params += '&validFrom=2020-01-01&validUntil=' + yesterday + '&expired=true';
                break;
            }

        case _AppConstants.SmartCarnetTicketStatus.ALL:
            {
                var nextYear = (0, _TrainTime2.default)().add(1, 'year').format('YYYY-MM-DD');
                params += '&validFrom=2020-01-01&validUntil=' + nextYear;
                break;
            }
    }

    return '/customers/' + customerId + '/smartcard/keygo/carnet/tickets/' + params;
};

var getValidatePassesUrl = function getValidatePassesUrl(customerId, newTickets, originNlc, destinationNlc) {
    return '/smartcard/' + customerId + '/keygo/carnet/tickets/validate?newTickets=' + newTickets + '&originNlc=' + originNlc + '&destinationNlc=' + destinationNlc;
};

var SmartCarnetService = {
    search: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
            var _ref$products = _ref.products,
                products = _ref$products === undefined ? 1 : _ref$products,
                search = _ref.search;
            var url, response, requestBody, faresResult, fares;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = SEARCH_URL;
                            response = void 0;
                            requestBody = {
                                origin: search.origin.nlc,
                                destination: search.destination.nlc,
                                outward: search.startingDate.format('YYYY-MM-DD'),
                                products: parseInt(products),
                                searchPreferences: {
                                    ticketTypes: [_AppConstants.SmartCarnetTicketCodes.OFF_PEAK, _AppConstants.SmartCarnetTicketCodes.PEAK]
                                }
                            };
                            _context.prev = 3;
                            _context.next = 6;
                            return _APIClient2.default.post(url, requestBody);

                        case 6:
                            response = _context.sent;
                            _context.next = 18;
                            break;

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](3);

                            if (!(0, _result3.default)(_context.t0, 'body.result', []).length) {
                                _context.next = 17;
                                break;
                            }

                            console.error('Supressing error', _context.t0);
                            response = _context.t0.body;
                            throw _context.t0;

                        case 17:
                            throw _context.t0;

                        case 18:
                            faresResult = (0, _result3.default)(response, 'result', []);
                            fares = (0, _LinkMapper.resolveAll)(faresResult).as(_Fare2.default);
                            return _context.abrupt('return', fares.sortBy(function (fare) {
                                return fare.getPrice();
                            }));

                        case 21:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[3, 9]]);
        }));

        function search(_x) {
            return _ref2.apply(this, arguments);
        }

        return search;
    }(),
    searchReturn: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref3) {
            var _ref3$products = _ref3.products,
                products = _ref3$products === undefined ? 1 : _ref3$products,
                search = _ref3.search;
            var destination, origin, returnSearch;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            // Swap stations
                            destination = search.origin;
                            origin = search.destination;
                            returnSearch = search.set('destination', destination).set('origin', origin);
                            _context2.next = 5;
                            return SmartCarnetService.search({ search: returnSearch, products: products });

                        case 5:
                            return _context2.abrupt('return', _context2.sent);

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function searchReturn(_x2) {
            return _ref4.apply(this, arguments);
        }

        return searchReturn;
    }(),
    getSingleTicket: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(ticketId) {
            var user, url, response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();

                            if (!(!user || !user.id)) {
                                _context3.next = 3;
                                break;
                            }

                            return _context3.abrupt('return', null);

                        case 3:
                            url = user && user.id ? getSingleTicketUrl(user.id, ticketId) : null;

                            if (url) {
                                _context3.next = 6;
                                break;
                            }

                            return _context3.abrupt('return', null);

                        case 6:
                            response = void 0;
                            _context3.prev = 7;
                            _context3.next = 10;
                            return _IblocksAPIClient2.default.get(url);

                        case 10:
                            response = _context3.sent;
                            return _context3.abrupt('return', (0, _LinkMapper.resolve)(response).as(_TicketSmartCarnet2.default));

                        case 14:
                            _context3.prev = 14;
                            _context3.t0 = _context3['catch'](7);

                            if (!(0, _result3.default)(_context3.t0, 'body.result', []).length) {
                                _context3.next = 21;
                                break;
                            }

                            console.error('Supressing error', _context3.t0);
                            response = _context3.t0.body;
                            _context3.next = 22;
                            break;

                        case 21:
                            throw _context3.t0;

                        case 22:
                            return _context3.abrupt('return', null);

                        case 23:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[7, 14]]);
        }));

        function getSingleTicket(_x3) {
            return _ref5.apply(this, arguments);
        }

        return getSingleTicket;
    }(),
    getTickets: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref6) {
            var ticketStatus = _ref6.ticketStatus,
                user = _ref6.user;
            var response, tickets;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!(!user || !user.id)) {
                                _context4.next = 2;
                                break;
                            }

                            return _context4.abrupt('return', null);

                        case 2:
                            response = void 0;
                            _context4.prev = 3;
                            _context4.next = 6;
                            return _IblocksAPIClient2.default.get(getTicketsUrl(user.id, ticketStatus));

                        case 6:
                            response = _context4.sent;
                            tickets = (0, _LinkMapper.resolveAll)(response.result).as(_TicketSmartCarnet2.default);
                            return _context4.abrupt('return', tickets);

                        case 11:
                            _context4.prev = 11;
                            _context4.t0 = _context4['catch'](3);

                            if (!(0, _result3.default)(_context4.t0, 'body.result', []).length) {
                                _context4.next = 18;
                                break;
                            }

                            console.error('Supressing error', _context4.t0);
                            response = _context4.t0.body;
                            _context4.next = 19;
                            break;

                        case 18:
                            throw _context4.t0;

                        case 19:
                            return _context4.abrupt('return', null);

                        case 20:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[3, 11]]);
        }));

        function getTickets(_x4) {
            return _ref7.apply(this, arguments);
        }

        return getTickets;
    }(),
    validatePasses: function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref8) {
            var destination = _ref8.destination,
                origin = _ref8.origin,
                newTickets = _ref8.newTickets,
                user = _ref8.user;
            var url, response;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            url = user && user.id ? getValidatePassesUrl(user.id, newTickets, origin.nlc, destination.nlc) : -1;
                            response = void 0;
                            _context5.prev = 2;
                            _context5.next = 5;
                            return _IblocksAPIClient2.default.get(url);

                        case 5:
                            response = _context5.sent;
                            return _context5.abrupt('return', response);

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](2);

                            if (!(0, _result3.default)(_context5.t0, 'body.result', []).length) {
                                _context5.next = 16;
                                break;
                            }

                            console.error('Supressing error', _context5.t0);
                            response = _context5.t0.body;
                            _context5.next = 17;
                            break;

                        case 16:
                            throw _context5.t0;

                        case 17:
                            return _context5.abrupt('return', null);

                        case 18:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[2, 9]]);
        }));

        function validatePasses(_x5) {
            return _ref9.apply(this, arguments);
        }

        return validatePasses;
    }()
};

exports.default = SmartCarnetService;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.calculateCarbonEmissions = exports.calculateDistance = undefined;

var _AppConstants = __webpack_require__(6);

// Calculates the distance between two points (with latitude and longitude in degrees) on the Earth's surface
var calculateDistance = exports.calculateDistance = function calculateDistance(lat1, lon1, lat2, lon2) {
    var R = 3981.875; // Radius of the Earth in miles

    // Convert latitude and longitude from degrees to radians
    var toRadians = function toRadians(degrees) {
        return degrees * Math.PI / 180;
    };
    var phi1 = toRadians(lat1);
    var phi2 = toRadians(lat2);

    // Calculate the difference in latitude and longitude in radians
    var deltaPhi = toRadians(lat2 - lat1);
    var deltaLambda = toRadians(lon2 - lon1);

    // Calculate the square of half the chord length between the points using the Haversine formula
    var a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);

    // Calculate the angular distance in radians using the Haversine formula
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // Return the distance by multiplying the angular distance by the Earth's radius
    return R * c;
};

var getOriginAndDestinationFromUnknownFare = function getOriginAndDestinationFromUnknownFare(fare, origin, destination) {
    if (!origin || !destination) {
        if (fare.outwardJourney) {
            return {
                origin: fare.outwardJourney.getOrigin(),
                destination: fare.outwardJourney.getDestination()
            };
        } else {
            return {
                origin: fare.origin,
                destination: fare.destination
            };
        }
    }
    return {
        origin: origin,
        destination: destination
    };
};

var calculateCarbonEmissions = exports.calculateCarbonEmissions = function calculateCarbonEmissions(_ref) {
    var fare = _ref.fare,
        originStation = _ref.originStation,
        destinationStation = _ref.destinationStation;

    var _getOriginAndDestinat = getOriginAndDestinationFromUnknownFare(fare, originStation, destinationStation),
        origin = _getOriginAndDestinat.origin,
        destination = _getOriginAndDestinat.destination;

    var _origin$getLatLng = origin.getLatLng(),
        lat1 = _origin$getLatLng.lat,
        lng1 = _origin$getLatLng.lng;

    var _destination$getLatLn = destination.getLatLng(),
        lat2 = _destination$getLatLn.lat,
        lng2 = _destination$getLatLn.lng;

    var hasRequiredData = Boolean(lat1) && Boolean(lng1) && Boolean(lat2) && Boolean(lng2);

    if (!hasRequiredData) {
        return { requiredDataNotProvided: true };
    }

    var passengersAmount = fare.adults() + fare.children();
    var ticketsAmount = fare.ticketType.isReturn ? 2 : 1;

    var dist = calculateDistance(lat1, lng1, lat2, lng2);

    // calc journey CO2 emissions
    var carEmissions = dist * passengersAmount * ticketsAmount * _AppConstants.CARBON_FOOTPRINT_DATA.CAR_EMISSIONS_PER_MILE;
    var trainEmissions = dist * passengersAmount * ticketsAmount * _AppConstants.CARBON_FOOTPRINT_DATA.TRAIN_EMISSIONS_PER_MILE;

    // calc difference in CO2 emissions
    var emissionsDifference = carEmissions - trainEmissions;

    // make sure the train percentage is between 15 and 30, so the car percentage is between around 45 and 90
    var trainPercentage = Math.min(Math.max(trainEmissions * 1.5, 15), 30);
    var carPercentage = trainPercentage * _AppConstants.CARBON_FOOTPRINT_DATA.CAR_EMISSIONS_PER_MILE / _AppConstants.CARBON_FOOTPRINT_DATA.TRAIN_EMISSIONS_PER_MILE;

    return {
        trainEmissions: trainEmissions.toFixed(2),
        carEmissions: carEmissions.toFixed(2),
        trainPercentage: Math.round(trainPercentage),
        carPercentage: Math.round(carPercentage),
        distance: dist.toFixed(2),
        origin: origin.getName(),
        destination: destination.getName(),
        savedCO2e: emissionsDifference.toFixed(2),
        bulb: (emissionsDifference / _AppConstants.CARBON_FOOTPRINT_DATA.BULB_PER_KG).toFixed(2),
        fullyChargingSmartphones: (emissionsDifference / _AppConstants.CARBON_FOOTPRINT_DATA.PHONE_PER_KG).toFixed(2),
        kettle: (emissionsDifference / _AppConstants.CARBON_FOOTPRINT_DATA.KETTLE_PER_KG).toFixed(2),
        microwave: (emissionsDifference / _AppConstants.CARBON_FOOTPRINT_DATA.MICROWAVE_PER_KG).toFixed(2),
        tv: (emissionsDifference / _AppConstants.CARBON_FOOTPRINT_DATA.TV_PER_KG).toFixed(2),
        washingMachine: (emissionsDifference / _AppConstants.CARBON_FOOTPRINT_DATA.WASHING_MACHINE_PER_KG).toFixed(2)
    };
};

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _BaseModal = __webpack_require__(29);

var _GreenPlanetIcon = __webpack_require__(942);

var _GreenPlanetIcon2 = _interopRequireDefault(_GreenPlanetIcon);

var _CarbonFootprintModalInfoSection = __webpack_require__(2059);

var _CarbonFootprintModalInfoSection2 = _interopRequireDefault(_CarbonFootprintModalInfoSection);

var _CarbonFootprintModalAlternativeInfoSection = __webpack_require__(2062);

var _CarbonFootprintModalAlternativeInfoSection2 = _interopRequireDefault(_CarbonFootprintModalAlternativeInfoSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarbonFootprintModal = function CarbonFootprintModal(_ref) {
    var toggleModal = _ref.toggleModal,
        carbonCalculationData = _ref.carbonCalculationData,
        restProps = (0, _objectWithoutProperties3.default)(_ref, ['toggleModal', 'carbonCalculationData']);
    var savedCO2e = carbonCalculationData.savedCO2e;


    var modalProps = (0, _extends3.default)({
        onClose: toggleModal(false),
        hideContinue: true,
        titleText: 'carbonFootprint.modal.title',
        className: 'carbon-footprint-modal',
        headerClass: "text-left",
        onOpen: toggleModal(true)
    }, restProps);

    var EPACalculationUrl = _config2.default.get('EPACalculationUrl') || '';
    var carbonFootprintCalculatorUrl = _config2.default.get('carbonFootprintCalculatorUrl') || '';

    return _react2.default.createElement(
        _BaseModal.BaseModal,
        modalProps,
        _react2.default.createElement(
            'div',
            { className: 'carbon-footprint-modal__saved-msg--container' },
            _react2.default.createElement(
                'div',
                { className: 'carbon-footprint-modal__saved-msg--icon' },
                _react2.default.createElement(_GreenPlanetIcon2.default, null)
            ),
            _react2.default.createElement(
                'p',
                { className: 'no-margin' },
                _react2.default.createElement(
                    'strong',
                    null,
                    (0, _I18n.translate)('carbonFootprint.saved', { savedCO2e: savedCO2e })
                )
            )
        ),
        _react2.default.createElement(
            'p',
            { className: 'carbon-footprint-modal__text--black' },
            (0, _I18n.translate)('carbonFootprint.modal.paragraph1')
        ),
        _react2.default.createElement(
            'p',
            { className: 'carbon-footprint-modal__text--black' },
            (0, _I18n.translate)('carbonFootprint.modal.paragraph2')
        ),
        _react2.default.createElement(_CarbonFootprintModalInfoSection2.default, { carbonCalculationData: carbonCalculationData }),
        _react2.default.createElement(_CarbonFootprintModalAlternativeInfoSection2.default, { carbonCalculationData: carbonCalculationData }),
        _react2.default.createElement(
            'p',
            { className: 'carbon-footprint-modal__text--black no-margin' },
            _react2.default.createElement(
                'span',
                null,
                (0, _I18n.translate)('carbonFootprint.modal.paragraph3')
            ),
            _react2.default.createElement(
                'a',
                { href: EPACalculationUrl, target: '_blank', className: 'carbon-footprint-modal__link' },
                (0, _I18n.translate)('carbonFootprint.modal.paragraph3.link')
            ),
            _react2.default.createElement(
                'span',
                null,
                (0, _I18n.translate)('carbonFootprint.modal.paragraph4')
            ),
            _react2.default.createElement(
                'a',
                { href: carbonFootprintCalculatorUrl, target: '_blank', className: 'carbon-footprint-modal__link' },
                (0, _I18n.translate)('carbonFootprint.modal.paragraph4.link')
            ),
            _react2.default.createElement(
                'span',
                null,
                (0, _I18n.translate)('carbonFootprint.modal.paragraph5')
            )
        )
    );
};

CarbonFootprintModal.propTypes = {
    toggleModal: _propTypes2.default.func.isRequired,
    carbonCalculationData: _propTypes2.default.object.isRequired,
    show: _propTypes2.default.bool
};

CarbonFootprintModal.defaultProps = {
    toggleModal: function toggleModal() {
        return function () {};
    },
    carbonCalculationData: {},
    show: false
};

exports.default = CarbonFootprintModal;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _TrainIcon = __webpack_require__(2060);

var _TrainIcon2 = _interopRequireDefault(_TrainIcon);

var _CarIcon = __webpack_require__(2061);

var _CarIcon2 = _interopRequireDefault(_CarIcon);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ProgressBar = __webpack_require__(642);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarbonFootprintModalInfoSection = function CarbonFootprintModalInfoSection(_ref) {
    var carbonCalculationData = _ref.carbonCalculationData;

    var carbonFootprint = _config2.default.get('carbonFootprint') || '';
    var carEmissions = carbonCalculationData.carEmissions,
        carPercentage = carbonCalculationData.carPercentage,
        trainEmissions = carbonCalculationData.trainEmissions,
        trainPercentage = carbonCalculationData.trainPercentage,
        distance = carbonCalculationData.distance,
        origin = carbonCalculationData.origin,
        destination = carbonCalculationData.destination;


    var renderTransportCards = function renderTransportCards() {
        var transportEmissionsCardsConfig = [{
            title: (0, _I18n.translate)('carbonFootprint.modal.info.card-train.title'),
            iconComponent: _react2.default.createElement(_TrainIcon2.default, null),
            emission: trainEmissions,
            color: 'green',
            percentage: trainPercentage
        }, {
            title: (0, _I18n.translate)('carbonFootprint.modal.info.card-car.title'),
            iconComponent: _react2.default.createElement(_CarIcon2.default, null),
            emission: carEmissions,
            color: 'red',
            percentage: carPercentage
        }];

        return transportEmissionsCardsConfig.map(function (_ref2) {
            var title = _ref2.title,
                iconComponent = _ref2.iconComponent,
                emission = _ref2.emission,
                color = _ref2.color,
                percentage = _ref2.percentage;
            return _react2.default.createElement(
                'li',
                { className: 'carbon-footprint-modal__info--card carbon-footprint-modal__background--' + color, key: title },
                _react2.default.createElement(
                    'div',
                    { className: 'carbon-footprint-modal__info--card-title-container' },
                    _react2.default.createElement(
                        'h5',
                        { className: 'carbon-footprint-modal__title' },
                        title
                    ),
                    iconComponent
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'carbon-footprint-modal__info--card-subtitle' },
                    (0, _I18n.translate)('carbonFootprint.modal.info.card.subtitle')
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'carbon-footprint-modal__info--card-text-' + color },
                    (0, _I18n.translate)('carbonFootprint.modal.info.card.emission', { emission: emission })
                ),
                _react2.default.createElement(_ProgressBar2.default, { completed: percentage, containerStyle: { backgroundColor: 'white', boxShadow: 'none', marginTop: 10, borderColor: 'white', borderWidth: 1, height: 8 }, style: { backgroundColor: color, height: 6, top: 1, left: 1 }, total: 100 })
            );
        });
    };

    return _react2.default.createElement(
        'div',
        { className: 'carbon-footprint-modal__info--container' },
        _react2.default.createElement(
            'h4',
            { className: 'carbon-footprint-modal__title' },
            (0, _I18n.translate)('carbonFootprint.modal.info.title', { distance: distance, origin: origin, destination: destination })
        ),
        _react2.default.createElement(
            'ul',
            { className: 'carbon-footprint-modal__info--cards-container' },
            renderTransportCards()
        ),
        _react2.default.createElement(
            'p',
            { className: 'carbon-footprint-modal__text' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'carbonFootprint.modal.info.paragraph1' })
        ),
        _react2.default.createElement(
            'p',
            { className: 'carbon-footprint-modal__text' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'carbonFootprint.modal.info.paragraph2' })
        ),
        _react2.default.createElement(
            'p',
            { className: 'carbon-footprint-modal__text no-margin' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'carbonFootprint.modal.info.paragraph3' }),
            _react2.default.createElement(
                'a',
                { href: carbonFootprint, target: '_blank', className: 'carbon-footprint-modal__link word-break' },
                carbonFootprint
            )
        )
    );
};

CarbonFootprintModalInfoSection.propTypes = {
    carbonCalculationData: _propTypes2.default.object.isRequired
};

exports.default = CarbonFootprintModalInfoSection;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrainIcon = function TrainIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#32AE57" }),
        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 9.11764C6 6.84353 7.91878 5 10.2857 5H13.7143C16.0812 5 18 6.84353 18 9.11764V15.7059C18 16.1607 17.6162 16.5294 17.1429 16.5294H15.9152L17.4722 18.3246C17.6237 18.4993 17.5992 18.7589 17.4173 18.9045C17.2355 19.0501 16.9653 19.0265 16.8137 18.8518L16.228 18.1764H7.77228L7.1865 18.8518C7.03497 19.0265 6.76473 19.0501 6.58289 18.9045C6.40106 18.7589 6.37649 18.4993 6.52802 18.3246L8.08504 16.5294H6.85714C6.38376 16.5294 6 16.1607 6 15.7059V9.11764ZM9.20079 16.5294L8.48656 17.3529H15.5137L14.7994 16.5294H9.20079ZM7.71429 9.11764C7.71429 7.75318 8.86555 6.64706 10.2857 6.64706H13.7143C15.1344 6.64706 16.2857 7.75318 16.2857 9.11764V11.1765C16.2857 11.6313 15.902 12 15.4286 12H8.57143C8.09804 12 7.71429 11.6313 7.71429 11.1765V9.11764ZM8.57143 14.8823C9.04482 14.8823 9.42857 14.5136 9.42857 14.0588C9.42857 13.604 9.04482 13.2353 8.57143 13.2353C8.09804 13.2353 7.71429 13.604 7.71429 14.0588C7.71429 14.5136 8.09804 14.8823 8.57143 14.8823ZM16.2857 14.0588C16.2857 14.5136 15.902 14.8823 15.4286 14.8823C14.9552 14.8823 14.5714 14.5136 14.5714 14.0588C14.5714 13.604 14.9552 13.2353 15.4286 13.2353C15.902 13.2353 16.2857 13.604 16.2857 14.0588Z", fill: "white" })
    );
};

exports.default = TrainIcon;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarIcon = function CarIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#E8001D" }),
        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.80207 7H12.0541H12.3209H16.5729L16.6512 7.0751C17.1981 7.59999 17.5998 8.32944 17.8948 9.14639C18.1907 9.96554 18.385 10.8888 18.5073 11.8172C18.7517 13.6734 18.7112 15.5769 18.5985 16.7668L18.5764 17H16.4623V15.4615H12.3209H12.0541H7.91273V17H5.79861L5.77652 16.7668C5.66381 15.5769 5.62327 13.6734 5.8677 11.8172C5.98995 10.8888 6.18434 9.96554 6.48019 9.14639C6.77524 8.32944 7.17691 7.59999 7.72382 7.0751L7.80207 7ZM12.0541 10.7179H12.3209H16.9862C16.9465 10.2112 16.7973 9.66178 16.6111 9.15594C16.4235 8.64643 16.2037 8.19528 16.0375 7.89744H12.3209H12.0541H8.33752C8.17132 8.19528 7.95148 8.64643 7.76389 9.15594C7.57765 9.66178 7.42846 10.2112 7.38879 10.7179H12.0541ZM9.68749 13C9.68749 13.5523 9.23978 14 8.68749 14C8.13521 14 7.68749 13.5523 7.68749 13C7.68749 12.4477 8.13521 12 8.68749 12C9.23978 12 9.68749 12.4477 9.68749 13ZM15 13C15 13.5523 15.4477 14 16 14C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12C15.4477 12 15 12.4477 15 13Z", fill: "white" })
    );
};

exports.default = CarIcon;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _sampleSize2 = __webpack_require__(2063);

var _sampleSize3 = _interopRequireDefault(_sampleSize2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _BatteryIcon = __webpack_require__(2067);

var _BatteryIcon2 = _interopRequireDefault(_BatteryIcon);

var _BulbIcon = __webpack_require__(2068);

var _BulbIcon2 = _interopRequireDefault(_BulbIcon);

var _KettleIcon = __webpack_require__(2069);

var _KettleIcon2 = _interopRequireDefault(_KettleIcon);

var _MicrowaveIcon = __webpack_require__(2070);

var _MicrowaveIcon2 = _interopRequireDefault(_MicrowaveIcon);

var _TVIcon = __webpack_require__(2071);

var _TVIcon2 = _interopRequireDefault(_TVIcon);

var _WashingMachineIcon = __webpack_require__(2072);

var _WashingMachineIcon2 = _interopRequireDefault(_WashingMachineIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatValue = function formatValue(value) {
    return parseFloat(value) > 10.0 ? Math.round(parseFloat(value)) : value;
};

var CarbonFootprintModalAlternativeInfoSection = function CarbonFootprintModalAlternativeInfoSection(_ref) {
    var carbonCalculationData = _ref.carbonCalculationData;
    var bulb = carbonCalculationData.bulb,
        fullyChargingSmartphones = carbonCalculationData.fullyChargingSmartphones,
        kettle = carbonCalculationData.kettle,
        microwave = carbonCalculationData.microwave,
        savedCO2e = carbonCalculationData.savedCO2e,
        tv = carbonCalculationData.tv,
        washingMachine = carbonCalculationData.washingMachine;


    var renderAlternativeInfoCards = function renderAlternativeInfoCards() {
        var alternativeInfoCardsConfig = [{
            iconComponent: _react2.default.createElement(_BatteryIcon2.default, null),
            title: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.battery.title'),
            info: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.battery.info', {
                value: formatValue(fullyChargingSmartphones)
            }),
            value: fullyChargingSmartphones
        }, {
            iconComponent: _react2.default.createElement(_WashingMachineIcon2.default, null),
            title: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.washingMachine.title'),
            info: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.washingMachine.info', {
                value: formatValue(washingMachine)
            }),
            value: washingMachine
        }, {
            iconComponent: _react2.default.createElement(_TVIcon2.default, null),
            title: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.tv.title'),
            info: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.tv.info', { value: formatValue(tv) }),
            value: tv
        }, {
            iconComponent: _react2.default.createElement(_KettleIcon2.default, null),
            title: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.kettle.title'),
            info: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.kettle.info', { value: formatValue(kettle) }),
            value: kettle
        }, {
            iconComponent: _react2.default.createElement(_BulbIcon2.default, null),
            title: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.bulb.title'),
            info: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.bulb.info', { value: formatValue(bulb) }),
            value: bulb
        }, {
            iconComponent: _react2.default.createElement(_MicrowaveIcon2.default, null),
            title: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.microwave.title'),
            info: (0, _I18n.translate)('carbonFootprint.modal.alternative.card.microwave.info', { value: formatValue(microwave) }),
            value: microwave
        }];

        var notNullableCards = alternativeInfoCardsConfig.filter(function (_ref2) {
            var value = _ref2.value;
            return value > 1.0;
        });

        var randomlyPickedCards = (0, _sampleSize3.default)(notNullableCards, 3);

        return randomlyPickedCards.map(function (_ref3) {
            var iconComponent = _ref3.iconComponent,
                title = _ref3.title,
                info = _ref3.info;
            return _react2.default.createElement(
                'li',
                {
                    className: 'carbon-footprint-modal__alternative--card carbon-footprint-modal__alternative--card-' + notNullableCards.length,
                    key: title
                },
                _react2.default.createElement(
                    'div',
                    { className: 'carbon-footprint-modal__alternative--card-img-container' },
                    iconComponent
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'carbon-footprint-modal__alternative--card-title' },
                    title
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'carbon-footprint-modal__alternative--card-info' },
                    info
                )
            );
        });
    };

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'h4',
            { className: 'carbon-footprint-modal__title' },
            (0, _I18n.translate)('carbonFootprint.modal.alternative.info.title', { savedCO2e: savedCO2e })
        ),
        _react2.default.createElement(
            'ul',
            { className: 'carbon-footprint-modal__alternative--cards-container' },
            renderAlternativeInfoCards()
        )
    );
};

CarbonFootprintModalAlternativeInfoSection.propTypes = {
    carbonCalculationData: _propTypes2.default.object.isRequired
};

CarbonFootprintModalAlternativeInfoSection.defaultProps = {
    carbonCalculationData: {}
};

exports.default = CarbonFootprintModalAlternativeInfoSection;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

var arraySampleSize = __webpack_require__(2064),
    baseSampleSize = __webpack_require__(2066),
    isArray = __webpack_require__(68),
    isIterateeCall = __webpack_require__(236),
    toInteger = __webpack_require__(200);

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

module.exports = sampleSize;


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(544),
    copyArray = __webpack_require__(311),
    shuffleSelf = __webpack_require__(943);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),
/* 2065 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(544),
    shuffleSelf = __webpack_require__(943),
    values = __webpack_require__(92);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

module.exports = baseSampleSize;


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatteryIcon = function BatteryIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "18", height: "32", viewBox: "0 0 55 100", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("rect", {
            x: "1.33951",
            y: "1",
            width: "52.321",
            height: "98",
            rx: "5",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "1",
            y: "1",
            width: "52.321",
            height: "98",
            rx: "5",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "16.7716",
            y: "1",
            width: "21.4568",
            height: "5.40741",
            rx: "1",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", { x: "17.0062", y: "92.5926", width: "20.9877", height: "2.46914", rx: "1.23457", fill: "black" }),
        _react2.default.createElement("rect", { x: "10", y: "43", width: "32.0129", height: "14", rx: "2", stroke: "#32AE57", strokeWidth: "2" }),
        _react2.default.createElement("rect", { x: "41", y: "47", width: "3", height: "6", rx: "1", fill: "#32AE57" }),
        _react2.default.createElement("rect", { x: "12", y: "45", width: "28", height: "10", rx: "1", fill: "#32AE57" })
    );
};

exports.default = BatteryIcon;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BulbIcon = function BulbIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "27", height: "32", viewBox: "0 0 75 88", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", {
            d: "M59.5 42.9972C59.5 57.2132 51.8888 57.2155 49.671 64.0226C47.4532 70.8297 50.6241 76 45.1066 76L30.4696 75.9251C24.774 75.9251 27.5094 70.7337 25.2845 64.0226C23.0597 57.3115 15.5 57.8524 15.5 42.9972C15.5 30.8489 25.3501 21 37.5 21C49.6499 21 59.5 30.8489 59.5 42.9972Z",
            fill: "white",
            stroke: "black",
            strokeWidth: "2",
            strokeMiterlimit: "10"
        }),
        _react2.default.createElement("path", {
            d: "M34.5 76L31 50L37 53.5L43 50L40.5 76",
            stroke: "black",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        _react2.default.createElement("path", {
            d: "M30 76H45V81C45 84.3137 42.3137 87 39 87H36C32.6863 87 30 84.3137 30 81V76Z",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", { x: "36.5", width: "2", height: "16", rx: "1", fill: "#32AE57" }),
        _react2.default.createElement("rect", {
            x: "74.5",
            y: "43",
            width: "2",
            height: "10",
            rx: "1",
            transform: "rotate(90 74.5 43)",
            fill: "#32AE57"
        }),
        _react2.default.createElement("rect", {
            x: "74.5",
            y: "43",
            width: "2",
            height: "10",
            rx: "1",
            transform: "rotate(90 74.5 43)",
            fill: "#32AE57"
        }),
        _react2.default.createElement("rect", {
            width: "2",
            height: "10",
            rx: "1",
            transform: "matrix(4.37114e-08 1 1 -4.37114e-08 0.5 43)",
            fill: "#32AE57"
        }),
        _react2.default.createElement("rect", {
            x: "67.6924",
            y: "16",
            width: "2",
            height: "13",
            rx: "1",
            transform: "rotate(45 67.6924 16)",
            fill: "#32AE57"
        }),
        _react2.default.createElement("rect", {
            width: "2",
            height: "13",
            rx: "1",
            transform: "matrix(-0.707107 0.707107 0.707107 0.707107 7.91422 16)",
            fill: "#32AE57"
        })
    );
};

exports.default = BulbIcon;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KettleIcon = function KettleIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "26", height: "32", viewBox: "0 0 81 100", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", {
            d: "M18.6372 32.0932C19.8 20.0777 29.8977 10.9099 41.9694 10.9099C53.9456 10.9099 63.9959 19.9375 65.2763 31.845L70.986 84.9453C71.431 89.0836 68.1883 92.6937 64.0261 92.6937H20.4827C16.3503 92.6937 13.1172 89.1326 13.5153 85.0194L18.6372 32.0932Z",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("path", {
            d: "M68.8802 63.8649L65.4817 30.7297H71.1684C73.7354 30.7297 75.8853 32.6736 76.1431 35.2276L78.4783 58.3627C78.7755 61.3077 76.4635 63.8649 73.5035 63.8649H68.8802Z",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("path", {
            d: "M9.96846 95.8919C9.96846 94.2351 11.3116 92.8919 12.9685 92.8919H71.6351C73.292 92.8919 74.6351 94.2351 74.6351 95.8919V99H9.96846V95.8919Z",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", { x: "21.5811", y: "22.5225", width: "41.4414", height: "1.8018", fill: "black" }),
        _react2.default.createElement("path", {
            d: "M21.1306 23.4234H10.7703L17.527 39.6396",
            stroke: "black",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        _react2.default.createElement("rect", { x: "13.473", y: "81.0811", width: "57.6577", height: "1.8018", fill: "black" }),
        _react2.default.createElement("circle", {
            cx: "4.5045",
            cy: "4.5045",
            r: "3.5045",
            transform: "matrix(-1 0 0 1 17.527 9.90991)",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("circle", {
            cx: "3.6036",
            cy: "3.6036",
            r: "2.6036",
            transform: "matrix(-1 0 0 1 9.41891 3.60358)",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("circle", {
            cx: "2.7027",
            cy: "2.7027",
            r: "1.7027",
            transform: "matrix(-1 0 0 1 17.527 1.80182)",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "38.7973",
            y: "34.3333",
            width: "7.00901",
            height: "38.5405",
            rx: "3.5045",
            fill: "white",
            stroke: "#32AE57",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", { x: "41.4009", y: "39.6396", width: "5.40541", height: "1.8018", rx: "0.900901", fill: "black" }),
        _react2.default.createElement("rect", { x: "41.4009", y: "50.4504", width: "5.40541", height: "1.8018", rx: "0.900901", fill: "black" }),
        _react2.default.createElement("rect", { x: "41.4009", y: "61.2612", width: "5.40541", height: "1.8018", rx: "0.900901", fill: "black" }),
        _react2.default.createElement("rect", { x: "43.2027", y: "45.045", width: "3.6036", height: "1.8018", rx: "0.900901", fill: "black" }),
        _react2.default.createElement("rect", { x: "43.2027", y: "55.8558", width: "3.6036", height: "1.8018", rx: "0.900901", fill: "black" }),
        _react2.default.createElement("rect", { x: "43.2027", y: "66.6667", width: "3.6036", height: "1.8018", rx: "0.900901", fill: "black" })
    );
};

exports.default = KettleIcon;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MicrowaveIcon = function MicrowaveIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "45", height: "32", viewBox: "0 0 99 70", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("rect", {
            x: "1.14102",
            y: "1",
            width: "96.7179",
            height: "63.5128",
            rx: "5",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "8.32051",
            y: "8.17944",
            width: "66.2051",
            height: "49.1538",
            rx: "5",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("path", {
            d: "M90.6795 18.8462C90.6795 21.2677 88.7164 23.2308 86.2949 23.2308C83.8733 23.2308 81.9103 21.2677 81.9103 18.8462C81.9103 16.4246 83.8733 14.4615 86.2949 14.4615C88.7164 14.4615 90.6795 16.4246 90.6795 18.8462Z",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("path", {
            d: "M90.6795 33.2052C90.6795 35.6267 88.7164 37.5898 86.2949 37.5898C83.8733 37.5898 81.9103 35.6267 81.9103 33.2052C81.9103 30.7836 83.8733 28.8206 86.2949 28.8206C88.7164 28.8206 90.6795 30.7836 90.6795 33.2052Z",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "81.9103",
            y: "49.4615",
            width: "8.76923",
            height: "6.07692",
            rx: "1",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "80.1154",
            y: "64.7179",
            width: "10.5641",
            height: "4.28205",
            rx: "1",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "8.32051",
            y: "64.7179",
            width: "10.5641",
            height: "4.28205",
            rx: "1",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("path", {
            d: "M32.4751 18.8462C32.4751 18.8462 29.3077 21.9689 29.3077 26.2271C29.3077 30.4854 33.7949 35.0275 33.7949 39.5696C33.7949 44.1118 31.4193 46.6667 31.4193 46.6667",
            stroke: "#32AE57",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        _react2.default.createElement("path", {
            d: "M42.3469 18.8462C42.3469 18.8462 39.1795 21.9689 39.1795 26.2271C39.1795 30.4854 43.6667 35.0275 43.6667 39.5696C43.6667 44.1118 41.2911 46.6667 41.2911 46.6667",
            stroke: "#32AE57",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        _react2.default.createElement("path", {
            d: "M52.2187 18.8462C52.2187 18.8462 49.0513 21.9689 49.0513 26.2271C49.0513 30.4854 53.5385 35.0275 53.5385 39.5696C53.5385 44.1118 51.1629 46.6667 51.1629 46.6667",
            stroke: "#32AE57",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    );
};

exports.default = MicrowaveIcon;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TVIcon = function TVIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "37", height: "32", viewBox: "0 0 109 94", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("rect", {
            x: "1.5",
            y: "20",
            width: "106",
            height: "67",
            rx: "5",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "7.5",
            y: "26",
            width: "94",
            height: "51",
            rx: "5",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("rect", {
            x: "31",
            y: "87",
            width: "47",
            height: "6",
            rx: "1",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("path", {
            d: "M42 9.14286L53.6364 20L74 1",
            stroke: "black",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        _react2.default.createElement("rect", {
            x: "59",
            y: "81",
            width: "2",
            height: "10",
            rx: "1",
            transform: "rotate(90 59 81)",
            fill: "#32AE57"
        })
    );
};

exports.default = TVIcon;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WashingMachineIcon = function WashingMachineIcon() {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "32", viewBox: "0 0 93 106", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("rect", {
            x: "1.5",
            y: "1",
            width: "90",
            height: "104",
            rx: "5",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("circle", { cx: "46.5", cy: "62", r: "32", fill: "white", stroke: "black", strokeWidth: "2" }),
        _react2.default.createElement("path", {
            d: "M26 75.5672C28.5 75.5672 29.9 74.5672 31.5 72.5672C33.5 70.0672 34 66.0672 38.5 66.0672C44 66.0672 44.5 75.5672 50.5 75.5672C57 75.5672 58 65 64 65C68 65 68 68.5672 70.5 68.5672",
            stroke: "#32AE57",
            strokeWidth: "2"
        }),
        _react2.default.createElement("circle", { cx: "46.5", cy: "62", r: "25", stroke: "black", strokeWidth: "2" }),
        _react2.default.createElement("rect", { x: "0.5", y: "22", width: "92", height: "2", fill: "black" }),
        _react2.default.createElement("rect", {
            x: "7.5",
            y: "7",
            width: "20",
            height: "10",
            rx: "2",
            fill: "white",
            stroke: "black",
            strokeWidth: "2"
        }),
        _react2.default.createElement("circle", { cx: "54.5", cy: "12", r: "5", fill: "white", stroke: "black", strokeWidth: "2" }),
        _react2.default.createElement(
            "mask",
            { id: "path-8-inside-1_1079_12867", fill: "white" },
            _react2.default.createElement("rect", { x: "72", y: "9", width: "6", height: "6", rx: "1" })
        ),
        _react2.default.createElement("rect", {
            x: "72",
            y: "9",
            width: "6",
            height: "6",
            rx: "1",
            fill: "white",
            stroke: "black",
            strokeWidth: "4",
            mask: "url(#path-8-inside-1_1079_12867)"
        }),
        _react2.default.createElement(
            "mask",
            { id: "path-9-inside-2_1079_12867", fill: "white" },
            _react2.default.createElement("rect", { x: "80", y: "9", width: "6", height: "6", rx: "1" })
        ),
        _react2.default.createElement("rect", {
            x: "80",
            y: "9",
            width: "6",
            height: "6",
            rx: "1",
            fill: "white",
            stroke: "black",
            strokeWidth: "4",
            mask: "url(#path-9-inside-2_1079_12867)"
        })
    );
};

exports.default = WashingMachineIcon;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _TripPlusbus = __webpack_require__(634);

var _TripPlusbus2 = _interopRequireDefault(_TripPlusbus);

var _Trip = __webpack_require__(442);

var _Trip2 = _interopRequireDefault(_Trip);

var _Fare = __webpack_require__(2074);

var _Fare2 = _interopRequireDefault(_Fare);

var _DownloadTicketsModal = __webpack_require__(1048);

var _DownloadTicketsModal2 = _interopRequireDefault(_DownloadTicketsModal);

var _RemoveJourneyModal = __webpack_require__(2076);

var _RemoveJourneyModal2 = _interopRequireDefault(_RemoveJourneyModal);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trip = function (_PointTrip) {
    (0, _inherits3.default)(Trip, _PointTrip);

    function Trip() {
        (0, _classCallCheck3.default)(this, Trip);
        return (0, _possibleConstructorReturn3.default)(this, _PointTrip.apply(this, arguments));
    }

    Trip.prototype._renderRemoveConfirm = function _renderRemoveConfirm() {
        var _this2 = this;

        return this.state.journeyToRemove && _react2.default.createElement(_RemoveJourneyModal2.default, {
            orderTrip: this.props.orderTrip,
            onBack: this._handleRemoveJourneyBack,
            onConfirm: function onConfirm() {
                _this2._handleRemoveJourneyConfirm();
                _this2.props.setBasketChanged();
            }
        });
    };

    Trip.prototype.render = function render() {
        var open = this.state.open;
        var _props = this.props,
            order = _props.order,
            orderTrip = _props.orderTrip,
            index = _props.index,
            context = _props.context;

        var fares = orderTrip.getJourneyFares();
        var titleKey = orderTrip.isSmartcard() ? 'smartcard_title' : 'journey_title';
        var tripTitle = (0, _I18n.translate)('order.summary.' + titleKey, { number: index + 1 });
        var TripTitleTag = context === _AppConstants.OrderSummaryContexts.BASKET_MODAL ? 'h2' : 'h3';

        var classNames = (0, _classnames2.default)('order-summary__item', {
            'order-summary__item--expanded': open
        });

        var dropDownClassNames = (0, _classnames2.default)('hidden-print text-secondary', {
            'otrl-rotate-180': open
        });

        return _react2.default.createElement(
            'li',
            { className: classNames },
            this._renderRemoveConfirm(),
            _react2.default.createElement(
                'div',
                { className: 'box-headed box-headed--primary' },
                _react2.default.createElement(
                    'div',
                    { className: 'box-headed__header box--padded text-weight--normal' },
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 8 },
                            _react2.default.createElement(
                                TripTitleTag,
                                { className: 'journey-heading text-weight--normal' },
                                tripTitle
                            )
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 4, className: 'text-right price' },
                            _react2.default.createElement(_Price2.default, { price: orderTrip.getTotalPrice() })
                        )
                    )
                ),
                _react2.default.createElement(
                    _FeatureFlag2.default,
                    { name: 'enableTicketDownload' },
                    order.hasDownloadableTickets() && _react2.default.createElement(
                        'div',
                        { className: 'box box--padded box-headed__body' },
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xsOffset: 8, xs: 4, className: 'text-right price' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { onClick: this._showDownloads },
                                    (0, _I18n.translate)('order.summary.download.tickets')
                                ),
                                this.state.showDownloads && _react2.default.createElement(_DownloadTicketsModal2.default, (0, _extends3.default)({ onClose: this._closeDownloads }, { order: order, orderTrip: orderTrip }))
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'box-headed__body box--padded' },
                    _react2.default.createElement(
                        'p',
                        { className: 'journey-toggler no-margin text-secondary text-weight--normal' },
                        _react2.default.createElement(
                            _OnEnterTrigger2.default,
                            { element: 'span', onClick: this._toggleOpen, className: dropDownClassNames },
                            _react2.default.createElement(_Icon2.default, { icon: 'dropdown', className: dropDownClassNames }),
                            (0, _I18n.translate)('order.summary.journey_details')
                        ),
                        this.renderRemoveJourney(tripTitle)
                    ),
                    fares.map(function (fare, key) {
                        return _react2.default.createElement(_Fare2.default, {
                            orderFare: fare,
                            key: key,
                            open: open
                        });
                    }),
                    _react2.default.createElement(_TripPlusbus2.default, { orderTrip: orderTrip, open: open })
                )
            )
        );
    };

    return Trip;
}(_Trip2.default);

exports.default = Trip;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FarePassengers = __webpack_require__(938);

var _FarePassengers2 = _interopRequireDefault(_FarePassengers);

var _FareRestrictions = __webpack_require__(617);

var _FareRestrictions2 = _interopRequireDefault(_FareRestrictions);

var _FareSummary = __webpack_require__(2075);

var _FareSummary2 = _interopRequireDefault(_FareSummary);

var _Fare = __webpack_require__(636);

var _Fare2 = _interopRequireDefault(_Fare);

var _FareValidity = __webpack_require__(414);

var _FareValidity2 = _interopRequireDefault(_FareValidity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fare = function (_PointFare) {
    (0, _inherits3.default)(Fare, _PointFare);

    function Fare() {
        (0, _classCallCheck3.default)(this, Fare);
        return (0, _possibleConstructorReturn3.default)(this, _PointFare.apply(this, arguments));
    }

    Fare.prototype._renderFareDetails = function _renderFareDetails(props) {
        var open = props.open,
            orderFare = props.orderFare;


        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)("fare-details also-visible-print", { "hidden": !open }) },
            _react2.default.createElement(_FarePassengers2.default, { orderFare: orderFare, className: '' }),
            _react2.default.createElement(
                _Row2.default,
                { className: 'margin-bottom--sm' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, sm: 10 },
                    _react2.default.createElement(_FareValidity2.default, {
                        from: orderFare.outwardJourney.validFrom,
                        to: orderFare.outwardJourney.validTo
                    })
                )
            ),
            _react2.default.createElement(
                'ul',
                { className: 'list-unstyled exceptions-list text-sm text-light' },
                _react2.default.createElement(_FareRestrictions2.default, { fare: orderFare, useBootstrap: true })
            )
        );
    };

    Fare.prototype.render = function render() {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_FareSummary2.default, this.props),
            this._renderFareDetails(this.props)
        );
    };

    return Fare;
}(_Fare2.default);

exports.default = Fare;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _Fare = __webpack_require__(76);

var _Fare2 = _interopRequireDefault(_Fare);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FareSummary = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FareSummary, _React$PureComponent);

    function FareSummary() {
        (0, _classCallCheck3.default)(this, FareSummary);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    FareSummary.prototype.render = function render() {
        var orderFare = this.props.orderFare;

        var ticketTermsUrl = _config2.default.get('ticketTermsAndConditions').replace('{ticketTypeCode}', orderFare.ticketType.code);

        return _react2.default.createElement(
            _Row2.default,
            { className: 'fare-summary' },
            _react2.default.createElement(
                _Col2.default,
                { xs: 12, md: 6, lg: 6, className: 'text-weight--normal' },
                orderFare.getName(),
                '\xA0',
                _react2.default.createElement(_ExternalLink2.default, { className: 'text-sm', href: ticketTermsUrl, message: (0, _I18n.translate)('booking.fares.nre-link.text') }),
                '\xA0',
                orderFare.isGroupSave() && (0, _I18n.translate)('order.summary.groupSave')
            )
        );
    };

    return FareSummary;
}(_react2.default.PureComponent), _class.propTypes = {
    orderFare: _propTypes2.default.instanceOf(_Fare2.default).isRequired
}, _temp);
exports.default = FareSummary;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _FareValidity = __webpack_require__(414);

var _FareValidity2 = _interopRequireDefault(_FareValidity);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RemoveJourneyModal = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(RemoveJourneyModal, _PureRenderComponent);

    function RemoveJourneyModal() {
        (0, _classCallCheck3.default)(this, RemoveJourneyModal);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    RemoveJourneyModal.prototype._getFareDetails = function _getFareDetails(fare, key) {
        return _react2.default.createElement(
            'li',
            { key: key, className: 'order-summary__item order-summary__item--short' },
            _react2.default.createElement(
                _Row2.default,
                { className: 'fare-summary' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, md: 6, lg: 6, className: 'text-weight--normal no-margin' },
                    _react2.default.createElement(
                        'p',
                        null,
                        fare.getName(),
                        '\xA0',
                        fare.isGroupSave() && (0, _I18n2.default)('order.summary.groupSave')
                    )
                )
            ),
            _react2.default.createElement(_FareValidity2.default, {
                from: fare.outwardJourney.validFrom,
                to: fare.outwardJourney.validTo
            })
        );
    };

    RemoveJourneyModal.prototype.render = function render() {
        var _props = this.props,
            orderTrip = _props.orderTrip,
            onBack = _props.onBack,
            onConfirm = _props.onConfirm;

        var modalProps = {
            titleText: 'order.summary.confirmRemoveJourney',
            closeText: 'button.text.cancel',
            continueText: 'button.text.removeJourney',
            onClose: onBack,
            onContinue: onConfirm,
            className: 'modal--sm modal--remove-journey'
        };

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { sm: 12 },
                    _react2.default.createElement(
                        'ul',
                        { className: 'order-summary__list list-unstyled' },
                        orderTrip.getJourneyFares().map(this._getFareDetails)
                    )
                )
            )
        );
    };

    return RemoveJourneyModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    onBack: _propTypes2.default.func.isRequired,
    onConfirm: _propTypes2.default.func.isRequired
}, _temp);
exports.default = RemoveJourneyModal;

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

exports.default = FareOnlyTrip;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AppConstants = __webpack_require__(6);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Trip = __webpack_require__(86);

var _Trip2 = _interopRequireDefault(_Trip);

var _SeasonTrip = __webpack_require__(944);

var _SeasonTrip2 = _interopRequireDefault(_SeasonTrip);

var _Trip3 = __webpack_require__(442);

var _Trip4 = _interopRequireDefault(_Trip3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FareOnlyTrip(props) {
    var orderTrip = props.orderTrip;

    if (!orderTrip.hasFareOnlyFare()) {
        return null;
    }

    if (orderTrip.getFareOnlyFare().isSeason()) {
        return _react2.default.createElement(_SeasonTrip2.default, (0, _extends3.default)({}, props, { isFareOnly: true }));
    }

    return _react2.default.createElement(_Trip4.default, (0, _extends3.default)({}, props, { isFareOnly: true }));
}

FareOnlyTrip.propTypes = {
    index: _propTypes2.default.number.isRequired,
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired,
    orderTrip: _propTypes2.default.instanceOf(_Trip2.default).isRequired,
    open: _propTypes2.default.bool,
    isLocked: _propTypes2.default.bool,
    isLoggedIn: _propTypes2.default.bool,
    context: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.OrderSummaryContexts))
};

FareOnlyTrip.defaultProps = {
    open: false,
    isLocked: false,
    isLoggedIn: false,
    context: null
};

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmptyBasket() {
    return _react2.default.createElement(
        'div',
        { className: 'basket--empty vertical-align-parent padding-top padding-bottom bg--light-grey' },
        _react2.default.createElement(
            'div',
            { className: 'confirmation vertical-align text-center' },
            _react2.default.createElement(_Icon2.default, { icon: 'error margin-bottom--sm otrl-xl' }),
            _react2.default.createElement(
                'p',
                { className: 'alert-danger no-margin text-weight--normal' },
                (0, _I18n.translate)('basket.empty')
            )
        )
    );
}

exports.default = EmptyBasket;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _I18n = __webpack_require__(9);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _PaymentCardDetails = __webpack_require__(628);

var _PaymentCardDetails2 = _interopRequireDefault(_PaymentCardDetails);

var _PaypalPaymentDetails = __webpack_require__(647);

var _PaypalPaymentDetails2 = _interopRequireDefault(_PaypalPaymentDetails);

var _AmazonPayPaymentDetails = __webpack_require__(648);

var _AmazonPayPaymentDetails2 = _interopRequireDefault(_AmazonPayPaymentDetails);

var _ApplePayPaymentDetails = __webpack_require__(1110);

var _ApplePayPaymentDetails2 = _interopRequireDefault(_ApplePayPaymentDetails);

var _GooglePayPaymentDetails = __webpack_require__(1111);

var _GooglePayPaymentDetails2 = _interopRequireDefault(_GooglePayPaymentDetails);

var _BraintreeCardPaymentDetails = __webpack_require__(1087);

var _BraintreeCardPaymentDetails2 = _interopRequireDefault(_BraintreeCardPaymentDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentInformation = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(PaymentInformation, _React$PureComponent);

    function PaymentInformation() {
        (0, _classCallCheck3.default)(this, PaymentInformation);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    PaymentInformation.prototype.renderPaymentDetails = function renderPaymentDetails(type) {
        var order = this.props.order;


        var cards = order[type].getCards();
        var voucherAmount = order.getVoucherPaymentAmount(type);
        var paypalPayment = order.getPaypalPayment(type);
        var amazonPayPayment = order.getAmazonPayPayment(type);
        var applePayPayment = order.getApplePayPayment(type);
        var googlePayPayment = order.getGooglePayPayment(type);
        var braintreeCardPayment = order.getBraintreeCardPayment(type);

        return _react2.default.createElement(
            _Row2.default,
            null,
            voucherAmount > 0 && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    (0, _I18n.translate)('account.orders.eVoucherPayment', { count: order.payments.warrants.size })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: voucherAmount })
                )
            ),
            order.hasCardPayment() && cards.filter(function (card) {
                return card.amount > 0;
            }).map(function (card, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        _react2.default.createElement(_PaymentCardDetails2.default, { card: card })
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right price' },
                        _react2.default.createElement(_Price2.default, { price: card.amount })
                    )
                );
            }),
            paypalPayment && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    _react2.default.createElement(_PaypalPaymentDetails2.default, { payment: paypalPayment })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: paypalPayment.amount })
                )
            ),
            amazonPayPayment && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    _react2.default.createElement(_AmazonPayPaymentDetails2.default, { payment: amazonPayPayment })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: amazonPayPayment.amount })
                )
            ),
            applePayPayment && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    _react2.default.createElement(_ApplePayPaymentDetails2.default, { payment: applePayPayment })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: applePayPayment.amount })
                )
            ),
            googlePayPayment && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    _react2.default.createElement(_GooglePayPaymentDetails2.default, { payment: googlePayPayment })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: googlePayPayment.amount })
                )
            ),
            braintreeCardPayment && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 8 },
                    _react2.default.createElement(_BraintreeCardPaymentDetails2.default, { payment: braintreeCardPayment })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 4, className: 'text-right price' },
                    _react2.default.createElement(_Price2.default, { price: braintreeCardPayment.amount })
                )
            )
        );
    };

    PaymentInformation.prototype.render = function render() {
        var order = this.props.order;


        if (!order.isPaid() || order.isFullRefund) {
            return null;
        }

        return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(
                    'div',
                    { className: 'padding-bottom--sm border--bottom' },
                    _react2.default.createElement(
                        _Row2.default,
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 12 },
                            _react2.default.createElement(
                                'h3',
                                { className: 'text-weight--bold' },
                                (0, _I18n.translate)('account.orders.paymentDetails')
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'order-summary__payments-wrapper' },
                        this.renderPaymentDetails('payments'),
                        order.hasChangeoverTickets() && this.renderPaymentDetails('changeoverPayments')
                    )
                )
            )
        );
    };

    return PaymentInformation;
}(_react2.default.PureComponent), _class.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired
}, _temp);
exports.default = PaymentInformation;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(521);

module.exports = function dasherize(str) {
  return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
};


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {


var makeString = __webpack_require__(254);

var from  = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž',
  to    = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';

from += from.toUpperCase();
to += to.toUpperCase();

to = to.split('');

// for tokens requireing multitoken output
from += 'ß';
to.push('ss');


module.exports = function cleanDiacritics(str) {
  return makeString(str).replace(/.{1}/g, function(c){
    var index = from.indexOf(c);
    return index === -1 ? c : to[index];
  });
};


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

var _PaymentCardDetails = __webpack_require__(628);

var _PaymentCardDetails2 = _interopRequireDefault(_PaymentCardDetails);

var _PaypalPaymentDetails = __webpack_require__(647);

var _PaypalPaymentDetails2 = _interopRequireDefault(_PaypalPaymentDetails);

var _AmazonPayPaymentDetails = __webpack_require__(648);

var _AmazonPayPaymentDetails2 = _interopRequireDefault(_AmazonPayPaymentDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundInformation = function RefundInformation(_ref) {
    var refund = _ref.refund,
        isFullRefund = _ref.isFullRefund;

    if (!(refund && (refund.hasRefunds() || refund.isChangeoverRefund))) {
        return null;
    }

    var cards = refund.payments.getCards();
    var voucherAmount = refund.getVoucherRefundAmount();
    var paypalPayment = refund.getPaypalPayment();
    var amazonPayment = refund.getAmazonPayPayment();
    var alternativePayment = refund.getAlternativePayment();
    var cardsFiltered = cards && cards.filter(function (card) {
        return card.amountRefunded > 0;
    });

    var paymentDetailsClassName = (0, _classnames2.default)('text-weight--bold', {
        'padding-top--sm': !isFullRefund
    });

    return _react2.default.createElement(
        _Row2.default,
        null,
        _react2.default.createElement(
            _Col2.default,
            { xs: 12 },
            _react2.default.createElement(
                'div',
                { className: 'padding-bottom--sm border--bottom' },
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12 },
                        _react2.default.createElement(
                            'h3',
                            { className: paymentDetailsClassName },
                            (0, _I18n2.default)('account.orders.refundDetails')
                        )
                    )
                ),
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    !alternativePayment && _react2.default.createElement(
                        'div',
                        null,
                        voucherAmount > 0 && _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                (0, _I18n2.default)('account.orders.eVoucherPayment', {
                                    count: refund.payments.warrants.size
                                })
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right price' },
                                _react2.default.createElement(_Price2.default, { price: voucherAmount })
                            )
                        ),
                        refund.hasCardPayment() && cardsFiltered && _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                _react2.default.createElement(_PaymentCardDetails2.default, { card: cardsFiltered.get(0) })
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                {
                                    xs: 4,
                                    className: 'text-right price'
                                },
                                _react2.default.createElement(_Price2.default, {
                                    price: cards.map(function (entry) {
                                        return entry.get('amountRefunded');
                                    }).reduce(function (prev, current) {
                                        return prev + current;
                                    })
                                })
                            )
                        ),
                        paypalPayment && _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                _react2.default.createElement(_PaypalPaymentDetails2.default, {
                                    payment: paypalPayment
                                })
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right price' },
                                _react2.default.createElement(_Price2.default, {
                                    price: paypalPayment.amountRefunded
                                })
                            )
                        ),
                        amazonPayment && _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 8 },
                                _react2.default.createElement(_AmazonPayPaymentDetails2.default, {
                                    payment: amazonPayment
                                })
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 4, className: 'text-right price' },
                                _react2.default.createElement(_Price2.default, {
                                    price: amazonPayment.amountRefunded
                                })
                            )
                        )
                    ),
                    alternativePayment && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 8 },
                            (0, _I18n2.default)('account.orders.refund.itso.manualRefundedIn.' + refund.getAlternativePaymentType())
                        ),
                        _react2.default.createElement(
                            _Col2.default,
                            { xs: 4, className: 'text-right price' },
                            _react2.default.createElement(_Price2.default, {
                                price: alternativePayment.amount
                            })
                        )
                    )
                )
            )
        )
    );
};

RefundInformation.propTypes = {
    refund: _propTypes2.default.instanceOf(_Order2.default),
    isFullRefund: _propTypes2.default.bool
};

exports.default = RefundInformation;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(2084),
    toString = __webpack_require__(119);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(639);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(2086),
    hasUnicodeWord = __webpack_require__(2087),
    toString = __webpack_require__(119),
    unicodeWords = __webpack_require__(2088);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 2086 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 2087 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 2088 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _I18n = __webpack_require__(9);

var _brand = __webpack_require__(435);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryInformationCollection = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(DeliveryInformationCollection, _PureRenderComponent);

    function DeliveryInformationCollection() {
        (0, _classCallCheck3.default)(this, DeliveryInformationCollection);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    DeliveryInformationCollection.prototype.render = function render() {
        var order = this.props.order;
        var delivery = order.delivery;

        var _getBrandInfo = (0, _brand.getBrandInfo)(),
            isGTR = _getBrandInfo.isGTR;

        var deliveryTimeInMinutes = isGTR ? 5 : 30;

        return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(
                    'div',
                    null,
                    order.collectionReference && _react2.default.createElement(
                        'p',
                        { className: 'text-primary text-weight--normal text-lg' },
                        (0, _I18n.translate)('order.details.collectionreference', { ref: order.collectionReference }),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            '. '
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_FormattedHTMLMessage2.default, { message: (0, _I18n.translate)("order.details.todWithAnyCard", { stationName: delivery.collectionLocation.name, ref: order.collectionReference, deliveryTime: deliveryTimeInMinutes }) })
                    )
                )
            )
        );
    };

    return DeliveryInformationCollection;
}(_PureRenderComponent3.default), _class.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired
}, _temp);
exports.default = DeliveryInformationCollection;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _I18n = __webpack_require__(9);

var _SmartcardAppIcons = __webpack_require__(649);

var _SmartcardAppIcons2 = _interopRequireDefault(_SmartcardAppIcons);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _STicketLoadingDetails = __webpack_require__(1174);

var _STicketLoadingDetails2 = _interopRequireDefault(_STicketLoadingDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DeliveryInformationSTicket(_ref) {
    var brand = _ref.brand;

    var _useState = (0, _react.useState)(false),
        showAppModal = _useState[0],
        setShowAppModal = _useState[1];

    var toggleAppModal = function toggleAppModal() {
        return setShowAppModal(!showAppModal);
    };

    var renderModal = function renderModal() {
        return _react2.default.createElement(
            _BaseModal2.default,
            {
                titleText: (0, _I18n.translate)('booking.delivery.sticket.modal.title'),
                className: 'modal--lg load-smartcard-modal',
                onClose: toggleAppModal,
                hideContinue: true
            },
            _react2.default.createElement(_STicketLoadingDetails2.default, null)
        );
    };

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: 'order-summary__load-smartcard-info' },
            _react2.default.createElement(
                'h3',
                { className: 'text-weight--bold margin-bottom--xs' },
                (0, _I18n.translate)('confirmation.sTicket.app.title')
            ),
            _react2.default.createElement(
                'p',
                { className: 'text-size--normal leading-md' },
                _react2.default.createElement(_FormattedHTMLMessage2.default, { message: (0, _I18n.translate)('confirmation.sTicket.app.description', {
                        brand: brand
                    }) }),
                ' ',
                _react2.default.createElement(_SmartcardAppIcons2.default, { toggleAppModal: toggleAppModal })
            )
        ),
        showAppModal && renderModal()
    );
}

DeliveryInformationSTicket.propTypes = {
    brand: _propTypes2.default.string.isRequired
};

exports.default = DeliveryInformationSTicket;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _Handoff = __webpack_require__(1060);

var _Handoff2 = _interopRequireDefault(_Handoff);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        handoffDetails: _OrderStore2.default.getHandoffDetails()
    };
};

var NRETransactionFrame = function (_Component) {
    (0, _inherits3.default)(NRETransactionFrame, _Component);

    function NRETransactionFrame() {
        (0, _classCallCheck3.default)(this, NRETransactionFrame);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
    }

    NRETransactionFrame.prototype.componentWillUnmount = function componentWillUnmount() {
        (0, _defer3.default)(function () {
            return _OrderActions2.default.updateHandoffDetails(null);
        });
    };

    NRETransactionFrame.prototype.render = function render() {
        var _props = this.props,
            handoffDetails = _props.handoffDetails,
            order = _props.order;


        if (!handoffDetails || !handoffDetails.handoffid) {
            return null;
        }

        var isProd = _config2.default.get('environment') === 'prod';
        var baseUrl = _config2.default.get(isProd ? 'journeyPlannerNREUrl' : 'journeyPlannerNREStagingUrl');
        var queryString = '?' + handoffDetails.getTransactionQueryString(order.id);
        var url = baseUrl + '/service/iframe/success' + queryString;

        return _react2.default.createElement('iframe', { src: url, width: 1, height: 1, frameBorder: 0, style: { display: 'none' } });
    };

    return NRETransactionFrame;
}(_react.Component);

NRETransactionFrame.propTypes = {
    handoffDetails: _propTypes2.default.instanceOf(_Handoff2.default),
    order: _propTypes2.default.instanceOf(_Order2.default)
};

exports.default = (0, _connectToStores2.default)([_OrderStore2.default], _getStateFromStores)(NRETransactionFrame);

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _I18n = __webpack_require__(9);

var _useChangeovers2 = __webpack_require__(2093);

var _useChangeovers3 = _interopRequireDefault(_useChangeovers2);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Price = __webpack_require__(110);

var _Price2 = _interopRequireDefault(_Price);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Changeovers = function Changeovers(_ref) {
    var order = _ref.order;

    var _useChangeovers = (0, _useChangeovers3.default)(order),
        changeovers = _useChangeovers.changeovers;

    var _useState = (0, _react.useState)(false),
        open = _useState[0],
        setOpen = _useState[1];

    var toggleOpen = (0, _react.useCallback)(function () {
        setOpen(!open);
    }, [open]);

    var dropDownClassNames = (0, _classnames2.default)('hidden-print text-secondary', {
        'otrl-rotate-180': open
    });

    if (changeovers.isEmpty()) {
        return null;
    }

    var changeover = changeovers.first();

    return _react2.default.createElement(
        'div',
        { className: 'box--light box--rounded bg--white margin-bottom--sm margin-top--sm' },
        _react2.default.createElement(
            _OnEnterTrigger2.default,
            { element: 'span', onClick: toggleOpen },
            _react2.default.createElement(
                _Row2.default,
                { className: 'no-margin box--clickable padding--vert-md' },
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 10 },
                    _react2.default.createElement(
                        'h3',
                        { className: 'text-weight--bold margin-bottom--xs' },
                        (0, _I18n.translate)('account.orders.changeover.originalSeasonTicket')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'like-table fare-stations', key: 'changeover-' + changeover.id },
                        _react2.default.createElement(
                            'div',
                            { className: 'table-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'table-cell text-weight--normal' },
                                changeover.fromOrigin.name
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'table-cell direction text-center' },
                                _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-180' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'table-cell text-weight--normal' },
                                changeover.fromDestination.name
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 2, className: 'text-right' },
                    _react2.default.createElement(
                        'div',
                        { className: 'padding--vert-md' },
                        _react2.default.createElement(_Icon2.default, { icon: 'dropdown', className: dropDownClassNames })
                    )
                )
            )
        ),
        open ? _react2.default.createElement(
            'div',
            { className: 'padding--horiz-md padding-bottom--sm' },
            _react2.default.createElement(
                'div',
                { className: 'padding--vert-md border--top' },
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'text-weight--normal text-secondary' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        (0, _I18n.translate)('account.orders.changeover.originalSeasonTicket'),
                        ':'
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right' },
                        _react2.default.createElement(_Price2.default, { price: changeover.oldPrice })
                    )
                ),
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'text-weight--normal text-secondary' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        (0, _I18n.translate)('account.orders.changeover.newSeasonTicket'),
                        ':'
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right' },
                        _react2.default.createElement(_Price2.default, { price: changeover.newPrice })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'padding--vert-md border--top' },
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'text-weight--normal text-secondary' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        (0, _I18n.translate)('account.orders.changeover.daysRemaining'),
                        ':'
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right' },
                        changeover.daysRemaining
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'padding--vert-md border--top' },
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'text-weight--normal text-secondary' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        (0, _I18n.translate)('account.orders.changeover.creditRemaining'),
                        ':'
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right' },
                        _react2.default.createElement(_Price2.default, { price: changeover.credit })
                    )
                ),
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'text-weight--normal text-secondary' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        (0, _I18n.translate)('account.orders.changeover.amountDue'),
                        ':'
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right' },
                        _react2.default.createElement(_Price2.default, { price: changeover.amountDue })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'padding-top--sm border--top' },
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'text-md text-weight--bold text-primary' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 8 },
                        (0, _I18n.translate)('account.orders.changeover.totalAmount'),
                        ':'
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 4, className: 'text-right' },
                        _react2.default.createElement(_Price2.default, { price: changeover.oldPrice + changeover.difference })
                    )
                )
            )
        ) : null
    );
};

Changeovers.propTypes = {
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired
};

Changeovers.defaultProps = {};

exports.default = Changeovers;

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _react = __webpack_require__(0);

var _immutable = __webpack_require__(5);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useChangeovers = function useChangeovers(order) {
    var _useState = (0, _react.useState)(new _immutable.List()),
        changeovers = _useState[0],
        setChangeovers = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        isLoading = _useState2[0],
        setIsLoading = _useState2[1];

    var user = _UserStore2.default.getCurrent();

    var fetchChangeovers = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var data;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setIsLoading(true);
                            _context.next = 3;
                            return _OrderActions2.default.loadChangeovers(order, user.id);

                        case 3:
                            data = _context.sent;

                            setChangeovers(data);
                            setIsLoading(false);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function fetchChangeovers() {
            return _ref.apply(this, arguments);
        };
    }();

    (0, _react.useEffect)(function () {
        if (user && user.isLoggedIn()) {
            (0, _defer3.default)(fetchChangeovers);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return { changeovers: changeovers, isLoading: isLoading };
};

exports.default = useChangeovers;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExpiredModal(_ref) {
    var order = _ref.order,
        onClose = _ref.onClose;


    var modalProps = {
        disableBlur: true,
        disableEscape: true,
        className: "modal--sm basket-expired-modal",
        titleText: 'basket.expired',
        onClose: onClose,
        hideContinue: true,
        backdropClassName: "basket-expired-modal"
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            'div',
            { className: 'alert-warning margin-top margin-bottom text-center' },
            _react2.default.createElement(_Icon2.default, { className: 'text-lg', icon: 'error' }),
            _react2.default.createElement(
                'h3',
                null,
                (0, _I18n.translate)('basket.expired.chosenJourneys', { journeys: order.trips.size })
            )
        ),
        _react2.default.createElement(
            'p',
            { className: 'text-center' },
            (0, _I18n.translate)('basket.expired.pleaseTryAgain')
        )
    );
}

ExpiredModal.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired
};

exports.default = ExpiredModal;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _CustomerService = __webpack_require__(280);

var _CustomerService2 = _interopRequireDefault(_CustomerService);

var _ForgotPasswordForm = __webpack_require__(2096);

var _ForgotPasswordForm2 = _interopRequireDefault(_ForgotPasswordForm);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPasswordModal = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(ForgotPasswordModal, _PureRenderComponent);

    function ForgotPasswordModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ForgotPasswordModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            form: new _ForgotPasswordForm2.default(),
            submitted: false,
            loading: false,
            success: false
        }, _this._handleSelect = function () {
            if (!_this.state.form.isComplete()) {
                _this.setState({ submitted: true });
            } else {
                _this.setState({ loading: true });

                var resetLinkQueryParams = _this.props.isBrochureRedirect ? 'redirect=brochure' : null;

                _CustomerService2.default.requestResetPassword(_this.state.form.email, resetLinkQueryParams).then(function () {
                    _this.setState({ loading: false, success: true });
                });
            }
        }, _this._handleChange = function (field, value) {
            _this.setState({
                form: _this.state.form.set(field, value),
                submitted: false
            });
        }, _this._handleCancel = function () {
            if (!_this.state.success) {
                _this.props.onCancel();
            }
            _ModalActions2.default.close(_AppConstants.GlobalModals.FORGOT_PASSWORD);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ForgotPasswordModal.prototype._renderSuccess = function _renderSuccess() {
        return _react2.default.createElement(
            'div',
            { className: 'vertical-align-parent full-height' },
            _react2.default.createElement(
                'div',
                { className: 'confirmation vertical-align text-center' },
                _react2.default.createElement(_Icon2.default, { icon: 'selected', className: 'margin-bottom--sm otrl-xl' }),
                _react2.default.createElement(
                    'p',
                    { className: 'alert-success no-margin text-weight--normal' },
                    (0, _I18n2.default)('login.forgotPassword.submitted')
                )
            )
        );
    };

    ForgotPasswordModal.prototype._renderForm = function _renderForm() {
        return _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        'p',
                        { className: 'text-light margin-bottom' },
                        (0, _I18n2.default)('login.forgotPassword.help')
                    )
                )
            ),
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(_ValidatedField2.default, {
                        form: this.state.form,
                        id: 'email',
                        field: 'email',
                        label: (0, _I18n2.default)('customerdetails.email'),
                        labelClassName: 'sr-only',
                        placeholder: (0, _I18n2.default)('customerdetails.email'),
                        onChange: this._handleChange,
                        visited: this.state.submitted
                    })
                )
            )
        );
    };

    ForgotPasswordModal.prototype.render = function render() {
        var modalProps = {
            onClose: this._handleCancel,
            onContinue: this._handleSelect,
            className: 'modal--sm modal--standard',
            titleText: 'login.forgotPassword',
            disableContinue: this.state.loading,
            continueText: 'button.text.continue',
            closeText: this.state.success ? 'button.text.close' : 'button.text.cancel',
            hideContinue: this.state.success,
            onEnterContinue: false
        };

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            this.state.success ? this._renderSuccess() : this._renderForm()
        );
    };

    return ForgotPasswordModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    onCancel: _propTypes2.default.func,
    isBrochureRedirect: _propTypes2.default.bool
}, _class.defaultProps = {
    onCancel: _noop3.default,
    isBrochureRedirect: false
}, _temp2);
exports.default = ForgotPasswordModal;

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPasswordForm = function (_record) {
    (0, _inherits3.default)(ForgotPasswordForm, _record);

    function ForgotPasswordForm() {
        (0, _classCallCheck3.default)(this, ForgotPasswordForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    ForgotPasswordForm.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new ForgotPasswordForm(json);
    };

    ForgotPasswordForm.prototype.getSchema = function getSchema() {
        return {
            email: _validation2.default.email()
        };
    };

    return ForgotPasswordForm;
}((0, _immutable.Record)({ email: null }));

(0, _assign2.default)(ForgotPasswordForm.prototype, _ValidationMixin2.default);

exports.default = ForgotPasswordForm;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoggedOutModal(_ref) {
    var onClose = _ref.onClose;

    var modalProps = {
        disableBlur: true,
        disableEscape: true,
        titleText: 'account.loggedOut',
        onClose: onClose,
        hideContinue: true,
        className: "modal--sm auto-logout-modal",
        backdropClassName: "auto-logout-modal"
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            'div',
            { className: 'vertical-align-parent full-height' },
            _react2.default.createElement(
                'div',
                { className: 'confirmation vertical-align text-center' },
                _react2.default.createElement(_Icon2.default, { icon: 'clock', className: 'margin-bottom--sm otrl-xl' }),
                _react2.default.createElement(
                    'p',
                    { className: 'alert-warning text-weight--normal' },
                    (0, _I18n.translate)('account.loggedOut.youWereloggedOut')
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'text-center' },
                    (0, _I18n.translate)('account.loggedOut.possibleReasons', {
                        autoLogoutMinutes: _config2.default.get('autoLogoutMinutes')
                    })
                )
            )
        )
    );
}

LoggedOutModal.propTypes = {
    onClose: _propTypes2.default.func.isRequired
};

exports.default = LoggedOutModal;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LogoutWarningModal(_ref) {
    var onClose = _ref.onClose;

    var modalProps = {
        disableBlur: true,
        disableEscape: true,
        titleText: 'account.logoutWarning',
        onClose: onClose,
        className: "modal--sm logout-warning-modal",
        hideContinue: true,
        backdropClassName: "logout-warning-modal"
    };

    return _react2.default.createElement(
        _BaseModal2.default,
        modalProps,
        _react2.default.createElement(
            'div',
            { className: 'vertical-align-parent full-height' },
            _react2.default.createElement(
                'div',
                { className: 'confirmation vertical-align text-center' },
                _react2.default.createElement(_Icon2.default, { icon: 'clock', className: 'margin-bottom--sm otrl-xl' }),
                _react2.default.createElement(
                    'p',
                    { className: 'alert-warning text-weight--normal' },
                    (0, _I18n.translate)('account.logoutWarning.almostTime')
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'text-center' },
                    (0, _I18n.translate)('account.logoutWarning.possibleReasons', {
                        autoLogoutMinutes: _config2.default.get('autoLogoutMinutes')
                    })
                )
            )
        )
    );
}

LogoutWarningModal.propTypes = {
    onClose: _propTypes2.default.func.isRequired
};

exports.default = LogoutWarningModal;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Modal = __webpack_require__(547);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _AppConstants = __webpack_require__(6);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _I18n = __webpack_require__(9);

var _Header = __webpack_require__(1177);

var _Header2 = _interopRequireDefault(_Header);

var _Failure = __webpack_require__(2100);

var _Failure2 = _interopRequireDefault(_Failure);

var _Success = __webpack_require__(2101);

var _Success2 = _interopRequireDefault(_Success);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NRETransferModal(_ref) {
    var success = _ref.success;


    var close = function close() {
        return _ModalActions2.default.close(_AppConstants.GlobalModals.NRE);
    };
    var modalProps = {
        onHide: close,
        dialogClassName: 'modal--med',
        animation: false,
        show: true
    };

    return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({}, modalProps, { className: 'modal--transfer' }),
        _react2.default.createElement(
            _Modal2.default.Body,
            null,
            _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(_Header2.default, null),
                success ? _react2.default.createElement(_Success2.default, null) : _react2.default.createElement(_Failure2.default, null)
            )
        ),
        _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'default',
                    onClick: close,
                    className: 'close btn-lg' },
                (0, _I18n.translate)('button.text.continue')
            )
        )
    );
}

NRETransferModal.propTypes = {
    success: _propTypes2.default.bool
};

NRETransferModal.defaultProps = {
    success: false
};

exports.default = NRETransferModal;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Failure() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'p',
            { className: 'margin-top--md font-margin-bottom text-weight--normal text-lg text-secondary' },
            (0, _I18n.translate)('nre.transferModal.failure.sorry')
        ),
        _react2.default.createElement(
            'p',
            { className: 'margin-top--sm text-weight--normal' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'nre.transferModal.failure.text',
                brand: _react2.default.createElement(
                    'span',
                    { className: 'text-secondary' },
                    (0, _I18n.translate)('app.owner')
                )
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'text-weight--normal' },
            (0, _I18n.translate)('nre.transferModal.failure.text2')
        )
    );
}

exports.default = Failure;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Success() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'p',
            { className: 'margin-top--sm text-weight--normal' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'nre.transferModal.success.text',
                brand: _react2.default.createElement(
                    'span',
                    { className: 'text-secondary' },
                    (0, _I18n.translate)('app.owner')
                )
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'text-weight--normal' },
            (0, _I18n.translate)('nre.transferModal.success.text2')
        )
    );
}

exports.default = Success;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderStateErrorModal = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(OrderStateErrorModal, _PureRenderComponent);

    function OrderStateErrorModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OrderStateErrorModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            loading: true
        }, _this._clearBasket = function () {
            _OrderActions2.default.clearBasket(_OrderStore2.default.getCurrent());
            _this._closeModal();
        }, _this._goToConfirmation = function () {
            _this.props.router.push(_urls2.default.location(_AppConstants.CheckoutStages.PAYMENT_CONFIRMATION));
            _this._closeModal();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    OrderStateErrorModal.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var _this2 = this;

        (0, _defer3.default)(function () {
            var order = _OrderStore2.default.getCurrent();
            _OrderActions2.default.refresh(order).then(function () {
                _this2.setState({ loading: false });
            });
        });
    };

    OrderStateErrorModal.prototype._closeModal = function _closeModal() {
        _ModalActions2.default.close(_AppConstants.GlobalModals.ORDER_STATE_ERROR);
    };

    OrderStateErrorModal.prototype.render = function render() {
        return _react2.default.createElement(
            _BaseModal2.default,
            { className: 'modal--sm',
                titleText: 'order.invalidStateModal.heading',
                onClose: this._clearBasket,
                onContinue: this._goToConfirmation,
                continueText: 'order.invalidStateModal.paymentConfirmation',
                closeText: 'order.invalidStateModal.planJourney',
                disableContinue: this.props.loading },
            _react2.default.createElement(
                'div',
                { className: 'vertical-align-parent full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'confirmation margin-top margin-bottom vertical-align text-center' },
                    _react2.default.createElement(
                        'p',
                        null,
                        (0, _I18n.translate)('order.invalidStateModal.message')
                    )
                )
            )
        );
    };

    return OrderStateErrorModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    router: _propTypes2.default.any.isRequired
}, _temp2);
exports.default = OrderStateErrorModal;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InteropErrorModal = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(InteropErrorModal, _PureRenderComponent);

    function InteropErrorModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, InteropErrorModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            loading: true
        }, _this._clearBasket = function () {
            _OrderActions2.default.clearBasket(_OrderStore2.default.getCurrent());
            _this._closeModal();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    InteropErrorModal.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var _this2 = this;

        (0, _defer3.default)(function () {
            var order = _OrderStore2.default.getCurrent();
            _OrderActions2.default.refresh(order).then(function () {
                _this2.setState({ loading: false });
            });
        });
    };

    InteropErrorModal.prototype._closeModal = function _closeModal() {
        _ModalActions2.default.close(_AppConstants.GlobalModals.INTEROP_ERROR);
    };

    InteropErrorModal.prototype.render = function render() {
        return _react2.default.createElement(
            _BaseModal2.default,
            { className: 'modal--sm',
                titleText: 'order.interopErrorModal.heading',
                onClose: this._clearBasket,
                hideContinue: true
            },
            _react2.default.createElement(
                'div',
                { className: 'vertical-align-parent full-height' },
                _react2.default.createElement(
                    'div',
                    { className: 'b-alert b-alert--danger margin-top margin-bottom vertical-align text-center' },
                    _react2.default.createElement(
                        'p',
                        null,
                        (0, _I18n.translate)('order.interopError.message')
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        (0, _I18n.translate)('order.interopError.messageHelp')
                    )
                )
            )
        );
    };

    return InteropErrorModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    router: _propTypes2.default.any.isRequired
}, _temp2);
exports.default = InteropErrorModal;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AmazonLoginStore = __webpack_require__(352);

var _AmazonLoginStore2 = _interopRequireDefault(_AmazonLoginStore);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _UserChange = __webpack_require__(1089);

var _UserChange2 = _interopRequireDefault(_UserChange);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        amazonEmail: _AmazonLoginStore2.default.getAmazonEmail(),
        user: _UserStore2.default.getCurrent()
    };
}; /* eslint-disable react/prop-types */
/* we can re-enable this when (if) AmazonLogin is ever revived (dead feature) */
/* eslint-disable no-unused-vars */

var AmazonSyncEmailModal = function (_PureComponent) {
    (0, _inherits3.default)(AmazonSyncEmailModal, _PureComponent);

    function AmazonSyncEmailModal() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AmazonSyncEmailModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
            form: new _UserChange2.default(_this.props.user.customer.toJS())
        }, _this.onClose = function () {
            _ModalActions2.default.close();
        }, _this.onContinue = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _this$props, amazonEmail, user, form;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$props = _this.props, amazonEmail = _this$props.amazonEmail, user = _this$props.user;
                            form = _this.state.form;


                            _ModalActions2.default.close();

                            _context.next = 5;
                            return _CustomerActions2.default.updateAuthenticatedProperties({
                                user: user,
                                changes: form.changes,
                                requireAuth: false
                            });

                        case 5:
                            _NotificationActions2.default.showNotification('account.details.updated');

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    AmazonSyncEmailModal.prototype.componentDidUpdate = function componentDidUpdate(_ref2) {
        var prevUser = _ref2.user;
        var _props = this.props,
            amazonEmail = _props.amazonEmail,
            user = _props.user;
        var form = this.state.form;


        if (user && user !== prevUser) {
            this.setState({ form: form.merge({
                    changeEmail: true,
                    email: amazonEmail
                }) });
        }
    };

    AmazonSyncEmailModal.prototype.render = function render() {
        var modalProps = {
            className: 'modal--xs',
            closeText: (0, _I18n2.default)('login.syncEmail.amazon.closeText'),
            continueText: (0, _I18n2.default)('login.syncEmail.amazon.continueText'),
            onClose: this.onClose,
            onContinue: this.onContinue,
            titleText: (0, _I18n2.default)('login.syncEmail.amazon.title')
        };

        var _props2 = this.props,
            amazonEmail = _props2.amazonEmail,
            customer = _props2.customer;


        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'text-center' },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_FormattedHTMLMessage2.default, {
                            message: 'login.syncEmail.amazon.message',
                            accountType: (0, _I18n2.default)('app.owner.short'),
                            amazonEmail: amazonEmail,
                            accountEmail: customer.email })
                    )
                )
            )
        );
    };

    return AmazonSyncEmailModal;
}(_react.PureComponent);

exports.default = (0, _connectToStores2.default)([_AmazonLoginStore2.default, _UserStore2.default], _getStateFromStores)(AmazonSyncEmailModal);

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lib = __webpack_require__(2106);

var _immutable = __webpack_require__(5);

var _PropTypes = __webpack_require__(85);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _PassengerAssistStore = __webpack_require__(173);

var _PassengerAssistStore2 = _interopRequireDefault(_PassengerAssistStore);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

var _AccessibilityCircleIcon = __webpack_require__(439);

var _AssistedTravel = __webpack_require__(675);

var _AssistedTravel2 = _interopRequireDefault(_AssistedTravel);

var _PassengerAssistActions = __webpack_require__(334);

var _PassengerAssistActions2 = _interopRequireDefault(_PassengerAssistActions);

var _utils = __webpack_require__(999);

var _I18n = __webpack_require__(9);

var _usePassengerAssistBookingModal = __webpack_require__(2154);

var _AlertIcon = __webpack_require__(1113);

var _Journey = __webpack_require__(826);

var _Journey2 = _interopRequireDefault(_Journey);

var _Trip = __webpack_require__(199);

var _Trip2 = _interopRequireDefault(_Trip);

var _Radio = __webpack_require__(231);

var _Radio2 = _interopRequireDefault(_Radio);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PassengerAssistBookingModal(props) {
    var onClose = props.onClose,
        onContinue = props.onContinue,
        router = props.router,
        currentJourneyData = props.currentJourneyData;

    var _usePassengerAssistBo = (0, _usePassengerAssistBookingModal.usePassengerAssistBookingModal)({ currentJourneyData: currentJourneyData }),
        journeys = _usePassengerAssistBo.journeys,
        pendingTravelAssistRequests = _usePassengerAssistBo.pendingTravelAssistRequests;

    var passengerAssist = (0, _useStoreState2.default)(_PassengerAssistStore2.default);

    var _useState = (0, _react.useState)([]),
        selectedTrips = _useState[0],
        setSelectedTrips = _useState[1];

    var _useState2 = (0, _react.useState)(''),
        warning = _useState2[0],
        setShowWarning = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        isLoading = _useState3[0],
        setIsLoading = _useState3[1];

    var widgetToggled = passengerAssist.widgetToggled,
        participateImprovementSurvey = passengerAssist.accessibilityProfileForm.participateImprovementSurvey;


    (0, _react.useEffect)(function () {
        if (!widgetToggled) {
            onContinue();
        }
    }, [widgetToggled, onContinue]);

    // Set Passenger Assist trips from selected journeys
    var setPATrips = function setPATrips() {
        if (selectedTrips.length > 0) {
            var combinedSelectedTrips = selectedTrips.map(function (t) {
                var direction = t.direction,
                    tripId = t.tripId;


                var matchingTrip = selectedTrips.find(function (tr) {
                    return tr.tripId === tripId && tr.direction !== direction;
                });

                if (!matchingTrip) {
                    return t;
                }

                var combined = (0, _extends3.default)({}, t, {
                    returnJourney: matchingTrip.returnJourney
                });

                return combined;
            }).filter(function (t) {
                var direction = t.direction,
                    tripId = t.tripId;


                var hasMatchingTrip = !!selectedTrips.find(function (tr) {
                    return tr.tripId === tripId && tr.direction !== direction;
                });

                if (t.direction === 'Return' && hasMatchingTrip) {
                    return false;
                } else {
                    return true;
                }
            });

            var tripsForPassengerAssist = combinedSelectedTrips.map(function (i) {
                var outwardJourney = i.outwardJourney,
                    returnJourney = i.returnJourney,
                    trip = i.trip;


                var outwardEnabled = !(0, _isEmpty3.default)(outwardJourney);
                var returnEnabled = !(0, _isEmpty3.default)(returnJourney);

                var departureTime = outwardEnabled ? outwardJourney.journey.getDepartureDateTime() : returnJourney.journey.getDepartureDateTime();

                var normalisedOutwardJourney = {};
                var normalisedReturnJourney = {};

                var isSingle = trip.isSingle();
                var isOpenReturn = trip.isOpenReturn();

                normalisedOutwardJourney = (0, _utils.normalizeJourney)(outwardEnabled ? outwardJourney.journey : trip.outwardJourney.journey);

                if (!isSingle && !isOpenReturn) {
                    normalisedReturnJourney = (0, _utils.normalizeJourney)(returnEnabled ? returnJourney.journey : trip.returnJourney.journey);
                }

                return new _AssistedTravel2.default({
                    departureDate: departureTime,
                    outwardJourney: normalisedOutwardJourney,
                    returnJourney: normalisedReturnJourney,
                    outwardEnabled: outwardEnabled,
                    returnEnabled: returnEnabled
                });
            });

            _PassengerAssistActions2.default.setPendingTravelAssistRequests(new _immutable.List(tripsForPassengerAssist));
        }
    };

    var renderJourney = function renderJourney(_ref) {
        var trip = _ref.trip,
            journey = _ref.journey,
            _ref$direction = _ref.direction,
            direction = _ref$direction === undefined ? 'Outward' : _ref$direction;

        if (!journey) {
            return null;
        }

        var _getPAModalJourneyDat = (0, _utils.getPAModalJourneyData)(journey),
            origin = _getPAModalJourneyDat.origin,
            destination = _getPAModalJourneyDat.destination,
            departureTime = _getPAModalJourneyDat.departureTime,
            arrivalTime = _getPAModalJourneyDat.arrivalTime;

        var legs = journey.legs || journey.journey.legs;

        var isTripSelected = !!selectedTrips.find(function (t) {
            return t.journey.id === journey.id;
        });

        var updateSelection = function updateSelection() {
            if (isTripSelected) {
                setSelectedTrips(selectedTrips.filter(function (t) {
                    return t.journey.id !== journey.id;
                }));
            } else {
                setShowWarning('');
                setSelectedTrips([].concat(selectedTrips, [{
                    trip: trip,
                    journey: journey,
                    journeyId: journey.id,
                    outwardJourney: direction === 'Outward' ? journey : {},
                    returnJourney: direction === 'Return' ? journey : {},
                    direction: direction
                }]));
            }
        };

        var onChange = function onChange() {
            updateSelection();
        };

        return _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'div',
                { className: 'passenger-assist-trip-summary' },
                _react2.default.createElement(
                    'div',
                    { className: 'passenger-assist-trip-summary__times' },
                    _react2.default.createElement(
                        'div',
                        { className: 'passenger-assist-trip-summary__first-row' },
                        _react2.default.createElement(_Checkbox2.default, {
                            className: 'trip-pa-select-checkbox',
                            label: '',
                            'aria-label': '',
                            onChange: onChange,
                            checked: isTripSelected
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: 'passenger-assist-trip-summary__direction' },
                            _react2.default.createElement(
                                'strong',
                                null,
                                direction === 'Outward' ? 'Outbound' : direction
                            ),
                            ':'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'passenger-assist-trip-summary__date' },
                            departureTime && (0, _TrainTime2.default)(departureTime).format('ddd D MMM YYYY')
                        )
                    )
                ),
                _react2.default.createElement(
                    _lib.Row,
                    null,
                    _react2.default.createElement(
                        _lib.Col,
                        { xs: 8 },
                        _react2.default.createElement(
                            'div',
                            { className: 'passenger-assist-trip-summary__stations' },
                            _react2.default.createElement(
                                'div',
                                { className: 'passenger-assist-trip-summary__origin-info' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'passenger-assist-trip-summary__origin-info__time' },
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        departureTime && departureTime.format('HH:mm')
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'passenger-assist-trip-summary__origin-info__station' },
                                    origin.name
                                )
                            ),
                            _react2.default.createElement('img', { className: 'arrow-icon', src: '/images/arrow-icon.svg', alt: 'Arrow icon' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'passenger-assist-trip-summary__destination-info' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'passenger-assist-trip-summary__destination-info__time' },
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        arrivalTime && arrivalTime.format('HH:mm')
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'passenger-assist-trip-summary__destination-info__station' },
                                    destination.name
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _lib.Col,
                        { xs: 4 },
                        _react2.default.createElement(
                            'div',
                            { className: 'passenger-assist-trip-summary__leg-info' },
                            legs && legs.size > 1 ? _react2.default.createElement(
                                'span',
                                { className: 'passenger-assist-trip-summary__badge passenger-assist-trip-summary__badge--multileg' },
                                (0, _I18n.translate)('account.passenger-assist.book-passenger-assist.multi-leg')
                            ) : _react2.default.createElement(
                                'span',
                                { className: 'passenger-assist-trip-summary__badge passenger-assist-trip-summary__badge--direct' },
                                (0, _I18n.translate)('account.passenger-assist.book-passenger-assist.direct')
                            )
                        )
                    )
                )
            )
        );
    };

    var renderPassengerAssistRequest = function renderPassengerAssistRequest(req) {
        var outwardJourney = req.outwardJourney,
            returnJourney = req.returnJourney;


        var data = [{ journey: outwardJourney, direction: 'Outward' }, { journey: returnJourney, direction: 'Return' }];

        return data.map(function (j) {
            var direction = j.direction,
                journey = j.journey;


            if ((0, _isEmpty3.default)(journey)) {
                return null;
            }

            var arrivalHour = journey.arrivalHour,
                arrivalMinutes = journey.arrivalMinutes;


            var onChange = function onChange() {
                _PassengerAssistActions2.default.setPendingTravelAssistRequestEnabled({
                    orderTripId: req.orderTripId,
                    enabled: direction === 'Outward' ? !req.outwardEnabled : !req.returnEnabled,
                    direction: direction
                });
            };

            var outwardEnabled = req.outwardEnabled,
                returnEnabled = req.returnEnabled;


            var legs = direction === 'Outward' ? req.outwardJourney.legs : req.returnJourney.legs;

            var checked = direction === 'Outward' ? outwardEnabled : returnEnabled;

            return _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'passenger-assist-trip-summary' },
                    _react2.default.createElement(
                        'div',
                        { className: 'passenger-assist-trip-summary__times' },
                        _react2.default.createElement(
                            'div',
                            { className: 'passenger-assist-trip-summary__first-row' },
                            _react2.default.createElement(_Checkbox2.default, {
                                className: 'trip-pa-select-checkbox',
                                label: '',
                                'aria-label': '',
                                onChange: onChange,
                                checked: checked
                            }),
                            _react2.default.createElement(
                                'span',
                                { className: 'passenger-assist-trip-summary__direction' },
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    direction === 'Outward' ? 'Outbound' : direction
                                ),
                                ':'
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'passenger-assist-trip-summary__date' },
                                (0, _moment2.default)(direction === 'Outward' ? req.outwardJourney.departureDate : req.returnJourney.departureDate, 'DD/MM/YYYY').format('ddd D MMM YYYY')
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _lib.Row,
                        null,
                        _react2.default.createElement(
                            _lib.Col,
                            { xs: 8 },
                            _react2.default.createElement(
                                'div',
                                { className: 'passenger-assist-trip-summary__stations' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'passenger-assist-trip-summary__origin-info' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'passenger-assist-trip-summary__origin-info__time' },
                                        _react2.default.createElement(
                                            'strong',
                                            null,
                                            direction === 'Outward' ? req.outwardJourney.departureHour + ":" + req.outwardJourney.departureMinutes : req.returnJourney.departureHour + ":" + req.returnJourney.departureMinutes
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'passenger-assist-trip-summary__origin-info__station' },
                                        direction === 'Outward' ? req.outwardJourney.origin.name : req.returnJourney.origin.name
                                    )
                                ),
                                _react2.default.createElement('img', { className: 'arrow-icon', src: '/images/arrow-icon.svg', alt: 'Arrow icon' }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'passenger-assist-trip-summary__destination-info' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'passenger-assist-trip-summary__destination-info__time' },
                                        _react2.default.createElement(
                                            'strong',
                                            null,
                                            arrivalHour + ':' + arrivalMinutes
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'passenger-assist-trip-summary__destination-info__station' },
                                        direction === 'Outward' ? req.outwardJourney.destination.name : req.returnJourney.destination.name
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _lib.Col,
                            { xs: 4 },
                            _react2.default.createElement(
                                'div',
                                { className: 'passenger-assist-trip-summary__leg-info' },
                                legs && legs.length > 1 ? _react2.default.createElement(
                                    'span',
                                    { className: 'passenger-assist-trip-summary__badge passenger-assist-trip-summary__badge--multileg' },
                                    (0, _I18n.translate)('account.passenger-assist.book-passenger-assist.multi-leg')
                                ) : _react2.default.createElement(
                                    'span',
                                    { className: 'passenger-assist-trip-summary__badge passenger-assist-trip-summary__badge--direct' },
                                    (0, _I18n.translate)('account.passenger-assist.book-passenger-assist.direct')
                                )
                            )
                        )
                    )
                )
            );
        });
    };

    var viewAccessibilityProfile = function viewAccessibilityProfile() {
        onClose();
        _PassengerAssistActions2.default.setShowBackToSearchResultsButton(true);
        router.push(_urls2.default.location(_AppConstants.AccountPages.ACCESSIBILITY_PROFILE));
    };

    if (!widgetToggled) {
        return null;
    }

    var onSubmit = function onSubmit() {
        if (isLoading) {
            return false;
        }

        var enabledReqs = pendingTravelAssistRequests.filter(function (r) {
            return r.outwardEnabled || r.returnEnabled;
        });

        if (!selectedTrips.length && enabledReqs.size < 1) {
            setShowWarning((0, _I18n.translate)('passenger-assist.modal.no-trips.warning'));
            return false;
        }

        if (typeof participateImprovementSurvey !== 'boolean') {
            setShowWarning((0, _I18n.translate)('passenger-assist.modal.no-contact-answer.warning'));
            return false;
        }

        _PassengerAssistActions2.default.setAccessibilityProfileForm({ participateImprovementSurvey: participateImprovementSurvey });

        setIsLoading(true);

        setPATrips(selectedTrips);

        onContinue();

        return true;
    };

    var onChangeParticipateImprovementSurvey = function onChangeParticipateImprovementSurvey(value) {
        return function () {
            _PassengerAssistActions2.default.setAccessibilityProfileForm({
                participateImprovementSurvey: value
            });
            setShowWarning('');
        };
    };

    var modalProps = (0, _extends3.default)({}, props, {
        onContinue: onSubmit
    });

    return _react2.default.createElement(
        _BaseModal2.default,
        (0, _extends3.default)({ className: 'modal--xs passenger-assist-booking-modal' }, modalProps),
        isLoading ? _react2.default.createElement(_Loading2.default, { className: 'margin-top', unwrapped: true, standalone: true }) : _react2.default.createElement(
            'form',
            null,
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'section',
                    null,
                    _react2.default.createElement(
                        _lib.Row,
                        null,
                        _react2.default.createElement(
                            _lib.Col,
                            { xs: 12 },
                            _react2.default.createElement(
                                _lib.Row,
                                null,
                                _react2.default.createElement(
                                    _lib.Col,
                                    { xs: 1 },
                                    _react2.default.createElement(_AccessibilityCircleIcon.AccessibilityCircleIcon, null)
                                ),
                                _react2.default.createElement(
                                    _lib.Col,
                                    { xs: 11 },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            _lib.Button,
                                            {
                                                bsStyle: 'link',
                                                className: 'view-accessibility-profile',
                                                onClick: viewAccessibilityProfile,
                                                'aria-label': 'View accessibility profile'
                                            },
                                            (0, _I18n.translate)('account.passenger-assist.view-profile')
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            (0, _I18n.translate)('passenger-assist.modal.text')
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'passenger-assist-trip-summary-list' },
                                journeys.map(renderJourney),
                                pendingTravelAssistRequests.map(renderPassengerAssistRequest)
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _lib.Row,
                    null,
                    _react2.default.createElement(
                        _lib.Col,
                        { xs: 12 },
                        _react2.default.createElement(
                            'h3',
                            { className: 'label', id: 'contact-preferences-question' },
                            (0, _I18n.translate)('account.passenger-assist.accessibility-profile.form.contact-preferences.question.3')
                        ),
                        _react2.default.createElement(_Radio2.default, {
                            radioClass: 'regular-radio',
                            name: (0, _I18n.translate)('account.passenger-assist.accessibility-profile.form.contact-preferences.question.3') + '-' + (0, _I18n.translate)('account.passenger-assist.accessibility-profile.form.contact-preferences.answer.yes'),
                            label: (0, _I18n.translate)('account.passenger-assist.accessibility-profile.form.contact-preferences.answer.yes'),
                            'aria-labelledby': 'contact-preferences-question',
                            checked: participateImprovementSurvey,
                            onChange: onChangeParticipateImprovementSurvey(true)
                        }),
                        _react2.default.createElement(_Radio2.default, {
                            radioClass: 'regular-radio',
                            name: (0, _I18n.translate)('account.passenger-assist.accessibility-profile.form.contact-preferences.question.3') + '-' + (0, _I18n.translate)('account.passenger-assist.accessibility-profile.form.contact-preferences.answer.no'),
                            label: (0, _I18n.translate)('account.passenger-assist.accessibility-profile.form.contact-preferences.answer.no'),
                            'aria-labelledby': 'contact-preferences-question',
                            checked: participateImprovementSurvey === false,
                            onChange: onChangeParticipateImprovementSurvey(false)
                        })
                    )
                ),
                warning && _react2.default.createElement(
                    _lib.Row,
                    null,
                    _react2.default.createElement(
                        _lib.Col,
                        { xs: 12, className: 'pa-assist__message--container margin-top--sm' },
                        _react2.default.createElement(_AlertIcon.AlertIcon, { className: 'pa-assist__icon' }),
                        _react2.default.createElement(
                            'p',
                            { className: 'pa-assist__message pa-assist__message-warning' },
                            warning
                        )
                    )
                )
            )
        )
    );
}

PassengerAssistBookingModal.propTypes = {
    onClose: _propTypes2.default.func,
    onContinue: _propTypes2.default.func,
    router: _PropTypes.routerShape,
    trip: _propTypes2.default.instanceOf(_Trip2.default),
    journey: _propTypes2.default.instanceOf(_Journey2.default),
    currentJourneyData: _propTypes2.default.instanceOf(_Journey2.default),
    direction: _propTypes2.default.oneOf(['Outward', 'Return'])
};

exports.default = PassengerAssistBookingModal;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.utils = void 0;

var _Accordion2 = _interopRequireDefault(__webpack_require__(1049));

exports.Accordion = _Accordion2.default;

var _Alert2 = _interopRequireDefault(__webpack_require__(2107));

exports.Alert = _Alert2.default;

var _Badge2 = _interopRequireDefault(__webpack_require__(908));

exports.Badge = _Badge2.default;

var _Breadcrumb2 = _interopRequireDefault(__webpack_require__(2108));

exports.Breadcrumb = _Breadcrumb2.default;

var _BreadcrumbItem2 = _interopRequireDefault(__webpack_require__(947));

exports.BreadcrumbItem = _BreadcrumbItem2.default;

var _Button2 = _interopRequireDefault(__webpack_require__(45));

exports.Button = _Button2.default;

var _ButtonGroup2 = _interopRequireDefault(__webpack_require__(589));

exports.ButtonGroup = _ButtonGroup2.default;

var _ButtonToolbar2 = _interopRequireDefault(__webpack_require__(2109));

exports.ButtonToolbar = _ButtonToolbar2.default;

var _Carousel2 = _interopRequireDefault(__webpack_require__(2110));

exports.Carousel = _Carousel2.default;

var _CarouselItem2 = _interopRequireDefault(__webpack_require__(948));

exports.CarouselItem = _CarouselItem2.default;

var _Checkbox2 = _interopRequireDefault(__webpack_require__(923));

exports.Checkbox = _Checkbox2.default;

var _Clearfix2 = _interopRequireDefault(__webpack_require__(2112));

exports.Clearfix = _Clearfix2.default;

var _CloseButton2 = _interopRequireDefault(__webpack_require__(571));

exports.CloseButton = _CloseButton2.default;

var _ControlLabel2 = _interopRequireDefault(__webpack_require__(461));

exports.ControlLabel = _ControlLabel2.default;

var _Col2 = _interopRequireDefault(__webpack_require__(33));

exports.Col = _Col2.default;

var _Collapse2 = _interopRequireDefault(__webpack_require__(347));

exports.Collapse = _Collapse2.default;

var _Dropdown2 = _interopRequireDefault(__webpack_require__(415));

exports.Dropdown = _Dropdown2.default;

var _DropdownButton2 = _interopRequireDefault(__webpack_require__(2114));

exports.DropdownButton = _DropdownButton2.default;

var _Fade2 = _interopRequireDefault(__webpack_require__(405));

exports.Fade = _Fade2.default;

var _Form2 = _interopRequireDefault(__webpack_require__(2115));

exports.Form = _Form2.default;

var _FormControl2 = _interopRequireDefault(__webpack_require__(178));

exports.FormControl = _FormControl2.default;

var _FormGroup2 = _interopRequireDefault(__webpack_require__(611));

exports.FormGroup = _FormGroup2.default;

var _Glyphicon2 = _interopRequireDefault(__webpack_require__(587));

exports.Glyphicon = _Glyphicon2.default;

var _Grid2 = _interopRequireDefault(__webpack_require__(428));

exports.Grid = _Grid2.default;

var _HelpBlock2 = _interopRequireDefault(__webpack_require__(2116));

exports.HelpBlock = _HelpBlock2.default;

var _Image2 = _interopRequireDefault(__webpack_require__(2117));

exports.Image = _Image2.default;

var _InputGroup2 = _interopRequireDefault(__webpack_require__(2118));

exports.InputGroup = _InputGroup2.default;

var _Jumbotron2 = _interopRequireDefault(__webpack_require__(2121));

exports.Jumbotron = _Jumbotron2.default;

var _Label2 = _interopRequireDefault(__webpack_require__(2122));

exports.Label = _Label2.default;

var _ListGroup2 = _interopRequireDefault(__webpack_require__(2123));

exports.ListGroup = _ListGroup2.default;

var _ListGroupItem2 = _interopRequireDefault(__webpack_require__(950));

exports.ListGroupItem = _ListGroupItem2.default;

var _Media2 = _interopRequireDefault(__webpack_require__(416));

exports.Media = _Media2.default;

var _MenuItem2 = _interopRequireDefault(__webpack_require__(2130));

exports.MenuItem = _MenuItem2.default;

var _Modal2 = _interopRequireDefault(__webpack_require__(547));

exports.Modal = _Modal2.default;

var _ModalBody2 = _interopRequireDefault(__webpack_require__(868));

exports.ModalBody = _ModalBody2.default;

var _ModalDialog2 = _interopRequireDefault(__webpack_require__(870));

exports.ModalDialog = _ModalDialog2.default;

var _ModalFooter2 = _interopRequireDefault(__webpack_require__(871));

exports.ModalFooter = _ModalFooter2.default;

var _ModalHeader2 = _interopRequireDefault(__webpack_require__(872));

exports.ModalHeader = _ModalHeader2.default;

var _ModalTitle2 = _interopRequireDefault(__webpack_require__(873));

exports.ModalTitle = _ModalTitle2.default;

var _Nav2 = _interopRequireDefault(__webpack_require__(683));

exports.Nav = _Nav2.default;

var _Navbar2 = _interopRequireDefault(__webpack_require__(2131));

exports.Navbar = _Navbar2.default;

var _NavbarBrand2 = _interopRequireDefault(__webpack_require__(951));

exports.NavbarBrand = _NavbarBrand2.default;

var _NavDropdown2 = _interopRequireDefault(__webpack_require__(2135));

exports.NavDropdown = _NavDropdown2.default;

var _NavItem2 = _interopRequireDefault(__webpack_require__(684));

exports.NavItem = _NavItem2.default;

var _Overlay2 = _interopRequireDefault(__webpack_require__(952));

exports.Overlay = _Overlay2.default;

var _OverlayTrigger2 = _interopRequireDefault(__webpack_require__(2136));

exports.OverlayTrigger = _OverlayTrigger2.default;

var _PageHeader2 = _interopRequireDefault(__webpack_require__(2137));

exports.PageHeader = _PageHeader2.default;

var _PageItem2 = _interopRequireDefault(__webpack_require__(2138));

exports.PageItem = _PageItem2.default;

var _Pager2 = _interopRequireDefault(__webpack_require__(2140));

exports.Pager = _Pager2.default;

var _Pagination2 = _interopRequireDefault(__webpack_require__(1050));

exports.Pagination = _Pagination2.default;

var _Panel2 = _interopRequireDefault(__webpack_require__(1051));

exports.Panel = _Panel2.default;

var _PanelGroup2 = _interopRequireDefault(__webpack_require__(945));

exports.PanelGroup = _PanelGroup2.default;

var _Popover2 = _interopRequireDefault(__webpack_require__(2146));

exports.Popover = _Popover2.default;

var _ProgressBar2 = _interopRequireDefault(__webpack_require__(1091));

exports.ProgressBar = _ProgressBar2.default;

var _Radio2 = _interopRequireDefault(__webpack_require__(924));

exports.Radio = _Radio2.default;

var _ResponsiveEmbed2 = _interopRequireDefault(__webpack_require__(2147));

exports.ResponsiveEmbed = _ResponsiveEmbed2.default;

var _Row2 = _interopRequireDefault(__webpack_require__(41));

exports.Row = _Row2.default;

var _SafeAnchor2 = _interopRequireDefault(__webpack_require__(141));

exports.SafeAnchor = _SafeAnchor2.default;

var _SplitButton2 = _interopRequireDefault(__webpack_require__(2148));

exports.SplitButton = _SplitButton2.default;

var _Tab2 = _interopRequireDefault(__webpack_require__(1178));

exports.Tab = _Tab2.default;

var _TabContainer2 = _interopRequireDefault(__webpack_require__(590));

exports.TabContainer = _TabContainer2.default;

var _TabContent2 = _interopRequireDefault(__webpack_require__(591));

exports.TabContent = _TabContent2.default;

var _Table2 = _interopRequireDefault(__webpack_require__(2150));

exports.Table = _Table2.default;

var _TabPane2 = _interopRequireDefault(__webpack_require__(956));

exports.TabPane = _TabPane2.default;

var _Tabs2 = _interopRequireDefault(__webpack_require__(1179));

exports.Tabs = _Tabs2.default;

var _Thumbnail2 = _interopRequireDefault(__webpack_require__(2151));

exports.Thumbnail = _Thumbnail2.default;

var _ToggleButton2 = _interopRequireDefault(__webpack_require__(685));

exports.ToggleButton = _ToggleButton2.default;

var _ToggleButtonGroup2 = _interopRequireDefault(__webpack_require__(1180));

exports.ToggleButtonGroup = _ToggleButtonGroup2.default;

var _Tooltip2 = _interopRequireDefault(__webpack_require__(2152));

exports.Tooltip = _Tooltip2.default;

var _Well2 = _interopRequireDefault(__webpack_require__(1181));

exports.Well = _Well2.default;

var _utils = _interopRequireWildcard(__webpack_require__(2153));

exports.utils = _utils;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _values = _interopRequireDefault(__webpack_require__(125));

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var _CloseButton = _interopRequireDefault(__webpack_require__(571));

var propTypes = {
  onDismiss: _propTypes.default.func,
  closeLabel: _propTypes.default.string
};
var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Alert, _React$Component);

  function Alert() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        onDismiss = _this$props.onDismiss,
        closeLabel = _this$props.closeLabel,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onDismiss", "closeLabel", "className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
      role: "alert",
      className: (0, _classnames.default)(className, classes)
    }), dismissable && _react.default.createElement(_CloseButton.default, {
      onClick: onDismiss,
      label: closeLabel
    }), children);
  };

  return Alert;
}(_react.default.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(947));

var _bootstrapUtils = __webpack_require__(21);

var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Breadcrumb, _React$Component);

  function Breadcrumb() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Breadcrumb.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("ol", (0, _extends2.default)({}, elementProps, {
      role: "navigation",
      "aria-label": "breadcrumbs",
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Breadcrumb;
}(_react.default.Component);

Breadcrumb.Item = _BreadcrumbItem.default;

var _default = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var ButtonToolbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonToolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      role: "toolbar",
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return ButtonToolbar;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _CarouselCaption = _interopRequireDefault(__webpack_require__(2111));

var _CarouselItem = _interopRequireDefault(__webpack_require__(948));

var _Glyphicon = _interopRequireDefault(__webpack_require__(587));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var _bootstrapUtils = __webpack_require__(21);

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

// TODO: `slide` should be `animate`.
// TODO: Use uncontrollable.
var propTypes = {
  slide: _propTypes.default.bool,
  indicators: _propTypes.default.bool,

  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: _propTypes.default.number,
  controls: _propTypes.default.bool,
  pauseOnHover: _propTypes.default.bool,
  wrap: _propTypes.default.bool,

  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: _propTypes.default.func,
  onSlideEnd: _propTypes.default.func,
  activeIndex: _propTypes.default.number,
  defaultActiveIndex: _propTypes.default.number,
  direction: _propTypes.default.oneOf(['prev', 'next']),
  prevIcon: _propTypes.default.node,

  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: _propTypes.default.string,
  nextIcon: _propTypes.default.node,

  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: _propTypes.default.string
};
var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: _react.default.createElement(_Glyphicon.default, {
    glyph: "chevron-left"
  }),
  prevLabel: 'Previous',
  nextIcon: _react.default.createElement(_Glyphicon.default, {
    glyph: "chevron-right"
  }),
  nextLabel: 'Next'
};

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Carousel, _React$Component);

  function Carousel(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleMouseOver = _this.handleMouseOver.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleMouseOut = _this.handleMouseOut.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handlePrev = _this.handlePrev.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleNext = _this.handleNext.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    var defaultActiveIndex = props.defaultActiveIndex;
    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);
      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  _proto.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  _proto.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  _proto.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  _proto.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  _proto.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;

    var count = _ValidComponentChildren.default.count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }

      index = 0;
    }

    this.select(index, e, 'next');
  };

  _proto.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }

      index = _ValidComponentChildren.default.count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  }; // This might be a public API.


  _proto.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  }; // This might be a public API.


  _proto.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  _proto.select = function select(index, e, direction) {
    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.

    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);
    var onSelect = this.props.onSelect;

    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = {
            direction: direction
          };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  _proto.waitForNext = function waitForNext() {
    var _this$props = this.props,
        slide = _this$props.slide,
        interval = _this$props.interval,
        activeIndexProp = _this$props.activeIndex;

    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  _proto.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;
    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');

    var count = _ValidComponentChildren.default.count(children);

    return [(wrap || activeIndex !== 0) && _react.default.createElement(_SafeAnchor.default, {
      key: "prev",
      className: (0, _classnames.default)(controlClassName, 'left'),
      onClick: this.handlePrev
    }, prevIcon, prevLabel && _react.default.createElement("span", {
      className: "sr-only"
    }, prevLabel)), (wrap || activeIndex !== count - 1) && _react.default.createElement(_SafeAnchor.default, {
      key: "next",
      className: (0, _classnames.default)(controlClassName, 'right'),
      onClick: this.handleNext
    }, nextIcon, nextLabel && _react.default.createElement("span", {
      className: "sr-only"
    }, nextLabel))];
  };

  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    _ValidComponentChildren.default.forEach(children, function (child, index) {
      indicators.push(_react.default.createElement("li", {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }), // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return _react.default.createElement("ol", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators')
    }, indicators);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props2 = this.props,
        slide = _this$props2.slide,
        indicators = _this$props2.indicators,
        controls = _this$props2.controls,
        wrap = _this$props2.wrap,
        prevIcon = _this$props2.prevIcon,
        prevLabel = _this$props2.prevLabel,
        nextIcon = _this$props2.nextIcon,
        nextLabel = _this$props2.nextLabel,
        className = _this$props2.className,
        children = _this$props2.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);
    var _this$state = this.state,
        previousActiveIndex = _this$state.previousActiveIndex,
        direction = _this$state.direction;

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();
    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      slide: slide
    });
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes),
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut
    }), indicators && this.renderIndicators(children, activeIndex, bsProps), _react.default.createElement("div", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'inner')
    }, _ValidComponentChildren.default.map(children, function (child, index) {
      var active = index === activeIndex;
      var previousActive = slide && index === previousActiveIndex;
      return (0, _react.cloneElement)(child, {
        active: active,
        index: index,
        animateOut: previousActive,
        animateIn: active && previousActiveIndex != null && slide,
        direction: direction,
        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
      });
    })), controls && this.renderControls({
      wrap: wrap,
      children: children,
      activeIndex: activeIndex,
      prevIcon: prevIcon,
      prevLabel: prevLabel,
      nextIcon: nextIcon,
      nextLabel: nextLabel,
      bsProps: bsProps
    }));
  };

  return Carousel;
}(_react.default.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
Carousel.Caption = _CarouselCaption.default;
Carousel.Item = _CarouselItem.default;

var _default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(CarouselCaption, _React$Component);

  function CarouselCaption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CarouselCaption.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return CarouselCaption;
}(_react.default.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var _capitalize = _interopRequireDefault(__webpack_require__(941));

var _StyleConfig = __webpack_require__(90);

var propTypes = {
  componentClass: _elementType.default,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: _propTypes.default.bool,

  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: _propTypes.default.bool,

  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: _propTypes.default.bool,

  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: _propTypes.default.bool
};
var defaultProps = {
  componentClass: 'div'
};

var Clearfix =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Clearfix, _React$Component);

  function Clearfix() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Clearfix.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
      var propName = "visible" + (0, _capitalize.default)(size) + "Block";

      if (elementProps[propName]) {
        classes["visible-" + size + "-block"] = true;
      }

      delete elementProps[propName];
    });

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Clearfix;
}(_react.default.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _from = _interopRequireDefault(__webpack_require__(912));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _keycode = _interopRequireDefault(__webpack_require__(267));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _RootCloseWrapper = _interopRequireDefault(__webpack_require__(586));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var propTypes = {
  open: _propTypes.default.bool,
  pullRight: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  labelledBy: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onSelect: _propTypes.default.func,
  rootCloseEvent: _propTypes.default.oneOf(['click', 'mousedown'])
};
var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleRootClose = _this.handleRootClose.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = _reactDom.default.findDOMNode(this);

    if (!node) {
      return [];
    }

    return (0, _from.default)(node.querySelectorAll('[tabIndex="-1"]'));
  };

  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);
    return {
      items: items,
      activeIndex: activeIndex
    };
  };

  _proto.focusNext = function focusNext() {
    var _this$getItemsAndActi = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi.items,
        activeIndex = _this$getItemsAndActi.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  _proto.focusPrevious = function focusPrevious() {
    var _this$getItemsAndActi2 = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi2.items,
        activeIndex = _this$getItemsAndActi2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case _keycode.default.codes.down:
        this.focusNext();
        event.preventDefault();
        break;

      case _keycode.default.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;

      case _keycode.default.codes.esc:
      case _keycode.default.codes.tab:
        this.props.onClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, {
      source: 'rootClose'
    });
  };

  _proto.render = function render() {
    var _extends2,
        _this2 = this;

    var _this$props = this.props,
        open = _this$props.open,
        pullRight = _this$props.pullRight,
        labelledBy = _this$props.labelledBy,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
    return _react.default.createElement(_RootCloseWrapper.default, {
      disabled: !open,
      onRootClose: this.handleRootClose,
      event: rootCloseEvent
    }, _react.default.createElement("ul", (0, _extends3.default)({}, elementProps, {
      role: "menu",
      className: (0, _classnames.default)(className, classes),
      "aria-labelledby": labelledBy
    }), _ValidComponentChildren.default.map(children, function (child) {
      return _react.default.cloneElement(child, {
        onKeyDown: (0, _createChainedFunction.default)(child.props.onKeyDown, _this2.handleKeyDown),
        onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect)
      });
    })));
  };

  return DropdownMenu;
}(_react.default.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Dropdown = _interopRequireDefault(__webpack_require__(415));

var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(410));

var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
  // Toggle props.
  bsStyle: _propTypes.default.string,
  bsSize: _propTypes.default.string,
  title: _propTypes.default.node.isRequired,
  noCaret: _propTypes.default.bool,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: _propTypes.default.node
});

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DropdownButton, _React$Component);

  function DropdownButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["bsSize", "bsStyle", "title", "children"]);

    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), _react.default.createElement(_Dropdown.default.Toggle, (0, _extends2.default)({}, toggleProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), _react.default.createElement(_Dropdown.default.Menu, null, children));
  };

  return DropdownButton;
}(_react.default.Component);

DropdownButton.propTypes = propTypes;
var _default = DropdownButton;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  horizontal: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  componentClass: _elementType.default
};
var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Form, _React$Component);

  function Form() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        horizontal = _this$props.horizontal,
        inline = _this$props.inline,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["horizontal", "inline", "componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    if (horizontal) {
      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
    }

    if (inline) {
      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Form;
}(_react.default.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('form', Form);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var HelpBlock =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(HelpBlock, _React$Component);

  function HelpBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HelpBlock.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return HelpBlock;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: _propTypes.default.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: _propTypes.default.bool,

  /**
   * Sets image shape as circle
   */
  circle: _propTypes.default.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: _propTypes.default.bool
};
var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Image, _React$Component);

  function Image() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _classes;

    var _this$props = this.props,
        responsive = _this$props.responsive,
        rounded = _this$props.rounded,
        circle = _this$props.circle,
        thumbnail = _this$props.thumbnail,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["responsive", "rounded", "circle", "thumbnail", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
    return _react.default.createElement("img", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Image;
}(_react.default.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('img', Image);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _InputGroupAddon = _interopRequireDefault(__webpack_require__(2119));

var _InputGroupButton = _interopRequireDefault(__webpack_require__(2120));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var InputGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(InputGroup, _React$Component);

  function InputGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return InputGroup;
}(_react.default.Component);

InputGroup.Addon = _InputGroupAddon.default;
InputGroup.Button = _InputGroupButton.default;

var _default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var InputGroupAddon =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupAddon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return InputGroupAddon;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var InputGroupButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(InputGroupButton, _React$Component);

  function InputGroupButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return InputGroupButton;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};

var Jumbotron =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Jumbotron, _React$Component);

  function Jumbotron() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Jumbotron.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return Jumbotron;
}(_react.default.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _values = _interopRequireDefault(__webpack_require__(125));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var Label =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Label, _React$Component);

  function Label() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;

    _react.default.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends2.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });
    return _react.default.createElement("span", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), children);
  };

  return Label;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)((0, _values.default)(_StyleConfig.State).concat([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _ListGroupItem = _interopRequireDefault(__webpack_require__(950));

var _bootstrapUtils = __webpack_require__(21);

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: _elementType.default
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (_ValidComponentChildren.default.some(children, function (child) {
    return child.type !== _ListGroupItem.default || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$component = _this$props.componentClass,
        Component = _this$props$component === void 0 ? getDefaultComponent(children) : _this$props$component,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    var useListItem = Component === 'ul' && _ValidComponentChildren.default.every(children, function (child) {
      return child.type === _ListGroupItem.default;
    });

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), useListItem ? _ValidComponentChildren.default.map(children, function (child) {
      return (0, _react.cloneElement)(child, {
        listItem: true
      });
    }) : children);
  };

  return ListGroup;
}(_react.default.Component);

ListGroup.propTypes = propTypes;

var _default = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _Media = _interopRequireDefault(__webpack_require__(416));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: _propTypes.default.oneOf(['top', 'middle', 'bottom']),
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};

var MediaBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MediaBody, _React$Component);

  function MediaBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        align = _this$props.align,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "align", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return MediaBody;
}(_react.default.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MediaHeading, _React$Component);

  function MediaHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["componentClass", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return MediaHeading;
}(_react.default.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Media = _interopRequireDefault(__webpack_require__(416));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: _propTypes.default.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MediaLeft, _React$Component);

  function MediaLeft() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaLeft.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["align", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
    }

    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return MediaLeft;
}(_react.default.Component);

MediaLeft.propTypes = propTypes;

var _default = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var MediaList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MediaList, _React$Component);

  function MediaList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return MediaList;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var MediaListItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MediaListItem, _React$Component);

  function MediaListItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return MediaListItem;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('media', MediaListItem);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Media = _interopRequireDefault(__webpack_require__(416));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: _propTypes.default.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MediaRight, _React$Component);

  function MediaRight() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaRight.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["align", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[(0, _bootstrapUtils.prefix)(_Media.default.defaultProps, align)] = true;
    }

    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return MediaRight;
}(_react.default.Component);

MediaRight.propTypes = propTypes;

var _default = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _all = _interopRequireDefault(__webpack_require__(196));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: _propTypes.default.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: _propTypes.default.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: (0, _all.default)(_propTypes.default.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: _propTypes.default.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: _propTypes.default.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: _propTypes.default.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: _propTypes.default.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: _propTypes.default.func
};
var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MenuItem, _React$Component);

  function MenuItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        href = _this$props.href,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        disabled = _this$props2.disabled,
        divider = _this$props2.divider,
        header = _this$props2.header,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;
      return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
        role: "separator",
        className: (0, _classnames.default)(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return _react.default.createElement("li", (0, _extends2.default)({}, elementProps, {
        role: "heading",
        className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
        style: style
      }));
    }

    return _react.default.createElement("li", {
      role: "presentation",
      className: (0, _classnames.default)(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, elementProps, {
      role: "menuitem",
      tabIndex: "-1",
      onClick: (0, _createChainedFunction.default)(onClick, this.handleClick)
    })));
  };

  return MenuItem;
}(_react.default.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(26));

var _uncontrollable = _interopRequireDefault(__webpack_require__(106));

var _Grid = _interopRequireDefault(__webpack_require__(428));

var _NavbarBrand = _interopRequireDefault(__webpack_require__(951));

var _NavbarCollapse = _interopRequireDefault(__webpack_require__(2132));

var _NavbarHeader = _interopRequireDefault(__webpack_require__(2133));

var _NavbarToggle = _interopRequireDefault(__webpack_require__(2134));

var _bootstrapUtils = __webpack_require__(21);

var _StyleConfig = __webpack_require__(90);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

// TODO: Remove this pragma once we upgrade eslint-config-airbnb.

/* eslint-disable react/no-multi-comp */
var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: _propTypes.default.bool,

  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: _propTypes.default.bool,

  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: _propTypes.default.bool,

  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: _propTypes.default.bool,

  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: _propTypes.default.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: _elementType.default,

  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: _propTypes.default.func,

  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: _propTypes.default.func,

  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: _propTypes.default.bool,

  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: _propTypes.default.bool,
  role: _propTypes.default.string
};
var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};
var childContextTypes = {
  $bs_navbar: _propTypes.default.shape({
    bsClass: _propTypes.default.string,
    expanded: _propTypes.default.bool,
    onToggle: _propTypes.default.func.isRequired,
    onSelect: _propTypes.default.func
  })
};

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Navbar, _React$Component);

  function Navbar(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleCollapse = _this.handleCollapse.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        expanded = _this$props.expanded,
        onSelect = _this$props.onSelect,
        collapseOnSelect = _this$props.collapseOnSelect;
    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: (0, _createChainedFunction.default)(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  _proto.handleCollapse = function handleCollapse() {
    var _this$props2 = this.props,
        onToggle = _this$props2.onToggle,
        expanded = _this$props2.expanded;

    if (expanded) {
      onToggle(false);
    }
  };

  _proto.handleToggle = function handleToggle() {
    var _this$props3 = this.props,
        onToggle = _this$props3.onToggle,
        expanded = _this$props3.expanded;
    onToggle(!expanded);
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props4 = this.props,
        Component = _this$props4.componentClass,
        fixedTop = _this$props4.fixedTop,
        fixedBottom = _this$props4.fixedBottom,
        staticTop = _this$props4.staticTop,
        inverse = _this$props4.inverse,
        fluid = _this$props4.fluid,
        className = _this$props4.className,
        children = _this$props4.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
    }

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
    return _react.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), _react.default.createElement(_Grid.default, {
      fluid: fluid
    }, children));
  };

  return Navbar;
}(_react.default.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;
(0, _bootstrapUtils.bsClass)('navbar', Navbar);
var UncontrollableNavbar = (0, _uncontrollable.default)(Navbar, {
  expanded: 'onToggle'
});

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === void 0 ? {
      bsClass: 'navbar'
    } : _ref2$$bs_navbar;
    return _react.default.createElement(Component, (0, _extends3.default)({}, props, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;
  Wrapper.propTypes = {
    componentClass: _elementType.default,
    pullRight: _propTypes.default.bool,
    pullLeft: _propTypes.default.bool
  };
  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };
  Wrapper.contextTypes = {
    $bs_navbar: _propTypes.default.shape({
      bsClass: _propTypes.default.string
    })
  };
  return Wrapper;
}

UncontrollableNavbar.Brand = _NavbarBrand.default;
UncontrollableNavbar.Header = _NavbarHeader.default;
UncontrollableNavbar.Toggle = _NavbarToggle.default;
UncontrollableNavbar.Collapse = _NavbarCollapse.default;
UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.

var _default = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Collapse = _interopRequireDefault(__webpack_require__(347));

var _bootstrapUtils = __webpack_require__(21);

var contextTypes = {
  $bs_navbar: _propTypes.default.shape({
    bsClass: _propTypes.default.string,
    expanded: _propTypes.default.bool
  })
};

var NavbarCollapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarCollapse.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children"]);
    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
      in: navbarProps.expanded
    }, props), _react.default.createElement("div", {
      className: bsClassName
    }, children));
  };

  return NavbarCollapse;
}(_react.default.Component);

NavbarCollapse.contextTypes = contextTypes;
var _default = NavbarCollapse;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var contextTypes = {
  $bs_navbar: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};

var NavbarHeader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(NavbarHeader, _React$Component);

  function NavbarHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className"]);
    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
    return _react.default.createElement("div", (0, _extends2.default)({}, props, {
      className: (0, _classnames.default)(className, bsClassName)
    }));
  };

  return NavbarHeader;
}(_react.default.Component);

NavbarHeader.contextTypes = contextTypes;
var _default = NavbarHeader;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var propTypes = {
  onClick: _propTypes.default.func,

  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: _propTypes.default.node
};
var contextTypes = {
  $bs_navbar: _propTypes.default.shape({
    bsClass: _propTypes.default.string,
    expanded: _propTypes.default.bool,
    onToggle: _propTypes.default.func.isRequired
  })
};

var NavbarToggle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(NavbarToggle, _React$Component);

  function NavbarToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onClick", "className", "children"]);
    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var buttonProps = (0, _extends2.default)({
      type: 'button'
    }, props, {
      onClick: (0, _createChainedFunction.default)(onClick, navbarProps.onToggle),
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return _react.default.createElement("button", buttonProps, children);
    }

    return _react.default.createElement("button", buttonProps, _react.default.createElement("span", {
      className: "sr-only"
    }, "Toggle navigation"), _react.default.createElement("span", {
      className: "icon-bar"
    }), _react.default.createElement("span", {
      className: "icon-bar"
    }), _react.default.createElement("span", {
      className: "icon-bar"
    }));
  };

  return NavbarToggle;
}(_react.default.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;
var _default = NavbarToggle;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Dropdown = _interopRequireDefault(__webpack_require__(415));

var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(410));

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
  // Toggle props.
  title: _propTypes.default.node.isRequired,
  noCaret: _propTypes.default.bool,
  active: _propTypes.default.bool,
  activeKey: _propTypes.default.any,
  activeHref: _propTypes.default.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: _propTypes.default.node
});

var NavDropdown =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(NavDropdown, _React$Component);

  function NavDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropdown.prototype;

  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
    var _this = this;

    var props = _ref.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (_ValidComponentChildren.default.some(props.children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        title = _this$props.title,
        activeKey = _this$props.activeKey,
        activeHref = _this$props.activeHref,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["title", "activeKey", "activeHref", "className", "style", "children"]);
    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().

    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.


    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
      componentClass: "li",
      className: (0, _classnames.default)(className, {
        active: active
      }),
      style: style
    }), _react.default.createElement(_Dropdown.default.Toggle, (0, _extends2.default)({}, toggleProps, {
      useAnchor: true
    }), title), _react.default.createElement(_Dropdown.default.Menu, null, _ValidComponentChildren.default.map(children, function (child) {
      return _react.default.cloneElement(child, {
        active: _this2.isActive(child, activeKey, activeHref)
      });
    })));
  };

  return NavDropdown;
}(_react.default.Component);

NavDropdown.propTypes = propTypes;
var _default = NavDropdown;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(105));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _isArray = _interopRequireDefault(__webpack_require__(916));

var _contains = _interopRequireDefault(__webpack_require__(194));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _Overlay = _interopRequireDefault(__webpack_require__(952));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if ((0, _isArray.default)(of)) {
    return of.indexOf(one) >= 0;
  }

  return one === of;
}

var triggerType = _propTypes.default.oneOf(['click', 'hover', 'focus']);

var propTypes = (0, _extends2.default)({}, _Overlay.default.propTypes, {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: _propTypes.default.oneOfType([triggerType, _propTypes.default.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: _propTypes.default.number,

  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: _propTypes.default.number,

  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: _propTypes.default.number,
  // FIXME: This should be `defaultShow`.

  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: _propTypes.default.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: _propTypes.default.node.isRequired,

  /**
   * @private
   */
  onBlur: _propTypes.default.func,

  /**
   * @private
   */
  onClick: _propTypes.default.func,

  /**
   * @private
   */
  onFocus: _propTypes.default.func,

  /**
   * @private
   */
  onMouseOut: _propTypes.default.func,

  /**
   * @private
   */
  onMouseOver: _propTypes.default.func,
  // Overridden props from `<Overlay>`.

  /**
   * @private
   */
  target: _propTypes.default.oneOf([null]),

  /**
   * @private
   */
  onHide: _propTypes.default.oneOf([null]),

  /**
   * @private
   */
  show: _propTypes.default.oneOf([null])
});
var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleDelayedShow = _this.handleDelayedShow.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleDelayedHide = _this.handleDelayedHide.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleHide = _this.handleHide.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;
    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  var _proto = OverlayTrigger.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _reactDom.default.unmountComponentAtNode(this._mountNode);

    this._mountNode = null;
    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  _proto.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;

      _this2.hide();
    }, delay);
  };

  _proto.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;

      _this3.show();
    }, delay);
  };

  _proto.handleHide = function handleHide() {
    this.hide();
  }; // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !(0, _contains.default)(target, related)) {
      handler(e);
    }
  };

  _proto.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  _proto.hide = function hide() {
    this.setState({
      show: false
    });
  };

  _proto.makeOverlay = function makeOverlay(overlay, props) {
    return _react.default.createElement(_Overlay.default, (0, _extends2.default)({}, props, {
      show: this.state.show,
      onHide: this.handleHide,
      target: this
    }), overlay);
  };

  _proto.show = function show() {
    this.setState({
      show: true
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    _reactDom.default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        trigger = _this$props.trigger,
        overlay = _this$props.overlay,
        children = _this$props.children,
        onBlur = _this$props.onBlur,
        onClick = _this$props.onClick,
        onFocus = _this$props.onFocus,
        onMouseOut = _this$props.onMouseOut,
        onMouseOver = _this$props.onMouseOver,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);
    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = _react.default.Children.only(children);

    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    } // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.


    triggerProps.onClick = (0, _createChainedFunction.default)(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = (0, _createChainedFunction.default)(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? (0, _warning.default)(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
      triggerProps.onMouseOver = (0, _createChainedFunction.default)(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = (0, _createChainedFunction.default)(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = (0, _createChainedFunction.default)(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = (0, _createChainedFunction.default)(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);
    return (0, _react.cloneElement)(child, triggerProps);
  };

  return OverlayTrigger;
}(_react.default.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;
var _default = OverlayTrigger;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _bootstrapUtils = __webpack_require__(21);

var PageHeader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PageHeader, _React$Component);

  function PageHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), _react.default.createElement("h1", null, children));
  };

  return PageHeader;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _PagerItem = _interopRequireDefault(__webpack_require__(953));

var _deprecationWarning = _interopRequireDefault(__webpack_require__(2139));

var _default = _deprecationWarning.default.wrapper(_PagerItem.default, '`<PageItem>`', '`<Pager.Item>`');

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports._resetWarned = _resetWarned;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _warning = _interopRequireDefault(__webpack_require__(64));

var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message;

  if (typeof oldname === 'object') {
    message = oldname.message;
  } else {
    message = oldname + " is deprecated. Use " + newname + " instead.";

    if (link) {
      message += "\nYou can read more about it at " + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? (0, _warning.default)(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(DeprecatedComponent, _Component);

      function DeprecatedComponent() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = DeprecatedComponent.prototype;

      _proto.componentWillMount = function componentWillMount() {
        deprecationWarning.apply(void 0, args);

        if (_Component.prototype.componentWillMount) {
          var _Component$prototype$;

          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            methodArgs[_key2] = arguments[_key2];
          }

          (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
        }
      };

      return DeprecatedComponent;
    }(Component)
  );
};

var _default = deprecationWarning;
exports.default = _default;

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _PagerItem = _interopRequireDefault(__webpack_require__(953));

var _bootstrapUtils = __webpack_require__(21);

var _createChainedFunction = _interopRequireDefault(__webpack_require__(79));

var _ValidComponentChildren = _interopRequireDefault(__webpack_require__(107));

var propTypes = {
  onSelect: _propTypes.default.func
};

var Pager =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Pager, _React$Component);

  function Pager() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pager.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onSelect", "className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), _ValidComponentChildren.default.map(children, function (child) {
      return (0, _react.cloneElement)(child, {
        onSelect: (0, _createChainedFunction.default)(child.props.onSelect, onSelect)
      });
    }));
  };

  return Pager;
}(_react.default.Component);

Pager.propTypes = propTypes;
Pager.Item = _PagerItem.default;

var _default = (0, _bootstrapUtils.bsClass)('pager', Pager);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = PaginationItem;
exports.Last = exports.Next = exports.Ellipsis = exports.Prev = exports.First = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

/* eslint-disable react/no-multi-comp */
var propTypes = {
  eventKey: _propTypes.default.any,
  className: _propTypes.default.string,
  onSelect: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  active: _propTypes.default.bool,
  activeLabel: _propTypes.default.string.isRequired
};
var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};

function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);
  var Component = active || disabled ? 'span' : _SafeAnchor.default;
  return _react.default.createElement("li", {
    style: style,
    className: (0, _classnames.default)(className, {
      active: active,
      disabled: disabled
    })
  }, _react.default.createElement(Component, (0, _extends2.default)({
    disabled: disabled
  }, props), children, active && _react.default.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
}

PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;

function createButton(name, defaultValue, label) {
  var _class, _temp;

  if (label === void 0) {
    label = name;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inheritsLoose2.default)(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          children = _this$props.children,
          className = _this$props.className,
          props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["disabled", "children", "className"]);
      var Component = disabled ? 'span' : _SafeAnchor.default;
      return _react.default.createElement("li", (0, _extends2.default)({
        "aria-label": label,
        className: (0, _classnames.default)(className, {
          disabled: disabled
        })
      }, props), _react.default.createElement(Component, null, children || defaultValue));
    };

    return _class;
  }(_react.default.Component), _class.displayName = name, _class.propTypes = {
    disabled: _propTypes.default.bool
  }, _temp;
}

var First = createButton('First', "\xAB");
exports.First = First;
var Prev = createButton('Prev', "\u2039");
exports.Prev = Prev;
var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
exports.Ellipsis = Ellipsis;
var Next = createButton('Next', "\u203A");
exports.Next = Next;
var Last = createButton('Last', "\xBB");
exports.Last = Last;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _bootstrapUtils = __webpack_require__(21);

var _PanelCollapse = _interopRequireDefault(__webpack_require__(954));

var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: _propTypes.default.bool.isRequired
};
var defaultProps = {
  collapsible: false
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};

var PanelBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelBody, _React$Component);

  function PanelBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        collapsible = _this$props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    var body = _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'body'))
    }), children);

    if (collapsible) {
      body = _react.default.createElement(_PanelCollapse.default, null, body);
    }

    return body;
  };

  return PanelBody;
}(_react.default.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelBody);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _elementType = _interopRequireDefault(__webpack_require__(268));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  componentClass: _elementType.default
};
var defaultProps = {
  componentClass: 'div'
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    headingId: _propTypes.default.string,
    bsClass: _propTypes.default.string
  })
};

var PanelHeading =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelHeading, _React$Component);

  function PanelHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        Component = _this$props.componentClass,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'heading'))
    }), children);
  };

  return PanelHeading;
}(_react.default.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelHeading);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _elementType = _interopRequireDefault(__webpack_require__(268));

var _bootstrapUtils = __webpack_require__(21);

var _PanelToggle = _interopRequireDefault(__webpack_require__(955));

var propTypes = {
  componentClass: _elementType.default,

  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: _propTypes.default.bool
};
var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};
var defaultProps = {
  componentClass: 'div'
};

var PanelTitle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelTitle, _React$Component);

  function PanelTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        toggle = _this$props.toggle,
        Component = _this$props.componentClass,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["children", "className", "toggle", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = _react.default.createElement(_PanelToggle.default, null, children);
    }

    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'title'))
    }), children);
  };

  return PanelTitle;
}(_react.default.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelTitle);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _bootstrapUtils = __webpack_require__(21);

var contextTypes = {
  $bs_panel: _propTypes.default.shape({
    bsClass: _propTypes.default.string
  })
};

var PanelFooter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(PanelFooter, _React$Component);

  function PanelFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'footer'))
    }), children);
  };

  return PanelFooter;
}(_react.default.Component);

PanelFooter.contextTypes = contextTypes;

var _default = (0, _bootstrapUtils.bsClass)('panel', PanelFooter);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(197));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The "left" position value for the Popover.
   */
  positionLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Title content
   */
  title: _propTypes.default.node
};
var defaultProps = {
  placement: 'right'
};

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Popover, _React$Component);

  function Popover() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popover.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        title = _this$props.title,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
    var outerStyle = (0, _extends3.default)({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);
    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
      role: "tooltip",
      className: (0, _classnames.default)(className, classes),
      style: outerStyle
    }), _react.default.createElement("div", {
      className: "arrow",
      style: arrowStyle
    }), title && _react.default.createElement("h3", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'title')
    }, title), _react.default.createElement("div", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'content')
    }, children));
  };

  return Popover;
}(_react.default.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('popover', Popover);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(89);

var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(64));

var _bootstrapUtils = __webpack_require__(21);

// TODO: This should probably take a single `aspectRatio` prop.
var propTypes = {
  /**
   * This component requires a single child element
   */
  children: _propTypes.default.element.isRequired,

  /**
   * 16by9 aspect ratio
   */
  a16by9: _propTypes.default.bool,

  /**
   * 4by3 aspect ratio
   */
  a4by3: _propTypes.default.bool
};
var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ResponsiveEmbed.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        a16by9 = _this$props.a16by9,
        a4by3 = _this$props.a4by3,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["a16by9", "a4by3", "className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? (0, _warning.default)(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? (0, _warning.default)(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(classes)
    }, (0, _react.cloneElement)(children, (0, _extends3.default)({}, elementProps, {
      className: (0, _classnames.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
    })));
  };

  return ResponsiveEmbed;
}(_react.default.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Button = _interopRequireDefault(__webpack_require__(45));

var _Dropdown = _interopRequireDefault(__webpack_require__(415));

var _SplitToggle = _interopRequireDefault(__webpack_require__(2149));

var _splitComponentProps2 = _interopRequireDefault(__webpack_require__(410));

var propTypes = (0, _extends2.default)({}, _Dropdown.default.propTypes, {
  // Toggle props.
  bsStyle: _propTypes.default.string,
  bsSize: _propTypes.default.string,
  href: _propTypes.default.string,
  onClick: _propTypes.default.func,

  /**
   * The content of the split button.
   */
  title: _propTypes.default.node.isRequired,

  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: _propTypes.default.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: _propTypes.default.node
});

var SplitButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(SplitButton, _React$Component);

  function SplitButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        toggleLabel = _this$props.toggleLabel,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);

    var _splitComponentProps = (0, _splitComponentProps2.default)(props, _Dropdown.default.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return _react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), _react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
      disabled: props.disabled,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), _react.default.createElement(_SplitToggle.default, {
      "aria-label": toggleLabel || title,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), _react.default.createElement(_Dropdown.default.Menu, null, children));
  };

  return SplitButton;
}(_react.default.Component);

SplitButton.propTypes = propTypes;
SplitButton.Toggle = _SplitToggle.default;
var _default = SplitButton;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _DropdownToggle = _interopRequireDefault(__webpack_require__(949));

var SplitToggle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(SplitToggle, _React$Component);

  function SplitToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitToggle.prototype;

  _proto.render = function render() {
    return _react.default.createElement(_DropdownToggle.default, (0, _extends2.default)({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(_react.default.Component);

SplitToggle.defaultProps = _DropdownToggle.default.defaultProps;
var _default = SplitToggle;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  striped: _propTypes.default.bool,
  bordered: _propTypes.default.bool,
  condensed: _propTypes.default.bool,
  hover: _propTypes.default.bool,
  responsive: _propTypes.default.bool
};
var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Table, _React$Component);

  function Table() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        striped = _this$props.striped,
        bordered = _this$props.bordered,
        condensed = _this$props.condensed,
        hover = _this$props.hover,
        responsive = _this$props.responsive,
        className = _this$props.className,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));

    var table = _react.default.createElement("table", (0, _extends3.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));

    if (responsive) {
      return _react.default.createElement("div", {
        className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive')
      }, table);
    }

    return table;
  };

  return Table;
}(_react.default.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('table', Table);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(141));

var _bootstrapUtils = __webpack_require__(21);

/* eslint-disable jsx-a11y/alt-text */
var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: _propTypes.default.string,

  /**
   * alt property that is passed down to the image inside this component
   */
  alt: _propTypes.default.string,

  /**
   * href property that is passed down to the image inside this component
   */
  href: _propTypes.default.string,

  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: _propTypes.default.func,

  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: _propTypes.default.func
};

var Thumbnail =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Thumbnail, _React$Component);

  function Thumbnail() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Thumbnail.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        src = _this$props.src,
        alt = _this$props.alt,
        onError = _this$props.onError,
        onLoad = _this$props.onLoad,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["src", "alt", "onError", "onLoad", "className", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? _SafeAnchor.default : 'div';
    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement(Component, (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }), _react.default.createElement("img", {
      src: src,
      alt: alt,
      onError: onError,
      onLoad: onLoad
    }), children && _react.default.createElement("div", {
      className: "caption"
    }, children));
  };

  return Thumbnail;
}(_react.default.Component);

Thumbnail.propTypes = propTypes;

var _default = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(17));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(20));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(14));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _isRequiredForA11y = _interopRequireDefault(__webpack_require__(197));

var _bootstrapUtils = __webpack_require__(21);

var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: (0, _isRequiredForA11y.default)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
var defaultProps = {
  placement: 'right'
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Tooltip, _React$Component);

  function Tooltip() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tooltip.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
    var outerStyle = (0, _extends3.default)({
      top: positionTop,
      left: positionLeft
    }, style);
    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return _react.default.createElement("div", (0, _extends3.default)({}, elementProps, {
      role: "tooltip",
      className: (0, _classnames.default)(className, classes),
      style: outerStyle
    }), _react.default.createElement("div", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'),
      style: arrowStyle
    }), _react.default.createElement("div", {
      className: (0, _bootstrapUtils.prefix)(bsProps, 'inner')
    }, children));
  };

  return Tooltip;
}(_react.default.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

var _default = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(12);

var _interopRequireWildcard = __webpack_require__(89);

exports.__esModule = true;
exports.bootstrapUtils = void 0;

var _bootstrapUtils = _interopRequireWildcard(__webpack_require__(21));

exports.bootstrapUtils = _bootstrapUtils;

var _createChainedFunction2 = _interopRequireDefault(__webpack_require__(79));

exports.createChainedFunction = _createChainedFunction2.default;

var _ValidComponentChildren2 = _interopRequireDefault(__webpack_require__(107));

exports.ValidComponentChildren = _ValidComponentChildren2.default;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.usePassengerAssistBookingModal = undefined;

var _useStoreState2 = __webpack_require__(145);

var _useStoreState3 = _interopRequireDefault(_useStoreState2);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

var _PassengerAssistStore = __webpack_require__(173);

var _PassengerAssistStore2 = _interopRequireDefault(_PassengerAssistStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usePassengerAssistBookingModal = exports.usePassengerAssistBookingModal = function usePassengerAssistBookingModal(_ref) {
    var currentJourneyData = _ref.currentJourneyData;

    var currentTrip = (0, _useStoreState3.default)(_CurrentTripStore2.default);

    var _useStoreState = (0, _useStoreState3.default)(_PassengerAssistStore2.default),
        pendingTravelAssistRequests = _useStoreState.pendingTravelAssistRequests;

    var journeys = [];

    if (currentJourneyData) {
        // if List view
        var service = currentJourneyData.service,
            trip = currentJourneyData.trip,
            isReturnJourney = currentJourneyData.isReturnJourney;

        if (isReturnJourney) {
            journeys.push({
                trip: trip,
                journey: trip.getOutwardService(),
                direction: 'Outward'
            });

            journeys.push({
                trip: trip,
                journey: service.get('journey'),
                direction: 'Return'
            });
        } else {
            journeys.push({
                trip: trip,
                journey: service.get('journey'),
                direction: 'Outward'
            });
        }
    } else {
        journeys.push({
            trip: currentTrip,
            journey: currentTrip.getOutwardService(),
            direction: 'Outward'
        });

        if (currentTrip.isReturn()) {
            journeys.push({
                trip: currentTrip,
                journey: currentTrip.getInwardService(),
                direction: 'Return'
            });
        }
    }

    var validJourneys = journeys.filter(function (j) {
        return !j.trip.isSeason() && j.trip.getType() !== _AppConstants.TripTypes.ROVERSRANGERS;
    });

    return {
        journeys: validJourneys,
        pendingTravelAssistRequests: pendingTravelAssistRequests
    };
};

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ChildSmartCardExpirationModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _Address = __webpack_require__(618);

var _Address2 = _interopRequireDefault(_Address);

var _AppConstants = __webpack_require__(6);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChildSmartCardExpirationModal = exports.ChildSmartCardExpirationModal = function ChildSmartCardExpirationModal() {
    var _React$useState = _react2.default.useState(true),
        isModalOpen = _React$useState[0],
        setIsModalOpen = _React$useState[1];

    var toggleModal = function toggleModal() {
        return setIsModalOpen(!isModalOpen);
    };

    var user = _UserStore2.default.getCurrent();
    var smartCardAddress = user.getSmartcardAddress();

    return _react2.default.createElement(
        _BaseModal2.default,
        {
            className: 'modal--sm',
            show: isModalOpen,
            onClose: toggleModal,
            hideContinue: true,
            titleText: (0, _I18n.translate)('transitioning-child-smartcard.modal.title')
        },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('transitioning-child-smartcard.modal.paragraph.1')
            ),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('transitioning-child-smartcard.modal.paragraph.2')
            ),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('transitioning-child-smartcard.modal.paragraph.3')
            ),
            smartCardAddress && _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n.translate)('transitioning-child-smartcard.modal.paragraph.4')
                ),
                _react2.default.createElement(_Address2.default, {
                    address: smartCardAddress,
                    className: 'margin-top--sm margin-bottom--sm text-weight--normal'
                }),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n.translate)('transitioning-child-smartcard.modal.paragraph.5.1'),
                    _react2.default.createElement(
                        _Link2.default,
                        { to: _AppConstants.AccountPages.ACCOUNT_ADDRESSES, onClick: toggleModal },
                        (0, _I18n.translate)('transitioning-child-smartcard.modal.paragraph.5.address.link')
                    ),
                    (0, _I18n.translate)('transitioning-child-smartcard.modal.paragraph.5.2')
                )
            )
        )
    );
};

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Radio = __webpack_require__(231);

var _Radio2 = _interopRequireDefault(_Radio);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroups = function RadioGroups(_ref) {
    var name = _ref.name,
        title = _ref.title,
        i18nPrefix = _ref.i18nPrefix,
        options = _ref.options,
        seatingPreferences = _ref.seatingPreferences,
        handleSeatingPreferenceChange = _ref.handleSeatingPreferenceChange;

    return _react2.default.createElement(
        'div',
        { className: 'seat-container__item' },
        _react2.default.createElement(
            'div',
            { className: 'seat-container__item--title' },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: 'radio-row' },
            options.map(function (_ref2) {
                var value = _ref2.value,
                    key = _ref2.key;
                return _react2.default.createElement(_Radio2.default, {
                    key: value,
                    name: name,
                    value: value,
                    label: (0, _I18n2.default)(i18nPrefix + '.' + key),
                    checked: seatingPreferences.get(name) === value,
                    onChange: handleSeatingPreferenceChange(name)
                });
            })
        )
    );
};

RadioGroups.propTypes = {
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    i18nPrefix: _propTypes2.default.string.isRequired,
    options: _propTypes2.default.array.isRequired,
    seatingPreferences: _propTypes2.default.object.isRequired,
    handleSeatingPreferenceChange: _propTypes2.default.func.isRequired
};

exports.default = RadioGroups;

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keymirror = __webpack_require__(177);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Use keyMirror for feature keys
var Features = (0, _keymirror2.default)({
    quietCoach: null,
    nearToilets: null,
    powerSocket: null,
    nearLuggageRack: null
});

// Build array dynamically from Features
var featureCheckboxes = (0, _keys2.default)(Features).map(function (key) {
    return {
        name: key,
        key: key
    };
});

var FeatureCheckboxes = function FeatureCheckboxes(_ref) {
    var seatingPreferences = _ref.seatingPreferences,
        handleCheckboxChange = _ref.handleCheckboxChange;

    return _react2.default.createElement(
        'div',
        { className: 'seat-container__item' },
        _react2.default.createElement(
            'div',
            { className: 'seat-container__item--title' },
            (0, _I18n2.default)('booking.seating.features')
        ),
        _react2.default.createElement(
            'div',
            { className: 'radio-row' },
            featureCheckboxes.map(function (_ref2) {
                var name = _ref2.name,
                    key = _ref2.key;
                return _react2.default.createElement(_Checkbox2.default, {
                    key: name,
                    name: name,
                    className: 'reservation-checkbox',
                    label: (0, _I18n2.default)('booking.seating.features.' + key),
                    checked: seatingPreferences.get(name),
                    onChange: handleCheckboxChange(name)
                });
            })
        )
    );
};

FeatureCheckboxes.propTypes = {
    seatingPreferences: _propTypes2.default.object.isRequired,
    handleCheckboxChange: _propTypes2.default.func.isRequired
};

exports.default = FeatureCheckboxes;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _LinkMapper = __webpack_require__(8);

var _Reservation = __webpack_require__(644);

var _Reservation2 = _interopRequireDefault(_Reservation);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservationsService = {
    getBaseUrl: function getBaseUrl() {
        return '/reservations/reservation/';
    },
    getReservationsAvailability: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
            var journeys = _ref.journeys,
                passengers = _ref.passengers;
            var payload, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            payload = {
                                salesFlowType: _AppConstants.ReservationSalesFlowType.SALES,
                                journeys: journeys,
                                passengers: passengers
                            };
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.post('/reservations/availability?includeLegAvailability=true', payload);

                        case 4:
                            response = _context.sent;
                            return _context.abrupt('return', response);

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);
                            throw _context.t0;

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 8]]);
        }));

        function getReservationsAvailability(_x) {
            return _ref2.apply(this, arguments);
        }

        return getReservationsAvailability;
    }(),
    createReservation: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(reservation) {
            var user, payload, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;

                            /*
                                {
                                "passengers": [
                                    {
                                    "statusCode": "000",
                                    "attributes": [
                                        "NONE",
                                        "WIND",
                                        "AIRL",
                                        "QUIE",
                                        "NRWC",
                                        "POWE",
                                        "LUGG"
                                    ]
                                    }
                                ],
                                "outwardJourney": {
                                    "origin": {
                                    "nlc": "6836",
                                    "name": "Chelmsford"
                                    },
                                    "destination": {
                                    "nlc": "8487",
                                    "name": "Leeds"
                                    },
                                    "ticketTypeCode": "OAS",
                                    "routeCode": "00430",
                                    "reserve": true,
                                    "legs": [
                                    {
                                        "date": "2025-04-02",
                                        "retailServiceId": "LE519500",
                                        "origin": {
                                        "nlc": "6836",
                                        "name": "Chelmsford"
                                        },
                                        "destination": {
                                        "nlc": "6965",
                                        "name": "London Liverpool Street"
                                        },
                                        "departure": "2025-04-02T16:26:00",
                                        "arrival": "2025-04-02T17:02:00",
                                        "reservable": "No",
                                        "operator": "LE",
                                        "mode": "Train"
                                    },
                                    {
                                        "origin": {
                                        "nlc": "6965",
                                        "name": "London Liverpool Street"
                                        },
                                        "destination": {
                                        "nlc": "6121",
                                        "name": "London Kings Cross"
                                        },
                                        "operator": "LT",
                                        "mode": "Metro"
                                    },
                                    {
                                        "date": "2025-04-02",
                                        "retailServiceId": "GR258000",
                                        "origin": {
                                        "nlc": "6121",
                                        "name": "London Kings Cross"
                                        },
                                        "destination": {
                                        "nlc": "8487",
                                        "name": "Leeds"
                                        },
                                        "departure": "2025-04-02T17:48:00",
                                        "arrival": "2025-04-02T20:17:00",
                                        "reservable": "Compulsory",
                                        "operator": "GR",
                                        "mode": "Train"
                                    }
                                    ]
                                },
                                "returnJourney": {
                                    "origin": {
                                    "nlc": "8487",
                                    "name": "Leeds"
                                    },
                                    "destination": {
                                    "nlc": "6836",
                                    "name": "Chelmsford"
                                    },
                                    "ticketTypeCode": "OET",
                                    "routeCode": "00430",
                                    "reserve": true,
                                    "legs": [
                                    {
                                        "date": "2025-04-03",
                                        "retailServiceId": "TP530000",
                                        "origin": {
                                        "nlc": "8487",
                                        "name": "Leeds"
                                        },
                                        "destination": {
                                        "nlc": "8263",
                                        "name": "York"
                                        },
                                        "departure": "2025-04-03T02:34:00",
                                        "arrival": "2025-04-03T03:13:00",
                                        "reservable": "Possible",
                                        "operator": "TP",
                                        "mode": "Train"
                                    },
                                    {
                                        "date": "2025-04-03",
                                        "retailServiceId": "GR300000",
                                        "origin": {
                                        "nlc": "8263",
                                        "name": "York"
                                        },
                                        "destination": {
                                        "nlc": "6121",
                                        "name": "London Kings Cross"
                                        },
                                        "departure": "2025-04-03T04:40:00",
                                        "arrival": "2025-04-03T07:00:00",
                                        "reservable": "Compulsory",
                                        "operator": "GR",
                                        "mode": "Train"
                                    },
                                    {
                                        "origin": {
                                        "nlc": "6121",
                                        "name": "London Kings Cross"
                                        },
                                        "destination": {
                                        "nlc": "6965",
                                        "name": "London Liverpool Street"
                                        },
                                        "operator": "LT",
                                        "mode": "Metro"
                                    },
                                    {
                                        "date": "2025-04-03",
                                        "retailServiceId": "LE516300",
                                        "origin": {
                                        "nlc": "6965",
                                        "name": "London Liverpool Street"
                                        },
                                        "destination": {
                                        "nlc": "6836",
                                        "name": "Chelmsford"
                                        },
                                        "departure": "2025-04-03T07:46:00",
                                        "arrival": "2025-04-03T08:21:00",
                                        "reservable": "No",
                                        "operator": "LE",
                                        "mode": "Train"
                                    }
                                    ]
                                },
                                "bikes": 1
                                }
                            */

                            user = _UserStore2.default.getCurrent();
                            payload = reservation.formatForAPI(reservation);
                            _context2.next = 5;
                            return _AuthenticatedAPIClient2.default.post(this.getBaseUrl() + 'customer/' + user.id, payload);

                        case 5:
                            response = _context2.sent;
                            return _context2.abrupt('return', (0, _LinkMapper.resolve)(response).as(_Reservation2.default));

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](0);

                            console.warn('Create reservation error', _context2.t0);
                            throw _context2.t0;

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 9]]);
        }));

        function createReservation(_x2) {
            return _ref3.apply(this, arguments);
        }

        return createReservation;
    }(),
    amendReservation: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(reservation) {
            var user, payload, response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            user = _UserStore2.default.getCurrent();
                            payload = reservation.formatForAPI(reservation, user.id);
                            _context3.next = 5;
                            return _AuthenticatedAPIClient2.default.put('' + this.getBaseUrl() + reservation.reservationId, payload);

                        case 5:
                            response = _context3.sent;
                            return _context3.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_Reservation2.default));

                        case 9:
                            _context3.prev = 9;
                            _context3.t0 = _context3['catch'](0);
                            throw _context3.t0;

                        case 12:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 9]]);
        }));

        function amendReservation(_x3) {
            return _ref4.apply(this, arguments);
        }

        return amendReservation;
    }(),
    cancelReservation: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(reservationId) {
            var response, reservation;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return _AuthenticatedAPIClient2.default.put('' + this.getBaseUrl() + reservationId);

                        case 3:
                            response = _context4.sent;
                            reservation = (0, _LinkMapper.resolve)(response).as(_Reservation2.default);
                            return _context4.abrupt('return', reservation);

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](0);
                            throw _context4.t0;

                        case 11:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 8]]);
        }));

        function cancelReservation(_x4) {
            return _ref5.apply(this, arguments);
        }

        return cancelReservation;
    }(),
    getReservations: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var user, response, resolvedReservations;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.prev = 0;
                            user = _UserStore2.default.getCurrent();
                            _context5.next = 4;
                            return _AuthenticatedAPIClient2.default.get(this.getBaseUrl() + 'customer/' + user.id + '?page=' + page);

                        case 4:
                            response = _context5.sent;

                            if (!response.result) {
                                _context5.next = 14;
                                break;
                            }

                            _context5.prev = 6;
                            resolvedReservations = (0, _LinkMapper.resolveAll)(response.result).as(_Reservation2.default);
                            return _context5.abrupt('return', {
                                reservations: resolvedReservations,
                                pagination: response.pagination
                            });

                        case 11:
                            _context5.prev = 11;
                            _context5.t0 = _context5['catch'](6);

                            console.warn('error retrieving reservations', _context5.t0);

                        case 14:
                            return _context5.abrupt('return', null);

                        case 17:
                            _context5.prev = 17;
                            _context5.t1 = _context5['catch'](0);
                            throw _context5.t1;

                        case 20:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[0, 17], [6, 11]]);
        }));

        function getReservations() {
            return _ref6.apply(this, arguments);
        }

        return getReservations;
    }()
};

exports.default = ReservationsService;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.radioGroups = undefined;

var _AppConstants = __webpack_require__(6);

var radioGroups = exports.radioGroups = [{
    name: 'direction',
    title: 'Direction',
    i18nPrefix: 'booking.seating',
    options: [{ value: _AppConstants.SeatingPrefs.NONE, key: 'noPreference' }, { value: _AppConstants.SeatingPrefs.FORWARDS, key: 'direction.forwards' }, { value: _AppConstants.SeatingPrefs.BACKWARDS, key: 'direction.backwards' }]
}, {
    name: 'position',
    title: 'Position',
    i18nPrefix: 'booking.seating',
    options: [{ value: _AppConstants.SeatingPrefs.NONE, key: 'noPreference' }, { value: _AppConstants.SeatingPrefs.AISLE, key: 'position.aisle' }, { value: _AppConstants.SeatingPrefs.WINDOW, key: 'position.window' }, { value: _AppConstants.SeatingPrefs.INDIVIDUAL, key: 'position.individual' }]
}, {
    name: 'seatType',
    title: 'Seat type',
    i18nPrefix: 'booking.seating',
    options: [{ value: _AppConstants.SeatingPrefs.NONE, key: 'noPreference' }, { value: _AppConstants.SeatingPrefs.AIRLINE, key: 'seatType.airline' }, { value: _AppConstants.SeatingPrefs.TABLE, key: 'seatType.table' }]
}];

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LoadingStore = __webpack_require__(455);

var _LoadingStore2 = _interopRequireDefault(_LoadingStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    return {
        loading: _LoadingStore2.default.isLoading()
    };
}

var LoadingLine = (_dec = (0, _connectToStores2.default)([_LoadingStore2.default], _getStateFromStores), _dec(_class = (_temp = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(LoadingLine, _PureRenderComponent);

    function LoadingLine() {
        (0, _classCallCheck3.default)(this, LoadingLine);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    LoadingLine.prototype.render = function render() {
        if (this.props.loading) {
            return _react2.default.createElement(
                'div',
                { className: 'loading-line' },
                _react2.default.createElement('div', { className: 'break dot1' }),
                _react2.default.createElement('div', { className: 'break dot2' }),
                _react2.default.createElement('div', { className: 'break dot3' })
            );
        }
        return null;
    };

    return LoadingLine;
}(_PureRenderComponent3.default), _class2.propTypes = {
    loading: _propTypes2.default.bool
}, _class2.defaultProps = {
    loading: false
}, _temp)) || _class);
exports.default = LoadingLine;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _NotificationStore = __webpack_require__(876);

var _NotificationStore2 = _interopRequireDefault(_NotificationStore);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    return {
        notification: _NotificationStore2.default.getActive()
    };
}

var Notifications = (_dec = (0, _connectToStores2.default)([_NotificationStore2.default], _getStateFromStores), _dec(_class = (_temp = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(Notifications, _PureRenderComponent);

    function Notifications() {
        (0, _classCallCheck3.default)(this, Notifications);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    Notifications.prototype.render = function render() {
        var notification = this.props.notification;

        if (notification) {
            return _react2.default.createElement(
                'div',
                { className: 'notification text-weight--normal text-center', onClick: _NotificationActions2.default.hideNotification },
                (0, _I18n.translate)(notification)
            );
        }
        return null;
    };

    return Notifications;
}(_PureRenderComponent3.default), _class2.propTypes = {
    notification: _propTypes2.default.string
}, _class2.defaultProps = {
    notification: null
}, _temp)) || _class);
exports.default = Notifications;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _useRouter = __webpack_require__(338);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _I18n = __webpack_require__(9);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Webchat = function Webchat(_ref) {
    var isMobile = _ref.isMobile;

    var location = (0, _useRouter.useLocation)();

    var _useState = (0, _react.useState)(false),
        isOpen = _useState[0],
        setIsOpen = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        isAllowed = _useState2[0],
        setIsAllowed = _useState2[1];

    var _useMemo = (0, _react.useMemo)(function () {
        return [_config2.default.get('webchatIframeSrc') || '', _config2.default.get('webchatProhibitedPaths')];
    }, []),
        iframeSrc = _useMemo[0],
        prohibitedPaths = _useMemo[1];

    (0, _react.useEffect)(function () {
        var isProhibited = Array.isArray(prohibitedPaths) && prohibitedPaths.some(function (pathSubstring) {
            return location.pathname.includes(pathSubstring);
        });

        setIsAllowed(!isProhibited);
    }, [location, prohibitedPaths]);

    var handleClick = function handleClick() {
        setIsOpen(!isOpen);

        if (!isOpen) {
            _TrackingActions2.default.webchatOpened();
        }
    };

    return _react2.default.createElement(
        _FeatureFlag2.default,
        { name: 'enableWebchat' },
        _react2.default.createElement(
            'div',
            { className: 'webchat__container hidden-print ' },
            isOpen && isAllowed && !isMobile && _react2.default.createElement('iframe', {
                id: 'webchat',
                className: 'webchat__iframe',
                src: iframeSrc,
                width: '375',
                height: '600'
            }),
            isAllowed && !isMobile && _react2.default.createElement(
                'button',
                {
                    className: 'webchat__toggle',
                    onClick: handleClick,
                    tabIndex: '0',
                    'aria-label': (0, _I18n.translate)('ariaLabel.webchatButton')
                },
                _react2.default.createElement(_Icon2.default, { icon: isOpen ? 'close' : 'chat' })
            )
        )
    );
};

Webchat.propTypes = {
    isMobile: _propTypes2.default.bool
};

exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default], function () {
    return {
        isMobile: _DimensionsStore2.default.isMobileWidth()
    };
})(Webchat);

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _appVersion = __webpack_require__(351);

var _appVersion2 = _interopRequireDefault(_appVersion);

var _ErrorReporter = __webpack_require__(2164);

var _ErrorReporter2 = _interopRequireDefault(_ErrorReporter);

var _AppConstants = __webpack_require__(6);

var _DeviceDetection = __webpack_require__(597);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _ErrorModal = __webpack_require__(681);

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorHandler = function errorHandler() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var e = args.length === 5 ? args.pop() : args.shift();
    var error = e.detail ? e.detail.reason : e;
    var shouldIgnore = typeof e.message === 'string' && _AppConstants.IgnoredErrors.some(function (errorPattern) {
        return e.message.match(errorPattern);
    });

    var isRefreshTokenError = error && error.name && error.name === 'RefreshTokenError';

    var isCookiebotConsentRequestIssue = error && error.reason && error.reason.includes && error.reason.includes('Failed to fetch') && error.reason.includes('googletagmanager.com') && error.reason.includes('consent.cookiebot.com') && error.reason.includes('consentmode');

    if (!shouldIgnore && !isRefreshTokenError && !isCookiebotConsentRequestIssue) {
        console.error('Error boundary caught: ', error);
        _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, { error: error });
    }
    var hasErrorEvent = typeof ErrorEvent !== 'undefined';
    if (!(hasErrorEvent && error instanceof ErrorEvent)) {
        (0, _ErrorReporter2.default)(error);
    }
};

var GlobalErrorBoundary = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(GlobalErrorBoundary, _React$Component);

    function GlobalErrorBoundary() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, GlobalErrorBoundary);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            hasError: false,
            isRefreshing: false
        }, _this.continue = function () {
            _this.setState({ hasError: false });
        }, _this.refresh = function () {
            _this.setState({ hasError: false, isRefreshing: true });
            window.location.reload();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    GlobalErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return { hasError: true };
    };

    GlobalErrorBoundary.prototype.componentDidMount = function componentDidMount() {
        var canUseRavenSDK = !_config2.default.get('debug') && (0, _DeviceDetection.browserDetection)() !== _AppConstants.Browsers.IOS_CHROME;

        if (canUseRavenSDK) {
            (0, _ErrorReporter.init)(_appVersion2.default.version);
        }
        window.addEventListener('error', errorHandler);
        window.addEventListener('unhandledrejection', errorHandler);
    };

    GlobalErrorBoundary.prototype.componentDidCatch = function componentDidCatch(error) {
        errorHandler(error);
    };

    GlobalErrorBoundary.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('error', errorHandler);
        window.removeEventListener('unhandledrejection', errorHandler);
    };

    GlobalErrorBoundary.prototype.render = function render() {
        if (this.state.isRefreshing) {
            return _react2.default.createElement(
                'div',
                { className: 'margin-top padding-top loading text-center loading--standalone' },
                _react2.default.createElement('span', { className: 'otrl circle-spinner' }),
                _react2.default.createElement(
                    'h2',
                    { className: 'no-margin' },
                    (0, _I18n2.default)('global.loading')
                )
            );
        }
        if (this.state.hasError) {
            return _react2.default.createElement(_ErrorModal2.default, {
                closeText: 'button.text.continue',
                onClose: this.continue,
                customButton: {
                    text: 'button.text.refresh',
                    onClick: this.refresh
                }
            });
        }
        return this.props.children;
    };

    return GlobalErrorBoundary;
}(_react2.default.Component), _class.propTypes = {
    children: _propTypes2.default.any
}, _temp2);
exports.default = GlobalErrorBoundary;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _stringify = __webpack_require__(74);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

exports.init = init;
exports.default = reportError;

var _ravenJs = __webpack_require__(2165);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userFields = _config2.default.get('environment') === 'prod' ? ['id'] : ['id', 'fullName', 'email'];

var excludeErrors = [/TypeError: .*(null.*_currentElement|_currentElement.*null)/, /Error: Minified exception occurred/, /TypeError: Network request failed/, /TypeError: Failed to fetch/, /TypeError: this\.get\(\.\.\.\)\.querySelectorAll is not a function/, /TypeError: plugin\.setSuspendState is not a function/, /SyntaxError: Unexpected token </, /TypeError: Failed to execute 'removeChild' on 'Node': parameter 1 is not of type 'Node'/, /undefined: \[object Event\]/, /Error: Out of memory/, /undefined: RangeError: Maximum call stack size exceeded/];

function addErrorContext() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var currentUser = _UserStore2.default.getCurrent();
    if (currentUser.isLoggedIn()) {
        data.user = (0, _pick3.default)(currentUser, userFields);
    }
    data.tags = (0, _assign2.default)({}, data.tags, {
        'app': _config2.default.get('name'),
        'in-app': !!_InAppStore2.default.isInApp()
    });

    var order = _OrderStore2.default.getCurrent();
    var trip = _CurrentTripStore2.default.get();
    var lastException = _ravenJs2.default.lastException() || new Error();
    data.extra = (0, _assign2.default)({}, data.extra, lastException.extra, {
        'order.id': order.id,
        'order.state': order.state,
        'order.products': (0, _stringify2.default)(order.getProducts()),
        'order.totalPrice': order.getTotalPrice(),
        'order.expiry': order.expiry && order.expiry.format(),
        'order.fulfilment': order.getDeliveryMethodName(),
        'trip.type': trip.getType(),
        'trip.isValid': trip.isValid(),
        'trip': (0, _stringify2.default)(trip)
    });

    return data;
}

function shouldSendError(data) {
    var exception = data.exception && data.exception.values[0];
    var message = exception ? (exception.type ? exception.type + ': ' : '') + exception.value : data.message;
    if (!message || excludeErrors.some(function (pattern) {
        return message.match(pattern);
    })) {
        return false;
    }
    return true;
}

function init(version) {
    var dsn = _InAppStore2.default.isInApp() ? _config2.default.get('ravenDSNTAB') : _config2.default.get('ravenDSN');
    if (dsn) {
        _ravenJs2.default.config(dsn, { release: version }).setTagsContext({
            brand: _config2.default.get('brand'),
            environment: _config2.default.get('environment')
        }).setDataCallback(addErrorContext).setShouldSendCallback(shouldSendError).install();
    }
}

function reportError(error) {
    _ravenJs2.default.captureException(error, { extra: error.extra });
}

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(2166);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(2167);
var stringify = __webpack_require__(957);
var md5 = __webpack_require__(2168);
var RavenConfigError = __webpack_require__(2169);

var utils = __webpack_require__(592);
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(2170).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.27.2',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = objectMerge(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    } else if (current.fingerprint || last.fingerprint) {
      return Boolean(current.fingerprint && last.fingerprint) &&
        JSON.stringify(current.fingerprint) === JSON.stringify(last.fingerprint)
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(592);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
    ? global
    : typeof self !== 'undefined'
    ? self
    : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(
      function() {
        if (lastException === ex) {
          processLastException();
        }
      },
      stack.incomplete ? 2000 : 0
    );

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)))

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 2169 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(592);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Refocus = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Refocus, _React$PureComponent);

    function Refocus() {
        (0, _classCallCheck3.default)(this, Refocus);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    Refocus.prototype.componentDidUpdate = function componentDidUpdate() {
        var routes = this.props.routes;

        // Do not refocus if any of the routes are opting out of this

        var noRefocus = routes.some(function (route) {
            return route.shouldRefocusRouteContent && !route.shouldRefocusRouteContent();
        });

        var focusableNode = document.getElementById('route__content');
        if (focusableNode && !noRefocus) {
            focusableNode.focus();
        }
    };

    Refocus.prototype.render = function render() {
        return _react2.default.createElement(
            'div',
            null,
            this.props.children
        );
    };

    return Refocus;
}(_react2.default.PureComponent), _class.propTypes = {
    children: _propTypes2.default.node,
    routes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
}, _temp);
exports.default = Refocus;

/***/ }),
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AccountHeader(props) {
    var classes = (0, _classnames2.default)('text-primary padding-top--sm padding-bottom--sm border--bottom text-lg no-margin', {
        'hidden-mobile hidden-tablet-portrait': !props.isStaticPage,
        'text-center': props.isStaticPage && !props.disableCentered,
        'header--smartcard': props.smartcardHeader
    });

    var headerContainerClasses = (0, _classnames2.default)('account-header__container border--bottom', {
        'header--with-button': props.isReservation
    });

    if (props.button !== undefined) {
        return _react2.default.createElement(
            'div',
            { className: headerContainerClasses },
            _react2.default.createElement(
                'h1',
                { className: classes },
                props.children
            ),
            props.button,
            props.isReservation && _react2.default.createElement(
                'button',
                {
                    onClick: function onClick() {
                        return props.openJourneyModal(true);
                    },
                    className: 'btn action-btn action-btn--primary make-a-reservation-button'
                },
                (0, _I18n2.default)('account.reservation.button')
            )
        );
    }
    return _react2.default.createElement(
        'h1',
        { className: classes },
        props.children
    );
}

AccountHeader.propTypes = {
    children: _propTypes2.default.any,
    isStaticPage: _propTypes2.default.bool,
    smartcardHeader: _propTypes2.default.bool,
    disableCentered: _propTypes2.default.bool,
    button: _propTypes2.default.node,
    isReservation: _propTypes2.default.bool,
    openJourneyModal: _propTypes2.default.func
};

AccountHeader.defaultProps = {
    isStaticPage: false,
    smartcardHeader: false,
    disableCentered: false,
    isPassengerAssist: false,
    button: null
};

exports.default = AccountHeader;

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Tutorial = __webpack_require__(2180);

var _Tutorial2 = _interopRequireDefault(_Tutorial);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Breadcrumb(_ref) {
    var pageName = _ref.pageName,
        tutorialName = _ref.tutorialName;

    var classNames = (0, _classnames2.default)('breadcrumb', 'border--bottom', 'text-primary', 'text-weight--normal', 'margin-bottom--sm');

    return _react2.default.createElement(
        _Col2.default,
        { md: 12, className: classNames },
        _react2.default.createElement(
            'span',
            { className: 'margin-right--sm' },
            pageName
        ),
        tutorialName && _react2.default.createElement(
            _Tutorial2.default,
            { name: tutorialName },
            _react2.default.createElement(_Icon2.default, { icon: 'info' })
        )
    );
}

Breadcrumb.propTypes = {
    pageName: _propTypes2.default.string,
    tutorialName: _propTypes2.default.string
};

Breadcrumb.defaultProps = {
    tutorialName: ''
};

exports.default = Breadcrumb;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Tutorial = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _Tutorial = __webpack_require__(964);

var _Tutorial2 = _interopRequireDefault(_Tutorial);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _TutorialStore = __webpack_require__(963);

var _TutorialStore2 = _interopRequireDefault(_TutorialStore);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _AppConstants = __webpack_require__(6);

var _TutorialActions = __webpack_require__(2192);

var _TutorialActions2 = _interopRequireDefault(_TutorialActions);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _BaseModal = __webpack_require__(29);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _ToggleInput = __webpack_require__(2181);

var _ToggleInput2 = _interopRequireDefault(_ToggleInput);

var _OnEnterTrigger = __webpack_require__(114);

var _OnEnterTrigger2 = _interopRequireDefault(_OnEnterTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores(params) {
    var forceHide = Boolean(params.hideMobile && _DimensionsStore2.default.isMobileWidth() || params.hideTablet && _DimensionsStore2.default.isTabletWidth() || params.hideDesktop && _DimensionsStore2.default.isDesktopWidth());

    return {
        tutorial: _TutorialStore2.default.getTutorialByName(params.name),
        dismissed: _TutorialStore2.default.isTutorialDismissed(params.name),
        forceHide: forceHide
    };
}

var Tutorial = exports.Tutorial = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Tutorial, _React$PureComponent);

    function Tutorial() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Tutorial);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            open: _this.props.tutorial && _this.props.tutorial.defaultOpen && !_this.props.dismissed,
            dismissed: _this.props.dismissed,
            tutorial: _this.props.tutorial
        }, _this.toggleModal = function () {
            var open = !_this.state.open;
            var _this$state = _this.state,
                tutorial = _this$state.tutorial,
                dismissed = _this$state.dismissed;

            _TutorialActions2.default.toggle(_this.props.name, {
                open: open,
                dismissed: dismissed,
                lastStage: tutorial.stageCount(),
                currentStage: tutorial.currentIndex + 1
            });
            _this.setState({
                open: open,
                tutorial: _this.state.tutorial.setCurrentStage(0)
            });
        }, _this.handleDismissedToggle = function () {
            _this.setState({ dismissed: !_this.state.dismissed });
        }, _this.movePrev = function () {
            _this.setState({ tutorial: _this.state.tutorial.moveToPrev() });
        }, _this.moveNext = function () {
            _this.setState({ tutorial: _this.state.tutorial.moveToNext() });
        }, _this.handleKeyDown = function (event) {
            if (_this.props.tutorial && event.keyCode === _AppConstants.KeyCodes.LEFT_ARROW) {
                _this.movePrev();
            }

            if (_this.props.tutorial && event.keyCode === _AppConstants.KeyCodes.RIGHT_ARROW) {
                _this.moveNext();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Tutorial.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.tutorial && !newProps.dismissed && newProps.dismissed !== this.props.dismissed) {
            this.setState({
                open: false,
                dismissed: newProps.dismissed
            });
        }
    };

    Tutorial.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    };

    Tutorial.prototype.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    };

    Tutorial.prototype.renderHeader = function renderHeader(currentStage) {
        var tutorial = this.state.tutorial;

        return _react2.default.createElement(
            'h1',
            { className: 'modal-title text-left' },
            (0, _I18n2.default)(currentStage.title),
            !tutorial.hideProgression && _react2.default.createElement(
                'span',
                { className: 'pull-right' },
                '(' + (tutorial.currentIndex + 1) + '/' + tutorial.stageCount() + ')'
            )
        );
    };

    Tutorial.prototype.renderFooter = function renderFooter() {
        var _state = this.state,
            dismissed = _state.dismissed,
            tutorial = _state.tutorial;

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: 'pull-left' },
                _react2.default.createElement(
                    'span',
                    { className: 'pull-left' },
                    _react2.default.createElement(
                        _Button2.default,
                        {
                            bsStyle: 'default',
                            onClick: this.toggleModal,
                            className: 'close btn-md' },
                        (0, _I18n2.default)('button.text.close')
                    ),
                    '\xA0\xA0'
                ),
                tutorial.showToggle() && _react2.default.createElement(_ToggleInput2.default, { checked: dismissed, label: (0, _I18n2.default)('tutorial.dismiss-checkbox-label'), onChange: this.handleDismissedToggle })
            ),
            _react2.default.createElement(
                'span',
                { className: 'pull-right' },
                tutorial.hasPrev() && _react2.default.createElement(
                    'span',
                    null,
                    '\xA0',
                    _react2.default.createElement(
                        _Button2.default,
                        {
                            bsStyle: 'default',
                            onClick: this.movePrev,
                            className: 'close btn-md btn-primary' },
                        (0, _I18n2.default)('button.text.prev-tip')
                    )
                ),
                tutorial.hasNext() && _react2.default.createElement(
                    'span',
                    null,
                    '\xA0',
                    _react2.default.createElement(
                        _Button2.default,
                        {
                            bsStyle: 'default',
                            onClick: this.moveNext,
                            className: 'close btn-md btn-primary' },
                        (0, _I18n2.default)('button.text.next-tip')
                    )
                )
            )
        );
    };

    Tutorial.prototype.render = function render() {
        var _props = this.props,
            forceHide = _props.forceHide,
            tutorial = _props.tutorial,
            notAccessible = _props.notAccessible;

        if (forceHide || !tutorial) {
            return null;
        }

        var stage = this.state.tutorial.getCurrentStage();
        var modalProps = {
            show: this.state.open,
            onClose: this.toggleModal,
            className: 'modal--sm tutorial-modal',
            header: this.renderHeader(stage),
            footer: this.renderFooter()
        };
        var imageName = _config2.default.get('brand') + '/' + this.props.name + '-' + stage.name + '.png';

        var accessibilityProps = {};
        if (notAccessible) {
            (0, _assign2.default)(accessibilityProps, { tabIndex: "-1", ariaHidden: "true" });
        }

        return _react2.default.createElement(
            'span',
            { className: 'tutorial ' + this.props.className },
            _react2.default.createElement(
                _OnEnterTrigger2.default,
                (0, _extends3.default)({ element: 'span', className: 'tutorial__trigger', role: 'button', onClick: this.toggleModal }, accessibilityProps),
                this.props.children
            ),
            _react2.default.createElement(
                _BaseModal2.default,
                modalProps,
                stage.image && !stage.video && _react2.default.createElement(
                    'div',
                    { className: 'tutorial-modal__image' },
                    _react2.default.createElement('span', { className: 'image', style: { backgroundImage: 'url(/images/tutorials/' + imageName + ')' } }),
                    _react2.default.createElement('span', { className: 'loader' })
                ),
                stage.video && !stage.image && _react2.default.createElement(
                    'div',
                    { className: 'tutorial-modal__image' },
                    _react2.default.createElement('iframe', { height: '280', width: '100%', className: 'image', src: 'https://www.youtube.com/embed/' + stage.video + '?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3', frameBorder: '0', allow: 'autoplay; encrypted-media', allowFullscreen: true }),
                    _react2.default.createElement('span', { className: 'loader' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _I18n2.default)(stage.text)
                )
            )
        );
    };

    return Tutorial;
}(_react2.default.PureComponent), _class.propTypes = {
    name: _propTypes2.default.string.isRequired,
    tutorial: _propTypes2.default.instanceOf(_Tutorial2.default),
    dismissed: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    hideMobile: _propTypes2.default.bool,
    hideTablet: _propTypes2.default.bool,
    hideDesktop: _propTypes2.default.bool,
    forceHide: _propTypes2.default.bool,
    notAccessible: _propTypes2.default.bool
}, _class.defaultProps = {
    tutorial: null,
    className: '',
    children: null,
    dismissed: false,
    hideMobile: false,
    hideTablet: false,
    hideDesktop: false,
    forceHide: false,
    notAccessible: false
}, _temp2);
exports.default = (0, _connectToStores2.default)([_TutorialStore2.default, _DimensionsStore2.default], _getStateFromStores)(Tutorial);

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleInput = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(ToggleInput, _React$PureComponent);

    function ToggleInput() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ToggleInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            checked: !!_this.props.checked
        }, _this._handleChange = function () {
            var checked = _this.state.checked;
            var _this$props = _this.props,
                field = _this$props.field,
                index = _this$props.index;


            var dynamicArguments = function dynamicArguments() {
                /* passing field name, toggle status and index of the element if necessary
                (used for photocards, but it can be useful for other iterable element). */
                if (_this.props.field) {
                    return [field, !checked, index];
                } else {
                    return !checked;
                }
            };

            if (!_this.props.disabled) {
                var _this$props$onChange;

                _this.setState({ checked: !checked }, (_this$props$onChange = _this.props.onChange).bind.apply(_this$props$onChange, [null].concat(dynamicArguments())));
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ToggleInput.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.checked !== this.props.checked) {
            this.setState({ checked: !!newProps.checked });
        }
    };

    ToggleInput.prototype.render = function render() {
        var _props = this.props,
            value = _props.value,
            ariaLabel = _props.ariaLabel,
            label = _props.label,
            labelClassName = _props.labelClassName,
            className = _props.className,
            disabled = _props.disabled,
            disableInputOnly = _props.disableInputOnly,
            onClick = _props.onClick,
            onChangeOverride = _props.onChangeOverride;
        var checked = this.state.checked;

        var containerClasses = (0, _classnames2.default)(className, 'clearfix', 'toggle', {
            'toggle--checked': checked,
            'toggle--disabled': disabled && !disableInputOnly
        });

        return _react2.default.createElement(
            'div',
            { className: containerClasses },
            _react2.default.createElement('input', { type: 'checkbox',
                id: value,
                className: (0, _classnames2.default)({ 'toggle--disabled': disabled && disableInputOnly }),
                name: value,
                defaultChecked: checked,
                onChange: onChangeOverride || this._handleChange,
                onClick: onClick }),
            _react2.default.createElement(
                'div',
                { className: 'toggle-inner-wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'toggle__lane pull-left' },
                    _react2.default.createElement('div', { className: 'otrl otrl-rotate-90 otrl-remove' }),
                    _react2.default.createElement('div', { className: 'toggle__handle' }),
                    _react2.default.createElement('div', { className: 'otrl otrl-select' })
                ),
                _react2.default.createElement(
                    'label',
                    { htmlFor: value, 'aria-label': ariaLabel, className: labelClassName },
                    label
                )
            )
        );
    };

    return ToggleInput;
}(_react2.default.PureComponent), _class.propTypes = {
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.object.isRequired]),
    ariaLabel: _propTypes2.default.string,
    field: _propTypes2.default.string,
    labelClassName: _propTypes2.default.string,
    checked: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    disableInputOnly: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    className: _propTypes2.default.string,
    onChangeOverride: _propTypes2.default.func,
    index: _propTypes2.default.number
}, _class.defaultProps = {
    value: '',
    label: '',
    ariaLabel: '',
    field: '',
    labelClassName: '',
    defaultChecked: true,
    onChange: _noop3.default,
    onClick: _noop3.default,
    className: '',
    disabled: false,
    disableInputOnly: false
}, _temp2);
exports.default = ToggleInput;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _Railcard1617Service = __webpack_require__(2226);

var _Railcard1617Service2 = _interopRequireDefault(_Railcard1617Service);

var _AccountRailcard = __webpack_require__(437);

var _AccountRailcard2 = _interopRequireDefault(_AccountRailcard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Railcard1617Actions = {
    addGuestRailcard: function addGuestRailcard(guestRailcardForm) {
        var railcard = new _AccountRailcard2.default({
            firstName: guestRailcardForm.get('firstName'),
            isGuest: true,
            lastName: guestRailcardForm.get('lastName'),
            railcardCode: _AppConstants.RAILCARD1617_CODE,
            railcardNumber: guestRailcardForm.get('railcardNumber')
        });

        _AppDispatcher2.default.dispatch({
            railcard: railcard,
            actionType: _AppConstants.ActionTypes.RAILCARD1617_LOADED
        });
    },
    load: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var railcards;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(user && user.id)) {
                                _context.next = 14;
                                break;
                            }

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_LOAD_STARTED });
                            _context.prev = 2;
                            _context.next = 5;
                            return _Railcard1617Service2.default.getRailcards(user);

                        case 5:
                            railcards = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                railcards: railcards,
                                actionType: _AppConstants.ActionTypes.RAILCARD1617_LOADED
                            });
                            return _context.abrupt('return', railcards);

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](2);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_LOAD_FAILED });
                            throw _context.t0;

                        case 14:
                            return _context.abrupt('return', null);

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[2, 10]]);
        }));

        function load(_x) {
            return _ref.apply(this, arguments);
        }

        return load;
    }(),
    flashCheckbox: function flashCheckbox(_flashCheckbox) {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_FLASH_CHECKBOX, flashCheckbox: _flashCheckbox });
    },
    remove: function remove() {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_REMOVE });
    },
    resetValidation: function resetValidation() {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_RESET_VALIDATION });
    },
    linkToAccount: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
            var firstName = _ref2.firstName,
                lastName = _ref2.lastName,
                railcardNumber = _ref2.railcardNumber,
                sync = _ref2.sync,
                expiryDate = _ref2.expiryDate,
                user = _ref2.user;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(user && user.id)) {
                                _context2.next = 10;
                                break;
                            }

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _Railcard1617Service2.default.linkToAccount({
                                firstName: firstName,
                                lastName: lastName,
                                railcardNumber: railcardNumber,
                                syncWithKeygo: sync,
                                user: user,
                                expiryDate: expiryDate.format('YYYY-MM-DD')
                            });

                        case 4:
                            return _context2.abrupt('return', _context2.sent);

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_VALIDATION_FAILED, message: _context2.t0.message });

                        case 10:
                            return _context2.abrupt('return', null);

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 7]]);
        }));

        function linkToAccount(_x2) {
            return _ref3.apply(this, arguments);
        }

        return linkToAccount;
    }(),
    syncWithKeyGo: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref4) {
            var railcardId = _ref4.railcardId,
                userId = _ref4.userId;
            var response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!userId) {
                                _context3.next = 5;
                                break;
                            }

                            _context3.next = 3;
                            return _Railcard1617Service2.default.syncWithKeyGo({ railcardId: railcardId, userId: userId });

                        case 3:
                            response = _context3.sent;
                            return _context3.abrupt('return', response !== null);

                        case 5:
                            return _context3.abrupt('return', false);

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function syncWithKeyGo(_x3) {
            return _ref5.apply(this, arguments);
        }

        return syncWithKeyGo;
    }(),
    setChecked: function setChecked(checked) {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_CHECKED, checked: checked });
    },
    validate: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref6) {
            var railcardNumber = _ref6.railcardNumber,
                firstName = _ref6.firstName,
                lastName = _ref6.lastName,
                expiryDate = _ref6.expiryDate;
            var response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_VALIDATION_STARTED });
                            _context4.prev = 1;
                            _context4.next = 4;
                            return _Railcard1617Service2.default.validate({ railcardNumber: railcardNumber, firstName: firstName, lastName: lastName, expiryDate: expiryDate });

                        case 4:
                            response = _context4.sent;

                            if (!response.isValid) {
                                _context4.next = 10;
                                break;
                            }

                            _AppDispatcher2.default.dispatch({
                                railcardNumber: railcardNumber,
                                firstName: firstName,
                                lastName: lastName,
                                expiryDate: response.get('expiryDate'),
                                actionType: _AppConstants.ActionTypes.RAILCARD1617_VALIDATION_COMPLETED
                            });
                            return _context4.abrupt('return', true);

                        case 10:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_VALIDATION_FAILED, message: 'booking.railcard1617.errors.invalid' });

                        case 11:
                            _context4.next = 16;
                            break;

                        case 13:
                            _context4.prev = 13;
                            _context4.t0 = _context4['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARD1617_VALIDATION_FAILED });

                        case 16:
                            return _context4.abrupt('return', false);

                        case 17:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[1, 13]]);
        }));

        function validate(_x4) {
            return _ref7.apply(this, arguments);
        }

        return validate;
    }()
};

exports.default = Railcard1617Actions;

/***/ }),
/* 2183 */,
/* 2184 */,
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.OpenSearchRecordShape = exports.OpenSearchRecord = undefined;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _LinkMapper = __webpack_require__(8);

var _SearchUrls = __webpack_require__(97);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    adults: 1,
    children: 0,
    destination: new _Station2.default(),
    origin: new _Station2.default(),
    railcards: new _immutable.List()
}; /* eslint-disable no-unused-vars */

var OpenSearchRecord = exports.OpenSearchRecord = function (_record) {
    (0, _inherits3.default)(OpenSearchRecord, _record);

    function OpenSearchRecord() {
        (0, _classCallCheck3.default)(this, OpenSearchRecord);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    OpenSearchRecord.prototype.serialize = function serialize() {
        return (0, _SearchUrls.serialize)({
            origin: _SearchUrls.serializers.station,
            adults: _SearchUrls.serializers.identity,
            children: _SearchUrls.serializers.identity,
            railcards: _SearchUrls.serializers.railcards
        }, this);
    };

    /**
     * Return a promise that resolves to a new Search, from the url params
     */


    OpenSearchRecord.deserialize = function deserialize(params, query) {
        var source = (0, _assign2.default)({}, query, params);
        var schema = {
            origin: _SearchUrls.deserializers.station,
            adults: _SearchUrls.deserializers.int,
            children: _SearchUrls.deserializers.int,
            railcards: _SearchUrls.deserializers.railcards
        };

        return (0, _SearchUrls.deserialize)(schema, source).then(function (deserialized) {
            return new OpenSearchRecord(deserialized);
        });
    };

    OpenSearchRecord.prototype.getComputedValues = function getComputedValues() {
        return {
            adults: _LinkMapper.fields.number,
            children: _LinkMapper.fields.number,
            destination: this.destination.getName(),
            origin: this.origin.getName(),
            railcards: _LinkMapper.resolveAll.as(_PassengerRailcard2.default)
        };
    };

    OpenSearchRecord.prototype.getSchema = function getSchema() {
        return {
            // date: validators.required(),
            time: _validation2.default.required(),
            origin: _validation2.default.requiredString(),
            submitted: _validation2.default.optional()
        };
    };

    OpenSearchRecord.prototype.isValid = function isValid() {
        return !this.origin.isEmpty();
    };

    return OpenSearchRecord;
}((0, _immutable.Record)(defaults));

var OpenSearchRecordShape = exports.OpenSearchRecordShape = _propTypes2.default.shape({
    destination: _propTypes2.default.instanceOf(_Station2.default).isRequired,
    origin: _propTypes2.default.instanceOf(_Station2.default).isRequired
});

(0, _assign2.default)(OpenSearchRecord.prototype, _ValidationMixin2.default);

exports.default = OpenSearchRecord;

/***/ }),
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TutorialActions = {
    toggle: function toggle(tutorialName, _ref) {
        var open = _ref.open,
            dismissed = _ref.dismissed,
            lastStage = _ref.lastStage,
            currentStage = _ref.currentStage;

        _AppDispatcher2.default.dispatch({
            tutorialName: tutorialName,
            open: open,
            dismissed: dismissed,
            lastStage: lastStage,
            currentStage: currentStage,
            actionType: _AppConstants.ActionTypes.TUTORIAL_TOGGLE
        });
    }
};

exports.default = TutorialActions;

/***/ }),
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _DaySaveService = __webpack_require__(2235);

var _DaySaveService2 = _interopRequireDefault(_DaySaveService);

var _DaySaveSearch = __webpack_require__(420);

var _DaySaveSearch2 = _interopRequireDefault(_DaySaveSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DaySaveActions = {
    loadFromParams: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
            var search;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _DaySaveSearch2.default.deserialize(params);

                        case 2:
                            search = _context.sent;
                            return _context.abrupt('return', this.load(search));

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadFromParams(_x) {
            return _ref.apply(this, arguments);
        }

        return loadFromParams;
    }(),
    load: function load(search) {
        _AppDispatcher2.default.dispatch({
            search: search,
            actionType: _AppConstants.ActionTypes.DAYSAVE_SEARCH_LOADED
        });
        return search;
    },
    search: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_search) {
            var result;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DAYSAVE_SEARCH_STARTED,
                                search: _search
                            });

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _DaySaveService2.default.search(_search);

                        case 4:
                            result = _context2.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DAYSAVE_SEARCH_FINISHED,
                                search: _search,
                                searchResults: result
                            });

                            return _context2.abrupt('return', result);

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.DAYSAVE_SEARCH_FAILED,
                                search: _search,
                                error: _context2.t0
                            });
                            throw _context2.t0;

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 9]]);
        }));

        function search(_x2) {
            return _ref2.apply(this, arguments);
        }

        return search;
    }(),
    selectTicket: function selectTicket(fare) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.DAYSAVE_TICKET_SELECTED,
            fare: fare
        });
    }
};

exports.default = DaySaveActions;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _RoversRangersService = __webpack_require__(2238);

var _RoversRangersService2 = _interopRequireDefault(_RoversRangersService);

var _RoversRangersSearch = __webpack_require__(595);

var _RoversRangersSearch2 = _interopRequireDefault(_RoversRangersSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoversRangersActions = {
    loadFromParams: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
            var search;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _RoversRangersSearch2.default.deserialize(params);

                        case 2:
                            search = _context.sent;
                            return _context.abrupt('return', this.load(search));

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadFromParams(_x) {
            return _ref.apply(this, arguments);
        }

        return loadFromParams;
    }(),
    load: function load(search) {
        _AppDispatcher2.default.dispatch({
            search: search,
            actionType: _AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_LOADED
        });
        return search;
    },
    search: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_search) {
            var result;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_STARTED,
                                search: _search
                            });

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _RoversRangersService2.default.search(_search);

                        case 4:
                            result = _context2.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_FINISHED,
                                search: _search,
                                searchResults: result
                            });

                            return _context2.abrupt('return', result);

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.ROVERSRANGERS_SEARCH_FAILED,
                                search: _search,
                                error: _context2.t0
                            });

                            throw _context2.t0;

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 9]]);
        }));

        function search(_x2) {
            return _ref2.apply(this, arguments);
        }

        return search;
    }(),
    selectTicket: function selectTicket(fare) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.ROVERSRANGERS_TICKET_SELECTED,
            fare: fare
        });
    },
    changePassengers: function changePassengers(pax) {
        _AppDispatcher2.default.dispatch({
            pax: pax,
            actionType: _AppConstants.ActionTypes.ROVERSRANGERS_TICKET_PASSENGERS_CHANGED
        });
    }
};

exports.default = RoversRangersActions;

/***/ }),
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(331),
    copyObject = __webpack_require__(229),
    createAssigner = __webpack_require__(970),
    isArrayLike = __webpack_require__(143),
    isPrototype = __webpack_require__(330),
    keys = __webpack_require__(127);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 2207 */,
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _OpenGolfService = __webpack_require__(2265);

var _OpenGolfService2 = _interopRequireDefault(_OpenGolfService);

var _OpenSearchRecord = __webpack_require__(2185);

var _OpenSearchRecord2 = _interopRequireDefault(_OpenSearchRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenGolfActions = {
    loadFromParams: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
            var openSearch;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _OpenSearchRecord2.default.deserialize(params);

                        case 2:
                            openSearch = _context.sent;
                            return _context.abrupt('return', openSearch);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadFromParams(_x) {
            return _ref.apply(this, arguments);
        }

        return loadFromParams;
    }(),
    addLoadingTrip: function addLoadingTrip(trip) {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.OPEN_GOLF_ADD_TRIP,
            trip: trip
        });
    },
    getTickets: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(search) {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.OPEN_GOLF_GET_TICKETS_STARTED
                            });

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _OpenGolfService2.default.getTickets(search);

                        case 4:
                            response = _context2.sent;


                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.OPEN_GOLF_GET_TICKETS_ENDED,
                                tickets: response
                            });
                            _context2.next = 11;
                            break;

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.OPEN_GOLF_GET_TICKETS_FAILED,
                                error: _context2.t0
                            });

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 8]]);
        }));

        function getTickets(_x2) {
            return _ref2.apply(this, arguments);
        }

        return getTickets;
    }()
};

exports.default = OpenGolfActions;

/***/ }),
/* 2209 */,
/* 2210 */,
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(687);
module.exports = __webpack_require__(2212);


/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {


        __webpack_require__(53).default = __webpack_require__(1398);
        __webpack_require__(2213);
        
    

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _app = __webpack_require__(1408);

var _app2 = _interopRequireDefault(_app);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QUICK_SKELETON_UI_DISMISS_MS = 100;
var SLOW_SKELETON_UI_DISMISS_MS = 500;

function onInit() {
    var stores = {};
    var storesContext = __webpack_require__(1668);
    storesContext.keys().forEach(function (file) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        // Load store module
        var module = storesContext.apply(undefined, [file].concat(args));

        var _file$match = file.match(/\/(.*)\.js$/),
            storeName = _file$match[1];

        stores[storeName] = module.default;
    });

    if (_config2.default.get('debug')) {
        // Expose stores & config globally
        (0, _assign2.default)(window.OTRL, { stores: stores, config: _config2.default });
    }
}

var dismissSkeletonUI = function dismissSkeletonUI() {
    var now = new Date();
    var skeleontUITimeout = QUICK_SKELETON_UI_DISMISS_MS;
    if (window.otrlWidgetStartDate) {
        var widgetLoadTimeMs = now.getTime() - window.otrlWidgetStartDate.getTime();
        if (widgetLoadTimeMs > 2000) {
            // If it took longer to load the widget postpone hiding the skeleton UI
            // so React has enough time to render the widget first so the skeleton UI
            // is transitioning to already rendered widget and not an empty canvas.
            //
            // For most cases this will happen on a slow network connection
            // or for first-time users.
            skeleontUITimeout = SLOW_SKELETON_UI_DISMISS_MS;
        }
    }
    setTimeout(function () {
        return document.querySelector('.skeleton').classList.add('skeleton--hide');
    }, skeleontUITimeout);
};

function onRender(containerEl) {
    var renderApp = function renderApp() {
        var Root = __webpack_require__(2214).default;
        dismissSkeletonUI();
        (0, _reactDom.render)(_react2.default.createElement(Root, null), containerEl);
    };

    if (false) {
        module.hot.accept('./components/Root.js', renderApp);
    }
    renderApp();
}

var app = window.OTRL = (0, _app2.default)(onInit, onRender);
exports.default = app;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(645);

var _useRouterHistory = __webpack_require__(581);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

var _history = __webpack_require__(1906);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _routes = __webpack_require__(2215);

var _routes2 = _interopRequireDefault(_routes);

var _GlobalErrorBoundary = __webpack_require__(2163);

var _GlobalErrorBoundary2 = _interopRequireDefault(_GlobalErrorBoundary);

var _RefocusRouteContent = __webpack_require__(2171);

var _RefocusRouteContent2 = _interopRequireDefault(_RefocusRouteContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Root = function (_React$PureComponent) {
    (0, _inherits3.default)(Root, _React$PureComponent);

    function Root() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Root);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.history = (0, _useRouterHistory2.default)(_history.createHistory)({
            basename: _config2.default.get('baseHref')
        }), _this.specialRender = function (props) {
            return _react2.default.createElement(
                _RefocusRouteContent2.default,
                { routes: props.routes },
                _react2.default.createElement(_reactRouter.RouterContext, props)
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks


    Root.prototype.render = function render() {
        return _react2.default.createElement(
            _GlobalErrorBoundary2.default,
            null,
            _react2.default.createElement(_reactRouter.Router, { history: this.history, routes: _routes2.default, render: this.specialRender })
        );
    };

    return Root;
}(_react2.default.PureComponent);

exports.default = Root;

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _helpers = __webpack_require__(60);

var _App = __webpack_require__(1909);

var _App2 = _interopRequireDefault(_App);

var _AppConstants = __webpack_require__(6);

var _AppActions = __webpack_require__(390);

var _AppActions2 = _interopRequireDefault(_AppActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dynamic routing setup - only load code for a route when its needed
 * @see https://github.com/rackt/react-router/blob/master/docs/guides/advanced/DynamicRouting.md
 */

var rootRoute = {
    component: _App2.default,
    path: '/',

    //Redirect / to /search
    indexRoute: (0, _helpers.redirectRoute)(null, _AppConstants.PointStages.SEARCH),

    onEnter: function onEnter(_ref) {
        var location = _ref.location;

        if (location.query) {
            var featureFlags = (0, _keys2.default)(location.query).filter(function (param) {
                return param.startsWith('feature.');
            });
            featureFlags.forEach(function (param) {
                var feature = param.replace('feature.', '');
                var featureValue = location.query[param];
                _AppActions2.default.toggleFeature(feature, !!featureValue.match(/^(?:yes|true|on|1)$/i));
            });
        }
    },


    childRoutes: [__webpack_require__(2216), __webpack_require__(2217), __webpack_require__(2218), __webpack_require__(2219), __webpack_require__(2220), __webpack_require__(2221), __webpack_require__(2222), __webpack_require__(2223), __webpack_require__(2224), __webpack_require__(2225), __webpack_require__(2229), __webpack_require__(2230), __webpack_require__(2231), __webpack_require__(2232), __webpack_require__(2233), __webpack_require__(2234), __webpack_require__(2236), __webpack_require__(2237), __webpack_require__(2239), __webpack_require__(2240), __webpack_require__(2241), __webpack_require__(2242), __webpack_require__(2243), __webpack_require__(2244), __webpack_require__(2245), __webpack_require__(2246), __webpack_require__(2249), __webpack_require__(2250), __webpack_require__(2251), __webpack_require__(2252), __webpack_require__(2254), __webpack_require__(2255), __webpack_require__(2257), __webpack_require__(2259), __webpack_require__(2260), __webpack_require__(2261), __webpack_require__(2262), __webpack_require__(2263), __webpack_require__(2264), __webpack_require__(2266),

    //Any not found route goes to search
    (0, _helpers.redirectRoute)('/**', _AppConstants.PointStages.SEARCH)].filter(function (x) {
        return !!x;
    }) //Remove any null routes
};

exports.default = rootRoute;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__(43);

var _keys2 = _interopRequireDefault(_keys);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _SearchActions = __webpack_require__(426);

var _SearchActions2 = _interopRequireDefault(_SearchActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.PointStages.INIT, {
    onEnter: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref, replace, callback) {
            var location = _ref.location,
                params = _ref.params;
            var definedParams;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            definedParams = (0, _keys2.default)(params).filter(function (key) {
                                return params[key] !== undefined;
                            });

                            if (!definedParams.length) {
                                _context.next = 5;
                                break;
                            }

                            _context.next = 5;
                            return _SearchActions2.default.loadFromParams(params, location.query);

                        case 5:
                            _context.next = 10;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            console.error(_context.t0);

                        case 10:

                            replace(_urls2.default.location(_AppConstants.PointStages.SEARCH));
                            callback();

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 7]]);
        }));

        function onEnter(_x, _x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _SearchActions = __webpack_require__(426);

var _SearchActions2 = _interopRequireDefault(_SearchActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.PointStages.SEARCH, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(9).then((function (require) {
            cb(null, __webpack_require__(2301).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextState) {
            var query;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            query = nextState.location.query;


                            if (query.promoCode) {
                                // pre fill and pre validate promo input on the main page if there's promoCode query param
                                _SearchActions2.default.preFillPromoFromQuery(query);
                            }

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter(_x) {
            return _ref.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(60);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.PointStages.RESULTS, {
    onEnter: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref, replace) {
            var params = _ref.params,
                location = _ref.location;
            var targetLayout, isMobileWidth, routeName;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            targetLayout = _config2.default.get('journeyPlannerDefaultLayout');
                            isMobileWidth = _DimensionsStore2.default.isMobileWidth();
                            routeName = void 0;

                            if (isMobileWidth || targetLayout === _AppConstants.JourneyPlannerLayout.LIST) {
                                routeName = _AppConstants.PointStages.CHOOSE_OUTWARD;
                            } else {
                                routeName = _AppConstants.GridPages.SERVICES;
                            }
                            replace(_urls2.default.location(routeName, params, location.query));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(60);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.PointStages.SEARCH_RESULTS, {
    onEnter: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref, replace) {
            var params = _ref.params,
                location = _ref.location;
            var targetLayout, isMobileWidth, routeName;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            targetLayout = _config2.default.get('journeyPlannerDefaultLayout');
                            isMobileWidth = _DimensionsStore2.default.isMobileWidth();
                            routeName = void 0;

                            if (isMobileWidth || targetLayout === _AppConstants.JourneyPlannerLayout.LIST) {
                                routeName = _AppConstants.PointStages.CHOOSE_OUTWARD;
                            } else {
                                routeName = _AppConstants.GridPages.SERVICES;
                            }
                            replace(_urls2.default.location(routeName, params, location.query));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _helpers = __webpack_require__(60);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

var _FeatureVariantStore = __webpack_require__(534);

var _FeatureVariantStore2 = _interopRequireDefault(_FeatureVariantStore);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

var _JourneyStore = __webpack_require__(610);

var _JourneyStore2 = _interopRequireDefault(_JourneyStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _TripActions = __webpack_require__(603);

var _TripActions2 = _interopRequireDefault(_TripActions);

var _SearchActions = __webpack_require__(426);

var _SearchActions2 = _interopRequireDefault(_SearchActions);

var _Search = __webpack_require__(421);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STYLE = 0;
var NEW_STYLE = 1;

module.exports = (0, _helpers.route)(_AppConstants.PointStages.CHOOSE_OUTWARD, {
    shouldRefocusRouteContent: function shouldRefocusRouteContent() {
        var componentVersion = _FeatureVariantStore2.default.get("serviceListVersion");
        if (componentVersion === NEW_STYLE) {
            return false;
        }
        return true;
    },
    getComponent: function getComponent(location, cb) {
        var _this = this;

        __webpack_require__.e/* require.ensure */(5).then((function (require) {
            (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var componentVersion;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_FeatureVariantStore2.default.has('serviceListVersion')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return _FeatureVariantStore2.default.triggerEvent(_AppConstants.GOTriggers.SERVICES_GRID);

                            case 3:
                                _context.next = 5;
                                return new _promise2.default(function (resolve) {
                                    return _FeatureVariantStore2.default.waitForGO(resolve, resolve);
                                });

                            case 5:
                                componentVersion = _FeatureVariantStore2.default.get("serviceListVersion");
                                // eslint-disable-next-line no-console

                                console.info('%cLoading servicelist v' + (componentVersion + 1), 'color: white; background-color: blue; font-size: 1.5em');
                                _context.t0 = componentVersion;
                                _context.next = _context.t0 === NEW_STYLE ? 10 : _context.t0 === DEFAULT_STYLE ? 11 : 11;
                                break;

                            case 10:
                                return _context.abrupt('return', cb(null, __webpack_require__(2302).default));

                            case 11:
                                return _context.abrupt('return', cb(null, __webpack_require__(2303).default));

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    },
    onComponentLoad: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(nextState, replace, callback) {
            var forcePlusBus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var params, location, search, trip, user;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            params = nextState.params, location = nextState.location;
                            _context2.next = 3;
                            return _SearchActions2.default.loadFromParams(params, location.query);

                        case 3:
                            search = _context2.sent;


                            if (search.targetLayout !== _AppConstants.JourneyPlannerLayout.LIST) {
                                search = search.setTargetLayout(_AppConstants.JourneyPlannerLayout.LIST);
                                _SearchActions2.default.update(search);
                            }
                            if (!search.isValid()) {
                                replace(_urls2.default.location(_AppConstants.PointStages.SEARCH, null, location.query));
                            }

                            trip = _CurrentTripStore2.default.get().set('listStep', location.query.step);

                            _TripActions2.default.updateTrip(trip);

                            if (_JourneyStore2.default.isCurrentSearch(search)) {
                                _context2.next = 27;
                                break;
                            }

                            _context2.prev = 9;
                            user = _UserStore2.default.getCurrent();
                            _context2.next = 13;
                            return _SearchActions2.default.search({ search: search, user: user });

                        case 13:
                            if (trip.isPlusBusAvailable()) {
                                _TripActions2.default.loadPlusBusAvailability(trip);
                            }
                            (0, _defer3.default)(callback);
                            _context2.next = 25;
                            break;

                        case 17:
                            _context2.prev = 17;
                            _context2.t0 = _context2['catch'](9);

                            replace(_urls2.default.location(_AppConstants.PointStages.SEARCH, null, location.query));

                            if (!(_context2.t0 instanceof _Search.InvalidSearchError)) {
                                _context2.next = 24;
                                break;
                            }

                            console.error(_context2.t0);
                            _context2.next = 25;
                            break;

                        case 24:
                            throw _context2.t0;

                        case 25:
                            _context2.next = 28;
                            break;

                        case 27:
                            if (forcePlusBus && trip.isPlusBusAvailable()) {
                                _TripActions2.default.loadPlusBusAvailability(trip);
                            }

                        case 28:
                            (0, _defer3.default)(callback);

                        case 29:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[9, 17]]);
        }));

        function onComponentLoad(_x2, _x3, _x4) {
            return _ref2.apply(this, arguments);
        }

        return onComponentLoad;
    }(),
    onEnter: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(nextState, replace, callback) {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.onComponentLoad(nextState, replace, callback, true);

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function onEnter(_x5, _x6, _x7) {
            return _ref3.apply(this, arguments);
        }

        return onEnter;
    }(),
    onChange: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(prevState, nextState, replace, callback) {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            this.onComponentLoad(nextState, replace, callback);

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function onChange(_x8, _x9, _x10, _x11) {
            return _ref4.apply(this, arguments);
        }

        return onChange;
    }()
});

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _helpers = __webpack_require__(60);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

var _SearchActions = __webpack_require__(426);

var _SearchActions2 = _interopRequireDefault(_SearchActions);

var _TripActions = __webpack_require__(603);

var _TripActions2 = _interopRequireDefault(_TripActions);

var _JourneyStore = __webpack_require__(610);

var _JourneyStore2 = _interopRequireDefault(_JourneyStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _CurrentTripStore = __webpack_require__(175);

var _CurrentTripStore2 = _interopRequireDefault(_CurrentTripStore);

var _FeatureVariantStore = __webpack_require__(534);

var _FeatureVariantStore2 = _interopRequireDefault(_FeatureVariantStore);

var _Search = __webpack_require__(421);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLayoutName = function getLayoutName(version) {
    switch (version) {
        case 1:
            return _AppConstants.JourneyPlannerLayout.GRID_2;
        default:
            return _AppConstants.JourneyPlannerLayout.GRID_2;
    }
};

module.exports = (0, _helpers.route)(_AppConstants.GridPages.SERVICES, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(6).then((function (require) {
            (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var componentVersion, layoutName;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_FeatureVariantStore2.default.has('gridView')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return _FeatureVariantStore2.default.triggerEvent(_AppConstants.GOTriggers.SERVICES_GRID);

                            case 3:
                                _context.next = 5;
                                return new _promise2.default(function (resolve) {
                                    return _FeatureVariantStore2.default.waitForGO(resolve, resolve);
                                });

                            case 5:
                                componentVersion = _FeatureVariantStore2.default.get("gridViewVersion");
                                // eslint-disable-next-line no-console

                                console.info('%cLoading grid v' + (componentVersion + 1), 'color: white; background-color: blue; font-size: 1.5em');
                                layoutName = getLayoutName(componentVersion);
                                _context.t0 = layoutName;
                                _context.next = _context.t0 === _AppConstants.JourneyPlannerLayout.GRID_2 ? 11 : 11;
                                break;

                            case 11:
                                return _context.abrupt('return', cb(null, __webpack_require__(2304).default));

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }))();
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    },
    onComponentLoad: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(nextState, replace, callback) {
            var _this = this;

            var forcePlusBus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var params, location, refreshSearchFromUrl;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            params = nextState.params, location = nextState.location;

                            refreshSearchFromUrl = function () {
                                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(targetLayout) {
                                    var query, search, trip, user;
                                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    query = (0, _extends3.default)({}, location.query, { targetLayout: targetLayout });
                                                    _context2.next = 3;
                                                    return _SearchActions2.default.loadFromParams(params, query);

                                                case 3:
                                                    search = _context2.sent;

                                                    if (!search.isValid()) {
                                                        replace(_urls2.default.location(_AppConstants.PointStages.SEARCH, null, location.query));
                                                    }

                                                    trip = _CurrentTripStore2.default.get();

                                                    if (_JourneyStore2.default.isCurrentSearch(search)) {
                                                        _context2.next = 25;
                                                        break;
                                                    }

                                                    _context2.prev = 7;
                                                    user = _UserStore2.default.getCurrent();
                                                    _context2.next = 11;
                                                    return _SearchActions2.default.search({ search: search, user: user });

                                                case 11:
                                                    if (trip.isPlusBusAvailable()) {
                                                        _TripActions2.default.loadPlusBusAvailability(trip);
                                                    }
                                                    (0, _defer3.default)(callback);
                                                    _context2.next = 23;
                                                    break;

                                                case 15:
                                                    _context2.prev = 15;
                                                    _context2.t0 = _context2['catch'](7);

                                                    replace(_urls2.default.location(_AppConstants.PointStages.SEARCH, null, location.query));

                                                    if (!(_context2.t0 instanceof _Search.InvalidSearchError)) {
                                                        _context2.next = 22;
                                                        break;
                                                    }

                                                    console.error(_context2.t0);
                                                    _context2.next = 23;
                                                    break;

                                                case 22:
                                                    throw _context2.t0;

                                                case 23:
                                                    _context2.next = 26;
                                                    break;

                                                case 25:
                                                    if (trip.isPlusBusAvailable() && forcePlusBus) {
                                                        _TripActions2.default.loadPlusBusAvailability(trip);
                                                    }

                                                case 26:
                                                    (0, _defer3.default)(callback);

                                                case 27:
                                                case 'end':
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, _this, [[7, 15]]);
                                }));

                                return function refreshSearchFromUrl(_x5) {
                                    return _ref3.apply(this, arguments);
                                };
                            }();

                            (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                                var componentVersion;
                                return _regenerator2.default.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                if (!_FeatureVariantStore2.default.has('gridView')) {
                                                    _context3.next = 5;
                                                    break;
                                                }

                                                _context3.next = 3;
                                                return _FeatureVariantStore2.default.triggerEvent(_AppConstants.GOTriggers.SERVICES_GRID);

                                            case 3:
                                                _context3.next = 5;
                                                return new _promise2.default(function (resolve) {
                                                    return _FeatureVariantStore2.default.waitForGO(resolve, resolve);
                                                });

                                            case 5:
                                                componentVersion = _FeatureVariantStore2.default.get("gridViewVersion");
                                                return _context3.abrupt('return', refreshSearchFromUrl(getLayoutName(componentVersion)));

                                            case 7:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, this);
                            }))();

                        case 3:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function onComponentLoad(_x2, _x3, _x4) {
            return _ref2.apply(this, arguments);
        }

        return onComponentLoad;
    }(),
    onEnter: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(nextState, replace, callback) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            this.onComponentLoad(nextState, replace, callback, true);

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function onEnter(_x6, _x7, _x8) {
            return _ref5.apply(this, arguments);
        }

        return onEnter;
    }(),
    onChange: function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(prevState, nextState, replace, callback) {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            this.onComponentLoad(nextState, replace, callback);

                        case 1:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function onChange(_x9, _x10, _x11, _x12) {
            return _ref6.apply(this, arguments);
        }

        return onChange;
    }()
});

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _helpers = __webpack_require__(60);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.CheckoutStages.DELIVERY, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(10).then((function (require) {
            cb(null, __webpack_require__(2305).default);
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    },
    onEnter: function onEnter(nextState, replace) {
        if (_OrderStore2.default.getCurrent().isEmpty()) {
            replace(_urls2.default.location(_AppConstants.PointStages.SEARCH));
        }
    }
});

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _AppConstants = __webpack_require__(6);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _PaymentStore = __webpack_require__(418);

var _PaymentStore2 = _interopRequireDefault(_PaymentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(39).then((function (require) {
            cb(null, __webpack_require__(2306).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    getChildRoutes: function getChildRoutes(location, cb) {
        __webpack_require__.e/* require.ensure */(37).then((function (require) {
            cb(null, [__webpack_require__(2307), __webpack_require__(2308), __webpack_require__(2309), __webpack_require__(2310)].concat(__webpack_require__(2311)).filter(function (x) {
                return !!x;
            }));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onLeave: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onLeave() {
            return _ref.apply(this, arguments);
        }

        return onLeave;
    }(),
    onEnter: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2, replace) {
            var routes = _ref2.routes;
            var currentOrder, smartcard, isAwaitingProduct, thisRoute, paymentForm;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            currentOrder = _OrderStore2.default.getCurrent();
                            smartcard = _SmartcardStore2.default.getCurrent();
                            isAwaitingProduct = currentOrder.isSmartcard() && smartcard ? smartcard.isAwaitingProduct() : false;
                            thisRoute = routes[routes.length - 1];
                            paymentForm = _PaymentStore2.default.getForm();

                            // No order to checkout

                            if (!currentOrder || currentOrder.isEmpty()) {
                                replace(_urls2.default.location(_AppConstants.PointStages.SEARCH));
                            }

                            // Needs fulfilment details
                            else if (!currentOrder.hasFulfilment({ disableAddressCheck: true }) && !isAwaitingProduct) {
                                    replace(_urls2.default.location(_AppConstants.CheckoutStages.DELIVERY));
                                }

                                // Payment form is empty
                                else if (!paymentForm && ![_AppConstants.CheckoutStages.PAYMENT, _AppConstants.CheckoutStages.PAYMENT_AMAZON_PAY].includes(thisRoute.name)) {
                                        replace(_urls2.default.location(_AppConstants.CheckoutStages.PAYMENT));
                                    }

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function onEnter(_x, _x2) {
            return _ref3.apply(this, arguments);
        }

        return onEnter;
    }()
}; /**
    * This route without a path groups together a few payment-related routes
    * for the purposes of being able to hook into lifecycle method for the entire group
    * (e.g. entering & leaving the payment page group, ignoring transitions between payment pages)
    */

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _helpers = __webpack_require__(60);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.CheckoutStages.PAYMENT_CONFIRMATION, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(32).then((function (require) {
            cb(null, __webpack_require__(2312).default);
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    },
    onEnter: function onEnter(nextState, replace) {
        var paidOrder = _OrderStore2.default.getPaid();

        if (!paidOrder || !paidOrder.id) {
            var currentOrder = _OrderStore2.default.getCurrent();
            var redirectTo = !currentOrder || currentOrder.isEmpty() ? _AppConstants.PointStages.SEARCH : _AppConstants.CheckoutStages.PAYMENT;
            replace(_urls2.default.location(redirectTo));
        }
    }
});

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _helpers = __webpack_require__(60);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _AppConstants = __webpack_require__(6);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    path: '/account',

    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(28).then((function (require) {
            cb(null, __webpack_require__(2299).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },


    indexRoute: (0, _helpers.redirectRoute)(null, _AppConstants.AccountPages.ACCOUNT_DETAILS),

    getChildRoutes: function getChildRoutes(location, cb) {
        __webpack_require__.e/* require.ensure */(21).then((function (require) {
            cb(null, [__webpack_require__(2313), __webpack_require__(2314), __webpack_require__(2315), __webpack_require__(2316), __webpack_require__(2317), __webpack_require__(2318), __webpack_require__(2319), __webpack_require__(2320), __webpack_require__(2321), __webpack_require__(2322), __webpack_require__(2323), __webpack_require__(2324), __webpack_require__(2325), __webpack_require__(2326), __webpack_require__(2327), __webpack_require__(2328), __webpack_require__(2329), __webpack_require__(2330), __webpack_require__(2331), __webpack_require__(2332), __webpack_require__(2333), __webpack_require__(2334), __webpack_require__(2335), __webpack_require__(2336), __webpack_require__(2337), __webpack_require__(2338), __webpack_require__(2339), __webpack_require__(2340)].filter(function (x) {
                return !!x;
            }));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextState, replace, callback) {
            var user, skipRedirect, smartcard;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();
                            skipRedirect = _AppConstants.AccountPagesForceLoginInsteadOfRedirect.includes(_urls2.default.resolve(nextState.location.pathname).name);

                            if (!skipRedirect && (!user || !user.isLoggedIn())) {
                                replace(_urls2.default.location(_AppConstants.PointStages.SEARCH));
                                _ModalActions2.default.open(_AppConstants.GlobalModals.LOGIN, { initialPath: nextState.location.pathname });
                            }

                            //Load smartcards first, as the account pages expect them to be loaded

                            if (_SmartcardStore2.default.getCurrent()) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 6;
                            return _CustomerActions2.default.getSmartcard(user);

                        case 6:
                            smartcard = _context.sent;

                            if (!smartcard) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 10;
                            return _CustomerActions2.default.getAllSmartcards(user);

                        case 10:
                            callback();

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return onEnter;
    }()
};

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _immutable = __webpack_require__(5);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _LinkMapper = __webpack_require__(8);

var _AppConstants = __webpack_require__(6);

var _AuthenticatedAPIClient = __webpack_require__(58);

var _AuthenticatedAPIClient2 = _interopRequireDefault(_AuthenticatedAPIClient);

var _AccountRailcard = __webpack_require__(437);

var _AccountRailcard2 = _interopRequireDefault(_AccountRailcard);

var _RailcardValidationResponse = __webpack_require__(2227);

var _RailcardValidationResponse2 = _interopRequireDefault(_RailcardValidationResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Railcard1617Service = {
    getBaseUrl: function getBaseUrl(user) {
        return Railcard1617Service.getBaseUrlFromId(user.id);
    },
    getBaseUrlFromId: function getBaseUrlFromId(userId) {
        return '/customers/' + userId;
    },
    getRailcards: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user) {
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            endpoint = this.getBaseUrl(user) + '/season-railcards';
                            _context.next = 4;
                            return _AuthenticatedAPIClient2.default.get(endpoint);

                        case 4:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_AccountRailcard2.default));

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0 instanceof _APIClient.NotFoundError) {
                                _context.next = 12;
                                break;
                            }

                            throw _context.t0;

                        case 12:
                            return _context.abrupt('return', new _immutable.List());

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 8]]);
        }));

        function getRailcards(_x) {
            return _ref.apply(this, arguments);
        }

        return getRailcards;
    }(),
    linkToAccount: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
            var firstName = _ref2.firstName,
                lastName = _ref2.lastName,
                railcardNumber = _ref2.railcardNumber,
                expiryDate = _ref2.expiryDate,
                _ref2$syncWithKeygo = _ref2.syncWithKeygo,
                syncWithKeygo = _ref2$syncWithKeygo === undefined ? false : _ref2$syncWithKeygo,
                user = _ref2.user;
            var railcard, endpoint, response, hasErrors, isRailcardAlreadyExistError;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            railcard = {
                                firstName: firstName,
                                lastName: lastName,
                                railcardNumber: railcardNumber,
                                railcardCode: _AppConstants.RAILCARD1617_CODE,
                                syncWithKeygo: syncWithKeygo,
                                expiryDate: expiryDate
                            };
                            endpoint = this.getBaseUrl(user) + '/railcards';
                            _context2.next = 5;
                            return _AuthenticatedAPIClient2.default.postForm(endpoint, railcard);

                        case 5:
                            response = _context2.sent;
                            return _context2.abrupt('return', response);

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](0);

                            if (!(_context2.t0 instanceof _APIClient.BadRequestError)) {
                                _context2.next = 20;
                                break;
                            }

                            console.error('linkToAccouunt BadRequestError:', _context2.t0.message, _context2.t0.body);
                            hasErrors = _context2.t0.body && _context2.t0.body.errors && _context2.t0.body.errors.length;
                            isRailcardAlreadyExistError = hasErrors && _context2.t0.body.errors[0].message.includes(_AppConstants.Railcard1617Errors.ALREADY_EXISTS);

                            if (!isRailcardAlreadyExistError) {
                                _context2.next = 17;
                                break;
                            }

                            throw { message: 'booking.railcard1617.errors.alreadyExists' };

                        case 17:
                            throw { message: 'booking.railcard1617.errors.unknown' };

                        case 20:
                            if (_context2.t0 instanceof _APIClient.NotFoundError) {
                                _context2.next = 22;
                                break;
                            }

                            throw _context2.t0;

                        case 22:
                            return _context2.abrupt('return', null);

                        case 23:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 9]]);
        }));

        function linkToAccount(_x2) {
            return _ref3.apply(this, arguments);
        }

        return linkToAccount;
    }(),
    syncWithKeyGo: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref4) {
            var railcardId = _ref4.railcardId,
                userId = _ref4.userId;
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            endpoint = this.getBaseUrlFromId(userId) + '/season-railcards/' + railcardId + '/sync';
                            _context3.next = 4;
                            return _AuthenticatedAPIClient2.default.post(endpoint);

                        case 4:
                            response = _context3.sent;
                            return _context3.abrupt('return', response);

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](0);

                            if (!(_context3.t0 instanceof _APIClient.BadRequestError)) {
                                _context3.next = 14;
                                break;
                            }

                            console.error('syncWithKeyGo BadRequestError:', _context3.t0.message, _context3.t0.body);
                            _context3.next = 16;
                            break;

                        case 14:
                            if (_context3.t0 instanceof _APIClient.NotFoundError) {
                                _context3.next = 16;
                                break;
                            }

                            throw _context3.t0;

                        case 16:
                            return _context3.abrupt('return', null);

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 8]]);
        }));

        function syncWithKeyGo(_x3) {
            return _ref5.apply(this, arguments);
        }

        return syncWithKeyGo;
    }(),


    // eslint-disable-next-line no-unused-vars
    validate: function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref6) {
            var firstName = _ref6.firstName,
                lastName = _ref6.lastName,
                railcardNumber = _ref6.railcardNumber,
                expiryDate = _ref6.expiryDate;
            var endpoint, response;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            endpoint = '/customers/season-railcards/validate';
                            _context4.next = 4;
                            return _APIClient2.default.post(endpoint, { railcardNumber: railcardNumber, lastName: lastName, expiryDate: expiryDate });

                        case 4:
                            response = _context4.sent;
                            return _context4.abrupt('return', (0, _LinkMapper.resolve)(response.result).as(_RailcardValidationResponse2.default));

                        case 8:
                            _context4.prev = 8;
                            _context4.t0 = _context4['catch'](0);

                            if (_context4.t0 instanceof _APIClient.NotFoundError) {
                                _context4.next = 12;
                                break;
                            }

                            throw _context4.t0;

                        case 12:
                            return _context4.abrupt('return', false);

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 8]]);
        }));

        function validate(_x4) {
            return _ref7.apply(this, arguments);
        }

        return validate;
    }()
};

exports.default = Railcard1617Service;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    isValid: false,
    expiryDate: null
};

var RailcardValidationResponse = function (_record) {
    (0, _inherits3.default)(RailcardValidationResponse, _record);

    function RailcardValidationResponse() {
        (0, _classCallCheck3.default)(this, RailcardValidationResponse);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    RailcardValidationResponse.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return (0, _LinkMapper.construct)(RailcardValidationResponse, json, {
            expiryDate: _LinkMapper.fields.string,
            isValid: _LinkMapper.fields.bool
        });
    };

    return RailcardValidationResponse;
}((0, _immutable.Record)(defaults));

exports.default = RailcardValidationResponse;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _isEmpty2 = __webpack_require__(171);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _LinkMapper = __webpack_require__(8);

var _PromoCodeStore = __webpack_require__(342);

var _PromoCodeStore2 = _interopRequireDefault(_PromoCodeStore);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDurations = function getDurations(search) {
    var durations = [];
    if (_FeatureFlagStore2.default.get('enableFlexiSeasonTickets') && search.flexi) {
        durations.push('FLEXI');
    }
    if (_FeatureFlagStore2.default.get('enableWeeklySeasonTickets') && search.weekly) {
        durations.push('P7D');
    }
    if (_FeatureFlagStore2.default.get('enableFourWeeklySeasonTickets') && search.fourWeekly && search.smartcard) {
        durations.push('P28D');
    }
    if (search.monthly) {
        durations.push('P1M');
    }
    if (_FeatureFlagStore2.default.get('enableQuarterlySeasonTickets') && search.quarterly) {
        durations.push('P3M');
    }
    if (_FeatureFlagStore2.default.get('enableSixMonthlySeasonTickets') && search.sixMonthly) {
        durations.push('P6M');
    }
    if (search.annual) {
        durations.push('P12M');
    }

    if (search.custom) {
        durations.push(search.dates.formatDuration());
    }

    return durations;
};

var SeasonTicketsService = {
    search: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_search, user) {
            var url, requestBody, railcardJobCentrePlus, railcards, promo, response, faresResult, fares;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = '/jp/season-tickets';
                            requestBody = {
                                origin: _search.origin.nlc,
                                destination: _search.destination.nlc,
                                startDate: _search.dates.getStartDate().format('YYYY-MM-DD'),
                                duration: getDurations(_search),
                                adult: _search.isAdult()
                            };


                            if (_search.smartcard && user) {
                                (0, _assign2.default)(requestBody, {
                                    adult: user.isAdult()
                                });
                            }

                            railcardJobCentrePlus = _search.get('railcardJobCentrePlus');
                            railcards = [];


                            if (_search.railcard1617 && _search.railcard1617.isValid() && user) {
                                railcards.push(_search.railcard1617.get('railcardCode'));
                            }

                            if (user && railcardJobCentrePlus) {
                                railcards.push(_AppConstants.JOB_CENTRE_PLUS_RAILCARD_CODE);
                            }
                            requestBody = (0, _extends3.default)({}, requestBody, {
                                railcards: (0, _isEmpty3.default)(railcards) ? null : railcards
                            });

                            promo = !_search.promoCode.isEmpty() ? _search.promoCode : _PromoCodeStore2.default.getActive();


                            if (promo) {
                                requestBody.promoCode = promo.promoCode;
                            }

                            if (_search.orderId) {
                                requestBody.orderId = _search.orderId;
                            }

                            response = void 0;
                            _context.prev = 12;
                            _context.next = 15;
                            return _APIClient2.default.post(url, requestBody);

                        case 15:
                            response = _context.sent;
                            _context.next = 26;
                            break;

                        case 18:
                            _context.prev = 18;
                            _context.t0 = _context['catch'](12);

                            if (!(0, _result3.default)(_context.t0, 'body.result', []).length) {
                                _context.next = 25;
                                break;
                            }

                            console.error('Supressing error', _context.t0);
                            response = _context.t0.body;
                            _context.next = 26;
                            break;

                        case 25:
                            throw _context.t0;

                        case 26:
                            faresResult = (0, _result3.default)(response, 'result', []);
                            fares = (0, _LinkMapper.resolveAll)(faresResult).as(_Fare2.default);
                            return _context.abrupt('return', fares.sortBy(function (fare) {
                                return fare.getPrice();
                            }));

                        case 29:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[12, 18]]);
        }));

        function search(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return search;
    }()
};

exports.default = SeasonTicketsService;

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.AccountPages.SMARTCARD_LINK_CONFIRMATION, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(46).then((function (require) {
            cb(null, __webpack_require__(2341).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(60);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _SeasonSearchActions = __webpack_require__(1041);

var _SeasonSearchActions2 = _interopRequireDefault(_SeasonSearchActions);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.SeasonStages.INIT, {
    onEnter: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref, replace, callback) {
            var location = _ref.location,
                params = _ref.params;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return _SeasonSearchActions2.default.loadFromParams(params, location.query);

                        case 3:
                            _context.next = 8;
                            break;

                        case 5:
                            _context.prev = 5;
                            _context.t0 = _context['catch'](0);

                            console.error(_context.t0);

                        case 8:
                            replace(_urls2.default.location(_AppConstants.SeasonStages.SEARCH));
                            callback();

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 5]]);
        }));

        function onEnter(_x, _x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _SeasonSearchActions = __webpack_require__(1041);

var _SeasonSearchActions2 = _interopRequireDefault(_SeasonSearchActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.featureRoute)('enableSeasonTickets', _AppConstants.SeasonStages.SEARCH, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(11).then((function (require) {
            cb(null, __webpack_require__(2342).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextState) {
            var query;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            query = nextState.location.query;


                            if (query.promoCode) {
                                // pre fill and pre validate promo input on the main page if there's promoCode query param
                                _SeasonSearchActions2.default.preFillPromoFromQuery(query);
                            }

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter(_x) {
            return _ref.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _SeasonSearchActions = __webpack_require__(1041);

var _SeasonSearchActions2 = _interopRequireDefault(_SeasonSearchActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.featureRoute)('enableSeasonTickets', _AppConstants.SeasonStages.RESULTS, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(13).then((function (require) {
            cb(null, __webpack_require__(2343).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter(nextState, replace, callback) {
        var params = nextState.params,
            location = nextState.location;

        _SeasonSearchActions2.default.loadFromParams(params, location.query).then(function (search) {
            if (!search.isValid()) {
                replace(_urls2.default.location(_AppConstants.SeasonStages.SEARCH, null, location.query));
            }
            (0, _defer3.default)(callback);
        });
    }
});

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enableOtherTickets', _AppConstants.OtherTicketStages.SEARCH, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(17).then((function (require) {
            cb(null, __webpack_require__(2344).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enableDaySave', _AppConstants.DaySaveStages.SEARCH, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(27).then((function (require) {
            cb(null, __webpack_require__(2345).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _LinkMapper = __webpack_require__(8);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _PromoCodeStore = __webpack_require__(342);

var _PromoCodeStore2 = _interopRequireDefault(_PromoCodeStore);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DaySaveService = {
    search: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_search) {
            var url, request, order, promo, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = '/jp/day-save';
                            request = {
                                date: _search.date.format('YYYY-MM-DD'),
                                adults: _search.adults,
                                children: _search.children,
                                origin: _search.origin.nlc,
                                destination: _search.destinationNlc
                            };
                            order = _OrderStore2.default.getCurrent();
                            promo = _PromoCodeStore2.default.getActive();

                            if (promo && !order.hasReachedDiscountLimit(promo.discount)) {
                                request.promoCode = promo.promoCode;
                            }
                            _context.next = 7;
                            return _APIClient2.default.post(url, request);

                        case 7:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Fare2.default).sortBy(function (fare) {
                                return fare.totalPrice;
                            }));

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function search(_x) {
            return _ref.apply(this, arguments);
        }

        return search;
    }()
};

exports.default = DaySaveService;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _DaySaveActions = __webpack_require__(2196);

var _DaySaveActions2 = _interopRequireDefault(_DaySaveActions);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.featureRoute)('enableDaySave', _AppConstants.DaySaveStages.RESULTS, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(22).then((function (require) {
            cb(null, __webpack_require__(2346).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter(nextState, replace, callback) {
        var params = nextState.params,
            location = nextState.location;

        _DaySaveActions2.default.loadFromParams(params, location.query).then(function (search) {
            if (!search.isValid()) {
                replace(_urls2.default.location(_AppConstants.DaySaveStages.SEARCH));
            }
            (0, _defer3.default)(callback);
        });
    }
});

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enableRoversRangers', _AppConstants.RoversRangersStages.SEARCH, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(26).then((function (require) {
            cb(null, __webpack_require__(2347).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign2 = __webpack_require__(2206);

var _assign3 = _interopRequireDefault(_assign2);

var _immutable = __webpack_require__(5);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _LinkMapper = __webpack_require__(8);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _JourneyPlanService = __webpack_require__(272);

var _TicketType = __webpack_require__(109);

var _TicketType2 = _interopRequireDefault(_TicketType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoversRangersService = {
    search: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_search) {
            var url, railcards, request, response, requestedFares, familyFares;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = '/jp/rail-rovers';
                            railcards = (0, _JourneyPlanService.serialiseRailcards)(_search);
                            request = {
                                start: _search.date.format('YYYY-MM-DD'),
                                adults: _search.adults,
                                children: _search.children,
                                roverCode: _search.ticketType.code
                            };


                            if (railcards.length > 0) {
                                request.railcards = railcards;
                            }

                            _context.next = 6;
                            return _APIClient2.default.post(url, request);

                        case 6:
                            response = _context.sent;
                            requestedFares = (0, _LinkMapper.resolveAll)(response.result).as(_Fare2.default);
                            _context.next = 10;
                            return this._getFamilyFares(_search, request, url);

                        case 10:
                            familyFares = _context.sent;
                            return _context.abrupt('return', requestedFares.concat(familyFares).sortBy(function (fare) {
                                return fare.totalPrice;
                            }));

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function search(_x) {
            return _ref.apply(this, arguments);
        }

        return search;
    }(),
    _getFamilyFares: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(search, request, url) {
            var familyRequest, familyResponse;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(search.ticketType.isNonFamilyRanger() && search.adults >= 1 && search.adults <= 2 && search.children >= 1 && search.children <= 4)) {
                                _context2.next = 6;
                                break;
                            }

                            familyRequest = (0, _assign3.default)({}, request, { roverCode: _TicketType2.default.getFamilyRangerCode() });
                            _context2.next = 4;
                            return _APIClient2.default.post(url, familyRequest);

                        case 4:
                            familyResponse = _context2.sent;
                            return _context2.abrupt('return', (0, _LinkMapper.resolveAll)(familyResponse.result).as(_Fare2.default));

                        case 6:
                            return _context2.abrupt('return', new _immutable.List());

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function _getFamilyFares(_x2, _x3, _x4) {
            return _ref2.apply(this, arguments);
        }

        return _getFamilyFares;
    }()
};

exports.default = RoversRangersService;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _RoversRangersActions = __webpack_require__(2197);

var _RoversRangersActions2 = _interopRequireDefault(_RoversRangersActions);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.featureRoute)('enableRoversRangers', _AppConstants.RoversRangersStages.RESULTS, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(20).then((function (require) {
            cb(null, __webpack_require__(2348).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter(nextState, replace, callback) {
        var params = nextState.params,
            location = nextState.location;

        _RoversRangersActions2.default.loadFromParams(params, location.query).then(function (search) {
            if (!search.isValid()) {
                replace(_urls2.default.location(_AppConstants.RoversRangersStages.SEARCH));
            }
            (0, _defer3.default)(callback);
        });
    }
});

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enableSmartCarnet', _AppConstants.SmartCarnetStages.RESULTS, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(3).then((function (require) {
            cb(null, __webpack_require__(2349).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRouteOr)(['enableTPEStaffRover', 'enableStaffDiscounts'], _AppConstants.PromotionPages.TOC_FAMILY, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(44).then((function (require) {
            cb(null, __webpack_require__(2350).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.PromotionPages.TOC_FAMILY_VERIFY, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(40).then((function (require) {
            cb(null, __webpack_require__(2351).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.PromotionPages.PROMOTION, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(36).then((function (require) {
            cb(null, __webpack_require__(2352).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.PromotionPages.APPLY_PROMOTION, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(45).then((function (require) {
            cb(null, __webpack_require__(2353).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.LoginPages.RESET_PASSWORD, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(8).then((function (require) {
            cb(null, __webpack_require__(2354).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _SetPasswordAndPreferences = __webpack_require__(2247);

var _SetPasswordAndPreferences2 = _interopRequireDefault(_SetPasswordAndPreferences);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showPage = _FeatureFlagStore2.default.get('enableSetPasswordAndPreferencesPage');

module.exports = showPage ? (0, _helpers.route)(_AppConstants.LoginPages.SET_PASSWORD_AND_PREFERENCES, {
    getComponent: function getComponent(location, cb) {
        new Promise(function(resolve) { resolve(); }).then((function () {
            cb(null, _SetPasswordAndPreferences2.default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var user;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();

                            if (!(user && user.isLoggedIn())) {
                                _context.next = 4;
                                break;
                            }

                            _context.next = 4;
                            return _CustomerActions2.default.logout(_UserStore2.default.getCurrent());

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter() {
            return _ref.apply(this, arguments);
        }

        return onEnter;
    }()
}) : null;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SetPasswordAndPreferences = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PropTypes = __webpack_require__(85);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _PasswordAndPreferencesForm = __webpack_require__(2248);

var _PasswordAndPreferencesForm2 = _interopRequireDefault(_PasswordAndPreferencesForm);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _AccountHeader = __webpack_require__(2178);

var _AccountHeader2 = _interopRequireDefault(_AccountHeader);

var _Breadcrumb = __webpack_require__(2179);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FormComponent2 = __webpack_require__(417);

var _FormComponent3 = _interopRequireDefault(_FormComponent2);

var _PhoneNumber = __webpack_require__(959);

var _PhoneNumber2 = _interopRequireDefault(_PhoneNumber);

var _Password = __webpack_require__(419);

var _Password2 = _interopRequireDefault(_Password);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PrefsTable = __webpack_require__(965);

var _PrefsTable2 = _interopRequireDefault(_PrefsTable);

var _SignupTAndCs = __webpack_require__(594);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetPasswordAndPreferences = exports.SetPasswordAndPreferences = (_temp2 = _class = function (_FormComponent) {
    (0, _inherits3.default)(SetPasswordAndPreferences, _FormComponent);

    function SetPasswordAndPreferences() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SetPasswordAndPreferences);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _FormComponent.call.apply(_FormComponent, [this].concat(args))), _this), _this.state = {
            form: new _PasswordAndPreferencesForm2.default(),
            loading: false,
            submitted: false
        }, _this._handleFieldChange = function (field, value) {
            _this.setState({ form: _this.state.form.set(field, value), submitted: false });
        }, _this._handleSubmit = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var form, _this$props, token, router;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            form = _this.state.form;

                            if (form.isComplete()) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt('return');

                        case 3:

                            _this.setState({ loading: true, submitted: true });

                            _this$props = _this.props, token = _this$props.params.token, router = _this$props.router;
                            _context.prev = 5;
                            _context.next = 8;
                            return _CustomerActions2.default.setPasswordAndPreferences(token, form);

                        case 8:
                            _this.setState({ loading: false });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.CONFIRM, {
                                title: 'login.setPasswordAndPreferences.modal.title',
                                message: 'login.setPasswordAndPreferences.modal.success.message',
                                hideClose: true,
                                onConfirm: function onConfirm() {
                                    return router.push('/');
                                }
                            });
                            _context.next = 17;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](5);

                            console.error(_context.t0);
                            _this.setState({ loading: false });
                            _ModalActions2.default.open(_AppConstants.GlobalModals.ERROR, {
                                title: 'login.setPasswordAndPreferences.modal.title',
                                message: 'login.setPasswordAndPreferences.modal.error.message'
                            });

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[5, 12]]);
        })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    SetPasswordAndPreferences.prototype._renderPasswordForm = function _renderPasswordForm() {
        var _state = this.state,
            form = _state.form,
            submitted = _state.submitted;


        return _react2.default.createElement(
            'div',
            { className: 'margin-top--sm margin-bottom--sm' },
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n2.default)('login.resetPassword.help')
            ),
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(_Password2.default, {
                        form: form,
                        field: 'password',
                        onChange: this._handleFieldChange,
                        visited: submitted,
                        showPasswordIcon: true,
                        showPasswordHints: true
                    })
                )
            )
        );
    };

    SetPasswordAndPreferences.prototype._renderPreferencesForm = function _renderPreferencesForm() {
        var _props = this.props,
            enableEmailMarketing = _props.enableEmailMarketing,
            enableSmsMarketing = _props.enableSmsMarketing;
        var _state2 = this.state,
            form = _state2.form,
            submitted = _state2.submitted;

        var needsToAddPhoneNumber = form.get('preferences').isSomeSmsPrefSetToTrue();

        return _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: 'preference-centre.intro',
                    privacyPolicy: _react2.default.createElement(_SignupTAndCs.PrivacyPolicyLink, null)
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'margin-top--sm margin-bottom--sm border--bottom' },
                _react2.default.createElement(_PrefsTable2.default, {
                    enableEmailMarketing: enableEmailMarketing,
                    enableSmsMarketing: enableSmsMarketing,
                    form: form.get('preferences'),
                    isOver16: true,
                    onChange: this._handleFieldChange
                }),
                needsToAddPhoneNumber && _react2.default.createElement(_PhoneNumber2.default, {
                    form: form,
                    field: 'telephoneNumber',
                    onChange: this._handleFieldChange,
                    visited: submitted,
                    required: true
                })
            )
        );
    };

    SetPasswordAndPreferences.prototype.render = function render() {
        var _state3 = this.state,
            form = _state3.form,
            loading = _state3.loading;


        return _react2.default.createElement(
            _Row2.default,
            { ref: this.captureFormRef, className: 'padding--horiz' },
            _react2.default.createElement(_Breadcrumb2.default, { pageName: 'Set Password and Preferences' }),
            _react2.default.createElement(
                'div',
                { className: 'account-container clearfix' },
                _react2.default.createElement(
                    _Col2.default,
                    { md: 8, mdOffset: 2, className: 'account margin-bottom' },
                    _react2.default.createElement(
                        'div',
                        { className: 'set-password-and-preferences__header-wrapper margin-top margin-bottom' },
                        _react2.default.createElement(
                            _AccountHeader2.default,
                            null,
                            (0, _I18n2.default)('login.setPasswordAndPreferences.heading')
                        )
                    ),
                    this._renderPasswordForm(),
                    this._renderPreferencesForm(),
                    _react2.default.createElement(
                        _Button2.default,
                        { bsStyle: 'primary',
                            onClick: this._handleSubmit,
                            disabled: !form.isComplete() || loading,
                            className: 'btn-lg pull-right select' },
                        loading ? _react2.default.createElement(_Icon2.default, { icon: 'spinner', className: 'otrl-spin' }) : (0, _I18n2.default)('login.setPasswordAndPreferences.form.action')
                    )
                )
            )
        );
    };

    return SetPasswordAndPreferences;
}(_FormComponent3.default), _class.propTypes = {
    enableEmailMarketing: _propTypes2.default.bool,
    enableSmsMarketing: _propTypes2.default.bool,
    location: _PropTypes.locationShape.isRequired,
    params: _propTypes2.default.object.isRequired,
    router: _PropTypes.routerShape.isRequired
}, _class.defaultProps = {
    enableEmailMarketing: true,
    enableSmsMarketing: true
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default], function () {
    return {
        enableEmailMarketing: _FeatureFlagStore2.default.get('enableEmailMarketing'),
        enableSmsMarketing: _FeatureFlagStore2.default.get('enableSmsMarketing')
    };
})(SetPasswordAndPreferences);

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _UserPreferences = __webpack_require__(228);

var _UserPreferences2 = _interopRequireDefault(_UserPreferences);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    password: null,
    preferences: new _UserPreferences2.default(),
    telephoneNumber: null
};

var PasswordAndPreferencesForm = function (_record) {
    (0, _inherits3.default)(PasswordAndPreferencesForm, _record);

    function PasswordAndPreferencesForm() {
        (0, _classCallCheck3.default)(this, PasswordAndPreferencesForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PasswordAndPreferencesForm.prototype.getSchema = function getSchema() {
        var schema = {};
        if (this.preferences.isSomeSmsPrefSetToTrue()) {
            schema = {
                telephoneNumber: _validation2.default.phone().required()
            };
        }
        return (0, _extends3.default)({}, schema, {
            password: _validation2.default.passwordCreate().required()
        });
    };

    return PasswordAndPreferencesForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(PasswordAndPreferencesForm.prototype, _ValidationMixin2.default);

exports.default = PasswordAndPreferencesForm;

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.NewsletterPages.UNSUBSCRIBE, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(41).then((function (require) {
            cb(null, __webpack_require__(2355).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.NREPages.ORDER_LANDING, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(43).then((function (require) {
            cb(null, __webpack_require__(2356).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.OtherPages.PAYMENT_LANDING, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(50).then((function (require) {
            cb(null, __webpack_require__(2357).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _SearchWidgetActions = __webpack_require__(2253);

var _SearchWidgetActions2 = _interopRequireDefault(_SearchWidgetActions);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.SearchWidgetPages.IFRAME, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(12).then((function (require) {
            cb(null, __webpack_require__(2358).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter() {
        _SearchWidgetActions2.default.initialiseIFrameWidget();
    }
});

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchWidgetActions = {
    initialiseIFrameWidget: function initialiseIFrameWidget() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.SEARCH_WIDGET_LOADED
        });
    }
};

exports.default = SearchWidgetActions;

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _semver = __webpack_require__(599);

var _semver2 = _interopRequireDefault(_semver);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _helpers = __webpack_require__(60);

var _I18n = __webpack_require__(9);

var _DeviceDetection = __webpack_require__(597);

var _InAppHelpers = __webpack_require__(969);

var _AppConstants = __webpack_require__(6);

var _InAppActions = __webpack_require__(960);

var _InAppActions2 = _interopRequireDefault(_InAppActions);

var _ModalActions = __webpack_require__(28);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var holdAppVersion = void 0; // Store the appVersion from the query between the calls

module.exports = {
    path: '/in-app',
    name: 'tab',

    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(51).then((function (require) {
            cb(null, __webpack_require__(2359).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },


    indexRoute: (0, _helpers.redirectRoute)(null, _AppConstants.InAppPages.REDIRECT, { splat: 'search' }),

    getChildRoutes: function getChildRoutes(location, cb) {
        __webpack_require__.e/* require.ensure */(30).then((function (require) {
            cb(null, [__webpack_require__(2360), __webpack_require__(2361), __webpack_require__(2362), __webpack_require__(2363), __webpack_require__(2364), __webpack_require__(2365), __webpack_require__(2366), __webpack_require__(2367), __webpack_require__(2368), __webpack_require__(2369), __webpack_require__(2370), __webpack_require__(2371), __webpack_require__(2372)].filter(function (x) {
                return !!x;
            }));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter(nextState) {
        var _nextState$location$q = nextState.location.query,
            queryAppVersion = _nextState$location$q.appVersion,
            channel = _nextState$location$q.channel,
            deviceToken = _nextState$location$q.deviceToken,
            disableAutoLogout = _nextState$location$q.disableAutoLogout,
            disableAccountNavigationLogout = _nextState$location$q.disableAccountNavigationLogout;

        var enableAppUpdateAlertPopup = _FeatureFlagStore2.default.get('enableAppUpdateAlertPopup');
        var appVersion = void 0;

        if (queryAppVersion) {
            // This is a workaround for onEnter executing twice in a desktop browser.
            // On the second invocation the location.query is empty which sets the
            // appVersion to null.
            holdAppVersion = queryAppVersion;
        }

        appVersion = holdAppVersion;

        _InAppActions2.default.startSession({
            appVersion: appVersion,
            deviceToken: deviceToken,
            channel: channel,
            disableAutoLogout: disableAutoLogout === 'true',
            disableAccountNavigationLogout: disableAccountNavigationLogout === 'true'
        });

        if (appVersion) {
            var appVersionFull = (0, _InAppHelpers.standardizeVersion)(appVersion);

            /* eslint-disable-next-line no-console */
            console.log('MOBILE APP VERSION: ', appVersionFull);

            if ((!_semver2.default.valid(appVersionFull) || _semver2.default.satisfies(appVersionFull, _config2.default.get('unsupportedAppVersions')[(0, _DeviceDetection.deviceDetection)()])) && enableAppUpdateAlertPopup) {
                (0, _defer3.default)(function () {
                    _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
                        type: 'warning',
                        title: 'inApp.updateRequired',
                        message: (0, _I18n.translate)("inApp." + (0, _DeviceDetection.deviceDetection)() + "UpdateMessage"),
                        hideClose: true,
                        disableEscape: true,
                        disableBlur: true
                    });
                });
            }
        }
    }
};

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _WidgetAuthActions = __webpack_require__(2256);

var _WidgetAuthActions2 = _interopRequireDefault(_WidgetAuthActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    path: '/widget-auth',

    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(49).then((function (require) {
            cb(null, __webpack_require__(2373).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },


    indexRoute: (0, _helpers.redirectRoute)(null, _AppConstants.WidgetAuthPages.LOGIN),

    getChildRoutes: function getChildRoutes(location, cb) {
        __webpack_require__.e/* require.ensure */(7).then((function (require) {
            cb(null, [__webpack_require__(2374), __webpack_require__(2375), __webpack_require__(2376)].filter(function (x) {
                return !!x;
            }));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter() {
        _WidgetAuthActions2.default.startSession();
    }
};

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _LayoutActions = __webpack_require__(962);

var _LayoutActions2 = _interopRequireDefault(_LayoutActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WidgetAuthActions = {
    startSession: function startSession() {
        _AppDispatcher2.default.dispatch({
            actionType: _AppConstants.ActionTypes.WIDGET_AUTH_SESSION_STARTED
        });
        _LayoutActions2.default.setEmbedded(true);
    }
};

exports.default = WidgetAuthActions;

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _FareHandOffActions = __webpack_require__(2258);

var _FareHandOffActions2 = _interopRequireDefault(_FareHandOffActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.HandOffPages.FARE, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(31).then((function (require) {
            cb(null, __webpack_require__(2377).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextState, replace, callback) {
            var user;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            user = _UserStore2.default.getCurrent();
                            _context.next = 4;
                            return _FareHandOffActions2.default.getReorderable(nextState.location.query, user);

                        case 4:
                            _context.next = 10;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context['catch'](0);

                            console.error('Error getting favourites', _context.t0);
                            replace(_urls2.default.location(_AppConstants.PointStages.SEARCH));

                        case 10:

                            callback();

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 6]]);
        }));

        function onEnter(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

// Construct a reorderable (Favourite) from query parameters
var getReorderableFromQuery = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(query, user) {
        var isTrue, json, enriched;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        isTrue = function isTrue(val) {
                            return ['true', 'yes', '1'].includes(String(val).toLowerCase());
                        };

                        json = {
                            origin: query.origin,
                            destination: query.destination,
                            adults: query.adults || 0,
                            children: query.children || 0,
                            route: query.route,
                            ticketType: query.ticketType,
                            smartTicketType: query.smartTicketType,
                            railcards: query.railcards ? query.railcards.split(',') : null,
                            isSeason: isTrue(query.isSeason),
                            isSmartcard: isTrue(query.isSmartcard),
                            isOpenReturn: isTrue(query.isOpenReturn),
                            duration: query.duration
                        };
                        _context2.next = 4;
                        return (0, _Favourites.enrichFavouritesResponse)(json, user);

                    case 4:
                        enriched = _context2.sent;
                        return _context2.abrupt('return', _Favourite2.default.fromJSON(enriched));

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function getReorderableFromQuery(_x3, _x4) {
        return _ref3.apply(this, arguments);
    };
}();

var _AppConstants = __webpack_require__(6);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _Favourites = __webpack_require__(971);

var _Favourite = __webpack_require__(198);

var _Favourite2 = _interopRequireDefault(_Favourite);

var _FavouritesActions = __webpack_require__(422);

var _FavouritesActions2 = _interopRequireDefault(_FavouritesActions);

var _FavouritesStore = __webpack_require__(271);

var _FavouritesStore2 = _interopRequireDefault(_FavouritesStore);

var _Railcard1617Actions = __webpack_require__(2182);

var _Railcard1617Actions2 = _interopRequireDefault(_Railcard1617Actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FareHandOffActions = function () {
    function FareHandOffActions() {
        (0, _classCallCheck3.default)(this, FareHandOffActions);
    }

    FareHandOffActions.prototype.getReorderable = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(query, user) {
            var pending, reorderable, _ref2;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_HANDOFF_LOADING
                            });

                            _context.prev = 1;
                            pending = [user.isLoggedIn() && _Railcard1617Actions2.default.load(user)];
                            reorderable = void 0;

                            if (!query.reorder) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 7;
                            return _promise2.default.all([].concat(pending, [_FavouritesActions2.default.getAll(user)]));

                        case 7:
                            reorderable = _FavouritesStore2.default.getFavouriteById(Number(query.reorder));
                            _context.next = 14;
                            break;

                        case 10:
                            _context.next = 12;
                            return _promise2.default.all([].concat(pending, [getReorderableFromQuery(query, user)]));

                        case 12:
                            _ref2 = _context.sent;
                            reorderable = _ref2[1];

                        case 14:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_HANDOFF_LOADED,
                                reorderable: reorderable
                            });
                            _context.next = 21;
                            break;

                        case 17:
                            _context.prev = 17;
                            _context.t0 = _context['catch'](1);

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.FARE_HANDOFF_LOAD_FAILED
                            });
                            throw _context.t0;

                        case 21:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 17]]);
        }));

        function getReorderable(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return getReorderable;
    }();

    return FareHandOffActions;
}();

exports.default = new FareHandOffActions();

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _FeatureFlagStore = __webpack_require__(27);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.route)(_AppConstants.SmartcardPages.SELF_REGISTERED, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(42).then((function (require) {
            cb(null, __webpack_require__(2378).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextState, replace) {
            var user;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            user = _UserStore2.default.getCurrent();

                            if (!(user && user.isLoggedIn())) {
                                _context.next = 4;
                                break;
                            }

                            _context.next = 4;
                            return _CustomerActions2.default.logout(_UserStore2.default.getCurrent());

                        case 4:

                            if (!_FeatureFlagStore2.default.get('enableSmartcardSelfRegistration') || !_FeatureFlagStore2.default.get('enableSmartcard')) {
                                replace(_urls2.default.location(_AppConstants.PointStages.SEARCH));
                            }

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = {
    path: '/disruption-alerts',

    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(4).then((function (require) {
            cb(null, __webpack_require__(2207).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },


    indexRoute: (0, _helpers.redirectRoute)(null, _AppConstants.DisruptionAlertsPages.MUTE),

    getChildRoutes: function getChildRoutes(location, cb) {
        __webpack_require__.e/* require.ensure */(48).then((function (require) {
            cb(null, [__webpack_require__(2379)].filter(Boolean));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = {
    path: '/timetable-change',

    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(4).then((function (require) {
            cb(null, __webpack_require__(2207).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },


    indexRoute: (0, _helpers.redirectRoute)(null, _AppConstants.DisruptionAlertsPages.DELETE),

    getChildRoutes: function getChildRoutes(location, cb) {
        __webpack_require__.e/* require.ensure */(47).then((function (require) {
            cb(null, [__webpack_require__(2380)].filter(Boolean));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
};

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enableOpenGolf', _AppConstants.Widgets.OPEN_GOLF_FIND_TICKETS, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(33).then((function (require) {
            cb(null, __webpack_require__(2381).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enableOpenGolf', _AppConstants.Widgets.OPEN_GOLF_TIMETABLE, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(35).then((function (require) {
            cb(null, __webpack_require__(2382).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _helpers = __webpack_require__(60);

var _OpenGolfActions = __webpack_require__(2208);

var _OpenGolfActions2 = _interopRequireDefault(_OpenGolfActions);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = (0, _helpers.featureRoute)('enableOpenGolf', _AppConstants.Widgets.OPEN_GOLF_TICKET_SELECTION, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(18).then((function (require) {
            cb(null, __webpack_require__(2383).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref, replace, callback) {
            var params = _ref.params,
                location = _ref.location;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _OpenGolfActions2.default.loadFromParams(params, location.query);

                        case 2:
                            (0, _defer3.default)(callback);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function onEnter(_x, _x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return onEnter;
    }()
});

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _times2 = __webpack_require__(598);

var _times3 = _interopRequireDefault(_times2);

var _APIClient = __webpack_require__(52);

var _APIClient2 = _interopRequireDefault(_APIClient);

var _LinkMapper = __webpack_require__(8);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenGolfService = {
    getTickets: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(search) {
            var response, railcards, request;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            response = void 0;
                            railcards = search.railcards.toJS().flatMap(function (railcard) {
                                return (0, _times3.default)(railcard.quantity ? railcard.quantity : 1, function () {
                                    return String(railcard.code);
                                });
                            });
                            request = {
                                "origin": search.getIn(['origin', 'nlc'], ''),
                                "destination": "5026",
                                "adults": search.adults,
                                "children": search.children,
                                railcards: railcards
                            };
                            _context.prev = 3;
                            _context.next = 6;
                            return _APIClient2.default.post('/jp/open-golf-tickets', request);

                        case 6:
                            response = _context.sent;
                            return _context.abrupt('return', (0, _LinkMapper.resolveAll)(response.result).as(_Fare2.default));

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](3);
                            throw new Error(_context.t0);

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[3, 10]]);
        }));

        function getTickets(_x) {
            return _ref.apply(this, arguments);
        }

        return getTickets;
    }()
};

exports.default = OpenGolfService;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.Widgets.REFUND_WIDGET, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(38).then((function (require) {
            cb(null, __webpack_require__(2384).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/app.b42a637e2433e6824cc3.js